var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// ../../node_modules/lodash/lodash.js
var require_lodash = __commonJS({
  "../../node_modules/lodash/lodash.js"(exports, module) {
    "use strict";
    (function() {
      var undefined2;
      var VERSION = "4.17.21";
      var LARGE_ARRAY_SIZE = 200;
      var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
      var HASH_UNDEFINED = "__lodash_hash_undefined__";
      var MAX_MEMOIZE_SIZE = 500;
      var PLACEHOLDER = "__lodash_placeholder__";
      var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
      var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
      var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
      var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
      var HOT_COUNT = 800, HOT_SPAN = 16;
      var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
      var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 17976931348623157e292, NAN = 0 / 0;
      var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
      var wrapFlags = [
        ["ary", WRAP_ARY_FLAG],
        ["bind", WRAP_BIND_FLAG],
        ["bindKey", WRAP_BIND_KEY_FLAG],
        ["curry", WRAP_CURRY_FLAG],
        ["curryRight", WRAP_CURRY_RIGHT_FLAG],
        ["flip", WRAP_FLIP_FLAG],
        ["partial", WRAP_PARTIAL_FLAG],
        ["partialRight", WRAP_PARTIAL_RIGHT_FLAG],
        ["rearg", WRAP_REARG_FLAG]
      ];
      var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
      var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
      var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
      var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
      var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
      var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
      var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
      var reTrimStart = /^\s+/;
      var reWhitespace = /\s/;
      var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
      var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
      var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
      var reEscapeChar = /\\(\\)?/g;
      var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
      var reFlags = /\w*$/;
      var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
      var reIsBinary = /^0b[01]+$/i;
      var reIsHostCtor = /^\[object .+?Constructor\]$/;
      var reIsOctal = /^0o[0-7]+$/i;
      var reIsUint = /^(?:0|[1-9]\d*)$/;
      var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
      var reNoMatch = /($^)/;
      var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
      var rsAstralRange = "\\ud800-\\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
      var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\\ud83c[\\udffb-\\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
      var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [rsDingbat, rsRegional, rsSurrPair].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")";
      var reApos = RegExp(rsApos, "g");
      var reComboMark = RegExp(rsCombo, "g");
      var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
      var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [rsBreak, rsUpper, "$"].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [rsBreak, rsUpper + rsMiscLower, "$"].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
      ].join("|"), "g");
      var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
      var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
      var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ];
      var templateCounter = -1;
      var typedArrayTags = {};
      typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
      typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
      var cloneableTags = {};
      cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
      cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
      var deburredLetters = {
        // Latin-1 Supplement block.
        "\xC0": "A",
        "\xC1": "A",
        "\xC2": "A",
        "\xC3": "A",
        "\xC4": "A",
        "\xC5": "A",
        "\xE0": "a",
        "\xE1": "a",
        "\xE2": "a",
        "\xE3": "a",
        "\xE4": "a",
        "\xE5": "a",
        "\xC7": "C",
        "\xE7": "c",
        "\xD0": "D",
        "\xF0": "d",
        "\xC8": "E",
        "\xC9": "E",
        "\xCA": "E",
        "\xCB": "E",
        "\xE8": "e",
        "\xE9": "e",
        "\xEA": "e",
        "\xEB": "e",
        "\xCC": "I",
        "\xCD": "I",
        "\xCE": "I",
        "\xCF": "I",
        "\xEC": "i",
        "\xED": "i",
        "\xEE": "i",
        "\xEF": "i",
        "\xD1": "N",
        "\xF1": "n",
        "\xD2": "O",
        "\xD3": "O",
        "\xD4": "O",
        "\xD5": "O",
        "\xD6": "O",
        "\xD8": "O",
        "\xF2": "o",
        "\xF3": "o",
        "\xF4": "o",
        "\xF5": "o",
        "\xF6": "o",
        "\xF8": "o",
        "\xD9": "U",
        "\xDA": "U",
        "\xDB": "U",
        "\xDC": "U",
        "\xF9": "u",
        "\xFA": "u",
        "\xFB": "u",
        "\xFC": "u",
        "\xDD": "Y",
        "\xFD": "y",
        "\xFF": "y",
        "\xC6": "Ae",
        "\xE6": "ae",
        "\xDE": "Th",
        "\xFE": "th",
        "\xDF": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
      };
      var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      };
      var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      };
      var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      };
      var freeParseFloat = parseFloat, freeParseInt = parseInt;
      var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
      var freeSelf = typeof self == "object" && self && self.Object === Object && self;
      var root = freeGlobal || freeSelf || Function("return this")();
      var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
      var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
      var moduleExports = freeModule && freeModule.exports === freeExports;
      var freeProcess = moduleExports && freeGlobal.process;
      var nodeUtil = function() {
        try {
          var types2 = freeModule && freeModule.require && freeModule.require("util").types;
          if (types2) {
            return types2;
          }
          return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e4) {
        }
      }();
      var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
      function apply(func, thisArg, args) {
        switch (args.length) {
          case 0:
            return func.call(thisArg);
          case 1:
            return func.call(thisArg, args[0]);
          case 2:
            return func.call(thisArg, args[0], args[1]);
          case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
      }
      function arrayAggregator(array2, setter, iteratee, accumulator) {
        var index2 = -1, length = array2 == null ? 0 : array2.length;
        while (++index2 < length) {
          var value = array2[index2];
          setter(accumulator, value, iteratee(value), array2);
        }
        return accumulator;
      }
      function arrayEach(array2, iteratee) {
        var index2 = -1, length = array2 == null ? 0 : array2.length;
        while (++index2 < length) {
          if (iteratee(array2[index2], index2, array2) === false) {
            break;
          }
        }
        return array2;
      }
      function arrayEachRight(array2, iteratee) {
        var length = array2 == null ? 0 : array2.length;
        while (length--) {
          if (iteratee(array2[length], length, array2) === false) {
            break;
          }
        }
        return array2;
      }
      function arrayEvery(array2, predicate) {
        var index2 = -1, length = array2 == null ? 0 : array2.length;
        while (++index2 < length) {
          if (!predicate(array2[index2], index2, array2)) {
            return false;
          }
        }
        return true;
      }
      function arrayFilter(array2, predicate) {
        var index2 = -1, length = array2 == null ? 0 : array2.length, resIndex = 0, result = [];
        while (++index2 < length) {
          var value = array2[index2];
          if (predicate(value, index2, array2)) {
            result[resIndex++] = value;
          }
        }
        return result;
      }
      function arrayIncludes(array2, value) {
        var length = array2 == null ? 0 : array2.length;
        return !!length && baseIndexOf(array2, value, 0) > -1;
      }
      function arrayIncludesWith(array2, value, comparator) {
        var index2 = -1, length = array2 == null ? 0 : array2.length;
        while (++index2 < length) {
          if (comparator(value, array2[index2])) {
            return true;
          }
        }
        return false;
      }
      function arrayMap(array2, iteratee) {
        var index2 = -1, length = array2 == null ? 0 : array2.length, result = Array(length);
        while (++index2 < length) {
          result[index2] = iteratee(array2[index2], index2, array2);
        }
        return result;
      }
      function arrayPush(array2, values) {
        var index2 = -1, length = values.length, offset = array2.length;
        while (++index2 < length) {
          array2[offset + index2] = values[index2];
        }
        return array2;
      }
      function arrayReduce(array2, iteratee, accumulator, initAccum) {
        var index2 = -1, length = array2 == null ? 0 : array2.length;
        if (initAccum && length) {
          accumulator = array2[++index2];
        }
        while (++index2 < length) {
          accumulator = iteratee(accumulator, array2[index2], index2, array2);
        }
        return accumulator;
      }
      function arrayReduceRight(array2, iteratee, accumulator, initAccum) {
        var length = array2 == null ? 0 : array2.length;
        if (initAccum && length) {
          accumulator = array2[--length];
        }
        while (length--) {
          accumulator = iteratee(accumulator, array2[length], length, array2);
        }
        return accumulator;
      }
      function arraySome(array2, predicate) {
        var index2 = -1, length = array2 == null ? 0 : array2.length;
        while (++index2 < length) {
          if (predicate(array2[index2], index2, array2)) {
            return true;
          }
        }
        return false;
      }
      var asciiSize = baseProperty("length");
      function asciiToArray(string21) {
        return string21.split("");
      }
      function asciiWords(string21) {
        return string21.match(reAsciiWord) || [];
      }
      function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection2) {
          if (predicate(value, key, collection2)) {
            result = key;
            return false;
          }
        });
        return result;
      }
      function baseFindIndex(array2, predicate, fromIndex, fromRight) {
        var length = array2.length, index2 = fromIndex + (fromRight ? 1 : -1);
        while (fromRight ? index2-- : ++index2 < length) {
          if (predicate(array2[index2], index2, array2)) {
            return index2;
          }
        }
        return -1;
      }
      function baseIndexOf(array2, value, fromIndex) {
        return value === value ? strictIndexOf(array2, value, fromIndex) : baseFindIndex(array2, baseIsNaN, fromIndex);
      }
      function baseIndexOfWith(array2, value, fromIndex, comparator) {
        var index2 = fromIndex - 1, length = array2.length;
        while (++index2 < length) {
          if (comparator(array2[index2], value)) {
            return index2;
          }
        }
        return -1;
      }
      function baseIsNaN(value) {
        return value !== value;
      }
      function baseMean(array2, iteratee) {
        var length = array2 == null ? 0 : array2.length;
        return length ? baseSum(array2, iteratee) / length : NAN;
      }
      function baseProperty(key) {
        return function(object23) {
          return object23 == null ? undefined2 : object23[key];
        };
      }
      function basePropertyOf(object23) {
        return function(key) {
          return object23 == null ? undefined2 : object23[key];
        };
      }
      function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index2, collection2) {
          accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index2, collection2);
        });
        return accumulator;
      }
      function baseSortBy(array2, comparer) {
        var length = array2.length;
        array2.sort(comparer);
        while (length--) {
          array2[length] = array2[length].value;
        }
        return array2;
      }
      function baseSum(array2, iteratee) {
        var result, index2 = -1, length = array2.length;
        while (++index2 < length) {
          var current = iteratee(array2[index2]);
          if (current !== undefined2) {
            result = result === undefined2 ? current : result + current;
          }
        }
        return result;
      }
      function baseTimes(n3, iteratee) {
        var index2 = -1, result = Array(n3);
        while (++index2 < n3) {
          result[index2] = iteratee(index2);
        }
        return result;
      }
      function baseToPairs(object23, props) {
        return arrayMap(props, function(key) {
          return [key, object23[key]];
        });
      }
      function baseTrim(string21) {
        return string21 ? string21.slice(0, trimmedEndIndex(string21) + 1).replace(reTrimStart, "") : string21;
      }
      function baseUnary(func) {
        return function(value) {
          return func(value);
        };
      }
      function baseValues(object23, props) {
        return arrayMap(props, function(key) {
          return object23[key];
        });
      }
      function cacheHas(cache, key) {
        return cache.has(key);
      }
      function charsStartIndex(strSymbols, chrSymbols) {
        var index2 = -1, length = strSymbols.length;
        while (++index2 < length && baseIndexOf(chrSymbols, strSymbols[index2], 0) > -1) {
        }
        return index2;
      }
      function charsEndIndex(strSymbols, chrSymbols) {
        var index2 = strSymbols.length;
        while (index2-- && baseIndexOf(chrSymbols, strSymbols[index2], 0) > -1) {
        }
        return index2;
      }
      function countHolders(array2, placeholder) {
        var length = array2.length, result = 0;
        while (length--) {
          if (array2[length] === placeholder) {
            ++result;
          }
        }
        return result;
      }
      var deburrLetter = basePropertyOf(deburredLetters);
      var escapeHtmlChar = basePropertyOf(htmlEscapes);
      function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
      }
      function getValue(object23, key) {
        return object23 == null ? undefined2 : object23[key];
      }
      function hasUnicode(string21) {
        return reHasUnicode.test(string21);
      }
      function hasUnicodeWord(string21) {
        return reHasUnicodeWord.test(string21);
      }
      function iteratorToArray(iterator) {
        var data, result = [];
        while (!(data = iterator.next()).done) {
          result.push(data.value);
        }
        return result;
      }
      function mapToArray(map) {
        var index2 = -1, result = Array(map.size);
        map.forEach(function(value, key) {
          result[++index2] = [key, value];
        });
        return result;
      }
      function overArg(func, transform) {
        return function(arg) {
          return func(transform(arg));
        };
      }
      function replaceHolders(array2, placeholder) {
        var index2 = -1, length = array2.length, resIndex = 0, result = [];
        while (++index2 < length) {
          var value = array2[index2];
          if (value === placeholder || value === PLACEHOLDER) {
            array2[index2] = PLACEHOLDER;
            result[resIndex++] = index2;
          }
        }
        return result;
      }
      function setToArray(set) {
        var index2 = -1, result = Array(set.size);
        set.forEach(function(value) {
          result[++index2] = value;
        });
        return result;
      }
      function setToPairs(set) {
        var index2 = -1, result = Array(set.size);
        set.forEach(function(value) {
          result[++index2] = [value, value];
        });
        return result;
      }
      function strictIndexOf(array2, value, fromIndex) {
        var index2 = fromIndex - 1, length = array2.length;
        while (++index2 < length) {
          if (array2[index2] === value) {
            return index2;
          }
        }
        return -1;
      }
      function strictLastIndexOf(array2, value, fromIndex) {
        var index2 = fromIndex + 1;
        while (index2--) {
          if (array2[index2] === value) {
            return index2;
          }
        }
        return index2;
      }
      function stringSize(string21) {
        return hasUnicode(string21) ? unicodeSize(string21) : asciiSize(string21);
      }
      function stringToArray(string21) {
        return hasUnicode(string21) ? unicodeToArray(string21) : asciiToArray(string21);
      }
      function trimmedEndIndex(string21) {
        var index2 = string21.length;
        while (index2-- && reWhitespace.test(string21.charAt(index2))) {
        }
        return index2;
      }
      var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
      function unicodeSize(string21) {
        var result = reUnicode.lastIndex = 0;
        while (reUnicode.test(string21)) {
          ++result;
        }
        return result;
      }
      function unicodeToArray(string21) {
        return string21.match(reUnicode) || [];
      }
      function unicodeWords(string21) {
        return string21.match(reUnicodeWord) || [];
      }
      var runInContext = function runInContext2(context) {
        context = context == null ? root : _4.defaults(root.Object(), context, _4.pick(root, contextProps));
        var Array2 = context.Array, Date2 = context.Date, Error12 = context.Error, Function2 = context.Function, Math2 = context.Math, Object2 = context.Object, RegExp2 = context.RegExp, String2 = context.String, TypeError2 = context.TypeError;
        var arrayProto = Array2.prototype, funcProto = Function2.prototype, objectProto = Object2.prototype;
        var coreJsData = context["__core-js_shared__"];
        var funcToString = funcProto.toString;
        var hasOwnProperty = objectProto.hasOwnProperty;
        var idCounter = 0;
        var maskSrcKey = function() {
          var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
          return uid ? "Symbol(src)_1." + uid : "";
        }();
        var nativeObjectToString = objectProto.toString;
        var objectCtorString = funcToString.call(Object2);
        var oldDash = root._;
        var reIsNative = RegExp2(
          "^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        );
        var Buffer2 = moduleExports ? context.Buffer : undefined2, Symbol2 = context.Symbol, Uint8Array2 = context.Uint8Array, allocUnsafe = Buffer2 ? Buffer2.allocUnsafe : undefined2, getPrototype = overArg(Object2.getPrototypeOf, Object2), objectCreate = Object2.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol2 ? Symbol2.isConcatSpreadable : undefined2, symIterator = Symbol2 ? Symbol2.iterator : undefined2, symToStringTag = Symbol2 ? Symbol2.toStringTag : undefined2;
        var defineProperty = function() {
          try {
            var func = getNative(Object2, "defineProperty");
            func({}, "", {});
            return func;
          } catch (e4) {
          }
        }();
        var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date2 && Date2.now !== root.Date.now && Date2.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        var nativeCeil = Math2.ceil, nativeFloor = Math2.floor, nativeGetSymbols = Object2.getOwnPropertySymbols, nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : undefined2, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object2.keys, Object2), nativeMax = Math2.max, nativeMin = Math2.min, nativeNow = Date2.now, nativeParseInt = context.parseInt, nativeRandom = Math2.random, nativeReverse = arrayProto.reverse;
        var DataView2 = getNative(context, "DataView"), Map2 = getNative(context, "Map"), Promise2 = getNative(context, "Promise"), Set2 = getNative(context, "Set"), WeakMap2 = getNative(context, "WeakMap"), nativeCreate = getNative(Object2, "create");
        var metaMap = WeakMap2 && new WeakMap2();
        var realNames = {};
        var dataViewCtorString = toSource(DataView2), mapCtorString = toSource(Map2), promiseCtorString = toSource(Promise2), setCtorString = toSource(Set2), weakMapCtorString = toSource(WeakMap2);
        var symbolProto = Symbol2 ? Symbol2.prototype : undefined2, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined2, symbolToString = symbolProto ? symbolProto.toString : undefined2;
        function lodash(value) {
          if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
            if (value instanceof LodashWrapper) {
              return value;
            }
            if (hasOwnProperty.call(value, "__wrapped__")) {
              return wrapperClone(value);
            }
          }
          return new LodashWrapper(value);
        }
        var baseCreate = function() {
          function object23() {
          }
          return function(proto) {
            if (!isObject(proto)) {
              return {};
            }
            if (objectCreate) {
              return objectCreate(proto);
            }
            object23.prototype = proto;
            var result2 = new object23();
            object23.prototype = undefined2;
            return result2;
          };
        }();
        function baseLodash() {
        }
        function LodashWrapper(value, chainAll) {
          this.__wrapped__ = value;
          this.__actions__ = [];
          this.__chain__ = !!chainAll;
          this.__index__ = 0;
          this.__values__ = undefined2;
        }
        lodash.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          "escape": reEscape,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          "evaluate": reEvaluate,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          "interpolate": reInterpolate,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          "variable": "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          "imports": {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            "_": lodash
          }
        };
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        function LazyWrapper(value) {
          this.__wrapped__ = value;
          this.__actions__ = [];
          this.__dir__ = 1;
          this.__filtered__ = false;
          this.__iteratees__ = [];
          this.__takeCount__ = MAX_ARRAY_LENGTH;
          this.__views__ = [];
        }
        function lazyClone() {
          var result2 = new LazyWrapper(this.__wrapped__);
          result2.__actions__ = copyArray(this.__actions__);
          result2.__dir__ = this.__dir__;
          result2.__filtered__ = this.__filtered__;
          result2.__iteratees__ = copyArray(this.__iteratees__);
          result2.__takeCount__ = this.__takeCount__;
          result2.__views__ = copyArray(this.__views__);
          return result2;
        }
        function lazyReverse() {
          if (this.__filtered__) {
            var result2 = new LazyWrapper(this);
            result2.__dir__ = -1;
            result2.__filtered__ = true;
          } else {
            result2 = this.clone();
            result2.__dir__ *= -1;
          }
          return result2;
        }
        function lazyValue() {
          var array2 = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array2), isRight = dir < 0, arrLength = isArr ? array2.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index2 = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
          if (!isArr || !isRight && arrLength == length && takeCount == length) {
            return baseWrapperValue(array2, this.__actions__);
          }
          var result2 = [];
          outer:
            while (length-- && resIndex < takeCount) {
              index2 += dir;
              var iterIndex = -1, value = array2[index2];
              while (++iterIndex < iterLength) {
                var data = iteratees[iterIndex], iteratee2 = data.iteratee, type = data.type, computed = iteratee2(value);
                if (type == LAZY_MAP_FLAG) {
                  value = computed;
                } else if (!computed) {
                  if (type == LAZY_FILTER_FLAG) {
                    continue outer;
                  } else {
                    break outer;
                  }
                }
              }
              result2[resIndex++] = value;
            }
          return result2;
        }
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        function Hash(entries) {
          var index2 = -1, length = entries == null ? 0 : entries.length;
          this.clear();
          while (++index2 < length) {
            var entry = entries[index2];
            this.set(entry[0], entry[1]);
          }
        }
        function hashClear() {
          this.__data__ = nativeCreate ? nativeCreate(null) : {};
          this.size = 0;
        }
        function hashDelete(key) {
          var result2 = this.has(key) && delete this.__data__[key];
          this.size -= result2 ? 1 : 0;
          return result2;
        }
        function hashGet(key) {
          var data = this.__data__;
          if (nativeCreate) {
            var result2 = data[key];
            return result2 === HASH_UNDEFINED ? undefined2 : result2;
          }
          return hasOwnProperty.call(data, key) ? data[key] : undefined2;
        }
        function hashHas(key) {
          var data = this.__data__;
          return nativeCreate ? data[key] !== undefined2 : hasOwnProperty.call(data, key);
        }
        function hashSet(key, value) {
          var data = this.__data__;
          this.size += this.has(key) ? 0 : 1;
          data[key] = nativeCreate && value === undefined2 ? HASH_UNDEFINED : value;
          return this;
        }
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        function ListCache(entries) {
          var index2 = -1, length = entries == null ? 0 : entries.length;
          this.clear();
          while (++index2 < length) {
            var entry = entries[index2];
            this.set(entry[0], entry[1]);
          }
        }
        function listCacheClear() {
          this.__data__ = [];
          this.size = 0;
        }
        function listCacheDelete(key) {
          var data = this.__data__, index2 = assocIndexOf(data, key);
          if (index2 < 0) {
            return false;
          }
          var lastIndex = data.length - 1;
          if (index2 == lastIndex) {
            data.pop();
          } else {
            splice.call(data, index2, 1);
          }
          --this.size;
          return true;
        }
        function listCacheGet(key) {
          var data = this.__data__, index2 = assocIndexOf(data, key);
          return index2 < 0 ? undefined2 : data[index2][1];
        }
        function listCacheHas(key) {
          return assocIndexOf(this.__data__, key) > -1;
        }
        function listCacheSet(key, value) {
          var data = this.__data__, index2 = assocIndexOf(data, key);
          if (index2 < 0) {
            ++this.size;
            data.push([key, value]);
          } else {
            data[index2][1] = value;
          }
          return this;
        }
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        function MapCache(entries) {
          var index2 = -1, length = entries == null ? 0 : entries.length;
          this.clear();
          while (++index2 < length) {
            var entry = entries[index2];
            this.set(entry[0], entry[1]);
          }
        }
        function mapCacheClear() {
          this.size = 0;
          this.__data__ = {
            "hash": new Hash(),
            "map": new (Map2 || ListCache)(),
            "string": new Hash()
          };
        }
        function mapCacheDelete(key) {
          var result2 = getMapData(this, key)["delete"](key);
          this.size -= result2 ? 1 : 0;
          return result2;
        }
        function mapCacheGet(key) {
          return getMapData(this, key).get(key);
        }
        function mapCacheHas(key) {
          return getMapData(this, key).has(key);
        }
        function mapCacheSet(key, value) {
          var data = getMapData(this, key), size2 = data.size;
          data.set(key, value);
          this.size += data.size == size2 ? 0 : 1;
          return this;
        }
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        function SetCache(values2) {
          var index2 = -1, length = values2 == null ? 0 : values2.length;
          this.__data__ = new MapCache();
          while (++index2 < length) {
            this.add(values2[index2]);
          }
        }
        function setCacheAdd(value) {
          this.__data__.set(value, HASH_UNDEFINED);
          return this;
        }
        function setCacheHas(value) {
          return this.__data__.has(value);
        }
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        function Stack(entries) {
          var data = this.__data__ = new ListCache(entries);
          this.size = data.size;
        }
        function stackClear() {
          this.__data__ = new ListCache();
          this.size = 0;
        }
        function stackDelete(key) {
          var data = this.__data__, result2 = data["delete"](key);
          this.size = data.size;
          return result2;
        }
        function stackGet(key) {
          return this.__data__.get(key);
        }
        function stackHas(key) {
          return this.__data__.has(key);
        }
        function stackSet(key, value) {
          var data = this.__data__;
          if (data instanceof ListCache) {
            var pairs = data.__data__;
            if (!Map2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
              pairs.push([key, value]);
              this.size = ++data.size;
              return this;
            }
            data = this.__data__ = new MapCache(pairs);
          }
          data.set(key, value);
          this.size = data.size;
          return this;
        }
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        function arrayLikeKeys(value, inherited) {
          var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result2 = skipIndexes ? baseTimes(value.length, String2) : [], length = result2.length;
          for (var key in value) {
            if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) {
              result2.push(key);
            }
          }
          return result2;
        }
        function arraySample(array2) {
          var length = array2.length;
          return length ? array2[baseRandom(0, length - 1)] : undefined2;
        }
        function arraySampleSize(array2, n3) {
          return shuffleSelf(copyArray(array2), baseClamp(n3, 0, array2.length));
        }
        function arrayShuffle(array2) {
          return shuffleSelf(copyArray(array2));
        }
        function assignMergeValue(object23, key, value) {
          if (value !== undefined2 && !eq(object23[key], value) || value === undefined2 && !(key in object23)) {
            baseAssignValue(object23, key, value);
          }
        }
        function assignValue(object23, key, value) {
          var objValue = object23[key];
          if (!(hasOwnProperty.call(object23, key) && eq(objValue, value)) || value === undefined2 && !(key in object23)) {
            baseAssignValue(object23, key, value);
          }
        }
        function assocIndexOf(array2, key) {
          var length = array2.length;
          while (length--) {
            if (eq(array2[length][0], key)) {
              return length;
            }
          }
          return -1;
        }
        function baseAggregator(collection, setter, iteratee2, accumulator) {
          baseEach(collection, function(value, key, collection2) {
            setter(accumulator, value, iteratee2(value), collection2);
          });
          return accumulator;
        }
        function baseAssign(object23, source) {
          return object23 && copyObject(source, keys(source), object23);
        }
        function baseAssignIn(object23, source) {
          return object23 && copyObject(source, keysIn(source), object23);
        }
        function baseAssignValue(object23, key, value) {
          if (key == "__proto__" && defineProperty) {
            defineProperty(object23, key, {
              "configurable": true,
              "enumerable": true,
              "value": value,
              "writable": true
            });
          } else {
            object23[key] = value;
          }
        }
        function baseAt(object23, paths) {
          var index2 = -1, length = paths.length, result2 = Array2(length), skip = object23 == null;
          while (++index2 < length) {
            result2[index2] = skip ? undefined2 : get(object23, paths[index2]);
          }
          return result2;
        }
        function baseClamp(number3, lower, upper) {
          if (number3 === number3) {
            if (upper !== undefined2) {
              number3 = number3 <= upper ? number3 : upper;
            }
            if (lower !== undefined2) {
              number3 = number3 >= lower ? number3 : lower;
            }
          }
          return number3;
        }
        function baseClone(value, bitmask, customizer, key, object23, stack) {
          var result2, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
          if (customizer) {
            result2 = object23 ? customizer(value, key, object23, stack) : customizer(value);
          }
          if (result2 !== undefined2) {
            return result2;
          }
          if (!isObject(value)) {
            return value;
          }
          var isArr = isArray(value);
          if (isArr) {
            result2 = initCloneArray(value);
            if (!isDeep) {
              return copyArray(value, result2);
            }
          } else {
            var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
            if (isBuffer(value)) {
              return cloneBuffer(value, isDeep);
            }
            if (tag == objectTag || tag == argsTag || isFunc && !object23) {
              result2 = isFlat || isFunc ? {} : initCloneObject(value);
              if (!isDeep) {
                return isFlat ? copySymbolsIn(value, baseAssignIn(result2, value)) : copySymbols(value, baseAssign(result2, value));
              }
            } else {
              if (!cloneableTags[tag]) {
                return object23 ? value : {};
              }
              result2 = initCloneByTag(value, tag, isDeep);
            }
          }
          stack || (stack = new Stack());
          var stacked = stack.get(value);
          if (stacked) {
            return stacked;
          }
          stack.set(value, result2);
          if (isSet(value)) {
            value.forEach(function(subValue) {
              result2.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
          } else if (isMap(value)) {
            value.forEach(function(subValue, key2) {
              result2.set(key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
            });
          }
          var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
          var props = isArr ? undefined2 : keysFunc(value);
          arrayEach(props || value, function(subValue, key2) {
            if (props) {
              key2 = subValue;
              subValue = value[key2];
            }
            assignValue(result2, key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
          });
          return result2;
        }
        function baseConforms(source) {
          var props = keys(source);
          return function(object23) {
            return baseConformsTo(object23, source, props);
          };
        }
        function baseConformsTo(object23, source, props) {
          var length = props.length;
          if (object23 == null) {
            return !length;
          }
          object23 = Object2(object23);
          while (length--) {
            var key = props[length], predicate = source[key], value = object23[key];
            if (value === undefined2 && !(key in object23) || !predicate(value)) {
              return false;
            }
          }
          return true;
        }
        function baseDelay(func, wait, args) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          return setTimeout2(function() {
            func.apply(undefined2, args);
          }, wait);
        }
        function baseDifference(array2, values2, iteratee2, comparator) {
          var index2 = -1, includes2 = arrayIncludes, isCommon = true, length = array2.length, result2 = [], valuesLength = values2.length;
          if (!length) {
            return result2;
          }
          if (iteratee2) {
            values2 = arrayMap(values2, baseUnary(iteratee2));
          }
          if (comparator) {
            includes2 = arrayIncludesWith;
            isCommon = false;
          } else if (values2.length >= LARGE_ARRAY_SIZE) {
            includes2 = cacheHas;
            isCommon = false;
            values2 = new SetCache(values2);
          }
          outer:
            while (++index2 < length) {
              var value = array2[index2], computed = iteratee2 == null ? value : iteratee2(value);
              value = comparator || value !== 0 ? value : 0;
              if (isCommon && computed === computed) {
                var valuesIndex = valuesLength;
                while (valuesIndex--) {
                  if (values2[valuesIndex] === computed) {
                    continue outer;
                  }
                }
                result2.push(value);
              } else if (!includes2(values2, computed, comparator)) {
                result2.push(value);
              }
            }
          return result2;
        }
        var baseEach = createBaseEach(baseForOwn);
        var baseEachRight = createBaseEach(baseForOwnRight, true);
        function baseEvery(collection, predicate) {
          var result2 = true;
          baseEach(collection, function(value, index2, collection2) {
            result2 = !!predicate(value, index2, collection2);
            return result2;
          });
          return result2;
        }
        function baseExtremum(array2, iteratee2, comparator) {
          var index2 = -1, length = array2.length;
          while (++index2 < length) {
            var value = array2[index2], current = iteratee2(value);
            if (current != null && (computed === undefined2 ? current === current && !isSymbol(current) : comparator(current, computed))) {
              var computed = current, result2 = value;
            }
          }
          return result2;
        }
        function baseFill(array2, value, start, end) {
          var length = array2.length;
          start = toInteger(start);
          if (start < 0) {
            start = -start > length ? 0 : length + start;
          }
          end = end === undefined2 || end > length ? length : toInteger(end);
          if (end < 0) {
            end += length;
          }
          end = start > end ? 0 : toLength(end);
          while (start < end) {
            array2[start++] = value;
          }
          return array2;
        }
        function baseFilter(collection, predicate) {
          var result2 = [];
          baseEach(collection, function(value, index2, collection2) {
            if (predicate(value, index2, collection2)) {
              result2.push(value);
            }
          });
          return result2;
        }
        function baseFlatten(array2, depth, predicate, isStrict, result2) {
          var index2 = -1, length = array2.length;
          predicate || (predicate = isFlattenable);
          result2 || (result2 = []);
          while (++index2 < length) {
            var value = array2[index2];
            if (depth > 0 && predicate(value)) {
              if (depth > 1) {
                baseFlatten(value, depth - 1, predicate, isStrict, result2);
              } else {
                arrayPush(result2, value);
              }
            } else if (!isStrict) {
              result2[result2.length] = value;
            }
          }
          return result2;
        }
        var baseFor = createBaseFor();
        var baseForRight = createBaseFor(true);
        function baseForOwn(object23, iteratee2) {
          return object23 && baseFor(object23, iteratee2, keys);
        }
        function baseForOwnRight(object23, iteratee2) {
          return object23 && baseForRight(object23, iteratee2, keys);
        }
        function baseFunctions(object23, props) {
          return arrayFilter(props, function(key) {
            return isFunction(object23[key]);
          });
        }
        function baseGet(object23, path) {
          path = castPath(path, object23);
          var index2 = 0, length = path.length;
          while (object23 != null && index2 < length) {
            object23 = object23[toKey(path[index2++])];
          }
          return index2 && index2 == length ? object23 : undefined2;
        }
        function baseGetAllKeys(object23, keysFunc, symbolsFunc) {
          var result2 = keysFunc(object23);
          return isArray(object23) ? result2 : arrayPush(result2, symbolsFunc(object23));
        }
        function baseGetTag(value) {
          if (value == null) {
            return value === undefined2 ? undefinedTag : nullTag;
          }
          return symToStringTag && symToStringTag in Object2(value) ? getRawTag(value) : objectToString3(value);
        }
        function baseGt(value, other) {
          return value > other;
        }
        function baseHas(object23, key) {
          return object23 != null && hasOwnProperty.call(object23, key);
        }
        function baseHasIn(object23, key) {
          return object23 != null && key in Object2(object23);
        }
        function baseInRange(number3, start, end) {
          return number3 >= nativeMin(start, end) && number3 < nativeMax(start, end);
        }
        function baseIntersection(arrays, iteratee2, comparator) {
          var includes2 = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array2(othLength), maxLength = Infinity, result2 = [];
          while (othIndex--) {
            var array2 = arrays[othIndex];
            if (othIndex && iteratee2) {
              array2 = arrayMap(array2, baseUnary(iteratee2));
            }
            maxLength = nativeMin(array2.length, maxLength);
            caches[othIndex] = !comparator && (iteratee2 || length >= 120 && array2.length >= 120) ? new SetCache(othIndex && array2) : undefined2;
          }
          array2 = arrays[0];
          var index2 = -1, seen = caches[0];
          outer:
            while (++index2 < length && result2.length < maxLength) {
              var value = array2[index2], computed = iteratee2 ? iteratee2(value) : value;
              value = comparator || value !== 0 ? value : 0;
              if (!(seen ? cacheHas(seen, computed) : includes2(result2, computed, comparator))) {
                othIndex = othLength;
                while (--othIndex) {
                  var cache = caches[othIndex];
                  if (!(cache ? cacheHas(cache, computed) : includes2(arrays[othIndex], computed, comparator))) {
                    continue outer;
                  }
                }
                if (seen) {
                  seen.push(computed);
                }
                result2.push(value);
              }
            }
          return result2;
        }
        function baseInverter(object23, setter, iteratee2, accumulator) {
          baseForOwn(object23, function(value, key, object24) {
            setter(accumulator, iteratee2(value), key, object24);
          });
          return accumulator;
        }
        function baseInvoke(object23, path, args) {
          path = castPath(path, object23);
          object23 = parent(object23, path);
          var func = object23 == null ? object23 : object23[toKey(last(path))];
          return func == null ? undefined2 : apply(func, object23, args);
        }
        function baseIsArguments(value) {
          return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        function baseIsArrayBuffer(value) {
          return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        function baseIsDate(value) {
          return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        function baseIsEqual(value, other, bitmask, customizer, stack) {
          if (value === other) {
            return true;
          }
          if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
            return value !== value && other !== other;
          }
          return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        function baseIsEqualDeep(object23, other, bitmask, customizer, equalFunc, stack) {
          var objIsArr = isArray(object23), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object23), othTag = othIsArr ? arrayTag : getTag(other);
          objTag = objTag == argsTag ? objectTag : objTag;
          othTag = othTag == argsTag ? objectTag : othTag;
          var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
          if (isSameTag && isBuffer(object23)) {
            if (!isBuffer(other)) {
              return false;
            }
            objIsArr = true;
            objIsObj = false;
          }
          if (isSameTag && !objIsObj) {
            stack || (stack = new Stack());
            return objIsArr || isTypedArray(object23) ? equalArrays(object23, other, bitmask, customizer, equalFunc, stack) : equalByTag(object23, other, objTag, bitmask, customizer, equalFunc, stack);
          }
          if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
            var objIsWrapped = objIsObj && hasOwnProperty.call(object23, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
            if (objIsWrapped || othIsWrapped) {
              var objUnwrapped = objIsWrapped ? object23.value() : object23, othUnwrapped = othIsWrapped ? other.value() : other;
              stack || (stack = new Stack());
              return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
            }
          }
          if (!isSameTag) {
            return false;
          }
          stack || (stack = new Stack());
          return equalObjects(object23, other, bitmask, customizer, equalFunc, stack);
        }
        function baseIsMap(value) {
          return isObjectLike(value) && getTag(value) == mapTag;
        }
        function baseIsMatch(object23, source, matchData, customizer) {
          var index2 = matchData.length, length = index2, noCustomizer = !customizer;
          if (object23 == null) {
            return !length;
          }
          object23 = Object2(object23);
          while (index2--) {
            var data = matchData[index2];
            if (noCustomizer && data[2] ? data[1] !== object23[data[0]] : !(data[0] in object23)) {
              return false;
            }
          }
          while (++index2 < length) {
            data = matchData[index2];
            var key = data[0], objValue = object23[key], srcValue = data[1];
            if (noCustomizer && data[2]) {
              if (objValue === undefined2 && !(key in object23)) {
                return false;
              }
            } else {
              var stack = new Stack();
              if (customizer) {
                var result2 = customizer(objValue, srcValue, key, object23, source, stack);
              }
              if (!(result2 === undefined2 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result2)) {
                return false;
              }
            }
          }
          return true;
        }
        function baseIsNative(value) {
          if (!isObject(value) || isMasked(value)) {
            return false;
          }
          var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
          return pattern.test(toSource(value));
        }
        function baseIsRegExp(value) {
          return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        function baseIsSet(value) {
          return isObjectLike(value) && getTag(value) == setTag;
        }
        function baseIsTypedArray(value) {
          return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        function baseIteratee(value) {
          if (typeof value == "function") {
            return value;
          }
          if (value == null) {
            return identity2;
          }
          if (typeof value == "object") {
            return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
          }
          return property(value);
        }
        function baseKeys(object23) {
          if (!isPrototype(object23)) {
            return nativeKeys(object23);
          }
          var result2 = [];
          for (var key in Object2(object23)) {
            if (hasOwnProperty.call(object23, key) && key != "constructor") {
              result2.push(key);
            }
          }
          return result2;
        }
        function baseKeysIn(object23) {
          if (!isObject(object23)) {
            return nativeKeysIn(object23);
          }
          var isProto = isPrototype(object23), result2 = [];
          for (var key in object23) {
            if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object23, key)))) {
              result2.push(key);
            }
          }
          return result2;
        }
        function baseLt(value, other) {
          return value < other;
        }
        function baseMap(collection, iteratee2) {
          var index2 = -1, result2 = isArrayLike(collection) ? Array2(collection.length) : [];
          baseEach(collection, function(value, key, collection2) {
            result2[++index2] = iteratee2(value, key, collection2);
          });
          return result2;
        }
        function baseMatches(source) {
          var matchData = getMatchData(source);
          if (matchData.length == 1 && matchData[0][2]) {
            return matchesStrictComparable(matchData[0][0], matchData[0][1]);
          }
          return function(object23) {
            return object23 === source || baseIsMatch(object23, source, matchData);
          };
        }
        function baseMatchesProperty(path, srcValue) {
          if (isKey(path) && isStrictComparable(srcValue)) {
            return matchesStrictComparable(toKey(path), srcValue);
          }
          return function(object23) {
            var objValue = get(object23, path);
            return objValue === undefined2 && objValue === srcValue ? hasIn(object23, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
          };
        }
        function baseMerge(object23, source, srcIndex, customizer, stack) {
          if (object23 === source) {
            return;
          }
          baseFor(source, function(srcValue, key) {
            stack || (stack = new Stack());
            if (isObject(srcValue)) {
              baseMergeDeep(object23, source, key, srcIndex, baseMerge, customizer, stack);
            } else {
              var newValue = customizer ? customizer(safeGet(object23, key), srcValue, key + "", object23, source, stack) : undefined2;
              if (newValue === undefined2) {
                newValue = srcValue;
              }
              assignMergeValue(object23, key, newValue);
            }
          }, keysIn);
        }
        function baseMergeDeep(object23, source, key, srcIndex, mergeFunc, customizer, stack) {
          var objValue = safeGet(object23, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
          if (stacked) {
            assignMergeValue(object23, key, stacked);
            return;
          }
          var newValue = customizer ? customizer(objValue, srcValue, key + "", object23, source, stack) : undefined2;
          var isCommon = newValue === undefined2;
          if (isCommon) {
            var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
            newValue = srcValue;
            if (isArr || isBuff || isTyped) {
              if (isArray(objValue)) {
                newValue = objValue;
              } else if (isArrayLikeObject(objValue)) {
                newValue = copyArray(objValue);
              } else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
              } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
              } else {
                newValue = [];
              }
            } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
              newValue = objValue;
              if (isArguments(objValue)) {
                newValue = toPlainObject(objValue);
              } else if (!isObject(objValue) || isFunction(objValue)) {
                newValue = initCloneObject(srcValue);
              }
            } else {
              isCommon = false;
            }
          }
          if (isCommon) {
            stack.set(srcValue, newValue);
            mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
            stack["delete"](srcValue);
          }
          assignMergeValue(object23, key, newValue);
        }
        function baseNth(array2, n3) {
          var length = array2.length;
          if (!length) {
            return;
          }
          n3 += n3 < 0 ? length : 0;
          return isIndex(n3, length) ? array2[n3] : undefined2;
        }
        function baseOrderBy(collection, iteratees, orders) {
          if (iteratees.length) {
            iteratees = arrayMap(iteratees, function(iteratee2) {
              if (isArray(iteratee2)) {
                return function(value) {
                  return baseGet(value, iteratee2.length === 1 ? iteratee2[0] : iteratee2);
                };
              }
              return iteratee2;
            });
          } else {
            iteratees = [identity2];
          }
          var index2 = -1;
          iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
          var result2 = baseMap(collection, function(value, key, collection2) {
            var criteria = arrayMap(iteratees, function(iteratee2) {
              return iteratee2(value);
            });
            return { "criteria": criteria, "index": ++index2, "value": value };
          });
          return baseSortBy(result2, function(object23, other) {
            return compareMultiple(object23, other, orders);
          });
        }
        function basePick(object23, paths) {
          return basePickBy(object23, paths, function(value, path) {
            return hasIn(object23, path);
          });
        }
        function basePickBy(object23, paths, predicate) {
          var index2 = -1, length = paths.length, result2 = {};
          while (++index2 < length) {
            var path = paths[index2], value = baseGet(object23, path);
            if (predicate(value, path)) {
              baseSet(result2, castPath(path, object23), value);
            }
          }
          return result2;
        }
        function basePropertyDeep(path) {
          return function(object23) {
            return baseGet(object23, path);
          };
        }
        function basePullAll(array2, values2, iteratee2, comparator) {
          var indexOf2 = comparator ? baseIndexOfWith : baseIndexOf, index2 = -1, length = values2.length, seen = array2;
          if (array2 === values2) {
            values2 = copyArray(values2);
          }
          if (iteratee2) {
            seen = arrayMap(array2, baseUnary(iteratee2));
          }
          while (++index2 < length) {
            var fromIndex = 0, value = values2[index2], computed = iteratee2 ? iteratee2(value) : value;
            while ((fromIndex = indexOf2(seen, computed, fromIndex, comparator)) > -1) {
              if (seen !== array2) {
                splice.call(seen, fromIndex, 1);
              }
              splice.call(array2, fromIndex, 1);
            }
          }
          return array2;
        }
        function basePullAt(array2, indexes) {
          var length = array2 ? indexes.length : 0, lastIndex = length - 1;
          while (length--) {
            var index2 = indexes[length];
            if (length == lastIndex || index2 !== previous) {
              var previous = index2;
              if (isIndex(index2)) {
                splice.call(array2, index2, 1);
              } else {
                baseUnset(array2, index2);
              }
            }
          }
          return array2;
        }
        function baseRandom(lower, upper) {
          return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        function baseRange(start, end, step, fromRight) {
          var index2 = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result2 = Array2(length);
          while (length--) {
            result2[fromRight ? length : ++index2] = start;
            start += step;
          }
          return result2;
        }
        function baseRepeat(string21, n3) {
          var result2 = "";
          if (!string21 || n3 < 1 || n3 > MAX_SAFE_INTEGER) {
            return result2;
          }
          do {
            if (n3 % 2) {
              result2 += string21;
            }
            n3 = nativeFloor(n3 / 2);
            if (n3) {
              string21 += string21;
            }
          } while (n3);
          return result2;
        }
        function baseRest(func, start) {
          return setToString(overRest(func, start, identity2), func + "");
        }
        function baseSample(collection) {
          return arraySample(values(collection));
        }
        function baseSampleSize(collection, n3) {
          var array2 = values(collection);
          return shuffleSelf(array2, baseClamp(n3, 0, array2.length));
        }
        function baseSet(object23, path, value, customizer) {
          if (!isObject(object23)) {
            return object23;
          }
          path = castPath(path, object23);
          var index2 = -1, length = path.length, lastIndex = length - 1, nested = object23;
          while (nested != null && ++index2 < length) {
            var key = toKey(path[index2]), newValue = value;
            if (key === "__proto__" || key === "constructor" || key === "prototype") {
              return object23;
            }
            if (index2 != lastIndex) {
              var objValue = nested[key];
              newValue = customizer ? customizer(objValue, key, nested) : undefined2;
              if (newValue === undefined2) {
                newValue = isObject(objValue) ? objValue : isIndex(path[index2 + 1]) ? [] : {};
              }
            }
            assignValue(nested, key, newValue);
            nested = nested[key];
          }
          return object23;
        }
        var baseSetData = !metaMap ? identity2 : function(func, data) {
          metaMap.set(func, data);
          return func;
        };
        var baseSetToString = !defineProperty ? identity2 : function(func, string21) {
          return defineProperty(func, "toString", {
            "configurable": true,
            "enumerable": false,
            "value": constant(string21),
            "writable": true
          });
        };
        function baseShuffle(collection) {
          return shuffleSelf(values(collection));
        }
        function baseSlice(array2, start, end) {
          var index2 = -1, length = array2.length;
          if (start < 0) {
            start = -start > length ? 0 : length + start;
          }
          end = end > length ? length : end;
          if (end < 0) {
            end += length;
          }
          length = start > end ? 0 : end - start >>> 0;
          start >>>= 0;
          var result2 = Array2(length);
          while (++index2 < length) {
            result2[index2] = array2[index2 + start];
          }
          return result2;
        }
        function baseSome(collection, predicate) {
          var result2;
          baseEach(collection, function(value, index2, collection2) {
            result2 = predicate(value, index2, collection2);
            return !result2;
          });
          return !!result2;
        }
        function baseSortedIndex(array2, value, retHighest) {
          var low = 0, high = array2 == null ? low : array2.length;
          if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
            while (low < high) {
              var mid = low + high >>> 1, computed = array2[mid];
              if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) {
                low = mid + 1;
              } else {
                high = mid;
              }
            }
            return high;
          }
          return baseSortedIndexBy(array2, value, identity2, retHighest);
        }
        function baseSortedIndexBy(array2, value, iteratee2, retHighest) {
          var low = 0, high = array2 == null ? 0 : array2.length;
          if (high === 0) {
            return 0;
          }
          value = iteratee2(value);
          var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined2;
          while (low < high) {
            var mid = nativeFloor((low + high) / 2), computed = iteratee2(array2[mid]), othIsDefined = computed !== undefined2, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
            if (valIsNaN) {
              var setLow = retHighest || othIsReflexive;
            } else if (valIsUndefined) {
              setLow = othIsReflexive && (retHighest || othIsDefined);
            } else if (valIsNull) {
              setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
            } else if (valIsSymbol) {
              setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
            } else if (othIsNull || othIsSymbol) {
              setLow = false;
            } else {
              setLow = retHighest ? computed <= value : computed < value;
            }
            if (setLow) {
              low = mid + 1;
            } else {
              high = mid;
            }
          }
          return nativeMin(high, MAX_ARRAY_INDEX);
        }
        function baseSortedUniq(array2, iteratee2) {
          var index2 = -1, length = array2.length, resIndex = 0, result2 = [];
          while (++index2 < length) {
            var value = array2[index2], computed = iteratee2 ? iteratee2(value) : value;
            if (!index2 || !eq(computed, seen)) {
              var seen = computed;
              result2[resIndex++] = value === 0 ? 0 : value;
            }
          }
          return result2;
        }
        function baseToNumber(value) {
          if (typeof value == "number") {
            return value;
          }
          if (isSymbol(value)) {
            return NAN;
          }
          return +value;
        }
        function baseToString(value) {
          if (typeof value == "string") {
            return value;
          }
          if (isArray(value)) {
            return arrayMap(value, baseToString) + "";
          }
          if (isSymbol(value)) {
            return symbolToString ? symbolToString.call(value) : "";
          }
          var result2 = value + "";
          return result2 == "0" && 1 / value == -INFINITY ? "-0" : result2;
        }
        function baseUniq(array2, iteratee2, comparator) {
          var index2 = -1, includes2 = arrayIncludes, length = array2.length, isCommon = true, result2 = [], seen = result2;
          if (comparator) {
            isCommon = false;
            includes2 = arrayIncludesWith;
          } else if (length >= LARGE_ARRAY_SIZE) {
            var set2 = iteratee2 ? null : createSet(array2);
            if (set2) {
              return setToArray(set2);
            }
            isCommon = false;
            includes2 = cacheHas;
            seen = new SetCache();
          } else {
            seen = iteratee2 ? [] : result2;
          }
          outer:
            while (++index2 < length) {
              var value = array2[index2], computed = iteratee2 ? iteratee2(value) : value;
              value = comparator || value !== 0 ? value : 0;
              if (isCommon && computed === computed) {
                var seenIndex = seen.length;
                while (seenIndex--) {
                  if (seen[seenIndex] === computed) {
                    continue outer;
                  }
                }
                if (iteratee2) {
                  seen.push(computed);
                }
                result2.push(value);
              } else if (!includes2(seen, computed, comparator)) {
                if (seen !== result2) {
                  seen.push(computed);
                }
                result2.push(value);
              }
            }
          return result2;
        }
        function baseUnset(object23, path) {
          path = castPath(path, object23);
          object23 = parent(object23, path);
          return object23 == null || delete object23[toKey(last(path))];
        }
        function baseUpdate(object23, path, updater, customizer) {
          return baseSet(object23, path, updater(baseGet(object23, path)), customizer);
        }
        function baseWhile(array2, predicate, isDrop, fromRight) {
          var length = array2.length, index2 = fromRight ? length : -1;
          while ((fromRight ? index2-- : ++index2 < length) && predicate(array2[index2], index2, array2)) {
          }
          return isDrop ? baseSlice(array2, fromRight ? 0 : index2, fromRight ? index2 + 1 : length) : baseSlice(array2, fromRight ? index2 + 1 : 0, fromRight ? length : index2);
        }
        function baseWrapperValue(value, actions) {
          var result2 = value;
          if (result2 instanceof LazyWrapper) {
            result2 = result2.value();
          }
          return arrayReduce(actions, function(result3, action) {
            return action.func.apply(action.thisArg, arrayPush([result3], action.args));
          }, result2);
        }
        function baseXor(arrays, iteratee2, comparator) {
          var length = arrays.length;
          if (length < 2) {
            return length ? baseUniq(arrays[0]) : [];
          }
          var index2 = -1, result2 = Array2(length);
          while (++index2 < length) {
            var array2 = arrays[index2], othIndex = -1;
            while (++othIndex < length) {
              if (othIndex != index2) {
                result2[index2] = baseDifference(result2[index2] || array2, arrays[othIndex], iteratee2, comparator);
              }
            }
          }
          return baseUniq(baseFlatten(result2, 1), iteratee2, comparator);
        }
        function baseZipObject(props, values2, assignFunc) {
          var index2 = -1, length = props.length, valsLength = values2.length, result2 = {};
          while (++index2 < length) {
            var value = index2 < valsLength ? values2[index2] : undefined2;
            assignFunc(result2, props[index2], value);
          }
          return result2;
        }
        function castArrayLikeObject(value) {
          return isArrayLikeObject(value) ? value : [];
        }
        function castFunction(value) {
          return typeof value == "function" ? value : identity2;
        }
        function castPath(value, object23) {
          if (isArray(value)) {
            return value;
          }
          return isKey(value, object23) ? [value] : stringToPath(toString(value));
        }
        var castRest = baseRest;
        function castSlice(array2, start, end) {
          var length = array2.length;
          end = end === undefined2 ? length : end;
          return !start && end >= length ? array2 : baseSlice(array2, start, end);
        }
        var clearTimeout2 = ctxClearTimeout || function(id18) {
          return root.clearTimeout(id18);
        };
        function cloneBuffer(buffer, isDeep) {
          if (isDeep) {
            return buffer.slice();
          }
          var length = buffer.length, result2 = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
          buffer.copy(result2);
          return result2;
        }
        function cloneArrayBuffer(arrayBuffer) {
          var result2 = new arrayBuffer.constructor(arrayBuffer.byteLength);
          new Uint8Array2(result2).set(new Uint8Array2(arrayBuffer));
          return result2;
        }
        function cloneDataView(dataView, isDeep) {
          var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
          return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        function cloneRegExp(regexp) {
          var result2 = new regexp.constructor(regexp.source, reFlags.exec(regexp));
          result2.lastIndex = regexp.lastIndex;
          return result2;
        }
        function cloneSymbol(symbol) {
          return symbolValueOf ? Object2(symbolValueOf.call(symbol)) : {};
        }
        function cloneTypedArray(typedArray, isDeep) {
          var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
          return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        function compareAscending(value, other) {
          if (value !== other) {
            var valIsDefined = value !== undefined2, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
            var othIsDefined = other !== undefined2, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
            if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
              return 1;
            }
            if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
              return -1;
            }
          }
          return 0;
        }
        function compareMultiple(object23, other, orders) {
          var index2 = -1, objCriteria = object23.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
          while (++index2 < length) {
            var result2 = compareAscending(objCriteria[index2], othCriteria[index2]);
            if (result2) {
              if (index2 >= ordersLength) {
                return result2;
              }
              var order2 = orders[index2];
              return result2 * (order2 == "desc" ? -1 : 1);
            }
          }
          return object23.index - other.index;
        }
        function composeArgs(args, partials, holders, isCurried) {
          var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result2 = Array2(leftLength + rangeLength), isUncurried = !isCurried;
          while (++leftIndex < leftLength) {
            result2[leftIndex] = partials[leftIndex];
          }
          while (++argsIndex < holdersLength) {
            if (isUncurried || argsIndex < argsLength) {
              result2[holders[argsIndex]] = args[argsIndex];
            }
          }
          while (rangeLength--) {
            result2[leftIndex++] = args[argsIndex++];
          }
          return result2;
        }
        function composeArgsRight(args, partials, holders, isCurried) {
          var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result2 = Array2(rangeLength + rightLength), isUncurried = !isCurried;
          while (++argsIndex < rangeLength) {
            result2[argsIndex] = args[argsIndex];
          }
          var offset = argsIndex;
          while (++rightIndex < rightLength) {
            result2[offset + rightIndex] = partials[rightIndex];
          }
          while (++holdersIndex < holdersLength) {
            if (isUncurried || argsIndex < argsLength) {
              result2[offset + holders[holdersIndex]] = args[argsIndex++];
            }
          }
          return result2;
        }
        function copyArray(source, array2) {
          var index2 = -1, length = source.length;
          array2 || (array2 = Array2(length));
          while (++index2 < length) {
            array2[index2] = source[index2];
          }
          return array2;
        }
        function copyObject(source, props, object23, customizer) {
          var isNew = !object23;
          object23 || (object23 = {});
          var index2 = -1, length = props.length;
          while (++index2 < length) {
            var key = props[index2];
            var newValue = customizer ? customizer(object23[key], source[key], key, object23, source) : undefined2;
            if (newValue === undefined2) {
              newValue = source[key];
            }
            if (isNew) {
              baseAssignValue(object23, key, newValue);
            } else {
              assignValue(object23, key, newValue);
            }
          }
          return object23;
        }
        function copySymbols(source, object23) {
          return copyObject(source, getSymbols(source), object23);
        }
        function copySymbolsIn(source, object23) {
          return copyObject(source, getSymbolsIn(source), object23);
        }
        function createAggregator(setter, initializer) {
          return function(collection, iteratee2) {
            var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
            return func(collection, setter, getIteratee(iteratee2, 2), accumulator);
          };
        }
        function createAssigner(assigner) {
          return baseRest(function(object23, sources) {
            var index2 = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined2, guard = length > 2 ? sources[2] : undefined2;
            customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined2;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) {
              customizer = length < 3 ? undefined2 : customizer;
              length = 1;
            }
            object23 = Object2(object23);
            while (++index2 < length) {
              var source = sources[index2];
              if (source) {
                assigner(object23, source, index2, customizer);
              }
            }
            return object23;
          });
        }
        function createBaseEach(eachFunc, fromRight) {
          return function(collection, iteratee2) {
            if (collection == null) {
              return collection;
            }
            if (!isArrayLike(collection)) {
              return eachFunc(collection, iteratee2);
            }
            var length = collection.length, index2 = fromRight ? length : -1, iterable = Object2(collection);
            while (fromRight ? index2-- : ++index2 < length) {
              if (iteratee2(iterable[index2], index2, iterable) === false) {
                break;
              }
            }
            return collection;
          };
        }
        function createBaseFor(fromRight) {
          return function(object23, iteratee2, keysFunc) {
            var index2 = -1, iterable = Object2(object23), props = keysFunc(object23), length = props.length;
            while (length--) {
              var key = props[fromRight ? length : ++index2];
              if (iteratee2(iterable[key], key, iterable) === false) {
                break;
              }
            }
            return object23;
          };
        }
        function createBind(func, bitmask, thisArg) {
          var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
          function wrapper() {
            var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
            return fn.apply(isBind ? thisArg : this, arguments);
          }
          return wrapper;
        }
        function createCaseFirst(methodName) {
          return function(string21) {
            string21 = toString(string21);
            var strSymbols = hasUnicode(string21) ? stringToArray(string21) : undefined2;
            var chr = strSymbols ? strSymbols[0] : string21.charAt(0);
            var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string21.slice(1);
            return chr[methodName]() + trailing;
          };
        }
        function createCompounder(callback) {
          return function(string21) {
            return arrayReduce(words(deburr(string21).replace(reApos, "")), callback, "");
          };
        }
        function createCtor(Ctor) {
          return function() {
            var args = arguments;
            switch (args.length) {
              case 0:
                return new Ctor();
              case 1:
                return new Ctor(args[0]);
              case 2:
                return new Ctor(args[0], args[1]);
              case 3:
                return new Ctor(args[0], args[1], args[2]);
              case 4:
                return new Ctor(args[0], args[1], args[2], args[3]);
              case 5:
                return new Ctor(args[0], args[1], args[2], args[3], args[4]);
              case 6:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
              case 7:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
            }
            var thisBinding = baseCreate(Ctor.prototype), result2 = Ctor.apply(thisBinding, args);
            return isObject(result2) ? result2 : thisBinding;
          };
        }
        function createCurry(func, bitmask, arity) {
          var Ctor = createCtor(func);
          function wrapper() {
            var length = arguments.length, args = Array2(length), index2 = length, placeholder = getHolder(wrapper);
            while (index2--) {
              args[index2] = arguments[index2];
            }
            var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
            length -= holders.length;
            if (length < arity) {
              return createRecurry(
                func,
                bitmask,
                createHybrid,
                wrapper.placeholder,
                undefined2,
                args,
                holders,
                undefined2,
                undefined2,
                arity - length
              );
            }
            var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
            return apply(fn, this, args);
          }
          return wrapper;
        }
        function createFind(findIndexFunc) {
          return function(collection, predicate, fromIndex) {
            var iterable = Object2(collection);
            if (!isArrayLike(collection)) {
              var iteratee2 = getIteratee(predicate, 3);
              collection = keys(collection);
              predicate = function(key) {
                return iteratee2(iterable[key], key, iterable);
              };
            }
            var index2 = findIndexFunc(collection, predicate, fromIndex);
            return index2 > -1 ? iterable[iteratee2 ? collection[index2] : index2] : undefined2;
          };
        }
        function createFlow(fromRight) {
          return flatRest(function(funcs) {
            var length = funcs.length, index2 = length, prereq = LodashWrapper.prototype.thru;
            if (fromRight) {
              funcs.reverse();
            }
            while (index2--) {
              var func = funcs[index2];
              if (typeof func != "function") {
                throw new TypeError2(FUNC_ERROR_TEXT);
              }
              if (prereq && !wrapper && getFuncName(func) == "wrapper") {
                var wrapper = new LodashWrapper([], true);
              }
            }
            index2 = wrapper ? index2 : length;
            while (++index2 < length) {
              func = funcs[index2];
              var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined2;
              if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) {
                wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
              } else {
                wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
              }
            }
            return function() {
              var args = arguments, value = args[0];
              if (wrapper && args.length == 1 && isArray(value)) {
                return wrapper.plant(value).value();
              }
              var index3 = 0, result2 = length ? funcs[index3].apply(this, args) : value;
              while (++index3 < length) {
                result2 = funcs[index3].call(this, result2);
              }
              return result2;
            };
          });
        }
        function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary2, arity) {
          var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined2 : createCtor(func);
          function wrapper() {
            var length = arguments.length, args = Array2(length), index2 = length;
            while (index2--) {
              args[index2] = arguments[index2];
            }
            if (isCurried) {
              var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
            }
            if (partials) {
              args = composeArgs(args, partials, holders, isCurried);
            }
            if (partialsRight) {
              args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
            }
            length -= holdersCount;
            if (isCurried && length < arity) {
              var newHolders = replaceHolders(args, placeholder);
              return createRecurry(
                func,
                bitmask,
                createHybrid,
                wrapper.placeholder,
                thisArg,
                args,
                newHolders,
                argPos,
                ary2,
                arity - length
              );
            }
            var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
            length = args.length;
            if (argPos) {
              args = reorder(args, argPos);
            } else if (isFlip && length > 1) {
              args.reverse();
            }
            if (isAry && ary2 < length) {
              args.length = ary2;
            }
            if (this && this !== root && this instanceof wrapper) {
              fn = Ctor || createCtor(fn);
            }
            return fn.apply(thisBinding, args);
          }
          return wrapper;
        }
        function createInverter(setter, toIteratee) {
          return function(object23, iteratee2) {
            return baseInverter(object23, setter, toIteratee(iteratee2), {});
          };
        }
        function createMathOperation(operator, defaultValue) {
          return function(value, other) {
            var result2;
            if (value === undefined2 && other === undefined2) {
              return defaultValue;
            }
            if (value !== undefined2) {
              result2 = value;
            }
            if (other !== undefined2) {
              if (result2 === undefined2) {
                return other;
              }
              if (typeof value == "string" || typeof other == "string") {
                value = baseToString(value);
                other = baseToString(other);
              } else {
                value = baseToNumber(value);
                other = baseToNumber(other);
              }
              result2 = operator(value, other);
            }
            return result2;
          };
        }
        function createOver(arrayFunc) {
          return flatRest(function(iteratees) {
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            return baseRest(function(args) {
              var thisArg = this;
              return arrayFunc(iteratees, function(iteratee2) {
                return apply(iteratee2, thisArg, args);
              });
            });
          });
        }
        function createPadding(length, chars) {
          chars = chars === undefined2 ? " " : baseToString(chars);
          var charsLength = chars.length;
          if (charsLength < 2) {
            return charsLength ? baseRepeat(chars, length) : chars;
          }
          var result2 = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
          return hasUnicode(chars) ? castSlice(stringToArray(result2), 0, length).join("") : result2.slice(0, length);
        }
        function createPartial(func, bitmask, thisArg, partials) {
          var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
          function wrapper() {
            var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array2(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
            while (++leftIndex < leftLength) {
              args[leftIndex] = partials[leftIndex];
            }
            while (argsLength--) {
              args[leftIndex++] = arguments[++argsIndex];
            }
            return apply(fn, isBind ? thisArg : this, args);
          }
          return wrapper;
        }
        function createRange(fromRight) {
          return function(start, end, step) {
            if (step && typeof step != "number" && isIterateeCall(start, end, step)) {
              end = step = undefined2;
            }
            start = toFinite(start);
            if (end === undefined2) {
              end = start;
              start = 0;
            } else {
              end = toFinite(end);
            }
            step = step === undefined2 ? start < end ? 1 : -1 : toFinite(step);
            return baseRange(start, end, step, fromRight);
          };
        }
        function createRelationalOperation(operator) {
          return function(value, other) {
            if (!(typeof value == "string" && typeof other == "string")) {
              value = toNumber(value);
              other = toNumber(other);
            }
            return operator(value, other);
          };
        }
        function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary2, arity) {
          var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined2, newHoldersRight = isCurry ? undefined2 : holders, newPartials = isCurry ? partials : undefined2, newPartialsRight = isCurry ? undefined2 : partials;
          bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
          bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
          if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
            bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
          }
          var newData = [
            func,
            bitmask,
            thisArg,
            newPartials,
            newHolders,
            newPartialsRight,
            newHoldersRight,
            argPos,
            ary2,
            arity
          ];
          var result2 = wrapFunc.apply(undefined2, newData);
          if (isLaziable(func)) {
            setData(result2, newData);
          }
          result2.placeholder = placeholder;
          return setWrapToString(result2, func, bitmask);
        }
        function createRound(methodName) {
          var func = Math2[methodName];
          return function(number3, precision) {
            number3 = toNumber(number3);
            precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
            if (precision && nativeIsFinite(number3)) {
              var pair = (toString(number3) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
              pair = (toString(value) + "e").split("e");
              return +(pair[0] + "e" + (+pair[1] - precision));
            }
            return func(number3);
          };
        }
        var createSet = !(Set2 && 1 / setToArray(new Set2([, -0]))[1] == INFINITY) ? noop20 : function(values2) {
          return new Set2(values2);
        };
        function createToPairs(keysFunc) {
          return function(object23) {
            var tag = getTag(object23);
            if (tag == mapTag) {
              return mapToArray(object23);
            }
            if (tag == setTag) {
              return setToPairs(object23);
            }
            return baseToPairs(object23, keysFunc(object23));
          };
        }
        function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary2, arity) {
          var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
          if (!isBindKey && typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          var length = partials ? partials.length : 0;
          if (!length) {
            bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
            partials = holders = undefined2;
          }
          ary2 = ary2 === undefined2 ? ary2 : nativeMax(toInteger(ary2), 0);
          arity = arity === undefined2 ? arity : toInteger(arity);
          length -= holders ? holders.length : 0;
          if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
            var partialsRight = partials, holdersRight = holders;
            partials = holders = undefined2;
          }
          var data = isBindKey ? undefined2 : getData(func);
          var newData = [
            func,
            bitmask,
            thisArg,
            partials,
            holders,
            partialsRight,
            holdersRight,
            argPos,
            ary2,
            arity
          ];
          if (data) {
            mergeData(newData, data);
          }
          func = newData[0];
          bitmask = newData[1];
          thisArg = newData[2];
          partials = newData[3];
          holders = newData[4];
          arity = newData[9] = newData[9] === undefined2 ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
          if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
            bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
          }
          if (!bitmask || bitmask == WRAP_BIND_FLAG) {
            var result2 = createBind(func, bitmask, thisArg);
          } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
            result2 = createCurry(func, bitmask, arity);
          } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
            result2 = createPartial(func, bitmask, thisArg, partials);
          } else {
            result2 = createHybrid.apply(undefined2, newData);
          }
          var setter = data ? baseSetData : setData;
          return setWrapToString(setter(result2, newData), func, bitmask);
        }
        function customDefaultsAssignIn(objValue, srcValue, key, object23) {
          if (objValue === undefined2 || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object23, key)) {
            return srcValue;
          }
          return objValue;
        }
        function customDefaultsMerge(objValue, srcValue, key, object23, source, stack) {
          if (isObject(objValue) && isObject(srcValue)) {
            stack.set(srcValue, objValue);
            baseMerge(objValue, srcValue, undefined2, customDefaultsMerge, stack);
            stack["delete"](srcValue);
          }
          return objValue;
        }
        function customOmitClone(value) {
          return isPlainObject(value) ? undefined2 : value;
        }
        function equalArrays(array2, other, bitmask, customizer, equalFunc, stack) {
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array2.length, othLength = other.length;
          if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
            return false;
          }
          var arrStacked = stack.get(array2);
          var othStacked = stack.get(other);
          if (arrStacked && othStacked) {
            return arrStacked == other && othStacked == array2;
          }
          var index2 = -1, result2 = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined2;
          stack.set(array2, other);
          stack.set(other, array2);
          while (++index2 < arrLength) {
            var arrValue = array2[index2], othValue = other[index2];
            if (customizer) {
              var compared = isPartial ? customizer(othValue, arrValue, index2, other, array2, stack) : customizer(arrValue, othValue, index2, array2, other, stack);
            }
            if (compared !== undefined2) {
              if (compared) {
                continue;
              }
              result2 = false;
              break;
            }
            if (seen) {
              if (!arraySome(other, function(othValue2, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
                result2 = false;
                break;
              }
            } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              result2 = false;
              break;
            }
          }
          stack["delete"](array2);
          stack["delete"](other);
          return result2;
        }
        function equalByTag(object23, other, tag, bitmask, customizer, equalFunc, stack) {
          switch (tag) {
            case dataViewTag:
              if (object23.byteLength != other.byteLength || object23.byteOffset != other.byteOffset) {
                return false;
              }
              object23 = object23.buffer;
              other = other.buffer;
            case arrayBufferTag:
              if (object23.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object23), new Uint8Array2(other))) {
                return false;
              }
              return true;
            case boolTag:
            case dateTag:
            case numberTag:
              return eq(+object23, +other);
            case errorTag:
              return object23.name == other.name && object23.message == other.message;
            case regexpTag:
            case stringTag:
              return object23 == other + "";
            case mapTag:
              var convert = mapToArray;
            case setTag:
              var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
              convert || (convert = setToArray);
              if (object23.size != other.size && !isPartial) {
                return false;
              }
              var stacked = stack.get(object23);
              if (stacked) {
                return stacked == other;
              }
              bitmask |= COMPARE_UNORDERED_FLAG;
              stack.set(object23, other);
              var result2 = equalArrays(convert(object23), convert(other), bitmask, customizer, equalFunc, stack);
              stack["delete"](object23);
              return result2;
            case symbolTag:
              if (symbolValueOf) {
                return symbolValueOf.call(object23) == symbolValueOf.call(other);
              }
          }
          return false;
        }
        function equalObjects(object23, other, bitmask, customizer, equalFunc, stack) {
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object23), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
          if (objLength != othLength && !isPartial) {
            return false;
          }
          var index2 = objLength;
          while (index2--) {
            var key = objProps[index2];
            if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
              return false;
            }
          }
          var objStacked = stack.get(object23);
          var othStacked = stack.get(other);
          if (objStacked && othStacked) {
            return objStacked == other && othStacked == object23;
          }
          var result2 = true;
          stack.set(object23, other);
          stack.set(other, object23);
          var skipCtor = isPartial;
          while (++index2 < objLength) {
            key = objProps[index2];
            var objValue = object23[key], othValue = other[key];
            if (customizer) {
              var compared = isPartial ? customizer(othValue, objValue, key, other, object23, stack) : customizer(objValue, othValue, key, object23, other, stack);
            }
            if (!(compared === undefined2 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
              result2 = false;
              break;
            }
            skipCtor || (skipCtor = key == "constructor");
          }
          if (result2 && !skipCtor) {
            var objCtor = object23.constructor, othCtor = other.constructor;
            if (objCtor != othCtor && ("constructor" in object23 && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
              result2 = false;
            }
          }
          stack["delete"](object23);
          stack["delete"](other);
          return result2;
        }
        function flatRest(func) {
          return setToString(overRest(func, undefined2, flatten), func + "");
        }
        function getAllKeys(object23) {
          return baseGetAllKeys(object23, keys, getSymbols);
        }
        function getAllKeysIn(object23) {
          return baseGetAllKeys(object23, keysIn, getSymbolsIn);
        }
        var getData = !metaMap ? noop20 : function(func) {
          return metaMap.get(func);
        };
        function getFuncName(func) {
          var result2 = func.name + "", array2 = realNames[result2], length = hasOwnProperty.call(realNames, result2) ? array2.length : 0;
          while (length--) {
            var data = array2[length], otherFunc = data.func;
            if (otherFunc == null || otherFunc == func) {
              return data.name;
            }
          }
          return result2;
        }
        function getHolder(func) {
          var object23 = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
          return object23.placeholder;
        }
        function getIteratee() {
          var result2 = lodash.iteratee || iteratee;
          result2 = result2 === iteratee ? baseIteratee : result2;
          return arguments.length ? result2(arguments[0], arguments[1]) : result2;
        }
        function getMapData(map2, key) {
          var data = map2.__data__;
          return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        function getMatchData(object23) {
          var result2 = keys(object23), length = result2.length;
          while (length--) {
            var key = result2[length], value = object23[key];
            result2[length] = [key, value, isStrictComparable(value)];
          }
          return result2;
        }
        function getNative(object23, key) {
          var value = getValue(object23, key);
          return baseIsNative(value) ? value : undefined2;
        }
        function getRawTag(value) {
          var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
          try {
            value[symToStringTag] = undefined2;
            var unmasked = true;
          } catch (e4) {
          }
          var result2 = nativeObjectToString.call(value);
          if (unmasked) {
            if (isOwn) {
              value[symToStringTag] = tag;
            } else {
              delete value[symToStringTag];
            }
          }
          return result2;
        }
        var getSymbols = !nativeGetSymbols ? stubArray : function(object23) {
          if (object23 == null) {
            return [];
          }
          object23 = Object2(object23);
          return arrayFilter(nativeGetSymbols(object23), function(symbol) {
            return propertyIsEnumerable.call(object23, symbol);
          });
        };
        var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object23) {
          var result2 = [];
          while (object23) {
            arrayPush(result2, getSymbols(object23));
            object23 = getPrototype(object23);
          }
          return result2;
        };
        var getTag = baseGetTag;
        if (DataView2 && getTag(new DataView2(new ArrayBuffer(1))) != dataViewTag || Map2 && getTag(new Map2()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set2 && getTag(new Set2()) != setTag || WeakMap2 && getTag(new WeakMap2()) != weakMapTag) {
          getTag = function(value) {
            var result2 = baseGetTag(value), Ctor = result2 == objectTag ? value.constructor : undefined2, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) {
              switch (ctorString) {
                case dataViewCtorString:
                  return dataViewTag;
                case mapCtorString:
                  return mapTag;
                case promiseCtorString:
                  return promiseTag;
                case setCtorString:
                  return setTag;
                case weakMapCtorString:
                  return weakMapTag;
              }
            }
            return result2;
          };
        }
        function getView(start, end, transforms) {
          var index2 = -1, length = transforms.length;
          while (++index2 < length) {
            var data = transforms[index2], size2 = data.size;
            switch (data.type) {
              case "drop":
                start += size2;
                break;
              case "dropRight":
                end -= size2;
                break;
              case "take":
                end = nativeMin(end, start + size2);
                break;
              case "takeRight":
                start = nativeMax(start, end - size2);
                break;
            }
          }
          return { "start": start, "end": end };
        }
        function getWrapDetails(source) {
          var match = source.match(reWrapDetails);
          return match ? match[1].split(reSplitDetails) : [];
        }
        function hasPath(object23, path, hasFunc) {
          path = castPath(path, object23);
          var index2 = -1, length = path.length, result2 = false;
          while (++index2 < length) {
            var key = toKey(path[index2]);
            if (!(result2 = object23 != null && hasFunc(object23, key))) {
              break;
            }
            object23 = object23[key];
          }
          if (result2 || ++index2 != length) {
            return result2;
          }
          length = object23 == null ? 0 : object23.length;
          return !!length && isLength(length) && isIndex(key, length) && (isArray(object23) || isArguments(object23));
        }
        function initCloneArray(array2) {
          var length = array2.length, result2 = new array2.constructor(length);
          if (length && typeof array2[0] == "string" && hasOwnProperty.call(array2, "index")) {
            result2.index = array2.index;
            result2.input = array2.input;
          }
          return result2;
        }
        function initCloneObject(object23) {
          return typeof object23.constructor == "function" && !isPrototype(object23) ? baseCreate(getPrototype(object23)) : {};
        }
        function initCloneByTag(object23, tag, isDeep) {
          var Ctor = object23.constructor;
          switch (tag) {
            case arrayBufferTag:
              return cloneArrayBuffer(object23);
            case boolTag:
            case dateTag:
              return new Ctor(+object23);
            case dataViewTag:
              return cloneDataView(object23, isDeep);
            case float32Tag:
            case float64Tag:
            case int8Tag:
            case int16Tag:
            case int32Tag:
            case uint8Tag:
            case uint8ClampedTag:
            case uint16Tag:
            case uint32Tag:
              return cloneTypedArray(object23, isDeep);
            case mapTag:
              return new Ctor();
            case numberTag:
            case stringTag:
              return new Ctor(object23);
            case regexpTag:
              return cloneRegExp(object23);
            case setTag:
              return new Ctor();
            case symbolTag:
              return cloneSymbol(object23);
          }
        }
        function insertWrapDetails(source, details) {
          var length = details.length;
          if (!length) {
            return source;
          }
          var lastIndex = length - 1;
          details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
          details = details.join(length > 2 ? ", " : " ");
          return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        function isFlattenable(value) {
          return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        function isIndex(value, length) {
          var type = typeof value;
          length = length == null ? MAX_SAFE_INTEGER : length;
          return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
        }
        function isIterateeCall(value, index2, object23) {
          if (!isObject(object23)) {
            return false;
          }
          var type = typeof index2;
          if (type == "number" ? isArrayLike(object23) && isIndex(index2, object23.length) : type == "string" && index2 in object23) {
            return eq(object23[index2], value);
          }
          return false;
        }
        function isKey(value, object23) {
          if (isArray(value)) {
            return false;
          }
          var type = typeof value;
          if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) {
            return true;
          }
          return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object23 != null && value in Object2(object23);
        }
        function isKeyable(value) {
          var type = typeof value;
          return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        function isLaziable(func) {
          var funcName = getFuncName(func), other = lodash[funcName];
          if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) {
            return false;
          }
          if (func === other) {
            return true;
          }
          var data = getData(other);
          return !!data && func === data[0];
        }
        function isMasked(func) {
          return !!maskSrcKey && maskSrcKey in func;
        }
        var isMaskable = coreJsData ? isFunction : stubFalse;
        function isPrototype(value) {
          var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
          return value === proto;
        }
        function isStrictComparable(value) {
          return value === value && !isObject(value);
        }
        function matchesStrictComparable(key, srcValue) {
          return function(object23) {
            if (object23 == null) {
              return false;
            }
            return object23[key] === srcValue && (srcValue !== undefined2 || key in Object2(object23));
          };
        }
        function memoizeCapped(func) {
          var result2 = memoize3(func, function(key) {
            if (cache.size === MAX_MEMOIZE_SIZE) {
              cache.clear();
            }
            return key;
          });
          var cache = result2.cache;
          return result2;
        }
        function mergeData(data, source) {
          var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
          var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
          if (!(isCommon || isCombo)) {
            return data;
          }
          if (srcBitmask & WRAP_BIND_FLAG) {
            data[2] = source[2];
            newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
          }
          var value = source[3];
          if (value) {
            var partials = data[3];
            data[3] = partials ? composeArgs(partials, value, source[4]) : value;
            data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
          }
          value = source[5];
          if (value) {
            partials = data[5];
            data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
            data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
          }
          value = source[7];
          if (value) {
            data[7] = value;
          }
          if (srcBitmask & WRAP_ARY_FLAG) {
            data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
          }
          if (data[9] == null) {
            data[9] = source[9];
          }
          data[0] = source[0];
          data[1] = newBitmask;
          return data;
        }
        function nativeKeysIn(object23) {
          var result2 = [];
          if (object23 != null) {
            for (var key in Object2(object23)) {
              result2.push(key);
            }
          }
          return result2;
        }
        function objectToString3(value) {
          return nativeObjectToString.call(value);
        }
        function overRest(func, start, transform2) {
          start = nativeMax(start === undefined2 ? func.length - 1 : start, 0);
          return function() {
            var args = arguments, index2 = -1, length = nativeMax(args.length - start, 0), array2 = Array2(length);
            while (++index2 < length) {
              array2[index2] = args[start + index2];
            }
            index2 = -1;
            var otherArgs = Array2(start + 1);
            while (++index2 < start) {
              otherArgs[index2] = args[index2];
            }
            otherArgs[start] = transform2(array2);
            return apply(func, this, otherArgs);
          };
        }
        function parent(object23, path) {
          return path.length < 2 ? object23 : baseGet(object23, baseSlice(path, 0, -1));
        }
        function reorder(array2, indexes) {
          var arrLength = array2.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array2);
          while (length--) {
            var index2 = indexes[length];
            array2[length] = isIndex(index2, arrLength) ? oldArray[index2] : undefined2;
          }
          return array2;
        }
        function safeGet(object23, key) {
          if (key === "constructor" && typeof object23[key] === "function") {
            return;
          }
          if (key == "__proto__") {
            return;
          }
          return object23[key];
        }
        var setData = shortOut(baseSetData);
        var setTimeout2 = ctxSetTimeout || function(func, wait) {
          return root.setTimeout(func, wait);
        };
        var setToString = shortOut(baseSetToString);
        function setWrapToString(wrapper, reference, bitmask) {
          var source = reference + "";
          return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        function shortOut(func) {
          var count = 0, lastCalled = 0;
          return function() {
            var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
            lastCalled = stamp;
            if (remaining > 0) {
              if (++count >= HOT_COUNT) {
                return arguments[0];
              }
            } else {
              count = 0;
            }
            return func.apply(undefined2, arguments);
          };
        }
        function shuffleSelf(array2, size2) {
          var index2 = -1, length = array2.length, lastIndex = length - 1;
          size2 = size2 === undefined2 ? length : size2;
          while (++index2 < size2) {
            var rand = baseRandom(index2, lastIndex), value = array2[rand];
            array2[rand] = array2[index2];
            array2[index2] = value;
          }
          array2.length = size2;
          return array2;
        }
        var stringToPath = memoizeCapped(function(string21) {
          var result2 = [];
          if (string21.charCodeAt(0) === 46) {
            result2.push("");
          }
          string21.replace(rePropName, function(match, number3, quote, subString) {
            result2.push(quote ? subString.replace(reEscapeChar, "$1") : number3 || match);
          });
          return result2;
        });
        function toKey(value) {
          if (typeof value == "string" || isSymbol(value)) {
            return value;
          }
          var result2 = value + "";
          return result2 == "0" && 1 / value == -INFINITY ? "-0" : result2;
        }
        function toSource(func) {
          if (func != null) {
            try {
              return funcToString.call(func);
            } catch (e4) {
            }
            try {
              return func + "";
            } catch (e4) {
            }
          }
          return "";
        }
        function updateWrapDetails(details, bitmask) {
          arrayEach(wrapFlags, function(pair) {
            var value = "_." + pair[0];
            if (bitmask & pair[1] && !arrayIncludes(details, value)) {
              details.push(value);
            }
          });
          return details.sort();
        }
        function wrapperClone(wrapper) {
          if (wrapper instanceof LazyWrapper) {
            return wrapper.clone();
          }
          var result2 = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
          result2.__actions__ = copyArray(wrapper.__actions__);
          result2.__index__ = wrapper.__index__;
          result2.__values__ = wrapper.__values__;
          return result2;
        }
        function chunk(array2, size2, guard) {
          if (guard ? isIterateeCall(array2, size2, guard) : size2 === undefined2) {
            size2 = 1;
          } else {
            size2 = nativeMax(toInteger(size2), 0);
          }
          var length = array2 == null ? 0 : array2.length;
          if (!length || size2 < 1) {
            return [];
          }
          var index2 = 0, resIndex = 0, result2 = Array2(nativeCeil(length / size2));
          while (index2 < length) {
            result2[resIndex++] = baseSlice(array2, index2, index2 += size2);
          }
          return result2;
        }
        function compact(array2) {
          var index2 = -1, length = array2 == null ? 0 : array2.length, resIndex = 0, result2 = [];
          while (++index2 < length) {
            var value = array2[index2];
            if (value) {
              result2[resIndex++] = value;
            }
          }
          return result2;
        }
        function concat() {
          var length = arguments.length;
          if (!length) {
            return [];
          }
          var args = Array2(length - 1), array2 = arguments[0], index2 = length;
          while (index2--) {
            args[index2 - 1] = arguments[index2];
          }
          return arrayPush(isArray(array2) ? copyArray(array2) : [array2], baseFlatten(args, 1));
        }
        var difference = baseRest(function(array2, values2) {
          return isArrayLikeObject(array2) ? baseDifference(array2, baseFlatten(values2, 1, isArrayLikeObject, true)) : [];
        });
        var differenceBy = baseRest(function(array2, values2) {
          var iteratee2 = last(values2);
          if (isArrayLikeObject(iteratee2)) {
            iteratee2 = undefined2;
          }
          return isArrayLikeObject(array2) ? baseDifference(array2, baseFlatten(values2, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2)) : [];
        });
        var differenceWith = baseRest(function(array2, values2) {
          var comparator = last(values2);
          if (isArrayLikeObject(comparator)) {
            comparator = undefined2;
          }
          return isArrayLikeObject(array2) ? baseDifference(array2, baseFlatten(values2, 1, isArrayLikeObject, true), undefined2, comparator) : [];
        });
        function drop(array2, n3, guard) {
          var length = array2 == null ? 0 : array2.length;
          if (!length) {
            return [];
          }
          n3 = guard || n3 === undefined2 ? 1 : toInteger(n3);
          return baseSlice(array2, n3 < 0 ? 0 : n3, length);
        }
        function dropRight(array2, n3, guard) {
          var length = array2 == null ? 0 : array2.length;
          if (!length) {
            return [];
          }
          n3 = guard || n3 === undefined2 ? 1 : toInteger(n3);
          n3 = length - n3;
          return baseSlice(array2, 0, n3 < 0 ? 0 : n3);
        }
        function dropRightWhile(array2, predicate) {
          return array2 && array2.length ? baseWhile(array2, getIteratee(predicate, 3), true, true) : [];
        }
        function dropWhile(array2, predicate) {
          return array2 && array2.length ? baseWhile(array2, getIteratee(predicate, 3), true) : [];
        }
        function fill(array2, value, start, end) {
          var length = array2 == null ? 0 : array2.length;
          if (!length) {
            return [];
          }
          if (start && typeof start != "number" && isIterateeCall(array2, value, start)) {
            start = 0;
            end = length;
          }
          return baseFill(array2, value, start, end);
        }
        function findIndex(array2, predicate, fromIndex) {
          var length = array2 == null ? 0 : array2.length;
          if (!length) {
            return -1;
          }
          var index2 = fromIndex == null ? 0 : toInteger(fromIndex);
          if (index2 < 0) {
            index2 = nativeMax(length + index2, 0);
          }
          return baseFindIndex(array2, getIteratee(predicate, 3), index2);
        }
        function findLastIndex(array2, predicate, fromIndex) {
          var length = array2 == null ? 0 : array2.length;
          if (!length) {
            return -1;
          }
          var index2 = length - 1;
          if (fromIndex !== undefined2) {
            index2 = toInteger(fromIndex);
            index2 = fromIndex < 0 ? nativeMax(length + index2, 0) : nativeMin(index2, length - 1);
          }
          return baseFindIndex(array2, getIteratee(predicate, 3), index2, true);
        }
        function flatten(array2) {
          var length = array2 == null ? 0 : array2.length;
          return length ? baseFlatten(array2, 1) : [];
        }
        function flattenDeep(array2) {
          var length = array2 == null ? 0 : array2.length;
          return length ? baseFlatten(array2, INFINITY) : [];
        }
        function flattenDepth(array2, depth) {
          var length = array2 == null ? 0 : array2.length;
          if (!length) {
            return [];
          }
          depth = depth === undefined2 ? 1 : toInteger(depth);
          return baseFlatten(array2, depth);
        }
        function fromPairs(pairs) {
          var index2 = -1, length = pairs == null ? 0 : pairs.length, result2 = {};
          while (++index2 < length) {
            var pair = pairs[index2];
            result2[pair[0]] = pair[1];
          }
          return result2;
        }
        function head(array2) {
          return array2 && array2.length ? array2[0] : undefined2;
        }
        function indexOf(array2, value, fromIndex) {
          var length = array2 == null ? 0 : array2.length;
          if (!length) {
            return -1;
          }
          var index2 = fromIndex == null ? 0 : toInteger(fromIndex);
          if (index2 < 0) {
            index2 = nativeMax(length + index2, 0);
          }
          return baseIndexOf(array2, value, index2);
        }
        function initial(array2) {
          var length = array2 == null ? 0 : array2.length;
          return length ? baseSlice(array2, 0, -1) : [];
        }
        var intersection = baseRest(function(arrays) {
          var mapped = arrayMap(arrays, castArrayLikeObject);
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        var intersectionBy = baseRest(function(arrays) {
          var iteratee2 = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
          if (iteratee2 === last(mapped)) {
            iteratee2 = undefined2;
          } else {
            mapped.pop();
          }
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee2, 2)) : [];
        });
        var intersectionWith = baseRest(function(arrays) {
          var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
          comparator = typeof comparator == "function" ? comparator : undefined2;
          if (comparator) {
            mapped.pop();
          }
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined2, comparator) : [];
        });
        function join(array2, separator2) {
          return array2 == null ? "" : nativeJoin.call(array2, separator2);
        }
        function last(array2) {
          var length = array2 == null ? 0 : array2.length;
          return length ? array2[length - 1] : undefined2;
        }
        function lastIndexOf(array2, value, fromIndex) {
          var length = array2 == null ? 0 : array2.length;
          if (!length) {
            return -1;
          }
          var index2 = length;
          if (fromIndex !== undefined2) {
            index2 = toInteger(fromIndex);
            index2 = index2 < 0 ? nativeMax(length + index2, 0) : nativeMin(index2, length - 1);
          }
          return value === value ? strictLastIndexOf(array2, value, index2) : baseFindIndex(array2, baseIsNaN, index2, true);
        }
        function nth(array2, n3) {
          return array2 && array2.length ? baseNth(array2, toInteger(n3)) : undefined2;
        }
        var pull = baseRest(pullAll);
        function pullAll(array2, values2) {
          return array2 && array2.length && values2 && values2.length ? basePullAll(array2, values2) : array2;
        }
        function pullAllBy(array2, values2, iteratee2) {
          return array2 && array2.length && values2 && values2.length ? basePullAll(array2, values2, getIteratee(iteratee2, 2)) : array2;
        }
        function pullAllWith(array2, values2, comparator) {
          return array2 && array2.length && values2 && values2.length ? basePullAll(array2, values2, undefined2, comparator) : array2;
        }
        var pullAt = flatRest(function(array2, indexes) {
          var length = array2 == null ? 0 : array2.length, result2 = baseAt(array2, indexes);
          basePullAt(array2, arrayMap(indexes, function(index2) {
            return isIndex(index2, length) ? +index2 : index2;
          }).sort(compareAscending));
          return result2;
        });
        function remove(array2, predicate) {
          var result2 = [];
          if (!(array2 && array2.length)) {
            return result2;
          }
          var index2 = -1, indexes = [], length = array2.length;
          predicate = getIteratee(predicate, 3);
          while (++index2 < length) {
            var value = array2[index2];
            if (predicate(value, index2, array2)) {
              result2.push(value);
              indexes.push(index2);
            }
          }
          basePullAt(array2, indexes);
          return result2;
        }
        function reverse(array2) {
          return array2 == null ? array2 : nativeReverse.call(array2);
        }
        function slice(array2, start, end) {
          var length = array2 == null ? 0 : array2.length;
          if (!length) {
            return [];
          }
          if (end && typeof end != "number" && isIterateeCall(array2, start, end)) {
            start = 0;
            end = length;
          } else {
            start = start == null ? 0 : toInteger(start);
            end = end === undefined2 ? length : toInteger(end);
          }
          return baseSlice(array2, start, end);
        }
        function sortedIndex(array2, value) {
          return baseSortedIndex(array2, value);
        }
        function sortedIndexBy(array2, value, iteratee2) {
          return baseSortedIndexBy(array2, value, getIteratee(iteratee2, 2));
        }
        function sortedIndexOf(array2, value) {
          var length = array2 == null ? 0 : array2.length;
          if (length) {
            var index2 = baseSortedIndex(array2, value);
            if (index2 < length && eq(array2[index2], value)) {
              return index2;
            }
          }
          return -1;
        }
        function sortedLastIndex(array2, value) {
          return baseSortedIndex(array2, value, true);
        }
        function sortedLastIndexBy(array2, value, iteratee2) {
          return baseSortedIndexBy(array2, value, getIteratee(iteratee2, 2), true);
        }
        function sortedLastIndexOf(array2, value) {
          var length = array2 == null ? 0 : array2.length;
          if (length) {
            var index2 = baseSortedIndex(array2, value, true) - 1;
            if (eq(array2[index2], value)) {
              return index2;
            }
          }
          return -1;
        }
        function sortedUniq(array2) {
          return array2 && array2.length ? baseSortedUniq(array2) : [];
        }
        function sortedUniqBy(array2, iteratee2) {
          return array2 && array2.length ? baseSortedUniq(array2, getIteratee(iteratee2, 2)) : [];
        }
        function tail(array2) {
          var length = array2 == null ? 0 : array2.length;
          return length ? baseSlice(array2, 1, length) : [];
        }
        function take(array2, n3, guard) {
          if (!(array2 && array2.length)) {
            return [];
          }
          n3 = guard || n3 === undefined2 ? 1 : toInteger(n3);
          return baseSlice(array2, 0, n3 < 0 ? 0 : n3);
        }
        function takeRight(array2, n3, guard) {
          var length = array2 == null ? 0 : array2.length;
          if (!length) {
            return [];
          }
          n3 = guard || n3 === undefined2 ? 1 : toInteger(n3);
          n3 = length - n3;
          return baseSlice(array2, n3 < 0 ? 0 : n3, length);
        }
        function takeRightWhile(array2, predicate) {
          return array2 && array2.length ? baseWhile(array2, getIteratee(predicate, 3), false, true) : [];
        }
        function takeWhile(array2, predicate) {
          return array2 && array2.length ? baseWhile(array2, getIteratee(predicate, 3)) : [];
        }
        var union = baseRest(function(arrays) {
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        var unionBy = baseRest(function(arrays) {
          var iteratee2 = last(arrays);
          if (isArrayLikeObject(iteratee2)) {
            iteratee2 = undefined2;
          }
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2));
        });
        var unionWith = baseRest(function(arrays) {
          var comparator = last(arrays);
          comparator = typeof comparator == "function" ? comparator : undefined2;
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined2, comparator);
        });
        function uniq(array2) {
          return array2 && array2.length ? baseUniq(array2) : [];
        }
        function uniqBy(array2, iteratee2) {
          return array2 && array2.length ? baseUniq(array2, getIteratee(iteratee2, 2)) : [];
        }
        function uniqWith(array2, comparator) {
          comparator = typeof comparator == "function" ? comparator : undefined2;
          return array2 && array2.length ? baseUniq(array2, undefined2, comparator) : [];
        }
        function unzip(array2) {
          if (!(array2 && array2.length)) {
            return [];
          }
          var length = 0;
          array2 = arrayFilter(array2, function(group) {
            if (isArrayLikeObject(group)) {
              length = nativeMax(group.length, length);
              return true;
            }
          });
          return baseTimes(length, function(index2) {
            return arrayMap(array2, baseProperty(index2));
          });
        }
        function unzipWith(array2, iteratee2) {
          if (!(array2 && array2.length)) {
            return [];
          }
          var result2 = unzip(array2);
          if (iteratee2 == null) {
            return result2;
          }
          return arrayMap(result2, function(group) {
            return apply(iteratee2, undefined2, group);
          });
        }
        var without = baseRest(function(array2, values2) {
          return isArrayLikeObject(array2) ? baseDifference(array2, values2) : [];
        });
        var xor = baseRest(function(arrays) {
          return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        var xorBy = baseRest(function(arrays) {
          var iteratee2 = last(arrays);
          if (isArrayLikeObject(iteratee2)) {
            iteratee2 = undefined2;
          }
          return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee2, 2));
        });
        var xorWith = baseRest(function(arrays) {
          var comparator = last(arrays);
          comparator = typeof comparator == "function" ? comparator : undefined2;
          return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined2, comparator);
        });
        var zip = baseRest(unzip);
        function zipObject(props, values2) {
          return baseZipObject(props || [], values2 || [], assignValue);
        }
        function zipObjectDeep(props, values2) {
          return baseZipObject(props || [], values2 || [], baseSet);
        }
        var zipWith = baseRest(function(arrays) {
          var length = arrays.length, iteratee2 = length > 1 ? arrays[length - 1] : undefined2;
          iteratee2 = typeof iteratee2 == "function" ? (arrays.pop(), iteratee2) : undefined2;
          return unzipWith(arrays, iteratee2);
        });
        function chain(value) {
          var result2 = lodash(value);
          result2.__chain__ = true;
          return result2;
        }
        function tap(value, interceptor) {
          interceptor(value);
          return value;
        }
        function thru(value, interceptor) {
          return interceptor(value);
        }
        var wrapperAt = flatRest(function(paths) {
          var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object23) {
            return baseAt(object23, paths);
          };
          if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) {
            return this.thru(interceptor);
          }
          value = value.slice(start, +start + (length ? 1 : 0));
          value.__actions__.push({
            "func": thru,
            "args": [interceptor],
            "thisArg": undefined2
          });
          return new LodashWrapper(value, this.__chain__).thru(function(array2) {
            if (length && !array2.length) {
              array2.push(undefined2);
            }
            return array2;
          });
        });
        function wrapperChain() {
          return chain(this);
        }
        function wrapperCommit() {
          return new LodashWrapper(this.value(), this.__chain__);
        }
        function wrapperNext() {
          if (this.__values__ === undefined2) {
            this.__values__ = toArray(this.value());
          }
          var done = this.__index__ >= this.__values__.length, value = done ? undefined2 : this.__values__[this.__index__++];
          return { "done": done, "value": value };
        }
        function wrapperToIterator() {
          return this;
        }
        function wrapperPlant(value) {
          var result2, parent2 = this;
          while (parent2 instanceof baseLodash) {
            var clone2 = wrapperClone(parent2);
            clone2.__index__ = 0;
            clone2.__values__ = undefined2;
            if (result2) {
              previous.__wrapped__ = clone2;
            } else {
              result2 = clone2;
            }
            var previous = clone2;
            parent2 = parent2.__wrapped__;
          }
          previous.__wrapped__ = value;
          return result2;
        }
        function wrapperReverse() {
          var value = this.__wrapped__;
          if (value instanceof LazyWrapper) {
            var wrapped = value;
            if (this.__actions__.length) {
              wrapped = new LazyWrapper(this);
            }
            wrapped = wrapped.reverse();
            wrapped.__actions__.push({
              "func": thru,
              "args": [reverse],
              "thisArg": undefined2
            });
            return new LodashWrapper(wrapped, this.__chain__);
          }
          return this.thru(reverse);
        }
        function wrapperValue() {
          return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        var countBy = createAggregator(function(result2, value, key) {
          if (hasOwnProperty.call(result2, key)) {
            ++result2[key];
          } else {
            baseAssignValue(result2, key, 1);
          }
        });
        function every(collection, predicate, guard) {
          var func = isArray(collection) ? arrayEvery : baseEvery;
          if (guard && isIterateeCall(collection, predicate, guard)) {
            predicate = undefined2;
          }
          return func(collection, getIteratee(predicate, 3));
        }
        function filter2(collection, predicate) {
          var func = isArray(collection) ? arrayFilter : baseFilter;
          return func(collection, getIteratee(predicate, 3));
        }
        var find = createFind(findIndex);
        var findLast = createFind(findLastIndex);
        function flatMap(collection, iteratee2) {
          return baseFlatten(map(collection, iteratee2), 1);
        }
        function flatMapDeep(collection, iteratee2) {
          return baseFlatten(map(collection, iteratee2), INFINITY);
        }
        function flatMapDepth(collection, iteratee2, depth) {
          depth = depth === undefined2 ? 1 : toInteger(depth);
          return baseFlatten(map(collection, iteratee2), depth);
        }
        function forEach(collection, iteratee2) {
          var func = isArray(collection) ? arrayEach : baseEach;
          return func(collection, getIteratee(iteratee2, 3));
        }
        function forEachRight(collection, iteratee2) {
          var func = isArray(collection) ? arrayEachRight : baseEachRight;
          return func(collection, getIteratee(iteratee2, 3));
        }
        var groupBy3 = createAggregator(function(result2, value, key) {
          if (hasOwnProperty.call(result2, key)) {
            result2[key].push(value);
          } else {
            baseAssignValue(result2, key, [value]);
          }
        });
        function includes(collection, value, fromIndex, guard) {
          collection = isArrayLike(collection) ? collection : values(collection);
          fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
          var length = collection.length;
          if (fromIndex < 0) {
            fromIndex = nativeMax(length + fromIndex, 0);
          }
          return isString5(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        var invokeMap = baseRest(function(collection, path, args) {
          var index2 = -1, isFunc = typeof path == "function", result2 = isArrayLike(collection) ? Array2(collection.length) : [];
          baseEach(collection, function(value) {
            result2[++index2] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
          });
          return result2;
        });
        var keyBy = createAggregator(function(result2, value, key) {
          baseAssignValue(result2, key, value);
        });
        function map(collection, iteratee2) {
          var func = isArray(collection) ? arrayMap : baseMap;
          return func(collection, getIteratee(iteratee2, 3));
        }
        function orderBy(collection, iteratees, orders, guard) {
          if (collection == null) {
            return [];
          }
          if (!isArray(iteratees)) {
            iteratees = iteratees == null ? [] : [iteratees];
          }
          orders = guard ? undefined2 : orders;
          if (!isArray(orders)) {
            orders = orders == null ? [] : [orders];
          }
          return baseOrderBy(collection, iteratees, orders);
        }
        var partition = createAggregator(function(result2, value, key) {
          result2[key ? 0 : 1].push(value);
        }, function() {
          return [[], []];
        });
        function reduce(collection, iteratee2, accumulator) {
          var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
          return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEach);
        }
        function reduceRight(collection, iteratee2, accumulator) {
          var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
          return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEachRight);
        }
        function reject(collection, predicate) {
          var func = isArray(collection) ? arrayFilter : baseFilter;
          return func(collection, negate(getIteratee(predicate, 3)));
        }
        function sample(collection) {
          var func = isArray(collection) ? arraySample : baseSample;
          return func(collection);
        }
        function sampleSize(collection, n3, guard) {
          if (guard ? isIterateeCall(collection, n3, guard) : n3 === undefined2) {
            n3 = 1;
          } else {
            n3 = toInteger(n3);
          }
          var func = isArray(collection) ? arraySampleSize : baseSampleSize;
          return func(collection, n3);
        }
        function shuffle(collection) {
          var func = isArray(collection) ? arrayShuffle : baseShuffle;
          return func(collection);
        }
        function size(collection) {
          if (collection == null) {
            return 0;
          }
          if (isArrayLike(collection)) {
            return isString5(collection) ? stringSize(collection) : collection.length;
          }
          var tag = getTag(collection);
          if (tag == mapTag || tag == setTag) {
            return collection.size;
          }
          return baseKeys(collection).length;
        }
        function some(collection, predicate, guard) {
          var func = isArray(collection) ? arraySome : baseSome;
          if (guard && isIterateeCall(collection, predicate, guard)) {
            predicate = undefined2;
          }
          return func(collection, getIteratee(predicate, 3));
        }
        var sortBy = baseRest(function(collection, iteratees) {
          if (collection == null) {
            return [];
          }
          var length = iteratees.length;
          if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
            iteratees = [];
          } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
            iteratees = [iteratees[0]];
          }
          return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        var now2 = ctxNow || function() {
          return root.Date.now();
        };
        function after(n3, func) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          n3 = toInteger(n3);
          return function() {
            if (--n3 < 1) {
              return func.apply(this, arguments);
            }
          };
        }
        function ary(func, n3, guard) {
          n3 = guard ? undefined2 : n3;
          n3 = func && n3 == null ? func.length : n3;
          return createWrap(func, WRAP_ARY_FLAG, undefined2, undefined2, undefined2, undefined2, n3);
        }
        function before(n3, func) {
          var result2;
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          n3 = toInteger(n3);
          return function() {
            if (--n3 > 0) {
              result2 = func.apply(this, arguments);
            }
            if (n3 <= 1) {
              func = undefined2;
            }
            return result2;
          };
        }
        var bind = baseRest(function(func, thisArg, partials) {
          var bitmask = WRAP_BIND_FLAG;
          if (partials.length) {
            var holders = replaceHolders(partials, getHolder(bind));
            bitmask |= WRAP_PARTIAL_FLAG;
          }
          return createWrap(func, bitmask, thisArg, partials, holders);
        });
        var bindKey = baseRest(function(object23, key, partials) {
          var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
          if (partials.length) {
            var holders = replaceHolders(partials, getHolder(bindKey));
            bitmask |= WRAP_PARTIAL_FLAG;
          }
          return createWrap(key, bitmask, object23, partials, holders);
        });
        function curry(func, arity, guard) {
          arity = guard ? undefined2 : arity;
          var result2 = createWrap(func, WRAP_CURRY_FLAG, undefined2, undefined2, undefined2, undefined2, undefined2, arity);
          result2.placeholder = curry.placeholder;
          return result2;
        }
        function curryRight(func, arity, guard) {
          arity = guard ? undefined2 : arity;
          var result2 = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined2, undefined2, undefined2, undefined2, undefined2, arity);
          result2.placeholder = curryRight.placeholder;
          return result2;
        }
        function debounce13(func, wait, options7) {
          var lastArgs, lastThis, maxWait, result2, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          wait = toNumber(wait) || 0;
          if (isObject(options7)) {
            leading = !!options7.leading;
            maxing = "maxWait" in options7;
            maxWait = maxing ? nativeMax(toNumber(options7.maxWait) || 0, wait) : maxWait;
            trailing = "trailing" in options7 ? !!options7.trailing : trailing;
          }
          function invokeFunc(time) {
            var args = lastArgs, thisArg = lastThis;
            lastArgs = lastThis = undefined2;
            lastInvokeTime = time;
            result2 = func.apply(thisArg, args);
            return result2;
          }
          function leadingEdge(time) {
            lastInvokeTime = time;
            timerId = setTimeout2(timerExpired, wait);
            return leading ? invokeFunc(time) : result2;
          }
          function remainingWait(time) {
            var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
            return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
          }
          function shouldInvoke(time) {
            var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
            return lastCallTime === undefined2 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
          }
          function timerExpired() {
            var time = now2();
            if (shouldInvoke(time)) {
              return trailingEdge(time);
            }
            timerId = setTimeout2(timerExpired, remainingWait(time));
          }
          function trailingEdge(time) {
            timerId = undefined2;
            if (trailing && lastArgs) {
              return invokeFunc(time);
            }
            lastArgs = lastThis = undefined2;
            return result2;
          }
          function cancel() {
            if (timerId !== undefined2) {
              clearTimeout2(timerId);
            }
            lastInvokeTime = 0;
            lastArgs = lastCallTime = lastThis = timerId = undefined2;
          }
          function flush() {
            return timerId === undefined2 ? result2 : trailingEdge(now2());
          }
          function debounced() {
            var time = now2(), isInvoking = shouldInvoke(time);
            lastArgs = arguments;
            lastThis = this;
            lastCallTime = time;
            if (isInvoking) {
              if (timerId === undefined2) {
                return leadingEdge(lastCallTime);
              }
              if (maxing) {
                clearTimeout2(timerId);
                timerId = setTimeout2(timerExpired, wait);
                return invokeFunc(lastCallTime);
              }
            }
            if (timerId === undefined2) {
              timerId = setTimeout2(timerExpired, wait);
            }
            return result2;
          }
          debounced.cancel = cancel;
          debounced.flush = flush;
          return debounced;
        }
        var defer = baseRest(function(func, args) {
          return baseDelay(func, 1, args);
        });
        var delay2 = baseRest(function(func, wait, args) {
          return baseDelay(func, toNumber(wait) || 0, args);
        });
        function flip(func) {
          return createWrap(func, WRAP_FLIP_FLAG);
        }
        function memoize3(func, resolver) {
          if (typeof func != "function" || resolver != null && typeof resolver != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          var memoized = function() {
            var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
            if (cache.has(key)) {
              return cache.get(key);
            }
            var result2 = func.apply(this, args);
            memoized.cache = cache.set(key, result2) || cache;
            return result2;
          };
          memoized.cache = new (memoize3.Cache || MapCache)();
          return memoized;
        }
        memoize3.Cache = MapCache;
        function negate(predicate) {
          if (typeof predicate != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          return function() {
            var args = arguments;
            switch (args.length) {
              case 0:
                return !predicate.call(this);
              case 1:
                return !predicate.call(this, args[0]);
              case 2:
                return !predicate.call(this, args[0], args[1]);
              case 3:
                return !predicate.call(this, args[0], args[1], args[2]);
            }
            return !predicate.apply(this, args);
          };
        }
        function once(func) {
          return before(2, func);
        }
        var overArgs = castRest(function(func, transforms) {
          transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
          var funcsLength = transforms.length;
          return baseRest(function(args) {
            var index2 = -1, length = nativeMin(args.length, funcsLength);
            while (++index2 < length) {
              args[index2] = transforms[index2].call(this, args[index2]);
            }
            return apply(func, this, args);
          });
        });
        var partial = baseRest(function(func, partials) {
          var holders = replaceHolders(partials, getHolder(partial));
          return createWrap(func, WRAP_PARTIAL_FLAG, undefined2, partials, holders);
        });
        var partialRight = baseRest(function(func, partials) {
          var holders = replaceHolders(partials, getHolder(partialRight));
          return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined2, partials, holders);
        });
        var rearg = flatRest(function(func, indexes) {
          return createWrap(func, WRAP_REARG_FLAG, undefined2, undefined2, undefined2, indexes);
        });
        function rest(func, start) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          start = start === undefined2 ? start : toInteger(start);
          return baseRest(func, start);
        }
        function spread(func, start) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          start = start == null ? 0 : nativeMax(toInteger(start), 0);
          return baseRest(function(args) {
            var array2 = args[start], otherArgs = castSlice(args, 0, start);
            if (array2) {
              arrayPush(otherArgs, array2);
            }
            return apply(func, this, otherArgs);
          });
        }
        function throttle2(func, wait, options7) {
          var leading = true, trailing = true;
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          if (isObject(options7)) {
            leading = "leading" in options7 ? !!options7.leading : leading;
            trailing = "trailing" in options7 ? !!options7.trailing : trailing;
          }
          return debounce13(func, wait, {
            "leading": leading,
            "maxWait": wait,
            "trailing": trailing
          });
        }
        function unary(func) {
          return ary(func, 1);
        }
        function wrap(value, wrapper) {
          return partial(castFunction(wrapper), value);
        }
        function castArray() {
          if (!arguments.length) {
            return [];
          }
          var value = arguments[0];
          return isArray(value) ? value : [value];
        }
        function clone(value) {
          return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        function cloneWith(value, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        function cloneDeep(value) {
          return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        function cloneDeepWith(value, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        function conformsTo(object23, source) {
          return source == null || baseConformsTo(object23, source, keys(source));
        }
        function eq(value, other) {
          return value === other || value !== value && other !== other;
        }
        var gt = createRelationalOperation(baseGt);
        var gte = createRelationalOperation(function(value, other) {
          return value >= other;
        });
        var isArguments = baseIsArguments(function() {
          return arguments;
        }()) ? baseIsArguments : function(value) {
          return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        var isArray = Array2.isArray;
        var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        function isArrayLike(value) {
          return value != null && isLength(value.length) && !isFunction(value);
        }
        function isArrayLikeObject(value) {
          return isObjectLike(value) && isArrayLike(value);
        }
        function isBoolean(value) {
          return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        var isBuffer = nativeIsBuffer || stubFalse;
        var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        function isElement(value) {
          return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        function isEmpty(value) {
          if (value == null) {
            return true;
          }
          if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) {
            return !value.length;
          }
          var tag = getTag(value);
          if (tag == mapTag || tag == setTag) {
            return !value.size;
          }
          if (isPrototype(value)) {
            return !baseKeys(value).length;
          }
          for (var key in value) {
            if (hasOwnProperty.call(value, key)) {
              return false;
            }
          }
          return true;
        }
        function isEqual3(value, other) {
          return baseIsEqual(value, other);
        }
        function isEqualWith(value, other, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          var result2 = customizer ? customizer(value, other) : undefined2;
          return result2 === undefined2 ? baseIsEqual(value, other, undefined2, customizer) : !!result2;
        }
        function isError3(value) {
          if (!isObjectLike(value)) {
            return false;
          }
          var tag = baseGetTag(value);
          return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        function isFinite(value) {
          return typeof value == "number" && nativeIsFinite(value);
        }
        function isFunction(value) {
          if (!isObject(value)) {
            return false;
          }
          var tag = baseGetTag(value);
          return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        function isInteger(value) {
          return typeof value == "number" && value == toInteger(value);
        }
        function isLength(value) {
          return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        function isObject(value) {
          var type = typeof value;
          return value != null && (type == "object" || type == "function");
        }
        function isObjectLike(value) {
          return value != null && typeof value == "object";
        }
        var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        function isMatch2(object23, source) {
          return object23 === source || baseIsMatch(object23, source, getMatchData(source));
        }
        function isMatchWith(object23, source, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return baseIsMatch(object23, source, getMatchData(source), customizer);
        }
        function isNaN2(value) {
          return isNumber(value) && value != +value;
        }
        function isNative(value) {
          if (isMaskable(value)) {
            throw new Error12(CORE_ERROR_TEXT);
          }
          return baseIsNative(value);
        }
        function isNull(value) {
          return value === null;
        }
        function isNil(value) {
          return value == null;
        }
        function isNumber(value) {
          return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        function isPlainObject(value) {
          if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
            return false;
          }
          var proto = getPrototype(value);
          if (proto === null) {
            return true;
          }
          var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
          return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        function isSafeInteger(value) {
          return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        function isString5(value) {
          return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        function isSymbol(value) {
          return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        function isUndefined(value) {
          return value === undefined2;
        }
        function isWeakMap(value) {
          return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        function isWeakSet(value) {
          return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        var lt = createRelationalOperation(baseLt);
        var lte = createRelationalOperation(function(value, other) {
          return value <= other;
        });
        function toArray(value) {
          if (!value) {
            return [];
          }
          if (isArrayLike(value)) {
            return isString5(value) ? stringToArray(value) : copyArray(value);
          }
          if (symIterator && value[symIterator]) {
            return iteratorToArray(value[symIterator]());
          }
          var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
          return func(value);
        }
        function toFinite(value) {
          if (!value) {
            return value === 0 ? value : 0;
          }
          value = toNumber(value);
          if (value === INFINITY || value === -INFINITY) {
            var sign = value < 0 ? -1 : 1;
            return sign * MAX_INTEGER;
          }
          return value === value ? value : 0;
        }
        function toInteger(value) {
          var result2 = toFinite(value), remainder = result2 % 1;
          return result2 === result2 ? remainder ? result2 - remainder : result2 : 0;
        }
        function toLength(value) {
          return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        function toNumber(value) {
          if (typeof value == "number") {
            return value;
          }
          if (isSymbol(value)) {
            return NAN;
          }
          if (isObject(value)) {
            var other = typeof value.valueOf == "function" ? value.valueOf() : value;
            value = isObject(other) ? other + "" : other;
          }
          if (typeof value != "string") {
            return value === 0 ? value : +value;
          }
          value = baseTrim(value);
          var isBinary = reIsBinary.test(value);
          return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        function toPlainObject(value) {
          return copyObject(value, keysIn(value));
        }
        function toSafeInteger(value) {
          return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        function toString(value) {
          return value == null ? "" : baseToString(value);
        }
        var assign2 = createAssigner(function(object23, source) {
          if (isPrototype(source) || isArrayLike(source)) {
            copyObject(source, keys(source), object23);
            return;
          }
          for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
              assignValue(object23, key, source[key]);
            }
          }
        });
        var assignIn = createAssigner(function(object23, source) {
          copyObject(source, keysIn(source), object23);
        });
        var assignInWith = createAssigner(function(object23, source, srcIndex, customizer) {
          copyObject(source, keysIn(source), object23, customizer);
        });
        var assignWith = createAssigner(function(object23, source, srcIndex, customizer) {
          copyObject(source, keys(source), object23, customizer);
        });
        var at = flatRest(baseAt);
        function create(prototype, properties) {
          var result2 = baseCreate(prototype);
          return properties == null ? result2 : baseAssign(result2, properties);
        }
        var defaults = baseRest(function(object23, sources) {
          object23 = Object2(object23);
          var index2 = -1;
          var length = sources.length;
          var guard = length > 2 ? sources[2] : undefined2;
          if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            length = 1;
          }
          while (++index2 < length) {
            var source = sources[index2];
            var props = keysIn(source);
            var propsIndex = -1;
            var propsLength = props.length;
            while (++propsIndex < propsLength) {
              var key = props[propsIndex];
              var value = object23[key];
              if (value === undefined2 || eq(value, objectProto[key]) && !hasOwnProperty.call(object23, key)) {
                object23[key] = source[key];
              }
            }
          }
          return object23;
        });
        var defaultsDeep = baseRest(function(args) {
          args.push(undefined2, customDefaultsMerge);
          return apply(mergeWith, undefined2, args);
        });
        function findKey(object23, predicate) {
          return baseFindKey(object23, getIteratee(predicate, 3), baseForOwn);
        }
        function findLastKey(object23, predicate) {
          return baseFindKey(object23, getIteratee(predicate, 3), baseForOwnRight);
        }
        function forIn(object23, iteratee2) {
          return object23 == null ? object23 : baseFor(object23, getIteratee(iteratee2, 3), keysIn);
        }
        function forInRight(object23, iteratee2) {
          return object23 == null ? object23 : baseForRight(object23, getIteratee(iteratee2, 3), keysIn);
        }
        function forOwn(object23, iteratee2) {
          return object23 && baseForOwn(object23, getIteratee(iteratee2, 3));
        }
        function forOwnRight(object23, iteratee2) {
          return object23 && baseForOwnRight(object23, getIteratee(iteratee2, 3));
        }
        function functions(object23) {
          return object23 == null ? [] : baseFunctions(object23, keys(object23));
        }
        function functionsIn(object23) {
          return object23 == null ? [] : baseFunctions(object23, keysIn(object23));
        }
        function get(object23, path, defaultValue) {
          var result2 = object23 == null ? undefined2 : baseGet(object23, path);
          return result2 === undefined2 ? defaultValue : result2;
        }
        function has3(object23, path) {
          return object23 != null && hasPath(object23, path, baseHas);
        }
        function hasIn(object23, path) {
          return object23 != null && hasPath(object23, path, baseHasIn);
        }
        var invert = createInverter(function(result2, value, key) {
          if (value != null && typeof value.toString != "function") {
            value = nativeObjectToString.call(value);
          }
          result2[value] = key;
        }, constant(identity2));
        var invertBy = createInverter(function(result2, value, key) {
          if (value != null && typeof value.toString != "function") {
            value = nativeObjectToString.call(value);
          }
          if (hasOwnProperty.call(result2, value)) {
            result2[value].push(key);
          } else {
            result2[value] = [key];
          }
        }, getIteratee);
        var invoke = baseRest(baseInvoke);
        function keys(object23) {
          return isArrayLike(object23) ? arrayLikeKeys(object23) : baseKeys(object23);
        }
        function keysIn(object23) {
          return isArrayLike(object23) ? arrayLikeKeys(object23, true) : baseKeysIn(object23);
        }
        function mapKeys(object23, iteratee2) {
          var result2 = {};
          iteratee2 = getIteratee(iteratee2, 3);
          baseForOwn(object23, function(value, key, object24) {
            baseAssignValue(result2, iteratee2(value, key, object24), value);
          });
          return result2;
        }
        function mapValues(object23, iteratee2) {
          var result2 = {};
          iteratee2 = getIteratee(iteratee2, 3);
          baseForOwn(object23, function(value, key, object24) {
            baseAssignValue(result2, key, iteratee2(value, key, object24));
          });
          return result2;
        }
        var merge = createAssigner(function(object23, source, srcIndex) {
          baseMerge(object23, source, srcIndex);
        });
        var mergeWith = createAssigner(function(object23, source, srcIndex, customizer) {
          baseMerge(object23, source, srcIndex, customizer);
        });
        var omit = flatRest(function(object23, paths) {
          var result2 = {};
          if (object23 == null) {
            return result2;
          }
          var isDeep = false;
          paths = arrayMap(paths, function(path) {
            path = castPath(path, object23);
            isDeep || (isDeep = path.length > 1);
            return path;
          });
          copyObject(object23, getAllKeysIn(object23), result2);
          if (isDeep) {
            result2 = baseClone(result2, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
          }
          var length = paths.length;
          while (length--) {
            baseUnset(result2, paths[length]);
          }
          return result2;
        });
        function omitBy(object23, predicate) {
          return pickBy(object23, negate(getIteratee(predicate)));
        }
        var pick = flatRest(function(object23, paths) {
          return object23 == null ? {} : basePick(object23, paths);
        });
        function pickBy(object23, predicate) {
          if (object23 == null) {
            return {};
          }
          var props = arrayMap(getAllKeysIn(object23), function(prop) {
            return [prop];
          });
          predicate = getIteratee(predicate);
          return basePickBy(object23, props, function(value, path) {
            return predicate(value, path[0]);
          });
        }
        function result(object23, path, defaultValue) {
          path = castPath(path, object23);
          var index2 = -1, length = path.length;
          if (!length) {
            length = 1;
            object23 = undefined2;
          }
          while (++index2 < length) {
            var value = object23 == null ? undefined2 : object23[toKey(path[index2])];
            if (value === undefined2) {
              index2 = length;
              value = defaultValue;
            }
            object23 = isFunction(value) ? value.call(object23) : value;
          }
          return object23;
        }
        function set(object23, path, value) {
          return object23 == null ? object23 : baseSet(object23, path, value);
        }
        function setWith(object23, path, value, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return object23 == null ? object23 : baseSet(object23, path, value, customizer);
        }
        var toPairs = createToPairs(keys);
        var toPairsIn = createToPairs(keysIn);
        function transform(object23, iteratee2, accumulator) {
          var isArr = isArray(object23), isArrLike = isArr || isBuffer(object23) || isTypedArray(object23);
          iteratee2 = getIteratee(iteratee2, 4);
          if (accumulator == null) {
            var Ctor = object23 && object23.constructor;
            if (isArrLike) {
              accumulator = isArr ? new Ctor() : [];
            } else if (isObject(object23)) {
              accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object23)) : {};
            } else {
              accumulator = {};
            }
          }
          (isArrLike ? arrayEach : baseForOwn)(object23, function(value, index2, object24) {
            return iteratee2(accumulator, value, index2, object24);
          });
          return accumulator;
        }
        function unset(object23, path) {
          return object23 == null ? true : baseUnset(object23, path);
        }
        function update(object23, path, updater) {
          return object23 == null ? object23 : baseUpdate(object23, path, castFunction(updater));
        }
        function updateWith(object23, path, updater, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return object23 == null ? object23 : baseUpdate(object23, path, castFunction(updater), customizer);
        }
        function values(object23) {
          return object23 == null ? [] : baseValues(object23, keys(object23));
        }
        function valuesIn(object23) {
          return object23 == null ? [] : baseValues(object23, keysIn(object23));
        }
        function clamp2(number3, lower, upper) {
          if (upper === undefined2) {
            upper = lower;
            lower = undefined2;
          }
          if (upper !== undefined2) {
            upper = toNumber(upper);
            upper = upper === upper ? upper : 0;
          }
          if (lower !== undefined2) {
            lower = toNumber(lower);
            lower = lower === lower ? lower : 0;
          }
          return baseClamp(toNumber(number3), lower, upper);
        }
        function inRange(number3, start, end) {
          start = toFinite(start);
          if (end === undefined2) {
            end = start;
            start = 0;
          } else {
            end = toFinite(end);
          }
          number3 = toNumber(number3);
          return baseInRange(number3, start, end);
        }
        function random(lower, upper, floating) {
          if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) {
            upper = floating = undefined2;
          }
          if (floating === undefined2) {
            if (typeof upper == "boolean") {
              floating = upper;
              upper = undefined2;
            } else if (typeof lower == "boolean") {
              floating = lower;
              lower = undefined2;
            }
          }
          if (lower === undefined2 && upper === undefined2) {
            lower = 0;
            upper = 1;
          } else {
            lower = toFinite(lower);
            if (upper === undefined2) {
              upper = lower;
              lower = 0;
            } else {
              upper = toFinite(upper);
            }
          }
          if (lower > upper) {
            var temp = lower;
            lower = upper;
            upper = temp;
          }
          if (floating || lower % 1 || upper % 1) {
            var rand = nativeRandom();
            return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
          }
          return baseRandom(lower, upper);
        }
        var camelCase = createCompounder(function(result2, word, index2) {
          word = word.toLowerCase();
          return result2 + (index2 ? capitalize(word) : word);
        });
        function capitalize(string21) {
          return upperFirst(toString(string21).toLowerCase());
        }
        function deburr(string21) {
          string21 = toString(string21);
          return string21 && string21.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        function endsWith(string21, target, position) {
          string21 = toString(string21);
          target = baseToString(target);
          var length = string21.length;
          position = position === undefined2 ? length : baseClamp(toInteger(position), 0, length);
          var end = position;
          position -= target.length;
          return position >= 0 && string21.slice(position, end) == target;
        }
        function escape2(string21) {
          string21 = toString(string21);
          return string21 && reHasUnescapedHtml.test(string21) ? string21.replace(reUnescapedHtml, escapeHtmlChar) : string21;
        }
        function escapeRegExp(string21) {
          string21 = toString(string21);
          return string21 && reHasRegExpChar.test(string21) ? string21.replace(reRegExpChar, "\\$&") : string21;
        }
        var kebabCase = createCompounder(function(result2, word, index2) {
          return result2 + (index2 ? "-" : "") + word.toLowerCase();
        });
        var lowerCase = createCompounder(function(result2, word, index2) {
          return result2 + (index2 ? " " : "") + word.toLowerCase();
        });
        var lowerFirst = createCaseFirst("toLowerCase");
        function pad2(string21, length, chars) {
          string21 = toString(string21);
          length = toInteger(length);
          var strLength = length ? stringSize(string21) : 0;
          if (!length || strLength >= length) {
            return string21;
          }
          var mid = (length - strLength) / 2;
          return createPadding(nativeFloor(mid), chars) + string21 + createPadding(nativeCeil(mid), chars);
        }
        function padEnd(string21, length, chars) {
          string21 = toString(string21);
          length = toInteger(length);
          var strLength = length ? stringSize(string21) : 0;
          return length && strLength < length ? string21 + createPadding(length - strLength, chars) : string21;
        }
        function padStart(string21, length, chars) {
          string21 = toString(string21);
          length = toInteger(length);
          var strLength = length ? stringSize(string21) : 0;
          return length && strLength < length ? createPadding(length - strLength, chars) + string21 : string21;
        }
        function parseInt2(string21, radix, guard) {
          if (guard || radix == null) {
            radix = 0;
          } else if (radix) {
            radix = +radix;
          }
          return nativeParseInt(toString(string21).replace(reTrimStart, ""), radix || 0);
        }
        function repeat(string21, n3, guard) {
          if (guard ? isIterateeCall(string21, n3, guard) : n3 === undefined2) {
            n3 = 1;
          } else {
            n3 = toInteger(n3);
          }
          return baseRepeat(toString(string21), n3);
        }
        function replace() {
          var args = arguments, string21 = toString(args[0]);
          return args.length < 3 ? string21 : string21.replace(args[1], args[2]);
        }
        var snakeCase = createCompounder(function(result2, word, index2) {
          return result2 + (index2 ? "_" : "") + word.toLowerCase();
        });
        function split(string21, separator2, limit) {
          if (limit && typeof limit != "number" && isIterateeCall(string21, separator2, limit)) {
            separator2 = limit = undefined2;
          }
          limit = limit === undefined2 ? MAX_ARRAY_LENGTH : limit >>> 0;
          if (!limit) {
            return [];
          }
          string21 = toString(string21);
          if (string21 && (typeof separator2 == "string" || separator2 != null && !isRegExp(separator2))) {
            separator2 = baseToString(separator2);
            if (!separator2 && hasUnicode(string21)) {
              return castSlice(stringToArray(string21), 0, limit);
            }
          }
          return string21.split(separator2, limit);
        }
        var startCase = createCompounder(function(result2, word, index2) {
          return result2 + (index2 ? " " : "") + upperFirst(word);
        });
        function startsWith(string21, target, position) {
          string21 = toString(string21);
          position = position == null ? 0 : baseClamp(toInteger(position), 0, string21.length);
          target = baseToString(target);
          return string21.slice(position, position + target.length) == target;
        }
        function template(string21, options7, guard) {
          var settings = lodash.templateSettings;
          if (guard && isIterateeCall(string21, options7, guard)) {
            options7 = undefined2;
          }
          string21 = toString(string21);
          options7 = assignInWith({}, options7, settings, customDefaultsAssignIn);
          var imports = assignInWith({}, options7.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
          var isEscaping, isEvaluating, index2 = 0, interpolate3 = options7.interpolate || reNoMatch, source = "__p += '";
          var reDelimiters = RegExp2(
            (options7.escape || reNoMatch).source + "|" + interpolate3.source + "|" + (interpolate3 === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options7.evaluate || reNoMatch).source + "|$",
            "g"
          );
          var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options7, "sourceURL") ? (options7.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
          string21.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
            interpolateValue || (interpolateValue = esTemplateValue);
            source += string21.slice(index2, offset).replace(reUnescapedString, escapeStringChar);
            if (escapeValue) {
              isEscaping = true;
              source += "' +\n__e(" + escapeValue + ") +\n'";
            }
            if (evaluateValue) {
              isEvaluating = true;
              source += "';\n" + evaluateValue + ";\n__p += '";
            }
            if (interpolateValue) {
              source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
            }
            index2 = offset + match.length;
            return match;
          });
          source += "';\n";
          var variable = hasOwnProperty.call(options7, "variable") && options7.variable;
          if (!variable) {
            source = "with (obj) {\n" + source + "\n}\n";
          } else if (reForbiddenIdentifierChars.test(variable)) {
            throw new Error12(INVALID_TEMPL_VAR_ERROR_TEXT);
          }
          source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
          source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
          var result2 = attempt(function() {
            return Function2(importsKeys, sourceURL + "return " + source).apply(undefined2, importsValues);
          });
          result2.source = source;
          if (isError3(result2)) {
            throw result2;
          }
          return result2;
        }
        function toLower(value) {
          return toString(value).toLowerCase();
        }
        function toUpper(value) {
          return toString(value).toUpperCase();
        }
        function trim(string21, chars, guard) {
          string21 = toString(string21);
          if (string21 && (guard || chars === undefined2)) {
            return baseTrim(string21);
          }
          if (!string21 || !(chars = baseToString(chars))) {
            return string21;
          }
          var strSymbols = stringToArray(string21), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
          return castSlice(strSymbols, start, end).join("");
        }
        function trimEnd(string21, chars, guard) {
          string21 = toString(string21);
          if (string21 && (guard || chars === undefined2)) {
            return string21.slice(0, trimmedEndIndex(string21) + 1);
          }
          if (!string21 || !(chars = baseToString(chars))) {
            return string21;
          }
          var strSymbols = stringToArray(string21), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
          return castSlice(strSymbols, 0, end).join("");
        }
        function trimStart(string21, chars, guard) {
          string21 = toString(string21);
          if (string21 && (guard || chars === undefined2)) {
            return string21.replace(reTrimStart, "");
          }
          if (!string21 || !(chars = baseToString(chars))) {
            return string21;
          }
          var strSymbols = stringToArray(string21), start = charsStartIndex(strSymbols, stringToArray(chars));
          return castSlice(strSymbols, start).join("");
        }
        function truncate(string21, options7) {
          var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
          if (isObject(options7)) {
            var separator2 = "separator" in options7 ? options7.separator : separator2;
            length = "length" in options7 ? toInteger(options7.length) : length;
            omission = "omission" in options7 ? baseToString(options7.omission) : omission;
          }
          string21 = toString(string21);
          var strLength = string21.length;
          if (hasUnicode(string21)) {
            var strSymbols = stringToArray(string21);
            strLength = strSymbols.length;
          }
          if (length >= strLength) {
            return string21;
          }
          var end = length - stringSize(omission);
          if (end < 1) {
            return omission;
          }
          var result2 = strSymbols ? castSlice(strSymbols, 0, end).join("") : string21.slice(0, end);
          if (separator2 === undefined2) {
            return result2 + omission;
          }
          if (strSymbols) {
            end += result2.length - end;
          }
          if (isRegExp(separator2)) {
            if (string21.slice(end).search(separator2)) {
              var match, substring = result2;
              if (!separator2.global) {
                separator2 = RegExp2(separator2.source, toString(reFlags.exec(separator2)) + "g");
              }
              separator2.lastIndex = 0;
              while (match = separator2.exec(substring)) {
                var newEnd = match.index;
              }
              result2 = result2.slice(0, newEnd === undefined2 ? end : newEnd);
            }
          } else if (string21.indexOf(baseToString(separator2), end) != end) {
            var index2 = result2.lastIndexOf(separator2);
            if (index2 > -1) {
              result2 = result2.slice(0, index2);
            }
          }
          return result2 + omission;
        }
        function unescape(string21) {
          string21 = toString(string21);
          return string21 && reHasEscapedHtml.test(string21) ? string21.replace(reEscapedHtml, unescapeHtmlChar) : string21;
        }
        var upperCase = createCompounder(function(result2, word, index2) {
          return result2 + (index2 ? " " : "") + word.toUpperCase();
        });
        var upperFirst = createCaseFirst("toUpperCase");
        function words(string21, pattern, guard) {
          string21 = toString(string21);
          pattern = guard ? undefined2 : pattern;
          if (pattern === undefined2) {
            return hasUnicodeWord(string21) ? unicodeWords(string21) : asciiWords(string21);
          }
          return string21.match(pattern) || [];
        }
        var attempt = baseRest(function(func, args) {
          try {
            return apply(func, undefined2, args);
          } catch (e4) {
            return isError3(e4) ? e4 : new Error12(e4);
          }
        });
        var bindAll = flatRest(function(object23, methodNames) {
          arrayEach(methodNames, function(key) {
            key = toKey(key);
            baseAssignValue(object23, key, bind(object23[key], object23));
          });
          return object23;
        });
        function cond(pairs) {
          var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
          pairs = !length ? [] : arrayMap(pairs, function(pair) {
            if (typeof pair[1] != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT);
            }
            return [toIteratee(pair[0]), pair[1]];
          });
          return baseRest(function(args) {
            var index2 = -1;
            while (++index2 < length) {
              var pair = pairs[index2];
              if (apply(pair[0], this, args)) {
                return apply(pair[1], this, args);
              }
            }
          });
        }
        function conforms(source) {
          return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        function constant(value) {
          return function() {
            return value;
          };
        }
        function defaultTo(value, defaultValue) {
          return value == null || value !== value ? defaultValue : value;
        }
        var flow = createFlow();
        var flowRight = createFlow(true);
        function identity2(value) {
          return value;
        }
        function iteratee(func) {
          return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        function matches(source) {
          return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        function matchesProperty(path, srcValue) {
          return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        var method = baseRest(function(path, args) {
          return function(object23) {
            return baseInvoke(object23, path, args);
          };
        });
        var methodOf = baseRest(function(object23, args) {
          return function(path) {
            return baseInvoke(object23, path, args);
          };
        });
        function mixin(object23, source, options7) {
          var props = keys(source), methodNames = baseFunctions(source, props);
          if (options7 == null && !(isObject(source) && (methodNames.length || !props.length))) {
            options7 = source;
            source = object23;
            object23 = this;
            methodNames = baseFunctions(source, keys(source));
          }
          var chain2 = !(isObject(options7) && "chain" in options7) || !!options7.chain, isFunc = isFunction(object23);
          arrayEach(methodNames, function(methodName) {
            var func = source[methodName];
            object23[methodName] = func;
            if (isFunc) {
              object23.prototype[methodName] = function() {
                var chainAll = this.__chain__;
                if (chain2 || chainAll) {
                  var result2 = object23(this.__wrapped__), actions = result2.__actions__ = copyArray(this.__actions__);
                  actions.push({ "func": func, "args": arguments, "thisArg": object23 });
                  result2.__chain__ = chainAll;
                  return result2;
                }
                return func.apply(object23, arrayPush([this.value()], arguments));
              };
            }
          });
          return object23;
        }
        function noConflict() {
          if (root._ === this) {
            root._ = oldDash;
          }
          return this;
        }
        function noop20() {
        }
        function nthArg(n3) {
          n3 = toInteger(n3);
          return baseRest(function(args) {
            return baseNth(args, n3);
          });
        }
        var over = createOver(arrayMap);
        var overEvery = createOver(arrayEvery);
        var overSome = createOver(arraySome);
        function property(path) {
          return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        function propertyOf(object23) {
          return function(path) {
            return object23 == null ? undefined2 : baseGet(object23, path);
          };
        }
        var range = createRange();
        var rangeRight = createRange(true);
        function stubArray() {
          return [];
        }
        function stubFalse() {
          return false;
        }
        function stubObject() {
          return {};
        }
        function stubString() {
          return "";
        }
        function stubTrue() {
          return true;
        }
        function times(n3, iteratee2) {
          n3 = toInteger(n3);
          if (n3 < 1 || n3 > MAX_SAFE_INTEGER) {
            return [];
          }
          var index2 = MAX_ARRAY_LENGTH, length = nativeMin(n3, MAX_ARRAY_LENGTH);
          iteratee2 = getIteratee(iteratee2);
          n3 -= MAX_ARRAY_LENGTH;
          var result2 = baseTimes(length, iteratee2);
          while (++index2 < n3) {
            iteratee2(index2);
          }
          return result2;
        }
        function toPath(value) {
          if (isArray(value)) {
            return arrayMap(value, toKey);
          }
          return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
        }
        function uniqueId(prefix) {
          var id18 = ++idCounter;
          return toString(prefix) + id18;
        }
        var add2 = createMathOperation(function(augend, addend) {
          return augend + addend;
        }, 0);
        var ceil = createRound("ceil");
        var divide = createMathOperation(function(dividend, divisor) {
          return dividend / divisor;
        }, 1);
        var floor = createRound("floor");
        function max(array2) {
          return array2 && array2.length ? baseExtremum(array2, identity2, baseGt) : undefined2;
        }
        function maxBy(array2, iteratee2) {
          return array2 && array2.length ? baseExtremum(array2, getIteratee(iteratee2, 2), baseGt) : undefined2;
        }
        function mean(array2) {
          return baseMean(array2, identity2);
        }
        function meanBy(array2, iteratee2) {
          return baseMean(array2, getIteratee(iteratee2, 2));
        }
        function min(array2) {
          return array2 && array2.length ? baseExtremum(array2, identity2, baseLt) : undefined2;
        }
        function minBy(array2, iteratee2) {
          return array2 && array2.length ? baseExtremum(array2, getIteratee(iteratee2, 2), baseLt) : undefined2;
        }
        var multiply = createMathOperation(function(multiplier, multiplicand) {
          return multiplier * multiplicand;
        }, 1);
        var round = createRound("round");
        var subtract = createMathOperation(function(minuend, subtrahend) {
          return minuend - subtrahend;
        }, 0);
        function sum(array2) {
          return array2 && array2.length ? baseSum(array2, identity2) : 0;
        }
        function sumBy(array2, iteratee2) {
          return array2 && array2.length ? baseSum(array2, getIteratee(iteratee2, 2)) : 0;
        }
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign2;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce13;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay2;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter2;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy3;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize3;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle2;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        mixin(lodash, lodash);
        lodash.add = add2;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp2;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape2;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has3;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity2;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual3;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError3;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch2;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN2;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString5;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop20;
        lodash.now = now2;
        lodash.pad = pad2;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt2;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext2;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
          var source = {};
          baseForOwn(lodash, function(func, methodName) {
            if (!hasOwnProperty.call(lodash.prototype, methodName)) {
              source[methodName] = func;
            }
          });
          return source;
        }(), { "chain": false });
        lodash.VERSION = VERSION;
        arrayEach(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(methodName) {
          lodash[methodName].placeholder = lodash;
        });
        arrayEach(["drop", "take"], function(methodName, index2) {
          LazyWrapper.prototype[methodName] = function(n3) {
            n3 = n3 === undefined2 ? 1 : nativeMax(toInteger(n3), 0);
            var result2 = this.__filtered__ && !index2 ? new LazyWrapper(this) : this.clone();
            if (result2.__filtered__) {
              result2.__takeCount__ = nativeMin(n3, result2.__takeCount__);
            } else {
              result2.__views__.push({
                "size": nativeMin(n3, MAX_ARRAY_LENGTH),
                "type": methodName + (result2.__dir__ < 0 ? "Right" : "")
              });
            }
            return result2;
          };
          LazyWrapper.prototype[methodName + "Right"] = function(n3) {
            return this.reverse()[methodName](n3).reverse();
          };
        });
        arrayEach(["filter", "map", "takeWhile"], function(methodName, index2) {
          var type = index2 + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
          LazyWrapper.prototype[methodName] = function(iteratee2) {
            var result2 = this.clone();
            result2.__iteratees__.push({
              "iteratee": getIteratee(iteratee2, 3),
              "type": type
            });
            result2.__filtered__ = result2.__filtered__ || isFilter;
            return result2;
          };
        });
        arrayEach(["head", "last"], function(methodName, index2) {
          var takeName = "take" + (index2 ? "Right" : "");
          LazyWrapper.prototype[methodName] = function() {
            return this[takeName](1).value()[0];
          };
        });
        arrayEach(["initial", "tail"], function(methodName, index2) {
          var dropName = "drop" + (index2 ? "" : "Right");
          LazyWrapper.prototype[methodName] = function() {
            return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
          };
        });
        LazyWrapper.prototype.compact = function() {
          return this.filter(identity2);
        };
        LazyWrapper.prototype.find = function(predicate) {
          return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
          return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
          if (typeof path == "function") {
            return new LazyWrapper(this);
          }
          return this.map(function(value) {
            return baseInvoke(value, path, args);
          });
        });
        LazyWrapper.prototype.reject = function(predicate) {
          return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
          start = toInteger(start);
          var result2 = this;
          if (result2.__filtered__ && (start > 0 || end < 0)) {
            return new LazyWrapper(result2);
          }
          if (start < 0) {
            result2 = result2.takeRight(-start);
          } else if (start) {
            result2 = result2.drop(start);
          }
          if (end !== undefined2) {
            end = toInteger(end);
            result2 = end < 0 ? result2.dropRight(-end) : result2.take(end - start);
          }
          return result2;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
          return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
          return this.take(MAX_ARRAY_LENGTH);
        };
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
          var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
          if (!lodashFunc) {
            return;
          }
          lodash.prototype[methodName] = function() {
            var value = this.__wrapped__, args = isTaker ? [1] : arguments, isLazy = value instanceof LazyWrapper, iteratee2 = args[0], useLazy = isLazy || isArray(value);
            var interceptor = function(value2) {
              var result3 = lodashFunc.apply(lodash, arrayPush([value2], args));
              return isTaker && chainAll ? result3[0] : result3;
            };
            if (useLazy && checkIteratee && typeof iteratee2 == "function" && iteratee2.length != 1) {
              isLazy = useLazy = false;
            }
            var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
            if (!retUnwrapped && useLazy) {
              value = onlyLazy ? value : new LazyWrapper(this);
              var result2 = func.apply(value, args);
              result2.__actions__.push({ "func": thru, "args": [interceptor], "thisArg": undefined2 });
              return new LodashWrapper(result2, chainAll);
            }
            if (isUnwrapped && onlyLazy) {
              return func.apply(this, args);
            }
            result2 = this.thru(interceptor);
            return isUnwrapped ? isTaker ? result2.value()[0] : result2.value() : result2;
          };
        });
        arrayEach(["pop", "push", "shift", "sort", "splice", "unshift"], function(methodName) {
          var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
          lodash.prototype[methodName] = function() {
            var args = arguments;
            if (retUnwrapped && !this.__chain__) {
              var value = this.value();
              return func.apply(isArray(value) ? value : [], args);
            }
            return this[chainName](function(value2) {
              return func.apply(isArray(value2) ? value2 : [], args);
            });
          };
        });
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
          var lodashFunc = lodash[methodName];
          if (lodashFunc) {
            var key = lodashFunc.name + "";
            if (!hasOwnProperty.call(realNames, key)) {
              realNames[key] = [];
            }
            realNames[key].push({ "name": methodName, "func": lodashFunc });
          }
        });
        realNames[createHybrid(undefined2, WRAP_BIND_KEY_FLAG).name] = [{
          "name": "wrapper",
          "func": undefined2
        }];
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) {
          lodash.prototype[symIterator] = wrapperToIterator;
        }
        return lodash;
      };
      var _4 = runInContext();
      if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        root._ = _4;
        define(function() {
          return _4;
        });
      } else if (freeModule) {
        (freeModule.exports = _4)._ = _4;
        freeExports._ = _4;
      } else {
        root._ = _4;
      }
    }).call(exports);
  }
});

// ../../node_modules/p-retry/node_modules/retry/lib/retry_operation.js
var require_retry_operation = __commonJS({
  "../../node_modules/p-retry/node_modules/retry/lib/retry_operation.js"(exports, module) {
    "use strict";
    function RetryOperation(timeouts, options7) {
      if (typeof options7 === "boolean") {
        options7 = { forever: options7 };
      }
      this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
      this._timeouts = timeouts;
      this._options = options7 || {};
      this._maxRetryTime = options7 && options7.maxRetryTime || Infinity;
      this._fn = null;
      this._errors = [];
      this._attempts = 1;
      this._operationTimeout = null;
      this._operationTimeoutCb = null;
      this._timeout = null;
      this._operationStart = null;
      this._timer = null;
      if (this._options.forever) {
        this._cachedTimeouts = this._timeouts.slice(0);
      }
    }
    module.exports = RetryOperation;
    RetryOperation.prototype.reset = function() {
      this._attempts = 1;
      this._timeouts = this._originalTimeouts.slice(0);
    };
    RetryOperation.prototype.stop = function() {
      if (this._timeout) {
        clearTimeout(this._timeout);
      }
      if (this._timer) {
        clearTimeout(this._timer);
      }
      this._timeouts = [];
      this._cachedTimeouts = null;
    };
    RetryOperation.prototype.retry = function(err) {
      if (this._timeout) {
        clearTimeout(this._timeout);
      }
      if (!err) {
        return false;
      }
      var currentTime = (/* @__PURE__ */ new Date()).getTime();
      if (err && currentTime - this._operationStart >= this._maxRetryTime) {
        this._errors.push(err);
        this._errors.unshift(new Error("RetryOperation timeout occurred"));
        return false;
      }
      this._errors.push(err);
      var timeout = this._timeouts.shift();
      if (timeout === void 0) {
        if (this._cachedTimeouts) {
          this._errors.splice(0, this._errors.length - 1);
          timeout = this._cachedTimeouts.slice(-1);
        } else {
          return false;
        }
      }
      var self2 = this;
      this._timer = setTimeout(function() {
        self2._attempts++;
        if (self2._operationTimeoutCb) {
          self2._timeout = setTimeout(function() {
            self2._operationTimeoutCb(self2._attempts);
          }, self2._operationTimeout);
          if (self2._options.unref) {
            self2._timeout.unref();
          }
        }
        self2._fn(self2._attempts);
      }, timeout);
      if (this._options.unref) {
        this._timer.unref();
      }
      return true;
    };
    RetryOperation.prototype.attempt = function(fn, timeoutOps) {
      this._fn = fn;
      if (timeoutOps) {
        if (timeoutOps.timeout) {
          this._operationTimeout = timeoutOps.timeout;
        }
        if (timeoutOps.cb) {
          this._operationTimeoutCb = timeoutOps.cb;
        }
      }
      var self2 = this;
      if (this._operationTimeoutCb) {
        this._timeout = setTimeout(function() {
          self2._operationTimeoutCb();
        }, self2._operationTimeout);
      }
      this._operationStart = (/* @__PURE__ */ new Date()).getTime();
      this._fn(this._attempts);
    };
    RetryOperation.prototype.try = function(fn) {
      console.log("Using RetryOperation.try() is deprecated");
      this.attempt(fn);
    };
    RetryOperation.prototype.start = function(fn) {
      console.log("Using RetryOperation.start() is deprecated");
      this.attempt(fn);
    };
    RetryOperation.prototype.start = RetryOperation.prototype.try;
    RetryOperation.prototype.errors = function() {
      return this._errors;
    };
    RetryOperation.prototype.attempts = function() {
      return this._attempts;
    };
    RetryOperation.prototype.mainError = function() {
      if (this._errors.length === 0) {
        return null;
      }
      var counts = {};
      var mainError = null;
      var mainErrorCount = 0;
      for (var i4 = 0; i4 < this._errors.length; i4++) {
        var error = this._errors[i4];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
          mainError = error;
          mainErrorCount = count;
        }
      }
      return mainError;
    };
  }
});

// ../../node_modules/p-retry/node_modules/retry/lib/retry.js
var require_retry = __commonJS({
  "../../node_modules/p-retry/node_modules/retry/lib/retry.js"(exports) {
    "use strict";
    var RetryOperation = require_retry_operation();
    exports.operation = function(options7) {
      var timeouts = exports.timeouts(options7);
      return new RetryOperation(timeouts, {
        forever: options7 && (options7.forever || options7.retries === Infinity),
        unref: options7 && options7.unref,
        maxRetryTime: options7 && options7.maxRetryTime
      });
    };
    exports.timeouts = function(options7) {
      if (options7 instanceof Array) {
        return [].concat(options7);
      }
      var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1 * 1e3,
        maxTimeout: Infinity,
        randomize: false
      };
      for (var key in options7) {
        opts[key] = options7[key];
      }
      if (opts.minTimeout > opts.maxTimeout) {
        throw new Error("minTimeout is greater than maxTimeout");
      }
      var timeouts = [];
      for (var i4 = 0; i4 < opts.retries; i4++) {
        timeouts.push(this.createTimeout(i4, opts));
      }
      if (options7 && options7.forever && !timeouts.length) {
        timeouts.push(this.createTimeout(i4, opts));
      }
      timeouts.sort(function(a4, b3) {
        return a4 - b3;
      });
      return timeouts;
    };
    exports.createTimeout = function(attempt, opts) {
      var random = opts.randomize ? Math.random() + 1 : 1;
      var timeout = Math.round(random * Math.max(opts.minTimeout, 1) * Math.pow(opts.factor, attempt));
      timeout = Math.min(timeout, opts.maxTimeout);
      return timeout;
    };
    exports.wrap = function(obj, options7, methods) {
      if (options7 instanceof Array) {
        methods = options7;
        options7 = null;
      }
      if (!methods) {
        methods = [];
        for (var key in obj) {
          if (typeof obj[key] === "function") {
            methods.push(key);
          }
        }
      }
      for (var i4 = 0; i4 < methods.length; i4++) {
        var method = methods[i4];
        var original = obj[method];
        obj[method] = function retryWrapper(original2) {
          var op = exports.operation(options7);
          var args = Array.prototype.slice.call(arguments, 1);
          var callback = args.pop();
          args.push(function(err) {
            if (op.retry(err)) {
              return;
            }
            if (err) {
              arguments[0] = op.mainError();
            }
            callback.apply(this, arguments);
          });
          op.attempt(function() {
            original2.apply(obj, args);
          });
        }.bind(obj, original);
        obj[method].options = options7;
      }
    };
  }
});

// ../../node_modules/p-retry/node_modules/retry/index.js
var require_retry2 = __commonJS({
  "../../node_modules/p-retry/node_modules/retry/index.js"(exports, module) {
    "use strict";
    module.exports = require_retry();
  }
});

// ../../node_modules/lodash/isObject.js
var require_isObject = __commonJS({
  "../../node_modules/lodash/isObject.js"(exports, module) {
    "use strict";
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == "object" || type == "function");
    }
    module.exports = isObject;
  }
});

// ../../node_modules/lodash/_freeGlobal.js
var require_freeGlobal = __commonJS({
  "../../node_modules/lodash/_freeGlobal.js"(exports, module) {
    "use strict";
    var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
    module.exports = freeGlobal;
  }
});

// ../../node_modules/lodash/_root.js
var require_root = __commonJS({
  "../../node_modules/lodash/_root.js"(exports, module) {
    "use strict";
    var freeGlobal = require_freeGlobal();
    var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    var root = freeGlobal || freeSelf || Function("return this")();
    module.exports = root;
  }
});

// ../../node_modules/lodash/now.js
var require_now = __commonJS({
  "../../node_modules/lodash/now.js"(exports, module) {
    "use strict";
    var root = require_root();
    var now2 = function() {
      return root.Date.now();
    };
    module.exports = now2;
  }
});

// ../../node_modules/lodash/_trimmedEndIndex.js
var require_trimmedEndIndex = __commonJS({
  "../../node_modules/lodash/_trimmedEndIndex.js"(exports, module) {
    "use strict";
    var reWhitespace = /\s/;
    function trimmedEndIndex(string21) {
      var index2 = string21.length;
      while (index2-- && reWhitespace.test(string21.charAt(index2))) {
      }
      return index2;
    }
    module.exports = trimmedEndIndex;
  }
});

// ../../node_modules/lodash/_baseTrim.js
var require_baseTrim = __commonJS({
  "../../node_modules/lodash/_baseTrim.js"(exports, module) {
    "use strict";
    var trimmedEndIndex = require_trimmedEndIndex();
    var reTrimStart = /^\s+/;
    function baseTrim(string21) {
      return string21 ? string21.slice(0, trimmedEndIndex(string21) + 1).replace(reTrimStart, "") : string21;
    }
    module.exports = baseTrim;
  }
});

// ../../node_modules/lodash/_Symbol.js
var require_Symbol = __commonJS({
  "../../node_modules/lodash/_Symbol.js"(exports, module) {
    "use strict";
    var root = require_root();
    var Symbol2 = root.Symbol;
    module.exports = Symbol2;
  }
});

// ../../node_modules/lodash/_getRawTag.js
var require_getRawTag = __commonJS({
  "../../node_modules/lodash/_getRawTag.js"(exports, module) {
    "use strict";
    var Symbol2 = require_Symbol();
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    var nativeObjectToString = objectProto.toString;
    var symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
      try {
        value[symToStringTag] = void 0;
        var unmasked = true;
      } catch (e4) {
      }
      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }
    module.exports = getRawTag;
  }
});

// ../../node_modules/lodash/_objectToString.js
var require_objectToString = __commonJS({
  "../../node_modules/lodash/_objectToString.js"(exports, module) {
    "use strict";
    var objectProto = Object.prototype;
    var nativeObjectToString = objectProto.toString;
    function objectToString3(value) {
      return nativeObjectToString.call(value);
    }
    module.exports = objectToString3;
  }
});

// ../../node_modules/lodash/_baseGetTag.js
var require_baseGetTag = __commonJS({
  "../../node_modules/lodash/_baseGetTag.js"(exports, module) {
    "use strict";
    var Symbol2 = require_Symbol();
    var getRawTag = require_getRawTag();
    var objectToString3 = require_objectToString();
    var nullTag = "[object Null]";
    var undefinedTag = "[object Undefined]";
    var symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
    function baseGetTag(value) {
      if (value == null) {
        return value === void 0 ? undefinedTag : nullTag;
      }
      return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString3(value);
    }
    module.exports = baseGetTag;
  }
});

// ../../node_modules/lodash/isObjectLike.js
var require_isObjectLike = __commonJS({
  "../../node_modules/lodash/isObjectLike.js"(exports, module) {
    "use strict";
    function isObjectLike(value) {
      return value != null && typeof value == "object";
    }
    module.exports = isObjectLike;
  }
});

// ../../node_modules/lodash/isSymbol.js
var require_isSymbol = __commonJS({
  "../../node_modules/lodash/isSymbol.js"(exports, module) {
    "use strict";
    var baseGetTag = require_baseGetTag();
    var isObjectLike = require_isObjectLike();
    var symbolTag = "[object Symbol]";
    function isSymbol(value) {
      return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
    }
    module.exports = isSymbol;
  }
});

// ../../node_modules/lodash/toNumber.js
var require_toNumber = __commonJS({
  "../../node_modules/lodash/toNumber.js"(exports, module) {
    "use strict";
    var baseTrim = require_baseTrim();
    var isObject = require_isObject();
    var isSymbol = require_isSymbol();
    var NAN = 0 / 0;
    var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    var reIsBinary = /^0b[01]+$/i;
    var reIsOctal = /^0o[0-7]+$/i;
    var freeParseInt = parseInt;
    function toNumber(value) {
      if (typeof value == "number") {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = isObject(other) ? other + "" : other;
      }
      if (typeof value != "string") {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
    }
    module.exports = toNumber;
  }
});

// ../../node_modules/lodash/debounce.js
var require_debounce = __commonJS({
  "../../node_modules/lodash/debounce.js"(exports, module) {
    "use strict";
    var isObject = require_isObject();
    var now2 = require_now();
    var toNumber = require_toNumber();
    var FUNC_ERROR_TEXT = "Expected a function";
    var nativeMax = Math.max;
    var nativeMin = Math.min;
    function debounce13(func, wait, options7) {
      var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
      if (typeof func != "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options7)) {
        leading = !!options7.leading;
        maxing = "maxWait" in options7;
        maxWait = maxing ? nativeMax(toNumber(options7.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options7 ? !!options7.trailing : trailing;
      }
      function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = void 0;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }
      function leadingEdge(time) {
        lastInvokeTime = time;
        timerId = setTimeout(timerExpired, wait);
        return leading ? invokeFunc(time) : result;
      }
      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
      }
      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
      }
      function timerExpired() {
        var time = now2();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        timerId = setTimeout(timerExpired, remainingWait(time));
      }
      function trailingEdge(time) {
        timerId = void 0;
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = void 0;
        return result;
      }
      function cancel() {
        if (timerId !== void 0) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = void 0;
      }
      function flush() {
        return timerId === void 0 ? result : trailingEdge(now2());
      }
      function debounced() {
        var time = now2(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
          if (timerId === void 0) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === void 0) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }
    module.exports = debounce13;
  }
});

// ../../node_modules/lodash/throttle.js
var require_throttle = __commonJS({
  "../../node_modules/lodash/throttle.js"(exports, module) {
    "use strict";
    var debounce13 = require_debounce();
    var isObject = require_isObject();
    var FUNC_ERROR_TEXT = "Expected a function";
    function throttle2(func, wait, options7) {
      var leading = true, trailing = true;
      if (typeof func != "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options7)) {
        leading = "leading" in options7 ? !!options7.leading : leading;
        trailing = "trailing" in options7 ? !!options7.trailing : trailing;
      }
      return debounce13(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
      });
    }
    module.exports = throttle2;
  }
});

// ../../node_modules/namespace-emitter/index.js
var require_namespace_emitter = __commonJS({
  "../../node_modules/namespace-emitter/index.js"(exports, module) {
    "use strict";
    module.exports = function createNamespaceEmitter() {
      var emitter = {};
      var _fns = emitter._fns = {};
      emitter.emit = function emit(event, arg1, arg2, arg3, arg4, arg5, arg6) {
        var toEmit = getListeners(event);
        if (toEmit.length) {
          emitAll(event, toEmit, [arg1, arg2, arg3, arg4, arg5, arg6]);
        }
      };
      emitter.on = function on(event, fn) {
        if (!_fns[event]) {
          _fns[event] = [];
        }
        _fns[event].push(fn);
      };
      emitter.once = function once(event, fn) {
        function one() {
          fn.apply(this, arguments);
          emitter.off(event, one);
        }
        this.on(event, one);
      };
      emitter.off = function off(event, fn) {
        var keep = [];
        if (event && fn) {
          var fns = this._fns[event];
          var i4 = 0;
          var l4 = fns ? fns.length : 0;
          for (i4; i4 < l4; i4++) {
            if (fns[i4] !== fn) {
              keep.push(fns[i4]);
            }
          }
        }
        keep.length ? this._fns[event] = keep : delete this._fns[event];
      };
      function getListeners(e4) {
        var out = _fns[e4] ? _fns[e4] : [];
        var idx = e4.indexOf(":");
        var args = idx === -1 ? [e4] : [e4.substring(0, idx), e4.substring(idx + 1)];
        var keys = Object.keys(_fns);
        var i4 = 0;
        var l4 = keys.length;
        for (i4; i4 < l4; i4++) {
          var key = keys[i4];
          if (key === "*") {
            out = out.concat(_fns[key]);
          }
          if (args.length === 2 && args[0] === key) {
            out = out.concat(_fns[key]);
            break;
          }
        }
        return out;
      }
      function emitAll(e4, fns, args) {
        var i4 = 0;
        var l4 = fns.length;
        for (i4; i4 < l4; i4++) {
          if (!fns[i4])
            break;
          fns[i4].event = e4;
          fns[i4].apply(fns[i4], args);
        }
      }
      return emitter;
    };
  }
});

// ../../node_modules/react-is/cjs/react-is.production.min.js
var require_react_is_production_min = __commonJS({
  "../../node_modules/react-is/cjs/react-is.production.min.js"(exports) {
    "use strict";
    var b3 = "function" === typeof Symbol && Symbol.for;
    var c4 = b3 ? Symbol.for("react.element") : 60103;
    var d4 = b3 ? Symbol.for("react.portal") : 60106;
    var e4 = b3 ? Symbol.for("react.fragment") : 60107;
    var f4 = b3 ? Symbol.for("react.strict_mode") : 60108;
    var g3 = b3 ? Symbol.for("react.profiler") : 60114;
    var h11 = b3 ? Symbol.for("react.provider") : 60109;
    var k4 = b3 ? Symbol.for("react.context") : 60110;
    var l4 = b3 ? Symbol.for("react.async_mode") : 60111;
    var m4 = b3 ? Symbol.for("react.concurrent_mode") : 60111;
    var n3 = b3 ? Symbol.for("react.forward_ref") : 60112;
    var p4 = b3 ? Symbol.for("react.suspense") : 60113;
    var q4 = b3 ? Symbol.for("react.suspense_list") : 60120;
    var r4 = b3 ? Symbol.for("react.memo") : 60115;
    var t4 = b3 ? Symbol.for("react.lazy") : 60116;
    var v4 = b3 ? Symbol.for("react.block") : 60121;
    var w4 = b3 ? Symbol.for("react.fundamental") : 60117;
    var x4 = b3 ? Symbol.for("react.responder") : 60118;
    var y4 = b3 ? Symbol.for("react.scope") : 60119;
    function z10(a4) {
      if ("object" === typeof a4 && null !== a4) {
        var u4 = a4.$$typeof;
        switch (u4) {
          case c4:
            switch (a4 = a4.type, a4) {
              case l4:
              case m4:
              case e4:
              case g3:
              case f4:
              case p4:
                return a4;
              default:
                switch (a4 = a4 && a4.$$typeof, a4) {
                  case k4:
                  case n3:
                  case t4:
                  case r4:
                  case h11:
                    return a4;
                  default:
                    return u4;
                }
            }
          case d4:
            return u4;
        }
      }
    }
    function A3(a4) {
      return z10(a4) === m4;
    }
    exports.AsyncMode = l4;
    exports.ConcurrentMode = m4;
    exports.ContextConsumer = k4;
    exports.ContextProvider = h11;
    exports.Element = c4;
    exports.ForwardRef = n3;
    exports.Fragment = e4;
    exports.Lazy = t4;
    exports.Memo = r4;
    exports.Portal = d4;
    exports.Profiler = g3;
    exports.StrictMode = f4;
    exports.Suspense = p4;
    exports.isAsyncMode = function(a4) {
      return A3(a4) || z10(a4) === l4;
    };
    exports.isConcurrentMode = A3;
    exports.isContextConsumer = function(a4) {
      return z10(a4) === k4;
    };
    exports.isContextProvider = function(a4) {
      return z10(a4) === h11;
    };
    exports.isElement = function(a4) {
      return "object" === typeof a4 && null !== a4 && a4.$$typeof === c4;
    };
    exports.isForwardRef = function(a4) {
      return z10(a4) === n3;
    };
    exports.isFragment = function(a4) {
      return z10(a4) === e4;
    };
    exports.isLazy = function(a4) {
      return z10(a4) === t4;
    };
    exports.isMemo = function(a4) {
      return z10(a4) === r4;
    };
    exports.isPortal = function(a4) {
      return z10(a4) === d4;
    };
    exports.isProfiler = function(a4) {
      return z10(a4) === g3;
    };
    exports.isStrictMode = function(a4) {
      return z10(a4) === f4;
    };
    exports.isSuspense = function(a4) {
      return z10(a4) === p4;
    };
    exports.isValidElementType = function(a4) {
      return "string" === typeof a4 || "function" === typeof a4 || a4 === e4 || a4 === m4 || a4 === g3 || a4 === f4 || a4 === p4 || a4 === q4 || "object" === typeof a4 && null !== a4 && (a4.$$typeof === t4 || a4.$$typeof === r4 || a4.$$typeof === h11 || a4.$$typeof === k4 || a4.$$typeof === n3 || a4.$$typeof === w4 || a4.$$typeof === x4 || a4.$$typeof === y4 || a4.$$typeof === v4);
    };
    exports.typeOf = z10;
  }
});

// ../../node_modules/react-is/cjs/react-is.development.js
var require_react_is_development = __commonJS({
  "../../node_modules/react-is/cjs/react-is.development.js"(exports) {
    "use strict";
    if (process.env.NODE_ENV !== "production") {
      (function() {
        "use strict";
        var hasSymbol = typeof Symbol === "function" && Symbol.for;
        var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103;
        var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
        var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107;
        var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
        var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
        var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
        var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
        var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
        var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
        var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
        var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
        var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
        var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
        var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
        var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
        var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
        var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
        var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
        function isValidElementType(type) {
          return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
          type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
        }
        function typeOf(object23) {
          if (typeof object23 === "object" && object23 !== null) {
            var $$typeof = object23.$$typeof;
            switch ($$typeof) {
              case REACT_ELEMENT_TYPE:
                var type = object23.type;
                switch (type) {
                  case REACT_ASYNC_MODE_TYPE:
                  case REACT_CONCURRENT_MODE_TYPE:
                  case REACT_FRAGMENT_TYPE:
                  case REACT_PROFILER_TYPE:
                  case REACT_STRICT_MODE_TYPE:
                  case REACT_SUSPENSE_TYPE:
                    return type;
                  default:
                    var $$typeofType = type && type.$$typeof;
                    switch ($$typeofType) {
                      case REACT_CONTEXT_TYPE:
                      case REACT_FORWARD_REF_TYPE:
                      case REACT_LAZY_TYPE:
                      case REACT_MEMO_TYPE:
                      case REACT_PROVIDER_TYPE:
                        return $$typeofType;
                      default:
                        return $$typeof;
                    }
                }
              case REACT_PORTAL_TYPE:
                return $$typeof;
            }
          }
          return void 0;
        }
        var AsyncMode = REACT_ASYNC_MODE_TYPE;
        var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
        var ContextConsumer = REACT_CONTEXT_TYPE;
        var ContextProvider = REACT_PROVIDER_TYPE;
        var Element2 = REACT_ELEMENT_TYPE;
        var ForwardRef = REACT_FORWARD_REF_TYPE;
        var Fragment116 = REACT_FRAGMENT_TYPE;
        var Lazy = REACT_LAZY_TYPE;
        var Memo = REACT_MEMO_TYPE;
        var Portal = REACT_PORTAL_TYPE;
        var Profiler = REACT_PROFILER_TYPE;
        var StrictMode = REACT_STRICT_MODE_TYPE;
        var Suspense151 = REACT_SUSPENSE_TYPE;
        var hasWarnedAboutDeprecatedIsAsyncMode = false;
        function isAsyncMode(object23) {
          {
            if (!hasWarnedAboutDeprecatedIsAsyncMode) {
              hasWarnedAboutDeprecatedIsAsyncMode = true;
              console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
            }
          }
          return isConcurrentMode(object23) || typeOf(object23) === REACT_ASYNC_MODE_TYPE;
        }
        function isConcurrentMode(object23) {
          return typeOf(object23) === REACT_CONCURRENT_MODE_TYPE;
        }
        function isContextConsumer(object23) {
          return typeOf(object23) === REACT_CONTEXT_TYPE;
        }
        function isContextProvider(object23) {
          return typeOf(object23) === REACT_PROVIDER_TYPE;
        }
        function isElement(object23) {
          return typeof object23 === "object" && object23 !== null && object23.$$typeof === REACT_ELEMENT_TYPE;
        }
        function isForwardRef(object23) {
          return typeOf(object23) === REACT_FORWARD_REF_TYPE;
        }
        function isFragment(object23) {
          return typeOf(object23) === REACT_FRAGMENT_TYPE;
        }
        function isLazy(object23) {
          return typeOf(object23) === REACT_LAZY_TYPE;
        }
        function isMemo(object23) {
          return typeOf(object23) === REACT_MEMO_TYPE;
        }
        function isPortal(object23) {
          return typeOf(object23) === REACT_PORTAL_TYPE;
        }
        function isProfiler(object23) {
          return typeOf(object23) === REACT_PROFILER_TYPE;
        }
        function isStrictMode(object23) {
          return typeOf(object23) === REACT_STRICT_MODE_TYPE;
        }
        function isSuspense(object23) {
          return typeOf(object23) === REACT_SUSPENSE_TYPE;
        }
        exports.AsyncMode = AsyncMode;
        exports.ConcurrentMode = ConcurrentMode;
        exports.ContextConsumer = ContextConsumer;
        exports.ContextProvider = ContextProvider;
        exports.Element = Element2;
        exports.ForwardRef = ForwardRef;
        exports.Fragment = Fragment116;
        exports.Lazy = Lazy;
        exports.Memo = Memo;
        exports.Portal = Portal;
        exports.Profiler = Profiler;
        exports.StrictMode = StrictMode;
        exports.Suspense = Suspense151;
        exports.isAsyncMode = isAsyncMode;
        exports.isConcurrentMode = isConcurrentMode;
        exports.isContextConsumer = isContextConsumer;
        exports.isContextProvider = isContextProvider;
        exports.isElement = isElement;
        exports.isForwardRef = isForwardRef;
        exports.isFragment = isFragment;
        exports.isLazy = isLazy;
        exports.isMemo = isMemo;
        exports.isPortal = isPortal;
        exports.isProfiler = isProfiler;
        exports.isStrictMode = isStrictMode;
        exports.isSuspense = isSuspense;
        exports.isValidElementType = isValidElementType;
        exports.typeOf = typeOf;
      })();
    }
  }
});

// ../../node_modules/react-is/index.js
var require_react_is = __commonJS({
  "../../node_modules/react-is/index.js"(exports, module) {
    "use strict";
    if (process.env.NODE_ENV === "production") {
      module.exports = require_react_is_production_min();
    } else {
      module.exports = require_react_is_development();
    }
  }
});

// ../../node_modules/object-assign/index.js
var require_object_assign = __commonJS({
  "../../node_modules/object-assign/index.js"(exports, module) {
    "use strict";
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var propIsEnumerable = Object.prototype.propertyIsEnumerable;
    function toObject(val) {
      if (val === null || val === void 0) {
        throw new TypeError("Object.assign cannot be called with null or undefined");
      }
      return Object(val);
    }
    function shouldUseNative() {
      try {
        if (!Object.assign) {
          return false;
        }
        var test1 = new String("abc");
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") {
          return false;
        }
        var test2 = {};
        for (var i4 = 0; i4 < 10; i4++) {
          test2["_" + String.fromCharCode(i4)] = i4;
        }
        var order2 = Object.getOwnPropertyNames(test2).map(function(n3) {
          return test2[n3];
        });
        if (order2.join("") !== "0123456789") {
          return false;
        }
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
          test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
          return false;
        }
        return true;
      } catch (err) {
        return false;
      }
    }
    module.exports = shouldUseNative() ? Object.assign : function(target, source) {
      var from;
      var to = toObject(target);
      var symbols;
      for (var s4 = 1; s4 < arguments.length; s4++) {
        from = Object(arguments[s4]);
        for (var key in from) {
          if (hasOwnProperty.call(from, key)) {
            to[key] = from[key];
          }
        }
        if (getOwnPropertySymbols) {
          symbols = getOwnPropertySymbols(from);
          for (var i4 = 0; i4 < symbols.length; i4++) {
            if (propIsEnumerable.call(from, symbols[i4])) {
              to[symbols[i4]] = from[symbols[i4]];
            }
          }
        }
      }
      return to;
    };
  }
});

// ../../node_modules/prop-types/lib/ReactPropTypesSecret.js
var require_ReactPropTypesSecret = __commonJS({
  "../../node_modules/prop-types/lib/ReactPropTypesSecret.js"(exports, module) {
    "use strict";
    var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    module.exports = ReactPropTypesSecret;
  }
});

// ../../node_modules/prop-types/lib/has.js
var require_has = __commonJS({
  "../../node_modules/prop-types/lib/has.js"(exports, module) {
    "use strict";
    module.exports = Function.call.bind(Object.prototype.hasOwnProperty);
  }
});

// ../../node_modules/prop-types/checkPropTypes.js
var require_checkPropTypes = __commonJS({
  "../../node_modules/prop-types/checkPropTypes.js"(exports, module) {
    "use strict";
    var printWarning = function() {
    };
    if (process.env.NODE_ENV !== "production") {
      ReactPropTypesSecret = require_ReactPropTypesSecret();
      loggedTypeFailures = {};
      has3 = require_has();
      printWarning = function(text) {
        var message = "Warning: " + text;
        if (typeof console !== "undefined") {
          console.error(message);
        }
        try {
          throw new Error(message);
        } catch (x4) {
        }
      };
    }
    var ReactPropTypesSecret;
    var loggedTypeFailures;
    var has3;
    function checkPropTypes(typeSpecs, values, location2, componentName, getStack) {
      if (process.env.NODE_ENV !== "production") {
        for (var typeSpecName in typeSpecs) {
          if (has3(typeSpecs, typeSpecName)) {
            var error;
            try {
              if (typeof typeSpecs[typeSpecName] !== "function") {
                var err = Error(
                  (componentName || "React class") + ": " + location2 + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
                );
                err.name = "Invariant Violation";
                throw err;
              }
              error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location2, null, ReactPropTypesSecret);
            } catch (ex) {
              error = ex;
            }
            if (error && !(error instanceof Error)) {
              printWarning(
                (componentName || "React class") + ": type specification of " + location2 + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
              );
            }
            if (error instanceof Error && !(error.message in loggedTypeFailures)) {
              loggedTypeFailures[error.message] = true;
              var stack = getStack ? getStack() : "";
              printWarning(
                "Failed " + location2 + " type: " + error.message + (stack != null ? stack : "")
              );
            }
          }
        }
      }
    }
    checkPropTypes.resetWarningCache = function() {
      if (process.env.NODE_ENV !== "production") {
        loggedTypeFailures = {};
      }
    };
    module.exports = checkPropTypes;
  }
});

// ../../node_modules/prop-types/factoryWithTypeCheckers.js
var require_factoryWithTypeCheckers = __commonJS({
  "../../node_modules/prop-types/factoryWithTypeCheckers.js"(exports, module) {
    "use strict";
    var ReactIs = require_react_is();
    var assign2 = require_object_assign();
    var ReactPropTypesSecret = require_ReactPropTypesSecret();
    var has3 = require_has();
    var checkPropTypes = require_checkPropTypes();
    var printWarning = function() {
    };
    if (process.env.NODE_ENV !== "production") {
      printWarning = function(text) {
        var message = "Warning: " + text;
        if (typeof console !== "undefined") {
          console.error(message);
        }
        try {
          throw new Error(message);
        } catch (x4) {
        }
      };
    }
    function emptyFunctionThatReturnsNull() {
      return null;
    }
    module.exports = function(isValidElement8, throwOnDirectAccess) {
      var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = "@@iterator";
      function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === "function") {
          return iteratorFn;
        }
      }
      var ANONYMOUS = "<<anonymous>>";
      var ReactPropTypes = {
        array: createPrimitiveTypeChecker("array"),
        bigint: createPrimitiveTypeChecker("bigint"),
        bool: createPrimitiveTypeChecker("boolean"),
        func: createPrimitiveTypeChecker("function"),
        number: createPrimitiveTypeChecker("number"),
        object: createPrimitiveTypeChecker("object"),
        string: createPrimitiveTypeChecker("string"),
        symbol: createPrimitiveTypeChecker("symbol"),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        elementType: createElementTypeTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
      };
      function is(x4, y4) {
        if (x4 === y4) {
          return x4 !== 0 || 1 / x4 === 1 / y4;
        } else {
          return x4 !== x4 && y4 !== y4;
        }
      }
      function PropTypeError(message, data) {
        this.message = message;
        this.data = data && typeof data === "object" ? data : {};
        this.stack = "";
      }
      PropTypeError.prototype = Error.prototype;
      function createChainableTypeChecker(validate) {
        if (process.env.NODE_ENV !== "production") {
          var manualPropTypeCallCache = {};
          var manualPropTypeWarningCount = 0;
        }
        function checkType(isRequired, props, propName, componentName, location2, propFullName, secret) {
          componentName = componentName || ANONYMOUS;
          propFullName = propFullName || propName;
          if (secret !== ReactPropTypesSecret) {
            if (throwOnDirectAccess) {
              var err = new Error(
                "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
              );
              err.name = "Invariant Violation";
              throw err;
            } else if (process.env.NODE_ENV !== "production" && typeof console !== "undefined") {
              var cacheKey = componentName + ":" + propName;
              if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
              manualPropTypeWarningCount < 3) {
                printWarning(
                  "You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
                );
                manualPropTypeCallCache[cacheKey] = true;
                manualPropTypeWarningCount++;
              }
            }
          }
          if (props[propName] == null) {
            if (isRequired) {
              if (props[propName] === null) {
                return new PropTypeError("The " + location2 + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
              }
              return new PropTypeError("The " + location2 + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
            }
            return null;
          } else {
            return validate(props, propName, componentName, location2, propFullName);
          }
        }
        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
      }
      function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location2, propFullName, secret) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== expectedType) {
            var preciseType = getPreciseType(propValue);
            return new PropTypeError(
              "Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."),
              { expectedType }
            );
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createAnyTypeChecker() {
        return createChainableTypeChecker(emptyFunctionThatReturnsNull);
      }
      function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location2, propFullName) {
          if (typeof typeChecker !== "function") {
            return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
          }
          var propValue = props[propName];
          if (!Array.isArray(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
          }
          for (var i4 = 0; i4 < propValue.length; i4++) {
            var error = typeChecker(propValue, i4, componentName, location2, propFullName + "[" + i4 + "]", ReactPropTypesSecret);
            if (error instanceof Error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createElementTypeChecker() {
        function validate(props, propName, componentName, location2, propFullName) {
          var propValue = props[propName];
          if (!isValidElement8(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createElementTypeTypeChecker() {
        function validate(props, propName, componentName, location2, propFullName) {
          var propValue = props[propName];
          if (!ReactIs.isValidElementType(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location2, propFullName) {
          if (!(props[propName] instanceof expectedClass)) {
            var expectedClassName = expectedClass.name || ANONYMOUS;
            var actualClassName = getClassName(props[propName]);
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) {
          if (process.env.NODE_ENV !== "production") {
            if (arguments.length > 1) {
              printWarning(
                "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
              );
            } else {
              printWarning("Invalid argument supplied to oneOf, expected an array.");
            }
          }
          return emptyFunctionThatReturnsNull;
        }
        function validate(props, propName, componentName, location2, propFullName) {
          var propValue = props[propName];
          for (var i4 = 0; i4 < expectedValues.length; i4++) {
            if (is(propValue, expectedValues[i4])) {
              return null;
            }
          }
          var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
            var type = getPreciseType(value);
            if (type === "symbol") {
              return String(value);
            }
            return value;
          });
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
        }
        return createChainableTypeChecker(validate);
      }
      function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location2, propFullName) {
          if (typeof typeChecker !== "function") {
            return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
          }
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
          }
          for (var key in propValue) {
            if (has3(propValue, key)) {
              var error = typeChecker(propValue, key, componentName, location2, propFullName + "." + key, ReactPropTypesSecret);
              if (error instanceof Error) {
                return error;
              }
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) {
          process.env.NODE_ENV !== "production" ? printWarning("Invalid argument supplied to oneOfType, expected an instance of array.") : void 0;
          return emptyFunctionThatReturnsNull;
        }
        for (var i4 = 0; i4 < arrayOfTypeCheckers.length; i4++) {
          var checker = arrayOfTypeCheckers[i4];
          if (typeof checker !== "function") {
            printWarning(
              "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i4 + "."
            );
            return emptyFunctionThatReturnsNull;
          }
        }
        function validate(props, propName, componentName, location2, propFullName) {
          var expectedTypes = [];
          for (var i5 = 0; i5 < arrayOfTypeCheckers.length; i5++) {
            var checker2 = arrayOfTypeCheckers[i5];
            var checkerResult = checker2(props, propName, componentName, location2, propFullName, ReactPropTypesSecret);
            if (checkerResult == null) {
              return null;
            }
            if (checkerResult.data && has3(checkerResult.data, "expectedType")) {
              expectedTypes.push(checkerResult.data.expectedType);
            }
          }
          var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
        }
        return createChainableTypeChecker(validate);
      }
      function createNodeChecker() {
        function validate(props, propName, componentName, location2, propFullName) {
          if (!isNode(props[propName])) {
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function invalidValidatorError(componentName, location2, propFullName, key, type) {
        return new PropTypeError(
          (componentName || "React class") + ": " + location2 + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type + "`."
        );
      }
      function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location2, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
          }
          for (var key in shapeTypes) {
            var checker = shapeTypes[key];
            if (typeof checker !== "function") {
              return invalidValidatorError(componentName, location2, propFullName, key, getPreciseType(checker));
            }
            var error = checker(propValue, key, componentName, location2, propFullName + "." + key, ReactPropTypesSecret);
            if (error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location2, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
          }
          var allKeys = assign2({}, props[propName], shapeTypes);
          for (var key in allKeys) {
            var checker = shapeTypes[key];
            if (has3(shapeTypes, key) && typeof checker !== "function") {
              return invalidValidatorError(componentName, location2, propFullName, key, getPreciseType(checker));
            }
            if (!checker) {
              return new PropTypeError(
                "Invalid " + location2 + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  ")
              );
            }
            var error = checker(propValue, key, componentName, location2, propFullName + "." + key, ReactPropTypesSecret);
            if (error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function isNode(propValue) {
        switch (typeof propValue) {
          case "number":
          case "string":
          case "undefined":
            return true;
          case "boolean":
            return !propValue;
          case "object":
            if (Array.isArray(propValue)) {
              return propValue.every(isNode);
            }
            if (propValue === null || isValidElement8(propValue)) {
              return true;
            }
            var iteratorFn = getIteratorFn(propValue);
            if (iteratorFn) {
              var iterator = iteratorFn.call(propValue);
              var step;
              if (iteratorFn !== propValue.entries) {
                while (!(step = iterator.next()).done) {
                  if (!isNode(step.value)) {
                    return false;
                  }
                }
              } else {
                while (!(step = iterator.next()).done) {
                  var entry = step.value;
                  if (entry) {
                    if (!isNode(entry[1])) {
                      return false;
                    }
                  }
                }
              }
            } else {
              return false;
            }
            return true;
          default:
            return false;
        }
      }
      function isSymbol(propType, propValue) {
        if (propType === "symbol") {
          return true;
        }
        if (!propValue) {
          return false;
        }
        if (propValue["@@toStringTag"] === "Symbol") {
          return true;
        }
        if (typeof Symbol === "function" && propValue instanceof Symbol) {
          return true;
        }
        return false;
      }
      function getPropType(propValue) {
        var propType = typeof propValue;
        if (Array.isArray(propValue)) {
          return "array";
        }
        if (propValue instanceof RegExp) {
          return "object";
        }
        if (isSymbol(propType, propValue)) {
          return "symbol";
        }
        return propType;
      }
      function getPreciseType(propValue) {
        if (typeof propValue === "undefined" || propValue === null) {
          return "" + propValue;
        }
        var propType = getPropType(propValue);
        if (propType === "object") {
          if (propValue instanceof Date) {
            return "date";
          } else if (propValue instanceof RegExp) {
            return "regexp";
          }
        }
        return propType;
      }
      function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);
        switch (type) {
          case "array":
          case "object":
            return "an " + type;
          case "boolean":
          case "date":
          case "regexp":
            return "a " + type;
          default:
            return type;
        }
      }
      function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) {
          return ANONYMOUS;
        }
        return propValue.constructor.name;
      }
      ReactPropTypes.checkPropTypes = checkPropTypes;
      ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
      ReactPropTypes.PropTypes = ReactPropTypes;
      return ReactPropTypes;
    };
  }
});

// ../../node_modules/prop-types/factoryWithThrowingShims.js
var require_factoryWithThrowingShims = __commonJS({
  "../../node_modules/prop-types/factoryWithThrowingShims.js"(exports, module) {
    "use strict";
    var ReactPropTypesSecret = require_ReactPropTypesSecret();
    function emptyFunction() {
    }
    function emptyFunctionWithReset() {
    }
    emptyFunctionWithReset.resetWarningCache = emptyFunction;
    module.exports = function() {
      function shim(props, propName, componentName, location2, propFullName, secret) {
        if (secret === ReactPropTypesSecret) {
          return;
        }
        var err = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        err.name = "Invariant Violation";
        throw err;
      }
      ;
      shim.isRequired = shim;
      function getShim() {
        return shim;
      }
      ;
      var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
      };
      ReactPropTypes.PropTypes = ReactPropTypes;
      return ReactPropTypes;
    };
  }
});

// ../../node_modules/prop-types/index.js
var require_prop_types = __commonJS({
  "../../node_modules/prop-types/index.js"(exports, module) {
    "use strict";
    if (process.env.NODE_ENV !== "production") {
      ReactIs = require_react_is();
      throwOnDirectAccess = true;
      module.exports = require_factoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
    } else {
      module.exports = require_factoryWithThrowingShims()();
    }
    var ReactIs;
    var throwOnDirectAccess;
  }
});

// ../../node_modules/classnames/index.js
var require_classnames = __commonJS({
  "../../node_modules/classnames/index.js"(exports, module) {
    "use strict";
    (function() {
      "use strict";
      var hasOwn = {}.hasOwnProperty;
      function classNames50() {
        var classes = "";
        for (var i4 = 0; i4 < arguments.length; i4++) {
          var arg = arguments[i4];
          if (arg) {
            classes = appendClass(classes, parseValue(arg));
          }
        }
        return classes;
      }
      function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") {
          return arg;
        }
        if (typeof arg !== "object") {
          return "";
        }
        if (Array.isArray(arg)) {
          return classNames50.apply(null, arg);
        }
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
          return arg.toString();
        }
        var classes = "";
        for (var key in arg) {
          if (hasOwn.call(arg, key) && arg[key]) {
            classes = appendClass(classes, key);
          }
        }
        return classes;
      }
      function appendClass(value, newClass) {
        if (!newClass) {
          return value;
        }
        if (value) {
          return value + " " + newClass;
        }
        return value + newClass;
      }
      if (typeof module !== "undefined" && module.exports) {
        classNames50.default = classNames50;
        module.exports = classNames50;
      } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) {
        define("classnames", [], function() {
          return classNames50;
        });
      } else {
        window.classNames = classNames50;
      }
    })();
  }
});

// ../../node_modules/@transloadit/prettier-bytes/dist/prettierBytes.js
var require_prettierBytes = __commonJS({
  "../../node_modules/@transloadit/prettier-bytes/dist/prettierBytes.js"(exports, module) {
    "use strict";
    module.exports = function prettierBytes2(num) {
      if (typeof num !== "number" || Number.isNaN(num)) {
        throw new TypeError(`Expected a number, got ${typeof num}`);
      }
      const neg = num < 0;
      const units = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
      if (neg) {
        num = -num;
      }
      if (num < 1) {
        return `${(neg ? "-" : "") + num} B`;
      }
      const exponent = Math.min(Math.floor(Math.log(num) / Math.log(1024)), units.length - 1);
      num = Number(num / 1024 ** exponent);
      const unit = units[exponent];
      if (num >= 10 || num % 1 === 0) {
        return `${(neg ? "-" : "") + num.toFixed(0)} ${unit}`;
      }
      return `${(neg ? "-" : "") + num.toFixed(1)} ${unit}`;
    };
  }
});

// ../../node_modules/@emotion/memoize/dist/memoize.esm.js
function memoize(fn) {
  var cache = {};
  return function(arg) {
    if (cache[arg] === void 0)
      cache[arg] = fn(arg);
    return cache[arg];
  };
}
var memoize_esm_default;
var init_memoize_esm = __esm({
  "../../node_modules/@emotion/memoize/dist/memoize.esm.js"() {
    "use strict";
    memoize_esm_default = memoize;
  }
});

// ../../node_modules/@emotion/is-prop-valid/dist/is-prop-valid.esm.js
var is_prop_valid_esm_exports = {};
__export(is_prop_valid_esm_exports, {
  default: () => is_prop_valid_esm_default
});
var reactPropsRegex, index, is_prop_valid_esm_default;
var init_is_prop_valid_esm = __esm({
  "../../node_modules/@emotion/is-prop-valid/dist/is-prop-valid.esm.js"() {
    "use strict";
    init_memoize_esm();
    reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/;
    index = memoize_esm_default(
      function(prop) {
        return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
      }
      /* Z+1 */
    );
    is_prop_valid_esm_default = index;
  }
});

// src/applications/components/__generated__/ApplicationActions_application.graphql.ts
var node = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ApplicationActions_application",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "applicationStateName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "workflowStateName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Vacancy",
        "kind": "LinkedField",
        "name": "vacancy",
        "plural": false,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerName",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Application",
    "abstractKey": null
  };
}();
node.hash = "3a95052f62cc4087fa7030676ad0682d";
var ApplicationActions_application_graphql_default = node;

// src/applications/components/ApplicationActions.tsx
import { useFragment } from "react-relay";
import { Button } from "shared-ui";
import { jsx } from "react/jsx-runtime";
var applicationFragment = ApplicationActions_application_graphql_default;
var ApplicationActions = ({
  application: application3,
  onWithdraw
}) => {
  const data = useFragment(applicationFragment, application3);
  if (data.applicationStateName === "Active") {
    return /* @__PURE__ */ jsx("div", { className: "flex items-center space-x-4", children: /* @__PURE__ */ jsx(Button, { clicked: onWithdraw, children: "Withdraw Application" }) });
  }
  return /* @__PURE__ */ jsx("div", { className: "flex items-center space-x-4", children: /* @__PURE__ */ jsx("p", { children: "No actions" }) });
};

// src/applications/components/__generated__/ApplicationApplyWorkflow_candidate.graphql.ts
var node2 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ApplicationApplyWorkflow_candidate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasAgreedToTerms",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isGdprConsented",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isEmailVerified",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAnonymised",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSuspended",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CandidateAccountEmailVerifyForm_account"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CandidateAccountGDPRConsentForm_account"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CandidateAccountTermsForm_account"
    }
  ],
  "type": "AccountsCandidateAccount",
  "abstractKey": null
};
node2.hash = "f9b8cdef88bd33a99913efd11f339853";
var ApplicationApplyWorkflow_candidate_graphql_default = node2;

// src/applications/components/__generated__/ApplicationApplyWorkflow_profile.graphql.ts
var node3 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ApplicationApplyWorkflow_profile",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "recruitProfileId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitResume",
        "kind": "LinkedField",
        "name": "resume",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "resumeId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "addedToProfile",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasExperienceToClarify",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasExperienceToImport",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasValidExperience",
            "storageKey": null
          },
          v0
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitProfileSummary",
        "kind": "LinkedField",
        "name": "summary",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currentJobTitleName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "prefersNoResume",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "statementWhatYouDo",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "statementWhatYouWant",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "statementYourExperience",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RightToWork",
        "kind": "LinkedField",
        "name": "rightToWork",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "countryIso3",
            "storageKey": null
          },
          v0
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "ApplicationRateEditor_RecruitProfile"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "ApplicationRightToWorkEditor_RecruitProfile"
      }
    ],
    "type": "RecruitProfile",
    "abstractKey": null
  };
}();
node3.hash = "cf571868e75936c0997f164c73f67ec4";
var ApplicationApplyWorkflow_profile_graphql_default = node3;

// src/applications/components/__generated__/ApplicationApplyWorkflow_application.graphql.ts
var node4 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currencyCode",
    "storageKey": null
  }, v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "payType",
    "storageKey": null
  }, v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "max",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "min",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ApplicationApplyWorkflow_application",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "applicationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "version",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "employerId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "employerName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "vacancyName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "applicationStateName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "workflowStateName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "appliedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "completedByCandidateAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "declinedByCandidateAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "declinedByEmployerAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hiredAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasCompletedDocumentTypes",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasCompletedForms",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasCompletedRequiredSkills",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasCompletedOptionalSkills",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasCompletedRate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rightToWorkStatus",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ApplicationCandidateRate",
        "kind": "LinkedField",
        "name": "candidateRate",
        "plural": false,
        "selections": [
          v0,
          v1,
          v23,
          v32
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Vacancy",
        "kind": "LinkedField",
        "name": "vacancy",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "VacancyRate",
            "kind": "LinkedField",
            "name": "rate",
            "plural": false,
            "selections": [
              v23,
              v32,
              v0,
              v1,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currencyCountry",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isPrivate",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LocationCriteria",
            "kind": "LinkedField",
            "name": "locations",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "countryCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "countryName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "entireCountry",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "latitude",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "longitude",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "radius",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "state",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "ApplicationRightToWorkEditor_application"
      }
    ],
    "type": "Application",
    "abstractKey": null
  };
}();
node4.hash = "d78a1793d23d429ea91485cd6cf29df7";
var ApplicationApplyWorkflow_application_graphql_default = node4;

// src/applications/components/ApplicationApplyWorkflow.tsx
import { useMemo as useMemo38 } from "react";
import { useFragment as useFragment115 } from "react-relay";
import { useLogger as useLogger26, useUserErrorCode as useUserErrorCode7 } from "shared-lib";
import {
  CandidateAccountEmailVerifyForm as CandidateAccountEmailVerifyForm2,
  CandidateAccountGDPRConsentForm,
  CandidateAccountTermsForm
} from "feature-candidate-accounts";

// src/applications/lib/ApplicationWorkflowModel.ts
import { LogLevel } from "shared-lib";

// src/applications/lib/ApplicationApplyStates.ts
var ApplicationApplyStates = /* @__PURE__ */ ((ApplicationApplyStates2) => {
  ApplicationApplyStates2["TermsAndConditionsConsent"] = "TermsAndConditionsConsent";
  ApplicationApplyStates2["GdprConsent"] = "GdprConsent";
  ApplicationApplyStates2["EmailAddressConfirm"] = "EmailAddressConfirm";
  ApplicationApplyStates2["Submit"] = "Submit";
  ApplicationApplyStates2["ResumeUpload"] = "ResumeUpload";
  ApplicationApplyStates2["RateClarification"] = "RateClarification";
  ApplicationApplyStates2["RightToWork"] = "RightToWork";
  ApplicationApplyStates2["ResumeImport"] = "ResumeImport";
  ApplicationApplyStates2["Completed"] = "Completed";
  return ApplicationApplyStates2;
})(ApplicationApplyStates || {});

// src/applications/lib/ApplicationRates.ts
var RateValue = class {
  constructor(rate) {
    this.exact = 0;
    this.rate = rate || 0;
    this.exact = rate || 0;
  }
  get rounded() {
    return Math.round(this.exact);
  }
};
var _CandidateRate = class _CandidateRate {
  constructor(candidateId = "", min = 0, desired = 0, payType = "PER_DAY", isPrivate = false, currencyCode = "", currencySymbol = "", currencyName = "", currencyCountryCode = "") {
    this.candidateId = candidateId;
    this.min = min;
    this.desired = desired;
    this.payType = payType;
    this.isPrivate = isPrivate;
    this.currencyCode = currencyCode;
    this.currencySymbol = currencySymbol;
    this.currencyName = currencyName;
    this.currencyCountryCode = currencyCountryCode;
    this.isInFlight = false;
    this.currencyCountryName = "";
    this.matchedWithVacancy = null;
  }
  static isGreaterThan(rateOneValue, rateOnePayType, rateTwoValue, rateTwoPayType) {
    const convRateOne = _CandidateRate.convert(
      rateOnePayType,
      "PER_DAY",
      rateOneValue
    );
    const convRateTwo = _CandidateRate.convert(
      rateTwoPayType,
      "PER_DAY",
      rateTwoValue
    );
    return convRateOne.rate > convRateTwo.rate;
  }
  static convert(fromFrequency, toFrequency, rate) {
    if (fromFrequency === toFrequency) {
      return rate;
    } else {
      if (fromFrequency === "PER_HOUR") {
        return toFrequency === "PER_DAY" ? _CandidateRate.convertHourlyToDaily(rate) : _CandidateRate.convertHourlyToAnnually(rate);
      } else if (fromFrequency === "PER_DAY") {
        return toFrequency === "PER_HOUR" ? _CandidateRate.convertDailyToHourly(rate) : _CandidateRate.convertDailyToAnnually(rate);
      } else {
        return toFrequency === "PER_HOUR" ? _CandidateRate.convertAnnualToHourly(rate) : _CandidateRate.convertAnnualToDaily(rate);
      }
    }
  }
  static convertDailyToHourly(rate) {
    return new RateValue(rate.exact / _CandidateRate.WORKING_HOURS_PER_DAY);
  }
  static convertDailyToAnnually(rate) {
    return new RateValue(rate.exact * _CandidateRate.WORKING_DAYS_PER_YEAR);
  }
  static convertHourlyToDaily(rate) {
    return new RateValue(rate.exact * _CandidateRate.WORKING_HOURS_PER_DAY);
  }
  static convertHourlyToAnnually(rate) {
    return new RateValue(
      _CandidateRate.convertHourlyToDaily(rate).exact * _CandidateRate.WORKING_DAYS_PER_YEAR
    );
  }
  static convertAnnualToDaily(rate) {
    return new RateValue(rate.exact / _CandidateRate.WORKING_DAYS_PER_YEAR);
  }
  static convertAnnualToHourly(rate) {
    return new RateValue(
      _CandidateRate.convertAnnualToDaily(rate).exact / _CandidateRate.WORKING_HOURS_PER_DAY
    );
  }
};
_CandidateRate.WORKING_HOURS_PER_DAY = 8;
_CandidateRate.WORKING_DAYS_A_WEEK = 5;
_CandidateRate.WORKING_WEEKS_PER_YEAR = 48;
_CandidateRate.WORKING_DAYS_PER_YEAR = _CandidateRate.WORKING_DAYS_A_WEEK * _CandidateRate.WORKING_WEEKS_PER_YEAR;
var CandidateRate = _CandidateRate;

// src/applications/lib/ApplicationResumes.ts
import { atom, useRecoilState } from "recoil";
var ResumeImportStatus = /* @__PURE__ */ ((ResumeImportStatus3) => {
  ResumeImportStatus3[ResumeImportStatus3["NotStarted"] = 0] = "NotStarted";
  ResumeImportStatus3[ResumeImportStatus3["Uploaded"] = 1] = "Uploaded";
  ResumeImportStatus3[ResumeImportStatus3["NoResume"] = 2] = "NoResume";
  ResumeImportStatus3[ResumeImportStatus3["Failed"] = 3] = "Failed";
  return ResumeImportStatus3;
})(ResumeImportStatus || {});
var resumeWorkflowStateAtom = atom({
  key: "resumeWorkflow",
  default: {
    importStatus: 0 /* NotStarted */
  }
});
function useResumeWorkflowState() {
  const [resumeWorkflowState, setResumeWorkflowState] = useRecoilState(
    resumeWorkflowStateAtom
  );
  return [resumeWorkflowState, setResumeWorkflowState];
}
function requiresResumeImport(model, importStatus) {
  if (importStatus === 1 /* Uploaded */ || importStatus === 2 /* NoResume */) {
    return false;
  }
  if (model.resume && (model.resume.hasExperienceToClarify || model.resume.hasExperienceToImport)) {
    return true;
  }
  return false;
}
function requiresResumeUpload(model) {
  if (!model.resume && (!model.summary || model.summary.prefersNoResume === false)) {
    return true;
  }
  return false;
}
function isBusyWithResume(model, status) {
  if (!model.resume) {
    return false;
  }
  if (model.resume?.status === "COMPLETED" || model.resume?.status === "RESOLVED") {
    return false;
  }
  return status !== 1 /* Uploaded */;
}

// src/applications/lib/ApplicationWorkflowModel.ts
function applicationCanBeSubmitted(state) {
  return state.toLowerCase() === "created";
}
function logger(log, application3, candidate, profile, resumeImportStatus) {
  return (message) => {
    log(`workflow-apply state check`, LogLevel.INFO);
    log(application3, LogLevel.INFO);
    log(candidate, LogLevel.INFO);
    log(profile, LogLevel.INFO);
    log(resumeImportStatus, LogLevel.INFO);
    log(`workflow-apply: Message: ${message}`, LogLevel.INFO);
  };
}
function requiresRateClarification(model) {
  if (!model.candidateRate || !model.candidateRate.currencyCode || !model.candidateRate.payType || !model.candidateRate.max || model.candidateRate.max === 0 || !model.candidateRate.min || model.candidateRate.min === 0) {
    return true;
  }
  if (!model.vacancy.rate) {
    return false;
  }
  return model.vacancy.rate.isPrivate && !model.hasCompletedRate && (isApplicationRateTooHigh(
    model,
    model.candidateRate.min,
    model.candidateRate.payType
  ) || model.candidateRate.min === 0);
}
var candidateHasRight = (rights, vacancyLocations) => {
  if (vacancyLocations.length === 0) {
    return true;
  }
  let hasRight = false;
  if (rights.length > 0) {
    const vacancyLocation = vacancyLocations[0];
    hasRight = rights.some(
      (right) => right.countryIso3 === vacancyLocation.countryCode
    );
  }
  return hasRight;
};
function requiresRightToWorkClarification(model, profile) {
  const hasRightToWork = candidateHasRight(
    profile.rightToWork,
    model.vacancy.locations
  );
  return model.rightToWorkStatus === "NOT_SET" && hasRightToWork == false;
}
var isApplicationRateTooHigh = (model, candidateMin, candidatePayType) => {
  let isTooHigh = false;
  if (!model.vacancy.rate) {
    return false;
  }
  if (model.vacancy.rate.isPrivate) {
    const candidateMinRate = new RateValue(candidateMin);
    const vacancyMaxRate = new RateValue(model.vacancy.rate.max);
    isTooHigh = CandidateRate.isGreaterThan(
      candidateMinRate,
      candidatePayType,
      vacancyMaxRate,
      model.vacancy.rate.payType
    );
  }
  return isTooHigh;
};
function getApplicationState(log, application3, candidate, profile, resumeImportState) {
  const logStateChange = logger(
    log,
    application3,
    candidate,
    profile,
    resumeImportState.importStatus
  );
  if (!candidate.hasAgreedToTerms) {
    logStateChange("TermsAndConditionsConsent");
    return "TermsAndConditionsConsent" /* TermsAndConditionsConsent */;
  }
  if (!candidate.isGdprConsented) {
    logStateChange("GdprConsent");
    return "GdprConsent" /* GdprConsent */;
  }
  if (!candidate.isEmailVerified) {
    logStateChange("EmailAddressConfirm");
    return "EmailAddressConfirm" /* EmailAddressConfirm */;
  }
  if (requiresResumeUpload(profile)) {
    logStateChange("ResumeUpload");
    return "ResumeUpload" /* ResumeUpload */;
  }
  if (requiresRateClarification(application3)) {
    logStateChange("RateClarification");
    return "RateClarification" /* RateClarification */;
  }
  if (requiresRightToWorkClarification(application3, profile)) {
    logStateChange("RightToWork");
    return "RightToWork" /* RightToWork */;
  }
  if (applicationCanBeSubmitted(application3.applicationStateName)) {
    logStateChange("Apply");
    return "Submit" /* Submit */;
  }
  if (requiresResumeImport(profile, resumeImportState.importStatus)) {
    logStateChange("ResumeImport");
    return "ResumeImport" /* ResumeImport */;
  }
  logStateChange("Completed");
  return "Completed" /* Completed */;
}

// src/applications/lib/Profile.ts
import { formatCurrency } from "shared-lib";

// src/profiles/edit/components/__generated__/CompaniesTags_profile.graphql.ts
var node5 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CompaniesTags_profile",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitProfileExperience",
        "kind": "LinkedField",
        "name": "experience",
        "plural": true,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "candidateExperienceId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "companyName",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RecruitProfile",
    "abstractKey": null
  };
}();
node5.hash = "960ccdc18b8a8812b436c47740ad072f";
var CompaniesTags_profile_graphql_default = node5;

// src/profiles/edit/components/CompaniesTags.tsx
import { useFragment as useFragment2 } from "react-relay";
import { Tags } from "shared-ui";
import { jsx as jsx2 } from "react/jsx-runtime";
var fragmentDef = CompaniesTags_profile_graphql_default;
var CompaniesTags = ({ fragmentRef }) => {
  const data = useFragment2(fragmentDef, fragmentRef);
  const companies = data.experience.map((e4) => e4.companyName);
  return /* @__PURE__ */ jsx2(Tags, { size: "xsmall", list: [...new Set(companies)] });
};

// src/profiles/edit/components/ExperienceAdd.tsx
import { Suspense as Suspense2 } from "react";
import { useUserErrorCode } from "shared-lib";
import { AlertMessage } from "shared-ui";

// src/profiles/edit/mutations/__generated__/UseCandidateExperienceCreateMutation.graphql.ts
var node6 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateExperienceId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdOn",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedOn",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "version",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "industry",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "titleId",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyId",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyIsVerified",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyName",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  }, v14 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "startDate",
    "storageKey": null
  }, v15 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "endDate",
    "storageKey": null
  }, v16 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "positionType",
    "storageKey": null
  }, v17 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "skills",
    "storageKey": null
  }, v18 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "escoOccupationId",
    "storageKey": null
  }, v19 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "escoHierarchy",
    "storageKey": null
  }, v20 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseCandidateExperienceCreateMutation",
      "selections": [
        {
          "alias": "experience",
          "args": v1,
          "concreteType": "RecruitCandidateExperienceCreatePayload",
          "kind": "LinkedField",
          "name": "recruitCandidateExperienceCreate",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfCandidateExperience",
              "kind": "LinkedField",
              "name": "candidateExperience",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperience",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v23,
                    v32,
                    v4,
                    v5,
                    v6,
                    v7,
                    v8,
                    v9,
                    v10,
                    v11,
                    v12,
                    v13,
                    v14,
                    v15,
                    v16,
                    v17,
                    v18,
                    v19,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfile",
                      "kind": "LinkedField",
                      "name": "profile",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileExperience",
                          "kind": "LinkedField",
                          "name": "experience",
                          "plural": true,
                          "selections": [
                            v23,
                            v32,
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "ExperienceItem_profile"
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v20
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseCandidateExperienceCreateMutation",
      "selections": [
        {
          "alias": "experience",
          "args": v1,
          "concreteType": "RecruitCandidateExperienceCreatePayload",
          "kind": "LinkedField",
          "name": "recruitCandidateExperienceCreate",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfCandidateExperience",
              "kind": "LinkedField",
              "name": "candidateExperience",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperience",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v23,
                    v32,
                    v4,
                    v5,
                    v6,
                    v7,
                    v8,
                    v9,
                    v10,
                    v11,
                    v12,
                    v13,
                    v14,
                    v15,
                    v16,
                    v17,
                    v18,
                    v19,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfile",
                      "kind": "LinkedField",
                      "name": "profile",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileExperience",
                          "kind": "LinkedField",
                          "name": "experience",
                          "plural": true,
                          "selections": [
                            v23,
                            v32,
                            v6,
                            v8,
                            v9,
                            v10,
                            v12,
                            v11,
                            v14,
                            v15,
                            v7,
                            v16,
                            v13,
                            v17
                          ],
                          "storageKey": null
                        },
                        v23
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v20
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "7e0ae8bd534ae863b55afa4751f7a8d0",
      "id": null,
      "metadata": {},
      "name": "UseCandidateExperienceCreateMutation",
      "operationKind": "mutation",
      "text": "mutation UseCandidateExperienceCreateMutation(\n  $input: RecruitCandidateExperienceCreateInput!\n) {\n  experience: recruitCandidateExperienceCreate(input: $input) {\n    candidateExperience {\n      node {\n        id\n        candidateExperienceId\n        createdOn\n        updatedOn\n        version\n        industry\n        titleId\n        title\n        companyId\n        companyIsVerified\n        companyName\n        description\n        startDate\n        endDate\n        positionType\n        skills\n        escoOccupationId\n        escoHierarchy\n        profile {\n          experience {\n            id\n            candidateExperienceId\n            ...ExperienceItem_profile\n          }\n          id\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n\nfragment ExperienceItem_profile on RecruitProfileExperience {\n  id\n  version\n  candidateExperienceId\n  titleId\n  title\n  companyId\n  companyName\n  companyIsVerified\n  startDate\n  endDate\n  industry\n  positionType\n  description\n  skills\n  ...ExperienceSkills_skills\n}\n\nfragment ExperienceSkills_skills on RecruitProfileExperience {\n  skills\n}\n"
    }
  };
}();
node6.hash = "e73c2eb6eb940e681549e30ea740a766";
var UseCandidateExperienceCreateMutation_graphql_default = node6;

// src/profiles/edit/mutations/UseCandidateExperienceCreate.ts
import { useCallback } from "react";
import { useMutation } from "react-relay";
import {
  createClientMutationId,
  useSetUserErrorCodes,
  useUnhandledError
} from "shared-lib";
var mutationDef = UseCandidateExperienceCreateMutation_graphql_default;
var useCandidateExperienceCreate = (profileId, onDone) => {
  const [, setUnhandledError] = useUnhandledError();
  const setErrorCodes = useSetUserErrorCodes();
  const [commitMutation4, isMutationInFlight] = useMutation(mutationDef);
  const invokeMutation = useCallback(
    (form) => {
      const clientMutationId = createClientMutationId();
      const input = {
        ...form,
        profileId,
        clientMutationId
      };
      commitMutation4({
        variables: {
          input
        },
        onError: (e4) => {
          setUnhandledError(e4);
        },
        onCompleted: (response) => {
          if (response.experience.candidateExperience) {
            onDone();
          }
          if (response.experience.userErrors) {
            setErrorCodes(response.experience.userErrors);
          }
        }
      });
    },
    [commitMutation4]
  );
  return [invokeMutation, isMutationInFlight];
};

// src/profiles/edit/mutations/__generated__/UseCandidateExperienceEditMutation.graphql.ts
var node7 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateExperienceId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdOn",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedOn",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "version",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "industry",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "titleId",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyId",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyIsVerified",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyName",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  }, v14 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "startDate",
    "storageKey": null
  }, v15 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "endDate",
    "storageKey": null
  }, v16 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "positionType",
    "storageKey": null
  }, v17 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "skills",
    "storageKey": null
  }, v18 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "escoOccupationId",
    "storageKey": null
  }, v19 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "escoHierarchy",
    "storageKey": null
  }, v20 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseCandidateExperienceEditMutation",
      "selections": [
        {
          "alias": "experience",
          "args": v1,
          "concreteType": "RecruitCandidateExperienceUpdatePayload",
          "kind": "LinkedField",
          "name": "recruitCandidateExperienceUpdate",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfCandidateExperience",
              "kind": "LinkedField",
              "name": "candidateExperience",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperience",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v23,
                    v32,
                    v4,
                    v5,
                    v6,
                    v7,
                    v8,
                    v9,
                    v10,
                    v11,
                    v12,
                    v13,
                    v14,
                    v15,
                    v16,
                    v17,
                    v18,
                    v19,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfile",
                      "kind": "LinkedField",
                      "name": "profile",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileExperience",
                          "kind": "LinkedField",
                          "name": "experience",
                          "plural": true,
                          "selections": [
                            v23,
                            v32,
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "ExperienceItem_profile"
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v20
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseCandidateExperienceEditMutation",
      "selections": [
        {
          "alias": "experience",
          "args": v1,
          "concreteType": "RecruitCandidateExperienceUpdatePayload",
          "kind": "LinkedField",
          "name": "recruitCandidateExperienceUpdate",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfCandidateExperience",
              "kind": "LinkedField",
              "name": "candidateExperience",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperience",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v23,
                    v32,
                    v4,
                    v5,
                    v6,
                    v7,
                    v8,
                    v9,
                    v10,
                    v11,
                    v12,
                    v13,
                    v14,
                    v15,
                    v16,
                    v17,
                    v18,
                    v19,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfile",
                      "kind": "LinkedField",
                      "name": "profile",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileExperience",
                          "kind": "LinkedField",
                          "name": "experience",
                          "plural": true,
                          "selections": [
                            v23,
                            v32,
                            v6,
                            v8,
                            v9,
                            v10,
                            v12,
                            v11,
                            v14,
                            v15,
                            v7,
                            v16,
                            v13,
                            v17
                          ],
                          "storageKey": null
                        },
                        v23
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v20
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "bdef553a6bcc4175d2c4008f0bf5abad",
      "id": null,
      "metadata": {},
      "name": "UseCandidateExperienceEditMutation",
      "operationKind": "mutation",
      "text": "mutation UseCandidateExperienceEditMutation(\n  $input: RecruitCandidateExperienceUpdateInput!\n) {\n  experience: recruitCandidateExperienceUpdate(input: $input) {\n    candidateExperience {\n      node {\n        id\n        candidateExperienceId\n        createdOn\n        updatedOn\n        version\n        industry\n        titleId\n        title\n        companyId\n        companyIsVerified\n        companyName\n        description\n        startDate\n        endDate\n        positionType\n        skills\n        escoOccupationId\n        escoHierarchy\n        profile {\n          experience {\n            id\n            candidateExperienceId\n            ...ExperienceItem_profile\n          }\n          id\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n\nfragment ExperienceItem_profile on RecruitProfileExperience {\n  id\n  version\n  candidateExperienceId\n  titleId\n  title\n  companyId\n  companyName\n  companyIsVerified\n  startDate\n  endDate\n  industry\n  positionType\n  description\n  skills\n  ...ExperienceSkills_skills\n}\n\nfragment ExperienceSkills_skills on RecruitProfileExperience {\n  skills\n}\n"
    }
  };
}();
node7.hash = "91779258c0a3ed769a3848ee87beb361";
var UseCandidateExperienceEditMutation_graphql_default = node7;

// src/profiles/edit/mutations/UseCandidateExperienceEdit.ts
import { useCallback as useCallback2 } from "react";
import { useMutation as useMutation2 } from "react-relay";
import {
  createClientMutationId as createClientMutationId2,
  useSetUserErrorCodes as useSetUserErrorCodes2,
  useUnhandledError as useUnhandledError2
} from "shared-lib";
var mutationDef2 = UseCandidateExperienceEditMutation_graphql_default;
var useCandidateExperienceEdit = (candidateId, onDone, applicationId) => {
  const [, setUnhandledError] = useUnhandledError2();
  const setErrorCodes = useSetUserErrorCodes2();
  const [commitMutation4, isMutationInFlight] = useMutation2(mutationDef2);
  const invokeMutation = useCallback2(
    (form) => {
      const clientMutationId = createClientMutationId2();
      const input = {
        ...form,
        clientMutationId
      };
      commitMutation4({
        variables: {
          input
        },
        onError: (e4) => {
          setUnhandledError(e4);
        },
        updater: (store) => {
          if (applicationId) {
            const application3 = store.get(applicationId);
            application3?.invalidateRecord();
          }
        },
        onCompleted: (response) => {
          if (response.experience.candidateExperience) {
            onDone(form.candidateExperienceId);
          }
          if (response.experience.userErrors) {
            setErrorCodes(response.experience.userErrors);
          }
        }
      });
    },
    [commitMutation4]
  );
  return [invokeMutation, isMutationInFlight];
};

// src/profiles/edit/mutations/__generated__/UseCandidateExperienceRemoveMutation.graphql.ts
var node8 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "result",
    "storageKey": null
  }, v32 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseCandidateExperienceRemoveMutation",
      "selections": [
        {
          "alias": "removal",
          "args": v1,
          "concreteType": "RecruitCandidateExperienceRemovePayload",
          "kind": "LinkedField",
          "name": "recruitCandidateExperienceRemove",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseCandidateExperienceRemoveMutation",
      "selections": [
        {
          "alias": "removal",
          "args": v1,
          "concreteType": "RecruitCandidateExperienceRemovePayload",
          "kind": "LinkedField",
          "name": "recruitCandidateExperienceRemove",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "5e3add572afc679afb227ac65331c34a",
      "id": null,
      "metadata": {},
      "name": "UseCandidateExperienceRemoveMutation",
      "operationKind": "mutation",
      "text": "mutation UseCandidateExperienceRemoveMutation(\n  $input: RecruitCandidateExperienceRemoveInput!\n) {\n  removal: recruitCandidateExperienceRemove(input: $input) {\n    result\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node8.hash = "e080c509dde333f4cb3f09bac03f84a0";
var UseCandidateExperienceRemoveMutation_graphql_default = node8;

// src/profiles/edit/mutations/UseCandidateExperienceRemove.ts
import { useCallback as useCallback3 } from "react";
import { useMutation as useMutation3 } from "react-relay";
import {
  createClientMutationId as createClientMutationId3,
  useUnhandledError as useUnhandledError3,
  useSetUserErrorCodes as useSetUserErrorCodes3
} from "shared-lib";
var mutationDef3 = UseCandidateExperienceRemoveMutation_graphql_default;
var useCandidateExperienceRemove = (candidateId, onDone) => {
  const [, setUnhandledError] = useUnhandledError3();
  const setErrorCodes = useSetUserErrorCodes3();
  const [commitMutation4, isMutationInFlight] = useMutation3(mutationDef3);
  const invokeMutation = useCallback3(
    (candidateExperienceId) => {
      const clientMutationId = createClientMutationId3();
      const input = {
        candidateExperienceId,
        clientMutationId
      };
      commitMutation4({
        variables: {
          input
        },
        onError: (e4) => {
          setUnhandledError(e4);
        },
        onCompleted: (response) => {
          if (response.removal.result) {
            onDone();
          }
          if (response.removal.userErrors) {
            setErrorCodes(response.removal.userErrors);
          }
        }
      });
    },
    [commitMutation4]
  );
  return [invokeMutation, isMutationInFlight];
};

// src/profiles/edit/mutations/__generated__/UseCandidateProfileChangeJobTitleMutation.graphql.ts
var node9 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfCandidateExperienceSummary",
    "kind": "LinkedField",
    "name": "profile",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitProfileSummary",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "recruitProfileId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "version",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currentJobTitleId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currentJobTitleName",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v32 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseCandidateProfileChangeJobTitleMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitCandidateProfileSummaryChangeJobTitlePayload",
          "kind": "LinkedField",
          "name": "recruitCandidateProfileSummaryChangeJobTitle",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseCandidateProfileChangeJobTitleMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitCandidateProfileSummaryChangeJobTitlePayload",
          "kind": "LinkedField",
          "name": "recruitCandidateProfileSummaryChangeJobTitle",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "dd2c06e98ff8ece28d0f86e18826156a",
      "id": null,
      "metadata": {},
      "name": "UseCandidateProfileChangeJobTitleMutation",
      "operationKind": "mutation",
      "text": "mutation UseCandidateProfileChangeJobTitleMutation(\n  $input: RecruitCandidateProfileSummaryChangeJobTitleInput!\n) {\n  result: recruitCandidateProfileSummaryChangeJobTitle(input: $input) {\n    profile {\n      node {\n        id\n        recruitProfileId\n        createdOn\n        updatedOn\n        version\n        currentJobTitleId\n        currentJobTitleName\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node9.hash = "c792df95af6b7d73ec42afb1730e8d84";
var UseCandidateProfileChangeJobTitleMutation_graphql_default = node9;

// src/profiles/edit/mutations/UseCandidateProfileChangeJobTitle.ts
import { useCallback as useCallback4 } from "react";
import { useMutation as useMutation4 } from "react-relay";
import {
  createClientMutationId as createClientMutationId4,
  useUnhandledError as useUnhandledError4,
  useSetUserErrorCodes as useSetUserErrorCodes4
} from "shared-lib";
var mutationDef4 = UseCandidateProfileChangeJobTitleMutation_graphql_default;
var useCandidateProfileChangeJobTitle = (profileId, onDone) => {
  const [, setUnhandledError] = useUnhandledError4();
  const setErrorCodes = useSetUserErrorCodes4();
  const [commitMutation4, isMutationInFlight] = useMutation4(mutationDef4);
  const invokeMutation = useCallback4(
    (form) => {
      const clientMutationId = createClientMutationId4();
      const input = {
        model: {
          ...form
        },
        profileId,
        clientMutationId
      };
      commitMutation4({
        variables: {
          input
        },
        onError: (e4) => {
          setUnhandledError(e4);
        },
        onCompleted: (response) => {
          if (response.result.profile) {
            onDone();
          }
          if (response.result.userErrors) {
            setErrorCodes(response.result.userErrors);
          }
        }
      });
    },
    [commitMutation4]
  );
  return [invokeMutation, isMutationInFlight];
};

// src/profiles/edit/components/ExperienceForm.tsx
import { useCallback as useCallback7, useMemo as useMemo2 } from "react";
import {
  subMonths,
  isBefore,
  isAfter,
  startOfMonth,
  subYears,
  parseISO
} from "date-fns";
import { Controller as Controller2, useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { formatDateHtml, parseDate, useLogger, useToggle } from "shared-lib";
import {
  ErrorField,
  FormDateInput,
  FormTextAreaInput,
  FormInputRow,
  RadioListInput,
  ActionContainer,
  Button as Button2,
  Input
} from "shared-ui";
import { CompaniesSearchBoxInput } from "feature-data-management";

// src/job-titles/components/JobTitleSearchBox.tsx
import {
  Suspense,
  useCallback as useCallback5,
  useEffect as useEffect2,
  useMemo,
  useState
} from "react";
import { debounce } from "lodash-es";
import { ChevronUpDownIcon } from "@heroicons/react/24/solid";
import { Combobox as Combobox2 } from "@headlessui/react";

// src/job-titles/components/__generated__/JobTitleSearchOptionsPaginationQuery.graphql.ts
var node10 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v23 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v32 = [
    v1,
    v23,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "name": "ASC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "JobTitleSearchOptionsPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v23
          ],
          "kind": "FragmentSpread",
          "name": "JobTitleSearchOptions_titles"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "JobTitleSearchOptionsPaginationQuery",
      "selections": [
        {
          "alias": "titles",
          "args": v32,
          "concreteType": "RecruitJobFunctionsConnection",
          "kind": "LinkedField",
          "name": "recruitJobFunctions",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitJobFunctionsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "JobFunction",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobFunctionId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "titles",
          "args": v32,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "JobTitleSearchOptions_titles",
          "kind": "LinkedHandle",
          "name": "recruitJobFunctions"
        }
      ]
    },
    "params": {
      "cacheID": "7f39b06153021fd1331788ac32e3e335",
      "id": null,
      "metadata": {},
      "name": "JobTitleSearchOptionsPaginationQuery",
      "operationKind": "query",
      "text": "query JobTitleSearchOptionsPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $where: JobFunctionFilter\n) {\n  ...JobTitleSearchOptions_titles_2HEEH6\n}\n\nfragment JobTitleSearchOptions_titles_2HEEH6 on Query {\n  titles: recruitJobFunctions(first: $first, after: $after, order: [{name: ASC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        jobFunctionId\n        name\n        createdAt\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node10.hash = "034517915e502f0180518e6e9255a87f";
var JobTitleSearchOptionsPaginationQuery_graphql_default = node10;

// src/job-titles/components/__generated__/JobTitleSearchOptions_titles.graphql.ts
var node11 = function() {
  var v0 = [
    "titles"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": JobTitleSearchOptionsPaginationQuery_graphql_default
      }
    },
    "name": "JobTitleSearchOptions_titles",
    "selections": [
      {
        "alias": "titles",
        "args": [
          {
            "kind": "Literal",
            "name": "order",
            "value": [
              {
                "name": "ASC"
              }
            ]
          },
          {
            "kind": "Variable",
            "name": "where",
            "variableName": "where"
          }
        ],
        "concreteType": "RecruitJobFunctionsConnection",
        "kind": "LinkedField",
        "name": "__JobTitleSearchOptions_titles_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitJobFunctionsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "JobFunction",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "jobFunctionId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node11.hash = "034517915e502f0180518e6e9255a87f";
var JobTitleSearchOptions_titles_graphql_default = node11;

// src/job-titles/components/JobTitleSearchOptions.tsx
import { useEffect } from "react";
import { usePaginationFragment } from "react-relay/hooks";
import { Combobox } from "@headlessui/react";
import { CheckIcon } from "@heroicons/react/24/solid";
import { classNames } from "shared-ui";
import { Fragment, jsx as jsx3, jsxs } from "react/jsx-runtime";
var fragmentDef2 = JobTitleSearchOptions_titles_graphql_default;
var JobTitleSearchOptions = ({
  fragmentRef,
  searchTerm
}) => {
  const { data, refetch } = usePaginationFragment(fragmentDef2, fragmentRef);
  useEffect(() => {
    if (!searchTerm) {
      return;
    }
    const where = { name: { startsWith: searchTerm } };
    refetch({ first: 10, where }, { fetchPolicy: "store-or-network" });
  }, [refetch, searchTerm]);
  const { titles } = data;
  const rows = (titles?.edges ?? []).map((edge) => edge.node);
  return /* @__PURE__ */ jsx3(Combobox.Options, { className: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm", children: rows.map((result) => /* @__PURE__ */ jsx3(
    Combobox.Option,
    {
      value: result,
      className: ({ active }) => classNames(
        "relative cursor-default select-none py-2 pl-3 pr-9",
        active ? "bg-info-600 text-white" : "text-gray-900"
      ),
      children: ({ active, selected }) => /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx3("div", { className: "flex", children: /* @__PURE__ */ jsx3(
          "span",
          {
            className: classNames(
              "truncate",
              selected ? "font-semibold" : ""
            ),
            children: result.name
          }
        ) }),
        selected && /* @__PURE__ */ jsx3(
          "span",
          {
            className: classNames(
              "absolute inset-y-0 right-0 flex items-center pr-4",
              active ? "bg-info-600 text-white" : "text-info-600"
            ),
            children: /* @__PURE__ */ jsx3(CheckIcon, { className: "h-5 w-5", "aria-hidden": "true" })
          }
        )
      ] })
    },
    result.id
  )) });
};

// src/job-titles/components/JobTitleSearchBox.tsx
import { jsx as jsx4, jsxs as jsxs2 } from "react/jsx-runtime";
var JobTitleSearchBox = ({
  title,
  onSelected,
  fragmentRef,
  defaultValue
}) => {
  const [selected, setSelected] = useState(
    defaultValue ?? null
  );
  const [searchTerm, setSearchTerm] = useState("");
  const onQueryChangeHandler = useMemo(
    () => debounce((q4) => setSearchTerm(q4), 500),
    []
  );
  useEffect2(() => {
    return () => {
      onQueryChangeHandler.cancel();
    };
  }, [onQueryChangeHandler]);
  const onSetSelected = useCallback5(
    (r4) => {
      setSelected(r4);
      onSelected(r4);
    },
    [onSelected]
  );
  return /* @__PURE__ */ jsxs2(Combobox2, { as: "div", value: selected, onChange: onSetSelected, children: [
    title && /* @__PURE__ */ jsx4(Combobox2.Label, { className: "block text-sm font-medium text-gray-700", children: title }),
    /* @__PURE__ */ jsxs2("div", { className: "relative mt-2", children: [
      /* @__PURE__ */ jsx4(
        Combobox2.Input,
        {
          className: "focus:border-info-500 focus:ring-info-500 w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:outline-none focus:ring-1 sm:text-sm",
          onChange: (event) => onQueryChangeHandler(event.target.value),
          displayValue: (result) => {
            if (result) {
              return result.name;
            }
            return "";
          },
          autoComplete: "off"
        }
      ),
      /* @__PURE__ */ jsx4(Combobox2.Button, { className: "absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none", children: /* @__PURE__ */ jsx4(
        ChevronUpDownIcon,
        {
          className: "h-5 w-5 text-gray-400",
          "aria-hidden": "true"
        }
      ) }),
      /* @__PURE__ */ jsx4(Suspense, { fallback: "Searching...", children: /* @__PURE__ */ jsx4(
        JobTitleSearchOptions,
        {
          fragmentRef,
          searchTerm
        }
      ) })
    ] })
  ] });
};

// src/job-titles/components/__generated__/JobTitleSearchBoxInputQuery.graphql.ts
var node12 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "name": "ASC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "JobTitleSearchBoxInputQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "JobTitleSearchOptions_titles"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "JobTitleSearchBoxInputQuery",
      "selections": [
        {
          "alias": "titles",
          "args": v1,
          "concreteType": "RecruitJobFunctionsConnection",
          "kind": "LinkedField",
          "name": "recruitJobFunctions",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitJobFunctionsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "JobFunction",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobFunctionId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "titles",
          "args": v1,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "JobTitleSearchOptions_titles",
          "kind": "LinkedHandle",
          "name": "recruitJobFunctions"
        }
      ]
    },
    "params": {
      "cacheID": "d2e1750693004d067c12e6cab7b5e2d7",
      "id": null,
      "metadata": {},
      "name": "JobTitleSearchBoxInputQuery",
      "operationKind": "query",
      "text": "query JobTitleSearchBoxInputQuery(\n  $where: JobFunctionFilter!\n) {\n  ...JobTitleSearchOptions_titles\n}\n\nfragment JobTitleSearchOptions_titles on Query {\n  titles: recruitJobFunctions(first: 10, order: [{name: ASC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        jobFunctionId\n        name\n        createdAt\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node12.hash = "b11201114ec27de7fc4228328f761b49";
var JobTitleSearchBoxInputQuery_graphql_default = node12;

// src/job-titles/components/JobTitleSearchBoxInput.tsx
import { Controller } from "react-hook-form";
import { useLazyLoadQuery } from "react-relay";
import { jsx as jsx5 } from "react/jsx-runtime";
var graphqlQuery = JobTitleSearchBoxInputQuery_graphql_default;
var JobTitleSearchBoxInput = ({
  name,
  control
}) => {
  const where = {};
  const query3 = useLazyLoadQuery(
    graphqlQuery,
    { where },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsx5(
    Controller,
    {
      control,
      name,
      render: ({ field: { onChange: onControllerChange, value } }) => {
        console.log(`JobTitle Search: Value ${JSON.stringify(value)}`);
        return /* @__PURE__ */ jsx5(
          JobTitleSearchBox,
          {
            onSelected: (result) => {
              if (result) {
                onControllerChange({
                  id: result.jobFunctionId,
                  name: result.name
                });
              }
            },
            fragmentRef: query3,
            defaultValue: value ?? null
          }
        );
      }
    }
  );
};

// src/job-titles/components/__generated__/JobTitleSearchContainerQuery.graphql.ts
var node13 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "name": "ASC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "JobTitleSearchContainerQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "JobTitleSearchOptions_titles"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "JobTitleSearchContainerQuery",
      "selections": [
        {
          "alias": "titles",
          "args": v1,
          "concreteType": "RecruitJobFunctionsConnection",
          "kind": "LinkedField",
          "name": "recruitJobFunctions",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitJobFunctionsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "JobFunction",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobFunctionId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "titles",
          "args": v1,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "JobTitleSearchOptions_titles",
          "kind": "LinkedHandle",
          "name": "recruitJobFunctions"
        }
      ]
    },
    "params": {
      "cacheID": "f8592cd478c193ab636e5e66a149f618",
      "id": null,
      "metadata": {},
      "name": "JobTitleSearchContainerQuery",
      "operationKind": "query",
      "text": "query JobTitleSearchContainerQuery(\n  $where: JobFunctionFilter!\n) {\n  ...JobTitleSearchOptions_titles\n}\n\nfragment JobTitleSearchOptions_titles on Query {\n  titles: recruitJobFunctions(first: 10, order: [{name: ASC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        jobFunctionId\n        name\n        createdAt\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node13.hash = "a16c188d6290c218b8a80a0aa89b3dab";
var JobTitleSearchContainerQuery_graphql_default = node13;

// src/job-titles/components/JobTitleSearchContainer.tsx
import { useCallback as useCallback6, useState as useState2 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery2 } from "react-relay";
import { jsx as jsx6 } from "react/jsx-runtime";
var graphqlQuery2 = JobTitleSearchContainerQuery_graphql_default;
var JobTitleSearchContainer = ({
  onSearchCompleted
}) => {
  const [selectedResult, setSelectedResult] = useState2(null);
  const onSetSelected = useCallback6(
    (r4) => {
      setSelectedResult(r4);
      onSearchCompleted(r4);
    },
    [onSearchCompleted]
  );
  const where = {};
  const query3 = useLazyLoadQuery2(
    graphqlQuery2,
    { where },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsx6("div", { children: /* @__PURE__ */ jsx6(JobTitleSearchBox, { onSelected: onSetSelected, fragmentRef: query3 }) });
};

// src/profiles/edit/components/ExperienceForm.tsx
import { jsx as jsx7, jsxs as jsxs3 } from "react/jsx-runtime";
var positionTypesList = [
  {
    id: "UNKNOWN",
    label: "Unknown"
  },
  {
    id: "PERMANENT",
    label: "Permanent"
  },
  {
    id: "CONTRACT",
    label: "Contract"
  }
];
var FormSchema = z.object({
  title: z.union([
    z.object({
      id: z.string(),
      name: z.string()
    }),
    z.string()
  ]).nullable(),
  company: z.union([
    z.object({
      id: z.string(),
      name: z.string(),
      industry: z.string().optional(),
      isVerified: z.boolean()
    }),
    z.string()
  ]).nullable(),
  startDate: z.string(),
  endDate: z.string(),
  description: z.string(),
  positionType: z.string()
});
function formatStartOfMonthsAgo(months) {
  const previousMonth = subMonths(/* @__PURE__ */ new Date(), months);
  return formatDateHtml(startOfMonth(previousMonth));
}
function compareMonth(dateValue, compareTo) {
  const date = parseDate(dateValue);
  const compareDate = parseDate(compareTo);
  if (isBefore(date, compareDate)) {
    return 0 /* Before */;
  }
  if (isAfter(date, compareDate)) {
    return 2 /* After */;
  }
  return 1 /* Equals */;
}
var maxDate = formatDateHtml(/* @__PURE__ */ new Date());
var minDate = formatDateHtml(subYears(/* @__PURE__ */ new Date(), 40));
function initializeFormData(data) {
  let defaults;
  if (data) {
    defaults = {
      company: null,
      title: "",
      startDate: formatDateHtml(parseISO(data.startDate)),
      endDate: formatDateHtml(parseISO(data.endDate)),
      description: data.description,
      positionType: data.positionType
    };
    if (data.companyId) {
      defaults.company = {
        id: data.companyId,
        name: data.companyName,
        isVerified: data.companyIsVerified
      };
    }
    if (data.titleId && data.title) {
      defaults.title = {
        id: data.titleId,
        name: data.title
      };
    }
  } else {
    defaults = {
      company: null,
      title: null,
      startDate: formatStartOfMonthsAgo(6),
      endDate: formatStartOfMonthsAgo(1),
      description: "",
      positionType: "UNKNOWN"
    };
  }
  return defaults;
}
function extractFormInput(formData) {
  if (!formData || !formData.description || !formData.startDate || !formData.endDate) {
    return null;
  }
  let company;
  if (typeof formData.company === "string") {
    company = {
      create: formData.company
    };
  } else if (formData.company && formData.company.id) {
    company = {
      selected: {
        companyId: formData.company.id,
        companyIsVerified: formData.company.isVerified || false,
        companyName: formData.company.name
      }
    };
  } else if (formData.company && formData.company.name) {
    company = {
      create: formData.company.name
    };
  } else {
    return null;
  }
  let industry = void 0;
  if (typeof formData.company != "string" && formData.company.industry) {
    industry = formData.company.industry;
  }
  let title = {};
  if (typeof formData.title === "string") {
    title = {
      create: formData.title
    };
  } else if (formData.title && formData.title.id && formData.title.name) {
    title.create = formData.title.name;
    title.selected = {
      id: formData.title.id,
      name: formData.title.name
    };
  } else if (formData.title && formData.title.name) {
    title.create = formData.title.name;
  } else {
    title = {
      selected: null,
      create: null
    };
  }
  const positionType = formData.positionType;
  const data = {
    company,
    title,
    startDate: formData.startDate,
    endDate: formData.endDate,
    description: formData.description,
    positionType,
    industry
  };
  return data;
}
var ExperienceForm = ({
  data,
  isSaving,
  onSubmit,
  onCancel,
  showCancel = true
}) => {
  const [log] = useLogger();
  log(`Render ExperienceForm`);
  const defaultValues2 = useMemo2(() => {
    const defaults = initializeFormData(data);
    log(`Load ExperienceForm DefaultValues: ${JSON.stringify(defaults)}`);
    return defaults;
  }, [data]);
  const { register, handleSubmit, setError, getValues, formState, control } = useForm({
    resolver: zodResolver(FormSchema),
    defaultValues: defaultValues2
  });
  const submit = useCallback7(
    (formData) => {
      const data2 = extractFormInput(formData);
      if (!data2) {
        return;
      }
      onSubmit(data2);
    },
    [onSubmit]
  );
  const onSubmitted = handleSubmit(
    (form) => submit(form),
    (invalid) => {
      console.log(invalid);
    }
  );
  const { errors, isDirty } = formState;
  const [isNewJobTitle, toggleIsNewJobTitle] = useToggle(false);
  return /* @__PURE__ */ jsx7("div", { className: "container", children: /* @__PURE__ */ jsxs3(
    ActionContainer,
    {
      onSubmit: onSubmitted,
      onCancel,
      isDirty,
      isSaving,
      showCancel,
      titleTop: `Edit work experience`,
      children: [
        /* @__PURE__ */ jsxs3(FormInputRow, { name: "title", title: "Job Title *", children: [
          isNewJobTitle && /* @__PURE__ */ jsx7(
            Controller2,
            {
              name: "title",
              control,
              render: ({ field: { onChange } }) => {
                return /* @__PURE__ */ jsx7(Input, { placeholder: "Job Title", onValueChange: onChange });
              }
            }
          ),
          !isNewJobTitle && /* @__PURE__ */ jsx7(JobTitleSearchBoxInput, { control, name: "title" }),
          /* @__PURE__ */ jsx7(ErrorField, { field: errors.title }),
          /* @__PURE__ */ jsx7("div", { className: "flex w-full justify-end pt-2", children: /* @__PURE__ */ jsx7(Button2, { onClick: toggleIsNewJobTitle, color: "primary", children: isNewJobTitle ? "Cancel" : "Add new job title" }) })
        ] }),
        /* @__PURE__ */ jsxs3(FormInputRow, { name: "Company", title: "Company *", children: [
          /* @__PURE__ */ jsx7(CompaniesSearchBoxInput, { name: "company", control }),
          /* @__PURE__ */ jsx7(ErrorField, { field: errors.company })
        ] }),
        /* @__PURE__ */ jsxs3(FormInputRow, { name: "startDate", title: "From *", children: [
          /* @__PURE__ */ jsx7(
            FormDateInput,
            {
              max: maxDate,
              min: minDate,
              placeholder: " From ",
              name: "startDate",
              register,
              onValueChange: (date) => {
                const endDate = getValues("endDate");
                if (!endDate) {
                  return;
                }
                const compare = compareMonth(date, endDate);
                if (compare === 2 /* After */ || compare === 1 /* Equals */) {
                  setError("startDate", {
                    type: "beforeError",
                    message: "Start must be before End"
                  });
                }
              }
            }
          ),
          /* @__PURE__ */ jsx7(ErrorField, { field: errors.startDate })
        ] }),
        /* @__PURE__ */ jsxs3(FormInputRow, { name: "endDate", title: "To *", children: [
          /* @__PURE__ */ jsx7(
            FormDateInput,
            {
              max: maxDate,
              min: minDate,
              placeholder: " To ",
              name: "endDate",
              register,
              onValueChange: (date) => {
                const startDate = getValues("startDate");
                if (!startDate) {
                  return;
                }
                const compare = compareMonth(date, startDate);
                if (compare === 0 /* Before */ || compare === 1 /* Equals */) {
                  setError("endDate", {
                    type: "afterError",
                    message: "End must be after Start"
                  });
                }
              }
            }
          ),
          /* @__PURE__ */ jsx7(ErrorField, { field: errors.endDate })
        ] }),
        /* @__PURE__ */ jsxs3(FormInputRow, { name: "positionType", title: "Contract", children: [
          /* @__PURE__ */ jsx7(
            RadioListInput,
            {
              name: "positionType",
              title: "Contract",
              control,
              list: positionTypesList
            }
          ),
          /* @__PURE__ */ jsx7(ErrorField, { field: errors.positionType })
        ] }),
        /* @__PURE__ */ jsxs3(FormInputRow, { name: "description", title: "Description *", children: [
          /* @__PURE__ */ jsx7(
            FormTextAreaInput,
            {
              rows: 10,
              className: "mt-1",
              placeholder: " What i did ",
              name: "description",
              required: true,
              register
            }
          ),
          /* @__PURE__ */ jsx7(ErrorField, { field: errors.description })
        ] })
      ]
    }
  ) });
};

// src/profiles/edit/components/ExperienceAdd.tsx
import { jsx as jsx8, jsxs as jsxs4 } from "react/jsx-runtime";
var ExperienceAdd = ({ profileId, onAdded, onCancel }) => {
  const errorCode = useUserErrorCode();
  const [save, isSaving] = useCandidateExperienceCreate(profileId, () => {
    if (onAdded) {
      onAdded();
    }
  });
  return /* @__PURE__ */ jsx8(Suspense2, { fallback: /* @__PURE__ */ jsx8("div", { children: "Loading" }), children: /* @__PURE__ */ jsxs4("div", { className: "space-y-6 bg-white px-4 py-5 sm:p-6", children: [
    errorCode ? /* @__PURE__ */ jsx8(AlertMessage, { message: errorCode }) : null,
    /* @__PURE__ */ jsx8(
      ExperienceForm,
      {
        saveButtonLabel: "Add",
        isSaving,
        onCancel,
        onSubmit: (data) => save(data)
      }
    )
  ] }) });
};

// src/profiles/edit/components/__generated__/ExperienceEditQuery.graphql.ts
var node14 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "id"
    }
  ], v1 = [
    {
      "alias": "experience",
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "id"
        }
      ],
      "concreteType": "RecruitProfileExperience",
      "kind": "LinkedField",
      "name": "recruitProfileExperienceById",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdOn",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedOn",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "candidateExperienceId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "version",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "titleId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "industry",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "companyIsVerified",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "companyId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "companyName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "positionType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "skills",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "escoOccupationId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "escoHierarchy",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ExperienceEditQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ExperienceEditQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "786afe5b9538d1aa026aae11e5d8594e",
      "id": null,
      "metadata": {},
      "name": "ExperienceEditQuery",
      "operationKind": "query",
      "text": "query ExperienceEditQuery(\n  $id: UUID!\n) {\n  experience: recruitProfileExperienceById(id: $id) {\n    id\n    createdOn\n    updatedOn\n    candidateExperienceId\n    version\n    titleId\n    title\n    industry\n    companyIsVerified\n    companyId\n    companyName\n    description\n    startDate\n    endDate\n    positionType\n    skills\n    escoOccupationId\n    escoHierarchy\n  }\n}\n"
    }
  };
}();
node14.hash = "fd91a9ba149e83b5501c6c2da25ee143";
var ExperienceEditQuery_graphql_default = node14;

// src/profiles/edit/components/ExperienceEdit.tsx
import { Suspense as Suspense3, useCallback as useCallback8 } from "react";
import { useParams } from "react-router-dom";
import { useLazyLoadQuery as useLazyLoadQuery3 } from "react-relay";
import { useUserErrorCode as useUserErrorCode2 } from "shared-lib";
import { AlertMessage as AlertMessage2 } from "shared-ui";
import { jsx as jsx9, jsxs as jsxs5 } from "react/jsx-runtime";
var queryDef = ExperienceEditQuery_graphql_default;
var ExperienceEdit = ({
  profileId,
  onDone,
  onCancel,
  applicationId
}) => {
  const { id: id18 } = useParams();
  return /* @__PURE__ */ jsx9(
    ExperienceEditComponent,
    {
      profileId,
      onDone,
      onCancel,
      id: id18,
      applicationId
    }
  );
};
var ExperienceEditComponent = ({ id: id18, profileId, onDone, onCancel, showCancel = true, applicationId }) => {
  const errorCode = useUserErrorCode2();
  const query3 = useLazyLoadQuery3(
    queryDef,
    { id: id18 },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { experience } = query3;
  const [save, isSaving] = useCandidateExperienceEdit(
    profileId,
    (id19) => {
      if (onDone) {
        onDone(id19);
      }
    },
    applicationId
  );
  const onSaved = useCallback8(
    (form) => {
      if (!experience) {
        return;
      }
      const input = {
        ...form,
        version: experience.version,
        candidateExperienceId: experience.candidateExperienceId,
        title: form.title ?? {}
      };
      save(input);
    },
    [experience, save]
  );
  if (!experience) {
    return /* @__PURE__ */ jsx9("div", { children: "Experience Not Found!!" });
  }
  return /* @__PURE__ */ jsx9(Suspense3, { fallback: /* @__PURE__ */ jsx9("div", { children: "Loading" }), children: /* @__PURE__ */ jsxs5("div", { className: "space-y-6 py-5", children: [
    errorCode ? /* @__PURE__ */ jsx9(AlertMessage2, { message: errorCode }) : null,
    /* @__PURE__ */ jsx9(
      ExperienceForm,
      {
        saveButtonLabel: "Update",
        data: experience,
        isSaving,
        showCancel,
        onCancel: () => {
          onCancel(experience?.candidateExperienceId);
        },
        onSubmit: (props) => {
          onSaved(props);
        }
      }
    )
  ] }) });
};

// src/profiles/edit/components/__generated__/ExperienceItem_profile.graphql.ts
var node15 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ExperienceItem_profile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "candidateExperienceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "titleId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "companyId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "companyName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "companyIsVerified",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "industry",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "positionType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "skills",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ExperienceSkills_skills"
    }
  ],
  "type": "RecruitProfileExperience",
  "abstractKey": null
};
node15.hash = "675f7d94bd28244d87832ca984ec63a9";
var ExperienceItem_profile_graphql_default = node15;

// src/profiles/edit/components/ExperienceItem.tsx
import { useFragment as useFragment4 } from "react-relay";
import { format, formatDistance } from "date-fns";
import { parseDate as parseDate2 } from "shared-lib";
import { HtmlDisplay, Tag } from "shared-ui";

// src/profiles/edit/components/__generated__/ExperienceSkills_skills.graphql.ts
var node16 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ExperienceSkills_skills",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "skills",
      "storageKey": null
    }
  ],
  "type": "RecruitProfileExperience",
  "abstractKey": null
};
node16.hash = "30f715e60a49c9a475c8031d9e616efc";
var ExperienceSkills_skills_graphql_default = node16;

// src/profiles/edit/components/ExperienceSkills.tsx
import { useFragment as useFragment3 } from "react-relay";
import { useToggle as useToggle2 } from "shared-lib";
import { Fragment as Fragment2, jsx as jsx10, jsxs as jsxs6 } from "react/jsx-runtime";
var fragmentDef3 = ExperienceSkills_skills_graphql_default;
var ExperienceSkills = ({ fragmentRef }) => {
  const data = useFragment3(
    fragmentDef3,
    fragmentRef
  );
  return /* @__PURE__ */ jsx10(ExperienceSkillsComponent, { skillsList: [...data.skills] });
};
var ExperienceSkillsComponent = ({
  skillsList
}) => {
  const [expanded, toggleExpanded] = useToggle2(false);
  const skills = skillsList.slice(0, expanded ? void 0 : 5).map((s4) => /* @__PURE__ */ jsx10(
    "li",
    {
      className: "sm:text-md inline rounded-full bg-green-300 px-3 py-1 text-sm text-purple-900",
      children: s4
    },
    s4
  ));
  if (skills.length === 0) {
    return /* @__PURE__ */ jsx10(Fragment2, {});
  }
  return /* @__PURE__ */ jsx10("div", { className: "flex flex-col", children: /* @__PURE__ */ jsxs6("ul", { className: "flex flex-wrap gap-2", children: [
    skills,
    skillsList.length > 5 && /* @__PURE__ */ jsx10(
      "li",
      {
        onClick: toggleExpanded,
        className: "sm:text-md inline cursor-pointer rounded-full border bg-gray-100 px-3 py-1 text-sm text-purple-900",
        children: expanded ? "- Less" : "+ More"
      }
    )
  ] }) });
};

// src/profiles/edit/components/ExperienceItem.tsx
import { jsx as jsx11, jsxs as jsxs7 } from "react/jsx-runtime";
var fragmentDef4 = ExperienceItem_profile_graphql_default;
var ExperienceItem = ({ fragmentRef }) => {
  const data = useFragment4(
    fragmentDef4,
    fragmentRef
  );
  const startDate = parseDate2(data.startDate);
  const endDate = parseDate2(data.endDate);
  const skills = data.skills.map((s4, i4) => {
    return /* @__PURE__ */ jsx11("div", { children: s4 }, s4);
  });
  return /* @__PURE__ */ jsx11("div", { className: "flex w-full flex-col bg-white", children: /* @__PURE__ */ jsxs7("div", { className: "flex flex-col gap-5 rounded-lg px-6 py-5", children: [
    /* @__PURE__ */ jsxs7("div", { className: "flex flex-col justify-between", children: [
      /* @__PURE__ */ jsx11("h3", { className: "text-xl font-medium text-gray-900 lg:hidden", children: data.title }),
      /* @__PURE__ */ jsx11("strong", { className: "text-primary-700 text-lg font-bold", children: data.companyName }),
      /* @__PURE__ */ jsxs7("div", { className: "flex flex-grow items-center text-gray-500", children: [
        format(startDate, "LLLL y"),
        " - ",
        format(endDate, "LLLL y"),
        " (",
        formatDistance(startDate, endDate),
        ")\xA0"
      ] })
    ] }),
    data.positionType && data.positionType != "UNKNOWN" && /* @__PURE__ */ jsx11("div", { children: /* @__PURE__ */ jsx11(
      Tag,
      {
        size: "xsmall",
        color: "bg-purple-100 text-purple-600",
        className: "border border-purple-600 px-6",
        children: data.positionType
      }
    ) }),
    /* @__PURE__ */ jsx11("div", { children: /* @__PURE__ */ jsx11(ExperienceSkills, { fragmentRef: data }) }),
    /* @__PURE__ */ jsx11("div", { className: "text-gray-500", children: /* @__PURE__ */ jsx11(HtmlDisplay, { html: data.description }) })
  ] }) });
  return /* @__PURE__ */ jsx11("div", { className: "flex flex-col bg-white", children: /* @__PURE__ */ jsxs7("div", { className: "px-4 py-5 sm:px-6", children: [
    /* @__PURE__ */ jsxs7("div", { className: "flex justify-between", children: [
      /* @__PURE__ */ jsx11("div", { className: "flex flex-row flex-wrap items-baseline leading-10 ", children: /* @__PURE__ */ jsxs7("div", { className: "text-md flex flex-row items-center", children: [
        /* @__PURE__ */ jsx11("h3", { className: "text-md align-baseline font-medium leading-6 text-gray-900", children: data.companyName }),
        data.industry && /* @__PURE__ */ jsx11("div", { className: "text-primary-500 align-baseline leading-4 ", children: /* @__PURE__ */ jsx11("div", { className: "text-md ml-2 flex border-l border-black pl-2", children: data.industry }) })
      ] }) }),
      data.positionType && data.positionType != "UNKNOWN" && /* @__PURE__ */ jsx11("div", { children: /* @__PURE__ */ jsx11(Tag, { size: "xsmall", children: data.positionType }) })
    ] }),
    /* @__PURE__ */ jsxs7("div", { className: "flex flex-grow flex-wrap items-center text-sm", children: [
      /* @__PURE__ */ jsxs7("div", { className: "pr-3 leading-8", children: [
        format(startDate, "LLLL y"),
        " - ",
        format(endDate, "LLLL y")
      ] }),
      /* @__PURE__ */ jsxs7("div", { children: [
        "(",
        formatDistance(startDate, endDate),
        ")\xA0"
      ] })
    ] }),
    /* @__PURE__ */ jsx11("div", { className: "mt-2 rounded-md border border-t bg-gray-50 p-4", children: /* @__PURE__ */ jsx11(HtmlDisplay, { html: data.description }) }),
    /* @__PURE__ */ jsx11("div", { className: "mt-2 flex items-center gap-2 rounded-md border border-t bg-gray-50 p-4", children: skills })
  ] }) });
};

// src/profiles/edit/components/__generated__/ExperienceLayoutQuery.graphql.ts
var node17 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "profileId"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "profileId"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "recruitProfileId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateExperienceId",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyName",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "skills",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "startDate",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "endDate",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "industry",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "positionType",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ExperienceLayoutQuery",
      "selections": [
        {
          "alias": "profile",
          "args": v1,
          "concreteType": "RecruitProfile",
          "kind": "LinkedField",
          "name": "recruitProfileById",
          "plural": false,
          "selections": [
            v23,
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfileExperienceCollection",
              "kind": "LinkedField",
              "name": "experiences",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperience",
                  "kind": "LinkedField",
                  "name": "items",
                  "plural": true,
                  "selections": [
                    v23,
                    v4,
                    v5,
                    v6,
                    v7,
                    v8,
                    v9,
                    v10,
                    v11,
                    v12,
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "ExperienceItem_profile"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ExperienceList_profile"
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ExperienceLayoutQuery",
      "selections": [
        {
          "alias": "profile",
          "args": v1,
          "concreteType": "RecruitProfile",
          "kind": "LinkedField",
          "name": "recruitProfileById",
          "plural": false,
          "selections": [
            v23,
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfileExperienceCollection",
              "kind": "LinkedField",
              "name": "experiences",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperience",
                  "kind": "LinkedField",
                  "name": "items",
                  "plural": true,
                  "selections": [
                    v23,
                    v4,
                    v5,
                    v6,
                    v7,
                    v8,
                    v9,
                    v10,
                    v11,
                    v12,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "version",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "titleId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "companyId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "companyIsVerified",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "escoOccupationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "escoHierarchy",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SkillUsage",
                  "kind": "LinkedField",
                  "name": "skills",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastUsed",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DateRange",
                      "kind": "LinkedField",
                      "name": "periods",
                      "plural": true,
                      "selections": [
                        v8,
                        v10
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "averageMonthsUsed",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "totalMonthsUsed",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "totalPositionsUsed",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "840532a263389e5dfa443d7091114ea2",
      "id": null,
      "metadata": {},
      "name": "ExperienceLayoutQuery",
      "operationKind": "query",
      "text": "query ExperienceLayoutQuery(\n  $profileId: UUID!\n) {\n  profile: recruitProfileById(id: $profileId) {\n    id\n    recruitProfileId\n    experiences {\n      items {\n        id\n        candidateExperienceId\n        title\n        companyName\n        skills\n        startDate\n        description\n        endDate\n        industry\n        positionType\n        ...ExperienceItem_profile\n      }\n    }\n    ...ExperienceList_profile\n  }\n}\n\nfragment CandidateApplicationProfile_profile on RecruitProfile {\n  experiences {\n    items {\n      id\n      candidateExperienceId\n      title\n      companyName\n      startDate\n      endDate\n      ...ExperienceDetails_experience\n    }\n    skills {\n      name\n      lastUsed\n      periods {\n        startDate\n        endDate\n      }\n      averageMonthsUsed\n      totalMonthsUsed\n      totalPositionsUsed\n    }\n  }\n}\n\nfragment ExperienceDetails_experience on RecruitProfileExperience {\n  id\n  createdOn\n  updatedOn\n  candidateExperienceId\n  version\n  titleId\n  title\n  industry\n  companyIsVerified\n  companyId\n  companyName\n  description\n  startDate\n  endDate\n  positionType\n  skills\n  escoOccupationId\n  escoHierarchy\n}\n\nfragment ExperienceItem_profile on RecruitProfileExperience {\n  id\n  version\n  candidateExperienceId\n  titleId\n  title\n  companyId\n  companyName\n  companyIsVerified\n  startDate\n  endDate\n  industry\n  positionType\n  description\n  skills\n  ...ExperienceSkills_skills\n}\n\nfragment ExperienceList_profile on RecruitProfile {\n  id\n  recruitProfileId\n  experiences {\n    items {\n      id\n      candidateExperienceId\n      title\n      companyName\n      skills\n      startDate\n      description\n      endDate\n      industry\n      positionType\n      ...ExperienceItem_profile\n    }\n  }\n  ...CandidateApplicationProfile_profile\n}\n\nfragment ExperienceSkills_skills on RecruitProfileExperience {\n  skills\n}\n"
    }
  };
}();
node17.hash = "281f5b5e8dcf27b3a80a4fa7724f4fee";
var ExperienceLayoutQuery_graphql_default = node17;

// src/profiles/edit/components/ExperienceLayout.tsx
import { isValidElement, Suspense as Suspense8 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery6 } from "react-relay";
import {
  Routes,
  Route,
  useNavigate as useNavigate3,
  Outlet,
  Link as Link2,
  Navigate
} from "react-router-dom";
import { ErrorBoundary as ErrorBoundary2 } from "react-error-boundary";
import { EdButtonLink, EdSkeleton as EdSkeleton3, RouteContent } from "shared-ui";
import { ErrorBoundaryFallback as ErrorBoundaryFallback2 } from "app-core";

// src/profiles/edit/components/__generated__/ExperienceDetailsQuery.graphql.ts
var node18 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "id"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "id"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ExperienceDetailsQuery",
      "selections": [
        {
          "alias": "experience",
          "args": v1,
          "concreteType": "RecruitProfileExperience",
          "kind": "LinkedField",
          "name": "recruitProfileExperienceById",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ExperienceDetails_experience"
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ExperienceDetailsQuery",
      "selections": [
        {
          "alias": "experience",
          "args": v1,
          "concreteType": "RecruitProfileExperience",
          "kind": "LinkedField",
          "name": "recruitProfileExperienceById",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdOn",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedOn",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "candidateExperienceId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "version",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "titleId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "industry",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "companyIsVerified",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "companyId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "companyName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "positionType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "skills",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "escoOccupationId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "escoHierarchy",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "6e2e1eb10f0c0406c12d71619007fb8f",
      "id": null,
      "metadata": {},
      "name": "ExperienceDetailsQuery",
      "operationKind": "query",
      "text": "query ExperienceDetailsQuery(\n  $id: UUID!\n) {\n  experience: recruitProfileExperienceById(id: $id) {\n    ...ExperienceDetails_experience\n    id\n  }\n}\n\nfragment ExperienceDetails_experience on RecruitProfileExperience {\n  id\n  createdOn\n  updatedOn\n  candidateExperienceId\n  version\n  titleId\n  title\n  industry\n  companyIsVerified\n  companyId\n  companyName\n  description\n  startDate\n  endDate\n  positionType\n  skills\n  escoOccupationId\n  escoHierarchy\n}\n"
    }
  };
}();
node18.hash = "5636f02743a7bba1ba120dabb53c8766";
var ExperienceDetailsQuery_graphql_default = node18;

// src/profiles/edit/components/__generated__/ExperienceDetails_experience.graphql.ts
var node19 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ExperienceDetails_experience",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "candidateExperienceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "titleId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "industry",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "companyIsVerified",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "companyId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "companyName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "positionType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "skills",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "escoOccupationId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "escoHierarchy",
      "storageKey": null
    }
  ],
  "type": "RecruitProfileExperience",
  "abstractKey": null
};
node19.hash = "93740aa9f6681194c57da527c34255ec";
var ExperienceDetails_experience_graphql_default = node19;

// src/profiles/edit/components/ExperienceDetails.tsx
import { Suspense as Suspense4 } from "react";
import { useParams as useParams2 } from "react-router-dom";
import { format as format2, formatDistance as formatDistance2 } from "date-fns";
import { useFragment as useFragment5, useLazyLoadQuery as useLazyLoadQuery4 } from "react-relay";
import { isNotNull, noop, parseDate as parseDate3 } from "shared-lib";
import { Button as Button3, ButtonList, EdLink, HtmlDisplay as HtmlDisplay2, Tag as Tag2, Tags as Tags2 } from "shared-ui";
import { jsx as jsx12, jsxs as jsxs8 } from "react/jsx-runtime";
var queryDef2 = ExperienceDetailsQuery_graphql_default;
var ExperienceDetails = ({ onEdit, onBack }) => {
  const { id: id18 } = useParams2();
  const query3 = useLazyLoadQuery4(
    queryDef2,
    { id: id18 },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsx12(
    ExperienceDetailsComponent,
    {
      onEdit,
      onBack,
      onDelete: noop,
      fragmentRef: query3.experience
    }
  );
};
var fragmentDef5 = ExperienceDetails_experience_graphql_default;
var ExperienceDetailsComponent = ({ onEdit, onBack, fragmentRef }) => {
  const experience = useFragment5(fragmentDef5, fragmentRef);
  const startDate = parseDate3(experience.startDate);
  const endDate = parseDate3(experience.endDate);
  const skills = (experience.skills || []).filter(isNotNull);
  return /* @__PURE__ */ jsx12(Suspense4, { fallback: /* @__PURE__ */ jsx12("div", { children: "Loading" }), children: /* @__PURE__ */ jsxs8("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ jsx12("div", { className: "bg-gray-700 px-4 py-5 text-white sm:px-6 md:bg-white md:text-black", children: /* @__PURE__ */ jsxs8("div", { className: "flex flex-col justify-between gap-1 md:flex-col md:flex-wrap", children: [
      /* @__PURE__ */ jsxs8("div", { className: "flex items-center justify-between", children: [
        /* @__PURE__ */ jsxs8("h3", { className: "text-lg font-medium leading-5 md:leading-10 md:text-gray-900", children: [
          experience.title,
          " | ",
          /* @__PURE__ */ jsx12("strong", { children: experience.companyName })
        ] }),
        (onEdit || onBack) && /* @__PURE__ */ jsxs8(ButtonList, { children: [
          onEdit && /* @__PURE__ */ jsx12(
            Button3,
            {
              color: "primary",
              outline: true,
              clicked: () => {
                onEdit(experience.candidateExperienceId);
              },
              children: "Edit"
            }
          ),
          onBack && /* @__PURE__ */ jsx12(
            Button3,
            {
              color: "primary",
              outline: true,
              clicked: () => {
                onBack(experience.candidateExperienceId);
              },
              children: "Back"
            }
          )
        ] })
      ] }),
      experience.industry && /* @__PURE__ */ jsx12("div", { className: "flex flex-grow items-center", children: /* @__PURE__ */ jsx12("div", { children: experience.industry }) }),
      /* @__PURE__ */ jsx12("div", { className: "flex flex-grow items-center text-sm", children: /* @__PURE__ */ jsxs8("div", { children: [
        format2(startDate, "LLLL y"),
        " - ",
        format2(endDate, "LLLL y"),
        " (",
        formatDistance2(startDate, endDate),
        ")\xA0"
      ] }) })
    ] }) }),
    experience.positionType && experience.positionType != "UNKNOWN" && /* @__PURE__ */ jsx12("div", { className: "mx-5 mt-5 md:mb-5 md:mt-0", children: /* @__PURE__ */ jsx12(Tag2, { size: "xsmall", children: experience.positionType }) }),
    /* @__PURE__ */ jsxs8("div", { className: "mb-5 md:mx-5", children: [
      /* @__PURE__ */ jsx12("div", { className: "rounded-md p-4 md:border md:bg-gray-50", children: /* @__PURE__ */ jsx12(HtmlDisplay2, { html: experience.description }) }),
      /* @__PURE__ */ jsx12("div", { className: "flex gap-1 p-2", children: /* @__PURE__ */ jsx12(Tags2, { size: "xsmall", list: skills }) })
    ] }),
    /* @__PURE__ */ jsx12(
      EdLink,
      {
        name: "delete",
        href: `../delete/${experience.candidateExperienceId}`,
        className: "flex w-full p-5",
        children: /* @__PURE__ */ jsx12(Button3, { color: `danger`, children: "Delete" })
      }
    )
  ] }) });
};

// src/profiles/edit/components/__generated__/ExperienceDeleteQuery.graphql.ts
var node20 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "id"
    }
  ], v1 = [
    {
      "alias": "experience",
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "id"
        }
      ],
      "concreteType": "RecruitProfileExperience",
      "kind": "LinkedField",
      "name": "recruitProfileExperienceById",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "candidateExperienceId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "companyName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endDate",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ExperienceDeleteQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ExperienceDeleteQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "aa7f1d546d61a1bea06b76ec441288f1",
      "id": null,
      "metadata": {},
      "name": "ExperienceDeleteQuery",
      "operationKind": "query",
      "text": "query ExperienceDeleteQuery(\n  $id: UUID!\n) {\n  experience: recruitProfileExperienceById(id: $id) {\n    id\n    candidateExperienceId\n    title\n    companyName\n    startDate\n    endDate\n  }\n}\n"
    }
  };
}();
node20.hash = "6265a40e94a5edf9319e26d57f458f9c";
var ExperienceDeleteQuery_graphql_default = node20;

// src/profiles/edit/components/ExperienceDelete.tsx
import { Suspense as Suspense5 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery5 } from "react-relay";
import { useParams as useParams3 } from "react-router-dom";
import { format as format3, formatDistance as formatDistance3 } from "date-fns";
import { parseDate as parseDate4, useUserErrorCode as useUserErrorCode3 } from "shared-lib";
import { AlertMessage as AlertMessage3, Button as Button4, ButtonList as ButtonList2 } from "shared-ui";
import { jsx as jsx13, jsxs as jsxs9 } from "react/jsx-runtime";
var queryDef3 = ExperienceDeleteQuery_graphql_default;
var ExperienceDelete = ({
  profileId,
  onDone,
  onCancel
}) => {
  const { id: id18 } = useParams3();
  const query3 = useLazyLoadQuery5(
    queryDef3,
    { id: id18 },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const errorCode = useUserErrorCode3();
  const [deleteExperience, isDeleting] = useCandidateExperienceRemove(
    profileId,
    () => {
      if (onDone) {
        onDone();
      }
    }
  );
  const { experience } = query3;
  if (!experience) {
    return /* @__PURE__ */ jsx13("div", { children: "Experience Not Found" });
  }
  const startDate = parseDate4(experience.startDate);
  const endDate = parseDate4(experience.endDate);
  return /* @__PURE__ */ jsx13(Suspense5, { fallback: /* @__PURE__ */ jsx13("div", { children: "Loading" }), children: /* @__PURE__ */ jsx13("div", { className: "flex justify-center", children: /* @__PURE__ */ jsxs9("div", { className: "space-y-6 bg-white px-4 py-5 sm:mt-2 sm:border sm:p-6", children: [
    errorCode ? /* @__PURE__ */ jsx13(AlertMessage3, { message: errorCode }) : null,
    /* @__PURE__ */ jsxs9("div", { className: "border-b border-gray-200 px-4 py-5 sm:px-6", children: [
      /* @__PURE__ */ jsx13("div", { className: "flex justify-between", children: /* @__PURE__ */ jsxs9("h3", { className: "text-lg font-medium leading-10 text-gray-900", children: [
        experience.title,
        " | ",
        /* @__PURE__ */ jsx13("strong", { children: experience.companyName })
      ] }) }),
      /* @__PURE__ */ jsx13("div", { className: "flex flex-grow items-center", children: /* @__PURE__ */ jsxs9("div", { children: [
        format3(startDate, "LLLL y"),
        " - ",
        format3(endDate, "LLLL y"),
        " (",
        formatDistance3(startDate, endDate),
        ")\xA0"
      ] }) })
    ] }),
    /* @__PURE__ */ jsxs9(ButtonList2, { justify: "START", children: [
      /* @__PURE__ */ jsx13(
        Button4,
        {
          clicked: () => deleteExperience(experience.candidateExperienceId),
          color: "warning",
          confirmMessage: `Delete are you sure?`,
          disabled: isDeleting,
          children: "Delete"
        }
      ),
      /* @__PURE__ */ jsx13(
        Button4,
        {
          color: "gray",
          clicked: () => onCancel(experience.candidateExperienceId),
          disabled: isDeleting,
          children: "Cancel"
        }
      )
    ] })
  ] }) }) });
};

// src/profiles/edit/components/__generated__/ExperienceList_profile.graphql.ts
var node21 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ExperienceList_profile",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "recruitProfileId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitProfileExperienceCollection",
        "kind": "LinkedField",
        "name": "experiences",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitProfileExperience",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              v0,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "candidateExperienceId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "companyName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "skills",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "industry",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "positionType",
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ExperienceItem_profile"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "CandidateApplicationProfile_profile"
      }
    ],
    "type": "RecruitProfile",
    "abstractKey": null
  };
}();
node21.hash = "8ebbe888abdbd51045bb62a7901c7340";
var ExperienceList_profile_graphql_default = node21;

// src/profiles/edit/components/ExperienceList.tsx
import { Suspense as Suspense7 } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useFragment as useFragment7 } from "react-relay";
import { useNavigate as useNavigate2 } from "react-router-dom";
import { ErrorBoundaryFallback } from "app-core";
import { EdSkeleton as EdSkeleton2 } from "shared-ui";

// src/candidates/components/__generated__/CandidateApplicationProfileRouteQuery.graphql.ts
var node22 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "applicationCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "applicationCode",
      "variableName": "applicationCode"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v5 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "startDate",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "endDate",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateApplicationProfileRouteQuery",
      "selections": [
        {
          "alias": "application",
          "args": v1,
          "concreteType": "Application",
          "kind": "LinkedField",
          "name": "applicationByCode",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "candidate",
              "plural": false,
              "selections": [
                v32,
                v4
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfile",
              "kind": "LinkedField",
              "name": "profile",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "CandidateApplicationProfile_profile"
                }
              ],
              "storageKey": null
            },
            v5
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateApplicationProfileRouteQuery",
      "selections": [
        {
          "alias": "application",
          "args": v1,
          "concreteType": "Application",
          "kind": "LinkedField",
          "name": "applicationByCode",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "candidate",
              "plural": false,
              "selections": [
                v32,
                v4,
                v23
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfile",
              "kind": "LinkedField",
              "name": "profile",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperienceCollection",
                  "kind": "LinkedField",
                  "name": "experiences",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileExperience",
                      "kind": "LinkedField",
                      "name": "items",
                      "plural": true,
                      "selections": [
                        v23,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "candidateExperienceId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "title",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "companyName",
                          "storageKey": null
                        },
                        v6,
                        v7,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "createdOn",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "updatedOn",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "version",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "titleId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "industry",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "companyIsVerified",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "companyId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "description",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "positionType",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "skills",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "escoOccupationId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "escoHierarchy",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "SkillUsage",
                      "kind": "LinkedField",
                      "name": "skills",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "lastUsed",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "DateRange",
                          "kind": "LinkedField",
                          "name": "periods",
                          "plural": true,
                          "selections": [
                            v6,
                            v7
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "averageMonthsUsed",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "totalMonthsUsed",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "totalPositionsUsed",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                v23
              ],
              "storageKey": null
            },
            v5
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "35d8a985db559e07fe6d408745c23ac4",
      "id": null,
      "metadata": {},
      "name": "CandidateApplicationProfileRouteQuery",
      "operationKind": "query",
      "text": "query CandidateApplicationProfileRouteQuery(\n  $applicationCode: Int!\n) {\n  application: applicationByCode(applicationCode: $applicationCode) {\n    id\n    candidate {\n      firstName\n      lastName\n      id\n    }\n    profile {\n      ...CandidateApplicationProfile_profile\n      id\n    }\n  }\n}\n\nfragment CandidateApplicationProfile_profile on RecruitProfile {\n  experiences {\n    items {\n      id\n      candidateExperienceId\n      title\n      companyName\n      startDate\n      endDate\n      ...ExperienceDetails_experience\n    }\n    skills {\n      name\n      lastUsed\n      periods {\n        startDate\n        endDate\n      }\n      averageMonthsUsed\n      totalMonthsUsed\n      totalPositionsUsed\n    }\n  }\n}\n\nfragment ExperienceDetails_experience on RecruitProfileExperience {\n  id\n  createdOn\n  updatedOn\n  candidateExperienceId\n  version\n  titleId\n  title\n  industry\n  companyIsVerified\n  companyId\n  companyName\n  description\n  startDate\n  endDate\n  positionType\n  skills\n  escoOccupationId\n  escoHierarchy\n}\n"
    }
  };
}();
node22.hash = "88f86376705e48d5debf0784b0f95332";
var CandidateApplicationProfileRouteQuery_graphql_default = node22;

// src/candidates/components/__generated__/CandidateApplicationProfile_profile.graphql.ts
var node23 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "startDate",
    "storageKey": null
  }, v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "endDate",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CandidateApplicationProfile_profile",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitProfileExperienceCollection",
        "kind": "LinkedField",
        "name": "experiences",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitProfileExperience",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "candidateExperienceId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "companyName",
                "storageKey": null
              },
              v0,
              v1,
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ExperienceDetails_experience"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SkillUsage",
            "kind": "LinkedField",
            "name": "skills",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastUsed",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DateRange",
                "kind": "LinkedField",
                "name": "periods",
                "plural": true,
                "selections": [
                  v0,
                  v1
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "averageMonthsUsed",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalMonthsUsed",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalPositionsUsed",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RecruitProfile",
    "abstractKey": null
  };
}();
node23.hash = "eccf18a356637d0f0cd3bf51ca758773";
var CandidateApplicationProfile_profile_graphql_default = node23;

// src/candidates/components/CandidateApplicationProfile.tsx
import { Suspense as Suspense6, useState as useState3 } from "react";
import { loadQuery, useFragment as useFragment6 } from "react-relay";
import { Link, useNavigate } from "react-router-dom";
import { formatMonth, useRouteData } from "shared-lib";
import { Button as Button5, ButtonList as ButtonList3, EdSkeleton, Size, Timeline } from "shared-ui";
import { Fragment as Fragment3, jsx as jsx14, jsxs as jsxs10 } from "react/jsx-runtime";
var queryDef4 = CandidateApplicationProfileRouteQuery_graphql_default;
async function loader(environment, params) {
  const code = params.applicationCode;
  const applicationCode = parseInt(code);
  return loadQuery(
    environment,
    queryDef4,
    {
      applicationCode
    }
  );
}
var CandidateApplicationProfile = ({
  routeId: routeId4
}) => {
  const data = useRouteData(
    queryDef4,
    routeId4
  );
  const { application: application3 } = data;
  if (!application3) {
    return /* @__PURE__ */ jsx14(Fragment3, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx14(CandidateApplicationProfileComponent, { fragmentDef: application3.profile });
};
var fragments = {
  profile: CandidateApplicationProfile_profile_graphql_default
};
var CandidateApplicationProfileComponent = ({ onEdit, fragmentDef: fragmentDef122 }) => {
  const navigate = useNavigate();
  const [selectedId, setSelectedId] = useState3(null);
  const profile = useFragment6(
    fragments.profile,
    fragmentDef122
  );
  if (!profile) {
    return /* @__PURE__ */ jsx14(Fragment3, { children: "Loading..." });
  }
  let selectedContainer = null;
  if (selectedId) {
    const selected = profile.experiences.items.find(
      (e4) => e4.candidateExperienceId === selectedId
    );
    if (selected) {
      selectedContainer = /* @__PURE__ */ jsxs10("div", { className: "relative", children: [
        /* @__PURE__ */ jsx14("div", { className: "absolute right-0 top-0 flex justify-end p-5", children: /* @__PURE__ */ jsxs10(ButtonList3, { children: [
          onEdit && /* @__PURE__ */ jsx14(
            Button5,
            {
              color: "primary",
              outline: true,
              clicked: () => navigate(`../edit/${selected.candidateExperienceId}`),
              children: "Edit"
            }
          ),
          /* @__PURE__ */ jsx14(
            Button5,
            {
              size: Size.sm,
              color: "primary",
              clicked: () => setSelectedId(null),
              children: "Close"
            }
          )
        ] }) }),
        /* @__PURE__ */ jsx14(ExperienceDetailsComponent, { fragmentRef: selected })
      ] });
    }
  }
  return /* @__PURE__ */ jsx14(Suspense6, { fallback: /* @__PURE__ */ jsx14(EdSkeleton, {}), children: /* @__PURE__ */ jsxs10("div", { className: "@container flex flex-wrap bg-white", children: [
    selectedContainer ? /* @__PURE__ */ jsx14("div", { className: "flex flex-1 flex-col gap-5 border-r md:px-5", children: selectedContainer }) : /* @__PURE__ */ jsxs10("div", { className: "flex flex-1 flex-col gap-5 border-r md:px-5", children: [
      profile.experiences.items.map((experience) => /* @__PURE__ */ jsx14("div", { className: "bg-white", children: /* @__PURE__ */ jsx14(
        ExperienceDetailsComponent,
        {
          onEdit,
          fragmentRef: experience
        }
      ) }, experience.id)),
      profile.experiences.items.length === 0 && /* @__PURE__ */ jsxs10("div", { className: "flex h-96 flex-col items-center justify-center rounded-lg bg-white", children: [
        /* @__PURE__ */ jsx14("div", { className: "text-2xl font-bold", children: "No experience found" }),
        /* @__PURE__ */ jsx14("div", { className: "text-lg text-gray-500", children: "This user has not added any work experience" })
      ] })
    ] }),
    /* @__PURE__ */ jsx14("div", { children: /* @__PURE__ */ jsx14("div", { className: "w/1-5 @4xl:flex hidden flex-col gap-2 divide-y", children: /* @__PURE__ */ jsx14(
      Timeline,
      {
        list: profile.experiences.items.map((x4) => {
          return {
            title: x4.title,
            body: `${x4.companyName} ${formatMonth(
              x4.startDate
            )} - ${formatMonth(x4.endDate)}`,
            isActive: true,
            isSelected: false,
            isCompleted: false,
            onClick: () => setSelectedId(x4.candidateExperienceId)
          };
        })
      }
    ) }) })
  ] }) });
};
var createRoute = (routePrefix, environment, context) => {
  const routeId4 = `${routePrefix}-application-search-profile`;
  return {
    id: routeId4,
    path: "profile",
    element: /* @__PURE__ */ jsx14(CandidateApplicationProfile, { routeId: routeId4 }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx14(Link, { to: "profile", children: "Profile" })
    },
    loader: ({ params }) => {
      return loader(environment, params);
    }
  };
};

// src/profiles/edit/components/ExperienceList.tsx
import { jsx as jsx15 } from "react/jsx-runtime";
var fragmentDef6 = ExperienceList_profile_graphql_default;
var ExperienceList = ({ fragmentRef }) => {
  const data = useFragment7(fragmentDef6, fragmentRef);
  const navigate = useNavigate2();
  return /* @__PURE__ */ jsx15(ErrorBoundary, { FallbackComponent: ErrorBoundaryFallback, children: /* @__PURE__ */ jsx15(Suspense7, { fallback: /* @__PURE__ */ jsx15(EdSkeleton2, {}), children: /* @__PURE__ */ jsx15(
    CandidateApplicationProfileComponent,
    {
      onEdit: (id18) => navigate(`../edit/${id18}`),
      fragmentDef: data
    }
  ) }) });
};

// src/profiles/edit/components/ExperienceLayout.tsx
import { Fragment as Fragment4, jsx as jsx16, jsxs as jsxs11 } from "react/jsx-runtime";
var queryDef5 = ExperienceLayoutQuery_graphql_default;
var RootContainer = () => {
  return /* @__PURE__ */ jsx16("div", { children: /* @__PURE__ */ jsx16(Outlet, {}) });
};
var ExperienceLayout = ({
  profileId,
  onExperienceChanged
}) => {
  const navigate = useNavigate3();
  const data = useLazyLoadQuery6(
    queryDef5,
    {
      profileId
    },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { profile } = data;
  if (!profile) {
    return /* @__PURE__ */ jsx16("div", { children: "Profile Not Found" });
  }
  return /* @__PURE__ */ jsx16(ErrorBoundary2, { FallbackComponent: ErrorBoundaryFallback2, children: /* @__PURE__ */ jsx16(Suspense8, { fallback: /* @__PURE__ */ jsx16(EdSkeleton3, {}), children: /* @__PURE__ */ jsxs11(Routes, { children: [
    /* @__PURE__ */ jsxs11(Route, { element: /* @__PURE__ */ jsx16(RootContainer, {}), children: [
      /* @__PURE__ */ jsx16(
        Route,
        {
          path: "list/*",
          element: /* @__PURE__ */ jsx16(
            RouteContent,
            {
              title: "Work Experience",
              actions: /* @__PURE__ */ jsx16("div", { className: "w-sm", children: /* @__PURE__ */ jsx16(EdButtonLink, { name: "Add", to: "../add" }) }),
              children: /* @__PURE__ */ jsx16(ExperienceList, { fragmentRef: profile })
            }
          )
        }
      ),
      /* @__PURE__ */ jsx16(
        Route,
        {
          path: "add/*",
          element: /* @__PURE__ */ jsx16(
            RouteContent,
            {
              title: "Add Work Experience",
              actions: /* @__PURE__ */ jsx16("div", { children: /* @__PURE__ */ jsx16(
                Link2,
                {
                  className: "inline-flex items-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2",
                  to: "../",
                  children: "Back"
                }
              ) }),
              children: /* @__PURE__ */ jsx16(
                ExperienceAdd,
                {
                  profileId: profile.recruitProfileId,
                  onAdded: () => {
                    onExperienceChanged();
                    navigate("./list");
                  },
                  onCancel: () => {
                    navigate("./list");
                  }
                }
              )
            }
          )
        }
      ),
      /* @__PURE__ */ jsx16(
        Route,
        {
          path: "edit/:id/*",
          element: /* @__PURE__ */ jsx16(
            ExperienceEdit,
            {
              profileId: profile.recruitProfileId,
              onDone: (id18) => {
                onExperienceChanged();
                navigate(`./list/${id18}`);
              },
              onCancel: (id18) => {
                navigate(`./list/${id18}`);
              }
            }
          )
        }
      ),
      /* @__PURE__ */ jsx16(
        Route,
        {
          path: "delete/:id/*",
          element: /* @__PURE__ */ jsx16(RouteContent, { title: "Delete Work Experience", children: /* @__PURE__ */ jsx16(
            ExperienceDelete,
            {
              profileId: profile.recruitProfileId,
              onDone: () => {
                onExperienceChanged();
                navigate(`./list`);
              },
              onCancel: (id18) => {
                navigate(`./list/${id18}`);
              }
            }
          ) })
        }
      ),
      /* @__PURE__ */ jsx16(
        Route,
        {
          path: "view/:id/*",
          element: /* @__PURE__ */ jsx16(
            RouteContent,
            {
              title: "View Experience",
              actions: /* @__PURE__ */ jsx16("div", { children: /* @__PURE__ */ jsx16(
                Link2,
                {
                  className: "inline-flex items-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2",
                  to: "../",
                  children: "Back"
                }
              ) }),
              children: /* @__PURE__ */ jsx16(
                ExperienceDetails,
                {
                  onEdit: (id18) => {
                    navigate(`./edit/${id18}`);
                  },
                  onDelete: (id18) => {
                    navigate(`./delete/${id18}`);
                  },
                  onBack: (id18) => {
                    navigate(`./list/${id18}`);
                  }
                }
              )
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ jsx16(Route, { path: "*", element: /* @__PURE__ */ jsx16(Navigate, { to: "./list" }) })
  ] }) }) });
};

// src/profiles/edit/components/__generated__/ExperienceViewer_profile.graphql.ts
var node24 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ExperienceViewer_profile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "candidateExperienceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "companyName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "skills",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "industry",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "positionType",
      "storageKey": null
    }
  ],
  "type": "RecruitProfileExperience",
  "abstractKey": null
};
node24.hash = "db4fb3d8acce64cef5726ef739fd29aa";
var ExperienceViewer_profile_graphql_default = node24;

// src/profiles/edit/components/ExperienceViewer.tsx
import { useFragment as useFragment8 } from "react-relay";
import { format as format4, formatDistance as formatDistance4 } from "date-fns";
import { isNotNull as isNotNull2, parseDate as parseDate5 } from "shared-lib";
import { Tag as Tag3, Tags as Tags3 } from "shared-ui";
import { jsx as jsx17, jsxs as jsxs12 } from "react/jsx-runtime";
var fragmentDef7 = ExperienceViewer_profile_graphql_default;
var ExperienceViewer = ({ fragmentRef }) => {
  const data = useFragment8(
    fragmentDef7,
    fragmentRef
  );
  const startDate = parseDate5(data.startDate);
  const endDate = parseDate5(data.endDate);
  const skills = (data.skills || []).filter(isNotNull2);
  return /* @__PURE__ */ jsxs12("div", { className: "flex flex-col overflow-hidden rounded-lg border bg-white hover:bg-gray-50", children: [
    /* @__PURE__ */ jsxs12("div", { className: "border-b border-gray-200 px-4 py-5 sm:px-6", children: [
      /* @__PURE__ */ jsxs12("div", { className: "flex justify-between", children: [
        /* @__PURE__ */ jsxs12("h3", { className: "text-lg font-medium leading-10 text-gray-900", children: [
          data.title,
          " | ",
          /* @__PURE__ */ jsx17("strong", { children: data.companyName })
        ] }),
        /* @__PURE__ */ jsx17("div", { children: /* @__PURE__ */ jsx17(Tag3, { size: "xsmall", children: data.positionType }) })
      ] }),
      /* @__PURE__ */ jsx17("div", { className: "flex flex-grow items-center", children: /* @__PURE__ */ jsxs12("div", { children: [
        format4(startDate, "LLLL y"),
        " - ",
        format4(endDate, "LLLL y"),
        " (",
        formatDistance4(startDate, endDate),
        ")\xA0"
      ] }) })
    ] }),
    /* @__PURE__ */ jsxs12("div", { className: "px-6 py-5", children: [
      /* @__PURE__ */ jsx17("div", { className: "whitespace-pre-wrap", children: data.description }),
      /* @__PURE__ */ jsx17("div", { className: "flex gap-1 pt-2", children: /* @__PURE__ */ jsx17(Tags3, { size: "xsmall", list: skills }) })
    ] })
  ] });
};

// src/profiles/edit/components/__generated__/IndustriesTags_profile.graphql.ts
var node25 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "IndustriesTags_profile",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitProfileExperience",
        "kind": "LinkedField",
        "name": "experience",
        "plural": true,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "industry",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RecruitProfile",
    "abstractKey": null
  };
}();
node25.hash = "3c2eafa9554c2341122e7947366ac540";
var IndustriesTags_profile_graphql_default = node25;

// src/profiles/edit/components/IndustriesTags.tsx
import { useFragment as useFragment9 } from "react-relay";
import { isNotNull as isNotNull3 } from "shared-lib";
import { Tags as Tags4 } from "shared-ui";
import { jsx as jsx18 } from "react/jsx-runtime";
var fragmentDef8 = IndustriesTags_profile_graphql_default;
var IndustriesTags = ({ fragmentRef }) => {
  const data = useFragment9(
    fragmentDef8,
    fragmentRef
  );
  const companies = (data.experience || []).map((e4) => e4.industry).filter(isNotNull3).filter((x4) => x4 !== "");
  return /* @__PURE__ */ jsx18(Tags4, { size: "xsmall", list: [...new Set(companies)] });
};

// src/profiles/shared/components/JobSearchStatusLabel.tsx
import { Fragment as Fragment5, jsx as jsx19 } from "react/jsx-runtime";
var JobSearchStatusLabel = ({ status }) => {
  let label = null;
  switch (status) {
    case "NOT_LOOKING":
      label = "Not Looking";
      break;
    case "ACTIVELY_LOOKING":
      label = "Actively Looking";
      break;
    case "PASSIVELY_LOOKING":
      label = "Passively Looking";
      break;
  }
  if (!label) {
    return /* @__PURE__ */ jsx19(Fragment5, {});
  }
  return /* @__PURE__ */ jsx19("div", { className: "inline whitespace-nowrap", children: label });
};

// src/profiles/edit/components/__generated__/ProfileEdit_profile.graphql.ts
var node26 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileEdit_profile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recruitProfileId",
      "storageKey": null
    }
  ],
  "type": "RecruitProfile",
  "abstractKey": null
};
node26.hash = "b0adbc1d715a30129768b0ba83fbfe1d";
var ProfileEdit_profile_graphql_default = node26;

// src/profiles/edit/components/__generated__/ProfileEditMutation.graphql.ts
var node27 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "input",
          "variableName": "input"
        }
      ],
      "concreteType": "RecruitCandidateProfileSummaryUpdatePayload",
      "kind": "LinkedField",
      "name": "recruitCandidateProfileSummaryUpdate",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EdgeOfCandidateExperienceSummary",
          "kind": "LinkedField",
          "name": "profile",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfileSummary",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "statementYourExperience",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "statementWhatYouWant",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "currentJobTitleName",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ProfileEditMutation",
      "selections": v1,
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ProfileEditMutation",
      "selections": v1
    },
    "params": {
      "cacheID": "2c3b1a05dc639d7496661b709a46342a",
      "id": null,
      "metadata": {},
      "name": "ProfileEditMutation",
      "operationKind": "mutation",
      "text": "mutation ProfileEditMutation(\n  $input: RecruitCandidateProfileSummaryUpdateInput!\n) {\n  recruitCandidateProfileSummaryUpdate(input: $input) {\n    profile {\n      node {\n        id\n        statementYourExperience\n        statementWhatYouWant\n        currentJobTitleName\n      }\n    }\n  }\n}\n"
    }
  };
}();
node27.hash = "5d0418ae1354d724ebcf4298087c5349";
var ProfileEditMutation_graphql_default = node27;

// src/profiles/edit/components/ProfileEdit.tsx
import { useCallback as useCallback9, useState as useState4 } from "react";
import { useFragment as useFragment10, useMutation as useMutation5 } from "react-relay";
import { useNavigate as useNavigate4 } from "react-router-dom";
import { useForm as useForm2 } from "react-hook-form";
import * as zod from "zod";
import { zodResolver as zodResolver2 } from "@hookform/resolvers/zod";
import {
  createClientMutationId as createClientMutationId5,
  useToggle as useToggle3
} from "shared-lib";
import { Button as Button6, FormInput, Size as Size2 } from "shared-ui";
import { UserErrorList } from "app-core";
import { jsx as jsx20, jsxs as jsxs13 } from "react/jsx-runtime";
var formSchema = zod.object({
  statementYourExperience: zod.string().nonempty(),
  statementWhatYouWant: zod.string().nonempty(),
  jobTitle: zod.object({
    jobTitleId: zod.string().optional(),
    jobTitleName: zod.string().optional()
  }).required()
});
var fragmentDef9 = ProfileEdit_profile_graphql_default;
var mutationDef5 = ProfileEditMutation_graphql_default;
var ProfileEdit = ({
  fragmentRef,
  onCompleted,
  onError,
  onBack
}) => {
  const data = useFragment10(fragmentDef9, fragmentRef);
  const navigate = useNavigate4();
  const [formData, setFormData] = useState4({
    statementYourExperience: "",
    statementWhatYouWant: "",
    jobTitle: ""
  });
  const [criticalFailure, toggleCriticalFailure] = useToggle3(false);
  const [userErrors, setUserErrors] = useState4([]);
  const [commit11, isMutationInFlight] = useMutation5(mutationDef5);
  const { register, handleSubmit, formState, control } = useForm2({
    resolver: zodResolver2(formSchema)
  });
  const { errors, isValid } = formState;
  const onSubmit = handleSubmit((data2) => onCreateExperience(isValid, data2));
  const onCreateExperience = useCallback9(
    (isValid2, form) => {
      commit11({
        variables: {
          input: {
            clientMutationId: createClientMutationId5(),
            profileId: data.recruitProfileId,
            statementYourExperience: form.statementYourExperience,
            statementWhatYouWant: form.statementWhatYouWant,
            jobTitleName: form.jobTitle?.jobTitleName
          }
        }
      });
    },
    [data, commit11]
  );
  return /* @__PURE__ */ jsx20("div", { className: "mt-4 shadow sm:rounded-md md:w-3/4 lg:w-1/2", children: /* @__PURE__ */ jsxs13("div", { className: "space-y-6 bg-white px-4 py-5 sm:p-6", children: [
    /* @__PURE__ */ jsxs13("div", { className: "sm:mx-auto sm:w-full sm:max-w-md", children: [
      /* @__PURE__ */ jsx20("h2", { className: "mt-6 text-center text-3xl font-bold tracking-tight text-gray-900", children: "Sign up to find work you'll love" }),
      /* @__PURE__ */ jsx20("p", { className: "text-md mt-2 text-center text-gray-600", children: "Create an account or sign-in" })
    ] }),
    criticalFailure ? /* @__PURE__ */ jsx20("div", { children: "A error has occurred, please try again" }) : null,
    userErrors ? /* @__PURE__ */ jsx20(UserErrorList, { errors: userErrors }) : null,
    /* @__PURE__ */ jsxs13("form", { onSubmit, children: [
      /* @__PURE__ */ jsx20("div", { className: "flex", children: /* @__PURE__ */ jsxs13("div", { className: "flex-grow", children: [
        /* @__PURE__ */ jsx20("label", { children: "Job Title *" }),
        /* @__PURE__ */ jsx20(JobTitleSearchBoxInput, { control, name: "jobTitle" })
      ] }) }),
      /* @__PURE__ */ jsxs13("div", { className: "mt-4", children: [
        /* @__PURE__ */ jsx20("label", { children: "Describe your ideal role " }),
        /* @__PURE__ */ jsx20(
          FormInput,
          {
            className: "mt-1",
            type: "text",
            placeholder: " Your ideal role ",
            name: "statementWhatYouWant",
            required: true,
            register
          }
        )
      ] }),
      /* @__PURE__ */ jsxs13("div", { className: "mt-4", children: [
        /* @__PURE__ */ jsx20("label", { children: "Your experience" }),
        /* @__PURE__ */ jsx20(
          FormInput,
          {
            className: "mt-1",
            type: "text",
            placeholder: " Your experience ",
            name: "statementYourExperience",
            required: true,
            register
          }
        )
      ] }),
      /* @__PURE__ */ jsx20("div", { className: "mt-5 flex", children: /* @__PURE__ */ jsx20(
        Button6,
        {
          className: "flex-1",
          disabled: !isValid || isMutationInFlight,
          color: "primary",
          size: Size2.xl,
          type: "submit",
          children: "Update"
        }
      ) })
    ] })
  ] }) });
};

// src/profiles/edit/components/__generated__/ProfileInfoSidebar_profile.graphql.ts
var node28 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "countryCode",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProfileInfoSidebar_profile",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitProfileExperience",
        "kind": "LinkedField",
        "name": "experience",
        "plural": true,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "candidateExperienceId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "companyName",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitProfileRate",
        "kind": "LinkedField",
        "name": "rate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "payType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "minimumRateOfPay",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "maximumRateOfPay",
            "storageKey": null
          },
          v1,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currencyCode",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitProfileAvailability",
        "kind": "LinkedField",
        "name": "availability",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "jobSearchStatus",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitProfileWorkLocations",
        "kind": "LinkedField",
        "name": "workLocations",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "WorkLocationEntry",
            "kind": "LinkedField",
            "name": "workLocations",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              v1
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RecruitProfile",
    "abstractKey": null
  };
}();
node28.hash = "a24fbee37cd759107e9e9bddb44b1028";
var ProfileInfoSidebar_profile_graphql_default = node28;

// src/profiles/edit/components/ProfileInfoSidebar.tsx
import { useFragment as useFragment11 } from "react-relay";
import { Button as Button7, EdLink as EdLink2, classNames as classNames2 } from "shared-ui";

// src/profiles/shared/components/RateLabel.tsx
import { jsx as jsx21, jsxs as jsxs14 } from "react/jsx-runtime";
function payTypeLabel(payType) {
  switch (payType) {
    case "PER_DAY":
      return "per Day";
    case "PER_HOUR":
      return "per Hour";
    case "PER_YEAR":
      return "per year";
  }
  return "";
}
var RateLabel = ({ rate }) => {
  let minimumRateOfPay = rate?.minimumRateOfPay.toString();
  let maximumRateOfPay = rate?.maximumRateOfPay.toString();
  if (rate) {
    const currencyFormatter = new Intl.NumberFormat(void 0, {
      style: "currency",
      currency: rate?.currencyCode ?? void 0,
      maximumFractionDigits: 2
    });
    minimumRateOfPay = currencyFormatter.format(rate.minimumRateOfPay);
    maximumRateOfPay = currencyFormatter.format(rate.maximumRateOfPay);
  }
  return /* @__PURE__ */ jsxs14("div", { className: "flex flex-wrap items-baseline gap-1", children: [
    /* @__PURE__ */ jsxs14("div", { className: "mb-2 text-xl capitalize text-purple-900 sm:mb-0", children: [
      minimumRateOfPay,
      " - ",
      maximumRateOfPay
    ] }),
    rate && /* @__PURE__ */ jsx21("small", { className: "", children: payTypeLabel(rate.payType) })
  ] });
};

// src/profiles/edit/components/ProfileInfoSidebar.tsx
import { Fragment as Fragment6, jsx as jsx22, jsxs as jsxs15 } from "react/jsx-runtime";
var fragmentDef10 = ProfileInfoSidebar_profile_graphql_default;
var defaultJobSearchStatus = "UNKNOWN";
var ProfileInfoSidebar = ({ fragmentRef }) => {
  const data = useFragment11(
    fragmentDef10,
    fragmentRef
  );
  const workLocations = (data.workLocations?.workLocations || []).map(
    (e4) => `${e4.name} (${e4.countryCode})`
  );
  const searchStatus = data.availability?.jobSearchStatus || defaultJobSearchStatus;
  const isLookingForWork = searchStatus !== "NOT_LOOKING";
  return /* @__PURE__ */ jsx22(EdLink2, { href: `/candidates/app/account/rate`, name: "edit-rate", children: /* @__PURE__ */ jsxs15("div", { className: "flex flex-col gap-5", children: [
    /* @__PURE__ */ jsx22(FillInLocationRates, { workLocations, rate: data.rate }),
    workLocations.length > 0 && data.rate?.maximumRateOfPay !== 0 && /* @__PURE__ */ jsx22(
      "div",
      {
        className: classNames2(
          "flex flex-col gap-3 ",
          isLookingForWork ? "text-primary-900 bg-white" : "bg-red-500 text-white"
        ),
        children: /* @__PURE__ */ jsxs15("div", { children: [
          searchStatus === "NOT_LOOKING" && /* @__PURE__ */ jsx22("div", { children: /* @__PURE__ */ jsx22("div", { className: "font-bold leading-5", children: "Not looking for work" }) }),
          searchStatus !== "NOT_LOOKING" && /* @__PURE__ */ jsxs15("div", { className: "flex flex-col gap-2", children: [
            /* @__PURE__ */ jsx22("div", { className: "", children: /* @__PURE__ */ jsx22(RateLabel, { rate: data.rate }) }),
            /* @__PURE__ */ jsxs15("div", { className: "mt-3 text-base leading-6", children: [
              /* @__PURE__ */ jsx22(JobSearchStatusLabel, { status: searchStatus }),
              ` for work in:`,
              /* @__PURE__ */ jsx22("div", { className: "mb-2 text-xl capitalize text-purple-900 sm:mb-0", children: workLocations.join(", ") })
            ] })
          ] })
        ] })
      }
    )
  ] }) });
};
var FillInLocationRates = ({ workLocations, rate }) => {
  const hasSetWorkLocation = workLocations.length > 0;
  let addLocation = /* @__PURE__ */ jsx22(Fragment6, {});
  let addRate = /* @__PURE__ */ jsx22(Fragment6, {});
  if (!hasSetWorkLocation) {
    addLocation = /* @__PURE__ */ jsx22("div", { className: "flex justify-center border-2 border-dashed border-gray-200 bg-white p-5", children: /* @__PURE__ */ jsx22(EdLink2, { name: "locations", href: "/candidates/app/account/locations", children: /* @__PURE__ */ jsx22(Button7, { color: "primary", children: "Add work locations" }) }) });
  }
  const hasSetRate = rate.maximumRateOfPay !== 0;
  if (!hasSetRate) {
    addRate = /* @__PURE__ */ jsx22("div", { className: "flex justify-center border-2 border-dashed border-gray-200 bg-white p-5", children: /* @__PURE__ */ jsx22(EdLink2, { href: "/candidates/app/account/rate", name: "add-rate", children: /* @__PURE__ */ jsx22(Button7, { color: "primary", children: "Add your rate" }) }) });
  }
  return /* @__PURE__ */ jsxs15(Fragment6, { children: [
    addLocation,
    addRate
  ] });
};

// src/profiles/edit/components/ProfileSearchBox.tsx
var import_lodash = __toESM(require_lodash());
import {
  useCallback as useCallback10,
  useEffect as useEffect4,
  useMemo as useMemo3,
  useState as useState5,
  Suspense as Suspense9
} from "react";
import { ChevronUpDownIcon as ChevronUpDownIcon2 } from "@heroicons/react/24/solid";
import { Combobox as Combobox4 } from "@headlessui/react";

// src/profiles/edit/components/__generated__/ProfileSearchOptionsPaginationQuery.graphql.ts
var node29 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v23 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v32 = [
    v1,
    v23,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "firstName": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ProfileSearchOptionsPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v23
          ],
          "kind": "FragmentSpread",
          "name": "ProfileSearchOptions_results"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ProfileSearchOptionsPaginationQuery",
      "selections": [
        {
          "alias": "results",
          "args": v32,
          "concreteType": "RecruitProfilesConnection",
          "kind": "LinkedField",
          "name": "recruitProfiles",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfilesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfile",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "recruitProfileId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "firstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "emailAddress",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "results",
          "args": v32,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "ProfileSearchOptions_results",
          "kind": "LinkedHandle",
          "name": "recruitProfiles"
        }
      ]
    },
    "params": {
      "cacheID": "8b14b9b1d1e054cea2dd63ccc039f262",
      "id": null,
      "metadata": {},
      "name": "ProfileSearchOptionsPaginationQuery",
      "operationKind": "query",
      "text": "query ProfileSearchOptionsPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $where: RecruitProfileFilter\n) {\n  ...ProfileSearchOptions_results_2HEEH6\n}\n\nfragment ProfileSearchOptions_results_2HEEH6 on Query {\n  results: recruitProfiles(first: $first, after: $after, order: [{firstName: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        recruitProfileId\n        code\n        firstName\n        lastName\n        emailAddress\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node29.hash = "6eebe659c3699e7bc3fa3d0516a3119f";
var ProfileSearchOptionsPaginationQuery_graphql_default = node29;

// src/profiles/edit/components/__generated__/ProfileSearchOptions_results.graphql.ts
var node30 = function() {
  var v0 = [
    "results"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": ProfileSearchOptionsPaginationQuery_graphql_default
      }
    },
    "name": "ProfileSearchOptions_results",
    "selections": [
      {
        "alias": "results",
        "args": [
          {
            "kind": "Literal",
            "name": "order",
            "value": [
              {
                "firstName": "DESC"
              }
            ]
          },
          {
            "kind": "Variable",
            "name": "where",
            "variableName": "where"
          }
        ],
        "concreteType": "RecruitProfilesConnection",
        "kind": "LinkedField",
        "name": "__ProfileSearchOptions_results_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitProfilesEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitProfile",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "recruitProfileId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "emailAddress",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node30.hash = "6eebe659c3699e7bc3fa3d0516a3119f";
var ProfileSearchOptions_results_graphql_default = node30;

// src/profiles/edit/components/ProfileSearchOptions.tsx
import { useEffect as useEffect3 } from "react";
import { usePaginationFragment as usePaginationFragment2 } from "react-relay/hooks";
import { Combobox as Combobox3 } from "@headlessui/react";
import { CheckIcon as CheckIcon2 } from "@heroicons/react/24/solid";
import { isNotNull as isNotNull4 } from "shared-lib";
import { classNames as classNames3 } from "shared-ui";
import { Fragment as Fragment7, jsx as jsx23, jsxs as jsxs16 } from "react/jsx-runtime";
var fragmentDef11 = ProfileSearchOptions_results_graphql_default;
var ProfileSearchOptions = ({
  fragmentRef,
  searchTerm
}) => {
  const { data, refetch } = usePaginationFragment2(fragmentDef11, fragmentRef);
  const where = {
    isDeactivated: { eq: false }
  };
  if (searchTerm) {
    where.and = [
      {
        or: [
          { firstName: { startsWith: searchTerm } },
          { lastName: { startsWith: searchTerm } },
          { emailAddress: { startsWith: searchTerm } }
        ]
      },
      { isDeactivated: { eq: false } }
    ];
  }
  useEffect3(() => {
    refetch({ first: 10, where }, { fetchPolicy: "store-or-network" });
  }, [searchTerm]);
  const { results } = data;
  const rows = (results?.edges ?? []).map((edge) => edge.node).filter(isNotNull4);
  return /* @__PURE__ */ jsx23(Combobox3.Options, { className: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm", children: rows.map((result) => /* @__PURE__ */ jsx23(
    Combobox3.Option,
    {
      value: result,
      className: ({ active }) => classNames3(
        "relative cursor-default select-none py-2 pl-3 pr-9",
        active ? "bg-info-600 text-white" : "text-gray-900"
      ),
      children: ({ active, selected }) => /* @__PURE__ */ jsxs16(Fragment7, { children: [
        /* @__PURE__ */ jsx23("div", { className: "flex", children: /* @__PURE__ */ jsxs16(
          "span",
          {
            className: classNames3(
              "truncate",
              selected ? "font-semibold" : ""
            ),
            children: [
              result.firstName,
              " ",
              result.lastName,
              " - ",
              result.emailAddress
            ]
          }
        ) }),
        selected && /* @__PURE__ */ jsx23(
          "span",
          {
            className: classNames3(
              "absolute inset-y-0 right-0 flex items-center pr-4",
              active ? "bg-info-600 text-white" : "text-info-600"
            ),
            children: /* @__PURE__ */ jsx23(CheckIcon2, { className: "h-5 w-5", "aria-hidden": "true" })
          }
        )
      ] })
    },
    result.id
  )) });
};

// src/profiles/edit/components/ProfileSearchBox.tsx
import { jsx as jsx24, jsxs as jsxs17 } from "react/jsx-runtime";
var ProfileSearchBox = ({
  onSelected,
  fragmentRef,
  defaultValue
}) => {
  const [selected, setSelected] = useState5(
    defaultValue ?? null
  );
  const [searchTerm, setSearchTerm] = useState5("");
  const onQueryChangeHandler = useMemo3(
    () => (0, import_lodash.debounce)((q4) => setSearchTerm(q4), 500),
    []
  );
  useEffect4(() => {
    return () => {
      onQueryChangeHandler.cancel();
    };
  }, []);
  const onSetSelected = useCallback10(
    (r4) => {
      setSelected(r4);
      onSelected(r4);
    },
    [selected]
  );
  return /* @__PURE__ */ jsx24(Combobox4, { as: "div", value: selected, onChange: onSetSelected, children: /* @__PURE__ */ jsxs17("div", { className: "relative mt-2", children: [
    /* @__PURE__ */ jsx24(
      Combobox4.Input,
      {
        className: "focus:border-info-500 focus:ring-info-500 w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:outline-none focus:ring-1 sm:text-sm",
        onChange: (event) => onQueryChangeHandler(event.target.value),
        displayValue: (result) => {
          if (result) {
            return `${result.firstName} ${result.lastName} (${result.emailAddress})`;
          }
          return "";
        },
        autoComplete: "off"
      }
    ),
    /* @__PURE__ */ jsx24(Combobox4.Button, { className: "absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none", children: /* @__PURE__ */ jsx24(
      ChevronUpDownIcon2,
      {
        className: "h-5 w-5 text-gray-400",
        "aria-hidden": "true"
      }
    ) }),
    /* @__PURE__ */ jsx24(Suspense9, { fallback: "Searching...", children: /* @__PURE__ */ jsx24(
      ProfileSearchOptions,
      {
        fragmentRef,
        searchTerm
      }
    ) })
  ] }) });
};

// src/profiles/edit/components/__generated__/ProfileSearchBoxInputQuery.graphql.ts
var node31 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "firstName": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ProfileSearchBoxInputQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProfileSearchOptions_results"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ProfileSearchBoxInputQuery",
      "selections": [
        {
          "alias": "results",
          "args": v1,
          "concreteType": "RecruitProfilesConnection",
          "kind": "LinkedField",
          "name": "recruitProfiles",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfilesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfile",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "recruitProfileId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "firstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "emailAddress",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "results",
          "args": v1,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "ProfileSearchOptions_results",
          "kind": "LinkedHandle",
          "name": "recruitProfiles"
        }
      ]
    },
    "params": {
      "cacheID": "69d266ddee52663603bf5ab453c6b78a",
      "id": null,
      "metadata": {},
      "name": "ProfileSearchBoxInputQuery",
      "operationKind": "query",
      "text": "query ProfileSearchBoxInputQuery(\n  $where: RecruitProfileFilter!\n) {\n  ...ProfileSearchOptions_results\n}\n\nfragment ProfileSearchOptions_results on Query {\n  results: recruitProfiles(first: 10, order: [{firstName: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        recruitProfileId\n        code\n        firstName\n        lastName\n        emailAddress\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node31.hash = "d8b71e1bc3faf05fadbe362a80287b19";
var ProfileSearchBoxInputQuery_graphql_default = node31;

// src/profiles/edit/components/ProfileSearchBoxInput.tsx
import { Controller as Controller3 } from "react-hook-form";
import { useLazyLoadQuery as useLazyLoadQuery7 } from "react-relay/hooks";
import { jsx as jsx25 } from "react/jsx-runtime";
var graphqlQuery3 = ProfileSearchBoxInputQuery_graphql_default;
var ProfileSearchBoxInput = ({
  name,
  control,
  defaultValue
}) => {
  const where = {
    isDeactivated: { eq: false }
  };
  const query3 = useLazyLoadQuery7(
    graphqlQuery3,
    { where },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsx25(
    Controller3,
    {
      control,
      name,
      render: ({ field: { onChange: onControllerChange } }) => /* @__PURE__ */ jsx25(
        ProfileSearchBox,
        {
          onSelected: (result) => {
            onControllerChange(result.id);
          },
          fragmentRef: query3,
          defaultValue
        }
      )
    }
  );
};

// src/profiles/edit/components/__generated__/ProfileSearchBoxContainerQuery.graphql.ts
var node32 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "firstName": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ProfileSearchBoxContainerQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProfileSearchOptions_results"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ProfileSearchBoxContainerQuery",
      "selections": [
        {
          "alias": "results",
          "args": v1,
          "concreteType": "RecruitProfilesConnection",
          "kind": "LinkedField",
          "name": "recruitProfiles",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfilesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfile",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "recruitProfileId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "firstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "emailAddress",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "results",
          "args": v1,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "ProfileSearchOptions_results",
          "kind": "LinkedHandle",
          "name": "recruitProfiles"
        }
      ]
    },
    "params": {
      "cacheID": "57dd6b769d9d1746f3b1719ea2a4529e",
      "id": null,
      "metadata": {},
      "name": "ProfileSearchBoxContainerQuery",
      "operationKind": "query",
      "text": "query ProfileSearchBoxContainerQuery(\n  $where: RecruitProfileFilter!\n) {\n  ...ProfileSearchOptions_results\n}\n\nfragment ProfileSearchOptions_results on Query {\n  results: recruitProfiles(first: 10, order: [{firstName: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        recruitProfileId\n        code\n        firstName\n        lastName\n        emailAddress\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node32.hash = "8495473642ab027b01c263d599dbc669";
var ProfileSearchBoxContainerQuery_graphql_default = node32;

// src/profiles/edit/components/ProfileSearchBoxContainer.tsx
import { useCallback as useCallback11, useState as useState6 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery8 } from "react-relay/hooks";
import { jsx as jsx26 } from "react/jsx-runtime";
var graphqlQuery4 = ProfileSearchBoxContainerQuery_graphql_default;
var ProfileSearchBoxContainer = ({
  onSearchCompleted
}) => {
  const [selectedResult, setSelectedResult] = useState6();
  const onSetSelected = useCallback11(
    (r4) => {
      setSelectedResult(r4);
      onSearchCompleted(r4);
    },
    [selectedResult]
  );
  const where = {
    isDeactivated: { eq: false }
  };
  const query3 = useLazyLoadQuery8(
    graphqlQuery4,
    { where },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsx26(ProfileSearchBox, { onSelected: onSetSelected, fragmentRef: query3 });
};

// src/profiles/edit/components/__generated__/ProfileContainer_tasks.graphql.ts
var node33 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "type",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [
      {
        "kind": "RootArgument",
        "name": "candidateId"
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProfileContainer_tasks",
    "selections": [
      {
        "alias": "globalTasks",
        "args": [
          {
            "kind": "Variable",
            "name": "candidateId",
            "variableName": "candidateId"
          }
        ],
        "concreteType": "CandidateTaskGlobalGroup",
        "kind": "LinkedField",
        "name": "tasksCandidateGlobalTasks",
        "plural": true,
        "selections": [
          v0,
          v1,
          {
            "alias": null,
            "args": null,
            "concreteType": "TasksCandidateTask",
            "kind": "LinkedField",
            "name": "tasks",
            "plural": true,
            "selections": [
              v0,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              v1
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node33.hash = "3b8f4d737f8e027c9ac069e52cec319f";
var ProfileContainer_tasks_graphql_default = node33;

// src/profiles/edit/components/__generated__/ProfileContainerRecommendationPaginationQuery.graphql.ts
var node34 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 8,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": {
        "createdOn": "DESC"
      },
      "kind": "LocalArgument",
      "name": "sort"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v23 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v32 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }, v4 = [
    v1,
    v23,
    {
      "kind": "Variable",
      "name": "order",
      "variableName": "sort"
    },
    v32
  ], v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ProfileContainerRecommendationPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v23,
            {
              "kind": "Variable",
              "name": "sort",
              "variableName": "sort"
            },
            v32
          ],
          "kind": "FragmentSpread",
          "name": "ProfileContainer_recommendations"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ProfileContainerRecommendationPaginationQuery",
      "selections": [
        {
          "alias": "recommendations",
          "args": v4,
          "concreteType": "RecruitRecommendationsConnection",
          "kind": "LinkedField",
          "name": "recruitRecommendations",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitRecommendationsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitRecommendation",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v5,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "recruitRecommendationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currentStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Vacancy",
                      "kind": "LinkedField",
                      "name": "vacancy",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "code",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "employerLogoUrl",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "employerName",
                          "storageKey": null
                        },
                        v5
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "recommendations",
          "args": v4,
          "filters": [],
          "handle": "connection",
          "key": "ProfileContainer_recommendations",
          "kind": "LinkedHandle",
          "name": "recruitRecommendations"
        }
      ]
    },
    "params": {
      "cacheID": "f989f12c6dcf7e86fa0305b09505bacb",
      "id": null,
      "metadata": {},
      "name": "ProfileContainerRecommendationPaginationQuery",
      "operationKind": "query",
      "text": "query ProfileContainerRecommendationPaginationQuery(\n  $after: String\n  $first: Int = 8\n  $sort: [RecruitRecommendationSort!] = {createdOn: DESC}\n  $where: RecruitRecommendationFilter\n) {\n  ...ProfileContainer_recommendations_5yRcm\n}\n\nfragment ProfileContainer_recommendations_5yRcm on Query {\n  recommendations: recruitRecommendations(first: $first, after: $after, where: $where, order: $sort) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        recruitRecommendationId\n        currentStatus\n        vacancy {\n          name\n          code\n          employerLogoUrl\n          employerName\n          id\n        }\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node34.hash = "28f298b28a5e2876a98b74193a52c763";
var ProfileContainerRecommendationPaginationQuery_graphql_default = node34;

// src/profiles/edit/components/__generated__/ProfileContainer_recommendations.graphql.ts
var node35 = function() {
  var v0 = [
    "recommendations"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 8,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "defaultValue": {
          "createdOn": "DESC"
        },
        "kind": "LocalArgument",
        "name": "sort"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": ProfileContainerRecommendationPaginationQuery_graphql_default
      }
    },
    "name": "ProfileContainer_recommendations",
    "selections": [
      {
        "alias": "recommendations",
        "args": null,
        "concreteType": "RecruitRecommendationsConnection",
        "kind": "LinkedField",
        "name": "__ProfileContainer_recommendations_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitRecommendationsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitRecommendation",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "recruitRecommendationId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "currentStatus",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Vacancy",
                    "kind": "LinkedField",
                    "name": "vacancy",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "code",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "employerLogoUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "employerName",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node35.hash = "28f298b28a5e2876a98b74193a52c763";
var ProfileContainer_recommendations_graphql_default = node35;

// src/profiles/edit/components/__generated__/ProfileContainerInterviewListPaginationQuery.graphql.ts
var node36 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 4,
      "kind": "LocalArgument",
      "name": "first"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "after",
      "variableName": "after"
    },
    {
      "kind": "Variable",
      "name": "first",
      "variableName": "first"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ProfileContainerInterviewListPaginationQuery",
      "selections": [
        {
          "args": v1,
          "kind": "FragmentSpread",
          "name": "ProfileContainer_interviews"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ProfileContainerInterviewListPaginationQuery",
      "selections": [
        {
          "alias": "interviews",
          "args": v1,
          "concreteType": "RecruitInterviewsConnection",
          "kind": "LinkedField",
          "name": "recruitInterviews",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitInterviewsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitInterview",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v23,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "interviewId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "vacancyId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "applicationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "stage",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "type",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Vacancy",
                      "kind": "LinkedField",
                      "name": "vacancy",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "code",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "employerName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "employerLogoUrl",
                          "storageKey": null
                        },
                        v23
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "interviews",
          "args": v1,
          "filters": [],
          "handle": "connection",
          "key": "ProfileContainer_interviews",
          "kind": "LinkedHandle",
          "name": "recruitInterviews"
        }
      ]
    },
    "params": {
      "cacheID": "0e1006374aa23e600d969541d4067740",
      "id": null,
      "metadata": {},
      "name": "ProfileContainerInterviewListPaginationQuery",
      "operationKind": "query",
      "text": "query ProfileContainerInterviewListPaginationQuery(\n  $after: String\n  $first: Int = 4\n) {\n  ...ProfileContainer_interviews_2HEEH6\n}\n\nfragment ProfileContainer_interviews_2HEEH6 on Query {\n  interviews: recruitInterviews(first: $first, after: $after) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        interviewId\n        vacancyId\n        applicationId\n        employerId\n        stage\n        status\n        type\n        vacancy {\n          name\n          code\n          employerName\n          employerLogoUrl\n          id\n        }\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node36.hash = "23c40d5b90010fcbf4d5e4138076455b";
var ProfileContainerInterviewListPaginationQuery_graphql_default = node36;

// src/profiles/edit/components/__generated__/ProfileContainer_interviews.graphql.ts
var node37 = function() {
  var v0 = [
    "interviews"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 4,
        "kind": "LocalArgument",
        "name": "first"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": ProfileContainerInterviewListPaginationQuery_graphql_default
      }
    },
    "name": "ProfileContainer_interviews",
    "selections": [
      {
        "alias": "interviews",
        "args": null,
        "concreteType": "RecruitInterviewsConnection",
        "kind": "LinkedField",
        "name": "__ProfileContainer_interviews_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitInterviewsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitInterview",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "interviewId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "vacancyId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "applicationId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "employerId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "stage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "type",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Vacancy",
                    "kind": "LinkedField",
                    "name": "vacancy",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "code",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "employerName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "employerLogoUrl",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node37.hash = "23c40d5b90010fcbf4d5e4138076455b";
var ProfileContainer_interviews_graphql_default = node37;

// src/profiles/edit/components/__generated__/ProfileContainerApplicationListPaginationQuery.graphql.ts
var node38 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 4,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": {
        "createdAt": "DESC"
      },
      "kind": "LocalArgument",
      "name": "sort"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v23 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v32 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }, v4 = [
    v1,
    v23,
    {
      "kind": "Variable",
      "name": "order",
      "variableName": "sort"
    },
    v32
  ], v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "employerName",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ProfileContainerApplicationListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v23,
            {
              "kind": "Variable",
              "name": "sort",
              "variableName": "sort"
            },
            v32
          ],
          "kind": "FragmentSpread",
          "name": "ProfileContainer_applications"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ProfileContainerApplicationListPaginationQuery",
      "selections": [
        {
          "alias": null,
          "args": v4,
          "concreteType": "ApplicationsConnection",
          "kind": "LinkedField",
          "name": "applications",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ApplicationsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Application",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v5,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "applicationId",
                      "storageKey": null
                    },
                    v6,
                    v7,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "vacancyName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasCompletedDocumentTypes",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasCompletedForms",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasCompletedOptionalSkills",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasCompletedRate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasCompletedRequiredSkills",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "applicationStateName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Vacancy",
                      "kind": "LinkedField",
                      "name": "vacancy",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        },
                        v6,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "employerLogoUrl",
                          "storageKey": null
                        },
                        v7,
                        v5
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": v4,
          "filters": [],
          "handle": "connection",
          "key": "ProfileContainer_applications",
          "kind": "LinkedHandle",
          "name": "applications"
        }
      ]
    },
    "params": {
      "cacheID": "f881bdb0945a080612cba4b59ff975f1",
      "id": null,
      "metadata": {},
      "name": "ProfileContainerApplicationListPaginationQuery",
      "operationKind": "query",
      "text": "query ProfileContainerApplicationListPaginationQuery(\n  $after: String\n  $first: Int = 4\n  $sort: [ApplicationSort!] = {createdAt: DESC}\n  $where: ApplicationFilter\n) {\n  ...ProfileContainer_applications_5yRcm\n}\n\nfragment ProfileContainer_applications_5yRcm on Query {\n  applications(first: $first, after: $after, where: $where, order: $sort) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        applicationId\n        code\n        employerName\n        vacancyName\n        hasCompletedDocumentTypes\n        hasCompletedForms\n        hasCompletedOptionalSkills\n        hasCompletedRate\n        hasCompletedRequiredSkills\n        applicationStateName\n        vacancy {\n          name\n          code\n          employerLogoUrl\n          employerName\n          id\n        }\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node38.hash = "589487ebe52037500faaf6054a3d8174";
var ProfileContainerApplicationListPaginationQuery_graphql_default = node38;

// src/profiles/edit/components/__generated__/ProfileContainer_applications.graphql.ts
var node39 = function() {
  var v0 = [
    "applications"
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "employerName",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 4,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "defaultValue": {
          "createdAt": "DESC"
        },
        "kind": "LocalArgument",
        "name": "sort"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": ProfileContainerApplicationListPaginationQuery_graphql_default
      }
    },
    "name": "ProfileContainer_applications",
    "selections": [
      {
        "alias": "applications",
        "args": null,
        "concreteType": "ApplicationsConnection",
        "kind": "LinkedField",
        "name": "__ProfileContainer_applications_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ApplicationsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Application",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "applicationId",
                    "storageKey": null
                  },
                  v1,
                  v23,
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "vacancyName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasCompletedDocumentTypes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasCompletedForms",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasCompletedOptionalSkills",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasCompletedRate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasCompletedRequiredSkills",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "applicationStateName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Vacancy",
                    "kind": "LinkedField",
                    "name": "vacancy",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      v1,
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "employerLogoUrl",
                        "storageKey": null
                      },
                      v23
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node39.hash = "589487ebe52037500faaf6054a3d8174";
var ProfileContainer_applications_graphql_default = node39;

// src/profiles/edit/components/__generated__/ProfileContainerRefetchQuery.graphql.ts
var node40 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "id"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "id"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyName",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateExperienceId",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "industry",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "skills",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "countryCode",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ProfileContainerRefetchQuery",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ProfileContainer_profile"
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ProfileContainerRefetchQuery",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            },
            v23,
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "recruitProfileId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileSummary",
                  "kind": "LinkedField",
                  "name": "summary",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currentJobTitleName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "prefersNoResume",
                      "storageKey": null
                    },
                    v23
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperience",
                  "kind": "LinkedField",
                  "name": "currentPosition",
                  "plural": false,
                  "selections": [
                    v32,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "companyIsVerified",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "title",
                      "storageKey": null
                    },
                    v23,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "version",
                      "storageKey": null
                    },
                    v4,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "titleId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "companyId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "startDate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "endDate",
                      "storageKey": null
                    },
                    v5,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "positionType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    v6
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileRate",
                  "kind": "LinkedField",
                  "name": "rate",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "maximumRateOfPay",
                      "storageKey": null
                    },
                    v23,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "payType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "minimumRateOfPay",
                      "storageKey": null
                    },
                    v7,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currencyCode",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperienceCollection",
                  "kind": "LinkedField",
                  "name": "experiences",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileExperience",
                      "kind": "LinkedField",
                      "name": "items",
                      "plural": true,
                      "selections": [
                        v23,
                        v6
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitResume",
                  "kind": "LinkedField",
                  "name": "resume",
                  "plural": false,
                  "selections": [
                    v23,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "addedToProfile",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RightToWork",
                  "kind": "LinkedField",
                  "name": "rightToWork",
                  "plural": true,
                  "selections": [
                    v23
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsCandidateAccount",
                  "kind": "LinkedField",
                  "name": "account",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "accountId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "firstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastName",
                      "storageKey": null
                    },
                    v23
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileWorkLocations",
                  "kind": "LinkedField",
                  "name": "workLocations",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currentLocationCountryCode",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currentLocationCountryName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currentLocationName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currentLocationLatitude",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currentLocationLongitude",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currentLocationRadius",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "WorkLocationEntry",
                      "kind": "LinkedField",
                      "name": "workLocations",
                      "plural": true,
                      "selections": [
                        v23,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        },
                        v7,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "countryName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "entireCountry",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "latitude",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "longitude",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "radius",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    v23
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperience",
                  "kind": "LinkedField",
                  "name": "experience",
                  "plural": true,
                  "selections": [
                    v23,
                    v4,
                    v32,
                    v5
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileAvailability",
                  "kind": "LinkedField",
                  "name": "availability",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobSearchStatus",
                      "storageKey": null
                    },
                    v23
                  ],
                  "storageKey": null
                }
              ],
              "type": "RecruitProfile",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "bd5a0133821cb56db5eb10fe5a2879ad",
      "id": null,
      "metadata": {},
      "name": "ProfileContainerRefetchQuery",
      "operationKind": "query",
      "text": "query ProfileContainerRefetchQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...ProfileContainer_profile\n    id\n  }\n}\n\nfragment CompaniesTags_profile on RecruitProfile {\n  id\n  experience {\n    id\n    candidateExperienceId\n    companyName\n  }\n}\n\nfragment ExperienceCurrent_profile on RecruitProfile {\n  id\n  recruitProfileId\n  summary {\n    prefersNoResume\n    id\n  }\n  currentPosition {\n    id\n    version\n    candidateExperienceId\n    titleId\n    title\n    companyId\n    companyName\n    companyIsVerified\n    startDate\n    endDate\n    industry\n    positionType\n    description\n    ...ExperienceItem_profile\n  }\n}\n\nfragment ExperienceItem_profile on RecruitProfileExperience {\n  id\n  version\n  candidateExperienceId\n  titleId\n  title\n  companyId\n  companyName\n  companyIsVerified\n  startDate\n  endDate\n  industry\n  positionType\n  description\n  skills\n  ...ExperienceSkills_skills\n}\n\nfragment ExperienceSkills_skills on RecruitProfileExperience {\n  skills\n}\n\nfragment IndustriesTags_profile on RecruitProfile {\n  id\n  experience {\n    id\n    industry\n  }\n}\n\nfragment ProfileContainer_profile on RecruitProfile {\n  id\n  recruitProfileId\n  summary {\n    currentJobTitleName\n    prefersNoResume\n    id\n  }\n  currentPosition {\n    companyName\n    companyIsVerified\n    title\n    id\n  }\n  rate {\n    maximumRateOfPay\n    id\n  }\n  experiences {\n    items {\n      id\n      skills\n    }\n  }\n  resume {\n    id\n    addedToProfile\n  }\n  rightToWork {\n    id\n  }\n  account {\n    accountId\n    firstName\n    lastName\n    id\n  }\n  workLocations {\n    currentLocationCountryCode\n    currentLocationCountryName\n    currentLocationName\n    currentLocationLatitude\n    currentLocationLongitude\n    currentLocationRadius\n    workLocations {\n      id\n      name\n      countryCode\n      countryName\n      entireCountry\n      latitude\n      longitude\n      radius\n    }\n    id\n  }\n  ...Rates_RecruitProfile\n  ...ProfileInfoSidebar_profile\n  ...CompaniesTags_profile\n  ...IndustriesTags_profile\n  ...ExperienceCurrent_profile\n  ...RateEditor_RecruitProfile\n}\n\nfragment ProfileInfoSidebar_profile on RecruitProfile {\n  id\n  experience {\n    id\n    candidateExperienceId\n    companyName\n  }\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n  availability {\n    jobSearchStatus\n    id\n  }\n  workLocations {\n    workLocations {\n      name\n      countryCode\n    }\n    id\n  }\n}\n\nfragment RateEditor_RecruitProfile on RecruitProfile {\n  recruitProfileId\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n}\n\nfragment Rates_RecruitProfile on RecruitProfile {\n  recruitProfileId\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n}\n"
    }
  };
}();
node40.hash = "7ebd575dc28e00dabace8b54859e3442";
var ProfileContainerRefetchQuery_graphql_default = node40;

// src/profiles/edit/components/__generated__/ProfileContainer_profile.graphql.ts
var node41 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
      "refetch": {
        "connection": null,
        "fragmentPathInResult": [
          "node"
        ],
        "operation": ProfileContainerRefetchQuery_graphql_default,
        "identifierInfo": {
          "identifierField": "id",
          "identifierQueryVariableName": "id"
        }
      }
    },
    "name": "ProfileContainer_profile",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "recruitProfileId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitProfileSummary",
        "kind": "LinkedField",
        "name": "summary",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currentJobTitleName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "prefersNoResume",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitProfileExperience",
        "kind": "LinkedField",
        "name": "currentPosition",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "companyName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "companyIsVerified",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitProfileRate",
        "kind": "LinkedField",
        "name": "rate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "maximumRateOfPay",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitProfileExperienceCollection",
        "kind": "LinkedField",
        "name": "experiences",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitProfileExperience",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              v0,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "skills",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitResume",
        "kind": "LinkedField",
        "name": "resume",
        "plural": false,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "addedToProfile",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RightToWork",
        "kind": "LinkedField",
        "name": "rightToWork",
        "plural": true,
        "selections": [
          v0
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsCandidateAccount",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitProfileWorkLocations",
        "kind": "LinkedField",
        "name": "workLocations",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currentLocationCountryCode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currentLocationCountryName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currentLocationName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currentLocationLatitude",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currentLocationLongitude",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currentLocationRadius",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "WorkLocationEntry",
            "kind": "LinkedField",
            "name": "workLocations",
            "plural": true,
            "selections": [
              v0,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "countryCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "countryName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "entireCountry",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "latitude",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "longitude",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "radius",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "Rates_RecruitProfile"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "ProfileInfoSidebar_profile"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "CompaniesTags_profile"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "IndustriesTags_profile"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "ExperienceCurrent_profile"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "RateEditor_RecruitProfile"
      }
    ],
    "type": "RecruitProfile",
    "abstractKey": null
  };
}();
node41.hash = "7ebd575dc28e00dabace8b54859e3442";
var ProfileContainer_profile_graphql_default = node41;

// src/profiles/edit/components/__generated__/ProfileContainer_account.graphql.ts
var node42 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileContainer_account",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isEmailVerified",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CandidateAccountEmailVerifyForm_account"
    }
  ],
  "type": "AccountsCandidateAccount",
  "abstractKey": null
};
node42.hash = "07e3324a97339e4a4675a65409f7d9e7";
var ProfileContainer_account_graphql_default = node42;

// src/profiles/edit/components/ProfileContainer.tsx
import { useCallback as useCallback28, useMemo as useMemo9, useState as useState16 } from "react";
import { useFragment as useFragment25, usePaginationFragment as usePaginationFragment5 } from "react-relay";
import { useNavigate as useNavigate6 } from "react-router-dom";
import { ArrowRightIcon, ChevronRightIcon } from "@heroicons/react/24/solid";
import { useLogger as useLogger11, useToggle as useToggle10 } from "shared-lib";
import { Button as Button17, EdLink as EdLink4, StepStatus, Tag as Tag6 } from "shared-ui";
import { CandidateAccountEmailVerifyForm } from "feature-candidate-accounts";

// src/resumes/components/__generated__/ResumeClarifyPositions_resume.graphql.ts
var node43 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ResumeClarifyPositions_resume",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "resumeId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RecruitResumeData",
      "kind": "LinkedField",
      "name": "resumeData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RecruitResumePosition",
          "kind": "LinkedField",
          "name": "employmentHistory",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "index",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isInProfile",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canClarify",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canImport",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ResumePositionEditor_position"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RecruitResume",
  "abstractKey": null
};
node43.hash = "21d7a3ff271ca0c3b402e94261915ec2";
var ResumeClarifyPositions_resume_graphql_default = node43;

// src/resumes/components/ResumeClarifyPositions.tsx
import { useCallback as useCallback13 } from "react";
import { useFragment as useFragment13 } from "react-relay";
import { createClientMutationId as createClientMutationId7 } from "shared-lib";
import { Button as Button9, Size as Size3 } from "shared-ui";

// src/resumes/lib/Resume.ts
function checkRequireClarifications(employmentHistory) {
  return employmentHistory.some(
    (e4) => e4.isInProfile === false && e4.canClarify === true
  );
}

// src/resumes/mutations/__generated__/UseCandidateResumeUploadMutation.graphql.ts
var node44 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "addedToProfile",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfCandidateResume",
    "kind": "LinkedField",
    "name": "candidateResume",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitResume",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          v23,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "resumeId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "profileId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "version",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fileName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasExperience",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasExperienceToClarify",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasRecentExperience",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasRecentExperienceToClarify",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasExperienceToImport",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasValidExperience",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasInValidExperience",
            "storageKey": null
          },
          v32,
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitProfile",
            "kind": "LinkedField",
            "name": "profile",
            "plural": false,
            "selections": [
              v23,
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitResume",
                "kind": "LinkedField",
                "name": "resume",
                "plural": false,
                "selections": [
                  v23,
                  v32
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v5 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseCandidateResumeUploadMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitCandidateUploadResumePayload",
          "kind": "LinkedField",
          "name": "recruitCandidateUploadResume",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseCandidateResumeUploadMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitCandidateUploadResumePayload",
          "kind": "LinkedField",
          "name": "recruitCandidateUploadResume",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "8fd52b417e73c4eb92c7ef88026f5496",
      "id": null,
      "metadata": {},
      "name": "UseCandidateResumeUploadMutation",
      "operationKind": "mutation",
      "text": "mutation UseCandidateResumeUploadMutation(\n  $input: RecruitCandidateUploadResumeInput!\n) {\n  data: recruitCandidateUploadResume(input: $input) {\n    candidateResume {\n      node {\n        id\n        resumeId\n        profileId\n        version\n        fileName\n        status\n        hasExperience\n        hasExperienceToClarify\n        hasRecentExperience\n        hasRecentExperienceToClarify\n        hasExperienceToImport\n        hasValidExperience\n        hasInValidExperience\n        addedToProfile\n        profile {\n          id\n          resume {\n            id\n            addedToProfile\n          }\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node44.hash = "e279df9ce2e358155ad8102e26ecb9a4";
var UseCandidateResumeUploadMutation_graphql_default = node44;

// src/resumes/mutations/UseCandidateResumeUpload.ts
import { useAsyncMutation } from "shared-lib";
var mutationDef6 = UseCandidateResumeUploadMutation_graphql_default;
function useCandidateResumeUpload() {
  const [commit11, isBusy] = useAsyncMutation(mutationDef6);
  return [commit11, isBusy];
}
var UseCandidateResumeUploadGraphQL = mutationDef6;

// src/resumes/mutations/__generated__/UseCandidateResumeAddPositionsMutation.graphql.ts
var node45 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "resumeId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "profileId",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "version",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fileName",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasExperience",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasExperienceToClarify",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasRecentExperience",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasRecentExperienceToClarify",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasExperienceToImport",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasValidExperience",
    "storageKey": null
  }, v14 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasInValidExperience",
    "storageKey": null
  }, v15 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "addedToProfile",
    "storageKey": null
  }, v16 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  }, v17 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyName",
    "storageKey": null
  }, v18 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyIsVerified",
    "storageKey": null
  }, v19 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  }, v20 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateExperienceId",
    "storageKey": null
  }, v21 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "titleId",
    "storageKey": null
  }, v222 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyId",
    "storageKey": null
  }, v232 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "startDate",
    "storageKey": null
  }, v24 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "endDate",
    "storageKey": null
  }, v25 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "industry",
    "storageKey": null
  }, v26 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "positionType",
    "storageKey": null
  }, v27 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  }, v28 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "skills",
    "storageKey": null
  }, v29 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "countryCode",
    "storageKey": null
  }, v30 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseCandidateResumeAddPositionsMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitCandidateResumeAddPositionsPayload",
          "kind": "LinkedField",
          "name": "recruitCandidateResumeAddPositions",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfCandidateResume",
              "kind": "LinkedField",
              "name": "candidateResume",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitResume",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v23,
                    v32,
                    v4,
                    v5,
                    v6,
                    v7,
                    v8,
                    v9,
                    v10,
                    v11,
                    v12,
                    v13,
                    v14,
                    v15,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfile",
                      "kind": "LinkedField",
                      "name": "profile",
                      "plural": false,
                      "selections": [
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "ProfileContainer_profile"
                        },
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "ExperienceList_profile"
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v16
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseCandidateResumeAddPositionsMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitCandidateResumeAddPositionsPayload",
          "kind": "LinkedField",
          "name": "recruitCandidateResumeAddPositions",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfCandidateResume",
              "kind": "LinkedField",
              "name": "candidateResume",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitResume",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v23,
                    v32,
                    v4,
                    v5,
                    v6,
                    v7,
                    v8,
                    v9,
                    v10,
                    v11,
                    v12,
                    v13,
                    v14,
                    v15,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfile",
                      "kind": "LinkedField",
                      "name": "profile",
                      "plural": false,
                      "selections": [
                        v23,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "recruitProfileId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileSummary",
                          "kind": "LinkedField",
                          "name": "summary",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "currentJobTitleName",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "prefersNoResume",
                              "storageKey": null
                            },
                            v23
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileExperience",
                          "kind": "LinkedField",
                          "name": "currentPosition",
                          "plural": false,
                          "selections": [
                            v17,
                            v18,
                            v19,
                            v23,
                            v5,
                            v20,
                            v21,
                            v222,
                            v232,
                            v24,
                            v25,
                            v26,
                            v27,
                            v28
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileRate",
                          "kind": "LinkedField",
                          "name": "rate",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "maximumRateOfPay",
                              "storageKey": null
                            },
                            v23,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "payType",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "minimumRateOfPay",
                              "storageKey": null
                            },
                            v29,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "currencyCode",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileExperienceCollection",
                          "kind": "LinkedField",
                          "name": "experiences",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "RecruitProfileExperience",
                              "kind": "LinkedField",
                              "name": "items",
                              "plural": true,
                              "selections": [
                                v23,
                                v28,
                                v20,
                                v19,
                                v17,
                                v232,
                                v27,
                                v24,
                                v25,
                                v26,
                                v5,
                                v21,
                                v222,
                                v18,
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "createdOn",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "updatedOn",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "escoOccupationId",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "escoHierarchy",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "SkillUsage",
                              "kind": "LinkedField",
                              "name": "skills",
                              "plural": true,
                              "selections": [
                                v30,
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "lastUsed",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "DateRange",
                                  "kind": "LinkedField",
                                  "name": "periods",
                                  "plural": true,
                                  "selections": [
                                    v232,
                                    v24
                                  ],
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "averageMonthsUsed",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "totalMonthsUsed",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "totalPositionsUsed",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitResume",
                          "kind": "LinkedField",
                          "name": "resume",
                          "plural": false,
                          "selections": [
                            v23,
                            v15
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RightToWork",
                          "kind": "LinkedField",
                          "name": "rightToWork",
                          "plural": true,
                          "selections": [
                            v23
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "AccountsCandidateAccount",
                          "kind": "LinkedField",
                          "name": "account",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "accountId",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "firstName",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "lastName",
                              "storageKey": null
                            },
                            v23
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileWorkLocations",
                          "kind": "LinkedField",
                          "name": "workLocations",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "currentLocationCountryCode",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "currentLocationCountryName",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "currentLocationName",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "currentLocationLatitude",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "currentLocationLongitude",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "currentLocationRadius",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "WorkLocationEntry",
                              "kind": "LinkedField",
                              "name": "workLocations",
                              "plural": true,
                              "selections": [
                                v23,
                                v30,
                                v29,
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "countryName",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "entireCountry",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "latitude",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "longitude",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "radius",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            },
                            v23
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileExperience",
                          "kind": "LinkedField",
                          "name": "experience",
                          "plural": true,
                          "selections": [
                            v23,
                            v20,
                            v17,
                            v25
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileAvailability",
                          "kind": "LinkedField",
                          "name": "availability",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "jobSearchStatus",
                              "storageKey": null
                            },
                            v23
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v16
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "537e6a2cd892587677e49a7de7743643",
      "id": null,
      "metadata": {},
      "name": "UseCandidateResumeAddPositionsMutation",
      "operationKind": "mutation",
      "text": "mutation UseCandidateResumeAddPositionsMutation(\n  $input: RecruitCandidateResumeAddPositionsInput!\n) {\n  data: recruitCandidateResumeAddPositions(input: $input) {\n    candidateResume {\n      node {\n        id\n        resumeId\n        profileId\n        version\n        fileName\n        status\n        hasExperience\n        hasExperienceToClarify\n        hasRecentExperience\n        hasRecentExperienceToClarify\n        hasExperienceToImport\n        hasValidExperience\n        hasInValidExperience\n        addedToProfile\n        profile {\n          ...ProfileContainer_profile\n          ...ExperienceList_profile\n          id\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n\nfragment CandidateApplicationProfile_profile on RecruitProfile {\n  experiences {\n    items {\n      id\n      candidateExperienceId\n      title\n      companyName\n      startDate\n      endDate\n      ...ExperienceDetails_experience\n    }\n    skills {\n      name\n      lastUsed\n      periods {\n        startDate\n        endDate\n      }\n      averageMonthsUsed\n      totalMonthsUsed\n      totalPositionsUsed\n    }\n  }\n}\n\nfragment CompaniesTags_profile on RecruitProfile {\n  id\n  experience {\n    id\n    candidateExperienceId\n    companyName\n  }\n}\n\nfragment ExperienceCurrent_profile on RecruitProfile {\n  id\n  recruitProfileId\n  summary {\n    prefersNoResume\n    id\n  }\n  currentPosition {\n    id\n    version\n    candidateExperienceId\n    titleId\n    title\n    companyId\n    companyName\n    companyIsVerified\n    startDate\n    endDate\n    industry\n    positionType\n    description\n    ...ExperienceItem_profile\n  }\n}\n\nfragment ExperienceDetails_experience on RecruitProfileExperience {\n  id\n  createdOn\n  updatedOn\n  candidateExperienceId\n  version\n  titleId\n  title\n  industry\n  companyIsVerified\n  companyId\n  companyName\n  description\n  startDate\n  endDate\n  positionType\n  skills\n  escoOccupationId\n  escoHierarchy\n}\n\nfragment ExperienceItem_profile on RecruitProfileExperience {\n  id\n  version\n  candidateExperienceId\n  titleId\n  title\n  companyId\n  companyName\n  companyIsVerified\n  startDate\n  endDate\n  industry\n  positionType\n  description\n  skills\n  ...ExperienceSkills_skills\n}\n\nfragment ExperienceList_profile on RecruitProfile {\n  id\n  recruitProfileId\n  experiences {\n    items {\n      id\n      candidateExperienceId\n      title\n      companyName\n      skills\n      startDate\n      description\n      endDate\n      industry\n      positionType\n      ...ExperienceItem_profile\n    }\n  }\n  ...CandidateApplicationProfile_profile\n}\n\nfragment ExperienceSkills_skills on RecruitProfileExperience {\n  skills\n}\n\nfragment IndustriesTags_profile on RecruitProfile {\n  id\n  experience {\n    id\n    industry\n  }\n}\n\nfragment ProfileContainer_profile on RecruitProfile {\n  id\n  recruitProfileId\n  summary {\n    currentJobTitleName\n    prefersNoResume\n    id\n  }\n  currentPosition {\n    companyName\n    companyIsVerified\n    title\n    id\n  }\n  rate {\n    maximumRateOfPay\n    id\n  }\n  experiences {\n    items {\n      id\n      skills\n    }\n  }\n  resume {\n    id\n    addedToProfile\n  }\n  rightToWork {\n    id\n  }\n  account {\n    accountId\n    firstName\n    lastName\n    id\n  }\n  workLocations {\n    currentLocationCountryCode\n    currentLocationCountryName\n    currentLocationName\n    currentLocationLatitude\n    currentLocationLongitude\n    currentLocationRadius\n    workLocations {\n      id\n      name\n      countryCode\n      countryName\n      entireCountry\n      latitude\n      longitude\n      radius\n    }\n    id\n  }\n  ...Rates_RecruitProfile\n  ...ProfileInfoSidebar_profile\n  ...CompaniesTags_profile\n  ...IndustriesTags_profile\n  ...ExperienceCurrent_profile\n  ...RateEditor_RecruitProfile\n}\n\nfragment ProfileInfoSidebar_profile on RecruitProfile {\n  id\n  experience {\n    id\n    candidateExperienceId\n    companyName\n  }\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n  availability {\n    jobSearchStatus\n    id\n  }\n  workLocations {\n    workLocations {\n      name\n      countryCode\n    }\n    id\n  }\n}\n\nfragment RateEditor_RecruitProfile on RecruitProfile {\n  recruitProfileId\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n}\n\nfragment Rates_RecruitProfile on RecruitProfile {\n  recruitProfileId\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n}\n"
    }
  };
}();
node45.hash = "9b84a8848097252e2e77cee781958fcf";
var UseCandidateResumeAddPositionsMutation_graphql_default = node45;

// src/resumes/mutations/UseCandidateResumeAddPositions.ts
import { useAsyncMutation as useAsyncMutation2 } from "shared-lib";
var mutationDef7 = UseCandidateResumeAddPositionsMutation_graphql_default;
function useCandidateResumeAddPositions() {
  const [commit11, isBusy] = useAsyncMutation2(mutationDef7);
  return [commit11, isBusy];
}

// src/resumes/mutations/__generated__/UseCandidateResumeCreateUploadUrlMutation.graphql.ts
var node46 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "concreteType": "ResumeUploadRequest",
    "kind": "LinkedField",
    "name": "candidateResumeUploadRequest",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v32 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseCandidateResumeCreateUploadUrlMutation",
      "selections": [
        {
          "alias": "uploadUrl",
          "args": v1,
          "concreteType": "RecruitCandidateResumeCreateUploadUrlPayload",
          "kind": "LinkedField",
          "name": "recruitCandidateResumeCreateUploadUrl",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseCandidateResumeCreateUploadUrlMutation",
      "selections": [
        {
          "alias": "uploadUrl",
          "args": v1,
          "concreteType": "RecruitCandidateResumeCreateUploadUrlPayload",
          "kind": "LinkedField",
          "name": "recruitCandidateResumeCreateUploadUrl",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "df01362e20cde595af68d547c5ded44b",
      "id": null,
      "metadata": {},
      "name": "UseCandidateResumeCreateUploadUrlMutation",
      "operationKind": "mutation",
      "text": "mutation UseCandidateResumeCreateUploadUrlMutation(\n  $input: RecruitCandidateResumeCreateUploadUrlInput!\n) {\n  uploadUrl: recruitCandidateResumeCreateUploadUrl(input: $input) {\n    candidateResumeUploadRequest {\n      url\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node46.hash = "e56df97a19c917057c0fd2bd0576f0a4";
var UseCandidateResumeCreateUploadUrlMutation_graphql_default = node46;

// src/resumes/mutations/UseCandidateResumeCreateUploadUrl.ts
import { useAsyncMutation as useAsyncMutation3 } from "shared-lib";
var mutationDef8 = UseCandidateResumeCreateUploadUrlMutation_graphql_default;
function useCandidateResumeCreateUploadUrl() {
  const [commit11, isBusy] = useAsyncMutation3(mutationDef8);
  return [commit11, isBusy];
}

// src/resumes/mutations/__generated__/UseCandidateResumeExcludePositionMutation.graphql.ts
var node47 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "resumeId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "profileId",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "version",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fileName",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasExperience",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasExperienceToClarify",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasRecentExperience",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasRecentExperienceToClarify",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasExperienceToImport",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasValidExperience",
    "storageKey": null
  }, v14 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasInValidExperience",
    "storageKey": null
  }, v15 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "addedToProfile",
    "storageKey": null
  }, v16 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  }, v17 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyName",
    "storageKey": null
  }, v18 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyIsVerified",
    "storageKey": null
  }, v19 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  }, v20 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateExperienceId",
    "storageKey": null
  }, v21 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "titleId",
    "storageKey": null
  }, v222 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyId",
    "storageKey": null
  }, v232 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "startDate",
    "storageKey": null
  }, v24 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "endDate",
    "storageKey": null
  }, v25 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "industry",
    "storageKey": null
  }, v26 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "positionType",
    "storageKey": null
  }, v27 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  }, v28 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "skills",
    "storageKey": null
  }, v29 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "countryCode",
    "storageKey": null
  }, v30 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseCandidateResumeExcludePositionMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitCandidateResumeExcludePositionPayload",
          "kind": "LinkedField",
          "name": "recruitCandidateResumeExcludePosition",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfCandidateResume",
              "kind": "LinkedField",
              "name": "candidateResume",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitResume",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v23,
                    v32,
                    v4,
                    v5,
                    v6,
                    v7,
                    v8,
                    v9,
                    v10,
                    v11,
                    v12,
                    v13,
                    v14,
                    v15,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfile",
                      "kind": "LinkedField",
                      "name": "profile",
                      "plural": false,
                      "selections": [
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "ProfileContainer_profile"
                        },
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "ExperienceList_profile"
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v16
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseCandidateResumeExcludePositionMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitCandidateResumeExcludePositionPayload",
          "kind": "LinkedField",
          "name": "recruitCandidateResumeExcludePosition",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfCandidateResume",
              "kind": "LinkedField",
              "name": "candidateResume",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitResume",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v23,
                    v32,
                    v4,
                    v5,
                    v6,
                    v7,
                    v8,
                    v9,
                    v10,
                    v11,
                    v12,
                    v13,
                    v14,
                    v15,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfile",
                      "kind": "LinkedField",
                      "name": "profile",
                      "plural": false,
                      "selections": [
                        v23,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "recruitProfileId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileSummary",
                          "kind": "LinkedField",
                          "name": "summary",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "currentJobTitleName",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "prefersNoResume",
                              "storageKey": null
                            },
                            v23
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileExperience",
                          "kind": "LinkedField",
                          "name": "currentPosition",
                          "plural": false,
                          "selections": [
                            v17,
                            v18,
                            v19,
                            v23,
                            v5,
                            v20,
                            v21,
                            v222,
                            v232,
                            v24,
                            v25,
                            v26,
                            v27,
                            v28
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileRate",
                          "kind": "LinkedField",
                          "name": "rate",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "maximumRateOfPay",
                              "storageKey": null
                            },
                            v23,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "payType",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "minimumRateOfPay",
                              "storageKey": null
                            },
                            v29,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "currencyCode",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileExperienceCollection",
                          "kind": "LinkedField",
                          "name": "experiences",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "RecruitProfileExperience",
                              "kind": "LinkedField",
                              "name": "items",
                              "plural": true,
                              "selections": [
                                v23,
                                v28,
                                v20,
                                v19,
                                v17,
                                v232,
                                v27,
                                v24,
                                v25,
                                v26,
                                v5,
                                v21,
                                v222,
                                v18,
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "createdOn",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "updatedOn",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "escoOccupationId",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "escoHierarchy",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "SkillUsage",
                              "kind": "LinkedField",
                              "name": "skills",
                              "plural": true,
                              "selections": [
                                v30,
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "lastUsed",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "DateRange",
                                  "kind": "LinkedField",
                                  "name": "periods",
                                  "plural": true,
                                  "selections": [
                                    v232,
                                    v24
                                  ],
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "averageMonthsUsed",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "totalMonthsUsed",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "totalPositionsUsed",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitResume",
                          "kind": "LinkedField",
                          "name": "resume",
                          "plural": false,
                          "selections": [
                            v23,
                            v15
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RightToWork",
                          "kind": "LinkedField",
                          "name": "rightToWork",
                          "plural": true,
                          "selections": [
                            v23
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "AccountsCandidateAccount",
                          "kind": "LinkedField",
                          "name": "account",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "accountId",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "firstName",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "lastName",
                              "storageKey": null
                            },
                            v23
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileWorkLocations",
                          "kind": "LinkedField",
                          "name": "workLocations",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "currentLocationCountryCode",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "currentLocationCountryName",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "currentLocationName",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "currentLocationLatitude",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "currentLocationLongitude",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "currentLocationRadius",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "WorkLocationEntry",
                              "kind": "LinkedField",
                              "name": "workLocations",
                              "plural": true,
                              "selections": [
                                v23,
                                v30,
                                v29,
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "countryName",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "entireCountry",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "latitude",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "longitude",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "radius",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            },
                            v23
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileExperience",
                          "kind": "LinkedField",
                          "name": "experience",
                          "plural": true,
                          "selections": [
                            v23,
                            v20,
                            v17,
                            v25
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileAvailability",
                          "kind": "LinkedField",
                          "name": "availability",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "jobSearchStatus",
                              "storageKey": null
                            },
                            v23
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v16
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "1c489fd756cf13cb0e7e2822826064ac",
      "id": null,
      "metadata": {},
      "name": "UseCandidateResumeExcludePositionMutation",
      "operationKind": "mutation",
      "text": "mutation UseCandidateResumeExcludePositionMutation(\n  $input: RecruitCandidateResumeExcludePositionInput!\n) {\n  data: recruitCandidateResumeExcludePosition(input: $input) {\n    candidateResume {\n      node {\n        id\n        resumeId\n        profileId\n        version\n        fileName\n        status\n        hasExperience\n        hasExperienceToClarify\n        hasRecentExperience\n        hasRecentExperienceToClarify\n        hasExperienceToImport\n        hasValidExperience\n        hasInValidExperience\n        addedToProfile\n        profile {\n          ...ProfileContainer_profile\n          ...ExperienceList_profile\n          id\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n\nfragment CandidateApplicationProfile_profile on RecruitProfile {\n  experiences {\n    items {\n      id\n      candidateExperienceId\n      title\n      companyName\n      startDate\n      endDate\n      ...ExperienceDetails_experience\n    }\n    skills {\n      name\n      lastUsed\n      periods {\n        startDate\n        endDate\n      }\n      averageMonthsUsed\n      totalMonthsUsed\n      totalPositionsUsed\n    }\n  }\n}\n\nfragment CompaniesTags_profile on RecruitProfile {\n  id\n  experience {\n    id\n    candidateExperienceId\n    companyName\n  }\n}\n\nfragment ExperienceCurrent_profile on RecruitProfile {\n  id\n  recruitProfileId\n  summary {\n    prefersNoResume\n    id\n  }\n  currentPosition {\n    id\n    version\n    candidateExperienceId\n    titleId\n    title\n    companyId\n    companyName\n    companyIsVerified\n    startDate\n    endDate\n    industry\n    positionType\n    description\n    ...ExperienceItem_profile\n  }\n}\n\nfragment ExperienceDetails_experience on RecruitProfileExperience {\n  id\n  createdOn\n  updatedOn\n  candidateExperienceId\n  version\n  titleId\n  title\n  industry\n  companyIsVerified\n  companyId\n  companyName\n  description\n  startDate\n  endDate\n  positionType\n  skills\n  escoOccupationId\n  escoHierarchy\n}\n\nfragment ExperienceItem_profile on RecruitProfileExperience {\n  id\n  version\n  candidateExperienceId\n  titleId\n  title\n  companyId\n  companyName\n  companyIsVerified\n  startDate\n  endDate\n  industry\n  positionType\n  description\n  skills\n  ...ExperienceSkills_skills\n}\n\nfragment ExperienceList_profile on RecruitProfile {\n  id\n  recruitProfileId\n  experiences {\n    items {\n      id\n      candidateExperienceId\n      title\n      companyName\n      skills\n      startDate\n      description\n      endDate\n      industry\n      positionType\n      ...ExperienceItem_profile\n    }\n  }\n  ...CandidateApplicationProfile_profile\n}\n\nfragment ExperienceSkills_skills on RecruitProfileExperience {\n  skills\n}\n\nfragment IndustriesTags_profile on RecruitProfile {\n  id\n  experience {\n    id\n    industry\n  }\n}\n\nfragment ProfileContainer_profile on RecruitProfile {\n  id\n  recruitProfileId\n  summary {\n    currentJobTitleName\n    prefersNoResume\n    id\n  }\n  currentPosition {\n    companyName\n    companyIsVerified\n    title\n    id\n  }\n  rate {\n    maximumRateOfPay\n    id\n  }\n  experiences {\n    items {\n      id\n      skills\n    }\n  }\n  resume {\n    id\n    addedToProfile\n  }\n  rightToWork {\n    id\n  }\n  account {\n    accountId\n    firstName\n    lastName\n    id\n  }\n  workLocations {\n    currentLocationCountryCode\n    currentLocationCountryName\n    currentLocationName\n    currentLocationLatitude\n    currentLocationLongitude\n    currentLocationRadius\n    workLocations {\n      id\n      name\n      countryCode\n      countryName\n      entireCountry\n      latitude\n      longitude\n      radius\n    }\n    id\n  }\n  ...Rates_RecruitProfile\n  ...ProfileInfoSidebar_profile\n  ...CompaniesTags_profile\n  ...IndustriesTags_profile\n  ...ExperienceCurrent_profile\n  ...RateEditor_RecruitProfile\n}\n\nfragment ProfileInfoSidebar_profile on RecruitProfile {\n  id\n  experience {\n    id\n    candidateExperienceId\n    companyName\n  }\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n  availability {\n    jobSearchStatus\n    id\n  }\n  workLocations {\n    workLocations {\n      name\n      countryCode\n    }\n    id\n  }\n}\n\nfragment RateEditor_RecruitProfile on RecruitProfile {\n  recruitProfileId\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n}\n\nfragment Rates_RecruitProfile on RecruitProfile {\n  recruitProfileId\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n}\n"
    }
  };
}();
node47.hash = "d01ba765daba70ab535655b2f199293f";
var UseCandidateResumeExcludePositionMutation_graphql_default = node47;

// src/resumes/mutations/UseCandidateResumeExcludePosition.ts
import { useAsyncMutation as useAsyncMutation4 } from "shared-lib";
var mutationDef9 = UseCandidateResumeExcludePositionMutation_graphql_default;
function useCandidateResumeExcludePosition() {
  const [commit11, isBusy] = useAsyncMutation4(mutationDef9);
  return [commit11, isBusy];
}

// src/resumes/mutations/__generated__/UseCandidateResumeImportPositionsMutation.graphql.ts
var node48 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "resumeId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "profileId",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "version",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fileName",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasExperience",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasExperienceToClarify",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasRecentExperience",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasRecentExperienceToClarify",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasExperienceToImport",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasValidExperience",
    "storageKey": null
  }, v14 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasInValidExperience",
    "storageKey": null
  }, v15 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "addedToProfile",
    "storageKey": null
  }, v16 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  }, v17 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyName",
    "storageKey": null
  }, v18 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyIsVerified",
    "storageKey": null
  }, v19 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  }, v20 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateExperienceId",
    "storageKey": null
  }, v21 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "titleId",
    "storageKey": null
  }, v222 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyId",
    "storageKey": null
  }, v232 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "startDate",
    "storageKey": null
  }, v24 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "endDate",
    "storageKey": null
  }, v25 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "industry",
    "storageKey": null
  }, v26 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "positionType",
    "storageKey": null
  }, v27 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  }, v28 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "skills",
    "storageKey": null
  }, v29 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "countryCode",
    "storageKey": null
  }, v30 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseCandidateResumeImportPositionsMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitCandidateResumeImportPositionsPayload",
          "kind": "LinkedField",
          "name": "recruitCandidateResumeImportPositions",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfCandidateResume",
              "kind": "LinkedField",
              "name": "candidateResume",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitResume",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v23,
                    v32,
                    v4,
                    v5,
                    v6,
                    v7,
                    v8,
                    v9,
                    v10,
                    v11,
                    v12,
                    v13,
                    v14,
                    v15,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfile",
                      "kind": "LinkedField",
                      "name": "profile",
                      "plural": false,
                      "selections": [
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "ProfileContainer_profile"
                        },
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "ExperienceList_profile"
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v16
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseCandidateResumeImportPositionsMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitCandidateResumeImportPositionsPayload",
          "kind": "LinkedField",
          "name": "recruitCandidateResumeImportPositions",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfCandidateResume",
              "kind": "LinkedField",
              "name": "candidateResume",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitResume",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v23,
                    v32,
                    v4,
                    v5,
                    v6,
                    v7,
                    v8,
                    v9,
                    v10,
                    v11,
                    v12,
                    v13,
                    v14,
                    v15,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfile",
                      "kind": "LinkedField",
                      "name": "profile",
                      "plural": false,
                      "selections": [
                        v23,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "recruitProfileId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileSummary",
                          "kind": "LinkedField",
                          "name": "summary",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "currentJobTitleName",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "prefersNoResume",
                              "storageKey": null
                            },
                            v23
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileExperience",
                          "kind": "LinkedField",
                          "name": "currentPosition",
                          "plural": false,
                          "selections": [
                            v17,
                            v18,
                            v19,
                            v23,
                            v5,
                            v20,
                            v21,
                            v222,
                            v232,
                            v24,
                            v25,
                            v26,
                            v27,
                            v28
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileRate",
                          "kind": "LinkedField",
                          "name": "rate",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "maximumRateOfPay",
                              "storageKey": null
                            },
                            v23,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "payType",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "minimumRateOfPay",
                              "storageKey": null
                            },
                            v29,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "currencyCode",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileExperienceCollection",
                          "kind": "LinkedField",
                          "name": "experiences",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "RecruitProfileExperience",
                              "kind": "LinkedField",
                              "name": "items",
                              "plural": true,
                              "selections": [
                                v23,
                                v28,
                                v20,
                                v19,
                                v17,
                                v232,
                                v27,
                                v24,
                                v25,
                                v26,
                                v5,
                                v21,
                                v222,
                                v18,
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "createdOn",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "updatedOn",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "escoOccupationId",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "escoHierarchy",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "SkillUsage",
                              "kind": "LinkedField",
                              "name": "skills",
                              "plural": true,
                              "selections": [
                                v30,
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "lastUsed",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "DateRange",
                                  "kind": "LinkedField",
                                  "name": "periods",
                                  "plural": true,
                                  "selections": [
                                    v232,
                                    v24
                                  ],
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "averageMonthsUsed",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "totalMonthsUsed",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "totalPositionsUsed",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitResume",
                          "kind": "LinkedField",
                          "name": "resume",
                          "plural": false,
                          "selections": [
                            v23,
                            v15
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RightToWork",
                          "kind": "LinkedField",
                          "name": "rightToWork",
                          "plural": true,
                          "selections": [
                            v23
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "AccountsCandidateAccount",
                          "kind": "LinkedField",
                          "name": "account",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "accountId",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "firstName",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "lastName",
                              "storageKey": null
                            },
                            v23
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileWorkLocations",
                          "kind": "LinkedField",
                          "name": "workLocations",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "currentLocationCountryCode",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "currentLocationCountryName",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "currentLocationName",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "currentLocationLatitude",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "currentLocationLongitude",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "currentLocationRadius",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "WorkLocationEntry",
                              "kind": "LinkedField",
                              "name": "workLocations",
                              "plural": true,
                              "selections": [
                                v23,
                                v30,
                                v29,
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "countryName",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "entireCountry",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "latitude",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "longitude",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "radius",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            },
                            v23
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileExperience",
                          "kind": "LinkedField",
                          "name": "experience",
                          "plural": true,
                          "selections": [
                            v23,
                            v20,
                            v17,
                            v25
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileAvailability",
                          "kind": "LinkedField",
                          "name": "availability",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "jobSearchStatus",
                              "storageKey": null
                            },
                            v23
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v16
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "c8bcd35bc57d552ebbd629b4b0d9ffd2",
      "id": null,
      "metadata": {},
      "name": "UseCandidateResumeImportPositionsMutation",
      "operationKind": "mutation",
      "text": "mutation UseCandidateResumeImportPositionsMutation(\n  $input: RecruitCandidateResumeImportPositionsInput!\n) {\n  data: recruitCandidateResumeImportPositions(input: $input) {\n    candidateResume {\n      node {\n        id\n        resumeId\n        profileId\n        version\n        fileName\n        status\n        hasExperience\n        hasExperienceToClarify\n        hasRecentExperience\n        hasRecentExperienceToClarify\n        hasExperienceToImport\n        hasValidExperience\n        hasInValidExperience\n        addedToProfile\n        profile {\n          ...ProfileContainer_profile\n          ...ExperienceList_profile\n          id\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n\nfragment CandidateApplicationProfile_profile on RecruitProfile {\n  experiences {\n    items {\n      id\n      candidateExperienceId\n      title\n      companyName\n      startDate\n      endDate\n      ...ExperienceDetails_experience\n    }\n    skills {\n      name\n      lastUsed\n      periods {\n        startDate\n        endDate\n      }\n      averageMonthsUsed\n      totalMonthsUsed\n      totalPositionsUsed\n    }\n  }\n}\n\nfragment CompaniesTags_profile on RecruitProfile {\n  id\n  experience {\n    id\n    candidateExperienceId\n    companyName\n  }\n}\n\nfragment ExperienceCurrent_profile on RecruitProfile {\n  id\n  recruitProfileId\n  summary {\n    prefersNoResume\n    id\n  }\n  currentPosition {\n    id\n    version\n    candidateExperienceId\n    titleId\n    title\n    companyId\n    companyName\n    companyIsVerified\n    startDate\n    endDate\n    industry\n    positionType\n    description\n    ...ExperienceItem_profile\n  }\n}\n\nfragment ExperienceDetails_experience on RecruitProfileExperience {\n  id\n  createdOn\n  updatedOn\n  candidateExperienceId\n  version\n  titleId\n  title\n  industry\n  companyIsVerified\n  companyId\n  companyName\n  description\n  startDate\n  endDate\n  positionType\n  skills\n  escoOccupationId\n  escoHierarchy\n}\n\nfragment ExperienceItem_profile on RecruitProfileExperience {\n  id\n  version\n  candidateExperienceId\n  titleId\n  title\n  companyId\n  companyName\n  companyIsVerified\n  startDate\n  endDate\n  industry\n  positionType\n  description\n  skills\n  ...ExperienceSkills_skills\n}\n\nfragment ExperienceList_profile on RecruitProfile {\n  id\n  recruitProfileId\n  experiences {\n    items {\n      id\n      candidateExperienceId\n      title\n      companyName\n      skills\n      startDate\n      description\n      endDate\n      industry\n      positionType\n      ...ExperienceItem_profile\n    }\n  }\n  ...CandidateApplicationProfile_profile\n}\n\nfragment ExperienceSkills_skills on RecruitProfileExperience {\n  skills\n}\n\nfragment IndustriesTags_profile on RecruitProfile {\n  id\n  experience {\n    id\n    industry\n  }\n}\n\nfragment ProfileContainer_profile on RecruitProfile {\n  id\n  recruitProfileId\n  summary {\n    currentJobTitleName\n    prefersNoResume\n    id\n  }\n  currentPosition {\n    companyName\n    companyIsVerified\n    title\n    id\n  }\n  rate {\n    maximumRateOfPay\n    id\n  }\n  experiences {\n    items {\n      id\n      skills\n    }\n  }\n  resume {\n    id\n    addedToProfile\n  }\n  rightToWork {\n    id\n  }\n  account {\n    accountId\n    firstName\n    lastName\n    id\n  }\n  workLocations {\n    currentLocationCountryCode\n    currentLocationCountryName\n    currentLocationName\n    currentLocationLatitude\n    currentLocationLongitude\n    currentLocationRadius\n    workLocations {\n      id\n      name\n      countryCode\n      countryName\n      entireCountry\n      latitude\n      longitude\n      radius\n    }\n    id\n  }\n  ...Rates_RecruitProfile\n  ...ProfileInfoSidebar_profile\n  ...CompaniesTags_profile\n  ...IndustriesTags_profile\n  ...ExperienceCurrent_profile\n  ...RateEditor_RecruitProfile\n}\n\nfragment ProfileInfoSidebar_profile on RecruitProfile {\n  id\n  experience {\n    id\n    candidateExperienceId\n    companyName\n  }\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n  availability {\n    jobSearchStatus\n    id\n  }\n  workLocations {\n    workLocations {\n      name\n      countryCode\n    }\n    id\n  }\n}\n\nfragment RateEditor_RecruitProfile on RecruitProfile {\n  recruitProfileId\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n}\n\nfragment Rates_RecruitProfile on RecruitProfile {\n  recruitProfileId\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n}\n"
    }
  };
}();
node48.hash = "edb23fbb85555080e3ad2456c42b611f";
var UseCandidateResumeImportPositionsMutation_graphql_default = node48;

// src/resumes/mutations/UseCandidateResumeImportPositions.ts
import { useAsyncMutation as useAsyncMutation5 } from "shared-lib";
var mutationDef10 = UseCandidateResumeImportPositionsMutation_graphql_default;
function useCandidateResumeImportPositions() {
  const [commit11, isBusy] = useAsyncMutation5(mutationDef10);
  return [commit11, isBusy];
}

// src/resumes/mutations/__generated__/UseCandidateResumeUpdatePositionMutation.graphql.ts
var node49 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "resumeId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "profileId",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "version",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fileName",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasExperience",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasExperienceToClarify",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasRecentExperience",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasRecentExperienceToClarify",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasExperienceToImport",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasValidExperience",
    "storageKey": null
  }, v14 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasInValidExperience",
    "storageKey": null
  }, v15 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "addedToProfile",
    "storageKey": null
  }, v16 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  }, v17 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyId",
    "storageKey": null
  }, v18 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyName",
    "storageKey": null
  }, v19 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyIsVerified",
    "storageKey": null
  }, v20 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  }, v21 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "industry",
    "storageKey": null
  }, v222 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  }, v232 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateExperienceId",
    "storageKey": null
  }, v24 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "titleId",
    "storageKey": null
  }, v25 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "startDate",
    "storageKey": null
  }, v26 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "endDate",
    "storageKey": null
  }, v27 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "positionType",
    "storageKey": null
  }, v28 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "skills",
    "storageKey": null
  }, v29 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "countryCode",
    "storageKey": null
  }, v30 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseCandidateResumeUpdatePositionMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitCandidateResumeUpdatePositionPayload",
          "kind": "LinkedField",
          "name": "recruitCandidateResumeUpdatePosition",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfCandidateResume",
              "kind": "LinkedField",
              "name": "candidateResume",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitResume",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v23,
                    v32,
                    v4,
                    v5,
                    v6,
                    v7,
                    v8,
                    v9,
                    v10,
                    v11,
                    v12,
                    v13,
                    v14,
                    v15,
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "ResumeClarifyPositions_resume"
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfile",
                      "kind": "LinkedField",
                      "name": "profile",
                      "plural": false,
                      "selections": [
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "ProfileContainer_profile"
                        },
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "ExperienceList_profile"
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v16
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseCandidateResumeUpdatePositionMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitCandidateResumeUpdatePositionPayload",
          "kind": "LinkedField",
          "name": "recruitCandidateResumeUpdatePosition",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfCandidateResume",
              "kind": "LinkedField",
              "name": "candidateResume",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitResume",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v23,
                    v32,
                    v4,
                    v5,
                    v6,
                    v7,
                    v8,
                    v9,
                    v10,
                    v11,
                    v12,
                    v13,
                    v14,
                    v15,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitResumeData",
                      "kind": "LinkedField",
                      "name": "resumeData",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitResumePosition",
                          "kind": "LinkedField",
                          "name": "employmentHistory",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "index",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "isInProfile",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "canClarify",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "canImport",
                              "storageKey": null
                            },
                            v17,
                            v18,
                            v19,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "inProfileOn",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "hasInvalidCompany",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "hasInvalidFromDate",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "hasInvalidToDate",
                              "storageKey": null
                            },
                            v20,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "resumePositionType",
                              "storageKey": null
                            },
                            v21,
                            v222,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "from",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "to",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "jobTitles",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "SkillTag",
                              "kind": "LinkedField",
                              "name": "skills",
                              "plural": true,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "skillId",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "skillName",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfile",
                      "kind": "LinkedField",
                      "name": "profile",
                      "plural": false,
                      "selections": [
                        v23,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "recruitProfileId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileSummary",
                          "kind": "LinkedField",
                          "name": "summary",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "currentJobTitleName",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "prefersNoResume",
                              "storageKey": null
                            },
                            v23
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileExperience",
                          "kind": "LinkedField",
                          "name": "currentPosition",
                          "plural": false,
                          "selections": [
                            v18,
                            v19,
                            v20,
                            v23,
                            v5,
                            v232,
                            v24,
                            v17,
                            v25,
                            v26,
                            v21,
                            v27,
                            v222,
                            v28
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileRate",
                          "kind": "LinkedField",
                          "name": "rate",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "maximumRateOfPay",
                              "storageKey": null
                            },
                            v23,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "payType",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "minimumRateOfPay",
                              "storageKey": null
                            },
                            v29,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "currencyCode",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileExperienceCollection",
                          "kind": "LinkedField",
                          "name": "experiences",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "RecruitProfileExperience",
                              "kind": "LinkedField",
                              "name": "items",
                              "plural": true,
                              "selections": [
                                v23,
                                v28,
                                v232,
                                v20,
                                v18,
                                v25,
                                v222,
                                v26,
                                v21,
                                v27,
                                v5,
                                v24,
                                v17,
                                v19,
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "createdOn",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "updatedOn",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "escoOccupationId",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "escoHierarchy",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "SkillUsage",
                              "kind": "LinkedField",
                              "name": "skills",
                              "plural": true,
                              "selections": [
                                v30,
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "lastUsed",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "DateRange",
                                  "kind": "LinkedField",
                                  "name": "periods",
                                  "plural": true,
                                  "selections": [
                                    v25,
                                    v26
                                  ],
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "averageMonthsUsed",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "totalMonthsUsed",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "totalPositionsUsed",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitResume",
                          "kind": "LinkedField",
                          "name": "resume",
                          "plural": false,
                          "selections": [
                            v23,
                            v15
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RightToWork",
                          "kind": "LinkedField",
                          "name": "rightToWork",
                          "plural": true,
                          "selections": [
                            v23
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "AccountsCandidateAccount",
                          "kind": "LinkedField",
                          "name": "account",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "accountId",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "firstName",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "lastName",
                              "storageKey": null
                            },
                            v23
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileWorkLocations",
                          "kind": "LinkedField",
                          "name": "workLocations",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "currentLocationCountryCode",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "currentLocationCountryName",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "currentLocationName",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "currentLocationLatitude",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "currentLocationLongitude",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "currentLocationRadius",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "WorkLocationEntry",
                              "kind": "LinkedField",
                              "name": "workLocations",
                              "plural": true,
                              "selections": [
                                v23,
                                v30,
                                v29,
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "countryName",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "entireCountry",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "latitude",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "longitude",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "radius",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            },
                            v23
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileExperience",
                          "kind": "LinkedField",
                          "name": "experience",
                          "plural": true,
                          "selections": [
                            v23,
                            v232,
                            v18,
                            v21
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileAvailability",
                          "kind": "LinkedField",
                          "name": "availability",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "jobSearchStatus",
                              "storageKey": null
                            },
                            v23
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v16
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "49aefe75e49fc0092444dad2923d5565",
      "id": null,
      "metadata": {},
      "name": "UseCandidateResumeUpdatePositionMutation",
      "operationKind": "mutation",
      "text": "mutation UseCandidateResumeUpdatePositionMutation(\n  $input: RecruitCandidateResumeUpdatePositionInput!\n) {\n  data: recruitCandidateResumeUpdatePosition(input: $input) {\n    candidateResume {\n      node {\n        id\n        resumeId\n        profileId\n        version\n        fileName\n        status\n        hasExperience\n        hasExperienceToClarify\n        hasRecentExperience\n        hasRecentExperienceToClarify\n        hasExperienceToImport\n        hasValidExperience\n        hasInValidExperience\n        addedToProfile\n        ...ResumeClarifyPositions_resume\n        profile {\n          ...ProfileContainer_profile\n          ...ExperienceList_profile\n          id\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n\nfragment CandidateApplicationProfile_profile on RecruitProfile {\n  experiences {\n    items {\n      id\n      candidateExperienceId\n      title\n      companyName\n      startDate\n      endDate\n      ...ExperienceDetails_experience\n    }\n    skills {\n      name\n      lastUsed\n      periods {\n        startDate\n        endDate\n      }\n      averageMonthsUsed\n      totalMonthsUsed\n      totalPositionsUsed\n    }\n  }\n}\n\nfragment CompaniesTags_profile on RecruitProfile {\n  id\n  experience {\n    id\n    candidateExperienceId\n    companyName\n  }\n}\n\nfragment ExperienceCurrent_profile on RecruitProfile {\n  id\n  recruitProfileId\n  summary {\n    prefersNoResume\n    id\n  }\n  currentPosition {\n    id\n    version\n    candidateExperienceId\n    titleId\n    title\n    companyId\n    companyName\n    companyIsVerified\n    startDate\n    endDate\n    industry\n    positionType\n    description\n    ...ExperienceItem_profile\n  }\n}\n\nfragment ExperienceDetails_experience on RecruitProfileExperience {\n  id\n  createdOn\n  updatedOn\n  candidateExperienceId\n  version\n  titleId\n  title\n  industry\n  companyIsVerified\n  companyId\n  companyName\n  description\n  startDate\n  endDate\n  positionType\n  skills\n  escoOccupationId\n  escoHierarchy\n}\n\nfragment ExperienceItem_profile on RecruitProfileExperience {\n  id\n  version\n  candidateExperienceId\n  titleId\n  title\n  companyId\n  companyName\n  companyIsVerified\n  startDate\n  endDate\n  industry\n  positionType\n  description\n  skills\n  ...ExperienceSkills_skills\n}\n\nfragment ExperienceList_profile on RecruitProfile {\n  id\n  recruitProfileId\n  experiences {\n    items {\n      id\n      candidateExperienceId\n      title\n      companyName\n      skills\n      startDate\n      description\n      endDate\n      industry\n      positionType\n      ...ExperienceItem_profile\n    }\n  }\n  ...CandidateApplicationProfile_profile\n}\n\nfragment ExperienceSkills_skills on RecruitProfileExperience {\n  skills\n}\n\nfragment IndustriesTags_profile on RecruitProfile {\n  id\n  experience {\n    id\n    industry\n  }\n}\n\nfragment ProfileContainer_profile on RecruitProfile {\n  id\n  recruitProfileId\n  summary {\n    currentJobTitleName\n    prefersNoResume\n    id\n  }\n  currentPosition {\n    companyName\n    companyIsVerified\n    title\n    id\n  }\n  rate {\n    maximumRateOfPay\n    id\n  }\n  experiences {\n    items {\n      id\n      skills\n    }\n  }\n  resume {\n    id\n    addedToProfile\n  }\n  rightToWork {\n    id\n  }\n  account {\n    accountId\n    firstName\n    lastName\n    id\n  }\n  workLocations {\n    currentLocationCountryCode\n    currentLocationCountryName\n    currentLocationName\n    currentLocationLatitude\n    currentLocationLongitude\n    currentLocationRadius\n    workLocations {\n      id\n      name\n      countryCode\n      countryName\n      entireCountry\n      latitude\n      longitude\n      radius\n    }\n    id\n  }\n  ...Rates_RecruitProfile\n  ...ProfileInfoSidebar_profile\n  ...CompaniesTags_profile\n  ...IndustriesTags_profile\n  ...ExperienceCurrent_profile\n  ...RateEditor_RecruitProfile\n}\n\nfragment ProfileInfoSidebar_profile on RecruitProfile {\n  id\n  experience {\n    id\n    candidateExperienceId\n    companyName\n  }\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n  availability {\n    jobSearchStatus\n    id\n  }\n  workLocations {\n    workLocations {\n      name\n      countryCode\n    }\n    id\n  }\n}\n\nfragment RateEditor_RecruitProfile on RecruitProfile {\n  recruitProfileId\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n}\n\nfragment Rates_RecruitProfile on RecruitProfile {\n  recruitProfileId\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n}\n\nfragment ResumeClarifyPositions_resume on RecruitResume {\n  id\n  resumeId\n  resumeData {\n    employmentHistory {\n      index\n      isInProfile\n      canClarify\n      canImport\n      ...ResumePositionEditor_position\n    }\n  }\n}\n\nfragment ResumePositionEditor_position on RecruitResumePosition {\n  index\n  companyId\n  companyName\n  companyIsVerified\n  canClarify\n  canImport\n  isInProfile\n  inProfileOn\n  hasInvalidCompany\n  hasInvalidFromDate\n  hasInvalidToDate\n  title\n  resumePositionType\n  industry\n  description\n  from\n  to\n  jobTitles\n  skills {\n    skillId\n    skillName\n  }\n}\n"
    }
  };
}();
node49.hash = "c53000c4e5e1f3a5639751ce61878fe3";
var UseCandidateResumeUpdatePositionMutation_graphql_default = node49;

// src/resumes/mutations/UseCandidateResumeUpdatePosition.ts
import { useAsyncMutation as useAsyncMutation6 } from "shared-lib";
var mutationDef11 = UseCandidateResumeUpdatePositionMutation_graphql_default;
function useCandidateResumeUpdatePosition() {
  const [commit11, isBusy] = useAsyncMutation6(mutationDef11);
  return [commit11, isBusy];
}

// src/resumes/components/__generated__/ResumePositionEditor_position.graphql.ts
var node50 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ResumePositionEditor_position",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "index",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "companyId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "companyName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "companyIsVerified",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canClarify",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canImport",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isInProfile",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "inProfileOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasInvalidCompany",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasInvalidFromDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasInvalidToDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "resumePositionType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "industry",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "from",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "to",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "jobTitles",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SkillTag",
      "kind": "LinkedField",
      "name": "skills",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "skillId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "skillName",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RecruitResumePosition",
  "abstractKey": null
};
node50.hash = "17e9052f1020bf13a883c762a650e23e";
var ResumePositionEditor_position_graphql_default = node50;

// src/resumes/components/ResumePositionEditor.tsx
import { useCallback as useCallback12, useState as useState7 } from "react";
import { useFragment as useFragment12 } from "react-relay";
import { format as format5, formatISO9075 } from "date-fns";
import {
  createClientMutationId as createClientMutationId6,
  parseDate as parseDate6,
  useLogger as useLogger2,
  useToggle as useToggle4
} from "shared-lib";
import { AlertMessage as AlertMessage4, Button as Button8, Input as Input2, Tag as Tag4 } from "shared-ui";
import { CompaniesSearchContainer } from "feature-data-management";
import { jsx as jsx27, jsxs as jsxs18 } from "react/jsx-runtime";
var fragmentDef12 = ResumePositionEditor_position_graphql_default;
var ResumePositionEditor = ({
  fragmentRef,
  resumeId,
  profileId
}) => {
  const [log] = useLogger2();
  const data = useFragment12(
    fragmentDef12,
    fragmentRef
  );
  const [showDescription, toggleShowDescription] = useToggle4();
  const [wasSaved, setWasSaved] = useState7(false);
  const [update, isUpdating] = useCandidateResumeUpdatePosition();
  const [company, setCompany] = useState7(() => {
    if (data.hasInvalidCompany === false && data.companyId && data.companyName && data.companyIsVerified) {
      return {
        id: data.companyId,
        name: data.companyName,
        isVerified: data.companyIsVerified
      };
    }
    return null;
  });
  const [from, setFrom] = useState7(() => {
    if (data.hasInvalidFromDate === false && data.from) {
      return parseDate6(data.from);
    }
    return null;
  });
  const [to, setTo] = useState7(() => {
    if (data.hasInvalidToDate === false && data.to) {
      return parseDate6(data.to);
    }
    return null;
  });
  async function onTryUpdate(changes) {
    if (!changes.company || !changes.from || !changes.to) {
      return;
    }
    log(
      `On Change. Company ${JSON.stringify(
        changes.company
      )} From ${JSON.stringify(changes.from)} To ${JSON.stringify(changes.to)}`
    );
    const response = await update({
      input: {
        resumeId,
        profileId,
        clientMutationId: createClientMutationId6(),
        position: {
          index: data.index,
          companyId: changes.company.id,
          companyName: changes.company.name,
          companyIsVerified: changes.company.isVerified,
          description: data.description || "",
          title: data.title || "",
          from: formatISO9075(changes.from),
          to: formatISO9075(changes.to)
        }
      }
    });
    if (!response.data.userErrors) {
      setWasSaved(true);
    }
  }
  const onSetCompany = useCallback12(
    async (updated) => {
      setCompany(updated);
      if (!updated || !from || !to) {
        log(`onSetCompany: Company ${updated} From ${from} To ${to}`);
        return;
      }
      await onTryUpdate({ company: updated, from, to });
    },
    [from, log, onTryUpdate, to]
  );
  const onSetFrom = useCallback12(
    async (updated) => {
      setFrom(updated);
      if (!company || !updated || !to) {
        log(`onSetFrom: Company ${company} From ${updated} To ${to}`);
        return;
      }
      await onTryUpdate({ company, from: updated, to });
    },
    [company, log, onTryUpdate, to]
  );
  const onSetTo = useCallback12(
    async (updated) => {
      setTo(updated);
      if (!company || !from || !updated) {
        log(`onSetTo: Company ${company} From ${from} To ${updated}`);
        return;
      }
      await onTryUpdate({ company, from, to: updated });
    },
    [company, from, log, onTryUpdate]
  );
  return /* @__PURE__ */ jsxs18("div", { className: "flex flex-col", children: [
    wasSaved ? /* @__PURE__ */ jsx27(AlertMessage4, { message: "Position Updated" }) : null,
    isUpdating && /* @__PURE__ */ jsx27("div", { children: "Saving...." }),
    /* @__PURE__ */ jsxs18("div", { className: "mb-3 border-b pb-1", children: [
      /* @__PURE__ */ jsxs18("div", { className: "flex flex-wrap justify-between sm:items-center", children: [
        /* @__PURE__ */ jsx27("h3", { className: "text-lg font-medium leading-10 text-gray-900", children: data.title }),
        /* @__PURE__ */ jsx27("div", { children: /* @__PURE__ */ jsx27(Tag4, { size: "xsmall", children: data.resumePositionType }) })
      ] }),
      data.industry && /* @__PURE__ */ jsx27("div", { className: "prose mt-2", children: /* @__PURE__ */ jsx27("div", { children: data.industry }) })
    ] }),
    company ? /* @__PURE__ */ jsx27("div", { children: /* @__PURE__ */ jsx27("h3", { className: "text-primary-900 text-lg font-medium leading-10", children: company.name }) }) : /* @__PURE__ */ jsxs18("div", { children: [
      /* @__PURE__ */ jsx27("div", { children: "What Company did you work for ? " }),
      /* @__PURE__ */ jsx27("div", { children: /* @__PURE__ */ jsx27(
        CompaniesSearchContainer,
        {
          name: `companies-search-${data.index}`,
          onSearchCompleted: onSetCompany
        }
      ) })
    ] }),
    /* @__PURE__ */ jsxs18("div", { className: "flex items-center space-x-2 py-3", children: [
      from ? /* @__PURE__ */ jsxs18("div", { className: "flex items-center space-x-2", children: [
        /* @__PURE__ */ jsx27("span", { className: "text-gray-500", children: "From" }),
        /* @__PURE__ */ jsx27("span", { className: "text-gray-900", children: from && format5(from, "MMMM yyyy") })
      ] }) : /* @__PURE__ */ jsxs18("div", { children: [
        /* @__PURE__ */ jsx27("div", { children: "When did you start working here ? " }),
        /* @__PURE__ */ jsx27("div", { children: /* @__PURE__ */ jsx27(
          Input2,
          {
            id: `position-from-${data.index}`,
            type: "date",
            onValueChange: (d4) => onSetFrom(parseDate6(d4))
          }
        ) })
      ] }),
      to ? /* @__PURE__ */ jsxs18("div", { className: "flex items-center space-x-2", children: [
        /* @__PURE__ */ jsx27("span", { className: "text-gray-500", children: "To" }),
        /* @__PURE__ */ jsx27("span", { className: "text-gray-900", children: to && format5(to, "MMMM yyyy") })
      ] }) : /* @__PURE__ */ jsxs18("div", { children: [
        /* @__PURE__ */ jsx27("div", { children: "When did you finish working here ? " }),
        /* @__PURE__ */ jsx27("div", { children: /* @__PURE__ */ jsx27(
          Input2,
          {
            id: `position-to-${data.index}`,
            type: "date",
            onValueChange: (d4) => onSetTo(parseDate6(d4))
          }
        ) })
      ] })
    ] }),
    showDescription && data.description ? /* @__PURE__ */ jsxs18("div", { className: "flex flex-col gap-2", children: [
      /* @__PURE__ */ jsx27("div", { className: "prose-lg mt-2 flex border bg-yellow-50 p-2", children: /* @__PURE__ */ jsx27("div", { children: data.description }) }),
      /* @__PURE__ */ jsx27("div", { className: "mt-2 flex", children: /* @__PURE__ */ jsx27(
        Button8,
        {
          color: "primary",
          outline: true,
          clicked: toggleShowDescription,
          children: "Hide Description"
        }
      ) })
    ] }) : /* @__PURE__ */ jsx27("div", { className: "mt-2 flex", children: /* @__PURE__ */ jsx27(
      Button8,
      {
        color: "primary",
        outline: true,
        clicked: toggleShowDescription,
        children: "Show Description"
      }
    ) })
  ] });
};

// src/resumes/components/ResumeClarifyPositions.tsx
import { jsx as jsx28, jsxs as jsxs19 } from "react/jsx-runtime";
var fragmentDef13 = ResumeClarifyPositions_resume_graphql_default;
var ResumeClarifyPositions = ({
  profileId,
  fragmentRef,
  onDone
}) => {
  const data = useFragment13(
    fragmentDef13,
    fragmentRef
  );
  const [addPositions, isAddingPositions] = useCandidateResumeAddPositions();
  const onAdd = useCallback13(async () => {
    const input = {
      profileId,
      clientMutationId: createClientMutationId7(),
      resumeId: data.resumeId
    };
    const response = await addPositions({ input });
    if (response.data.candidateResume) {
      onDone();
    }
  }, [addPositions, profileId, data.resumeId]);
  const employmentHistory = data.resumeData.employmentHistory.filter((e4) => e4.isInProfile === false && e4.canClarify === true).map((e4) => /* @__PURE__ */ jsx28(
    "div",
    {
      className: "my-2 border bg-white p-2 sm:rounded-lg sm:p-8 sm:shadow",
      children: /* @__PURE__ */ jsx28(
        ResumePositionEditor,
        {
          fragmentRef: e4,
          resumeId: data.resumeId,
          profileId
        }
      )
    },
    e4.index
  ));
  const hasClarifications = checkRequireClarifications(
    data.resumeData.employmentHistory
  );
  if (hasClarifications) {
    return /* @__PURE__ */ jsxs19("div", { className: "flex flex-col gap-3", children: [
      /* @__PURE__ */ jsx28("div", { className: "text-primary-500 mb-2 text-lg", children: "Missing Resume Info" }),
      /* @__PURE__ */ jsx28("div", { className: "mb-2 py-2 sm:py-3", children: "The following positions found in your resume has some missing data. In order to import into the system we need to clarify a few points It will only take a minute" }),
      /* @__PURE__ */ jsx28("div", { className: "flex flex-col gap-3", children: employmentHistory }),
      ";"
    ] });
  }
  return /* @__PURE__ */ jsx28("div", { className: "flex justify-center", children: /* @__PURE__ */ jsx28(
    Button9,
    {
      size: Size3.lg,
      color: "success",
      disabled: isAddingPositions,
      clicked: onAdd,
      children: "Continue"
    }
  ) });
};

// src/resumes/components/__generated__/ResumeContainerQuery.graphql.ts
var node51 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "resumeId"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "resumeId"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "resumeId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "profileId",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "skillId",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "skillName",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ResumeContainerQuery",
      "selections": [
        {
          "alias": "resume",
          "args": v1,
          "concreteType": "RecruitResume",
          "kind": "LinkedField",
          "name": "recruitResumeById",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            v5,
            v6,
            v7,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ResumeView_resume"
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ResumeContainerQuery",
      "selections": [
        {
          "alias": "resume",
          "args": v1,
          "concreteType": "RecruitResume",
          "kind": "LinkedField",
          "name": "recruitResumeById",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            v5,
            v6,
            v7,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "fileName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitResumeData",
              "kind": "LinkedField",
              "name": "resumeData",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SkillModel",
                  "kind": "LinkedField",
                  "name": "skills",
                  "plural": true,
                  "selections": [
                    v8,
                    v9,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastUsed",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "monthsUsed",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitResumePosition",
                  "kind": "LinkedField",
                  "name": "employmentHistory",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "index",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isInProfile",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "canClarify",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "canImport",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "companyId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "companyName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "companyIsVerified",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "inProfileOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasInvalidCompany",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasInvalidFromDate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasInvalidToDate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "title",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "resumePositionType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "industry",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "from",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "to",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobTitles",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "SkillTag",
                      "kind": "LinkedField",
                      "name": "skills",
                      "plural": true,
                      "selections": [
                        v8,
                        v9
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isExcluded",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasExperience",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasExperienceToClarify",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasRecentExperience",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasRecentExperienceToClarify",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasExperienceToImport",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasValidExperience",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasInValidExperience",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "addedToProfile",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "17e0ffa142f342ec0f6695ed9bfa50ee",
      "id": null,
      "metadata": {},
      "name": "ResumeContainerQuery",
      "operationKind": "query",
      "text": "query ResumeContainerQuery(\n  $resumeId: UUID!\n) {\n  resume: recruitResumeById(id: $resumeId) {\n    id\n    resumeId\n    profileId\n    status\n    createdAt\n    updatedAt\n    ...ResumeView_resume\n  }\n}\n\nfragment ResumeClarifyPositions_resume on RecruitResume {\n  id\n  resumeId\n  resumeData {\n    employmentHistory {\n      index\n      isInProfile\n      canClarify\n      canImport\n      ...ResumePositionEditor_position\n    }\n  }\n}\n\nfragment ResumeHeader_resume on RecruitResume {\n  id\n  resumeId\n  profileId\n  createdAt\n  updatedAt\n  fileName\n  status\n}\n\nfragment ResumePositionEditor_position on RecruitResumePosition {\n  index\n  companyId\n  companyName\n  companyIsVerified\n  canClarify\n  canImport\n  isInProfile\n  inProfileOn\n  hasInvalidCompany\n  hasInvalidFromDate\n  hasInvalidToDate\n  title\n  resumePositionType\n  industry\n  description\n  from\n  to\n  jobTitles\n  skills {\n    skillId\n    skillName\n  }\n}\n\nfragment ResumePosition_position on RecruitResumePosition {\n  index\n  companyId\n  companyName\n  companyIsVerified\n  canClarify\n  canImport\n  isInProfile\n  isExcluded\n  inProfileOn\n  title\n  resumePositionType\n  industry\n  description\n  from\n  to\n  jobTitles\n  skills {\n    skillId\n    skillName\n  }\n}\n\nfragment ResumePositions_resume on RecruitResume {\n  id\n  resumeId\n  profileId\n  resumeData {\n    employmentHistory {\n      index\n      canImport\n      isInProfile\n      ...ResumePosition_position\n    }\n  }\n}\n\nfragment ResumeSkills_resume on RecruitResume {\n  id\n  resumeData {\n    skills {\n      skillId\n      skillName\n      lastUsed\n      monthsUsed\n    }\n  }\n}\n\nfragment ResumeView_resume on RecruitResume {\n  id\n  resumeId\n  profileId\n  createdAt\n  updatedAt\n  fileName\n  status\n  ...ResumeHeader_resume\n  ...ResumeSkills_resume\n  ...ResumeWorkflow_resume\n  ...ResumePositions_resume\n  ...ResumeClarifyPositions_resume\n}\n\nfragment ResumeWorkflow_resume on RecruitResume {\n  id\n  resumeId\n  profileId\n  createdAt\n  updatedAt\n  fileName\n  status\n  hasExperience\n  hasExperienceToClarify\n  hasRecentExperience\n  hasRecentExperienceToClarify\n  hasExperienceToImport\n  hasValidExperience\n  hasInValidExperience\n  addedToProfile\n  resumeData {\n    employmentHistory {\n      index\n      isInProfile\n      canClarify\n      canImport\n      ...ResumePositionEditor_position\n    }\n  }\n}\n"
    }
  };
}();
node51.hash = "b7c321be792aeb2302eb97de61bd6b5b";
var ResumeContainerQuery_graphql_default = node51;

// src/resumes/components/ResumeContainer.tsx
import { useLazyLoadQuery as useLazyLoadQuery9 } from "react-relay";
import { useParams as useParams4 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary3 } from "react-error-boundary";
import { noop as noop2 } from "shared-lib";
import { AlertMessage as AlertMessage5, EdSkeleton as EdSkeleton5 } from "shared-ui";

// src/resumes/components/__generated__/ResumeView_resume.graphql.ts
var node52 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ResumeView_resume",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "resumeId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profileId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fileName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ResumeHeader_resume"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ResumeSkills_resume"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ResumeWorkflow_resume"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ResumePositions_resume"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ResumeClarifyPositions_resume"
    }
  ],
  "type": "RecruitResume",
  "abstractKey": null
};
node52.hash = "b8a84312699db9a346754db3c44a2527";
var ResumeView_resume_graphql_default = node52;

// src/resumes/components/ResumeView.tsx
import { useFragment as useFragment19 } from "react-relay";
import { useToggle as useToggle6 } from "shared-lib";

// src/resumes/components/__generated__/ResumeHeader_resume.graphql.ts
var node53 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ResumeHeader_resume",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "resumeId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profileId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fileName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "RecruitResume",
  "abstractKey": null
};
node53.hash = "9c3283884913ea05496dbae71ec7e809";
var ResumeHeader_resume_graphql_default = node53;

// src/resumes/components/ResumeHeader.tsx
import { useFragment as useFragment14 } from "react-relay";
import { format as format6, parseISO as parseISO2 } from "date-fns";
import { jsx as jsx29, jsxs as jsxs20 } from "react/jsx-runtime";
var fragmentDef14 = ResumeHeader_resume_graphql_default;
var ResumeHeader = ({ fragmentRef }) => {
  const data = useFragment14(fragmentDef14, fragmentRef);
  return /* @__PURE__ */ jsxs20("div", { className: "p-2", children: [
    /* @__PURE__ */ jsx29("h3", { className: "text-lg font-medium uppercase leading-6 text-gray-900", children: data.fileName }),
    /* @__PURE__ */ jsxs20("p", { className: "mt-2 flex max-w-2xl items-center text-sm text-gray-500 sm:space-x-2", children: [
      /* @__PURE__ */ jsx29("span", { className: "hidden font-bold sm:block", children: "Uploaded" }),
      /* @__PURE__ */ jsx29("span", { children: format6(parseISO2(data.createdAt), "PPPp") })
    ] })
  ] });
};

// src/resumes/components/__generated__/ResumeWorkflow_resume.graphql.ts
var node54 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ResumeWorkflow_resume",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "resumeId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profileId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fileName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasExperience",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasExperienceToClarify",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasRecentExperience",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasRecentExperienceToClarify",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasExperienceToImport",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasValidExperience",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasInValidExperience",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "addedToProfile",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RecruitResumeData",
      "kind": "LinkedField",
      "name": "resumeData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RecruitResumePosition",
          "kind": "LinkedField",
          "name": "employmentHistory",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "index",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isInProfile",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canClarify",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canImport",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ResumePositionEditor_position"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RecruitResume",
  "abstractKey": null
};
node54.hash = "75c200e19c41e06517ce79e6c315d1cd";
var ResumeWorkflow_resume_graphql_default = node54;

// src/resumes/components/ResumeWorkflow.tsx
import { useCallback as useCallback14 } from "react";
import { useFragment as useFragment15 } from "react-relay";
import { createClientMutationId as createClientMutationId8, useLogger as useLogger3 } from "shared-lib";
import { Button as Button10 } from "shared-ui";
import { Fragment as Fragment8, jsx as jsx30, jsxs as jsxs21 } from "react/jsx-runtime";
var fragmentDef15 = ResumeWorkflow_resume_graphql_default;
var ResponseBox = ({
  message,
  action
}) => {
  return /* @__PURE__ */ jsxs21("div", { className: "my-2 border bg-white px-4 py-5 sm:px-6", children: [
    message && /* @__PURE__ */ jsx30("div", { className: "md:text-md py-2 text-sm", children: message }),
    /* @__PURE__ */ jsx30("div", { className: "mt-1 flex flex-col", children: action })
  ] });
};
var ResumeWorkflow = ({
  profileId,
  fragmentRef,
  onClarify
}) => {
  const [log] = useLogger3();
  const data = useFragment15(fragmentDef15, fragmentRef);
  const [addPositions, isAddingPositions] = useCandidateResumeAddPositions();
  const hasClarifications = checkRequireClarifications(
    data.resumeData.employmentHistory
  );
  const onAdd = useCallback14(async () => {
    const input = {
      profileId,
      clientMutationId: createClientMutationId8(),
      resumeId: data.resumeId
    };
    await addPositions({ input });
  }, [addPositions, profileId, data.resumeId]);
  log(`ResumeWorkflow Data: ${JSON.stringify(data)}`);
  if (hasClarifications) {
    return /* @__PURE__ */ jsx30(
      ResponseBox,
      {
        message: /* @__PURE__ */ jsx30("span", { children: "There is some work experience in your resume with missing data" }),
        action: /* @__PURE__ */ jsx30(Button10, { color: "primary", clicked: onClarify, children: "Clarify Now" })
      }
    );
  }
  if (data.hasExperienceToImport) {
    return /* @__PURE__ */ jsx30(
      ResponseBox,
      {
        action: /* @__PURE__ */ jsx30(Button10, { disabled: isAddingPositions, color: "primary", clicked: onAdd, children: "Add to your Profile" })
      }
    );
  }
  return /* @__PURE__ */ jsx30(Fragment8, {});
};

// src/resumes/components/__generated__/ResumeSkills_resume.graphql.ts
var node55 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ResumeSkills_resume",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RecruitResumeData",
      "kind": "LinkedField",
      "name": "resumeData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SkillModel",
          "kind": "LinkedField",
          "name": "skills",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "skillId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "skillName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lastUsed",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "monthsUsed",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RecruitResume",
  "abstractKey": null
};
node55.hash = "27174a86086a3e8aa64212b9a6f91f20";
var ResumeSkills_resume_graphql_default = node55;

// src/resumes/components/ResumeSkills.tsx
import { useFragment as useFragment16 } from "react-relay";
import { jsx as jsx31, jsxs as jsxs22 } from "react/jsx-runtime";
var fragmentDef16 = ResumeSkills_resume_graphql_default;
var ResumeSkills = ({ fragmentRef }) => {
  const data = useFragment16(fragmentDef16, fragmentRef);
  const skills = data.resumeData.skills.map((s4) => /* @__PURE__ */ jsx31(
    "li",
    {
      className: "bg-secondary-500 sm:text-md m-1 inline rounded px-2 py-1 text-sm text-white",
      children: s4.skillName
    },
    s4.skillId
  ));
  return /* @__PURE__ */ jsxs22("div", { className: "", children: [
    /* @__PURE__ */ jsx31("div", { className: "text-primary-500 text-md py-4", children: "Skills" }),
    /* @__PURE__ */ jsx31("ul", { className: "flex flex-wrap", children: skills })
  ] });
};

// src/resumes/components/__generated__/ResumePositions_resume.graphql.ts
var node56 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ResumePositions_resume",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "resumeId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profileId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RecruitResumeData",
      "kind": "LinkedField",
      "name": "resumeData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RecruitResumePosition",
          "kind": "LinkedField",
          "name": "employmentHistory",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "index",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canImport",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isInProfile",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ResumePosition_position"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RecruitResume",
  "abstractKey": null
};
node56.hash = "ce38ca6b4f27ca98aa77409492ecae4c";
var ResumePositions_resume_graphql_default = node56;

// src/resumes/components/ResumePositions.tsx
import { useFragment as useFragment18 } from "react-relay";

// src/resumes/components/__generated__/ResumePosition_position.graphql.ts
var node57 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ResumePosition_position",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "index",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "companyId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "companyName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "companyIsVerified",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canClarify",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canImport",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isInProfile",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isExcluded",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "inProfileOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "resumePositionType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "industry",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "from",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "to",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "jobTitles",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SkillTag",
      "kind": "LinkedField",
      "name": "skills",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "skillId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "skillName",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RecruitResumePosition",
  "abstractKey": null
};
node57.hash = "10a28d0d9020f614a43d6fd56e8271b9";
var ResumePosition_position_graphql_default = node57;

// src/resumes/components/ResumePosition.tsx
import { useCallback as useCallback15 } from "react";
import { useFragment as useFragment17 } from "react-relay";
import { format as format7, formatDistance as formatDistance5 } from "date-fns";
import {
  createClientMutationId as createClientMutationId9,
  parseDate as parseDate7,
  useLogger as useLogger4,
  useToggle as useToggle5
} from "shared-lib";
import { Button as Button11, ButtonList as ButtonList4, HtmlDisplay as HtmlDisplay3, Tag as Tag5 } from "shared-ui";
import { Fragment as Fragment9, jsx as jsx32, jsxs as jsxs23 } from "react/jsx-runtime";
var fragmentDef17 = ResumePosition_position_graphql_default;
var ResumePosition = ({
  profileId,
  resumeId,
  fragmentRef
}) => {
  const [log] = useLogger4();
  const data = useFragment17(
    fragmentDef17,
    fragmentRef
  );
  const [addToProfile, isAddingToProfile] = useCandidateResumeImportPositions();
  const [excludePosition, isExcludingPosition] = useCandidateResumeExcludePosition();
  const [isShowingDescription, toggleShowDescription] = useToggle5(false);
  const onIgnore = useCallback15(() => {
    async function onIgnoreAsync() {
      await excludePosition({
        input: {
          profileId,
          resumeId,
          positionIndex: data.index,
          clientMutationId: createClientMutationId9()
        }
      });
      log("ExcludePosition");
    }
    onIgnoreAsync();
  }, [log]);
  const onAddToProfile = useCallback15(() => {
    async function onAddToProfileAsync() {
      await addToProfile({
        input: {
          profileId,
          resumeId,
          positionIndexes: [data.index],
          clientMutationId: createClientMutationId9()
        }
      });
      log("AddToProfile");
    }
    onAddToProfileAsync();
  }, [log]);
  let from = "Unknown";
  let to = "Unknown";
  let distance2 = "";
  let startDate, endDate;
  if (data.from) {
    startDate = parseDate7(data.from);
    from = format7(startDate, "MMMM yyyy");
  }
  if (data.to) {
    endDate = parseDate7(data.to);
    to = format7(endDate, "MMMM yyyy");
  }
  if (startDate && endDate) {
    distance2 = formatDistance5(startDate, endDate);
  }
  return /* @__PURE__ */ jsxs23("div", { className: "flex flex-col rounded-lg border-b bg-white lg:border-x ", children: [
    /* @__PURE__ */ jsxs23("div", { className: "px-4 py-5 sm:px-6", children: [
      /* @__PURE__ */ jsxs23("div", { className: "flex flex-wrap justify-between sm:items-center", children: [
        /* @__PURE__ */ jsx32("h3", { className: "text-primary-900 text-lg font-medium leading-10", children: data.companyName }),
        data.industry && /* @__PURE__ */ jsx32(Tag5, { size: "xsmall", children: data.industry })
      ] }),
      /* @__PURE__ */ jsxs23("div", { className: "flex flex-wrap justify-between sm:items-center", children: [
        /* @__PURE__ */ jsx32("h3", { className: "border-b text-lg font-medium leading-8 text-gray-700 sm:border-none", children: data.title }),
        /* @__PURE__ */ jsxs23("div", { className: "flex flex-wrap justify-end space-x-2 py-2 sm:py-0", children: [
          data.isInProfile && /* @__PURE__ */ jsx32("div", { children: /* @__PURE__ */ jsx32(Tag5, { size: "xsmall", children: "In Profile" }) }),
          /* @__PURE__ */ jsx32("div", { children: /* @__PURE__ */ jsx32(Tag5, { size: "xsmall", children: data.resumePositionType }) })
        ] })
      ] }),
      /* @__PURE__ */ jsxs23("div", { className: "flex items-center space-x-2 py-3 text-sm text-gray-500", children: [
        /* @__PURE__ */ jsxs23("div", { className: "", children: [
          from,
          " -"
        ] }),
        /* @__PURE__ */ jsx32("div", { className: "", children: to }),
        /* @__PURE__ */ jsxs23("div", { className: "hidden sm:block", children: [
          "(",
          distance2,
          ")\xA0"
        ] })
      ] }),
      isShowingDescription && data.description ? /* @__PURE__ */ jsxs23("div", { children: [
        /* @__PURE__ */ jsx32("div", { className: "mb-2 py-2", children: /* @__PURE__ */ jsx32(Button11, { color: "green", clicked: toggleShowDescription, children: "Hide Description" }) }),
        /* @__PURE__ */ jsx32("div", { className: "rounded-md border bg-gray-50 p-4", children: /* @__PURE__ */ jsx32(HtmlDisplay3, { html: data.description }) })
      ] }) : null
    ] }),
    /* @__PURE__ */ jsxs23("div", { className: "mt-2 flex items-center justify-between border-t px-4 py-2 lg:px-6", children: [
      /* @__PURE__ */ jsx32(ButtonList4, { children: /* @__PURE__ */ jsx32(
        Button11,
        {
          disabled: isShowingDescription,
          color: "green",
          clicked: toggleShowDescription,
          children: "Show Description"
        }
      ) }),
      /* @__PURE__ */ jsx32(ButtonList4, { justify: "END", children: !data.inProfileOn && !data.isExcluded && /* @__PURE__ */ jsxs23(Fragment9, { children: [
        /* @__PURE__ */ jsx32(
          Button11,
          {
            color: "primary",
            disabled: isAddingToProfile,
            clicked: onAddToProfile,
            children: "Add To Profile"
          }
        ),
        /* @__PURE__ */ jsx32(
          Button11,
          {
            color: "gray",
            disabled: isExcludingPosition,
            clicked: onIgnore,
            children: "Ignore"
          }
        )
      ] }) })
    ] })
  ] });
};

// src/resumes/components/ResumePositions.tsx
import { Fragment as Fragment10, jsx as jsx33, jsxs as jsxs24 } from "react/jsx-runtime";
var fragmentDef18 = ResumePositions_resume_graphql_default;
var ResumePositions = ({
  filterCanImportOnly,
  fragmentRef
}) => {
  const data = useFragment18(
    fragmentDef18,
    fragmentRef
  );
  const positions = filterCanImportOnly ? data.resumeData.employmentHistory.filter(
    (e4) => e4.canImport && e4.isInProfile === false
  ) : data.resumeData.employmentHistory;
  const employmentHistory = positions.map((e4) => /* @__PURE__ */ jsx33("div", { children: /* @__PURE__ */ jsx33(
    ResumePosition,
    {
      profileId: data.profileId,
      resumeId: data.resumeId,
      fragmentRef: e4
    }
  ) }, e4.index));
  return /* @__PURE__ */ jsxs24(Fragment10, { children: [
    /* @__PURE__ */ jsx33("div", { className: "text-primary-500 text-md mb-5 border-b px-2 py-3", children: "Work History" }),
    /* @__PURE__ */ jsx33("div", { className: "flex flex-col gap-2", children: employmentHistory })
  ] });
};

// src/resumes/components/ResumeView.tsx
import { jsx as jsx34, jsxs as jsxs25 } from "react/jsx-runtime";
var fragmentDef19 = ResumeView_resume_graphql_default;
var ResumeView = ({ fragmentRef }) => {
  const data = useFragment19(fragmentDef19, fragmentRef);
  const [isClarifying, toggleIsClarifying] = useToggle6(false);
  if (isClarifying) {
    return /* @__PURE__ */ jsx34(
      ResumeClarifyPositions,
      {
        profileId: data.profileId,
        fragmentRef: data,
        onDone: toggleIsClarifying
      }
    );
  }
  return /* @__PURE__ */ jsxs25("div", { children: [
    /* @__PURE__ */ jsx34(ResumeHeader, { fragmentRef: data }),
    /* @__PURE__ */ jsx34(
      ResumeWorkflow,
      {
        profileId: data.profileId,
        fragmentRef: data,
        onClarify: toggleIsClarifying
      }
    ),
    /* @__PURE__ */ jsxs25("div", { className: "grid", children: [
      /* @__PURE__ */ jsx34(ResumePositions, { fragmentRef: data }),
      /* @__PURE__ */ jsx34(ResumeSkills, { fragmentRef: data })
    ] })
  ] });
};

// src/resumes/components/__generated__/ResumePollerQuery.graphql.ts
var node58 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "id"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "id"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdBy",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedBy",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "resumeId",
    "storageKey": null
  }, v8 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "skillId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "skillName",
      "storageKey": null
    }
  ], v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyId",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyName",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyIsVerified",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "industry",
    "storageKey": null
  }, v14 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  }, v15 = {
    "alias": null,
    "args": null,
    "concreteType": "RecruitResumeData",
    "kind": "LinkedField",
    "name": "resumeData",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SkillModel",
        "kind": "LinkedField",
        "name": "skills",
        "plural": true,
        "selections": v8,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitResumePosition",
        "kind": "LinkedField",
        "name": "employmentHistory",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "index",
            "storageKey": null
          },
          v9,
          v10,
          v11,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canClarify",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canImport",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isInProfile",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isExcluded",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "inProfileOn",
            "storageKey": null
          },
          v12,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "resumePositionType",
            "storageKey": null
          },
          v13,
          v14,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "from",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "to",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "jobTitles",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SkillTag",
            "kind": "LinkedField",
            "name": "skills",
            "plural": true,
            "selections": v8,
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v16 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "profileId",
    "storageKey": null
  }, v17 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "version",
    "storageKey": null
  }, v18 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasExperience",
    "storageKey": null
  }, v19 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasExperienceToClarify",
    "storageKey": null
  }, v20 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasRecentExperience",
    "storageKey": null
  }, v21 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasRecentExperienceToClarify",
    "storageKey": null
  }, v222 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasExperienceToImport",
    "storageKey": null
  }, v232 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasValidExperience",
    "storageKey": null
  }, v24 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasInValidExperience",
    "storageKey": null
  }, v25 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "addedToProfile",
    "storageKey": null
  }, v26 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  }, v27 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "recruitProfileId",
    "storageKey": null
  }, v28 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateExperienceId",
    "storageKey": null
  }, v29 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "skills",
    "storageKey": null
  }, v30 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "countryCode",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ResumePollerQuery",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitResume",
          "kind": "LinkedField",
          "name": "recruitResumeById",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            v5,
            v6,
            v7,
            v15,
            v16,
            v17,
            v18,
            v19,
            v20,
            v21,
            v222,
            v232,
            v24,
            v25,
            v26,
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfile",
              "kind": "LinkedField",
              "name": "profile",
              "plural": false,
              "selections": [
                v27,
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ProfileContainer_profile"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ResumePollerQuery",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitResume",
          "kind": "LinkedField",
          "name": "recruitResumeById",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            v5,
            v6,
            v7,
            v15,
            v16,
            v17,
            v18,
            v19,
            v20,
            v21,
            v222,
            v232,
            v24,
            v25,
            v26,
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfile",
              "kind": "LinkedField",
              "name": "profile",
              "plural": false,
              "selections": [
                v27,
                v23,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileSummary",
                  "kind": "LinkedField",
                  "name": "summary",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currentJobTitleName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "prefersNoResume",
                      "storageKey": null
                    },
                    v23
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperience",
                  "kind": "LinkedField",
                  "name": "currentPosition",
                  "plural": false,
                  "selections": [
                    v10,
                    v11,
                    v12,
                    v23,
                    v17,
                    v28,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "titleId",
                      "storageKey": null
                    },
                    v9,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "startDate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "endDate",
                      "storageKey": null
                    },
                    v13,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "positionType",
                      "storageKey": null
                    },
                    v14,
                    v29
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileRate",
                  "kind": "LinkedField",
                  "name": "rate",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "maximumRateOfPay",
                      "storageKey": null
                    },
                    v23,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "payType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "minimumRateOfPay",
                      "storageKey": null
                    },
                    v30,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currencyCode",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperienceCollection",
                  "kind": "LinkedField",
                  "name": "experiences",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileExperience",
                      "kind": "LinkedField",
                      "name": "items",
                      "plural": true,
                      "selections": [
                        v23,
                        v29
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitResume",
                  "kind": "LinkedField",
                  "name": "resume",
                  "plural": false,
                  "selections": [
                    v23,
                    v25
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RightToWork",
                  "kind": "LinkedField",
                  "name": "rightToWork",
                  "plural": true,
                  "selections": [
                    v23
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsCandidateAccount",
                  "kind": "LinkedField",
                  "name": "account",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "accountId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "firstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastName",
                      "storageKey": null
                    },
                    v23
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileWorkLocations",
                  "kind": "LinkedField",
                  "name": "workLocations",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currentLocationCountryCode",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currentLocationCountryName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currentLocationName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currentLocationLatitude",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currentLocationLongitude",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currentLocationRadius",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "WorkLocationEntry",
                      "kind": "LinkedField",
                      "name": "workLocations",
                      "plural": true,
                      "selections": [
                        v23,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        },
                        v30,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "countryName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "entireCountry",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "latitude",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "longitude",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "radius",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    v23
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperience",
                  "kind": "LinkedField",
                  "name": "experience",
                  "plural": true,
                  "selections": [
                    v23,
                    v28,
                    v10,
                    v13
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileAvailability",
                  "kind": "LinkedField",
                  "name": "availability",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobSearchStatus",
                      "storageKey": null
                    },
                    v23
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "2782126f802a49f67c8225e085cfbc1e",
      "id": null,
      "metadata": {},
      "name": "ResumePollerQuery",
      "operationKind": "query",
      "text": "query ResumePollerQuery(\n  $id: UUID!\n) {\n  result: recruitResumeById(id: $id) {\n    id\n    createdAt\n    createdBy\n    updatedAt\n    updatedBy\n    resumeId\n    resumeData {\n      skills {\n        skillId\n        skillName\n      }\n      employmentHistory {\n        index\n        companyId\n        companyName\n        companyIsVerified\n        canClarify\n        canImport\n        isInProfile\n        isExcluded\n        inProfileOn\n        title\n        resumePositionType\n        industry\n        description\n        from\n        to\n        jobTitles\n        skills {\n          skillId\n          skillName\n        }\n      }\n    }\n    profileId\n    version\n    hasExperience\n    hasExperienceToClarify\n    hasRecentExperience\n    hasRecentExperienceToClarify\n    hasExperienceToImport\n    hasValidExperience\n    hasInValidExperience\n    addedToProfile\n    status\n    profile {\n      recruitProfileId\n      ...ProfileContainer_profile\n      id\n    }\n  }\n}\n\nfragment CompaniesTags_profile on RecruitProfile {\n  id\n  experience {\n    id\n    candidateExperienceId\n    companyName\n  }\n}\n\nfragment ExperienceCurrent_profile on RecruitProfile {\n  id\n  recruitProfileId\n  summary {\n    prefersNoResume\n    id\n  }\n  currentPosition {\n    id\n    version\n    candidateExperienceId\n    titleId\n    title\n    companyId\n    companyName\n    companyIsVerified\n    startDate\n    endDate\n    industry\n    positionType\n    description\n    ...ExperienceItem_profile\n  }\n}\n\nfragment ExperienceItem_profile on RecruitProfileExperience {\n  id\n  version\n  candidateExperienceId\n  titleId\n  title\n  companyId\n  companyName\n  companyIsVerified\n  startDate\n  endDate\n  industry\n  positionType\n  description\n  skills\n  ...ExperienceSkills_skills\n}\n\nfragment ExperienceSkills_skills on RecruitProfileExperience {\n  skills\n}\n\nfragment IndustriesTags_profile on RecruitProfile {\n  id\n  experience {\n    id\n    industry\n  }\n}\n\nfragment ProfileContainer_profile on RecruitProfile {\n  id\n  recruitProfileId\n  summary {\n    currentJobTitleName\n    prefersNoResume\n    id\n  }\n  currentPosition {\n    companyName\n    companyIsVerified\n    title\n    id\n  }\n  rate {\n    maximumRateOfPay\n    id\n  }\n  experiences {\n    items {\n      id\n      skills\n    }\n  }\n  resume {\n    id\n    addedToProfile\n  }\n  rightToWork {\n    id\n  }\n  account {\n    accountId\n    firstName\n    lastName\n    id\n  }\n  workLocations {\n    currentLocationCountryCode\n    currentLocationCountryName\n    currentLocationName\n    currentLocationLatitude\n    currentLocationLongitude\n    currentLocationRadius\n    workLocations {\n      id\n      name\n      countryCode\n      countryName\n      entireCountry\n      latitude\n      longitude\n      radius\n    }\n    id\n  }\n  ...Rates_RecruitProfile\n  ...ProfileInfoSidebar_profile\n  ...CompaniesTags_profile\n  ...IndustriesTags_profile\n  ...ExperienceCurrent_profile\n  ...RateEditor_RecruitProfile\n}\n\nfragment ProfileInfoSidebar_profile on RecruitProfile {\n  id\n  experience {\n    id\n    candidateExperienceId\n    companyName\n  }\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n  availability {\n    jobSearchStatus\n    id\n  }\n  workLocations {\n    workLocations {\n      name\n      countryCode\n    }\n    id\n  }\n}\n\nfragment RateEditor_RecruitProfile on RecruitProfile {\n  recruitProfileId\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n}\n\nfragment Rates_RecruitProfile on RecruitProfile {\n  recruitProfileId\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n}\n"
    }
  };
}();
node58.hash = "beb9e2e3a9d0d019e2c62cfa53e5d51a";
var ResumePollerQuery_graphql_default = node58;

// src/resumes/components/ResumePoller.tsx
import { useCallback as useCallback16, useEffect as useEffect5, useState as useState8, useTransition } from "react";
import {
  usePreloadedQuery,
  useQueryLoader
} from "react-relay";
import { useInterval } from "react-use";
import { useLogger as useLogger5 } from "shared-lib";
import { EdSkeleton as EdSkeleton4 } from "shared-ui";
import { jsx as jsx35, jsxs as jsxs26 } from "react/jsx-runtime";
var queryDef6 = ResumePollerQuery_graphql_default;
var PollLimit = 500;
var ResumePollerLoader = ({
  resumeId,
  onReady,
  onTimeout,
  onFailed
}) => {
  const [queryReference, loadQuery48, disposeQuery] = useQueryLoader(queryDef6);
  const [isPending, startTransition2] = useTransition();
  const reload = useCallback16(() => {
    startTransition2(() => {
      disposeQuery();
      loadQuery48({ id: resumeId }, { fetchPolicy: "network-only" });
    });
  }, [loadQuery48, resumeId, disposeQuery]);
  const ready = useCallback16(
    (resume) => {
      disposeQuery();
      onReady(resume);
    },
    [disposeQuery, onReady]
  );
  const timeout = useCallback16(() => {
    disposeQuery();
    onTimeout();
  }, [disposeQuery, onTimeout]);
  const failed = useCallback16(() => {
    disposeQuery();
    onFailed();
  }, [disposeQuery, onFailed]);
  useEffect5(() => {
    startTransition2(() => {
      disposeQuery();
      loadQuery48({ id: resumeId }, { fetchPolicy: "network-only" });
    });
  }, [loadQuery48, resumeId, disposeQuery]);
  if (isPending || !queryReference) {
    return /* @__PURE__ */ jsx35(EdSkeleton4, {});
  }
  return /* @__PURE__ */ jsx35(
    ResumePoller,
    {
      queryRef: queryReference,
      onReload: reload,
      onReady: ready,
      onTimeout: timeout,
      onFailed: failed
    }
  );
};
var ResumePoller = ({
  queryRef: queryRef3,
  onReload,
  onReady,
  onTimeout,
  onFailed
}) => {
  const [log] = useLogger5();
  const [isWaiting, setIsWaiting] = useState8(true);
  const [pollCount, setPollCount] = useState8(1);
  const data = usePreloadedQuery(queryDef6, queryRef3);
  log(`Resume Poller Query Result: ${JSON.stringify(data.result)}`);
  useInterval(
    () => {
      setPollCount((count) => count + 1);
      if (data.result && data.result.status) {
        const status = data.result.status;
        log(`Resume Status ${status}`);
        if (data.result.status === "COMPLETED" || data.result.status === "RESOLVED") {
          setIsWaiting(false);
          log(`Resume Poller onReady: ${JSON.stringify(data.result)}`);
          onReady(data.result);
        } else if (data.result.status === "FAILED") {
          setIsWaiting(false);
          onFailed();
        } else if (data.result.status === "PARSED" || data.result.status === "CREATED") {
          if (pollCount >= PollLimit) {
            setIsWaiting(false);
            onTimeout();
          } else {
            onReload();
          }
          return;
        }
      }
    },
    isWaiting ? 2e3 : null
  );
  return /* @__PURE__ */ jsx35("div", { className: "flex justify-center", children: /* @__PURE__ */ jsxs26("div", { children: [
    /* @__PURE__ */ jsx35("div", { className: "text-primary-700 pb-3 font-bold", children: "Processing your Resume, one moment...." }),
    /* @__PURE__ */ jsx35("div", { children: isWaiting && /* @__PURE__ */ jsx35(EdSkeleton4, {}) })
  ] }) });
};

// src/resumes/components/ResumeContainer.tsx
import { jsx as jsx36, jsxs as jsxs27 } from "react/jsx-runtime";
var queryDef7 = ResumeContainerQuery_graphql_default;
var ResumeBoundaryFallback = ({
  error
}) => {
  return /* @__PURE__ */ jsxs27("div", { className: "m-8", role: "alert", children: [
    /* @__PURE__ */ jsx36("div", { className: "text-info-500 border-b border-gray-500 font-medium", children: /* @__PURE__ */ jsx36("h1", { children: "Something went wrong" }) }),
    /* @__PURE__ */ jsx36("div", { className: "flex flex-wrap", children: /* @__PURE__ */ jsx36("p", { className: "bg-danger-500", children: error.message }) })
  ] });
};
var ResumeContainer = () => {
  const { resumeId } = useParams4();
  const query3 = useLazyLoadQuery9(
    queryDef7,
    { resumeId },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { resume } = query3;
  if (!resume) {
    return /* @__PURE__ */ jsx36("div", { children: /* @__PURE__ */ jsx36("h1", { children: "Resume Not Found" }) });
  }
  let currentState;
  switch (resume.status) {
    case "CREATED":
      currentState = /* @__PURE__ */ jsx36(EdSkeleton5, {});
      break;
    case "FAILED":
      currentState = /* @__PURE__ */ jsx36("div", { className: "my-8", children: /* @__PURE__ */ jsx36(AlertMessage5, { message: "Resume processing failed. Please contact support to investigate further" }) });
      break;
    case "COMPLETED":
    case "RESOLVED":
      if (resume) {
        currentState = /* @__PURE__ */ jsx36(ResumeView, { fragmentRef: resume });
      } else {
        currentState = /* @__PURE__ */ jsx36(EdSkeleton5, {});
      }
      break;
    default:
      currentState = /* @__PURE__ */ jsx36(
        ResumePollerLoader,
        {
          resumeId: resume.resumeId,
          onReady: noop2,
          onFailed: noop2,
          onTimeout: noop2
        }
      );
      break;
  }
  return /* @__PURE__ */ jsx36(ErrorBoundary3, { FallbackComponent: ResumeBoundaryFallback, children: /* @__PURE__ */ jsx36("div", { className: "p-2 md:mx-4 md:mt-2 lg:mx-16 lg:mt-8", children: currentState }) });
};

// src/resumes/components/__generated__/ResumeListPaginationQuery.graphql.ts
var node59 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 15,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": {
        "createdAt": "DESC"
      },
      "kind": "LocalArgument",
      "name": "order"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v23 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v32 = {
    "kind": "Variable",
    "name": "order",
    "variableName": "order"
  }, v4 = [
    v1,
    v23,
    v32,
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ], v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "skillId",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "skillName",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ResumeListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v23,
            v32
          ],
          "kind": "FragmentSpread",
          "name": "ResumeList_resumes"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ResumeListPaginationQuery",
      "selections": [
        {
          "alias": "resumes",
          "args": v4,
          "concreteType": "RecruitResumesConnection",
          "kind": "LinkedField",
          "name": "recruitResumes",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitResumesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitResume",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "resumeId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "profileId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "fileName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasExperience",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasExperienceToClarify",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasRecentExperience",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasRecentExperienceToClarify",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasExperienceToImport",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasValidExperience",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasInValidExperience",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "addedToProfile",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitResumeData",
                      "kind": "LinkedField",
                      "name": "resumeData",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "SkillModel",
                          "kind": "LinkedField",
                          "name": "skills",
                          "plural": true,
                          "selections": [
                            v5,
                            v6,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "lastUsed",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "monthsUsed",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitResumePosition",
                          "kind": "LinkedField",
                          "name": "employmentHistory",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "index",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "isInProfile",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "canClarify",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "canImport",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "companyId",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "companyName",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "companyIsVerified",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "inProfileOn",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "hasInvalidCompany",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "hasInvalidFromDate",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "hasInvalidToDate",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "title",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "resumePositionType",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "industry",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "description",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "from",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "to",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "jobTitles",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "SkillTag",
                              "kind": "LinkedField",
                              "name": "skills",
                              "plural": true,
                              "selections": [
                                v5,
                                v6
                              ],
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "isExcluded",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "resumes",
          "args": v4,
          "filters": [],
          "handle": "connection",
          "key": "ResumeList_resumes",
          "kind": "LinkedHandle",
          "name": "recruitResumes"
        }
      ]
    },
    "params": {
      "cacheID": "13d21512ef9944e274bae16b16d7f651",
      "id": null,
      "metadata": {},
      "name": "ResumeListPaginationQuery",
      "operationKind": "query",
      "text": "query ResumeListPaginationQuery(\n  $after: String\n  $first: Int = 15\n  $order: [RecruitResumeSort!] = {createdAt: DESC}\n  $where: RecruitResumeFilter\n) {\n  ...ResumeList_resumes_gOVF5\n}\n\nfragment ResumeClarifyPositions_resume on RecruitResume {\n  id\n  resumeId\n  resumeData {\n    employmentHistory {\n      index\n      isInProfile\n      canClarify\n      canImport\n      ...ResumePositionEditor_position\n    }\n  }\n}\n\nfragment ResumeHeader_resume on RecruitResume {\n  id\n  resumeId\n  profileId\n  createdAt\n  updatedAt\n  fileName\n  status\n}\n\nfragment ResumeList_resumes_gOVF5 on Query {\n  resumes: recruitResumes(first: $first, after: $after, order: $order, where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        resumeId\n        profileId\n        createdAt\n        updatedAt\n        fileName\n        status\n        hasExperience\n        hasExperienceToClarify\n        hasRecentExperience\n        hasRecentExperienceToClarify\n        hasExperienceToImport\n        hasValidExperience\n        hasInValidExperience\n        addedToProfile\n        ...ResumeView_resume\n        __typename\n      }\n    }\n  }\n}\n\nfragment ResumePositionEditor_position on RecruitResumePosition {\n  index\n  companyId\n  companyName\n  companyIsVerified\n  canClarify\n  canImport\n  isInProfile\n  inProfileOn\n  hasInvalidCompany\n  hasInvalidFromDate\n  hasInvalidToDate\n  title\n  resumePositionType\n  industry\n  description\n  from\n  to\n  jobTitles\n  skills {\n    skillId\n    skillName\n  }\n}\n\nfragment ResumePosition_position on RecruitResumePosition {\n  index\n  companyId\n  companyName\n  companyIsVerified\n  canClarify\n  canImport\n  isInProfile\n  isExcluded\n  inProfileOn\n  title\n  resumePositionType\n  industry\n  description\n  from\n  to\n  jobTitles\n  skills {\n    skillId\n    skillName\n  }\n}\n\nfragment ResumePositions_resume on RecruitResume {\n  id\n  resumeId\n  profileId\n  resumeData {\n    employmentHistory {\n      index\n      canImport\n      isInProfile\n      ...ResumePosition_position\n    }\n  }\n}\n\nfragment ResumeSkills_resume on RecruitResume {\n  id\n  resumeData {\n    skills {\n      skillId\n      skillName\n      lastUsed\n      monthsUsed\n    }\n  }\n}\n\nfragment ResumeView_resume on RecruitResume {\n  id\n  resumeId\n  profileId\n  createdAt\n  updatedAt\n  fileName\n  status\n  ...ResumeHeader_resume\n  ...ResumeSkills_resume\n  ...ResumeWorkflow_resume\n  ...ResumePositions_resume\n  ...ResumeClarifyPositions_resume\n}\n\nfragment ResumeWorkflow_resume on RecruitResume {\n  id\n  resumeId\n  profileId\n  createdAt\n  updatedAt\n  fileName\n  status\n  hasExperience\n  hasExperienceToClarify\n  hasRecentExperience\n  hasRecentExperienceToClarify\n  hasExperienceToImport\n  hasValidExperience\n  hasInValidExperience\n  addedToProfile\n  resumeData {\n    employmentHistory {\n      index\n      isInProfile\n      canClarify\n      canImport\n      ...ResumePositionEditor_position\n    }\n  }\n}\n"
    }
  };
}();
node59.hash = "9ac9c706a70fc32373703db476a4fb4a";
var ResumeListPaginationQuery_graphql_default = node59;

// src/resumes/components/__generated__/ResumeList_resumes.graphql.ts
var node60 = function() {
  var v0 = [
    "resumes"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 15,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "defaultValue": {
          "createdAt": "DESC"
        },
        "kind": "LocalArgument",
        "name": "order"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": ResumeListPaginationQuery_graphql_default
      }
    },
    "name": "ResumeList_resumes",
    "selections": [
      {
        "alias": "resumes",
        "args": null,
        "concreteType": "RecruitResumesConnection",
        "kind": "LinkedField",
        "name": "__ResumeList_resumes_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitResumesEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitResume",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "resumeId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "profileId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fileName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasExperience",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasExperienceToClarify",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasRecentExperience",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasRecentExperienceToClarify",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasExperienceToImport",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasValidExperience",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasInValidExperience",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "addedToProfile",
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ResumeView_resume"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node60.hash = "9ac9c706a70fc32373703db476a4fb4a";
var ResumeList_resumes_graphql_default = node60;

// src/resumes/components/ResumeList.tsx
import { useCallback as useCallback17 } from "react";
import { usePaginationFragment as usePaginationFragment3 } from "react-relay";
import { DocumentIcon } from "@heroicons/react/24/outline";
import { parseISO as parseISO3 } from "date-fns";
import { formatDate, isNotNullOrUndefined } from "shared-lib";
import { SectionedLayout } from "shared-ui";
import { jsx as jsx37 } from "react/jsx-runtime";
var fragment = ResumeList_resumes_graphql_default;
var SectionElement = ({ children }) => {
  return /* @__PURE__ */ jsx37("div", { className: "px-2 py-1 sm:px-8 sm:py-5", children });
};
var ResumeList = ({
  candidateId,
  fragmentRef
}) => {
  const { data, loadNext, hasNext, isLoadingNext } = usePaginationFragment3(fragment, fragmentRef);
  const { resumes } = data;
  const sections = (resumes?.edges || []).filter(isNotNullOrUndefined).map((resume) => {
    return {
      key: resume.node.resumeId,
      itemTitle: resume.node.fileName || "no file name",
      listTitle: resume.node.fileName || "no file name",
      description: `${formatDate(parseISO3(resume.node.createdAt))}`,
      icon: DocumentIcon,
      iconForeground: "text-primary-700",
      iconBackground: "bg-primary-50",
      element: /* @__PURE__ */ jsx37(SectionElement, { children: /* @__PURE__ */ jsx37(ResumeView, { fragmentRef: resume.node }) })
    };
  });
  const loadMore = useCallback17(() => {
    if (isLoadingNext) {
      return;
    }
    loadNext(5);
  }, [isLoadingNext, loadNext]);
  return /* @__PURE__ */ jsx37(
    SectionedLayout,
    {
      showMobileMenuIcon: false,
      sections,
      loadMore: hasNext ? loadMore : () => 0,
      isLoading: isLoadingNext && hasNext
    }
  );
};

// src/resumes/components/__generated__/ResumesLayoutQuery.graphql.ts
var node61 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 15
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": {
        "createdAt": "DESC"
      }
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "skillId",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "skillName",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ResumesLayoutQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ResumeList_resumes"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ResumesLayoutQuery",
      "selections": [
        {
          "alias": "resumes",
          "args": v1,
          "concreteType": "RecruitResumesConnection",
          "kind": "LinkedField",
          "name": "recruitResumes",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitResumesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitResume",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "resumeId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "profileId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "fileName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasExperience",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasExperienceToClarify",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasRecentExperience",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasRecentExperienceToClarify",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasExperienceToImport",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasValidExperience",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasInValidExperience",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "addedToProfile",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitResumeData",
                      "kind": "LinkedField",
                      "name": "resumeData",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "SkillModel",
                          "kind": "LinkedField",
                          "name": "skills",
                          "plural": true,
                          "selections": [
                            v23,
                            v32,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "lastUsed",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "monthsUsed",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitResumePosition",
                          "kind": "LinkedField",
                          "name": "employmentHistory",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "index",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "isInProfile",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "canClarify",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "canImport",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "companyId",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "companyName",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "companyIsVerified",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "inProfileOn",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "hasInvalidCompany",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "hasInvalidFromDate",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "hasInvalidToDate",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "title",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "resumePositionType",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "industry",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "description",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "from",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "to",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "jobTitles",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "SkillTag",
                              "kind": "LinkedField",
                              "name": "skills",
                              "plural": true,
                              "selections": [
                                v23,
                                v32
                              ],
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "isExcluded",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "resumes",
          "args": v1,
          "filters": [],
          "handle": "connection",
          "key": "ResumeList_resumes",
          "kind": "LinkedHandle",
          "name": "recruitResumes"
        }
      ]
    },
    "params": {
      "cacheID": "265cda541945fbf3a2263dd9a80aa21b",
      "id": null,
      "metadata": {},
      "name": "ResumesLayoutQuery",
      "operationKind": "query",
      "text": "query ResumesLayoutQuery(\n  $where: RecruitResumeFilter!\n) {\n  ...ResumeList_resumes\n}\n\nfragment ResumeClarifyPositions_resume on RecruitResume {\n  id\n  resumeId\n  resumeData {\n    employmentHistory {\n      index\n      isInProfile\n      canClarify\n      canImport\n      ...ResumePositionEditor_position\n    }\n  }\n}\n\nfragment ResumeHeader_resume on RecruitResume {\n  id\n  resumeId\n  profileId\n  createdAt\n  updatedAt\n  fileName\n  status\n}\n\nfragment ResumeList_resumes on Query {\n  resumes: recruitResumes(first: 15, order: {createdAt: DESC}, where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        resumeId\n        profileId\n        createdAt\n        updatedAt\n        fileName\n        status\n        hasExperience\n        hasExperienceToClarify\n        hasRecentExperience\n        hasRecentExperienceToClarify\n        hasExperienceToImport\n        hasValidExperience\n        hasInValidExperience\n        addedToProfile\n        ...ResumeView_resume\n        __typename\n      }\n    }\n  }\n}\n\nfragment ResumePositionEditor_position on RecruitResumePosition {\n  index\n  companyId\n  companyName\n  companyIsVerified\n  canClarify\n  canImport\n  isInProfile\n  inProfileOn\n  hasInvalidCompany\n  hasInvalidFromDate\n  hasInvalidToDate\n  title\n  resumePositionType\n  industry\n  description\n  from\n  to\n  jobTitles\n  skills {\n    skillId\n    skillName\n  }\n}\n\nfragment ResumePosition_position on RecruitResumePosition {\n  index\n  companyId\n  companyName\n  companyIsVerified\n  canClarify\n  canImport\n  isInProfile\n  isExcluded\n  inProfileOn\n  title\n  resumePositionType\n  industry\n  description\n  from\n  to\n  jobTitles\n  skills {\n    skillId\n    skillName\n  }\n}\n\nfragment ResumePositions_resume on RecruitResume {\n  id\n  resumeId\n  profileId\n  resumeData {\n    employmentHistory {\n      index\n      canImport\n      isInProfile\n      ...ResumePosition_position\n    }\n  }\n}\n\nfragment ResumeSkills_resume on RecruitResume {\n  id\n  resumeData {\n    skills {\n      skillId\n      skillName\n      lastUsed\n      monthsUsed\n    }\n  }\n}\n\nfragment ResumeView_resume on RecruitResume {\n  id\n  resumeId\n  profileId\n  createdAt\n  updatedAt\n  fileName\n  status\n  ...ResumeHeader_resume\n  ...ResumeSkills_resume\n  ...ResumeWorkflow_resume\n  ...ResumePositions_resume\n  ...ResumeClarifyPositions_resume\n}\n\nfragment ResumeWorkflow_resume on RecruitResume {\n  id\n  resumeId\n  profileId\n  createdAt\n  updatedAt\n  fileName\n  status\n  hasExperience\n  hasExperienceToClarify\n  hasRecentExperience\n  hasRecentExperienceToClarify\n  hasExperienceToImport\n  hasValidExperience\n  hasInValidExperience\n  addedToProfile\n  resumeData {\n    employmentHistory {\n      index\n      isInProfile\n      canClarify\n      canImport\n      ...ResumePositionEditor_position\n    }\n  }\n}\n"
    }
  };
}();
node61.hash = "59622f601b0fa99d3be992349379875b";
var ResumesLayoutQuery_graphql_default = node61;

// src/resumes/components/ResumesLayout.tsx
import { Suspense as Suspense10 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery10 } from "react-relay";
import { Routes as Routes2, Route as Route2, Navigate as Navigate2, Outlet as Outlet2, Link as Link3 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary4 } from "react-error-boundary";
import { Button as Button13, EdLink as EdLink3, EdSkeleton as EdSkeleton6, RouteContent as RouteContent2 } from "shared-ui";
import { ErrorBoundaryFallback as ErrorBoundaryFallback3 } from "app-core";

// src/resumes/components/ResumeUploadContainer.tsx
import { useCallback as useCallback18 } from "react";
import { useNavigate as useNavigate5 } from "react-router-dom";
import { useLogger as useLogger8 } from "shared-lib";

// src/resumes/components/ResumeUploader.tsx
import { useState as useState10 } from "react";
import { useLogger as useLogger7 } from "shared-lib";

// src/resumes/components/ResumeUpload.tsx
import { useState as useState9 } from "react";
import { useRelayEnvironment } from "react-relay";
import Uppy from "@uppy/core";

// ../../node_modules/@uppy/aws-s3/lib/index.js
import BasePlugin2 from "@uppy/core/lib/BasePlugin.js";

// ../../node_modules/@uppy/aws-s3-multipart/lib/index.js
import BasePlugin from "@uppy/core/lib/BasePlugin.js";

// ../../node_modules/@uppy/utils/lib/UserFacingApiError.js
var UserFacingApiError = class extends Error {
  constructor() {
    super(...arguments);
    this.name = "UserFacingApiError";
  }
};
var UserFacingApiError_default = UserFacingApiError;

// ../../node_modules/p-retry/index.js
var import_retry = __toESM(require_retry2(), 1);

// ../../node_modules/is-network-error/index.js
var objectToString = Object.prototype.toString;
var isError = (value) => objectToString.call(value) === "[object Error]";
var errorMessages = /* @__PURE__ */ new Set([
  "network error",
  // Chrome
  "Failed to fetch",
  // Chrome
  "NetworkError when attempting to fetch resource.",
  // Firefox
  "The Internet connection appears to be offline.",
  // Safari 16
  "Load failed",
  // Safari 17+
  "Network request failed",
  // `cross-fetch`
  "fetch failed"
  // Undici (Node.js)
]);
function isNetworkError(error) {
  const isValid = error && isError(error) && error.name === "TypeError" && typeof error.message === "string";
  if (!isValid) {
    return false;
  }
  if (error.message === "Load failed") {
    return error.stack === void 0;
  }
  return errorMessages.has(error.message);
}

// ../../node_modules/p-retry/index.js
var AbortError = class extends Error {
  constructor(message) {
    super();
    if (message instanceof Error) {
      this.originalError = message;
      ({ message } = message);
    } else {
      this.originalError = new Error(message);
      this.originalError.stack = this.stack;
    }
    this.name = "AbortError";
    this.message = message;
  }
};
var decorateErrorWithCounts = (error, attemptNumber, options7) => {
  const retriesLeft = options7.retries - (attemptNumber - 1);
  error.attemptNumber = attemptNumber;
  error.retriesLeft = retriesLeft;
  return error;
};
async function pRetry(input, options7) {
  return new Promise((resolve, reject) => {
    options7 = {
      onFailedAttempt() {
      },
      retries: 10,
      shouldRetry: () => true,
      ...options7
    };
    const operation = import_retry.default.operation(options7);
    const abortHandler = () => {
      operation.stop();
      reject(options7.signal?.reason);
    };
    if (options7.signal && !options7.signal.aborted) {
      options7.signal.addEventListener("abort", abortHandler, { once: true });
    }
    const cleanUp = () => {
      options7.signal?.removeEventListener("abort", abortHandler);
      operation.stop();
    };
    operation.attempt(async (attemptNumber) => {
      try {
        const result = await input(attemptNumber);
        cleanUp();
        resolve(result);
      } catch (error) {
        try {
          if (!(error instanceof Error)) {
            throw new TypeError(`Non-error was thrown: "${error}". You should only throw errors.`);
          }
          if (error instanceof AbortError) {
            throw error.originalError;
          }
          if (error instanceof TypeError && !isNetworkError(error)) {
            throw error;
          }
          decorateErrorWithCounts(error, attemptNumber, options7);
          if (!await options7.shouldRetry(error)) {
            operation.stop();
            reject(error);
          }
          await options7.onFailedAttempt(error);
          if (!operation.retry(error)) {
            throw operation.mainError();
          }
        } catch (finalError) {
          decorateErrorWithCounts(finalError, attemptNumber, options7);
          cleanUp();
          reject(finalError);
        }
      }
    });
  });
}

// ../../node_modules/@uppy/utils/lib/NetworkError.js
var NetworkError = class extends Error {
  constructor(error, xhr) {
    if (xhr === void 0) {
      xhr = null;
    }
    super(`This looks like a network error, the endpoint might be blocked by an internet provider or a firewall.`);
    this.cause = error;
    this.isNetworkError = true;
    this.request = xhr;
  }
};
var NetworkError_default = NetworkError;

// ../../node_modules/@uppy/utils/lib/fetchWithNetworkError.js
function fetchWithNetworkError() {
  return fetch(...arguments).catch((err) => {
    if (err.name === "AbortError") {
      throw err;
    } else {
      throw new NetworkError_default(err);
    }
  });
}

// ../../node_modules/@uppy/utils/lib/hasProperty.js
function has(object23, key) {
  return Object.prototype.hasOwnProperty.call(object23, key);
}

// ../../node_modules/@uppy/utils/lib/ErrorWithCause.js
var ErrorWithCause = class extends Error {
  constructor(message, options7) {
    super(message);
    this.cause = options7 == null ? void 0 : options7.cause;
    if (this.cause && has(this.cause, "isNetworkError")) {
      this.isNetworkError = this.cause.isNetworkError;
    } else {
      this.isNetworkError = false;
    }
  }
};
var ErrorWithCause_default = ErrorWithCause;

// ../../node_modules/@uppy/utils/lib/emitSocketProgress.js
var import_throttle = __toESM(require_throttle(), 1);
function emitSocketProgress(uploader, progressData, file) {
  const {
    progress: progress2,
    bytesUploaded,
    bytesTotal
  } = progressData;
  if (progress2) {
    uploader.uppy.log(`Upload progress: ${progress2}`);
    uploader.uppy.emit("upload-progress", file, {
      // @ts-expect-error todo remove in next major
      uploader,
      bytesUploaded,
      bytesTotal
    });
  }
}
var emitSocketProgress_default = (0, import_throttle.default)(emitSocketProgress, 300, {
  leading: true,
  trailing: true
});

// ../../node_modules/@uppy/utils/lib/getSocketHost.js
function getSocketHost(url) {
  var _regex$exec;
  const regex = /^(?:https?:\/\/|\/\/)?(?:[^@\n]+@)?(?:www\.)?([^\n]+)/i;
  const host = (_regex$exec = regex.exec(url)) == null ? void 0 : _regex$exec[1];
  const socketProtocol = /^http:\/\//i.test(url) ? "ws" : "wss";
  return `${socketProtocol}://${host}`;
}

// ../../node_modules/@uppy/companion-client/lib/AuthError.js
var AuthError = class extends Error {
  constructor() {
    super("Authorization required");
    this.name = "AuthError";
    this.isAuthError = true;
  }
};
var AuthError_default = AuthError;

// ../../node_modules/@uppy/companion-client/lib/RequestClient.js
var _Symbol$for;
function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id = 0;
function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}
var packageJson = {
  "version": "3.7.4"
};
function stripSlash(url) {
  return url.replace(/\/$/, "");
}
var retryCount = 10;
var socketActivityTimeoutMs = 5 * 60 * 1e3;
var authErrorStatusCode = 401;
var HttpError = class extends Error {
  constructor(_ref) {
    let {
      statusCode,
      message
    } = _ref;
    super(message);
    this.name = "HttpError";
    this.statusCode = statusCode;
  }
};
async function handleJSONResponse(res) {
  if (res.status === authErrorStatusCode) {
    throw new AuthError_default();
  }
  if (res.ok) {
    return res.json();
  }
  let errMsg = `Failed request with status: ${res.status}. ${res.statusText}`;
  let errData;
  try {
    errData = await res.json();
    if (errData.message)
      errMsg = `${errMsg} message: ${errData.message}`;
    if (errData.requestId)
      errMsg = `${errMsg} request-Id: ${errData.requestId}`;
  } catch (cause) {
    throw new Error(errMsg, {
      cause
    });
  }
  if (res.status >= 400 && res.status <= 499 && errData.message) {
    throw new UserFacingApiError_default(errData.message);
  }
  throw new HttpError({
    statusCode: res.status,
    message: errMsg
  });
}
var _companionHeaders = /* @__PURE__ */ _classPrivateFieldLooseKey("companionHeaders");
var _getUrl = /* @__PURE__ */ _classPrivateFieldLooseKey("getUrl");
var _requestSocketToken = /* @__PURE__ */ _classPrivateFieldLooseKey("requestSocketToken");
var _awaitRemoteFileUpload = /* @__PURE__ */ _classPrivateFieldLooseKey("awaitRemoteFileUpload");
_Symbol$for = Symbol.for("uppy test: getCompanionHeaders");
var RequestClient = class {
  constructor(uppy3, opts) {
    Object.defineProperty(this, _awaitRemoteFileUpload, {
      value: _awaitRemoteFileUpload2
    });
    Object.defineProperty(this, _getUrl, {
      value: _getUrl2
    });
    Object.defineProperty(this, _companionHeaders, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _requestSocketToken, {
      writable: true,
      value: async (_ref2) => {
        var _file$remote;
        let {
          file,
          postBody,
          signal
        } = _ref2;
        if (((_file$remote = file.remote) == null ? void 0 : _file$remote.url) == null) {
          throw new Error("Cannot connect to an undefined URL");
        }
        const res = await this.post(file.remote.url, {
          ...file.remote.body,
          ...postBody
        }, {
          signal
        });
        return res.token;
      }
    });
    this.uppy = uppy3;
    this.opts = opts;
    this.onReceiveResponse = this.onReceiveResponse.bind(this);
    _classPrivateFieldLooseBase(this, _companionHeaders)[_companionHeaders] = opts == null ? void 0 : opts.companionHeaders;
  }
  setCompanionHeaders(headers) {
    _classPrivateFieldLooseBase(this, _companionHeaders)[_companionHeaders] = headers;
  }
  [_Symbol$for]() {
    return _classPrivateFieldLooseBase(this, _companionHeaders)[_companionHeaders];
  }
  get hostname() {
    const {
      companion
    } = this.uppy.getState();
    const host = this.opts.companionUrl;
    return stripSlash(companion && companion[host] ? companion[host] : host);
  }
  async headers(emptyBody) {
    if (emptyBody === void 0) {
      emptyBody = false;
    }
    const defaultHeaders = {
      Accept: "application/json",
      ...emptyBody ? void 0 : {
        // Passing those headers on requests with no data forces browsers to first make a preflight request.
        "Content-Type": "application/json"
      }
    };
    return {
      ...defaultHeaders,
      ..._classPrivateFieldLooseBase(this, _companionHeaders)[_companionHeaders]
    };
  }
  onReceiveResponse(res) {
    const {
      headers
    } = res;
    const state = this.uppy.getState();
    const companion = state.companion || {};
    const host = this.opts.companionUrl;
    if (headers.has("i-am") && headers.get("i-am") !== companion[host]) {
      this.uppy.setState({
        companion: {
          ...companion,
          [host]: headers.get("i-am")
        }
      });
    }
  }
  async request(_ref3) {
    let {
      path,
      method = "GET",
      data,
      skipPostResponse,
      signal
    } = _ref3;
    try {
      const headers = await this.headers(!data);
      const response = await fetchWithNetworkError(_classPrivateFieldLooseBase(this, _getUrl)[_getUrl](path), {
        method,
        signal,
        headers,
        credentials: this.opts.companionCookiesRule || "same-origin",
        body: data ? JSON.stringify(data) : null
      });
      if (!skipPostResponse)
        this.onReceiveResponse(response);
      return await handleJSONResponse(response);
    } catch (err) {
      if (err.isAuthError || err.name === "UserFacingApiError" || err.name === "AbortError")
        throw err;
      throw new ErrorWithCause_default(`Could not ${method} ${_classPrivateFieldLooseBase(this, _getUrl)[_getUrl](path)}`, {
        cause: err
      });
    }
  }
  async get(path, options7) {
    if (typeof options7 === "boolean")
      options7 = {
        skipPostResponse: options7
      };
    return this.request({
      ...options7,
      path
    });
  }
  async post(path, data, options7) {
    if (typeof options7 === "boolean")
      options7 = {
        skipPostResponse: options7
      };
    return this.request({
      ...options7,
      path,
      method: "POST",
      data
    });
  }
  async delete(path, data, options7) {
    if (typeof options7 === "boolean")
      options7 = {
        skipPostResponse: options7
      };
    return this.request({
      ...options7,
      path,
      method: "DELETE",
      data
    });
  }
  /**
   * Remote uploading consists of two steps:
   * 1. #requestSocketToken which starts the download/upload in companion and returns a unique token for the upload.
   * Then companion will halt the upload until:
   * 2. #awaitRemoteFileUpload is called, which will open/ensure a websocket connection towards companion, with the
   * previously generated token provided. It returns a promise that will resolve/reject once the file has finished
   * uploading or is otherwise done (failed, canceled)
   */
  async uploadRemoteFile(file, reqBody, options7) {
    var _this = this;
    try {
      const {
        signal,
        getQueue
      } = options7 || {};
      return await pRetry(async () => {
        var _this$uppy$getFile;
        const existingServerToken = (_this$uppy$getFile = this.uppy.getFile(file.id)) == null ? void 0 : _this$uppy$getFile.serverToken;
        if (existingServerToken != null) {
          this.uppy.log(`Connecting to exiting websocket ${existingServerToken}`);
          return _classPrivateFieldLooseBase(this, _awaitRemoteFileUpload)[_awaitRemoteFileUpload]({
            file,
            queue: getQueue(),
            signal
          });
        }
        const queueRequestSocketToken = getQueue().wrapPromiseFunction(async function() {
          try {
            return await _classPrivateFieldLooseBase(_this, _requestSocketToken)[_requestSocketToken](...arguments);
          } catch (outerErr) {
            if (outerErr.isAuthError)
              throw new AbortError(outerErr);
            if (outerErr.cause == null)
              throw outerErr;
            const err = outerErr.cause;
            const isRetryableHttpError = () => [408, 409, 429, 418, 423].includes(err.statusCode) || err.statusCode >= 500 && err.statusCode <= 599 && ![501, 505].includes(err.statusCode);
            if (err.name === "HttpError" && !isRetryableHttpError())
              throw new AbortError(err);
            throw err;
          }
        }, {
          priority: -1
        });
        const serverToken = await queueRequestSocketToken({
          file,
          postBody: reqBody,
          signal
        }).abortOn(signal);
        if (!this.uppy.getFile(file.id))
          return void 0;
        this.uppy.setFileState(file.id, {
          serverToken
        });
        return _classPrivateFieldLooseBase(this, _awaitRemoteFileUpload)[_awaitRemoteFileUpload]({
          file: this.uppy.getFile(file.id),
          // re-fetching file because it might have changed in the meantime
          queue: getQueue(),
          signal
        });
      }, {
        retries: retryCount,
        signal,
        onFailedAttempt: (err) => this.uppy.log(`Retrying upload due to: ${err.message}`, "warning")
      });
    } catch (err) {
      if (err.name === "AbortError") {
        return void 0;
      }
      this.uppy.emit("upload-error", file, err);
      throw err;
    }
  }
};
function _getUrl2(url) {
  if (/^(https?:|)\/\//.test(url)) {
    return url;
  }
  return `${this.hostname}/${url}`;
}
async function _awaitRemoteFileUpload2(_ref4) {
  let {
    file,
    queue,
    signal
  } = _ref4;
  let removeEventHandlers;
  const {
    capabilities
  } = this.uppy.getState();
  try {
    return await new Promise((resolve, reject) => {
      const token = file.serverToken;
      const host = getSocketHost(file.remote.companionUrl);
      let socket;
      let socketAbortController;
      let activityTimeout;
      let {
        isPaused
      } = file;
      const socketSend = (action, payload) => {
        if (socket == null || socket.readyState !== socket.OPEN) {
          var _socket3;
          this.uppy.log(`Cannot send "${action}" to socket ${file.id} because the socket state was ${String((_socket3 = socket) == null ? void 0 : _socket3.readyState)}`, "warning");
          return;
        }
        socket.send(JSON.stringify({
          action,
          payload: payload != null ? payload : {}
        }));
      };
      function sendState() {
        if (!capabilities.resumableUploads)
          return;
        if (isPaused)
          socketSend("pause");
        else
          socketSend("resume");
      }
      const createWebsocket = async () => {
        if (socketAbortController)
          socketAbortController.abort();
        socketAbortController = new AbortController();
        const onFatalError = (err) => {
          var _socketAbortControlle;
          this.uppy.setFileState(file.id, {
            serverToken: null
          });
          (_socketAbortControlle = socketAbortController) == null || _socketAbortControlle.abort == null || _socketAbortControlle.abort();
          reject(err);
        };
        function resetActivityTimeout() {
          clearTimeout(activityTimeout);
          if (isPaused)
            return;
          activityTimeout = setTimeout(() => onFatalError(new Error("Timeout waiting for message from Companion socket")), socketActivityTimeoutMs);
        }
        try {
          await queue.wrapPromiseFunction(async () => {
            const reconnectWebsocket = async () => (
              // eslint-disable-next-line promise/param-names
              new Promise((_4, rejectSocket) => {
                socket = new WebSocket(`${host}/api/${token}`);
                resetActivityTimeout();
                socket.addEventListener("close", () => {
                  socket = void 0;
                  rejectSocket(new Error("Socket closed unexpectedly"));
                });
                socket.addEventListener("error", (error) => {
                  var _socket22;
                  this.uppy.log(`Companion socket error ${JSON.stringify(error)}, closing socket`, "warning");
                  (_socket22 = socket) == null || _socket22.close();
                });
                socket.addEventListener("open", () => {
                  sendState();
                });
                socket.addEventListener("message", (e4) => {
                  resetActivityTimeout();
                  try {
                    const {
                      action,
                      payload
                    } = JSON.parse(e4.data);
                    switch (action) {
                      case "progress": {
                        emitSocketProgress_default(this, payload, this.uppy.getFile(file.id));
                        break;
                      }
                      case "success": {
                        var _payload$response, _payload$response$sta, _payload$response2, _socketAbortControlle2;
                        const text = (_payload$response = payload.response) == null ? void 0 : _payload$response.responseText;
                        this.uppy.emit("upload-success", this.uppy.getFile(file.id), {
                          uploadURL: payload.url,
                          status: (_payload$response$sta = (_payload$response2 = payload.response) == null ? void 0 : _payload$response2.status) != null ? _payload$response$sta : 200,
                          body: text ? JSON.parse(text) : void 0
                        });
                        (_socketAbortControlle2 = socketAbortController) == null || _socketAbortControlle2.abort == null || _socketAbortControlle2.abort();
                        resolve();
                        break;
                      }
                      case "error": {
                        const {
                          message
                        } = payload.error;
                        throw Object.assign(new Error(message), {
                          cause: payload.error
                        });
                      }
                      default:
                        this.uppy.log(`Companion socket unknown action ${action}`, "warning");
                    }
                  } catch (err) {
                    onFatalError(err);
                  }
                });
                const closeSocket = () => {
                  this.uppy.log(`Closing socket ${file.id}`, "info");
                  clearTimeout(activityTimeout);
                  if (socket)
                    socket.close();
                  socket = void 0;
                };
                socketAbortController.signal.addEventListener("abort", () => {
                  closeSocket();
                });
              })
            );
            await pRetry(reconnectWebsocket, {
              retries: retryCount,
              signal: socketAbortController.signal,
              onFailedAttempt: () => {
                if (socketAbortController.signal.aborted)
                  return;
                this.uppy.log(`Retrying websocket ${file.id}`, "info");
              }
            });
          })().abortOn(socketAbortController.signal);
        } catch (err) {
          if (socketAbortController.signal.aborted)
            return;
          onFatalError(err);
        }
      };
      const pause = (newPausedState) => {
        if (!capabilities.resumableUploads)
          return;
        isPaused = newPausedState;
        if (socket)
          sendState();
        if (newPausedState) {
          var _socketAbortControlle3;
          (_socketAbortControlle3 = socketAbortController) == null || _socketAbortControlle3.abort == null || _socketAbortControlle3.abort();
        } else {
          createWebsocket();
        }
      };
      const onFileRemove = (targetFile) => {
        var _socketAbortControlle4;
        if (!capabilities.individualCancellation)
          return;
        if (targetFile.id !== file.id)
          return;
        socketSend("cancel");
        (_socketAbortControlle4 = socketAbortController) == null || _socketAbortControlle4.abort == null || _socketAbortControlle4.abort();
        this.uppy.log(`upload ${file.id} was removed`, "info");
        resolve();
      };
      const onCancelAll = (_ref5) => {
        var _socketAbortControlle5;
        let {
          reason
        } = _ref5;
        if (reason === "user") {
          socketSend("cancel");
        }
        (_socketAbortControlle5 = socketAbortController) == null || _socketAbortControlle5.abort == null || _socketAbortControlle5.abort();
        this.uppy.log(`upload ${file.id} was canceled`, "info");
        resolve();
      };
      const onFilePausedChange = (targetFileId, newPausedState) => {
        if (targetFileId !== file.id)
          return;
        pause(newPausedState);
      };
      const onPauseAll = () => pause(true);
      const onResumeAll = () => pause(false);
      this.uppy.on("file-removed", onFileRemove);
      this.uppy.on("cancel-all", onCancelAll);
      this.uppy.on("upload-pause", onFilePausedChange);
      this.uppy.on("pause-all", onPauseAll);
      this.uppy.on("resume-all", onResumeAll);
      removeEventHandlers = () => {
        this.uppy.off("file-removed", onFileRemove);
        this.uppy.off("cancel-all", onCancelAll);
        this.uppy.off("upload-pause", onFilePausedChange);
        this.uppy.off("pause-all", onPauseAll);
        this.uppy.off("resume-all", onResumeAll);
      };
      signal.addEventListener("abort", () => {
        var _socketAbortControlle6;
        (_socketAbortControlle6 = socketAbortController) == null || _socketAbortControlle6.abort();
      });
      createWebsocket();
    });
  } finally {
    removeEventHandlers == null || removeEventHandlers();
  }
}
RequestClient.VERSION = packageJson.version;

// ../../node_modules/@uppy/companion-client/lib/Socket.js
var import_namespace_emitter = __toESM(require_namespace_emitter(), 1);
var _Symbol$for2;
var _Symbol$for22;
function _classPrivateFieldLooseBase2(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id2 = 0;
function _classPrivateFieldLooseKey2(name) {
  return "__private_" + id2++ + "_" + name;
}
var _queued = /* @__PURE__ */ _classPrivateFieldLooseKey2("queued");
var _emitter = /* @__PURE__ */ _classPrivateFieldLooseKey2("emitter");
var _isOpen = /* @__PURE__ */ _classPrivateFieldLooseKey2("isOpen");
var _socket = /* @__PURE__ */ _classPrivateFieldLooseKey2("socket");
var _handleMessage = /* @__PURE__ */ _classPrivateFieldLooseKey2("handleMessage");
_Symbol$for2 = Symbol.for("uppy test: getSocket");
_Symbol$for22 = Symbol.for("uppy test: getQueued");
var UppySocket = class {
  constructor(opts) {
    Object.defineProperty(this, _queued, {
      writable: true,
      value: []
    });
    Object.defineProperty(this, _emitter, {
      writable: true,
      value: (0, import_namespace_emitter.default)()
    });
    Object.defineProperty(this, _isOpen, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _socket, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _handleMessage, {
      writable: true,
      value: (e4) => {
        try {
          const message = JSON.parse(e4.data);
          this.emit(message.action, message.payload);
        } catch (err) {
          console.log(err);
        }
      }
    });
    this.opts = opts;
    if (!opts || opts.autoOpen !== false) {
      this.open();
    }
  }
  get isOpen() {
    return _classPrivateFieldLooseBase2(this, _isOpen)[_isOpen];
  }
  [_Symbol$for2]() {
    return _classPrivateFieldLooseBase2(this, _socket)[_socket];
  }
  [_Symbol$for22]() {
    return _classPrivateFieldLooseBase2(this, _queued)[_queued];
  }
  open() {
    if (_classPrivateFieldLooseBase2(this, _socket)[_socket] != null)
      return;
    _classPrivateFieldLooseBase2(this, _socket)[_socket] = new WebSocket(this.opts.target);
    _classPrivateFieldLooseBase2(this, _socket)[_socket].onopen = () => {
      _classPrivateFieldLooseBase2(this, _isOpen)[_isOpen] = true;
      while (_classPrivateFieldLooseBase2(this, _queued)[_queued].length > 0 && _classPrivateFieldLooseBase2(this, _isOpen)[_isOpen]) {
        const first = _classPrivateFieldLooseBase2(this, _queued)[_queued].shift();
        this.send(first.action, first.payload);
      }
    };
    _classPrivateFieldLooseBase2(this, _socket)[_socket].onclose = () => {
      _classPrivateFieldLooseBase2(this, _isOpen)[_isOpen] = false;
      _classPrivateFieldLooseBase2(this, _socket)[_socket] = null;
    };
    _classPrivateFieldLooseBase2(this, _socket)[_socket].onmessage = _classPrivateFieldLooseBase2(this, _handleMessage)[_handleMessage];
  }
  close() {
    var _classPrivateFieldLoo;
    (_classPrivateFieldLoo = _classPrivateFieldLooseBase2(this, _socket)[_socket]) == null || _classPrivateFieldLoo.close();
  }
  send(action, payload) {
    if (!_classPrivateFieldLooseBase2(this, _isOpen)[_isOpen]) {
      _classPrivateFieldLooseBase2(this, _queued)[_queued].push({
        action,
        payload
      });
      return;
    }
    _classPrivateFieldLooseBase2(this, _socket)[_socket].send(JSON.stringify({
      action,
      payload
    }));
  }
  on(action, handler) {
    _classPrivateFieldLooseBase2(this, _emitter)[_emitter].on(action, handler);
  }
  emit(action, payload) {
    _classPrivateFieldLooseBase2(this, _emitter)[_emitter].emit(action, payload);
  }
  once(action, handler) {
    _classPrivateFieldLooseBase2(this, _emitter)[_emitter].once(action, handler);
  }
};

// ../../node_modules/@uppy/utils/lib/EventManager.js
function _classPrivateFieldLooseBase3(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id3 = 0;
function _classPrivateFieldLooseKey3(name) {
  return "__private_" + id3++ + "_" + name;
}
var _uppy = /* @__PURE__ */ _classPrivateFieldLooseKey3("uppy");
var _events = /* @__PURE__ */ _classPrivateFieldLooseKey3("events");
var EventManager = class {
  constructor(uppy3) {
    Object.defineProperty(this, _uppy, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _events, {
      writable: true,
      value: []
    });
    _classPrivateFieldLooseBase3(this, _uppy)[_uppy] = uppy3;
  }
  on(event, fn) {
    _classPrivateFieldLooseBase3(this, _events)[_events].push([event, fn]);
    return _classPrivateFieldLooseBase3(this, _uppy)[_uppy].on(event, fn);
  }
  remove() {
    for (const [event, fn] of _classPrivateFieldLooseBase3(this, _events)[_events].splice(0)) {
      _classPrivateFieldLooseBase3(this, _uppy)[_uppy].off(event, fn);
    }
  }
  onFilePause(fileID, cb) {
    this.on("upload-pause", (targetFileID, isPaused) => {
      if (fileID === targetFileID) {
        cb(isPaused);
      }
    });
  }
  onFileRemove(fileID, cb) {
    this.on("file-removed", (file) => {
      if (fileID === file.id)
        cb(file.id);
    });
  }
  onPause(fileID, cb) {
    this.on("upload-pause", (targetFileID, isPaused) => {
      if (fileID === targetFileID) {
        cb(isPaused);
      }
    });
  }
  onRetry(fileID, cb) {
    this.on("upload-retry", (targetFileID) => {
      if (fileID === targetFileID) {
        cb();
      }
    });
  }
  onRetryAll(fileID, cb) {
    this.on("retry-all", () => {
      if (!_classPrivateFieldLooseBase3(this, _uppy)[_uppy].getFile(fileID))
        return;
      cb();
    });
  }
  onPauseAll(fileID, cb) {
    this.on("pause-all", () => {
      if (!_classPrivateFieldLooseBase3(this, _uppy)[_uppy].getFile(fileID))
        return;
      cb();
    });
  }
  onCancelAll(fileID, eventHandler) {
    var _this = this;
    this.on("cancel-all", function() {
      if (!_classPrivateFieldLooseBase3(_this, _uppy)[_uppy].getFile(fileID))
        return;
      eventHandler(...arguments);
    });
  }
  onResumeAll(fileID, cb) {
    this.on("resume-all", () => {
      if (!_classPrivateFieldLooseBase3(this, _uppy)[_uppy].getFile(fileID))
        return;
      cb();
    });
  }
};

// ../../node_modules/@uppy/utils/lib/RateLimitedQueue.js
function _classPrivateFieldLooseBase4(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id4 = 0;
function _classPrivateFieldLooseKey4(name) {
  return "__private_" + id4++ + "_" + name;
}
function createCancelError(cause) {
  return new Error("Cancelled", {
    cause
  });
}
function abortOn(signal) {
  if (signal != null) {
    var _this$then;
    const abortPromise = () => this.abort(signal.reason);
    signal.addEventListener("abort", abortPromise, {
      once: true
    });
    const removeAbortListener = () => {
      signal.removeEventListener("abort", abortPromise);
    };
    (_this$then = this.then) == null || _this$then.call(this, removeAbortListener, removeAbortListener);
  }
  return this;
}
var _activeRequests = /* @__PURE__ */ _classPrivateFieldLooseKey4("activeRequests");
var _queuedHandlers = /* @__PURE__ */ _classPrivateFieldLooseKey4("queuedHandlers");
var _paused = /* @__PURE__ */ _classPrivateFieldLooseKey4("paused");
var _pauseTimer = /* @__PURE__ */ _classPrivateFieldLooseKey4("pauseTimer");
var _downLimit = /* @__PURE__ */ _classPrivateFieldLooseKey4("downLimit");
var _upperLimit = /* @__PURE__ */ _classPrivateFieldLooseKey4("upperLimit");
var _rateLimitingTimer = /* @__PURE__ */ _classPrivateFieldLooseKey4("rateLimitingTimer");
var _call = /* @__PURE__ */ _classPrivateFieldLooseKey4("call");
var _queueNext = /* @__PURE__ */ _classPrivateFieldLooseKey4("queueNext");
var _next = /* @__PURE__ */ _classPrivateFieldLooseKey4("next");
var _queue = /* @__PURE__ */ _classPrivateFieldLooseKey4("queue");
var _dequeue = /* @__PURE__ */ _classPrivateFieldLooseKey4("dequeue");
var _resume = /* @__PURE__ */ _classPrivateFieldLooseKey4("resume");
var _increaseLimit = /* @__PURE__ */ _classPrivateFieldLooseKey4("increaseLimit");
var RateLimitedQueue = class {
  constructor(limit) {
    Object.defineProperty(this, _dequeue, {
      value: _dequeue2
    });
    Object.defineProperty(this, _queue, {
      value: _queue2
    });
    Object.defineProperty(this, _next, {
      value: _next2
    });
    Object.defineProperty(this, _queueNext, {
      value: _queueNext2
    });
    Object.defineProperty(this, _call, {
      value: _call2
    });
    Object.defineProperty(this, _activeRequests, {
      writable: true,
      value: 0
    });
    Object.defineProperty(this, _queuedHandlers, {
      writable: true,
      value: []
    });
    Object.defineProperty(this, _paused, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _pauseTimer, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _downLimit, {
      writable: true,
      value: 1
    });
    Object.defineProperty(this, _upperLimit, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _rateLimitingTimer, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _resume, {
      writable: true,
      value: () => this.resume()
    });
    Object.defineProperty(this, _increaseLimit, {
      writable: true,
      value: () => {
        if (_classPrivateFieldLooseBase4(this, _paused)[_paused]) {
          _classPrivateFieldLooseBase4(this, _rateLimitingTimer)[_rateLimitingTimer] = setTimeout(_classPrivateFieldLooseBase4(this, _increaseLimit)[_increaseLimit], 0);
          return;
        }
        _classPrivateFieldLooseBase4(this, _downLimit)[_downLimit] = this.limit;
        this.limit = Math.ceil((_classPrivateFieldLooseBase4(this, _upperLimit)[_upperLimit] + _classPrivateFieldLooseBase4(this, _downLimit)[_downLimit]) / 2);
        for (let i4 = _classPrivateFieldLooseBase4(this, _downLimit)[_downLimit]; i4 <= this.limit; i4++) {
          _classPrivateFieldLooseBase4(this, _queueNext)[_queueNext]();
        }
        if (_classPrivateFieldLooseBase4(this, _upperLimit)[_upperLimit] - _classPrivateFieldLooseBase4(this, _downLimit)[_downLimit] > 3) {
          _classPrivateFieldLooseBase4(this, _rateLimitingTimer)[_rateLimitingTimer] = setTimeout(_classPrivateFieldLooseBase4(this, _increaseLimit)[_increaseLimit], 2e3);
        } else {
          _classPrivateFieldLooseBase4(this, _downLimit)[_downLimit] = Math.floor(_classPrivateFieldLooseBase4(this, _downLimit)[_downLimit] / 2);
        }
      }
    });
    if (typeof limit !== "number" || limit === 0) {
      this.limit = Infinity;
    } else {
      this.limit = limit;
    }
  }
  run(fn, queueOptions) {
    if (!_classPrivateFieldLooseBase4(this, _paused)[_paused] && _classPrivateFieldLooseBase4(this, _activeRequests)[_activeRequests] < this.limit) {
      return _classPrivateFieldLooseBase4(this, _call)[_call](fn);
    }
    return _classPrivateFieldLooseBase4(this, _queue)[_queue](fn, queueOptions);
  }
  wrapSyncFunction(fn, queueOptions) {
    var _this = this;
    return function() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      const queuedRequest = _this.run(() => {
        fn(...args);
        queueMicrotask(() => queuedRequest.done());
        return () => {
        };
      }, queueOptions);
      return {
        abortOn,
        abort() {
          queuedRequest.abort();
        }
      };
    };
  }
  wrapPromiseFunction(fn, queueOptions) {
    var _this2 = this;
    return function() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      let queuedRequest;
      const outerPromise = new Promise((resolve, reject) => {
        queuedRequest = _this2.run(() => {
          let cancelError;
          let innerPromise;
          try {
            innerPromise = Promise.resolve(fn(...args));
          } catch (err) {
            innerPromise = Promise.reject(err);
          }
          innerPromise.then((result) => {
            if (cancelError) {
              reject(cancelError);
            } else {
              queuedRequest.done();
              resolve(result);
            }
          }, (err) => {
            if (cancelError) {
              reject(cancelError);
            } else {
              queuedRequest.done();
              reject(err);
            }
          });
          return (cause) => {
            cancelError = createCancelError(cause);
          };
        }, queueOptions);
      });
      outerPromise.abort = (cause) => {
        queuedRequest.abort(cause);
      };
      outerPromise.abortOn = abortOn;
      return outerPromise;
    };
  }
  resume() {
    _classPrivateFieldLooseBase4(this, _paused)[_paused] = false;
    clearTimeout(_classPrivateFieldLooseBase4(this, _pauseTimer)[_pauseTimer]);
    for (let i4 = 0; i4 < this.limit; i4++) {
      _classPrivateFieldLooseBase4(this, _queueNext)[_queueNext]();
    }
  }
  /**
   * Freezes the queue for a while or indefinitely.
   *
   * @param {number | null } [duration] Duration for the pause to happen, in milliseconds.
   *                                    If omitted, the queue won't resume automatically.
   */
  pause(duration2) {
    if (duration2 === void 0) {
      duration2 = null;
    }
    _classPrivateFieldLooseBase4(this, _paused)[_paused] = true;
    clearTimeout(_classPrivateFieldLooseBase4(this, _pauseTimer)[_pauseTimer]);
    if (duration2 != null) {
      _classPrivateFieldLooseBase4(this, _pauseTimer)[_pauseTimer] = setTimeout(_classPrivateFieldLooseBase4(this, _resume)[_resume], duration2);
    }
  }
  /**
   * Pauses the queue for a duration, and lower the limit of concurrent requests
   * when the queue resumes. When the queue resumes, it tries to progressively
   * increase the limit in `this.#increaseLimit` until another call is made to
   * `this.rateLimit`.
   * Call this function when using the RateLimitedQueue for network requests and
   * the remote server responds with 429 HTTP code.
   *
   * @param {number} duration in milliseconds.
   */
  rateLimit(duration2) {
    clearTimeout(_classPrivateFieldLooseBase4(this, _rateLimitingTimer)[_rateLimitingTimer]);
    this.pause(duration2);
    if (this.limit > 1 && Number.isFinite(this.limit)) {
      _classPrivateFieldLooseBase4(this, _upperLimit)[_upperLimit] = this.limit - 1;
      this.limit = _classPrivateFieldLooseBase4(this, _downLimit)[_downLimit];
      _classPrivateFieldLooseBase4(this, _rateLimitingTimer)[_rateLimitingTimer] = setTimeout(_classPrivateFieldLooseBase4(this, _increaseLimit)[_increaseLimit], duration2);
    }
  }
  get isPaused() {
    return _classPrivateFieldLooseBase4(this, _paused)[_paused];
  }
};
function _call2(fn) {
  _classPrivateFieldLooseBase4(this, _activeRequests)[_activeRequests] += 1;
  let done = false;
  let cancelActive;
  try {
    cancelActive = fn();
  } catch (err) {
    _classPrivateFieldLooseBase4(this, _activeRequests)[_activeRequests] -= 1;
    throw err;
  }
  return {
    abort: (cause) => {
      if (done)
        return;
      done = true;
      _classPrivateFieldLooseBase4(this, _activeRequests)[_activeRequests] -= 1;
      cancelActive == null || cancelActive(cause);
      _classPrivateFieldLooseBase4(this, _queueNext)[_queueNext]();
    },
    done: () => {
      if (done)
        return;
      done = true;
      _classPrivateFieldLooseBase4(this, _activeRequests)[_activeRequests] -= 1;
      _classPrivateFieldLooseBase4(this, _queueNext)[_queueNext]();
    }
  };
}
function _queueNext2() {
  queueMicrotask(() => _classPrivateFieldLooseBase4(this, _next)[_next]());
}
function _next2() {
  if (_classPrivateFieldLooseBase4(this, _paused)[_paused] || _classPrivateFieldLooseBase4(this, _activeRequests)[_activeRequests] >= this.limit) {
    return;
  }
  if (_classPrivateFieldLooseBase4(this, _queuedHandlers)[_queuedHandlers].length === 0) {
    return;
  }
  const next = _classPrivateFieldLooseBase4(this, _queuedHandlers)[_queuedHandlers].shift();
  const handler = _classPrivateFieldLooseBase4(this, _call)[_call](next.fn);
  next.abort = handler.abort;
  next.done = handler.done;
}
function _queue2(fn, options7) {
  if (options7 === void 0) {
    options7 = {};
  }
  const handler = {
    fn,
    priority: options7.priority || 0,
    abort: () => {
      _classPrivateFieldLooseBase4(this, _dequeue)[_dequeue](handler);
    },
    done: () => {
      throw new Error("Cannot mark a queued request as done: this indicates a bug");
    }
  };
  const index2 = _classPrivateFieldLooseBase4(this, _queuedHandlers)[_queuedHandlers].findIndex((other) => {
    return handler.priority > other.priority;
  });
  if (index2 === -1) {
    _classPrivateFieldLooseBase4(this, _queuedHandlers)[_queuedHandlers].push(handler);
  } else {
    _classPrivateFieldLooseBase4(this, _queuedHandlers)[_queuedHandlers].splice(index2, 0, handler);
  }
  return handler;
}
function _dequeue2(handler) {
  const index2 = _classPrivateFieldLooseBase4(this, _queuedHandlers)[_queuedHandlers].indexOf(handler);
  if (index2 !== -1) {
    _classPrivateFieldLooseBase4(this, _queuedHandlers)[_queuedHandlers].splice(index2, 1);
  }
}
var internalRateLimitedQueue = Symbol("__queue");

// ../../node_modules/@uppy/utils/lib/fileFilters.js
function filterNonFailedFiles(files) {
  const hasError = (file) => "error" in file && !!file.error;
  return files.filter((file) => !hasError(file));
}
function filterFilesToEmitUploadStarted(files) {
  return files.filter((file) => {
    var _file$progress;
    return !((_file$progress = file.progress) != null && _file$progress.uploadStarted) || !file.isRestored;
  });
}

// ../../node_modules/@uppy/utils/lib/AbortController.js
var {
  AbortController: AbortController2
} = globalThis;
var {
  AbortSignal
} = globalThis;
var createAbortError = function(message, options7) {
  if (message === void 0) {
    message = "Aborted";
  }
  const err = new DOMException(message, "AbortError");
  if (options7 != null && has(options7, "cause")) {
    Object.defineProperty(err, "cause", {
      // @ts-expect-error TS is drunk
      __proto__: null,
      configurable: true,
      writable: true,
      value: options7.cause
    });
  }
  return err;
};

// ../../node_modules/@uppy/aws-s3-multipart/lib/MultipartUploader.js
function _classPrivateFieldLooseBase5(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id5 = 0;
function _classPrivateFieldLooseKey5(name) {
  return "__private_" + id5++ + "_" + name;
}
var MB = 1024 * 1024;
var defaultOptions = {
  getChunkSize(file) {
    return Math.ceil(file.size / 1e4);
  },
  onProgress() {
  },
  onPartComplete() {
  },
  onSuccess() {
  },
  onError(err) {
    throw err;
  }
};
function ensureInt(value) {
  if (typeof value === "string") {
    return parseInt(value, 10);
  }
  if (typeof value === "number") {
    return value;
  }
  throw new TypeError("Expected a number");
}
var pausingUploadReason = Symbol("pausing upload, not an actual error");
var _abortController = /* @__PURE__ */ _classPrivateFieldLooseKey5("abortController");
var _chunks = /* @__PURE__ */ _classPrivateFieldLooseKey5("chunks");
var _chunkState = /* @__PURE__ */ _classPrivateFieldLooseKey5("chunkState");
var _data = /* @__PURE__ */ _classPrivateFieldLooseKey5("data");
var _file = /* @__PURE__ */ _classPrivateFieldLooseKey5("file");
var _uploadHasStarted = /* @__PURE__ */ _classPrivateFieldLooseKey5("uploadHasStarted");
var _onError = /* @__PURE__ */ _classPrivateFieldLooseKey5("onError");
var _onSuccess = /* @__PURE__ */ _classPrivateFieldLooseKey5("onSuccess");
var _shouldUseMultipart = /* @__PURE__ */ _classPrivateFieldLooseKey5("shouldUseMultipart");
var _isRestoring = /* @__PURE__ */ _classPrivateFieldLooseKey5("isRestoring");
var _onReject = /* @__PURE__ */ _classPrivateFieldLooseKey5("onReject");
var _maxMultipartParts = /* @__PURE__ */ _classPrivateFieldLooseKey5("maxMultipartParts");
var _minPartSize = /* @__PURE__ */ _classPrivateFieldLooseKey5("minPartSize");
var _initChunks = /* @__PURE__ */ _classPrivateFieldLooseKey5("initChunks");
var _createUpload = /* @__PURE__ */ _classPrivateFieldLooseKey5("createUpload");
var _resumeUpload = /* @__PURE__ */ _classPrivateFieldLooseKey5("resumeUpload");
var _onPartProgress = /* @__PURE__ */ _classPrivateFieldLooseKey5("onPartProgress");
var _onPartComplete = /* @__PURE__ */ _classPrivateFieldLooseKey5("onPartComplete");
var _abortUpload = /* @__PURE__ */ _classPrivateFieldLooseKey5("abortUpload");
var MultipartUploader = class {
  constructor(data, options7) {
    var _this$options, _this$options$getChun;
    Object.defineProperty(this, _abortUpload, {
      value: _abortUpload2
    });
    Object.defineProperty(this, _resumeUpload, {
      value: _resumeUpload2
    });
    Object.defineProperty(this, _createUpload, {
      value: _createUpload2
    });
    Object.defineProperty(this, _initChunks, {
      value: _initChunks2
    });
    Object.defineProperty(this, _abortController, {
      writable: true,
      value: new AbortController2()
    });
    Object.defineProperty(this, _chunks, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _chunkState, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _data, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _file, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _uploadHasStarted, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _onError, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _onSuccess, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _shouldUseMultipart, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _isRestoring, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _onReject, {
      writable: true,
      value: (err) => (err == null ? void 0 : err.cause) === pausingUploadReason ? null : _classPrivateFieldLooseBase5(this, _onError)[_onError](err)
    });
    Object.defineProperty(this, _maxMultipartParts, {
      writable: true,
      value: 1e4
    });
    Object.defineProperty(this, _minPartSize, {
      writable: true,
      value: 5 * MB
    });
    Object.defineProperty(this, _onPartProgress, {
      writable: true,
      value: (index2) => (ev) => {
        if (!ev.lengthComputable)
          return;
        _classPrivateFieldLooseBase5(this, _chunkState)[_chunkState][index2].uploaded = ensureInt(ev.loaded);
        const totalUploaded = _classPrivateFieldLooseBase5(this, _chunkState)[_chunkState].reduce((n3, c4) => n3 + c4.uploaded, 0);
        this.options.onProgress(totalUploaded, _classPrivateFieldLooseBase5(this, _data)[_data].size);
      }
    });
    Object.defineProperty(this, _onPartComplete, {
      writable: true,
      value: (index2) => (etag) => {
        _classPrivateFieldLooseBase5(this, _chunks)[_chunks][index2] = null;
        _classPrivateFieldLooseBase5(this, _chunkState)[_chunkState][index2].etag = etag;
        _classPrivateFieldLooseBase5(this, _chunkState)[_chunkState][index2].done = true;
        const part = {
          PartNumber: index2 + 1,
          ETag: etag
        };
        this.options.onPartComplete(part);
      }
    });
    this.options = {
      ...defaultOptions,
      ...options7
    };
    (_this$options$getChun = (_this$options = this.options).getChunkSize) != null ? _this$options$getChun : _this$options.getChunkSize = defaultOptions.getChunkSize;
    _classPrivateFieldLooseBase5(this, _data)[_data] = data;
    _classPrivateFieldLooseBase5(this, _file)[_file] = options7.file;
    _classPrivateFieldLooseBase5(this, _onSuccess)[_onSuccess] = this.options.onSuccess;
    _classPrivateFieldLooseBase5(this, _onError)[_onError] = this.options.onError;
    _classPrivateFieldLooseBase5(this, _shouldUseMultipart)[_shouldUseMultipart] = this.options.shouldUseMultipart;
    _classPrivateFieldLooseBase5(this, _isRestoring)[_isRestoring] = options7.uploadId && options7.key;
    _classPrivateFieldLooseBase5(this, _initChunks)[_initChunks]();
  }
  start() {
    if (_classPrivateFieldLooseBase5(this, _uploadHasStarted)[_uploadHasStarted]) {
      if (!_classPrivateFieldLooseBase5(this, _abortController)[_abortController].signal.aborted)
        _classPrivateFieldLooseBase5(this, _abortController)[_abortController].abort(pausingUploadReason);
      _classPrivateFieldLooseBase5(this, _abortController)[_abortController] = new AbortController2();
      _classPrivateFieldLooseBase5(this, _resumeUpload)[_resumeUpload]();
    } else if (_classPrivateFieldLooseBase5(this, _isRestoring)[_isRestoring]) {
      this.options.companionComm.restoreUploadFile(_classPrivateFieldLooseBase5(this, _file)[_file], {
        uploadId: this.options.uploadId,
        key: this.options.key
      });
      _classPrivateFieldLooseBase5(this, _resumeUpload)[_resumeUpload]();
    } else {
      _classPrivateFieldLooseBase5(this, _createUpload)[_createUpload]();
    }
  }
  pause() {
    _classPrivateFieldLooseBase5(this, _abortController)[_abortController].abort(pausingUploadReason);
    _classPrivateFieldLooseBase5(this, _abortController)[_abortController] = new AbortController2();
  }
  abort(opts) {
    var _opts;
    if (opts === void 0) {
      opts = void 0;
    }
    if ((_opts = opts) != null && _opts.really)
      _classPrivateFieldLooseBase5(this, _abortUpload)[_abortUpload]();
    else
      this.pause();
  }
  // TODO: remove this in the next major
  get chunkState() {
    return _classPrivateFieldLooseBase5(this, _chunkState)[_chunkState];
  }
};
function _initChunks2() {
  const fileSize = _classPrivateFieldLooseBase5(this, _data)[_data].size;
  const shouldUseMultipart = typeof _classPrivateFieldLooseBase5(this, _shouldUseMultipart)[_shouldUseMultipart] === "function" ? _classPrivateFieldLooseBase5(this, _shouldUseMultipart)[_shouldUseMultipart](_classPrivateFieldLooseBase5(this, _file)[_file]) : Boolean(_classPrivateFieldLooseBase5(this, _shouldUseMultipart)[_shouldUseMultipart]);
  if (shouldUseMultipart && fileSize > _classPrivateFieldLooseBase5(this, _minPartSize)[_minPartSize]) {
    let chunkSize = Math.max(this.options.getChunkSize(_classPrivateFieldLooseBase5(this, _data)[_data]), _classPrivateFieldLooseBase5(this, _minPartSize)[_minPartSize]);
    let arraySize = Math.floor(fileSize / chunkSize);
    if (arraySize > _classPrivateFieldLooseBase5(this, _maxMultipartParts)[_maxMultipartParts]) {
      arraySize = _classPrivateFieldLooseBase5(this, _maxMultipartParts)[_maxMultipartParts];
      chunkSize = fileSize / _classPrivateFieldLooseBase5(this, _maxMultipartParts)[_maxMultipartParts];
    }
    _classPrivateFieldLooseBase5(this, _chunks)[_chunks] = Array(arraySize);
    for (let offset = 0, j4 = 0; offset < fileSize; offset += chunkSize, j4++) {
      const end = Math.min(fileSize, offset + chunkSize);
      const getData = () => {
        const i23 = offset;
        return _classPrivateFieldLooseBase5(this, _data)[_data].slice(i23, end);
      };
      _classPrivateFieldLooseBase5(this, _chunks)[_chunks][j4] = {
        getData,
        onProgress: _classPrivateFieldLooseBase5(this, _onPartProgress)[_onPartProgress](j4),
        onComplete: _classPrivateFieldLooseBase5(this, _onPartComplete)[_onPartComplete](j4),
        shouldUseMultipart
      };
      if (_classPrivateFieldLooseBase5(this, _isRestoring)[_isRestoring]) {
        const size = offset + chunkSize > fileSize ? fileSize - offset : chunkSize;
        _classPrivateFieldLooseBase5(this, _chunks)[_chunks][j4].setAsUploaded = () => {
          _classPrivateFieldLooseBase5(this, _chunks)[_chunks][j4] = null;
          _classPrivateFieldLooseBase5(this, _chunkState)[_chunkState][j4].uploaded = size;
        };
      }
    }
  } else {
    _classPrivateFieldLooseBase5(this, _chunks)[_chunks] = [{
      getData: () => _classPrivateFieldLooseBase5(this, _data)[_data],
      onProgress: _classPrivateFieldLooseBase5(this, _onPartProgress)[_onPartProgress](0),
      onComplete: _classPrivateFieldLooseBase5(this, _onPartComplete)[_onPartComplete](0),
      shouldUseMultipart
    }];
  }
  _classPrivateFieldLooseBase5(this, _chunkState)[_chunkState] = _classPrivateFieldLooseBase5(this, _chunks)[_chunks].map(() => ({
    uploaded: 0
  }));
}
function _createUpload2() {
  this.options.companionComm.uploadFile(_classPrivateFieldLooseBase5(this, _file)[_file], _classPrivateFieldLooseBase5(this, _chunks)[_chunks], _classPrivateFieldLooseBase5(this, _abortController)[_abortController].signal).then(_classPrivateFieldLooseBase5(this, _onSuccess)[_onSuccess], _classPrivateFieldLooseBase5(this, _onReject)[_onReject]);
  _classPrivateFieldLooseBase5(this, _uploadHasStarted)[_uploadHasStarted] = true;
}
function _resumeUpload2() {
  this.options.companionComm.resumeUploadFile(_classPrivateFieldLooseBase5(this, _file)[_file], _classPrivateFieldLooseBase5(this, _chunks)[_chunks], _classPrivateFieldLooseBase5(this, _abortController)[_abortController].signal).then(_classPrivateFieldLooseBase5(this, _onSuccess)[_onSuccess], _classPrivateFieldLooseBase5(this, _onReject)[_onReject]);
}
function _abortUpload2() {
  _classPrivateFieldLooseBase5(this, _abortController)[_abortController].abort();
  this.options.companionComm.abortFileUpload(_classPrivateFieldLooseBase5(this, _file)[_file]).catch((err) => this.options.log(err));
}
var MultipartUploader_default = MultipartUploader;

// ../../node_modules/@uppy/aws-s3-multipart/lib/createSignedURL.js
function createCanonicalRequest(_ref) {
  let {
    method = "PUT",
    CanonicalUri = "/",
    CanonicalQueryString = "",
    SignedHeaders,
    HashedPayload
  } = _ref;
  const headerKeys = Object.keys(SignedHeaders).map((k4) => k4.toLowerCase()).sort();
  return [method, CanonicalUri, CanonicalQueryString, ...headerKeys.map((k4) => `${k4}:${SignedHeaders[k4]}`), "", headerKeys.join(";"), HashedPayload].join("\n");
}
var ec = new TextEncoder();
var algorithm = {
  name: "HMAC",
  hash: "SHA-256"
};
async function digest(data) {
  const {
    subtle
  } = globalThis.crypto;
  return subtle.digest(algorithm.hash, ec.encode(data));
}
async function generateHmacKey(secret) {
  const {
    subtle
  } = globalThis.crypto;
  return subtle.importKey("raw", typeof secret === "string" ? ec.encode(secret) : secret, algorithm, false, ["sign"]);
}
function arrayBufferToHexString(arrayBuffer) {
  const byteArray = new Uint8Array(arrayBuffer);
  let hexString = "";
  for (let i4 = 0; i4 < byteArray.length; i4++) {
    hexString += byteArray[i4].toString(16).padStart(2, "0");
  }
  return hexString;
}
async function hash(key, data) {
  const {
    subtle
  } = globalThis.crypto;
  return subtle.sign(algorithm, await generateHmacKey(key), ec.encode(data));
}
async function createSignedURL(_ref2) {
  let {
    accountKey,
    accountSecret,
    sessionToken,
    bucketName,
    Key,
    Region,
    expires,
    uploadId,
    partNumber
  } = _ref2;
  const Service = "s3";
  const host = `${bucketName}.${Service}.${Region}.amazonaws.com`;
  const CanonicalUri = `/${encodeURI(Key)}`;
  const payload = "UNSIGNED-PAYLOAD";
  const requestDateTime = (/* @__PURE__ */ new Date()).toISOString().replace(/[-:]|\.\d+/g, "");
  const date = requestDateTime.slice(0, 8);
  const scope = `${date}/${Region}/${Service}/aws4_request`;
  const url = new URL(`https://${host}${CanonicalUri}`);
  url.searchParams.set("X-Amz-Algorithm", "AWS4-HMAC-SHA256");
  url.searchParams.set("X-Amz-Content-Sha256", payload);
  url.searchParams.set("X-Amz-Credential", `${accountKey}/${scope}`);
  url.searchParams.set("X-Amz-Date", requestDateTime);
  url.searchParams.set("X-Amz-Expires", expires);
  url.searchParams.set("X-Amz-Security-Token", sessionToken);
  url.searchParams.set("X-Amz-SignedHeaders", "host");
  if (partNumber)
    url.searchParams.set("partNumber", partNumber);
  if (uploadId)
    url.searchParams.set("uploadId", uploadId);
  url.searchParams.set("x-id", partNumber && uploadId ? "UploadPart" : "PutObject");
  const canonical = createCanonicalRequest({
    CanonicalUri,
    CanonicalQueryString: url.search.slice(1),
    SignedHeaders: {
      host
    },
    HashedPayload: payload
  });
  const hashedCanonical = arrayBufferToHexString(await digest(canonical));
  const stringToSign = [
    `AWS4-HMAC-SHA256`,
    // The algorithm used to create the hash of the canonical request.
    requestDateTime,
    // The date and time used in the credential scope.
    scope,
    // The credential scope. This restricts the resulting signature to the specified Region and service.
    hashedCanonical
    // The hash of the canonical request.
  ].join("\n");
  const kDate = await hash(`AWS4${accountSecret}`, date);
  const kRegion = await hash(kDate, Region);
  const kService = await hash(kRegion, Service);
  const kSigning = await hash(kService, "aws4_request");
  const signature = arrayBufferToHexString(await hash(kSigning, stringToSign));
  url.searchParams.set("X-Amz-Signature", signature);
  return url;
}

// ../../node_modules/@uppy/aws-s3-multipart/lib/index.js
var _Symbol$for3;
function _classPrivateFieldLooseBase6(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id6 = 0;
function _classPrivateFieldLooseKey6(name) {
  return "__private_" + id6++ + "_" + name;
}
var packageJson2 = {
  "version": "3.10.2"
};
function assertServerError(res) {
  if (res && res.error) {
    const error = new Error(res.message);
    Object.assign(error, res.error);
    throw error;
  }
  return res;
}
function removeMetadataFromURL(urlString) {
  const urlObject = new URL(urlString);
  urlObject.search = "";
  urlObject.hash = "";
  return urlObject.href;
}
function getExpiry(credentials) {
  const expirationDate = credentials.Expiration;
  if (expirationDate) {
    const timeUntilExpiry = Math.floor((new Date(expirationDate) - Date.now()) / 1e3);
    if (timeUntilExpiry > 9) {
      return timeUntilExpiry;
    }
  }
  return void 0;
}
function getAllowedMetadata(_ref) {
  let {
    meta,
    allowedMetaFields,
    querify = false
  } = _ref;
  const metaFields3 = allowedMetaFields != null ? allowedMetaFields : Object.keys(meta);
  if (!meta)
    return {};
  return Object.fromEntries(metaFields3.filter((key) => meta[key] != null).map((key) => {
    const realKey = querify ? `metadata[${key}]` : key;
    const value = String(meta[key]);
    return [realKey, value];
  }));
}
function throwIfAborted(signal) {
  if (signal != null && signal.aborted) {
    throw createAbortError("The operation was aborted", {
      cause: signal.reason
    });
  }
}
var _abortMultipartUpload = /* @__PURE__ */ _classPrivateFieldLooseKey6("abortMultipartUpload");
var _cache = /* @__PURE__ */ _classPrivateFieldLooseKey6("cache");
var _createMultipartUpload = /* @__PURE__ */ _classPrivateFieldLooseKey6("createMultipartUpload");
var _fetchSignature = /* @__PURE__ */ _classPrivateFieldLooseKey6("fetchSignature");
var _getUploadParameters = /* @__PURE__ */ _classPrivateFieldLooseKey6("getUploadParameters");
var _listParts = /* @__PURE__ */ _classPrivateFieldLooseKey6("listParts");
var _previousRetryDelay = /* @__PURE__ */ _classPrivateFieldLooseKey6("previousRetryDelay");
var _requests = /* @__PURE__ */ _classPrivateFieldLooseKey6("requests");
var _retryDelays = /* @__PURE__ */ _classPrivateFieldLooseKey6("retryDelays");
var _sendCompletionRequest = /* @__PURE__ */ _classPrivateFieldLooseKey6("sendCompletionRequest");
var _setS3MultipartState = /* @__PURE__ */ _classPrivateFieldLooseKey6("setS3MultipartState");
var _uploadPartBytes = /* @__PURE__ */ _classPrivateFieldLooseKey6("uploadPartBytes");
var _getFile = /* @__PURE__ */ _classPrivateFieldLooseKey6("getFile");
var _shouldRetry = /* @__PURE__ */ _classPrivateFieldLooseKey6("shouldRetry");
var _nonMultipartUpload = /* @__PURE__ */ _classPrivateFieldLooseKey6("nonMultipartUpload");
var HTTPCommunicationQueue = class {
  constructor(_requests23, options7, setS3MultipartState, getFile) {
    Object.defineProperty(this, _nonMultipartUpload, {
      value: _nonMultipartUpload2
    });
    Object.defineProperty(this, _shouldRetry, {
      value: _shouldRetry2
    });
    Object.defineProperty(this, _abortMultipartUpload, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _cache, {
      writable: true,
      value: /* @__PURE__ */ new WeakMap()
    });
    Object.defineProperty(this, _createMultipartUpload, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _fetchSignature, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _getUploadParameters, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _listParts, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _previousRetryDelay, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _requests, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _retryDelays, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _sendCompletionRequest, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _setS3MultipartState, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _uploadPartBytes, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _getFile, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldLooseBase6(this, _requests)[_requests] = _requests23;
    _classPrivateFieldLooseBase6(this, _setS3MultipartState)[_setS3MultipartState] = setS3MultipartState;
    _classPrivateFieldLooseBase6(this, _getFile)[_getFile] = getFile;
    this.setOptions(options7);
  }
  setOptions(options7) {
    const requests = _classPrivateFieldLooseBase6(this, _requests)[_requests];
    if ("abortMultipartUpload" in options7) {
      _classPrivateFieldLooseBase6(this, _abortMultipartUpload)[_abortMultipartUpload] = requests.wrapPromiseFunction(options7.abortMultipartUpload, {
        priority: 1
      });
    }
    if ("createMultipartUpload" in options7) {
      _classPrivateFieldLooseBase6(this, _createMultipartUpload)[_createMultipartUpload] = requests.wrapPromiseFunction(options7.createMultipartUpload, {
        priority: -1
      });
    }
    if ("signPart" in options7) {
      _classPrivateFieldLooseBase6(this, _fetchSignature)[_fetchSignature] = requests.wrapPromiseFunction(options7.signPart);
    }
    if ("listParts" in options7) {
      _classPrivateFieldLooseBase6(this, _listParts)[_listParts] = requests.wrapPromiseFunction(options7.listParts);
    }
    if ("completeMultipartUpload" in options7) {
      _classPrivateFieldLooseBase6(this, _sendCompletionRequest)[_sendCompletionRequest] = requests.wrapPromiseFunction(options7.completeMultipartUpload, {
        priority: 1
      });
    }
    if ("retryDelays" in options7) {
      var _options$retryDelays;
      _classPrivateFieldLooseBase6(this, _retryDelays)[_retryDelays] = (_options$retryDelays = options7.retryDelays) != null ? _options$retryDelays : [];
    }
    if ("uploadPartBytes" in options7) {
      _classPrivateFieldLooseBase6(this, _uploadPartBytes)[_uploadPartBytes] = requests.wrapPromiseFunction(options7.uploadPartBytes, {
        priority: Infinity
      });
    }
    if ("getUploadParameters" in options7) {
      _classPrivateFieldLooseBase6(this, _getUploadParameters)[_getUploadParameters] = requests.wrapPromiseFunction(options7.getUploadParameters);
    }
  }
  async getUploadId(file, signal) {
    let cachedResult;
    while ((cachedResult = _classPrivateFieldLooseBase6(this, _cache)[_cache].get(file.data)) != null) {
      try {
        return await cachedResult;
      } catch {
      }
    }
    const promise = _classPrivateFieldLooseBase6(this, _createMultipartUpload)[_createMultipartUpload](_classPrivateFieldLooseBase6(this, _getFile)[_getFile](file), signal);
    const abortPromise = () => {
      promise.abort(signal.reason);
      _classPrivateFieldLooseBase6(this, _cache)[_cache].delete(file.data);
    };
    signal.addEventListener("abort", abortPromise, {
      once: true
    });
    _classPrivateFieldLooseBase6(this, _cache)[_cache].set(file.data, promise);
    promise.then(async (result) => {
      signal.removeEventListener("abort", abortPromise);
      _classPrivateFieldLooseBase6(this, _setS3MultipartState)[_setS3MultipartState](file, result);
      _classPrivateFieldLooseBase6(this, _cache)[_cache].set(file.data, result);
    }, () => {
      signal.removeEventListener("abort", abortPromise);
      _classPrivateFieldLooseBase6(this, _cache)[_cache].delete(file.data);
    });
    return promise;
  }
  async abortFileUpload(file) {
    const result = _classPrivateFieldLooseBase6(this, _cache)[_cache].get(file.data);
    if (result == null) {
      return;
    }
    _classPrivateFieldLooseBase6(this, _cache)[_cache].delete(file.data);
    _classPrivateFieldLooseBase6(this, _setS3MultipartState)[_setS3MultipartState](file, /* @__PURE__ */ Object.create(null));
    let awaitedResult;
    try {
      awaitedResult = await result;
    } catch {
      return;
    }
    await _classPrivateFieldLooseBase6(this, _abortMultipartUpload)[_abortMultipartUpload](_classPrivateFieldLooseBase6(this, _getFile)[_getFile](file), awaitedResult);
  }
  /**
   * @param {import("@uppy/core").UppyFile} file
   * @param {import("../types/chunk").Chunk[]} chunks
   * @param {AbortSignal} signal
   * @returns {Promise<void>}
   */
  async uploadFile(file, chunks2, signal) {
    throwIfAborted(signal);
    if (chunks2.length === 1 && !chunks2[0].shouldUseMultipart) {
      return _classPrivateFieldLooseBase6(this, _nonMultipartUpload)[_nonMultipartUpload](file, chunks2[0], signal);
    }
    const {
      uploadId,
      key
    } = await this.getUploadId(file, signal);
    throwIfAborted(signal);
    try {
      const parts = await Promise.all(chunks2.map((chunk, i4) => this.uploadChunk(file, i4 + 1, chunk, signal)));
      throwIfAborted(signal);
      return await _classPrivateFieldLooseBase6(this, _sendCompletionRequest)[_sendCompletionRequest](_classPrivateFieldLooseBase6(this, _getFile)[_getFile](file), {
        key,
        uploadId,
        parts,
        signal
      }, signal).abortOn(signal);
    } catch (err) {
      if ((err == null ? void 0 : err.cause) !== pausingUploadReason && (err == null ? void 0 : err.name) !== "AbortError") {
        this.abortFileUpload(file);
      }
      throw err;
    }
  }
  restoreUploadFile(file, uploadIdAndKey) {
    _classPrivateFieldLooseBase6(this, _cache)[_cache].set(file.data, uploadIdAndKey);
  }
  async resumeUploadFile(file, chunks2, signal) {
    throwIfAborted(signal);
    if (chunks2.length === 1 && chunks2[0] != null && !chunks2[0].shouldUseMultipart) {
      return _classPrivateFieldLooseBase6(this, _nonMultipartUpload)[_nonMultipartUpload](file, chunks2[0], signal);
    }
    const {
      uploadId,
      key
    } = await this.getUploadId(file, signal);
    throwIfAborted(signal);
    const alreadyUploadedParts = await _classPrivateFieldLooseBase6(this, _listParts)[_listParts](_classPrivateFieldLooseBase6(this, _getFile)[_getFile](file), {
      uploadId,
      key,
      signal
    }, signal).abortOn(signal);
    throwIfAborted(signal);
    const parts = await Promise.all(chunks2.map((chunk, i4) => {
      const partNumber = i4 + 1;
      const alreadyUploadedInfo = alreadyUploadedParts.find((_ref2) => {
        let {
          PartNumber
        } = _ref2;
        return PartNumber === partNumber;
      });
      if (alreadyUploadedInfo == null) {
        return this.uploadChunk(file, partNumber, chunk, signal);
      }
      chunk == null || chunk.setAsUploaded == null || chunk.setAsUploaded();
      return {
        PartNumber: partNumber,
        ETag: alreadyUploadedInfo.ETag
      };
    }));
    throwIfAborted(signal);
    return _classPrivateFieldLooseBase6(this, _sendCompletionRequest)[_sendCompletionRequest](_classPrivateFieldLooseBase6(this, _getFile)[_getFile](file), {
      key,
      uploadId,
      parts,
      signal
    }, signal).abortOn(signal);
  }
  /**
   *
   * @param {import("@uppy/core").UppyFile} file
   * @param {number} partNumber
   * @param {import("../types/chunk").Chunk} chunk
   * @param {AbortSignal} signal
   * @returns {Promise<object>}
   */
  async uploadChunk(file, partNumber, chunk, signal) {
    throwIfAborted(signal);
    const {
      uploadId,
      key
    } = await this.getUploadId(file, signal);
    const signatureRetryIterator = _classPrivateFieldLooseBase6(this, _retryDelays)[_retryDelays].values();
    const chunkRetryIterator = _classPrivateFieldLooseBase6(this, _retryDelays)[_retryDelays].values();
    const shouldRetrySignature = () => {
      const next = signatureRetryIterator.next();
      if (next == null || next.done) {
        return null;
      }
      return next.value;
    };
    for (; ; ) {
      throwIfAborted(signal);
      const chunkData = chunk.getData();
      const {
        onProgress,
        onComplete
      } = chunk;
      let signature;
      try {
        signature = await _classPrivateFieldLooseBase6(this, _fetchSignature)[_fetchSignature](_classPrivateFieldLooseBase6(this, _getFile)[_getFile](file), {
          uploadId,
          key,
          partNumber,
          body: chunkData,
          signal
        }).abortOn(signal);
      } catch (err) {
        const timeout = shouldRetrySignature();
        if (timeout == null || signal.aborted) {
          throw err;
        }
        await new Promise((resolve) => setTimeout(resolve, timeout));
        continue;
      }
      throwIfAborted(signal);
      try {
        return {
          PartNumber: partNumber,
          ...await _classPrivateFieldLooseBase6(this, _uploadPartBytes)[_uploadPartBytes]({
            signature,
            body: chunkData,
            size: chunkData.size,
            onProgress,
            onComplete,
            signal
          }).abortOn(signal)
        };
      } catch (err) {
        if (!await _classPrivateFieldLooseBase6(this, _shouldRetry)[_shouldRetry](err, chunkRetryIterator))
          throw err;
      }
    }
  }
};
async function _shouldRetry2(err, retryDelayIterator) {
  var _err$source;
  const requests = _classPrivateFieldLooseBase6(this, _requests)[_requests];
  const status = err == null || (_err$source = err.source) == null ? void 0 : _err$source.status;
  if (status == null) {
    return false;
  }
  if (status === 403 && err.message === "Request has expired") {
    if (!requests.isPaused) {
      if (requests.limit === 1 || _classPrivateFieldLooseBase6(this, _previousRetryDelay)[_previousRetryDelay] == null) {
        const next = retryDelayIterator.next();
        if (next == null || next.done) {
          return false;
        }
        _classPrivateFieldLooseBase6(this, _previousRetryDelay)[_previousRetryDelay] = next.value;
      }
      requests.rateLimit(0);
      await new Promise((resolve) => setTimeout(resolve, _classPrivateFieldLooseBase6(this, _previousRetryDelay)[_previousRetryDelay]));
    }
  } else if (status === 429) {
    if (!requests.isPaused) {
      const next = retryDelayIterator.next();
      if (next == null || next.done) {
        return false;
      }
      requests.rateLimit(next.value);
    }
  } else if (status > 400 && status < 500 && status !== 409) {
    return false;
  } else if (typeof navigator !== "undefined" && navigator.onLine === false) {
    if (!requests.isPaused) {
      requests.pause();
      window.addEventListener("online", () => {
        requests.resume();
      }, {
        once: true
      });
    }
  } else {
    const next = retryDelayIterator.next();
    if (next == null || next.done) {
      return false;
    }
    await new Promise((resolve) => setTimeout(resolve, next.value));
  }
  return true;
}
async function _nonMultipartUpload2(file, chunk, signal) {
  const {
    method = "POST",
    url,
    fields,
    headers
  } = await _classPrivateFieldLooseBase6(this, _getUploadParameters)[_getUploadParameters](_classPrivateFieldLooseBase6(this, _getFile)[_getFile](file), {
    signal
  }).abortOn(signal);
  let body;
  const data = chunk.getData();
  if (method.toUpperCase() === "POST") {
    const formData = new FormData();
    Object.entries(fields).forEach((_ref10) => {
      let [key, value] = _ref10;
      return formData.set(key, value);
    });
    formData.set("file", data);
    body = formData;
  } else {
    body = data;
  }
  const {
    onProgress,
    onComplete
  } = chunk;
  const result = await _classPrivateFieldLooseBase6(this, _uploadPartBytes)[_uploadPartBytes]({
    signature: {
      url,
      headers,
      method
    },
    body,
    size: data.size,
    onProgress,
    onComplete,
    signal
  }).abortOn(signal);
  return "location" in result ? result : {
    location: removeMetadataFromURL(url),
    ...result
  };
}
var _companionCommunicationQueue = /* @__PURE__ */ _classPrivateFieldLooseKey6("companionCommunicationQueue");
var _client = /* @__PURE__ */ _classPrivateFieldLooseKey6("client");
var _cachedTemporaryCredentials = /* @__PURE__ */ _classPrivateFieldLooseKey6("cachedTemporaryCredentials");
var _getTemporarySecurityCredentials = /* @__PURE__ */ _classPrivateFieldLooseKey6("getTemporarySecurityCredentials");
var _setS3MultipartState2 = /* @__PURE__ */ _classPrivateFieldLooseKey6("setS3MultipartState");
var _getFile2 = /* @__PURE__ */ _classPrivateFieldLooseKey6("getFile");
var _uploadLocalFile = /* @__PURE__ */ _classPrivateFieldLooseKey6("uploadLocalFile");
var _getCompanionClientArgs = /* @__PURE__ */ _classPrivateFieldLooseKey6("getCompanionClientArgs");
var _upload = /* @__PURE__ */ _classPrivateFieldLooseKey6("upload");
var _setCompanionHeaders = /* @__PURE__ */ _classPrivateFieldLooseKey6("setCompanionHeaders");
var _setResumableUploadsCapability = /* @__PURE__ */ _classPrivateFieldLooseKey6("setResumableUploadsCapability");
var _resetResumableCapability = /* @__PURE__ */ _classPrivateFieldLooseKey6("resetResumableCapability");
_Symbol$for3 = Symbol.for("uppy test: getClient");
var AwsS3Multipart = class _AwsS3Multipart2 extends BasePlugin {
  constructor(uppy3, opts) {
    var _this$opts$rateLimite;
    super(uppy3, opts);
    Object.defineProperty(this, _getCompanionClientArgs, {
      value: _getCompanionClientArgs2
    });
    Object.defineProperty(this, _uploadLocalFile, {
      value: _uploadLocalFile2
    });
    Object.defineProperty(this, _getTemporarySecurityCredentials, {
      value: _getTemporarySecurityCredentials2
    });
    Object.defineProperty(this, _companionCommunicationQueue, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _client, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _cachedTemporaryCredentials, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _setS3MultipartState2, {
      writable: true,
      value: (file, _ref3) => {
        let {
          key,
          uploadId
        } = _ref3;
        const cFile = this.uppy.getFile(file.id);
        if (cFile == null) {
          return;
        }
        this.uppy.setFileState(file.id, {
          s3Multipart: {
            ...cFile.s3Multipart,
            key,
            uploadId
          }
        });
      }
    });
    Object.defineProperty(this, _getFile2, {
      writable: true,
      value: (file) => {
        return this.uppy.getFile(file.id) || file;
      }
    });
    Object.defineProperty(this, _upload, {
      writable: true,
      value: async (fileIDs) => {
        if (fileIDs.length === 0)
          return void 0;
        const files = this.uppy.getFilesByIds(fileIDs);
        const filesFiltered = filterNonFailedFiles(files);
        const filesToEmit = filterFilesToEmitUploadStarted(filesFiltered);
        this.uppy.emit("upload-start", filesToEmit);
        const promises = filesFiltered.map((file) => {
          if (file.isRemote) {
            const getQueue = () => this.requests;
            _classPrivateFieldLooseBase6(this, _setResumableUploadsCapability)[_setResumableUploadsCapability](false);
            const controller = new AbortController();
            const removedHandler = (removedFile) => {
              if (removedFile.id === file.id)
                controller.abort();
            };
            this.uppy.on("file-removed", removedHandler);
            const uploadPromise = this.uppy.getRequestClientForFile(file).uploadRemoteFile(file, _classPrivateFieldLooseBase6(this, _getCompanionClientArgs)[_getCompanionClientArgs](file), {
              signal: controller.signal,
              getQueue
            });
            this.requests.wrapSyncFunction(() => {
              this.uppy.off("file-removed", removedHandler);
            }, {
              priority: -1
            })();
            return uploadPromise;
          }
          return _classPrivateFieldLooseBase6(this, _uploadLocalFile)[_uploadLocalFile](file);
        });
        const upload = await Promise.all(promises);
        _classPrivateFieldLooseBase6(this, _setResumableUploadsCapability)[_setResumableUploadsCapability](true);
        return upload;
      }
    });
    Object.defineProperty(this, _setCompanionHeaders, {
      writable: true,
      value: () => {
        _classPrivateFieldLooseBase6(this, _client)[_client].setCompanionHeaders(this.opts.companionHeaders);
      }
    });
    Object.defineProperty(this, _setResumableUploadsCapability, {
      writable: true,
      value: (boolean8) => {
        const {
          capabilities
        } = this.uppy.getState();
        this.uppy.setState({
          capabilities: {
            ...capabilities,
            resumableUploads: boolean8
          }
        });
      }
    });
    Object.defineProperty(this, _resetResumableCapability, {
      writable: true,
      value: () => {
        _classPrivateFieldLooseBase6(this, _setResumableUploadsCapability)[_setResumableUploadsCapability](true);
      }
    });
    this.type = "uploader";
    this.id = this.opts.id || "AwsS3Multipart";
    this.title = "AWS S3 Multipart";
    _classPrivateFieldLooseBase6(this, _client)[_client] = new RequestClient(uppy3, opts);
    const defaultOptions8 = {
      // TODO: null here means “include all”, [] means include none.
      // This is inconsistent with @uppy/aws-s3 and @uppy/transloadit
      allowedMetaFields: null,
      limit: 6,
      shouldUseMultipart: (file) => file.size !== 0,
      // TODO: Switch default to:
      // eslint-disable-next-line no-bitwise
      // shouldUseMultipart: (file) => file.size >> 10 >> 10 > 100,
      retryDelays: [0, 1e3, 3e3, 5e3],
      createMultipartUpload: this.createMultipartUpload.bind(this),
      listParts: this.listParts.bind(this),
      abortMultipartUpload: this.abortMultipartUpload.bind(this),
      completeMultipartUpload: this.completeMultipartUpload.bind(this),
      getTemporarySecurityCredentials: false,
      signPart: opts != null && opts.getTemporarySecurityCredentials ? this.createSignedURL.bind(this) : this.signPart.bind(this),
      uploadPartBytes: _AwsS3Multipart2.uploadPartBytes,
      getUploadParameters: opts != null && opts.getTemporarySecurityCredentials ? this.createSignedURL.bind(this) : this.getUploadParameters.bind(this),
      companionHeaders: {}
    };
    this.opts = {
      ...defaultOptions8,
      ...opts
    };
    if ((opts == null ? void 0 : opts.prepareUploadParts) != null && opts.signPart == null) {
      this.opts.signPart = async (file, _ref4) => {
        let {
          uploadId,
          key,
          partNumber,
          body,
          signal
        } = _ref4;
        const {
          presignedUrls,
          headers
        } = await opts.prepareUploadParts(file, {
          uploadId,
          key,
          parts: [{
            number: partNumber,
            chunk: body
          }],
          signal
        });
        return {
          url: presignedUrls == null ? void 0 : presignedUrls[partNumber],
          headers: headers == null ? void 0 : headers[partNumber]
        };
      };
    }
    this.requests = (_this$opts$rateLimite = this.opts.rateLimitedQueue) != null ? _this$opts$rateLimite : new RateLimitedQueue(this.opts.limit);
    _classPrivateFieldLooseBase6(this, _companionCommunicationQueue)[_companionCommunicationQueue] = new HTTPCommunicationQueue(this.requests, this.opts, _classPrivateFieldLooseBase6(this, _setS3MultipartState2)[_setS3MultipartState2], _classPrivateFieldLooseBase6(this, _getFile2)[_getFile2]);
    this.uploaders = /* @__PURE__ */ Object.create(null);
    this.uploaderEvents = /* @__PURE__ */ Object.create(null);
    this.uploaderSockets = /* @__PURE__ */ Object.create(null);
  }
  [_Symbol$for3]() {
    return _classPrivateFieldLooseBase6(this, _client)[_client];
  }
  setOptions(newOptions) {
    _classPrivateFieldLooseBase6(this, _companionCommunicationQueue)[_companionCommunicationQueue].setOptions(newOptions);
    super.setOptions(newOptions);
    _classPrivateFieldLooseBase6(this, _setCompanionHeaders)[_setCompanionHeaders]();
  }
  /**
   * Clean up all references for a file's upload: the MultipartUploader instance,
   * any events related to the file, and the Companion WebSocket connection.
   *
   * Set `opts.abort` to tell S3 that the multipart upload is cancelled and must be removed.
   * This should be done when the user cancels the upload, not when the upload is completed or errored.
   */
  resetUploaderReferences(fileID, opts) {
    if (opts === void 0) {
      opts = {};
    }
    if (this.uploaders[fileID]) {
      this.uploaders[fileID].abort({
        really: opts.abort || false
      });
      this.uploaders[fileID] = null;
    }
    if (this.uploaderEvents[fileID]) {
      this.uploaderEvents[fileID].remove();
      this.uploaderEvents[fileID] = null;
    }
    if (this.uploaderSockets[fileID]) {
      this.uploaderSockets[fileID].close();
      this.uploaderSockets[fileID] = null;
    }
  }
  // TODO: make this a private method in the next major
  assertHost(method) {
    if (!this.opts.companionUrl) {
      throw new Error(`Expected a \`companionUrl\` option containing a Companion address, or if you are not using Companion, a custom \`${method}\` implementation.`);
    }
  }
  createMultipartUpload(file, signal) {
    this.assertHost("createMultipartUpload");
    throwIfAborted(signal);
    const metadata = getAllowedMetadata({
      meta: file.meta,
      allowedMetaFields: this.opts.allowedMetaFields
    });
    return _classPrivateFieldLooseBase6(this, _client)[_client].post("s3/multipart", {
      filename: file.name,
      type: file.type,
      metadata
    }, {
      signal
    }).then(assertServerError);
  }
  listParts(file, _ref5, signal) {
    let {
      key,
      uploadId
    } = _ref5;
    this.assertHost("listParts");
    throwIfAborted(signal);
    const filename = encodeURIComponent(key);
    return _classPrivateFieldLooseBase6(this, _client)[_client].get(`s3/multipart/${uploadId}?key=${filename}`, {
      signal
    }).then(assertServerError);
  }
  completeMultipartUpload(file, _ref6, signal) {
    let {
      key,
      uploadId,
      parts
    } = _ref6;
    this.assertHost("completeMultipartUpload");
    throwIfAborted(signal);
    const filename = encodeURIComponent(key);
    const uploadIdEnc = encodeURIComponent(uploadId);
    return _classPrivateFieldLooseBase6(this, _client)[_client].post(`s3/multipart/${uploadIdEnc}/complete?key=${filename}`, {
      parts
    }, {
      signal
    }).then(assertServerError);
  }
  async createSignedURL(file, options7) {
    const data = await _classPrivateFieldLooseBase6(this, _getTemporarySecurityCredentials)[_getTemporarySecurityCredentials](options7);
    const expires = getExpiry(data.credentials) || 604800;
    const {
      uploadId,
      key,
      partNumber,
      signal
    } = options7;
    return {
      method: "PUT",
      expires,
      fields: {},
      url: `${await createSignedURL({
        accountKey: data.credentials.AccessKeyId,
        accountSecret: data.credentials.SecretAccessKey,
        sessionToken: data.credentials.SessionToken,
        expires,
        bucketName: data.bucket,
        Region: data.region,
        Key: key != null ? key : `${crypto.randomUUID()}-${file.name}`,
        uploadId,
        partNumber,
        signal
      })}`,
      // Provide content type header required by S3
      headers: {
        "Content-Type": file.type
      }
    };
  }
  signPart(file, _ref7) {
    let {
      uploadId,
      key,
      partNumber,
      signal
    } = _ref7;
    this.assertHost("signPart");
    throwIfAborted(signal);
    if (uploadId == null || key == null || partNumber == null) {
      throw new Error("Cannot sign without a key, an uploadId, and a partNumber");
    }
    const filename = encodeURIComponent(key);
    return _classPrivateFieldLooseBase6(this, _client)[_client].get(`s3/multipart/${uploadId}/${partNumber}?key=${filename}`, {
      signal
    }).then(assertServerError);
  }
  abortMultipartUpload(file, _ref8, signal) {
    let {
      key,
      uploadId
    } = _ref8;
    this.assertHost("abortMultipartUpload");
    const filename = encodeURIComponent(key);
    const uploadIdEnc = encodeURIComponent(uploadId);
    return _classPrivateFieldLooseBase6(this, _client)[_client].delete(`s3/multipart/${uploadIdEnc}?key=${filename}`, void 0, {
      signal
    }).then(assertServerError);
  }
  getUploadParameters(file, options7) {
    const {
      meta
    } = file;
    const {
      type,
      name: filename
    } = meta;
    const metadata = getAllowedMetadata({
      meta,
      allowedMetaFields: this.opts.allowedMetaFields,
      querify: true
    });
    const query3 = new URLSearchParams({
      filename,
      type,
      ...metadata
    });
    return _classPrivateFieldLooseBase6(this, _client)[_client].get(`s3/params?${query3}`, options7);
  }
  static async uploadPartBytes(_ref9) {
    let {
      signature: {
        url,
        expires,
        headers,
        method = "PUT"
      },
      body,
      size = body.size,
      onProgress,
      onComplete,
      signal
    } = _ref9;
    throwIfAborted(signal);
    if (url == null) {
      throw new Error("Cannot upload to an undefined URL");
    }
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open(method, url, true);
      if (headers) {
        Object.keys(headers).forEach((key) => {
          xhr.setRequestHeader(key, headers[key]);
        });
      }
      xhr.responseType = "text";
      if (typeof expires === "number") {
        xhr.timeout = expires * 1e3;
      }
      function onabort() {
        xhr.abort();
      }
      function cleanup() {
        signal.removeEventListener("abort", onabort);
      }
      signal.addEventListener("abort", onabort);
      xhr.upload.addEventListener("progress", (ev) => {
        onProgress(ev);
      });
      xhr.addEventListener("abort", () => {
        cleanup();
        reject(createAbortError());
      });
      xhr.addEventListener("timeout", () => {
        cleanup();
        const error = new Error("Request has expired");
        error.source = {
          status: 403
        };
        reject(error);
      });
      xhr.addEventListener("load", (ev) => {
        cleanup();
        if (ev.target.status === 403 && ev.target.responseText.includes("<Message>Request has expired</Message>")) {
          const error = new Error("Request has expired");
          error.source = ev.target;
          reject(error);
          return;
        }
        if (ev.target.status < 200 || ev.target.status >= 300) {
          const error = new Error("Non 2xx");
          error.source = ev.target;
          reject(error);
          return;
        }
        onProgress == null || onProgress({
          loaded: size,
          lengthComputable: true
        });
        const etag = ev.target.getResponseHeader("ETag");
        const location2 = ev.target.getResponseHeader("Location");
        if (method.toUpperCase() === "POST" && location2 === null) {
          console.warn("AwsS3/Multipart: Could not read the Location header. This likely means CORS is not configured correctly on the S3 Bucket. See https://uppy.io/docs/aws-s3-multipart#S3-Bucket-Configuration for instructions.");
        }
        if (etag === null) {
          reject(new Error("AwsS3/Multipart: Could not read the ETag header. This likely means CORS is not configured correctly on the S3 Bucket. See https://uppy.io/docs/aws-s3-multipart#S3-Bucket-Configuration for instructions."));
          return;
        }
        onComplete == null || onComplete(etag);
        resolve({
          ETag: etag,
          ...location2 ? {
            location: location2
          } : void 0
        });
      });
      xhr.addEventListener("error", (ev) => {
        cleanup();
        const error = new Error("Unknown error");
        error.source = ev.target;
        reject(error);
      });
      xhr.send(body);
    });
  }
  install() {
    _classPrivateFieldLooseBase6(this, _setResumableUploadsCapability)[_setResumableUploadsCapability](true);
    this.uppy.addPreProcessor(_classPrivateFieldLooseBase6(this, _setCompanionHeaders)[_setCompanionHeaders]);
    this.uppy.addUploader(_classPrivateFieldLooseBase6(this, _upload)[_upload]);
    this.uppy.on("cancel-all", _classPrivateFieldLooseBase6(this, _resetResumableCapability)[_resetResumableCapability]);
  }
  uninstall() {
    this.uppy.removePreProcessor(_classPrivateFieldLooseBase6(this, _setCompanionHeaders)[_setCompanionHeaders]);
    this.uppy.removeUploader(_classPrivateFieldLooseBase6(this, _upload)[_upload]);
    this.uppy.off("cancel-all", _classPrivateFieldLooseBase6(this, _resetResumableCapability)[_resetResumableCapability]);
  }
};
async function _getTemporarySecurityCredentials2(options7) {
  throwIfAborted(options7 == null ? void 0 : options7.signal);
  if (_classPrivateFieldLooseBase6(this, _cachedTemporaryCredentials)[_cachedTemporaryCredentials] == null) {
    if (this.opts.getTemporarySecurityCredentials === true) {
      this.assertHost("getTemporarySecurityCredentials");
      _classPrivateFieldLooseBase6(this, _cachedTemporaryCredentials)[_cachedTemporaryCredentials] = _classPrivateFieldLooseBase6(this, _client)[_client].get("s3/sts", null, options7).then(assertServerError);
    } else {
      _classPrivateFieldLooseBase6(this, _cachedTemporaryCredentials)[_cachedTemporaryCredentials] = this.opts.getTemporarySecurityCredentials(options7);
    }
    _classPrivateFieldLooseBase6(this, _cachedTemporaryCredentials)[_cachedTemporaryCredentials] = await _classPrivateFieldLooseBase6(this, _cachedTemporaryCredentials)[_cachedTemporaryCredentials];
    setTimeout(() => {
      _classPrivateFieldLooseBase6(this, _cachedTemporaryCredentials)[_cachedTemporaryCredentials] = null;
    }, (getExpiry(_classPrivateFieldLooseBase6(this, _cachedTemporaryCredentials)[_cachedTemporaryCredentials].credentials) || 0) * 500);
  }
  return _classPrivateFieldLooseBase6(this, _cachedTemporaryCredentials)[_cachedTemporaryCredentials];
}
function _uploadLocalFile2(file) {
  var _this = this;
  return new Promise((resolve, reject) => {
    const onProgress = (bytesUploaded, bytesTotal) => {
      this.uppy.emit("upload-progress", this.uppy.getFile(file.id), {
        uploader: this,
        bytesUploaded,
        bytesTotal
      });
    };
    const onError = (err) => {
      this.uppy.log(err);
      this.uppy.emit("upload-error", file, err);
      this.resetUploaderReferences(file.id);
      reject(err);
    };
    const onSuccess = (result) => {
      const uploadResp = {
        body: {
          ...result
        },
        uploadURL: result.location
      };
      this.resetUploaderReferences(file.id);
      this.uppy.emit("upload-success", _classPrivateFieldLooseBase6(this, _getFile2)[_getFile2](file), uploadResp);
      if (result.location) {
        this.uppy.log(`Download ${file.name} from ${result.location}`);
      }
      resolve();
    };
    const onPartComplete = (part) => {
      this.uppy.emit("s3-multipart:part-uploaded", _classPrivateFieldLooseBase6(this, _getFile2)[_getFile2](file), part);
    };
    const upload = new MultipartUploader_default(file.data, {
      // .bind to pass the file object to each handler.
      companionComm: _classPrivateFieldLooseBase6(this, _companionCommunicationQueue)[_companionCommunicationQueue],
      log: function() {
        return _this.uppy.log(...arguments);
      },
      getChunkSize: this.opts.getChunkSize ? this.opts.getChunkSize.bind(this) : null,
      onProgress,
      onError,
      onSuccess,
      onPartComplete,
      file,
      shouldUseMultipart: this.opts.shouldUseMultipart,
      ...file.s3Multipart
    });
    this.uploaders[file.id] = upload;
    const eventManager = new EventManager(this.uppy);
    this.uploaderEvents[file.id] = eventManager;
    eventManager.onFileRemove(file.id, (removed) => {
      upload.abort();
      this.resetUploaderReferences(file.id, {
        abort: true
      });
      resolve(`upload ${removed.id} was removed`);
    });
    eventManager.onCancelAll(file.id, function(_temp) {
      let {
        reason
      } = _temp === void 0 ? {} : _temp;
      if (reason === "user") {
        upload.abort();
        _this.resetUploaderReferences(file.id, {
          abort: true
        });
      }
      resolve(`upload ${file.id} was canceled`);
    });
    eventManager.onFilePause(file.id, (isPaused) => {
      if (isPaused) {
        upload.pause();
      } else {
        upload.start();
      }
    });
    eventManager.onPauseAll(file.id, () => {
      upload.pause();
    });
    eventManager.onResumeAll(file.id, () => {
      upload.start();
    });
    upload.start();
  });
}
function _getCompanionClientArgs2(file) {
  return {
    ...file.remote.body,
    protocol: "s3-multipart",
    size: file.data.size,
    metadata: file.meta
  };
}
AwsS3Multipart.VERSION = packageJson2.version;

// ../../node_modules/nanoid/non-secure/index.js
var urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
var nanoid = (size = 21) => {
  let id18 = "";
  let i4 = size;
  while (i4--) {
    id18 += urlAlphabet[Math.random() * 64 | 0];
  }
  return id18;
};

// ../../node_modules/@uppy/utils/lib/ProgressTimeout.js
function _classPrivateFieldLooseBase7(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id7 = 0;
function _classPrivateFieldLooseKey7(name) {
  return "__private_" + id7++ + "_" + name;
}
var _aliveTimer = /* @__PURE__ */ _classPrivateFieldLooseKey7("aliveTimer");
var _isDone = /* @__PURE__ */ _classPrivateFieldLooseKey7("isDone");
var _onTimedOut = /* @__PURE__ */ _classPrivateFieldLooseKey7("onTimedOut");
var _timeout = /* @__PURE__ */ _classPrivateFieldLooseKey7("timeout");
var ProgressTimeout = class {
  constructor(timeout, timeoutHandler) {
    Object.defineProperty(this, _aliveTimer, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _isDone, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _onTimedOut, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _timeout, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldLooseBase7(this, _timeout)[_timeout] = timeout;
    _classPrivateFieldLooseBase7(this, _onTimedOut)[_onTimedOut] = timeoutHandler;
  }
  progress() {
    if (_classPrivateFieldLooseBase7(this, _isDone)[_isDone])
      return;
    if (_classPrivateFieldLooseBase7(this, _timeout)[_timeout] > 0) {
      clearTimeout(_classPrivateFieldLooseBase7(this, _aliveTimer)[_aliveTimer]);
      _classPrivateFieldLooseBase7(this, _aliveTimer)[_aliveTimer] = setTimeout(_classPrivateFieldLooseBase7(this, _onTimedOut)[_onTimedOut], _classPrivateFieldLooseBase7(this, _timeout)[_timeout]);
    }
  }
  done() {
    if (!_classPrivateFieldLooseBase7(this, _isDone)[_isDone]) {
      clearTimeout(_classPrivateFieldLooseBase7(this, _aliveTimer)[_aliveTimer]);
      _classPrivateFieldLooseBase7(this, _aliveTimer)[_aliveTimer] = void 0;
      _classPrivateFieldLooseBase7(this, _isDone)[_isDone] = true;
    }
  }
};
var ProgressTimeout_default = ProgressTimeout;

// ../../node_modules/@uppy/utils/lib/isNetworkError.js
function isNetworkError2(xhr) {
  if (!xhr) {
    return false;
  }
  return xhr.readyState !== 0 && xhr.readyState !== 4 || xhr.status === 0;
}
var isNetworkError_default = isNetworkError2;

// ../../node_modules/@uppy/aws-s3/lib/MiniXHRUpload.js
function _classPrivateFieldLooseBase8(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id8 = 0;
function _classPrivateFieldLooseKey8(name) {
  return "__private_" + id8++ + "_" + name;
}
function buildResponseError(xhr, error) {
  if (isNetworkError_default(xhr))
    return new NetworkError_default(error, xhr);
  const err = new ErrorWithCause_default("Upload error", {
    cause: error
  });
  err.request = xhr;
  return err;
}
function setTypeInBlob(file) {
  const dataWithUpdatedType = file.data.slice(0, file.data.size, file.meta.type);
  return dataWithUpdatedType;
}
function addMetadata(formData, meta, opts) {
  const allowedMetaFields = Array.isArray(opts.allowedMetaFields) ? opts.allowedMetaFields : Object.keys(meta);
  allowedMetaFields.forEach((item) => {
    formData.append(item, meta[item]);
  });
}
function createFormDataUpload(file, opts) {
  const formPost = new FormData();
  addMetadata(formPost, file.meta, opts);
  const dataWithUpdatedType = setTypeInBlob(file);
  if (file.name) {
    formPost.append(opts.fieldName, dataWithUpdatedType, file.meta.name);
  } else {
    formPost.append(opts.fieldName, dataWithUpdatedType);
  }
  return formPost;
}
var createBareUpload = (file) => file.data;
var _addEventHandlerForFile = /* @__PURE__ */ _classPrivateFieldLooseKey8("addEventHandlerForFile");
var _addEventHandlerIfFileStillExists = /* @__PURE__ */ _classPrivateFieldLooseKey8("addEventHandlerIfFileStillExists");
var MiniXHRUpload = class {
  constructor(uppy3, opts) {
    Object.defineProperty(this, _addEventHandlerIfFileStillExists, {
      value: _addEventHandlerIfFileStillExists2
    });
    Object.defineProperty(this, _addEventHandlerForFile, {
      value: _addEventHandlerForFile2
    });
    this.uppy = uppy3;
    this.opts = {
      validateStatus(status) {
        return status >= 200 && status < 300;
      },
      ...opts
    };
    this.requests = opts[internalRateLimitedQueue];
    this.uploaderEvents = /* @__PURE__ */ Object.create(null);
    this.i18n = opts.i18n;
  }
  getOptions(file) {
    var _file$xhrUpload;
    const {
      uppy: uppy3
    } = this;
    const overrides = uppy3.getState().xhrUpload;
    const opts = {
      ...this.opts,
      ...overrides || {},
      ...file.xhrUpload || {},
      headers: {
        ...this.opts.headers,
        ...overrides == null ? void 0 : overrides.headers,
        ...(_file$xhrUpload = file.xhrUpload) == null ? void 0 : _file$xhrUpload.headers
      }
    };
    return opts;
  }
  uploadLocalFile(file) {
    const opts = this.getOptions(file);
    return new Promise((resolve, reject) => {
      const data = opts.formData ? createFormDataUpload(file, opts) : createBareUpload(file, opts);
      const xhr = new XMLHttpRequest();
      this.uploaderEvents[file.id] = new EventManager(this.uppy);
      const timer = new ProgressTimeout_default(opts.timeout, () => {
        xhr.abort();
        queuedRequest.done();
        const error = new Error(this.i18n("timedOut", {
          seconds: Math.ceil(opts.timeout / 1e3)
        }));
        this.uppy.emit("upload-error", file, error);
        reject(error);
      });
      const id18 = nanoid();
      xhr.upload.addEventListener("loadstart", () => {
        this.uppy.log(`[AwsS3/XHRUpload] ${id18} started`);
      });
      xhr.upload.addEventListener("progress", (ev) => {
        this.uppy.log(`[AwsS3/XHRUpload] ${id18} progress: ${ev.loaded} / ${ev.total}`);
        timer.progress();
        if (ev.lengthComputable) {
          this.uppy.emit("upload-progress", this.uppy.getFile(file.id), {
            uploader: this,
            bytesUploaded: ev.loaded,
            bytesTotal: ev.total
          });
        }
      });
      xhr.addEventListener("load", (ev) => {
        this.uppy.log(`[AwsS3/XHRUpload] ${id18} finished`);
        timer.done();
        queuedRequest.done();
        if (this.uploaderEvents[file.id]) {
          this.uploaderEvents[file.id].remove();
          this.uploaderEvents[file.id] = null;
        }
        if (opts.validateStatus(ev.target.status, xhr.responseText, xhr)) {
          const body2 = opts.getResponseData(xhr.responseText, xhr);
          const uploadURL = body2[opts.responseUrlFieldName];
          const uploadResp = {
            status: ev.target.status,
            body: body2,
            uploadURL
          };
          this.uppy.emit("upload-success", this.uppy.getFile(file.id), uploadResp);
          if (uploadURL) {
            this.uppy.log(`Download ${file.name} from ${uploadURL}`);
          }
          return resolve(file);
        }
        const body = opts.getResponseData(xhr.responseText, xhr);
        const error = buildResponseError(xhr, opts.getResponseError(xhr.responseText, xhr));
        const response = {
          status: ev.target.status,
          body
        };
        this.uppy.emit("upload-error", file, error, response);
        return reject(error);
      });
      xhr.addEventListener("error", () => {
        this.uppy.log(`[AwsS3/XHRUpload] ${id18} errored`);
        timer.done();
        queuedRequest.done();
        if (this.uploaderEvents[file.id]) {
          this.uploaderEvents[file.id].remove();
          this.uploaderEvents[file.id] = null;
        }
        const error = buildResponseError(xhr, opts.getResponseError(xhr.responseText, xhr));
        this.uppy.emit("upload-error", file, error);
        return reject(error);
      });
      xhr.open(opts.method.toUpperCase(), opts.endpoint, true);
      xhr.withCredentials = Boolean(opts.withCredentials);
      if (opts.responseType !== "") {
        xhr.responseType = opts.responseType;
      }
      Object.keys(opts.headers).forEach((header) => {
        xhr.setRequestHeader(header, opts.headers[header]);
      });
      const queuedRequest = this.requests.run(() => {
        xhr.send(data);
        return () => {
          timer.done();
          xhr.abort();
        };
      }, {
        priority: 1
      });
      _classPrivateFieldLooseBase8(this, _addEventHandlerForFile)[_addEventHandlerForFile]("file-removed", file.id, () => {
        queuedRequest.abort();
        reject(new Error("File removed"));
      });
      _classPrivateFieldLooseBase8(this, _addEventHandlerIfFileStillExists)[_addEventHandlerIfFileStillExists]("cancel-all", file.id, function(_temp) {
        let {
          reason
        } = _temp === void 0 ? {} : _temp;
        if (reason === "user") {
          queuedRequest.abort();
        }
        reject(new Error("Upload cancelled"));
      });
    });
  }
};
function _addEventHandlerForFile2(eventName, fileID, eventHandler) {
  this.uploaderEvents[fileID].on(eventName, (fileOrID) => {
    var _fileOrID$id;
    const id18 = (_fileOrID$id = fileOrID == null ? void 0 : fileOrID.id) != null ? _fileOrID$id : fileOrID;
    if (fileID === id18)
      eventHandler();
  });
}
function _addEventHandlerIfFileStillExists2(eventName, fileID, eventHandler) {
  var _this = this;
  this.uploaderEvents[fileID].on(eventName, function() {
    if (_this.uppy.getFile(fileID))
      eventHandler(...arguments);
  });
}

// ../../node_modules/@uppy/aws-s3/lib/isXml.js
function removeMimeParameters(mimeType) {
  return mimeType.replace(/;.*$/, "");
}
function isXml(content, xhr) {
  const rawContentType = xhr.headers ? xhr.headers["content-type"] : xhr.getResponseHeader("Content-Type");
  if (typeof rawContentType === "string") {
    const contentType = removeMimeParameters(rawContentType).toLowerCase();
    if (contentType === "application/xml" || contentType === "text/xml") {
      return true;
    }
    if (contentType === "text/html" && /^<\?xml /.test(content)) {
      return true;
    }
  }
  return false;
}
var isXml_default = isXml;

// ../../node_modules/@uppy/aws-s3/lib/locale.js
var locale_default = {
  strings: {
    timedOut: "Upload stalled for %{seconds} seconds, aborting."
  }
};

// ../../node_modules/@uppy/aws-s3/lib/index.js
var _Symbol$for4;
function _classPrivateFieldLooseBase9(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id9 = 0;
function _classPrivateFieldLooseKey9(name) {
  return "__private_" + id9++ + "_" + name;
}
var packageJson3 = {
  "version": "3.6.2"
};
function resolveUrl(origin, link) {
  if (!origin && !link.startsWith("https://") && !link.startsWith("http://")) {
    link = `https://${link}`;
  }
  return new URL(link, origin || void 0).toString();
}
function getXmlValue(source, tagName) {
  const start = source.indexOf(`<${tagName}>`);
  const end = source.indexOf(`</${tagName}>`, start);
  return start !== -1 && end !== -1 ? source.slice(start + tagName.length + 2, end) : "";
}
function assertServerError2(res) {
  if (res && res.error) {
    const error = new Error(res.message);
    Object.assign(error, res.error);
    throw error;
  }
  return res;
}
function validateParameters(file, params) {
  const valid = params != null && typeof params.url === "string" && (typeof params.fields === "object" || params.fields == null);
  if (!valid) {
    const err = new TypeError(`AwsS3: got incorrect result from 'getUploadParameters()' for file '${file.name}', expected an object '{ url, method, fields, headers }' but got '${JSON.stringify(params)}' instead.
See https://uppy.io/docs/aws-s3/#getUploadParameters-file for more on the expected format.`);
    throw err;
  }
  const methodIsValid = params.method == null || /^p(u|os)t$/i.test(params.method);
  if (!methodIsValid) {
    const err = new TypeError(`AwsS3: got incorrect method from 'getUploadParameters()' for file '${file.name}', expected  'PUT' or 'POST' but got '${params.method}' instead.
See https://uppy.io/docs/aws-s3/#getUploadParameters-file for more on the expected format.`);
    throw err;
  }
}
function defaultGetResponseError(content, xhr) {
  if (!isXml_default(content, xhr)) {
    return void 0;
  }
  const error = getXmlValue(content, "Message");
  return new Error(error);
}
var warnedSuccessActionStatus = false;
var _client2 = /* @__PURE__ */ _classPrivateFieldLooseKey9("client");
var _requests2 = /* @__PURE__ */ _classPrivateFieldLooseKey9("requests");
var _uploader = /* @__PURE__ */ _classPrivateFieldLooseKey9("uploader");
var _handleUpload = /* @__PURE__ */ _classPrivateFieldLooseKey9("handleUpload");
var _setCompanionHeaders2 = /* @__PURE__ */ _classPrivateFieldLooseKey9("setCompanionHeaders");
var _getCompanionClientArgs3 = /* @__PURE__ */ _classPrivateFieldLooseKey9("getCompanionClientArgs");
_Symbol$for4 = Symbol.for("uppy test: getClient");
var AwsS3 = class extends BasePlugin2 {
  constructor(uppy3, _opts) {
    if ((_opts == null ? void 0 : _opts.shouldUseMultipart) != null) {
      return new AwsS3Multipart(uppy3, _opts);
    }
    super(uppy3, _opts);
    Object.defineProperty(this, _client2, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _requests2, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _uploader, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _handleUpload, {
      writable: true,
      value: async (fileIDs) => {
        const paramsPromises = /* @__PURE__ */ Object.create(null);
        function onremove(file) {
          var _paramsPromises$id;
          const {
            id: id18
          } = file;
          (_paramsPromises$id = paramsPromises[id18]) == null || _paramsPromises$id.abort();
        }
        this.uppy.on("file-removed", onremove);
        const files = this.uppy.getFilesByIds(fileIDs);
        const filesFiltered = filterNonFailedFiles(files);
        const filesToEmit = filterFilesToEmitUploadStarted(filesFiltered);
        this.uppy.emit("upload-start", filesToEmit);
        const getUploadParameters = _classPrivateFieldLooseBase9(this, _requests2)[_requests2].wrapPromiseFunction((file) => {
          return this.opts.getUploadParameters(file);
        });
        const numberOfFiles = fileIDs.length;
        return Promise.allSettled(fileIDs.map((id18, index2) => {
          paramsPromises[id18] = getUploadParameters(this.uppy.getFile(id18));
          return paramsPromises[id18].then((params) => {
            delete paramsPromises[id18];
            const file = this.uppy.getFile(id18);
            validateParameters(file, params);
            const {
              method = "POST",
              url,
              fields,
              headers
            } = params;
            const xhrOpts = {
              method,
              formData: method.toUpperCase() === "POST",
              endpoint: url,
              allowedMetaFields: fields ? Object.keys(fields) : []
            };
            if (headers) {
              xhrOpts.headers = headers;
            }
            this.uppy.setFileState(file.id, {
              meta: {
                ...file.meta,
                ...fields
              },
              xhrUpload: xhrOpts
            });
            return this.uploadFile(file.id, index2, numberOfFiles);
          }).catch((error) => {
            delete paramsPromises[id18];
            const file = this.uppy.getFile(id18);
            this.uppy.emit("upload-error", file, error);
            return Promise.reject(error);
          });
        })).finally(() => {
          this.uppy.off("file-removed", onremove);
        });
      }
    });
    Object.defineProperty(this, _setCompanionHeaders2, {
      writable: true,
      value: () => {
        _classPrivateFieldLooseBase9(this, _client2)[_client2].setCompanionHeaders(this.opts.companionHeaders);
        return Promise.resolve();
      }
    });
    Object.defineProperty(this, _getCompanionClientArgs3, {
      writable: true,
      value: (file) => {
        const opts = _classPrivateFieldLooseBase9(this, _uploader)[_uploader].getOptions(file);
        const allowedMetaFields = Array.isArray(opts.allowedMetaFields) ? opts.allowedMetaFields : Object.keys(file.meta);
        return {
          ...file.remote.body,
          protocol: "multipart",
          endpoint: opts.endpoint,
          size: file.data.size,
          fieldname: opts.fieldName,
          metadata: Object.fromEntries(allowedMetaFields.map((name) => [name, file.meta[name]])),
          httpMethod: opts.method,
          useFormData: opts.formData,
          headers: typeof opts.headers === "function" ? opts.headers(file) : opts.headers
        };
      }
    });
    this.type = "uploader";
    this.id = this.opts.id || "AwsS3";
    this.title = "AWS S3";
    this.defaultLocale = locale_default;
    const defaultOptions8 = {
      timeout: 30 * 1e3,
      limit: 0,
      allowedMetaFields: [],
      // have to opt in
      getUploadParameters: this.getUploadParameters.bind(this),
      shouldUseMultipart: false,
      companionHeaders: {}
    };
    this.opts = {
      ...defaultOptions8,
      ..._opts
    };
    if ((_opts == null ? void 0 : _opts.allowedMetaFields) === void 0 && "metaFields" in this.opts) {
      throw new Error("The `metaFields` option has been renamed to `allowedMetaFields`.");
    }
    this.i18nInit();
    _classPrivateFieldLooseBase9(this, _client2)[_client2] = new RequestClient(uppy3, _opts);
    _classPrivateFieldLooseBase9(this, _requests2)[_requests2] = new RateLimitedQueue(this.opts.limit);
  }
  [_Symbol$for4]() {
    return _classPrivateFieldLooseBase9(this, _client2)[_client2];
  }
  // TODO: remove getter and setter for #client on the next major release
  get client() {
    return _classPrivateFieldLooseBase9(this, _client2)[_client2];
  }
  set client(client) {
    _classPrivateFieldLooseBase9(this, _client2)[_client2] = client;
  }
  getUploadParameters(file) {
    if (!this.opts.companionUrl) {
      throw new Error("Expected a `companionUrl` option containing a Companion address.");
    }
    const filename = file.meta.name;
    const {
      type
    } = file.meta;
    const metadata = Object.fromEntries(this.opts.allowedMetaFields.filter((key) => file.meta[key] != null).map((key) => [`metadata[${key}]`, file.meta[key].toString()]));
    const query3 = new URLSearchParams({
      filename,
      type,
      ...metadata
    });
    return _classPrivateFieldLooseBase9(this, _client2)[_client2].get(`s3/params?${query3}`).then(assertServerError2);
  }
  uploadFile(id18, current, total) {
    const file = this.uppy.getFile(id18);
    this.uppy.log(`uploading ${current} of ${total}`);
    if (file.error)
      throw new Error(file.error);
    if (file.isRemote) {
      const getQueue = () => _classPrivateFieldLooseBase9(this, _requests2)[_requests2];
      const controller = new AbortController();
      const removedHandler = (removedFile) => {
        if (removedFile.id === file.id)
          controller.abort();
      };
      this.uppy.on("file-removed", removedHandler);
      const uploadPromise = this.uppy.getRequestClientForFile(file).uploadRemoteFile(file, _classPrivateFieldLooseBase9(this, _getCompanionClientArgs3)[_getCompanionClientArgs3](file), {
        signal: controller.signal,
        getQueue
      });
      _classPrivateFieldLooseBase9(this, _requests2)[_requests2].wrapSyncFunction(() => {
        this.uppy.off("file-removed", removedHandler);
      }, {
        priority: -1
      })();
      return uploadPromise;
    }
    return _classPrivateFieldLooseBase9(this, _uploader)[_uploader].uploadLocalFile(file, current, total);
  }
  install() {
    const {
      uppy: uppy3
    } = this;
    uppy3.addPreProcessor(_classPrivateFieldLooseBase9(this, _setCompanionHeaders2)[_setCompanionHeaders2]);
    uppy3.addUploader(_classPrivateFieldLooseBase9(this, _handleUpload)[_handleUpload]);
    function defaultGetResponseData(content, xhr) {
      const opts = this;
      if (!isXml_default(content, xhr)) {
        if (opts.method.toUpperCase() === "POST") {
          if (!warnedSuccessActionStatus) {
            uppy3.log("[AwsS3] No response data found, make sure to set the success_action_status AWS SDK option to 201. See https://uppy.io/docs/aws-s3/#POST-Uploads", "warning");
            warnedSuccessActionStatus = true;
          }
          return {
            location: null
          };
        }
        if (!xhr.responseURL) {
          return {
            location: null
          };
        }
        return {
          location: xhr.responseURL.replace(/\?.*$/, "")
        };
      }
      return {
        // Some S3 alternatives do not reply with an absolute URL.
        // Eg DigitalOcean Spaces uses /$bucketName/xyz
        location: resolveUrl(xhr.responseURL, getXmlValue(content, "Location")),
        bucket: getXmlValue(content, "Bucket"),
        key: getXmlValue(content, "Key"),
        etag: getXmlValue(content, "ETag")
      };
    }
    const xhrOptions = {
      fieldName: "file",
      responseUrlFieldName: "location",
      timeout: this.opts.timeout,
      // Share the rate limiting queue with XHRUpload.
      [internalRateLimitedQueue]: _classPrivateFieldLooseBase9(this, _requests2)[_requests2],
      responseType: "text",
      getResponseData: this.opts.getResponseData || defaultGetResponseData,
      getResponseError: defaultGetResponseError
    };
    xhrOptions.i18n = this.i18n;
    _classPrivateFieldLooseBase9(this, _uploader)[_uploader] = new MiniXHRUpload(uppy3, xhrOptions);
  }
  uninstall() {
    this.uppy.removePreProcessor(_classPrivateFieldLooseBase9(this, _setCompanionHeaders2)[_setCompanionHeaders2]);
    this.uppy.removeUploader(_classPrivateFieldLooseBase9(this, _handleUpload)[_handleUpload]);
  }
};
AwsS3.VERSION = packageJson3.version;

// ../../node_modules/@uppy/react/lib/Dashboard.js
import { createElement as h, Component } from "react";
import DashboardPlugin from "@uppy/dashboard";

// ../../node_modules/@uppy/react/lib/propTypes.js
var import_prop_types = __toESM(require_prop_types(), 1);
import { Uppy as UppyCore } from "@uppy/core";
var uppy = import_prop_types.default.instanceOf(UppyCore);
var plugins = import_prop_types.default.arrayOf(import_prop_types.default.string);
var locale = import_prop_types.default.shape({
  strings: import_prop_types.default.object,
  // eslint-disable-line react/forbid-prop-types
  pluralize: import_prop_types.default.func
});
var metaField = import_prop_types.default.shape({
  id: import_prop_types.default.string.isRequired,
  name: import_prop_types.default.string.isRequired,
  placeholder: import_prop_types.default.string
});
var metaFields = import_prop_types.default.oneOfType([import_prop_types.default.arrayOf(metaField), import_prop_types.default.func]);
var cssSize = import_prop_types.default.oneOfType([import_prop_types.default.string, import_prop_types.default.number]);
var dashboard = {
  uppy,
  inline: import_prop_types.default.bool,
  plugins,
  width: cssSize,
  height: cssSize,
  showProgressDetails: import_prop_types.default.bool,
  hideUploadButton: import_prop_types.default.bool,
  hideProgressAfterFinish: import_prop_types.default.bool,
  note: import_prop_types.default.string,
  metaFields,
  proudlyDisplayPoweredByUppy: import_prop_types.default.bool,
  disableStatusBar: import_prop_types.default.bool,
  disableInformer: import_prop_types.default.bool,
  disableThumbnailGenerator: import_prop_types.default.bool,
  // pass-through to ThumbnailGenerator
  thumbnailWidth: import_prop_types.default.number,
  locale
};

// ../../node_modules/@uppy/react/lib/getHTMLProps.js
var reactSupportedHtmlAttr = [
  // React-specific Attributes
  "defaultChecked",
  "defaultValue",
  "suppressContentEditableWarning",
  "suppressHydrationWarning",
  "dangerouslySetInnerHTML",
  // Standard HTML Attributes
  "accessKey",
  "className",
  "contentEditable",
  "contextMenu",
  "dir",
  "draggable",
  "hidden",
  "id",
  "lang",
  "placeholder",
  "slot",
  "spellCheck",
  "style",
  "tabIndex",
  "title",
  "translate",
  // Unknown
  "radioGroup",
  // WAI-ARIA
  "role",
  // RDFa Attributes
  "about",
  "datatype",
  "inlist",
  "prefix",
  "property",
  "resource",
  "typeof",
  "vocab",
  // Non-standard Attributes
  "autoCapitalize",
  "autoCorrect",
  "autoSave",
  "color",
  "itemProp",
  "itemScope",
  "itemType",
  "itemID",
  "itemRef",
  "results",
  "security",
  "unselectable",
  // Living Standard
  "inputMode",
  "is",
  // Clipboard Events
  "onCopy",
  "onCopyCapture",
  "onCut",
  "onCutCapture",
  "onPaste",
  "onPasteCapture",
  // Composition Events
  "onCompositionEnd",
  "onCompositionEndCapture",
  "onCompositionStart",
  "onCompositionStartCapture",
  "onCompositionUpdate",
  "onCompositionUpdateCapture",
  // Focus Events
  "onFocus",
  "onFocusCapture",
  "onBlur",
  "onBlurCapture",
  // Form Events
  "onChange",
  "onChangeCapture",
  "onBeforeInput",
  "onBeforeInputCapture",
  "onInput",
  "onInputCapture",
  "onReset",
  "onResetCapture",
  "onSubmit",
  "onSubmitCapture",
  "onInvalid",
  "onInvalidCapture",
  // Image Events
  "onLoad",
  "onLoadCapture",
  "onError",
  // also a Media Event
  "onErrorCapture",
  // also a Media Event
  // Keyboard Events
  "onKeyDown",
  "onKeyDownCapture",
  "onKeyPress",
  "onKeyPressCapture",
  "onKeyUp",
  "onKeyUpCapture",
  // Media Events
  "onAbort",
  "onAbortCapture",
  "onCanPlay",
  "onCanPlayCapture",
  "onCanPlayThrough",
  "onCanPlayThroughCapture",
  "onDurationChange",
  "onDurationChangeCapture",
  "onEmptied",
  "onEmptiedCapture",
  "onEncrypted",
  "onEncryptedCapture",
  "onEnded",
  "onEndedCapture",
  "onLoadedData",
  "onLoadedDataCapture",
  "onLoadedMetadata",
  "onLoadedMetadataCapture",
  "onLoadStart",
  "onLoadStartCapture",
  "onPause",
  "onPauseCapture",
  "onPlay",
  "onPlayCapture",
  "onPlaying",
  "onPlayingCapture",
  "onProgress",
  "onProgressCapture",
  "onRateChange",
  "onRateChangeCapture",
  "onSeeked",
  "onSeekedCapture",
  "onSeeking",
  "onSeekingCapture",
  "onStalled",
  "onStalledCapture",
  "onSuspend",
  "onSuspendCapture",
  "onTimeUpdate",
  "onTimeUpdateCapture",
  "onVolumeChange",
  "onVolumeChangeCapture",
  "onWaiting",
  "onWaitingCapture",
  // MouseEvents
  "onAuxClick",
  "onAuxClickCapture",
  "onClick",
  "onClickCapture",
  "onContextMenu",
  "onContextMenuCapture",
  "onDoubleClick",
  "onDoubleClickCapture",
  "onDrag",
  "onDragCapture",
  "onDragEnd",
  "onDragEndCapture",
  "onDragEnter",
  "onDragEnterCapture",
  "onDragExit",
  "onDragExitCapture",
  "onDragLeave",
  "onDragLeaveCapture",
  "onDragOver",
  "onDragOverCapture",
  "onDragStart",
  "onDragStartCapture",
  "onDrop",
  "onDropCapture",
  "onMouseDown",
  "onMouseDownCapture",
  "onMouseEnter",
  "onMouseLeave",
  "onMouseMove",
  "onMouseMoveCapture",
  "onMouseOut",
  "onMouseOutCapture",
  "onMouseOver",
  "onMouseOverCapture",
  "onMouseUp",
  "onMouseUpCapture",
  // Selection Events
  "onSelect",
  "onSelectCapture",
  // Touch Events
  "onTouchCancel",
  "onTouchCancelCapture",
  "onTouchEnd",
  "onTouchEndCapture",
  "onTouchMove",
  "onTouchMoveCapture",
  "onTouchStart",
  "onTouchStartCapture",
  // Pointer Events
  "onPointerDown",
  "onPointerDownCapture",
  "onPointerMove",
  "onPointerMoveCapture",
  "onPointerUp",
  "onPointerUpCapture",
  "onPointerCancel",
  "onPointerCancelCapture",
  "onPointerEnter",
  "onPointerEnterCapture",
  "onPointerLeave",
  "onPointerLeaveCapture",
  "onPointerOver",
  "onPointerOverCapture",
  "onPointerOut",
  "onPointerOutCapture",
  "onGotPointerCapture",
  "onGotPointerCaptureCapture",
  "onLostPointerCapture",
  "onLostPointerCaptureCapture",
  // UI Events
  "onScroll",
  "onScrollCapture",
  // Wheel Events
  "onWheel",
  "onWheelCapture",
  // Animation Events
  "onAnimationStart",
  "onAnimationStartCapture",
  "onAnimationEnd",
  "onAnimationEndCapture",
  "onAnimationIteration",
  "onAnimationIterationCapture",
  // Transition Events
  "onTransitionEnd",
  "onTransitionEndCapture"
];
var validHTMLAttribute = /^(aria-|data-)/;
var getHTMLProps = (props) => {
  return Object.fromEntries(Object.entries(props).filter((_ref) => {
    let [key] = _ref;
    return validHTMLAttribute.test(key) || reactSupportedHtmlAttr.includes(key);
  }));
};
var getHTMLProps_default = getHTMLProps;

// ../../node_modules/@uppy/react/lib/nonHtmlPropsHaveChanged.js
function nonHtmlPropsHaveChanged(props, prevProps) {
  return Object.keys(props).some((key) => !Object.hasOwn(props, key) && props[key] !== prevProps[key]);
}

// ../../node_modules/@uppy/react/lib/Dashboard.js
var Dashboard = class extends Component {
  componentDidMount() {
    this.installPlugin();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.uppy !== this.props.uppy) {
      this.uninstallPlugin(prevProps);
      this.installPlugin();
    } else if (nonHtmlPropsHaveChanged(this.props, prevProps)) {
      const options7 = {
        ...this.props,
        target: this.container
      };
      delete options7.uppy;
      this.plugin.setOptions(options7);
    }
  }
  componentWillUnmount() {
    this.uninstallPlugin();
  }
  installPlugin() {
    const {
      uppy: uppy3
    } = this.props;
    const options7 = {
      id: "react:Dashboard",
      ...this.props,
      target: this.container
    };
    delete options7.uppy;
    uppy3.use(DashboardPlugin, options7);
    this.plugin = uppy3.getPlugin(options7.id);
  }
  uninstallPlugin(props) {
    if (props === void 0) {
      props = this.props;
    }
    const {
      uppy: uppy3
    } = props;
    uppy3.removePlugin(this.plugin);
  }
  render() {
    return h("div", {
      className: "uppy-Container",
      ref: (container) => {
        this.container = container;
      },
      ...getHTMLProps_default(this.props)
    });
  }
};
Dashboard.propTypes = dashboard;
Dashboard.defaultProps = {
  inline: true
};
var Dashboard_default = Dashboard;

// ../../node_modules/@uppy/react/lib/DashboardModal.js
var import_prop_types2 = __toESM(require_prop_types(), 1);
import { createElement as h2, Component as Component2 } from "react";
import DashboardPlugin2 from "@uppy/dashboard";
var DashboardModal = class extends Component2 {
  componentDidMount() {
    this.installPlugin();
  }
  componentDidUpdate(prevProps) {
    const {
      uppy: uppy3,
      open,
      onRequestClose
    } = this.props;
    if (prevProps.uppy !== uppy3) {
      this.uninstallPlugin(prevProps);
      this.installPlugin();
    } else if (nonHtmlPropsHaveChanged(this.props, prevProps)) {
      const options7 = {
        ...this.props,
        onRequestCloseModal: onRequestClose
      };
      delete options7.uppy;
      this.plugin.setOptions(options7);
    }
    if (prevProps.open && !open) {
      this.plugin.closeModal();
    } else if (!prevProps.open && open) {
      this.plugin.openModal();
    }
  }
  componentWillUnmount() {
    this.uninstallPlugin();
  }
  installPlugin() {
    const {
      id: id18 = "react:DashboardModal",
      uppy: uppy3,
      target,
      open,
      onRequestClose,
      closeModalOnClickOutside,
      disablePageScrollWhenModalOpen,
      inline,
      plugins: plugins3,
      // eslint-disable-line no-shadow
      width,
      height,
      showProgressDetails,
      note,
      metaFields: metaFields3,
      // eslint-disable-line no-shadow
      proudlyDisplayPoweredByUppy,
      autoOpenFileEditor,
      animateOpenClose,
      browserBackButtonClose,
      closeAfterFinish,
      disableStatusBar,
      disableInformer,
      disableThumbnailGenerator,
      disableLocalFiles,
      disabled,
      hideCancelButton,
      hidePauseResumeButton,
      hideProgressAfterFinish,
      hideRetryButton,
      hideUploadButton,
      showLinkToFileUploadResult,
      showRemoveButtonAfterComplete,
      showSelectedFiles,
      waitForThumbnailsBeforeUpload,
      fileManagerSelectionType,
      theme,
      thumbnailType,
      thumbnailWidth,
      locale: locale3
      // eslint-disable-line no-shadow
    } = this.props;
    const options7 = {
      id: id18,
      target,
      closeModalOnClickOutside,
      disablePageScrollWhenModalOpen,
      inline,
      plugins: plugins3,
      width,
      height,
      showProgressDetails,
      note,
      metaFields: metaFields3,
      proudlyDisplayPoweredByUppy,
      autoOpenFileEditor,
      animateOpenClose,
      browserBackButtonClose,
      closeAfterFinish,
      disableStatusBar,
      disableInformer,
      disableThumbnailGenerator,
      disableLocalFiles,
      disabled,
      hideCancelButton,
      hidePauseResumeButton,
      hideProgressAfterFinish,
      hideRetryButton,
      hideUploadButton,
      showLinkToFileUploadResult,
      showRemoveButtonAfterComplete,
      showSelectedFiles,
      waitForThumbnailsBeforeUpload,
      fileManagerSelectionType,
      theme,
      thumbnailType,
      thumbnailWidth,
      locale: locale3,
      onRequestCloseModal: onRequestClose
    };
    if (!options7.target) {
      options7.target = this.container;
    }
    delete options7.uppy;
    uppy3.use(DashboardPlugin2, options7);
    this.plugin = uppy3.getPlugin(options7.id);
    if (open) {
      this.plugin.openModal();
    }
  }
  uninstallPlugin(props) {
    if (props === void 0) {
      props = this.props;
    }
    const {
      uppy: uppy3
    } = props;
    uppy3.removePlugin(this.plugin);
  }
  render() {
    return h2("div", {
      className: "uppy-Container",
      ref: (container) => {
        this.container = container;
      },
      ...getHTMLProps_default(this.props)
    });
  }
};
DashboardModal.propTypes = {
  uppy: uppy.isRequired,
  target: typeof window !== "undefined" ? import_prop_types2.default.instanceOf(window.HTMLElement) : import_prop_types2.default.any,
  open: import_prop_types2.default.bool,
  onRequestClose: import_prop_types2.default.func,
  closeModalOnClickOutside: import_prop_types2.default.bool,
  disablePageScrollWhenModalOpen: import_prop_types2.default.bool,
  inline: import_prop_types2.default.bool,
  plugins,
  width: cssSize,
  height: cssSize,
  showProgressDetails: import_prop_types2.default.bool,
  note: import_prop_types2.default.string,
  metaFields,
  proudlyDisplayPoweredByUppy: import_prop_types2.default.bool,
  autoOpenFileEditor: import_prop_types2.default.bool,
  animateOpenClose: import_prop_types2.default.bool,
  browserBackButtonClose: import_prop_types2.default.bool,
  closeAfterFinish: import_prop_types2.default.bool,
  disableStatusBar: import_prop_types2.default.bool,
  disableInformer: import_prop_types2.default.bool,
  disableThumbnailGenerator: import_prop_types2.default.bool,
  disableLocalFiles: import_prop_types2.default.bool,
  disabled: import_prop_types2.default.bool,
  hideCancelButton: import_prop_types2.default.bool,
  hidePauseResumeButton: import_prop_types2.default.bool,
  hideProgressAfterFinish: import_prop_types2.default.bool,
  hideRetryButton: import_prop_types2.default.bool,
  hideUploadButton: import_prop_types2.default.bool,
  showLinkToFileUploadResult: import_prop_types2.default.bool,
  showRemoveButtonAfterComplete: import_prop_types2.default.bool,
  showSelectedFiles: import_prop_types2.default.bool,
  waitForThumbnailsBeforeUpload: import_prop_types2.default.bool,
  fileManagerSelectionType: import_prop_types2.default.string,
  theme: import_prop_types2.default.string,
  // pass-through to ThumbnailGenerator
  thumbnailType: import_prop_types2.default.string,
  thumbnailWidth: import_prop_types2.default.number,
  locale
};
DashboardModal.defaultProps = {
  metaFields: [],
  plugins: [],
  inline: false,
  width: 750,
  height: 550,
  thumbnailWidth: 280,
  thumbnailType: "image/jpeg",
  waitForThumbnailsBeforeUpload: false,
  showLinkToFileUploadResult: false,
  showProgressDetails: false,
  hideUploadButton: false,
  hideCancelButton: false,
  hideRetryButton: false,
  hidePauseResumeButton: false,
  hideProgressAfterFinish: false,
  note: null,
  closeModalOnClickOutside: false,
  closeAfterFinish: false,
  disableStatusBar: false,
  disableInformer: false,
  disableThumbnailGenerator: false,
  disablePageScrollWhenModalOpen: true,
  animateOpenClose: true,
  fileManagerSelectionType: "files",
  proudlyDisplayPoweredByUppy: true,
  showSelectedFiles: true,
  showRemoveButtonAfterComplete: false,
  browserBackButtonClose: false,
  theme: "light",
  autoOpenFileEditor: false,
  disabled: false,
  disableLocalFiles: false,
  // extra
  open: void 0,
  target: void 0,
  locale: null,
  onRequestClose: void 0
};

// ../../node_modules/@uppy/react/lib/DragDrop.js
var import_prop_types3 = __toESM(require_prop_types(), 1);
import { createElement as h4, Component as Component3 } from "react";

// ../../node_modules/@uppy/drag-drop/lib/DragDrop.js
import { UIPlugin } from "@uppy/core";

// ../../node_modules/@uppy/utils/lib/toArray.js
var toArray_default = Array.from;

// ../../node_modules/@uppy/utils/lib/isDragDropSupported.js
function isDragDropSupported() {
  const div = document.body;
  if (!("draggable" in div) || !("ondragstart" in div && "ondrop" in div)) {
    return false;
  }
  if (!("FormData" in window)) {
    return false;
  }
  if (!("FileReader" in window)) {
    return false;
  }
  return true;
}

// ../../node_modules/@uppy/utils/lib/getDroppedFiles/utils/webkitGetAsEntryApi/getFilesAndDirectoriesFromDirectory.js
function getFilesAndDirectoriesFromDirectory(directoryReader, oldEntries, logDropError, _ref) {
  let {
    onSuccess
  } = _ref;
  directoryReader.readEntries(
    (entries) => {
      const newEntries = [...oldEntries, ...entries];
      if (entries.length) {
        queueMicrotask(() => {
          getFilesAndDirectoriesFromDirectory(directoryReader, newEntries, logDropError, {
            onSuccess
          });
        });
      } else {
        onSuccess(newEntries);
      }
    },
    // Make sure we resolve on error anyway, it's fine if only one directory couldn't be parsed!
    (error) => {
      logDropError(error);
      onSuccess(oldEntries);
    }
  );
}

// ../../node_modules/@uppy/utils/lib/getDroppedFiles/utils/webkitGetAsEntryApi/index.js
function getAsFileSystemHandleFromEntry(entry, logDropError) {
  if (entry == null)
    return entry;
  return {
    kind: (
      // eslint-disable-next-line no-nested-ternary
      entry.isFile ? "file" : entry.isDirectory ? "directory" : void 0
    ),
    name: entry.name,
    getFile() {
      return new Promise((resolve, reject) => entry.file(resolve, reject));
    },
    async *values() {
      const directoryReader = entry.createReader();
      const entries = await new Promise((resolve) => {
        getFilesAndDirectoriesFromDirectory(directoryReader, [], logDropError, {
          onSuccess: (dirEntries) => resolve(dirEntries.map((file) => getAsFileSystemHandleFromEntry(file, logDropError)))
        });
      });
      yield* entries;
    },
    isSameEntry: void 0
  };
}
function createPromiseToAddFileOrParseDirectory(entry, relativePath, lastResortFile) {
  try {
    if (lastResortFile === void 0) {
      lastResortFile = void 0;
    }
    return async function* () {
      const getNextRelativePath = () => `${relativePath}/${entry.name}`;
      if (entry.kind === "file") {
        const file = await entry.getFile();
        if (file != null) {
          ;
          file.relativePath = relativePath ? getNextRelativePath() : null;
          yield file;
        } else if (lastResortFile != null)
          yield lastResortFile;
      } else if (entry.kind === "directory") {
        for await (const handle of entry.values()) {
          yield* createPromiseToAddFileOrParseDirectory(handle, relativePath ? getNextRelativePath() : entry.name);
        }
      } else if (lastResortFile != null)
        yield lastResortFile;
    }();
  } catch (e4) {
    return Promise.reject(e4);
  }
}
async function* getFilesFromDataTransfer(dataTransfer, logDropError) {
  const fileSystemHandles = await Promise.all(Array.from(dataTransfer.items, async (item) => {
    var _fileSystemHandle;
    let fileSystemHandle;
    const getAsEntry = () => typeof item.getAsEntry === "function" ? item.getAsEntry() : item.webkitGetAsEntry();
    (_fileSystemHandle = fileSystemHandle) != null ? _fileSystemHandle : fileSystemHandle = getAsFileSystemHandleFromEntry(getAsEntry(), logDropError);
    return {
      fileSystemHandle,
      lastResortFile: item.getAsFile()
      // can be used as a fallback in case other methods fail
    };
  }));
  for (const {
    lastResortFile,
    fileSystemHandle
  } of fileSystemHandles) {
    if (fileSystemHandle != null) {
      try {
        yield* createPromiseToAddFileOrParseDirectory(fileSystemHandle, "", lastResortFile);
      } catch (err) {
        if (lastResortFile != null) {
          yield lastResortFile;
        } else {
          logDropError(err);
        }
      }
    } else if (lastResortFile != null)
      yield lastResortFile;
  }
}

// ../../node_modules/@uppy/utils/lib/getDroppedFiles/utils/fallbackApi.js
function fallbackApi(dataTransfer) {
  const files = toArray_default(dataTransfer.files);
  return Promise.resolve(files);
}

// ../../node_modules/@uppy/utils/lib/getDroppedFiles/index.js
async function getDroppedFiles(dataTransfer, options7) {
  var _options$logDropError;
  const logDropError = (_options$logDropError = options7 == null ? void 0 : options7.logDropError) != null ? _options$logDropError : Function.prototype;
  try {
    const accumulator = [];
    for await (const file of getFilesFromDataTransfer(dataTransfer, logDropError)) {
      accumulator.push(file);
    }
    return accumulator;
  } catch {
    return fallbackApi(dataTransfer);
  }
}

// ../../node_modules/preact/dist/preact.mjs
var n;
var l;
var u;
var t;
var i;
var o;
var r;
var f;
var e;
var c = {};
var s = [];
var a = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
var h3 = Array.isArray;
function v(n3, l4) {
  for (var u4 in l4)
    n3[u4] = l4[u4];
  return n3;
}
function p(n3) {
  var l4 = n3.parentNode;
  l4 && l4.removeChild(n3);
}
function y(l4, u4, t4) {
  var i4, o4, r4, f4 = {};
  for (r4 in u4)
    "key" == r4 ? i4 = u4[r4] : "ref" == r4 ? o4 = u4[r4] : f4[r4] = u4[r4];
  if (arguments.length > 2 && (f4.children = arguments.length > 3 ? n.call(arguments, 2) : t4), "function" == typeof l4 && null != l4.defaultProps)
    for (r4 in l4.defaultProps)
      void 0 === f4[r4] && (f4[r4] = l4.defaultProps[r4]);
  return d(l4, f4, i4, o4, null);
}
function d(n3, t4, i4, o4, r4) {
  var f4 = { type: n3, props: t4, key: i4, ref: o4, __k: null, __: null, __b: 0, __e: null, __d: void 0, __c: null, constructor: void 0, __v: null == r4 ? ++u : r4, __i: -1, __u: 0 };
  return null == r4 && null != l.vnode && l.vnode(f4), f4;
}
function g(n3) {
  return n3.children;
}
function b(n3, l4) {
  this.props = n3, this.context = l4;
}
function m(n3, l4) {
  if (null == l4)
    return n3.__ ? m(n3.__, n3.__i + 1) : null;
  for (var u4; l4 < n3.__k.length; l4++)
    if (null != (u4 = n3.__k[l4]) && null != u4.__e)
      return u4.__e;
  return "function" == typeof n3.type ? m(n3) : null;
}
function w(n3, u4, t4) {
  var i4, o4 = n3.__v, r4 = o4.__e, f4 = n3.__P;
  if (f4)
    return (i4 = v({}, o4)).__v = o4.__v + 1, l.vnode && l.vnode(i4), M(f4, i4, o4, n3.__n, void 0 !== f4.ownerSVGElement, 32 & o4.__u ? [r4] : null, u4, null == r4 ? m(o4) : r4, !!(32 & o4.__u), t4), i4.__v = o4.__v, i4.__.__k[i4.__i] = i4, i4.__d = void 0, i4.__e != r4 && k(i4), i4;
}
function k(n3) {
  var l4, u4;
  if (null != (n3 = n3.__) && null != n3.__c) {
    for (n3.__e = n3.__c.base = null, l4 = 0; l4 < n3.__k.length; l4++)
      if (null != (u4 = n3.__k[l4]) && null != u4.__e) {
        n3.__e = n3.__c.base = u4.__e;
        break;
      }
    return k(n3);
  }
}
function x(n3) {
  (!n3.__d && (n3.__d = true) && i.push(n3) && !C.__r++ || o !== l.debounceRendering) && ((o = l.debounceRendering) || r)(C);
}
function C() {
  var n3, u4, t4, o4 = [], r4 = [];
  for (i.sort(f); n3 = i.shift(); )
    n3.__d && (t4 = i.length, u4 = w(n3, o4, r4) || u4, 0 === t4 || i.length > t4 ? (j(o4, u4, r4), r4.length = o4.length = 0, u4 = void 0, i.sort(f)) : u4 && l.__c && l.__c(u4, s));
  u4 && j(o4, u4, r4), C.__r = 0;
}
function P(n3, l4, u4, t4, i4, o4, r4, f4, e4, a4, h11) {
  var v4, p4, y4, d4, _4, g3 = t4 && t4.__k || s, b3 = l4.length;
  for (u4.__d = e4, S(u4, l4, g3), e4 = u4.__d, v4 = 0; v4 < b3; v4++)
    null != (y4 = u4.__k[v4]) && "boolean" != typeof y4 && "function" != typeof y4 && (p4 = -1 === y4.__i ? c : g3[y4.__i] || c, y4.__i = v4, M(n3, y4, p4, i4, o4, r4, f4, e4, a4, h11), d4 = y4.__e, y4.ref && p4.ref != y4.ref && (p4.ref && N(p4.ref, null, y4), h11.push(y4.ref, y4.__c || d4, y4)), null == _4 && null != d4 && (_4 = d4), 65536 & y4.__u || p4.__k === y4.__k ? e4 = $(y4, e4, n3) : "function" == typeof y4.type && void 0 !== y4.__d ? e4 = y4.__d : d4 && (e4 = d4.nextSibling), y4.__d = void 0, y4.__u &= -196609);
  u4.__d = e4, u4.__e = _4;
}
function S(n3, l4, u4) {
  var t4, i4, o4, r4, f4, e4 = l4.length, c4 = u4.length, s4 = c4, a4 = 0;
  for (n3.__k = [], t4 = 0; t4 < e4; t4++)
    r4 = t4 + a4, null != (i4 = n3.__k[t4] = null == (i4 = l4[t4]) || "boolean" == typeof i4 || "function" == typeof i4 ? null : "string" == typeof i4 || "number" == typeof i4 || "bigint" == typeof i4 || i4.constructor == String ? d(null, i4, null, null, null) : h3(i4) ? d(g, { children: i4 }, null, null, null) : void 0 === i4.constructor && i4.__b > 0 ? d(i4.type, i4.props, i4.key, i4.ref ? i4.ref : null, i4.__v) : i4) ? (i4.__ = n3, i4.__b = n3.__b + 1, f4 = I(i4, u4, r4, s4), i4.__i = f4, o4 = null, -1 !== f4 && (s4--, (o4 = u4[f4]) && (o4.__u |= 131072)), null == o4 || null === o4.__v ? (-1 == f4 && a4--, "function" != typeof i4.type && (i4.__u |= 65536)) : f4 !== r4 && (f4 === r4 + 1 ? a4++ : f4 > r4 ? s4 > e4 - r4 ? a4 += f4 - r4 : a4-- : f4 < r4 ? f4 == r4 - 1 && (a4 = f4 - r4) : a4 = 0, f4 !== t4 + a4 && (i4.__u |= 65536))) : (o4 = u4[r4]) && null == o4.key && o4.__e && 0 == (131072 & o4.__u) && (o4.__e == n3.__d && (n3.__d = m(o4)), O(o4, o4, false), u4[r4] = null, s4--);
  if (s4)
    for (t4 = 0; t4 < c4; t4++)
      null != (o4 = u4[t4]) && 0 == (131072 & o4.__u) && (o4.__e == n3.__d && (n3.__d = m(o4)), O(o4, o4));
}
function $(n3, l4, u4) {
  var t4, i4;
  if ("function" == typeof n3.type) {
    for (t4 = n3.__k, i4 = 0; t4 && i4 < t4.length; i4++)
      t4[i4] && (t4[i4].__ = n3, l4 = $(t4[i4], l4, u4));
    return l4;
  }
  n3.__e != l4 && (u4.insertBefore(n3.__e, l4 || null), l4 = n3.__e);
  do {
    l4 = l4 && l4.nextSibling;
  } while (null != l4 && 8 === l4.nodeType);
  return l4;
}
function I(n3, l4, u4, t4) {
  var i4 = n3.key, o4 = n3.type, r4 = u4 - 1, f4 = u4 + 1, e4 = l4[u4];
  if (null === e4 || e4 && i4 == e4.key && o4 === e4.type && 0 == (131072 & e4.__u))
    return u4;
  if (t4 > (null != e4 && 0 == (131072 & e4.__u) ? 1 : 0))
    for (; r4 >= 0 || f4 < l4.length; ) {
      if (r4 >= 0) {
        if ((e4 = l4[r4]) && 0 == (131072 & e4.__u) && i4 == e4.key && o4 === e4.type)
          return r4;
        r4--;
      }
      if (f4 < l4.length) {
        if ((e4 = l4[f4]) && 0 == (131072 & e4.__u) && i4 == e4.key && o4 === e4.type)
          return f4;
        f4++;
      }
    }
  return -1;
}
function T(n3, l4, u4) {
  "-" === l4[0] ? n3.setProperty(l4, null == u4 ? "" : u4) : n3[l4] = null == u4 ? "" : "number" != typeof u4 || a.test(l4) ? u4 : u4 + "px";
}
function A(n3, l4, u4, t4, i4) {
  var o4;
  n:
    if ("style" === l4)
      if ("string" == typeof u4)
        n3.style.cssText = u4;
      else {
        if ("string" == typeof t4 && (n3.style.cssText = t4 = ""), t4)
          for (l4 in t4)
            u4 && l4 in u4 || T(n3.style, l4, "");
        if (u4)
          for (l4 in u4)
            t4 && u4[l4] === t4[l4] || T(n3.style, l4, u4[l4]);
      }
    else if ("o" === l4[0] && "n" === l4[1])
      o4 = l4 !== (l4 = l4.replace(/(PointerCapture)$|Capture$/i, "$1")), l4 = l4.toLowerCase() in n3 ? l4.toLowerCase().slice(2) : l4.slice(2), n3.l || (n3.l = {}), n3.l[l4 + o4] = u4, u4 ? t4 ? u4.u = t4.u : (u4.u = Date.now(), n3.addEventListener(l4, o4 ? L : D, o4)) : n3.removeEventListener(l4, o4 ? L : D, o4);
    else {
      if (i4)
        l4 = l4.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
      else if ("width" !== l4 && "height" !== l4 && "href" !== l4 && "list" !== l4 && "form" !== l4 && "tabIndex" !== l4 && "download" !== l4 && "rowSpan" !== l4 && "colSpan" !== l4 && "role" !== l4 && l4 in n3)
        try {
          n3[l4] = null == u4 ? "" : u4;
          break n;
        } catch (n4) {
        }
      "function" == typeof u4 || (null == u4 || false === u4 && "-" !== l4[4] ? n3.removeAttribute(l4) : n3.setAttribute(l4, u4));
    }
}
function D(n3) {
  if (this.l) {
    var u4 = this.l[n3.type + false];
    if (n3.t) {
      if (n3.t <= u4.u)
        return;
    } else
      n3.t = Date.now();
    return u4(l.event ? l.event(n3) : n3);
  }
}
function L(n3) {
  if (this.l)
    return this.l[n3.type + true](l.event ? l.event(n3) : n3);
}
function M(n3, u4, t4, i4, o4, r4, f4, e4, c4, s4) {
  var a4, p4, y4, d4, _4, m4, w4, k4, x4, C4, S3, $3, H3, I3, T3, A3 = u4.type;
  if (void 0 !== u4.constructor)
    return null;
  128 & t4.__u && (c4 = !!(32 & t4.__u), r4 = [e4 = u4.__e = t4.__e]), (a4 = l.__b) && a4(u4);
  n:
    if ("function" == typeof A3)
      try {
        if (k4 = u4.props, x4 = (a4 = A3.contextType) && i4[a4.__c], C4 = a4 ? x4 ? x4.props.value : a4.__ : i4, t4.__c ? w4 = (p4 = u4.__c = t4.__c).__ = p4.__E : ("prototype" in A3 && A3.prototype.render ? u4.__c = p4 = new A3(k4, C4) : (u4.__c = p4 = new b(k4, C4), p4.constructor = A3, p4.render = q), x4 && x4.sub(p4), p4.props = k4, p4.state || (p4.state = {}), p4.context = C4, p4.__n = i4, y4 = p4.__d = true, p4.__h = [], p4._sb = []), null == p4.__s && (p4.__s = p4.state), null != A3.getDerivedStateFromProps && (p4.__s == p4.state && (p4.__s = v({}, p4.__s)), v(p4.__s, A3.getDerivedStateFromProps(k4, p4.__s))), d4 = p4.props, _4 = p4.state, p4.__v = u4, y4)
          null == A3.getDerivedStateFromProps && null != p4.componentWillMount && p4.componentWillMount(), null != p4.componentDidMount && p4.__h.push(p4.componentDidMount);
        else {
          if (null == A3.getDerivedStateFromProps && k4 !== d4 && null != p4.componentWillReceiveProps && p4.componentWillReceiveProps(k4, C4), !p4.__e && (null != p4.shouldComponentUpdate && false === p4.shouldComponentUpdate(k4, p4.__s, C4) || u4.__v === t4.__v)) {
            for (u4.__v !== t4.__v && (p4.props = k4, p4.state = p4.__s, p4.__d = false), u4.__e = t4.__e, u4.__k = t4.__k, u4.__k.forEach(function(n4) {
              n4 && (n4.__ = u4);
            }), S3 = 0; S3 < p4._sb.length; S3++)
              p4.__h.push(p4._sb[S3]);
            p4._sb = [], p4.__h.length && f4.push(p4);
            break n;
          }
          null != p4.componentWillUpdate && p4.componentWillUpdate(k4, p4.__s, C4), null != p4.componentDidUpdate && p4.__h.push(function() {
            p4.componentDidUpdate(d4, _4, m4);
          });
        }
        if (p4.context = C4, p4.props = k4, p4.__P = n3, p4.__e = false, $3 = l.__r, H3 = 0, "prototype" in A3 && A3.prototype.render) {
          for (p4.state = p4.__s, p4.__d = false, $3 && $3(u4), a4 = p4.render(p4.props, p4.state, p4.context), I3 = 0; I3 < p4._sb.length; I3++)
            p4.__h.push(p4._sb[I3]);
          p4._sb = [];
        } else
          do {
            p4.__d = false, $3 && $3(u4), a4 = p4.render(p4.props, p4.state, p4.context), p4.state = p4.__s;
          } while (p4.__d && ++H3 < 25);
        p4.state = p4.__s, null != p4.getChildContext && (i4 = v(v({}, i4), p4.getChildContext())), y4 || null == p4.getSnapshotBeforeUpdate || (m4 = p4.getSnapshotBeforeUpdate(d4, _4)), P(n3, h3(T3 = null != a4 && a4.type === g && null == a4.key ? a4.props.children : a4) ? T3 : [T3], u4, t4, i4, o4, r4, f4, e4, c4, s4), p4.base = u4.__e, u4.__u &= -161, p4.__h.length && f4.push(p4), w4 && (p4.__E = p4.__ = null);
      } catch (n4) {
        u4.__v = null, c4 || null != r4 ? (u4.__e = e4, u4.__u |= c4 ? 160 : 32, r4[r4.indexOf(e4)] = null) : (u4.__e = t4.__e, u4.__k = t4.__k), l.__e(n4, u4, t4);
      }
    else
      null == r4 && u4.__v === t4.__v ? (u4.__k = t4.__k, u4.__e = t4.__e) : u4.__e = z2(t4.__e, u4, t4, i4, o4, r4, f4, c4, s4);
  (a4 = l.diffed) && a4(u4);
}
function j(n3, u4, t4) {
  for (var i4 = 0; i4 < t4.length; i4++)
    N(t4[i4], t4[++i4], t4[++i4]);
  l.__c && l.__c(u4, n3), n3.some(function(u5) {
    try {
      n3 = u5.__h, u5.__h = [], n3.some(function(n4) {
        n4.call(u5);
      });
    } catch (n4) {
      l.__e(n4, u5.__v);
    }
  });
}
function z2(l4, u4, t4, i4, o4, r4, f4, e4, s4) {
  var a4, v4, y4, d4, _4, g3, b3, w4 = t4.props, k4 = u4.props, x4 = u4.type;
  if ("svg" === x4 && (o4 = true), null != r4) {
    for (a4 = 0; a4 < r4.length; a4++)
      if ((_4 = r4[a4]) && "setAttribute" in _4 == !!x4 && (x4 ? _4.localName === x4 : 3 === _4.nodeType)) {
        l4 = _4, r4[a4] = null;
        break;
      }
  }
  if (null == l4) {
    if (null === x4)
      return document.createTextNode(k4);
    l4 = o4 ? document.createElementNS("http://www.w3.org/2000/svg", x4) : document.createElement(x4, k4.is && k4), r4 = null, e4 = false;
  }
  if (null === x4)
    w4 === k4 || e4 && l4.data === k4 || (l4.data = k4);
  else {
    if (r4 = r4 && n.call(l4.childNodes), w4 = t4.props || c, !e4 && null != r4)
      for (w4 = {}, a4 = 0; a4 < l4.attributes.length; a4++)
        w4[(_4 = l4.attributes[a4]).name] = _4.value;
    for (a4 in w4)
      _4 = w4[a4], "children" == a4 || ("dangerouslySetInnerHTML" == a4 ? y4 = _4 : "key" === a4 || a4 in k4 || A(l4, a4, null, _4, o4));
    for (a4 in k4)
      _4 = k4[a4], "children" == a4 ? d4 = _4 : "dangerouslySetInnerHTML" == a4 ? v4 = _4 : "value" == a4 ? g3 = _4 : "checked" == a4 ? b3 = _4 : "key" === a4 || e4 && "function" != typeof _4 || w4[a4] === _4 || A(l4, a4, _4, w4[a4], o4);
    if (v4)
      e4 || y4 && (v4.__html === y4.__html || v4.__html === l4.innerHTML) || (l4.innerHTML = v4.__html), u4.__k = [];
    else if (y4 && (l4.innerHTML = ""), P(l4, h3(d4) ? d4 : [d4], u4, t4, i4, o4 && "foreignObject" !== x4, r4, f4, r4 ? r4[0] : t4.__k && m(t4, 0), e4, s4), null != r4)
      for (a4 = r4.length; a4--; )
        null != r4[a4] && p(r4[a4]);
    e4 || (a4 = "value", void 0 !== g3 && (g3 !== l4[a4] || "progress" === x4 && !g3 || "option" === x4 && g3 !== w4[a4]) && A(l4, a4, g3, w4[a4], false), a4 = "checked", void 0 !== b3 && b3 !== l4[a4] && A(l4, a4, b3, w4[a4], false));
  }
  return l4;
}
function N(n3, u4, t4) {
  try {
    "function" == typeof n3 ? n3(u4) : n3.current = u4;
  } catch (n4) {
    l.__e(n4, t4);
  }
}
function O(n3, u4, t4) {
  var i4, o4;
  if (l.unmount && l.unmount(n3), (i4 = n3.ref) && (i4.current && i4.current !== n3.__e || N(i4, null, u4)), null != (i4 = n3.__c)) {
    if (i4.componentWillUnmount)
      try {
        i4.componentWillUnmount();
      } catch (n4) {
        l.__e(n4, u4);
      }
    i4.base = i4.__P = null, n3.__c = void 0;
  }
  if (i4 = n3.__k)
    for (o4 = 0; o4 < i4.length; o4++)
      i4[o4] && O(i4[o4], u4, t4 || "function" != typeof n3.type);
  t4 || null == n3.__e || p(n3.__e), n3.__ = n3.__e = n3.__d = void 0;
}
function q(n3, l4, u4) {
  return this.constructor(n3, u4);
}
n = s.slice, l = { __e: function(n3, l4, u4, t4) {
  for (var i4, o4, r4; l4 = l4.__; )
    if ((i4 = l4.__c) && !i4.__)
      try {
        if ((o4 = i4.constructor) && null != o4.getDerivedStateFromError && (i4.setState(o4.getDerivedStateFromError(n3)), r4 = i4.__d), null != i4.componentDidCatch && (i4.componentDidCatch(n3, t4 || {}), r4 = i4.__d), r4)
          return i4.__E = i4;
      } catch (l5) {
        n3 = l5;
      }
  throw n3;
} }, u = 0, t = function(n3) {
  return null != n3 && null == n3.constructor;
}, b.prototype.setState = function(n3, l4) {
  var u4;
  u4 = null != this.__s && this.__s !== this.state ? this.__s : this.__s = v({}, this.state), "function" == typeof n3 && (n3 = n3(v({}, u4), this.props)), n3 && v(u4, n3), null != n3 && this.__v && (l4 && this._sb.push(l4), x(this));
}, b.prototype.forceUpdate = function(n3) {
  this.__v && (this.__e = true, n3 && this.__h.push(n3), x(this));
}, b.prototype.render = g, i = [], r = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, f = function(n3, l4) {
  return n3.__v.__b - l4.__v.__b;
}, C.__r = 0, e = 0;

// ../../node_modules/@uppy/drag-drop/lib/locale.js
var locale_default2 = {
  strings: {
    // Text to show on the droppable area.
    // `%{browse}` is replaced with a link that opens the system file selection dialog.
    dropHereOr: "Drop here or %{browse}",
    // Used as the label for the link that opens the system file selection dialog.
    browse: "browse"
  }
};

// ../../node_modules/@uppy/drag-drop/lib/DragDrop.js
var packageJson4 = {
  "version": "3.0.3"
};
var DragDrop = class _DragDrop2 extends UIPlugin {
  constructor(uppy3, opts) {
    super(uppy3, opts);
    this.handleDrop = async (event) => {
      var _this$opts$onDrop, _this$opts;
      event.preventDefault();
      event.stopPropagation();
      clearTimeout(this.removeDragOverClassTimeout);
      this.setPluginState({
        isDraggingOver: false
      });
      const logDropError = (error) => {
        this.uppy.log(error, "error");
      };
      const files = await getDroppedFiles(event.dataTransfer, {
        logDropError
      });
      if (files.length > 0) {
        this.uppy.log("[DragDrop] Files dropped");
        this.addFiles(files);
      }
      (_this$opts$onDrop = (_this$opts = this.opts).onDrop) == null ? void 0 : _this$opts$onDrop.call(_this$opts, event);
    };
    this.type = "acquirer";
    this.id = this.opts.id || "DragDrop";
    this.title = "Drag & Drop";
    this.defaultLocale = locale_default2;
    const defaultOpts = {
      target: null,
      inputName: "files[]",
      width: "100%",
      height: "100%",
      note: null
    };
    this.opts = {
      ...defaultOpts,
      ...opts
    };
    this.i18nInit();
    this.isDragDropSupported = isDragDropSupported();
    this.removeDragOverClassTimeout = null;
    this.onInputChange = this.onInputChange.bind(this);
    this.handleDragOver = this.handleDragOver.bind(this);
    this.handleDragLeave = this.handleDragLeave.bind(this);
    this.handleDrop = this.handleDrop.bind(this);
    this.addFiles = this.addFiles.bind(this);
    this.render = this.render.bind(this);
  }
  addFiles(files) {
    const descriptors = files.map((file) => ({
      source: this.id,
      name: file.name,
      type: file.type,
      data: file,
      meta: {
        // path of the file relative to the ancestor directory the user selected.
        // e.g. 'docs/Old Prague/airbnb.pdf'
        relativePath: file.relativePath || null
      }
    }));
    try {
      this.uppy.addFiles(descriptors);
    } catch (err) {
      this.uppy.log(err);
    }
  }
  onInputChange(event) {
    const files = toArray_default(event.target.files);
    if (files.length > 0) {
      this.uppy.log("[DragDrop] Files selected through input");
      this.addFiles(files);
    }
    event.target.value = null;
  }
  handleDragOver(event) {
    var _this$opts$onDragOver, _this$opts2;
    event.preventDefault();
    event.stopPropagation();
    const {
      types: types2
    } = event.dataTransfer;
    const hasFiles = types2.some((type) => type === "Files");
    const {
      allowNewUpload
    } = this.uppy.getState();
    if (!hasFiles || !allowNewUpload) {
      event.dataTransfer.dropEffect = "none";
      clearTimeout(this.removeDragOverClassTimeout);
      return;
    }
    event.dataTransfer.dropEffect = "copy";
    clearTimeout(this.removeDragOverClassTimeout);
    this.setPluginState({
      isDraggingOver: true
    });
    (_this$opts$onDragOver = (_this$opts2 = this.opts).onDragOver) == null ? void 0 : _this$opts$onDragOver.call(_this$opts2, event);
  }
  handleDragLeave(event) {
    var _this$opts$onDragLeav, _this$opts3;
    event.preventDefault();
    event.stopPropagation();
    clearTimeout(this.removeDragOverClassTimeout);
    this.removeDragOverClassTimeout = setTimeout(() => {
      this.setPluginState({
        isDraggingOver: false
      });
    }, 50);
    (_this$opts$onDragLeav = (_this$opts3 = this.opts).onDragLeave) == null ? void 0 : _this$opts$onDragLeav.call(_this$opts3, event);
  }
  renderHiddenFileInput() {
    const {
      restrictions
    } = this.uppy.opts;
    return y("input", {
      className: "uppy-DragDrop-input",
      type: "file",
      hidden: true,
      ref: (ref) => {
        this.fileInputRef = ref;
      },
      name: this.opts.inputName,
      multiple: restrictions.maxNumberOfFiles !== 1,
      accept: restrictions.allowedFileTypes,
      onChange: this.onInputChange
    });
  }
  static renderArrowSvg() {
    return y("svg", {
      "aria-hidden": "true",
      focusable: "false",
      className: "uppy-c-icon uppy-DragDrop-arrow",
      width: "16",
      height: "16",
      viewBox: "0 0 16 16"
    }, y("path", {
      d: "M11 10V0H5v10H2l6 6 6-6h-3zm0 0",
      fillRule: "evenodd"
    }));
  }
  renderLabel() {
    return y("div", {
      className: "uppy-DragDrop-label"
    }, this.i18nArray("dropHereOr", {
      browse: y("span", {
        className: "uppy-DragDrop-browse"
      }, this.i18n("browse"))
    }));
  }
  renderNote() {
    return y("span", {
      className: "uppy-DragDrop-note"
    }, this.opts.note);
  }
  render() {
    const dragDropClass = `uppy-u-reset
      uppy-DragDrop-container
      ${this.isDragDropSupported ? "uppy-DragDrop--isDragDropSupported" : ""}
      ${this.getPluginState().isDraggingOver ? "uppy-DragDrop--isDraggingOver" : ""}
    `;
    const dragDropStyle = {
      width: this.opts.width,
      height: this.opts.height
    };
    return y("button", {
      type: "button",
      className: dragDropClass,
      style: dragDropStyle,
      onClick: () => this.fileInputRef.click(),
      onDragOver: this.handleDragOver,
      onDragLeave: this.handleDragLeave,
      onDrop: this.handleDrop
    }, this.renderHiddenFileInput(), y("div", {
      className: "uppy-DragDrop-inner"
    }, _DragDrop2.renderArrowSvg(), this.renderLabel(), this.renderNote()));
  }
  install() {
    const {
      target
    } = this.opts;
    this.setPluginState({
      isDraggingOver: false
    });
    if (target) {
      this.mount(target, this);
    }
  }
  uninstall() {
    this.unmount();
  }
};
DragDrop.VERSION = packageJson4.version;

// ../../node_modules/@uppy/react/lib/DragDrop.js
var DragDrop2 = class extends Component3 {
  componentDidMount() {
    this.installPlugin();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.uppy !== this.props.uppy) {
      this.uninstallPlugin(prevProps);
      this.installPlugin();
    } else if (nonHtmlPropsHaveChanged(this.props, prevProps)) {
      const options7 = {
        ...this.props,
        target: this.container
      };
      delete options7.uppy;
      this.plugin.setOptions(options7);
    }
  }
  componentWillUnmount() {
    this.uninstallPlugin();
  }
  installPlugin() {
    const {
      uppy: uppy3,
      locale: locale3,
      inputName,
      width,
      height,
      note
    } = this.props;
    const options7 = {
      id: "react:DragDrop",
      locale: locale3,
      inputName,
      width,
      height,
      note,
      target: this.container
    };
    delete options7.uppy;
    uppy3.use(DragDrop, options7);
    this.plugin = uppy3.getPlugin(options7.id);
  }
  uninstallPlugin(props) {
    if (props === void 0) {
      props = this.props;
    }
    const {
      uppy: uppy3
    } = props;
    uppy3.removePlugin(this.plugin);
  }
  render() {
    return h4("div", {
      className: "uppy-Container",
      ref: (container) => {
        this.container = container;
      },
      ...getHTMLProps_default(this.props)
    });
  }
};
DragDrop2.propTypes = {
  uppy: uppy.isRequired,
  locale,
  inputName: import_prop_types3.default.string,
  width: import_prop_types3.default.string,
  height: import_prop_types3.default.string,
  note: import_prop_types3.default.string
};
DragDrop2.defaultProps = {
  locale: null,
  inputName: "files[]",
  width: "100%",
  height: "100%",
  note: null
};

// ../../node_modules/@uppy/react/lib/ProgressBar.js
var import_prop_types4 = __toESM(require_prop_types(), 1);
import { createElement as h5, Component as Component4 } from "react";

// ../../node_modules/@uppy/progress-bar/lib/ProgressBar.js
import { UIPlugin as UIPlugin2 } from "@uppy/core";
var packageJson5 = {
  "version": "3.1.0"
};
var defaultOptions2 = {
  target: "body",
  fixed: false,
  hideAfterFinish: true
};
var ProgressBar = class extends UIPlugin2 {
  constructor(uppy3, opts) {
    super(uppy3, {
      ...defaultOptions2,
      ...opts
    });
    this.id = this.opts.id || "ProgressBar";
    this.title = "Progress Bar";
    this.type = "progressindicator";
    this.render = this.render.bind(this);
  }
  render(state) {
    const progress2 = state.totalProgress || 0;
    const isHidden = (progress2 === 0 || progress2 === 100) && this.opts.hideAfterFinish;
    return y("div", {
      className: "uppy uppy-ProgressBar",
      style: {
        position: this.opts.fixed ? "fixed" : "initial"
      },
      "aria-hidden": isHidden
    }, y("div", {
      className: "uppy-ProgressBar-inner",
      style: {
        width: `${progress2}%`
      }
    }), y("div", {
      className: "uppy-ProgressBar-percentage"
    }, progress2));
  }
  install() {
    const {
      target
    } = this.opts;
    if (target) {
      this.mount(target, this);
    }
  }
  uninstall() {
    this.unmount();
  }
};
ProgressBar.VERSION = packageJson5.version;

// ../../node_modules/@uppy/react/lib/ProgressBar.js
var ProgressBar2 = class extends Component4 {
  componentDidMount() {
    this.installPlugin();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.uppy !== this.props.uppy) {
      this.uninstallPlugin(prevProps);
      this.installPlugin();
    } else if (nonHtmlPropsHaveChanged(this.props, prevProps)) {
      const options7 = {
        ...this.props,
        target: this.container
      };
      delete options7.uppy;
      this.plugin.setOptions(options7);
    }
  }
  componentWillUnmount() {
    this.uninstallPlugin();
  }
  installPlugin() {
    const {
      uppy: uppy3,
      fixed,
      hideAfterFinish
    } = this.props;
    const options7 = {
      id: "react:ProgressBar",
      fixed,
      hideAfterFinish,
      target: this.container
    };
    delete options7.uppy;
    uppy3.use(ProgressBar, options7);
    this.plugin = uppy3.getPlugin(options7.id);
  }
  uninstallPlugin(props) {
    if (props === void 0) {
      props = this.props;
    }
    const {
      uppy: uppy3
    } = props;
    uppy3.removePlugin(this.plugin);
  }
  render() {
    return h5("div", {
      className: "uppy-Container",
      ref: (container) => {
        this.container = container;
      },
      ...getHTMLProps_default(this.props)
    });
  }
};
ProgressBar2.propTypes = {
  uppy: uppy.isRequired,
  fixed: import_prop_types4.default.bool,
  hideAfterFinish: import_prop_types4.default.bool
};
ProgressBar2.defaultProps = {
  fixed: false,
  hideAfterFinish: true
};

// ../../node_modules/@uppy/react/lib/StatusBar.js
var import_prop_types5 = __toESM(require_prop_types(), 1);
import { createElement as h6, Component as Component5 } from "react";

// ../../node_modules/@uppy/status-bar/lib/StatusBar.js
import { UIPlugin as UIPlugin3 } from "@uppy/core";

// ../../node_modules/@uppy/utils/lib/emaFilter.js
function emaFilter(newValue, previousSmoothedValue, halfLife, dt) {
  if (halfLife === 0 || newValue === previousSmoothedValue)
    return newValue;
  if (dt === 0)
    return previousSmoothedValue;
  return newValue + (previousSmoothedValue - newValue) * 2 ** (-dt / halfLife);
}

// ../../node_modules/@uppy/utils/lib/getTextDirection.js
function getTextDirection(element) {
  var _element;
  while (element && !element.dir) {
    element = element.parentNode;
  }
  return (_element = element) == null ? void 0 : _element.dir;
}
var getTextDirection_default = getTextDirection;

// ../../node_modules/@uppy/status-bar/lib/StatusBarStates.js
var StatusBarStates_default = {
  STATE_ERROR: "error",
  STATE_WAITING: "waiting",
  STATE_PREPROCESSING: "preprocessing",
  STATE_UPLOADING: "uploading",
  STATE_POSTPROCESSING: "postprocessing",
  STATE_COMPLETE: "complete"
};

// ../../node_modules/@uppy/status-bar/lib/StatusBarUI.js
var import_classnames2 = __toESM(require_classnames(), 1);

// ../../node_modules/@uppy/status-bar/lib/calculateProcessingProgress.js
function calculateProcessingProgress(files) {
  const values = [];
  let mode = "indeterminate";
  let message;
  for (const {
    progress: progress2
  } of Object.values(files)) {
    const {
      preprocess,
      postprocess
    } = progress2;
    if (message == null && (preprocess || postprocess)) {
      ;
      ({
        mode,
        message
      } = preprocess || postprocess);
    }
    if ((preprocess == null ? void 0 : preprocess.mode) === "determinate")
      values.push(preprocess.value);
    if ((postprocess == null ? void 0 : postprocess.mode) === "determinate")
      values.push(postprocess.value);
  }
  const value = values.reduce((total, progressValue) => {
    return total + progressValue / values.length;
  }, 0);
  return {
    mode,
    message,
    value
  };
}

// ../../node_modules/@uppy/status-bar/lib/Components.js
var import_classnames = __toESM(require_classnames(), 1);
var import_prettier_bytes = __toESM(require_prettierBytes(), 1);

// ../../node_modules/@uppy/utils/lib/secondsToTime.js
function secondsToTime(rawSeconds) {
  const hours = Math.floor(rawSeconds / 3600) % 24;
  const minutes = Math.floor(rawSeconds / 60) % 60;
  const seconds = Math.floor(rawSeconds % 60);
  return {
    hours,
    minutes,
    seconds
  };
}

// ../../node_modules/@uppy/utils/lib/prettyETA.js
function prettyETA(seconds) {
  const time = secondsToTime(seconds);
  const hoursStr = time.hours === 0 ? "" : `${time.hours}h`;
  const minutesStr = time.minutes === 0 ? "" : `${time.hours === 0 ? time.minutes : ` ${time.minutes.toString(10).padStart(2, "0")}`}m`;
  const secondsStr = time.hours !== 0 ? "" : `${time.minutes === 0 ? time.seconds : ` ${time.seconds.toString(10).padStart(2, "0")}`}s`;
  return `${hoursStr}${minutesStr}${secondsStr}`;
}

// ../../node_modules/@uppy/status-bar/lib/Components.js
var DOT = `\xB7`;
var renderDot = () => ` ${DOT} `;
function UploadBtn(props) {
  const {
    newFiles,
    isUploadStarted,
    recoveredState,
    i18n,
    uploadState,
    isSomeGhost,
    startUpload
  } = props;
  const uploadBtnClassNames = (0, import_classnames.default)("uppy-u-reset", "uppy-c-btn", "uppy-StatusBar-actionBtn", "uppy-StatusBar-actionBtn--upload", {
    "uppy-c-btn-primary": uploadState === StatusBarStates_default.STATE_WAITING
  }, {
    "uppy-StatusBar-actionBtn--disabled": isSomeGhost
  });
  const uploadBtnText = newFiles && isUploadStarted && !recoveredState ? i18n("uploadXNewFiles", {
    smart_count: newFiles
  }) : i18n("uploadXFiles", {
    smart_count: newFiles
  });
  return y("button", {
    type: "button",
    className: uploadBtnClassNames,
    "aria-label": i18n("uploadXFiles", {
      smart_count: newFiles
    }),
    onClick: startUpload,
    disabled: isSomeGhost,
    "data-uppy-super-focusable": true
  }, uploadBtnText);
}
function RetryBtn(props) {
  const {
    i18n,
    uppy: uppy3
  } = props;
  return y("button", {
    type: "button",
    className: "uppy-u-reset uppy-c-btn uppy-StatusBar-actionBtn uppy-StatusBar-actionBtn--retry",
    "aria-label": i18n("retryUpload"),
    onClick: () => uppy3.retryAll().catch(() => {
    }),
    "data-uppy-super-focusable": true,
    "data-cy": "retry"
  }, y("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    width: "8",
    height: "10",
    viewBox: "0 0 8 10"
  }, y("path", {
    d: "M4 2.408a2.75 2.75 0 1 0 2.75 2.75.626.626 0 0 1 1.25.018v.023a4 4 0 1 1-4-4.041V.25a.25.25 0 0 1 .389-.208l2.299 1.533a.25.25 0 0 1 0 .416l-2.3 1.533A.25.25 0 0 1 4 3.316v-.908z"
  })), i18n("retry"));
}
function CancelBtn(props) {
  const {
    i18n,
    uppy: uppy3
  } = props;
  return y("button", {
    type: "button",
    className: "uppy-u-reset uppy-StatusBar-actionCircleBtn",
    title: i18n("cancel"),
    "aria-label": i18n("cancel"),
    onClick: () => uppy3.cancelAll(),
    "data-cy": "cancel",
    "data-uppy-super-focusable": true
  }, y("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16"
  }, y("g", {
    fill: "none",
    fillRule: "evenodd"
  }, y("circle", {
    fill: "#888",
    cx: "8",
    cy: "8",
    r: "8"
  }), y("path", {
    fill: "#FFF",
    d: "M9.283 8l2.567 2.567-1.283 1.283L8 9.283 5.433 11.85 4.15 10.567 6.717 8 4.15 5.433 5.433 4.15 8 6.717l2.567-2.567 1.283 1.283z"
  }))));
}
function PauseResumeButton(props) {
  const {
    isAllPaused,
    i18n,
    isAllComplete,
    resumableUploads,
    uppy: uppy3
  } = props;
  const title = isAllPaused ? i18n("resume") : i18n("pause");
  function togglePauseResume() {
    if (isAllComplete)
      return;
    if (!resumableUploads) {
      uppy3.cancelAll();
      return;
    }
    if (isAllPaused) {
      uppy3.resumeAll();
      return;
    }
    uppy3.pauseAll();
  }
  return y("button", {
    title,
    "aria-label": title,
    className: "uppy-u-reset uppy-StatusBar-actionCircleBtn",
    type: "button",
    onClick: togglePauseResume,
    "data-cy": "togglePauseResume",
    "data-uppy-super-focusable": true
  }, y("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16"
  }, y("g", {
    fill: "none",
    fillRule: "evenodd"
  }, y("circle", {
    fill: "#888",
    cx: "8",
    cy: "8",
    r: "8"
  }), y("path", {
    fill: "#FFF",
    d: isAllPaused ? "M6 4.25L11.5 8 6 11.75z" : "M5 4.5h2v7H5v-7zm4 0h2v7H9v-7z"
  }))));
}
function DoneBtn(props) {
  const {
    i18n,
    doneButtonHandler
  } = props;
  return y("button", {
    type: "button",
    className: "uppy-u-reset uppy-c-btn uppy-StatusBar-actionBtn uppy-StatusBar-actionBtn--done",
    onClick: doneButtonHandler,
    "data-uppy-super-focusable": true
  }, i18n("done"));
}
function LoadingSpinner() {
  return y("svg", {
    className: "uppy-StatusBar-spinner",
    "aria-hidden": "true",
    focusable: "false",
    width: "14",
    height: "14"
  }, y("path", {
    d: "M13.983 6.547c-.12-2.509-1.64-4.893-3.939-5.936-2.48-1.127-5.488-.656-7.556 1.094C.524 3.367-.398 6.048.162 8.562c.556 2.495 2.46 4.52 4.94 5.183 2.932.784 5.61-.602 7.256-3.015-1.493 1.993-3.745 3.309-6.298 2.868-2.514-.434-4.578-2.349-5.153-4.84a6.226 6.226 0 0 1 2.98-6.778C6.34.586 9.74 1.1 11.373 3.493c.407.596.693 1.282.842 1.988.127.598.073 1.197.161 1.794.078.525.543 1.257 1.15.864.525-.341.49-1.05.456-1.592-.007-.15.02.3 0 0",
    fillRule: "evenodd"
  }));
}
function ProgressBarProcessing(props) {
  const {
    progress: progress2
  } = props;
  const {
    value,
    mode,
    message
  } = progress2;
  const dot = `\xB7`;
  return y("div", {
    className: "uppy-StatusBar-content"
  }, y(LoadingSpinner, null), mode === "determinate" ? `${Math.round(value * 100)}% ${dot} ` : "", message);
}
function ProgressDetails(props) {
  const {
    numUploads,
    complete,
    totalUploadedSize,
    totalSize,
    totalETA,
    i18n
  } = props;
  const ifShowFilesUploadedOfTotal = numUploads > 1;
  return y("div", {
    className: "uppy-StatusBar-statusSecondary"
  }, ifShowFilesUploadedOfTotal && i18n("filesUploadedOfTotal", {
    complete,
    smart_count: numUploads
  }), y("span", {
    className: "uppy-StatusBar-additionalInfo"
  }, ifShowFilesUploadedOfTotal && renderDot(), i18n("dataUploadedOfTotal", {
    complete: (0, import_prettier_bytes.default)(totalUploadedSize),
    total: (0, import_prettier_bytes.default)(totalSize)
  }), renderDot(), i18n("xTimeLeft", {
    time: prettyETA(totalETA)
  })));
}
function FileUploadCount(props) {
  const {
    i18n,
    complete,
    numUploads
  } = props;
  return y("div", {
    className: "uppy-StatusBar-statusSecondary"
  }, i18n("filesUploadedOfTotal", {
    complete,
    smart_count: numUploads
  }));
}
function UploadNewlyAddedFiles(props) {
  const {
    i18n,
    newFiles,
    startUpload
  } = props;
  const uploadBtnClassNames = (0, import_classnames.default)("uppy-u-reset", "uppy-c-btn", "uppy-StatusBar-actionBtn", "uppy-StatusBar-actionBtn--uploadNewlyAdded");
  return y("div", {
    className: "uppy-StatusBar-statusSecondary"
  }, y("div", {
    className: "uppy-StatusBar-statusSecondaryHint"
  }, i18n("xMoreFilesAdded", {
    smart_count: newFiles
  })), y("button", {
    type: "button",
    className: uploadBtnClassNames,
    "aria-label": i18n("uploadXFiles", {
      smart_count: newFiles
    }),
    onClick: startUpload
  }, i18n("upload")));
}
function ProgressBarUploading(props) {
  const {
    i18n,
    supportsUploadProgress: supportsUploadProgress2,
    totalProgress,
    showProgressDetails,
    isUploadStarted,
    isAllComplete,
    isAllPaused,
    newFiles,
    numUploads,
    complete,
    totalUploadedSize,
    totalSize,
    totalETA,
    startUpload
  } = props;
  const showUploadNewlyAddedFiles = newFiles && isUploadStarted;
  if (!isUploadStarted || isAllComplete) {
    return null;
  }
  const title = isAllPaused ? i18n("paused") : i18n("uploading");
  function renderProgressDetails() {
    if (!isAllPaused && !showUploadNewlyAddedFiles && showProgressDetails) {
      if (supportsUploadProgress2) {
        return y(ProgressDetails, {
          numUploads,
          complete,
          totalUploadedSize,
          totalSize,
          totalETA,
          i18n
        });
      }
      return y(FileUploadCount, {
        i18n,
        complete,
        numUploads
      });
    }
    return null;
  }
  return y("div", {
    className: "uppy-StatusBar-content",
    "aria-label": title,
    title
  }, !isAllPaused ? y(LoadingSpinner, null) : null, y("div", {
    className: "uppy-StatusBar-status"
  }, y("div", {
    className: "uppy-StatusBar-statusPrimary"
  }, supportsUploadProgress2 ? `${title}: ${totalProgress}%` : title), renderProgressDetails(), showUploadNewlyAddedFiles ? y(UploadNewlyAddedFiles, {
    i18n,
    newFiles,
    startUpload
  }) : null));
}
function ProgressBarComplete(props) {
  const {
    i18n
  } = props;
  return y("div", {
    className: "uppy-StatusBar-content",
    role: "status",
    title: i18n("complete")
  }, y("div", {
    className: "uppy-StatusBar-status"
  }, y("div", {
    className: "uppy-StatusBar-statusPrimary"
  }, y("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-StatusBar-statusIndicator uppy-c-icon",
    width: "15",
    height: "11",
    viewBox: "0 0 15 11"
  }, y("path", {
    d: "M.414 5.843L1.627 4.63l3.472 3.472L13.202 0l1.212 1.213L5.1 10.528z"
  })), i18n("complete"))));
}
function ProgressBarError(props) {
  const {
    error,
    i18n,
    complete,
    numUploads
  } = props;
  function displayErrorAlert() {
    const errorMessage = `${i18n("uploadFailed")} 

 ${error}`;
    alert(errorMessage);
  }
  return y("div", {
    className: "uppy-StatusBar-content",
    title: i18n("uploadFailed")
  }, y("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-StatusBar-statusIndicator uppy-c-icon",
    width: "11",
    height: "11",
    viewBox: "0 0 11 11"
  }, y("path", {
    d: "M4.278 5.5L0 1.222 1.222 0 5.5 4.278 9.778 0 11 1.222 6.722 5.5 11 9.778 9.778 11 5.5 6.722 1.222 11 0 9.778z"
  })), y("div", {
    className: "uppy-StatusBar-status"
  }, y("div", {
    className: "uppy-StatusBar-statusPrimary"
  }, i18n("uploadFailed"), y("button", {
    className: "uppy-u-reset uppy-StatusBar-details",
    "aria-label": i18n("showErrorDetails"),
    "data-microtip-position": "top-right",
    "data-microtip-size": "medium",
    onClick: displayErrorAlert,
    type: "button"
  }, "?")), y(FileUploadCount, {
    i18n,
    complete,
    numUploads
  })));
}

// ../../node_modules/@uppy/status-bar/lib/StatusBarUI.js
var {
  STATE_ERROR,
  STATE_WAITING,
  STATE_PREPROCESSING,
  STATE_UPLOADING,
  STATE_POSTPROCESSING,
  STATE_COMPLETE
} = StatusBarStates_default;
function StatusBar(props) {
  const {
    newFiles,
    allowNewUpload,
    isUploadInProgress,
    isAllPaused,
    resumableUploads,
    error,
    hideUploadButton,
    hidePauseResumeButton,
    hideCancelButton,
    hideRetryButton,
    recoveredState,
    uploadState,
    totalProgress,
    files,
    supportsUploadProgress: supportsUploadProgress2,
    hideAfterFinish,
    isSomeGhost,
    doneButtonHandler,
    isUploadStarted,
    i18n,
    startUpload,
    uppy: uppy3,
    isAllComplete,
    showProgressDetails,
    numUploads,
    complete,
    totalSize,
    totalETA,
    totalUploadedSize
  } = props;
  function getProgressValue() {
    switch (uploadState) {
      case STATE_POSTPROCESSING:
      case STATE_PREPROCESSING: {
        const progress2 = calculateProcessingProgress(files);
        if (progress2.mode === "determinate") {
          return progress2.value * 100;
        }
        return totalProgress;
      }
      case STATE_ERROR: {
        return null;
      }
      case STATE_UPLOADING: {
        if (!supportsUploadProgress2) {
          return null;
        }
        return totalProgress;
      }
      default:
        return totalProgress;
    }
  }
  function getIsIndeterminate() {
    switch (uploadState) {
      case STATE_POSTPROCESSING:
      case STATE_PREPROCESSING: {
        const {
          mode
        } = calculateProcessingProgress(files);
        return mode === "indeterminate";
      }
      case STATE_UPLOADING: {
        if (!supportsUploadProgress2) {
          return true;
        }
        return false;
      }
      default:
        return false;
    }
  }
  function getIsHidden() {
    if (recoveredState) {
      return false;
    }
    switch (uploadState) {
      case STATE_WAITING:
        return hideUploadButton || newFiles === 0;
      case STATE_COMPLETE:
        return hideAfterFinish;
      default:
        return false;
    }
  }
  const progressValue = getProgressValue();
  const isHidden = getIsHidden();
  const width = progressValue != null ? progressValue : 100;
  const showUploadBtn = !error && newFiles && !isUploadInProgress && !isAllPaused && allowNewUpload && !hideUploadButton;
  const showCancelBtn = !hideCancelButton && uploadState !== STATE_WAITING && uploadState !== STATE_COMPLETE;
  const showPauseResumeBtn = resumableUploads && !hidePauseResumeButton && uploadState === STATE_UPLOADING;
  const showRetryBtn = error && !isAllComplete && !hideRetryButton;
  const showDoneBtn = doneButtonHandler && uploadState === STATE_COMPLETE;
  const progressClassNames = (0, import_classnames2.default)("uppy-StatusBar-progress", {
    "is-indeterminate": getIsIndeterminate()
  });
  const statusBarClassNames = (0, import_classnames2.default)("uppy-StatusBar", `is-${uploadState}`, {
    "has-ghosts": isSomeGhost
  });
  return y("div", {
    className: statusBarClassNames,
    "aria-hidden": isHidden
  }, y("div", {
    className: progressClassNames,
    style: {
      width: `${width}%`
    },
    role: "progressbar",
    "aria-label": `${width}%`,
    "aria-valuetext": `${width}%`,
    "aria-valuemin": 0,
    "aria-valuemax": 100,
    "aria-valuenow": progressValue
  }), (() => {
    switch (uploadState) {
      case STATE_PREPROCESSING:
      case STATE_POSTPROCESSING:
        return y(ProgressBarProcessing, {
          progress: calculateProcessingProgress(files)
        });
      case STATE_COMPLETE:
        return y(ProgressBarComplete, {
          i18n
        });
      case STATE_ERROR:
        return y(ProgressBarError, {
          error,
          i18n,
          numUploads,
          complete
        });
      case STATE_UPLOADING:
        return y(ProgressBarUploading, {
          i18n,
          supportsUploadProgress: supportsUploadProgress2,
          totalProgress,
          showProgressDetails,
          isUploadStarted,
          isAllComplete,
          isAllPaused,
          newFiles,
          numUploads,
          complete,
          totalUploadedSize,
          totalSize,
          totalETA,
          startUpload
        });
      default:
        return null;
    }
  })(), y("div", {
    className: "uppy-StatusBar-actions"
  }, recoveredState || showUploadBtn ? y(UploadBtn, {
    newFiles,
    isUploadStarted,
    recoveredState,
    i18n,
    isSomeGhost,
    startUpload,
    uploadState
  }) : null, showRetryBtn ? y(RetryBtn, {
    i18n,
    uppy: uppy3
  }) : null, showPauseResumeBtn ? y(PauseResumeButton, {
    isAllPaused,
    i18n,
    isAllComplete,
    resumableUploads,
    uppy: uppy3
  }) : null, showCancelBtn ? y(CancelBtn, {
    i18n,
    uppy: uppy3
  }) : null, showDoneBtn ? y(DoneBtn, {
    i18n,
    doneButtonHandler
  }) : null));
}
StatusBar.defaultProps = {
  doneButtonHandler: void 0,
  hideAfterFinish: false,
  hideCancelButton: false,
  hidePauseResumeButton: false,
  hideRetryButton: false,
  hideUploadButton: void 0,
  showProgressDetails: void 0
};

// ../../node_modules/@uppy/status-bar/lib/locale.js
var locale_default3 = {
  strings: {
    // Shown in the status bar while files are being uploaded.
    uploading: "Uploading",
    // Shown in the status bar once all files have been uploaded.
    complete: "Complete",
    // Shown in the status bar if an upload failed.
    uploadFailed: "Upload failed",
    // Shown in the status bar while the upload is paused.
    paused: "Paused",
    // Used as the label for the button that retries an upload.
    retry: "Retry",
    // Used as the label for the button that cancels an upload.
    cancel: "Cancel",
    // Used as the label for the button that pauses an upload.
    pause: "Pause",
    // Used as the label for the button that resumes an upload.
    resume: "Resume",
    // Used as the label for the button that resets the upload state after an upload
    done: "Done",
    // When `showProgressDetails` is set, shows the number of files that have been fully uploaded so far.
    filesUploadedOfTotal: {
      0: "%{complete} of %{smart_count} file uploaded",
      1: "%{complete} of %{smart_count} files uploaded"
    },
    // When `showProgressDetails` is set, shows the amount of bytes that have been uploaded so far.
    dataUploadedOfTotal: "%{complete} of %{total}",
    // When `showProgressDetails` is set, shows an estimation of how long the upload will take to complete.
    xTimeLeft: "%{time} left",
    // Used as the label for the button that starts an upload.
    uploadXFiles: {
      0: "Upload %{smart_count} file",
      1: "Upload %{smart_count} files"
    },
    // Used as the label for the button that starts an upload, if another upload has been started in the past
    // and new files were added later.
    uploadXNewFiles: {
      0: "Upload +%{smart_count} file",
      1: "Upload +%{smart_count} files"
    },
    upload: "Upload",
    retryUpload: "Retry upload",
    xMoreFilesAdded: {
      0: "%{smart_count} more file added",
      1: "%{smart_count} more files added"
    },
    showErrorDetails: "Show error details"
  }
};

// ../../node_modules/@uppy/status-bar/lib/StatusBar.js
function _classPrivateFieldLooseBase10(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id10 = 0;
function _classPrivateFieldLooseKey10(name) {
  return "__private_" + id10++ + "_" + name;
}
var packageJson6 = {
  "version": "3.3.0"
};
var speedFilterHalfLife = 2e3;
var ETAFilterHalfLife = 2e3;
function getUploadingState(error, isAllComplete, recoveredState, files) {
  if (error) {
    return StatusBarStates_default.STATE_ERROR;
  }
  if (isAllComplete) {
    return StatusBarStates_default.STATE_COMPLETE;
  }
  if (recoveredState) {
    return StatusBarStates_default.STATE_WAITING;
  }
  let state = StatusBarStates_default.STATE_WAITING;
  const fileIDs = Object.keys(files);
  for (let i4 = 0; i4 < fileIDs.length; i4++) {
    const {
      progress: progress2
    } = files[fileIDs[i4]];
    if (progress2.uploadStarted && !progress2.uploadComplete) {
      return StatusBarStates_default.STATE_UPLOADING;
    }
    if (progress2.preprocess) {
      state = StatusBarStates_default.STATE_PREPROCESSING;
    }
    if (progress2.postprocess && state !== StatusBarStates_default.STATE_PREPROCESSING) {
      state = StatusBarStates_default.STATE_POSTPROCESSING;
    }
  }
  return state;
}
var defaultOptions3 = {
  target: "body",
  hideUploadButton: false,
  hideRetryButton: false,
  hidePauseResumeButton: false,
  hideCancelButton: false,
  showProgressDetails: false,
  hideAfterFinish: true,
  doneButtonHandler: null
};
var _lastUpdateTime = /* @__PURE__ */ _classPrivateFieldLooseKey10("lastUpdateTime");
var _previousUploadedBytes = /* @__PURE__ */ _classPrivateFieldLooseKey10("previousUploadedBytes");
var _previousSpeed = /* @__PURE__ */ _classPrivateFieldLooseKey10("previousSpeed");
var _previousETA = /* @__PURE__ */ _classPrivateFieldLooseKey10("previousETA");
var _computeSmoothETA = /* @__PURE__ */ _classPrivateFieldLooseKey10("computeSmoothETA");
var _onUploadStart = /* @__PURE__ */ _classPrivateFieldLooseKey10("onUploadStart");
var StatusBar2 = class extends UIPlugin3 {
  constructor(uppy3, opts) {
    super(uppy3, {
      ...defaultOptions3,
      ...opts
    });
    Object.defineProperty(this, _computeSmoothETA, {
      value: _computeSmoothETA2
    });
    Object.defineProperty(this, _lastUpdateTime, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _previousUploadedBytes, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _previousSpeed, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _previousETA, {
      writable: true,
      value: void 0
    });
    this.startUpload = () => {
      return this.uppy.upload().catch(() => {
      });
    };
    Object.defineProperty(this, _onUploadStart, {
      writable: true,
      value: () => {
        const {
          recoveredState
        } = this.uppy.getState();
        _classPrivateFieldLooseBase10(this, _previousSpeed)[_previousSpeed] = null;
        _classPrivateFieldLooseBase10(this, _previousETA)[_previousETA] = null;
        if (recoveredState) {
          _classPrivateFieldLooseBase10(this, _previousUploadedBytes)[_previousUploadedBytes] = Object.values(recoveredState.files).reduce((pv, _ref) => {
            let {
              progress: progress2
            } = _ref;
            return pv + progress2.bytesUploaded;
          }, 0);
          this.uppy.emit("restore-confirmed");
          return;
        }
        _classPrivateFieldLooseBase10(this, _lastUpdateTime)[_lastUpdateTime] = performance.now();
        _classPrivateFieldLooseBase10(this, _previousUploadedBytes)[_previousUploadedBytes] = 0;
      }
    });
    this.id = this.opts.id || "StatusBar";
    this.title = "StatusBar";
    this.type = "progressindicator";
    this.defaultLocale = locale_default3;
    this.i18nInit();
    this.render = this.render.bind(this);
    this.install = this.install.bind(this);
  }
  render(state) {
    const {
      capabilities,
      files,
      allowNewUpload,
      totalProgress,
      error,
      recoveredState
    } = state;
    const {
      newFiles,
      startedFiles,
      completeFiles,
      isUploadStarted,
      isAllComplete,
      isAllErrored,
      isAllPaused,
      isUploadInProgress,
      isSomeGhost
    } = this.uppy.getObjectOfFilesPerState();
    const newFilesOrRecovered = recoveredState ? Object.values(files) : newFiles;
    const resumableUploads = !!capabilities.resumableUploads;
    const supportsUploadProgress2 = capabilities.uploadProgress !== false;
    let totalSize = 0;
    let totalUploadedSize = 0;
    startedFiles.forEach((file) => {
      totalSize += file.progress.bytesTotal || 0;
      totalUploadedSize += file.progress.bytesUploaded || 0;
    });
    const totalETA = _classPrivateFieldLooseBase10(this, _computeSmoothETA)[_computeSmoothETA]({
      uploaded: totalUploadedSize,
      total: totalSize,
      remaining: totalSize - totalUploadedSize
    });
    return StatusBar({
      error,
      uploadState: getUploadingState(error, isAllComplete, recoveredState, state.files || {}),
      allowNewUpload,
      totalProgress,
      totalSize,
      totalUploadedSize,
      isAllComplete: false,
      isAllPaused,
      // @ts-expect-error TODO: remove this in 4.x branch
      isAllErrored,
      isUploadStarted,
      isUploadInProgress,
      isSomeGhost,
      recoveredState,
      complete: completeFiles.length,
      newFiles: newFilesOrRecovered.length,
      numUploads: startedFiles.length,
      totalETA,
      files,
      i18n: this.i18n,
      uppy: this.uppy,
      startUpload: this.startUpload,
      doneButtonHandler: this.opts.doneButtonHandler,
      resumableUploads,
      supportsUploadProgress: supportsUploadProgress2,
      showProgressDetails: this.opts.showProgressDetails,
      hideUploadButton: this.opts.hideUploadButton,
      hideRetryButton: this.opts.hideRetryButton,
      hidePauseResumeButton: this.opts.hidePauseResumeButton,
      hideCancelButton: this.opts.hideCancelButton,
      hideAfterFinish: this.opts.hideAfterFinish,
      // ts-expect-error TODO: remove this in 4.x branch
      isTargetDOMEl: this.isTargetDOMEl
    });
  }
  onMount() {
    const element = this.el;
    const direction = getTextDirection_default(element);
    if (!direction) {
      element.dir = "ltr";
    }
  }
  install() {
    const {
      target
    } = this.opts;
    if (target) {
      this.mount(target, this);
    }
    this.uppy.on("upload", _classPrivateFieldLooseBase10(this, _onUploadStart)[_onUploadStart]);
    _classPrivateFieldLooseBase10(this, _lastUpdateTime)[_lastUpdateTime] = performance.now();
    _classPrivateFieldLooseBase10(this, _previousUploadedBytes)[_previousUploadedBytes] = this.uppy.getFiles().reduce((pv, file) => pv + file.progress.bytesUploaded, 0);
  }
  uninstall() {
    this.unmount();
    this.uppy.off("upload", _classPrivateFieldLooseBase10(this, _onUploadStart)[_onUploadStart]);
  }
};
function _computeSmoothETA2(totalBytes) {
  var _classPrivateFieldLoo, _classPrivateFieldLoo2;
  if (totalBytes.total === 0 || totalBytes.remaining === 0) {
    return 0;
  }
  (_classPrivateFieldLoo2 = (_classPrivateFieldLoo = _classPrivateFieldLooseBase10(this, _lastUpdateTime))[_lastUpdateTime]) != null ? _classPrivateFieldLoo2 : _classPrivateFieldLoo[_lastUpdateTime] = performance.now();
  const dt = performance.now() - _classPrivateFieldLooseBase10(this, _lastUpdateTime)[_lastUpdateTime];
  if (dt === 0) {
    var _classPrivateFieldLoo3;
    return Math.round(((_classPrivateFieldLoo3 = _classPrivateFieldLooseBase10(this, _previousETA)[_previousETA]) != null ? _classPrivateFieldLoo3 : 0) / 100) / 10;
  }
  const uploadedBytesSinceLastTick = totalBytes.uploaded - _classPrivateFieldLooseBase10(this, _previousUploadedBytes)[_previousUploadedBytes];
  _classPrivateFieldLooseBase10(this, _previousUploadedBytes)[_previousUploadedBytes] = totalBytes.uploaded;
  if (uploadedBytesSinceLastTick <= 0) {
    var _classPrivateFieldLoo4;
    return Math.round(((_classPrivateFieldLoo4 = _classPrivateFieldLooseBase10(this, _previousETA)[_previousETA]) != null ? _classPrivateFieldLoo4 : 0) / 100) / 10;
  }
  const currentSpeed = uploadedBytesSinceLastTick / dt;
  const filteredSpeed = _classPrivateFieldLooseBase10(this, _previousSpeed)[_previousSpeed] == null ? currentSpeed : emaFilter(currentSpeed, _classPrivateFieldLooseBase10(this, _previousSpeed)[_previousSpeed], speedFilterHalfLife, dt);
  _classPrivateFieldLooseBase10(this, _previousSpeed)[_previousSpeed] = filteredSpeed;
  const instantETA = totalBytes.remaining / filteredSpeed;
  const updatedPreviousETA = Math.max(_classPrivateFieldLooseBase10(this, _previousETA)[_previousETA] - dt, 0);
  const filteredETA = _classPrivateFieldLooseBase10(this, _previousETA)[_previousETA] == null ? instantETA : emaFilter(instantETA, updatedPreviousETA, ETAFilterHalfLife, dt);
  _classPrivateFieldLooseBase10(this, _previousETA)[_previousETA] = filteredETA;
  _classPrivateFieldLooseBase10(this, _lastUpdateTime)[_lastUpdateTime] = performance.now();
  return Math.round(filteredETA / 100) / 10;
}
StatusBar2.VERSION = packageJson6.version;

// ../../node_modules/@uppy/react/lib/StatusBar.js
var StatusBar3 = class extends Component5 {
  componentDidMount() {
    this.installPlugin();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.uppy !== this.props.uppy) {
      this.uninstallPlugin(prevProps);
      this.installPlugin();
    } else if (nonHtmlPropsHaveChanged(this.props, prevProps)) {
      const options7 = {
        ...this.props,
        target: this.container
      };
      delete options7.uppy;
      this.plugin.setOptions(options7);
    }
  }
  componentWillUnmount() {
    this.uninstallPlugin();
  }
  installPlugin() {
    const {
      uppy: uppy3,
      hideUploadButton,
      hideRetryButton,
      hidePauseResumeButton,
      hideCancelButton,
      showProgressDetails,
      hideAfterFinish,
      doneButtonHandler
    } = this.props;
    const options7 = {
      id: "react:StatusBar",
      hideUploadButton,
      hideRetryButton,
      hidePauseResumeButton,
      hideCancelButton,
      showProgressDetails,
      hideAfterFinish,
      doneButtonHandler,
      target: this.container
    };
    delete options7.uppy;
    uppy3.use(StatusBar2, options7);
    this.plugin = uppy3.getPlugin(options7.id);
  }
  uninstallPlugin(props) {
    if (props === void 0) {
      props = this.props;
    }
    const {
      uppy: uppy3
    } = props;
    uppy3.removePlugin(this.plugin);
  }
  render() {
    return h6("div", {
      className: "uppy-Container",
      ref: (container) => {
        this.container = container;
      },
      ...getHTMLProps_default(this.props)
    });
  }
};
StatusBar3.propTypes = {
  uppy: uppy.isRequired,
  hideUploadButton: import_prop_types5.default.bool,
  hideRetryButton: import_prop_types5.default.bool,
  hidePauseResumeButton: import_prop_types5.default.bool,
  hideCancelButton: import_prop_types5.default.bool,
  showProgressDetails: import_prop_types5.default.bool,
  hideAfterFinish: import_prop_types5.default.bool,
  doneButtonHandler: import_prop_types5.default.func
};
StatusBar3.defaultProps = {
  hideUploadButton: false,
  hideRetryButton: false,
  hidePauseResumeButton: false,
  hideCancelButton: false,
  showProgressDetails: false,
  hideAfterFinish: true,
  doneButtonHandler: null
};

// ../../node_modules/@uppy/react/lib/FileInput.js
var import_prop_types6 = __toESM(require_prop_types(), 1);
import { createElement as h7, Component as Component6 } from "react";

// ../../node_modules/@uppy/file-input/lib/FileInput.js
import { UIPlugin as UIPlugin4 } from "@uppy/core";

// ../../node_modules/@uppy/file-input/lib/locale.js
var locale_default4 = {
  strings: {
    chooseFiles: "Choose files"
  }
};

// ../../node_modules/@uppy/file-input/lib/FileInput.js
var packageJson7 = {
  "version": "3.1.0"
};
var defaultOptions4 = {
  pretty: true,
  inputName: "files[]"
};
var FileInput = class extends UIPlugin4 {
  constructor(uppy3, opts) {
    super(uppy3, {
      ...defaultOptions4,
      ...opts
    });
    this.id = this.opts.id || "FileInput";
    this.title = "File Input";
    this.type = "acquirer";
    this.defaultLocale = locale_default4;
    this.i18nInit();
    this.render = this.render.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }
  addFiles(files) {
    const descriptors = files.map((file) => ({
      source: this.id,
      name: file.name,
      type: file.type,
      data: file
    }));
    try {
      this.uppy.addFiles(descriptors);
    } catch (err) {
      this.uppy.log(err);
    }
  }
  handleInputChange(event) {
    this.uppy.log("[FileInput] Something selected through input...");
    const files = toArray_default(event.target.files);
    this.addFiles(files);
    event.target.value = null;
  }
  handleClick() {
    this.input.click();
  }
  render() {
    const hiddenInputStyle = {
      width: "0.1px",
      height: "0.1px",
      opacity: 0,
      overflow: "hidden",
      position: "absolute",
      zIndex: -1
    };
    const {
      restrictions
    } = this.uppy.opts;
    const accept = restrictions.allowedFileTypes ? restrictions.allowedFileTypes.join(",") : void 0;
    return y("div", {
      className: "uppy-FileInput-container"
    }, y("input", {
      className: "uppy-FileInput-input",
      style: this.opts.pretty ? hiddenInputStyle : void 0,
      type: "file",
      name: this.opts.inputName,
      onChange: this.handleInputChange,
      multiple: restrictions.maxNumberOfFiles !== 1,
      accept,
      ref: (input) => {
        this.input = input;
      }
    }), this.opts.pretty && y("button", {
      className: "uppy-FileInput-btn",
      type: "button",
      onClick: this.handleClick
    }, this.i18n("chooseFiles")));
  }
  install() {
    const {
      target
    } = this.opts;
    if (target) {
      this.mount(target, this);
    }
  }
  uninstall() {
    this.unmount();
  }
};
FileInput.VERSION = packageJson7.version;

// ../../node_modules/@uppy/react/lib/FileInput.js
var FileInput2 = class extends Component6 {
  componentDidMount() {
    this.installPlugin();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.uppy !== this.props.uppy) {
      this.uninstallPlugin(prevProps);
      this.installPlugin();
    }
  }
  componentWillUnmount() {
    this.uninstallPlugin();
  }
  installPlugin() {
    const {
      uppy: uppy3,
      locale: locale3,
      pretty,
      inputName
    } = this.props;
    const options7 = {
      id: "react:FileInput",
      locale: locale3,
      pretty,
      inputName,
      target: this.container
    };
    delete options7.uppy;
    uppy3.use(FileInput, options7);
    this.plugin = uppy3.getPlugin(options7.id);
  }
  uninstallPlugin(props) {
    if (props === void 0) {
      props = this.props;
    }
    const {
      uppy: uppy3
    } = props;
    uppy3.removePlugin(this.plugin);
  }
  render() {
    return h7("div", {
      className: "uppy-Container",
      ref: (container) => {
        this.container = container;
      }
    });
  }
};
FileInput2.propTypes = {
  uppy: uppy.isRequired,
  locale,
  pretty: import_prop_types6.default.bool,
  inputName: import_prop_types6.default.string
};
FileInput2.defaultProps = {
  locale: void 0,
  pretty: true,
  inputName: "files[]"
};

// ../../node_modules/@uppy/react/lib/useUppy.js
import { useEffect as useEffect6, useRef } from "react";
import { Uppy as UppyCore2 } from "@uppy/core";

// src/resumes/components/ResumeUpload.tsx
import { XCircleIcon } from "@heroicons/react/20/solid";
import { Button as Button12, Spinner } from "shared-ui";
import {
  commitAsyncMutation,
  createClientMutationId as createClientMutationId10,
  LogLevel as LogLevel2,
  noop as noop3,
  useLogger as useLogger6,
  useUnhandledError as useUnhandledError5
} from "shared-lib";
import "@uppy/core/dist/style.css";
import "@uppy/dashboard/dist/style.css";
import { Fragment as Fragment11, jsx as jsx38, jsxs as jsxs28 } from "react/jsx-runtime";
var ResumeUpload = ({
  profileId,
  showNoResumeButton = true,
  cancelText,
  onUploadStarted,
  onSuccess,
  onCancel
}) => {
  const [log] = useLogger6();
  const [, setUnhandledError] = useUnhandledError5();
  const [isLoading, setIsLoading] = useState9(false);
  const [signedUrl] = useCandidateResumeCreateUploadUrl();
  const [onSetNoResume] = useSetNoResume(profileId, noop3);
  const environment = useRelayEnvironment();
  const uppy3 = new Uppy({
    restrictions: { maxNumberOfFiles: 1 }
  });
  uppy3.use(AwsS3, {
    async getUploadParameters(file) {
      setIsLoading(true);
      const data = await signedUrl({
        input: {
          profileId,
          clientMutationId: createClientMutationId10(),
          fileName: file.name,
          contentType: file.type || "*/*"
        }
      });
      return {
        method: "PUT",
        url: data?.uploadUrl.candidateResumeUploadRequest?.url || "",
        headers: {
          "Content-Type": file.type || "*/*"
        }
      };
    }
  });
  const [errors, setErrors] = useState9([]);
  uppy3.on("upload-error", (file, err) => {
    setErrors([err.message]);
    setIsLoading(false);
    setUnhandledError(err);
  });
  uppy3.on("upload-success", async (file) => {
    log("uppy upload success");
    onUploadStarted();
    if (!file) {
      log("Undefined file", LogLevel2.ERROR);
      return;
    }
    const importResponse = await commitAsyncMutation(
      environment,
      UseCandidateResumeUploadGraphQL,
      {
        input: {
          profileId,
          clientMutationId: createClientMutationId10(),
          model: {
            fileName: file.name,
            key: file.name
          }
        }
      }
    );
    const status = importResponse.data.candidateResume?.node.status;
    log(`resume status: ${status}`);
    if (importResponse.data.candidateResume?.node) {
      onSuccess(importResponse.data.candidateResume?.node);
    }
  });
  return /* @__PURE__ */ jsxs28("div", { className: "w-md rounded bg-white px-4 py-2", children: [
    /* @__PURE__ */ jsxs28("div", { className: "pb-2 sm:flex sm:items-center sm:justify-between", children: [
      /* @__PURE__ */ jsx38("h1", { className: "text-info-900 p-2 text-2xl", children: "Upload your Resume" }),
      /* @__PURE__ */ jsx38("div", { className: "flex p-2 sm:mb-3 sm:flex-none", children: showNoResumeButton && /* @__PURE__ */ jsx38(Button12, { onClick: () => onSetNoResume(true), children: "I don't have a Resume" }) })
    ] }),
    /* @__PURE__ */ jsx38("div", { className: "relative flex w-full justify-center", children: /* @__PURE__ */ jsxs28("div", { className: "flex w-full flex-col justify-center gap-5 sm:w-[750px]", children: [
      /* @__PURE__ */ jsx38(Error2, { errors }),
      /* @__PURE__ */ jsx38(
        Dashboard_default,
        {
          style: { width: "100%", display: isLoading ? "none" : "auto" },
          width: "100%",
          hideUploadButton: false,
          showSelectedFiles: true,
          showProgressDetails: true,
          proudlyDisplayPoweredByUppy: false,
          uppy: uppy3
        }
      ),
      isLoading && /* @__PURE__ */ jsx38("div", { className: "flex justify-center", children: /* @__PURE__ */ jsx38(Spinner, {}) })
    ] }) })
  ] });
};
var Error2 = function(props) {
  if (props.errors.length == 0) {
    return /* @__PURE__ */ jsx38(Fragment11, {});
  }
  return /* @__PURE__ */ jsx38("div", { className: "bg-danger-50 rounded-md p-4", children: /* @__PURE__ */ jsxs28("div", { className: "flex", children: [
    /* @__PURE__ */ jsx38("div", { className: "flex-shrink-0", children: /* @__PURE__ */ jsx38(XCircleIcon, { className: "text-danger-400 h-5 w-5", "aria-hidden": "true" }) }),
    /* @__PURE__ */ jsxs28("div", { className: "ml-3", children: [
      /* @__PURE__ */ jsxs28("h3", { className: "text-danger-800 text-sm font-medium", children: [
        "There ",
        props.errors.length == 1 ? "is" : "are",
        " ",
        props.errors.length,
        "error",
        props.errors.length == 1 ? "" : "s",
        " with your submission"
      ] }),
      /* @__PURE__ */ jsx38("div", { className: "text-danger-700 mt-2 text-sm", children: /* @__PURE__ */ jsx38("ul", { role: "list", className: "list-disc space-y-1 pl-5", children: props.errors.map((x4, key) => {
        return /* @__PURE__ */ jsx38("li", { children: x4 }, key);
      }) }) })
    ] })
  ] }) });
};

// src/resumes/components/ResumeUploader.tsx
import { jsx as jsx39 } from "react/jsx-runtime";
var ResumeUploader = ({
  profileId,
  onUploadStarted,
  onReady,
  onCancel,
  onFailed,
  onTimedOut
}) => {
  const [log] = useLogger7();
  const [uiState, setUIState] = useState10(0 /* Uploading */);
  const [uploadedResume, setUploadedResume] = useState10(
    null
  );
  switch (uiState) {
    case 0 /* Uploading */:
      return /* @__PURE__ */ jsx39(
        ResumeUpload,
        {
          cancelText: "Cancel",
          profileId,
          onCancel,
          onUploadStarted,
          showNoResumeButton: false,
          onSuccess: (resume) => {
            setUploadedResume(resume);
            setUIState(1 /* Uploaded */);
          }
        }
      );
      break;
    case 1 /* Uploaded */:
      return /* @__PURE__ */ jsx39(
        ResumePollerLoader,
        {
          resumeId: uploadedResume.resumeId,
          onReady: (resume) => {
            log("ResumeUploader onReady " + JSON.stringify(resume));
            onReady(resume);
          },
          onFailed,
          onTimeout: onTimedOut
        }
      );
      break;
  }
};

// src/resumes/components/ResumeUploadContainer.tsx
import { jsx as jsx40 } from "react/jsx-runtime";
var ResumeUploadContainer = ({ profileId }) => {
  const [log] = useLogger8();
  const navigate = useNavigate5();
  const onFailed = useCallback18(() => {
    log("Resume Failed");
  }, [log]);
  const onTimedOut = useCallback18(() => {
    log("Resume TimedOut");
  }, [log]);
  const onReady = useCallback18(
    (resume) => {
      navigate(`../view/${resume.resumeId}`);
    },
    [navigate]
  );
  const onCancel = useCallback18(() => {
    navigate("../list");
  }, [navigate]);
  return /* @__PURE__ */ jsx40(
    ResumeUploader,
    {
      profileId,
      onUploadStarted: () => log("ResumeUpload Upload Started"),
      onReady,
      onCancel,
      onFailed,
      onTimedOut
    }
  );
};

// src/resumes/components/ResumesLayout.tsx
import { jsx as jsx41, jsxs as jsxs29 } from "react/jsx-runtime";
var queryDef8 = ResumesLayoutQuery_graphql_default;
var RootContainer2 = () => {
  return /* @__PURE__ */ jsx41("div", { children: /* @__PURE__ */ jsx41(Outlet2, {}) });
};
var ResumesLayout = ({ profileId }) => {
  const where = {
    profileId: { eq: profileId }
  };
  const query3 = useLazyLoadQuery10(
    queryDef8,
    { where },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsx41(ErrorBoundary4, { FallbackComponent: ErrorBoundaryFallback3, children: /* @__PURE__ */ jsx41(Suspense10, { fallback: /* @__PURE__ */ jsx41(EdSkeleton6, {}), children: /* @__PURE__ */ jsx41(Routes2, { children: /* @__PURE__ */ jsxs29(Route2, { element: /* @__PURE__ */ jsx41(RootContainer2, {}), children: [
    /* @__PURE__ */ jsx41(
      Route2,
      {
        path: "list/*",
        element: /* @__PURE__ */ jsx41(
          RouteContent2,
          {
            title: "Resumes",
            actions: /* @__PURE__ */ jsx41("div", { children: /* @__PURE__ */ jsx41(EdLink3, { href: "../upload", name: "upload", children: /* @__PURE__ */ jsx41(Button13, { color: "primary", children: "Upload" }) }) }),
            children: /* @__PURE__ */ jsx41(ResumeList, { candidateId: profileId, fragmentRef: query3 })
          }
        )
      }
    ),
    /* @__PURE__ */ jsx41(
      Route2,
      {
        path: "view/:resumeId/*",
        element: /* @__PURE__ */ jsx41(
          RouteContent2,
          {
            title: "Resumes",
            actions: /* @__PURE__ */ jsx41(
              Link3,
              {
                className: "inline-flex items-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2",
                to: "../list",
                children: "Back"
              }
            ),
            children: /* @__PURE__ */ jsx41(ResumeContainer, {})
          }
        )
      }
    ),
    /* @__PURE__ */ jsx41(
      Route2,
      {
        path: "upload/*",
        element: /* @__PURE__ */ jsx41(
          RouteContent2,
          {
            title: "Resumes",
            actions: /* @__PURE__ */ jsx41(EdLink3, { href: "../list", name: "cancel", children: /* @__PURE__ */ jsx41(Button13, { color: "danger", children: "Cancel" }) }),
            children: /* @__PURE__ */ jsx41("div", { className: "mx-4 mt-2 lg:mx-auto lg:w-1/2", children: /* @__PURE__ */ jsx41(ResumeUploadContainer, { profileId }) })
          }
        )
      }
    ),
    /* @__PURE__ */ jsx41(Route2, { path: "*", element: /* @__PURE__ */ jsx41(Navigate2, { to: "list", replace: true }) })
  ] }) }) }) });
};

// src/resumes/components/ResumeStatusLabel.tsx
import { Fragment as Fragment12, jsx as jsx42 } from "react/jsx-runtime";
var ResumeStatusLabel = ({ status }) => {
  if (status === "COMPLETED") {
    return /* @__PURE__ */ jsx42("div", { className: "font-medium", children: /* @__PURE__ */ jsx42("span", { className: "text-primary-500", children: "COMPLETED" }) });
  } else if (status === "CREATED") {
    return /* @__PURE__ */ jsx42("div", { className: "font-medium", children: /* @__PURE__ */ jsx42("span", { className: "text-primary-500", children: "CREATED" }) });
  } else if (status === "FAILED") {
    return /* @__PURE__ */ jsx42("div", { className: "font-medium", children: /* @__PURE__ */ jsx42("span", { className: "text-gray-500", children: "FAILED" }) });
  } else if (status === "PARSED") {
    return /* @__PURE__ */ jsx42("div", { className: "font-medium", children: /* @__PURE__ */ jsx42("span", { className: "text-success-500", children: "PARSED" }) });
  } else if (status === "RESOLVED") {
    return /* @__PURE__ */ jsx42("div", { className: "font-medium", children: /* @__PURE__ */ jsx42("span", { className: "text-success-500", children: "RESOLVED" }) });
  }
  return /* @__PURE__ */ jsx42(Fragment12, {});
};

// src/locations/components/__generated__/LocationsContainerQuery.graphql.ts
var node62 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "id"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "id"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "recruitProfileWorkLocationsId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "version",
    "storageKey": null
  }, v5 = [
    v23,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountType",
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "LocationsContainerQuery",
      "selections": [
        {
          "alias": "workLocations",
          "args": v1,
          "concreteType": "RecruitProfileWorkLocations",
          "kind": "LinkedField",
          "name": "recruitProfileWorkLocationsById",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "WorkLocationsContainer_workLocations"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "CurrentLocationContainer_workLocations"
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "LocationsContainerQuery",
      "selections": [
        {
          "alias": "workLocations",
          "args": v1,
          "concreteType": "RecruitProfileWorkLocations",
          "kind": "LinkedField",
          "name": "recruitProfileWorkLocationsById",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdOn",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountId",
              "kind": "LinkedField",
              "name": "createdBy",
              "plural": false,
              "selections": v5,
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedOn",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountId",
              "kind": "LinkedField",
              "name": "updatedBy",
              "plural": false,
              "selections": v5,
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "currentLocationCountryCode",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "currentLocationCountryName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "currentLocationName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "currentLocationLatitude",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "currentLocationLongitude",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "currentLocationRadius",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "WorkLocationEntry",
              "kind": "LinkedField",
              "name": "workLocations",
              "plural": true,
              "selections": [
                v23,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "countryCode",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "countryName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "entireCountry",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "latitude",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "longitude",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "radius",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "e0b24594165998c72eeb1080d2dbb4fe",
      "id": null,
      "metadata": {},
      "name": "LocationsContainerQuery",
      "operationKind": "query",
      "text": "query LocationsContainerQuery(\n  $id: UUID!\n) {\n  workLocations: recruitProfileWorkLocationsById(id: $id) {\n    id\n    recruitProfileWorkLocationsId\n    version\n    ...WorkLocationsContainer_workLocations\n    ...CurrentLocationContainer_workLocations\n  }\n}\n\nfragment CurrentLocationContainer_workLocations on RecruitProfileWorkLocations {\n  id\n  recruitProfileWorkLocationsId\n  version\n  currentLocationCountryCode\n  currentLocationCountryName\n  currentLocationName\n  currentLocationLatitude\n  currentLocationLongitude\n  currentLocationRadius\n}\n\nfragment WorkLocationEntriesList_workLocations on RecruitProfileWorkLocations {\n  id\n  workLocations {\n    id\n    name\n    countryCode\n    countryName\n    entireCountry\n    latitude\n    longitude\n    radius\n  }\n}\n\nfragment WorkLocationsContainer_workLocations on RecruitProfileWorkLocations {\n  id\n  createdOn\n  createdBy {\n    id\n    accountType\n  }\n  updatedOn\n  updatedBy {\n    id\n    accountType\n  }\n  recruitProfileWorkLocationsId\n  version\n  currentLocationCountryCode\n  currentLocationCountryName\n  currentLocationName\n  currentLocationLatitude\n  currentLocationLongitude\n  currentLocationRadius\n  workLocations {\n    id\n    name\n    countryCode\n    countryName\n    entireCountry\n    latitude\n    longitude\n    radius\n  }\n  ...WorkLocationEntriesList_workLocations\n}\n"
    }
  };
}();
node62.hash = "8bb528c3a98aa2b9785e7f03731138c4";
var LocationsContainerQuery_graphql_default = node62;

// src/locations/components/LocationsContainer.tsx
import { useLazyLoadQuery as useLazyLoadQuery11 } from "react-relay";

// src/locations/components/__generated__/WorkLocationsContainer_workLocations.graphql.ts
var node63 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v1 = [
    v0,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountType",
      "storageKey": null
    }
  ];
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkLocationsContainer_workLocations",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountId",
        "kind": "LinkedField",
        "name": "createdBy",
        "plural": false,
        "selections": v1,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountId",
        "kind": "LinkedField",
        "name": "updatedBy",
        "plural": false,
        "selections": v1,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "recruitProfileWorkLocationsId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "version",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currentLocationCountryCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currentLocationCountryName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currentLocationName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currentLocationLatitude",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currentLocationLongitude",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currentLocationRadius",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "WorkLocationEntry",
        "kind": "LinkedField",
        "name": "workLocations",
        "plural": true,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "countryCode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "countryName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "entireCountry",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "latitude",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "longitude",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "radius",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "WorkLocationEntriesList_workLocations"
      }
    ],
    "type": "RecruitProfileWorkLocations",
    "abstractKey": null
  };
}();
node63.hash = "3fde3a088bb96e756543a3f0e629e871";
var WorkLocationsContainer_workLocations_graphql_default = node63;

// src/locations/components/WorkLocationsContainer.tsx
import { useCallback as useCallback21, useState as useState12 } from "react";
import { useFragment as useFragment21 } from "react-relay";
import { createClientMutationId as createClientMutationId12, useToggle as useToggle7 } from "shared-lib";
import {
  ActionContainer as ActionContainer2,
  AlertMessage as AlertMessage7,
  Button as Button15,
  ButtonList as ButtonList6,
  EditContainer
} from "shared-ui";
import {
  DefaultGeoCountry,
  GeoLocationsSearchContainer
} from "feature-data-management";

// src/locations/components/__generated__/WorkLocationEntriesList_workLocations.graphql.ts
var node64 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkLocationEntriesList_workLocations",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "concreteType": "WorkLocationEntry",
        "kind": "LinkedField",
        "name": "workLocations",
        "plural": true,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "countryCode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "countryName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "entireCountry",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "latitude",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "longitude",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "radius",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RecruitProfileWorkLocations",
    "abstractKey": null
  };
}();
node64.hash = "91a56a387736fcc13cca87365c653b3e";
var WorkLocationEntriesList_workLocations_graphql_default = node64;

// src/locations/components/WorkLocationEntriesList.tsx
import { useCallback as useCallback20, useState as useState11 } from "react";
import { useFragment as useFragment20 } from "react-relay";

// ../../node_modules/framer-motion/dist/es/motion/index.mjs
import * as React from "react";
import { forwardRef, useContext as useContext3 } from "react";

// ../../node_modules/framer-motion/dist/es/context/MotionConfigContext.mjs
import { createContext } from "react";
var MotionConfigContext = createContext({
  transformPagePoint: (p4) => p4,
  isStatic: false,
  reducedMotion: "never"
});

// ../../node_modules/framer-motion/dist/es/context/MotionContext/index.mjs
import { createContext as createContext2 } from "react";
var MotionContext = createContext2({});

// ../../node_modules/framer-motion/dist/es/motion/utils/use-visual-element.mjs
import { useContext, useRef as useRef2, useInsertionEffect, useEffect as useEffect8 } from "react";

// ../../node_modules/framer-motion/dist/es/context/PresenceContext.mjs
import { createContext as createContext3 } from "react";
var PresenceContext = createContext3(null);

// ../../node_modules/framer-motion/dist/es/utils/use-isomorphic-effect.mjs
import { useLayoutEffect, useEffect as useEffect7 } from "react";

// ../../node_modules/framer-motion/dist/es/utils/is-browser.mjs
var isBrowser = typeof document !== "undefined";

// ../../node_modules/framer-motion/dist/es/utils/use-isomorphic-effect.mjs
var useIsomorphicLayoutEffect = isBrowser ? useLayoutEffect : useEffect7;

// ../../node_modules/framer-motion/dist/es/context/LazyContext.mjs
import { createContext as createContext4 } from "react";
var LazyContext = createContext4({ strict: false });

// ../../node_modules/framer-motion/dist/es/render/dom/utils/camel-to-dash.mjs
var camelToDash = (str) => str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();

// ../../node_modules/framer-motion/dist/es/animation/optimized-appear/data-id.mjs
var optimizedAppearDataId = "framerAppearId";
var optimizedAppearDataAttribute = "data-" + camelToDash(optimizedAppearDataId);

// ../../node_modules/framer-motion/dist/es/motion/utils/use-visual-element.mjs
function useVisualElement(Component8, visualState, props, createVisualElement) {
  const { visualElement: parent } = useContext(MotionContext);
  const lazyContext = useContext(LazyContext);
  const presenceContext = useContext(PresenceContext);
  const reducedMotionConfig = useContext(MotionConfigContext).reducedMotion;
  const visualElementRef = useRef2();
  createVisualElement = createVisualElement || lazyContext.renderer;
  if (!visualElementRef.current && createVisualElement) {
    visualElementRef.current = createVisualElement(Component8, {
      visualState,
      parent,
      props,
      presenceContext,
      blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
      reducedMotionConfig
    });
  }
  const visualElement = visualElementRef.current;
  useInsertionEffect(() => {
    visualElement && visualElement.update(props, presenceContext);
  });
  const wantsHandoff = useRef2(Boolean(props[optimizedAppearDataAttribute] && !window.HandoffComplete));
  useIsomorphicLayoutEffect(() => {
    if (!visualElement)
      return;
    visualElement.render();
    if (wantsHandoff.current && visualElement.animationState) {
      visualElement.animationState.animateChanges();
    }
  });
  useEffect8(() => {
    if (!visualElement)
      return;
    visualElement.updateFeatures();
    if (!wantsHandoff.current && visualElement.animationState) {
      visualElement.animationState.animateChanges();
    }
    if (wantsHandoff.current) {
      wantsHandoff.current = false;
      window.HandoffComplete = true;
    }
  });
  return visualElement;
}

// ../../node_modules/framer-motion/dist/es/motion/utils/use-motion-ref.mjs
import { useCallback as useCallback19 } from "react";

// ../../node_modules/framer-motion/dist/es/utils/is-ref-object.mjs
function isRefObject(ref) {
  return ref && typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}

// ../../node_modules/framer-motion/dist/es/motion/utils/use-motion-ref.mjs
function useMotionRef(visualState, visualElement, externalRef) {
  return useCallback19(
    (instance) => {
      instance && visualState.mount && visualState.mount(instance);
      if (visualElement) {
        instance ? visualElement.mount(instance) : visualElement.unmount();
      }
      if (externalRef) {
        if (typeof externalRef === "function") {
          externalRef(instance);
        } else if (isRefObject(externalRef)) {
          externalRef.current = instance;
        }
      }
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [visualElement]
  );
}

// ../../node_modules/framer-motion/dist/es/context/MotionContext/create.mjs
import { useContext as useContext2, useMemo as useMemo4 } from "react";

// ../../node_modules/framer-motion/dist/es/render/utils/is-variant-label.mjs
function isVariantLabel(v4) {
  return typeof v4 === "string" || Array.isArray(v4);
}

// ../../node_modules/framer-motion/dist/es/animation/utils/is-animation-controls.mjs
function isAnimationControls(v4) {
  return v4 !== null && typeof v4 === "object" && typeof v4.start === "function";
}

// ../../node_modules/framer-motion/dist/es/render/utils/variant-props.mjs
var variantPriorityOrder = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
];
var variantProps = ["initial", ...variantPriorityOrder];

// ../../node_modules/framer-motion/dist/es/render/utils/is-controlling-variants.mjs
function isControllingVariants(props) {
  return isAnimationControls(props.animate) || variantProps.some((name) => isVariantLabel(props[name]));
}
function isVariantNode(props) {
  return Boolean(isControllingVariants(props) || props.variants);
}

// ../../node_modules/framer-motion/dist/es/context/MotionContext/utils.mjs
function getCurrentTreeVariants(props, context) {
  if (isControllingVariants(props)) {
    const { initial, animate } = props;
    return {
      initial: initial === false || isVariantLabel(initial) ? initial : void 0,
      animate: isVariantLabel(animate) ? animate : void 0
    };
  }
  return props.inherit !== false ? context : {};
}

// ../../node_modules/framer-motion/dist/es/context/MotionContext/create.mjs
function useCreateMotionContext(props) {
  const { initial, animate } = getCurrentTreeVariants(props, useContext2(MotionContext));
  return useMemo4(() => ({ initial, animate }), [variantLabelsAsDependency(initial), variantLabelsAsDependency(animate)]);
}
function variantLabelsAsDependency(prop) {
  return Array.isArray(prop) ? prop.join(" ") : prop;
}

// ../../node_modules/framer-motion/dist/es/motion/features/definitions.mjs
var featureProps = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
};
var featureDefinitions = {};
for (const key in featureProps) {
  featureDefinitions[key] = {
    isEnabled: (props) => featureProps[key].some((name) => !!props[name])
  };
}

// ../../node_modules/framer-motion/dist/es/motion/features/load-features.mjs
function loadFeatures(features) {
  for (const key in features) {
    featureDefinitions[key] = {
      ...featureDefinitions[key],
      ...features[key]
    };
  }
}

// ../../node_modules/framer-motion/dist/es/context/LayoutGroupContext.mjs
import { createContext as createContext5 } from "react";
var LayoutGroupContext = createContext5({});

// ../../node_modules/framer-motion/dist/es/context/SwitchLayoutGroupContext.mjs
import { createContext as createContext6 } from "react";
var SwitchLayoutGroupContext = createContext6({});

// ../../node_modules/framer-motion/dist/es/motion/utils/symbol.mjs
var motionComponentSymbol = Symbol.for("motionComponentSymbol");

// ../../node_modules/framer-motion/dist/es/motion/index.mjs
function createMotionComponent({ preloadedFeatures: preloadedFeatures2, createVisualElement, useRender, useVisualState, Component: Component8 }) {
  preloadedFeatures2 && loadFeatures(preloadedFeatures2);
  function MotionComponent(props, externalRef) {
    let MeasureLayout2;
    const configAndProps = {
      ...useContext3(MotionConfigContext),
      ...props,
      layoutId: useLayoutId(props)
    };
    const { isStatic } = configAndProps;
    const context = useCreateMotionContext(props);
    const visualState = useVisualState(props, isStatic);
    if (!isStatic && isBrowser) {
      context.visualElement = useVisualElement(Component8, visualState, configAndProps, createVisualElement);
      const initialLayoutGroupConfig = useContext3(SwitchLayoutGroupContext);
      const isStrict = useContext3(LazyContext).strict;
      if (context.visualElement) {
        MeasureLayout2 = context.visualElement.loadFeatures(
          // Note: Pass the full new combined props to correctly re-render dynamic feature components.
          configAndProps,
          isStrict,
          preloadedFeatures2,
          initialLayoutGroupConfig
        );
      }
    }
    return React.createElement(
      MotionContext.Provider,
      { value: context },
      MeasureLayout2 && context.visualElement ? React.createElement(MeasureLayout2, { visualElement: context.visualElement, ...configAndProps }) : null,
      useRender(Component8, props, useMotionRef(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement)
    );
  }
  const ForwardRefComponent = forwardRef(MotionComponent);
  ForwardRefComponent[motionComponentSymbol] = Component8;
  return ForwardRefComponent;
}
function useLayoutId({ layoutId }) {
  const layoutGroupId = useContext3(LayoutGroupContext).id;
  return layoutGroupId && layoutId !== void 0 ? layoutGroupId + "-" + layoutId : layoutId;
}

// ../../node_modules/framer-motion/dist/es/render/dom/motion-proxy.mjs
function createMotionProxy(createConfig) {
  function custom(Component8, customMotionComponentConfig = {}) {
    return createMotionComponent(createConfig(Component8, customMotionComponentConfig));
  }
  if (typeof Proxy === "undefined") {
    return custom;
  }
  const componentCache = /* @__PURE__ */ new Map();
  return new Proxy(custom, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (_target, key) => {
      if (!componentCache.has(key)) {
        componentCache.set(key, custom(key));
      }
      return componentCache.get(key);
    }
  });
}

// ../../node_modules/framer-motion/dist/es/render/svg/lowercase-elements.mjs
var lowercaseSVGElements = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];

// ../../node_modules/framer-motion/dist/es/render/dom/utils/is-svg-component.mjs
function isSVGComponent(Component8) {
  if (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof Component8 !== "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    Component8.includes("-")
  ) {
    return false;
  } else if (
    /**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */
    lowercaseSVGElements.indexOf(Component8) > -1 || /**
     * If it contains a capital letter, it's an SVG component
     */
    /[A-Z]/.test(Component8)
  ) {
    return true;
  }
  return false;
}

// ../../node_modules/framer-motion/dist/es/render/dom/use-render.mjs
import { useMemo as useMemo7, createElement as createElement2 } from "react";

// ../../node_modules/framer-motion/dist/es/render/html/use-props.mjs
import { useMemo as useMemo5 } from "react";

// ../../node_modules/framer-motion/dist/es/projection/styles/scale-correction.mjs
var scaleCorrectors = {};
function addScaleCorrector(correctors) {
  Object.assign(scaleCorrectors, correctors);
}

// ../../node_modules/framer-motion/dist/es/render/html/utils/transform.mjs
var transformPropOrder = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
];
var transformProps = new Set(transformPropOrder);

// ../../node_modules/framer-motion/dist/es/motion/utils/is-forced-motion-value.mjs
function isForcedMotionValue(key, { layout: layout2, layoutId }) {
  return transformProps.has(key) || key.startsWith("origin") || (layout2 || layoutId !== void 0) && (!!scaleCorrectors[key] || key === "opacity");
}

// ../../node_modules/framer-motion/dist/es/value/utils/is-motion-value.mjs
var isMotionValue = (value) => Boolean(value && value.getVelocity);

// ../../node_modules/framer-motion/dist/es/render/html/utils/build-transform.mjs
var translateAlias = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
};
var numTransforms = transformPropOrder.length;
function buildTransform(transform, { enableHardwareAcceleration = true, allowTransformNone = true }, transformIsDefault, transformTemplate) {
  let transformString = "";
  for (let i4 = 0; i4 < numTransforms; i4++) {
    const key = transformPropOrder[i4];
    if (transform[key] !== void 0) {
      const transformName = translateAlias[key] || key;
      transformString += `${transformName}(${transform[key]}) `;
    }
  }
  if (enableHardwareAcceleration && !transform.z) {
    transformString += "translateZ(0)";
  }
  transformString = transformString.trim();
  if (transformTemplate) {
    transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
  } else if (allowTransformNone && transformIsDefault) {
    transformString = "none";
  }
  return transformString;
}

// ../../node_modules/framer-motion/dist/es/render/dom/utils/is-css-variable.mjs
var checkStringStartsWith = (token) => (key) => typeof key === "string" && key.startsWith(token);
var isCSSVariableName = checkStringStartsWith("--");
var isCSSVariableToken = checkStringStartsWith("var(--");
var cssVariableRegex = /var\s*\(\s*--[\w-]+(\s*,\s*(?:(?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)+)?\s*\)/g;

// ../../node_modules/framer-motion/dist/es/render/dom/value-types/get-as-type.mjs
var getValueAsType = (value, type) => {
  return type && typeof value === "number" ? type.transform(value) : value;
};

// ../../node_modules/framer-motion/dist/es/utils/clamp.mjs
var clamp = (min, max, v4) => Math.min(Math.max(v4, min), max);

// ../../node_modules/framer-motion/dist/es/value/types/numbers/index.mjs
var number = {
  test: (v4) => typeof v4 === "number",
  parse: parseFloat,
  transform: (v4) => v4
};
var alpha = {
  ...number,
  transform: (v4) => clamp(0, 1, v4)
};
var scale = {
  ...number,
  default: 1
};

// ../../node_modules/framer-motion/dist/es/value/types/utils.mjs
var sanitize = (v4) => Math.round(v4 * 1e5) / 1e5;
var floatRegex = /(-)?([\d]*\.?[\d])+/g;
var colorRegex = /(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))/gi;
var singleColorRegex = /^(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))$/i;
function isString(v4) {
  return typeof v4 === "string";
}

// ../../node_modules/framer-motion/dist/es/value/types/numbers/units.mjs
var createUnitType = (unit) => ({
  test: (v4) => isString(v4) && v4.endsWith(unit) && v4.split(" ").length === 1,
  parse: parseFloat,
  transform: (v4) => `${v4}${unit}`
});
var degrees = createUnitType("deg");
var percent = createUnitType("%");
var px = createUnitType("px");
var vh = createUnitType("vh");
var vw = createUnitType("vw");
var progressPercentage = {
  ...percent,
  parse: (v4) => percent.parse(v4) / 100,
  transform: (v4) => percent.transform(v4 * 100)
};

// ../../node_modules/framer-motion/dist/es/render/dom/value-types/type-int.mjs
var int = {
  ...number,
  transform: Math.round
};

// ../../node_modules/framer-motion/dist/es/render/dom/value-types/number.mjs
var numberValueTypes = {
  // Border props
  borderWidth: px,
  borderTopWidth: px,
  borderRightWidth: px,
  borderBottomWidth: px,
  borderLeftWidth: px,
  borderRadius: px,
  radius: px,
  borderTopLeftRadius: px,
  borderTopRightRadius: px,
  borderBottomRightRadius: px,
  borderBottomLeftRadius: px,
  // Positioning props
  width: px,
  maxWidth: px,
  height: px,
  maxHeight: px,
  size: px,
  top: px,
  right: px,
  bottom: px,
  left: px,
  // Spacing props
  padding: px,
  paddingTop: px,
  paddingRight: px,
  paddingBottom: px,
  paddingLeft: px,
  margin: px,
  marginTop: px,
  marginRight: px,
  marginBottom: px,
  marginLeft: px,
  // Transform props
  rotate: degrees,
  rotateX: degrees,
  rotateY: degrees,
  rotateZ: degrees,
  scale,
  scaleX: scale,
  scaleY: scale,
  scaleZ: scale,
  skew: degrees,
  skewX: degrees,
  skewY: degrees,
  distance: px,
  translateX: px,
  translateY: px,
  translateZ: px,
  x: px,
  y: px,
  z: px,
  perspective: px,
  transformPerspective: px,
  opacity: alpha,
  originX: progressPercentage,
  originY: progressPercentage,
  originZ: px,
  // Misc
  zIndex: int,
  // SVG
  fillOpacity: alpha,
  strokeOpacity: alpha,
  numOctaves: int
};

// ../../node_modules/framer-motion/dist/es/render/html/utils/build-styles.mjs
function buildHTMLStyles(state, latestValues, options7, transformTemplate) {
  const { style, vars, transform, transformOrigin } = state;
  let hasTransform2 = false;
  let hasTransformOrigin = false;
  let transformIsNone = true;
  for (const key in latestValues) {
    const value = latestValues[key];
    if (isCSSVariableName(key)) {
      vars[key] = value;
      continue;
    }
    const valueType = numberValueTypes[key];
    const valueAsType = getValueAsType(value, valueType);
    if (transformProps.has(key)) {
      hasTransform2 = true;
      transform[key] = valueAsType;
      if (!transformIsNone)
        continue;
      if (value !== (valueType.default || 0))
        transformIsNone = false;
    } else if (key.startsWith("origin")) {
      hasTransformOrigin = true;
      transformOrigin[key] = valueAsType;
    } else {
      style[key] = valueAsType;
    }
  }
  if (!latestValues.transform) {
    if (hasTransform2 || transformTemplate) {
      style.transform = buildTransform(state.transform, options7, transformIsNone, transformTemplate);
    } else if (style.transform) {
      style.transform = "none";
    }
  }
  if (hasTransformOrigin) {
    const { originX = "50%", originY = "50%", originZ = 0 } = transformOrigin;
    style.transformOrigin = `${originX} ${originY} ${originZ}`;
  }
}

// ../../node_modules/framer-motion/dist/es/render/html/utils/create-render-state.mjs
var createHtmlRenderState = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});

// ../../node_modules/framer-motion/dist/es/render/html/use-props.mjs
function copyRawValuesOnly(target, source, props) {
  for (const key in source) {
    if (!isMotionValue(source[key]) && !isForcedMotionValue(key, props)) {
      target[key] = source[key];
    }
  }
}
function useInitialMotionValues({ transformTemplate }, visualState, isStatic) {
  return useMemo5(() => {
    const state = createHtmlRenderState();
    buildHTMLStyles(state, visualState, { enableHardwareAcceleration: !isStatic }, transformTemplate);
    return Object.assign({}, state.vars, state.style);
  }, [visualState]);
}
function useStyle(props, visualState, isStatic) {
  const styleProp = props.style || {};
  const style = {};
  copyRawValuesOnly(style, styleProp, props);
  Object.assign(style, useInitialMotionValues(props, visualState, isStatic));
  return props.transformValues ? props.transformValues(style) : style;
}
function useHTMLProps(props, visualState, isStatic) {
  const htmlProps = {};
  const style = useStyle(props, visualState, isStatic);
  if (props.drag && props.dragListener !== false) {
    htmlProps.draggable = false;
    style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
    style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
  }
  if (props.tabIndex === void 0 && (props.onTap || props.onTapStart || props.whileTap)) {
    htmlProps.tabIndex = 0;
  }
  htmlProps.style = style;
  return htmlProps;
}

// ../../node_modules/framer-motion/dist/es/motion/utils/valid-prop.mjs
var validMotionProps = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "transformValues",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function isValidMotionProp(key) {
  return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || validMotionProps.has(key);
}

// ../../node_modules/framer-motion/dist/es/render/dom/utils/filter-props.mjs
var shouldForward = (key) => !isValidMotionProp(key);
function loadExternalIsValidProp(isValidProp) {
  if (!isValidProp)
    return;
  shouldForward = (key) => key.startsWith("on") ? !isValidMotionProp(key) : isValidProp(key);
}
try {
  loadExternalIsValidProp((init_is_prop_valid_esm(), __toCommonJS(is_prop_valid_esm_exports)).default);
} catch (_a) {
}
function filterProps(props, isDom, forwardMotionProps) {
  const filteredProps = {};
  for (const key in props) {
    if (key === "values" && typeof props.values === "object")
      continue;
    if (shouldForward(key) || forwardMotionProps === true && isValidMotionProp(key) || !isDom && !isValidMotionProp(key) || // If trying to use native HTML drag events, forward drag listeners
    props["draggable"] && key.startsWith("onDrag")) {
      filteredProps[key] = props[key];
    }
  }
  return filteredProps;
}

// ../../node_modules/framer-motion/dist/es/render/svg/use-props.mjs
import { useMemo as useMemo6 } from "react";

// ../../node_modules/framer-motion/dist/es/render/svg/utils/transform-origin.mjs
function calcOrigin(origin, offset, size) {
  return typeof origin === "string" ? origin : px.transform(offset + size * origin);
}
function calcSVGTransformOrigin(dimensions, originX, originY) {
  const pxOriginX = calcOrigin(originX, dimensions.x, dimensions.width);
  const pxOriginY = calcOrigin(originY, dimensions.y, dimensions.height);
  return `${pxOriginX} ${pxOriginY}`;
}

// ../../node_modules/framer-motion/dist/es/render/svg/utils/path.mjs
var dashKeys = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
};
var camelKeys = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function buildSVGPath(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
  attrs.pathLength = 1;
  const keys = useDashCase ? dashKeys : camelKeys;
  attrs[keys.offset] = px.transform(-offset);
  const pathLength = px.transform(length);
  const pathSpacing = px.transform(spacing);
  attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}

// ../../node_modules/framer-motion/dist/es/render/svg/utils/build-attrs.mjs
function buildSVGAttrs(state, {
  attrX,
  attrY,
  attrScale,
  originX,
  originY,
  pathLength,
  pathSpacing = 1,
  pathOffset = 0,
  // This is object creation, which we try to avoid per-frame.
  ...latest
}, options7, isSVGTag2, transformTemplate) {
  buildHTMLStyles(state, latest, options7, transformTemplate);
  if (isSVGTag2) {
    if (state.style.viewBox) {
      state.attrs.viewBox = state.style.viewBox;
    }
    return;
  }
  state.attrs = state.style;
  state.style = {};
  const { attrs, style, dimensions } = state;
  if (attrs.transform) {
    if (dimensions)
      style.transform = attrs.transform;
    delete attrs.transform;
  }
  if (dimensions && (originX !== void 0 || originY !== void 0 || style.transform)) {
    style.transformOrigin = calcSVGTransformOrigin(dimensions, originX !== void 0 ? originX : 0.5, originY !== void 0 ? originY : 0.5);
  }
  if (attrX !== void 0)
    attrs.x = attrX;
  if (attrY !== void 0)
    attrs.y = attrY;
  if (attrScale !== void 0)
    attrs.scale = attrScale;
  if (pathLength !== void 0) {
    buildSVGPath(attrs, pathLength, pathSpacing, pathOffset, false);
  }
}

// ../../node_modules/framer-motion/dist/es/render/svg/utils/create-render-state.mjs
var createSvgRenderState = () => ({
  ...createHtmlRenderState(),
  attrs: {}
});

// ../../node_modules/framer-motion/dist/es/render/svg/utils/is-svg-tag.mjs
var isSVGTag = (tag) => typeof tag === "string" && tag.toLowerCase() === "svg";

// ../../node_modules/framer-motion/dist/es/render/svg/use-props.mjs
function useSVGProps(props, visualState, _isStatic, Component8) {
  const visualProps = useMemo6(() => {
    const state = createSvgRenderState();
    buildSVGAttrs(state, visualState, { enableHardwareAcceleration: false }, isSVGTag(Component8), props.transformTemplate);
    return {
      ...state.attrs,
      style: { ...state.style }
    };
  }, [visualState]);
  if (props.style) {
    const rawStyles = {};
    copyRawValuesOnly(rawStyles, props.style, props);
    visualProps.style = { ...rawStyles, ...visualProps.style };
  }
  return visualProps;
}

// ../../node_modules/framer-motion/dist/es/render/dom/use-render.mjs
function createUseRender(forwardMotionProps = false) {
  const useRender = (Component8, props, ref, { latestValues }, isStatic) => {
    const useVisualProps = isSVGComponent(Component8) ? useSVGProps : useHTMLProps;
    const visualProps = useVisualProps(props, latestValues, isStatic, Component8);
    const filteredProps = filterProps(props, typeof Component8 === "string", forwardMotionProps);
    const elementProps = {
      ...filteredProps,
      ...visualProps,
      ref
    };
    const { children } = props;
    const renderedChildren = useMemo7(() => isMotionValue(children) ? children.get() : children, [children]);
    return createElement2(Component8, {
      ...elementProps,
      children: renderedChildren
    });
  };
  return useRender;
}

// ../../node_modules/framer-motion/dist/es/render/html/utils/render.mjs
function renderHTML(element, { style, vars }, styleProp, projection) {
  Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
  for (const key in vars) {
    element.style.setProperty(key, vars[key]);
  }
}

// ../../node_modules/framer-motion/dist/es/render/svg/utils/camel-case-attrs.mjs
var camelCaseAttributes = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);

// ../../node_modules/framer-motion/dist/es/render/svg/utils/render.mjs
function renderSVG(element, renderState, _styleProp, projection) {
  renderHTML(element, renderState, void 0, projection);
  for (const key in renderState.attrs) {
    element.setAttribute(!camelCaseAttributes.has(key) ? camelToDash(key) : key, renderState.attrs[key]);
  }
}

// ../../node_modules/framer-motion/dist/es/render/html/utils/scrape-motion-values.mjs
function scrapeMotionValuesFromProps(props, prevProps) {
  const { style } = props;
  const newValues = {};
  for (const key in style) {
    if (isMotionValue(style[key]) || prevProps.style && isMotionValue(prevProps.style[key]) || isForcedMotionValue(key, props)) {
      newValues[key] = style[key];
    }
  }
  return newValues;
}

// ../../node_modules/framer-motion/dist/es/render/svg/utils/scrape-motion-values.mjs
function scrapeMotionValuesFromProps2(props, prevProps) {
  const newValues = scrapeMotionValuesFromProps(props, prevProps);
  for (const key in props) {
    if (isMotionValue(props[key]) || isMotionValue(prevProps[key])) {
      const targetKey = transformPropOrder.indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
      newValues[targetKey] = props[key];
    }
  }
  return newValues;
}

// ../../node_modules/framer-motion/dist/es/motion/utils/use-visual-state.mjs
import { useContext as useContext4 } from "react";

// ../../node_modules/framer-motion/dist/es/render/utils/resolve-variants.mjs
function resolveVariantFromProps(props, definition, custom, currentValues = {}, currentVelocity = {}) {
  if (typeof definition === "function") {
    definition = definition(custom !== void 0 ? custom : props.custom, currentValues, currentVelocity);
  }
  if (typeof definition === "string") {
    definition = props.variants && props.variants[definition];
  }
  if (typeof definition === "function") {
    definition = definition(custom !== void 0 ? custom : props.custom, currentValues, currentVelocity);
  }
  return definition;
}

// ../../node_modules/framer-motion/dist/es/utils/use-constant.mjs
import { useRef as useRef3 } from "react";
function useConstant(init) {
  const ref = useRef3(null);
  if (ref.current === null) {
    ref.current = init();
  }
  return ref.current;
}

// ../../node_modules/framer-motion/dist/es/animation/utils/is-keyframes-target.mjs
var isKeyframesTarget = (v4) => {
  return Array.isArray(v4);
};

// ../../node_modules/framer-motion/dist/es/utils/resolve-value.mjs
var isCustomValue = (v4) => {
  return Boolean(v4 && typeof v4 === "object" && v4.mix && v4.toValue);
};
var resolveFinalValueInKeyframes = (v4) => {
  return isKeyframesTarget(v4) ? v4[v4.length - 1] || 0 : v4;
};

// ../../node_modules/framer-motion/dist/es/value/utils/resolve-motion-value.mjs
function resolveMotionValue(value) {
  const unwrappedValue = isMotionValue(value) ? value.get() : value;
  return isCustomValue(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}

// ../../node_modules/framer-motion/dist/es/motion/utils/use-visual-state.mjs
function makeState({ scrapeMotionValuesFromProps: scrapeMotionValuesFromProps3, createRenderState, onMount }, props, context, presenceContext) {
  const state = {
    latestValues: makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps3),
    renderState: createRenderState()
  };
  if (onMount) {
    state.mount = (instance) => onMount(props, instance, state);
  }
  return state;
}
var makeUseVisualState = (config) => (props, isStatic) => {
  const context = useContext4(MotionContext);
  const presenceContext = useContext4(PresenceContext);
  const make = () => makeState(config, props, context, presenceContext);
  return isStatic ? make() : useConstant(make);
};
function makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
  const values = {};
  const motionValues = scrapeMotionValues(props, {});
  for (const key in motionValues) {
    values[key] = resolveMotionValue(motionValues[key]);
  }
  let { initial, animate } = props;
  const isControllingVariants$1 = isControllingVariants(props);
  const isVariantNode$1 = isVariantNode(props);
  if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
    if (initial === void 0)
      initial = context.initial;
    if (animate === void 0)
      animate = context.animate;
  }
  let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
  isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
  const variantToSet = isInitialAnimationBlocked ? animate : initial;
  if (variantToSet && typeof variantToSet !== "boolean" && !isAnimationControls(variantToSet)) {
    const list2 = Array.isArray(variantToSet) ? variantToSet : [variantToSet];
    list2.forEach((definition) => {
      const resolved = resolveVariantFromProps(props, definition);
      if (!resolved)
        return;
      const { transitionEnd, transition, ...target } = resolved;
      for (const key in target) {
        let valueTarget = target[key];
        if (Array.isArray(valueTarget)) {
          const index2 = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
          valueTarget = valueTarget[index2];
        }
        if (valueTarget !== null) {
          values[key] = valueTarget;
        }
      }
      for (const key in transitionEnd)
        values[key] = transitionEnd[key];
    });
  }
  return values;
}

// ../../node_modules/framer-motion/dist/es/utils/noop.mjs
var noop4 = (any3) => any3;

// ../../node_modules/framer-motion/dist/es/frameloop/render-step.mjs
var Queue = class {
  constructor() {
    this.order = [];
    this.scheduled = /* @__PURE__ */ new Set();
  }
  add(process2) {
    if (!this.scheduled.has(process2)) {
      this.scheduled.add(process2);
      this.order.push(process2);
      return true;
    }
  }
  remove(process2) {
    const index2 = this.order.indexOf(process2);
    if (index2 !== -1) {
      this.order.splice(index2, 1);
      this.scheduled.delete(process2);
    }
  }
  clear() {
    this.order.length = 0;
    this.scheduled.clear();
  }
};
function createRenderStep(runNextFrame) {
  let thisFrame = new Queue();
  let nextFrame = new Queue();
  let numToRun = 0;
  let isProcessing = false;
  let flushNextFrame = false;
  const toKeepAlive = /* @__PURE__ */ new WeakSet();
  const step = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (callback, keepAlive = false, immediate = false) => {
      const addToCurrentFrame = immediate && isProcessing;
      const queue = addToCurrentFrame ? thisFrame : nextFrame;
      if (keepAlive)
        toKeepAlive.add(callback);
      if (queue.add(callback) && addToCurrentFrame && isProcessing) {
        numToRun = thisFrame.order.length;
      }
      return callback;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (callback) => {
      nextFrame.remove(callback);
      toKeepAlive.delete(callback);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (frameData2) => {
      if (isProcessing) {
        flushNextFrame = true;
        return;
      }
      isProcessing = true;
      [thisFrame, nextFrame] = [nextFrame, thisFrame];
      nextFrame.clear();
      numToRun = thisFrame.order.length;
      if (numToRun) {
        for (let i4 = 0; i4 < numToRun; i4++) {
          const callback = thisFrame.order[i4];
          callback(frameData2);
          if (toKeepAlive.has(callback)) {
            step.schedule(callback);
            runNextFrame();
          }
        }
      }
      isProcessing = false;
      if (flushNextFrame) {
        flushNextFrame = false;
        step.process(frameData2);
      }
    }
  };
  return step;
}

// ../../node_modules/framer-motion/dist/es/frameloop/batcher.mjs
var stepsOrder = [
  "prepare",
  "read",
  "update",
  "preRender",
  "render",
  "postRender"
];
var maxElapsed = 40;
function createRenderBatcher(scheduleNextBatch, allowKeepAlive) {
  let runNextFrame = false;
  let useDefaultElapsed = true;
  const state = {
    delta: 0,
    timestamp: 0,
    isProcessing: false
  };
  const steps2 = stepsOrder.reduce((acc, key) => {
    acc[key] = createRenderStep(() => runNextFrame = true);
    return acc;
  }, {});
  const processStep = (stepId) => steps2[stepId].process(state);
  const processBatch = () => {
    const timestamp = performance.now();
    runNextFrame = false;
    state.delta = useDefaultElapsed ? 1e3 / 60 : Math.max(Math.min(timestamp - state.timestamp, maxElapsed), 1);
    state.timestamp = timestamp;
    state.isProcessing = true;
    stepsOrder.forEach(processStep);
    state.isProcessing = false;
    if (runNextFrame && allowKeepAlive) {
      useDefaultElapsed = false;
      scheduleNextBatch(processBatch);
    }
  };
  const wake = () => {
    runNextFrame = true;
    useDefaultElapsed = true;
    if (!state.isProcessing) {
      scheduleNextBatch(processBatch);
    }
  };
  const schedule = stepsOrder.reduce((acc, key) => {
    const step = steps2[key];
    acc[key] = (process2, keepAlive = false, immediate = false) => {
      if (!runNextFrame)
        wake();
      return step.schedule(process2, keepAlive, immediate);
    };
    return acc;
  }, {});
  const cancel = (process2) => stepsOrder.forEach((key) => steps2[key].cancel(process2));
  return { schedule, cancel, state, steps: steps2 };
}

// ../../node_modules/framer-motion/dist/es/frameloop/frame.mjs
var { schedule: frame, cancel: cancelFrame, state: frameData, steps } = createRenderBatcher(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : noop4, true);

// ../../node_modules/framer-motion/dist/es/render/svg/config-motion.mjs
var svgMotionConfig = {
  useVisualState: makeUseVisualState({
    scrapeMotionValuesFromProps: scrapeMotionValuesFromProps2,
    createRenderState: createSvgRenderState,
    onMount: (props, instance, { renderState, latestValues }) => {
      frame.read(() => {
        try {
          renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
        } catch (e4) {
          renderState.dimensions = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
          };
        }
      });
      frame.render(() => {
        buildSVGAttrs(renderState, latestValues, { enableHardwareAcceleration: false }, isSVGTag(instance.tagName), props.transformTemplate);
        renderSVG(instance, renderState);
      });
    }
  })
};

// ../../node_modules/framer-motion/dist/es/render/html/config-motion.mjs
var htmlMotionConfig = {
  useVisualState: makeUseVisualState({
    scrapeMotionValuesFromProps,
    createRenderState: createHtmlRenderState
  })
};

// ../../node_modules/framer-motion/dist/es/render/dom/utils/create-config.mjs
function createDomMotionConfig(Component8, { forwardMotionProps = false }, preloadedFeatures2, createVisualElement) {
  const baseConfig = isSVGComponent(Component8) ? svgMotionConfig : htmlMotionConfig;
  return {
    ...baseConfig,
    preloadedFeatures: preloadedFeatures2,
    useRender: createUseRender(forwardMotionProps),
    createVisualElement,
    Component: Component8
  };
}

// ../../node_modules/framer-motion/dist/es/events/add-dom-event.mjs
function addDomEvent(target, eventName, handler, options7 = { passive: true }) {
  target.addEventListener(eventName, handler, options7);
  return () => target.removeEventListener(eventName, handler);
}

// ../../node_modules/framer-motion/dist/es/events/utils/is-primary-pointer.mjs
var isPrimaryPointer = (event) => {
  if (event.pointerType === "mouse") {
    return typeof event.button !== "number" || event.button <= 0;
  } else {
    return event.isPrimary !== false;
  }
};

// ../../node_modules/framer-motion/dist/es/events/event-info.mjs
function extractEventInfo(event, pointType = "page") {
  return {
    point: {
      x: event[pointType + "X"],
      y: event[pointType + "Y"]
    }
  };
}
var addPointerInfo = (handler) => {
  return (event) => isPrimaryPointer(event) && handler(event, extractEventInfo(event));
};

// ../../node_modules/framer-motion/dist/es/events/add-pointer-event.mjs
function addPointerEvent(target, eventName, handler, options7) {
  return addDomEvent(target, eventName, addPointerInfo(handler), options7);
}

// ../../node_modules/framer-motion/dist/es/utils/pipe.mjs
var combineFunctions = (a4, b3) => (v4) => b3(a4(v4));
var pipe = (...transformers) => transformers.reduce(combineFunctions);

// ../../node_modules/framer-motion/dist/es/gestures/drag/utils/lock.mjs
function createLock(name) {
  let lock = null;
  return () => {
    const openLock = () => {
      lock = null;
    };
    if (lock === null) {
      lock = name;
      return openLock;
    }
    return false;
  };
}
var globalHorizontalLock = createLock("dragHorizontal");
var globalVerticalLock = createLock("dragVertical");
function getGlobalLock(drag2) {
  let lock = false;
  if (drag2 === "y") {
    lock = globalVerticalLock();
  } else if (drag2 === "x") {
    lock = globalHorizontalLock();
  } else {
    const openHorizontal = globalHorizontalLock();
    const openVertical = globalVerticalLock();
    if (openHorizontal && openVertical) {
      lock = () => {
        openHorizontal();
        openVertical();
      };
    } else {
      if (openHorizontal)
        openHorizontal();
      if (openVertical)
        openVertical();
    }
  }
  return lock;
}
function isDragActive() {
  const openGestureLock = getGlobalLock(true);
  if (!openGestureLock)
    return true;
  openGestureLock();
  return false;
}

// ../../node_modules/framer-motion/dist/es/motion/features/Feature.mjs
var Feature = class {
  constructor(node566) {
    this.isMounted = false;
    this.node = node566;
  }
  update() {
  }
};

// ../../node_modules/framer-motion/dist/es/gestures/hover.mjs
function addHoverEvent(node566, isActive) {
  const eventName = "pointer" + (isActive ? "enter" : "leave");
  const callbackName = "onHover" + (isActive ? "Start" : "End");
  const handleEvent = (event, info) => {
    if (event.pointerType === "touch" || isDragActive())
      return;
    const props = node566.getProps();
    if (node566.animationState && props.whileHover) {
      node566.animationState.setActive("whileHover", isActive);
    }
    if (props[callbackName]) {
      frame.update(() => props[callbackName](event, info));
    }
  };
  return addPointerEvent(node566.current, eventName, handleEvent, {
    passive: !node566.getProps()[callbackName]
  });
}
var HoverGesture = class extends Feature {
  mount() {
    this.unmount = pipe(addHoverEvent(this.node, true), addHoverEvent(this.node, false));
  }
  unmount() {
  }
};

// ../../node_modules/framer-motion/dist/es/gestures/focus.mjs
var FocusGesture = class extends Feature {
  constructor() {
    super(...arguments);
    this.isActive = false;
  }
  onFocus() {
    let isFocusVisible = false;
    try {
      isFocusVisible = this.node.current.matches(":focus-visible");
    } catch (e4) {
      isFocusVisible = true;
    }
    if (!isFocusVisible || !this.node.animationState)
      return;
    this.node.animationState.setActive("whileFocus", true);
    this.isActive = true;
  }
  onBlur() {
    if (!this.isActive || !this.node.animationState)
      return;
    this.node.animationState.setActive("whileFocus", false);
    this.isActive = false;
  }
  mount() {
    this.unmount = pipe(addDomEvent(this.node.current, "focus", () => this.onFocus()), addDomEvent(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
};

// ../../node_modules/framer-motion/dist/es/gestures/utils/is-node-or-child.mjs
var isNodeOrChild = (parent, child) => {
  if (!child) {
    return false;
  } else if (parent === child) {
    return true;
  } else {
    return isNodeOrChild(parent, child.parentElement);
  }
};

// ../../node_modules/framer-motion/dist/es/gestures/press.mjs
function fireSyntheticPointerEvent(name, handler) {
  if (!handler)
    return;
  const syntheticPointerEvent = new PointerEvent("pointer" + name);
  handler(syntheticPointerEvent, extractEventInfo(syntheticPointerEvent));
}
var PressGesture = class extends Feature {
  constructor() {
    super(...arguments);
    this.removeStartListeners = noop4;
    this.removeEndListeners = noop4;
    this.removeAccessibleListeners = noop4;
    this.startPointerPress = (startEvent, startInfo) => {
      if (this.isPressing)
        return;
      this.removeEndListeners();
      const props = this.node.getProps();
      const endPointerPress = (endEvent, endInfo) => {
        if (!this.checkPressEnd())
          return;
        const { onTap, onTapCancel, globalTapTarget } = this.node.getProps();
        frame.update(() => {
          !globalTapTarget && !isNodeOrChild(this.node.current, endEvent.target) ? onTapCancel && onTapCancel(endEvent, endInfo) : onTap && onTap(endEvent, endInfo);
        });
      };
      const removePointerUpListener = addPointerEvent(window, "pointerup", endPointerPress, { passive: !(props.onTap || props["onPointerUp"]) });
      const removePointerCancelListener = addPointerEvent(window, "pointercancel", (cancelEvent, cancelInfo) => this.cancelPress(cancelEvent, cancelInfo), { passive: !(props.onTapCancel || props["onPointerCancel"]) });
      this.removeEndListeners = pipe(removePointerUpListener, removePointerCancelListener);
      this.startPress(startEvent, startInfo);
    };
    this.startAccessiblePress = () => {
      const handleKeydown = (keydownEvent) => {
        if (keydownEvent.key !== "Enter" || this.isPressing)
          return;
        const handleKeyup = (keyupEvent) => {
          if (keyupEvent.key !== "Enter" || !this.checkPressEnd())
            return;
          fireSyntheticPointerEvent("up", (event, info) => {
            const { onTap } = this.node.getProps();
            if (onTap) {
              frame.update(() => onTap(event, info));
            }
          });
        };
        this.removeEndListeners();
        this.removeEndListeners = addDomEvent(this.node.current, "keyup", handleKeyup);
        fireSyntheticPointerEvent("down", (event, info) => {
          this.startPress(event, info);
        });
      };
      const removeKeydownListener = addDomEvent(this.node.current, "keydown", handleKeydown);
      const handleBlur = () => {
        if (!this.isPressing)
          return;
        fireSyntheticPointerEvent("cancel", (cancelEvent, cancelInfo) => this.cancelPress(cancelEvent, cancelInfo));
      };
      const removeBlurListener = addDomEvent(this.node.current, "blur", handleBlur);
      this.removeAccessibleListeners = pipe(removeKeydownListener, removeBlurListener);
    };
  }
  startPress(event, info) {
    this.isPressing = true;
    const { onTapStart, whileTap } = this.node.getProps();
    if (whileTap && this.node.animationState) {
      this.node.animationState.setActive("whileTap", true);
    }
    if (onTapStart) {
      frame.update(() => onTapStart(event, info));
    }
  }
  checkPressEnd() {
    this.removeEndListeners();
    this.isPressing = false;
    const props = this.node.getProps();
    if (props.whileTap && this.node.animationState) {
      this.node.animationState.setActive("whileTap", false);
    }
    return !isDragActive();
  }
  cancelPress(event, info) {
    if (!this.checkPressEnd())
      return;
    const { onTapCancel } = this.node.getProps();
    if (onTapCancel) {
      frame.update(() => onTapCancel(event, info));
    }
  }
  mount() {
    const props = this.node.getProps();
    const removePointerListener = addPointerEvent(props.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, { passive: !(props.onTapStart || props["onPointerStart"]) });
    const removeFocusListener = addDomEvent(this.node.current, "focus", this.startAccessiblePress);
    this.removeStartListeners = pipe(removePointerListener, removeFocusListener);
  }
  unmount() {
    this.removeStartListeners();
    this.removeEndListeners();
    this.removeAccessibleListeners();
  }
};

// ../../node_modules/framer-motion/dist/es/motion/features/viewport/observers.mjs
var observerCallbacks = /* @__PURE__ */ new WeakMap();
var observers = /* @__PURE__ */ new WeakMap();
var fireObserverCallback = (entry) => {
  const callback = observerCallbacks.get(entry.target);
  callback && callback(entry);
};
var fireAllObserverCallbacks = (entries) => {
  entries.forEach(fireObserverCallback);
};
function initIntersectionObserver({ root, ...options7 }) {
  const lookupRoot = root || document;
  if (!observers.has(lookupRoot)) {
    observers.set(lookupRoot, {});
  }
  const rootObservers = observers.get(lookupRoot);
  const key = JSON.stringify(options7);
  if (!rootObservers[key]) {
    rootObservers[key] = new IntersectionObserver(fireAllObserverCallbacks, { root, ...options7 });
  }
  return rootObservers[key];
}
function observeIntersection(element, options7, callback) {
  const rootInteresectionObserver = initIntersectionObserver(options7);
  observerCallbacks.set(element, callback);
  rootInteresectionObserver.observe(element);
  return () => {
    observerCallbacks.delete(element);
    rootInteresectionObserver.unobserve(element);
  };
}

// ../../node_modules/framer-motion/dist/es/motion/features/viewport/index.mjs
var thresholdNames = {
  some: 0,
  all: 1
};
var InViewFeature = class extends Feature {
  constructor() {
    super(...arguments);
    this.hasEnteredView = false;
    this.isInView = false;
  }
  startObserver() {
    this.unmount();
    const { viewport = {} } = this.node.getProps();
    const { root, margin: rootMargin, amount = "some", once } = viewport;
    const options7 = {
      root: root ? root.current : void 0,
      rootMargin,
      threshold: typeof amount === "number" ? amount : thresholdNames[amount]
    };
    const onIntersectionUpdate = (entry) => {
      const { isIntersecting } = entry;
      if (this.isInView === isIntersecting)
        return;
      this.isInView = isIntersecting;
      if (once && !isIntersecting && this.hasEnteredView) {
        return;
      } else if (isIntersecting) {
        this.hasEnteredView = true;
      }
      if (this.node.animationState) {
        this.node.animationState.setActive("whileInView", isIntersecting);
      }
      const { onViewportEnter, onViewportLeave } = this.node.getProps();
      const callback = isIntersecting ? onViewportEnter : onViewportLeave;
      callback && callback(entry);
    };
    return observeIntersection(this.node.current, options7, onIntersectionUpdate);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver === "undefined")
      return;
    const { props, prevProps } = this.node;
    const hasOptionsChanged = ["amount", "margin", "root"].some(hasViewportOptionChanged(props, prevProps));
    if (hasOptionsChanged) {
      this.startObserver();
    }
  }
  unmount() {
  }
};
function hasViewportOptionChanged({ viewport = {} }, { viewport: prevViewport = {} } = {}) {
  return (name) => viewport[name] !== prevViewport[name];
}

// ../../node_modules/framer-motion/dist/es/motion/features/gestures.mjs
var gestureAnimations = {
  inView: {
    Feature: InViewFeature
  },
  tap: {
    Feature: PressGesture
  },
  focus: {
    Feature: FocusGesture
  },
  hover: {
    Feature: HoverGesture
  }
};

// ../../node_modules/framer-motion/dist/es/utils/shallow-compare.mjs
function shallowCompare(next, prev) {
  if (!Array.isArray(prev))
    return false;
  const prevLength = prev.length;
  if (prevLength !== next.length)
    return false;
  for (let i4 = 0; i4 < prevLength; i4++) {
    if (prev[i4] !== next[i4])
      return false;
  }
  return true;
}

// ../../node_modules/framer-motion/dist/es/render/utils/resolve-dynamic-variants.mjs
function getCurrent(visualElement) {
  const current = {};
  visualElement.values.forEach((value, key) => current[key] = value.get());
  return current;
}
function getVelocity(visualElement) {
  const velocity = {};
  visualElement.values.forEach((value, key) => velocity[key] = value.getVelocity());
  return velocity;
}
function resolveVariant(visualElement, definition, custom) {
  const props = visualElement.getProps();
  return resolveVariantFromProps(props, definition, custom !== void 0 ? custom : props.custom, getCurrent(visualElement), getVelocity(visualElement));
}

// ../../node_modules/framer-motion/dist/es/utils/errors.mjs
var warning = noop4;
var invariant = noop4;
if (process.env.NODE_ENV !== "production") {
  warning = (check, message) => {
    if (!check && typeof console !== "undefined") {
      console.warn(message);
    }
  };
  invariant = (check, message) => {
    if (!check) {
      throw new Error(message);
    }
  };
}

// ../../node_modules/framer-motion/dist/es/utils/time-conversion.mjs
var secondsToMilliseconds = (seconds) => seconds * 1e3;
var millisecondsToSeconds = (milliseconds) => milliseconds / 1e3;

// ../../node_modules/framer-motion/dist/es/utils/use-instant-transition-state.mjs
var instantAnimationState = {
  current: false
};

// ../../node_modules/framer-motion/dist/es/easing/utils/is-bezier-definition.mjs
var isBezierDefinition = (easing) => Array.isArray(easing) && typeof easing[0] === "number";

// ../../node_modules/framer-motion/dist/es/animation/animators/waapi/easing.mjs
function isWaapiSupportedEasing(easing) {
  return Boolean(!easing || typeof easing === "string" && supportedWaapiEasing[easing] || isBezierDefinition(easing) || Array.isArray(easing) && easing.every(isWaapiSupportedEasing));
}
var cubicBezierAsString = ([a4, b3, c4, d4]) => `cubic-bezier(${a4}, ${b3}, ${c4}, ${d4})`;
var supportedWaapiEasing = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: cubicBezierAsString([0, 0.65, 0.55, 1]),
  circOut: cubicBezierAsString([0.55, 0, 1, 0.45]),
  backIn: cubicBezierAsString([0.31, 0.01, 0.66, -0.59]),
  backOut: cubicBezierAsString([0.33, 1.53, 0.69, 0.99])
};
function mapEasingToNativeEasing(easing) {
  if (!easing)
    return void 0;
  return isBezierDefinition(easing) ? cubicBezierAsString(easing) : Array.isArray(easing) ? easing.map(mapEasingToNativeEasing) : supportedWaapiEasing[easing];
}

// ../../node_modules/framer-motion/dist/es/animation/animators/waapi/index.mjs
function animateStyle(element, valueName, keyframes2, { delay: delay2 = 0, duration: duration2, repeat = 0, repeatType = "loop", ease: ease2, times } = {}) {
  const keyframeOptions = { [valueName]: keyframes2 };
  if (times)
    keyframeOptions.offset = times;
  const easing = mapEasingToNativeEasing(ease2);
  if (Array.isArray(easing))
    keyframeOptions.easing = easing;
  return element.animate(keyframeOptions, {
    delay: delay2,
    duration: duration2,
    easing: !Array.isArray(easing) ? easing : "linear",
    fill: "both",
    iterations: repeat + 1,
    direction: repeatType === "reverse" ? "alternate" : "normal"
  });
}

// ../../node_modules/framer-motion/dist/es/animation/animators/waapi/utils/get-final-keyframe.mjs
function getFinalKeyframe(keyframes2, { repeat, repeatType = "loop" }) {
  const index2 = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : keyframes2.length - 1;
  return keyframes2[index2];
}

// ../../node_modules/framer-motion/dist/es/easing/cubic-bezier.mjs
var calcBezier = (t4, a1, a23) => (((1 - 3 * a23 + 3 * a1) * t4 + (3 * a23 - 6 * a1)) * t4 + 3 * a1) * t4;
var subdivisionPrecision = 1e-7;
var subdivisionMaxIterations = 12;
function binarySubdivide(x4, lowerBound2, upperBound, mX1, mX2) {
  let currentX;
  let currentT;
  let i4 = 0;
  do {
    currentT = lowerBound2 + (upperBound - lowerBound2) / 2;
    currentX = calcBezier(currentT, mX1, mX2) - x4;
    if (currentX > 0) {
      upperBound = currentT;
    } else {
      lowerBound2 = currentT;
    }
  } while (Math.abs(currentX) > subdivisionPrecision && ++i4 < subdivisionMaxIterations);
  return currentT;
}
function cubicBezier(mX1, mY1, mX2, mY2) {
  if (mX1 === mY1 && mX2 === mY2)
    return noop4;
  const getTForX = (aX) => binarySubdivide(aX, 0, 1, mX1, mX2);
  return (t4) => t4 === 0 || t4 === 1 ? t4 : calcBezier(getTForX(t4), mY1, mY2);
}

// ../../node_modules/framer-motion/dist/es/easing/ease.mjs
var easeIn = cubicBezier(0.42, 0, 1, 1);
var easeOut = cubicBezier(0, 0, 0.58, 1);
var easeInOut = cubicBezier(0.42, 0, 0.58, 1);

// ../../node_modules/framer-motion/dist/es/easing/utils/is-easing-array.mjs
var isEasingArray = (ease2) => {
  return Array.isArray(ease2) && typeof ease2[0] !== "number";
};

// ../../node_modules/framer-motion/dist/es/easing/modifiers/mirror.mjs
var mirrorEasing = (easing) => (p4) => p4 <= 0.5 ? easing(2 * p4) / 2 : (2 - easing(2 * (1 - p4))) / 2;

// ../../node_modules/framer-motion/dist/es/easing/modifiers/reverse.mjs
var reverseEasing = (easing) => (p4) => 1 - easing(1 - p4);

// ../../node_modules/framer-motion/dist/es/easing/circ.mjs
var circIn = (p4) => 1 - Math.sin(Math.acos(p4));
var circOut = reverseEasing(circIn);
var circInOut = mirrorEasing(circIn);

// ../../node_modules/framer-motion/dist/es/easing/back.mjs
var backOut = cubicBezier(0.33, 1.53, 0.69, 0.99);
var backIn = reverseEasing(backOut);
var backInOut = mirrorEasing(backIn);

// ../../node_modules/framer-motion/dist/es/easing/anticipate.mjs
var anticipate = (p4) => (p4 *= 2) < 1 ? 0.5 * backIn(p4) : 0.5 * (2 - Math.pow(2, -10 * (p4 - 1)));

// ../../node_modules/framer-motion/dist/es/easing/utils/map.mjs
var easingLookup = {
  linear: noop4,
  easeIn,
  easeInOut,
  easeOut,
  circIn,
  circInOut,
  circOut,
  backIn,
  backInOut,
  backOut,
  anticipate
};
var easingDefinitionToFunction = (definition) => {
  if (Array.isArray(definition)) {
    invariant(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
    const [x1, y1, x23, y23] = definition;
    return cubicBezier(x1, y1, x23, y23);
  } else if (typeof definition === "string") {
    invariant(easingLookup[definition] !== void 0, `Invalid easing type '${definition}'`);
    return easingLookup[definition];
  }
  return definition;
};

// ../../node_modules/framer-motion/dist/es/value/types/color/utils.mjs
var isColorString = (type, testProp) => (v4) => {
  return Boolean(isString(v4) && singleColorRegex.test(v4) && v4.startsWith(type) || testProp && Object.prototype.hasOwnProperty.call(v4, testProp));
};
var splitColor = (aName, bName, cName) => (v4) => {
  if (!isString(v4))
    return v4;
  const [a4, b3, c4, alpha2] = v4.match(floatRegex);
  return {
    [aName]: parseFloat(a4),
    [bName]: parseFloat(b3),
    [cName]: parseFloat(c4),
    alpha: alpha2 !== void 0 ? parseFloat(alpha2) : 1
  };
};

// ../../node_modules/framer-motion/dist/es/value/types/color/rgba.mjs
var clampRgbUnit = (v4) => clamp(0, 255, v4);
var rgbUnit = {
  ...number,
  transform: (v4) => Math.round(clampRgbUnit(v4))
};
var rgba = {
  test: isColorString("rgb", "red"),
  parse: splitColor("red", "green", "blue"),
  transform: ({ red, green, blue, alpha: alpha$1 = 1 }) => "rgba(" + rgbUnit.transform(red) + ", " + rgbUnit.transform(green) + ", " + rgbUnit.transform(blue) + ", " + sanitize(alpha.transform(alpha$1)) + ")"
};

// ../../node_modules/framer-motion/dist/es/value/types/color/hex.mjs
function parseHex(v4) {
  let r4 = "";
  let g3 = "";
  let b3 = "";
  let a4 = "";
  if (v4.length > 5) {
    r4 = v4.substring(1, 3);
    g3 = v4.substring(3, 5);
    b3 = v4.substring(5, 7);
    a4 = v4.substring(7, 9);
  } else {
    r4 = v4.substring(1, 2);
    g3 = v4.substring(2, 3);
    b3 = v4.substring(3, 4);
    a4 = v4.substring(4, 5);
    r4 += r4;
    g3 += g3;
    b3 += b3;
    a4 += a4;
  }
  return {
    red: parseInt(r4, 16),
    green: parseInt(g3, 16),
    blue: parseInt(b3, 16),
    alpha: a4 ? parseInt(a4, 16) / 255 : 1
  };
}
var hex = {
  test: isColorString("#"),
  parse: parseHex,
  transform: rgba.transform
};

// ../../node_modules/framer-motion/dist/es/value/types/color/hsla.mjs
var hsla = {
  test: isColorString("hsl", "hue"),
  parse: splitColor("hue", "saturation", "lightness"),
  transform: ({ hue, saturation, lightness, alpha: alpha$1 = 1 }) => {
    return "hsla(" + Math.round(hue) + ", " + percent.transform(sanitize(saturation)) + ", " + percent.transform(sanitize(lightness)) + ", " + sanitize(alpha.transform(alpha$1)) + ")";
  }
};

// ../../node_modules/framer-motion/dist/es/value/types/color/index.mjs
var color = {
  test: (v4) => rgba.test(v4) || hex.test(v4) || hsla.test(v4),
  parse: (v4) => {
    if (rgba.test(v4)) {
      return rgba.parse(v4);
    } else if (hsla.test(v4)) {
      return hsla.parse(v4);
    } else {
      return hex.parse(v4);
    }
  },
  transform: (v4) => {
    return isString(v4) ? v4 : v4.hasOwnProperty("red") ? rgba.transform(v4) : hsla.transform(v4);
  }
};

// ../../node_modules/framer-motion/dist/es/utils/mix.mjs
var mix = (from, to, progress2) => -progress2 * from + progress2 * to + from;

// ../../node_modules/framer-motion/dist/es/utils/hsla-to-rgba.mjs
function hueToRgb(p4, q4, t4) {
  if (t4 < 0)
    t4 += 1;
  if (t4 > 1)
    t4 -= 1;
  if (t4 < 1 / 6)
    return p4 + (q4 - p4) * 6 * t4;
  if (t4 < 1 / 2)
    return q4;
  if (t4 < 2 / 3)
    return p4 + (q4 - p4) * (2 / 3 - t4) * 6;
  return p4;
}
function hslaToRgba({ hue, saturation, lightness, alpha: alpha2 }) {
  hue /= 360;
  saturation /= 100;
  lightness /= 100;
  let red = 0;
  let green = 0;
  let blue = 0;
  if (!saturation) {
    red = green = blue = lightness;
  } else {
    const q4 = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
    const p4 = 2 * lightness - q4;
    red = hueToRgb(p4, q4, hue + 1 / 3);
    green = hueToRgb(p4, q4, hue);
    blue = hueToRgb(p4, q4, hue - 1 / 3);
  }
  return {
    red: Math.round(red * 255),
    green: Math.round(green * 255),
    blue: Math.round(blue * 255),
    alpha: alpha2
  };
}

// ../../node_modules/framer-motion/dist/es/utils/mix-color.mjs
var mixLinearColor = (from, to, v4) => {
  const fromExpo = from * from;
  return Math.sqrt(Math.max(0, v4 * (to * to - fromExpo) + fromExpo));
};
var colorTypes = [hex, rgba, hsla];
var getColorType = (v4) => colorTypes.find((type) => type.test(v4));
function asRGBA(color2) {
  const type = getColorType(color2);
  invariant(Boolean(type), `'${color2}' is not an animatable color. Use the equivalent color code instead.`);
  let model = type.parse(color2);
  if (type === hsla) {
    model = hslaToRgba(model);
  }
  return model;
}
var mixColor = (from, to) => {
  const fromRGBA = asRGBA(from);
  const toRGBA = asRGBA(to);
  const blended = { ...fromRGBA };
  return (v4) => {
    blended.red = mixLinearColor(fromRGBA.red, toRGBA.red, v4);
    blended.green = mixLinearColor(fromRGBA.green, toRGBA.green, v4);
    blended.blue = mixLinearColor(fromRGBA.blue, toRGBA.blue, v4);
    blended.alpha = mix(fromRGBA.alpha, toRGBA.alpha, v4);
    return rgba.transform(blended);
  };
};

// ../../node_modules/framer-motion/dist/es/value/types/complex/index.mjs
function test(v4) {
  var _a, _b;
  return isNaN(v4) && isString(v4) && (((_a = v4.match(floatRegex)) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v4.match(colorRegex)) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
var cssVarTokeniser = {
  regex: cssVariableRegex,
  countKey: "Vars",
  token: "${v}",
  parse: noop4
};
var colorTokeniser = {
  regex: colorRegex,
  countKey: "Colors",
  token: "${c}",
  parse: color.parse
};
var numberTokeniser = {
  regex: floatRegex,
  countKey: "Numbers",
  token: "${n}",
  parse: number.parse
};
function tokenise(info, { regex, countKey, token, parse: parse2 }) {
  const matches = info.tokenised.match(regex);
  if (!matches)
    return;
  info["num" + countKey] = matches.length;
  info.tokenised = info.tokenised.replace(regex, token);
  info.values.push(...matches.map(parse2));
}
function analyseComplexValue(value) {
  const originalValue = value.toString();
  const info = {
    value: originalValue,
    tokenised: originalValue,
    values: [],
    numVars: 0,
    numColors: 0,
    numNumbers: 0
  };
  if (info.value.includes("var(--"))
    tokenise(info, cssVarTokeniser);
  tokenise(info, colorTokeniser);
  tokenise(info, numberTokeniser);
  return info;
}
function parseComplexValue(v4) {
  return analyseComplexValue(v4).values;
}
function createTransformer(source) {
  const { values, numColors, numVars, tokenised } = analyseComplexValue(source);
  const numValues = values.length;
  return (v4) => {
    let output = tokenised;
    for (let i4 = 0; i4 < numValues; i4++) {
      if (i4 < numVars) {
        output = output.replace(cssVarTokeniser.token, v4[i4]);
      } else if (i4 < numVars + numColors) {
        output = output.replace(colorTokeniser.token, color.transform(v4[i4]));
      } else {
        output = output.replace(numberTokeniser.token, sanitize(v4[i4]));
      }
    }
    return output;
  };
}
var convertNumbersToZero = (v4) => typeof v4 === "number" ? 0 : v4;
function getAnimatableNone(v4) {
  const parsed = parseComplexValue(v4);
  const transformer = createTransformer(v4);
  return transformer(parsed.map(convertNumbersToZero));
}
var complex = {
  test,
  parse: parseComplexValue,
  createTransformer,
  getAnimatableNone
};

// ../../node_modules/framer-motion/dist/es/utils/mix-complex.mjs
var mixImmediate = (origin, target) => (p4) => `${p4 > 0 ? target : origin}`;
function getMixer(origin, target) {
  if (typeof origin === "number") {
    return (v4) => mix(origin, target, v4);
  } else if (color.test(origin)) {
    return mixColor(origin, target);
  } else {
    return origin.startsWith("var(") ? mixImmediate(origin, target) : mixComplex(origin, target);
  }
}
var mixArray = (from, to) => {
  const output = [...from];
  const numValues = output.length;
  const blendValue = from.map((fromThis, i4) => getMixer(fromThis, to[i4]));
  return (v4) => {
    for (let i4 = 0; i4 < numValues; i4++) {
      output[i4] = blendValue[i4](v4);
    }
    return output;
  };
};
var mixObject = (origin, target) => {
  const output = { ...origin, ...target };
  const blendValue = {};
  for (const key in output) {
    if (origin[key] !== void 0 && target[key] !== void 0) {
      blendValue[key] = getMixer(origin[key], target[key]);
    }
  }
  return (v4) => {
    for (const key in blendValue) {
      output[key] = blendValue[key](v4);
    }
    return output;
  };
};
var mixComplex = (origin, target) => {
  const template = complex.createTransformer(target);
  const originStats = analyseComplexValue(origin);
  const targetStats = analyseComplexValue(target);
  const canInterpolate = originStats.numVars === targetStats.numVars && originStats.numColors === targetStats.numColors && originStats.numNumbers >= targetStats.numNumbers;
  if (canInterpolate) {
    return pipe(mixArray(originStats.values, targetStats.values), template);
  } else {
    warning(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
    return mixImmediate(origin, target);
  }
};

// ../../node_modules/framer-motion/dist/es/utils/progress.mjs
var progress = (from, to, value) => {
  const toFromDifference = to - from;
  return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};

// ../../node_modules/framer-motion/dist/es/utils/interpolate.mjs
var mixNumber = (from, to) => (p4) => mix(from, to, p4);
function detectMixerFactory(v4) {
  if (typeof v4 === "number") {
    return mixNumber;
  } else if (typeof v4 === "string") {
    return color.test(v4) ? mixColor : mixComplex;
  } else if (Array.isArray(v4)) {
    return mixArray;
  } else if (typeof v4 === "object") {
    return mixObject;
  }
  return mixNumber;
}
function createMixers(output, ease2, customMixer) {
  const mixers = [];
  const mixerFactory = customMixer || detectMixerFactory(output[0]);
  const numMixers = output.length - 1;
  for (let i4 = 0; i4 < numMixers; i4++) {
    let mixer = mixerFactory(output[i4], output[i4 + 1]);
    if (ease2) {
      const easingFunction = Array.isArray(ease2) ? ease2[i4] || noop4 : ease2;
      mixer = pipe(easingFunction, mixer);
    }
    mixers.push(mixer);
  }
  return mixers;
}
function interpolate(input, output, { clamp: isClamp = true, ease: ease2, mixer } = {}) {
  const inputLength = input.length;
  invariant(inputLength === output.length, "Both input and output ranges must be the same length");
  if (inputLength === 1)
    return () => output[0];
  if (input[0] > input[inputLength - 1]) {
    input = [...input].reverse();
    output = [...output].reverse();
  }
  const mixers = createMixers(output, ease2, mixer);
  const numMixers = mixers.length;
  const interpolator = (v4) => {
    let i4 = 0;
    if (numMixers > 1) {
      for (; i4 < input.length - 2; i4++) {
        if (v4 < input[i4 + 1])
          break;
      }
    }
    const progressInRange = progress(input[i4], input[i4 + 1], v4);
    return mixers[i4](progressInRange);
  };
  return isClamp ? (v4) => interpolator(clamp(input[0], input[inputLength - 1], v4)) : interpolator;
}

// ../../node_modules/framer-motion/dist/es/utils/offsets/fill.mjs
function fillOffset(offset, remaining) {
  const min = offset[offset.length - 1];
  for (let i4 = 1; i4 <= remaining; i4++) {
    const offsetProgress = progress(0, remaining, i4);
    offset.push(mix(min, 1, offsetProgress));
  }
}

// ../../node_modules/framer-motion/dist/es/utils/offsets/default.mjs
function defaultOffset(arr) {
  const offset = [0];
  fillOffset(offset, arr.length - 1);
  return offset;
}

// ../../node_modules/framer-motion/dist/es/utils/offsets/time.mjs
function convertOffsetToTimes(offset, duration2) {
  return offset.map((o4) => o4 * duration2);
}

// ../../node_modules/framer-motion/dist/es/animation/generators/keyframes.mjs
function defaultEasing(values, easing) {
  return values.map(() => easing || easeInOut).splice(0, values.length - 1);
}
function keyframes({ duration: duration2 = 300, keyframes: keyframeValues, times, ease: ease2 = "easeInOut" }) {
  const easingFunctions = isEasingArray(ease2) ? ease2.map(easingDefinitionToFunction) : easingDefinitionToFunction(ease2);
  const state = {
    done: false,
    value: keyframeValues[0]
  };
  const absoluteTimes = convertOffsetToTimes(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : defaultOffset(keyframeValues),
    duration2
  );
  const mapTimeToKeyframe = interpolate(absoluteTimes, keyframeValues, {
    ease: Array.isArray(easingFunctions) ? easingFunctions : defaultEasing(keyframeValues, easingFunctions)
  });
  return {
    calculatedDuration: duration2,
    next: (t4) => {
      state.value = mapTimeToKeyframe(t4);
      state.done = t4 >= duration2;
      return state;
    }
  };
}

// ../../node_modules/framer-motion/dist/es/utils/velocity-per-second.mjs
function velocityPerSecond(velocity, frameDuration) {
  return frameDuration ? velocity * (1e3 / frameDuration) : 0;
}

// ../../node_modules/framer-motion/dist/es/animation/generators/utils/velocity.mjs
var velocitySampleDuration = 5;
function calcGeneratorVelocity(resolveValue, t4, current) {
  const prevT = Math.max(t4 - velocitySampleDuration, 0);
  return velocityPerSecond(current - resolveValue(prevT), t4 - prevT);
}

// ../../node_modules/framer-motion/dist/es/animation/generators/spring/find.mjs
var safeMin = 1e-3;
var minDuration = 0.01;
var maxDuration = 10;
var minDamping = 0.05;
var maxDamping = 1;
function findSpring({ duration: duration2 = 800, bounce = 0.25, velocity = 0, mass = 1 }) {
  let envelope;
  let derivative;
  warning(duration2 <= secondsToMilliseconds(maxDuration), "Spring duration must be 10 seconds or less");
  let dampingRatio = 1 - bounce;
  dampingRatio = clamp(minDamping, maxDamping, dampingRatio);
  duration2 = clamp(minDuration, maxDuration, millisecondsToSeconds(duration2));
  if (dampingRatio < 1) {
    envelope = (undampedFreq2) => {
      const exponentialDecay = undampedFreq2 * dampingRatio;
      const delta = exponentialDecay * duration2;
      const a4 = exponentialDecay - velocity;
      const b3 = calcAngularFreq(undampedFreq2, dampingRatio);
      const c4 = Math.exp(-delta);
      return safeMin - a4 / b3 * c4;
    };
    derivative = (undampedFreq2) => {
      const exponentialDecay = undampedFreq2 * dampingRatio;
      const delta = exponentialDecay * duration2;
      const d4 = delta * velocity + velocity;
      const e4 = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq2, 2) * duration2;
      const f4 = Math.exp(-delta);
      const g3 = calcAngularFreq(Math.pow(undampedFreq2, 2), dampingRatio);
      const factor = -envelope(undampedFreq2) + safeMin > 0 ? -1 : 1;
      return factor * ((d4 - e4) * f4) / g3;
    };
  } else {
    envelope = (undampedFreq2) => {
      const a4 = Math.exp(-undampedFreq2 * duration2);
      const b3 = (undampedFreq2 - velocity) * duration2 + 1;
      return -safeMin + a4 * b3;
    };
    derivative = (undampedFreq2) => {
      const a4 = Math.exp(-undampedFreq2 * duration2);
      const b3 = (velocity - undampedFreq2) * (duration2 * duration2);
      return a4 * b3;
    };
  }
  const initialGuess = 5 / duration2;
  const undampedFreq = approximateRoot(envelope, derivative, initialGuess);
  duration2 = secondsToMilliseconds(duration2);
  if (isNaN(undampedFreq)) {
    return {
      stiffness: 100,
      damping: 10,
      duration: duration2
    };
  } else {
    const stiffness = Math.pow(undampedFreq, 2) * mass;
    return {
      stiffness,
      damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
      duration: duration2
    };
  }
}
var rootIterations = 12;
function approximateRoot(envelope, derivative, initialGuess) {
  let result = initialGuess;
  for (let i4 = 1; i4 < rootIterations; i4++) {
    result = result - envelope(result) / derivative(result);
  }
  return result;
}
function calcAngularFreq(undampedFreq, dampingRatio) {
  return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}

// ../../node_modules/framer-motion/dist/es/animation/generators/spring/index.mjs
var durationKeys = ["duration", "bounce"];
var physicsKeys = ["stiffness", "damping", "mass"];
function isSpringType(options7, keys) {
  return keys.some((key) => options7[key] !== void 0);
}
function getSpringOptions(options7) {
  let springOptions = {
    velocity: 0,
    stiffness: 100,
    damping: 10,
    mass: 1,
    isResolvedFromDuration: false,
    ...options7
  };
  if (!isSpringType(options7, physicsKeys) && isSpringType(options7, durationKeys)) {
    const derived = findSpring(options7);
    springOptions = {
      ...springOptions,
      ...derived,
      mass: 1
    };
    springOptions.isResolvedFromDuration = true;
  }
  return springOptions;
}
function spring({ keyframes: keyframes2, restDelta, restSpeed, ...options7 }) {
  const origin = keyframes2[0];
  const target = keyframes2[keyframes2.length - 1];
  const state = { done: false, value: origin };
  const { stiffness, damping, mass, duration: duration2, velocity, isResolvedFromDuration } = getSpringOptions({
    ...options7,
    velocity: -millisecondsToSeconds(options7.velocity || 0)
  });
  const initialVelocity = velocity || 0;
  const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
  const initialDelta = target - origin;
  const undampedAngularFreq = millisecondsToSeconds(Math.sqrt(stiffness / mass));
  const isGranularScale = Math.abs(initialDelta) < 5;
  restSpeed || (restSpeed = isGranularScale ? 0.01 : 2);
  restDelta || (restDelta = isGranularScale ? 5e-3 : 0.5);
  let resolveSpring;
  if (dampingRatio < 1) {
    const angularFreq = calcAngularFreq(undampedAngularFreq, dampingRatio);
    resolveSpring = (t4) => {
      const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t4);
      return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t4) + initialDelta * Math.cos(angularFreq * t4));
    };
  } else if (dampingRatio === 1) {
    resolveSpring = (t4) => target - Math.exp(-undampedAngularFreq * t4) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t4);
  } else {
    const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
    resolveSpring = (t4) => {
      const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t4);
      const freqForT = Math.min(dampedAngularFreq * t4, 300);
      return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
    };
  }
  return {
    calculatedDuration: isResolvedFromDuration ? duration2 || null : null,
    next: (t4) => {
      const current = resolveSpring(t4);
      if (!isResolvedFromDuration) {
        let currentVelocity = initialVelocity;
        if (t4 !== 0) {
          if (dampingRatio < 1) {
            currentVelocity = calcGeneratorVelocity(resolveSpring, t4, current);
          } else {
            currentVelocity = 0;
          }
        }
        const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
        const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
        state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
      } else {
        state.done = t4 >= duration2;
      }
      state.value = state.done ? target : current;
      return state;
    }
  };
}

// ../../node_modules/framer-motion/dist/es/animation/generators/inertia.mjs
function inertia({ keyframes: keyframes2, velocity = 0, power = 0.8, timeConstant = 325, bounceDamping = 10, bounceStiffness = 500, modifyTarget, min, max, restDelta = 0.5, restSpeed }) {
  const origin = keyframes2[0];
  const state = {
    done: false,
    value: origin
  };
  const isOutOfBounds = (v4) => min !== void 0 && v4 < min || max !== void 0 && v4 > max;
  const nearestBoundary = (v4) => {
    if (min === void 0)
      return max;
    if (max === void 0)
      return min;
    return Math.abs(min - v4) < Math.abs(max - v4) ? min : max;
  };
  let amplitude = power * velocity;
  const ideal = origin + amplitude;
  const target = modifyTarget === void 0 ? ideal : modifyTarget(ideal);
  if (target !== ideal)
    amplitude = target - origin;
  const calcDelta = (t4) => -amplitude * Math.exp(-t4 / timeConstant);
  const calcLatest = (t4) => target + calcDelta(t4);
  const applyFriction = (t4) => {
    const delta = calcDelta(t4);
    const latest = calcLatest(t4);
    state.done = Math.abs(delta) <= restDelta;
    state.value = state.done ? target : latest;
  };
  let timeReachedBoundary;
  let spring$1;
  const checkCatchBoundary = (t4) => {
    if (!isOutOfBounds(state.value))
      return;
    timeReachedBoundary = t4;
    spring$1 = spring({
      keyframes: [state.value, nearestBoundary(state.value)],
      velocity: calcGeneratorVelocity(calcLatest, t4, state.value),
      damping: bounceDamping,
      stiffness: bounceStiffness,
      restDelta,
      restSpeed
    });
  };
  checkCatchBoundary(0);
  return {
    calculatedDuration: null,
    next: (t4) => {
      let hasUpdatedFrame = false;
      if (!spring$1 && timeReachedBoundary === void 0) {
        hasUpdatedFrame = true;
        applyFriction(t4);
        checkCatchBoundary(t4);
      }
      if (timeReachedBoundary !== void 0 && t4 > timeReachedBoundary) {
        return spring$1.next(t4 - timeReachedBoundary);
      } else {
        !hasUpdatedFrame && applyFriction(t4);
        return state;
      }
    }
  };
}

// ../../node_modules/framer-motion/dist/es/animation/animators/js/driver-frameloop.mjs
var frameloopDriver = (update) => {
  const passTimestamp = ({ timestamp }) => update(timestamp);
  return {
    start: () => frame.update(passTimestamp, true),
    stop: () => cancelFrame(passTimestamp),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => frameData.isProcessing ? frameData.timestamp : performance.now()
  };
};

// ../../node_modules/framer-motion/dist/es/animation/generators/utils/calc-duration.mjs
var maxGeneratorDuration = 2e4;
function calcGeneratorDuration(generator) {
  let duration2 = 0;
  const timeStep = 50;
  let state = generator.next(duration2);
  while (!state.done && duration2 < maxGeneratorDuration) {
    duration2 += timeStep;
    state = generator.next(duration2);
  }
  return duration2 >= maxGeneratorDuration ? Infinity : duration2;
}

// ../../node_modules/framer-motion/dist/es/animation/animators/js/index.mjs
var types = {
  decay: inertia,
  inertia,
  tween: keyframes,
  keyframes,
  spring
};
function animateValue({ autoplay = true, delay: delay2 = 0, driver = frameloopDriver, keyframes: keyframes$1, type = "keyframes", repeat = 0, repeatDelay = 0, repeatType = "loop", onPlay, onStop, onComplete, onUpdate, ...options7 }) {
  let speed = 1;
  let hasStopped = false;
  let resolveFinishedPromise;
  let currentFinishedPromise;
  const updateFinishedPromise = () => {
    currentFinishedPromise = new Promise((resolve) => {
      resolveFinishedPromise = resolve;
    });
  };
  updateFinishedPromise();
  let animationDriver;
  const generatorFactory = types[type] || keyframes;
  let mapNumbersToKeyframes;
  if (generatorFactory !== keyframes && typeof keyframes$1[0] !== "number") {
    if (process.env.NODE_ENV !== "production") {
      invariant(keyframes$1.length === 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${keyframes$1}`);
    }
    mapNumbersToKeyframes = interpolate([0, 100], keyframes$1, {
      clamp: false
    });
    keyframes$1 = [0, 100];
  }
  const generator = generatorFactory({ ...options7, keyframes: keyframes$1 });
  let mirroredGenerator;
  if (repeatType === "mirror") {
    mirroredGenerator = generatorFactory({
      ...options7,
      keyframes: [...keyframes$1].reverse(),
      velocity: -(options7.velocity || 0)
    });
  }
  let playState = "idle";
  let holdTime = null;
  let startTime = null;
  let cancelTime = null;
  if (generator.calculatedDuration === null && repeat) {
    generator.calculatedDuration = calcGeneratorDuration(generator);
  }
  const { calculatedDuration } = generator;
  let resolvedDuration = Infinity;
  let totalDuration = Infinity;
  if (calculatedDuration !== null) {
    resolvedDuration = calculatedDuration + repeatDelay;
    totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
  }
  let currentTime = 0;
  const tick = (timestamp) => {
    if (startTime === null)
      return;
    if (speed > 0)
      startTime = Math.min(startTime, timestamp);
    if (speed < 0)
      startTime = Math.min(timestamp - totalDuration / speed, startTime);
    if (holdTime !== null) {
      currentTime = holdTime;
    } else {
      currentTime = Math.round(timestamp - startTime) * speed;
    }
    const timeWithoutDelay = currentTime - delay2 * (speed >= 0 ? 1 : -1);
    const isInDelayPhase = speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
    currentTime = Math.max(timeWithoutDelay, 0);
    if (playState === "finished" && holdTime === null) {
      currentTime = totalDuration;
    }
    let elapsed = currentTime;
    let frameGenerator = generator;
    if (repeat) {
      const progress2 = Math.min(currentTime, totalDuration) / resolvedDuration;
      let currentIteration = Math.floor(progress2);
      let iterationProgress = progress2 % 1;
      if (!iterationProgress && progress2 >= 1) {
        iterationProgress = 1;
      }
      iterationProgress === 1 && currentIteration--;
      currentIteration = Math.min(currentIteration, repeat + 1);
      const isOddIteration = Boolean(currentIteration % 2);
      if (isOddIteration) {
        if (repeatType === "reverse") {
          iterationProgress = 1 - iterationProgress;
          if (repeatDelay) {
            iterationProgress -= repeatDelay / resolvedDuration;
          }
        } else if (repeatType === "mirror") {
          frameGenerator = mirroredGenerator;
        }
      }
      elapsed = clamp(0, 1, iterationProgress) * resolvedDuration;
    }
    const state = isInDelayPhase ? { done: false, value: keyframes$1[0] } : frameGenerator.next(elapsed);
    if (mapNumbersToKeyframes) {
      state.value = mapNumbersToKeyframes(state.value);
    }
    let { done } = state;
    if (!isInDelayPhase && calculatedDuration !== null) {
      done = speed >= 0 ? currentTime >= totalDuration : currentTime <= 0;
    }
    const isAnimationFinished = holdTime === null && (playState === "finished" || playState === "running" && done);
    if (onUpdate) {
      onUpdate(state.value);
    }
    if (isAnimationFinished) {
      finish();
    }
    return state;
  };
  const stopAnimationDriver = () => {
    animationDriver && animationDriver.stop();
    animationDriver = void 0;
  };
  const cancel = () => {
    playState = "idle";
    stopAnimationDriver();
    resolveFinishedPromise();
    updateFinishedPromise();
    startTime = cancelTime = null;
  };
  const finish = () => {
    playState = "finished";
    onComplete && onComplete();
    stopAnimationDriver();
    resolveFinishedPromise();
  };
  const play = () => {
    if (hasStopped)
      return;
    if (!animationDriver)
      animationDriver = driver(tick);
    const now2 = animationDriver.now();
    onPlay && onPlay();
    if (holdTime !== null) {
      startTime = now2 - holdTime;
    } else if (!startTime || playState === "finished") {
      startTime = now2;
    }
    if (playState === "finished") {
      updateFinishedPromise();
    }
    cancelTime = startTime;
    holdTime = null;
    playState = "running";
    animationDriver.start();
  };
  if (autoplay) {
    play();
  }
  const controls = {
    then(resolve, reject) {
      return currentFinishedPromise.then(resolve, reject);
    },
    get time() {
      return millisecondsToSeconds(currentTime);
    },
    set time(newTime) {
      newTime = secondsToMilliseconds(newTime);
      currentTime = newTime;
      if (holdTime !== null || !animationDriver || speed === 0) {
        holdTime = newTime;
      } else {
        startTime = animationDriver.now() - newTime / speed;
      }
    },
    get duration() {
      const duration2 = generator.calculatedDuration === null ? calcGeneratorDuration(generator) : generator.calculatedDuration;
      return millisecondsToSeconds(duration2);
    },
    get speed() {
      return speed;
    },
    set speed(newSpeed) {
      if (newSpeed === speed || !animationDriver)
        return;
      speed = newSpeed;
      controls.time = millisecondsToSeconds(currentTime);
    },
    get state() {
      return playState;
    },
    play,
    pause: () => {
      playState = "paused";
      holdTime = currentTime;
    },
    stop: () => {
      hasStopped = true;
      if (playState === "idle")
        return;
      playState = "idle";
      onStop && onStop();
      cancel();
    },
    cancel: () => {
      if (cancelTime !== null)
        tick(cancelTime);
      cancel();
    },
    complete: () => {
      playState = "finished";
    },
    sample: (elapsed) => {
      startTime = 0;
      return tick(elapsed);
    }
  };
  return controls;
}

// ../../node_modules/framer-motion/dist/es/utils/memo.mjs
function memo(callback) {
  let result;
  return () => {
    if (result === void 0)
      result = callback();
    return result;
  };
}

// ../../node_modules/framer-motion/dist/es/animation/animators/waapi/create-accelerated-animation.mjs
var supportsWaapi = memo(() => Object.hasOwnProperty.call(Element.prototype, "animate"));
var acceleratedValues = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform",
  "backgroundColor"
]);
var sampleDelta = 10;
var maxDuration2 = 2e4;
var requiresPregeneratedKeyframes = (valueName, options7) => options7.type === "spring" || valueName === "backgroundColor" || !isWaapiSupportedEasing(options7.ease);
function createAcceleratedAnimation(value, valueName, { onUpdate, onComplete, ...options7 }) {
  const canAccelerateAnimation = supportsWaapi() && acceleratedValues.has(valueName) && !options7.repeatDelay && options7.repeatType !== "mirror" && options7.damping !== 0 && options7.type !== "inertia";
  if (!canAccelerateAnimation)
    return false;
  let hasStopped = false;
  let resolveFinishedPromise;
  let currentFinishedPromise;
  let pendingCancel = false;
  const updateFinishedPromise = () => {
    currentFinishedPromise = new Promise((resolve) => {
      resolveFinishedPromise = resolve;
    });
  };
  updateFinishedPromise();
  let { keyframes: keyframes2, duration: duration2 = 300, ease: ease2, times } = options7;
  if (requiresPregeneratedKeyframes(valueName, options7)) {
    const sampleAnimation = animateValue({
      ...options7,
      repeat: 0,
      delay: 0
    });
    let state = { done: false, value: keyframes2[0] };
    const pregeneratedKeyframes = [];
    let t4 = 0;
    while (!state.done && t4 < maxDuration2) {
      state = sampleAnimation.sample(t4);
      pregeneratedKeyframes.push(state.value);
      t4 += sampleDelta;
    }
    times = void 0;
    keyframes2 = pregeneratedKeyframes;
    duration2 = t4 - sampleDelta;
    ease2 = "linear";
  }
  const animation = animateStyle(value.owner.current, valueName, keyframes2, {
    ...options7,
    duration: duration2,
    /**
     * This function is currently not called if ease is provided
     * as a function so the cast is safe.
     *
     * However it would be possible for a future refinement to port
     * in easing pregeneration from Motion One for browsers that
     * support the upcoming `linear()` easing function.
     */
    ease: ease2,
    times
  });
  const cancelAnimation = () => {
    pendingCancel = false;
    animation.cancel();
  };
  const safeCancel = () => {
    pendingCancel = true;
    frame.update(cancelAnimation);
    resolveFinishedPromise();
    updateFinishedPromise();
  };
  animation.onfinish = () => {
    if (pendingCancel)
      return;
    value.set(getFinalKeyframe(keyframes2, options7));
    onComplete && onComplete();
    safeCancel();
  };
  const controls = {
    then(resolve, reject) {
      return currentFinishedPromise.then(resolve, reject);
    },
    attachTimeline(timeline) {
      animation.timeline = timeline;
      animation.onfinish = null;
      return noop4;
    },
    get time() {
      return millisecondsToSeconds(animation.currentTime || 0);
    },
    set time(newTime) {
      animation.currentTime = secondsToMilliseconds(newTime);
    },
    get speed() {
      return animation.playbackRate;
    },
    set speed(newSpeed) {
      animation.playbackRate = newSpeed;
    },
    get duration() {
      return millisecondsToSeconds(duration2);
    },
    play: () => {
      if (hasStopped)
        return;
      animation.play();
      cancelFrame(cancelAnimation);
    },
    pause: () => animation.pause(),
    stop: () => {
      hasStopped = true;
      if (animation.playState === "idle")
        return;
      const { currentTime } = animation;
      if (currentTime) {
        const sampleAnimation = animateValue({
          ...options7,
          autoplay: false
        });
        value.setWithVelocity(sampleAnimation.sample(currentTime - sampleDelta).value, sampleAnimation.sample(currentTime).value, sampleDelta);
      }
      safeCancel();
    },
    complete: () => {
      if (pendingCancel)
        return;
      animation.finish();
    },
    cancel: safeCancel
  };
  return controls;
}

// ../../node_modules/framer-motion/dist/es/animation/animators/instant.mjs
function createInstantAnimation({ keyframes: keyframes2, delay: delay2, onUpdate, onComplete }) {
  const setValue = () => {
    onUpdate && onUpdate(keyframes2[keyframes2.length - 1]);
    onComplete && onComplete();
    return {
      time: 0,
      speed: 1,
      duration: 0,
      play: noop4,
      pause: noop4,
      stop: noop4,
      then: (resolve) => {
        resolve();
        return Promise.resolve();
      },
      cancel: noop4,
      complete: noop4
    };
  };
  return delay2 ? animateValue({
    keyframes: [0, 1],
    duration: 0,
    delay: delay2,
    onComplete: setValue
  }) : setValue();
}

// ../../node_modules/framer-motion/dist/es/animation/utils/default-transitions.mjs
var underDampedSpring = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
};
var criticallyDampedSpring = (target) => ({
  type: "spring",
  stiffness: 550,
  damping: target === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
});
var keyframesTransition = {
  type: "keyframes",
  duration: 0.8
};
var ease = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
};
var getDefaultTransition = (valueKey, { keyframes: keyframes2 }) => {
  if (keyframes2.length > 2) {
    return keyframesTransition;
  } else if (transformProps.has(valueKey)) {
    return valueKey.startsWith("scale") ? criticallyDampedSpring(keyframes2[1]) : underDampedSpring;
  }
  return ease;
};

// ../../node_modules/framer-motion/dist/es/animation/utils/is-animatable.mjs
var isAnimatable = (key, value) => {
  if (key === "zIndex")
    return false;
  if (typeof value === "number" || Array.isArray(value))
    return true;
  if (typeof value === "string" && // It's animatable if we have a string
  (complex.test(value) || value === "0") && // And it contains numbers and/or colors
  !value.startsWith("url(")) {
    return true;
  }
  return false;
};

// ../../node_modules/framer-motion/dist/es/value/types/complex/filter.mjs
var maxDefaults = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function applyDefaultFilter(v4) {
  const [name, value] = v4.slice(0, -1).split("(");
  if (name === "drop-shadow")
    return v4;
  const [number3] = value.match(floatRegex) || [];
  if (!number3)
    return v4;
  const unit = value.replace(number3, "");
  let defaultValue = maxDefaults.has(name) ? 1 : 0;
  if (number3 !== value)
    defaultValue *= 100;
  return name + "(" + defaultValue + unit + ")";
}
var functionRegex = /([a-z-]*)\(.*?\)/g;
var filter = {
  ...complex,
  getAnimatableNone: (v4) => {
    const functions = v4.match(functionRegex);
    return functions ? functions.map(applyDefaultFilter).join(" ") : v4;
  }
};

// ../../node_modules/framer-motion/dist/es/render/dom/value-types/defaults.mjs
var defaultValueTypes = {
  ...numberValueTypes,
  // Color props
  color,
  backgroundColor: color,
  outlineColor: color,
  fill: color,
  stroke: color,
  // Border props
  borderColor: color,
  borderTopColor: color,
  borderRightColor: color,
  borderBottomColor: color,
  borderLeftColor: color,
  filter,
  WebkitFilter: filter
};
var getDefaultValueType = (key) => defaultValueTypes[key];

// ../../node_modules/framer-motion/dist/es/render/dom/value-types/animatable-none.mjs
function getAnimatableNone2(key, value) {
  let defaultValueType = getDefaultValueType(key);
  if (defaultValueType !== filter)
    defaultValueType = complex;
  return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : void 0;
}

// ../../node_modules/framer-motion/dist/es/utils/is-zero-value-string.mjs
var isZeroValueString = (v4) => /^0[^.\s]+$/.test(v4);

// ../../node_modules/framer-motion/dist/es/animation/utils/is-none.mjs
function isNone(value) {
  if (typeof value === "number") {
    return value === 0;
  } else if (value !== null) {
    return value === "none" || value === "0" || isZeroValueString(value);
  }
}

// ../../node_modules/framer-motion/dist/es/animation/utils/keyframes.mjs
function getKeyframes(value, valueName, target, transition) {
  const isTargetAnimatable = isAnimatable(valueName, target);
  let keyframes2;
  if (Array.isArray(target)) {
    keyframes2 = [...target];
  } else {
    keyframes2 = [null, target];
  }
  const defaultOrigin = transition.from !== void 0 ? transition.from : value.get();
  let animatableTemplateValue = void 0;
  const noneKeyframeIndexes = [];
  for (let i4 = 0; i4 < keyframes2.length; i4++) {
    if (keyframes2[i4] === null) {
      keyframes2[i4] = i4 === 0 ? defaultOrigin : keyframes2[i4 - 1];
    }
    if (isNone(keyframes2[i4])) {
      noneKeyframeIndexes.push(i4);
    }
    if (typeof keyframes2[i4] === "string" && keyframes2[i4] !== "none" && keyframes2[i4] !== "0") {
      animatableTemplateValue = keyframes2[i4];
    }
  }
  if (isTargetAnimatable && noneKeyframeIndexes.length && animatableTemplateValue) {
    for (let i4 = 0; i4 < noneKeyframeIndexes.length; i4++) {
      const index2 = noneKeyframeIndexes[i4];
      keyframes2[index2] = getAnimatableNone2(valueName, animatableTemplateValue);
    }
  }
  return keyframes2;
}

// ../../node_modules/framer-motion/dist/es/animation/utils/transitions.mjs
function isTransitionDefined({ when, delay: _delay, delayChildren, staggerChildren, staggerDirection, repeat, repeatType, repeatDelay, from, elapsed, ...transition }) {
  return !!Object.keys(transition).length;
}
function getValueTransition(transition, key) {
  return transition[key] || transition["default"] || transition;
}

// ../../node_modules/framer-motion/dist/es/utils/GlobalConfig.mjs
var MotionGlobalConfig = {
  skipAnimations: false
};

// ../../node_modules/framer-motion/dist/es/animation/interfaces/motion-value.mjs
var animateMotionValue = (valueName, value, target, transition = {}) => {
  return (onComplete) => {
    const valueTransition = getValueTransition(transition, valueName) || {};
    const delay2 = valueTransition.delay || transition.delay || 0;
    let { elapsed = 0 } = transition;
    elapsed = elapsed - secondsToMilliseconds(delay2);
    const keyframes2 = getKeyframes(value, valueName, target, valueTransition);
    const originKeyframe = keyframes2[0];
    const targetKeyframe = keyframes2[keyframes2.length - 1];
    const isOriginAnimatable = isAnimatable(valueName, originKeyframe);
    const isTargetAnimatable = isAnimatable(valueName, targetKeyframe);
    warning(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${valueName} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
    let options7 = {
      keyframes: keyframes2,
      velocity: value.getVelocity(),
      ease: "easeOut",
      ...valueTransition,
      delay: -elapsed,
      onUpdate: (v4) => {
        value.set(v4);
        valueTransition.onUpdate && valueTransition.onUpdate(v4);
      },
      onComplete: () => {
        onComplete();
        valueTransition.onComplete && valueTransition.onComplete();
      }
    };
    if (!isTransitionDefined(valueTransition)) {
      options7 = {
        ...options7,
        ...getDefaultTransition(valueName, options7)
      };
    }
    if (options7.duration) {
      options7.duration = secondsToMilliseconds(options7.duration);
    }
    if (options7.repeatDelay) {
      options7.repeatDelay = secondsToMilliseconds(options7.repeatDelay);
    }
    if (!isOriginAnimatable || !isTargetAnimatable || instantAnimationState.current || valueTransition.type === false || MotionGlobalConfig.skipAnimations) {
      return createInstantAnimation(instantAnimationState.current ? { ...options7, delay: 0 } : options7);
    }
    if (
      /**
       * If this is a handoff animation, the optimised animation will be running via
       * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
       * optimised animation.
       */
      !transition.isHandoff && value.owner && value.owner.current instanceof HTMLElement && /**
       * If we're outputting values to onUpdate then we can't use WAAPI as there's
       * no way to read the value from WAAPI every frame.
       */
      !value.owner.getProps().onUpdate
    ) {
      const acceleratedAnimation = createAcceleratedAnimation(value, valueName, options7);
      if (acceleratedAnimation)
        return acceleratedAnimation;
    }
    return animateValue(options7);
  };
};

// ../../node_modules/framer-motion/dist/es/value/use-will-change/is.mjs
function isWillChangeMotionValue(value) {
  return Boolean(isMotionValue(value) && value.add);
}

// ../../node_modules/framer-motion/dist/es/utils/is-numerical-string.mjs
var isNumericalString = (v4) => /^\-?\d*\.?\d+$/.test(v4);

// ../../node_modules/framer-motion/dist/es/utils/array.mjs
function addUniqueItem(arr, item) {
  if (arr.indexOf(item) === -1)
    arr.push(item);
}
function removeItem(arr, item) {
  const index2 = arr.indexOf(item);
  if (index2 > -1)
    arr.splice(index2, 1);
}

// ../../node_modules/framer-motion/dist/es/utils/subscription-manager.mjs
var SubscriptionManager = class {
  constructor() {
    this.subscriptions = [];
  }
  add(handler) {
    addUniqueItem(this.subscriptions, handler);
    return () => removeItem(this.subscriptions, handler);
  }
  notify(a4, b3, c4) {
    const numSubscriptions = this.subscriptions.length;
    if (!numSubscriptions)
      return;
    if (numSubscriptions === 1) {
      this.subscriptions[0](a4, b3, c4);
    } else {
      for (let i4 = 0; i4 < numSubscriptions; i4++) {
        const handler = this.subscriptions[i4];
        handler && handler(a4, b3, c4);
      }
    }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
};

// ../../node_modules/framer-motion/dist/es/utils/warn-once.mjs
var warned = /* @__PURE__ */ new Set();
function warnOnce(condition, message, element) {
  if (condition || warned.has(message))
    return;
  console.warn(message);
  if (element)
    console.warn(element);
  warned.add(message);
}

// ../../node_modules/framer-motion/dist/es/value/index.mjs
var isFloat = (value) => {
  return !isNaN(parseFloat(value));
};
var collectMotionValues = {
  current: void 0
};
var MotionValue = class {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   *
   * @internal
   */
  constructor(init, options7 = {}) {
    this.version = "10.18.0";
    this.timeDelta = 0;
    this.lastUpdated = 0;
    this.canTrackVelocity = false;
    this.events = {};
    this.updateAndNotify = (v4, render = true) => {
      this.prev = this.current;
      this.current = v4;
      const { delta, timestamp } = frameData;
      if (this.lastUpdated !== timestamp) {
        this.timeDelta = delta;
        this.lastUpdated = timestamp;
        frame.postRender(this.scheduleVelocityCheck);
      }
      if (this.prev !== this.current && this.events.change) {
        this.events.change.notify(this.current);
      }
      if (this.events.velocityChange) {
        this.events.velocityChange.notify(this.getVelocity());
      }
      if (render && this.events.renderRequest) {
        this.events.renderRequest.notify(this.current);
      }
    };
    this.scheduleVelocityCheck = () => frame.postRender(this.velocityCheck);
    this.velocityCheck = ({ timestamp }) => {
      if (timestamp !== this.lastUpdated) {
        this.prev = this.current;
        if (this.events.velocityChange) {
          this.events.velocityChange.notify(this.getVelocity());
        }
      }
    };
    this.hasAnimated = false;
    this.prev = this.current = init;
    this.canTrackVelocity = isFloat(this.current);
    this.owner = options7.owner;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(subscription) {
    if (process.env.NODE_ENV !== "production") {
      warnOnce(false, `value.onChange(callback) is deprecated. Switch to value.on("change", callback).`);
    }
    return this.on("change", subscription);
  }
  on(eventName, callback) {
    if (!this.events[eventName]) {
      this.events[eventName] = new SubscriptionManager();
    }
    const unsubscribe = this.events[eventName].add(callback);
    if (eventName === "change") {
      return () => {
        unsubscribe();
        frame.read(() => {
          if (!this.events.change.getSize()) {
            this.stop();
          }
        });
      };
    }
    return unsubscribe;
  }
  clearListeners() {
    for (const eventManagers in this.events) {
      this.events[eventManagers].clear();
    }
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   *
   * @internal
   */
  attach(passiveEffect, stopPassiveEffect) {
    this.passiveEffect = passiveEffect;
    this.stopPassiveEffect = stopPassiveEffect;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(v4, render = true) {
    if (!render || !this.passiveEffect) {
      this.updateAndNotify(v4, render);
    } else {
      this.passiveEffect(v4, this.updateAndNotify);
    }
  }
  setWithVelocity(prev, current, delta) {
    this.set(current);
    this.prev = prev;
    this.timeDelta = delta;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(v4) {
    this.updateAndNotify(v4);
    this.prev = v4;
    this.stop();
    if (this.stopPassiveEffect)
      this.stopPassiveEffect();
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    if (collectMotionValues.current) {
      collectMotionValues.current.push(this);
    }
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    return this.canTrackVelocity ? (
      // These casts could be avoided if parseFloat would be typed better
      velocityPerSecond(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta)
    ) : 0;
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   *
   * @internal
   */
  start(startAnimation) {
    this.stop();
    return new Promise((resolve) => {
      this.hasAnimated = true;
      this.animation = startAnimation(resolve);
      if (this.events.animationStart) {
        this.events.animationStart.notify();
      }
    }).then(() => {
      if (this.events.animationComplete) {
        this.events.animationComplete.notify();
      }
      this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    if (this.animation) {
      this.animation.stop();
      if (this.events.animationCancel) {
        this.events.animationCancel.notify();
      }
    }
    this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.clearListeners();
    this.stop();
    if (this.stopPassiveEffect) {
      this.stopPassiveEffect();
    }
  }
};
function motionValue(init, options7) {
  return new MotionValue(init, options7);
}

// ../../node_modules/framer-motion/dist/es/render/dom/value-types/test.mjs
var testValueType = (v4) => (type) => type.test(v4);

// ../../node_modules/framer-motion/dist/es/render/dom/value-types/type-auto.mjs
var auto = {
  test: (v4) => v4 === "auto",
  parse: (v4) => v4
};

// ../../node_modules/framer-motion/dist/es/render/dom/value-types/dimensions.mjs
var dimensionValueTypes = [number, px, percent, degrees, vw, vh, auto];
var findDimensionValueType = (v4) => dimensionValueTypes.find(testValueType(v4));

// ../../node_modules/framer-motion/dist/es/render/dom/value-types/find.mjs
var valueTypes = [...dimensionValueTypes, color, complex];
var findValueType = (v4) => valueTypes.find(testValueType(v4));

// ../../node_modules/framer-motion/dist/es/render/utils/setters.mjs
function setMotionValue(visualElement, key, value) {
  if (visualElement.hasValue(key)) {
    visualElement.getValue(key).set(value);
  } else {
    visualElement.addValue(key, motionValue(value));
  }
}
function setTarget(visualElement, definition) {
  const resolved = resolveVariant(visualElement, definition);
  let { transitionEnd = {}, transition = {}, ...target } = resolved ? visualElement.makeTargetAnimatable(resolved, false) : {};
  target = { ...target, ...transitionEnd };
  for (const key in target) {
    const value = resolveFinalValueInKeyframes(target[key]);
    setMotionValue(visualElement, key, value);
  }
}
function checkTargetForNewValues(visualElement, target, origin) {
  var _a, _b;
  const newValueKeys = Object.keys(target).filter((key) => !visualElement.hasValue(key));
  const numNewValues = newValueKeys.length;
  if (!numNewValues)
    return;
  for (let i4 = 0; i4 < numNewValues; i4++) {
    const key = newValueKeys[i4];
    const targetValue = target[key];
    let value = null;
    if (Array.isArray(targetValue)) {
      value = targetValue[0];
    }
    if (value === null) {
      value = (_b = (_a = origin[key]) !== null && _a !== void 0 ? _a : visualElement.readValue(key)) !== null && _b !== void 0 ? _b : target[key];
    }
    if (value === void 0 || value === null)
      continue;
    if (typeof value === "string" && (isNumericalString(value) || isZeroValueString(value))) {
      value = parseFloat(value);
    } else if (!findValueType(value) && complex.test(targetValue)) {
      value = getAnimatableNone2(key, targetValue);
    }
    visualElement.addValue(key, motionValue(value, { owner: visualElement }));
    if (origin[key] === void 0) {
      origin[key] = value;
    }
    if (value !== null)
      visualElement.setBaseTarget(key, value);
  }
}
function getOriginFromTransition(key, transition) {
  if (!transition)
    return;
  const valueTransition = transition[key] || transition["default"] || transition;
  return valueTransition.from;
}
function getOrigin(target, transition, visualElement) {
  const origin = {};
  for (const key in target) {
    const transitionOrigin = getOriginFromTransition(key, transition);
    if (transitionOrigin !== void 0) {
      origin[key] = transitionOrigin;
    } else {
      const value = visualElement.getValue(key);
      if (value) {
        origin[key] = value.get();
      }
    }
  }
  return origin;
}

// ../../node_modules/framer-motion/dist/es/animation/interfaces/visual-element-target.mjs
function shouldBlockAnimation({ protectedKeys, needsAnimating }, key) {
  const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
  needsAnimating[key] = false;
  return shouldBlock;
}
function hasKeyframesChanged(value, target) {
  const current = value.get();
  if (Array.isArray(target)) {
    for (let i4 = 0; i4 < target.length; i4++) {
      if (target[i4] !== current)
        return true;
    }
  } else {
    return current !== target;
  }
}
function animateTarget(visualElement, definition, { delay: delay2 = 0, transitionOverride, type } = {}) {
  let { transition = visualElement.getDefaultTransition(), transitionEnd, ...target } = visualElement.makeTargetAnimatable(definition);
  const willChange = visualElement.getValue("willChange");
  if (transitionOverride)
    transition = transitionOverride;
  const animations2 = [];
  const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
  for (const key in target) {
    const value = visualElement.getValue(key);
    const valueTarget = target[key];
    if (!value || valueTarget === void 0 || animationTypeState && shouldBlockAnimation(animationTypeState, key)) {
      continue;
    }
    const valueTransition = {
      delay: delay2,
      elapsed: 0,
      ...getValueTransition(transition || {}, key)
    };
    if (window.HandoffAppearAnimations) {
      const appearId = visualElement.getProps()[optimizedAppearDataAttribute];
      if (appearId) {
        const elapsed = window.HandoffAppearAnimations(appearId, key, value, frame);
        if (elapsed !== null) {
          valueTransition.elapsed = elapsed;
          valueTransition.isHandoff = true;
        }
      }
    }
    let canSkip = !valueTransition.isHandoff && !hasKeyframesChanged(value, valueTarget);
    if (valueTransition.type === "spring" && (value.getVelocity() || valueTransition.velocity)) {
      canSkip = false;
    }
    if (value.animation) {
      canSkip = false;
    }
    if (canSkip)
      continue;
    value.start(animateMotionValue(key, value, valueTarget, visualElement.shouldReduceMotion && transformProps.has(key) ? { type: false } : valueTransition));
    const animation = value.animation;
    if (isWillChangeMotionValue(willChange)) {
      willChange.add(key);
      animation.then(() => willChange.remove(key));
    }
    animations2.push(animation);
  }
  if (transitionEnd) {
    Promise.all(animations2).then(() => {
      transitionEnd && setTarget(visualElement, transitionEnd);
    });
  }
  return animations2;
}

// ../../node_modules/framer-motion/dist/es/animation/interfaces/visual-element-variant.mjs
function animateVariant(visualElement, variant, options7 = {}) {
  const resolved = resolveVariant(visualElement, variant, options7.custom);
  let { transition = visualElement.getDefaultTransition() || {} } = resolved || {};
  if (options7.transitionOverride) {
    transition = options7.transitionOverride;
  }
  const getAnimation = resolved ? () => Promise.all(animateTarget(visualElement, resolved, options7)) : () => Promise.resolve();
  const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0) => {
    const { delayChildren = 0, staggerChildren, staggerDirection } = transition;
    return animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options7);
  } : () => Promise.resolve();
  const { when } = transition;
  if (when) {
    const [first, last] = when === "beforeChildren" ? [getAnimation, getChildAnimations] : [getChildAnimations, getAnimation];
    return first().then(() => last());
  } else {
    return Promise.all([getAnimation(), getChildAnimations(options7.delay)]);
  }
}
function animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options7) {
  const animations2 = [];
  const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
  const generateStaggerDuration = staggerDirection === 1 ? (i4 = 0) => i4 * staggerChildren : (i4 = 0) => maxStaggerDuration - i4 * staggerChildren;
  Array.from(visualElement.variantChildren).sort(sortByTreeOrder).forEach((child, i4) => {
    child.notify("AnimationStart", variant);
    animations2.push(animateVariant(child, variant, {
      ...options7,
      delay: delayChildren + generateStaggerDuration(i4)
    }).then(() => child.notify("AnimationComplete", variant)));
  });
  return Promise.all(animations2);
}
function sortByTreeOrder(a4, b3) {
  return a4.sortNodePosition(b3);
}

// ../../node_modules/framer-motion/dist/es/animation/interfaces/visual-element.mjs
function animateVisualElement(visualElement, definition, options7 = {}) {
  visualElement.notify("AnimationStart", definition);
  let animation;
  if (Array.isArray(definition)) {
    const animations2 = definition.map((variant) => animateVariant(visualElement, variant, options7));
    animation = Promise.all(animations2);
  } else if (typeof definition === "string") {
    animation = animateVariant(visualElement, definition, options7);
  } else {
    const resolvedDefinition = typeof definition === "function" ? resolveVariant(visualElement, definition, options7.custom) : definition;
    animation = Promise.all(animateTarget(visualElement, resolvedDefinition, options7));
  }
  return animation.then(() => visualElement.notify("AnimationComplete", definition));
}

// ../../node_modules/framer-motion/dist/es/render/utils/animation-state.mjs
var reversePriorityOrder = [...variantPriorityOrder].reverse();
var numAnimationTypes = variantPriorityOrder.length;
function animateList(visualElement) {
  return (animations2) => Promise.all(animations2.map(({ animation, options: options7 }) => animateVisualElement(visualElement, animation, options7)));
}
function createAnimationState(visualElement) {
  let animate = animateList(visualElement);
  const state = createState();
  let isInitialRender = true;
  const buildResolvedTypeValues = (acc, definition) => {
    const resolved = resolveVariant(visualElement, definition);
    if (resolved) {
      const { transition, transitionEnd, ...target } = resolved;
      acc = { ...acc, ...target, ...transitionEnd };
    }
    return acc;
  };
  function setAnimateFunction(makeAnimator) {
    animate = makeAnimator(visualElement);
  }
  function animateChanges(options7, changedActiveType) {
    const props = visualElement.getProps();
    const context = visualElement.getVariantContext(true) || {};
    const animations2 = [];
    const removedKeys = /* @__PURE__ */ new Set();
    let encounteredKeys = {};
    let removedVariantIndex = Infinity;
    for (let i4 = 0; i4 < numAnimationTypes; i4++) {
      const type = reversePriorityOrder[i4];
      const typeState = state[type];
      const prop = props[type] !== void 0 ? props[type] : context[type];
      const propIsVariant = isVariantLabel(prop);
      const activeDelta = type === changedActiveType ? typeState.isActive : null;
      if (activeDelta === false)
        removedVariantIndex = i4;
      let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
      if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) {
        isInherited = false;
      }
      typeState.protectedKeys = { ...encounteredKeys };
      if (
        // If it isn't active and hasn't *just* been set as inactive
        !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
        !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
        isAnimationControls(prop) || typeof prop === "boolean"
      ) {
        continue;
      }
      const variantDidChange = checkVariantsDidChange(typeState.prevProp, prop);
      let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
      type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
      i4 > removedVariantIndex && propIsVariant;
      let handledRemovedValues = false;
      const definitionList = Array.isArray(prop) ? prop : [prop];
      let resolvedValues = definitionList.reduce(buildResolvedTypeValues, {});
      if (activeDelta === false)
        resolvedValues = {};
      const { prevResolvedValues = {} } = typeState;
      const allKeys = {
        ...prevResolvedValues,
        ...resolvedValues
      };
      const markToAnimate = (key) => {
        shouldAnimateType = true;
        if (removedKeys.has(key)) {
          handledRemovedValues = true;
          removedKeys.delete(key);
        }
        typeState.needsAnimating[key] = true;
      };
      for (const key in allKeys) {
        const next = resolvedValues[key];
        const prev = prevResolvedValues[key];
        if (encounteredKeys.hasOwnProperty(key))
          continue;
        let valueHasChanged = false;
        if (isKeyframesTarget(next) && isKeyframesTarget(prev)) {
          valueHasChanged = !shallowCompare(next, prev);
        } else {
          valueHasChanged = next !== prev;
        }
        if (valueHasChanged) {
          if (next !== void 0) {
            markToAnimate(key);
          } else {
            removedKeys.add(key);
          }
        } else if (next !== void 0 && removedKeys.has(key)) {
          markToAnimate(key);
        } else {
          typeState.protectedKeys[key] = true;
        }
      }
      typeState.prevProp = prop;
      typeState.prevResolvedValues = resolvedValues;
      if (typeState.isActive) {
        encounteredKeys = { ...encounteredKeys, ...resolvedValues };
      }
      if (isInitialRender && visualElement.blockInitialAnimation) {
        shouldAnimateType = false;
      }
      if (shouldAnimateType && (!isInherited || handledRemovedValues)) {
        animations2.push(...definitionList.map((animation) => ({
          animation,
          options: { type, ...options7 }
        })));
      }
    }
    if (removedKeys.size) {
      const fallbackAnimation = {};
      removedKeys.forEach((key) => {
        const fallbackTarget = visualElement.getBaseTarget(key);
        if (fallbackTarget !== void 0) {
          fallbackAnimation[key] = fallbackTarget;
        }
      });
      animations2.push({ animation: fallbackAnimation });
    }
    let shouldAnimate = Boolean(animations2.length);
    if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) {
      shouldAnimate = false;
    }
    isInitialRender = false;
    return shouldAnimate ? animate(animations2) : Promise.resolve();
  }
  function setActive(type, isActive, options7) {
    var _a;
    if (state[type].isActive === isActive)
      return Promise.resolve();
    (_a = visualElement.variantChildren) === null || _a === void 0 ? void 0 : _a.forEach((child) => {
      var _a2;
      return (_a2 = child.animationState) === null || _a2 === void 0 ? void 0 : _a2.setActive(type, isActive);
    });
    state[type].isActive = isActive;
    const animations2 = animateChanges(options7, type);
    for (const key in state) {
      state[key].protectedKeys = {};
    }
    return animations2;
  }
  return {
    animateChanges,
    setActive,
    setAnimateFunction,
    getState: () => state
  };
}
function checkVariantsDidChange(prev, next) {
  if (typeof next === "string") {
    return next !== prev;
  } else if (Array.isArray(next)) {
    return !shallowCompare(next, prev);
  }
  return false;
}
function createTypeState(isActive = false) {
  return {
    isActive,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function createState() {
  return {
    animate: createTypeState(true),
    whileInView: createTypeState(),
    whileHover: createTypeState(),
    whileTap: createTypeState(),
    whileDrag: createTypeState(),
    whileFocus: createTypeState(),
    exit: createTypeState()
  };
}

// ../../node_modules/framer-motion/dist/es/motion/features/animation/index.mjs
var AnimationFeature = class extends Feature {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(node566) {
    super(node566);
    node566.animationState || (node566.animationState = createAnimationState(node566));
  }
  updateAnimationControlsSubscription() {
    const { animate } = this.node.getProps();
    this.unmount();
    if (isAnimationControls(animate)) {
      this.unmount = animate.subscribe(this.node);
    }
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate } = this.node.getProps();
    const { animate: prevAnimate } = this.node.prevProps || {};
    if (animate !== prevAnimate) {
      this.updateAnimationControlsSubscription();
    }
  }
  unmount() {
  }
};

// ../../node_modules/framer-motion/dist/es/motion/features/animation/exit.mjs
var id11 = 0;
var ExitAnimationFeature = class extends Feature {
  constructor() {
    super(...arguments);
    this.id = id11++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent, onExitComplete, custom } = this.node.presenceContext;
    const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || isPresent === prevIsPresent) {
      return;
    }
    const exitAnimation = this.node.animationState.setActive("exit", !isPresent, { custom: custom !== null && custom !== void 0 ? custom : this.node.getProps().custom });
    if (onExitComplete && !isPresent) {
      exitAnimation.then(() => onExitComplete(this.id));
    }
  }
  mount() {
    const { register } = this.node.presenceContext || {};
    if (register) {
      this.unmount = register(this.id);
    }
  }
  unmount() {
  }
};

// ../../node_modules/framer-motion/dist/es/motion/features/animations.mjs
var animations = {
  animation: {
    Feature: AnimationFeature
  },
  exit: {
    Feature: ExitAnimationFeature
  }
};

// ../../node_modules/framer-motion/dist/es/utils/distance.mjs
var distance = (a4, b3) => Math.abs(a4 - b3);
function distance2D(a4, b3) {
  const xDelta = distance(a4.x, b3.x);
  const yDelta = distance(a4.y, b3.y);
  return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}

// ../../node_modules/framer-motion/dist/es/gestures/pan/PanSession.mjs
var PanSession = class {
  constructor(event, handlers, { transformPagePoint, contextWindow, dragSnapToOrigin = false } = {}) {
    this.startEvent = null;
    this.lastMoveEvent = null;
    this.lastMoveEventInfo = null;
    this.handlers = {};
    this.contextWindow = window;
    this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const info2 = getPanInfo(this.lastMoveEventInfo, this.history);
      const isPanStarted = this.startEvent !== null;
      const isDistancePastThreshold = distance2D(info2.offset, { x: 0, y: 0 }) >= 3;
      if (!isPanStarted && !isDistancePastThreshold)
        return;
      const { point: point2 } = info2;
      const { timestamp: timestamp2 } = frameData;
      this.history.push({ ...point2, timestamp: timestamp2 });
      const { onStart, onMove } = this.handlers;
      if (!isPanStarted) {
        onStart && onStart(this.lastMoveEvent, info2);
        this.startEvent = this.lastMoveEvent;
      }
      onMove && onMove(this.lastMoveEvent, info2);
    };
    this.handlePointerMove = (event2, info2) => {
      this.lastMoveEvent = event2;
      this.lastMoveEventInfo = transformPoint(info2, this.transformPagePoint);
      frame.update(this.updatePoint, true);
    };
    this.handlePointerUp = (event2, info2) => {
      this.end();
      const { onEnd, onSessionEnd, resumeAnimation } = this.handlers;
      if (this.dragSnapToOrigin)
        resumeAnimation && resumeAnimation();
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const panInfo = getPanInfo(event2.type === "pointercancel" ? this.lastMoveEventInfo : transformPoint(info2, this.transformPagePoint), this.history);
      if (this.startEvent && onEnd) {
        onEnd(event2, panInfo);
      }
      onSessionEnd && onSessionEnd(event2, panInfo);
    };
    if (!isPrimaryPointer(event))
      return;
    this.dragSnapToOrigin = dragSnapToOrigin;
    this.handlers = handlers;
    this.transformPagePoint = transformPagePoint;
    this.contextWindow = contextWindow || window;
    const info = extractEventInfo(event);
    const initialInfo = transformPoint(info, this.transformPagePoint);
    const { point } = initialInfo;
    const { timestamp } = frameData;
    this.history = [{ ...point, timestamp }];
    const { onSessionStart } = handlers;
    onSessionStart && onSessionStart(event, getPanInfo(initialInfo, this.history));
    this.removeListeners = pipe(addPointerEvent(this.contextWindow, "pointermove", this.handlePointerMove), addPointerEvent(this.contextWindow, "pointerup", this.handlePointerUp), addPointerEvent(this.contextWindow, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(handlers) {
    this.handlers = handlers;
  }
  end() {
    this.removeListeners && this.removeListeners();
    cancelFrame(this.updatePoint);
  }
};
function transformPoint(info, transformPagePoint) {
  return transformPagePoint ? { point: transformPagePoint(info.point) } : info;
}
function subtractPoint(a4, b3) {
  return { x: a4.x - b3.x, y: a4.y - b3.y };
}
function getPanInfo({ point }, history2) {
  return {
    point,
    delta: subtractPoint(point, lastDevicePoint(history2)),
    offset: subtractPoint(point, startDevicePoint(history2)),
    velocity: getVelocity2(history2, 0.1)
  };
}
function startDevicePoint(history2) {
  return history2[0];
}
function lastDevicePoint(history2) {
  return history2[history2.length - 1];
}
function getVelocity2(history2, timeDelta) {
  if (history2.length < 2) {
    return { x: 0, y: 0 };
  }
  let i4 = history2.length - 1;
  let timestampedPoint = null;
  const lastPoint = lastDevicePoint(history2);
  while (i4 >= 0) {
    timestampedPoint = history2[i4];
    if (lastPoint.timestamp - timestampedPoint.timestamp > secondsToMilliseconds(timeDelta)) {
      break;
    }
    i4--;
  }
  if (!timestampedPoint) {
    return { x: 0, y: 0 };
  }
  const time = millisecondsToSeconds(lastPoint.timestamp - timestampedPoint.timestamp);
  if (time === 0) {
    return { x: 0, y: 0 };
  }
  const currentVelocity = {
    x: (lastPoint.x - timestampedPoint.x) / time,
    y: (lastPoint.y - timestampedPoint.y) / time
  };
  if (currentVelocity.x === Infinity) {
    currentVelocity.x = 0;
  }
  if (currentVelocity.y === Infinity) {
    currentVelocity.y = 0;
  }
  return currentVelocity;
}

// ../../node_modules/framer-motion/dist/es/projection/geometry/delta-calc.mjs
function calcLength(axis) {
  return axis.max - axis.min;
}
function isNear(value, target = 0, maxDistance = 0.01) {
  return Math.abs(value - target) <= maxDistance;
}
function calcAxisDelta(delta, source, target, origin = 0.5) {
  delta.origin = origin;
  delta.originPoint = mix(source.min, source.max, delta.origin);
  delta.scale = calcLength(target) / calcLength(source);
  if (isNear(delta.scale, 1, 1e-4) || isNaN(delta.scale))
    delta.scale = 1;
  delta.translate = mix(target.min, target.max, delta.origin) - delta.originPoint;
  if (isNear(delta.translate) || isNaN(delta.translate))
    delta.translate = 0;
}
function calcBoxDelta(delta, source, target, origin) {
  calcAxisDelta(delta.x, source.x, target.x, origin ? origin.originX : void 0);
  calcAxisDelta(delta.y, source.y, target.y, origin ? origin.originY : void 0);
}
function calcRelativeAxis(target, relative, parent) {
  target.min = parent.min + relative.min;
  target.max = target.min + calcLength(relative);
}
function calcRelativeBox(target, relative, parent) {
  calcRelativeAxis(target.x, relative.x, parent.x);
  calcRelativeAxis(target.y, relative.y, parent.y);
}
function calcRelativeAxisPosition(target, layout2, parent) {
  target.min = layout2.min - parent.min;
  target.max = target.min + calcLength(layout2);
}
function calcRelativePosition(target, layout2, parent) {
  calcRelativeAxisPosition(target.x, layout2.x, parent.x);
  calcRelativeAxisPosition(target.y, layout2.y, parent.y);
}

// ../../node_modules/framer-motion/dist/es/gestures/drag/utils/constraints.mjs
function applyConstraints(point, { min, max }, elastic) {
  if (min !== void 0 && point < min) {
    point = elastic ? mix(min, point, elastic.min) : Math.max(point, min);
  } else if (max !== void 0 && point > max) {
    point = elastic ? mix(max, point, elastic.max) : Math.min(point, max);
  }
  return point;
}
function calcRelativeAxisConstraints(axis, min, max) {
  return {
    min: min !== void 0 ? axis.min + min : void 0,
    max: max !== void 0 ? axis.max + max - (axis.max - axis.min) : void 0
  };
}
function calcRelativeConstraints(layoutBox, { top, left, bottom, right }) {
  return {
    x: calcRelativeAxisConstraints(layoutBox.x, left, right),
    y: calcRelativeAxisConstraints(layoutBox.y, top, bottom)
  };
}
function calcViewportAxisConstraints(layoutAxis, constraintsAxis) {
  let min = constraintsAxis.min - layoutAxis.min;
  let max = constraintsAxis.max - layoutAxis.max;
  if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) {
    [min, max] = [max, min];
  }
  return { min, max };
}
function calcViewportConstraints(layoutBox, constraintsBox) {
  return {
    x: calcViewportAxisConstraints(layoutBox.x, constraintsBox.x),
    y: calcViewportAxisConstraints(layoutBox.y, constraintsBox.y)
  };
}
function calcOrigin2(source, target) {
  let origin = 0.5;
  const sourceLength = calcLength(source);
  const targetLength = calcLength(target);
  if (targetLength > sourceLength) {
    origin = progress(target.min, target.max - sourceLength, source.min);
  } else if (sourceLength > targetLength) {
    origin = progress(source.min, source.max - targetLength, target.min);
  }
  return clamp(0, 1, origin);
}
function rebaseAxisConstraints(layout2, constraints) {
  const relativeConstraints = {};
  if (constraints.min !== void 0) {
    relativeConstraints.min = constraints.min - layout2.min;
  }
  if (constraints.max !== void 0) {
    relativeConstraints.max = constraints.max - layout2.min;
  }
  return relativeConstraints;
}
var defaultElastic = 0.35;
function resolveDragElastic(dragElastic = defaultElastic) {
  if (dragElastic === false) {
    dragElastic = 0;
  } else if (dragElastic === true) {
    dragElastic = defaultElastic;
  }
  return {
    x: resolveAxisElastic(dragElastic, "left", "right"),
    y: resolveAxisElastic(dragElastic, "top", "bottom")
  };
}
function resolveAxisElastic(dragElastic, minLabel, maxLabel) {
  return {
    min: resolvePointElastic(dragElastic, minLabel),
    max: resolvePointElastic(dragElastic, maxLabel)
  };
}
function resolvePointElastic(dragElastic, label) {
  return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}

// ../../node_modules/framer-motion/dist/es/projection/geometry/models.mjs
var createAxisDelta = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
});
var createDelta = () => ({
  x: createAxisDelta(),
  y: createAxisDelta()
});
var createAxis = () => ({ min: 0, max: 0 });
var createBox = () => ({
  x: createAxis(),
  y: createAxis()
});

// ../../node_modules/framer-motion/dist/es/projection/utils/each-axis.mjs
function eachAxis(callback) {
  return [callback("x"), callback("y")];
}

// ../../node_modules/framer-motion/dist/es/projection/geometry/conversion.mjs
function convertBoundingBoxToBox({ top, left, right, bottom }) {
  return {
    x: { min: left, max: right },
    y: { min: top, max: bottom }
  };
}
function convertBoxToBoundingBox({ x: x4, y: y4 }) {
  return { top: y4.min, right: x4.max, bottom: y4.max, left: x4.min };
}
function transformBoxPoints(point, transformPoint2) {
  if (!transformPoint2)
    return point;
  const topLeft = transformPoint2({ x: point.left, y: point.top });
  const bottomRight = transformPoint2({ x: point.right, y: point.bottom });
  return {
    top: topLeft.y,
    left: topLeft.x,
    bottom: bottomRight.y,
    right: bottomRight.x
  };
}

// ../../node_modules/framer-motion/dist/es/projection/utils/has-transform.mjs
function isIdentityScale(scale2) {
  return scale2 === void 0 || scale2 === 1;
}
function hasScale({ scale: scale2, scaleX, scaleY }) {
  return !isIdentityScale(scale2) || !isIdentityScale(scaleX) || !isIdentityScale(scaleY);
}
function hasTransform(values) {
  return hasScale(values) || has2DTranslate(values) || values.z || values.rotate || values.rotateX || values.rotateY;
}
function has2DTranslate(values) {
  return is2DTranslate(values.x) || is2DTranslate(values.y);
}
function is2DTranslate(value) {
  return value && value !== "0%";
}

// ../../node_modules/framer-motion/dist/es/projection/geometry/delta-apply.mjs
function scalePoint(point, scale2, originPoint) {
  const distanceFromOrigin = point - originPoint;
  const scaled = scale2 * distanceFromOrigin;
  return originPoint + scaled;
}
function applyPointDelta(point, translate, scale2, originPoint, boxScale) {
  if (boxScale !== void 0) {
    point = scalePoint(point, boxScale, originPoint);
  }
  return scalePoint(point, scale2, originPoint) + translate;
}
function applyAxisDelta(axis, translate = 0, scale2 = 1, originPoint, boxScale) {
  axis.min = applyPointDelta(axis.min, translate, scale2, originPoint, boxScale);
  axis.max = applyPointDelta(axis.max, translate, scale2, originPoint, boxScale);
}
function applyBoxDelta(box, { x: x4, y: y4 }) {
  applyAxisDelta(box.x, x4.translate, x4.scale, x4.originPoint);
  applyAxisDelta(box.y, y4.translate, y4.scale, y4.originPoint);
}
function applyTreeDeltas(box, treeScale, treePath, isSharedTransition = false) {
  const treeLength = treePath.length;
  if (!treeLength)
    return;
  treeScale.x = treeScale.y = 1;
  let node566;
  let delta;
  for (let i4 = 0; i4 < treeLength; i4++) {
    node566 = treePath[i4];
    delta = node566.projectionDelta;
    const instance = node566.instance;
    if (instance && instance.style && instance.style.display === "contents") {
      continue;
    }
    if (isSharedTransition && node566.options.layoutScroll && node566.scroll && node566 !== node566.root) {
      transformBox(box, {
        x: -node566.scroll.offset.x,
        y: -node566.scroll.offset.y
      });
    }
    if (delta) {
      treeScale.x *= delta.x.scale;
      treeScale.y *= delta.y.scale;
      applyBoxDelta(box, delta);
    }
    if (isSharedTransition && hasTransform(node566.latestValues)) {
      transformBox(box, node566.latestValues);
    }
  }
  treeScale.x = snapToDefault(treeScale.x);
  treeScale.y = snapToDefault(treeScale.y);
}
function snapToDefault(scale2) {
  if (Number.isInteger(scale2))
    return scale2;
  return scale2 > 1.0000000000001 || scale2 < 0.999999999999 ? scale2 : 1;
}
function translateAxis(axis, distance2) {
  axis.min = axis.min + distance2;
  axis.max = axis.max + distance2;
}
function transformAxis(axis, transforms, [key, scaleKey, originKey]) {
  const axisOrigin = transforms[originKey] !== void 0 ? transforms[originKey] : 0.5;
  const originPoint = mix(axis.min, axis.max, axisOrigin);
  applyAxisDelta(axis, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
var xKeys = ["x", "scaleX", "originX"];
var yKeys = ["y", "scaleY", "originY"];
function transformBox(box, transform) {
  transformAxis(box.x, transform, xKeys);
  transformAxis(box.y, transform, yKeys);
}

// ../../node_modules/framer-motion/dist/es/projection/utils/measure.mjs
function measureViewportBox(instance, transformPoint2) {
  return convertBoundingBoxToBox(transformBoxPoints(instance.getBoundingClientRect(), transformPoint2));
}
function measurePageBox(element, rootProjectionNode2, transformPagePoint) {
  const viewportBox = measureViewportBox(element, transformPagePoint);
  const { scroll } = rootProjectionNode2;
  if (scroll) {
    translateAxis(viewportBox.x, scroll.offset.x);
    translateAxis(viewportBox.y, scroll.offset.y);
  }
  return viewportBox;
}

// ../../node_modules/framer-motion/dist/es/utils/get-context-window.mjs
var getContextWindow = ({ current }) => {
  return current ? current.ownerDocument.defaultView : null;
};

// ../../node_modules/framer-motion/dist/es/gestures/drag/VisualElementDragControls.mjs
var elementDragControls = /* @__PURE__ */ new WeakMap();
var VisualElementDragControls = class {
  constructor(visualElement) {
    this.openGlobalLock = null;
    this.isDragging = false;
    this.currentDirection = null;
    this.originPoint = { x: 0, y: 0 };
    this.constraints = false;
    this.hasMutatedConstraints = false;
    this.elastic = createBox();
    this.visualElement = visualElement;
  }
  start(originEvent, { snapToCursor = false } = {}) {
    const { presenceContext } = this.visualElement;
    if (presenceContext && presenceContext.isPresent === false)
      return;
    const onSessionStart = (event) => {
      const { dragSnapToOrigin: dragSnapToOrigin2 } = this.getProps();
      dragSnapToOrigin2 ? this.pauseAnimation() : this.stopAnimation();
      if (snapToCursor) {
        this.snapToCursor(extractEventInfo(event, "page").point);
      }
    };
    const onStart = (event, info) => {
      const { drag: drag2, dragPropagation, onDragStart } = this.getProps();
      if (drag2 && !dragPropagation) {
        if (this.openGlobalLock)
          this.openGlobalLock();
        this.openGlobalLock = getGlobalLock(drag2);
        if (!this.openGlobalLock)
          return;
      }
      this.isDragging = true;
      this.currentDirection = null;
      this.resolveConstraints();
      if (this.visualElement.projection) {
        this.visualElement.projection.isAnimationBlocked = true;
        this.visualElement.projection.target = void 0;
      }
      eachAxis((axis) => {
        let current = this.getAxisMotionValue(axis).get() || 0;
        if (percent.test(current)) {
          const { projection } = this.visualElement;
          if (projection && projection.layout) {
            const measuredAxis = projection.layout.layoutBox[axis];
            if (measuredAxis) {
              const length = calcLength(measuredAxis);
              current = length * (parseFloat(current) / 100);
            }
          }
        }
        this.originPoint[axis] = current;
      });
      if (onDragStart) {
        frame.update(() => onDragStart(event, info), false, true);
      }
      const { animationState } = this.visualElement;
      animationState && animationState.setActive("whileDrag", true);
    };
    const onMove = (event, info) => {
      const { dragPropagation, dragDirectionLock, onDirectionLock, onDrag } = this.getProps();
      if (!dragPropagation && !this.openGlobalLock)
        return;
      const { offset } = info;
      if (dragDirectionLock && this.currentDirection === null) {
        this.currentDirection = getCurrentDirection(offset);
        if (this.currentDirection !== null) {
          onDirectionLock && onDirectionLock(this.currentDirection);
        }
        return;
      }
      this.updateAxis("x", info.point, offset);
      this.updateAxis("y", info.point, offset);
      this.visualElement.render();
      onDrag && onDrag(event, info);
    };
    const onSessionEnd = (event, info) => this.stop(event, info);
    const resumeAnimation = () => eachAxis((axis) => {
      var _a;
      return this.getAnimationState(axis) === "paused" && ((_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.play());
    });
    const { dragSnapToOrigin } = this.getProps();
    this.panSession = new PanSession(originEvent, {
      onSessionStart,
      onStart,
      onMove,
      onSessionEnd,
      resumeAnimation
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin,
      contextWindow: getContextWindow(this.visualElement)
    });
  }
  stop(event, info) {
    const isDragging = this.isDragging;
    this.cancel();
    if (!isDragging)
      return;
    const { velocity } = info;
    this.startAnimation(velocity);
    const { onDragEnd } = this.getProps();
    if (onDragEnd) {
      frame.update(() => onDragEnd(event, info));
    }
  }
  cancel() {
    this.isDragging = false;
    const { projection, animationState } = this.visualElement;
    if (projection) {
      projection.isAnimationBlocked = false;
    }
    this.panSession && this.panSession.end();
    this.panSession = void 0;
    const { dragPropagation } = this.getProps();
    if (!dragPropagation && this.openGlobalLock) {
      this.openGlobalLock();
      this.openGlobalLock = null;
    }
    animationState && animationState.setActive("whileDrag", false);
  }
  updateAxis(axis, _point, offset) {
    const { drag: drag2 } = this.getProps();
    if (!offset || !shouldDrag(axis, drag2, this.currentDirection))
      return;
    const axisValue = this.getAxisMotionValue(axis);
    let next = this.originPoint[axis] + offset[axis];
    if (this.constraints && this.constraints[axis]) {
      next = applyConstraints(next, this.constraints[axis], this.elastic[axis]);
    }
    axisValue.set(next);
  }
  resolveConstraints() {
    var _a;
    const { dragConstraints, dragElastic } = this.getProps();
    const layout2 = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : (_a = this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout;
    const prevConstraints = this.constraints;
    if (dragConstraints && isRefObject(dragConstraints)) {
      if (!this.constraints) {
        this.constraints = this.resolveRefConstraints();
      }
    } else {
      if (dragConstraints && layout2) {
        this.constraints = calcRelativeConstraints(layout2.layoutBox, dragConstraints);
      } else {
        this.constraints = false;
      }
    }
    this.elastic = resolveDragElastic(dragElastic);
    if (prevConstraints !== this.constraints && layout2 && this.constraints && !this.hasMutatedConstraints) {
      eachAxis((axis) => {
        if (this.getAxisMotionValue(axis)) {
          this.constraints[axis] = rebaseAxisConstraints(layout2.layoutBox[axis], this.constraints[axis]);
        }
      });
    }
  }
  resolveRefConstraints() {
    const { dragConstraints: constraints, onMeasureDragConstraints } = this.getProps();
    if (!constraints || !isRefObject(constraints))
      return false;
    const constraintsElement = constraints.current;
    invariant(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
    const { projection } = this.visualElement;
    if (!projection || !projection.layout)
      return false;
    const constraintsBox = measurePageBox(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
    let measuredConstraints = calcViewportConstraints(projection.layout.layoutBox, constraintsBox);
    if (onMeasureDragConstraints) {
      const userConstraints = onMeasureDragConstraints(convertBoxToBoundingBox(measuredConstraints));
      this.hasMutatedConstraints = !!userConstraints;
      if (userConstraints) {
        measuredConstraints = convertBoundingBoxToBox(userConstraints);
      }
    }
    return measuredConstraints;
  }
  startAnimation(velocity) {
    const { drag: drag2, dragMomentum, dragElastic, dragTransition, dragSnapToOrigin, onDragTransitionEnd } = this.getProps();
    const constraints = this.constraints || {};
    const momentumAnimations = eachAxis((axis) => {
      if (!shouldDrag(axis, drag2, this.currentDirection)) {
        return;
      }
      let transition = constraints && constraints[axis] || {};
      if (dragSnapToOrigin)
        transition = { min: 0, max: 0 };
      const bounceStiffness = dragElastic ? 200 : 1e6;
      const bounceDamping = dragElastic ? 40 : 1e7;
      const inertia2 = {
        type: "inertia",
        velocity: dragMomentum ? velocity[axis] : 0,
        bounceStiffness,
        bounceDamping,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...dragTransition,
        ...transition
      };
      return this.startAxisValueAnimation(axis, inertia2);
    });
    return Promise.all(momentumAnimations).then(onDragTransitionEnd);
  }
  startAxisValueAnimation(axis, transition) {
    const axisValue = this.getAxisMotionValue(axis);
    return axisValue.start(animateMotionValue(axis, axisValue, 0, transition));
  }
  stopAnimation() {
    eachAxis((axis) => this.getAxisMotionValue(axis).stop());
  }
  pauseAnimation() {
    eachAxis((axis) => {
      var _a;
      return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.pause();
    });
  }
  getAnimationState(axis) {
    var _a;
    return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.state;
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(axis) {
    const dragKey = "_drag" + axis.toUpperCase();
    const props = this.visualElement.getProps();
    const externalMotionValue = props[dragKey];
    return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : void 0) || 0);
  }
  snapToCursor(point) {
    eachAxis((axis) => {
      const { drag: drag2 } = this.getProps();
      if (!shouldDrag(axis, drag2, this.currentDirection))
        return;
      const { projection } = this.visualElement;
      const axisValue = this.getAxisMotionValue(axis);
      if (projection && projection.layout) {
        const { min, max } = projection.layout.layoutBox[axis];
        axisValue.set(point[axis] - mix(min, max, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: drag2, dragConstraints } = this.getProps();
    const { projection } = this.visualElement;
    if (!isRefObject(dragConstraints) || !projection || !this.constraints)
      return;
    this.stopAnimation();
    const boxProgress = { x: 0, y: 0 };
    eachAxis((axis) => {
      const axisValue = this.getAxisMotionValue(axis);
      if (axisValue) {
        const latest = axisValue.get();
        boxProgress[axis] = calcOrigin2({ min: latest, max: latest }, this.constraints[axis]);
      }
    });
    const { transformTemplate } = this.visualElement.getProps();
    this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
    projection.root && projection.root.updateScroll();
    projection.updateLayout();
    this.resolveConstraints();
    eachAxis((axis) => {
      if (!shouldDrag(axis, drag2, null))
        return;
      const axisValue = this.getAxisMotionValue(axis);
      const { min, max } = this.constraints[axis];
      axisValue.set(mix(min, max, boxProgress[axis]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    elementDragControls.set(this.visualElement, this);
    const element = this.visualElement.current;
    const stopPointerListener = addPointerEvent(element, "pointerdown", (event) => {
      const { drag: drag2, dragListener = true } = this.getProps();
      drag2 && dragListener && this.start(event);
    });
    const measureDragConstraints = () => {
      const { dragConstraints } = this.getProps();
      if (isRefObject(dragConstraints)) {
        this.constraints = this.resolveRefConstraints();
      }
    };
    const { projection } = this.visualElement;
    const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
    if (projection && !projection.layout) {
      projection.root && projection.root.updateScroll();
      projection.updateLayout();
    }
    measureDragConstraints();
    const stopResizeListener = addDomEvent(window, "resize", () => this.scalePositionWithinConstraints());
    const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta, hasLayoutChanged }) => {
      if (this.isDragging && hasLayoutChanged) {
        eachAxis((axis) => {
          const motionValue2 = this.getAxisMotionValue(axis);
          if (!motionValue2)
            return;
          this.originPoint[axis] += delta[axis].translate;
          motionValue2.set(motionValue2.get() + delta[axis].translate);
        });
        this.visualElement.render();
      }
    });
    return () => {
      stopResizeListener();
      stopPointerListener();
      stopMeasureLayoutListener();
      stopLayoutUpdateListener && stopLayoutUpdateListener();
    };
  }
  getProps() {
    const props = this.visualElement.getProps();
    const { drag: drag2 = false, dragDirectionLock = false, dragPropagation = false, dragConstraints = false, dragElastic = defaultElastic, dragMomentum = true } = props;
    return {
      ...props,
      drag: drag2,
      dragDirectionLock,
      dragPropagation,
      dragConstraints,
      dragElastic,
      dragMomentum
    };
  }
};
function shouldDrag(direction, drag2, currentDirection) {
  return (drag2 === true || drag2 === direction) && (currentDirection === null || currentDirection === direction);
}
function getCurrentDirection(offset, lockThreshold = 10) {
  let direction = null;
  if (Math.abs(offset.y) > lockThreshold) {
    direction = "y";
  } else if (Math.abs(offset.x) > lockThreshold) {
    direction = "x";
  }
  return direction;
}

// ../../node_modules/framer-motion/dist/es/gestures/drag/index.mjs
var DragGesture = class extends Feature {
  constructor(node566) {
    super(node566);
    this.removeGroupControls = noop4;
    this.removeListeners = noop4;
    this.controls = new VisualElementDragControls(node566);
  }
  mount() {
    const { dragControls } = this.node.getProps();
    if (dragControls) {
      this.removeGroupControls = dragControls.subscribe(this.controls);
    }
    this.removeListeners = this.controls.addListeners() || noop4;
  }
  unmount() {
    this.removeGroupControls();
    this.removeListeners();
  }
};

// ../../node_modules/framer-motion/dist/es/gestures/pan/index.mjs
var asyncHandler = (handler) => (event, info) => {
  if (handler) {
    frame.update(() => handler(event, info));
  }
};
var PanGesture = class extends Feature {
  constructor() {
    super(...arguments);
    this.removePointerDownListener = noop4;
  }
  onPointerDown(pointerDownEvent) {
    this.session = new PanSession(pointerDownEvent, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: getContextWindow(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart, onPanStart, onPan, onPanEnd } = this.node.getProps();
    return {
      onSessionStart: asyncHandler(onPanSessionStart),
      onStart: asyncHandler(onPanStart),
      onMove: onPan,
      onEnd: (event, info) => {
        delete this.session;
        if (onPanEnd) {
          frame.update(() => onPanEnd(event, info));
        }
      }
    };
  }
  mount() {
    this.removePointerDownListener = addPointerEvent(this.node.current, "pointerdown", (event) => this.onPointerDown(event));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener();
    this.session && this.session.end();
  }
};

// ../../node_modules/framer-motion/dist/es/motion/features/layout/MeasureLayout.mjs
import React__default, { useContext as useContext6 } from "react";

// ../../node_modules/framer-motion/dist/es/components/AnimatePresence/use-presence.mjs
import { useContext as useContext5, useId, useEffect as useEffect9 } from "react";
function usePresence() {
  const context = useContext5(PresenceContext);
  if (context === null)
    return [true, null];
  const { isPresent, onExitComplete, register } = context;
  const id18 = useId();
  useEffect9(() => register(id18), []);
  const safeToRemove = () => onExitComplete && onExitComplete(id18);
  return !isPresent && onExitComplete ? [false, safeToRemove] : [true];
}

// ../../node_modules/framer-motion/dist/es/projection/node/state.mjs
var globalProjectionState = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: true,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: false
};

// ../../node_modules/framer-motion/dist/es/projection/styles/scale-border-radius.mjs
function pixelsToPercent(pixels, axis) {
  if (axis.max === axis.min)
    return 0;
  return pixels / (axis.max - axis.min) * 100;
}
var correctBorderRadius = {
  correct: (latest, node566) => {
    if (!node566.target)
      return latest;
    if (typeof latest === "string") {
      if (px.test(latest)) {
        latest = parseFloat(latest);
      } else {
        return latest;
      }
    }
    const x4 = pixelsToPercent(latest, node566.target.x);
    const y4 = pixelsToPercent(latest, node566.target.y);
    return `${x4}% ${y4}%`;
  }
};

// ../../node_modules/framer-motion/dist/es/projection/styles/scale-box-shadow.mjs
var correctBoxShadow = {
  correct: (latest, { treeScale, projectionDelta }) => {
    const original = latest;
    const shadow = complex.parse(latest);
    if (shadow.length > 5)
      return original;
    const template = complex.createTransformer(latest);
    const offset = typeof shadow[0] !== "number" ? 1 : 0;
    const xScale = projectionDelta.x.scale * treeScale.x;
    const yScale = projectionDelta.y.scale * treeScale.y;
    shadow[0 + offset] /= xScale;
    shadow[1 + offset] /= yScale;
    const averageScale = mix(xScale, yScale, 0.5);
    if (typeof shadow[2 + offset] === "number")
      shadow[2 + offset] /= averageScale;
    if (typeof shadow[3 + offset] === "number")
      shadow[3 + offset] /= averageScale;
    return template(shadow);
  }
};

// ../../node_modules/framer-motion/dist/es/motion/features/layout/MeasureLayout.mjs
var MeasureLayoutWithContext = class extends React__default.Component {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement, layoutGroup, switchLayoutGroup, layoutId } = this.props;
    const { projection } = visualElement;
    addScaleCorrector(defaultScaleCorrectors);
    if (projection) {
      if (layoutGroup.group)
        layoutGroup.group.add(projection);
      if (switchLayoutGroup && switchLayoutGroup.register && layoutId) {
        switchLayoutGroup.register(projection);
      }
      projection.root.didUpdate();
      projection.addEventListener("animationComplete", () => {
        this.safeToRemove();
      });
      projection.setOptions({
        ...projection.options,
        onExitComplete: () => this.safeToRemove()
      });
    }
    globalProjectionState.hasEverUpdated = true;
  }
  getSnapshotBeforeUpdate(prevProps) {
    const { layoutDependency, visualElement, drag: drag2, isPresent } = this.props;
    const projection = visualElement.projection;
    if (!projection)
      return null;
    projection.isPresent = isPresent;
    if (drag2 || prevProps.layoutDependency !== layoutDependency || layoutDependency === void 0) {
      projection.willUpdate();
    } else {
      this.safeToRemove();
    }
    if (prevProps.isPresent !== isPresent) {
      if (isPresent) {
        projection.promote();
      } else if (!projection.relegate()) {
        frame.postRender(() => {
          const stack = projection.getStack();
          if (!stack || !stack.members.length) {
            this.safeToRemove();
          }
        });
      }
    }
    return null;
  }
  componentDidUpdate() {
    const { projection } = this.props.visualElement;
    if (projection) {
      projection.root.didUpdate();
      queueMicrotask(() => {
        if (!projection.currentAnimation && projection.isLead()) {
          this.safeToRemove();
        }
      });
    }
  }
  componentWillUnmount() {
    const { visualElement, layoutGroup, switchLayoutGroup: promoteContext } = this.props;
    const { projection } = visualElement;
    if (projection) {
      projection.scheduleCheckAfterUnmount();
      if (layoutGroup && layoutGroup.group)
        layoutGroup.group.remove(projection);
      if (promoteContext && promoteContext.deregister)
        promoteContext.deregister(projection);
    }
  }
  safeToRemove() {
    const { safeToRemove } = this.props;
    safeToRemove && safeToRemove();
  }
  render() {
    return null;
  }
};
function MeasureLayout(props) {
  const [isPresent, safeToRemove] = usePresence();
  const layoutGroup = useContext6(LayoutGroupContext);
  return React__default.createElement(MeasureLayoutWithContext, { ...props, layoutGroup, switchLayoutGroup: useContext6(SwitchLayoutGroupContext), isPresent, safeToRemove });
}
var defaultScaleCorrectors = {
  borderRadius: {
    ...correctBorderRadius,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: correctBorderRadius,
  borderTopRightRadius: correctBorderRadius,
  borderBottomLeftRadius: correctBorderRadius,
  borderBottomRightRadius: correctBorderRadius,
  boxShadow: correctBoxShadow
};

// ../../node_modules/framer-motion/dist/es/projection/animation/mix-values.mjs
var borders = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"];
var numBorders = borders.length;
var asNumber = (value) => typeof value === "string" ? parseFloat(value) : value;
var isPx = (value) => typeof value === "number" || px.test(value);
function mixValues(target, follow, lead, progress2, shouldCrossfadeOpacity, isOnlyMember) {
  if (shouldCrossfadeOpacity) {
    target.opacity = mix(
      0,
      // TODO Reinstate this if only child
      lead.opacity !== void 0 ? lead.opacity : 1,
      easeCrossfadeIn(progress2)
    );
    target.opacityExit = mix(follow.opacity !== void 0 ? follow.opacity : 1, 0, easeCrossfadeOut(progress2));
  } else if (isOnlyMember) {
    target.opacity = mix(follow.opacity !== void 0 ? follow.opacity : 1, lead.opacity !== void 0 ? lead.opacity : 1, progress2);
  }
  for (let i4 = 0; i4 < numBorders; i4++) {
    const borderLabel = `border${borders[i4]}Radius`;
    let followRadius = getRadius(follow, borderLabel);
    let leadRadius = getRadius(lead, borderLabel);
    if (followRadius === void 0 && leadRadius === void 0)
      continue;
    followRadius || (followRadius = 0);
    leadRadius || (leadRadius = 0);
    const canMix = followRadius === 0 || leadRadius === 0 || isPx(followRadius) === isPx(leadRadius);
    if (canMix) {
      target[borderLabel] = Math.max(mix(asNumber(followRadius), asNumber(leadRadius), progress2), 0);
      if (percent.test(leadRadius) || percent.test(followRadius)) {
        target[borderLabel] += "%";
      }
    } else {
      target[borderLabel] = leadRadius;
    }
  }
  if (follow.rotate || lead.rotate) {
    target.rotate = mix(follow.rotate || 0, lead.rotate || 0, progress2);
  }
}
function getRadius(values, radiusName) {
  return values[radiusName] !== void 0 ? values[radiusName] : values.borderRadius;
}
var easeCrossfadeIn = compress(0, 0.5, circOut);
var easeCrossfadeOut = compress(0.5, 0.95, noop4);
function compress(min, max, easing) {
  return (p4) => {
    if (p4 < min)
      return 0;
    if (p4 > max)
      return 1;
    return easing(progress(min, max, p4));
  };
}

// ../../node_modules/framer-motion/dist/es/projection/geometry/copy.mjs
function copyAxisInto(axis, originAxis) {
  axis.min = originAxis.min;
  axis.max = originAxis.max;
}
function copyBoxInto(box, originBox) {
  copyAxisInto(box.x, originBox.x);
  copyAxisInto(box.y, originBox.y);
}

// ../../node_modules/framer-motion/dist/es/projection/geometry/delta-remove.mjs
function removePointDelta(point, translate, scale2, originPoint, boxScale) {
  point -= translate;
  point = scalePoint(point, 1 / scale2, originPoint);
  if (boxScale !== void 0) {
    point = scalePoint(point, 1 / boxScale, originPoint);
  }
  return point;
}
function removeAxisDelta(axis, translate = 0, scale2 = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
  if (percent.test(translate)) {
    translate = parseFloat(translate);
    const relativeProgress = mix(sourceAxis.min, sourceAxis.max, translate / 100);
    translate = relativeProgress - sourceAxis.min;
  }
  if (typeof translate !== "number")
    return;
  let originPoint = mix(originAxis.min, originAxis.max, origin);
  if (axis === originAxis)
    originPoint -= translate;
  axis.min = removePointDelta(axis.min, translate, scale2, originPoint, boxScale);
  axis.max = removePointDelta(axis.max, translate, scale2, originPoint, boxScale);
}
function removeAxisTransforms(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
  removeAxisDelta(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
var xKeys2 = ["x", "scaleX", "originX"];
var yKeys2 = ["y", "scaleY", "originY"];
function removeBoxTransforms(box, transforms, originBox, sourceBox) {
  removeAxisTransforms(box.x, transforms, xKeys2, originBox ? originBox.x : void 0, sourceBox ? sourceBox.x : void 0);
  removeAxisTransforms(box.y, transforms, yKeys2, originBox ? originBox.y : void 0, sourceBox ? sourceBox.y : void 0);
}

// ../../node_modules/framer-motion/dist/es/projection/geometry/utils.mjs
function isAxisDeltaZero(delta) {
  return delta.translate === 0 && delta.scale === 1;
}
function isDeltaZero(delta) {
  return isAxisDeltaZero(delta.x) && isAxisDeltaZero(delta.y);
}
function boxEquals(a4, b3) {
  return a4.x.min === b3.x.min && a4.x.max === b3.x.max && a4.y.min === b3.y.min && a4.y.max === b3.y.max;
}
function boxEqualsRounded(a4, b3) {
  return Math.round(a4.x.min) === Math.round(b3.x.min) && Math.round(a4.x.max) === Math.round(b3.x.max) && Math.round(a4.y.min) === Math.round(b3.y.min) && Math.round(a4.y.max) === Math.round(b3.y.max);
}
function aspectRatio(box) {
  return calcLength(box.x) / calcLength(box.y);
}

// ../../node_modules/framer-motion/dist/es/projection/shared/stack.mjs
var NodeStack = class {
  constructor() {
    this.members = [];
  }
  add(node566) {
    addUniqueItem(this.members, node566);
    node566.scheduleRender();
  }
  remove(node566) {
    removeItem(this.members, node566);
    if (node566 === this.prevLead) {
      this.prevLead = void 0;
    }
    if (node566 === this.lead) {
      const prevLead = this.members[this.members.length - 1];
      if (prevLead) {
        this.promote(prevLead);
      }
    }
  }
  relegate(node566) {
    const indexOfNode = this.members.findIndex((member) => node566 === member);
    if (indexOfNode === 0)
      return false;
    let prevLead;
    for (let i4 = indexOfNode; i4 >= 0; i4--) {
      const member = this.members[i4];
      if (member.isPresent !== false) {
        prevLead = member;
        break;
      }
    }
    if (prevLead) {
      this.promote(prevLead);
      return true;
    } else {
      return false;
    }
  }
  promote(node566, preserveFollowOpacity) {
    const prevLead = this.lead;
    if (node566 === prevLead)
      return;
    this.prevLead = prevLead;
    this.lead = node566;
    node566.show();
    if (prevLead) {
      prevLead.instance && prevLead.scheduleRender();
      node566.scheduleRender();
      node566.resumeFrom = prevLead;
      if (preserveFollowOpacity) {
        node566.resumeFrom.preserveOpacity = true;
      }
      if (prevLead.snapshot) {
        node566.snapshot = prevLead.snapshot;
        node566.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
      }
      if (node566.root && node566.root.isUpdating) {
        node566.isLayoutDirty = true;
      }
      const { crossfade } = node566.options;
      if (crossfade === false) {
        prevLead.hide();
      }
    }
  }
  exitAnimationComplete() {
    this.members.forEach((node566) => {
      const { options: options7, resumingFrom } = node566;
      options7.onExitComplete && options7.onExitComplete();
      if (resumingFrom) {
        resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
      }
    });
  }
  scheduleRender() {
    this.members.forEach((node566) => {
      node566.instance && node566.scheduleRender(false);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    if (this.lead && this.lead.snapshot) {
      this.lead.snapshot = void 0;
    }
  }
};

// ../../node_modules/framer-motion/dist/es/projection/styles/transform.mjs
function buildProjectionTransform(delta, treeScale, latestTransform) {
  let transform = "";
  const xTranslate = delta.x.translate / treeScale.x;
  const yTranslate = delta.y.translate / treeScale.y;
  if (xTranslate || yTranslate) {
    transform = `translate3d(${xTranslate}px, ${yTranslate}px, 0) `;
  }
  if (treeScale.x !== 1 || treeScale.y !== 1) {
    transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
  }
  if (latestTransform) {
    const { rotate, rotateX, rotateY } = latestTransform;
    if (rotate)
      transform += `rotate(${rotate}deg) `;
    if (rotateX)
      transform += `rotateX(${rotateX}deg) `;
    if (rotateY)
      transform += `rotateY(${rotateY}deg) `;
  }
  const elementScaleX = delta.x.scale * treeScale.x;
  const elementScaleY = delta.y.scale * treeScale.y;
  if (elementScaleX !== 1 || elementScaleY !== 1) {
    transform += `scale(${elementScaleX}, ${elementScaleY})`;
  }
  return transform || "none";
}

// ../../node_modules/framer-motion/dist/es/render/utils/compare-by-depth.mjs
var compareByDepth = (a4, b3) => a4.depth - b3.depth;

// ../../node_modules/framer-motion/dist/es/render/utils/flat-tree.mjs
var FlatTree = class {
  constructor() {
    this.children = [];
    this.isDirty = false;
  }
  add(child) {
    addUniqueItem(this.children, child);
    this.isDirty = true;
  }
  remove(child) {
    removeItem(this.children, child);
    this.isDirty = true;
  }
  forEach(callback) {
    this.isDirty && this.children.sort(compareByDepth);
    this.isDirty = false;
    this.children.forEach(callback);
  }
};

// ../../node_modules/framer-motion/dist/es/utils/delay.mjs
function delay(callback, timeout) {
  const start = performance.now();
  const checkElapsed = ({ timestamp }) => {
    const elapsed = timestamp - start;
    if (elapsed >= timeout) {
      cancelFrame(checkElapsed);
      callback(elapsed - timeout);
    }
  };
  frame.read(checkElapsed, true);
  return () => cancelFrame(checkElapsed);
}

// ../../node_modules/framer-motion/dist/es/debug/record.mjs
function record(data) {
  if (window.MotionDebug) {
    window.MotionDebug.record(data);
  }
}

// ../../node_modules/framer-motion/dist/es/render/dom/utils/is-svg-element.mjs
function isSVGElement(element) {
  return element instanceof SVGElement && element.tagName !== "svg";
}

// ../../node_modules/framer-motion/dist/es/animation/interfaces/single-value.mjs
function animateSingleValue(value, keyframes2, options7) {
  const motionValue$1 = isMotionValue(value) ? value : motionValue(value);
  motionValue$1.start(animateMotionValue("", motionValue$1, keyframes2, options7));
  return motionValue$1.animation;
}

// ../../node_modules/framer-motion/dist/es/projection/node/create-projection-node.mjs
var transformAxes = ["", "X", "Y", "Z"];
var hiddenVisibility = { visibility: "hidden" };
var animationTarget = 1e3;
var id12 = 0;
var projectionFrameData = {
  type: "projectionFrame",
  totalNodes: 0,
  resolvedTargetDeltas: 0,
  recalculatedProjection: 0
};
function createProjectionNode({ attachResizeListener, defaultParent, measureScroll, checkIsScrollRoot, resetTransform }) {
  return class ProjectionNode {
    constructor(latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()) {
      this.id = id12++;
      this.animationId = 0;
      this.children = /* @__PURE__ */ new Set();
      this.options = {};
      this.isTreeAnimating = false;
      this.isAnimationBlocked = false;
      this.isLayoutDirty = false;
      this.isProjectionDirty = false;
      this.isSharedProjectionDirty = false;
      this.isTransformDirty = false;
      this.updateManuallyBlocked = false;
      this.updateBlockedByResize = false;
      this.isUpdating = false;
      this.isSVG = false;
      this.needsReset = false;
      this.shouldResetTransform = false;
      this.treeScale = { x: 1, y: 1 };
      this.eventHandlers = /* @__PURE__ */ new Map();
      this.hasTreeAnimated = false;
      this.updateScheduled = false;
      this.projectionUpdateScheduled = false;
      this.checkUpdateFailed = () => {
        if (this.isUpdating) {
          this.isUpdating = false;
          this.clearAllSnapshots();
        }
      };
      this.updateProjection = () => {
        this.projectionUpdateScheduled = false;
        projectionFrameData.totalNodes = projectionFrameData.resolvedTargetDeltas = projectionFrameData.recalculatedProjection = 0;
        this.nodes.forEach(propagateDirtyNodes);
        this.nodes.forEach(resolveTargetDelta);
        this.nodes.forEach(calcProjection);
        this.nodes.forEach(cleanDirtyNodes);
        record(projectionFrameData);
      };
      this.hasProjected = false;
      this.isVisible = true;
      this.animationProgress = 0;
      this.sharedNodes = /* @__PURE__ */ new Map();
      this.latestValues = latestValues;
      this.root = parent ? parent.root || parent : this;
      this.path = parent ? [...parent.path, parent] : [];
      this.parent = parent;
      this.depth = parent ? parent.depth + 1 : 0;
      for (let i4 = 0; i4 < this.path.length; i4++) {
        this.path[i4].shouldResetTransform = true;
      }
      if (this.root === this)
        this.nodes = new FlatTree();
    }
    addEventListener(name, handler) {
      if (!this.eventHandlers.has(name)) {
        this.eventHandlers.set(name, new SubscriptionManager());
      }
      return this.eventHandlers.get(name).add(handler);
    }
    notifyListeners(name, ...args) {
      const subscriptionManager = this.eventHandlers.get(name);
      subscriptionManager && subscriptionManager.notify(...args);
    }
    hasListeners(name) {
      return this.eventHandlers.has(name);
    }
    /**
     * Lifecycles
     */
    mount(instance, isLayoutDirty = this.root.hasTreeAnimated) {
      if (this.instance)
        return;
      this.isSVG = isSVGElement(instance);
      this.instance = instance;
      const { layoutId, layout: layout2, visualElement } = this.options;
      if (visualElement && !visualElement.current) {
        visualElement.mount(instance);
      }
      this.root.nodes.add(this);
      this.parent && this.parent.children.add(this);
      if (isLayoutDirty && (layout2 || layoutId)) {
        this.isLayoutDirty = true;
      }
      if (attachResizeListener) {
        let cancelDelay;
        const resizeUnblockUpdate = () => this.root.updateBlockedByResize = false;
        attachResizeListener(instance, () => {
          this.root.updateBlockedByResize = true;
          cancelDelay && cancelDelay();
          cancelDelay = delay(resizeUnblockUpdate, 250);
          if (globalProjectionState.hasAnimatedSinceResize) {
            globalProjectionState.hasAnimatedSinceResize = false;
            this.nodes.forEach(finishAnimation);
          }
        });
      }
      if (layoutId) {
        this.root.registerSharedNode(layoutId, this);
      }
      if (this.options.animate !== false && visualElement && (layoutId || layout2)) {
        this.addEventListener("didUpdate", ({ delta, hasLayoutChanged, hasRelativeTargetChanged, layout: newLayout }) => {
          if (this.isTreeAnimationBlocked()) {
            this.target = void 0;
            this.relativeTarget = void 0;
            return;
          }
          const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || defaultLayoutTransition;
          const { onLayoutAnimationStart, onLayoutAnimationComplete } = visualElement.getProps();
          const targetChanged = !this.targetLayout || !boxEqualsRounded(this.targetLayout, newLayout) || hasRelativeTargetChanged;
          const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
          if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !this.currentAnimation)) {
            if (this.resumeFrom) {
              this.resumingFrom = this.resumeFrom;
              this.resumingFrom.resumingFrom = void 0;
            }
            this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
            const animationOptions = {
              ...getValueTransition(layoutTransition, "layout"),
              onPlay: onLayoutAnimationStart,
              onComplete: onLayoutAnimationComplete
            };
            if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
              animationOptions.delay = 0;
              animationOptions.type = false;
            }
            this.startAnimation(animationOptions);
          } else {
            if (!hasLayoutChanged) {
              finishAnimation(this);
            }
            if (this.isLead() && this.options.onExitComplete) {
              this.options.onExitComplete();
            }
          }
          this.targetLayout = newLayout;
        });
      }
    }
    unmount() {
      this.options.layoutId && this.willUpdate();
      this.root.nodes.remove(this);
      const stack = this.getStack();
      stack && stack.remove(this);
      this.parent && this.parent.children.delete(this);
      this.instance = void 0;
      cancelFrame(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = true;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = false;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
    }
    // Note: currently only running on root node
    startUpdate() {
      if (this.isUpdateBlocked())
        return;
      this.isUpdating = true;
      this.nodes && this.nodes.forEach(resetRotation);
      this.animationId++;
    }
    getTransformTemplate() {
      const { visualElement } = this.options;
      return visualElement && visualElement.getProps().transformTemplate;
    }
    willUpdate(shouldNotifyListeners = true) {
      this.root.hasTreeAnimated = true;
      if (this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      !this.root.isUpdating && this.root.startUpdate();
      if (this.isLayoutDirty)
        return;
      this.isLayoutDirty = true;
      for (let i4 = 0; i4 < this.path.length; i4++) {
        const node566 = this.path[i4];
        node566.shouldResetTransform = true;
        node566.updateScroll("snapshot");
        if (node566.options.layoutRoot) {
          node566.willUpdate(false);
        }
      }
      const { layoutId, layout: layout2 } = this.options;
      if (layoutId === void 0 && !layout2)
        return;
      const transformTemplate = this.getTransformTemplate();
      this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : void 0;
      this.updateSnapshot();
      shouldNotifyListeners && this.notifyListeners("willUpdate");
    }
    update() {
      this.updateScheduled = false;
      const updateWasBlocked = this.isUpdateBlocked();
      if (updateWasBlocked) {
        this.unblockUpdate();
        this.clearAllSnapshots();
        this.nodes.forEach(clearMeasurements);
        return;
      }
      if (!this.isUpdating) {
        this.nodes.forEach(clearIsLayoutDirty);
      }
      this.isUpdating = false;
      this.nodes.forEach(resetTransformStyle);
      this.nodes.forEach(updateLayout);
      this.nodes.forEach(notifyLayoutUpdate);
      this.clearAllSnapshots();
      const now2 = performance.now();
      frameData.delta = clamp(0, 1e3 / 60, now2 - frameData.timestamp);
      frameData.timestamp = now2;
      frameData.isProcessing = true;
      steps.update.process(frameData);
      steps.preRender.process(frameData);
      steps.render.process(frameData);
      frameData.isProcessing = false;
    }
    didUpdate() {
      if (!this.updateScheduled) {
        this.updateScheduled = true;
        queueMicrotask(() => this.update());
      }
    }
    clearAllSnapshots() {
      this.nodes.forEach(clearSnapshot);
      this.sharedNodes.forEach(removeLeadSnapshots);
    }
    scheduleUpdateProjection() {
      if (!this.projectionUpdateScheduled) {
        this.projectionUpdateScheduled = true;
        frame.preRender(this.updateProjection, false, true);
      }
    }
    scheduleCheckAfterUnmount() {
      frame.postRender(() => {
        if (this.isLayoutDirty) {
          this.root.didUpdate();
        } else {
          this.root.checkUpdateFailed();
        }
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      if (this.snapshot || !this.instance)
        return;
      this.snapshot = this.measure();
    }
    updateLayout() {
      if (!this.instance)
        return;
      this.updateScroll();
      if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) {
        return;
      }
      if (this.resumeFrom && !this.resumeFrom.instance) {
        for (let i4 = 0; i4 < this.path.length; i4++) {
          const node566 = this.path[i4];
          node566.updateScroll();
        }
      }
      const prevLayout = this.layout;
      this.layout = this.measure(false);
      this.layoutCorrected = createBox();
      this.isLayoutDirty = false;
      this.projectionDelta = void 0;
      this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement } = this.options;
      visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : void 0);
    }
    updateScroll(phase = "measure") {
      let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) {
        needsMeasurement = false;
      }
      if (needsMeasurement) {
        this.scroll = {
          animationId: this.root.animationId,
          phase,
          isRoot: checkIsScrollRoot(this.instance),
          offset: measureScroll(this.instance)
        };
      }
    }
    resetTransform() {
      if (!resetTransform)
        return;
      const isResetRequested = this.isLayoutDirty || this.shouldResetTransform;
      const hasProjection = this.projectionDelta && !isDeltaZero(this.projectionDelta);
      const transformTemplate = this.getTransformTemplate();
      const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : void 0;
      const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
      if (isResetRequested && (hasProjection || hasTransform(this.latestValues) || transformTemplateHasChanged)) {
        resetTransform(this.instance, transformTemplateValue);
        this.shouldResetTransform = false;
        this.scheduleRender();
      }
    }
    measure(removeTransform = true) {
      const pageBox = this.measurePageBox();
      let layoutBox = this.removeElementScroll(pageBox);
      if (removeTransform) {
        layoutBox = this.removeTransform(layoutBox);
      }
      roundBox(layoutBox);
      return {
        animationId: this.root.animationId,
        measuredBox: pageBox,
        layoutBox,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      const { visualElement } = this.options;
      if (!visualElement)
        return createBox();
      const box = visualElement.measureViewportBox();
      const { scroll } = this.root;
      if (scroll) {
        translateAxis(box.x, scroll.offset.x);
        translateAxis(box.y, scroll.offset.y);
      }
      return box;
    }
    removeElementScroll(box) {
      const boxWithoutScroll = createBox();
      copyBoxInto(boxWithoutScroll, box);
      for (let i4 = 0; i4 < this.path.length; i4++) {
        const node566 = this.path[i4];
        const { scroll, options: options7 } = node566;
        if (node566 !== this.root && scroll && options7.layoutScroll) {
          if (scroll.isRoot) {
            copyBoxInto(boxWithoutScroll, box);
            const { scroll: rootScroll } = this.root;
            if (rootScroll) {
              translateAxis(boxWithoutScroll.x, -rootScroll.offset.x);
              translateAxis(boxWithoutScroll.y, -rootScroll.offset.y);
            }
          }
          translateAxis(boxWithoutScroll.x, scroll.offset.x);
          translateAxis(boxWithoutScroll.y, scroll.offset.y);
        }
      }
      return boxWithoutScroll;
    }
    applyTransform(box, transformOnly = false) {
      const withTransforms = createBox();
      copyBoxInto(withTransforms, box);
      for (let i4 = 0; i4 < this.path.length; i4++) {
        const node566 = this.path[i4];
        if (!transformOnly && node566.options.layoutScroll && node566.scroll && node566 !== node566.root) {
          transformBox(withTransforms, {
            x: -node566.scroll.offset.x,
            y: -node566.scroll.offset.y
          });
        }
        if (!hasTransform(node566.latestValues))
          continue;
        transformBox(withTransforms, node566.latestValues);
      }
      if (hasTransform(this.latestValues)) {
        transformBox(withTransforms, this.latestValues);
      }
      return withTransforms;
    }
    removeTransform(box) {
      const boxWithoutTransform = createBox();
      copyBoxInto(boxWithoutTransform, box);
      for (let i4 = 0; i4 < this.path.length; i4++) {
        const node566 = this.path[i4];
        if (!node566.instance)
          continue;
        if (!hasTransform(node566.latestValues))
          continue;
        hasScale(node566.latestValues) && node566.updateSnapshot();
        const sourceBox = createBox();
        const nodeBox = node566.measurePageBox();
        copyBoxInto(sourceBox, nodeBox);
        removeBoxTransforms(boxWithoutTransform, node566.latestValues, node566.snapshot ? node566.snapshot.layoutBox : void 0, sourceBox);
      }
      if (hasTransform(this.latestValues)) {
        removeBoxTransforms(boxWithoutTransform, this.latestValues);
      }
      return boxWithoutTransform;
    }
    setTargetDelta(delta) {
      this.targetDelta = delta;
      this.root.scheduleUpdateProjection();
      this.isProjectionDirty = true;
    }
    setOptions(options7) {
      this.options = {
        ...this.options,
        ...options7,
        crossfade: options7.crossfade !== void 0 ? options7.crossfade : true
      };
    }
    clearMeasurements() {
      this.scroll = void 0;
      this.layout = void 0;
      this.snapshot = void 0;
      this.prevTransformTemplateValue = void 0;
      this.targetDelta = void 0;
      this.target = void 0;
      this.isLayoutDirty = false;
    }
    forceRelativeParentToResolveTarget() {
      if (!this.relativeParent)
        return;
      if (this.relativeParent.resolvedRelativeTargetAt !== frameData.timestamp) {
        this.relativeParent.resolveTargetDelta(true);
      }
    }
    resolveTargetDelta(forceRecalculation = false) {
      var _a;
      const lead = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
      this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
      this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
      const isShared = Boolean(this.resumingFrom) || this !== lead;
      const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty) || this.attemptToResolveRelativeTarget);
      if (canSkip)
        return;
      const { layout: layout2, layoutId } = this.options;
      if (!this.layout || !(layout2 || layoutId))
        return;
      this.resolvedRelativeTargetAt = frameData.timestamp;
      if (!this.targetDelta && !this.relativeTarget) {
        const relativeParent = this.getClosestProjectingParent();
        if (relativeParent && relativeParent.layout && this.animationProgress !== 1) {
          this.relativeParent = relativeParent;
          this.forceRelativeParentToResolveTarget();
          this.relativeTarget = createBox();
          this.relativeTargetOrigin = createBox();
          calcRelativePosition(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
          copyBoxInto(this.relativeTarget, this.relativeTargetOrigin);
        } else {
          this.relativeParent = this.relativeTarget = void 0;
        }
      }
      if (!this.relativeTarget && !this.targetDelta)
        return;
      if (!this.target) {
        this.target = createBox();
        this.targetWithTransforms = createBox();
      }
      if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
        this.forceRelativeParentToResolveTarget();
        calcRelativeBox(this.target, this.relativeTarget, this.relativeParent.target);
      } else if (this.targetDelta) {
        if (Boolean(this.resumingFrom)) {
          this.target = this.applyTransform(this.layout.layoutBox);
        } else {
          copyBoxInto(this.target, this.layout.layoutBox);
        }
        applyBoxDelta(this.target, this.targetDelta);
      } else {
        copyBoxInto(this.target, this.layout.layoutBox);
      }
      if (this.attemptToResolveRelativeTarget) {
        this.attemptToResolveRelativeTarget = false;
        const relativeParent = this.getClosestProjectingParent();
        if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) {
          this.relativeParent = relativeParent;
          this.forceRelativeParentToResolveTarget();
          this.relativeTarget = createBox();
          this.relativeTargetOrigin = createBox();
          calcRelativePosition(this.relativeTargetOrigin, this.target, relativeParent.target);
          copyBoxInto(this.relativeTarget, this.relativeTargetOrigin);
        } else {
          this.relativeParent = this.relativeTarget = void 0;
        }
      }
      projectionFrameData.resolvedTargetDeltas++;
    }
    getClosestProjectingParent() {
      if (!this.parent || hasScale(this.parent.latestValues) || has2DTranslate(this.parent.latestValues)) {
        return void 0;
      }
      if (this.parent.isProjecting()) {
        return this.parent;
      } else {
        return this.parent.getClosestProjectingParent();
      }
    }
    isProjecting() {
      return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      var _a;
      const lead = this.getLead();
      const isShared = Boolean(this.resumingFrom) || this !== lead;
      let canSkip = true;
      if (this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty)) {
        canSkip = false;
      }
      if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) {
        canSkip = false;
      }
      if (this.resolvedRelativeTargetAt === frameData.timestamp) {
        canSkip = false;
      }
      if (canSkip)
        return;
      const { layout: layout2, layoutId } = this.options;
      this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
      if (!this.isTreeAnimating) {
        this.targetDelta = this.relativeTarget = void 0;
      }
      if (!this.layout || !(layout2 || layoutId))
        return;
      copyBoxInto(this.layoutCorrected, this.layout.layoutBox);
      const prevTreeScaleX = this.treeScale.x;
      const prevTreeScaleY = this.treeScale.y;
      applyTreeDeltas(this.layoutCorrected, this.treeScale, this.path, isShared);
      if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) {
        lead.target = lead.layout.layoutBox;
      }
      const { target } = lead;
      if (!target) {
        if (this.projectionTransform) {
          this.projectionDelta = createDelta();
          this.projectionTransform = "none";
          this.scheduleRender();
        }
        return;
      }
      if (!this.projectionDelta) {
        this.projectionDelta = createDelta();
        this.projectionDeltaWithTransform = createDelta();
      }
      const prevProjectionTransform = this.projectionTransform;
      calcBoxDelta(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
      this.projectionTransform = buildProjectionTransform(this.projectionDelta, this.treeScale);
      if (this.projectionTransform !== prevProjectionTransform || this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY) {
        this.hasProjected = true;
        this.scheduleRender();
        this.notifyListeners("projectionUpdate", target);
      }
      projectionFrameData.recalculatedProjection++;
    }
    hide() {
      this.isVisible = false;
    }
    show() {
      this.isVisible = true;
    }
    scheduleRender(notifyAll = true) {
      this.options.scheduleRender && this.options.scheduleRender();
      if (notifyAll) {
        const stack = this.getStack();
        stack && stack.scheduleRender();
      }
      if (this.resumingFrom && !this.resumingFrom.instance) {
        this.resumingFrom = void 0;
      }
    }
    setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
      const snapshot = this.snapshot;
      const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
      const mixedValues = { ...this.latestValues };
      const targetDelta = createDelta();
      if (!this.relativeParent || !this.relativeParent.options.layoutRoot) {
        this.relativeTarget = this.relativeTargetOrigin = void 0;
      }
      this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
      const relativeLayout = createBox();
      const snapshotSource = snapshot ? snapshot.source : void 0;
      const layoutSource = this.layout ? this.layout.source : void 0;
      const isSharedLayoutAnimation = snapshotSource !== layoutSource;
      const stack = this.getStack();
      const isOnlyMember = !stack || stack.members.length <= 1;
      const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some(hasOpacityCrossfade));
      this.animationProgress = 0;
      let prevRelativeTarget;
      this.mixTargetDelta = (latest) => {
        const progress2 = latest / 1e3;
        mixAxisDelta(targetDelta.x, delta.x, progress2);
        mixAxisDelta(targetDelta.y, delta.y, progress2);
        this.setTargetDelta(targetDelta);
        if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
          calcRelativePosition(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
          mixBox(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress2);
          if (prevRelativeTarget && boxEquals(this.relativeTarget, prevRelativeTarget)) {
            this.isProjectionDirty = false;
          }
          if (!prevRelativeTarget)
            prevRelativeTarget = createBox();
          copyBoxInto(prevRelativeTarget, this.relativeTarget);
        }
        if (isSharedLayoutAnimation) {
          this.animationValues = mixedValues;
          mixValues(mixedValues, snapshotLatestValues, this.latestValues, progress2, shouldCrossfadeOpacity, isOnlyMember);
        }
        this.root.scheduleUpdateProjection();
        this.scheduleRender();
        this.animationProgress = progress2;
      };
      this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(options7) {
      this.notifyListeners("animationStart");
      this.currentAnimation && this.currentAnimation.stop();
      if (this.resumingFrom && this.resumingFrom.currentAnimation) {
        this.resumingFrom.currentAnimation.stop();
      }
      if (this.pendingAnimation) {
        cancelFrame(this.pendingAnimation);
        this.pendingAnimation = void 0;
      }
      this.pendingAnimation = frame.update(() => {
        globalProjectionState.hasAnimatedSinceResize = true;
        this.currentAnimation = animateSingleValue(0, animationTarget, {
          ...options7,
          onUpdate: (latest) => {
            this.mixTargetDelta(latest);
            options7.onUpdate && options7.onUpdate(latest);
          },
          onComplete: () => {
            options7.onComplete && options7.onComplete();
            this.completeAnimation();
          }
        });
        if (this.resumingFrom) {
          this.resumingFrom.currentAnimation = this.currentAnimation;
        }
        this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      if (this.resumingFrom) {
        this.resumingFrom.currentAnimation = void 0;
        this.resumingFrom.preserveOpacity = void 0;
      }
      const stack = this.getStack();
      stack && stack.exitAnimationComplete();
      this.resumingFrom = this.currentAnimation = this.animationValues = void 0;
      this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      if (this.currentAnimation) {
        this.mixTargetDelta && this.mixTargetDelta(animationTarget);
        this.currentAnimation.stop();
      }
      this.completeAnimation();
    }
    applyTransformsToTarget() {
      const lead = this.getLead();
      let { targetWithTransforms, target, layout: layout2, latestValues } = lead;
      if (!targetWithTransforms || !target || !layout2)
        return;
      if (this !== lead && this.layout && layout2 && shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout2.layoutBox)) {
        target = this.target || createBox();
        const xLength = calcLength(this.layout.layoutBox.x);
        target.x.min = lead.target.x.min;
        target.x.max = target.x.min + xLength;
        const yLength = calcLength(this.layout.layoutBox.y);
        target.y.min = lead.target.y.min;
        target.y.max = target.y.min + yLength;
      }
      copyBoxInto(targetWithTransforms, target);
      transformBox(targetWithTransforms, latestValues);
      calcBoxDelta(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
    }
    registerSharedNode(layoutId, node566) {
      if (!this.sharedNodes.has(layoutId)) {
        this.sharedNodes.set(layoutId, new NodeStack());
      }
      const stack = this.sharedNodes.get(layoutId);
      stack.add(node566);
      const config = node566.options.initialPromotionConfig;
      node566.promote({
        transition: config ? config.transition : void 0,
        preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node566) : void 0
      });
    }
    isLead() {
      const stack = this.getStack();
      return stack ? stack.lead === this : true;
    }
    getLead() {
      var _a;
      const { layoutId } = this.options;
      return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
    }
    getPrevLead() {
      var _a;
      const { layoutId } = this.options;
      return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : void 0;
    }
    getStack() {
      const { layoutId } = this.options;
      if (layoutId)
        return this.root.sharedNodes.get(layoutId);
    }
    promote({ needsReset, transition, preserveFollowOpacity } = {}) {
      const stack = this.getStack();
      if (stack)
        stack.promote(this, preserveFollowOpacity);
      if (needsReset) {
        this.projectionDelta = void 0;
        this.needsReset = true;
      }
      if (transition)
        this.setOptions({ transition });
    }
    relegate() {
      const stack = this.getStack();
      if (stack) {
        return stack.relegate(this);
      } else {
        return false;
      }
    }
    resetRotation() {
      const { visualElement } = this.options;
      if (!visualElement)
        return;
      let hasRotate = false;
      const { latestValues } = visualElement;
      if (latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ) {
        hasRotate = true;
      }
      if (!hasRotate)
        return;
      const resetValues = {};
      for (let i4 = 0; i4 < transformAxes.length; i4++) {
        const key = "rotate" + transformAxes[i4];
        if (latestValues[key]) {
          resetValues[key] = latestValues[key];
          visualElement.setStaticValue(key, 0);
        }
      }
      visualElement.render();
      for (const key in resetValues) {
        visualElement.setStaticValue(key, resetValues[key]);
      }
      visualElement.scheduleRender();
    }
    getProjectionStyles(styleProp) {
      var _a, _b;
      if (!this.instance || this.isSVG)
        return void 0;
      if (!this.isVisible) {
        return hiddenVisibility;
      }
      const styles = {
        visibility: ""
      };
      const transformTemplate = this.getTransformTemplate();
      if (this.needsReset) {
        this.needsReset = false;
        styles.opacity = "";
        styles.pointerEvents = resolveMotionValue(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
        styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
        return styles;
      }
      const lead = this.getLead();
      if (!this.projectionDelta || !this.layout || !lead.target) {
        const emptyStyles = {};
        if (this.options.layoutId) {
          emptyStyles.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1;
          emptyStyles.pointerEvents = resolveMotionValue(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
        }
        if (this.hasProjected && !hasTransform(this.latestValues)) {
          emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
          this.hasProjected = false;
        }
        return emptyStyles;
      }
      const valuesToRender = lead.animationValues || lead.latestValues;
      this.applyTransformsToTarget();
      styles.transform = buildProjectionTransform(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
      if (transformTemplate) {
        styles.transform = transformTemplate(valuesToRender, styles.transform);
      }
      const { x: x4, y: y4 } = this.projectionDelta;
      styles.transformOrigin = `${x4.origin * 100}% ${y4.origin * 100}% 0`;
      if (lead.animationValues) {
        styles.opacity = lead === this ? (_b = (_a = valuesToRender.opacity) !== null && _a !== void 0 ? _a : this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
      } else {
        styles.opacity = lead === this ? valuesToRender.opacity !== void 0 ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== void 0 ? valuesToRender.opacityExit : 0;
      }
      for (const key in scaleCorrectors) {
        if (valuesToRender[key] === void 0)
          continue;
        const { correct, applyTo } = scaleCorrectors[key];
        const corrected = styles.transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
        if (applyTo) {
          const num = applyTo.length;
          for (let i4 = 0; i4 < num; i4++) {
            styles[applyTo[i4]] = corrected;
          }
        } else {
          styles[key] = corrected;
        }
      }
      if (this.options.layoutId) {
        styles.pointerEvents = lead === this ? resolveMotionValue(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "" : "none";
      }
      return styles;
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((node566) => {
        var _a;
        return (_a = node566.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
      });
      this.root.nodes.forEach(clearMeasurements);
      this.root.sharedNodes.clear();
    }
  };
}
function updateLayout(node566) {
  node566.updateLayout();
}
function notifyLayoutUpdate(node566) {
  var _a;
  const snapshot = ((_a = node566.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node566.snapshot;
  if (node566.isLead() && node566.layout && snapshot && node566.hasListeners("didUpdate")) {
    const { layoutBox: layout2, measuredBox: measuredLayout } = node566.layout;
    const { animationType } = node566.options;
    const isShared = snapshot.source !== node566.layout.source;
    if (animationType === "size") {
      eachAxis((axis) => {
        const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
        const length = calcLength(axisSnapshot);
        axisSnapshot.min = layout2[axis].min;
        axisSnapshot.max = axisSnapshot.min + length;
      });
    } else if (shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout2)) {
      eachAxis((axis) => {
        const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
        const length = calcLength(layout2[axis]);
        axisSnapshot.max = axisSnapshot.min + length;
        if (node566.relativeTarget && !node566.currentAnimation) {
          node566.isProjectionDirty = true;
          node566.relativeTarget[axis].max = node566.relativeTarget[axis].min + length;
        }
      });
    }
    const layoutDelta = createDelta();
    calcBoxDelta(layoutDelta, layout2, snapshot.layoutBox);
    const visualDelta = createDelta();
    if (isShared) {
      calcBoxDelta(visualDelta, node566.applyTransform(measuredLayout, true), snapshot.measuredBox);
    } else {
      calcBoxDelta(visualDelta, layout2, snapshot.layoutBox);
    }
    const hasLayoutChanged = !isDeltaZero(layoutDelta);
    let hasRelativeTargetChanged = false;
    if (!node566.resumeFrom) {
      const relativeParent = node566.getClosestProjectingParent();
      if (relativeParent && !relativeParent.resumeFrom) {
        const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
        if (parentSnapshot && parentLayout) {
          const relativeSnapshot = createBox();
          calcRelativePosition(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
          const relativeLayout = createBox();
          calcRelativePosition(relativeLayout, layout2, parentLayout.layoutBox);
          if (!boxEqualsRounded(relativeSnapshot, relativeLayout)) {
            hasRelativeTargetChanged = true;
          }
          if (relativeParent.options.layoutRoot) {
            node566.relativeTarget = relativeLayout;
            node566.relativeTargetOrigin = relativeSnapshot;
            node566.relativeParent = relativeParent;
          }
        }
      }
    }
    node566.notifyListeners("didUpdate", {
      layout: layout2,
      snapshot,
      delta: visualDelta,
      layoutDelta,
      hasLayoutChanged,
      hasRelativeTargetChanged
    });
  } else if (node566.isLead()) {
    const { onExitComplete } = node566.options;
    onExitComplete && onExitComplete();
  }
  node566.options.transition = void 0;
}
function propagateDirtyNodes(node566) {
  projectionFrameData.totalNodes++;
  if (!node566.parent)
    return;
  if (!node566.isProjecting()) {
    node566.isProjectionDirty = node566.parent.isProjectionDirty;
  }
  node566.isSharedProjectionDirty || (node566.isSharedProjectionDirty = Boolean(node566.isProjectionDirty || node566.parent.isProjectionDirty || node566.parent.isSharedProjectionDirty));
  node566.isTransformDirty || (node566.isTransformDirty = node566.parent.isTransformDirty);
}
function cleanDirtyNodes(node566) {
  node566.isProjectionDirty = node566.isSharedProjectionDirty = node566.isTransformDirty = false;
}
function clearSnapshot(node566) {
  node566.clearSnapshot();
}
function clearMeasurements(node566) {
  node566.clearMeasurements();
}
function clearIsLayoutDirty(node566) {
  node566.isLayoutDirty = false;
}
function resetTransformStyle(node566) {
  const { visualElement } = node566.options;
  if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) {
    visualElement.notify("BeforeLayoutMeasure");
  }
  node566.resetTransform();
}
function finishAnimation(node566) {
  node566.finishAnimation();
  node566.targetDelta = node566.relativeTarget = node566.target = void 0;
  node566.isProjectionDirty = true;
}
function resolveTargetDelta(node566) {
  node566.resolveTargetDelta();
}
function calcProjection(node566) {
  node566.calcProjection();
}
function resetRotation(node566) {
  node566.resetRotation();
}
function removeLeadSnapshots(stack) {
  stack.removeLeadSnapshot();
}
function mixAxisDelta(output, delta, p4) {
  output.translate = mix(delta.translate, 0, p4);
  output.scale = mix(delta.scale, 1, p4);
  output.origin = delta.origin;
  output.originPoint = delta.originPoint;
}
function mixAxis(output, from, to, p4) {
  output.min = mix(from.min, to.min, p4);
  output.max = mix(from.max, to.max, p4);
}
function mixBox(output, from, to, p4) {
  mixAxis(output.x, from.x, to.x, p4);
  mixAxis(output.y, from.y, to.y, p4);
}
function hasOpacityCrossfade(node566) {
  return node566.animationValues && node566.animationValues.opacityExit !== void 0;
}
var defaultLayoutTransition = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
};
var userAgentContains = (string21) => typeof navigator !== "undefined" && navigator.userAgent.toLowerCase().includes(string21);
var roundPoint = userAgentContains("applewebkit/") && !userAgentContains("chrome/") ? Math.round : noop4;
function roundAxis(axis) {
  axis.min = roundPoint(axis.min);
  axis.max = roundPoint(axis.max);
}
function roundBox(box) {
  roundAxis(box.x);
  roundAxis(box.y);
}
function shouldAnimatePositionOnly(animationType, snapshot, layout2) {
  return animationType === "position" || animationType === "preserve-aspect" && !isNear(aspectRatio(snapshot), aspectRatio(layout2), 0.2);
}

// ../../node_modules/framer-motion/dist/es/projection/node/DocumentProjectionNode.mjs
var DocumentProjectionNode = createProjectionNode({
  attachResizeListener: (ref, notify) => addDomEvent(ref, "resize", notify),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body.scrollLeft,
    y: document.documentElement.scrollTop || document.body.scrollTop
  }),
  checkIsScrollRoot: () => true
});

// ../../node_modules/framer-motion/dist/es/projection/node/HTMLProjectionNode.mjs
var rootProjectionNode = {
  current: void 0
};
var HTMLProjectionNode = createProjectionNode({
  measureScroll: (instance) => ({
    x: instance.scrollLeft,
    y: instance.scrollTop
  }),
  defaultParent: () => {
    if (!rootProjectionNode.current) {
      const documentNode = new DocumentProjectionNode({});
      documentNode.mount(window);
      documentNode.setOptions({ layoutScroll: true });
      rootProjectionNode.current = documentNode;
    }
    return rootProjectionNode.current;
  },
  resetTransform: (instance, value) => {
    instance.style.transform = value !== void 0 ? value : "none";
  },
  checkIsScrollRoot: (instance) => Boolean(window.getComputedStyle(instance).position === "fixed")
});

// ../../node_modules/framer-motion/dist/es/motion/features/drag.mjs
var drag = {
  pan: {
    Feature: PanGesture
  },
  drag: {
    Feature: DragGesture,
    ProjectionNode: HTMLProjectionNode,
    MeasureLayout
  }
};

// ../../node_modules/framer-motion/dist/es/render/dom/utils/css-variables-conversion.mjs
var splitCSSVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function parseCSSVariable(current) {
  const match = splitCSSVariableRegex.exec(current);
  if (!match)
    return [,];
  const [, token, fallback] = match;
  return [token, fallback];
}
var maxDepth = 4;
function getVariableValue(current, element, depth = 1) {
  invariant(depth <= maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
  const [token, fallback] = parseCSSVariable(current);
  if (!token)
    return;
  const resolved = window.getComputedStyle(element).getPropertyValue(token);
  if (resolved) {
    const trimmed = resolved.trim();
    return isNumericalString(trimmed) ? parseFloat(trimmed) : trimmed;
  } else if (isCSSVariableToken(fallback)) {
    return getVariableValue(fallback, element, depth + 1);
  } else {
    return fallback;
  }
}
function resolveCSSVariables(visualElement, { ...target }, transitionEnd) {
  const element = visualElement.current;
  if (!(element instanceof Element))
    return { target, transitionEnd };
  if (transitionEnd) {
    transitionEnd = { ...transitionEnd };
  }
  visualElement.values.forEach((value) => {
    const current = value.get();
    if (!isCSSVariableToken(current))
      return;
    const resolved = getVariableValue(current, element);
    if (resolved)
      value.set(resolved);
  });
  for (const key in target) {
    const current = target[key];
    if (!isCSSVariableToken(current))
      continue;
    const resolved = getVariableValue(current, element);
    if (!resolved)
      continue;
    target[key] = resolved;
    if (!transitionEnd)
      transitionEnd = {};
    if (transitionEnd[key] === void 0) {
      transitionEnd[key] = current;
    }
  }
  return { target, transitionEnd };
}

// ../../node_modules/framer-motion/dist/es/render/dom/utils/unit-conversion.mjs
var positionalKeys = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y",
  "translateX",
  "translateY"
]);
var isPositionalKey = (key) => positionalKeys.has(key);
var hasPositionalKey = (target) => {
  return Object.keys(target).some(isPositionalKey);
};
var isNumOrPxType = (v4) => v4 === number || v4 === px;
var getPosFromMatrix = (matrix, pos) => parseFloat(matrix.split(", ")[pos]);
var getTranslateFromMatrix = (pos2, pos3) => (_bbox, { transform }) => {
  if (transform === "none" || !transform)
    return 0;
  const matrix3d = transform.match(/^matrix3d\((.+)\)$/);
  if (matrix3d) {
    return getPosFromMatrix(matrix3d[1], pos3);
  } else {
    const matrix = transform.match(/^matrix\((.+)\)$/);
    if (matrix) {
      return getPosFromMatrix(matrix[1], pos2);
    } else {
      return 0;
    }
  }
};
var transformKeys = /* @__PURE__ */ new Set(["x", "y", "z"]);
var nonTranslationalTransformKeys = transformPropOrder.filter((key) => !transformKeys.has(key));
function removeNonTranslationalTransform(visualElement) {
  const removedTransforms = [];
  nonTranslationalTransformKeys.forEach((key) => {
    const value = visualElement.getValue(key);
    if (value !== void 0) {
      removedTransforms.push([key, value.get()]);
      value.set(key.startsWith("scale") ? 1 : 0);
    }
  });
  if (removedTransforms.length)
    visualElement.render();
  return removedTransforms;
}
var positionalValues = {
  // Dimensions
  width: ({ x: x4 }, { paddingLeft = "0", paddingRight = "0" }) => x4.max - x4.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
  height: ({ y: y4 }, { paddingTop = "0", paddingBottom = "0" }) => y4.max - y4.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
  top: (_bbox, { top }) => parseFloat(top),
  left: (_bbox, { left }) => parseFloat(left),
  bottom: ({ y: y4 }, { top }) => parseFloat(top) + (y4.max - y4.min),
  right: ({ x: x4 }, { left }) => parseFloat(left) + (x4.max - x4.min),
  // Transform
  x: getTranslateFromMatrix(4, 13),
  y: getTranslateFromMatrix(5, 14)
};
positionalValues.translateX = positionalValues.x;
positionalValues.translateY = positionalValues.y;
var convertChangedValueTypes = (target, visualElement, changedKeys) => {
  const originBbox = visualElement.measureViewportBox();
  const element = visualElement.current;
  const elementComputedStyle = getComputedStyle(element);
  const { display } = elementComputedStyle;
  const origin = {};
  if (display === "none") {
    visualElement.setStaticValue("display", target.display || "block");
  }
  changedKeys.forEach((key) => {
    origin[key] = positionalValues[key](originBbox, elementComputedStyle);
  });
  visualElement.render();
  const targetBbox = visualElement.measureViewportBox();
  changedKeys.forEach((key) => {
    const value = visualElement.getValue(key);
    value && value.jump(origin[key]);
    target[key] = positionalValues[key](targetBbox, elementComputedStyle);
  });
  return target;
};
var checkAndConvertChangedValueTypes = (visualElement, target, origin = {}, transitionEnd = {}) => {
  target = { ...target };
  transitionEnd = { ...transitionEnd };
  const targetPositionalKeys = Object.keys(target).filter(isPositionalKey);
  let removedTransformValues = [];
  let hasAttemptedToRemoveTransformValues = false;
  const changedValueTypeKeys = [];
  targetPositionalKeys.forEach((key) => {
    const value = visualElement.getValue(key);
    if (!visualElement.hasValue(key))
      return;
    let from = origin[key];
    let fromType = findDimensionValueType(from);
    const to = target[key];
    let toType;
    if (isKeyframesTarget(to)) {
      const numKeyframes = to.length;
      const fromIndex = to[0] === null ? 1 : 0;
      from = to[fromIndex];
      fromType = findDimensionValueType(from);
      for (let i4 = fromIndex; i4 < numKeyframes; i4++) {
        if (to[i4] === null)
          break;
        if (!toType) {
          toType = findDimensionValueType(to[i4]);
          invariant(toType === fromType || isNumOrPxType(fromType) && isNumOrPxType(toType), "Keyframes must be of the same dimension as the current value");
        } else {
          invariant(findDimensionValueType(to[i4]) === toType, "All keyframes must be of the same type");
        }
      }
    } else {
      toType = findDimensionValueType(to);
    }
    if (fromType !== toType) {
      if (isNumOrPxType(fromType) && isNumOrPxType(toType)) {
        const current = value.get();
        if (typeof current === "string") {
          value.set(parseFloat(current));
        }
        if (typeof to === "string") {
          target[key] = parseFloat(to);
        } else if (Array.isArray(to) && toType === px) {
          target[key] = to.map(parseFloat);
        }
      } else if ((fromType === null || fromType === void 0 ? void 0 : fromType.transform) && (toType === null || toType === void 0 ? void 0 : toType.transform) && (from === 0 || to === 0)) {
        if (from === 0) {
          value.set(toType.transform(from));
        } else {
          target[key] = fromType.transform(to);
        }
      } else {
        if (!hasAttemptedToRemoveTransformValues) {
          removedTransformValues = removeNonTranslationalTransform(visualElement);
          hasAttemptedToRemoveTransformValues = true;
        }
        changedValueTypeKeys.push(key);
        transitionEnd[key] = transitionEnd[key] !== void 0 ? transitionEnd[key] : target[key];
        value.jump(to);
      }
    }
  });
  if (changedValueTypeKeys.length) {
    const scrollY = changedValueTypeKeys.indexOf("height") >= 0 ? window.pageYOffset : null;
    const convertedTarget = convertChangedValueTypes(target, visualElement, changedValueTypeKeys);
    if (removedTransformValues.length) {
      removedTransformValues.forEach(([key, value]) => {
        visualElement.getValue(key).set(value);
      });
    }
    visualElement.render();
    if (isBrowser && scrollY !== null) {
      window.scrollTo({ top: scrollY });
    }
    return { target: convertedTarget, transitionEnd };
  } else {
    return { target, transitionEnd };
  }
};
function unitConversion(visualElement, target, origin, transitionEnd) {
  return hasPositionalKey(target) ? checkAndConvertChangedValueTypes(visualElement, target, origin, transitionEnd) : { target, transitionEnd };
}

// ../../node_modules/framer-motion/dist/es/render/dom/utils/parse-dom-variant.mjs
var parseDomVariant = (visualElement, target, origin, transitionEnd) => {
  const resolved = resolveCSSVariables(visualElement, target, transitionEnd);
  target = resolved.target;
  transitionEnd = resolved.transitionEnd;
  return unitConversion(visualElement, target, origin, transitionEnd);
};

// ../../node_modules/framer-motion/dist/es/utils/reduced-motion/state.mjs
var prefersReducedMotion = { current: null };
var hasReducedMotionListener = { current: false };

// ../../node_modules/framer-motion/dist/es/utils/reduced-motion/index.mjs
function initPrefersReducedMotion() {
  hasReducedMotionListener.current = true;
  if (!isBrowser)
    return;
  if (window.matchMedia) {
    const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
    const setReducedMotionPreferences = () => prefersReducedMotion.current = motionMediaQuery.matches;
    motionMediaQuery.addListener(setReducedMotionPreferences);
    setReducedMotionPreferences();
  } else {
    prefersReducedMotion.current = false;
  }
}

// ../../node_modules/framer-motion/dist/es/render/utils/motion-values.mjs
function updateMotionValuesFromProps(element, next, prev) {
  const { willChange } = next;
  for (const key in next) {
    const nextValue = next[key];
    const prevValue = prev[key];
    if (isMotionValue(nextValue)) {
      element.addValue(key, nextValue);
      if (isWillChangeMotionValue(willChange)) {
        willChange.add(key);
      }
      if (process.env.NODE_ENV === "development") {
        warnOnce(nextValue.version === "10.18.0", `Attempting to mix Framer Motion versions ${nextValue.version} with 10.18.0 may not work as expected.`);
      }
    } else if (isMotionValue(prevValue)) {
      element.addValue(key, motionValue(nextValue, { owner: element }));
      if (isWillChangeMotionValue(willChange)) {
        willChange.remove(key);
      }
    } else if (prevValue !== nextValue) {
      if (element.hasValue(key)) {
        const existingValue = element.getValue(key);
        !existingValue.hasAnimated && existingValue.set(nextValue);
      } else {
        const latestValue = element.getStaticValue(key);
        element.addValue(key, motionValue(latestValue !== void 0 ? latestValue : nextValue, { owner: element }));
      }
    }
  }
  for (const key in prev) {
    if (next[key] === void 0)
      element.removeValue(key);
  }
  return next;
}

// ../../node_modules/framer-motion/dist/es/render/store.mjs
var visualElementStore = /* @__PURE__ */ new WeakMap();

// ../../node_modules/framer-motion/dist/es/render/VisualElement.mjs
var featureNames = Object.keys(featureDefinitions);
var numFeatures = featureNames.length;
var propEventHandlers = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
var numVariantProps = variantProps.length;
var VisualElement = class {
  constructor({ parent, props, presenceContext, reducedMotionConfig, visualState }, options7 = {}) {
    this.current = null;
    this.children = /* @__PURE__ */ new Set();
    this.isVariantNode = false;
    this.isControllingVariants = false;
    this.shouldReduceMotion = null;
    this.values = /* @__PURE__ */ new Map();
    this.features = {};
    this.valueSubscriptions = /* @__PURE__ */ new Map();
    this.prevMotionValues = {};
    this.events = {};
    this.propEventSubscriptions = {};
    this.notifyUpdate = () => this.notify("Update", this.latestValues);
    this.render = () => {
      if (!this.current)
        return;
      this.triggerBuild();
      this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
    };
    this.scheduleRender = () => frame.render(this.render, false, true);
    const { latestValues, renderState } = visualState;
    this.latestValues = latestValues;
    this.baseTarget = { ...latestValues };
    this.initialValues = props.initial ? { ...latestValues } : {};
    this.renderState = renderState;
    this.parent = parent;
    this.props = props;
    this.presenceContext = presenceContext;
    this.depth = parent ? parent.depth + 1 : 0;
    this.reducedMotionConfig = reducedMotionConfig;
    this.options = options7;
    this.isControllingVariants = isControllingVariants(props);
    this.isVariantNode = isVariantNode(props);
    if (this.isVariantNode) {
      this.variantChildren = /* @__PURE__ */ new Set();
    }
    this.manuallyAnimateOnMount = Boolean(parent && parent.current);
    const { willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {});
    for (const key in initialMotionValues) {
      const value = initialMotionValues[key];
      if (latestValues[key] !== void 0 && isMotionValue(value)) {
        value.set(latestValues[key], false);
        if (isWillChangeMotionValue(willChange)) {
          willChange.add(key);
        }
      }
    }
  }
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(_props, _prevProps) {
    return {};
  }
  mount(instance) {
    this.current = instance;
    visualElementStore.set(instance, this);
    if (this.projection && !this.projection.instance) {
      this.projection.mount(instance);
    }
    if (this.parent && this.isVariantNode && !this.isControllingVariants) {
      this.removeFromVariantTree = this.parent.addVariantChild(this);
    }
    this.values.forEach((value, key) => this.bindToMotionValue(key, value));
    if (!hasReducedMotionListener.current) {
      initPrefersReducedMotion();
    }
    this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : prefersReducedMotion.current;
    if (process.env.NODE_ENV !== "production") {
      warnOnce(this.shouldReduceMotion !== true, "You have Reduced Motion enabled on your device. Animations may not appear as expected.");
    }
    if (this.parent)
      this.parent.children.add(this);
    this.update(this.props, this.presenceContext);
  }
  unmount() {
    visualElementStore.delete(this.current);
    this.projection && this.projection.unmount();
    cancelFrame(this.notifyUpdate);
    cancelFrame(this.render);
    this.valueSubscriptions.forEach((remove) => remove());
    this.removeFromVariantTree && this.removeFromVariantTree();
    this.parent && this.parent.children.delete(this);
    for (const key in this.events) {
      this.events[key].clear();
    }
    for (const key in this.features) {
      this.features[key].unmount();
    }
    this.current = null;
  }
  bindToMotionValue(key, value) {
    const valueIsTransform = transformProps.has(key);
    const removeOnChange = value.on("change", (latestValue) => {
      this.latestValues[key] = latestValue;
      this.props.onUpdate && frame.update(this.notifyUpdate, false, true);
      if (valueIsTransform && this.projection) {
        this.projection.isTransformDirty = true;
      }
    });
    const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
    this.valueSubscriptions.set(key, () => {
      removeOnChange();
      removeOnRenderRequest();
    });
  }
  sortNodePosition(other) {
    if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) {
      return 0;
    }
    return this.sortInstanceNodePosition(this.current, other.current);
  }
  loadFeatures({ children, ...renderedProps }, isStrict, preloadedFeatures2, initialLayoutGroupConfig) {
    let ProjectionNodeConstructor;
    let MeasureLayout2;
    if (process.env.NODE_ENV !== "production" && preloadedFeatures2 && isStrict) {
      const strictMessage = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
      renderedProps.ignoreStrict ? warning(false, strictMessage) : invariant(false, strictMessage);
    }
    for (let i4 = 0; i4 < numFeatures; i4++) {
      const name = featureNames[i4];
      const { isEnabled, Feature: FeatureConstructor, ProjectionNode, MeasureLayout: MeasureLayoutComponent } = featureDefinitions[name];
      if (ProjectionNode)
        ProjectionNodeConstructor = ProjectionNode;
      if (isEnabled(renderedProps)) {
        if (!this.features[name] && FeatureConstructor) {
          this.features[name] = new FeatureConstructor(this);
        }
        if (MeasureLayoutComponent) {
          MeasureLayout2 = MeasureLayoutComponent;
        }
      }
    }
    if ((this.type === "html" || this.type === "svg") && !this.projection && ProjectionNodeConstructor) {
      this.projection = new ProjectionNodeConstructor(this.latestValues, this.parent && this.parent.projection);
      const { layoutId, layout: layout2, drag: drag2, dragConstraints, layoutScroll, layoutRoot } = renderedProps;
      this.projection.setOptions({
        layoutId,
        layout: layout2,
        alwaysMeasureLayout: Boolean(drag2) || dragConstraints && isRefObject(dragConstraints),
        visualElement: this,
        scheduleRender: () => this.scheduleRender(),
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */
        animationType: typeof layout2 === "string" ? layout2 : "both",
        initialPromotionConfig: initialLayoutGroupConfig,
        layoutScroll,
        layoutRoot
      });
    }
    return MeasureLayout2;
  }
  updateFeatures() {
    for (const key in this.features) {
      const feature = this.features[key];
      if (feature.isMounted) {
        feature.update();
      } else {
        feature.mount();
        feature.isMounted = true;
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.options, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : createBox();
  }
  getStaticValue(key) {
    return this.latestValues[key];
  }
  setStaticValue(key, value) {
    this.latestValues[key] = value;
  }
  /**
   * Make a target animatable by Popmotion. For instance, if we're
   * trying to animate width from 100px to 100vw we need to measure 100vw
   * in pixels to determine what we really need to animate to. This is also
   * pluggable to support Framer's custom value types like Color,
   * and CSS variables.
   */
  makeTargetAnimatable(target, canMutate = true) {
    return this.makeTargetAnimatableFromInstance(target, this.props, canMutate);
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(props, presenceContext) {
    if (props.transformTemplate || this.props.transformTemplate) {
      this.scheduleRender();
    }
    this.prevProps = this.props;
    this.props = props;
    this.prevPresenceContext = this.presenceContext;
    this.presenceContext = presenceContext;
    for (let i4 = 0; i4 < propEventHandlers.length; i4++) {
      const key = propEventHandlers[i4];
      if (this.propEventSubscriptions[key]) {
        this.propEventSubscriptions[key]();
        delete this.propEventSubscriptions[key];
      }
      const listener = props["on" + key];
      if (listener) {
        this.propEventSubscriptions[key] = this.on(key, listener);
      }
    }
    this.prevMotionValues = updateMotionValuesFromProps(this, this.scrapeMotionValuesFromProps(props, this.prevProps), this.prevMotionValues);
    if (this.handleChildMotionValue) {
      this.handleChildMotionValue();
    }
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(name) {
    return this.props.variants ? this.props.variants[name] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  getVariantContext(startAtParent = false) {
    if (startAtParent) {
      return this.parent ? this.parent.getVariantContext() : void 0;
    }
    if (!this.isControllingVariants) {
      const context2 = this.parent ? this.parent.getVariantContext() || {} : {};
      if (this.props.initial !== void 0) {
        context2.initial = this.props.initial;
      }
      return context2;
    }
    const context = {};
    for (let i4 = 0; i4 < numVariantProps; i4++) {
      const name = variantProps[i4];
      const prop = this.props[name];
      if (isVariantLabel(prop) || prop === false) {
        context[name] = prop;
      }
    }
    return context;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(child) {
    const closestVariantNode = this.getClosestVariantNode();
    if (closestVariantNode) {
      closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
      return () => closestVariantNode.variantChildren.delete(child);
    }
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(key, value) {
    if (value !== this.values.get(key)) {
      this.removeValue(key);
      this.bindToMotionValue(key, value);
    }
    this.values.set(key, value);
    this.latestValues[key] = value.get();
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(key) {
    this.values.delete(key);
    const unsubscribe = this.valueSubscriptions.get(key);
    if (unsubscribe) {
      unsubscribe();
      this.valueSubscriptions.delete(key);
    }
    delete this.latestValues[key];
    this.removeValueFromRenderState(key, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(key) {
    return this.values.has(key);
  }
  getValue(key, defaultValue) {
    if (this.props.values && this.props.values[key]) {
      return this.props.values[key];
    }
    let value = this.values.get(key);
    if (value === void 0 && defaultValue !== void 0) {
      value = motionValue(defaultValue, { owner: this });
      this.addValue(key, value);
    }
    return value;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(key) {
    var _a;
    return this.latestValues[key] !== void 0 || !this.current ? this.latestValues[key] : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(key, value) {
    this.baseTarget[key] = value;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(key) {
    var _a;
    const { initial } = this.props;
    const valueFromInitial = typeof initial === "string" || typeof initial === "object" ? (_a = resolveVariantFromProps(this.props, initial)) === null || _a === void 0 ? void 0 : _a[key] : void 0;
    if (initial && valueFromInitial !== void 0) {
      return valueFromInitial;
    }
    const target = this.getBaseTargetFromProps(this.props, key);
    if (target !== void 0 && !isMotionValue(target))
      return target;
    return this.initialValues[key] !== void 0 && valueFromInitial === void 0 ? void 0 : this.baseTarget[key];
  }
  on(eventName, callback) {
    if (!this.events[eventName]) {
      this.events[eventName] = new SubscriptionManager();
    }
    return this.events[eventName].add(callback);
  }
  notify(eventName, ...args) {
    if (this.events[eventName]) {
      this.events[eventName].notify(...args);
    }
  }
};

// ../../node_modules/framer-motion/dist/es/render/dom/DOMVisualElement.mjs
var DOMVisualElement = class extends VisualElement {
  sortInstanceNodePosition(a4, b3) {
    return a4.compareDocumentPosition(b3) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(props, key) {
    return props.style ? props.style[key] : void 0;
  }
  removeValueFromRenderState(key, { vars, style }) {
    delete vars[key];
    delete style[key];
  }
  makeTargetAnimatableFromInstance({ transition, transitionEnd, ...target }, { transformValues }, isMounted) {
    let origin = getOrigin(target, transition || {}, this);
    if (transformValues) {
      if (transitionEnd)
        transitionEnd = transformValues(transitionEnd);
      if (target)
        target = transformValues(target);
      if (origin)
        origin = transformValues(origin);
    }
    if (isMounted) {
      checkTargetForNewValues(this, target, origin);
      const parsed = parseDomVariant(this, target, origin, transitionEnd);
      transitionEnd = parsed.transitionEnd;
      target = parsed.target;
    }
    return {
      transition,
      transitionEnd,
      ...target
    };
  }
};

// ../../node_modules/framer-motion/dist/es/render/html/HTMLVisualElement.mjs
function getComputedStyle2(element) {
  return window.getComputedStyle(element);
}
var HTMLVisualElement = class extends DOMVisualElement {
  constructor() {
    super(...arguments);
    this.type = "html";
  }
  readValueFromInstance(instance, key) {
    if (transformProps.has(key)) {
      const defaultType = getDefaultValueType(key);
      return defaultType ? defaultType.default || 0 : 0;
    } else {
      const computedStyle = getComputedStyle2(instance);
      const value = (isCSSVariableName(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
      return typeof value === "string" ? value.trim() : value;
    }
  }
  measureInstanceViewportBox(instance, { transformPagePoint }) {
    return measureViewportBox(instance, transformPagePoint);
  }
  build(renderState, latestValues, options7, props) {
    buildHTMLStyles(renderState, latestValues, options7, props.transformTemplate);
  }
  scrapeMotionValuesFromProps(props, prevProps) {
    return scrapeMotionValuesFromProps(props, prevProps);
  }
  handleChildMotionValue() {
    if (this.childSubscription) {
      this.childSubscription();
      delete this.childSubscription;
    }
    const { children } = this.props;
    if (isMotionValue(children)) {
      this.childSubscription = children.on("change", (latest) => {
        if (this.current)
          this.current.textContent = `${latest}`;
      });
    }
  }
  renderInstance(instance, renderState, styleProp, projection) {
    renderHTML(instance, renderState, styleProp, projection);
  }
};

// ../../node_modules/framer-motion/dist/es/render/svg/SVGVisualElement.mjs
var SVGVisualElement = class extends DOMVisualElement {
  constructor() {
    super(...arguments);
    this.type = "svg";
    this.isSVGTag = false;
  }
  getBaseTargetFromProps(props, key) {
    return props[key];
  }
  readValueFromInstance(instance, key) {
    if (transformProps.has(key)) {
      const defaultType = getDefaultValueType(key);
      return defaultType ? defaultType.default || 0 : 0;
    }
    key = !camelCaseAttributes.has(key) ? camelToDash(key) : key;
    return instance.getAttribute(key);
  }
  measureInstanceViewportBox() {
    return createBox();
  }
  scrapeMotionValuesFromProps(props, prevProps) {
    return scrapeMotionValuesFromProps2(props, prevProps);
  }
  build(renderState, latestValues, options7, props) {
    buildSVGAttrs(renderState, latestValues, options7, this.isSVGTag, props.transformTemplate);
  }
  renderInstance(instance, renderState, styleProp, projection) {
    renderSVG(instance, renderState, styleProp, projection);
  }
  mount(instance) {
    this.isSVGTag = isSVGTag(instance.tagName);
    super.mount(instance);
  }
};

// ../../node_modules/framer-motion/dist/es/render/dom/create-visual-element.mjs
var createDomVisualElement = (Component8, options7) => {
  return isSVGComponent(Component8) ? new SVGVisualElement(options7, { enableHardwareAcceleration: false }) : new HTMLVisualElement(options7, { enableHardwareAcceleration: true });
};

// ../../node_modules/framer-motion/dist/es/motion/features/layout.mjs
var layout = {
  layout: {
    ProjectionNode: HTMLProjectionNode,
    MeasureLayout
  }
};

// ../../node_modules/framer-motion/dist/es/render/dom/motion.mjs
var preloadedFeatures = {
  ...animations,
  ...gestureAnimations,
  ...drag,
  ...layout
};
var motion = /* @__PURE__ */ createMotionProxy((Component8, config) => createDomMotionConfig(Component8, config, preloadedFeatures, createDomVisualElement));

// src/locations/components/WorkLocationEntriesList.tsx
import { createClientMutationId as createClientMutationId11 } from "shared-lib";
import { AlertMessage as AlertMessage6, Button as Button14, ButtonList as ButtonList5 } from "shared-ui";

// src/locations/mutations/__generated__/UseCandidateCurrentLocationUpdateMutation.graphql.ts
var node65 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = [
    v23,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountType",
      "storageKey": null
    }
  ], v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfCandidateWorkLocations",
    "kind": "LinkedField",
    "name": "locations",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitProfileWorkLocations",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          v23,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountId",
            "kind": "LinkedField",
            "name": "createdBy",
            "plural": false,
            "selections": v32,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountId",
            "kind": "LinkedField",
            "name": "updatedBy",
            "plural": false,
            "selections": v32,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "recruitProfileWorkLocationsId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "version",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currentLocationCountryCode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currentLocationCountryName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currentLocationName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currentLocationLatitude",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currentLocationLongitude",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currentLocationRadius",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "WorkLocationEntry",
            "kind": "LinkedField",
            "name": "workLocations",
            "plural": true,
            "selections": [
              v23,
              v4,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "countryCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "countryName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "entireCountry",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "latitude",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "longitude",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "radius",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  }, v7 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      v6,
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationItem",
        "kind": "LinkedField",
        "name": "validations",
        "plural": true,
        "selections": [
          v4,
          v6
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "data",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseCandidateCurrentLocationUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitCandidateCurrentLocationFullUpdatePayload",
          "kind": "LinkedField",
          "name": "recruitCandidateCurrentLocationFullUpdate",
          "plural": false,
          "selections": [
            v5,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v7
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseCandidateCurrentLocationUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitCandidateCurrentLocationFullUpdatePayload",
          "kind": "LinkedField",
          "name": "recruitCandidateCurrentLocationFullUpdate",
          "plural": false,
          "selections": [
            v5,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v7
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "fa046c2f858f0a85ca30e93276fb8be6",
      "id": null,
      "metadata": {},
      "name": "UseCandidateCurrentLocationUpdateMutation",
      "operationKind": "mutation",
      "text": "mutation UseCandidateCurrentLocationUpdateMutation(\n  $input: RecruitCandidateCurrentLocationFullUpdateInput!\n) {\n  data: recruitCandidateCurrentLocationFullUpdate(input: $input) {\n    locations {\n      node {\n        id\n        createdOn\n        createdBy {\n          id\n          accountType\n        }\n        updatedOn\n        updatedBy {\n          id\n          accountType\n        }\n        recruitProfileWorkLocationsId\n        version\n        currentLocationCountryCode\n        currentLocationCountryName\n        currentLocationName\n        currentLocationLatitude\n        currentLocationLongitude\n        currentLocationRadius\n        workLocations {\n          id\n          name\n          countryCode\n          countryName\n          entireCountry\n          latitude\n          longitude\n          radius\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n        validations {\n          name\n          message\n        }\n        data\n      }\n    }\n  }\n}\n"
    }
  };
}();
node65.hash = "3ddfc72cf1508c40d4b238e0df71927c";
var UseCandidateCurrentLocationUpdateMutation_graphql_default = node65;

// src/locations/mutations/UseCandidateCurrentLocationUpdate.ts
import { useAsyncMutation as useAsyncMutation7 } from "shared-lib";
var mutationDef12 = UseCandidateCurrentLocationUpdateMutation_graphql_default;
function useCandidateCurrentLocationUpdate() {
  const [commit11, isBusy] = useAsyncMutation7(mutationDef12);
  return [commit11, isBusy];
}

// src/locations/mutations/__generated__/UseCandidateWorkLocationAddMutation.graphql.ts
var node66 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = [
    v23,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountType",
      "storageKey": null
    }
  ], v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfCandidateWorkLocations",
    "kind": "LinkedField",
    "name": "locations",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitProfileWorkLocations",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          v23,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountId",
            "kind": "LinkedField",
            "name": "createdBy",
            "plural": false,
            "selections": v32,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountId",
            "kind": "LinkedField",
            "name": "updatedBy",
            "plural": false,
            "selections": v32,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "recruitProfileWorkLocationsId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "version",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currentLocationCountryCode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currentLocationCountryName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currentLocationName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currentLocationLatitude",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currentLocationLongitude",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currentLocationRadius",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "WorkLocationEntry",
            "kind": "LinkedField",
            "name": "workLocations",
            "plural": true,
            "selections": [
              v23,
              v4,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "countryCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "countryName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "entireCountry",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "latitude",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "longitude",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "radius",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  }, v7 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      v6,
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationItem",
        "kind": "LinkedField",
        "name": "validations",
        "plural": true,
        "selections": [
          v4,
          v6
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "data",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseCandidateWorkLocationAddMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitCandidateWorkLocationFullAddPayload",
          "kind": "LinkedField",
          "name": "recruitCandidateWorkLocationFullAdd",
          "plural": false,
          "selections": [
            v5,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v7
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseCandidateWorkLocationAddMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitCandidateWorkLocationFullAddPayload",
          "kind": "LinkedField",
          "name": "recruitCandidateWorkLocationFullAdd",
          "plural": false,
          "selections": [
            v5,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v7
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "2c9c5ede77db4cc1fb4bb67ec05f8977",
      "id": null,
      "metadata": {},
      "name": "UseCandidateWorkLocationAddMutation",
      "operationKind": "mutation",
      "text": "mutation UseCandidateWorkLocationAddMutation(\n  $input: RecruitCandidateWorkLocationFullAddInput!\n) {\n  data: recruitCandidateWorkLocationFullAdd(input: $input) {\n    locations {\n      node {\n        id\n        createdOn\n        createdBy {\n          id\n          accountType\n        }\n        updatedOn\n        updatedBy {\n          id\n          accountType\n        }\n        recruitProfileWorkLocationsId\n        version\n        currentLocationCountryCode\n        currentLocationCountryName\n        currentLocationName\n        currentLocationLatitude\n        currentLocationLongitude\n        currentLocationRadius\n        workLocations {\n          id\n          name\n          countryCode\n          countryName\n          entireCountry\n          latitude\n          longitude\n          radius\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n        validations {\n          name\n          message\n        }\n        data\n      }\n    }\n  }\n}\n"
    }
  };
}();
node66.hash = "12ca6524d2db461c60a9f5cb2c5e4981";
var UseCandidateWorkLocationAddMutation_graphql_default = node66;

// src/locations/mutations/UseCandidateWorkLocationAdd.ts
import { useAsyncMutation as useAsyncMutation8 } from "shared-lib";
var mutationDef13 = UseCandidateWorkLocationAddMutation_graphql_default;
function useCandidateWorkLocationAdd() {
  const [commit11, isBusy] = useAsyncMutation8(mutationDef13);
  return [commit11, isBusy];
}

// src/locations/mutations/__generated__/UseCandidateWorkLocationRemoveMutation.graphql.ts
var node67 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = [
    v23,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountType",
      "storageKey": null
    }
  ], v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfCandidateWorkLocations",
    "kind": "LinkedField",
    "name": "locations",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitProfileWorkLocations",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          v23,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountId",
            "kind": "LinkedField",
            "name": "createdBy",
            "plural": false,
            "selections": v32,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountId",
            "kind": "LinkedField",
            "name": "updatedBy",
            "plural": false,
            "selections": v32,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "recruitProfileWorkLocationsId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "version",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currentLocationCountryCode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currentLocationCountryName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currentLocationName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currentLocationLatitude",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currentLocationLongitude",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currentLocationRadius",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "WorkLocationEntry",
            "kind": "LinkedField",
            "name": "workLocations",
            "plural": true,
            "selections": [
              v23,
              v4,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "countryCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "countryName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "entireCountry",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "latitude",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "longitude",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "radius",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  }, v7 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      v6,
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationItem",
        "kind": "LinkedField",
        "name": "validations",
        "plural": true,
        "selections": [
          v4,
          v6
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "data",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseCandidateWorkLocationRemoveMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitCandidateWorkLocationRemovePayload",
          "kind": "LinkedField",
          "name": "recruitCandidateWorkLocationRemove",
          "plural": false,
          "selections": [
            v5,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v7
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseCandidateWorkLocationRemoveMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitCandidateWorkLocationRemovePayload",
          "kind": "LinkedField",
          "name": "recruitCandidateWorkLocationRemove",
          "plural": false,
          "selections": [
            v5,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v7
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "55799d4151371d518e4162c5c2aa74fb",
      "id": null,
      "metadata": {},
      "name": "UseCandidateWorkLocationRemoveMutation",
      "operationKind": "mutation",
      "text": "mutation UseCandidateWorkLocationRemoveMutation(\n  $input: RecruitCandidateWorkLocationRemoveInput!\n) {\n  data: recruitCandidateWorkLocationRemove(input: $input) {\n    locations {\n      node {\n        id\n        createdOn\n        createdBy {\n          id\n          accountType\n        }\n        updatedOn\n        updatedBy {\n          id\n          accountType\n        }\n        recruitProfileWorkLocationsId\n        version\n        currentLocationCountryCode\n        currentLocationCountryName\n        currentLocationName\n        currentLocationLatitude\n        currentLocationLongitude\n        currentLocationRadius\n        workLocations {\n          id\n          name\n          countryCode\n          countryName\n          entireCountry\n          latitude\n          longitude\n          radius\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n        validations {\n          name\n          message\n        }\n        data\n      }\n    }\n  }\n}\n"
    }
  };
}();
node67.hash = "6a321c20e88a67dd341b6432f276a6df";
var UseCandidateWorkLocationRemoveMutation_graphql_default = node67;

// src/locations/mutations/UseCandidateWorkLocationRemove.ts
import { useAsyncMutation as useAsyncMutation9 } from "shared-lib";
var mutationDef14 = UseCandidateWorkLocationRemoveMutation_graphql_default;
function useCandidateWorkLocationRemove() {
  const [commit11, isBusy] = useAsyncMutation9(mutationDef14);
  return [commit11, isBusy];
}

// src/locations/components/WorkLocationEntriesList.tsx
import { jsx as jsx43, jsxs as jsxs30 } from "react/jsx-runtime";
var fragmentDef20 = WorkLocationEntriesList_workLocations_graphql_default;
var WorkLocationEntriesList = ({
  profileId,
  fragmentRef
}) => {
  const data = useFragment20(
    fragmentDef20,
    fragmentRef
  );
  const workLocations = data.workLocations || [];
  const [selectedId, setSelectedId] = useState11(null);
  const selectedItem = workLocations.find(({ id: id18 }) => id18 === selectedId);
  const [remove, isRemoving] = useCandidateWorkLocationRemove();
  const onSelect = useCallback20((location2) => {
    if (!location2) {
      return;
    }
    console.log(location2);
    console.log(`selected ${location2.id}`);
    setSelectedId(location2.id);
  }, []);
  const [deleted, setDeleted] = useState11(false);
  const onRemove = useCallback20(
    (location2) => {
      async function onRemoveAsync() {
        if (!location2) {
          return;
        }
        setDeleted(false);
        const input = {
          profileId,
          location: location2.id,
          clientMutationId: createClientMutationId11()
        };
        const response = await remove({ input });
        if (response.data.locations?.node) {
          setSelectedId(null);
          setDeleted(true);
        }
      }
      onRemoveAsync();
    },
    [remove, profileId]
  );
  const rows = workLocations.map((location2) => {
    return /* @__PURE__ */ jsx43(
      "li",
      {
        className: "cursor-pointer",
        onClick: () => onSelect(location2),
        children: /* @__PURE__ */ jsx43("div", { className: "flex flex-col rounded-xl border bg-white px-4 py-3", children: /* @__PURE__ */ jsx43("div", { className: "flex items-baseline justify-between text-sm", children: /* @__PURE__ */ jsx43("a", { href: "#", className: "font-medium text-gray-900", children: `${location2.name} (${location2.countryCode})` }) }) })
      },
      location2.id
    );
  });
  return /* @__PURE__ */ jsxs30("div", { className: "relative", children: [
    deleted ? /* @__PURE__ */ jsx43(AlertMessage6, { message: "Location Removed" }) : null,
    selectedItem && /* @__PURE__ */ jsxs30(
      motion.div,
      {
        className: "my-4 rounded-lg border bg-white px-4 py-4 shadow",
        animate: { opacity: 1, scale: 1 },
        initial: { opacity: 0, scale: 0.5 },
        children: [
          /* @__PURE__ */ jsx43("div", { className: "text-primary-500 py-2 font-medium", children: selectedItem.name }),
          /* @__PURE__ */ jsxs30(ButtonList5, { children: [
            /* @__PURE__ */ jsx43(
              Button14,
              {
                color: "warning",
                confirmMessage: "Delete, Are you sure?",
                clicked: () => {
                  onRemove(selectedItem);
                },
                children: "Delete"
              }
            ),
            /* @__PURE__ */ jsx43(
              Button14,
              {
                color: "gray",
                clicked: () => {
                  setSelectedId(null);
                },
                children: "Close"
              }
            )
          ] })
        ]
      }
    ),
    /* @__PURE__ */ jsx43("div", { className: "py-2", children: /* @__PURE__ */ jsx43(
      "ul",
      {
        role: "list",
        className: "flex flex-1 flex-col gap-2",
        hidden: !!selectedItem,
        children: rows
      }
    ) })
  ] });
};

// src/locations/components/WorkLocationsContainer.tsx
import { jsx as jsx44, jsxs as jsxs31 } from "react/jsx-runtime";
var fragmentDef21 = WorkLocationsContainer_workLocations_graphql_default;
var WorkLocationsContainer = ({
  profileId,
  fragmentRef
}) => {
  const data = useFragment21(
    fragmentDef21,
    fragmentRef
  );
  const [isAdding, toggleIsAdding] = useToggle7();
  const [saved, setSaved] = useState12(false);
  const [country, setCountry] = useState12(DefaultGeoCountry);
  const onChangeCountry = useCallback21(
    (c4) => {
      setCountry(c4);
    },
    [country]
  );
  const [selectedResult, setSelectedResult] = useState12(null);
  const onSelectLocation = useCallback21(
    (selected) => {
      setSelectedResult(selected);
    },
    [selectedResult]
  );
  const [addLocation] = useCandidateWorkLocationAdd();
  const onAdd = useCallback21(() => {
    async function onAddAsync() {
      if (!selectedResult) {
        return;
      }
      setSaved(false);
      const location2 = {
        name: selectedResult.name,
        countryCode: selectedResult.countryCode,
        countryName: country.name,
        latitude: selectedResult.latitude,
        longitude: selectedResult.longitude
      };
      const input = {
        profileId,
        clientMutationId: createClientMutationId12(),
        location: location2
      };
      const response = await addLocation({
        input
      });
      if (response.data.locations?.node) {
        toggleIsAdding();
        setSaved(true);
        setSelectedResult(null);
      }
    }
    onAddAsync();
  }, [addLocation, profileId]);
  const [whereYouWantToWorkEditable, toggleEditWhereYouWantToWork] = useToggle7();
  return /* @__PURE__ */ jsxs31("div", { children: [
    !whereYouWantToWorkEditable && /* @__PURE__ */ jsx44(
      EditContainer,
      {
        title: "Where you want to work",
        value: /* @__PURE__ */ jsx44("div", { children: /* @__PURE__ */ jsx44("div", { className: "flex justify-between", children: /* @__PURE__ */ jsx44("ul", { children: data.workLocations?.map(
          (location2) => location2?.countryName && location2?.countryCode && /* @__PURE__ */ jsxs31("li", { children: [
            location2.name,
            " (",
            location2.countryCode,
            ")"
          ] }, location2.countryCode)
        ) }) }) }),
        onClick: toggleEditWhereYouWantToWork
      }
    ),
    whereYouWantToWorkEditable && /* @__PURE__ */ jsxs31(
      ActionContainer2,
      {
        titleTop: `Where you want to work`,
        submitText: "Add location",
        onSubmit: toggleIsAdding,
        onCancel: () => {
          toggleEditWhereYouWantToWork();
          if (isAdding) {
            toggleIsAdding();
          }
        },
        showCancel: true,
        showSubmit: !isAdding,
        children: [
          saved ? /* @__PURE__ */ jsx44(AlertMessage7, { message: "Location Saved" }) : null,
          isAdding ? /* @__PURE__ */ jsxs31("div", { children: [
            /* @__PURE__ */ jsx44("div", { className: "py-4", children: /* @__PURE__ */ jsx44(
              GeoLocationsSearchContainer,
              {
                name: "location-search",
                onSearchCompleted: onSelectLocation,
                onCountryChanged: onChangeCountry
              }
            ) }),
            selectedResult && /* @__PURE__ */ jsx44("div", { className: "px-1 pt-2", children: /* @__PURE__ */ jsx44(ButtonList6, { children: /* @__PURE__ */ jsx44(Button15, { color: "primary", clicked: onAdd, children: "Add" }) }) })
          ] }) : /* @__PURE__ */ jsx44("div", { children: /* @__PURE__ */ jsx44(
            WorkLocationEntriesList,
            {
              profileId,
              fragmentRef: data
            }
          ) })
        ]
      }
    )
  ] });
};

// src/locations/components/__generated__/CurrentLocationContainer_workLocations.graphql.ts
var node68 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CurrentLocationContainer_workLocations",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recruitProfileWorkLocationsId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentLocationCountryCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentLocationCountryName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentLocationName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentLocationLatitude",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentLocationLongitude",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentLocationRadius",
      "storageKey": null
    }
  ],
  "type": "RecruitProfileWorkLocations",
  "abstractKey": null
};
node68.hash = "a7787ac0a68f22bf584781cf20f5d260";
var CurrentLocationContainer_workLocations_graphql_default = node68;

// src/locations/components/CurrentLocationContainer.tsx
import { useCallback as useCallback22, useState as useState13 } from "react";
import { useFragment as useFragment22 } from "react-relay";
import { createClientMutationId as createClientMutationId13, useToggle as useToggle8 } from "shared-lib";
import {
  ActionContainer as ActionContainer3,
  AlertMessage as AlertMessage8,
  Button as Button16,
  EditContainer as EditContainer2
} from "shared-ui";
import {
  DefaultGeoCountry as DefaultGeoCountry2,
  GeoLocationsSearchContainer as GeoLocationsSearchContainer2
} from "feature-data-management";
import { jsx as jsx45, jsxs as jsxs32 } from "react/jsx-runtime";
var fragmentDef22 = CurrentLocationContainer_workLocations_graphql_default;
var CurrentLocationContainer = ({
  profileId,
  fragmentRef
}) => {
  const data = useFragment22(
    fragmentDef22,
    fragmentRef
  );
  const [isEditing, toggleIsEditing] = useToggle8();
  const [saved, setSaved] = useState13(false);
  const [country, setCountry] = useState13(DefaultGeoCountry2);
  const onChangeCountry = useCallback22(
    (c4) => {
      setCountry(c4);
    },
    [country]
  );
  const [selectedResult, setSelectedResult] = useState13(null);
  const onSelectLocation = useCallback22(
    (selected) => {
      setSelectedResult(selected);
    },
    [selectedResult]
  );
  const [addLocation] = useCandidateCurrentLocationUpdate();
  const onChange = useCallback22(() => {
    async function onAddAsync() {
      if (!selectedResult) {
        return;
      }
      setSaved(false);
      const location2 = {
        name: selectedResult.name,
        countryCode: selectedResult.countryCode,
        countryName: country.name,
        latitude: selectedResult.latitude,
        longitude: selectedResult.longitude
      };
      const input = {
        profileId,
        clientMutationId: createClientMutationId13(),
        location: location2
      };
      const response = await addLocation({
        input
      });
      if (response.data.locations?.node) {
        toggleIsEditing();
        setSaved(true);
        setSelectedResult(null);
      }
    }
    onAddAsync();
  }, [addLocation, profileId]);
  const [whereYouLiveEditable, toggleWhereYouLiveEditable] = useToggle8();
  return /* @__PURE__ */ jsxs32("div", { children: [
    !whereYouLiveEditable && /* @__PURE__ */ jsx45(
      EditContainer2,
      {
        title: "Where you live",
        value: /* @__PURE__ */ jsx45("div", { children: data.currentLocationName }),
        onClick: toggleWhereYouLiveEditable
      }
    ),
    whereYouLiveEditable && /* @__PURE__ */ jsxs32(
      ActionContainer3,
      {
        titleTop: `Where you live`,
        onSubmit: !isEditing ? toggleIsEditing : onChange,
        showCancel: true,
        onCancel: toggleWhereYouLiveEditable,
        showSubmit: !isEditing || selectedResult !== null,
        submitText: data.currentLocationName ? "Change your location" : "Add your location",
        children: [
          saved ? /* @__PURE__ */ jsx45(AlertMessage8, { message: "Location Saved" }) : null,
          isEditing ? /* @__PURE__ */ jsx45("div", { children: /* @__PURE__ */ jsx45(
            GeoLocationsSearchContainer2,
            {
              name: "location-search",
              onSearchCompleted: onSelectLocation,
              onCountryChanged: onChangeCountry
            }
          ) }) : /* @__PURE__ */ jsx45("div", { children: !data.currentLocationName ? /* @__PURE__ */ jsx45("div", { children: /* @__PURE__ */ jsx45(Button16, { clicked: toggleIsEditing, color: "primary", children: "Add your Location" }) }) : /* @__PURE__ */ jsx45("div", { className: "flex items-center justify-between", children: /* @__PURE__ */ jsxs32("div", { children: [
            data.currentLocationName,
            ",",
            " ",
            data.currentLocationCountryName
          ] }) }) })
        ]
      }
    )
  ] });
};

// src/locations/components/LocationsContainer.tsx
import { jsx as jsx46, jsxs as jsxs33 } from "react/jsx-runtime";
var queryDef9 = LocationsContainerQuery_graphql_default;
var LocationsContainer = ({
  profileId,
  hideCurrentLocation = false
}) => {
  const query3 = useLazyLoadQuery11(
    queryDef9,
    { id: profileId },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { workLocations } = query3;
  return /* @__PURE__ */ jsxs33("div", { className: "flex flex-col gap-5 xl:container", children: [
    /* @__PURE__ */ jsx46(
      WorkLocationsContainer,
      {
        profileId,
        fragmentRef: workLocations
      }
    ),
    !hideCurrentLocation && /* @__PURE__ */ jsx46(
      CurrentLocationContainer,
      {
        profileId,
        fragmentRef: workLocations
      }
    )
  ] });
};

// src/right-to-work/components/RightToWorkEditor.tsx
import { Suspense as Suspense11, useCallback as useCallback25, useState as useState15 } from "react";
import { createClientMutationId as createClientMutationId16, useToggle as useToggle9 } from "shared-lib";
import { Spinner as Spinner2, AlertMessage as AlertMessage9 } from "shared-ui";

// src/right-to-work/components/RightToWorkForm.tsx
import { useEffect as useEffect10, useMemo as useMemo8, useState as useState14 } from "react";
import { useForm as useForm3 } from "react-hook-form";
import { z as z3 } from "zod";
import { zodResolver as zodResolver3 } from "@hookform/resolvers/zod";
import { useFirstMountState } from "react-use";
import { useLogger as useLogger9 } from "shared-lib";
import {
  ErrorField as ErrorField2,
  FormInput as FormInput2,
  FormInputRow as FormInputRow2,
  ListDirection,
  RadioListInput as RadioListInput2,
  ActionContainer as ActionContainer4
} from "shared-ui";
import { GeoCountriesSearchBoxInput } from "feature-data-management";

// src/right-to-work/lib/RightToWorkStatus.ts
var statusBuilder = {
  1: (countryName) => `Citizen of ${countryName}`,
  2: (countryName) => `Citizen of other country with right to work in ${countryName}`,
  3: () => `Visa or residency`,
  4: (countryName) => `No current right to work in ${countryName}`
};
function createRightToWorkStatusList(countryName) {
  return [
    {
      id: "1",
      label: statusBuilder[1](countryName)
    },
    {
      id: "2",
      label: statusBuilder[2](countryName)
    },
    {
      id: "3",
      label: statusBuilder[3](countryName)
    },
    {
      id: "4",
      label: statusBuilder[4](countryName)
    }
  ];
}
function createRightToWorkStatus(statusId, countryName) {
  return {
    id: statusId.toString(),
    label: createRightToWorkStatusLabel(statusId, countryName)
  };
}
function createRightToWorkStatusLabel(statusId, countryName) {
  return statusBuilder[statusId](countryName);
}

// src/right-to-work/components/RightToWorkForm.tsx
import { Fragment as Fragment13, jsx as jsx47, jsxs as jsxs34 } from "react/jsx-runtime";
var formSchema2 = z3.object({
  country: z3.object({
    iso3: z3.string(),
    name: z3.string()
  }).nullable(),
  otherCountry: z3.object({
    iso3: z3.string(),
    name: z3.string()
  }).nullable(),
  statusId: z3.string(),
  visaNumber: z3.string().nullable(),
  visaType: z3.string().nullable(),
  additionalInfo: z3.string().nullable()
}).superRefine((obj, ctx) => {
  if (obj.statusId === "3") {
    if (!obj.visaNumber) {
      ctx.addIssue({
        code: z3.ZodIssueCode.custom,
        message: "Visa number is required",
        path: ["visaNumber"]
      });
    }
    if (!obj.visaType) {
      ctx.addIssue({
        code: z3.ZodIssueCode.custom,
        message: "Visa type is required",
        path: ["visaType"]
      });
    }
  }
  return ctx;
});
function initializeFormData2(rightToWork, country) {
  const defaultValues2 = {
    visaNumber: null,
    visaType: null,
    additionalInfo: null,
    country: null,
    otherCountry: null,
    statusId: null
  };
  if (rightToWork) {
    if (rightToWork.country) {
      defaultValues2.country = {
        iso3: rightToWork.country.iso3,
        name: rightToWork.country.name
      };
    }
    if (rightToWork.otherCountry) {
      defaultValues2.otherCountry = {
        iso3: rightToWork.otherCountry.iso3,
        name: rightToWork.otherCountry.name
      };
    }
    if (rightToWork.statusId) {
      defaultValues2.statusId = rightToWork.statusId.toString();
    }
    if (rightToWork.additionalInfo) {
      defaultValues2.additionalInfo = rightToWork.additionalInfo;
    }
    if (rightToWork.visaNumber) {
      defaultValues2.visaNumber = rightToWork.visaNumber;
    }
    if (rightToWork.visaType) {
      defaultValues2.visaType = rightToWork.visaType;
    }
  }
  if (country) {
    defaultValues2.country = {
      iso3: country.iso3,
      name: country.name
    };
  }
  return defaultValues2;
}
function extractFormInput2(form) {
  if (!form.country || !form.statusId) {
    return null;
  }
  const input = {
    countryCode: form.country.iso3,
    statusId: parseInt(form.statusId),
    visaType: form.visaType,
    visaNumber: form.visaNumber,
    additionalInfo: form.additionalInfo
  };
  if (form.otherCountry) {
    input.otherCountryCode = form.otherCountry.iso3;
  }
  return input;
}
var RightToWorkForm = ({
  rightToWork,
  onSave,
  showCancel,
  onCancel,
  onDelete,
  isDeleting,
  showDelete,
  isBusy,
  country
}) => {
  const isFirstMount = useFirstMountState();
  const [log] = useLogger9();
  const [selectedCountry, setSelectedCountry] = useState14(null);
  const [statusList3, setStatusList] = useState14(null);
  const [statusId, setStatusId] = useState14(null);
  log(`RightToWorkForm Render`);
  const defaultValues2 = useMemo8(() => {
    const defaults = initializeFormData2(rightToWork, country);
    log(`Load RightToWorkForm DefaultValues: ${JSON.stringify(defaults)}`);
    return defaults;
  }, [rightToWork, country, log]);
  const { register, handleSubmit, formState, control, setValue } = useForm3({
    resolver: zodResolver3(formSchema2),
    defaultValues: defaultValues2
  });
  useEffect10(() => {
    if (!isFirstMount) {
      return;
    }
    if (country) {
      setSelectedCountry({
        iso3: country.iso3,
        name: country.name
      });
    }
    if (rightToWork) {
      if (!selectedCountry && rightToWork.country) {
        setSelectedCountry({
          iso3: rightToWork.country.iso3,
          name: rightToWork.country.name
        });
      }
      if (!statusId && rightToWork.statusId) {
        log(`Render RightToWorkForm: setStatusId ${rightToWork.statusId}`);
        setStatusId(rightToWork.statusId.toString());
        setValue("statusId", rightToWork.statusId.toString());
      }
    }
  }, [
    country,
    isFirstMount,
    log,
    rightToWork,
    selectedCountry,
    setValue,
    statusId
  ]);
  useEffect10(() => {
    log(`RightToWorkForm Selected Country`);
    if (!selectedCountry) {
      setStatusList([]);
      return;
    }
    const statusList4 = createRightToWorkStatusList(selectedCountry.name);
    setStatusList(statusList4);
    if (!statusId) {
      const defaultStatusId = statusList4[0].id;
      setStatusId(defaultStatusId);
      setValue("statusId", defaultStatusId);
      log(`RightToWorkForm Selected Country setStatusId: ${defaultStatusId}`);
    }
  }, [log, selectedCountry, setValue, statusId]);
  const { errors, isValid, isDirty } = formState;
  const onSubmit = handleSubmit(
    (valid) => {
      log(valid);
      const input = extractFormInput2(valid);
      if (!input) {
        return;
      }
      onSave(isValid, input);
    },
    (invalid) => {
      log(invalid);
    }
  );
  return /* @__PURE__ */ jsxs34(
    ActionContainer4,
    {
      showDelete,
      onDelete,
      showCancel,
      onCancel,
      isDirty,
      isSaving: isBusy,
      onSubmit,
      titleTop: "Right to work",
      deleteText: `Delete location`,
      children: [
        /* @__PURE__ */ jsxs34(
          FormInputRow2,
          {
            name: "country",
            title: "Country",
            description: "Select a country you're eligible to work in",
            children: [
              country ? /* @__PURE__ */ jsx47("div", { children: country.name }) : /* @__PURE__ */ jsx47(
                GeoCountriesSearchBoxInput,
                {
                  name: "country",
                  control,
                  onSelected: (country2) => setSelectedCountry(country2)
                }
              ),
              /* @__PURE__ */ jsx47(ErrorField2, { field: errors.country })
            ]
          }
        ),
        statusList3 && statusList3.length > 0 ? /* @__PURE__ */ jsxs34(
          FormInputRow2,
          {
            name: "statusId",
            title: "Status",
            description: "Select your residency status",
            children: [
              /* @__PURE__ */ jsx47(
                RadioListInput2,
                {
                  name: "statusId",
                  title: "Status",
                  control,
                  list: statusList3,
                  direction: ListDirection.Vertical,
                  onChange: (s4) => setStatusId(s4.id)
                }
              ),
              /* @__PURE__ */ jsx47(ErrorField2, { field: errors.statusId, message: "Status is required" })
            ]
          }
        ) : null,
        statusId && statusId === "2" ? /* @__PURE__ */ jsxs34(FormInputRow2, { name: "otherCountry", title: "Other Country", children: [
          /* @__PURE__ */ jsx47(GeoCountriesSearchBoxInput, { name: "otherCountry", control }),
          /* @__PURE__ */ jsx47(ErrorField2, { field: errors.otherCountry })
        ] }) : null,
        statusId && statusId === "3" ? /* @__PURE__ */ jsxs34(Fragment13, { children: [
          /* @__PURE__ */ jsxs34(FormInputRow2, { name: "visaType", title: "Visa Type", children: [
            /* @__PURE__ */ jsx47(
              FormInput2,
              {
                type: "text",
                name: "visaType",
                required: true,
                register
              }
            ),
            /* @__PURE__ */ jsx47(ErrorField2, { field: errors.visaType })
          ] }),
          /* @__PURE__ */ jsxs34(FormInputRow2, { name: "visaNumber", title: "Visa Number", children: [
            /* @__PURE__ */ jsx47(
              FormInput2,
              {
                type: "text",
                name: "visaNumber",
                required: true,
                register
              }
            ),
            /* @__PURE__ */ jsx47(ErrorField2, { field: errors.visaNumber })
          ] })
        ] }) : null,
        /* @__PURE__ */ jsxs34(
          FormInputRow2,
          {
            name: "additionalInfo",
            title: "Additional Info",
            description: `Add any additional information you know of which might affect your ability to legally work in this country`,
            children: [
              /* @__PURE__ */ jsx47(
                FormInput2,
                {
                  type: "text",
                  name: "additionalInfo",
                  required: true,
                  register
                }
              ),
              /* @__PURE__ */ jsx47(ErrorField2, { field: errors.additionalInfo })
            ]
          }
        )
      ]
    }
  );
};

// src/right-to-work/mutations/__generated__/DeleteRightToWorkMutation.graphql.ts
var node69 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "boolean",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      v32,
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationItem",
        "kind": "LinkedField",
        "name": "validations",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          v32
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "data",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "DeleteRightToWorkMutation",
      "selections": [
        {
          "alias": "payload",
          "args": v1,
          "concreteType": "RecruitDeleteRightToWorkPayload",
          "kind": "LinkedField",
          "name": "recruitDeleteRightToWork",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "DeleteRightToWorkMutation",
      "selections": [
        {
          "alias": "payload",
          "args": v1,
          "concreteType": "RecruitDeleteRightToWorkPayload",
          "kind": "LinkedField",
          "name": "recruitDeleteRightToWork",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "29a567ab46b874b82bc1ac647c1416ae",
      "id": null,
      "metadata": {},
      "name": "DeleteRightToWorkMutation",
      "operationKind": "mutation",
      "text": "mutation DeleteRightToWorkMutation(\n  $input: RecruitDeleteRightToWorkInput!\n) {\n  payload: recruitDeleteRightToWork(input: $input) {\n    boolean\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n        validations {\n          name\n          message\n        }\n        data\n      }\n    }\n  }\n}\n"
    }
  };
}();
node69.hash = "a108ec1f3c6d87ead177c08d358c630e";
var DeleteRightToWorkMutation_graphql_default = node69;

// src/right-to-work/mutations/DeleteRightToWork.ts
import { useCallback as useCallback23 } from "react";
import { useMutation as useMutation6 } from "react-relay";
import { createClientMutationId as createClientMutationId14 } from "shared-lib";
var mutationDef15 = DeleteRightToWorkMutation_graphql_default;
var useDeleteRightToWork = (candidateId, onDone, onUserError, onError) => {
  const [commitMutation4, isMutationInFlight] = useMutation6(mutationDef15);
  const invokeMutation = useCallback23(
    (rightToWorkId) => {
      if (!candidateId || !rightToWorkId) {
        return;
      }
      const input = {
        clientMutationId: createClientMutationId14(),
        candidateId,
        rightToWorkId
      };
      commitMutation4({
        variables: {
          input
        },
        onError: (e4) => {
          onError(e4);
        },
        onCompleted: (response) => {
          if (response.payload.boolean) {
            onDone();
          }
          if (response.payload.userErrors && response.payload.userErrors.length > 0) {
            const userError = response.payload.userErrors[0];
            if (userError.code) {
              onUserError(userError.code);
            }
          }
        }
      });
    },
    [commitMutation4]
  );
  return [invokeMutation, isMutationInFlight];
};

// src/right-to-work/mutations/__generated__/SetRightToWorkMutation.graphql.ts
var node70 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "rightToWorkId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateAccountId",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "countryIso3",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "statusId",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "otherCountryIso3",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "visaType",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "visaNumber",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "additionalInfo",
    "storageKey": null
  }, v14 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v15 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "iso3",
    "storageKey": null
  }, v16 = [
    v14,
    v15
  ], v17 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  }, v18 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      v17,
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationItem",
        "kind": "LinkedField",
        "name": "validations",
        "plural": true,
        "selections": [
          v14,
          v17
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "data",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  }, v19 = [
    v14,
    v15,
    v23
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "SetRightToWorkMutation",
      "selections": [
        {
          "alias": "payload",
          "args": v1,
          "concreteType": "RecruitSetRightToWorkPayload",
          "kind": "LinkedField",
          "name": "recruitSetRightToWork",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfRightToWorkRow",
              "kind": "LinkedField",
              "name": "edgeOfRightToWorkRow",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RightToWork",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v23,
                    v32,
                    v4,
                    v5,
                    v6,
                    v7,
                    v8,
                    v9,
                    v10,
                    v11,
                    v12,
                    v13,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "GeoCountry",
                      "kind": "LinkedField",
                      "name": "country",
                      "plural": false,
                      "selections": v16,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "GeoCountry",
                      "kind": "LinkedField",
                      "name": "otherCountry",
                      "plural": false,
                      "selections": v16,
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v18
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "SetRightToWorkMutation",
      "selections": [
        {
          "alias": "payload",
          "args": v1,
          "concreteType": "RecruitSetRightToWorkPayload",
          "kind": "LinkedField",
          "name": "recruitSetRightToWork",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfRightToWorkRow",
              "kind": "LinkedField",
              "name": "edgeOfRightToWorkRow",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RightToWork",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v23,
                    v32,
                    v4,
                    v5,
                    v6,
                    v7,
                    v8,
                    v9,
                    v10,
                    v11,
                    v12,
                    v13,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "GeoCountry",
                      "kind": "LinkedField",
                      "name": "country",
                      "plural": false,
                      "selections": v19,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "GeoCountry",
                      "kind": "LinkedField",
                      "name": "otherCountry",
                      "plural": false,
                      "selections": v19,
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v18
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "ff35bff43d47df7ccd2038e030bca92c",
      "id": null,
      "metadata": {},
      "name": "SetRightToWorkMutation",
      "operationKind": "mutation",
      "text": "mutation SetRightToWorkMutation(\n  $input: RecruitSetRightToWorkInput!\n) {\n  payload: recruitSetRightToWork(input: $input) {\n    edgeOfRightToWorkRow {\n      node {\n        id\n        rightToWorkId\n        createdAt\n        updatedAt\n        candidateAccountId\n        countryIso3\n        status\n        statusId\n        otherCountryIso3\n        visaType\n        visaNumber\n        additionalInfo\n        country {\n          name\n          iso3\n          id\n        }\n        otherCountry {\n          name\n          iso3\n          id\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n        validations {\n          name\n          message\n        }\n        data\n      }\n    }\n  }\n}\n"
    }
  };
}();
node70.hash = "5573d9a8691f7b7371a02b4122ff3736";
var SetRightToWorkMutation_graphql_default = node70;

// src/right-to-work/mutations/SetRightToWork.ts
import { useCallback as useCallback24 } from "react";
import { useMutation as useMutation7 } from "react-relay";
import { createClientMutationId as createClientMutationId15 } from "shared-lib";
var mutationDef16 = SetRightToWorkMutation_graphql_default;
var useSetRightToWork = (candidateId, onDone, onUserError, onError) => {
  const [commitMutation4, isMutationInFlight] = useMutation7(mutationDef16);
  const invokeMutation = useCallback24(
    (isValid, form) => {
      if (!form.countryCode || !form.statusId) {
        return;
      }
      const input = {
        candidateId,
        clientMutationId: createClientMutationId15(),
        countryCode: form.countryCode,
        statusId: form.statusId,
        otherCountryCode: form.otherCountryCode,
        visaNumber: form.visaNumber,
        visaType: form.visaType,
        additionalInfo: form.additionalInfo
      };
      commitMutation4({
        variables: {
          input
        },
        onError: (e4) => {
          onError(e4);
        },
        onCompleted: (response) => {
          if (response.payload.edgeOfRightToWorkRow?.node) {
            onDone(response.payload.edgeOfRightToWorkRow?.node);
          }
          if (response.payload.userErrors && response.payload.userErrors.length > 0) {
            const userError = response.payload.userErrors[0];
            if (userError.code) {
              onUserError(userError.code);
            }
          }
        }
      });
    },
    [commitMutation4]
  );
  return [invokeMutation, isMutationInFlight];
};

// src/right-to-work/components/RightToWorkEditor.tsx
import { jsx as jsx48, jsxs as jsxs35 } from "react/jsx-runtime";
var RightToWorkEditor = ({
  candidateId,
  rightToWork,
  onSaved,
  onCancel,
  onDeleted
}) => {
  const [setRightToWork, isSetRightToWorkInProgress] = useSetRightToWork(
    candidateId,
    (updated) => {
      setCompleted(true);
      if (onSaved) {
        onSaved(updated);
      }
    },
    (code) => {
      setErrorCode(code);
    },
    (e4) => {
      toggleCriticalFailure();
    }
  );
  const [deleteRightToWork, isDeleteRightToWorkInProgress] = useDeleteRightToWork(
    candidateId,
    () => {
      setDeleted(true);
      if (onDeleted) {
        onDeleted();
      }
    },
    (code) => {
      setErrorCode(code);
    },
    (e4) => {
      toggleCriticalFailure();
    }
  );
  const onDelete = useCallback25(() => {
    if (!rightToWork || !rightToWork.rightToWorkId) {
      return;
    }
    deleteRightToWork(rightToWork.rightToWorkId);
  }, [deleteRightToWork]);
  const onSave = useCallback25(
    (isValid, form) => {
      const input = {
        ...form,
        candidateId,
        clientMutationId: createClientMutationId16()
      };
      setRightToWork(isValid, input);
    },
    []
  );
  const [completed, setCompleted] = useState15(false);
  const [deleted, setDeleted] = useState15(false);
  const [criticalFailure, toggleCriticalFailure] = useToggle9(false);
  const [errorCode, setErrorCode] = useState15(null);
  return /* @__PURE__ */ jsx48("div", { className: "container mx-auto sm:py-5", children: /* @__PURE__ */ jsxs35(Suspense11, { fallback: /* @__PURE__ */ jsx48(Spinner2, {}), children: [
    criticalFailure ? /* @__PURE__ */ jsx48("div", { children: "A error has occurred, please try again" }) : null,
    completed ? /* @__PURE__ */ jsx48(AlertMessage9, { message: "Right To Work Updated" }) : null,
    deleted ? /* @__PURE__ */ jsx48(AlertMessage9, { message: "Right To Work Deleted" }) : null,
    /* @__PURE__ */ jsx48(
      RightToWorkForm,
      {
        onSave,
        showCancel: true,
        onCancel,
        onDelete,
        showDelete: !!rightToWork,
        isDeleting: isDeleteRightToWorkInProgress,
        isBusy: isSetRightToWorkInProgress,
        rightToWork
      }
    )
  ] }) });
};

// src/right-to-work/components/RightToWorkAdd.tsx
import { jsx as jsx49 } from "react/jsx-runtime";
var RightToWorkAdd = ({ candidateId, onAdd, onCancel }) => {
  return /* @__PURE__ */ jsx49(
    RightToWorkEditor,
    {
      candidateId,
      onSaved: onAdd,
      onCancel
    }
  );
};

// src/right-to-work/components/__generated__/RightToWorkEditor_rightToWork.graphql.ts
var node71 = function() {
  var v0 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "iso3",
      "storageKey": null
    }
  ];
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "RightToWorkEditor_rightToWork",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rightToWorkId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "candidateAccountId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "countryIso3",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "statusId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "otherCountryIso3",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "visaType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "visaNumber",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "additionalInfo",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "GeoCountry",
        "kind": "LinkedField",
        "name": "country",
        "plural": false,
        "selections": v0,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "GeoCountry",
        "kind": "LinkedField",
        "name": "otherCountry",
        "plural": false,
        "selections": v0,
        "storageKey": null
      }
    ],
    "type": "RightToWork",
    "abstractKey": null
  };
}();
node71.hash = "5fdaf43ae0f074656509647c86efce87";
var RightToWorkEditor_rightToWork_graphql_default = node71;

// src/right-to-work/components/RightToWorkEdit.tsx
import { useFragment as useFragment23 } from "react-relay";
import { jsx as jsx50 } from "react/jsx-runtime";
var RightToWorkEdit = ({
  candidateId,
  fragmentRef,
  onEdit,
  onCancel,
  onDeleted
}) => {
  const data = useFragment23(
    RightToWorkEditor_rightToWork_graphql_default,
    fragmentRef
  );
  return /* @__PURE__ */ jsx50(
    RightToWorkEditor,
    {
      rightToWork: data,
      candidateId,
      onSaved: onEdit,
      onCancel,
      onDeleted
    }
  );
};

// src/right-to-work/components/__generated__/RightToWorkListPaginationQuery.graphql.ts
var node72 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": {
        "createdAt": "DESC"
      },
      "kind": "LocalArgument",
      "name": "order"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v23 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v32 = {
    "kind": "Variable",
    "name": "order",
    "variableName": "order"
  }, v4 = [
    v1,
    v23,
    v32,
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ], v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v6 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "iso3",
      "storageKey": null
    },
    v5
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "RightToWorkListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v23,
            v32
          ],
          "kind": "FragmentSpread",
          "name": "RightToWorkList_rightsToWork"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "RightToWorkListPaginationQuery",
      "selections": [
        {
          "alias": "rightsToWork",
          "args": v4,
          "concreteType": "RecruitRightsToWorkConnection",
          "kind": "LinkedField",
          "name": "recruitRightsToWork",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitRightsToWorkEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RightToWork",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v5,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "rightToWorkId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "candidateAccountId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "GeoCountry",
                      "kind": "LinkedField",
                      "name": "country",
                      "plural": false,
                      "selections": v6,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "countryIso3",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "statusId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "otherCountryIso3",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "GeoCountry",
                      "kind": "LinkedField",
                      "name": "otherCountry",
                      "plural": false,
                      "selections": v6,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "visaType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "visaNumber",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "additionalInfo",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "rightsToWork",
          "args": v4,
          "filters": [],
          "handle": "connection",
          "key": "RightToWorkList_rightsToWork",
          "kind": "LinkedHandle",
          "name": "recruitRightsToWork"
        }
      ]
    },
    "params": {
      "cacheID": "4ecaac91bf9997d60689fb45fc241c32",
      "id": null,
      "metadata": {},
      "name": "RightToWorkListPaginationQuery",
      "operationKind": "query",
      "text": "query RightToWorkListPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $order: [RightToWorkSort!] = {createdAt: DESC}\n  $where: RightToWorkFilter\n) {\n  ...RightToWorkList_rightsToWork_gOVF5\n}\n\nfragment RightToWorkList_rightsToWork_gOVF5 on Query {\n  rightsToWork: recruitRightsToWork(first: $first, after: $after, order: $order, where: $where) {\n    totalCount\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        rightToWorkId\n        createdAt\n        updatedAt\n        candidateAccountId\n        country {\n          name\n          iso3\n          id\n        }\n        countryIso3\n        status\n        statusId\n        otherCountryIso3\n        otherCountry {\n          name\n          iso3\n          id\n        }\n        visaType\n        visaNumber\n        additionalInfo\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node72.hash = "59eceb1501e665e65e8b42e780332d39";
var RightToWorkListPaginationQuery_graphql_default = node72;

// src/right-to-work/components/__generated__/RightToWorkList_rightsToWork.graphql.ts
var node73 = function() {
  var v0 = [
    "rightsToWork"
  ], v1 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "iso3",
      "storageKey": null
    }
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "defaultValue": {
          "createdAt": "DESC"
        },
        "kind": "LocalArgument",
        "name": "order"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": RightToWorkListPaginationQuery_graphql_default
      }
    },
    "name": "RightToWorkList_rightsToWork",
    "selections": [
      {
        "alias": "rightsToWork",
        "args": null,
        "concreteType": "RecruitRightsToWorkConnection",
        "kind": "LinkedField",
        "name": "__RightToWorkList_rightsToWork_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitRightsToWorkEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RightToWork",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "rightToWorkId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "candidateAccountId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GeoCountry",
                    "kind": "LinkedField",
                    "name": "country",
                    "plural": false,
                    "selections": v1,
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "countryIso3",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "statusId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "otherCountryIso3",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GeoCountry",
                    "kind": "LinkedField",
                    "name": "otherCountry",
                    "plural": false,
                    "selections": v1,
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "visaType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "visaNumber",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "additionalInfo",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node73.hash = "59eceb1501e665e65e8b42e780332d39";
var RightToWorkList_rightsToWork_graphql_default = node73;

// src/right-to-work/components/RightToWorkList.tsx
import { usePaginationFragment as usePaginationFragment4 } from "react-relay";
import { jsx as jsx51, jsxs as jsxs36 } from "react/jsx-runtime";
var fragment2 = RightToWorkList_rightsToWork_graphql_default;
var RightToWorkList = ({ fragmentRef, onSelect }) => {
  const { data, loadNext, refetch, hasNext, isLoadingNext } = usePaginationFragment4(fragment2, fragmentRef);
  const rightsToWork = (data.rightsToWork?.edges || []).map((e4) => e4.node);
  const rows = rightsToWork.map((rtw) => {
    return /* @__PURE__ */ jsx51(
      "li",
      {
        className: "cursor-pointer",
        onClick: () => onSelect(rtw.rightToWorkId),
        children: /* @__PURE__ */ jsxs36("div", { className: "flex flex-col rounded-xl border bg-white px-4 py-3", children: [
          /* @__PURE__ */ jsxs36("div", { className: "flex items-baseline justify-between text-sm", children: [
            /* @__PURE__ */ jsx51("a", { href: "#", className: "font-medium text-gray-900", children: rtw.country ? rtw.country.name : rtw.countryIso3 }),
            /* @__PURE__ */ jsx51("span", { className: "text-xs font-medium text-gray-500" })
          ] }),
          rtw.country && /* @__PURE__ */ jsx51("div", { className: "mt-1 text-sm text-gray-700", children: /* @__PURE__ */ jsx51("div", { className: "whitespace-pre-wrap", children: createRightToWorkStatusLabel(rtw.statusId, rtw.country.name) }) }),
          rtw.otherCountry && /* @__PURE__ */ jsx51("div", { className: "mt-1 text-sm text-gray-700", children: /* @__PURE__ */ jsx51("div", { className: "whitespace-pre-wrap", children: rtw.otherCountry.name }) }),
          rtw.visaType && /* @__PURE__ */ jsx51("div", { className: "mt-1 text-sm text-gray-700", children: /* @__PURE__ */ jsx51("div", { className: "whitespace-pre-wrap", children: rtw.visaType }) }),
          rtw.visaNumber && /* @__PURE__ */ jsx51("div", { className: "mt-1 text-sm text-gray-700", children: /* @__PURE__ */ jsx51("div", { className: "whitespace-pre-wrap", children: rtw.visaNumber }) })
        ] })
      },
      rtw.rightToWorkId
    );
  });
  return /* @__PURE__ */ jsx51("div", { className: "relative", children: /* @__PURE__ */ jsx51("div", { className: "flex-1 overflow-y-scroll pt-2", children: /* @__PURE__ */ jsx51("ul", { role: "list", className: "flex flex-col gap-2", children: rows }) }) });
};

// src/rates/__generated__/Rates_RecruitProfile.graphql.ts
var node74 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Rates_RecruitProfile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recruitProfileId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RecruitProfileRate",
      "kind": "LinkedField",
      "name": "rate",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "payType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "minimumRateOfPay",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "maximumRateOfPay",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "countryCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currencyCode",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RecruitProfile",
  "abstractKey": null
};
node74.hash = "738286b08a02c8a47a32b5d75d2b10c0";
var Rates_RecruitProfile_graphql_default = node74;

// src/rates/__generated__/RatesMutation.graphql.ts
var node75 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "payType",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "minimumRateOfPay",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "maximumRateOfPay",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "countryCode",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currencyCode",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  }, v8 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      v7,
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationItem",
        "kind": "LinkedField",
        "name": "validations",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          v7
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "data",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "RatesMutation",
      "selections": [
        {
          "alias": "rate",
          "args": v1,
          "concreteType": "RecruitCandidateRateUpdatePayload",
          "kind": "LinkedField",
          "name": "recruitCandidateRateUpdate",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CandidateRatePayload",
              "kind": "LinkedField",
              "name": "candidateRatePayload",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EdgeOfCandidateRate",
                  "kind": "LinkedField",
                  "name": "rate",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileRate",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        v23,
                        v32,
                        v4,
                        v5,
                        v6
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v8
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "RatesMutation",
      "selections": [
        {
          "alias": "rate",
          "args": v1,
          "concreteType": "RecruitCandidateRateUpdatePayload",
          "kind": "LinkedField",
          "name": "recruitCandidateRateUpdate",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CandidateRatePayload",
              "kind": "LinkedField",
              "name": "candidateRatePayload",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EdgeOfCandidateRate",
                  "kind": "LinkedField",
                  "name": "rate",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileRate",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        v23,
                        v32,
                        v4,
                        v5,
                        v6,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "id",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v8
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "48089241be2f06ac5c02f4e04e5a6cad",
      "id": null,
      "metadata": {},
      "name": "RatesMutation",
      "operationKind": "mutation",
      "text": "mutation RatesMutation(\n  $input: RecruitCandidateRateUpdateInput!\n) {\n  rate: recruitCandidateRateUpdate(input: $input) {\n    candidateRatePayload {\n      rate {\n        node {\n          payType\n          minimumRateOfPay\n          maximumRateOfPay\n          countryCode\n          currencyCode\n          id\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n        validations {\n          name\n          message\n        }\n        data\n      }\n    }\n  }\n}\n"
    }
  };
}();
node75.hash = "764fb4b95b87fab87b502c337cf53e9f";
var RatesMutation_graphql_default = node75;

// src/rates/Rates.tsx
import { useCallback as useCallback26 } from "react";
import { useFragment as useFragment24, useMutation as useMutation8 } from "react-relay";
import { RateForm } from "feature-candidate-accounts";
import { createClientMutationId as createClientMutationId17 } from "shared-lib";
import { jsx as jsx52 } from "react/jsx-runtime";
var Rates = ({
  fragmentRef
}) => {
  const { rate, recruitProfileId } = useFragment24(
    Rates_RecruitProfile_graphql_default,
    fragmentRef
  );
  const [commitMutation4, isMutationInFlight] = useMutation8(RatesMutation_graphql_default);
  const onSave = useCallback26(
    (isValid, form) => {
      if (!form.max || !form.min || !form.payType || !form.countryCode) {
        return;
      }
      commitMutation4({
        variables: {
          input: {
            profileId: recruitProfileId,
            clientMutationId: createClientMutationId17(),
            model: {
              countryCode: form.countryCode,
              isPrivate: false,
              max: form.max,
              min: form.min,
              payType: form.payType
            }
          }
        }
      });
    },
    [commitMutation4, recruitProfileId]
  );
  return /* @__PURE__ */ jsx52(RateForm, { isBusy: isMutationInFlight, rate, onSave });
};

// src/profiles/edit/components/JobTitleEditor.tsx
import { useCallback as useCallback27 } from "react";
import { useLogger as useLogger10 } from "shared-lib";
import { jsx as jsx53 } from "react/jsx-runtime";
var JobTitleEditor = ({
  profileId,
  onCompleted,
  onCancel
}) => {
  const [log] = useLogger10();
  const onDone = useCallback27(() => {
    onCompleted();
  }, [onCompleted]);
  const [change, isChanging] = useCandidateProfileChangeJobTitle(
    profileId,
    onDone
  );
  const onChange = useCallback27(
    (result) => {
      async function onChangeAsync() {
        log(result);
        await change({
          jobTitleId: result.jobFunctionId,
          jobTitleName: result.name
        });
      }
      onChangeAsync();
    },
    [change, log]
  );
  return /* @__PURE__ */ jsx53("div", { children: /* @__PURE__ */ jsx53(JobTitleSearchContainer, { onSearchCompleted: onChange }) });
};

// src/profiles/edit/components/ProfileContainer.tsx
import { Fragment as Fragment14, jsx as jsx54, jsxs as jsxs37 } from "react/jsx-runtime";
var tasksFragmentDef = ProfileContainer_tasks_graphql_default;
var recommendationFragmentDef = ProfileContainer_recommendations_graphql_default;
var interviewsFragmentDef = ProfileContainer_interviews_graphql_default;
var allTasksFragmentDef = ProfileContainer_applications_graphql_default;
var profileFragmentDef = ProfileContainer_profile_graphql_default;
var accountFragmentDef = ProfileContainer_account_graphql_default;
var JobTitle = ({
  jobTitle,
  currentEmployerName,
  isCurrentEmployerVerified,
  onChange
}) => /* @__PURE__ */ jsx54("div", { className: "flex flex-col", children: jobTitle ? /* @__PURE__ */ jsxs37("div", { className: "flex flex-col  bg-white", children: [
  /* @__PURE__ */ jsxs37("div", { className: "mb-2 text-xl capitalize text-purple-900 sm:mb-0", children: [
    jobTitle,
    currentEmployerName && /* @__PURE__ */ jsxs37(Fragment14, { children: [
      " at",
      /* @__PURE__ */ jsxs37("span", { className: "text-primary-700", children: [
        " ",
        currentEmployerName,
        " "
      ] })
    ] })
  ] }),
  !isCurrentEmployerVerified && /* @__PURE__ */ jsx54("div", { className: "flex", children: /* @__PURE__ */ jsx54(Button17, { color: "primary", clicked: onChange, children: "Confirm my Profession" }) })
] }) : /* @__PURE__ */ jsxs37("div", { className: "flex flex-col flex-wrap items-center justify-between gap-5 rounded-lg border bg-orange-400 p-4 py-8 text-center md:flex-row md:text-left", children: [
  /* @__PURE__ */ jsxs37("div", { children: [
    /* @__PURE__ */ jsx54("div", { className: "text-lg", children: "You have currently not set a Profession" }),
    /* @__PURE__ */ jsx54("div", { className: "mt-1", children: "We strongly recommend you add one" })
  ] }),
  /* @__PURE__ */ jsx54("div", { className: "mt-2 flex sm:mt-0 ", children: /* @__PURE__ */ jsx54(Button17, { color: "white", clicked: onChange, children: /* @__PURE__ */ jsxs37("div", { className: "flex items-center gap-1 px-1", children: [
    /* @__PURE__ */ jsx54("div", { className: "text-lg", children: "Add Profession" }),
    /* @__PURE__ */ jsx54(ArrowRightIcon, { className: "h-7 w-7" })
  ] }) }) })
] }) });
var EmptyList = ({ title, subTitle, buttonText, path }) => /* @__PURE__ */ jsx54("div", { className: "mt-5 flex h-[320px] flex-col justify-center rounded-lg border border-dashed border-gray-200  text-center ", children: /* @__PURE__ */ jsxs37("div", { className: "m-5 flex flex-col  flex-wrap gap-2 ", children: [
  /* @__PURE__ */ jsx54("div", { className: "text-grey-500 text-4xl", children: title }),
  /* @__PURE__ */ jsx54("div", { className: "text-grey-500 mx-1 text-base", children: subTitle }),
  path && buttonText && /* @__PURE__ */ jsx54(EdLink4, { name: buttonText, href: path, children: /* @__PURE__ */ jsx54(Button17, { color: "green", className: "w-fit px-5", children: /* @__PURE__ */ jsx54("div", { className: "text-lg", children: buttonText }) }) })
] }) });
var ProfileResumeUpload = ({
  profileId,
  onStarted
}) => {
  const [log] = useLogger11();
  const navigate = useNavigate6();
  const onFailed = useCallback28(() => {
    log("Resume Failed");
  }, [log]);
  const onTimedOut = useCallback28(() => {
    log("Resume TimedOut");
  }, [log]);
  const onReady = useCallback28(
    (resume) => {
      log(`Resume Ready`);
    },
    [log, navigate]
  );
  const onCancel = useCallback28(() => {
    log(`Resume Cancel`);
  }, [log]);
  return /* @__PURE__ */ jsx54("div", { className: "", children: /* @__PURE__ */ jsx54(
    ResumeUploader,
    {
      profileId,
      onUploadStarted: onStarted,
      onReady,
      onCancel,
      onFailed,
      onTimedOut
    }
  ) });
};
var ListItem = ({
  jobTitle,
  employerName,
  actionName,
  actionType,
  path
}) => {
  return /* @__PURE__ */ jsx54("div", { className: "b flex flex-col gap-2  border-b-2 px-3 py-3 last:border-b-0", children: /* @__PURE__ */ jsxs37("div", { className: "flex items-center justify-between gap-2", children: [
    /* @__PURE__ */ jsx54("div", { className: "text-base capitalize text-purple-900", children: `${jobTitle} at ${employerName}` }),
    actionType === "TAG" && /* @__PURE__ */ jsx54(Tag6, { className: " border-primary-700 border", size: "xsmall", children: actionName }),
    actionType !== "TAG" && path && /* @__PURE__ */ jsx54(EdLink4, { name: actionName, href: path, children: /* @__PURE__ */ jsx54("div", { className: "text-primary-700 text-base capitalize", children: actionName }) }),
    actionType !== "TAG" && !path && /* @__PURE__ */ jsx54("div", { className: "text-primary-700 text-base capitalize", children: actionName })
  ] }) });
};
var CardHeader = ({
  title,
  path,
  actionName,
  isExpandVisible
}) => {
  return /* @__PURE__ */ jsxs37("div", { className: "flex items-center justify-between gap-2 py-3 pl-2", children: [
    /* @__PURE__ */ jsx54("div", { className: "text-xl text-purple-900", children: title }),
    isExpandVisible && /* @__PURE__ */ jsx54(EdLink4, { className: " ", name: actionName, href: path, children: /* @__PURE__ */ jsxs37("div", { className: "mx-1 flex items-center gap-1", children: [
      /* @__PURE__ */ jsx54("div", { className: "whitespace-nowrap text-sm text-xs text-gray-600", children: "View more" }),
      /* @__PURE__ */ jsx54(ChevronRightIcon, { className: "h-5 w-5 text-gray-600" })
    ] }) })
  ] });
};
var ProfileContainer = ({
  profileFragmentRef,
  accountFragmentRef,
  tasksFragmentRef,
  recommendationFragmentRef,
  interviewsFragmentRef,
  allTasksFragmentRef,
  onReload
}) => {
  const [isChangingJobTitle, setIsChangingJobTitle] = useState16(false);
  const [isProcessingResume, setIsProcessingResume] = useState16(false);
  const tasks = useFragment25(
    tasksFragmentDef,
    tasksFragmentRef
  );
  const { data: recommendationsData } = usePaginationFragment5(recommendationFragmentDef, recommendationFragmentRef);
  const { recommendations } = recommendationsData;
  const { data: InterviewData } = usePaginationFragment5(interviewsFragmentDef, interviewsFragmentRef);
  const { interviews } = InterviewData;
  const { data: allTasksData } = usePaginationFragment5(allTasksFragmentDef, allTasksFragmentRef);
  const { applications } = allTasksData;
  const profileData = useFragment25(
    profileFragmentDef,
    profileFragmentRef
  );
  const account = useFragment25(
    accountFragmentDef,
    accountFragmentRef
  );
  const showResumeUpload = profileData.experiences.items.length === 0 && !profileData.resume;
  const steps2 = useMemo9(() => {
    const stages = [
      {
        key: "verify-email",
        index: 1,
        name: "Verify Email",
        status: StepStatus.Pending
      },
      {
        key: "experience",
        index: 2,
        name: "Experience",
        status: StepStatus.Pending
      },
      {
        key: "location",
        index: 3,
        name: "Location",
        status: StepStatus.Pending
      },
      {
        key: "rates",
        index: 4,
        name: "Rates",
        status: StepStatus.Pending
      },
      {
        key: "right-to-work",
        index: 5,
        name: "Right to Work",
        status: StepStatus.Pending
      }
    ];
    return stages.map((step) => {
      if (step.key === "verify-email" && account.isEmailVerified) {
        return {
          ...step,
          status: StepStatus.Complete
        };
      }
      if (step.key === "experience" && !showResumeUpload) {
        return {
          ...step,
          status: StepStatus.Complete
        };
      }
      if (step.key === "location" && profileData.workLocations?.workLocations.length > 0) {
        return {
          ...step,
          status: StepStatus.Complete
        };
      }
      if (step.key === "rates" && profileData.rate?.maximumRateOfPay != 0) {
        return {
          ...step,
          status: StepStatus.Complete
        };
      }
      if (step.key === "right-to-work" && profileData.rightToWork.length > 0) {
        return {
          ...step,
          status: StepStatus.Complete
        };
      }
      return step;
    });
  }, [
    account.isEmailVerified,
    profileData.rate?.maximumRateOfPay,
    profileData.rightToWork.length,
    profileData.workLocations.currentLocationCountryName,
    profileData.workLocations?.workLocations.length,
    showResumeUpload
  ]);
  const currentStep = useMemo9(() => {
    return steps2.find((s4) => s4.status === StepStatus.Pending)?.key || steps2[0].key;
  }, [steps2]);
  const signupComplete = useMemo9(() => {
    return steps2.every((s4) => s4.status === StepStatus.Complete);
  }, [steps2]);
  const currentHour = (/* @__PURE__ */ new Date()).getHours();
  const determineGreeting = useMemo9(() => {
    if (currentHour >= 5 && currentHour < 12) {
      return "Good morning";
    } else if (currentHour >= 12 && currentHour < 18) {
      return "Good afternoon";
    } else if (currentHour >= 18 && currentHour < 22) {
      return "Good evening";
    } else {
      return "Good night";
    }
  }, [currentHour]);
  const determineApplicationTasks = useCallback28((node566) => {
    if (!node566.hasCompletedOptionalSkills || !node566.hasCompletedRequiredSkills) {
      return "Confirm Skills";
    } else if (!node566.hasCompletedRate) {
      return "Clarify Rates";
    } else if (!node566.hasCompletedDocumentTypes) {
      return "Clarify Documents";
    } else if (!node566.hasCompletedForms) {
      return "Clarify Forms";
    } else if (node566.applicationStateName === "ACTIVE") {
      return "Respond invitation";
    }
  }, []);
  const [hasResume, toggleHasResume] = useToggle10(true);
  if (!profileData || !account) {
    return /* @__PURE__ */ jsx54(Fragment14, { children: "Loading" });
  }
  const hasApplications = applications?.edges && applications?.edges?.length > 0;
  const hasInterviews = interviews?.edges && interviews?.edges?.length > 0;
  const hasRecommendations = recommendations?.edges && recommendations?.edges?.length > 0;
  return /* @__PURE__ */ jsxs37("div", { children: [
    /* @__PURE__ */ jsx54("div", { className: "mb-2 ml-4 mt-10 text-2xl capitalize", children: profileData?.account?.firstName && /* @__PURE__ */ jsx54("strong", { children: `${determineGreeting || "Hello"} ${profileData?.account?.firstName || ""} \u{1F44B}` }) }),
    /* @__PURE__ */ jsx54("div", { className: "container mx-auto flex flex-col  px-5 py-8 pb-40", children: /* @__PURE__ */ jsxs37("div", { className: "flex w-full flex-col gap-5 lg:flex-row ", children: [
      /* @__PURE__ */ jsxs37("div", { className: "flex flex-col gap-5 lg:w-6/12", children: [
        signupComplete && /* @__PURE__ */ jsx54("div", { children: isChangingJobTitle ? /* @__PURE__ */ jsxs37("div", { className: "mb-8 flex flex-col rounded-lg border bg-white p-4", children: [
          /* @__PURE__ */ jsx54("div", { children: "Add Profession" }),
          /* @__PURE__ */ jsx54(
            JobTitleEditor,
            {
              profileId: profileData.recruitProfileId,
              onCompleted: () => setIsChangingJobTitle(false),
              onCancel: () => setIsChangingJobTitle(false)
            }
          )
        ] }) : /* @__PURE__ */ jsxs37("div", { className: "flex flex-col gap-2 rounded-lg  border bg-white p-5", children: [
          /* @__PURE__ */ jsx54(
            CardHeader,
            {
              title: "My Details",
              isExpandVisible: false,
              path: "",
              actionName: ""
            }
          ),
          /* @__PURE__ */ jsxs37("div", { className: "flex flex-col gap-4 px-2 ", children: [
            /* @__PURE__ */ jsxs37("div", { children: [
              /* @__PURE__ */ jsx54("span", { className: "text-base text-gray-700 ", children: "Most Recent Experience" }),
              /* @__PURE__ */ jsx54(
                JobTitle,
                {
                  jobTitle: profileData?.currentPosition?.title || "",
                  currentEmployerName: profileData?.currentPosition?.companyName || "",
                  isCurrentEmployerVerified: profileData?.currentPosition?.companyIsVerified || false,
                  onChange: () => setIsChangingJobTitle(true)
                }
              )
            ] }),
            profileData.summary?.currentJobTitleName && /* @__PURE__ */ jsxs37("div", { children: [
              /* @__PURE__ */ jsx54("span", { className: "text-base text-gray-700", children: "Current Profession" }),
              /* @__PURE__ */ jsx54(
                JobTitle,
                {
                  jobTitle: profileData.summary?.currentJobTitleName || "",
                  currentEmployerName: "",
                  isCurrentEmployerVerified: profileData?.currentPosition?.companyIsVerified || false,
                  onChange: () => setIsChangingJobTitle(true)
                }
              )
            ] }),
            /* @__PURE__ */ jsxs37("div", { className: "flex flex-col gap-2", children: [
              /* @__PURE__ */ jsx54("span", { className: "text-base text-gray-700", children: "My Top Skills" }),
              /* @__PURE__ */ jsx54(
                ExperienceSkillsComponent,
                {
                  skillsList: [
                    ...new Set(
                      profileData.experiences.items.flatMap(
                        (x4) => x4.skills
                      )
                    )
                  ]
                }
              )
            ] }),
            /* @__PURE__ */ jsxs37("div", { children: [
              /* @__PURE__ */ jsx54("span", { className: "text-base text-gray-700", children: "My Salary Expectation" }),
              /* @__PURE__ */ jsx54(ProfileInfoSidebar, { fragmentRef: profileData })
            ] })
          ] })
        ] }) }),
        !signupComplete && /* @__PURE__ */ jsxs37("div", { children: [
          currentStep == "verify-email" && /* @__PURE__ */ jsx54(CandidateAccountEmailVerifyForm, { fragmentRef: account }),
          currentStep == "experience" && /* @__PURE__ */ jsxs37("div", { className: "flex flex-col gap-5 bg-white pb-5 text-center", children: [
            hasResume && /* @__PURE__ */ jsx54(
              ProfileResumeUpload,
              {
                profileId: profileData.recruitProfileId,
                onStarted: () => setIsProcessingResume(true)
              }
            ),
            !hasResume && /* @__PURE__ */ jsx54(
              ExperienceAdd,
              {
                profileId: profileData.recruitProfileId,
                onAdded: () => {
                  onReload();
                },
                onCancel: () => toggleHasResume()
              }
            ),
            /* @__PURE__ */ jsx54("div", { children: /* @__PURE__ */ jsx54(Button17, { onClick: toggleHasResume, children: hasResume ? /* @__PURE__ */ jsx54(Fragment14, { children: " I don't have a Resume" }) : /* @__PURE__ */ jsx54(Fragment14, { children: "I want to upload a resume" }) }) })
          ] }),
          currentStep == "location" && /* @__PURE__ */ jsx54(
            LocationsContainer,
            {
              profileId: profileData.recruitProfileId,
              hideCurrentLocation: true
            }
          ),
          currentStep == "rates" && /* @__PURE__ */ jsx54(Rates, { fragmentRef: profileData }),
          currentStep == "right-to-work" && /* @__PURE__ */ jsx54(
            RightToWorkEditor,
            {
              candidateId: account.accountId,
              onSaved: () => onReload()
            }
          )
        ] }),
        /* @__PURE__ */ jsxs37("div", { className: "min-h-[400px] gap-5 overflow-hidden rounded-lg border bg-white p-5", children: [
          /* @__PURE__ */ jsx54(
            CardHeader,
            {
              title: "My Outstanding Tasks",
              actionName: "Tasks",
              path: "/candidates/app/tasks",
              isExpandVisible: hasApplications || false
            }
          ),
          hasApplications ? (applications?.edges || [])?.map((application3) => {
            return /* @__PURE__ */ jsx54(
              ListItem,
              {
                jobTitle: application3.node.vacancy.name,
                employerName: application3.node.vacancy.employerName,
                actionName: determineApplicationTasks(application3?.node) || application3.node?.applicationStateName,
                path: `/candidates/app/tasks/${application3?.node.applicationId}/tasks`
              },
              application3?.node?.applicationId
            );
          }) : /* @__PURE__ */ jsx54(
            EmptyList,
            {
              title: "Well Done! \u{1F917}",
              subTitle: "No tasks to complete"
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ jsxs37("div", { className: " flex flex-col gap-5 sm:mt-0 lg:w-6/12", children: [
        /* @__PURE__ */ jsxs37("div", { className: " min-h-[350px] overflow-hidden rounded-lg border bg-white p-5", children: [
          /* @__PURE__ */ jsx54(
            CardHeader,
            {
              title: "My Recommendations",
              actionName: "Recommendations",
              path: "/candidates/app/jobs/recommendations",
              isExpandVisible: hasRecommendations || false
            }
          ),
          hasRecommendations ? (recommendations?.edges || [])?.map((recommendation) => {
            return /* @__PURE__ */ jsx54(
              ListItem,
              {
                jobTitle: recommendation.node.vacancy.name,
                employerName: recommendation.node.vacancy.employerName,
                actionName: recommendation.node.currentStatus,
                actionType: "TAG"
              },
              recommendation.node.recruitRecommendationId
            );
          }) : /* @__PURE__ */ jsx54(
            EmptyList,
            {
              title: "No Recommendations Yet \u{1F632}",
              subTitle: "Make sure you have updated your location, rate expectations, and add at least 1 recent piece of work experience to get jobs matched to you",
              path: "/candidates/app/profile/experience/list",
              buttonText: "Review Work Experience"
            }
          )
        ] }),
        /* @__PURE__ */ jsxs37("div", { className: "min-h-[400px] overflow-hidden rounded-lg border bg-white p-5", children: [
          /* @__PURE__ */ jsx54(
            CardHeader,
            {
              title: "My Interviews",
              actionName: "Interviews",
              path: "/candidates/app/interviews",
              isExpandVisible: hasInterviews || false
            }
          ),
          hasInterviews ? (interviews?.edges || [])?.map((interview) => {
            return /* @__PURE__ */ jsx54(
              ListItem,
              {
                jobTitle: interview?.node?.vacancy?.name,
                employerName: interview?.node?.vacancy?.employerName,
                actionName: interview.node?.status
              },
              interview?.node?.interviewId
            );
          }) : /* @__PURE__ */ jsx54(EmptyList, { title: "No Interviews Booked Yet \u{1F9D0}", subTitle: "" })
        ] })
      ] })
    ] }) })
  ] });
};

// src/profiles/edit/components/__generated__/ProfileSearchResultTimeline_profile.graphql.ts
var node76 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "startDate",
    "storageKey": null
  }, v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "endDate",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProfileSearchResultTimeline_profile",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitProfileExperienceCollection",
        "kind": "LinkedField",
        "name": "experiences",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitProfileExperience",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              v0,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "candidateExperienceId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "companyId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "companyIsVerified",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "companyName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              v1,
              v23,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "skills",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SkillUsage",
            "kind": "LinkedField",
            "name": "skills",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "skillId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalMonthsUsed",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "averageMonthsUsed",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalPositionsUsed",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastUsed",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DateRange",
                "kind": "LinkedField",
                "name": "periods",
                "plural": true,
                "selections": [
                  v1,
                  v23
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RecruitProfile",
    "abstractKey": null
  };
}();
node76.hash = "3c63b19d56115ecf6375a3cd34071994";
var ProfileSearchResultTimeline_profile_graphql_default = node76;

// src/profiles/edit/components/ProfileSearchResultTimeline.tsx
import { Suspense as Suspense12, useMemo as useMemo10 } from "react";
import { useFragment as useFragment26 } from "react-relay";
import { useAtom as useAtom2 } from "jotai";
import {
  EdColumnCell,
  EdRow,
  EdSkeleton as EdSkeleton7,
  EdTable,
  SignalBar,
  SignalBarSize,
  classNames as classNames6
} from "shared-ui";
import { noop as noop5, timeAgo } from "shared-lib";

// src/timelines/components/TimelineProvider.tsx
import {
  createContext as createContext7,
  useCallback as useCallback29,
  useContext as useContext7,
  useState as useState17
} from "react";
import { addYears, subYears as subYears3 } from "date-fns";

// src/timelines/lib/Timelines.ts
import {
  addMonths,
  eachMonthOfInterval,
  endOfMonth,
  getMonth,
  subMonths as subMonths2,
  subYears as subYears2
} from "date-fns";
function filterTimelineInstancesInsideDateRange(start, end, instances) {
  return instances.filter((i4) => {
    return i4.start <= end && i4.end >= start || i4.start <= start && i4.end >= end || i4.start >= start && i4.end <= end;
  });
}
function calculateTimelineSpec(contextDate) {
  const numberOfYears = 5;
  const endDate = endOfMonth(subMonths2(contextDate, 1));
  const startDate = addMonths(subYears2(endDate, numberOfYears), 1);
  const endTime = endDate.getTime();
  const startTime = startDate.getTime();
  const unit = (endTime - startTime) / 100;
  return {
    startDate,
    startTime,
    endDate,
    endYear: endDate.getFullYear(),
    endMonth: endDate.getMonth(),
    endTime,
    unit
  };
}
function calculateTimelineInstanceContext(timelineContext, instanceStartDate, instanceEndDate) {
  let startPercentage = 0;
  let endPercentage = 0;
  let periodWidthPercentage = 0;
  const instanceStartTime = instanceStartDate.getTime();
  const instanceEndTime = instanceEndDate.getTime();
  if (instanceEndTime > timelineContext.startTime) {
    if (instanceStartTime < timelineContext.startTime) {
      startPercentage = 0;
    } else {
      startPercentage = (instanceStartDate.getTime() - timelineContext.startTime) / timelineContext.unit;
    }
    endPercentage = (instanceEndDate.getTime() - timelineContext.startTime) / timelineContext.unit;
    periodWidthPercentage = endPercentage - startPercentage;
  } else {
    startPercentage = null;
    endPercentage = null;
    periodWidthPercentage = null;
  }
  return {
    startPercentage,
    endPercentage,
    widthPercentage: periodWidthPercentage
  };
}

// src/timelines/components/TimelineProvider.tsx
import { jsx as jsx55 } from "react/jsx-runtime";
var TimelineContext = createContext7(null);
var useTimelineContext = () => {
  return useContext7(TimelineContext);
};
function filterItemsBySpec(sourceItemSets, spec) {
  return Object.keys(sourceItemSets).reduce((dict, key) => {
    const set = sourceItemSets[key];
    const items = set.map((item) => {
      const instances = filterTimelineInstancesInsideDateRange(
        spec.startDate,
        spec.endDate,
        item.instances
      ).map((instance) => {
        return {
          context: calculateTimelineInstanceContext(
            spec,
            instance.start,
            instance.end
          ),
          instance
        };
      });
      return {
        key,
        item,
        instances
      };
    });
    dict[key] = items;
    return dict;
  }, {});
}
var TimelineProvider = ({
  sourceItemSets,
  endDate,
  children
}) => {
  const [spec, setSpec] = useState17(() => {
    return calculateTimelineSpec(endDate ?? /* @__PURE__ */ new Date());
  });
  const [currentItems, setCurrentItems] = useState17(() => {
    const initialSpec = calculateTimelineSpec(endDate ?? /* @__PURE__ */ new Date());
    return filterItemsBySpec(sourceItemSets, initialSpec);
  });
  const onRangeForward = useCallback29(() => {
    const nextEndDate = addYears(spec.endDate, 5);
    const nextSpec = calculateTimelineSpec(nextEndDate);
    const items = filterItemsBySpec(sourceItemSets, nextSpec);
    setSpec(nextSpec);
    setCurrentItems(items);
  }, [spec, setSpec, setCurrentItems]);
  const onRangeBack = useCallback29(() => {
    const nextEndDate = subYears3(spec.endDate, 5);
    const nextSpec = calculateTimelineSpec(nextEndDate);
    const items = filterItemsBySpec(sourceItemSets, nextSpec);
    setSpec(nextSpec);
    setCurrentItems(items);
  }, [spec, setSpec, setCurrentItems]);
  return /* @__PURE__ */ jsx55(
    TimelineContext.Provider,
    {
      value: {
        isBusy: false,
        spec,
        items: currentItems,
        onRangeForward,
        onRangeBack
      },
      children
    }
  );
};

// src/timelines/components/TimelineHeader.tsx
import { formatMonth as formatMonth2, useToggle as useToggle11 } from "shared-lib";
import { Button as Button18, Size as Size4 } from "shared-ui";

// src/timelines/components/TimelineYearView.tsx
import { jsx as jsx56 } from "react/jsx-runtime";
var TimelineYearView = ({
  endYear,
  endMonth,
  offset,
  isLast
}) => {
  if (isLast) {
    const flexGrow = 1 / (12 / (12 - endMonth));
    return /* @__PURE__ */ jsx56(
      "div",
      {
        className: "header-last flex-1 overflow-hidden overflow-ellipsis whitespace-nowrap border-r px-2 text-center",
        style: { flexGrow },
        children: /* @__PURE__ */ jsx56("div", { className: "text-primary-500 font-medium", children: endYear - offset })
      }
    );
  }
  return /* @__PURE__ */ jsx56("div", { className: "flex-1 overflow-hidden overflow-ellipsis whitespace-nowrap border-r px-2 text-center", children: /* @__PURE__ */ jsx56("div", { className: "text-primary-500 font-medium", children: endYear - offset }) });
};

// src/timelines/components/TimelineHeader.tsx
import { jsx as jsx57, jsxs as jsxs38 } from "react/jsx-runtime";
var TimeLineItemDebugger = ({
  item
}) => {
  const instances = item.instances.map((i4) => {
    return /* @__PURE__ */ jsxs38("div", { className: "flex flex-col gap-2", children: [
      /* @__PURE__ */ jsx57("div", { children: i4.instance.name }),
      /* @__PURE__ */ jsx57("div", { children: formatMonth2(i4.instance.start) }),
      /* @__PURE__ */ jsx57("div", { children: formatMonth2(i4.instance.end) })
    ] }, i4.instance.id);
  });
  return /* @__PURE__ */ jsxs38("div", { children: [
    /* @__PURE__ */ jsx57("div", { children: item.item.name }),
    /* @__PURE__ */ jsx57("div", { className: "flex items-center gap-2", children: instances })
  ] });
};
var TimeLineDebugger = () => {
  const context = useTimelineContext();
  const item = context.items["relevance"].find(
    (i4) => i4.key === "relevance" && i4.item.type === "Experience"
  );
  return /* @__PURE__ */ jsxs38("div", { className: "flex flex-col gap-2", children: [
    /* @__PURE__ */ jsxs38("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ jsxs38("div", { children: [
        "From ",
        formatMonth2(context.spec.startDate)
      ] }),
      /* @__PURE__ */ jsxs38("div", { children: [
        "To ",
        formatMonth2(context.spec.endDate)
      ] })
    ] }),
    /* @__PURE__ */ jsx57("div", { children: item && /* @__PURE__ */ jsx57(TimeLineItemDebugger, { item }) })
  ] });
};
var TimelineHeader = () => {
  const context = useTimelineContext();
  const [debug, toggleDebug] = useToggle11(false);
  const currentDate = /* @__PURE__ */ new Date();
  const currentYear = currentDate.getFullYear();
  const companyInstances = context?.items?.company[0]?.item?.instances;
  const startDate = companyInstances && companyInstances?.length > 0 ? companyInstances[companyInstances?.length - 1]?.start : null;
  const startYear = startDate ? new Date(startDate).getFullYear() : null;
  return /* @__PURE__ */ jsxs38("div", { children: [
    /* @__PURE__ */ jsx57("div", { className: "flex items-center", children: debug && /* @__PURE__ */ jsx57(TimeLineDebugger, {}) }),
    /* @__PURE__ */ jsxs38("div", { className: "flex items-center", children: [
      /* @__PURE__ */ jsx57("div", { className: "relative mr-4 flex w-32 items-center justify-end overflow-hidden border-r px-2 sm:w-64", children: /* @__PURE__ */ jsxs38("div", { className: "flex items-center justify-between", children: [
        /* @__PURE__ */ jsx57(
          Button18,
          {
            className: "text-primary-600 cursor-pointer",
            size: Size4.sm,
            onClick: context.onRangeBack,
            disabled: startYear ? startYear >= context.spec.endYear - 5 : true,
            children: "Back"
          }
        ),
        /* @__PURE__ */ jsx57(
          Button18,
          {
            className: "text-primary-600 ml-2 cursor-pointer",
            size: Size4.sm,
            onClick: context.onRangeForward,
            disabled: context.spec.endYear >= currentYear,
            children: "Forward"
          }
        )
      ] }) }),
      /* @__PURE__ */ jsxs38("div", { className: "relative flex flex-1 items-center overflow-hidden py-2", children: [
        /* @__PURE__ */ jsx57(
          TimelineYearView,
          {
            endYear: context.spec.endYear,
            endMonth: context.spec.endMonth,
            offset: 5
          }
        ),
        /* @__PURE__ */ jsx57(
          TimelineYearView,
          {
            endYear: context.spec.endYear,
            endMonth: context.spec.endMonth,
            offset: 4
          }
        ),
        /* @__PURE__ */ jsx57(
          TimelineYearView,
          {
            endYear: context.spec.endYear,
            endMonth: context.spec.endMonth,
            offset: 3
          }
        ),
        /* @__PURE__ */ jsx57(
          TimelineYearView,
          {
            endYear: context.spec.endYear,
            endMonth: context.spec.endMonth,
            offset: 2
          }
        ),
        /* @__PURE__ */ jsx57(
          TimelineYearView,
          {
            endYear: context.spec.endYear,
            endMonth: context.spec.endMonth,
            offset: 1
          }
        ),
        /* @__PURE__ */ jsx57(
          TimelineYearView,
          {
            endYear: context.spec.endYear,
            endMonth: context.spec.endMonth,
            offset: 0,
            isLast: true
          }
        )
      ] })
    ] })
  ] });
};

// src/timelines/components/TimelineRow.tsx
import { jsx as jsx58, jsxs as jsxs39 } from "react/jsx-runtime";
var TimelineRow = ({
  item,
  renderItem: renderItem3,
  instances,
  renderInstance
}) => {
  const instanceRows = instances.map((i4) => renderInstance(i4));
  return /* @__PURE__ */ jsxs39("div", { className: "flex items-center", children: [
    /* @__PURE__ */ jsx58("div", { className: "relative mr-4 flex w-32 items-center justify-end overflow-hidden border-r px-2 sm:w-64", children: renderItem3(item) }),
    /* @__PURE__ */ jsx58("div", { className: "relative flex h-4 flex-1 items-center py-2", children: instanceRows })
  ] });
};

// src/timelines/components/TimelineRowSet.tsx
import { jsx as jsx59 } from "react/jsx-runtime";
var TimelineRowSet = ({
  set,
  renderItem: renderItem3,
  renderInstance
}) => {
  const context = useTimelineContext();
  const rows = (context.items[set] || []).map(
    (positioned) => {
      return /* @__PURE__ */ jsx59("div", { className: "block", children: /* @__PURE__ */ jsx59(
        TimelineRow,
        {
          item: positioned.item,
          renderItem: renderItem3,
          instances: positioned.instances,
          renderInstance
        }
      ) }, positioned.item.id + positioned.key);
    }
  );
  return /* @__PURE__ */ jsx59("div", { className: "my-4 block overflow-hidden border-b border-gray-100 pb-2", children: rows });
};

// src/timelines/components/TimelineItemView.tsx
import { useCallback as useCallback30 } from "react";
import { jsx as jsx60, jsxs as jsxs40 } from "react/jsx-runtime";
var TimelineItemView = ({ item, onSelect }) => {
  const onClick = useCallback30(() => {
    if (onSelect) {
      onSelect(item);
    }
  }, []);
  return /* @__PURE__ */ jsxs40(
    "div",
    {
      title: item.description,
      onClick,
      className: "text-primary-500 flex cursor-pointer items-center px-2 py-1",
      children: [
        item.isSelectable && /* @__PURE__ */ jsx60("a", { className: "cursor-pointer truncate lowercase underline", children: item.name }),
        !item.isSelectable && /* @__PURE__ */ jsx60("p", { className: "truncate lowercase", children: item.name })
      ]
    }
  );
};

// src/profile-search/lib/ProfileSearch.ts
import { useCallback as useCallback31 } from "react";
import { atomWithStorage } from "jotai/utils";
import { atom as atom2, useAtom } from "jotai";
import { atomWithLocation } from "jotai-location";
import { createClientMutationId as createClientMutationId18 } from "shared-lib";
import { SortDir, sortDirToGraphQL } from "shared-ui";

// src/profile-search/mutations/__generated__/UseRecommendVacancyToProfilesMutation.graphql.ts
var node77 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": "result",
    "args": null,
    "concreteType": "RecruitRecommendCandidatesResult",
    "kind": "LinkedField",
    "name": "recruitRecommendCandidatesResult",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "vacancyId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitRecommendCandidateResult",
        "kind": "LinkedField",
        "name": "results",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "candidateId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v32 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseRecommendVacancyToProfilesMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitRecommendationVacancyToProfilesPayload",
          "kind": "LinkedField",
          "name": "recruitRecommendationVacancyToProfiles",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseRecommendVacancyToProfilesMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitRecommendationVacancyToProfilesPayload",
          "kind": "LinkedField",
          "name": "recruitRecommendationVacancyToProfiles",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "2fe399d6e761a6c5fc177766b384eb06",
      "id": null,
      "metadata": {},
      "name": "UseRecommendVacancyToProfilesMutation",
      "operationKind": "mutation",
      "text": "mutation UseRecommendVacancyToProfilesMutation(\n  $input: RecruitRecommendationVacancyToProfilesInput!\n) {\n  result: recruitRecommendationVacancyToProfiles(input: $input) {\n    result: recruitRecommendCandidatesResult {\n      vacancyId\n      results {\n        candidateId\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node77.hash = "8da79ea702f79ee714fd8be9ee57731c";
var UseRecommendVacancyToProfilesMutation_graphql_default = node77;

// src/profile-search/mutations/UseRecommendVacancyToProfiles.ts
import { useAsyncMutation as useAsyncMutation10 } from "shared-lib";
var mutationDef17 = UseRecommendVacancyToProfilesMutation_graphql_default;
function useRecommendVacancyToProfiles() {
  const [commit11, isBusy] = useAsyncMutation10(mutationDef17);
  return [commit11, isBusy];
}

// src/profile-search/lib/ProfileSearch.ts
var facetLabels = {
  countries: "Countries",
  companies: "Companies",
  cities: "Cities",
  currentCompanies: "Current Companies",
  currentCountries: "Current Countries",
  currentCities: "Current Cities",
  escoLevel1: "Esco Level 1",
  escoLevel2: "Esco Level 2",
  escoLevel3: "Esco Level 3",
  escoLevel4: "Esco Level 4",
  escoLevel5: "Esco Level 5",
  educationTitle: "Education Title",
  educationInstitution: "Education Institution",
  industries: "Industries",
  lastExperienceYear: "Latest Experience",
  sourceTypes: "Source Types",
  skills: "Skills"
};
var defaultFilterState = {
  filters: {
    countries: [],
    cities: [],
    currentCompanies: [],
    currentCountries: [],
    currentCities: [],
    educationInstitution: [],
    educationTitle: [],
    lastExperienceYear: [],
    sourceTypes: [],
    talentPools: [],
    standard: {
      escoLevel1: [],
      escoLevel2: [],
      escoLevel3: [],
      escoLevel4: [],
      escoLevel5: [],
      industries: [],
      companies: [],
      skills: []
    }
  },
  sort: {
    field: { standard: "BEST_MATCH" },
    order: "DESC"
  }
};
var ProfileSortFieldType = /* @__PURE__ */ ((ProfileSortFieldType2) => {
  ProfileSortFieldType2["BEST_MATCH"] = "BEST_MATCH";
  ProfileSortFieldType2["NAME"] = "NAME";
  ProfileSortFieldType2["LAST_EXPERIENCE_YEAR"] = "LAST_EXPERIENCE_YEAR";
  return ProfileSortFieldType2;
})(ProfileSortFieldType || {});
var profileSearchSortFields = [
  {
    id: "BEST_MATCH" /* BEST_MATCH */,
    name: "Sort by 'Rank'"
  },
  {
    id: "NAME" /* NAME */,
    name: "Sort by 'Name'"
  },
  {
    id: "LAST_EXPERIENCE_YEAR" /* LAST_EXPERIENCE_YEAR */,
    name: "Sort by 'Recency'"
  }
];
function profileSortFieldToGraphQL(sort) {
  switch (sort) {
    case "BEST_MATCH" /* BEST_MATCH */: {
      return {
        standard: "BEST_MATCH"
      };
    }
    case "NAME" /* NAME */: {
      return {
        standard: "NAME"
      };
    }
    case "LAST_EXPERIENCE_YEAR" /* LAST_EXPERIENCE_YEAR */: {
      return {
        custom: "LAST_EXPERIENCE_YEAR"
      };
    }
  }
}
var defaultValues = {
  filters: {},
  pagination: {
    pageNumber: 1,
    pageSize: 10
  },
  sort: {
    field: profileSortFieldToGraphQL("BEST_MATCH" /* BEST_MATCH */),
    order: sortDirToGraphQL(SortDir.Desc)
  }
};
var locationAtom = atomWithLocation();
var profileSearchAtom = atom2(
  (get) => {
    const searchParams = get(locationAtom).searchParams?.get("q");
    if (!searchParams) {
      return defaultValues;
    }
    return JSON.parse(atob(searchParams));
  },
  (get, set, input) => {
    set(locationAtom, (prev) => ({
      ...prev,
      searchParams: new URLSearchParams([
        ["q", btoa(JSON.stringify(input.payload))]
      ])
    }));
  }
);
var profileSearchContextAtom = atomWithStorage(
  "myn-profile-search",
  {
    isFiltersOpen: false,
    isSent: false,
    isSending: false,
    isSendFormOpen: false,
    sendMessage: null,
    selectedProfileIds: [],
    selectedVacancy: null
  }
);
function useRecommendVacancy() {
  const [context, setContext] = useAtom(profileSearchContextAtom);
  const [recommend, isRecommending] = useRecommendVacancyToProfiles();
  const onRecommendVacancy = useCallback31(async () => {
    if (!context || !context.selectedVacancy || !context.selectedProfileIds || context.selectedProfileIds.length === 0) {
      return;
    }
    const input = {
      clientMutationId: createClientMutationId18(),
      vacancyId: context.selectedVacancy.vacancyId,
      coveringLetter: context.sendMessage || "",
      profiles: context.selectedProfileIds
    };
    const response = await recommend({ input });
    if (response.result.result) {
      setContext({
        ...context,
        isSent: true,
        isSending: false,
        selectedProfileIds: []
      });
    }
  }, [context, setContext, recommend]);
  return [onRecommendVacancy, isRecommending];
}

// src/profiles/edit/components/ProfileSearchResultTimeline.tsx
import { Fragment as Fragment15, jsx as jsx61, jsxs as jsxs41 } from "react/jsx-runtime";
var fragmentDef23 = ProfileSearchResultTimeline_profile_graphql_default;
function renderCompanyInstance(positioned, onSelect) {
  const left = `${positioned.context.startPercentage}%`;
  const width = `${positioned.context.widthPercentage}%`;
  const title = `${positioned.instance.name} - ${timeAgo(
    positioned.instance.start
  )} to ${timeAgo(positioned.instance.end)} `;
  return /* @__PURE__ */ jsx61(
    "div",
    {
      title,
      onClick: () => onSelect(positioned.instance.id),
      style: { left, width },
      className: 'text-primary-500 hover:font-bold" absolute cursor-pointer truncate rounded-lg border border-gray-100 bg-yellow-50 p-2 text-center text-sm font-medium uppercase underline',
      children: positioned.instance.name
    },
    positioned.instance.uniqueKey
  );
}
function renderSkillInstance(positioned, prefix) {
  const left = `${positioned.context.startPercentage}%`;
  const width = `${positioned.context.widthPercentage}%`;
  const relevance = positioned.instance;
  let highlightClasses = "";
  if (relevance.isRelevant) {
    highlightClasses = "h-6 bg-green-600";
  } else if (relevance.isUnknown) {
    highlightClasses = "h-6 bg-gray-300";
  } else if (relevance.isNotRelevant) {
    highlightClasses = "h-4";
  } else {
    highlightClasses = "h-6 bg-green-600";
  }
  const title = `${positioned.instance.name} - ${timeAgo(
    positioned.instance.start
  )} to ${timeAgo(positioned.instance.end)} `;
  return /* @__PURE__ */ jsx61(
    "div",
    {
      title,
      style: { left, width },
      className: classNames6(
        "absolute",
        highlightClasses,
        "rounded-lg border-2 border-gray-100"
      )
    },
    `${prefix}-${title}`
  );
}
function renderItem(item, onSelect) {
  return /* @__PURE__ */ jsx61(TimelineItemView, { item, onSelect });
}
var ProfileSearchResultTimeline = ({ fragmentRef }) => {
  const [searchInput] = useAtom2(profileSearchAtom);
  const data = useFragment26(
    fragmentDef23,
    fragmentRef
  );
  const hasFilters = searchInput.filters?.standard?.skills?.length && searchInput.filters?.standard?.skills?.length > 0;
  const sourceItemSets = useMemo10(() => {
    return buildProfileTimelineSets(buildProfileModel(data), {
      items: searchInput.filters?.standard?.skills?.map((x4) => ({
        selected: true,
        name: x4.skillId
      }))
    });
  }, [data, searchInput.filters?.standard?.skills]);
  const topSkills = useMemo10(() => {
    const profileModel = buildProfileModel(data);
    if (profileModel) {
      return buildProfileTopSkillsTimeline(
        profileModel.skills,
        profileModel.skillsIndex
      );
    }
    return [];
  }, [data]);
  if (!data) {
    return /* @__PURE__ */ jsx61(Fragment15, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsxs41(Suspense12, { fallback: /* @__PURE__ */ jsx61(EdSkeleton7, {}), children: [
    /* @__PURE__ */ jsx61("div", { className: "flex flex-col gap-2 p-2 xl:hidden", children: /* @__PURE__ */ jsx61(
      EdTable,
      {
        defaultColumns: [
          {
            id: "1",
            name: "Top Skills"
          }
        ],
        rows: topSkills.map((skill) => /* @__PURE__ */ jsxs41(EdRow, { children: [
          /* @__PURE__ */ jsx61(EdColumnCell, { className: "font-bold", children: /* @__PURE__ */ jsx61("div", { className: "flex flex-col", children: /* @__PURE__ */ jsx61("span", { children: skill.name }) }) }),
          /* @__PURE__ */ jsx61(EdColumnCell, { className: "flex justify-end self-end text-right", children: /* @__PURE__ */ jsx61("div", { className: classNames6("text-green-500"), children: /* @__PURE__ */ jsx61(
            SignalBar,
            {
              signalSize: SignalBarSize.signalBar5,
              iconSize: "sm"
            }
          ) }) })
        ] }, skill.name))
      }
    ) }),
    /* @__PURE__ */ jsx61("div", { className: "hidden border bg-white p-4 xl:block", children: /* @__PURE__ */ jsxs41(TimelineProvider, { sourceItemSets, children: [
      /* @__PURE__ */ jsx61(TimelineHeader, {}),
      /* @__PURE__ */ jsx61(
        TimelineRowSet,
        {
          renderInstance: (i4) => renderCompanyInstance(i4, noop5),
          renderItem,
          set: "company"
        }
      ),
      !hasFilters && /* @__PURE__ */ jsx61(
        TimelineRowSet,
        {
          renderInstance: (i4) => renderSkillInstance(i4, "topSkills"),
          renderItem,
          set: "topSkills"
        }
      ),
      hasFilters && /* @__PURE__ */ jsx61(
        TimelineRowSet,
        {
          renderInstance: (i4) => renderSkillInstance(i4, "filteredSkills"),
          renderItem,
          set: "filteredSkills"
        }
      )
    ] }) })
  ] });
};

// src/profiles/lib/CompaniesTimeline.ts
function buildProfileCompanyTimeline(profileId, experience, source) {
  const instances = experience.map((position) => {
    return {
      uniqueKey: `company-${position.candidateExperienceId}`,
      type: "Company",
      id: position.candidateExperienceId.toString(),
      name: position.companyName,
      description: `${position.title} at ${position.companyName}`,
      start: position.startDate,
      end: position.endDate,
      source: { position }
    };
  });
  return {
    type: "Company",
    id: profileId,
    name: "Companies",
    description: "Companies",
    isSelectable: false,
    instances,
    source
  };
}

// src/profiles/lib/ProfileModel.ts
import { parseDate as parseDate8 } from "shared-lib";
function buildProfileModel(profile) {
  if (profile === null || profile === void 0) {
    return null;
  }
  const experience = profile.experiences.items.map((e4) => {
    return {
      ...e4,
      startDate: parseDate8(e4.startDate),
      endDate: parseDate8(e4.endDate)
    };
  });
  return {
    id: profile.id,
    experience,
    skills: profile.experiences.skills.map((s4) => {
      return {
        ...s4,
        lastUsed: parseDate8(s4.lastUsed),
        periods: s4.periods.map((p4) => {
          const startDate = parseDate8(p4.startDate);
          const endDate = parseDate8(p4.endDate);
          return {
            ...p4,
            startDate,
            endDate,
            durationMonths: calculateDuration(startDate, endDate)
          };
        })
      };
    }),
    skillsIndex: createIndex(experience)
  };
}
function calculateDuration(startDate, endDate) {
  const years = (endDate.getFullYear() - startDate.getFullYear()) * 12;
  const months = endDate.getMonth() - startDate.getMonth();
  return years + months;
}
function createIndex(experience) {
  return experience.reduce((dict, item) => {
    (item.skills || []).forEach((s4) => {
      let skillIndex = dict[s4];
      if (!skillIndex) {
        skillIndex = dict[s4] = [];
      }
      skillIndex.push(item);
    });
    return dict;
  }, {});
}

// src/profiles/lib/SkillsTimelines.ts
function createSkillTimelineItem(skill, skillsIndex) {
  const index2 = skillsIndex[skill.name];
  const instances = index2.map((position) => {
    return {
      uniqueKey: `skill-${skill.skillId}`,
      type: "Skill",
      id: skill.skillId.toString(),
      name: position.title,
      description: `${position.title} at ${position.companyName}`,
      start: position.startDate,
      end: position.endDate,
      source: { position, skill }
    };
  });
  return {
    type: "Skill",
    id: skill.skillId.toString(),
    name: skill.name,
    description: skill.name,
    isSelectable: true,
    instances,
    source: skill
  };
}
function buildProfileTopSkillsTimeline(skills, skillsIndex) {
  const items = [...skills].sort((a4, b3) => b3.totalMonthsUsed - a4.totalMonthsUsed).slice(0, Math.min(10, skills.length)).map((skill) => {
    return createSkillTimelineItem(skill, skillsIndex);
  });
  return items;
}
function buildProfileFilteredSkillsTimeline(skills, skillsIndex, skillNames) {
  if (!skillNames || skillNames.length === 0) {
    return [];
  }
  const items = skills.filter((s4) => skillNames.some((id18) => id18 == String(s4.skillId))).map((skill) => {
    return createSkillTimelineItem(skill, skillsIndex);
  });
  return items;
}

// src/profiles/lib/ProfileTimelines.ts
function buildProfileTimelineSets(profile, filter2) {
  if (profile === null) {
    return {};
  }
  const company = buildProfileCompanyTimeline(profile.id, profile.experience, {
    profile
  });
  const topSkills = buildProfileTopSkillsTimeline(
    profile.skills,
    profile.skillsIndex
  );
  let skillNames = [];
  let filteredSkills = [];
  if (filter2 && filter2.items) {
    skillNames = filter2.items.map((i4) => i4.name);
    filteredSkills = buildProfileFilteredSkillsTimeline(
      profile.skills,
      profile.skillsIndex,
      skillNames
    );
    console.log(`Found ${filteredSkills.length} Filtered Skills`);
  }
  const timeline = {
    company: [company],
    topSkills,
    filteredSkills
  };
  return timeline;
}

// src/profiles/list/components/__generated__/RecruitProfileHeader_profile.graphql.ts
var node78 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RecruitProfileHeader_profile",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RecruitProfileApplicationHeader_application"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recruitProfileId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profileType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RecruitProfileWorkLocations",
      "kind": "LinkedField",
      "name": "workLocations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currentLocationName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currentLocationCountryName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AccountsCandidateAccount",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accountId",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RecruitProfileExperience",
      "kind": "LinkedField",
      "name": "currentPosition",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "companyName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endDate",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RecruitProfileRate",
      "kind": "LinkedField",
      "name": "rate",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "payType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "minimumRateOfPay",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "maximumRateOfPay",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "countryCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currencyCode",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RightToWork",
      "kind": "LinkedField",
      "name": "rightToWork",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RecruitProfileAvailability",
      "kind": "LinkedField",
      "name": "availability",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "jobSearchStatus",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RecruitProfile",
  "abstractKey": null
};
node78.hash = "4f450ea75bc23d57354aa73d0cb00a98";
var RecruitProfileHeader_profile_graphql_default = node78;

// src/profiles/list/components/RecruitProfileHeader.tsx
import { Suspense as Suspense126, createContext as createContext13, useCallback as useCallback198 } from "react";
import { useFragment as useFragment111 } from "react-relay";
import { useAtom as useAtom25 } from "jotai";
import { SwitchInputComponent as SwitchInputComponent3 } from "shared-ui";

// src/profile-search/components/__generated__/ProfileQuery.graphql.ts
var node79 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "code"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 1
    },
    {
      "fields": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "eq",
              "variableName": "code"
            }
          ],
          "kind": "ObjectValue",
          "name": "code"
        }
      ],
      "kind": "ObjectValue",
      "name": "where"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "emailAddress",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateExperienceId",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyName",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "startDate",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "endDate",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyIsVerified",
    "storageKey": null
  }, v14 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyId",
    "storageKey": null
  }, v15 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  }, v16 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "skills",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ProfileQuery",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "RecruitProfilesConnection",
          "kind": "LinkedField",
          "name": "recruitProfiles",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfile",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                v23,
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "Profile_profile"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ProfileQuery",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "RecruitProfilesConnection",
          "kind": "LinkedField",
          "name": "recruitProfiles",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfile",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                v23,
                v32,
                v4,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "recruitProfileId",
                  "storageKey": null
                },
                v5,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitCandidateProfileNote",
                  "kind": "LinkedField",
                  "name": "notes",
                  "plural": true,
                  "selections": [
                    v23,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "content",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitCandidateProfileNoteTag",
                      "kind": "LinkedField",
                      "name": "tags",
                      "plural": true,
                      "selections": [
                        v6,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "value",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountsUser",
                      "kind": "LinkedField",
                      "name": "createdByUser",
                      "plural": false,
                      "selections": [
                        v5,
                        v32,
                        v4
                      ],
                      "storageKey": null
                    },
                    v7
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsCandidateAccount",
                  "kind": "LinkedField",
                  "name": "account",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "accountId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CandidatePhoneVerification",
                      "kind": "LinkedField",
                      "name": "phone",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "phoneVerificationStatus",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "phoneNumber",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "phoneCountryPrefix",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    v7
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperience",
                  "kind": "LinkedField",
                  "name": "experience",
                  "plural": true,
                  "selections": [
                    v7,
                    v8,
                    v9,
                    v10,
                    v11,
                    v12,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "version",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "titleId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "industry",
                      "storageKey": null
                    },
                    v13,
                    v14,
                    v15,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "positionType",
                      "storageKey": null
                    },
                    v16,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "escoOccupationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "escoHierarchy",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                v7,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileWorkLocations",
                  "kind": "LinkedField",
                  "name": "workLocations",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currentLocationName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currentLocationCountryName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "WorkLocationEntry",
                      "kind": "LinkedField",
                      "name": "workLocations",
                      "plural": true,
                      "selections": [
                        v6
                      ],
                      "storageKey": null
                    },
                    v7
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperience",
                  "kind": "LinkedField",
                  "name": "currentPosition",
                  "plural": false,
                  "selections": [
                    v9,
                    v10,
                    v11,
                    v12,
                    v7
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileRate",
                  "kind": "LinkedField",
                  "name": "rate",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "payType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "minimumRateOfPay",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "maximumRateOfPay",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "countryCode",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currencyCode",
                      "storageKey": null
                    },
                    v7
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileAvailability",
                  "kind": "LinkedField",
                  "name": "availability",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobSearchStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "availabilityStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "NoticeCriteria",
                      "kind": "LinkedField",
                      "name": "noticeCriteria",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "availableFrom",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "noticePeriodWeeks",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "noticeTimeframe",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    v7
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "profileType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RightToWork",
                  "kind": "LinkedField",
                  "name": "rightToWork",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    v7
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperienceCollection",
                  "kind": "LinkedField",
                  "name": "experiences",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileExperience",
                      "kind": "LinkedField",
                      "name": "items",
                      "plural": true,
                      "selections": [
                        v7,
                        v8,
                        v9,
                        v14,
                        v13,
                        v10,
                        v15,
                        v11,
                        v12,
                        v16
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "SkillUsage",
                      "kind": "LinkedField",
                      "name": "skills",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "skillId",
                          "storageKey": null
                        },
                        v6,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "totalMonthsUsed",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "averageMonthsUsed",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "totalPositionsUsed",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "lastUsed",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "DateRange",
                          "kind": "LinkedField",
                          "name": "periods",
                          "plural": true,
                          "selections": [
                            v11,
                            v12
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "f109aa4e6811a909ae6baf990ec92f29",
      "id": null,
      "metadata": {},
      "name": "ProfileQuery",
      "operationKind": "query",
      "text": "query ProfileQuery(\n  $code: Long\n) {\n  recruitProfiles(where: {code: {eq: $code}}, first: 1) {\n    nodes {\n      code\n      ...Profile_profile\n      id\n    }\n  }\n}\n\nfragment ExperienceDetails_experience on RecruitProfileExperience {\n  id\n  createdOn\n  updatedOn\n  candidateExperienceId\n  version\n  titleId\n  title\n  industry\n  companyIsVerified\n  companyId\n  companyName\n  description\n  startDate\n  endDate\n  positionType\n  skills\n  escoOccupationId\n  escoHierarchy\n}\n\nfragment ProfileSearchResultTimeline_profile on RecruitProfile {\n  id\n  experiences {\n    items {\n      id\n      candidateExperienceId\n      title\n      companyId\n      companyIsVerified\n      companyName\n      description\n      startDate\n      endDate\n      skills\n    }\n    skills {\n      skillId\n      name\n      totalMonthsUsed\n      averageMonthsUsed\n      totalPositionsUsed\n      lastUsed\n      periods {\n        startDate\n        endDate\n      }\n    }\n  }\n}\n\nfragment Profile_profile on RecruitProfile {\n  code\n  firstName\n  lastName\n  recruitProfileId\n  emailAddress\n  notes {\n    code\n    content\n    tags {\n      name\n      value\n    }\n    updatedAt\n    createdByUser {\n      emailAddress\n      firstName\n      lastName\n    }\n    id\n  }\n  account {\n    accountId\n    phone {\n      phoneVerificationStatus\n      phoneNumber\n      phoneCountryPrefix\n    }\n    id\n  }\n  experience {\n    id\n    candidateExperienceId\n    title\n    companyName\n    startDate\n    endDate\n    ...ExperienceDetails_experience\n  }\n  ...RecruitProfileHeader_profile\n  ...ProfileSearchResultTimeline_profile\n}\n\nfragment RecruitProfileApplicationHeader_application on RecruitProfile {\n  id\n  firstName\n  lastName\n  workLocations {\n    currentLocationName\n    currentLocationCountryName\n    workLocations {\n      name\n    }\n    id\n  }\n  currentPosition {\n    title\n    companyName\n    startDate\n    endDate\n    id\n  }\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n  availability {\n    jobSearchStatus\n    availabilityStatus\n    noticeCriteria {\n      availableFrom\n      noticePeriodWeeks\n      noticeTimeframe\n    }\n    id\n  }\n}\n\nfragment RecruitProfileHeader_profile on RecruitProfile {\n  ...RecruitProfileApplicationHeader_application\n  id\n  recruitProfileId\n  firstName\n  lastName\n  profileType\n  workLocations {\n    currentLocationName\n    currentLocationCountryName\n    id\n  }\n  account {\n    accountId\n    id\n  }\n  currentPosition {\n    title\n    companyName\n    startDate\n    endDate\n    id\n  }\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n  rightToWork {\n    status\n    id\n  }\n  availability {\n    jobSearchStatus\n    id\n  }\n}\n"
    }
  };
}();
node79.hash = "547bd3e1cfc9c2eb9f5f09ac8fb405ce";
var ProfileQuery_graphql_default = node79;

// src/profile-search/components/__generated__/Profile_profile.graphql.ts
var node80 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "emailAddress",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "Profile_profile",
    "selections": [
      v0,
      v1,
      v23,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "recruitProfileId",
        "storageKey": null
      },
      v32,
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitCandidateProfileNote",
        "kind": "LinkedField",
        "name": "notes",
        "plural": true,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "content",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitCandidateProfileNoteTag",
            "kind": "LinkedField",
            "name": "tags",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountsUser",
            "kind": "LinkedField",
            "name": "createdByUser",
            "plural": false,
            "selections": [
              v32,
              v1,
              v23
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsCandidateAccount",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CandidatePhoneVerification",
            "kind": "LinkedField",
            "name": "phone",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneVerificationStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneCountryPrefix",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitProfileExperience",
        "kind": "LinkedField",
        "name": "experience",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "candidateExperienceId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "companyName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "endDate",
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ExperienceDetails_experience"
          }
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "RecruitProfileHeader_profile"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "ProfileSearchResultTimeline_profile"
      }
    ],
    "type": "RecruitProfile",
    "abstractKey": null
  };
}();
node80.hash = "f2dc94d30c66ab7d02d70834278b8801";
var Profile_profile_graphql_default = node80;

// src/profile-search/components/Profile.tsx
import { Suspense as Suspense120, useState as useState95 } from "react";
import { useFragment as useFragment104, useLazyLoadQuery as useLazyLoadQuery49 } from "react-relay";
import { useParams as useParams11 } from "react-router-dom";
import { useLocation as useLocation6 } from "react-router-dom";
import { formatMonth as formatMonth4 } from "shared-lib";
import {
  Breadcrumbs as Breadcrumbs6,
  Button as Button85,
  classNames as classNames38,
  createLinkState as createLinkState6,
  Loading as Loading10,
  Size as Size43,
  Tag as Tag23
} from "shared-ui";

// src/shared/components/__generated__/DetailsComponent_profile.graphql.ts
var node81 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DetailsComponent_profile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recruitProfileId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RecruitResume",
      "kind": "LinkedField",
      "name": "resume",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bucket",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "resumeId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fileKey",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fileName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "filePath",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RecruitProfile",
  "abstractKey": null
};
node81.hash = "34e3d36dc1c93ebb4e9fa4be6f4c91cd";
var DetailsComponent_profile_graphql_default = node81;

// src/shared/components/__generated__/DetailsComponent_candidate.graphql.ts
var node82 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DetailsComponent_candidate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CandidatePhoneVerification",
      "kind": "LinkedField",
      "name": "phone",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phoneNumber",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phoneCountryPrefix",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phoneVerificationStatus",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AccountsCandidateAccount",
  "abstractKey": null
};
node82.hash = "c71904126a14569be9101e9155086e57";
var DetailsComponent_candidate_graphql_default = node82;

// src/shared/components/DetailsComponent.tsx
import { useFragment as useFragment27 } from "react-relay";
import { jsx as jsx62, jsxs as jsxs42 } from "react/jsx-runtime";
var fragments2 = {
  profile: DetailsComponent_profile_graphql_default,
  candidate: DetailsComponent_candidate_graphql_default
};
var DetailsComponent = ({ profileFragmentRef, candidateFragmentRef }) => {
  const profile = useFragment27(
    fragments2.profile,
    profileFragmentRef
  );
  const candidate = useFragment27(
    fragments2.candidate,
    candidateFragmentRef
  );
  return /* @__PURE__ */ jsx62("div", { className: "p-5", children: /* @__PURE__ */ jsx62(
    Info,
    {
      fullName: `${candidate.firstName} ${candidate.lastName}`,
      emailAddress: candidate.email,
      phone: candidate.phone,
      profileId: profile.recruitProfileId
    }
  ) });
};
function Info({
  fullName,
  emailAddress,
  phone,
  profileId
}) {
  return /* @__PURE__ */ jsxs42("div", { className: "overflow-hidden bg-white shadow sm:rounded-lg", children: [
    /* @__PURE__ */ jsxs42("div", { className: "px-4 py-6 sm:px-6", children: [
      /* @__PURE__ */ jsx62("h3", { className: "text-base font-semibold leading-7 text-gray-900", children: "Applicant Information" }),
      /* @__PURE__ */ jsx62("p", { className: "mt-1 max-w-2xl text-sm leading-6 text-gray-500", children: "Personal details and application." })
    ] }),
    /* @__PURE__ */ jsx62("div", { className: "border-t border-gray-100", children: /* @__PURE__ */ jsxs42("dl", { className: "divide-y divide-gray-100", children: [
      /* @__PURE__ */ jsxs42("div", { className: "px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6", children: [
        /* @__PURE__ */ jsx62("dt", { className: "text-sm font-medium text-gray-900", children: "Full Name" }),
        /* @__PURE__ */ jsx62("dd", { className: "mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0", children: fullName })
      ] }),
      /* @__PURE__ */ jsxs42("div", { className: "px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6", children: [
        /* @__PURE__ */ jsx62("dt", { className: "text-sm font-medium text-gray-900", children: "Email address" }),
        /* @__PURE__ */ jsx62("dd", { className: "mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0", children: emailAddress })
      ] }),
      /* @__PURE__ */ jsxs42("div", { className: "px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6", children: [
        /* @__PURE__ */ jsx62("dt", { className: "text-sm font-medium text-gray-900", children: "Phone Number" }),
        /* @__PURE__ */ jsx62("dd", { className: "mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0", children: phone.phoneVerificationStatus === "VERIFIED" && phone.phoneNumber ? `(+${phone.phoneCountryPrefix}) ${phone.phoneNumber}` : "Not verified" })
      ] })
    ] }) })
  ] });
}

// src/profile-search/components/__generated__/ProfileNotesQuery.graphql.ts
var node83 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "code"
    }
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "emailAddress",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateExperienceId",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyName",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "startDate",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "endDate",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyIsVerified",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyId",
    "storageKey": null
  }, v14 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  }, v15 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "skills",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ProfileNotesQuery",
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "code",
              "variableName": "code"
            }
          ],
          "kind": "FragmentSpread",
          "name": "ProfileNotes_profile"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ProfileNotesQuery",
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 1
            },
            {
              "fields": [
                {
                  "fields": [
                    {
                      "kind": "Variable",
                      "name": "eq",
                      "variableName": "code"
                    }
                  ],
                  "kind": "ObjectValue",
                  "name": "code"
                }
              ],
              "kind": "ObjectValue",
              "name": "where"
            }
          ],
          "concreteType": "RecruitProfilesConnection",
          "kind": "LinkedField",
          "name": "recruitProfiles",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfile",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                v1,
                v23,
                v32,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "recruitProfileId",
                  "storageKey": null
                },
                v4,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitCandidateProfileNote",
                  "kind": "LinkedField",
                  "name": "notes",
                  "plural": true,
                  "selections": [
                    v1,
                    {
                      "alias": "noteId",
                      "args": null,
                      "kind": "ScalarField",
                      "name": "candidateProfileNoteId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "content",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitCandidateProfileNoteTag",
                      "kind": "LinkedField",
                      "name": "tags",
                      "plural": true,
                      "selections": [
                        v5,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "value",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountsUser",
                      "kind": "LinkedField",
                      "name": "createdByUser",
                      "plural": false,
                      "selections": [
                        v4,
                        v23,
                        v32
                      ],
                      "storageKey": null
                    },
                    v6
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsCandidateAccount",
                  "kind": "LinkedField",
                  "name": "account",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CandidatePhoneVerification",
                      "kind": "LinkedField",
                      "name": "phone",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "phoneVerificationStatus",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "phoneNumber",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "phoneCountryPrefix",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    v6,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "accountId",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperience",
                  "kind": "LinkedField",
                  "name": "experience",
                  "plural": true,
                  "selections": [
                    v6,
                    v7,
                    v8,
                    v9,
                    v10,
                    v11,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "version",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "titleId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "industry",
                      "storageKey": null
                    },
                    v12,
                    v13,
                    v14,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "positionType",
                      "storageKey": null
                    },
                    v15,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "escoOccupationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "escoHierarchy",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                v6,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileWorkLocations",
                  "kind": "LinkedField",
                  "name": "workLocations",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currentLocationName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currentLocationCountryName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "WorkLocationEntry",
                      "kind": "LinkedField",
                      "name": "workLocations",
                      "plural": true,
                      "selections": [
                        v5
                      ],
                      "storageKey": null
                    },
                    v6
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperience",
                  "kind": "LinkedField",
                  "name": "currentPosition",
                  "plural": false,
                  "selections": [
                    v8,
                    v9,
                    v10,
                    v11,
                    v6
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileRate",
                  "kind": "LinkedField",
                  "name": "rate",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "payType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "minimumRateOfPay",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "maximumRateOfPay",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "countryCode",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currencyCode",
                      "storageKey": null
                    },
                    v6
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileAvailability",
                  "kind": "LinkedField",
                  "name": "availability",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobSearchStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "availabilityStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "NoticeCriteria",
                      "kind": "LinkedField",
                      "name": "noticeCriteria",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "availableFrom",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "noticePeriodWeeks",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "noticeTimeframe",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    v6
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "profileType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RightToWork",
                  "kind": "LinkedField",
                  "name": "rightToWork",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    v6
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperienceCollection",
                  "kind": "LinkedField",
                  "name": "experiences",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileExperience",
                      "kind": "LinkedField",
                      "name": "items",
                      "plural": true,
                      "selections": [
                        v6,
                        v7,
                        v8,
                        v13,
                        v12,
                        v9,
                        v14,
                        v10,
                        v11,
                        v15
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "SkillUsage",
                      "kind": "LinkedField",
                      "name": "skills",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "skillId",
                          "storageKey": null
                        },
                        v5,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "totalMonthsUsed",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "averageMonthsUsed",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "totalPositionsUsed",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "lastUsed",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "DateRange",
                          "kind": "LinkedField",
                          "name": "periods",
                          "plural": true,
                          "selections": [
                            v10,
                            v11
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "c3ec93329be60be4aee14aee9c31f5e1",
      "id": null,
      "metadata": {},
      "name": "ProfileNotesQuery",
      "operationKind": "query",
      "text": "query ProfileNotesQuery(\n  $code: Long\n) {\n  ...ProfileNotes_profile_4d58ER\n}\n\nfragment ExperienceDetails_experience on RecruitProfileExperience {\n  id\n  createdOn\n  updatedOn\n  candidateExperienceId\n  version\n  titleId\n  title\n  industry\n  companyIsVerified\n  companyId\n  companyName\n  description\n  startDate\n  endDate\n  positionType\n  skills\n  escoOccupationId\n  escoHierarchy\n}\n\nfragment ProfileNotes_profile_4d58ER on Query {\n  recruitProfiles(where: {code: {eq: $code}}, first: 1) {\n    nodes {\n      code\n      firstName\n      lastName\n      recruitProfileId\n      emailAddress\n      notes {\n        code\n        noteId: candidateProfileNoteId\n        content\n        tags {\n          name\n          value\n        }\n        updatedAt\n        createdByUser {\n          emailAddress\n          firstName\n          lastName\n        }\n        id\n      }\n      account {\n        phone {\n          phoneVerificationStatus\n          phoneNumber\n          phoneCountryPrefix\n        }\n        id\n      }\n      experience {\n        id\n        candidateExperienceId\n        title\n        companyName\n        startDate\n        endDate\n        ...ExperienceDetails_experience\n      }\n      ...RecruitProfileHeader_profile\n      ...ProfileSearchResultTimeline_profile\n      id\n    }\n  }\n}\n\nfragment ProfileSearchResultTimeline_profile on RecruitProfile {\n  id\n  experiences {\n    items {\n      id\n      candidateExperienceId\n      title\n      companyId\n      companyIsVerified\n      companyName\n      description\n      startDate\n      endDate\n      skills\n    }\n    skills {\n      skillId\n      name\n      totalMonthsUsed\n      averageMonthsUsed\n      totalPositionsUsed\n      lastUsed\n      periods {\n        startDate\n        endDate\n      }\n    }\n  }\n}\n\nfragment RecruitProfileApplicationHeader_application on RecruitProfile {\n  id\n  firstName\n  lastName\n  workLocations {\n    currentLocationName\n    currentLocationCountryName\n    workLocations {\n      name\n    }\n    id\n  }\n  currentPosition {\n    title\n    companyName\n    startDate\n    endDate\n    id\n  }\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n  availability {\n    jobSearchStatus\n    availabilityStatus\n    noticeCriteria {\n      availableFrom\n      noticePeriodWeeks\n      noticeTimeframe\n    }\n    id\n  }\n}\n\nfragment RecruitProfileHeader_profile on RecruitProfile {\n  ...RecruitProfileApplicationHeader_application\n  id\n  recruitProfileId\n  firstName\n  lastName\n  profileType\n  workLocations {\n    currentLocationName\n    currentLocationCountryName\n    id\n  }\n  account {\n    accountId\n    id\n  }\n  currentPosition {\n    title\n    companyName\n    startDate\n    endDate\n    id\n  }\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n  rightToWork {\n    status\n    id\n  }\n  availability {\n    jobSearchStatus\n    id\n  }\n}\n"
    }
  };
}();
node83.hash = "2768378514ada24aaf9fe2c9bd765b5a";
var ProfileNotesQuery_graphql_default = node83;

// src/profile-search/components/__generated__/ProfileNotesEditorPaginationQuery.graphql.ts
var node84 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "code"
    }
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "emailAddress",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateExperienceId",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyName",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "startDate",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "endDate",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyIsVerified",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyId",
    "storageKey": null
  }, v14 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  }, v15 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "skills",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ProfileNotesEditorPaginationQuery",
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "code",
              "variableName": "code"
            }
          ],
          "kind": "FragmentSpread",
          "name": "ProfileNotes_profile"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ProfileNotesEditorPaginationQuery",
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 1
            },
            {
              "fields": [
                {
                  "fields": [
                    {
                      "kind": "Variable",
                      "name": "eq",
                      "variableName": "code"
                    }
                  ],
                  "kind": "ObjectValue",
                  "name": "code"
                }
              ],
              "kind": "ObjectValue",
              "name": "where"
            }
          ],
          "concreteType": "RecruitProfilesConnection",
          "kind": "LinkedField",
          "name": "recruitProfiles",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfile",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                v1,
                v23,
                v32,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "recruitProfileId",
                  "storageKey": null
                },
                v4,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitCandidateProfileNote",
                  "kind": "LinkedField",
                  "name": "notes",
                  "plural": true,
                  "selections": [
                    v1,
                    {
                      "alias": "noteId",
                      "args": null,
                      "kind": "ScalarField",
                      "name": "candidateProfileNoteId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "content",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitCandidateProfileNoteTag",
                      "kind": "LinkedField",
                      "name": "tags",
                      "plural": true,
                      "selections": [
                        v5,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "value",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountsUser",
                      "kind": "LinkedField",
                      "name": "createdByUser",
                      "plural": false,
                      "selections": [
                        v4,
                        v23,
                        v32
                      ],
                      "storageKey": null
                    },
                    v6
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsCandidateAccount",
                  "kind": "LinkedField",
                  "name": "account",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CandidatePhoneVerification",
                      "kind": "LinkedField",
                      "name": "phone",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "phoneVerificationStatus",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "phoneNumber",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "phoneCountryPrefix",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    v6,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "accountId",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperience",
                  "kind": "LinkedField",
                  "name": "experience",
                  "plural": true,
                  "selections": [
                    v6,
                    v7,
                    v8,
                    v9,
                    v10,
                    v11,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "version",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "titleId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "industry",
                      "storageKey": null
                    },
                    v12,
                    v13,
                    v14,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "positionType",
                      "storageKey": null
                    },
                    v15,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "escoOccupationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "escoHierarchy",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                v6,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileWorkLocations",
                  "kind": "LinkedField",
                  "name": "workLocations",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currentLocationName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currentLocationCountryName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "WorkLocationEntry",
                      "kind": "LinkedField",
                      "name": "workLocations",
                      "plural": true,
                      "selections": [
                        v5
                      ],
                      "storageKey": null
                    },
                    v6
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperience",
                  "kind": "LinkedField",
                  "name": "currentPosition",
                  "plural": false,
                  "selections": [
                    v8,
                    v9,
                    v10,
                    v11,
                    v6
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileRate",
                  "kind": "LinkedField",
                  "name": "rate",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "payType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "minimumRateOfPay",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "maximumRateOfPay",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "countryCode",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currencyCode",
                      "storageKey": null
                    },
                    v6
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileAvailability",
                  "kind": "LinkedField",
                  "name": "availability",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobSearchStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "availabilityStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "NoticeCriteria",
                      "kind": "LinkedField",
                      "name": "noticeCriteria",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "availableFrom",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "noticePeriodWeeks",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "noticeTimeframe",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    v6
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "profileType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RightToWork",
                  "kind": "LinkedField",
                  "name": "rightToWork",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    v6
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperienceCollection",
                  "kind": "LinkedField",
                  "name": "experiences",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileExperience",
                      "kind": "LinkedField",
                      "name": "items",
                      "plural": true,
                      "selections": [
                        v6,
                        v7,
                        v8,
                        v13,
                        v12,
                        v9,
                        v14,
                        v10,
                        v11,
                        v15
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "SkillUsage",
                      "kind": "LinkedField",
                      "name": "skills",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "skillId",
                          "storageKey": null
                        },
                        v5,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "totalMonthsUsed",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "averageMonthsUsed",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "totalPositionsUsed",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "lastUsed",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "DateRange",
                          "kind": "LinkedField",
                          "name": "periods",
                          "plural": true,
                          "selections": [
                            v10,
                            v11
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "96d213c0d93687c9c836192c54e552a7",
      "id": null,
      "metadata": {},
      "name": "ProfileNotesEditorPaginationQuery",
      "operationKind": "query",
      "text": "query ProfileNotesEditorPaginationQuery(\n  $code: Long\n) {\n  ...ProfileNotes_profile_4d58ER\n}\n\nfragment ExperienceDetails_experience on RecruitProfileExperience {\n  id\n  createdOn\n  updatedOn\n  candidateExperienceId\n  version\n  titleId\n  title\n  industry\n  companyIsVerified\n  companyId\n  companyName\n  description\n  startDate\n  endDate\n  positionType\n  skills\n  escoOccupationId\n  escoHierarchy\n}\n\nfragment ProfileNotes_profile_4d58ER on Query {\n  recruitProfiles(where: {code: {eq: $code}}, first: 1) {\n    nodes {\n      code\n      firstName\n      lastName\n      recruitProfileId\n      emailAddress\n      notes {\n        code\n        noteId: candidateProfileNoteId\n        content\n        tags {\n          name\n          value\n        }\n        updatedAt\n        createdByUser {\n          emailAddress\n          firstName\n          lastName\n        }\n        id\n      }\n      account {\n        phone {\n          phoneVerificationStatus\n          phoneNumber\n          phoneCountryPrefix\n        }\n        id\n      }\n      experience {\n        id\n        candidateExperienceId\n        title\n        companyName\n        startDate\n        endDate\n        ...ExperienceDetails_experience\n      }\n      ...RecruitProfileHeader_profile\n      ...ProfileSearchResultTimeline_profile\n      id\n    }\n  }\n}\n\nfragment ProfileSearchResultTimeline_profile on RecruitProfile {\n  id\n  experiences {\n    items {\n      id\n      candidateExperienceId\n      title\n      companyId\n      companyIsVerified\n      companyName\n      description\n      startDate\n      endDate\n      skills\n    }\n    skills {\n      skillId\n      name\n      totalMonthsUsed\n      averageMonthsUsed\n      totalPositionsUsed\n      lastUsed\n      periods {\n        startDate\n        endDate\n      }\n    }\n  }\n}\n\nfragment RecruitProfileApplicationHeader_application on RecruitProfile {\n  id\n  firstName\n  lastName\n  workLocations {\n    currentLocationName\n    currentLocationCountryName\n    workLocations {\n      name\n    }\n    id\n  }\n  currentPosition {\n    title\n    companyName\n    startDate\n    endDate\n    id\n  }\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n  availability {\n    jobSearchStatus\n    availabilityStatus\n    noticeCriteria {\n      availableFrom\n      noticePeriodWeeks\n      noticeTimeframe\n    }\n    id\n  }\n}\n\nfragment RecruitProfileHeader_profile on RecruitProfile {\n  ...RecruitProfileApplicationHeader_application\n  id\n  recruitProfileId\n  firstName\n  lastName\n  profileType\n  workLocations {\n    currentLocationName\n    currentLocationCountryName\n    id\n  }\n  account {\n    accountId\n    id\n  }\n  currentPosition {\n    title\n    companyName\n    startDate\n    endDate\n    id\n  }\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n  rightToWork {\n    status\n    id\n  }\n  availability {\n    jobSearchStatus\n    id\n  }\n}\n"
    }
  };
}();
node84.hash = "f11aa165b1f8b7289e18e304aa32d32a";
var ProfileNotesEditorPaginationQuery_graphql_default = node84;

// src/profile-search/components/__generated__/ProfileNotes_profile.graphql.ts
var node85 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "emailAddress",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "code"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "refetch": {
        "connection": null,
        "fragmentPathInResult": [],
        "operation": ProfileNotesEditorPaginationQuery_graphql_default
      }
    },
    "name": "ProfileNotes_profile",
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "first",
            "value": 1
          },
          {
            "fields": [
              {
                "fields": [
                  {
                    "kind": "Variable",
                    "name": "eq",
                    "variableName": "code"
                  }
                ],
                "kind": "ObjectValue",
                "name": "code"
              }
            ],
            "kind": "ObjectValue",
            "name": "where"
          }
        ],
        "concreteType": "RecruitProfilesConnection",
        "kind": "LinkedField",
        "name": "recruitProfiles",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitProfile",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              v0,
              v1,
              v23,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "recruitProfileId",
                "storageKey": null
              },
              v32,
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitCandidateProfileNote",
                "kind": "LinkedField",
                "name": "notes",
                "plural": true,
                "selections": [
                  v0,
                  {
                    "alias": "noteId",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "candidateProfileNoteId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "content",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RecruitCandidateProfileNoteTag",
                    "kind": "LinkedField",
                    "name": "tags",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "value",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AccountsUser",
                    "kind": "LinkedField",
                    "name": "createdByUser",
                    "plural": false,
                    "selections": [
                      v32,
                      v1,
                      v23
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountsCandidateAccount",
                "kind": "LinkedField",
                "name": "account",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CandidatePhoneVerification",
                    "kind": "LinkedField",
                    "name": "phone",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "phoneVerificationStatus",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "phoneNumber",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "phoneCountryPrefix",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitProfileExperience",
                "kind": "LinkedField",
                "name": "experience",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "candidateExperienceId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "companyName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endDate",
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ExperienceDetails_experience"
                  }
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "RecruitProfileHeader_profile"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ProfileSearchResultTimeline_profile"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node85.hash = "f11aa165b1f8b7289e18e304aa32d32a";
var ProfileNotes_profile_graphql_default = node85;

// src/profile-search/components/__generated__/ProfileNotesAddNoteMutation.graphql.ts
var node86 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "input",
          "variableName": "input"
        }
      ],
      "concreteType": "RecruitCandidateProfileNoteCreatePayload",
      "kind": "LinkedField",
      "name": "recruitCandidateProfileNoteCreate",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EdgeOfCandidateProfileNote",
          "kind": "LinkedField",
          "name": "CandidateProfileNote",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitCandidateProfileNote",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ProfileNotesAddNoteMutation",
      "selections": v1,
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ProfileNotesAddNoteMutation",
      "selections": v1
    },
    "params": {
      "cacheID": "f83f3242acb6ea56534d3028a5129854",
      "id": null,
      "metadata": {},
      "name": "ProfileNotesAddNoteMutation",
      "operationKind": "mutation",
      "text": "mutation ProfileNotesAddNoteMutation(\n  $input: RecruitCandidateProfileNoteCreateInput!\n) {\n  recruitCandidateProfileNoteCreate(input: $input) {\n    CandidateProfileNote {\n      node {\n        id\n      }\n    }\n  }\n}\n"
    }
  };
}();
node86.hash = "5b848a1c553f146ad65a03cfc90b87bd";
var ProfileNotesAddNoteMutation_graphql_default = node86;

// src/profile-search/components/__generated__/ProfileNotesDeleteNoteMutation.graphql.ts
var node87 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "input",
          "variableName": "input"
        }
      ],
      "concreteType": "RecruitCandidateProfileNoteDeletePayload",
      "kind": "LinkedField",
      "name": "recruitCandidateProfileNoteDelete",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "DeleteResult",
          "kind": "LinkedField",
          "name": "result",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "succeeded",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ProfileNotesDeleteNoteMutation",
      "selections": v1,
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ProfileNotesDeleteNoteMutation",
      "selections": v1
    },
    "params": {
      "cacheID": "7ff3ec489bdc2670cc77461841c10bf6",
      "id": null,
      "metadata": {},
      "name": "ProfileNotesDeleteNoteMutation",
      "operationKind": "mutation",
      "text": "mutation ProfileNotesDeleteNoteMutation(\n  $input: RecruitCandidateProfileNoteDeleteInput!\n) {\n  recruitCandidateProfileNoteDelete(input: $input) {\n    result {\n      succeeded\n    }\n  }\n}\n"
    }
  };
}();
node87.hash = "7469cbb1a5d7b1899f5afa9274cc0cbb";
var ProfileNotesDeleteNoteMutation_graphql_default = node87;

// src/profile-search/components/__generated__/ProfileNotesUpdateNoteMutation.graphql.ts
var node88 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "content",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ProfileNotesUpdateNoteMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "RecruitCandidateProfileNoteUpdatePayload",
          "kind": "LinkedField",
          "name": "recruitCandidateProfileNoteUpdate",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfCandidateProfileNote",
              "kind": "LinkedField",
              "name": "CandidateProfileNote",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitCandidateProfileNote",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v23
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ProfileNotesUpdateNoteMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "RecruitCandidateProfileNoteUpdatePayload",
          "kind": "LinkedField",
          "name": "recruitCandidateProfileNoteUpdate",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfCandidateProfileNote",
              "kind": "LinkedField",
              "name": "CandidateProfileNote",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitCandidateProfileNote",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v23,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "6186abbdd1bf3d096945eb15db9b39c2",
      "id": null,
      "metadata": {},
      "name": "ProfileNotesUpdateNoteMutation",
      "operationKind": "mutation",
      "text": "mutation ProfileNotesUpdateNoteMutation(\n  $input: RecruitCandidateProfileNoteUpdateInput!\n) {\n  recruitCandidateProfileNoteUpdate(input: $input) {\n    CandidateProfileNote {\n      node {\n        content\n        id\n      }\n    }\n  }\n}\n"
    }
  };
}();
node88.hash = "98291d59f29e727a409874a267e3c00b";
var ProfileNotesUpdateNoteMutation_graphql_default = node88;

// src/profile-search/components/ProfileNotes.tsx
import {
  useLazyLoadQuery as useLazyLoadQuery12,
  useMutation as useMutation9,
  useRefetchableFragment
} from "react-relay";
import { useParams as useParams5 } from "react-router-dom";
import { createClientMutationId as createClientMutationId19 } from "shared-lib";
import { useUserSessionContext as useUserSessionContext2 } from "app-core";

// src/notes/components/NotesEditor.tsx
import { useCallback as useCallback32, useState as useState18 } from "react";
import { timeAgo as timeAgo2 } from "shared-lib";
import {
  Button as Button19,
  ButtonList as ButtonList7,
  LinkButton,
  Tags as Tags5,
  TagsEditor,
  TextArea
} from "shared-ui";
import { useUserSessionContext } from "app-core";
import { jsx as jsx63, jsxs as jsxs43 } from "react/jsx-runtime";
function sortNotesByDate(notes) {
  if (!notes) {
    return [];
  }
  return [...notes].sort(
    (a4, b3) => new Date(b3.updatedAt).getTime() - new Date(a4.updatedAt).getTime()
  );
}
function mapTagValues(tags) {
  return (tags || []).map((t4) => t4.value);
}
function toTags(tags) {
  return (tags || []).map((value) => ({
    name: "tag",
    value
  }));
}
var NoteEditor = ({
  noteContent,
  noteTags,
  onChangeNoteContent,
  onChangeNoteTags
}) => {
  const [tags, setTags] = useState18(() => {
    return noteTags;
  });
  const [selectedTag, setSelectedTag] = useState18(null);
  const onSelectTag = useCallback32(
    (tag) => {
      setSelectedTag(tag);
    },
    [setSelectedTag]
  );
  const onCloseSelectedTag = useCallback32(() => {
    setSelectedTag(null);
  }, [setSelectedTag]);
  const onRemovedSelectTag = useCallback32(() => {
    if (!selectedTag) {
      return;
    }
    const newTags = tags.filter((t4) => t4 !== selectedTag);
    setTags(newTags);
    onCloseSelectedTag();
    onChangeNoteTags(newTags);
  }, [selectedTag, tags, setTags, onCloseSelectedTag, onChangeNoteTags]);
  return /* @__PURE__ */ jsxs43("div", { className: "flex flex-col gap-1 p-2 py-4", children: [
    /* @__PURE__ */ jsx63("div", { className: "p-2", children: /* @__PURE__ */ jsx63("div", { className: "flex items-center gap-2", children: /* @__PURE__ */ jsx63(
      TextArea,
      {
        placeholder: " Note Content ",
        name: "noteName",
        rows: 4,
        value: noteContent || "",
        onValueChange: onChangeNoteContent
      },
      "noteName"
    ) }) }),
    /* @__PURE__ */ jsx63("div", { className: "mb-2 border-b p-2", children: selectedTag ? /* @__PURE__ */ jsxs43("div", { className: "flex flex-col gap-3", children: [
      /* @__PURE__ */ jsx63("div", { children: selectedTag }),
      /* @__PURE__ */ jsxs43("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ jsx63(Button19, { color: "gray", clicked: onCloseSelectedTag, children: "Close" }),
        /* @__PURE__ */ jsx63(Button19, { color: "danger", clicked: onRemovedSelectTag, children: "Delete" })
      ] })
    ] }) : /* @__PURE__ */ jsx63("div", { className: "flex items-center gap-2", children: /* @__PURE__ */ jsx63(TagsEditor, { tags, onSelected: onSelectTag }) }) })
  ] });
};
var NotesEditor = ({
  isBusy,
  notes,
  onAdd,
  onUpdated,
  onRemove
}) => {
  const session = useUserSessionContext();
  const [addingNote, setAddingNote] = useState18(false);
  const [editNote, setEditNote] = useState18(null);
  const [noteContent, setNoteContent] = useState18(null);
  const [noteTags, setNoteTags] = useState18(
    null
  );
  const onChangeNoteContent = useCallback32(
    (content) => {
      if (!content) {
        return;
      }
      setNoteContent(content);
    },
    [noteContent, setNoteContent]
  );
  const onChangeNoteTags = useCallback32(
    (tags) => {
      setNoteTags(toTags(tags));
    },
    [setNoteTags]
  );
  const onAddStart = useCallback32(() => {
    if (addingNote) {
      return;
    }
    setNoteContent("");
    setNoteTags([]);
    setAddingNote(true);
  }, [setNoteContent]);
  const onEditStart = useCallback32(
    (note) => {
      setEditNote(note);
      setNoteContent(note.content);
      setNoteTags(note.tags);
    },
    [setEditNote, setNoteContent, setNoteTags]
  );
  const onAddNote = useCallback32(() => {
    if (!noteContent || !noteContent || !noteTags) {
      return;
    }
    onAdd({ content: noteContent, tags: noteTags }, () => {
      setAddingNote(false);
    });
  }, [noteTags, noteContent, onAdd, setAddingNote]);
  const onSaveNote = useCallback32(() => {
    if (!editNote || !noteContent || !noteTags) {
      return;
    }
    const note = {
      ...editNote,
      content: noteContent,
      tags: noteTags
    };
    onUpdated(note, () => {
      setEditNote(null);
    });
  }, [editNote, noteTags, noteContent, onUpdated, setEditNote]);
  const onDeleteEditNote = useCallback32(() => {
    if (!editNote) {
      return;
    }
    onRemove(editNote.noteId, () => {
      setEditNote(null);
    });
  }, [editNote, onRemove, setEditNote]);
  let editorContent;
  if (addingNote) {
    editorContent = /* @__PURE__ */ jsxs43("div", { className: "flex flex-col gap-2 p-2 py-4", children: [
      /* @__PURE__ */ jsx63(
        NoteEditor,
        {
          noteContent: noteContent || "",
          noteTags: mapTagValues(noteTags),
          onChangeNoteContent,
          onChangeNoteTags
        }
      ),
      /* @__PURE__ */ jsxs43(ButtonList7, { children: [
        /* @__PURE__ */ jsx63(Button19, { color: "primary", disabled: isBusy, clicked: onAddNote, children: "Save" }),
        /* @__PURE__ */ jsx63(Button19, { color: "gray", clicked: () => setAddingNote(false), children: "Cancel" })
      ] })
    ] });
  } else if (editNote) {
    editorContent = /* @__PURE__ */ jsxs43("div", { className: "flex flex-col gap-2 p-2 py-4", children: [
      /* @__PURE__ */ jsx63(
        NoteEditor,
        {
          noteContent: noteContent || "",
          noteTags: mapTagValues(noteTags),
          onChangeNoteContent,
          onChangeNoteTags
        }
      ),
      /* @__PURE__ */ jsxs43(ButtonList7, { children: [
        /* @__PURE__ */ jsx63(Button19, { color: "primary", clicked: onSaveNote, children: "Save" }),
        /* @__PURE__ */ jsx63(Button19, { color: "gray", clicked: () => setEditNote(null), children: "Cancel" }),
        /* @__PURE__ */ jsx63(Button19, { color: "danger", clicked: onDeleteEditNote, children: "Delete" })
      ] })
    ] });
  } else {
    editorContent = /* @__PURE__ */ jsxs43("div", { className: "my-4 flex flex-col gap-1", children: [
      /* @__PURE__ */ jsxs43("div", { className: "flex items-center justify-between border-b pb-4", children: [
        /* @__PURE__ */ jsx63("div", { className: "text-primary-500 px-4 text-lg font-medium", children: "Notes" }),
        /* @__PURE__ */ jsx63("div", { children: session.accountType === "EMPLOYER" ? /* @__PURE__ */ jsx63(
          Button19,
          {
            color: "primary",
            disabled: addingNote,
            clicked: onAddStart,
            children: "Add"
          }
        ) : /* @__PURE__ */ jsx63("div", { className: "text-danger-500 px-4 text-lg font-bold", children: "Only Employer Accounts Can Add Notes" }) })
      ] }),
      /* @__PURE__ */ jsx63("ul", { role: "list", className: "divide-y divide-gray-100", children: sortNotesByDate(notes).map((n3) => /* @__PURE__ */ jsxs43(
        "li",
        {
          className: "flex items-center justify-between gap-x-6 py-5",
          children: [
            /* @__PURE__ */ jsxs43("div", { className: "min-w-0 px-3", children: [
              /* @__PURE__ */ jsx63("div", { className: "mb-3 whitespace-nowrap text-lg", children: n3.content }),
              /* @__PURE__ */ jsxs43("div", { className: "my-2 flex items-center gap-x-2 text-sm leading-5 text-gray-500", children: [
                /* @__PURE__ */ jsxs43("p", { className: "flex items-center gap-x-1 whitespace-nowrap", children: [
                  /* @__PURE__ */ jsx63("span", { children: n3.createdByUser.firstName }),
                  /* @__PURE__ */ jsx63("span", { children: n3.createdByUser.lastName })
                ] }),
                /* @__PURE__ */ jsx63("p", { className: "whitespace-nowrap", children: timeAgo2(n3.updatedAt) })
              ] }),
              /* @__PURE__ */ jsx63("div", { className: "mt-3 flex items-center gap-2", children: /* @__PURE__ */ jsx63(Tags5, { list: mapTagValues(n3.tags) }) })
            ] }),
            /* @__PURE__ */ jsx63(LinkButton, { clicked: () => onEditStart(n3), children: "Edit" })
          ]
        },
        n3.code
      )) })
    ] });
  }
  return /* @__PURE__ */ jsx63("div", { children: editorContent });
};

// src/profile-search/components/ProfileNotes.tsx
import { jsx as jsx64 } from "react/jsx-runtime";
var queryRef = ProfileNotesQuery_graphql_default;
var fragmentDef24 = ProfileNotes_profile_graphql_default;
var addNoteMutation = ProfileNotesAddNoteMutation_graphql_default;
var deleteNoteMutation = ProfileNotesDeleteNoteMutation_graphql_default;
var updateNoteMutation = ProfileNotesUpdateNoteMutation_graphql_default;
var ProfileNotes = () => {
  const { profileId } = useParams5();
  if (!profileId)
    return /* @__PURE__ */ jsx64("div", { children: "Not found" });
  return /* @__PURE__ */ jsx64(ProfilesNotesById, { profileId });
};
var ProfilesNotesById = ({ profileId }) => {
  const data = useLazyLoadQuery12(queryRef, {
    code: profileId ? parseInt(profileId) : 0
  });
  if (!profileId || !data)
    return /* @__PURE__ */ jsx64("div", { children: "Not found" });
  return /* @__PURE__ */ jsx64(ProfileNotesComponent, { fragmentRef: data });
};
var ProfileNotesComponent = ({
  fragmentRef
}) => {
  const [createNote] = useMutation9(addNoteMutation);
  const [deleteNote] = useMutation9(deleteNoteMutation);
  const [updateNote] = useMutation9(updateNoteMutation);
  const session = useUserSessionContext2();
  const employerId = session.employerId;
  const [data, refetch] = useRefetchableFragment(fragmentDef24, fragmentRef);
  const profile = data?.recruitProfiles?.nodes && data?.recruitProfiles?.nodes[0];
  if (!profile) {
    return /* @__PURE__ */ jsx64("div", { children: "Profile not found" });
  }
  const onAdd = (data2, onCompleted) => {
    if (!employerId) {
      return;
    }
    createNote({
      variables: {
        input: {
          clientMutationId: createClientMutationId19(),
          employerId: session.employerId,
          profileId: profile.recruitProfileId,
          content: data2.content,
          tags: data2.tags
        }
      },
      onCompleted: () => {
        refetch({ code: profile.code }, { fetchPolicy: "network-only" });
        onCompleted();
      }
    });
  };
  const onDelete = (noteId, onCompleted) => {
    deleteNote({
      variables: {
        input: {
          clientMutationId: createClientMutationId19(),
          noteId
        }
      },
      onCompleted: () => {
        refetch({ code: profile.code }, { fetchPolicy: "network-only" });
        onCompleted();
      }
    });
  };
  const onUpdate = (data2, onCompleted) => {
    updateNote({
      variables: {
        input: {
          clientMutationId: createClientMutationId19(),
          noteId: data2.noteId,
          content: data2.content,
          tags: data2.tags
        }
      },
      onCompleted
    });
  };
  return /* @__PURE__ */ jsx64("div", { className: "rounded-lg bg-white px-5 py-4", children: /* @__PURE__ */ jsx64(
    NotesEditor,
    {
      isBusy: false,
      notes: profile.notes,
      onAdd,
      onRemove: onDelete,
      onUpdated: onUpdate
    }
  ) });
};

// src/candidates/components/__generated__/VacancyApplicationSearchContainer_vacancy.graphql.ts
var node89 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VacancyApplicationSearchContainer_vacancy",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vacancyId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "VacancyApplicationSearchList_vacancy"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "VacancyApplicationSearchListHeader_vacancy"
    }
  ],
  "type": "Vacancy",
  "abstractKey": null
};
node89.hash = "bcfce1f812b964e34b7fe4221a28d23e";
var VacancyApplicationSearchContainer_vacancy_graphql_default = node89;

// src/candidates/components/VacancyApplicationSearchContainer.tsx
import {
  memo as memo5,
  Suspense as Suspense110,
  useCallback as useCallback181,
  useEffect as useEffect38,
  useMemo as useMemo37,
  useTransition as useTransition13
} from "react";
import { useFragment as useFragment99, useQueryLoader as useQueryLoader16 } from "react-relay";
import { useAtom as useAtom15 } from "jotai";
import { Loading as Loading9, SortDir as SortDir8, sortDirToGraphQL as sortDirToGraphQL6 } from "shared-ui";

// src/candidates/lib/Application.ts
var defaultApplicationSort = "BEST_MATCH";
var defaultApplicationSortOrder = "DESC";
var applicationSortBestMatch = {
  id: defaultApplicationSort,
  name: "Best Match"
};
var applicationSortValues = [
  applicationSortBestMatch,
  {
    id: "COMPANY_SCORE",
    name: "Company Score"
  },
  {
    id: "SKILL_SCORE",
    name: "Skill Score"
  },
  {
    id: "DATE_CREATED",
    name: "Created On"
  },
  {
    id: "RATE",
    name: "Rate"
  }
];

// src/candidates/lib/ApplicationProfileExperienceSimilaritySearch.ts
import { groupBy } from "lodash-es";
import {
  datesAndDuration,
  Guard,
  tokenize
} from "shared-lib";
function positionDatesAndDuration(position) {
  if (Guard.isNull(position.startDate) || Guard.isNull(position.endDate)) {
    return "";
  }
  return datesAndDuration(position.startDate, position.endDate);
}
var DocumentSearchResult = class {
  constructor(sentences, source) {
    this.showAll = false;
    this.sentences = sentences;
    this.hasMatches = this.sentences.length > 0;
    this.source = source;
  }
};
var DocumentSearchIndex = class {
  constructor(source) {
    this.source = source;
    this.document = tokenize(source.description);
  }
  filterSentences(terms) {
    return new DocumentSearchResult(
      this.document.sentencesWithContent(terms),
      this.source
    );
  }
};
function createIndexedPositionsIndex(sources) {
  return sources.map((p4) => new DocumentSearchIndex(p4));
}
function filterExperiencesByTerms(sources, terms) {
  return (sources || []).map(
    (e4) => e4.filterSentences(terms)
  );
}
var DocumentSearchIndexCollection = class {
  constructor(sources) {
    this.sources = [];
    this.sources = sources.map(
      (p4) => new DocumentSearchIndex(p4)
    );
  }
  filterExperiences(terms) {
    return (this.sources || []).map(
      (e4) => e4.filterSentences(terms)
    );
  }
};
function matchExperienceByFilter(filter2, index2, similarities) {
  const groupSentenceSimilarities = similarities.filter(
    (s4) => s4.skillGroupId === filter2.groupId
  );
  const similarityGroups = groupBy(
    groupSentenceSimilarities.map((s4) => ({
      ...s4,
      sentence: s4.sentence.replace(new RegExp("\\\\n", "g"), "")
    })),
    (x4) => x4.experienceId
  );
  const filteredExperience = index2.filterExperiences(filter2.terms);
  const matchedExperiences = filteredExperience.filter((c4) => {
    return similarityGroups[c4.source.id] && similarityGroups[c4.source.id].length > 0;
  });
  const results = matchedExperiences.filter((context) => {
    return !!similarityGroups[context.source.id];
  }).map((context) => {
    const similarity = similarityGroups[context.source.id];
    return {
      result: context,
      similarity
    };
  });
  return results;
}

// src/candidates/lib/ApplicationSearch.ts
import { useCallback as useCallback33 } from "react";
import { atom as atom3, useAtom as useAtom3 } from "jotai";
import { atomWithReducer, useHydrateAtoms } from "jotai/utils";
import { isMatch } from "lodash-es";
import { updatedDiff } from "deep-object-diff";
import { SortDir as SortDir2, sortDirToGraphQL as sortDirToGraphQL2 } from "shared-ui";
var ApplicationSortFieldType = /* @__PURE__ */ ((ApplicationSortFieldType2) => {
  ApplicationSortFieldType2["BEST_MATCH"] = "BEST_MATCH";
  ApplicationSortFieldType2["NAME"] = "NAME";
  ApplicationSortFieldType2["APPLICATION_DATE"] = "APPLICATION_DATE";
  return ApplicationSortFieldType2;
})(ApplicationSortFieldType || {});
var workflowStateChangeEventsAtom = atom3([]);
var applicationSortFields = [
  {
    id: "BEST_MATCH" /* BEST_MATCH */,
    name: "Sort by 'Rank'"
  },
  {
    id: "NAME" /* NAME */,
    name: "Sort by 'Name'"
  },
  {
    id: "APPLICATION_DATE" /* APPLICATION_DATE */,
    name: "Sort by 'Applied On'"
  }
];
function atomWithCompare(initialValue) {
  return atomWithReducer(initialValue, (prev, next) => {
    if (isMatch(JSON.stringify(prev), JSON.stringify(next))) {
      return prev;
    }
    console.log("search input changes");
    console.log(updatedDiff(prev, next));
    return next;
  });
}
var defaultApplicationSearchAtomValues = {
  filters: {},
  pagination: {
    pageNumber: 1,
    pageSize: 10
  },
  sort: {
    field: applicationSortFieldToGraphQL(
      "APPLICATION_DATE" /* APPLICATION_DATE */
    ),
    order: sortDirToGraphQL2(SortDir2.Desc)
  }
};
var applicationSearchAtom = atomWithCompare(
  defaultApplicationSearchAtomValues
);
function useLoadMoreApplications() {
  const [filters, setFilters] = useAtom3(applicationSearchAtom);
  const loadMore = useCallback33(() => {
    if (!filters.pagination) {
      return;
    }
    if (filters.pagination?.pageNumber === filters.pagination?.pageSize) {
      return;
    }
    setFilters({
      ...filters,
      pagination: {
        pageNumber: filters.pagination.pageNumber + 1,
        pageSize: filters.pagination.pageSize
      }
    });
  }, [filters, setFilters]);
  return loadMore;
}
var InitializeSearchAtoms = ({ initialValues, children }) => {
  useHydrateAtoms(initialValues, {
    dangerouslyForceHydrate: true
  });
  return children;
};
function applicationSortFieldToGraphQL(sort) {
  switch (sort) {
    case "BEST_MATCH" /* BEST_MATCH */: {
      return {
        standard: "BEST_MATCH"
      };
    }
    case "NAME" /* NAME */: {
      return {
        standard: "NAME"
      };
    }
    case "APPLICATION_DATE" /* APPLICATION_DATE */: {
      return {
        custom: "APPLICATION_DATE"
      };
    }
  }
}
var applicationStatusValues = [
  {
    id: "ALL",
    name: "All"
  },
  {
    id: "ACTIVE",
    name: "Active"
  },
  {
    id: "CREATED",
    name: "Created"
  },
  {
    id: "HIRED",
    name: "Hired"
  },
  {
    id: "SUBMITTED",
    name: "Submitted"
  },
  {
    id: "UNSUCCESSFUL",
    name: "Unsuccessful"
  },
  {
    id: "WITHDRAWN",
    name: "Withdrawn"
  }
];

// src/candidates/lib/useLegacyPagination.ts
import { useCallback as useCallback34, useMemo as useMemo11, useState as useState19, useTransition as useTransition2 } from "react";
import { useRefetchableFragment as useRefetchableFragment2 } from "react-relay";
var useLegacyPagination = (fragmentDef122, fragmentRef, listItem) => {
  const [result, refetch] = useRefetchableFragment2(
    fragmentDef122,
    fragmentRef
  );
  const [list2, setList] = useState19([]);
  const [filters, setFilters] = useState19({});
  const [isLoading, startTransition2] = useTransition2();
  const listResults = listItem(result);
  const updateFilters = useCallback34(
    (filtersList) => {
      setFilters(filtersList);
      if (!result?.result.paging)
        return;
      startTransition2(() => {
        refetch(
          {
            input: {
              pageNumber: 1,
              pageSize: result.result.paging.itemsPerPage,
              ...filtersList
            }
          },
          {
            onComplete: () => {
              setList([]);
            }
          }
        );
      });
    },
    [refetch, result?.result.paging]
  );
  const loadMore = useCallback34(() => {
    if (!result?.result.paging) {
      return;
    }
    if (result?.result.paging?.pageNumber === result?.result.paging?.pages) {
      return;
    }
    startTransition2(() => {
      refetch(
        {
          input: {
            pageNumber: result?.result.paging.pageNumber + 1,
            pageSize: result?.result.paging.itemsPerPage,
            ...filters
          }
        },
        {
          onComplete: () => {
            setList([...list2, ...listResults]);
          }
        }
      );
    });
  }, [result?.result.paging, refetch, filters, list2, listResults]);
  const memoList = useMemo11(() => {
    return [...list2, ...listResults];
  }, [list2, listResults]);
  return {
    result,
    list: memoList,
    isLoading,
    loadMore,
    updateFilters,
    filters
  };
};

// src/candidates/lib/LinkRegistryAtom.ts
import {
  atom as atom4,
  useRecoilState as useRecoilState2,
  useRecoilValue,
  useSetRecoilState
} from "recoil";
var linkRegistryAtom = atom4({
  key: "linkRegistryRec",
  default: {
    prefixes: {}
  }
});
function useLinkRegistryState() {
  const [linkRegistry, setLinkRegistry] = useRecoilState2(linkRegistryAtom);
  return [linkRegistry, setLinkRegistry];
}
function useSetLinkRegistry() {
  const setRegistry = useSetRecoilState(linkRegistryAtom);
  return setRegistry;
}
function useLinkRegistry() {
  const linkRegistry = useRecoilValue(linkRegistryAtom);
  return linkRegistry;
}

// src/candidates/lib/useOffsetPagination.ts
import { useCallback as useCallback35, useMemo as useMemo12, useState as useState20, useTransition as useTransition3 } from "react";
import { useRefetchableFragment as useRefetchableFragment3 } from "react-relay";
var useOffsetPagination = (fragmentDef122, fragmentRef, listItem, defaultFilters) => {
  const [result, refetch] = useRefetchableFragment3(
    fragmentDef122,
    fragmentRef
  );
  const [list2, setList] = useState20([]);
  const [filters, setFilters] = useState20(defaultFilters);
  const [isLoading, startTransition2] = useTransition3();
  const listResults = listItem(result);
  const updateFilters = useCallback35(
    (filtersList) => {
      setFilters(filtersList);
      if (!result?.result.pagination?.itemsPerPage)
        return;
      startTransition2(() => {
        refetch(
          {
            input: {
              pagination: {
                pageNumber: 1,
                pageSize: result.result.pagination.itemsPerPage
              },
              ...filtersList
            }
          },
          {
            onComplete: () => {
              setList([]);
            }
          }
        );
      });
    },
    [refetch, result?.result.pagination.itemsPerPage, setFilters]
  );
  const loadMore = useCallback35(() => {
    if (result?.result.pagination?.pageNumber === result?.result.pagination?.pages)
      return;
    if (!result?.result.pagination)
      return;
    startTransition2(() => {
      refetch(
        {
          input: {
            pagination: {
              pageNumber: result?.result.pagination.pageNumber + 1,
              pageSize: result?.result.pagination.itemsPerPage
            },
            ...filters
          }
        },
        {
          onComplete: () => {
            setList([...list2, ...listResults]);
          }
        }
      );
    });
  }, [result?.result.pagination, refetch, filters, list2, listResults]);
  const memoList = useMemo12(() => {
    return [...list2, ...listResults];
  }, [list2, listResults]);
  return {
    result,
    list: memoList,
    isLoading,
    loadMore,
    updateFilters,
    filters
  };
};

// src/candidates/lib/VacancyApplicationSearchContext.ts
import { atom as atom5 } from "jotai";
var vacancyApplicationSearchContextAtom = atom5({
  isFiltersOpen: false
});

// src/candidates/components/__generated__/VacancyApplicationSearchListQuery.graphql.ts
var node90 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "key",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isSelected",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "text",
    "storageKey": null
  }, v8 = [
    v4,
    v23,
    v32,
    {
      "alias": null,
      "args": null,
      "concreteType": "DefaultAggregationValueModel",
      "kind": "LinkedField",
      "name": "values",
      "plural": true,
      "selections": [
        v4,
        v6,
        v5,
        v7
      ],
      "storageKey": null
    }
  ], v9 = [
    v32,
    {
      "alias": null,
      "args": null,
      "concreteType": "DefaultAggregationValueModel",
      "kind": "LinkedField",
      "name": "values",
      "plural": true,
      "selections": [
        v4,
        v7,
        v6,
        v5
      ],
      "storageKey": null
    }
  ], v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "applicationId",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "version",
    "storageKey": null
  }, v14 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  }, v15 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v16 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v17 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v18 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "accountId",
    "storageKey": null
  }, v19 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "phoneNumber",
    "storageKey": null
  }, v20 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "phoneCountryPrefix",
    "storageKey": null
  }, v21 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "phoneVerificationStatus",
    "storageKey": null
  }, v222 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyName",
    "storageKey": null
  }, v232 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "startDate",
    "storageKey": null
  }, v24 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "endDate",
    "storageKey": null
  }, v25 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "vacancyId",
    "storageKey": null
  }, v26 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "skillGroupId",
    "storageKey": null
  }, v27 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isRequired",
    "storageKey": null
  }, v28 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "weight",
    "storageKey": null
  }, v29 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationAmount",
    "storageKey": null
  }, v30 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationType",
    "storageKey": null
  }, v31 = [
    v29,
    v30
  ], v322 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "numberOfMonthsCertain",
    "storageKey": null
  }, v33 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "numberOfMonthsCertainPlusUnknown",
    "storageKey": null
  }, v34 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "mostRecentCertainExperienceEnd",
    "storageKey": null
  }, v35 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "mostRecentUnknownExperienceEnd",
    "storageKey": null
  }, v36 = [
    v322,
    v33,
    v34,
    v35
  ], v37 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "titleId",
    "storageKey": null
  }, v38 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "industry",
    "storageKey": null
  }, v39 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyIsVerified",
    "storageKey": null
  }, v40 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyId",
    "storageKey": null
  }, v41 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  }, v42 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "positionType",
    "storageKey": null
  }, v43 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "escoOccupationId",
    "storageKey": null
  }, v44 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "escoHierarchy",
    "storageKey": null
  }, v45 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "emailAddress",
    "storageKey": null
  }, v46 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }, v47 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateExperienceId",
    "storageKey": null
  }, v48 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdOn",
    "storageKey": null
  }, v49 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedOn",
    "storageKey": null
  }, v50 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "skills",
    "storageKey": null
  }, v51 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  }, v52 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isSubmitted",
    "storageKey": null
  }, v53 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }, v54 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "parentId",
    "storageKey": null
  }, v55 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "workflowDefinitionId",
    "storageKey": null
  }, v56 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "transitionId",
    "storageKey": null
  }, v57 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "nextStateId",
    "storageKey": null
  }, v58 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currentStateId",
    "storageKey": null
  }, v59 = {
    "alias": null,
    "args": null,
    "concreteType": "WorkflowActionTransition",
    "kind": "LinkedField",
    "name": "actions",
    "plural": true,
    "selections": [
      v10,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "workflowActionTransitionId",
        "storageKey": null
      },
      v55,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "actionGroup",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "actionType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "actionName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "actionDialog",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "actionLabel",
        "storageKey": null
      },
      v56,
      v57,
      v58,
      {
        "alias": null,
        "args": null,
        "concreteType": "WorkflowSecurityContext",
        "kind": "LinkedField",
        "name": "securityContext",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "WorkflowSecurityUser",
            "kind": "LinkedField",
            "name": "users",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "owner",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "WorkflowPermission",
                "kind": "LinkedField",
                "name": "permissions",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "action",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "resource",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userType",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v60 = {
    "alias": null,
    "args": null,
    "concreteType": "WorkflowEventTransition",
    "kind": "LinkedField",
    "name": "events",
    "plural": true,
    "selections": [
      v10,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "eventName",
        "storageKey": null
      },
      v56,
      v55,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "workflowEventTransitionId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v61 = {
    "alias": null,
    "args": null,
    "concreteType": "WorkflowTransition",
    "kind": "LinkedField",
    "name": "transitions",
    "plural": true,
    "selections": [
      v10,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "workflowTransitionId",
        "storageKey": null
      },
      v55,
      v58,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currentStateName",
        "storageKey": null
      },
      v57,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "nextStateName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "WorkflowTransitionActivity",
        "kind": "LinkedField",
        "name": "activities",
        "plural": true,
        "selections": [
          v10,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "workflowTransitionActivityId",
            "storageKey": null
          },
          v56,
          {
            "alias": null,
            "args": null,
            "concreteType": "WorkflowActivityContext",
            "kind": "LinkedField",
            "name": "context",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "workflowActivityType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "workflowActivityParameters",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "VacancyApplicationSearchListQuery",
      "selections": [
        {
          "args": v1,
          "kind": "FragmentSpread",
          "name": "VacancyApplicationSearchList_query"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "VacancyApplicationSearchListQuery",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "ApplicationSearchResults",
          "kind": "LinkedField",
          "name": "recruitApplicationSearch2",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CollectionMetaData",
              "kind": "LinkedField",
              "name": "pagination",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "totalResults",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "itemsPerPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "pageNumber",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "pages",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ApplicationSearchAggregations",
              "kind": "LinkedField",
              "name": "aggregations",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "applicationState",
                  "plural": false,
                  "selections": [
                    v23,
                    v32,
                    v4,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationValueModel",
                      "kind": "LinkedField",
                      "name": "values",
                      "plural": true,
                      "selections": [
                        v4,
                        v5,
                        v6,
                        v7
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "StandardAggregationResults",
                  "kind": "LinkedField",
                  "name": "standard",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "skills",
                      "plural": false,
                      "selections": v8,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "companies",
                      "plural": false,
                      "selections": v8,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "industries",
                      "plural": false,
                      "selections": v8,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "escoLevel1",
                      "plural": false,
                      "selections": v9,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "escoLevel2",
                      "plural": false,
                      "selections": v9,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "escoLevel3",
                      "plural": false,
                      "selections": v9,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "escoLevel4",
                      "plural": false,
                      "selections": v9,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "escoLevel5",
                      "plural": false,
                      "selections": v9,
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "project",
                  "plural": false,
                  "selections": v8,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "dateCreated",
                  "plural": false,
                  "selections": v8,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "vacancy",
                  "plural": false,
                  "selections": v8,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "currentState",
                  "plural": false,
                  "selections": v8,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "industryExperienceRelevance",
                  "plural": false,
                  "selections": v8,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "industryRecencyRelevance",
                  "plural": false,
                  "selections": v8,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "jobExperienceRelevance",
                  "plural": false,
                  "selections": v8,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "jobRecencyRelevance",
                  "plural": false,
                  "selections": v8,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "currentCompany",
                  "plural": false,
                  "selections": v9,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "skillGroups",
                  "plural": false,
                  "selections": v9,
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ApplicationSearchResult",
              "kind": "LinkedField",
              "name": "results",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "rankInVacancy",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "totalApplicationsInVacancy",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Application",
                  "kind": "LinkedField",
                  "name": "application",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "applicationStateName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "workflowStateName",
                      "storageKey": null
                    },
                    v10,
                    v11,
                    v12,
                    v13,
                    v14,
                    v15,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "appliedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "applicantSource",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountsCandidateAccount",
                      "kind": "LinkedField",
                      "name": "candidate",
                      "plural": false,
                      "selections": [
                        v16,
                        v17,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "email",
                          "storageKey": null
                        },
                        v10,
                        v18,
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "CandidatePhoneVerification",
                          "kind": "LinkedField",
                          "name": "phone",
                          "plural": false,
                          "selections": [
                            v19,
                            v20,
                            v21
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileExperience",
                      "kind": "LinkedField",
                      "name": "currentPosition",
                      "plural": false,
                      "selections": [
                        v222,
                        v232,
                        v24,
                        v32,
                        v10
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "candidateId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "rightToWorkStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Vacancy",
                      "kind": "LinkedField",
                      "name": "vacancy",
                      "plural": false,
                      "selections": [
                        v11,
                        v25,
                        v10,
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "SkillGroup",
                          "kind": "LinkedField",
                          "name": "skillGroups",
                          "plural": true,
                          "selections": [
                            v10,
                            v26,
                            v5,
                            v27,
                            v28,
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "SkillGroupTerm",
                              "kind": "LinkedField",
                              "name": "terms",
                              "plural": true,
                              "selections": [
                                v5,
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "isSkill",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Duration",
                              "kind": "LinkedField",
                              "name": "experience",
                              "plural": false,
                              "selections": v31,
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Duration",
                              "kind": "LinkedField",
                              "name": "recency",
                              "plural": false,
                              "selections": [
                                v30,
                                v29
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "VacancyScoringConfig",
                          "kind": "LinkedField",
                          "name": "scoringConfig",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Duration",
                              "kind": "LinkedField",
                              "name": "industryExperience",
                              "plural": false,
                              "selections": v31,
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "industryNegativeThreshold",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "industryPositiveThreshold",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Duration",
                              "kind": "LinkedField",
                              "name": "industryRecency",
                              "plural": false,
                              "selections": v31,
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "relevanceNegativeThreshold",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "relevancePositiveThreshold",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Duration",
                              "kind": "LinkedField",
                              "name": "relevantExperience",
                              "plural": false,
                              "selections": v31,
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Duration",
                              "kind": "LinkedField",
                              "name": "relevantRecency",
                              "plural": false,
                              "selections": v31,
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "WorkflowDefinition",
                          "kind": "LinkedField",
                          "name": "workflowDefinition",
                          "plural": false,
                          "selections": [
                            v10,
                            v5,
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "WorkflowState",
                              "kind": "LinkedField",
                              "name": "states",
                              "plural": true,
                              "selections": [
                                v10,
                                v5,
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "label",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "WorkflowState",
                                  "kind": "LinkedField",
                                  "name": "children",
                                  "plural": true,
                                  "selections": [
                                    v10,
                                    v5
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitMatchRelevanceContainer",
                      "kind": "LinkedField",
                      "name": "matchRelevance",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitMatchSkillRelevance",
                          "kind": "LinkedField",
                          "name": "skillGroups",
                          "plural": true,
                          "selections": [
                            v26,
                            v322,
                            v33,
                            v34,
                            v35
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitMatchRelevance",
                          "kind": "LinkedField",
                          "name": "industry",
                          "plural": false,
                          "selections": v36,
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitMatchRelevance",
                          "kind": "LinkedField",
                          "name": "job",
                          "plural": false,
                          "selections": v36,
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitMatchProfile",
                      "kind": "LinkedField",
                      "name": "matchProfile",
                      "plural": false,
                      "selections": [
                        v10,
                        v25,
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitMatchProfileExperience",
                          "kind": "LinkedField",
                          "name": "experience",
                          "plural": true,
                          "selections": [
                            v10,
                            v11,
                            v13,
                            v37,
                            v32,
                            v38,
                            v39,
                            v40,
                            v222,
                            v41,
                            v232,
                            v24,
                            v42,
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "MatchProfileExperienceSkillGroupScore",
                              "kind": "LinkedField",
                              "name": "skillGroupScores",
                              "plural": true,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "groupId",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "hasMatch",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "minSkillGroupScore",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "score",
                                  "storageKey": null
                                },
                                v28
                              ],
                              "storageKey": null
                            },
                            v43,
                            v44,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "jobMatchWeight",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "jobMatchScore",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "companyScore",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "companyScoreWeight",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "hasCompanyVector",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfile",
                      "kind": "LinkedField",
                      "name": "profile",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileRate",
                          "kind": "LinkedField",
                          "name": "rate",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "countryCode",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "currencyCode",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "maximumRateOfPay",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "minimumRateOfPay",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "payType",
                              "storageKey": null
                            },
                            v10
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "recruitProfileId",
                          "storageKey": null
                        },
                        v11,
                        v16,
                        v17,
                        v45,
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitCandidateProfileNote",
                          "kind": "LinkedField",
                          "name": "notes",
                          "plural": true,
                          "selections": [
                            v11,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "content",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "RecruitCandidateProfileNoteTag",
                              "kind": "LinkedField",
                              "name": "tags",
                              "plural": true,
                              "selections": [
                                v5,
                                v46
                              ],
                              "storageKey": null
                            },
                            v15,
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "AccountsUser",
                              "kind": "LinkedField",
                              "name": "createdByUser",
                              "plural": false,
                              "selections": [
                                v45,
                                v16,
                                v17
                              ],
                              "storageKey": null
                            },
                            v10
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "AccountsCandidateAccount",
                          "kind": "LinkedField",
                          "name": "account",
                          "plural": false,
                          "selections": [
                            v18,
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "CandidatePhoneVerification",
                              "kind": "LinkedField",
                              "name": "phone",
                              "plural": false,
                              "selections": [
                                v21,
                                v19,
                                v20
                              ],
                              "storageKey": null
                            },
                            v10
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileExperience",
                          "kind": "LinkedField",
                          "name": "experience",
                          "plural": true,
                          "selections": [
                            v10,
                            v47,
                            v32,
                            v222,
                            v232,
                            v24,
                            v48,
                            v49,
                            v13,
                            v37,
                            v38,
                            v39,
                            v40,
                            v41,
                            v42,
                            v50,
                            v43,
                            v44
                          ],
                          "storageKey": null
                        },
                        v10,
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileWorkLocations",
                          "kind": "LinkedField",
                          "name": "workLocations",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "currentLocationName",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "currentLocationCountryName",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "WorkLocationEntry",
                              "kind": "LinkedField",
                              "name": "workLocations",
                              "plural": true,
                              "selections": [
                                v5
                              ],
                              "storageKey": null
                            },
                            v10
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileExperience",
                          "kind": "LinkedField",
                          "name": "currentPosition",
                          "plural": false,
                          "selections": [
                            v32,
                            v222,
                            v232,
                            v24,
                            v10
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileAvailability",
                          "kind": "LinkedField",
                          "name": "availability",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "jobSearchStatus",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "availabilityStatus",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "NoticeCriteria",
                              "kind": "LinkedField",
                              "name": "noticeCriteria",
                              "plural": false,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "availableFrom",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "noticePeriodWeeks",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "noticeTimeframe",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            },
                            v10
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "profileType",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RightToWork",
                          "kind": "LinkedField",
                          "name": "rightToWork",
                          "plural": true,
                          "selections": [
                            v51,
                            v10
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileExperienceCollection",
                          "kind": "LinkedField",
                          "name": "experiences",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "RecruitProfileExperience",
                              "kind": "LinkedField",
                              "name": "items",
                              "plural": true,
                              "selections": [
                                v10,
                                v47,
                                v32,
                                v40,
                                v39,
                                v222,
                                v41,
                                v232,
                                v24,
                                v50,
                                v48,
                                v49,
                                v13,
                                v37,
                                v38,
                                v42,
                                v43,
                                v44
                              ],
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "SkillUsage",
                              "kind": "LinkedField",
                              "name": "skills",
                              "plural": true,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "skillId",
                                  "storageKey": null
                                },
                                v5,
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "totalMonthsUsed",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "averageMonthsUsed",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "totalPositionsUsed",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "lastUsed",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "DateRange",
                                  "kind": "LinkedField",
                                  "name": "periods",
                                  "plural": true,
                                  "selections": [
                                    v232,
                                    v24
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitResume",
                          "kind": "LinkedField",
                          "name": "resume",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "bucket",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "resumeId",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "fileKey",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "fileName",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "filePath",
                              "storageKey": null
                            },
                            v10
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ApplicationDocument",
                      "kind": "LinkedField",
                      "name": "documents",
                      "plural": true,
                      "selections": [
                        v10,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "applicationDocumentId",
                          "storageKey": null
                        },
                        v14,
                        v15,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "documentReferenceId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "documentReferenceFileName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "documentTypeId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "documentTypeName",
                          "storageKey": null
                        },
                        v27,
                        v52,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isUploaded",
                          "storageKey": null
                        },
                        v51,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "requiresExpiryDate",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "requiresIssueDate",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "requiresIssueNumber",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "documentExpiryDate",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "documentIssueDate",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "documentIssueNumber",
                          "storageKey": null
                        },
                        v12
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "vacancyName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ApplicationForm",
                      "kind": "LinkedField",
                      "name": "forms",
                      "plural": true,
                      "selections": [
                        v10,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "applicationFormId",
                          "storageKey": null
                        },
                        v11,
                        v14,
                        v15,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isEdited",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isCompleted",
                          "storageKey": null
                        },
                        v27,
                        v52,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "formTemplateName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "FormField",
                          "kind": "LinkedField",
                          "name": "fields",
                          "plural": true,
                          "selections": [
                            v23,
                            v46,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "skipped",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "type",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        v12,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "formTemplateId",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasCompletedForms",
                      "storageKey": null
                    },
                    v53,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "applicationStateId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "workflowStateId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "WorkflowDefinition",
                      "kind": "LinkedField",
                      "name": "workflowDefinition",
                      "plural": false,
                      "selections": [
                        v10,
                        v5,
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "WorkflowState",
                          "kind": "LinkedField",
                          "name": "states",
                          "plural": true,
                          "selections": [
                            v10,
                            v5,
                            v54,
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "WorkflowState",
                              "kind": "LinkedField",
                              "name": "children",
                              "plural": true,
                              "selections": [
                                v10,
                                v5,
                                v54,
                                v59,
                                v60,
                                v61
                              ],
                              "storageKey": null
                            },
                            v59,
                            v60,
                            v61
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v53
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "1bb811b4058bea1ad05c7bcf50693764",
      "id": null,
      "metadata": {},
      "name": "VacancyApplicationSearchListQuery",
      "operationKind": "query",
      "text": "query VacancyApplicationSearchListQuery(\n  $input: ApplicationSearchInput2Input!\n) {\n  ...VacancyApplicationSearchList_query_2VV6jB\n}\n\nfragment AggregationTags_Aggregation on DefaultAggregationModel {\n  title\n  values {\n    count\n    text\n    isSelected\n    name\n  }\n}\n\nfragment CandidateApplicationDocumentDetail_document on ApplicationDocument {\n  id\n  applicationDocumentId\n  applicationId\n  createdAt\n  updatedAt\n  documentReferenceId\n  documentReferenceFileName\n  documentTypeId\n  documentTypeName\n  isRequired\n  isSubmitted\n  isUploaded\n  status\n  requiresExpiryDate\n  requiresIssueDate\n  requiresIssueNumber\n  documentExpiryDate\n  documentIssueDate\n  documentIssueNumber\n}\n\nfragment CandidateApplicationDocumentRow_document on ApplicationDocument {\n  id\n  applicationDocumentId\n  createdAt\n  updatedAt\n  documentReferenceId\n  documentReferenceFileName\n  documentTypeId\n  documentTypeName\n  isRequired\n  isSubmitted\n  isUploaded\n  status\n  requiresExpiryDate\n  requiresIssueDate\n  requiresIssueNumber\n  documentExpiryDate\n  documentIssueDate\n  documentIssueNumber\n}\n\nfragment CandidateApplicationDocuments_application on Application {\n  documents {\n    id\n    applicationDocumentId\n    createdAt\n    updatedAt\n    documentReferenceId\n    documentReferenceFileName\n    documentTypeId\n    documentTypeName\n    isRequired\n    isSubmitted\n    isUploaded\n    status\n    requiresExpiryDate\n    requiresIssueDate\n    requiresIssueNumber\n    documentExpiryDate\n    documentIssueDate\n    documentIssueNumber\n    ...CandidateApplicationDocumentRow_document\n    ...CandidateApplicationDocumentDetail_document\n  }\n}\n\nfragment CandidateApplicationFormDetail_form on ApplicationForm {\n  id\n  applicationFormId\n  code\n  applicationId\n  createdAt\n  updatedAt\n  isEdited\n  isCompleted\n  isRequired\n  isSubmitted\n  formTemplateId\n  formTemplateName\n  fields {\n    key\n    value\n    skipped\n    type\n  }\n}\n\nfragment CandidateApplicationFormRow_form on ApplicationForm {\n  id\n  applicationFormId\n  code\n  createdAt\n  updatedAt\n  isEdited\n  isCompleted\n  isRequired\n  isSubmitted\n  formTemplateName\n  fields {\n    key\n    value\n    skipped\n    type\n  }\n}\n\nfragment CandidateApplicationForms_application on Application {\n  id\n  code\n  applicationId\n  vacancyName\n  candidate {\n    firstName\n    lastName\n    id\n  }\n  forms {\n    id\n    applicationFormId\n    code\n    createdAt\n    updatedAt\n    isEdited\n    isCompleted\n    isRequired\n    isSubmitted\n    formTemplateName\n    fields {\n      key\n      value\n      skipped\n      type\n    }\n    ...CandidateApplicationFormRow_form\n    ...CandidateApplicationFormDetail_form\n  }\n  hasCompletedForms\n}\n\nfragment CandidateApplicationLayout_applicationSearchResult on Application {\n  code\n  applicationId\n  candidateId\n  employerId\n  version\n  rightToWorkStatus\n  createdAt\n  workflowStateName\n  vacancy {\n    code\n    vacancyId\n    id\n    ...MatchRelevanceProvider_vacancy\n  }\n  matchRelevance {\n    ...MatchRelevanceProvider_relevance\n  }\n  matchProfile {\n    ...MatchRelevanceProvider_matchProfile\n  }\n  candidate {\n    accountId\n    ...DetailsComponent_candidate\n    id\n  }\n  profile {\n    rate {\n      countryCode\n      currencyCode\n      maximumRateOfPay\n      minimumRateOfPay\n      payType\n      id\n    }\n    recruitProfileId\n    ...Profile_profile\n    ...RecruitProfileApplicationHeader_application\n    ...CandidateApplicationProfile_profile\n    ...DetailsComponent_profile\n    id\n  }\n  ...CandidateApplicationRelevance_application\n  ...CandidateApplicationDocuments_application\n  ...CandidateApplicationForms_application\n  ...CandidateApplicationWorkflowContainer_application\n}\n\nfragment CandidateApplicationProfile_profile on RecruitProfile {\n  experiences {\n    items {\n      id\n      candidateExperienceId\n      title\n      companyName\n      startDate\n      endDate\n      ...ExperienceDetails_experience\n    }\n    skills {\n      name\n      lastUsed\n      periods {\n        startDate\n        endDate\n      }\n      averageMonthsUsed\n      totalMonthsUsed\n      totalPositionsUsed\n    }\n  }\n}\n\nfragment CandidateApplicationRelevance_application on Application {\n  code\n  vacancy {\n    code\n    id\n  }\n  profile {\n    recruitProfileId\n    id\n  }\n}\n\nfragment CandidateApplicationWorkflowContainer_application on Application {\n  id\n  applicationId\n  updatedAt\n  applicationStateId\n  applicationStateName\n  workflowStateId\n  workflowStateName\n  workflowDefinition {\n    id\n    name\n    states {\n      id\n      name\n      parentId\n      children {\n        id\n        name\n        parentId\n        actions {\n          id\n          workflowActionTransitionId\n          workflowDefinitionId\n          actionGroup\n          actionType\n          actionName\n          actionDialog\n          actionLabel\n          transitionId\n          nextStateId\n          currentStateId\n          securityContext {\n            users {\n              owner\n              permissions {\n                action\n                resource\n              }\n              userType\n            }\n          }\n        }\n        events {\n          id\n          eventName\n          transitionId\n          workflowDefinitionId\n          workflowEventTransitionId\n        }\n        transitions {\n          id\n          workflowTransitionId\n          workflowDefinitionId\n          currentStateId\n          currentStateName\n          nextStateId\n          nextStateName\n          activities {\n            id\n            workflowTransitionActivityId\n            transitionId\n            context {\n              workflowActivityType\n              workflowActivityParameters\n            }\n          }\n        }\n      }\n      actions {\n        id\n        workflowActionTransitionId\n        workflowDefinitionId\n        actionGroup\n        actionType\n        actionName\n        actionDialog\n        actionLabel\n        transitionId\n        nextStateId\n        currentStateId\n        securityContext {\n          users {\n            owner\n            permissions {\n              action\n              resource\n            }\n            userType\n          }\n        }\n      }\n      events {\n        id\n        eventName\n        transitionId\n        workflowDefinitionId\n        workflowEventTransitionId\n      }\n      transitions {\n        id\n        workflowTransitionId\n        workflowDefinitionId\n        currentStateId\n        currentStateName\n        nextStateId\n        nextStateName\n        activities {\n          id\n          workflowTransitionActivityId\n          transitionId\n          context {\n            workflowActivityType\n            workflowActivityParameters\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment DetailsComponent_candidate on AccountsCandidateAccount {\n  firstName\n  lastName\n  email\n  phone {\n    phoneNumber\n    phoneCountryPrefix\n    phoneVerificationStatus\n  }\n}\n\nfragment DetailsComponent_profile on RecruitProfile {\n  recruitProfileId\n  resume {\n    bucket\n    resumeId\n    fileKey\n    fileName\n    filePath\n    id\n  }\n}\n\nfragment ExperienceDetails_experience on RecruitProfileExperience {\n  id\n  createdOn\n  updatedOn\n  candidateExperienceId\n  version\n  titleId\n  title\n  industry\n  companyIsVerified\n  companyId\n  companyName\n  description\n  startDate\n  endDate\n  positionType\n  skills\n  escoOccupationId\n  escoHierarchy\n}\n\nfragment MatchRelevanceProvider_matchProfile on RecruitMatchProfile {\n  id\n  vacancyId\n  experience {\n    id\n    code\n    version\n    titleId\n    title\n    industry\n    companyIsVerified\n    companyId\n    companyName\n    description\n    startDate\n    endDate\n    positionType\n    skillGroupScores {\n      groupId\n      hasMatch\n      minSkillGroupScore\n      score\n      weight\n    }\n    escoOccupationId\n    escoHierarchy\n    jobMatchWeight\n    jobMatchScore\n    companyScore\n    companyScoreWeight\n    hasCompanyVector\n  }\n}\n\nfragment MatchRelevanceProvider_relevance on RecruitMatchRelevanceContainer {\n  skillGroups {\n    skillGroupId\n    numberOfMonthsCertain\n    numberOfMonthsCertainPlusUnknown\n    mostRecentCertainExperienceEnd\n    mostRecentUnknownExperienceEnd\n  }\n  industry {\n    numberOfMonthsCertain\n    numberOfMonthsCertainPlusUnknown\n    mostRecentCertainExperienceEnd\n    mostRecentUnknownExperienceEnd\n  }\n  job {\n    numberOfMonthsCertain\n    numberOfMonthsCertainPlusUnknown\n    mostRecentCertainExperienceEnd\n    mostRecentUnknownExperienceEnd\n  }\n}\n\nfragment MatchRelevanceProvider_vacancy on Vacancy {\n  id\n  code\n  skillGroups {\n    id\n    skillGroupId\n    name\n    isRequired\n    weight\n    terms {\n      name\n      isSkill\n    }\n    experience {\n      durationAmount\n      durationType\n    }\n    recency {\n      durationType\n      durationAmount\n    }\n  }\n  scoringConfig {\n    industryExperience {\n      durationAmount\n      durationType\n    }\n    industryNegativeThreshold\n    industryPositiveThreshold\n    industryRecency {\n      durationAmount\n      durationType\n    }\n    relevanceNegativeThreshold\n    relevancePositiveThreshold\n    relevantExperience {\n      durationAmount\n      durationType\n    }\n    relevantRecency {\n      durationAmount\n      durationType\n    }\n  }\n}\n\nfragment MultiFacetContainer_facet on DefaultAggregationModel {\n  count\n  key\n  title\n  values {\n    count\n    isSelected\n    name\n    text\n  }\n}\n\nfragment ProfileSearchResultTimeline_profile on RecruitProfile {\n  id\n  experiences {\n    items {\n      id\n      candidateExperienceId\n      title\n      companyId\n      companyIsVerified\n      companyName\n      description\n      startDate\n      endDate\n      skills\n    }\n    skills {\n      skillId\n      name\n      totalMonthsUsed\n      averageMonthsUsed\n      totalPositionsUsed\n      lastUsed\n      periods {\n        startDate\n        endDate\n      }\n    }\n  }\n}\n\nfragment ProfileSkillsFacetsContainer_facets on StandardAggregationResults {\n  skills {\n    count\n    ...MultiFacetContainer_facet\n  }\n}\n\nfragment Profile_profile on RecruitProfile {\n  code\n  firstName\n  lastName\n  recruitProfileId\n  emailAddress\n  notes {\n    code\n    content\n    tags {\n      name\n      value\n    }\n    updatedAt\n    createdByUser {\n      emailAddress\n      firstName\n      lastName\n    }\n    id\n  }\n  account {\n    accountId\n    phone {\n      phoneVerificationStatus\n      phoneNumber\n      phoneCountryPrefix\n    }\n    id\n  }\n  experience {\n    id\n    candidateExperienceId\n    title\n    companyName\n    startDate\n    endDate\n    ...ExperienceDetails_experience\n  }\n  ...RecruitProfileHeader_profile\n  ...ProfileSearchResultTimeline_profile\n}\n\nfragment RecruitProfileApplicationHeader_application on RecruitProfile {\n  id\n  firstName\n  lastName\n  workLocations {\n    currentLocationName\n    currentLocationCountryName\n    workLocations {\n      name\n    }\n    id\n  }\n  currentPosition {\n    title\n    companyName\n    startDate\n    endDate\n    id\n  }\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n  availability {\n    jobSearchStatus\n    availabilityStatus\n    noticeCriteria {\n      availableFrom\n      noticePeriodWeeks\n      noticeTimeframe\n    }\n    id\n  }\n}\n\nfragment RecruitProfileHeader_profile on RecruitProfile {\n  ...RecruitProfileApplicationHeader_application\n  id\n  recruitProfileId\n  firstName\n  lastName\n  profileType\n  workLocations {\n    currentLocationName\n    currentLocationCountryName\n    id\n  }\n  account {\n    accountId\n    id\n  }\n  currentPosition {\n    title\n    companyName\n    startDate\n    endDate\n    id\n  }\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n  rightToWork {\n    status\n    id\n  }\n  availability {\n    jobSearchStatus\n    id\n  }\n}\n\nfragment TagFacetFragment on DefaultAggregationModel {\n  count\n  key\n  title\n  values {\n    count\n    isSelected\n    name\n    text\n  }\n}\n\nfragment VacancyApplicationHeader_candidate on AccountsCandidateAccount {\n  firstName\n  lastName\n  email\n}\n\nfragment VacancyApplicationHeader_currentPosition on RecruitProfileExperience {\n  companyName\n  startDate\n  endDate\n  title\n}\n\nfragment VacancyApplicationSearchActiveFilters_results on ApplicationSearchResults {\n  pagination {\n    totalResults\n    itemsPerPage\n    pageNumber\n    pages\n  }\n  aggregations {\n    currentState {\n      ...TagFacetFragment\n      ...AggregationTags_Aggregation\n    }\n    applicationState {\n      ...AggregationTags_Aggregation\n    }\n    currentCompany {\n      ...AggregationTags_Aggregation\n    }\n    vacancy {\n      ...AggregationTags_Aggregation\n    }\n    project {\n      ...AggregationTags_Aggregation\n    }\n    dateCreated {\n      ...AggregationTags_Aggregation\n    }\n    skillGroups {\n      ...AggregationTags_Aggregation\n    }\n    jobExperienceRelevance {\n      ...AggregationTags_Aggregation\n    }\n    jobRecencyRelevance {\n      ...AggregationTags_Aggregation\n    }\n    industryExperienceRelevance {\n      ...AggregationTags_Aggregation\n    }\n    industryRecencyRelevance {\n      ...AggregationTags_Aggregation\n    }\n    standard {\n      companies {\n        ...AggregationTags_Aggregation\n      }\n      escoLevel1 {\n        ...AggregationTags_Aggregation\n      }\n      escoLevel2 {\n        ...AggregationTags_Aggregation\n      }\n      escoLevel3 {\n        ...AggregationTags_Aggregation\n      }\n      escoLevel4 {\n        ...AggregationTags_Aggregation\n      }\n      escoLevel5 {\n        ...AggregationTags_Aggregation\n      }\n      industries {\n        ...AggregationTags_Aggregation\n      }\n      skills {\n        ...AggregationTags_Aggregation\n      }\n      ...VacancyApplicationSearchFacets_results\n    }\n  }\n  results {\n    application {\n      applicationStateName\n      workflowStateName\n      id\n      code\n      applicationId\n      version\n      createdAt\n      updatedAt\n      appliedAt\n      applicantSource\n      candidate {\n        ...VacancyApplicationHeader_candidate\n        firstName\n        lastName\n        email\n        id\n      }\n      currentPosition {\n        ...VacancyApplicationHeader_currentPosition\n        id\n      }\n    }\n  }\n}\n\nfragment VacancyApplicationSearchFacets_aggregations on ApplicationSearchAggregations {\n  standard {\n    ...VacancyApplicationSearchFacets_results\n  }\n  project {\n    count\n    ...MultiFacetContainer_facet\n  }\n  dateCreated {\n    count\n    ...MultiFacetContainer_facet\n  }\n  vacancy {\n    count\n    ...MultiFacetContainer_facet\n  }\n  applicationState {\n    count\n    ...MultiFacetContainer_facet\n  }\n  currentState {\n    count\n    ...MultiFacetContainer_facet\n  }\n  industryExperienceRelevance {\n    count\n    ...MultiFacetContainer_facet\n  }\n  industryRecencyRelevance {\n    count\n    ...MultiFacetContainer_facet\n  }\n  jobExperienceRelevance {\n    count\n    ...MultiFacetContainer_facet\n  }\n  jobRecencyRelevance {\n    count\n    ...MultiFacetContainer_facet\n  }\n}\n\nfragment VacancyApplicationSearchFacets_results on StandardAggregationResults {\n  ...ProfileSkillsFacetsContainer_facets\n  companies {\n    count\n    ...MultiFacetContainer_facet\n  }\n  industries {\n    count\n    ...MultiFacetContainer_facet\n  }\n}\n\nfragment VacancyApplicationSearchFilters_results on ApplicationSearchResults {\n  aggregations {\n    ...VacancyApplicationSearchFacets_aggregations\n    standard {\n      ...VacancyApplicationSearchFacets_results\n    }\n  }\n}\n\nfragment VacancyApplicationSearchListHeader_results on ApplicationSearchResults {\n  pagination {\n    pages\n  }\n  ...VacancyApplicationSearchFilters_results\n  ...VacancyApplicationSearchActiveFilters_results\n  ...VacancyApplicationStatusFilters_results\n  ...VacancyApplicationSearchPaging_results\n}\n\nfragment VacancyApplicationSearchListResults_results on ApplicationSearchResults {\n  pagination {\n    totalResults\n    itemsPerPage\n    pageNumber\n    pages\n  }\n  aggregations {\n    applicationState {\n      key\n      title\n      count\n      values {\n        count\n        name\n        isSelected\n        text\n      }\n    }\n  }\n  results {\n    rankInVacancy\n    totalApplicationsInVacancy\n    application {\n      applicationStateName\n      workflowStateName\n      id\n      code\n      applicationId\n      version\n      createdAt\n      updatedAt\n      appliedAt\n      applicantSource\n      candidate {\n        ...VacancyApplicationHeader_candidate\n        firstName\n        lastName\n        email\n        id\n      }\n      currentPosition {\n        ...VacancyApplicationHeader_currentPosition\n        id\n      }\n      ...CandidateApplicationLayout_applicationSearchResult\n    }\n  }\n}\n\nfragment VacancyApplicationSearchList_query_2VV6jB on Query {\n  result: recruitApplicationSearch2(input: $input) {\n    ...VacancyApplicationSearchListResults_results\n    ...VacancyApplicationSearchListHeader_results\n    ...VacancyApplicationStatusFilters_results\n    ...VacancyApplicationSearchFilters_results\n    ...VacancyApplicationSearchPaging_results\n    ...VacancyApplicationSearchActiveFilters_results\n    aggregations {\n      applicationState {\n        ...MultiFacetContainer_facet\n      }\n      currentState {\n        ...MultiFacetContainer_facet\n      }\n    }\n    results {\n      application {\n        vacancy {\n          vacancyId\n          workflowDefinition {\n            id\n            name\n            states {\n              id\n              name\n              label\n              children {\n                id\n                name\n              }\n            }\n          }\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment VacancyApplicationSearchPaging_results on ApplicationSearchResults {\n  pagination {\n    pages\n    pageNumber\n    itemsPerPage\n    totalResults\n  }\n}\n\nfragment VacancyApplicationStatusFilters_results on ApplicationSearchResults {\n  pagination {\n    totalResults\n  }\n  aggregations {\n    applicationState {\n      key\n      title\n      count\n      values {\n        count\n        name\n        isSelected\n        text\n      }\n    }\n    currentState {\n      key\n      title\n      count\n      values {\n        count\n        name\n        isSelected\n        text\n      }\n    }\n  }\n}\n"
    }
  };
}();
node90.hash = "5bd8988dc6ae4e2c50b1ec8bc092f979";
var VacancyApplicationSearchListQuery_graphql_default = node90;

// src/candidates/components/__generated__/VacancyApplicationSearchListFragment.graphql.ts
var node91 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "key",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isSelected",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "text",
    "storageKey": null
  }, v8 = [
    v4,
    v23,
    v32,
    {
      "alias": null,
      "args": null,
      "concreteType": "DefaultAggregationValueModel",
      "kind": "LinkedField",
      "name": "values",
      "plural": true,
      "selections": [
        v4,
        v6,
        v5,
        v7
      ],
      "storageKey": null
    }
  ], v9 = [
    v32,
    {
      "alias": null,
      "args": null,
      "concreteType": "DefaultAggregationValueModel",
      "kind": "LinkedField",
      "name": "values",
      "plural": true,
      "selections": [
        v4,
        v7,
        v6,
        v5
      ],
      "storageKey": null
    }
  ], v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "applicationId",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "version",
    "storageKey": null
  }, v14 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  }, v15 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v16 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v17 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v18 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "accountId",
    "storageKey": null
  }, v19 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "phoneNumber",
    "storageKey": null
  }, v20 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "phoneCountryPrefix",
    "storageKey": null
  }, v21 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "phoneVerificationStatus",
    "storageKey": null
  }, v222 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyName",
    "storageKey": null
  }, v232 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "startDate",
    "storageKey": null
  }, v24 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "endDate",
    "storageKey": null
  }, v25 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "vacancyId",
    "storageKey": null
  }, v26 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "skillGroupId",
    "storageKey": null
  }, v27 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isRequired",
    "storageKey": null
  }, v28 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "weight",
    "storageKey": null
  }, v29 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationAmount",
    "storageKey": null
  }, v30 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationType",
    "storageKey": null
  }, v31 = [
    v29,
    v30
  ], v322 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "numberOfMonthsCertain",
    "storageKey": null
  }, v33 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "numberOfMonthsCertainPlusUnknown",
    "storageKey": null
  }, v34 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "mostRecentCertainExperienceEnd",
    "storageKey": null
  }, v35 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "mostRecentUnknownExperienceEnd",
    "storageKey": null
  }, v36 = [
    v322,
    v33,
    v34,
    v35
  ], v37 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "titleId",
    "storageKey": null
  }, v38 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "industry",
    "storageKey": null
  }, v39 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyIsVerified",
    "storageKey": null
  }, v40 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyId",
    "storageKey": null
  }, v41 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  }, v42 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "positionType",
    "storageKey": null
  }, v43 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "escoOccupationId",
    "storageKey": null
  }, v44 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "escoHierarchy",
    "storageKey": null
  }, v45 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "emailAddress",
    "storageKey": null
  }, v46 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }, v47 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateExperienceId",
    "storageKey": null
  }, v48 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdOn",
    "storageKey": null
  }, v49 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedOn",
    "storageKey": null
  }, v50 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "skills",
    "storageKey": null
  }, v51 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  }, v52 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isSubmitted",
    "storageKey": null
  }, v53 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }, v54 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "parentId",
    "storageKey": null
  }, v55 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "workflowDefinitionId",
    "storageKey": null
  }, v56 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "transitionId",
    "storageKey": null
  }, v57 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "nextStateId",
    "storageKey": null
  }, v58 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currentStateId",
    "storageKey": null
  }, v59 = {
    "alias": null,
    "args": null,
    "concreteType": "WorkflowActionTransition",
    "kind": "LinkedField",
    "name": "actions",
    "plural": true,
    "selections": [
      v10,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "workflowActionTransitionId",
        "storageKey": null
      },
      v55,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "actionGroup",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "actionType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "actionName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "actionDialog",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "actionLabel",
        "storageKey": null
      },
      v56,
      v57,
      v58,
      {
        "alias": null,
        "args": null,
        "concreteType": "WorkflowSecurityContext",
        "kind": "LinkedField",
        "name": "securityContext",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "WorkflowSecurityUser",
            "kind": "LinkedField",
            "name": "users",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "owner",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "WorkflowPermission",
                "kind": "LinkedField",
                "name": "permissions",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "action",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "resource",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userType",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v60 = {
    "alias": null,
    "args": null,
    "concreteType": "WorkflowEventTransition",
    "kind": "LinkedField",
    "name": "events",
    "plural": true,
    "selections": [
      v10,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "eventName",
        "storageKey": null
      },
      v56,
      v55,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "workflowEventTransitionId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v61 = {
    "alias": null,
    "args": null,
    "concreteType": "WorkflowTransition",
    "kind": "LinkedField",
    "name": "transitions",
    "plural": true,
    "selections": [
      v10,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "workflowTransitionId",
        "storageKey": null
      },
      v55,
      v58,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currentStateName",
        "storageKey": null
      },
      v57,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "nextStateName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "WorkflowTransitionActivity",
        "kind": "LinkedField",
        "name": "activities",
        "plural": true,
        "selections": [
          v10,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "workflowTransitionActivityId",
            "storageKey": null
          },
          v56,
          {
            "alias": null,
            "args": null,
            "concreteType": "WorkflowActivityContext",
            "kind": "LinkedField",
            "name": "context",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "workflowActivityType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "workflowActivityParameters",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "VacancyApplicationSearchListFragment",
      "selections": [
        {
          "args": v1,
          "kind": "FragmentSpread",
          "name": "VacancyApplicationSearchList_query"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "VacancyApplicationSearchListFragment",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "ApplicationSearchResults",
          "kind": "LinkedField",
          "name": "recruitApplicationSearch2",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CollectionMetaData",
              "kind": "LinkedField",
              "name": "pagination",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "totalResults",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "itemsPerPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "pageNumber",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "pages",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ApplicationSearchAggregations",
              "kind": "LinkedField",
              "name": "aggregations",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "applicationState",
                  "plural": false,
                  "selections": [
                    v23,
                    v32,
                    v4,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationValueModel",
                      "kind": "LinkedField",
                      "name": "values",
                      "plural": true,
                      "selections": [
                        v4,
                        v5,
                        v6,
                        v7
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "StandardAggregationResults",
                  "kind": "LinkedField",
                  "name": "standard",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "skills",
                      "plural": false,
                      "selections": v8,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "companies",
                      "plural": false,
                      "selections": v8,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "industries",
                      "plural": false,
                      "selections": v8,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "escoLevel1",
                      "plural": false,
                      "selections": v9,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "escoLevel2",
                      "plural": false,
                      "selections": v9,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "escoLevel3",
                      "plural": false,
                      "selections": v9,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "escoLevel4",
                      "plural": false,
                      "selections": v9,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "escoLevel5",
                      "plural": false,
                      "selections": v9,
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "project",
                  "plural": false,
                  "selections": v8,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "dateCreated",
                  "plural": false,
                  "selections": v8,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "vacancy",
                  "plural": false,
                  "selections": v8,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "currentState",
                  "plural": false,
                  "selections": v8,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "industryExperienceRelevance",
                  "plural": false,
                  "selections": v8,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "industryRecencyRelevance",
                  "plural": false,
                  "selections": v8,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "jobExperienceRelevance",
                  "plural": false,
                  "selections": v8,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "jobRecencyRelevance",
                  "plural": false,
                  "selections": v8,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "currentCompany",
                  "plural": false,
                  "selections": v9,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "skillGroups",
                  "plural": false,
                  "selections": v9,
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ApplicationSearchResult",
              "kind": "LinkedField",
              "name": "results",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "rankInVacancy",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "totalApplicationsInVacancy",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Application",
                  "kind": "LinkedField",
                  "name": "application",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "applicationStateName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "workflowStateName",
                      "storageKey": null
                    },
                    v10,
                    v11,
                    v12,
                    v13,
                    v14,
                    v15,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "appliedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "applicantSource",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountsCandidateAccount",
                      "kind": "LinkedField",
                      "name": "candidate",
                      "plural": false,
                      "selections": [
                        v16,
                        v17,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "email",
                          "storageKey": null
                        },
                        v10,
                        v18,
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "CandidatePhoneVerification",
                          "kind": "LinkedField",
                          "name": "phone",
                          "plural": false,
                          "selections": [
                            v19,
                            v20,
                            v21
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileExperience",
                      "kind": "LinkedField",
                      "name": "currentPosition",
                      "plural": false,
                      "selections": [
                        v222,
                        v232,
                        v24,
                        v32,
                        v10
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "candidateId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "rightToWorkStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Vacancy",
                      "kind": "LinkedField",
                      "name": "vacancy",
                      "plural": false,
                      "selections": [
                        v11,
                        v25,
                        v10,
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "SkillGroup",
                          "kind": "LinkedField",
                          "name": "skillGroups",
                          "plural": true,
                          "selections": [
                            v10,
                            v26,
                            v5,
                            v27,
                            v28,
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "SkillGroupTerm",
                              "kind": "LinkedField",
                              "name": "terms",
                              "plural": true,
                              "selections": [
                                v5,
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "isSkill",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Duration",
                              "kind": "LinkedField",
                              "name": "experience",
                              "plural": false,
                              "selections": v31,
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Duration",
                              "kind": "LinkedField",
                              "name": "recency",
                              "plural": false,
                              "selections": [
                                v30,
                                v29
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "VacancyScoringConfig",
                          "kind": "LinkedField",
                          "name": "scoringConfig",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Duration",
                              "kind": "LinkedField",
                              "name": "industryExperience",
                              "plural": false,
                              "selections": v31,
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "industryNegativeThreshold",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "industryPositiveThreshold",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Duration",
                              "kind": "LinkedField",
                              "name": "industryRecency",
                              "plural": false,
                              "selections": v31,
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "relevanceNegativeThreshold",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "relevancePositiveThreshold",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Duration",
                              "kind": "LinkedField",
                              "name": "relevantExperience",
                              "plural": false,
                              "selections": v31,
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Duration",
                              "kind": "LinkedField",
                              "name": "relevantRecency",
                              "plural": false,
                              "selections": v31,
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "WorkflowDefinition",
                          "kind": "LinkedField",
                          "name": "workflowDefinition",
                          "plural": false,
                          "selections": [
                            v10,
                            v5,
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "WorkflowState",
                              "kind": "LinkedField",
                              "name": "states",
                              "plural": true,
                              "selections": [
                                v10,
                                v5,
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "label",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "WorkflowState",
                                  "kind": "LinkedField",
                                  "name": "children",
                                  "plural": true,
                                  "selections": [
                                    v10,
                                    v5
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitMatchRelevanceContainer",
                      "kind": "LinkedField",
                      "name": "matchRelevance",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitMatchSkillRelevance",
                          "kind": "LinkedField",
                          "name": "skillGroups",
                          "plural": true,
                          "selections": [
                            v26,
                            v322,
                            v33,
                            v34,
                            v35
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitMatchRelevance",
                          "kind": "LinkedField",
                          "name": "industry",
                          "plural": false,
                          "selections": v36,
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitMatchRelevance",
                          "kind": "LinkedField",
                          "name": "job",
                          "plural": false,
                          "selections": v36,
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitMatchProfile",
                      "kind": "LinkedField",
                      "name": "matchProfile",
                      "plural": false,
                      "selections": [
                        v10,
                        v25,
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitMatchProfileExperience",
                          "kind": "LinkedField",
                          "name": "experience",
                          "plural": true,
                          "selections": [
                            v10,
                            v11,
                            v13,
                            v37,
                            v32,
                            v38,
                            v39,
                            v40,
                            v222,
                            v41,
                            v232,
                            v24,
                            v42,
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "MatchProfileExperienceSkillGroupScore",
                              "kind": "LinkedField",
                              "name": "skillGroupScores",
                              "plural": true,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "groupId",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "hasMatch",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "minSkillGroupScore",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "score",
                                  "storageKey": null
                                },
                                v28
                              ],
                              "storageKey": null
                            },
                            v43,
                            v44,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "jobMatchWeight",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "jobMatchScore",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "companyScore",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "companyScoreWeight",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "hasCompanyVector",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfile",
                      "kind": "LinkedField",
                      "name": "profile",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileRate",
                          "kind": "LinkedField",
                          "name": "rate",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "countryCode",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "currencyCode",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "maximumRateOfPay",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "minimumRateOfPay",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "payType",
                              "storageKey": null
                            },
                            v10
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "recruitProfileId",
                          "storageKey": null
                        },
                        v11,
                        v16,
                        v17,
                        v45,
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitCandidateProfileNote",
                          "kind": "LinkedField",
                          "name": "notes",
                          "plural": true,
                          "selections": [
                            v11,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "content",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "RecruitCandidateProfileNoteTag",
                              "kind": "LinkedField",
                              "name": "tags",
                              "plural": true,
                              "selections": [
                                v5,
                                v46
                              ],
                              "storageKey": null
                            },
                            v15,
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "AccountsUser",
                              "kind": "LinkedField",
                              "name": "createdByUser",
                              "plural": false,
                              "selections": [
                                v45,
                                v16,
                                v17
                              ],
                              "storageKey": null
                            },
                            v10
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "AccountsCandidateAccount",
                          "kind": "LinkedField",
                          "name": "account",
                          "plural": false,
                          "selections": [
                            v18,
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "CandidatePhoneVerification",
                              "kind": "LinkedField",
                              "name": "phone",
                              "plural": false,
                              "selections": [
                                v21,
                                v19,
                                v20
                              ],
                              "storageKey": null
                            },
                            v10
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileExperience",
                          "kind": "LinkedField",
                          "name": "experience",
                          "plural": true,
                          "selections": [
                            v10,
                            v47,
                            v32,
                            v222,
                            v232,
                            v24,
                            v48,
                            v49,
                            v13,
                            v37,
                            v38,
                            v39,
                            v40,
                            v41,
                            v42,
                            v50,
                            v43,
                            v44
                          ],
                          "storageKey": null
                        },
                        v10,
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileWorkLocations",
                          "kind": "LinkedField",
                          "name": "workLocations",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "currentLocationName",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "currentLocationCountryName",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "WorkLocationEntry",
                              "kind": "LinkedField",
                              "name": "workLocations",
                              "plural": true,
                              "selections": [
                                v5
                              ],
                              "storageKey": null
                            },
                            v10
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileExperience",
                          "kind": "LinkedField",
                          "name": "currentPosition",
                          "plural": false,
                          "selections": [
                            v32,
                            v222,
                            v232,
                            v24,
                            v10
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileAvailability",
                          "kind": "LinkedField",
                          "name": "availability",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "jobSearchStatus",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "availabilityStatus",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "NoticeCriteria",
                              "kind": "LinkedField",
                              "name": "noticeCriteria",
                              "plural": false,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "availableFrom",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "noticePeriodWeeks",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "noticeTimeframe",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            },
                            v10
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "profileType",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RightToWork",
                          "kind": "LinkedField",
                          "name": "rightToWork",
                          "plural": true,
                          "selections": [
                            v51,
                            v10
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileExperienceCollection",
                          "kind": "LinkedField",
                          "name": "experiences",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "RecruitProfileExperience",
                              "kind": "LinkedField",
                              "name": "items",
                              "plural": true,
                              "selections": [
                                v10,
                                v47,
                                v32,
                                v40,
                                v39,
                                v222,
                                v41,
                                v232,
                                v24,
                                v50,
                                v48,
                                v49,
                                v13,
                                v37,
                                v38,
                                v42,
                                v43,
                                v44
                              ],
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "SkillUsage",
                              "kind": "LinkedField",
                              "name": "skills",
                              "plural": true,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "skillId",
                                  "storageKey": null
                                },
                                v5,
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "totalMonthsUsed",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "averageMonthsUsed",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "totalPositionsUsed",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "lastUsed",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "DateRange",
                                  "kind": "LinkedField",
                                  "name": "periods",
                                  "plural": true,
                                  "selections": [
                                    v232,
                                    v24
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitResume",
                          "kind": "LinkedField",
                          "name": "resume",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "bucket",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "resumeId",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "fileKey",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "fileName",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "filePath",
                              "storageKey": null
                            },
                            v10
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ApplicationDocument",
                      "kind": "LinkedField",
                      "name": "documents",
                      "plural": true,
                      "selections": [
                        v10,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "applicationDocumentId",
                          "storageKey": null
                        },
                        v14,
                        v15,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "documentReferenceId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "documentReferenceFileName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "documentTypeId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "documentTypeName",
                          "storageKey": null
                        },
                        v27,
                        v52,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isUploaded",
                          "storageKey": null
                        },
                        v51,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "requiresExpiryDate",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "requiresIssueDate",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "requiresIssueNumber",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "documentExpiryDate",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "documentIssueDate",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "documentIssueNumber",
                          "storageKey": null
                        },
                        v12
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "vacancyName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ApplicationForm",
                      "kind": "LinkedField",
                      "name": "forms",
                      "plural": true,
                      "selections": [
                        v10,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "applicationFormId",
                          "storageKey": null
                        },
                        v11,
                        v14,
                        v15,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isEdited",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isCompleted",
                          "storageKey": null
                        },
                        v27,
                        v52,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "formTemplateName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "FormField",
                          "kind": "LinkedField",
                          "name": "fields",
                          "plural": true,
                          "selections": [
                            v23,
                            v46,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "skipped",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "type",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        v12,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "formTemplateId",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasCompletedForms",
                      "storageKey": null
                    },
                    v53,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "applicationStateId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "workflowStateId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "WorkflowDefinition",
                      "kind": "LinkedField",
                      "name": "workflowDefinition",
                      "plural": false,
                      "selections": [
                        v10,
                        v5,
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "WorkflowState",
                          "kind": "LinkedField",
                          "name": "states",
                          "plural": true,
                          "selections": [
                            v10,
                            v5,
                            v54,
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "WorkflowState",
                              "kind": "LinkedField",
                              "name": "children",
                              "plural": true,
                              "selections": [
                                v10,
                                v5,
                                v54,
                                v59,
                                v60,
                                v61
                              ],
                              "storageKey": null
                            },
                            v59,
                            v60,
                            v61
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v53
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "b6a4a130a63f5138bfd1f16d48808878",
      "id": null,
      "metadata": {},
      "name": "VacancyApplicationSearchListFragment",
      "operationKind": "query",
      "text": "query VacancyApplicationSearchListFragment(\n  $input: ApplicationSearchInput2Input!\n) {\n  ...VacancyApplicationSearchList_query_2VV6jB\n}\n\nfragment AggregationTags_Aggregation on DefaultAggregationModel {\n  title\n  values {\n    count\n    text\n    isSelected\n    name\n  }\n}\n\nfragment CandidateApplicationDocumentDetail_document on ApplicationDocument {\n  id\n  applicationDocumentId\n  applicationId\n  createdAt\n  updatedAt\n  documentReferenceId\n  documentReferenceFileName\n  documentTypeId\n  documentTypeName\n  isRequired\n  isSubmitted\n  isUploaded\n  status\n  requiresExpiryDate\n  requiresIssueDate\n  requiresIssueNumber\n  documentExpiryDate\n  documentIssueDate\n  documentIssueNumber\n}\n\nfragment CandidateApplicationDocumentRow_document on ApplicationDocument {\n  id\n  applicationDocumentId\n  createdAt\n  updatedAt\n  documentReferenceId\n  documentReferenceFileName\n  documentTypeId\n  documentTypeName\n  isRequired\n  isSubmitted\n  isUploaded\n  status\n  requiresExpiryDate\n  requiresIssueDate\n  requiresIssueNumber\n  documentExpiryDate\n  documentIssueDate\n  documentIssueNumber\n}\n\nfragment CandidateApplicationDocuments_application on Application {\n  documents {\n    id\n    applicationDocumentId\n    createdAt\n    updatedAt\n    documentReferenceId\n    documentReferenceFileName\n    documentTypeId\n    documentTypeName\n    isRequired\n    isSubmitted\n    isUploaded\n    status\n    requiresExpiryDate\n    requiresIssueDate\n    requiresIssueNumber\n    documentExpiryDate\n    documentIssueDate\n    documentIssueNumber\n    ...CandidateApplicationDocumentRow_document\n    ...CandidateApplicationDocumentDetail_document\n  }\n}\n\nfragment CandidateApplicationFormDetail_form on ApplicationForm {\n  id\n  applicationFormId\n  code\n  applicationId\n  createdAt\n  updatedAt\n  isEdited\n  isCompleted\n  isRequired\n  isSubmitted\n  formTemplateId\n  formTemplateName\n  fields {\n    key\n    value\n    skipped\n    type\n  }\n}\n\nfragment CandidateApplicationFormRow_form on ApplicationForm {\n  id\n  applicationFormId\n  code\n  createdAt\n  updatedAt\n  isEdited\n  isCompleted\n  isRequired\n  isSubmitted\n  formTemplateName\n  fields {\n    key\n    value\n    skipped\n    type\n  }\n}\n\nfragment CandidateApplicationForms_application on Application {\n  id\n  code\n  applicationId\n  vacancyName\n  candidate {\n    firstName\n    lastName\n    id\n  }\n  forms {\n    id\n    applicationFormId\n    code\n    createdAt\n    updatedAt\n    isEdited\n    isCompleted\n    isRequired\n    isSubmitted\n    formTemplateName\n    fields {\n      key\n      value\n      skipped\n      type\n    }\n    ...CandidateApplicationFormRow_form\n    ...CandidateApplicationFormDetail_form\n  }\n  hasCompletedForms\n}\n\nfragment CandidateApplicationLayout_applicationSearchResult on Application {\n  code\n  applicationId\n  candidateId\n  employerId\n  version\n  rightToWorkStatus\n  createdAt\n  workflowStateName\n  vacancy {\n    code\n    vacancyId\n    id\n    ...MatchRelevanceProvider_vacancy\n  }\n  matchRelevance {\n    ...MatchRelevanceProvider_relevance\n  }\n  matchProfile {\n    ...MatchRelevanceProvider_matchProfile\n  }\n  candidate {\n    accountId\n    ...DetailsComponent_candidate\n    id\n  }\n  profile {\n    rate {\n      countryCode\n      currencyCode\n      maximumRateOfPay\n      minimumRateOfPay\n      payType\n      id\n    }\n    recruitProfileId\n    ...Profile_profile\n    ...RecruitProfileApplicationHeader_application\n    ...CandidateApplicationProfile_profile\n    ...DetailsComponent_profile\n    id\n  }\n  ...CandidateApplicationRelevance_application\n  ...CandidateApplicationDocuments_application\n  ...CandidateApplicationForms_application\n  ...CandidateApplicationWorkflowContainer_application\n}\n\nfragment CandidateApplicationProfile_profile on RecruitProfile {\n  experiences {\n    items {\n      id\n      candidateExperienceId\n      title\n      companyName\n      startDate\n      endDate\n      ...ExperienceDetails_experience\n    }\n    skills {\n      name\n      lastUsed\n      periods {\n        startDate\n        endDate\n      }\n      averageMonthsUsed\n      totalMonthsUsed\n      totalPositionsUsed\n    }\n  }\n}\n\nfragment CandidateApplicationRelevance_application on Application {\n  code\n  vacancy {\n    code\n    id\n  }\n  profile {\n    recruitProfileId\n    id\n  }\n}\n\nfragment CandidateApplicationWorkflowContainer_application on Application {\n  id\n  applicationId\n  updatedAt\n  applicationStateId\n  applicationStateName\n  workflowStateId\n  workflowStateName\n  workflowDefinition {\n    id\n    name\n    states {\n      id\n      name\n      parentId\n      children {\n        id\n        name\n        parentId\n        actions {\n          id\n          workflowActionTransitionId\n          workflowDefinitionId\n          actionGroup\n          actionType\n          actionName\n          actionDialog\n          actionLabel\n          transitionId\n          nextStateId\n          currentStateId\n          securityContext {\n            users {\n              owner\n              permissions {\n                action\n                resource\n              }\n              userType\n            }\n          }\n        }\n        events {\n          id\n          eventName\n          transitionId\n          workflowDefinitionId\n          workflowEventTransitionId\n        }\n        transitions {\n          id\n          workflowTransitionId\n          workflowDefinitionId\n          currentStateId\n          currentStateName\n          nextStateId\n          nextStateName\n          activities {\n            id\n            workflowTransitionActivityId\n            transitionId\n            context {\n              workflowActivityType\n              workflowActivityParameters\n            }\n          }\n        }\n      }\n      actions {\n        id\n        workflowActionTransitionId\n        workflowDefinitionId\n        actionGroup\n        actionType\n        actionName\n        actionDialog\n        actionLabel\n        transitionId\n        nextStateId\n        currentStateId\n        securityContext {\n          users {\n            owner\n            permissions {\n              action\n              resource\n            }\n            userType\n          }\n        }\n      }\n      events {\n        id\n        eventName\n        transitionId\n        workflowDefinitionId\n        workflowEventTransitionId\n      }\n      transitions {\n        id\n        workflowTransitionId\n        workflowDefinitionId\n        currentStateId\n        currentStateName\n        nextStateId\n        nextStateName\n        activities {\n          id\n          workflowTransitionActivityId\n          transitionId\n          context {\n            workflowActivityType\n            workflowActivityParameters\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment DetailsComponent_candidate on AccountsCandidateAccount {\n  firstName\n  lastName\n  email\n  phone {\n    phoneNumber\n    phoneCountryPrefix\n    phoneVerificationStatus\n  }\n}\n\nfragment DetailsComponent_profile on RecruitProfile {\n  recruitProfileId\n  resume {\n    bucket\n    resumeId\n    fileKey\n    fileName\n    filePath\n    id\n  }\n}\n\nfragment ExperienceDetails_experience on RecruitProfileExperience {\n  id\n  createdOn\n  updatedOn\n  candidateExperienceId\n  version\n  titleId\n  title\n  industry\n  companyIsVerified\n  companyId\n  companyName\n  description\n  startDate\n  endDate\n  positionType\n  skills\n  escoOccupationId\n  escoHierarchy\n}\n\nfragment MatchRelevanceProvider_matchProfile on RecruitMatchProfile {\n  id\n  vacancyId\n  experience {\n    id\n    code\n    version\n    titleId\n    title\n    industry\n    companyIsVerified\n    companyId\n    companyName\n    description\n    startDate\n    endDate\n    positionType\n    skillGroupScores {\n      groupId\n      hasMatch\n      minSkillGroupScore\n      score\n      weight\n    }\n    escoOccupationId\n    escoHierarchy\n    jobMatchWeight\n    jobMatchScore\n    companyScore\n    companyScoreWeight\n    hasCompanyVector\n  }\n}\n\nfragment MatchRelevanceProvider_relevance on RecruitMatchRelevanceContainer {\n  skillGroups {\n    skillGroupId\n    numberOfMonthsCertain\n    numberOfMonthsCertainPlusUnknown\n    mostRecentCertainExperienceEnd\n    mostRecentUnknownExperienceEnd\n  }\n  industry {\n    numberOfMonthsCertain\n    numberOfMonthsCertainPlusUnknown\n    mostRecentCertainExperienceEnd\n    mostRecentUnknownExperienceEnd\n  }\n  job {\n    numberOfMonthsCertain\n    numberOfMonthsCertainPlusUnknown\n    mostRecentCertainExperienceEnd\n    mostRecentUnknownExperienceEnd\n  }\n}\n\nfragment MatchRelevanceProvider_vacancy on Vacancy {\n  id\n  code\n  skillGroups {\n    id\n    skillGroupId\n    name\n    isRequired\n    weight\n    terms {\n      name\n      isSkill\n    }\n    experience {\n      durationAmount\n      durationType\n    }\n    recency {\n      durationType\n      durationAmount\n    }\n  }\n  scoringConfig {\n    industryExperience {\n      durationAmount\n      durationType\n    }\n    industryNegativeThreshold\n    industryPositiveThreshold\n    industryRecency {\n      durationAmount\n      durationType\n    }\n    relevanceNegativeThreshold\n    relevancePositiveThreshold\n    relevantExperience {\n      durationAmount\n      durationType\n    }\n    relevantRecency {\n      durationAmount\n      durationType\n    }\n  }\n}\n\nfragment MultiFacetContainer_facet on DefaultAggregationModel {\n  count\n  key\n  title\n  values {\n    count\n    isSelected\n    name\n    text\n  }\n}\n\nfragment ProfileSearchResultTimeline_profile on RecruitProfile {\n  id\n  experiences {\n    items {\n      id\n      candidateExperienceId\n      title\n      companyId\n      companyIsVerified\n      companyName\n      description\n      startDate\n      endDate\n      skills\n    }\n    skills {\n      skillId\n      name\n      totalMonthsUsed\n      averageMonthsUsed\n      totalPositionsUsed\n      lastUsed\n      periods {\n        startDate\n        endDate\n      }\n    }\n  }\n}\n\nfragment ProfileSkillsFacetsContainer_facets on StandardAggregationResults {\n  skills {\n    count\n    ...MultiFacetContainer_facet\n  }\n}\n\nfragment Profile_profile on RecruitProfile {\n  code\n  firstName\n  lastName\n  recruitProfileId\n  emailAddress\n  notes {\n    code\n    content\n    tags {\n      name\n      value\n    }\n    updatedAt\n    createdByUser {\n      emailAddress\n      firstName\n      lastName\n    }\n    id\n  }\n  account {\n    accountId\n    phone {\n      phoneVerificationStatus\n      phoneNumber\n      phoneCountryPrefix\n    }\n    id\n  }\n  experience {\n    id\n    candidateExperienceId\n    title\n    companyName\n    startDate\n    endDate\n    ...ExperienceDetails_experience\n  }\n  ...RecruitProfileHeader_profile\n  ...ProfileSearchResultTimeline_profile\n}\n\nfragment RecruitProfileApplicationHeader_application on RecruitProfile {\n  id\n  firstName\n  lastName\n  workLocations {\n    currentLocationName\n    currentLocationCountryName\n    workLocations {\n      name\n    }\n    id\n  }\n  currentPosition {\n    title\n    companyName\n    startDate\n    endDate\n    id\n  }\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n  availability {\n    jobSearchStatus\n    availabilityStatus\n    noticeCriteria {\n      availableFrom\n      noticePeriodWeeks\n      noticeTimeframe\n    }\n    id\n  }\n}\n\nfragment RecruitProfileHeader_profile on RecruitProfile {\n  ...RecruitProfileApplicationHeader_application\n  id\n  recruitProfileId\n  firstName\n  lastName\n  profileType\n  workLocations {\n    currentLocationName\n    currentLocationCountryName\n    id\n  }\n  account {\n    accountId\n    id\n  }\n  currentPosition {\n    title\n    companyName\n    startDate\n    endDate\n    id\n  }\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n  rightToWork {\n    status\n    id\n  }\n  availability {\n    jobSearchStatus\n    id\n  }\n}\n\nfragment TagFacetFragment on DefaultAggregationModel {\n  count\n  key\n  title\n  values {\n    count\n    isSelected\n    name\n    text\n  }\n}\n\nfragment VacancyApplicationHeader_candidate on AccountsCandidateAccount {\n  firstName\n  lastName\n  email\n}\n\nfragment VacancyApplicationHeader_currentPosition on RecruitProfileExperience {\n  companyName\n  startDate\n  endDate\n  title\n}\n\nfragment VacancyApplicationSearchActiveFilters_results on ApplicationSearchResults {\n  pagination {\n    totalResults\n    itemsPerPage\n    pageNumber\n    pages\n  }\n  aggregations {\n    currentState {\n      ...TagFacetFragment\n      ...AggregationTags_Aggregation\n    }\n    applicationState {\n      ...AggregationTags_Aggregation\n    }\n    currentCompany {\n      ...AggregationTags_Aggregation\n    }\n    vacancy {\n      ...AggregationTags_Aggregation\n    }\n    project {\n      ...AggregationTags_Aggregation\n    }\n    dateCreated {\n      ...AggregationTags_Aggregation\n    }\n    skillGroups {\n      ...AggregationTags_Aggregation\n    }\n    jobExperienceRelevance {\n      ...AggregationTags_Aggregation\n    }\n    jobRecencyRelevance {\n      ...AggregationTags_Aggregation\n    }\n    industryExperienceRelevance {\n      ...AggregationTags_Aggregation\n    }\n    industryRecencyRelevance {\n      ...AggregationTags_Aggregation\n    }\n    standard {\n      companies {\n        ...AggregationTags_Aggregation\n      }\n      escoLevel1 {\n        ...AggregationTags_Aggregation\n      }\n      escoLevel2 {\n        ...AggregationTags_Aggregation\n      }\n      escoLevel3 {\n        ...AggregationTags_Aggregation\n      }\n      escoLevel4 {\n        ...AggregationTags_Aggregation\n      }\n      escoLevel5 {\n        ...AggregationTags_Aggregation\n      }\n      industries {\n        ...AggregationTags_Aggregation\n      }\n      skills {\n        ...AggregationTags_Aggregation\n      }\n      ...VacancyApplicationSearchFacets_results\n    }\n  }\n  results {\n    application {\n      applicationStateName\n      workflowStateName\n      id\n      code\n      applicationId\n      version\n      createdAt\n      updatedAt\n      appliedAt\n      applicantSource\n      candidate {\n        ...VacancyApplicationHeader_candidate\n        firstName\n        lastName\n        email\n        id\n      }\n      currentPosition {\n        ...VacancyApplicationHeader_currentPosition\n        id\n      }\n    }\n  }\n}\n\nfragment VacancyApplicationSearchFacets_aggregations on ApplicationSearchAggregations {\n  standard {\n    ...VacancyApplicationSearchFacets_results\n  }\n  project {\n    count\n    ...MultiFacetContainer_facet\n  }\n  dateCreated {\n    count\n    ...MultiFacetContainer_facet\n  }\n  vacancy {\n    count\n    ...MultiFacetContainer_facet\n  }\n  applicationState {\n    count\n    ...MultiFacetContainer_facet\n  }\n  currentState {\n    count\n    ...MultiFacetContainer_facet\n  }\n  industryExperienceRelevance {\n    count\n    ...MultiFacetContainer_facet\n  }\n  industryRecencyRelevance {\n    count\n    ...MultiFacetContainer_facet\n  }\n  jobExperienceRelevance {\n    count\n    ...MultiFacetContainer_facet\n  }\n  jobRecencyRelevance {\n    count\n    ...MultiFacetContainer_facet\n  }\n}\n\nfragment VacancyApplicationSearchFacets_results on StandardAggregationResults {\n  ...ProfileSkillsFacetsContainer_facets\n  companies {\n    count\n    ...MultiFacetContainer_facet\n  }\n  industries {\n    count\n    ...MultiFacetContainer_facet\n  }\n}\n\nfragment VacancyApplicationSearchFilters_results on ApplicationSearchResults {\n  aggregations {\n    ...VacancyApplicationSearchFacets_aggregations\n    standard {\n      ...VacancyApplicationSearchFacets_results\n    }\n  }\n}\n\nfragment VacancyApplicationSearchListHeader_results on ApplicationSearchResults {\n  pagination {\n    pages\n  }\n  ...VacancyApplicationSearchFilters_results\n  ...VacancyApplicationSearchActiveFilters_results\n  ...VacancyApplicationStatusFilters_results\n  ...VacancyApplicationSearchPaging_results\n}\n\nfragment VacancyApplicationSearchListResults_results on ApplicationSearchResults {\n  pagination {\n    totalResults\n    itemsPerPage\n    pageNumber\n    pages\n  }\n  aggregations {\n    applicationState {\n      key\n      title\n      count\n      values {\n        count\n        name\n        isSelected\n        text\n      }\n    }\n  }\n  results {\n    rankInVacancy\n    totalApplicationsInVacancy\n    application {\n      applicationStateName\n      workflowStateName\n      id\n      code\n      applicationId\n      version\n      createdAt\n      updatedAt\n      appliedAt\n      applicantSource\n      candidate {\n        ...VacancyApplicationHeader_candidate\n        firstName\n        lastName\n        email\n        id\n      }\n      currentPosition {\n        ...VacancyApplicationHeader_currentPosition\n        id\n      }\n      ...CandidateApplicationLayout_applicationSearchResult\n    }\n  }\n}\n\nfragment VacancyApplicationSearchList_query_2VV6jB on Query {\n  result: recruitApplicationSearch2(input: $input) {\n    ...VacancyApplicationSearchListResults_results\n    ...VacancyApplicationSearchListHeader_results\n    ...VacancyApplicationStatusFilters_results\n    ...VacancyApplicationSearchFilters_results\n    ...VacancyApplicationSearchPaging_results\n    ...VacancyApplicationSearchActiveFilters_results\n    aggregations {\n      applicationState {\n        ...MultiFacetContainer_facet\n      }\n      currentState {\n        ...MultiFacetContainer_facet\n      }\n    }\n    results {\n      application {\n        vacancy {\n          vacancyId\n          workflowDefinition {\n            id\n            name\n            states {\n              id\n              name\n              label\n              children {\n                id\n                name\n              }\n            }\n          }\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment VacancyApplicationSearchPaging_results on ApplicationSearchResults {\n  pagination {\n    pages\n    pageNumber\n    itemsPerPage\n    totalResults\n  }\n}\n\nfragment VacancyApplicationStatusFilters_results on ApplicationSearchResults {\n  pagination {\n    totalResults\n  }\n  aggregations {\n    applicationState {\n      key\n      title\n      count\n      values {\n        count\n        name\n        isSelected\n        text\n      }\n    }\n    currentState {\n      key\n      title\n      count\n      values {\n        count\n        name\n        isSelected\n        text\n      }\n    }\n  }\n}\n"
    }
  };
}();
node91.hash = "984907fe0977e7e40de134fb38c170c7";
var VacancyApplicationSearchListFragment_graphql_default = node91;

// src/candidates/components/__generated__/VacancyApplicationSearchList_query.graphql.ts
var node92 = function() {
  var v0 = [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MultiFacetContainer_facet"
    }
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "refetch": {
        "connection": null,
        "fragmentPathInResult": [],
        "operation": VacancyApplicationSearchListFragment_graphql_default
      }
    },
    "name": "VacancyApplicationSearchList_query",
    "selections": [
      {
        "alias": "result",
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "ApplicationSearchResults",
        "kind": "LinkedField",
        "name": "recruitApplicationSearch2",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "VacancyApplicationSearchListResults_results"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "VacancyApplicationSearchListHeader_results"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "VacancyApplicationStatusFilters_results"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "VacancyApplicationSearchFilters_results"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "VacancyApplicationSearchPaging_results"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "VacancyApplicationSearchActiveFilters_results"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ApplicationSearchAggregations",
            "kind": "LinkedField",
            "name": "aggregations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "applicationState",
                "plural": false,
                "selections": v0,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "currentState",
                "plural": false,
                "selections": v0,
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ApplicationSearchResult",
            "kind": "LinkedField",
            "name": "results",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Application",
                "kind": "LinkedField",
                "name": "application",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Vacancy",
                    "kind": "LinkedField",
                    "name": "vacancy",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "vacancyId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WorkflowDefinition",
                        "kind": "LinkedField",
                        "name": "workflowDefinition",
                        "plural": false,
                        "selections": [
                          v1,
                          v23,
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "WorkflowState",
                            "kind": "LinkedField",
                            "name": "states",
                            "plural": true,
                            "selections": [
                              v1,
                              v23,
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "label",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "WorkflowState",
                                "kind": "LinkedField",
                                "name": "children",
                                "plural": true,
                                "selections": [
                                  v1,
                                  v23
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node92.hash = "984907fe0977e7e40de134fb38c170c7";
var VacancyApplicationSearchList_query_graphql_default = node92;

// src/candidates/components/VacancyApplicationSearchList.tsx
import { Suspense as Suspense109, useCallback as useCallback180 } from "react";
import {
  usePreloadedQuery as usePreloadedQuery36,
  useRefetchableFragment as useRefetchableFragment12
} from "react-relay";
import { useAtom as useAtom14 } from "jotai";
import { Button as Button84, IconText as IconText5, classNames as classNames37 } from "shared-ui";
import { useToggle as useToggle33 } from "shared-lib";
import { Icons as Icons6 } from "shared-ui";
import { MultiFacetContainer as MultiFacetContainer7 } from "app-core";

// src/candidates/components/__generated__/VacancyApplicationSearchListResults_results.graphql.ts
var node93 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "VacancyApplicationSearchListResults_results",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CollectionMetaData",
        "kind": "LinkedField",
        "name": "pagination",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalResults",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "itemsPerPage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pageNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pages",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ApplicationSearchAggregations",
        "kind": "LinkedField",
        "name": "aggregations",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DefaultAggregationModel",
            "kind": "LinkedField",
            "name": "applicationState",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              v0,
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationValueModel",
                "kind": "LinkedField",
                "name": "values",
                "plural": true,
                "selections": [
                  v0,
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isSelected",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "text",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ApplicationSearchResult",
        "kind": "LinkedField",
        "name": "results",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rankInVacancy",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalApplicationsInVacancy",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Application",
            "kind": "LinkedField",
            "name": "application",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "applicationStateName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "workflowStateName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "code",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "applicationId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "version",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "appliedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "applicantSource",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountsCandidateAccount",
                "kind": "LinkedField",
                "name": "candidate",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "VacancyApplicationHeader_candidate"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "email",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitProfileExperience",
                "kind": "LinkedField",
                "name": "currentPosition",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "VacancyApplicationHeader_currentPosition"
                  }
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CandidateApplicationLayout_applicationSearchResult"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "ApplicationSearchResults",
    "abstractKey": null
  };
}();
node93.hash = "389f0b5b3326252f4870eadfc0e144d8";
var VacancyApplicationSearchListResults_results_graphql_default = node93;

// src/candidates/components/VacancyApplicationSearchListResults.tsx
import { Suspense as Suspense106 } from "react";
import { TrophyIcon } from "@heroicons/react/24/outline";
import { useFragment as useFragment94 } from "react-relay";
import { timeAgo as timeAgo8 } from "shared-lib";
import { Loading as Loading8, Tag as Tag21, workflowLabelMap as workflowLabelMap3 } from "shared-ui";
import { EdCard } from "shared-ui";

// src/candidates/components/__generated__/CandidateApplicationLayoutQuery.graphql.ts
var node94 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "applicationCode"
    }
  ], v1 = [
    {
      "fields": [
        {
          "fields": [
            {
              "items": [
                {
                  "kind": "Variable",
                  "name": "applicationCodes.0",
                  "variableName": "applicationCode"
                }
              ],
              "kind": "ListValue",
              "name": "applicationCodes"
            }
          ],
          "kind": "ObjectValue",
          "name": "filters"
        },
        {
          "kind": "Literal",
          "name": "pagination",
          "value": {
            "pageNumber": 1,
            "pageSize": 1
          }
        },
        {
          "kind": "Literal",
          "name": "sort",
          "value": {
            "field": {
              "standard": "NAME"
            },
            "order": "ASC"
          }
        }
      ],
      "kind": "ObjectValue",
      "name": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "rankInVacancy",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "totalApplicationsInVacancy",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "concreteType": "ApplicationSearchAggregations",
    "kind": "LinkedField",
    "name": "aggregations",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "DefaultAggregationModel",
        "kind": "LinkedField",
        "name": "applicationState",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DefaultAggregationValueModel",
            "kind": "LinkedField",
            "name": "values",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "count",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v5 = [
    {
      "kind": "Variable",
      "name": "applicationCode",
      "variableName": "applicationCode"
    }
  ], v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "version",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "applicationId",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "vacancyName",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "accountId",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v14 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "applicationStateName",
    "storageKey": null
  }, v15 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "workflowStateName",
    "storageKey": null
  }, v16 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "employerId",
    "storageKey": null
  }, v17 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "employerName",
    "storageKey": null
  }, v18 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "vacancyId",
    "storageKey": null
  }, v19 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v20 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "publicDescriptionHtml",
    "storageKey": null
  }, v21 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "employerReference",
    "storageKey": null
  }, v222 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "recruitProfileId",
    "storageKey": null
  }, v232 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "skillGroupId",
    "storageKey": null
  }, v24 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "numberOfMonthsCertain",
    "storageKey": null
  }, v25 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "numberOfMonthsCertainPlusUnknown",
    "storageKey": null
  }, v26 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "mostRecentCertainExperienceEnd",
    "storageKey": null
  }, v27 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "mostRecentUnknownExperienceEnd",
    "storageKey": null
  }, v28 = [
    v24,
    v25,
    v26,
    v27
  ], v29 = {
    "alias": null,
    "args": null,
    "concreteType": "RecruitMatchRelevanceContainer",
    "kind": "LinkedField",
    "name": "matchRelevance",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitMatchSkillRelevance",
        "kind": "LinkedField",
        "name": "skillGroups",
        "plural": true,
        "selections": [
          v232,
          v24,
          v25,
          v26,
          v27
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitMatchRelevance",
        "kind": "LinkedField",
        "name": "industry",
        "plural": false,
        "selections": v28,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitMatchRelevance",
        "kind": "LinkedField",
        "name": "job",
        "plural": false,
        "selections": v28,
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v30 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }, v31 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  }, v322 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isRequired",
    "storageKey": null
  }, v33 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "weight",
    "storageKey": null
  }, v34 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationAmount",
    "storageKey": null
  }, v35 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationType",
    "storageKey": null
  }, v36 = [
    v34,
    v35
  ], v37 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "titleId",
    "storageKey": null
  }, v38 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  }, v39 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "industry",
    "storageKey": null
  }, v40 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyIsVerified",
    "storageKey": null
  }, v41 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyId",
    "storageKey": null
  }, v42 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyName",
    "storageKey": null
  }, v43 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  }, v44 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "startDate",
    "storageKey": null
  }, v45 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "endDate",
    "storageKey": null
  }, v46 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "positionType",
    "storageKey": null
  }, v47 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "escoOccupationId",
    "storageKey": null
  }, v48 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "escoHierarchy",
    "storageKey": null
  }, v49 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "phoneNumber",
    "storageKey": null
  }, v50 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "phoneCountryPrefix",
    "storageKey": null
  }, v51 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "phoneVerificationStatus",
    "storageKey": null
  }, v52 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "countryCode",
    "storageKey": null
  }, v53 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currencyCode",
    "storageKey": null
  }, v54 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "maximumRateOfPay",
    "storageKey": null
  }, v55 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "minimumRateOfPay",
    "storageKey": null
  }, v56 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "payType",
    "storageKey": null
  }, v57 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "emailAddress",
    "storageKey": null
  }, v58 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }, v59 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v60 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateExperienceId",
    "storageKey": null
  }, v61 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdOn",
    "storageKey": null
  }, v62 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedOn",
    "storageKey": null
  }, v63 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "skills",
    "storageKey": null
  }, v64 = {
    "alias": null,
    "args": null,
    "concreteType": "RecruitProfileWorkLocations",
    "kind": "LinkedField",
    "name": "workLocations",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currentLocationName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currentLocationCountryName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "WorkLocationEntry",
        "kind": "LinkedField",
        "name": "workLocations",
        "plural": true,
        "selections": [
          v19
        ],
        "storageKey": null
      },
      v6
    ],
    "storageKey": null
  }, v65 = {
    "alias": null,
    "args": null,
    "concreteType": "RecruitProfileExperience",
    "kind": "LinkedField",
    "name": "currentPosition",
    "plural": false,
    "selections": [
      v38,
      v42,
      v44,
      v45,
      v6
    ],
    "storageKey": null
  }, v66 = {
    "alias": null,
    "args": null,
    "concreteType": "RecruitProfileAvailability",
    "kind": "LinkedField",
    "name": "availability",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "jobSearchStatus",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "availabilityStatus",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "NoticeCriteria",
        "kind": "LinkedField",
        "name": "noticeCriteria",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "availableFrom",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "noticePeriodWeeks",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "noticeTimeframe",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      v6
    ],
    "storageKey": null
  }, v67 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "profileType",
    "storageKey": null
  }, v68 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  }, v69 = {
    "alias": null,
    "args": null,
    "concreteType": "RightToWork",
    "kind": "LinkedField",
    "name": "rightToWork",
    "plural": true,
    "selections": [
      v68,
      v6
    ],
    "storageKey": null
  }, v70 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isSubmitted",
    "storageKey": null
  }, v71 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "applicationStateId",
    "storageKey": null
  }, v72 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "workflowStateId",
    "storageKey": null
  }, v73 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "parentId",
    "storageKey": null
  }, v74 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "workflowDefinitionId",
    "storageKey": null
  }, v75 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "transitionId",
    "storageKey": null
  }, v76 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "nextStateId",
    "storageKey": null
  }, v77 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currentStateId",
    "storageKey": null
  }, v78 = {
    "alias": null,
    "args": null,
    "concreteType": "WorkflowActionTransition",
    "kind": "LinkedField",
    "name": "actions",
    "plural": true,
    "selections": [
      v6,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "workflowActionTransitionId",
        "storageKey": null
      },
      v74,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "actionGroup",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "actionType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "actionName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "actionDialog",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "actionLabel",
        "storageKey": null
      },
      v75,
      v76,
      v77,
      {
        "alias": null,
        "args": null,
        "concreteType": "WorkflowSecurityContext",
        "kind": "LinkedField",
        "name": "securityContext",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "WorkflowSecurityUser",
            "kind": "LinkedField",
            "name": "users",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "owner",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "WorkflowPermission",
                "kind": "LinkedField",
                "name": "permissions",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "action",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "resource",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userType",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v79 = {
    "alias": null,
    "args": null,
    "concreteType": "WorkflowEventTransition",
    "kind": "LinkedField",
    "name": "events",
    "plural": true,
    "selections": [
      v6,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "eventName",
        "storageKey": null
      },
      v75,
      v74,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "workflowEventTransitionId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v80 = {
    "alias": null,
    "args": null,
    "concreteType": "WorkflowTransition",
    "kind": "LinkedField",
    "name": "transitions",
    "plural": true,
    "selections": [
      v6,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "workflowTransitionId",
        "storageKey": null
      },
      v74,
      v77,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currentStateName",
        "storageKey": null
      },
      v76,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "nextStateName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "WorkflowTransitionActivity",
        "kind": "LinkedField",
        "name": "activities",
        "plural": true,
        "selections": [
          v6,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "workflowTransitionActivityId",
            "storageKey": null
          },
          v75,
          {
            "alias": null,
            "args": null,
            "concreteType": "WorkflowActivityContext",
            "kind": "LinkedField",
            "name": "context",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "workflowActivityType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "workflowActivityParameters",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v81 = {
    "alias": null,
    "args": null,
    "concreteType": "WorkflowDefinition",
    "kind": "LinkedField",
    "name": "workflowDefinition",
    "plural": false,
    "selections": [
      v6,
      v19,
      {
        "alias": null,
        "args": null,
        "concreteType": "WorkflowState",
        "kind": "LinkedField",
        "name": "states",
        "plural": true,
        "selections": [
          v6,
          v19,
          v73,
          {
            "alias": null,
            "args": null,
            "concreteType": "WorkflowState",
            "kind": "LinkedField",
            "name": "children",
            "plural": true,
            "selections": [
              v6,
              v19,
              v73,
              v78,
              v79,
              v80
            ],
            "storageKey": null
          },
          v78,
          v79,
          v80
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateApplicationLayoutQuery",
      "selections": [
        {
          "alias": "applicationSearch",
          "args": v1,
          "concreteType": "ApplicationSearchResults",
          "kind": "LinkedField",
          "name": "recruitApplicationSearch2",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ApplicationSearchResult",
              "kind": "LinkedField",
              "name": "results",
              "plural": true,
              "selections": [
                v23,
                v32,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Application",
                  "kind": "LinkedField",
                  "name": "application",
                  "plural": false,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "CandidateApplicationLayout_applicationSearchResult"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v4
          ],
          "storageKey": null
        },
        {
          "alias": "application",
          "args": v5,
          "concreteType": "Application",
          "kind": "LinkedField",
          "name": "applicationByCode",
          "plural": false,
          "selections": [
            v6,
            v7,
            v8,
            v9,
            v10,
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "candidate",
              "plural": false,
              "selections": [
                v11,
                v12,
                v13
              ],
              "storageKey": null
            },
            v14,
            v15,
            v16,
            v17,
            {
              "alias": null,
              "args": null,
              "concreteType": "Vacancy",
              "kind": "LinkedField",
              "name": "vacancy",
              "plural": false,
              "selections": [
                v18,
                v19,
                v7,
                v20,
                v21
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfile",
              "kind": "LinkedField",
              "name": "profile",
              "plural": false,
              "selections": [
                v222,
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "RecruitProfileHeader_profile"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "RecruitProfileApplicationHeader_application"
                }
              ],
              "storageKey": null
            },
            v29,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "CandidateApplicationWorkflowContainer_application"
            },
            v30
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateApplicationLayoutQuery",
      "selections": [
        {
          "alias": "applicationSearch",
          "args": v1,
          "concreteType": "ApplicationSearchResults",
          "kind": "LinkedField",
          "name": "recruitApplicationSearch2",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ApplicationSearchResult",
              "kind": "LinkedField",
              "name": "results",
              "plural": true,
              "selections": [
                v23,
                v32,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Application",
                  "kind": "LinkedField",
                  "name": "application",
                  "plural": false,
                  "selections": [
                    v7,
                    v9,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "candidateId",
                      "storageKey": null
                    },
                    v16,
                    v8,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "rightToWorkStatus",
                      "storageKey": null
                    },
                    v31,
                    v15,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Vacancy",
                      "kind": "LinkedField",
                      "name": "vacancy",
                      "plural": false,
                      "selections": [
                        v7,
                        v18,
                        v6,
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "SkillGroup",
                          "kind": "LinkedField",
                          "name": "skillGroups",
                          "plural": true,
                          "selections": [
                            v6,
                            v232,
                            v19,
                            v322,
                            v33,
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "SkillGroupTerm",
                              "kind": "LinkedField",
                              "name": "terms",
                              "plural": true,
                              "selections": [
                                v19,
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "isSkill",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Duration",
                              "kind": "LinkedField",
                              "name": "experience",
                              "plural": false,
                              "selections": v36,
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Duration",
                              "kind": "LinkedField",
                              "name": "recency",
                              "plural": false,
                              "selections": [
                                v35,
                                v34
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "VacancyScoringConfig",
                          "kind": "LinkedField",
                          "name": "scoringConfig",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Duration",
                              "kind": "LinkedField",
                              "name": "industryExperience",
                              "plural": false,
                              "selections": v36,
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "industryNegativeThreshold",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "industryPositiveThreshold",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Duration",
                              "kind": "LinkedField",
                              "name": "industryRecency",
                              "plural": false,
                              "selections": v36,
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "relevanceNegativeThreshold",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "relevancePositiveThreshold",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Duration",
                              "kind": "LinkedField",
                              "name": "relevantExperience",
                              "plural": false,
                              "selections": v36,
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Duration",
                              "kind": "LinkedField",
                              "name": "relevantRecency",
                              "plural": false,
                              "selections": v36,
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    v29,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitMatchProfile",
                      "kind": "LinkedField",
                      "name": "matchProfile",
                      "plural": false,
                      "selections": [
                        v6,
                        v18,
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitMatchProfileExperience",
                          "kind": "LinkedField",
                          "name": "experience",
                          "plural": true,
                          "selections": [
                            v6,
                            v7,
                            v8,
                            v37,
                            v38,
                            v39,
                            v40,
                            v41,
                            v42,
                            v43,
                            v44,
                            v45,
                            v46,
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "MatchProfileExperienceSkillGroupScore",
                              "kind": "LinkedField",
                              "name": "skillGroupScores",
                              "plural": true,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "groupId",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "hasMatch",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "minSkillGroupScore",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "score",
                                  "storageKey": null
                                },
                                v33
                              ],
                              "storageKey": null
                            },
                            v47,
                            v48,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "jobMatchWeight",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "jobMatchScore",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "companyScore",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "companyScoreWeight",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "hasCompanyVector",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountsCandidateAccount",
                      "kind": "LinkedField",
                      "name": "candidate",
                      "plural": false,
                      "selections": [
                        v11,
                        v12,
                        v13,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "email",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "CandidatePhoneVerification",
                          "kind": "LinkedField",
                          "name": "phone",
                          "plural": false,
                          "selections": [
                            v49,
                            v50,
                            v51
                          ],
                          "storageKey": null
                        },
                        v6
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfile",
                      "kind": "LinkedField",
                      "name": "profile",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileRate",
                          "kind": "LinkedField",
                          "name": "rate",
                          "plural": false,
                          "selections": [
                            v52,
                            v53,
                            v54,
                            v55,
                            v56,
                            v6
                          ],
                          "storageKey": null
                        },
                        v222,
                        v7,
                        v12,
                        v13,
                        v57,
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitCandidateProfileNote",
                          "kind": "LinkedField",
                          "name": "notes",
                          "plural": true,
                          "selections": [
                            v7,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "content",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "RecruitCandidateProfileNoteTag",
                              "kind": "LinkedField",
                              "name": "tags",
                              "plural": true,
                              "selections": [
                                v19,
                                v58
                              ],
                              "storageKey": null
                            },
                            v59,
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "AccountsUser",
                              "kind": "LinkedField",
                              "name": "createdByUser",
                              "plural": false,
                              "selections": [
                                v57,
                                v12,
                                v13
                              ],
                              "storageKey": null
                            },
                            v6
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "AccountsCandidateAccount",
                          "kind": "LinkedField",
                          "name": "account",
                          "plural": false,
                          "selections": [
                            v11,
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "CandidatePhoneVerification",
                              "kind": "LinkedField",
                              "name": "phone",
                              "plural": false,
                              "selections": [
                                v51,
                                v49,
                                v50
                              ],
                              "storageKey": null
                            },
                            v6
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileExperience",
                          "kind": "LinkedField",
                          "name": "experience",
                          "plural": true,
                          "selections": [
                            v6,
                            v60,
                            v38,
                            v42,
                            v44,
                            v45,
                            v61,
                            v62,
                            v8,
                            v37,
                            v39,
                            v40,
                            v41,
                            v43,
                            v46,
                            v63,
                            v47,
                            v48
                          ],
                          "storageKey": null
                        },
                        v6,
                        v64,
                        v65,
                        v66,
                        v67,
                        v69,
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileExperienceCollection",
                          "kind": "LinkedField",
                          "name": "experiences",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "RecruitProfileExperience",
                              "kind": "LinkedField",
                              "name": "items",
                              "plural": true,
                              "selections": [
                                v6,
                                v60,
                                v38,
                                v41,
                                v40,
                                v42,
                                v43,
                                v44,
                                v45,
                                v63,
                                v61,
                                v62,
                                v8,
                                v37,
                                v39,
                                v46,
                                v47,
                                v48
                              ],
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "SkillUsage",
                              "kind": "LinkedField",
                              "name": "skills",
                              "plural": true,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "skillId",
                                  "storageKey": null
                                },
                                v19,
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "totalMonthsUsed",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "averageMonthsUsed",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "totalPositionsUsed",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "lastUsed",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "DateRange",
                                  "kind": "LinkedField",
                                  "name": "periods",
                                  "plural": true,
                                  "selections": [
                                    v44,
                                    v45
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitResume",
                          "kind": "LinkedField",
                          "name": "resume",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "bucket",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "resumeId",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "fileKey",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "fileName",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "filePath",
                              "storageKey": null
                            },
                            v6
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ApplicationDocument",
                      "kind": "LinkedField",
                      "name": "documents",
                      "plural": true,
                      "selections": [
                        v6,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "applicationDocumentId",
                          "storageKey": null
                        },
                        v31,
                        v59,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "documentReferenceId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "documentReferenceFileName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "documentTypeId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "documentTypeName",
                          "storageKey": null
                        },
                        v322,
                        v70,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isUploaded",
                          "storageKey": null
                        },
                        v68,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "requiresExpiryDate",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "requiresIssueDate",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "requiresIssueNumber",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "documentExpiryDate",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "documentIssueDate",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "documentIssueNumber",
                          "storageKey": null
                        },
                        v9
                      ],
                      "storageKey": null
                    },
                    v6,
                    v10,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ApplicationForm",
                      "kind": "LinkedField",
                      "name": "forms",
                      "plural": true,
                      "selections": [
                        v6,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "applicationFormId",
                          "storageKey": null
                        },
                        v7,
                        v31,
                        v59,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isEdited",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isCompleted",
                          "storageKey": null
                        },
                        v322,
                        v70,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "formTemplateName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "FormField",
                          "kind": "LinkedField",
                          "name": "fields",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "key",
                              "storageKey": null
                            },
                            v58,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "skipped",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "type",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        v9,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "formTemplateId",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasCompletedForms",
                      "storageKey": null
                    },
                    v30,
                    v59,
                    v71,
                    v14,
                    v72,
                    v81
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v4
          ],
          "storageKey": null
        },
        {
          "alias": "application",
          "args": v5,
          "concreteType": "Application",
          "kind": "LinkedField",
          "name": "applicationByCode",
          "plural": false,
          "selections": [
            v6,
            v7,
            v8,
            v9,
            v10,
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "candidate",
              "plural": false,
              "selections": [
                v11,
                v12,
                v13,
                v6
              ],
              "storageKey": null
            },
            v14,
            v15,
            v16,
            v17,
            {
              "alias": null,
              "args": null,
              "concreteType": "Vacancy",
              "kind": "LinkedField",
              "name": "vacancy",
              "plural": false,
              "selections": [
                v18,
                v19,
                v7,
                v20,
                v21,
                v6
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfile",
              "kind": "LinkedField",
              "name": "profile",
              "plural": false,
              "selections": [
                v222,
                v6,
                v12,
                v13,
                v64,
                v65,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileRate",
                  "kind": "LinkedField",
                  "name": "rate",
                  "plural": false,
                  "selections": [
                    v56,
                    v55,
                    v54,
                    v52,
                    v53,
                    v6
                  ],
                  "storageKey": null
                },
                v66,
                v67,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsCandidateAccount",
                  "kind": "LinkedField",
                  "name": "account",
                  "plural": false,
                  "selections": [
                    v11,
                    v6
                  ],
                  "storageKey": null
                },
                v69
              ],
              "storageKey": null
            },
            v29,
            v59,
            v71,
            v72,
            v81,
            v30
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "fb3d5157eb3067c1a2e37d6a0a173e21",
      "id": null,
      "metadata": {},
      "name": "CandidateApplicationLayoutQuery",
      "operationKind": "query",
      "text": "query CandidateApplicationLayoutQuery(\n  $applicationCode: Int!\n) {\n  applicationSearch: recruitApplicationSearch2(input: {filters: {applicationCodes: [$applicationCode]}, pagination: {pageNumber: 1, pageSize: 1}, sort: {field: {standard: NAME}, order: ASC}}) {\n    results {\n      rankInVacancy\n      totalApplicationsInVacancy\n      application {\n        ...CandidateApplicationLayout_applicationSearchResult\n        id\n      }\n    }\n    aggregations {\n      applicationState {\n        values {\n          count\n        }\n      }\n    }\n  }\n  application: applicationByCode(applicationCode: $applicationCode) {\n    id\n    code\n    version\n    applicationId\n    vacancyName\n    candidate {\n      accountId\n      firstName\n      lastName\n      id\n    }\n    applicationStateName\n    workflowStateName\n    employerId\n    employerName\n    vacancy {\n      vacancyId\n      name\n      code\n      publicDescriptionHtml\n      employerReference\n      id\n    }\n    profile {\n      recruitProfileId\n      ...RecruitProfileHeader_profile\n      ...RecruitProfileApplicationHeader_application\n      id\n    }\n    matchRelevance {\n      skillGroups {\n        skillGroupId\n        numberOfMonthsCertain\n        numberOfMonthsCertainPlusUnknown\n        mostRecentCertainExperienceEnd\n        mostRecentUnknownExperienceEnd\n      }\n      industry {\n        numberOfMonthsCertain\n        numberOfMonthsCertainPlusUnknown\n        mostRecentCertainExperienceEnd\n        mostRecentUnknownExperienceEnd\n      }\n      job {\n        numberOfMonthsCertain\n        numberOfMonthsCertainPlusUnknown\n        mostRecentCertainExperienceEnd\n        mostRecentUnknownExperienceEnd\n      }\n    }\n    ...CandidateApplicationWorkflowContainer_application\n  }\n}\n\nfragment CandidateApplicationDocumentDetail_document on ApplicationDocument {\n  id\n  applicationDocumentId\n  applicationId\n  createdAt\n  updatedAt\n  documentReferenceId\n  documentReferenceFileName\n  documentTypeId\n  documentTypeName\n  isRequired\n  isSubmitted\n  isUploaded\n  status\n  requiresExpiryDate\n  requiresIssueDate\n  requiresIssueNumber\n  documentExpiryDate\n  documentIssueDate\n  documentIssueNumber\n}\n\nfragment CandidateApplicationDocumentRow_document on ApplicationDocument {\n  id\n  applicationDocumentId\n  createdAt\n  updatedAt\n  documentReferenceId\n  documentReferenceFileName\n  documentTypeId\n  documentTypeName\n  isRequired\n  isSubmitted\n  isUploaded\n  status\n  requiresExpiryDate\n  requiresIssueDate\n  requiresIssueNumber\n  documentExpiryDate\n  documentIssueDate\n  documentIssueNumber\n}\n\nfragment CandidateApplicationDocuments_application on Application {\n  documents {\n    id\n    applicationDocumentId\n    createdAt\n    updatedAt\n    documentReferenceId\n    documentReferenceFileName\n    documentTypeId\n    documentTypeName\n    isRequired\n    isSubmitted\n    isUploaded\n    status\n    requiresExpiryDate\n    requiresIssueDate\n    requiresIssueNumber\n    documentExpiryDate\n    documentIssueDate\n    documentIssueNumber\n    ...CandidateApplicationDocumentRow_document\n    ...CandidateApplicationDocumentDetail_document\n  }\n}\n\nfragment CandidateApplicationFormDetail_form on ApplicationForm {\n  id\n  applicationFormId\n  code\n  applicationId\n  createdAt\n  updatedAt\n  isEdited\n  isCompleted\n  isRequired\n  isSubmitted\n  formTemplateId\n  formTemplateName\n  fields {\n    key\n    value\n    skipped\n    type\n  }\n}\n\nfragment CandidateApplicationFormRow_form on ApplicationForm {\n  id\n  applicationFormId\n  code\n  createdAt\n  updatedAt\n  isEdited\n  isCompleted\n  isRequired\n  isSubmitted\n  formTemplateName\n  fields {\n    key\n    value\n    skipped\n    type\n  }\n}\n\nfragment CandidateApplicationForms_application on Application {\n  id\n  code\n  applicationId\n  vacancyName\n  candidate {\n    firstName\n    lastName\n    id\n  }\n  forms {\n    id\n    applicationFormId\n    code\n    createdAt\n    updatedAt\n    isEdited\n    isCompleted\n    isRequired\n    isSubmitted\n    formTemplateName\n    fields {\n      key\n      value\n      skipped\n      type\n    }\n    ...CandidateApplicationFormRow_form\n    ...CandidateApplicationFormDetail_form\n  }\n  hasCompletedForms\n}\n\nfragment CandidateApplicationLayout_applicationSearchResult on Application {\n  code\n  applicationId\n  candidateId\n  employerId\n  version\n  rightToWorkStatus\n  createdAt\n  workflowStateName\n  vacancy {\n    code\n    vacancyId\n    id\n    ...MatchRelevanceProvider_vacancy\n  }\n  matchRelevance {\n    ...MatchRelevanceProvider_relevance\n  }\n  matchProfile {\n    ...MatchRelevanceProvider_matchProfile\n  }\n  candidate {\n    accountId\n    ...DetailsComponent_candidate\n    id\n  }\n  profile {\n    rate {\n      countryCode\n      currencyCode\n      maximumRateOfPay\n      minimumRateOfPay\n      payType\n      id\n    }\n    recruitProfileId\n    ...Profile_profile\n    ...RecruitProfileApplicationHeader_application\n    ...CandidateApplicationProfile_profile\n    ...DetailsComponent_profile\n    id\n  }\n  ...CandidateApplicationRelevance_application\n  ...CandidateApplicationDocuments_application\n  ...CandidateApplicationForms_application\n  ...CandidateApplicationWorkflowContainer_application\n}\n\nfragment CandidateApplicationProfile_profile on RecruitProfile {\n  experiences {\n    items {\n      id\n      candidateExperienceId\n      title\n      companyName\n      startDate\n      endDate\n      ...ExperienceDetails_experience\n    }\n    skills {\n      name\n      lastUsed\n      periods {\n        startDate\n        endDate\n      }\n      averageMonthsUsed\n      totalMonthsUsed\n      totalPositionsUsed\n    }\n  }\n}\n\nfragment CandidateApplicationRelevance_application on Application {\n  code\n  vacancy {\n    code\n    id\n  }\n  profile {\n    recruitProfileId\n    id\n  }\n}\n\nfragment CandidateApplicationWorkflowContainer_application on Application {\n  id\n  applicationId\n  updatedAt\n  applicationStateId\n  applicationStateName\n  workflowStateId\n  workflowStateName\n  workflowDefinition {\n    id\n    name\n    states {\n      id\n      name\n      parentId\n      children {\n        id\n        name\n        parentId\n        actions {\n          id\n          workflowActionTransitionId\n          workflowDefinitionId\n          actionGroup\n          actionType\n          actionName\n          actionDialog\n          actionLabel\n          transitionId\n          nextStateId\n          currentStateId\n          securityContext {\n            users {\n              owner\n              permissions {\n                action\n                resource\n              }\n              userType\n            }\n          }\n        }\n        events {\n          id\n          eventName\n          transitionId\n          workflowDefinitionId\n          workflowEventTransitionId\n        }\n        transitions {\n          id\n          workflowTransitionId\n          workflowDefinitionId\n          currentStateId\n          currentStateName\n          nextStateId\n          nextStateName\n          activities {\n            id\n            workflowTransitionActivityId\n            transitionId\n            context {\n              workflowActivityType\n              workflowActivityParameters\n            }\n          }\n        }\n      }\n      actions {\n        id\n        workflowActionTransitionId\n        workflowDefinitionId\n        actionGroup\n        actionType\n        actionName\n        actionDialog\n        actionLabel\n        transitionId\n        nextStateId\n        currentStateId\n        securityContext {\n          users {\n            owner\n            permissions {\n              action\n              resource\n            }\n            userType\n          }\n        }\n      }\n      events {\n        id\n        eventName\n        transitionId\n        workflowDefinitionId\n        workflowEventTransitionId\n      }\n      transitions {\n        id\n        workflowTransitionId\n        workflowDefinitionId\n        currentStateId\n        currentStateName\n        nextStateId\n        nextStateName\n        activities {\n          id\n          workflowTransitionActivityId\n          transitionId\n          context {\n            workflowActivityType\n            workflowActivityParameters\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment DetailsComponent_candidate on AccountsCandidateAccount {\n  firstName\n  lastName\n  email\n  phone {\n    phoneNumber\n    phoneCountryPrefix\n    phoneVerificationStatus\n  }\n}\n\nfragment DetailsComponent_profile on RecruitProfile {\n  recruitProfileId\n  resume {\n    bucket\n    resumeId\n    fileKey\n    fileName\n    filePath\n    id\n  }\n}\n\nfragment ExperienceDetails_experience on RecruitProfileExperience {\n  id\n  createdOn\n  updatedOn\n  candidateExperienceId\n  version\n  titleId\n  title\n  industry\n  companyIsVerified\n  companyId\n  companyName\n  description\n  startDate\n  endDate\n  positionType\n  skills\n  escoOccupationId\n  escoHierarchy\n}\n\nfragment MatchRelevanceProvider_matchProfile on RecruitMatchProfile {\n  id\n  vacancyId\n  experience {\n    id\n    code\n    version\n    titleId\n    title\n    industry\n    companyIsVerified\n    companyId\n    companyName\n    description\n    startDate\n    endDate\n    positionType\n    skillGroupScores {\n      groupId\n      hasMatch\n      minSkillGroupScore\n      score\n      weight\n    }\n    escoOccupationId\n    escoHierarchy\n    jobMatchWeight\n    jobMatchScore\n    companyScore\n    companyScoreWeight\n    hasCompanyVector\n  }\n}\n\nfragment MatchRelevanceProvider_relevance on RecruitMatchRelevanceContainer {\n  skillGroups {\n    skillGroupId\n    numberOfMonthsCertain\n    numberOfMonthsCertainPlusUnknown\n    mostRecentCertainExperienceEnd\n    mostRecentUnknownExperienceEnd\n  }\n  industry {\n    numberOfMonthsCertain\n    numberOfMonthsCertainPlusUnknown\n    mostRecentCertainExperienceEnd\n    mostRecentUnknownExperienceEnd\n  }\n  job {\n    numberOfMonthsCertain\n    numberOfMonthsCertainPlusUnknown\n    mostRecentCertainExperienceEnd\n    mostRecentUnknownExperienceEnd\n  }\n}\n\nfragment MatchRelevanceProvider_vacancy on Vacancy {\n  id\n  code\n  skillGroups {\n    id\n    skillGroupId\n    name\n    isRequired\n    weight\n    terms {\n      name\n      isSkill\n    }\n    experience {\n      durationAmount\n      durationType\n    }\n    recency {\n      durationType\n      durationAmount\n    }\n  }\n  scoringConfig {\n    industryExperience {\n      durationAmount\n      durationType\n    }\n    industryNegativeThreshold\n    industryPositiveThreshold\n    industryRecency {\n      durationAmount\n      durationType\n    }\n    relevanceNegativeThreshold\n    relevancePositiveThreshold\n    relevantExperience {\n      durationAmount\n      durationType\n    }\n    relevantRecency {\n      durationAmount\n      durationType\n    }\n  }\n}\n\nfragment ProfileSearchResultTimeline_profile on RecruitProfile {\n  id\n  experiences {\n    items {\n      id\n      candidateExperienceId\n      title\n      companyId\n      companyIsVerified\n      companyName\n      description\n      startDate\n      endDate\n      skills\n    }\n    skills {\n      skillId\n      name\n      totalMonthsUsed\n      averageMonthsUsed\n      totalPositionsUsed\n      lastUsed\n      periods {\n        startDate\n        endDate\n      }\n    }\n  }\n}\n\nfragment Profile_profile on RecruitProfile {\n  code\n  firstName\n  lastName\n  recruitProfileId\n  emailAddress\n  notes {\n    code\n    content\n    tags {\n      name\n      value\n    }\n    updatedAt\n    createdByUser {\n      emailAddress\n      firstName\n      lastName\n    }\n    id\n  }\n  account {\n    accountId\n    phone {\n      phoneVerificationStatus\n      phoneNumber\n      phoneCountryPrefix\n    }\n    id\n  }\n  experience {\n    id\n    candidateExperienceId\n    title\n    companyName\n    startDate\n    endDate\n    ...ExperienceDetails_experience\n  }\n  ...RecruitProfileHeader_profile\n  ...ProfileSearchResultTimeline_profile\n}\n\nfragment RecruitProfileApplicationHeader_application on RecruitProfile {\n  id\n  firstName\n  lastName\n  workLocations {\n    currentLocationName\n    currentLocationCountryName\n    workLocations {\n      name\n    }\n    id\n  }\n  currentPosition {\n    title\n    companyName\n    startDate\n    endDate\n    id\n  }\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n  availability {\n    jobSearchStatus\n    availabilityStatus\n    noticeCriteria {\n      availableFrom\n      noticePeriodWeeks\n      noticeTimeframe\n    }\n    id\n  }\n}\n\nfragment RecruitProfileHeader_profile on RecruitProfile {\n  ...RecruitProfileApplicationHeader_application\n  id\n  recruitProfileId\n  firstName\n  lastName\n  profileType\n  workLocations {\n    currentLocationName\n    currentLocationCountryName\n    id\n  }\n  account {\n    accountId\n    id\n  }\n  currentPosition {\n    title\n    companyName\n    startDate\n    endDate\n    id\n  }\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n  rightToWork {\n    status\n    id\n  }\n  availability {\n    jobSearchStatus\n    id\n  }\n}\n"
    }
  };
}();
node94.hash = "592d7fc96d778db5f16e751d4f04783d";
var CandidateApplicationLayoutQuery_graphql_default = node94;

// src/candidates/components/__generated__/CandidateApplicationLayout_applicationSearchResult.graphql.ts
var node95 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CandidateApplicationLayout_applicationSearchResult",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "applicationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "candidateId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "employerId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "version",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rightToWorkStatus",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "workflowStateName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Vacancy",
        "kind": "LinkedField",
        "name": "vacancy",
        "plural": false,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vacancyId",
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "MatchRelevanceProvider_vacancy"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitMatchRelevanceContainer",
        "kind": "LinkedField",
        "name": "matchRelevance",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "MatchRelevanceProvider_relevance"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitMatchProfile",
        "kind": "LinkedField",
        "name": "matchProfile",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "MatchRelevanceProvider_matchProfile"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsCandidateAccount",
        "kind": "LinkedField",
        "name": "candidate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DetailsComponent_candidate"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitProfile",
        "kind": "LinkedField",
        "name": "profile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitProfileRate",
            "kind": "LinkedField",
            "name": "rate",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "countryCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currencyCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "maximumRateOfPay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "minimumRateOfPay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "payType",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "recruitProfileId",
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Profile_profile"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RecruitProfileApplicationHeader_application"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CandidateApplicationProfile_profile"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DetailsComponent_profile"
          }
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "CandidateApplicationRelevance_application"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "CandidateApplicationDocuments_application"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "CandidateApplicationForms_application"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "CandidateApplicationWorkflowContainer_application"
      }
    ],
    "type": "Application",
    "abstractKey": null
  };
}();
node95.hash = "0e58dad7ac3ff5f3338f734c9d438c7d";
var CandidateApplicationLayout_applicationSearchResult_graphql_default = node95;

// src/candidates/components/CandidateApplicationLayout.tsx
import { useState as useState91, Suspense as Suspense105, useCallback as useCallback174 } from "react";
import {
  Link as Link25,
  Outlet as Outlet11,
  useLoaderData as useLoaderData4,
  useLocation as useLocation5,
  useNavigate as useNavigate23,
  useRouteLoaderData as useRouteLoaderData15
} from "react-router-dom";
import {
  loadQuery as loadQuery35,
  useFragment as useFragment93,
  usePreloadedQuery as usePreloadedQuery35
} from "react-relay";
import { noop as noop10, parseDate as parseDate15, useToggle as useToggle31 } from "shared-lib";
import {
  Button as Button83,
  classNames as classNames36,
  createLinkState as createLinkState5,
  DynamicBreadcrumb as DynamicBreadcrumb5,
  EdLink as EdLink20,
  Tabs as Tabs5,
  Tag as Tag20,
  workflowLabelMap as workflowLabelMap2
} from "shared-ui";
import { fromAccountsUserAccountType, useUserSessionContext as useUserSessionContext6 } from "app-core";
import { useLinkRegistry as useLinkRegistry2 } from "app-core";

// src/matches/relevance/components/__generated__/MatchRelevanceProvider_relevance.graphql.ts
var node96 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "numberOfMonthsCertain",
    "storageKey": null
  }, v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "numberOfMonthsCertainPlusUnknown",
    "storageKey": null
  }, v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "mostRecentCertainExperienceEnd",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "mostRecentUnknownExperienceEnd",
    "storageKey": null
  }, v4 = [
    v0,
    v1,
    v23,
    v32
  ];
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "MatchRelevanceProvider_relevance",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitMatchSkillRelevance",
        "kind": "LinkedField",
        "name": "skillGroups",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "skillGroupId",
            "storageKey": null
          },
          v0,
          v1,
          v23,
          v32
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitMatchRelevance",
        "kind": "LinkedField",
        "name": "industry",
        "plural": false,
        "selections": v4,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitMatchRelevance",
        "kind": "LinkedField",
        "name": "job",
        "plural": false,
        "selections": v4,
        "storageKey": null
      }
    ],
    "type": "RecruitMatchRelevanceContainer",
    "abstractKey": null
  };
}();
node96.hash = "f7804c1b075f2798b44107361925bbfc";
var MatchRelevanceProvider_relevance_graphql_default = node96;

// src/matches/relevance/components/__generated__/MatchRelevanceProvider_vacancy.graphql.ts
var node97 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationAmount",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationType",
    "storageKey": null
  }, v4 = [
    v23,
    v32
  ];
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "MatchRelevanceProvider_vacancy",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SkillGroup",
        "kind": "LinkedField",
        "name": "skillGroups",
        "plural": true,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "skillGroupId",
            "storageKey": null
          },
          v1,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isRequired",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "weight",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SkillGroupTerm",
            "kind": "LinkedField",
            "name": "terms",
            "plural": true,
            "selections": [
              v1,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isSkill",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Duration",
            "kind": "LinkedField",
            "name": "experience",
            "plural": false,
            "selections": v4,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Duration",
            "kind": "LinkedField",
            "name": "recency",
            "plural": false,
            "selections": [
              v32,
              v23
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "VacancyScoringConfig",
        "kind": "LinkedField",
        "name": "scoringConfig",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Duration",
            "kind": "LinkedField",
            "name": "industryExperience",
            "plural": false,
            "selections": v4,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "industryNegativeThreshold",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "industryPositiveThreshold",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Duration",
            "kind": "LinkedField",
            "name": "industryRecency",
            "plural": false,
            "selections": v4,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "relevanceNegativeThreshold",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "relevancePositiveThreshold",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Duration",
            "kind": "LinkedField",
            "name": "relevantExperience",
            "plural": false,
            "selections": v4,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Duration",
            "kind": "LinkedField",
            "name": "relevantRecency",
            "plural": false,
            "selections": v4,
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Vacancy",
    "abstractKey": null
  };
}();
node97.hash = "aef82a97fa07b1586b275b729c656b7f";
var MatchRelevanceProvider_vacancy_graphql_default = node97;

// src/matches/relevance/components/__generated__/MatchRelevanceProvider_matchProfile.graphql.ts
var node98 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "MatchRelevanceProvider_matchProfile",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "vacancyId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitMatchProfileExperience",
        "kind": "LinkedField",
        "name": "experience",
        "plural": true,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "version",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "titleId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "industry",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "companyIsVerified",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "companyId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "companyName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "endDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "positionType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MatchProfileExperienceSkillGroupScore",
            "kind": "LinkedField",
            "name": "skillGroupScores",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "groupId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasMatch",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "minSkillGroupScore",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "score",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "weight",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "escoOccupationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "escoHierarchy",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "jobMatchWeight",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "jobMatchScore",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "companyScore",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "companyScoreWeight",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasCompanyVector",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RecruitMatchProfile",
    "abstractKey": null
  };
}();
node98.hash = "288ad9cacd266c27d78bac37280fb34f";
var MatchRelevanceProvider_matchProfile_graphql_default = node98;

// src/matches/relevance/components/MatchRelevanceProvider.tsx
import {
  createContext as createContext10,
  useCallback as useCallback128,
  useContext as useContext10,
  useMemo as useMemo31,
  useState as useState74
} from "react";
import { useFragment as useFragment73 } from "react-relay";
import { useToggle as useToggle27 } from "shared-lib";

// src/vacancies/components/SalaryEditor.tsx
import { useState as useState22 } from "react";
import { Controller as Controller4 } from "react-hook-form";
import {
  GeoCountriesSearchContainer
} from "feature-data-management";
import { CheckBox, Error as Error3, Input as Input3 } from "shared-ui";

// src/vacancies/components/PayTypeSelector.tsx
import { useCallback as useCallback36, useState as useState21 } from "react";
import { RadioList } from "shared-ui";

// src/vacancies/lib/Durations.ts
function toDuration(data) {
  return data ? {
    durationAmount: data.durationAmount,
    durationType: data.durationType
  } : null;
}

// src/vacancies/lib/Vacancy.ts
import { isString as isString2, parseDate as parseDate9 } from "shared-lib";
var PayTypes = /* @__PURE__ */ ((PayTypes3) => {
  PayTypes3["PerDay"] = "PerDay";
  PayTypes3["PerHour"] = "PerHour";
  PayTypes3["PerYear"] = "PerYear";
  return PayTypes3;
})(PayTypes || {});
var RoleTypes = /* @__PURE__ */ ((RoleTypes3) => {
  RoleTypes3["ToBeConfirmed"] = "ToBeConfirmed";
  RoleTypes3["Permanent"] = "Permanent";
  RoleTypes3["FixedLength"] = "FixedLength";
  return RoleTypes3;
})(RoleTypes || {});
var vacancyStatusOpen = {
  order: 1,
  id: "Open",
  name: "Open",
  checked: true
};
var vacancyStatusDraft = {
  order: 2,
  id: "Draft",
  name: "Draft",
  checked: true
};
var vacancyStatusFilled = {
  order: 3,
  id: "Filled",
  name: "Filled",
  checked: false
};
var vacancyStatusArchived = {
  order: 4,
  id: "Archived",
  name: "Archived",
  checked: false
};
var vacancyStatusValues = [
  vacancyStatusArchived,
  vacancyStatusFilled,
  vacancyStatusOpen,
  vacancyStatusDraft
];
var vacancySortBestMatch = {
  id: "BEST_MATCH",
  name: "Best Match"
};
var vacancySortLastActivity = {
  id: "LAST_ACTIVITY",
  name: "Last Activity"
};
var vacancySortValues = [
  {
    id: "RECENT_ACTIVITY",
    name: "Recent Activity"
  },
  {
    id: "MOST_RECENTLY_OPENED",
    name: "Most Recently Opened"
  },
  {
    id: "OLDEST_OPENED",
    name: "Oldest Opened"
  },
  {
    id: "CLOSING_SOON",
    name: "Closing Soon"
  },
  {
    id: "VACANCY_NAME_ASC",
    name: "Vacancy Name A -> Z"
  },
  {
    id: "VACANCY_NAME_DESC",
    name: "Vacancy Name Z -> A"
  }
];
function toVacancyDurationCode(role) {
  switch (role) {
    case "ToBeConfirmed" /* ToBeConfirmed */: {
      return "TO_BE_CONFIRMED";
    }
    case "Permanent" /* Permanent */: {
      return "PERMANENT";
    }
    case "FixedLength" /* FixedLength */: {
      return "FIXED_LENGTH";
    }
  }
}
function toRoleType(durationCode) {
  switch (durationCode) {
    case "FIXED_LENGTH": {
      return "FixedLength" /* FixedLength */;
    }
    case "PERMANENT": {
      return "Permanent" /* Permanent */;
    }
    case "TO_BE_CONFIRMED": {
      return "ToBeConfirmed" /* ToBeConfirmed */;
    }
  }
  return "ToBeConfirmed" /* ToBeConfirmed */;
}
function toPayType(type) {
  switch (type) {
    case "PerDay" /* PerDay */: {
      return "PER_DAY";
    }
    case "PerHour" /* PerHour */: {
      return "PER_HOUR";
    }
    case "PerYear" /* PerYear */: {
      return "PER_YEAR";
    }
  }
}
function fromPayType(type) {
  switch (type) {
    case "PER_DAY": {
      return "PerDay" /* PerDay */;
    }
    case "PER_HOUR": {
      return "PerHour" /* PerHour */;
    }
    case "PER_YEAR": {
      return "PerYear" /* PerYear */;
    }
  }
  return "PerDay" /* PerDay */;
}
function deserializeSkillGroups(skillGroups) {
  const mappedSkillGroups = (skillGroups || []).map((sg) => {
    const experience = sg.experience ? {
      durationAmount: sg.experience.durationAmount,
      durationType: sg.experience.durationType
    } : null;
    const recency = sg.recency ? {
      durationAmount: sg.recency.durationAmount,
      durationType: sg.recency.durationType
    } : null;
    return {
      id: sg.id,
      skillGroupId: sg.skillGroupId,
      name: sg.name,
      isRequired: sg.isRequired,
      weight: sg.weight,
      experience,
      recency,
      terms: sg.terms
    };
  });
  return mappedSkillGroups;
}
function toDuration2(data) {
  if (!data) {
    return null;
  }
  const durationAmount = isString2(data.durationAmount) ? parseInt(data.durationAmount) : data.durationAmount;
  return {
    durationAmount: durationAmount || 0,
    durationType: data.durationType
  };
}
function serializeSkillGroups(skillGroups) {
  const mappedSkillGroups = (skillGroups || []).map(
    (sg) => {
      return {
        id: sg.id,
        name: sg.name,
        isRequired: sg.isRequired,
        weight: sg.weight,
        experience: toDuration2(sg.experience),
        recency: toDuration2(sg.recency),
        terms: sg.terms
      };
    }
  );
  return mappedSkillGroups;
}
function vacancyDetailsHaveChanged(form, vacancy, log) {
  if (fromPayType(vacancy?.rate?.payType) !== form.payType) {
    log(`Pay Type Has Changed`);
    return true;
  }
  if (JSON.stringify(vacancy?.locations) !== JSON.stringify(form.locations)) {
    log(`Locations Have Changed`);
    return true;
  }
  if (vacancy?.rate?.min !== form.minRate) {
    log(`Min Rate Has Changed`);
    return true;
  }
  if (vacancy?.rate?.max !== form.maxRate) {
    log(`Max Rate Has Changed`);
    return true;
  }
  if (vacancy?.rate?.currencyCountryCode !== form.country?.iso3) {
    log(`Currency Country Has Changed`);
    return true;
  }
  if (vacancy?.rate?.isPrivate !== form.rateIsPrivate) {
    log(`Rate Is Private Has Changed`);
    return true;
  }
  if (toRoleType(vacancy?.dates?.durationCode) !== form.roleType) {
    log(`Duration Code Has Changed`);
    return true;
  }
  if (vacancy?.dates?.durationAmount !== form.durationAmount) {
    log(`Duration Amount Has Changed`);
    return true;
  }
  if (vacancy?.dates?.durationType !== form.durationType) {
    log(`Duration Type Has Changed`);
    return true;
  }
  if (vacancy?.dates?.startAsap !== form.startAsap) {
    log(`Start Asap Code Has Changed`);
    return true;
  }
  if (vacancy?.dates?.startDate !== form.startDate) {
    log(`Start Date Amount Has Changed`);
    return true;
  }
  if (vacancy?.locations?.length !== form.locations.length) {
    log(`Locations Type Has Changed`);
    return true;
  }
  if (vacancy?.headcount !== form.positionCount) {
    log(`Headcount Code Has Changed`);
    return true;
  }
  if (vacancy?.employerReference !== form.employerReference) {
    log(`Employer Reference Amount Has Changed`);
    return true;
  }
  if (vacancy.expiresAt && parseDate9(vacancy.expiresAt).getDate() !== form.expiryDate.getDate()) {
    log(`Expiry Date Has Changed`);
    return true;
  }
  return false;
}
function createDefaultEmployerReference(vacancy) {
  if (!vacancy) {
    return "";
  }
  return `${vacancy.employerSlug}-${vacancy.code}`;
}

// src/vacancies/lib/PluralizeDuration.ts
var pluralizeDuration = (durationType, durationAmount) => {
  let lowercaseDurationType = durationType.toLowerCase();
  if (lowercaseDurationType[durationType.length - 1] === "s") {
    lowercaseDurationType = lowercaseDurationType.slice(
      0,
      durationType.length - 1
    );
  }
  return `${lowercaseDurationType}${durationAmount === 1 ? "" : "s"}`;
};

// src/vacancies/lib/VacancyModel.ts
import { KeyableSet } from "shared-lib";

// src/vacancies/lib/VacancyScoringConfig.ts
import { Duration } from "shared-lib";
var VacancyScoringConfig = class {
  constructor(data) {
    this.relevancePositiveThreshold = data.relevancePositiveThreshold;
    this.relevanceNegativeThreshold = data.relevanceNegativeThreshold;
    this.industryPositiveThreshold = data.industryPositiveThreshold;
    this.industryNegativeThreshold = data.industryNegativeThreshold;
    this.relevantExperience = Duration.parse(data.relevantExperience);
    this.relevantRecency = Duration.parse(data.relevantRecency);
    this.industryExperience = Duration.parse(data.industryExperience);
    this.industryRecency = Duration.parse(data.industryRecency);
  }
};

// src/vacancies/lib/VacancySkillGroup.ts
import { Duration as Duration2 } from "shared-lib";

// src/vacancies/lib/SkillGroupTerm.ts
var SkillGroupTerm = class {
  constructor(data) {
    this.selected = false;
    this.name = data.name;
    this.isSkill = data.isSkill;
  }
};

// src/vacancies/lib/VacancySkillGroup.ts
var VacancySkillGroup = class {
  constructor(data) {
    this.experience = null;
    this.recency = null;
    this.id = data.id;
    this.name = data.name;
    this.weight = data.weight;
    this.isRequired = data.isRequired;
    this.terms = data.terms.map((x4) => new SkillGroupTerm(x4));
    if (data.experience) {
      this.experience = Duration2.parse(data.experience);
    }
    if (data.recency) {
      this.recency = Duration2.parse(data.recency);
    }
  }
  static sortByWeight(groups) {
    return groups.sort(
      (a4, b3) => b3.weight - a4.weight
    );
  }
  key() {
    return this.id;
  }
};

// src/vacancies/lib/VacancyModel.ts
function createVacancyModel(data) {
  const skillGroups = new KeyableSet(
    data.skillGroups.map((group) => {
      return new VacancySkillGroup(group);
    })
  );
  return {
    ...data,
    skillGroups,
    scoringConfig: new VacancyScoringConfig(data.scoringConfig)
  };
}
function createFiltersFromVacancy(vacancy) {
  if (!vacancy) {
    return [];
  }
  return vacancy.skillGroups.list.sort((x4, y4) => {
    return x4 === y4 ? 0 : x4 ? -1 : 1;
  }).map((s4) => {
    const terms = s4.terms.filter((s5) => s5.isSkill).map((s5) => s5.name);
    return {
      groupId: s4.id,
      groupName: s4.name,
      groupExperience: s4.experience,
      terms
    };
  });
}

// src/vacancies/lib/VacancySearch.ts
import { atom as atom6 } from "jotai";
var vacancySearchAtom = atom6({
  pageNumber: 1,
  pageSize: 10,
  status: ["Open", "Draft"],
  sortField: "LAST_ACTIVITY",
  sortOrder: "DESC",
  myVacancies: ["PLEASE"]
});

// src/vacancies/lib/VacancyMatches.ts
import { fetchQuery } from "react-relay";
async function fetchMatchRun(queryDef80, vacancyCode, environment) {
  const onFetchRun = fetchQuery(
    environment,
    queryDef80,
    {
      vacancyCode
    }
  );
  try {
    return onFetchRun.toPromise();
  } catch (e4) {
    return void 0;
  }
}

// src/vacancies/components/PayTypeSelector.tsx
import { jsx as jsx65 } from "react/jsx-runtime";
var perDay = {
  id: "PerDay" /* PerDay */,
  label: "Per Day"
};
var perHour = {
  id: "PerHour" /* PerHour */,
  label: "Per Hour"
};
var perYear = {
  id: "PerYear" /* PerYear */,
  label: "Per Year"
};
function toRadio(durationType) {
  switch (durationType) {
    case "PerDay" /* PerDay */: {
      return perDay;
    }
    case "PerHour" /* PerHour */: {
      return perHour;
    }
    case "PerYear" /* PerYear */: {
      return perYear;
    }
  }
}
var options = [perYear, perHour, perDay];
var PayTypeSelector = ({ value, onChanged }) => {
  const [current, setCurrent] = useState21(() => {
    if (value) {
      return toRadio(value);
    }
    return perYear;
  });
  const changed = useCallback36(
    (value2) => {
      setCurrent(value2);
      onChanged(value2.id);
    },
    [setCurrent]
  );
  return /* @__PURE__ */ jsx65(RadioList, { value: current, list: options, onChange: changed });
};

// src/vacancies/components/SalaryEditor.tsx
import { jsx as jsx66, jsxs as jsxs44 } from "react/jsx-runtime";
var Salary = ({
  form,
  onMinRateChanged,
  onMaxRateChanged,
  onPayTypeChanged,
  onChangeCountry,
  onRateIsPrivateChanged,
  errors
}) => {
  const [minValue, setMinValue] = useState22(
    Number(form.minRate).toFixed(2)
  );
  const [maxValue, setMaxValue] = useState22(
    Number(form.maxRate).toFixed(2)
  );
  const isCurrency = (fn) => (value) => {
    if (/^\d*(\.\d{0,2})?$/.test(value)) {
      fn(value);
    }
  };
  return /* @__PURE__ */ jsxs44("div", { className: "flex flex-col gap-2", children: [
    /* @__PURE__ */ jsxs44("div", { className: "grid items-center gap-2 border-b border-gray-100 pb-4 sm:grid-cols-2", children: [
      /* @__PURE__ */ jsxs44("div", { className: "col-span-1 flex items-center space-x-4", children: [
        /* @__PURE__ */ jsx66("div", { className: "w-12 text-gray-500", children: "Min" }),
        /* @__PURE__ */ jsx66(
          Input3,
          {
            width: "w-32",
            type: "text",
            value: minValue,
            onValueChange: isCurrency(setMinValue),
            onValueBlur: (x4) => {
              onMinRateChanged(Number(minValue).toFixed(2));
              if (Number.isInteger(Number(minValue))) {
                setMinValue(parseInt(minValue).toString());
              } else {
                setMinValue(Number(minValue).toFixed(2));
              }
            },
            name: "minRate",
            required: true
          }
        ),
        /* @__PURE__ */ jsx66(Error3, { children: errors?.minRate || "" })
      ] }),
      /* @__PURE__ */ jsxs44("div", { className: "col-span-1 flex items-center space-x-4", children: [
        /* @__PURE__ */ jsx66("div", { className: "w-12 text-gray-500", children: "Max" }),
        /* @__PURE__ */ jsx66(
          Input3,
          {
            width: "w-32",
            type: "text",
            value: maxValue,
            onValueChange: isCurrency(setMaxValue),
            onValueBlur: () => {
              onMaxRateChanged(Number(maxValue).toFixed(2));
              if (Number.isInteger(Number(maxValue))) {
                setMaxValue(parseInt(maxValue).toString());
              } else {
                setMaxValue(Number(maxValue).toFixed(2));
              }
            },
            name: "maxRate",
            required: true
          }
        ),
        /* @__PURE__ */ jsx66(Error3, { children: errors?.maxRate || "" })
      ] })
    ] }),
    /* @__PURE__ */ jsx66("div", { className: "grid grid-cols-3 items-center gap-2 border-b border-gray-100 pb-4", children: /* @__PURE__ */ jsx66("div", { className: "col-span-3", children: /* @__PURE__ */ jsx66(PayTypeSelector, { value: form.payType, onChanged: onPayTypeChanged }) }) }),
    /* @__PURE__ */ jsxs44("div", { className: "grid grid-row-2 lg:grid-cols-2 items-center gap-2 border-b border-gray-100 pb-4", children: [
      /* @__PURE__ */ jsxs44("div", { className: "gap-2 flex lg:space-x-4 flex-col items-start lg:flex-row lg:items-center", children: [
        /* @__PURE__ */ jsx66("div", { className: " text-gray-500", children: "Currency of" }),
        /* @__PURE__ */ jsxs44("div", { className: "relative", children: [
          /* @__PURE__ */ jsx66(
            GeoCountriesSearchContainer,
            {
              name: "phone-country-search",
              value: form.country,
              onSearchCompleted: onChangeCountry
            }
          ),
          /* @__PURE__ */ jsx66(Error3, { className: "absolute", children: errors?.country || "" })
        ] })
      ] }),
      /* @__PURE__ */ jsxs44("div", { className: " flex items-center gap-2 space-x-4 ", children: [
        /* @__PURE__ */ jsx66("div", { className: "text-gray-500", children: "Private Rate" }),
        /* @__PURE__ */ jsx66("div", { className: "col-span-2", children: /* @__PURE__ */ jsx66(
          CheckBox,
          {
            checked: form.rateIsPrivate,
            onChanged: onRateIsPrivateChanged
          }
        ) })
      ] })
    ] })
  ] });
};
var SalaryEditorInput = ({
  name,
  control
}) => {
  return /* @__PURE__ */ jsx66(
    Controller4,
    {
      control,
      render: ({ field: { onChange, value }, fieldState: { error } }) => {
        return /* @__PURE__ */ jsx66(
          Salary,
          {
            errors: Object.entries(error || {}).reduce((acc, [key, value2]) => {
              const error2 = value2;
              acc[key] = error2.message;
              return acc;
            }, {}),
            form: value,
            onMinRateChanged: (minRate) => {
              onChange({
                ...value,
                minRate
              });
            },
            onMaxRateChanged: (maxRate) => onChange({
              ...value,
              maxRate
            }),
            onPayTypeChanged: (payType) => onChange({
              ...value,
              payType
            }),
            onChangeCountry: (country) => onChange({
              ...value,
              country
            }),
            onRateIsPrivateChanged: (rateIsPrivate) => {
              onChange({
                ...value,
                rateIsPrivate
              });
            }
          }
        );
      },
      name
    }
  );
};

// src/vacancies/components/VacancySearchLoader.tsx
import { Suspense as Suspense30, useCallback as useCallback60, useTransition as useTransition9 } from "react";
import { useEffectOnce } from "react-use";
import { useQueryLoader as useQueryLoader3 } from "react-relay";
import { useAtomValue as useAtomValue3 } from "jotai";
import { EdSkeleton as EdSkeleton27, Loading } from "shared-ui";

// src/vacancies/components/__generated__/VacancySearchContainerQuery.graphql.ts
var node99 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AggregationTags_Aggregation"
    }
  ], v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  }, v6 = [
    v5,
    v4
  ], v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isSelected",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "text",
    "storageKey": null
  }, v10 = [
    v5,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    },
    v7,
    {
      "alias": null,
      "args": null,
      "concreteType": "DefaultAggregationValueModel",
      "kind": "LinkedField",
      "name": "values",
      "plural": true,
      "selections": [
        v5,
        v8,
        v32,
        v9
      ],
      "storageKey": null
    }
  ], v11 = [
    v7,
    {
      "alias": null,
      "args": null,
      "concreteType": "DefaultAggregationValueModel",
      "kind": "LinkedField",
      "name": "values",
      "plural": true,
      "selections": [
        v5,
        v9,
        v8,
        v32
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "VacancySearchContainerQuery",
      "selections": [
        {
          "args": v1,
          "kind": "FragmentSpread",
          "name": "VacancySearchList_vacancies"
        },
        {
          "alias": null,
          "args": v1,
          "concreteType": "VacancySearchResult",
          "kind": "LinkedField",
          "name": "recruitVacanciesSearch",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "VacancySearchResultFacets",
              "kind": "LinkedField",
              "name": "facets",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "VacancySearchFacets_aggregations"
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "createdBy",
                  "plural": false,
                  "selections": v23,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "projects",
                  "plural": false,
                  "selections": v23,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "status",
                  "plural": false,
                  "selections": v23,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "closingOn",
                  "plural": false,
                  "selections": v23,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "companies",
                  "plural": false,
                  "selections": v23,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "employmentType",
                  "plural": false,
                  "selections": v23,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "jobTitles",
                  "plural": false,
                  "selections": v23,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "lastActivity",
                  "plural": false,
                  "selections": v23,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "locationHierarchies",
                  "plural": false,
                  "selections": v23,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "locations",
                  "plural": false,
                  "selections": v23,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "openedOn",
                  "plural": false,
                  "selections": v23,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "skills",
                  "plural": false,
                  "selections": v23,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "targetCompanies",
                  "plural": false,
                  "selections": v23,
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "VacancySearchContainerQuery",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "VacancySearchResult",
          "kind": "LinkedField",
          "name": "recruitVacanciesSearch",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CollectionMetaData",
              "kind": "LinkedField",
              "name": "paging",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "itemsPerPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "pageNumber",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "pages",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "totalResults",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "VacancySearchModel",
              "kind": "LinkedField",
              "name": "items",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "vacancyId",
                  "storageKey": null
                },
                v32,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "code",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "employerName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "projectName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "employerReference",
                  "storageKey": null
                },
                v4,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "recommendations",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "matches",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "expiresAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "dateCreated",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "dateOpened",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "VacancyCandidateCount",
                  "kind": "LinkedField",
                  "name": "candidateCounts",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CandidateCount",
                      "kind": "LinkedField",
                      "name": "created",
                      "plural": false,
                      "selections": v6,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CandidateCount",
                      "kind": "LinkedField",
                      "name": "submitted",
                      "plural": false,
                      "selections": v6,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CandidateCount",
                      "kind": "LinkedField",
                      "name": "active",
                      "plural": false,
                      "selections": v6,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CandidateCount",
                      "kind": "LinkedField",
                      "name": "hired",
                      "plural": false,
                      "selections": v6,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CandidateCount",
                      "kind": "LinkedField",
                      "name": "withdrawn",
                      "plural": false,
                      "selections": v6,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CandidateCount",
                      "kind": "LinkedField",
                      "name": "unsuccessful",
                      "plural": false,
                      "selections": v6,
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": v1,
          "concreteType": "VacancySearchResult",
          "kind": "LinkedField",
          "name": "recruitVacanciesSearch",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "VacancySearchResultFacets",
              "kind": "LinkedField",
              "name": "facets",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "createdBy",
                  "plural": false,
                  "selections": v10,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "projects",
                  "plural": false,
                  "selections": v10,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "status",
                  "plural": false,
                  "selections": v10,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "skills",
                  "plural": false,
                  "selections": v10,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "closingOn",
                  "plural": false,
                  "selections": v10,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "employmentType",
                  "plural": false,
                  "selections": v10,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "jobTitles",
                  "plural": false,
                  "selections": v10,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "locations",
                  "plural": false,
                  "selections": v10,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "openedOn",
                  "plural": false,
                  "selections": v10,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "companies",
                  "plural": false,
                  "selections": v10,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "lastActivity",
                  "plural": false,
                  "selections": v11,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "locationHierarchies",
                  "plural": false,
                  "selections": v11,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "targetCompanies",
                  "plural": false,
                  "selections": v11,
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "b72face143a165529f09aacb6877ffdd",
      "id": null,
      "metadata": {},
      "name": "VacancySearchContainerQuery",
      "operationKind": "query",
      "text": "query VacancySearchContainerQuery(\n  $input: VacancySearchInput!\n) {\n  ...VacancySearchList_vacancies_2VV6jB\n  recruitVacanciesSearch(input: $input) {\n    facets {\n      ...VacancySearchFacets_aggregations\n      createdBy {\n        ...AggregationTags_Aggregation\n      }\n      projects {\n        ...AggregationTags_Aggregation\n      }\n      status {\n        ...AggregationTags_Aggregation\n      }\n      closingOn {\n        ...AggregationTags_Aggregation\n      }\n      companies {\n        ...AggregationTags_Aggregation\n      }\n      employmentType {\n        ...AggregationTags_Aggregation\n      }\n      jobTitles {\n        ...AggregationTags_Aggregation\n      }\n      lastActivity {\n        ...AggregationTags_Aggregation\n      }\n      locationHierarchies {\n        ...AggregationTags_Aggregation\n      }\n      locations {\n        ...AggregationTags_Aggregation\n      }\n      openedOn {\n        ...AggregationTags_Aggregation\n      }\n      skills {\n        ...AggregationTags_Aggregation\n      }\n      targetCompanies {\n        ...AggregationTags_Aggregation\n      }\n    }\n  }\n}\n\nfragment AggregationTags_Aggregation on DefaultAggregationModel {\n  title\n  values {\n    count\n    text\n    isSelected\n    name\n  }\n}\n\nfragment MultiFacetContainer_facet on DefaultAggregationModel {\n  count\n  key\n  title\n  values {\n    count\n    isSelected\n    name\n    text\n  }\n}\n\nfragment VacancySearchDashboardChart_vacancy on VacancySearchModel {\n  id\n  name\n  code\n  status\n  candidateCounts {\n    created {\n      count\n      status\n    }\n    submitted {\n      count\n      status\n    }\n    active {\n      count\n      status\n    }\n    hired {\n      count\n      status\n    }\n    withdrawn {\n      count\n      status\n    }\n    unsuccessful {\n      count\n      status\n    }\n  }\n}\n\nfragment VacancySearchDashboardLayout_vacancy on VacancySearchModel {\n  id\n  status\n  employerReference\n  projectName\n  ...VacancySearchDashboardChart_vacancy\n}\n\nfragment VacancySearchFacets_aggregations on VacancySearchResultFacets {\n  createdBy {\n    count\n    ...MultiFacetContainer_facet\n  }\n  projects {\n    count\n    ...MultiFacetContainer_facet\n  }\n  status {\n    count\n    ...MultiFacetContainer_facet\n  }\n  skills {\n    count\n    ...MultiFacetContainer_facet\n  }\n  closingOn {\n    count\n    ...MultiFacetContainer_facet\n  }\n  employmentType {\n    count\n    ...MultiFacetContainer_facet\n  }\n  jobTitles {\n    count\n    ...MultiFacetContainer_facet\n  }\n  locations {\n    count\n    ...MultiFacetContainer_facet\n  }\n  openedOn {\n    count\n    ...MultiFacetContainer_facet\n  }\n  companies {\n    count\n    ...MultiFacetContainer_facet\n  }\n}\n\nfragment VacancySearchHeader_vacancy on VacancySearchModel {\n  id\n  name\n  code\n  status\n  projectName\n  employerName\n}\n\nfragment VacancySearchList_vacancies_2VV6jB on Query {\n  result: recruitVacanciesSearch(input: $input) {\n    paging {\n      itemsPerPage\n      pageNumber\n      pages\n      totalResults\n    }\n    items {\n      id\n      vacancyId\n      name\n      code\n      employerName\n      projectName\n      employerReference\n      status\n      recommendations\n      matches\n      expiresAt\n      dateCreated\n      dateOpened\n      candidateCounts {\n        created {\n          count\n          status\n        }\n        submitted {\n          count\n          status\n        }\n        active {\n          count\n          status\n        }\n        hired {\n          count\n          status\n        }\n        withdrawn {\n          count\n          status\n        }\n        unsuccessful {\n          count\n          status\n        }\n        ...VacancySearchList_vacancyCandidateCount\n      }\n      ...VacancySearchHeader_vacancy\n      ...VacancySearchDashboardLayout_vacancy\n    }\n  }\n}\n\nfragment VacancySearchList_vacancyCandidateCount on VacancyCandidateCount {\n  created {\n    count\n    status\n  }\n  submitted {\n    count\n    status\n  }\n  active {\n    count\n    status\n  }\n  hired {\n    count\n    status\n  }\n  withdrawn {\n    count\n    status\n  }\n  unsuccessful {\n    count\n    status\n  }\n}\n"
    }
  };
}();
node99.hash = "9b000522613e84ab0536b22be682878d";
var VacancySearchContainerQuery_graphql_default = node99;

// src/vacancies/components/VacancySearchContainer.tsx
import { Suspense as Suspense29, useCallback as useCallback59, useTransition as useTransition8 } from "react";
import {
  usePreloadedQuery as usePreloadedQuery9,
  useRefetchableFragment as useRefetchableFragment6
} from "react-relay";
import { atom as atom8, useAtom as useAtom6 } from "jotai";
import {
  AggregationTags,
  Button as Button31,
  DisplayFieldEnum,
  Card as Card3,
  EdLink as EdLink10,
  IconText as IconText2,
  Modal,
  SimplePagination as SimplePagination2,
  Size as Size13,
  classNames as classNames11,
  Spinner as Spinner9,
  StyledTable,
  ScrollArea
} from "shared-ui";
import { Icons as Icons3 } from "shared-ui";
import { createClientMutationId as createClientMutationId29, useToggle as useToggle15 } from "shared-lib";

// src/vacancies/components/VacancySearchSort.tsx
import { useCallback as useCallback41, useMemo as useMemo13 } from "react";
import { useAtomValue } from "jotai";

// src/shared/components/__generated__/ExperienceDropdown_RecruitProfile.graphql.ts
var node100 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ExperienceDropdown_RecruitProfile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RecruitProfileExperience",
      "kind": "LinkedField",
      "name": "experience",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "candidateExperienceId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "companyId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "companyName",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RecruitProfile",
  "abstractKey": null
};
node100.hash = "75349eeabd4a4c715f3575b73b1e541a";
var ExperienceDropdown_RecruitProfile_graphql_default = node100;

// src/shared/components/ExperienceDropdown.tsx
import { useEffect as useEffect11 } from "react";
import { useForm as useForm4 } from "react-hook-form";
import { useFragment as useFragment28 } from "react-relay";
import { SelectMenuInput } from "shared-ui";
import { jsx as jsx67 } from "react/jsx-runtime";
var fragmentDef25 = ExperienceDropdown_RecruitProfile_graphql_default;
var ExperienceDropdown = ({
  fragmentRef,
  onChange
}) => {
  const data = useFragment28(
    fragmentDef25,
    fragmentRef
  );
  const { control, watch } = useForm4();
  const previousExperienceValue = watch("previous-experience");
  useEffect11(() => {
    onChange(previousExperienceValue);
  }, [onChange, previousExperienceValue]);
  const prevExperience = data.experience.map(
    ({ candidateExperienceId, companyName }) => ({
      id: candidateExperienceId,
      name: companyName
    })
  );
  return /* @__PURE__ */ jsx67(
    SelectMenuInput,
    {
      items: prevExperience,
      name: "previous-experience",
      title: "Previous Experience",
      control,
      disabled: false,
      selectedItem: prevExperience.filter(({ id: id18 }) => id18 == previousExperienceValue)[0] || {
        id: "NONE",
        name: "Select previous experience"
      }
    }
  );
};
var ExperienceDropdown_default = ExperienceDropdown;

// src/shared/components/LocationsList.tsx
import { Fragment as Fragment16, jsx as jsx68, jsxs as jsxs45 } from "react/jsx-runtime";
var LocationsList = ({ locations }) => {
  const items = locations.map((l4) => {
    return /* @__PURE__ */ jsx68("div", { className: "flex flex-col text-sm text-gray-700", children: /* @__PURE__ */ jsxs45("div", { children: [
      l4.name,
      ", ",
      l4.countryName
    ] }) }, l4.name);
  });
  return /* @__PURE__ */ jsxs45(Fragment16, { children: [
    locations.length > 0 && /* @__PURE__ */ jsx68("div", { className: "mb-2 font-medium", children: "Locations" }),
    /* @__PURE__ */ jsx68("div", { className: "", children: items })
  ] });
};

// src/shared/components/MultiFilter.tsx
import { useCallback as useCallback37 } from "react";
import { CheckBoxList } from "shared-ui";
import { jsx as jsx69 } from "react/jsx-runtime";
var MultiFilter = ({
  title,
  selected,
  values,
  onChanged
}) => {
  const items = values.map((item) => ({
    id: item.id,
    title: item.name,
    checked: selected.includes(item.id)
  }));
  const changed = useCallback37((items2) => {
    onChanged(items2.filter((i4) => i4.checked));
  }, []);
  return /* @__PURE__ */ jsx69("div", { children: /* @__PURE__ */ jsx69(CheckBoxList, { title, initialItems: items, onChanged: changed }) });
};

// src/shared/components/RateInfo.tsx
import { Fragment as Fragment17, jsx as jsx70, jsxs as jsxs46 } from "react/jsx-runtime";
var RateType = ({ payType }) => {
  switch (payType) {
    case "PER_HOUR":
      return /* @__PURE__ */ jsx70("div", { children: "Per Hour" });
    case "PER_YEAR":
      return /* @__PURE__ */ jsx70("div", { children: "Per Year" });
    case "PER_DAY":
      return /* @__PURE__ */ jsx70("div", { children: "Per Day" });
  }
  return /* @__PURE__ */ jsx70(Fragment17, {});
};
var RateInfo = ({ rate }) => {
  if (!rate) {
    return /* @__PURE__ */ jsx70(Fragment17, {});
  }
  if (rate.isPrivate) {
    return /* @__PURE__ */ jsx70("div", { children: "Negotiable" });
  }
  return /* @__PURE__ */ jsxs46("div", { className: "flex items-center space-x-2", children: [
    /* @__PURE__ */ jsxs46("div", { className: "flex items-center", children: [
      /* @__PURE__ */ jsx70("div", { className: "mr-0.5", children: rate.min }),
      /* @__PURE__ */ jsx70("div", { className: "mr-0.5", children: "-" }),
      /* @__PURE__ */ jsx70("div", { children: rate.max })
    ] }),
    /* @__PURE__ */ jsxs46("div", { className: "flex items-center space-x-1", children: [
      /* @__PURE__ */ jsx70("div", { children: /* @__PURE__ */ jsx70(RateType, { payType: rate.payType }) }),
      /* @__PURE__ */ jsxs46("div", { children: [
        "(",
        rate.currencyCode,
        ")"
      ] })
    ] })
  ] });
};

// src/shared/components/SingleFilter.tsx
import { useCallback as useCallback38 } from "react";
import { SelectMenu } from "shared-ui";
import { jsx as jsx71 } from "react/jsx-runtime";
var SingleFilter = ({
  title,
  widthClass,
  selected,
  values,
  onChanged
}) => {
  let status = null;
  if (selected) {
    status = values.find((l4) => l4.id === selected) || null;
  }
  const onChange = useCallback38(
    (item) => {
      if (item.id === "ALL") {
        onChanged(null);
      } else {
        onChanged(item);
      }
    },
    [onChanged]
  );
  return /* @__PURE__ */ jsx71(
    SelectMenu,
    {
      title,
      widthClass,
      items: values,
      onChange,
      value: status
    }
  );
};

// src/shared/components/SkillGroupList.tsx
import { Tags as Tags6 } from "shared-ui";
import { jsx as jsx72 } from "react/jsx-runtime";
var SkillGroupList = ({ skillGroups }) => {
  const skills = skillGroups.map((g3) => `${g3.name}`);
  return /* @__PURE__ */ jsx72(Tags6, { size: "xsmall", list: [...new Set(skills)] });
};

// src/shared/components/SortDirectionList.tsx
import { useCallback as useCallback39, useState as useState23 } from "react";
import { Button as Button20, Icon, Icons, Size as Size5, SortDir as SortDir3 } from "shared-ui";
import { jsx as jsx73 } from "react/jsx-runtime";
var SortDirectionList = ({ value, onChanged }) => {
  const [current, setCurrent] = useState23(() => {
    if (value) {
      return value;
    }
    return SortDir3.Desc;
  });
  const onSortAsc = useCallback39(() => {
    setCurrent(SortDir3.Asc);
    onChanged(SortDir3.Asc);
  }, [onChanged, setCurrent]);
  const onSortDesc = useCallback39(() => {
    setCurrent(SortDir3.Desc);
    onChanged(SortDir3.Desc);
  }, [onChanged, setCurrent]);
  if (current === SortDir3.Asc) {
    return /* @__PURE__ */ jsx73(Button20, { size: Size5.md, color: "white", clicked: onSortDesc, children: /* @__PURE__ */ jsx73(Icon, { height: "6", icon: Icons.BarsArrowUp }) });
  }
  return /* @__PURE__ */ jsx73(Button20, { size: Size5.md, color: "white", clicked: onSortAsc, children: /* @__PURE__ */ jsx73(Icon, { height: "6", icon: Icons.BarsArrowDown }) });
};

// src/shared/components/TextQueryFilter.tsx
import { useCallback as useCallback40, useState as useState24 } from "react";
import { MagnifyingGlassIcon, XCircleIcon as XCircleIcon2 } from "@heroicons/react/24/outline";
import { useDebounce } from "react-use";
import { Input as Input4 } from "shared-ui";
import { jsx as jsx74, jsxs as jsxs47 } from "react/jsx-runtime";
var TextQueryFilter = ({
  query: query3,
  placeholder,
  onChanged
}) => {
  const [searchTerm, setSearchTerm] = useState24(() => {
    return query3 || null;
  });
  const [, cancel] = useDebounce(
    () => {
      onChanged(searchTerm);
    },
    1e3,
    [searchTerm]
  );
  const change = useCallback40(
    (text) => {
      setSearchTerm(text);
    },
    [setSearchTerm]
  );
  const clear = useCallback40(() => {
    setSearchTerm(null);
    onChanged(searchTerm);
  }, [onChanged, searchTerm]);
  return /* @__PURE__ */ jsx74("div", { className: "flex grow", children: /* @__PURE__ */ jsx74("div", { className: "relative flex w-full grow items-center", children: /* @__PURE__ */ jsxs47("div", { className: "relative w-full text-gray-400 focus-within:text-gray-600", children: [
    /* @__PURE__ */ jsxs47("div", { className: "absolute inset-y-0 right-1 z-10 flex items-center", children: [
      !searchTerm && /* @__PURE__ */ jsx74(
        MagnifyingGlassIcon,
        {
          className: "mr-1 h-5 w-5 flex-shrink-0",
          "aria-hidden": "true"
        }
      ),
      /* @__PURE__ */ jsx74(
        "div",
        {
          onClick: clear,
          className: "absolute right-0 z-10 flex w-7 cursor-pointer justify-center",
          children: searchTerm ? /* @__PURE__ */ jsx74(XCircleIcon2, { className: "h-4 w-4" }) : ""
        }
      )
    ] }),
    /* @__PURE__ */ jsx74(
      Input4,
      {
        className: "w-full grow pr-7",
        value: searchTerm || "",
        type: "text",
        placeholder: placeholder || "Search here",
        onValueChange: change
      }
    )
  ] }) }) });
};

// src/shared/components/SignalBarComponent.tsx
import { SignalBar as SignalBar2, SignalBarSize as SignalBarSize2 } from "shared-ui";
import { Fragment as Fragment18, jsx as jsx75 } from "react/jsx-runtime";
var SignalBarComponent = ({
  state,
  size = "lg"
}) => {
  let signalBar = /* @__PURE__ */ jsx75(Fragment18, {});
  switch (state) {
    case "Yes": {
      signalBar = /* @__PURE__ */ jsx75("div", { className: "text-green-600", children: /* @__PURE__ */ jsx75(SignalBar2, { signalSize: SignalBarSize2.signalBar5, iconSize: size }) });
      break;
    }
    case "No": {
      signalBar = /* @__PURE__ */ jsx75("div", { className: "text-red-400", children: /* @__PURE__ */ jsx75(SignalBar2, { signalSize: SignalBarSize2.signalBar0, iconSize: size }) });
      break;
    }
    case "Unknown": {
      signalBar = /* @__PURE__ */ jsx75("div", { className: "text-gray-400", children: /* @__PURE__ */ jsx75(SignalBar2, { signalSize: SignalBarSize2.signalBar2, iconSize: size }) });
      break;
    }
  }
  return signalBar;
};

// src/vacancies/components/VacancySearchSort.tsx
import { jsx as jsx76 } from "react/jsx-runtime";
var VacancySearchSort = ({ onSearch }) => {
  const search4 = useAtomValue(vacancySearchAtom);
  const onSortFieldChanged = useCallback41(
    (item) => {
      switch (item?.id) {
        case "RECENT_ACTIVITY":
          onSearch("VacancySearchSortField", {
            ...search4,
            sortField: "LAST_ACTIVITY",
            sortOrder: "DESC"
          });
          break;
        case "MOST_RECENTLY_OPENED":
          onSearch("VacancySearchSortField", {
            ...search4,
            sortField: "DATE_OPENED",
            sortOrder: "DESC"
          });
          break;
        case "OLDEST_OPENED":
          onSearch("VacancySearchSortField", {
            ...search4,
            sortField: "DATE_OPENED",
            sortOrder: "ASC"
          });
          break;
        case "CLOSING_SOON":
          onSearch("VacancySearchSortField", {
            ...search4,
            sortField: "DATE_TO_BE_FILLED",
            sortOrder: "DESC"
          });
          break;
        case "VACANCY_NAME_ASC":
          onSearch("VacancySearchSortField", {
            ...search4,
            sortField: "VACANCY_NAME",
            sortOrder: "ASC"
          });
          break;
        case "VACANCY_NAME_DESC":
          onSearch("VacancySearchSortField", {
            ...search4,
            sortField: "VACANCY_NAME",
            sortOrder: "DESC"
          });
          break;
        case "RATES":
          onSearch("VacancySearchSortField", {
            ...search4,
            sortField: "RATE",
            sortOrder: "DESC"
          });
          break;
      }
    },
    [onSearch, search4]
  );
  const selected = useMemo13(() => {
    if (search4.sortField === "LAST_ACTIVITY" && search4.sortOrder === "DESC") {
      return "RECENT_ACTIVITY";
    }
    if (search4.sortField === "DATE_OPENED" && search4.sortOrder === "DESC") {
      return "MOST_RECENTLY_OPENED";
    }
    if (search4.sortField === "DATE_OPENED" && search4.sortOrder === "ASC") {
      return "OLDEST_OPENED";
    }
    if (search4.sortField === "DATE_TO_BE_FILLED" && search4.sortOrder === "DESC") {
      return "CLOSING_SOON";
    }
    if (search4.sortField === "VACANCY_NAME" && search4.sortOrder === "ASC") {
      return "VACANCY_NAME_ASC";
    }
    if (search4.sortField === "VACANCY_NAME" && search4.sortOrder === "DESC") {
      return "VACANCY_NAME_DESC";
    }
    if (search4.sortField === "RATE" && search4.sortOrder === "DESC") {
      return "RATES";
    }
  }, [search4.sortField, search4.sortOrder]);
  return /* @__PURE__ */ jsx76("div", { className: "flex gap-4 lg:justify-end ", children: /* @__PURE__ */ jsx76("div", { className: "flex grow justify-center", children: /* @__PURE__ */ jsx76("div", { className: "w-full", children: /* @__PURE__ */ jsx76(
    SingleFilter,
    {
      selected: selected || "RECENT_ACTIVITY",
      values: vacancySortValues,
      defaultValue: vacancySortBestMatch,
      onChanged: onSortFieldChanged
    }
  ) }) }) });
};

// src/vacancies/components/VacancySearchBox.tsx
import { useState as useState25 } from "react";
import { useAtomValue as useAtomValue2 } from "jotai";
import { SelectMenu as SelectMenu2 } from "shared-ui";
import { jsx as jsx77, jsxs as jsxs48 } from "react/jsx-runtime";
var VacancySearchBox = ({
  onSearch,
  className,
  searchClassName,
  sortClassName
}) => {
  const search4 = useAtomValue2(vacancySearchAtom);
  const [queryValue, setQueryValue] = useState25("");
  const [selectedValue, setSelectedValue] = useState25({
    id: "query",
    name: "All"
  });
  const onQueryChanged = (query3) => {
    setQueryValue(query3);
    const newSearch = {
      ...search4,
      query: null,
      [selectedValue.id]: query3
    };
    onSearch("VacancySearchBox", newSearch);
  };
  const onSelectionChanged = (selection) => {
    setSelectedValue(selection);
    const newSearch = {
      ...search4,
      query: null,
      employerReference: null,
      createdByName: null,
      name: null,
      [selection.id]: queryValue
    };
    onSearch("VacancySearchBox", newSearch);
  };
  return /* @__PURE__ */ jsxs48("div", { className: `flex grow gap-1 lg:m-2 ${className}`, children: [
    /* @__PURE__ */ jsx77("label", { htmlFor: "search-field", className: "sr-only", children: "Search" }),
    /* @__PURE__ */ jsx77("div", { className: "relative flex w-full grow lg:min-w-[400px]", children: /* @__PURE__ */ jsx77(TextQueryFilter, { placeholder: "Search", onChanged: onQueryChanged }) }),
    /* @__PURE__ */ jsx77("div", { className: "flex w-full justify-end lg:flex-1", children: /* @__PURE__ */ jsx77(
      SelectMenu2,
      {
        className: "text-2xl lg:max-w-[200px]",
        value: selectedValue,
        items: [
          { id: "query", name: "All" },
          { id: "name", name: "Vacancy Name" },
          { id: "employerReference", name: "Reference Number" },
          { id: "createdByName", name: "User Name" }
        ],
        onChange: onSelectionChanged
      }
    ) })
  ] });
};

// src/vacancies/components/__generated__/VacancySearchListQueryFragment.graphql.ts
var node101 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  }, v32 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "count",
      "storageKey": null
    },
    v23
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "VacancySearchListQueryFragment",
      "selections": [
        {
          "args": v1,
          "kind": "FragmentSpread",
          "name": "VacancySearchList_vacancies"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "VacancySearchListQueryFragment",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "VacancySearchResult",
          "kind": "LinkedField",
          "name": "recruitVacanciesSearch",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CollectionMetaData",
              "kind": "LinkedField",
              "name": "paging",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "itemsPerPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "pageNumber",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "pages",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "totalResults",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "VacancySearchModel",
              "kind": "LinkedField",
              "name": "items",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "vacancyId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "code",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "employerName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "projectName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "employerReference",
                  "storageKey": null
                },
                v23,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "recommendations",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "matches",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "expiresAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "dateCreated",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "dateOpened",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "VacancyCandidateCount",
                  "kind": "LinkedField",
                  "name": "candidateCounts",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CandidateCount",
                      "kind": "LinkedField",
                      "name": "created",
                      "plural": false,
                      "selections": v32,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CandidateCount",
                      "kind": "LinkedField",
                      "name": "submitted",
                      "plural": false,
                      "selections": v32,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CandidateCount",
                      "kind": "LinkedField",
                      "name": "active",
                      "plural": false,
                      "selections": v32,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CandidateCount",
                      "kind": "LinkedField",
                      "name": "hired",
                      "plural": false,
                      "selections": v32,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CandidateCount",
                      "kind": "LinkedField",
                      "name": "withdrawn",
                      "plural": false,
                      "selections": v32,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CandidateCount",
                      "kind": "LinkedField",
                      "name": "unsuccessful",
                      "plural": false,
                      "selections": v32,
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "b65e42e65824aeae1df9fe194b7897fb",
      "id": null,
      "metadata": {},
      "name": "VacancySearchListQueryFragment",
      "operationKind": "query",
      "text": "query VacancySearchListQueryFragment(\n  $input: VacancySearchInput!\n) {\n  ...VacancySearchList_vacancies_2VV6jB\n}\n\nfragment VacancySearchDashboardChart_vacancy on VacancySearchModel {\n  id\n  name\n  code\n  status\n  candidateCounts {\n    created {\n      count\n      status\n    }\n    submitted {\n      count\n      status\n    }\n    active {\n      count\n      status\n    }\n    hired {\n      count\n      status\n    }\n    withdrawn {\n      count\n      status\n    }\n    unsuccessful {\n      count\n      status\n    }\n  }\n}\n\nfragment VacancySearchDashboardLayout_vacancy on VacancySearchModel {\n  id\n  status\n  employerReference\n  projectName\n  ...VacancySearchDashboardChart_vacancy\n}\n\nfragment VacancySearchHeader_vacancy on VacancySearchModel {\n  id\n  name\n  code\n  status\n  projectName\n  employerName\n}\n\nfragment VacancySearchList_vacancies_2VV6jB on Query {\n  result: recruitVacanciesSearch(input: $input) {\n    paging {\n      itemsPerPage\n      pageNumber\n      pages\n      totalResults\n    }\n    items {\n      id\n      vacancyId\n      name\n      code\n      employerName\n      projectName\n      employerReference\n      status\n      recommendations\n      matches\n      expiresAt\n      dateCreated\n      dateOpened\n      candidateCounts {\n        created {\n          count\n          status\n        }\n        submitted {\n          count\n          status\n        }\n        active {\n          count\n          status\n        }\n        hired {\n          count\n          status\n        }\n        withdrawn {\n          count\n          status\n        }\n        unsuccessful {\n          count\n          status\n        }\n        ...VacancySearchList_vacancyCandidateCount\n      }\n      ...VacancySearchHeader_vacancy\n      ...VacancySearchDashboardLayout_vacancy\n    }\n  }\n}\n\nfragment VacancySearchList_vacancyCandidateCount on VacancyCandidateCount {\n  created {\n    count\n    status\n  }\n  submitted {\n    count\n    status\n  }\n  active {\n    count\n    status\n  }\n  hired {\n    count\n    status\n  }\n  withdrawn {\n    count\n    status\n  }\n  unsuccessful {\n    count\n    status\n  }\n}\n"
    }
  };
}();
node101.hash = "965f304110bc05c46b428050fded56b6";
var VacancySearchListQueryFragment_graphql_default = node101;

// src/vacancies/components/__generated__/VacancySearchList_vacancies.graphql.ts
var node102 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  }, v1 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "count",
      "storageKey": null
    },
    v0
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "refetch": {
        "connection": null,
        "fragmentPathInResult": [],
        "operation": VacancySearchListQueryFragment_graphql_default
      }
    },
    "name": "VacancySearchList_vacancies",
    "selections": [
      {
        "alias": "result",
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "VacancySearchResult",
        "kind": "LinkedField",
        "name": "recruitVacanciesSearch",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CollectionMetaData",
            "kind": "LinkedField",
            "name": "paging",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "itemsPerPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pageNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pages",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalResults",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VacancySearchModel",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vacancyId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "code",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "employerName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "employerReference",
                "storageKey": null
              },
              v0,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "recommendations",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "matches",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "expiresAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dateCreated",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dateOpened",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "VacancyCandidateCount",
                "kind": "LinkedField",
                "name": "candidateCounts",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CandidateCount",
                    "kind": "LinkedField",
                    "name": "created",
                    "plural": false,
                    "selections": v1,
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CandidateCount",
                    "kind": "LinkedField",
                    "name": "submitted",
                    "plural": false,
                    "selections": v1,
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CandidateCount",
                    "kind": "LinkedField",
                    "name": "active",
                    "plural": false,
                    "selections": v1,
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CandidateCount",
                    "kind": "LinkedField",
                    "name": "hired",
                    "plural": false,
                    "selections": v1,
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CandidateCount",
                    "kind": "LinkedField",
                    "name": "withdrawn",
                    "plural": false,
                    "selections": v1,
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CandidateCount",
                    "kind": "LinkedField",
                    "name": "unsuccessful",
                    "plural": false,
                    "selections": v1,
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "VacancySearchList_vacancyCandidateCount"
                  }
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "VacancySearchHeader_vacancy"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "VacancySearchDashboardLayout_vacancy"
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node102.hash = "965f304110bc05c46b428050fded56b6";
var VacancySearchList_vacancies_graphql_default = node102;

// src/vacancies/components/__generated__/VacancySearchList_vacancyCandidateCount.graphql.ts
var node103 = function() {
  var v0 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "count",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ];
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "VacancySearchList_vacancyCandidateCount",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CandidateCount",
        "kind": "LinkedField",
        "name": "created",
        "plural": false,
        "selections": v0,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CandidateCount",
        "kind": "LinkedField",
        "name": "submitted",
        "plural": false,
        "selections": v0,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CandidateCount",
        "kind": "LinkedField",
        "name": "active",
        "plural": false,
        "selections": v0,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CandidateCount",
        "kind": "LinkedField",
        "name": "hired",
        "plural": false,
        "selections": v0,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CandidateCount",
        "kind": "LinkedField",
        "name": "withdrawn",
        "plural": false,
        "selections": v0,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CandidateCount",
        "kind": "LinkedField",
        "name": "unsuccessful",
        "plural": false,
        "selections": v0,
        "storageKey": null
      }
    ],
    "type": "VacancyCandidateCount",
    "abstractKey": null
  };
}();
node103.hash = "103851da7603bd933bd9a4aea01a0779";
var VacancySearchList_vacancyCandidateCount_graphql_default = node103;

// src/vacancies/components/VacancySearchList.tsx
import { useCallback as useCallback42, useMemo as useMemo14 } from "react";
import { useFragment as useFragment29 } from "react-relay";
import { useNavigate as useNavigate7 } from "react-router-dom";
import { useAtom as useAtom4 } from "jotai";
import { EdColumnCell as EdColumnCell2, EdRow as EdRow2, EdTable as EdTable2, SwitchInputComponent, Tag as Tag7 } from "shared-ui";
import { formatDate as formatDate2 } from "shared-lib";
import { Fragment as Fragment19, jsx as jsx78, jsxs as jsxs49 } from "react/jsx-runtime";
var fragmentDef26 = VacancySearchList_vacancies_graphql_default;
var tagColors = {
  DRAFT: "bg-primary-200",
  OPEN: "bg-green-200",
  FILLED: "bg-orange-200",
  ARCHIVED: "bg-orange-200"
};
var defaultColumns = [
  { id: "vacancy", name: "Vacancy" },
  { id: "status", name: "Status" },
  { id: "candidates", name: "Candidates" },
  { id: "project", name: "Project" },
  { id: "dates", name: "Dates" }
];
var VacancySearchList = ({ result }) => {
  const navigate = useNavigate7();
  const [vacancySelectState, setVacancySelectState] = useAtom4(vacancySelectAtom);
  const { vacancySelectEnabled } = vacancySelectState;
  const addVacancyToSelectList = useCallback42(
    (vacancy) => {
      let selectedVacancies = vacancySelectState.selectedVacancies.filter(
        (x4) => x4.code !== vacancy.code
      );
      if (!vacancySelectState.selectedVacancies.find((x4) => x4.code === vacancy.code)) {
        selectedVacancies = [...selectedVacancies, vacancy];
      }
      setVacancySelectState({
        ...vacancySelectState,
        selectedVacancies
      });
    },
    [setVacancySelectState, vacancySelectState]
  );
  const selectedVacancyCodes = useMemo14(() => {
    return vacancySelectState.selectedVacancies.map((x4) => x4.code);
  }, [vacancySelectState.selectedVacancies]);
  const selectVacancyRow = useCallback42(
    (x4) => {
      navigate(
        x4.status === "DRAFT" ? `../view/${x4.code}/edit/wizard/description` : `../view/${x4.code}/dashboard`
      );
    },
    [navigate]
  );
  return /* @__PURE__ */ jsxs49("div", { className: "flex w-full grow", children: [
    /* @__PURE__ */ jsx78("div", { className: "flex w-full flex-col gap-2 text-sm 2xl:hidden", children: result.result.items.map((x4) => /* @__PURE__ */ jsx78("div", { children: /* @__PURE__ */ jsx78(
      EdTable2,
      {
        hasActionsColumn: false,
        fixedHeight: false,
        classes: vacancySelectEnabled && selectedVacancyCodes.includes(x4.code) ? "border border-black rounded" : "",
        defaultColumns: [],
        rows: [
          /* @__PURE__ */ jsxs49(EdRow2, { rowKey: String(x4.code), className: "bg-primary-50", children: [
            /* @__PURE__ */ jsx78(EdColumnCell2, { wrap: true, className: "text-lg text-gray-700 lg:text-xl", children: /* @__PURE__ */ jsx78("div", { onClick: () => selectVacancyRow(x4), children: x4.name }) }),
            /* @__PURE__ */ jsx78(EdColumnCell2, { className: "text-right", wrap: true, children: /* @__PURE__ */ jsx78("div", { className: "flex w-full text-right justify-end", children: /* @__PURE__ */ jsx78(SwitchInputComponent, { value: selectedVacancyCodes.includes(x4.code), onChange: () => {
              addVacancyToSelectList(x4);
            } }) }) })
          ] }, x4.code + "select"),
          /* @__PURE__ */ jsxs49(EdRow2, { rowKey: String(x4.code), children: [
            /* @__PURE__ */ jsx78(EdColumnCell2, { className: "text-gray-700", children: "Status" }),
            /* @__PURE__ */ jsx78(EdColumnCell2, { className: "text-right", wrap: true, children: /* @__PURE__ */ jsx78(Tag7, { color: tagColors[x4.status], children: x4.status }) })
          ] }, x4.code + "status"),
          /* @__PURE__ */ jsxs49(EdRow2, { children: [
            /* @__PURE__ */ jsx78(EdColumnCell2, { className: "text-gray-700", children: "Candidates" }),
            /* @__PURE__ */ jsx78(EdColumnCell2, { className: "text-right", wrap: true, children: /* @__PURE__ */ jsx78("div", { className: "inline-block ", children: x4.status !== "DRAFT" ? /* @__PURE__ */ jsxs49("div", { className: "lg:min-w-[200px]", children: [
              /* @__PURE__ */ jsxs49("div", { className: "flex justify-between gap-5", children: [
                /* @__PURE__ */ jsx78("div", { children: "Applicants" }),
                /* @__PURE__ */ jsx78("div", { children: /* @__PURE__ */ jsx78(
                  ApplicantsCount,
                  {
                    fragmentRef: x4.candidateCounts
                  }
                ) })
              ] }),
              /* @__PURE__ */ jsxs49("div", { className: "flex justify-between gap-5", children: [
                /* @__PURE__ */ jsx78("div", { children: "Recommended" }),
                /* @__PURE__ */ jsx78("div", { children: x4.recommendations })
              ] }),
              /* @__PURE__ */ jsxs49("div", { className: "flex justify-between gap-5", children: [
                /* @__PURE__ */ jsx78("div", { children: "Matches" }),
                /* @__PURE__ */ jsx78("div", { children: x4.matches })
              ] })
            ] }) : /* @__PURE__ */ jsx78("div", { children: "-" }) }) })
          ] }, x4.code + "candidates"),
          /* @__PURE__ */ jsxs49(EdRow2, { rowKey: String(x4.code), children: [
            /* @__PURE__ */ jsx78(EdColumnCell2, { className: "text-gray-700", children: "Project" }),
            /* @__PURE__ */ jsx78(EdColumnCell2, { className: "text-right", wrap: true, children: x4.employerReference })
          ] }, x4.code + "project"),
          /* @__PURE__ */ jsxs49(EdRow2, { children: [
            /* @__PURE__ */ jsx78(EdColumnCell2, { className: "text-gray-700", children: "Dates" }),
            /* @__PURE__ */ jsx78(EdColumnCell2, { className: "text-right", wrap: true, children: /* @__PURE__ */ jsxs49("td", { className: "inline-block lg:min-w-[200px] ", children: [
              /* @__PURE__ */ jsxs49("div", { className: "flex justify-between gap-5", children: [
                /* @__PURE__ */ jsx78("div", { children: "Expires" }),
                /* @__PURE__ */ jsx78("div", { children: formatDate2(x4.expiresAt) })
              ] }),
              /* @__PURE__ */ jsxs49("div", { className: "flex justify-between gap-5", children: [
                /* @__PURE__ */ jsx78("div", { children: "Published" }),
                /* @__PURE__ */ jsx78("div", { children: x4.status === "DRAFT" ? "-" : formatDate2(x4.dateOpened) })
              ] }),
              /* @__PURE__ */ jsxs49("div", { className: "flex justify-between gap-5", children: [
                /* @__PURE__ */ jsx78("div", { children: "Created" }),
                /* @__PURE__ */ jsx78("div", { children: formatDate2(x4.dateCreated) })
              ] })
            ] }) })
          ] }, x4.code + "dates")
        ]
      }
    ) }, x4.code)) }),
    /* @__PURE__ */ jsx78("div", { className: "hidden w-full 2xl:flex", children: /* @__PURE__ */ jsx78(
      EdTable2,
      {
        hasActionsColumn: false,
        fixedHeight: false,
        defaultColumns: [{ id: "select", name: "Select" }, ...defaultColumns],
        rows: result.result.items.map((x4) => /* @__PURE__ */ jsxs49(
          EdRow2,
          {
            rowKey: String(x4.code),
            className: vacancySelectEnabled && selectedVacancyCodes.includes(x4.code) ? "bg-primary-100 hover:bg-primary-100" : "",
            children: [
              /* @__PURE__ */ jsx78(EdColumnCell2, { children: /* @__PURE__ */ jsx78(SwitchInputComponent, { value: selectedVacancyCodes.includes(x4.code), onChange: function(e4) {
                addVacancyToSelectList(x4);
              } }) }),
              /* @__PURE__ */ jsx78(EdColumnCell2, { children: /* @__PURE__ */ jsx78("div", { onClick: () => {
                navigate(
                  x4.status === "DRAFT" ? `../view/${x4.code}/edit/wizard/description` : `../view/${x4.code}/dashboard`
                );
              }, children: x4.name }) }),
              /* @__PURE__ */ jsx78(EdColumnCell2, { children: /* @__PURE__ */ jsx78(Tag7, { color: tagColors[x4.status], children: x4.status }) }),
              /* @__PURE__ */ jsx78(EdColumnCell2, { children: x4.status !== "DRAFT" ? /* @__PURE__ */ jsxs49(Fragment19, { children: [
                /* @__PURE__ */ jsxs49("div", { className: "flex justify-between gap-5", children: [
                  /* @__PURE__ */ jsx78("div", { children: "Applicants" }),
                  /* @__PURE__ */ jsx78("div", { children: /* @__PURE__ */ jsx78(ApplicantsCount, { fragmentRef: x4.candidateCounts }) })
                ] }),
                /* @__PURE__ */ jsxs49("div", { className: "flex justify-between gap-5", children: [
                  /* @__PURE__ */ jsx78("div", { children: "Recommended" }),
                  /* @__PURE__ */ jsx78("div", { children: x4.recommendations })
                ] }),
                /* @__PURE__ */ jsxs49("div", { className: "flex justify-between gap-5", children: [
                  /* @__PURE__ */ jsx78("div", { children: "Matches" }),
                  /* @__PURE__ */ jsx78("div", { children: x4.matches })
                ] })
              ] }) : /* @__PURE__ */ jsx78("div", { children: "-" }) }),
              /* @__PURE__ */ jsx78(EdColumnCell2, { children: x4.employerReference }),
              /* @__PURE__ */ jsxs49(EdColumnCell2, { children: [
                /* @__PURE__ */ jsxs49("div", { className: "flex justify-between gap-5", children: [
                  /* @__PURE__ */ jsx78("div", { children: "Expires" }),
                  /* @__PURE__ */ jsx78("div", { children: formatDate2(x4.expiresAt) })
                ] }),
                /* @__PURE__ */ jsxs49("div", { className: "flex justify-between gap-5", children: [
                  /* @__PURE__ */ jsx78("div", { children: "Published" }),
                  /* @__PURE__ */ jsx78("div", { children: x4.status === "DRAFT" ? "-" : formatDate2(x4.dateOpened) })
                ] }),
                /* @__PURE__ */ jsxs49("div", { className: "flex justify-between gap-5", children: [
                  /* @__PURE__ */ jsx78("div", { children: "Created" }),
                  /* @__PURE__ */ jsx78("div", { children: formatDate2(x4.dateCreated) })
                ] })
              ] })
            ]
          },
          x4.code
        ))
      }
    ) })
  ] });
};
function ApplicantsCount({
  fragmentRef
}) {
  const data = useFragment29(
    ApplicantsCount.fragments.vacancySearchModel,
    fragmentRef
  );
  const applications = useMemo14(() => {
    return Object.values(data).map((x4) => x4?.count).reduce((acc, item) => acc + (item || 0), 0);
  }, [data]);
  return /* @__PURE__ */ jsx78("div", { children: applications });
}
ApplicantsCount.fragments = {
  vacancySearchModel: VacancySearchList_vacancyCandidateCount_graphql_default
};

// src/candidates/components/__generated__/VacancySearchFacets_aggregations.graphql.ts
var node104 = function() {
  var v0 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "count",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MultiFacetContainer_facet"
    }
  ];
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "VacancySearchFacets_aggregations",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "DefaultAggregationModel",
        "kind": "LinkedField",
        "name": "createdBy",
        "plural": false,
        "selections": v0,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DefaultAggregationModel",
        "kind": "LinkedField",
        "name": "projects",
        "plural": false,
        "selections": v0,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DefaultAggregationModel",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": v0,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DefaultAggregationModel",
        "kind": "LinkedField",
        "name": "skills",
        "plural": false,
        "selections": v0,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DefaultAggregationModel",
        "kind": "LinkedField",
        "name": "closingOn",
        "plural": false,
        "selections": v0,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DefaultAggregationModel",
        "kind": "LinkedField",
        "name": "employmentType",
        "plural": false,
        "selections": v0,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DefaultAggregationModel",
        "kind": "LinkedField",
        "name": "jobTitles",
        "plural": false,
        "selections": v0,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DefaultAggregationModel",
        "kind": "LinkedField",
        "name": "locations",
        "plural": false,
        "selections": v0,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DefaultAggregationModel",
        "kind": "LinkedField",
        "name": "openedOn",
        "plural": false,
        "selections": v0,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DefaultAggregationModel",
        "kind": "LinkedField",
        "name": "companies",
        "plural": false,
        "selections": v0,
        "storageKey": null
      }
    ],
    "type": "VacancySearchResultFacets",
    "abstractKey": null
  };
}();
node104.hash = "6ef82eb98fe0cd859e0e431a02d7bb2b";
var VacancySearchFacets_aggregations_graphql_default = node104;

// src/candidates/components/VacancySearchFacets.tsx
import { useCallback as useCallback43, useState as useState26 } from "react";
import { useFragment as useFragment30 } from "react-relay";
import {
  FilterSectionContainer,
  FilterSectionLink
} from "shared-ui";
import { MultiFacetContainer } from "app-core";
import { useToggle as useToggle12 } from "shared-lib";
import { jsx as jsx79 } from "react/jsx-runtime";
var defaultAggregationFacetsFragment = VacancySearchFacets_aggregations_graphql_default;
var mutationMap = {
  createdBy: { mutationKey: "createdById", label: "Created By" },
  projects: { mutationKey: "projectId", label: "Projects" },
  status: { mutationKey: "status", label: "Status" },
  skills: { mutationKey: "skills", label: "Skills" },
  companies: { mutationKey: "employerId", label: "Employer" },
  employmentType: { mutationKey: "employmentType", label: "Employment Type" },
  jobTitles: { mutationKey: "jobTitles", label: "Job Titles" },
  lastActivity: { mutationKey: "lastActivity", label: "Last Activity" },
  locationHierarchies: {
    mutationKey: "locationHierarchies",
    label: "Location Hierarchies"
  },
  locations: { mutationKey: "locations", label: "Locations" },
  openedOn: { mutationKey: "dateCreated", label: "Opened On" },
  closingOn: { mutationKey: "dateToBeFilled", label: "Closing On" },
  targetCompanies: { mutationKey: "employerName", label: "Target Companies" }
};
var VacancySearchFacets = ({ fragmentRef, onSearch }) => {
  const result = useFragment30(
    defaultAggregationFacetsFragment,
    fragmentRef
  );
  const filterSections4 = Object.keys(result).map(
    (x4) => ({
      key: x4,
      title: mutationMap[x4].label
    })
  );
  const [selectedSection, setSelectedSection] = useState26("");
  const onFacetChanged = useCallback43(
    (key, value) => {
      onSearch("VacancyRecommendationSearchFilters", {
        key: mutationMap[key].mutationKey,
        value
      });
    },
    [onSearch]
  );
  const sections = filterSections4.map((s4) => {
    return /* @__PURE__ */ jsx79(
      FilterSectionLink,
      {
        section: s4,
        onSelect: (value) => setSelectedSection(value),
        selectedKey: selectedSection
      },
      s4.key
    );
  });
  const [isOpen, toggleOpen] = useToggle12(true);
  return /* @__PURE__ */ jsx79(
    FilterSectionContainer,
    {
      sections,
      isFiltersOpen: isOpen,
      onToggleOpen: toggleOpen,
      hasSelectedValue: !!selectedSection,
      toggleSelectedValue: () => setSelectedSection(""),
      children: Object.entries(result).filter(([key]) => key === selectedSection).map(([key, value]) => /* @__PURE__ */ jsx79(
        MultiFacetContainer,
        {
          fragmentRef: value,
          onFacetChanged: (selectedValue) => onFacetChanged(key, selectedValue)
        },
        key
      ))
    }
  );
};

// src/vacancies/components/__generated__/VacancyCloseRouteQuery.graphql.ts
var node105 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "vacancyCode"
    }
  ], v1 = [
    {
      "alias": "vacancy",
      "args": [
        {
          "kind": "Variable",
          "name": "vacancyCode",
          "variableName": "vacancyCode"
        }
      ],
      "concreteType": "Vacancy",
      "kind": "LinkedField",
      "name": "recruitVacancyByCode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "vacancyId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dateOpened",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dateFilled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "archivedAt",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "VacancyCloseRouteQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "VacancyCloseRouteQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "c826f182461066e3720152e2b34a9c47",
      "id": null,
      "metadata": {},
      "name": "VacancyCloseRouteQuery",
      "operationKind": "query",
      "text": "query VacancyCloseRouteQuery(\n  $vacancyCode: Int!\n) {\n  vacancy: recruitVacancyByCode(vacancyCode: $vacancyCode) {\n    id\n    code\n    vacancyId\n    name\n    status\n    createdAt\n    updatedAt\n    dateOpened\n    dateFilled\n    archivedAt\n  }\n}\n"
    }
  };
}();
node105.hash = "3cc2da75d99d6181b791083bfce469bd";
var VacancyCloseRouteQuery_graphql_default = node105;

// src/vacancies/components/VacancyClose.tsx
import { Suspense as Suspense13, useCallback as useCallback45, useState as useState28 } from "react";
import {
  loadQuery as loadQuery2,
  usePreloadedQuery as usePreloadedQuery2
} from "react-relay";
import { useRouteLoaderData } from "react-router-dom";
import { useNavigate as useNavigate8 } from "react-router-dom";
import { Button as Button21, ButtonList as ButtonList8, EdSkeleton as EdSkeleton8, Size as Size6, TextArea as TextArea2 } from "shared-ui";
import { createClientMutationId as createClientMutationId20, timeAgo as timeAgo3 } from "shared-lib";

// src/vacancies/components/FulfillmentReasonsSelectList.tsx
import { useCallback as useCallback44, useMemo as useMemo15, useState as useState27 } from "react";
import { useAtom as useAtom5 } from "jotai";
import { CheckCircleIcon, PlusIcon } from "@heroicons/react/24/solid";
import { classNames as classNames7 } from "shared-ui";

// src/lib/DocumentSearch.ts
import { tokenize as tokenize2 } from "shared-lib";
var DocumentSearchResult2 = class {
  constructor(sentences, source) {
    this.showAll = false;
    this.sentences = sentences;
    this.hasMatches = this.sentences.length > 0;
    this.source = source;
  }
};
var DocumentSearchIndex2 = class {
  constructor(source) {
    this.source = source;
    this.document = tokenize2(source.description);
  }
  filterSentences(terms) {
    return new DocumentSearchResult2(
      this.document.sentencesWithContent(terms),
      this.source
    );
  }
};
var DocumentSearchIndexCollection2 = class {
  constructor(sources) {
    this.sources = [];
    this.sources = sources.map(
      (p4) => new DocumentSearchIndex2(p4)
    );
  }
  filterExperiences(terms) {
    return (this.sources || []).map(
      (e4) => e4.filterSentences(terms)
    );
  }
};

// src/lib/RecruitDomainErrorCodes.ts
var ApplicationErrorSpec = class {
  constructor(prefix) {
    this.ResumeRequired = `${prefix}_APPLICATION_RESUME_REQUIRED`;
    this.ResumeClarification = `${prefix}_APPLICATION_RESUME_CLARIFICATION`;
  }
};
var RecruitSpec = class {
  constructor() {
    this.prefix = "RECRUIT";
    this.Application = new ApplicationErrorSpec(this.prefix);
  }
};
var RecruitDomainErrorCodes = class {
};
RecruitDomainErrorCodes.Recruit = new RecruitSpec();

// src/lib/__generated__/FulfillmentReasonsAtomQuery.graphql.ts
var node106 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "employerId"
    }
  ], v1 = [
    {
      "alias": "items",
      "args": [
        {
          "kind": "Variable",
          "name": "employerId",
          "variableName": "employerId"
        },
        {
          "kind": "Literal",
          "name": "where",
          "value": {
            "discriminator": {
              "eq": "VacancyFulfilmentReason"
            }
          }
        }
      ],
      "concreteType": "RefDataItemsByEmployerConnection",
      "kind": "LinkedField",
      "name": "refDataItemsByEmployer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasPreviousPage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RefDataItemsByEmployerEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RefDataItem",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "refDataItemId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "discriminator",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "tenantId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "display",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "displayOrder",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "FulfillmentReasonsAtomQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "FulfillmentReasonsAtomQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "9575c9f90ec7551529cd57827434c51c",
      "id": null,
      "metadata": {},
      "name": "FulfillmentReasonsAtomQuery",
      "operationKind": "query",
      "text": 'query FulfillmentReasonsAtomQuery(\n  $employerId: UUID!\n) {\n  items: refDataItemsByEmployer(employerId: $employerId, where: {discriminator: {eq: "VacancyFulfilmentReason"}}) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        refDataItemId\n        discriminator\n        tenantId\n        display\n        displayOrder\n      }\n    }\n  }\n}\n'
    }
  };
}();
node106.hash = "7ca35ee168f9b363ffcbcf2d64900629";
var FulfillmentReasonsAtomQuery_graphql_default = node106;

// src/lib/FulfillmentReasonsAtom.ts
import { atomWithQuery } from "jotai-relay";
import { employerIdAtom } from "app-core";
var query = FulfillmentReasonsAtomQuery_graphql_default;
var fulfillmentReasonsAtom = atomWithQuery(query, (get) => ({
  employerId: get(employerIdAtom)
}));

// src/vacancies/components/FulfillmentReasonsSelectList.tsx
import { jsx as jsx80, jsxs as jsxs50 } from "react/jsx-runtime";
function sortReasons(a4, b3) {
  if (a4.displayOrder === b3.displayOrder) {
    return 0;
  }
  return (a4.displayOrder || 0) < (b3.displayOrder || 0) ? 1 : -1;
}
var FulfillmentReasonsSelectItem = ({
  reason,
  currentId,
  onSelect
}) => {
  const onClick = useCallback44(() => {
    onSelect(reason);
  }, [onSelect]);
  const isSelected = reason.refDataItemId == currentId;
  return /* @__PURE__ */ jsxs50(
    "div",
    {
      className: classNames7(
        "prose flex cursor-pointer items-center py-2 leading-6",
        isSelected ? "bg-primary-800 hover:bg-primary-700 text-white" : " hover:bg-gray-50"
      ),
      onClick,
      children: [
        /* @__PURE__ */ jsx80("div", { className: "mx-2", children: isSelected ? /* @__PURE__ */ jsx80(CheckCircleIcon, { className: "primary h-6 w-6", "aria-hidden": "true" }) : /* @__PURE__ */ jsx80(PlusIcon, { className: "primary h-6 w-6", "aria-hidden": "true" }) }),
        /* @__PURE__ */ jsx80("div", { children: reason.display })
      ]
    },
    reason.refDataItemId
  );
};
var FulfillmentReasonsSelectList = ({ onSelect }) => {
  const [data, dispatch2] = useAtom5(fulfillmentReasonsAtom);
  const reasons = useMemo15(() => {
    const edges = data.items?.edges || [];
    const nodes = edges.map((e4) => e4.node);
    return nodes.sort(sortReasons);
  }, [data]);
  const [currentId, setCurrentId] = useState27(null);
  const onSelectReason = useCallback44(
    (value) => {
      setCurrentId(value.refDataItemId);
      onSelect(value);
    },
    [onSelect, setCurrentId]
  );
  const items = reasons.map((r4) => {
    return /* @__PURE__ */ jsx80(
      FulfillmentReasonsSelectItem,
      {
        reason: r4,
        currentId,
        onSelect: onSelectReason
      },
      r4.refDataItemId
    );
  });
  return /* @__PURE__ */ jsxs50("div", { children: [
    /* @__PURE__ */ jsx80("div", { className: "text-primary-900 mb-2 text-lg", children: "Reason" }),
    /* @__PURE__ */ jsx80("div", { className: "flex flex-col divide-y overflow-hidden rounded-lg border bg-gray-100 bg-white ", children: items })
  ] });
};

// src/vacancies/mutations/__generated__/VacancyUpdateDetailsMutation.graphql.ts
var node107 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationAmount",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationType",
    "storageKey": null
  }, v7 = [
    v5,
    v6
  ], v8 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfVacancy",
    "kind": "LinkedField",
    "name": "vacancy",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Vacancy",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          v23,
          v32,
          v4,
          {
            "alias": null,
            "args": null,
            "concreteType": "KeyValuePairOfStringAndInt32",
            "kind": "LinkedField",
            "name": "filterStats",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VacancyRate",
            "kind": "LinkedField",
            "name": "rate",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currencyCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currencyCountryCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currencyCountryName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isPrivate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "max",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "min",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "payType",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VacancyDates",
            "kind": "LinkedField",
            "name": "dates",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startAsap",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "durationCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "durationDescription",
                "storageKey": null
              },
              v5,
              v6
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VacancySkillAnalysis",
            "kind": "LinkedField",
            "name": "autogeneratedSkillGroups",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SkillGroup",
                "kind": "LinkedField",
                "name": "skillGroups",
                "plural": true,
                "selections": [
                  v23,
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isRequired",
                    "storageKey": null
                  },
                  v4,
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "weight",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SkillGroupTerm",
                    "kind": "LinkedField",
                    "name": "terms",
                    "plural": true,
                    "selections": [
                      v4,
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isSkill",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Duration",
                    "kind": "LinkedField",
                    "name": "experience",
                    "plural": false,
                    "selections": v7,
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Duration",
                    "kind": "LinkedField",
                    "name": "recency",
                    "plural": false,
                    "selections": v7,
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "expiresAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerReference",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "headcount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LocationCriteria",
            "kind": "LinkedField",
            "name": "locations",
            "plural": true,
            "selections": [
              v4,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "countryCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "latitude",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "longitude",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v9 = {
    "kind": "InlineFragment",
    "selections": [
      v32,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "VacancyUpdateDetailsMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitVacancyDetailsUpdatePayload",
          "kind": "LinkedField",
          "name": "recruitVacancyDetailsUpdate",
          "plural": false,
          "selections": [
            v8,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v9
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "VacancyUpdateDetailsMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitVacancyDetailsUpdatePayload",
          "kind": "LinkedField",
          "name": "recruitVacancyDetailsUpdate",
          "plural": false,
          "selections": [
            v8,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v9
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "0de4913e9aaaa030a710ad3fa857cdd7",
      "id": null,
      "metadata": {},
      "name": "VacancyUpdateDetailsMutation",
      "operationKind": "mutation",
      "text": "mutation VacancyUpdateDetailsMutation(\n  $input: RecruitVacancyDetailsUpdateInput!\n) {\n  result: recruitVacancyDetailsUpdate(input: $input) {\n    vacancy {\n      cursor\n      node {\n        id\n        code\n        name\n        filterStats {\n          key\n          value\n        }\n        rate {\n          currencyCode\n          currencyCountryCode\n          currencyCountryName\n          isPrivate\n          max\n          min\n          payType\n        }\n        dates {\n          startDate\n          startAsap\n          durationCode\n          durationDescription\n          durationAmount\n          durationType\n        }\n        autogeneratedSkillGroups {\n          status\n          skillGroups {\n            id\n            isRequired\n            name\n            weight\n            terms {\n              name\n              isSkill\n            }\n            experience {\n              durationAmount\n              durationType\n            }\n            recency {\n              durationAmount\n              durationType\n            }\n          }\n        }\n        expiresAt\n        employerReference\n        headcount\n        locations {\n          name\n          countryCode\n          latitude\n          longitude\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node107.hash = "efd448213cbb4e92b4068bcf0b30d6be";
var VacancyUpdateDetailsMutation_graphql_default = node107;

// src/vacancies/mutations/VacancyUpdateDetailsMutation.ts
import { useAsyncMutation as useAsyncMutation11 } from "shared-lib";
var mutationDef18 = VacancyUpdateDetailsMutation_graphql_default;
function useVacancyUpdateDetails() {
  const [commit11, isBusy] = useAsyncMutation11(mutationDef18);
  return [commit11, isBusy];
}

// src/vacancies/mutations/__generated__/UseSendMatchesMutation.graphql.ts
var node108 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "UserError",
    "abstractKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseSendMatchesMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitVacancyRecommendationsSendMatchesAboveScorePayload",
          "kind": "LinkedField",
          "name": "recruitVacancyRecommendationsSendMatchesAboveScore",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v23
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseSendMatchesMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitVacancyRecommendationsSendMatchesAboveScorePayload",
          "kind": "LinkedField",
          "name": "recruitVacancyRecommendationsSendMatchesAboveScore",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v23
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "001200b414b6e879fad0a1a532fef5a7",
      "id": null,
      "metadata": {},
      "name": "UseSendMatchesMutation",
      "operationKind": "mutation",
      "text": "mutation UseSendMatchesMutation(\n  $input: RecruitVacancyRecommendationsSendMatchesAboveScoreInput!\n) {\n  result: recruitVacancyRecommendationsSendMatchesAboveScore(input: $input) {\n    userErrors {\n      __typename\n      ... on UserError {\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node108.hash = "d4fefb19a32a7caeb94d89dc51285f25";
var UseSendMatchesMutation_graphql_default = node108;

// src/vacancies/mutations/UseSendMatches.ts
var import_lodash2 = __toESM(require_lodash());
import { useAsyncMutation as useAsyncMutation12 } from "shared-lib";
var mutationDef19 = UseSendMatchesMutation_graphql_default;
function useSendMatches({
  vacancyRelayId,
  onCompleted = import_lodash2.noop
}) {
  const [commit11, isBusy] = useAsyncMutation12(
    mutationDef19,
    {
      updater: (store) => {
        if (vacancyRelayId) {
          const vacancy = store.get(vacancyRelayId);
          vacancy?.invalidateRecord();
        }
      },
      onCompleted
    }
  );
  return [commit11, isBusy];
}

// src/vacancies/mutations/__generated__/UseVacancyDocumentAddMutation.graphql.ts
var node109 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "vacancyId",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfVacancy",
    "kind": "LinkedField",
    "name": "vacancy",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Vacancy",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v23,
          v32,
          {
            "alias": null,
            "args": null,
            "concreteType": "VacancyDocumentTypeReference",
            "kind": "LinkedField",
            "name": "documentTypeReferences",
            "plural": true,
            "selections": [
              v23,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "documentTypeId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "documentTypeName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isRequired",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "requiresExpiryDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "requiresIssueDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "requiresIssueNumber",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v5 = {
    "kind": "InlineFragment",
    "selections": [
      v32,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseVacancyDocumentAddMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitVacancyAddDocumentPayload",
          "kind": "LinkedField",
          "name": "recruitVacancyAddDocument",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseVacancyDocumentAddMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitVacancyAddDocumentPayload",
          "kind": "LinkedField",
          "name": "recruitVacancyAddDocument",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "bbd86443e41a89906eadeb4cfcbe9b89",
      "id": null,
      "metadata": {},
      "name": "UseVacancyDocumentAddMutation",
      "operationKind": "mutation",
      "text": "mutation UseVacancyDocumentAddMutation(\n  $input: RecruitVacancyAddDocumentInput!\n) {\n  data: recruitVacancyAddDocument(input: $input) {\n    vacancy {\n      node {\n        id\n        vacancyId\n        code\n        documentTypeReferences {\n          vacancyId\n          documentTypeId\n          documentTypeName\n          isRequired\n          requiresExpiryDate\n          requiresIssueDate\n          requiresIssueNumber\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node109.hash = "7a83b87fee1bceef65948fec38bdf083";
var UseVacancyDocumentAddMutation_graphql_default = node109;

// src/vacancies/mutations/UseVacancyDocumentAdd.ts
import { useAsyncMutation as useAsyncMutation13 } from "shared-lib";
var mutationDef20 = UseVacancyDocumentAddMutation_graphql_default;
function useVacancyDocumentAdd() {
  const [commit11, isBusy] = useAsyncMutation13(mutationDef20);
  return [commit11, isBusy];
}

// src/vacancies/mutations/__generated__/UseVacancyDocumentRemoveMutation.graphql.ts
var node110 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "vacancyId",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfVacancy",
    "kind": "LinkedField",
    "name": "vacancy",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Vacancy",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v23,
          v32,
          {
            "alias": null,
            "args": null,
            "concreteType": "VacancyDocumentTypeReference",
            "kind": "LinkedField",
            "name": "documentTypeReferences",
            "plural": true,
            "selections": [
              v23,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "documentTypeId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "documentTypeName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isRequired",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "requiresExpiryDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "requiresIssueDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "requiresIssueNumber",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v5 = {
    "kind": "InlineFragment",
    "selections": [
      v32,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseVacancyDocumentRemoveMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitVacancyRemoveDocumentPayload",
          "kind": "LinkedField",
          "name": "recruitVacancyRemoveDocument",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseVacancyDocumentRemoveMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitVacancyRemoveDocumentPayload",
          "kind": "LinkedField",
          "name": "recruitVacancyRemoveDocument",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "f6f513164b2da3443348d06c934ae5a7",
      "id": null,
      "metadata": {},
      "name": "UseVacancyDocumentRemoveMutation",
      "operationKind": "mutation",
      "text": "mutation UseVacancyDocumentRemoveMutation(\n  $input: RecruitVacancyRemoveDocumentInput!\n) {\n  data: recruitVacancyRemoveDocument(input: $input) {\n    vacancy {\n      node {\n        id\n        vacancyId\n        code\n        documentTypeReferences {\n          vacancyId\n          documentTypeId\n          documentTypeName\n          isRequired\n          requiresExpiryDate\n          requiresIssueDate\n          requiresIssueNumber\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node110.hash = "ef023ea09e644ac9d350e872f91dfd13";
var UseVacancyDocumentRemoveMutation_graphql_default = node110;

// src/vacancies/mutations/UseVacancyDocumentRemove.ts
import { useAsyncMutation as useAsyncMutation14 } from "shared-lib";
var mutationDef21 = UseVacancyDocumentRemoveMutation_graphql_default;
function useVacancyDocumentRemove() {
  const [commit11, isBusy] = useAsyncMutation14(mutationDef21);
  return [commit11, isBusy];
}

// src/vacancies/mutations/__generated__/UseVacancyFormAddMutation.graphql.ts
var node111 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "vacancyId",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfVacancy",
    "kind": "LinkedField",
    "name": "vacancy",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Vacancy",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v23,
          v32,
          {
            "alias": null,
            "args": null,
            "concreteType": "VacancyFormGroupReference",
            "kind": "LinkedField",
            "name": "formGroupReferences",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "formGroupId",
                "storageKey": null
              },
              v23,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "formTemplateId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "templateTypeVersion",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "templateName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "templateKey",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isRequired",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v5 = {
    "kind": "InlineFragment",
    "selections": [
      v32,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseVacancyFormAddMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitVacancyAddFormPayload",
          "kind": "LinkedField",
          "name": "recruitVacancyAddForm",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseVacancyFormAddMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitVacancyAddFormPayload",
          "kind": "LinkedField",
          "name": "recruitVacancyAddForm",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "b9bdaf7f2fca8d4bbd105f5d36505f11",
      "id": null,
      "metadata": {},
      "name": "UseVacancyFormAddMutation",
      "operationKind": "mutation",
      "text": "mutation UseVacancyFormAddMutation(\n  $input: RecruitVacancyAddFormInput!\n) {\n  data: recruitVacancyAddForm(input: $input) {\n    vacancy {\n      node {\n        id\n        vacancyId\n        code\n        formGroupReferences {\n          formGroupId\n          vacancyId\n          formTemplateId\n          templateTypeVersion\n          templateName\n          templateKey\n          isRequired\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node111.hash = "734a57f3f7e31158c2f614a8748321fa";
var UseVacancyFormAddMutation_graphql_default = node111;

// src/vacancies/mutations/UseVacancyFormAdd.ts
import { useAsyncMutation as useAsyncMutation15 } from "shared-lib";
var mutationDef22 = UseVacancyFormAddMutation_graphql_default;
function useVacancyFormAdd() {
  const [commit11, isBusy] = useAsyncMutation15(mutationDef22);
  return [commit11, isBusy];
}

// src/vacancies/mutations/__generated__/UseVacancyFormChangeVersionMutation.graphql.ts
var node112 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "vacancyId",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfVacancy",
    "kind": "LinkedField",
    "name": "vacancy",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Vacancy",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v23,
          v32,
          {
            "alias": null,
            "args": null,
            "concreteType": "VacancyFormGroupReference",
            "kind": "LinkedField",
            "name": "formGroupReferences",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "formGroupId",
                "storageKey": null
              },
              v23,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "formTemplateId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "templateTypeVersion",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "templateName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "templateKey",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isRequired",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v5 = {
    "kind": "InlineFragment",
    "selections": [
      v32,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseVacancyFormChangeVersionMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitVacancyChangeFormTemplateVersionPayload",
          "kind": "LinkedField",
          "name": "recruitVacancyChangeFormTemplateVersion",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseVacancyFormChangeVersionMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitVacancyChangeFormTemplateVersionPayload",
          "kind": "LinkedField",
          "name": "recruitVacancyChangeFormTemplateVersion",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "d824f34523144e12d8a96b8606fe5497",
      "id": null,
      "metadata": {},
      "name": "UseVacancyFormChangeVersionMutation",
      "operationKind": "mutation",
      "text": "mutation UseVacancyFormChangeVersionMutation(\n  $input: RecruitVacancyChangeFormTemplateVersionInput!\n) {\n  data: recruitVacancyChangeFormTemplateVersion(input: $input) {\n    vacancy {\n      node {\n        id\n        vacancyId\n        code\n        formGroupReferences {\n          formGroupId\n          vacancyId\n          formTemplateId\n          templateTypeVersion\n          templateName\n          templateKey\n          isRequired\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node112.hash = "cd28e27039cf7ab705e0ee38b514c036";
var UseVacancyFormChangeVersionMutation_graphql_default = node112;

// src/vacancies/mutations/UseVacancyFormChangeVersion.ts
import { useAsyncMutation as useAsyncMutation16 } from "shared-lib";
var mutationDef23 = UseVacancyFormChangeVersionMutation_graphql_default;
function useVacancyChangeFormVersion() {
  const [commit11, isBusy] = useAsyncMutation16(mutationDef23);
  return [commit11, isBusy];
}

// src/vacancies/mutations/__generated__/UseVacancyFormRemoveMutation.graphql.ts
var node113 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "vacancyId",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfVacancy",
    "kind": "LinkedField",
    "name": "vacancy",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Vacancy",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v23,
          v32,
          {
            "alias": null,
            "args": null,
            "concreteType": "VacancyFormGroupReference",
            "kind": "LinkedField",
            "name": "formGroupReferences",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "formGroupId",
                "storageKey": null
              },
              v23,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "formTemplateId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "templateTypeVersion",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "templateName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "templateKey",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isRequired",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v5 = {
    "kind": "InlineFragment",
    "selections": [
      v32,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseVacancyFormRemoveMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitVacancyRemoveFormPayload",
          "kind": "LinkedField",
          "name": "recruitVacancyRemoveForm",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseVacancyFormRemoveMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitVacancyRemoveFormPayload",
          "kind": "LinkedField",
          "name": "recruitVacancyRemoveForm",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "c54bb73e30a702e6471bb093f9258d2f",
      "id": null,
      "metadata": {},
      "name": "UseVacancyFormRemoveMutation",
      "operationKind": "mutation",
      "text": "mutation UseVacancyFormRemoveMutation(\n  $input: RecruitVacancyRemoveFormInput!\n) {\n  data: recruitVacancyRemoveForm(input: $input) {\n    vacancy {\n      node {\n        id\n        vacancyId\n        code\n        formGroupReferences {\n          formGroupId\n          vacancyId\n          formTemplateId\n          templateTypeVersion\n          templateName\n          templateKey\n          isRequired\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node113.hash = "ff52dee056aee05baf601a3e0ec8ed52";
var UseVacancyFormRemoveMutation_graphql_default = node113;

// src/vacancies/mutations/UseVacancyFormRemove.ts
import { useAsyncMutation as useAsyncMutation17 } from "shared-lib";
var mutationDef24 = UseVacancyFormRemoveMutation_graphql_default;
function useVacancyFormRemove() {
  const [commit11, isBusy] = useAsyncMutation17(mutationDef24);
  return [commit11, isBusy];
}

// src/vacancies/mutations/__generated__/UseVacancyFulfillMutation.graphql.ts
var node114 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "vacancyId",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfVacancy",
    "kind": "LinkedField",
    "name": "vacancy",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Vacancy",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v23,
          v32,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VacancyDocumentTypeReference",
            "kind": "LinkedField",
            "name": "documentTypeReferences",
            "plural": true,
            "selections": [
              v23,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "documentTypeId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "documentTypeName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isRequired",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "requiresExpiryDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "requiresIssueDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "requiresIssueNumber",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v5 = {
    "kind": "InlineFragment",
    "selections": [
      v32,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseVacancyFulfillMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitVacancyFulfillPayload",
          "kind": "LinkedField",
          "name": "recruitVacancyFulfill",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseVacancyFulfillMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitVacancyFulfillPayload",
          "kind": "LinkedField",
          "name": "recruitVacancyFulfill",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "af3223fb3ad564d6160235c36fb0ceb7",
      "id": null,
      "metadata": {},
      "name": "UseVacancyFulfillMutation",
      "operationKind": "mutation",
      "text": "mutation UseVacancyFulfillMutation(\n  $input: RecruitVacancyFulfillInput!\n) {\n  data: recruitVacancyFulfill(input: $input) {\n    vacancy {\n      node {\n        id\n        vacancyId\n        code\n        status\n        documentTypeReferences {\n          vacancyId\n          documentTypeId\n          documentTypeName\n          isRequired\n          requiresExpiryDate\n          requiresIssueDate\n          requiresIssueNumber\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node114.hash = "5e407b5528c43500097699d9794aeaff";
var UseVacancyFulfillMutation_graphql_default = node114;

// src/vacancies/mutations/UseVacancyFulfill.ts
import { useAsyncMutation as useAsyncMutation18 } from "shared-lib";
var mutationDef25 = UseVacancyFulfillMutation_graphql_default;
function useVacancyFulfill() {
  const [commit11, isBusy] = useAsyncMutation18(mutationDef25);
  return [commit11, isBusy];
}

// src/vacancies/mutations/__generated__/UseVacancyProfileSourcesUpdateMutation.graphql.ts
var node115 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "vacancyId",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "seqId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdOn",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "concreteType": "AccountId",
    "kind": "LinkedField",
    "name": "createdBy",
    "plural": false,
    "selections": [
      v1,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accountType",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "sourceId",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "sourceType",
    "storageKey": null
  }, v8 = [
    {
      "alias": "data",
      "args": [
        {
          "kind": "Variable",
          "name": "input",
          "variableName": "input"
        }
      ],
      "concreteType": "RecruitVacancyUpdateProfileSourcesPayload",
      "kind": "LinkedField",
      "name": "recruitVacancyUpdateProfileSources",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EdgeOfVacancy",
          "kind": "LinkedField",
          "name": "vacancy",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Vacancy",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                v1,
                v23,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "code",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "VacancyProfileSource",
                  "kind": "LinkedField",
                  "name": "vacancyProfileSources",
                  "plural": true,
                  "selections": [
                    v1,
                    v32,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "vacancyProfileSourceId",
                      "storageKey": null
                    },
                    v4,
                    v5,
                    v23,
                    v6
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EmployerProfileSource",
                  "kind": "LinkedField",
                  "name": "employerProfileSources",
                  "plural": true,
                  "selections": [
                    v1,
                    v32,
                    v4,
                    v5,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerId",
                      "storageKey": null
                    },
                    v6,
                    v7,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ProfileSource",
                      "kind": "LinkedField",
                      "name": "source",
                      "plural": false,
                      "selections": [
                        v6,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "sourceName",
                          "storageKey": null
                        },
                        v7
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "kind": "ClientExtension",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__id",
                      "storageKey": null
                    }
                  ]
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseVacancyProfileSourcesUpdateMutation",
      "selections": v8,
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseVacancyProfileSourcesUpdateMutation",
      "selections": v8
    },
    "params": {
      "cacheID": "f63bf758bde64955374da1c564948f28",
      "id": null,
      "metadata": {},
      "name": "UseVacancyProfileSourcesUpdateMutation",
      "operationKind": "mutation",
      "text": "mutation UseVacancyProfileSourcesUpdateMutation(\n  $input: RecruitVacancyUpdateProfileSourcesInput!\n) {\n  data: recruitVacancyUpdateProfileSources(input: $input) {\n    vacancy {\n      node {\n        id\n        vacancyId\n        code\n        vacancyProfileSources {\n          id\n          seqId\n          vacancyProfileSourceId\n          createdOn\n          createdBy {\n            id\n            accountType\n          }\n          vacancyId\n          sourceId\n        }\n        employerProfileSources {\n          id\n          seqId\n          createdOn\n          createdBy {\n            id\n            accountType\n          }\n          employerId\n          sourceId\n          sourceType\n          source {\n            sourceId\n            sourceName\n            sourceType\n          }\n        }\n      }\n    }\n  }\n}\n"
    }
  };
}();
node115.hash = "0b8fdbddecec5c6c6c36374ee90d41cd";
var UseVacancyProfileSourcesUpdateMutation_graphql_default = node115;

// src/vacancies/mutations/UseVacancyProfileSourcesUpdate.ts
import { useAsyncMutation as useAsyncMutation19 } from "shared-lib";
var mutationDef26 = UseVacancyProfileSourcesUpdateMutation_graphql_default;
function useVacancyProfileSourcesUpdate() {
  const [commit11, isBusy] = useAsyncMutation19(mutationDef26);
  return [commit11, isBusy];
}

// src/vacancies/mutations/__generated__/UseVacancyProfileSourceAddMutation.graphql.ts
var node116 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "vacancyId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "seqId",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdOn",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "concreteType": "AccountId",
    "kind": "LinkedField",
    "name": "createdBy",
    "plural": false,
    "selections": [
      v23,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accountType",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "sourceId",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "sourceType",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfVacancy",
    "kind": "LinkedField",
    "name": "vacancy",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Vacancy",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          v23,
          v32,
          v4,
          {
            "alias": null,
            "args": null,
            "concreteType": "VacancyProfileSource",
            "kind": "LinkedField",
            "name": "vacancyProfileSources",
            "plural": true,
            "selections": [
              v23,
              v5,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vacancyProfileSourceId",
                "storageKey": null
              },
              v6,
              v7,
              v32,
              v8
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EmployerProfileSource",
            "kind": "LinkedField",
            "name": "employerProfileSources",
            "plural": true,
            "selections": [
              v23,
              v5,
              v6,
              v7,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "employerId",
                "storageKey": null
              },
              v8,
              v9,
              {
                "alias": null,
                "args": null,
                "concreteType": "ProfileSource",
                "kind": "LinkedField",
                "name": "source",
                "plural": false,
                "selections": [
                  v8,
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sourceName",
                    "storageKey": null
                  },
                  v9
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v11 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": "name",
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      },
      v4,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseVacancyProfileSourceAddMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitVacancyAddProfileSourcePayload",
          "kind": "LinkedField",
          "name": "recruitVacancyAddProfileSource",
          "plural": false,
          "selections": [
            v10,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v11
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseVacancyProfileSourceAddMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitVacancyAddProfileSourcePayload",
          "kind": "LinkedField",
          "name": "recruitVacancyAddProfileSource",
          "plural": false,
          "selections": [
            v10,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v11
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "36c28b49d49295f7cd87b6e7373ccd6c",
      "id": null,
      "metadata": {},
      "name": "UseVacancyProfileSourceAddMutation",
      "operationKind": "mutation",
      "text": "mutation UseVacancyProfileSourceAddMutation(\n  $input: RecruitVacancyAddProfileSourceInput!\n) {\n  data: recruitVacancyAddProfileSource(input: $input) {\n    vacancy {\n      node {\n        id\n        vacancyId\n        code\n        vacancyProfileSources {\n          id\n          seqId\n          vacancyProfileSourceId\n          createdOn\n          createdBy {\n            id\n            accountType\n          }\n          vacancyId\n          sourceId\n        }\n        employerProfileSources {\n          id\n          seqId\n          createdOn\n          createdBy {\n            id\n            accountType\n          }\n          employerId\n          sourceId\n          sourceType\n          source {\n            sourceId\n            sourceName\n            sourceType\n          }\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        name: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node116.hash = "8d580967b7cbae181ecb02d3b7dae344";
var UseVacancyProfileSourceAddMutation_graphql_default = node116;

// src/vacancies/mutations/UseVacancyProfileSourceAdd.ts
import { useAsyncMutation as useAsyncMutation20 } from "shared-lib";
var mutationDef27 = UseVacancyProfileSourceAddMutation_graphql_default;
function useVacancyProfileSourceAdd() {
  const [commit11, isBusy] = useAsyncMutation20(mutationDef27);
  return [commit11, isBusy];
}

// src/vacancies/mutations/__generated__/UseVacancyProfileSourceRemoveMutation.graphql.ts
var node117 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "vacancyId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "seqId",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdOn",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "concreteType": "AccountId",
    "kind": "LinkedField",
    "name": "createdBy",
    "plural": false,
    "selections": [
      v23,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accountType",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "sourceId",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "sourceType",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfVacancy",
    "kind": "LinkedField",
    "name": "vacancy",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Vacancy",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          v23,
          v32,
          v4,
          {
            "alias": null,
            "args": null,
            "concreteType": "VacancyProfileSource",
            "kind": "LinkedField",
            "name": "vacancyProfileSources",
            "plural": true,
            "selections": [
              v23,
              v5,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vacancyProfileSourceId",
                "storageKey": null
              },
              v6,
              v7,
              v32,
              v8
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EmployerProfileSource",
            "kind": "LinkedField",
            "name": "employerProfileSources",
            "plural": true,
            "selections": [
              v23,
              v5,
              v6,
              v7,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "employerId",
                "storageKey": null
              },
              v8,
              v9,
              {
                "alias": null,
                "args": null,
                "concreteType": "ProfileSource",
                "kind": "LinkedField",
                "name": "source",
                "plural": false,
                "selections": [
                  v8,
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sourceName",
                    "storageKey": null
                  },
                  v9
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v11 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": "name",
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      },
      v4,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseVacancyProfileSourceRemoveMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitVacancyRemoveProfileSourcePayload",
          "kind": "LinkedField",
          "name": "recruitVacancyRemoveProfileSource",
          "plural": false,
          "selections": [
            v10,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v11
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseVacancyProfileSourceRemoveMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitVacancyRemoveProfileSourcePayload",
          "kind": "LinkedField",
          "name": "recruitVacancyRemoveProfileSource",
          "plural": false,
          "selections": [
            v10,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v11
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "52918c0d3e5f2c4905f790d62bf07b37",
      "id": null,
      "metadata": {},
      "name": "UseVacancyProfileSourceRemoveMutation",
      "operationKind": "mutation",
      "text": "mutation UseVacancyProfileSourceRemoveMutation(\n  $input: RecruitVacancyRemoveProfileSourceInput!\n) {\n  data: recruitVacancyRemoveProfileSource(input: $input) {\n    vacancy {\n      node {\n        id\n        vacancyId\n        code\n        vacancyProfileSources {\n          id\n          seqId\n          vacancyProfileSourceId\n          createdOn\n          createdBy {\n            id\n            accountType\n          }\n          vacancyId\n          sourceId\n        }\n        employerProfileSources {\n          id\n          seqId\n          createdOn\n          createdBy {\n            id\n            accountType\n          }\n          employerId\n          sourceId\n          sourceType\n          source {\n            sourceId\n            sourceName\n            sourceType\n          }\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        name: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node117.hash = "7ac6bf48eea7062657ea6243a1250257";
var UseVacancyProfileSourceRemoveMutation_graphql_default = node117;

// src/vacancies/mutations/UseVacancyProfileSourceRemove.ts
import { useAsyncMutation as useAsyncMutation21 } from "shared-lib";
var mutationDef28 = UseVacancyProfileSourceRemoveMutation_graphql_default;
function useVacancyProfileSourceRemove() {
  const [commit11, isBusy] = useAsyncMutation21(mutationDef28);
  return [commit11, isBusy];
}

// src/vacancies/mutations/__generated__/VacancyApplyMutation.graphql.ts
var node118 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfApplicationSqlReadModel",
    "kind": "LinkedField",
    "name": "application",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Application",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "applicationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "version",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "applicationStateId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "applicationStateName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "workflowStateId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "workflowStateName",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "VacancyApplyMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "CreateApplicationPayload",
          "kind": "LinkedField",
          "name": "createApplication",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ApplicationPayload",
              "kind": "LinkedField",
              "name": "applicationPayload",
              "plural": false,
              "selections": [
                v23,
                v32,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "userErrors",
                  "plural": true,
                  "selections": [
                    v4,
                    v5
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "VacancyApplyMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "CreateApplicationPayload",
          "kind": "LinkedField",
          "name": "createApplication",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ApplicationPayload",
              "kind": "LinkedField",
              "name": "applicationPayload",
              "plural": false,
              "selections": [
                v23,
                v32,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "userErrors",
                  "plural": true,
                  "selections": [
                    v23,
                    v4,
                    v5
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "79ffc3f027e8642b6f3526b78064eea0",
      "id": null,
      "metadata": {},
      "name": "VacancyApplyMutation",
      "operationKind": "mutation",
      "text": "mutation VacancyApplyMutation(\n  $input: CreateApplicationInput!\n) {\n  createApplication(input: $input) {\n    applicationPayload {\n      __typename\n      application {\n        cursor\n        node {\n          id\n          applicationId\n          status\n          version\n          applicationStateId\n          applicationStateName\n          workflowStateId\n          workflowStateName\n        }\n      }\n      userErrors {\n        __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node118.hash = "e5ff2252e210b9f8a2206834508e2d11";
var VacancyApplyMutation_graphql_default = node118;

// src/vacancies/mutations/VacancyApplyMutation.ts
import { useAsyncMutation as useAsyncMutation22 } from "shared-lib";
var mutationDef29 = VacancyApplyMutation_graphql_default;
function useVacancyApply() {
  const [commit11, isBusy] = useAsyncMutation22(mutationDef29);
  return [commit11, isBusy];
}

// src/vacancies/mutations/__generated__/VacancyCreateMutation.graphql.ts
var node119 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfVacancy",
    "kind": "LinkedField",
    "name": "vacancy",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Vacancy",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v23,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v23,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "VacancyCreateMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "RecruitVacancyCreatePayload",
          "kind": "LinkedField",
          "name": "recruitVacancyCreate",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "VacancyCreateMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "RecruitVacancyCreatePayload",
          "kind": "LinkedField",
          "name": "recruitVacancyCreate",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "f44d2c6cf12da0cc0d0a438892d1a4da",
      "id": null,
      "metadata": {},
      "name": "VacancyCreateMutation",
      "operationKind": "mutation",
      "text": "mutation VacancyCreateMutation(\n  $input: RecruitVacancyCreateInput!\n) {\n  recruitVacancyCreate(input: $input) {\n    vacancy {\n      cursor\n      node {\n        id\n        code\n        name\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node119.hash = "04fa70158dc22c0d70172b242cc1d638";
var VacancyCreateMutation_graphql_default = node119;

// src/vacancies/mutations/VacancyCreateMutation.ts
import { useAsyncMutation as useAsyncMutation23 } from "shared-lib";
var mutationDef30 = VacancyCreateMutation_graphql_default;
function useVacancyCreate() {
  const [commit11, isBusy] = useAsyncMutation23(mutationDef30);
  return [commit11, isBusy];
}

// src/vacancies/mutations/__generated__/VacancyUpdateDescriptionMutation.graphql.ts
var node120 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfVacancy",
    "kind": "LinkedField",
    "name": "vacancy",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Vacancy",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v23,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "publicDescriptionHtml",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "publicDescriptionText",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "publicDescriptionEditorState",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VacancyDates",
            "kind": "LinkedField",
            "name": "dates",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startAsap",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "durationCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "durationDescription",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "durationAmount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "durationType",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v23,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "VacancyUpdateDescriptionMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitVacancyDescriptionUpdatePayload",
          "kind": "LinkedField",
          "name": "recruitVacancyDescriptionUpdate",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "VacancyUpdateDescriptionMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitVacancyDescriptionUpdatePayload",
          "kind": "LinkedField",
          "name": "recruitVacancyDescriptionUpdate",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "dc947c76a568c2d9357d2201f3cb3e3c",
      "id": null,
      "metadata": {},
      "name": "VacancyUpdateDescriptionMutation",
      "operationKind": "mutation",
      "text": "mutation VacancyUpdateDescriptionMutation(\n  $input: RecruitVacancyDescriptionUpdateInput!\n) {\n  result: recruitVacancyDescriptionUpdate(input: $input) {\n    vacancy {\n      cursor\n      node {\n        id\n        code\n        name\n        publicDescriptionHtml\n        publicDescriptionText\n        publicDescriptionEditorState\n        dates {\n          startDate\n          startAsap\n          durationCode\n          durationDescription\n          durationAmount\n          durationType\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node120.hash = "d94114e412f0ff4d4f4586beef8dab2c";
var VacancyUpdateDescriptionMutation_graphql_default = node120;

// src/vacancies/mutations/VacancyUpdateDescriptionMutation.ts
import { useAsyncMutation as useAsyncMutation24 } from "shared-lib";
var mutationDef31 = VacancyUpdateDescriptionMutation_graphql_default;
function useVacancyUpdateDescription() {
  const [commit11, isBusy] = useAsyncMutation24(mutationDef31);
  return [commit11, isBusy];
}

// src/vacancies/mutations/__generated__/VacancyUpdateMutation.graphql.ts
var node121 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfVacancy",
    "kind": "LinkedField",
    "name": "vacancy",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Vacancy",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v23,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v23,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "VacancyUpdateMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "RecruitVacancyUpdatePayload",
          "kind": "LinkedField",
          "name": "recruitVacancyUpdate",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "VacancyUpdateMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "RecruitVacancyUpdatePayload",
          "kind": "LinkedField",
          "name": "recruitVacancyUpdate",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "fc5631f4a7e92d233a1a311a089ec1c8",
      "id": null,
      "metadata": {},
      "name": "VacancyUpdateMutation",
      "operationKind": "mutation",
      "text": "mutation VacancyUpdateMutation(\n  $input: RecruitVacancyUpdateInput!\n) {\n  recruitVacancyUpdate(input: $input) {\n    vacancy {\n      cursor\n      node {\n        id\n        code\n        name\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node121.hash = "ab47f92edfb0729de25c8cf64c218e5b";
var VacancyUpdateMutation_graphql_default = node121;

// src/vacancies/mutations/VacancyUpdateMutation.ts
import { useAsyncMutation as useAsyncMutation25 } from "shared-lib";
var mutationDef32 = VacancyUpdateMutation_graphql_default;
function useVacancyUpdate() {
  const [commit11, isBusy] = useAsyncMutation25(mutationDef32);
  return [commit11, isBusy];
}

// src/vacancies/mutations/__generated__/VacancyUpdateScoringMutation.graphql.ts
var node122 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationType",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationAmount",
    "storageKey": null
  }, v7 = [
    v5,
    v6
  ], v8 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfVacancy",
    "kind": "LinkedField",
    "name": "vacancy",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Vacancy",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          v23,
          v32,
          v4,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "companyVsSkillWeight",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VacancyScoringConfig",
            "kind": "LinkedField",
            "name": "scoringConfig",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "industryNegativeThreshold",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "industryPositiveThreshold",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "relevanceNegativeThreshold",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "relevancePositiveThreshold",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Duration",
                "kind": "LinkedField",
                "name": "industryExperience",
                "plural": false,
                "selections": v7,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Duration",
                "kind": "LinkedField",
                "name": "industryRecency",
                "plural": false,
                "selections": v7,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Duration",
                "kind": "LinkedField",
                "name": "relevantExperience",
                "plural": false,
                "selections": v7,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Duration",
                "kind": "LinkedField",
                "name": "relevantRecency",
                "plural": false,
                "selections": v7,
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SkillGroup",
            "kind": "LinkedField",
            "name": "skillGroups",
            "plural": true,
            "selections": [
              v23,
              v4,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isRequired",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "weight",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SkillGroupTerm",
                "kind": "LinkedField",
                "name": "terms",
                "plural": true,
                "selections": [
                  v4,
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isSkill",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Duration",
                "kind": "LinkedField",
                "name": "recency",
                "plural": false,
                "selections": v7,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Duration",
                "kind": "LinkedField",
                "name": "experience",
                "plural": false,
                "selections": [
                  v6,
                  v5
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v9 = {
    "kind": "InlineFragment",
    "selections": [
      v32,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "VacancyUpdateScoringMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitVacancyScoringUpdatePayload",
          "kind": "LinkedField",
          "name": "recruitVacancyScoringUpdate",
          "plural": false,
          "selections": [
            v8,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v9
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "VacancyUpdateScoringMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitVacancyScoringUpdatePayload",
          "kind": "LinkedField",
          "name": "recruitVacancyScoringUpdate",
          "plural": false,
          "selections": [
            v8,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v9
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "326077b723ad7610eb09d0b0a7b5ae7f",
      "id": null,
      "metadata": {},
      "name": "VacancyUpdateScoringMutation",
      "operationKind": "mutation",
      "text": "mutation VacancyUpdateScoringMutation(\n  $input: RecruitVacancyScoringUpdateInput!\n) {\n  result: recruitVacancyScoringUpdate(input: $input) {\n    vacancy {\n      cursor\n      node {\n        id\n        code\n        name\n        companyVsSkillWeight\n        scoringConfig {\n          industryNegativeThreshold\n          industryPositiveThreshold\n          relevanceNegativeThreshold\n          relevancePositiveThreshold\n          industryExperience {\n            durationType\n            durationAmount\n          }\n          industryRecency {\n            durationType\n            durationAmount\n          }\n          relevantExperience {\n            durationType\n            durationAmount\n          }\n          relevantRecency {\n            durationType\n            durationAmount\n          }\n        }\n        skillGroups {\n          id\n          name\n          isRequired\n          weight\n          terms {\n            name\n            isSkill\n          }\n          recency {\n            durationType\n            durationAmount\n          }\n          experience {\n            durationAmount\n            durationType\n          }\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node122.hash = "d1083baf4a7b971d819bb458ee4b5232";
var VacancyUpdateScoringMutation_graphql_default = node122;

// src/vacancies/mutations/VacancyUpdateScoringMutation.ts
import { useAsyncMutation as useAsyncMutation26 } from "shared-lib";
var mutationDef33 = VacancyUpdateScoringMutation_graphql_default;
function useVacancyUpdateScoring() {
  const [commitMutation4, isBusy] = useAsyncMutation26(mutationDef33);
  const commit11 = async (input) => {
    const result = await commitMutation4({
      ...input,
      input: {
        ...input.input,
        skillGroups: input.input.skillGroups.map((sg) => ({
          experience: sg.experience || null,
          id: sg.id,
          isRequired: sg.isRequired || false,
          name: sg.name,
          recency: sg.recency || null,
          weight: sg.weight,
          terms: sg.terms.map((t4) => ({
            ...t4,
            isSkill: t4.isSkill || false
          }))
        }))
      }
    });
    return result;
  };
  return [commit11, isBusy];
}

// src/vacancies/mutations/__generated__/VacancySkillsGenerationMutation.graphql.ts
var node123 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "input",
          "variableName": "input"
        }
      ],
      "concreteType": "RecruitVacancySkillsTextPayload",
      "kind": "LinkedField",
      "name": "recruitVacancySkillsText",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "VacancySkillsPayload",
          "kind": "LinkedField",
          "name": "vacancy",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfVacancy",
              "kind": "LinkedField",
              "name": "vacancy",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Vacancy",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "VacancySkillAnalysis",
                      "kind": "LinkedField",
                      "name": "autogeneratedSkillGroups",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "status",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "userOptionalSkills",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "userRequiredSkills",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "skillsText",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "VacancySkillsGenerationMutation",
      "selections": v1,
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "VacancySkillsGenerationMutation",
      "selections": v1
    },
    "params": {
      "cacheID": "f9fa2ea446b5fca790fe3431980f2790",
      "id": null,
      "metadata": {},
      "name": "VacancySkillsGenerationMutation",
      "operationKind": "mutation",
      "text": "mutation VacancySkillsGenerationMutation(\n  $input: RecruitVacancySkillsTextInput!\n) {\n  recruitVacancySkillsText(input: $input) {\n    vacancy {\n      vacancy {\n        node {\n          id\n          autogeneratedSkillGroups {\n            status\n          }\n        }\n      }\n      userOptionalSkills\n      userRequiredSkills\n      skillsText\n    }\n  }\n}\n"
    }
  };
}();
node123.hash = "f439259e345fa2b62193aedac9b52be8";
var VacancySkillsGenerationMutation_graphql_default = node123;

// src/vacancies/mutations/VacancySkillsGenerationMutation.ts
import { useAsyncMutation as useAsyncMutation27 } from "shared-lib";
var mutationDef34 = VacancySkillsGenerationMutation_graphql_default;
function useVacancySkillsGeneration() {
  const [commit11, isBusy] = useAsyncMutation27(mutationDef34);
  return [commit11, isBusy];
}

// src/vacancies/components/VacancyClose.tsx
import { Fragment as Fragment20, jsx as jsx81, jsxs as jsxs51 } from "react/jsx-runtime";
var queryDef10 = VacancyCloseRouteQuery_graphql_default;
async function loader2(environment, params) {
  const code = params.vacancyCode;
  const vacancyCode = parseInt(code);
  return loadQuery2(environment, queryDef10, {
    vacancyCode
  });
}
function useRouteData2(id18) {
  const queryRef3 = useRouteLoaderData(
    id18
  );
  const data = usePreloadedQuery2(queryDef10, queryRef3);
  return data;
}
var VacancyClose = ({ routeId: routeId4 }) => {
  const data = useRouteData2(routeId4);
  const { vacancy } = data;
  const navigate = useNavigate8();
  const [fulfill, isFulfilling] = useVacancyFulfill();
  const onFulfill = useCallback45(
    async ({ vacancyId, message, reasonId }) => {
      const input = {
        clientMutationId: createClientMutationId20(),
        vacancyId,
        message,
        reasonId
      };
      const response = await fulfill({ input });
      if (response.data.vacancy) {
        navigate("../");
      }
    },
    [fulfill, navigate]
  );
  if (!vacancy) {
    return /* @__PURE__ */ jsx81(Fragment20, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx81(VacancyCloseOverview, { vacancy, onFulfill });
};
var VacancyCloseOverview = ({
  vacancy,
  onFulfill
}) => {
  let content = /* @__PURE__ */ jsx81("div", {});
  if (vacancy.status === "OPEN") {
    content = /* @__PURE__ */ jsx81(
      CloseVacancy,
      {
        onSubmit: ({ message, reasonId }) => onFulfill({
          message,
          reasonId,
          vacancyId: vacancy.vacancyId
        })
      }
    );
  } else if (vacancy.status === "FILLED") {
    content = /* @__PURE__ */ jsx81("div", { className: "m-auto lg:w-1/2", children: /* @__PURE__ */ jsxs51("div", { className: "flex flex-col p-2", children: [
      /* @__PURE__ */ jsx81("div", { className: "text-primary-500 mb-2 border-b p-2 text-2xl", children: "Vacancy Closed" }),
      /* @__PURE__ */ jsx81("div", { className: "flex flex-col gap-2 p-2", children: vacancy.dateFilled && /* @__PURE__ */ jsxs51("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ jsx81("div", { children: "Filled" }),
        /* @__PURE__ */ jsx81("div", { className: "text-primary-500", children: timeAgo3(vacancy.dateFilled) })
      ] }) })
    ] }) });
  } else if (vacancy.status === "ARCHIVED") {
    content = /* @__PURE__ */ jsx81("div", { className: "m-auto lg:w-1/2", children: /* @__PURE__ */ jsxs51("div", { className: "flex flex-col p-2", children: [
      /* @__PURE__ */ jsx81("div", { className: "text-primary-500 mb-2 border-b p-2 text-2xl", children: "Vacancy Archived" }),
      /* @__PURE__ */ jsx81("div", { className: "flex flex-col gap-2 p-2", children: vacancy.archivedAt && /* @__PURE__ */ jsxs51("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ jsx81("div", { children: "Archived" }),
        /* @__PURE__ */ jsx81("div", { className: "text-primary-500", children: timeAgo3(vacancy.archivedAt) })
      ] }) })
    ] }) });
  } else if (vacancy.status === "DRAFT") {
    content = /* @__PURE__ */ jsx81("div", { className: "m-auto lg:w-1/2", children: /* @__PURE__ */ jsxs51("div", { className: "flex flex-col p-2", children: [
      /* @__PURE__ */ jsx81("div", { className: "text-primary-500 mb-2 border-b p-2 text-2xl", children: "Vacancy Draft" }),
      /* @__PURE__ */ jsx81("div", { className: "flex flex-col gap-2 p-2", children: vacancy.createdAt && /* @__PURE__ */ jsxs51("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ jsx81("div", { children: "Created" }),
        /* @__PURE__ */ jsx81("div", { className: "text-primary-500", children: timeAgo3(vacancy.createdAt) })
      ] }) })
    ] }) });
  }
  return /* @__PURE__ */ jsx81(Suspense13, { fallback: /* @__PURE__ */ jsx81(EdSkeleton8, {}), children: /* @__PURE__ */ jsx81("div", { className: "border-b bg-white p-4", children: content }) });
};
var CloseVacancy = ({
  onSubmit
}) => {
  const [reason, setReason] = useState28(null);
  const [message, setMessage] = useState28(null);
  const navigate = useNavigate8();
  return /* @__PURE__ */ jsx81("div", { children: /* @__PURE__ */ jsxs51("div", { className: "flex flex-col gap-5", children: [
    /* @__PURE__ */ jsx81("div", { className: "flex gap-5", children: /* @__PURE__ */ jsx81(FulfillmentReasonsSelectList, { onSelect: setReason }) }),
    /* @__PURE__ */ jsxs51("div", { className: "flex flex-col", children: [
      /* @__PURE__ */ jsx81("div", { className: "text-primary-900 mb-2 text-lg", children: "Message for unsuccessful applicants*" }),
      /* @__PURE__ */ jsx81(
        TextArea2,
        {
          rows: 3,
          className: "focus:border-info-500 focus:ring-info-500 block w-full rounded-md border border-gray-300 shadow-sm sm:text-sm",
          placeholder: "Reason",
          onValueChange: setMessage
        }
      )
    ] }),
    /* @__PURE__ */ jsx81("div", { className: "mt-4 border-t p-2", children: /* @__PURE__ */ jsxs51(ButtonList8, { children: [
      /* @__PURE__ */ jsx81("div", { className: "mt-2", children: /* @__PURE__ */ jsx81(
        Button21,
        {
          color: "gray",
          size: Size6.lg,
          clicked: () => navigate("../"),
          children: "Cancel"
        }
      ) }),
      /* @__PURE__ */ jsx81("div", { className: "mt-2", children: /* @__PURE__ */ jsx81(
        Button21,
        {
          color: "danger",
          size: Size6.lg,
          disabled: !reason || !message,
          clicked: () => {
            if (!message || !reason) {
              return;
            }
            onSubmit({
              message,
              reasonId: reason.refDataItemId
            });
          },
          children: "Close"
        }
      ) })
    ] }) })
  ] }) });
};

// src/vacancies/components/VacancyCopy.tsx
import { useFieldArray, useForm as useForm11 } from "react-hook-form";
import { z as z5 } from "zod";
import { zodResolver as zodResolver11 } from "@hookform/resolvers/zod";
import { useUserSessionContext as useUserSessionContext3 } from "app-core";
import { Button as Button29, Card, FormInput as FormInput8, Spinner as Spinner7, Table } from "shared-ui";
import { createClientMutationId as createClientMutationId27 } from "shared-lib";

// src/projects/components/ProjectRoutes.tsx
import { useMemo as useMemo17 } from "react";
import { Outlet as Outlet4, Navigate as Navigate5, useLocation } from "react-router-dom";
import {
  Button as Button27,
  createLinkState,
  EdLink as EdLink8,
  EdSkeleton as EdSkeleton24,
  ErrorContainer as ErrorContainer7,
  SelectLinks,
  Size as Size11,
  Tabs
} from "shared-ui";

// src/projects/components/__generated__/ProjectLayoutQuery.graphql.ts
var node124 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectCode"
    }
  ], v1 = [
    {
      "alias": "project",
      "args": [
        {
          "kind": "Variable",
          "name": "projectCode",
          "variableName": "projectCode"
        }
      ],
      "concreteType": "RecruitProject",
      "kind": "LinkedField",
      "name": "recruitProjectByCode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "employerId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "canonicalCompanyId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "canonicalCompanyName",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ProjectLayoutQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ProjectLayoutQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "f7245a593e50f2eb50b8f122075789f6",
      "id": null,
      "metadata": {},
      "name": "ProjectLayoutQuery",
      "operationKind": "query",
      "text": "query ProjectLayoutQuery(\n  $projectCode: Int!\n) {\n  project: recruitProjectByCode(projectCode: $projectCode) {\n    id\n    code\n    projectId\n    employerId\n    name\n    description\n    canonicalCompanyId\n    canonicalCompanyName\n  }\n}\n"
    }
  };
}();
node124.hash = "73c9ccc12d4a3e00d97b15c9c113d962";
var ProjectLayoutQuery_graphql_default = node124;

// src/projects/components/ProjectLayout.tsx
import { Suspense as Suspense14 } from "react";
import { Link as Link4, useRouteLoaderData as useRouteLoaderData2 } from "react-router-dom";
import {
  loadQuery as loadQuery3,
  usePreloadedQuery as usePreloadedQuery3
} from "react-relay";
import { Fragment as Fragment21, jsx as jsx82 } from "react/jsx-runtime";
var projectLayoutQueryDef = ProjectLayoutQuery_graphql_default;
var ProjectLink = ({ routeId: routeId4 }) => {
  const data = useProjectRouteData(routeId4);
  if (!data.project) {
    return /* @__PURE__ */ jsx82(Fragment21, {});
  }
  return /* @__PURE__ */ jsx82(Suspense14, { fallback: "Loading...", children: /* @__PURE__ */ jsx82(Link4, { to: ".", children: data.project.code }) });
};
async function loader3(environment, params) {
  const code = params.projectCode;
  const projectCode = Number(code);
  return loadQuery3(environment, projectLayoutQueryDef, {
    projectCode
  });
}
function useProjectRouteData(id18) {
  const queryRef3 = useRouteLoaderData2(id18);
  const data = usePreloadedQuery3(
    projectLayoutQueryDef,
    queryRef3
  );
  return data;
}

// src/projects/components/__generated__/ProjectVacanciesQuery.graphql.ts
var node125 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectIds"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "talentPoolIds"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "talentPoolIds",
    "variableName": "talentPoolIds"
  }, v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  }, v32 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "count",
      "storageKey": null
    },
    v23
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ProjectVacanciesQuery",
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "projectIds",
              "variableName": "projectIds"
            },
            v1
          ],
          "kind": "FragmentSpread",
          "name": "ProjectVacanciesList_vacancies"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ProjectVacanciesQuery",
      "selections": [
        {
          "alias": "vacancies",
          "args": [
            {
              "fields": [
                {
                  "kind": "Literal",
                  "name": "pageNumber",
                  "value": 1
                },
                {
                  "kind": "Literal",
                  "name": "pageSize",
                  "value": 15
                },
                {
                  "kind": "Variable",
                  "name": "projectId",
                  "variableName": "projectIds"
                },
                {
                  "kind": "Literal",
                  "name": "sortField",
                  "value": "DATE_OPENED"
                },
                {
                  "kind": "Literal",
                  "name": "sortOrder",
                  "value": "DESC"
                },
                v1
              ],
              "kind": "ObjectValue",
              "name": "input"
            }
          ],
          "concreteType": "VacancySearchResult",
          "kind": "LinkedField",
          "name": "recruitVacanciesSearch",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CollectionMetaData",
              "kind": "LinkedField",
              "name": "paging",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "pages",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "pageNumber",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "itemsPerPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "totalResults",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "VacancySearchModel",
              "kind": "LinkedField",
              "name": "items",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "code",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "projectName",
                  "storageKey": null
                },
                v23,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "employerName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "employerReference",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "dateCreated",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "dateOpened",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "dateToBeFilled",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "expiresAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "matches",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "recommendations",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "createdByName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "VacancyCandidateCount",
                  "kind": "LinkedField",
                  "name": "candidateCounts",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CandidateCount",
                      "kind": "LinkedField",
                      "name": "active",
                      "plural": false,
                      "selections": v32,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CandidateCount",
                      "kind": "LinkedField",
                      "name": "created",
                      "plural": false,
                      "selections": v32,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CandidateCount",
                      "kind": "LinkedField",
                      "name": "hired",
                      "plural": false,
                      "selections": v32,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CandidateCount",
                      "kind": "LinkedField",
                      "name": "submitted",
                      "plural": false,
                      "selections": v32,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CandidateCount",
                      "kind": "LinkedField",
                      "name": "unsuccessful",
                      "plural": false,
                      "selections": v32,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CandidateCount",
                      "kind": "LinkedField",
                      "name": "withdrawn",
                      "plural": false,
                      "selections": v32,
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "28a793e78008a2399b8277d5550ca986",
      "id": null,
      "metadata": {},
      "name": "ProjectVacanciesQuery",
      "operationKind": "query",
      "text": "query ProjectVacanciesQuery(\n  $projectIds: [UUID!]\n  $talentPoolIds: [UUID!]\n) {\n  ...ProjectVacanciesList_vacancies_48whSk\n}\n\nfragment ProjectVacanciesList_vacancies_48whSk on Query {\n  vacancies: recruitVacanciesSearch(input: {pageNumber: 1, projectId: $projectIds, talentPoolIds: $talentPoolIds, pageSize: 15, sortField: DATE_OPENED, sortOrder: DESC}) {\n    paging {\n      pages\n      pageNumber\n      itemsPerPage\n      totalResults\n    }\n    items {\n      name\n      code\n      projectName\n      status\n      employerName\n      employerReference\n      dateCreated\n      dateOpened\n      dateToBeFilled\n      expiresAt\n      matches\n      recommendations\n      createdByName\n      candidateCounts {\n        active {\n          count\n          status\n        }\n        created {\n          count\n          status\n        }\n        hired {\n          count\n          status\n        }\n        submitted {\n          count\n          status\n        }\n        unsuccessful {\n          count\n          status\n        }\n        withdrawn {\n          count\n          status\n        }\n      }\n      id\n    }\n  }\n}\n"
    }
  };
}();
node125.hash = "02b37b3e83964960a8e6fb07f4109c46";
var ProjectVacanciesQuery_graphql_default = node125;

// src/projects/components/ProjectVacancies.tsx
import { Suspense as Suspense15 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery13 } from "react-relay";
import { BreadcrumbLink, Button as Button22, EdLink as EdLink6, EdSkeleton as EdSkeleton9 } from "shared-ui";

// src/projects/components/__generated__/ProjectVacanciesListVacanciesQuery.graphql.ts
var node126 = function() {
  var v0 = [
    {
      "defaultValue": 1,
      "kind": "LocalArgument",
      "name": "pageNumber"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectIds"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "talentPoolIds"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "pageNumber",
    "variableName": "pageNumber"
  }, v23 = {
    "kind": "Variable",
    "name": "talentPoolIds",
    "variableName": "talentPoolIds"
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  }, v4 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "count",
      "storageKey": null
    },
    v32
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ProjectVacanciesListVacanciesQuery",
      "selections": [
        {
          "args": [
            v1,
            {
              "kind": "Variable",
              "name": "projectIds",
              "variableName": "projectIds"
            },
            v23
          ],
          "kind": "FragmentSpread",
          "name": "ProjectVacanciesList_vacancies"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ProjectVacanciesListVacanciesQuery",
      "selections": [
        {
          "alias": "vacancies",
          "args": [
            {
              "fields": [
                v1,
                {
                  "kind": "Literal",
                  "name": "pageSize",
                  "value": 15
                },
                {
                  "kind": "Variable",
                  "name": "projectId",
                  "variableName": "projectIds"
                },
                {
                  "kind": "Literal",
                  "name": "sortField",
                  "value": "DATE_OPENED"
                },
                {
                  "kind": "Literal",
                  "name": "sortOrder",
                  "value": "DESC"
                },
                v23
              ],
              "kind": "ObjectValue",
              "name": "input"
            }
          ],
          "concreteType": "VacancySearchResult",
          "kind": "LinkedField",
          "name": "recruitVacanciesSearch",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CollectionMetaData",
              "kind": "LinkedField",
              "name": "paging",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "pages",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "pageNumber",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "itemsPerPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "totalResults",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "VacancySearchModel",
              "kind": "LinkedField",
              "name": "items",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "code",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "projectName",
                  "storageKey": null
                },
                v32,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "employerName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "employerReference",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "dateCreated",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "dateOpened",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "dateToBeFilled",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "expiresAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "matches",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "recommendations",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "createdByName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "VacancyCandidateCount",
                  "kind": "LinkedField",
                  "name": "candidateCounts",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CandidateCount",
                      "kind": "LinkedField",
                      "name": "active",
                      "plural": false,
                      "selections": v4,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CandidateCount",
                      "kind": "LinkedField",
                      "name": "created",
                      "plural": false,
                      "selections": v4,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CandidateCount",
                      "kind": "LinkedField",
                      "name": "hired",
                      "plural": false,
                      "selections": v4,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CandidateCount",
                      "kind": "LinkedField",
                      "name": "submitted",
                      "plural": false,
                      "selections": v4,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CandidateCount",
                      "kind": "LinkedField",
                      "name": "unsuccessful",
                      "plural": false,
                      "selections": v4,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CandidateCount",
                      "kind": "LinkedField",
                      "name": "withdrawn",
                      "plural": false,
                      "selections": v4,
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "b79dbcfbc05ccc42f6f12a5bb0d0e4e7",
      "id": null,
      "metadata": {},
      "name": "ProjectVacanciesListVacanciesQuery",
      "operationKind": "query",
      "text": "query ProjectVacanciesListVacanciesQuery(\n  $pageNumber: Int = 1\n  $projectIds: [UUID!] = null\n  $talentPoolIds: [UUID!] = null\n) {\n  ...ProjectVacanciesList_vacancies_3WWHxT\n}\n\nfragment ProjectVacanciesList_vacancies_3WWHxT on Query {\n  vacancies: recruitVacanciesSearch(input: {pageNumber: $pageNumber, projectId: $projectIds, talentPoolIds: $talentPoolIds, pageSize: 15, sortField: DATE_OPENED, sortOrder: DESC}) {\n    paging {\n      pages\n      pageNumber\n      itemsPerPage\n      totalResults\n    }\n    items {\n      name\n      code\n      projectName\n      status\n      employerName\n      employerReference\n      dateCreated\n      dateOpened\n      dateToBeFilled\n      expiresAt\n      matches\n      recommendations\n      createdByName\n      candidateCounts {\n        active {\n          count\n          status\n        }\n        created {\n          count\n          status\n        }\n        hired {\n          count\n          status\n        }\n        submitted {\n          count\n          status\n        }\n        unsuccessful {\n          count\n          status\n        }\n        withdrawn {\n          count\n          status\n        }\n      }\n      id\n    }\n  }\n}\n"
    }
  };
}();
node126.hash = "92b43ecdfbe1fdf3321317fadcf727b3";
var ProjectVacanciesListVacanciesQuery_graphql_default = node126;

// src/projects/components/__generated__/ProjectVacanciesList_vacancies.graphql.ts
var node127 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  }, v1 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "count",
      "storageKey": null
    },
    v0
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": 1,
        "kind": "LocalArgument",
        "name": "pageNumber"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectIds"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "talentPoolIds"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "refetch": {
        "connection": null,
        "fragmentPathInResult": [],
        "operation": ProjectVacanciesListVacanciesQuery_graphql_default
      }
    },
    "name": "ProjectVacanciesList_vacancies",
    "selections": [
      {
        "alias": "vacancies",
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "pageNumber",
                "variableName": "pageNumber"
              },
              {
                "kind": "Literal",
                "name": "pageSize",
                "value": 15
              },
              {
                "kind": "Variable",
                "name": "projectId",
                "variableName": "projectIds"
              },
              {
                "kind": "Literal",
                "name": "sortField",
                "value": "DATE_OPENED"
              },
              {
                "kind": "Literal",
                "name": "sortOrder",
                "value": "DESC"
              },
              {
                "kind": "Variable",
                "name": "talentPoolIds",
                "variableName": "talentPoolIds"
              }
            ],
            "kind": "ObjectValue",
            "name": "input"
          }
        ],
        "concreteType": "VacancySearchResult",
        "kind": "LinkedField",
        "name": "recruitVacanciesSearch",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CollectionMetaData",
            "kind": "LinkedField",
            "name": "paging",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pages",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pageNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "itemsPerPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalResults",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VacancySearchModel",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "code",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectName",
                "storageKey": null
              },
              v0,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "employerName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "employerReference",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dateCreated",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dateOpened",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dateToBeFilled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "expiresAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "matches",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "recommendations",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdByName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "VacancyCandidateCount",
                "kind": "LinkedField",
                "name": "candidateCounts",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CandidateCount",
                    "kind": "LinkedField",
                    "name": "active",
                    "plural": false,
                    "selections": v1,
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CandidateCount",
                    "kind": "LinkedField",
                    "name": "created",
                    "plural": false,
                    "selections": v1,
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CandidateCount",
                    "kind": "LinkedField",
                    "name": "hired",
                    "plural": false,
                    "selections": v1,
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CandidateCount",
                    "kind": "LinkedField",
                    "name": "submitted",
                    "plural": false,
                    "selections": v1,
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CandidateCount",
                    "kind": "LinkedField",
                    "name": "unsuccessful",
                    "plural": false,
                    "selections": v1,
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CandidateCount",
                    "kind": "LinkedField",
                    "name": "withdrawn",
                    "plural": false,
                    "selections": v1,
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node127.hash = "92b43ecdfbe1fdf3321317fadcf727b3";
var ProjectVacanciesList_vacancies_graphql_default = node127;

// src/projects/components/ProjectVacanciesList.tsx
import { useCallback as useCallback46, useState as useState29, useTransition as useTransition4 } from "react";
import { useRefetchableFragment as useRefetchableFragment4 } from "react-relay";
import { formatDate as formatDate3 } from "shared-lib";
import {
  EdColumnCell as EdColumnCell3,
  EdLink as EdLink5,
  EdRow as EdRow3,
  EdTable as EdTable3,
  SimplePagination,
  Spinner as Spinner3,
  Tag as Tag8
} from "shared-ui";
import { jsx as jsx83, jsxs as jsxs52 } from "react/jsx-runtime";
var fragmentDef27 = ProjectVacanciesList_vacancies_graphql_default;
var tagColors2 = {
  DRAFT: "bg-primary-200",
  OPEN: "bg-green-200",
  FILLED: "bg-orange-200",
  ARCHIVED: "bg-orange-200"
};
var VacancyTitle = ({ name, code }) => /* @__PURE__ */ jsx83(EdLink5, { name: "vacancy-link", href: `/employers/app/vacancies/view/${code}`, children: name });
var VacancyDetails = ({
  employerReference,
  createdByName
}) => /* @__PURE__ */ jsxs52("div", { className: "flex flex-col gap-1", children: [
  employerReference,
  /* @__PURE__ */ jsx83("div", { children: /* @__PURE__ */ jsx83(Tag8, { children: createdByName }) })
] });
var VacancyDates = ({
  dateCreated,
  dateOpened,
  dateToBeFilled
}) => /* @__PURE__ */ jsxs52("div", { className: "flex flex-col", children: [
  dateCreated && /* @__PURE__ */ jsxs52("div", { children: [
    "Created: ",
    formatDate3(dateCreated)
  ] }),
  dateOpened && /* @__PURE__ */ jsxs52("div", { children: [
    "Opened: ",
    formatDate3(dateOpened) || "N/A"
  ] }),
  dateToBeFilled && /* @__PURE__ */ jsxs52("div", { children: [
    "To be filled by: ",
    formatDate3(dateToBeFilled) || "N/A"
  ] })
] });
var VacancyCandidateCounts = ({
  candidateCounts,
  matches,
  recommendations
}) => /* @__PURE__ */ jsxs52("div", { children: [
  /* @__PURE__ */ jsx83(
    CandidateCount,
    {
      count: Object.values(candidateCounts).reduce(
        (a4, c4) => a4 + c4.count,
        0
      ),
      status: "Applicants"
    }
  ),
  /* @__PURE__ */ jsx83(CandidateCount, { count: matches, status: "Recommended" }),
  /* @__PURE__ */ jsx83(CandidateCount, { count: recommendations, status: "Matches" })
] });
var ProjectVacanciesList = ({ fragmentRef }) => {
  const [fetchedVacancies, refetch] = useRefetchableFragment4(fragmentDef27, fragmentRef);
  const [pageNumber, setPageNumber] = useState29(1);
  const rows = (vacancyList) => vacancyList.map((field) => {
    return /* @__PURE__ */ jsxs52(EdRow3, { rowKey: field.name, children: [
      /* @__PURE__ */ jsx83(EdColumnCell3, { children: /* @__PURE__ */ jsx83(VacancyTitle, { name: field.name, code: field.code }) }),
      /* @__PURE__ */ jsx83(EdColumnCell3, { children: /* @__PURE__ */ jsx83(Tag8, { color: tagColors2[field.status], children: field.status }) }),
      /* @__PURE__ */ jsx83(EdColumnCell3, { children: /* @__PURE__ */ jsx83(
        VacancyCandidateCounts,
        {
          candidateCounts: field.candidateCounts,
          matches: field.matches,
          recommendations: field.recommendations
        }
      ) }),
      /* @__PURE__ */ jsx83(EdColumnCell3, { children: /* @__PURE__ */ jsx83(
        VacancyDetails,
        {
          employerReference: field.employerReference,
          createdByName: field.createdByName
        }
      ) }),
      /* @__PURE__ */ jsx83(EdColumnCell3, { children: /* @__PURE__ */ jsx83(
        VacancyDates,
        {
          dateCreated: field.dateCreated,
          dateOpened: field.dateOpened,
          dateToBeFilled: field.dateToBeFilled
        }
      ) })
    ] }, field.name);
  });
  const [isPending, startTransition2] = useTransition4();
  const loadMore = useCallback46(() => {
    startTransition2(() => {
      refetch(
        {
          pageNumber: pageNumber + 1
        },
        {
          onComplete: () => {
            setPageNumber(pageNumber + 1);
          }
        }
      );
    });
  }, [pageNumber, refetch]);
  return /* @__PURE__ */ jsxs52("div", { className: "@container flex flex-col gap-5", children: [
    /* @__PURE__ */ jsx83("div", { className: "@6xl:hidden flex flex-col gap-5", children: fetchedVacancies.vacancies.items.map((x4) => /* @__PURE__ */ jsx83(
      EdTable3,
      {
        defaultColumns: [
          {
            id: "Vacancy",
            name: `${x4.name}`
          }
        ],
        rows: [
          /* @__PURE__ */ jsxs52(EdRow3, { rowKey: "Vacancy", children: [
            /* @__PURE__ */ jsx83(EdColumnCell3, { className: "w-1/2", wrap: true, children: "Vacancy" }),
            /* @__PURE__ */ jsx83(EdColumnCell3, { className: "", wrap: true, children: /* @__PURE__ */ jsx83(VacancyTitle, { name: x4.name, code: String(x4.code) }) })
          ] }, x4.code),
          /* @__PURE__ */ jsxs52(EdRow3, { rowKey: "Status", className: "justify-center", children: [
            /* @__PURE__ */ jsx83(EdColumnCell3, { children: "Status" }),
            /* @__PURE__ */ jsx83(EdColumnCell3, { children: /* @__PURE__ */ jsx83(Tag8, { color: tagColors2[x4.status], children: x4.status }) })
          ] }, x4.code),
          /* @__PURE__ */ jsxs52(EdRow3, { rowKey: "Candidates", children: [
            /* @__PURE__ */ jsx83(EdColumnCell3, { children: "Candidates" }),
            /* @__PURE__ */ jsxs52(EdColumnCell3, { children: [
              " ",
              /* @__PURE__ */ jsx83(
                VacancyCandidateCounts,
                {
                  candidateCounts: x4.candidateCounts,
                  matches: x4.matches,
                  recommendations: x4.recommendations
                }
              )
            ] })
          ] }, x4.code),
          /* @__PURE__ */ jsxs52(EdRow3, { rowKey: "Project", children: [
            /* @__PURE__ */ jsx83(EdColumnCell3, { children: "Project" }),
            /* @__PURE__ */ jsx83(EdColumnCell3, { children: /* @__PURE__ */ jsx83(
              VacancyDetails,
              {
                employerReference: x4.employerReference || "",
                createdByName: x4.createdByName
              }
            ) })
          ] }, x4.code),
          /* @__PURE__ */ jsxs52(EdRow3, { rowKey: "Dates", children: [
            /* @__PURE__ */ jsx83(EdColumnCell3, { children: "Dates" }),
            /* @__PURE__ */ jsx83(EdColumnCell3, { children: /* @__PURE__ */ jsx83(
              VacancyDates,
              {
                dateCreated: x4.dateCreated,
                dateOpened: x4.dateOpened,
                dateToBeFilled: x4.dateToBeFilled
              }
            ) })
          ] }, x4.code)
        ]
      },
      x4.code
    )) }),
    /* @__PURE__ */ jsx83("div", { className: "@6xl:flex hidden", children: /* @__PURE__ */ jsx83(
      EdTable3,
      {
        hasActionsColumn: false,
        defaultColumns: [
          "Vacancy",
          "Status",
          "Candidates",
          "Project",
          "Dates"
        ].map((name) => ({ id: name, name })),
        rows: rows(fetchedVacancies.vacancies.items)
      }
    ) }),
    /* @__PURE__ */ jsx83("div", { className: "flex items-center gap-2 self-end ", children: isPending && /* @__PURE__ */ jsx83(Spinner3, {}) }),
    /* @__PURE__ */ jsx83(
      SimplePagination,
      {
        name: "project-pagination",
        totalResults: fetchedVacancies.vacancies.paging.totalResults,
        itemsPerPage: fetchedVacancies.vacancies.paging.itemsPerPage,
        pageNumber: fetchedVacancies.vacancies.paging.pageNumber,
        pages: fetchedVacancies.vacancies.paging.pages,
        onPage: (pageNumber2) => {
          refetch({
            pageNumber: pageNumber2
          });
        }
      }
    )
  ] });
};
var CandidateCount = ({ count, status }) => {
  return /* @__PURE__ */ jsxs52("div", { className: "flex justify-between gap-5", children: [
    /* @__PURE__ */ jsx83("div", { children: status }),
    /* @__PURE__ */ jsx83("div", { children: count })
  ] });
};

// src/projects/components/ProjectVacancies.tsx
import { jsx as jsx84, jsxs as jsxs53 } from "react/jsx-runtime";
var queryDef11 = ProjectVacanciesQuery_graphql_default;
var ProjectVacancies = ({ projectRouteId, routeId: routeId4, inList }) => {
  const projectRouteData = useProjectRouteData(projectRouteId);
  const { project } = projectRouteData;
  const data = useLazyLoadQuery13(
    queryDef11,
    {
      projectIds: [project.projectId]
    },
    {
      fetchPolicy: "store-and-network"
    }
  );
  if (!project || !data) {
    return /* @__PURE__ */ jsx84(EdSkeleton9, {});
  }
  return /* @__PURE__ */ jsx84(Suspense15, { fallback: /* @__PURE__ */ jsx84(EdSkeleton9, {}), children: /* @__PURE__ */ jsxs53("div", { className: "flex flex-col gap-3 px-2 pt-3 md:px-5", children: [
    /* @__PURE__ */ jsx84(
      EdLink6,
      {
        name: "add-vacancy",
        className: "self-end",
        href: `/employers/app/vacancies/create?projectId=${project.projectId}&projectName=${project.name}`,
        children: /* @__PURE__ */ jsx84(Button22, { color: "green", children: "Add Vacancy" })
      }
    ),
    /* @__PURE__ */ jsx84("div", { className: "rounded border p-3", children: /* @__PURE__ */ jsx84("div", { className: "italic", children: project.description }) }),
    /* @__PURE__ */ jsx84(Suspense15, { fallback: /* @__PURE__ */ jsx84(EdSkeleton9, {}), children: /* @__PURE__ */ jsx84("div", { className: "", children: /* @__PURE__ */ jsx84(ProjectVacanciesList, { fragmentRef: data }) }) })
  ] }) }, project.id);
};
var createRoute2 = (routePrefix, projectRouteId, environment, context, inList) => {
  const id18 = routePrefix + "-project-vacancies";
  return {
    id: id18,
    path: "vacancies",
    element: /* @__PURE__ */ jsx84(
      ProjectVacancies,
      {
        projectRouteId,
        routeId: id18,
        inList
      }
    ),
    handle: {
      crumb: () => /* @__PURE__ */ jsx84(BreadcrumbLink, { to: "dashboard", label: "Dashboard" })
    }
  };
};

// src/projects/components/ProjectUpdateRoute.tsx
import { Suspense as Suspense16, useCallback as useCallback48 } from "react";
import { useNavigate as useNavigate9 } from "react-router-dom";
import { BreadcrumbLink as BreadcrumbLink2, EdSkeleton as EdSkeleton10 } from "shared-ui";

// src/projects/components/ProjectUpdateForm.tsx
import { useCallback as useCallback47 } from "react";
import * as zod2 from "zod";
import { useForm as useForm5 } from "react-hook-form";
import { zodResolver as zodResolver4 } from "@hookform/resolvers/zod";
import {
  createClientMutationId as createClientMutationId21,
  useSetUserErrorCodes as useSetUserErrorCodes5,
  useUserErrorCode as useUserErrorCode4
} from "shared-lib";
import {
  ActionContainer as ActionContainer5,
  ErrorField as ErrorField3,
  FormErrorCodes,
  FormInputRow as FormInputRow3,
  FormTextAreaInput as FormTextAreaInput2,
  InputField
} from "shared-ui";

// src/projects/mutations/__generated__/UseProjectCreateMutation.graphql.ts
var node128 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = [
    v23,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountType",
      "storageKey": null
    }
  ], v5 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfProject",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitProject",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          v23,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "projectId",
            "storageKey": null
          },
          v32,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountId",
            "kind": "LinkedField",
            "name": "createdBy",
            "plural": false,
            "selections": v4,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountId",
            "kind": "LinkedField",
            "name": "updatedBy",
            "plural": false,
            "selections": v4,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canonicalCompanyId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canonicalCompanyName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isArchived",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v6 = {
    "kind": "InlineFragment",
    "selections": [
      v32,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseProjectCreateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitProjectCreatePayload",
          "kind": "LinkedField",
          "name": "recruitProjectCreate",
          "plural": false,
          "selections": [
            v5,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v6
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseProjectCreateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitProjectCreatePayload",
          "kind": "LinkedField",
          "name": "recruitProjectCreate",
          "plural": false,
          "selections": [
            v5,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v6
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "92b0de3d23a7344c93202338a1d1815e",
      "id": null,
      "metadata": {},
      "name": "UseProjectCreateMutation",
      "operationKind": "mutation",
      "text": "mutation UseProjectCreateMutation(\n  $input: RecruitProjectCreateInput!\n) {\n  data: recruitProjectCreate(input: $input) {\n    payload {\n      node {\n        id\n        projectId\n        code\n        createdAt\n        createdBy {\n          id\n          accountType\n        }\n        updatedAt\n        updatedBy {\n          id\n          accountType\n        }\n        name\n        description\n        employerId\n        canonicalCompanyId\n        canonicalCompanyName\n        isArchived\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node128.hash = "7223988bff95b4f5b20fc8866a277568";
var UseProjectCreateMutation_graphql_default = node128;

// src/projects/mutations/UseProjectCreate.ts
import { useAsyncMutation as useAsyncMutation28 } from "shared-lib";
var mutationDef35 = UseProjectCreateMutation_graphql_default;
function useProjectCreate() {
  const [commit11, isBusy] = useAsyncMutation28(mutationDef35);
  return [commit11, isBusy];
}

// src/projects/mutations/__generated__/UseProjectMemberAddMutation.graphql.ts
var node129 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }, v23 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "memberId",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "concreteType": "AccountId",
    "kind": "LinkedField",
    "name": "createdBy",
    "plural": false,
    "selections": [
      v32,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accountType",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "projectId",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "employerUserId",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "accountId",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v14 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "emailAddress",
    "storageKey": null
  }, v15 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v16 = {
    "kind": "InlineFragment",
    "selections": [
      v5,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "UseProjectMemberAddMutation",
      "selections": [
        {
          "alias": "data",
          "args": v23,
          "concreteType": "RecruitProjectMemberAddPayload",
          "kind": "LinkedField",
          "name": "recruitProjectMemberAdd",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfProjectUserMapping",
              "kind": "LinkedField",
              "name": "payload",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProjectMember",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v32,
                    v4,
                    v5,
                    v6,
                    v7,
                    v8,
                    v9,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProject",
                      "kind": "LinkedField",
                      "name": "project",
                      "plural": false,
                      "selections": [
                        v10
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountsEmployerUser",
                      "kind": "LinkedField",
                      "name": "user",
                      "plural": false,
                      "selections": [
                        v11,
                        v12,
                        v13,
                        v14,
                        v15
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v16
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "UseProjectMemberAddMutation",
      "selections": [
        {
          "alias": "data",
          "args": v23,
          "concreteType": "RecruitProjectMemberAddPayload",
          "kind": "LinkedField",
          "name": "recruitProjectMemberAdd",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfProjectUserMapping",
              "kind": "LinkedField",
              "name": "payload",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProjectMember",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v32,
                    v4,
                    v5,
                    v6,
                    v7,
                    v8,
                    v9,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProject",
                      "kind": "LinkedField",
                      "name": "project",
                      "plural": false,
                      "selections": [
                        v10,
                        v32
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountsEmployerUser",
                      "kind": "LinkedField",
                      "name": "user",
                      "plural": false,
                      "selections": [
                        v11,
                        v12,
                        v13,
                        v14,
                        v15,
                        v32
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "filters": null,
              "handle": "appendEdge",
              "key": "",
              "kind": "LinkedHandle",
              "name": "payload",
              "handleArgs": [
                {
                  "kind": "Variable",
                  "name": "connections",
                  "variableName": "connections"
                }
              ]
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v16
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "0794dac66f7d0b669a0e5f383682fe4b",
      "id": null,
      "metadata": {},
      "name": "UseProjectMemberAddMutation",
      "operationKind": "mutation",
      "text": "mutation UseProjectMemberAddMutation(\n  $input: RecruitProjectMemberAddInput!\n) {\n  data: recruitProjectMemberAdd(input: $input) {\n    payload {\n      node {\n        id\n        memberId\n        code\n        createdAt\n        createdBy {\n          id\n          accountType\n        }\n        projectId\n        employerUserId\n        project {\n          name\n          id\n        }\n        user {\n          accountId\n          firstName\n          lastName\n          emailAddress\n          updatedAt\n          id\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node129.hash = "18679ca4e470f55d2b1dd2cfc43a411c";
var UseProjectMemberAddMutation_graphql_default = node129;

// src/projects/mutations/UseProjectMemberAdd.ts
import { useAsyncMutation as useAsyncMutation29 } from "shared-lib";
var mutationDef36 = UseProjectMemberAddMutation_graphql_default;
function useProjectMemberAdd() {
  const [commit11, isBusy] = useAsyncMutation29(mutationDef36);
  return [commit11, isBusy];
}

// src/projects/mutations/__generated__/UseProjectMemberRemoveMutation.graphql.ts
var node130 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }, v23 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "UseProjectMemberRemoveMutation",
      "selections": [
        {
          "alias": "data",
          "args": v23,
          "concreteType": "RecruitProjectMemberRemovePayload",
          "kind": "LinkedField",
          "name": "recruitProjectMemberRemove",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "DeleteResultOfProjectUserMapping",
              "kind": "LinkedField",
              "name": "payload",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EdgeOfProjectUserMapping",
                  "kind": "LinkedField",
                  "name": "edge",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProjectMember",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        v32
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "UseProjectMemberRemoveMutation",
      "selections": [
        {
          "alias": "data",
          "args": v23,
          "concreteType": "RecruitProjectMemberRemovePayload",
          "kind": "LinkedField",
          "name": "recruitProjectMemberRemove",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "DeleteResultOfProjectUserMapping",
              "kind": "LinkedField",
              "name": "payload",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EdgeOfProjectUserMapping",
                  "kind": "LinkedField",
                  "name": "edge",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProjectMember",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        v32,
                        {
                          "alias": null,
                          "args": null,
                          "filters": null,
                          "handle": "deleteEdge",
                          "key": "",
                          "kind": "ScalarHandle",
                          "name": "id",
                          "handleArgs": [
                            {
                              "kind": "Variable",
                              "name": "connections",
                              "variableName": "connections"
                            }
                          ]
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "d91d532e822b17be11588e55bce04486",
      "id": null,
      "metadata": {},
      "name": "UseProjectMemberRemoveMutation",
      "operationKind": "mutation",
      "text": "mutation UseProjectMemberRemoveMutation(\n  $input: RecruitProjectMemberRemoveInput!\n) {\n  data: recruitProjectMemberRemove(input: $input) {\n    payload {\n      edge {\n        node {\n          id\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node130.hash = "45c94b38673bdefcf6b93f8f31934f47";
var UseProjectMemberRemoveMutation_graphql_default = node130;

// src/projects/mutations/UseProjectMemberRemove.ts
import { useAsyncMutation as useAsyncMutation30 } from "shared-lib";
var mutationDef37 = UseProjectMemberRemoveMutation_graphql_default;
function useProjectMemberRemove() {
  const [commit11, isBusy] = useAsyncMutation30(mutationDef37);
  return [commit11, isBusy];
}

// src/projects/mutations/__generated__/UseProjectUpdateMutation.graphql.ts
var node131 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfProject",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitProject",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          v23,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "projectId",
            "storageKey": null
          },
          v32,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountId",
            "kind": "LinkedField",
            "name": "updatedBy",
            "plural": false,
            "selections": [
              v23,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accountType",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canonicalCompanyId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canonicalCompanyName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isArchived",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v5 = {
    "kind": "InlineFragment",
    "selections": [
      v32,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseProjectUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitProjectUpdatePayload",
          "kind": "LinkedField",
          "name": "recruitProjectUpdate",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseProjectUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitProjectUpdatePayload",
          "kind": "LinkedField",
          "name": "recruitProjectUpdate",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "3f5f80707c215f8d4251a99b00b76a4f",
      "id": null,
      "metadata": {},
      "name": "UseProjectUpdateMutation",
      "operationKind": "mutation",
      "text": "mutation UseProjectUpdateMutation(\n  $input: RecruitProjectUpdateInput!\n) {\n  data: recruitProjectUpdate(input: $input) {\n    payload {\n      node {\n        id\n        projectId\n        code\n        updatedAt\n        updatedBy {\n          id\n          accountType\n        }\n        name\n        description\n        employerId\n        canonicalCompanyId\n        canonicalCompanyName\n        isArchived\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node131.hash = "8bfc0f0aa3e0b4800edf677069c5ce3c";
var UseProjectUpdateMutation_graphql_default = node131;

// src/projects/mutations/UseProjectUpdate.ts
import { useAsyncMutation as useAsyncMutation31 } from "shared-lib";
var mutationDef38 = UseProjectUpdateMutation_graphql_default;
function useProjectUpdate() {
  const [commit11, isBusy] = useAsyncMutation31(mutationDef38);
  return [commit11, isBusy];
}

// src/projects/components/ProjectUpdateForm.tsx
import { jsx as jsx85, jsxs as jsxs54 } from "react/jsx-runtime";
var formSchema3 = zod2.object({
  projectName: zod2.string().min(1, { message: "Project Name is required" }),
  projectDescription: zod2.string().min(1, { message: "Project Description is required" })
});
var ProjectUpdateForm = ({
  projectId,
  projectName,
  projectDescription,
  onUpdate,
  onCancel
}) => {
  const defaultValues2 = {
    projectName,
    projectDescription
  };
  const setErrorCode = useSetUserErrorCodes5();
  const { register, handleSubmit, watch, formState, control } = useForm5({
    resolver: zodResolver4(formSchema3),
    defaultValues: defaultValues2,
    mode: "onChange"
  });
  const userErrorCode = useUserErrorCode4();
  const [updateProject, isCreatingProject] = useProjectUpdate();
  const onSave = useCallback47(
    async (form) => {
      setErrorCode(null);
      if (!form.projectName || !form.projectDescription) {
        return;
      }
      const input = {
        clientMutationId: createClientMutationId21(),
        projectId,
        projectName: form.projectName,
        projectDescription: form.projectDescription
      };
      const response = await updateProject({ input });
      if (response.data.userErrors && response.data.userErrors.length > 0) {
        setErrorCode(response.data.userErrors);
      }
      if (response.data.payload?.node) {
        onUpdate(response.data.payload.node);
      }
    },
    [updateProject]
  );
  const onSubmit = handleSubmit(
    async (form) => {
      await onSave(form);
    },
    (invalid) => {
      console.error(invalid);
    }
  );
  const { errors, isValid, isDirty } = formState;
  const errorDisplay = /* @__PURE__ */ jsx85(FormErrorCodes, {});
  return /* @__PURE__ */ jsxs54("form", { onSubmit, children: [
    errorDisplay,
    /* @__PURE__ */ jsxs54(
      ActionContainer5,
      {
        isDirty,
        showSubmit: true,
        showCancel: true,
        submitText: "Update Project",
        onCancel,
        isDisabled: isCreatingProject,
        titleTop: `Update Project`,
        children: [
          /* @__PURE__ */ jsxs54(FormInputRow3, { name: "projectName", title: "Name *", children: [
            /* @__PURE__ */ jsx85(
              InputField,
              {
                register,
                name: "projectName",
                required: true,
                placeholder: "Project Name"
              }
            ),
            /* @__PURE__ */ jsx85(ErrorField3, { field: errors.projectName })
          ] }),
          /* @__PURE__ */ jsxs54(FormInputRow3, { name: "projectDescription", title: "Description *", children: [
            /* @__PURE__ */ jsx85(
              FormTextAreaInput2,
              {
                rows: 6,
                register,
                name: "projectDescription",
                required: false,
                placeholder: "Project Description"
              }
            ),
            /* @__PURE__ */ jsx85(ErrorField3, { field: errors.projectDescription })
          ] })
        ]
      }
    )
  ] });
};

// src/projects/components/ProjectUpdateRoute.tsx
import { jsx as jsx86 } from "react/jsx-runtime";
var ProjectUpdate = ({
  projectRouteId,
  routeId: routeId4
}) => {
  const navigate = useNavigate9();
  const projectRouteData = useProjectRouteData(projectRouteId);
  const { project } = projectRouteData;
  const onUpdated = useCallback48(() => {
    navigate(`../dashboard`);
  }, [navigate]);
  const onCancel = useCallback48(() => {
    navigate(`../`);
  }, [navigate]);
  if (!project) {
    return /* @__PURE__ */ jsx86(EdSkeleton10, {});
  }
  return /* @__PURE__ */ jsx86(Suspense16, { fallback: /* @__PURE__ */ jsx86(EdSkeleton10, {}), children: /* @__PURE__ */ jsx86("div", { className: "m-2 lg:m-8", children: /* @__PURE__ */ jsx86(
    ProjectUpdateForm,
    {
      projectId: project.projectId,
      projectName: project.name,
      projectDescription: project.description,
      onUpdate: onUpdated,
      onCancel
    }
  ) }) });
};
var createRoute3 = (routePrefix, projectRouteId, environment, context) => {
  const id18 = routePrefix + "-project-update";
  return {
    id: id18,
    path: "update",
    element: /* @__PURE__ */ jsx86(ProjectUpdate, { projectRouteId, routeId: id18 }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx86(BreadcrumbLink2, { to: "update", label: "Update" })
    }
  };
};

// src/projects/components/ProjectMembers.tsx
import { Suspense as Suspense18 } from "react";
import { useRouteLoaderData as useRouteLoaderData4, Navigate as Navigate3 } from "react-router-dom";
import {
  BreadcrumbLink as BreadcrumbLink3,
  EdSkeleton as EdSkeleton12,
  EdTextLink,
  ErrorContainer
} from "shared-ui";
import { OutletRoute } from "app-core";

// src/projects/components/__generated__/ProjectMembersListQuery.graphql.ts
var node132 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cursor"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  }, v23 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "order"
  }, v32 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectCode"
  }, v4 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v5 = {
    "kind": "Variable",
    "name": "order",
    "variableName": "order"
  }, v6 = {
    "kind": "Variable",
    "name": "projectCode",
    "variableName": "projectCode"
  }, v7 = [
    {
      "kind": "Variable",
      "name": "after",
      "variableName": "cursor"
    },
    v4,
    v5,
    v6
  ], v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1,
        v23,
        v32
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "ProjectMembersListQuery",
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "cursor",
              "variableName": "cursor"
            },
            v4,
            v5,
            v6
          ],
          "kind": "FragmentSpread",
          "name": "ProjectMembersList_members"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v32,
        v1,
        v0,
        v23
      ],
      "kind": "Operation",
      "name": "ProjectMembersListQuery",
      "selections": [
        {
          "alias": "members",
          "args": v7,
          "concreteType": "RecruitProjectMembersByCodeConnection",
          "kind": "LinkedField",
          "name": "recruitProjectMembersByCode",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProjectMembersByCodeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProjectMember",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v8,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "memberId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountsEmployerUser",
                      "kind": "LinkedField",
                      "name": "user",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "accountId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "firstName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "lastName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "emailAddress",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "updatedAt",
                          "storageKey": null
                        },
                        v8,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "createdAt",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "members",
          "args": v7,
          "filters": [],
          "handle": "connection",
          "key": "ProjectMembersList_members",
          "kind": "LinkedHandle",
          "name": "recruitProjectMembersByCode"
        }
      ]
    },
    "params": {
      "cacheID": "fbb1dbaa184220689e6e1bc0f99c9391",
      "id": null,
      "metadata": {},
      "name": "ProjectMembersListQuery",
      "operationKind": "query",
      "text": "query ProjectMembersListQuery(\n  $projectCode: Int!\n  $first: Int\n  $cursor: String\n  $order: [RecruitProjectMemberSort!]\n) {\n  ...ProjectMembersList_members_bZSd4\n}\n\nfragment ProjectMemberView_member on RecruitProjectMember {\n  id\n  user {\n    accountId\n    createdAt\n    updatedAt\n    firstName\n    lastName\n    emailAddress\n    id\n  }\n}\n\nfragment ProjectMembersList_members_bZSd4 on Query {\n  members: recruitProjectMembersByCode(projectCode: $projectCode, first: $first, after: $cursor, order: $order) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      endCursor\n    }\n    edges {\n      node {\n        id\n        code\n        memberId\n        user {\n          accountId\n          firstName\n          lastName\n          emailAddress\n          updatedAt\n          id\n        }\n        ...ProjectMemberView_member\n        __typename\n      }\n      cursor\n    }\n  }\n}\n"
    }
  };
}();
node132.hash = "671adc700a0d7cce65fe5376f7b142a2";
var ProjectMembersListQuery_graphql_default = node132;

// src/projects/components/__generated__/ProjectMembersListPaginationQuery.graphql.ts
var node133 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": 15,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": {
        "id": "DESC"
      },
      "kind": "LocalArgument",
      "name": "order"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectCode"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v23 = {
    "kind": "Variable",
    "name": "order",
    "variableName": "order"
  }, v32 = {
    "kind": "Variable",
    "name": "projectCode",
    "variableName": "projectCode"
  }, v4 = [
    {
      "kind": "Variable",
      "name": "after",
      "variableName": "cursor"
    },
    v1,
    v23,
    v32
  ], v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ProjectMembersListPaginationQuery",
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "cursor",
              "variableName": "cursor"
            },
            v1,
            v23,
            v32
          ],
          "kind": "FragmentSpread",
          "name": "ProjectMembersList_members"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ProjectMembersListPaginationQuery",
      "selections": [
        {
          "alias": "members",
          "args": v4,
          "concreteType": "RecruitProjectMembersByCodeConnection",
          "kind": "LinkedField",
          "name": "recruitProjectMembersByCode",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProjectMembersByCodeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProjectMember",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v5,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "memberId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountsEmployerUser",
                      "kind": "LinkedField",
                      "name": "user",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "accountId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "firstName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "lastName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "emailAddress",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "updatedAt",
                          "storageKey": null
                        },
                        v5,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "createdAt",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "members",
          "args": v4,
          "filters": [],
          "handle": "connection",
          "key": "ProjectMembersList_members",
          "kind": "LinkedHandle",
          "name": "recruitProjectMembersByCode"
        }
      ]
    },
    "params": {
      "cacheID": "4bc83dbdd051edda5caab59ec418c4a5",
      "id": null,
      "metadata": {},
      "name": "ProjectMembersListPaginationQuery",
      "operationKind": "query",
      "text": "query ProjectMembersListPaginationQuery(\n  $cursor: String = null\n  $first: Int = 15\n  $order: [RecruitProjectMemberSort!] = {id: DESC}\n  $projectCode: Int!\n) {\n  ...ProjectMembersList_members_bZSd4\n}\n\nfragment ProjectMemberView_member on RecruitProjectMember {\n  id\n  user {\n    accountId\n    createdAt\n    updatedAt\n    firstName\n    lastName\n    emailAddress\n    id\n  }\n}\n\nfragment ProjectMembersList_members_bZSd4 on Query {\n  members: recruitProjectMembersByCode(projectCode: $projectCode, first: $first, after: $cursor, order: $order) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      endCursor\n    }\n    edges {\n      node {\n        id\n        code\n        memberId\n        user {\n          accountId\n          firstName\n          lastName\n          emailAddress\n          updatedAt\n          id\n        }\n        ...ProjectMemberView_member\n        __typename\n      }\n      cursor\n    }\n  }\n}\n"
    }
  };
}();
node133.hash = "4e48a9990d1bfbd216ff854521d7b969";
var ProjectMembersListPaginationQuery_graphql_default = node133;

// src/projects/components/__generated__/ProjectMembersList_members.graphql.ts
var node134 = function() {
  var v0 = [
    "members"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cursor"
      },
      {
        "defaultValue": 15,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "defaultValue": {
          "id": "DESC"
        },
        "kind": "LocalArgument",
        "name": "order"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectCode"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "cursor",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "cursor"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": ProjectMembersListPaginationQuery_graphql_default
      }
    },
    "name": "ProjectMembersList_members",
    "selections": [
      {
        "alias": "members",
        "args": null,
        "concreteType": "RecruitProjectMembersByCodeConnection",
        "kind": "LinkedField",
        "name": "__ProjectMembersList_members_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitProjectMembersByCodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitProjectMember",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "memberId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AccountsEmployerUser",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "accountId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "firstName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lastName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "emailAddress",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "updatedAt",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ProjectMemberView_member"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node134.hash = "4e48a9990d1bfbd216ff854521d7b969";
var ProjectMembersList_members_graphql_default = node134;

// src/projects/components/ProjectMembersList.tsx
import {
  isValidElement as isValidElement2,
  useCallback as useCallback49,
  useTransition as useTransition5
} from "react";
import {
  loadQuery as loadQuery4,
  usePaginationFragment as usePaginationFragment6,
  usePreloadedQuery as usePreloadedQuery4
} from "react-relay";
import { formatDistanceToNow, parseISO as parseISO4 } from "date-fns";
import { isNotNullOrUndefined as isNotNullOrUndefined2 } from "shared-lib";
import { EdButtonLink as EdButtonLink2, ListLayout } from "shared-ui";

// src/projects/components/__generated__/ProjectMemberView_member.graphql.ts
var node135 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectMemberView_member",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AccountsEmployerUser",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accountId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "emailAddress",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RecruitProjectMember",
  "abstractKey": null
};
node135.hash = "11d4aa67bca586c8f05cfbe2fb671387";
var ProjectMemberView_member_graphql_default = node135;

// src/projects/components/ProjectMemberView.tsx
import { useFragment as useFragment31 } from "react-relay";
import { jsx as jsx87, jsxs as jsxs55 } from "react/jsx-runtime";
var fragmentDef28 = ProjectMemberView_member_graphql_default;
var ProjectMemberView = ({ fragmentRef }) => {
  const data = useFragment31(
    fragmentDef28,
    fragmentRef
  );
  return /* @__PURE__ */ jsx87("div", { children: /* @__PURE__ */ jsxs55("div", { className: "grid", children: [
    /* @__PURE__ */ jsx87("div", { children: data.user.firstName }),
    /* @__PURE__ */ jsx87("div", { children: data.user.lastName })
  ] }) });
};

// src/projects/components/ProjectMembersList.tsx
import { jsx as jsx88, jsxs as jsxs56 } from "react/jsx-runtime";
var queryDef12 = ProjectMembersListQuery_graphql_default;
async function loader4(environment, params) {
  const code = params.projectCode;
  const projectCode = Number(code);
  return loadQuery4(environment, queryDef12, {
    projectCode
  });
}
var fragment3 = ProjectMembersList_members_graphql_default;
var SectionElement2 = ({ children }) => {
  return /* @__PURE__ */ jsx88("div", { className: "px-2 py-1 sm:px-8 sm:py-5", children });
};
var ItemHeader = ({ section }) => {
  const code = section.context.code;
  const titleIsElement = isValidElement2(section.itemTitle);
  return /* @__PURE__ */ jsxs56("div", { children: [
    /* @__PURE__ */ jsx88("div", { children: /* @__PURE__ */ jsx88("h1", { children: "Project" }) }),
    titleIsElement ? section.itemTitle : /* @__PURE__ */ jsx88("div", { className: "font-InterMedium text-info-gray-800 text-3xl font-bold tracking-tight", children: section.itemTitle }),
    /* @__PURE__ */ jsx88("div", { className: "flex items-center space-x-2 sm:justify-end", children: /* @__PURE__ */ jsx88(EdButtonLink2, { name: "View", to: `../../../view/${code}` }) })
  ] });
};
var ProjectMembersListLoader = ({ queryRef: queryRef3 }) => {
  const data = usePreloadedQuery4(queryDef12, queryRef3);
  return /* @__PURE__ */ jsx88(ProjectMembersListLayout, { fragmentRef: data });
};
var ProjectMembersListLayout = ({
  fragmentRef
}) => {
  const { data, loadNext, refetch, isLoadingNext } = usePaginationFragment6(fragment3, fragmentRef);
  const { members } = data;
  const [isPending, startTransition2] = useTransition5();
  const sections = (members?.edges || []).filter(isNotNullOrUndefined2).map((edge) => edge.node).map((member) => {
    const name = `${member.user.firstName} ${member.user.lastName}`;
    return {
      key: `${member.code}`,
      mobileLink: `../${member.code}`,
      itemTitle: name,
      listTitle: /* @__PURE__ */ jsx88("div", { className: "flex w-full grow justify-between gap-2", children: /* @__PURE__ */ jsx88("div", { className: "text-sm font-medium uppercase", children: name }) }),
      description: /* @__PURE__ */ jsxs56("div", { className: "text-xs", children: [
        "Updated",
        " ",
        formatDistanceToNow(parseISO4(member.user.updatedAt), {
          addSuffix: true
        })
      ] }),
      hideIcon: true,
      icon: () => null,
      iconForeground: "text-primary-700",
      iconBackground: "bg-primary-50",
      context: {
        code: member.id
      },
      element: /* @__PURE__ */ jsx88(SectionElement2, { children: /* @__PURE__ */ jsx88(ProjectMemberView, { fragmentRef: member }) })
    };
  });
  const loadMore = useCallback49(() => {
    if (isLoadingNext) {
      return;
    }
    startTransition2(() => {
      loadNext(15);
    });
  }, [isLoadingNext, loadNext]);
  return /* @__PURE__ */ jsx88(
    ListLayout,
    {
      sections,
      itemHeader: (s4) => /* @__PURE__ */ jsx88(ItemHeader, { section: s4 }),
      loadMore,
      isLoading: isLoadingNext
    }
  );
};

// src/projects/components/__generated__/ProjectMemberQuery.graphql.ts
var node136 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "memberCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "memberCode",
      "variableName": "memberCode"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "memberId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "projectId",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "concreteType": "AccountsEmployerUser",
    "kind": "LinkedField",
    "name": "user",
    "plural": false,
    "selections": [
      v23,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accountId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "firstName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "emailAddress",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "concreteType": "RecruitProjectNotification",
    "kind": "LinkedField",
    "name": "notification",
    "plural": false,
    "selections": [
      v23,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "notificationType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "projectNotificationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ProjectMemberQuery",
      "selections": [
        {
          "alias": "member",
          "args": v1,
          "concreteType": "RecruitProjectMember",
          "kind": "LinkedField",
          "name": "recruitProjectMemberByCode",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProject",
              "kind": "LinkedField",
              "name": "project",
              "plural": false,
              "selections": [
                v5
              ],
              "storageKey": null
            },
            v6,
            v7
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ProjectMemberQuery",
      "selections": [
        {
          "alias": "member",
          "args": v1,
          "concreteType": "RecruitProjectMember",
          "kind": "LinkedField",
          "name": "recruitProjectMemberByCode",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProject",
              "kind": "LinkedField",
              "name": "project",
              "plural": false,
              "selections": [
                v5,
                v23
              ],
              "storageKey": null
            },
            v6,
            v7
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "5982bf82945e5a0fa07e3fcc4281db3f",
      "id": null,
      "metadata": {},
      "name": "ProjectMemberQuery",
      "operationKind": "query",
      "text": "query ProjectMemberQuery(\n  $memberCode: Int!\n) {\n  member: recruitProjectMemberByCode(memberCode: $memberCode) {\n    id\n    memberId\n    projectId\n    project {\n      name\n      id\n    }\n    user {\n      id\n      accountId\n      firstName\n      lastName\n      emailAddress\n    }\n    notification {\n      id\n      code\n      notificationType\n      projectNotificationId\n    }\n  }\n}\n"
    }
  };
}();
node136.hash = "869849dd52e00a4cdce07a8a1dcfde51";
var ProjectMemberQuery_graphql_default = node136;

// src/projects/components/ProjectMember.tsx
import { Suspense as Suspense17, useCallback as useCallback50, useState as useState30 } from "react";
import {
  loadQuery as loadQuery5,
  usePreloadedQuery as usePreloadedQuery5,
  ConnectionHandler
} from "react-relay";
import { useRouteLoaderData as useRouteLoaderData3, useNavigate as useNavigate10 } from "react-router-dom";
import { createClientMutationId as createClientMutationId22 } from "shared-lib";
import { Button as Button23, EdSkeleton as EdSkeleton11, Spinner as Spinner4, SwitchInputComponent as SwitchInputComponent2 } from "shared-ui";

// src/projects/mutations/__generated__/UseAddMemberNotificationsMutation.graphql.ts
var node137 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfProjectNotification",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitProjectNotification",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v23,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notificationType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "projectNotificationId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v23,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseAddMemberNotificationsMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitProjectNotificationCreatePayload",
          "kind": "LinkedField",
          "name": "recruitProjectNotificationCreate",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseAddMemberNotificationsMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitProjectNotificationCreatePayload",
          "kind": "LinkedField",
          "name": "recruitProjectNotificationCreate",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "bc115c0a454237da7a81214ff707d0af",
      "id": null,
      "metadata": {},
      "name": "UseAddMemberNotificationsMutation",
      "operationKind": "mutation",
      "text": "mutation UseAddMemberNotificationsMutation(\n  $input: RecruitProjectNotificationCreateInput!\n) {\n  data: recruitProjectNotificationCreate(input: $input) {\n    payload {\n      node {\n        id\n        code\n        notificationType\n        projectNotificationId\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node137.hash = "92f6280f6722aba04b336b2948c92cae";
var UseAddMemberNotificationsMutation_graphql_default = node137;

// src/projects/mutations/UseAddMemberNotifications.ts
import { useMutation as useMutation10 } from "react-relay";
var mutationDef39 = UseAddMemberNotificationsMutation_graphql_default;
function useAddMemberNotifications() {
  const [commit11, isBusy] = useMutation10(mutationDef39);
  return [commit11, isBusy];
}

// src/projects/mutations/__generated__/UseRemoveMemberNotificationsMutation.graphql.ts
var node138 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "alias": "data",
      "args": [
        {
          "kind": "Variable",
          "name": "input",
          "variableName": "input"
        }
      ],
      "concreteType": "RecruitProjectNotificationRemovePayload",
      "kind": "LinkedField",
      "name": "recruitProjectNotificationRemove",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EdgeOfProjectNotification",
          "kind": "LinkedField",
          "name": "payload",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProjectNotification",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseRemoveMemberNotificationsMutation",
      "selections": v1,
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseRemoveMemberNotificationsMutation",
      "selections": v1
    },
    "params": {
      "cacheID": "a7a06e238b6dbc4cad632332c82a5a06",
      "id": null,
      "metadata": {},
      "name": "UseRemoveMemberNotificationsMutation",
      "operationKind": "mutation",
      "text": "mutation UseRemoveMemberNotificationsMutation(\n  $input: RecruitProjectNotificationRemoveInput!\n) {\n  data: recruitProjectNotificationRemove(input: $input) {\n    payload {\n      node {\n        id\n      }\n    }\n  }\n}\n"
    }
  };
}();
node138.hash = "4c801890911e9aea4743654ef744cf61";
var UseRemoveMemberNotificationsMutation_graphql_default = node138;

// src/projects/mutations/UseRemoveMemberNotifications.ts
import { useMutation as useMutation11 } from "react-relay";
var mutationDef40 = UseRemoveMemberNotificationsMutation_graphql_default;
function useRemoveMemberNotifications() {
  const [commit11, isBusy] = useMutation11(mutationDef40);
  return [commit11, isBusy];
}

// src/projects/components/ProjectMember.tsx
import { jsx as jsx89, jsxs as jsxs57 } from "react/jsx-runtime";
async function loader5(environment, params) {
  return loadQuery5(
    environment,
    ProjectMember.query,
    {
      memberCode: Number(params.memberCode)
    },
    {
      fetchPolicy: "network-only"
    }
  );
}
var ProjectMemberContainer = ({ routeId: routeId4, projectRouteId }) => {
  const queryRef3 = useRouteLoaderData3(
    routeId4
  );
  return /* @__PURE__ */ jsx89(Suspense17, { fallback: /* @__PURE__ */ jsx89(EdSkeleton11, {}), children: /* @__PURE__ */ jsx89("div", { className: "flex-1", children: /* @__PURE__ */ jsx89(ProjectMemberLoader, { queryRef: queryRef3 }) }) });
};
function ProjectMemberLoader({ queryRef: queryRef3 }) {
  const data = usePreloadedQuery5(
    ProjectMember.query,
    queryRef3
  );
  return /* @__PURE__ */ jsx89(ProjectMember, { data }, data.member?.memberId);
}
function ProjectMember({ data }) {
  const navigate = useNavigate10();
  const { member } = data;
  const connectionId = ConnectionHandler.getConnectionID(
    "root",
    "ProjectMembersList_members"
  );
  const [removeMember, isRemovingMember] = useProjectMemberRemove();
  const [projectNotificationId, setProjectNotificationId] = useState30(data.member?.notification?.projectNotificationId || null);
  const onRemoveMember = useCallback50(async () => {
    if (!member) {
      return;
    }
    const input = {
      id: member.memberId,
      clientMutationId: createClientMutationId22()
    };
    const response = await removeMember({
      input,
      connections: [connectionId]
    });
    if (response.data.payload) {
      navigate(`../../`);
    }
  }, [connectionId, member, navigate, removeMember]);
  const [commitSubscribeToNotifications, isLoadingSubscribeNotifications] = useAddMemberNotifications();
  const [commitUnsubscribeToNotifications, isLoadingUnSubscribeNotifications] = useRemoveMemberNotifications();
  const [emailNotificationsEnabled, setEmailNotificationsEnabled] = useState30(member?.notification !== null);
  const subscribeToNotifications = useCallback50(
    (type) => {
      if (!member) {
        return;
      }
      commitSubscribeToNotifications({
        variables: {
          input: {
            notificationType: type,
            userId: member?.user.accountId,
            projectId: member?.projectId
          }
        },
        onCompleted: (data2) => {
          setEmailNotificationsEnabled(true);
          setProjectNotificationId(
            data2.data.payload?.node.projectNotificationId || null
          );
        }
      });
    },
    [
      commitSubscribeToNotifications,
      member,
      setProjectNotificationId,
      setEmailNotificationsEnabled
    ]
  );
  const unsubscribeFromNotifications = useCallback50(() => {
    if (projectNotificationId == null) {
      return;
    }
    commitUnsubscribeToNotifications({
      variables: {
        input: {
          clientMutationId: createClientMutationId22(),
          projectNotificationId
        }
      },
      onCompleted: () => {
        setEmailNotificationsEnabled(false);
      }
    });
  }, [
    commitUnsubscribeToNotifications,
    projectNotificationId,
    setEmailNotificationsEnabled
  ]);
  const onToggleEmailNotifications = useCallback50(() => {
    if (!emailNotificationsEnabled) {
      subscribeToNotifications("EMAIL");
    } else {
      unsubscribeFromNotifications();
    }
  }, [
    emailNotificationsEnabled,
    subscribeToNotifications,
    unsubscribeFromNotifications
  ]);
  if (!member) {
    return /* @__PURE__ */ jsx89(EdSkeleton11, {});
  }
  return /* @__PURE__ */ jsxs57("div", { className: "flex flex-col gap-2 bg-white p-4", children: [
    /* @__PURE__ */ jsxs57("div", { className: "text-primary-500 flex items-center gap-1 border-b p-4 text-xl", children: [
      /* @__PURE__ */ jsx89("div", { children: member.user.firstName }),
      /* @__PURE__ */ jsx89("div", { children: member.user.lastName })
    ] }),
    /* @__PURE__ */ jsx89("div", { className: "text-primary-500 border-b p-4 text-sm", children: /* @__PURE__ */ jsx89("div", { children: member.user.emailAddress }) }),
    /* @__PURE__ */ jsxs57("div", { className: "flex gap-2 pl-4 pt-4", children: [
      /* @__PURE__ */ jsx89(
        SwitchInputComponent2,
        {
          label: "Enable Email Notifications",
          value: emailNotificationsEnabled,
          onChange: onToggleEmailNotifications
        },
        member.user.id
      ),
      (isLoadingSubscribeNotifications || isLoadingUnSubscribeNotifications) && /* @__PURE__ */ jsx89(Spinner4, {})
    ] }),
    /* @__PURE__ */ jsx89("div", { className: "p-4", children: /* @__PURE__ */ jsx89(
      Button23,
      {
        color: "danger",
        disabled: isRemovingMember,
        clicked: onRemoveMember,
        children: "Remove From Project"
      }
    ) })
  ] });
}
ProjectMember.query = ProjectMemberQuery_graphql_default;
var createRoute4 = (parentRouteId, environment) => {
  const routeId4 = parentRouteId + "-member";
  return {
    id: routeId4,
    path: ":memberCode",
    element: /* @__PURE__ */ jsx89(
      ProjectMemberContainer,
      {
        projectRouteId: parentRouteId,
        routeId: routeId4
      }
    ),
    loader: ({ params }) => {
      return loader5(environment, params);
    }
  };
};

// src/projects/components/ProjectMembers.tsx
import { jsx as jsx90, jsxs as jsxs58 } from "react/jsx-runtime";
var ProjectMembers = ({ routeId: routeId4 }) => {
  const queryRef3 = useRouteLoaderData4(
    routeId4
  );
  return /* @__PURE__ */ jsxs58(Suspense18, { fallback: /* @__PURE__ */ jsx90(EdSkeleton12, {}), children: [
    /* @__PURE__ */ jsx90("div", { className: "flex w-full justify-between border-b bg-white px-5 py-3", children: /* @__PURE__ */ jsx90(
      EdTextLink,
      {
        id: "project-add-member-link",
        to: "../../add-member",
        label: "Add Member"
      }
    ) }),
    /* @__PURE__ */ jsx90(ProjectMembersListLoader, { queryRef: queryRef3 })
  ] });
};
var createRoute5 = (routePrefix, projectRouteId, environment, context) => {
  const routeId4 = routePrefix + "-project-members";
  const listId = `${routeId4}-list`;
  return {
    path: "members",
    id: routeId4,
    element: /* @__PURE__ */ jsx90(OutletRoute, {}),
    errorElement: /* @__PURE__ */ jsx90(ErrorContainer, {}),
    loader: ({ params }) => {
      return loader3(environment, params);
    },
    children: [
      {
        id: listId,
        path: "list",
        element: /* @__PURE__ */ jsx90(ProjectMembers, { routeId: routeId4 }),
        handle: {
          crumb: () => /* @__PURE__ */ jsx90(BreadcrumbLink3, { to: "members", label: "Members" })
        },
        loader: ({ params }) => {
          return loader4(environment, params);
        },
        children: [createRoute4(`${routeId4}-list`, environment)]
      },
      createRoute4(routeId4, environment),
      {
        path: "*",
        element: /* @__PURE__ */ jsx90(Navigate3, { to: "list", replace: true })
      }
    ]
  };
};

// src/projects/components/ProjectAddMember.tsx
import { Suspense as Suspense25, useCallback as useCallback53, useState as useState33 } from "react";
import { useNavigate as useNavigate12 } from "react-router-dom";
import { ConnectionHandler as ConnectionHandler3 } from "react-relay";
import { Button as Button26, EdSkeleton as EdSkeleton23 } from "shared-ui";

// ../feature-employer-accounts/dist/index.mjs
import { useCallback as useCallback210 } from "react";
import * as zod3 from "zod";
import { useForm as useForm6 } from "react-hook-form";
import { zodResolver as zodResolver5 } from "@hookform/resolvers/zod";
import {
  createClientMutationId as createClientMutationId23,
  useSetUserErrorCodes as useSetUserErrorCodes6,
  useUserErrorCode as useUserErrorCode5
} from "shared-lib";
import {
  ActionContainer as ActionContainer6,
  ErrorField as ErrorField4,
  FormErrorCode,
  FormErrorCodes as FormErrorCodes2,
  FormInputRow as FormInputRow4,
  FormTextAreaInput as FormTextAreaInput3,
  InputField as InputField2,
  SwitchInput
} from "shared-ui";
import { IdentityUserSearchBoxInput } from "app-core";
import { useAsyncMutation as useAsyncMutation32 } from "shared-lib";
import { useAsyncMutation as useAsyncMutation210 } from "shared-lib";
import { useAsyncMutation as useAsyncMutation33 } from "shared-lib";
import { useAsyncMutation as useAsyncMutation42 } from "shared-lib";
import { useAsyncMutation as useAsyncMutation52 } from "shared-lib";
import { useAsyncMutation as useAsyncMutation62 } from "shared-lib";
import { useAsyncMutation as useAsyncMutation72 } from "shared-lib";
import { useAsyncMutation as useAsyncMutation82 } from "shared-lib";
import { useAsyncMutation as useAsyncMutation92 } from "shared-lib";
import { useAsyncMutation as useAsyncMutation102 } from "shared-lib";
import { useAsyncMutation as useAsyncMutation112 } from "shared-lib";
import { useAsyncMutation as useAsyncMutation122 } from "shared-lib";
import { useAsyncMutation as useAsyncMutation132 } from "shared-lib";
import { useAsyncMutation as useAsyncMutation142 } from "shared-lib";
import { useAsyncMutation as useAsyncMutation152 } from "shared-lib";
import { useAsyncMutation as useAsyncMutation162 } from "shared-lib";
import { useAsyncMutation as useAsyncMutation172 } from "shared-lib";
import { useAsyncMutation as useAsyncMutation182 } from "shared-lib";
import { useAsyncMutation as useAsyncMutation192 } from "shared-lib";
import { useAsyncMutation as useAsyncMutation202 } from "shared-lib";
import { useAsyncMutation as useAsyncMutation212 } from "shared-lib";
import { useAsyncMutation as useAsyncMutation222 } from "shared-lib";
import { useAsyncMutation as useAsyncMutation232 } from "shared-lib";
import { Controller as Controller5 } from "react-hook-form";
import { useLazyLoadQuery as useLazyLoadQuery14 } from "react-relay";
import {
  useCallback as useCallback51,
  useEffect as useEffect12,
  useMemo as useMemo16,
  useState as useState31
} from "react";
import { usePaginationFragment as usePaginationFragment7 } from "react-relay";
import { debounce as debounce3 } from "lodash-es";
import { CheckIcon as CheckIcon3, ChevronUpDownIcon as ChevronUpDownIcon3 } from "@heroicons/react/24/solid";
import { Combobox as Combobox5 } from "@headlessui/react";
import { classNames as classNames8 } from "shared-ui";
import { Fragment as Fragment22, jsx as jsx91, jsxs as jsxs59 } from "react/jsx-runtime";
import { jsx as jsx210 } from "react/jsx-runtime";
import { Fragment as Fragment23, jsx as jsx310, jsxs as jsxs210 } from "react/jsx-runtime";
import { Suspense as Suspense19 } from "react";
import {
  loadQuery as loadQuery6,
  usePreloadedQuery as usePreloadedQuery6
} from "react-relay";
import { useRouteLoaderData as useRouteLoaderData5 } from "react-router-dom";
import { resolveEmployerId } from "app-core";
import { useLogger as useLogger22, useToggle as useToggle13 } from "shared-lib";
import { EdSkeleton as EdSkeleton13, ErrorContainer as ErrorContainer2 } from "shared-ui";
import { useCallback as useCallback310, useState as useState210 } from "react";
import { zodResolver as zodResolver22 } from "@hookform/resolvers/zod";
import { useForm as useForm22 } from "react-hook-form";
import { useFragment as useFragment32, useLazyLoadQuery as useLazyLoadQuery22 } from "react-relay";
import * as zod22 from "zod";
import { createClientMutationId as createClientMutationId24, useUserErrorCode as useUserErrorCode22 } from "shared-lib";
import {
  ActionContainer as ActionContainer22,
  AlertMessage as AlertMessage10,
  ErrorField as ErrorField22,
  FormInput as FormInput3,
  FormInputRow as FormInputRow22,
  SelectMenu as SelectMenu3
} from "shared-ui";
import { useAsyncMutation as useAsyncMutation242 } from "shared-lib";
import { jsx as jsx410, jsxs as jsxs310 } from "react/jsx-runtime";
import { useFragment as useFragment210 } from "react-relay";
import { PencilIcon } from "@heroicons/react/24/outline";
import { jsx as jsx510, jsxs as jsxs410 } from "react/jsx-runtime";
import { useCallback as useCallback410, useState as useState32 } from "react";
import { XCircleIcon as XCircleIcon3 } from "@heroicons/react/20/solid";
import { createElement as h42, Component as Component7 } from "react";
import { createElement as h52, Component as Component22 } from "react";
import { createElement as h62, Component as Component32 } from "react";
import { createElement as h72, Component as Component42 } from "react";
import { createElement as h8, Component as Component52 } from "react";
import { createElement as h9, Component as Component62 } from "react";
import { useEffect as useEffect22, useRef as useRef4 } from "react";
import { useFragment as useFragment33, useRelayEnvironment as useRelayEnvironment2 } from "react-relay";
import {
  LogLevel as LogLevel3,
  commitAsyncMutation as commitAsyncMutation2,
  createClientMutationId as createClientMutationId32,
  useLogger as useLogger12,
  useUnhandledError as useUnhandledError6
} from "shared-lib";
import { Button as Button24, ButtonList as ButtonList9, Spinner as Spinner5 } from "shared-ui";
import { Fragment as Fragment32, jsx as jsx610, jsxs as jsxs510 } from "react/jsx-runtime";
import { Fragment as Fragment42, jsx as jsx710, jsxs as jsxs62 } from "react/jsx-runtime";
import { Suspense as Suspense22, useCallback as useCallback52 } from "react";
import * as zod32 from "zod";
import { useForm as useForm32 } from "react-hook-form";
import { zodResolver as zodResolver32 } from "@hookform/resolvers/zod";
import { createClientMutationId as createClientMutationId42, useUserErrorCode as useUserErrorCode32 } from "shared-lib";
import {
  ActionContainer as ActionContainer32,
  EdSkeleton as EdSkeleton22,
  ErrorField as ErrorField32,
  FormInputRow as FormInputRow32,
  InputField as InputField22
} from "shared-ui";
import { jsx as jsx810, jsxs as jsxs72 } from "react/jsx-runtime";
import { Suspense as Suspense52, useState as useState52 } from "react";
import {
  loadQuery as loadQuery22,
  usePreloadedQuery as usePreloadedQuery22
} from "react-relay";
import { useRouteLoaderData as useRouteLoaderData22 } from "react-router-dom";
import { resolveEmployerId as resolveEmployerId2 } from "app-core";
import { useToggle as useToggle22 } from "shared-lib";
import { Button as Button42, EdSkeleton as EdSkeleton52, ErrorContainer as ErrorContainer22 } from "shared-ui";
import { Suspense as Suspense42 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery32 } from "react-relay";
import { EdSkeleton as EdSkeleton42 } from "shared-ui";
import { useFragment as useFragment42 } from "react-relay";
import { Button as Button25, Size as Size7 } from "shared-ui";
import { jsx as jsx92, jsxs as jsxs82 } from "react/jsx-runtime";
import { Suspense as Suspense32, useCallback as useCallback62, useState as useState42 } from "react";
import { zodResolver as zodResolver42 } from "@hookform/resolvers/zod";
import { useForm as useForm42 } from "react-hook-form";
import { useFragment as useFragment52 } from "react-relay";
import * as zod4 from "zod";
import { createClientMutationId as createClientMutationId52 } from "shared-lib";
import {
  Button as Button32,
  ButtonList as ButtonList22,
  EdSkeleton as EdSkeleton32,
  Error as Error32,
  FormInput as FormInput22,
  Size as Size22
} from "shared-ui";
import { jsx as jsx102, jsxs as jsxs92 } from "react/jsx-runtime";
import { jsx as jsx112 } from "react/jsx-runtime";
import { jsx as jsx122, jsxs as jsxs102 } from "react/jsx-runtime";
import { useCallback as useCallback72, useState as useState62 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery42 } from "react-relay";
import { jsx as jsx132 } from "react/jsx-runtime";
import { useFragment as useFragment62 } from "react-relay";
import { jsx as jsx142, jsxs as jsxs112 } from "react/jsx-runtime";
import {
  Suspense as Suspense62,
  useCallback as useCallback82,
  useEffect as useEffect32,
  useMemo as useMemo22,
  useState as useState72,
  useTransition as useTransition6
} from "react";
import {
  usePaginationFragment as usePaginationFragment22,
  usePreloadedQuery as usePreloadedQuery32,
  useRefetchableFragment as useRefetchableFragment5
} from "react-relay";
import { formatDistanceToNow as formatDistanceToNow2, parseISO as parseISO5 } from "date-fns";
import {
  DebouncedInput,
  DefaultListLayoutItemHeader,
  DefaultListLayoutSectionElement,
  ListLayout as ListLayout2,
  SelectMenu as SelectMenu22,
  Spinner as Spinner22,
  classNames as classNames14
} from "shared-ui";
import { isNotNullOrUndefined as isNotNullOrUndefined3, useQueryPreloader } from "shared-lib";
import { jsx as jsx152, jsxs as jsxs122 } from "react/jsx-runtime";
import { Outlet as Outlet3 } from "react-router-dom";
import { ErrorContainer as ErrorContainer4 } from "shared-ui";
import { OutletRoute as OutletRoute2 } from "app-core";
import { Suspense as Suspense72 } from "react";
import {
  loadQuery as loadQuery32,
  usePreloadedQuery as usePreloadedQuery42
} from "react-relay";
import { useRouteLoaderData as useRouteLoaderData32 } from "react-router-dom";
import { EdSkeleton as EdSkeleton62 } from "shared-ui";
import { resolveEmployerCode } from "app-core";
import {
  isValidElement as isValidElement3,
  useCallback as useCallback92
} from "react";
import { usePaginationFragment as usePaginationFragment32 } from "react-relay";
import { formatDistanceToNow as formatDistanceToNow22, parseISO as parseISO22 } from "date-fns";
import { isNotNullOrUndefined as isNotNullOrUndefined22 } from "shared-lib";
import { EdButtonLink as EdButtonLink3, ListLayout as ListLayout22 } from "shared-ui";
import { useFragment as useFragment72 } from "react-relay";
import { jsx as jsx162 } from "react/jsx-runtime";
import { jsx as jsx172, jsxs as jsxs132 } from "react/jsx-runtime";
import { jsx as jsx182 } from "react/jsx-runtime";
import { Navigate as Navigate4 } from "react-router-dom";
import { ErrorContainer as ErrorContainer3 } from "shared-ui";
import { Suspense as Suspense102 } from "react";
import {
  loadQuery as loadQuery42,
  usePreloadedQuery as usePreloadedQuery52
} from "react-relay";
import { Link as Link5, useRouteLoaderData as useRouteLoaderData42 } from "react-router-dom";
import { EdSkeleton as EdSkeleton92 } from "shared-ui";
import { Suspense as Suspense92, useCallback as useCallback132, useMemo as useMemo32, useState as useState82 } from "react";
import { useToggle as useToggle32 } from "shared-lib";
import { Button as Button62, classNames as classNames15, EdSkeleton as EdSkeleton82, Size as Size42 } from "shared-ui";
import {
  createAuthorizableGroups,
  createAuthorizables,
  createPermissionKeyableSet
} from "app-core";
import { useCallback as useCallback112 } from "react";
import { useFragment as useFragment82 } from "react-relay";
import { createClientMutationId as createClientMutationId62 } from "shared-lib";
import { useCallback as useCallback102 } from "react";
import { useForm as useForm52 } from "react-hook-form";
import { zodResolver as zodResolver52 } from "@hookform/resolvers/zod";
import * as zod5 from "zod";
import {
  Button as Button52,
  ButtonList as ButtonList32,
  CheckboxInput,
  FormInput as FormInput32,
  FormTextAreaInput as FormTextAreaInput22,
  Size as Size32
} from "shared-ui";
import { jsx as jsx192, jsxs as jsxs142 } from "react/jsx-runtime";
import { jsx as jsx202 } from "react/jsx-runtime";
import { Suspense as Suspense82, useCallback as useCallback122 } from "react";
import { createClientMutationId as createClientMutationId72 } from "shared-lib";
import { EdSkeleton as EdSkeleton72 } from "shared-ui";
import { AuthorizableGroupEditor } from "app-core";
import { jsx as jsx212 } from "react/jsx-runtime";
import { jsx as jsx222, jsxs as jsxs152 } from "react/jsx-runtime";
import { jsx as jsx232, jsxs as jsxs162 } from "react/jsx-runtime";
import { jsx as jsx242 } from "react/jsx-runtime";
import { Suspense as Suspense112 } from "react";
import { Link as Link22 } from "react-router-dom";
import { Button as Button72, EdSkeleton as EdSkeleton102 } from "shared-ui";
import { jsx as jsx252 } from "react/jsx-runtime";
import { Suspense as Suspense122, useCallback as useCallback142, useState as useState92 } from "react";
import { Link as Link32, useNavigate as useNavigate11 } from "react-router-dom";
import { ConnectionHandler as ConnectionHandler2 } from "react-relay";
import { Button as Button82, ButtonList as ButtonList42, EdSkeleton as EdSkeleton112, Input as Input5 } from "shared-ui";
import { createClientMutationId as createClientMutationId82 } from "shared-lib";
import { jsx as jsx262, jsxs as jsxs172 } from "react/jsx-runtime";
import { jsx as jsx272 } from "react/jsx-runtime";
import { Controller as Controller22 } from "react-hook-form";
import { useLazyLoadQuery as useLazyLoadQuery52 } from "react-relay";
import {
  useCallback as useCallback152,
  useEffect as useEffect42,
  useMemo as useMemo42,
  useState as useState102
} from "react";
import { usePaginationFragment as usePaginationFragment42 } from "react-relay";
import { debounce as debounce4 } from "lodash-es";
import { CheckIcon as CheckIcon22, ChevronUpDownIcon as ChevronUpDownIcon22 } from "@heroicons/react/24/solid";
import { Combobox as Combobox22 } from "@headlessui/react";
import { classNames as classNames16 } from "shared-ui";
import { Fragment as Fragment52, jsx as jsx282, jsxs as jsxs182 } from "react/jsx-runtime";
import { jsx as jsx292 } from "react/jsx-runtime";
import { Outlet as Outlet22 } from "react-router-dom";
import { ErrorContainer as ErrorContainer6 } from "shared-ui";
import { OutletRoute as OutletRoute22 } from "app-core";
import { Suspense as Suspense142 } from "react";
import {
  loadQuery as loadQuery52,
  usePreloadedQuery as usePreloadedQuery62
} from "react-relay";
import { useRouteLoaderData as useRouteLoaderData52 } from "react-router-dom";
import { EdSkeleton as EdSkeleton132 } from "shared-ui";
import { resolveEmployerCode as resolveEmployerCode2 } from "app-core";
import { Suspense as Suspense132 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery72 } from "react-relay";
import { useLocalStorage } from "react-use";
import { Button as Button92, DebouncedInput as DebouncedInput2, EdLink as EdLink7, EdSkeleton as EdSkeleton122, Size as Size52 } from "shared-ui";
import { useCallback as useCallback162, useState as useState112 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery62 } from "react-relay";
import { jsx as jsx302 } from "react/jsx-runtime";
import {
  isValidElement as isValidElement22,
  useCallback as useCallback172
} from "react";
import { usePaginationFragment as usePaginationFragment52 } from "react-relay";
import { formatDistanceToNow as formatDistanceToNow3, parseISO as parseISO32 } from "date-fns";
import { isNotNullOrUndefined as isNotNullOrUndefined32 } from "shared-lib";
import {
  EdButtonLink as EdButtonLink22,
  ListLayout as ListLayout3
} from "shared-ui";
import { useFragment as useFragment92 } from "react-relay";
import { jsx as jsx312 } from "react/jsx-runtime";
import { jsx as jsx322, jsxs as jsxs192 } from "react/jsx-runtime";
import { jsx as jsx332, jsxs as jsxs202 } from "react/jsx-runtime";
import { jsx as jsx342 } from "react/jsx-runtime";
import { Navigate as Navigate22 } from "react-router-dom";
import { ErrorContainer as ErrorContainer5 } from "shared-ui";
import { Suspense as Suspense182 } from "react";
import {
  loadQuery as loadQuery62,
  usePreloadedQuery as usePreloadedQuery7
} from "react-relay";
import { Link as Link42, useRouteLoaderData as useRouteLoaderData6 } from "react-router-dom";
import { EdSkeleton as EdSkeleton17 } from "shared-ui";
import { Suspense as Suspense172 } from "react";
import { useToggle as useToggle52 } from "shared-lib";
import { EdSkeleton as EdSkeleton16 } from "shared-ui";
import { PencilIcon as PencilIcon2 } from "@heroicons/react/24/outline";
import { timeAgo as timeAgo4 } from "shared-lib";
import { jsx as jsx352, jsxs as jsxs212 } from "react/jsx-runtime";
import { Suspense as Suspense152, useCallback as useCallback182 } from "react";
import { useFragment as useFragment102 } from "react-relay";
import { useForm as useForm62 } from "react-hook-form";
import { zodResolver as zodResolver6 } from "@hookform/resolvers/zod";
import * as zod6 from "zod";
import { createClientMutationId as createClientMutationId92 } from "shared-lib";
import {
  Button as Button102,
  ButtonList as ButtonList52,
  CheckboxInput as CheckboxInput2,
  EdSkeleton as EdSkeleton14,
  FormInput as FormInput4,
  Size as Size62
} from "shared-ui";
import { jsx as jsx362, jsxs as jsxs222 } from "react/jsx-runtime";
import { Suspense as Suspense162, useCallback as useCallback192, useState as useState122 } from "react";
import { useFragment as useFragment112 } from "react-relay";
import { createClientMutationId as createClientMutationId102, useToggle as useToggle42 } from "shared-lib";
import { Button as Button112, ButtonList as ButtonList62, EdSkeleton as EdSkeleton15, Size as Size72 } from "shared-ui";
import { jsx as jsx372, jsxs as jsxs232 } from "react/jsx-runtime";
import { jsx as jsx382, jsxs as jsxs242 } from "react/jsx-runtime";
import { jsx as jsx392, jsxs as jsxs252 } from "react/jsx-runtime";
import { jsx as jsx402 } from "react/jsx-runtime";
import { Suspense as Suspense192, useCallback as useCallback202, useState as useState132 } from "react";
import { Link as Link52, useNavigate as useNavigate22 } from "react-router-dom";
import { useForm as useForm7 } from "react-hook-form";
import { zodResolver as zodResolver7 } from "@hookform/resolvers/zod";
import * as zod7 from "zod";
import { RadioGroup } from "@headlessui/react";
import { CheckCircleIcon as CheckCircleIcon2 } from "@heroicons/react/24/solid";
import { createClientMutationId as createClientMutationId112 } from "shared-lib";
import {
  Button as Button122,
  ButtonList as ButtonList72,
  CheckboxInput as CheckboxInput3,
  EdSkeleton as EdSkeleton18,
  Error as Error4,
  FormInput as FormInput5,
  Size as Size8,
  classNames as classNames17
} from "shared-ui";
import {
  IdentityUserSearchBoxContainer
} from "app-core";
import { Fragment as Fragment62, jsx as jsx412, jsxs as jsxs262 } from "react/jsx-runtime";
import { Fragment as Fragment72, jsx as jsx422 } from "react/jsx-runtime";
import { Suspense as Suspense20, useCallback as useCallback212 } from "react";
import { useFragment as useFragment122 } from "react-relay";
import { useForm as useForm8 } from "react-hook-form";
import { zodResolver as zodResolver8 } from "@hookform/resolvers/zod";
import * as zod8 from "zod";
import { createClientMutationId as createClientMutationId122 } from "shared-lib";
import {
  Button as Button132,
  ButtonList as ButtonList82,
  EdSkeleton as EdSkeleton19,
  FormInput as FormInput6,
  Size as Size9
} from "shared-ui";
import { jsx as jsx432, jsxs as jsxs272 } from "react/jsx-runtime";
import { Suspense as Suspense21 } from "react";
import { useFragment as useFragment132 } from "react-relay";
import { EdSkeleton as EdSkeleton20 } from "shared-ui";
import { jsx as jsx442 } from "react/jsx-runtime";
import { Suspense as Suspense222, useCallback as useCallback222 } from "react";
import { useFragment as useFragment142 } from "react-relay";
import { useForm as useForm9 } from "react-hook-form";
import { zodResolver as zodResolver9 } from "@hookform/resolvers/zod";
import * as zod9 from "zod";
import { createClientMutationId as createClientMutationId132 } from "shared-lib";
import {
  Button as Button142,
  ButtonList as ButtonList92,
  EdSkeleton as EdSkeleton21,
  FormErrorCodes as FormErrorCodes22,
  FormInput as FormInput7,
  Size as Size10
} from "shared-ui";
import { jsx as jsx452, jsxs as jsxs282 } from "react/jsx-runtime";
import { Suspense as Suspense23 } from "react";
import { PlusIcon as PlusIcon2 } from "@heroicons/react/24/outline";
import { EdButtonLink as EdButtonLink32, EdSkeleton as EdSkeleton222 } from "shared-ui";
import { jsx as jsx462 } from "react/jsx-runtime";
import { Controller as Controller32 } from "react-hook-form";
import {
  Suspense as Suspense24,
  useCallback as useCallback232,
  useEffect as useEffect52,
  useMemo as useMemo52,
  useState as useState142
} from "react";
import { debounce as debounce5 } from "lodash-es";
import { ChevronUpDownIcon as ChevronUpDownIcon32 } from "@heroicons/react/24/solid";
import { Combobox as Combobox42 } from "@headlessui/react";
import { useLazyLoadQuery as useLazyLoadQuery82 } from "react-relay";
import { Combobox as Combobox32 } from "@headlessui/react";
import { CheckIcon as CheckIcon32 } from "@heroicons/react/24/solid";
import { isNotNull as isNotNull5 } from "shared-lib";
import { classNames as classNames18 } from "shared-ui";
import { Fragment as Fragment82, jsx as jsx472, jsxs as jsxs292 } from "react/jsx-runtime";
import { jsx as jsx482, jsxs as jsxs302 } from "react/jsx-runtime";
import { jsx as jsx492 } from "react/jsx-runtime";
import { useCallback as useCallback242, useState as useState152 } from "react";
import { jsx as jsx502 } from "react/jsx-runtime";
import { useCallback as useCallback252, useState as useState162 } from "react";
import { Link as Link6 } from "react-router-dom";
import { loadQuery as loadQuery7 } from "react-relay";
import { useCopyToClipboard } from "react-use";
import { useRouteData as useRouteData3 } from "shared-lib";
import { Button as Button152 } from "shared-ui";
import { ElevateAccountTypes, useImpersonateUser } from "app-core";
import { jsx as jsx512, jsxs as jsxs312 } from "react/jsx-runtime";
var __create2 = Object.create;
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc2 = Object.getOwnPropertyDescriptor;
var __getOwnPropNames2 = Object.getOwnPropertyNames;
var __getProtoOf2 = Object.getPrototypeOf;
var __hasOwnProp2 = Object.prototype.hasOwnProperty;
var __commonJS2 = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames2(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps2 = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames2(from))
      if (!__hasOwnProp2.call(to, key) && key !== except)
        __defProp2(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc2(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM2 = (mod, isNodeMode, target) => (target = mod != null ? __create2(__getProtoOf2(mod)) : {}, __copyProps2(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp2(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var require_retry_operation2 = __commonJS2({
  "../../node_modules/p-retry/node_modules/retry/lib/retry_operation.js"(exports, module) {
    "use strict";
    function RetryOperation(timeouts, options7) {
      if (typeof options7 === "boolean") {
        options7 = { forever: options7 };
      }
      this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
      this._timeouts = timeouts;
      this._options = options7 || {};
      this._maxRetryTime = options7 && options7.maxRetryTime || Infinity;
      this._fn = null;
      this._errors = [];
      this._attempts = 1;
      this._operationTimeout = null;
      this._operationTimeoutCb = null;
      this._timeout = null;
      this._operationStart = null;
      this._timer = null;
      if (this._options.forever) {
        this._cachedTimeouts = this._timeouts.slice(0);
      }
    }
    module.exports = RetryOperation;
    RetryOperation.prototype.reset = function() {
      this._attempts = 1;
      this._timeouts = this._originalTimeouts.slice(0);
    };
    RetryOperation.prototype.stop = function() {
      if (this._timeout) {
        clearTimeout(this._timeout);
      }
      if (this._timer) {
        clearTimeout(this._timer);
      }
      this._timeouts = [];
      this._cachedTimeouts = null;
    };
    RetryOperation.prototype.retry = function(err) {
      if (this._timeout) {
        clearTimeout(this._timeout);
      }
      if (!err) {
        return false;
      }
      var currentTime = (/* @__PURE__ */ new Date()).getTime();
      if (err && currentTime - this._operationStart >= this._maxRetryTime) {
        this._errors.push(err);
        this._errors.unshift(new Error("RetryOperation timeout occurred"));
        return false;
      }
      this._errors.push(err);
      var timeout = this._timeouts.shift();
      if (timeout === void 0) {
        if (this._cachedTimeouts) {
          this._errors.splice(0, this._errors.length - 1);
          timeout = this._cachedTimeouts.slice(-1);
        } else {
          return false;
        }
      }
      var self2 = this;
      this._timer = setTimeout(function() {
        self2._attempts++;
        if (self2._operationTimeoutCb) {
          self2._timeout = setTimeout(function() {
            self2._operationTimeoutCb(self2._attempts);
          }, self2._operationTimeout);
          if (self2._options.unref) {
            self2._timeout.unref();
          }
        }
        self2._fn(self2._attempts);
      }, timeout);
      if (this._options.unref) {
        this._timer.unref();
      }
      return true;
    };
    RetryOperation.prototype.attempt = function(fn, timeoutOps) {
      this._fn = fn;
      if (timeoutOps) {
        if (timeoutOps.timeout) {
          this._operationTimeout = timeoutOps.timeout;
        }
        if (timeoutOps.cb) {
          this._operationTimeoutCb = timeoutOps.cb;
        }
      }
      var self2 = this;
      if (this._operationTimeoutCb) {
        this._timeout = setTimeout(function() {
          self2._operationTimeoutCb();
        }, self2._operationTimeout);
      }
      this._operationStart = (/* @__PURE__ */ new Date()).getTime();
      this._fn(this._attempts);
    };
    RetryOperation.prototype.try = function(fn) {
      console.log("Using RetryOperation.try() is deprecated");
      this.attempt(fn);
    };
    RetryOperation.prototype.start = function(fn) {
      console.log("Using RetryOperation.start() is deprecated");
      this.attempt(fn);
    };
    RetryOperation.prototype.start = RetryOperation.prototype.try;
    RetryOperation.prototype.errors = function() {
      return this._errors;
    };
    RetryOperation.prototype.attempts = function() {
      return this._attempts;
    };
    RetryOperation.prototype.mainError = function() {
      if (this._errors.length === 0) {
        return null;
      }
      var counts = {};
      var mainError = null;
      var mainErrorCount = 0;
      for (var i4 = 0; i4 < this._errors.length; i4++) {
        var error = this._errors[i4];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
          mainError = error;
          mainErrorCount = count;
        }
      }
      return mainError;
    };
  }
});
var require_retry3 = __commonJS2({
  "../../node_modules/p-retry/node_modules/retry/lib/retry.js"(exports) {
    "use strict";
    var RetryOperation = require_retry_operation2();
    exports.operation = function(options7) {
      var timeouts = exports.timeouts(options7);
      return new RetryOperation(timeouts, {
        forever: options7 && (options7.forever || options7.retries === Infinity),
        unref: options7 && options7.unref,
        maxRetryTime: options7 && options7.maxRetryTime
      });
    };
    exports.timeouts = function(options7) {
      if (options7 instanceof Array) {
        return [].concat(options7);
      }
      var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1 * 1e3,
        maxTimeout: Infinity,
        randomize: false
      };
      for (var key in options7) {
        opts[key] = options7[key];
      }
      if (opts.minTimeout > opts.maxTimeout) {
        throw new Error("minTimeout is greater than maxTimeout");
      }
      var timeouts = [];
      for (var i4 = 0; i4 < opts.retries; i4++) {
        timeouts.push(this.createTimeout(i4, opts));
      }
      if (options7 && options7.forever && !timeouts.length) {
        timeouts.push(this.createTimeout(i4, opts));
      }
      timeouts.sort(function(a4, b3) {
        return a4 - b3;
      });
      return timeouts;
    };
    exports.createTimeout = function(attempt, opts) {
      var random = opts.randomize ? Math.random() + 1 : 1;
      var timeout = Math.round(random * Math.max(opts.minTimeout, 1) * Math.pow(opts.factor, attempt));
      timeout = Math.min(timeout, opts.maxTimeout);
      return timeout;
    };
    exports.wrap = function(obj, options7, methods) {
      if (options7 instanceof Array) {
        methods = options7;
        options7 = null;
      }
      if (!methods) {
        methods = [];
        for (var key in obj) {
          if (typeof obj[key] === "function") {
            methods.push(key);
          }
        }
      }
      for (var i4 = 0; i4 < methods.length; i4++) {
        var method = methods[i4];
        var original = obj[method];
        obj[method] = function retryWrapper(original2) {
          var op = exports.operation(options7);
          var args = Array.prototype.slice.call(arguments, 1);
          var callback = args.pop();
          args.push(function(err) {
            if (op.retry(err)) {
              return;
            }
            if (err) {
              arguments[0] = op.mainError();
            }
            callback.apply(this, arguments);
          });
          op.attempt(function() {
            original2.apply(obj, args);
          });
        }.bind(obj, original);
        obj[method].options = options7;
      }
    };
  }
});
var require_retry22 = __commonJS2({
  "../../node_modules/p-retry/node_modules/retry/index.js"(exports, module) {
    "use strict";
    module.exports = require_retry3();
  }
});
var require_isObject2 = __commonJS2({
  "../../node_modules/lodash/isObject.js"(exports, module) {
    "use strict";
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == "object" || type == "function");
    }
    module.exports = isObject;
  }
});
var require_freeGlobal2 = __commonJS2({
  "../../node_modules/lodash/_freeGlobal.js"(exports, module) {
    "use strict";
    var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
    module.exports = freeGlobal;
  }
});
var require_root2 = __commonJS2({
  "../../node_modules/lodash/_root.js"(exports, module) {
    "use strict";
    var freeGlobal = require_freeGlobal2();
    var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    var root = freeGlobal || freeSelf || Function("return this")();
    module.exports = root;
  }
});
var require_now2 = __commonJS2({
  "../../node_modules/lodash/now.js"(exports, module) {
    "use strict";
    var root = require_root2();
    var now2 = function() {
      return root.Date.now();
    };
    module.exports = now2;
  }
});
var require_trimmedEndIndex2 = __commonJS2({
  "../../node_modules/lodash/_trimmedEndIndex.js"(exports, module) {
    "use strict";
    var reWhitespace = /\s/;
    function trimmedEndIndex(string102) {
      var index2 = string102.length;
      while (index2-- && reWhitespace.test(string102.charAt(index2))) {
      }
      return index2;
    }
    module.exports = trimmedEndIndex;
  }
});
var require_baseTrim2 = __commonJS2({
  "../../node_modules/lodash/_baseTrim.js"(exports, module) {
    "use strict";
    var trimmedEndIndex = require_trimmedEndIndex2();
    var reTrimStart = /^\s+/;
    function baseTrim(string102) {
      return string102 ? string102.slice(0, trimmedEndIndex(string102) + 1).replace(reTrimStart, "") : string102;
    }
    module.exports = baseTrim;
  }
});
var require_Symbol2 = __commonJS2({
  "../../node_modules/lodash/_Symbol.js"(exports, module) {
    "use strict";
    var root = require_root2();
    var Symbol2 = root.Symbol;
    module.exports = Symbol2;
  }
});
var require_getRawTag2 = __commonJS2({
  "../../node_modules/lodash/_getRawTag.js"(exports, module) {
    "use strict";
    var Symbol2 = require_Symbol2();
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    var nativeObjectToString = objectProto.toString;
    var symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
      try {
        value[symToStringTag] = void 0;
        var unmasked = true;
      } catch (e4) {
      }
      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }
    module.exports = getRawTag;
  }
});
var require_objectToString2 = __commonJS2({
  "../../node_modules/lodash/_objectToString.js"(exports, module) {
    "use strict";
    var objectProto = Object.prototype;
    var nativeObjectToString = objectProto.toString;
    function objectToString22(value) {
      return nativeObjectToString.call(value);
    }
    module.exports = objectToString22;
  }
});
var require_baseGetTag2 = __commonJS2({
  "../../node_modules/lodash/_baseGetTag.js"(exports, module) {
    "use strict";
    var Symbol2 = require_Symbol2();
    var getRawTag = require_getRawTag2();
    var objectToString22 = require_objectToString2();
    var nullTag = "[object Null]";
    var undefinedTag = "[object Undefined]";
    var symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
    function baseGetTag(value) {
      if (value == null) {
        return value === void 0 ? undefinedTag : nullTag;
      }
      return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString22(value);
    }
    module.exports = baseGetTag;
  }
});
var require_isObjectLike2 = __commonJS2({
  "../../node_modules/lodash/isObjectLike.js"(exports, module) {
    "use strict";
    function isObjectLike(value) {
      return value != null && typeof value == "object";
    }
    module.exports = isObjectLike;
  }
});
var require_isSymbol2 = __commonJS2({
  "../../node_modules/lodash/isSymbol.js"(exports, module) {
    "use strict";
    var baseGetTag = require_baseGetTag2();
    var isObjectLike = require_isObjectLike2();
    var symbolTag = "[object Symbol]";
    function isSymbol(value) {
      return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
    }
    module.exports = isSymbol;
  }
});
var require_toNumber2 = __commonJS2({
  "../../node_modules/lodash/toNumber.js"(exports, module) {
    "use strict";
    var baseTrim = require_baseTrim2();
    var isObject = require_isObject2();
    var isSymbol = require_isSymbol2();
    var NAN = 0 / 0;
    var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    var reIsBinary = /^0b[01]+$/i;
    var reIsOctal = /^0o[0-7]+$/i;
    var freeParseInt = parseInt;
    function toNumber(value) {
      if (typeof value == "number") {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = isObject(other) ? other + "" : other;
      }
      if (typeof value != "string") {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
    }
    module.exports = toNumber;
  }
});
var require_debounce2 = __commonJS2({
  "../../node_modules/lodash/debounce.js"(exports, module) {
    "use strict";
    var isObject = require_isObject2();
    var now2 = require_now2();
    var toNumber = require_toNumber2();
    var FUNC_ERROR_TEXT = "Expected a function";
    var nativeMax = Math.max;
    var nativeMin = Math.min;
    function debounce62(func, wait, options7) {
      var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
      if (typeof func != "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options7)) {
        leading = !!options7.leading;
        maxing = "maxWait" in options7;
        maxWait = maxing ? nativeMax(toNumber(options7.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options7 ? !!options7.trailing : trailing;
      }
      function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = void 0;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }
      function leadingEdge(time) {
        lastInvokeTime = time;
        timerId = setTimeout(timerExpired, wait);
        return leading ? invokeFunc(time) : result;
      }
      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
      }
      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
      }
      function timerExpired() {
        var time = now2();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        timerId = setTimeout(timerExpired, remainingWait(time));
      }
      function trailingEdge(time) {
        timerId = void 0;
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = void 0;
        return result;
      }
      function cancel() {
        if (timerId !== void 0) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = void 0;
      }
      function flush() {
        return timerId === void 0 ? result : trailingEdge(now2());
      }
      function debounced() {
        var time = now2(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
          if (timerId === void 0) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === void 0) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }
    module.exports = debounce62;
  }
});
var require_throttle2 = __commonJS2({
  "../../node_modules/lodash/throttle.js"(exports, module) {
    "use strict";
    var debounce62 = require_debounce2();
    var isObject = require_isObject2();
    var FUNC_ERROR_TEXT = "Expected a function";
    function throttle3(func, wait, options7) {
      var leading = true, trailing = true;
      if (typeof func != "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options7)) {
        leading = "leading" in options7 ? !!options7.leading : leading;
        trailing = "trailing" in options7 ? !!options7.trailing : trailing;
      }
      return debounce62(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
      });
    }
    module.exports = throttle3;
  }
});
var require_namespace_emitter2 = __commonJS2({
  "../../node_modules/namespace-emitter/index.js"(exports, module) {
    "use strict";
    module.exports = function createNamespaceEmitter() {
      var emitter = {};
      var _fns = emitter._fns = {};
      emitter.emit = function emit(event, arg1, arg2, arg3, arg4, arg5, arg6) {
        var toEmit = getListeners(event);
        if (toEmit.length) {
          emitAll(event, toEmit, [arg1, arg2, arg3, arg4, arg5, arg6]);
        }
      };
      emitter.on = function on(event, fn) {
        if (!_fns[event]) {
          _fns[event] = [];
        }
        _fns[event].push(fn);
      };
      emitter.once = function once(event, fn) {
        function one() {
          fn.apply(this, arguments);
          emitter.off(event, one);
        }
        this.on(event, one);
      };
      emitter.off = function off(event, fn) {
        var keep = [];
        if (event && fn) {
          var fns = this._fns[event];
          var i4 = 0;
          var l4 = fns ? fns.length : 0;
          for (i4; i4 < l4; i4++) {
            if (fns[i4] !== fn) {
              keep.push(fns[i4]);
            }
          }
        }
        keep.length ? this._fns[event] = keep : delete this._fns[event];
      };
      function getListeners(e4) {
        var out = _fns[e4] ? _fns[e4] : [];
        var idx = e4.indexOf(":");
        var args = idx === -1 ? [e4] : [e4.substring(0, idx), e4.substring(idx + 1)];
        var keys = Object.keys(_fns);
        var i4 = 0;
        var l4 = keys.length;
        for (i4; i4 < l4; i4++) {
          var key = keys[i4];
          if (key === "*") {
            out = out.concat(_fns[key]);
          }
          if (args.length === 2 && args[0] === key) {
            out = out.concat(_fns[key]);
            break;
          }
        }
        return out;
      }
      function emitAll(e4, fns, args) {
        var i4 = 0;
        var l4 = fns.length;
        for (i4; i4 < l4; i4++) {
          if (!fns[i4])
            break;
          fns[i4].event = e4;
          fns[i4].apply(fns[i4], args);
        }
      }
      return emitter;
    };
  }
});
var require_prettierBytes2 = __commonJS2({
  "../../node_modules/@transloadit/prettier-bytes/dist/prettierBytes.js"(exports, module) {
    "use strict";
    module.exports = function prettierBytes4(num) {
      if (typeof num !== "number" || Number.isNaN(num)) {
        throw new TypeError(`Expected a number, got ${typeof num}`);
      }
      const neg = num < 0;
      const units = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
      if (neg) {
        num = -num;
      }
      if (num < 1) {
        return `${(neg ? "-" : "") + num} B`;
      }
      const exponent = Math.min(Math.floor(Math.log(num) / Math.log(1024)), units.length - 1);
      num = Number(num / 1024 ** exponent);
      const unit = units[exponent];
      if (num >= 10 || num % 1 === 0) {
        return `${(neg ? "-" : "") + num.toFixed(0)} ${unit}`;
      }
      return `${(neg ? "-" : "") + num.toFixed(1)} ${unit}`;
    };
  }
});
var require_wildcard = __commonJS2({
  "../../node_modules/wildcard/index.js"(exports, module) {
    "use strict";
    function WildcardMatcher(text, separator2) {
      this.text = text = text || "";
      this.hasWild = ~text.indexOf("*");
      this.separator = separator2;
      this.parts = text.split(separator2);
    }
    WildcardMatcher.prototype.match = function(input) {
      var matches = true;
      var parts = this.parts;
      var ii;
      var partsCount = parts.length;
      var testParts;
      if (typeof input == "string" || input instanceof String) {
        if (!this.hasWild && this.text != input) {
          matches = false;
        } else {
          testParts = (input || "").split(this.separator);
          for (ii = 0; matches && ii < partsCount; ii++) {
            if (parts[ii] === "*") {
              continue;
            } else if (ii < testParts.length) {
              matches = parts[ii] === testParts[ii];
            } else {
              matches = false;
            }
          }
          matches = matches && testParts;
        }
      } else if (typeof input.splice == "function") {
        matches = [];
        for (ii = input.length; ii--; ) {
          if (this.match(input[ii])) {
            matches[matches.length] = input[ii];
          }
        }
      } else if (typeof input == "object") {
        matches = {};
        for (var key in input) {
          if (this.match(key)) {
            matches[key] = input[key];
          }
        }
      }
      return matches;
    };
    module.exports = function(text, test2, separator2) {
      var matcher = new WildcardMatcher(text, separator2 || /[\/\.]/);
      if (typeof test2 != "undefined") {
        return matcher.match(test2);
      }
      return matcher;
    };
  }
});
var require_mime_match = __commonJS2({
  "../../node_modules/mime-match/index.js"(exports, module) {
    "use strict";
    var wildcard = require_wildcard();
    var reMimePartSplit = /[\/\+\.]/;
    module.exports = function(target, pattern) {
      function test2(pattern2) {
        var result = wildcard(pattern2, target, reMimePartSplit);
        return result && result.length >= 2;
      }
      return pattern ? test2(pattern.split(";")[0]) : test2;
    };
  }
});
var require_classnames2 = __commonJS2({
  "../../node_modules/classnames/index.js"(exports, module) {
    "use strict";
    (function() {
      "use strict";
      var hasOwn = {}.hasOwnProperty;
      function classNames192() {
        var classes = "";
        for (var i4 = 0; i4 < arguments.length; i4++) {
          var arg = arguments[i4];
          if (arg) {
            classes = appendClass(classes, parseValue(arg));
          }
        }
        return classes;
      }
      function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") {
          return arg;
        }
        if (typeof arg !== "object") {
          return "";
        }
        if (Array.isArray(arg)) {
          return classNames192.apply(null, arg);
        }
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
          return arg.toString();
        }
        var classes = "";
        for (var key in arg) {
          if (hasOwn.call(arg, key) && arg[key]) {
            classes = appendClass(classes, key);
          }
        }
        return classes;
      }
      function appendClass(value, newClass) {
        if (!newClass) {
          return value;
        }
        if (value) {
          return value + " " + newClass;
        }
        return value + newClass;
      }
      if (typeof module !== "undefined" && module.exports) {
        classNames192.default = classNames192;
        module.exports = classNames192;
      } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) {
        define("classnames", [], function() {
          return classNames192;
        });
      } else {
        window.classNames = classNames192;
      }
    })();
  }
});
var require_eventemitter3 = __commonJS2({
  "../../node_modules/eventemitter3/index.js"(exports, module) {
    "use strict";
    var has22 = Object.prototype.hasOwnProperty;
    var prefix = "~";
    function Events() {
    }
    if (Object.create) {
      Events.prototype = /* @__PURE__ */ Object.create(null);
      if (!new Events().__proto__)
        prefix = false;
    }
    function EE(fn, context, once) {
      this.fn = fn;
      this.context = context;
      this.once = once || false;
    }
    function addListener(emitter, event, fn, context, once) {
      if (typeof fn !== "function") {
        throw new TypeError("The listener must be a function");
      }
      var listener = new EE(fn, context || emitter, once), evt = prefix ? prefix + event : event;
      if (!emitter._events[evt])
        emitter._events[evt] = listener, emitter._eventsCount++;
      else if (!emitter._events[evt].fn)
        emitter._events[evt].push(listener);
      else
        emitter._events[evt] = [emitter._events[evt], listener];
      return emitter;
    }
    function clearEvent(emitter, evt) {
      if (--emitter._eventsCount === 0)
        emitter._events = new Events();
      else
        delete emitter._events[evt];
    }
    function EventEmitter2() {
      this._events = new Events();
      this._eventsCount = 0;
    }
    EventEmitter2.prototype.eventNames = function eventNames() {
      var names = [], events, name;
      if (this._eventsCount === 0)
        return names;
      for (name in events = this._events) {
        if (has22.call(events, name))
          names.push(prefix ? name.slice(1) : name);
      }
      if (Object.getOwnPropertySymbols) {
        return names.concat(Object.getOwnPropertySymbols(events));
      }
      return names;
    };
    EventEmitter2.prototype.listeners = function listeners(event) {
      var evt = prefix ? prefix + event : event, handlers = this._events[evt];
      if (!handlers)
        return [];
      if (handlers.fn)
        return [handlers.fn];
      for (var i4 = 0, l4 = handlers.length, ee4 = new Array(l4); i4 < l4; i4++) {
        ee4[i4] = handlers[i4].fn;
      }
      return ee4;
    };
    EventEmitter2.prototype.listenerCount = function listenerCount(event) {
      var evt = prefix ? prefix + event : event, listeners = this._events[evt];
      if (!listeners)
        return 0;
      if (listeners.fn)
        return 1;
      return listeners.length;
    };
    EventEmitter2.prototype.emit = function emit(event, a1, a222, a32, a4, a5) {
      var evt = prefix ? prefix + event : event;
      if (!this._events[evt])
        return false;
      var listeners = this._events[evt], len = arguments.length, args, i4;
      if (listeners.fn) {
        if (listeners.once)
          this.removeListener(event, listeners.fn, void 0, true);
        switch (len) {
          case 1:
            return listeners.fn.call(listeners.context), true;
          case 2:
            return listeners.fn.call(listeners.context, a1), true;
          case 3:
            return listeners.fn.call(listeners.context, a1, a222), true;
          case 4:
            return listeners.fn.call(listeners.context, a1, a222, a32), true;
          case 5:
            return listeners.fn.call(listeners.context, a1, a222, a32, a4), true;
          case 6:
            return listeners.fn.call(listeners.context, a1, a222, a32, a4, a5), true;
        }
        for (i4 = 1, args = new Array(len - 1); i4 < len; i4++) {
          args[i4 - 1] = arguments[i4];
        }
        listeners.fn.apply(listeners.context, args);
      } else {
        var length = listeners.length, j4;
        for (i4 = 0; i4 < length; i4++) {
          if (listeners[i4].once)
            this.removeListener(event, listeners[i4].fn, void 0, true);
          switch (len) {
            case 1:
              listeners[i4].fn.call(listeners[i4].context);
              break;
            case 2:
              listeners[i4].fn.call(listeners[i4].context, a1);
              break;
            case 3:
              listeners[i4].fn.call(listeners[i4].context, a1, a222);
              break;
            case 4:
              listeners[i4].fn.call(listeners[i4].context, a1, a222, a32);
              break;
            default:
              if (!args)
                for (j4 = 1, args = new Array(len - 1); j4 < len; j4++) {
                  args[j4 - 1] = arguments[j4];
                }
              listeners[i4].fn.apply(listeners[i4].context, args);
          }
        }
      }
      return true;
    };
    EventEmitter2.prototype.on = function on(event, fn, context) {
      return addListener(this, event, fn, context, false);
    };
    EventEmitter2.prototype.once = function once(event, fn, context) {
      return addListener(this, event, fn, context, true);
    };
    EventEmitter2.prototype.removeListener = function removeListener(event, fn, context, once) {
      var evt = prefix ? prefix + event : event;
      if (!this._events[evt])
        return this;
      if (!fn) {
        clearEvent(this, evt);
        return this;
      }
      var listeners = this._events[evt];
      if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) {
          clearEvent(this, evt);
        }
      } else {
        for (var i4 = 0, events = [], length = listeners.length; i4 < length; i4++) {
          if (listeners[i4].fn !== fn || once && !listeners[i4].once || context && listeners[i4].context !== context) {
            events.push(listeners[i4]);
          }
        }
        if (events.length)
          this._events[evt] = events.length === 1 ? events[0] : events;
        else
          clearEvent(this, evt);
      }
      return this;
    };
    EventEmitter2.prototype.removeAllListeners = function removeAllListeners(event) {
      var evt;
      if (event) {
        evt = prefix ? prefix + event : event;
        if (this._events[evt])
          clearEvent(this, evt);
      } else {
        this._events = new Events();
        this._eventsCount = 0;
      }
      return this;
    };
    EventEmitter2.prototype.off = EventEmitter2.prototype.removeListener;
    EventEmitter2.prototype.addListener = EventEmitter2.prototype.on;
    EventEmitter2.prefixed = prefix;
    EventEmitter2.EventEmitter = EventEmitter2;
    if ("undefined" !== typeof module) {
      module.exports = EventEmitter2;
    }
  }
});
var require_is_shallow_equal = __commonJS2({
  "../../node_modules/is-shallow-equal/index.js"(exports, module) {
    "use strict";
    module.exports = function isShallowEqual(a4, b3) {
      if (a4 === b3)
        return true;
      for (var i4 in a4)
        if (!(i4 in b3))
          return false;
      for (var i4 in b3)
        if (a4[i4] !== b3[i4])
          return false;
      return true;
    };
  }
});
var require_react_is_production_min2 = __commonJS2({
  "../../node_modules/react-is/cjs/react-is.production.min.js"(exports) {
    "use strict";
    var b3 = "function" === typeof Symbol && Symbol.for;
    var c4 = b3 ? Symbol.for("react.element") : 60103;
    var d4 = b3 ? Symbol.for("react.portal") : 60106;
    var e4 = b3 ? Symbol.for("react.fragment") : 60107;
    var f4 = b3 ? Symbol.for("react.strict_mode") : 60108;
    var g3 = b3 ? Symbol.for("react.profiler") : 60114;
    var h102 = b3 ? Symbol.for("react.provider") : 60109;
    var k4 = b3 ? Symbol.for("react.context") : 60110;
    var l4 = b3 ? Symbol.for("react.async_mode") : 60111;
    var m4 = b3 ? Symbol.for("react.concurrent_mode") : 60111;
    var n3 = b3 ? Symbol.for("react.forward_ref") : 60112;
    var p4 = b3 ? Symbol.for("react.suspense") : 60113;
    var q4 = b3 ? Symbol.for("react.suspense_list") : 60120;
    var r4 = b3 ? Symbol.for("react.memo") : 60115;
    var t4 = b3 ? Symbol.for("react.lazy") : 60116;
    var v4 = b3 ? Symbol.for("react.block") : 60121;
    var w4 = b3 ? Symbol.for("react.fundamental") : 60117;
    var x4 = b3 ? Symbol.for("react.responder") : 60118;
    var y4 = b3 ? Symbol.for("react.scope") : 60119;
    function z42(a4) {
      if ("object" === typeof a4 && null !== a4) {
        var u4 = a4.$$typeof;
        switch (u4) {
          case c4:
            switch (a4 = a4.type, a4) {
              case l4:
              case m4:
              case e4:
              case g3:
              case f4:
              case p4:
                return a4;
              default:
                switch (a4 = a4 && a4.$$typeof, a4) {
                  case k4:
                  case n3:
                  case t4:
                  case r4:
                  case h102:
                    return a4;
                  default:
                    return u4;
                }
            }
          case d4:
            return u4;
        }
      }
    }
    function A3(a4) {
      return z42(a4) === m4;
    }
    exports.AsyncMode = l4;
    exports.ConcurrentMode = m4;
    exports.ContextConsumer = k4;
    exports.ContextProvider = h102;
    exports.Element = c4;
    exports.ForwardRef = n3;
    exports.Fragment = e4;
    exports.Lazy = t4;
    exports.Memo = r4;
    exports.Portal = d4;
    exports.Profiler = g3;
    exports.StrictMode = f4;
    exports.Suspense = p4;
    exports.isAsyncMode = function(a4) {
      return A3(a4) || z42(a4) === l4;
    };
    exports.isConcurrentMode = A3;
    exports.isContextConsumer = function(a4) {
      return z42(a4) === k4;
    };
    exports.isContextProvider = function(a4) {
      return z42(a4) === h102;
    };
    exports.isElement = function(a4) {
      return "object" === typeof a4 && null !== a4 && a4.$$typeof === c4;
    };
    exports.isForwardRef = function(a4) {
      return z42(a4) === n3;
    };
    exports.isFragment = function(a4) {
      return z42(a4) === e4;
    };
    exports.isLazy = function(a4) {
      return z42(a4) === t4;
    };
    exports.isMemo = function(a4) {
      return z42(a4) === r4;
    };
    exports.isPortal = function(a4) {
      return z42(a4) === d4;
    };
    exports.isProfiler = function(a4) {
      return z42(a4) === g3;
    };
    exports.isStrictMode = function(a4) {
      return z42(a4) === f4;
    };
    exports.isSuspense = function(a4) {
      return z42(a4) === p4;
    };
    exports.isValidElementType = function(a4) {
      return "string" === typeof a4 || "function" === typeof a4 || a4 === e4 || a4 === m4 || a4 === g3 || a4 === f4 || a4 === p4 || a4 === q4 || "object" === typeof a4 && null !== a4 && (a4.$$typeof === t4 || a4.$$typeof === r4 || a4.$$typeof === h102 || a4.$$typeof === k4 || a4.$$typeof === n3 || a4.$$typeof === w4 || a4.$$typeof === x4 || a4.$$typeof === y4 || a4.$$typeof === v4);
    };
    exports.typeOf = z42;
  }
});
var require_react_is_development2 = __commonJS2({
  "../../node_modules/react-is/cjs/react-is.development.js"(exports) {
    "use strict";
    if (process.env.NODE_ENV !== "production") {
      (function() {
        "use strict";
        var hasSymbol = typeof Symbol === "function" && Symbol.for;
        var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103;
        var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
        var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107;
        var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
        var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
        var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
        var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
        var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
        var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
        var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
        var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
        var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
        var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
        var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
        var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
        var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
        var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
        var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
        function isValidElementType(type) {
          return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
          type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
        }
        function typeOf(object102) {
          if (typeof object102 === "object" && object102 !== null) {
            var $$typeof = object102.$$typeof;
            switch ($$typeof) {
              case REACT_ELEMENT_TYPE:
                var type = object102.type;
                switch (type) {
                  case REACT_ASYNC_MODE_TYPE:
                  case REACT_CONCURRENT_MODE_TYPE:
                  case REACT_FRAGMENT_TYPE:
                  case REACT_PROFILER_TYPE:
                  case REACT_STRICT_MODE_TYPE:
                  case REACT_SUSPENSE_TYPE:
                    return type;
                  default:
                    var $$typeofType = type && type.$$typeof;
                    switch ($$typeofType) {
                      case REACT_CONTEXT_TYPE:
                      case REACT_FORWARD_REF_TYPE:
                      case REACT_LAZY_TYPE:
                      case REACT_MEMO_TYPE:
                      case REACT_PROVIDER_TYPE:
                        return $$typeofType;
                      default:
                        return $$typeof;
                    }
                }
              case REACT_PORTAL_TYPE:
                return $$typeof;
            }
          }
          return void 0;
        }
        var AsyncMode = REACT_ASYNC_MODE_TYPE;
        var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
        var ContextConsumer = REACT_CONTEXT_TYPE;
        var ContextProvider = REACT_PROVIDER_TYPE;
        var Element2 = REACT_ELEMENT_TYPE;
        var ForwardRef = REACT_FORWARD_REF_TYPE;
        var Fragment910 = REACT_FRAGMENT_TYPE;
        var Lazy = REACT_LAZY_TYPE;
        var Memo = REACT_MEMO_TYPE;
        var Portal = REACT_PORTAL_TYPE;
        var Profiler = REACT_PROFILER_TYPE;
        var StrictMode = REACT_STRICT_MODE_TYPE;
        var Suspense252 = REACT_SUSPENSE_TYPE;
        var hasWarnedAboutDeprecatedIsAsyncMode = false;
        function isAsyncMode(object102) {
          {
            if (!hasWarnedAboutDeprecatedIsAsyncMode) {
              hasWarnedAboutDeprecatedIsAsyncMode = true;
              console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
            }
          }
          return isConcurrentMode(object102) || typeOf(object102) === REACT_ASYNC_MODE_TYPE;
        }
        function isConcurrentMode(object102) {
          return typeOf(object102) === REACT_CONCURRENT_MODE_TYPE;
        }
        function isContextConsumer(object102) {
          return typeOf(object102) === REACT_CONTEXT_TYPE;
        }
        function isContextProvider(object102) {
          return typeOf(object102) === REACT_PROVIDER_TYPE;
        }
        function isElement(object102) {
          return typeof object102 === "object" && object102 !== null && object102.$$typeof === REACT_ELEMENT_TYPE;
        }
        function isForwardRef(object102) {
          return typeOf(object102) === REACT_FORWARD_REF_TYPE;
        }
        function isFragment(object102) {
          return typeOf(object102) === REACT_FRAGMENT_TYPE;
        }
        function isLazy(object102) {
          return typeOf(object102) === REACT_LAZY_TYPE;
        }
        function isMemo(object102) {
          return typeOf(object102) === REACT_MEMO_TYPE;
        }
        function isPortal(object102) {
          return typeOf(object102) === REACT_PORTAL_TYPE;
        }
        function isProfiler(object102) {
          return typeOf(object102) === REACT_PROFILER_TYPE;
        }
        function isStrictMode(object102) {
          return typeOf(object102) === REACT_STRICT_MODE_TYPE;
        }
        function isSuspense(object102) {
          return typeOf(object102) === REACT_SUSPENSE_TYPE;
        }
        exports.AsyncMode = AsyncMode;
        exports.ConcurrentMode = ConcurrentMode;
        exports.ContextConsumer = ContextConsumer;
        exports.ContextProvider = ContextProvider;
        exports.Element = Element2;
        exports.ForwardRef = ForwardRef;
        exports.Fragment = Fragment910;
        exports.Lazy = Lazy;
        exports.Memo = Memo;
        exports.Portal = Portal;
        exports.Profiler = Profiler;
        exports.StrictMode = StrictMode;
        exports.Suspense = Suspense252;
        exports.isAsyncMode = isAsyncMode;
        exports.isConcurrentMode = isConcurrentMode;
        exports.isContextConsumer = isContextConsumer;
        exports.isContextProvider = isContextProvider;
        exports.isElement = isElement;
        exports.isForwardRef = isForwardRef;
        exports.isFragment = isFragment;
        exports.isLazy = isLazy;
        exports.isMemo = isMemo;
        exports.isPortal = isPortal;
        exports.isProfiler = isProfiler;
        exports.isStrictMode = isStrictMode;
        exports.isSuspense = isSuspense;
        exports.isValidElementType = isValidElementType;
        exports.typeOf = typeOf;
      })();
    }
  }
});
var require_react_is2 = __commonJS2({
  "../../node_modules/react-is/index.js"(exports, module) {
    "use strict";
    if (process.env.NODE_ENV === "production") {
      module.exports = require_react_is_production_min2();
    } else {
      module.exports = require_react_is_development2();
    }
  }
});
var require_object_assign2 = __commonJS2({
  "../../node_modules/object-assign/index.js"(exports, module) {
    "use strict";
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var propIsEnumerable = Object.prototype.propertyIsEnumerable;
    function toObject(val) {
      if (val === null || val === void 0) {
        throw new TypeError("Object.assign cannot be called with null or undefined");
      }
      return Object(val);
    }
    function shouldUseNative() {
      try {
        if (!Object.assign) {
          return false;
        }
        var test1 = new String("abc");
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") {
          return false;
        }
        var test2 = {};
        for (var i4 = 0; i4 < 10; i4++) {
          test2["_" + String.fromCharCode(i4)] = i4;
        }
        var order2 = Object.getOwnPropertyNames(test2).map(function(n3) {
          return test2[n3];
        });
        if (order2.join("") !== "0123456789") {
          return false;
        }
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
          test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
          return false;
        }
        return true;
      } catch (err) {
        return false;
      }
    }
    module.exports = shouldUseNative() ? Object.assign : function(target, source) {
      var from;
      var to = toObject(target);
      var symbols;
      for (var s4 = 1; s4 < arguments.length; s4++) {
        from = Object(arguments[s4]);
        for (var key in from) {
          if (hasOwnProperty.call(from, key)) {
            to[key] = from[key];
          }
        }
        if (getOwnPropertySymbols) {
          symbols = getOwnPropertySymbols(from);
          for (var i4 = 0; i4 < symbols.length; i4++) {
            if (propIsEnumerable.call(from, symbols[i4])) {
              to[symbols[i4]] = from[symbols[i4]];
            }
          }
        }
      }
      return to;
    };
  }
});
var require_ReactPropTypesSecret2 = __commonJS2({
  "../../node_modules/prop-types/lib/ReactPropTypesSecret.js"(exports, module) {
    "use strict";
    var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    module.exports = ReactPropTypesSecret;
  }
});
var require_has2 = __commonJS2({
  "../../node_modules/prop-types/lib/has.js"(exports, module) {
    "use strict";
    module.exports = Function.call.bind(Object.prototype.hasOwnProperty);
  }
});
var require_checkPropTypes2 = __commonJS2({
  "../../node_modules/prop-types/checkPropTypes.js"(exports, module) {
    "use strict";
    var printWarning = function() {
    };
    if (process.env.NODE_ENV !== "production") {
      ReactPropTypesSecret = require_ReactPropTypesSecret2();
      loggedTypeFailures = {};
      has22 = require_has2();
      printWarning = function(text) {
        var message = "Warning: " + text;
        if (typeof console !== "undefined") {
          console.error(message);
        }
        try {
          throw new Error(message);
        } catch (x4) {
        }
      };
    }
    var ReactPropTypesSecret;
    var loggedTypeFailures;
    var has22;
    function checkPropTypes(typeSpecs, values, location2, componentName, getStack) {
      if (process.env.NODE_ENV !== "production") {
        for (var typeSpecName in typeSpecs) {
          if (has22(typeSpecs, typeSpecName)) {
            var error;
            try {
              if (typeof typeSpecs[typeSpecName] !== "function") {
                var err = Error(
                  (componentName || "React class") + ": " + location2 + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
                );
                err.name = "Invariant Violation";
                throw err;
              }
              error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location2, null, ReactPropTypesSecret);
            } catch (ex) {
              error = ex;
            }
            if (error && !(error instanceof Error)) {
              printWarning(
                (componentName || "React class") + ": type specification of " + location2 + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
              );
            }
            if (error instanceof Error && !(error.message in loggedTypeFailures)) {
              loggedTypeFailures[error.message] = true;
              var stack = getStack ? getStack() : "";
              printWarning(
                "Failed " + location2 + " type: " + error.message + (stack != null ? stack : "")
              );
            }
          }
        }
      }
    }
    checkPropTypes.resetWarningCache = function() {
      if (process.env.NODE_ENV !== "production") {
        loggedTypeFailures = {};
      }
    };
    module.exports = checkPropTypes;
  }
});
var require_factoryWithTypeCheckers2 = __commonJS2({
  "../../node_modules/prop-types/factoryWithTypeCheckers.js"(exports, module) {
    "use strict";
    var ReactIs = require_react_is2();
    var assign2 = require_object_assign2();
    var ReactPropTypesSecret = require_ReactPropTypesSecret2();
    var has22 = require_has2();
    var checkPropTypes = require_checkPropTypes2();
    var printWarning = function() {
    };
    if (process.env.NODE_ENV !== "production") {
      printWarning = function(text) {
        var message = "Warning: " + text;
        if (typeof console !== "undefined") {
          console.error(message);
        }
        try {
          throw new Error(message);
        } catch (x4) {
        }
      };
    }
    function emptyFunctionThatReturnsNull() {
      return null;
    }
    module.exports = function(isValidElement32, throwOnDirectAccess) {
      var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = "@@iterator";
      function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === "function") {
          return iteratorFn;
        }
      }
      var ANONYMOUS = "<<anonymous>>";
      var ReactPropTypes = {
        array: createPrimitiveTypeChecker("array"),
        bigint: createPrimitiveTypeChecker("bigint"),
        bool: createPrimitiveTypeChecker("boolean"),
        func: createPrimitiveTypeChecker("function"),
        number: createPrimitiveTypeChecker("number"),
        object: createPrimitiveTypeChecker("object"),
        string: createPrimitiveTypeChecker("string"),
        symbol: createPrimitiveTypeChecker("symbol"),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        elementType: createElementTypeTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
      };
      function is(x4, y4) {
        if (x4 === y4) {
          return x4 !== 0 || 1 / x4 === 1 / y4;
        } else {
          return x4 !== x4 && y4 !== y4;
        }
      }
      function PropTypeError(message, data) {
        this.message = message;
        this.data = data && typeof data === "object" ? data : {};
        this.stack = "";
      }
      PropTypeError.prototype = Error.prototype;
      function createChainableTypeChecker(validate) {
        if (process.env.NODE_ENV !== "production") {
          var manualPropTypeCallCache = {};
          var manualPropTypeWarningCount = 0;
        }
        function checkType(isRequired, props, propName, componentName, location2, propFullName, secret) {
          componentName = componentName || ANONYMOUS;
          propFullName = propFullName || propName;
          if (secret !== ReactPropTypesSecret) {
            if (throwOnDirectAccess) {
              var err = new Error(
                "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
              );
              err.name = "Invariant Violation";
              throw err;
            } else if (process.env.NODE_ENV !== "production" && typeof console !== "undefined") {
              var cacheKey = componentName + ":" + propName;
              if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
              manualPropTypeWarningCount < 3) {
                printWarning(
                  "You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
                );
                manualPropTypeCallCache[cacheKey] = true;
                manualPropTypeWarningCount++;
              }
            }
          }
          if (props[propName] == null) {
            if (isRequired) {
              if (props[propName] === null) {
                return new PropTypeError("The " + location2 + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
              }
              return new PropTypeError("The " + location2 + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
            }
            return null;
          } else {
            return validate(props, propName, componentName, location2, propFullName);
          }
        }
        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
      }
      function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location2, propFullName, secret) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== expectedType) {
            var preciseType = getPreciseType(propValue);
            return new PropTypeError(
              "Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."),
              { expectedType }
            );
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createAnyTypeChecker() {
        return createChainableTypeChecker(emptyFunctionThatReturnsNull);
      }
      function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location2, propFullName) {
          if (typeof typeChecker !== "function") {
            return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
          }
          var propValue = props[propName];
          if (!Array.isArray(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
          }
          for (var i4 = 0; i4 < propValue.length; i4++) {
            var error = typeChecker(propValue, i4, componentName, location2, propFullName + "[" + i4 + "]", ReactPropTypesSecret);
            if (error instanceof Error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createElementTypeChecker() {
        function validate(props, propName, componentName, location2, propFullName) {
          var propValue = props[propName];
          if (!isValidElement32(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createElementTypeTypeChecker() {
        function validate(props, propName, componentName, location2, propFullName) {
          var propValue = props[propName];
          if (!ReactIs.isValidElementType(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location2, propFullName) {
          if (!(props[propName] instanceof expectedClass)) {
            var expectedClassName = expectedClass.name || ANONYMOUS;
            var actualClassName = getClassName(props[propName]);
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) {
          if (process.env.NODE_ENV !== "production") {
            if (arguments.length > 1) {
              printWarning(
                "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
              );
            } else {
              printWarning("Invalid argument supplied to oneOf, expected an array.");
            }
          }
          return emptyFunctionThatReturnsNull;
        }
        function validate(props, propName, componentName, location2, propFullName) {
          var propValue = props[propName];
          for (var i4 = 0; i4 < expectedValues.length; i4++) {
            if (is(propValue, expectedValues[i4])) {
              return null;
            }
          }
          var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
            var type = getPreciseType(value);
            if (type === "symbol") {
              return String(value);
            }
            return value;
          });
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
        }
        return createChainableTypeChecker(validate);
      }
      function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location2, propFullName) {
          if (typeof typeChecker !== "function") {
            return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
          }
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
          }
          for (var key in propValue) {
            if (has22(propValue, key)) {
              var error = typeChecker(propValue, key, componentName, location2, propFullName + "." + key, ReactPropTypesSecret);
              if (error instanceof Error) {
                return error;
              }
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) {
          process.env.NODE_ENV !== "production" ? printWarning("Invalid argument supplied to oneOfType, expected an instance of array.") : void 0;
          return emptyFunctionThatReturnsNull;
        }
        for (var i4 = 0; i4 < arrayOfTypeCheckers.length; i4++) {
          var checker = arrayOfTypeCheckers[i4];
          if (typeof checker !== "function") {
            printWarning(
              "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i4 + "."
            );
            return emptyFunctionThatReturnsNull;
          }
        }
        function validate(props, propName, componentName, location2, propFullName) {
          var expectedTypes = [];
          for (var i5 = 0; i5 < arrayOfTypeCheckers.length; i5++) {
            var checker2 = arrayOfTypeCheckers[i5];
            var checkerResult = checker2(props, propName, componentName, location2, propFullName, ReactPropTypesSecret);
            if (checkerResult == null) {
              return null;
            }
            if (checkerResult.data && has22(checkerResult.data, "expectedType")) {
              expectedTypes.push(checkerResult.data.expectedType);
            }
          }
          var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
        }
        return createChainableTypeChecker(validate);
      }
      function createNodeChecker() {
        function validate(props, propName, componentName, location2, propFullName) {
          if (!isNode(props[propName])) {
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function invalidValidatorError(componentName, location2, propFullName, key, type) {
        return new PropTypeError(
          (componentName || "React class") + ": " + location2 + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type + "`."
        );
      }
      function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location2, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
          }
          for (var key in shapeTypes) {
            var checker = shapeTypes[key];
            if (typeof checker !== "function") {
              return invalidValidatorError(componentName, location2, propFullName, key, getPreciseType(checker));
            }
            var error = checker(propValue, key, componentName, location2, propFullName + "." + key, ReactPropTypesSecret);
            if (error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location2, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
          }
          var allKeys = assign2({}, props[propName], shapeTypes);
          for (var key in allKeys) {
            var checker = shapeTypes[key];
            if (has22(shapeTypes, key) && typeof checker !== "function") {
              return invalidValidatorError(componentName, location2, propFullName, key, getPreciseType(checker));
            }
            if (!checker) {
              return new PropTypeError(
                "Invalid " + location2 + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  ")
              );
            }
            var error = checker(propValue, key, componentName, location2, propFullName + "." + key, ReactPropTypesSecret);
            if (error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function isNode(propValue) {
        switch (typeof propValue) {
          case "number":
          case "string":
          case "undefined":
            return true;
          case "boolean":
            return !propValue;
          case "object":
            if (Array.isArray(propValue)) {
              return propValue.every(isNode);
            }
            if (propValue === null || isValidElement32(propValue)) {
              return true;
            }
            var iteratorFn = getIteratorFn(propValue);
            if (iteratorFn) {
              var iterator = iteratorFn.call(propValue);
              var step;
              if (iteratorFn !== propValue.entries) {
                while (!(step = iterator.next()).done) {
                  if (!isNode(step.value)) {
                    return false;
                  }
                }
              } else {
                while (!(step = iterator.next()).done) {
                  var entry = step.value;
                  if (entry) {
                    if (!isNode(entry[1])) {
                      return false;
                    }
                  }
                }
              }
            } else {
              return false;
            }
            return true;
          default:
            return false;
        }
      }
      function isSymbol(propType, propValue) {
        if (propType === "symbol") {
          return true;
        }
        if (!propValue) {
          return false;
        }
        if (propValue["@@toStringTag"] === "Symbol") {
          return true;
        }
        if (typeof Symbol === "function" && propValue instanceof Symbol) {
          return true;
        }
        return false;
      }
      function getPropType(propValue) {
        var propType = typeof propValue;
        if (Array.isArray(propValue)) {
          return "array";
        }
        if (propValue instanceof RegExp) {
          return "object";
        }
        if (isSymbol(propType, propValue)) {
          return "symbol";
        }
        return propType;
      }
      function getPreciseType(propValue) {
        if (typeof propValue === "undefined" || propValue === null) {
          return "" + propValue;
        }
        var propType = getPropType(propValue);
        if (propType === "object") {
          if (propValue instanceof Date) {
            return "date";
          } else if (propValue instanceof RegExp) {
            return "regexp";
          }
        }
        return propType;
      }
      function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);
        switch (type) {
          case "array":
          case "object":
            return "an " + type;
          case "boolean":
          case "date":
          case "regexp":
            return "a " + type;
          default:
            return type;
        }
      }
      function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) {
          return ANONYMOUS;
        }
        return propValue.constructor.name;
      }
      ReactPropTypes.checkPropTypes = checkPropTypes;
      ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
      ReactPropTypes.PropTypes = ReactPropTypes;
      return ReactPropTypes;
    };
  }
});
var require_factoryWithThrowingShims2 = __commonJS2({
  "../../node_modules/prop-types/factoryWithThrowingShims.js"(exports, module) {
    "use strict";
    var ReactPropTypesSecret = require_ReactPropTypesSecret2();
    function emptyFunction() {
    }
    function emptyFunctionWithReset() {
    }
    emptyFunctionWithReset.resetWarningCache = emptyFunction;
    module.exports = function() {
      function shim(props, propName, componentName, location2, propFullName, secret) {
        if (secret === ReactPropTypesSecret) {
          return;
        }
        var err = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        err.name = "Invariant Violation";
        throw err;
      }
      ;
      shim.isRequired = shim;
      function getShim() {
        return shim;
      }
      ;
      var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
      };
      ReactPropTypes.PropTypes = ReactPropTypes;
      return ReactPropTypes;
    };
  }
});
var require_prop_types2 = __commonJS2({
  "../../node_modules/prop-types/index.js"(exports, module) {
    "use strict";
    if (process.env.NODE_ENV !== "production") {
      ReactIs = require_react_is2();
      throwOnDirectAccess = true;
      module.exports = require_factoryWithTypeCheckers2()(ReactIs.isElement, throwOnDirectAccess);
    } else {
      module.exports = require_factoryWithThrowingShims2()();
    }
    var ReactIs;
    var throwOnDirectAccess;
  }
});
var node139 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v222 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "payload",
    "storageKey": null
  }, v32 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerLogoUploadMutation",
      "selections": [
        {
          "alias": "uploadUrl",
          "args": v1,
          "concreteType": "AccountsEmployerGetPreSignedLogoUrlPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerGetPreSignedLogoUrl",
          "plural": false,
          "selections": [
            v222,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerLogoUploadMutation",
      "selections": [
        {
          "alias": "uploadUrl",
          "args": v1,
          "concreteType": "AccountsEmployerGetPreSignedLogoUrlPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerGetPreSignedLogoUrl",
          "plural": false,
          "selections": [
            v222,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "3ba37b3e4fd27825d8734cd4ef159703",
      "id": null,
      "metadata": {},
      "name": "UseEmployerLogoUploadMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerLogoUploadMutation(\n  $input: AccountsEmployerGetPreSignedLogoUrlInput!\n) {\n  uploadUrl: accountsEmployerGetPreSignedLogoUrl(input: $input) {\n    payload\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node139.hash = "5e158145e22abc2e0c75facc1ce138ef";
var node210 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v222 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfEmployer",
    "kind": "LinkedField",
    "name": "employer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Employer",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v222,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isApproved",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isActive",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isDeleted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isPayrolled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isTest",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canDownloadResumes",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canViewTelephoneNumbers",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v222,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerActivateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerActivatePayload",
          "kind": "LinkedField",
          "name": "accountsEmployerActivate",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerActivateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerActivatePayload",
          "kind": "LinkedField",
          "name": "accountsEmployerActivate",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "f313cb4cff2c6256503c2dad5e49a46f",
      "id": null,
      "metadata": {},
      "name": "UseEmployerActivateMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerActivateMutation(\n  $input: AccountsEmployerActivateInput!\n) {\n  data: accountsEmployerActivate(input: $input) {\n    employer {\n      node {\n        id\n        code\n        employerId\n        updatedAt\n        createdAt\n        name\n        isApproved\n        isActive\n        isDeleted\n        isPayrolled\n        isTest\n        canDownloadResumes\n        canViewTelephoneNumbers\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node210.hash = "f0f0b174bc0a02602251aae882e69473";
var node310 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v222 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfEmployer",
    "kind": "LinkedField",
    "name": "employer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Employer",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v222,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isApproved",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isActive",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isDeleted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isPayrolled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isTest",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canDownloadResumes",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canViewTelephoneNumbers",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v222,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerApproveMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerApprovePayload",
          "kind": "LinkedField",
          "name": "accountsEmployerApprove",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerApproveMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerApprovePayload",
          "kind": "LinkedField",
          "name": "accountsEmployerApprove",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "051a2c4702add1f3810c8c7aff000c9c",
      "id": null,
      "metadata": {},
      "name": "UseEmployerApproveMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerApproveMutation(\n  $input: AccountsEmployerApproveInput!\n) {\n  data: accountsEmployerApprove(input: $input) {\n    employer {\n      node {\n        id\n        code\n        employerId\n        updatedAt\n        createdAt\n        name\n        isApproved\n        isActive\n        isDeleted\n        isPayrolled\n        isTest\n        canDownloadResumes\n        canViewTelephoneNumbers\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node310.hash = "d9a9d46af974217d2cfbaeef8d8f40fe";
var node410 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v222 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfEmployer",
    "kind": "LinkedField",
    "name": "employer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Employer",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v222,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isApproved",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isActive",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isDeleted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isPayrolled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isTest",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canDownloadResumes",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canViewTelephoneNumbers",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v222,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerCreateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerCreatePayload",
          "kind": "LinkedField",
          "name": "accountsEmployerCreate",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerCreateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerCreatePayload",
          "kind": "LinkedField",
          "name": "accountsEmployerCreate",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "4a9e99321fb7bd793464bcbdce683357",
      "id": null,
      "metadata": {},
      "name": "UseEmployerCreateMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerCreateMutation(\n  $input: AccountsEmployerCreateInput!\n) {\n  data: accountsEmployerCreate(input: $input) {\n    employer {\n      node {\n        id\n        code\n        employerId\n        updatedAt\n        createdAt\n        name\n        isApproved\n        isActive\n        isDeleted\n        isPayrolled\n        isTest\n        canDownloadResumes\n        canViewTelephoneNumbers\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node410.hash = "1cf86c0983439fc0ac6791c0efd82be4";
var node510 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v222 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfEmployer",
    "kind": "LinkedField",
    "name": "employer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Employer",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v222,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isApproved",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isActive",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isDeleted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isPayrolled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isTest",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canDownloadResumes",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canViewTelephoneNumbers",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v222,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerDeactivateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerDeactivatePayload",
          "kind": "LinkedField",
          "name": "accountsEmployerDeactivate",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerDeactivateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerDeactivatePayload",
          "kind": "LinkedField",
          "name": "accountsEmployerDeactivate",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "f0be501663e85260ae793d3d35333565",
      "id": null,
      "metadata": {},
      "name": "UseEmployerDeactivateMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerDeactivateMutation(\n  $input: AccountsEmployerDeactivateInput!\n) {\n  data: accountsEmployerDeactivate(input: $input) {\n    employer {\n      node {\n        id\n        code\n        employerId\n        updatedAt\n        createdAt\n        name\n        isApproved\n        isActive\n        isDeleted\n        isPayrolled\n        isTest\n        canDownloadResumes\n        canViewTelephoneNumbers\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node510.hash = "a9a6c871fbe375b6cc7af901ce222219";
var node610 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v222 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfEmployerSendingConfig",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "EmployerSendingConfig",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailProvider",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isVerified",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailProviderConfig",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v32 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerEmailsSendingAddressChangeMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "NotificationsEmployerEmailsSendingAddressChangePayload",
          "kind": "LinkedField",
          "name": "notificationsEmployerEmailsSendingAddressChange",
          "plural": false,
          "selections": [
            v222,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerEmailsSendingAddressChangeMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "NotificationsEmployerEmailsSendingAddressChangePayload",
          "kind": "LinkedField",
          "name": "notificationsEmployerEmailsSendingAddressChange",
          "plural": false,
          "selections": [
            v222,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "dc152f5bc1d86888c84f56a595db04cc",
      "id": null,
      "metadata": {},
      "name": "UseEmployerEmailsSendingAddressChangeMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerEmailsSendingAddressChangeMutation(\n  $input: NotificationsEmployerEmailsSendingAddressChangeInput!\n) {\n  data: notificationsEmployerEmailsSendingAddressChange(input: $input) {\n    payload {\n      node {\n        id\n        employerId\n        updatedAt\n        email\n        emailProvider\n        isVerified\n        emailProviderConfig\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node610.hash = "a9ea7461cfd50aacaee33b6d40b20a4c";
var node710 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v222 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfEmployer",
    "kind": "LinkedField",
    "name": "employer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Employer",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v222,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isApproved",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isActive",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isDeleted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isPayrolled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isTest",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canDownloadResumes",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canViewTelephoneNumbers",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v222,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerSetIsTestAccountMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerSetIsTestAccountPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerSetIsTestAccount",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerSetIsTestAccountMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerSetIsTestAccountPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerSetIsTestAccount",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "89e66901fd0875acae7d9a843954c283",
      "id": null,
      "metadata": {},
      "name": "UseEmployerSetIsTestAccountMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerSetIsTestAccountMutation(\n  $input: AccountsEmployerSetIsTestAccountInput!\n) {\n  data: accountsEmployerSetIsTestAccount(input: $input) {\n    employer {\n      node {\n        id\n        code\n        employerId\n        updatedAt\n        createdAt\n        name\n        isApproved\n        isActive\n        isDeleted\n        isPayrolled\n        isTest\n        canDownloadResumes\n        canViewTelephoneNumbers\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node710.hash = "c0414a711518612b0bafadf0deeedc1d";
var node810 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v222 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfEmployer",
    "kind": "LinkedField",
    "name": "employer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Employer",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v222,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isApproved",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isActive",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isDeleted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isPayrolled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isTest",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canDownloadResumes",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canViewTelephoneNumbers",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v222,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerTogglePhoneNumberVisibilityMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerTogglePhoneNumberVisibilityPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerTogglePhoneNumberVisibility",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerTogglePhoneNumberVisibilityMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerTogglePhoneNumberVisibilityPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerTogglePhoneNumberVisibility",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "c0c122e23d8fdab784362d2eb98c8666",
      "id": null,
      "metadata": {},
      "name": "UseEmployerTogglePhoneNumberVisibilityMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerTogglePhoneNumberVisibilityMutation(\n  $input: AccountsEmployerTogglePhoneNumberVisibilityInput!\n) {\n  data: accountsEmployerTogglePhoneNumberVisibility(input: $input) {\n    employer {\n      node {\n        id\n        code\n        employerId\n        updatedAt\n        createdAt\n        name\n        isApproved\n        isActive\n        isDeleted\n        isPayrolled\n        isTest\n        canDownloadResumes\n        canViewTelephoneNumbers\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node810.hash = "edd96d5aa2b3daf0f0f620b9a8ecf79d";
var node910 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v222 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfEmployer",
    "kind": "LinkedField",
    "name": "employer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Employer",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v222,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isApproved",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isActive",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isDeleted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isPayrolled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isTest",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canDownloadResumes",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canViewTelephoneNumbers",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v222,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerUpdateCanonicalCompanyMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerChangeCanonicalCompanyPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerChangeCanonicalCompany",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerUpdateCanonicalCompanyMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerChangeCanonicalCompanyPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerChangeCanonicalCompany",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "0de0ad520b6faac254b21d8e29ba1b40",
      "id": null,
      "metadata": {},
      "name": "UseEmployerUpdateCanonicalCompanyMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerUpdateCanonicalCompanyMutation(\n  $input: AccountsEmployerChangeCanonicalCompanyInput!\n) {\n  data: accountsEmployerChangeCanonicalCompany(input: $input) {\n    employer {\n      node {\n        id\n        code\n        employerId\n        updatedAt\n        createdAt\n        name\n        isApproved\n        isActive\n        isDeleted\n        isPayrolled\n        isTest\n        canDownloadResumes\n        canViewTelephoneNumbers\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node910.hash = "2b04d793571b5eeb5bb16b5aa384bbdb";
var node1010 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v222 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfEmployer",
    "kind": "LinkedField",
    "name": "employer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Employer",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v222,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isApproved",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isActive",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isDeleted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isPayrolled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isTest",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canDownloadResumes",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canViewTelephoneNumbers",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v222,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerUpdateDetailsMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUpdateDetailsPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUpdateDetails",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerUpdateDetailsMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUpdateDetailsPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUpdateDetails",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "67e68cac459ef2a844a2891548e5a41b",
      "id": null,
      "metadata": {},
      "name": "UseEmployerUpdateDetailsMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerUpdateDetailsMutation(\n  $input: AccountsEmployerUpdateDetailsInput!\n) {\n  data: accountsEmployerUpdateDetails(input: $input) {\n    employer {\n      node {\n        id\n        code\n        employerId\n        updatedAt\n        createdAt\n        name\n        isApproved\n        isActive\n        isDeleted\n        isPayrolled\n        isTest\n        canDownloadResumes\n        canViewTelephoneNumbers\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node1010.hash = "ba8eaadc21cf2f782cec5f813f50fc19";
var node1110 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v222 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfEmployerUser",
    "kind": "LinkedField",
    "name": "employerUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsEmployerUser",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          v222,
          v32,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailAddress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isTest",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isDeleted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountsEmployerUserGroup",
            "kind": "LinkedField",
            "name": "userGroups",
            "plural": true,
            "selections": [
              v222,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isAdminGroup",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isDefault",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v5 = {
    "kind": "InlineFragment",
    "selections": [
      v32,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerUserEnableMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUserEnablePayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUserEnable",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerUserEnableMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUserEnablePayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUserEnable",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "39b53e65641834ded37b099caa960991",
      "id": null,
      "metadata": {},
      "name": "UseEmployerUserEnableMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerUserEnableMutation(\n  $input: AccountsEmployerUserEnableInput!\n) {\n  data: accountsEmployerUserEnable(input: $input) {\n    employerUser {\n      node {\n        id\n        code\n        accountId\n        employerId\n        firstName\n        lastName\n        emailAddress\n        updatedAt\n        createdAt\n        isTest\n        isDeleted\n        userGroups {\n          id\n          name\n          description\n          isAdminGroup\n          isDefault\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node1110.hash = "01611e818536a110576c8c5b088f6c9b";
var node1210 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v222 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfEmployerUser",
    "kind": "LinkedField",
    "name": "employerUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsEmployerUser",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          v222,
          v32,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailAddress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isTest",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isDeleted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountsEmployerUserGroup",
            "kind": "LinkedField",
            "name": "userGroups",
            "plural": true,
            "selections": [
              v222,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isAdminGroup",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isDefault",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v5 = {
    "kind": "InlineFragment",
    "selections": [
      v32,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerUserDisableMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUserDisablePayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUserDisable",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerUserDisableMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUserDisablePayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUserDisable",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "0a38fa61ef276f34585c90d996d111e2",
      "id": null,
      "metadata": {},
      "name": "UseEmployerUserDisableMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerUserDisableMutation(\n  $input: AccountsEmployerUserDisableInput!\n) {\n  data: accountsEmployerUserDisable(input: $input) {\n    employerUser {\n      node {\n        id\n        code\n        accountId\n        employerId\n        firstName\n        lastName\n        emailAddress\n        updatedAt\n        createdAt\n        isTest\n        isDeleted\n        userGroups {\n          id\n          name\n          description\n          isAdminGroup\n          isDefault\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node1210.hash = "64805e83f9fad11d262c5dba6bbda1e7";
var node1310 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v222 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfEmployerUser",
    "kind": "LinkedField",
    "name": "employerUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsEmployerUser",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v222,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailAddress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v222,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerUserEmailUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUserChangeEmailPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUserChangeEmail",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerUserEmailUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUserChangeEmailPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUserChangeEmail",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "98d97e729b39265a61fb1681b2eeac17",
      "id": null,
      "metadata": {},
      "name": "UseEmployerUserEmailUpdateMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerUserEmailUpdateMutation(\n  $input: AccountsEmployerUserChangeEmailInput!\n) {\n  data: accountsEmployerUserChangeEmail(input: $input) {\n    employerUser {\n      node {\n        id\n        code\n        accountId\n        employerId\n        emailAddress\n        updatedAt\n        createdAt\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node1310.hash = "23b0e9141999544df99eb88cacefe5b3";
var node142 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v222 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfEmployerUser",
    "kind": "LinkedField",
    "name": "employerUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsEmployerUser",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          v222,
          v32,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailAddress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isTest",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountsEmployerUserGroup",
            "kind": "LinkedField",
            "name": "userGroups",
            "plural": true,
            "selections": [
              v222,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isAdminGroup",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isDefault",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v5 = {
    "kind": "InlineFragment",
    "selections": [
      v32,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerUserCreateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUserCreatePayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUserCreate",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerUserCreateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUserCreatePayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUserCreate",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "082df230bfbaac4bd4e2aafa05c0b0fc",
      "id": null,
      "metadata": {},
      "name": "UseEmployerUserCreateMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerUserCreateMutation(\n  $input: AccountsEmployerUserCreateInput!\n) {\n  data: accountsEmployerUserCreate(input: $input) {\n    employerUser {\n      node {\n        id\n        code\n        accountId\n        employerId\n        firstName\n        lastName\n        emailAddress\n        updatedAt\n        createdAt\n        isTest\n        userGroups {\n          id\n          name\n          description\n          isAdminGroup\n          isDefault\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node142.hash = "8d8f3c473a13fb8981ce292d950c90bc";
var node152 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }, v222 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfEmployerUserGroup",
    "kind": "LinkedField",
    "name": "employerUserGroup",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsEmployerUserGroup",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v32,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isDefault",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAdminGroup",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PermissionSet",
            "kind": "LinkedField",
            "name": "permissionSet",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ResourcePermissions",
                "kind": "LinkedField",
                "name": "permissions",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "actions",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "resource",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v5 = {
    "kind": "InlineFragment",
    "selections": [
      v32,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerUserGroupCreateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v222,
          "concreteType": "AccountsEmployerUserGroupCreatePayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUserGroupCreate",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "UseEmployerUserGroupCreateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v222,
          "concreteType": "AccountsEmployerUserGroupCreatePayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUserGroupCreate",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "filters": null,
              "handle": "appendEdge",
              "key": "",
              "kind": "LinkedHandle",
              "name": "employerUserGroup",
              "handleArgs": [
                {
                  "kind": "Variable",
                  "name": "connections",
                  "variableName": "connections"
                }
              ]
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "9dbaa3256cba8e67a7d6288977e55ffe",
      "id": null,
      "metadata": {},
      "name": "UseEmployerUserGroupCreateMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerUserGroupCreateMutation(\n  $input: AccountsEmployerUserGroupCreateInput!\n) {\n  data: accountsEmployerUserGroupCreate(input: $input) {\n    employerUserGroup {\n      node {\n        id\n        code\n        updatedAt\n        createdAt\n        name\n        description\n        employerId\n        isDefault\n        isAdminGroup\n        permissionSet {\n          permissions {\n            actions\n            resource\n          }\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node152.hash = "acba05c81c5d068ecf745778a12ef875";
var node162 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v222 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfEmployerUserGroup",
    "kind": "LinkedField",
    "name": "employerUserGroup",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsEmployerUserGroup",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v222,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isDefault",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAdminGroup",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PermissionSet",
            "kind": "LinkedField",
            "name": "permissionSet",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ResourcePermissions",
                "kind": "LinkedField",
                "name": "permissions",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "actions",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "resource",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v222,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerUserGroupUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUserGroupUpdatePayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUserGroupUpdate",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerUserGroupUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUserGroupUpdatePayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUserGroupUpdate",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "75890fa9e7f22ded09c0f30235bb9ded",
      "id": null,
      "metadata": {},
      "name": "UseEmployerUserGroupUpdateMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerUserGroupUpdateMutation(\n  $input: AccountsEmployerUserGroupUpdateInput!\n) {\n  data: accountsEmployerUserGroupUpdate(input: $input) {\n    employerUserGroup {\n      node {\n        id\n        code\n        updatedAt\n        createdAt\n        name\n        description\n        employerId\n        isDefault\n        isAdminGroup\n        permissionSet {\n          permissions {\n            actions\n            resource\n          }\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node162.hash = "ea2ac3defaf27f8992a707c84f5fa363";
var node172 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v222 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "accountId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "emailAddress",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v8 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v10 = {
    "kind": "InlineFragment",
    "selections": [
      v9,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerUserUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUserUpdatePayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUserUpdate",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfEmployerUser",
              "kind": "LinkedField",
              "name": "employerUser",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsEmployerUser",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v222,
                    v32,
                    v4,
                    v5,
                    v6,
                    v7,
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "EmployerUserDetailsEditor_user"
                    },
                    v8
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v10
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerUserUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUserUpdatePayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUserUpdate",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfEmployerUser",
              "kind": "LinkedField",
              "name": "employerUser",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsEmployerUser",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v222,
                    v32,
                    v4,
                    v5,
                    v6,
                    v7,
                    v9,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isTest",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isDeleted",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountsEmployerUserGroup",
                      "kind": "LinkedField",
                      "name": "userGroups",
                      "plural": true,
                      "selections": [
                        v222,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "description",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isAdminGroup",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isDefault",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    v8
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v10
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "abeef04c344b2a9e96709a64bf473316",
      "id": null,
      "metadata": {},
      "name": "UseEmployerUserUpdateMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerUserUpdateMutation(\n  $input: AccountsEmployerUserUpdateInput!\n) {\n  data: accountsEmployerUserUpdate(input: $input) {\n    employerUser {\n      node {\n        id\n        accountId\n        firstName\n        lastName\n        emailAddress\n        updatedAt\n        ...EmployerUserDetailsEditor_user\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n\nfragment EmployerUserDetailsEditor_user on AccountsEmployerUser {\n  id\n  code\n  accountId\n  employerId\n  firstName\n  lastName\n  emailAddress\n  updatedAt\n  createdAt\n  isTest\n  isDeleted\n  userGroups {\n    id\n    name\n    description\n    isAdminGroup\n    isDefault\n  }\n}\n"
    }
  };
}();
node172.hash = "56fe10d213c3d70a49a543ee6f6f605e";
var node182 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v222 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "accountId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "emailAddress",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v8 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v10 = {
    "kind": "InlineFragment",
    "selections": [
      v9,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerUserJoinGroupMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUserJoinGroupPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUserJoinGroup",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfEmployerUser",
              "kind": "LinkedField",
              "name": "employerUser",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsEmployerUser",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v222,
                    v32,
                    v4,
                    v5,
                    v6,
                    v7,
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "EmployerUserDetailsEditor_user"
                    },
                    v8
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v10
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerUserJoinGroupMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUserJoinGroupPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUserJoinGroup",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfEmployerUser",
              "kind": "LinkedField",
              "name": "employerUser",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsEmployerUser",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v222,
                    v32,
                    v4,
                    v5,
                    v6,
                    v7,
                    v9,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isTest",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isDeleted",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountsEmployerUserGroup",
                      "kind": "LinkedField",
                      "name": "userGroups",
                      "plural": true,
                      "selections": [
                        v222,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "description",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isAdminGroup",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isDefault",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    v8
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v10
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "77c569981d5983a55d091d573763ce88",
      "id": null,
      "metadata": {},
      "name": "UseEmployerUserJoinGroupMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerUserJoinGroupMutation(\n  $input: AccountsEmployerUserJoinGroupInput!\n) {\n  data: accountsEmployerUserJoinGroup(input: $input) {\n    employerUser {\n      node {\n        id\n        accountId\n        firstName\n        lastName\n        emailAddress\n        updatedAt\n        ...EmployerUserDetailsEditor_user\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n\nfragment EmployerUserDetailsEditor_user on AccountsEmployerUser {\n  id\n  code\n  accountId\n  employerId\n  firstName\n  lastName\n  emailAddress\n  updatedAt\n  createdAt\n  isTest\n  isDeleted\n  userGroups {\n    id\n    name\n    description\n    isAdminGroup\n    isDefault\n  }\n}\n"
    }
  };
}();
node182.hash = "b6507bbc63ddc866fbcb113cb6af8085";
var node192 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v222 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "accountId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "emailAddress",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v8 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v10 = {
    "kind": "InlineFragment",
    "selections": [
      v9,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerUserLeaveGroupMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUserLeaveGroupPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUserLeaveGroup",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfEmployerUser",
              "kind": "LinkedField",
              "name": "employerUser",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsEmployerUser",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v222,
                    v32,
                    v4,
                    v5,
                    v6,
                    v7,
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "EmployerUserDetailsEditor_user"
                    },
                    v8
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v10
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerUserLeaveGroupMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUserLeaveGroupPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUserLeaveGroup",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfEmployerUser",
              "kind": "LinkedField",
              "name": "employerUser",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsEmployerUser",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v222,
                    v32,
                    v4,
                    v5,
                    v6,
                    v7,
                    v9,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isTest",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isDeleted",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountsEmployerUserGroup",
                      "kind": "LinkedField",
                      "name": "userGroups",
                      "plural": true,
                      "selections": [
                        v222,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "description",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isAdminGroup",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isDefault",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    v8
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v10
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "20a43fc1823b91129ae06b74eb5b71b8",
      "id": null,
      "metadata": {},
      "name": "UseEmployerUserLeaveGroupMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerUserLeaveGroupMutation(\n  $input: AccountsEmployerUserLeaveGroupInput!\n) {\n  data: accountsEmployerUserLeaveGroup(input: $input) {\n    employerUser {\n      node {\n        id\n        accountId\n        firstName\n        lastName\n        emailAddress\n        updatedAt\n        ...EmployerUserDetailsEditor_user\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n\nfragment EmployerUserDetailsEditor_user on AccountsEmployerUser {\n  id\n  code\n  accountId\n  employerId\n  firstName\n  lastName\n  emailAddress\n  updatedAt\n  createdAt\n  isTest\n  isDeleted\n  userGroups {\n    id\n    name\n    description\n    isAdminGroup\n    isDefault\n  }\n}\n"
    }
  };
}();
node192.hash = "fcf19a3cf40b56013434fe28996a00f9";
var node202 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v222 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfEmployerUser",
    "kind": "LinkedField",
    "name": "employerUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsEmployerUser",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v222,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailAddress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v222,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerUserPasswordUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUserChangePasswordPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUserChangePassword",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerUserPasswordUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUserChangePasswordPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUserChangePassword",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "a50c493c446f7854c2cec60645d548db",
      "id": null,
      "metadata": {},
      "name": "UseEmployerUserPasswordUpdateMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerUserPasswordUpdateMutation(\n  $input: AccountsEmployerUserChangePasswordInput!\n) {\n  data: accountsEmployerUserChangePassword(input: $input) {\n    employerUser {\n      node {\n        id\n        code\n        accountId\n        employerId\n        emailAddress\n        updatedAt\n        createdAt\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node202.hash = "37e33008b2e5f5a31298f95097f59818";
var node212 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v222 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfOfficeLocation",
    "kind": "LinkedField",
    "name": "employer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "EmployerOfficeLocation",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          v222,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "OfficeLocationAddress",
            "kind": "LinkedField",
            "name": "address",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "line1",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "line2",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "city",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "county",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "country",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "postCode",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v222,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerLocationCreateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerOfficeAddLocationPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerOfficeAddLocation",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerLocationCreateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerOfficeAddLocationPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerOfficeAddLocation",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "fedbd9c0c00b887ee75965f682842d1f",
      "id": null,
      "metadata": {},
      "name": "UseEmployerLocationCreateMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerLocationCreateMutation(\n  $input: AccountsEmployerOfficeAddLocationInput!\n) {\n  data: accountsEmployerOfficeAddLocation(input: $input) {\n    employer {\n      node {\n        id\n        name\n        code\n        updatedAt\n        createdAt\n        address {\n          line1\n          line2\n          city\n          county\n          country\n          postCode\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node212.hash = "c50bf28acaf2fab1369292cda3bb03d3";
var node222 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v222 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfOfficeLocation",
    "kind": "LinkedField",
    "name": "employer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "EmployerOfficeLocation",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          v222,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "OfficeLocationAddress",
            "kind": "LinkedField",
            "name": "address",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "line1",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "line2",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "city",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "county",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "country",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "postCode",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v222,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerLocationUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerOfficeUpdateLocationPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerOfficeUpdateLocation",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerLocationUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerOfficeUpdateLocationPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerOfficeUpdateLocation",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "fc5bc9462d41046c73d9eb9b4d79daa3",
      "id": null,
      "metadata": {},
      "name": "UseEmployerLocationUpdateMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerLocationUpdateMutation(\n  $input: AccountsEmployerOfficeUpdateLocationInput!\n) {\n  data: accountsEmployerOfficeUpdateLocation(input: $input) {\n    employer {\n      node {\n        id\n        name\n        code\n        updatedAt\n        createdAt\n        address {\n          line1\n          line2\n          city\n          county\n          country\n          postCode\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node222.hash = "e1b6b608c10589b4e16dcd066ca436e5";
var node232 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v222 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfEmployer",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Employer",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v32 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerNameUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUpdateNamePayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUpdateName",
          "plural": false,
          "selections": [
            v222,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerNameUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUpdateNamePayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUpdateName",
          "plural": false,
          "selections": [
            v222,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "e431eb7fda9d88da70b53c1f461d46d6",
      "id": null,
      "metadata": {},
      "name": "UseEmployerNameUpdateMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerNameUpdateMutation(\n  $input: AccountsEmployerUpdateNameInput!\n) {\n  data: accountsEmployerUpdateName(input: $input) {\n    payload {\n      node {\n        id\n        employerId\n        name\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node232.hash = "d478483a5397c544033137ecf3bc27f5";
var EmployerAccountsErrorCodes = class {
};
EmployerAccountsErrorCodes.USER_EMAIL_IS_IN_USE = "ACCOUNTS_EMPLOYER_USER_EMAIL_IS_IN_USE";
var node242 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "name": "ASC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerSearchBoxInputQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EmployerSearchBox_employers"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerSearchBoxInputQuery",
      "selections": [
        {
          "alias": "list",
          "args": v1,
          "concreteType": "AccountsEmployersConnection",
          "kind": "LinkedField",
          "name": "accountsEmployers",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsEmployersEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Employer",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "entityId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "slug",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "webSite",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v1,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "EmployerSearchBox_list",
          "kind": "LinkedHandle",
          "name": "accountsEmployers"
        }
      ]
    },
    "params": {
      "cacheID": "b62c77212cb78086d3cad11b82c0717d",
      "id": null,
      "metadata": {},
      "name": "EmployerSearchBoxInputQuery",
      "operationKind": "query",
      "text": "query EmployerSearchBoxInputQuery(\n  $where: EmployerFilter!\n) {\n  ...EmployerSearchBox_employers\n}\n\nfragment EmployerRow_account on Employer {\n  id\n  name\n  slug\n  webSite\n}\n\nfragment EmployerSearchBox_employers on Query {\n  list: accountsEmployers(first: 10, order: [{name: ASC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        entityId\n        code\n        employerId\n        name\n        slug\n        webSite\n        ...EmployerRow_account\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node242.hash = "fb9ef5f7c3109de78caa1b3dfdf506cf";
var node252 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v222 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v32 = [
    v1,
    v222,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "name": "ASC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerSearchBoxPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v222
          ],
          "kind": "FragmentSpread",
          "name": "EmployerSearchBox_employers"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerSearchBoxPaginationQuery",
      "selections": [
        {
          "alias": "list",
          "args": v32,
          "concreteType": "AccountsEmployersConnection",
          "kind": "LinkedField",
          "name": "accountsEmployers",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsEmployersEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Employer",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "entityId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "slug",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "webSite",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v32,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "EmployerSearchBox_list",
          "kind": "LinkedHandle",
          "name": "accountsEmployers"
        }
      ]
    },
    "params": {
      "cacheID": "2915028a33170e5fe188fd7f763cf4d8",
      "id": null,
      "metadata": {},
      "name": "EmployerSearchBoxPaginationQuery",
      "operationKind": "query",
      "text": "query EmployerSearchBoxPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $where: EmployerFilter\n) {\n  ...EmployerSearchBox_employers_2HEEH6\n}\n\nfragment EmployerRow_account on Employer {\n  id\n  name\n  slug\n  webSite\n}\n\nfragment EmployerSearchBox_employers_2HEEH6 on Query {\n  list: accountsEmployers(first: $first, after: $after, order: [{name: ASC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        entityId\n        code\n        employerId\n        name\n        slug\n        webSite\n        ...EmployerRow_account\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node252.hash = "16ff3350b81fd694b85a02e25c4e0695";
var EmployerSearchBoxPaginationQuery_graphql_default = node252;
var node262 = function() {
  var v0 = [
    "list"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": EmployerSearchBoxPaginationQuery_graphql_default
      }
    },
    "name": "EmployerSearchBox_employers",
    "selections": [
      {
        "alias": "list",
        "args": [
          {
            "kind": "Literal",
            "name": "order",
            "value": [
              {
                "name": "ASC"
              }
            ]
          },
          {
            "kind": "Variable",
            "name": "where",
            "variableName": "where"
          }
        ],
        "concreteType": "AccountsEmployersConnection",
        "kind": "LinkedField",
        "name": "__EmployerSearchBox_list_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountsEmployersEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Employer",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "entityId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "employerId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "slug",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "webSite",
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "EmployerRow_account"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node262.hash = "16ff3350b81fd694b85a02e25c4e0695";
var EmployerSearchBox_employers_graphql_default = node262;
var fragment4 = EmployerSearchBox_employers_graphql_default;
var EmployerSearchBox = ({
  onSelected,
  employers,
  defaultValue,
  showLabel
}) => {
  const [selected, setSelected] = useState31(
    defaultValue ?? null
  );
  const [searchTerm, setSearchTerm] = useState31("");
  const onQueryChangeHandler = useMemo16(
    () => debounce3((q4) => setSearchTerm(q4), 500),
    []
  );
  useEffect12(() => {
    return () => {
      onQueryChangeHandler.cancel();
    };
  }, []);
  const onSetSelected = useCallback51(
    (r4) => {
      setSelected(r4);
      onSelected(r4);
    },
    [selected]
  );
  const { data, refetch } = usePaginationFragment7(fragment4, employers);
  const where = { isDeleted: { eq: false } };
  if (searchTerm) {
    where.and = [
      { name: { startsWith: searchTerm } },
      { isDeleted: { eq: false } }
    ];
  } else {
    where.and = [{ isDeleted: { eq: false } }];
  }
  useEffect12(() => {
    refetch({ first: 10, where }, { fetchPolicy: "store-or-network" });
  }, [searchTerm]);
  const { list: list2 } = data;
  const rows = (list2?.edges ?? []).map((edge) => edge.node);
  return /* @__PURE__ */ jsxs59(Combobox5, { as: "div", value: selected, onChange: onSetSelected, children: [
    showLabel && /* @__PURE__ */ jsx91(Combobox5.Label, { className: "block text-sm font-medium text-gray-700", children: "Employer" }),
    /* @__PURE__ */ jsxs59("div", { className: "relative", children: [
      /* @__PURE__ */ jsx91(
        Combobox5.Input,
        {
          className: "focus:border-info-500 focus:ring-info-500 w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:outline-none focus:ring-1 sm:text-sm",
          onChange: (event) => onQueryChangeHandler(event.target.value),
          displayValue: (result) => {
            if (result) {
              return result.name;
            }
            return "";
          },
          autoComplete: "off"
        }
      ),
      /* @__PURE__ */ jsx91(Combobox5.Button, { className: "absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none", children: /* @__PURE__ */ jsx91(
        ChevronUpDownIcon3,
        {
          className: "h-5 w-5 text-gray-400",
          "aria-hidden": "true"
        }
      ) }),
      rows.length > 0 && /* @__PURE__ */ jsx91(Combobox5.Options, { className: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm", children: rows.map((result) => /* @__PURE__ */ jsx91(
        Combobox5.Option,
        {
          value: result,
          className: ({ active }) => classNames8(
            "relative cursor-default select-none py-2 pl-3 pr-9",
            active ? "bg-info-600 text-white" : "text-gray-900"
          ),
          children: ({ active, selected: selected2 }) => /* @__PURE__ */ jsxs59(Fragment22, { children: [
            /* @__PURE__ */ jsx91("div", { className: "flex", children: /* @__PURE__ */ jsx91(
              "span",
              {
                className: classNames8(
                  "truncate",
                  selected2 ? "font-semibold" : ""
                ),
                children: result.name
              }
            ) }),
            selected2 && /* @__PURE__ */ jsx91(
              "span",
              {
                className: classNames8(
                  "absolute inset-y-0 right-0 flex items-center pr-4",
                  active ? "bg-info-600 text-white" : "text-info-600"
                ),
                children: /* @__PURE__ */ jsx91(CheckIcon3, { className: "h-5 w-5", "aria-hidden": "true" })
              }
            )
          ] })
        },
        result.id
      )) })
    ] })
  ] });
};
var formSchema4 = zod3.object({
  account: zod3.object({
    employerId: zod3.string(),
    name: zod3.string()
  }).optional().nullable(),
  identity: zod3.object({
    identityUserId: zod3.string(),
    email: zod3.string()
  }).optional().nullable(),
  name: zod3.string().min(3, { message: "Employer name is required" }),
  adminFirstName: zod3.string().min(1, { message: "Firstname is required" }),
  adminLastName: zod3.string().min(1, { message: "Lastname is required" }),
  adminUserEmail: zod3.string().min(1, { message: "Email is required" }).email({
    message: "Must be a valid email"
  }),
  notes: zod3.string().nullable(),
  isTest: zod3.boolean(),
  useExistingAccount: zod3.boolean(),
  useExistingIdentity: zod3.boolean()
});
var node272 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "id"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "id"
    }
  ], v222 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerDetailsQuery",
      "selections": [
        {
          "alias": "employer",
          "args": v1,
          "concreteType": "Employer",
          "kind": "LinkedField",
          "name": "accountsEmployerById",
          "plural": false,
          "selections": [
            v222,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "EmployerDetailsViewFragment"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "EmployerDetailsEditFragment"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "EmployerLogoUploadFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerDetailsQuery",
      "selections": [
        {
          "alias": "employer",
          "args": v1,
          "concreteType": "Employer",
          "kind": "LinkedField",
          "name": "accountsEmployerById",
          "plural": false,
          "selections": [
            v222,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "logoUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "details",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "industry",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "webSite",
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "c26d752d3692f9b1e94d27d73bae92d4",
      "id": null,
      "metadata": {},
      "name": "EmployerDetailsQuery",
      "operationKind": "query",
      "text": "query EmployerDetailsQuery(\n  $id: UUID!\n) {\n  employer: accountsEmployerById(id: $id) {\n    id\n    ...EmployerDetailsViewFragment\n    ...EmployerDetailsEditFragment\n    ...EmployerLogoUploadFragment\n  }\n}\n\nfragment EmployerDetailsEditFragment on Employer {\n  name\n  logoUrl\n  details\n  industry\n  webSite\n}\n\nfragment EmployerDetailsViewFragment on Employer {\n  id\n  name\n  logoUrl\n  details\n  industry\n  webSite\n}\n\nfragment EmployerLogoUploadFragment on Employer {\n  id\n  name\n  logoUrl\n  details\n  industry\n  webSite\n}\n"
    }
  };
}();
node272.hash = "ada224dad184f1d4c49ee3e51f4cf441";
var node282 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmployerDetailsEditFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "logoUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "details",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "industry",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "webSite",
      "storageKey": null
    }
  ],
  "type": "Employer",
  "abstractKey": null
};
node282.hash = "c36376f062ed27f69cab26d963732f47";
var node292 = function() {
  var v0 = [
    {
      "alias": null,
      "args": null,
      "concreteType": "Industry",
      "kind": "LinkedField",
      "name": "industriesAll",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": [],
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerDetailsEditIndustriesAllQuery",
      "selections": v0,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [],
      "kind": "Operation",
      "name": "EmployerDetailsEditIndustriesAllQuery",
      "selections": v0
    },
    "params": {
      "cacheID": "10f66389aca005959f7704930143335b",
      "id": null,
      "metadata": {},
      "name": "EmployerDetailsEditIndustriesAllQuery",
      "operationKind": "query",
      "text": "query EmployerDetailsEditIndustriesAllQuery {\n  industriesAll {\n    id\n    name\n  }\n}\n"
    }
  };
}();
node292.hash = "71c9a3cf5e6436f1261fa73f78c39bf1";
var node302 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v222 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfEmployer",
    "kind": "LinkedField",
    "name": "employer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Employer",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "logoUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "details",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "industry",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "webSite",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v32 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerDetailsUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUpdateDetailsPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUpdateDetails",
          "plural": false,
          "selections": [
            v222,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerDetailsUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "AccountsEmployerUpdateDetailsPayload",
          "kind": "LinkedField",
          "name": "accountsEmployerUpdateDetails",
          "plural": false,
          "selections": [
            v222,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "0f243e5b24bdf9c041cb3c23109a60c8",
      "id": null,
      "metadata": {},
      "name": "UseEmployerDetailsUpdateMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerDetailsUpdateMutation(\n  $input: AccountsEmployerUpdateDetailsInput!\n) {\n  data: accountsEmployerUpdateDetails(input: $input) {\n    employer {\n      node {\n        id\n        name\n        logoUrl\n        details\n        industry\n        webSite\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node302.hash = "9b67f1c9c30557c9fa2c8d5a715dce64";
var formSchema22 = zod22.object({
  name: zod22.string().min(1, "name is required"),
  webSite: zod22.string().url(),
  industry: zod22.string(),
  details: zod22.string(),
  logoUrl: zod22.string()
});
var node312 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmployerDetailsViewFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "logoUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "details",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "industry",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "webSite",
      "storageKey": null
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__id",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Employer",
  "abstractKey": null
};
node312.hash = "208deb7e4f719099c91efa52c46a4c52";
var node322 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmployerLogoUploadFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "logoUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "details",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "industry",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "webSite",
      "storageKey": null
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__id",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Employer",
  "abstractKey": null
};
node322.hash = "5bfa614db7843d0448f50db3766ec256";
function _classPrivateFieldLooseBase11(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id13 = 0;
function _classPrivateFieldLooseKey11(name) {
  return "__private_" + id13++ + "_" + name;
}
function insertReplacement(source, rx, replacement) {
  const newParts = [];
  source.forEach((chunk) => {
    if (typeof chunk !== "string") {
      return newParts.push(chunk);
    }
    return rx[Symbol.split](chunk).forEach((raw, i4, list2) => {
      if (raw !== "") {
        newParts.push(raw);
      }
      if (i4 < list2.length - 1) {
        newParts.push(replacement);
      }
    });
  });
  return newParts;
}
function interpolate2(phrase, options7) {
  const dollarRegex = /\$/g;
  const dollarBillsYall = "$$$$";
  let interpolated = [phrase];
  if (options7 == null)
    return interpolated;
  for (const arg of Object.keys(options7)) {
    if (arg !== "_") {
      let replacement = options7[arg];
      if (typeof replacement === "string") {
        replacement = dollarRegex[Symbol.replace](replacement, dollarBillsYall);
      }
      interpolated = insertReplacement(interpolated, new RegExp(`%\\{${arg}\\}`, "g"), replacement);
    }
  }
  return interpolated;
}
var defaultOnMissingKey = (key) => {
  throw new Error(`missing string: ${key}`);
};
var _onMissingKey = /* @__PURE__ */ _classPrivateFieldLooseKey11("onMissingKey");
var _apply = /* @__PURE__ */ _classPrivateFieldLooseKey11("apply");
var Translator = class {
  constructor(locales, _temp) {
    let {
      onMissingKey = defaultOnMissingKey
    } = _temp === void 0 ? {} : _temp;
    Object.defineProperty(this, _apply, {
      value: _apply2
    });
    Object.defineProperty(this, _onMissingKey, {
      writable: true,
      value: void 0
    });
    this.locale = {
      strings: {},
      pluralize(n3) {
        if (n3 === 1) {
          return 0;
        }
        return 1;
      }
    };
    if (Array.isArray(locales)) {
      locales.forEach(_classPrivateFieldLooseBase11(this, _apply)[_apply], this);
    } else {
      _classPrivateFieldLooseBase11(this, _apply)[_apply](locales);
    }
    _classPrivateFieldLooseBase11(this, _onMissingKey)[_onMissingKey] = onMissingKey;
  }
  /**
   * Public translate method
   *
   * @param key
   * @param options with values that will be used later to replace placeholders in string
   * @returns string translated (and interpolated)
   */
  translate(key, options7) {
    return this.translateArray(key, options7).join("");
  }
  /**
   * Get a translation and return the translated and interpolated parts as an array.
   *
   * @returns The translated and interpolated parts, in order.
   */
  translateArray(key, options7) {
    let string102 = this.locale.strings[key];
    if (string102 == null) {
      _classPrivateFieldLooseBase11(this, _onMissingKey)[_onMissingKey](key);
      string102 = key;
    }
    const hasPluralForms = typeof string102 === "object";
    if (hasPluralForms) {
      if (options7 && typeof options7.smart_count !== "undefined") {
        const plural = this.locale.pluralize(options7.smart_count);
        return interpolate2(string102[plural], options7);
      }
      throw new Error("Attempted to use a string with plural forms, but no value was given for %{smart_count}");
    }
    if (typeof string102 !== "string") {
      throw new Error(`string was not a string`);
    }
    return interpolate2(string102, options7);
  }
};
function _apply2(locale22) {
  if (!(locale22 != null && locale22.strings)) {
    return;
  }
  const prevLocale = this.locale;
  Object.assign(this.locale, {
    strings: {
      ...prevLocale.strings,
      ...locale22.strings
    },
    pluralize: locale22.pluralize || prevLocale.pluralize
  });
}
var BasePlugin3 = class {
  constructor(uppy22, opts) {
    this.uppy = uppy22;
    this.opts = opts != null ? opts : {};
  }
  getPluginState() {
    const {
      plugins: plugins22
    } = this.uppy.getState();
    return (plugins22 == null ? void 0 : plugins22[this.id]) || {};
  }
  setPluginState(update) {
    if (!update)
      return;
    const {
      plugins: plugins22
    } = this.uppy.getState();
    this.uppy.setState({
      plugins: {
        ...plugins22,
        [this.id]: {
          ...plugins22[this.id],
          ...update
        }
      }
    });
  }
  setOptions(newOpts) {
    this.opts = {
      ...this.opts,
      ...newOpts
    };
    this.setPluginState(void 0);
    this.i18nInit();
  }
  i18nInit() {
    const translator = new Translator([this.defaultLocale, this.uppy.locale, this.opts.locale]);
    this.i18n = translator.translate.bind(translator);
    this.i18nArray = translator.translateArray.bind(translator);
    this.setPluginState(void 0);
  }
  /**
   * Extendable methods
   * ==================
   * These methods are here to serve as an overview of the extendable methods as well as
   * making them not conditional in use, such as `if (this.afterUpdate)`.
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  addTarget(plugin) {
    throw new Error("Extend the addTarget method to add your plugin to another plugin's target");
  }
  install() {
  }
  uninstall() {
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  update(state) {
  }
  // Called after every state update, after everything's mounted. Debounced.
  afterUpdate() {
  }
};
var UserFacingApiError2 = class extends Error {
  constructor() {
    super(...arguments);
    this.name = "UserFacingApiError";
  }
};
var UserFacingApiError_default2 = UserFacingApiError2;
var import_retry2 = __toESM2(require_retry22(), 1);
var objectToString2 = Object.prototype.toString;
var isError2 = (value) => objectToString2.call(value) === "[object Error]";
var errorMessages2 = /* @__PURE__ */ new Set([
  "network error",
  // Chrome
  "Failed to fetch",
  // Chrome
  "NetworkError when attempting to fetch resource.",
  // Firefox
  "The Internet connection appears to be offline.",
  // Safari 16
  "Load failed",
  // Safari 17+
  "Network request failed",
  // `cross-fetch`
  "fetch failed"
  // Undici (Node.js)
]);
function isNetworkError3(error) {
  const isValid = error && isError2(error) && error.name === "TypeError" && typeof error.message === "string";
  if (!isValid) {
    return false;
  }
  if (error.message === "Load failed") {
    return error.stack === void 0;
  }
  return errorMessages2.has(error.message);
}
var AbortError2 = class extends Error {
  constructor(message) {
    super();
    if (message instanceof Error) {
      this.originalError = message;
      ({ message } = message);
    } else {
      this.originalError = new Error(message);
      this.originalError.stack = this.stack;
    }
    this.name = "AbortError";
    this.message = message;
  }
};
var decorateErrorWithCounts2 = (error, attemptNumber, options7) => {
  const retriesLeft = options7.retries - (attemptNumber - 1);
  error.attemptNumber = attemptNumber;
  error.retriesLeft = retriesLeft;
  return error;
};
async function pRetry2(input, options7) {
  return new Promise((resolve, reject) => {
    options7 = {
      onFailedAttempt() {
      },
      retries: 10,
      shouldRetry: () => true,
      ...options7
    };
    const operation = import_retry2.default.operation(options7);
    const abortHandler = () => {
      operation.stop();
      reject(options7.signal?.reason);
    };
    if (options7.signal && !options7.signal.aborted) {
      options7.signal.addEventListener("abort", abortHandler, { once: true });
    }
    const cleanUp = () => {
      options7.signal?.removeEventListener("abort", abortHandler);
      operation.stop();
    };
    operation.attempt(async (attemptNumber) => {
      try {
        const result = await input(attemptNumber);
        cleanUp();
        resolve(result);
      } catch (error) {
        try {
          if (!(error instanceof Error)) {
            throw new TypeError(`Non-error was thrown: "${error}". You should only throw errors.`);
          }
          if (error instanceof AbortError2) {
            throw error.originalError;
          }
          if (error instanceof TypeError && !isNetworkError3(error)) {
            throw error;
          }
          decorateErrorWithCounts2(error, attemptNumber, options7);
          if (!await options7.shouldRetry(error)) {
            operation.stop();
            reject(error);
          }
          await options7.onFailedAttempt(error);
          if (!operation.retry(error)) {
            throw operation.mainError();
          }
        } catch (finalError) {
          decorateErrorWithCounts2(finalError, attemptNumber, options7);
          cleanUp();
          reject(finalError);
        }
      }
    });
  });
}
var NetworkError2 = class extends Error {
  constructor(error, xhr) {
    if (xhr === void 0) {
      xhr = null;
    }
    super(`This looks like a network error, the endpoint might be blocked by an internet provider or a firewall.`);
    this.cause = error;
    this.isNetworkError = true;
    this.request = xhr;
  }
};
var NetworkError_default2 = NetworkError2;
function fetchWithNetworkError2() {
  return fetch(...arguments).catch((err) => {
    if (err.name === "AbortError") {
      throw err;
    } else {
      throw new NetworkError_default2(err);
    }
  });
}
function has2(object102, key) {
  return Object.prototype.hasOwnProperty.call(object102, key);
}
var ErrorWithCause2 = class extends Error {
  constructor(message, options7) {
    super(message);
    this.cause = options7 == null ? void 0 : options7.cause;
    if (this.cause && has2(this.cause, "isNetworkError")) {
      this.isNetworkError = this.cause.isNetworkError;
    } else {
      this.isNetworkError = false;
    }
  }
};
var ErrorWithCause_default2 = ErrorWithCause2;
var import_throttle2 = __toESM2(require_throttle2(), 1);
function emitSocketProgress2(uploader, progressData, file) {
  const {
    progress: progress2,
    bytesUploaded,
    bytesTotal
  } = progressData;
  if (progress2) {
    uploader.uppy.log(`Upload progress: ${progress2}`);
    uploader.uppy.emit("upload-progress", file, {
      // @ts-expect-error todo remove in next major
      uploader,
      bytesUploaded,
      bytesTotal
    });
  }
}
var emitSocketProgress_default2 = (0, import_throttle2.default)(emitSocketProgress2, 300, {
  leading: true,
  trailing: true
});
function getSocketHost2(url) {
  var _regex$exec;
  const regex = /^(?:https?:\/\/|\/\/)?(?:[^@\n]+@)?(?:www\.)?([^\n]+)/i;
  const host = (_regex$exec = regex.exec(url)) == null ? void 0 : _regex$exec[1];
  const socketProtocol = /^http:\/\//i.test(url) ? "ws" : "wss";
  return `${socketProtocol}://${host}`;
}
var AuthError2 = class extends Error {
  constructor() {
    super("Authorization required");
    this.name = "AuthError";
    this.isAuthError = true;
  }
};
var AuthError_default2 = AuthError2;
var _Symbol$for5;
function _classPrivateFieldLooseBase22(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id22 = 0;
function _classPrivateFieldLooseKey22(name) {
  return "__private_" + id22++ + "_" + name;
}
var packageJson8 = {
  "version": "3.7.4"
};
function stripSlash2(url) {
  return url.replace(/\/$/, "");
}
var retryCount2 = 10;
var socketActivityTimeoutMs2 = 5 * 60 * 1e3;
var authErrorStatusCode2 = 401;
var HttpError2 = class extends Error {
  constructor(_ref) {
    let {
      statusCode,
      message
    } = _ref;
    super(message);
    this.name = "HttpError";
    this.statusCode = statusCode;
  }
};
async function handleJSONResponse2(res) {
  if (res.status === authErrorStatusCode2) {
    throw new AuthError_default2();
  }
  if (res.ok) {
    return res.json();
  }
  let errMsg = `Failed request with status: ${res.status}. ${res.statusText}`;
  let errData;
  try {
    errData = await res.json();
    if (errData.message)
      errMsg = `${errMsg} message: ${errData.message}`;
    if (errData.requestId)
      errMsg = `${errMsg} request-Id: ${errData.requestId}`;
  } catch (cause) {
    throw new Error(errMsg, {
      cause
    });
  }
  if (res.status >= 400 && res.status <= 499 && errData.message) {
    throw new UserFacingApiError_default2(errData.message);
  }
  throw new HttpError2({
    statusCode: res.status,
    message: errMsg
  });
}
var _companionHeaders2 = /* @__PURE__ */ _classPrivateFieldLooseKey22("companionHeaders");
var _getUrl3 = /* @__PURE__ */ _classPrivateFieldLooseKey22("getUrl");
var _requestSocketToken2 = /* @__PURE__ */ _classPrivateFieldLooseKey22("requestSocketToken");
var _awaitRemoteFileUpload3 = /* @__PURE__ */ _classPrivateFieldLooseKey22("awaitRemoteFileUpload");
_Symbol$for5 = Symbol.for("uppy test: getCompanionHeaders");
var RequestClient2 = class {
  constructor(uppy22, opts) {
    Object.defineProperty(this, _awaitRemoteFileUpload3, {
      value: _awaitRemoteFileUpload22
    });
    Object.defineProperty(this, _getUrl3, {
      value: _getUrl22
    });
    Object.defineProperty(this, _companionHeaders2, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _requestSocketToken2, {
      writable: true,
      value: async (_ref2) => {
        var _file$remote;
        let {
          file,
          postBody,
          signal
        } = _ref2;
        if (((_file$remote = file.remote) == null ? void 0 : _file$remote.url) == null) {
          throw new Error("Cannot connect to an undefined URL");
        }
        const res = await this.post(file.remote.url, {
          ...file.remote.body,
          ...postBody
        }, {
          signal
        });
        return res.token;
      }
    });
    this.uppy = uppy22;
    this.opts = opts;
    this.onReceiveResponse = this.onReceiveResponse.bind(this);
    _classPrivateFieldLooseBase22(this, _companionHeaders2)[_companionHeaders2] = opts == null ? void 0 : opts.companionHeaders;
  }
  setCompanionHeaders(headers) {
    _classPrivateFieldLooseBase22(this, _companionHeaders2)[_companionHeaders2] = headers;
  }
  [_Symbol$for5]() {
    return _classPrivateFieldLooseBase22(this, _companionHeaders2)[_companionHeaders2];
  }
  get hostname() {
    const {
      companion
    } = this.uppy.getState();
    const host = this.opts.companionUrl;
    return stripSlash2(companion && companion[host] ? companion[host] : host);
  }
  async headers(emptyBody) {
    if (emptyBody === void 0) {
      emptyBody = false;
    }
    const defaultHeaders = {
      Accept: "application/json",
      ...emptyBody ? void 0 : {
        // Passing those headers on requests with no data forces browsers to first make a preflight request.
        "Content-Type": "application/json"
      }
    };
    return {
      ...defaultHeaders,
      ..._classPrivateFieldLooseBase22(this, _companionHeaders2)[_companionHeaders2]
    };
  }
  onReceiveResponse(res) {
    const {
      headers
    } = res;
    const state = this.uppy.getState();
    const companion = state.companion || {};
    const host = this.opts.companionUrl;
    if (headers.has("i-am") && headers.get("i-am") !== companion[host]) {
      this.uppy.setState({
        companion: {
          ...companion,
          [host]: headers.get("i-am")
        }
      });
    }
  }
  async request(_ref3) {
    let {
      path,
      method = "GET",
      data,
      skipPostResponse,
      signal
    } = _ref3;
    try {
      const headers = await this.headers(!data);
      const response = await fetchWithNetworkError2(_classPrivateFieldLooseBase22(this, _getUrl3)[_getUrl3](path), {
        method,
        signal,
        headers,
        credentials: this.opts.companionCookiesRule || "same-origin",
        body: data ? JSON.stringify(data) : null
      });
      if (!skipPostResponse)
        this.onReceiveResponse(response);
      return await handleJSONResponse2(response);
    } catch (err) {
      if (err.isAuthError || err.name === "UserFacingApiError" || err.name === "AbortError")
        throw err;
      throw new ErrorWithCause_default2(`Could not ${method} ${_classPrivateFieldLooseBase22(this, _getUrl3)[_getUrl3](path)}`, {
        cause: err
      });
    }
  }
  async get(path, options7) {
    if (typeof options7 === "boolean")
      options7 = {
        skipPostResponse: options7
      };
    return this.request({
      ...options7,
      path
    });
  }
  async post(path, data, options7) {
    if (typeof options7 === "boolean")
      options7 = {
        skipPostResponse: options7
      };
    return this.request({
      ...options7,
      path,
      method: "POST",
      data
    });
  }
  async delete(path, data, options7) {
    if (typeof options7 === "boolean")
      options7 = {
        skipPostResponse: options7
      };
    return this.request({
      ...options7,
      path,
      method: "DELETE",
      data
    });
  }
  /**
   * Remote uploading consists of two steps:
   * 1. #requestSocketToken which starts the download/upload in companion and returns a unique token for the upload.
   * Then companion will halt the upload until:
   * 2. #awaitRemoteFileUpload is called, which will open/ensure a websocket connection towards companion, with the
   * previously generated token provided. It returns a promise that will resolve/reject once the file has finished
   * uploading or is otherwise done (failed, canceled)
   */
  async uploadRemoteFile(file, reqBody, options7) {
    var _this = this;
    try {
      const {
        signal,
        getQueue
      } = options7 || {};
      return await pRetry2(async () => {
        var _this$uppy$getFile;
        const existingServerToken = (_this$uppy$getFile = this.uppy.getFile(file.id)) == null ? void 0 : _this$uppy$getFile.serverToken;
        if (existingServerToken != null) {
          this.uppy.log(`Connecting to exiting websocket ${existingServerToken}`);
          return _classPrivateFieldLooseBase22(this, _awaitRemoteFileUpload3)[_awaitRemoteFileUpload3]({
            file,
            queue: getQueue(),
            signal
          });
        }
        const queueRequestSocketToken = getQueue().wrapPromiseFunction(async function() {
          try {
            return await _classPrivateFieldLooseBase22(_this, _requestSocketToken2)[_requestSocketToken2](...arguments);
          } catch (outerErr) {
            if (outerErr.isAuthError)
              throw new AbortError2(outerErr);
            if (outerErr.cause == null)
              throw outerErr;
            const err = outerErr.cause;
            const isRetryableHttpError = () => [408, 409, 429, 418, 423].includes(err.statusCode) || err.statusCode >= 500 && err.statusCode <= 599 && ![501, 505].includes(err.statusCode);
            if (err.name === "HttpError" && !isRetryableHttpError())
              throw new AbortError2(err);
            throw err;
          }
        }, {
          priority: -1
        });
        const serverToken = await queueRequestSocketToken({
          file,
          postBody: reqBody,
          signal
        }).abortOn(signal);
        if (!this.uppy.getFile(file.id))
          return void 0;
        this.uppy.setFileState(file.id, {
          serverToken
        });
        return _classPrivateFieldLooseBase22(this, _awaitRemoteFileUpload3)[_awaitRemoteFileUpload3]({
          file: this.uppy.getFile(file.id),
          // re-fetching file because it might have changed in the meantime
          queue: getQueue(),
          signal
        });
      }, {
        retries: retryCount2,
        signal,
        onFailedAttempt: (err) => this.uppy.log(`Retrying upload due to: ${err.message}`, "warning")
      });
    } catch (err) {
      if (err.name === "AbortError") {
        return void 0;
      }
      this.uppy.emit("upload-error", file, err);
      throw err;
    }
  }
};
function _getUrl22(url) {
  if (/^(https?:|)\/\//.test(url)) {
    return url;
  }
  return `${this.hostname}/${url}`;
}
async function _awaitRemoteFileUpload22(_ref4) {
  let {
    file,
    queue,
    signal
  } = _ref4;
  let removeEventHandlers;
  const {
    capabilities
  } = this.uppy.getState();
  try {
    return await new Promise((resolve, reject) => {
      const token = file.serverToken;
      const host = getSocketHost2(file.remote.companionUrl);
      let socket;
      let socketAbortController;
      let activityTimeout;
      let {
        isPaused
      } = file;
      const socketSend = (action, payload) => {
        if (socket == null || socket.readyState !== socket.OPEN) {
          var _socket22;
          this.uppy.log(`Cannot send "${action}" to socket ${file.id} because the socket state was ${String((_socket22 = socket) == null ? void 0 : _socket22.readyState)}`, "warning");
          return;
        }
        socket.send(JSON.stringify({
          action,
          payload: payload != null ? payload : {}
        }));
      };
      function sendState() {
        if (!capabilities.resumableUploads)
          return;
        if (isPaused)
          socketSend("pause");
        else
          socketSend("resume");
      }
      const createWebsocket = async () => {
        if (socketAbortController)
          socketAbortController.abort();
        socketAbortController = new AbortController();
        const onFatalError = (err) => {
          var _socketAbortControlle;
          this.uppy.setFileState(file.id, {
            serverToken: null
          });
          (_socketAbortControlle = socketAbortController) == null || _socketAbortControlle.abort == null || _socketAbortControlle.abort();
          reject(err);
        };
        function resetActivityTimeout() {
          clearTimeout(activityTimeout);
          if (isPaused)
            return;
          activityTimeout = setTimeout(() => onFatalError(new Error("Timeout waiting for message from Companion socket")), socketActivityTimeoutMs2);
        }
        try {
          await queue.wrapPromiseFunction(async () => {
            const reconnectWebsocket = async () => (
              // eslint-disable-next-line promise/param-names
              new Promise((_4, rejectSocket) => {
                socket = new WebSocket(`${host}/api/${token}`);
                resetActivityTimeout();
                socket.addEventListener("close", () => {
                  socket = void 0;
                  rejectSocket(new Error("Socket closed unexpectedly"));
                });
                socket.addEventListener("error", (error) => {
                  var _socket22;
                  this.uppy.log(`Companion socket error ${JSON.stringify(error)}, closing socket`, "warning");
                  (_socket22 = socket) == null || _socket22.close();
                });
                socket.addEventListener("open", () => {
                  sendState();
                });
                socket.addEventListener("message", (e4) => {
                  resetActivityTimeout();
                  try {
                    const {
                      action,
                      payload
                    } = JSON.parse(e4.data);
                    switch (action) {
                      case "progress": {
                        emitSocketProgress_default2(this, payload, this.uppy.getFile(file.id));
                        break;
                      }
                      case "success": {
                        var _payload$response, _payload$response$sta, _payload$response2, _socketAbortControlle2;
                        const text = (_payload$response = payload.response) == null ? void 0 : _payload$response.responseText;
                        this.uppy.emit("upload-success", this.uppy.getFile(file.id), {
                          uploadURL: payload.url,
                          status: (_payload$response$sta = (_payload$response2 = payload.response) == null ? void 0 : _payload$response2.status) != null ? _payload$response$sta : 200,
                          body: text ? JSON.parse(text) : void 0
                        });
                        (_socketAbortControlle2 = socketAbortController) == null || _socketAbortControlle2.abort == null || _socketAbortControlle2.abort();
                        resolve();
                        break;
                      }
                      case "error": {
                        const {
                          message
                        } = payload.error;
                        throw Object.assign(new Error(message), {
                          cause: payload.error
                        });
                      }
                      default:
                        this.uppy.log(`Companion socket unknown action ${action}`, "warning");
                    }
                  } catch (err) {
                    onFatalError(err);
                  }
                });
                const closeSocket = () => {
                  this.uppy.log(`Closing socket ${file.id}`, "info");
                  clearTimeout(activityTimeout);
                  if (socket)
                    socket.close();
                  socket = void 0;
                };
                socketAbortController.signal.addEventListener("abort", () => {
                  closeSocket();
                });
              })
            );
            await pRetry2(reconnectWebsocket, {
              retries: retryCount2,
              signal: socketAbortController.signal,
              onFailedAttempt: () => {
                if (socketAbortController.signal.aborted)
                  return;
                this.uppy.log(`Retrying websocket ${file.id}`, "info");
              }
            });
          })().abortOn(socketAbortController.signal);
        } catch (err) {
          if (socketAbortController.signal.aborted)
            return;
          onFatalError(err);
        }
      };
      const pause = (newPausedState) => {
        if (!capabilities.resumableUploads)
          return;
        isPaused = newPausedState;
        if (socket)
          sendState();
        if (newPausedState) {
          var _socketAbortControlle3;
          (_socketAbortControlle3 = socketAbortController) == null || _socketAbortControlle3.abort == null || _socketAbortControlle3.abort();
        } else {
          createWebsocket();
        }
      };
      const onFileRemove = (targetFile) => {
        var _socketAbortControlle4;
        if (!capabilities.individualCancellation)
          return;
        if (targetFile.id !== file.id)
          return;
        socketSend("cancel");
        (_socketAbortControlle4 = socketAbortController) == null || _socketAbortControlle4.abort == null || _socketAbortControlle4.abort();
        this.uppy.log(`upload ${file.id} was removed`, "info");
        resolve();
      };
      const onCancelAll = (_ref5) => {
        var _socketAbortControlle5;
        let {
          reason
        } = _ref5;
        if (reason === "user") {
          socketSend("cancel");
        }
        (_socketAbortControlle5 = socketAbortController) == null || _socketAbortControlle5.abort == null || _socketAbortControlle5.abort();
        this.uppy.log(`upload ${file.id} was canceled`, "info");
        resolve();
      };
      const onFilePausedChange = (targetFileId, newPausedState) => {
        if (targetFileId !== file.id)
          return;
        pause(newPausedState);
      };
      const onPauseAll = () => pause(true);
      const onResumeAll = () => pause(false);
      this.uppy.on("file-removed", onFileRemove);
      this.uppy.on("cancel-all", onCancelAll);
      this.uppy.on("upload-pause", onFilePausedChange);
      this.uppy.on("pause-all", onPauseAll);
      this.uppy.on("resume-all", onResumeAll);
      removeEventHandlers = () => {
        this.uppy.off("file-removed", onFileRemove);
        this.uppy.off("cancel-all", onCancelAll);
        this.uppy.off("upload-pause", onFilePausedChange);
        this.uppy.off("pause-all", onPauseAll);
        this.uppy.off("resume-all", onResumeAll);
      };
      signal.addEventListener("abort", () => {
        var _socketAbortControlle6;
        (_socketAbortControlle6 = socketAbortController) == null || _socketAbortControlle6.abort();
      });
      createWebsocket();
    });
  } finally {
    removeEventHandlers == null || removeEventHandlers();
  }
}
RequestClient2.VERSION = packageJson8.version;
var import_namespace_emitter2 = __toESM2(require_namespace_emitter2(), 1);
var _Symbol$for23;
var _Symbol$for222;
function _classPrivateFieldLooseBase32(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id32 = 0;
function _classPrivateFieldLooseKey32(name) {
  return "__private_" + id32++ + "_" + name;
}
var _queued2 = /* @__PURE__ */ _classPrivateFieldLooseKey32("queued");
var _emitter2 = /* @__PURE__ */ _classPrivateFieldLooseKey32("emitter");
var _isOpen2 = /* @__PURE__ */ _classPrivateFieldLooseKey32("isOpen");
var _socket2 = /* @__PURE__ */ _classPrivateFieldLooseKey32("socket");
var _handleMessage2 = /* @__PURE__ */ _classPrivateFieldLooseKey32("handleMessage");
_Symbol$for23 = Symbol.for("uppy test: getSocket");
_Symbol$for222 = Symbol.for("uppy test: getQueued");
var UppySocket2 = class {
  constructor(opts) {
    Object.defineProperty(this, _queued2, {
      writable: true,
      value: []
    });
    Object.defineProperty(this, _emitter2, {
      writable: true,
      value: (0, import_namespace_emitter2.default)()
    });
    Object.defineProperty(this, _isOpen2, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _socket2, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _handleMessage2, {
      writable: true,
      value: (e4) => {
        try {
          const message = JSON.parse(e4.data);
          this.emit(message.action, message.payload);
        } catch (err) {
          console.log(err);
        }
      }
    });
    this.opts = opts;
    if (!opts || opts.autoOpen !== false) {
      this.open();
    }
  }
  get isOpen() {
    return _classPrivateFieldLooseBase32(this, _isOpen2)[_isOpen2];
  }
  [_Symbol$for23]() {
    return _classPrivateFieldLooseBase32(this, _socket2)[_socket2];
  }
  [_Symbol$for222]() {
    return _classPrivateFieldLooseBase32(this, _queued2)[_queued2];
  }
  open() {
    if (_classPrivateFieldLooseBase32(this, _socket2)[_socket2] != null)
      return;
    _classPrivateFieldLooseBase32(this, _socket2)[_socket2] = new WebSocket(this.opts.target);
    _classPrivateFieldLooseBase32(this, _socket2)[_socket2].onopen = () => {
      _classPrivateFieldLooseBase32(this, _isOpen2)[_isOpen2] = true;
      while (_classPrivateFieldLooseBase32(this, _queued2)[_queued2].length > 0 && _classPrivateFieldLooseBase32(this, _isOpen2)[_isOpen2]) {
        const first = _classPrivateFieldLooseBase32(this, _queued2)[_queued2].shift();
        this.send(first.action, first.payload);
      }
    };
    _classPrivateFieldLooseBase32(this, _socket2)[_socket2].onclose = () => {
      _classPrivateFieldLooseBase32(this, _isOpen2)[_isOpen2] = false;
      _classPrivateFieldLooseBase32(this, _socket2)[_socket2] = null;
    };
    _classPrivateFieldLooseBase32(this, _socket2)[_socket2].onmessage = _classPrivateFieldLooseBase32(this, _handleMessage2)[_handleMessage2];
  }
  close() {
    var _classPrivateFieldLoo;
    (_classPrivateFieldLoo = _classPrivateFieldLooseBase32(this, _socket2)[_socket2]) == null || _classPrivateFieldLoo.close();
  }
  send(action, payload) {
    if (!_classPrivateFieldLooseBase32(this, _isOpen2)[_isOpen2]) {
      _classPrivateFieldLooseBase32(this, _queued2)[_queued2].push({
        action,
        payload
      });
      return;
    }
    _classPrivateFieldLooseBase32(this, _socket2)[_socket2].send(JSON.stringify({
      action,
      payload
    }));
  }
  on(action, handler) {
    _classPrivateFieldLooseBase32(this, _emitter2)[_emitter2].on(action, handler);
  }
  emit(action, payload) {
    _classPrivateFieldLooseBase32(this, _emitter2)[_emitter2].emit(action, payload);
  }
  once(action, handler) {
    _classPrivateFieldLooseBase32(this, _emitter2)[_emitter2].once(action, handler);
  }
};
function _classPrivateFieldLooseBase42(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id42 = 0;
function _classPrivateFieldLooseKey42(name) {
  return "__private_" + id42++ + "_" + name;
}
var _uppy2 = /* @__PURE__ */ _classPrivateFieldLooseKey42("uppy");
var _events2 = /* @__PURE__ */ _classPrivateFieldLooseKey42("events");
var EventManager2 = class {
  constructor(uppy22) {
    Object.defineProperty(this, _uppy2, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _events2, {
      writable: true,
      value: []
    });
    _classPrivateFieldLooseBase42(this, _uppy2)[_uppy2] = uppy22;
  }
  on(event, fn) {
    _classPrivateFieldLooseBase42(this, _events2)[_events2].push([event, fn]);
    return _classPrivateFieldLooseBase42(this, _uppy2)[_uppy2].on(event, fn);
  }
  remove() {
    for (const [event, fn] of _classPrivateFieldLooseBase42(this, _events2)[_events2].splice(0)) {
      _classPrivateFieldLooseBase42(this, _uppy2)[_uppy2].off(event, fn);
    }
  }
  onFilePause(fileID, cb) {
    this.on("upload-pause", (targetFileID, isPaused) => {
      if (fileID === targetFileID) {
        cb(isPaused);
      }
    });
  }
  onFileRemove(fileID, cb) {
    this.on("file-removed", (file) => {
      if (fileID === file.id)
        cb(file.id);
    });
  }
  onPause(fileID, cb) {
    this.on("upload-pause", (targetFileID, isPaused) => {
      if (fileID === targetFileID) {
        cb(isPaused);
      }
    });
  }
  onRetry(fileID, cb) {
    this.on("upload-retry", (targetFileID) => {
      if (fileID === targetFileID) {
        cb();
      }
    });
  }
  onRetryAll(fileID, cb) {
    this.on("retry-all", () => {
      if (!_classPrivateFieldLooseBase42(this, _uppy2)[_uppy2].getFile(fileID))
        return;
      cb();
    });
  }
  onPauseAll(fileID, cb) {
    this.on("pause-all", () => {
      if (!_classPrivateFieldLooseBase42(this, _uppy2)[_uppy2].getFile(fileID))
        return;
      cb();
    });
  }
  onCancelAll(fileID, eventHandler) {
    var _this = this;
    this.on("cancel-all", function() {
      if (!_classPrivateFieldLooseBase42(_this, _uppy2)[_uppy2].getFile(fileID))
        return;
      eventHandler(...arguments);
    });
  }
  onResumeAll(fileID, cb) {
    this.on("resume-all", () => {
      if (!_classPrivateFieldLooseBase42(this, _uppy2)[_uppy2].getFile(fileID))
        return;
      cb();
    });
  }
};
function _classPrivateFieldLooseBase52(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id52 = 0;
function _classPrivateFieldLooseKey52(name) {
  return "__private_" + id52++ + "_" + name;
}
function createCancelError2(cause) {
  return new Error("Cancelled", {
    cause
  });
}
function abortOn2(signal) {
  if (signal != null) {
    var _this$then;
    const abortPromise = () => this.abort(signal.reason);
    signal.addEventListener("abort", abortPromise, {
      once: true
    });
    const removeAbortListener = () => {
      signal.removeEventListener("abort", abortPromise);
    };
    (_this$then = this.then) == null || _this$then.call(this, removeAbortListener, removeAbortListener);
  }
  return this;
}
var _activeRequests2 = /* @__PURE__ */ _classPrivateFieldLooseKey52("activeRequests");
var _queuedHandlers2 = /* @__PURE__ */ _classPrivateFieldLooseKey52("queuedHandlers");
var _paused2 = /* @__PURE__ */ _classPrivateFieldLooseKey52("paused");
var _pauseTimer2 = /* @__PURE__ */ _classPrivateFieldLooseKey52("pauseTimer");
var _downLimit2 = /* @__PURE__ */ _classPrivateFieldLooseKey52("downLimit");
var _upperLimit2 = /* @__PURE__ */ _classPrivateFieldLooseKey52("upperLimit");
var _rateLimitingTimer2 = /* @__PURE__ */ _classPrivateFieldLooseKey52("rateLimitingTimer");
var _call3 = /* @__PURE__ */ _classPrivateFieldLooseKey52("call");
var _queueNext3 = /* @__PURE__ */ _classPrivateFieldLooseKey52("queueNext");
var _next3 = /* @__PURE__ */ _classPrivateFieldLooseKey52("next");
var _queue3 = /* @__PURE__ */ _classPrivateFieldLooseKey52("queue");
var _dequeue3 = /* @__PURE__ */ _classPrivateFieldLooseKey52("dequeue");
var _resume2 = /* @__PURE__ */ _classPrivateFieldLooseKey52("resume");
var _increaseLimit2 = /* @__PURE__ */ _classPrivateFieldLooseKey52("increaseLimit");
var RateLimitedQueue2 = class {
  constructor(limit) {
    Object.defineProperty(this, _dequeue3, {
      value: _dequeue22
    });
    Object.defineProperty(this, _queue3, {
      value: _queue22
    });
    Object.defineProperty(this, _next3, {
      value: _next22
    });
    Object.defineProperty(this, _queueNext3, {
      value: _queueNext22
    });
    Object.defineProperty(this, _call3, {
      value: _call22
    });
    Object.defineProperty(this, _activeRequests2, {
      writable: true,
      value: 0
    });
    Object.defineProperty(this, _queuedHandlers2, {
      writable: true,
      value: []
    });
    Object.defineProperty(this, _paused2, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _pauseTimer2, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _downLimit2, {
      writable: true,
      value: 1
    });
    Object.defineProperty(this, _upperLimit2, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _rateLimitingTimer2, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _resume2, {
      writable: true,
      value: () => this.resume()
    });
    Object.defineProperty(this, _increaseLimit2, {
      writable: true,
      value: () => {
        if (_classPrivateFieldLooseBase52(this, _paused2)[_paused2]) {
          _classPrivateFieldLooseBase52(this, _rateLimitingTimer2)[_rateLimitingTimer2] = setTimeout(_classPrivateFieldLooseBase52(this, _increaseLimit2)[_increaseLimit2], 0);
          return;
        }
        _classPrivateFieldLooseBase52(this, _downLimit2)[_downLimit2] = this.limit;
        this.limit = Math.ceil((_classPrivateFieldLooseBase52(this, _upperLimit2)[_upperLimit2] + _classPrivateFieldLooseBase52(this, _downLimit2)[_downLimit2]) / 2);
        for (let i4 = _classPrivateFieldLooseBase52(this, _downLimit2)[_downLimit2]; i4 <= this.limit; i4++) {
          _classPrivateFieldLooseBase52(this, _queueNext3)[_queueNext3]();
        }
        if (_classPrivateFieldLooseBase52(this, _upperLimit2)[_upperLimit2] - _classPrivateFieldLooseBase52(this, _downLimit2)[_downLimit2] > 3) {
          _classPrivateFieldLooseBase52(this, _rateLimitingTimer2)[_rateLimitingTimer2] = setTimeout(_classPrivateFieldLooseBase52(this, _increaseLimit2)[_increaseLimit2], 2e3);
        } else {
          _classPrivateFieldLooseBase52(this, _downLimit2)[_downLimit2] = Math.floor(_classPrivateFieldLooseBase52(this, _downLimit2)[_downLimit2] / 2);
        }
      }
    });
    if (typeof limit !== "number" || limit === 0) {
      this.limit = Infinity;
    } else {
      this.limit = limit;
    }
  }
  run(fn, queueOptions) {
    if (!_classPrivateFieldLooseBase52(this, _paused2)[_paused2] && _classPrivateFieldLooseBase52(this, _activeRequests2)[_activeRequests2] < this.limit) {
      return _classPrivateFieldLooseBase52(this, _call3)[_call3](fn);
    }
    return _classPrivateFieldLooseBase52(this, _queue3)[_queue3](fn, queueOptions);
  }
  wrapSyncFunction(fn, queueOptions) {
    var _this = this;
    return function() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      const queuedRequest = _this.run(() => {
        fn(...args);
        queueMicrotask(() => queuedRequest.done());
        return () => {
        };
      }, queueOptions);
      return {
        abortOn: abortOn2,
        abort() {
          queuedRequest.abort();
        }
      };
    };
  }
  wrapPromiseFunction(fn, queueOptions) {
    var _this2 = this;
    return function() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      let queuedRequest;
      const outerPromise = new Promise((resolve, reject) => {
        queuedRequest = _this2.run(() => {
          let cancelError;
          let innerPromise;
          try {
            innerPromise = Promise.resolve(fn(...args));
          } catch (err) {
            innerPromise = Promise.reject(err);
          }
          innerPromise.then((result) => {
            if (cancelError) {
              reject(cancelError);
            } else {
              queuedRequest.done();
              resolve(result);
            }
          }, (err) => {
            if (cancelError) {
              reject(cancelError);
            } else {
              queuedRequest.done();
              reject(err);
            }
          });
          return (cause) => {
            cancelError = createCancelError2(cause);
          };
        }, queueOptions);
      });
      outerPromise.abort = (cause) => {
        queuedRequest.abort(cause);
      };
      outerPromise.abortOn = abortOn2;
      return outerPromise;
    };
  }
  resume() {
    _classPrivateFieldLooseBase52(this, _paused2)[_paused2] = false;
    clearTimeout(_classPrivateFieldLooseBase52(this, _pauseTimer2)[_pauseTimer2]);
    for (let i4 = 0; i4 < this.limit; i4++) {
      _classPrivateFieldLooseBase52(this, _queueNext3)[_queueNext3]();
    }
  }
  /**
   * Freezes the queue for a while or indefinitely.
   *
   * @param {number | null } [duration] Duration for the pause to happen, in milliseconds.
   *                                    If omitted, the queue won't resume automatically.
   */
  pause(duration2) {
    if (duration2 === void 0) {
      duration2 = null;
    }
    _classPrivateFieldLooseBase52(this, _paused2)[_paused2] = true;
    clearTimeout(_classPrivateFieldLooseBase52(this, _pauseTimer2)[_pauseTimer2]);
    if (duration2 != null) {
      _classPrivateFieldLooseBase52(this, _pauseTimer2)[_pauseTimer2] = setTimeout(_classPrivateFieldLooseBase52(this, _resume2)[_resume2], duration2);
    }
  }
  /**
   * Pauses the queue for a duration, and lower the limit of concurrent requests
   * when the queue resumes. When the queue resumes, it tries to progressively
   * increase the limit in `this.#increaseLimit` until another call is made to
   * `this.rateLimit`.
   * Call this function when using the RateLimitedQueue for network requests and
   * the remote server responds with 429 HTTP code.
   *
   * @param {number} duration in milliseconds.
   */
  rateLimit(duration2) {
    clearTimeout(_classPrivateFieldLooseBase52(this, _rateLimitingTimer2)[_rateLimitingTimer2]);
    this.pause(duration2);
    if (this.limit > 1 && Number.isFinite(this.limit)) {
      _classPrivateFieldLooseBase52(this, _upperLimit2)[_upperLimit2] = this.limit - 1;
      this.limit = _classPrivateFieldLooseBase52(this, _downLimit2)[_downLimit2];
      _classPrivateFieldLooseBase52(this, _rateLimitingTimer2)[_rateLimitingTimer2] = setTimeout(_classPrivateFieldLooseBase52(this, _increaseLimit2)[_increaseLimit2], duration2);
    }
  }
  get isPaused() {
    return _classPrivateFieldLooseBase52(this, _paused2)[_paused2];
  }
};
function _call22(fn) {
  _classPrivateFieldLooseBase52(this, _activeRequests2)[_activeRequests2] += 1;
  let done = false;
  let cancelActive;
  try {
    cancelActive = fn();
  } catch (err) {
    _classPrivateFieldLooseBase52(this, _activeRequests2)[_activeRequests2] -= 1;
    throw err;
  }
  return {
    abort: (cause) => {
      if (done)
        return;
      done = true;
      _classPrivateFieldLooseBase52(this, _activeRequests2)[_activeRequests2] -= 1;
      cancelActive == null || cancelActive(cause);
      _classPrivateFieldLooseBase52(this, _queueNext3)[_queueNext3]();
    },
    done: () => {
      if (done)
        return;
      done = true;
      _classPrivateFieldLooseBase52(this, _activeRequests2)[_activeRequests2] -= 1;
      _classPrivateFieldLooseBase52(this, _queueNext3)[_queueNext3]();
    }
  };
}
function _queueNext22() {
  queueMicrotask(() => _classPrivateFieldLooseBase52(this, _next3)[_next3]());
}
function _next22() {
  if (_classPrivateFieldLooseBase52(this, _paused2)[_paused2] || _classPrivateFieldLooseBase52(this, _activeRequests2)[_activeRequests2] >= this.limit) {
    return;
  }
  if (_classPrivateFieldLooseBase52(this, _queuedHandlers2)[_queuedHandlers2].length === 0) {
    return;
  }
  const next = _classPrivateFieldLooseBase52(this, _queuedHandlers2)[_queuedHandlers2].shift();
  const handler = _classPrivateFieldLooseBase52(this, _call3)[_call3](next.fn);
  next.abort = handler.abort;
  next.done = handler.done;
}
function _queue22(fn, options7) {
  if (options7 === void 0) {
    options7 = {};
  }
  const handler = {
    fn,
    priority: options7.priority || 0,
    abort: () => {
      _classPrivateFieldLooseBase52(this, _dequeue3)[_dequeue3](handler);
    },
    done: () => {
      throw new Error("Cannot mark a queued request as done: this indicates a bug");
    }
  };
  const index2 = _classPrivateFieldLooseBase52(this, _queuedHandlers2)[_queuedHandlers2].findIndex((other) => {
    return handler.priority > other.priority;
  });
  if (index2 === -1) {
    _classPrivateFieldLooseBase52(this, _queuedHandlers2)[_queuedHandlers2].push(handler);
  } else {
    _classPrivateFieldLooseBase52(this, _queuedHandlers2)[_queuedHandlers2].splice(index2, 0, handler);
  }
  return handler;
}
function _dequeue22(handler) {
  const index2 = _classPrivateFieldLooseBase52(this, _queuedHandlers2)[_queuedHandlers2].indexOf(handler);
  if (index2 !== -1) {
    _classPrivateFieldLooseBase52(this, _queuedHandlers2)[_queuedHandlers2].splice(index2, 1);
  }
}
var internalRateLimitedQueue2 = Symbol("__queue");
function filterNonFailedFiles2(files) {
  const hasError = (file) => "error" in file && !!file.error;
  return files.filter((file) => !hasError(file));
}
function filterFilesToEmitUploadStarted2(files) {
  return files.filter((file) => {
    var _file$progress;
    return !((_file$progress = file.progress) != null && _file$progress.uploadStarted) || !file.isRestored;
  });
}
var {
  AbortController: AbortController22
} = globalThis;
var {
  AbortSignal: AbortSignal2
} = globalThis;
var createAbortError2 = function(message, options7) {
  if (message === void 0) {
    message = "Aborted";
  }
  const err = new DOMException(message, "AbortError");
  if (options7 != null && has2(options7, "cause")) {
    Object.defineProperty(err, "cause", {
      // @ts-expect-error TS is drunk
      __proto__: null,
      configurable: true,
      writable: true,
      value: options7.cause
    });
  }
  return err;
};
function _classPrivateFieldLooseBase62(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id62 = 0;
function _classPrivateFieldLooseKey62(name) {
  return "__private_" + id62++ + "_" + name;
}
var MB2 = 1024 * 1024;
var defaultOptions5 = {
  getChunkSize(file) {
    return Math.ceil(file.size / 1e4);
  },
  onProgress() {
  },
  onPartComplete() {
  },
  onSuccess() {
  },
  onError(err) {
    throw err;
  }
};
function ensureInt2(value) {
  if (typeof value === "string") {
    return parseInt(value, 10);
  }
  if (typeof value === "number") {
    return value;
  }
  throw new TypeError("Expected a number");
}
var pausingUploadReason2 = Symbol("pausing upload, not an actual error");
var _abortController2 = /* @__PURE__ */ _classPrivateFieldLooseKey62("abortController");
var _chunks2 = /* @__PURE__ */ _classPrivateFieldLooseKey62("chunks");
var _chunkState2 = /* @__PURE__ */ _classPrivateFieldLooseKey62("chunkState");
var _data2 = /* @__PURE__ */ _classPrivateFieldLooseKey62("data");
var _file2 = /* @__PURE__ */ _classPrivateFieldLooseKey62("file");
var _uploadHasStarted2 = /* @__PURE__ */ _classPrivateFieldLooseKey62("uploadHasStarted");
var _onError2 = /* @__PURE__ */ _classPrivateFieldLooseKey62("onError");
var _onSuccess2 = /* @__PURE__ */ _classPrivateFieldLooseKey62("onSuccess");
var _shouldUseMultipart2 = /* @__PURE__ */ _classPrivateFieldLooseKey62("shouldUseMultipart");
var _isRestoring2 = /* @__PURE__ */ _classPrivateFieldLooseKey62("isRestoring");
var _onReject2 = /* @__PURE__ */ _classPrivateFieldLooseKey62("onReject");
var _maxMultipartParts2 = /* @__PURE__ */ _classPrivateFieldLooseKey62("maxMultipartParts");
var _minPartSize2 = /* @__PURE__ */ _classPrivateFieldLooseKey62("minPartSize");
var _initChunks3 = /* @__PURE__ */ _classPrivateFieldLooseKey62("initChunks");
var _createUpload3 = /* @__PURE__ */ _classPrivateFieldLooseKey62("createUpload");
var _resumeUpload3 = /* @__PURE__ */ _classPrivateFieldLooseKey62("resumeUpload");
var _onPartProgress2 = /* @__PURE__ */ _classPrivateFieldLooseKey62("onPartProgress");
var _onPartComplete2 = /* @__PURE__ */ _classPrivateFieldLooseKey62("onPartComplete");
var _abortUpload3 = /* @__PURE__ */ _classPrivateFieldLooseKey62("abortUpload");
var MultipartUploader2 = class {
  constructor(data, options7) {
    var _this$options, _this$options$getChun;
    Object.defineProperty(this, _abortUpload3, {
      value: _abortUpload22
    });
    Object.defineProperty(this, _resumeUpload3, {
      value: _resumeUpload22
    });
    Object.defineProperty(this, _createUpload3, {
      value: _createUpload22
    });
    Object.defineProperty(this, _initChunks3, {
      value: _initChunks22
    });
    Object.defineProperty(this, _abortController2, {
      writable: true,
      value: new AbortController22()
    });
    Object.defineProperty(this, _chunks2, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _chunkState2, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _data2, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _file2, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _uploadHasStarted2, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _onError2, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _onSuccess2, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _shouldUseMultipart2, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _isRestoring2, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _onReject2, {
      writable: true,
      value: (err) => (err == null ? void 0 : err.cause) === pausingUploadReason2 ? null : _classPrivateFieldLooseBase62(this, _onError2)[_onError2](err)
    });
    Object.defineProperty(this, _maxMultipartParts2, {
      writable: true,
      value: 1e4
    });
    Object.defineProperty(this, _minPartSize2, {
      writable: true,
      value: 5 * MB2
    });
    Object.defineProperty(this, _onPartProgress2, {
      writable: true,
      value: (index2) => (ev) => {
        if (!ev.lengthComputable)
          return;
        _classPrivateFieldLooseBase62(this, _chunkState2)[_chunkState2][index2].uploaded = ensureInt2(ev.loaded);
        const totalUploaded = _classPrivateFieldLooseBase62(this, _chunkState2)[_chunkState2].reduce((n3, c4) => n3 + c4.uploaded, 0);
        this.options.onProgress(totalUploaded, _classPrivateFieldLooseBase62(this, _data2)[_data2].size);
      }
    });
    Object.defineProperty(this, _onPartComplete2, {
      writable: true,
      value: (index2) => (etag) => {
        _classPrivateFieldLooseBase62(this, _chunks2)[_chunks2][index2] = null;
        _classPrivateFieldLooseBase62(this, _chunkState2)[_chunkState2][index2].etag = etag;
        _classPrivateFieldLooseBase62(this, _chunkState2)[_chunkState2][index2].done = true;
        const part = {
          PartNumber: index2 + 1,
          ETag: etag
        };
        this.options.onPartComplete(part);
      }
    });
    this.options = {
      ...defaultOptions5,
      ...options7
    };
    (_this$options$getChun = (_this$options = this.options).getChunkSize) != null ? _this$options$getChun : _this$options.getChunkSize = defaultOptions5.getChunkSize;
    _classPrivateFieldLooseBase62(this, _data2)[_data2] = data;
    _classPrivateFieldLooseBase62(this, _file2)[_file2] = options7.file;
    _classPrivateFieldLooseBase62(this, _onSuccess2)[_onSuccess2] = this.options.onSuccess;
    _classPrivateFieldLooseBase62(this, _onError2)[_onError2] = this.options.onError;
    _classPrivateFieldLooseBase62(this, _shouldUseMultipart2)[_shouldUseMultipart2] = this.options.shouldUseMultipart;
    _classPrivateFieldLooseBase62(this, _isRestoring2)[_isRestoring2] = options7.uploadId && options7.key;
    _classPrivateFieldLooseBase62(this, _initChunks3)[_initChunks3]();
  }
  start() {
    if (_classPrivateFieldLooseBase62(this, _uploadHasStarted2)[_uploadHasStarted2]) {
      if (!_classPrivateFieldLooseBase62(this, _abortController2)[_abortController2].signal.aborted)
        _classPrivateFieldLooseBase62(this, _abortController2)[_abortController2].abort(pausingUploadReason2);
      _classPrivateFieldLooseBase62(this, _abortController2)[_abortController2] = new AbortController22();
      _classPrivateFieldLooseBase62(this, _resumeUpload3)[_resumeUpload3]();
    } else if (_classPrivateFieldLooseBase62(this, _isRestoring2)[_isRestoring2]) {
      this.options.companionComm.restoreUploadFile(_classPrivateFieldLooseBase62(this, _file2)[_file2], {
        uploadId: this.options.uploadId,
        key: this.options.key
      });
      _classPrivateFieldLooseBase62(this, _resumeUpload3)[_resumeUpload3]();
    } else {
      _classPrivateFieldLooseBase62(this, _createUpload3)[_createUpload3]();
    }
  }
  pause() {
    _classPrivateFieldLooseBase62(this, _abortController2)[_abortController2].abort(pausingUploadReason2);
    _classPrivateFieldLooseBase62(this, _abortController2)[_abortController2] = new AbortController22();
  }
  abort(opts) {
    var _opts;
    if (opts === void 0) {
      opts = void 0;
    }
    if ((_opts = opts) != null && _opts.really)
      _classPrivateFieldLooseBase62(this, _abortUpload3)[_abortUpload3]();
    else
      this.pause();
  }
  // TODO: remove this in the next major
  get chunkState() {
    return _classPrivateFieldLooseBase62(this, _chunkState2)[_chunkState2];
  }
};
function _initChunks22() {
  const fileSize = _classPrivateFieldLooseBase62(this, _data2)[_data2].size;
  const shouldUseMultipart = typeof _classPrivateFieldLooseBase62(this, _shouldUseMultipart2)[_shouldUseMultipart2] === "function" ? _classPrivateFieldLooseBase62(this, _shouldUseMultipart2)[_shouldUseMultipart2](_classPrivateFieldLooseBase62(this, _file2)[_file2]) : Boolean(_classPrivateFieldLooseBase62(this, _shouldUseMultipart2)[_shouldUseMultipart2]);
  if (shouldUseMultipart && fileSize > _classPrivateFieldLooseBase62(this, _minPartSize2)[_minPartSize2]) {
    let chunkSize = Math.max(this.options.getChunkSize(_classPrivateFieldLooseBase62(this, _data2)[_data2]), _classPrivateFieldLooseBase62(this, _minPartSize2)[_minPartSize2]);
    let arraySize = Math.floor(fileSize / chunkSize);
    if (arraySize > _classPrivateFieldLooseBase62(this, _maxMultipartParts2)[_maxMultipartParts2]) {
      arraySize = _classPrivateFieldLooseBase62(this, _maxMultipartParts2)[_maxMultipartParts2];
      chunkSize = fileSize / _classPrivateFieldLooseBase62(this, _maxMultipartParts2)[_maxMultipartParts2];
    }
    _classPrivateFieldLooseBase62(this, _chunks2)[_chunks2] = Array(arraySize);
    for (let offset = 0, j4 = 0; offset < fileSize; offset += chunkSize, j4++) {
      const end = Math.min(fileSize, offset + chunkSize);
      const getData = () => {
        const i222 = offset;
        return _classPrivateFieldLooseBase62(this, _data2)[_data2].slice(i222, end);
      };
      _classPrivateFieldLooseBase62(this, _chunks2)[_chunks2][j4] = {
        getData,
        onProgress: _classPrivateFieldLooseBase62(this, _onPartProgress2)[_onPartProgress2](j4),
        onComplete: _classPrivateFieldLooseBase62(this, _onPartComplete2)[_onPartComplete2](j4),
        shouldUseMultipart
      };
      if (_classPrivateFieldLooseBase62(this, _isRestoring2)[_isRestoring2]) {
        const size = offset + chunkSize > fileSize ? fileSize - offset : chunkSize;
        _classPrivateFieldLooseBase62(this, _chunks2)[_chunks2][j4].setAsUploaded = () => {
          _classPrivateFieldLooseBase62(this, _chunks2)[_chunks2][j4] = null;
          _classPrivateFieldLooseBase62(this, _chunkState2)[_chunkState2][j4].uploaded = size;
        };
      }
    }
  } else {
    _classPrivateFieldLooseBase62(this, _chunks2)[_chunks2] = [{
      getData: () => _classPrivateFieldLooseBase62(this, _data2)[_data2],
      onProgress: _classPrivateFieldLooseBase62(this, _onPartProgress2)[_onPartProgress2](0),
      onComplete: _classPrivateFieldLooseBase62(this, _onPartComplete2)[_onPartComplete2](0),
      shouldUseMultipart
    }];
  }
  _classPrivateFieldLooseBase62(this, _chunkState2)[_chunkState2] = _classPrivateFieldLooseBase62(this, _chunks2)[_chunks2].map(() => ({
    uploaded: 0
  }));
}
function _createUpload22() {
  this.options.companionComm.uploadFile(_classPrivateFieldLooseBase62(this, _file2)[_file2], _classPrivateFieldLooseBase62(this, _chunks2)[_chunks2], _classPrivateFieldLooseBase62(this, _abortController2)[_abortController2].signal).then(_classPrivateFieldLooseBase62(this, _onSuccess2)[_onSuccess2], _classPrivateFieldLooseBase62(this, _onReject2)[_onReject2]);
  _classPrivateFieldLooseBase62(this, _uploadHasStarted2)[_uploadHasStarted2] = true;
}
function _resumeUpload22() {
  this.options.companionComm.resumeUploadFile(_classPrivateFieldLooseBase62(this, _file2)[_file2], _classPrivateFieldLooseBase62(this, _chunks2)[_chunks2], _classPrivateFieldLooseBase62(this, _abortController2)[_abortController2].signal).then(_classPrivateFieldLooseBase62(this, _onSuccess2)[_onSuccess2], _classPrivateFieldLooseBase62(this, _onReject2)[_onReject2]);
}
function _abortUpload22() {
  _classPrivateFieldLooseBase62(this, _abortController2)[_abortController2].abort();
  this.options.companionComm.abortFileUpload(_classPrivateFieldLooseBase62(this, _file2)[_file2]).catch((err) => this.options.log(err));
}
var MultipartUploader_default2 = MultipartUploader2;
function createCanonicalRequest2(_ref) {
  let {
    method = "PUT",
    CanonicalUri = "/",
    CanonicalQueryString = "",
    SignedHeaders,
    HashedPayload
  } = _ref;
  const headerKeys = Object.keys(SignedHeaders).map((k4) => k4.toLowerCase()).sort();
  return [method, CanonicalUri, CanonicalQueryString, ...headerKeys.map((k4) => `${k4}:${SignedHeaders[k4]}`), "", headerKeys.join(";"), HashedPayload].join("\n");
}
var ec2 = new TextEncoder();
var algorithm2 = {
  name: "HMAC",
  hash: "SHA-256"
};
async function digest2(data) {
  const {
    subtle
  } = globalThis.crypto;
  return subtle.digest(algorithm2.hash, ec2.encode(data));
}
async function generateHmacKey2(secret) {
  const {
    subtle
  } = globalThis.crypto;
  return subtle.importKey("raw", typeof secret === "string" ? ec2.encode(secret) : secret, algorithm2, false, ["sign"]);
}
function arrayBufferToHexString2(arrayBuffer) {
  const byteArray = new Uint8Array(arrayBuffer);
  let hexString = "";
  for (let i4 = 0; i4 < byteArray.length; i4++) {
    hexString += byteArray[i4].toString(16).padStart(2, "0");
  }
  return hexString;
}
async function hash2(key, data) {
  const {
    subtle
  } = globalThis.crypto;
  return subtle.sign(algorithm2, await generateHmacKey2(key), ec2.encode(data));
}
async function createSignedURL2(_ref2) {
  let {
    accountKey,
    accountSecret,
    sessionToken,
    bucketName,
    Key,
    Region,
    expires,
    uploadId,
    partNumber
  } = _ref2;
  const Service = "s3";
  const host = `${bucketName}.${Service}.${Region}.amazonaws.com`;
  const CanonicalUri = `/${encodeURI(Key)}`;
  const payload = "UNSIGNED-PAYLOAD";
  const requestDateTime = (/* @__PURE__ */ new Date()).toISOString().replace(/[-:]|\.\d+/g, "");
  const date = requestDateTime.slice(0, 8);
  const scope = `${date}/${Region}/${Service}/aws4_request`;
  const url = new URL(`https://${host}${CanonicalUri}`);
  url.searchParams.set("X-Amz-Algorithm", "AWS4-HMAC-SHA256");
  url.searchParams.set("X-Amz-Content-Sha256", payload);
  url.searchParams.set("X-Amz-Credential", `${accountKey}/${scope}`);
  url.searchParams.set("X-Amz-Date", requestDateTime);
  url.searchParams.set("X-Amz-Expires", expires);
  url.searchParams.set("X-Amz-Security-Token", sessionToken);
  url.searchParams.set("X-Amz-SignedHeaders", "host");
  if (partNumber)
    url.searchParams.set("partNumber", partNumber);
  if (uploadId)
    url.searchParams.set("uploadId", uploadId);
  url.searchParams.set("x-id", partNumber && uploadId ? "UploadPart" : "PutObject");
  const canonical = createCanonicalRequest2({
    CanonicalUri,
    CanonicalQueryString: url.search.slice(1),
    SignedHeaders: {
      host
    },
    HashedPayload: payload
  });
  const hashedCanonical = arrayBufferToHexString2(await digest2(canonical));
  const stringToSign = [
    `AWS4-HMAC-SHA256`,
    // The algorithm used to create the hash of the canonical request.
    requestDateTime,
    // The date and time used in the credential scope.
    scope,
    // The credential scope. This restricts the resulting signature to the specified Region and service.
    hashedCanonical
    // The hash of the canonical request.
  ].join("\n");
  const kDate = await hash2(`AWS4${accountSecret}`, date);
  const kRegion = await hash2(kDate, Region);
  const kService = await hash2(kRegion, Service);
  const kSigning = await hash2(kService, "aws4_request");
  const signature = arrayBufferToHexString2(await hash2(kSigning, stringToSign));
  url.searchParams.set("X-Amz-Signature", signature);
  return url;
}
var _Symbol$for32;
function _classPrivateFieldLooseBase72(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id72 = 0;
function _classPrivateFieldLooseKey72(name) {
  return "__private_" + id72++ + "_" + name;
}
var packageJson22 = {
  "version": "3.10.2"
};
function assertServerError3(res) {
  if (res && res.error) {
    const error = new Error(res.message);
    Object.assign(error, res.error);
    throw error;
  }
  return res;
}
function removeMetadataFromURL2(urlString) {
  const urlObject = new URL(urlString);
  urlObject.search = "";
  urlObject.hash = "";
  return urlObject.href;
}
function getExpiry2(credentials) {
  const expirationDate = credentials.Expiration;
  if (expirationDate) {
    const timeUntilExpiry = Math.floor((new Date(expirationDate) - Date.now()) / 1e3);
    if (timeUntilExpiry > 9) {
      return timeUntilExpiry;
    }
  }
  return void 0;
}
function getAllowedMetadata2(_ref) {
  let {
    meta,
    allowedMetaFields,
    querify = false
  } = _ref;
  const metaFields22 = allowedMetaFields != null ? allowedMetaFields : Object.keys(meta);
  if (!meta)
    return {};
  return Object.fromEntries(metaFields22.filter((key) => meta[key] != null).map((key) => {
    const realKey = querify ? `metadata[${key}]` : key;
    const value = String(meta[key]);
    return [realKey, value];
  }));
}
function throwIfAborted2(signal) {
  if (signal != null && signal.aborted) {
    throw createAbortError2("The operation was aborted", {
      cause: signal.reason
    });
  }
}
var _abortMultipartUpload2 = /* @__PURE__ */ _classPrivateFieldLooseKey72("abortMultipartUpload");
var _cache2 = /* @__PURE__ */ _classPrivateFieldLooseKey72("cache");
var _createMultipartUpload2 = /* @__PURE__ */ _classPrivateFieldLooseKey72("createMultipartUpload");
var _fetchSignature2 = /* @__PURE__ */ _classPrivateFieldLooseKey72("fetchSignature");
var _getUploadParameters2 = /* @__PURE__ */ _classPrivateFieldLooseKey72("getUploadParameters");
var _listParts2 = /* @__PURE__ */ _classPrivateFieldLooseKey72("listParts");
var _previousRetryDelay2 = /* @__PURE__ */ _classPrivateFieldLooseKey72("previousRetryDelay");
var _requests3 = /* @__PURE__ */ _classPrivateFieldLooseKey72("requests");
var _retryDelays2 = /* @__PURE__ */ _classPrivateFieldLooseKey72("retryDelays");
var _sendCompletionRequest2 = /* @__PURE__ */ _classPrivateFieldLooseKey72("sendCompletionRequest");
var _setS3MultipartState3 = /* @__PURE__ */ _classPrivateFieldLooseKey72("setS3MultipartState");
var _uploadPartBytes2 = /* @__PURE__ */ _classPrivateFieldLooseKey72("uploadPartBytes");
var _getFile3 = /* @__PURE__ */ _classPrivateFieldLooseKey72("getFile");
var _shouldRetry3 = /* @__PURE__ */ _classPrivateFieldLooseKey72("shouldRetry");
var _nonMultipartUpload3 = /* @__PURE__ */ _classPrivateFieldLooseKey72("nonMultipartUpload");
var HTTPCommunicationQueue2 = class {
  constructor(_requests222, options7, setS3MultipartState, getFile) {
    Object.defineProperty(this, _nonMultipartUpload3, {
      value: _nonMultipartUpload22
    });
    Object.defineProperty(this, _shouldRetry3, {
      value: _shouldRetry22
    });
    Object.defineProperty(this, _abortMultipartUpload2, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _cache2, {
      writable: true,
      value: /* @__PURE__ */ new WeakMap()
    });
    Object.defineProperty(this, _createMultipartUpload2, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _fetchSignature2, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _getUploadParameters2, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _listParts2, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _previousRetryDelay2, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _requests3, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _retryDelays2, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _sendCompletionRequest2, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _setS3MultipartState3, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _uploadPartBytes2, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _getFile3, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldLooseBase72(this, _requests3)[_requests3] = _requests222;
    _classPrivateFieldLooseBase72(this, _setS3MultipartState3)[_setS3MultipartState3] = setS3MultipartState;
    _classPrivateFieldLooseBase72(this, _getFile3)[_getFile3] = getFile;
    this.setOptions(options7);
  }
  setOptions(options7) {
    const requests = _classPrivateFieldLooseBase72(this, _requests3)[_requests3];
    if ("abortMultipartUpload" in options7) {
      _classPrivateFieldLooseBase72(this, _abortMultipartUpload2)[_abortMultipartUpload2] = requests.wrapPromiseFunction(options7.abortMultipartUpload, {
        priority: 1
      });
    }
    if ("createMultipartUpload" in options7) {
      _classPrivateFieldLooseBase72(this, _createMultipartUpload2)[_createMultipartUpload2] = requests.wrapPromiseFunction(options7.createMultipartUpload, {
        priority: -1
      });
    }
    if ("signPart" in options7) {
      _classPrivateFieldLooseBase72(this, _fetchSignature2)[_fetchSignature2] = requests.wrapPromiseFunction(options7.signPart);
    }
    if ("listParts" in options7) {
      _classPrivateFieldLooseBase72(this, _listParts2)[_listParts2] = requests.wrapPromiseFunction(options7.listParts);
    }
    if ("completeMultipartUpload" in options7) {
      _classPrivateFieldLooseBase72(this, _sendCompletionRequest2)[_sendCompletionRequest2] = requests.wrapPromiseFunction(options7.completeMultipartUpload, {
        priority: 1
      });
    }
    if ("retryDelays" in options7) {
      var _options$retryDelays;
      _classPrivateFieldLooseBase72(this, _retryDelays2)[_retryDelays2] = (_options$retryDelays = options7.retryDelays) != null ? _options$retryDelays : [];
    }
    if ("uploadPartBytes" in options7) {
      _classPrivateFieldLooseBase72(this, _uploadPartBytes2)[_uploadPartBytes2] = requests.wrapPromiseFunction(options7.uploadPartBytes, {
        priority: Infinity
      });
    }
    if ("getUploadParameters" in options7) {
      _classPrivateFieldLooseBase72(this, _getUploadParameters2)[_getUploadParameters2] = requests.wrapPromiseFunction(options7.getUploadParameters);
    }
  }
  async getUploadId(file, signal) {
    let cachedResult;
    while ((cachedResult = _classPrivateFieldLooseBase72(this, _cache2)[_cache2].get(file.data)) != null) {
      try {
        return await cachedResult;
      } catch {
      }
    }
    const promise = _classPrivateFieldLooseBase72(this, _createMultipartUpload2)[_createMultipartUpload2](_classPrivateFieldLooseBase72(this, _getFile3)[_getFile3](file), signal);
    const abortPromise = () => {
      promise.abort(signal.reason);
      _classPrivateFieldLooseBase72(this, _cache2)[_cache2].delete(file.data);
    };
    signal.addEventListener("abort", abortPromise, {
      once: true
    });
    _classPrivateFieldLooseBase72(this, _cache2)[_cache2].set(file.data, promise);
    promise.then(async (result) => {
      signal.removeEventListener("abort", abortPromise);
      _classPrivateFieldLooseBase72(this, _setS3MultipartState3)[_setS3MultipartState3](file, result);
      _classPrivateFieldLooseBase72(this, _cache2)[_cache2].set(file.data, result);
    }, () => {
      signal.removeEventListener("abort", abortPromise);
      _classPrivateFieldLooseBase72(this, _cache2)[_cache2].delete(file.data);
    });
    return promise;
  }
  async abortFileUpload(file) {
    const result = _classPrivateFieldLooseBase72(this, _cache2)[_cache2].get(file.data);
    if (result == null) {
      return;
    }
    _classPrivateFieldLooseBase72(this, _cache2)[_cache2].delete(file.data);
    _classPrivateFieldLooseBase72(this, _setS3MultipartState3)[_setS3MultipartState3](file, /* @__PURE__ */ Object.create(null));
    let awaitedResult;
    try {
      awaitedResult = await result;
    } catch {
      return;
    }
    await _classPrivateFieldLooseBase72(this, _abortMultipartUpload2)[_abortMultipartUpload2](_classPrivateFieldLooseBase72(this, _getFile3)[_getFile3](file), awaitedResult);
  }
  /**
   * @param {import("@uppy/core").UppyFile} file
   * @param {import("../types/chunk").Chunk[]} chunks
   * @param {AbortSignal} signal
   * @returns {Promise<void>}
   */
  async uploadFile(file, chunks2, signal) {
    throwIfAborted2(signal);
    if (chunks2.length === 1 && !chunks2[0].shouldUseMultipart) {
      return _classPrivateFieldLooseBase72(this, _nonMultipartUpload3)[_nonMultipartUpload3](file, chunks2[0], signal);
    }
    const {
      uploadId,
      key
    } = await this.getUploadId(file, signal);
    throwIfAborted2(signal);
    try {
      const parts = await Promise.all(chunks2.map((chunk, i4) => this.uploadChunk(file, i4 + 1, chunk, signal)));
      throwIfAborted2(signal);
      return await _classPrivateFieldLooseBase72(this, _sendCompletionRequest2)[_sendCompletionRequest2](_classPrivateFieldLooseBase72(this, _getFile3)[_getFile3](file), {
        key,
        uploadId,
        parts,
        signal
      }, signal).abortOn(signal);
    } catch (err) {
      if ((err == null ? void 0 : err.cause) !== pausingUploadReason2 && (err == null ? void 0 : err.name) !== "AbortError") {
        this.abortFileUpload(file);
      }
      throw err;
    }
  }
  restoreUploadFile(file, uploadIdAndKey) {
    _classPrivateFieldLooseBase72(this, _cache2)[_cache2].set(file.data, uploadIdAndKey);
  }
  async resumeUploadFile(file, chunks2, signal) {
    throwIfAborted2(signal);
    if (chunks2.length === 1 && chunks2[0] != null && !chunks2[0].shouldUseMultipart) {
      return _classPrivateFieldLooseBase72(this, _nonMultipartUpload3)[_nonMultipartUpload3](file, chunks2[0], signal);
    }
    const {
      uploadId,
      key
    } = await this.getUploadId(file, signal);
    throwIfAborted2(signal);
    const alreadyUploadedParts = await _classPrivateFieldLooseBase72(this, _listParts2)[_listParts2](_classPrivateFieldLooseBase72(this, _getFile3)[_getFile3](file), {
      uploadId,
      key,
      signal
    }, signal).abortOn(signal);
    throwIfAborted2(signal);
    const parts = await Promise.all(chunks2.map((chunk, i4) => {
      const partNumber = i4 + 1;
      const alreadyUploadedInfo = alreadyUploadedParts.find((_ref2) => {
        let {
          PartNumber
        } = _ref2;
        return PartNumber === partNumber;
      });
      if (alreadyUploadedInfo == null) {
        return this.uploadChunk(file, partNumber, chunk, signal);
      }
      chunk == null || chunk.setAsUploaded == null || chunk.setAsUploaded();
      return {
        PartNumber: partNumber,
        ETag: alreadyUploadedInfo.ETag
      };
    }));
    throwIfAborted2(signal);
    return _classPrivateFieldLooseBase72(this, _sendCompletionRequest2)[_sendCompletionRequest2](_classPrivateFieldLooseBase72(this, _getFile3)[_getFile3](file), {
      key,
      uploadId,
      parts,
      signal
    }, signal).abortOn(signal);
  }
  /**
   *
   * @param {import("@uppy/core").UppyFile} file
   * @param {number} partNumber
   * @param {import("../types/chunk").Chunk} chunk
   * @param {AbortSignal} signal
   * @returns {Promise<object>}
   */
  async uploadChunk(file, partNumber, chunk, signal) {
    throwIfAborted2(signal);
    const {
      uploadId,
      key
    } = await this.getUploadId(file, signal);
    const signatureRetryIterator = _classPrivateFieldLooseBase72(this, _retryDelays2)[_retryDelays2].values();
    const chunkRetryIterator = _classPrivateFieldLooseBase72(this, _retryDelays2)[_retryDelays2].values();
    const shouldRetrySignature = () => {
      const next = signatureRetryIterator.next();
      if (next == null || next.done) {
        return null;
      }
      return next.value;
    };
    for (; ; ) {
      throwIfAborted2(signal);
      const chunkData = chunk.getData();
      const {
        onProgress,
        onComplete
      } = chunk;
      let signature;
      try {
        signature = await _classPrivateFieldLooseBase72(this, _fetchSignature2)[_fetchSignature2](_classPrivateFieldLooseBase72(this, _getFile3)[_getFile3](file), {
          uploadId,
          key,
          partNumber,
          body: chunkData,
          signal
        }).abortOn(signal);
      } catch (err) {
        const timeout = shouldRetrySignature();
        if (timeout == null || signal.aborted) {
          throw err;
        }
        await new Promise((resolve) => setTimeout(resolve, timeout));
        continue;
      }
      throwIfAborted2(signal);
      try {
        return {
          PartNumber: partNumber,
          ...await _classPrivateFieldLooseBase72(this, _uploadPartBytes2)[_uploadPartBytes2]({
            signature,
            body: chunkData,
            size: chunkData.size,
            onProgress,
            onComplete,
            signal
          }).abortOn(signal)
        };
      } catch (err) {
        if (!await _classPrivateFieldLooseBase72(this, _shouldRetry3)[_shouldRetry3](err, chunkRetryIterator))
          throw err;
      }
    }
  }
};
async function _shouldRetry22(err, retryDelayIterator) {
  var _err$source;
  const requests = _classPrivateFieldLooseBase72(this, _requests3)[_requests3];
  const status = err == null || (_err$source = err.source) == null ? void 0 : _err$source.status;
  if (status == null) {
    return false;
  }
  if (status === 403 && err.message === "Request has expired") {
    if (!requests.isPaused) {
      if (requests.limit === 1 || _classPrivateFieldLooseBase72(this, _previousRetryDelay2)[_previousRetryDelay2] == null) {
        const next = retryDelayIterator.next();
        if (next == null || next.done) {
          return false;
        }
        _classPrivateFieldLooseBase72(this, _previousRetryDelay2)[_previousRetryDelay2] = next.value;
      }
      requests.rateLimit(0);
      await new Promise((resolve) => setTimeout(resolve, _classPrivateFieldLooseBase72(this, _previousRetryDelay2)[_previousRetryDelay2]));
    }
  } else if (status === 429) {
    if (!requests.isPaused) {
      const next = retryDelayIterator.next();
      if (next == null || next.done) {
        return false;
      }
      requests.rateLimit(next.value);
    }
  } else if (status > 400 && status < 500 && status !== 409) {
    return false;
  } else if (typeof navigator !== "undefined" && navigator.onLine === false) {
    if (!requests.isPaused) {
      requests.pause();
      window.addEventListener("online", () => {
        requests.resume();
      }, {
        once: true
      });
    }
  } else {
    const next = retryDelayIterator.next();
    if (next == null || next.done) {
      return false;
    }
    await new Promise((resolve) => setTimeout(resolve, next.value));
  }
  return true;
}
async function _nonMultipartUpload22(file, chunk, signal) {
  const {
    method = "POST",
    url,
    fields,
    headers
  } = await _classPrivateFieldLooseBase72(this, _getUploadParameters2)[_getUploadParameters2](_classPrivateFieldLooseBase72(this, _getFile3)[_getFile3](file), {
    signal
  }).abortOn(signal);
  let body;
  const data = chunk.getData();
  if (method.toUpperCase() === "POST") {
    const formData = new FormData();
    Object.entries(fields).forEach((_ref10) => {
      let [key, value] = _ref10;
      return formData.set(key, value);
    });
    formData.set("file", data);
    body = formData;
  } else {
    body = data;
  }
  const {
    onProgress,
    onComplete
  } = chunk;
  const result = await _classPrivateFieldLooseBase72(this, _uploadPartBytes2)[_uploadPartBytes2]({
    signature: {
      url,
      headers,
      method
    },
    body,
    size: data.size,
    onProgress,
    onComplete,
    signal
  }).abortOn(signal);
  return "location" in result ? result : {
    location: removeMetadataFromURL2(url),
    ...result
  };
}
var _companionCommunicationQueue2 = /* @__PURE__ */ _classPrivateFieldLooseKey72("companionCommunicationQueue");
var _client3 = /* @__PURE__ */ _classPrivateFieldLooseKey72("client");
var _cachedTemporaryCredentials2 = /* @__PURE__ */ _classPrivateFieldLooseKey72("cachedTemporaryCredentials");
var _getTemporarySecurityCredentials3 = /* @__PURE__ */ _classPrivateFieldLooseKey72("getTemporarySecurityCredentials");
var _setS3MultipartState22 = /* @__PURE__ */ _classPrivateFieldLooseKey72("setS3MultipartState");
var _getFile22 = /* @__PURE__ */ _classPrivateFieldLooseKey72("getFile");
var _uploadLocalFile3 = /* @__PURE__ */ _classPrivateFieldLooseKey72("uploadLocalFile");
var _getCompanionClientArgs4 = /* @__PURE__ */ _classPrivateFieldLooseKey72("getCompanionClientArgs");
var _upload2 = /* @__PURE__ */ _classPrivateFieldLooseKey72("upload");
var _setCompanionHeaders3 = /* @__PURE__ */ _classPrivateFieldLooseKey72("setCompanionHeaders");
var _setResumableUploadsCapability2 = /* @__PURE__ */ _classPrivateFieldLooseKey72("setResumableUploadsCapability");
var _resetResumableCapability2 = /* @__PURE__ */ _classPrivateFieldLooseKey72("resetResumableCapability");
_Symbol$for32 = Symbol.for("uppy test: getClient");
var AwsS3Multipart2 = class _AwsS3Multipart extends BasePlugin3 {
  constructor(uppy22, opts) {
    var _this$opts$rateLimite;
    super(uppy22, opts);
    Object.defineProperty(this, _getCompanionClientArgs4, {
      value: _getCompanionClientArgs22
    });
    Object.defineProperty(this, _uploadLocalFile3, {
      value: _uploadLocalFile22
    });
    Object.defineProperty(this, _getTemporarySecurityCredentials3, {
      value: _getTemporarySecurityCredentials22
    });
    Object.defineProperty(this, _companionCommunicationQueue2, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _client3, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _cachedTemporaryCredentials2, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _setS3MultipartState22, {
      writable: true,
      value: (file, _ref3) => {
        let {
          key,
          uploadId
        } = _ref3;
        const cFile = this.uppy.getFile(file.id);
        if (cFile == null) {
          return;
        }
        this.uppy.setFileState(file.id, {
          s3Multipart: {
            ...cFile.s3Multipart,
            key,
            uploadId
          }
        });
      }
    });
    Object.defineProperty(this, _getFile22, {
      writable: true,
      value: (file) => {
        return this.uppy.getFile(file.id) || file;
      }
    });
    Object.defineProperty(this, _upload2, {
      writable: true,
      value: async (fileIDs) => {
        if (fileIDs.length === 0)
          return void 0;
        const files = this.uppy.getFilesByIds(fileIDs);
        const filesFiltered = filterNonFailedFiles2(files);
        const filesToEmit = filterFilesToEmitUploadStarted2(filesFiltered);
        this.uppy.emit("upload-start", filesToEmit);
        const promises = filesFiltered.map((file) => {
          if (file.isRemote) {
            const getQueue = () => this.requests;
            _classPrivateFieldLooseBase72(this, _setResumableUploadsCapability2)[_setResumableUploadsCapability2](false);
            const controller = new AbortController();
            const removedHandler = (removedFile) => {
              if (removedFile.id === file.id)
                controller.abort();
            };
            this.uppy.on("file-removed", removedHandler);
            const uploadPromise = this.uppy.getRequestClientForFile(file).uploadRemoteFile(file, _classPrivateFieldLooseBase72(this, _getCompanionClientArgs4)[_getCompanionClientArgs4](file), {
              signal: controller.signal,
              getQueue
            });
            this.requests.wrapSyncFunction(() => {
              this.uppy.off("file-removed", removedHandler);
            }, {
              priority: -1
            })();
            return uploadPromise;
          }
          return _classPrivateFieldLooseBase72(this, _uploadLocalFile3)[_uploadLocalFile3](file);
        });
        const upload = await Promise.all(promises);
        _classPrivateFieldLooseBase72(this, _setResumableUploadsCapability2)[_setResumableUploadsCapability2](true);
        return upload;
      }
    });
    Object.defineProperty(this, _setCompanionHeaders3, {
      writable: true,
      value: () => {
        _classPrivateFieldLooseBase72(this, _client3)[_client3].setCompanionHeaders(this.opts.companionHeaders);
      }
    });
    Object.defineProperty(this, _setResumableUploadsCapability2, {
      writable: true,
      value: (boolean52) => {
        const {
          capabilities
        } = this.uppy.getState();
        this.uppy.setState({
          capabilities: {
            ...capabilities,
            resumableUploads: boolean52
          }
        });
      }
    });
    Object.defineProperty(this, _resetResumableCapability2, {
      writable: true,
      value: () => {
        _classPrivateFieldLooseBase72(this, _setResumableUploadsCapability2)[_setResumableUploadsCapability2](true);
      }
    });
    this.type = "uploader";
    this.id = this.opts.id || "AwsS3Multipart";
    this.title = "AWS S3 Multipart";
    _classPrivateFieldLooseBase72(this, _client3)[_client3] = new RequestClient2(uppy22, opts);
    const defaultOptions8 = {
      // TODO: null here means “include all”, [] means include none.
      // This is inconsistent with @uppy/aws-s3 and @uppy/transloadit
      allowedMetaFields: null,
      limit: 6,
      shouldUseMultipart: (file) => file.size !== 0,
      // TODO: Switch default to:
      // eslint-disable-next-line no-bitwise
      // shouldUseMultipart: (file) => file.size >> 10 >> 10 > 100,
      retryDelays: [0, 1e3, 3e3, 5e3],
      createMultipartUpload: this.createMultipartUpload.bind(this),
      listParts: this.listParts.bind(this),
      abortMultipartUpload: this.abortMultipartUpload.bind(this),
      completeMultipartUpload: this.completeMultipartUpload.bind(this),
      getTemporarySecurityCredentials: false,
      signPart: opts != null && opts.getTemporarySecurityCredentials ? this.createSignedURL.bind(this) : this.signPart.bind(this),
      uploadPartBytes: _AwsS3Multipart.uploadPartBytes,
      getUploadParameters: opts != null && opts.getTemporarySecurityCredentials ? this.createSignedURL.bind(this) : this.getUploadParameters.bind(this),
      companionHeaders: {}
    };
    this.opts = {
      ...defaultOptions8,
      ...opts
    };
    if ((opts == null ? void 0 : opts.prepareUploadParts) != null && opts.signPart == null) {
      this.opts.signPart = async (file, _ref4) => {
        let {
          uploadId,
          key,
          partNumber,
          body,
          signal
        } = _ref4;
        const {
          presignedUrls,
          headers
        } = await opts.prepareUploadParts(file, {
          uploadId,
          key,
          parts: [{
            number: partNumber,
            chunk: body
          }],
          signal
        });
        return {
          url: presignedUrls == null ? void 0 : presignedUrls[partNumber],
          headers: headers == null ? void 0 : headers[partNumber]
        };
      };
    }
    this.requests = (_this$opts$rateLimite = this.opts.rateLimitedQueue) != null ? _this$opts$rateLimite : new RateLimitedQueue2(this.opts.limit);
    _classPrivateFieldLooseBase72(this, _companionCommunicationQueue2)[_companionCommunicationQueue2] = new HTTPCommunicationQueue2(this.requests, this.opts, _classPrivateFieldLooseBase72(this, _setS3MultipartState22)[_setS3MultipartState22], _classPrivateFieldLooseBase72(this, _getFile22)[_getFile22]);
    this.uploaders = /* @__PURE__ */ Object.create(null);
    this.uploaderEvents = /* @__PURE__ */ Object.create(null);
    this.uploaderSockets = /* @__PURE__ */ Object.create(null);
  }
  [_Symbol$for32]() {
    return _classPrivateFieldLooseBase72(this, _client3)[_client3];
  }
  setOptions(newOptions) {
    _classPrivateFieldLooseBase72(this, _companionCommunicationQueue2)[_companionCommunicationQueue2].setOptions(newOptions);
    super.setOptions(newOptions);
    _classPrivateFieldLooseBase72(this, _setCompanionHeaders3)[_setCompanionHeaders3]();
  }
  /**
   * Clean up all references for a file's upload: the MultipartUploader instance,
   * any events related to the file, and the Companion WebSocket connection.
   *
   * Set `opts.abort` to tell S3 that the multipart upload is cancelled and must be removed.
   * This should be done when the user cancels the upload, not when the upload is completed or errored.
   */
  resetUploaderReferences(fileID, opts) {
    if (opts === void 0) {
      opts = {};
    }
    if (this.uploaders[fileID]) {
      this.uploaders[fileID].abort({
        really: opts.abort || false
      });
      this.uploaders[fileID] = null;
    }
    if (this.uploaderEvents[fileID]) {
      this.uploaderEvents[fileID].remove();
      this.uploaderEvents[fileID] = null;
    }
    if (this.uploaderSockets[fileID]) {
      this.uploaderSockets[fileID].close();
      this.uploaderSockets[fileID] = null;
    }
  }
  // TODO: make this a private method in the next major
  assertHost(method) {
    if (!this.opts.companionUrl) {
      throw new Error(`Expected a \`companionUrl\` option containing a Companion address, or if you are not using Companion, a custom \`${method}\` implementation.`);
    }
  }
  createMultipartUpload(file, signal) {
    this.assertHost("createMultipartUpload");
    throwIfAborted2(signal);
    const metadata = getAllowedMetadata2({
      meta: file.meta,
      allowedMetaFields: this.opts.allowedMetaFields
    });
    return _classPrivateFieldLooseBase72(this, _client3)[_client3].post("s3/multipart", {
      filename: file.name,
      type: file.type,
      metadata
    }, {
      signal
    }).then(assertServerError3);
  }
  listParts(file, _ref5, signal) {
    let {
      key,
      uploadId
    } = _ref5;
    this.assertHost("listParts");
    throwIfAborted2(signal);
    const filename = encodeURIComponent(key);
    return _classPrivateFieldLooseBase72(this, _client3)[_client3].get(`s3/multipart/${uploadId}?key=${filename}`, {
      signal
    }).then(assertServerError3);
  }
  completeMultipartUpload(file, _ref6, signal) {
    let {
      key,
      uploadId,
      parts
    } = _ref6;
    this.assertHost("completeMultipartUpload");
    throwIfAborted2(signal);
    const filename = encodeURIComponent(key);
    const uploadIdEnc = encodeURIComponent(uploadId);
    return _classPrivateFieldLooseBase72(this, _client3)[_client3].post(`s3/multipart/${uploadIdEnc}/complete?key=${filename}`, {
      parts
    }, {
      signal
    }).then(assertServerError3);
  }
  async createSignedURL(file, options7) {
    const data = await _classPrivateFieldLooseBase72(this, _getTemporarySecurityCredentials3)[_getTemporarySecurityCredentials3](options7);
    const expires = getExpiry2(data.credentials) || 604800;
    const {
      uploadId,
      key,
      partNumber,
      signal
    } = options7;
    return {
      method: "PUT",
      expires,
      fields: {},
      url: `${await createSignedURL2({
        accountKey: data.credentials.AccessKeyId,
        accountSecret: data.credentials.SecretAccessKey,
        sessionToken: data.credentials.SessionToken,
        expires,
        bucketName: data.bucket,
        Region: data.region,
        Key: key != null ? key : `${crypto.randomUUID()}-${file.name}`,
        uploadId,
        partNumber,
        signal
      })}`,
      // Provide content type header required by S3
      headers: {
        "Content-Type": file.type
      }
    };
  }
  signPart(file, _ref7) {
    let {
      uploadId,
      key,
      partNumber,
      signal
    } = _ref7;
    this.assertHost("signPart");
    throwIfAborted2(signal);
    if (uploadId == null || key == null || partNumber == null) {
      throw new Error("Cannot sign without a key, an uploadId, and a partNumber");
    }
    const filename = encodeURIComponent(key);
    return _classPrivateFieldLooseBase72(this, _client3)[_client3].get(`s3/multipart/${uploadId}/${partNumber}?key=${filename}`, {
      signal
    }).then(assertServerError3);
  }
  abortMultipartUpload(file, _ref8, signal) {
    let {
      key,
      uploadId
    } = _ref8;
    this.assertHost("abortMultipartUpload");
    const filename = encodeURIComponent(key);
    const uploadIdEnc = encodeURIComponent(uploadId);
    return _classPrivateFieldLooseBase72(this, _client3)[_client3].delete(`s3/multipart/${uploadIdEnc}?key=${filename}`, void 0, {
      signal
    }).then(assertServerError3);
  }
  getUploadParameters(file, options7) {
    const {
      meta
    } = file;
    const {
      type,
      name: filename
    } = meta;
    const metadata = getAllowedMetadata2({
      meta,
      allowedMetaFields: this.opts.allowedMetaFields,
      querify: true
    });
    const query3 = new URLSearchParams({
      filename,
      type,
      ...metadata
    });
    return _classPrivateFieldLooseBase72(this, _client3)[_client3].get(`s3/params?${query3}`, options7);
  }
  static async uploadPartBytes(_ref9) {
    let {
      signature: {
        url,
        expires,
        headers,
        method = "PUT"
      },
      body,
      size = body.size,
      onProgress,
      onComplete,
      signal
    } = _ref9;
    throwIfAborted2(signal);
    if (url == null) {
      throw new Error("Cannot upload to an undefined URL");
    }
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open(method, url, true);
      if (headers) {
        Object.keys(headers).forEach((key) => {
          xhr.setRequestHeader(key, headers[key]);
        });
      }
      xhr.responseType = "text";
      if (typeof expires === "number") {
        xhr.timeout = expires * 1e3;
      }
      function onabort() {
        xhr.abort();
      }
      function cleanup() {
        signal.removeEventListener("abort", onabort);
      }
      signal.addEventListener("abort", onabort);
      xhr.upload.addEventListener("progress", (ev) => {
        onProgress(ev);
      });
      xhr.addEventListener("abort", () => {
        cleanup();
        reject(createAbortError2());
      });
      xhr.addEventListener("timeout", () => {
        cleanup();
        const error = new Error("Request has expired");
        error.source = {
          status: 403
        };
        reject(error);
      });
      xhr.addEventListener("load", (ev) => {
        cleanup();
        if (ev.target.status === 403 && ev.target.responseText.includes("<Message>Request has expired</Message>")) {
          const error = new Error("Request has expired");
          error.source = ev.target;
          reject(error);
          return;
        }
        if (ev.target.status < 200 || ev.target.status >= 300) {
          const error = new Error("Non 2xx");
          error.source = ev.target;
          reject(error);
          return;
        }
        onProgress == null || onProgress({
          loaded: size,
          lengthComputable: true
        });
        const etag = ev.target.getResponseHeader("ETag");
        const location2 = ev.target.getResponseHeader("Location");
        if (method.toUpperCase() === "POST" && location2 === null) {
          console.warn("AwsS3/Multipart: Could not read the Location header. This likely means CORS is not configured correctly on the S3 Bucket. See https://uppy.io/docs/aws-s3-multipart#S3-Bucket-Configuration for instructions.");
        }
        if (etag === null) {
          reject(new Error("AwsS3/Multipart: Could not read the ETag header. This likely means CORS is not configured correctly on the S3 Bucket. See https://uppy.io/docs/aws-s3-multipart#S3-Bucket-Configuration for instructions."));
          return;
        }
        onComplete == null || onComplete(etag);
        resolve({
          ETag: etag,
          ...location2 ? {
            location: location2
          } : void 0
        });
      });
      xhr.addEventListener("error", (ev) => {
        cleanup();
        const error = new Error("Unknown error");
        error.source = ev.target;
        reject(error);
      });
      xhr.send(body);
    });
  }
  install() {
    _classPrivateFieldLooseBase72(this, _setResumableUploadsCapability2)[_setResumableUploadsCapability2](true);
    this.uppy.addPreProcessor(_classPrivateFieldLooseBase72(this, _setCompanionHeaders3)[_setCompanionHeaders3]);
    this.uppy.addUploader(_classPrivateFieldLooseBase72(this, _upload2)[_upload2]);
    this.uppy.on("cancel-all", _classPrivateFieldLooseBase72(this, _resetResumableCapability2)[_resetResumableCapability2]);
  }
  uninstall() {
    this.uppy.removePreProcessor(_classPrivateFieldLooseBase72(this, _setCompanionHeaders3)[_setCompanionHeaders3]);
    this.uppy.removeUploader(_classPrivateFieldLooseBase72(this, _upload2)[_upload2]);
    this.uppy.off("cancel-all", _classPrivateFieldLooseBase72(this, _resetResumableCapability2)[_resetResumableCapability2]);
  }
};
async function _getTemporarySecurityCredentials22(options7) {
  throwIfAborted2(options7 == null ? void 0 : options7.signal);
  if (_classPrivateFieldLooseBase72(this, _cachedTemporaryCredentials2)[_cachedTemporaryCredentials2] == null) {
    if (this.opts.getTemporarySecurityCredentials === true) {
      this.assertHost("getTemporarySecurityCredentials");
      _classPrivateFieldLooseBase72(this, _cachedTemporaryCredentials2)[_cachedTemporaryCredentials2] = _classPrivateFieldLooseBase72(this, _client3)[_client3].get("s3/sts", null, options7).then(assertServerError3);
    } else {
      _classPrivateFieldLooseBase72(this, _cachedTemporaryCredentials2)[_cachedTemporaryCredentials2] = this.opts.getTemporarySecurityCredentials(options7);
    }
    _classPrivateFieldLooseBase72(this, _cachedTemporaryCredentials2)[_cachedTemporaryCredentials2] = await _classPrivateFieldLooseBase72(this, _cachedTemporaryCredentials2)[_cachedTemporaryCredentials2];
    setTimeout(() => {
      _classPrivateFieldLooseBase72(this, _cachedTemporaryCredentials2)[_cachedTemporaryCredentials2] = null;
    }, (getExpiry2(_classPrivateFieldLooseBase72(this, _cachedTemporaryCredentials2)[_cachedTemporaryCredentials2].credentials) || 0) * 500);
  }
  return _classPrivateFieldLooseBase72(this, _cachedTemporaryCredentials2)[_cachedTemporaryCredentials2];
}
function _uploadLocalFile22(file) {
  var _this = this;
  return new Promise((resolve, reject) => {
    const onProgress = (bytesUploaded, bytesTotal) => {
      this.uppy.emit("upload-progress", this.uppy.getFile(file.id), {
        uploader: this,
        bytesUploaded,
        bytesTotal
      });
    };
    const onError = (err) => {
      this.uppy.log(err);
      this.uppy.emit("upload-error", file, err);
      this.resetUploaderReferences(file.id);
      reject(err);
    };
    const onSuccess = (result) => {
      const uploadResp = {
        body: {
          ...result
        },
        uploadURL: result.location
      };
      this.resetUploaderReferences(file.id);
      this.uppy.emit("upload-success", _classPrivateFieldLooseBase72(this, _getFile22)[_getFile22](file), uploadResp);
      if (result.location) {
        this.uppy.log(`Download ${file.name} from ${result.location}`);
      }
      resolve();
    };
    const onPartComplete = (part) => {
      this.uppy.emit("s3-multipart:part-uploaded", _classPrivateFieldLooseBase72(this, _getFile22)[_getFile22](file), part);
    };
    const upload = new MultipartUploader_default2(file.data, {
      // .bind to pass the file object to each handler.
      companionComm: _classPrivateFieldLooseBase72(this, _companionCommunicationQueue2)[_companionCommunicationQueue2],
      log: function() {
        return _this.uppy.log(...arguments);
      },
      getChunkSize: this.opts.getChunkSize ? this.opts.getChunkSize.bind(this) : null,
      onProgress,
      onError,
      onSuccess,
      onPartComplete,
      file,
      shouldUseMultipart: this.opts.shouldUseMultipart,
      ...file.s3Multipart
    });
    this.uploaders[file.id] = upload;
    const eventManager = new EventManager2(this.uppy);
    this.uploaderEvents[file.id] = eventManager;
    eventManager.onFileRemove(file.id, (removed) => {
      upload.abort();
      this.resetUploaderReferences(file.id, {
        abort: true
      });
      resolve(`upload ${removed.id} was removed`);
    });
    eventManager.onCancelAll(file.id, function(_temp) {
      let {
        reason
      } = _temp === void 0 ? {} : _temp;
      if (reason === "user") {
        upload.abort();
        _this.resetUploaderReferences(file.id, {
          abort: true
        });
      }
      resolve(`upload ${file.id} was canceled`);
    });
    eventManager.onFilePause(file.id, (isPaused) => {
      if (isPaused) {
        upload.pause();
      } else {
        upload.start();
      }
    });
    eventManager.onPauseAll(file.id, () => {
      upload.pause();
    });
    eventManager.onResumeAll(file.id, () => {
      upload.start();
    });
    upload.start();
  });
}
function _getCompanionClientArgs22(file) {
  return {
    ...file.remote.body,
    protocol: "s3-multipart",
    size: file.data.size,
    metadata: file.meta
  };
}
AwsS3Multipart2.VERSION = packageJson22.version;
var urlAlphabet2 = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
var nanoid2 = (size = 21) => {
  let id18 = "";
  let i4 = size;
  while (i4--) {
    id18 += urlAlphabet2[Math.random() * 64 | 0];
  }
  return id18;
};
function _classPrivateFieldLooseBase82(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id82 = 0;
function _classPrivateFieldLooseKey82(name) {
  return "__private_" + id82++ + "_" + name;
}
var _aliveTimer2 = /* @__PURE__ */ _classPrivateFieldLooseKey82("aliveTimer");
var _isDone2 = /* @__PURE__ */ _classPrivateFieldLooseKey82("isDone");
var _onTimedOut2 = /* @__PURE__ */ _classPrivateFieldLooseKey82("onTimedOut");
var _timeout2 = /* @__PURE__ */ _classPrivateFieldLooseKey82("timeout");
var ProgressTimeout2 = class {
  constructor(timeout, timeoutHandler) {
    Object.defineProperty(this, _aliveTimer2, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _isDone2, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _onTimedOut2, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _timeout2, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldLooseBase82(this, _timeout2)[_timeout2] = timeout;
    _classPrivateFieldLooseBase82(this, _onTimedOut2)[_onTimedOut2] = timeoutHandler;
  }
  progress() {
    if (_classPrivateFieldLooseBase82(this, _isDone2)[_isDone2])
      return;
    if (_classPrivateFieldLooseBase82(this, _timeout2)[_timeout2] > 0) {
      clearTimeout(_classPrivateFieldLooseBase82(this, _aliveTimer2)[_aliveTimer2]);
      _classPrivateFieldLooseBase82(this, _aliveTimer2)[_aliveTimer2] = setTimeout(_classPrivateFieldLooseBase82(this, _onTimedOut2)[_onTimedOut2], _classPrivateFieldLooseBase82(this, _timeout2)[_timeout2]);
    }
  }
  done() {
    if (!_classPrivateFieldLooseBase82(this, _isDone2)[_isDone2]) {
      clearTimeout(_classPrivateFieldLooseBase82(this, _aliveTimer2)[_aliveTimer2]);
      _classPrivateFieldLooseBase82(this, _aliveTimer2)[_aliveTimer2] = void 0;
      _classPrivateFieldLooseBase82(this, _isDone2)[_isDone2] = true;
    }
  }
};
var ProgressTimeout_default2 = ProgressTimeout2;
function isNetworkError22(xhr) {
  if (!xhr) {
    return false;
  }
  return xhr.readyState !== 0 && xhr.readyState !== 4 || xhr.status === 0;
}
var isNetworkError_default2 = isNetworkError22;
function _classPrivateFieldLooseBase92(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id92 = 0;
function _classPrivateFieldLooseKey92(name) {
  return "__private_" + id92++ + "_" + name;
}
function buildResponseError2(xhr, error) {
  if (isNetworkError_default2(xhr))
    return new NetworkError_default2(error, xhr);
  const err = new ErrorWithCause_default2("Upload error", {
    cause: error
  });
  err.request = xhr;
  return err;
}
function setTypeInBlob2(file) {
  const dataWithUpdatedType = file.data.slice(0, file.data.size, file.meta.type);
  return dataWithUpdatedType;
}
function addMetadata2(formData, meta, opts) {
  const allowedMetaFields = Array.isArray(opts.allowedMetaFields) ? opts.allowedMetaFields : Object.keys(meta);
  allowedMetaFields.forEach((item) => {
    formData.append(item, meta[item]);
  });
}
function createFormDataUpload2(file, opts) {
  const formPost = new FormData();
  addMetadata2(formPost, file.meta, opts);
  const dataWithUpdatedType = setTypeInBlob2(file);
  if (file.name) {
    formPost.append(opts.fieldName, dataWithUpdatedType, file.meta.name);
  } else {
    formPost.append(opts.fieldName, dataWithUpdatedType);
  }
  return formPost;
}
var createBareUpload2 = (file) => file.data;
var _addEventHandlerForFile3 = /* @__PURE__ */ _classPrivateFieldLooseKey92("addEventHandlerForFile");
var _addEventHandlerIfFileStillExists3 = /* @__PURE__ */ _classPrivateFieldLooseKey92("addEventHandlerIfFileStillExists");
var MiniXHRUpload2 = class {
  constructor(uppy22, opts) {
    Object.defineProperty(this, _addEventHandlerIfFileStillExists3, {
      value: _addEventHandlerIfFileStillExists22
    });
    Object.defineProperty(this, _addEventHandlerForFile3, {
      value: _addEventHandlerForFile22
    });
    this.uppy = uppy22;
    this.opts = {
      validateStatus(status) {
        return status >= 200 && status < 300;
      },
      ...opts
    };
    this.requests = opts[internalRateLimitedQueue2];
    this.uploaderEvents = /* @__PURE__ */ Object.create(null);
    this.i18n = opts.i18n;
  }
  getOptions(file) {
    var _file$xhrUpload;
    const {
      uppy: uppy22
    } = this;
    const overrides = uppy22.getState().xhrUpload;
    const opts = {
      ...this.opts,
      ...overrides || {},
      ...file.xhrUpload || {},
      headers: {
        ...this.opts.headers,
        ...overrides == null ? void 0 : overrides.headers,
        ...(_file$xhrUpload = file.xhrUpload) == null ? void 0 : _file$xhrUpload.headers
      }
    };
    return opts;
  }
  uploadLocalFile(file) {
    const opts = this.getOptions(file);
    return new Promise((resolve, reject) => {
      const data = opts.formData ? createFormDataUpload2(file, opts) : createBareUpload2(file, opts);
      const xhr = new XMLHttpRequest();
      this.uploaderEvents[file.id] = new EventManager2(this.uppy);
      const timer = new ProgressTimeout_default2(opts.timeout, () => {
        xhr.abort();
        queuedRequest.done();
        const error = new Error(this.i18n("timedOut", {
          seconds: Math.ceil(opts.timeout / 1e3)
        }));
        this.uppy.emit("upload-error", file, error);
        reject(error);
      });
      const id18 = nanoid2();
      xhr.upload.addEventListener("loadstart", () => {
        this.uppy.log(`[AwsS3/XHRUpload] ${id18} started`);
      });
      xhr.upload.addEventListener("progress", (ev) => {
        this.uppy.log(`[AwsS3/XHRUpload] ${id18} progress: ${ev.loaded} / ${ev.total}`);
        timer.progress();
        if (ev.lengthComputable) {
          this.uppy.emit("upload-progress", this.uppy.getFile(file.id), {
            uploader: this,
            bytesUploaded: ev.loaded,
            bytesTotal: ev.total
          });
        }
      });
      xhr.addEventListener("load", (ev) => {
        this.uppy.log(`[AwsS3/XHRUpload] ${id18} finished`);
        timer.done();
        queuedRequest.done();
        if (this.uploaderEvents[file.id]) {
          this.uploaderEvents[file.id].remove();
          this.uploaderEvents[file.id] = null;
        }
        if (opts.validateStatus(ev.target.status, xhr.responseText, xhr)) {
          const body2 = opts.getResponseData(xhr.responseText, xhr);
          const uploadURL = body2[opts.responseUrlFieldName];
          const uploadResp = {
            status: ev.target.status,
            body: body2,
            uploadURL
          };
          this.uppy.emit("upload-success", this.uppy.getFile(file.id), uploadResp);
          if (uploadURL) {
            this.uppy.log(`Download ${file.name} from ${uploadURL}`);
          }
          return resolve(file);
        }
        const body = opts.getResponseData(xhr.responseText, xhr);
        const error = buildResponseError2(xhr, opts.getResponseError(xhr.responseText, xhr));
        const response = {
          status: ev.target.status,
          body
        };
        this.uppy.emit("upload-error", file, error, response);
        return reject(error);
      });
      xhr.addEventListener("error", () => {
        this.uppy.log(`[AwsS3/XHRUpload] ${id18} errored`);
        timer.done();
        queuedRequest.done();
        if (this.uploaderEvents[file.id]) {
          this.uploaderEvents[file.id].remove();
          this.uploaderEvents[file.id] = null;
        }
        const error = buildResponseError2(xhr, opts.getResponseError(xhr.responseText, xhr));
        this.uppy.emit("upload-error", file, error);
        return reject(error);
      });
      xhr.open(opts.method.toUpperCase(), opts.endpoint, true);
      xhr.withCredentials = Boolean(opts.withCredentials);
      if (opts.responseType !== "") {
        xhr.responseType = opts.responseType;
      }
      Object.keys(opts.headers).forEach((header) => {
        xhr.setRequestHeader(header, opts.headers[header]);
      });
      const queuedRequest = this.requests.run(() => {
        xhr.send(data);
        return () => {
          timer.done();
          xhr.abort();
        };
      }, {
        priority: 1
      });
      _classPrivateFieldLooseBase92(this, _addEventHandlerForFile3)[_addEventHandlerForFile3]("file-removed", file.id, () => {
        queuedRequest.abort();
        reject(new Error("File removed"));
      });
      _classPrivateFieldLooseBase92(this, _addEventHandlerIfFileStillExists3)[_addEventHandlerIfFileStillExists3]("cancel-all", file.id, function(_temp) {
        let {
          reason
        } = _temp === void 0 ? {} : _temp;
        if (reason === "user") {
          queuedRequest.abort();
        }
        reject(new Error("Upload cancelled"));
      });
    });
  }
};
function _addEventHandlerForFile22(eventName, fileID, eventHandler) {
  this.uploaderEvents[fileID].on(eventName, (fileOrID) => {
    var _fileOrID$id;
    const id18 = (_fileOrID$id = fileOrID == null ? void 0 : fileOrID.id) != null ? _fileOrID$id : fileOrID;
    if (fileID === id18)
      eventHandler();
  });
}
function _addEventHandlerIfFileStillExists22(eventName, fileID, eventHandler) {
  var _this = this;
  this.uploaderEvents[fileID].on(eventName, function() {
    if (_this.uppy.getFile(fileID))
      eventHandler(...arguments);
  });
}
function removeMimeParameters2(mimeType) {
  return mimeType.replace(/;.*$/, "");
}
function isXml2(content, xhr) {
  const rawContentType = xhr.headers ? xhr.headers["content-type"] : xhr.getResponseHeader("Content-Type");
  if (typeof rawContentType === "string") {
    const contentType = removeMimeParameters2(rawContentType).toLowerCase();
    if (contentType === "application/xml" || contentType === "text/xml") {
      return true;
    }
    if (contentType === "text/html" && /^<\?xml /.test(content)) {
      return true;
    }
  }
  return false;
}
var isXml_default2 = isXml2;
var locale_default5 = {
  strings: {
    timedOut: "Upload stalled for %{seconds} seconds, aborting."
  }
};
var _Symbol$for42;
function _classPrivateFieldLooseBase102(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id102 = 0;
function _classPrivateFieldLooseKey102(name) {
  return "__private_" + id102++ + "_" + name;
}
var packageJson32 = {
  "version": "3.6.2"
};
function resolveUrl2(origin, link) {
  if (!origin && !link.startsWith("https://") && !link.startsWith("http://")) {
    link = `https://${link}`;
  }
  return new URL(link, origin || void 0).toString();
}
function getXmlValue2(source, tagName) {
  const start = source.indexOf(`<${tagName}>`);
  const end = source.indexOf(`</${tagName}>`, start);
  return start !== -1 && end !== -1 ? source.slice(start + tagName.length + 2, end) : "";
}
function assertServerError22(res) {
  if (res && res.error) {
    const error = new Error(res.message);
    Object.assign(error, res.error);
    throw error;
  }
  return res;
}
function validateParameters2(file, params) {
  const valid = params != null && typeof params.url === "string" && (typeof params.fields === "object" || params.fields == null);
  if (!valid) {
    const err = new TypeError(`AwsS3: got incorrect result from 'getUploadParameters()' for file '${file.name}', expected an object '{ url, method, fields, headers }' but got '${JSON.stringify(params)}' instead.
See https://uppy.io/docs/aws-s3/#getUploadParameters-file for more on the expected format.`);
    throw err;
  }
  const methodIsValid = params.method == null || /^p(u|os)t$/i.test(params.method);
  if (!methodIsValid) {
    const err = new TypeError(`AwsS3: got incorrect method from 'getUploadParameters()' for file '${file.name}', expected  'PUT' or 'POST' but got '${params.method}' instead.
See https://uppy.io/docs/aws-s3/#getUploadParameters-file for more on the expected format.`);
    throw err;
  }
}
function defaultGetResponseError2(content, xhr) {
  if (!isXml_default2(content, xhr)) {
    return void 0;
  }
  const error = getXmlValue2(content, "Message");
  return new Error(error);
}
var warnedSuccessActionStatus2 = false;
var _client22 = /* @__PURE__ */ _classPrivateFieldLooseKey102("client");
var _requests22 = /* @__PURE__ */ _classPrivateFieldLooseKey102("requests");
var _uploader2 = /* @__PURE__ */ _classPrivateFieldLooseKey102("uploader");
var _handleUpload2 = /* @__PURE__ */ _classPrivateFieldLooseKey102("handleUpload");
var _setCompanionHeaders22 = /* @__PURE__ */ _classPrivateFieldLooseKey102("setCompanionHeaders");
var _getCompanionClientArgs32 = /* @__PURE__ */ _classPrivateFieldLooseKey102("getCompanionClientArgs");
_Symbol$for42 = Symbol.for("uppy test: getClient");
var AwsS32 = class extends BasePlugin3 {
  constructor(uppy22, _opts) {
    if ((_opts == null ? void 0 : _opts.shouldUseMultipart) != null) {
      return new AwsS3Multipart2(uppy22, _opts);
    }
    super(uppy22, _opts);
    Object.defineProperty(this, _client22, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _requests22, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _uploader2, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _handleUpload2, {
      writable: true,
      value: async (fileIDs) => {
        const paramsPromises = /* @__PURE__ */ Object.create(null);
        function onremove(file) {
          var _paramsPromises$id;
          const {
            id: id18
          } = file;
          (_paramsPromises$id = paramsPromises[id18]) == null || _paramsPromises$id.abort();
        }
        this.uppy.on("file-removed", onremove);
        const files = this.uppy.getFilesByIds(fileIDs);
        const filesFiltered = filterNonFailedFiles2(files);
        const filesToEmit = filterFilesToEmitUploadStarted2(filesFiltered);
        this.uppy.emit("upload-start", filesToEmit);
        const getUploadParameters = _classPrivateFieldLooseBase102(this, _requests22)[_requests22].wrapPromiseFunction((file) => {
          return this.opts.getUploadParameters(file);
        });
        const numberOfFiles = fileIDs.length;
        return Promise.allSettled(fileIDs.map((id18, index2) => {
          paramsPromises[id18] = getUploadParameters(this.uppy.getFile(id18));
          return paramsPromises[id18].then((params) => {
            delete paramsPromises[id18];
            const file = this.uppy.getFile(id18);
            validateParameters2(file, params);
            const {
              method = "POST",
              url,
              fields,
              headers
            } = params;
            const xhrOpts = {
              method,
              formData: method.toUpperCase() === "POST",
              endpoint: url,
              allowedMetaFields: fields ? Object.keys(fields) : []
            };
            if (headers) {
              xhrOpts.headers = headers;
            }
            this.uppy.setFileState(file.id, {
              meta: {
                ...file.meta,
                ...fields
              },
              xhrUpload: xhrOpts
            });
            return this.uploadFile(file.id, index2, numberOfFiles);
          }).catch((error) => {
            delete paramsPromises[id18];
            const file = this.uppy.getFile(id18);
            this.uppy.emit("upload-error", file, error);
            return Promise.reject(error);
          });
        })).finally(() => {
          this.uppy.off("file-removed", onremove);
        });
      }
    });
    Object.defineProperty(this, _setCompanionHeaders22, {
      writable: true,
      value: () => {
        _classPrivateFieldLooseBase102(this, _client22)[_client22].setCompanionHeaders(this.opts.companionHeaders);
        return Promise.resolve();
      }
    });
    Object.defineProperty(this, _getCompanionClientArgs32, {
      writable: true,
      value: (file) => {
        const opts = _classPrivateFieldLooseBase102(this, _uploader2)[_uploader2].getOptions(file);
        const allowedMetaFields = Array.isArray(opts.allowedMetaFields) ? opts.allowedMetaFields : Object.keys(file.meta);
        return {
          ...file.remote.body,
          protocol: "multipart",
          endpoint: opts.endpoint,
          size: file.data.size,
          fieldname: opts.fieldName,
          metadata: Object.fromEntries(allowedMetaFields.map((name) => [name, file.meta[name]])),
          httpMethod: opts.method,
          useFormData: opts.formData,
          headers: typeof opts.headers === "function" ? opts.headers(file) : opts.headers
        };
      }
    });
    this.type = "uploader";
    this.id = this.opts.id || "AwsS3";
    this.title = "AWS S3";
    this.defaultLocale = locale_default5;
    const defaultOptions8 = {
      timeout: 30 * 1e3,
      limit: 0,
      allowedMetaFields: [],
      // have to opt in
      getUploadParameters: this.getUploadParameters.bind(this),
      shouldUseMultipart: false,
      companionHeaders: {}
    };
    this.opts = {
      ...defaultOptions8,
      ..._opts
    };
    if ((_opts == null ? void 0 : _opts.allowedMetaFields) === void 0 && "metaFields" in this.opts) {
      throw new Error("The `metaFields` option has been renamed to `allowedMetaFields`.");
    }
    this.i18nInit();
    _classPrivateFieldLooseBase102(this, _client22)[_client22] = new RequestClient2(uppy22, _opts);
    _classPrivateFieldLooseBase102(this, _requests22)[_requests22] = new RateLimitedQueue2(this.opts.limit);
  }
  [_Symbol$for42]() {
    return _classPrivateFieldLooseBase102(this, _client22)[_client22];
  }
  // TODO: remove getter and setter for #client on the next major release
  get client() {
    return _classPrivateFieldLooseBase102(this, _client22)[_client22];
  }
  set client(client) {
    _classPrivateFieldLooseBase102(this, _client22)[_client22] = client;
  }
  getUploadParameters(file) {
    if (!this.opts.companionUrl) {
      throw new Error("Expected a `companionUrl` option containing a Companion address.");
    }
    const filename = file.meta.name;
    const {
      type
    } = file.meta;
    const metadata = Object.fromEntries(this.opts.allowedMetaFields.filter((key) => file.meta[key] != null).map((key) => [`metadata[${key}]`, file.meta[key].toString()]));
    const query3 = new URLSearchParams({
      filename,
      type,
      ...metadata
    });
    return _classPrivateFieldLooseBase102(this, _client22)[_client22].get(`s3/params?${query3}`).then(assertServerError22);
  }
  uploadFile(id18, current, total) {
    const file = this.uppy.getFile(id18);
    this.uppy.log(`uploading ${current} of ${total}`);
    if (file.error)
      throw new Error(file.error);
    if (file.isRemote) {
      const getQueue = () => _classPrivateFieldLooseBase102(this, _requests22)[_requests22];
      const controller = new AbortController();
      const removedHandler = (removedFile) => {
        if (removedFile.id === file.id)
          controller.abort();
      };
      this.uppy.on("file-removed", removedHandler);
      const uploadPromise = this.uppy.getRequestClientForFile(file).uploadRemoteFile(file, _classPrivateFieldLooseBase102(this, _getCompanionClientArgs32)[_getCompanionClientArgs32](file), {
        signal: controller.signal,
        getQueue
      });
      _classPrivateFieldLooseBase102(this, _requests22)[_requests22].wrapSyncFunction(() => {
        this.uppy.off("file-removed", removedHandler);
      }, {
        priority: -1
      })();
      return uploadPromise;
    }
    return _classPrivateFieldLooseBase102(this, _uploader2)[_uploader2].uploadLocalFile(file, current, total);
  }
  install() {
    const {
      uppy: uppy22
    } = this;
    uppy22.addPreProcessor(_classPrivateFieldLooseBase102(this, _setCompanionHeaders22)[_setCompanionHeaders22]);
    uppy22.addUploader(_classPrivateFieldLooseBase102(this, _handleUpload2)[_handleUpload2]);
    function defaultGetResponseData(content, xhr) {
      const opts = this;
      if (!isXml_default2(content, xhr)) {
        if (opts.method.toUpperCase() === "POST") {
          if (!warnedSuccessActionStatus2) {
            uppy22.log("[AwsS3] No response data found, make sure to set the success_action_status AWS SDK option to 201. See https://uppy.io/docs/aws-s3/#POST-Uploads", "warning");
            warnedSuccessActionStatus2 = true;
          }
          return {
            location: null
          };
        }
        if (!xhr.responseURL) {
          return {
            location: null
          };
        }
        return {
          location: xhr.responseURL.replace(/\?.*$/, "")
        };
      }
      return {
        // Some S3 alternatives do not reply with an absolute URL.
        // Eg DigitalOcean Spaces uses /$bucketName/xyz
        location: resolveUrl2(xhr.responseURL, getXmlValue2(content, "Location")),
        bucket: getXmlValue2(content, "Bucket"),
        key: getXmlValue2(content, "Key"),
        etag: getXmlValue2(content, "ETag")
      };
    }
    const xhrOptions = {
      fieldName: "file",
      responseUrlFieldName: "location",
      timeout: this.opts.timeout,
      // Share the rate limiting queue with XHRUpload.
      [internalRateLimitedQueue2]: _classPrivateFieldLooseBase102(this, _requests22)[_requests22],
      responseType: "text",
      getResponseData: this.opts.getResponseData || defaultGetResponseData,
      getResponseError: defaultGetResponseError2
    };
    xhrOptions.i18n = this.i18n;
    _classPrivateFieldLooseBase102(this, _uploader2)[_uploader2] = new MiniXHRUpload2(uppy22, xhrOptions);
  }
  uninstall() {
    this.uppy.removePreProcessor(_classPrivateFieldLooseBase102(this, _setCompanionHeaders22)[_setCompanionHeaders22]);
    this.uppy.removeUploader(_classPrivateFieldLooseBase102(this, _handleUpload2)[_handleUpload2]);
  }
};
AwsS32.VERSION = packageJson32.version;
var import_namespace_emitter22 = __toESM2(require_namespace_emitter2(), 1);
var import_throttle22 = __toESM2(require_throttle2(), 1);
function _classPrivateFieldLooseBase112(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id112 = 0;
function _classPrivateFieldLooseKey112(name) {
  return "__private_" + id112++ + "_" + name;
}
var packageJson42 = {
  "version": "3.2.2"
};
var _callbacks = /* @__PURE__ */ _classPrivateFieldLooseKey112("callbacks");
var _publish = /* @__PURE__ */ _classPrivateFieldLooseKey112("publish");
var DefaultStore = class {
  constructor() {
    Object.defineProperty(this, _publish, {
      value: _publish2
    });
    this.state = {};
    Object.defineProperty(this, _callbacks, {
      writable: true,
      value: /* @__PURE__ */ new Set()
    });
  }
  getState() {
    return this.state;
  }
  setState(patch) {
    const prevState = {
      ...this.state
    };
    const nextState = {
      ...this.state,
      ...patch
    };
    this.state = nextState;
    _classPrivateFieldLooseBase112(this, _publish)[_publish](prevState, nextState, patch);
  }
  subscribe(listener) {
    _classPrivateFieldLooseBase112(this, _callbacks)[_callbacks].add(listener);
    return () => {
      _classPrivateFieldLooseBase112(this, _callbacks)[_callbacks].delete(listener);
    };
  }
};
function _publish2() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  _classPrivateFieldLooseBase112(this, _callbacks)[_callbacks].forEach((listener) => {
    listener(...args);
  });
}
DefaultStore.VERSION = packageJson42.version;
var lib_default = DefaultStore;
function getFileNameAndExtension(fullFileName) {
  const lastDot = fullFileName.lastIndexOf(".");
  if (lastDot === -1 || lastDot === fullFileName.length - 1) {
    return {
      name: fullFileName,
      extension: void 0
    };
  }
  return {
    name: fullFileName.slice(0, lastDot),
    extension: fullFileName.slice(lastDot + 1)
  };
}
var mimeTypes_default = {
  __proto__: null,
  md: "text/markdown",
  markdown: "text/markdown",
  mp4: "video/mp4",
  mp3: "audio/mp3",
  svg: "image/svg+xml",
  jpg: "image/jpeg",
  png: "image/png",
  webp: "image/webp",
  gif: "image/gif",
  heic: "image/heic",
  heif: "image/heif",
  yaml: "text/yaml",
  yml: "text/yaml",
  csv: "text/csv",
  tsv: "text/tab-separated-values",
  tab: "text/tab-separated-values",
  avi: "video/x-msvideo",
  mks: "video/x-matroska",
  mkv: "video/x-matroska",
  mov: "video/quicktime",
  dicom: "application/dicom",
  doc: "application/msword",
  docm: "application/vnd.ms-word.document.macroenabled.12",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  dot: "application/msword",
  dotm: "application/vnd.ms-word.template.macroenabled.12",
  dotx: "application/vnd.openxmlformats-officedocument.wordprocessingml.template",
  xla: "application/vnd.ms-excel",
  xlam: "application/vnd.ms-excel.addin.macroenabled.12",
  xlc: "application/vnd.ms-excel",
  xlf: "application/x-xliff+xml",
  xlm: "application/vnd.ms-excel",
  xls: "application/vnd.ms-excel",
  xlsb: "application/vnd.ms-excel.sheet.binary.macroenabled.12",
  xlsm: "application/vnd.ms-excel.sheet.macroenabled.12",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  xlt: "application/vnd.ms-excel",
  xltm: "application/vnd.ms-excel.template.macroenabled.12",
  xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template",
  xlw: "application/vnd.ms-excel",
  txt: "text/plain",
  text: "text/plain",
  conf: "text/plain",
  log: "text/plain",
  pdf: "application/pdf",
  zip: "application/zip",
  "7z": "application/x-7z-compressed",
  rar: "application/x-rar-compressed",
  tar: "application/x-tar",
  gz: "application/gzip",
  dmg: "application/x-apple-diskimage"
};
function getFileType(file) {
  var _getFileNameAndExtens;
  if (file.type)
    return file.type;
  const fileExtension = file.name ? (_getFileNameAndExtens = getFileNameAndExtension(file.name).extension) == null ? void 0 : _getFileNameAndExtens.toLowerCase() : null;
  if (fileExtension && fileExtension in mimeTypes_default) {
    return mimeTypes_default[fileExtension];
  }
  return "application/octet-stream";
}
function encodeCharacter(character) {
  return character.charCodeAt(0).toString(32);
}
function encodeFilename(name) {
  let suffix = "";
  return name.replace(/[^A-Z0-9]/gi, (character) => {
    suffix += `-${encodeCharacter(character)}`;
    return "/";
  }) + suffix;
}
function generateFileID(file) {
  let id18 = "uppy";
  if (typeof file.name === "string") {
    id18 += `-${encodeFilename(file.name.toLowerCase())}`;
  }
  if (file.type !== void 0) {
    id18 += `-${file.type}`;
  }
  if (file.meta && typeof file.meta.relativePath === "string") {
    id18 += `-${encodeFilename(file.meta.relativePath.toLowerCase())}`;
  }
  if (file.data.size !== void 0) {
    id18 += `-${file.data.size}`;
  }
  if (file.data.lastModified !== void 0) {
    id18 += `-${file.data.lastModified}`;
  }
  return id18;
}
function hasFileStableId(file) {
  if (!file.isRemote || !file.remote)
    return false;
  const stableIdProviders = /* @__PURE__ */ new Set(["box", "dropbox", "drive", "facebook", "unsplash"]);
  return stableIdProviders.has(file.remote.provider);
}
function getSafeFileId(file) {
  if (hasFileStableId(file))
    return file.id;
  const fileType = getFileType(file);
  return generateFileID({
    ...file,
    type: fileType
  });
}
function supportsUploadProgress(userAgent) {
  if (userAgent == null && typeof navigator !== "undefined") {
    userAgent = navigator.userAgent;
  }
  if (!userAgent)
    return true;
  const m4 = /Edge\/(\d+\.\d+)/.exec(userAgent);
  if (!m4)
    return true;
  const edgeVersion = m4[1];
  const version = edgeVersion.split(".", 2);
  const major = parseInt(version[0], 10);
  const minor = parseInt(version[1], 10);
  if (major < 15 || major === 15 && minor < 15063) {
    return true;
  }
  if (major > 18 || major === 18 && minor >= 18218) {
    return true;
  }
  return false;
}
function getFileName(fileType, fileDescriptor) {
  if (fileDescriptor.name) {
    return fileDescriptor.name;
  }
  if (fileType.split("/")[0] === "image") {
    return `${fileType.split("/")[0]}.${fileType.split("/")[1]}`;
  }
  return "noname";
}
function pad(number3) {
  return number3 < 10 ? `0${number3}` : number3.toString();
}
function getTimeStamp() {
  const date = /* @__PURE__ */ new Date();
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());
  return `${hours}:${minutes}:${seconds}`;
}
var justErrorsLogger = {
  debug: () => {
  },
  warn: () => {
  },
  error: function() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return console.error(`[Uppy] [${getTimeStamp()}]`, ...args);
  }
};
var debugLogger = {
  debug: function() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    return console.debug(`[Uppy] [${getTimeStamp()}]`, ...args);
  },
  warn: function() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }
    return console.warn(`[Uppy] [${getTimeStamp()}]`, ...args);
  },
  error: function() {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }
    return console.error(`[Uppy] [${getTimeStamp()}]`, ...args);
  }
};
var import_prettier_bytes2 = __toESM2(require_prettierBytes2(), 1);
var import_mime_match = __toESM2(require_mime_match(), 1);
var defaultOptions22 = {
  maxFileSize: null,
  minFileSize: null,
  maxTotalFileSize: null,
  maxNumberOfFiles: null,
  minNumberOfFiles: null,
  allowedFileTypes: null,
  requiredMetaFields: []
};
var RestrictionError = class extends Error {
  constructor(message, opts) {
    var _opts$isUserFacing;
    super(message);
    this.isRestriction = true;
    this.isUserFacing = (_opts$isUserFacing = opts == null ? void 0 : opts.isUserFacing) != null ? _opts$isUserFacing : true;
    if (opts != null && opts.file) {
      this.file = opts.file;
    }
  }
};
var Restricter = class {
  constructor(getOpts, i18n) {
    this.i18n = i18n;
    this.getOpts = () => {
      var _opts$restrictions;
      const opts = getOpts();
      if (((_opts$restrictions = opts.restrictions) == null ? void 0 : _opts$restrictions.allowedFileTypes) != null && !Array.isArray(opts.restrictions.allowedFileTypes)) {
        throw new TypeError("`restrictions.allowedFileTypes` must be an array");
      }
      return opts;
    };
  }
  // Because these operations are slow, we cannot run them for every file (if we are adding multiple files)
  validateAggregateRestrictions(existingFiles, addingFiles) {
    const {
      maxTotalFileSize,
      maxNumberOfFiles
    } = this.getOpts().restrictions;
    if (maxNumberOfFiles) {
      const nonGhostFiles = existingFiles.filter((f4) => !f4.isGhost);
      if (nonGhostFiles.length + addingFiles.length > maxNumberOfFiles) {
        throw new RestrictionError(`${this.i18n("youCanOnlyUploadX", {
          smart_count: maxNumberOfFiles
        })}`);
      }
    }
    if (maxTotalFileSize) {
      let totalFilesSize = existingFiles.reduce((total, f4) => {
        var _f$size;
        return total + ((_f$size = f4.size) != null ? _f$size : 0);
      }, 0);
      for (const addingFile of addingFiles) {
        if (addingFile.size != null) {
          totalFilesSize += addingFile.size;
          if (totalFilesSize > maxTotalFileSize) {
            throw new RestrictionError(this.i18n("exceedsSize", {
              size: (0, import_prettier_bytes2.default)(maxTotalFileSize),
              file: addingFile.name
            }));
          }
        }
      }
    }
  }
  validateSingleFile(file) {
    const {
      maxFileSize,
      minFileSize,
      allowedFileTypes
    } = this.getOpts().restrictions;
    if (allowedFileTypes) {
      const isCorrectFileType = allowedFileTypes.some((type) => {
        if (type.includes("/")) {
          if (!file.type)
            return false;
          return (0, import_mime_match.default)(file.type.replace(/;.*?$/, ""), type);
        }
        if (type[0] === "." && file.extension) {
          return file.extension.toLowerCase() === type.slice(1).toLowerCase();
        }
        return false;
      });
      if (!isCorrectFileType) {
        const allowedFileTypesString = allowedFileTypes.join(", ");
        throw new RestrictionError(this.i18n("youCanOnlyUploadFileTypes", {
          types: allowedFileTypesString
        }), {
          file
        });
      }
    }
    if (maxFileSize && file.size != null && file.size > maxFileSize) {
      throw new RestrictionError(this.i18n("exceedsSize", {
        size: (0, import_prettier_bytes2.default)(maxFileSize),
        file: file.name
      }), {
        file
      });
    }
    if (minFileSize && file.size != null && file.size < minFileSize) {
      throw new RestrictionError(this.i18n("inferiorSize", {
        size: (0, import_prettier_bytes2.default)(minFileSize)
      }), {
        file
      });
    }
  }
  validate(existingFiles, addingFiles) {
    addingFiles.forEach((addingFile) => {
      this.validateSingleFile(addingFile);
    });
    this.validateAggregateRestrictions(existingFiles, addingFiles);
  }
  validateMinNumberOfFiles(files) {
    const {
      minNumberOfFiles
    } = this.getOpts().restrictions;
    if (minNumberOfFiles && Object.keys(files).length < minNumberOfFiles) {
      throw new RestrictionError(this.i18n("youHaveToAtLeastSelectX", {
        smart_count: minNumberOfFiles
      }));
    }
  }
  getMissingRequiredMetaFields(file) {
    const error = new RestrictionError(this.i18n("missingRequiredMetaFieldOnFile", {
      fileName: file.name
    }));
    const {
      requiredMetaFields
    } = this.getOpts().restrictions;
    const missingFields = [];
    for (const field of requiredMetaFields) {
      if (!Object.hasOwn(file.meta, field) || file.meta[field] === "") {
        missingFields.push(field);
      }
    }
    return {
      missingFields,
      error
    };
  }
};
var locale_default22 = {
  strings: {
    addBulkFilesFailed: {
      0: "Failed to add %{smart_count} file due to an internal error",
      1: "Failed to add %{smart_count} files due to internal errors"
    },
    youCanOnlyUploadX: {
      0: "You can only upload %{smart_count} file",
      1: "You can only upload %{smart_count} files"
    },
    youHaveToAtLeastSelectX: {
      0: "You have to select at least %{smart_count} file",
      1: "You have to select at least %{smart_count} files"
    },
    exceedsSize: "%{file} exceeds maximum allowed size of %{size}",
    missingRequiredMetaField: "Missing required meta fields",
    missingRequiredMetaFieldOnFile: "Missing required meta fields in %{fileName}",
    inferiorSize: "This file is smaller than the allowed size of %{size}",
    youCanOnlyUploadFileTypes: "You can only upload: %{types}",
    noMoreFilesAllowed: "Cannot add more files",
    noDuplicates: "Cannot add the duplicate file '%{fileName}', it already exists",
    companionError: "Connection with Companion failed",
    authAborted: "Authentication aborted",
    companionUnauthorizeHint: "To unauthorize to your %{provider} account, please go to %{url}",
    failedToUpload: "Failed to upload %{file}",
    noInternetConnection: "No Internet connection",
    connectedToInternet: "Connected to the Internet",
    // Strings for remote providers
    noFilesFound: "You have no files or folders here",
    noSearchResults: "Unfortunately, there are no results for this search",
    selectX: {
      0: "Select %{smart_count}",
      1: "Select %{smart_count}"
    },
    allFilesFromFolderNamed: "All files from folder %{name}",
    openFolderNamed: "Open folder %{name}",
    cancel: "Cancel",
    logOut: "Log out",
    filter: "Filter",
    resetFilter: "Reset filter",
    loading: "Loading...",
    loadedXFiles: "Loaded %{numFiles} files",
    authenticateWithTitle: "Please authenticate with %{pluginName} to select files",
    authenticateWith: "Connect to %{pluginName}",
    signInWithGoogle: "Sign in with Google",
    searchImages: "Search for images",
    enterTextToSearch: "Enter text to search for images",
    search: "Search",
    resetSearch: "Reset search",
    emptyFolderAdded: "No files were added from empty folder",
    addedNumFiles: "Added %{numFiles} file(s)",
    folderAlreadyAdded: 'The folder "%{folder}" was already added',
    folderAdded: {
      0: "Added %{smart_count} file from %{folder}",
      1: "Added %{smart_count} files from %{folder}"
    },
    additionalRestrictionsFailed: "%{count} additional restrictions were not fulfilled"
  }
};
var _Symbol$for52;
var _Symbol$for232;
function _classPrivateFieldLooseBase12(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id122 = 0;
function _classPrivateFieldLooseKey12(name) {
  return "__private_" + id122++ + "_" + name;
}
var packageJson52 = {
  "version": "3.9.3"
};
var defaultUploadState = {
  totalProgress: 0,
  allowNewUpload: true,
  error: null,
  recoveredState: null
};
var _plugins = /* @__PURE__ */ _classPrivateFieldLooseKey12("plugins");
var _restricter = /* @__PURE__ */ _classPrivateFieldLooseKey12("restricter");
var _storeUnsubscribe = /* @__PURE__ */ _classPrivateFieldLooseKey12("storeUnsubscribe");
var _emitter22 = /* @__PURE__ */ _classPrivateFieldLooseKey12("emitter");
var _preProcessors = /* @__PURE__ */ _classPrivateFieldLooseKey12("preProcessors");
var _uploaders = /* @__PURE__ */ _classPrivateFieldLooseKey12("uploaders");
var _postProcessors = /* @__PURE__ */ _classPrivateFieldLooseKey12("postProcessors");
var _informAndEmit = /* @__PURE__ */ _classPrivateFieldLooseKey12("informAndEmit");
var _checkRequiredMetaFieldsOnFile = /* @__PURE__ */ _classPrivateFieldLooseKey12("checkRequiredMetaFieldsOnFile");
var _checkRequiredMetaFields = /* @__PURE__ */ _classPrivateFieldLooseKey12("checkRequiredMetaFields");
var _assertNewUploadAllowed = /* @__PURE__ */ _classPrivateFieldLooseKey12("assertNewUploadAllowed");
var _transformFile = /* @__PURE__ */ _classPrivateFieldLooseKey12("transformFile");
var _startIfAutoProceed = /* @__PURE__ */ _classPrivateFieldLooseKey12("startIfAutoProceed");
var _checkAndUpdateFileState = /* @__PURE__ */ _classPrivateFieldLooseKey12("checkAndUpdateFileState");
var _addListeners = /* @__PURE__ */ _classPrivateFieldLooseKey12("addListeners");
var _updateOnlineStatus = /* @__PURE__ */ _classPrivateFieldLooseKey12("updateOnlineStatus");
var _requestClientById = /* @__PURE__ */ _classPrivateFieldLooseKey12("requestClientById");
var _createUpload32 = /* @__PURE__ */ _classPrivateFieldLooseKey12("createUpload");
var _getUpload = /* @__PURE__ */ _classPrivateFieldLooseKey12("getUpload");
var _removeUpload = /* @__PURE__ */ _classPrivateFieldLooseKey12("removeUpload");
var _runUpload = /* @__PURE__ */ _classPrivateFieldLooseKey12("runUpload");
_Symbol$for52 = Symbol.for("uppy test: getPlugins");
_Symbol$for232 = Symbol.for("uppy test: createUpload");
var Uppy2 = class _Uppy {
  /**
   * Instantiate Uppy
   */
  constructor(_opts) {
    Object.defineProperty(this, _runUpload, {
      value: _runUpload2
    });
    Object.defineProperty(this, _removeUpload, {
      value: _removeUpload2
    });
    Object.defineProperty(this, _getUpload, {
      value: _getUpload2
    });
    Object.defineProperty(this, _createUpload32, {
      value: _createUpload222
    });
    Object.defineProperty(this, _addListeners, {
      value: _addListeners2
    });
    Object.defineProperty(this, _checkAndUpdateFileState, {
      value: _checkAndUpdateFileState2
    });
    Object.defineProperty(this, _startIfAutoProceed, {
      value: _startIfAutoProceed2
    });
    Object.defineProperty(this, _transformFile, {
      value: _transformFile2
    });
    Object.defineProperty(this, _assertNewUploadAllowed, {
      value: _assertNewUploadAllowed2
    });
    Object.defineProperty(this, _checkRequiredMetaFields, {
      value: _checkRequiredMetaFields2
    });
    Object.defineProperty(this, _checkRequiredMetaFieldsOnFile, {
      value: _checkRequiredMetaFieldsOnFile2
    });
    Object.defineProperty(this, _informAndEmit, {
      value: _informAndEmit2
    });
    Object.defineProperty(this, _plugins, {
      writable: true,
      value: /* @__PURE__ */ Object.create(null)
    });
    Object.defineProperty(this, _restricter, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _storeUnsubscribe, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _emitter22, {
      writable: true,
      value: (0, import_namespace_emitter22.default)()
    });
    Object.defineProperty(this, _preProcessors, {
      writable: true,
      value: /* @__PURE__ */ new Set()
    });
    Object.defineProperty(this, _uploaders, {
      writable: true,
      value: /* @__PURE__ */ new Set()
    });
    Object.defineProperty(this, _postProcessors, {
      writable: true,
      value: /* @__PURE__ */ new Set()
    });
    this.scheduledAutoProceed = null;
    this.wasOffline = false;
    this.calculateProgress = (0, import_throttle22.default)((file, data) => {
      const fileInState = this.getFile(file == null ? void 0 : file.id);
      if (file == null || !fileInState) {
        this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
        return;
      }
      if (fileInState.progress.percentage === 100) {
        this.log(`Not setting progress for a file that has been already uploaded: ${file.id}`);
        return;
      }
      const canHavePercentage = Number.isFinite(data.bytesTotal) && data.bytesTotal > 0;
      this.setFileState(file.id, {
        progress: {
          ...fileInState.progress,
          bytesUploaded: data.bytesUploaded,
          bytesTotal: data.bytesTotal,
          percentage: canHavePercentage ? Math.round(data.bytesUploaded / data.bytesTotal * 100) : 0
        }
      });
      this.calculateTotalProgress();
    }, 500, {
      leading: true,
      trailing: true
    });
    Object.defineProperty(this, _updateOnlineStatus, {
      writable: true,
      value: this.updateOnlineStatus.bind(this)
    });
    Object.defineProperty(this, _requestClientById, {
      writable: true,
      value: /* @__PURE__ */ new Map()
    });
    this.defaultLocale = locale_default22;
    const defaultOptions8 = {
      id: "uppy",
      autoProceed: false,
      allowMultipleUploadBatches: true,
      debug: false,
      restrictions: defaultOptions22,
      meta: {},
      onBeforeFileAdded: (file, files) => !Object.hasOwn(files, file.id),
      onBeforeUpload: (files) => files,
      store: new lib_default(),
      logger: justErrorsLogger,
      infoTimeout: 5e3
    };
    const merged = {
      ...defaultOptions8,
      ..._opts
    };
    this.opts = {
      ...merged,
      restrictions: {
        ...defaultOptions8.restrictions,
        ..._opts && _opts.restrictions
      }
    };
    if (_opts && _opts.logger && _opts.debug) {
      this.log("You are using a custom `logger`, but also set `debug: true`, which uses built-in logger to output logs to console. Ignoring `debug: true` and using your custom `logger`.", "warning");
    } else if (_opts && _opts.debug) {
      this.opts.logger = debugLogger;
    }
    this.log(`Using Core v${_Uppy.VERSION}`);
    this.i18nInit();
    this.store = this.opts.store;
    this.setState({
      ...defaultUploadState,
      plugins: {},
      files: {},
      currentUploads: {},
      capabilities: {
        uploadProgress: supportsUploadProgress(),
        individualCancellation: true,
        resumableUploads: false
      },
      meta: {
        ...this.opts.meta
      },
      info: []
    });
    _classPrivateFieldLooseBase12(this, _restricter)[_restricter] = new Restricter(() => this.opts, this.i18n);
    _classPrivateFieldLooseBase12(this, _storeUnsubscribe)[_storeUnsubscribe] = this.store.subscribe(
      // eslint-disable-next-line
      // @ts-ignore Store is incorrectly typed
      (prevState, nextState, patch) => {
        this.emit("state-update", prevState, nextState, patch);
        this.updateAll(nextState);
      }
    );
    if (this.opts.debug && typeof window !== "undefined") {
      window[this.opts.id] = this;
    }
    _classPrivateFieldLooseBase12(this, _addListeners)[_addListeners]();
  }
  emit(event) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    _classPrivateFieldLooseBase12(this, _emitter22)[_emitter22].emit(event, ...args);
  }
  /** @deprecated */
  on(event, callback) {
    _classPrivateFieldLooseBase12(this, _emitter22)[_emitter22].on(event, callback);
    return this;
  }
  once(event, callback) {
    _classPrivateFieldLooseBase12(this, _emitter22)[_emitter22].once(event, callback);
    return this;
  }
  off(event, callback) {
    _classPrivateFieldLooseBase12(this, _emitter22)[_emitter22].off(event, callback);
    return this;
  }
  /**
   * Iterate on all plugins and run `update` on them.
   * Called each time state changes.
   *
   */
  updateAll(state) {
    this.iteratePlugins((plugin) => {
      plugin.update(state);
    });
  }
  /**
   * Updates state with a patch
   */
  setState(patch) {
    this.store.setState(patch);
  }
  /**
   * Returns current state.
   */
  getState() {
    return this.store.getState();
  }
  patchFilesState(filesWithNewState) {
    const existingFilesState = this.getState().files;
    this.setState({
      files: {
        ...existingFilesState,
        ...Object.fromEntries(Object.entries(filesWithNewState).map((_ref) => {
          let [fileID, newFileState] = _ref;
          return [fileID, {
            ...existingFilesState[fileID],
            ...newFileState
          }];
        }))
      }
    });
  }
  /**
   * Shorthand to set state for a specific file.
   */
  setFileState(fileID, state) {
    if (!this.getState().files[fileID]) {
      throw new Error(`Can\u2019t set state for ${fileID} (the file could have been removed)`);
    }
    this.patchFilesState({
      [fileID]: state
    });
  }
  i18nInit() {
    const onMissingKey = (key) => this.log(`Missing i18n string: ${key}`, "error");
    const translator = new Translator([this.defaultLocale, this.opts.locale], {
      onMissingKey
    });
    this.i18n = translator.translate.bind(translator);
    this.i18nArray = translator.translateArray.bind(translator);
    this.locale = translator.locale;
  }
  setOptions(newOpts) {
    this.opts = {
      ...this.opts,
      ...newOpts,
      restrictions: {
        ...this.opts.restrictions,
        ...newOpts == null ? void 0 : newOpts.restrictions
      }
    };
    if (newOpts.meta) {
      this.setMeta(newOpts.meta);
    }
    this.i18nInit();
    if (newOpts.locale) {
      this.iteratePlugins((plugin) => {
        plugin.setOptions(newOpts);
      });
    }
    this.setState(void 0);
  }
  // todo next major: remove
  resetProgress() {
    const defaultProgress = {
      percentage: 0,
      bytesUploaded: 0,
      uploadComplete: false,
      uploadStarted: null
    };
    const files = {
      ...this.getState().files
    };
    const updatedFiles = {};
    Object.keys(files).forEach((fileID) => {
      updatedFiles[fileID] = {
        ...files[fileID],
        progress: {
          ...files[fileID].progress,
          ...defaultProgress
        }
      };
    });
    this.setState({
      files: updatedFiles,
      ...defaultUploadState
    });
    this.emit("reset-progress");
  }
  // @todo next major: rename to `clear()`, make it also cancel ongoing uploads
  // or throw and say you need to cancel manually
  clearUploadedFiles() {
    this.setState({
      ...defaultUploadState,
      files: {}
    });
  }
  addPreProcessor(fn) {
    _classPrivateFieldLooseBase12(this, _preProcessors)[_preProcessors].add(fn);
  }
  removePreProcessor(fn) {
    return _classPrivateFieldLooseBase12(this, _preProcessors)[_preProcessors].delete(fn);
  }
  addPostProcessor(fn) {
    _classPrivateFieldLooseBase12(this, _postProcessors)[_postProcessors].add(fn);
  }
  removePostProcessor(fn) {
    return _classPrivateFieldLooseBase12(this, _postProcessors)[_postProcessors].delete(fn);
  }
  addUploader(fn) {
    _classPrivateFieldLooseBase12(this, _uploaders)[_uploaders].add(fn);
  }
  removeUploader(fn) {
    return _classPrivateFieldLooseBase12(this, _uploaders)[_uploaders].delete(fn);
  }
  setMeta(data) {
    const updatedMeta = {
      ...this.getState().meta,
      ...data
    };
    const updatedFiles = {
      ...this.getState().files
    };
    Object.keys(updatedFiles).forEach((fileID) => {
      updatedFiles[fileID] = {
        ...updatedFiles[fileID],
        meta: {
          ...updatedFiles[fileID].meta,
          ...data
        }
      };
    });
    this.log("Adding metadata:");
    this.log(data);
    this.setState({
      meta: updatedMeta,
      files: updatedFiles
    });
  }
  setFileMeta(fileID, data) {
    const updatedFiles = {
      ...this.getState().files
    };
    if (!updatedFiles[fileID]) {
      this.log("Was trying to set metadata for a file that has been removed: ", fileID);
      return;
    }
    const newMeta = {
      ...updatedFiles[fileID].meta,
      ...data
    };
    updatedFiles[fileID] = {
      ...updatedFiles[fileID],
      meta: newMeta
    };
    this.setState({
      files: updatedFiles
    });
  }
  /**
   * Get a file object.
   */
  getFile(fileID) {
    return this.getState().files[fileID];
  }
  /**
   * Get all files in an array.
   */
  getFiles() {
    const {
      files
    } = this.getState();
    return Object.values(files);
  }
  getFilesByIds(ids) {
    return ids.map((id18) => this.getFile(id18));
  }
  // TODO: remove or refactor this method. It's very inefficient
  getObjectOfFilesPerState() {
    const {
      files: filesObject,
      totalProgress,
      error
    } = this.getState();
    const files = Object.values(filesObject);
    const inProgressFiles = files.filter((_ref2) => {
      let {
        progress: progress2
      } = _ref2;
      return !progress2.uploadComplete && progress2.uploadStarted;
    });
    const newFiles = files.filter((file) => !file.progress.uploadStarted);
    const startedFiles = files.filter((file) => file.progress.uploadStarted || file.progress.preprocess || file.progress.postprocess);
    const uploadStartedFiles = files.filter((file) => file.progress.uploadStarted);
    const pausedFiles = files.filter((file) => file.isPaused);
    const completeFiles = files.filter((file) => file.progress.uploadComplete);
    const erroredFiles = files.filter((file) => file.error);
    const inProgressNotPausedFiles = inProgressFiles.filter((file) => !file.isPaused);
    const processingFiles = files.filter((file) => file.progress.preprocess || file.progress.postprocess);
    return {
      newFiles,
      startedFiles,
      uploadStartedFiles,
      pausedFiles,
      completeFiles,
      erroredFiles,
      inProgressFiles,
      inProgressNotPausedFiles,
      processingFiles,
      isUploadStarted: uploadStartedFiles.length > 0,
      isAllComplete: totalProgress === 100 && completeFiles.length === files.length && processingFiles.length === 0,
      isAllErrored: !!error && erroredFiles.length === files.length,
      isAllPaused: inProgressFiles.length !== 0 && pausedFiles.length === inProgressFiles.length,
      isUploadInProgress: inProgressFiles.length > 0,
      isSomeGhost: files.some((file) => file.isGhost)
    };
  }
  validateRestrictions(file, files) {
    if (files === void 0) {
      files = this.getFiles();
    }
    try {
      _classPrivateFieldLooseBase12(this, _restricter)[_restricter].validate(files, [file]);
    } catch (err) {
      return err;
    }
    return null;
  }
  checkIfFileAlreadyExists(fileID) {
    const {
      files
    } = this.getState();
    if (files[fileID] && !files[fileID].isGhost) {
      return true;
    }
    return false;
  }
  /**
   * Add a new file to `state.files`. This will run `onBeforeFileAdded`,
   * try to guess file type in a clever way, check file against restrictions,
   * and start an upload if `autoProceed === true`.
   */
  addFile(file) {
    _classPrivateFieldLooseBase12(this, _assertNewUploadAllowed)[_assertNewUploadAllowed](file);
    const {
      nextFilesState,
      validFilesToAdd,
      errors
    } = _classPrivateFieldLooseBase12(this, _checkAndUpdateFileState)[_checkAndUpdateFileState]([file]);
    const restrictionErrors = errors.filter((error) => error.isRestriction);
    _classPrivateFieldLooseBase12(this, _informAndEmit)[_informAndEmit](restrictionErrors);
    if (errors.length > 0)
      throw errors[0];
    this.setState({
      files: nextFilesState
    });
    const [firstValidFileToAdd] = validFilesToAdd;
    this.emit("file-added", firstValidFileToAdd);
    this.emit("files-added", validFilesToAdd);
    this.log(`Added file: ${firstValidFileToAdd.name}, ${firstValidFileToAdd.id}, mime type: ${firstValidFileToAdd.type}`);
    _classPrivateFieldLooseBase12(this, _startIfAutoProceed)[_startIfAutoProceed]();
    return firstValidFileToAdd.id;
  }
  /**
   * Add multiple files to `state.files`. See the `addFile()` documentation.
   *
   * If an error occurs while adding a file, it is logged and the user is notified.
   * This is good for UI plugins, but not for programmatic use.
   * Programmatic users should usually still use `addFile()` on individual files.
   */
  addFiles(fileDescriptors) {
    _classPrivateFieldLooseBase12(this, _assertNewUploadAllowed)[_assertNewUploadAllowed]();
    const {
      nextFilesState,
      validFilesToAdd,
      errors
    } = _classPrivateFieldLooseBase12(this, _checkAndUpdateFileState)[_checkAndUpdateFileState](fileDescriptors);
    const restrictionErrors = errors.filter((error) => error.isRestriction);
    _classPrivateFieldLooseBase12(this, _informAndEmit)[_informAndEmit](restrictionErrors);
    const nonRestrictionErrors = errors.filter((error) => !error.isRestriction);
    if (nonRestrictionErrors.length > 0) {
      let message = "Multiple errors occurred while adding files:\n";
      nonRestrictionErrors.forEach((subError) => {
        message += `
 * ${subError.message}`;
      });
      this.info({
        message: this.i18n("addBulkFilesFailed", {
          smart_count: nonRestrictionErrors.length
        }),
        details: message
      }, "error", this.opts.infoTimeout);
      if (typeof AggregateError === "function") {
        throw new AggregateError(nonRestrictionErrors, message);
      } else {
        const err = new Error(message);
        err.errors = nonRestrictionErrors;
        throw err;
      }
    }
    this.setState({
      files: nextFilesState
    });
    validFilesToAdd.forEach((file) => {
      this.emit("file-added", file);
    });
    this.emit("files-added", validFilesToAdd);
    if (validFilesToAdd.length > 5) {
      this.log(`Added batch of ${validFilesToAdd.length} files`);
    } else {
      Object.values(validFilesToAdd).forEach((file) => {
        this.log(`Added file: ${file.name}
 id: ${file.id}
 type: ${file.type}`);
      });
    }
    if (validFilesToAdd.length > 0) {
      _classPrivateFieldLooseBase12(this, _startIfAutoProceed)[_startIfAutoProceed]();
    }
  }
  removeFiles(fileIDs, reason) {
    const {
      files,
      currentUploads
    } = this.getState();
    const updatedFiles = {
      ...files
    };
    const updatedUploads = {
      ...currentUploads
    };
    const removedFiles = /* @__PURE__ */ Object.create(null);
    fileIDs.forEach((fileID) => {
      if (files[fileID]) {
        removedFiles[fileID] = files[fileID];
        delete updatedFiles[fileID];
      }
    });
    function fileIsNotRemoved(uploadFileID) {
      return removedFiles[uploadFileID] === void 0;
    }
    Object.keys(updatedUploads).forEach((uploadID) => {
      const newFileIDs = currentUploads[uploadID].fileIDs.filter(fileIsNotRemoved);
      if (newFileIDs.length === 0) {
        delete updatedUploads[uploadID];
        return;
      }
      const {
        capabilities
      } = this.getState();
      if (newFileIDs.length !== currentUploads[uploadID].fileIDs.length && !capabilities.individualCancellation) {
        throw new Error("individualCancellation is disabled");
      }
      updatedUploads[uploadID] = {
        ...currentUploads[uploadID],
        fileIDs: newFileIDs
      };
    });
    const stateUpdate = {
      currentUploads: updatedUploads,
      files: updatedFiles
    };
    if (Object.keys(updatedFiles).length === 0) {
      stateUpdate.allowNewUpload = true;
      stateUpdate.error = null;
      stateUpdate.recoveredState = null;
    }
    this.setState(stateUpdate);
    this.calculateTotalProgress();
    const removedFileIDs = Object.keys(removedFiles);
    removedFileIDs.forEach((fileID) => {
      this.emit("file-removed", removedFiles[fileID], reason);
    });
    if (removedFileIDs.length > 5) {
      this.log(`Removed ${removedFileIDs.length} files`);
    } else {
      this.log(`Removed files: ${removedFileIDs.join(", ")}`);
    }
  }
  removeFile(fileID, reason) {
    this.removeFiles([fileID], reason);
  }
  pauseResume(fileID) {
    if (!this.getState().capabilities.resumableUploads || this.getFile(fileID).progress.uploadComplete) {
      return void 0;
    }
    const wasPaused = this.getFile(fileID).isPaused || false;
    const isPaused = !wasPaused;
    this.setFileState(fileID, {
      isPaused
    });
    this.emit("upload-pause", fileID, isPaused);
    return isPaused;
  }
  pauseAll() {
    const updatedFiles = {
      ...this.getState().files
    };
    const inProgressUpdatedFiles = Object.keys(updatedFiles).filter((file) => {
      return !updatedFiles[file].progress.uploadComplete && updatedFiles[file].progress.uploadStarted;
    });
    inProgressUpdatedFiles.forEach((file) => {
      const updatedFile = {
        ...updatedFiles[file],
        isPaused: true
      };
      updatedFiles[file] = updatedFile;
    });
    this.setState({
      files: updatedFiles
    });
    this.emit("pause-all");
  }
  resumeAll() {
    const updatedFiles = {
      ...this.getState().files
    };
    const inProgressUpdatedFiles = Object.keys(updatedFiles).filter((file) => {
      return !updatedFiles[file].progress.uploadComplete && updatedFiles[file].progress.uploadStarted;
    });
    inProgressUpdatedFiles.forEach((file) => {
      const updatedFile = {
        ...updatedFiles[file],
        isPaused: false,
        error: null
      };
      updatedFiles[file] = updatedFile;
    });
    this.setState({
      files: updatedFiles
    });
    this.emit("resume-all");
  }
  retryAll() {
    const updatedFiles = {
      ...this.getState().files
    };
    const filesToRetry = Object.keys(updatedFiles).filter((file) => {
      return updatedFiles[file].error;
    });
    filesToRetry.forEach((file) => {
      const updatedFile = {
        ...updatedFiles[file],
        isPaused: false,
        error: null
      };
      updatedFiles[file] = updatedFile;
    });
    this.setState({
      files: updatedFiles,
      error: null
    });
    this.emit("retry-all", filesToRetry);
    if (filesToRetry.length === 0) {
      return Promise.resolve({
        successful: [],
        failed: []
      });
    }
    const uploadID = _classPrivateFieldLooseBase12(this, _createUpload32)[_createUpload32](filesToRetry, {
      forceAllowNewUpload: true
      // create new upload even if allowNewUpload: false
    });
    return _classPrivateFieldLooseBase12(this, _runUpload)[_runUpload](uploadID);
  }
  cancelAll(_temp) {
    let {
      reason = "user"
    } = _temp === void 0 ? {} : _temp;
    this.emit("cancel-all", {
      reason
    });
    if (reason === "user") {
      const {
        files
      } = this.getState();
      const fileIDs = Object.keys(files);
      if (fileIDs.length) {
        this.removeFiles(fileIDs, "cancel-all");
      }
      this.setState(defaultUploadState);
    }
  }
  retryUpload(fileID) {
    this.setFileState(fileID, {
      error: null,
      isPaused: false
    });
    this.emit("upload-retry", fileID);
    const uploadID = _classPrivateFieldLooseBase12(this, _createUpload32)[_createUpload32]([fileID], {
      forceAllowNewUpload: true
      // create new upload even if allowNewUpload: false
    });
    return _classPrivateFieldLooseBase12(this, _runUpload)[_runUpload](uploadID);
  }
  logout() {
    this.iteratePlugins((plugin) => {
      var _provider;
      ;
      (_provider = plugin.provider) == null || _provider.logout == null || _provider.logout();
    });
  }
  calculateTotalProgress() {
    const files = this.getFiles();
    const inProgress = files.filter((file) => {
      return file.progress.uploadStarted || file.progress.preprocess || file.progress.postprocess;
    });
    if (inProgress.length === 0) {
      this.emit("progress", 0);
      this.setState({
        totalProgress: 0
      });
      return;
    }
    const sizedFiles = inProgress.filter((file) => file.progress.bytesTotal != null);
    const unsizedFiles = inProgress.filter((file) => file.progress.bytesTotal == null);
    if (sizedFiles.length === 0) {
      const progressMax = inProgress.length * 100;
      const currentProgress = unsizedFiles.reduce((acc, file) => {
        return acc + file.progress.percentage;
      }, 0);
      const totalProgress2 = Math.round(currentProgress / progressMax * 100);
      this.setState({
        totalProgress: totalProgress2
      });
      return;
    }
    let totalSize = sizedFiles.reduce((acc, file) => {
      var _file$progress$bytesT;
      return acc + ((_file$progress$bytesT = file.progress.bytesTotal) != null ? _file$progress$bytesT : 0);
    }, 0);
    const averageSize = totalSize / sizedFiles.length;
    totalSize += averageSize * unsizedFiles.length;
    let uploadedSize = 0;
    sizedFiles.forEach((file) => {
      uploadedSize += file.progress.bytesUploaded;
    });
    unsizedFiles.forEach((file) => {
      uploadedSize += averageSize * (file.progress.percentage || 0) / 100;
    });
    let totalProgress = totalSize === 0 ? 0 : Math.round(uploadedSize / totalSize * 100);
    if (totalProgress > 100) {
      totalProgress = 100;
    }
    this.setState({
      totalProgress
    });
    this.emit("progress", totalProgress);
  }
  updateOnlineStatus() {
    var _window$navigator$onL;
    const online = (_window$navigator$onL = window.navigator.onLine) != null ? _window$navigator$onL : true;
    if (!online) {
      this.emit("is-offline");
      this.info(this.i18n("noInternetConnection"), "error", 0);
      this.wasOffline = true;
    } else {
      this.emit("is-online");
      if (this.wasOffline) {
        this.emit("back-online");
        this.info(this.i18n("connectedToInternet"), "success", 3e3);
        this.wasOffline = false;
      }
    }
  }
  getID() {
    return this.opts.id;
  }
  /**
   * Registers a plugin with Core.
   */
  use(Plugin, opts) {
    if (typeof Plugin !== "function") {
      const msg = `Expected a plugin class, but got ${Plugin === null ? "null" : typeof Plugin}. Please verify that the plugin was imported and spelled correctly.`;
      throw new TypeError(msg);
    }
    const plugin = new Plugin(this, opts);
    const pluginId = plugin.id;
    if (!pluginId) {
      throw new Error("Your plugin must have an id");
    }
    if (!plugin.type) {
      throw new Error("Your plugin must have a type");
    }
    const existsPluginAlready = this.getPlugin(pluginId);
    if (existsPluginAlready) {
      const msg = `Already found a plugin named '${existsPluginAlready.id}'. Tried to use: '${pluginId}'.
Uppy plugins must have unique \`id\` options. See https://uppy.io/docs/plugins/#id.`;
      throw new Error(msg);
    }
    if (Plugin.VERSION) {
      this.log(`Using ${pluginId} v${Plugin.VERSION}`);
    }
    if (plugin.type in _classPrivateFieldLooseBase12(this, _plugins)[_plugins]) {
      _classPrivateFieldLooseBase12(this, _plugins)[_plugins][plugin.type].push(plugin);
    } else {
      _classPrivateFieldLooseBase12(this, _plugins)[_plugins][plugin.type] = [plugin];
    }
    plugin.install();
    this.emit("plugin-added", plugin);
    return this;
  }
  /**
   * Find one Plugin by name.
   */
  getPlugin(id18) {
    for (const plugins22 of Object.values(_classPrivateFieldLooseBase12(this, _plugins)[_plugins])) {
      const foundPlugin = plugins22.find((plugin) => plugin.id === id18);
      if (foundPlugin != null)
        return foundPlugin;
    }
    return void 0;
  }
  [_Symbol$for52](type) {
    return _classPrivateFieldLooseBase12(this, _plugins)[_plugins][type];
  }
  /**
   * Iterate through all `use`d plugins.
   *
   */
  iteratePlugins(method) {
    Object.values(_classPrivateFieldLooseBase12(this, _plugins)[_plugins]).flat(1).forEach(method);
  }
  /**
   * Uninstall and remove a plugin.
   *
   * @param {object} instance The plugin instance to remove.
   */
  removePlugin(instance) {
    this.log(`Removing plugin ${instance.id}`);
    this.emit("plugin-remove", instance);
    if (instance.uninstall) {
      instance.uninstall();
    }
    const list2 = _classPrivateFieldLooseBase12(this, _plugins)[_plugins][instance.type];
    const index2 = list2.findIndex((item) => item.id === instance.id);
    if (index2 !== -1) {
      list2.splice(index2, 1);
    }
    const state = this.getState();
    const updatedState = {
      plugins: {
        ...state.plugins,
        [instance.id]: void 0
      }
    };
    this.setState(updatedState);
  }
  /**
   * Uninstall all plugins and close down this Uppy instance.
   */
  // @todo next major: rename to `destroy`.
  // Cancel local uploads, cancel remote uploads, DON'T cancel assemblies
  // document that if you do want to cancel assemblies, you need to call smth manually.
  // Potentially remove reason, as it’s confusing, just come up with a default behaviour.
  close(_temp2) {
    let {
      reason
    } = _temp2 === void 0 ? {} : _temp2;
    this.log(`Closing Uppy instance ${this.opts.id}: removing all files and uninstalling plugins`);
    this.cancelAll({
      reason
    });
    _classPrivateFieldLooseBase12(this, _storeUnsubscribe)[_storeUnsubscribe]();
    this.iteratePlugins((plugin) => {
      this.removePlugin(plugin);
    });
    if (typeof window !== "undefined" && window.removeEventListener) {
      window.removeEventListener("online", _classPrivateFieldLooseBase12(this, _updateOnlineStatus)[_updateOnlineStatus]);
      window.removeEventListener("offline", _classPrivateFieldLooseBase12(this, _updateOnlineStatus)[_updateOnlineStatus]);
    }
  }
  hideInfo() {
    const {
      info
    } = this.getState();
    this.setState({
      info: info.slice(1)
    });
    this.emit("info-hidden");
  }
  /**
   * Set info message in `state.info`, so that UI plugins like `Informer`
   * can display the message.
   */
  info(message, type, duration2) {
    if (type === void 0) {
      type = "info";
    }
    if (duration2 === void 0) {
      duration2 = 3e3;
    }
    const isComplexMessage = typeof message === "object";
    this.setState({
      info: [...this.getState().info, {
        type,
        message: isComplexMessage ? message.message : message,
        details: isComplexMessage ? message.details : null
      }]
    });
    setTimeout(() => this.hideInfo(), duration2);
    this.emit("info-visible");
  }
  /**
   * Passes messages to a function, provided in `opts.logger`.
   * If `opts.logger: Uppy.debugLogger` or `opts.debug: true`, logs to the browser console.
   */
  log(message, type) {
    const {
      logger: logger2
    } = this.opts;
    switch (type) {
      case "error":
        logger2.error(message);
        break;
      case "warning":
        logger2.warn(message);
        break;
      default:
        logger2.debug(message);
        break;
    }
  }
  registerRequestClient(id18, client) {
    _classPrivateFieldLooseBase12(this, _requestClientById)[_requestClientById].set(id18, client);
  }
  /** @protected */
  getRequestClientForFile(file) {
    if (!file.remote)
      throw new Error(`Tried to get RequestClient for a non-remote file ${file.id}`);
    const requestClient = _classPrivateFieldLooseBase12(this, _requestClientById)[_requestClientById].get(file.remote.requestClientId);
    if (requestClient == null)
      throw new Error(`requestClientId "${file.remote.requestClientId}" not registered for file "${file.id}"`);
    return requestClient;
  }
  /**
   * Restore an upload by its ID.
   */
  restore(uploadID) {
    this.log(`Core: attempting to restore upload "${uploadID}"`);
    if (!this.getState().currentUploads[uploadID]) {
      _classPrivateFieldLooseBase12(this, _removeUpload)[_removeUpload](uploadID);
      return Promise.reject(new Error("Nonexistent upload"));
    }
    return _classPrivateFieldLooseBase12(this, _runUpload)[_runUpload](uploadID);
  }
  [_Symbol$for232]() {
    return _classPrivateFieldLooseBase12(this, _createUpload32)[_createUpload32](...arguments);
  }
  /**
   * Add data to an upload's result object.
   */
  addResultData(uploadID, data) {
    if (!_classPrivateFieldLooseBase12(this, _getUpload)[_getUpload](uploadID)) {
      this.log(`Not setting result for an upload that has been removed: ${uploadID}`);
      return;
    }
    const {
      currentUploads
    } = this.getState();
    const currentUpload = {
      ...currentUploads[uploadID],
      result: {
        ...currentUploads[uploadID].result,
        ...data
      }
    };
    this.setState({
      currentUploads: {
        ...currentUploads,
        [uploadID]: currentUpload
      }
    });
  }
  /**
   * Start an upload for all the files that are not currently being uploaded.
   */
  upload() {
    var _classPrivateFieldLoo;
    if (!((_classPrivateFieldLoo = _classPrivateFieldLooseBase12(this, _plugins)[_plugins].uploader) != null && _classPrivateFieldLoo.length)) {
      this.log("No uploader type plugins are used", "warning");
    }
    let {
      files
    } = this.getState();
    const onBeforeUploadResult = this.opts.onBeforeUpload(files);
    if (onBeforeUploadResult === false) {
      return Promise.reject(new Error("Not starting the upload because onBeforeUpload returned false"));
    }
    if (onBeforeUploadResult && typeof onBeforeUploadResult === "object") {
      files = onBeforeUploadResult;
      this.setState({
        files
      });
    }
    return Promise.resolve().then(() => _classPrivateFieldLooseBase12(this, _restricter)[_restricter].validateMinNumberOfFiles(files)).catch((err) => {
      _classPrivateFieldLooseBase12(this, _informAndEmit)[_informAndEmit]([err]);
      throw err;
    }).then(() => {
      if (!_classPrivateFieldLooseBase12(this, _checkRequiredMetaFields)[_checkRequiredMetaFields](files)) {
        throw new RestrictionError(this.i18n("missingRequiredMetaField"));
      }
    }).catch((err) => {
      throw err;
    }).then(() => {
      const {
        currentUploads
      } = this.getState();
      const currentlyUploadingFiles = Object.values(currentUploads).flatMap((curr) => curr.fileIDs);
      const waitingFileIDs = [];
      Object.keys(files).forEach((fileID) => {
        const file = this.getFile(fileID);
        if (!file.progress.uploadStarted && currentlyUploadingFiles.indexOf(fileID) === -1) {
          waitingFileIDs.push(file.id);
        }
      });
      const uploadID = _classPrivateFieldLooseBase12(this, _createUpload32)[_createUpload32](waitingFileIDs);
      return _classPrivateFieldLooseBase12(this, _runUpload)[_runUpload](uploadID);
    }).catch((err) => {
      this.emit("error", err);
      this.log(err, "error");
      throw err;
    });
  }
};
function _informAndEmit2(errors) {
  for (const error of errors) {
    if (error.isRestriction) {
      this.emit("restriction-failed", error.file, error);
    } else {
      this.emit("error", error, error.file);
    }
    this.log(error, "warning");
  }
  const userFacingErrors = errors.filter((error) => error.isUserFacing);
  const maxNumToShow = 4;
  const firstErrors = userFacingErrors.slice(0, maxNumToShow);
  const additionalErrors = userFacingErrors.slice(maxNumToShow);
  firstErrors.forEach((_ref3) => {
    let {
      message,
      details = ""
    } = _ref3;
    this.info({
      message,
      details
    }, "error", this.opts.infoTimeout);
  });
  if (additionalErrors.length > 0) {
    this.info({
      message: this.i18n("additionalRestrictionsFailed", {
        count: additionalErrors.length
      })
    });
  }
}
function _checkRequiredMetaFieldsOnFile2(file) {
  const {
    missingFields,
    error
  } = _classPrivateFieldLooseBase12(this, _restricter)[_restricter].getMissingRequiredMetaFields(file);
  if (missingFields.length > 0) {
    this.setFileState(file.id, {
      missingRequiredMetaFields: missingFields
    });
    this.log(error.message);
    this.emit("restriction-failed", file, error);
    return false;
  }
  return true;
}
function _checkRequiredMetaFields2(files) {
  let success = true;
  for (const file of Object.values(files)) {
    if (!_classPrivateFieldLooseBase12(this, _checkRequiredMetaFieldsOnFile)[_checkRequiredMetaFieldsOnFile](file)) {
      success = false;
    }
  }
  return success;
}
function _assertNewUploadAllowed2(file) {
  const {
    allowNewUpload
  } = this.getState();
  if (allowNewUpload === false) {
    const error = new RestrictionError(this.i18n("noMoreFilesAllowed"), {
      file
    });
    _classPrivateFieldLooseBase12(this, _informAndEmit)[_informAndEmit]([error]);
    throw error;
  }
}
function _transformFile2(fileDescriptorOrFile) {
  const file = fileDescriptorOrFile instanceof File ? {
    name: fileDescriptorOrFile.name,
    type: fileDescriptorOrFile.type,
    size: fileDescriptorOrFile.size,
    data: fileDescriptorOrFile
  } : fileDescriptorOrFile;
  const fileType = getFileType(file);
  const fileName = getFileName(fileType, file);
  const fileExtension = getFileNameAndExtension(fileName).extension;
  const id18 = getSafeFileId(file);
  const meta = file.meta || {};
  meta.name = fileName;
  meta.type = fileType;
  const size = Number.isFinite(file.data.size) ? file.data.size : null;
  return {
    source: file.source || "",
    id: id18,
    name: fileName,
    extension: fileExtension || "",
    meta: {
      ...this.getState().meta,
      ...meta
    },
    type: fileType,
    data: file.data,
    progress: {
      percentage: 0,
      bytesUploaded: 0,
      bytesTotal: size,
      uploadComplete: false,
      uploadStarted: null
    },
    size,
    isGhost: false,
    isRemote: file.isRemote || false,
    // TODO: this should not be a string
    // @ts-expect-error wrong
    remote: file.remote || "",
    preview: file.preview
  };
}
function _startIfAutoProceed2() {
  if (this.opts.autoProceed && !this.scheduledAutoProceed) {
    this.scheduledAutoProceed = setTimeout(() => {
      this.scheduledAutoProceed = null;
      this.upload().catch((err) => {
        if (!err.isRestriction) {
          this.log(err.stack || err.message || err);
        }
      });
    }, 4);
  }
}
function _checkAndUpdateFileState2(filesToAdd) {
  const {
    files: existingFiles
  } = this.getState();
  const nextFilesState = {
    ...existingFiles
  };
  const validFilesToAdd = [];
  const errors = [];
  for (const fileToAdd of filesToAdd) {
    try {
      var _existingFiles$newFil;
      let newFile = _classPrivateFieldLooseBase12(this, _transformFile)[_transformFile](fileToAdd);
      const isGhost = (_existingFiles$newFil = existingFiles[newFile.id]) == null ? void 0 : _existingFiles$newFil.isGhost;
      if (isGhost) {
        const existingFileState = existingFiles[newFile.id];
        newFile = {
          ...existingFileState,
          isGhost: false,
          data: fileToAdd.data
        };
        this.log(`Replaced the blob in the restored ghost file: ${newFile.name}, ${newFile.id}`);
      }
      const onBeforeFileAddedResult = this.opts.onBeforeFileAdded(newFile, nextFilesState);
      if (!onBeforeFileAddedResult && this.checkIfFileAlreadyExists(newFile.id)) {
        throw new RestrictionError(this.i18n("noDuplicates", {
          fileName: newFile.name
        }), {
          file: fileToAdd
        });
      }
      if (onBeforeFileAddedResult === false && !isGhost) {
        throw new RestrictionError("Cannot add the file because onBeforeFileAdded returned false.", {
          isUserFacing: false,
          file: fileToAdd
        });
      } else if (typeof onBeforeFileAddedResult === "object" && onBeforeFileAddedResult !== null) {
        newFile = onBeforeFileAddedResult;
      }
      _classPrivateFieldLooseBase12(this, _restricter)[_restricter].validateSingleFile(newFile);
      nextFilesState[newFile.id] = newFile;
      validFilesToAdd.push(newFile);
    } catch (err) {
      errors.push(err);
    }
  }
  try {
    _classPrivateFieldLooseBase12(this, _restricter)[_restricter].validateAggregateRestrictions(Object.values(existingFiles), validFilesToAdd);
  } catch (err) {
    errors.push(err);
    return {
      nextFilesState: existingFiles,
      validFilesToAdd: [],
      errors
    };
  }
  return {
    nextFilesState,
    validFilesToAdd,
    errors
  };
}
function _addListeners2() {
  const errorHandler = (error, file, response) => {
    let errorMsg = error.message || "Unknown error";
    if (error.details) {
      errorMsg += ` ${error.details}`;
    }
    this.setState({
      error: errorMsg
    });
    if (file != null && file.id in this.getState().files) {
      this.setFileState(file.id, {
        error: errorMsg,
        response
      });
    }
  };
  this.on("error", errorHandler);
  this.on("upload-error", (file, error, response) => {
    errorHandler(error, file, response);
    if (typeof error === "object" && error.message) {
      var _file$name;
      this.log(error.message, "error");
      const newError = new Error(this.i18n("failedToUpload", {
        file: (_file$name = file == null ? void 0 : file.name) != null ? _file$name : ""
      }));
      newError.isUserFacing = true;
      newError.details = error.message;
      if (error.details) {
        newError.details += ` ${error.details}`;
      }
      _classPrivateFieldLooseBase12(this, _informAndEmit)[_informAndEmit]([newError]);
    } else {
      _classPrivateFieldLooseBase12(this, _informAndEmit)[_informAndEmit]([error]);
    }
  });
  let uploadStalledWarningRecentlyEmitted = null;
  this.on("upload-stalled", (error, files) => {
    const {
      message
    } = error;
    const details = files.map((file) => file.meta.name).join(", ");
    if (!uploadStalledWarningRecentlyEmitted) {
      this.info({
        message,
        details
      }, "warning", this.opts.infoTimeout);
      uploadStalledWarningRecentlyEmitted = setTimeout(() => {
        uploadStalledWarningRecentlyEmitted = null;
      }, this.opts.infoTimeout);
    }
    this.log(`${message} ${details}`.trim(), "warning");
  });
  this.on("upload", () => {
    this.setState({
      error: null
    });
  });
  const onUploadStarted = (files) => {
    const filesFiltered = files.filter((file) => {
      const exists = file != null && this.getFile(file.id);
      if (!exists)
        this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
      return exists;
    });
    const filesState = Object.fromEntries(filesFiltered.map((file) => [file.id, {
      progress: {
        uploadStarted: Date.now(),
        uploadComplete: false,
        percentage: 0,
        bytesUploaded: 0,
        bytesTotal: file.size
      }
    }]));
    this.patchFilesState(filesState);
  };
  this.on("upload-start", (files) => {
    files.forEach((file) => {
      this.emit("upload-started", file);
    });
    onUploadStarted(files);
  });
  this.on("upload-progress", this.calculateProgress);
  this.on("upload-success", (file, uploadResp) => {
    if (file == null || !this.getFile(file.id)) {
      this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
      return;
    }
    const currentProgress = this.getFile(file.id).progress;
    this.setFileState(file.id, {
      progress: {
        ...currentProgress,
        postprocess: _classPrivateFieldLooseBase12(this, _postProcessors)[_postProcessors].size > 0 ? {
          mode: "indeterminate"
        } : void 0,
        uploadComplete: true,
        percentage: 100,
        bytesUploaded: currentProgress.bytesTotal
      },
      response: uploadResp,
      uploadURL: uploadResp.uploadURL,
      isPaused: false
    });
    if (file.size == null) {
      this.setFileState(file.id, {
        size: uploadResp.bytesUploaded || currentProgress.bytesTotal
      });
    }
    this.calculateTotalProgress();
  });
  this.on("preprocess-progress", (file, progress2) => {
    if (file == null || !this.getFile(file.id)) {
      this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
      return;
    }
    this.setFileState(file.id, {
      progress: {
        ...this.getFile(file.id).progress,
        preprocess: progress2
      }
    });
  });
  this.on("preprocess-complete", (file) => {
    if (file == null || !this.getFile(file.id)) {
      this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
      return;
    }
    const files = {
      ...this.getState().files
    };
    files[file.id] = {
      ...files[file.id],
      progress: {
        ...files[file.id].progress
      }
    };
    delete files[file.id].progress.preprocess;
    this.setState({
      files
    });
  });
  this.on("postprocess-progress", (file, progress2) => {
    if (file == null || !this.getFile(file.id)) {
      this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
      return;
    }
    this.setFileState(file.id, {
      progress: {
        ...this.getState().files[file.id].progress,
        postprocess: progress2
      }
    });
  });
  this.on("postprocess-complete", (file) => {
    if (file == null || !this.getFile(file.id)) {
      this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
      return;
    }
    const files = {
      ...this.getState().files
    };
    files[file.id] = {
      ...files[file.id],
      progress: {
        ...files[file.id].progress
      }
    };
    delete files[file.id].progress.postprocess;
    this.setState({
      files
    });
  });
  this.on("restored", () => {
    this.calculateTotalProgress();
  });
  this.on("dashboard:file-edit-complete", (file) => {
    if (file) {
      _classPrivateFieldLooseBase12(this, _checkRequiredMetaFieldsOnFile)[_checkRequiredMetaFieldsOnFile](file);
    }
  });
  if (typeof window !== "undefined" && window.addEventListener) {
    window.addEventListener("online", _classPrivateFieldLooseBase12(this, _updateOnlineStatus)[_updateOnlineStatus]);
    window.addEventListener("offline", _classPrivateFieldLooseBase12(this, _updateOnlineStatus)[_updateOnlineStatus]);
    setTimeout(_classPrivateFieldLooseBase12(this, _updateOnlineStatus)[_updateOnlineStatus], 3e3);
  }
}
function _createUpload222(fileIDs, opts) {
  if (opts === void 0) {
    opts = {};
  }
  const {
    forceAllowNewUpload = false
  } = opts;
  const {
    allowNewUpload,
    currentUploads
  } = this.getState();
  if (!allowNewUpload && !forceAllowNewUpload) {
    throw new Error("Cannot create a new upload: already uploading.");
  }
  const uploadID = nanoid2();
  this.emit("upload", {
    id: uploadID,
    fileIDs
  });
  this.setState({
    allowNewUpload: this.opts.allowMultipleUploadBatches !== false && this.opts.allowMultipleUploads !== false,
    currentUploads: {
      ...currentUploads,
      [uploadID]: {
        fileIDs,
        step: 0,
        result: {}
      }
    }
  });
  return uploadID;
}
function _getUpload2(uploadID) {
  const {
    currentUploads
  } = this.getState();
  return currentUploads[uploadID];
}
function _removeUpload2(uploadID) {
  const currentUploads = {
    ...this.getState().currentUploads
  };
  delete currentUploads[uploadID];
  this.setState({
    currentUploads
  });
}
async function _runUpload2(uploadID) {
  const getCurrentUpload = () => {
    const {
      currentUploads
    } = this.getState();
    return currentUploads[uploadID];
  };
  let currentUpload = getCurrentUpload();
  const steps2 = [..._classPrivateFieldLooseBase12(this, _preProcessors)[_preProcessors], ..._classPrivateFieldLooseBase12(this, _uploaders)[_uploaders], ..._classPrivateFieldLooseBase12(this, _postProcessors)[_postProcessors]];
  try {
    for (let step = currentUpload.step || 0; step < steps2.length; step++) {
      if (!currentUpload) {
        break;
      }
      const fn = steps2[step];
      this.setState({
        currentUploads: {
          ...this.getState().currentUploads,
          [uploadID]: {
            ...currentUpload,
            step
          }
        }
      });
      const {
        fileIDs
      } = currentUpload;
      await fn(fileIDs, uploadID);
      currentUpload = getCurrentUpload();
    }
  } catch (err) {
    _classPrivateFieldLooseBase12(this, _removeUpload)[_removeUpload](uploadID);
    throw err;
  }
  if (currentUpload) {
    currentUpload.fileIDs.forEach((fileID) => {
      const file = this.getFile(fileID);
      if (file && file.progress.postprocess) {
        this.emit("postprocess-complete", file);
      }
    });
    const files = currentUpload.fileIDs.map((fileID) => this.getFile(fileID));
    const successful = files.filter((file) => !file.error);
    const failed = files.filter((file) => file.error);
    this.addResultData(uploadID, {
      successful,
      failed,
      uploadID
    });
    currentUpload = getCurrentUpload();
  }
  let result;
  if (currentUpload) {
    result = currentUpload.result;
    this.emit("complete", result);
    _classPrivateFieldLooseBase12(this, _removeUpload)[_removeUpload](uploadID);
  }
  if (result == null) {
    this.log(`Not setting result for an upload that has been removed: ${uploadID}`);
  }
  return result;
}
Uppy2.VERSION = packageJson52.version;
var Uppy_default = Uppy2;
var n2;
var l2;
var u2;
var t2;
var i2;
var o2;
var r2;
var f2;
var e2;
var c2 = {};
var s2 = [];
var a2 = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
var h10 = Array.isArray;
function v2(n3, l4) {
  for (var u4 in l4)
    n3[u4] = l4[u4];
  return n3;
}
function p2(n3) {
  var l4 = n3.parentNode;
  l4 && l4.removeChild(n3);
}
function y2(l4, u4, t4) {
  var i4, o4, r4, f4 = {};
  for (r4 in u4)
    "key" == r4 ? i4 = u4[r4] : "ref" == r4 ? o4 = u4[r4] : f4[r4] = u4[r4];
  if (arguments.length > 2 && (f4.children = arguments.length > 3 ? n2.call(arguments, 2) : t4), "function" == typeof l4 && null != l4.defaultProps)
    for (r4 in l4.defaultProps)
      void 0 === f4[r4] && (f4[r4] = l4.defaultProps[r4]);
  return d2(l4, f4, i4, o4, null);
}
function d2(n3, t4, i4, o4, r4) {
  var f4 = { type: n3, props: t4, key: i4, ref: o4, __k: null, __: null, __b: 0, __e: null, __d: void 0, __c: null, constructor: void 0, __v: null == r4 ? ++u2 : r4, __i: -1, __u: 0 };
  return null == r4 && null != l2.vnode && l2.vnode(f4), f4;
}
function _() {
  return { current: null };
}
function g2(n3) {
  return n3.children;
}
function b2(n3, l4) {
  this.props = n3, this.context = l4;
}
function m2(n3, l4) {
  if (null == l4)
    return n3.__ ? m2(n3.__, n3.__i + 1) : null;
  for (var u4; l4 < n3.__k.length; l4++)
    if (null != (u4 = n3.__k[l4]) && null != u4.__e)
      return u4.__e;
  return "function" == typeof n3.type ? m2(n3) : null;
}
function w2(n3, u4, t4) {
  var i4, o4 = n3.__v, r4 = o4.__e, f4 = n3.__P;
  if (f4)
    return (i4 = v2({}, o4)).__v = o4.__v + 1, l2.vnode && l2.vnode(i4), M2(f4, i4, o4, n3.__n, void 0 !== f4.ownerSVGElement, 32 & o4.__u ? [r4] : null, u4, null == r4 ? m2(o4) : r4, !!(32 & o4.__u), t4), i4.__v = o4.__v, i4.__.__k[i4.__i] = i4, i4.__d = void 0, i4.__e != r4 && k2(i4), i4;
}
function k2(n3) {
  var l4, u4;
  if (null != (n3 = n3.__) && null != n3.__c) {
    for (n3.__e = n3.__c.base = null, l4 = 0; l4 < n3.__k.length; l4++)
      if (null != (u4 = n3.__k[l4]) && null != u4.__e) {
        n3.__e = n3.__c.base = u4.__e;
        break;
      }
    return k2(n3);
  }
}
function x2(n3) {
  (!n3.__d && (n3.__d = true) && i2.push(n3) && !C2.__r++ || o2 !== l2.debounceRendering) && ((o2 = l2.debounceRendering) || r2)(C2);
}
function C2() {
  var n3, u4, t4, o4 = [], r4 = [];
  for (i2.sort(f2); n3 = i2.shift(); )
    n3.__d && (t4 = i2.length, u4 = w2(n3, o4, r4) || u4, 0 === t4 || i2.length > t4 ? (j2(o4, u4, r4), r4.length = o4.length = 0, u4 = void 0, i2.sort(f2)) : u4 && l2.__c && l2.__c(u4, s2));
  u4 && j2(o4, u4, r4), C2.__r = 0;
}
function P2(n3, l4, u4, t4, i4, o4, r4, f4, e4, a4, h102) {
  var v4, p4, y4, d4, _4, g3 = t4 && t4.__k || s2, b3 = l4.length;
  for (u4.__d = e4, S2(u4, l4, g3), e4 = u4.__d, v4 = 0; v4 < b3; v4++)
    null != (y4 = u4.__k[v4]) && "boolean" != typeof y4 && "function" != typeof y4 && (p4 = -1 === y4.__i ? c2 : g3[y4.__i] || c2, y4.__i = v4, M2(n3, y4, p4, i4, o4, r4, f4, e4, a4, h102), d4 = y4.__e, y4.ref && p4.ref != y4.ref && (p4.ref && N2(p4.ref, null, y4), h102.push(y4.ref, y4.__c || d4, y4)), null == _4 && null != d4 && (_4 = d4), 65536 & y4.__u || p4.__k === y4.__k ? e4 = $2(y4, e4, n3) : "function" == typeof y4.type && void 0 !== y4.__d ? e4 = y4.__d : d4 && (e4 = d4.nextSibling), y4.__d = void 0, y4.__u &= -196609);
  u4.__d = e4, u4.__e = _4;
}
function S2(n3, l4, u4) {
  var t4, i4, o4, r4, f4, e4 = l4.length, c4 = u4.length, s4 = c4, a4 = 0;
  for (n3.__k = [], t4 = 0; t4 < e4; t4++)
    r4 = t4 + a4, null != (i4 = n3.__k[t4] = null == (i4 = l4[t4]) || "boolean" == typeof i4 || "function" == typeof i4 ? null : "string" == typeof i4 || "number" == typeof i4 || "bigint" == typeof i4 || i4.constructor == String ? d2(null, i4, null, null, null) : h10(i4) ? d2(g2, { children: i4 }, null, null, null) : void 0 === i4.constructor && i4.__b > 0 ? d2(i4.type, i4.props, i4.key, i4.ref ? i4.ref : null, i4.__v) : i4) ? (i4.__ = n3, i4.__b = n3.__b + 1, f4 = I2(i4, u4, r4, s4), i4.__i = f4, o4 = null, -1 !== f4 && (s4--, (o4 = u4[f4]) && (o4.__u |= 131072)), null == o4 || null === o4.__v ? (-1 == f4 && a4--, "function" != typeof i4.type && (i4.__u |= 65536)) : f4 !== r4 && (f4 === r4 + 1 ? a4++ : f4 > r4 ? s4 > e4 - r4 ? a4 += f4 - r4 : a4-- : f4 < r4 ? f4 == r4 - 1 && (a4 = f4 - r4) : a4 = 0, f4 !== t4 + a4 && (i4.__u |= 65536))) : (o4 = u4[r4]) && null == o4.key && o4.__e && 0 == (131072 & o4.__u) && (o4.__e == n3.__d && (n3.__d = m2(o4)), O2(o4, o4, false), u4[r4] = null, s4--);
  if (s4)
    for (t4 = 0; t4 < c4; t4++)
      null != (o4 = u4[t4]) && 0 == (131072 & o4.__u) && (o4.__e == n3.__d && (n3.__d = m2(o4)), O2(o4, o4));
}
function $2(n3, l4, u4) {
  var t4, i4;
  if ("function" == typeof n3.type) {
    for (t4 = n3.__k, i4 = 0; t4 && i4 < t4.length; i4++)
      t4[i4] && (t4[i4].__ = n3, l4 = $2(t4[i4], l4, u4));
    return l4;
  }
  n3.__e != l4 && (u4.insertBefore(n3.__e, l4 || null), l4 = n3.__e);
  do {
    l4 = l4 && l4.nextSibling;
  } while (null != l4 && 8 === l4.nodeType);
  return l4;
}
function H(n3, l4) {
  return l4 = l4 || [], null == n3 || "boolean" == typeof n3 || (h10(n3) ? n3.some(function(n4) {
    H(n4, l4);
  }) : l4.push(n3)), l4;
}
function I2(n3, l4, u4, t4) {
  var i4 = n3.key, o4 = n3.type, r4 = u4 - 1, f4 = u4 + 1, e4 = l4[u4];
  if (null === e4 || e4 && i4 == e4.key && o4 === e4.type && 0 == (131072 & e4.__u))
    return u4;
  if (t4 > (null != e4 && 0 == (131072 & e4.__u) ? 1 : 0))
    for (; r4 >= 0 || f4 < l4.length; ) {
      if (r4 >= 0) {
        if ((e4 = l4[r4]) && 0 == (131072 & e4.__u) && i4 == e4.key && o4 === e4.type)
          return r4;
        r4--;
      }
      if (f4 < l4.length) {
        if ((e4 = l4[f4]) && 0 == (131072 & e4.__u) && i4 == e4.key && o4 === e4.type)
          return f4;
        f4++;
      }
    }
  return -1;
}
function T2(n3, l4, u4) {
  "-" === l4[0] ? n3.setProperty(l4, null == u4 ? "" : u4) : n3[l4] = null == u4 ? "" : "number" != typeof u4 || a2.test(l4) ? u4 : u4 + "px";
}
function A2(n3, l4, u4, t4, i4) {
  var o4;
  n:
    if ("style" === l4)
      if ("string" == typeof u4)
        n3.style.cssText = u4;
      else {
        if ("string" == typeof t4 && (n3.style.cssText = t4 = ""), t4)
          for (l4 in t4)
            u4 && l4 in u4 || T2(n3.style, l4, "");
        if (u4)
          for (l4 in u4)
            t4 && u4[l4] === t4[l4] || T2(n3.style, l4, u4[l4]);
      }
    else if ("o" === l4[0] && "n" === l4[1])
      o4 = l4 !== (l4 = l4.replace(/(PointerCapture)$|Capture$/i, "$1")), l4 = l4.toLowerCase() in n3 ? l4.toLowerCase().slice(2) : l4.slice(2), n3.l || (n3.l = {}), n3.l[l4 + o4] = u4, u4 ? t4 ? u4.u = t4.u : (u4.u = Date.now(), n3.addEventListener(l4, o4 ? L2 : D2, o4)) : n3.removeEventListener(l4, o4 ? L2 : D2, o4);
    else {
      if (i4)
        l4 = l4.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
      else if ("width" !== l4 && "height" !== l4 && "href" !== l4 && "list" !== l4 && "form" !== l4 && "tabIndex" !== l4 && "download" !== l4 && "rowSpan" !== l4 && "colSpan" !== l4 && "role" !== l4 && l4 in n3)
        try {
          n3[l4] = null == u4 ? "" : u4;
          break n;
        } catch (n4) {
        }
      "function" == typeof u4 || (null == u4 || false === u4 && "-" !== l4[4] ? n3.removeAttribute(l4) : n3.setAttribute(l4, u4));
    }
}
function D2(n3) {
  if (this.l) {
    var u4 = this.l[n3.type + false];
    if (n3.t) {
      if (n3.t <= u4.u)
        return;
    } else
      n3.t = Date.now();
    return u4(l2.event ? l2.event(n3) : n3);
  }
}
function L2(n3) {
  if (this.l)
    return this.l[n3.type + true](l2.event ? l2.event(n3) : n3);
}
function M2(n3, u4, t4, i4, o4, r4, f4, e4, c4, s4) {
  var a4, p4, y4, d4, _4, m4, w4, k4, x4, C4, S3, $3, H3, I3, T3, A3 = u4.type;
  if (void 0 !== u4.constructor)
    return null;
  128 & t4.__u && (c4 = !!(32 & t4.__u), r4 = [e4 = u4.__e = t4.__e]), (a4 = l2.__b) && a4(u4);
  n:
    if ("function" == typeof A3)
      try {
        if (k4 = u4.props, x4 = (a4 = A3.contextType) && i4[a4.__c], C4 = a4 ? x4 ? x4.props.value : a4.__ : i4, t4.__c ? w4 = (p4 = u4.__c = t4.__c).__ = p4.__E : ("prototype" in A3 && A3.prototype.render ? u4.__c = p4 = new A3(k4, C4) : (u4.__c = p4 = new b2(k4, C4), p4.constructor = A3, p4.render = q2), x4 && x4.sub(p4), p4.props = k4, p4.state || (p4.state = {}), p4.context = C4, p4.__n = i4, y4 = p4.__d = true, p4.__h = [], p4._sb = []), null == p4.__s && (p4.__s = p4.state), null != A3.getDerivedStateFromProps && (p4.__s == p4.state && (p4.__s = v2({}, p4.__s)), v2(p4.__s, A3.getDerivedStateFromProps(k4, p4.__s))), d4 = p4.props, _4 = p4.state, p4.__v = u4, y4)
          null == A3.getDerivedStateFromProps && null != p4.componentWillMount && p4.componentWillMount(), null != p4.componentDidMount && p4.__h.push(p4.componentDidMount);
        else {
          if (null == A3.getDerivedStateFromProps && k4 !== d4 && null != p4.componentWillReceiveProps && p4.componentWillReceiveProps(k4, C4), !p4.__e && (null != p4.shouldComponentUpdate && false === p4.shouldComponentUpdate(k4, p4.__s, C4) || u4.__v === t4.__v)) {
            for (u4.__v !== t4.__v && (p4.props = k4, p4.state = p4.__s, p4.__d = false), u4.__e = t4.__e, u4.__k = t4.__k, u4.__k.forEach(function(n4) {
              n4 && (n4.__ = u4);
            }), S3 = 0; S3 < p4._sb.length; S3++)
              p4.__h.push(p4._sb[S3]);
            p4._sb = [], p4.__h.length && f4.push(p4);
            break n;
          }
          null != p4.componentWillUpdate && p4.componentWillUpdate(k4, p4.__s, C4), null != p4.componentDidUpdate && p4.__h.push(function() {
            p4.componentDidUpdate(d4, _4, m4);
          });
        }
        if (p4.context = C4, p4.props = k4, p4.__P = n3, p4.__e = false, $3 = l2.__r, H3 = 0, "prototype" in A3 && A3.prototype.render) {
          for (p4.state = p4.__s, p4.__d = false, $3 && $3(u4), a4 = p4.render(p4.props, p4.state, p4.context), I3 = 0; I3 < p4._sb.length; I3++)
            p4.__h.push(p4._sb[I3]);
          p4._sb = [];
        } else
          do {
            p4.__d = false, $3 && $3(u4), a4 = p4.render(p4.props, p4.state, p4.context), p4.state = p4.__s;
          } while (p4.__d && ++H3 < 25);
        p4.state = p4.__s, null != p4.getChildContext && (i4 = v2(v2({}, i4), p4.getChildContext())), y4 || null == p4.getSnapshotBeforeUpdate || (m4 = p4.getSnapshotBeforeUpdate(d4, _4)), P2(n3, h10(T3 = null != a4 && a4.type === g2 && null == a4.key ? a4.props.children : a4) ? T3 : [T3], u4, t4, i4, o4, r4, f4, e4, c4, s4), p4.base = u4.__e, u4.__u &= -161, p4.__h.length && f4.push(p4), w4 && (p4.__E = p4.__ = null);
      } catch (n4) {
        u4.__v = null, c4 || null != r4 ? (u4.__e = e4, u4.__u |= c4 ? 160 : 32, r4[r4.indexOf(e4)] = null) : (u4.__e = t4.__e, u4.__k = t4.__k), l2.__e(n4, u4, t4);
      }
    else
      null == r4 && u4.__v === t4.__v ? (u4.__k = t4.__k, u4.__e = t4.__e) : u4.__e = z4(t4.__e, u4, t4, i4, o4, r4, f4, c4, s4);
  (a4 = l2.diffed) && a4(u4);
}
function j2(n3, u4, t4) {
  for (var i4 = 0; i4 < t4.length; i4++)
    N2(t4[i4], t4[++i4], t4[++i4]);
  l2.__c && l2.__c(u4, n3), n3.some(function(u5) {
    try {
      n3 = u5.__h, u5.__h = [], n3.some(function(n4) {
        n4.call(u5);
      });
    } catch (n4) {
      l2.__e(n4, u5.__v);
    }
  });
}
function z4(l4, u4, t4, i4, o4, r4, f4, e4, s4) {
  var a4, v4, y4, d4, _4, g3, b3, w4 = t4.props, k4 = u4.props, x4 = u4.type;
  if ("svg" === x4 && (o4 = true), null != r4) {
    for (a4 = 0; a4 < r4.length; a4++)
      if ((_4 = r4[a4]) && "setAttribute" in _4 == !!x4 && (x4 ? _4.localName === x4 : 3 === _4.nodeType)) {
        l4 = _4, r4[a4] = null;
        break;
      }
  }
  if (null == l4) {
    if (null === x4)
      return document.createTextNode(k4);
    l4 = o4 ? document.createElementNS("http://www.w3.org/2000/svg", x4) : document.createElement(x4, k4.is && k4), r4 = null, e4 = false;
  }
  if (null === x4)
    w4 === k4 || e4 && l4.data === k4 || (l4.data = k4);
  else {
    if (r4 = r4 && n2.call(l4.childNodes), w4 = t4.props || c2, !e4 && null != r4)
      for (w4 = {}, a4 = 0; a4 < l4.attributes.length; a4++)
        w4[(_4 = l4.attributes[a4]).name] = _4.value;
    for (a4 in w4)
      _4 = w4[a4], "children" == a4 || ("dangerouslySetInnerHTML" == a4 ? y4 = _4 : "key" === a4 || a4 in k4 || A2(l4, a4, null, _4, o4));
    for (a4 in k4)
      _4 = k4[a4], "children" == a4 ? d4 = _4 : "dangerouslySetInnerHTML" == a4 ? v4 = _4 : "value" == a4 ? g3 = _4 : "checked" == a4 ? b3 = _4 : "key" === a4 || e4 && "function" != typeof _4 || w4[a4] === _4 || A2(l4, a4, _4, w4[a4], o4);
    if (v4)
      e4 || y4 && (v4.__html === y4.__html || v4.__html === l4.innerHTML) || (l4.innerHTML = v4.__html), u4.__k = [];
    else if (y4 && (l4.innerHTML = ""), P2(l4, h10(d4) ? d4 : [d4], u4, t4, i4, o4 && "foreignObject" !== x4, r4, f4, r4 ? r4[0] : t4.__k && m2(t4, 0), e4, s4), null != r4)
      for (a4 = r4.length; a4--; )
        null != r4[a4] && p2(r4[a4]);
    e4 || (a4 = "value", void 0 !== g3 && (g3 !== l4[a4] || "progress" === x4 && !g3 || "option" === x4 && g3 !== w4[a4]) && A2(l4, a4, g3, w4[a4], false), a4 = "checked", void 0 !== b3 && b3 !== l4[a4] && A2(l4, a4, b3, w4[a4], false));
  }
  return l4;
}
function N2(n3, u4, t4) {
  try {
    "function" == typeof n3 ? n3(u4) : n3.current = u4;
  } catch (n4) {
    l2.__e(n4, t4);
  }
}
function O2(n3, u4, t4) {
  var i4, o4;
  if (l2.unmount && l2.unmount(n3), (i4 = n3.ref) && (i4.current && i4.current !== n3.__e || N2(i4, null, u4)), null != (i4 = n3.__c)) {
    if (i4.componentWillUnmount)
      try {
        i4.componentWillUnmount();
      } catch (n4) {
        l2.__e(n4, u4);
      }
    i4.base = i4.__P = null, n3.__c = void 0;
  }
  if (i4 = n3.__k)
    for (o4 = 0; o4 < i4.length; o4++)
      i4[o4] && O2(i4[o4], u4, t4 || "function" != typeof n3.type);
  t4 || null == n3.__e || p2(n3.__e), n3.__ = n3.__e = n3.__d = void 0;
}
function q2(n3, l4, u4) {
  return this.constructor(n3, u4);
}
function B(u4, t4, i4) {
  var o4, r4, f4, e4;
  l2.__ && l2.__(u4, t4), r4 = (o4 = "function" == typeof i4) ? null : i4 && i4.__k || t4.__k, f4 = [], e4 = [], M2(t4, u4 = (!o4 && i4 || t4).__k = y2(g2, null, [u4]), r4 || c2, c2, void 0 !== t4.ownerSVGElement, !o4 && i4 ? [i4] : r4 ? null : t4.firstChild ? n2.call(t4.childNodes) : null, f4, !o4 && i4 ? i4 : r4 ? r4.__e : t4.firstChild, o4, e4), u4.__d = void 0, j2(f4, u4, e4);
}
function F(l4, u4, t4) {
  var i4, o4, r4, f4, e4 = v2({}, l4.props);
  for (r4 in l4.type && l4.type.defaultProps && (f4 = l4.type.defaultProps), u4)
    "key" == r4 ? i4 = u4[r4] : "ref" == r4 ? o4 = u4[r4] : e4[r4] = void 0 === u4[r4] && void 0 !== f4 ? f4[r4] : u4[r4];
  return arguments.length > 2 && (e4.children = arguments.length > 3 ? n2.call(arguments, 2) : t4), d2(l4.type, e4, i4 || l4.key, o4 || l4.ref, null);
}
n2 = s2.slice, l2 = { __e: function(n3, l4, u4, t4) {
  for (var i4, o4, r4; l4 = l4.__; )
    if ((i4 = l4.__c) && !i4.__)
      try {
        if ((o4 = i4.constructor) && null != o4.getDerivedStateFromError && (i4.setState(o4.getDerivedStateFromError(n3)), r4 = i4.__d), null != i4.componentDidCatch && (i4.componentDidCatch(n3, t4 || {}), r4 = i4.__d), r4)
          return i4.__E = i4;
      } catch (l5) {
        n3 = l5;
      }
  throw n3;
} }, u2 = 0, t2 = function(n3) {
  return null != n3 && null == n3.constructor;
}, b2.prototype.setState = function(n3, l4) {
  var u4;
  u4 = null != this.__s && this.__s !== this.state ? this.__s : this.__s = v2({}, this.state), "function" == typeof n3 && (n3 = n3(v2({}, u4), this.props)), n3 && v2(u4, n3), null != n3 && this.__v && (l4 && this._sb.push(l4), x2(this));
}, b2.prototype.forceUpdate = function(n3) {
  this.__v && (this.__e = true, n3 && this.__h.push(n3), x2(this));
}, b2.prototype.render = g2, i2 = [], r2 = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, f2 = function(n3, l4) {
  return n3.__v.__b - l4.__v.__b;
}, C2.__r = 0, e2 = 0;
function isDOMElement(obj) {
  if (typeof obj !== "object" || obj === null)
    return false;
  if (!("nodeType" in obj))
    return false;
  return obj.nodeType === Node.ELEMENT_NODE;
}
function findDOMElement(element, context) {
  if (context === void 0) {
    context = document;
  }
  if (typeof element === "string") {
    return context.querySelector(element);
  }
  if (isDOMElement(element)) {
    return element;
  }
  return null;
}
var findDOMElement_default = findDOMElement;
function getTextDirection2(element) {
  var _element;
  while (element && !element.dir) {
    element = element.parentNode;
  }
  return (_element = element) == null ? void 0 : _element.dir;
}
var getTextDirection_default2 = getTextDirection2;
function _classPrivateFieldLooseBase13(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id132 = 0;
function _classPrivateFieldLooseKey13(name) {
  return "__private_" + id132++ + "_" + name;
}
function debounce22(fn) {
  let calling = null;
  let latestArgs;
  return function() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    latestArgs = args;
    if (!calling) {
      calling = Promise.resolve().then(() => {
        calling = null;
        return fn(...latestArgs);
      });
    }
    return calling;
  };
}
var _updateUI = /* @__PURE__ */ _classPrivateFieldLooseKey13("updateUI");
var UIPlugin5 = class _UIPlugin extends BasePlugin3 {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, _updateUI, {
      writable: true,
      value: void 0
    });
  }
  getTargetPlugin(target) {
    let targetPlugin;
    if (typeof (target == null ? void 0 : target.addTarget) === "function") {
      targetPlugin = target;
      if (!(targetPlugin instanceof _UIPlugin)) {
        console.warn(new Error("The provided plugin is not an instance of UIPlugin. This is an indication of a bug with the way Uppy is bundled.", {
          cause: {
            targetPlugin,
            UIPlugin: _UIPlugin
          }
        }));
      }
    } else if (typeof target === "function") {
      const Target = target;
      this.uppy.iteratePlugins((p4) => {
        if (p4 instanceof Target) {
          targetPlugin = p4;
        }
      });
    }
    return targetPlugin;
  }
  /**
   * Check if supplied `target` is a DOM element or an `object`.
   * If it’s an object — target is a plugin, and we search `plugins`
   * for a plugin with same name and return its target.
   */
  mount(target, plugin) {
    const callerPluginName = plugin.id;
    const targetElement = findDOMElement_default(target);
    if (targetElement) {
      this.isTargetDOMEl = true;
      const uppyRootElement = document.createElement("div");
      uppyRootElement.classList.add("uppy-Root");
      _classPrivateFieldLooseBase13(this, _updateUI)[_updateUI] = debounce22((state) => {
        if (!this.uppy.getPlugin(this.id))
          return;
        B(this.render(state), uppyRootElement);
        this.afterUpdate();
      });
      this.uppy.log(`Installing ${callerPluginName} to a DOM element '${target}'`);
      if (this.opts.replaceTargetContent) {
        targetElement.innerHTML = "";
      }
      B(this.render(this.uppy.getState()), uppyRootElement);
      this.el = uppyRootElement;
      targetElement.appendChild(uppyRootElement);
      uppyRootElement.dir = this.opts.direction || getTextDirection_default2(uppyRootElement) || "ltr";
      this.onMount();
      return this.el;
    }
    const targetPlugin = this.getTargetPlugin(target);
    if (targetPlugin) {
      this.uppy.log(`Installing ${callerPluginName} to ${targetPlugin.id}`);
      this.parent = targetPlugin;
      this.el = targetPlugin.addTarget(plugin);
      this.onMount();
      return this.el;
    }
    this.uppy.log(`Not installing ${callerPluginName}`);
    let message = `Invalid target option given to ${callerPluginName}.`;
    if (typeof target === "function") {
      message += " The given target is not a Plugin class. Please check that you're not specifying a React Component instead of a plugin. If you are using @uppy/* packages directly, make sure you have only 1 version of @uppy/core installed: run `npm ls @uppy/core` on the command line and verify that all the versions match and are deduped correctly.";
    } else {
      message += "If you meant to target an HTML element, please make sure that the element exists. Check that the <script> tag initializing Uppy is right before the closing </body> tag at the end of the page. (see https://github.com/transloadit/uppy/issues/1042)\n\nIf you meant to target a plugin, please confirm that your `import` statements or `require` calls are correct.";
    }
    throw new Error(message);
  }
  /**
   * Called when plugin is mounted, whether in DOM or into another plugin.
   * Needed because sometimes plugins are mounted separately/after `install`,
   * so this.el and this.parent might not be available in `install`.
   * This is the case with @uppy/react plugins, for example.
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  render(state) {
    throw new Error("Extend the render method to add your plugin to a DOM element");
  }
  update(state) {
    if (this.el != null) {
      var _classPrivateFieldLoo, _classPrivateFieldLoo2;
      (_classPrivateFieldLoo = (_classPrivateFieldLoo2 = _classPrivateFieldLooseBase13(this, _updateUI))[_updateUI]) == null || _classPrivateFieldLoo.call(_classPrivateFieldLoo2, state);
    }
  }
  unmount() {
    if (this.isTargetDOMEl) {
      var _this$el;
      (_this$el = this.el) == null || _this$el.remove();
    }
    this.onUnmount();
  }
  onMount() {
  }
  onUnmount() {
  }
};
var UIPlugin_default = UIPlugin5;
function emaFilter2(newValue, previousSmoothedValue, halfLife, dt) {
  if (halfLife === 0 || newValue === previousSmoothedValue)
    return newValue;
  if (dt === 0)
    return previousSmoothedValue;
  return newValue + (previousSmoothedValue - newValue) * 2 ** (-dt / halfLife);
}
var StatusBarStates_default2 = {
  STATE_ERROR: "error",
  STATE_WAITING: "waiting",
  STATE_PREPROCESSING: "preprocessing",
  STATE_UPLOADING: "uploading",
  STATE_POSTPROCESSING: "postprocessing",
  STATE_COMPLETE: "complete"
};
var import_classnames22 = __toESM2(require_classnames2(), 1);
function calculateProcessingProgress2(files) {
  const values = [];
  let mode = "indeterminate";
  let message;
  for (const {
    progress: progress2
  } of Object.values(files)) {
    const {
      preprocess,
      postprocess
    } = progress2;
    if (message == null && (preprocess || postprocess)) {
      ;
      ({
        mode,
        message
      } = preprocess || postprocess);
    }
    if ((preprocess == null ? void 0 : preprocess.mode) === "determinate")
      values.push(preprocess.value);
    if ((postprocess == null ? void 0 : postprocess.mode) === "determinate")
      values.push(postprocess.value);
  }
  const value = values.reduce((total, progressValue) => {
    return total + progressValue / values.length;
  }, 0);
  return {
    mode,
    message,
    value
  };
}
var import_classnames3 = __toESM2(require_classnames2(), 1);
var import_prettier_bytes22 = __toESM2(require_prettierBytes2(), 1);
function secondsToTime2(rawSeconds) {
  const hours = Math.floor(rawSeconds / 3600) % 24;
  const minutes = Math.floor(rawSeconds / 60) % 60;
  const seconds = Math.floor(rawSeconds % 60);
  return {
    hours,
    minutes,
    seconds
  };
}
function prettyETA2(seconds) {
  const time = secondsToTime2(seconds);
  const hoursStr = time.hours === 0 ? "" : `${time.hours}h`;
  const minutesStr = time.minutes === 0 ? "" : `${time.hours === 0 ? time.minutes : ` ${time.minutes.toString(10).padStart(2, "0")}`}m`;
  const secondsStr = time.hours !== 0 ? "" : `${time.minutes === 0 ? time.seconds : ` ${time.seconds.toString(10).padStart(2, "0")}`}s`;
  return `${hoursStr}${minutesStr}${secondsStr}`;
}
var DOT2 = `\xB7`;
var renderDot2 = () => ` ${DOT2} `;
function UploadBtn2(props) {
  const {
    newFiles,
    isUploadStarted,
    recoveredState,
    i18n,
    uploadState,
    isSomeGhost,
    startUpload
  } = props;
  const uploadBtnClassNames = (0, import_classnames3.default)("uppy-u-reset", "uppy-c-btn", "uppy-StatusBar-actionBtn", "uppy-StatusBar-actionBtn--upload", {
    "uppy-c-btn-primary": uploadState === StatusBarStates_default2.STATE_WAITING
  }, {
    "uppy-StatusBar-actionBtn--disabled": isSomeGhost
  });
  const uploadBtnText = newFiles && isUploadStarted && !recoveredState ? i18n("uploadXNewFiles", {
    smart_count: newFiles
  }) : i18n("uploadXFiles", {
    smart_count: newFiles
  });
  return y2("button", {
    type: "button",
    className: uploadBtnClassNames,
    "aria-label": i18n("uploadXFiles", {
      smart_count: newFiles
    }),
    onClick: startUpload,
    disabled: isSomeGhost,
    "data-uppy-super-focusable": true
  }, uploadBtnText);
}
function RetryBtn2(props) {
  const {
    i18n,
    uppy: uppy22
  } = props;
  return y2("button", {
    type: "button",
    className: "uppy-u-reset uppy-c-btn uppy-StatusBar-actionBtn uppy-StatusBar-actionBtn--retry",
    "aria-label": i18n("retryUpload"),
    onClick: () => uppy22.retryAll().catch(() => {
    }),
    "data-uppy-super-focusable": true,
    "data-cy": "retry"
  }, y2("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    width: "8",
    height: "10",
    viewBox: "0 0 8 10"
  }, y2("path", {
    d: "M4 2.408a2.75 2.75 0 1 0 2.75 2.75.626.626 0 0 1 1.25.018v.023a4 4 0 1 1-4-4.041V.25a.25.25 0 0 1 .389-.208l2.299 1.533a.25.25 0 0 1 0 .416l-2.3 1.533A.25.25 0 0 1 4 3.316v-.908z"
  })), i18n("retry"));
}
function CancelBtn2(props) {
  const {
    i18n,
    uppy: uppy22
  } = props;
  return y2("button", {
    type: "button",
    className: "uppy-u-reset uppy-StatusBar-actionCircleBtn",
    title: i18n("cancel"),
    "aria-label": i18n("cancel"),
    onClick: () => uppy22.cancelAll(),
    "data-cy": "cancel",
    "data-uppy-super-focusable": true
  }, y2("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16"
  }, y2("g", {
    fill: "none",
    fillRule: "evenodd"
  }, y2("circle", {
    fill: "#888",
    cx: "8",
    cy: "8",
    r: "8"
  }), y2("path", {
    fill: "#FFF",
    d: "M9.283 8l2.567 2.567-1.283 1.283L8 9.283 5.433 11.85 4.15 10.567 6.717 8 4.15 5.433 5.433 4.15 8 6.717l2.567-2.567 1.283 1.283z"
  }))));
}
function PauseResumeButton2(props) {
  const {
    isAllPaused,
    i18n,
    isAllComplete,
    resumableUploads,
    uppy: uppy22
  } = props;
  const title = isAllPaused ? i18n("resume") : i18n("pause");
  function togglePauseResume() {
    if (isAllComplete)
      return;
    if (!resumableUploads) {
      uppy22.cancelAll();
      return;
    }
    if (isAllPaused) {
      uppy22.resumeAll();
      return;
    }
    uppy22.pauseAll();
  }
  return y2("button", {
    title,
    "aria-label": title,
    className: "uppy-u-reset uppy-StatusBar-actionCircleBtn",
    type: "button",
    onClick: togglePauseResume,
    "data-cy": "togglePauseResume",
    "data-uppy-super-focusable": true
  }, y2("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16"
  }, y2("g", {
    fill: "none",
    fillRule: "evenodd"
  }, y2("circle", {
    fill: "#888",
    cx: "8",
    cy: "8",
    r: "8"
  }), y2("path", {
    fill: "#FFF",
    d: isAllPaused ? "M6 4.25L11.5 8 6 11.75z" : "M5 4.5h2v7H5v-7zm4 0h2v7H9v-7z"
  }))));
}
function DoneBtn2(props) {
  const {
    i18n,
    doneButtonHandler
  } = props;
  return y2("button", {
    type: "button",
    className: "uppy-u-reset uppy-c-btn uppy-StatusBar-actionBtn uppy-StatusBar-actionBtn--done",
    onClick: doneButtonHandler,
    "data-uppy-super-focusable": true
  }, i18n("done"));
}
function LoadingSpinner2() {
  return y2("svg", {
    className: "uppy-StatusBar-spinner",
    "aria-hidden": "true",
    focusable: "false",
    width: "14",
    height: "14"
  }, y2("path", {
    d: "M13.983 6.547c-.12-2.509-1.64-4.893-3.939-5.936-2.48-1.127-5.488-.656-7.556 1.094C.524 3.367-.398 6.048.162 8.562c.556 2.495 2.46 4.52 4.94 5.183 2.932.784 5.61-.602 7.256-3.015-1.493 1.993-3.745 3.309-6.298 2.868-2.514-.434-4.578-2.349-5.153-4.84a6.226 6.226 0 0 1 2.98-6.778C6.34.586 9.74 1.1 11.373 3.493c.407.596.693 1.282.842 1.988.127.598.073 1.197.161 1.794.078.525.543 1.257 1.15.864.525-.341.49-1.05.456-1.592-.007-.15.02.3 0 0",
    fillRule: "evenodd"
  }));
}
function ProgressBarProcessing2(props) {
  const {
    progress: progress2
  } = props;
  const {
    value,
    mode,
    message
  } = progress2;
  const dot = `\xB7`;
  return y2("div", {
    className: "uppy-StatusBar-content"
  }, y2(LoadingSpinner2, null), mode === "determinate" ? `${Math.round(value * 100)}% ${dot} ` : "", message);
}
function ProgressDetails2(props) {
  const {
    numUploads,
    complete,
    totalUploadedSize,
    totalSize,
    totalETA,
    i18n
  } = props;
  const ifShowFilesUploadedOfTotal = numUploads > 1;
  return y2("div", {
    className: "uppy-StatusBar-statusSecondary"
  }, ifShowFilesUploadedOfTotal && i18n("filesUploadedOfTotal", {
    complete,
    smart_count: numUploads
  }), y2("span", {
    className: "uppy-StatusBar-additionalInfo"
  }, ifShowFilesUploadedOfTotal && renderDot2(), i18n("dataUploadedOfTotal", {
    complete: (0, import_prettier_bytes22.default)(totalUploadedSize),
    total: (0, import_prettier_bytes22.default)(totalSize)
  }), renderDot2(), i18n("xTimeLeft", {
    time: prettyETA2(totalETA)
  })));
}
function FileUploadCount2(props) {
  const {
    i18n,
    complete,
    numUploads
  } = props;
  return y2("div", {
    className: "uppy-StatusBar-statusSecondary"
  }, i18n("filesUploadedOfTotal", {
    complete,
    smart_count: numUploads
  }));
}
function UploadNewlyAddedFiles2(props) {
  const {
    i18n,
    newFiles,
    startUpload
  } = props;
  const uploadBtnClassNames = (0, import_classnames3.default)("uppy-u-reset", "uppy-c-btn", "uppy-StatusBar-actionBtn", "uppy-StatusBar-actionBtn--uploadNewlyAdded");
  return y2("div", {
    className: "uppy-StatusBar-statusSecondary"
  }, y2("div", {
    className: "uppy-StatusBar-statusSecondaryHint"
  }, i18n("xMoreFilesAdded", {
    smart_count: newFiles
  })), y2("button", {
    type: "button",
    className: uploadBtnClassNames,
    "aria-label": i18n("uploadXFiles", {
      smart_count: newFiles
    }),
    onClick: startUpload
  }, i18n("upload")));
}
function ProgressBarUploading2(props) {
  const {
    i18n,
    supportsUploadProgress: supportsUploadProgress2,
    totalProgress,
    showProgressDetails,
    isUploadStarted,
    isAllComplete,
    isAllPaused,
    newFiles,
    numUploads,
    complete,
    totalUploadedSize,
    totalSize,
    totalETA,
    startUpload
  } = props;
  const showUploadNewlyAddedFiles = newFiles && isUploadStarted;
  if (!isUploadStarted || isAllComplete) {
    return null;
  }
  const title = isAllPaused ? i18n("paused") : i18n("uploading");
  function renderProgressDetails() {
    if (!isAllPaused && !showUploadNewlyAddedFiles && showProgressDetails) {
      if (supportsUploadProgress2) {
        return y2(ProgressDetails2, {
          numUploads,
          complete,
          totalUploadedSize,
          totalSize,
          totalETA,
          i18n
        });
      }
      return y2(FileUploadCount2, {
        i18n,
        complete,
        numUploads
      });
    }
    return null;
  }
  return y2("div", {
    className: "uppy-StatusBar-content",
    "aria-label": title,
    title
  }, !isAllPaused ? y2(LoadingSpinner2, null) : null, y2("div", {
    className: "uppy-StatusBar-status"
  }, y2("div", {
    className: "uppy-StatusBar-statusPrimary"
  }, supportsUploadProgress2 ? `${title}: ${totalProgress}%` : title), renderProgressDetails(), showUploadNewlyAddedFiles ? y2(UploadNewlyAddedFiles2, {
    i18n,
    newFiles,
    startUpload
  }) : null));
}
function ProgressBarComplete2(props) {
  const {
    i18n
  } = props;
  return y2("div", {
    className: "uppy-StatusBar-content",
    role: "status",
    title: i18n("complete")
  }, y2("div", {
    className: "uppy-StatusBar-status"
  }, y2("div", {
    className: "uppy-StatusBar-statusPrimary"
  }, y2("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-StatusBar-statusIndicator uppy-c-icon",
    width: "15",
    height: "11",
    viewBox: "0 0 15 11"
  }, y2("path", {
    d: "M.414 5.843L1.627 4.63l3.472 3.472L13.202 0l1.212 1.213L5.1 10.528z"
  })), i18n("complete"))));
}
function ProgressBarError2(props) {
  const {
    error,
    i18n,
    complete,
    numUploads
  } = props;
  function displayErrorAlert() {
    const errorMessage = `${i18n("uploadFailed")} 

 ${error}`;
    alert(errorMessage);
  }
  return y2("div", {
    className: "uppy-StatusBar-content",
    title: i18n("uploadFailed")
  }, y2("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-StatusBar-statusIndicator uppy-c-icon",
    width: "11",
    height: "11",
    viewBox: "0 0 11 11"
  }, y2("path", {
    d: "M4.278 5.5L0 1.222 1.222 0 5.5 4.278 9.778 0 11 1.222 6.722 5.5 11 9.778 9.778 11 5.5 6.722 1.222 11 0 9.778z"
  })), y2("div", {
    className: "uppy-StatusBar-status"
  }, y2("div", {
    className: "uppy-StatusBar-statusPrimary"
  }, i18n("uploadFailed"), y2("button", {
    className: "uppy-u-reset uppy-StatusBar-details",
    "aria-label": i18n("showErrorDetails"),
    "data-microtip-position": "top-right",
    "data-microtip-size": "medium",
    onClick: displayErrorAlert,
    type: "button"
  }, "?")), y2(FileUploadCount2, {
    i18n,
    complete,
    numUploads
  })));
}
var {
  STATE_ERROR: STATE_ERROR2,
  STATE_WAITING: STATE_WAITING2,
  STATE_PREPROCESSING: STATE_PREPROCESSING2,
  STATE_UPLOADING: STATE_UPLOADING2,
  STATE_POSTPROCESSING: STATE_POSTPROCESSING2,
  STATE_COMPLETE: STATE_COMPLETE2
} = StatusBarStates_default2;
function StatusBar4(props) {
  const {
    newFiles,
    allowNewUpload,
    isUploadInProgress,
    isAllPaused,
    resumableUploads,
    error,
    hideUploadButton,
    hidePauseResumeButton,
    hideCancelButton,
    hideRetryButton,
    recoveredState,
    uploadState,
    totalProgress,
    files,
    supportsUploadProgress: supportsUploadProgress2,
    hideAfterFinish,
    isSomeGhost,
    doneButtonHandler,
    isUploadStarted,
    i18n,
    startUpload,
    uppy: uppy22,
    isAllComplete,
    showProgressDetails,
    numUploads,
    complete,
    totalSize,
    totalETA,
    totalUploadedSize
  } = props;
  function getProgressValue() {
    switch (uploadState) {
      case STATE_POSTPROCESSING2:
      case STATE_PREPROCESSING2: {
        const progress2 = calculateProcessingProgress2(files);
        if (progress2.mode === "determinate") {
          return progress2.value * 100;
        }
        return totalProgress;
      }
      case STATE_ERROR2: {
        return null;
      }
      case STATE_UPLOADING2: {
        if (!supportsUploadProgress2) {
          return null;
        }
        return totalProgress;
      }
      default:
        return totalProgress;
    }
  }
  function getIsIndeterminate() {
    switch (uploadState) {
      case STATE_POSTPROCESSING2:
      case STATE_PREPROCESSING2: {
        const {
          mode
        } = calculateProcessingProgress2(files);
        return mode === "indeterminate";
      }
      case STATE_UPLOADING2: {
        if (!supportsUploadProgress2) {
          return true;
        }
        return false;
      }
      default:
        return false;
    }
  }
  function getIsHidden() {
    if (recoveredState) {
      return false;
    }
    switch (uploadState) {
      case STATE_WAITING2:
        return hideUploadButton || newFiles === 0;
      case STATE_COMPLETE2:
        return hideAfterFinish;
      default:
        return false;
    }
  }
  const progressValue = getProgressValue();
  const isHidden = getIsHidden();
  const width = progressValue != null ? progressValue : 100;
  const showUploadBtn = !error && newFiles && !isUploadInProgress && !isAllPaused && allowNewUpload && !hideUploadButton;
  const showCancelBtn = !hideCancelButton && uploadState !== STATE_WAITING2 && uploadState !== STATE_COMPLETE2;
  const showPauseResumeBtn = resumableUploads && !hidePauseResumeButton && uploadState === STATE_UPLOADING2;
  const showRetryBtn = error && !isAllComplete && !hideRetryButton;
  const showDoneBtn = doneButtonHandler && uploadState === STATE_COMPLETE2;
  const progressClassNames = (0, import_classnames22.default)("uppy-StatusBar-progress", {
    "is-indeterminate": getIsIndeterminate()
  });
  const statusBarClassNames = (0, import_classnames22.default)("uppy-StatusBar", `is-${uploadState}`, {
    "has-ghosts": isSomeGhost
  });
  return y2("div", {
    className: statusBarClassNames,
    "aria-hidden": isHidden
  }, y2("div", {
    className: progressClassNames,
    style: {
      width: `${width}%`
    },
    role: "progressbar",
    "aria-label": `${width}%`,
    "aria-valuetext": `${width}%`,
    "aria-valuemin": 0,
    "aria-valuemax": 100,
    "aria-valuenow": progressValue
  }), (() => {
    switch (uploadState) {
      case STATE_PREPROCESSING2:
      case STATE_POSTPROCESSING2:
        return y2(ProgressBarProcessing2, {
          progress: calculateProcessingProgress2(files)
        });
      case STATE_COMPLETE2:
        return y2(ProgressBarComplete2, {
          i18n
        });
      case STATE_ERROR2:
        return y2(ProgressBarError2, {
          error,
          i18n,
          numUploads,
          complete
        });
      case STATE_UPLOADING2:
        return y2(ProgressBarUploading2, {
          i18n,
          supportsUploadProgress: supportsUploadProgress2,
          totalProgress,
          showProgressDetails,
          isUploadStarted,
          isAllComplete,
          isAllPaused,
          newFiles,
          numUploads,
          complete,
          totalUploadedSize,
          totalSize,
          totalETA,
          startUpload
        });
      default:
        return null;
    }
  })(), y2("div", {
    className: "uppy-StatusBar-actions"
  }, recoveredState || showUploadBtn ? y2(UploadBtn2, {
    newFiles,
    isUploadStarted,
    recoveredState,
    i18n,
    isSomeGhost,
    startUpload,
    uploadState
  }) : null, showRetryBtn ? y2(RetryBtn2, {
    i18n,
    uppy: uppy22
  }) : null, showPauseResumeBtn ? y2(PauseResumeButton2, {
    isAllPaused,
    i18n,
    isAllComplete,
    resumableUploads,
    uppy: uppy22
  }) : null, showCancelBtn ? y2(CancelBtn2, {
    i18n,
    uppy: uppy22
  }) : null, showDoneBtn ? y2(DoneBtn2, {
    i18n,
    doneButtonHandler
  }) : null));
}
StatusBar4.defaultProps = {
  doneButtonHandler: void 0,
  hideAfterFinish: false,
  hideCancelButton: false,
  hidePauseResumeButton: false,
  hideRetryButton: false,
  hideUploadButton: void 0,
  showProgressDetails: void 0
};
var locale_default32 = {
  strings: {
    // Shown in the status bar while files are being uploaded.
    uploading: "Uploading",
    // Shown in the status bar once all files have been uploaded.
    complete: "Complete",
    // Shown in the status bar if an upload failed.
    uploadFailed: "Upload failed",
    // Shown in the status bar while the upload is paused.
    paused: "Paused",
    // Used as the label for the button that retries an upload.
    retry: "Retry",
    // Used as the label for the button that cancels an upload.
    cancel: "Cancel",
    // Used as the label for the button that pauses an upload.
    pause: "Pause",
    // Used as the label for the button that resumes an upload.
    resume: "Resume",
    // Used as the label for the button that resets the upload state after an upload
    done: "Done",
    // When `showProgressDetails` is set, shows the number of files that have been fully uploaded so far.
    filesUploadedOfTotal: {
      0: "%{complete} of %{smart_count} file uploaded",
      1: "%{complete} of %{smart_count} files uploaded"
    },
    // When `showProgressDetails` is set, shows the amount of bytes that have been uploaded so far.
    dataUploadedOfTotal: "%{complete} of %{total}",
    // When `showProgressDetails` is set, shows an estimation of how long the upload will take to complete.
    xTimeLeft: "%{time} left",
    // Used as the label for the button that starts an upload.
    uploadXFiles: {
      0: "Upload %{smart_count} file",
      1: "Upload %{smart_count} files"
    },
    // Used as the label for the button that starts an upload, if another upload has been started in the past
    // and new files were added later.
    uploadXNewFiles: {
      0: "Upload +%{smart_count} file",
      1: "Upload +%{smart_count} files"
    },
    upload: "Upload",
    retryUpload: "Retry upload",
    xMoreFilesAdded: {
      0: "%{smart_count} more file added",
      1: "%{smart_count} more files added"
    },
    showErrorDetails: "Show error details"
  }
};
function _classPrivateFieldLooseBase14(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id14 = 0;
function _classPrivateFieldLooseKey14(name) {
  return "__private_" + id14++ + "_" + name;
}
var packageJson62 = {
  "version": "3.3.0"
};
var speedFilterHalfLife2 = 2e3;
var ETAFilterHalfLife2 = 2e3;
function getUploadingState2(error, isAllComplete, recoveredState, files) {
  if (error) {
    return StatusBarStates_default2.STATE_ERROR;
  }
  if (isAllComplete) {
    return StatusBarStates_default2.STATE_COMPLETE;
  }
  if (recoveredState) {
    return StatusBarStates_default2.STATE_WAITING;
  }
  let state = StatusBarStates_default2.STATE_WAITING;
  const fileIDs = Object.keys(files);
  for (let i4 = 0; i4 < fileIDs.length; i4++) {
    const {
      progress: progress2
    } = files[fileIDs[i4]];
    if (progress2.uploadStarted && !progress2.uploadComplete) {
      return StatusBarStates_default2.STATE_UPLOADING;
    }
    if (progress2.preprocess) {
      state = StatusBarStates_default2.STATE_PREPROCESSING;
    }
    if (progress2.postprocess && state !== StatusBarStates_default2.STATE_PREPROCESSING) {
      state = StatusBarStates_default2.STATE_POSTPROCESSING;
    }
  }
  return state;
}
var defaultOptions32 = {
  target: "body",
  hideUploadButton: false,
  hideRetryButton: false,
  hidePauseResumeButton: false,
  hideCancelButton: false,
  showProgressDetails: false,
  hideAfterFinish: true,
  doneButtonHandler: null
};
var _lastUpdateTime2 = /* @__PURE__ */ _classPrivateFieldLooseKey14("lastUpdateTime");
var _previousUploadedBytes2 = /* @__PURE__ */ _classPrivateFieldLooseKey14("previousUploadedBytes");
var _previousSpeed2 = /* @__PURE__ */ _classPrivateFieldLooseKey14("previousSpeed");
var _previousETA2 = /* @__PURE__ */ _classPrivateFieldLooseKey14("previousETA");
var _computeSmoothETA3 = /* @__PURE__ */ _classPrivateFieldLooseKey14("computeSmoothETA");
var _onUploadStart2 = /* @__PURE__ */ _classPrivateFieldLooseKey14("onUploadStart");
var StatusBar22 = class extends UIPlugin_default {
  constructor(uppy22, opts) {
    super(uppy22, {
      ...defaultOptions32,
      ...opts
    });
    Object.defineProperty(this, _computeSmoothETA3, {
      value: _computeSmoothETA22
    });
    Object.defineProperty(this, _lastUpdateTime2, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _previousUploadedBytes2, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _previousSpeed2, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _previousETA2, {
      writable: true,
      value: void 0
    });
    this.startUpload = () => {
      return this.uppy.upload().catch(() => {
      });
    };
    Object.defineProperty(this, _onUploadStart2, {
      writable: true,
      value: () => {
        const {
          recoveredState
        } = this.uppy.getState();
        _classPrivateFieldLooseBase14(this, _previousSpeed2)[_previousSpeed2] = null;
        _classPrivateFieldLooseBase14(this, _previousETA2)[_previousETA2] = null;
        if (recoveredState) {
          _classPrivateFieldLooseBase14(this, _previousUploadedBytes2)[_previousUploadedBytes2] = Object.values(recoveredState.files).reduce((pv, _ref) => {
            let {
              progress: progress2
            } = _ref;
            return pv + progress2.bytesUploaded;
          }, 0);
          this.uppy.emit("restore-confirmed");
          return;
        }
        _classPrivateFieldLooseBase14(this, _lastUpdateTime2)[_lastUpdateTime2] = performance.now();
        _classPrivateFieldLooseBase14(this, _previousUploadedBytes2)[_previousUploadedBytes2] = 0;
      }
    });
    this.id = this.opts.id || "StatusBar";
    this.title = "StatusBar";
    this.type = "progressindicator";
    this.defaultLocale = locale_default32;
    this.i18nInit();
    this.render = this.render.bind(this);
    this.install = this.install.bind(this);
  }
  render(state) {
    const {
      capabilities,
      files,
      allowNewUpload,
      totalProgress,
      error,
      recoveredState
    } = state;
    const {
      newFiles,
      startedFiles,
      completeFiles,
      isUploadStarted,
      isAllComplete,
      isAllErrored,
      isAllPaused,
      isUploadInProgress,
      isSomeGhost
    } = this.uppy.getObjectOfFilesPerState();
    const newFilesOrRecovered = recoveredState ? Object.values(files) : newFiles;
    const resumableUploads = !!capabilities.resumableUploads;
    const supportsUploadProgress2 = capabilities.uploadProgress !== false;
    let totalSize = 0;
    let totalUploadedSize = 0;
    startedFiles.forEach((file) => {
      totalSize += file.progress.bytesTotal || 0;
      totalUploadedSize += file.progress.bytesUploaded || 0;
    });
    const totalETA = _classPrivateFieldLooseBase14(this, _computeSmoothETA3)[_computeSmoothETA3]({
      uploaded: totalUploadedSize,
      total: totalSize,
      remaining: totalSize - totalUploadedSize
    });
    return StatusBar4({
      error,
      uploadState: getUploadingState2(error, isAllComplete, recoveredState, state.files || {}),
      allowNewUpload,
      totalProgress,
      totalSize,
      totalUploadedSize,
      isAllComplete: false,
      isAllPaused,
      // @ts-expect-error TODO: remove this in 4.x branch
      isAllErrored,
      isUploadStarted,
      isUploadInProgress,
      isSomeGhost,
      recoveredState,
      complete: completeFiles.length,
      newFiles: newFilesOrRecovered.length,
      numUploads: startedFiles.length,
      totalETA,
      files,
      i18n: this.i18n,
      uppy: this.uppy,
      startUpload: this.startUpload,
      doneButtonHandler: this.opts.doneButtonHandler,
      resumableUploads,
      supportsUploadProgress: supportsUploadProgress2,
      showProgressDetails: this.opts.showProgressDetails,
      hideUploadButton: this.opts.hideUploadButton,
      hideRetryButton: this.opts.hideRetryButton,
      hidePauseResumeButton: this.opts.hidePauseResumeButton,
      hideCancelButton: this.opts.hideCancelButton,
      hideAfterFinish: this.opts.hideAfterFinish,
      // ts-expect-error TODO: remove this in 4.x branch
      isTargetDOMEl: this.isTargetDOMEl
    });
  }
  onMount() {
    const element = this.el;
    const direction = getTextDirection_default2(element);
    if (!direction) {
      element.dir = "ltr";
    }
  }
  install() {
    const {
      target
    } = this.opts;
    if (target) {
      this.mount(target, this);
    }
    this.uppy.on("upload", _classPrivateFieldLooseBase14(this, _onUploadStart2)[_onUploadStart2]);
    _classPrivateFieldLooseBase14(this, _lastUpdateTime2)[_lastUpdateTime2] = performance.now();
    _classPrivateFieldLooseBase14(this, _previousUploadedBytes2)[_previousUploadedBytes2] = this.uppy.getFiles().reduce((pv, file) => pv + file.progress.bytesUploaded, 0);
  }
  uninstall() {
    this.unmount();
    this.uppy.off("upload", _classPrivateFieldLooseBase14(this, _onUploadStart2)[_onUploadStart2]);
  }
};
function _computeSmoothETA22(totalBytes) {
  var _classPrivateFieldLoo, _classPrivateFieldLoo2;
  if (totalBytes.total === 0 || totalBytes.remaining === 0) {
    return 0;
  }
  (_classPrivateFieldLoo2 = (_classPrivateFieldLoo = _classPrivateFieldLooseBase14(this, _lastUpdateTime2))[_lastUpdateTime2]) != null ? _classPrivateFieldLoo2 : _classPrivateFieldLoo[_lastUpdateTime2] = performance.now();
  const dt = performance.now() - _classPrivateFieldLooseBase14(this, _lastUpdateTime2)[_lastUpdateTime2];
  if (dt === 0) {
    var _classPrivateFieldLoo3;
    return Math.round(((_classPrivateFieldLoo3 = _classPrivateFieldLooseBase14(this, _previousETA2)[_previousETA2]) != null ? _classPrivateFieldLoo3 : 0) / 100) / 10;
  }
  const uploadedBytesSinceLastTick = totalBytes.uploaded - _classPrivateFieldLooseBase14(this, _previousUploadedBytes2)[_previousUploadedBytes2];
  _classPrivateFieldLooseBase14(this, _previousUploadedBytes2)[_previousUploadedBytes2] = totalBytes.uploaded;
  if (uploadedBytesSinceLastTick <= 0) {
    var _classPrivateFieldLoo4;
    return Math.round(((_classPrivateFieldLoo4 = _classPrivateFieldLooseBase14(this, _previousETA2)[_previousETA2]) != null ? _classPrivateFieldLoo4 : 0) / 100) / 10;
  }
  const currentSpeed = uploadedBytesSinceLastTick / dt;
  const filteredSpeed = _classPrivateFieldLooseBase14(this, _previousSpeed2)[_previousSpeed2] == null ? currentSpeed : emaFilter2(currentSpeed, _classPrivateFieldLooseBase14(this, _previousSpeed2)[_previousSpeed2], speedFilterHalfLife2, dt);
  _classPrivateFieldLooseBase14(this, _previousSpeed2)[_previousSpeed2] = filteredSpeed;
  const instantETA = totalBytes.remaining / filteredSpeed;
  const updatedPreviousETA = Math.max(_classPrivateFieldLooseBase14(this, _previousETA2)[_previousETA2] - dt, 0);
  const filteredETA = _classPrivateFieldLooseBase14(this, _previousETA2)[_previousETA2] == null ? instantETA : emaFilter2(instantETA, updatedPreviousETA, ETAFilterHalfLife2, dt);
  _classPrivateFieldLooseBase14(this, _previousETA2)[_previousETA2] = filteredETA;
  _classPrivateFieldLooseBase14(this, _lastUpdateTime2)[_lastUpdateTime2] = performance.now();
  return Math.round(filteredETA / 100) / 10;
}
StatusBar22.VERSION = packageJson62.version;
var TRANSITION_MS = 300;
var FadeIn = class extends b2 {
  constructor() {
    super(...arguments);
    this.ref = _();
  }
  componentWillEnter(callback) {
    this.ref.current.style.opacity = "1";
    this.ref.current.style.transform = "none";
    setTimeout(callback, TRANSITION_MS);
  }
  componentWillLeave(callback) {
    this.ref.current.style.opacity = "0";
    this.ref.current.style.transform = "translateY(350%)";
    setTimeout(callback, TRANSITION_MS);
  }
  render() {
    const {
      children
    } = this.props;
    return y2("div", {
      className: "uppy-Informer-animated",
      ref: this.ref
    }, children);
  }
};
function assign(obj, props) {
  return Object.assign(obj, props);
}
function getKey(vnode, fallback) {
  var _vnode$key;
  return (_vnode$key = vnode == null ? void 0 : vnode.key) != null ? _vnode$key : fallback;
}
function linkRef(component, name) {
  const cache = component._ptgLinkedRefs || (component._ptgLinkedRefs = {});
  return cache[name] || (cache[name] = (c4) => {
    component.refs[name] = c4;
  });
}
function getChildMapping(children) {
  const out = {};
  for (let i4 = 0; i4 < children.length; i4++) {
    if (children[i4] != null) {
      const key = getKey(children[i4], i4.toString(36));
      out[key] = children[i4];
    }
  }
  return out;
}
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};
  const getValueForKey = (key) => next.hasOwnProperty(key) ? next[key] : prev[key];
  const nextKeysPending = {};
  let pendingKeys = [];
  for (const prevKey in prev) {
    if (next.hasOwnProperty(prevKey)) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }
  const childMapping = {};
  for (const nextKey in next) {
    if (nextKeysPending.hasOwnProperty(nextKey)) {
      for (let i4 = 0; i4 < nextKeysPending[nextKey].length; i4++) {
        const pendingNextKey = nextKeysPending[nextKey][i4];
        childMapping[nextKeysPending[nextKey][i4]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }
  for (let i4 = 0; i4 < pendingKeys.length; i4++) {
    childMapping[pendingKeys[i4]] = getValueForKey(pendingKeys[i4]);
  }
  return childMapping;
}
var identity = (i4) => i4;
var TransitionGroup = class extends b2 {
  constructor(props, context) {
    super(props, context);
    this.refs = {};
    this.state = {
      children: getChildMapping(H(H(this.props.children)) || [])
    };
    this.performAppear = this.performAppear.bind(this);
    this.performEnter = this.performEnter.bind(this);
    this.performLeave = this.performLeave.bind(this);
  }
  componentWillMount() {
    this.currentlyTransitioningKeys = {};
    this.keysToAbortLeave = [];
    this.keysToEnter = [];
    this.keysToLeave = [];
  }
  componentDidMount() {
    const initialChildMapping = this.state.children;
    for (const key in initialChildMapping) {
      if (initialChildMapping[key]) {
        this.performAppear(key);
      }
    }
  }
  componentWillReceiveProps(nextProps) {
    const nextChildMapping = getChildMapping(H(nextProps.children) || []);
    const prevChildMapping = this.state.children;
    this.setState((prevState) => ({
      children: mergeChildMappings(prevState.children, nextChildMapping)
    }));
    let key;
    for (key in nextChildMapping) {
      if (nextChildMapping.hasOwnProperty(key)) {
        const hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
        if (nextChildMapping[key] && hasPrev && this.currentlyTransitioningKeys[key]) {
          this.keysToEnter.push(key);
          this.keysToAbortLeave.push(key);
        } else if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
          this.keysToEnter.push(key);
        }
      }
    }
    for (key in prevChildMapping) {
      if (prevChildMapping.hasOwnProperty(key)) {
        const hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(key);
        if (prevChildMapping[key] && !hasNext && !this.currentlyTransitioningKeys[key]) {
          this.keysToLeave.push(key);
        }
      }
    }
  }
  componentDidUpdate() {
    const {
      keysToEnter
    } = this;
    this.keysToEnter = [];
    keysToEnter.forEach(this.performEnter);
    const {
      keysToLeave
    } = this;
    this.keysToLeave = [];
    keysToLeave.forEach(this.performLeave);
  }
  _finishAbort(key) {
    const idx = this.keysToAbortLeave.indexOf(key);
    if (idx !== -1) {
      this.keysToAbortLeave.splice(idx, 1);
    }
  }
  performAppear(key) {
    this.currentlyTransitioningKeys[key] = true;
    const component = this.refs[key];
    if (component != null && component.componentWillAppear) {
      component.componentWillAppear(this._handleDoneAppearing.bind(this, key));
    } else {
      this._handleDoneAppearing(key);
    }
  }
  _handleDoneAppearing(key) {
    const component = this.refs[key];
    if (component != null && component.componentDidAppear) {
      component.componentDidAppear();
    }
    delete this.currentlyTransitioningKeys[key];
    this._finishAbort(key);
    const currentChildMapping = getChildMapping(H(this.props.children) || []);
    if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
      this.performLeave(key);
    }
  }
  performEnter(key) {
    this.currentlyTransitioningKeys[key] = true;
    const component = this.refs[key];
    if (component != null && component.componentWillEnter) {
      component.componentWillEnter(this._handleDoneEntering.bind(this, key));
    } else {
      this._handleDoneEntering(key);
    }
  }
  _handleDoneEntering(key) {
    const component = this.refs[key];
    if (component != null && component.componentDidEnter) {
      component.componentDidEnter();
    }
    delete this.currentlyTransitioningKeys[key];
    this._finishAbort(key);
    const currentChildMapping = getChildMapping(H(this.props.children) || []);
    if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
      this.performLeave(key);
    }
  }
  performLeave(key) {
    const idx = this.keysToAbortLeave.indexOf(key);
    if (idx !== -1) {
      return;
    }
    this.currentlyTransitioningKeys[key] = true;
    const component = this.refs[key];
    if (component != null && component.componentWillLeave) {
      component.componentWillLeave(this._handleDoneLeaving.bind(this, key));
    } else {
      this._handleDoneLeaving(key);
    }
  }
  _handleDoneLeaving(key) {
    const idx = this.keysToAbortLeave.indexOf(key);
    if (idx !== -1) {
      return;
    }
    const component = this.refs[key];
    if (component != null && component.componentDidLeave) {
      component.componentDidLeave();
    }
    delete this.currentlyTransitioningKeys[key];
    const currentChildMapping = getChildMapping(H(this.props.children) || []);
    if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
      this.performEnter(key);
    } else {
      const children = assign({}, this.state.children);
      delete children[key];
      this.setState({
        children
      });
    }
  }
  render(_ref, _ref2) {
    let {
      childFactory,
      transitionLeave,
      transitionName: transitionName2,
      transitionAppear,
      transitionEnter,
      transitionLeaveTimeout,
      transitionEnterTimeout,
      transitionAppearTimeout,
      component,
      ...props
    } = _ref;
    let {
      children
    } = _ref2;
    const childrenToRender = Object.entries(children).map((_ref3) => {
      let [key, child] = _ref3;
      if (!child)
        return void 0;
      const ref = linkRef(this, key);
      return F(childFactory(child), {
        ref,
        key
      });
    }).filter(Boolean);
    return y2(component, props, childrenToRender);
  }
};
TransitionGroup.defaultProps = {
  component: "span",
  childFactory: identity
};
var TransitionGroup_default = TransitionGroup;
var packageJson72 = {
  "version": "3.1.0"
};
var Informer = class extends UIPlugin_default {
  constructor(uppy22, opts) {
    super(uppy22, opts);
    this.render = (state) => {
      return y2("div", {
        className: "uppy uppy-Informer"
      }, y2(TransitionGroup_default, null, state.info.map((info) => y2(FadeIn, {
        key: info.message
      }, y2("p", {
        role: "alert"
      }, info.message, " ", info.details && y2("span", {
        "aria-label": info.details,
        "data-microtip-position": "top-left",
        "data-microtip-size": "medium",
        role: "tooltip",
        onClick: () => (
          // eslint-disable-next-line no-alert
          alert(`${info.message} 

 ${info.details}`)
        )
      }, "?"))))));
    };
    this.type = "progressindicator";
    this.id = this.opts.id || "Informer";
    this.title = "Informer";
  }
  install() {
    const {
      target
    } = this.opts;
    if (target) {
      this.mount(target, this);
    }
  }
};
Informer.VERSION = packageJson72.version;
var DATA_URL_PATTERN = /^data:([^/]+\/[^,;]+(?:[^,]*?))(;base64)?,([\s\S]*)$/;
function dataURItoBlob(dataURI, opts, toFile) {
  var _ref, _opts$mimeType;
  const dataURIData = DATA_URL_PATTERN.exec(dataURI);
  const mimeType = (_ref = (_opts$mimeType = opts.mimeType) != null ? _opts$mimeType : dataURIData == null ? void 0 : dataURIData[1]) != null ? _ref : "plain/text";
  let data;
  if ((dataURIData == null ? void 0 : dataURIData[2]) != null) {
    const binary = atob(decodeURIComponent(dataURIData[3]));
    const bytes = new Uint8Array(binary.length);
    for (let i4 = 0; i4 < binary.length; i4++) {
      bytes[i4] = binary.charCodeAt(i4);
    }
    data = [bytes];
  } else if ((dataURIData == null ? void 0 : dataURIData[3]) != null) {
    data = [decodeURIComponent(dataURIData[3])];
  }
  if (toFile) {
    return new File(data, opts.name || "", {
      type: mimeType
    });
  }
  return new Blob(data, {
    type: mimeType
  });
}
function isObjectURL(url) {
  return url.startsWith("blob:");
}
function isPreviewSupported(fileType) {
  if (!fileType)
    return false;
  return /^[^/]+\/(jpe?g|gif|png|svg|svg\+xml|bmp|webp|avif)$/.test(fileType);
}
function e22(e4, t4, s4) {
  return t4 in e4 ? Object.defineProperty(e4, t4, { value: s4, enumerable: true, configurable: true, writable: true }) : e4[t4] = s4, e4;
}
var t22 = "undefined" != typeof self ? self : global;
var s22 = "undefined" != typeof navigator;
var i22 = s22 && "undefined" == typeof HTMLImageElement;
var n22 = !("undefined" == typeof global || "undefined" == typeof process || !process.versions || !process.versions.node);
var r22 = t22.Buffer;
var a22 = !!r22;
var h22 = (e4) => void 0 !== e4;
function f22(e4) {
  return void 0 === e4 || (e4 instanceof Map ? 0 === e4.size : 0 === Object.values(e4).filter(h22).length);
}
function l22(e4) {
  let t4 = new Error(e4);
  throw delete t4.stack, t4;
}
function o22(e4) {
  let t4 = function(e5) {
    let t5 = 0;
    return e5.ifd0.enabled && (t5 += 1024), e5.exif.enabled && (t5 += 2048), e5.makerNote && (t5 += 2048), e5.userComment && (t5 += 1024), e5.gps.enabled && (t5 += 512), e5.interop.enabled && (t5 += 100), e5.ifd1.enabled && (t5 += 1024), t5 + 2048;
  }(e4);
  return e4.jfif.enabled && (t4 += 50), e4.xmp.enabled && (t4 += 2e4), e4.iptc.enabled && (t4 += 14e3), e4.icc.enabled && (t4 += 6e3), t4;
}
var u22 = (e4) => String.fromCharCode.apply(null, e4);
var d22 = "undefined" != typeof TextDecoder ? new TextDecoder("utf-8") : void 0;
var c22 = class _c {
  static from(e4, t4) {
    return e4 instanceof this && e4.le === t4 ? e4 : new _c(e4, void 0, void 0, t4);
  }
  constructor(e4, t4 = 0, s4, i4) {
    if ("boolean" == typeof i4 && (this.le = i4), Array.isArray(e4) && (e4 = new Uint8Array(e4)), 0 === e4)
      this.byteOffset = 0, this.byteLength = 0;
    else if (e4 instanceof ArrayBuffer) {
      void 0 === s4 && (s4 = e4.byteLength - t4);
      let i5 = new DataView(e4, t4, s4);
      this._swapDataView(i5);
    } else if (e4 instanceof Uint8Array || e4 instanceof DataView || e4 instanceof _c) {
      void 0 === s4 && (s4 = e4.byteLength - t4), (t4 += e4.byteOffset) + s4 > e4.byteOffset + e4.byteLength && l22("Creating view outside of available memory in ArrayBuffer");
      let i5 = new DataView(e4.buffer, t4, s4);
      this._swapDataView(i5);
    } else if ("number" == typeof e4) {
      let t5 = new DataView(new ArrayBuffer(e4));
      this._swapDataView(t5);
    } else
      l22("Invalid input argument for BufferView: " + e4);
  }
  _swapArrayBuffer(e4) {
    this._swapDataView(new DataView(e4));
  }
  _swapBuffer(e4) {
    this._swapDataView(new DataView(e4.buffer, e4.byteOffset, e4.byteLength));
  }
  _swapDataView(e4) {
    this.dataView = e4, this.buffer = e4.buffer, this.byteOffset = e4.byteOffset, this.byteLength = e4.byteLength;
  }
  _lengthToEnd(e4) {
    return this.byteLength - e4;
  }
  set(e4, t4, s4 = _c) {
    return e4 instanceof DataView || e4 instanceof _c ? e4 = new Uint8Array(e4.buffer, e4.byteOffset, e4.byteLength) : e4 instanceof ArrayBuffer && (e4 = new Uint8Array(e4)), e4 instanceof Uint8Array || l22("BufferView.set(): Invalid data argument."), this.toUint8().set(e4, t4), new s4(this, t4, e4.byteLength);
  }
  subarray(e4, t4) {
    return t4 = t4 || this._lengthToEnd(e4), new _c(this, e4, t4);
  }
  toUint8() {
    return new Uint8Array(this.buffer, this.byteOffset, this.byteLength);
  }
  getUint8Array(e4, t4) {
    return new Uint8Array(this.buffer, this.byteOffset + e4, t4);
  }
  getString(e4 = 0, t4 = this.byteLength) {
    let s4 = this.getUint8Array(e4, t4);
    return i4 = s4, d22 ? d22.decode(i4) : a22 ? Buffer.from(i4).toString("utf8") : decodeURIComponent(escape(u22(i4)));
    var i4;
  }
  getLatin1String(e4 = 0, t4 = this.byteLength) {
    let s4 = this.getUint8Array(e4, t4);
    return u22(s4);
  }
  getUnicodeString(e4 = 0, t4 = this.byteLength) {
    const s4 = [];
    for (let i4 = 0; i4 < t4 && e4 + i4 < this.byteLength; i4 += 2)
      s4.push(this.getUint16(e4 + i4));
    return u22(s4);
  }
  getInt8(e4) {
    return this.dataView.getInt8(e4);
  }
  getUint8(e4) {
    return this.dataView.getUint8(e4);
  }
  getInt16(e4, t4 = this.le) {
    return this.dataView.getInt16(e4, t4);
  }
  getInt32(e4, t4 = this.le) {
    return this.dataView.getInt32(e4, t4);
  }
  getUint16(e4, t4 = this.le) {
    return this.dataView.getUint16(e4, t4);
  }
  getUint32(e4, t4 = this.le) {
    return this.dataView.getUint32(e4, t4);
  }
  getFloat32(e4, t4 = this.le) {
    return this.dataView.getFloat32(e4, t4);
  }
  getFloat64(e4, t4 = this.le) {
    return this.dataView.getFloat64(e4, t4);
  }
  getFloat(e4, t4 = this.le) {
    return this.dataView.getFloat32(e4, t4);
  }
  getDouble(e4, t4 = this.le) {
    return this.dataView.getFloat64(e4, t4);
  }
  getUintBytes(e4, t4, s4) {
    switch (t4) {
      case 1:
        return this.getUint8(e4, s4);
      case 2:
        return this.getUint16(e4, s4);
      case 4:
        return this.getUint32(e4, s4);
      case 8:
        return this.getUint64 && this.getUint64(e4, s4);
    }
  }
  getUint(e4, t4, s4) {
    switch (t4) {
      case 8:
        return this.getUint8(e4, s4);
      case 16:
        return this.getUint16(e4, s4);
      case 32:
        return this.getUint32(e4, s4);
      case 64:
        return this.getUint64 && this.getUint64(e4, s4);
    }
  }
  toString(e4) {
    return this.dataView.toString(e4, this.constructor.name);
  }
  ensureChunk() {
  }
};
function p22(e4, t4) {
  l22(`${e4} '${t4}' was not loaded, try using full build of exifr.`);
}
var g22 = class extends Map {
  constructor(e4) {
    super(), this.kind = e4;
  }
  get(e4, t4) {
    return this.has(e4) || p22(this.kind, e4), t4 && (e4 in t4 || function(e5, t5) {
      l22(`Unknown ${e5} '${t5}'.`);
    }(this.kind, e4), t4[e4].enabled || p22(this.kind, e4)), super.get(e4);
  }
  keyList() {
    return Array.from(this.keys());
  }
};
var m22 = new g22("file parser");
var y22 = new g22("segment parser");
var b22 = new g22("file reader");
var w22 = t22.fetch;
function k22(e4, t4) {
  return (i4 = e4).startsWith("data:") || i4.length > 1e4 ? v22(e4, t4, "base64") : n22 && e4.includes("://") ? O22(e4, t4, "url", S22) : n22 ? v22(e4, t4, "fs") : s22 ? O22(e4, t4, "url", S22) : void l22("Invalid input argument");
  var i4;
}
async function O22(e4, t4, s4, i4) {
  return b22.has(s4) ? v22(e4, t4, s4) : i4 ? async function(e5, t5) {
    let s5 = await t5(e5);
    return new c22(s5);
  }(e4, i4) : void l22(`Parser ${s4} is not loaded`);
}
async function v22(e4, t4, s4) {
  let i4 = new (b22.get(s4))(e4, t4);
  return await i4.read(), i4;
}
var S22 = (e4) => w22(e4).then((e5) => e5.arrayBuffer());
var A22 = (e4) => new Promise((t4, s4) => {
  let i4 = new FileReader();
  i4.onloadend = () => t4(i4.result || new ArrayBuffer()), i4.onerror = s4, i4.readAsArrayBuffer(e4);
});
var U = class extends Map {
  get tagKeys() {
    return this.allKeys || (this.allKeys = Array.from(this.keys())), this.allKeys;
  }
  get tagValues() {
    return this.allValues || (this.allValues = Array.from(this.values())), this.allValues;
  }
};
function x22(e4, t4, s4) {
  let i4 = new U();
  for (let [e5, t5] of s4)
    i4.set(e5, t5);
  if (Array.isArray(t4))
    for (let s5 of t4)
      e4.set(s5, i4);
  else
    e4.set(t4, i4);
  return i4;
}
function C22(e4, t4, s4) {
  let i4, n3 = e4.get(t4);
  for (i4 of s4)
    n3.set(i4[0], i4[1]);
}
var B2 = /* @__PURE__ */ new Map();
var V = /* @__PURE__ */ new Map();
var I22 = /* @__PURE__ */ new Map();
var L22 = ["chunked", "firstChunkSize", "firstChunkSizeNode", "firstChunkSizeBrowser", "chunkSize", "chunkLimit"];
var T22 = ["jfif", "xmp", "icc", "iptc", "ihdr"];
var z22 = ["tiff", ...T22];
var P22 = ["ifd0", "ifd1", "exif", "gps", "interop"];
var F2 = [...z22, ...P22];
var j22 = ["makerNote", "userComment"];
var E = ["translateKeys", "translateValues", "reviveValues", "multiSegment"];
var M22 = [...E, "sanitize", "mergeOutput", "silentErrors"];
var _2 = class {
  get translate() {
    return this.translateKeys || this.translateValues || this.reviveValues;
  }
};
var D22 = class extends _2 {
  get needed() {
    return this.enabled || this.deps.size > 0;
  }
  constructor(t4, s4, i4, n3) {
    if (super(), e22(this, "enabled", false), e22(this, "skip", /* @__PURE__ */ new Set()), e22(this, "pick", /* @__PURE__ */ new Set()), e22(this, "deps", /* @__PURE__ */ new Set()), e22(this, "translateKeys", false), e22(this, "translateValues", false), e22(this, "reviveValues", false), this.key = t4, this.enabled = s4, this.parse = this.enabled, this.applyInheritables(n3), this.canBeFiltered = P22.includes(t4), this.canBeFiltered && (this.dict = B2.get(t4)), void 0 !== i4)
      if (Array.isArray(i4))
        this.parse = this.enabled = true, this.canBeFiltered && i4.length > 0 && this.translateTagSet(i4, this.pick);
      else if ("object" == typeof i4) {
        if (this.enabled = true, this.parse = false !== i4.parse, this.canBeFiltered) {
          let { pick: e4, skip: t5 } = i4;
          e4 && e4.length > 0 && this.translateTagSet(e4, this.pick), t5 && t5.length > 0 && this.translateTagSet(t5, this.skip);
        }
        this.applyInheritables(i4);
      } else
        true === i4 || false === i4 ? this.parse = this.enabled = i4 : l22(`Invalid options argument: ${i4}`);
  }
  applyInheritables(e4) {
    let t4, s4;
    for (t4 of E)
      s4 = e4[t4], void 0 !== s4 && (this[t4] = s4);
  }
  translateTagSet(e4, t4) {
    if (this.dict) {
      let s4, i4, { tagKeys: n3, tagValues: r4 } = this.dict;
      for (s4 of e4)
        "string" == typeof s4 ? (i4 = r4.indexOf(s4), -1 === i4 && (i4 = n3.indexOf(Number(s4))), -1 !== i4 && t4.add(Number(n3[i4]))) : t4.add(s4);
    } else
      for (let s4 of e4)
        t4.add(s4);
  }
  finalizeFilters() {
    !this.enabled && this.deps.size > 0 ? (this.enabled = true, X(this.pick, this.deps)) : this.enabled && this.pick.size > 0 && X(this.pick, this.deps);
  }
};
var N22 = { jfif: false, tiff: true, xmp: false, icc: false, iptc: false, ifd0: true, ifd1: false, exif: true, gps: true, interop: false, ihdr: void 0, makerNote: false, userComment: false, multiSegment: false, skip: [], pick: [], translateKeys: true, translateValues: true, reviveValues: true, sanitize: true, mergeOutput: true, silentErrors: true, chunked: true, firstChunkSize: void 0, firstChunkSizeNode: 512, firstChunkSizeBrowser: 65536, chunkSize: 65536, chunkLimit: 5 };
var $22 = /* @__PURE__ */ new Map();
var R = class extends _2 {
  static useCached(e4) {
    let t4 = $22.get(e4);
    return void 0 !== t4 || (t4 = new this(e4), $22.set(e4, t4)), t4;
  }
  constructor(e4) {
    super(), true === e4 ? this.setupFromTrue() : void 0 === e4 ? this.setupFromUndefined() : Array.isArray(e4) ? this.setupFromArray(e4) : "object" == typeof e4 ? this.setupFromObject(e4) : l22(`Invalid options argument ${e4}`), void 0 === this.firstChunkSize && (this.firstChunkSize = s22 ? this.firstChunkSizeBrowser : this.firstChunkSizeNode), this.mergeOutput && (this.ifd1.enabled = false), this.filterNestedSegmentTags(), this.traverseTiffDependencyTree(), this.checkLoadedPlugins();
  }
  setupFromUndefined() {
    let e4;
    for (e4 of L22)
      this[e4] = N22[e4];
    for (e4 of M22)
      this[e4] = N22[e4];
    for (e4 of j22)
      this[e4] = N22[e4];
    for (e4 of F2)
      this[e4] = new D22(e4, N22[e4], void 0, this);
  }
  setupFromTrue() {
    let e4;
    for (e4 of L22)
      this[e4] = N22[e4];
    for (e4 of M22)
      this[e4] = N22[e4];
    for (e4 of j22)
      this[e4] = true;
    for (e4 of F2)
      this[e4] = new D22(e4, true, void 0, this);
  }
  setupFromArray(e4) {
    let t4;
    for (t4 of L22)
      this[t4] = N22[t4];
    for (t4 of M22)
      this[t4] = N22[t4];
    for (t4 of j22)
      this[t4] = N22[t4];
    for (t4 of F2)
      this[t4] = new D22(t4, false, void 0, this);
    this.setupGlobalFilters(e4, void 0, P22);
  }
  setupFromObject(e4) {
    let t4;
    for (t4 of (P22.ifd0 = P22.ifd0 || P22.image, P22.ifd1 = P22.ifd1 || P22.thumbnail, Object.assign(this, e4), L22))
      this[t4] = W(e4[t4], N22[t4]);
    for (t4 of M22)
      this[t4] = W(e4[t4], N22[t4]);
    for (t4 of j22)
      this[t4] = W(e4[t4], N22[t4]);
    for (t4 of z22)
      this[t4] = new D22(t4, N22[t4], e4[t4], this);
    for (t4 of P22)
      this[t4] = new D22(t4, N22[t4], e4[t4], this.tiff);
    this.setupGlobalFilters(e4.pick, e4.skip, P22, F2), true === e4.tiff ? this.batchEnableWithBool(P22, true) : false === e4.tiff ? this.batchEnableWithUserValue(P22, e4) : Array.isArray(e4.tiff) ? this.setupGlobalFilters(e4.tiff, void 0, P22) : "object" == typeof e4.tiff && this.setupGlobalFilters(e4.tiff.pick, e4.tiff.skip, P22);
  }
  batchEnableWithBool(e4, t4) {
    for (let s4 of e4)
      this[s4].enabled = t4;
  }
  batchEnableWithUserValue(e4, t4) {
    for (let s4 of e4) {
      let e5 = t4[s4];
      this[s4].enabled = false !== e5 && void 0 !== e5;
    }
  }
  setupGlobalFilters(e4, t4, s4, i4 = s4) {
    if (e4 && e4.length) {
      for (let e5 of i4)
        this[e5].enabled = false;
      let t5 = K(e4, s4);
      for (let [e5, s5] of t5)
        X(this[e5].pick, s5), this[e5].enabled = true;
    } else if (t4 && t4.length) {
      let e5 = K(t4, s4);
      for (let [t5, s5] of e5)
        X(this[t5].skip, s5);
    }
  }
  filterNestedSegmentTags() {
    let { ifd0: e4, exif: t4, xmp: s4, iptc: i4, icc: n3 } = this;
    this.makerNote ? t4.deps.add(37500) : t4.skip.add(37500), this.userComment ? t4.deps.add(37510) : t4.skip.add(37510), s4.enabled || e4.skip.add(700), i4.enabled || e4.skip.add(33723), n3.enabled || e4.skip.add(34675);
  }
  traverseTiffDependencyTree() {
    let { ifd0: e4, exif: t4, gps: s4, interop: i4 } = this;
    i4.needed && (t4.deps.add(40965), e4.deps.add(40965)), t4.needed && e4.deps.add(34665), s4.needed && e4.deps.add(34853), this.tiff.enabled = P22.some((e5) => true === this[e5].enabled) || this.makerNote || this.userComment;
    for (let e5 of P22)
      this[e5].finalizeFilters();
  }
  get onlyTiff() {
    return !T22.map((e4) => this[e4].enabled).some((e4) => true === e4) && this.tiff.enabled;
  }
  checkLoadedPlugins() {
    for (let e4 of z22)
      this[e4].enabled && !y22.has(e4) && p22("segment parser", e4);
  }
};
function K(e4, t4) {
  let s4, i4, n3, r4, a4 = [];
  for (n3 of t4) {
    for (r4 of (s4 = B2.get(n3), i4 = [], s4))
      (e4.includes(r4[0]) || e4.includes(r4[1])) && i4.push(r4[0]);
    i4.length && a4.push([n3, i4]);
  }
  return a4;
}
function W(e4, t4) {
  return void 0 !== e4 ? e4 : void 0 !== t4 ? t4 : void 0;
}
function X(e4, t4) {
  for (let s4 of t4)
    e4.add(s4);
}
e22(R, "default", N22);
var H2 = class {
  constructor(t4) {
    e22(this, "parsers", {}), e22(this, "output", {}), e22(this, "errors", []), e22(this, "pushToErrors", (e4) => this.errors.push(e4)), this.options = R.useCached(t4);
  }
  async read(e4) {
    this.file = await function(e5, t4) {
      return "string" == typeof e5 ? k22(e5, t4) : s22 && !i22 && e5 instanceof HTMLImageElement ? k22(e5.src, t4) : e5 instanceof Uint8Array || e5 instanceof ArrayBuffer || e5 instanceof DataView ? new c22(e5) : s22 && e5 instanceof Blob ? O22(e5, t4, "blob", A22) : void l22("Invalid input argument");
    }(e4, this.options);
  }
  setup() {
    if (this.fileParser)
      return;
    let { file: e4 } = this, t4 = e4.getUint16(0);
    for (let [s4, i4] of m22)
      if (i4.canHandle(e4, t4))
        return this.fileParser = new i4(this.options, this.file, this.parsers), e4[s4] = true;
    this.file.close && this.file.close(), l22("Unknown file format");
  }
  async parse() {
    let { output: e4, errors: t4 } = this;
    return this.setup(), this.options.silentErrors ? (await this.executeParsers().catch(this.pushToErrors), t4.push(...this.fileParser.errors)) : await this.executeParsers(), this.file.close && this.file.close(), this.options.silentErrors && t4.length > 0 && (e4.errors = t4), f22(s4 = e4) ? void 0 : s4;
    var s4;
  }
  async executeParsers() {
    let { output: e4 } = this;
    await this.fileParser.parse();
    let t4 = Object.values(this.parsers).map(async (t5) => {
      let s4 = await t5.parse();
      t5.assignToOutput(e4, s4);
    });
    this.options.silentErrors && (t4 = t4.map((e5) => e5.catch(this.pushToErrors))), await Promise.all(t4);
  }
  async extractThumbnail() {
    this.setup();
    let { options: e4, file: t4 } = this, s4 = y22.get("tiff", e4);
    var i4;
    if (t4.tiff ? i4 = { start: 0, type: "tiff" } : t4.jpeg && (i4 = await this.fileParser.getOrFindSegment("tiff")), void 0 === i4)
      return;
    let n3 = await this.fileParser.ensureSegmentChunk(i4), r4 = this.parsers.tiff = new s4(n3, e4, t4), a4 = await r4.extractThumbnail();
    return t4.close && t4.close(), a4;
  }
};
async function Y(e4, t4) {
  let s4 = new H2(t4);
  return await s4.read(e4), s4.parse();
}
var G = Object.freeze({ __proto__: null, parse: Y, Exifr: H2, fileParsers: m22, segmentParsers: y22, fileReaders: b22, tagKeys: B2, tagValues: V, tagRevivers: I22, createDictionary: x22, extendDictionary: C22, fetchUrlAsArrayBuffer: S22, readBlobAsArrayBuffer: A22, chunkedProps: L22, otherSegments: T22, segments: z22, tiffBlocks: P22, segmentsAndBlocks: F2, tiffExtractables: j22, inheritables: E, allFormatters: M22, Options: R });
var J = class {
  static findPosition(e4, t4) {
    let s4 = e4.getUint16(t4 + 2) + 2, i4 = "function" == typeof this.headerLength ? this.headerLength(e4, t4, s4) : this.headerLength, n3 = t4 + i4, r4 = s4 - i4;
    return { offset: t4, length: s4, headerLength: i4, start: n3, size: r4, end: n3 + r4 };
  }
  static parse(e4, t4 = {}) {
    return new this(e4, new R({ [this.type]: t4 }), e4).parse();
  }
  normalizeInput(e4) {
    return e4 instanceof c22 ? e4 : new c22(e4);
  }
  constructor(t4, s4 = {}, i4) {
    e22(this, "errors", []), e22(this, "raw", /* @__PURE__ */ new Map()), e22(this, "handleError", (e4) => {
      if (!this.options.silentErrors)
        throw e4;
      this.errors.push(e4.message);
    }), this.chunk = this.normalizeInput(t4), this.file = i4, this.type = this.constructor.type, this.globalOptions = this.options = s4, this.localOptions = s4[this.type], this.canTranslate = this.localOptions && this.localOptions.translate;
  }
  translate() {
    this.canTranslate && (this.translated = this.translateBlock(this.raw, this.type));
  }
  get output() {
    return this.translated ? this.translated : this.raw ? Object.fromEntries(this.raw) : void 0;
  }
  translateBlock(e4, t4) {
    let s4 = I22.get(t4), i4 = V.get(t4), n3 = B2.get(t4), r4 = this.options[t4], a4 = r4.reviveValues && !!s4, h102 = r4.translateValues && !!i4, f4 = r4.translateKeys && !!n3, l4 = {};
    for (let [t5, r5] of e4)
      a4 && s4.has(t5) ? r5 = s4.get(t5)(r5) : h102 && i4.has(t5) && (r5 = this.translateValue(r5, i4.get(t5))), f4 && n3.has(t5) && (t5 = n3.get(t5) || t5), l4[t5] = r5;
    return l4;
  }
  translateValue(e4, t4) {
    return t4[e4] || t4.DEFAULT || e4;
  }
  assignToOutput(e4, t4) {
    this.assignObjectToOutput(e4, this.constructor.type, t4);
  }
  assignObjectToOutput(e4, t4, s4) {
    if (this.globalOptions.mergeOutput)
      return Object.assign(e4, s4);
    e4[t4] ? Object.assign(e4[t4], s4) : e4[t4] = s4;
  }
};
e22(J, "headerLength", 4), e22(J, "type", void 0), e22(J, "multiSegment", false), e22(J, "canHandle", () => false);
function q22(e4) {
  return 192 === e4 || 194 === e4 || 196 === e4 || 219 === e4 || 221 === e4 || 218 === e4 || 254 === e4;
}
function Q(e4) {
  return e4 >= 224 && e4 <= 239;
}
function Z(e4, t4, s4) {
  for (let [i4, n3] of y22)
    if (n3.canHandle(e4, t4, s4))
      return i4;
}
var ee3 = class extends class {
  constructor(t4, s4, i4) {
    e22(this, "errors", []), e22(this, "ensureSegmentChunk", async (e4) => {
      let t5 = e4.start, s5 = e4.size || 65536;
      if (this.file.chunked)
        if (this.file.available(t5, s5))
          e4.chunk = this.file.subarray(t5, s5);
        else
          try {
            e4.chunk = await this.file.readChunk(t5, s5);
          } catch (t6) {
            l22(`Couldn't read segment: ${JSON.stringify(e4)}. ${t6.message}`);
          }
      else
        this.file.byteLength > t5 + s5 ? e4.chunk = this.file.subarray(t5, s5) : void 0 === e4.size ? e4.chunk = this.file.subarray(t5) : l22("Segment unreachable: " + JSON.stringify(e4));
      return e4.chunk;
    }), this.extendOptions && this.extendOptions(t4), this.options = t4, this.file = s4, this.parsers = i4;
  }
  injectSegment(e4, t4) {
    this.options[e4].enabled && this.createParser(e4, t4);
  }
  createParser(e4, t4) {
    let s4 = new (y22.get(e4))(t4, this.options, this.file);
    return this.parsers[e4] = s4;
  }
  createParsers(e4) {
    for (let t4 of e4) {
      let { type: e5, chunk: s4 } = t4, i4 = this.options[e5];
      if (i4 && i4.enabled) {
        let t5 = this.parsers[e5];
        t5 && t5.append || t5 || this.createParser(e5, s4);
      }
    }
  }
  async readSegments(e4) {
    let t4 = e4.map(this.ensureSegmentChunk);
    await Promise.all(t4);
  }
} {
  constructor(...t4) {
    super(...t4), e22(this, "appSegments", []), e22(this, "jpegSegments", []), e22(this, "unknownSegments", []);
  }
  static canHandle(e4, t4) {
    return 65496 === t4;
  }
  async parse() {
    await this.findAppSegments(), await this.readSegments(this.appSegments), this.mergeMultiSegments(), this.createParsers(this.mergedAppSegments || this.appSegments);
  }
  setupSegmentFinderArgs(e4) {
    true === e4 ? (this.findAll = true, this.wanted = new Set(y22.keyList())) : (e4 = void 0 === e4 ? y22.keyList().filter((e5) => this.options[e5].enabled) : e4.filter((e5) => this.options[e5].enabled && y22.has(e5)), this.findAll = false, this.remaining = new Set(e4), this.wanted = new Set(e4)), this.unfinishedMultiSegment = false;
  }
  async findAppSegments(e4 = 0, t4) {
    this.setupSegmentFinderArgs(t4);
    let { file: s4, findAll: i4, wanted: n3, remaining: r4 } = this;
    if (!i4 && this.file.chunked && (i4 = Array.from(n3).some((e5) => {
      let t5 = y22.get(e5), s5 = this.options[e5];
      return t5.multiSegment && s5.multiSegment;
    }), i4 && await this.file.readWhole()), e4 = this.findAppSegmentsInRange(e4, s4.byteLength), !this.options.onlyTiff && s4.chunked) {
      let t5 = false;
      for (; r4.size > 0 && !t5 && (s4.canReadNextChunk || this.unfinishedMultiSegment); ) {
        let { nextChunkOffset: i5 } = s4, n4 = this.appSegments.some((e5) => !this.file.available(e5.offset || e5.start, e5.length || e5.size));
        if (t5 = e4 > i5 && !n4 ? !await s4.readNextChunk(e4) : !await s4.readNextChunk(i5), void 0 === (e4 = this.findAppSegmentsInRange(e4, s4.byteLength)))
          return;
      }
    }
  }
  findAppSegmentsInRange(e4, t4) {
    t4 -= 2;
    let s4, i4, n3, r4, a4, h102, { file: f4, findAll: l4, wanted: o4, remaining: u4, options: d4 } = this;
    for (; e4 < t4; e4++)
      if (255 === f4.getUint8(e4)) {
        if (s4 = f4.getUint8(e4 + 1), Q(s4)) {
          if (i4 = f4.getUint16(e4 + 2), n3 = Z(f4, e4, i4), n3 && o4.has(n3) && (r4 = y22.get(n3), a4 = r4.findPosition(f4, e4), h102 = d4[n3], a4.type = n3, this.appSegments.push(a4), !l4 && (r4.multiSegment && h102.multiSegment ? (this.unfinishedMultiSegment = a4.chunkNumber < a4.chunkCount, this.unfinishedMultiSegment || u4.delete(n3)) : u4.delete(n3), 0 === u4.size)))
            break;
          d4.recordUnknownSegments && (a4 = J.findPosition(f4, e4), a4.marker = s4, this.unknownSegments.push(a4)), e4 += i4 + 1;
        } else if (q22(s4)) {
          if (i4 = f4.getUint16(e4 + 2), 218 === s4 && false !== d4.stopAfterSos)
            return;
          d4.recordJpegSegments && this.jpegSegments.push({ offset: e4, length: i4, marker: s4 }), e4 += i4 + 1;
        }
      }
    return e4;
  }
  mergeMultiSegments() {
    if (!this.appSegments.some((e5) => e5.multiSegment))
      return;
    let e4 = function(e5, t4) {
      let s4, i4, n3, r4 = /* @__PURE__ */ new Map();
      for (let a4 = 0; a4 < e5.length; a4++)
        s4 = e5[a4], i4 = s4[t4], r4.has(i4) ? n3 = r4.get(i4) : r4.set(i4, n3 = []), n3.push(s4);
      return Array.from(r4);
    }(this.appSegments, "type");
    this.mergedAppSegments = e4.map(([e5, t4]) => {
      let s4 = y22.get(e5, this.options);
      if (s4.handleMultiSegments) {
        return { type: e5, chunk: s4.handleMultiSegments(t4) };
      }
      return t4[0];
    });
  }
  getSegment(e4) {
    return this.appSegments.find((t4) => t4.type === e4);
  }
  async getOrFindSegment(e4) {
    let t4 = this.getSegment(e4);
    return void 0 === t4 && (await this.findAppSegments(0, [e4]), t4 = this.getSegment(e4)), t4;
  }
};
e22(ee3, "type", "jpeg"), m22.set("jpeg", ee3);
var te = [void 0, 1, 1, 2, 4, 8, 1, 1, 2, 4, 8, 4, 8, 4];
var se = class extends J {
  parseHeader() {
    var e4 = this.chunk.getUint16();
    18761 === e4 ? this.le = true : 19789 === e4 && (this.le = false), this.chunk.le = this.le, this.headerParsed = true;
  }
  parseTags(e4, t4, s4 = /* @__PURE__ */ new Map()) {
    let { pick: i4, skip: n3 } = this.options[t4];
    i4 = new Set(i4);
    let r4 = i4.size > 0, a4 = 0 === n3.size, h102 = this.chunk.getUint16(e4);
    e4 += 2;
    for (let f4 = 0; f4 < h102; f4++) {
      let h11 = this.chunk.getUint16(e4);
      if (r4) {
        if (i4.has(h11) && (s4.set(h11, this.parseTag(e4, h11, t4)), i4.delete(h11), 0 === i4.size))
          break;
      } else
        !a4 && n3.has(h11) || s4.set(h11, this.parseTag(e4, h11, t4));
      e4 += 12;
    }
    return s4;
  }
  parseTag(e4, t4, s4) {
    let { chunk: i4 } = this, n3 = i4.getUint16(e4 + 2), r4 = i4.getUint32(e4 + 4), a4 = te[n3];
    if (a4 * r4 <= 4 ? e4 += 8 : e4 = i4.getUint32(e4 + 8), (n3 < 1 || n3 > 13) && l22(`Invalid TIFF value type. block: ${s4.toUpperCase()}, tag: ${t4.toString(16)}, type: ${n3}, offset ${e4}`), e4 > i4.byteLength && l22(`Invalid TIFF value offset. block: ${s4.toUpperCase()}, tag: ${t4.toString(16)}, type: ${n3}, offset ${e4} is outside of chunk size ${i4.byteLength}`), 1 === n3)
      return i4.getUint8Array(e4, r4);
    if (2 === n3)
      return "" === (h102 = function(e5) {
        for (; e5.endsWith("\0"); )
          e5 = e5.slice(0, -1);
        return e5;
      }(h102 = i4.getString(e4, r4)).trim()) ? void 0 : h102;
    var h102;
    if (7 === n3)
      return i4.getUint8Array(e4, r4);
    if (1 === r4)
      return this.parseTagValue(n3, e4);
    {
      let t5 = new (function(e5) {
        switch (e5) {
          case 1:
            return Uint8Array;
          case 3:
            return Uint16Array;
          case 4:
            return Uint32Array;
          case 5:
            return Array;
          case 6:
            return Int8Array;
          case 8:
            return Int16Array;
          case 9:
            return Int32Array;
          case 10:
            return Array;
          case 11:
            return Float32Array;
          case 12:
            return Float64Array;
          default:
            return Array;
        }
      }(n3))(r4), s5 = a4;
      for (let i5 = 0; i5 < r4; i5++)
        t5[i5] = this.parseTagValue(n3, e4), e4 += s5;
      return t5;
    }
  }
  parseTagValue(e4, t4) {
    let { chunk: s4 } = this;
    switch (e4) {
      case 1:
        return s4.getUint8(t4);
      case 3:
        return s4.getUint16(t4);
      case 4:
        return s4.getUint32(t4);
      case 5:
        return s4.getUint32(t4) / s4.getUint32(t4 + 4);
      case 6:
        return s4.getInt8(t4);
      case 8:
        return s4.getInt16(t4);
      case 9:
        return s4.getInt32(t4);
      case 10:
        return s4.getInt32(t4) / s4.getInt32(t4 + 4);
      case 11:
        return s4.getFloat(t4);
      case 12:
        return s4.getDouble(t4);
      case 13:
        return s4.getUint32(t4);
      default:
        l22(`Invalid tiff type ${e4}`);
    }
  }
};
var ie = class extends se {
  static canHandle(e4, t4) {
    return 225 === e4.getUint8(t4 + 1) && 1165519206 === e4.getUint32(t4 + 4) && 0 === e4.getUint16(t4 + 8);
  }
  async parse() {
    this.parseHeader();
    let { options: e4 } = this;
    return e4.ifd0.enabled && await this.parseIfd0Block(), e4.exif.enabled && await this.safeParse("parseExifBlock"), e4.gps.enabled && await this.safeParse("parseGpsBlock"), e4.interop.enabled && await this.safeParse("parseInteropBlock"), e4.ifd1.enabled && await this.safeParse("parseThumbnailBlock"), this.createOutput();
  }
  safeParse(e4) {
    let t4 = this[e4]();
    return void 0 !== t4.catch && (t4 = t4.catch(this.handleError)), t4;
  }
  findIfd0Offset() {
    void 0 === this.ifd0Offset && (this.ifd0Offset = this.chunk.getUint32(4));
  }
  findIfd1Offset() {
    if (void 0 === this.ifd1Offset) {
      this.findIfd0Offset();
      let e4 = this.chunk.getUint16(this.ifd0Offset), t4 = this.ifd0Offset + 2 + 12 * e4;
      this.ifd1Offset = this.chunk.getUint32(t4);
    }
  }
  parseBlock(e4, t4) {
    let s4 = /* @__PURE__ */ new Map();
    return this[t4] = s4, this.parseTags(e4, t4, s4), s4;
  }
  async parseIfd0Block() {
    if (this.ifd0)
      return;
    let { file: e4 } = this;
    this.findIfd0Offset(), this.ifd0Offset < 8 && l22("Malformed EXIF data"), !e4.chunked && this.ifd0Offset > e4.byteLength && l22(`IFD0 offset points to outside of file.
this.ifd0Offset: ${this.ifd0Offset}, file.byteLength: ${e4.byteLength}`), e4.tiff && await e4.ensureChunk(this.ifd0Offset, o22(this.options));
    let t4 = this.parseBlock(this.ifd0Offset, "ifd0");
    return 0 !== t4.size ? (this.exifOffset = t4.get(34665), this.interopOffset = t4.get(40965), this.gpsOffset = t4.get(34853), this.xmp = t4.get(700), this.iptc = t4.get(33723), this.icc = t4.get(34675), this.options.sanitize && (t4.delete(34665), t4.delete(40965), t4.delete(34853), t4.delete(700), t4.delete(33723), t4.delete(34675)), t4) : void 0;
  }
  async parseExifBlock() {
    if (this.exif)
      return;
    if (this.ifd0 || await this.parseIfd0Block(), void 0 === this.exifOffset)
      return;
    this.file.tiff && await this.file.ensureChunk(this.exifOffset, o22(this.options));
    let e4 = this.parseBlock(this.exifOffset, "exif");
    return this.interopOffset || (this.interopOffset = e4.get(40965)), this.makerNote = e4.get(37500), this.userComment = e4.get(37510), this.options.sanitize && (e4.delete(40965), e4.delete(37500), e4.delete(37510)), this.unpack(e4, 41728), this.unpack(e4, 41729), e4;
  }
  unpack(e4, t4) {
    let s4 = e4.get(t4);
    s4 && 1 === s4.length && e4.set(t4, s4[0]);
  }
  async parseGpsBlock() {
    if (this.gps)
      return;
    if (this.ifd0 || await this.parseIfd0Block(), void 0 === this.gpsOffset)
      return;
    let e4 = this.parseBlock(this.gpsOffset, "gps");
    return e4 && e4.has(2) && e4.has(4) && (e4.set("latitude", ne(...e4.get(2), e4.get(1))), e4.set("longitude", ne(...e4.get(4), e4.get(3)))), e4;
  }
  async parseInteropBlock() {
    if (!this.interop && (this.ifd0 || await this.parseIfd0Block(), void 0 !== this.interopOffset || this.exif || await this.parseExifBlock(), void 0 !== this.interopOffset))
      return this.parseBlock(this.interopOffset, "interop");
  }
  async parseThumbnailBlock(e4 = false) {
    if (!this.ifd1 && !this.ifd1Parsed && (!this.options.mergeOutput || e4))
      return this.findIfd1Offset(), this.ifd1Offset > 0 && (this.parseBlock(this.ifd1Offset, "ifd1"), this.ifd1Parsed = true), this.ifd1;
  }
  async extractThumbnail() {
    if (this.headerParsed || this.parseHeader(), this.ifd1Parsed || await this.parseThumbnailBlock(true), void 0 === this.ifd1)
      return;
    let e4 = this.ifd1.get(513), t4 = this.ifd1.get(514);
    return this.chunk.getUint8Array(e4, t4);
  }
  get image() {
    return this.ifd0;
  }
  get thumbnail() {
    return this.ifd1;
  }
  createOutput() {
    let e4, t4, s4, i4 = {};
    for (t4 of P22)
      if (e4 = this[t4], !f22(e4))
        if (s4 = this.canTranslate ? this.translateBlock(e4, t4) : Object.fromEntries(e4), this.options.mergeOutput) {
          if ("ifd1" === t4)
            continue;
          Object.assign(i4, s4);
        } else
          i4[t4] = s4;
    return this.makerNote && (i4.makerNote = this.makerNote), this.userComment && (i4.userComment = this.userComment), i4;
  }
  assignToOutput(e4, t4) {
    if (this.globalOptions.mergeOutput)
      Object.assign(e4, t4);
    else
      for (let [s4, i4] of Object.entries(t4))
        this.assignObjectToOutput(e4, s4, i4);
  }
};
function ne(e4, t4, s4, i4) {
  var n3 = e4 + t4 / 60 + s4 / 3600;
  return "S" !== i4 && "W" !== i4 || (n3 *= -1), n3;
}
e22(ie, "type", "tiff"), e22(ie, "headerLength", 10), y22.set("tiff", ie);
var re = Object.freeze({ __proto__: null, default: G, Exifr: H2, fileParsers: m22, segmentParsers: y22, fileReaders: b22, tagKeys: B2, tagValues: V, tagRevivers: I22, createDictionary: x22, extendDictionary: C22, fetchUrlAsArrayBuffer: S22, readBlobAsArrayBuffer: A22, chunkedProps: L22, otherSegments: T22, segments: z22, tiffBlocks: P22, segmentsAndBlocks: F2, tiffExtractables: j22, inheritables: E, allFormatters: M22, Options: R, parse: Y });
var ae = { ifd0: false, ifd1: false, exif: false, gps: false, interop: false, sanitize: false, reviveValues: true, translateKeys: false, translateValues: false, mergeOutput: false };
var he = Object.assign({}, ae, { firstChunkSize: 4e4, gps: [1, 2, 3, 4] });
var le = Object.assign({}, ae, { tiff: false, ifd1: true, mergeOutput: false });
var de = Object.assign({}, ae, { firstChunkSize: 4e4, ifd0: [274] });
async function ce(e4) {
  let t4 = new H2(de);
  await t4.read(e4);
  let s4 = await t4.parse();
  if (s4 && s4.ifd0)
    return s4.ifd0[274];
}
var pe = Object.freeze({ 1: { dimensionSwapped: false, scaleX: 1, scaleY: 1, deg: 0, rad: 0 }, 2: { dimensionSwapped: false, scaleX: -1, scaleY: 1, deg: 0, rad: 0 }, 3: { dimensionSwapped: false, scaleX: 1, scaleY: 1, deg: 180, rad: 180 * Math.PI / 180 }, 4: { dimensionSwapped: false, scaleX: -1, scaleY: 1, deg: 180, rad: 180 * Math.PI / 180 }, 5: { dimensionSwapped: true, scaleX: 1, scaleY: -1, deg: 90, rad: 90 * Math.PI / 180 }, 6: { dimensionSwapped: true, scaleX: 1, scaleY: 1, deg: 90, rad: 90 * Math.PI / 180 }, 7: { dimensionSwapped: true, scaleX: 1, scaleY: -1, deg: 270, rad: 270 * Math.PI / 180 }, 8: { dimensionSwapped: true, scaleX: 1, scaleY: 1, deg: 270, rad: 270 * Math.PI / 180 } });
var ge = true;
var me = true;
if ("object" == typeof navigator) {
  let e4 = navigator.userAgent;
  if (e4.includes("iPad") || e4.includes("iPhone")) {
    let t4 = e4.match(/OS (\d+)_(\d+)/);
    if (t4) {
      let [, e5, s4] = t4, i4 = Number(e5) + 0.1 * Number(s4);
      ge = i4 < 13.4, me = false;
    }
  } else if (e4.includes("OS X 10")) {
    let [, t4] = e4.match(/OS X 10[_.](\d+)/);
    ge = me = Number(t4) < 15;
  }
  if (e4.includes("Chrome/")) {
    let [, t4] = e4.match(/Chrome\/(\d+)/);
    ge = me = Number(t4) < 81;
  } else if (e4.includes("Firefox/")) {
    let [, t4] = e4.match(/Firefox\/(\d+)/);
    ge = me = Number(t4) < 77;
  }
}
async function ye(e4) {
  let t4 = await ce(e4);
  return Object.assign({ canvas: ge, css: me }, pe[t4]);
}
var be = class extends c22 {
  constructor(...t4) {
    super(...t4), e22(this, "ranges", new we()), 0 !== this.byteLength && this.ranges.add(0, this.byteLength);
  }
  _tryExtend(e4, t4, s4) {
    if (0 === e4 && 0 === this.byteLength && s4) {
      let e5 = new DataView(s4.buffer || s4, s4.byteOffset, s4.byteLength);
      this._swapDataView(e5);
    } else {
      let s5 = e4 + t4;
      if (s5 > this.byteLength) {
        let { dataView: e5 } = this._extend(s5);
        this._swapDataView(e5);
      }
    }
  }
  _extend(e4) {
    let t4;
    t4 = a22 ? r22.allocUnsafe(e4) : new Uint8Array(e4);
    let s4 = new DataView(t4.buffer, t4.byteOffset, t4.byteLength);
    return t4.set(new Uint8Array(this.buffer, this.byteOffset, this.byteLength), 0), { uintView: t4, dataView: s4 };
  }
  subarray(e4, t4, s4 = false) {
    return t4 = t4 || this._lengthToEnd(e4), s4 && this._tryExtend(e4, t4), this.ranges.add(e4, t4), super.subarray(e4, t4);
  }
  set(e4, t4, s4 = false) {
    s4 && this._tryExtend(t4, e4.byteLength, e4);
    let i4 = super.set(e4, t4);
    return this.ranges.add(t4, i4.byteLength), i4;
  }
  async ensureChunk(e4, t4) {
    this.chunked && (this.ranges.available(e4, t4) || await this.readChunk(e4, t4));
  }
  available(e4, t4) {
    return this.ranges.available(e4, t4);
  }
};
var we = class {
  constructor() {
    e22(this, "list", []);
  }
  get length() {
    return this.list.length;
  }
  add(e4, t4, s4 = 0) {
    let i4 = e4 + t4, n3 = this.list.filter((t5) => ke(e4, t5.offset, i4) || ke(e4, t5.end, i4));
    if (n3.length > 0) {
      e4 = Math.min(e4, ...n3.map((e5) => e5.offset)), i4 = Math.max(i4, ...n3.map((e5) => e5.end)), t4 = i4 - e4;
      let s5 = n3.shift();
      s5.offset = e4, s5.length = t4, s5.end = i4, this.list = this.list.filter((e5) => !n3.includes(e5));
    } else
      this.list.push({ offset: e4, length: t4, end: i4 });
  }
  available(e4, t4) {
    let s4 = e4 + t4;
    return this.list.some((t5) => t5.offset <= e4 && s4 <= t5.end);
  }
};
function ke(e4, t4, s4) {
  return e4 <= t4 && t4 <= s4;
}
var Oe = class extends be {
  constructor(t4, s4) {
    super(0), e22(this, "chunksRead", 0), this.input = t4, this.options = s4;
  }
  async readWhole() {
    this.chunked = false, await this.readChunk(this.nextChunkOffset);
  }
  async readChunked() {
    this.chunked = true, await this.readChunk(0, this.options.firstChunkSize);
  }
  async readNextChunk(e4 = this.nextChunkOffset) {
    if (this.fullyRead)
      return this.chunksRead++, false;
    let t4 = this.options.chunkSize, s4 = await this.readChunk(e4, t4);
    return !!s4 && s4.byteLength === t4;
  }
  async readChunk(e4, t4) {
    if (this.chunksRead++, 0 !== (t4 = this.safeWrapAddress(e4, t4)))
      return this._readChunk(e4, t4);
  }
  safeWrapAddress(e4, t4) {
    return void 0 !== this.size && e4 + t4 > this.size ? Math.max(0, this.size - e4) : t4;
  }
  get nextChunkOffset() {
    if (0 !== this.ranges.list.length)
      return this.ranges.list[0].length;
  }
  get canReadNextChunk() {
    return this.chunksRead < this.options.chunkLimit;
  }
  get fullyRead() {
    return void 0 !== this.size && this.nextChunkOffset === this.size;
  }
  read() {
    return this.options.chunked ? this.readChunked() : this.readWhole();
  }
  close() {
  }
};
b22.set("blob", class extends Oe {
  async readWhole() {
    this.chunked = false;
    let e4 = await A22(this.input);
    this._swapArrayBuffer(e4);
  }
  readChunked() {
    return this.chunked = true, this.size = this.input.size, super.readChunked();
  }
  async _readChunk(e4, t4) {
    let s4 = t4 ? e4 + t4 : void 0, i4 = this.input.slice(e4, s4), n3 = await A22(i4);
    return this.set(n3, e4, true);
  }
});
var locale_default42 = {
  strings: {
    generatingThumbnails: "Generating thumbnails..."
  }
};
var packageJson82 = {
  "version": "3.0.8"
};
function canvasToBlob(canvas, type, quality) {
  try {
    canvas.getContext("2d").getImageData(0, 0, 1, 1);
  } catch (err) {
    if (err.code === 18) {
      return Promise.reject(new Error("cannot read image, probably an svg with external resources"));
    }
  }
  if (canvas.toBlob) {
    return new Promise((resolve) => {
      canvas.toBlob(resolve, type, quality);
    }).then((blob) => {
      if (blob === null) {
        throw new Error("cannot read image, probably an svg with external resources");
      }
      return blob;
    });
  }
  return Promise.resolve().then(() => {
    return dataURItoBlob(canvas.toDataURL(type, quality), {});
  }).then((blob) => {
    if (blob === null) {
      throw new Error("could not extract blob, probably an old browser");
    }
    return blob;
  });
}
function rotateImage(image, translate) {
  let w4 = image.width;
  let h102 = image.height;
  if (translate.deg === 90 || translate.deg === 270) {
    w4 = image.height;
    h102 = image.width;
  }
  const canvas = document.createElement("canvas");
  canvas.width = w4;
  canvas.height = h102;
  const context = canvas.getContext("2d");
  context.translate(w4 / 2, h102 / 2);
  if (translate.canvas) {
    context.rotate(translate.rad);
    context.scale(translate.scaleX, translate.scaleY);
  }
  context.drawImage(image, -image.width / 2, -image.height / 2, image.width, image.height);
  return canvas;
}
function protect(image) {
  const ratio = image.width / image.height;
  const maxSquare = 5e6;
  const maxSize = 4096;
  let maxW = Math.floor(Math.sqrt(maxSquare * ratio));
  let maxH = Math.floor(maxSquare / Math.sqrt(maxSquare * ratio));
  if (maxW > maxSize) {
    maxW = maxSize;
    maxH = Math.round(maxW / ratio);
  }
  if (maxH > maxSize) {
    maxH = maxSize;
    maxW = Math.round(ratio * maxH);
  }
  if (image.width > maxW) {
    const canvas = document.createElement("canvas");
    canvas.width = maxW;
    canvas.height = maxH;
    canvas.getContext("2d").drawImage(image, 0, 0, maxW, maxH);
    return canvas;
  }
  return image;
}
var ThumbnailGenerator = class extends UIPlugin_default {
  constructor(uppy22, opts) {
    super(uppy22, opts);
    this.onFileAdded = (file) => {
      if (!file.preview && file.data && isPreviewSupported(file.type) && !file.isRemote) {
        this.addToQueue(file.id);
      }
    };
    this.onCancelRequest = (file) => {
      const index2 = this.queue.indexOf(file.id);
      if (index2 !== -1) {
        this.queue.splice(index2, 1);
      }
    };
    this.onFileRemoved = (file) => {
      const index2 = this.queue.indexOf(file.id);
      if (index2 !== -1) {
        this.queue.splice(index2, 1);
      }
      if (file.preview && isObjectURL(file.preview)) {
        URL.revokeObjectURL(file.preview);
      }
    };
    this.onRestored = () => {
      const restoredFiles = this.uppy.getFiles().filter((file) => file.isRestored);
      restoredFiles.forEach((file) => {
        if (!file.preview || isObjectURL(file.preview)) {
          this.addToQueue(file.id);
        }
      });
    };
    this.onAllFilesRemoved = () => {
      this.queue = [];
    };
    this.waitUntilAllProcessed = (fileIDs) => {
      fileIDs.forEach((fileID) => {
        const file = this.uppy.getFile(fileID);
        this.uppy.emit("preprocess-progress", file, {
          mode: "indeterminate",
          message: this.i18n("generatingThumbnails")
        });
      });
      const emitPreprocessCompleteForAll = () => {
        fileIDs.forEach((fileID) => {
          const file = this.uppy.getFile(fileID);
          this.uppy.emit("preprocess-complete", file);
        });
      };
      return new Promise((resolve) => {
        if (this.queueProcessing) {
          this.uppy.once("thumbnail:all-generated", () => {
            emitPreprocessCompleteForAll();
            resolve();
          });
        } else {
          emitPreprocessCompleteForAll();
          resolve();
        }
      });
    };
    this.type = "modifier";
    this.id = this.opts.id || "ThumbnailGenerator";
    this.title = "Thumbnail Generator";
    this.queue = [];
    this.queueProcessing = false;
    this.defaultThumbnailDimension = 200;
    this.thumbnailType = this.opts.thumbnailType || "image/jpeg";
    this.defaultLocale = locale_default42;
    const defaultOptions8 = {
      thumbnailWidth: null,
      thumbnailHeight: null,
      waitForThumbnailsBeforeUpload: false,
      lazy: false
    };
    this.opts = {
      ...defaultOptions8,
      ...opts
    };
    this.i18nInit();
    if (this.opts.lazy && this.opts.waitForThumbnailsBeforeUpload) {
      throw new Error("ThumbnailGenerator: The `lazy` and `waitForThumbnailsBeforeUpload` options are mutually exclusive. Please ensure at most one of them is set to `true`.");
    }
  }
  /**
   * Create a thumbnail for the given Uppy file object.
   *
   * @param {{data: Blob}} file
   * @param {number} targetWidth
   * @param {number} targetHeight
   * @returns {Promise}
   */
  createThumbnail(file, targetWidth, targetHeight) {
    const originalUrl = URL.createObjectURL(file.data);
    const onload = new Promise((resolve, reject) => {
      const image = new Image();
      image.src = originalUrl;
      image.addEventListener("load", () => {
        URL.revokeObjectURL(originalUrl);
        resolve(image);
      });
      image.addEventListener("error", (event) => {
        URL.revokeObjectURL(originalUrl);
        reject(event.error || new Error("Could not create thumbnail"));
      });
    });
    const orientationPromise = ye(file.data).catch(() => 1);
    return Promise.all([onload, orientationPromise]).then((_ref) => {
      let [image, orientation] = _ref;
      const dimensions = this.getProportionalDimensions(image, targetWidth, targetHeight, orientation.deg);
      const rotatedImage = rotateImage(image, orientation);
      const resizedImage = this.resizeImage(rotatedImage, dimensions.width, dimensions.height);
      return canvasToBlob(resizedImage, this.thumbnailType, 80);
    }).then((blob) => {
      return URL.createObjectURL(blob);
    });
  }
  /**
   * Get the new calculated dimensions for the given image and a target width
   * or height. If both width and height are given, only width is taken into
   * account. If neither width nor height are given, the default dimension
   * is used.
   */
  getProportionalDimensions(img, width, height, rotation) {
    let aspect = img.width / img.height;
    if (rotation === 90 || rotation === 270) {
      aspect = img.height / img.width;
    }
    if (width != null) {
      return {
        width,
        height: Math.round(width / aspect)
      };
    }
    if (height != null) {
      return {
        width: Math.round(height * aspect),
        height
      };
    }
    return {
      width: this.defaultThumbnailDimension,
      height: Math.round(this.defaultThumbnailDimension / aspect)
    };
  }
  /**
   * Resize an image to the target `width` and `height`.
   *
   * Returns a Canvas with the resized image on it.
   */
  // eslint-disable-next-line class-methods-use-this
  resizeImage(image, targetWidth, targetHeight) {
    let img = protect(image);
    let steps2 = Math.ceil(Math.log2(img.width / targetWidth));
    if (steps2 < 1) {
      steps2 = 1;
    }
    let sW = targetWidth * 2 ** (steps2 - 1);
    let sH = targetHeight * 2 ** (steps2 - 1);
    const x4 = 2;
    while (steps2--) {
      const canvas = document.createElement("canvas");
      canvas.width = sW;
      canvas.height = sH;
      canvas.getContext("2d").drawImage(img, 0, 0, sW, sH);
      img = canvas;
      sW = Math.round(sW / x4);
      sH = Math.round(sH / x4);
    }
    return img;
  }
  /**
   * Set the preview URL for a file.
   */
  setPreviewURL(fileID, preview) {
    this.uppy.setFileState(fileID, {
      preview
    });
  }
  addToQueue(item) {
    this.queue.push(item);
    if (this.queueProcessing === false) {
      this.processQueue();
    }
  }
  processQueue() {
    this.queueProcessing = true;
    if (this.queue.length > 0) {
      const current = this.uppy.getFile(this.queue.shift());
      if (!current) {
        this.uppy.log("[ThumbnailGenerator] file was removed before a thumbnail could be generated, but not removed from the queue. This is probably a bug", "error");
        return Promise.resolve();
      }
      return this.requestThumbnail(current).catch(() => {
      }).then(() => this.processQueue());
    }
    this.queueProcessing = false;
    this.uppy.log("[ThumbnailGenerator] Emptied thumbnail queue");
    this.uppy.emit("thumbnail:all-generated");
    return Promise.resolve();
  }
  requestThumbnail(file) {
    if (isPreviewSupported(file.type) && !file.isRemote) {
      return this.createThumbnail(file, this.opts.thumbnailWidth, this.opts.thumbnailHeight).then((preview) => {
        this.setPreviewURL(file.id, preview);
        this.uppy.log(`[ThumbnailGenerator] Generated thumbnail for ${file.id}`);
        this.uppy.emit("thumbnail:generated", this.uppy.getFile(file.id), preview);
      }).catch((err) => {
        this.uppy.log(`[ThumbnailGenerator] Failed thumbnail for ${file.id}:`, "warning");
        this.uppy.log(err, "warning");
        this.uppy.emit("thumbnail:error", this.uppy.getFile(file.id), err);
      });
    }
    return Promise.resolve();
  }
  install() {
    this.uppy.on("file-removed", this.onFileRemoved);
    this.uppy.on("cancel-all", this.onAllFilesRemoved);
    if (this.opts.lazy) {
      this.uppy.on("thumbnail:request", this.onFileAdded);
      this.uppy.on("thumbnail:cancel", this.onCancelRequest);
    } else {
      this.uppy.on("thumbnail:request", this.onFileAdded);
      this.uppy.on("file-added", this.onFileAdded);
      this.uppy.on("restored", this.onRestored);
    }
    if (this.opts.waitForThumbnailsBeforeUpload) {
      this.uppy.addPreProcessor(this.waitUntilAllProcessed);
    }
  }
  uninstall() {
    this.uppy.off("file-removed", this.onFileRemoved);
    this.uppy.off("cancel-all", this.onAllFilesRemoved);
    if (this.opts.lazy) {
      this.uppy.off("thumbnail:request", this.onFileAdded);
      this.uppy.off("thumbnail:cancel", this.onCancelRequest);
    } else {
      this.uppy.off("thumbnail:request", this.onFileAdded);
      this.uppy.off("file-added", this.onFileAdded);
      this.uppy.off("restored", this.onRestored);
    }
    if (this.opts.waitForThumbnailsBeforeUpload) {
      this.uppy.removePreProcessor(this.waitUntilAllProcessed);
    }
  }
};
ThumbnailGenerator.VERSION = packageJson82.version;
function findAllDOMElements(element) {
  if (typeof element === "string") {
    const elements = document.querySelectorAll(element);
    return elements.length === 0 ? null : Array.from(elements);
  }
  if (typeof element === "object" && isDOMElement(element)) {
    return [element];
  }
  return null;
}
var toArray_default2 = Array.from;
function getFilesAndDirectoriesFromDirectory2(directoryReader, oldEntries, logDropError, _ref) {
  let {
    onSuccess
  } = _ref;
  directoryReader.readEntries(
    (entries) => {
      const newEntries = [...oldEntries, ...entries];
      if (entries.length) {
        queueMicrotask(() => {
          getFilesAndDirectoriesFromDirectory2(directoryReader, newEntries, logDropError, {
            onSuccess
          });
        });
      } else {
        onSuccess(newEntries);
      }
    },
    // Make sure we resolve on error anyway, it's fine if only one directory couldn't be parsed!
    (error) => {
      logDropError(error);
      onSuccess(oldEntries);
    }
  );
}
function getAsFileSystemHandleFromEntry2(entry, logDropError) {
  if (entry == null)
    return entry;
  return {
    kind: (
      // eslint-disable-next-line no-nested-ternary
      entry.isFile ? "file" : entry.isDirectory ? "directory" : void 0
    ),
    name: entry.name,
    getFile() {
      return new Promise((resolve, reject) => entry.file(resolve, reject));
    },
    async *values() {
      const directoryReader = entry.createReader();
      const entries = await new Promise((resolve) => {
        getFilesAndDirectoriesFromDirectory2(directoryReader, [], logDropError, {
          onSuccess: (dirEntries) => resolve(dirEntries.map((file) => getAsFileSystemHandleFromEntry2(file, logDropError)))
        });
      });
      yield* entries;
    },
    isSameEntry: void 0
  };
}
function createPromiseToAddFileOrParseDirectory2(entry, relativePath, lastResortFile) {
  try {
    if (lastResortFile === void 0) {
      lastResortFile = void 0;
    }
    return async function* () {
      const getNextRelativePath = () => `${relativePath}/${entry.name}`;
      if (entry.kind === "file") {
        const file = await entry.getFile();
        if (file != null) {
          ;
          file.relativePath = relativePath ? getNextRelativePath() : null;
          yield file;
        } else if (lastResortFile != null)
          yield lastResortFile;
      } else if (entry.kind === "directory") {
        for await (const handle of entry.values()) {
          yield* createPromiseToAddFileOrParseDirectory2(handle, relativePath ? getNextRelativePath() : entry.name);
        }
      } else if (lastResortFile != null)
        yield lastResortFile;
    }();
  } catch (e4) {
    return Promise.reject(e4);
  }
}
async function* getFilesFromDataTransfer2(dataTransfer, logDropError) {
  const fileSystemHandles = await Promise.all(Array.from(dataTransfer.items, async (item) => {
    var _fileSystemHandle;
    let fileSystemHandle;
    const getAsEntry = () => typeof item.getAsEntry === "function" ? item.getAsEntry() : item.webkitGetAsEntry();
    (_fileSystemHandle = fileSystemHandle) != null ? _fileSystemHandle : fileSystemHandle = getAsFileSystemHandleFromEntry2(getAsEntry(), logDropError);
    return {
      fileSystemHandle,
      lastResortFile: item.getAsFile()
      // can be used as a fallback in case other methods fail
    };
  }));
  for (const {
    lastResortFile,
    fileSystemHandle
  } of fileSystemHandles) {
    if (fileSystemHandle != null) {
      try {
        yield* createPromiseToAddFileOrParseDirectory2(fileSystemHandle, "", lastResortFile);
      } catch (err) {
        if (lastResortFile != null) {
          yield lastResortFile;
        } else {
          logDropError(err);
        }
      }
    } else if (lastResortFile != null)
      yield lastResortFile;
  }
}
function fallbackApi2(dataTransfer) {
  const files = toArray_default2(dataTransfer.files);
  return Promise.resolve(files);
}
async function getDroppedFiles2(dataTransfer, options7) {
  var _options$logDropError;
  const logDropError = (_options$logDropError = options7 == null ? void 0 : options7.logDropError) != null ? _options$logDropError : Function.prototype;
  try {
    const accumulator = [];
    for await (const file of getFilesFromDataTransfer2(dataTransfer, logDropError)) {
      accumulator.push(file);
    }
    return accumulator;
  } catch {
    return fallbackApi2(dataTransfer);
  }
}
var import_index4 = __toESM2(require_eventemitter3(), 1);
var TimeoutError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "TimeoutError";
  }
};
var AbortError22 = class extends Error {
  constructor(message) {
    super();
    this.name = "AbortError";
    this.message = message;
  }
};
var getDOMException = (errorMessage) => globalThis.DOMException === void 0 ? new AbortError22(errorMessage) : new DOMException(errorMessage);
var getAbortedReason = (signal) => {
  const reason = signal.reason === void 0 ? getDOMException("This operation was aborted.") : signal.reason;
  return reason instanceof Error ? reason : getDOMException(reason);
};
function pTimeout(promise, milliseconds, fallback, options7) {
  let timer;
  const cancelablePromise = new Promise((resolve, reject) => {
    if (typeof milliseconds !== "number" || Math.sign(milliseconds) !== 1) {
      throw new TypeError(`Expected \`milliseconds\` to be a positive number, got \`${milliseconds}\``);
    }
    if (milliseconds === Number.POSITIVE_INFINITY) {
      resolve(promise);
      return;
    }
    options7 = {
      customTimers: { setTimeout, clearTimeout },
      ...options7
    };
    if (options7.signal) {
      const { signal } = options7;
      if (signal.aborted) {
        reject(getAbortedReason(signal));
      }
      signal.addEventListener("abort", () => {
        reject(getAbortedReason(signal));
      });
    }
    timer = options7.customTimers.setTimeout.call(void 0, () => {
      if (typeof fallback === "function") {
        try {
          resolve(fallback());
        } catch (error) {
          reject(error);
        }
        return;
      }
      const message = typeof fallback === "string" ? fallback : `Promise timed out after ${milliseconds} milliseconds`;
      const timeoutError = fallback instanceof Error ? fallback : new TimeoutError(message);
      if (typeof promise.cancel === "function") {
        promise.cancel();
      }
      reject(timeoutError);
    }, milliseconds);
    (async () => {
      try {
        resolve(await promise);
      } catch (error) {
        reject(error);
      } finally {
        options7.customTimers.clearTimeout.call(void 0, timer);
      }
    })();
  });
  cancelablePromise.clear = () => {
    clearTimeout(timer);
    timer = void 0;
  };
  return cancelablePromise;
}
function lowerBound(array2, value, comparator) {
  let first = 0;
  let count = array2.length;
  while (count > 0) {
    const step = Math.trunc(count / 2);
    let it = first + step;
    if (comparator(array2[it], value) <= 0) {
      first = ++it;
      count -= step + 1;
    } else {
      count = step;
    }
  }
  return first;
}
var __classPrivateFieldGet = function(receiver, state, kind, f4) {
  if (kind === "a" && !f4)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f4 : !state.has(receiver))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f4 : kind === "a" ? f4.call(receiver) : f4 ? f4.value : state.get(receiver);
};
var _PriorityQueue_queue;
var PriorityQueue = class {
  constructor() {
    _PriorityQueue_queue.set(this, []);
  }
  enqueue(run, options7) {
    options7 = {
      priority: 0,
      ...options7
    };
    const element = {
      priority: options7.priority,
      run
    };
    if (this.size && __classPrivateFieldGet(this, _PriorityQueue_queue, "f")[this.size - 1].priority >= options7.priority) {
      __classPrivateFieldGet(this, _PriorityQueue_queue, "f").push(element);
      return;
    }
    const index2 = lowerBound(__classPrivateFieldGet(this, _PriorityQueue_queue, "f"), element, (a4, b3) => b3.priority - a4.priority);
    __classPrivateFieldGet(this, _PriorityQueue_queue, "f").splice(index2, 0, element);
  }
  dequeue() {
    const item = __classPrivateFieldGet(this, _PriorityQueue_queue, "f").shift();
    return item === null || item === void 0 ? void 0 : item.run;
  }
  filter(options7) {
    return __classPrivateFieldGet(this, _PriorityQueue_queue, "f").filter((element) => element.priority === options7.priority).map((element) => element.run);
  }
  get size() {
    return __classPrivateFieldGet(this, _PriorityQueue_queue, "f").length;
  }
};
_PriorityQueue_queue = /* @__PURE__ */ new WeakMap();
var priority_queue_default = PriorityQueue;
var __classPrivateFieldSet = function(receiver, state, value, kind, f4) {
  if (kind === "m")
    throw new TypeError("Private method is not writable");
  if (kind === "a" && !f4)
    throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f4 : !state.has(receiver))
    throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return kind === "a" ? f4.call(receiver, value) : f4 ? f4.value = value : state.set(receiver, value), value;
};
var __classPrivateFieldGet2 = function(receiver, state, kind, f4) {
  if (kind === "a" && !f4)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f4 : !state.has(receiver))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f4 : kind === "a" ? f4.call(receiver) : f4 ? f4.value : state.get(receiver);
};
var _PQueue_instances;
var _PQueue_carryoverConcurrencyCount;
var _PQueue_isIntervalIgnored;
var _PQueue_intervalCount;
var _PQueue_intervalCap;
var _PQueue_interval;
var _PQueue_intervalEnd;
var _PQueue_intervalId;
var _PQueue_timeoutId;
var _PQueue_queue;
var _PQueue_queueClass;
var _PQueue_pending;
var _PQueue_concurrency;
var _PQueue_isPaused;
var _PQueue_throwOnTimeout;
var _PQueue_doesIntervalAllowAnother_get;
var _PQueue_doesConcurrentAllowAnother_get;
var _PQueue_next;
var _PQueue_onResumeInterval;
var _PQueue_isIntervalPaused_get;
var _PQueue_tryToStartAnother;
var _PQueue_initializeIntervalIfNeeded;
var _PQueue_onInterval;
var _PQueue_processQueue;
var _PQueue_throwOnAbort;
var _PQueue_onEvent;
var AbortError3 = class extends Error {
};
var PQueue = class extends import_index4.default {
  // TODO: The `throwOnTimeout` option should affect the return types of `add()` and `addAll()`
  constructor(options7) {
    var _a, _b, _c2, _d;
    super();
    _PQueue_instances.add(this);
    _PQueue_carryoverConcurrencyCount.set(this, void 0);
    _PQueue_isIntervalIgnored.set(this, void 0);
    _PQueue_intervalCount.set(this, 0);
    _PQueue_intervalCap.set(this, void 0);
    _PQueue_interval.set(this, void 0);
    _PQueue_intervalEnd.set(this, 0);
    _PQueue_intervalId.set(this, void 0);
    _PQueue_timeoutId.set(this, void 0);
    _PQueue_queue.set(this, void 0);
    _PQueue_queueClass.set(this, void 0);
    _PQueue_pending.set(this, 0);
    _PQueue_concurrency.set(this, void 0);
    _PQueue_isPaused.set(this, void 0);
    _PQueue_throwOnTimeout.set(this, void 0);
    Object.defineProperty(this, "timeout", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    options7 = {
      carryoverConcurrencyCount: false,
      intervalCap: Number.POSITIVE_INFINITY,
      interval: 0,
      concurrency: Number.POSITIVE_INFINITY,
      autoStart: true,
      queueClass: priority_queue_default,
      ...options7
    };
    if (!(typeof options7.intervalCap === "number" && options7.intervalCap >= 1)) {
      throw new TypeError(`Expected \`intervalCap\` to be a number from 1 and up, got \`${(_b = (_a = options7.intervalCap) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : ""}\` (${typeof options7.intervalCap})`);
    }
    if (options7.interval === void 0 || !(Number.isFinite(options7.interval) && options7.interval >= 0)) {
      throw new TypeError(`Expected \`interval\` to be a finite number >= 0, got \`${(_d = (_c2 = options7.interval) === null || _c2 === void 0 ? void 0 : _c2.toString()) !== null && _d !== void 0 ? _d : ""}\` (${typeof options7.interval})`);
    }
    __classPrivateFieldSet(this, _PQueue_carryoverConcurrencyCount, options7.carryoverConcurrencyCount, "f");
    __classPrivateFieldSet(this, _PQueue_isIntervalIgnored, options7.intervalCap === Number.POSITIVE_INFINITY || options7.interval === 0, "f");
    __classPrivateFieldSet(this, _PQueue_intervalCap, options7.intervalCap, "f");
    __classPrivateFieldSet(this, _PQueue_interval, options7.interval, "f");
    __classPrivateFieldSet(this, _PQueue_queue, new options7.queueClass(), "f");
    __classPrivateFieldSet(this, _PQueue_queueClass, options7.queueClass, "f");
    this.concurrency = options7.concurrency;
    this.timeout = options7.timeout;
    __classPrivateFieldSet(this, _PQueue_throwOnTimeout, options7.throwOnTimeout === true, "f");
    __classPrivateFieldSet(this, _PQueue_isPaused, options7.autoStart === false, "f");
  }
  get concurrency() {
    return __classPrivateFieldGet2(this, _PQueue_concurrency, "f");
  }
  set concurrency(newConcurrency) {
    if (!(typeof newConcurrency === "number" && newConcurrency >= 1)) {
      throw new TypeError(`Expected \`concurrency\` to be a number from 1 and up, got \`${newConcurrency}\` (${typeof newConcurrency})`);
    }
    __classPrivateFieldSet(this, _PQueue_concurrency, newConcurrency, "f");
    __classPrivateFieldGet2(this, _PQueue_instances, "m", _PQueue_processQueue).call(this);
  }
  async add(function_, options7 = {}) {
    options7 = {
      timeout: this.timeout,
      throwOnTimeout: __classPrivateFieldGet2(this, _PQueue_throwOnTimeout, "f"),
      ...options7
    };
    return new Promise((resolve, reject) => {
      __classPrivateFieldGet2(this, _PQueue_queue, "f").enqueue(async () => {
        var _a;
        var _b, _c2;
        __classPrivateFieldSet(this, _PQueue_pending, (_b = __classPrivateFieldGet2(this, _PQueue_pending, "f"), _b++, _b), "f");
        __classPrivateFieldSet(this, _PQueue_intervalCount, (_c2 = __classPrivateFieldGet2(this, _PQueue_intervalCount, "f"), _c2++, _c2), "f");
        try {
          if ((_a = options7.signal) === null || _a === void 0 ? void 0 : _a.aborted) {
            throw new AbortError3("The task was aborted.");
          }
          let operation = function_({ signal: options7.signal });
          if (options7.timeout) {
            operation = pTimeout(Promise.resolve(operation), options7.timeout);
          }
          if (options7.signal) {
            operation = Promise.race([operation, __classPrivateFieldGet2(this, _PQueue_instances, "m", _PQueue_throwOnAbort).call(this, options7.signal)]);
          }
          const result = await operation;
          resolve(result);
          this.emit("completed", result);
        } catch (error) {
          if (error instanceof TimeoutError && !options7.throwOnTimeout) {
            resolve();
            return;
          }
          reject(error);
          this.emit("error", error);
        } finally {
          __classPrivateFieldGet2(this, _PQueue_instances, "m", _PQueue_next).call(this);
        }
      }, options7);
      this.emit("add");
      __classPrivateFieldGet2(this, _PQueue_instances, "m", _PQueue_tryToStartAnother).call(this);
    });
  }
  async addAll(functions, options7) {
    return Promise.all(functions.map(async (function_) => this.add(function_, options7)));
  }
  /**
  Start (or resume) executing enqueued tasks within concurrency limit. No need to call this if queue is not paused (via `options.autoStart = false` or by `.pause()` method.)
  */
  start() {
    if (!__classPrivateFieldGet2(this, _PQueue_isPaused, "f")) {
      return this;
    }
    __classPrivateFieldSet(this, _PQueue_isPaused, false, "f");
    __classPrivateFieldGet2(this, _PQueue_instances, "m", _PQueue_processQueue).call(this);
    return this;
  }
  /**
  Put queue execution on hold.
  */
  pause() {
    __classPrivateFieldSet(this, _PQueue_isPaused, true, "f");
  }
  /**
  Clear the queue.
  */
  clear() {
    __classPrivateFieldSet(this, _PQueue_queue, new (__classPrivateFieldGet2(this, _PQueue_queueClass, "f"))(), "f");
  }
  /**
      Can be called multiple times. Useful if you for example add additional items at a later time.
  
      @returns A promise that settles when the queue becomes empty.
      */
  async onEmpty() {
    if (__classPrivateFieldGet2(this, _PQueue_queue, "f").size === 0) {
      return;
    }
    await __classPrivateFieldGet2(this, _PQueue_instances, "m", _PQueue_onEvent).call(this, "empty");
  }
  /**
      @returns A promise that settles when the queue size is less than the given limit: `queue.size < limit`.
  
      If you want to avoid having the queue grow beyond a certain size you can `await queue.onSizeLessThan()` before adding a new item.
  
      Note that this only limits the number of items waiting to start. There could still be up to `concurrency` jobs already running that this call does not include in its calculation.
      */
  async onSizeLessThan(limit) {
    if (__classPrivateFieldGet2(this, _PQueue_queue, "f").size < limit) {
      return;
    }
    await __classPrivateFieldGet2(this, _PQueue_instances, "m", _PQueue_onEvent).call(this, "next", () => __classPrivateFieldGet2(this, _PQueue_queue, "f").size < limit);
  }
  /**
      The difference with `.onEmpty` is that `.onIdle` guarantees that all work from the queue has finished. `.onEmpty` merely signals that the queue is empty, but it could mean that some promises haven't completed yet.
  
      @returns A promise that settles when the queue becomes empty, and all promises have completed; `queue.size === 0 && queue.pending === 0`.
      */
  async onIdle() {
    if (__classPrivateFieldGet2(this, _PQueue_pending, "f") === 0 && __classPrivateFieldGet2(this, _PQueue_queue, "f").size === 0) {
      return;
    }
    await __classPrivateFieldGet2(this, _PQueue_instances, "m", _PQueue_onEvent).call(this, "idle");
  }
  /**
  Size of the queue, the number of queued items waiting to run.
  */
  get size() {
    return __classPrivateFieldGet2(this, _PQueue_queue, "f").size;
  }
  /**
      Size of the queue, filtered by the given options.
  
      For example, this can be used to find the number of items remaining in the queue with a specific priority level.
      */
  sizeBy(options7) {
    return __classPrivateFieldGet2(this, _PQueue_queue, "f").filter(options7).length;
  }
  /**
  Number of running items (no longer in the queue).
  */
  get pending() {
    return __classPrivateFieldGet2(this, _PQueue_pending, "f");
  }
  /**
  Whether the queue is currently paused.
  */
  get isPaused() {
    return __classPrivateFieldGet2(this, _PQueue_isPaused, "f");
  }
};
_PQueue_carryoverConcurrencyCount = /* @__PURE__ */ new WeakMap(), _PQueue_isIntervalIgnored = /* @__PURE__ */ new WeakMap(), _PQueue_intervalCount = /* @__PURE__ */ new WeakMap(), _PQueue_intervalCap = /* @__PURE__ */ new WeakMap(), _PQueue_interval = /* @__PURE__ */ new WeakMap(), _PQueue_intervalEnd = /* @__PURE__ */ new WeakMap(), _PQueue_intervalId = /* @__PURE__ */ new WeakMap(), _PQueue_timeoutId = /* @__PURE__ */ new WeakMap(), _PQueue_queue = /* @__PURE__ */ new WeakMap(), _PQueue_queueClass = /* @__PURE__ */ new WeakMap(), _PQueue_pending = /* @__PURE__ */ new WeakMap(), _PQueue_concurrency = /* @__PURE__ */ new WeakMap(), _PQueue_isPaused = /* @__PURE__ */ new WeakMap(), _PQueue_throwOnTimeout = /* @__PURE__ */ new WeakMap(), _PQueue_instances = /* @__PURE__ */ new WeakSet(), _PQueue_doesIntervalAllowAnother_get = function _PQueue_doesIntervalAllowAnother_get2() {
  return __classPrivateFieldGet2(this, _PQueue_isIntervalIgnored, "f") || __classPrivateFieldGet2(this, _PQueue_intervalCount, "f") < __classPrivateFieldGet2(this, _PQueue_intervalCap, "f");
}, _PQueue_doesConcurrentAllowAnother_get = function _PQueue_doesConcurrentAllowAnother_get2() {
  return __classPrivateFieldGet2(this, _PQueue_pending, "f") < __classPrivateFieldGet2(this, _PQueue_concurrency, "f");
}, _PQueue_next = function _PQueue_next2() {
  var _a;
  __classPrivateFieldSet(this, _PQueue_pending, (_a = __classPrivateFieldGet2(this, _PQueue_pending, "f"), _a--, _a), "f");
  __classPrivateFieldGet2(this, _PQueue_instances, "m", _PQueue_tryToStartAnother).call(this);
  this.emit("next");
}, _PQueue_onResumeInterval = function _PQueue_onResumeInterval2() {
  __classPrivateFieldGet2(this, _PQueue_instances, "m", _PQueue_onInterval).call(this);
  __classPrivateFieldGet2(this, _PQueue_instances, "m", _PQueue_initializeIntervalIfNeeded).call(this);
  __classPrivateFieldSet(this, _PQueue_timeoutId, void 0, "f");
}, _PQueue_isIntervalPaused_get = function _PQueue_isIntervalPaused_get2() {
  const now2 = Date.now();
  if (__classPrivateFieldGet2(this, _PQueue_intervalId, "f") === void 0) {
    const delay2 = __classPrivateFieldGet2(this, _PQueue_intervalEnd, "f") - now2;
    if (delay2 < 0) {
      __classPrivateFieldSet(this, _PQueue_intervalCount, __classPrivateFieldGet2(this, _PQueue_carryoverConcurrencyCount, "f") ? __classPrivateFieldGet2(this, _PQueue_pending, "f") : 0, "f");
    } else {
      if (__classPrivateFieldGet2(this, _PQueue_timeoutId, "f") === void 0) {
        __classPrivateFieldSet(this, _PQueue_timeoutId, setTimeout(() => {
          __classPrivateFieldGet2(this, _PQueue_instances, "m", _PQueue_onResumeInterval).call(this);
        }, delay2), "f");
      }
      return true;
    }
  }
  return false;
}, _PQueue_tryToStartAnother = function _PQueue_tryToStartAnother2() {
  if (__classPrivateFieldGet2(this, _PQueue_queue, "f").size === 0) {
    if (__classPrivateFieldGet2(this, _PQueue_intervalId, "f")) {
      clearInterval(__classPrivateFieldGet2(this, _PQueue_intervalId, "f"));
    }
    __classPrivateFieldSet(this, _PQueue_intervalId, void 0, "f");
    this.emit("empty");
    if (__classPrivateFieldGet2(this, _PQueue_pending, "f") === 0) {
      this.emit("idle");
    }
    return false;
  }
  if (!__classPrivateFieldGet2(this, _PQueue_isPaused, "f")) {
    const canInitializeInterval = !__classPrivateFieldGet2(this, _PQueue_instances, "a", _PQueue_isIntervalPaused_get);
    if (__classPrivateFieldGet2(this, _PQueue_instances, "a", _PQueue_doesIntervalAllowAnother_get) && __classPrivateFieldGet2(this, _PQueue_instances, "a", _PQueue_doesConcurrentAllowAnother_get)) {
      const job = __classPrivateFieldGet2(this, _PQueue_queue, "f").dequeue();
      if (!job) {
        return false;
      }
      this.emit("active");
      job();
      if (canInitializeInterval) {
        __classPrivateFieldGet2(this, _PQueue_instances, "m", _PQueue_initializeIntervalIfNeeded).call(this);
      }
      return true;
    }
  }
  return false;
}, _PQueue_initializeIntervalIfNeeded = function _PQueue_initializeIntervalIfNeeded2() {
  if (__classPrivateFieldGet2(this, _PQueue_isIntervalIgnored, "f") || __classPrivateFieldGet2(this, _PQueue_intervalId, "f") !== void 0) {
    return;
  }
  __classPrivateFieldSet(this, _PQueue_intervalId, setInterval(() => {
    __classPrivateFieldGet2(this, _PQueue_instances, "m", _PQueue_onInterval).call(this);
  }, __classPrivateFieldGet2(this, _PQueue_interval, "f")), "f");
  __classPrivateFieldSet(this, _PQueue_intervalEnd, Date.now() + __classPrivateFieldGet2(this, _PQueue_interval, "f"), "f");
}, _PQueue_onInterval = function _PQueue_onInterval2() {
  if (__classPrivateFieldGet2(this, _PQueue_intervalCount, "f") === 0 && __classPrivateFieldGet2(this, _PQueue_pending, "f") === 0 && __classPrivateFieldGet2(this, _PQueue_intervalId, "f")) {
    clearInterval(__classPrivateFieldGet2(this, _PQueue_intervalId, "f"));
    __classPrivateFieldSet(this, _PQueue_intervalId, void 0, "f");
  }
  __classPrivateFieldSet(this, _PQueue_intervalCount, __classPrivateFieldGet2(this, _PQueue_carryoverConcurrencyCount, "f") ? __classPrivateFieldGet2(this, _PQueue_pending, "f") : 0, "f");
  __classPrivateFieldGet2(this, _PQueue_instances, "m", _PQueue_processQueue).call(this);
}, _PQueue_processQueue = function _PQueue_processQueue2() {
  while (__classPrivateFieldGet2(this, _PQueue_instances, "m", _PQueue_tryToStartAnother).call(this)) {
  }
}, _PQueue_throwOnAbort = async function _PQueue_throwOnAbort2(signal) {
  return new Promise((_resolve, reject) => {
    signal.addEventListener("abort", () => {
      reject(new AbortError3("The task was aborted."));
    }, { once: true });
  });
}, _PQueue_onEvent = async function _PQueue_onEvent2(event, filter2) {
  return new Promise((resolve) => {
    const listener = () => {
      if (filter2 && !filter2()) {
        return;
      }
      this.off(event, listener);
      resolve();
    };
    this.on(event, listener);
  });
};
var dist_default = PQueue;
var t3;
var r3;
var u3;
var i3;
var o3 = 0;
var f3 = [];
var c3 = [];
var e3 = l2;
var a3 = e3.__b;
var v3 = e3.__r;
var l3 = e3.diffed;
var m3 = e3.__c;
var s3 = e3.unmount;
var d3 = e3.__;
function h32(n3, t4) {
  e3.__h && e3.__h(r3, n3, o3 || t4), o3 = 0;
  var u4 = r3.__H || (r3.__H = { __: [], __h: [] });
  return n3 >= u4.__.length && u4.__.push({ __V: c3 }), u4.__[n3];
}
function p3(n3) {
  return o3 = 1, y3(D3, n3);
}
function y3(n3, u4, i4) {
  var o4 = h32(t3++, 2);
  if (o4.t = n3, !o4.__c && (o4.__ = [i4 ? i4(u4) : D3(void 0, u4), function(n4) {
    var t4 = o4.__N ? o4.__N[0] : o4.__[0], r4 = o4.t(t4, n4);
    t4 !== r4 && (o4.__N = [r4, o4.__[1]], o4.__c.setState({}));
  }], o4.__c = r3, !r3.u)) {
    var f4 = function(n4, t4, r4) {
      if (!o4.__c.__H)
        return true;
      var u5 = o4.__c.__H.__.filter(function(n5) {
        return !!n5.__c;
      });
      if (u5.every(function(n5) {
        return !n5.__N;
      }))
        return !c4 || c4.call(this, n4, t4, r4);
      var i5 = false;
      return u5.forEach(function(n5) {
        if (n5.__N) {
          var t5 = n5.__[0];
          n5.__ = n5.__N, n5.__N = void 0, t5 !== n5.__[0] && (i5 = true);
        }
      }), !(!i5 && o4.__c.props === n4) && (!c4 || c4.call(this, n4, t4, r4));
    };
    r3.u = true;
    var c4 = r3.shouldComponentUpdate, e4 = r3.componentWillUpdate;
    r3.componentWillUpdate = function(n4, t4, r4) {
      if (this.__e) {
        var u5 = c4;
        c4 = void 0, f4(n4, t4, r4), c4 = u5;
      }
      e4 && e4.call(this, n4, t4, r4);
    }, r3.shouldComponentUpdate = f4;
  }
  return o4.__N || o4.__;
}
function _3(n3, u4) {
  var i4 = h32(t3++, 3);
  !e3.__s && C3(i4.__H, u4) && (i4.__ = n3, i4.i = u4, r3.__H.__h.push(i4));
}
function q3(n3, r4) {
  var u4 = h32(t3++, 7);
  return C3(u4.__H, r4) ? (u4.__V = n3(), u4.i = r4, u4.__h = n3, u4.__V) : u4.__;
}
function x3(n3, t4) {
  return o3 = 8, q3(function() {
    return n3;
  }, t4);
}
function j3() {
  for (var n3; n3 = f3.shift(); )
    if (n3.__P && n3.__H)
      try {
        n3.__H.__h.forEach(z32), n3.__H.__h.forEach(B3), n3.__H.__h = [];
      } catch (t4) {
        n3.__H.__h = [], e3.__e(t4, n3.__v);
      }
}
e3.__b = function(n3) {
  r3 = null, a3 && a3(n3);
}, e3.__ = function(n3, t4) {
  n3 && t4.__k && t4.__k.__m && (n3.__m = t4.__k.__m), d3 && d3(n3, t4);
}, e3.__r = function(n3) {
  v3 && v3(n3), t3 = 0;
  var i4 = (r3 = n3.__c).__H;
  i4 && (u3 === r3 ? (i4.__h = [], r3.__h = [], i4.__.forEach(function(n4) {
    n4.__N && (n4.__ = n4.__N), n4.__V = c3, n4.__N = n4.i = void 0;
  })) : (i4.__h.forEach(z32), i4.__h.forEach(B3), i4.__h = [], t3 = 0)), u3 = r3;
}, e3.diffed = function(n3) {
  l3 && l3(n3);
  var t4 = n3.__c;
  t4 && t4.__H && (t4.__H.__h.length && (1 !== f3.push(t4) && i3 === e3.requestAnimationFrame || ((i3 = e3.requestAnimationFrame) || w3)(j3)), t4.__H.__.forEach(function(n4) {
    n4.i && (n4.__H = n4.i), n4.__V !== c3 && (n4.__ = n4.__V), n4.i = void 0, n4.__V = c3;
  })), u3 = r3 = null;
}, e3.__c = function(n3, t4) {
  t4.some(function(n4) {
    try {
      n4.__h.forEach(z32), n4.__h = n4.__h.filter(function(n5) {
        return !n5.__ || B3(n5);
      });
    } catch (r4) {
      t4.some(function(n5) {
        n5.__h && (n5.__h = []);
      }), t4 = [], e3.__e(r4, n4.__v);
    }
  }), m3 && m3(n3, t4);
}, e3.unmount = function(n3) {
  s3 && s3(n3);
  var t4, r4 = n3.__c;
  r4 && r4.__H && (r4.__H.__.forEach(function(n4) {
    try {
      z32(n4);
    } catch (n5) {
      t4 = n5;
    }
  }), r4.__H = void 0, t4 && e3.__e(t4, r4.__v));
};
var k3 = "function" == typeof requestAnimationFrame;
function w3(n3) {
  var t4, r4 = function() {
    clearTimeout(u4), k3 && cancelAnimationFrame(t4), setTimeout(n3);
  }, u4 = setTimeout(r4, 100);
  k3 && (t4 = requestAnimationFrame(r4));
}
function z32(n3) {
  var t4 = r3, u4 = n3.__c;
  "function" == typeof u4 && (n3.__c = void 0, u4()), r3 = t4;
}
function B3(n3) {
  var t4 = r3;
  n3.__c = n3.__(), r3 = t4;
}
function C3(n3, t4) {
  return !n3 || n3.length !== t4.length || t4.some(function(t5, r4) {
    return t5 !== n3[r4];
  });
}
function D3(n3, t4) {
  return "function" == typeof t4 ? t4(n3) : t4;
}
function GoogleIcon() {
  return y2("svg", {
    width: "26",
    height: "26",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg"
  }, y2("g", {
    fill: "none",
    "fill-rule": "evenodd"
  }, y2("circle", {
    fill: "#FFF",
    cx: "13",
    cy: "13",
    r: "13"
  }), y2("path", {
    d: "M21.64 13.205c0-.639-.057-1.252-.164-1.841H13v3.481h4.844a4.14 4.14 0 01-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z",
    fill: "#4285F4",
    "fill-rule": "nonzero"
  }), y2("path", {
    d: "M13 22c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H4.957v2.332A8.997 8.997 0 0013 22z",
    fill: "#34A853",
    "fill-rule": "nonzero"
  }), y2("path", {
    d: "M7.964 14.71A5.41 5.41 0 017.682 13c0-.593.102-1.17.282-1.71V8.958H4.957A8.996 8.996 0 004 13c0 1.452.348 2.827.957 4.042l3.007-2.332z",
    fill: "#FBBC05",
    "fill-rule": "nonzero"
  }), y2("path", {
    d: "M13 7.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C17.463 4.891 15.426 4 13 4a8.997 8.997 0 00-8.043 4.958l3.007 2.332C8.672 9.163 10.656 7.58 13 7.58z",
    fill: "#EA4335",
    "fill-rule": "nonzero"
  }), y2("path", {
    d: "M4 4h18v18H4z"
  })));
}
function DefaultForm(_ref) {
  let {
    pluginName,
    i18n,
    onAuth
  } = _ref;
  const isGoogleDrive = pluginName === "Google Drive";
  const onSubmit = x3((e4) => {
    e4.preventDefault();
    onAuth();
  }, [onAuth]);
  return y2("form", {
    onSubmit
  }, isGoogleDrive ? y2("button", {
    type: "submit",
    className: "uppy-u-reset uppy-c-btn uppy-c-btn-primary uppy-Provider-authBtn uppy-Provider-btn-google",
    "data-uppy-super-focusable": true
  }, y2(GoogleIcon, null), i18n("signInWithGoogle")) : y2("button", {
    type: "submit",
    className: "uppy-u-reset uppy-c-btn uppy-c-btn-primary uppy-Provider-authBtn",
    "data-uppy-super-focusable": true
  }, i18n("authenticateWith", {
    pluginName
  })));
}
var defaultRenderForm = (_ref2) => {
  let {
    pluginName,
    i18n,
    onAuth
  } = _ref2;
  return y2(DefaultForm, {
    pluginName,
    i18n,
    onAuth
  });
};
function AuthView(props) {
  const {
    loading,
    pluginName,
    pluginIcon,
    i18n,
    handleAuth,
    renderForm = defaultRenderForm
  } = props;
  return y2("div", {
    className: "uppy-Provider-auth"
  }, y2("div", {
    className: "uppy-Provider-authIcon"
  }, pluginIcon()), y2("div", {
    className: "uppy-Provider-authTitle"
  }, i18n("authenticateWithTitle", {
    pluginName
  })), y2("div", {
    className: "uppy-Provider-authForm"
  }, renderForm({
    pluginName,
    i18n,
    loading,
    onAuth: handleAuth
  })));
}
function User(_ref) {
  let {
    i18n,
    logout,
    username
  } = _ref;
  return y2(g2, null, y2("span", {
    className: "uppy-ProviderBrowser-user",
    key: "username"
  }, username), y2("button", {
    type: "button",
    onClick: logout,
    className: "uppy-u-reset uppy-c-btn uppy-ProviderBrowser-userLogout",
    key: "logout"
  }, i18n("logOut")));
}
var Breadcrumb = (props) => {
  const {
    getFolder,
    title,
    isLast
  } = props;
  return y2(g2, null, y2("button", {
    type: "button",
    className: "uppy-u-reset uppy-c-btn",
    onClick: getFolder
  }, title), !isLast ? " / " : "");
};
function Breadcrumbs(props) {
  const {
    getFolder,
    title,
    breadcrumbsIcon,
    breadcrumbs
  } = props;
  return y2("div", {
    className: "uppy-Provider-breadcrumbs"
  }, y2("div", {
    className: "uppy-Provider-breadcrumbsIcon"
  }, breadcrumbsIcon), breadcrumbs.map((directory, i4) => y2(Breadcrumb, {
    key: directory.id,
    getFolder: () => getFolder(directory.requestPath, directory.name),
    title: i4 === 0 ? title : directory.name,
    isLast: i4 + 1 === breadcrumbs.length
  })));
}
function Header(props) {
  return y2(g2, null, props.showBreadcrumbs && y2(Breadcrumbs, {
    getFolder: props.getFolder,
    breadcrumbs: props.breadcrumbs,
    breadcrumbsIcon: props.pluginIcon && props.pluginIcon(),
    title: props.title
  }), y2(User, {
    logout: props.logout,
    username: props.username,
    i18n: props.i18n
  }));
}
var import_classnames5 = __toESM2(require_classnames2(), 1);
function remoteFileObjToLocal(file) {
  return {
    ...file,
    type: file.mimeType,
    extension: file.name ? getFileNameAndExtension(file.name).extension : null
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i4 = 1; i4 < arguments.length; i4++) {
      var source = arguments[i4];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var STYLE_INNER = {
  position: "relative",
  // Disabled for our use case: the wrapper elements around FileList already deal with overflow,
  // and this additional property would hide things that we want to show.
  //
  // overflow: 'hidden',
  width: "100%",
  minHeight: "100%"
};
var STYLE_CONTENT = {
  position: "absolute",
  top: 0,
  left: 0,
  // Because the `top` value gets set to some offset, this `height` being 100% would make the scrollbar
  // stretch far beyond the content. For our use case, the content div actually can get its height from
  // the elements inside it, so we don't need to specify a `height` property at all.
  //
  // height: '100%',
  width: "100%",
  overflow: "visible"
};
var VirtualList = class extends b2 {
  constructor(props) {
    super(props);
    this.handleScroll = () => {
      this.setState({
        offset: this.base.scrollTop
      });
    };
    this.handleResize = () => {
      this.resize();
    };
    this.focusElement = null;
    this.state = {
      offset: 0,
      height: 0
    };
  }
  componentDidMount() {
    this.resize();
    window.addEventListener("resize", this.handleResize);
  }
  // TODO: refactor to stable lifecycle method
  // eslint-disable-next-line
  componentWillUpdate() {
    if (this.base.contains(document.activeElement)) {
      this.focusElement = document.activeElement;
    }
  }
  componentDidUpdate() {
    if (this.focusElement && this.focusElement.parentNode && document.activeElement !== this.focusElement) {
      this.focusElement.focus();
    }
    this.focusElement = null;
    this.resize();
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }
  resize() {
    const {
      height
    } = this.state;
    if (height !== this.base.offsetHeight) {
      this.setState({
        height: this.base.offsetHeight
      });
    }
  }
  render(_ref) {
    let {
      data,
      rowHeight,
      renderRow,
      overscanCount = 10,
      ...props
    } = _ref;
    const {
      offset,
      height
    } = this.state;
    let start = Math.floor(offset / rowHeight);
    let visibleRowCount = Math.floor(height / rowHeight);
    if (overscanCount) {
      start = Math.max(0, start - start % overscanCount);
      visibleRowCount += overscanCount;
    }
    const end = start + visibleRowCount + 4;
    const selection = data.slice(start, end);
    const styleInner = {
      ...STYLE_INNER,
      height: data.length * rowHeight
    };
    const styleContent = {
      ...STYLE_CONTENT,
      top: start * rowHeight
    };
    return (
      // eslint-disable-next-line react/jsx-props-no-spreading
      y2("div", _extends({
        onScroll: this.handleScroll
      }, props), y2("div", {
        role: "presentation",
        style: styleInner
      }, y2("div", {
        role: "presentation",
        style: styleContent
      }, selection.map(renderRow))))
    );
  }
};
var VirtualList_default = VirtualList;
function SearchFilterInput(props) {
  const {
    search: search4,
    searchOnInput,
    searchTerm,
    showButton,
    inputLabel,
    clearSearchLabel,
    buttonLabel,
    clearSearch,
    inputClassName,
    buttonCSSClassName
  } = props;
  const [searchText, setSearchText] = p3(searchTerm != null ? searchTerm : "");
  const validateAndSearch = x3((ev) => {
    ev.preventDefault();
    search4(searchText);
  }, [search4, searchText]);
  const handleInput = x3((ev) => {
    const inputValue = ev.target.value;
    setSearchText(inputValue);
    if (searchOnInput)
      search4(inputValue);
  }, [setSearchText, searchOnInput, search4]);
  const handleReset = () => {
    setSearchText("");
    if (clearSearch)
      clearSearch();
  };
  const [form] = p3(() => {
    const formEl = document.createElement("form");
    formEl.setAttribute("tabindex", "-1");
    formEl.id = nanoid2();
    return formEl;
  });
  _3(() => {
    document.body.appendChild(form);
    form.addEventListener("submit", validateAndSearch);
    return () => {
      form.removeEventListener("submit", validateAndSearch);
      document.body.removeChild(form);
    };
  }, [form, validateAndSearch]);
  return y2(g2, null, y2("input", {
    className: `uppy-u-reset ${inputClassName}`,
    type: "search",
    "aria-label": inputLabel,
    placeholder: inputLabel,
    value: searchText,
    onInput: handleInput,
    form: form.id,
    "data-uppy-super-focusable": true
  }), !showButton && y2("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon uppy-ProviderBrowser-searchFilterIcon",
    width: "12",
    height: "12",
    viewBox: "0 0 12 12"
  }, y2("path", {
    d: "M8.638 7.99l3.172 3.172a.492.492 0 1 1-.697.697L7.91 8.656a4.977 4.977 0 0 1-2.983.983C2.206 9.639 0 7.481 0 4.819 0 2.158 2.206 0 4.927 0c2.721 0 4.927 2.158 4.927 4.82a4.74 4.74 0 0 1-1.216 3.17zm-3.71.685c2.176 0 3.94-1.726 3.94-3.856 0-2.129-1.764-3.855-3.94-3.855C2.75.964.984 2.69.984 4.819c0 2.13 1.765 3.856 3.942 3.856z"
  })), !showButton && searchText && y2("button", {
    className: "uppy-u-reset uppy-ProviderBrowser-searchFilterReset",
    type: "button",
    "aria-label": clearSearchLabel,
    title: clearSearchLabel,
    onClick: handleReset
  }, y2("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    viewBox: "0 0 19 19"
  }, y2("path", {
    d: "M17.318 17.232L9.94 9.854 9.586 9.5l-.354.354-7.378 7.378h.707l-.62-.62v.706L9.318 9.94l.354-.354-.354-.354L1.94 1.854v.707l.62-.62h-.706l7.378 7.378.354.354.354-.354 7.378-7.378h-.707l.622.62v-.706L9.854 9.232l-.354.354.354.354 7.378 7.378.708-.707-7.38-7.378v.708l7.38-7.38.353-.353-.353-.353-.622-.622-.353-.353-.354.352-7.378 7.38h.708L2.56 1.23 2.208.88l-.353.353-.622.62-.353.355.352.353 7.38 7.38v-.708l-7.38 7.38-.353.353.352.353.622.622.353.353.354-.353 7.38-7.38h-.708l7.38 7.38z"
  }))), showButton && y2("button", {
    className: `uppy-u-reset uppy-c-btn uppy-c-btn-primary ${buttonCSSClassName}`,
    type: "submit",
    form: form.id
  }, buttonLabel));
}
function FooterActions(_ref) {
  let {
    cancel,
    done,
    i18n,
    selected
  } = _ref;
  return y2("div", {
    className: "uppy-ProviderBrowser-footer"
  }, y2("button", {
    className: "uppy-u-reset uppy-c-btn uppy-c-btn-primary",
    onClick: done,
    type: "button"
  }, i18n("selectX", {
    smart_count: selected
  })), y2("button", {
    className: "uppy-u-reset uppy-c-btn uppy-c-btn-link",
    onClick: cancel,
    type: "button"
  }, i18n("cancel")));
}
var import_classnames4 = __toESM2(require_classnames2(), 1);
function FileIcon() {
  return y2("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    width: 11,
    height: 14.5,
    viewBox: "0 0 44 58"
  }, y2("path", {
    d: "M27.437.517a1 1 0 0 0-.094.03H4.25C2.037.548.217 2.368.217 4.58v48.405c0 2.212 1.82 4.03 4.03 4.03H39.03c2.21 0 4.03-1.818 4.03-4.03V15.61a1 1 0 0 0-.03-.28 1 1 0 0 0 0-.093 1 1 0 0 0-.03-.032 1 1 0 0 0 0-.03 1 1 0 0 0-.032-.063 1 1 0 0 0-.03-.063 1 1 0 0 0-.032 0 1 1 0 0 0-.03-.063 1 1 0 0 0-.032-.03 1 1 0 0 0-.03-.063 1 1 0 0 0-.063-.062l-14.593-14a1 1 0 0 0-.062-.062A1 1 0 0 0 28 .708a1 1 0 0 0-.374-.157 1 1 0 0 0-.156 0 1 1 0 0 0-.03-.03l-.003-.003zM4.25 2.547h22.218v9.97c0 2.21 1.82 4.03 4.03 4.03h10.564v36.438a2.02 2.02 0 0 1-2.032 2.032H4.25c-1.13 0-2.032-.9-2.032-2.032V4.58c0-1.13.902-2.032 2.03-2.032zm24.218 1.345l10.375 9.937.75.718H30.5c-1.13 0-2.032-.9-2.032-2.03V3.89z"
  }));
}
function FolderIcon() {
  return y2("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    style: {
      minWidth: 16,
      marginRight: 3
    },
    viewBox: "0 0 276.157 276.157"
  }, y2("path", {
    d: "M273.08 101.378c-3.3-4.65-8.86-7.32-15.254-7.32h-24.34V67.59c0-10.2-8.3-18.5-18.5-18.5h-85.322c-3.63 0-9.295-2.875-11.436-5.805l-6.386-8.735c-4.982-6.814-15.104-11.954-23.546-11.954H58.73c-9.292 0-18.638 6.608-21.737 15.372l-2.033 5.752c-.958 2.71-4.72 5.37-7.596 5.37H18.5C8.3 49.09 0 57.39 0 67.59v167.07c0 .886.16 1.73.443 2.52.152 3.306 1.18 6.424 3.053 9.064 3.3 4.652 8.86 7.32 15.255 7.32h188.487c11.395 0 23.27-8.425 27.035-19.18l40.677-116.188c2.11-6.035 1.43-12.164-1.87-16.816zM18.5 64.088h8.864c9.295 0 18.64-6.607 21.738-15.37l2.032-5.75c.96-2.712 4.722-5.373 7.597-5.373h29.565c3.63 0 9.295 2.876 11.437 5.806l6.386 8.735c4.982 6.815 15.104 11.954 23.546 11.954h85.322c1.898 0 3.5 1.602 3.5 3.5v26.47H69.34c-11.395 0-23.27 8.423-27.035 19.178L15 191.23V67.59c0-1.898 1.603-3.5 3.5-3.5zm242.29 49.15l-40.676 116.188c-1.674 4.78-7.812 9.135-12.877 9.135H18.75c-1.447 0-2.576-.372-3.02-.997-.442-.625-.422-1.814.057-3.18l40.677-116.19c1.674-4.78 7.812-9.134 12.877-9.134h188.487c1.448 0 2.577.372 3.02.997.443.625.423 1.814-.056 3.18z"
  }));
}
function VideoIcon() {
  return y2("svg", {
    "aria-hidden": "true",
    focusable: "false",
    style: {
      width: 16,
      marginRight: 4
    },
    viewBox: "0 0 58 58"
  }, y2("path", {
    d: "M36.537 28.156l-11-7a1.005 1.005 0 0 0-1.02-.033C24.2 21.3 24 21.635 24 22v14a1 1 0 0 0 1.537.844l11-7a1.002 1.002 0 0 0 0-1.688zM26 34.18V23.82L34.137 29 26 34.18z"
  }), y2("path", {
    d: "M57 6H1a1 1 0 0 0-1 1v44a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1zM10 28H2v-9h8v9zm-8 2h8v9H2v-9zm10 10V8h34v42H12V40zm44-12h-8v-9h8v9zm-8 2h8v9h-8v-9zm8-22v9h-8V8h8zM2 8h8v9H2V8zm0 42v-9h8v9H2zm54 0h-8v-9h8v9z"
  }));
}
function ItemIcon(props) {
  const {
    itemIconString
  } = props;
  if (itemIconString === null)
    return null;
  switch (itemIconString) {
    case "file":
      return y2(FileIcon, null);
    case "folder":
      return y2(FolderIcon, null);
    case "video":
      return y2(VideoIcon, null);
    default: {
      const {
        alt
      } = props;
      return y2("img", {
        src: itemIconString,
        alt,
        referrerPolicy: "no-referrer",
        loading: "lazy",
        width: 16,
        height: 16
      });
    }
  }
}
var import_classnames32 = __toESM2(require_classnames2(), 1);
function GridListItem(props) {
  const {
    className,
    isDisabled,
    restrictionError,
    isChecked,
    title,
    itemIconEl,
    showTitles,
    toggleCheckbox,
    recordShiftKeyPress,
    id: id18,
    children
  } = props;
  const checkBoxClassName = (0, import_classnames32.default)("uppy-u-reset", "uppy-ProviderBrowserItem-checkbox", "uppy-ProviderBrowserItem-checkbox--grid", {
    "uppy-ProviderBrowserItem-checkbox--is-checked": isChecked
  });
  return y2("li", {
    className,
    title: isDisabled ? restrictionError == null ? void 0 : restrictionError.message : void 0
  }, y2("input", {
    type: "checkbox",
    className: checkBoxClassName,
    onChange: toggleCheckbox,
    onKeyDown: recordShiftKeyPress,
    onMouseDown: recordShiftKeyPress,
    name: "listitem",
    id: id18,
    checked: isChecked,
    disabled: isDisabled,
    "data-uppy-super-focusable": true
  }), y2("label", {
    htmlFor: id18,
    "aria-label": title,
    className: "uppy-u-reset uppy-ProviderBrowserItem-inner"
  }, itemIconEl, showTitles && title, children));
}
var GridLi_default = GridListItem;
function ListItem22(props) {
  const {
    className,
    isDisabled,
    restrictionError,
    isCheckboxDisabled,
    isChecked,
    toggleCheckbox,
    recordShiftKeyPress,
    type,
    id: id18,
    itemIconEl,
    title,
    handleFolderClick,
    showTitles,
    i18n
  } = props;
  return y2("li", {
    className,
    title: isDisabled ? restrictionError == null ? void 0 : restrictionError.message : void 0
  }, !isCheckboxDisabled ? y2("input", {
    type: "checkbox",
    className: `uppy-u-reset uppy-ProviderBrowserItem-checkbox ${isChecked ? "uppy-ProviderBrowserItem-checkbox--is-checked" : ""}`,
    onChange: toggleCheckbox,
    onKeyDown: recordShiftKeyPress,
    onMouseDown: recordShiftKeyPress,
    name: "listitem",
    id: id18,
    checked: isChecked,
    "aria-label": type === "file" ? null : i18n("allFilesFromFolderNamed", {
      name: title
    }),
    disabled: isDisabled,
    "data-uppy-super-focusable": true
  }) : null, type === "file" ? (
    // label for a checkbox
    y2("label", {
      htmlFor: id18,
      className: "uppy-u-reset uppy-ProviderBrowserItem-inner"
    }, y2("div", {
      className: "uppy-ProviderBrowserItem-iconWrap"
    }, itemIconEl), showTitles && title)
  ) : y2("button", {
    type: "button",
    className: "uppy-u-reset uppy-c-btn uppy-ProviderBrowserItem-inner",
    onClick: handleFolderClick,
    "aria-label": i18n("openFolderNamed", {
      name: title
    })
  }, y2("div", {
    className: "uppy-ProviderBrowserItem-iconWrap"
  }, itemIconEl), showTitles && y2("span", null, title)));
}
function _extends2() {
  _extends2 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i4 = 1; i4 < arguments.length; i4++) {
      var source = arguments[i4];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends2.apply(this, arguments);
}
function Item(props) {
  const {
    author,
    getItemIcon,
    isChecked,
    isDisabled,
    viewType
  } = props;
  const itemIconString = getItemIcon();
  const className = (0, import_classnames4.default)("uppy-ProviderBrowserItem", {
    "uppy-ProviderBrowserItem--selected": isChecked
  }, {
    "uppy-ProviderBrowserItem--disabled": isDisabled
  }, {
    "uppy-ProviderBrowserItem--noPreview": itemIconString === "video"
  });
  const itemIconEl = y2(ItemIcon, {
    itemIconString
  });
  switch (viewType) {
    case "grid":
      return y2(GridLi_default, _extends2({}, props, {
        className,
        itemIconEl
      }));
    case "list":
      return y2(ListItem22, _extends2({}, props, {
        className,
        itemIconEl
      }));
    case "unsplash":
      return y2(GridLi_default, _extends2({}, props, {
        className,
        itemIconEl
      }), y2("a", {
        href: `${author.url}?utm_source=Companion&utm_medium=referral`,
        target: "_blank",
        rel: "noopener noreferrer",
        className: "uppy-ProviderBrowserItem-author",
        tabIndex: -1
      }, author.name));
    default:
      throw new Error(`There is no such type ${viewType}`);
  }
}
var VIRTUAL_SHARED_DIR = "shared-with-me";
function ListItem32(props) {
  const {
    currentSelection,
    uppyFiles,
    viewType,
    isChecked,
    toggleCheckbox,
    recordShiftKeyPress,
    showTitles,
    i18n,
    validateRestrictions,
    getNextFolder,
    f: f4
  } = props;
  if (f4.isFolder) {
    return Item({
      showTitles,
      viewType,
      i18n,
      id: f4.id,
      title: f4.name,
      getItemIcon: () => f4.icon,
      isChecked: isChecked(f4),
      toggleCheckbox: (event) => toggleCheckbox(event, f4),
      recordShiftKeyPress,
      type: "folder",
      // TODO: when was this supposed to be true?
      isDisabled: false,
      isCheckboxDisabled: f4.id === VIRTUAL_SHARED_DIR,
      // getNextFolder always exists when f.isFolder is true
      handleFolderClick: () => getNextFolder(f4)
    });
  }
  const restrictionError = validateRestrictions(remoteFileObjToLocal(f4), [...uppyFiles, ...currentSelection]);
  return Item({
    id: f4.id,
    title: f4.name,
    author: f4.author,
    getItemIcon: () => f4.icon,
    isChecked: isChecked(f4),
    toggleCheckbox: (event) => toggleCheckbox(event, f4),
    isCheckboxDisabled: false,
    recordShiftKeyPress,
    showTitles,
    viewType,
    i18n,
    type: "file",
    isDisabled: Boolean(restrictionError) && !isChecked(f4),
    restrictionError
  });
}
function Browser(props) {
  const {
    currentSelection,
    folders,
    files,
    uppyFiles,
    viewType,
    headerComponent,
    showBreadcrumbs,
    isChecked,
    toggleCheckbox,
    recordShiftKeyPress,
    handleScroll,
    showTitles,
    i18n,
    validateRestrictions,
    isLoading,
    showSearchFilter,
    search: search4,
    searchTerm,
    clearSearch,
    searchOnInput,
    searchInputLabel,
    clearSearchLabel,
    getNextFolder,
    cancel,
    done,
    noResultsLabel,
    loadAllFiles
  } = props;
  const selected = currentSelection.length;
  const rows = q3(() => [...folders, ...files], [folders, files]);
  return y2("div", {
    className: (0, import_classnames5.default)("uppy-ProviderBrowser", `uppy-ProviderBrowser-viewType--${viewType}`)
  }, headerComponent && y2("div", {
    className: "uppy-ProviderBrowser-header"
  }, y2("div", {
    className: (0, import_classnames5.default)("uppy-ProviderBrowser-headerBar", !showBreadcrumbs && "uppy-ProviderBrowser-headerBar--simple")
  }, headerComponent)), showSearchFilter && y2("div", {
    class: "uppy-ProviderBrowser-searchFilter"
  }, y2(SearchFilterInput, {
    search: search4,
    searchTerm,
    clearSearch,
    inputLabel: searchInputLabel,
    clearSearchLabel,
    inputClassName: "uppy-ProviderBrowser-searchFilterInput",
    searchOnInput
  })), (() => {
    if (isLoading) {
      return y2("div", {
        className: "uppy-Provider-loading"
      }, y2("span", null, i18n("loading")));
    }
    if (!folders.length && !files.length) {
      return y2("div", {
        className: "uppy-Provider-empty"
      }, noResultsLabel);
    }
    if (loadAllFiles) {
      return y2("div", {
        className: "uppy-ProviderBrowser-body"
      }, y2("ul", {
        className: "uppy-ProviderBrowser-list"
      }, y2(VirtualList_default, {
        data: rows,
        renderRow: (f4) => y2(ListItem32, {
          currentSelection,
          uppyFiles,
          viewType,
          isChecked,
          toggleCheckbox,
          recordShiftKeyPress,
          showTitles,
          i18n,
          validateRestrictions,
          getNextFolder,
          f: f4
        }),
        rowHeight: 31
      })));
    }
    return y2("div", {
      className: "uppy-ProviderBrowser-body"
    }, y2("ul", {
      className: "uppy-ProviderBrowser-list",
      onScroll: handleScroll,
      role: "listbox",
      tabIndex: -1
    }, rows.map((f4) => y2(ListItem32, {
      currentSelection,
      uppyFiles,
      viewType,
      isChecked,
      toggleCheckbox,
      recordShiftKeyPress,
      showTitles,
      i18n,
      validateRestrictions,
      getNextFolder,
      f: f4
    }))));
  })(), selected > 0 && y2(FooterActions, {
    selected,
    done,
    cancel,
    i18n
  }));
}
var Browser_default = Browser;
var CloseWrapper = class extends b2 {
  componentWillUnmount() {
    const {
      onUnmount
    } = this.props;
    onUnmount();
  }
  render() {
    const {
      children
    } = this.props;
    return H(children)[0];
  }
};
var View = class {
  constructor(plugin, opts) {
    this.filterItems = (items) => {
      const state = this.plugin.getPluginState();
      if (!state.filterInput || state.filterInput === "") {
        return items;
      }
      return items.filter((folder) => {
        return folder.name.toLowerCase().indexOf(state.filterInput.toLowerCase()) !== -1;
      });
    };
    this.recordShiftKeyPress = (e4) => {
      this.isShiftKeyPressed = e4.shiftKey;
    };
    this.toggleCheckbox = (e4, file) => {
      e4.stopPropagation();
      e4.preventDefault();
      e4.currentTarget.focus();
      const {
        folders,
        files
      } = this.plugin.getPluginState();
      const items = this.filterItems(folders.concat(files));
      if (this.lastCheckbox && this.isShiftKeyPressed) {
        const {
          currentSelection: currentSelection2
        } = this.plugin.getPluginState();
        const prevIndex = items.indexOf(this.lastCheckbox);
        const currentIndex = items.indexOf(file);
        const newSelection = prevIndex < currentIndex ? items.slice(prevIndex, currentIndex + 1) : items.slice(currentIndex, prevIndex + 1);
        const reducedNewSelection = [];
        for (const item of newSelection) {
          const {
            uppy: uppy22
          } = this.plugin;
          const restrictionError = uppy22.validateRestrictions(remoteFileObjToLocal(item), [...uppy22.getFiles(), ...reducedNewSelection]);
          if (!restrictionError) {
            reducedNewSelection.push(item);
          } else {
            uppy22.info({
              message: restrictionError.message
            }, "error", uppy22.opts.infoTimeout);
          }
        }
        this.plugin.setPluginState({
          currentSelection: [.../* @__PURE__ */ new Set([...currentSelection2, ...reducedNewSelection])]
        });
        return;
      }
      this.lastCheckbox = file;
      const {
        currentSelection
      } = this.plugin.getPluginState();
      if (this.isChecked(file)) {
        this.plugin.setPluginState({
          currentSelection: currentSelection.filter((item) => item.id !== file.id)
        });
      } else {
        this.plugin.setPluginState({
          currentSelection: currentSelection.concat([file])
        });
      }
    };
    this.isChecked = (file) => {
      const {
        currentSelection
      } = this.plugin.getPluginState();
      return currentSelection.some((item) => item.id === file.id);
    };
    this.plugin = plugin;
    this.provider = opts.provider;
    this.opts = opts;
    this.isHandlingScroll = false;
    this.preFirstRender = this.preFirstRender.bind(this);
    this.handleError = this.handleError.bind(this);
    this.clearSelection = this.clearSelection.bind(this);
    this.cancelPicking = this.cancelPicking.bind(this);
  }
  preFirstRender() {
    this.plugin.setPluginState({
      didFirstRender: true
    });
    this.plugin.onFirstRender();
  }
  shouldHandleScroll(event) {
    const {
      scrollHeight,
      scrollTop,
      offsetHeight
    } = event.target;
    const scrollPosition = scrollHeight - (scrollTop + offsetHeight);
    return scrollPosition < 50 && !this.isHandlingScroll;
  }
  clearSelection() {
    this.plugin.setPluginState({
      currentSelection: [],
      filterInput: ""
    });
  }
  cancelPicking() {
    this.clearSelection();
    const dashboard22 = this.plugin.uppy.getPlugin("Dashboard");
    if (dashboard22) {
      dashboard22.hideAllPanels();
    }
  }
  handleError(error) {
    var _error$cause;
    const {
      uppy: uppy22
    } = this.plugin;
    const message = uppy22.i18n("companionError");
    uppy22.log(error.toString());
    if (error.isAuthError || ((_error$cause = error.cause) == null ? void 0 : _error$cause.name) === "AbortError") {
      return;
    }
    uppy22.info({
      message,
      details: error.toString()
    }, "error", 5e3);
  }
  registerRequestClient() {
    this.requestClientId = this.provider.provider;
    this.plugin.uppy.registerRequestClient(this.requestClientId, this.provider);
  }
  // TODO: document what is a "tagFile" or get rid of this concept
  getTagFile(file) {
    const tagFile = {
      id: file.id,
      source: this.plugin.id,
      name: file.name || file.id,
      type: file.mimeType,
      isRemote: true,
      // @ts-expect-error meta is filled conditionally below
      data: file,
      // @ts-expect-error meta is filled conditionally below
      meta: {},
      body: {
        fileId: file.id
      },
      remote: {
        companionUrl: this.plugin.opts.companionUrl,
        // @ts-expect-error untyped for now
        url: `${this.provider.fileUrl(file.requestPath)}`,
        body: {
          fileId: file.id
        },
        providerName: this.provider.name,
        provider: this.provider.provider,
        requestClientId: this.requestClientId
      }
    };
    const fileType = getFileType(tagFile);
    if (fileType && isPreviewSupported(fileType)) {
      tagFile.preview = file.thumbnail;
    }
    if (file.author) {
      if (file.author.name != null)
        tagFile.meta.authorName = String(file.author.name);
      if (file.author.url)
        tagFile.meta.authorUrl = file.author.url;
    }
    if (file.relDirPath != null)
      tagFile.meta.relativePath = file.relDirPath ? `${file.relDirPath}/${tagFile.name}` : null;
    if (file.absDirPath != null)
      tagFile.meta.absolutePath = file.absDirPath ? `/${file.absDirPath}/${tagFile.name}` : `/${tagFile.name}`;
    return tagFile;
  }
  setLoading(loading) {
    this.plugin.setPluginState({
      loading
    });
  }
};
function _classPrivateFieldLooseBase15(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id15 = 0;
function _classPrivateFieldLooseKey15(name) {
  return "__private_" + id15++ + "_" + name;
}
var packageJson9 = {
  "version": "3.10.0"
};
function formatBreadcrumbs(breadcrumbs) {
  return breadcrumbs.slice(1).map((directory) => directory.name).join("/");
}
function prependPath(path, component) {
  if (!path)
    return component;
  return `${path}/${component}`;
}
function defaultPickerIcon() {
  return y2("svg", {
    "aria-hidden": "true",
    focusable: "false",
    width: "30",
    height: "30",
    viewBox: "0 0 30 30"
  }, y2("path", {
    d: "M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15zm4.258-12.676v6.846h-8.426v-6.846H5.204l9.82-12.364 9.82 12.364H19.26z"
  }));
}
var defaultOptions42 = {
  viewType: "list",
  showTitles: true,
  showFilter: true,
  showBreadcrumbs: true,
  loadAllFiles: false
};
var _abortController22 = /* @__PURE__ */ _classPrivateFieldLooseKey15("abortController");
var _withAbort = /* @__PURE__ */ _classPrivateFieldLooseKey15("withAbort");
var _list = /* @__PURE__ */ _classPrivateFieldLooseKey15("list");
var _listFilesAndFolders = /* @__PURE__ */ _classPrivateFieldLooseKey15("listFilesAndFolders");
var _recursivelyListAllFiles = /* @__PURE__ */ _classPrivateFieldLooseKey15("recursivelyListAllFiles");
var ProviderView = class extends View {
  constructor(plugin, opts) {
    super(plugin, {
      ...defaultOptions42,
      ...opts
    });
    Object.defineProperty(this, _recursivelyListAllFiles, {
      value: _recursivelyListAllFiles2
    });
    Object.defineProperty(this, _listFilesAndFolders, {
      value: _listFilesAndFolders2
    });
    Object.defineProperty(this, _list, {
      value: _list2
    });
    Object.defineProperty(this, _withAbort, {
      value: _withAbort2
    });
    Object.defineProperty(this, _abortController22, {
      writable: true,
      value: void 0
    });
    this.filterQuery = this.filterQuery.bind(this);
    this.clearFilter = this.clearFilter.bind(this);
    this.getFolder = this.getFolder.bind(this);
    this.getNextFolder = this.getNextFolder.bind(this);
    this.logout = this.logout.bind(this);
    this.handleAuth = this.handleAuth.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.donePicking = this.donePicking.bind(this);
    this.render = this.render.bind(this);
    this.plugin.setPluginState({
      authenticated: void 0,
      // we don't know yet
      files: [],
      folders: [],
      breadcrumbs: [],
      filterInput: "",
      isSearchVisible: false,
      currentSelection: []
    });
    this.registerRequestClient();
  }
  // eslint-disable-next-line class-methods-use-this
  tearDown() {
  }
  /**
   * Select a folder based on its id: fetches the folder and then updates state with its contents
   * TODO rename to something better like selectFolder or navigateToFolder (breaking change?)
   *
   */
  async getFolder(requestPath, name) {
    this.setLoading(true);
    try {
      await _classPrivateFieldLooseBase15(this, _withAbort)[_withAbort](async (signal) => {
        this.lastCheckbox = void 0;
        let {
          breadcrumbs
        } = this.plugin.getPluginState();
        const index2 = breadcrumbs.findIndex((dir) => requestPath === dir.requestPath);
        if (index2 !== -1) {
          breadcrumbs = breadcrumbs.slice(0, index2 + 1);
        } else {
          breadcrumbs = [...breadcrumbs, {
            requestPath,
            name
          }];
        }
        this.nextPagePath = requestPath;
        let files = [];
        let folders = [];
        do {
          const {
            files: newFiles,
            folders: newFolders
          } = await _classPrivateFieldLooseBase15(this, _listFilesAndFolders)[_listFilesAndFolders]({
            breadcrumbs,
            signal
          });
          files = files.concat(newFiles);
          folders = folders.concat(newFolders);
          this.setLoading(this.plugin.uppy.i18n("loadedXFiles", {
            numFiles: files.length + folders.length
          }));
        } while (this.opts.loadAllFiles && this.nextPagePath);
        this.plugin.setPluginState({
          folders,
          files,
          breadcrumbs,
          filterInput: ""
        });
      });
    } catch (err) {
      if ((err == null ? void 0 : err.name) === "UserFacingApiError") {
        this.plugin.uppy.info({
          message: this.plugin.uppy.i18n(err.message)
        }, "warning", 5e3);
        return;
      }
      this.handleError(err);
    } finally {
      this.setLoading(false);
    }
  }
  /**
   * Fetches new folder
   */
  getNextFolder(folder) {
    this.getFolder(folder.requestPath, folder.name);
    this.lastCheckbox = void 0;
  }
  /**
   * Removes session token on client side.
   */
  async logout() {
    try {
      await _classPrivateFieldLooseBase15(this, _withAbort)[_withAbort](async (signal) => {
        const res = await this.provider.logout({
          signal
        });
        if (res.ok) {
          if (!res.revoked) {
            const message = this.plugin.uppy.i18n("companionUnauthorizeHint", {
              provider: this.plugin.title,
              url: res.manual_revoke_url
            });
            this.plugin.uppy.info(message, "info", 7e3);
          }
          const newState = {
            authenticated: false,
            files: [],
            folders: [],
            breadcrumbs: [],
            filterInput: ""
          };
          this.plugin.setPluginState(newState);
        }
      });
    } catch (err) {
      this.handleError(err);
    }
  }
  filterQuery(input) {
    this.plugin.setPluginState({
      filterInput: input
    });
  }
  clearFilter() {
    this.plugin.setPluginState({
      filterInput: ""
    });
  }
  async handleAuth(authFormData) {
    try {
      await _classPrivateFieldLooseBase15(this, _withAbort)[_withAbort](async (signal) => {
        this.setLoading(true);
        await this.provider.login({
          authFormData,
          signal
        });
        this.plugin.setPluginState({
          authenticated: true
        });
        this.preFirstRender();
      });
    } catch (err) {
      if (err.name === "UserFacingApiError") {
        this.plugin.uppy.info({
          message: this.plugin.uppy.i18n(err.message)
        }, "warning", 5e3);
        return;
      }
      this.plugin.uppy.log(`login failed: ${err.message}`);
    } finally {
      this.setLoading(false);
    }
  }
  async handleScroll(event) {
    if (this.shouldHandleScroll(event) && this.nextPagePath) {
      this.isHandlingScroll = true;
      try {
        await _classPrivateFieldLooseBase15(this, _withAbort)[_withAbort](async (signal) => {
          const {
            files,
            folders,
            breadcrumbs
          } = this.plugin.getPluginState();
          const {
            files: newFiles,
            folders: newFolders
          } = await _classPrivateFieldLooseBase15(this, _listFilesAndFolders)[_listFilesAndFolders]({
            breadcrumbs,
            signal
          });
          const combinedFiles = files.concat(newFiles);
          const combinedFolders = folders.concat(newFolders);
          this.plugin.setPluginState({
            folders: combinedFolders,
            files: combinedFiles
          });
        });
      } catch (error) {
        this.handleError(error);
      } finally {
        this.isHandlingScroll = false;
      }
    }
  }
  async donePicking() {
    this.setLoading(true);
    try {
      await _classPrivateFieldLooseBase15(this, _withAbort)[_withAbort](async (signal) => {
        const {
          currentSelection
        } = this.plugin.getPluginState();
        const messages = [];
        const newFiles = [];
        for (const selectedItem of currentSelection) {
          const {
            requestPath
          } = selectedItem;
          const withRelDirPath = (newItem) => ({
            ...newItem,
            // calculate the file's path relative to the user's selected item's path
            // see https://github.com/transloadit/uppy/pull/4537#issuecomment-1614236655
            relDirPath: newItem.absDirPath.replace(selectedItem.absDirPath, "").replace(/^\//, "")
          });
          if (selectedItem.isFolder) {
            let isEmpty = true;
            let numNewFiles = 0;
            const queue = new dist_default({
              concurrency: 6
            });
            const onFiles = (files) => {
              for (const newFile of files) {
                const tagFile = this.getTagFile(newFile);
                const id18 = getSafeFileId(tagFile);
                if (!this.plugin.uppy.checkIfFileAlreadyExists(id18)) {
                  newFiles.push(withRelDirPath(newFile));
                  numNewFiles++;
                  this.setLoading(this.plugin.uppy.i18n("addedNumFiles", {
                    numFiles: numNewFiles
                  }));
                }
                isEmpty = false;
              }
            };
            await _classPrivateFieldLooseBase15(this, _recursivelyListAllFiles)[_recursivelyListAllFiles]({
              requestPath,
              absDirPath: prependPath(selectedItem.absDirPath, selectedItem.name),
              relDirPath: selectedItem.name,
              queue,
              onFiles,
              signal
            });
            await queue.onIdle();
            let message;
            if (isEmpty) {
              message = this.plugin.uppy.i18n("emptyFolderAdded");
            } else if (numNewFiles === 0) {
              message = this.plugin.uppy.i18n("folderAlreadyAdded", {
                folder: selectedItem.name
              });
            } else {
              message = this.plugin.uppy.i18n("folderAdded", {
                smart_count: numNewFiles,
                folder: selectedItem.name
              });
            }
            messages.push(message);
          } else {
            newFiles.push(withRelDirPath(selectedItem));
          }
        }
        this.plugin.uppy.log("Adding files from a remote provider");
        this.plugin.uppy.addFiles(
          // @ts-expect-error `addFiles` expects `body` to be `File` or `Blob`,
          // but as the todo comment in `View.ts` indicates, we strangly pass `CompanionFile` as `body`.
          // For now it's better to ignore than to have a potential breaking change.
          newFiles.map((file) => this.getTagFile(file, this.requestClientId))
        );
        this.plugin.setPluginState({
          filterInput: ""
        });
        messages.forEach((message) => this.plugin.uppy.info(message));
        this.clearSelection();
      });
    } catch (err) {
      this.handleError(err);
    } finally {
      this.setLoading(false);
    }
  }
  render(state, viewOptions) {
    var _this = this;
    if (viewOptions === void 0) {
      viewOptions = {};
    }
    const {
      authenticated,
      didFirstRender
    } = this.plugin.getPluginState();
    const {
      i18n
    } = this.plugin.uppy;
    if (!didFirstRender) {
      this.preFirstRender();
    }
    const targetViewOptions = {
      ...this.opts,
      ...viewOptions
    };
    const {
      files,
      folders,
      filterInput,
      loading,
      currentSelection
    } = this.plugin.getPluginState();
    const {
      isChecked,
      toggleCheckbox,
      recordShiftKeyPress,
      filterItems
    } = this;
    const hasInput = filterInput !== "";
    const pluginIcon = this.plugin.icon || defaultPickerIcon;
    const headerProps = {
      showBreadcrumbs: targetViewOptions.showBreadcrumbs,
      getFolder: this.getFolder,
      breadcrumbs: this.plugin.getPluginState().breadcrumbs,
      pluginIcon,
      title: this.plugin.title,
      logout: this.logout,
      username: this.username,
      i18n
    };
    const browserProps = {
      isChecked,
      toggleCheckbox,
      recordShiftKeyPress,
      currentSelection,
      files: hasInput ? filterItems(files) : files,
      folders: hasInput ? filterItems(folders) : folders,
      getNextFolder: this.getNextFolder,
      getFolder: this.getFolder,
      loadAllFiles: this.opts.loadAllFiles,
      // For SearchFilterInput component
      showSearchFilter: targetViewOptions.showFilter,
      search: this.filterQuery,
      clearSearch: this.clearFilter,
      searchTerm: filterInput,
      searchOnInput: true,
      searchInputLabel: i18n("filter"),
      clearSearchLabel: i18n("resetFilter"),
      noResultsLabel: i18n("noFilesFound"),
      logout: this.logout,
      handleScroll: this.handleScroll,
      done: this.donePicking,
      cancel: this.cancelPicking,
      // eslint-disable-next-line react/jsx-props-no-spreading
      headerComponent: y2(Header, headerProps),
      title: this.plugin.title,
      viewType: targetViewOptions.viewType,
      showTitles: targetViewOptions.showTitles,
      showBreadcrumbs: targetViewOptions.showBreadcrumbs,
      pluginIcon,
      i18n: this.plugin.uppy.i18n,
      uppyFiles: this.plugin.uppy.getFiles(),
      validateRestrictions: function() {
        return _this.plugin.uppy.validateRestrictions(...arguments);
      },
      isLoading: loading
    };
    if (authenticated === false) {
      return y2(CloseWrapper, {
        onUnmount: this.clearSelection
      }, y2(AuthView, {
        pluginName: this.plugin.title,
        pluginIcon,
        handleAuth: this.handleAuth,
        i18n: this.plugin.uppy.i18nArray,
        renderForm: this.opts.renderAuthForm,
        loading
      }));
    }
    return y2(CloseWrapper, {
      onUnmount: this.clearSelection
    }, y2(Browser_default, browserProps));
  }
};
async function _withAbort2(op) {
  var _classPrivateFieldLoo;
  (_classPrivateFieldLoo = _classPrivateFieldLooseBase15(this, _abortController22)[_abortController22]) == null || _classPrivateFieldLoo.abort();
  const abortController = new AbortController();
  _classPrivateFieldLooseBase15(this, _abortController22)[_abortController22] = abortController;
  const cancelRequest = () => {
    abortController.abort();
    this.clearSelection();
  };
  try {
    this.plugin.uppy.on("dashboard:close-panel", cancelRequest);
    this.plugin.uppy.on("cancel-all", cancelRequest);
    await op(abortController.signal);
  } finally {
    this.plugin.uppy.off("dashboard:close-panel", cancelRequest);
    this.plugin.uppy.off("cancel-all", cancelRequest);
    _classPrivateFieldLooseBase15(this, _abortController22)[_abortController22] = void 0;
  }
}
async function _list2(_ref) {
  let {
    requestPath,
    absDirPath,
    signal
  } = _ref;
  const {
    username,
    nextPagePath,
    items
  } = await this.provider.list(requestPath, {
    signal
  });
  this.username = username || this.username;
  return {
    items: items.map((item) => ({
      ...item,
      absDirPath
    })),
    nextPagePath
  };
}
async function _listFilesAndFolders2(_ref2) {
  let {
    breadcrumbs,
    signal
  } = _ref2;
  const absDirPath = formatBreadcrumbs(breadcrumbs);
  const {
    items,
    nextPagePath
  } = await _classPrivateFieldLooseBase15(this, _list)[_list]({
    requestPath: this.nextPagePath,
    absDirPath,
    signal
  });
  this.nextPagePath = nextPagePath;
  const files = [];
  const folders = [];
  items.forEach((item) => {
    if (item.isFolder) {
      folders.push(item);
    } else {
      files.push(item);
    }
  });
  return {
    files,
    folders
  };
}
async function _recursivelyListAllFiles2(_ref3) {
  let {
    requestPath,
    absDirPath,
    relDirPath,
    queue,
    onFiles,
    signal
  } = _ref3;
  let curPath = requestPath;
  while (curPath) {
    const res = await _classPrivateFieldLooseBase15(this, _list)[_list]({
      requestPath: curPath,
      absDirPath,
      signal
    });
    curPath = res.nextPagePath;
    const files = res.items.filter((item) => !item.isFolder);
    const folders = res.items.filter((item) => item.isFolder);
    onFiles(files);
    const promises = folders.map(async (folder) => queue.add(async () => _classPrivateFieldLooseBase15(this, _recursivelyListAllFiles)[_recursivelyListAllFiles]({
      requestPath: folder.requestPath,
      absDirPath: prependPath(absDirPath, folder.name),
      relDirPath: prependPath(relDirPath, folder.name),
      queue,
      onFiles,
      signal
    })));
    await Promise.all(promises);
  }
}
ProviderView.VERSION = packageJson9.version;
function _classPrivateFieldLooseBase16(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id16 = 0;
function _classPrivateFieldLooseKey16(name) {
  return "__private_" + id16++ + "_" + name;
}
var packageJson10 = {
  "version": "3.10.0"
};
var defaultState = {
  isInputMode: true,
  files: [],
  folders: [],
  breadcrumbs: [],
  filterInput: "",
  currentSelection: [],
  searchTerm: null
};
var defaultOptions52 = {
  viewType: "grid",
  showTitles: true,
  showFilter: true,
  showBreadcrumbs: true
};
var _updateFilesAndInputMode = /* @__PURE__ */ _classPrivateFieldLooseKey16("updateFilesAndInputMode");
var SearchProviderView = class extends View {
  constructor(plugin, opts) {
    super(plugin, {
      ...defaultOptions52,
      ...opts
    });
    Object.defineProperty(this, _updateFilesAndInputMode, {
      value: _updateFilesAndInputMode2
    });
    this.nextPageQuery = null;
    this.search = this.search.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
    this.resetPluginState = this.resetPluginState.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.donePicking = this.donePicking.bind(this);
    this.render = this.render.bind(this);
    this.plugin.setPluginState(defaultState);
    this.registerRequestClient();
  }
  // eslint-disable-next-line class-methods-use-this
  tearDown() {
  }
  resetPluginState() {
    this.plugin.setPluginState(defaultState);
  }
  async search(query3) {
    const {
      searchTerm
    } = this.plugin.getPluginState();
    if (query3 && query3 === searchTerm) {
      return;
    }
    this.setLoading(true);
    try {
      const res = await this.provider.search(query3);
      _classPrivateFieldLooseBase16(this, _updateFilesAndInputMode)[_updateFilesAndInputMode](res, []);
    } catch (err) {
      this.handleError(err);
    } finally {
      this.setLoading(false);
    }
  }
  clearSearch() {
    this.plugin.setPluginState({
      currentSelection: [],
      files: [],
      searchTerm: null
    });
  }
  async handleScroll(event) {
    const query3 = this.nextPageQuery || null;
    if (this.shouldHandleScroll(event) && query3) {
      this.isHandlingScroll = true;
      try {
        const {
          files,
          searchTerm
        } = this.plugin.getPluginState();
        const response = await this.provider.search(searchTerm, query3);
        _classPrivateFieldLooseBase16(this, _updateFilesAndInputMode)[_updateFilesAndInputMode](response, files);
      } catch (error) {
        this.handleError(error);
      } finally {
        this.isHandlingScroll = false;
      }
    }
  }
  donePicking() {
    const {
      currentSelection
    } = this.plugin.getPluginState();
    this.plugin.uppy.log("Adding remote search provider files");
    this.plugin.uppy.addFiles(currentSelection.map((file) => this.getTagFile(file)));
    this.resetPluginState();
  }
  render(state, viewOptions) {
    var _this = this;
    if (viewOptions === void 0) {
      viewOptions = {};
    }
    const {
      didFirstRender,
      isInputMode,
      searchTerm
    } = this.plugin.getPluginState();
    const {
      i18n
    } = this.plugin.uppy;
    if (!didFirstRender) {
      this.preFirstRender();
    }
    const targetViewOptions = {
      ...this.opts,
      ...viewOptions
    };
    const {
      files,
      folders,
      filterInput,
      loading,
      currentSelection
    } = this.plugin.getPluginState();
    const {
      isChecked,
      toggleCheckbox,
      filterItems,
      recordShiftKeyPress
    } = this;
    const hasInput = filterInput !== "";
    const browserProps = {
      isChecked,
      toggleCheckbox,
      recordShiftKeyPress,
      currentSelection,
      files: hasInput ? filterItems(files) : files,
      folders: hasInput ? filterItems(folders) : folders,
      handleScroll: this.handleScroll,
      done: this.donePicking,
      cancel: this.cancelPicking,
      // For SearchFilterInput component
      showSearchFilter: targetViewOptions.showFilter,
      search: this.search,
      clearSearch: this.clearSearch,
      searchTerm,
      searchOnInput: false,
      searchInputLabel: i18n("search"),
      clearSearchLabel: i18n("resetSearch"),
      noResultsLabel: i18n("noSearchResults"),
      title: this.plugin.title,
      viewType: targetViewOptions.viewType,
      showTitles: targetViewOptions.showTitles,
      showFilter: targetViewOptions.showFilter,
      isLoading: loading,
      showBreadcrumbs: targetViewOptions.showBreadcrumbs,
      pluginIcon: this.plugin.icon,
      i18n,
      uppyFiles: this.plugin.uppy.getFiles(),
      validateRestrictions: function() {
        return _this.plugin.uppy.validateRestrictions(...arguments);
      }
    };
    if (isInputMode) {
      return y2(CloseWrapper, {
        onUnmount: this.resetPluginState
      }, y2("div", {
        className: "uppy-SearchProvider"
      }, y2(SearchFilterInput, {
        search: this.search,
        inputLabel: i18n("enterTextToSearch"),
        buttonLabel: i18n("searchImages"),
        inputClassName: "uppy-c-textInput uppy-SearchProvider-input",
        buttonCSSClassName: "uppy-SearchProvider-searchButton",
        showButton: true
      })));
    }
    return y2(CloseWrapper, {
      onUnmount: this.resetPluginState
    }, y2(Browser_default, browserProps));
  }
};
function _updateFilesAndInputMode2(res, files) {
  this.nextPageQuery = res.nextPageQuery;
  res.items.forEach((item) => {
    files.push(item);
  });
  this.plugin.setPluginState({
    currentSelection: [],
    isInputMode: false,
    files,
    searchTerm: res.searchedFor
  });
}
SearchProviderView.VERSION = packageJson10.version;
var safeIsNaN = Number.isNaN || function ponyfill(value) {
  return typeof value === "number" && value !== value;
};
function isEqual(first, second) {
  if (first === second) {
    return true;
  }
  if (safeIsNaN(first) && safeIsNaN(second)) {
    return true;
  }
  return false;
}
function areInputsEqual(newInputs, lastInputs) {
  if (newInputs.length !== lastInputs.length) {
    return false;
  }
  for (var i4 = 0; i4 < newInputs.length; i4++) {
    if (!isEqual(newInputs[i4], lastInputs[i4])) {
      return false;
    }
  }
  return true;
}
function memoizeOne(resultFn, isEqual22) {
  if (isEqual22 === void 0) {
    isEqual22 = areInputsEqual;
  }
  var cache = null;
  function memoized() {
    var newArgs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      newArgs[_i] = arguments[_i];
    }
    if (cache && cache.lastThis === this && isEqual22(newArgs, cache.lastArgs)) {
      return cache.lastResult;
    }
    var lastResult = resultFn.apply(this, newArgs);
    cache = {
      lastResult,
      lastArgs: newArgs,
      lastThis: this
    };
    return lastResult;
  }
  memoized.clear = function clear() {
    cache = null;
  };
  return memoized;
}
var FOCUSABLE_ELEMENTS_default = ['a[href]:not([tabindex^="-"]):not([inert]):not([aria-hidden])', 'area[href]:not([tabindex^="-"]):not([inert]):not([aria-hidden])', "input:not([disabled]):not([inert]):not([aria-hidden])", "select:not([disabled]):not([inert]):not([aria-hidden])", "textarea:not([disabled]):not([inert]):not([aria-hidden])", "button:not([disabled]):not([inert]):not([aria-hidden])", 'iframe:not([tabindex^="-"]):not([inert]):not([aria-hidden])', 'object:not([tabindex^="-"]):not([inert]):not([aria-hidden])', 'embed:not([tabindex^="-"]):not([inert]):not([aria-hidden])', '[contenteditable]:not([tabindex^="-"]):not([inert]):not([aria-hidden])', '[tabindex]:not([tabindex^="-"]):not([inert]):not([aria-hidden])'];
function getActiveOverlayEl(dashboardEl, activeOverlayType) {
  if (activeOverlayType) {
    const overlayEl = dashboardEl.querySelector(`[data-uppy-paneltype="${activeOverlayType}"]`);
    if (overlayEl)
      return overlayEl;
  }
  return dashboardEl;
}
function focusOnFirstNode(event, nodes) {
  const node682 = nodes[0];
  if (node682) {
    node682.focus();
    event.preventDefault();
  }
}
function focusOnLastNode(event, nodes) {
  const node682 = nodes[nodes.length - 1];
  if (node682) {
    node682.focus();
    event.preventDefault();
  }
}
function isFocusInOverlay(activeOverlayEl) {
  return activeOverlayEl.contains(document.activeElement);
}
function trapFocus(event, activeOverlayType, dashboardEl) {
  const activeOverlayEl = getActiveOverlayEl(dashboardEl, activeOverlayType);
  const focusableNodes = toArray_default2(activeOverlayEl.querySelectorAll(FOCUSABLE_ELEMENTS_default));
  const focusedItemIndex = focusableNodes.indexOf(document.activeElement);
  if (!isFocusInOverlay(activeOverlayEl)) {
    focusOnFirstNode(event, focusableNodes);
  } else if (event.shiftKey && focusedItemIndex === 0) {
    focusOnLastNode(event, focusableNodes);
  } else if (!event.shiftKey && focusedItemIndex === focusableNodes.length - 1) {
    focusOnFirstNode(event, focusableNodes);
  }
}
function forInline(event, activeOverlayType, dashboardEl) {
  if (activeOverlayType === null) {
  } else {
    trapFocus(event, activeOverlayType, dashboardEl);
  }
}
var import_debounce = __toESM2(require_debounce2(), 1);
function createSuperFocus() {
  let lastFocusWasOnSuperFocusableEl = false;
  const superFocus = (dashboardEl, activeOverlayType) => {
    const overlayEl = getActiveOverlayEl(dashboardEl, activeOverlayType);
    const isFocusInOverlay2 = overlayEl.contains(document.activeElement);
    if (isFocusInOverlay2 && lastFocusWasOnSuperFocusableEl)
      return;
    const superFocusableEl = overlayEl.querySelector("[data-uppy-super-focusable]");
    if (isFocusInOverlay2 && !superFocusableEl)
      return;
    if (superFocusableEl) {
      superFocusableEl.focus({
        preventScroll: true
      });
      lastFocusWasOnSuperFocusableEl = true;
    } else {
      const firstEl = overlayEl.querySelector(FOCUSABLE_ELEMENTS_default);
      firstEl == null || firstEl.focus({
        preventScroll: true
      });
      lastFocusWasOnSuperFocusableEl = false;
    }
  };
  return (0, import_debounce.default)(superFocus, 260);
}
var import_classnames12 = __toESM2(require_classnames2(), 1);
function isDragDropSupported2() {
  const div = document.body;
  if (!("draggable" in div) || !("ondragstart" in div && "ondrop" in div)) {
    return false;
  }
  if (!("FormData" in window)) {
    return false;
  }
  if (!("FileReader" in window)) {
    return false;
  }
  return true;
}
var import_classnames6 = __toESM2(require_classnames2(), 1);
var import_is_shallow_equal = __toESM2(require_is_shallow_equal(), 1);
function iconImage() {
  return y2("svg", {
    "aria-hidden": "true",
    focusable: "false",
    width: "25",
    height: "25",
    viewBox: "0 0 25 25"
  }, y2("g", {
    fill: "#686DE0",
    fillRule: "evenodd"
  }, y2("path", {
    d: "M5 7v10h15V7H5zm0-1h15a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1z",
    fillRule: "nonzero"
  }), y2("path", {
    d: "M6.35 17.172l4.994-5.026a.5.5 0 0 1 .707 0l2.16 2.16 3.505-3.505a.5.5 0 0 1 .707 0l2.336 2.31-.707.72-1.983-1.97-3.505 3.505a.5.5 0 0 1-.707 0l-2.16-2.159-3.938 3.939-1.409.026z",
    fillRule: "nonzero"
  }), y2("circle", {
    cx: "7.5",
    cy: "9.5",
    r: "1.5"
  })));
}
function iconAudio() {
  return y2("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    width: "25",
    height: "25",
    viewBox: "0 0 25 25"
  }, y2("path", {
    d: "M9.5 18.64c0 1.14-1.145 2-2.5 2s-2.5-.86-2.5-2c0-1.14 1.145-2 2.5-2 .557 0 1.079.145 1.5.396V7.25a.5.5 0 0 1 .379-.485l9-2.25A.5.5 0 0 1 18.5 5v11.64c0 1.14-1.145 2-2.5 2s-2.5-.86-2.5-2c0-1.14 1.145-2 2.5-2 .557 0 1.079.145 1.5.396V8.67l-8 2v7.97zm8-11v-2l-8 2v2l8-2zM7 19.64c.855 0 1.5-.484 1.5-1s-.645-1-1.5-1-1.5.484-1.5 1 .645 1 1.5 1zm9-2c.855 0 1.5-.484 1.5-1s-.645-1-1.5-1-1.5.484-1.5 1 .645 1 1.5 1z",
    fill: "#049BCF",
    fillRule: "nonzero"
  }));
}
function iconVideo() {
  return y2("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    width: "25",
    height: "25",
    viewBox: "0 0 25 25"
  }, y2("path", {
    d: "M16 11.834l4.486-2.691A1 1 0 0 1 22 10v6a1 1 0 0 1-1.514.857L16 14.167V17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2.834zM15 9H5v8h10V9zm1 4l5 3v-6l-5 3z",
    fill: "#19AF67",
    fillRule: "nonzero"
  }));
}
function iconPDF() {
  return y2("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    width: "25",
    height: "25",
    viewBox: "0 0 25 25"
  }, y2("path", {
    d: "M9.766 8.295c-.691-1.843-.539-3.401.747-3.726 1.643-.414 2.505.938 2.39 3.299-.039.79-.194 1.662-.537 3.148.324.49.66.967 1.055 1.51.17.231.382.488.629.757 1.866-.128 3.653.114 4.918.655 1.487.635 2.192 1.685 1.614 2.84-.566 1.133-1.839 1.084-3.416.249-1.141-.604-2.457-1.634-3.51-2.707a13.467 13.467 0 0 0-2.238.426c-1.392 4.051-4.534 6.453-5.707 4.572-.986-1.58 1.38-4.206 4.914-5.375.097-.322.185-.656.264-1.001.08-.353.306-1.31.407-1.737-.678-1.059-1.2-2.031-1.53-2.91zm2.098 4.87c-.033.144-.068.287-.104.427l.033-.01-.012.038a14.065 14.065 0 0 1 1.02-.197l-.032-.033.052-.004a7.902 7.902 0 0 1-.208-.271c-.197-.27-.38-.526-.555-.775l-.006.028-.002-.003c-.076.323-.148.632-.186.8zm5.77 2.978c1.143.605 1.832.632 2.054.187.26-.519-.087-1.034-1.113-1.473-.911-.39-2.175-.608-3.55-.608.845.766 1.787 1.459 2.609 1.894zM6.559 18.789c.14.223.693.16 1.425-.413.827-.648 1.61-1.747 2.208-3.206-2.563 1.064-4.102 2.867-3.633 3.62zm5.345-10.97c.088-1.793-.351-2.48-1.146-2.28-.473.119-.564 1.05-.056 2.405.213.566.52 1.188.908 1.859.18-.858.268-1.453.294-1.984z",
    fill: "#E2514A",
    fillRule: "nonzero"
  }));
}
function iconArchive() {
  return y2("svg", {
    "aria-hidden": "true",
    focusable: "false",
    width: "25",
    height: "25",
    viewBox: "0 0 25 25"
  }, y2("path", {
    d: "M10.45 2.05h1.05a.5.5 0 0 1 .5.5v.024a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5V2.55a.5.5 0 0 1 .5-.5zm2.05 1.024h1.05a.5.5 0 0 1 .5.5V3.6a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5v-.001zM10.45 0h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5V.5a.5.5 0 0 1 .5-.5zm2.05 1.025h1.05a.5.5 0 0 1 .5.5v.024a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.024a.5.5 0 0 1 .5-.5zm-2.05 3.074h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5zm2.05 1.025h1.05a.5.5 0 0 1 .5.5v.024a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.024a.5.5 0 0 1 .5-.5zm-2.05 1.024h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5zm2.05 1.025h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5zm-2.05 1.025h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5zm2.05 1.025h1.05a.5.5 0 0 1 .5.5v.024a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.024a.5.5 0 0 1 .5-.5zm-1.656 3.074l-.82 5.946c.52.302 1.174.458 1.976.458.803 0 1.455-.156 1.975-.458l-.82-5.946h-2.311zm0-1.025h2.312c.512 0 .946.378 1.015.885l.82 5.946c.056.412-.142.817-.501 1.026-.686.398-1.515.597-2.49.597-.974 0-1.804-.199-2.49-.597a1.025 1.025 0 0 1-.5-1.026l.819-5.946c.07-.507.503-.885 1.015-.885zm.545 6.6a.5.5 0 0 1-.397-.561l.143-.999a.5.5 0 0 1 .495-.429h.74a.5.5 0 0 1 .495.43l.143.998a.5.5 0 0 1-.397.561c-.404.08-.819.08-1.222 0z",
    fill: "#00C469",
    fillRule: "nonzero"
  }));
}
function iconFile() {
  return y2("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    width: "25",
    height: "25",
    viewBox: "0 0 25 25"
  }, y2("g", {
    fill: "#A7AFB7",
    fillRule: "nonzero"
  }, y2("path", {
    d: "M5.5 22a.5.5 0 0 1-.5-.5v-18a.5.5 0 0 1 .5-.5h10.719a.5.5 0 0 1 .367.16l3.281 3.556a.5.5 0 0 1 .133.339V21.5a.5.5 0 0 1-.5.5h-14zm.5-1h13V7.25L16 4H6v17z"
  }), y2("path", {
    d: "M15 4v3a1 1 0 0 0 1 1h3V7h-3V4h-1z"
  })));
}
function iconText() {
  return y2("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    width: "25",
    height: "25",
    viewBox: "0 0 25 25"
  }, y2("path", {
    d: "M4.5 7h13a.5.5 0 1 1 0 1h-13a.5.5 0 0 1 0-1zm0 3h15a.5.5 0 1 1 0 1h-15a.5.5 0 1 1 0-1zm0 3h15a.5.5 0 1 1 0 1h-15a.5.5 0 1 1 0-1zm0 3h10a.5.5 0 1 1 0 1h-10a.5.5 0 1 1 0-1z",
    fill: "#5A5E69",
    fillRule: "nonzero"
  }));
}
function getIconByMime(fileType) {
  const defaultChoice = {
    color: "#838999",
    icon: iconFile()
  };
  if (!fileType)
    return defaultChoice;
  const fileTypeGeneral = fileType.split("/")[0];
  const fileTypeSpecific = fileType.split("/")[1];
  if (fileTypeGeneral === "text") {
    return {
      color: "#5a5e69",
      icon: iconText()
    };
  }
  if (fileTypeGeneral === "image") {
    return {
      color: "#686de0",
      icon: iconImage()
    };
  }
  if (fileTypeGeneral === "audio") {
    return {
      color: "#068dbb",
      icon: iconAudio()
    };
  }
  if (fileTypeGeneral === "video") {
    return {
      color: "#19af67",
      icon: iconVideo()
    };
  }
  if (fileTypeGeneral === "application" && fileTypeSpecific === "pdf") {
    return {
      color: "#e25149",
      icon: iconPDF()
    };
  }
  const archiveTypes = ["zip", "x-7z-compressed", "x-rar-compressed", "x-tar", "x-gzip", "x-apple-diskimage"];
  if (fileTypeGeneral === "application" && archiveTypes.indexOf(fileTypeSpecific) !== -1) {
    return {
      color: "#00C469",
      icon: iconArchive()
    };
  }
  return defaultChoice;
}
function FilePreview(props) {
  const {
    file
  } = props;
  if (file.preview) {
    return y2("img", {
      className: "uppy-Dashboard-Item-previewImg",
      alt: file.name,
      src: file.preview
    });
  }
  const {
    color: color2,
    icon
  } = getIconByMime(file.type);
  return y2("div", {
    className: "uppy-Dashboard-Item-previewIconWrap"
  }, y2("span", {
    className: "uppy-Dashboard-Item-previewIcon",
    style: {
      color: color2
    }
  }, icon), y2("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-Dashboard-Item-previewIconBg",
    width: "58",
    height: "76",
    viewBox: "0 0 58 76"
  }, y2("rect", {
    fill: "#FFF",
    width: "58",
    height: "76",
    rx: "3",
    fillRule: "evenodd"
  })));
}
var metaFieldIdToName = (metaFieldId, metaFields22) => {
  const fields = typeof metaFields22 === "function" ? metaFields22() : metaFields22;
  const field = fields.filter((f4) => f4.id === metaFieldId);
  return field[0].name;
};
function renderMissingMetaFieldsError(props) {
  const {
    file,
    toggleFileCard,
    i18n,
    metaFields: metaFields22
  } = props;
  const {
    missingRequiredMetaFields
  } = file;
  if (!(missingRequiredMetaFields != null && missingRequiredMetaFields.length)) {
    return null;
  }
  const metaFieldsString = missingRequiredMetaFields.map((missingMetaField) => metaFieldIdToName(missingMetaField, metaFields22)).join(", ");
  return y2("div", {
    className: "uppy-Dashboard-Item-errorMessage"
  }, i18n("missingRequiredMetaFields", {
    smart_count: missingRequiredMetaFields.length,
    fields: metaFieldsString
  }), " ", y2("button", {
    type: "button",
    class: "uppy-u-reset uppy-Dashboard-Item-errorMessageBtn",
    onClick: () => toggleFileCard(true, file.id)
  }, i18n("editFile")));
}
function FilePreviewAndLink(props) {
  const {
    file,
    i18n,
    toggleFileCard,
    metaFields: metaFields22,
    showLinkToFileUploadResult
  } = props;
  const white = "rgba(255, 255, 255, 0.5)";
  const previewBackgroundColor = file.preview ? white : getIconByMime(props.file.type).color;
  return y2("div", {
    className: "uppy-Dashboard-Item-previewInnerWrap",
    style: {
      backgroundColor: previewBackgroundColor
    }
  }, showLinkToFileUploadResult && file.uploadURL && y2("a", {
    className: "uppy-Dashboard-Item-previewLink",
    href: file.uploadURL,
    rel: "noreferrer noopener",
    target: "_blank",
    "aria-label": file.meta.name
  }, y2("span", {
    hidden: true
  }, file.meta.name)), y2(FilePreview, {
    file
  }), y2(renderMissingMetaFieldsError, {
    file,
    i18n,
    toggleFileCard,
    metaFields: metaFields22
  }));
}
function onPauseResumeCancelRetry(props) {
  if (props.isUploaded)
    return;
  if (props.error && !props.hideRetryButton) {
    props.uppy.retryUpload(props.file.id);
    return;
  }
  if (props.resumableUploads && !props.hidePauseResumeButton) {
    props.uppy.pauseResume(props.file.id);
  } else if (props.individualCancellation && !props.hideCancelButton) {
    props.uppy.removeFile(props.file.id);
  }
}
function progressIndicatorTitle(props) {
  if (props.isUploaded) {
    return props.i18n("uploadComplete");
  }
  if (props.error) {
    return props.i18n("retryUpload");
  }
  if (props.resumableUploads) {
    if (props.file.isPaused) {
      return props.i18n("resumeUpload");
    }
    return props.i18n("pauseUpload");
  }
  if (props.individualCancellation) {
    return props.i18n("cancelUpload");
  }
  return "";
}
function ProgressIndicatorButton(props) {
  return y2("div", {
    className: "uppy-Dashboard-Item-progress"
  }, y2("button", {
    className: "uppy-u-reset uppy-c-btn uppy-Dashboard-Item-progressIndicator",
    type: "button",
    "aria-label": progressIndicatorTitle(props),
    title: progressIndicatorTitle(props),
    onClick: () => onPauseResumeCancelRetry(props)
  }, props.children));
}
function ProgressCircleContainer(_ref) {
  let {
    children
  } = _ref;
  return y2("svg", {
    "aria-hidden": "true",
    focusable: "false",
    width: "70",
    height: "70",
    viewBox: "0 0 36 36",
    className: "uppy-c-icon uppy-Dashboard-Item-progressIcon--circle"
  }, children);
}
function ProgressCircle(_ref2) {
  let {
    progress: progress2
  } = _ref2;
  const circleLength = 2 * Math.PI * 15;
  return y2("g", null, y2("circle", {
    className: "uppy-Dashboard-Item-progressIcon--bg",
    r: "15",
    cx: "18",
    cy: "18",
    "stroke-width": "2",
    fill: "none"
  }), y2("circle", {
    className: "uppy-Dashboard-Item-progressIcon--progress",
    r: "15",
    cx: "18",
    cy: "18",
    transform: "rotate(-90, 18, 18)",
    fill: "none",
    "stroke-width": "2",
    "stroke-dasharray": circleLength,
    "stroke-dashoffset": circleLength - circleLength / 100 * progress2
  }));
}
function FileProgress(props) {
  if (!props.file.progress.uploadStarted) {
    return null;
  }
  if (props.isUploaded) {
    return y2("div", {
      className: "uppy-Dashboard-Item-progress"
    }, y2("div", {
      className: "uppy-Dashboard-Item-progressIndicator"
    }, y2(ProgressCircleContainer, null, y2("circle", {
      r: "15",
      cx: "18",
      cy: "18",
      fill: "#1bb240"
    }), y2("polygon", {
      className: "uppy-Dashboard-Item-progressIcon--check",
      transform: "translate(2, 3)",
      points: "14 22.5 7 15.2457065 8.99985857 13.1732815 14 18.3547104 22.9729883 9 25 11.1005634"
    }))));
  }
  if (props.recoveredState) {
    return void 0;
  }
  if (props.error && !props.hideRetryButton) {
    return (
      // eslint-disable-next-line react/jsx-props-no-spreading
      y2(ProgressIndicatorButton, props, y2("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon uppy-Dashboard-Item-progressIcon--retry",
        width: "28",
        height: "31",
        viewBox: "0 0 16 19"
      }, y2("path", {
        d: "M16 11a8 8 0 1 1-8-8v2a6 6 0 1 0 6 6h2z"
      }), y2("path", {
        d: "M7.9 3H10v2H7.9z"
      }), y2("path", {
        d: "M8.536.5l3.535 3.536-1.414 1.414L7.12 1.914z"
      }), y2("path", {
        d: "M10.657 2.621l1.414 1.415L8.536 7.57 7.12 6.157z"
      })))
    );
  }
  if (props.resumableUploads && !props.hidePauseResumeButton) {
    return (
      // eslint-disable-next-line react/jsx-props-no-spreading
      y2(ProgressIndicatorButton, props, y2(ProgressCircleContainer, null, y2(ProgressCircle, {
        progress: props.file.progress.percentage
      }), props.file.isPaused ? y2("polygon", {
        className: "uppy-Dashboard-Item-progressIcon--play",
        transform: "translate(3, 3)",
        points: "12 20 12 10 20 15"
      }) : y2("g", {
        className: "uppy-Dashboard-Item-progressIcon--pause",
        transform: "translate(14.5, 13)"
      }, y2("rect", {
        x: "0",
        y: "0",
        width: "2",
        height: "10",
        rx: "0"
      }), y2("rect", {
        x: "5",
        y: "0",
        width: "2",
        height: "10",
        rx: "0"
      }))))
    );
  }
  if (!props.resumableUploads && props.individualCancellation && !props.hideCancelButton) {
    return (
      // eslint-disable-next-line react/jsx-props-no-spreading
      y2(ProgressIndicatorButton, props, y2(ProgressCircleContainer, null, y2(ProgressCircle, {
        progress: props.file.progress.percentage
      }), y2("polygon", {
        className: "cancel",
        transform: "translate(2, 2)",
        points: "19.8856516 11.0625 16 14.9481516 12.1019737 11.0625 11.0625 12.1143484 14.9481516 16 11.0625 19.8980263 12.1019737 20.9375 16 17.0518484 19.8856516 20.9375 20.9375 19.8980263 17.0518484 16 20.9375 12"
      })))
    );
  }
  return y2("div", {
    className: "uppy-Dashboard-Item-progress"
  }, y2("div", {
    className: "uppy-Dashboard-Item-progressIndicator"
  }, y2(ProgressCircleContainer, null, y2(ProgressCircle, {
    progress: props.file.progress.percentage
  }))));
}
var import_prettier_bytes3 = __toESM2(require_prettierBytes2(), 1);
var separator = "...";
function truncateString(string102, maxLength) {
  if (maxLength === 0)
    return "";
  if (string102.length <= maxLength)
    return string102;
  if (maxLength <= separator.length + 1)
    return `${string102.slice(0, maxLength - 1)}\u2026`;
  const charsToShow = maxLength - separator.length;
  const frontChars = Math.ceil(charsToShow / 2);
  const backChars = Math.floor(charsToShow / 2);
  return string102.slice(0, frontChars) + separator + string102.slice(-backChars);
}
var renderFileName = (props) => {
  const {
    author,
    name
  } = props.file.meta;
  function getMaxNameLength() {
    if (props.isSingleFile && props.containerHeight >= 350) {
      return 90;
    }
    if (props.containerWidth <= 352) {
      return 35;
    }
    if (props.containerWidth <= 576) {
      return 60;
    }
    return author ? 20 : 30;
  }
  return y2("div", {
    className: "uppy-Dashboard-Item-name",
    title: name
  }, truncateString(name, getMaxNameLength()));
};
var renderAuthor = (props) => {
  var _props$file$remote;
  const {
    author
  } = props.file.meta;
  const providerName = (_props$file$remote = props.file.remote) == null ? void 0 : _props$file$remote.providerName;
  const dot = `\xB7`;
  if (!author) {
    return null;
  }
  return y2("div", {
    className: "uppy-Dashboard-Item-author"
  }, y2("a", {
    href: `${author.url}?utm_source=Companion&utm_medium=referral`,
    target: "_blank",
    rel: "noopener noreferrer"
  }, truncateString(author.name, 13)), providerName ? y2(g2, null, ` ${dot} `, providerName, ` ${dot} `) : null);
};
var renderFileSize = (props) => props.file.size && y2("div", {
  className: "uppy-Dashboard-Item-statusSize"
}, (0, import_prettier_bytes3.default)(props.file.size));
var ReSelectButton = (props) => props.file.isGhost && y2("span", null, " \u2022 ", y2("button", {
  className: "uppy-u-reset uppy-c-btn uppy-Dashboard-Item-reSelect",
  type: "button",
  onClick: props.toggleAddFilesPanel
}, props.i18n("reSelect")));
var ErrorButton = (_ref) => {
  let {
    file,
    onClick
  } = _ref;
  if (file.error) {
    return y2("button", {
      className: "uppy-u-reset uppy-c-btn uppy-Dashboard-Item-errorDetails",
      "aria-label": file.error,
      "data-microtip-position": "bottom",
      "data-microtip-size": "medium",
      onClick,
      type: "button"
    }, "?");
  }
  return null;
};
function FileInfo(props) {
  const {
    file
  } = props;
  return y2("div", {
    className: "uppy-Dashboard-Item-fileInfo",
    "data-uppy-file-source": file.source
  }, y2("div", {
    className: "uppy-Dashboard-Item-fileName"
  }, renderFileName(props), y2(ErrorButton, {
    file: props.file,
    onClick: () => alert(props.file.error)
    // TODO: move to a custom alert implementation
  })), y2("div", {
    className: "uppy-Dashboard-Item-status"
  }, renderAuthor(props), renderFileSize(props), ReSelectButton(props)), y2(renderMissingMetaFieldsError, {
    file: props.file,
    i18n: props.i18n,
    toggleFileCard: props.toggleFileCard,
    metaFields: props.metaFields
  }));
}
function copyToClipboard(textToCopy, fallbackString) {
  if (fallbackString === void 0) {
    fallbackString = "Copy the URL below";
  }
  return new Promise((resolve) => {
    const textArea = document.createElement("textarea");
    textArea.setAttribute("style", {
      position: "fixed",
      top: 0,
      left: 0,
      width: "2em",
      height: "2em",
      padding: 0,
      border: "none",
      outline: "none",
      boxShadow: "none",
      background: "transparent"
    });
    textArea.value = textToCopy;
    document.body.appendChild(textArea);
    textArea.select();
    const magicCopyFailed = () => {
      document.body.removeChild(textArea);
      window.prompt(fallbackString, textToCopy);
      resolve();
    };
    try {
      const successful = document.execCommand("copy");
      if (!successful) {
        return magicCopyFailed("copy command unavailable");
      }
      document.body.removeChild(textArea);
      return resolve();
    } catch (err) {
      document.body.removeChild(textArea);
      return magicCopyFailed(err);
    }
  });
}
function EditButton(_ref) {
  let {
    file,
    uploadInProgressOrComplete,
    metaFields: metaFields22,
    canEditFile,
    i18n,
    onClick
  } = _ref;
  if (!uploadInProgressOrComplete && metaFields22 && metaFields22.length > 0 || !uploadInProgressOrComplete && canEditFile(file)) {
    return y2("button", {
      className: "uppy-u-reset uppy-c-btn uppy-Dashboard-Item-action uppy-Dashboard-Item-action--edit",
      type: "button",
      "aria-label": i18n("editFileWithFilename", {
        file: file.meta.name
      }),
      title: i18n("editFileWithFilename", {
        file: file.meta.name
      }),
      onClick: () => onClick()
    }, y2("svg", {
      "aria-hidden": "true",
      focusable: "false",
      className: "uppy-c-icon",
      width: "14",
      height: "14",
      viewBox: "0 0 14 14"
    }, y2("g", {
      fillRule: "evenodd"
    }, y2("path", {
      d: "M1.5 10.793h2.793A1 1 0 0 0 5 10.5L11.5 4a1 1 0 0 0 0-1.414L9.707.793a1 1 0 0 0-1.414 0l-6.5 6.5A1 1 0 0 0 1.5 8v2.793zm1-1V8L9 1.5l1.793 1.793-6.5 6.5H2.5z",
      fillRule: "nonzero"
    }), y2("rect", {
      x: "1",
      y: "12.293",
      width: "11",
      height: "1",
      rx: ".5"
    }), y2("path", {
      fillRule: "nonzero",
      d: "M6.793 2.5L9.5 5.207l.707-.707L7.5 1.793z"
    }))));
  }
  return null;
}
function RemoveButton(_ref2) {
  let {
    i18n,
    onClick,
    file
  } = _ref2;
  return y2("button", {
    className: "uppy-u-reset uppy-Dashboard-Item-action uppy-Dashboard-Item-action--remove",
    type: "button",
    "aria-label": i18n("removeFile", {
      file: file.meta.name
    }),
    title: i18n("removeFile", {
      file: file.meta.name
    }),
    onClick: () => onClick()
  }, y2("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    width: "18",
    height: "18",
    viewBox: "0 0 18 18"
  }, y2("path", {
    d: "M9 0C4.034 0 0 4.034 0 9s4.034 9 9 9 9-4.034 9-9-4.034-9-9-9z"
  }), y2("path", {
    fill: "#FFF",
    d: "M13 12.222l-.778.778L9 9.778 5.778 13 5 12.222 8.222 9 5 5.778 5.778 5 9 8.222 12.222 5l.778.778L9.778 9z"
  })));
}
var copyLinkToClipboard = (event, props) => {
  copyToClipboard(props.file.uploadURL, props.i18n("copyLinkToClipboardFallback")).then(() => {
    props.uppy.log("Link copied to clipboard.");
    props.uppy.info(props.i18n("copyLinkToClipboardSuccess"), "info", 3e3);
  }).catch(props.uppy.log).then(() => event.target.focus({
    preventScroll: true
  }));
};
function CopyLinkButton(props) {
  const {
    i18n
  } = props;
  return y2("button", {
    className: "uppy-u-reset uppy-Dashboard-Item-action uppy-Dashboard-Item-action--copyLink",
    type: "button",
    "aria-label": i18n("copyLink"),
    title: i18n("copyLink"),
    onClick: (event) => copyLinkToClipboard(event, props)
  }, y2("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    width: "14",
    height: "14",
    viewBox: "0 0 14 12"
  }, y2("path", {
    d: "M7.94 7.703a2.613 2.613 0 0 1-.626 2.681l-.852.851a2.597 2.597 0 0 1-1.849.766A2.616 2.616 0 0 1 2.764 7.54l.852-.852a2.596 2.596 0 0 1 2.69-.625L5.267 7.099a1.44 1.44 0 0 0-.833.407l-.852.851a1.458 1.458 0 0 0 1.03 2.486c.39 0 .755-.152 1.03-.426l.852-.852c.231-.231.363-.522.406-.824l1.04-1.038zm4.295-5.937A2.596 2.596 0 0 0 10.387 1c-.698 0-1.355.272-1.849.766l-.852.851a2.614 2.614 0 0 0-.624 2.688l1.036-1.036c.041-.304.173-.6.407-.833l.852-.852c.275-.275.64-.426 1.03-.426a1.458 1.458 0 0 1 1.03 2.486l-.852.851a1.442 1.442 0 0 1-.824.406l-1.04 1.04a2.596 2.596 0 0 0 2.683-.628l.851-.85a2.616 2.616 0 0 0 0-3.697zm-6.88 6.883a.577.577 0 0 0 .82 0l3.474-3.474a.579.579 0 1 0-.819-.82L5.355 7.83a.579.579 0 0 0 0 .819z"
  })));
}
function Buttons(props) {
  const {
    uppy: uppy22,
    file,
    uploadInProgressOrComplete,
    canEditFile,
    metaFields: metaFields22,
    showLinkToFileUploadResult,
    showRemoveButton,
    i18n,
    toggleFileCard,
    openFileEditor
  } = props;
  const editAction = () => {
    if (metaFields22 && metaFields22.length > 0) {
      toggleFileCard(true, file.id);
    } else {
      openFileEditor(file);
    }
  };
  return y2("div", {
    className: "uppy-Dashboard-Item-actionWrapper"
  }, y2(EditButton, {
    i18n,
    file,
    uploadInProgressOrComplete,
    canEditFile,
    metaFields: metaFields22,
    onClick: editAction
  }), showLinkToFileUploadResult && file.uploadURL ? y2(CopyLinkButton, {
    file,
    uppy: uppy22,
    i18n
  }) : null, showRemoveButton ? y2(RemoveButton, {
    i18n,
    file,
    uppy: uppy22,
    onClick: () => props.uppy.removeFile(file.id, "removed-by-user")
  }) : null);
}
var FileItem = class extends b2 {
  componentDidMount() {
    const {
      file
    } = this.props;
    if (!file.preview) {
      this.props.handleRequestThumbnail(file);
    }
  }
  shouldComponentUpdate(nextProps) {
    return !(0, import_is_shallow_equal.default)(this.props, nextProps);
  }
  // VirtualList mounts FileItems again and they emit `thumbnail:request`
  // Otherwise thumbnails are broken or missing after Golden Retriever restores files
  componentDidUpdate() {
    const {
      file
    } = this.props;
    if (!file.preview) {
      this.props.handleRequestThumbnail(file);
    }
  }
  componentWillUnmount() {
    const {
      file
    } = this.props;
    if (!file.preview) {
      this.props.handleCancelThumbnail(file);
    }
  }
  render() {
    const {
      file
    } = this.props;
    const isProcessing = file.progress.preprocess || file.progress.postprocess;
    const isUploaded = file.progress.uploadComplete && !isProcessing && !file.error;
    const uploadInProgressOrComplete = file.progress.uploadStarted || isProcessing;
    const uploadInProgress = file.progress.uploadStarted && !file.progress.uploadComplete || isProcessing;
    const error = file.error || false;
    const {
      isGhost
    } = file;
    let showRemoveButton = this.props.individualCancellation ? !isUploaded : !uploadInProgress && !isUploaded;
    if (isUploaded && this.props.showRemoveButtonAfterComplete) {
      showRemoveButton = true;
    }
    const dashboardItemClass = (0, import_classnames6.default)({
      "uppy-Dashboard-Item": true,
      "is-inprogress": uploadInProgress && !this.props.recoveredState,
      "is-processing": isProcessing,
      "is-complete": isUploaded,
      "is-error": !!error,
      "is-resumable": this.props.resumableUploads,
      "is-noIndividualCancellation": !this.props.individualCancellation,
      "is-ghost": isGhost
    });
    return y2("div", {
      className: dashboardItemClass,
      id: `uppy_${file.id}`,
      role: this.props.role
    }, y2("div", {
      className: "uppy-Dashboard-Item-preview"
    }, y2(FilePreviewAndLink, {
      file,
      showLinkToFileUploadResult: this.props.showLinkToFileUploadResult,
      i18n: this.props.i18n,
      toggleFileCard: this.props.toggleFileCard,
      metaFields: this.props.metaFields
    }), y2(FileProgress, {
      uppy: this.props.uppy,
      file,
      error,
      isUploaded,
      hideRetryButton: this.props.hideRetryButton,
      hideCancelButton: this.props.hideCancelButton,
      hidePauseResumeButton: this.props.hidePauseResumeButton,
      recoveredState: this.props.recoveredState,
      showRemoveButtonAfterComplete: this.props.showRemoveButtonAfterComplete,
      resumableUploads: this.props.resumableUploads,
      individualCancellation: this.props.individualCancellation,
      i18n: this.props.i18n
    })), y2("div", {
      className: "uppy-Dashboard-Item-fileInfoAndButtons"
    }, y2(FileInfo, {
      file,
      id: this.props.id,
      acquirers: this.props.acquirers,
      containerWidth: this.props.containerWidth,
      containerHeight: this.props.containerHeight,
      i18n: this.props.i18n,
      toggleAddFilesPanel: this.props.toggleAddFilesPanel,
      toggleFileCard: this.props.toggleFileCard,
      metaFields: this.props.metaFields,
      isSingleFile: this.props.isSingleFile
    }), y2(Buttons, {
      file,
      metaFields: this.props.metaFields,
      showLinkToFileUploadResult: this.props.showLinkToFileUploadResult,
      showRemoveButton,
      canEditFile: this.props.canEditFile,
      uploadInProgressOrComplete,
      toggleFileCard: this.props.toggleFileCard,
      openFileEditor: this.props.openFileEditor,
      uppy: this.props.uppy,
      i18n: this.props.i18n
    })));
  }
};
function chunks(list2, size) {
  const chunked = [];
  let currentChunk = [];
  list2.forEach((item) => {
    if (currentChunk.length < size) {
      currentChunk.push(item);
    } else {
      chunked.push(currentChunk);
      currentChunk = [item];
    }
  });
  if (currentChunk.length)
    chunked.push(currentChunk);
  return chunked;
}
var FileList_default = (_ref) => {
  let {
    id: id18,
    error,
    i18n,
    uppy: uppy22,
    files,
    acquirers,
    resumableUploads,
    hideRetryButton,
    hidePauseResumeButton,
    hideCancelButton,
    showLinkToFileUploadResult,
    showRemoveButtonAfterComplete,
    isWide,
    metaFields: metaFields22,
    isSingleFile,
    toggleFileCard,
    handleRequestThumbnail,
    handleCancelThumbnail,
    recoveredState,
    individualCancellation,
    itemsPerRow,
    openFileEditor,
    canEditFile,
    toggleAddFilesPanel,
    containerWidth,
    containerHeight
  } = _ref;
  const rowHeight = itemsPerRow === 1 ? 71 : 200;
  const rows = q3(() => {
    const sortByGhostComesFirst = (file1, file2) => files[file2].isGhost - files[file1].isGhost;
    const fileIds = Object.keys(files);
    if (recoveredState)
      fileIds.sort(sortByGhostComesFirst);
    return chunks(fileIds, itemsPerRow);
  }, [files, itemsPerRow, recoveredState]);
  const renderRow = (row) => (
    // The `role="presentation` attribute ensures that the list items are properly
    // associated with the `VirtualList` element.
    // We use the first file ID as the key—this should not change across scroll rerenders
    y2("div", {
      class: "uppy-Dashboard-filesInner",
      role: "presentation",
      key: row[0]
    }, row.map((fileID) => y2(FileItem, {
      key: fileID,
      uppy: uppy22,
      id: id18,
      error,
      i18n,
      acquirers,
      resumableUploads,
      individualCancellation,
      hideRetryButton,
      hidePauseResumeButton,
      hideCancelButton,
      showLinkToFileUploadResult,
      showRemoveButtonAfterComplete,
      isWide,
      metaFields: metaFields22,
      recoveredState,
      isSingleFile,
      containerWidth,
      containerHeight,
      toggleFileCard,
      handleRequestThumbnail,
      handleCancelThumbnail,
      role: "listitem",
      openFileEditor,
      canEditFile,
      toggleAddFilesPanel,
      file: files[fileID]
    })))
  );
  if (isSingleFile) {
    return y2("div", {
      class: "uppy-Dashboard-files"
    }, renderRow(rows[0]));
  }
  return y2(VirtualList_default, {
    class: "uppy-Dashboard-files",
    role: "list",
    data: rows,
    renderRow,
    rowHeight
  });
};
var _Symbol$for6;
_Symbol$for6 = Symbol.for("uppy test: disable unused locale key warning");
var AddFiles = class extends b2 {
  constructor() {
    super(...arguments);
    this.triggerFileInputClick = () => {
      this.fileInput.click();
    };
    this.triggerFolderInputClick = () => {
      this.folderInput.click();
    };
    this.triggerVideoCameraInputClick = () => {
      this.mobileVideoFileInput.click();
    };
    this.triggerPhotoCameraInputClick = () => {
      this.mobilePhotoFileInput.click();
    };
    this.onFileInputChange = (event) => {
      this.props.handleInputChange(event);
      event.target.value = null;
    };
    this.renderHiddenInput = (isFolder, refCallback) => {
      return y2("input", {
        className: "uppy-Dashboard-input",
        hidden: true,
        "aria-hidden": "true",
        tabIndex: -1,
        webkitdirectory: isFolder,
        type: "file",
        name: "files[]",
        multiple: this.props.maxNumberOfFiles !== 1,
        onChange: this.onFileInputChange,
        accept: this.props.allowedFileTypes,
        ref: refCallback
      });
    };
    this.renderHiddenCameraInput = (type, nativeCameraFacingMode, refCallback) => {
      const typeToAccept = {
        photo: "image/*",
        video: "video/*"
      };
      const accept = typeToAccept[type];
      return y2("input", {
        className: "uppy-Dashboard-input",
        hidden: true,
        "aria-hidden": "true",
        tabIndex: -1,
        type: "file",
        name: `camera-${type}`,
        onChange: this.onFileInputChange,
        capture: nativeCameraFacingMode,
        accept,
        ref: refCallback
      });
    };
    this.renderMyDeviceAcquirer = () => {
      return y2("div", {
        className: "uppy-DashboardTab",
        role: "presentation",
        "data-uppy-acquirer-id": "MyDevice"
      }, y2("button", {
        type: "button",
        className: "uppy-u-reset uppy-c-btn uppy-DashboardTab-btn",
        role: "tab",
        tabIndex: 0,
        "data-uppy-super-focusable": true,
        onClick: this.triggerFileInputClick
      }, y2("div", {
        className: "uppy-DashboardTab-inner"
      }, y2("svg", {
        className: "uppy-DashboardTab-iconMyDevice",
        "aria-hidden": "true",
        focusable: "false",
        width: "32",
        height: "32",
        viewBox: "0 0 32 32"
      }, y2("path", {
        d: "M8.45 22.087l-1.305-6.674h17.678l-1.572 6.674H8.45zm4.975-12.412l1.083 1.765a.823.823 0 00.715.386h7.951V13.5H8.587V9.675h4.838zM26.043 13.5h-1.195v-2.598c0-.463-.336-.75-.798-.75h-8.356l-1.082-1.766A.823.823 0 0013.897 8H7.728c-.462 0-.815.256-.815.718V13.5h-.956a.97.97 0 00-.746.37.972.972 0 00-.19.81l1.724 8.565c.095.44.484.755.933.755H24c.44 0 .824-.3.929-.727l2.043-8.568a.972.972 0 00-.176-.825.967.967 0 00-.753-.38z",
        fill: "currentcolor",
        "fill-rule": "evenodd"
      }))), y2("div", {
        className: "uppy-DashboardTab-name"
      }, this.props.i18n("myDevice"))));
    };
    this.renderPhotoCamera = () => {
      return y2("div", {
        className: "uppy-DashboardTab",
        role: "presentation",
        "data-uppy-acquirer-id": "MobilePhotoCamera"
      }, y2("button", {
        type: "button",
        className: "uppy-u-reset uppy-c-btn uppy-DashboardTab-btn",
        role: "tab",
        tabIndex: 0,
        "data-uppy-super-focusable": true,
        onClick: this.triggerPhotoCameraInputClick
      }, y2("div", {
        className: "uppy-DashboardTab-inner"
      }, y2("svg", {
        "aria-hidden": "true",
        focusable: "false",
        width: "32",
        height: "32",
        viewBox: "0 0 32 32"
      }, y2("path", {
        d: "M23.5 9.5c1.417 0 2.5 1.083 2.5 2.5v9.167c0 1.416-1.083 2.5-2.5 2.5h-15c-1.417 0-2.5-1.084-2.5-2.5V12c0-1.417 1.083-2.5 2.5-2.5h2.917l1.416-2.167C13 7.167 13.25 7 13.5 7h5c.25 0 .5.167.667.333L20.583 9.5H23.5zM16 11.417a4.706 4.706 0 00-4.75 4.75 4.704 4.704 0 004.75 4.75 4.703 4.703 0 004.75-4.75c0-2.663-2.09-4.75-4.75-4.75zm0 7.825c-1.744 0-3.076-1.332-3.076-3.074 0-1.745 1.333-3.077 3.076-3.077 1.744 0 3.074 1.333 3.074 3.076s-1.33 3.075-3.074 3.075z",
        fill: "#02B383",
        "fill-rule": "nonzero"
      }))), y2("div", {
        className: "uppy-DashboardTab-name"
      }, this.props.i18n("takePictureBtn"))));
    };
    this.renderVideoCamera = () => {
      return y2("div", {
        className: "uppy-DashboardTab",
        role: "presentation",
        "data-uppy-acquirer-id": "MobileVideoCamera"
      }, y2("button", {
        type: "button",
        className: "uppy-u-reset uppy-c-btn uppy-DashboardTab-btn",
        role: "tab",
        tabIndex: 0,
        "data-uppy-super-focusable": true,
        onClick: this.triggerVideoCameraInputClick
      }, y2("div", {
        className: "uppy-DashboardTab-inner"
      }, y2("svg", {
        "aria-hidden": "true",
        width: "32",
        height: "32",
        viewBox: "0 0 32 32"
      }, y2("path", {
        fill: "#FF675E",
        fillRule: "nonzero",
        d: "m21.254 14.277 2.941-2.588c.797-.313 1.243.818 1.09 1.554-.01 2.094.02 4.189-.017 6.282-.126.915-1.145 1.08-1.58.34l-2.434-2.142c-.192.287-.504 1.305-.738.468-.104-1.293-.028-2.596-.05-3.894.047-.312.381.823.426 1.069.063-.384.206-.744.362-1.09zm-12.939-3.73c3.858.013 7.717-.025 11.574.02.912.129 1.492 1.237 1.351 2.217-.019 2.412.04 4.83-.03 7.239-.17 1.025-1.166 1.59-2.029 1.429-3.705-.012-7.41.025-11.114-.019-.913-.129-1.492-1.237-1.352-2.217.018-2.404-.036-4.813.029-7.214.136-.82.83-1.473 1.571-1.454z "
      }))), y2("div", {
        className: "uppy-DashboardTab-name"
      }, this.props.i18n("recordVideoBtn"))));
    };
    this.renderBrowseButton = (text, onClickFn) => {
      const numberOfAcquirers = this.props.acquirers.length;
      return y2("button", {
        type: "button",
        className: "uppy-u-reset uppy-c-btn uppy-Dashboard-browse",
        onClick: onClickFn,
        "data-uppy-super-focusable": numberOfAcquirers === 0
      }, text);
    };
    this.renderDropPasteBrowseTagline = (numberOfAcquirers) => {
      const browseFiles = this.renderBrowseButton(this.props.i18n("browseFiles"), this.triggerFileInputClick);
      const browseFolders = this.renderBrowseButton(this.props.i18n("browseFolders"), this.triggerFolderInputClick);
      const lowerFMSelectionType = this.props.fileManagerSelectionType;
      const camelFMSelectionType = lowerFMSelectionType.charAt(0).toUpperCase() + lowerFMSelectionType.slice(1);
      return y2(
        "div",
        {
          class: "uppy-Dashboard-AddFiles-title"
        },
        // eslint-disable-next-line no-nested-ternary
        this.props.disableLocalFiles ? this.props.i18n("importFiles") : numberOfAcquirers > 0 ? this.props.i18nArray(`dropPasteImport${camelFMSelectionType}`, {
          browseFiles,
          browseFolders,
          browse: browseFiles
        }) : this.props.i18nArray(`dropPaste${camelFMSelectionType}`, {
          browseFiles,
          browseFolders,
          browse: browseFiles
        })
      );
    };
    this.renderAcquirer = (acquirer) => {
      return y2("div", {
        className: "uppy-DashboardTab",
        role: "presentation",
        "data-uppy-acquirer-id": acquirer.id
      }, y2("button", {
        type: "button",
        className: "uppy-u-reset uppy-c-btn uppy-DashboardTab-btn",
        role: "tab",
        tabIndex: 0,
        "data-cy": acquirer.id,
        "aria-controls": `uppy-DashboardContent-panel--${acquirer.id}`,
        "aria-selected": this.props.activePickerPanel.id === acquirer.id,
        "data-uppy-super-focusable": true,
        onClick: () => this.props.showPanel(acquirer.id)
      }, y2("div", {
        className: "uppy-DashboardTab-inner"
      }, acquirer.icon()), y2("div", {
        className: "uppy-DashboardTab-name"
      }, acquirer.name)));
    };
    this.renderAcquirers = (acquirers) => {
      const acquirersWithoutLastTwo = [...acquirers];
      const lastTwoAcquirers = acquirersWithoutLastTwo.splice(acquirers.length - 2, acquirers.length);
      return y2(g2, null, acquirersWithoutLastTwo.map((acquirer) => this.renderAcquirer(acquirer)), y2("span", {
        role: "presentation",
        style: {
          "white-space": "nowrap"
        }
      }, lastTwoAcquirers.map((acquirer) => this.renderAcquirer(acquirer))));
    };
    this.renderSourcesList = (acquirers, disableLocalFiles) => {
      const {
        showNativePhotoCameraButton,
        showNativeVideoCameraButton
      } = this.props;
      let list2 = [];
      const myDeviceKey = "myDevice";
      if (!disableLocalFiles)
        list2.push({
          key: myDeviceKey,
          elements: this.renderMyDeviceAcquirer()
        });
      if (showNativePhotoCameraButton)
        list2.push({
          key: "nativePhotoCameraButton",
          elements: this.renderPhotoCamera()
        });
      if (showNativeVideoCameraButton)
        list2.push({
          key: "nativePhotoCameraButton",
          elements: this.renderVideoCamera()
        });
      list2.push(...acquirers.map((acquirer) => ({
        key: acquirer.id,
        elements: this.renderAcquirer(acquirer)
      })));
      const hasOnlyMyDevice = list2.length === 1 && list2[0].key === myDeviceKey;
      if (hasOnlyMyDevice)
        list2 = [];
      const listWithoutLastTwo = [...list2];
      const lastTwo = listWithoutLastTwo.splice(list2.length - 2, list2.length);
      const renderList = (l4) => l4.map((_ref) => {
        let {
          key,
          elements
        } = _ref;
        return y2(g2, {
          key
        }, elements);
      });
      return y2(g2, null, this.renderDropPasteBrowseTagline(list2.length), y2("div", {
        className: "uppy-Dashboard-AddFiles-list",
        role: "tablist"
      }, renderList(listWithoutLastTwo), y2("span", {
        role: "presentation",
        style: {
          "white-space": "nowrap"
        }
      }, renderList(lastTwo))));
    };
  }
  [_Symbol$for6]() {
    this.props.i18nArray("dropPasteBoth");
    this.props.i18nArray("dropPasteFiles");
    this.props.i18nArray("dropPasteFolders");
    this.props.i18nArray("dropPasteImportBoth");
    this.props.i18nArray("dropPasteImportFiles");
    this.props.i18nArray("dropPasteImportFolders");
  }
  renderPoweredByUppy() {
    const {
      i18nArray
    } = this.props;
    const uppyBranding = y2("span", null, y2("svg", {
      "aria-hidden": "true",
      focusable: "false",
      className: "uppy-c-icon uppy-Dashboard-poweredByIcon",
      width: "11",
      height: "11",
      viewBox: "0 0 11 11"
    }, y2("path", {
      d: "M7.365 10.5l-.01-4.045h2.612L5.5.806l-4.467 5.65h2.604l.01 4.044h3.718z",
      fillRule: "evenodd"
    })), y2("span", {
      className: "uppy-Dashboard-poweredByUppy"
    }, "Uppy"));
    const linkText = i18nArray("poweredBy", {
      uppy: uppyBranding
    });
    return y2("a", {
      tabIndex: "-1",
      href: "https://uppy.io",
      rel: "noreferrer noopener",
      target: "_blank",
      className: "uppy-Dashboard-poweredBy"
    }, linkText);
  }
  render() {
    const {
      showNativePhotoCameraButton,
      showNativeVideoCameraButton,
      nativeCameraFacingMode
    } = this.props;
    return y2("div", {
      className: "uppy-Dashboard-AddFiles"
    }, this.renderHiddenInput(false, (ref) => {
      this.fileInput = ref;
    }), this.renderHiddenInput(true, (ref) => {
      this.folderInput = ref;
    }), showNativePhotoCameraButton && this.renderHiddenCameraInput("photo", nativeCameraFacingMode, (ref) => {
      this.mobilePhotoFileInput = ref;
    }), showNativeVideoCameraButton && this.renderHiddenCameraInput("video", nativeCameraFacingMode, (ref) => {
      this.mobileVideoFileInput = ref;
    }), this.renderSourcesList(this.props.acquirers, this.props.disableLocalFiles), y2("div", {
      className: "uppy-Dashboard-AddFiles-info"
    }, this.props.note && y2("div", {
      className: "uppy-Dashboard-note"
    }, this.props.note), this.props.proudlyDisplayPoweredByUppy && this.renderPoweredByUppy(this.props)));
  }
};
var AddFiles_default = AddFiles;
var import_classnames7 = __toESM2(require_classnames2(), 1);
var AddFilesPanel = (props) => {
  return y2("div", {
    className: (0, import_classnames7.default)("uppy-Dashboard-AddFilesPanel", props.className),
    "data-uppy-panelType": "AddFiles",
    "aria-hidden": !props.showAddFilesPanel
  }, y2("div", {
    className: "uppy-DashboardContent-bar"
  }, y2("div", {
    className: "uppy-DashboardContent-title",
    role: "heading",
    "aria-level": "1"
  }, props.i18n("addingMoreFiles")), y2("button", {
    className: "uppy-DashboardContent-back",
    type: "button",
    onClick: () => props.toggleAddFilesPanel(false)
  }, props.i18n("back"))), y2(AddFiles_default, props));
};
var AddFilesPanel_default = AddFilesPanel;
var import_classnames8 = __toESM2(require_classnames2(), 1);
function ignoreEvent(ev) {
  const {
    tagName
  } = ev.target;
  if (tagName === "INPUT" || tagName === "TEXTAREA") {
    ev.stopPropagation();
    return;
  }
  ev.preventDefault();
  ev.stopPropagation();
}
var ignoreEvent_default = ignoreEvent;
function PickerPanelContent(_ref) {
  let {
    activePickerPanel,
    className,
    hideAllPanels,
    i18n,
    state,
    uppy: uppy22
  } = _ref;
  return y2("div", {
    className: (0, import_classnames8.default)("uppy-DashboardContent-panel", className),
    role: "tabpanel",
    "data-uppy-panelType": "PickerPanel",
    id: `uppy-DashboardContent-panel--${activePickerPanel.id}`,
    onDragOver: ignoreEvent_default,
    onDragLeave: ignoreEvent_default,
    onDrop: ignoreEvent_default,
    onPaste: ignoreEvent_default
  }, y2("div", {
    className: "uppy-DashboardContent-bar"
  }, y2("div", {
    className: "uppy-DashboardContent-title",
    role: "heading",
    "aria-level": "1"
  }, i18n("importFrom", {
    name: activePickerPanel.name
  })), y2("button", {
    className: "uppy-DashboardContent-back",
    type: "button",
    onClick: hideAllPanels
  }, i18n("cancel"))), y2("div", {
    className: "uppy-DashboardContent-panelBody"
  }, uppy22.getPlugin(activePickerPanel.id).render(state)));
}
var PickerPanelContent_default = PickerPanelContent;
var import_classnames9 = __toESM2(require_classnames2(), 1);
function EditorPanel(props) {
  const file = props.files[props.fileCardFor];
  const handleCancel = () => {
    props.uppy.emit("file-editor:cancel", file);
    props.closeFileEditor();
  };
  return y2("div", {
    className: (0, import_classnames9.default)("uppy-DashboardContent-panel", props.className),
    role: "tabpanel",
    "data-uppy-panelType": "FileEditor",
    id: "uppy-DashboardContent-panel--editor"
  }, y2("div", {
    className: "uppy-DashboardContent-bar"
  }, y2("div", {
    className: "uppy-DashboardContent-title",
    role: "heading",
    "aria-level": "1"
  }, props.i18nArray("editing", {
    file: y2("span", {
      className: "uppy-DashboardContent-titleFile"
    }, file.meta ? file.meta.name : file.name)
  })), y2("button", {
    className: "uppy-DashboardContent-back",
    type: "button",
    onClick: handleCancel
  }, props.i18n("cancel")), y2("button", {
    className: "uppy-DashboardContent-save",
    type: "button",
    onClick: props.saveFileEditor
  }, props.i18n("save"))), y2("div", {
    className: "uppy-DashboardContent-panelBody"
  }, props.editors.map((target) => {
    return props.uppy.getPlugin(target.id).render(props.state);
  })));
}
var EditorPanel_default = EditorPanel;
var uploadStates = {
  STATE_ERROR: "error",
  STATE_WAITING: "waiting",
  STATE_PREPROCESSING: "preprocessing",
  STATE_UPLOADING: "uploading",
  STATE_POSTPROCESSING: "postprocessing",
  STATE_COMPLETE: "complete",
  STATE_PAUSED: "paused"
};
function getUploadingState22(isAllErrored, isAllComplete, isAllPaused, files) {
  if (files === void 0) {
    files = {};
  }
  if (isAllErrored) {
    return uploadStates.STATE_ERROR;
  }
  if (isAllComplete) {
    return uploadStates.STATE_COMPLETE;
  }
  if (isAllPaused) {
    return uploadStates.STATE_PAUSED;
  }
  let state = uploadStates.STATE_WAITING;
  const fileIDs = Object.keys(files);
  for (let i4 = 0; i4 < fileIDs.length; i4++) {
    const {
      progress: progress2
    } = files[fileIDs[i4]];
    if (progress2.uploadStarted && !progress2.uploadComplete) {
      return uploadStates.STATE_UPLOADING;
    }
    if (progress2.preprocess && state !== uploadStates.STATE_UPLOADING) {
      state = uploadStates.STATE_PREPROCESSING;
    }
    if (progress2.postprocess && state !== uploadStates.STATE_UPLOADING && state !== uploadStates.STATE_PREPROCESSING) {
      state = uploadStates.STATE_POSTPROCESSING;
    }
  }
  return state;
}
function UploadStatus(_ref) {
  let {
    files,
    i18n,
    isAllComplete,
    isAllErrored,
    isAllPaused,
    inProgressNotPausedFiles,
    newFiles,
    processingFiles
  } = _ref;
  const uploadingState = getUploadingState22(isAllErrored, isAllComplete, isAllPaused, files);
  switch (uploadingState) {
    case "uploading":
      return i18n("uploadingXFiles", {
        smart_count: inProgressNotPausedFiles.length
      });
    case "preprocessing":
    case "postprocessing":
      return i18n("processingXFiles", {
        smart_count: processingFiles.length
      });
    case "paused":
      return i18n("uploadPaused");
    case "waiting":
      return i18n("xFilesSelected", {
        smart_count: newFiles.length
      });
    case "complete":
      return i18n("uploadComplete");
    case "error":
      return i18n("error");
    default:
  }
}
function PanelTopBar(props) {
  const {
    i18n,
    isAllComplete,
    hideCancelButton,
    maxNumberOfFiles,
    toggleAddFilesPanel,
    uppy: uppy22
  } = props;
  let {
    allowNewUpload
  } = props;
  if (allowNewUpload && maxNumberOfFiles) {
    allowNewUpload = props.totalFileCount < props.maxNumberOfFiles;
  }
  return y2("div", {
    className: "uppy-DashboardContent-bar"
  }, !isAllComplete && !hideCancelButton ? y2("button", {
    className: "uppy-DashboardContent-back",
    type: "button",
    onClick: () => uppy22.cancelAll()
  }, i18n("cancel")) : y2("div", null), y2("div", {
    className: "uppy-DashboardContent-title",
    role: "heading",
    "aria-level": "1"
  }, y2(UploadStatus, props)), allowNewUpload ? y2("button", {
    className: "uppy-DashboardContent-addMore",
    type: "button",
    "aria-label": i18n("addMoreFiles"),
    title: i18n("addMoreFiles"),
    onClick: () => toggleAddFilesPanel(true)
  }, y2("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    width: "15",
    height: "15",
    viewBox: "0 0 15 15"
  }, y2("path", {
    d: "M8 6.5h6a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5H8v6a.5.5 0 0 1-.5.5H7a.5.5 0 0 1-.5-.5V8h-6a.5.5 0 0 1-.5-.5V7a.5.5 0 0 1 .5-.5h6v-6A.5.5 0 0 1 7 0h.5a.5.5 0 0 1 .5.5v6z"
  })), y2("span", {
    className: "uppy-DashboardContent-addMoreCaption"
  }, i18n("addMore"))) : y2("div", null));
}
var PickerPanelTopBar_default = PanelTopBar;
var import_classnames10 = __toESM2(require_classnames2(), 1);
function RenderMetaFields(props) {
  const {
    computedMetaFields,
    requiredMetaFields,
    updateMeta,
    form,
    formState
  } = props;
  const fieldCSSClasses = {
    text: "uppy-u-reset uppy-c-textInput uppy-Dashboard-FileCard-input"
  };
  return computedMetaFields.map((field) => {
    const id18 = `uppy-Dashboard-FileCard-input-${field.id}`;
    const required = requiredMetaFields.includes(field.id);
    return y2("fieldset", {
      key: field.id,
      className: "uppy-Dashboard-FileCard-fieldset"
    }, y2("label", {
      className: "uppy-Dashboard-FileCard-label",
      htmlFor: id18
    }, field.name), field.render !== void 0 ? field.render({
      value: formState[field.id],
      onChange: (newVal) => updateMeta(newVal, field.id),
      fieldCSSClasses,
      required,
      form: form.id
    }, y2) : y2("input", {
      className: fieldCSSClasses.text,
      id: id18,
      form: form.id,
      type: field.type || "text",
      required,
      value: formState[field.id],
      placeholder: field.placeholder,
      onInput: (ev) => updateMeta(ev.target.value, field.id),
      "data-uppy-super-focusable": true
    }));
  });
}
function FileCard(props) {
  var _getMetaFields;
  const {
    files,
    fileCardFor,
    toggleFileCard,
    saveFileCard,
    metaFields: metaFields22,
    requiredMetaFields,
    openFileEditor,
    i18n,
    i18nArray,
    className,
    canEditFile
  } = props;
  const getMetaFields = () => {
    return typeof metaFields22 === "function" ? metaFields22(files[fileCardFor]) : metaFields22;
  };
  const file = files[fileCardFor];
  const computedMetaFields = (_getMetaFields = getMetaFields()) != null ? _getMetaFields : [];
  const showEditButton = canEditFile(file);
  const storedMetaData = {};
  computedMetaFields.forEach((field) => {
    var _file$meta$field$id;
    storedMetaData[field.id] = (_file$meta$field$id = file.meta[field.id]) != null ? _file$meta$field$id : "";
  });
  const [formState, setFormState] = p3(storedMetaData);
  const handleSave = x3((ev) => {
    ev.preventDefault();
    saveFileCard(formState, fileCardFor);
  }, [saveFileCard, formState, fileCardFor]);
  const updateMeta = (newVal, name) => {
    setFormState({
      ...formState,
      [name]: newVal
    });
  };
  const handleCancel = () => {
    toggleFileCard(false);
  };
  const [form] = p3(() => {
    const formEl = document.createElement("form");
    formEl.setAttribute("tabindex", "-1");
    formEl.id = nanoid2();
    return formEl;
  });
  _3(() => {
    document.body.appendChild(form);
    form.addEventListener("submit", handleSave);
    return () => {
      form.removeEventListener("submit", handleSave);
      document.body.removeChild(form);
    };
  }, [form, handleSave]);
  return y2("div", {
    className: (0, import_classnames10.default)("uppy-Dashboard-FileCard", className),
    "data-uppy-panelType": "FileCard",
    onDragOver: ignoreEvent_default,
    onDragLeave: ignoreEvent_default,
    onDrop: ignoreEvent_default,
    onPaste: ignoreEvent_default
  }, y2("div", {
    className: "uppy-DashboardContent-bar"
  }, y2("div", {
    className: "uppy-DashboardContent-title",
    role: "heading",
    "aria-level": "1"
  }, i18nArray("editing", {
    file: y2("span", {
      className: "uppy-DashboardContent-titleFile"
    }, file.meta ? file.meta.name : file.name)
  })), y2("button", {
    className: "uppy-DashboardContent-back",
    type: "button",
    form: form.id,
    title: i18n("finishEditingFile"),
    onClick: handleCancel
  }, i18n("cancel"))), y2("div", {
    className: "uppy-Dashboard-FileCard-inner"
  }, y2("div", {
    className: "uppy-Dashboard-FileCard-preview",
    style: {
      backgroundColor: getIconByMime(file.type).color
    }
  }, y2(FilePreview, {
    file
  }), showEditButton && y2("button", {
    type: "button",
    className: "uppy-u-reset uppy-c-btn uppy-Dashboard-FileCard-edit",
    onClick: (event) => {
      handleSave(event);
      openFileEditor(file);
    }
  }, i18n("editImage"))), y2("div", {
    className: "uppy-Dashboard-FileCard-info"
  }, y2(RenderMetaFields, {
    computedMetaFields,
    requiredMetaFields,
    updateMeta,
    form,
    formState
  })), y2("div", {
    className: "uppy-Dashboard-FileCard-actions"
  }, y2("button", {
    className: "uppy-u-reset uppy-c-btn uppy-c-btn-primary uppy-Dashboard-FileCard-actionsBtn",
    type: "submit",
    form: form.id
  }, i18n("saveChanges")), y2("button", {
    className: "uppy-u-reset uppy-c-btn uppy-c-btn-link uppy-Dashboard-FileCard-actionsBtn",
    type: "button",
    onClick: handleCancel,
    form: form.id
  }, i18n("cancel")))));
}
var import_classnames11 = __toESM2(require_classnames2(), 1);
var transitionName = "uppy-transition-slideDownUp";
var duration = 250;
var Slide = class extends b2 {
  constructor(props) {
    super(props);
    this.state = {
      cachedChildren: null,
      className: ""
    };
  }
  // TODO: refactor to stable lifecycle method
  // eslint-disable-next-line
  componentWillUpdate(nextProps) {
    const {
      cachedChildren
    } = this.state;
    const child = H(nextProps.children)[0];
    if (cachedChildren === child)
      return null;
    const patch = {
      cachedChildren: child
    };
    if (child && !cachedChildren) {
      patch.className = `${transitionName}-enter`;
      cancelAnimationFrame(this.animationFrame);
      clearTimeout(this.leaveTimeout);
      this.leaveTimeout = void 0;
      this.animationFrame = requestAnimationFrame(() => {
        this.setState({
          className: `${transitionName}-enter ${transitionName}-enter-active`
        });
        this.enterTimeout = setTimeout(() => {
          this.setState({
            className: ""
          });
        }, duration);
      });
    }
    if (cachedChildren && !child && this.leaveTimeout === void 0) {
      patch.cachedChildren = cachedChildren;
      patch.className = `${transitionName}-leave`;
      cancelAnimationFrame(this.animationFrame);
      clearTimeout(this.enterTimeout);
      this.enterTimeout = void 0;
      this.animationFrame = requestAnimationFrame(() => {
        this.setState({
          className: `${transitionName}-leave ${transitionName}-leave-active`
        });
        this.leaveTimeout = setTimeout(() => {
          this.setState({
            cachedChildren: null,
            className: ""
          });
        }, duration);
      });
    }
    this.setState(patch);
  }
  render() {
    const {
      cachedChildren,
      className
    } = this.state;
    if (!cachedChildren) {
      return null;
    }
    return F(cachedChildren, {
      className: (0, import_classnames11.default)(className, cachedChildren.props.className)
    });
  }
};
var Slide_default = Slide;
function _extends3() {
  _extends3 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i4 = 1; i4 < arguments.length; i4++) {
      var source = arguments[i4];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends3.apply(this, arguments);
}
var WIDTH_XL = 900;
var WIDTH_LG = 700;
var WIDTH_MD = 576;
var HEIGHT_MD = 330;
function Dashboard2(props) {
  const isNoFiles = props.totalFileCount === 0;
  const isSingleFile = props.totalFileCount === 1;
  const isSizeMD = props.containerWidth > WIDTH_MD;
  const isSizeHeightMD = props.containerHeight > HEIGHT_MD;
  const dashboardClassName = (0, import_classnames12.default)({
    "uppy-Dashboard": true,
    "uppy-Dashboard--isDisabled": props.disabled,
    "uppy-Dashboard--animateOpenClose": props.animateOpenClose,
    "uppy-Dashboard--isClosing": props.isClosing,
    "uppy-Dashboard--isDraggingOver": props.isDraggingOver,
    "uppy-Dashboard--modal": !props.inline,
    "uppy-size--md": props.containerWidth > WIDTH_MD,
    "uppy-size--lg": props.containerWidth > WIDTH_LG,
    "uppy-size--xl": props.containerWidth > WIDTH_XL,
    "uppy-size--height-md": props.containerHeight > HEIGHT_MD,
    // We might want to enable this in the future
    // 'uppy-size--height-lg': props.containerHeight > HEIGHT_LG,
    // 'uppy-size--height-xl': props.containerHeight > HEIGHT_XL,
    "uppy-Dashboard--isAddFilesPanelVisible": props.showAddFilesPanel,
    "uppy-Dashboard--isInnerWrapVisible": props.areInsidesReadyToBeVisible,
    // Only enable “centered single file” mode when Dashboard is tall enough
    "uppy-Dashboard--singleFile": props.singleFileFullScreen && isSingleFile && isSizeHeightMD
  });
  let itemsPerRow = 1;
  if (props.containerWidth > WIDTH_XL) {
    itemsPerRow = 5;
  } else if (props.containerWidth > WIDTH_LG) {
    itemsPerRow = 4;
  } else if (props.containerWidth > WIDTH_MD) {
    itemsPerRow = 3;
  }
  const showFileList = props.showSelectedFiles && !isNoFiles;
  const numberOfFilesForRecovery = props.recoveredState ? Object.keys(props.recoveredState.files).length : null;
  const numberOfGhosts = props.files ? Object.keys(props.files).filter((fileID) => props.files[fileID].isGhost).length : null;
  const renderRestoredText = () => {
    if (numberOfGhosts > 0) {
      return props.i18n("recoveredXFiles", {
        smart_count: numberOfGhosts
      });
    }
    return props.i18n("recoveredAllFiles");
  };
  const dashboard22 = y2("div", {
    className: dashboardClassName,
    "data-uppy-theme": props.theme,
    "data-uppy-num-acquirers": props.acquirers.length,
    "data-uppy-drag-drop-supported": !props.disableLocalFiles && isDragDropSupported2(),
    "aria-hidden": props.inline ? "false" : props.isHidden,
    "aria-disabled": props.disabled,
    "aria-label": !props.inline ? props.i18n("dashboardWindowTitle") : props.i18n("dashboardTitle"),
    onPaste: props.handlePaste,
    onDragOver: props.handleDragOver,
    onDragLeave: props.handleDragLeave,
    onDrop: props.handleDrop
  }, y2("div", {
    "aria-hidden": "true",
    className: "uppy-Dashboard-overlay",
    tabIndex: -1,
    onClick: props.handleClickOutside
  }), y2("div", {
    className: "uppy-Dashboard-inner",
    "aria-modal": !props.inline && "true",
    role: !props.inline && "dialog",
    style: {
      width: props.inline && props.width ? props.width : "",
      height: props.inline && props.height ? props.height : ""
    }
  }, !props.inline ? y2("button", {
    className: "uppy-u-reset uppy-Dashboard-close",
    type: "button",
    "aria-label": props.i18n("closeModal"),
    title: props.i18n("closeModal"),
    onClick: props.closeModal
  }, y2("span", {
    "aria-hidden": "true"
  }, "\xD7")) : null, y2("div", {
    className: "uppy-Dashboard-innerWrap"
  }, y2("div", {
    className: "uppy-Dashboard-dropFilesHereHint"
  }, props.i18n("dropHint")), showFileList && y2(PickerPanelTopBar_default, props), numberOfFilesForRecovery && y2("div", {
    className: "uppy-Dashboard-serviceMsg"
  }, y2("svg", {
    className: "uppy-Dashboard-serviceMsg-icon",
    "aria-hidden": "true",
    focusable: "false",
    width: "21",
    height: "16",
    viewBox: "0 0 24 19"
  }, y2("g", {
    transform: "translate(0 -1)",
    fill: "none",
    fillRule: "evenodd"
  }, y2("path", {
    d: "M12.857 1.43l10.234 17.056A1 1 0 0122.234 20H1.766a1 1 0 01-.857-1.514L11.143 1.429a1 1 0 011.714 0z",
    fill: "#FFD300"
  }), y2("path", {
    fill: "#000",
    d: "M11 6h2l-.3 8h-1.4z"
  }), y2("circle", {
    fill: "#000",
    cx: "12",
    cy: "17",
    r: "1"
  }))), y2("strong", {
    className: "uppy-Dashboard-serviceMsg-title"
  }, props.i18n("sessionRestored")), y2("div", {
    className: "uppy-Dashboard-serviceMsg-text"
  }, renderRestoredText())), showFileList ? y2(FileList_default, {
    id: props.id,
    error: props.error,
    i18n: props.i18n,
    uppy: props.uppy,
    files: props.files,
    acquirers: props.acquirers,
    resumableUploads: props.resumableUploads,
    hideRetryButton: props.hideRetryButton,
    hidePauseResumeButton: props.hidePauseResumeButton,
    hideCancelButton: props.hideCancelButton,
    showLinkToFileUploadResult: props.showLinkToFileUploadResult,
    showRemoveButtonAfterComplete: props.showRemoveButtonAfterComplete,
    isWide: props.isWide,
    metaFields: props.metaFields,
    toggleFileCard: props.toggleFileCard,
    handleRequestThumbnail: props.handleRequestThumbnail,
    handleCancelThumbnail: props.handleCancelThumbnail,
    recoveredState: props.recoveredState,
    individualCancellation: props.individualCancellation,
    openFileEditor: props.openFileEditor,
    canEditFile: props.canEditFile,
    toggleAddFilesPanel: props.toggleAddFilesPanel,
    isSingleFile,
    itemsPerRow
  }) : (
    // eslint-disable-next-line react/jsx-props-no-spreading
    y2(AddFiles_default, _extends3({}, props, {
      isSizeMD
    }))
  ), y2(Slide_default, null, props.showAddFilesPanel ? y2(AddFilesPanel_default, _extends3({
    key: "AddFiles"
  }, props, {
    isSizeMD
  })) : null), y2(Slide_default, null, props.fileCardFor ? y2(FileCard, _extends3({
    key: "FileCard"
  }, props)) : null), y2(Slide_default, null, props.activePickerPanel ? y2(PickerPanelContent_default, _extends3({
    key: "Picker"
  }, props)) : null), y2(Slide_default, null, props.showFileEditor ? y2(EditorPanel_default, _extends3({
    key: "Editor"
  }, props)) : null), y2("div", {
    className: "uppy-Dashboard-progressindicators"
  }, props.progressindicators.map((target) => {
    return props.uppy.getPlugin(target.id).render(props.state);
  })))));
  return dashboard22;
}
var locale_default52 = {
  strings: {
    // When `inline: false`, used as the screen reader label for the button that closes the modal.
    closeModal: "Close Modal",
    // Used as the screen reader label for the plus (+) button that shows the “Add more files” screen
    addMoreFiles: "Add more files",
    addingMoreFiles: "Adding more files",
    // Used as the header for import panels, e.g., “Import from Google Drive”.
    importFrom: "Import from %{name}",
    // When `inline: false`, used as the screen reader label for the dashboard modal.
    dashboardWindowTitle: "Uppy Dashboard Window (Press escape to close)",
    // When `inline: true`, used as the screen reader label for the dashboard area.
    dashboardTitle: "Uppy Dashboard",
    // Shown in the Informer when a link to a file was copied to the clipboard.
    copyLinkToClipboardSuccess: "Link copied to clipboard.",
    // Used when a link cannot be copied automatically — the user has to select the text from the
    // input element below this string.
    copyLinkToClipboardFallback: "Copy the URL below",
    // Used as the hover title and screen reader label for buttons that copy a file link.
    copyLink: "Copy link",
    back: "Back",
    // Used as the screen reader label for buttons that remove a file.
    removeFile: "Remove file",
    // Used as the screen reader label for buttons that open the metadata editor panel for a file.
    editFile: "Edit file",
    editImage: "Edit image",
    // Shown in the panel header for the metadata editor. Rendered as “Editing image.png”.
    editing: "Editing %{file}",
    // Shown on the main upload screen when an upload error occurs
    error: "Error",
    // Used as the screen reader label for the button that saves metadata edits and returns to the
    // file list view.
    finishEditingFile: "Finish editing file",
    saveChanges: "Save changes",
    // Used as the label for the tab button that opens the system file selection dialog.
    myDevice: "My Device",
    dropHint: "Drop your files here",
    // Used as the hover text and screen reader label for file progress indicators when
    // they have been fully uploaded.
    uploadComplete: "Upload complete",
    uploadPaused: "Upload paused",
    // Used as the hover text and screen reader label for the buttons to resume paused uploads.
    resumeUpload: "Resume upload",
    // Used as the hover text and screen reader label for the buttons to pause uploads.
    pauseUpload: "Pause upload",
    // Used as the hover text and screen reader label for the buttons to retry failed uploads.
    retryUpload: "Retry upload",
    // Used as the hover text and screen reader label for the buttons to cancel uploads.
    cancelUpload: "Cancel upload",
    // Used in a title, how many files are currently selected
    xFilesSelected: {
      0: "%{smart_count} file selected",
      1: "%{smart_count} files selected"
    },
    uploadingXFiles: {
      0: "Uploading %{smart_count} file",
      1: "Uploading %{smart_count} files"
    },
    processingXFiles: {
      0: "Processing %{smart_count} file",
      1: "Processing %{smart_count} files"
    },
    // The "powered by Uppy" link at the bottom of the Dashboard.
    poweredBy: "Powered by %{uppy}",
    addMore: "Add more",
    editFileWithFilename: "Edit file %{file}",
    save: "Save",
    cancel: "Cancel",
    dropPasteFiles: "Drop files here or %{browseFiles}",
    dropPasteFolders: "Drop files here or %{browseFolders}",
    dropPasteBoth: "Drop files here, %{browseFiles} or %{browseFolders}",
    dropPasteImportFiles: "Drop files here, %{browseFiles} or import from:",
    dropPasteImportFolders: "Drop files here, %{browseFolders} or import from:",
    dropPasteImportBoth: "Drop files here, %{browseFiles}, %{browseFolders} or import from:",
    importFiles: "Import files from:",
    browseFiles: "browse files",
    browseFolders: "browse folders",
    recoveredXFiles: {
      0: "We could not fully recover 1 file. Please re-select it and resume the upload.",
      1: "We could not fully recover %{smart_count} files. Please re-select them and resume the upload."
    },
    recoveredAllFiles: "We restored all files. You can now resume the upload.",
    sessionRestored: "Session restored",
    reSelect: "Re-select",
    missingRequiredMetaFields: {
      0: "Missing required meta field: %{fields}.",
      1: "Missing required meta fields: %{fields}."
    },
    // Used for native device camera buttons on mobile
    takePictureBtn: "Take Picture",
    recordVideoBtn: "Record Video"
  }
};
function _classPrivateFieldLooseBase17(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id17 = 0;
function _classPrivateFieldLooseKey17(name) {
  return "__private_" + id17++ + "_" + name;
}
var packageJson11 = {
  "version": "3.7.5"
};
var memoize2 = memoizeOne.default || memoizeOne;
var TAB_KEY = 9;
var ESC_KEY = 27;
function createPromise() {
  const o4 = {};
  o4.promise = new Promise((resolve, reject) => {
    o4.resolve = resolve;
    o4.reject = reject;
  });
  return o4;
}
var _disabledNodes = /* @__PURE__ */ _classPrivateFieldLooseKey17("disabledNodes");
var _generateLargeThumbnailIfSingleFile = /* @__PURE__ */ _classPrivateFieldLooseKey17("generateLargeThumbnailIfSingleFile");
var _openFileEditorWhenFilesAdded = /* @__PURE__ */ _classPrivateFieldLooseKey17("openFileEditorWhenFilesAdded");
var _attachRenderFunctionToTarget = /* @__PURE__ */ _classPrivateFieldLooseKey17("attachRenderFunctionToTarget");
var _isTargetSupported = /* @__PURE__ */ _classPrivateFieldLooseKey17("isTargetSupported");
var _getAcquirers = /* @__PURE__ */ _classPrivateFieldLooseKey17("getAcquirers");
var _getProgressIndicators = /* @__PURE__ */ _classPrivateFieldLooseKey17("getProgressIndicators");
var _getEditors = /* @__PURE__ */ _classPrivateFieldLooseKey17("getEditors");
var _addSpecifiedPluginsFromOptions = /* @__PURE__ */ _classPrivateFieldLooseKey17("addSpecifiedPluginsFromOptions");
var _autoDiscoverPlugins = /* @__PURE__ */ _classPrivateFieldLooseKey17("autoDiscoverPlugins");
var _addSupportedPluginIfNoTarget = /* @__PURE__ */ _classPrivateFieldLooseKey17("addSupportedPluginIfNoTarget");
var Dashboard22 = class extends UIPlugin_default {
  constructor(uppy22, _opts) {
    var _this;
    super(uppy22, _opts);
    _this = this;
    Object.defineProperty(this, _disabledNodes, {
      writable: true,
      value: null
    });
    this.removeTarget = (plugin) => {
      const pluginState = this.getPluginState();
      const newTargets = pluginState.targets.filter((target) => target.id !== plugin.id);
      this.setPluginState({
        targets: newTargets
      });
    };
    this.addTarget = (plugin) => {
      const callerPluginId = plugin.id || plugin.constructor.name;
      const callerPluginName = plugin.title || callerPluginId;
      const callerPluginType = plugin.type;
      if (callerPluginType !== "acquirer" && callerPluginType !== "progressindicator" && callerPluginType !== "editor") {
        const msg = "Dashboard: can only be targeted by plugins of types: acquirer, progressindicator, editor";
        this.uppy.log(msg, "error");
        return void 0;
      }
      const target = {
        id: callerPluginId,
        name: callerPluginName,
        type: callerPluginType
      };
      const state = this.getPluginState();
      const newTargets = state.targets.slice();
      newTargets.push(target);
      this.setPluginState({
        targets: newTargets
      });
      return this.el;
    };
    this.hideAllPanels = () => {
      const state = this.getPluginState();
      const update = {
        activePickerPanel: false,
        showAddFilesPanel: false,
        activeOverlayType: null,
        fileCardFor: null,
        showFileEditor: false
      };
      if (state.activePickerPanel === update.activePickerPanel && state.showAddFilesPanel === update.showAddFilesPanel && state.showFileEditor === update.showFileEditor && state.activeOverlayType === update.activeOverlayType) {
        return;
      }
      this.setPluginState(update);
      this.uppy.emit("dashboard:close-panel", state.activePickerPanel.id);
    };
    this.showPanel = (id18) => {
      const {
        targets
      } = this.getPluginState();
      const activePickerPanel = targets.filter((target) => {
        return target.type === "acquirer" && target.id === id18;
      })[0];
      this.setPluginState({
        activePickerPanel,
        activeOverlayType: "PickerPanel"
      });
      this.uppy.emit("dashboard:show-panel", id18);
    };
    this.canEditFile = (file) => {
      const {
        targets
      } = this.getPluginState();
      const editors = _classPrivateFieldLooseBase17(this, _getEditors)[_getEditors](targets);
      return editors.some((target) => this.uppy.getPlugin(target.id).canEditFile(file));
    };
    this.openFileEditor = (file) => {
      const {
        targets
      } = this.getPluginState();
      const editors = _classPrivateFieldLooseBase17(this, _getEditors)[_getEditors](targets);
      this.setPluginState({
        showFileEditor: true,
        fileCardFor: file.id || null,
        activeOverlayType: "FileEditor"
      });
      editors.forEach((editor) => {
        this.uppy.getPlugin(editor.id).selectFile(file);
      });
    };
    this.closeFileEditor = () => {
      const {
        metaFields: metaFields22
      } = this.getPluginState();
      const isMetaEditorEnabled = metaFields22 && metaFields22.length > 0;
      if (isMetaEditorEnabled) {
        this.setPluginState({
          showFileEditor: false,
          activeOverlayType: "FileCard"
        });
      } else {
        this.setPluginState({
          showFileEditor: false,
          fileCardFor: null,
          activeOverlayType: "AddFiles"
        });
      }
    };
    this.saveFileEditor = () => {
      const {
        targets
      } = this.getPluginState();
      const editors = _classPrivateFieldLooseBase17(this, _getEditors)[_getEditors](targets);
      editors.forEach((editor) => {
        this.uppy.getPlugin(editor.id).save();
      });
      this.closeFileEditor();
    };
    this.openModal = () => {
      const {
        promise,
        resolve
      } = createPromise();
      this.savedScrollPosition = window.pageYOffset;
      this.savedActiveElement = document.activeElement;
      if (this.opts.disablePageScrollWhenModalOpen) {
        document.body.classList.add("uppy-Dashboard-isFixed");
      }
      if (this.opts.animateOpenClose && this.getPluginState().isClosing) {
        const handler = () => {
          this.setPluginState({
            isHidden: false
          });
          this.el.removeEventListener("animationend", handler, false);
          resolve();
        };
        this.el.addEventListener("animationend", handler, false);
      } else {
        this.setPluginState({
          isHidden: false
        });
        resolve();
      }
      if (this.opts.browserBackButtonClose) {
        this.updateBrowserHistory();
      }
      document.addEventListener("keydown", this.handleKeyDownInModal);
      this.uppy.emit("dashboard:modal-open");
      return promise;
    };
    this.closeModal = function(opts) {
      if (opts === void 0) {
        opts = {};
      }
      const {
        // Whether the modal is being closed by the user (`true`) or by other means (e.g. browser back button)
        manualClose = true
      } = opts;
      const {
        isHidden,
        isClosing
      } = _this.getPluginState();
      if (isHidden || isClosing) {
        return void 0;
      }
      const {
        promise,
        resolve
      } = createPromise();
      if (_this.opts.disablePageScrollWhenModalOpen) {
        document.body.classList.remove("uppy-Dashboard-isFixed");
      }
      if (_this.opts.animateOpenClose) {
        _this.setPluginState({
          isClosing: true
        });
        const handler = () => {
          _this.setPluginState({
            isHidden: true,
            isClosing: false
          });
          _this.superFocus.cancel();
          _this.savedActiveElement.focus();
          _this.el.removeEventListener("animationend", handler, false);
          resolve();
        };
        _this.el.addEventListener("animationend", handler, false);
      } else {
        _this.setPluginState({
          isHidden: true
        });
        _this.superFocus.cancel();
        _this.savedActiveElement.focus();
        resolve();
      }
      document.removeEventListener("keydown", _this.handleKeyDownInModal);
      if (manualClose) {
        if (_this.opts.browserBackButtonClose) {
          var _history$state;
          if ((_history$state = history.state) != null && _history$state[_this.modalName]) {
            history.back();
          }
        }
      }
      _this.uppy.emit("dashboard:modal-closed");
      return promise;
    };
    this.isModalOpen = () => {
      return !this.getPluginState().isHidden || false;
    };
    this.requestCloseModal = () => {
      if (this.opts.onRequestCloseModal) {
        return this.opts.onRequestCloseModal();
      }
      return this.closeModal();
    };
    this.setDarkModeCapability = (isDarkModeOn) => {
      const {
        capabilities
      } = this.uppy.getState();
      this.uppy.setState({
        capabilities: {
          ...capabilities,
          darkMode: isDarkModeOn
        }
      });
    };
    this.handleSystemDarkModeChange = (event) => {
      const isDarkModeOnNow = event.matches;
      this.uppy.log(`[Dashboard] Dark mode is ${isDarkModeOnNow ? "on" : "off"}`);
      this.setDarkModeCapability(isDarkModeOnNow);
    };
    this.toggleFileCard = (show, fileID) => {
      const file = this.uppy.getFile(fileID);
      if (show) {
        this.uppy.emit("dashboard:file-edit-start", file);
      } else {
        this.uppy.emit("dashboard:file-edit-complete", file);
      }
      this.setPluginState({
        fileCardFor: show ? fileID : null,
        activeOverlayType: show ? "FileCard" : null
      });
    };
    this.toggleAddFilesPanel = (show) => {
      this.setPluginState({
        showAddFilesPanel: show,
        activeOverlayType: show ? "AddFiles" : null
      });
    };
    this.addFiles = (files) => {
      const descriptors = files.map((file) => ({
        source: this.id,
        name: file.name,
        type: file.type,
        data: file,
        meta: {
          // path of the file relative to the ancestor directory the user selected.
          // e.g. 'docs/Old Prague/airbnb.pdf'
          relativePath: file.relativePath || file.webkitRelativePath || null
        }
      }));
      try {
        this.uppy.addFiles(descriptors);
      } catch (err) {
        this.uppy.log(err);
      }
    };
    this.startListeningToResize = () => {
      this.resizeObserver = new ResizeObserver((entries) => {
        const uppyDashboardInnerEl = entries[0];
        const {
          width,
          height
        } = uppyDashboardInnerEl.contentRect;
        this.setPluginState({
          containerWidth: width,
          containerHeight: height,
          areInsidesReadyToBeVisible: true
        });
      });
      this.resizeObserver.observe(this.el.querySelector(".uppy-Dashboard-inner"));
      this.makeDashboardInsidesVisibleAnywayTimeout = setTimeout(() => {
        const pluginState = this.getPluginState();
        const isModalAndClosed = !this.opts.inline && pluginState.isHidden;
        if (
          // We might want to enable this in the future
          // if ResizeObserver hasn't yet fired,
          !pluginState.areInsidesReadyToBeVisible && !isModalAndClosed
        ) {
          this.uppy.log("[Dashboard] resize event didn\u2019t fire on time: defaulted to mobile layout", "warning");
          this.setPluginState({
            areInsidesReadyToBeVisible: true
          });
        }
      }, 1e3);
    };
    this.stopListeningToResize = () => {
      this.resizeObserver.disconnect();
      clearTimeout(this.makeDashboardInsidesVisibleAnywayTimeout);
    };
    this.recordIfFocusedOnUppyRecently = (event) => {
      if (this.el.contains(event.target)) {
        this.ifFocusedOnUppyRecently = true;
      } else {
        this.ifFocusedOnUppyRecently = false;
        this.superFocus.cancel();
      }
    };
    this.disableInteractiveElements = (disable) => {
      var _classPrivateFieldLoo;
      const NODES_TO_DISABLE = ["a[href]", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])", "button:not([disabled])", '[role="button"]:not([disabled])'];
      const nodesToDisable = (_classPrivateFieldLoo = _classPrivateFieldLooseBase17(this, _disabledNodes)[_disabledNodes]) != null ? _classPrivateFieldLoo : toArray_default2(this.el.querySelectorAll(NODES_TO_DISABLE)).filter((node682) => !node682.classList.contains("uppy-Dashboard-close"));
      for (const node682 of nodesToDisable) {
        if (node682.tagName === "A") {
          node682.setAttribute("aria-disabled", disable);
        } else {
          node682.disabled = disable;
        }
      }
      if (disable) {
        _classPrivateFieldLooseBase17(this, _disabledNodes)[_disabledNodes] = nodesToDisable;
      } else {
        _classPrivateFieldLooseBase17(this, _disabledNodes)[_disabledNodes] = null;
      }
      this.dashboardIsDisabled = disable;
    };
    this.updateBrowserHistory = () => {
      var _history$state2;
      if (!((_history$state2 = history.state) != null && _history$state2[this.modalName])) {
        history.pushState({
          // eslint-disable-next-line no-restricted-globals
          ...history.state,
          [this.modalName]: true
        }, "");
      }
      window.addEventListener("popstate", this.handlePopState, false);
    };
    this.handlePopState = (event) => {
      var _event$state;
      if (this.isModalOpen() && (!event.state || !event.state[this.modalName])) {
        this.closeModal({
          manualClose: false
        });
      }
      if (!this.isModalOpen() && (_event$state = event.state) != null && _event$state[this.modalName]) {
        history.back();
      }
    };
    this.handleKeyDownInModal = (event) => {
      if (event.keyCode === ESC_KEY)
        this.requestCloseModal(event);
      if (event.keyCode === TAB_KEY)
        trapFocus(event, this.getPluginState().activeOverlayType, this.el);
    };
    this.handleClickOutside = () => {
      if (this.opts.closeModalOnClickOutside)
        this.requestCloseModal();
    };
    this.handlePaste = (event) => {
      this.uppy.iteratePlugins((plugin) => {
        if (plugin.type === "acquirer") {
          plugin.handleRootPaste == null || plugin.handleRootPaste(event);
        }
      });
      const files = toArray_default2(event.clipboardData.files);
      if (files.length > 0) {
        this.uppy.log("[Dashboard] Files pasted");
        this.addFiles(files);
      }
    };
    this.handleInputChange = (event) => {
      event.preventDefault();
      const files = toArray_default2(event.target.files);
      if (files.length > 0) {
        this.uppy.log("[Dashboard] Files selected through input");
        this.addFiles(files);
      }
    };
    this.handleDragOver = (event) => {
      var _this$opts$onDragOver, _this$opts;
      event.preventDefault();
      event.stopPropagation();
      const canSomePluginHandleRootDrop = () => {
        let somePluginCanHandleRootDrop2 = true;
        this.uppy.iteratePlugins((plugin) => {
          if (plugin.canHandleRootDrop != null && plugin.canHandleRootDrop(event)) {
            somePluginCanHandleRootDrop2 = true;
          }
        });
        return somePluginCanHandleRootDrop2;
      };
      const doesEventHaveFiles = () => {
        const {
          types: types2
        } = event.dataTransfer;
        return types2.some((type) => type === "Files");
      };
      const somePluginCanHandleRootDrop = canSomePluginHandleRootDrop(event);
      const hasFiles = doesEventHaveFiles(event);
      if (!somePluginCanHandleRootDrop && !hasFiles || this.opts.disabled || this.opts.disableLocalFiles && (hasFiles || !somePluginCanHandleRootDrop) || !this.uppy.getState().allowNewUpload) {
        event.dataTransfer.dropEffect = "none";
        clearTimeout(this.removeDragOverClassTimeout);
        return;
      }
      event.dataTransfer.dropEffect = "copy";
      clearTimeout(this.removeDragOverClassTimeout);
      this.setPluginState({
        isDraggingOver: true
      });
      (_this$opts$onDragOver = (_this$opts = this.opts).onDragOver) == null || _this$opts$onDragOver.call(_this$opts, event);
    };
    this.handleDragLeave = (event) => {
      var _this$opts$onDragLeav, _this$opts2;
      event.preventDefault();
      event.stopPropagation();
      clearTimeout(this.removeDragOverClassTimeout);
      this.removeDragOverClassTimeout = setTimeout(() => {
        this.setPluginState({
          isDraggingOver: false
        });
      }, 50);
      (_this$opts$onDragLeav = (_this$opts2 = this.opts).onDragLeave) == null || _this$opts$onDragLeav.call(_this$opts2, event);
    };
    this.handleDrop = async (event) => {
      var _this$opts$onDrop, _this$opts3;
      event.preventDefault();
      event.stopPropagation();
      clearTimeout(this.removeDragOverClassTimeout);
      this.setPluginState({
        isDraggingOver: false
      });
      this.uppy.iteratePlugins((plugin) => {
        if (plugin.type === "acquirer") {
          plugin.handleRootDrop == null || plugin.handleRootDrop(event);
        }
      });
      let executedDropErrorOnce = false;
      const logDropError = (error) => {
        this.uppy.log(error, "error");
        if (!executedDropErrorOnce) {
          this.uppy.info(error.message, "error");
          executedDropErrorOnce = true;
        }
      };
      this.uppy.log("[Dashboard] Processing dropped files");
      const files = await getDroppedFiles2(event.dataTransfer, {
        logDropError
      });
      if (files.length > 0) {
        this.uppy.log("[Dashboard] Files dropped");
        this.addFiles(files);
      }
      (_this$opts$onDrop = (_this$opts3 = this.opts).onDrop) == null || _this$opts$onDrop.call(_this$opts3, event);
    };
    this.handleRequestThumbnail = (file) => {
      if (!this.opts.waitForThumbnailsBeforeUpload) {
        this.uppy.emit("thumbnail:request", file);
      }
    };
    this.handleCancelThumbnail = (file) => {
      if (!this.opts.waitForThumbnailsBeforeUpload) {
        this.uppy.emit("thumbnail:cancel", file);
      }
    };
    this.handleKeyDownInInline = (event) => {
      if (event.keyCode === TAB_KEY)
        forInline(event, this.getPluginState().activeOverlayType, this.el);
    };
    this.handlePasteOnBody = (event) => {
      const isFocusInOverlay2 = this.el.contains(document.activeElement);
      if (isFocusInOverlay2) {
        this.handlePaste(event);
      }
    };
    this.handleComplete = (_ref) => {
      let {
        failed
      } = _ref;
      if (this.opts.closeAfterFinish && failed.length === 0) {
        this.requestCloseModal();
      }
    };
    this.handleCancelRestore = () => {
      this.uppy.emit("restore-canceled");
    };
    Object.defineProperty(this, _generateLargeThumbnailIfSingleFile, {
      writable: true,
      value: () => {
        if (this.opts.disableThumbnailGenerator) {
          return;
        }
        const LARGE_THUMBNAIL = 600;
        const files = this.uppy.getFiles();
        if (files.length === 1) {
          const thumbnailGenerator = this.uppy.getPlugin(`${this.id}:ThumbnailGenerator`);
          thumbnailGenerator == null || thumbnailGenerator.setOptions({
            thumbnailWidth: LARGE_THUMBNAIL
          });
          const fileForThumbnail = {
            ...files[0],
            preview: void 0
          };
          thumbnailGenerator.requestThumbnail(fileForThumbnail).then(() => {
            thumbnailGenerator == null || thumbnailGenerator.setOptions({
              thumbnailWidth: this.opts.thumbnailWidth
            });
          });
        }
      }
    });
    Object.defineProperty(this, _openFileEditorWhenFilesAdded, {
      writable: true,
      value: (files) => {
        const firstFile = files[0];
        const {
          metaFields: metaFields22
        } = this.getPluginState();
        const isMetaEditorEnabled = metaFields22 && metaFields22.length > 0;
        const isFileEditorEnabled = this.canEditFile(firstFile);
        if (isMetaEditorEnabled) {
          this.toggleFileCard(true, firstFile.id);
        } else if (isFileEditorEnabled) {
          this.openFileEditor(firstFile);
        }
      }
    });
    this.initEvents = () => {
      if (this.opts.trigger && !this.opts.inline) {
        const showModalTrigger = findAllDOMElements(this.opts.trigger);
        if (showModalTrigger) {
          showModalTrigger.forEach((trigger) => trigger.addEventListener("click", this.openModal));
        } else {
          this.uppy.log("Dashboard modal trigger not found. Make sure `trigger` is set in Dashboard options, unless you are planning to call `dashboard.openModal()` method yourself", "warning");
        }
      }
      this.startListeningToResize();
      document.addEventListener("paste", this.handlePasteOnBody);
      this.uppy.on("plugin-added", _classPrivateFieldLooseBase17(this, _addSupportedPluginIfNoTarget)[_addSupportedPluginIfNoTarget]);
      this.uppy.on("plugin-remove", this.removeTarget);
      this.uppy.on("file-added", this.hideAllPanels);
      this.uppy.on("dashboard:modal-closed", this.hideAllPanels);
      this.uppy.on("complete", this.handleComplete);
      this.uppy.on("files-added", _classPrivateFieldLooseBase17(this, _generateLargeThumbnailIfSingleFile)[_generateLargeThumbnailIfSingleFile]);
      this.uppy.on("file-removed", _classPrivateFieldLooseBase17(this, _generateLargeThumbnailIfSingleFile)[_generateLargeThumbnailIfSingleFile]);
      document.addEventListener("focus", this.recordIfFocusedOnUppyRecently, true);
      document.addEventListener("click", this.recordIfFocusedOnUppyRecently, true);
      if (this.opts.inline) {
        this.el.addEventListener("keydown", this.handleKeyDownInInline);
      }
      if (this.opts.autoOpenFileEditor) {
        this.uppy.on("files-added", _classPrivateFieldLooseBase17(this, _openFileEditorWhenFilesAdded)[_openFileEditorWhenFilesAdded]);
      }
    };
    this.removeEvents = () => {
      const showModalTrigger = findAllDOMElements(this.opts.trigger);
      if (!this.opts.inline && showModalTrigger) {
        showModalTrigger.forEach((trigger) => trigger.removeEventListener("click", this.openModal));
      }
      this.stopListeningToResize();
      document.removeEventListener("paste", this.handlePasteOnBody);
      window.removeEventListener("popstate", this.handlePopState, false);
      this.uppy.off("plugin-added", _classPrivateFieldLooseBase17(this, _addSupportedPluginIfNoTarget)[_addSupportedPluginIfNoTarget]);
      this.uppy.off("plugin-remove", this.removeTarget);
      this.uppy.off("file-added", this.hideAllPanels);
      this.uppy.off("dashboard:modal-closed", this.hideAllPanels);
      this.uppy.off("complete", this.handleComplete);
      this.uppy.off("files-added", _classPrivateFieldLooseBase17(this, _generateLargeThumbnailIfSingleFile)[_generateLargeThumbnailIfSingleFile]);
      this.uppy.off("file-removed", _classPrivateFieldLooseBase17(this, _generateLargeThumbnailIfSingleFile)[_generateLargeThumbnailIfSingleFile]);
      document.removeEventListener("focus", this.recordIfFocusedOnUppyRecently);
      document.removeEventListener("click", this.recordIfFocusedOnUppyRecently);
      if (this.opts.inline) {
        this.el.removeEventListener("keydown", this.handleKeyDownInInline);
      }
      if (this.opts.autoOpenFileEditor) {
        this.uppy.off("files-added", _classPrivateFieldLooseBase17(this, _openFileEditorWhenFilesAdded)[_openFileEditorWhenFilesAdded]);
      }
    };
    this.superFocusOnEachUpdate = () => {
      const isFocusInUppy = this.el.contains(document.activeElement);
      const isFocusNowhere = document.activeElement === document.body || document.activeElement === null;
      const isInformerHidden = this.uppy.getState().info.length === 0;
      const isModal = !this.opts.inline;
      if (
        // If update is connected to showing the Informer - let the screen reader calmly read it.
        isInformerHidden && // If we are in a modal - always superfocus without concern for other elements
        // on the page (user is unlikely to want to interact with the rest of the page)
        (isModal || isFocusInUppy || isFocusNowhere && this.ifFocusedOnUppyRecently)
      ) {
        this.superFocus(this.el, this.getPluginState().activeOverlayType);
      } else {
        this.superFocus.cancel();
      }
    };
    this.afterUpdate = () => {
      if (this.opts.disabled && !this.dashboardIsDisabled) {
        this.disableInteractiveElements(true);
        return;
      }
      if (!this.opts.disabled && this.dashboardIsDisabled) {
        this.disableInteractiveElements(false);
      }
      this.superFocusOnEachUpdate();
    };
    this.saveFileCard = (meta, fileID) => {
      this.uppy.setFileMeta(fileID, meta);
      this.toggleFileCard(false, fileID);
    };
    Object.defineProperty(this, _attachRenderFunctionToTarget, {
      writable: true,
      value: (target) => {
        const plugin = this.uppy.getPlugin(target.id);
        return {
          ...target,
          icon: plugin.icon || this.opts.defaultPickerIcon,
          render: plugin.render
        };
      }
    });
    Object.defineProperty(this, _isTargetSupported, {
      writable: true,
      value: (target) => {
        const plugin = this.uppy.getPlugin(target.id);
        if (typeof plugin.isSupported !== "function") {
          return true;
        }
        return plugin.isSupported();
      }
    });
    Object.defineProperty(this, _getAcquirers, {
      writable: true,
      value: memoize2((targets) => {
        return targets.filter((target) => target.type === "acquirer" && _classPrivateFieldLooseBase17(this, _isTargetSupported)[_isTargetSupported](target)).map(_classPrivateFieldLooseBase17(this, _attachRenderFunctionToTarget)[_attachRenderFunctionToTarget]);
      })
    });
    Object.defineProperty(this, _getProgressIndicators, {
      writable: true,
      value: memoize2((targets) => {
        return targets.filter((target) => target.type === "progressindicator").map(_classPrivateFieldLooseBase17(this, _attachRenderFunctionToTarget)[_attachRenderFunctionToTarget]);
      })
    });
    Object.defineProperty(this, _getEditors, {
      writable: true,
      value: memoize2((targets) => {
        return targets.filter((target) => target.type === "editor").map(_classPrivateFieldLooseBase17(this, _attachRenderFunctionToTarget)[_attachRenderFunctionToTarget]);
      })
    });
    this.render = (state) => {
      const pluginState = this.getPluginState();
      const {
        files,
        capabilities,
        allowNewUpload
      } = state;
      const {
        newFiles,
        uploadStartedFiles,
        completeFiles,
        erroredFiles,
        inProgressFiles,
        inProgressNotPausedFiles,
        processingFiles,
        isUploadStarted,
        isAllComplete,
        isAllErrored,
        isAllPaused
      } = this.uppy.getObjectOfFilesPerState();
      const acquirers = _classPrivateFieldLooseBase17(this, _getAcquirers)[_getAcquirers](pluginState.targets);
      const progressindicators = _classPrivateFieldLooseBase17(this, _getProgressIndicators)[_getProgressIndicators](pluginState.targets);
      const editors = _classPrivateFieldLooseBase17(this, _getEditors)[_getEditors](pluginState.targets);
      let theme;
      if (this.opts.theme === "auto") {
        theme = capabilities.darkMode ? "dark" : "light";
      } else {
        theme = this.opts.theme;
      }
      if (["files", "folders", "both"].indexOf(this.opts.fileManagerSelectionType) < 0) {
        this.opts.fileManagerSelectionType = "files";
        console.warn(`Unsupported option for "fileManagerSelectionType". Using default of "${this.opts.fileManagerSelectionType}".`);
      }
      return Dashboard2({
        state,
        isHidden: pluginState.isHidden,
        files,
        newFiles,
        uploadStartedFiles,
        completeFiles,
        erroredFiles,
        inProgressFiles,
        inProgressNotPausedFiles,
        processingFiles,
        isUploadStarted,
        isAllComplete,
        isAllErrored,
        isAllPaused,
        totalFileCount: Object.keys(files).length,
        totalProgress: state.totalProgress,
        allowNewUpload,
        acquirers,
        theme,
        disabled: this.opts.disabled,
        disableLocalFiles: this.opts.disableLocalFiles,
        direction: this.opts.direction,
        activePickerPanel: pluginState.activePickerPanel,
        showFileEditor: pluginState.showFileEditor,
        saveFileEditor: this.saveFileEditor,
        closeFileEditor: this.closeFileEditor,
        disableInteractiveElements: this.disableInteractiveElements,
        animateOpenClose: this.opts.animateOpenClose,
        isClosing: pluginState.isClosing,
        progressindicators,
        editors,
        autoProceed: this.uppy.opts.autoProceed,
        id: this.id,
        closeModal: this.requestCloseModal,
        handleClickOutside: this.handleClickOutside,
        handleInputChange: this.handleInputChange,
        handlePaste: this.handlePaste,
        inline: this.opts.inline,
        showPanel: this.showPanel,
        hideAllPanels: this.hideAllPanels,
        i18n: this.i18n,
        i18nArray: this.i18nArray,
        uppy: this.uppy,
        note: this.opts.note,
        recoveredState: state.recoveredState,
        metaFields: pluginState.metaFields,
        resumableUploads: capabilities.resumableUploads || false,
        individualCancellation: capabilities.individualCancellation,
        isMobileDevice: capabilities.isMobileDevice,
        fileCardFor: pluginState.fileCardFor,
        toggleFileCard: this.toggleFileCard,
        toggleAddFilesPanel: this.toggleAddFilesPanel,
        showAddFilesPanel: pluginState.showAddFilesPanel,
        saveFileCard: this.saveFileCard,
        openFileEditor: this.openFileEditor,
        canEditFile: this.canEditFile,
        width: this.opts.width,
        height: this.opts.height,
        showLinkToFileUploadResult: this.opts.showLinkToFileUploadResult,
        fileManagerSelectionType: this.opts.fileManagerSelectionType,
        proudlyDisplayPoweredByUppy: this.opts.proudlyDisplayPoweredByUppy,
        hideCancelButton: this.opts.hideCancelButton,
        hideRetryButton: this.opts.hideRetryButton,
        hidePauseResumeButton: this.opts.hidePauseResumeButton,
        showRemoveButtonAfterComplete: this.opts.showRemoveButtonAfterComplete,
        containerWidth: pluginState.containerWidth,
        containerHeight: pluginState.containerHeight,
        areInsidesReadyToBeVisible: pluginState.areInsidesReadyToBeVisible,
        isTargetDOMEl: this.isTargetDOMEl,
        parentElement: this.el,
        allowedFileTypes: this.uppy.opts.restrictions.allowedFileTypes,
        maxNumberOfFiles: this.uppy.opts.restrictions.maxNumberOfFiles,
        requiredMetaFields: this.uppy.opts.restrictions.requiredMetaFields,
        showSelectedFiles: this.opts.showSelectedFiles,
        showNativePhotoCameraButton: this.opts.showNativePhotoCameraButton,
        showNativeVideoCameraButton: this.opts.showNativeVideoCameraButton,
        nativeCameraFacingMode: this.opts.nativeCameraFacingMode,
        singleFileFullScreen: this.opts.singleFileFullScreen,
        handleCancelRestore: this.handleCancelRestore,
        handleRequestThumbnail: this.handleRequestThumbnail,
        handleCancelThumbnail: this.handleCancelThumbnail,
        // drag props
        isDraggingOver: pluginState.isDraggingOver,
        handleDragOver: this.handleDragOver,
        handleDragLeave: this.handleDragLeave,
        handleDrop: this.handleDrop
      });
    };
    Object.defineProperty(this, _addSpecifiedPluginsFromOptions, {
      writable: true,
      value: () => {
        const plugins22 = this.opts.plugins || [];
        plugins22.forEach((pluginID) => {
          const plugin = this.uppy.getPlugin(pluginID);
          if (plugin) {
            plugin.mount(this, plugin);
          } else {
            this.uppy.log(`[Uppy] Dashboard could not find plugin '${pluginID}', make sure to uppy.use() the plugins you are specifying`, "warning");
          }
        });
      }
    });
    Object.defineProperty(this, _autoDiscoverPlugins, {
      writable: true,
      value: () => {
        this.uppy.iteratePlugins(_classPrivateFieldLooseBase17(this, _addSupportedPluginIfNoTarget)[_addSupportedPluginIfNoTarget]);
      }
    });
    Object.defineProperty(this, _addSupportedPluginIfNoTarget, {
      writable: true,
      value: (plugin) => {
        var _plugin$opts;
        const typesAllowed = ["acquirer", "editor"];
        if (plugin && !((_plugin$opts = plugin.opts) != null && _plugin$opts.target) && typesAllowed.includes(plugin.type)) {
          const pluginAlreadyAdded = this.getPluginState().targets.some((installedPlugin) => plugin.id === installedPlugin.id);
          if (!pluginAlreadyAdded) {
            plugin.mount(this, plugin);
          }
        }
      }
    });
    this.install = () => {
      this.setPluginState({
        isHidden: true,
        fileCardFor: null,
        activeOverlayType: null,
        showAddFilesPanel: false,
        activePickerPanel: false,
        showFileEditor: false,
        metaFields: this.opts.metaFields,
        targets: [],
        // We'll make them visible once .containerWidth is determined
        areInsidesReadyToBeVisible: false,
        isDraggingOver: false
      });
      const {
        inline,
        closeAfterFinish
      } = this.opts;
      if (inline && closeAfterFinish) {
        throw new Error("[Dashboard] `closeAfterFinish: true` cannot be used on an inline Dashboard, because an inline Dashboard cannot be closed at all. Either set `inline: false`, or disable the `closeAfterFinish` option.");
      }
      const {
        allowMultipleUploads,
        allowMultipleUploadBatches
      } = this.uppy.opts;
      if ((allowMultipleUploads || allowMultipleUploadBatches) && closeAfterFinish) {
        this.uppy.log("[Dashboard] When using `closeAfterFinish`, we recommended setting the `allowMultipleUploadBatches` option to `false` in the Uppy constructor. See https://uppy.io/docs/uppy/#allowMultipleUploads-true", "warning");
      }
      const {
        target
      } = this.opts;
      if (target) {
        this.mount(target, this);
      }
      if (!this.opts.disableStatusBar) {
        this.uppy.use(StatusBar22, {
          id: `${this.id}:StatusBar`,
          target: this,
          hideUploadButton: this.opts.hideUploadButton,
          hideRetryButton: this.opts.hideRetryButton,
          hidePauseResumeButton: this.opts.hidePauseResumeButton,
          hideCancelButton: this.opts.hideCancelButton,
          showProgressDetails: this.opts.showProgressDetails,
          hideAfterFinish: this.opts.hideProgressAfterFinish,
          locale: this.opts.locale,
          doneButtonHandler: this.opts.doneButtonHandler
        });
      }
      if (!this.opts.disableInformer) {
        this.uppy.use(Informer, {
          id: `${this.id}:Informer`,
          target: this
        });
      }
      if (!this.opts.disableThumbnailGenerator) {
        this.uppy.use(ThumbnailGenerator, {
          id: `${this.id}:ThumbnailGenerator`,
          thumbnailWidth: this.opts.thumbnailWidth,
          thumbnailHeight: this.opts.thumbnailHeight,
          thumbnailType: this.opts.thumbnailType,
          waitForThumbnailsBeforeUpload: this.opts.waitForThumbnailsBeforeUpload,
          // If we don't block on thumbnails, we can lazily generate them
          lazy: !this.opts.waitForThumbnailsBeforeUpload
        });
      }
      this.darkModeMediaQuery = typeof window !== "undefined" && window.matchMedia ? window.matchMedia("(prefers-color-scheme: dark)") : null;
      const isDarkModeOnFromTheStart = this.darkModeMediaQuery ? this.darkModeMediaQuery.matches : false;
      this.uppy.log(`[Dashboard] Dark mode is ${isDarkModeOnFromTheStart ? "on" : "off"}`);
      this.setDarkModeCapability(isDarkModeOnFromTheStart);
      if (this.opts.theme === "auto") {
        this.darkModeMediaQuery.addListener(this.handleSystemDarkModeChange);
      }
      _classPrivateFieldLooseBase17(this, _addSpecifiedPluginsFromOptions)[_addSpecifiedPluginsFromOptions]();
      _classPrivateFieldLooseBase17(this, _autoDiscoverPlugins)[_autoDiscoverPlugins]();
      this.initEvents();
    };
    this.uninstall = () => {
      if (!this.opts.disableInformer) {
        const informer = this.uppy.getPlugin(`${this.id}:Informer`);
        if (informer)
          this.uppy.removePlugin(informer);
      }
      if (!this.opts.disableStatusBar) {
        const statusBar = this.uppy.getPlugin(`${this.id}:StatusBar`);
        if (statusBar)
          this.uppy.removePlugin(statusBar);
      }
      if (!this.opts.disableThumbnailGenerator) {
        const thumbnail = this.uppy.getPlugin(`${this.id}:ThumbnailGenerator`);
        if (thumbnail)
          this.uppy.removePlugin(thumbnail);
      }
      const plugins22 = this.opts.plugins || [];
      plugins22.forEach((pluginID) => {
        const plugin = this.uppy.getPlugin(pluginID);
        if (plugin)
          plugin.unmount();
      });
      if (this.opts.theme === "auto") {
        this.darkModeMediaQuery.removeListener(this.handleSystemDarkModeChange);
      }
      if (this.opts.disablePageScrollWhenModalOpen) {
        document.body.classList.remove("uppy-Dashboard-isFixed");
      }
      this.unmount();
      this.removeEvents();
    };
    this.id = this.opts.id || "Dashboard";
    this.title = "Dashboard";
    this.type = "orchestrator";
    this.modalName = `uppy-Dashboard-${nanoid2()}`;
    this.defaultLocale = locale_default52;
    const defaultOptions8 = {
      target: "body",
      metaFields: [],
      trigger: null,
      inline: false,
      width: 750,
      height: 550,
      thumbnailWidth: 280,
      thumbnailType: "image/jpeg",
      waitForThumbnailsBeforeUpload: false,
      defaultPickerIcon,
      showLinkToFileUploadResult: false,
      showProgressDetails: false,
      hideUploadButton: false,
      hideCancelButton: false,
      hideRetryButton: false,
      hidePauseResumeButton: false,
      hideProgressAfterFinish: false,
      doneButtonHandler: () => {
        this.uppy.clearUploadedFiles();
        this.requestCloseModal();
      },
      note: null,
      closeModalOnClickOutside: false,
      closeAfterFinish: false,
      singleFileFullScreen: true,
      disableStatusBar: false,
      disableInformer: false,
      disableThumbnailGenerator: false,
      disablePageScrollWhenModalOpen: true,
      animateOpenClose: true,
      fileManagerSelectionType: "files",
      proudlyDisplayPoweredByUppy: true,
      onRequestCloseModal: () => this.closeModal(),
      showSelectedFiles: true,
      showRemoveButtonAfterComplete: false,
      browserBackButtonClose: false,
      showNativePhotoCameraButton: false,
      showNativeVideoCameraButton: false,
      theme: "light",
      autoOpenFileEditor: false,
      disabled: false,
      disableLocalFiles: false
    };
    this.opts = {
      ...defaultOptions8,
      ..._opts
    };
    this.i18nInit();
    this.superFocus = createSuperFocus();
    this.ifFocusedOnUppyRecently = false;
    this.makeDashboardInsidesVisibleAnywayTimeout = null;
    this.removeDragOverClassTimeout = null;
  }
};
Dashboard22.VERSION = packageJson11.version;
var import_prop_types7 = __toESM2(require_prop_types2(), 1);
var uppy2 = import_prop_types7.default.instanceOf(Uppy_default);
var plugins2 = import_prop_types7.default.arrayOf(import_prop_types7.default.string);
var locale2 = import_prop_types7.default.shape({
  strings: import_prop_types7.default.object,
  // eslint-disable-line react/forbid-prop-types
  pluralize: import_prop_types7.default.func
});
var metaField2 = import_prop_types7.default.shape({
  id: import_prop_types7.default.string.isRequired,
  name: import_prop_types7.default.string.isRequired,
  placeholder: import_prop_types7.default.string
});
var metaFields2 = import_prop_types7.default.oneOfType([import_prop_types7.default.arrayOf(metaField2), import_prop_types7.default.func]);
var cssSize2 = import_prop_types7.default.oneOfType([import_prop_types7.default.string, import_prop_types7.default.number]);
var dashboard2 = {
  uppy: uppy2,
  inline: import_prop_types7.default.bool,
  plugins: plugins2,
  width: cssSize2,
  height: cssSize2,
  showProgressDetails: import_prop_types7.default.bool,
  hideUploadButton: import_prop_types7.default.bool,
  hideProgressAfterFinish: import_prop_types7.default.bool,
  note: import_prop_types7.default.string,
  metaFields: metaFields2,
  proudlyDisplayPoweredByUppy: import_prop_types7.default.bool,
  disableStatusBar: import_prop_types7.default.bool,
  disableInformer: import_prop_types7.default.bool,
  disableThumbnailGenerator: import_prop_types7.default.bool,
  // pass-through to ThumbnailGenerator
  thumbnailWidth: import_prop_types7.default.number,
  locale: locale2
};
var reactSupportedHtmlAttr2 = [
  // React-specific Attributes
  "defaultChecked",
  "defaultValue",
  "suppressContentEditableWarning",
  "suppressHydrationWarning",
  "dangerouslySetInnerHTML",
  // Standard HTML Attributes
  "accessKey",
  "className",
  "contentEditable",
  "contextMenu",
  "dir",
  "draggable",
  "hidden",
  "id",
  "lang",
  "placeholder",
  "slot",
  "spellCheck",
  "style",
  "tabIndex",
  "title",
  "translate",
  // Unknown
  "radioGroup",
  // WAI-ARIA
  "role",
  // RDFa Attributes
  "about",
  "datatype",
  "inlist",
  "prefix",
  "property",
  "resource",
  "typeof",
  "vocab",
  // Non-standard Attributes
  "autoCapitalize",
  "autoCorrect",
  "autoSave",
  "color",
  "itemProp",
  "itemScope",
  "itemType",
  "itemID",
  "itemRef",
  "results",
  "security",
  "unselectable",
  // Living Standard
  "inputMode",
  "is",
  // Clipboard Events
  "onCopy",
  "onCopyCapture",
  "onCut",
  "onCutCapture",
  "onPaste",
  "onPasteCapture",
  // Composition Events
  "onCompositionEnd",
  "onCompositionEndCapture",
  "onCompositionStart",
  "onCompositionStartCapture",
  "onCompositionUpdate",
  "onCompositionUpdateCapture",
  // Focus Events
  "onFocus",
  "onFocusCapture",
  "onBlur",
  "onBlurCapture",
  // Form Events
  "onChange",
  "onChangeCapture",
  "onBeforeInput",
  "onBeforeInputCapture",
  "onInput",
  "onInputCapture",
  "onReset",
  "onResetCapture",
  "onSubmit",
  "onSubmitCapture",
  "onInvalid",
  "onInvalidCapture",
  // Image Events
  "onLoad",
  "onLoadCapture",
  "onError",
  // also a Media Event
  "onErrorCapture",
  // also a Media Event
  // Keyboard Events
  "onKeyDown",
  "onKeyDownCapture",
  "onKeyPress",
  "onKeyPressCapture",
  "onKeyUp",
  "onKeyUpCapture",
  // Media Events
  "onAbort",
  "onAbortCapture",
  "onCanPlay",
  "onCanPlayCapture",
  "onCanPlayThrough",
  "onCanPlayThroughCapture",
  "onDurationChange",
  "onDurationChangeCapture",
  "onEmptied",
  "onEmptiedCapture",
  "onEncrypted",
  "onEncryptedCapture",
  "onEnded",
  "onEndedCapture",
  "onLoadedData",
  "onLoadedDataCapture",
  "onLoadedMetadata",
  "onLoadedMetadataCapture",
  "onLoadStart",
  "onLoadStartCapture",
  "onPause",
  "onPauseCapture",
  "onPlay",
  "onPlayCapture",
  "onPlaying",
  "onPlayingCapture",
  "onProgress",
  "onProgressCapture",
  "onRateChange",
  "onRateChangeCapture",
  "onSeeked",
  "onSeekedCapture",
  "onSeeking",
  "onSeekingCapture",
  "onStalled",
  "onStalledCapture",
  "onSuspend",
  "onSuspendCapture",
  "onTimeUpdate",
  "onTimeUpdateCapture",
  "onVolumeChange",
  "onVolumeChangeCapture",
  "onWaiting",
  "onWaitingCapture",
  // MouseEvents
  "onAuxClick",
  "onAuxClickCapture",
  "onClick",
  "onClickCapture",
  "onContextMenu",
  "onContextMenuCapture",
  "onDoubleClick",
  "onDoubleClickCapture",
  "onDrag",
  "onDragCapture",
  "onDragEnd",
  "onDragEndCapture",
  "onDragEnter",
  "onDragEnterCapture",
  "onDragExit",
  "onDragExitCapture",
  "onDragLeave",
  "onDragLeaveCapture",
  "onDragOver",
  "onDragOverCapture",
  "onDragStart",
  "onDragStartCapture",
  "onDrop",
  "onDropCapture",
  "onMouseDown",
  "onMouseDownCapture",
  "onMouseEnter",
  "onMouseLeave",
  "onMouseMove",
  "onMouseMoveCapture",
  "onMouseOut",
  "onMouseOutCapture",
  "onMouseOver",
  "onMouseOverCapture",
  "onMouseUp",
  "onMouseUpCapture",
  // Selection Events
  "onSelect",
  "onSelectCapture",
  // Touch Events
  "onTouchCancel",
  "onTouchCancelCapture",
  "onTouchEnd",
  "onTouchEndCapture",
  "onTouchMove",
  "onTouchMoveCapture",
  "onTouchStart",
  "onTouchStartCapture",
  // Pointer Events
  "onPointerDown",
  "onPointerDownCapture",
  "onPointerMove",
  "onPointerMoveCapture",
  "onPointerUp",
  "onPointerUpCapture",
  "onPointerCancel",
  "onPointerCancelCapture",
  "onPointerEnter",
  "onPointerEnterCapture",
  "onPointerLeave",
  "onPointerLeaveCapture",
  "onPointerOver",
  "onPointerOverCapture",
  "onPointerOut",
  "onPointerOutCapture",
  "onGotPointerCapture",
  "onGotPointerCaptureCapture",
  "onLostPointerCapture",
  "onLostPointerCaptureCapture",
  // UI Events
  "onScroll",
  "onScrollCapture",
  // Wheel Events
  "onWheel",
  "onWheelCapture",
  // Animation Events
  "onAnimationStart",
  "onAnimationStartCapture",
  "onAnimationEnd",
  "onAnimationEndCapture",
  "onAnimationIteration",
  "onAnimationIterationCapture",
  // Transition Events
  "onTransitionEnd",
  "onTransitionEndCapture"
];
var validHTMLAttribute2 = /^(aria-|data-)/;
var getHTMLProps2 = (props) => {
  return Object.fromEntries(Object.entries(props).filter((_ref) => {
    let [key] = _ref;
    return validHTMLAttribute2.test(key) || reactSupportedHtmlAttr2.includes(key);
  }));
};
var getHTMLProps_default2 = getHTMLProps2;
function nonHtmlPropsHaveChanged2(props, prevProps) {
  return Object.keys(props).some((key) => !Object.hasOwn(props, key) && props[key] !== prevProps[key]);
}
var Dashboard3 = class extends Component7 {
  componentDidMount() {
    this.installPlugin();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.uppy !== this.props.uppy) {
      this.uninstallPlugin(prevProps);
      this.installPlugin();
    } else if (nonHtmlPropsHaveChanged2(this.props, prevProps)) {
      const options7 = {
        ...this.props,
        target: this.container
      };
      delete options7.uppy;
      this.plugin.setOptions(options7);
    }
  }
  componentWillUnmount() {
    this.uninstallPlugin();
  }
  installPlugin() {
    const {
      uppy: uppy22
    } = this.props;
    const options7 = {
      id: "react:Dashboard",
      ...this.props,
      target: this.container
    };
    delete options7.uppy;
    uppy22.use(Dashboard22, options7);
    this.plugin = uppy22.getPlugin(options7.id);
  }
  uninstallPlugin(props) {
    if (props === void 0) {
      props = this.props;
    }
    const {
      uppy: uppy22
    } = props;
    uppy22.removePlugin(this.plugin);
  }
  render() {
    return h42("div", {
      className: "uppy-Container",
      ref: (container) => {
        this.container = container;
      },
      ...getHTMLProps_default2(this.props)
    });
  }
};
Dashboard3.propTypes = dashboard2;
Dashboard3.defaultProps = {
  inline: true
};
var import_prop_types22 = __toESM2(require_prop_types2(), 1);
var DashboardModal2 = class extends Component22 {
  componentDidMount() {
    this.installPlugin();
  }
  componentDidUpdate(prevProps) {
    const {
      uppy: uppy22,
      open,
      onRequestClose
    } = this.props;
    if (prevProps.uppy !== uppy22) {
      this.uninstallPlugin(prevProps);
      this.installPlugin();
    } else if (nonHtmlPropsHaveChanged2(this.props, prevProps)) {
      const options7 = {
        ...this.props,
        onRequestCloseModal: onRequestClose
      };
      delete options7.uppy;
      this.plugin.setOptions(options7);
    }
    if (prevProps.open && !open) {
      this.plugin.closeModal();
    } else if (!prevProps.open && open) {
      this.plugin.openModal();
    }
  }
  componentWillUnmount() {
    this.uninstallPlugin();
  }
  installPlugin() {
    const {
      id: id18 = "react:DashboardModal",
      uppy: uppy22,
      target,
      open,
      onRequestClose,
      closeModalOnClickOutside,
      disablePageScrollWhenModalOpen,
      inline,
      plugins: plugins22,
      // eslint-disable-line no-shadow
      width,
      height,
      showProgressDetails,
      note,
      metaFields: metaFields22,
      // eslint-disable-line no-shadow
      proudlyDisplayPoweredByUppy,
      autoOpenFileEditor,
      animateOpenClose,
      browserBackButtonClose,
      closeAfterFinish,
      disableStatusBar,
      disableInformer,
      disableThumbnailGenerator,
      disableLocalFiles,
      disabled,
      hideCancelButton,
      hidePauseResumeButton,
      hideProgressAfterFinish,
      hideRetryButton,
      hideUploadButton,
      showLinkToFileUploadResult,
      showRemoveButtonAfterComplete,
      showSelectedFiles,
      waitForThumbnailsBeforeUpload,
      fileManagerSelectionType,
      theme,
      thumbnailType,
      thumbnailWidth,
      locale: locale22
      // eslint-disable-line no-shadow
    } = this.props;
    const options7 = {
      id: id18,
      target,
      closeModalOnClickOutside,
      disablePageScrollWhenModalOpen,
      inline,
      plugins: plugins22,
      width,
      height,
      showProgressDetails,
      note,
      metaFields: metaFields22,
      proudlyDisplayPoweredByUppy,
      autoOpenFileEditor,
      animateOpenClose,
      browserBackButtonClose,
      closeAfterFinish,
      disableStatusBar,
      disableInformer,
      disableThumbnailGenerator,
      disableLocalFiles,
      disabled,
      hideCancelButton,
      hidePauseResumeButton,
      hideProgressAfterFinish,
      hideRetryButton,
      hideUploadButton,
      showLinkToFileUploadResult,
      showRemoveButtonAfterComplete,
      showSelectedFiles,
      waitForThumbnailsBeforeUpload,
      fileManagerSelectionType,
      theme,
      thumbnailType,
      thumbnailWidth,
      locale: locale22,
      onRequestCloseModal: onRequestClose
    };
    if (!options7.target) {
      options7.target = this.container;
    }
    delete options7.uppy;
    uppy22.use(Dashboard22, options7);
    this.plugin = uppy22.getPlugin(options7.id);
    if (open) {
      this.plugin.openModal();
    }
  }
  uninstallPlugin(props) {
    if (props === void 0) {
      props = this.props;
    }
    const {
      uppy: uppy22
    } = props;
    uppy22.removePlugin(this.plugin);
  }
  render() {
    return h52("div", {
      className: "uppy-Container",
      ref: (container) => {
        this.container = container;
      },
      ...getHTMLProps_default2(this.props)
    });
  }
};
DashboardModal2.propTypes = {
  uppy: uppy2.isRequired,
  target: typeof window !== "undefined" ? import_prop_types22.default.instanceOf(window.HTMLElement) : import_prop_types22.default.any,
  open: import_prop_types22.default.bool,
  onRequestClose: import_prop_types22.default.func,
  closeModalOnClickOutside: import_prop_types22.default.bool,
  disablePageScrollWhenModalOpen: import_prop_types22.default.bool,
  inline: import_prop_types22.default.bool,
  plugins: plugins2,
  width: cssSize2,
  height: cssSize2,
  showProgressDetails: import_prop_types22.default.bool,
  note: import_prop_types22.default.string,
  metaFields: metaFields2,
  proudlyDisplayPoweredByUppy: import_prop_types22.default.bool,
  autoOpenFileEditor: import_prop_types22.default.bool,
  animateOpenClose: import_prop_types22.default.bool,
  browserBackButtonClose: import_prop_types22.default.bool,
  closeAfterFinish: import_prop_types22.default.bool,
  disableStatusBar: import_prop_types22.default.bool,
  disableInformer: import_prop_types22.default.bool,
  disableThumbnailGenerator: import_prop_types22.default.bool,
  disableLocalFiles: import_prop_types22.default.bool,
  disabled: import_prop_types22.default.bool,
  hideCancelButton: import_prop_types22.default.bool,
  hidePauseResumeButton: import_prop_types22.default.bool,
  hideProgressAfterFinish: import_prop_types22.default.bool,
  hideRetryButton: import_prop_types22.default.bool,
  hideUploadButton: import_prop_types22.default.bool,
  showLinkToFileUploadResult: import_prop_types22.default.bool,
  showRemoveButtonAfterComplete: import_prop_types22.default.bool,
  showSelectedFiles: import_prop_types22.default.bool,
  waitForThumbnailsBeforeUpload: import_prop_types22.default.bool,
  fileManagerSelectionType: import_prop_types22.default.string,
  theme: import_prop_types22.default.string,
  // pass-through to ThumbnailGenerator
  thumbnailType: import_prop_types22.default.string,
  thumbnailWidth: import_prop_types22.default.number,
  locale: locale2
};
DashboardModal2.defaultProps = {
  metaFields: [],
  plugins: [],
  inline: false,
  width: 750,
  height: 550,
  thumbnailWidth: 280,
  thumbnailType: "image/jpeg",
  waitForThumbnailsBeforeUpload: false,
  showLinkToFileUploadResult: false,
  showProgressDetails: false,
  hideUploadButton: false,
  hideCancelButton: false,
  hideRetryButton: false,
  hidePauseResumeButton: false,
  hideProgressAfterFinish: false,
  note: null,
  closeModalOnClickOutside: false,
  closeAfterFinish: false,
  disableStatusBar: false,
  disableInformer: false,
  disableThumbnailGenerator: false,
  disablePageScrollWhenModalOpen: true,
  animateOpenClose: true,
  fileManagerSelectionType: "files",
  proudlyDisplayPoweredByUppy: true,
  showSelectedFiles: true,
  showRemoveButtonAfterComplete: false,
  browserBackButtonClose: false,
  theme: "light",
  autoOpenFileEditor: false,
  disabled: false,
  disableLocalFiles: false,
  // extra
  open: void 0,
  target: void 0,
  locale: null,
  onRequestClose: void 0
};
var import_prop_types32 = __toESM2(require_prop_types2(), 1);
var locale_default6 = {
  strings: {
    // Text to show on the droppable area.
    // `%{browse}` is replaced with a link that opens the system file selection dialog.
    dropHereOr: "Drop here or %{browse}",
    // Used as the label for the link that opens the system file selection dialog.
    browse: "browse"
  }
};
var packageJson12 = {
  "version": "3.0.3"
};
var DragDrop3 = class _DragDrop extends UIPlugin_default {
  constructor(uppy22, opts) {
    super(uppy22, opts);
    this.handleDrop = async (event) => {
      var _this$opts$onDrop, _this$opts;
      event.preventDefault();
      event.stopPropagation();
      clearTimeout(this.removeDragOverClassTimeout);
      this.setPluginState({
        isDraggingOver: false
      });
      const logDropError = (error) => {
        this.uppy.log(error, "error");
      };
      const files = await getDroppedFiles2(event.dataTransfer, {
        logDropError
      });
      if (files.length > 0) {
        this.uppy.log("[DragDrop] Files dropped");
        this.addFiles(files);
      }
      (_this$opts$onDrop = (_this$opts = this.opts).onDrop) == null ? void 0 : _this$opts$onDrop.call(_this$opts, event);
    };
    this.type = "acquirer";
    this.id = this.opts.id || "DragDrop";
    this.title = "Drag & Drop";
    this.defaultLocale = locale_default6;
    const defaultOpts = {
      target: null,
      inputName: "files[]",
      width: "100%",
      height: "100%",
      note: null
    };
    this.opts = {
      ...defaultOpts,
      ...opts
    };
    this.i18nInit();
    this.isDragDropSupported = isDragDropSupported2();
    this.removeDragOverClassTimeout = null;
    this.onInputChange = this.onInputChange.bind(this);
    this.handleDragOver = this.handleDragOver.bind(this);
    this.handleDragLeave = this.handleDragLeave.bind(this);
    this.handleDrop = this.handleDrop.bind(this);
    this.addFiles = this.addFiles.bind(this);
    this.render = this.render.bind(this);
  }
  addFiles(files) {
    const descriptors = files.map((file) => ({
      source: this.id,
      name: file.name,
      type: file.type,
      data: file,
      meta: {
        // path of the file relative to the ancestor directory the user selected.
        // e.g. 'docs/Old Prague/airbnb.pdf'
        relativePath: file.relativePath || null
      }
    }));
    try {
      this.uppy.addFiles(descriptors);
    } catch (err) {
      this.uppy.log(err);
    }
  }
  onInputChange(event) {
    const files = toArray_default2(event.target.files);
    if (files.length > 0) {
      this.uppy.log("[DragDrop] Files selected through input");
      this.addFiles(files);
    }
    event.target.value = null;
  }
  handleDragOver(event) {
    var _this$opts$onDragOver, _this$opts2;
    event.preventDefault();
    event.stopPropagation();
    const {
      types: types2
    } = event.dataTransfer;
    const hasFiles = types2.some((type) => type === "Files");
    const {
      allowNewUpload
    } = this.uppy.getState();
    if (!hasFiles || !allowNewUpload) {
      event.dataTransfer.dropEffect = "none";
      clearTimeout(this.removeDragOverClassTimeout);
      return;
    }
    event.dataTransfer.dropEffect = "copy";
    clearTimeout(this.removeDragOverClassTimeout);
    this.setPluginState({
      isDraggingOver: true
    });
    (_this$opts$onDragOver = (_this$opts2 = this.opts).onDragOver) == null ? void 0 : _this$opts$onDragOver.call(_this$opts2, event);
  }
  handleDragLeave(event) {
    var _this$opts$onDragLeav, _this$opts3;
    event.preventDefault();
    event.stopPropagation();
    clearTimeout(this.removeDragOverClassTimeout);
    this.removeDragOverClassTimeout = setTimeout(() => {
      this.setPluginState({
        isDraggingOver: false
      });
    }, 50);
    (_this$opts$onDragLeav = (_this$opts3 = this.opts).onDragLeave) == null ? void 0 : _this$opts$onDragLeav.call(_this$opts3, event);
  }
  renderHiddenFileInput() {
    const {
      restrictions
    } = this.uppy.opts;
    return y2("input", {
      className: "uppy-DragDrop-input",
      type: "file",
      hidden: true,
      ref: (ref) => {
        this.fileInputRef = ref;
      },
      name: this.opts.inputName,
      multiple: restrictions.maxNumberOfFiles !== 1,
      accept: restrictions.allowedFileTypes,
      onChange: this.onInputChange
    });
  }
  static renderArrowSvg() {
    return y2("svg", {
      "aria-hidden": "true",
      focusable: "false",
      className: "uppy-c-icon uppy-DragDrop-arrow",
      width: "16",
      height: "16",
      viewBox: "0 0 16 16"
    }, y2("path", {
      d: "M11 10V0H5v10H2l6 6 6-6h-3zm0 0",
      fillRule: "evenodd"
    }));
  }
  renderLabel() {
    return y2("div", {
      className: "uppy-DragDrop-label"
    }, this.i18nArray("dropHereOr", {
      browse: y2("span", {
        className: "uppy-DragDrop-browse"
      }, this.i18n("browse"))
    }));
  }
  renderNote() {
    return y2("span", {
      className: "uppy-DragDrop-note"
    }, this.opts.note);
  }
  render() {
    const dragDropClass = `uppy-u-reset
      uppy-DragDrop-container
      ${this.isDragDropSupported ? "uppy-DragDrop--isDragDropSupported" : ""}
      ${this.getPluginState().isDraggingOver ? "uppy-DragDrop--isDraggingOver" : ""}
    `;
    const dragDropStyle = {
      width: this.opts.width,
      height: this.opts.height
    };
    return y2("button", {
      type: "button",
      className: dragDropClass,
      style: dragDropStyle,
      onClick: () => this.fileInputRef.click(),
      onDragOver: this.handleDragOver,
      onDragLeave: this.handleDragLeave,
      onDrop: this.handleDrop
    }, this.renderHiddenFileInput(), y2("div", {
      className: "uppy-DragDrop-inner"
    }, _DragDrop.renderArrowSvg(), this.renderLabel(), this.renderNote()));
  }
  install() {
    const {
      target
    } = this.opts;
    this.setPluginState({
      isDraggingOver: false
    });
    if (target) {
      this.mount(target, this);
    }
  }
  uninstall() {
    this.unmount();
  }
};
DragDrop3.VERSION = packageJson12.version;
var DragDrop22 = class extends Component32 {
  componentDidMount() {
    this.installPlugin();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.uppy !== this.props.uppy) {
      this.uninstallPlugin(prevProps);
      this.installPlugin();
    } else if (nonHtmlPropsHaveChanged2(this.props, prevProps)) {
      const options7 = {
        ...this.props,
        target: this.container
      };
      delete options7.uppy;
      this.plugin.setOptions(options7);
    }
  }
  componentWillUnmount() {
    this.uninstallPlugin();
  }
  installPlugin() {
    const {
      uppy: uppy22,
      locale: locale22,
      inputName,
      width,
      height,
      note
    } = this.props;
    const options7 = {
      id: "react:DragDrop",
      locale: locale22,
      inputName,
      width,
      height,
      note,
      target: this.container
    };
    delete options7.uppy;
    uppy22.use(DragDrop3, options7);
    this.plugin = uppy22.getPlugin(options7.id);
  }
  uninstallPlugin(props) {
    if (props === void 0) {
      props = this.props;
    }
    const {
      uppy: uppy22
    } = props;
    uppy22.removePlugin(this.plugin);
  }
  render() {
    return h62("div", {
      className: "uppy-Container",
      ref: (container) => {
        this.container = container;
      },
      ...getHTMLProps_default2(this.props)
    });
  }
};
DragDrop22.propTypes = {
  uppy: uppy2.isRequired,
  locale: locale2,
  inputName: import_prop_types32.default.string,
  width: import_prop_types32.default.string,
  height: import_prop_types32.default.string,
  note: import_prop_types32.default.string
};
DragDrop22.defaultProps = {
  locale: null,
  inputName: "files[]",
  width: "100%",
  height: "100%",
  note: null
};
var import_prop_types42 = __toESM2(require_prop_types2(), 1);
var packageJson13 = {
  "version": "3.1.0"
};
var defaultOptions6 = {
  target: "body",
  fixed: false,
  hideAfterFinish: true
};
var ProgressBar3 = class extends UIPlugin_default {
  constructor(uppy22, opts) {
    super(uppy22, {
      ...defaultOptions6,
      ...opts
    });
    this.id = this.opts.id || "ProgressBar";
    this.title = "Progress Bar";
    this.type = "progressindicator";
    this.render = this.render.bind(this);
  }
  render(state) {
    const progress2 = state.totalProgress || 0;
    const isHidden = (progress2 === 0 || progress2 === 100) && this.opts.hideAfterFinish;
    return y2("div", {
      className: "uppy uppy-ProgressBar",
      style: {
        position: this.opts.fixed ? "fixed" : "initial"
      },
      "aria-hidden": isHidden
    }, y2("div", {
      className: "uppy-ProgressBar-inner",
      style: {
        width: `${progress2}%`
      }
    }), y2("div", {
      className: "uppy-ProgressBar-percentage"
    }, progress2));
  }
  install() {
    const {
      target
    } = this.opts;
    if (target) {
      this.mount(target, this);
    }
  }
  uninstall() {
    this.unmount();
  }
};
ProgressBar3.VERSION = packageJson13.version;
var ProgressBar22 = class extends Component42 {
  componentDidMount() {
    this.installPlugin();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.uppy !== this.props.uppy) {
      this.uninstallPlugin(prevProps);
      this.installPlugin();
    } else if (nonHtmlPropsHaveChanged2(this.props, prevProps)) {
      const options7 = {
        ...this.props,
        target: this.container
      };
      delete options7.uppy;
      this.plugin.setOptions(options7);
    }
  }
  componentWillUnmount() {
    this.uninstallPlugin();
  }
  installPlugin() {
    const {
      uppy: uppy22,
      fixed,
      hideAfterFinish
    } = this.props;
    const options7 = {
      id: "react:ProgressBar",
      fixed,
      hideAfterFinish,
      target: this.container
    };
    delete options7.uppy;
    uppy22.use(ProgressBar3, options7);
    this.plugin = uppy22.getPlugin(options7.id);
  }
  uninstallPlugin(props) {
    if (props === void 0) {
      props = this.props;
    }
    const {
      uppy: uppy22
    } = props;
    uppy22.removePlugin(this.plugin);
  }
  render() {
    return h72("div", {
      className: "uppy-Container",
      ref: (container) => {
        this.container = container;
      },
      ...getHTMLProps_default2(this.props)
    });
  }
};
ProgressBar22.propTypes = {
  uppy: uppy2.isRequired,
  fixed: import_prop_types42.default.bool,
  hideAfterFinish: import_prop_types42.default.bool
};
ProgressBar22.defaultProps = {
  fixed: false,
  hideAfterFinish: true
};
var import_prop_types52 = __toESM2(require_prop_types2(), 1);
var StatusBar32 = class extends Component52 {
  componentDidMount() {
    this.installPlugin();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.uppy !== this.props.uppy) {
      this.uninstallPlugin(prevProps);
      this.installPlugin();
    } else if (nonHtmlPropsHaveChanged2(this.props, prevProps)) {
      const options7 = {
        ...this.props,
        target: this.container
      };
      delete options7.uppy;
      this.plugin.setOptions(options7);
    }
  }
  componentWillUnmount() {
    this.uninstallPlugin();
  }
  installPlugin() {
    const {
      uppy: uppy22,
      hideUploadButton,
      hideRetryButton,
      hidePauseResumeButton,
      hideCancelButton,
      showProgressDetails,
      hideAfterFinish,
      doneButtonHandler
    } = this.props;
    const options7 = {
      id: "react:StatusBar",
      hideUploadButton,
      hideRetryButton,
      hidePauseResumeButton,
      hideCancelButton,
      showProgressDetails,
      hideAfterFinish,
      doneButtonHandler,
      target: this.container
    };
    delete options7.uppy;
    uppy22.use(StatusBar22, options7);
    this.plugin = uppy22.getPlugin(options7.id);
  }
  uninstallPlugin(props) {
    if (props === void 0) {
      props = this.props;
    }
    const {
      uppy: uppy22
    } = props;
    uppy22.removePlugin(this.plugin);
  }
  render() {
    return h8("div", {
      className: "uppy-Container",
      ref: (container) => {
        this.container = container;
      },
      ...getHTMLProps_default2(this.props)
    });
  }
};
StatusBar32.propTypes = {
  uppy: uppy2.isRequired,
  hideUploadButton: import_prop_types52.default.bool,
  hideRetryButton: import_prop_types52.default.bool,
  hidePauseResumeButton: import_prop_types52.default.bool,
  hideCancelButton: import_prop_types52.default.bool,
  showProgressDetails: import_prop_types52.default.bool,
  hideAfterFinish: import_prop_types52.default.bool,
  doneButtonHandler: import_prop_types52.default.func
};
StatusBar32.defaultProps = {
  hideUploadButton: false,
  hideRetryButton: false,
  hidePauseResumeButton: false,
  hideCancelButton: false,
  showProgressDetails: false,
  hideAfterFinish: true,
  doneButtonHandler: null
};
var import_prop_types62 = __toESM2(require_prop_types2(), 1);
var locale_default7 = {
  strings: {
    chooseFiles: "Choose files"
  }
};
var packageJson14 = {
  "version": "3.1.0"
};
var defaultOptions7 = {
  pretty: true,
  inputName: "files[]"
};
var FileInput3 = class extends UIPlugin_default {
  constructor(uppy22, opts) {
    super(uppy22, {
      ...defaultOptions7,
      ...opts
    });
    this.id = this.opts.id || "FileInput";
    this.title = "File Input";
    this.type = "acquirer";
    this.defaultLocale = locale_default7;
    this.i18nInit();
    this.render = this.render.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }
  addFiles(files) {
    const descriptors = files.map((file) => ({
      source: this.id,
      name: file.name,
      type: file.type,
      data: file
    }));
    try {
      this.uppy.addFiles(descriptors);
    } catch (err) {
      this.uppy.log(err);
    }
  }
  handleInputChange(event) {
    this.uppy.log("[FileInput] Something selected through input...");
    const files = toArray_default2(event.target.files);
    this.addFiles(files);
    event.target.value = null;
  }
  handleClick() {
    this.input.click();
  }
  render() {
    const hiddenInputStyle = {
      width: "0.1px",
      height: "0.1px",
      opacity: 0,
      overflow: "hidden",
      position: "absolute",
      zIndex: -1
    };
    const {
      restrictions
    } = this.uppy.opts;
    const accept = restrictions.allowedFileTypes ? restrictions.allowedFileTypes.join(",") : void 0;
    return y2("div", {
      className: "uppy-FileInput-container"
    }, y2("input", {
      className: "uppy-FileInput-input",
      style: this.opts.pretty ? hiddenInputStyle : void 0,
      type: "file",
      name: this.opts.inputName,
      onChange: this.handleInputChange,
      multiple: restrictions.maxNumberOfFiles !== 1,
      accept,
      ref: (input) => {
        this.input = input;
      }
    }), this.opts.pretty && y2("button", {
      className: "uppy-FileInput-btn",
      type: "button",
      onClick: this.handleClick
    }, this.i18n("chooseFiles")));
  }
  install() {
    const {
      target
    } = this.opts;
    if (target) {
      this.mount(target, this);
    }
  }
  uninstall() {
    this.unmount();
  }
};
FileInput3.VERSION = packageJson14.version;
var FileInput22 = class extends Component62 {
  componentDidMount() {
    this.installPlugin();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.uppy !== this.props.uppy) {
      this.uninstallPlugin(prevProps);
      this.installPlugin();
    }
  }
  componentWillUnmount() {
    this.uninstallPlugin();
  }
  installPlugin() {
    const {
      uppy: uppy22,
      locale: locale22,
      pretty,
      inputName
    } = this.props;
    const options7 = {
      id: "react:FileInput",
      locale: locale22,
      pretty,
      inputName,
      target: this.container
    };
    delete options7.uppy;
    uppy22.use(FileInput3, options7);
    this.plugin = uppy22.getPlugin(options7.id);
  }
  uninstallPlugin(props) {
    if (props === void 0) {
      props = this.props;
    }
    const {
      uppy: uppy22
    } = props;
    uppy22.removePlugin(this.plugin);
  }
  render() {
    return h9("div", {
      className: "uppy-Container",
      ref: (container) => {
        this.container = container;
      }
    });
  }
};
FileInput22.propTypes = {
  uppy: uppy2.isRequired,
  locale: locale2,
  pretty: import_prop_types62.default.bool,
  inputName: import_prop_types62.default.string
};
FileInput22.defaultProps = {
  locale: void 0,
  pretty: true,
  inputName: "files[]"
};
var formSchema32 = zod32.object({
  email: zod32.string().min(1, { message: "Email is required" }).email({
    message: "Must be a valid email"
  })
});
var node332 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "id"
    }
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v222 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v32 = [
    {
      "alias": "employer",
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "id"
        }
      ],
      "concreteType": "Employer",
      "kind": "LinkedField",
      "name": "accountsEmployerById",
      "plural": false,
      "selections": [
        v1,
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "employerId",
          "storageKey": null
        },
        v222,
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "webSite",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "industry",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "details",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "EmployerOfficeLocation",
          "kind": "LinkedField",
          "name": "officeLocations",
          "plural": true,
          "selections": [
            v1,
            v222,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "employerOfficeLocationId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "OfficeLocationAddress",
              "kind": "LinkedField",
              "name": "address",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "line1",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "line2",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "city",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "county",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "country",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "postCode",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerLocationsQuery",
      "selections": v32,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerLocationsQuery",
      "selections": v32
    },
    "params": {
      "cacheID": "2bb3c0bdc8dcc85f2c3b4c466e00df0e",
      "id": null,
      "metadata": {},
      "name": "EmployerLocationsQuery",
      "operationKind": "query",
      "text": "query EmployerLocationsQuery(\n  $id: UUID!\n) {\n  employer: accountsEmployerById(id: $id) {\n    id\n    employerId\n    name\n    webSite\n    industry\n    details\n    officeLocations {\n      id\n      name\n      employerOfficeLocationId\n      address {\n        line1\n        line2\n        city\n        county\n        country\n        postCode\n      }\n    }\n  }\n}\n"
    }
  };
}();
node332.hash = "2a0c6f9207f7e877769ce93f014042e1";
var node342 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "id"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "id"
    }
  ], v222 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "employerOfficeLocationId",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerLocationDetailsQuery",
      "selections": [
        {
          "alias": "officeLocations",
          "args": v1,
          "concreteType": "EmployerOfficeLocation",
          "kind": "LinkedField",
          "name": "accountOfficeLocationByNodeId",
          "plural": false,
          "selections": [
            v222,
            v32,
            v4,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "EmployerLocationDetailsEditor_location"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "EmployerLocationDetailsView_location"
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerLocationDetailsQuery",
      "selections": [
        {
          "alias": "officeLocations",
          "args": v1,
          "concreteType": "EmployerOfficeLocation",
          "kind": "LinkedField",
          "name": "accountOfficeLocationByNodeId",
          "plural": false,
          "selections": [
            v222,
            v32,
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": "OfficeLocationAddress",
              "kind": "LinkedField",
              "name": "address",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "line1",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "line2",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "city",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "county",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "country",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "postCode",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "221e5a04a89b87a061592d6bbca56147",
      "id": null,
      "metadata": {},
      "name": "EmployerLocationDetailsQuery",
      "operationKind": "query",
      "text": "query EmployerLocationDetailsQuery(\n  $id: ID!\n) {\n  officeLocations: accountOfficeLocationByNodeId(id: $id) {\n    id\n    name\n    employerOfficeLocationId\n    ...EmployerLocationDetailsEditor_location\n    ...EmployerLocationDetailsView_location\n  }\n}\n\nfragment EmployerLocationDetailsEditor_location on EmployerOfficeLocation {\n  id\n  name\n  address {\n    line1\n    line2\n    city\n    county\n    country\n    postCode\n  }\n}\n\nfragment EmployerLocationDetailsView_location on EmployerOfficeLocation {\n  id\n  name\n  address {\n    line1\n    line2\n    city\n    county\n    country\n    postCode\n  }\n}\n"
    }
  };
}();
node342.hash = "381cbae316be2bacd8eef7e2838f2c39";
var node352 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmployerLocationDetailsView_location",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "OfficeLocationAddress",
      "kind": "LinkedField",
      "name": "address",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "line1",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "line2",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "city",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "county",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "country",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "postCode",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "EmployerOfficeLocation",
  "abstractKey": null
};
node352.hash = "e1f46db700c48fe3882af3523906108c";
var node362 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmployerLocationDetailsEditor_location",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "OfficeLocationAddress",
      "kind": "LinkedField",
      "name": "address",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "line1",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "line2",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "city",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "county",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "country",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "postCode",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "EmployerOfficeLocation",
  "abstractKey": null
};
node362.hash = "db1f88c56d6d0c09acd7b2e1c247efb5";
var formSchema42 = zod4.object({
  name: zod4.string().min(1, { message: "Name cannot be blank" }),
  addressLine1: zod4.string().min(1, { message: "Address line 1 cannot be blank" }),
  addressLine2: zod4.string().optional(),
  city: zod4.string().min(1, { message: "City cannot be blank" }),
  county: zod4.string().min(1, { message: "County cannot be blank" }),
  postalCode: zod4.string().min(1, { message: "Postal Code cannot be blank" }),
  country: zod4.string().min(1, { message: "Country cannot be blank" })
});
var node372 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "name": "ASC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerSearchContainerQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EmployerSearchBox_employers"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerSearchContainerQuery",
      "selections": [
        {
          "alias": "list",
          "args": v1,
          "concreteType": "AccountsEmployersConnection",
          "kind": "LinkedField",
          "name": "accountsEmployers",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsEmployersEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Employer",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "entityId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "slug",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "webSite",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v1,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "EmployerSearchBox_list",
          "kind": "LinkedHandle",
          "name": "accountsEmployers"
        }
      ]
    },
    "params": {
      "cacheID": "29385a9cd0109f6dba2c9ca6a4306aac",
      "id": null,
      "metadata": {},
      "name": "EmployerSearchContainerQuery",
      "operationKind": "query",
      "text": "query EmployerSearchContainerQuery(\n  $where: EmployerFilter!\n) {\n  ...EmployerSearchBox_employers\n}\n\nfragment EmployerRow_account on Employer {\n  id\n  name\n  slug\n  webSite\n}\n\nfragment EmployerSearchBox_employers on Query {\n  list: accountsEmployers(first: 10, order: [{name: ASC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        entityId\n        code\n        employerId\n        name\n        slug\n        webSite\n        ...EmployerRow_account\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node372.hash = "d4085650d7cc8b3ef19bafa1d6e92711";
var EmployerSearchContainerQuery_graphql_default = node372;
var graphqlQuery22 = EmployerSearchContainerQuery_graphql_default;
var EmployerSearchContainer = ({
  defaultValue,
  onSearchCompleted
}) => {
  const [selectedResult, setSelectedResult] = useState62();
  const onSetSelected = useCallback72(
    (r4) => {
      setSelectedResult(r4);
      onSearchCompleted(r4);
    },
    [selectedResult]
  );
  const where = { isDeleted: { eq: false } };
  const query3 = useLazyLoadQuery42(
    graphqlQuery22,
    { where },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsx132(
    EmployerSearchBox,
    {
      onSelected: onSetSelected,
      employers: query3,
      defaultValue
    }
  );
};
var node382 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmployerRow_account",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "webSite",
      "storageKey": null
    }
  ],
  "type": "Employer",
  "abstractKey": null
};
node382.hash = "5f7da24cd711531c3e98cfcd9f64b367";
var node392 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "order"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "where"
  }, v222 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 25
    },
    {
      "kind": "Variable",
      "name": "order",
      "variableName": "order"
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployersListContainerQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EmployersListContainer_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "EmployersListContainerQuery",
      "selections": [
        {
          "alias": "list",
          "args": v222,
          "concreteType": "AccountsEmployersConnection",
          "kind": "LinkedField",
          "name": "accountsEmployers",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsEmployersEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Employer",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "slug",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "webSite",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v222,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "EmployersList_list",
          "kind": "LinkedHandle",
          "name": "accountsEmployers"
        }
      ]
    },
    "params": {
      "cacheID": "d0733d71be189557cd626c7b4f25b2a7",
      "id": null,
      "metadata": {},
      "name": "EmployersListContainerQuery",
      "operationKind": "query",
      "text": "query EmployersListContainerQuery(\n  $where: EmployerFilter!\n  $order: [EmployerSortInput!]\n) {\n  ...EmployersListContainer_list\n}\n\nfragment EmployerRow_account on Employer {\n  id\n  name\n  slug\n  webSite\n}\n\nfragment EmployersListContainer_list on Query {\n  list: accountsEmployers(first: 25, order: $order, where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        employerId\n        updatedAt\n        createdAt\n        code\n        name\n        slug\n        webSite\n        ...EmployerRow_account\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node392.hash = "06e99c1fe69ada41b97b0963f72f6a2e";
var node402 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 25,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "order"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v222 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v32 = [
    v1,
    v222,
    {
      "kind": "Variable",
      "name": "order",
      "variableName": "order"
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployersListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v222
          ],
          "kind": "FragmentSpread",
          "name": "EmployersListContainer_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployersListPaginationQuery",
      "selections": [
        {
          "alias": "list",
          "args": v32,
          "concreteType": "AccountsEmployersConnection",
          "kind": "LinkedField",
          "name": "accountsEmployers",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsEmployersEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Employer",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "slug",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "webSite",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v32,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "EmployersList_list",
          "kind": "LinkedHandle",
          "name": "accountsEmployers"
        }
      ]
    },
    "params": {
      "cacheID": "eee08e9514cdf8a220b0e34bcb15f1b6",
      "id": null,
      "metadata": {},
      "name": "EmployersListPaginationQuery",
      "operationKind": "query",
      "text": "query EmployersListPaginationQuery(\n  $after: String\n  $first: Int = 25\n  $order: [EmployerSortInput!]\n  $where: EmployerFilter\n) {\n  ...EmployersListContainer_list_2HEEH6\n}\n\nfragment EmployerRow_account on Employer {\n  id\n  name\n  slug\n  webSite\n}\n\nfragment EmployersListContainer_list_2HEEH6 on Query {\n  list: accountsEmployers(first: $first, after: $after, order: $order, where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        employerId\n        updatedAt\n        createdAt\n        code\n        name\n        slug\n        webSite\n        ...EmployerRow_account\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node402.hash = "a5b1f5acab6871c8faad31fdfa0c154c";
var EmployersListPaginationQuery_graphql_default = node402;
var node412 = function() {
  var v0 = [
    "list"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 25,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "order"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": EmployersListPaginationQuery_graphql_default
      }
    },
    "name": "EmployersListContainer_list",
    "selections": [
      {
        "alias": "list",
        "args": [
          {
            "kind": "Variable",
            "name": "order",
            "variableName": "order"
          },
          {
            "kind": "Variable",
            "name": "where",
            "variableName": "where"
          }
        ],
        "concreteType": "AccountsEmployersConnection",
        "kind": "LinkedField",
        "name": "__EmployersList_list_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountsEmployersEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Employer",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "employerId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "slug",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "webSite",
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "EmployerRow_account"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node412.hash = "a5b1f5acab6871c8faad31fdfa0c154c";
var node422 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }, v222 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 25
    },
    v1
  ], v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployersListContainerSearchQuery",
      "selections": [
        {
          "args": [
            v1
          ],
          "kind": "FragmentSpread",
          "name": "EmployersListContainer_query"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployersListContainerSearchQuery",
      "selections": [
        {
          "alias": null,
          "args": v222,
          "concreteType": "AccountEmployerUsersConnection",
          "kind": "LinkedField",
          "name": "accountEmployerUsers",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountEmployerUsersEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsEmployerUser",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Employer",
                      "kind": "LinkedField",
                      "name": "employer",
                      "plural": false,
                      "selections": [
                        v32,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "code",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "employerId",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    v32,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": v222,
          "filters": [
            "where"
          ],
          "handle": "connection",
          "key": "EmployersListContainer__accountEmployerUsers",
          "kind": "LinkedHandle",
          "name": "accountEmployerUsers"
        }
      ]
    },
    "params": {
      "cacheID": "e510984e1dce192070f8d5e6c710a8e5",
      "id": null,
      "metadata": {},
      "name": "EmployersListContainerSearchQuery",
      "operationKind": "query",
      "text": "query EmployersListContainerSearchQuery(\n  $where: AccountsEmployerUserFilter!\n) {\n  ...EmployersListContainer_query_3FC4Qo\n}\n\nfragment EmployersListContainer_query_3FC4Qo on Query {\n  accountEmployerUsers(first: 25, where: $where) {\n    totalCount\n    edges {\n      node {\n        employer {\n          id\n          code\n          name\n          employerId\n        }\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
    }
  };
}();
node422.hash = "ff96c7de2c8892de509e7a6744c85c68";
var node432 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 25,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "after",
      "variableName": "after"
    },
    {
      "kind": "Variable",
      "name": "first",
      "variableName": "first"
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ], v222 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployersListContainer_accountEmployerUsers",
      "selections": [
        {
          "args": v1,
          "kind": "FragmentSpread",
          "name": "EmployersListContainer_query"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployersListContainer_accountEmployerUsers",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "AccountEmployerUsersConnection",
          "kind": "LinkedField",
          "name": "accountEmployerUsers",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountEmployerUsersEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsEmployerUser",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Employer",
                      "kind": "LinkedField",
                      "name": "employer",
                      "plural": false,
                      "selections": [
                        v222,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "code",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "employerId",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    v222,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": v1,
          "filters": [
            "where"
          ],
          "handle": "connection",
          "key": "EmployersListContainer__accountEmployerUsers",
          "kind": "LinkedHandle",
          "name": "accountEmployerUsers"
        }
      ]
    },
    "params": {
      "cacheID": "a616d3c307abbdd3387068ea6da663b1",
      "id": null,
      "metadata": {},
      "name": "EmployersListContainer_accountEmployerUsers",
      "operationKind": "query",
      "text": "query EmployersListContainer_accountEmployerUsers(\n  $after: String\n  $first: Int = 25\n  $where: AccountsEmployerUserFilter\n) {\n  ...EmployersListContainer_query_3sueo6\n}\n\nfragment EmployersListContainer_query_3sueo6 on Query {\n  accountEmployerUsers(first: $first, after: $after, where: $where) {\n    totalCount\n    edges {\n      node {\n        employer {\n          id\n          code\n          name\n          employerId\n        }\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
    }
  };
}();
node432.hash = "9cd645fb58ded3b1bc3ccb4127fe4de6";
var EmployersListContainer_accountEmployerUsers_graphql_default = node432;
var node442 = function() {
  var v0 = [
    "accountEmployerUsers"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 25,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": EmployersListContainer_accountEmployerUsers_graphql_default
      }
    },
    "name": "EmployersListContainer_query",
    "selections": [
      {
        "alias": "accountEmployerUsers",
        "args": [
          {
            "kind": "Variable",
            "name": "where",
            "variableName": "where"
          }
        ],
        "concreteType": "AccountEmployerUsersConnection",
        "kind": "LinkedField",
        "name": "__EmployersListContainer__accountEmployerUsers_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountEmployerUsersEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountsEmployerUser",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Employer",
                    "kind": "LinkedField",
                    "name": "employer",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "id",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "code",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "employerId",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node442.hash = "9cd645fb58ded3b1bc3ccb4127fe4de6";
var node452 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "employerCode"
    }
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v222 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "employerId",
    "storageKey": null
  }, v32 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }, v4 = {
    "alias": "employer",
    "args": [
      {
        "kind": "Variable",
        "name": "code",
        "variableName": "employerCode"
      }
    ],
    "concreteType": "Employer",
    "kind": "LinkedField",
    "name": "accountsEmployerByCode",
    "plural": false,
    "selections": [
      v1,
      v222,
      v32
    ],
    "storageKey": null
  }, v5 = {
    "kind": "Variable",
    "name": "employerCode",
    "variableName": "employerCode"
  }, v6 = [
    v5,
    {
      "kind": "Literal",
      "name": "first",
      "value": 15
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": {
        "updatedAt": "DESC"
      }
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerUserGroupsListLayoutQuery",
      "selections": [
        v4,
        {
          "args": [
            v5
          ],
          "kind": "FragmentSpread",
          "name": "EmployerUserGroupsList_groups"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerUserGroupsListLayoutQuery",
      "selections": [
        v4,
        {
          "alias": "groups",
          "args": v6,
          "concreteType": "AccountEmployerUserGroupsByEmployerCodeConnection",
          "kind": "LinkedField",
          "name": "accountEmployerUserGroupsByEmployerCode",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountEmployerUserGroupsByEmployerCodeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsEmployerUserGroup",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v1,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    v222,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isDefault",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isAdminGroup",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "PermissionSet",
                      "kind": "LinkedField",
                      "name": "permissionSet",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ResourcePermissions",
                          "kind": "LinkedField",
                          "name": "permissions",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "actions",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "resource",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v32
          ],
          "storageKey": null
        },
        {
          "alias": "groups",
          "args": v6,
          "filters": [],
          "handle": "connection",
          "key": "EmployerUserGroupsList_groups",
          "kind": "LinkedHandle",
          "name": "accountEmployerUserGroupsByEmployerCode"
        }
      ]
    },
    "params": {
      "cacheID": "f3f7fa061b123f6b3996c41bbc516fbf",
      "id": null,
      "metadata": {},
      "name": "EmployerUserGroupsListLayoutQuery",
      "operationKind": "query",
      "text": "query EmployerUserGroupsListLayoutQuery(\n  $employerCode: Long!\n) {\n  employer: accountsEmployerByCode(code: $employerCode) {\n    id\n    employerId\n  }\n  ...EmployerUserGroupsList_groups_4pmpJH\n}\n\nfragment EmployerUserGroupView_group on AccountsEmployerUserGroup {\n  id\n  code\n  name\n  employerId\n  isDefault\n  isAdminGroup\n  description\n  permissionSet {\n    permissions {\n      actions\n      resource\n    }\n  }\n}\n\nfragment EmployerUserGroupsList_groups_4pmpJH on Query {\n  groups: accountEmployerUserGroupsByEmployerCode(employerCode: $employerCode, first: 15, order: {updatedAt: DESC}) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        code\n        name\n        employerId\n        isDefault\n        isAdminGroup\n        description\n        updatedAt\n        ...EmployerUserGroupView_group\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node452.hash = "8b19442829597595db81189b5c4f86fb";
var node462 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "employerCode"
    },
    {
      "defaultValue": 15,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": {
        "updatedAt": "DESC"
      },
      "kind": "LocalArgument",
      "name": "sort"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v222 = {
    "kind": "Variable",
    "name": "employerCode",
    "variableName": "employerCode"
  }, v32 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v4 = [
    v1,
    v222,
    v32,
    {
      "kind": "Variable",
      "name": "order",
      "variableName": "sort"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerUserGroupsListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v222,
            v32,
            {
              "kind": "Variable",
              "name": "sort",
              "variableName": "sort"
            }
          ],
          "kind": "FragmentSpread",
          "name": "EmployerUserGroupsList_groups"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerUserGroupsListPaginationQuery",
      "selections": [
        {
          "alias": "groups",
          "args": v4,
          "concreteType": "AccountEmployerUserGroupsByEmployerCodeConnection",
          "kind": "LinkedField",
          "name": "accountEmployerUserGroupsByEmployerCode",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountEmployerUserGroupsByEmployerCodeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsEmployerUserGroup",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isDefault",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isAdminGroup",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "PermissionSet",
                      "kind": "LinkedField",
                      "name": "permissionSet",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ResourcePermissions",
                          "kind": "LinkedField",
                          "name": "permissions",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "actions",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "resource",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "groups",
          "args": v4,
          "filters": [],
          "handle": "connection",
          "key": "EmployerUserGroupsList_groups",
          "kind": "LinkedHandle",
          "name": "accountEmployerUserGroupsByEmployerCode"
        }
      ]
    },
    "params": {
      "cacheID": "138f4bdde01ae8810fa2e59f4dc368e4",
      "id": null,
      "metadata": {},
      "name": "EmployerUserGroupsListPaginationQuery",
      "operationKind": "query",
      "text": "query EmployerUserGroupsListPaginationQuery(\n  $after: String\n  $employerCode: Long!\n  $first: Int = 15\n  $sort: [AccountsEmployerUserGroupSort!] = {updatedAt: DESC}\n) {\n  ...EmployerUserGroupsList_groups_47mpHu\n}\n\nfragment EmployerUserGroupView_group on AccountsEmployerUserGroup {\n  id\n  code\n  name\n  employerId\n  isDefault\n  isAdminGroup\n  description\n  permissionSet {\n    permissions {\n      actions\n      resource\n    }\n  }\n}\n\nfragment EmployerUserGroupsList_groups_47mpHu on Query {\n  groups: accountEmployerUserGroupsByEmployerCode(employerCode: $employerCode, first: $first, after: $after, order: $sort) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        code\n        name\n        employerId\n        isDefault\n        isAdminGroup\n        description\n        updatedAt\n        ...EmployerUserGroupView_group\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node462.hash = "35ddd17db8a9d46891c3425d699c45f9";
var EmployerUserGroupsListPaginationQuery_graphql_default = node462;
var node472 = function() {
  var v0 = [
    "groups"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "employerCode"
      },
      {
        "defaultValue": 15,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "defaultValue": {
          "updatedAt": "DESC"
        },
        "kind": "LocalArgument",
        "name": "sort"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": EmployerUserGroupsListPaginationQuery_graphql_default
      }
    },
    "name": "EmployerUserGroupsList_groups",
    "selections": [
      {
        "alias": "groups",
        "args": null,
        "concreteType": "AccountEmployerUserGroupsByEmployerCodeConnection",
        "kind": "LinkedField",
        "name": "__EmployerUserGroupsList_groups_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountEmployerUserGroupsByEmployerCodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountsEmployerUserGroup",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "employerId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isDefault",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isAdminGroup",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "EmployerUserGroupView_group"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node472.hash = "35ddd17db8a9d46891c3425d699c45f9";
var node482 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmployerUserGroupView_group",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "employerId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isDefault",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAdminGroup",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PermissionSet",
      "kind": "LinkedField",
      "name": "permissionSet",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ResourcePermissions",
          "kind": "LinkedField",
          "name": "permissions",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "actions",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "resource",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AccountsEmployerUserGroup",
  "abstractKey": null
};
node482.hash = "d50fb91ce3135e045c6c3595f8f31ce6";
var node492 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "code"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "code"
    }
  ], v222 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "groupId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "employerId",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isDefault",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isAdminGroup",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "concreteType": "PermissionSet",
    "kind": "LinkedField",
    "name": "permissionSet",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ResourcePermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "actions",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "resource",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v11 = [
    v5,
    v9
  ], v12 = {
    "alias": null,
    "args": null,
    "concreteType": "Authorizable",
    "kind": "LinkedField",
    "name": "authorizableSets",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AuthorizableResource",
        "kind": "LinkedField",
        "name": "resource",
        "plural": false,
        "selections": v11,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AuthorizableCategory",
        "kind": "LinkedField",
        "name": "category",
        "plural": false,
        "selections": [
          v5,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "label",
            "storageKey": null
          },
          v9
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AuthorizableAction",
        "kind": "LinkedField",
        "name": "actions",
        "plural": true,
        "selections": v11,
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v13 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerUserGroupLayoutQuery",
      "selections": [
        {
          "alias": "userGroup",
          "args": v1,
          "concreteType": "AccountsEmployerUserGroup",
          "kind": "LinkedField",
          "name": "accountEmployerUserGroupByCode",
          "plural": false,
          "selections": [
            v222,
            v32,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            v10,
            v12,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "EmployerUserGroupDetailsEditor_userGroup"
            },
            v13
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerUserGroupLayoutQuery",
      "selections": [
        {
          "alias": "userGroup",
          "args": v1,
          "concreteType": "AccountsEmployerUserGroup",
          "kind": "LinkedField",
          "name": "accountEmployerUserGroupByCode",
          "plural": false,
          "selections": [
            v222,
            v32,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            v10,
            v12,
            v13
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "41886244d8ee9d130fcd2bacbc06b9b4",
      "id": null,
      "metadata": {},
      "name": "EmployerUserGroupLayoutQuery",
      "operationKind": "query",
      "text": "query EmployerUserGroupLayoutQuery(\n  $code: Int!\n) {\n  userGroup: accountEmployerUserGroupByCode(code: $code) {\n    id\n    groupId\n    code\n    name\n    employerId\n    isDefault\n    isAdminGroup\n    description\n    permissionSet {\n      permissions {\n        actions\n        resource\n      }\n    }\n    authorizableSets {\n      resource {\n        name\n        description\n      }\n      category {\n        name\n        label\n        description\n      }\n      actions {\n        name\n        description\n      }\n    }\n    ...EmployerUserGroupDetailsEditor_userGroup\n  }\n}\n\nfragment EmployerUserGroupDetailsEditor_userGroup on AccountsEmployerUserGroup {\n  id\n  groupId\n  code\n  name\n  employerId\n  isDefault\n  isAdminGroup\n  description\n  permissionSet {\n    permissions {\n      actions\n      resource\n    }\n  }\n}\n"
    }
  };
}();
node492.hash = "ce1fffdc44b1f25133b4433d48f3957b";
var node502 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmployerUserGroupDetailsEditor_userGroup",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "groupId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "employerId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isDefault",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAdminGroup",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PermissionSet",
      "kind": "LinkedField",
      "name": "permissionSet",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ResourcePermissions",
          "kind": "LinkedField",
          "name": "permissions",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "actions",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "resource",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AccountsEmployerUserGroup",
  "abstractKey": null
};
node502.hash = "437305cf9be911e9e9f379e047b34326";
var FormSchema2 = zod5.object({
  name: zod5.string(),
  description: zod5.string(),
  isAdminGroup: zod5.boolean(),
  isDefault: zod5.boolean()
});
var node512 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "employerId"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "name": "ASC"
        }
      ]
    },
    {
      "fields": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "eq",
              "variableName": "employerId"
            }
          ],
          "kind": "ObjectValue",
          "name": "employerId"
        }
      ],
      "kind": "ObjectValue",
      "name": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerUserGroupSearchBoxInputQuery",
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "employerId",
              "variableName": "employerId"
            }
          ],
          "kind": "FragmentSpread",
          "name": "EmployerUserGroupSearchBox_groups"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerUserGroupSearchBoxInputQuery",
      "selections": [
        {
          "alias": "groups",
          "args": v1,
          "concreteType": "AccountEmployerUserGroupsConnection",
          "kind": "LinkedField",
          "name": "accountEmployerUserGroups",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountEmployerUserGroupsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsEmployerUserGroup",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "groupId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isAdminGroup",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isDefault",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "groups",
          "args": v1,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "EmployerUserGroupSearchBox_groups",
          "kind": "LinkedHandle",
          "name": "accountEmployerUserGroups"
        }
      ]
    },
    "params": {
      "cacheID": "cedd6fde17e6a38ef8e760bf085c9f9a",
      "id": null,
      "metadata": {},
      "name": "EmployerUserGroupSearchBoxInputQuery",
      "operationKind": "query",
      "text": "query EmployerUserGroupSearchBoxInputQuery(\n  $employerId: UUID!\n) {\n  ...EmployerUserGroupSearchBox_groups_4aLTpM\n}\n\nfragment EmployerUserGroupSearchBox_groups_4aLTpM on Query {\n  groups: accountEmployerUserGroups(first: 10, order: [{name: ASC}], where: {employerId: {eq: $employerId}}) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        groupId\n        name\n        description\n        isAdminGroup\n        isDefault\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node512.hash = "61a70fbe472b490f4997cc680a1d19fc";
var node522 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "employerId"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v222 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v32 = [
    v1,
    v222,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "name": "ASC"
        }
      ]
    },
    {
      "fields": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "eq",
              "variableName": "employerId"
            }
          ],
          "kind": "ObjectValue",
          "name": "employerId"
        }
      ],
      "kind": "ObjectValue",
      "name": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerUserGroupSearchBoxPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            {
              "kind": "Variable",
              "name": "employerId",
              "variableName": "employerId"
            },
            v222
          ],
          "kind": "FragmentSpread",
          "name": "EmployerUserGroupSearchBox_groups"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerUserGroupSearchBoxPaginationQuery",
      "selections": [
        {
          "alias": "groups",
          "args": v32,
          "concreteType": "AccountEmployerUserGroupsConnection",
          "kind": "LinkedField",
          "name": "accountEmployerUserGroups",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountEmployerUserGroupsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsEmployerUserGroup",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "groupId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isAdminGroup",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isDefault",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "groups",
          "args": v32,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "EmployerUserGroupSearchBox_groups",
          "kind": "LinkedHandle",
          "name": "accountEmployerUserGroups"
        }
      ]
    },
    "params": {
      "cacheID": "5998ac67b602db095c74deae9dce52a5",
      "id": null,
      "metadata": {},
      "name": "EmployerUserGroupSearchBoxPaginationQuery",
      "operationKind": "query",
      "text": "query EmployerUserGroupSearchBoxPaginationQuery(\n  $after: String\n  $employerId: UUID\n  $first: Int = 10\n) {\n  ...EmployerUserGroupSearchBox_groups_2553ZF\n}\n\nfragment EmployerUserGroupSearchBox_groups_2553ZF on Query {\n  groups: accountEmployerUserGroups(first: $first, after: $after, order: [{name: ASC}], where: {employerId: {eq: $employerId}}) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        groupId\n        name\n        description\n        isAdminGroup\n        isDefault\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node522.hash = "8469155d851bd9ba65bcc33931e839cd";
var EmployerUserGroupSearchBoxPaginationQuery_graphql_default = node522;
var node532 = function() {
  var v0 = [
    "groups"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "employerId"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": EmployerUserGroupSearchBoxPaginationQuery_graphql_default
      }
    },
    "name": "EmployerUserGroupSearchBox_groups",
    "selections": [
      {
        "alias": "groups",
        "args": [
          {
            "kind": "Literal",
            "name": "order",
            "value": [
              {
                "name": "ASC"
              }
            ]
          },
          {
            "fields": [
              {
                "fields": [
                  {
                    "kind": "Variable",
                    "name": "eq",
                    "variableName": "employerId"
                  }
                ],
                "kind": "ObjectValue",
                "name": "employerId"
              }
            ],
            "kind": "ObjectValue",
            "name": "where"
          }
        ],
        "concreteType": "AccountEmployerUserGroupsConnection",
        "kind": "LinkedField",
        "name": "__EmployerUserGroupSearchBox_groups_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountEmployerUserGroupsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountsEmployerUserGroup",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "groupId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isAdminGroup",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isDefault",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node532.hash = "8469155d851bd9ba65bcc33931e839cd";
var node542 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "employerCode"
    }
  ], v1 = [
    {
      "alias": "employer",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "employerCode"
        }
      ],
      "concreteType": "Employer",
      "kind": "LinkedField",
      "name": "accountsEmployerByCode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "entityId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerUsersListLoaderQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerUsersListLoaderQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "ed47167c3cb93216041ef2ac5b436af8",
      "id": null,
      "metadata": {},
      "name": "EmployerUsersListLoaderQuery",
      "operationKind": "query",
      "text": "query EmployerUsersListLoaderQuery(\n  $employerCode: Long!\n) {\n  employer: accountsEmployerByCode(code: $employerCode) {\n    id\n    entityId\n    name\n    code\n  }\n}\n"
    }
  };
}();
node542.hash = "1a17e8c30ceb059a9ac40de62886d60f";
var EmployerUsersListLoaderQuery_graphql_default = node542;
var node552 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "employerCode"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "userGroupId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "employerCode",
    "variableName": "employerCode"
  }, v222 = {
    "kind": "Variable",
    "name": "userGroupId",
    "variableName": "userGroupId"
  }, v32 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }, v4 = [
    v1,
    {
      "kind": "Literal",
      "name": "first",
      "value": 15
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": {
        "updatedAt": "DESC"
      }
    },
    v222,
    v32
  ], v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerUsersListLayoutQuery",
      "selections": [
        {
          "args": [
            v1,
            v222,
            v32
          ],
          "kind": "FragmentSpread",
          "name": "EmployerUsersList_users"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerUsersListLayoutQuery",
      "selections": [
        {
          "alias": "users",
          "args": v4,
          "concreteType": "AccountEmployerUsersByEmployerCodeConnection",
          "kind": "LinkedField",
          "name": "accountEmployerUsersByEmployerCode",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountEmployerUsersByEmployerCodeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsEmployerUser",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v5,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "accountId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "firstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "emailAddress",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountsEmployerUserGroup",
                      "kind": "LinkedField",
                      "name": "userGroups",
                      "plural": true,
                      "selections": [
                        v5,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "description",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isAdminGroup",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isDefault",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "users",
          "args": v4,
          "filters": [],
          "handle": "connection",
          "key": "EmployerUsersList_users",
          "kind": "LinkedHandle",
          "name": "accountEmployerUsersByEmployerCode"
        }
      ]
    },
    "params": {
      "cacheID": "b9573d6e3af271197b989e7ec74c689f",
      "id": null,
      "metadata": {},
      "name": "EmployerUsersListLayoutQuery",
      "operationKind": "query",
      "text": "query EmployerUsersListLayoutQuery(\n  $employerCode: Long!\n  $userGroupId: UUID\n  $where: AccountsEmployerUserFilter\n) {\n  ...EmployerUsersList_users_1pPHZP\n}\n\nfragment EmployerUserView_user on AccountsEmployerUser {\n  id\n  accountId\n  employerId\n  firstName\n  lastName\n  emailAddress\n  createdAt\n  updatedAt\n}\n\nfragment EmployerUsersList_users_1pPHZP on Query {\n  users: accountEmployerUsersByEmployerCode(employerCode: $employerCode, userGroupId: $userGroupId, first: 15, order: {updatedAt: DESC}, where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        code\n        accountId\n        employerId\n        firstName\n        lastName\n        emailAddress\n        updatedAt\n        createdAt\n        userGroups {\n          id\n          name\n          description\n          isAdminGroup\n          isDefault\n        }\n        ...EmployerUserView_user\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node552.hash = "237ca3a67ec2b53f69a10823fd7a364f";
var node562 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "employerId"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "name": "ASC"
        }
      ]
    },
    {
      "fields": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "eq",
              "variableName": "employerId"
            }
          ],
          "kind": "ObjectValue",
          "name": "employerId"
        }
      ],
      "kind": "ObjectValue",
      "name": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerUserGroupSearchContainerQuery",
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "employerId",
              "variableName": "employerId"
            }
          ],
          "kind": "FragmentSpread",
          "name": "EmployerUserGroupSearchBox_groups"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerUserGroupSearchContainerQuery",
      "selections": [
        {
          "alias": "groups",
          "args": v1,
          "concreteType": "AccountEmployerUserGroupsConnection",
          "kind": "LinkedField",
          "name": "accountEmployerUserGroups",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountEmployerUserGroupsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsEmployerUserGroup",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "groupId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isAdminGroup",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isDefault",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "groups",
          "args": v1,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "EmployerUserGroupSearchBox_groups",
          "kind": "LinkedHandle",
          "name": "accountEmployerUserGroups"
        }
      ]
    },
    "params": {
      "cacheID": "b9044526c65515ba1eb672a910d1ff8d",
      "id": null,
      "metadata": {},
      "name": "EmployerUserGroupSearchContainerQuery",
      "operationKind": "query",
      "text": "query EmployerUserGroupSearchContainerQuery(\n  $employerId: UUID!\n) {\n  ...EmployerUserGroupSearchBox_groups_4aLTpM\n}\n\nfragment EmployerUserGroupSearchBox_groups_4aLTpM on Query {\n  groups: accountEmployerUserGroups(first: 10, order: [{name: ASC}], where: {employerId: {eq: $employerId}}) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        groupId\n        name\n        description\n        isAdminGroup\n        isDefault\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node562.hash = "be92056a4e81b25f95c39b25abef551a";
var node572 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "employerCode"
    },
    {
      "defaultValue": 15,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": {
        "updatedAt": "DESC"
      },
      "kind": "LocalArgument",
      "name": "sort"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "userGroupId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v222 = {
    "kind": "Variable",
    "name": "employerCode",
    "variableName": "employerCode"
  }, v32 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v4 = {
    "kind": "Variable",
    "name": "userGroupId",
    "variableName": "userGroupId"
  }, v5 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }, v6 = [
    v1,
    v222,
    v32,
    {
      "kind": "Variable",
      "name": "order",
      "variableName": "sort"
    },
    v4,
    v5
  ], v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerUsersListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v222,
            v32,
            {
              "kind": "Variable",
              "name": "sort",
              "variableName": "sort"
            },
            v4,
            v5
          ],
          "kind": "FragmentSpread",
          "name": "EmployerUsersList_users"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerUsersListPaginationQuery",
      "selections": [
        {
          "alias": "users",
          "args": v6,
          "concreteType": "AccountEmployerUsersByEmployerCodeConnection",
          "kind": "LinkedField",
          "name": "accountEmployerUsersByEmployerCode",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountEmployerUsersByEmployerCodeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsEmployerUser",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v7,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "accountId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "firstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "emailAddress",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountsEmployerUserGroup",
                      "kind": "LinkedField",
                      "name": "userGroups",
                      "plural": true,
                      "selections": [
                        v7,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "description",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isAdminGroup",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isDefault",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "users",
          "args": v6,
          "filters": [],
          "handle": "connection",
          "key": "EmployerUsersList_users",
          "kind": "LinkedHandle",
          "name": "accountEmployerUsersByEmployerCode"
        }
      ]
    },
    "params": {
      "cacheID": "a24611072abc9af898483d3b9f236cbf",
      "id": null,
      "metadata": {},
      "name": "EmployerUsersListPaginationQuery",
      "operationKind": "query",
      "text": "query EmployerUsersListPaginationQuery(\n  $after: String\n  $employerCode: Long!\n  $first: Int = 15\n  $sort: [AccountsEmployerUserSort!] = {updatedAt: DESC}\n  $userGroupId: UUID\n  $where: AccountsEmployerUserFilter\n) {\n  ...EmployerUsersList_users_1tExRl\n}\n\nfragment EmployerUserView_user on AccountsEmployerUser {\n  id\n  accountId\n  employerId\n  firstName\n  lastName\n  emailAddress\n  createdAt\n  updatedAt\n}\n\nfragment EmployerUsersList_users_1tExRl on Query {\n  users: accountEmployerUsersByEmployerCode(employerCode: $employerCode, userGroupId: $userGroupId, first: $first, after: $after, order: $sort, where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        code\n        accountId\n        employerId\n        firstName\n        lastName\n        emailAddress\n        updatedAt\n        createdAt\n        userGroups {\n          id\n          name\n          description\n          isAdminGroup\n          isDefault\n        }\n        ...EmployerUserView_user\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node572.hash = "c71861d209d9477455950ca3e594443b";
var EmployerUsersListPaginationQuery_graphql_default = node572;
var node582 = function() {
  var v0 = [
    "users"
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "employerCode"
      },
      {
        "defaultValue": 15,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "defaultValue": {
          "updatedAt": "DESC"
        },
        "kind": "LocalArgument",
        "name": "sort"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "userGroupId"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": EmployerUsersListPaginationQuery_graphql_default
      }
    },
    "name": "EmployerUsersList_users",
    "selections": [
      {
        "alias": "users",
        "args": null,
        "concreteType": "AccountEmployerUsersByEmployerCodeConnection",
        "kind": "LinkedField",
        "name": "__EmployerUsersList_users_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountEmployerUsersByEmployerCodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountsEmployerUser",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  v1,
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accountId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "employerId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "emailAddress",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AccountsEmployerUserGroup",
                    "kind": "LinkedField",
                    "name": "userGroups",
                    "plural": true,
                    "selections": [
                      v1,
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "description",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isAdminGroup",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isDefault",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "EmployerUserView_user"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node582.hash = "c71861d209d9477455950ca3e594443b";
var node592 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmployerUserView_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "employerId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailAddress",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    }
  ],
  "type": "AccountsEmployerUser",
  "abstractKey": null
};
node592.hash = "8202d9684178842ac836c25f126959f1";
function useEmployerUsersListLoaderRouteData(routeId4) {
  const { queryRef: queryRef3 } = useRouteLoaderData52(routeId4);
  const query3 = usePreloadedQuery62(
    useEmployerUsersListLoaderRouteData.query,
    queryRef3
  );
  return {
    query: query3
  };
}
useEmployerUsersListLoaderRouteData.query = EmployerUsersListLoaderQuery_graphql_default;
var node602 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "code"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "code"
    }
  ], v222 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "accountId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "emailAddress",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isDeleted",
    "storageKey": null
  }, v9 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerUserLayoutQuery",
      "selections": [
        {
          "alias": "user",
          "args": v1,
          "concreteType": "AccountsEmployerUser",
          "kind": "LinkedField",
          "name": "accountEmployerUserByCode",
          "plural": false,
          "selections": [
            v222,
            v32,
            v4,
            v5,
            v6,
            v7,
            v8,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "EmployerUserDetailsEditor_user"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "EmployerUserGroupsEditor_user"
            },
            v9
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerUserLayoutQuery",
      "selections": [
        {
          "alias": "user",
          "args": v1,
          "concreteType": "AccountsEmployerUser",
          "kind": "LinkedField",
          "name": "accountEmployerUserByCode",
          "plural": false,
          "selections": [
            v222,
            v32,
            v4,
            v5,
            v6,
            v7,
            v8,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "code",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "employerId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isTest",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsEmployerUserGroup",
              "kind": "LinkedField",
              "name": "userGroups",
              "plural": true,
              "selections": [
                v222,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "description",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isAdminGroup",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isDefault",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "groupId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v9
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "6cc6338168966353cb265fc62fd94c12",
      "id": null,
      "metadata": {},
      "name": "EmployerUserLayoutQuery",
      "operationKind": "query",
      "text": "query EmployerUserLayoutQuery(\n  $code: Long!\n) {\n  user: accountEmployerUserByCode(code: $code) {\n    id\n    accountId\n    firstName\n    lastName\n    emailAddress\n    updatedAt\n    isDeleted\n    ...EmployerUserDetailsEditor_user\n    ...EmployerUserGroupsEditor_user\n  }\n}\n\nfragment EmployerUserDetailsEditor_user on AccountsEmployerUser {\n  id\n  code\n  accountId\n  employerId\n  firstName\n  lastName\n  emailAddress\n  updatedAt\n  createdAt\n  isTest\n  isDeleted\n  userGroups {\n    id\n    name\n    description\n    isAdminGroup\n    isDefault\n  }\n}\n\nfragment EmployerUserGroupsEditor_user on AccountsEmployerUser {\n  id\n  code\n  accountId\n  employerId\n  updatedAt\n  userGroups {\n    id\n    groupId\n    name\n    description\n    isAdminGroup\n    isDefault\n  }\n}\n"
    }
  };
}();
node602.hash = "215e08205f279f5a6885bdf57723c747";
var node612 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "EmployerUserDetailsEditor_user",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accountId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "employerId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "firstName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "emailAddress",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isTest",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isDeleted",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsEmployerUserGroup",
        "kind": "LinkedField",
        "name": "userGroups",
        "plural": true,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAdminGroup",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isDefault",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "AccountsEmployerUser",
    "abstractKey": null
  };
}();
node612.hash = "9702149c9b64b2fc8e0ca76efecc768e";
var FormSchema22 = zod6.object({
  firstName: zod6.string().min(1),
  lastName: zod6.string().min(1),
  isTest: zod6.boolean().optional()
});
var node622 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "EmployerUserGroupsEditor_user",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accountId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "employerId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsEmployerUserGroup",
        "kind": "LinkedField",
        "name": "userGroups",
        "plural": true,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "groupId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAdminGroup",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isDefault",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "AccountsEmployerUser",
    "abstractKey": null
  };
}();
node622.hash = "7855dfa800c7eac4d5c446d5c006bd45";
var formSchema5 = zod7.object({
  firstName: zod7.string().nonempty(),
  lastName: zod7.string().nonempty(),
  groupId: zod7.string().optional().nullable(),
  email: zod7.string().optional(),
  isTest: zod7.boolean().optional()
});
var node632 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmployerUserEmailEditor_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "employerId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailAddress",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    }
  ],
  "type": "AccountsEmployerUser",
  "abstractKey": null
};
node632.hash = "e4f7d6a87c1fe31eed39a0e9a8b9376c";
var FormSchema3 = zod8.object({
  email: zod8.string().optional()
});
var node642 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "EmployerUserGroupsViewer_user",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accountId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "employerId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsEmployerUserGroup",
        "kind": "LinkedField",
        "name": "userGroups",
        "plural": true,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "groupId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAdminGroup",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isDefault",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "AccountsEmployerUser",
    "abstractKey": null
  };
}();
node642.hash = "73810f0a92d6391550953c46b2c28743";
var node652 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmployerUserPasswordEditor_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "employerId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailAddress",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    }
  ],
  "type": "AccountsEmployerUser",
  "abstractKey": null
};
node652.hash = "baa9f1333017d3b42c2e488fb82c2b92";
var FormSchema4 = zod9.object({
  newPassword: zod9.string().min(8),
  originalPassword: zod9.string().min(8)
});
var node662 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "order"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "where"
  }, v222 = [
    {
      "alias": "users",
      "args": [
        {
          "kind": "Variable",
          "name": "order",
          "variableName": "order"
        },
        {
          "kind": "Variable",
          "name": "where",
          "variableName": "where"
        }
      ],
      "concreteType": "AccountEmployerUsersConnection",
      "kind": "LinkedField",
      "name": "accountEmployerUsers",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasPreviousPage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AccountEmployerUsersEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsEmployerUser",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "accountId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "firstName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "emailAddress",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerUserSearchOptionsQuery",
      "selections": v222,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "EmployerUserSearchOptionsQuery",
      "selections": v222
    },
    "params": {
      "cacheID": "baeddc8c2af430ac2eb779c3248b6411",
      "id": null,
      "metadata": {},
      "name": "EmployerUserSearchOptionsQuery",
      "operationKind": "query",
      "text": "query EmployerUserSearchOptionsQuery(\n  $where: AccountsEmployerUserFilter!\n  $order: [AccountsEmployerUserSort!]\n) {\n  users: accountEmployerUsers(where: $where, order: $order) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        accountId\n        firstName\n        lastName\n        emailAddress\n      }\n    }\n  }\n}\n"
    }
  };
}();
node662.hash = "76259e4a20a580feb62801928db69e34";
var EmployerUserSearchOptionsQuery_graphql_default = node662;
var queryDef102 = EmployerUserSearchOptionsQuery_graphql_default;
var EmployerUserSearchOptions = ({
  employerId,
  term,
  onNoResults
}) => {
  let where = {
    or: [
      { firstName: { startsWith: term } },
      { lastName: { startsWith: term } },
      { emailAddress: { startsWith: term } }
    ]
  };
  if (employerId) {
    where = {
      ...where,
      employerId: { eq: employerId }
    };
  }
  const query3 = useLazyLoadQuery82(
    queryDef102,
    { where },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { users } = query3;
  const rows = (users?.edges ?? []).map((e4) => e4.node).filter(isNotNull5);
  if (term && rows && rows.length === 0) {
    onNoResults();
  }
  return /* @__PURE__ */ jsx472(Combobox32.Options, { className: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm", children: rows.map((result) => /* @__PURE__ */ jsx472(
    Combobox32.Option,
    {
      value: result,
      className: ({ active }) => classNames18(
        "relative cursor-default select-none py-2 pl-3 pr-9",
        active ? "bg-info-600 text-white" : "text-gray-900"
      ),
      children: ({ active, selected }) => /* @__PURE__ */ jsxs292(Fragment82, { children: [
        /* @__PURE__ */ jsx472("div", { className: "flex", children: /* @__PURE__ */ jsx472(
          "span",
          {
            className: classNames18(
              "truncate",
              selected ? "font-semibold" : ""
            ),
            children: `${result.firstName} ${result.lastName} - ${result.emailAddress}`
          }
        ) }),
        selected && /* @__PURE__ */ jsx472(
          "span",
          {
            className: classNames18(
              "absolute inset-y-0 right-0 flex items-center pr-4",
              active ? "bg-info-600 text-white" : "text-info-600"
            ),
            children: /* @__PURE__ */ jsx472(CheckIcon32, { className: "h-5 w-5", "aria-hidden": "true" })
          }
        )
      ] })
    },
    result.accountId
  )) });
};
var compareResults = (a4, b3) => a4?.id === b3?.id;
var EmployerUserSearchBox = ({
  employerId,
  name,
  onSelected,
  onNoResults,
  value,
  disabled
}) => {
  const [selected, setSelected] = useState142(value);
  const [searchTerm, setSearchTerm] = useState142("");
  const onQueryChangeHandler = useMemo52(
    () => debounce5((q4) => setSearchTerm(q4), 500),
    []
  );
  useEffect52(() => {
    return () => {
      onQueryChangeHandler.cancel();
    };
  }, [onQueryChangeHandler]);
  const onSetSelected = useCallback232(
    (result) => {
      setSelected(result);
      onSelected(result);
    },
    [onSelected]
  );
  return /* @__PURE__ */ jsx482(Suspense24, { fallback: /* @__PURE__ */ jsx482("div", { children: "Searching...." }), children: /* @__PURE__ */ jsx482(
    Combobox42,
    {
      as: "div",
      name,
      className: "w-full",
      value: selected,
      onChange: onSetSelected,
      disabled,
      by: compareResults,
      children: /* @__PURE__ */ jsxs302("div", { className: "relative mt-2", children: [
        /* @__PURE__ */ jsx482(
          Combobox42.Input,
          {
            className: "focus:border-info-500 focus:ring-info-500 w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:outline-none focus:ring-1 sm:text-sm",
            onChange: (event) => onQueryChangeHandler(event.target.value),
            displayValue: (result) => {
              if (!result) {
                return "";
              }
              return `${result.firstName} ${result.lastName} - ${result.emailAddress}`;
            },
            autoComplete: "off"
          }
        ),
        /* @__PURE__ */ jsx482(Combobox42.Button, { className: "absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none", children: /* @__PURE__ */ jsx482(
          ChevronUpDownIcon32,
          {
            className: "h-5 w-5 text-gray-400",
            "aria-hidden": "true"
          }
        ) }),
        /* @__PURE__ */ jsx482(Suspense24, { fallback: "Searching...", children: searchTerm && /* @__PURE__ */ jsx482(
          EmployerUserSearchOptions,
          {
            employerId,
            term: searchTerm,
            onNoResults: () => {
              if (onNoResults) {
                onNoResults(searchTerm);
              }
            }
          }
        ) })
      ] })
    }
  ) });
};
var EmployerUserSearchContainer = ({
  employerId,
  name,
  onSearchCompleted,
  value,
  disabled
}) => {
  const [selectedResult, setSelectedResult] = useState152();
  const onSetSelected = useCallback242(
    (r4) => {
      setSelectedResult(r4);
      onSearchCompleted(r4);
    },
    [selectedResult]
  );
  return /* @__PURE__ */ jsx502(
    EmployerUserSearchBox,
    {
      employerId,
      name: name || "accounts-employer-user-search",
      onSelected: onSetSelected,
      value,
      disabled
    }
  );
};
var node672 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "employerUserCode"
    }
  ], v1 = [
    {
      "alias": "user",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "employerUserCode"
        }
      ],
      "concreteType": "AccountsEmployerUser",
      "kind": "LinkedField",
      "name": "accountEmployerUserByCode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accountId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "emailAddress",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerUserImpersonateRouteQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerUserImpersonateRouteQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "c1cad739cebc3bb466c6399caa622708",
      "id": null,
      "metadata": {},
      "name": "EmployerUserImpersonateRouteQuery",
      "operationKind": "query",
      "text": "query EmployerUserImpersonateRouteQuery(\n  $employerUserCode: Long!\n) {\n  user: accountEmployerUserByCode(code: $employerUserCode) {\n    id\n    accountId\n    code\n    firstName\n    lastName\n    emailAddress\n  }\n}\n"
    }
  };
}();
node672.hash = "e800e428291bf1a82a30b372795f849d";

// src/projects/components/ProjectAddMember.tsx
import { createClientMutationId as createClientMutationId25 } from "shared-lib";
import { jsx as jsx93, jsxs as jsxs60 } from "react/jsx-runtime";
var ProjectAddMemberContainer = ({
  projectRouteId
}) => {
  const navigate = useNavigate12();
  const { project } = useProjectRouteData(projectRouteId);
  const [addMember, isAddingMember] = useProjectMemberAdd();
  const [selected, setSelected] = useState33(
    null
  );
  const onSearchCompleted = useCallback53(
    (result) => {
      setSelected(result);
    },
    [setSelected]
  );
  const connectionId = ConnectionHandler3.getConnectionID(
    "root",
    "ProjectMembersList_members"
  );
  const onAddMember = useCallback53(async () => {
    if (!project || !selected) {
      return;
    }
    const input = {
      projectId: project.projectId,
      userId: selected.accountId,
      clientMutationId: createClientMutationId25()
    };
    const response = await addMember({
      input,
      connections: [connectionId]
    });
    if (response.data.payload) {
      navigate(`../members`);
    }
  }, [addMember]);
  return /* @__PURE__ */ jsx93(Suspense25, { fallback: /* @__PURE__ */ jsx93(EdSkeleton23, {}), children: /* @__PURE__ */ jsx93("div", { className: "mx-auto flex-1 flex-col gap-2 border bg-white p-8 md:w-1/2 lg:my-8", children: selected ? /* @__PURE__ */ jsxs60("div", { className: "flex-col gap-3 py-2", children: [
    /* @__PURE__ */ jsx93("div", { className: "text-primary-500 border-b py-4 text-xl font-medium", children: /* @__PURE__ */ jsx93("h1", { children: "Add to Project" }) }),
    /* @__PURE__ */ jsxs60("div", { className: "flex-col gap-2 py-4", children: [
      /* @__PURE__ */ jsxs60("div", { className: "text-primary-500 flex items-center gap-1", children: [
        /* @__PURE__ */ jsx93("div", { children: selected.firstName }),
        /* @__PURE__ */ jsx93("div", { children: selected.lastName })
      ] }),
      /* @__PURE__ */ jsx93("div", { className: "flex items-center gap-1 text-gray-900", children: /* @__PURE__ */ jsx93("div", { children: selected.emailAddress }) })
    ] }),
    /* @__PURE__ */ jsx93("div", { className: "my-2 border-t py-4", children: /* @__PURE__ */ jsx93(
      Button26,
      {
        color: "primary",
        disabled: isAddingMember,
        clicked: onAddMember,
        children: "Add as Member"
      }
    ) })
  ] }) : /* @__PURE__ */ jsxs60("div", { className: "py-2", children: [
    /* @__PURE__ */ jsx93("div", { className: "text-primary-500 py-2 font-medium", children: /* @__PURE__ */ jsx93("h1", { children: "Find User" }) }),
    /* @__PURE__ */ jsx93(
      EmployerUserSearchContainer,
      {
        employerId: project.employerId,
        onSearchCompleted
      }
    )
  ] }) }) });
};
var createRoute6 = (parentRouteId, projectRouteId, environment) => {
  const routeId4 = parentRouteId + "-add-member";
  return {
    id: routeId4,
    path: "add-member",
    element: /* @__PURE__ */ jsx93(ProjectAddMemberContainer, { projectRouteId })
  };
};

// src/projects/components/ProjectRoutes.tsx
import { jsx as jsx94, jsxs as jsxs61 } from "react/jsx-runtime";
var ProjectLayout = ({
  projectRouteId,
  inList
}) => {
  const location2 = useLocation();
  const data = useProjectRouteData(projectRouteId);
  const { project } = data;
  const tabs6 = useMemo17(() => {
    return [
      createLinkState(location2, "Vacancies", `../vacancies`),
      createLinkState(location2, "Members", `../members`),
      createLinkState(location2, "Edit", `../update`)
    ];
  }, [location2]);
  if (!project) {
    return /* @__PURE__ */ jsx94(EdSkeleton24, {});
  }
  return /* @__PURE__ */ jsxs61("div", { children: [
    /* @__PURE__ */ jsx94("div", { className: "flex flex-col justify-between gap-2 bg-white px-4 py-2 lg:flex-row lg:gap-0 lg:py-0", children: /* @__PURE__ */ jsx94("div", { className: "flex w-full flex-col items-start justify-between lg:flex-row lg:items-center", children: /* @__PURE__ */ jsxs61("div", { className: "@container flex w-full items-center justify-between  gap-3", children: [
      /* @__PURE__ */ jsx94("div", { className: "flex w-full grow py-2 text-2xl font-medium text-gray-700", children: project.name }),
      /* @__PURE__ */ jsxs61("div", { className: "flex w-full items-center gap-2", children: [
        /* @__PURE__ */ jsx94("div", { className: "hidden w-full gap-1 md:flex", children: /* @__PURE__ */ jsx94("div", { className: "flex w-full justify-end", children: /* @__PURE__ */ jsx94(Tabs, { tabs: tabs6 }, project.id) }) }),
        /* @__PURE__ */ jsx94(
          EdLink8,
          {
            name: "add-vacancy",
            href: "/employers/app/projects/create",
            className: "lg:hidden",
            children: /* @__PURE__ */ jsx94(Button27, { color: "green", size: Size11.sm, children: "New\xA0project" })
          }
        )
      ] })
    ] }) }) }),
    /* @__PURE__ */ jsx94("div", { className: "flex w-full gap-1 px-2 md:hidden", children: /* @__PURE__ */ jsx94(SelectLinks, { tabs: tabs6 }) }),
    /* @__PURE__ */ jsx94(Outlet4, {})
  ] });
};
var createProjectRoutes = (routePrefix, environment, context, inList) => {
  const routeId4 = routePrefix + "-project";
  return [
    {
      path: "*",
      id: routeId4,
      element: /* @__PURE__ */ jsx94(ProjectLayout, { projectRouteId: routeId4, inList }),
      errorElement: /* @__PURE__ */ jsx94(ErrorContainer7, {}),
      handle: {
        crumb: () => /* @__PURE__ */ jsx94(ProjectLink, { routeId: routeId4 })
      },
      loader: ({ params }) => {
        return loader3(environment, params);
      },
      children: [
        createRoute2(
          routeId4,
          routeId4,
          environment,
          context,
          inList
        ),
        createRoute3(routeId4, routeId4, environment, context),
        createRoute5(routeId4, routeId4, environment, context),
        createRoute6(routeId4, routeId4, environment),
        {
          path: "*",
          element: /* @__PURE__ */ jsx94(Navigate5, { to: "vacancies", replace: true })
        }
      ]
    }
  ];
};

// src/projects/components/__generated__/ProjectListQuery.graphql.ts
var node140 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cursor"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  }, v23 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "myProjects"
  }, v32 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "order"
  }, v4 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "where"
  }, v5 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v6 = {
    "kind": "Variable",
    "name": "myProjects",
    "variableName": "myProjects"
  }, v7 = {
    "kind": "Variable",
    "name": "order",
    "variableName": "order"
  }, v8 = [
    {
      "kind": "Variable",
      "name": "after",
      "variableName": "cursor"
    },
    v5,
    v6,
    v7,
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1,
        v23,
        v32,
        v4
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "ProjectListQuery",
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "cursor",
              "variableName": "cursor"
            },
            v5,
            v6,
            v7
          ],
          "kind": "FragmentSpread",
          "name": "ProjectList_projects"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v23,
        v4,
        v32,
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "ProjectListQuery",
      "selections": [
        {
          "alias": "projects",
          "args": v8,
          "concreteType": "RecruitProjectsConnection",
          "kind": "LinkedField",
          "name": "recruitProjects",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProjectsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProject",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "projectId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "vacancyCount",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "projects",
          "args": v8,
          "filters": [
            "myProjects",
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "ProjectList_projects",
          "kind": "LinkedHandle",
          "name": "recruitProjects"
        }
      ]
    },
    "params": {
      "cacheID": "1aa6832adbaf70181dddf2348a094b18",
      "id": null,
      "metadata": {},
      "name": "ProjectListQuery",
      "operationKind": "query",
      "text": "query ProjectListQuery(\n  $myProjects: Boolean\n  $where: RecruitProjectFilter!\n  $order: [RecruitProjectSort!]\n  $first: Int\n  $cursor: String\n) {\n  ...ProjectList_projects_hTAKf\n}\n\nfragment ProjectHeader_project on RecruitProject {\n  id\n  projectId\n  employerId\n  createdAt\n  updatedAt\n  name\n  description\n}\n\nfragment ProjectList_projects_hTAKf on Query {\n  projects: recruitProjects(myProjects: $myProjects, first: $first, after: $cursor, order: $order, where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      endCursor\n    }\n    edges {\n      node {\n        id\n        code\n        projectId\n        employerId\n        createdAt\n        updatedAt\n        vacancyCount\n        name\n        ...ProjectView_project\n        __typename\n      }\n      cursor\n    }\n  }\n}\n\nfragment ProjectView_project on RecruitProject {\n  id\n  projectId\n  employerId\n  createdAt\n  updatedAt\n  name\n  description\n  ...ProjectHeader_project\n}\n"
    }
  };
}();
node140.hash = "a867a810a9b1c5d30b2518afd1d9bf49";
var ProjectListQuery_graphql_default = node140;

// src/projects/components/__generated__/ProjectListPaginationQuery.graphql.ts
var node141 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": 25,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "myProjects"
    },
    {
      "defaultValue": {
        "createdAt": "DESC"
      },
      "kind": "LocalArgument",
      "name": "order"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v23 = {
    "kind": "Variable",
    "name": "myProjects",
    "variableName": "myProjects"
  }, v32 = {
    "kind": "Variable",
    "name": "order",
    "variableName": "order"
  }, v4 = [
    {
      "kind": "Variable",
      "name": "after",
      "variableName": "cursor"
    },
    v1,
    v23,
    v32,
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ProjectListPaginationQuery",
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "cursor",
              "variableName": "cursor"
            },
            v1,
            v23,
            v32
          ],
          "kind": "FragmentSpread",
          "name": "ProjectList_projects"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ProjectListPaginationQuery",
      "selections": [
        {
          "alias": "projects",
          "args": v4,
          "concreteType": "RecruitProjectsConnection",
          "kind": "LinkedField",
          "name": "recruitProjects",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProjectsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProject",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "projectId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "vacancyCount",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "projects",
          "args": v4,
          "filters": [
            "myProjects",
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "ProjectList_projects",
          "kind": "LinkedHandle",
          "name": "recruitProjects"
        }
      ]
    },
    "params": {
      "cacheID": "57f79676d1648ad7ea25dd9c9bc6b75b",
      "id": null,
      "metadata": {},
      "name": "ProjectListPaginationQuery",
      "operationKind": "query",
      "text": "query ProjectListPaginationQuery(\n  $cursor: String = null\n  $first: Int = 25\n  $myProjects: Boolean = false\n  $order: [RecruitProjectSort!] = {createdAt: DESC}\n  $where: RecruitProjectFilter\n) {\n  ...ProjectList_projects_hTAKf\n}\n\nfragment ProjectHeader_project on RecruitProject {\n  id\n  projectId\n  employerId\n  createdAt\n  updatedAt\n  name\n  description\n}\n\nfragment ProjectList_projects_hTAKf on Query {\n  projects: recruitProjects(myProjects: $myProjects, first: $first, after: $cursor, order: $order, where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      endCursor\n    }\n    edges {\n      node {\n        id\n        code\n        projectId\n        employerId\n        createdAt\n        updatedAt\n        vacancyCount\n        name\n        ...ProjectView_project\n        __typename\n      }\n      cursor\n    }\n  }\n}\n\nfragment ProjectView_project on RecruitProject {\n  id\n  projectId\n  employerId\n  createdAt\n  updatedAt\n  name\n  description\n  ...ProjectHeader_project\n}\n"
    }
  };
}();
node141.hash = "90f646c9aae2f3268aac6562fce4fbc0";
var ProjectListPaginationQuery_graphql_default = node141;

// src/projects/components/__generated__/ProjectList_projects.graphql.ts
var node143 = function() {
  var v0 = [
    "projects"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cursor"
      },
      {
        "defaultValue": 25,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "myProjects"
      },
      {
        "defaultValue": {
          "createdAt": "DESC"
        },
        "kind": "LocalArgument",
        "name": "order"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "cursor",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "cursor"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": ProjectListPaginationQuery_graphql_default
      }
    },
    "name": "ProjectList_projects",
    "selections": [
      {
        "alias": "projects",
        "args": [
          {
            "kind": "Variable",
            "name": "myProjects",
            "variableName": "myProjects"
          },
          {
            "kind": "Variable",
            "name": "order",
            "variableName": "order"
          },
          {
            "kind": "Variable",
            "name": "where",
            "variableName": "where"
          }
        ],
        "concreteType": "RecruitProjectsConnection",
        "kind": "LinkedField",
        "name": "__ProjectList_projects_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitProjectsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitProject",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "projectId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "employerId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "vacancyCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ProjectView_project"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node143.hash = "90f646c9aae2f3268aac6562fce4fbc0";
var ProjectList_projects_graphql_default = node143;

// src/projects/components/ProjectList.tsx
import {
  isValidElement as isValidElement4,
  Suspense as Suspense26,
  useCallback as useCallback55,
  useEffect as useEffect14,
  useMemo as useMemo18,
  useTransition as useTransition7
} from "react";
import {
  loadQuery as loadQuery8,
  usePaginationFragment as usePaginationFragment8,
  usePreloadedQuery as usePreloadedQuery8,
  useQueryLoader as useQueryLoader2
} from "react-relay";
import { formatDistanceToNow as formatDistanceToNow4, parseISO as parseISO7 } from "date-fns";
import { isNotNullOrUndefined as isNotNullOrUndefined4, useToggle as useToggle14 } from "shared-lib";
import {
  Button as Button28,
  EdButtonLink as EdButtonLink4,
  EdLink as EdLink9,
  EdSkeleton as EdSkeleton25,
  IconText,
  Icons as Icons2,
  ListLayout as ListLayout4,
  Size as Size12,
  classNames as classNames9
} from "shared-ui";

// src/projects/components/__generated__/ProjectView_project.graphql.ts
var node144 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectView_project",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "employerId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProjectHeader_project"
    }
  ],
  "type": "RecruitProject",
  "abstractKey": null
};
node144.hash = "f321ffec32eeee580761964d438c447b";
var ProjectView_project_graphql_default = node144;

// src/projects/components/ProjectView.tsx
import { useFragment as useFragment35 } from "react-relay";

// src/projects/components/__generated__/ProjectHeader_project.graphql.ts
var node145 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectHeader_project",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "employerId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ],
  "type": "RecruitProject",
  "abstractKey": null
};
node145.hash = "9de12b4d3c0f75a6f15338ee4ed98215";
var ProjectHeader_project_graphql_default = node145;

// src/projects/components/ProjectHeader.tsx
import { useFragment as useFragment34 } from "react-relay";
import { format as format8, parseISO as parseISO6 } from "date-fns";
import { jsx as jsx95, jsxs as jsxs63 } from "react/jsx-runtime";
var fragmentDef29 = ProjectHeader_project_graphql_default;
var ProjectHeader = ({ fragmentRef }) => {
  const data = useFragment34(fragmentDef29, fragmentRef);
  return /* @__PURE__ */ jsxs63("div", { className: "p-2", children: [
    /* @__PURE__ */ jsx95("h3", { className: "text-lg font-medium uppercase leading-6 text-gray-900", children: data.name }),
    /* @__PURE__ */ jsxs63("p", { className: "mt-2 flex max-w-2xl items-center text-sm text-gray-500 sm:space-x-2", children: [
      /* @__PURE__ */ jsx95("span", { className: "hidden font-bold sm:block", children: "Updated" }),
      /* @__PURE__ */ jsx95("span", { children: format8(parseISO6(data.updatedAt), "PPPp") })
    ] })
  ] });
};

// src/projects/components/ProjectView.tsx
import { jsx as jsx96, jsxs as jsxs64 } from "react/jsx-runtime";
var fragmentDef30 = ProjectView_project_graphql_default;
var ProjectView = ({ fragmentRef }) => {
  const data = useFragment35(fragmentDef30, fragmentRef);
  return /* @__PURE__ */ jsxs64("div", { children: [
    /* @__PURE__ */ jsx96(ProjectHeader, { fragmentRef: data }),
    /* @__PURE__ */ jsx96("div", { className: "grid", children: /* @__PURE__ */ jsx96("div", { children: data.description }) })
  ] });
};

// src/projects/components/ProjectFilters.tsx
import { useCallback as useCallback54, useEffect as useEffect13 } from "react";
import { atom as atom7, useRecoilState as useRecoilState3 } from "recoil";
import { CheckBox as CheckBox2, Spinner as Spinner6 } from "shared-ui";

// src/projects/lib/Project.ts
var projectSortName = {
  id: "name",
  name: "Name"
};
var projectSortValues = [
  projectSortName,
  {
    id: "canonicalCompanyName",
    name: "Canonical Company"
  },
  {
    id: "updatedAt",
    name: "Updated On"
  },
  {
    id: "createdAt",
    name: "Created On"
  },
  {
    id: "code",
    name: "Project Id"
  }
];

// src/projects/components/ProjectFilters.tsx
import { jsx as jsx97, jsxs as jsxs65 } from "react/jsx-runtime";
var projectFilterState = atom7({
  key: "projectFilterState",
  default: {
    myProjects: false,
    sortField: "createdAt",
    sortDir: "DESC",
    filterBy: null,
    filterValue: null
  }
});
var ProjectFilters = ({ onChanged, isLoading = false }) => {
  const [options7, setOptions] = useRecoilState3(projectFilterState);
  useEffect13(() => {
    onChanged(options7);
  }, [onChanged, options7]);
  const onQueryChange = useCallback54(
    (query3) => {
      setOptions((current) => ({
        ...current,
        filterValue: query3
      }));
    },
    [setOptions]
  );
  const onSortChange = useCallback54(
    (item) => {
      const sortField = item?.id || projectSortName.id;
      setOptions((current) => ({
        ...current,
        sortField
      }));
    },
    [setOptions]
  );
  const onSortDirChange = useCallback54(
    (order2) => {
      const sortDir = order2;
      setOptions((current) => ({
        ...current,
        sortDir
      }));
    },
    [setOptions]
  );
  const onMyProjectChange = useCallback54(
    (value) => {
      setOptions((current) => ({
        ...current,
        myProjects: value
      }));
    },
    [setOptions]
  );
  return /* @__PURE__ */ jsxs65("div", { className: "flex w-full flex-col gap-3 py-4 lg:w-auto lg:flex-row lg:items-center lg:gap-1", children: [
    isLoading && /* @__PURE__ */ jsx97("div", { className: "flex items-center", children: /* @__PURE__ */ jsx97(Spinner6, {}) }),
    /* @__PURE__ */ jsx97("div", { className: "flex justify-between", children: /* @__PURE__ */ jsxs65("div", { className: "flex items-center", children: [
      /* @__PURE__ */ jsx97("div", { className: "px-2 text-sm text-gray-900 ", children: "My\xA0Projects" }),
      /* @__PURE__ */ jsx97(
        CheckBox2,
        {
          checked: options7.myProjects,
          onChanged: onMyProjectChange
        }
      )
    ] }) }),
    /* @__PURE__ */ jsx97("div", { className: "flex w-full items-center justify-between", children: /* @__PURE__ */ jsx97("div", { className: "w-full grow lg:min-w-[300px] xl:min-w-[400px]", children: /* @__PURE__ */ jsx97(
      TextQueryFilter,
      {
        query: options7.filterValue,
        placeholder: "Search",
        onChanged: onQueryChange
      }
    ) }) }),
    /* @__PURE__ */ jsx97("div", { className: "flex items-center justify-between", children: /* @__PURE__ */ jsxs65("div", { className: "flex grow items-center gap-2", children: [
      /* @__PURE__ */ jsx97(
        SingleFilter,
        {
          widthClass: "xl:min-w-[200px] md:w-48 grow",
          selected: options7.sortField,
          values: projectSortValues,
          defaultValue: projectSortName,
          onChanged: onSortChange
        }
      ),
      /* @__PURE__ */ jsx97("div", { children: /* @__PURE__ */ jsx97(
        SortDirectionList,
        {
          value: options7.sortDir,
          onChanged: onSortDirChange
        }
      ) })
    ] }) })
  ] });
};

// src/projects/components/ProjectList.tsx
import { Fragment as Fragment24, jsx as jsx98, jsxs as jsxs66 } from "react/jsx-runtime";
var queryDef13 = ProjectListQuery_graphql_default;
var fragment5 = ProjectList_projects_graphql_default;
var SectionElement3 = ({ children }) => {
  return /* @__PURE__ */ jsx98("div", { className: "px-2 py-1 sm:px-8 sm:py-5", children });
};
var ItemHeader2 = ({ section }) => {
  const code = section.context.code;
  const titleIsElement = isValidElement4(section.itemTitle);
  return /* @__PURE__ */ jsxs66("div", { children: [
    /* @__PURE__ */ jsx98("div", { children: /* @__PURE__ */ jsx98("h1", { children: "Project" }) }),
    titleIsElement ? section.itemTitle : /* @__PURE__ */ jsx98("div", { className: "font-InterMedium text-info-gray-800 text-3xl font-bold tracking-tight", children: section.itemTitle }),
    /* @__PURE__ */ jsx98("div", { className: "flex items-center space-x-2 sm:justify-end", children: /* @__PURE__ */ jsx98(EdButtonLink4, { name: "View", to: `../../../view/${code}` }) })
  ] });
};
var ProjectListLoader = ({
  employerId,
  queryRef: queryRef3
}) => {
  const data = usePreloadedQuery8(queryDef13, queryRef3);
  return /* @__PURE__ */ jsx98(ProjectListLayout, { employerId, fragmentRef: data });
};
var ProjectListLayout = ({
  fragmentRef
}) => {
  const { data, loadNext, refetch, isLoadingNext } = usePaginationFragment8(fragment5, fragmentRef);
  const { projects } = data;
  const [isPending, startTransition2] = useTransition7();
  const sections = (projects?.edges || []).filter(isNotNullOrUndefined4).map((edge) => edge.node).map((project) => {
    return {
      key: project.code.toString(),
      mobileLink: `../${project.code}`,
      itemTitle: project.name,
      listTitle: /* @__PURE__ */ jsxs66("div", { className: "flex w-full grow justify-between gap-2", children: [
        /* @__PURE__ */ jsx98("div", { className: "text-sm font-medium uppercase", children: project.name }),
        /* @__PURE__ */ jsx98("div", { className: "text-primary-900 text-sm font-medium", children: project.vacancyCount })
      ] }),
      description: /* @__PURE__ */ jsxs66("div", { className: "text-xs", children: [
        "Updated",
        " ",
        formatDistanceToNow4(parseISO7(project.updatedAt), {
          addSuffix: true
        })
      ] }),
      hideIcon: true,
      icon: () => null,
      iconForeground: "text-primary-700",
      iconBackground: "bg-primary-50",
      context: {
        code: project.code
      },
      element: /* @__PURE__ */ jsx98(SectionElement3, { children: /* @__PURE__ */ jsx98(ProjectView, { fragmentRef: project }) })
    };
  });
  const onChanged = useCallback55(
    (val) => {
      startTransition2(() => {
        refetch({
          myProjects: val.myProjects,
          order: [{ [val.sortField]: val.sortDir }],
          where: {
            name: {
              contains: val.filterValue || ""
            },
            isArchived: {
              eq: false
            }
          }
        });
      });
    },
    [refetch]
  );
  const [showFilters, toggleFilters] = useToggle14(false);
  const loadMore = useCallback55(() => {
    if (isLoadingNext) {
      return;
    }
    startTransition2(() => {
      loadNext(15);
    });
  }, [isLoadingNext, loadNext]);
  return /* @__PURE__ */ jsxs66(Fragment24, { children: [
    /* @__PURE__ */ jsx98("div", { className: "flex flex-col  border-b bg-white lg:mt-0 lg:pb-0", children: /* @__PURE__ */ jsx98("div", { className: "flex flex-col justify-between gap-2 px-4 py-2 lg:flex-row lg:gap-0 lg:py-0", children: /* @__PURE__ */ jsxs66("div", { className: "flex w-full flex-col items-start justify-between lg:flex-row lg:items-center", children: [
      /* @__PURE__ */ jsxs66("div", { className: "flex items-center justify-between gap-3", children: [
        /* @__PURE__ */ jsx98("div", { className: "py-2 text-2xl font-medium text-gray-700", children: "Projects" }),
        /* @__PURE__ */ jsxs66("div", { onClick: toggleFilters, className: "flex gap-2 lg:hidden", children: [
          /* @__PURE__ */ jsx98(Button28, { color: "primary", children: /* @__PURE__ */ jsx98(IconText, { text: "Filters", icon: Icons2.FilterHorizontal }) }),
          /* @__PURE__ */ jsx98(
            EdLink9,
            {
              name: "add-vacancy",
              href: "/employers/app/projects/create",
              className: "block lg:hidden",
              children: /* @__PURE__ */ jsx98(Button28, { color: "green", size: Size12.sm, children: "New\xA0project" })
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ jsx98(
        "div",
        {
          className: classNames9(
            "w-full justify-center lg:flex",
            !showFilters && "hidden"
          ),
          children: /* @__PURE__ */ jsx98(
            ProjectFilters,
            {
              sort: defaultSort,
              onChanged,
              isLoading: isPending
            }
          )
        }
      ),
      /* @__PURE__ */ jsx98(
        EdLink9,
        {
          name: "add-vacancy",
          href: "/employers/app/projects/create",
          className: "hidden lg:block",
          children: /* @__PURE__ */ jsx98(Button28, { color: "green", size: Size12.lg, children: "New\xA0project" })
        }
      )
    ] }) }) }),
    /* @__PURE__ */ jsx98(
      ListLayout4,
      {
        sections,
        itemHeader: (s4) => /* @__PURE__ */ jsx98(ItemHeader2, { section: s4 }),
        loadMore,
        isLoading: isLoadingNext,
        showFilters: false
      }
    )
  ] });
};
var defaultSort = {
  createdAt: "DESC"
};
var ProjectList = ({ employerId }) => {
  const where = useMemo18(
    () => ({
      isArchived: {
        eq: false
      }
    }),
    []
  );
  const [queryReference, loadQuery48, disposeQuery] = useQueryLoader2(queryDef13);
  useEffect14(() => {
    loadQuery48({
      cursor: null,
      first: 25,
      myProjects: false,
      order: [{ createdAt: "DESC" }],
      where
    });
  }, [loadQuery48, where]);
  return /* @__PURE__ */ jsx98(Suspense26, { fallback: /* @__PURE__ */ jsx98(EdSkeleton25, {}), children: queryReference && /* @__PURE__ */ jsx98(ProjectListLoader, { employerId, queryRef: queryReference }) });
};

// src/projects/components/ProjectSearchBox.tsx
import {
  Suspense as Suspense27,
  useCallback as useCallback56,
  useEffect as useEffect15,
  useMemo as useMemo19,
  useState as useState34
} from "react";
import { debounce as debounce6 } from "lodash-es";
import { ChevronUpDownIcon as ChevronUpDownIcon4 } from "@heroicons/react/24/solid";
import { Combobox as Combobox7 } from "@headlessui/react";

// src/projects/components/__generated__/ProjectSearchBoxOptionsQuery.graphql.ts
var node146 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "alias": "results",
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 20
        },
        {
          "kind": "Literal",
          "name": "order",
          "value": [
            {
              "name": "ASC"
            }
          ]
        },
        {
          "kind": "Variable",
          "name": "where",
          "variableName": "where"
        }
      ],
      "concreteType": "RecruitProjectsConnection",
      "kind": "LinkedField",
      "name": "recruitProjects",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasPreviousPage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RecruitProjectsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProject",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "projectId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ProjectSearchBoxOptionsQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ProjectSearchBoxOptionsQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "e082634352a66dc415d134169416b688",
      "id": null,
      "metadata": {},
      "name": "ProjectSearchBoxOptionsQuery",
      "operationKind": "query",
      "text": "query ProjectSearchBoxOptionsQuery(\n  $where: RecruitProjectFilter!\n) {\n  results: recruitProjects(first: 20, order: [{name: ASC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        projectId\n        name\n      }\n    }\n  }\n}\n"
    }
  };
}();
node146.hash = "7b2374d0f1f44103955b0cd9f23ede7c";
var ProjectSearchBoxOptionsQuery_graphql_default = node146;

// src/projects/components/ProjectSearchBoxOptions.tsx
import { useLazyLoadQuery as useLazyLoadQuery15 } from "react-relay";
import { Combobox as Combobox6 } from "@headlessui/react";
import { CheckIcon as CheckIcon4 } from "@heroicons/react/24/solid";
import { classNames as classNames10 } from "shared-ui";
import { Fragment as Fragment25, jsx as jsx99, jsxs as jsxs67 } from "react/jsx-runtime";
var queryDef14 = ProjectSearchBoxOptionsQuery_graphql_default;
var ProjectSearchBoxOptions = ({
  term,
  employerId
}) => {
  let where = {
    and: [{ employerId: { eq: employerId } }]
  };
  if (term) {
    where = {
      and: [{ employerId: { eq: employerId } }, { name: { startsWith: term } }]
    };
  }
  const query3 = useLazyLoadQuery15(
    queryDef14,
    {
      where
    },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { results } = query3;
  const rows = (results?.edges ?? []).map((edge) => edge.node).map((n3) => {
    return {
      id: n3.projectId,
      name: n3.name
    };
  });
  return /* @__PURE__ */ jsx99(Combobox6.Options, { className: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm", children: rows.map((result) => /* @__PURE__ */ jsx99(
    Combobox6.Option,
    {
      value: result,
      className: ({ active }) => classNames10(
        "relative cursor-default select-none py-2 pl-3 pr-9",
        active ? "bg-info-600 text-white" : "text-gray-900"
      ),
      children: ({ active, selected }) => /* @__PURE__ */ jsxs67(Fragment25, { children: [
        /* @__PURE__ */ jsx99("div", { className: "flex", children: /* @__PURE__ */ jsx99(
          "span",
          {
            className: classNames10(
              "truncate",
              selected ? "font-semibold" : ""
            ),
            children: result && result.name ? result.name : ""
          }
        ) }),
        selected && /* @__PURE__ */ jsx99(
          "span",
          {
            className: classNames10(
              "absolute inset-y-0 right-0 flex items-center pr-4",
              active ? "bg-info-600 text-white" : "text-info-600"
            ),
            children: /* @__PURE__ */ jsx99(CheckIcon4, { className: "h-5 w-5", "aria-hidden": "true" })
          }
        )
      ] })
    },
    result.id
  )) });
};

// src/projects/components/ProjectSearchBox.tsx
import { jsx as jsx100, jsxs as jsxs68 } from "react/jsx-runtime";
var ProjectSearchBox = ({
  name,
  employerId,
  placeholder,
  onSelected,
  defaultValue,
  showLabel
}) => {
  const showsLabel = showLabel === void 0 ? false : showLabel;
  const [selected, setSelected] = useState34(
    defaultValue ?? null
  );
  const [searchTerm, setSearchTerm] = useState34("");
  const onQueryChangeHandler = useMemo19(
    () => debounce6((q4) => setSearchTerm(q4), 500),
    []
  );
  useEffect15(() => {
    return () => {
      onQueryChangeHandler.cancel();
    };
  }, []);
  const onSetSelected = useCallback56(
    (r4) => {
      setSelected(r4);
      onSelected(r4);
    },
    [selected]
  );
  return /* @__PURE__ */ jsxs68(Combobox7, { name, as: "div", value: selected, onChange: onSetSelected, children: [
    showsLabel && /* @__PURE__ */ jsx100(Combobox7.Label, { className: "block text-sm font-medium text-gray-700", children: "Project" }),
    /* @__PURE__ */ jsxs68("div", { className: "relative", children: [
      /* @__PURE__ */ jsx100(
        Combobox7.Input,
        {
          className: "focus:border-info-500 focus:ring-info-500 w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:outline-none focus:ring-1 sm:text-sm",
          onChange: (event) => onQueryChangeHandler(event.target.value),
          displayValue: (result) => {
            if (result) {
              return result.name;
            }
            return "";
          },
          autoComplete: "off"
        }
      ),
      /* @__PURE__ */ jsx100(Combobox7.Button, { className: "absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none", children: /* @__PURE__ */ jsx100(
        ChevronUpDownIcon4,
        {
          className: "h-5 w-5 text-gray-400",
          "aria-hidden": "true"
        }
      ) }),
      /* @__PURE__ */ jsx100(Suspense27, { fallback: "Searching...", children: /* @__PURE__ */ jsx100(ProjectSearchBoxOptions, { employerId, term: searchTerm }) })
    ] })
  ] });
};

// src/projects/components/ProjectSearchBoxInput.tsx
import { Controller as Controller6 } from "react-hook-form";
import { jsx as jsx101, jsxs as jsxs69 } from "react/jsx-runtime";
var ProjectSearchBoxInput = ({
  name,
  control,
  employerId,
  placeholder,
  onSelected,
  label
}) => {
  return /* @__PURE__ */ jsxs69("div", { className: "flex flex-col gap-1", children: [
    /* @__PURE__ */ jsx101("div", { className: "flex w-full justify-between", children: label && /* @__PURE__ */ jsx101("label", { className: "text-xs", children: label }) }),
    /* @__PURE__ */ jsx101(
      Controller6,
      {
        control,
        name,
        render: ({ field: { onChange: onControllerChange, value } }) => {
          return /* @__PURE__ */ jsx101(
            ProjectSearchBox,
            {
              name,
              placeholder,
              employerId,
              onSelected: (result) => {
                onControllerChange(result);
                if (onSelected) {
                  onSelected(result);
                }
              },
              defaultValue: value ?? null
            }
          );
        }
      }
    )
  ] });
};

// src/projects/components/__generated__/ProjectCreateRouteQuery.graphql.ts
var node147 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "code"
    }
  ], v1 = [
    {
      "alias": "employer",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "code"
        }
      ],
      "concreteType": "Employer",
      "kind": "LinkedField",
      "name": "accountsEmployerByCode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "employerId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ProjectCreateRouteQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ProjectCreateRouteQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "a18af149257a4aab5db02070b9046f15",
      "id": null,
      "metadata": {},
      "name": "ProjectCreateRouteQuery",
      "operationKind": "query",
      "text": "query ProjectCreateRouteQuery(\n  $code: Long!\n) {\n  employer: accountsEmployerByCode(code: $code) {\n    id\n    employerId\n    code\n    name\n  }\n}\n"
    }
  };
}();
node147.hash = "5fdb884f203999156848068516331775";
var ProjectCreateRouteQuery_graphql_default = node147;

// src/projects/components/ProjectCreateRoute.tsx
import { Suspense as Suspense28, useCallback as useCallback58 } from "react";
import { useNavigate as useNavigate13 } from "react-router-dom";
import { loadQuery as loadQuery9 } from "react-relay";
import { useRouteData as useRouteData4 } from "shared-lib";
import { BreadcrumbLink as BreadcrumbLink4, EdSkeleton as EdSkeleton26 } from "shared-ui";
import { resolveEmployerCode as resolveEmployerCode3 } from "app-core";

// src/projects/components/ProjectCreateForm.tsx
import { useCallback as useCallback57 } from "react";
import * as zod10 from "zod";
import { useForm as useForm10 } from "react-hook-form";
import { zodResolver as zodResolver10 } from "@hookform/resolvers/zod";
import {
  createClientMutationId as createClientMutationId26,
  useSetUserErrorCodes as useSetUserErrorCodes7,
  useUserErrorCode as useUserErrorCode6
} from "shared-lib";
import {
  ActionContainer as ActionContainer7,
  ErrorField as ErrorField5,
  FormErrorCodes as FormErrorCodes3,
  FormInputRow as FormInputRow5,
  FormTextAreaInput as FormTextAreaInput4,
  InputField as InputField3
} from "shared-ui";
import { jsx as jsx103, jsxs as jsxs70 } from "react/jsx-runtime";
var formSchema6 = zod10.object({
  projectName: zod10.string().min(1, { message: "Project Name is required" }),
  projectDescription: zod10.string().min(1, { message: "Project Description is required" })
});
var ProjectCreateForm = ({
  employerId,
  onCreate,
  onCancel
}) => {
  const defaultValues2 = {
    projectName: "",
    projectDescription: ""
  };
  const setErrorCode = useSetUserErrorCodes7();
  const { register, handleSubmit, watch, formState, control } = useForm10({
    resolver: zodResolver10(formSchema6),
    defaultValues: defaultValues2,
    mode: "onChange"
  });
  const userErrorCode = useUserErrorCode6();
  const [createProject, isCreatingProject] = useProjectCreate();
  const onSave = useCallback57(
    async (form) => {
      setErrorCode(null);
      if (!form.projectName || !form.projectDescription) {
        return;
      }
      const input = {
        employerId,
        clientMutationId: createClientMutationId26(),
        projectName: form.projectName,
        projectDescription: form.projectDescription
      };
      const response = await createProject({ input });
      if (response.data.userErrors && response.data.userErrors.length > 0) {
        setErrorCode(response.data.userErrors);
      }
      if (response.data.payload?.node) {
        onCreate(response.data.payload.node);
      }
    },
    [createProject]
  );
  const onSubmit = handleSubmit(
    async (form) => {
      await onSave(form);
    },
    (invalid) => {
      console.error(invalid);
    }
  );
  const { errors, isValid, isDirty } = formState;
  const errorDisplay = /* @__PURE__ */ jsx103(FormErrorCodes3, {});
  return /* @__PURE__ */ jsxs70("form", { onSubmit, children: [
    errorDisplay,
    /* @__PURE__ */ jsxs70(
      ActionContainer7,
      {
        isDirty,
        showSubmit: true,
        showCancel: true,
        submitText: "Create Project",
        onCancel,
        isDisabled: isCreatingProject,
        titleTop: `Create Project`,
        children: [
          /* @__PURE__ */ jsxs70(FormInputRow5, { name: "projectName", title: "Name *", children: [
            /* @__PURE__ */ jsx103(
              InputField3,
              {
                register,
                name: "projectName",
                required: true,
                placeholder: "Project Name"
              }
            ),
            /* @__PURE__ */ jsx103(ErrorField5, { field: errors.projectName })
          ] }),
          /* @__PURE__ */ jsxs70(FormInputRow5, { name: "projectDescription", title: "Description *", children: [
            /* @__PURE__ */ jsx103(
              FormTextAreaInput4,
              {
                rows: 6,
                register,
                name: "projectDescription",
                required: false,
                placeholder: "Project Description"
              }
            ),
            /* @__PURE__ */ jsx103(ErrorField5, { field: errors.projectDescription })
          ] })
        ]
      }
    )
  ] });
};

// src/projects/components/ProjectCreateRoute.tsx
import { jsx as jsx104 } from "react/jsx-runtime";
var queryDef15 = ProjectCreateRouteQuery_graphql_default;
async function loader6(environment, params, context) {
  const code = resolveEmployerCode3(params, context);
  return loadQuery9(environment, queryDef15, {
    code
  });
}
var ProjectCreate = ({ routeId: routeId4 }) => {
  const navigate = useNavigate13();
  const data = useRouteData4(queryDef15, routeId4);
  const { employer } = data;
  const onCreated = useCallback58(
    (project) => {
      navigate(`../${project.code}`);
    },
    [navigate]
  );
  const onCancel = useCallback58(() => {
    navigate(`../`);
  }, [navigate]);
  if (!employer) {
    return /* @__PURE__ */ jsx104(EdSkeleton26, {});
  }
  return /* @__PURE__ */ jsx104(Suspense28, { fallback: /* @__PURE__ */ jsx104(EdSkeleton26, {}), children: /* @__PURE__ */ jsx104(
    ProjectCreateForm,
    {
      employerId: employer?.employerId,
      onCreate: onCreated,
      onCancel
    }
  ) });
};
var createRoute7 = (routePrefix, environment, context) => {
  const id18 = routePrefix + "-project-create";
  return {
    id: id18,
    path: "create",
    element: /* @__PURE__ */ jsx104(ProjectCreate, { routeId: id18 }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx104(BreadcrumbLink4, { to: "create", label: "Create" })
    },
    loader: ({ params }) => {
      return loader6(environment, params, context);
    }
  };
};

// src/vacancies/mutations/__generated__/UseRecruitVacancyCloneMutation.graphql.ts
var node148 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "UserError",
    "abstractKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseRecruitVacancyCloneMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitVacancyClonePayload",
          "kind": "LinkedField",
          "name": "recruitVacancyClone",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v23
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseRecruitVacancyCloneMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitVacancyClonePayload",
          "kind": "LinkedField",
          "name": "recruitVacancyClone",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v23
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "acfcc99cb135992fe363c5c30e2d6ca7",
      "id": null,
      "metadata": {},
      "name": "UseRecruitVacancyCloneMutation",
      "operationKind": "mutation",
      "text": "mutation UseRecruitVacancyCloneMutation(\n  $input: RecruitVacancyCloneInput!\n) {\n  result: recruitVacancyClone(input: $input) {\n    userErrors {\n      __typename\n      ... on UserError {\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node148.hash = "4b6306f40c88b7b80b16fab4e2c7be7a";
var UseRecruitVacancyCloneMutation_graphql_default = node148;

// src/vacancies/mutations/UseRecruitVacancyClone.ts
import { useAsyncMutation as useAsyncMutation34 } from "shared-lib";
var mutationDef41 = UseRecruitVacancyCloneMutation_graphql_default;
function useRecruitVacancyClone() {
  const [commit11, isBusy] = useAsyncMutation34(mutationDef41);
  return [commit11, isBusy];
}

// src/vacancies/components/VacancyCopy.tsx
import { Fragment as Fragment26, jsx as jsx105, jsxs as jsxs71 } from "react/jsx-runtime";
var formSchema7 = z5.object({
  project: z5.object({
    id: z5.string(),
    name: z5.string()
  }),
  vacancies: z5.array(
    z5.object({
      id: z5.string(),
      code: z5.number(),
      name: z5.string(),
      vacancyId: z5.string()
    })
  ).nonempty()
});
function VacancyCopy({
  vacancies,
  clearSelectedVacancies,
  toggleCopyVacancy
}) {
  const account = useUserSessionContext3();
  const {
    control,
    handleSubmit,
    register,
    watch,
    formState: { errors },
    getValues
  } = useForm11({
    resolver: zodResolver11(formSchema7),
    defaultValues: {
      vacancies
    }
  });
  watch("project");
  const [commit11, isFulfilling] = useRecruitVacancyClone();
  const onSubmit = handleSubmit(async (data) => {
    const vacancyPromises = data.vacancies.map(
      (vacancy) => commit11({
        input: {
          clientMutationId: createClientMutationId27(),
          cloneAsTemplate: false,
          clonedName: vacancy.name,
          toProjectId: data.project.id,
          vacancyId: vacancy.vacancyId
        }
      })
    );
    const vacancyPromisesData = await Promise.all(vacancyPromises);
    if (!vacancyPromisesData?.[0]?.result?.userErrors) {
      clearSelectedVacancies();
      toggleCopyVacancy();
    }
  });
  const { fields } = useFieldArray({
    control,
    // control props comes from useForm (optional: if you are using FormContext)
    name: "vacancies"
    // unique name for your Field Array
  });
  if (!account.employerId) {
    return /* @__PURE__ */ jsx105(Spinner7, {});
  }
  return /* @__PURE__ */ jsx105(Card, { className: "mt-10", children: /* @__PURE__ */ jsxs71("div", { children: [
    /* @__PURE__ */ jsx105("h1", { className: "text-2xl", children: "Copy vacancies" }),
    /* @__PURE__ */ jsx105(
      Table,
      {
        header: ["Code", "Vacancy Name"],
        items: fields.map((vacancy) => {
          return [
            {
              recordId: vacancy.id,
              value: vacancy.code,
              key: "Code"
            },
            {
              recordId: vacancy.id,
              value: vacancy.name,
              key: "Name"
            }
          ];
        }),
        children: ({ key, value, recordId, index: index2 }) => {
          return /* @__PURE__ */ jsxs71(Fragment26, { children: [
            /* @__PURE__ */ jsx105("div", { className: "@4xl:block hidden", children: value }, key + value + "lg"),
            /* @__PURE__ */ jsxs71(
              "div",
              {
                className: "@4xl:hidden grid grid-cols-2",
                children: [
                  /* @__PURE__ */ jsx105("div", { className: "font-bold", children: key }),
                  /* @__PURE__ */ jsxs71("div", { children: [
                    key == "Code" && value,
                    key == "Name" && /* @__PURE__ */ jsx105(
                      FormInput8,
                      {
                        register,
                        name: `vacancies.${index2}.name`
                      },
                      recordId
                    )
                  ] })
                ]
              },
              key + value + "sm"
            )
          ] });
        }
      }
    ),
    /* @__PURE__ */ jsx105(
      ProjectSearchBoxInput,
      {
        label: "Project",
        name: "project",
        control,
        employerId: account.employerId
      }
    ),
    getValues("project") != null && /* @__PURE__ */ jsxs71(Fragment26, { children: [
      /* @__PURE__ */ jsxs71(Button29, { color: `green`, className: `mt-3`, onClick: onSubmit, children: [
        "Copy ",
        fields.length,
        " vacancies to ",
        getValues("project")?.name
      ] }),
      isFulfilling && /* @__PURE__ */ jsx105(Spinner7, {})
    ] })
  ] }) });
}

// src/vacancies/components/VacancyMove.tsx
import { useFieldArray as useFieldArray2, useForm as useForm12 } from "react-hook-form";
import { z as z6 } from "zod";
import { zodResolver as zodResolver12 } from "@hookform/resolvers/zod";
import { useUserSessionContext as useUserSessionContext4 } from "app-core";
import { Button as Button30, Card as Card2, Spinner as Spinner8, Table as Table2 } from "shared-ui";
import { createClientMutationId as createClientMutationId28 } from "shared-lib";

// src/vacancies/mutations/__generated__/UseRecruitVacancyMoveMutation.graphql.ts
var node149 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "UserError",
    "abstractKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseRecruitVacancyMoveMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitVacancyMovePayload",
          "kind": "LinkedField",
          "name": "recruitVacancyMove",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v23
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseRecruitVacancyMoveMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitVacancyMovePayload",
          "kind": "LinkedField",
          "name": "recruitVacancyMove",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v23
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "fa29c62f6e8ca2731e2e8688686e59cc",
      "id": null,
      "metadata": {},
      "name": "UseRecruitVacancyMoveMutation",
      "operationKind": "mutation",
      "text": "mutation UseRecruitVacancyMoveMutation(\n  $input: RecruitVacancyMoveInput!\n) {\n  result: recruitVacancyMove(input: $input) {\n    userErrors {\n      __typename\n      ... on UserError {\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node149.hash = "5297682f889a6be7ce98154b3ab2097c";
var UseRecruitVacancyMoveMutation_graphql_default = node149;

// src/vacancies/mutations/UseRecruitVacancyMove.ts
import { useAsyncMutation as useAsyncMutation35 } from "shared-lib";
var mutationDef42 = UseRecruitVacancyMoveMutation_graphql_default;
function useRecruitVacancyMove() {
  const [commit11, isBusy] = useAsyncMutation35(mutationDef42);
  return [commit11, isBusy];
}

// src/vacancies/components/VacancyMove.tsx
import { Fragment as Fragment27, jsx as jsx106, jsxs as jsxs73 } from "react/jsx-runtime";
var formSchema8 = z6.object({
  project: z6.object({
    id: z6.string(),
    name: z6.string()
  }),
  vacancies: z6.array(
    z6.object({
      id: z6.string(),
      code: z6.number(),
      name: z6.string(),
      vacancyId: z6.string()
    })
  ).nonempty()
});
function VacancyMove({
  vacancies,
  clearSelectedVacancies,
  toggleMoveVacancy
}) {
  const account = useUserSessionContext4();
  const {
    control,
    handleSubmit,
    register,
    watch,
    formState: { errors },
    getValues
  } = useForm12({
    resolver: zodResolver12(formSchema8),
    defaultValues: {
      vacancies
    }
  });
  watch("project");
  const [commit11, isFulfilling] = useRecruitVacancyMove();
  const onSubmit = handleSubmit(async (data) => {
    const vacancyPromises = data.vacancies.map(
      (vacancy) => commit11({
        input: {
          clientMutationId: createClientMutationId28(),
          toProjectId: data.project.id,
          vacancyId: vacancy.vacancyId
        }
      })
    );
    const vacancyPromisesData = await Promise.all(vacancyPromises);
    if (!vacancyPromisesData?.[0]?.result?.userErrors) {
      clearSelectedVacancies();
      toggleMoveVacancy();
    }
  });
  const { fields } = useFieldArray2({
    control,
    // control props comes from useForm (optional: if you are using FormContext)
    name: "vacancies"
    // unique name for your Field Array
  });
  if (!account.employerId) {
    return /* @__PURE__ */ jsx106(Spinner8, {});
  }
  return /* @__PURE__ */ jsx106(Card2, { className: "mt-10", children: /* @__PURE__ */ jsxs73("div", { children: [
    /* @__PURE__ */ jsx106("h1", { className: "text-2xl", children: "Move vacancies" }),
    /* @__PURE__ */ jsx106(
      Table2,
      {
        header: ["Code", "Vacancy Name"],
        items: fields.map((vacancy) => {
          return [
            {
              recordId: vacancy.id,
              value: vacancy.code,
              key: "Code"
            },
            {
              recordId: vacancy.id,
              value: vacancy.name,
              key: "Name"
            }
          ];
        }),
        children: ({ key, value, recordId, index: index2 }) => {
          return /* @__PURE__ */ jsxs73(Fragment27, { children: [
            /* @__PURE__ */ jsx106("div", { className: "@4xl:block hidden", children: value }, key + value + "lg"),
            /* @__PURE__ */ jsxs73(
              "div",
              {
                className: "@4xl:hidden grid grid-cols-2",
                children: [
                  /* @__PURE__ */ jsx106("div", { className: "font-bold", children: key }),
                  /* @__PURE__ */ jsxs73("div", { children: [
                    key == "Code" && value,
                    value
                  ] })
                ]
              },
              key + value + "sm"
            )
          ] });
        }
      }
    ),
    /* @__PURE__ */ jsx106(
      ProjectSearchBoxInput,
      {
        label: "Project",
        name: "project",
        control,
        employerId: account.employerId
      }
    ),
    getValues("project") != null && /* @__PURE__ */ jsxs73(Fragment27, { children: [
      /* @__PURE__ */ jsxs73(Button30, { color: `green`, className: `mt-3`, onClick: onSubmit, children: [
        "Move ",
        fields.length,
        " vacancies to ",
        getValues("project")?.name
      ] }),
      isFulfilling && /* @__PURE__ */ jsx106(Spinner8, {})
    ] })
  ] }) });
}

// src/vacancies/components/VacancySearchContainer.tsx
import { jsx as jsx107, jsxs as jsxs74 } from "react/jsx-runtime";
var {
  Table: Table3,
  TableBody,
  TableCaption,
  TableCell,
  TableHead,
  TableHeader,
  TableRow
} = StyledTable;
var vacancySearchContainerQueryDef = VacancySearchContainerQuery_graphql_default;
var VacancySearchHeader = () => {
  return /* @__PURE__ */ jsx107("div", { className: "flex items-center gap-3", children: /* @__PURE__ */ jsx107("div", { className: "py-2 text-2xl font-medium text-gray-700", children: "Vacancies" }) });
};
var vacancySelectAtom = atom8({
  selectedVacancies: [],
  vacancySelectEnabled: false
});
var VacancySearchContainer = ({
  queryRef: queryRef3,
  onSearch,
  showAddVacancy = true
}) => {
  const data = usePreloadedQuery9(
    vacancySearchContainerQueryDef,
    queryRef3
  );
  const [filters, setFilters] = useAtom6(vacancySearchAtom);
  const [isLoading, startTransition2] = useTransition8();
  const [result, refetch] = useRefetchableFragment6(fragmentDef26, data);
  const onPage = useCallback59(
    (pageNumber) => {
      const f4 = {
        ...filters,
        pageNumber
      };
      setFilters(f4);
      startTransition2(() => {
        refetch({
          input: f4
        });
      });
    },
    [filters, refetch, setFilters]
  );
  const onUpdateSearch = useCallback59(
    (a4, f4) => {
      const mappedFilters = {
        ...filters,
        [f4.key]: f4.value
      };
      setFilters(mappedFilters);
      onSearch(a4, mappedFilters);
    },
    [filters, onSearch, setFilters]
  );
  const onDeselect = useCallback59(
    (source, value) => {
      const updatedFilters = filters[source].filter((x4) => x4 !== value);
      const mappedFilters = {
        ...filters,
        [source]: updatedFilters
      };
      setFilters(mappedFilters);
      onSearch(source, mappedFilters);
    },
    [filters, setFilters, onSearch]
  );
  const [showFilters, toggleFilters] = useToggle15(true);
  const [vacancySelectState, setVacancySelectState] = useAtom6(vacancySelectAtom);
  const { vacancySelectEnabled } = vacancySelectState;
  const toggleVacancySelect = useCallback59(() => {
    if (vacancySelectEnabled) {
      setVacancySelectState({
        selectedVacancies: [],
        vacancySelectEnabled: !vacancySelectEnabled
      });
    } else {
      setVacancySelectState({
        ...vacancySelectState,
        vacancySelectEnabled: !vacancySelectEnabled
      });
    }
  }, [setVacancySelectState, vacancySelectEnabled, vacancySelectState]);
  const [showCloseVacancy, toggleCloseVacancy] = useToggle15(false);
  const [showCopyVacancy, toggleCopyVacancy] = useToggle15(false);
  const [showMoveVacancy, toggleMoveVacancy] = useToggle15(false);
  const [fulfill, isFulfilling] = useVacancyFulfill();
  const onFulfill = useCallback59(
    ({ vacancyId, message, reasonId }) => {
      return fulfill({
        input: {
          clientMutationId: createClientMutationId29(),
          vacancyId,
          message,
          reasonId
        }
      });
    },
    [fulfill]
  );
  const clearSelectedVacancies = useCallback59(() => {
    setVacancySelectState({
      selectedVacancies: [],
      vacancySelectEnabled: false
    });
  }, [setVacancySelectState]);
  const closeVacancies = useCallback59(
    async ({
      message,
      reasonId
    }) => {
      const deleteQueue = Promise.all(
        vacancySelectState.selectedVacancies.map(async (vacancy) => {
          return await onFulfill({
            message,
            reasonId,
            vacancyId: vacancy.vacancyId
          });
        })
      );
      await deleteQueue;
      setTimeout(() => {
        clearSelectedVacancies();
        toggleCloseVacancy();
        refetch(
          { input: filters },
          {
            fetchPolicy: "network-only"
          }
        );
      }, 2e3);
    },
    [
      filters,
      onFulfill,
      refetch,
      toggleCloseVacancy,
      vacancySelectState.selectedVacancies
    ]
  );
  return /* @__PURE__ */ jsx107(Suspense29, { fallback: "Loading...", children: /* @__PURE__ */ jsxs74("div", { className: "mb-5 flex flex-col gap-2 lg:mt-0", children: [
    /* @__PURE__ */ jsx107("div", { className: "flex flex-col bg-white pb-5 lg:pb-0", children: /* @__PURE__ */ jsxs74("div", { className: "flex flex-col justify-between gap-2 px-4 py-2 lg:flex-row lg:gap-0", children: [
      /* @__PURE__ */ jsx107("div", { className: "flex flex-col items-center justify-between", children: /* @__PURE__ */ jsxs74("div", { className: "flex w-full items-center justify-between", children: [
        /* @__PURE__ */ jsx107(VacancySearchHeader, {}),
        showAddVacancy && /* @__PURE__ */ jsx107("div", { className: "lg:hidden", children: /* @__PURE__ */ jsx107(
          EdLink10,
          {
            name: "add-vacancy",
            href: "/employers/app/vacancies/create",
            children: /* @__PURE__ */ jsx107(Button31, { color: "green", children: "New vacancy" })
          }
        ) })
      ] }) }),
      /* @__PURE__ */ jsx107("div", { className: "flex", children: /* @__PURE__ */ jsx107(
        VacancySearchBox,
        {
          onSearch: (id18, obj) => {
            setFilters(obj);
            onSearch(id18, obj);
          }
        }
      ) }),
      /* @__PURE__ */ jsx107("div", { className: "flex", children: showAddVacancy && /* @__PURE__ */ jsx107("div", { className: "hidden grow items-center justify-center lg:flex", children: /* @__PURE__ */ jsx107(
        EdLink10,
        {
          name: "add-vacancy",
          href: "/employers/app/vacancies/create",
          children: /* @__PURE__ */ jsx107(Button31, { size: Size13.lg, color: "green", children: "New\xA0Vacancy" })
        }
      ) }) })
    ] }) }),
    /* @__PURE__ */ jsxs74("div", { className: "flex flex-col justify-between gap-2 px-2 lg:mt-2 lg:flex-row lg:px-5", children: [
      /* @__PURE__ */ jsx107("div", { className: "flex w-full justify-between", children: /* @__PURE__ */ jsxs74("div", { className: "flex w-full items-center justify-between lg:px-1", children: [
        /* @__PURE__ */ jsxs74("div", { className: "mb-1 flex flex-col gap-3", children: [
          /* @__PURE__ */ jsxs74("div", { className: "flex flex-wrap gap-1", children: [
            /* @__PURE__ */ jsx107(
              AggregationTags,
              {
                onSelected: (x4) => onDeselect("createdById", x4),
                fragmentRef: data.recruitVacanciesSearch.facets.createdBy,
                displayField: DisplayFieldEnum.text
              }
            ),
            /* @__PURE__ */ jsx107(
              AggregationTags,
              {
                onSelected: (x4) => onDeselect("projectId", x4),
                fragmentRef: data.recruitVacanciesSearch.facets.projects,
                displayField: DisplayFieldEnum.text
              }
            ),
            /* @__PURE__ */ jsx107(
              AggregationTags,
              {
                onSelected: (x4) => onDeselect("status", x4),
                fragmentRef: data.recruitVacanciesSearch.facets.status
              }
            ),
            /* @__PURE__ */ jsx107(
              AggregationTags,
              {
                onSelected: (x4) => onDeselect("employmentType", x4),
                fragmentRef: data.recruitVacanciesSearch.facets.employmentType
              }
            ),
            /* @__PURE__ */ jsx107(
              AggregationTags,
              {
                onSelected: (x4) => onDeselect("jobTitles", x4),
                fragmentRef: data.recruitVacanciesSearch.facets.jobTitles
              }
            ),
            /* @__PURE__ */ jsx107(
              AggregationTags,
              {
                onSelected: (x4) => onDeselect("lastActivity", x4),
                fragmentRef: data.recruitVacanciesSearch.facets.lastActivity
              }
            ),
            /* @__PURE__ */ jsx107(
              AggregationTags,
              {
                onSelected: (x4) => onDeselect("locationHierarchies", x4),
                fragmentRef: data.recruitVacanciesSearch.facets.locationHierarchies
              }
            ),
            /* @__PURE__ */ jsx107(
              AggregationTags,
              {
                onSelected: (x4) => onDeselect("locations", x4),
                fragmentRef: data.recruitVacanciesSearch.facets.locations
              }
            ),
            /* @__PURE__ */ jsx107(
              AggregationTags,
              {
                onSelected: (x4) => onDeselect("openedOn", x4),
                fragmentRef: data.recruitVacanciesSearch.facets.openedOn
              }
            ),
            /* @__PURE__ */ jsx107(
              AggregationTags,
              {
                onSelected: (x4) => onDeselect("skills", x4),
                fragmentRef: data.recruitVacanciesSearch.facets.skills
              }
            ),
            /* @__PURE__ */ jsx107(
              AggregationTags,
              {
                onSelected: (x4) => onDeselect("targetCompanies", x4),
                fragmentRef: data.recruitVacanciesSearch.facets.targetCompanies
              }
            )
          ] }),
          /* @__PURE__ */ jsx107("div", { className: "flex w-full items-start", children: /* @__PURE__ */ jsxs74("div", { className: "flex gap-5 ", children: [
            vacancySelectState.selectedVacancies.length > 0 && /* @__PURE__ */ jsxs74("div", { className: "flex gap-1", children: [
              /* @__PURE__ */ jsx107(Button31, { color: "danger", onClick: toggleCloseVacancy, children: "Close Vacancies" }),
              /* @__PURE__ */ jsx107(Button31, { color: "transparent", onClick: toggleCopyVacancy, children: "Copy Vacancies" }),
              /* @__PURE__ */ jsx107(Button31, { color: "transparent", onClick: toggleMoveVacancy, children: "Move Vacancies" }),
              /* @__PURE__ */ jsx107(
                Button31,
                {
                  onClick: clearSelectedVacancies,
                  className: "border border-gray-400",
                  children: "Clear"
                }
              )
            ] }),
            showCopyVacancy && /* @__PURE__ */ jsx107(Modal, { onClose: toggleCopyVacancy, children: /* @__PURE__ */ jsx107(
              VacancyCopy,
              {
                vacancies: vacancySelectState.selectedVacancies,
                clearSelectedVacancies,
                toggleCopyVacancy
              }
            ) }),
            showMoveVacancy && /* @__PURE__ */ jsx107(Modal, { onClose: toggleMoveVacancy, children: /* @__PURE__ */ jsx107(
              VacancyMove,
              {
                vacancies: vacancySelectState.selectedVacancies,
                clearSelectedVacancies,
                toggleMoveVacancy
              }
            ) }),
            showCloseVacancy && /* @__PURE__ */ jsx107(Modal, { onClose: toggleCloseVacancy, children: /* @__PURE__ */ jsxs74(Card3, { className: "mt-10 xl:min-w-[700px]", children: [
              /* @__PURE__ */ jsx107("div", { className: "text-2xl", children: "Close Vacancies" }),
              /* @__PURE__ */ jsxs74("div", { className: "mt-5", children: [
                /* @__PURE__ */ jsx107(Table3, { children: /* @__PURE__ */ jsxs74(ScrollArea, { className: "relative h-72 rounded-lg border", children: [
                  /* @__PURE__ */ jsx107(TableHeader, { className: "sticky top-0 bg-white", children: /* @__PURE__ */ jsxs74(TableRow, { children: [
                    /* @__PURE__ */ jsx107(TableHead, { className: "w-[200px]", children: "Reference" }),
                    /* @__PURE__ */ jsx107(TableHead, { children: "Name" }),
                    /* @__PURE__ */ jsx107(TableHead, { children: "Status" })
                  ] }) }),
                  /* @__PURE__ */ jsx107(TableBody, { children: vacancySelectState.selectedVacancies.map((vacancy) => {
                    return [
                      vacancy.employerReference,
                      vacancy.name,
                      vacancy.status
                    ];
                  }).map((x4, index2) => /* @__PURE__ */ jsx107(TableRow, { children: x4.map((cell) => /* @__PURE__ */ jsx107(TableCell, { children: cell }, cell)) }, x4 + index2.toString())) })
                ] }) }),
                /* @__PURE__ */ jsx107("div", { className: "mt-5", children: /* @__PURE__ */ jsx107(CloseVacancy, { onSubmit: (x4) => closeVacancies(x4) }) }),
                isFulfilling && /* @__PURE__ */ jsx107(Spinner9, {})
              ] })
            ] }) })
          ] }) })
        ] }),
        /* @__PURE__ */ jsx107("div", { onClick: toggleFilters, className: "mr-2 lg:hidden", children: /* @__PURE__ */ jsx107(Button31, { color: "primary", children: /* @__PURE__ */ jsx107(
          IconText2,
          {
            text: showFilters ? "Filters" : "Filters",
            icon: Icons3.FilterHorizontal
          }
        ) }) })
      ] }) }),
      /* @__PURE__ */ jsxs74("div", { className: "flex flex-col gap-3 lg:flex-row", children: [
        /* @__PURE__ */ jsx107(
          VacancySearchSort,
          {
            onSearch: (_4, newFilter) => {
              const mappedFilters = {
                ...filters,
                ...newFilter,
                pageNumber: 1
              };
              setFilters(mappedFilters);
              onSearch(_4, mappedFilters);
            }
          }
        ),
        /* @__PURE__ */ jsx107("div", { className: "hidden lg:flex", children: /* @__PURE__ */ jsx107(
          SimplePagination2,
          {
            name: "pg",
            totalResults: result.result.paging.totalResults,
            itemsPerPage: result.result.paging.itemsPerPage,
            pageNumber: result.result.paging.pageNumber,
            pages: result.result.paging.pages,
            onPage
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ jsx107("div", { className: "mx-2 flex lg:mx-2", children: /* @__PURE__ */ jsx107("div", { className: "flex w-full grow flex-col items-end justify-end", children: /* @__PURE__ */ jsx107(Suspense29, { fallback: "Loading...", children: /* @__PURE__ */ jsxs74("div", { className: "flex w-full", children: [
      /* @__PURE__ */ jsx107(
        "div",
        {
          className: classNames11(
            "w-full lg:mr-2 lg:w-auto",
            showFilters && "hidden lg:flex"
          ),
          children: /* @__PURE__ */ jsx107(
            "div",
            {
              className: classNames11(
                "w-full overflow-hidden rounded-md border bg-white lg:min-w-[400px] lg:max-w-[400px]"
              ),
              children: /* @__PURE__ */ jsx107("div", { className: "sticky top-0 bg-white", children: /* @__PURE__ */ jsx107(
                VacancySearchFacets,
                {
                  fragmentRef: data.recruitVacanciesSearch.facets,
                  onSearch: onUpdateSearch
                }
              ) })
            }
          )
        }
      ),
      /* @__PURE__ */ jsx107(
        "div",
        {
          className: classNames11(
            "flex grow",
            !showFilters && "hidden lg:flex"
          ),
          children: /* @__PURE__ */ jsx107(VacancySearchList, { result })
        }
      )
    ] }) }) }) }),
    showFilters && /* @__PURE__ */ jsx107("div", { className: "flex self-center px-5 lg:self-end", children: /* @__PURE__ */ jsx107(
      SimplePagination2,
      {
        name: "pg",
        totalResults: result.result.paging.totalResults,
        itemsPerPage: result.result.paging.itemsPerPage,
        pageNumber: result.result.paging.pageNumber,
        pages: result.result.paging.pages,
        onPage
      }
    ) })
  ] }) });
};

// src/vacancies/components/VacancySearchLoader.tsx
import { jsx as jsx108 } from "react/jsx-runtime";
var VacancySearchLoader = ({
  showAddVacancy
}) => {
  const [queryReference, loadQuery48] = useQueryLoader3(vacancySearchContainerQueryDef);
  const [isLoading, startTransition2] = useTransition9();
  const filterState = useAtomValue3(vacancySearchAtom);
  const onSearch = useCallback60(
    (source, input) => {
      console.log(`VacancySearchContainer onSearch: Source: ${source}`);
      console.log(input);
      startTransition2(() => {
        loadQuery48({ input }, { fetchPolicy: "network-only" });
      });
    },
    [loadQuery48]
  );
  useEffectOnce(() => {
    onSearch("VacancySearchLoader Page Render", {
      ...filterState,
      status: ["Open"],
      sortField: "LAST_ACTIVITY",
      sortOrder: "DESC",
      myVacancies: ["PLEASE"]
    });
  });
  if (!queryReference) {
    return /* @__PURE__ */ jsx108(EdSkeleton27, {});
  }
  return /* @__PURE__ */ jsx108("div", { children: /* @__PURE__ */ jsx108(Suspense30, { fallback: /* @__PURE__ */ jsx108(Loading, {}), children: /* @__PURE__ */ jsx108(
    VacancySearchContainer,
    {
      queryRef: queryReference,
      onSearch,
      showAddVacancy
    }
  ) }) });
};

// src/vacancies/components/__generated__/VacancyLayoutQuery.graphql.ts
var node150 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "vacancyCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "vacancyCode",
      "variableName": "vacancyCode"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "vacancyId",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "employerId",
    "storageKey": null
  }, v7 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "VacancyLayoutQuery",
      "selections": [
        {
          "alias": "vacancy",
          "args": v1,
          "concreteType": "Vacancy",
          "kind": "LinkedField",
          "name": "recruitVacancyByCode",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            v5,
            v6,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "VacancyApplicationSearchContainer_vacancy"
            },
            v7
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "VacancyLayoutQuery",
      "selections": [
        {
          "alias": "vacancy",
          "args": v1,
          "concreteType": "Vacancy",
          "kind": "LinkedField",
          "name": "recruitVacancyByCode",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            v5,
            v6,
            v7
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "756a74007d096df9511f1c4607ef05e1",
      "id": null,
      "metadata": {},
      "name": "VacancyLayoutQuery",
      "operationKind": "query",
      "text": "query VacancyLayoutQuery(\n  $vacancyCode: Int!\n) {\n  vacancy: recruitVacancyByCode(vacancyCode: $vacancyCode) {\n    id\n    code\n    vacancyId\n    name\n    employerId\n    ...VacancyApplicationSearchContainer_vacancy\n  }\n}\n\nfragment VacancyApplicationSearchContainer_vacancy on Vacancy {\n  vacancyId\n  ...VacancyApplicationSearchList_vacancy\n  ...VacancyApplicationSearchListHeader_vacancy\n}\n\nfragment VacancyApplicationSearchListHeader_vacancy on Vacancy {\n  vacancyId\n}\n\nfragment VacancyApplicationSearchList_vacancy on Vacancy {\n  ...VacancyApplicationSearchListHeader_vacancy\n}\n"
    }
  };
}();
node150.hash = "6a77e2c13912ae9728d430d8ba041584";
var VacancyLayoutQuery_graphql_default = node150;

// src/vacancies/components/Vacancy.tsx
import { createContext as createContext8, memo as memo2, Suspense as Suspense31, useContext as useContext8, useMemo as useMemo20 } from "react";
import {
  Outlet as Outlet5,
  useLoaderData,
  useLocation as useLocation2,
  useRouteLoaderData as useRouteLoaderData7
} from "react-router-dom";
import {
  loadQuery as loadQuery10,
  usePreloadedQuery as usePreloadedQuery10
} from "react-relay";
import {
  BreadcrumbLink as BreadcrumbLink5,
  Breadcrumbs as Breadcrumbs2,
  createLinkState as createLinkState2,
  DynamicBreadcrumb,
  ExpandButton,
  MobileHeader,
  Tabs as Tabs2
} from "shared-ui";
import { Fragment as Fragment28, jsx as jsx109, jsxs as jsxs75 } from "react/jsx-runtime";
var vacancyLayoutQueryDef = VacancyLayoutQuery_graphql_default;
var ShowExpandVacancy = createContext8(true);
var Vacancy = ({ hideHeader, tabs: tabs6 }) => {
  const preloadedQuery = useLoaderData();
  const data = usePreloadedQuery10(vacancyLayoutQueryDef, preloadedQuery);
  const location2 = useLocation2();
  const tabLinks = useMemo20(() => {
    const defaultTabs = [
      { name: "Dashboard", to: "dashboard" },
      { name: "Applications", to: "applications" },
      { name: "Matches", to: "matches" },
      { name: "Recommendations", to: "recommendations" },
      { name: "Adverts", to: `ads` },
      { name: "Edit", to: "edit" },
      { name: "Close", to: "close" }
    ];
    return (tabs6 || defaultTabs).map((tab) => {
      return createLinkState2(
        location2,
        tab.name,
        tab.to,
        false,
        false,
        tab.externalLink
      );
    });
  }, [location2, tabs6]);
  const showExpandSection = useContext8(ShowExpandVacancy);
  const currentPath = useMemo20(
    () => location2.pathname.replace("/list/", "/view/"),
    [location2]
  );
  if (data.vacancy === null || data.vacancy === void 0) {
    return /* @__PURE__ */ jsx109("div", { className: "flex h-full w-full items-center justify-center", children: /* @__PURE__ */ jsx109("div", { children: "Could not find Vacancy" }) });
  }
  return /* @__PURE__ */ jsxs75(Suspense31, { children: [
    /* @__PURE__ */ jsxs75("div", { className: "@container flex flex-col overflow-scroll", children: [
      /* @__PURE__ */ jsx109(
        Suspense31,
        {
          fallback: /* @__PURE__ */ jsx109(
            Breadcrumbs2,
            {
              links: [
                { name: "Vacancies", href: "../../../" },
                { name: data.vacancy.name, href: "." }
              ]
            }
          ),
          children: !hideHeader && /* @__PURE__ */ jsx109("div", { className: "md:border-b", children: /* @__PURE__ */ jsx109(DynamicBreadcrumb, {}) })
        }
      ),
      /* @__PURE__ */ jsxs75(Suspense31, { fallback: "Loading...", children: [
        /* @__PURE__ */ jsx109(
          MobileHeader,
          {
            showMobileNavIcon: false,
            showBackButton: false,
            title: /* @__PURE__ */ jsxs75("div", { className: "flex w-full items-center justify-start lg:justify-between", children: [
              /* @__PURE__ */ jsxs75("div", { className: "flex justify-start gap-2", children: [
                showExpandSection && /* @__PURE__ */ jsx109("div", { className: "hidden lg:flex", children: /* @__PURE__ */ jsx109(ExpandButton, { to: currentPath, label: "View Vacancy" }) }),
                /* @__PURE__ */ jsx109("div", { className: "py-2 text-2xl text-2xl font-medium leading-6 md:whitespace-nowrap", children: data.vacancy.name })
              ] }),
              /* @__PURE__ */ jsx109("div", { className: "hidden w-full justify-end py-2 md:flex", children: /* @__PURE__ */ jsx109("div", { className: " flex grow justify-end", children: /* @__PURE__ */ jsx109("div", { className: "flex flex-col items-end justify-end gap-2", children: /* @__PURE__ */ jsx109(Tabs2, { tabs: tabLinks }) }) }) })
            ] })
          }
        ),
        /* @__PURE__ */ jsx109("div", { className: "flex w-full grow justify-end px-2 md:hidden", children: /* @__PURE__ */ jsx109("div", { className: " flex w-full grow", children: /* @__PURE__ */ jsx109("div", { className: "flex w-full flex-col items-end justify-end gap-2", children: /* @__PURE__ */ jsx109(Tabs2, { tabs: tabLinks }) }) }) })
      ] })
    ] }),
    /* @__PURE__ */ jsx109(Outlet5, {})
  ] }, data.vacancy.code);
};
var VacancyRoute = memo2(Vacancy);
var VacancyLink = ({ id: id18 }) => {
  const data = useVacancyRouteData(id18);
  if (!data.vacancy) {
    return /* @__PURE__ */ jsx109(Fragment28, {});
  }
  return /* @__PURE__ */ jsx109(Suspense31, { fallback: "Loading...", children: /* @__PURE__ */ jsx109(BreadcrumbLink5, { to: ".", label: data.vacancy.name }) });
};
async function vacancyLoader(environment, params) {
  const code = params.vacancyCode;
  const vacancyCode = parseInt(code);
  return loadQuery10(environment, vacancyLayoutQueryDef, {
    vacancyCode
  });
}
function useVacancyRouteData(id18) {
  const queryRef3 = useRouteLoaderData7(id18);
  const data = usePreloadedQuery10(
    vacancyLayoutQueryDef,
    queryRef3
  );
  return data;
}

// src/vacancies/components/__generated__/VacancyAdDetails_vacancy.graphql.ts
var node151 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VacancyAdDetails_vacancy",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vacancyAdvertId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vacancyId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "employerId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "employerName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publicDescriptionHtml",
      "storageKey": null
    }
  ],
  "type": "VacancyAdvert",
  "abstractKey": null
};
node151.hash = "256c16075f2416b96951c7fbc4e92b7a";
var VacancyAdDetails_vacancy_graphql_default = node151;

// src/vacancies/components/VacancyAdDetails.tsx
import { useFragment as useFragment36 } from "react-relay";
import { jsx as jsx110 } from "react/jsx-runtime";
var fragment6 = VacancyAdDetails_vacancy_graphql_default;
var VacancyAdDetails = ({ vacancyKey }) => {
  const vacancy = useFragment36(
    fragment6,
    vacancyKey
  );
  return /* @__PURE__ */ jsx110(
    "article",
    {
      className: "prose prose-slate prose-lg max-w-max px-4",
      dangerouslySetInnerHTML: {
        __html: vacancy.publicDescriptionHtml
      }
    }
  );
};

// src/vacancies/components/__generated__/VacancyAdSummary_vacancy.graphql.ts
var node153 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VacancyAdSummary_vacancy",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vacancyAdvertId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vacancyId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "employerId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "employerName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "employerLogoUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publicDescriptionHtml",
      "storageKey": null
    }
  ],
  "type": "VacancyAdvert",
  "abstractKey": null
};
node153.hash = "ac86b2957aeb3a5cfeb0249b2074883e";
var VacancyAdSummary_vacancy_graphql_default = node153;

// src/vacancies/components/VacancyAdSummary.tsx
import { useFragment as useFragment37 } from "react-relay";
import { jsx as jsx111, jsxs as jsxs76 } from "react/jsx-runtime";
var fragment7 = VacancyAdSummary_vacancy_graphql_default;
var VacancyAdSummary = ({ vacancyKey }) => {
  const vacancy = useFragment37(
    fragment7,
    vacancyKey
  );
  return /* @__PURE__ */ jsxs76("div", { className: "flex flex-col items-center justify-center gap-5", children: [
    vacancy.employerLogoUrl && /* @__PURE__ */ jsx111("img", { src: vacancy.employerLogoUrl, alt: vacancy.employerName }),
    /* @__PURE__ */ jsx111("div", { className: "text-info-500 mx-auto py-2 text-2xl", children: vacancy.name })
  ] });
};

// src/vacancies/components/VacancyApplyButton.tsx
import { createClientMutationId as createClientMutationId30 } from "shared-lib";
import { Button as Button33, Size as Size14 } from "shared-ui";
import { jsx as jsx113 } from "react/jsx-runtime";
var VacancyApplyButton = ({
  candidateId,
  vacancyId,
  onCompleted
}) => {
  const [apply, isApplying] = useVacancyApply();
  return /* @__PURE__ */ jsx113(
    Button33,
    {
      className: "h-12 w-full",
      color: "primary",
      size: Size14.xl,
      clicked: async () => {
        const clientMutationId = createClientMutationId30();
        const response = await apply({
          input: { candidateId, vacancyId, clientMutationId }
        });
        if (response.createApplication.applicationPayload?.application?.node) {
          onCompleted(
            response.createApplication.applicationPayload?.application?.node.applicationId
          );
        }
      },
      disabled: isApplying,
      children: "Apply Now"
    }
  );
};

// src/vacancies/components/__generated__/VacancyApplyContainerQuery.graphql.ts
var node154 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "vacancyCode"
    }
  ], v1 = [
    {
      "alias": "vacancy",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "vacancyCode"
        }
      ],
      "concreteType": "VacancyAdvert",
      "kind": "LinkedField",
      "name": "recruitVacancyAdvertByCode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "vacancyAdvertId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "version",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "employerId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "employerName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "publicDescriptionHtml",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "VacancyApplyContainerQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "VacancyApplyContainerQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "d0df17bf7fe85e0369b1445ce9996ceb",
      "id": null,
      "metadata": {},
      "name": "VacancyApplyContainerQuery",
      "operationKind": "query",
      "text": "query VacancyApplyContainerQuery(\n  $vacancyCode: Int!\n) {\n  vacancy: recruitVacancyAdvertByCode(code: $vacancyCode) {\n    id\n    vacancyAdvertId\n    createdAt\n    version\n    employerId\n    employerName\n    name\n    publicDescriptionHtml\n  }\n}\n"
    }
  };
}();
node154.hash = "3aa670f9a9b8728c020b551ad90db60c";
var VacancyApplyContainerQuery_graphql_default = node154;

// src/vacancies/components/VacancyApplyContainer.tsx
import { Suspense as Suspense33 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery16 } from "react-relay";
import { EdSkeleton as EdSkeleton28 } from "shared-ui";
import { jsx as jsx114, jsxs as jsxs77 } from "react/jsx-runtime";
var query2 = VacancyApplyContainerQuery_graphql_default;
var VacancyApplyContainer = ({ vacancyCode, candidateId, onCompleted }) => {
  const data = useLazyLoadQuery16(
    query2,
    { vacancyCode },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { vacancy } = data;
  if (!vacancy) {
    return /* @__PURE__ */ jsx114("div", { className: "m-8", children: /* @__PURE__ */ jsxs77("div", { className: "text-info-500 border-b py-4 text-2xl", children: [
      "Could Not Find Vacancy with code ",
      vacancyCode
    ] }) });
  }
  return /* @__PURE__ */ jsx114("div", { children: /* @__PURE__ */ jsx114(Suspense33, { fallback: /* @__PURE__ */ jsx114(EdSkeleton28, {}), children: /* @__PURE__ */ jsxs77("div", { className: "m-8", children: [
    /* @__PURE__ */ jsx114("div", { className: "text-info-500 border-b py-4 text-2xl", children: vacancy.name }),
    /* @__PURE__ */ jsx114("div", { className: "py-4", children: /* @__PURE__ */ jsx114(
      VacancyApplyButton,
      {
        candidateId,
        vacancyId: vacancy.vacancyAdvertId,
        onCompleted
      }
    ) })
  ] }) }) });
};

// src/vacancies/components/__generated__/VacancyApplyPublicContainerQuery.graphql.ts
var node155 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "vacancyCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "vacancyCode"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "vacancyAdvertId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v5 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "VacancyApplyPublicContainerQuery",
      "selections": [
        {
          "alias": "vacancy",
          "args": v1,
          "concreteType": "VacancyAdvert",
          "kind": "LinkedField",
          "name": "recruitVacancyAdvertByCode",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "VacancyAdSummary_vacancy"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "VacancyAdDetails_vacancy"
            },
            v5
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "VacancyApplyPublicContainerQuery",
      "selections": [
        {
          "alias": "vacancy",
          "args": v1,
          "concreteType": "VacancyAdvert",
          "kind": "LinkedField",
          "name": "recruitVacancyAdvertByCode",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "vacancyId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "version",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "employerId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "employerName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "employerLogoUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "publicDescriptionHtml",
              "storageKey": null
            },
            v5
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "54833fc7813ebc98164dc0a577729444",
      "id": null,
      "metadata": {},
      "name": "VacancyApplyPublicContainerQuery",
      "operationKind": "query",
      "text": "query VacancyApplyPublicContainerQuery(\n  $vacancyCode: Int!\n) {\n  vacancy: recruitVacancyAdvertByCode(code: $vacancyCode) {\n    id\n    vacancyAdvertId\n    name\n    ...VacancyAdSummary_vacancy\n    ...VacancyAdDetails_vacancy\n  }\n}\n\nfragment VacancyAdDetails_vacancy on VacancyAdvert {\n  id\n  vacancyAdvertId\n  vacancyId\n  createdAt\n  version\n  employerId\n  employerName\n  name\n  publicDescriptionHtml\n}\n\nfragment VacancyAdSummary_vacancy on VacancyAdvert {\n  id\n  vacancyAdvertId\n  vacancyId\n  createdAt\n  version\n  employerId\n  employerName\n  employerLogoUrl\n  name\n  publicDescriptionHtml\n}\n"
    }
  };
}();
node155.hash = "861f254274c10c050e4679180d56c6aa";
var VacancyApplyPublicContainerQuery_graphql_default = node155;

// src/vacancies/components/VacancyApplyPublicContainer.tsx
import { Suspense as Suspense34, useEffect as useEffect16 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery17 } from "react-relay";
import { createMachine } from "xstate";
import { useMachine } from "@xstate/react";
import { useRecoilValue as useRecoilValue2 } from "recoil";
import { Button as Button35, ButtonList as ButtonList10, EdSkeleton as EdSkeleton29, Size as Size16 } from "shared-ui";
import {
  profileDetailsQuery,
  userIsLoggedInQuery
} from "app-core";

// src/vacancies/components/__generated__/VacancyApplyNewAccountFormMutation.graphql.ts
var node156 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": "result",
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }, v32 = {
    "kind": "InlineFragment",
    "selections": [
      v23,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdOn",
        "storageKey": null
      }
    ],
    "type": "ExistingAccountApplyResult",
    "abstractKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v23,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "otacCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "EdgeOfApplicationSqlReadModel",
        "kind": "LinkedField",
        "name": "application",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cursor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Application",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "applicationId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "version",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "applicationStateId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "applicationStateName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "workflowStateId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "workflowStateName",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "NewAccountApplyResult",
    "abstractKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  }, v6 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": "name",
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      v5,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "data",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationItem",
        "kind": "LinkedField",
        "name": "validations",
        "plural": true,
        "selections": [
          v5,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "VacancyApplyNewAccountFormMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "CreateApplicationAndAccountPayload",
          "kind": "LinkedField",
          "name": "createApplicationAndAccount",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "applicationApplyResult",
              "plural": false,
              "selections": [
                v32,
                v4
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v6
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "VacancyApplyNewAccountFormMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "CreateApplicationAndAccountPayload",
          "kind": "LinkedField",
          "name": "createApplicationAndAccount",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "applicationApplyResult",
              "plural": false,
              "selections": [
                v7,
                v32,
                v4
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v7,
                v6
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "20c36655d64591b0f730c6eabe731fd6",
      "id": null,
      "metadata": {},
      "name": "VacancyApplyNewAccountFormMutation",
      "operationKind": "mutation",
      "text": "mutation VacancyApplyNewAccountFormMutation(\n  $input: CreateApplicationAndAccountInput!\n) {\n  createApplicationAndAccount(input: $input) {\n    applicationApplyResult {\n      __typename\n      ... on ExistingAccountApplyResult {\n        result: __typename\n        createdOn\n      }\n      ... on NewAccountApplyResult {\n        result: __typename\n        otacCode\n        application {\n          cursor\n          node {\n            id\n            applicationId\n            status\n            version\n            applicationStateId\n            applicationStateName\n            workflowStateId\n            workflowStateName\n          }\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        name: __typename\n        code\n        message\n        data\n        validations {\n          message\n          name\n        }\n      }\n    }\n  }\n}\n"
    }
  };
}();
node156.hash = "3638a79a038e637841d9e9d135efaf28";
var VacancyApplyNewAccountFormMutation_graphql_default = node156;

// src/vacancies/components/VacancyApplyNewAccountForm.tsx
import { useCallback as useCallback61, useState as useState35 } from "react";
import { useMutation as useMutation12 } from "react-relay";
import { useForm as useForm13 } from "react-hook-form";
import * as zod11 from "zod";
import { zodResolver as zodResolver13 } from "@hookform/resolvers/zod";
import {
  createClientMutationId as createClientMutationId31,
  getPlatformLinks,
  useToggle as useToggle16
} from "shared-lib";
import {
  Button as Button34,
  CheckboxInput as CheckboxInput4,
  EdLink as EdLink11,
  FormInput as FormInput9,
  LinkButton as LinkButton2,
  Size as Size15
} from "shared-ui";
import { UserErrorList as UserErrorList2 } from "app-core";
import { jsx as jsx115, jsxs as jsxs78 } from "react/jsx-runtime";
var mutationDef43 = VacancyApplyNewAccountFormMutation_graphql_default;
var FormSchema5 = zod11.object({
  firstName: zod11.string().nonempty(),
  lastName: zod11.string().nonempty(),
  email: zod11.string().email(),
  password: zod11.string().nonempty(),
  acceptTerms: zod11.literal(true),
  acceptGdpr: zod11.literal(true)
});
var VacancyApplyNewAccountForm = ({
  vacancyId,
  onCompletedNewAccount,
  onCompletedExistingAccount,
  onFailed,
  onSignIn,
  onError
}) => {
  const defaultValues2 = {
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    acceptGdpr: true,
    acceptTerms: true
  };
  const { register, handleSubmit, formState, control } = useForm13({
    // There is a bug in yup which causes it to compare the type boolean with the string 'true', so we're checking any to avoid this
    resolver: zodResolver13(FormSchema5),
    defaultValues: defaultValues2
  });
  const { errors, isValid } = formState;
  const onSubmit = handleSubmit((data) => createAccount(isValid, data));
  const [emailIsInUse, setEmailIsInUse] = useState35(false);
  const [criticalFailure, toggleCriticalFailure] = useToggle16(false);
  const [userErrors, setUserErrors] = useState35([]);
  const [commitMutation4, isMutationInFlight] = useMutation12(mutationDef43);
  const createAccount = useCallback61(
    (isValid2, form) => {
      if (!form.email) {
        return;
      }
      const clientMutationId = createClientMutationId31();
      commitMutation4({
        variables: {
          input: {
            data: {
              vacancyId,
              firstName: form.firstName,
              lastName: form.lastName,
              email: form.email,
              password: form.password,
              acceptTerms: form.acceptTerms,
              acceptGdpr: form.acceptGdpr,
              source: "advert"
            },
            clientMutationId
          }
        },
        onError,
        onCompleted: (response) => {
          const applyResult = response.createApplicationAndAccount.applicationApplyResult;
          if (applyResult?.result === "NewAccountApplyResult" && applyResult.application?.node && applyResult.otacCode) {
            const context = {
              applicationId: applyResult.application.node.applicationId,
              otacCode: applyResult.otacCode,
              email: form.email
            };
            onCompletedNewAccount(context);
            return;
          } else if (applyResult?.result === "ExistingAccountApplyResult") {
            onCompletedExistingAccount();
            return;
          }
          const userErrors2 = response.createApplicationAndAccount.userErrors;
          if (userErrors2 && userErrors2.length > 0 && userErrors2[0].message) {
            onFailed(userErrors2[0].message);
          }
        }
      });
    },
    [
      commitMutation4,
      onCompletedExistingAccount,
      onCompletedNewAccount,
      onError,
      onFailed,
      vacancyId
    ]
  );
  const platformLinks = getPlatformLinks();
  return /* @__PURE__ */ jsx115("div", { className: "mt-4", children: /* @__PURE__ */ jsxs78("div", { className: "space-y-6 bg-white px-4 py-5 sm:p-6", children: [
    criticalFailure ? /* @__PURE__ */ jsx115("div", { children: "A error has occurred, please try again" }) : null,
    userErrors ? /* @__PURE__ */ jsx115(UserErrorList2, { errors: userErrors }) : null,
    /* @__PURE__ */ jsxs78("form", { onSubmit, children: [
      /* @__PURE__ */ jsxs78("div", { className: "flex flex-wrap sm:space-x-2", children: [
        /* @__PURE__ */ jsxs78("div", { className: "flex-grow", children: [
          /* @__PURE__ */ jsx115("label", { children: "First name *" }),
          /* @__PURE__ */ jsx115(
            FormInput9,
            {
              className: "mt-1",
              type: "text",
              placeholder: " First Name ",
              name: "firstName",
              required: true,
              register
            }
          ),
          errors.firstName && /* @__PURE__ */ jsx115("p", { children: errors.firstName.message })
        ] }),
        /* @__PURE__ */ jsxs78("div", { className: "flex-grow", children: [
          /* @__PURE__ */ jsx115("label", { children: "Last name *" }),
          /* @__PURE__ */ jsx115(
            FormInput9,
            {
              className: "mt-1",
              type: "text",
              placeholder: " Last Name ",
              name: "lastName",
              required: true,
              register
            }
          ),
          errors.lastName && /* @__PURE__ */ jsx115("p", { children: errors.lastName.message })
        ] })
      ] }),
      /* @__PURE__ */ jsxs78("div", { className: "mt-4", children: [
        /* @__PURE__ */ jsx115("label", { children: "Email address *" }),
        /* @__PURE__ */ jsx115(
          FormInput9,
          {
            className: "mt-1",
            type: "text",
            placeholder: " Email address ",
            name: "email",
            required: true,
            register
          }
        ),
        errors.email && /* @__PURE__ */ jsx115("p", { children: errors.email.message }),
        emailIsInUse && /* @__PURE__ */ jsx115("p", { children: "This email is already in use" })
      ] }),
      /* @__PURE__ */ jsxs78("div", { className: "mt-4", children: [
        /* @__PURE__ */ jsx115("label", { children: "Password *" }),
        /* @__PURE__ */ jsx115(
          FormInput9,
          {
            className: "mt-1",
            type: "text",
            placeholder: " Password ",
            name: "password",
            required: true,
            register
          }
        ),
        errors.password && /* @__PURE__ */ jsx115("p", { children: errors.password.message })
      ] }),
      /* @__PURE__ */ jsxs78("div", { className: "mt-4", children: [
        /* @__PURE__ */ jsx115(
          CheckboxInput4,
          {
            label: /* @__PURE__ */ jsxs78("span", { children: [
              "I accept the",
              " ",
              /* @__PURE__ */ jsx115(
                EdLink11,
                {
                  name: "terms-and-conditions",
                  href: platformLinks.termsAndConditions,
                  className: `underline`,
                  children: "Terms and Conditions"
                }
              )
            ] }),
            name: "acceptTerms",
            defaultChecked: defaultValues2.acceptTerms,
            control,
            disabled: false
          }
        ),
        errors.acceptTerms && /* @__PURE__ */ jsx115("p", { children: errors.acceptTerms.message })
      ] }),
      /* @__PURE__ */ jsxs78("div", { className: "mt-4", children: [
        /* @__PURE__ */ jsx115(
          CheckboxInput4,
          {
            label: /* @__PURE__ */ jsxs78("span", { children: [
              "I accept the",
              " ",
              /* @__PURE__ */ jsx115(
                EdLink11,
                {
                  name: "privacy-policy",
                  href: platformLinks.privacyPolicy,
                  className: `underline`,
                  children: "Privacy Policy"
                }
              )
            ] }),
            name: "acceptGdpr",
            defaultChecked: defaultValues2.acceptGdpr,
            control,
            disabled: false
          }
        ),
        errors.acceptGdpr && /* @__PURE__ */ jsx115("p", { children: errors.acceptGdpr.message })
      ] }),
      /* @__PURE__ */ jsx115("div", { className: "mt-5 flex", children: /* @__PURE__ */ jsx115(
        Button34,
        {
          className: "flex-1",
          disabled: !isValid || isMutationInFlight,
          color: "primary",
          size: Size15.xl,
          type: "submit",
          children: "Apply Now"
        }
      ) }),
      /* @__PURE__ */ jsxs78("div", { className: "mt-4 flex items-center justify-center space-x-2", children: [
        /* @__PURE__ */ jsx115("p", { className: "text-md text-center text-gray-600", children: "Already have an account?" }),
        /* @__PURE__ */ jsx115(LinkButton2, { label: "Sign in", clicked: onSignIn })
      ] })
    ] })
  ] }) });
};

// src/vacancies/components/VacancyApplyPublicContainer.tsx
import { Fragment as Fragment29, jsx as jsx116, jsxs as jsxs79 } from "react/jsx-runtime";
var queryDef16 = VacancyApplyPublicContainerQuery_graphql_default;
var machine = createMachine({
  id: "vacancy",
  initial: "viewing",
  states: {
    viewing: {
      initial: "public",
      id: "viewing",
      states: {
        public: {
          id: "viewing-public",
          on: {
            APPLY: { target: "#applying-public" },
            LOGGED_IN: { target: "#viewing-secure" }
          }
        },
        secure: {
          id: "viewing-secure",
          on: {
            APPLY: { target: "#applying-secure" },
            LOGGED_OUT: { target: "#viewing-public" }
          }
        }
      }
    },
    applying: {
      id: "applying",
      states: {
        public: {
          id: "applying-public",
          on: {
            CANCEL: { target: "#viewing-public" },
            APPLIED: { target: "#applied" },
            LOGGED_IN: { target: "#applying-secure" }
          }
        },
        secure: {
          id: "applying-secure",
          on: {
            CANCEL: { target: "#viewing-secure" },
            APPLIED: { target: "#applied" },
            LOGGED_OUT: { target: "#applying-public" }
          }
        }
      }
    },
    failed: {
      id: "failed",
      states: {
        public: {
          id: "failed-public",
          on: {
            CANCEL: { target: "#viewing-public" },
            RETRY: { target: "#applying-public" }
          }
        },
        secure: {
          id: "failed-secure",
          on: {
            CANCEL: { target: "#viewing-secure" },
            RETRY: { target: "#applying-secure" }
          }
        }
      }
    },
    applied: {
      id: "applied"
    }
  }
});
var VacancyApplyPublicContainer = ({
  vacancyCode,
  onCompleted,
  onCompletedSignIn,
  onCompletedByEmail,
  onFailed,
  onSignInRedirect,
  onBack
}) => {
  const isLoggedIn = useRecoilValue2(userIsLoggedInQuery);
  const profile = useRecoilValue2(profileDetailsQuery);
  const data = useLazyLoadQuery17(
    queryDef16,
    { vacancyCode },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const [state, send] = useMachine(machine);
  useEffect16(() => {
    if (isLoggedIn) {
      send("LOGGED_IN");
    } else {
      send("LOGGED_OUT");
    }
  }, [isLoggedIn, send]);
  const { vacancy } = data;
  if (!vacancy) {
    return /* @__PURE__ */ jsx116(Fragment29, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx116(Suspense34, { fallback: /* @__PURE__ */ jsx116(EdSkeleton29, {}), children: /* @__PURE__ */ jsxs79("div", { className: "mx-auto max-w-4xl bg-white p-4 md:m-2 md:border", children: [
    /* @__PURE__ */ jsx116("div", { className: "border-b", children: /* @__PURE__ */ jsx116("div", { className: "text-primary-900 px-2 py-4 md:text-2xl", children: vacancy.name }) }),
    /* @__PURE__ */ jsxs79("div", { className: "px-2 py-4", children: [
      state.matches("viewing") && /* @__PURE__ */ jsxs79("div", { className: "", children: [
        state.matches({ viewing: "public" }) && /* @__PURE__ */ jsx116(ButtonList10, { children: /* @__PURE__ */ jsx116(
          Button35,
          {
            color: "primary",
            size: Size16.lg,
            clicked: () => {
              send("APPLY");
            },
            children: "Apply"
          }
        ) }),
        state.matches({ viewing: "secure" }) && /* @__PURE__ */ jsxs79("div", { children: [
          /* @__PURE__ */ jsxs79("div", { className: "py-4 text-2xl text-gray-500", children: [
            "Hi, ",
            profile?.firstName
          ] }),
          /* @__PURE__ */ jsx116(ButtonList10, { children: /* @__PURE__ */ jsx116(
            Button35,
            {
              color: "primary",
              size: Size16.lg,
              clicked: () => {
                send("APPLY");
              },
              children: "Apply"
            }
          ) })
        ] }),
        /* @__PURE__ */ jsx116("div", { className: "mt-4 border-t pt-4", children: /* @__PURE__ */ jsx116(VacancyAdDetails, { vacancyKey: vacancy }) })
      ] }),
      state.matches("applying") && /* @__PURE__ */ jsxs79("div", { className: "", children: [
        state.matches({ applying: "public" }) && /* @__PURE__ */ jsx116("div", { children: /* @__PURE__ */ jsx116(
          VacancyApplyNewAccountForm,
          {
            vacancyId: vacancy.vacancyAdvertId,
            onSignIn: () => onSignInRedirect(vacancy.vacancyAdvertId),
            onCompletedNewAccount: onCompletedSignIn,
            onCompletedExistingAccount: onCompletedByEmail,
            onFailed
          }
        ) }),
        state.matches({ applying: "secure" }) && /* @__PURE__ */ jsxs79("div", { children: [
          /* @__PURE__ */ jsx116("div", { children: "Confirm you want to apply ? " }),
          profile && /* @__PURE__ */ jsx116(
            VacancyApplyButton,
            {
              candidateId: profile.id,
              vacancyId: vacancy.vacancyAdvertId,
              onCompleted: (id18) => {
                onCompleted(id18);
              }
            }
          )
        ] })
      ] })
    ] })
  ] }) });
};

// src/vacancies/components/__generated__/VacancyCreateContainerMutation.graphql.ts
var node157 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationAmount",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationType",
    "storageKey": null
  }, v5 = [
    v32,
    v4
  ], v6 = [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "input",
          "variableName": "input"
        }
      ],
      "concreteType": "RecruitVacancyDraftPayload",
      "kind": "LinkedField",
      "name": "recruitVacancyDraft",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EdgeOfVacancy",
          "kind": "LinkedField",
          "name": "vacancy",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Vacancy",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                v1,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "vacancyId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "code",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "publicDescriptionHtml",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "publicDescriptionText",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "publicDescriptionEditorState",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "profession",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "industryId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "industryName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "companyVsSkillWeight",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SkillGroup",
                  "kind": "LinkedField",
                  "name": "skillGroups",
                  "plural": true,
                  "selections": [
                    v1,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "skillGroupId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isRequired",
                      "storageKey": null
                    },
                    v23,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "weight",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "SkillGroupTerm",
                      "kind": "LinkedField",
                      "name": "terms",
                      "plural": true,
                      "selections": [
                        v23,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isSkill",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Duration",
                      "kind": "LinkedField",
                      "name": "experience",
                      "plural": false,
                      "selections": v5,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Duration",
                      "kind": "LinkedField",
                      "name": "recency",
                      "plural": false,
                      "selections": v5,
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "VacancyDates",
                  "kind": "LinkedField",
                  "name": "dates",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "startDate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "startAsap",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "durationCode",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "durationDescription",
                      "storageKey": null
                    },
                    v32,
                    v4
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "VacancyCreateContainerMutation",
      "selections": v6,
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "VacancyCreateContainerMutation",
      "selections": v6
    },
    "params": {
      "cacheID": "079a0b93c9c75ebf1b92c544f06ee24f",
      "id": null,
      "metadata": {},
      "name": "VacancyCreateContainerMutation",
      "operationKind": "mutation",
      "text": "mutation VacancyCreateContainerMutation(\n  $input: RecruitVacancyDraftInput!\n) {\n  recruitVacancyDraft(input: $input) {\n    vacancy {\n      node {\n        id\n        vacancyId\n        code\n        publicDescriptionHtml\n        publicDescriptionText\n        publicDescriptionEditorState\n        profession\n        industryId\n        industryName\n        companyVsSkillWeight\n        skillGroups {\n          id\n          skillGroupId\n          isRequired\n          name\n          weight\n          terms {\n            name\n            isSkill\n          }\n          experience {\n            durationAmount\n            durationType\n          }\n          recency {\n            durationAmount\n            durationType\n          }\n        }\n        dates {\n          startDate\n          startAsap\n          durationCode\n          durationDescription\n          durationAmount\n          durationType\n        }\n      }\n    }\n  }\n}\n"
    }
  };
}();
node157.hash = "f5f418ddc7dd1a233d36531272586ae6";
var VacancyCreateContainerMutation_graphql_default = node157;

// src/vacancies/components/VacancyCreateContainer.tsx
import { Suspense as Suspense48, useCallback as useCallback85, useEffect as useEffect23 } from "react";
import { zodResolver as zodResolver15 } from "@hookform/resolvers/zod";
import { useForm as useForm15 } from "react-hook-form";
import { useMutation as useMutation14 } from "react-relay";
import { useNavigate as useNavigate19 } from "react-router-dom";
import { object as object16, string as string15 } from "zod";
import { createClientMutationId as createClientMutationId40, useToggle as useToggle21 } from "shared-lib";
import {
  Button as Button47,
  ButtonList as ButtonList12,
  ContentEditor as ContentEditor2,
  EdSkeleton as EdSkeleton41,
  Error as Error8,
  Size as Size27,
  useEditorState as useEditorState2
} from "shared-ui";

// src/vacancies/components/DurationEditor.tsx
import { useCallback as useCallback64, useState as useState37 } from "react";

// src/vacancies/components/ExperienceDurationSelector.tsx
import { useCallback as useCallback63, useState as useState36 } from "react";
import { Controller as Controller7 } from "react-hook-form";
import { Input as Input6, ListDirection as ListDirection2, RadioList as RadioList2 } from "shared-ui";
import { isString as isString3 } from "shared-lib";
import { jsx as jsx117, jsxs as jsxs80 } from "react/jsx-runtime";
var monthsOption = {
  id: "MONTHS",
  label: "Months"
};
var yearsOption = {
  id: "YEARS",
  label: "Years"
};
var options2 = [monthsOption, yearsOption];
var ExperienceDurationSelector = ({ value, onChanged }) => {
  const [current, setCurrent] = useState36(() => {
    if (value) {
      return {
        durationAmount: value.durationAmount,
        durationType: value.durationType
      };
    }
    return {
      durationAmount: 1,
      durationType: "MONTHS"
    };
  });
  const valueChanged = useCallback63(
    (value2) => {
      const durationAmount = isString3(value2) ? parseInt(value2) : value2;
      setCurrent((currentState) => ({
        ...currentState,
        durationAmount
      }));
      onChanged({
        durationType: current.durationType,
        durationAmount
      });
    },
    [setCurrent, onChanged, current]
  );
  const typeChanged = useCallback63(
    (value2) => {
      setCurrent((currentState) => ({
        ...currentState,
        durationType: value2.id
      }));
      onChanged({
        ...current,
        durationType: value2.id
      });
    },
    [setCurrent, onChanged, current]
  );
  return /* @__PURE__ */ jsxs80("div", { className: "flex items-center gap-2", children: [
    /* @__PURE__ */ jsx117(
      Input6,
      {
        width: "w-16",
        min: 0,
        max: 31,
        id: "experience-duration-amount",
        type: "number",
        value: current.durationAmount,
        onValueChange: valueChanged
      }
    ),
    /* @__PURE__ */ jsx117(
      RadioList2,
      {
        direction: ListDirection2.Horizontal,
        value: current.durationType,
        list: options2,
        onChange: typeChanged
      }
    )
  ] });
};

// src/vacancies/components/DurationEditor.tsx
import { jsx as jsx118, jsxs as jsxs81 } from "react/jsx-runtime";
var DurationEditor = ({ amount, recency, onChanged }) => {
  const [currentAmount, setCurrentAmount] = useState37(
    () => amount
  );
  const [currentRecency, setCurrentRecency] = useState37(
    () => recency
  );
  const onAmountChanged = useCallback64(
    (changes) => {
      setCurrentAmount(changes);
      onChanged({
        amount: changes,
        recency: currentRecency
      });
    },
    [onChanged, currentRecency]
  );
  const onRecencyChanged = useCallback64(
    (changes) => {
      setCurrentRecency(changes);
      onChanged({
        amount: currentAmount,
        recency: changes
      });
    },
    [onChanged, currentAmount]
  );
  return /* @__PURE__ */ jsxs81("div", { className: "flex items-center gap-10", children: [
    /* @__PURE__ */ jsxs81("div", { className: "flex flex-col gap-2", children: [
      /* @__PURE__ */ jsx118("div", { children: "Amount" }),
      /* @__PURE__ */ jsx118("form", { children: /* @__PURE__ */ jsx118(
        ExperienceDurationSelector,
        {
          value: amount,
          onChanged: onAmountChanged
        }
      ) })
    ] }),
    /* @__PURE__ */ jsxs81("div", { className: "flex flex-col gap-2", children: [
      /* @__PURE__ */ jsx118("div", { children: "Recency" }),
      /* @__PURE__ */ jsx118("form", { children: /* @__PURE__ */ jsx118(
        ExperienceDurationSelector,
        {
          value: recency,
          onChanged: onRecencyChanged
        }
      ) })
    ] })
  ] });
};

// src/vacancies/components/__generated__/VacancyEditorDescriptionQuery.graphql.ts
var node158 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "vacancyId"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "vacancyId",
      "variableName": "vacancyId"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "vacancyId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "publicDescriptionHtml",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "publicDescriptionText",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "publicDescriptionEditorState",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "profession",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "industryId",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "industryName",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationAmount",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationType",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "concreteType": "VacancyDates",
    "kind": "LinkedField",
    "name": "dates",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "startDate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "startAsap",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "durationCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "durationDescription",
        "storageKey": null
      },
      v11,
      v12
    ],
    "storageKey": null
  }, v14 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v15 = [
    v12,
    v11
  ], v16 = [
    v11,
    v12
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "VacancyEditorDescriptionQuery",
      "selections": [
        {
          "alias": "vacancy",
          "args": v1,
          "concreteType": "Vacancy",
          "kind": "LinkedField",
          "name": "recruitVacancyById",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            v10,
            v13,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "VacancyEditorDescriptionFragment_vacancy"
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "VacancyEditorDescriptionQuery",
      "selections": [
        {
          "alias": "vacancy",
          "args": v1,
          "concreteType": "Vacancy",
          "kind": "LinkedField",
          "name": "recruitVacancyById",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            v10,
            v13,
            v14,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "companyVsSkillWeight",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "VacancyScoringConfig",
              "kind": "LinkedField",
              "name": "scoringConfig",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "industryNegativeThreshold",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "industryPositiveThreshold",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "relevanceNegativeThreshold",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "relevancePositiveThreshold",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Duration",
                  "kind": "LinkedField",
                  "name": "industryExperience",
                  "plural": false,
                  "selections": v15,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Duration",
                  "kind": "LinkedField",
                  "name": "industryRecency",
                  "plural": false,
                  "selections": v15,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Duration",
                  "kind": "LinkedField",
                  "name": "relevantExperience",
                  "plural": false,
                  "selections": v15,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Duration",
                  "kind": "LinkedField",
                  "name": "relevantRecency",
                  "plural": false,
                  "selections": v15,
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "SkillGroup",
              "kind": "LinkedField",
              "name": "skillGroups",
              "plural": true,
              "selections": [
                v23,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "skillGroupId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isRequired",
                  "storageKey": null
                },
                v14,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "weight",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SkillGroupTerm",
                  "kind": "LinkedField",
                  "name": "terms",
                  "plural": true,
                  "selections": [
                    v14,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isSkill",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Duration",
                  "kind": "LinkedField",
                  "name": "experience",
                  "plural": false,
                  "selections": v16,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Duration",
                  "kind": "LinkedField",
                  "name": "recency",
                  "plural": false,
                  "selections": v16,
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "userRequiredSkills",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "userOptionalSkills",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "d4e98bff082a9c7e88fb3e47e3dde3eb",
      "id": null,
      "metadata": {},
      "name": "VacancyEditorDescriptionQuery",
      "operationKind": "query",
      "text": "query VacancyEditorDescriptionQuery(\n  $vacancyId: UUID!\n) {\n  vacancy: recruitVacancyById(vacancyId: $vacancyId) {\n    id\n    vacancyId\n    code\n    publicDescriptionHtml\n    publicDescriptionText\n    publicDescriptionEditorState\n    profession\n    industryId\n    industryName\n    dates {\n      startDate\n      startAsap\n      durationCode\n      durationDescription\n      durationAmount\n      durationType\n    }\n    ...VacancyEditorDescriptionFragment_vacancy\n  }\n}\n\nfragment VacancyEditorDescriptionFragment_vacancy on Vacancy {\n  id\n  vacancyId\n  code\n  name\n  publicDescriptionHtml\n  publicDescriptionText\n  publicDescriptionEditorState\n  profession\n  industryId\n  industryName\n  companyVsSkillWeight\n  scoringConfig {\n    industryNegativeThreshold\n    industryPositiveThreshold\n    relevanceNegativeThreshold\n    relevancePositiveThreshold\n    industryExperience {\n      durationType\n      durationAmount\n    }\n    industryRecency {\n      durationType\n      durationAmount\n    }\n    relevantExperience {\n      durationType\n      durationAmount\n    }\n    relevantRecency {\n      durationType\n      durationAmount\n    }\n  }\n  dates {\n    startDate\n    startAsap\n    durationCode\n    durationDescription\n    durationAmount\n    durationType\n  }\n  skillGroups {\n    id\n    skillGroupId\n    isRequired\n    name\n    weight\n    terms {\n      name\n      isSkill\n    }\n    experience {\n      durationAmount\n      durationType\n    }\n    recency {\n      durationAmount\n      durationType\n    }\n  }\n  ...VacancySkillsText_vacancy\n}\n\nfragment VacancySkillsText_vacancy on Vacancy {\n  id\n  userRequiredSkills\n  userOptionalSkills\n}\n"
    }
  };
}();
node158.hash = "3e3c654f7d7c3b6cb79a040aad743bc2";
var VacancyEditorDescriptionQuery_graphql_default = node158;

// src/vacancies/components/__generated__/VacancyEditorDescriptionFragment_vacancy.graphql.ts
var node159 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationType",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationAmount",
    "storageKey": null
  }, v4 = [
    v23,
    v32
  ], v5 = [
    v32,
    v23
  ];
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "VacancyEditorDescriptionFragment_vacancy",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "vacancyId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      v1,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "publicDescriptionHtml",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "publicDescriptionText",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "publicDescriptionEditorState",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "profession",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "industryId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "industryName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "companyVsSkillWeight",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "VacancyScoringConfig",
        "kind": "LinkedField",
        "name": "scoringConfig",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "industryNegativeThreshold",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "industryPositiveThreshold",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "relevanceNegativeThreshold",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "relevancePositiveThreshold",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Duration",
            "kind": "LinkedField",
            "name": "industryExperience",
            "plural": false,
            "selections": v4,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Duration",
            "kind": "LinkedField",
            "name": "industryRecency",
            "plural": false,
            "selections": v4,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Duration",
            "kind": "LinkedField",
            "name": "relevantExperience",
            "plural": false,
            "selections": v4,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Duration",
            "kind": "LinkedField",
            "name": "relevantRecency",
            "plural": false,
            "selections": v4,
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "VacancyDates",
        "kind": "LinkedField",
        "name": "dates",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startAsap",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "durationCode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "durationDescription",
            "storageKey": null
          },
          v32,
          v23
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SkillGroup",
        "kind": "LinkedField",
        "name": "skillGroups",
        "plural": true,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "skillGroupId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isRequired",
            "storageKey": null
          },
          v1,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "weight",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SkillGroupTerm",
            "kind": "LinkedField",
            "name": "terms",
            "plural": true,
            "selections": [
              v1,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isSkill",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Duration",
            "kind": "LinkedField",
            "name": "experience",
            "plural": false,
            "selections": v5,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Duration",
            "kind": "LinkedField",
            "name": "recency",
            "plural": false,
            "selections": v5,
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "VacancySkillsText_vacancy"
      }
    ],
    "type": "Vacancy",
    "abstractKey": null
  };
}();
node159.hash = "970bef3370aa2342596b0ec87b780d40";
var VacancyEditorDescriptionFragment_vacancy_graphql_default = node159;

// src/vacancies/components/VacancyEditorDescription.tsx
import {
  Suspense as Suspense47,
  useCallback as useCallback84,
  useMemo as useMemo25,
  useState as useState55
} from "react";
import { useFragment as useFragment41, useLazyLoadQuery as useLazyLoadQuery25 } from "react-relay";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/solid";
import { object as object15, any as any2 } from "zod";
import { useNavigate as useNavigate18 } from "react-router-dom";
import { createClientMutationId as createClientMutationId39, useToggle as useToggle20 } from "shared-lib";
import {
  Button as Button46,
  ContentEditor,
  EdSkeleton as EdSkeleton40,
  Error as Error7,
  Input as Input12,
  isHTMLDocument,
  LinkButton as LinkButton4,
  serializeEditorStateToHtml as serializeEditorStateToHtml2,
  Size as Size26,
  useEditorState
} from "shared-ui";
import {
  IndustrySearchContainer
} from "feature-data-management";

// src/professions/__generated__/ProfessionSearchBoxQuery.graphql.ts
var node160 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "name"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "name": "ASC"
        }
      ]
    },
    {
      "fields": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "startsWith",
              "variableName": "name"
            }
          ],
          "kind": "ObjectValue",
          "name": "name"
        }
      ],
      "kind": "ObjectValue",
      "name": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ProfessionSearchBoxQuery",
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "name",
              "variableName": "name"
            }
          ],
          "kind": "FragmentSpread",
          "name": "ProfessionSearchOptions_industries"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ProfessionSearchBoxQuery",
      "selections": [
        {
          "alias": "professions",
          "args": v1,
          "concreteType": "RecruitProfessionsConnection",
          "kind": "LinkedField",
          "name": "recruitProfessions",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfessionsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfession",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "class",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "group",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "professions",
          "args": v1,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "ProfessionSearchOptions_professions",
          "kind": "LinkedHandle",
          "name": "recruitProfessions"
        }
      ]
    },
    "params": {
      "cacheID": "6511c227379cfe3eb76ce46741144bbd",
      "id": null,
      "metadata": {},
      "name": "ProfessionSearchBoxQuery",
      "operationKind": "query",
      "text": "query ProfessionSearchBoxQuery(\n  $name: String!\n) {\n  ...ProfessionSearchOptions_industries_2aiVTE\n}\n\nfragment ProfessionSearchOptions_industries_2aiVTE on Query {\n  professions: recruitProfessions(first: 10, order: [{name: ASC}], where: {name: {startsWith: $name}}) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        name\n        class\n        group\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node160.hash = "109f9fb710fe4ef06a9b97c43a85d524";
var ProfessionSearchBoxQuery_graphql_default = node160;

// src/professions/ProfessionSearchBox.tsx
import { Suspense as Suspense35, useCallback as useCallback65, useEffect as useEffect17, useMemo as useMemo21, useState as useState38 } from "react";
import { useQueryLoader as useQueryLoader4 } from "react-relay";
import { debounce as debounce7 } from "lodash-es";
import { ChevronUpDownIcon as ChevronUpDownIcon5 } from "@heroicons/react/24/solid";
import { Combobox as Combobox9 } from "@headlessui/react";

// src/professions/__generated__/ProfessionSearchOptionsPaginationQuery.graphql.ts
var node161 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "name"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v23 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v32 = [
    v1,
    v23,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "name": "ASC"
        }
      ]
    },
    {
      "fields": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "startsWith",
              "variableName": "name"
            }
          ],
          "kind": "ObjectValue",
          "name": "name"
        }
      ],
      "kind": "ObjectValue",
      "name": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ProfessionSearchOptionsPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v23,
            {
              "kind": "Variable",
              "name": "name",
              "variableName": "name"
            }
          ],
          "kind": "FragmentSpread",
          "name": "ProfessionSearchOptions_industries"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ProfessionSearchOptionsPaginationQuery",
      "selections": [
        {
          "alias": "professions",
          "args": v32,
          "concreteType": "RecruitProfessionsConnection",
          "kind": "LinkedField",
          "name": "recruitProfessions",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfessionsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfession",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "class",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "group",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "professions",
          "args": v32,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "ProfessionSearchOptions_professions",
          "kind": "LinkedHandle",
          "name": "recruitProfessions"
        }
      ]
    },
    "params": {
      "cacheID": "5b6de15415ff3bfc80f0f61a9f2407fc",
      "id": null,
      "metadata": {},
      "name": "ProfessionSearchOptionsPaginationQuery",
      "operationKind": "query",
      "text": 'query ProfessionSearchOptionsPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $name: String = ""\n) {\n  ...ProfessionSearchOptions_industries_3cTRis\n}\n\nfragment ProfessionSearchOptions_industries_3cTRis on Query {\n  professions: recruitProfessions(first: $first, after: $after, order: [{name: ASC}], where: {name: {startsWith: $name}}) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        name\n        class\n        group\n        __typename\n      }\n    }\n  }\n}\n'
    }
  };
}();
node161.hash = "cadcd23c2d455bdbc10434e50f6847fc";
var ProfessionSearchOptionsPaginationQuery_graphql_default = node161;

// src/professions/__generated__/ProfessionSearchOptions_industries.graphql.ts
var node163 = function() {
  var v0 = [
    "professions"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "defaultValue": "",
        "kind": "LocalArgument",
        "name": "name"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": ProfessionSearchOptionsPaginationQuery_graphql_default
      }
    },
    "name": "ProfessionSearchOptions_industries",
    "selections": [
      {
        "alias": "professions",
        "args": [
          {
            "kind": "Literal",
            "name": "order",
            "value": [
              {
                "name": "ASC"
              }
            ]
          },
          {
            "fields": [
              {
                "fields": [
                  {
                    "kind": "Variable",
                    "name": "startsWith",
                    "variableName": "name"
                  }
                ],
                "kind": "ObjectValue",
                "name": "name"
              }
            ],
            "kind": "ObjectValue",
            "name": "where"
          }
        ],
        "concreteType": "RecruitProfessionsConnection",
        "kind": "LinkedField",
        "name": "__ProfessionSearchOptions_professions_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitProfessionsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitProfession",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "class",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "group",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node163.hash = "cadcd23c2d455bdbc10434e50f6847fc";
var ProfessionSearchOptions_industries_graphql_default = node163;

// src/professions/ProfessionSearchOptions.tsx
import {
  usePaginationFragment as usePaginationFragment9,
  usePreloadedQuery as usePreloadedQuery11
} from "react-relay";
import { Combobox as Combobox8 } from "@headlessui/react";
import { CheckIcon as CheckIcon5 } from "@heroicons/react/24/solid";
import { isNotNull as isNotNull6 } from "shared-lib";
import { classNames as classNames12 } from "shared-ui";
import { Fragment as Fragment30, jsx as jsx119, jsxs as jsxs83 } from "react/jsx-runtime";
var fragmentDef31 = ProfessionSearchOptions_industries_graphql_default;
var ProfessionSearchOptionsLoader = ({
  queryRef: queryRef3
}) => {
  const data = usePreloadedQuery11(
    professionSearchBoxQueryDef,
    queryRef3
  );
  return /* @__PURE__ */ jsx119(ProfessionSearchOptions, { fragmentRef: data });
};
var ProfessionSearchOptions = ({ fragmentRef }) => {
  const { data, refetch } = usePaginationFragment9(fragmentDef31, fragmentRef);
  const { professions } = data;
  const items = professions?.edges?.map((e4) => e4.node);
  const rows = items ?? [].filter(isNotNull6);
  return /* @__PURE__ */ jsx119(Combobox8.Options, { className: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm", children: rows.map((result) => /* @__PURE__ */ jsx119(
    Combobox8.Option,
    {
      value: result,
      className: ({ active }) => classNames12(
        "relative cursor-default select-none py-2 pl-3 pr-9",
        active ? "bg-info-600 text-white" : "text-gray-900"
      ),
      children: ({ active, selected }) => /* @__PURE__ */ jsxs83(Fragment30, { children: [
        /* @__PURE__ */ jsx119("div", { className: "flex", children: /* @__PURE__ */ jsx119(
          "span",
          {
            className: classNames12(
              "truncate",
              selected ? "font-semibold" : ""
            ),
            children: result && result.name ? result.name : ""
          }
        ) }),
        selected && /* @__PURE__ */ jsx119(
          "span",
          {
            className: classNames12(
              "absolute inset-y-0 right-0 flex items-center pr-4",
              active ? "bg-info-600 text-white" : "text-info-600"
            ),
            children: /* @__PURE__ */ jsx119(CheckIcon5, { className: "h-5 w-5", "aria-hidden": "true" })
          }
        )
      ] })
    },
    result.id
  )) });
};

// src/professions/ProfessionSearchBox.tsx
import { jsx as jsx120, jsxs as jsxs84 } from "react/jsx-runtime";
var compareResults2 = (a4, b3) => a4?.id === b3?.id;
var professionSearchBoxQueryDef = ProfessionSearchBoxQuery_graphql_default;
var ProfessionSearchBox = ({ name, onSelected, value }) => {
  const [queryReference, loadQuery48, disposeQuery] = useQueryLoader4(professionSearchBoxQueryDef);
  const [selected, setSelected] = useState38(
    value || null
  );
  const [searchTerm, setSearchTerm] = useState38("");
  const onQueryChangeHandler = useMemo21(
    () => debounce7((q4) => setSearchTerm(q4), 500),
    []
  );
  useEffect17(() => {
    if (!searchTerm) {
      return;
    }
    loadQuery48({ name: searchTerm });
  }, [searchTerm]);
  useEffect17(() => {
    return () => {
      onQueryChangeHandler.cancel();
    };
  }, [onQueryChangeHandler]);
  const onSetSelected = useCallback65(
    (result) => {
      setSelected(result);
      onSelected(result);
    },
    [onSelected]
  );
  return /* @__PURE__ */ jsx120(Suspense35, { fallback: /* @__PURE__ */ jsx120("div", { children: "Searching...." }), children: /* @__PURE__ */ jsx120(
    Combobox9,
    {
      as: "div",
      name,
      className: "w-full",
      value: selected ?? void 0,
      onChange: onSetSelected,
      by: compareResults2,
      children: /* @__PURE__ */ jsxs84("div", { className: "relative mt-2", children: [
        /* @__PURE__ */ jsx120(
          Combobox9.Input,
          {
            className: "focus:border-info-500 focus:ring-info-500 w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:outline-none focus:ring-1 sm:text-sm",
            onChange: (event) => onQueryChangeHandler(event.target.value),
            displayValue: (result) => {
              if (!result || !result.name) {
                return "";
              }
              return result.name;
            },
            autoComplete: "off"
          }
        ),
        /* @__PURE__ */ jsx120(Combobox9.Button, { className: "absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none", children: /* @__PURE__ */ jsx120(
          ChevronUpDownIcon5,
          {
            className: "h-5 w-5 text-gray-400",
            "aria-hidden": "true"
          }
        ) }),
        /* @__PURE__ */ jsx120(Suspense35, { fallback: "Searching...", children: queryReference && /* @__PURE__ */ jsx120(ProfessionSearchOptionsLoader, { queryRef: queryReference }) })
      ] })
    }
  ) });
};

// src/professions/ProfessionSearchContainer.tsx
import { useCallback as useCallback66, useState as useState39 } from "react";
import { jsx as jsx121 } from "react/jsx-runtime";
var ProfessionSearchContainer = ({
  value,
  name,
  onSearchCompleted
}) => {
  const [selectedResult, setSelectedResult] = useState39(value || null);
  const onSetSelected = useCallback66(
    (r4) => {
      setSelectedResult(r4);
      onSearchCompleted(r4);
    },
    [selectedResult]
  );
  return /* @__PURE__ */ jsx121("div", { children: /* @__PURE__ */ jsx121(
    ProfessionSearchBox,
    {
      value: selectedResult,
      name: name || "industry-search",
      onSelected: onSetSelected
    }
  ) });
};

// src/vacancies/components/__generated__/VacancyEditRouteQuery.graphql.ts
var node164 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "vacancyCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "vacancyCode",
      "variableName": "vacancyCode"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v4 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }, v5 = {
    "alias": "vacancy",
    "args": v1,
    "concreteType": "Vacancy",
    "kind": "LinkedField",
    "name": "recruitVacancyByCode",
    "plural": false,
    "selections": [
      v23,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "vacancyId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "employerId",
        "storageKey": null
      },
      v32,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "publicDescriptionText",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "VacancyRate",
        "kind": "LinkedField",
        "name": "rate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "payType",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "LocationCriteria",
        "kind": "LinkedField",
        "name": "locations",
        "plural": true,
        "selections": [
          v32
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "VacancyDates",
        "kind": "LinkedField",
        "name": "dates",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "durationDescription",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SkillGroup",
        "kind": "LinkedField",
        "name": "skillGroups",
        "plural": true,
        "selections": [
          v23
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "VacancyEditState",
        "kind": "LinkedField",
        "name": "editState",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canPublish",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VacancyEditRequirement",
            "kind": "LinkedField",
            "name": "requirements",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      v4
    ],
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "concreteType": "RecruitTalentPool",
    "kind": "LinkedField",
    "name": "talentPool",
    "plural": false,
    "selections": [
      v23,
      v32
    ],
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "VacancyEditRouteQuery",
      "selections": [
        v5,
        {
          "alias": "vacancyTalentPools",
          "args": v1,
          "concreteType": "RecruitTalentPoolVacancyAccess",
          "kind": "LinkedField",
          "name": "recruitTalentPoolsForVacancyByCode",
          "plural": true,
          "selections": [
            v6,
            v4
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "VacancyEditRouteQuery",
      "selections": [
        v5,
        {
          "alias": "vacancyTalentPools",
          "args": v1,
          "concreteType": "RecruitTalentPoolVacancyAccess",
          "kind": "LinkedField",
          "name": "recruitTalentPoolsForVacancyByCode",
          "plural": true,
          "selections": [
            v6,
            v23,
            v4
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "5e5b6e1936bf5257f2c3c775349f7e80",
      "id": null,
      "metadata": {},
      "name": "VacancyEditRouteQuery",
      "operationKind": "query",
      "text": "query VacancyEditRouteQuery(\n  $vacancyCode: Int!\n) {\n  vacancy: recruitVacancyByCode(vacancyCode: $vacancyCode) {\n    id\n    code\n    vacancyId\n    employerId\n    name\n    status\n    publicDescriptionText\n    rate {\n      payType\n    }\n    locations {\n      name\n    }\n    dates {\n      durationDescription\n    }\n    skillGroups {\n      id\n    }\n    editState {\n      canPublish\n      requirements {\n        key\n        message\n      }\n    }\n  }\n  vacancyTalentPools: recruitTalentPoolsForVacancyByCode(vacancyCode: $vacancyCode) {\n    talentPool {\n      id\n      name\n    }\n    id\n  }\n}\n"
    }
  };
}();
node164.hash = "d7c305291427344108888b1b5ff23c28";
var VacancyEditRouteQuery_graphql_default = node164;

// src/vacancies/components/VacancyEdit.tsx
import { Suspense as Suspense46, useEffect as useEffect21 } from "react";
import {
  loadQuery as loadQuery11,
  usePreloadedQuery as usePreloadedQuery13
} from "react-relay";
import {
  Navigate as Navigate7,
  Outlet as Outlet7,
  useNavigate as useNavigate17,
  useRouteLoaderData as useRouteLoaderData8
} from "react-router-dom";
import { EdSkeleton as EdSkeleton39, ErrorContainer as ErrorContainer9 } from "shared-ui";

// src/vacancies/components/VacancyEditorOverview.tsx
import { Suspense as Suspense45, useCallback as useCallback83 } from "react";
import { Navigate as Navigate6, Outlet as Outlet6 } from "react-router-dom";
import { EdSkeleton as EdSkeleton38, ErrorContainer as ErrorContainer8 } from "shared-ui";

// src/vacancies/components/Wizard.tsx
import {
  createContext as createContext9,
  useContext as useContext9
} from "react";
import {
  Button as Button36,
  HorizontalWizardSteps,
  WizardStageTypes,
  Size as Size17
} from "shared-ui";
import { jsx as jsx123, jsxs as jsxs85 } from "react/jsx-runtime";
var WizardContext = createContext9(null);

// src/vacancies/components/__generated__/VacancyEditorFormsQuery.graphql.ts
var node165 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "vacancyId"
    }
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "vacancyId",
    "storageKey": null
  }, v23 = [
    {
      "alias": "vacancy",
      "args": [
        {
          "kind": "Variable",
          "name": "vacancyId",
          "variableName": "vacancyId"
        }
      ],
      "concreteType": "Vacancy",
      "kind": "LinkedField",
      "name": "recruitVacancyById",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        v1,
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "employerId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "employerSlug",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "VacancyFormGroupReference",
          "kind": "LinkedField",
          "name": "formGroupReferences",
          "plural": true,
          "selections": [
            v1,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "formTemplateId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "templateTypeVersion",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "templateName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "templateKey",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isRequired",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "VacancyEditorFormsQuery",
      "selections": v23,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "VacancyEditorFormsQuery",
      "selections": v23
    },
    "params": {
      "cacheID": "59aa9c21540f70dbf820155b08174160",
      "id": null,
      "metadata": {},
      "name": "VacancyEditorFormsQuery",
      "operationKind": "query",
      "text": "query VacancyEditorFormsQuery(\n  $vacancyId: UUID!\n) {\n  vacancy: recruitVacancyById(vacancyId: $vacancyId) {\n    id\n    vacancyId\n    employerId\n    employerSlug\n    code\n    formGroupReferences {\n      vacancyId\n      formTemplateId\n      templateTypeVersion\n      templateName\n      templateKey\n      isRequired\n    }\n  }\n}\n"
    }
  };
}();
node165.hash = "6413e2b9b68b62afaa784dc1b546e58d";
var VacancyEditorFormsQuery_graphql_default = node165;

// src/vacancies/components/VacancyEditorForms.tsx
import { Suspense as Suspense36, useCallback as useCallback67, useState as useState40 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery18 } from "react-relay";
import { createClientMutationId as createClientMutationId33, useLogger as useLogger13 } from "shared-lib";
import { Button as Button37, EdLink as EdLink12, EdSkeleton as EdSkeleton30, Size as Size18 } from "shared-ui";
import {
  FormTemplateSearchContainer
} from "app-core";
import { jsx as jsx124, jsxs as jsxs86 } from "react/jsx-runtime";
var queryDef17 = VacancyEditorFormsQuery_graphql_default;
var initialFormState = (vacancy) => {
  return {
    vacancyId: vacancy.vacancyId
  };
};
function vacancyHasChanged(form, vacancy, log) {
  return false;
}
var VacancyForm = ({ vacancyId, fg }) => {
  const [removeForm, isRemovingForm] = useVacancyFormRemove();
  const [changeFormVersion, isChangingFormVersion] = useVacancyChangeFormVersion();
  const onRemoveForm = useCallback67(async () => {
    const input = {
      vacancyId,
      templateId: fg.formTemplateId,
      clientMutationId: createClientMutationId33()
    };
    await removeForm({ input });
  }, [removeForm]);
  return /* @__PURE__ */ jsxs86("div", { className: "flex items-center justify-between", children: [
    /* @__PURE__ */ jsxs86("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ jsx124("div", { className: "text-primary-500 p-2 font-medium", children: fg.templateName }),
      fg.isRequired && /* @__PURE__ */ jsx124("div", { className: "font-medium text-green-500", children: "Required" })
    ] }),
    /* @__PURE__ */ jsx124("div", { className: "flex items-center justify-between", children: /* @__PURE__ */ jsx124(Button37, { color: "primary", clicked: onRemoveForm, children: "Remove Form" }) })
  ] }, fg.formTemplateId);
};
var VacancyEditorForms = ({ editRouteId }) => {
  const data = useVacancyEditRouteData(editRouteId);
  const [log] = useLogger13();
  const [selectedForm, setSelectedForm] = useState40(null);
  const onSearchCompleted = useCallback67(
    (result) => {
      setSelectedForm(result);
    },
    [setSelectedForm]
  );
  const [addForm, isAddingForm] = useVacancyFormAdd();
  const onAddForm = useCallback67(async () => {
    if (!selectedForm || !data.vacancy) {
      return;
    }
    const input = {
      vacancyId: data.vacancy.vacancyId,
      templateId: selectedForm.formTemplateId,
      clientMutationId: createClientMutationId33()
    };
    const response = await addForm({ input });
    if (response.data.vacancy) {
      setSelectedForm(null);
    }
  }, [addForm]);
  const onCancelAddForm = useCallback67(async () => {
    setSelectedForm(null);
  }, [addForm]);
  const query3 = useLazyLoadQuery18(
    queryDef17,
    { vacancyId: data.vacancy.vacancyId },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { vacancy } = query3;
  const initialState2 = initialFormState(vacancy);
  const [form, setForm] = useState40(initialState2);
  const [hasChanged, setHasChanged] = useState40(() => {
    return vacancyHasChanged(form, vacancy, log);
  });
  if (!vacancy) {
    return /* @__PURE__ */ jsx124(EdSkeleton30, {});
  }
  let forms = /* @__PURE__ */ jsx124("div", { className: "p-2 text-sm text-gray-900", children: "No Forms Configured" });
  if (vacancy.formGroupReferences && vacancy.formGroupReferences.length > 0) {
    const formsList = vacancy.formGroupReferences.map((fg) => {
      return /* @__PURE__ */ jsx124(
        VacancyForm,
        {
          vacancyId: vacancy.vacancyId,
          fg
        },
        fg.formTemplateId
      );
    });
    forms = /* @__PURE__ */ jsx124("div", { className: "flex flex-col gap-2 divide-y p-2", children: formsList });
  }
  return /* @__PURE__ */ jsx124(Suspense36, { fallback: /* @__PURE__ */ jsx124(EdSkeleton30, {}), children: /* @__PURE__ */ jsxs86("div", { className: "m-auto flex flex-col gap-2 border bg-white p-2 shadow sm:rounded-lg lg:p-8 xl:w-2/3", children: [
    /* @__PURE__ */ jsxs86("div", { className: "flex flex-col gap-2 p-2", children: [
      /* @__PURE__ */ jsx124("div", { className: "text-primary-500 border-b px-2 py-4", children: /* @__PURE__ */ jsx124("h1", { children: "Forms" }) }),
      selectedForm ? /* @__PURE__ */ jsxs86("div", { className: "mt-4 border bg-white p-8", children: [
        /* @__PURE__ */ jsx124("div", { className: "text-primary-500 border-b px-2 py-4 text-lg", children: selectedForm.name }),
        selectedForm.name !== selectedForm.description && /* @__PURE__ */ jsx124("div", { className: "border-b px-2 py-4 text-sm text-gray-900", children: selectedForm.description }),
        /* @__PURE__ */ jsxs86("div", { className: "flex justify-end gap-2 pt-4", children: [
          /* @__PURE__ */ jsx124("div", { children: /* @__PURE__ */ jsx124(Button37, { color: "primary", clicked: onAddForm, children: "Add Form" }) }),
          /* @__PURE__ */ jsx124("div", { children: /* @__PURE__ */ jsx124(Button37, { color: "secondary", clicked: onCancelAddForm, children: "Cancel" }) })
        ] })
      ] }) : /* @__PURE__ */ jsxs86("div", { className: "flex flex-col gap-4 p-2", children: [
        forms,
        /* @__PURE__ */ jsxs86("div", { className: "flex flex-col gap-2 p-2", children: [
          /* @__PURE__ */ jsx124("div", { children: "Search Forms" }),
          /* @__PURE__ */ jsx124(
            FormTemplateSearchContainer,
            {
              employerId: vacancy.employerId,
              onSearchCompleted,
              formType: "JsonForms"
            }
          )
        ] })
      ] })
    ] }),
    /* @__PURE__ */ jsx124(EdLink12, { name: "back", href: "../overview", children: /* @__PURE__ */ jsx124(Button37, { color: "primary", size: Size18.xl, children: "Back" }) })
  ] }) });
};

// src/vacancies/components/__generated__/VacancyEditorDetailsQuery.graphql.ts
var node166 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "vacancyId"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "vacancyId",
      "variableName": "vacancyId"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "vacancyId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "employerSlug",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "publicDescriptionHtml",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "publicDescriptionText",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "userRequiredSkills",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "userOptionalSkills",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "concreteType": "VacancyRate",
    "kind": "LinkedField",
    "name": "rate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currencyCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currencyCountryCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currencyCountryName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isPrivate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "max",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "min",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "payType",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "concreteType": "VacancyDates",
    "kind": "LinkedField",
    "name": "dates",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "startDate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "startAsap",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "durationCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "durationDescription",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "durationAmount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "durationType",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "expiresAt",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "employerReference",
    "storageKey": null
  }, v14 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "headcount",
    "storageKey": null
  }, v15 = {
    "alias": null,
    "args": null,
    "concreteType": "LocationCriteria",
    "kind": "LinkedField",
    "name": "locations",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "countryCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "latitude",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "longitude",
        "storageKey": null
      }
    ],
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "VacancyEditorDetailsQuery",
      "selections": [
        {
          "alias": "vacancy",
          "args": v1,
          "concreteType": "Vacancy",
          "kind": "LinkedField",
          "name": "recruitVacancyById",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            v10,
            v11,
            v12,
            v13,
            v14,
            v15,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "VacancySkillsText_vacancy"
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "VacancyEditorDetailsQuery",
      "selections": [
        {
          "alias": "vacancy",
          "args": v1,
          "concreteType": "Vacancy",
          "kind": "LinkedField",
          "name": "recruitVacancyById",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            v10,
            v11,
            v12,
            v13,
            v14,
            v15
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "8f04536c889f6eefa8b85c4360756914",
      "id": null,
      "metadata": {},
      "name": "VacancyEditorDetailsQuery",
      "operationKind": "query",
      "text": "query VacancyEditorDetailsQuery(\n  $vacancyId: UUID!\n) {\n  vacancy: recruitVacancyById(vacancyId: $vacancyId) {\n    id\n    vacancyId\n    employerSlug\n    code\n    publicDescriptionHtml\n    publicDescriptionText\n    userRequiredSkills\n    userOptionalSkills\n    rate {\n      currencyCode\n      currencyCountryCode\n      currencyCountryName\n      isPrivate\n      max\n      min\n      payType\n    }\n    dates {\n      startDate\n      startAsap\n      durationCode\n      durationDescription\n      durationAmount\n      durationType\n    }\n    expiresAt\n    employerReference\n    headcount\n    locations {\n      name\n      countryCode\n      latitude\n      longitude\n    }\n    ...VacancySkillsText_vacancy\n  }\n}\n\nfragment VacancySkillsText_vacancy on Vacancy {\n  id\n  userRequiredSkills\n  userOptionalSkills\n}\n"
    }
  };
}();
node166.hash = "7b72a0794f224462c1f89fd663c5b7a5";
var VacancyEditorDetailsQuery_graphql_default = node166;

// src/vacancies/components/VacancyEditorDetails.tsx
import { Suspense as Suspense37, useCallback as useCallback71, useEffect as useEffect18, useState as useState45 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery19 } from "react-relay";
import { addMonths as addMonths2 } from "date-fns";
import z7 from "zod";
import { useNavigate as useNavigate14 } from "react-router-dom";
import {
  createClientMutationId as createClientMutationId34,
  formatDateHtml as formatDateHtml3,
  formatForApi,
  parseDate as parseDate11,
  useLogger as useLogger14
} from "shared-lib";
import { Button as Button38, DateInput as DateInput2, EdSkeleton as EdSkeleton31, Error as Error5, Input as Input8, Size as Size19 } from "shared-ui";
import {
  GeoLocationsEditor
} from "feature-data-management";

// src/vacancies/components/DurationTypeSelector.tsx
import { useCallback as useCallback68, useState as useState41 } from "react";
import { RadioList as RadioList3 } from "shared-ui";
import { jsx as jsx125 } from "react/jsx-runtime";
var daysOption = {
  id: "DAYS",
  label: "Days"
};
var weeksOption = {
  id: "WEEKS",
  label: "Weeks"
};
var monthsOption2 = {
  id: "MONTHS",
  label: "Months"
};
var yearsOption2 = {
  id: "YEARS",
  label: "Years"
};
function toOption(item) {
  switch (item) {
    case "DAYS": {
      return daysOption;
    }
    case "WEEKS": {
      return weeksOption;
    }
    case "MONTHS": {
      return monthsOption2;
    }
    case "YEARS": {
      return yearsOption2;
    }
  }
  return monthsOption2;
}
var options3 = [
  daysOption,
  weeksOption,
  monthsOption2,
  yearsOption2
];
var DurationTypeSelector = ({ value, onChanged }) => {
  const [current, setCurrent] = useState41(() => {
    if (value) {
      return toOption(value);
    }
    return monthsOption2;
  });
  const changed = useCallback68(
    (value2) => {
      setCurrent(value2);
      onChanged(value2.id);
    },
    [setCurrent]
  );
  return /* @__PURE__ */ jsx125(RadioList3, { value: current, list: options3, onChange: changed });
};

// src/vacancies/components/PlacementStart.tsx
import { useCallback as useCallback69, useState as useState43 } from "react";
import { Controller as Controller8 } from "react-hook-form";
import { DateInput, RadioList as RadioList4 } from "shared-ui";
import { formatDateHtml as formatDateHtml2, parseDate as parseDate10 } from "shared-lib";
import { Fragment as Fragment31, jsx as jsx126, jsxs as jsxs87 } from "react/jsx-runtime";
var asapOption = {
  id: "true",
  label: "As soon as possible"
};
var dateOption = {
  id: "false",
  label: "On a specific date"
};
function toOption2(startAsap) {
  if (startAsap) {
    return asapOption;
  } else {
    return dateOption;
  }
}
function fromOption(option) {
  if (option.id === "true") {
    return true;
  } else {
    return false;
  }
}
var options4 = [asapOption, dateOption];
var PlacementStart = ({
  startAsap,
  startDate,
  onChanged
}) => {
  const [currentDateOption, setCurrentDateOption] = useState43(() => {
    if (startAsap === void 0 || startDate === null) {
      return asapOption;
    }
    return toOption2(startAsap);
  });
  const [currentDate, setCurrentDate] = useState43(() => {
    return startDate || null;
  });
  const dateOptionChanged = useCallback69(
    (value) => {
      setCurrentDateOption(value);
      onChanged(fromOption(value), currentDate);
    },
    [onChanged, currentDate]
  );
  const dateChanged = useCallback69(
    (dateValue) => {
      const date = parseDate10(dateValue);
      setCurrentDate(date);
      onChanged(fromOption(currentDateOption), date);
    },
    [currentDateOption, onChanged]
  );
  const isStartingAsap = fromOption(currentDateOption);
  const dateSelector = isStartingAsap ? /* @__PURE__ */ jsx126(Fragment31, {}) : /* @__PURE__ */ jsx126("div", { className: "mt-4", children: /* @__PURE__ */ jsx126(
    DateInput,
    {
      name: "startDate",
      initialDate: currentDate === null ? null : formatDateHtml2(currentDate),
      onChanged: dateChanged,
      minDate: (/* @__PURE__ */ new Date()).toISOString().split("T")[0]
    }
  ) });
  return /* @__PURE__ */ jsxs87("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ jsx126(
      RadioList4,
      {
        value: currentDateOption,
        list: options4,
        onChange: dateOptionChanged
      }
    ),
    dateSelector
  ] });
};

// src/vacancies/components/RoleTypeSelector.tsx
import { useCallback as useCallback70, useState as useState44 } from "react";
import { Controller as Controller9 } from "react-hook-form";
import { RadioList as RadioList5 } from "shared-ui";
import { Input as Input7 } from "shared-ui";
import { Fragment as Fragment33, jsx as jsx127, jsxs as jsxs88 } from "react/jsx-runtime";
var toBeConfirmed = {
  id: "ToBeConfirmed" /* ToBeConfirmed */,
  label: "To Be Confirmed"
};
var permanent = {
  id: "Permanent" /* Permanent */,
  label: "Permanent"
};
var fixedLength = {
  id: "FixedLength" /* FixedLength */,
  label: "Contract/Temp"
};
function toRadio2(durationType) {
  switch (durationType) {
    case "ToBeConfirmed" /* ToBeConfirmed */: {
      return toBeConfirmed;
    }
    case "Permanent" /* Permanent */: {
      return permanent;
    }
    case "FixedLength" /* FixedLength */: {
      return fixedLength;
    }
  }
}
var options5 = [fixedLength, permanent, toBeConfirmed];
var RoleTypeSelector = ({ value, onChanged }) => {
  const [current, setCurrent] = useState44(() => {
    if (value) {
      return toRadio2(value);
    }
    return fixedLength;
  });
  const changed = useCallback70(
    (value2) => {
      setCurrent(value2);
      onChanged(value2.id);
    },
    [setCurrent]
  );
  return /* @__PURE__ */ jsx127(RadioList5, { value: current, list: options5, onChange: changed });
};

// src/vacancies/components/Section.tsx
import { jsx as jsx128, jsxs as jsxs89 } from "react/jsx-runtime";
var Section = ({
  title,
  description,
  children
}) => {
  return /* @__PURE__ */ jsxs89("div", { className: "", children: [
    /* @__PURE__ */ jsx128("div", { className: "lg:col-span-1", children: /* @__PURE__ */ jsxs89("div", { className: "px-4 sm:px-0", children: [
      title && /* @__PURE__ */ jsx128("h3", { className: "text-base font-medium leading-6 text-gray-900", children: title }),
      /* @__PURE__ */ jsx128("p", { className: "mt-1 hidden text-sm text-gray-600 sm:block", children: description })
    ] }) }),
    /* @__PURE__ */ jsx128("div", { className: "lg:col-span-2 lg:mt-0", children: /* @__PURE__ */ jsx128("div", { className: "bg-white md:px-4", children }) })
  ] });
};

// src/vacancies/components/VacancyEditorProgressBar.tsx
import { HorizontalWizardStepsProgressBar, StepStatus as StepStatus2 } from "shared-ui";
import { jsx as jsx129 } from "react/jsx-runtime";
var VacancyEditorProgressBar = ({ step }) => /* @__PURE__ */ jsx129(
  HorizontalWizardStepsProgressBar,
  {
    currentStep: step,
    steps: [
      {
        key: "description",
        name: "Description",
        description: "Enter vacancy details",
        status: StepStatus2.Complete,
        index: 0
      },
      {
        key: "details",
        name: "Details",
        description: "Enter vacancy details",
        status: StepStatus2.Complete,
        index: 1
      },
      {
        key: "scoring",
        name: "Scoring",
        description: "Enter vacancy details",
        status: StepStatus2.Complete,
        index: 2
      },
      {
        key: "overview",
        name: "Overview",
        description: "Enter vacancy details",
        status: StepStatus2.Complete,
        index: 3
      }
    ]
  }
);

// src/vacancies/components/VacancyEditorDetails.tsx
import { jsx as jsx130, jsxs as jsxs90 } from "react/jsx-runtime";
var queryDef18 = VacancyEditorDetailsQuery_graphql_default;
var schema = z7.object({
  minRate: z7.number({
    invalid_type_error: "Min rate is required",
    required_error: "Min rate is required"
  }).min(1, "Min rate must be at least 1"),
  maxRate: z7.number({
    invalid_type_error: "Max rate is required",
    required_error: "Max rate is required"
  }).min(1, "Max rate must be at least 1"),
  locations: z7.any().array().min(1, "At least one location is required")
  // .min(
  //   'Max rate must be greater or equal to the minimum rate',
  // ),
  // country: object().required('Country is required'),
  // locations: array().min(1, 'At least one location is required'),
});
var initialFormState2 = (vacancy) => {
  const formState = {
    payType: vacancy?.rate?.payType ? fromPayType(vacancy?.rate?.payType) : "PerDay" /* PerDay */,
    minRate: vacancy?.rate?.min ? vacancy.rate?.min || 0 : 0,
    maxRate: vacancy?.rate?.max ? vacancy.rate?.max || 0 : 0,
    country: {
      iso3: "GBR",
      name: "United Kingdom of Great Britain and Northern Ireland",
      phone: "44"
    },
    rateIsPrivate: vacancy?.rate?.isPrivate ? vacancy.rate?.isPrivate || false : false,
    roleType: toRoleType(vacancy?.dates?.durationCode),
    durationAmount: vacancy?.dates?.durationAmount || 3,
    durationType: vacancy?.dates?.durationType || "MONTHS",
    startAsap: !!vacancy?.dates?.startAsap,
    startDate: vacancy?.dates?.startDate == null ? null : parseDate11(vacancy?.dates?.startDate),
    locations: vacancy?.locations == null ? [] : vacancy?.locations.map((l4) => l4),
    positionCount: vacancy?.headcount || 1,
    employerReference: vacancy?.employerReference || createDefaultEmployerReference(vacancy),
    expiryDate: vacancy?.expiresAt ? parseDate11(vacancy.expiresAt) : addMonths2(/* @__PURE__ */ new Date(), 1)
  };
  if (vacancy) {
    if (vacancy.rate && vacancy.rate.currencyCountryName && vacancy.rate.currencyCountryCode) {
      formState.country = {
        name: vacancy.rate?.currencyCountryName,
        iso3: vacancy.rate?.currencyCountryCode,
        phone: null
      };
    }
    if (vacancy.dates?.durationAmount) {
      formState.durationAmount = vacancy.dates?.durationAmount;
    }
  }
  return formState;
};
var VacancyEditorWizardDetails = ({
  editRouteId
}) => {
  const data = useVacancyEditRouteData(editRouteId);
  const navigate = useNavigate14();
  if (!data.vacancy) {
    return /* @__PURE__ */ jsx130(EdSkeleton31, {});
  }
  return /* @__PURE__ */ jsxs90("div", { className: "flex w-full flex-col items-center gap-10 md:px-5", children: [
    /* @__PURE__ */ jsx130("div", { className: "w-9/12", children: /* @__PURE__ */ jsx130(VacancyEditorProgressBar, { step: "details" }) }),
    /* @__PURE__ */ jsx130("div", { className: "w-full px-2 md:px-5", children: /* @__PURE__ */ jsx130(
      VacancyEditorDetails,
      {
        vacancyId: data.vacancy.vacancyId,
        onNext: () => navigate("../scoring"),
        onPrevious: () => navigate("../description"),
        nextLabel: "Save & Next"
      }
    ) })
  ] });
};
var VacancyEditorOverviewDetails = ({
  editRouteId
}) => {
  const data = useVacancyEditRouteData(editRouteId);
  const navigate = useNavigate14();
  const onSaved = useCallback71(() => {
    navigate("../scoring");
  }, [navigate]);
  return /* @__PURE__ */ jsx130(
    VacancyEditorDetails,
    {
      vacancyId: data.vacancy.vacancyId,
      onNext: onSaved,
      showPrevious: true,
      onPrevious: () => navigate("../description"),
      nextLabel: "Save & Change"
    }
  );
};
var VacancyEditorDetails = ({
  vacancyId,
  onNext,
  onPrevious,
  nextLabel,
  showPrevious = true
}) => {
  const [log] = useLogger14();
  const [updateDetails, isUpdatingDetails] = useVacancyUpdateDetails();
  const query3 = useLazyLoadQuery19(
    queryDef18,
    { vacancyId },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { vacancy } = query3;
  const initialState2 = initialFormState2(vacancy);
  const [form, setForm] = useState45(initialState2);
  const [hasChanged, setHasChanged] = useState45(false);
  useEffect18(() => {
    setHasChanged(vacancyDetailsHaveChanged(form, vacancy, log));
  }, [form, log, vacancy]);
  const onPayTypeChanged = useCallback71(
    (value) => {
      setForm((current) => ({
        ...current,
        payType: value
      }));
    },
    [setForm]
  );
  const onMinRateChanged = useCallback71(
    (value) => {
      setForm((current) => ({
        ...current,
        minRate: Number(value)
      }));
    },
    [setForm]
  );
  const onMaxRateChanged = useCallback71(
    (value) => {
      setForm((current) => ({
        ...current,
        maxRate: Number(value)
      }));
    },
    [setForm]
  );
  const onChangeCountry = useCallback71(
    (selected) => {
      setForm((current) => ({
        ...current,
        country: { name: selected.name, iso3: selected.iso3, phone: null }
      }));
    },
    [setForm]
  );
  const onRateIsPrivateChanged = useCallback71(
    (value) => {
      setForm((current) => ({
        ...current,
        rateIsPrivate: value
      }));
    },
    [setForm]
  );
  const onRoleTypeChanged = useCallback71(
    (value) => {
      setForm((current) => ({
        ...current,
        roleType: value
      }));
    },
    [setForm]
  );
  const onDurationAmountChanged = useCallback71(
    (value) => {
      setForm((current) => ({
        ...current,
        durationAmount: parseInt(value)
      }));
    },
    [setForm]
  );
  const onDurationTypeChanged = useCallback71(
    (value) => {
      setForm((current) => ({
        ...current,
        durationType: value
      }));
    },
    [setForm]
  );
  const onPlacementChanged = useCallback71(
    (startAsap, startDate) => {
      setForm((current) => ({
        ...current,
        startAsap,
        startDate
      }));
    },
    [setForm]
  );
  const onLocationsChanged = useCallback71(
    (results) => {
      setForm((current) => ({
        ...current,
        locations: results
      }));
    },
    [setForm]
  );
  const onPositionCountChanged = useCallback71(
    (value) => {
      setForm((current) => ({
        ...current,
        positionCount: Number(value)
      }));
    },
    [setForm]
  );
  const onEmployerReferenceChanged = useCallback71(
    (value) => {
      setForm((current) => ({
        ...current,
        employerReference: value
      }));
    },
    [setForm]
  );
  const onExpiryDateChanged = useCallback71(
    (date) => {
      setForm((current) => ({
        ...current,
        expiryDate: parseDate11(date)
      }));
    },
    [setForm]
  );
  const [errors, setErrors] = useState45({});
  const onSave = useCallback71(async () => {
    const input = {
      vacancyId,
      durationCode: toVacancyDurationCode(form.roleType),
      durationAmount: form.durationAmount,
      durationType: form.durationType,
      employerReference: form.employerReference,
      expiresAt: formatForApi(form.expiryDate),
      headcount: form.positionCount,
      startAsap: form.startAsap,
      startDate: formatForApi(form.startDate),
      locations: form.locations,
      minRate: Number(form.minRate),
      maxRate: Number(form.maxRate),
      payType: toPayType(form.payType),
      isPrivateRate: form.rateIsPrivate,
      currencyCountryCode: form.country ? form.country.iso3 : null,
      clientMutationId: createClientMutationId34()
    };
    const response = await updateDetails({
      input
    });
    return response;
  }, [
    form.country,
    form.durationAmount,
    form.durationType,
    form.employerReference,
    form.expiryDate,
    form.locations,
    form.maxRate,
    form.minRate,
    form.payType,
    form.positionCount,
    form.rateIsPrivate,
    form.roleType,
    form.startAsap,
    form.startDate,
    updateDetails,
    vacancyId
  ]);
  const onSaveNext = useCallback71(async () => {
    try {
      await schema.parse(form);
      if (!hasChanged) {
        onNext();
        return;
      }
      const response = await onSave();
      if (response.result.vacancy) {
        onNext();
      }
    } catch (error) {
      setErrors(
        error.issues.reduce((acc, current) => {
          acc[current.path] = current.message;
          return acc;
        }, {})
      );
    }
  }, [form, hasChanged, onNext, onSave]);
  const onSavePrevious = useCallback71(async () => {
    try {
      await schema.parse(form);
      if (!hasChanged) {
        if (onPrevious) {
          onPrevious();
        }
        return;
      }
      const response = await onSave();
      if (response.result.vacancy) {
        if (onPrevious) {
          onPrevious();
        }
      }
    } catch (error) {
      setErrors(
        error.issues.reduce((acc, current) => {
          acc[current.path] = current.message;
          return acc;
        }, {})
      );
    }
  }, [form, hasChanged, onPrevious, onSave]);
  if (!vacancy) {
    return /* @__PURE__ */ jsx130(EdSkeleton31, {});
  }
  return /* @__PURE__ */ jsxs90(Suspense37, { fallback: /* @__PURE__ */ jsx130(EdSkeleton31, {}), children: [
    /* @__PURE__ */ jsx130("div", { className: "flex flex-col gap-2 py-2", children: /* @__PURE__ */ jsxs90("div", { className: "flex flex-col gap-2", children: [
      /* @__PURE__ */ jsx130(EditContainer3, { title: "Locations", children: /* @__PURE__ */ jsxs90(Section, { children: [
        /* @__PURE__ */ jsx130(
          GeoLocationsEditor,
          {
            locations: form.locations,
            onChanged: onLocationsChanged,
            name: "locations"
          }
        ),
        /* @__PURE__ */ jsx130(Error5, { className: "pt-1", children: errors["locations"] || "" })
      ] }) }),
      /* @__PURE__ */ jsx130(EditContainer3, { title: "Rates", children: /* @__PURE__ */ jsx130(Section, { children: /* @__PURE__ */ jsx130(
        Salary,
        {
          form,
          onMinRateChanged,
          onMaxRateChanged,
          onPayTypeChanged,
          onChangeCountry,
          onRateIsPrivateChanged,
          errors
        }
      ) }) }),
      /* @__PURE__ */ jsx130(EditContainer3, { title: "Dates & Duration", children: /* @__PURE__ */ jsxs90(Section, { children: [
        /* @__PURE__ */ jsxs90("div", { className: "flex flex-col gap-2", children: [
          /* @__PURE__ */ jsxs90("div", { className: "grid grid-cols-3 items-center gap-2 border-b border-gray-100 pb-4", children: [
            /* @__PURE__ */ jsx130("div", { className: "col-span-1 text-gray-500", children: "Employment Type" }),
            /* @__PURE__ */ jsx130("div", { className: "col-span-3", children: /* @__PURE__ */ jsx130(
              RoleTypeSelector,
              {
                value: form.roleType,
                onChanged: (value) => onRoleTypeChanged(value)
              }
            ) })
          ] }),
          form.roleType === "FixedLength" && /* @__PURE__ */ jsxs90("div", { className: "grid grid-cols-3 items-center gap-2 border-b border-gray-100 pb-4", children: [
            /* @__PURE__ */ jsx130("div", { className: "col-span-3 text-gray-500", children: "Duration" }),
            /* @__PURE__ */ jsx130("div", { className: "col-span-1", children: /* @__PURE__ */ jsx130(
              Input8,
              {
                width: "w-16",
                type: "number",
                value: form.durationAmount,
                onValueChange: onDurationAmountChanged,
                name: "durationAmount",
                required: true
              }
            ) }),
            /* @__PURE__ */ jsx130("div", { className: "col-span-3 md:col-span-2", children: /* @__PURE__ */ jsx130(
              DurationTypeSelector,
              {
                value: form.durationType,
                onChanged: onDurationTypeChanged
              }
            ) })
          ] }),
          /* @__PURE__ */ jsxs90("div", { className: "grid grid-cols-3 items-center gap-2 pb-4", children: [
            /* @__PURE__ */ jsx130("div", { className: "col-span-1 text-gray-500", children: "Starts On" }),
            /* @__PURE__ */ jsx130("div", { className: "col-span-3", children: /* @__PURE__ */ jsx130(
              PlacementStart,
              {
                startDate: form.startDate,
                startAsap: form.startAsap,
                onChanged: onPlacementChanged
              }
            ) })
          ] })
        ] }),
        /* @__PURE__ */ jsxs90("div", { className: "grid grid-cols-3 items-center gap-2 pb-4", children: [
          /* @__PURE__ */ jsx130("div", { className: "col-span-1 text-gray-500", children: "Expires at" }),
          /* @__PURE__ */ jsx130("div", { className: "col-span-3", children: /* @__PURE__ */ jsx130(
            DateInput2,
            {
              name: "expiresAt",
              minDate: (/* @__PURE__ */ new Date()).toISOString().split("T")[0],
              initialDate: formatDateHtml3(form.expiryDate),
              onChanged: onExpiryDateChanged
            }
          ) })
        ] })
      ] }) }),
      /* @__PURE__ */ jsx130(EditContainer3, { title: "Details", children: /* @__PURE__ */ jsx130(Section, { children: /* @__PURE__ */ jsxs90("div", { className: "flex flex-col gap-4", children: [
        /* @__PURE__ */ jsxs90("div", { className: "grid grid-cols-3 items-center gap-2 border-b border-gray-100 pb-4", children: [
          /* @__PURE__ */ jsx130("div", { className: "col-span-1 text-gray-500", children: "No of Positions" }),
          /* @__PURE__ */ jsx130("div", { className: "col-span-2", children: /* @__PURE__ */ jsx130(
            Input8,
            {
              type: "number",
              value: String(form.positionCount),
              onValueChange: onPositionCountChanged,
              name: "positionCount",
              required: true
            }
          ) })
        ] }),
        /* @__PURE__ */ jsxs90("div", { className: "grid grid-cols-3 items-center gap-2 border-b border-gray-100 pb-4", children: [
          /* @__PURE__ */ jsx130("div", { className: "col-span-1 text-gray-500", children: "Job Reference" }),
          /* @__PURE__ */ jsx130("div", { className: "col-span-2", children: /* @__PURE__ */ jsx130(
            Input8,
            {
              type: "text",
              value: form.employerReference || void 0,
              onValueChange: onEmployerReferenceChanged,
              name: "employerReference",
              required: true
            }
          ) })
        ] })
      ] }) }) })
    ] }) }),
    /* @__PURE__ */ jsx130("div", { className: "mt-5 flex w-full justify-end", children: /* @__PURE__ */ jsxs90("div", { children: [
      showPrevious && /* @__PURE__ */ jsx130(Button38, { onClick: onSavePrevious, size: Size19.lg, children: "Previous" }),
      /* @__PURE__ */ jsx130(Button38, { onClick: onSaveNext, size: Size19.xl, color: "primary", children: nextLabel })
    ] }) })
  ] });
};

// src/vacancies/components/__generated__/VacancyEditorScoringQuery.graphql.ts
var node167 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "vacancyId"
    }
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationType",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationAmount",
    "storageKey": null
  }, v4 = [
    v23,
    v32
  ], v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "skillGroupId",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isRequired",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "weight",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "concreteType": "SkillGroupTerm",
    "kind": "LinkedField",
    "name": "terms",
    "plural": true,
    "selections": [
      v7,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isSkill",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v10 = [
    v32,
    v23
  ], v11 = {
    "alias": null,
    "args": null,
    "concreteType": "Duration",
    "kind": "LinkedField",
    "name": "experience",
    "plural": false,
    "selections": v10,
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "concreteType": "Duration",
    "kind": "LinkedField",
    "name": "recency",
    "plural": false,
    "selections": v10,
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "VacancyEditorScoringQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "VacancyEditorScoringFragment"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "VacancyEditorScoringQuery",
      "selections": [
        {
          "alias": "vacancy",
          "args": [
            {
              "kind": "Variable",
              "name": "vacancyId",
              "variableName": "vacancyId"
            }
          ],
          "concreteType": "Vacancy",
          "kind": "LinkedField",
          "name": "recruitVacancyById",
          "plural": false,
          "selections": [
            v1,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "vacancyId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "code",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "publicDescriptionHtml",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "publicDescriptionText",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "companyVsSkillWeight",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "VacancyScoringConfig",
              "kind": "LinkedField",
              "name": "scoringConfig",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "industryNegativeThreshold",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "industryPositiveThreshold",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "relevanceNegativeThreshold",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "relevancePositiveThreshold",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Duration",
                  "kind": "LinkedField",
                  "name": "industryExperience",
                  "plural": false,
                  "selections": v4,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Duration",
                  "kind": "LinkedField",
                  "name": "industryRecency",
                  "plural": false,
                  "selections": v4,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Duration",
                  "kind": "LinkedField",
                  "name": "relevantExperience",
                  "plural": false,
                  "selections": v4,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Duration",
                  "kind": "LinkedField",
                  "name": "relevantRecency",
                  "plural": false,
                  "selections": v4,
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "KeyValuePairOfStringAndInt32",
              "kind": "LinkedField",
              "name": "filterStats",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "key",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "value",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "VacancyRate",
              "kind": "LinkedField",
              "name": "rate",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "max",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "min",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "currencyCode",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "payType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "currencyCountry",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isPrivate",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "SkillGroup",
              "kind": "LinkedField",
              "name": "skillGroups",
              "plural": true,
              "selections": [
                v1,
                v5,
                v6,
                v7,
                v8,
                v9,
                v11,
                v12
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "LocationCriteria",
              "kind": "LinkedField",
              "name": "locations",
              "plural": true,
              "selections": [
                v7,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "countryCode",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "latitude",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "longitude",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "state",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "entireCountry",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "VacancySkillAnalysis",
              "kind": "LinkedField",
              "name": "autogeneratedSkillGroups",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "status",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SkillGroup",
                  "kind": "LinkedField",
                  "name": "skillGroups",
                  "plural": true,
                  "selections": [
                    v5,
                    v6,
                    v7,
                    v8,
                    v9,
                    v11,
                    v12
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "skillsText",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "75019a1f66237889c406406f86a7392b",
      "id": null,
      "metadata": {},
      "name": "VacancyEditorScoringQuery",
      "operationKind": "query",
      "text": "query VacancyEditorScoringQuery(\n  $vacancyId: UUID!\n) {\n  ...VacancyEditorScoringFragment\n}\n\nfragment VacancyEditorScoringFragment on Query {\n  vacancy: recruitVacancyById(vacancyId: $vacancyId) {\n    id\n    vacancyId\n    code\n    publicDescriptionHtml\n    publicDescriptionText\n    companyVsSkillWeight\n    scoringConfig {\n      industryNegativeThreshold\n      industryPositiveThreshold\n      relevanceNegativeThreshold\n      relevancePositiveThreshold\n      industryExperience {\n        durationType\n        durationAmount\n      }\n      industryRecency {\n        durationType\n        durationAmount\n      }\n      relevantExperience {\n        durationType\n        durationAmount\n      }\n      relevantRecency {\n        durationType\n        durationAmount\n      }\n    }\n    filterStats {\n      key\n      value\n    }\n    rate {\n      max\n      min\n      currencyCode\n      payType\n      currencyCountry\n      isPrivate\n    }\n    skillGroups {\n      id\n      skillGroupId\n      isRequired\n      name\n      weight\n      terms {\n        name\n        isSkill\n      }\n      experience {\n        durationAmount\n        durationType\n      }\n      recency {\n        durationAmount\n        durationType\n      }\n    }\n    locations {\n      name\n      countryCode\n      latitude\n      longitude\n      state\n      entireCountry\n    }\n    autogeneratedSkillGroups {\n      status\n      skillGroups {\n        skillGroupId\n        isRequired\n        name\n        weight\n        terms {\n          name\n          isSkill\n        }\n        experience {\n          durationAmount\n          durationType\n        }\n        recency {\n          durationAmount\n          durationType\n        }\n      }\n    }\n    ...VacancySkillGroups_groups\n  }\n}\n\nfragment VacancySkillGroupChart_vacancy on Vacancy {\n  id\n  skillGroups {\n    id\n    skillGroupId\n    isRequired\n    name\n    weight\n    terms {\n      name\n      isSkill\n    }\n    experience {\n      durationAmount\n      durationType\n    }\n    recency {\n      durationAmount\n      durationType\n    }\n  }\n}\n\nfragment VacancySkillGroups_groups on Vacancy {\n  id\n  vacancyId\n  skillsText\n  skillGroups {\n    skillGroupId\n    isRequired\n    name\n    weight\n    terms {\n      name\n      isSkill\n    }\n    experience {\n      durationAmount\n      durationType\n    }\n    recency {\n      durationAmount\n      durationType\n    }\n  }\n  autogeneratedSkillGroups {\n    skillGroups {\n      skillGroupId\n      isRequired\n      name\n      weight\n      terms {\n        name\n        isSkill\n      }\n      experience {\n        durationAmount\n        durationType\n      }\n      recency {\n        durationAmount\n        durationType\n      }\n    }\n  }\n  ...VacancySkillGroupChart_vacancy\n}\n"
    }
  };
}();
node167.hash = "abef85c89fd6d638d1ad7be5f58b43cc";
var VacancyEditorScoringQuery_graphql_default = node167;

// src/vacancies/components/__generated__/VacancySkillGroupsQuery.graphql.ts
var node168 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "vacancyId"
    }
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationType",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationAmount",
    "storageKey": null
  }, v4 = [
    v23,
    v32
  ], v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "skillGroupId",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isRequired",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "weight",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "concreteType": "SkillGroupTerm",
    "kind": "LinkedField",
    "name": "terms",
    "plural": true,
    "selections": [
      v7,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isSkill",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v10 = [
    v32,
    v23
  ], v11 = {
    "alias": null,
    "args": null,
    "concreteType": "Duration",
    "kind": "LinkedField",
    "name": "experience",
    "plural": false,
    "selections": v10,
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "concreteType": "Duration",
    "kind": "LinkedField",
    "name": "recency",
    "plural": false,
    "selections": v10,
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "VacancySkillGroupsQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "VacancyEditorScoringFragment"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "VacancySkillGroupsQuery",
      "selections": [
        {
          "alias": "vacancy",
          "args": [
            {
              "kind": "Variable",
              "name": "vacancyId",
              "variableName": "vacancyId"
            }
          ],
          "concreteType": "Vacancy",
          "kind": "LinkedField",
          "name": "recruitVacancyById",
          "plural": false,
          "selections": [
            v1,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "vacancyId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "code",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "publicDescriptionHtml",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "publicDescriptionText",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "companyVsSkillWeight",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "VacancyScoringConfig",
              "kind": "LinkedField",
              "name": "scoringConfig",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "industryNegativeThreshold",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "industryPositiveThreshold",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "relevanceNegativeThreshold",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "relevancePositiveThreshold",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Duration",
                  "kind": "LinkedField",
                  "name": "industryExperience",
                  "plural": false,
                  "selections": v4,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Duration",
                  "kind": "LinkedField",
                  "name": "industryRecency",
                  "plural": false,
                  "selections": v4,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Duration",
                  "kind": "LinkedField",
                  "name": "relevantExperience",
                  "plural": false,
                  "selections": v4,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Duration",
                  "kind": "LinkedField",
                  "name": "relevantRecency",
                  "plural": false,
                  "selections": v4,
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "KeyValuePairOfStringAndInt32",
              "kind": "LinkedField",
              "name": "filterStats",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "key",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "value",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "VacancyRate",
              "kind": "LinkedField",
              "name": "rate",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "max",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "min",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "currencyCode",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "payType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "currencyCountry",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isPrivate",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "SkillGroup",
              "kind": "LinkedField",
              "name": "skillGroups",
              "plural": true,
              "selections": [
                v1,
                v5,
                v6,
                v7,
                v8,
                v9,
                v11,
                v12
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "LocationCriteria",
              "kind": "LinkedField",
              "name": "locations",
              "plural": true,
              "selections": [
                v7,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "countryCode",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "latitude",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "longitude",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "state",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "entireCountry",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "VacancySkillAnalysis",
              "kind": "LinkedField",
              "name": "autogeneratedSkillGroups",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "status",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SkillGroup",
                  "kind": "LinkedField",
                  "name": "skillGroups",
                  "plural": true,
                  "selections": [
                    v5,
                    v6,
                    v7,
                    v8,
                    v9,
                    v11,
                    v12
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "skillsText",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "696e95bd074b828f096e2d7bc1c4984a",
      "id": null,
      "metadata": {},
      "name": "VacancySkillGroupsQuery",
      "operationKind": "query",
      "text": "query VacancySkillGroupsQuery(\n  $vacancyId: UUID!\n) {\n  ...VacancyEditorScoringFragment\n}\n\nfragment VacancyEditorScoringFragment on Query {\n  vacancy: recruitVacancyById(vacancyId: $vacancyId) {\n    id\n    vacancyId\n    code\n    publicDescriptionHtml\n    publicDescriptionText\n    companyVsSkillWeight\n    scoringConfig {\n      industryNegativeThreshold\n      industryPositiveThreshold\n      relevanceNegativeThreshold\n      relevancePositiveThreshold\n      industryExperience {\n        durationType\n        durationAmount\n      }\n      industryRecency {\n        durationType\n        durationAmount\n      }\n      relevantExperience {\n        durationType\n        durationAmount\n      }\n      relevantRecency {\n        durationType\n        durationAmount\n      }\n    }\n    filterStats {\n      key\n      value\n    }\n    rate {\n      max\n      min\n      currencyCode\n      payType\n      currencyCountry\n      isPrivate\n    }\n    skillGroups {\n      id\n      skillGroupId\n      isRequired\n      name\n      weight\n      terms {\n        name\n        isSkill\n      }\n      experience {\n        durationAmount\n        durationType\n      }\n      recency {\n        durationAmount\n        durationType\n      }\n    }\n    locations {\n      name\n      countryCode\n      latitude\n      longitude\n      state\n      entireCountry\n    }\n    autogeneratedSkillGroups {\n      status\n      skillGroups {\n        skillGroupId\n        isRequired\n        name\n        weight\n        terms {\n          name\n          isSkill\n        }\n        experience {\n          durationAmount\n          durationType\n        }\n        recency {\n          durationAmount\n          durationType\n        }\n      }\n    }\n    ...VacancySkillGroups_groups\n  }\n}\n\nfragment VacancySkillGroupChart_vacancy on Vacancy {\n  id\n  skillGroups {\n    id\n    skillGroupId\n    isRequired\n    name\n    weight\n    terms {\n      name\n      isSkill\n    }\n    experience {\n      durationAmount\n      durationType\n    }\n    recency {\n      durationAmount\n      durationType\n    }\n  }\n}\n\nfragment VacancySkillGroups_groups on Vacancy {\n  id\n  vacancyId\n  skillsText\n  skillGroups {\n    skillGroupId\n    isRequired\n    name\n    weight\n    terms {\n      name\n      isSkill\n    }\n    experience {\n      durationAmount\n      durationType\n    }\n    recency {\n      durationAmount\n      durationType\n    }\n  }\n  autogeneratedSkillGroups {\n    skillGroups {\n      skillGroupId\n      isRequired\n      name\n      weight\n      terms {\n        name\n        isSkill\n      }\n      experience {\n        durationAmount\n        durationType\n      }\n      recency {\n        durationAmount\n        durationType\n      }\n    }\n  }\n  ...VacancySkillGroupChart_vacancy\n}\n"
    }
  };
}();
node168.hash = "8b4cc938eaa1c037226bd947f52d359e";
var VacancySkillGroupsQuery_graphql_default = node168;

// src/vacancies/components/__generated__/VacancyEditorScoringFragment.graphql.ts
var node169 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationType",
    "storageKey": null
  }, v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationAmount",
    "storageKey": null
  }, v32 = [
    v1,
    v23
  ], v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "skillGroupId",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isRequired",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "weight",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "concreteType": "SkillGroupTerm",
    "kind": "LinkedField",
    "name": "terms",
    "plural": true,
    "selections": [
      v6,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isSkill",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v9 = [
    v23,
    v1
  ], v10 = {
    "alias": null,
    "args": null,
    "concreteType": "Duration",
    "kind": "LinkedField",
    "name": "experience",
    "plural": false,
    "selections": v9,
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "concreteType": "Duration",
    "kind": "LinkedField",
    "name": "recency",
    "plural": false,
    "selections": v9,
    "storageKey": null
  };
  return {
    "argumentDefinitions": [
      {
        "kind": "RootArgument",
        "name": "vacancyId"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "refetch": {
        "connection": null,
        "fragmentPathInResult": [],
        "operation": VacancySkillGroupsQuery_graphql_default
      }
    },
    "name": "VacancyEditorScoringFragment",
    "selections": [
      {
        "alias": "vacancy",
        "args": [
          {
            "kind": "Variable",
            "name": "vacancyId",
            "variableName": "vacancyId"
          }
        ],
        "concreteType": "Vacancy",
        "kind": "LinkedField",
        "name": "recruitVacancyById",
        "plural": false,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vacancyId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "publicDescriptionHtml",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "publicDescriptionText",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "companyVsSkillWeight",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VacancyScoringConfig",
            "kind": "LinkedField",
            "name": "scoringConfig",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "industryNegativeThreshold",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "industryPositiveThreshold",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "relevanceNegativeThreshold",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "relevancePositiveThreshold",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Duration",
                "kind": "LinkedField",
                "name": "industryExperience",
                "plural": false,
                "selections": v32,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Duration",
                "kind": "LinkedField",
                "name": "industryRecency",
                "plural": false,
                "selections": v32,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Duration",
                "kind": "LinkedField",
                "name": "relevantExperience",
                "plural": false,
                "selections": v32,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Duration",
                "kind": "LinkedField",
                "name": "relevantRecency",
                "plural": false,
                "selections": v32,
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "KeyValuePairOfStringAndInt32",
            "kind": "LinkedField",
            "name": "filterStats",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VacancyRate",
            "kind": "LinkedField",
            "name": "rate",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "max",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "min",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currencyCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "payType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currencyCountry",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isPrivate",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SkillGroup",
            "kind": "LinkedField",
            "name": "skillGroups",
            "plural": true,
            "selections": [
              v0,
              v4,
              v5,
              v6,
              v7,
              v8,
              v10,
              v11
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LocationCriteria",
            "kind": "LinkedField",
            "name": "locations",
            "plural": true,
            "selections": [
              v6,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "countryCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "latitude",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "longitude",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "state",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "entireCountry",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VacancySkillAnalysis",
            "kind": "LinkedField",
            "name": "autogeneratedSkillGroups",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SkillGroup",
                "kind": "LinkedField",
                "name": "skillGroups",
                "plural": true,
                "selections": [
                  v4,
                  v5,
                  v6,
                  v7,
                  v8,
                  v10,
                  v11
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "VacancySkillGroups_groups"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node169.hash = "8b4cc938eaa1c037226bd947f52d359e";
var VacancyEditorScoringFragment_graphql_default = node169;

// src/vacancies/components/VacancyEditorScoring.tsx
var import_lodash3 = __toESM(require_lodash());
import { Suspense as Suspense40, useCallback as useCallback78, useEffect as useEffect20, useMemo as useMemo24, useState as useState53 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery20, useRefetchableFragment as useRefetchableFragment7 } from "react-relay";
import { useNavigate as useNavigate15 } from "react-router-dom";
import { createClientMutationId as createClientMutationId35 } from "shared-lib";
import { Button as Button41, EdLink as EdLink13, EdSkeleton as EdSkeleton34, Loading as Loading2, Size as Size21 } from "shared-ui";

// src/vacancies/components/__generated__/VacancySkillGroups_groups.graphql.ts
var node170 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v1 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "durationAmount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "durationType",
      "storageKey": null
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "concreteType": "SkillGroup",
    "kind": "LinkedField",
    "name": "skillGroups",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "skillGroupId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isRequired",
        "storageKey": null
      },
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "weight",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SkillGroupTerm",
        "kind": "LinkedField",
        "name": "terms",
        "plural": true,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isSkill",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Duration",
        "kind": "LinkedField",
        "name": "experience",
        "plural": false,
        "selections": v1,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Duration",
        "kind": "LinkedField",
        "name": "recency",
        "plural": false,
        "selections": v1,
        "storageKey": null
      }
    ],
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "VacancySkillGroups_groups",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "vacancyId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "skillsText",
        "storageKey": null
      },
      v23,
      {
        "alias": null,
        "args": null,
        "concreteType": "VacancySkillAnalysis",
        "kind": "LinkedField",
        "name": "autogeneratedSkillGroups",
        "plural": false,
        "selections": [
          v23
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "VacancySkillGroupChart_vacancy"
      }
    ],
    "type": "Vacancy",
    "abstractKey": null
  };
}();
node170.hash = "9f0cc449f8b9fa78bde4a350aba3b1b8";
var VacancySkillGroups_groups_graphql_default = node170;

// src/vacancies/components/VacancySkillGroups.tsx
import { useCallback as useCallback77, useState as useState51 } from "react";
import { useFragment as useFragment39 } from "react-relay";

// src/vacancies/components/VacancySkillGroupChart.tsx
import { Suspense as Suspense38 } from "react";
import { useFragment as useFragment38 } from "react-relay";
import { ResponsivePie } from "@nivo/pie";
import { ChartColors, EdSkeleton as EdSkeleton33 } from "shared-ui";
import { jsx as jsx131 } from "react/jsx-runtime";
var VacancySkillGroupChartComponent = (data) => {
  const chartData = data.skillGroups.map((sg) => {
    return {
      id: sg.name,
      label: sg.name,
      value: Math.round(sg.weight),
      color: "hsl(90, 70%, 50%)"
    };
  }) || [];
  return /* @__PURE__ */ jsx131(Suspense38, { fallback: /* @__PURE__ */ jsx131(EdSkeleton33, {}), children: /* @__PURE__ */ jsx131(
    ResponsivePie,
    {
      isInteractive: true,
      enableArcLabels: true,
      enableArcLinkLabels: false,
      data: chartData,
      colors: ChartColors,
      innerRadius: 0.5,
      padAngle: 0.7,
      activeOuterRadiusOffset: 8,
      borderColor: { from: "color", modifiers: [["darker", 0.2]] },
      arcLinkLabelsSkipAngle: 10,
      arcLinkLabelsThickness: 2,
      arcLabelsSkipAngle: 10
    }
  ) });
};

// src/vacancies/components/VacancySkillGroupEditor.tsx
import { useCallback as useCallback76, useState as useState50 } from "react";
import { tokenize as tokenize3, useToggle as useToggle17 } from "shared-lib";
import { Button as Button40, ButtonList as ButtonList11, CheckBox as CheckBox3, Input as Input11, Size as Size20 } from "shared-ui";

// src/skills/components/SkillSearchBox.tsx
import {
  Suspense as Suspense39,
  useCallback as useCallback73,
  useEffect as useEffect19,
  useMemo as useMemo23,
  useState as useState46
} from "react";
import { useQueryLoader as useQueryLoader5 } from "react-relay";
import { debounce as debounce8 } from "lodash-es";
import { ChevronUpDownIcon as ChevronUpDownIcon6 } from "@heroicons/react/24/solid";
import { Combobox as Combobox11 } from "@headlessui/react";

// src/skills/components/__generated__/SkillSearchOptionsQuery.graphql.ts
var node171 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "page"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "query"
  }, v23 = [
    {
      "alias": "result",
      "args": [
        {
          "kind": "Variable",
          "name": "page",
          "variableName": "page"
        },
        {
          "kind": "Variable",
          "name": "query",
          "variableName": "query"
        }
      ],
      "concreteType": "SkillAutoCompletePayload",
      "kind": "LinkedField",
      "name": "recruitSkillsAutocomplete",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "page",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SkillAutoCompleteModel",
          "kind": "LinkedField",
          "name": "skills",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "skillId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "skillName",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "SkillSearchOptionsQuery",
      "selections": v23,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "SkillSearchOptionsQuery",
      "selections": v23
    },
    "params": {
      "cacheID": "9c4fe3e19a852bcf4bd624340cb1c569",
      "id": null,
      "metadata": {},
      "name": "SkillSearchOptionsQuery",
      "operationKind": "query",
      "text": "query SkillSearchOptionsQuery(\n  $query: String!\n  $page: Int!\n) {\n  result: recruitSkillsAutocomplete(query: $query, page: $page) {\n    page\n    skills {\n      skillId\n      skillName\n    }\n  }\n}\n"
    }
  };
}();
node171.hash = "3d2839e36d61bb1195607258b1a5cf27";
var SkillSearchOptionsQuery_graphql_default = node171;

// src/skills/components/SkillSearchOptions.tsx
import { usePreloadedQuery as usePreloadedQuery12 } from "react-relay";
import { Combobox as Combobox10 } from "@headlessui/react";
import { CheckIcon as CheckIcon6 } from "@heroicons/react/24/solid";
import { classNames as classNames13 } from "shared-ui";
import { Fragment as Fragment34, jsx as jsx133, jsxs as jsxs91 } from "react/jsx-runtime";
var skillSearchOptionsQueryDef = SkillSearchOptionsQuery_graphql_default;
var SkillSearchOptions = ({ queryRef: queryRef3 }) => {
  const data = usePreloadedQuery12(
    skillSearchOptionsQueryDef,
    queryRef3
  );
  const { result } = data;
  const skills = result?.skills ?? [];
  return /* @__PURE__ */ jsx133(Combobox10.Options, { className: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm", children: skills.map((result2) => /* @__PURE__ */ jsx133(
    Combobox10.Option,
    {
      value: result2,
      className: ({ active }) => classNames13(
        "relative cursor-default select-none py-2 pl-3 pr-9",
        active ? "bg-info-600 text-white" : "text-gray-900"
      ),
      children: ({ active, selected }) => /* @__PURE__ */ jsxs91(Fragment34, { children: [
        /* @__PURE__ */ jsx133("div", { className: "flex", children: /* @__PURE__ */ jsx133(
          "span",
          {
            className: classNames13(
              "truncate",
              selected ? "font-semibold" : ""
            ),
            children: result2.skillName
          }
        ) }),
        selected && /* @__PURE__ */ jsx133(
          "span",
          {
            className: classNames13(
              "absolute inset-y-0 right-0 flex items-center pr-4",
              active ? "bg-info-600 text-white" : "text-info-600"
            ),
            children: /* @__PURE__ */ jsx133(CheckIcon6, { className: "h-5 w-5", "aria-hidden": "true" })
          }
        )
      ] })
    },
    result2.skillId
  )) });
};

// src/skills/components/SkillSearchBox.tsx
import { jsx as jsx134, jsxs as jsxs93 } from "react/jsx-runtime";
var SkillSearchBox = ({
  title,
  placeholder,
  autoClearSelected,
  onSelected,
  defaultValue
}) => {
  const [selected, setSelected] = useState46(
    defaultValue ?? null
  );
  const onQueryChangeHandler = useMemo23(
    () => debounce8((q4) => onSearch(q4), 500),
    []
  );
  const [queryRef3, loadQuery48, disposeQuery] = useQueryLoader5(skillSearchOptionsQueryDef);
  useEffect19(() => {
    return () => {
      onQueryChangeHandler.cancel();
    };
  }, [onQueryChangeHandler]);
  const onSetSelected = useCallback73(
    (r4) => {
      if (autoClearSelected) {
        setSelected(null);
      } else {
        setSelected(r4);
      }
      onSelected(r4);
    },
    [onSelected]
  );
  const onSearch = useCallback73(
    (term) => {
      if (!term || term === "") {
        return;
      }
      loadQuery48({
        page: 1,
        query: term
      });
    },
    [loadQuery48]
  );
  return /* @__PURE__ */ jsxs93(Combobox11, { as: "div", value: selected, onChange: onSetSelected, children: [
    title && /* @__PURE__ */ jsx134(Combobox11.Label, { className: "block text-sm font-medium text-gray-700", children: title }),
    /* @__PURE__ */ jsxs93("div", { className: "relative mt-2", children: [
      /* @__PURE__ */ jsx134(
        Combobox11.Input,
        {
          className: "focus:border-info-500 focus:ring-info-500 w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:outline-none focus:ring-1 sm:text-sm",
          onChange: (event) => onQueryChangeHandler(event.target.value),
          displayValue: (result) => {
            if (result) {
              return result.skillName;
            }
            return "";
          },
          autoFocus: true,
          placeholder,
          autoComplete: "off"
        }
      ),
      /* @__PURE__ */ jsx134(Combobox11.Button, { className: "absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none", children: /* @__PURE__ */ jsx134(
        ChevronUpDownIcon6,
        {
          className: "h-5 w-5 text-gray-400",
          "aria-hidden": "true"
        }
      ) }),
      /* @__PURE__ */ jsx134(Suspense39, { fallback: "Searching...", children: queryRef3 && /* @__PURE__ */ jsx134(SkillSearchOptions, { queryRef: queryRef3 }) })
    ] })
  ] });
};

// src/skills/components/SkillSearchBoxInput.tsx
import { Controller as Controller10 } from "react-hook-form";
import { useLogger as useLogger15 } from "shared-lib";
import { jsx as jsx135 } from "react/jsx-runtime";
var SkillSearchBoxInput = ({
  name,
  control
}) => {
  const [log] = useLogger15();
  return /* @__PURE__ */ jsx135(
    Controller10,
    {
      control,
      name,
      render: ({ field: { onChange: onControllerChange, value } }) => {
        log(`Skill Search: Value ${JSON.stringify(value)}`);
        return /* @__PURE__ */ jsx135(
          SkillSearchBox,
          {
            autoClearSelected: false,
            onSelected: (result) => {
              if (result) {
                onControllerChange({
                  id: result.skillId.toString(),
                  name: result.skillName
                });
              }
            },
            defaultValue: value ?? null
          }
        );
      }
    }
  );
};

// src/skills/components/ProfileSkillSearch.tsx
import { useState as useState47, useCallback as useCallback74 } from "react";
import { Button as Button39, FieldLabel, Input as Input9 } from "shared-ui";
import { jsx as jsx136, jsxs as jsxs94 } from "react/jsx-runtime";
var ProfileSkillSearch = ({
  onSelected,
  defaultValue
}) => {
  const [currentSkill, setCurrentSkill] = useState47(
    null
  );
  const [currentSkillRecency, setCurrentSkillRecency] = useState47(
    36
  );
  const [currentSkillExperience, setCurrentSkillExperience] = useState47(12);
  const [skills, setSkills] = useState47([]);
  const removeSkill = useCallback74(
    (skillId) => {
      const filteredSkillList = skills.filter((x4) => x4.skillId !== skillId);
      setSkills(filteredSkillList);
      onSelected(
        filteredSkillList.map((x4) => ({
          skillId: x4.skillId,
          monthsAgoLastUsed: x4.monthsAgoLastUsed,
          minimumMonthsExperience: x4.minimumMonthsExperience
        }))
      );
    },
    [onSelected, skills]
  );
  return /* @__PURE__ */ jsxs94("div", { className: "flex w-full gap-5 border p-5", children: [
    /* @__PURE__ */ jsxs94("div", { className: "flex flex-col gap-3", children: [
      /* @__PURE__ */ jsx136("h1", { className: "text-2xl", children: "Skills" }),
      /* @__PURE__ */ jsxs94("div", { children: [
        /* @__PURE__ */ jsx136(FieldLabel, { label: "Skills" }),
        /* @__PURE__ */ jsx136(
          SkillSearchBox,
          {
            defaultValue,
            autoClearSelected: false,
            onSelected: (skill) => {
              setCurrentSkill(skill);
            }
          }
        )
      ] }),
      /* @__PURE__ */ jsx136(
        Input9,
        {
          label: "Recency (Months)",
          type: "number",
          defaultValue: 36,
          onChange: (e4) => {
            setCurrentSkillRecency(parseInt(e4.target.value));
          }
        }
      ),
      /* @__PURE__ */ jsx136(
        Input9,
        {
          label: "Months Experience",
          type: "number",
          defaultValue: 12,
          onChange: (e4) => {
            setCurrentSkillExperience(parseInt(e4.target.value));
          }
        }
      ),
      /* @__PURE__ */ jsx136(
        Button39,
        {
          color: "primary",
          onClick: () => {
            if (currentSkill && currentSkillRecency && currentSkillExperience) {
              const skillList = [
                ...skills.filter((x4) => x4.skillId !== currentSkill.skillId),
                {
                  skillId: currentSkill.skillId,
                  skillName: currentSkill.skillName,
                  monthsAgoLastUsed: currentSkillRecency,
                  minimumMonthsExperience: currentSkillExperience
                }
              ];
              setSkills(skillList);
              onSelected(
                skillList.map((x4) => ({
                  skillId: x4.skillId,
                  monthsAgoLastUsed: x4.monthsAgoLastUsed,
                  minimumMonthsExperience: x4.minimumMonthsExperience
                }))
              );
            }
          },
          children: "Add"
        }
      )
    ] }),
    /* @__PURE__ */ jsx136("div", { className: "flex w-full", children: /* @__PURE__ */ jsxs94("div", { className: "flex max-h-[300px] w-full flex-col gap-3 overflow-scroll even:bg-gray-400", children: [
      skills.length === 0 && /* @__PURE__ */ jsx136("div", { className: "flex h-full w-full items-center justify-center", children: "No Skills Selected" }),
      skills.map((skill) => /* @__PURE__ */ jsxs94(
        "div",
        {
          className: "flex w-full items-baseline justify-between rounded bg-gray-100 px-4 py-2 hover:bg-gray-200",
          children: [
            /* @__PURE__ */ jsxs94("div", { className: "flex flex-col items-baseline gap-3", children: [
              /* @__PURE__ */ jsx136("div", { className: "font-bold", children: skill.skillName }),
              /* @__PURE__ */ jsxs94("div", { className: "text-xs", children: [
                skill.monthsAgoLastUsed,
                " months ago,",
                " ",
                skill.minimumMonthsExperience,
                " months experience"
              ] })
            ] }),
            "\xA0",
            /* @__PURE__ */ jsx136("div", { onClick: () => removeSkill(skill.skillId), children: "x" })
          ]
        },
        skill.skillId
      ))
    ] }) })
  ] });
};

// src/vacancies/components/ImportanceSelector.tsx
import { Slider } from "shared-ui";
import { jsx as jsx137 } from "react/jsx-runtime";
var ImportanceSelector = ({
  current,
  onChanged,
  max = 1,
  step = 0.1
}) => {
  return /* @__PURE__ */ jsx137(
    Slider,
    {
      defaultValue: current || 0,
      onChange: onChanged,
      minLabel: "Not Important",
      maxLabel: "Critical",
      max,
      step
    }
  );
};

// src/vacancies/components/RecencyDurationSelector.tsx
import { useCallback as useCallback75, useState as useState48 } from "react";
import { Input as Input10, RadioList as RadioList6 } from "shared-ui";
import { isString as isString4 } from "shared-lib";
import { jsx as jsx138, jsxs as jsxs95 } from "react/jsx-runtime";
var monthsOption3 = {
  id: "MONTHS",
  label: "Months"
};
var yearsOption3 = {
  id: "YEARS",
  label: "Years"
};
var options6 = [monthsOption3, yearsOption3];
var RecencyDurationSelector = ({ value, onChanged }) => {
  const [current, setCurrent] = useState48(() => {
    if (value) {
      return {
        durationAmount: value.durationAmount,
        durationType: value.durationType
      };
    }
    return {
      durationAmount: 1,
      durationType: "MONTHS"
    };
  });
  const valueChanged = useCallback75(
    (value2) => {
      const durationAmount = isString4(value2) ? parseInt(value2) : value2;
      setCurrent((currentState) => ({
        ...currentState,
        durationAmount
      }));
      onChanged({
        durationType: current.durationType,
        durationAmount
      });
    },
    [setCurrent, onChanged, current]
  );
  const typeChanged = useCallback75(
    (value2) => {
      setCurrent((currentState) => ({
        ...currentState,
        durationType: value2.id
      }));
      onChanged({
        ...current,
        durationType: value2.id
      });
    },
    [setCurrent, onChanged, current]
  );
  return /* @__PURE__ */ jsxs95("div", { className: "flex items-center gap-2", children: [
    /* @__PURE__ */ jsx138(
      Input10,
      {
        width: "w-16",
        min: 0,
        max: 31,
        id: "recency-duration-amount",
        type: "number",
        value: current.durationAmount,
        onValueChange: valueChanged
      }
    ),
    /* @__PURE__ */ jsx138(
      RadioList6,
      {
        value: current.durationType,
        list: options6,
        onChange: typeChanged
      }
    )
  ] });
};

// src/vacancies/components/DocumentViewer.tsx
import { useState as useState49 } from "react";
import { jsx as jsx139 } from "react/jsx-runtime";
var DocumentViewer = ({ terms, document: document2 }) => {
  const [sentenceData] = useState49(() => {
    return document2.sentencesWithContent(terms);
  });
  const sentences = sentenceData.map((sentence) => {
    return /* @__PURE__ */ jsx139("div", { className: "groupText p-2 leading-8", children: /* @__PURE__ */ jsx139("p", { children: sentence.content }) }, sentence.id);
  });
  return /* @__PURE__ */ jsx139("div", { className: "flex flex-col gap-2", children: sentences });
};

// src/vacancies/components/VacancySkillGroupEditor.tsx
import { jsx as jsx140, jsxs as jsxs96 } from "react/jsx-runtime";
var VacancySkillGroupEditor = ({
  skillGroup,
  skillsText,
  onClose,
  onChanged,
  onDelete
}) => {
  const onDeleteClicked = useCallback76(() => {
    onDelete(skillGroup);
  }, [onDelete]);
  const [editorState, setEditorState] = useState50(() => {
    return {
      id: skillGroup.id,
      skillGroupId: skillGroup.skillGroupId,
      name: skillGroup.name,
      isRequired: skillGroup.isRequired,
      weight: skillGroup.weight,
      experience: skillGroup.experience,
      recency: skillGroup.recency,
      terms: [...skillGroup.terms]
    };
  });
  const onStateChanged = useCallback76(
    (change) => {
      const next = {
        ...editorState,
        ...change
      };
      setEditorState(next);
      onChanged(next);
    },
    [editorState, onChanged]
  );
  const [document2] = useState50(() => {
    return tokenize3(skillsText);
  });
  const terms = editorState.terms.map((t4) => {
    return /* @__PURE__ */ jsx140(
      "div",
      {
        onClick: () => onSelectTerm(t4.name),
        className: "bg-primary-500 cursor-pointer rounded-xl px-3 py-1 text-sm lowercase text-white underline-offset-4 hover:underline",
        children: t4.name
      },
      t4.name
    );
  });
  const [isAddingSkills, toggleIsAddingSkills] = useToggle17();
  const addSkill = useCallback76(
    (result) => {
      const newTerms = [
        ...editorState.terms,
        {
          isSkill: true,
          name: result.skillName
        }
      ];
      const next = {
        ...editorState,
        terms: newTerms
      };
      setEditorState(next);
      onChanged(next);
      toggleIsAddingSkills();
    },
    [editorState, setEditorState, toggleIsAddingSkills, onChanged]
  );
  const [selectedTermName, setSelectedTermName] = useState50(null);
  const onSelectTerm = useCallback76(
    (id18) => {
      setSelectedTermName(id18);
    },
    [setSelectedTermName]
  );
  const onCloseTerm = useCallback76(() => {
    setSelectedTermName(null);
  }, [setSelectedTermName]);
  const selectedTerm = selectedTermName ? editorState.terms.find((sg) => sg.name === selectedTermName) : null;
  const onRemoveSelectedTerm = useCallback76(() => {
    const newTerms = editorState.terms.filter((t4) => t4.name !== selectedTermName);
    const next = {
      ...editorState,
      terms: newTerms
    };
    setEditorState(next);
    onChanged(next);
    setSelectedTermName(null);
  }, [
    editorState,
    setEditorState,
    onChanged,
    selectedTermName,
    setSelectedTermName
  ]);
  return /* @__PURE__ */ jsxs96("div", { className: "my-4 flex flex-1 flex-col rounded-xl border p-8 shadow", children: [
    /* @__PURE__ */ jsxs96("div", { className: "mb-3 flex items-center justify-between gap-4 border-b pb-3", children: [
      /* @__PURE__ */ jsx140("div", { className: "text-primary-500 text-lg uppercase", children: editorState.name }),
      /* @__PURE__ */ jsxs96(ButtonList11, { children: [
        /* @__PURE__ */ jsx140(Button40, { size: Size20.xl, color: "primary", clicked: onClose, children: "Close" }),
        /* @__PURE__ */ jsx140(Button40, { size: Size20.xl, color: "danger", clicked: onDeleteClicked, children: "Delete" })
      ] })
    ] }),
    /* @__PURE__ */ jsxs96("div", { className: "my-4 flex flex-col gap-3 lg:w-1/2 lg:gap-6", children: [
      /* @__PURE__ */ jsxs96("div", { className: "flex flex-wrap items-center", children: [
        /* @__PURE__ */ jsx140("div", { className: "text-primary-500 text-md w-48", children: "Name" }),
        /* @__PURE__ */ jsx140("div", { className: "flex flex-1", children: /* @__PURE__ */ jsx140(Input11, { id: "name", type: "text", value: editorState.name }) })
      ] }),
      /* @__PURE__ */ jsxs96("div", { className: "flex flex-wrap items-center", children: [
        /* @__PURE__ */ jsx140("div", { className: "text-primary-500 text-md w-48", children: "Is Required" }),
        /* @__PURE__ */ jsx140("div", { className: "flex-1", children: /* @__PURE__ */ jsx140(
          CheckBox3,
          {
            checked: editorState.isRequired,
            onChanged: (isRequired) => {
              onStateChanged({
                isRequired
              });
            }
          }
        ) })
      ] }),
      /* @__PURE__ */ jsxs96("div", { className: "flex flex-wrap items-center", children: [
        /* @__PURE__ */ jsx140("div", { className: "text-primary-500 text-md w-48", children: "Importance" }),
        /* @__PURE__ */ jsx140("div", { className: "flex flex-1", children: /* @__PURE__ */ jsx140(
          ImportanceSelector,
          {
            step: 10,
            max: 100,
            current: editorState.weight,
            onChanged: (weight) => {
              onStateChanged({
                weight
              });
            }
          }
        ) })
      ] }),
      /* @__PURE__ */ jsxs96("div", { className: "flex flex-wrap items-center", children: [
        /* @__PURE__ */ jsx140("div", { className: "text-primary-500 text-md w-48", children: "Minimum Experience" }),
        /* @__PURE__ */ jsx140("div", { className: "flex items-center gap-2", children: /* @__PURE__ */ jsx140(
          ExperienceDurationSelector,
          {
            value: editorState.experience,
            onChanged: (experience) => {
              onStateChanged({
                experience
              });
            }
          }
        ) })
      ] }),
      /* @__PURE__ */ jsxs96("div", { className: "flex flex-wrap items-center", children: [
        /* @__PURE__ */ jsx140("div", { className: "text-primary-500 text-md w-48", children: "Recency (Within)" }),
        /* @__PURE__ */ jsx140("div", { className: "flex flex-1 items-center", children: /* @__PURE__ */ jsx140(
          RecencyDurationSelector,
          {
            value: editorState.recency,
            onChanged: (recency) => {
              onStateChanged({
                recency
              });
            }
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ jsxs96("div", { className: "mt-4", children: [
      /* @__PURE__ */ jsxs96("div", { className: "mb-3 flex items-center justify-between gap-4 border-b pb-3", children: [
        /* @__PURE__ */ jsx140("div", { className: "text-primary-500 pb-3 text-lg", children: "Skills" }),
        /* @__PURE__ */ jsx140("div", { children: /* @__PURE__ */ jsx140(
          Button40,
          {
            size: Size20.lg,
            color: "primary",
            clicked: toggleIsAddingSkills,
            children: "Add Skills"
          }
        ) })
      ] }),
      /* @__PURE__ */ jsx140("div", { children: isAddingSkills ? /* @__PURE__ */ jsx140(
        SkillSearchBox,
        {
          autoClearSelected: true,
          placeholder: "Search Skills",
          onSelected: addSkill
        }
      ) : /* @__PURE__ */ jsx140("div", { className: "my-2 flex flex-col gap-2", children: /* @__PURE__ */ jsx140("div", { className: "flex flex-wrap items-center gap-2", children: terms }) }) })
    ] }),
    selectedTerm && /* @__PURE__ */ jsxs96("div", { className: "my-4 flex flex-col gap-3 rounded-xl border bg-gray-50 p-4 lg:w-1/2", children: [
      /* @__PURE__ */ jsx140("div", { className: "text-primary-500 my-3 border-b pb-3 text-xl font-medium", children: selectedTerm.name }),
      /* @__PURE__ */ jsxs96("div", { className: "flex flex-wrap items-center justify-between gap-2", children: [
        /* @__PURE__ */ jsx140(Button40, { color: "gray", clicked: onCloseTerm, children: "Close" }),
        /* @__PURE__ */ jsx140(Button40, { color: "danger", clicked: onRemoveSelectedTerm, children: "Delete" })
      ] })
    ] }),
    /* @__PURE__ */ jsxs96("div", { className: "mt-4 rounded-lg border bg-gray-50 p-4", children: [
      /* @__PURE__ */ jsx140("div", { className: "text-primary-500 my-3 border-b pb-3 text-lg", children: "Description" }),
      /* @__PURE__ */ jsx140(
        DocumentViewer,
        {
          terms: editorState.terms.map((t4) => t4.name),
          document: document2
        }
      )
    ] })
  ] });
};

// src/vacancies/components/VacancySkillGroupsTable.tsx
import { Tag as Tag9 } from "shared-ui";
import { jsx as jsx141, jsxs as jsxs97 } from "react/jsx-runtime";
var VacancySkillGroupsTable = ({
  skillGroups,
  onSelect
}) => {
  const rows = skillGroups.map((sg) => {
    return /* @__PURE__ */ jsx141(
      "div",
      {
        className: "flex cursor-pointer flex-col border-b px-3 py-2 hover:bg-gray-50",
        onClick: () => onSelect(sg.id),
        children: /* @__PURE__ */ jsxs97("div", { className: "flex items-center justify-between gap-4", children: [
          /* @__PURE__ */ jsx141("div", { className: "text-primary-500 text-lg uppercase underline underline-offset-4", children: sg.name }),
          /* @__PURE__ */ jsxs97("div", { className: "flex items-center gap-2 text-sm text-gray-700", children: [
            sg.isRequired && /* @__PURE__ */ jsx141(Tag9, { children: "required" }),
            /* @__PURE__ */ jsx141("div", { children: Math.round(sg.weight) })
          ] })
        ] })
      },
      sg.id
    );
  });
  return /* @__PURE__ */ jsx141("div", { className: "flex w-full flex-col py-4", children: rows });
};

// src/vacancies/components/VacancySkillGroups.tsx
import { jsx as jsx143, jsxs as jsxs98 } from "react/jsx-runtime";
var fragmentDef32 = VacancySkillGroups_groups_graphql_default;
function mapSkillGroup(sg) {
  return {
    id: sg.skillGroupId,
    skillGroupId: sg.skillGroupId,
    name: sg.name,
    isRequired: sg.isRequired,
    weight: sg.weight,
    experience: toDuration(sg.experience),
    recency: toDuration(sg.recency),
    terms: sg.terms
  };
}
var VacancySkillGroups = ({
  fragmentRef,
  onChanged,
  showChart = true
}) => {
  const data = useFragment39(
    fragmentDef32,
    fragmentRef
  );
  const [skillGroups, setSkillGroups] = useState51(() => {
    let skillGroups2 = [];
    if (data.skillGroups && data.skillGroups.length > 0) {
      skillGroups2 = data.skillGroups.map(mapSkillGroup);
    } else if (data.autogeneratedSkillGroups && data.autogeneratedSkillGroups.skillGroups) {
      skillGroups2 = data.autogeneratedSkillGroups.skillGroups.map(mapSkillGroup);
    }
    return skillGroups2.sort((a4, b3) => b3.weight - a4.weight);
  });
  const [selectedId, setSelectedId] = useState51(null);
  const selectedGroup = selectedId ? skillGroups.find((sg) => sg.id === selectedId) : null;
  const onSelect = useCallback77(
    (id18) => {
      setSelectedId(id18);
    },
    [setSelectedId]
  );
  const onClose = useCallback77(() => {
    setSelectedId(null);
  }, [setSelectedId]);
  const onSkillGroupDeleted = useCallback77(
    (skillGroup) => {
      const filteredGroups = skillGroups.filter((sg) => sg.id !== skillGroup.id);
      setSkillGroups(filteredGroups);
      onChanged(filteredGroups);
    },
    [skillGroups, setSkillGroups, onChanged]
  );
  const onSkillGroupChanged = useCallback77(
    (skillGroup) => {
      const filteredGroups = skillGroups.filter((sg) => sg.id !== skillGroup.id);
      const newSkillGroups = [skillGroup, ...filteredGroups].sort(
        (a4, b3) => b3.weight - a4.weight
      );
      setSkillGroups(newSkillGroups);
      onChanged(newSkillGroups);
    },
    [skillGroups, setSkillGroups, onChanged]
  );
  return /* @__PURE__ */ jsx143("div", { className: "", children: selectedGroup ? /* @__PURE__ */ jsx143(
    VacancySkillGroupEditor,
    {
      skillsText: data.skillsText,
      skillGroup: selectedGroup,
      onClose,
      onChanged: onSkillGroupChanged,
      onDelete: onSkillGroupDeleted
    }
  ) : /* @__PURE__ */ jsxs98("div", { className: "flex flex-col gap-5 lg:flex-row", children: [
    /* @__PURE__ */ jsx143("div", { className: "flex w-full grow lg:w-1/3", children: /* @__PURE__ */ jsx143(
      VacancySkillGroupsTable,
      {
        skillGroups,
        onSelect
      }
    ) }),
    showChart && /* @__PURE__ */ jsx143("div", { className: "flex w-full grow items-center justify-center lg:w-2/3", children: /* @__PURE__ */ jsx143("div", { className: "w-full", style: { height: 500 }, children: /* @__PURE__ */ jsx143(VacancySkillGroupChartComponent, { skillGroups }) }) })
  ] }) });
};

// src/vacancies/components/VacancyEditorScoring.tsx
import { jsx as jsx144, jsxs as jsxs99 } from "react/jsx-runtime";
var queryDef19 = VacancyEditorScoringQuery_graphql_default;
var fragmentDef33 = VacancyEditorScoringFragment_graphql_default;
var VacancyEditorWizardScoring = ({
  editRouteId
}) => {
  const data = useVacancyEditRouteData(editRouteId);
  const { vacancy } = data;
  if (!vacancy) {
    return /* @__PURE__ */ jsx144(EdSkeleton34, {});
  }
  return /* @__PURE__ */ jsx144(VacancyEditorWizardScoringComponent, { vacancyId: vacancy.vacancyId });
};
var VacancyEditorWizardScoringComponent = ({
  vacancyId
}) => {
  const navigate = useNavigate15();
  const query3 = useLazyLoadQuery20(queryDef19, {
    vacancyId
  });
  if (!query3) {
    return /* @__PURE__ */ jsx144(EdSkeleton34, {});
  }
  return /* @__PURE__ */ jsx144(Suspense40, { fallback: "Loading...", children: /* @__PURE__ */ jsxs99("div", { className: "flex w-full flex-col items-center gap-10 px-2 md:px-5", children: [
    /* @__PURE__ */ jsx144("div", { className: "w-9/12", children: /* @__PURE__ */ jsx144(VacancyEditorProgressBar, { step: "scoring" }) }),
    /* @__PURE__ */ jsx144(
      VacancyEditorScoringComponent,
      {
        queryRef: query3,
        vacancyId,
        onNext: () => navigate("../overview"),
        onPrevious: () => navigate("../details"),
        onEditDescription: import_lodash3.noop,
        nextLabel: "Save & Next"
      }
    )
  ] }) });
};
var VacancyEditorOverviewScoring = ({
  editRouteId
}) => {
  const data = useVacancyEditRouteData(editRouteId);
  const navigate = useNavigate15();
  const onSaved = useCallback78(() => {
    navigate("../overview");
  }, [navigate]);
  const onEditDescription = useCallback78(() => {
    navigate("../description");
  }, [navigate]);
  const query3 = useLazyLoadQuery20(queryDef19, {
    vacancyId: data.vacancy.vacancyId
  });
  if (!query3) {
    return /* @__PURE__ */ jsx144("div", {});
  }
  return /* @__PURE__ */ jsx144(Suspense40, { fallback: "Loading...", children: /* @__PURE__ */ jsx144(
    VacancyEditorScoringComponent,
    {
      queryRef: query3,
      vacancyId: data.vacancy.vacancyId,
      onNext: onSaved,
      showPrevious: true,
      onPrevious: () => navigate("../details"),
      onEditDescription,
      nextLabel: "Save"
    }
  ) });
};
function mapSkillGroup2(sg) {
  return {
    id: sg.skillGroupId,
    skillGroupId: sg.skillGroupId,
    name: sg.name,
    isRequired: sg.isRequired,
    weight: sg.weight,
    experience: toDuration(sg.experience),
    recency: toDuration(sg.recency),
    terms: sg.terms
  };
}
var VacancyEditorScoringComponent = ({
  queryRef: queryRef3,
  vacancyId,
  onNext,
  onPrevious,
  onEditDescription,
  nextLabel,
  showPrevious = true
}) => {
  const [hasChanged, setHasChanged] = useState53(false);
  const [update] = useVacancyUpdateScoring();
  const [data, refetch] = useRefetchableFragment7(fragmentDef33, queryRef3);
  const { vacancy } = data;
  const generationStatus = vacancy?.autogeneratedSkillGroups.status;
  useEffect20(() => {
    const interval = setInterval(() => {
      if ((generationStatus === "SUCCESSFUL" || generationStatus === "FAILED" || generationStatus === "NO_SKILLS_FOUND") && vacancy && vacancy.filterStats.length > 0) {
        clearInterval(interval);
      } else {
        refetch({ vacancyId }, { fetchPolicy: "network-only" });
      }
    }, 2e3);
    return () => clearInterval(interval);
  }, [generationStatus, refetch, vacancyId, vacancy]);
  if (!vacancy) {
    throw Error("Vacancy Not Found");
  }
  const skillGroups = useMemo24(() => {
    if (vacancy.skillGroups && vacancy.skillGroups.length > 0) {
      return vacancy.skillGroups.reduce((acc, group) => {
        const exists = acc.find((g3) => g3.name === group.name);
        if (!exists) {
          acc.push(mapSkillGroup2(group));
        }
        return acc;
      }, []);
    } else if (vacancy.autogeneratedSkillGroups && vacancy.autogeneratedSkillGroups.skillGroups) {
      return vacancy.autogeneratedSkillGroups.skillGroups.map(mapSkillGroup2);
    }
    return [];
  }, [vacancy.skillGroups]);
  const [form, setForm] = useState53(() => {
    return {
      skillGroups: deserializeSkillGroups(skillGroups),
      relevantExperience: vacancy.scoringConfig.relevantExperience,
      relevantRecency: vacancy.scoringConfig.relevantRecency,
      industryExperience: vacancy.scoringConfig.industryExperience,
      industryRecency: vacancy.scoringConfig.industryRecency,
      companyVsSkillWeight: parseFloat(vacancy.companyVsSkillWeight.toFixed(2))
    };
  });
  const onSkillGroupsChanged = useCallback78(
    (skillGroups2) => {
      setForm((current) => ({
        ...current,
        skillGroups: skillGroups2
      }));
      setHasChanged(true);
    },
    [setForm, setHasChanged]
  );
  const onSave = useCallback78(async () => {
    const input = {
      vacancyId,
      skillGroups: serializeSkillGroups(form.skillGroups),
      clientMutationId: createClientMutationId35(),
      companyVsSkillWeight: form.companyVsSkillWeight,
      industryExperience: form.industryExperience,
      industryRecency: form.industryRecency,
      relevantExperience: form.relevantExperience,
      relevantRecency: form.relevantRecency
    };
    console.log(`VacancyEditorScoring onSave`);
    console.log(input);
    const response = await update({
      input
    });
    return response;
  }, [form, update, vacancyId]);
  const onSaveNext = useCallback78(async () => {
    const response = await onSave();
    if (response.result.vacancy) {
      onNext();
    }
  }, [onNext, onSave]);
  const onSavePrevious = useCallback78(async () => {
    if (!hasChanged) {
      if (onPrevious) {
        onPrevious();
      }
      return;
    }
    const response = await onSave();
    if (response.result.vacancy) {
      if (onPrevious) {
        onPrevious();
      }
    }
  }, [hasChanged, onPrevious, onSave]);
  const labels = {
    sources: "Candidates Matching Sources",
    sources_and_locations_and_is_available_and_approved: "Filtered By Locations & Availability",
    sources_and_locations_and_is_available_and_approved_and_rate: "Filtered By Rate",
    sources_and_locations_and_is_available_and_approved_and_rate_and_employment: "Filtered By Employment Type"
  };
  const funnelData = vacancy.filterStats.map(({ key, value }) => ({
    id: key,
    value,
    label: labels[key] || key
  }));
  const bottomOfFunnel = funnelData[funnelData.length - 1];
  if (!vacancy) {
    return /* @__PURE__ */ jsx144(EdSkeleton34, {});
  }
  return /* @__PURE__ */ jsx144(Suspense40, { fallback: /* @__PURE__ */ jsx144(EdSkeleton34, {}), children: /* @__PURE__ */ jsxs99("div", { className: "flex flex-col gap-2", children: [
    funnelData.length > 0 && vacancy.autogeneratedSkillGroups.status === "NO_SKILLS_FOUND" && /* @__PURE__ */ jsx144(EditContainer3, { title: "No Skills Found", children: /* @__PURE__ */ jsxs99("div", { className: "flex flex-col gap-5", children: [
      /* @__PURE__ */ jsx144("p", { children: "Based on the provided job description, we couldn't identify any relevant skills. Edit the vacancy description or contact our Support team." }),
      /* @__PURE__ */ jsx144(EdLink13, { name: "edit-description", href: "../description", children: /* @__PURE__ */ jsx144(
        Button41,
        {
          size: Size21.xl,
          color: "gray",
          onClick: onEditDescription,
          children: "Edit Description"
        }
      ) })
    ] }) }),
    (funnelData.length === 0 || vacancy.autogeneratedSkillGroups.status === "IN_PROGRESS") && /* @__PURE__ */ jsx144(EditContainer3, { children: /* @__PURE__ */ jsx144(Loading2, { label: "Calculating Skill Groups" }) }),
    funnelData.length > 0 && vacancy.autogeneratedSkillGroups.status === "SUCCESSFUL" && /* @__PURE__ */ jsx144("div", { className: "lg:py-8", children: /* @__PURE__ */ jsxs99(EditContainer3, { title: "Skills Analysis", children: [
      /* @__PURE__ */ jsx144("div", { className: "py-4 text-gray-500", children: /* @__PURE__ */ jsx144("p", { children: "The system has analysed the job description to pinpoint the important skills needed, it has then organized these requirements into skill groups, grouping together similar skills. More priority is given to the skill groups that carry the most weight when searching for suitable candidates." }) }),
      /* @__PURE__ */ jsx144(
        VacancySkillGroups,
        {
          fragmentRef: vacancy,
          onChanged: onSkillGroupsChanged
        },
        vacancy.vacancyId
      )
    ] }) }),
    /* @__PURE__ */ jsx144("div", { className: "mt-5 flex w-full justify-end", children: /* @__PURE__ */ jsxs99("div", { children: [
      showPrevious && /* @__PURE__ */ jsx144(Button41, { onClick: onSavePrevious, size: Size21.lg, children: "Previous" }),
      /* @__PURE__ */ jsx144(Button41, { onClick: onSaveNext, size: Size21.xl, color: "primary", children: nextLabel })
    ] }) })
  ] }) });
};

// src/vacancies/components/__generated__/VacancyEditorReview_vacancy.graphql.ts
var node173 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isRequired",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationAmount",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationType",
    "storageKey": null
  }, v5 = [
    v32,
    v4
  ], v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "sourceId",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "sourceType",
    "storageKey": null
  }, v8 = [
    v4,
    v32
  ];
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "VacancyEditorReview_vacancy",
    "selections": [
      v0,
      v1,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "vacancyId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "publicDescriptionHtml",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "publicDescriptionText",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "publicDescriptionEditorState",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "industryName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "industryId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "profession",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "companyVsSkillWeight",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "VacancyFormGroupReference",
        "kind": "LinkedField",
        "name": "formGroupReferences",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "templateName",
            "storageKey": null
          },
          v23
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "VacancyDocumentTypeReference",
        "kind": "LinkedField",
        "name": "documentTypeReferences",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "documentTypeName",
            "storageKey": null
          },
          v23
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SkillGroup",
        "kind": "LinkedField",
        "name": "skillGroups",
        "plural": true,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "skillGroupId",
            "storageKey": null
          },
          v23,
          v1,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "weight",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SkillGroupTerm",
            "kind": "LinkedField",
            "name": "terms",
            "plural": true,
            "selections": [
              v1,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isSkill",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Duration",
            "kind": "LinkedField",
            "name": "experience",
            "plural": false,
            "selections": v5,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Duration",
            "kind": "LinkedField",
            "name": "recency",
            "plural": false,
            "selections": v5,
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "EmployerProfileSource",
        "kind": "LinkedField",
        "name": "profileSources",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProfileSource",
            "kind": "LinkedField",
            "name": "source",
            "plural": false,
            "selections": [
              v6,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sourceName",
                "storageKey": null
              },
              v7
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "VacancyProfileSource",
        "kind": "LinkedField",
        "name": "vacancyProfileSources",
        "plural": true,
        "selections": [
          v6,
          v7
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "VacancyScoringConfig",
        "kind": "LinkedField",
        "name": "scoringConfig",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "industryNegativeThreshold",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "industryPositiveThreshold",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "relevanceNegativeThreshold",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "relevancePositiveThreshold",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Duration",
            "kind": "LinkedField",
            "name": "industryExperience",
            "plural": false,
            "selections": v8,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Duration",
            "kind": "LinkedField",
            "name": "industryRecency",
            "plural": false,
            "selections": v8,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Duration",
            "kind": "LinkedField",
            "name": "relevantExperience",
            "plural": false,
            "selections": v8,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Duration",
            "kind": "LinkedField",
            "name": "relevantRecency",
            "plural": false,
            "selections": v8,
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "KeyValuePairOfStringAndInt32",
        "kind": "LinkedField",
        "name": "filterStats",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "key",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "VacancyRate",
        "kind": "LinkedField",
        "name": "rate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currencyCode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currencyCountryCode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currencyCountryName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isPrivate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "max",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "min",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "payType",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "VacancyDates",
        "kind": "LinkedField",
        "name": "dates",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startAsap",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "durationCode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "durationDescription",
            "storageKey": null
          },
          v32,
          v4
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "expiresAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "employerReference",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "headcount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "LocationCriteria",
        "kind": "LinkedField",
        "name": "locations",
        "plural": true,
        "selections": [
          v1,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "countryCode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "latitude",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "longitude",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "entireCountry",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Vacancy",
    "abstractKey": null
  };
}();
node173.hash = "6cd8d4c88f0bf3e72cb9027c3fea02b6";
var VacancyEditorReview_vacancy_graphql_default = node173;

// src/vacancies/components/__generated__/VacancyEditorReviewMutation.graphql.ts
var node174 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "description"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "details"
  }, v23 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "profileSources"
  }, v32 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "publish"
  }, v4 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "scoring"
  }, v5 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "description"
    }
  ], v6 = [
    {
      "alias": null,
      "args": null,
      "concreteType": "EdgeOfVacancy",
      "kind": "LinkedField",
      "name": "vacancy",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Vacancy",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "VacancyEditorReview_vacancy"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ], v7 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "details"
    }
  ], v8 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "scoring"
    }
  ], v9 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "profileSources"
    }
  ], v10 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "publish"
    }
  ], v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isRequired",
    "storageKey": null
  }, v14 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationAmount",
    "storageKey": null
  }, v15 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationType",
    "storageKey": null
  }, v16 = [
    v14,
    v15
  ], v17 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "sourceId",
    "storageKey": null
  }, v18 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "sourceType",
    "storageKey": null
  }, v19 = [
    v15,
    v14
  ], v20 = [
    {
      "alias": null,
      "args": null,
      "concreteType": "EdgeOfVacancy",
      "kind": "LinkedField",
      "name": "vacancy",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Vacancy",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            v11,
            v12,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "vacancyId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "code",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "publicDescriptionHtml",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "publicDescriptionText",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "publicDescriptionEditorState",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "industryName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "industryId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "profession",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "companyVsSkillWeight",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "VacancyFormGroupReference",
              "kind": "LinkedField",
              "name": "formGroupReferences",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "templateName",
                  "storageKey": null
                },
                v13
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "VacancyDocumentTypeReference",
              "kind": "LinkedField",
              "name": "documentTypeReferences",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "documentTypeName",
                  "storageKey": null
                },
                v13
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "SkillGroup",
              "kind": "LinkedField",
              "name": "skillGroups",
              "plural": true,
              "selections": [
                v11,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "skillGroupId",
                  "storageKey": null
                },
                v13,
                v12,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "weight",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SkillGroupTerm",
                  "kind": "LinkedField",
                  "name": "terms",
                  "plural": true,
                  "selections": [
                    v12,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isSkill",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Duration",
                  "kind": "LinkedField",
                  "name": "experience",
                  "plural": false,
                  "selections": v16,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Duration",
                  "kind": "LinkedField",
                  "name": "recency",
                  "plural": false,
                  "selections": v16,
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "EmployerProfileSource",
              "kind": "LinkedField",
              "name": "profileSources",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProfileSource",
                  "kind": "LinkedField",
                  "name": "source",
                  "plural": false,
                  "selections": [
                    v17,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sourceName",
                      "storageKey": null
                    },
                    v18
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "VacancyProfileSource",
              "kind": "LinkedField",
              "name": "vacancyProfileSources",
              "plural": true,
              "selections": [
                v17,
                v18,
                v11
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "VacancyScoringConfig",
              "kind": "LinkedField",
              "name": "scoringConfig",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "industryNegativeThreshold",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "industryPositiveThreshold",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "relevanceNegativeThreshold",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "relevancePositiveThreshold",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Duration",
                  "kind": "LinkedField",
                  "name": "industryExperience",
                  "plural": false,
                  "selections": v19,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Duration",
                  "kind": "LinkedField",
                  "name": "industryRecency",
                  "plural": false,
                  "selections": v19,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Duration",
                  "kind": "LinkedField",
                  "name": "relevantExperience",
                  "plural": false,
                  "selections": v19,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Duration",
                  "kind": "LinkedField",
                  "name": "relevantRecency",
                  "plural": false,
                  "selections": v19,
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "KeyValuePairOfStringAndInt32",
              "kind": "LinkedField",
              "name": "filterStats",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "key",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "value",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "VacancyRate",
              "kind": "LinkedField",
              "name": "rate",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "currencyCode",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "currencyCountryCode",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "currencyCountryName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isPrivate",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "max",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "min",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "payType",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "VacancyDates",
              "kind": "LinkedField",
              "name": "dates",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startDate",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startAsap",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "durationCode",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "durationDescription",
                  "storageKey": null
                },
                v14,
                v15
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "expiresAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "employerReference",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "headcount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "LocationCriteria",
              "kind": "LinkedField",
              "name": "locations",
              "plural": true,
              "selections": [
                v12,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "countryCode",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "latitude",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "longitude",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "state",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "entireCountry",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1,
        v23,
        v32,
        v4
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "VacancyEditorReviewMutation",
      "selections": [
        {
          "alias": null,
          "args": v5,
          "concreteType": "RecruitVacancyDescriptionUpdatePayload",
          "kind": "LinkedField",
          "name": "recruitVacancyDescriptionUpdate",
          "plural": false,
          "selections": v6,
          "storageKey": null
        },
        {
          "alias": null,
          "args": v7,
          "concreteType": "RecruitVacancyDetailsUpdatePayload",
          "kind": "LinkedField",
          "name": "recruitVacancyDetailsUpdate",
          "plural": false,
          "selections": v6,
          "storageKey": null
        },
        {
          "alias": null,
          "args": v8,
          "concreteType": "RecruitVacancyScoringUpdatePayload",
          "kind": "LinkedField",
          "name": "recruitVacancyScoringUpdate",
          "plural": false,
          "selections": v6,
          "storageKey": null
        },
        {
          "alias": null,
          "args": v9,
          "concreteType": "RecruitVacancyUpdateProfileSourcesPayload",
          "kind": "LinkedField",
          "name": "recruitVacancyUpdateProfileSources",
          "plural": false,
          "selections": v6,
          "storageKey": null
        },
        {
          "alias": null,
          "args": v10,
          "concreteType": "RecruitVacancyPublishPayload",
          "kind": "LinkedField",
          "name": "recruitVacancyPublish",
          "plural": false,
          "selections": v6,
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v0,
        v1,
        v23,
        v4,
        v32
      ],
      "kind": "Operation",
      "name": "VacancyEditorReviewMutation",
      "selections": [
        {
          "alias": null,
          "args": v5,
          "concreteType": "RecruitVacancyDescriptionUpdatePayload",
          "kind": "LinkedField",
          "name": "recruitVacancyDescriptionUpdate",
          "plural": false,
          "selections": v20,
          "storageKey": null
        },
        {
          "alias": null,
          "args": v7,
          "concreteType": "RecruitVacancyDetailsUpdatePayload",
          "kind": "LinkedField",
          "name": "recruitVacancyDetailsUpdate",
          "plural": false,
          "selections": v20,
          "storageKey": null
        },
        {
          "alias": null,
          "args": v8,
          "concreteType": "RecruitVacancyScoringUpdatePayload",
          "kind": "LinkedField",
          "name": "recruitVacancyScoringUpdate",
          "plural": false,
          "selections": v20,
          "storageKey": null
        },
        {
          "alias": null,
          "args": v9,
          "concreteType": "RecruitVacancyUpdateProfileSourcesPayload",
          "kind": "LinkedField",
          "name": "recruitVacancyUpdateProfileSources",
          "plural": false,
          "selections": v20,
          "storageKey": null
        },
        {
          "alias": null,
          "args": v10,
          "concreteType": "RecruitVacancyPublishPayload",
          "kind": "LinkedField",
          "name": "recruitVacancyPublish",
          "plural": false,
          "selections": v20,
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "6939e4155f57fee4a1c48fd868681209",
      "id": null,
      "metadata": {},
      "name": "VacancyEditorReviewMutation",
      "operationKind": "mutation",
      "text": "mutation VacancyEditorReviewMutation(\n  $description: RecruitVacancyDescriptionUpdateInput!\n  $details: RecruitVacancyDetailsUpdateInput!\n  $profileSources: RecruitVacancyUpdateProfileSourcesInput!\n  $scoring: RecruitVacancyScoringUpdateInput!\n  $publish: RecruitVacancyPublishInput!\n) {\n  recruitVacancyDescriptionUpdate(input: $description) {\n    vacancy {\n      node {\n        ...VacancyEditorReview_vacancy\n        id\n      }\n    }\n  }\n  recruitVacancyDetailsUpdate(input: $details) {\n    vacancy {\n      node {\n        ...VacancyEditorReview_vacancy\n        id\n      }\n    }\n  }\n  recruitVacancyScoringUpdate(input: $scoring) {\n    vacancy {\n      node {\n        ...VacancyEditorReview_vacancy\n        id\n      }\n    }\n  }\n  recruitVacancyUpdateProfileSources(input: $profileSources) {\n    vacancy {\n      node {\n        ...VacancyEditorReview_vacancy\n        id\n      }\n    }\n  }\n  recruitVacancyPublish(input: $publish) {\n    vacancy {\n      node {\n        ...VacancyEditorReview_vacancy\n        id\n      }\n    }\n  }\n}\n\nfragment VacancyEditorReview_vacancy on Vacancy {\n  id\n  name\n  vacancyId\n  code\n  publicDescriptionHtml\n  publicDescriptionText\n  publicDescriptionEditorState\n  industryName\n  industryId\n  profession\n  companyVsSkillWeight\n  formGroupReferences {\n    templateName\n    isRequired\n  }\n  documentTypeReferences {\n    documentTypeName\n    isRequired\n  }\n  skillGroups {\n    id\n    skillGroupId\n    isRequired\n    name\n    weight\n    terms {\n      name\n      isSkill\n    }\n    experience {\n      durationAmount\n      durationType\n    }\n    recency {\n      durationAmount\n      durationType\n    }\n  }\n  profileSources {\n    source {\n      sourceId\n      sourceName\n      sourceType\n    }\n  }\n  vacancyProfileSources {\n    sourceId\n    sourceType\n    id\n  }\n  scoringConfig {\n    industryNegativeThreshold\n    industryPositiveThreshold\n    relevanceNegativeThreshold\n    relevancePositiveThreshold\n    industryExperience {\n      durationType\n      durationAmount\n    }\n    industryRecency {\n      durationType\n      durationAmount\n    }\n    relevantExperience {\n      durationType\n      durationAmount\n    }\n    relevantRecency {\n      durationType\n      durationAmount\n    }\n  }\n  filterStats {\n    key\n    value\n  }\n  rate {\n    currencyCode\n    currencyCountryCode\n    currencyCountryName\n    isPrivate\n    max\n    min\n    payType\n  }\n  dates {\n    startDate\n    startAsap\n    durationCode\n    durationDescription\n    durationAmount\n    durationType\n  }\n  expiresAt\n  employerReference\n  headcount\n  locations {\n    name\n    countryCode\n    latitude\n    longitude\n    state\n    entireCountry\n  }\n}\n"
    }
  };
}();
node174.hash = "4112467ac686d452fc2f5d0e283b7fbb";
var VacancyEditorReviewMutation_graphql_default = node174;

// src/vacancies/components/__generated__/VacancyEditorReviewQuery.graphql.ts
var node175 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "employerId"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "vacancyId"
  }, v23 = [
    {
      "kind": "Variable",
      "name": "vacancyId",
      "variableName": "vacancyId"
    }
  ], v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v5 = {
    "alias": "employerTalentPools",
    "args": [
      {
        "kind": "Variable",
        "name": "employerId",
        "variableName": "employerId"
      }
    ],
    "concreteType": "RecruitTalentPool",
    "kind": "LinkedField",
    "name": "recruitTalentPoolsForEmployer",
    "plural": true,
    "selections": [
      v32,
      v4,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "talentPoolId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isRequired",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "skillGroupId",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "weight",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "concreteType": "SkillGroupTerm",
    "kind": "LinkedField",
    "name": "terms",
    "plural": true,
    "selections": [
      v4,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isSkill",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationAmount",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationType",
    "storageKey": null
  }, v12 = [
    v10,
    v11
  ], v13 = {
    "alias": null,
    "args": null,
    "concreteType": "Duration",
    "kind": "LinkedField",
    "name": "experience",
    "plural": false,
    "selections": v12,
    "storageKey": null
  }, v14 = {
    "alias": null,
    "args": null,
    "concreteType": "Duration",
    "kind": "LinkedField",
    "name": "recency",
    "plural": false,
    "selections": v12,
    "storageKey": null
  }, v15 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "sourceId",
    "storageKey": null
  }, v16 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "sourceType",
    "storageKey": null
  }, v17 = [
    v11,
    v10
  ];
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "VacancyEditorReviewQuery",
      "selections": [
        {
          "alias": "vacancy",
          "args": v23,
          "concreteType": "Vacancy",
          "kind": "LinkedField",
          "name": "recruitVacancyById",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "VacancyEditorReview_vacancy"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "VacancySkillGroups_groups"
            }
          ],
          "storageKey": null
        },
        v5
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "VacancyEditorReviewQuery",
      "selections": [
        {
          "alias": "vacancy",
          "args": v23,
          "concreteType": "Vacancy",
          "kind": "LinkedField",
          "name": "recruitVacancyById",
          "plural": false,
          "selections": [
            v32,
            v4,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "vacancyId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "code",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "publicDescriptionHtml",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "publicDescriptionText",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "publicDescriptionEditorState",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "industryName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "industryId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "profession",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "companyVsSkillWeight",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "VacancyFormGroupReference",
              "kind": "LinkedField",
              "name": "formGroupReferences",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "templateName",
                  "storageKey": null
                },
                v6
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "VacancyDocumentTypeReference",
              "kind": "LinkedField",
              "name": "documentTypeReferences",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "documentTypeName",
                  "storageKey": null
                },
                v6
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "SkillGroup",
              "kind": "LinkedField",
              "name": "skillGroups",
              "plural": true,
              "selections": [
                v32,
                v7,
                v6,
                v4,
                v8,
                v9,
                v13,
                v14
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "EmployerProfileSource",
              "kind": "LinkedField",
              "name": "profileSources",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProfileSource",
                  "kind": "LinkedField",
                  "name": "source",
                  "plural": false,
                  "selections": [
                    v15,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sourceName",
                      "storageKey": null
                    },
                    v16
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "VacancyProfileSource",
              "kind": "LinkedField",
              "name": "vacancyProfileSources",
              "plural": true,
              "selections": [
                v15,
                v16,
                v32
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "VacancyScoringConfig",
              "kind": "LinkedField",
              "name": "scoringConfig",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "industryNegativeThreshold",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "industryPositiveThreshold",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "relevanceNegativeThreshold",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "relevancePositiveThreshold",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Duration",
                  "kind": "LinkedField",
                  "name": "industryExperience",
                  "plural": false,
                  "selections": v17,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Duration",
                  "kind": "LinkedField",
                  "name": "industryRecency",
                  "plural": false,
                  "selections": v17,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Duration",
                  "kind": "LinkedField",
                  "name": "relevantExperience",
                  "plural": false,
                  "selections": v17,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Duration",
                  "kind": "LinkedField",
                  "name": "relevantRecency",
                  "plural": false,
                  "selections": v17,
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "KeyValuePairOfStringAndInt32",
              "kind": "LinkedField",
              "name": "filterStats",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "key",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "value",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "VacancyRate",
              "kind": "LinkedField",
              "name": "rate",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "currencyCode",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "currencyCountryCode",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "currencyCountryName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isPrivate",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "max",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "min",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "payType",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "VacancyDates",
              "kind": "LinkedField",
              "name": "dates",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startDate",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startAsap",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "durationCode",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "durationDescription",
                  "storageKey": null
                },
                v10,
                v11
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "expiresAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "employerReference",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "headcount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "LocationCriteria",
              "kind": "LinkedField",
              "name": "locations",
              "plural": true,
              "selections": [
                v4,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "countryCode",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "latitude",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "longitude",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "state",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "entireCountry",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "skillsText",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "VacancySkillAnalysis",
              "kind": "LinkedField",
              "name": "autogeneratedSkillGroups",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SkillGroup",
                  "kind": "LinkedField",
                  "name": "skillGroups",
                  "plural": true,
                  "selections": [
                    v7,
                    v6,
                    v4,
                    v8,
                    v9,
                    v13,
                    v14
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        v5
      ]
    },
    "params": {
      "cacheID": "c1b2ddc69b287911bbd468cdc1b44738",
      "id": null,
      "metadata": {},
      "name": "VacancyEditorReviewQuery",
      "operationKind": "query",
      "text": "query VacancyEditorReviewQuery(\n  $vacancyId: UUID!\n  $employerId: UUID!\n) {\n  vacancy: recruitVacancyById(vacancyId: $vacancyId) {\n    ...VacancyEditorReview_vacancy\n    ...VacancySkillGroups_groups\n    id\n  }\n  employerTalentPools: recruitTalentPoolsForEmployer(employerId: $employerId) {\n    id\n    name\n    talentPoolId\n  }\n}\n\nfragment VacancyEditorReview_vacancy on Vacancy {\n  id\n  name\n  vacancyId\n  code\n  publicDescriptionHtml\n  publicDescriptionText\n  publicDescriptionEditorState\n  industryName\n  industryId\n  profession\n  companyVsSkillWeight\n  formGroupReferences {\n    templateName\n    isRequired\n  }\n  documentTypeReferences {\n    documentTypeName\n    isRequired\n  }\n  skillGroups {\n    id\n    skillGroupId\n    isRequired\n    name\n    weight\n    terms {\n      name\n      isSkill\n    }\n    experience {\n      durationAmount\n      durationType\n    }\n    recency {\n      durationAmount\n      durationType\n    }\n  }\n  profileSources {\n    source {\n      sourceId\n      sourceName\n      sourceType\n    }\n  }\n  vacancyProfileSources {\n    sourceId\n    sourceType\n    id\n  }\n  scoringConfig {\n    industryNegativeThreshold\n    industryPositiveThreshold\n    relevanceNegativeThreshold\n    relevancePositiveThreshold\n    industryExperience {\n      durationType\n      durationAmount\n    }\n    industryRecency {\n      durationType\n      durationAmount\n    }\n    relevantExperience {\n      durationType\n      durationAmount\n    }\n    relevantRecency {\n      durationType\n      durationAmount\n    }\n  }\n  filterStats {\n    key\n    value\n  }\n  rate {\n    currencyCode\n    currencyCountryCode\n    currencyCountryName\n    isPrivate\n    max\n    min\n    payType\n  }\n  dates {\n    startDate\n    startAsap\n    durationCode\n    durationDescription\n    durationAmount\n    durationType\n  }\n  expiresAt\n  employerReference\n  headcount\n  locations {\n    name\n    countryCode\n    latitude\n    longitude\n    state\n    entireCountry\n  }\n}\n\nfragment VacancySkillGroupChart_vacancy on Vacancy {\n  id\n  skillGroups {\n    id\n    skillGroupId\n    isRequired\n    name\n    weight\n    terms {\n      name\n      isSkill\n    }\n    experience {\n      durationAmount\n      durationType\n    }\n    recency {\n      durationAmount\n      durationType\n    }\n  }\n}\n\nfragment VacancySkillGroups_groups on Vacancy {\n  id\n  vacancyId\n  skillsText\n  skillGroups {\n    skillGroupId\n    isRequired\n    name\n    weight\n    terms {\n      name\n      isSkill\n    }\n    experience {\n      durationAmount\n      durationType\n    }\n    recency {\n      durationAmount\n      durationType\n    }\n  }\n  autogeneratedSkillGroups {\n    skillGroups {\n      skillGroupId\n      isRequired\n      name\n      weight\n      terms {\n        name\n        isSkill\n      }\n      experience {\n        durationAmount\n        durationType\n      }\n      recency {\n        durationAmount\n        durationType\n      }\n    }\n  }\n  ...VacancySkillGroupChart_vacancy\n}\n"
    }
  };
}();
node175.hash = "5db0e70d14a842fa2b9ec61bb8a1bca0";
var VacancyEditorReviewQuery_graphql_default = node175;

// src/vacancies/components/VacancyEditorReview.tsx
import { Fragment as Fragment35, Suspense as Suspense41, useCallback as useCallback79 } from "react";
import {
  useFragment as useFragment40,
  useLazyLoadQuery as useLazyLoadQuery21,
  useMutation as useMutation13
} from "react-relay";
import * as zod12 from "zod";
import { zodResolver as zodResolver14 } from "@hookform/resolvers/zod";
import { format as format9 } from "date-fns";
import { useForm as useForm14 } from "react-hook-form";
import { useNavigate as useNavigate16 } from "react-router-dom";
import { createClientMutationId as createClientMutationId36, formatDate as formatDate4, useToggle as useToggle18 } from "shared-lib";
import { Error as Error6, FormMultiSelectWithTags } from "shared-ui";
import { serializeEditorStateToHtml } from "shared-ui";
import {
  Button as Button43,
  DescriptionItem,
  DescriptionList,
  EdLink as EdLink14,
  EdSkeleton as EdSkeleton35,
  InputField as InputField4,
  Size as Size23,
  Tag as Tag10,
  classNames as classNames19
} from "shared-ui";
import { Fragment as Fragment36, jsx as jsx145, jsxs as jsxs100 } from "react/jsx-runtime";
var vacancyFragment = VacancyEditorReview_vacancy_graphql_default;
var mutationDef44 = VacancyEditorReviewMutation_graphql_default;
var queryDef20 = VacancyEditorReviewQuery_graphql_default;
var VacancyEditorOverviewReview = ({
  editRouteId
}) => {
  const data = useVacancyEditRouteData(editRouteId);
  const navigate = useNavigate16();
  const { vacancy } = data;
  const onSaved = useCallback79(() => {
    navigate("../overview");
  }, [navigate]);
  const onEditDescription = useCallback79(() => {
    navigate("../description");
  }, [navigate]);
  if (!vacancy) {
    return /* @__PURE__ */ jsx145(EdSkeleton35, {});
  }
  return /* @__PURE__ */ jsx145(
    VacancyEditorReview,
    {
      vacancyId: vacancy.vacancyId,
      employerId: vacancy.employerId,
      onNext: onSaved,
      onPrevious: () => navigate("../scoring"),
      onEditDescription,
      hasPrevious: false,
      hasNext: vacancy.editState.canPublish,
      nextLabel: "Publish",
      hideHeader: true
    }
  );
};
var VacancyEditorWizardReview = ({ editRouteId }) => {
  const data = useVacancyEditRouteData(editRouteId);
  const onEditDescription = useCallback79(() => {
  }, []);
  const navigate = useNavigate16();
  if (!data.vacancy) {
    return /* @__PURE__ */ jsx145(EdSkeleton35, {});
  }
  const { vacancyId, employerId } = data.vacancy;
  return /* @__PURE__ */ jsx145(Suspense41, { fallback: /* @__PURE__ */ jsx145(EdSkeleton35, {}), children: /* @__PURE__ */ jsxs100("div", { className: "flex w-full flex-col items-center gap-10 px-2 md:px-5", children: [
    /* @__PURE__ */ jsx145("div", { className: "w-9/12", children: /* @__PURE__ */ jsx145(VacancyEditorProgressBar, { step: "overview" }) }),
    /* @__PURE__ */ jsx145(
      VacancyEditorReview,
      {
        vacancyId,
        employerId,
        onPrevious: () => navigate("../scoring"),
        onNext: () => navigate("."),
        onEditDescription,
        hasNext: true,
        hasPrevious: true,
        nextLabel: "Publish"
      }
    )
  ] }) });
};
var VacancyEditorReview = ({
  vacancyId,
  employerId,
  onPrevious,
  hasPrevious,
  hasNext,
  nextLabel,
  hideHeader
}) => {
  const query3 = useLazyLoadQuery21(
    queryDef20,
    { vacancyId, employerId },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { employerTalentPools } = query3;
  const vacancy = useFragment40(
    vacancyFragment,
    query3.vacancy
  );
  const FormSchema7 = zod12.object({
    skills: zod12.array(zod12.any()).nonempty({
      message: "No skills have been generated. Try adding more details about the skills related to the job."
    }),
    salary: zod12.object({
      minRate: zod12.number({
        required_error: "Min rate is a required field",
        invalid_type_error: "Min rate is a required field"
      }),
      maxRate: zod12.number({
        required_error: "Max rate is a required field",
        invalid_type_error: "Max rate is a required field"
      }),
      countryCode: zod12.string({
        required_error: "Country is a required field",
        invalid_type_error: "Country is a required field"
      })
    }),
    "relevant-experience": zod12.object({
      durationAmount: zod12.number({
        required_error: "Relevant duration amount is a required field",
        invalid_type_error: "Relevant duration amount is a required field"
      }),
      durationType: zod12.string({
        required_error: "Relevant duration type is a required field",
        invalid_type_error: "Relevant duration type is a required field"
      })
    }),
    "relevant-recency": zod12.object({
      durationAmount: zod12.number({
        required_error: "Relevant recency amount is a required field",
        invalid_type_error: "Relevant recency amount is a required field"
      }),
      durationType: zod12.string({
        required_error: "Relevant recency type is a required field",
        invalid_type_error: "Relevant recency type is a required field"
      })
    }),
    "industry-experience": zod12.object({
      durationAmount: zod12.number({
        required_error: "Industry experience amount amount is a required field",
        invalid_type_error: "Industry experience amount is a required field"
      }),
      durationType: zod12.string({
        required_error: "Industry experience type is a required field",
        invalid_type_error: "Industry experience type is a required field"
      })
    }),
    "industry-recency": zod12.object({
      durationAmount: zod12.number({
        required_error: "Industry recency amount is a required field",
        invalid_type_error: "Industry recency amount is a required field"
      }),
      durationType: zod12.string({
        required_error: "Industry recency type is a required field",
        invalid_type_error: "Industry recency type is a required field"
      })
    })
  });
  const {
    register,
    getValues,
    control,
    handleSubmit,
    formState: { errors }
  } = useForm14({
    resolver: zodResolver14(FormSchema7),
    defaultValues: {
      "vacancy-name": vacancy?.name,
      "industry-name": {
        id: "",
        name: vacancy?.industryName,
        industryId: vacancy?.industryId
      },
      profession: { id: "", name: vacancy?.profession },
      "relevant-experience": {
        durationAmount: vacancy?.scoringConfig?.relevantExperience?.durationAmount || 0,
        durationType: vacancy?.scoringConfig?.relevantExperience?.durationType || "YEARS"
      },
      "relevant-recency": {
        durationAmount: vacancy?.scoringConfig?.relevantRecency?.durationAmount || 0,
        durationType: vacancy?.scoringConfig?.relevantRecency?.durationType || "YEARS"
      },
      "industry-experience": {
        durationAmount: vacancy?.scoringConfig?.industryExperience?.durationAmount || 0,
        durationType: vacancy?.scoringConfig?.industryExperience?.durationType || "YEARS"
      },
      "industry-recency": {
        durationAmount: vacancy?.scoringConfig?.industryRecency?.durationAmount || 0,
        durationType: vacancy?.scoringConfig?.industryRecency?.durationType || "YEARS"
      },
      "public-description": JSON.parse(
        vacancy?.publicDescriptionEditorState || "[]"
      ),
      skills: vacancy?.skillGroups,
      salary: {
        minRate: vacancy?.rate?.min || 0,
        maxRate: vacancy?.rate?.max || 0,
        payType: fromPayType(vacancy?.rate?.payType || "PER_DAY"),
        currencyCode: vacancy?.rate?.currencyCode || "GBP",
        countryCode: vacancy?.rate?.currencyCountryCode || "GB",
        rateIsPrivate: vacancy?.rate?.isPrivate || false
      },
      "start-date": {
        startASAP: vacancy?.dates?.startAsap || false,
        startDate: vacancy?.dates?.startDate || /* @__PURE__ */ new Date()
      },
      "expires-at": format9(
        vacancy?.expiresAt ? new Date(vacancy?.expiresAt) : /* @__PURE__ */ new Date(),
        "yyyy-MM-dd"
      ),
      headcount: vacancy?.headcount || 1,
      "employer-reference": vacancy?.employerReference || "",
      "employment-type": {
        roleType: toRoleType(vacancy?.dates?.durationCode),
        durationAmount: vacancy?.dates?.durationAmount || 0,
        durationType: vacancy?.dates?.durationType || "MONTHS"
      },
      "talent-pools": vacancy?.vacancyProfileSources.map((x4) => ({
        id: x4.sourceId,
        name: vacancy.profileSources.find((y4) => y4.source.sourceId === x4.sourceId)?.source.sourceName || ""
      })) || [],
      locations: vacancy?.locations.map(
        ({ name, countryCode, latitude, longitude }) => ({
          name,
          countryCode,
          latitude,
          longitude
        })
      ) || []
    }
  });
  const [commit11] = useMutation13(mutationDef44);
  const onSave = useCallback79(() => {
    const formValues = getValues();
    commit11({
      variables: {
        publish: {
          clientMutationId: createClientMutationId36(),
          vacancyId
        },
        scoring: {
          clientMutationId: createClientMutationId36(),
          vacancyId,
          skillGroups: serializeSkillGroups(
            formValues["skills"] || []
          ),
          companyVsSkillWeight: vacancy?.companyVsSkillWeight,
          industryExperience: {
            durationType: formValues["industry-experience"].durationType,
            durationAmount: formValues["industry-experience"].durationAmount
          },
          industryRecency: {
            durationType: formValues["industry-recency"].durationType,
            durationAmount: formValues["industry-recency"].durationAmount
          },
          relevantExperience: {
            durationType: formValues["relevant-experience"].durationType,
            durationAmount: formValues["relevant-experience"].durationAmount
          },
          relevantRecency: {
            durationType: formValues["relevant-recency"].durationType,
            durationAmount: formValues["relevant-recency"].durationAmount
          }
        },
        profileSources: {
          clientMutationId: createClientMutationId36(),
          vacancyId,
          vaults: [],
          vaultRecommendationMode: "",
          talentPools: formValues["talent-pools"].map(({ id: id18 }) => ({
            sourceId: id18
          }))
        },
        description: {
          vacancyId,
          name: formValues["vacancy-name"],
          clientMutationId: createClientMutationId36(),
          description: serializeEditorStateToHtml(
            formValues["public-description"]
          ),
          editorState: JSON.stringify(formValues["public-description"]),
          industryId: formValues["industry-name"].industryId,
          industryName: formValues["industry-name"].name,
          industryExperience: {
            durationType: formValues["industry-experience"].durationType,
            durationAmount: formValues["industry-experience"].durationAmount
          },
          industryRecency: {
            durationType: formValues["industry-recency"].durationType,
            durationAmount: formValues["industry-recency"].durationAmount
          },
          relevantExperience: {
            durationType: formValues["relevant-experience"].durationType,
            durationAmount: formValues["relevant-experience"].durationAmount
          },
          relevantRecency: {
            durationType: formValues["relevant-recency"].durationType,
            durationAmount: formValues["relevant-recency"].durationAmount
          },
          profession: formValues.profession.name
        },
        details: {
          clientMutationId: createClientMutationId36(),
          vacancyId,
          startAsap: formValues["start-date"].startASAP,
          startDate: formValues["start-date"].startDate,
          headcount: formValues.headcount,
          employerReference: formValues["employer-reference"],
          expiresAt: formValues["expires-at"],
          durationCode: toVacancyDurationCode(
            formValues["employment-type"].roleType
          ),
          minRate: Number(formValues.salary.minRate),
          maxRate: Number(formValues.salary.maxRate),
          isPrivateRate: formValues.salary.rateIsPrivate,
          payType: toPayType(formValues.salary.payType),
          currencyCountryCode: formValues.salary.countryCode,
          locations: formValues.locations
        }
      },
      onCompleted: () => {
        window.location.href = `/portal/employers/app/vacancies/view/${vacancy?.code}/matches?page=info`;
      }
    });
  }, [
    commit11,
    getValues,
    vacancy?.code,
    vacancy?.companyVsSkillWeight,
    vacancyId
  ]);
  const [extendedJobDescription, toggleExtendedJobDescription] = useToggle18(false);
  if (!vacancy || !query3.vacancy) {
    return /* @__PURE__ */ jsx145(EdSkeleton35, {});
  }
  const labels = {
    sources: "Entire Pool",
    sources_and_locations_and_is_available_and_approved: "Available and approved candidates",
    sources_and_locations_and_is_available_and_approved_and_rate: "Available, approved candidates, who match the set rate",
    sources_and_locations_and_is_available_and_approved_and_rate_and_employment: "Available, approved candidates, who match the set rate and employment type"
  };
  const funnelData = vacancy.filterStats.map(({ key, value }) => ({
    id: key,
    value,
    label: labels[key] || key
  }));
  return /* @__PURE__ */ jsx145(Suspense41, { fallback: /* @__PURE__ */ jsx145(EdSkeleton35, {}), children: /* @__PURE__ */ jsxs100("div", { className: "flex flex-col gap-5", children: [
    !hideHeader && /* @__PURE__ */ jsx145(EditContainer3, { title: "Review", children: /* @__PURE__ */ jsx145("div", { className: "flex grow flex-row items-baseline justify-between gap-3", children: /* @__PURE__ */ jsx145("p", { className: "text-md", children: "Please review the following information before publishing your vacancy" }) }) }),
    /* @__PURE__ */ jsx145(
      DescriptionList,
      {
        heading: /* @__PURE__ */ jsx145("div", { className: "flex items-baseline gap-2", children: /* @__PURE__ */ jsx145("div", { children: "Description" }) }),
        items: [
          /* @__PURE__ */ jsxs100(Fragment35, { children: [
            /* @__PURE__ */ jsx145(
              DescriptionItem,
              {
                label: /* @__PURE__ */ jsx145(
                  DescriptionEditTitle,
                  {
                    editLabel: `Edit`,
                    label: "Vacancy Name",
                    href: "../description"
                  }
                ),
                children: /* @__PURE__ */ jsx145(
                  InputField4,
                  {
                    name: "vacancy-name",
                    register,
                    required: false,
                    interactive: false
                  }
                )
              }
            ),
            /* @__PURE__ */ jsx145(
              DescriptionItem,
              {
                label: /* @__PURE__ */ jsx145(
                  DescriptionEditTitle,
                  {
                    editLabel: `Edit`,
                    label: "Industry",
                    href: "../description"
                  }
                ),
                children: getValues("industry-name").name
              }
            ),
            /* @__PURE__ */ jsx145(
              DescriptionItem,
              {
                label: /* @__PURE__ */ jsx145(
                  DescriptionEditTitle,
                  {
                    editLabel: `Edit`,
                    label: "Profession",
                    href: "../description"
                  }
                ),
                children: getValues("profession").name
              }
            ),
            /* @__PURE__ */ jsx145(
              DescriptionItem,
              {
                label: /* @__PURE__ */ jsx145(
                  DescriptionEditTitle,
                  {
                    editLabel: `Edit`,
                    label: "Experience Required",
                    href: "../description"
                  }
                ),
                children: /* @__PURE__ */ jsx145(Fragment36, { children: ((experience) => {
                  return /* @__PURE__ */ jsxs100(Fragment36, { children: [
                    experience.durationAmount,
                    " ",
                    pluralizeDuration(
                      experience.durationType,
                      experience.durationAmount
                    )
                  ] });
                })(getValues("relevant-experience")) })
              }
            ),
            /* @__PURE__ */ jsx145(
              DescriptionItem,
              {
                label: /* @__PURE__ */ jsx145(
                  DescriptionEditTitle,
                  {
                    editLabel: `Edit`,
                    label: "Industry Experience Required",
                    href: "../description"
                  }
                ),
                children: /* @__PURE__ */ jsx145(Fragment36, { children: ((experience) => {
                  return /* @__PURE__ */ jsxs100(Fragment36, { children: [
                    experience.durationAmount,
                    " ",
                    pluralizeDuration(
                      experience.durationType,
                      experience.durationAmount
                    )
                  ] });
                })(getValues("industry-experience")) })
              }
            ),
            /* @__PURE__ */ jsx145(
              DescriptionItem,
              {
                label: /* @__PURE__ */ jsx145(
                  DescriptionEditTitle,
                  {
                    editLabel: "Edit",
                    label: "Role Purpose/Summary",
                    href: "../description"
                  }
                ),
                children: /* @__PURE__ */ jsxs100("div", { children: [
                  /* @__PURE__ */ jsx145(
                    "div",
                    {
                      className: classNames19(
                        !extendedJobDescription && "line-clamp-5"
                      ),
                      dangerouslySetInnerHTML: {
                        __html: serializeEditorStateToHtml(
                          getValues("public-description")
                        )
                      }
                    }
                  ),
                  /* @__PURE__ */ jsx145(
                    "div",
                    {
                      className: "text-primary-400 cursor-pointer pt-1 text-xs",
                      onClick: toggleExtendedJobDescription,
                      children: extendedJobDescription ? "Less" : "More"
                    }
                  )
                ] })
              }
            )
          ] }, "description")
        ]
      }
    ),
    /* @__PURE__ */ jsx145(
      DescriptionList,
      {
        heading: /* @__PURE__ */ jsx145("div", { className: "flex items-baseline gap-2", children: /* @__PURE__ */ jsx145("div", { children: "Details" }) }),
        items: [
          /* @__PURE__ */ jsxs100(Fragment35, { children: [
            /* @__PURE__ */ jsx145(
              DescriptionItem,
              {
                label: /* @__PURE__ */ jsx145(DescriptionEditTitle, { label: "Salary", href: "../details" }),
                children: /* @__PURE__ */ jsx145(Fragment36, { children: ((rate) => /* @__PURE__ */ jsx145("div", { children: /* @__PURE__ */ jsx145(
                  RateLabel,
                  {
                    rate: {
                      countryCode: rate.countryCode,
                      currencyCode: rate.currencyCode,
                      maximumRateOfPay: rate.maxRate,
                      minimumRateOfPay: rate.minRate,
                      payType: toPayType(rate.payType)
                    }
                  }
                ) }))(getValues("salary")) })
              }
            ),
            /* @__PURE__ */ jsx145(
              DescriptionItem,
              {
                label: /* @__PURE__ */ jsx145(
                  DescriptionEditTitle,
                  {
                    label: "Contract Term",
                    href: "../details"
                  }
                ),
                children: ((x4) => {
                  return x4.roleType === "FixedLength" ? /* @__PURE__ */ jsxs100(Fragment36, { children: [
                    x4.durationAmount,
                    " ",
                    pluralizeDuration(x4.durationType, x4.durationAmount)
                  ] }) : /* @__PURE__ */ jsx145(Fragment36, { children: x4.roleType });
                })(getValues("employment-type"))
              }
            ),
            /* @__PURE__ */ jsx145(
              DescriptionItem,
              {
                label: /* @__PURE__ */ jsx145(DescriptionEditTitle, { label: "Locations", href: "../details" }),
                children: /* @__PURE__ */ jsx145("div", { className: "flex flex-wrap gap-2", children: vacancy.locations.map((location2) => location2.name).map((x4) => /* @__PURE__ */ jsx145(Tag10, { children: x4 }, x4)) })
              }
            ),
            /* @__PURE__ */ jsx145(
              DescriptionItem,
              {
                label: /* @__PURE__ */ jsx145(
                  DescriptionEditTitle,
                  {
                    label: "Start Date",
                    href: "../details"
                  }
                ),
                children: ((date) => {
                  return /* @__PURE__ */ jsxs100(Fragment36, { children: [
                    !date.startASAP && formatDate4(date.startDate),
                    " ",
                    date.startASAP && /* @__PURE__ */ jsx145("span", { className: "text-gray-400", children: "(ASAP)" })
                  ] });
                })(getValues("start-date"))
              }
            ),
            /* @__PURE__ */ jsx145(
              DescriptionItem,
              {
                label: /* @__PURE__ */ jsx145(
                  DescriptionEditTitle,
                  {
                    label: "Expires At",
                    href: "../details"
                  }
                ),
                children: /* @__PURE__ */ jsx145(
                  InputField4,
                  {
                    name: "expires-at",
                    type: "date",
                    register,
                    required: false,
                    interactive: false
                  }
                )
              }
            ),
            /* @__PURE__ */ jsx145(
              DescriptionItem,
              {
                label: /* @__PURE__ */ jsx145(
                  DescriptionEditTitle,
                  {
                    label: "Number of positions",
                    href: "../details"
                  }
                ),
                children: /* @__PURE__ */ jsx145(
                  InputField4,
                  {
                    name: "headcount",
                    type: "number",
                    min: 1,
                    register,
                    required: false,
                    interactive: false
                  }
                )
              }
            ),
            /* @__PURE__ */ jsx145(
              DescriptionItem,
              {
                label: /* @__PURE__ */ jsx145(
                  DescriptionEditTitle,
                  {
                    label: "Job Reference",
                    href: "../details"
                  }
                ),
                children: /* @__PURE__ */ jsx145(
                  InputField4,
                  {
                    name: "employer-reference",
                    register,
                    required: false,
                    interactive: false
                  }
                )
              }
            )
          ] }, "details")
        ]
      }
    ),
    /* @__PURE__ */ jsx145(
      DescriptionList,
      {
        heading: /* @__PURE__ */ jsx145("div", { className: "flex items-baseline gap-2", children: /* @__PURE__ */ jsx145("div", { children: "Search" }) }),
        items: [
          /* @__PURE__ */ jsxs100(Fragment35, { children: [
            /* @__PURE__ */ jsxs100(
              DescriptionItem,
              {
                label: /* @__PURE__ */ jsx145(DescriptionEditTitle, { label: "Skills", href: "../scoring" }),
                children: [
                  /* @__PURE__ */ jsx145("div", { className: "flex flex-wrap gap-2", children: ((skillGroups) => {
                    const required = skillGroups?.filter((x4) => x4.isRequired);
                    const optional = skillGroups?.filter((x4) => !x4.isRequired);
                    return /* @__PURE__ */ jsxs100("div", { className: "flex flex-col gap-2", children: [
                      /* @__PURE__ */ jsxs100("div", { className: "flex flex-wrap gap-1", children: [
                        "Required:",
                        " ",
                        required?.map((x4) => /* @__PURE__ */ jsx145(Tag10, { children: x4.name }, x4.id))
                      ] }),
                      /* @__PURE__ */ jsxs100("div", { className: "flex flex-wrap gap-1", children: [
                        "Optional:",
                        " ",
                        optional?.map((x4) => /* @__PURE__ */ jsx145(Tag10, { color: "bg-gray-200", children: x4.name }, x4.id))
                      ] })
                    ] });
                  })(getValues("skills")) }),
                  /* @__PURE__ */ jsx145(Error6, { children: errors.skills?.message })
                ]
              }
            ),
            /* @__PURE__ */ jsx145(
              DescriptionItem,
              {
                label: /* @__PURE__ */ jsx145(
                  DescriptionEditTitle,
                  {
                    label: "Searching Candidates In",
                    href: "../talent-pools"
                  }
                ),
                children: /* @__PURE__ */ jsx145(
                  FormMultiSelectWithTags,
                  {
                    interactive: false,
                    control,
                    name: "talent-pools",
                    items: employerTalentPools.map((x4) => ({
                      id: x4.talentPoolId,
                      name: x4.name
                    }))
                  }
                )
              }
            )
          ] }, "search")
        ]
      }
    ),
    /* @__PURE__ */ jsx145(
      DescriptionList,
      {
        heading: /* @__PURE__ */ jsx145("div", { className: "flex items-baseline gap-2", children: /* @__PURE__ */ jsx145("div", { children: "Compliance" }) }),
        items: [
          /* @__PURE__ */ jsxs100(Fragment35, { children: [
            /* @__PURE__ */ jsx145(
              DescriptionItem,
              {
                label: /* @__PURE__ */ jsx145(DescriptionEditTitle, { label: "Forms", href: "../forms" }),
                children: /* @__PURE__ */ jsxs100("ul", { children: [
                  vacancy.formGroupReferences.map((x4) => /* @__PURE__ */ jsx145("li", { children: x4.templateName }, x4.templateName)),
                  vacancy.formGroupReferences.length === 0 && /* @__PURE__ */ jsx145("li", { className: "text-gray-400", children: "No Forms Selected" })
                ] })
              }
            ),
            /* @__PURE__ */ jsx145(
              DescriptionItem,
              {
                label: /* @__PURE__ */ jsx145(
                  DescriptionEditTitle,
                  {
                    label: "Documents",
                    href: "../documents"
                  }
                ),
                children: /* @__PURE__ */ jsxs100("ul", { children: [
                  vacancy.documentTypeReferences.map((x4) => /* @__PURE__ */ jsx145("li", { children: x4.documentTypeName }, x4.documentTypeName)),
                  vacancy.documentTypeReferences.length === 0 && /* @__PURE__ */ jsx145("li", { className: "text-gray-400", children: "No Documents Selected" })
                ] })
              }
            )
          ] }, "compliance")
        ]
      }
    ),
    /* @__PURE__ */ jsx145("div", { className: "mt-5 flex w-full justify-end", children: /* @__PURE__ */ jsxs100("div", { children: [
      hasPrevious && /* @__PURE__ */ jsx145(Button43, { onClick: onPrevious, size: Size23.lg, children: "Previous" }),
      hasNext && /* @__PURE__ */ jsx145(
        Button43,
        {
          onClick: handleSubmit(onSave),
          size: Size23.xl,
          color: "primary",
          children: nextLabel
        }
      )
    ] }) })
  ] }) });
};
var DescriptionEditTitle = ({
  label,
  href,
  editLabel = "Edit"
}) => /* @__PURE__ */ jsxs100(Fragment36, { children: [
  label,
  /* @__PURE__ */ jsx145(EdLink14, { name: "search", href, children: /* @__PURE__ */ jsx145("div", { className: "cursor-pointer text-xs text-blue-400", children: editLabel }) })
] });

// src/vacancies/components/__generated__/VacancyEditorDocumentsQuery.graphql.ts
var node176 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "vacancyId"
    }
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "vacancyId",
    "storageKey": null
  }, v23 = [
    {
      "alias": "vacancy",
      "args": [
        {
          "kind": "Variable",
          "name": "vacancyId",
          "variableName": "vacancyId"
        }
      ],
      "concreteType": "Vacancy",
      "kind": "LinkedField",
      "name": "recruitVacancyById",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        v1,
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "employerSlug",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "VacancyDocumentTypeReference",
          "kind": "LinkedField",
          "name": "documentTypeReferences",
          "plural": true,
          "selections": [
            v1,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "documentTypeId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "documentTypeName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isRequired",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "requiresExpiryDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "requiresIssueDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "requiresIssueNumber",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "VacancyEditorDocumentsQuery",
      "selections": v23,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "VacancyEditorDocumentsQuery",
      "selections": v23
    },
    "params": {
      "cacheID": "317b6625bb3d0b4f200426ede235b827",
      "id": null,
      "metadata": {},
      "name": "VacancyEditorDocumentsQuery",
      "operationKind": "query",
      "text": "query VacancyEditorDocumentsQuery(\n  $vacancyId: UUID!\n) {\n  vacancy: recruitVacancyById(vacancyId: $vacancyId) {\n    id\n    vacancyId\n    employerSlug\n    code\n    documentTypeReferences {\n      vacancyId\n      documentTypeId\n      documentTypeName\n      isRequired\n      requiresExpiryDate\n      requiresIssueDate\n      requiresIssueNumber\n    }\n  }\n}\n"
    }
  };
}();
node176.hash = "ce8f148d014f823de9486dfe14b93189";
var VacancyEditorDocumentsQuery_graphql_default = node176;

// src/vacancies/components/VacancyEditorDocuments.tsx
import { Suspense as Suspense43, useCallback as useCallback80, useState as useState54 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery23 } from "react-relay";
import { createClientMutationId as createClientMutationId37, useLogger as useLogger16 } from "shared-lib";
import {
  BooleanLabel,
  Button as Button44,
  CheckBox as CheckBox4,
  EdActionCell,
  EdColumnCell as EdColumnCell4,
  EdLink as EdLink15,
  EdRow as EdRow4,
  EdSkeleton as EdSkeleton36,
  EdTable as EdTable4,
  LinkButton as LinkButton3,
  Size as Size24
} from "shared-ui";
import {
  DocumentTypeSearchBoxContainer
} from "app-core";
import { jsx as jsx146, jsxs as jsxs101 } from "react/jsx-runtime";
var queryDef21 = VacancyEditorDocumentsQuery_graphql_default;
var documentColumns = [
  { id: "documentTypeName", name: "Document Type" },
  { id: "isRequired", name: "Required" },
  { id: "requiresExpiryDate", name: "Requires Expiry Date" },
  { id: "requiresIssueDate", name: "Requires Issue Date" },
  { id: "requiresIssueNumber", name: "Requires Issue Number" }
];
var DocumentRow = ({ reference, onSelect }) => {
  const select = useCallback80(() => {
    onSelect(reference);
  }, [onSelect]);
  return /* @__PURE__ */ jsxs101(EdRow4, { clicked: select, rowKey: reference.documentTypeId, children: [
    /* @__PURE__ */ jsx146(EdColumnCell4, { children: reference.documentTypeName }),
    /* @__PURE__ */ jsx146(EdColumnCell4, { children: /* @__PURE__ */ jsx146(BooleanLabel, { value: reference.isRequired }) }),
    /* @__PURE__ */ jsx146(EdColumnCell4, { children: /* @__PURE__ */ jsx146(BooleanLabel, { value: reference.requiresExpiryDate }) }),
    /* @__PURE__ */ jsx146(EdColumnCell4, { children: /* @__PURE__ */ jsx146(BooleanLabel, { value: reference.requiresIssueDate }) }),
    /* @__PURE__ */ jsx146(EdColumnCell4, { children: /* @__PURE__ */ jsx146(BooleanLabel, { value: reference.requiresIssueNumber }) }),
    /* @__PURE__ */ jsx146(EdActionCell, { children: /* @__PURE__ */ jsx146(LinkButton3, { label: "Select", clicked: select }) })
  ] });
};
var VacancyEditorDocuments = ({ editRouteId }) => {
  const [log] = useLogger16();
  const data = useVacancyEditRouteData(editRouteId);
  const query3 = useLazyLoadQuery23(
    queryDef21,
    { vacancyId: data.vacancy.vacancyId },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { vacancy } = query3;
  const [selectedDocumentIsRequired, setSelectedDocumentIsRequired] = useState54(false);
  const [documentToAdd, setDocumentToAdd] = useState54(null);
  const onSearchCompleted = useCallback80(
    (result) => {
      setDocumentToAdd(result);
    },
    [setDocumentToAdd]
  );
  const [addDoc, isAddingDoc] = useVacancyDocumentAdd();
  const [removeDoc, isRemovingDoc] = useVacancyDocumentRemove();
  const onAddForm = useCallback80(async () => {
    if (!documentToAdd || !data.vacancy) {
      return;
    }
    const input = {
      vacancyId: data.vacancy.vacancyId,
      documentTypeId: documentToAdd.documentTypeId,
      isRequired: selectedDocumentIsRequired,
      clientMutationId: createClientMutationId37()
    };
    const response = await addDoc({ input });
    if (response.data.vacancy) {
      setDocumentToAdd(null);
    }
  }, [addDoc]);
  const onCancelAddForm = useCallback80(async () => {
    setDocumentToAdd(null);
  }, [addDoc]);
  const [selectedDocumentId, setSelectedDocumentId] = useState54(
    null
  );
  const onSelectDoc = useCallback80(
    (reference) => {
      setSelectedDocumentId(reference.documentTypeId);
    },
    [setSelectedDocumentId]
  );
  const onClearSelected = useCallback80(async () => {
    setSelectedDocumentId(null);
  }, [setSelectedDocumentId]);
  const onAddDocument = useCallback80(async () => {
    if (!selectedDocumentId || !vacancy) {
      return;
    }
    const selected = vacancy.documentTypeReferences.find(
      (d4) => d4.documentTypeId === selectedDocumentId
    );
    if (!selected) {
      return;
    }
    const input = {
      vacancyId: vacancy.vacancyId,
      documentTypeId: selected.documentTypeId,
      clientMutationId: createClientMutationId37()
    };
    const response = await removeDoc({ input });
    if (response.data.vacancy) {
      setSelectedDocumentId(null);
    }
  }, [setSelectedDocumentId, removeDoc]);
  if (!vacancy) {
    return /* @__PURE__ */ jsx146(EdSkeleton36, {});
  }
  let Documents = /* @__PURE__ */ jsx146("div", { className: "p-2 text-sm text-gray-900", children: "No Documents Configured" });
  if (vacancy.documentTypeReferences && vacancy.documentTypeReferences.length > 0) {
    const documentRows = vacancy.documentTypeReferences.map((fg) => {
      return /* @__PURE__ */ jsx146(DocumentRow, { reference: fg, onSelect: onSelectDoc });
    });
    Documents = /* @__PURE__ */ jsx146(EdTable4, { defaultColumns: documentColumns, rows: documentRows });
  }
  let selectedDocument = null;
  if (selectedDocumentId) {
    selectedDocument = vacancy.documentTypeReferences.find(
      (d4) => d4.documentTypeId === selectedDocumentId
    );
  }
  let content = /* @__PURE__ */ jsx146("div", {});
  if (selectedDocument) {
    content = /* @__PURE__ */ jsxs101("div", { className: "mt-4 border bg-white p-8", children: [
      /* @__PURE__ */ jsx146("div", { className: "text-primary-500 border-b px-2 py-4 text-lg", children: selectedDocument.documentTypeName }),
      /* @__PURE__ */ jsxs101("div", { className: "flex items-center gap-2", children: [
        selectedDocument.requiresExpiryDate && /* @__PURE__ */ jsx146("div", { className: "text-sm font-medium text-green-500", children: "Expiry Date Required" }),
        selectedDocument.requiresIssueDate && /* @__PURE__ */ jsx146("div", { className: "text-sm font-medium text-green-500", children: "Issue Date Required" }),
        selectedDocument.requiresIssueNumber && /* @__PURE__ */ jsx146("div", { className: "text-sm font-medium text-green-500", children: "Issue Number Required" })
      ] }),
      /* @__PURE__ */ jsxs101("div", { className: "flex justify-end gap-2 pt-4", children: [
        /* @__PURE__ */ jsx146("div", { children: /* @__PURE__ */ jsx146(Button44, { color: "primary", clicked: onAddDocument, children: "Remove Document" }) }),
        /* @__PURE__ */ jsx146("div", { children: /* @__PURE__ */ jsx146(Button44, { color: "secondary", clicked: onClearSelected, children: "Cancel" }) })
      ] })
    ] });
  } else if (documentToAdd) {
    content = /* @__PURE__ */ jsxs101("div", { className: "mt-4 border bg-white p-8", children: [
      /* @__PURE__ */ jsx146("div", { className: "text-primary-500 border-b px-2 py-4 text-lg", children: documentToAdd.name }),
      /* @__PURE__ */ jsxs101("div", { className: "flex items-center gap-2", children: [
        documentToAdd.requiresExpiryDate && /* @__PURE__ */ jsx146("div", { className: "text-sm font-medium text-green-500", children: "Expiry Date Required" }),
        documentToAdd.requiresIssueDate && /* @__PURE__ */ jsx146("div", { className: "text-sm font-medium text-green-500", children: "Issue Date Required" }),
        documentToAdd.requiresIssueNumber && /* @__PURE__ */ jsx146("div", { className: "text-sm font-medium text-green-500", children: "Issue Number Required" })
      ] }),
      /* @__PURE__ */ jsx146("div", { className: "my-4", children: /* @__PURE__ */ jsx146(
        CheckBox4,
        {
          checked: selectedDocumentIsRequired,
          title: /* @__PURE__ */ jsx146("span", { children: "Document is Required ? " }),
          onChanged: setSelectedDocumentIsRequired
        }
      ) }),
      /* @__PURE__ */ jsxs101("div", { className: "flex justify-end gap-2 pt-4", children: [
        /* @__PURE__ */ jsx146("div", { children: /* @__PURE__ */ jsx146(Button44, { color: "primary", clicked: onAddForm, children: "Add Document" }) }),
        /* @__PURE__ */ jsx146("div", { children: /* @__PURE__ */ jsx146(Button44, { color: "secondary", clicked: onCancelAddForm, children: "Cancel" }) })
      ] })
    ] });
  } else {
    content = /* @__PURE__ */ jsxs101("div", { className: "flex flex-col gap-4 p-2", children: [
      /* @__PURE__ */ jsx146("div", { className: "flex flex-col gap-2 border-b px-2 pb-8 pt-2", children: Documents }),
      /* @__PURE__ */ jsxs101("div", { className: "flex flex-col gap-2 p-2", children: [
        /* @__PURE__ */ jsx146("div", { className: "text-primary-500 py-2", children: "Add Documents" }),
        /* @__PURE__ */ jsx146(
          DocumentTypeSearchBoxContainer,
          {
            onSearchCompleted
          }
        )
      ] })
    ] });
  }
  return /* @__PURE__ */ jsx146(Suspense43, { fallback: /* @__PURE__ */ jsx146(EdSkeleton36, {}), children: /* @__PURE__ */ jsxs101("div", { className: "m-auto flex flex-col gap-2 border bg-white p-2 shadow sm:rounded-lg lg:p-8", children: [
    /* @__PURE__ */ jsxs101("div", { className: "flex flex-col gap-2 p-2", children: [
      /* @__PURE__ */ jsx146("div", { className: "text-primary-500 border-b px-2 py-4", children: /* @__PURE__ */ jsx146("h1", { children: "Documents" }) }),
      content
    ] }),
    /* @__PURE__ */ jsx146(EdLink15, { name: "back", href: "../overview", children: /* @__PURE__ */ jsx146(Button44, { color: "primary", size: Size24.xl, children: "Back" }) })
  ] }) });
};

// src/vacancies/components/__generated__/VacancyEditorTalentPoolsQuery.graphql.ts
var node177 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "vacancyId"
    }
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "vacancyId",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "employerId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "seqId",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdOn",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "concreteType": "AccountId",
    "kind": "LinkedField",
    "name": "createdBy",
    "plural": false,
    "selections": [
      v1,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accountType",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "sourceId",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "sourceType",
    "storageKey": null
  }, v9 = [
    {
      "alias": "vacancy",
      "args": [
        {
          "kind": "Variable",
          "name": "vacancyId",
          "variableName": "vacancyId"
        }
      ],
      "concreteType": "Vacancy",
      "kind": "LinkedField",
      "name": "recruitVacancyById",
      "plural": false,
      "selections": [
        v1,
        v23,
        v32,
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "employerSlug",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RecruitVacancyMatchingConfig",
          "kind": "LinkedField",
          "name": "matchingConfig",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "vaultRecommendationModeKey",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "VacancyProfileSource",
          "kind": "LinkedField",
          "name": "vacancyProfileSources",
          "plural": true,
          "selections": [
            v1,
            v4,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "vacancyProfileSourceId",
              "storageKey": null
            },
            v5,
            v6,
            v23,
            v7
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "EmployerProfileSource",
          "kind": "LinkedField",
          "name": "employerProfileSources",
          "plural": true,
          "selections": [
            v1,
            v4,
            v5,
            v6,
            v32,
            v7,
            v8,
            {
              "alias": null,
              "args": null,
              "concreteType": "ProfileSource",
              "kind": "LinkedField",
              "name": "source",
              "plural": false,
              "selections": [
                v7,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "sourceName",
                  "storageKey": null
                },
                v8
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "VacancyEditorTalentPoolsQuery",
      "selections": v9,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "VacancyEditorTalentPoolsQuery",
      "selections": v9
    },
    "params": {
      "cacheID": "cedd8e96dbcca9762e1f35dab72e4fe4",
      "id": null,
      "metadata": {},
      "name": "VacancyEditorTalentPoolsQuery",
      "operationKind": "query",
      "text": "query VacancyEditorTalentPoolsQuery(\n  $vacancyId: UUID!\n) {\n  vacancy: recruitVacancyById(vacancyId: $vacancyId) {\n    id\n    vacancyId\n    employerId\n    employerSlug\n    code\n    matchingConfig {\n      vaultRecommendationModeKey\n    }\n    vacancyProfileSources {\n      id\n      seqId\n      vacancyProfileSourceId\n      createdOn\n      createdBy {\n        id\n        accountType\n      }\n      vacancyId\n      sourceId\n    }\n    employerProfileSources {\n      id\n      seqId\n      createdOn\n      createdBy {\n        id\n        accountType\n      }\n      employerId\n      sourceId\n      sourceType\n      source {\n        sourceId\n        sourceName\n        sourceType\n      }\n    }\n  }\n}\n"
    }
  };
}();
node177.hash = "8ad06e412bb90c89ffe6836993e74984";
var VacancyEditorTalentPoolsQuery_graphql_default = node177;

// src/vacancies/components/VacancyEditorTalentPools.tsx
import { Suspense as Suspense44, useCallback as useCallback81 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery24 } from "react-relay";
import {
  createClientMutationId as createClientMutationId38,
  isNotNullOrUndefined as isNotNullOrUndefined5,
  useToggle as useToggle19
} from "shared-lib";
import { Button as Button45, EdLink as EdLink16, EdSkeleton as EdSkeleton37, Size as Size25 } from "shared-ui";
import { jsx as jsx147, jsxs as jsxs103 } from "react/jsx-runtime";
var queryDef22 = VacancyEditorTalentPoolsQuery_graphql_default;
var VacancySource = ({
  vacancyId,
  source
}) => {
  const [removeSource, isRemovingSource] = useVacancyProfileSourceRemove();
  const [isRemoving, toggleIsRemoving] = useToggle19();
  const onRemoveSource = useCallback81(async () => {
    const input = {
      vacancyId,
      clientMutationId: createClientMutationId38(),
      sourceId: source.source.sourceId
    };
    await removeSource({ input });
  }, [removeSource]);
  return /* @__PURE__ */ jsxs103(
    "div",
    {
      className: "flex items-center justify-between py-2",
      children: [
        /* @__PURE__ */ jsx147("div", { className: "flex items-center gap-2", children: /* @__PURE__ */ jsx147("div", { className: "text-primary-500 p-2 font-medium", children: source.source.sourceName }) }),
        /* @__PURE__ */ jsx147("div", { className: "flex items-center justify-between", children: isRemoving ? /* @__PURE__ */ jsx147(
          Button45,
          {
            color: "danger",
            clicked: onRemoveSource,
            disabled: isRemovingSource,
            children: "Remove, Are you sure ?"
          }
        ) : /* @__PURE__ */ jsx147(Button45, { color: "danger", clicked: toggleIsRemoving, children: "Remove" }) })
      ]
    },
    source.sourceId
  );
};
var ProfileSourceList = ({
  vacancy,
  sources,
  onDone
}) => {
  return /* @__PURE__ */ jsxs103("div", { children: [
    /* @__PURE__ */ jsxs103("div", { className: "flex items-center justify-between gap-2 p-2", children: [
      /* @__PURE__ */ jsx147("div", { className: "text-primary-500 text-base font-semibold leading-6", children: "Add Source" }),
      /* @__PURE__ */ jsx147("div", { children: /* @__PURE__ */ jsx147(Button45, { color: "primary", clicked: onDone, children: "Cancel" }) })
    ] }),
    /* @__PURE__ */ jsx147("div", { className: "mt-4 divide-y divide-gray-200 border border-b border-t border-gray-200", children: sources.map((es) => /* @__PURE__ */ jsx147(
      ProfileSource,
      {
        vacancy,
        source: es,
        onDone
      },
      es.id
    )) })
  ] });
};
var ProfileSource = ({
  vacancy,
  source,
  onDone
}) => {
  const [addSource, isAddingSource] = useVacancyProfileSourceAdd();
  const onAddSource = useCallback81(async () => {
    if (!vacancy || !source) {
      return;
    }
    const input = {
      vacancyId: vacancy?.vacancyId,
      clientMutationId: createClientMutationId38(),
      sourceId: source.source.sourceId,
      sourceType: source.source.sourceType
    };
    const response = await addSource({ input });
    if (response.data.vacancy) {
      onDone();
    }
  }, [source]);
  return /* @__PURE__ */ jsxs103(
    "div",
    {
      className: "flex cursor-pointer items-start items-center justify-between hover:bg-gray-50",
      children: [
        /* @__PURE__ */ jsx147("div", { className: "text-primary-500 p-4", children: source.source.sourceName }),
        /* @__PURE__ */ jsx147("div", { className: "p-4", children: /* @__PURE__ */ jsx147(
          Button45,
          {
            color: "primary",
            disabled: isAddingSource,
            clicked: onAddSource,
            children: "Add"
          }
        ) })
      ]
    },
    source.source.sourceId
  );
};
var VacancyEditorTalentPools = ({ editRouteId }) => {
  const data = useVacancyEditRouteData(editRouteId);
  const query3 = useLazyLoadQuery24(
    queryDef22,
    { vacancyId: data.vacancy.vacancyId },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { vacancy } = query3;
  const employerSources = vacancy?.employerProfileSources || [];
  const vacancySources = vacancy?.vacancyProfileSources || [];
  const vacancyProfileSources = vacancySources.map((s4) => {
    const employerSource = employerSources.find(
      (es) => es.sourceId === s4.sourceId
    );
    return employerSource;
  }).filter(isNotNullOrUndefined5);
  const [isAdding, toggleIsAdding] = useToggle19();
  if (!vacancy) {
    return /* @__PURE__ */ jsx147(EdSkeleton37, {});
  }
  let sources = /* @__PURE__ */ jsx147("div", { className: "p-2 text-sm text-gray-900", children: "No TalentPools Configured" });
  if (vacancyProfileSources) {
    const profileSourceList = vacancyProfileSources.map((source) => {
      return /* @__PURE__ */ jsx147(
        VacancySource,
        {
          vacancyId: vacancy.vacancyId,
          source
        },
        source.sourceId
      );
    });
    sources = /* @__PURE__ */ jsx147("div", { className: "flex flex-col divide-y", children: profileSourceList });
  }
  let content = /* @__PURE__ */ jsx147("div", { className: "flex flex-col gap-4 px-4 py-2", children: sources });
  if (isAdding && vacancy) {
    content = /* @__PURE__ */ jsx147("div", { className: "flex flex-col gap-2 p-4", children: /* @__PURE__ */ jsx147(
      ProfileSourceList,
      {
        vacancy,
        sources: vacancy.employerProfileSources,
        onDone: toggleIsAdding
      }
    ) });
  }
  return /* @__PURE__ */ jsx147(Suspense44, { fallback: /* @__PURE__ */ jsx147(EdSkeleton37, {}), children: /* @__PURE__ */ jsxs103("div", { className: "m-auto flex flex-col gap-2 border bg-white p-2 shadow sm:rounded-lg lg:w-1/2 lg:p-4", children: [
    /* @__PURE__ */ jsx147("div", { className: "flex flex-col gap-2 p-2", children: /* @__PURE__ */ jsxs103("div", { className: "flex items-center justify-between gap-2 border-b p-2", children: [
      /* @__PURE__ */ jsx147("div", { className: "text-primary-500 px-2 py-4", children: /* @__PURE__ */ jsx147("h1", { children: "Searching Candidates In" }) }),
      /* @__PURE__ */ jsx147("div", { children: !isAdding && /* @__PURE__ */ jsx147(Button45, { color: "primary", clicked: toggleIsAdding, children: isAdding ? "Cancel" : "Add Source" }) })
    ] }) }),
    content,
    /* @__PURE__ */ jsx147(EdLink16, { name: "back", href: "../overview", children: /* @__PURE__ */ jsx147(Button45, { color: "primary", size: Size25.xl, children: "Back" }) })
  ] }) });
};

// src/vacancies/components/VacancyEditorOverview.tsx
import { jsx as jsx148 } from "react/jsx-runtime";
var VacancyEditorOverview = ({ editRouteId }) => {
  const data = useVacancyEditRouteData(editRouteId);
  const onNext = useCallback83(() => {
  }, []);
  const onPrevious = useCallback83(() => {
  }, []);
  const { vacancy } = data;
  if (!vacancy) {
    return /* @__PURE__ */ jsx148(EdSkeleton38, {});
  }
  return /* @__PURE__ */ jsx148(Suspense45, { fallback: /* @__PURE__ */ jsx148(EdSkeleton38, {}), children: /* @__PURE__ */ jsx148("div", { className: "w-full py-2", children: /* @__PURE__ */ jsx148("div", { className: "flex flex-wrap justify-between gap-2 md:p-4", children: /* @__PURE__ */ jsx148("div", { className: "flex-1 p-2", children: /* @__PURE__ */ jsx148(
    WizardContext.Provider,
    {
      value: {
        onNext,
        onPrevious
      },
      children: /* @__PURE__ */ jsx148(Outlet6, {})
    }
  ) }) }) }) });
};
var createVacancyEditOverviewRoutes = (editRouteId, environment, context) => {
  const routeId4 = `${editRouteId}-overview-root`;
  return [
    {
      path: "*",
      id: routeId4,
      element: /* @__PURE__ */ jsx148(VacancyLayout, { editRouteId }),
      errorElement: /* @__PURE__ */ jsx148(ErrorContainer8, {}),
      children: [
        {
          path: "overview/*",
          element: /* @__PURE__ */ jsx148(VacancyEditorOverviewReview, { editRouteId })
        },
        {
          path: "description/*",
          element: /* @__PURE__ */ jsx148(VacancyEditorDescription, { editRouteId })
        },
        {
          path: "details/*",
          element: /* @__PURE__ */ jsx148(VacancyEditorOverviewDetails, { editRouteId })
        },
        {
          path: "scoring/*",
          element: /* @__PURE__ */ jsx148(VacancyEditorOverviewScoring, { editRouteId })
        },
        {
          path: "forms/*",
          element: /* @__PURE__ */ jsx148(VacancyEditorForms, { editRouteId })
        },
        {
          path: "talent-pools/*",
          element: /* @__PURE__ */ jsx148(VacancyEditorTalentPools, { editRouteId })
        },
        {
          path: "documents/*",
          element: /* @__PURE__ */ jsx148(VacancyEditorDocuments, { editRouteId })
        },
        {
          path: "*",
          element: /* @__PURE__ */ jsx148(Navigate6, { to: "overview", replace: true })
        }
      ]
    }
  ];
};

// src/vacancies/components/VacancyEdit.tsx
import { jsx as jsx149 } from "react/jsx-runtime";
var queryDef23 = VacancyEditRouteQuery_graphql_default;
async function loader7(environment, params) {
  const code = params.vacancyCode;
  const vacancyCode = parseInt(code);
  return loadQuery11(environment, queryDef23, {
    vacancyCode
  });
}
function useVacancyEditRouteData(routeId4) {
  const queryRef3 = useRouteLoaderData8(
    routeId4
  );
  const data = usePreloadedQuery13(queryDef23, queryRef3);
  return data;
}
function requiresWizard(vacancy) {
  if (!vacancy) {
    return true;
  }
  if (vacancy.status === "OPEN") {
    return false;
  }
  if (!vacancy.publicDescriptionText || vacancy.publicDescriptionText === "") {
    return true;
  }
  if (!vacancy.rate || !vacancy.rate.payType) {
    return true;
  }
  if (!vacancy.locations || vacancy.locations.length === 0) {
    return true;
  }
  if (!vacancy.skillGroups || vacancy.skillGroups.length === 0) {
    return true;
  }
  if (!vacancy.editState.canPublish) {
    return true;
  }
  return false;
}
var VacancyLayout = ({ editRouteId }) => {
  const data = useVacancyEditRouteData(editRouteId);
  const { vacancy } = data;
  if (!vacancy) {
    return /* @__PURE__ */ jsx149(EdSkeleton39, {});
  }
  return /* @__PURE__ */ jsx149(Suspense46, { fallback: /* @__PURE__ */ jsx149(EdSkeleton39, {}), children: /* @__PURE__ */ jsx149(Outlet7, {}) });
};
var VacancyNav = ({ editRouteId }) => {
  const navigate = useNavigate17();
  const data = useVacancyEditRouteData(editRouteId);
  const { vacancy } = data;
  useEffect21(() => {
    if (!vacancy) {
      return;
    }
    if (requiresWizard(vacancy)) {
      navigate("wizard");
      return;
    }
    navigate("overview");
  }, [vacancy]);
  return /* @__PURE__ */ jsx149(EdSkeleton39, {});
};
var createVacancyEditRoutes = (parentRouteId, environment, context) => {
  return [
    {
      path: "*",
      id: `${parentRouteId}-root`,
      element: /* @__PURE__ */ jsx149(VacancyLayout, { editRouteId: parentRouteId }),
      errorElement: /* @__PURE__ */ jsx149(ErrorContainer9, {}),
      children: [
        {
          path: "wizard/*",
          element: /* @__PURE__ */ jsx149(Suspense46, { fallback: /* @__PURE__ */ jsx149(EdSkeleton39, {}), children: /* @__PURE__ */ jsx149("div", { className: "flex grow bg-gray-100", children: /* @__PURE__ */ jsx149("div", { className: "container mx-auto mb-20", children: /* @__PURE__ */ jsx149(Outlet7, {}) }) }) }),
          children: [
            {
              path: "description",
              element: /* @__PURE__ */ jsx149(VacancyWizardEditorDescription, { editRouteId: parentRouteId })
            },
            {
              path: "details",
              element: /* @__PURE__ */ jsx149(VacancyEditorWizardDetails, { editRouteId: parentRouteId })
            },
            {
              path: "scoring",
              element: /* @__PURE__ */ jsx149(VacancyEditorWizardScoring, { editRouteId: parentRouteId })
            },
            {
              path: "overview",
              element: /* @__PURE__ */ jsx149(VacancyEditorWizardReview, { editRouteId: parentRouteId })
            },
            {
              path: "forms",
              element: /* @__PURE__ */ jsx149(VacancyEditorForms, { editRouteId: parentRouteId })
            },
            {
              path: "talent-pools",
              element: /* @__PURE__ */ jsx149(VacancyEditorTalentPools, { editRouteId: parentRouteId })
            },
            {
              path: "documents",
              element: /* @__PURE__ */ jsx149(VacancyEditorDocuments, { editRouteId: parentRouteId })
            },
            {
              path: "*",
              element: /* @__PURE__ */ jsx149(Navigate7, { to: "description", replace: true })
            }
          ]
        },
        {
          path: "overview/*",
          element: /* @__PURE__ */ jsx149(VacancyEditorOverview, { editRouteId: parentRouteId }),
          children: createVacancyEditOverviewRoutes(
            parentRouteId,
            environment,
            context
          )
        },
        {
          path: "*",
          element: /* @__PURE__ */ jsx149(VacancyNav, { editRouteId: parentRouteId })
        }
      ]
    }
  ];
};

// src/vacancies/components/VacancyEditorDescription.tsx
import { Fragment as Fragment37, jsx as jsx150, jsxs as jsxs104 } from "react/jsx-runtime";
var vacancyEditorDescriptionSchema = object15({
  description: any2().array().min(2, "Please add more details to the description")
});
var queryDef24 = VacancyEditorDescriptionQuery_graphql_default;
var fragmentDef34 = VacancyEditorDescriptionFragment_vacancy_graphql_default;
var VacancyWizardEditorDescription = ({ editRouteId }) => {
  const data = useVacancyEditRouteData(editRouteId);
  const query3 = useLazyLoadQuery25(
    queryDef24,
    { vacancyId: data.vacancy.vacancyId },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const navigate = useNavigate18();
  const [save, isSaving, errors] = useSaveVacancyDescription();
  const onSaved = useCallback84(
    async (vacancyId, companyVsSkillWeight, skillGroups, form, editorState, vacancyEditState, publicDescriptionEditorState) => {
      const success = await save(
        vacancyId,
        companyVsSkillWeight,
        skillGroups,
        form,
        editorState,
        vacancyEditState,
        publicDescriptionEditorState
      );
      if (success) {
        navigate("../details");
      }
      return success;
    },
    [save]
  );
  const { vacancy } = query3;
  if (!vacancy) {
    return /* @__PURE__ */ jsx150(EdSkeleton40, {});
  }
  return /* @__PURE__ */ jsx150(Suspense47, { fallback: /* @__PURE__ */ jsx150(EdSkeleton40, {}), children: /* @__PURE__ */ jsxs104("div", { className: "flex w-full flex-col items-center gap-10 px-2 md:px-5", children: [
    /* @__PURE__ */ jsx150("div", { className: "w-9/12", children: /* @__PURE__ */ jsx150(VacancyEditorProgressBar, { step: "description" }) }),
    /* @__PURE__ */ jsx150("div", { className: "w-full", children: /* @__PURE__ */ jsx150(
      VacancyEditor,
      {
        fragmentRef: vacancy,
        vacancyId: vacancy.vacancyId,
        publicDescriptionEditorState: vacancy.publicDescriptionEditorState,
        publicDescriptionHtml: vacancy.publicDescriptionHtml,
        publicDescriptionText: vacancy.publicDescriptionText,
        profession: vacancy.profession,
        industryId: vacancy.industryId,
        industryName: vacancy.industryName,
        isBusy: isSaving,
        errors,
        onSaved,
        nextLabel: "Save & Next"
      }
    ) })
  ] }) });
};
var VacancyEditorDescription = ({
  editRouteId
}) => {
  const navigate = useNavigate18();
  const data = useVacancyEditRouteData(editRouteId);
  const query3 = useLazyLoadQuery25(
    queryDef24,
    { vacancyId: data.vacancy.vacancyId },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const [save, isSaving, errors] = useSaveVacancyDescription();
  const onSaved = useCallback84(
    async (vacancyId, companyVsSkillWeight, skillGroups, form, editorState, vacancyEditState, publicDescriptionEditorState) => {
      const success = await save(
        vacancyId,
        companyVsSkillWeight,
        skillGroups,
        form,
        editorState,
        vacancyEditState,
        publicDescriptionEditorState
      );
      navigate("../details");
      return success;
    },
    [navigate, save]
  );
  const { vacancy } = query3;
  if (!vacancy) {
    return /* @__PURE__ */ jsx150(EdSkeleton40, {});
  }
  return /* @__PURE__ */ jsx150(Suspense47, { fallback: /* @__PURE__ */ jsx150(EdSkeleton40, {}), children: /* @__PURE__ */ jsx150(
    VacancyEditor,
    {
      fragmentRef: vacancy,
      vacancyId: vacancy.vacancyId,
      publicDescriptionEditorState: vacancy.publicDescriptionEditorState,
      publicDescriptionHtml: vacancy.publicDescriptionHtml,
      publicDescriptionText: vacancy.publicDescriptionText,
      profession: vacancy.profession,
      industryId: vacancy.industryId,
      industryName: vacancy.industryName,
      isBusy: isSaving,
      errors,
      onSaved,
      nextLabel: "Save & Change"
    }
  ) });
};
var IndustryEditor = ({
  industryName,
  onChanged,
  showTitle = true
}) => {
  const [isEditing, setIsEditing] = useState55(!industryName);
  const [currentIndustry, setCurrentIndustry] = useState55(() => {
    return industryName;
  });
  const onIndustrySelected = useCallback84(
    (industry) => {
      setCurrentIndustry(industry.name);
      setIsEditing(false);
      onChanged(industry);
    },
    [setCurrentIndustry, setIsEditing, onChanged]
  );
  return /* @__PURE__ */ jsxs104("div", { className: "flex flex-col gap-2", children: [
    showTitle && /* @__PURE__ */ jsx150("div", { className: "text-primary-500 text-lg font-medium", children: "Industry" }),
    isEditing ? /* @__PURE__ */ jsx150(IndustrySearchContainer, { onSearchCompleted: onIndustrySelected }) : /* @__PURE__ */ jsxs104("div", { className: "flex flex-wrap gap-2", children: [
      currentIndustry && /* @__PURE__ */ jsx150("div", { children: currentIndustry }),
      /* @__PURE__ */ jsx150(LinkButton4, { clicked: () => setIsEditing(true), children: "Change" })
    ] })
  ] });
};
var ProfessionEditor = ({
  profession,
  onChanged
}) => {
  const [isEditing, setIsEditing] = useState55(() => {
    return !profession;
  });
  const [currentProfession, setCurrentProfession] = useState55(() => {
    return profession;
  });
  const onProfessionSelected = useCallback84(
    (profession2) => {
      setCurrentProfession(profession2.name);
      onChanged(profession2.name);
      setIsEditing(false);
    },
    [setCurrentProfession]
  );
  return /* @__PURE__ */ jsxs104("div", { className: "flex flex-col gap-2", children: [
    /* @__PURE__ */ jsx150("div", { className: "text-primary-500 text-lg font-medium", children: "Profession" }),
    isEditing ? /* @__PURE__ */ jsx150(ProfessionSearchContainer, { onSearchCompleted: onProfessionSelected }) : /* @__PURE__ */ jsxs104("div", { className: "flex flex-wrap gap-2", children: [
      currentProfession && /* @__PURE__ */ jsx150("div", { children: currentProfession }),
      /* @__PURE__ */ jsx150(LinkButton4, { clicked: () => setIsEditing(true), children: "Edit" })
    ] })
  ] });
};
var VacancyNameEditor = ({
  vacancyName: vacancyName2,
  onChanged
}) => {
  const [isEditing, setIsEditing] = useState55(() => {
    return !vacancyName2;
  });
  const [currentVacancyName, setCurrentVacancyName] = useState55(() => {
    return vacancyName2;
  });
  const onVacancyChanged = useCallback84(
    (value) => {
      setCurrentVacancyName(value);
      onChanged(value);
    },
    [onChanged]
  );
  return /* @__PURE__ */ jsxs104("div", { className: "flex flex-col gap-2", children: [
    /* @__PURE__ */ jsx150("div", { className: "text-primary-500 text-lg font-medium", children: "Vacancy Name" }),
    isEditing ? /* @__PURE__ */ jsx150(
      Input12,
      {
        value: currentVacancyName || "",
        onChange: (e4) => onVacancyChanged(e4.currentTarget.value)
      }
    ) : /* @__PURE__ */ jsxs104("div", { className: "flex flex-wrap gap-2", children: [
      currentVacancyName && /* @__PURE__ */ jsx150("div", { children: currentVacancyName }),
      /* @__PURE__ */ jsx150(LinkButton4, { clicked: () => setIsEditing(true), children: "Edit" })
    ] })
  ] });
};
function useSaveVacancyDescription() {
  const [errors, setErrors] = useState55({});
  const [update, updateInFlight] = useVacancyUpdateScoring();
  const [updateDescription, isUpdateDescription] = useVacancyUpdateDescription();
  const isBusy = updateInFlight || isUpdateDescription;
  const onSave = useCallback84(
    async (vacancyId, companyVsSkillWeight, skillGroups, form, editorState, vacancyEditState, publicDescriptionEditorState) => {
      await update({
        input: {
          clientMutationId: createClientMutationId39(),
          relevantExperience: {
            durationAmount: form.relevantExperience.durationAmount || 0,
            durationType: form.relevantExperience.durationType || "YEARS"
          },
          relevantRecency: {
            durationAmount: form.relevantRecency.durationAmount || 0,
            durationType: form.relevantRecency.durationType || "YEARS"
          },
          industryExperience: {
            durationAmount: form.industryExperience.durationAmount || 0,
            durationType: form.industryExperience.durationType || "YEARS"
          },
          industryRecency: {
            durationAmount: form.industryRecency.durationAmount || 0,
            durationType: form.industryRecency.durationType || "YEARS"
          },
          companyVsSkillWeight,
          vacancyId,
          skillGroups: deserializeSkillGroups(skillGroups)
        }
      });
      try {
        vacancyEditorDescriptionSchema.parse({
          profession: vacancyEditState.profession,
          industry: vacancyEditState.industryName,
          description: editorState
        });
        if (publicDescriptionEditorState === JSON.stringify(editorState)) {
          return true;
        }
        const response = await updateDescription({
          input: {
            vacancyId,
            name: vacancyEditState.vacancyName,
            description: serializeEditorStateToHtml2(editorState),
            editorState: JSON.stringify(editorState),
            industryId: vacancyEditState.industryId,
            industryName: vacancyEditState.industryName,
            profession: vacancyEditState.profession,
            clientMutationId: createClientMutationId39()
          }
        });
        if (response.result.vacancy) {
          return true;
        } else {
          return false;
        }
      } catch (error) {
        setErrors(
          error.issues.reduce((acc, current) => {
            acc[current.path] = current.message;
            return acc;
          }, {})
        );
        return false;
      }
    },
    [update, updateDescription]
  );
  return [onSave, isBusy, errors];
}
var contentEditorPlaceHolder = `
Example Job Description Layout:

About Company
-------------
Myn is a digital outsourced workforce platform profiding a full life cycle of services; From search and hire, to pay and benefirst, cost saving and value enhancing for the employer and an efficient low-cost payroll system with benefirst to the contingent worker.

Job Responsibilities
--------------------
\u2022 Report to the Head of Engineering
\u2022 Work with the team to design and implement new features
\u2022 Maintain and improve the performance of existing software

Job Requirements
----------------
\u2022 Bachelor's degree in Computer Science or related field
\u2022 5+ years of experience in software development
\u2022 Experience in developing web applications using at least one popular web framework (React, Angular, Vue, etc.)

Company Benefits
----------------
\u2022 Flexible working hours
\u2022 Medical insurance
              
                        `.trim();
var VacancyEditor = ({
  fragmentRef,
  vacancyId,
  publicDescriptionEditorState,
  publicDescriptionHtml,
  publicDescriptionText,
  profession,
  industryId,
  industryName,
  isBusy,
  errors,
  onSaved,
  onPrevious,
  nextLabel
}) => {
  const vacancy = useFragment41(fragmentDef34, fragmentRef);
  const [isDebuggingEditorState, setIsDebuggingEditorState] = useState55(false);
  const isHtml = useMemo25(() => {
    if (publicDescriptionEditorState) {
      return false;
    }
    return isHTMLDocument(publicDescriptionHtml || "");
  }, [publicDescriptionEditorState, publicDescriptionHtml]);
  const [editorState, setEditorState] = useEditorState(
    publicDescriptionEditorState,
    publicDescriptionText
  );
  const [shouldTriggerSkillsRegeneration, setShouldTriggerSkillsRegeneration] = useState55(false);
  const [vacancyEditState, setVacancyEditState] = useState55(
    () => {
      return {
        vacancyId,
        vacancyName: vacancy.name,
        publicDescriptionEditorState,
        publicDescriptionHtml,
        publicDescriptionText,
        profession,
        industryId,
        industryName
      };
    }
  );
  const onProfessionChanged = useCallback84(
    (profession2) => {
      setVacancyEditState((current) => ({
        ...current,
        profession: profession2
      }));
      setShouldTriggerSkillsRegeneration(true);
    },
    [setVacancyEditState]
  );
  const onIndustryChanged = useCallback84(
    (industry) => {
      setVacancyEditState((current) => ({
        ...current,
        industryId: industry.industryId,
        industryName: industry.name
      }));
    },
    [setVacancyEditState]
  );
  const onEditorChanged = useCallback84(
    (data) => {
      setEditorState(data);
      setShouldTriggerSkillsRegeneration(true);
    },
    [setEditorState]
  );
  const [form, setForm] = useState55(() => ({
    relevantExperience: vacancy.scoringConfig.relevantExperience,
    relevantRecency: vacancy.scoringConfig.relevantRecency,
    industryExperience: vacancy.scoringConfig.industryExperience,
    industryRecency: vacancy.scoringConfig.industryRecency
  }));
  const [
    industryRequiredExperienceEditable,
    toggleIndustryRequiredExperienceEditable
  ] = useToggle20(false);
  const [
    professionRequiredExperienceEditable,
    toggleProfessionRequiredExperienceEditable
  ] = useToggle20(false);
  const onSave = useCallback84(async () => {
    await onSaved(
      vacancyId,
      vacancy.companyVsSkillWeight,
      vacancy.skillGroups,
      form,
      editorState,
      vacancyEditState,
      publicDescriptionEditorState
    );
  }, [
    onSaved,
    vacancyId,
    vacancy.companyVsSkillWeight,
    vacancy.skillGroups,
    form,
    editorState,
    vacancyEditState,
    publicDescriptionEditorState
  ]);
  return /* @__PURE__ */ jsxs104(Suspense47, { fallback: /* @__PURE__ */ jsx150(EdSkeleton40, {}), children: [
    /* @__PURE__ */ jsxs104("div", { className: "flex flex-col gap-2", children: [
      /* @__PURE__ */ jsx150(EditContainer3, { children: /* @__PURE__ */ jsx150(
        VacancyNameEditor,
        {
          vacancyName: vacancyEditState.vacancyName,
          onChanged: (vacancyName2) => setVacancyEditState({
            ...vacancyEditState,
            vacancyName: vacancyName2
          })
        }
      ) }),
      /* @__PURE__ */ jsxs104(EditContainer3, { children: [
        /* @__PURE__ */ jsxs104("div", { className: "mb-3 flex flex-row items-center justify-between gap-2 border-b py-3", children: [
          /* @__PURE__ */ jsx150("div", { className: "text-primary-500 text-lg font-medium", children: "Description" }),
          /* @__PURE__ */ jsx150("div", { className: "flex flex-row items-center gap-2" })
        ] }),
        isDebuggingEditorState && /* @__PURE__ */ jsx150("pre", { className: "whitespace-pre-wrap", children: JSON.stringify(editorState, null, 2) }),
        !isDebuggingEditorState && editorState && /* @__PURE__ */ jsx150(
          ContentEditor,
          {
            placeholder: contentEditorPlaceHolder,
            state: editorState,
            isBusy,
            onChanged: onEditorChanged
          }
        ),
        /* @__PURE__ */ jsx150(Error7, { children: errors["description"] || "" })
      ] }),
      /* @__PURE__ */ jsxs104("div", { className: "flex flex-col gap-2 md:flex-row", children: [
        /* @__PURE__ */ jsxs104(EditContainer3, { children: [
          /* @__PURE__ */ jsx150(
            IndustryEditor,
            {
              industryId: vacancyEditState.industryId,
              industryName: vacancyEditState.industryName,
              onChanged: onIndustryChanged
            }
          ),
          /* @__PURE__ */ jsx150(Error7, { children: errors["industry"] || "" }),
          /* @__PURE__ */ jsxs104("div", { className: "mt-4 flex flex-row items-center gap-5", children: [
            /* @__PURE__ */ jsxs104("div", { className: "flex flex-row items-baseline gap-2", children: [
              /* @__PURE__ */ jsxs104("h2", { className: "flex gap-1", children: [
                /* @__PURE__ */ jsx150("div", { children: "Required Experience:" }),
                !industryRequiredExperienceEditable && /* @__PURE__ */ jsxs104("div", { children: [
                  vacancy.scoringConfig.industryExperience.durationAmount,
                  " ",
                  pluralizeDuration(
                    vacancy.scoringConfig.industryExperience.durationType,
                    vacancy.scoringConfig.industryExperience.durationAmount
                  )
                ] })
              ] }),
              !industryRequiredExperienceEditable && /* @__PURE__ */ jsx150(Fragment37, { children: /* @__PURE__ */ jsx150(
                "button",
                {
                  onClick: toggleIndustryRequiredExperienceEditable,
                  className: "text-xs text-blue-500 hover:text-blue-700",
                  children: "Edit"
                }
              ) })
            ] }),
            industryRequiredExperienceEditable && /* @__PURE__ */ jsx150(
              DurationEditor,
              {
                amount: vacancy.scoringConfig.industryExperience,
                recency: vacancy.scoringConfig.industryRecency,
                onChanged: (e4) => {
                  setForm({
                    ...form,
                    industryExperience: e4.amount,
                    industryRecency: e4.recency
                  });
                }
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ jsxs104(EditContainer3, { children: [
          /* @__PURE__ */ jsx150(
            ProfessionEditor,
            {
              profession: vacancyEditState.profession,
              onChanged: onProfessionChanged
            }
          ),
          /* @__PURE__ */ jsx150(Error7, { children: errors["profession"] || "" }),
          /* @__PURE__ */ jsxs104("div", { className: "mt-4 flex flex-row items-center gap-5", children: [
            /* @__PURE__ */ jsxs104("div", { className: "flex flex-row items-baseline gap-2", children: [
              /* @__PURE__ */ jsxs104("h2", { className: "flex gap-1", children: [
                /* @__PURE__ */ jsx150("div", { children: "Required Experience:" }),
                !professionRequiredExperienceEditable && /* @__PURE__ */ jsxs104("div", { children: [
                  vacancy.scoringConfig.relevantExperience.durationAmount,
                  " ",
                  pluralizeDuration(
                    vacancy.scoringConfig.relevantExperience.durationType,
                    vacancy.scoringConfig.relevantExperience.durationAmount
                  )
                ] })
              ] }),
              !professionRequiredExperienceEditable && /* @__PURE__ */ jsx150(Fragment37, { children: /* @__PURE__ */ jsx150(
                "button",
                {
                  onClick: toggleProfessionRequiredExperienceEditable,
                  className: "text-xs text-blue-500 hover:text-blue-700",
                  children: "Edit"
                }
              ) })
            ] }),
            professionRequiredExperienceEditable && /* @__PURE__ */ jsx150(
              DurationEditor,
              {
                amount: vacancy.scoringConfig.relevantExperience,
                recency: vacancy.scoringConfig.relevantRecency,
                onChanged: (e4) => {
                  setForm({
                    ...form,
                    relevantExperience: e4.amount,
                    relevantRecency: e4.recency
                  });
                }
              }
            )
          ] })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ jsx150("div", { className: "mt-5 flex w-full justify-end", children: /* @__PURE__ */ jsx150("div", { children: /* @__PURE__ */ jsx150(Button46, { color: "primary", clicked: onSave, size: Size26.xl, children: nextLabel }) }) })
  ] });
};
var EditContainer3 = ({ title, children, collapsable, defaultCollapsed = false }) => {
  const [isCollapsed, toggleCollapse] = useToggle20(defaultCollapsed);
  return /* @__PURE__ */ jsxs104("div", { className: "flex w-full grow flex-col gap-2 rounded-md border-b bg-white px-4 py-5 sm:p-4 sm:shadow", children: [
    title && /* @__PURE__ */ jsxs104("div", { className: "flex w-full items-center justify-between", children: [
      /* @__PURE__ */ jsx150("div", { className: "text-primary-500 text-lg font-medium", children: title }),
      collapsable && /* @__PURE__ */ jsx150("div", { onClick: toggleCollapse, children: isCollapsed ? /* @__PURE__ */ jsx150(ChevronDownIcon, { className: "h-4 w-4" }) : /* @__PURE__ */ jsx150(ChevronUpIcon, { className: "h-4 w-4" }) })
    ] }),
    !isCollapsed && /* @__PURE__ */ jsx150("div", { children })
  ] });
};

// src/vacancies/components/VacancyCreateContainer.tsx
import { Fragment as Fragment38, jsx as jsx151, jsxs as jsxs105 } from "react/jsx-runtime";
var schema2 = vacancyEditorDescriptionSchema.extend({
  "project-select": object16({
    id: string15({ required_error: "Project Id is required" }),
    name: string15({ required_error: "Project is required" })
  }),
  vacancyEditState: object16({
    vacancyName: string15({ required_error: "Vacancy name is required" }).min(
      6,
      "Vacancy name must be at least 6 characters"
    )
  })
});
var mutation = VacancyCreateContainerMutation_graphql_default;
var VacancyCreateContainer = ({
  employerId,
  projectId,
  projectName
}) => {
  const navigate = useNavigate19();
  const [commitMutation4, isMutationInFlight] = useMutation14(mutation);
  const [editorState, setEditorState] = useEditorState2("", "");
  const [
    industryRequiredExperienceEditable,
    toggleIndustryRequiredExperienceEditable
  ] = useToggle21(false);
  const [
    professionRequiredExperienceEditable,
    toggleProfessionRequiredExperienceEditable
  ] = useToggle21(false);
  const {
    handleSubmit,
    control,
    watch,
    getValues,
    setValue,
    formState: { errors: formErrors }
  } = useForm15({
    resolver: zodResolver15(schema2),
    defaultValues: {
      "project-select": projectId && projectName ? {
        id: projectId,
        name: projectName
      } : {},
      profession: "",
      description: [],
      form: {
        industryExperience: { durationAmount: 0, durationType: "MONTHS" },
        industryRecency: { durationAmount: 10, durationType: "YEARS" },
        relevantExperience: { durationAmount: 1, durationType: "MONTHS" },
        relevantRecency: { durationAmount: 3, durationType: "YEARS" }
      },
      vacancyEditState: {
        vacancyId: "",
        vacancyName: "",
        publicDescriptionEditorState: "",
        publicDescriptionHtml: "",
        publicDescriptionText: "",
        profession: "",
        industryId: 0,
        industryName: ""
      }
    }
  });
  const onSubmit = handleSubmit((data) => {
    const project = getValues("project-select");
    const form = getValues("form");
    if (!project.id) {
      return;
    }
    commitMutation4({
      variables: {
        input: {
          name: data?.["vacancyEditState"]?.vacancyName,
          projectId: project.id,
          clientMutationId: createClientMutationId40(),
          isTemplate: false
        }
      },
      onCompleted(response) {
        const vacancyData = response.recruitVacancyDraft.vacancy?.node;
        setValue("vacancyEditState", {
          ...getValues("vacancyEditState"),
          vacancyId: vacancyData?.vacancyId || ""
        });
        onSaved(
          vacancyData?.code,
          vacancyData?.vacancyId || "",
          vacancyData?.companyVsSkillWeight || 0,
          vacancyData?.skillGroups || [],
          form,
          editorState,
          data?.["vacancyEditState"],
          vacancyData?.publicDescriptionEditorState
        );
      }
    });
  });
  const [save, isSaving, errors] = useSaveVacancyDescription();
  const onSaved = useCallback85(
    async (code, vacancyId, companyVsSkillWeight, skillGroups, form, editorState2, vacancyEditState, publicDescriptionEditorState) => {
      const success = await save(
        vacancyId,
        companyVsSkillWeight,
        skillGroups,
        form,
        editorState2,
        vacancyEditState,
        publicDescriptionEditorState
      );
      if (success) {
        navigate(`../view/${code}/edit/wizard/details`);
      }
      return success;
    },
    [save]
  );
  watch();
  useEffect23(() => {
    const subscription = watch(
      (value, { name, type }) => console.log(value, name, type)
    );
    return () => subscription.unsubscribe();
  }, [watch]);
  return /* @__PURE__ */ jsx151(Suspense48, { fallback: /* @__PURE__ */ jsx151(EdSkeleton41, {}), children: /* @__PURE__ */ jsx151("div", { className: "flex grow bg-gray-100", children: /* @__PURE__ */ jsx151("div", { className: "container mx-auto mb-20", children: /* @__PURE__ */ jsxs105("div", { className: "flex w-full flex-col items-center gap-10 px-2 md:px-5", children: [
    /* @__PURE__ */ jsx151("div", { className: "w-9/12", children: /* @__PURE__ */ jsx151(VacancyEditorProgressBar, { step: "description" }) }),
    /* @__PURE__ */ jsx151("div", { className: "w-full", children: /* @__PURE__ */ jsxs105("div", { className: "flex flex-col gap-2", children: [
      /* @__PURE__ */ jsxs105("div", { className: "flex flex-col gap-2 md:flex-row", children: [
        /* @__PURE__ */ jsxs105(EditContainer3, { children: [
          /* @__PURE__ */ jsx151(
            VacancyNameEditor,
            {
              vacancyName: getValues("vacancyEditState").vacancyName,
              onChanged: (vacancyName2) => {
                setValue("vacancyEditState", {
                  ...getValues("vacancyEditState"),
                  vacancyName: vacancyName2
                });
              }
            }
          ),
          formErrors?.["vacancyEditState"]?.vacancyName && /* @__PURE__ */ jsx151("div", { className: "mt-2 text-sm text-red-400", children: formErrors?.["vacancyEditState"]?.vacancyName?.message?.toString() })
        ] }),
        /* @__PURE__ */ jsx151(EditContainer3, { children: /* @__PURE__ */ jsxs105("div", { className: "flex flex-col gap-2", children: [
          /* @__PURE__ */ jsx151("div", { className: "text-primary-500 text-lg font-medium", children: "Project" }),
          /* @__PURE__ */ jsx151(
            ProjectSearchBoxInput,
            {
              employerId,
              control,
              name: "project-select",
              placeholder: "Select project"
            }
          ),
          formErrors?.["project-select"] && /* @__PURE__ */ jsx151("div", { className: "mt-2 text-sm text-red-400", children: formErrors?.["project-select"]?.name?.message?.toString() })
        ] }) })
      ] }),
      /* @__PURE__ */ jsxs105(EditContainer3, { children: [
        /* @__PURE__ */ jsxs105("div", { className: "mb-3 flex flex-row items-center justify-between gap-2 border-b py-3", children: [
          /* @__PURE__ */ jsx151("div", { className: "text-primary-500 text-lg font-medium", children: "Description" }),
          /* @__PURE__ */ jsx151("div", { className: "flex flex-row items-center gap-2" })
        ] }),
        /* @__PURE__ */ jsx151(
          ContentEditor2,
          {
            placeholder: contentEditorPlaceHolder,
            state: editorState,
            isBusy: false,
            onChanged: (data) => {
              setValue("description", data);
              setEditorState(data);
            }
          }
        ),
        errors["description"] ? /* @__PURE__ */ jsx151(Error8, { children: errors["description"] || "" }) : formErrors?.["description"] && /* @__PURE__ */ jsx151("div", { className: "mt-2 text-sm text-red-400", children: formErrors?.["description"]?.message?.toString() })
      ] }),
      /* @__PURE__ */ jsxs105("div", { className: "flex flex-col gap-2 lg:flex-row", children: [
        /* @__PURE__ */ jsxs105(EditContainer3, { children: [
          /* @__PURE__ */ jsx151(
            IndustryEditor,
            {
              industryId: 0,
              industryName: getValues("vacancyEditState").industryName,
              onChanged: (industry) => {
                setValue("vacancyEditState", {
                  ...getValues("vacancyEditState"),
                  industryId: industry.industryId,
                  industryName: industry.name
                });
              }
            }
          ),
          errors["industry"] ? /* @__PURE__ */ jsx151(Error8, { children: errors["industry"] || "" }) : formErrors?.["vacancyEditState"]?.industryName && /* @__PURE__ */ jsx151("div", { className: "mt-2 text-sm text-red-400", children: formErrors?.["vacancyEditState"].industryName?.message?.toString() }),
          /* @__PURE__ */ jsxs105("div", { className: "mt-4 flex flex-row items-center gap-5", children: [
            /* @__PURE__ */ jsxs105("div", { className: "flex flex-row items-baseline gap-2", children: [
              /* @__PURE__ */ jsxs105("h2", { className: "flex gap-1", children: [
                /* @__PURE__ */ jsx151("div", { children: "Required Experience:" }),
                !industryRequiredExperienceEditable && /* @__PURE__ */ jsxs105("div", { children: [
                  getValues("form")?.industryExperience.durationAmount,
                  " ",
                  getValues(
                    "form"
                  ).industryExperience.durationType?.toLowerCase()
                ] })
              ] }),
              !industryRequiredExperienceEditable && /* @__PURE__ */ jsx151(Fragment38, { children: /* @__PURE__ */ jsx151(
                "button",
                {
                  onClick: toggleIndustryRequiredExperienceEditable,
                  className: "text-xs text-blue-500 hover:text-blue-700",
                  children: "Edit"
                }
              ) })
            ] }),
            industryRequiredExperienceEditable && /* @__PURE__ */ jsx151(
              DurationEditor,
              {
                amount: {
                  durationAmount: 0,
                  durationType: "MONTHS"
                },
                recency: {
                  durationAmount: 10,
                  durationType: "YEARS"
                },
                onChanged: (e4) => {
                  setValue("form", {
                    ...getValues("form"),
                    industryExperience: e4.amount,
                    industryRecency: e4.recency
                  });
                }
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ jsxs105(EditContainer3, { children: [
          /* @__PURE__ */ jsx151(
            ProfessionEditor,
            {
              profession: getValues("vacancyEditState").profession,
              onChanged: (profession) => setValue("vacancyEditState", {
                ...getValues("vacancyEditState"),
                profession
              })
            }
          ),
          errors["profession"] ? /* @__PURE__ */ jsx151(Error8, { children: errors["profession"] || "" }) : formErrors?.["vacancyEditState"]?.profession && /* @__PURE__ */ jsx151("div", { className: "mt-2 text-sm text-red-400", children: formErrors?.["vacancyEditState"]?.profession?.message?.toString() }),
          /* @__PURE__ */ jsxs105("div", { className: "mt-4 flex flex-row items-center gap-5", children: [
            /* @__PURE__ */ jsxs105("div", { className: "flex flex-row items-baseline gap-2", children: [
              /* @__PURE__ */ jsxs105("h2", { className: "flex gap-1", children: [
                /* @__PURE__ */ jsx151("div", { children: "Required Experience:" }),
                !professionRequiredExperienceEditable && /* @__PURE__ */ jsxs105("div", { children: [
                  getValues("form")?.relevantExperience.durationAmount,
                  " ",
                  getValues(
                    "form"
                  ).relevantExperience.durationType?.toLowerCase()
                ] })
              ] }),
              !professionRequiredExperienceEditable && /* @__PURE__ */ jsx151(Fragment38, { children: /* @__PURE__ */ jsx151(
                "button",
                {
                  onClick: toggleProfessionRequiredExperienceEditable,
                  className: "text-xs text-blue-500 hover:text-blue-700",
                  children: "Edit"
                }
              ) })
            ] }),
            professionRequiredExperienceEditable && /* @__PURE__ */ jsx151(
              DurationEditor,
              {
                amount: {
                  durationAmount: 1,
                  durationType: "MONTHS"
                },
                recency: {
                  durationAmount: 3,
                  durationType: "YEARS"
                },
                onChanged: (e4) => {
                  setValue("form", {
                    ...getValues("form"),
                    relevantExperience: e4.amount,
                    relevantRecency: e4.recency
                  });
                }
              }
            )
          ] })
        ] })
      ] }),
      /* @__PURE__ */ jsx151("div", { className: "mt-5 flex w-full justify-end", children: /* @__PURE__ */ jsx151("div", { children: /* @__PURE__ */ jsxs105(ButtonList12, { children: [
        /* @__PURE__ */ jsx151("div", { children: /* @__PURE__ */ jsx151(
          Button47,
          {
            color: "primary",
            disabled: isMutationInFlight || isSaving,
            clicked: onSubmit,
            size: Size27.xl,
            children: "Save & Next"
          }
        ) }),
        /* @__PURE__ */ jsx151("div", { children: /* @__PURE__ */ jsx151(
          Button47,
          {
            color: "gray",
            disabled: isMutationInFlight || isSaving,
            clicked: () => navigate("/employers/app/vacancies/list"),
            size: Size27.xl,
            children: "Cancel"
          }
        ) })
      ] }) }) })
    ] }) })
  ] }) }) }) });
};

// src/vacancies/components/VacancyRoutes.tsx
import { Suspense as Suspense74 } from "react";
import { Link as Link12 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary5 } from "react-error-boundary";
import { Navigate as Navigate9 } from "react-router-dom";
import {
  BreadcrumbLink as BreadcrumbLink6,
  ErrorContainer as ErrorContainer11,
  ListLayoutMobileList,
  Loading as Loading6
} from "shared-ui";
import { ErrorBoundaryFallback as ErrorBoundaryFallback4, OutletRoute as OutletRoute3 } from "app-core";

// src/recommendations/candidates/components/AvailableInList.tsx
import { useCallback as useCallback86 } from "react";
import { ListDirection as ListDirection3, RadioList as RadioList7 } from "shared-ui";
import { jsx as jsx153 } from "react/jsx-runtime";
var quickMonthsList = [
  {
    id: "1",
    label: "1 Month"
  },
  {
    id: "3",
    label: "3 Months"
  },
  {
    id: "6",
    label: "6 Months"
  },
  {
    id: "12",
    label: "1 Year +"
  }
];
var AvailableInList = ({ disabled, onChanged }) => {
  const onValueChanged = useCallback86((value) => {
    const months = parseInt(value.id);
    onChanged(months);
  }, []);
  return /* @__PURE__ */ jsx153(
    RadioList7,
    {
      list: quickMonthsList,
      disabled,
      direction: ListDirection3.Vertical,
      onChange: onValueChanged
    }
  );
};

// src/recommendations/candidates/components/__generated__/PublicRecommendationLayoutQuery.graphql.ts
var node178 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "recommendationId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "token"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "recommendationId",
      "variableName": "recommendationId"
    },
    {
      "kind": "Variable",
      "name": "token",
      "variableName": "token"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "recruitRecommendationId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateId",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v7 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationType",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationAmount",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "PublicRecommendationLayoutQuery",
      "selections": [
        {
          "alias": "recommendation",
          "args": v1,
          "concreteType": "RecruitRecommendation",
          "kind": "LinkedField",
          "name": "recruitRecommendationPublicById",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": "Vacancy",
              "kind": "LinkedField",
              "name": "vacancy",
              "plural": false,
              "selections": [
                v5,
                v6
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "RecommendationContainer_recommendation"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "RecommendationHeader_recommendation"
            },
            v7
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "PublicRecommendationLayoutQuery",
      "selections": [
        {
          "alias": "recommendation",
          "args": v1,
          "concreteType": "RecruitRecommendation",
          "kind": "LinkedField",
          "name": "recruitRecommendationPublicById",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": "Vacancy",
              "kind": "LinkedField",
              "name": "vacancy",
              "plural": false,
              "selections": [
                v5,
                v6,
                v23,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "publicDescriptionHtml",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SkillGroup",
                  "kind": "LinkedField",
                  "name": "skillGroups",
                  "plural": true,
                  "selections": [
                    v23,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "skillGroupId",
                      "storageKey": null
                    },
                    v5,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "SkillGroupTerm",
                      "kind": "LinkedField",
                      "name": "terms",
                      "plural": true,
                      "selections": [
                        v5,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isSkill",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Duration",
                      "kind": "LinkedField",
                      "name": "recency",
                      "plural": false,
                      "selections": [
                        v8,
                        v9
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isRequired",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "weight",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Duration",
                      "kind": "LinkedField",
                      "name": "experience",
                      "plural": false,
                      "selections": [
                        v9,
                        v8
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "LocationCriteria",
                  "kind": "LinkedField",
                  "name": "locations",
                  "plural": true,
                  "selections": [
                    v5,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "state",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "countryCode",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "countryName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "latitude",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "longitude",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "radius",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "entireCountry",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "employerLogoUrl",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "expiresAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "VacancyDates",
                  "kind": "LinkedField",
                  "name": "dates",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "startDate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "durationCode",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "durationDescription",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "startAsap",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "VacancyRate",
                  "kind": "LinkedField",
                  "name": "rate",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "max",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "min",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currencyCode",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "payType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currencyCountry",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isPrivate",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedOn",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "currentStatus",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "vacancyName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "currentDecision",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "declineReason",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasGivenAvailabilityReason",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "availableInMonths",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasDeclined",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "declinedOn",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "declinePreferredLocation",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "declinePreferredRateType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "declinePreferredRate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitSkillTag",
              "kind": "LinkedField",
              "name": "feedbackSkills",
              "plural": true,
              "selections": [
                v23,
                v5
              ],
              "storageKey": null
            },
            v7
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "0ef8391ec7f493b6d2e3941552a0a748",
      "id": null,
      "metadata": {},
      "name": "PublicRecommendationLayoutQuery",
      "operationKind": "query",
      "text": "query PublicRecommendationLayoutQuery(\n  $recommendationId: UUID!\n  $token: UUID!\n) {\n  recommendation: recruitRecommendationPublicById(recommendationId: $recommendationId, token: $token) {\n    id\n    recruitRecommendationId\n    candidateId\n    vacancy {\n      name\n      code\n      id\n    }\n    ...RecommendationContainer_recommendation\n    ...RecommendationHeader_recommendation\n  }\n}\n\nfragment RecommendationContainer_recommendation on RecruitRecommendation {\n  id\n  recruitRecommendationId\n  updatedOn\n  currentStatus\n  vacancyName\n  vacancy {\n    code\n    id\n  }\n  ...RecommendationWorkflowAppliedContainer_recommendation\n  ...RecommendationWorkflowDeclinedNotAvailable_recommendation\n  ...RecommendationWorkflowDeclined_recommendation\n  ...RecommendationNoDecision_recommendation\n  ...RecommendationVacancyInfo_recommendation\n}\n\nfragment RecommendationHeader_recommendation on RecruitRecommendation {\n  id\n  vacancy {\n    name\n    code\n    id\n  }\n}\n\nfragment RecommendationNoDecision_recommendation on RecruitRecommendation {\n  id\n  recruitRecommendationId\n}\n\nfragment RecommendationVacancyInfo_recommendation on RecruitRecommendation {\n  id\n  recruitRecommendationId\n  vacancy {\n    name\n    code\n    publicDescriptionHtml\n    skillGroups {\n      id\n      skillGroupId\n      name\n      terms {\n        name\n        isSkill\n      }\n      recency {\n        durationType\n        durationAmount\n      }\n      isRequired\n      weight\n      experience {\n        durationAmount\n        durationType\n      }\n    }\n    locations {\n      name\n      state\n      countryCode\n      countryName\n      latitude\n      longitude\n      radius\n      entireCountry\n    }\n    employerLogoUrl\n    expiresAt\n    dates {\n      startDate\n      durationCode\n      durationDescription\n      startAsap\n    }\n    rate {\n      max\n      min\n      currencyCode\n      payType\n      currencyCountry\n      isPrivate\n    }\n    id\n  }\n}\n\nfragment RecommendationWorkflowAppliedContainer_recommendation on RecruitRecommendation {\n  id\n  recruitRecommendationId\n  currentStatus\n  ...RecommendationWorkflowChange_recommendation\n}\n\nfragment RecommendationWorkflowChange_recommendation on RecruitRecommendation {\n  id\n  recruitRecommendationId\n  currentStatus\n  currentDecision\n  declineReason\n}\n\nfragment RecommendationWorkflowDeclineReason_recommendation on RecruitRecommendation {\n  id\n  recruitRecommendationId\n  declineReason\n}\n\nfragment RecommendationWorkflowDeclinedNoReason_recommendation on RecruitRecommendation {\n  id\n  recruitRecommendationId\n  declineReason\n  ...RecommendationWorkflowDeclineReason_recommendation\n}\n\nfragment RecommendationWorkflowDeclinedNotAvailable_recommendation on RecruitRecommendation {\n  recruitRecommendationId\n  hasGivenAvailabilityReason\n  availableInMonths\n}\n\nfragment RecommendationWorkflowDeclinedUnsuitableLocation_recommendation on RecruitRecommendation {\n  recruitRecommendationId\n  declinePreferredLocation\n}\n\nfragment RecommendationWorkflowDeclinedUnsuitableRate_recommendation on RecruitRecommendation {\n  recruitRecommendationId\n  declinePreferredRate\n  declinePreferredRateType\n}\n\nfragment RecommendationWorkflowDeclinedUnsuitableSkills_recommendation on RecruitRecommendation {\n  id\n  recruitRecommendationId\n  currentDecision\n  declineReason\n  feedbackSkills {\n    id\n    name\n  }\n}\n\nfragment RecommendationWorkflowDeclined_recommendation on RecruitRecommendation {\n  id\n  recruitRecommendationId\n  currentStatus\n  currentDecision\n  hasDeclined\n  declineReason\n  declinedOn\n  hasGivenAvailabilityReason\n  declinePreferredLocation\n  declinePreferredRateType\n  declinePreferredRate\n  availableInMonths\n  ...RecommendationWorkflowChange_recommendation\n  ...RecommendationWorkflowDeclinedNotAvailable_recommendation\n  ...RecommendationWorkflowDeclinedUnsuitableSkills_recommendation\n  ...RecommendationWorkflowDeclinedUnsuitableLocation_recommendation\n  ...RecommendationWorkflowDeclinedUnsuitableRate_recommendation\n  ...RecommendationWorkflowDeclinedNoReason_recommendation\n}\n"
    }
  };
}();
node178.hash = "a856fe4f46a3094fcea3f67fe2fdbcca";
var PublicRecommendationLayoutQuery_graphql_default = node178;

// src/recommendations/candidates/components/PublicRecommendationLayout.tsx
import { Suspense as Suspense49 } from "react";
import { usePreloadedQuery as usePreloadedQuery14 } from "react-relay";
import { Route as Route3, Routes as Routes3 } from "react-router-dom";
import { EdSkeleton as EdSkeleton44 } from "shared-ui";

// src/recommendations/candidates/components/__generated__/RecommendationContainer_recommendation.graphql.ts
var node179 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RecommendationContainer_recommendation",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recruitRecommendationId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vacancyName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Vacancy",
      "kind": "LinkedField",
      "name": "vacancy",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RecommendationWorkflowAppliedContainer_recommendation"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RecommendationWorkflowDeclinedNotAvailable_recommendation"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RecommendationWorkflowDeclined_recommendation"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RecommendationNoDecision_recommendation"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RecommendationVacancyInfo_recommendation"
    }
  ],
  "type": "RecruitRecommendation",
  "abstractKey": null
};
node179.hash = "1bfe2b161b2564586e9f996bc2b1b6fc";
var RecommendationContainer_recommendation_graphql_default = node179;

// src/recommendations/candidates/components/RecommendationContainer.tsx
import { useFragment as useFragment54 } from "react-relay";
import { Breadcrumbs as Breadcrumbs3, EdSkeleton as EdSkeleton43, MobileHeader as MobileHeader2, classNames as classNames20 } from "shared-ui";

// src/recommendations/candidates/components/__generated__/RecommendationNoDecision_recommendation.graphql.ts
var node180 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RecommendationNoDecision_recommendation",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recruitRecommendationId",
      "storageKey": null
    }
  ],
  "type": "RecruitRecommendation",
  "abstractKey": null
};
node180.hash = "46a65913c7318233749dc7949c4b8a7a";
var RecommendationNoDecision_recommendation_graphql_default = node180;

// src/recommendations/candidates/components/RecommendationNoDecision.tsx
import { useFragment as useFragment43 } from "react-relay";
import { ButtonList as ButtonList13 } from "shared-ui";

// src/recommendations/candidates/components/RecommendationDeclineButton.tsx
import { useLogger as useLogger17 } from "shared-lib";
import { Button as Button48, Size as Size28 } from "shared-ui";

// src/recommendations/candidates/mutations/__generated__/UseRecommendationAddRightToWorkMutation.graphql.ts
var node181 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "concreteType": "RecommendationPayload",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "otacCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "EdgeOfRecommendationReadModel",
        "kind": "LinkedField",
        "name": "recommendation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitRecommendation",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "recruitRecommendationId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rightToWorkStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasCompletedRightToWork",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currentStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currentDecision",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "declineReason",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "declinePreferredLocation",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "declinePreferredRateType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "declinePreferredRate",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v32 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseRecommendationAddRightToWorkMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitRecommendationAddRightToWorkPayload",
          "kind": "LinkedField",
          "name": "recruitRecommendationAddRightToWork",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseRecommendationAddRightToWorkMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitRecommendationAddRightToWorkPayload",
          "kind": "LinkedField",
          "name": "recruitRecommendationAddRightToWork",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "54fdb34107551a12c83b82c7bf4834ad",
      "id": null,
      "metadata": {},
      "name": "UseRecommendationAddRightToWorkMutation",
      "operationKind": "mutation",
      "text": "mutation UseRecommendationAddRightToWorkMutation(\n  $input: RecruitRecommendationAddRightToWorkInput!\n) {\n  result: recruitRecommendationAddRightToWork(input: $input) {\n    payload {\n      otacCode\n      recommendation {\n        node {\n          id\n          recruitRecommendationId\n          rightToWorkStatus\n          hasCompletedRightToWork\n          currentStatus\n          currentDecision\n          declineReason\n          declinePreferredLocation\n          declinePreferredRateType\n          declinePreferredRate\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node181.hash = "930123573956373ed2ed1eca97531c5b";
var UseRecommendationAddRightToWorkMutation_graphql_default = node181;

// src/recommendations/candidates/mutations/UseRecommendationAddRightToWork.ts
import { useCallback as useCallback87 } from "react";
import { useMutation as useMutation15 } from "react-relay";
import {
  createClientMutationId as createClientMutationId41,
  useUnhandledError as useUnhandledError7,
  useSetUserErrorCodes as useSetUserErrorCodes8
} from "shared-lib";
var mutationDef45 = UseRecommendationAddRightToWorkMutation_graphql_default;
var useRecommendationAddRightToWork = (candidateId, recommendationId, onDone, decisionToken) => {
  const [, setUnhandledError] = useUnhandledError7();
  const setErrorCodes = useSetUserErrorCodes8();
  const [commitMutation4, isMutationInFlight] = useMutation15(mutationDef45);
  const invokeMutation = useCallback87(
    (model) => {
      const clientMutationId = createClientMutationId41();
      const input = {
        model,
        recommendationId,
        decisionToken,
        clientMutationId
      };
      commitMutation4({
        variables: {
          input
        },
        onError: (e4) => {
          setUnhandledError(e4);
        },
        onCompleted: (response) => {
          if (response.result.payload?.recommendation) {
            onDone(response.result.payload?.otacCode);
          }
          if (response.result.userErrors) {
            setErrorCodes(response.result.userErrors);
          }
        }
      });
    },
    [commitMutation4]
  );
  return [invokeMutation, isMutationInFlight];
};

// src/recommendations/candidates/mutations/__generated__/UseRecommendationApplyMutation.graphql.ts
var node183 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "concreteType": "RecommendationPayload",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "otacCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "EdgeOfRecommendationReadModel",
        "kind": "LinkedField",
        "name": "recommendation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitRecommendation",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "recruitRecommendationId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currentStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currentDecision",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "declineReason",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "declinePreferredLocation",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "declinePreferredRateType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "declinePreferredRate",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v32 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseRecommendationApplyMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitRecommendationApplyPayload",
          "kind": "LinkedField",
          "name": "recruitRecommendationApply",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseRecommendationApplyMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitRecommendationApplyPayload",
          "kind": "LinkedField",
          "name": "recruitRecommendationApply",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "92fd23a3e5f41276d4d5aed1b7128911",
      "id": null,
      "metadata": {},
      "name": "UseRecommendationApplyMutation",
      "operationKind": "mutation",
      "text": "mutation UseRecommendationApplyMutation(\n  $input: RecruitRecommendationApplyInput!\n) {\n  result: recruitRecommendationApply(input: $input) {\n    payload {\n      otacCode\n      recommendation {\n        node {\n          id\n          recruitRecommendationId\n          currentStatus\n          currentDecision\n          declineReason\n          declinePreferredLocation\n          declinePreferredRateType\n          declinePreferredRate\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node183.hash = "8cd7e1c89724b230d1838c9cc8aac3da";
var UseRecommendationApplyMutation_graphql_default = node183;

// src/recommendations/candidates/mutations/UseRecommendationApply.ts
import { useCallback as useCallback88 } from "react";
import { useMutation as useMutation16 } from "react-relay";
import {
  createClientMutationId as createClientMutationId43,
  useUnhandledError as useUnhandledError8,
  useSetUserErrorCodes as useSetUserErrorCodes9
} from "shared-lib";
var mutationDef46 = UseRecommendationApplyMutation_graphql_default;
var useRecommendationApply = (candidateId, recommendationId, onDone, decisionToken) => {
  const [, setUnhandledError] = useUnhandledError8();
  const setErrorCodes = useSetUserErrorCodes9();
  const [commitMutation4, isMutationInFlight] = useMutation16(mutationDef46);
  const invokeMutation = useCallback88(() => {
    const clientMutationId = createClientMutationId43();
    const input = {
      recommendationId,
      decisionToken,
      clientMutationId
    };
    commitMutation4({
      variables: {
        input
      },
      onError: (e4) => {
        setUnhandledError(e4);
      },
      onCompleted: (response) => {
        if (response.result.payload?.recommendation) {
          onDone(response.result.payload?.otacCode);
        }
        if (response.result.userErrors) {
          setErrorCodes(response.result.userErrors);
        }
      }
    });
  }, [commitMutation4]);
  return [invokeMutation, isMutationInFlight];
};

// src/recommendations/candidates/mutations/__generated__/UseRecommendationCommentMutation.graphql.ts
var node184 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "concreteType": "RecommendationPayload",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "otacCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "EdgeOfRecommendationReadModel",
        "kind": "LinkedField",
        "name": "recommendation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitRecommendation",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "recruitRecommendationId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currentStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currentDecision",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitRecommendationComment",
                "kind": "LinkedField",
                "name": "comments",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "comment",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "commentOn",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v32 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseRecommendationCommentMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitRecommendationCommentPayload",
          "kind": "LinkedField",
          "name": "recruitRecommendationComment",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseRecommendationCommentMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitRecommendationCommentPayload",
          "kind": "LinkedField",
          "name": "recruitRecommendationComment",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "6593cb63d6c65ad951b0225b1d4318d9",
      "id": null,
      "metadata": {},
      "name": "UseRecommendationCommentMutation",
      "operationKind": "mutation",
      "text": "mutation UseRecommendationCommentMutation(\n  $input: RecruitRecommendationCommentInput!\n) {\n  result: recruitRecommendationComment(input: $input) {\n    payload {\n      otacCode\n      recommendation {\n        node {\n          id\n          recruitRecommendationId\n          currentStatus\n          currentDecision\n          comments {\n            comment\n            commentOn\n          }\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node184.hash = "37897f7edaaa72d17f2b2d407e5f912d";
var UseRecommendationCommentMutation_graphql_default = node184;

// src/recommendations/candidates/mutations/UseRecommendationComment.ts
import { useCallback as useCallback89 } from "react";
import { useMutation as useMutation17 } from "react-relay";
import {
  createClientMutationId as createClientMutationId44,
  useUnhandledError as useUnhandledError9,
  useSetUserErrorCodes as useSetUserErrorCodes10
} from "shared-lib";
var mutationDef47 = UseRecommendationCommentMutation_graphql_default;
var useRecommendationComment = (candidateId, recommendationId, onDone, decisionToken) => {
  const [, setUnhandledError] = useUnhandledError9();
  const setErrorCodes = useSetUserErrorCodes10();
  const [commitMutation4, isMutationInFlight] = useMutation17(mutationDef47);
  const invokeMutation = useCallback89(
    (comment) => {
      const clientMutationId = createClientMutationId44();
      const input = {
        model: {
          comment
        },
        recommendationId,
        decisionToken,
        clientMutationId
      };
      commitMutation4({
        variables: {
          input
        },
        onError: (e4) => {
          setUnhandledError(e4);
        },
        onCompleted: (response) => {
          if (response.result.payload?.recommendation) {
            onDone(response.result.payload?.otacCode);
          }
          if (response.result.userErrors) {
            setErrorCodes(response.result.userErrors);
          }
        }
      });
    },
    [commitMutation4]
  );
  return [invokeMutation, isMutationInFlight];
};

// src/recommendations/candidates/mutations/__generated__/UseRecommendationDeclineMutation.graphql.ts
var node185 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "concreteType": "RecommendationPayload",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "otacCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "EdgeOfRecommendationReadModel",
        "kind": "LinkedField",
        "name": "recommendation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitRecommendation",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "recruitRecommendationId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currentStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currentDecision",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "declineReason",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "declinePreferredLocation",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "declinePreferredRateType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "declinePreferredRate",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v32 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseRecommendationDeclineMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitRecommendationDeclinePayload",
          "kind": "LinkedField",
          "name": "recruitRecommendationDecline",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseRecommendationDeclineMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitRecommendationDeclinePayload",
          "kind": "LinkedField",
          "name": "recruitRecommendationDecline",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "8fd691f961896ec22f4fc58e7542dac8",
      "id": null,
      "metadata": {},
      "name": "UseRecommendationDeclineMutation",
      "operationKind": "mutation",
      "text": "mutation UseRecommendationDeclineMutation(\n  $input: RecruitRecommendationDeclineInput!\n) {\n  result: recruitRecommendationDecline(input: $input) {\n    payload {\n      otacCode\n      recommendation {\n        node {\n          id\n          recruitRecommendationId\n          currentStatus\n          currentDecision\n          declineReason\n          declinePreferredLocation\n          declinePreferredRateType\n          declinePreferredRate\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node185.hash = "4c19b806e48b425196780c7b1d7adce4";
var UseRecommendationDeclineMutation_graphql_default = node185;

// src/recommendations/candidates/mutations/UseRecommendationDecline.ts
import { useCallback as useCallback90 } from "react";
import { useMutation as useMutation18 } from "react-relay";
import {
  createClientMutationId as createClientMutationId45,
  useUnhandledError as useUnhandledError10,
  useSetUserErrorCodes as useSetUserErrorCodes11
} from "shared-lib";
var mutationDef48 = UseRecommendationDeclineMutation_graphql_default;
var useRecommendationDecline = (candidateId, recommendationId, onDone, decisionToken) => {
  const [, setUnhandledError] = useUnhandledError10();
  const setErrorCodes = useSetUserErrorCodes11();
  const [commitMutation4, isMutationInFlight] = useMutation18(mutationDef48);
  const invokeMutation = useCallback90(
    (declineReason) => {
      const clientMutationId = createClientMutationId45();
      const input = {
        recommendationId,
        decisionToken,
        declineReason,
        clientMutationId
      };
      commitMutation4({
        variables: {
          input
        },
        onError: (e4) => {
          setUnhandledError(e4);
        },
        onCompleted: (response) => {
          if (response.result.payload?.recommendation) {
            onDone(response.result.payload?.otacCode);
          }
          if (response.result.userErrors) {
            setErrorCodes(response.result.userErrors);
          }
        }
      });
    },
    [commitMutation4]
  );
  return [invokeMutation, isMutationInFlight];
};

// src/recommendations/candidates/mutations/__generated__/UseRecommendationDeclineAvailabilityMutation.graphql.ts
var node186 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "concreteType": "RecommendationPayload",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "otacCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "EdgeOfRecommendationReadModel",
        "kind": "LinkedField",
        "name": "recommendation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitRecommendation",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "recruitRecommendationId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currentStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currentDecision",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "declineReason",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "declinePreferredLocation",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "declinePreferredRateType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "declinePreferredRate",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v32 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseRecommendationDeclineAvailabilityMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitRecommendationDeclineAvailabilityPayload",
          "kind": "LinkedField",
          "name": "recruitRecommendationDeclineAvailability",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseRecommendationDeclineAvailabilityMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitRecommendationDeclineAvailabilityPayload",
          "kind": "LinkedField",
          "name": "recruitRecommendationDeclineAvailability",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "0cf07b4699ae51f211d213eb14d89c92",
      "id": null,
      "metadata": {},
      "name": "UseRecommendationDeclineAvailabilityMutation",
      "operationKind": "mutation",
      "text": "mutation UseRecommendationDeclineAvailabilityMutation(\n  $input: RecruitRecommendationDeclineAvailabilityInput!\n) {\n  result: recruitRecommendationDeclineAvailability(input: $input) {\n    payload {\n      otacCode\n      recommendation {\n        node {\n          id\n          recruitRecommendationId\n          currentStatus\n          currentDecision\n          declineReason\n          declinePreferredLocation\n          declinePreferredRateType\n          declinePreferredRate\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node186.hash = "99c734d45a133e45e60d2fb31f4e54c8";
var UseRecommendationDeclineAvailabilityMutation_graphql_default = node186;

// src/recommendations/candidates/mutations/UseRecommendationDeclineAvailability.ts
import { useCallback as useCallback91 } from "react";
import { useMutation as useMutation19 } from "react-relay";
import {
  createClientMutationId as createClientMutationId46,
  useUnhandledError as useUnhandledError11,
  useSetUserErrorCodes as useSetUserErrorCodes12
} from "shared-lib";
var mutationDef49 = UseRecommendationDeclineAvailabilityMutation_graphql_default;
var useRecommendationDeclineAvailability = (candidateId, recommendationId, onDone, decisionToken) => {
  const [, setUnhandledError] = useUnhandledError11();
  const setErrorCodes = useSetUserErrorCodes12();
  const [commitMutation4, isMutationInFlight] = useMutation19(mutationDef49);
  const invokeMutation = useCallback91(() => {
    const clientMutationId = createClientMutationId46();
    const input = {
      recommendationId,
      decisionToken,
      clientMutationId
    };
    commitMutation4({
      variables: {
        input
      },
      onError: (e4) => {
        setUnhandledError(e4);
      },
      onCompleted: (response) => {
        if (response.result.payload?.recommendation) {
          onDone(response.result.payload?.otacCode);
        }
        if (response.result.userErrors) {
          setErrorCodes(response.result.userErrors);
        }
      }
    });
  }, [commitMutation4]);
  return [invokeMutation, isMutationInFlight];
};

// src/recommendations/candidates/mutations/__generated__/UseRecommendationDeclineCloseAccountMutation.graphql.ts
var node187 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "concreteType": "RecommendationPayload",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "otacCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "EdgeOfRecommendationReadModel",
        "kind": "LinkedField",
        "name": "recommendation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitRecommendation",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "recruitRecommendationId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currentStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currentDecision",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "declineReason",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "declinePreferredLocation",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "declinePreferredRateType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "declinePreferredRate",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v32 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseRecommendationDeclineCloseAccountMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitRecommendationDeclineCloseAccountPayload",
          "kind": "LinkedField",
          "name": "recruitRecommendationDeclineCloseAccount",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseRecommendationDeclineCloseAccountMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitRecommendationDeclineCloseAccountPayload",
          "kind": "LinkedField",
          "name": "recruitRecommendationDeclineCloseAccount",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "c43818bd513c0f743d2bd5067cb03efa",
      "id": null,
      "metadata": {},
      "name": "UseRecommendationDeclineCloseAccountMutation",
      "operationKind": "mutation",
      "text": "mutation UseRecommendationDeclineCloseAccountMutation(\n  $input: RecruitRecommendationDeclineCloseAccountInput!\n) {\n  result: recruitRecommendationDeclineCloseAccount(input: $input) {\n    payload {\n      otacCode\n      recommendation {\n        node {\n          id\n          recruitRecommendationId\n          currentStatus\n          currentDecision\n          declineReason\n          declinePreferredLocation\n          declinePreferredRateType\n          declinePreferredRate\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node187.hash = "ad4a32cbac22de3148b2e2d362c2e88d";
var UseRecommendationDeclineCloseAccountMutation_graphql_default = node187;

// src/recommendations/candidates/mutations/UseRecommendationDeclineCloseAccount.ts
import { useCallback as useCallback93 } from "react";
import { useMutation as useMutation20 } from "react-relay";
import {
  createClientMutationId as createClientMutationId47,
  useUnhandledError as useUnhandledError12,
  useSetUserErrorCodes as useSetUserErrorCodes13
} from "shared-lib";
var mutationDef50 = UseRecommendationDeclineCloseAccountMutation_graphql_default;
var useRecommendationDeclineCloseAccount = (candidateId, recommendationId, onDone, decisionToken) => {
  const [, setUnhandledError] = useUnhandledError12();
  const setErrorCodes = useSetUserErrorCodes13();
  const [commitMutation4, isMutationInFlight] = useMutation20(mutationDef50);
  const invokeMutation = useCallback93(() => {
    const clientMutationId = createClientMutationId47();
    const input = {
      recommendationId,
      decisionToken,
      clientMutationId
    };
    commitMutation4({
      variables: {
        input
      },
      onError: (e4) => {
        setUnhandledError(e4);
      },
      onCompleted: (response) => {
        if (response.result.payload?.recommendation) {
          onDone(response.result.payload?.otacCode);
        }
        if (response.result.userErrors) {
          setErrorCodes(response.result.userErrors);
        }
      }
    });
  }, [commitMutation4]);
  return [invokeMutation, isMutationInFlight];
};

// src/recommendations/candidates/mutations/__generated__/UseRecommendationDeclineFeedbackAvailabilityMutation.graphql.ts
var node188 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "concreteType": "RecommendationPayload",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "otacCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "EdgeOfRecommendationReadModel",
        "kind": "LinkedField",
        "name": "recommendation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitRecommendation",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "recruitRecommendationId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currentStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currentDecision",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "declineReason",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasGivenAvailabilityReason",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "availableInMonths",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v32 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseRecommendationDeclineFeedbackAvailabilityMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitRecommendationDeclineFeedbackAvailabilityPayload",
          "kind": "LinkedField",
          "name": "recruitRecommendationDeclineFeedbackAvailability",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseRecommendationDeclineFeedbackAvailabilityMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitRecommendationDeclineFeedbackAvailabilityPayload",
          "kind": "LinkedField",
          "name": "recruitRecommendationDeclineFeedbackAvailability",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "5bcac70869ab91d9fe1c3b5c4b66c913",
      "id": null,
      "metadata": {},
      "name": "UseRecommendationDeclineFeedbackAvailabilityMutation",
      "operationKind": "mutation",
      "text": "mutation UseRecommendationDeclineFeedbackAvailabilityMutation(\n  $input: RecruitRecommendationDeclineFeedbackAvailabilityInput!\n) {\n  result: recruitRecommendationDeclineFeedbackAvailability(input: $input) {\n    payload {\n      otacCode\n      recommendation {\n        node {\n          id\n          recruitRecommendationId\n          currentStatus\n          currentDecision\n          declineReason\n          hasGivenAvailabilityReason\n          availableInMonths\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node188.hash = "5c836b47c76d90503c6641418520c983";
var UseRecommendationDeclineFeedbackAvailabilityMutation_graphql_default = node188;

// src/recommendations/candidates/mutations/UseRecommendationDeclineFeedbackAvailability.ts
import { useCallback as useCallback94 } from "react";
import {
  createClientMutationId as createClientMutationId48,
  useAsyncMutation as useAsyncMutation36,
  useUnhandledError as useUnhandledError13,
  useSetUserErrorCodes as useSetUserErrorCodes14
} from "shared-lib";
var mutationDef51 = UseRecommendationDeclineFeedbackAvailabilityMutation_graphql_default;
var useRecommendationDeclineFeedbackAvailability = (candidateId, recommendationId, decisionToken) => {
  const [, setUnhandledError] = useUnhandledError13();
  const setErrorCodes = useSetUserErrorCodes14();
  const [commitMutation4, isMutationInFlight] = useAsyncMutation36(
    mutationDef51
  );
  const invokeMutation = useCallback94(
    async (numberOfMonths) => {
      const clientMutationId = createClientMutationId48();
      const input = {
        model: {
          numberOfMonths
        },
        recommendationId,
        decisionToken,
        clientMutationId
      };
      const response = await commitMutation4({
        input
      });
      if (response.result.payload?.recommendation) {
        return {
          otacCode: response.result.payload?.otacCode
        };
      }
      if (response.result.userErrors) {
        setErrorCodes(response.result.userErrors);
      }
    },
    [commitMutation4]
  );
  return [invokeMutation, isMutationInFlight];
};

// src/recommendations/candidates/mutations/__generated__/UseRecommendationDeclineFeedbackLocationMutation.graphql.ts
var node189 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "concreteType": "RecommendationPayload",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "otacCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "EdgeOfRecommendationReadModel",
        "kind": "LinkedField",
        "name": "recommendation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitRecommendation",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "recruitRecommendationId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currentStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currentDecision",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "declineReason",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "declinePreferredLocation",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "declinePreferredRateType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "declinePreferredRate",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v32 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseRecommendationDeclineFeedbackLocationMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitRecommendationDeclineFeedbackLocationPayload",
          "kind": "LinkedField",
          "name": "recruitRecommendationDeclineFeedbackLocation",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseRecommendationDeclineFeedbackLocationMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitRecommendationDeclineFeedbackLocationPayload",
          "kind": "LinkedField",
          "name": "recruitRecommendationDeclineFeedbackLocation",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "4330585e51014abf0eafa6fbc53092da",
      "id": null,
      "metadata": {},
      "name": "UseRecommendationDeclineFeedbackLocationMutation",
      "operationKind": "mutation",
      "text": "mutation UseRecommendationDeclineFeedbackLocationMutation(\n  $input: RecruitRecommendationDeclineFeedbackLocationInput!\n) {\n  result: recruitRecommendationDeclineFeedbackLocation(input: $input) {\n    payload {\n      otacCode\n      recommendation {\n        node {\n          id\n          recruitRecommendationId\n          currentStatus\n          currentDecision\n          declineReason\n          declinePreferredLocation\n          declinePreferredRateType\n          declinePreferredRate\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node189.hash = "a83b188a6f83399334c2939afbfe3368";
var UseRecommendationDeclineFeedbackLocationMutation_graphql_default = node189;

// src/recommendations/candidates/mutations/UseRecommendationDeclineFeedbackLocation.ts
import { useCallback as useCallback95 } from "react";
import {
  createClientMutationId as createClientMutationId49,
  useAsyncMutation as useAsyncMutation37,
  useSetUserErrorCodes as useSetUserErrorCodes15
} from "shared-lib";
var mutationDef52 = UseRecommendationDeclineFeedbackLocationMutation_graphql_default;
var useRecommendationDeclineFeedbackLocation = (candidateId, recommendationId, decisionToken) => {
  const setErrorCodes = useSetUserErrorCodes15();
  const [commitMutation4, isMutationInFlight] = useAsyncMutation37(
    mutationDef52
  );
  const invokeMutation = useCallback95(
    async (location2) => {
      const clientMutationId = createClientMutationId49();
      const input = {
        location: location2,
        recommendationId,
        decisionToken,
        clientMutationId
      };
      const response = await commitMutation4({
        input
      });
      if (response.result.payload?.recommendation) {
        return response.result.payload?.otacCode;
      }
      if (response.result.userErrors) {
        setErrorCodes(response.result.userErrors);
      }
    },
    [commitMutation4]
  );
  return [invokeMutation, isMutationInFlight];
};

// src/recommendations/candidates/mutations/__generated__/UseRecommendationDeclineFeedbackRateMutation.graphql.ts
var node190 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "concreteType": "RecommendationPayload",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "otacCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "EdgeOfRecommendationReadModel",
        "kind": "LinkedField",
        "name": "recommendation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitRecommendation",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "recruitRecommendationId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currentStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currentDecision",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "declineReason",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "declinePreferredLocation",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "declinePreferredRateType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "declinePreferredRate",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v32 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseRecommendationDeclineFeedbackRateMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitRecommendationDeclineFeedbackRatePayload",
          "kind": "LinkedField",
          "name": "recruitRecommendationDeclineFeedbackRate",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseRecommendationDeclineFeedbackRateMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitRecommendationDeclineFeedbackRatePayload",
          "kind": "LinkedField",
          "name": "recruitRecommendationDeclineFeedbackRate",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "1e31ce25ceefd7d851f9bd367d774ea4",
      "id": null,
      "metadata": {},
      "name": "UseRecommendationDeclineFeedbackRateMutation",
      "operationKind": "mutation",
      "text": "mutation UseRecommendationDeclineFeedbackRateMutation(\n  $input: RecruitRecommendationDeclineFeedbackRateInput!\n) {\n  result: recruitRecommendationDeclineFeedbackRate(input: $input) {\n    payload {\n      otacCode\n      recommendation {\n        node {\n          id\n          recruitRecommendationId\n          currentStatus\n          currentDecision\n          declineReason\n          declinePreferredLocation\n          declinePreferredRateType\n          declinePreferredRate\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node190.hash = "27b82efcf9921ff72dd71f16596e97ed";
var UseRecommendationDeclineFeedbackRateMutation_graphql_default = node190;

// src/recommendations/candidates/mutations/UseRecommendationDeclineFeedbackRate.ts
import { useCallback as useCallback96 } from "react";
import {
  createClientMutationId as createClientMutationId50,
  useAsyncMutation as useAsyncMutation38,
  useUnhandledError as useUnhandledError14,
  useSetUserErrorCodes as useSetUserErrorCodes16
} from "shared-lib";
var mutationDef53 = UseRecommendationDeclineFeedbackRateMutation_graphql_default;
var useRecommendationDeclineFeedbackRate = (candidateId, recommendationId, decisionToken) => {
  const [, setUnhandledError] = useUnhandledError14();
  const setErrorCodes = useSetUserErrorCodes16();
  const [commitMutation4, isMutationInFlight] = useAsyncMutation38(mutationDef53);
  const invokeMutation = useCallback96(
    async (preferredRate, preferredRatePayType) => {
      const clientMutationId = createClientMutationId50();
      const input = {
        preferredRate,
        preferredRatePayType,
        recommendationId,
        decisionToken,
        clientMutationId
      };
      const response = await commitMutation4({
        input
      });
      if (response.result.payload?.recommendation) {
        return {
          otacCode: response.result.payload?.otacCode
        };
      }
      if (response.result.userErrors) {
        setErrorCodes(response.result.userErrors);
      }
    },
    [commitMutation4]
  );
  return [invokeMutation, isMutationInFlight];
};

// src/recommendations/candidates/mutations/__generated__/UseRecommendationDeclineFeedbackSkillsMutation.graphql.ts
var node191 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "RecommendationPayload",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "otacCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "EdgeOfRecommendationReadModel",
        "kind": "LinkedField",
        "name": "recommendation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitRecommendation",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              v23,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "recruitRecommendationId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currentStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currentDecision",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "declineReason",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "declinePreferredLocation",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "declinePreferredRateType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "declinePreferredRate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitSkillTag",
                "kind": "LinkedField",
                "name": "feedbackSkills",
                "plural": true,
                "selections": [
                  v23,
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseRecommendationDeclineFeedbackSkillsMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitRecommendationDeclineFeedbackSkillsPayload",
          "kind": "LinkedField",
          "name": "recruitRecommendationDeclineFeedbackSkills",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseRecommendationDeclineFeedbackSkillsMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitRecommendationDeclineFeedbackSkillsPayload",
          "kind": "LinkedField",
          "name": "recruitRecommendationDeclineFeedbackSkills",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "52c97d0f8dc502cf22d9869e20190708",
      "id": null,
      "metadata": {},
      "name": "UseRecommendationDeclineFeedbackSkillsMutation",
      "operationKind": "mutation",
      "text": "mutation UseRecommendationDeclineFeedbackSkillsMutation(\n  $input: RecruitRecommendationDeclineFeedbackSkillsInput!\n) {\n  result: recruitRecommendationDeclineFeedbackSkills(input: $input) {\n    payload {\n      otacCode\n      recommendation {\n        node {\n          id\n          recruitRecommendationId\n          currentStatus\n          currentDecision\n          declineReason\n          declinePreferredLocation\n          declinePreferredRateType\n          declinePreferredRate\n          feedbackSkills {\n            id\n            name\n          }\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node191.hash = "4c7fdbbf3fcff8cc3278870dfffe5b3a";
var UseRecommendationDeclineFeedbackSkillsMutation_graphql_default = node191;

// src/recommendations/candidates/mutations/UseRecommendationDeclineFeedbackSkills.ts
import { useCallback as useCallback97 } from "react";
import { useMutation as useMutation21 } from "react-relay";
import {
  createClientMutationId as createClientMutationId51,
  useUnhandledError as useUnhandledError15,
  useSetUserErrorCodes as useSetUserErrorCodes17
} from "shared-lib";
var mutationDef54 = UseRecommendationDeclineFeedbackSkillsMutation_graphql_default;
var useRecommendationDeclineFeedbackSkills = (candidateId, recommendationId, onDone, decisionToken) => {
  const [, setUnhandledError] = useUnhandledError15();
  const setErrorCodes = useSetUserErrorCodes17();
  const [commitMutation4, isMutationInFlight] = useMutation21(mutationDef54);
  const invokeMutation = useCallback97(
    (skills) => {
      const clientMutationId = createClientMutationId51();
      const input = {
        model: {
          skills
        },
        recommendationId,
        decisionToken,
        clientMutationId
      };
      commitMutation4({
        variables: {
          input
        },
        onError: (e4) => {
          setUnhandledError(e4);
        },
        onCompleted: (response) => {
          if (response.result.payload?.recommendation) {
            onDone(response.result.payload?.otacCode);
          }
          if (response.result.userErrors) {
            setErrorCodes(response.result.userErrors);
          }
        }
      });
    },
    [commitMutation4]
  );
  return [invokeMutation, isMutationInFlight];
};

// src/recommendations/candidates/mutations/__generated__/UseRecommendationDeclineSkillsMutation.graphql.ts
var node193 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "concreteType": "RecommendationPayload",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "otacCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "EdgeOfRecommendationReadModel",
        "kind": "LinkedField",
        "name": "recommendation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitRecommendation",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "recruitRecommendationId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currentStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currentDecision",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "declineReason",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "declinePreferredLocation",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "declinePreferredRateType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "declinePreferredRate",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v32 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseRecommendationDeclineSkillsMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitRecommendationDeclineSkillsPayload",
          "kind": "LinkedField",
          "name": "recruitRecommendationDeclineSkills",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseRecommendationDeclineSkillsMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitRecommendationDeclineSkillsPayload",
          "kind": "LinkedField",
          "name": "recruitRecommendationDeclineSkills",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "690ffa393499382f7d2f43edc3d185da",
      "id": null,
      "metadata": {},
      "name": "UseRecommendationDeclineSkillsMutation",
      "operationKind": "mutation",
      "text": "mutation UseRecommendationDeclineSkillsMutation(\n  $input: RecruitRecommendationDeclineSkillsInput!\n) {\n  result: recruitRecommendationDeclineSkills(input: $input) {\n    payload {\n      otacCode\n      recommendation {\n        node {\n          id\n          recruitRecommendationId\n          currentStatus\n          currentDecision\n          declineReason\n          declinePreferredLocation\n          declinePreferredRateType\n          declinePreferredRate\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node193.hash = "c07646528e5871f04d39361552818392";
var UseRecommendationDeclineSkillsMutation_graphql_default = node193;

// src/recommendations/candidates/mutations/UseRecommendationDeclineSkills.ts
import { useCallback as useCallback98 } from "react";
import { useMutation as useMutation22 } from "react-relay";
import {
  createClientMutationId as createClientMutationId53,
  useUnhandledError as useUnhandledError16,
  useSetUserErrorCodes as useSetUserErrorCodes18
} from "shared-lib";
var mutationDef55 = UseRecommendationDeclineSkillsMutation_graphql_default;
var useRecommendationDeclineSkills = (candidateId, recommendationId, onDone, decisionToken) => {
  const [, setUnhandledError] = useUnhandledError16();
  const setErrorCodes = useSetUserErrorCodes18();
  const [commitMutation4, isMutationInFlight] = useMutation22(mutationDef55);
  const invokeMutation = useCallback98(() => {
    const clientMutationId = createClientMutationId53();
    const input = {
      recommendationId,
      decisionToken,
      clientMutationId
    };
    commitMutation4({
      variables: {
        input
      },
      onError: (e4) => {
        setUnhandledError(e4);
      },
      onCompleted: (response) => {
        if (response.result.payload?.recommendation) {
          onDone(response.result.payload?.otacCode);
        }
        if (response.result.userErrors) {
          setErrorCodes(response.result.userErrors);
        }
      }
    });
  }, [commitMutation4]);
  return [invokeMutation, isMutationInFlight];
};

// src/recommendations/candidates/mutations/__generated__/UseRecommendationDeclineLocationMutation.graphql.ts
var node194 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "concreteType": "RecommendationPayload",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "otacCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "EdgeOfRecommendationReadModel",
        "kind": "LinkedField",
        "name": "recommendation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitRecommendation",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "recruitRecommendationId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currentStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currentDecision",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "declineReason",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "declinePreferredLocation",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "declinePreferredRateType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "declinePreferredRate",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v32 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseRecommendationDeclineLocationMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitRecommendationDeclineLocationPayload",
          "kind": "LinkedField",
          "name": "recruitRecommendationDeclineLocation",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseRecommendationDeclineLocationMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitRecommendationDeclineLocationPayload",
          "kind": "LinkedField",
          "name": "recruitRecommendationDeclineLocation",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "e13800791d1a3af46f06d5ffa21006c5",
      "id": null,
      "metadata": {},
      "name": "UseRecommendationDeclineLocationMutation",
      "operationKind": "mutation",
      "text": "mutation UseRecommendationDeclineLocationMutation(\n  $input: RecruitRecommendationDeclineLocationInput!\n) {\n  result: recruitRecommendationDeclineLocation(input: $input) {\n    payload {\n      otacCode\n      recommendation {\n        node {\n          id\n          recruitRecommendationId\n          currentStatus\n          currentDecision\n          declineReason\n          declinePreferredLocation\n          declinePreferredRateType\n          declinePreferredRate\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node194.hash = "7040e9054e1ff4762eef1cfa4e477c6f";
var UseRecommendationDeclineLocationMutation_graphql_default = node194;

// src/recommendations/candidates/mutations/UseRecommendationDeclineLocation.ts
import { useCallback as useCallback99 } from "react";
import { useMutation as useMutation23 } from "react-relay";
import {
  createClientMutationId as createClientMutationId54,
  useUnhandledError as useUnhandledError17,
  useSetUserErrorCodes as useSetUserErrorCodes19
} from "shared-lib";
var mutationDef56 = UseRecommendationDeclineLocationMutation_graphql_default;
var useRecommendationDeclineLocation = (candidateId, recommendationId, onDone, decisionToken) => {
  const [, setUnhandledError] = useUnhandledError17();
  const setErrorCodes = useSetUserErrorCodes19();
  const [commitMutation4, isMutationInFlight] = useMutation23(mutationDef56);
  const invokeMutation = useCallback99(() => {
    const clientMutationId = createClientMutationId54();
    const input = {
      recommendationId,
      decisionToken,
      clientMutationId
    };
    commitMutation4({
      variables: {
        input
      },
      onError: (e4) => {
        setUnhandledError(e4);
      },
      onCompleted: (response) => {
        if (response.result.payload?.recommendation) {
          onDone(response.result.payload?.otacCode);
        }
        if (response.result.userErrors) {
          setErrorCodes(response.result.userErrors);
        }
      }
    });
  }, [commitMutation4]);
  return [invokeMutation, isMutationInFlight];
};

// src/recommendations/candidates/mutations/__generated__/UseRecommendationDeclineNotInterestedMutation.graphql.ts
var node195 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "concreteType": "RecommendationPayload",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "otacCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "EdgeOfRecommendationReadModel",
        "kind": "LinkedField",
        "name": "recommendation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitRecommendation",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "recruitRecommendationId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currentStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currentDecision",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "declineReason",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "declinePreferredLocation",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "declinePreferredRateType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "declinePreferredRate",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v32 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseRecommendationDeclineNotInterestedMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitRecommendationDeclineNotInterestedPayload",
          "kind": "LinkedField",
          "name": "recruitRecommendationDeclineNotInterested",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseRecommendationDeclineNotInterestedMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitRecommendationDeclineNotInterestedPayload",
          "kind": "LinkedField",
          "name": "recruitRecommendationDeclineNotInterested",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "1ba71ae4641048ca82567d5b59d96009",
      "id": null,
      "metadata": {},
      "name": "UseRecommendationDeclineNotInterestedMutation",
      "operationKind": "mutation",
      "text": "mutation UseRecommendationDeclineNotInterestedMutation(\n  $input: RecruitRecommendationDeclineNotInterestedInput!\n) {\n  result: recruitRecommendationDeclineNotInterested(input: $input) {\n    payload {\n      otacCode\n      recommendation {\n        node {\n          id\n          recruitRecommendationId\n          currentStatus\n          currentDecision\n          declineReason\n          declinePreferredLocation\n          declinePreferredRateType\n          declinePreferredRate\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node195.hash = "93ec48bf4dfce717cad4e05f04238ec1";
var UseRecommendationDeclineNotInterestedMutation_graphql_default = node195;

// src/recommendations/candidates/mutations/UseRecommendationDeclineNotInterested.ts
import { useCallback as useCallback100 } from "react";
import { useMutation as useMutation24 } from "react-relay";
import {
  createClientMutationId as createClientMutationId55,
  useUnhandledError as useUnhandledError18,
  useSetUserErrorCodes as useSetUserErrorCodes20
} from "shared-lib";
var mutationDef57 = UseRecommendationDeclineNotInterestedMutation_graphql_default;
var useRecommendationDeclineNotInterested = (candidateId, recommendationId, onDone, decisionToken) => {
  const [, setUnhandledError] = useUnhandledError18();
  const setErrorCodes = useSetUserErrorCodes20();
  const [commitMutation4, isMutationInFlight] = useMutation24(mutationDef57);
  const invokeMutation = useCallback100(() => {
    const clientMutationId = createClientMutationId55();
    const input = {
      recommendationId,
      decisionToken,
      clientMutationId
    };
    commitMutation4({
      variables: {
        input
      },
      onError: (e4) => {
        setUnhandledError(e4);
      },
      onCompleted: (response) => {
        if (response.result.payload?.recommendation) {
          onDone(response.result.payload?.otacCode);
        }
        if (response.result.userErrors) {
          setErrorCodes(response.result.userErrors);
        }
      }
    });
  }, [commitMutation4]);
  return [invokeMutation, isMutationInFlight];
};

// src/recommendations/candidates/mutations/__generated__/UseRecommendationDeclineRateMutation.graphql.ts
var node196 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "concreteType": "RecommendationPayload",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "otacCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "EdgeOfRecommendationReadModel",
        "kind": "LinkedField",
        "name": "recommendation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitRecommendation",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "recruitRecommendationId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currentStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currentDecision",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "declineReason",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "declinePreferredLocation",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "declinePreferredRateType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "declinePreferredRate",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v32 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseRecommendationDeclineRateMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitRecommendationDeclineRatePayload",
          "kind": "LinkedField",
          "name": "recruitRecommendationDeclineRate",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseRecommendationDeclineRateMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitRecommendationDeclineRatePayload",
          "kind": "LinkedField",
          "name": "recruitRecommendationDeclineRate",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "2a24a0f876256fa139a3eadcf8361e66",
      "id": null,
      "metadata": {},
      "name": "UseRecommendationDeclineRateMutation",
      "operationKind": "mutation",
      "text": "mutation UseRecommendationDeclineRateMutation(\n  $input: RecruitRecommendationDeclineRateInput!\n) {\n  result: recruitRecommendationDeclineRate(input: $input) {\n    payload {\n      otacCode\n      recommendation {\n        node {\n          id\n          recruitRecommendationId\n          currentStatus\n          currentDecision\n          declineReason\n          declinePreferredLocation\n          declinePreferredRateType\n          declinePreferredRate\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node196.hash = "6b94b006e900e632e19cdd317aa10e6f";
var UseRecommendationDeclineRateMutation_graphql_default = node196;

// src/recommendations/candidates/mutations/UseRecommendationDeclineRate.ts
import { useCallback as useCallback101 } from "react";
import { useMutation as useMutation25 } from "react-relay";
import {
  createClientMutationId as createClientMutationId56,
  useUnhandledError as useUnhandledError19,
  useSetUserErrorCodes as useSetUserErrorCodes21
} from "shared-lib";
var mutationDef58 = UseRecommendationDeclineRateMutation_graphql_default;
var useRecommendationDeclineRate = (candidateId, recommendationId, onDone, decisionToken) => {
  const [, setUnhandledError] = useUnhandledError19();
  const setErrorCodes = useSetUserErrorCodes21();
  const [commitMutation4, isMutationInFlight] = useMutation25(mutationDef58);
  const invokeMutation = useCallback101(() => {
    const clientMutationId = createClientMutationId56();
    const input = {
      recommendationId,
      decisionToken,
      clientMutationId
    };
    commitMutation4({
      variables: {
        input
      },
      onError: (e4) => {
        setUnhandledError(e4);
      },
      onCompleted: (response) => {
        if (response.result.payload?.recommendation) {
          onDone(response.result.payload?.otacCode);
        }
        if (response.result.userErrors) {
          setErrorCodes(response.result.userErrors);
        }
      }
    });
  }, [commitMutation4]);
  return [invokeMutation, isMutationInFlight];
};

// src/recommendations/candidates/components/RecommendationDeclineButton.tsx
import { jsx as jsx154 } from "react/jsx-runtime";
var RecommendationDeclineButton = ({
  candidateId,
  recommendationId,
  decisionToken,
  onDone
}) => {
  const [log] = useLogger17();
  const [decline, isDeclining] = useRecommendationDeclineNotInterested(
    candidateId,
    recommendationId,
    (otacCode) => {
      log("Declined Recommendation");
      if (onDone) {
        onDone(otacCode);
      }
    },
    decisionToken
  );
  return /* @__PURE__ */ jsx154(
    Button48,
    {
      disabled: isDeclining,
      size: Size28.lg,
      color: "warning",
      clicked: decline,
      children: "Decline"
    }
  );
};

// src/recommendations/candidates/components/RecommendationApplyButton.tsx
import { useLogger as useLogger18 } from "shared-lib";
import { Button as Button49, Size as Size29 } from "shared-ui";
import { jsx as jsx155 } from "react/jsx-runtime";
var RecommendationApplyButton = ({
  candidateId,
  recommendationId,
  decisionToken,
  onDone
}) => {
  const [log] = useLogger18();
  const [apply, isApplying] = useRecommendationApply(
    candidateId,
    recommendationId,
    (otacCode) => {
      log("Applied To Recommendation");
      if (onDone) {
        onDone(otacCode);
      }
    },
    decisionToken
  );
  return /* @__PURE__ */ jsx155(Button49, { disabled: isApplying, size: Size29.lg, color: "green", clicked: apply, children: "Apply" });
};

// src/recommendations/candidates/components/RecommendationNoDecision.tsx
import { Fragment as Fragment39, jsx as jsx156, jsxs as jsxs106 } from "react/jsx-runtime";
var fragmentDef35 = RecommendationNoDecision_recommendation_graphql_default;
var RecommendationNoDecision = ({
  candidateId,
  recommendationId,
  decisionToken,
  fragmentRef,
  onDone
}) => {
  const data = useFragment43(
    fragmentDef35,
    fragmentRef
  );
  return /* @__PURE__ */ jsxs106(Fragment39, { children: [
    /* @__PURE__ */ jsx156("div", { className: "bg-primary-100 flex flex-col rounded-t-xl border p-4", children: /* @__PURE__ */ jsx156("div", { className: "p-4", children: /* @__PURE__ */ jsxs106("p", { children: [
      "Based on your ",
      /* @__PURE__ */ jsx156("strong", { children: "past work" }),
      ", you look like a good match for this job. We assess your fitness using a combination of",
      " ",
      /* @__PURE__ */ jsx156("strong", { children: "skills" }),
      ", ",
      /* @__PURE__ */ jsx156("strong", { children: "company culture" }),
      " and",
      " ",
      /* @__PURE__ */ jsx156("strong", { children: "rate" }),
      "."
    ] }) }) }),
    /* @__PURE__ */ jsx156("div", { className: "rounded-b-xl border-x border-b bg-white p-4", children: /* @__PURE__ */ jsxs106(ButtonList13, { justify: "START", children: [
      /* @__PURE__ */ jsx156(
        RecommendationApplyButton,
        {
          candidateId,
          recommendationId,
          decisionToken,
          onDone
        }
      ),
      /* @__PURE__ */ jsx156(
        RecommendationDeclineButton,
        {
          candidateId,
          recommendationId,
          decisionToken,
          onDone
        }
      )
    ] }) })
  ] });
};

// src/recommendations/candidates/components/__generated__/RecommendationWorkflowAppliedContainer_recommendation.graphql.ts
var node197 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RecommendationWorkflowAppliedContainer_recommendation",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recruitRecommendationId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentStatus",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RecommendationWorkflowChange_recommendation"
    }
  ],
  "type": "RecruitRecommendation",
  "abstractKey": null
};
node197.hash = "beb31f72da51e6b12e6274e5a228ff1f";
var RecommendationWorkflowAppliedContainer_recommendation_graphql_default = node197;

// src/recommendations/candidates/components/RecommendationWorkflowAppliedContainer.tsx
import { useFragment as useFragment45 } from "react-relay";

// src/recommendations/candidates/components/__generated__/RecommendationWorkflowChange_recommendation.graphql.ts
var node198 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RecommendationWorkflowChange_recommendation",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recruitRecommendationId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentDecision",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "declineReason",
      "storageKey": null
    }
  ],
  "type": "RecruitRecommendation",
  "abstractKey": null
};
node198.hash = "51c9efb0fbf14aab0386f6945d26ccd9";
var RecommendationWorkflowChange_recommendation_graphql_default = node198;

// src/recommendations/candidates/components/RecommendationWorkflowChange.tsx
import { useFragment as useFragment44 } from "react-relay";
import { useLogger as useLogger19, useToggle as useToggle23 } from "shared-lib";
import { Button as Button50, ButtonList as ButtonList14, Size as Size30 } from "shared-ui";

// src/recommendations/candidates/lib/RecommendationStatus.ts
function recommendationHasApplied(status) {
  if (status === "APPLIED") {
    return true;
  }
  return false;
}

// src/recommendations/candidates/components/RecommendationWorkflowChange.tsx
import { jsx as jsx157, jsxs as jsxs107 } from "react/jsx-runtime";
var fragmentDef36 = RecommendationWorkflowChange_recommendation_graphql_default;
var RecommendationWorkflowChange = ({
  fragmentRef,
  candidateId,
  recommendationId,
  decisionToken,
  onDone
}) => {
  const [log] = useLogger19();
  const data = useFragment44(
    fragmentDef36,
    fragmentRef
  );
  const [isChanging, toggleIsChanging] = useToggle23();
  log(`Render RecommendationWorkflowChange ${data.currentStatus}`);
  const changeButton = recommendationHasApplied(data.currentStatus) ? /* @__PURE__ */ jsx157(
    RecommendationDeclineButton,
    {
      candidateId,
      recommendationId,
      decisionToken,
      onDone
    }
  ) : /* @__PURE__ */ jsx157(
    RecommendationApplyButton,
    {
      candidateId,
      recommendationId,
      decisionToken,
      onDone
    }
  );
  return /* @__PURE__ */ jsx157("div", { children: isChanging ? /* @__PURE__ */ jsx157("div", { children: /* @__PURE__ */ jsxs107(ButtonList14, { justify: "START", children: [
    changeButton,
    /* @__PURE__ */ jsx157(Button50, { color: "gray", size: Size30.md, clicked: toggleIsChanging, children: "Cancel" })
  ] }) }) : data.currentDecision === "APPLIED" ? /* @__PURE__ */ jsx157(Button50, { color: "primary", size: Size30.md, clicked: toggleIsChanging, children: "Decline Instead ?" }) : /* @__PURE__ */ jsx157(Button50, { color: "primary", size: Size30.md, clicked: toggleIsChanging, children: "Apply Instead ?" }) });
};

// src/recommendations/candidates/components/RecommendationWorkflowAppliedContainer.tsx
import { jsx as jsx158, jsxs as jsxs108 } from "react/jsx-runtime";
var fragmentDef37 = RecommendationWorkflowAppliedContainer_recommendation_graphql_default;
var RecommendationWorkflowAppliedContainer = ({
  fragmentRef,
  candidateId,
  recommendationId,
  decisionToken,
  onDone
}) => {
  const data = useFragment45(
    fragmentDef37,
    fragmentRef
  );
  return /* @__PURE__ */ jsxs108("div", { className: "flex flex-col rounded-lg border bg-white p-4", children: [
    /* @__PURE__ */ jsxs108("h5", { children: [
      "You have ",
      /* @__PURE__ */ jsx158("strong", { children: "applied" }),
      " for this role"
    ] }),
    /* @__PURE__ */ jsx158("div", { className: "mt-2", children: /* @__PURE__ */ jsx158(
      RecommendationWorkflowChange,
      {
        fragmentRef: data,
        candidateId,
        recommendationId,
        decisionToken,
        onDone
      }
    ) })
  ] });
};

// src/recommendations/candidates/components/__generated__/RecommendationVacancyInfo_recommendation.graphql.ts
var node199 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationType",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationAmount",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "RecommendationVacancyInfo_recommendation",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "recruitRecommendationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Vacancy",
        "kind": "LinkedField",
        "name": "vacancy",
        "plural": false,
        "selections": [
          v1,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "publicDescriptionHtml",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SkillGroup",
            "kind": "LinkedField",
            "name": "skillGroups",
            "plural": true,
            "selections": [
              v0,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "skillGroupId",
                "storageKey": null
              },
              v1,
              {
                "alias": null,
                "args": null,
                "concreteType": "SkillGroupTerm",
                "kind": "LinkedField",
                "name": "terms",
                "plural": true,
                "selections": [
                  v1,
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isSkill",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Duration",
                "kind": "LinkedField",
                "name": "recency",
                "plural": false,
                "selections": [
                  v23,
                  v32
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isRequired",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "weight",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Duration",
                "kind": "LinkedField",
                "name": "experience",
                "plural": false,
                "selections": [
                  v32,
                  v23
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LocationCriteria",
            "kind": "LinkedField",
            "name": "locations",
            "plural": true,
            "selections": [
              v1,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "state",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "countryCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "countryName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "latitude",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "longitude",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "radius",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "entireCountry",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerLogoUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "expiresAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VacancyDates",
            "kind": "LinkedField",
            "name": "dates",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "durationCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "durationDescription",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startAsap",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VacancyRate",
            "kind": "LinkedField",
            "name": "rate",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "max",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "min",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currencyCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "payType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currencyCountry",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isPrivate",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RecruitRecommendation",
    "abstractKey": null
  };
}();
node199.hash = "cb34f323972e5ea35eb75fc8423532d3";
var RecommendationVacancyInfo_recommendation_graphql_default = node199;

// src/recommendations/candidates/components/RecommendationVacancyInfo.tsx
import { useFragment as useFragment46 } from "react-relay";
import { HtmlDisplay as HtmlDisplay4 } from "shared-ui";
import { jsx as jsx159, jsxs as jsxs109 } from "react/jsx-runtime";
var fragmentDef38 = RecommendationVacancyInfo_recommendation_graphql_default;
var RecommendationVacancyInfo = ({ fragmentRef }) => {
  const data = useFragment46(
    fragmentDef38,
    fragmentRef
  );
  return /* @__PURE__ */ jsxs109("div", { className: "mt-5 flex flex-col gap-4", children: [
    /* @__PURE__ */ jsxs109("div", { className: "flex flex-col gap-2 sm:flex-row", children: [
      data.vacancy.locations && /* @__PURE__ */ jsx159("div", { className: "w-full rounded-xl border bg-white p-4", children: /* @__PURE__ */ jsx159(LocationsList, { locations: data.vacancy.locations }) }),
      data.vacancy.rate && /* @__PURE__ */ jsx159("div", { className: "text-md flex w-full items-center justify-center rounded-xl border bg-white py-6 font-bold text-gray-700", children: /* @__PURE__ */ jsx159(RateInfo, { rate: data.vacancy.rate }) })
    ] }),
    data.vacancy.skillGroups && /* @__PURE__ */ jsx159("div", { className: "p-1", children: /* @__PURE__ */ jsx159(SkillGroupList, { skillGroups: data.vacancy.skillGroups }) }),
    /* @__PURE__ */ jsx159("div", { className: "text-md mt-3 px-2 font-medium text-gray-700", children: "Full Details" }),
    /* @__PURE__ */ jsx159("div", { className: "rounded-xl border border-t bg-white p-4", children: /* @__PURE__ */ jsx159(HtmlDisplay4, { html: data.vacancy.publicDescriptionHtml }) })
  ] });
};

// src/recommendations/candidates/components/__generated__/RecommendationWorkflowDeclined_recommendation.graphql.ts
var node200 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RecommendationWorkflowDeclined_recommendation",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recruitRecommendationId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentDecision",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasDeclined",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "declineReason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "declinedOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasGivenAvailabilityReason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "declinePreferredLocation",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "declinePreferredRateType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "declinePreferredRate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "availableInMonths",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RecommendationWorkflowChange_recommendation"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RecommendationWorkflowDeclinedNotAvailable_recommendation"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RecommendationWorkflowDeclinedUnsuitableSkills_recommendation"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RecommendationWorkflowDeclinedUnsuitableLocation_recommendation"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RecommendationWorkflowDeclinedUnsuitableRate_recommendation"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RecommendationWorkflowDeclinedNoReason_recommendation"
    }
  ],
  "type": "RecruitRecommendation",
  "abstractKey": null
};
node200.hash = "23e4965dddc3197d960e8e512d2c904e";
var RecommendationWorkflowDeclined_recommendation_graphql_default = node200;

// src/recommendations/candidates/components/RecommendationWorkflowDeclined.tsx
import { useCallback as useCallback108, useState as useState61 } from "react";
import { useFragment as useFragment53 } from "react-relay";
import { useLogger as useLogger21 } from "shared-lib";

// src/recommendations/candidates/components/__generated__/RecommendationWorkflowDeclinedNotAvailable_recommendation.graphql.ts
var node201 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RecommendationWorkflowDeclinedNotAvailable_recommendation",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recruitRecommendationId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasGivenAvailabilityReason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "availableInMonths",
      "storageKey": null
    }
  ],
  "type": "RecruitRecommendation",
  "abstractKey": null
};
node201.hash = "0ef7a09134edf91b22430ff2f89da08a";
var RecommendationWorkflowDeclinedNotAvailable_recommendation_graphql_default = node201;

// src/recommendations/candidates/components/RecommendationWorkflowDeclinedNotAvailable.tsx
import { useCallback as useCallback103, useState as useState56 } from "react";
import { useFragment as useFragment47 } from "react-relay";
import { Button as Button51, ButtonList as ButtonList15 } from "shared-ui";
import { jsx as jsx160, jsxs as jsxs110 } from "react/jsx-runtime";
var fragmentDef39 = RecommendationWorkflowDeclinedNotAvailable_recommendation_graphql_default;
var RecommendationWorkflowDeclinedNotAvailable = ({
  fragmentRef,
  candidateId,
  recommendationId,
  decisionToken,
  onChangeFeedback
}) => {
  const {
    recruitRecommendationId,
    hasGivenAvailabilityReason,
    availableInMonths
  } = useFragment47(
    fragmentDef39,
    fragmentRef
  );
  const [isChanging, setIsChanging] = useState56(false);
  const [setAvailability, isSettingAvailability] = useRecommendationDeclineFeedbackAvailability(
    candidateId,
    recommendationId,
    decisionToken
  );
  const onSelectedValueChanged = useCallback103(async (months) => {
    await setAvailability(months);
    setIsChanging(false);
  }, []);
  if (!hasGivenAvailabilityReason || isChanging) {
    return /* @__PURE__ */ jsxs110("div", { className: "flex flex-col gap-3", children: [
      /* @__PURE__ */ jsx160("div", { className: "text-primary-500", children: "When are you available ?" }),
      /* @__PURE__ */ jsx160("div", { children: /* @__PURE__ */ jsx160(
        AvailableInList,
        {
          disabled: isSettingAvailability,
          onChanged: onSelectedValueChanged
        }
      ) })
    ] });
  }
  return /* @__PURE__ */ jsxs110("div", { className: "flex flex-col gap-3", children: [
    /* @__PURE__ */ jsxs110("div", { className: "text-primary-500 flex items-center space-x-2", children: [
      /* @__PURE__ */ jsx160("div", { children: "You told us you are available in" }),
      /* @__PURE__ */ jsxs110("div", { className: "font-bold", children: [
        availableInMonths,
        " months"
      ] })
    ] }),
    /* @__PURE__ */ jsxs110(ButtonList15, { justify: "START", children: [
      /* @__PURE__ */ jsx160(Button51, { clicked: () => setIsChanging(true), children: "Change Availability" }),
      onChangeFeedback && /* @__PURE__ */ jsx160(Button51, { clicked: onChangeFeedback, color: "primary", children: "Change Reason" })
    ] })
  ] });
};

// src/recommendations/candidates/components/RecommendationDeclineMessage.tsx
import { jsx as jsx161, jsxs as jsxs111 } from "react/jsx-runtime";
var RecommendationDeclineMessage = ({
  message
}) => {
  return /* @__PURE__ */ jsxs111("div", { className: "whitespace-pre-wrap", children: [
    /* @__PURE__ */ jsx161("p", { children: "Thanks for taking the time to consider this role." }),
    message && /* @__PURE__ */ jsxs111("p", { children: [
      "You've declined it as ",
      message,
      "."
    ] }),
    /* @__PURE__ */ jsx161("p", { children: "Your feedback will help us make more suitable recommendations in the future." })
  ] });
};

// src/recommendations/candidates/components/RecommendationDeclineReasonSelector.tsx
import { useCallback as useCallback104, useState as useState57 } from "react";
import { ListDirection as ListDirection4, RadioList as RadioList8 } from "shared-ui";
import { jsx as jsx163 } from "react/jsx-runtime";
var list = [
  {
    id: "INCORRECT_AVAILABILITY" /* INCORRECT_AVAILABILITY */,
    label: "I'm Not Available"
  },
  {
    id: "INCORRECT_SKILLS" /* INCORRECT_SKILLS */,
    label: "The skills are not a good match"
  },
  {
    id: "INCORRECT_LOCATION" /* INCORRECT_LOCATION */,
    label: "The location is unsuitable"
  },
  {
    id: "INCORRECT_RATE" /* INCORRECT_RATE */,
    label: "The rate is too low"
  },
  {
    id: "NOT_INTERESTED" /* NOT_INTERESTED */,
    label: "I'm just not interested"
  }
];
var RecommendationDeclineReasonSelector = ({
  id: id18,
  onChanged,
  disabled
}) => {
  const [selectedId, setSelectedId] = useState57(
    id18 || "NOT_INTERESTED" /* NOT_INTERESTED */
  );
  const change = useCallback104(
    (ms) => {
      setSelectedId(ms.id);
      onChanged(ms.id);
    },
    [setSelectedId]
  );
  const current = list.find((s4) => s4.id === selectedId);
  return /* @__PURE__ */ jsx163(
    RadioList8,
    {
      disabled,
      direction: ListDirection4.Vertical,
      list,
      value: current,
      onChange: (status) => change(status)
    }
  );
};

// src/recommendations/candidates/components/__generated__/RecommendationWorkflowDeclinedUnsuitableSkills_recommendation.graphql.ts
var node203 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "RecommendationWorkflowDeclinedUnsuitableSkills_recommendation",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "recruitRecommendationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currentDecision",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "declineReason",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitSkillTag",
        "kind": "LinkedField",
        "name": "feedbackSkills",
        "plural": true,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RecruitRecommendation",
    "abstractKey": null
  };
}();
node203.hash = "4723cb645e7a5b464be5bcf52b76139e";
var RecommendationWorkflowDeclinedUnsuitableSkills_recommendation_graphql_default = node203;

// src/recommendations/candidates/components/RecommendationWorkflowDeclinedUnsuitableSkills.tsx
import { useCallback as useCallback105, useState as useState58 } from "react";
import { useFragment as useFragment48 } from "react-relay";
import { Button as Button53, ButtonList as ButtonList16, Size as Size31 } from "shared-ui";
import { useLogger as useLogger20 } from "shared-lib";
import { jsx as jsx164, jsxs as jsxs113 } from "react/jsx-runtime";
var fragmentDef40 = RecommendationWorkflowDeclinedUnsuitableSkills_recommendation_graphql_default;
var RecommendationWorkflowDeclinedUnsuitableSkills = ({
  candidateId,
  recommendationId,
  decisionToken,
  fragmentRef,
  onChangeFeedback
}) => {
  const [log] = useLogger20();
  const { feedbackSkills } = useFragment48(
    fragmentDef40,
    fragmentRef
  );
  const [isChanging, setIsChanging] = useState58(false);
  const [feedback, isFeedingBack] = useRecommendationDeclineFeedbackSkills(
    candidateId,
    recommendationId,
    () => {
      log("Feed Back Skills Done");
    },
    decisionToken
  );
  const [skills, setSkills] = useState58([]);
  const addSkill = useCallback105((result) => {
    setSkills((s4) => [...s4, result]);
  }, []);
  const removeSkill = useCallback105((result) => {
    setSkills((s4) => s4.filter((skill) => skill.skillId !== result.skillId));
  }, []);
  const addSkillsFeedback = useCallback105(() => {
    log("Feeding Back Skills");
    const tags = skills.map((s4) => ({
      id: s4.skillId,
      name: s4.skillName
    }));
    feedback(tags);
    setIsChanging(false);
  }, [skills, log]);
  return /* @__PURE__ */ jsx164("div", { className: "mt-3 flex flex-col gap-3", children: !isChanging && feedbackSkills && feedbackSkills.length > 0 ? /* @__PURE__ */ jsxs113("div", { children: [
    /* @__PURE__ */ jsx164("div", { children: "You told us you wanted jobs with the following skills" }),
    /* @__PURE__ */ jsx164("div", { className: "flex flex-wrap gap-1 pt-2", children: feedbackSkills.map((skill) => /* @__PURE__ */ jsx164(
      "div",
      {
        className: "bg-info-500 rounded-lg px-2.5 py-1 font-medium text-white",
        children: skill.name
      },
      skill.id
    )) }),
    /* @__PURE__ */ jsxs113(ButtonList16, { justify: "START", children: [
      /* @__PURE__ */ jsx164(Button53, { clicked: () => setIsChanging(true), children: "Change Skills" }),
      /* @__PURE__ */ jsx164(Button53, { clicked: onChangeFeedback, color: "primary", children: "Change Reason" })
    ] })
  ] }) : /* @__PURE__ */ jsxs113("div", { children: [
    /* @__PURE__ */ jsx164("div", { children: "What skills are more suitable?" }),
    /* @__PURE__ */ jsx164("div", { children: /* @__PURE__ */ jsx164(
      SkillSearchBox,
      {
        autoClearSelected: true,
        placeholder: "Search Skills",
        onSelected: addSkill
      }
    ) }),
    skills && /* @__PURE__ */ jsx164("div", { children: /* @__PURE__ */ jsx164("div", { className: "flex flex-wrap gap-1", children: skills.map((skill) => /* @__PURE__ */ jsxs113(
      "div",
      {
        className: "text-md flex items-center justify-between border border-gray-200 bg-white font-medium",
        children: [
          /* @__PURE__ */ jsx164("div", { className: "text-info-500 border-r bg-white px-2.5 py-2", children: skill.skillName }),
          /* @__PURE__ */ jsx164(
            "div",
            {
              className: "cursor-pointer bg-white px-4 py-2 font-bold text-gray-900 hover:bg-gray-200",
              onClick: () => removeSkill(skill),
              children: "x"
            }
          )
        ]
      },
      skill.skillId
    )) }) }),
    skills && /* @__PURE__ */ jsx164(ButtonList16, { children: /* @__PURE__ */ jsx164(
      Button53,
      {
        disabled: skills.length === 0 || isFeedingBack,
        clicked: addSkillsFeedback,
        color: "primary",
        size: Size31.lg,
        children: "Add Feedback"
      }
    ) })
  ] }) });
};

// src/recommendations/candidates/components/__generated__/RecommendationWorkflowDeclinedUnsuitableLocation_recommendation.graphql.ts
var node204 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RecommendationWorkflowDeclinedUnsuitableLocation_recommendation",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recruitRecommendationId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "declinePreferredLocation",
      "storageKey": null
    }
  ],
  "type": "RecruitRecommendation",
  "abstractKey": null
};
node204.hash = "804af34959d787dcc46415b08cdff00f";
var RecommendationWorkflowDeclinedUnsuitableLocation_recommendation_graphql_default = node204;

// src/recommendations/candidates/components/RecommendationWorkflowDeclinedUnsuitableLocation.tsx
import { useCallback as useCallback106, useState as useState59 } from "react";
import { useFragment as useFragment49 } from "react-relay";
import { Button as Button54, ButtonList as ButtonList17 } from "shared-ui";
import {
  GeoLocationsSearchContainer as GeoLocationsSearchContainer3
} from "feature-data-management";
import { jsx as jsx165, jsxs as jsxs114 } from "react/jsx-runtime";
var fragmentDef41 = RecommendationWorkflowDeclinedUnsuitableLocation_recommendation_graphql_default;
var RecommendationWorkflowDeclinedUnsuitableLocation = ({
  fragmentRef,
  candidateId,
  recommendationId,
  decisionToken,
  onChangeFeedback
}) => {
  const data = useFragment49(
    fragmentDef41,
    fragmentRef
  );
  const [isChanging, setIsChanging] = useState59(false);
  const [addLocation, isAddingLocation] = useRecommendationDeclineFeedbackLocation(
    candidateId,
    recommendationId,
    decisionToken
  );
  const onSelectLocation = useCallback106(
    async (result) => {
      const location2 = {
        name: result.name,
        latitude: result.latitude,
        longitude: result.longitude,
        countryCode: result.countryCode
      };
      const code = await addLocation(location2);
      setIsChanging(false);
    },
    []
  );
  if (!data.declinePreferredLocation || isChanging) {
    return /* @__PURE__ */ jsxs114("div", { className: "flex flex-col gap-3", children: [
      /* @__PURE__ */ jsx165("div", { className: "text-primary-500", children: "What Locations do you want to work in ?" }),
      /* @__PURE__ */ jsx165(
        GeoLocationsSearchContainer3,
        {
          name: "location-search",
          autoClearSelected: true,
          onSearchCompleted: onSelectLocation
        }
      )
    ] });
  }
  return /* @__PURE__ */ jsxs114("div", { className: "flex flex-col gap-3", children: [
    /* @__PURE__ */ jsxs114("div", { className: "text-primary-500", children: [
      "You told us you'd prefer jobs in",
      " ",
      /* @__PURE__ */ jsx165("span", { className: "font-bold", children: data.declinePreferredLocation })
    ] }),
    /* @__PURE__ */ jsxs114(ButtonList17, { justify: "START", children: [
      /* @__PURE__ */ jsx165(Button54, { clicked: () => setIsChanging(true), children: "Change Location" }),
      /* @__PURE__ */ jsx165(Button54, { clicked: onChangeFeedback, color: "primary", children: "Change Reason" })
    ] })
  ] });
};

// src/recommendations/candidates/components/__generated__/RecommendationWorkflowDeclinedUnsuitableRate_recommendation.graphql.ts
var node205 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RecommendationWorkflowDeclinedUnsuitableRate_recommendation",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recruitRecommendationId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "declinePreferredRate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "declinePreferredRateType",
      "storageKey": null
    }
  ],
  "type": "RecruitRecommendation",
  "abstractKey": null
};
node205.hash = "2872c15fda262f093ecd56bbeb597475";
var RecommendationWorkflowDeclinedUnsuitableRate_recommendation_graphql_default = node205;

// src/recommendations/candidates/components/RecommendationWorkflowDeclinedUnsuitableRate.tsx
import { useCallback as useCallback107, useState as useState60 } from "react";
import { useFragment as useFragment50 } from "react-relay";
import { useForm as useForm16 } from "react-hook-form";
import { z as z8 } from "zod";
import { zodResolver as zodResolver16 } from "@hookform/resolvers/zod";
import {
  Button as Button55,
  ButtonList as ButtonList18,
  ErrorField as ErrorField6,
  FormInput as FormInput10,
  FormInputRow as FormInputRow6,
  Size as Size33
} from "shared-ui";
import { PayTypesControl } from "app-core";
import { jsx as jsx166, jsxs as jsxs115 } from "react/jsx-runtime";
var fragmentDef42 = RecommendationWorkflowDeclinedUnsuitableRate_recommendation_graphql_default;
var PayTypes2 = /* @__PURE__ */ ((PayTypes3) => {
  PayTypes3["PER_DAY"] = "PER_DAY";
  PayTypes3["PER_HOUR"] = "PER_HOUR";
  PayTypes3["PER_YEAR"] = "PER_YEAR";
  return PayTypes3;
})(PayTypes2 || {});
var formSchema9 = z8.object({
  amount: z8.number(),
  payType: z8.nativeEnum(PayTypes2)
});
var RecommendationRateForm = ({ disabled, onChanged }) => {
  const defaultValues2 = {
    amount: 0,
    payType: "PER_DAY" /* PER_DAY */
  };
  const { register, handleSubmit, formState, control } = useForm16({
    resolver: zodResolver16(formSchema9),
    defaultValues: defaultValues2
  });
  const { errors, isValid, isDirty } = formState;
  const onSubmit = handleSubmit(
    (valid) => {
      if (!valid.payType || !valid.amount) {
        return;
      }
      onChanged({
        amount: valid.amount,
        payType: valid.payType
      });
    },
    (invalid) => {
      console.log(invalid);
    }
  );
  return /* @__PURE__ */ jsx166("div", { className: "space-y-6 rounded-lg bg-white px-4 py-5 shadow-lg ring-1 ring-black ring-opacity-5 sm:p-6", children: /* @__PURE__ */ jsxs115("form", { onSubmit, children: [
    /* @__PURE__ */ jsxs115(FormInputRow6, { name: "amount", title: "Rate Amount", children: [
      /* @__PURE__ */ jsx166(
        FormInput10,
        {
          className: "mt-1",
          type: "number",
          placeholder: " e.g. \xA350 ",
          name: "amount",
          required: true,
          disabled,
          register
        }
      ),
      /* @__PURE__ */ jsx166(ErrorField6, { field: errors.amount })
    ] }),
    /* @__PURE__ */ jsxs115(FormInputRow6, { name: "payType", title: "Pay Type", children: [
      /* @__PURE__ */ jsx166(PayTypesControl, { disabled, control }),
      /* @__PURE__ */ jsx166(ErrorField6, { field: errors.payType })
    ] }),
    /* @__PURE__ */ jsx166("div", { className: "mt-4 flex items-center justify-end space-x-4", children: /* @__PURE__ */ jsx166(
      Button55,
      {
        type: "submit",
        disabled: !isDirty || !isValid || disabled,
        color: "primary",
        size: Size33.xl,
        children: "Save"
      }
    ) })
  ] }) });
};
var RecommendationWorkflowDeclinedUnsuitableRate = ({
  fragmentRef,
  candidateId,
  recommendationId,
  decisionToken,
  onChangeFeedback
}) => {
  const {
    recruitRecommendationId,
    declinePreferredRate,
    declinePreferredRateType
  } = useFragment50(
    fragmentDef42,
    fragmentRef
  );
  const [isChanging, setIsChanging] = useState60(false);
  const [setRate, isSettingRate] = useRecommendationDeclineFeedbackRate(
    candidateId,
    recommendationId,
    decisionToken
  );
  const onSelectLocation = useCallback107(async (result) => {
    const code = setRate(result.amount, result.payType);
    setIsChanging(false);
  }, []);
  if (!declinePreferredRate || !declinePreferredRateType || isChanging) {
    return /* @__PURE__ */ jsxs115("div", { className: "flex flex-col gap-3", children: [
      /* @__PURE__ */ jsx166("div", { className: "text-primary-500", children: "What rate are you looking for ?" }),
      /* @__PURE__ */ jsx166("div", { children: /* @__PURE__ */ jsx166(
        RecommendationRateForm,
        {
          disabled: isSettingRate,
          onChanged: onSelectLocation
        }
      ) })
    ] });
  }
  return /* @__PURE__ */ jsxs115("div", { className: "flex flex-col gap-3", children: [
    /* @__PURE__ */ jsxs115("div", { className: "text-primary-500", children: [
      "You told us you want",
      " ",
      /* @__PURE__ */ jsxs115("span", { className: "font-bold", children: [
        declinePreferredRate,
        " ",
        declinePreferredRateType
      ] })
    ] }),
    /* @__PURE__ */ jsxs115(ButtonList18, { justify: "START", children: [
      /* @__PURE__ */ jsx166(Button55, { clicked: () => setIsChanging(true), children: "Change Rate" }),
      /* @__PURE__ */ jsx166(Button55, { clicked: onChangeFeedback, color: "primary", children: "Change Reason" })
    ] })
  ] });
};

// src/recommendations/candidates/components/__generated__/RecommendationWorkflowDeclinedNoReason_recommendation.graphql.ts
var node206 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RecommendationWorkflowDeclinedNoReason_recommendation",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recruitRecommendationId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "declineReason",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RecommendationWorkflowDeclineReason_recommendation"
    }
  ],
  "type": "RecruitRecommendation",
  "abstractKey": null
};
node206.hash = "5133f9f96885fa002d3540aa79d76323";
var RecommendationWorkflowDeclinedNoReason_recommendation_graphql_default = node206;

// src/recommendations/candidates/components/RecommendationWorkflowDeclinedNoReason.tsx
import { useFragment as useFragment51 } from "react-relay";
import { Button as Button56, Size as Size34 } from "shared-ui";
import { jsx as jsx167 } from "react/jsx-runtime";
var fragmentDef43 = RecommendationWorkflowDeclinedNoReason_recommendation_graphql_default;
var RecommendationWorkflowDeclinedNoReason = ({
  fragmentRef,
  candidateId,
  recommendationId,
  decisionToken,
  onChangeFeedback
}) => {
  const data = useFragment51(
    fragmentDef43,
    fragmentRef
  );
  return /* @__PURE__ */ jsx167("div", { className: "flex flex-col", children: /* @__PURE__ */ jsx167(Button56, { color: "primary", size: Size34.lg, clicked: onChangeFeedback, children: "Add Feedback" }) });
};

// src/recommendations/candidates/components/RecommendationWorkflowDeclined.tsx
import { jsx as jsx168, jsxs as jsxs116 } from "react/jsx-runtime";
var fragmentDef44 = RecommendationWorkflowDeclined_recommendation_graphql_default;
var RecommendationWorkflowDeclined = ({
  fragmentRef,
  candidateId,
  recommendationId,
  decisionToken,
  onDone
}) => {
  const [log] = useLogger21();
  const data = useFragment53(
    fragmentDef44,
    fragmentRef
  );
  const [addDeclineReason, isAddingDeclineReason] = useRecommendationDecline(
    candidateId,
    recommendationId,
    () => {
      log(`Added Decline Reason`);
    },
    decisionToken
  );
  const [declineReason, setDeclineReason] = useState61(data.declineReason);
  const changeDeclineReason = useCallback108(
    (reason) => {
      setDeclineReason(reason);
      addDeclineReason(reason);
    },
    [setDeclineReason]
  );
  let nextAction = null;
  let declineReasonMessage = null;
  if (declineReason) {
    switch (declineReason) {
      case "INCORRECT_AVAILABILITY": {
        nextAction = /* @__PURE__ */ jsx168(
          RecommendationWorkflowDeclinedNotAvailable,
          {
            candidateId,
            recommendationId,
            decisionToken,
            fragmentRef: data,
            onChangeFeedback: () => setDeclineReason(null)
          }
        );
        declineReasonMessage = " you are not available at the moment";
        break;
      }
      case "INCORRECT_LOCATION": {
        nextAction = /* @__PURE__ */ jsx168(
          RecommendationWorkflowDeclinedUnsuitableLocation,
          {
            candidateId,
            recommendationId,
            decisionToken,
            fragmentRef: data,
            onChangeFeedback: () => setDeclineReason(null)
          }
        );
        declineReasonMessage = " the location is not right";
        break;
      }
      case "INCORRECT_RATE": {
        nextAction = /* @__PURE__ */ jsx168(
          RecommendationWorkflowDeclinedUnsuitableRate,
          {
            recommendationId,
            candidateId,
            decisionToken,
            fragmentRef: data,
            onChangeFeedback: () => setDeclineReason(null)
          }
        );
        declineReasonMessage = " the rate was not suitable";
        break;
      }
      case "INCORRECT_SKILLS": {
        nextAction = /* @__PURE__ */ jsx168(
          RecommendationWorkflowDeclinedUnsuitableSkills,
          {
            candidateId,
            recommendationId,
            decisionToken,
            fragmentRef: data,
            onChangeFeedback: () => setDeclineReason(null)
          }
        );
        declineReasonMessage = " the skills are not a good match";
        break;
      }
      case "NOT_INTERESTED": {
        nextAction = /* @__PURE__ */ jsx168(
          RecommendationWorkflowDeclinedNoReason,
          {
            candidateId,
            recommendationId,
            decisionToken,
            fragmentRef: data,
            onChangeFeedback: () => setDeclineReason(null)
          }
        );
        declineReasonMessage = " you are just not interested in it";
        break;
      }
      case "REMOVE_DATA": {
        nextAction = /* @__PURE__ */ jsx168("div", { children: "REMOVE_DATA" });
        declineReasonMessage = " you want us to remove your account and data";
        break;
      }
      default: {
        nextAction = /* @__PURE__ */ jsx168(
          RecommendationDeclineReasonSelector,
          {
            id: declineReason,
            disabled: isAddingDeclineReason,
            onChanged: changeDeclineReason
          }
        );
        break;
      }
    }
  } else {
    nextAction = /* @__PURE__ */ jsx168(
      RecommendationDeclineReasonSelector,
      {
        id: declineReason,
        disabled: isAddingDeclineReason,
        onChanged: changeDeclineReason
      }
    );
  }
  return /* @__PURE__ */ jsxs116("div", { className: "flex flex-col gap-3", children: [
    /* @__PURE__ */ jsx168("div", { className: "border bg-white p-4", children: /* @__PURE__ */ jsxs116("h5", { className: "text-md text-primary-500 font-bold", children: [
      "You have ",
      /* @__PURE__ */ jsx168("strong", { children: "declined" }),
      " this role"
    ] }) }),
    /* @__PURE__ */ jsx168("div", { className: "border bg-white p-4", children: /* @__PURE__ */ jsx168(RecommendationDeclineMessage, { message: declineReasonMessage }) }),
    /* @__PURE__ */ jsx168("div", { className: "border bg-white p-4", children: nextAction }),
    /* @__PURE__ */ jsx168("div", { className: "border bg-white p-4", children: /* @__PURE__ */ jsx168(
      RecommendationWorkflowChange,
      {
        fragmentRef: data,
        candidateId,
        recommendationId,
        decisionToken,
        onDone
      }
    ) })
  ] });
};

// src/recommendations/candidates/components/RecommendationContainer.tsx
import { Fragment as Fragment40, jsx as jsx169, jsxs as jsxs117 } from "react/jsx-runtime";
var fragmentDef45 = RecommendationContainer_recommendation_graphql_default;
var RecommendationContainer = ({
  candidateId,
  recommendationId,
  decisionToken,
  fragmentRef,
  onDone,
  showMobileNavigation = true
}) => {
  const data = useFragment54(
    fragmentDef45,
    fragmentRef
  );
  if (!data) {
    return /* @__PURE__ */ jsx169(EdSkeleton43, {});
  }
  const { currentStatus } = data;
  let actions = /* @__PURE__ */ jsx169("div", {});
  switch (currentStatus) {
    case "APPLIED": {
      actions = /* @__PURE__ */ jsx169(
        RecommendationWorkflowAppliedContainer,
        {
          candidateId,
          recommendationId,
          decisionToken,
          fragmentRef: data,
          onDone
        }
      );
      break;
    }
    case "DECLINED": {
      actions = /* @__PURE__ */ jsx169(
        RecommendationWorkflowDeclined,
        {
          candidateId,
          recommendationId,
          decisionToken,
          fragmentRef: data,
          onDone
        }
      );
      break;
    }
    case "NOT_AVAILABLE": {
      actions = /* @__PURE__ */ jsx169(
        RecommendationWorkflowDeclinedNotAvailable,
        {
          candidateId,
          recommendationId,
          decisionToken,
          fragmentRef: data
        }
      );
      break;
    }
    case "CLOSED": {
      actions = /* @__PURE__ */ jsx169("div", { className: "flex w-full justify-center rounded-lg bg-red-500 p-4 text-white", children: /* @__PURE__ */ jsx169("div", { children: "This Vacancy is now closed." }) });
      break;
    }
    case "EXPIRED": {
      actions = /* @__PURE__ */ jsx169("div", { className: "flex w-full justify-center rounded-lg bg-red-500 p-4 text-white", children: /* @__PURE__ */ jsx169("div", { children: "This Vacancy Recommendation has expired." }) });
      break;
    }
    case "CREATED": {
      actions = /* @__PURE__ */ jsx169("div", {});
      break;
    }
    case "RECOMMENDED": {
      actions = /* @__PURE__ */ jsx169(
        RecommendationNoDecision,
        {
          candidateId,
          recommendationId,
          decisionToken,
          fragmentRef: data,
          onDone
        }
      );
      break;
    }
    default: {
      actions = /* @__PURE__ */ jsx169("div", {});
      break;
    }
  }
  const isInactive = [
    "CLOSED",
    "EXPIRED",
    "NOT_AVAILABLE",
    "DECLINED"
  ].includes(currentStatus);
  return /* @__PURE__ */ jsxs117(Fragment40, { children: [
    /* @__PURE__ */ jsxs117("div", { className: "flex flex-col lg:flex-col-reverse", children: [
      showMobileNavigation && /* @__PURE__ */ jsx169(
        MobileHeader2,
        {
          showMobileNavIcon: true,
          title: /* @__PURE__ */ jsx169("div", { className: "flex w-full items-center justify-center lg:justify-between", children: /* @__PURE__ */ jsx169("div", { className: "text-2xl font-bold", children: data.vacancyName }) })
        }
      ),
      /* @__PURE__ */ jsx169(
        BreadcrumbLinks,
        {
          recommendation: {
            name: data.vacancyName,
            id: data.recruitRecommendationId
          }
        }
      )
    ] }),
    /* @__PURE__ */ jsxs117("div", { className: "mt-5 px-4 xl:container sm:my-8 sm:px-6 lg:px-8", children: [
      /* @__PURE__ */ jsx169("div", { className: "", children: actions }),
      /* @__PURE__ */ jsx169("div", { className: classNames20(isInactive && "opacity-50 grayscale"), children: /* @__PURE__ */ jsx169(RecommendationVacancyInfo, { fragmentRef: data }) })
    ] })
  ] });
};
var BreadcrumbLinks = ({
  recommendation
}) => {
  return /* @__PURE__ */ jsx169("div", { className: "flex flex-col-reverse md:flex-col", children: /* @__PURE__ */ jsx169(
    Breadcrumbs3,
    {
      links: [
        {
          name: "Recommendations",
          href: "/candidates/app/jobs/recommendations/"
        },
        {
          name: recommendation.name,
          href: `/candidates/app/jobs/recommendation/${recommendation.id}`
        }
      ]
    }
  ) });
};

// src/recommendations/candidates/components/__generated__/RecommendationHeader_recommendation.graphql.ts
var node207 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RecommendationHeader_recommendation",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Vacancy",
      "kind": "LinkedField",
      "name": "vacancy",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RecruitRecommendation",
  "abstractKey": null
};
node207.hash = "dad63e928234fbd61c4d66dfc326e8bd";
var RecommendationHeader_recommendation_graphql_default = node207;

// src/recommendations/candidates/components/RecommendationHeader.tsx
import { useFragment as useFragment55 } from "react-relay";
import { jsx as jsx170, jsxs as jsxs118 } from "react/jsx-runtime";
var fragmentDef46 = RecommendationHeader_recommendation_graphql_default;
var RecommendationHeader = ({
  fragmentRef
}) => {
  const { vacancy } = useFragment55(
    fragmentDef46,
    fragmentRef
  );
  return /* @__PURE__ */ jsx170("div", { className: "mb-2 border-b bg-white p-3 sm:border", children: /* @__PURE__ */ jsxs118("div", { className: "flex items-center space-x-2 text-xl", children: [
    vacancy.name,
    " (",
    vacancy.code,
    ")"
  ] }) });
};

// src/recommendations/candidates/components/PublicRecommendationLayout.tsx
import { jsx as jsx171, jsxs as jsxs119 } from "react/jsx-runtime";
var publicRecommendationLayoutQueryDef = PublicRecommendationLayoutQuery_graphql_default;
var PublicRecommendationLayout = ({
  queryRef: queryRef3,
  token,
  onResponseCompleted
}) => {
  const data = usePreloadedQuery14(
    publicRecommendationLayoutQueryDef,
    queryRef3
  );
  const { recommendation } = data;
  if (!recommendation) {
    return /* @__PURE__ */ jsx171("div", { children: "Recommendation Not Found" });
  }
  return /* @__PURE__ */ jsx171(Suspense49, { fallback: /* @__PURE__ */ jsx171(EdSkeleton44, {}), children: /* @__PURE__ */ jsx171(Routes3, { children: /* @__PURE__ */ jsx171(
    Route3,
    {
      path: ":decisionToken?",
      element: /* @__PURE__ */ jsxs119("div", { children: [
        /* @__PURE__ */ jsx171(RecommendationHeader, { fragmentRef: recommendation }),
        /* @__PURE__ */ jsx171(
          RecommendationContainer,
          {
            recommendationId: recommendation.recruitRecommendationId,
            candidateId: recommendation.candidateId,
            decisionToken: token,
            fragmentRef: recommendation,
            onDone: onResponseCompleted
          }
        )
      ] })
    }
  ) }) });
};

// src/recommendations/candidates/components/PublicRecommendationLoader.tsx
import { Suspense as Suspense50, useEffect as useEffect24 } from "react";
import { useQueryLoader as useQueryLoader6 } from "react-relay";
import { EdSkeleton as EdSkeleton45 } from "shared-ui";
import { jsx as jsx173 } from "react/jsx-runtime";
var PublicRecommendationLoader = ({
  recommendationId,
  token,
  onResponseCompleted
}) => {
  const [queryReference, loadQuery48, disposeQuery] = useQueryLoader6(
    publicRecommendationLayoutQueryDef
  );
  useEffect24(() => {
    loadQuery48({ recommendationId, token });
  }, [recommendationId, loadQuery48]);
  if (!queryReference) {
    return /* @__PURE__ */ jsx173("div", { className: "m-8", children: /* @__PURE__ */ jsx173(EdSkeleton45, {}) });
  }
  return /* @__PURE__ */ jsx173(Suspense50, { fallback: /* @__PURE__ */ jsx173(EdSkeleton45, {}), children: /* @__PURE__ */ jsx173(
    PublicRecommendationLayout,
    {
      queryRef: queryReference,
      token,
      onResponseCompleted
    }
  ) });
};

// src/recommendations/candidates/components/__generated__/RecommendationExpired_recommendation.graphql.ts
var node208 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RecommendationExpired_recommendation",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recruitRecommendationId",
      "storageKey": null
    }
  ],
  "type": "RecruitRecommendation",
  "abstractKey": null
};
node208.hash = "6619e8e3a25542f78448f835d9cb8205";
var RecommendationExpired_recommendation_graphql_default = node208;

// src/recommendations/candidates/components/RecommendationExpired.tsx
import { useFragment as useFragment56 } from "react-relay";
import { jsx as jsx174 } from "react/jsx-runtime";
var fragmentDef47 = RecommendationExpired_recommendation_graphql_default;
var RecommendationExpired = ({
  fragmentRef
}) => {
  const { recruitRecommendationId } = useFragment56(
    fragmentDef47,
    fragmentRef
  );
  return /* @__PURE__ */ jsx174("div", { className: "flex flex-col", children: /* @__PURE__ */ jsx174("div", {}) });
};

// src/recommendations/candidates/components/__generated__/RecommendationLayoutQuery.graphql.ts
var node209 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "recommendationId"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "recommendationId"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "recruitRecommendationId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateId",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "vacancyName",
    "storageKey": null
  }, v6 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationType",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationAmount",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "RecommendationLayoutQuery",
      "selections": [
        {
          "alias": "recommendation",
          "args": v1,
          "concreteType": "RecruitRecommendation",
          "kind": "LinkedField",
          "name": "recruitRecommendationById",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            v5,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "RecommendationContainer_recommendation"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "RecommendationHeader_recommendation"
            },
            v6
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "RecommendationLayoutQuery",
      "selections": [
        {
          "alias": "recommendation",
          "args": v1,
          "concreteType": "RecruitRecommendation",
          "kind": "LinkedField",
          "name": "recruitRecommendationById",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            v5,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedOn",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "currentStatus",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Vacancy",
              "kind": "LinkedField",
              "name": "vacancy",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "code",
                  "storageKey": null
                },
                v23,
                v7,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "publicDescriptionHtml",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SkillGroup",
                  "kind": "LinkedField",
                  "name": "skillGroups",
                  "plural": true,
                  "selections": [
                    v23,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "skillGroupId",
                      "storageKey": null
                    },
                    v7,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "SkillGroupTerm",
                      "kind": "LinkedField",
                      "name": "terms",
                      "plural": true,
                      "selections": [
                        v7,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isSkill",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Duration",
                      "kind": "LinkedField",
                      "name": "recency",
                      "plural": false,
                      "selections": [
                        v8,
                        v9
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isRequired",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "weight",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Duration",
                      "kind": "LinkedField",
                      "name": "experience",
                      "plural": false,
                      "selections": [
                        v9,
                        v8
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "LocationCriteria",
                  "kind": "LinkedField",
                  "name": "locations",
                  "plural": true,
                  "selections": [
                    v7,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "state",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "countryCode",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "countryName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "latitude",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "longitude",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "radius",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "entireCountry",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "employerLogoUrl",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "expiresAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "VacancyDates",
                  "kind": "LinkedField",
                  "name": "dates",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "startDate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "durationCode",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "durationDescription",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "startAsap",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "VacancyRate",
                  "kind": "LinkedField",
                  "name": "rate",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "max",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "min",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currencyCode",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "payType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currencyCountry",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isPrivate",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "currentDecision",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "declineReason",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasGivenAvailabilityReason",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "availableInMonths",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasDeclined",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "declinedOn",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "declinePreferredLocation",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "declinePreferredRateType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "declinePreferredRate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitSkillTag",
              "kind": "LinkedField",
              "name": "feedbackSkills",
              "plural": true,
              "selections": [
                v23,
                v7
              ],
              "storageKey": null
            },
            v6
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "9ac917b3160a90705a4b1244a7c76f81",
      "id": null,
      "metadata": {},
      "name": "RecommendationLayoutQuery",
      "operationKind": "query",
      "text": "query RecommendationLayoutQuery(\n  $recommendationId: UUID!\n) {\n  recommendation: recruitRecommendationById(id: $recommendationId) {\n    id\n    recruitRecommendationId\n    candidateId\n    vacancyName\n    ...RecommendationContainer_recommendation\n    ...RecommendationHeader_recommendation\n  }\n}\n\nfragment RecommendationContainer_recommendation on RecruitRecommendation {\n  id\n  recruitRecommendationId\n  updatedOn\n  currentStatus\n  vacancyName\n  vacancy {\n    code\n    id\n  }\n  ...RecommendationWorkflowAppliedContainer_recommendation\n  ...RecommendationWorkflowDeclinedNotAvailable_recommendation\n  ...RecommendationWorkflowDeclined_recommendation\n  ...RecommendationNoDecision_recommendation\n  ...RecommendationVacancyInfo_recommendation\n}\n\nfragment RecommendationHeader_recommendation on RecruitRecommendation {\n  id\n  vacancy {\n    name\n    code\n    id\n  }\n}\n\nfragment RecommendationNoDecision_recommendation on RecruitRecommendation {\n  id\n  recruitRecommendationId\n}\n\nfragment RecommendationVacancyInfo_recommendation on RecruitRecommendation {\n  id\n  recruitRecommendationId\n  vacancy {\n    name\n    code\n    publicDescriptionHtml\n    skillGroups {\n      id\n      skillGroupId\n      name\n      terms {\n        name\n        isSkill\n      }\n      recency {\n        durationType\n        durationAmount\n      }\n      isRequired\n      weight\n      experience {\n        durationAmount\n        durationType\n      }\n    }\n    locations {\n      name\n      state\n      countryCode\n      countryName\n      latitude\n      longitude\n      radius\n      entireCountry\n    }\n    employerLogoUrl\n    expiresAt\n    dates {\n      startDate\n      durationCode\n      durationDescription\n      startAsap\n    }\n    rate {\n      max\n      min\n      currencyCode\n      payType\n      currencyCountry\n      isPrivate\n    }\n    id\n  }\n}\n\nfragment RecommendationWorkflowAppliedContainer_recommendation on RecruitRecommendation {\n  id\n  recruitRecommendationId\n  currentStatus\n  ...RecommendationWorkflowChange_recommendation\n}\n\nfragment RecommendationWorkflowChange_recommendation on RecruitRecommendation {\n  id\n  recruitRecommendationId\n  currentStatus\n  currentDecision\n  declineReason\n}\n\nfragment RecommendationWorkflowDeclineReason_recommendation on RecruitRecommendation {\n  id\n  recruitRecommendationId\n  declineReason\n}\n\nfragment RecommendationWorkflowDeclinedNoReason_recommendation on RecruitRecommendation {\n  id\n  recruitRecommendationId\n  declineReason\n  ...RecommendationWorkflowDeclineReason_recommendation\n}\n\nfragment RecommendationWorkflowDeclinedNotAvailable_recommendation on RecruitRecommendation {\n  recruitRecommendationId\n  hasGivenAvailabilityReason\n  availableInMonths\n}\n\nfragment RecommendationWorkflowDeclinedUnsuitableLocation_recommendation on RecruitRecommendation {\n  recruitRecommendationId\n  declinePreferredLocation\n}\n\nfragment RecommendationWorkflowDeclinedUnsuitableRate_recommendation on RecruitRecommendation {\n  recruitRecommendationId\n  declinePreferredRate\n  declinePreferredRateType\n}\n\nfragment RecommendationWorkflowDeclinedUnsuitableSkills_recommendation on RecruitRecommendation {\n  id\n  recruitRecommendationId\n  currentDecision\n  declineReason\n  feedbackSkills {\n    id\n    name\n  }\n}\n\nfragment RecommendationWorkflowDeclined_recommendation on RecruitRecommendation {\n  id\n  recruitRecommendationId\n  currentStatus\n  currentDecision\n  hasDeclined\n  declineReason\n  declinedOn\n  hasGivenAvailabilityReason\n  declinePreferredLocation\n  declinePreferredRateType\n  declinePreferredRate\n  availableInMonths\n  ...RecommendationWorkflowChange_recommendation\n  ...RecommendationWorkflowDeclinedNotAvailable_recommendation\n  ...RecommendationWorkflowDeclinedUnsuitableSkills_recommendation\n  ...RecommendationWorkflowDeclinedUnsuitableLocation_recommendation\n  ...RecommendationWorkflowDeclinedUnsuitableRate_recommendation\n  ...RecommendationWorkflowDeclinedNoReason_recommendation\n}\n"
    }
  };
}();
node209.hash = "3be1c991bfb704bc0128057544bbf1bc";
var RecommendationLayoutQuery_graphql_default = node209;

// src/recommendations/candidates/components/RecommendationLayout.tsx
import { Suspense as Suspense51 } from "react";
import { usePreloadedQuery as usePreloadedQuery15 } from "react-relay";
import { Route as Route4, Routes as Routes4 } from "react-router-dom";
import { EdSkeleton as EdSkeleton46 } from "shared-ui";
import { jsx as jsx175 } from "react/jsx-runtime";
var recommendationLayoutQueryDef = RecommendationLayoutQuery_graphql_default;
var RecommendationLayout = ({
  queryRef: queryRef3,
  showExpand,
  showMobileNavigation
}) => {
  const data = usePreloadedQuery15(
    recommendationLayoutQueryDef,
    queryRef3
  );
  const { recommendation } = data;
  if (!recommendation) {
    return /* @__PURE__ */ jsx175("div", { children: "Recommendation Not Found" });
  }
  return /* @__PURE__ */ jsx175(Suspense51, { fallback: /* @__PURE__ */ jsx175(EdSkeleton46, {}), children: /* @__PURE__ */ jsx175(Routes4, { children: /* @__PURE__ */ jsx175(
    Route4,
    {
      path: ":decisionToken?",
      element: /* @__PURE__ */ jsx175("div", { children: /* @__PURE__ */ jsx175(
        RecommendationContainer,
        {
          showMobileNavigation,
          recommendationId: recommendation.recruitRecommendationId,
          candidateId: recommendation.candidateId,
          fragmentRef: recommendation
        }
      ) })
    }
  ) }) });
};

// src/recommendations/candidates/components/__generated__/RecommendationListPaginationQuery.graphql.ts
var node211 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 15,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": {
        "createdOn": "DESC"
      },
      "kind": "LocalArgument",
      "name": "sort"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v23 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v32 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }, v4 = [
    v1,
    v23,
    {
      "kind": "Variable",
      "name": "order",
      "variableName": "sort"
    },
    v32
  ], v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "RecommendationListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v23,
            {
              "kind": "Variable",
              "name": "sort",
              "variableName": "sort"
            },
            v32
          ],
          "kind": "FragmentSpread",
          "name": "RecommendationList_recommendations"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "RecommendationListPaginationQuery",
      "selections": [
        {
          "alias": "recommendations",
          "args": v4,
          "concreteType": "RecruitRecommendationsConnection",
          "kind": "LinkedField",
          "name": "recruitRecommendations",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitRecommendationsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitRecommendation",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v5,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "recruitRecommendationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currentStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Vacancy",
                      "kind": "LinkedField",
                      "name": "vacancy",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "code",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "employerLogoUrl",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "employerName",
                          "storageKey": null
                        },
                        v5
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "recommendations",
          "args": v4,
          "filters": [],
          "handle": "connection",
          "key": "RecommendationList_recommendations",
          "kind": "LinkedHandle",
          "name": "recruitRecommendations"
        }
      ]
    },
    "params": {
      "cacheID": "06245fdcc914cb0b6b38448c9b0f45ae",
      "id": null,
      "metadata": {},
      "name": "RecommendationListPaginationQuery",
      "operationKind": "query",
      "text": "query RecommendationListPaginationQuery(\n  $after: String\n  $first: Int = 15\n  $sort: [RecruitRecommendationSort!] = {createdOn: DESC}\n  $where: RecruitRecommendationFilter\n) {\n  ...RecommendationList_recommendations_5yRcm\n}\n\nfragment RecommendationList_recommendations_5yRcm on Query {\n  recommendations: recruitRecommendations(first: $first, after: $after, where: $where, order: $sort) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        recruitRecommendationId\n        currentStatus\n        vacancy {\n          name\n          code\n          employerLogoUrl\n          employerName\n          id\n        }\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node211.hash = "6d43994e490a3432ab05ce6f34982a41";
var RecommendationListPaginationQuery_graphql_default = node211;

// src/recommendations/candidates/components/__generated__/RecommendationList_recommendations.graphql.ts
var node213 = function() {
  var v0 = [
    "recommendations"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 15,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "defaultValue": {
          "createdOn": "DESC"
        },
        "kind": "LocalArgument",
        "name": "sort"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": RecommendationListPaginationQuery_graphql_default
      }
    },
    "name": "RecommendationList_recommendations",
    "selections": [
      {
        "alias": "recommendations",
        "args": null,
        "concreteType": "RecruitRecommendationsConnection",
        "kind": "LinkedField",
        "name": "__RecommendationList_recommendations_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitRecommendationsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitRecommendation",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "recruitRecommendationId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "currentStatus",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Vacancy",
                    "kind": "LinkedField",
                    "name": "vacancy",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "code",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "employerLogoUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "employerName",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node213.hash = "6d43994e490a3432ab05ce6f34982a41";
var RecommendationList_recommendations_graphql_default = node213;

// src/recommendations/candidates/components/RecommendationList.tsx
import { useCallback as useCallback109, useEffect as useEffect26 } from "react";
import { usePaginationFragment as usePaginationFragment10 } from "react-relay";
import { AdjustmentsVerticalIcon as AdjustmentsVerticalIconOutline } from "@heroicons/react/24/outline";
import { AdjustmentsVerticalIcon as AdjustmentsVerticalIconSolid } from "@heroicons/react/24/solid";
import { BuildingOffice2Icon } from "@heroicons/react/24/solid";
import { useForm as useForm17 } from "react-hook-form";
import { isNotNullOrUndefined as isNotNullOrUndefined6 } from "shared-lib";
import { SectionedLayout as SectionedLayout2, SelectMenuInput as SelectMenuInput2, Tag as Tag11 } from "shared-ui";

// src/recommendations/candidates/components/RecommendationLoader.tsx
import { Suspense as Suspense53, useEffect as useEffect25 } from "react";
import { useQueryLoader as useQueryLoader7 } from "react-relay";
import { EdSkeleton as EdSkeleton47 } from "shared-ui";
import { jsx as jsx176 } from "react/jsx-runtime";
var RecommendationLoader = ({
  showMobileNavigation,
  showExpand = true,
  recommendationId,
  showHeader
}) => {
  const [queryReference, loadQuery48] = useQueryLoader7(
    recommendationLayoutQueryDef
  );
  useEffect25(() => {
    loadQuery48({ recommendationId });
  }, [recommendationId, loadQuery48]);
  if (!queryReference) {
    return /* @__PURE__ */ jsx176("div", { className: "m-8", children: /* @__PURE__ */ jsx176(EdSkeleton47, {}) });
  }
  return /* @__PURE__ */ jsx176(Suspense53, { fallback: /* @__PURE__ */ jsx176(EdSkeleton47, {}), children: /* @__PURE__ */ jsx176(
    RecommendationLayout,
    {
      showMobileNavigation,
      showExpand,
      queryRef: queryReference,
      showHeader
    }
  ) });
};

// src/recommendations/candidates/components/RecommendationList.tsx
import { Fragment as Fragment41, jsx as jsx177, jsxs as jsxs120 } from "react/jsx-runtime";
var fragment8 = RecommendationList_recommendations_graphql_default;
var applicationSortValues2 = [
  {
    id: "MOST_RECENT",
    name: "Most Recent"
  },
  {
    id: "STATUS",
    name: "Status"
  },
  {
    id: "VACANCY_NAME",
    name: "Vacancy Name"
  }
];
var RecommendationList = ({
  candidateId,
  fragmentRef
}) => {
  const { data, loadNext, hasNext, isLoadingNext, refetch } = usePaginationFragment10(fragment8, fragmentRef);
  const { recommendations } = data;
  const sections = (recommendations?.edges || []).filter(isNotNullOrUndefined6).map((recommendation) => {
    return {
      key: recommendation.node.recruitRecommendationId,
      listTitle: /* @__PURE__ */ jsxs120("div", { className: "flex flex-col gap-1", children: [
        /* @__PURE__ */ jsx177("div", { className: "items-top text-primary-900 flex w-full justify-between gap-2", children: /* @__PURE__ */ jsx177("div", { children: recommendation.node.vacancy.name }) }),
        /* @__PURE__ */ jsxs120("div", { className: "flex w-full grow justify-between text-sm text-gray-900", children: [
          recommendation.node.vacancy.employerName,
          /* @__PURE__ */ jsx177(Tag11, { size: "xsmall", children: recommendation.node.currentStatus })
        ] })
      ] }),
      itemTitle: `${recommendation.node.vacancy.name} ${recommendation.node.vacancy.code}`,
      icon: () => {
        let logo = /* @__PURE__ */ jsx177(
          "img",
          {
            src: recommendation.node.vacancy.employerLogoUrl,
            className: "w-full"
          }
        );
        if (recommendation.node.vacancy.employerLogoUrl == null) {
          logo = /* @__PURE__ */ jsx177(BuildingOffice2Icon, { className: "h-5 w-5" });
        }
        return /* @__PURE__ */ jsx177("div", { className: "flex h-[30px] w-[30px] items-center justify-center", children: logo });
      },
      iconForeground: "text-gray-700",
      iconBackground: "bg-gray-100",
      element: /* @__PURE__ */ jsx177(
        RecommendationLoader,
        {
          showMobileNavigation: false,
          recommendationId: recommendation.node.recruitRecommendationId
        }
      )
    };
  });
  const { control, watch, getValues, reset } = useForm17();
  const loadMore = useCallback109(() => {
    if (isLoadingNext) {
      return;
    }
    loadNext(5);
  }, [isLoadingNext, loadNext]);
  const sortField = watch("sort");
  useEffect26(() => {
    let sort = {};
    switch (sortField) {
      case "VACANCY_NAME":
        sort = { vacancyName: "ASC" };
        break;
      case "MOST_RECENT":
        sort = { createdOn: "DESC" };
        break;
      case "STATUS":
        sort = { currentStatus: "ASC" };
        break;
    }
    refetch(
      {
        sort: [sort]
      },
      {
        fetchPolicy: "store-and-network"
      }
    );
  }, [refetch, sortField]);
  return /* @__PURE__ */ jsx177(Fragment41, { children: /* @__PURE__ */ jsx177(
    SectionedLayout2,
    {
      expandLink: (id18) => `../../../../recommendation/${id18}`,
      title: "Recommendations",
      showFilters: true,
      sections,
      loadMore: hasNext ? loadMore : () => 0,
      isLoading: isLoadingNext && hasNext,
      FilterIconActive: /* @__PURE__ */ jsx177(AdjustmentsVerticalIconSolid, { className: "h-5 w-5" }),
      FilterIconInactive: /* @__PURE__ */ jsx177(AdjustmentsVerticalIconOutline, { className: "h-5 w-5" }),
      children: /* @__PURE__ */ jsx177(SectionedLayout2.Filters, { children: /* @__PURE__ */ jsx177("div", { className: "bg-secondary-50 relative z-10", children: /* @__PURE__ */ jsx177("div", { className: "", children: /* @__PURE__ */ jsx177("div", { className: "flex w-screen max-w-sm flex-auto flex-col gap-5 p-4 text-sm leading-6", children: /* @__PURE__ */ jsxs120("div", { className: "flex justify-between gap-5", children: [
        /* @__PURE__ */ jsx177("h1", { className: "text-md w-12 font-bold", children: "Sort" }),
        /* @__PURE__ */ jsx177("div", { className: "flex grow flex-col gap-3", children: /* @__PURE__ */ jsxs120("div", { className: "relative rounded-lg ", children: [
          /* @__PURE__ */ jsx177("div", { className: "font-semibold text-gray-900" }),
          /* @__PURE__ */ jsx177(
            SelectMenuInput2,
            {
              name: "sort",
              title: "",
              items: applicationSortValues2,
              selectedItem: applicationSortValues2.filter(
                (x4) => x4.id == getValues("sort")
              )[0] || applicationSortValues2[0],
              control,
              disabled: false
            }
          )
        ] }) })
      ] }) }) }) }) })
    }
  ) });
};

// src/recommendations/candidates/components/__generated__/RecommendationsContainerQuery.graphql.ts
var node214 = function() {
  var v0 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 15
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": {
        "createdOn": "DESC"
      }
    }
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": [],
      "kind": "Fragment",
      "metadata": null,
      "name": "RecommendationsContainerQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "RecommendationList_recommendations"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [],
      "kind": "Operation",
      "name": "RecommendationsContainerQuery",
      "selections": [
        {
          "alias": "recommendations",
          "args": v0,
          "concreteType": "RecruitRecommendationsConnection",
          "kind": "LinkedField",
          "name": "recruitRecommendations",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitRecommendationsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitRecommendation",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v1,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "recruitRecommendationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currentStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Vacancy",
                      "kind": "LinkedField",
                      "name": "vacancy",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "code",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "employerLogoUrl",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "employerName",
                          "storageKey": null
                        },
                        v1
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": 'recruitRecommendations(first:15,order:{"createdOn":"DESC"})'
        },
        {
          "alias": "recommendations",
          "args": v0,
          "filters": [],
          "handle": "connection",
          "key": "RecommendationList_recommendations",
          "kind": "LinkedHandle",
          "name": "recruitRecommendations"
        }
      ]
    },
    "params": {
      "cacheID": "54a0bcff91198254ea09c63330997d45",
      "id": null,
      "metadata": {},
      "name": "RecommendationsContainerQuery",
      "operationKind": "query",
      "text": "query RecommendationsContainerQuery {\n  ...RecommendationList_recommendations\n}\n\nfragment RecommendationList_recommendations on Query {\n  recommendations: recruitRecommendations(first: 15, order: {createdOn: DESC}) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        recruitRecommendationId\n        currentStatus\n        vacancy {\n          name\n          code\n          employerLogoUrl\n          employerName\n          id\n        }\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node214.hash = "6ea05f7c9d691eb00f26b7689fafcf34";
var RecommendationsContainerQuery_graphql_default = node214;

// src/recommendations/candidates/components/RecommendationsContainer.tsx
import { Suspense as Suspense54 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery26 } from "react-relay";
import { EdSkeleton as EdSkeleton48 } from "shared-ui";
import { jsx as jsx178 } from "react/jsx-runtime";
var graphqlQuery5 = RecommendationsContainerQuery_graphql_default;
var RecommendationsContainer = ({ candidateId }) => {
  const query3 = useLazyLoadQuery26(
    graphqlQuery5,
    {},
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsx178(Suspense54, { fallback: /* @__PURE__ */ jsx178(EdSkeleton48, {}), children: /* @__PURE__ */ jsx178(RecommendationList, { candidateId, fragmentRef: query3 }) });
};

// src/recommendations/candidates/components/__generated__/RecommendationWorkflowDeclinedDataRemoved_recommendation.graphql.ts
var node215 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RecommendationWorkflowDeclinedDataRemoved_recommendation",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recruitRecommendationId",
      "storageKey": null
    }
  ],
  "type": "RecruitRecommendation",
  "abstractKey": null
};
node215.hash = "49e9999ba7c12a7244df60e648240814";
var RecommendationWorkflowDeclinedDataRemoved_recommendation_graphql_default = node215;

// src/recommendations/candidates/components/RecommendationWorkflowDeclinedDataRemoved.tsx
import { useFragment as useFragment57 } from "react-relay";
import { jsx as jsx179 } from "react/jsx-runtime";
var fragmentDef48 = RecommendationWorkflowDeclinedDataRemoved_recommendation_graphql_default;
var RecommendationWorkflowDeclinedDataRemoved = ({
  fragmentRef
}) => {
  const { recruitRecommendationId } = useFragment57(
    fragmentDef48,
    fragmentRef
  );
  return /* @__PURE__ */ jsx179("div", { className: "flex flex-col", children: /* @__PURE__ */ jsx179("div", {}) });
};

// src/recommendations/candidates/components/__generated__/RecommendationWorkflowNoDecision_recommendation.graphql.ts
var node216 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RecommendationWorkflowNoDecision_recommendation",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recruitRecommendationId",
      "storageKey": null
    }
  ],
  "type": "RecruitRecommendation",
  "abstractKey": null
};
node216.hash = "e5cf7c6daf822d6d4d096effdedf7043";
var RecommendationWorkflowNoDecision_recommendation_graphql_default = node216;

// src/recommendations/candidates/components/RecommendationWorkflowNoDecision.tsx
import { useFragment as useFragment58 } from "react-relay";
import { jsx as jsx180 } from "react/jsx-runtime";
var fragmentDef49 = RecommendationWorkflowNoDecision_recommendation_graphql_default;
var RecommendationWorkflowNoDecision = ({
  fragmentRef
}) => {
  const { recruitRecommendationId } = useFragment58(
    fragmentDef49,
    fragmentRef
  );
  return /* @__PURE__ */ jsx180("div", { className: "flex flex-col", children: /* @__PURE__ */ jsx180("div", {}) });
};

// src/recommendations/recruiter/components/VacancyRecommendationRoute.tsx
import { Navigate as Navigate8 } from "react-router-dom";
import { ErrorContainer as ErrorContainer10 } from "shared-ui";

// src/recommendations/recruiter/components/__generated__/VacancyRecommendationLayoutQuery.graphql.ts
var node217 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "recommendationCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "recommendationCode"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "vacancyName",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "rightToWorkStatus",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currentStatus",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "emailAddress",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "employerReference",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "employerName",
    "storageKey": null
  }, v13 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "VacancyRecommendationLayoutQuery",
      "selections": [
        {
          "alias": "recommendation",
          "args": v1,
          "concreteType": "RecruitRecommendation",
          "kind": "LinkedField",
          "name": "recruitRecommendationByCode",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            v5,
            v6,
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfile",
              "kind": "LinkedField",
              "name": "profile",
              "plural": false,
              "selections": [
                v7,
                v8,
                v9,
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "RecruitProfileHeader_profile"
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Vacancy",
              "kind": "LinkedField",
              "name": "vacancy",
              "plural": false,
              "selections": [
                v10,
                v32,
                v11,
                v12
              ],
              "storageKey": null
            },
            v13
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "VacancyRecommendationLayoutQuery",
      "selections": [
        {
          "alias": "recommendation",
          "args": v1,
          "concreteType": "RecruitRecommendation",
          "kind": "LinkedField",
          "name": "recruitRecommendationByCode",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            v5,
            v6,
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfile",
              "kind": "LinkedField",
              "name": "profile",
              "plural": false,
              "selections": [
                v7,
                v8,
                v9,
                v23,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileWorkLocations",
                  "kind": "LinkedField",
                  "name": "workLocations",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currentLocationName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currentLocationCountryName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "WorkLocationEntry",
                      "kind": "LinkedField",
                      "name": "workLocations",
                      "plural": true,
                      "selections": [
                        v10
                      ],
                      "storageKey": null
                    },
                    v23
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperience",
                  "kind": "LinkedField",
                  "name": "currentPosition",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "title",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "companyName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "startDate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "endDate",
                      "storageKey": null
                    },
                    v23
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileRate",
                  "kind": "LinkedField",
                  "name": "rate",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "payType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "minimumRateOfPay",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "maximumRateOfPay",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "countryCode",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currencyCode",
                      "storageKey": null
                    },
                    v23
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileAvailability",
                  "kind": "LinkedField",
                  "name": "availability",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobSearchStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "availabilityStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "NoticeCriteria",
                      "kind": "LinkedField",
                      "name": "noticeCriteria",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "availableFrom",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "noticePeriodWeeks",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "noticeTimeframe",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    v23
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "recruitProfileId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "profileType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsCandidateAccount",
                  "kind": "LinkedField",
                  "name": "account",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "accountId",
                      "storageKey": null
                    },
                    v23
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RightToWork",
                  "kind": "LinkedField",
                  "name": "rightToWork",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    v23
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Vacancy",
              "kind": "LinkedField",
              "name": "vacancy",
              "plural": false,
              "selections": [
                v10,
                v32,
                v11,
                v12,
                v23
              ],
              "storageKey": null
            },
            v13
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "8fb9a61d2c7fc6880327ca59a3411611",
      "id": null,
      "metadata": {},
      "name": "VacancyRecommendationLayoutQuery",
      "operationKind": "query",
      "text": "query VacancyRecommendationLayoutQuery(\n  $recommendationCode: Long!\n) {\n  recommendation: recruitRecommendationByCode(code: $recommendationCode) {\n    id\n    code\n    vacancyName\n    rightToWorkStatus\n    currentStatus\n    profile {\n      firstName\n      lastName\n      emailAddress\n      ...RecruitProfileHeader_profile\n      id\n    }\n    vacancy {\n      name\n      code\n      employerReference\n      employerName\n      id\n    }\n  }\n}\n\nfragment RecruitProfileApplicationHeader_application on RecruitProfile {\n  id\n  firstName\n  lastName\n  workLocations {\n    currentLocationName\n    currentLocationCountryName\n    workLocations {\n      name\n    }\n    id\n  }\n  currentPosition {\n    title\n    companyName\n    startDate\n    endDate\n    id\n  }\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n  availability {\n    jobSearchStatus\n    availabilityStatus\n    noticeCriteria {\n      availableFrom\n      noticePeriodWeeks\n      noticeTimeframe\n    }\n    id\n  }\n}\n\nfragment RecruitProfileHeader_profile on RecruitProfile {\n  ...RecruitProfileApplicationHeader_application\n  id\n  recruitProfileId\n  firstName\n  lastName\n  profileType\n  workLocations {\n    currentLocationName\n    currentLocationCountryName\n    id\n  }\n  account {\n    accountId\n    id\n  }\n  currentPosition {\n    title\n    companyName\n    startDate\n    endDate\n    id\n  }\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n  rightToWork {\n    status\n    id\n  }\n  availability {\n    jobSearchStatus\n    id\n  }\n}\n"
    }
  };
}();
node217.hash = "010f67edec534dedc1167f3fbe589324";
var VacancyRecommendationLayoutQuery_graphql_default = node217;

// src/recommendations/recruiter/components/VacancyRecommendationLayout.tsx
import { Suspense as Suspense55, useMemo as useMemo26 } from "react";
import {
  Link as Link7,
  Outlet as Outlet8,
  useLoaderData as useLoaderData2,
  useLocation as useLocation3,
  useParams as useParams6,
  useRouteLoaderData as useRouteLoaderData9
} from "react-router-dom";
import {
  loadQuery as loadQuery12,
  usePreloadedQuery as usePreloadedQuery16
} from "react-relay";
import {
  createLinkState as createLinkState3,
  DynamicBreadcrumb as DynamicBreadcrumb2,
  EdSkeleton as EdSkeleton50,
  Tabs as Tabs3
} from "shared-ui";

// src/recommendations/recruiter/components/__generated__/RecommendationRelevanceProviderQuery.graphql.ts
var node218 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "recommendationCode"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "vacancyCode"
  }, v23 = [
    {
      "kind": "Literal",
      "name": "experienceIds",
      "value": []
    },
    {
      "kind": "Variable",
      "name": "recommendationCode",
      "variableName": "recommendationCode"
    },
    {
      "kind": "Literal",
      "name": "skillGroupIds",
      "value": []
    },
    {
      "kind": "Variable",
      "name": "vacancyCode",
      "variableName": "vacancyCode"
    }
  ], v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "experienceId",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "sentence",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "sentenceIndex",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "similarity",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "skillGroupId",
    "storageKey": null
  }, v9 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "recommendationCode"
    }
  ], v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "source",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "matchSourceType",
    "storageKey": null
  }, v14 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }, v15 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "numberOfMonthsCertain",
    "storageKey": null
  }, v16 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "numberOfMonthsCertainPlusUnknown",
    "storageKey": null
  }, v17 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "mostRecentCertainExperienceEnd",
    "storageKey": null
  }, v18 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "mostRecentUnknownExperienceEnd",
    "storageKey": null
  }, v19 = [
    v15,
    v16,
    v17,
    v18
  ], v20 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "weight",
    "storageKey": null
  }, v21 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v222 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationAmount",
    "storageKey": null
  }, v232 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationType",
    "storageKey": null
  }, v24 = [
    v222,
    v232
  ];
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "RecommendationRelevanceProviderQuery",
      "selections": [
        {
          "alias": "results",
          "args": v23,
          "concreteType": "SentenceSimilarity",
          "kind": "LinkedField",
          "name": "recruitVacancyGetSentenceSimilaritiesForRecommendation",
          "plural": true,
          "selections": [
            v32,
            v4,
            v5,
            v6,
            v7,
            v8,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "MatchRelevanceProvider_sentences"
            }
          ],
          "storageKey": null
        },
        {
          "alias": "recommendation",
          "args": v9,
          "concreteType": "RecruitRecommendation",
          "kind": "LinkedField",
          "name": "recruitRecommendationByCode",
          "plural": false,
          "selections": [
            v10,
            v11,
            v12,
            v13,
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitMatchRelevanceContainer",
              "kind": "LinkedField",
              "name": "matchRelevance",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "MatchRelevanceProvider_relevance"
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitMatchProfile",
              "kind": "LinkedField",
              "name": "matchProfile",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "MatchRelevanceProvider_matchProfile"
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Vacancy",
              "kind": "LinkedField",
              "name": "vacancy",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "MatchRelevanceProvider_vacancy"
                }
              ],
              "storageKey": null
            },
            v14
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "RecommendationRelevanceProviderQuery",
      "selections": [
        {
          "alias": "results",
          "args": v23,
          "concreteType": "SentenceSimilarity",
          "kind": "LinkedField",
          "name": "recruitVacancyGetSentenceSimilaritiesForRecommendation",
          "plural": true,
          "selections": [
            v32,
            v4,
            v5,
            v6,
            v7,
            v8
          ],
          "storageKey": null
        },
        {
          "alias": "recommendation",
          "args": v9,
          "concreteType": "RecruitRecommendation",
          "kind": "LinkedField",
          "name": "recruitRecommendationByCode",
          "plural": false,
          "selections": [
            v10,
            v11,
            v12,
            v13,
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitMatchRelevanceContainer",
              "kind": "LinkedField",
              "name": "matchRelevance",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitMatchSkillRelevance",
                  "kind": "LinkedField",
                  "name": "skillGroups",
                  "plural": true,
                  "selections": [
                    v8,
                    v15,
                    v16,
                    v17,
                    v18
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitMatchRelevance",
                  "kind": "LinkedField",
                  "name": "industry",
                  "plural": false,
                  "selections": v19,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitMatchRelevance",
                  "kind": "LinkedField",
                  "name": "job",
                  "plural": false,
                  "selections": v19,
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitMatchProfile",
              "kind": "LinkedField",
              "name": "matchProfile",
              "plural": false,
              "selections": [
                v10,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "vacancyId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitMatchProfileExperience",
                  "kind": "LinkedField",
                  "name": "experience",
                  "plural": true,
                  "selections": [
                    v10,
                    v11,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "version",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "titleId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "title",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "industry",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "companyIsVerified",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "companyId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "companyName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "startDate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "endDate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "positionType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "MatchProfileExperienceSkillGroupScore",
                      "kind": "LinkedField",
                      "name": "skillGroupScores",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "groupId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "hasMatch",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "minSkillGroupScore",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "score",
                          "storageKey": null
                        },
                        v20
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "escoOccupationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "escoHierarchy",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobMatchWeight",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobMatchScore",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "companyScore",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "companyScoreWeight",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasCompanyVector",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Vacancy",
              "kind": "LinkedField",
              "name": "vacancy",
              "plural": false,
              "selections": [
                v10,
                v11,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SkillGroup",
                  "kind": "LinkedField",
                  "name": "skillGroups",
                  "plural": true,
                  "selections": [
                    v10,
                    v8,
                    v21,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isRequired",
                      "storageKey": null
                    },
                    v20,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "SkillGroupTerm",
                      "kind": "LinkedField",
                      "name": "terms",
                      "plural": true,
                      "selections": [
                        v21,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isSkill",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Duration",
                      "kind": "LinkedField",
                      "name": "experience",
                      "plural": false,
                      "selections": v24,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Duration",
                      "kind": "LinkedField",
                      "name": "recency",
                      "plural": false,
                      "selections": [
                        v232,
                        v222
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "VacancyScoringConfig",
                  "kind": "LinkedField",
                  "name": "scoringConfig",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Duration",
                      "kind": "LinkedField",
                      "name": "industryExperience",
                      "plural": false,
                      "selections": v24,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "industryNegativeThreshold",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "industryPositiveThreshold",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Duration",
                      "kind": "LinkedField",
                      "name": "industryRecency",
                      "plural": false,
                      "selections": v24,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "relevanceNegativeThreshold",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "relevancePositiveThreshold",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Duration",
                      "kind": "LinkedField",
                      "name": "relevantExperience",
                      "plural": false,
                      "selections": v24,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Duration",
                      "kind": "LinkedField",
                      "name": "relevantRecency",
                      "plural": false,
                      "selections": v24,
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v14
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "e3a560b0eaaf3ff3a08a60e2b18108a0",
      "id": null,
      "metadata": {},
      "name": "RecommendationRelevanceProviderQuery",
      "operationKind": "query",
      "text": "query RecommendationRelevanceProviderQuery(\n  $vacancyCode: Int!\n  $recommendationCode: Long!\n) {\n  results: recruitVacancyGetSentenceSimilaritiesForRecommendation(vacancyCode: $vacancyCode, recommendationCode: $recommendationCode, experienceIds: [], skillGroupIds: []) {\n    candidateId\n    experienceId\n    sentence\n    sentenceIndex\n    similarity\n    skillGroupId\n    ...MatchRelevanceProvider_sentences\n  }\n  recommendation: recruitRecommendationByCode(code: $recommendationCode) {\n    id\n    code\n    source\n    matchSourceType\n    matchRelevance {\n      ...MatchRelevanceProvider_relevance\n    }\n    matchProfile {\n      ...MatchRelevanceProvider_matchProfile\n    }\n    vacancy {\n      ...MatchRelevanceProvider_vacancy\n      id\n    }\n  }\n}\n\nfragment MatchRelevanceProvider_matchProfile on RecruitMatchProfile {\n  id\n  vacancyId\n  experience {\n    id\n    code\n    version\n    titleId\n    title\n    industry\n    companyIsVerified\n    companyId\n    companyName\n    description\n    startDate\n    endDate\n    positionType\n    skillGroupScores {\n      groupId\n      hasMatch\n      minSkillGroupScore\n      score\n      weight\n    }\n    escoOccupationId\n    escoHierarchy\n    jobMatchWeight\n    jobMatchScore\n    companyScore\n    companyScoreWeight\n    hasCompanyVector\n  }\n}\n\nfragment MatchRelevanceProvider_relevance on RecruitMatchRelevanceContainer {\n  skillGroups {\n    skillGroupId\n    numberOfMonthsCertain\n    numberOfMonthsCertainPlusUnknown\n    mostRecentCertainExperienceEnd\n    mostRecentUnknownExperienceEnd\n  }\n  industry {\n    numberOfMonthsCertain\n    numberOfMonthsCertainPlusUnknown\n    mostRecentCertainExperienceEnd\n    mostRecentUnknownExperienceEnd\n  }\n  job {\n    numberOfMonthsCertain\n    numberOfMonthsCertainPlusUnknown\n    mostRecentCertainExperienceEnd\n    mostRecentUnknownExperienceEnd\n  }\n}\n\nfragment MatchRelevanceProvider_sentences on SentenceSimilarity {\n  candidateId\n  experienceId\n  sentence\n  sentenceIndex\n  similarity\n  skillGroupId\n}\n\nfragment MatchRelevanceProvider_vacancy on Vacancy {\n  id\n  code\n  skillGroups {\n    id\n    skillGroupId\n    name\n    isRequired\n    weight\n    terms {\n      name\n      isSkill\n    }\n    experience {\n      durationAmount\n      durationType\n    }\n    recency {\n      durationType\n      durationAmount\n    }\n  }\n  scoringConfig {\n    industryExperience {\n      durationAmount\n      durationType\n    }\n    industryNegativeThreshold\n    industryPositiveThreshold\n    industryRecency {\n      durationAmount\n      durationType\n    }\n    relevanceNegativeThreshold\n    relevancePositiveThreshold\n    relevantExperience {\n      durationAmount\n      durationType\n    }\n    relevantRecency {\n      durationAmount\n      durationType\n    }\n  }\n}\n"
    }
  };
}();
node218.hash = "2e395316bba0c33e2380e96edb307f2c";
var RecommendationRelevanceProviderQuery_graphql_default = node218;

// src/recommendations/recruiter/components/RecommendationRelevanceProvider.tsx
import { useLazyLoadQuery as useLazyLoadQuery27 } from "react-relay";
import { EdSkeleton as EdSkeleton49 } from "shared-ui";
import { jsx as jsx181, jsxs as jsxs121 } from "react/jsx-runtime";
var queryDef25 = RecommendationRelevanceProviderQuery_graphql_default;
var RecommendationRelevanceProvider = ({
  vacancyCode,
  recommendationCode,
  children
}) => {
  const query3 = useLazyLoadQuery27(
    queryDef25,
    {
      vacancyCode,
      recommendationCode
    },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { recommendation } = query3;
  if (!recommendation || !recommendation.matchProfile) {
    return /* @__PURE__ */ jsx181(EdSkeleton49, {});
  }
  if (!recommendation.matchRelevance) {
    return /* @__PURE__ */ jsxs121("div", { className: "m-4 border bg-yellow-100 p-2", children: [
      /* @__PURE__ */ jsx181("div", { className: "text-danger-500 p-2 font-medium", children: "Could Not Load Relevance for Recommendation" }),
      /* @__PURE__ */ jsxs121("div", { className: "flex items-center gap-2 p-2", children: [
        /* @__PURE__ */ jsx181("div", { className: "font-medium", children: "Match Source Type" }),
        /* @__PURE__ */ jsx181("div", { className: "text-primary-500", children: recommendation.matchSourceType })
      ] })
    ] });
  }
  const { matchProfile, matchRelevance, vacancy } = recommendation;
  return /* @__PURE__ */ jsx181(
    MatchRelevanceProvider,
    {
      sentences: query3.results,
      matchProfileFragmentRef: matchProfile,
      matchRelevanceFragmentRef: matchRelevance,
      vacancyFragmentRef: vacancy,
      children
    }
  );
};

// src/recommendations/recruiter/components/VacancyRecommendationLayout.tsx
import { Fragment as Fragment43, jsx as jsx183, jsxs as jsxs123 } from "react/jsx-runtime";
var routeId = "recommendation-relevance";
var queryDef26 = VacancyRecommendationLayoutQuery_graphql_default;
var tabs = [
  // { name: 'Info', to: 'info' },
  { name: "Relevance", to: "relevance" },
  { name: "Work History", to: "profile" },
  { name: "Details", to: "details" }
];
var VacancyRecommendationLayout = ({ showHeader }) => {
  const params = useParams6();
  const preloadedQuery = useLoaderData2();
  const data = usePreloadedQuery16(queryDef26, preloadedQuery);
  const location2 = useLocation3();
  const tabLinks = tabs.map((tab) => {
    return createLinkState3(location2, tab.name, tab.to);
  });
  const currentPath = useMemo26(
    () => location2.pathname.slice(
      location2.pathname.lastIndexOf("/"),
      location2.pathname.length
    ),
    [location2.pathname]
  );
  const currentEnvironment = useMemo26(() => {
    return location2.pathname.split("/")[1];
  }, [location2.pathname]);
  const { recommendation } = data;
  if (!recommendation) {
    return /* @__PURE__ */ jsx183(EdSkeleton50, {});
  }
  const { profile } = recommendation;
  return /* @__PURE__ */ jsx183(Suspense55, { fallback: "Loading...", children: /* @__PURE__ */ jsxs123("div", { className: "@container flex flex-1 flex-col overflow-scroll", children: [
    showHeader && /* @__PURE__ */ jsx183("div", { className: "flex flex-wrap items-center justify-between border-b bg-white", children: /* @__PURE__ */ jsx183(DynamicBreadcrumb2, {}) }),
    /* @__PURE__ */ jsxs123("div", { className: "items-top @4xl:flex-row flex flex-col justify-between gap-2 border-b bg-white p-4", children: [
      /* @__PURE__ */ jsx183(
        RecruitProfileHeader,
        {
          expandLink: `/${currentEnvironment}/app/vacancies/view/${recommendation.vacancy.code}/recommendation/${recommendation.code}${currentPath}`,
          rightToWorkStatus: recommendation.rightToWorkStatus,
          currentStatus: recommendation.currentStatus,
          fragmentRef: profile
        }
      ),
      /* @__PURE__ */ jsx183(
        RecommendationRelevanceProvider,
        {
          vacancyCode: Number(params.vacancyCode),
          recommendationCode: Number(params.recommendationCode),
          children: /* @__PURE__ */ jsx183(MatchRelevanceScores, {})
        }
      )
    ] }),
    /* @__PURE__ */ jsx183("div", { className: "flex flex-wrap items-center justify-between gap-2 border-b bg-white px-4", children: /* @__PURE__ */ jsx183("div", { className: "@container w-full px-4 py-2", children: /* @__PURE__ */ jsx183(Tabs3, { tabs: tabLinks }) }) }),
    /* @__PURE__ */ jsx183(Outlet8, {})
  ] }) });
};
var VacancyRecommendationLink = ({
  routeId: routeId4,
  label
}) => {
  const data = useRecommendationSearchRouteData(routeId4);
  const { recommendation } = data;
  if (!recommendation) {
    return /* @__PURE__ */ jsx183(Fragment43, {});
  }
  const { profile } = recommendation;
  const name = `${profile.firstName} ${profile.lastName}`;
  return /* @__PURE__ */ jsx183(Suspense55, { fallback: "Loading...", children: /* @__PURE__ */ jsx183(Link7, { to: ".", children: label || name }) });
};
async function loader8(environment, params) {
  const code = params.recommendationCode;
  const recommendationCode = parseInt(code);
  return loadQuery12(environment, queryDef26, {
    recommendationCode
  });
}
function useRecommendationSearchRouteData(routeId4) {
  const queryRef3 = useRouteLoaderData9(
    routeId4
  );
  const data = usePreloadedQuery16(
    queryDef26,
    queryRef3
  );
  return data;
}

// src/recommendations/recruiter/components/__generated__/VacancyRecommendationRootRouteQuery.graphql.ts
var node219 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "recommendationCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "recommendationCode"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdOn",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "vacancyName",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "employerReference",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "employerName",
    "storageKey": null
  }, v11 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "VacancyRecommendationRootRouteQuery",
      "selections": [
        {
          "alias": "recommendation",
          "args": v1,
          "concreteType": "RecruitRecommendation",
          "kind": "LinkedField",
          "name": "recruitRecommendationByCode",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            v5,
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "candidate",
              "plural": false,
              "selections": [
                v6,
                v7
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfile",
              "kind": "LinkedField",
              "name": "profile",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperience",
                  "kind": "LinkedField",
                  "name": "currentPosition",
                  "plural": false,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "ExperienceViewer_profile"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Vacancy",
              "kind": "LinkedField",
              "name": "vacancy",
              "plural": false,
              "selections": [
                v8,
                v32,
                v9,
                v10
              ],
              "storageKey": null
            },
            v11
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "VacancyRecommendationRootRouteQuery",
      "selections": [
        {
          "alias": "recommendation",
          "args": v1,
          "concreteType": "RecruitRecommendation",
          "kind": "LinkedField",
          "name": "recruitRecommendationByCode",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            v5,
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "candidate",
              "plural": false,
              "selections": [
                v6,
                v7,
                v23
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfile",
              "kind": "LinkedField",
              "name": "profile",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperience",
                  "kind": "LinkedField",
                  "name": "currentPosition",
                  "plural": false,
                  "selections": [
                    v23,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "candidateExperienceId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "title",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "companyName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "skills",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "startDate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "endDate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "industry",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "positionType",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                v23
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Vacancy",
              "kind": "LinkedField",
              "name": "vacancy",
              "plural": false,
              "selections": [
                v8,
                v32,
                v9,
                v10,
                v23
              ],
              "storageKey": null
            },
            v11
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "6916205d0e1a50e7f87e2e0c4358cf88",
      "id": null,
      "metadata": {},
      "name": "VacancyRecommendationRootRouteQuery",
      "operationKind": "query",
      "text": "query VacancyRecommendationRootRouteQuery(\n  $recommendationCode: Long!\n) {\n  recommendation: recruitRecommendationByCode(code: $recommendationCode) {\n    id\n    code\n    createdOn\n    vacancyName\n    candidate {\n      firstName\n      lastName\n      id\n    }\n    profile {\n      currentPosition {\n        ...ExperienceViewer_profile\n        id\n      }\n      id\n    }\n    vacancy {\n      name\n      code\n      employerReference\n      employerName\n      id\n    }\n  }\n}\n\nfragment ExperienceViewer_profile on RecruitProfileExperience {\n  id\n  candidateExperienceId\n  title\n  companyName\n  skills\n  startDate\n  description\n  endDate\n  industry\n  positionType\n}\n"
    }
  };
}();
node219.hash = "59126fcc1adccd558cdcbb9ad4981ecd";
var VacancyRecommendationRootRouteQuery_graphql_default = node219;

// src/recommendations/recruiter/components/VacancyRecommendationRoot.tsx
import { Suspense as Suspense56 } from "react";
import { loadQuery as loadQuery13 } from "react-relay";
import { Link as Link8 } from "react-router-dom";
import { timeAgo as timeAgo5, useRouteData as useRouteData5 } from "shared-lib";
import { EdSkeleton as EdSkeleton51 } from "shared-ui";
import { Fragment as Fragment44, jsx as jsx184, jsxs as jsxs124 } from "react/jsx-runtime";
var queryDef27 = VacancyRecommendationRootRouteQuery_graphql_default;
async function loader9(environment, params) {
  const code = params.recommendationCode;
  const recommendationCode = parseInt(code);
  return loadQuery13(environment, queryDef27, {
    recommendationCode
  });
}
var VacancyRecommendationRoot = ({ routeId: routeId4, inList }) => {
  const data = useRouteData5(
    queryDef27,
    routeId4
  );
  if (!data) {
    return /* @__PURE__ */ jsx184(Fragment44, { children: "Loading..." });
  }
  const { recommendation } = data;
  if (!recommendation) {
    return /* @__PURE__ */ jsx184(Fragment44, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx184(Suspense56, { fallback: /* @__PURE__ */ jsx184(EdSkeleton51, {}), children: /* @__PURE__ */ jsxs124("div", { className: "border-y bg-white p-4", children: [
    /* @__PURE__ */ jsxs124("div", { className: "flex flex-col gap-2", children: [
      /* @__PURE__ */ jsx184("div", { className: "text-primary-500 px-4 text-lg font-medium", children: recommendation.vacancy.name }),
      /* @__PURE__ */ jsx184("div", { className: "text-primary-500 px-4 text-lg", children: recommendation.vacancy.employerName }),
      recommendation.createdOn && /* @__PURE__ */ jsxs124("div", { className: "text-primary-500 text-md px-4", children: [
        "Created ",
        timeAgo5(recommendation.createdOn)
      ] })
    ] }),
    data.recommendation?.profile.currentPosition && /* @__PURE__ */ jsx184("div", { className: "m-4 p-4", children: /* @__PURE__ */ jsx184(
      ExperienceViewer,
      {
        fragmentRef: data.recommendation?.profile.currentPosition
      }
    ) })
  ] }) });
};
var createRoute8 = (routePrefix, environment, context, inList = true) => {
  const routeId4 = `${routePrefix}-recommendation-search-root`;
  return {
    id: routeId4,
    path: "info",
    element: /* @__PURE__ */ jsx184(VacancyRecommendationRoot, { routeId: routeId4, inList }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx184(Link8, { to: "", children: "Recommendation" })
    },
    loader: ({ params }) => {
      return loader9(environment, params);
    }
  };
};

// src/recommendations/recruiter/components/__generated__/VacancyRecommendationRelevanceRouteQuery.graphql.ts
var node220 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "recommendationCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "recommendationCode"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "source",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdOn",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "vacancyName",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "employerReference",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "employerName",
    "storageKey": null
  }, v12 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "VacancyRecommendationRelevanceRouteQuery",
      "selections": [
        {
          "alias": "recommendation",
          "args": v1,
          "concreteType": "RecruitRecommendation",
          "kind": "LinkedField",
          "name": "recruitRecommendationByCode",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            v5,
            v6,
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "candidate",
              "plural": false,
              "selections": [
                v7,
                v8
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfile",
              "kind": "LinkedField",
              "name": "profile",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperience",
                  "kind": "LinkedField",
                  "name": "currentPosition",
                  "plural": false,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "ExperienceViewer_profile"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Vacancy",
              "kind": "LinkedField",
              "name": "vacancy",
              "plural": false,
              "selections": [
                v9,
                v32,
                v10,
                v11
              ],
              "storageKey": null
            },
            v12
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "VacancyRecommendationRelevanceRouteQuery",
      "selections": [
        {
          "alias": "recommendation",
          "args": v1,
          "concreteType": "RecruitRecommendation",
          "kind": "LinkedField",
          "name": "recruitRecommendationByCode",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            v5,
            v6,
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "candidate",
              "plural": false,
              "selections": [
                v7,
                v8,
                v23
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfile",
              "kind": "LinkedField",
              "name": "profile",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperience",
                  "kind": "LinkedField",
                  "name": "currentPosition",
                  "plural": false,
                  "selections": [
                    v23,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "candidateExperienceId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "title",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "companyName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "skills",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "startDate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "endDate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "industry",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "positionType",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                v23
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Vacancy",
              "kind": "LinkedField",
              "name": "vacancy",
              "plural": false,
              "selections": [
                v9,
                v32,
                v10,
                v11,
                v23
              ],
              "storageKey": null
            },
            v12
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "79cdd06f9c02f0f9560012ef37d34a18",
      "id": null,
      "metadata": {},
      "name": "VacancyRecommendationRelevanceRouteQuery",
      "operationKind": "query",
      "text": "query VacancyRecommendationRelevanceRouteQuery(\n  $recommendationCode: Long!\n) {\n  recommendation: recruitRecommendationByCode(code: $recommendationCode) {\n    id\n    code\n    source\n    createdOn\n    vacancyName\n    candidate {\n      firstName\n      lastName\n      id\n    }\n    profile {\n      currentPosition {\n        ...ExperienceViewer_profile\n        id\n      }\n      id\n    }\n    vacancy {\n      name\n      code\n      employerReference\n      employerName\n      id\n    }\n  }\n}\n\nfragment ExperienceViewer_profile on RecruitProfileExperience {\n  id\n  candidateExperienceId\n  title\n  companyName\n  skills\n  startDate\n  description\n  endDate\n  industry\n  positionType\n}\n"
    }
  };
}();
node220.hash = "ed2a34242ed82eff15e585fc8eec02f9";
var VacancyRecommendationRelevanceRouteQuery_graphql_default = node220;

// src/recommendations/recruiter/components/VacancyRecommendationRelevance.tsx
import { Suspense as Suspense57 } from "react";
import { loadQuery as loadQuery14 } from "react-relay";
import { Link as Link9, useParams as useParams7 } from "react-router-dom";
import { EdSkeleton as EdSkeleton53 } from "shared-ui";
import { jsx as jsx185, jsxs as jsxs125 } from "react/jsx-runtime";
var queryDef28 = VacancyRecommendationRelevanceRouteQuery_graphql_default;
async function loader10(environment, params) {
  const code = params.recommendationCode;
  const recommendationCode = parseInt(code);
  return loadQuery14(
    environment,
    queryDef28,
    {
      recommendationCode
    }
  );
}
var VacancyRecommendationRelevance = () => {
  const params = useParams7();
  return /* @__PURE__ */ jsx185(Suspense57, { fallback: /* @__PURE__ */ jsx185(EdSkeleton53, {}), children: /* @__PURE__ */ jsx185(
    RecommendationRelevanceProvider,
    {
      vacancyCode: Number(params.vacancyCode),
      recommendationCode: Number(params.recommendationCode),
      children: /* @__PURE__ */ jsxs125("div", { className: "flex flex-col gap-5 p-5", children: [
        /* @__PURE__ */ jsx185("div", { className: "rounded-lg border bg-white p-5", children: /* @__PURE__ */ jsx185(MatchRelevanceProfileTimeline, {}) }),
        /* @__PURE__ */ jsx185("div", { className: "rounded-lg border bg-white p-5", children: /* @__PURE__ */ jsx185(MatchExperienceSimilarityHighlighter, {}) })
      ] })
    }
  ) });
};
var createRoute9 = (routePrefix, environment, context, inList = true) => {
  const routeId4 = `${routePrefix}-recommendation-search-relevance`;
  return {
    id: routeId4,
    path: "relevance",
    element: /* @__PURE__ */ jsx185(VacancyRecommendationRelevance, { routeId: routeId4, inList }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx185(Link9, { to: "", children: "Recommendation" })
    },
    loader: ({ params }) => {
      return loader10(environment, params);
    }
  };
};

// src/candidates/components/__generated__/CandidateRecommendationDetailsApplicationRouteQuery.graphql.ts
var node221 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "recommendationCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "recommendationCode"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "vacancyName",
    "storageKey": null
  }, v5 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateRecommendationDetailsApplicationRouteQuery",
      "selections": [
        {
          "alias": "recommendation",
          "args": v1,
          "concreteType": "RecruitRecommendation",
          "kind": "LinkedField",
          "name": "recruitRecommendationByCode",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfile",
              "kind": "LinkedField",
              "name": "profile",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "DetailsComponent_profile"
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "candidate",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "DetailsComponent_candidate"
                }
              ],
              "storageKey": null
            },
            v5
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateRecommendationDetailsApplicationRouteQuery",
      "selections": [
        {
          "alias": "recommendation",
          "args": v1,
          "concreteType": "RecruitRecommendation",
          "kind": "LinkedField",
          "name": "recruitRecommendationByCode",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfile",
              "kind": "LinkedField",
              "name": "profile",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "recruitProfileId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitResume",
                  "kind": "LinkedField",
                  "name": "resume",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "bucket",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "resumeId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "fileKey",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "fileName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "filePath",
                      "storageKey": null
                    },
                    v23
                  ],
                  "storageKey": null
                },
                v23
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "candidate",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "firstName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "email",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CandidatePhoneVerification",
                  "kind": "LinkedField",
                  "name": "phone",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "phoneNumber",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "phoneCountryPrefix",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "phoneVerificationStatus",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                v23
              ],
              "storageKey": null
            },
            v5
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "69bb5adca16136f4d77e930ea20dc8b0",
      "id": null,
      "metadata": {},
      "name": "CandidateRecommendationDetailsApplicationRouteQuery",
      "operationKind": "query",
      "text": "query CandidateRecommendationDetailsApplicationRouteQuery(\n  $recommendationCode: Long!\n) {\n  recommendation: recruitRecommendationByCode(code: $recommendationCode) {\n    id\n    code\n    vacancyName\n    profile {\n      ...DetailsComponent_profile\n      id\n    }\n    candidate {\n      ...DetailsComponent_candidate\n      id\n    }\n  }\n}\n\nfragment DetailsComponent_candidate on AccountsCandidateAccount {\n  firstName\n  lastName\n  email\n  phone {\n    phoneNumber\n    phoneCountryPrefix\n    phoneVerificationStatus\n  }\n}\n\nfragment DetailsComponent_profile on RecruitProfile {\n  recruitProfileId\n  resume {\n    bucket\n    resumeId\n    fileKey\n    fileName\n    filePath\n    id\n  }\n}\n"
    }
  };
}();
node221.hash = "548bd1fe8093985df08c40de9473cb6f";
var CandidateRecommendationDetailsApplicationRouteQuery_graphql_default = node221;

// src/candidates/components/CandidateRecommendationDetails.tsx
import { loadQuery as loadQuery15 } from "react-relay";
import { Link as Link10 } from "react-router-dom";
import { useRouteData as useRouteData6 } from "shared-lib";
import { Fragment as Fragment45, jsx as jsx186 } from "react/jsx-runtime";
var queryDef29 = CandidateRecommendationDetailsApplicationRouteQuery_graphql_default;
async function loader11(environment, params) {
  const code = params.recommendationCode;
  const recommendationCode = parseInt(code);
  return loadQuery15(
    environment,
    queryDef29,
    {
      recommendationCode
    }
  );
}
var CandidateRecommendationDetails = ({
  routeId: routeId4
}) => {
  const data = useRouteData6(
    queryDef29,
    routeId4
  );
  if (!data.recommendation?.candidate || !data.recommendation?.profile) {
    return /* @__PURE__ */ jsx186(Fragment45, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx186(
    DetailsComponent,
    {
      candidateFragmentRef: data.recommendation?.candidate,
      profileFragmentRef: data.recommendation?.profile
    }
  );
};
var createRoute10 = (routePrefix, environment, context) => {
  const routeId4 = `${routePrefix}-application-details-forms`;
  return {
    id: routeId4,
    path: "details",
    loader: ({ params }) => {
      return loader11(environment, params);
    },
    element: /* @__PURE__ */ jsx186(CandidateRecommendationDetails, { routeId: routeId4 }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx186(Link10, { to: "details", children: "Details" })
    }
  };
};

// src/recommendations/recruiter/components/__generated__/VacancyRecommendationProfileRouteQuery.graphql.ts
var node223 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "recommendationCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "recommendationCode"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "vacancyName",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateExperienceId",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyName",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "startDate",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "endDate",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "concreteType": "SkillUsage",
    "kind": "LinkedField",
    "name": "skills",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastUsed",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DateRange",
        "kind": "LinkedField",
        "name": "periods",
        "plural": true,
        "selections": [
          v10,
          v11
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "averageMonthsUsed",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalMonthsUsed",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalPositionsUsed",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v13 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "VacancyRecommendationProfileRouteQuery",
      "selections": [
        {
          "alias": "application",
          "args": v1,
          "concreteType": "RecruitRecommendation",
          "kind": "LinkedField",
          "name": "recruitRecommendationByCode",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "candidate",
              "plural": false,
              "selections": [
                v5,
                v6
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfile",
              "kind": "LinkedField",
              "name": "profile",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperienceCollection",
                  "kind": "LinkedField",
                  "name": "experiences",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileExperience",
                      "kind": "LinkedField",
                      "name": "items",
                      "plural": true,
                      "selections": [
                        v23,
                        v7,
                        v8,
                        v9,
                        v10,
                        v11,
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "ExperienceDetails_experience"
                        }
                      ],
                      "storageKey": null
                    },
                    v12
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v13
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "VacancyRecommendationProfileRouteQuery",
      "selections": [
        {
          "alias": "application",
          "args": v1,
          "concreteType": "RecruitRecommendation",
          "kind": "LinkedField",
          "name": "recruitRecommendationByCode",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "candidate",
              "plural": false,
              "selections": [
                v5,
                v6,
                v23
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfile",
              "kind": "LinkedField",
              "name": "profile",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperienceCollection",
                  "kind": "LinkedField",
                  "name": "experiences",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileExperience",
                      "kind": "LinkedField",
                      "name": "items",
                      "plural": true,
                      "selections": [
                        v23,
                        v7,
                        v8,
                        v9,
                        v10,
                        v11,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "createdOn",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "updatedOn",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "version",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "titleId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "industry",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "companyIsVerified",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "companyId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "description",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "positionType",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "skills",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "escoOccupationId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "escoHierarchy",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    v12
                  ],
                  "storageKey": null
                },
                v23
              ],
              "storageKey": null
            },
            v13
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "6e55c2bdd69e06f6a7ec631f3bd2945a",
      "id": null,
      "metadata": {},
      "name": "VacancyRecommendationProfileRouteQuery",
      "operationKind": "query",
      "text": "query VacancyRecommendationProfileRouteQuery(\n  $recommendationCode: Long!\n) {\n  application: recruitRecommendationByCode(code: $recommendationCode) {\n    id\n    code\n    vacancyName\n    candidate {\n      firstName\n      lastName\n      id\n    }\n    profile {\n      experiences {\n        items {\n          id\n          candidateExperienceId\n          title\n          companyName\n          startDate\n          endDate\n          ...ExperienceDetails_experience\n        }\n        skills {\n          name\n          lastUsed\n          periods {\n            startDate\n            endDate\n          }\n          averageMonthsUsed\n          totalMonthsUsed\n          totalPositionsUsed\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment ExperienceDetails_experience on RecruitProfileExperience {\n  id\n  createdOn\n  updatedOn\n  candidateExperienceId\n  version\n  titleId\n  title\n  industry\n  companyIsVerified\n  companyId\n  companyName\n  description\n  startDate\n  endDate\n  positionType\n  skills\n  escoOccupationId\n  escoHierarchy\n}\n"
    }
  };
}();
node223.hash = "61904ca3dba907acc6d0ca9dc47f88a5";
var VacancyRecommendationProfileRouteQuery_graphql_default = node223;

// src/recommendations/recruiter/components/VacancyRecommendationProfile.tsx
import { Suspense as Suspense58, useState as useState63 } from "react";
import { loadQuery as loadQuery16 } from "react-relay";
import { Link as Link11 } from "react-router-dom";
import { formatMonth as formatMonth3, useRouteData as useRouteData7 } from "shared-lib";
import { Button as Button57, classNames as classNames21, EdSkeleton as EdSkeleton54, Size as Size35 } from "shared-ui";
import { Fragment as Fragment46, jsx as jsx187, jsxs as jsxs126 } from "react/jsx-runtime";
var queryDef30 = VacancyRecommendationProfileRouteQuery_graphql_default;
async function loader12(environment, params) {
  const code = params.recommendationCode;
  const recommendationCode = parseInt(code);
  return loadQuery16(
    environment,
    queryDef30,
    {
      recommendationCode
    }
  );
}
var CandidateApplicationProfile2 = ({
  routeId: routeId4
}) => {
  const data = useRouteData7(
    queryDef30,
    routeId4
  );
  const [selectedId, setSelectedId] = useState63(null);
  const { application: application3 } = data;
  if (!application3) {
    return /* @__PURE__ */ jsx187(Fragment46, { children: "Loading..." });
  }
  const { profile } = application3;
  let selectedContainer = null;
  if (selectedId) {
    const selected = profile.experiences.items.find(
      (e4) => e4.candidateExperienceId === selectedId
    );
    if (selected) {
      selectedContainer = /* @__PURE__ */ jsxs126("div", { className: "", children: [
        /* @__PURE__ */ jsx187("div", { className: "flex justify-end p-2", children: /* @__PURE__ */ jsx187("div", { children: /* @__PURE__ */ jsx187(
          Button57,
          {
            size: Size35.sm,
            color: "primary",
            clicked: () => setSelectedId(null),
            children: "Close"
          }
        ) }) }),
        /* @__PURE__ */ jsx187(ExperienceDetailsComponent, { fragmentRef: selected })
      ] });
    }
  }
  return /* @__PURE__ */ jsx187(Suspense58, { fallback: /* @__PURE__ */ jsx187(EdSkeleton54, {}), children: /* @__PURE__ */ jsxs126("div", { className: "flex flex-wrap bg-white", children: [
    selectedContainer ? /* @__PURE__ */ jsx187("div", { className: "flex flex-1 flex-col gap-5 px-5", children: selectedContainer }) : /* @__PURE__ */ jsxs126("div", { className: "flex flex-1 flex-col gap-5 px-5", children: [
      profile.experiences.items.map((experience) => /* @__PURE__ */ jsx187("div", { className: "rounded-lg bg-white", children: /* @__PURE__ */ jsx187(ExperienceDetailsComponent, { fragmentRef: experience }) }, experience.id)),
      profile.experiences.items.length === 0 && /* @__PURE__ */ jsxs126("div", { className: "flex h-96 flex-col items-center justify-center rounded-lg bg-white", children: [
        /* @__PURE__ */ jsx187("div", { className: "text-2xl font-bold", children: "No experience found" }),
        /* @__PURE__ */ jsx187("div", { className: "text-lg text-gray-500", children: "This user has not added any work experience" })
      ] })
    ] }),
    /* @__PURE__ */ jsx187("div", { children: /* @__PURE__ */ jsx187("div", { className: "w/1-5 flex flex-col gap-2 divide-y border-b border-l", children: profile.experiences.items.map((e4) => /* @__PURE__ */ jsxs126(
      "div",
      {
        className: classNames21(
          "flex cursor-pointer flex-col gap-2 bg-white p-3",
          e4.candidateExperienceId === selectedId ? "text-primary-500" : "text-gray-900"
        ),
        onClick: () => setSelectedId(e4.candidateExperienceId),
        children: [
          /* @__PURE__ */ jsxs126("div", { className: "flex items-center gap-2", children: [
            /* @__PURE__ */ jsx187("div", { children: e4.title }),
            /* @__PURE__ */ jsx187("div", { children: e4.companyName })
          ] }),
          /* @__PURE__ */ jsxs126("div", { className: "flex items-center gap-2", children: [
            /* @__PURE__ */ jsx187("div", { children: formatMonth3(e4.startDate) }),
            /* @__PURE__ */ jsx187("div", { children: formatMonth3(e4.endDate) })
          ] })
        ]
      },
      e4.id
    )) }) })
  ] }) });
};
var createRoute11 = (routePrefix, environment, context) => {
  const routeId4 = `${routePrefix}-application-search-profile`;
  return {
    id: routeId4,
    path: "profile",
    element: /* @__PURE__ */ jsx187(CandidateApplicationProfile2, { routeId: routeId4 }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx187(Link11, { to: "profile", children: "Profile" })
    },
    loader: ({ params }) => {
      return loader12(environment, params);
    }
  };
};

// src/recommendations/recruiter/components/VacancyRecommendationRoute.tsx
import { jsx as jsx188 } from "react/jsx-runtime";
var createVacancyRecommendationRoutes = (routePrefix, environment, context, showHeader = true, inList = true) => {
  const routeId4 = `${routePrefix}-${routeId}`;
  return [
    {
      path: "*",
      id: routeId4,
      element: /* @__PURE__ */ jsx188(VacancyRecommendationLayout, { showHeader }),
      errorElement: /* @__PURE__ */ jsx188(ErrorContainer10, {}),
      handle: {
        crumb: () => /* @__PURE__ */ jsx188(VacancyRecommendationLink, { routeId: routeId4 })
      },
      loader: ({ params }) => {
        return loader8(environment, params);
      },
      children: [
        createRoute8(routePrefix, environment, context, inList),
        createRoute11(routePrefix, environment, context),
        createRoute10(routePrefix, environment, context),
        createRoute9(
          routePrefix,
          environment,
          context,
          inList
        ),
        {
          path: "*",
          element: /* @__PURE__ */ jsx188(Navigate8, { to: "relevance", replace: true })
        }
      ]
    }
  ];
};

// src/recommendations/recruiter/components/__generated__/VacancyRecommendationSearchContainerQuery.graphql.ts
var node224 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "key",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isSelected",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "text",
    "storageKey": null
  }, v8 = [
    v23,
    v32,
    v4,
    {
      "alias": null,
      "args": null,
      "concreteType": "DefaultAggregationValueModel",
      "kind": "LinkedField",
      "name": "values",
      "plural": true,
      "selections": [
        v23,
        v5,
        v6,
        v7
      ],
      "storageKey": null
    }
  ], v9 = {
    "alias": null,
    "args": null,
    "concreteType": "DefaultAggregationValueModel",
    "kind": "LinkedField",
    "name": "values",
    "plural": true,
    "selections": [
      v23,
      v7,
      v5,
      v6
    ],
    "storageKey": null
  }, v10 = [
    v4,
    v9,
    v23,
    v32
  ], v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdOn",
    "storageKey": null
  }, v14 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v15 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v16 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyName",
    "storageKey": null
  }, v17 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "startDate",
    "storageKey": null
  }, v18 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "endDate",
    "storageKey": null
  }, v19 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "version",
    "storageKey": null
  }, v20 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "titleId",
    "storageKey": null
  }, v21 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "industry",
    "storageKey": null
  }, v222 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyIsVerified",
    "storageKey": null
  }, v232 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyId",
    "storageKey": null
  }, v24 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  }, v25 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "positionType",
    "storageKey": null
  }, v26 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "escoOccupationId",
    "storageKey": null
  }, v27 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "escoHierarchy",
    "storageKey": null
  }, v28 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "skillGroupId",
    "storageKey": null
  }, v29 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "numberOfMonthsCertain",
    "storageKey": null
  }, v30 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "numberOfMonthsCertainPlusUnknown",
    "storageKey": null
  }, v31 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "mostRecentCertainExperienceEnd",
    "storageKey": null
  }, v322 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "mostRecentUnknownExperienceEnd",
    "storageKey": null
  }, v33 = [
    v29,
    v30,
    v31,
    v322
  ], v34 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "weight",
    "storageKey": null
  }, v35 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationAmount",
    "storageKey": null
  }, v36 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationType",
    "storageKey": null
  }, v37 = [
    v35,
    v36
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "VacancyRecommendationSearchContainerQuery",
      "selections": [
        {
          "args": v1,
          "kind": "FragmentSpread",
          "name": "VacancyRecommendationSearchContainerFragment"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "VacancyRecommendationSearchContainerQuery",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecommendationSearchResults",
          "kind": "LinkedField",
          "name": "recruitRecommendationSearch2",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecommendationSearchAggregations",
              "kind": "LinkedField",
              "name": "aggregations",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "status",
                  "plural": false,
                  "selections": v8,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "StandardAggregationResults",
                  "kind": "LinkedField",
                  "name": "standard",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "skills",
                      "plural": false,
                      "selections": v8,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "companies",
                      "plural": false,
                      "selections": v8,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "industries",
                      "plural": false,
                      "selections": v8,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "escoLevel1",
                      "plural": false,
                      "selections": v8,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "escoLevel2",
                      "plural": false,
                      "selections": v10,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "escoLevel3",
                      "plural": false,
                      "selections": v10,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "escoLevel4",
                      "plural": false,
                      "selections": v10,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "escoLevel5",
                      "plural": false,
                      "selections": v10,
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "source",
                  "plural": false,
                  "selections": [
                    v4,
                    v9
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CollectionMetaData",
              "kind": "LinkedField",
              "name": "pagination",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "pages",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "pageNumber",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "itemsPerPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "totalResults",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitRecommendation",
              "kind": "LinkedField",
              "name": "results",
              "plural": true,
              "selections": [
                v11,
                v12,
                v13,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "createdBy",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "employerId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "candidateId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "availableInMonths",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "currentStatus",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "rightToWorkStatus",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "source",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfile",
                  "kind": "LinkedField",
                  "name": "profile",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "recruitProfileId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileRate",
                      "kind": "LinkedField",
                      "name": "rate",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "countryCode",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "currencyCode",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "maximumRateOfPay",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "minimumRateOfPay",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "payType",
                          "storageKey": null
                        },
                        v11
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileAvailability",
                      "kind": "LinkedField",
                      "name": "availability",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "jobSearchStatus",
                          "storageKey": null
                        },
                        v11,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "availabilityStatus",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "availability",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "__typename",
                              "storageKey": null
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "date",
                                  "storageKey": null
                                }
                              ],
                              "type": "CandidateAvailableFromDate",
                              "abstractKey": null
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "immediately",
                                  "storageKey": null
                                }
                              ],
                              "type": "CandidateAvailableImmediately",
                              "abstractKey": null
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "notice",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "timeframe",
                                  "storageKey": null
                                }
                              ],
                              "type": "CandidateAvailableNotice",
                              "abstractKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "NoticeCriteria",
                          "kind": "LinkedField",
                          "name": "noticeCriteria",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "availableFrom",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "noticePeriodWeeks",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "noticeTimeframe",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    v11,
                    v14,
                    v15,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileWorkLocations",
                      "kind": "LinkedField",
                      "name": "workLocations",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "currentLocationName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "currentLocationCountryName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "WorkLocationEntry",
                          "kind": "LinkedField",
                          "name": "workLocations",
                          "plural": true,
                          "selections": [
                            v6
                          ],
                          "storageKey": null
                        },
                        v11
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileExperience",
                      "kind": "LinkedField",
                      "name": "currentPosition",
                      "plural": false,
                      "selections": [
                        v4,
                        v16,
                        v17,
                        v18,
                        v11
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileExperienceCollection",
                      "kind": "LinkedField",
                      "name": "experiences",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileExperience",
                          "kind": "LinkedField",
                          "name": "items",
                          "plural": true,
                          "selections": [
                            v11,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "candidateExperienceId",
                              "storageKey": null
                            },
                            v4,
                            v16,
                            v17,
                            v18,
                            v13,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "updatedOn",
                              "storageKey": null
                            },
                            v19,
                            v20,
                            v21,
                            v222,
                            v232,
                            v24,
                            v25,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "skills",
                              "storageKey": null
                            },
                            v26,
                            v27
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "SkillUsage",
                          "kind": "LinkedField",
                          "name": "skills",
                          "plural": true,
                          "selections": [
                            v6,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "lastUsed",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "DateRange",
                              "kind": "LinkedField",
                              "name": "periods",
                              "plural": true,
                              "selections": [
                                v17,
                                v18
                              ],
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "averageMonthsUsed",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "totalMonthsUsed",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "totalPositionsUsed",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitResume",
                      "kind": "LinkedField",
                      "name": "resume",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "bucket",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "resumeId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "fileKey",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "fileName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "filePath",
                          "storageKey": null
                        },
                        v11
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitMatchRelevanceContainer",
                  "kind": "LinkedField",
                  "name": "matchRelevance",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitMatchSkillRelevance",
                      "kind": "LinkedField",
                      "name": "skillGroups",
                      "plural": true,
                      "selections": [
                        v28,
                        v29,
                        v30,
                        v31,
                        v322
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitMatchRelevance",
                      "kind": "LinkedField",
                      "name": "industry",
                      "plural": false,
                      "selections": v33,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitMatchRelevance",
                      "kind": "LinkedField",
                      "name": "job",
                      "plural": false,
                      "selections": v33,
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitMatchProfile",
                  "kind": "LinkedField",
                  "name": "matchProfile",
                  "plural": false,
                  "selections": [
                    v11,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "vacancyId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitMatchProfileExperience",
                      "kind": "LinkedField",
                      "name": "experience",
                      "plural": true,
                      "selections": [
                        v11,
                        v12,
                        v19,
                        v20,
                        v4,
                        v21,
                        v222,
                        v232,
                        v16,
                        v24,
                        v17,
                        v18,
                        v25,
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "MatchProfileExperienceSkillGroupScore",
                          "kind": "LinkedField",
                          "name": "skillGroupScores",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "groupId",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "hasMatch",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "minSkillGroupScore",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "score",
                              "storageKey": null
                            },
                            v34
                          ],
                          "storageKey": null
                        },
                        v26,
                        v27,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "jobMatchWeight",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "jobMatchScore",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "companyScore",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "companyScoreWeight",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "hasCompanyVector",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Vacancy",
                  "kind": "LinkedField",
                  "name": "vacancy",
                  "plural": false,
                  "selections": [
                    v12,
                    v11,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "SkillGroup",
                      "kind": "LinkedField",
                      "name": "skillGroups",
                      "plural": true,
                      "selections": [
                        v11,
                        v28,
                        v6,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isRequired",
                          "storageKey": null
                        },
                        v34,
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "SkillGroupTerm",
                          "kind": "LinkedField",
                          "name": "terms",
                          "plural": true,
                          "selections": [
                            v6,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "isSkill",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Duration",
                          "kind": "LinkedField",
                          "name": "experience",
                          "plural": false,
                          "selections": v37,
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Duration",
                          "kind": "LinkedField",
                          "name": "recency",
                          "plural": false,
                          "selections": [
                            v36,
                            v35
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "VacancyScoringConfig",
                      "kind": "LinkedField",
                      "name": "scoringConfig",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Duration",
                          "kind": "LinkedField",
                          "name": "industryExperience",
                          "plural": false,
                          "selections": v37,
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "industryNegativeThreshold",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "industryPositiveThreshold",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Duration",
                          "kind": "LinkedField",
                          "name": "industryRecency",
                          "plural": false,
                          "selections": v37,
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "relevanceNegativeThreshold",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "relevancePositiveThreshold",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Duration",
                          "kind": "LinkedField",
                          "name": "relevantExperience",
                          "plural": false,
                          "selections": v37,
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Duration",
                          "kind": "LinkedField",
                          "name": "relevantRecency",
                          "plural": false,
                          "selections": v37,
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsCandidateAccount",
                  "kind": "LinkedField",
                  "name": "candidate",
                  "plural": false,
                  "selections": [
                    v14,
                    v15,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "email",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CandidatePhoneVerification",
                      "kind": "LinkedField",
                      "name": "phone",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "phoneCountryCode",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "phoneCountryPrefix",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "phoneNumber",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "phoneVerificationStatus",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    v11
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "dbdae996a1d113d6482ad4b5c1ed8809",
      "id": null,
      "metadata": {},
      "name": "VacancyRecommendationSearchContainerQuery",
      "operationKind": "query",
      "text": "query VacancyRecommendationSearchContainerQuery(\n  $input: RecommendationSearchInput2Input!\n) {\n  ...VacancyRecommendationSearchContainerFragment_2VV6jB\n}\n\nfragment AggregationTags_Aggregation on DefaultAggregationModel {\n  title\n  values {\n    count\n    text\n    isSelected\n    name\n  }\n}\n\nfragment CandidateApplicationProfile_profile on RecruitProfile {\n  experiences {\n    items {\n      id\n      candidateExperienceId\n      title\n      companyName\n      startDate\n      endDate\n      ...ExperienceDetails_experience\n    }\n    skills {\n      name\n      lastUsed\n      periods {\n        startDate\n        endDate\n      }\n      averageMonthsUsed\n      totalMonthsUsed\n      totalPositionsUsed\n    }\n  }\n}\n\nfragment DetailsComponent_candidate on AccountsCandidateAccount {\n  firstName\n  lastName\n  email\n  phone {\n    phoneNumber\n    phoneCountryPrefix\n    phoneVerificationStatus\n  }\n}\n\nfragment DetailsComponent_profile on RecruitProfile {\n  recruitProfileId\n  resume {\n    bucket\n    resumeId\n    fileKey\n    fileName\n    filePath\n    id\n  }\n}\n\nfragment ExperienceDetails_experience on RecruitProfileExperience {\n  id\n  createdOn\n  updatedOn\n  candidateExperienceId\n  version\n  titleId\n  title\n  industry\n  companyIsVerified\n  companyId\n  companyName\n  description\n  startDate\n  endDate\n  positionType\n  skills\n  escoOccupationId\n  escoHierarchy\n}\n\nfragment MatchRelevanceProvider_matchProfile on RecruitMatchProfile {\n  id\n  vacancyId\n  experience {\n    id\n    code\n    version\n    titleId\n    title\n    industry\n    companyIsVerified\n    companyId\n    companyName\n    description\n    startDate\n    endDate\n    positionType\n    skillGroupScores {\n      groupId\n      hasMatch\n      minSkillGroupScore\n      score\n      weight\n    }\n    escoOccupationId\n    escoHierarchy\n    jobMatchWeight\n    jobMatchScore\n    companyScore\n    companyScoreWeight\n    hasCompanyVector\n  }\n}\n\nfragment MatchRelevanceProvider_relevance on RecruitMatchRelevanceContainer {\n  skillGroups {\n    skillGroupId\n    numberOfMonthsCertain\n    numberOfMonthsCertainPlusUnknown\n    mostRecentCertainExperienceEnd\n    mostRecentUnknownExperienceEnd\n  }\n  industry {\n    numberOfMonthsCertain\n    numberOfMonthsCertainPlusUnknown\n    mostRecentCertainExperienceEnd\n    mostRecentUnknownExperienceEnd\n  }\n  job {\n    numberOfMonthsCertain\n    numberOfMonthsCertainPlusUnknown\n    mostRecentCertainExperienceEnd\n    mostRecentUnknownExperienceEnd\n  }\n}\n\nfragment MatchRelevanceProvider_vacancy on Vacancy {\n  id\n  code\n  skillGroups {\n    id\n    skillGroupId\n    name\n    isRequired\n    weight\n    terms {\n      name\n      isSkill\n    }\n    experience {\n      durationAmount\n      durationType\n    }\n    recency {\n      durationType\n      durationAmount\n    }\n  }\n  scoringConfig {\n    industryExperience {\n      durationAmount\n      durationType\n    }\n    industryNegativeThreshold\n    industryPositiveThreshold\n    industryRecency {\n      durationAmount\n      durationType\n    }\n    relevanceNegativeThreshold\n    relevancePositiveThreshold\n    relevantExperience {\n      durationAmount\n      durationType\n    }\n    relevantRecency {\n      durationAmount\n      durationType\n    }\n  }\n}\n\nfragment MultiFacetContainer_facet on DefaultAggregationModel {\n  count\n  key\n  title\n  values {\n    count\n    isSelected\n    name\n    text\n  }\n}\n\nfragment ProfileFacetsListFragment on StandardAggregationResults {\n  companies {\n    count\n    ...TagFacetFragment\n  }\n  escoLevel1 {\n    count\n    ...TagFacetFragment\n  }\n  escoLevel2 {\n    count\n    ...TagFacetFragment\n  }\n  escoLevel3 {\n    count\n    ...TagFacetFragment\n  }\n  escoLevel4 {\n    count\n    ...TagFacetFragment\n  }\n  escoLevel5 {\n    count\n    ...TagFacetFragment\n  }\n  industries {\n    count\n    ...TagFacetFragment\n  }\n  skills {\n    count\n    ...TagFacetFragment\n  }\n}\n\nfragment ProfileSkillsFacetsContainer_facets on StandardAggregationResults {\n  skills {\n    count\n    ...MultiFacetContainer_facet\n  }\n}\n\nfragment RecruitProfileApplicationHeader_application on RecruitProfile {\n  id\n  firstName\n  lastName\n  workLocations {\n    currentLocationName\n    currentLocationCountryName\n    workLocations {\n      name\n    }\n    id\n  }\n  currentPosition {\n    title\n    companyName\n    startDate\n    endDate\n    id\n  }\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n  availability {\n    jobSearchStatus\n    availabilityStatus\n    noticeCriteria {\n      availableFrom\n      noticePeriodWeeks\n      noticeTimeframe\n    }\n    id\n  }\n}\n\nfragment TagFacetFragment on DefaultAggregationModel {\n  count\n  key\n  title\n  values {\n    count\n    isSelected\n    name\n    text\n  }\n}\n\nfragment VacancyApplicationSearchFacets_results on StandardAggregationResults {\n  ...ProfileSkillsFacetsContainer_facets\n  companies {\n    count\n    ...MultiFacetContainer_facet\n  }\n  industries {\n    count\n    ...MultiFacetContainer_facet\n  }\n}\n\nfragment VacancyRecommendationHeader_recommendation on RecruitRecommendation {\n  candidate {\n    firstName\n    lastName\n    email\n    phone {\n      phoneCountryCode\n      phoneCountryPrefix\n      phoneNumber\n    }\n    id\n  }\n  profile {\n    currentPosition {\n      companyName\n      startDate\n      endDate\n      title\n      id\n    }\n    id\n  }\n}\n\nfragment VacancyRecommendationSearchActiveFilters_results on RecommendationSearchResults {\n  pagination {\n    totalResults\n    itemsPerPage\n    pageNumber\n    pages\n  }\n  aggregations {\n    status {\n      ...AggregationTags_Aggregation\n    }\n    source {\n      ...AggregationTags_Aggregation\n    }\n    standard {\n      companies {\n        ...AggregationTags_Aggregation\n      }\n      escoLevel1 {\n        ...AggregationTags_Aggregation\n      }\n      escoLevel2 {\n        ...AggregationTags_Aggregation\n      }\n      escoLevel3 {\n        ...AggregationTags_Aggregation\n      }\n      escoLevel4 {\n        ...AggregationTags_Aggregation\n      }\n      escoLevel5 {\n        ...AggregationTags_Aggregation\n      }\n      industries {\n        ...AggregationTags_Aggregation\n      }\n      skills {\n        ...AggregationTags_Aggregation\n      }\n      ...VacancyApplicationSearchFacets_results\n    }\n  }\n}\n\nfragment VacancyRecommendationSearchContainerFragment_2VV6jB on Query {\n  result: recruitRecommendationSearch2(input: $input) {\n    ...VacancyRecommendationSearchFilters_results\n    ...VacancyRecommendationSearchPaging_results\n    ...VacancyRecommendationSearchActiveFilters_results\n    pagination {\n      totalResults\n      itemsPerPage\n      pageNumber\n      pages\n    }\n    aggregations {\n      status {\n        ...MultiFacetContainer_facet\n        title\n        count\n        values {\n          count\n          name\n          isSelected\n          text\n        }\n        key\n      }\n      standard {\n        companies {\n          ...AggregationTags_Aggregation\n        }\n        escoLevel1 {\n          ...AggregationTags_Aggregation\n        }\n        escoLevel2 {\n          ...AggregationTags_Aggregation\n        }\n        escoLevel3 {\n          ...AggregationTags_Aggregation\n        }\n        escoLevel4 {\n          ...AggregationTags_Aggregation\n        }\n        escoLevel5 {\n          ...AggregationTags_Aggregation\n        }\n        industries {\n          ...AggregationTags_Aggregation\n        }\n        skills {\n          ...AggregationTags_Aggregation\n        }\n        ...ProfileFacetsListFragment\n      }\n    }\n    results {\n      id\n      code\n      createdOn\n      createdBy\n      employerId\n      candidateId\n      availableInMonths\n      currentStatus\n      rightToWorkStatus\n      source\n      profile {\n        recruitProfileId\n        rate {\n          countryCode\n          currencyCode\n          maximumRateOfPay\n          minimumRateOfPay\n          payType\n          id\n        }\n        availability {\n          jobSearchStatus\n          id\n          availabilityStatus\n          availability {\n            __typename\n            ... on CandidateAvailableFromDate {\n              date\n            }\n            ... on CandidateAvailableImmediately {\n              immediately\n            }\n            ... on CandidateAvailableNotice {\n              notice\n              timeframe\n            }\n          }\n        }\n        ...RecruitProfileApplicationHeader_application\n        ...CandidateApplicationProfile_profile\n        ...DetailsComponent_profile\n        id\n      }\n      matchRelevance {\n        ...MatchRelevanceProvider_relevance\n      }\n      matchProfile {\n        ...MatchRelevanceProvider_matchProfile\n      }\n      vacancy {\n        code\n        ...MatchRelevanceProvider_vacancy\n        id\n      }\n      candidate {\n        firstName\n        lastName\n        email\n        phone {\n          phoneCountryCode\n          phoneCountryPrefix\n          phoneNumber\n        }\n        ...DetailsComponent_candidate\n        id\n      }\n      ...VacancyRecommendationHeader_recommendation\n    }\n  }\n}\n\nfragment VacancyRecommendationSearchFilters_results on RecommendationSearchResults {\n  aggregations {\n    status {\n      count\n      ...MultiFacetContainer_facet\n    }\n    standard {\n      ...ProfileSkillsFacetsContainer_facets\n      skills {\n        count\n        ...MultiFacetContainer_facet\n      }\n      companies {\n        count\n        ...MultiFacetContainer_facet\n      }\n      industries {\n        count\n        ...MultiFacetContainer_facet\n      }\n      escoLevel1 {\n        count\n        ...MultiFacetContainer_facet\n      }\n    }\n  }\n}\n\nfragment VacancyRecommendationSearchPaging_results on RecommendationSearchResults {\n  pagination {\n    pages\n    pageNumber\n    itemsPerPage\n    totalResults\n  }\n}\n"
    }
  };
}();
node224.hash = "ceb4569a660a4f20becae6480915e6bb";
var VacancyRecommendationSearchContainerQuery_graphql_default = node224;

// src/recommendations/recruiter/components/__generated__/VacancyRecommendationSearchListPaginationQuery.graphql.ts
var node225 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "key",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isSelected",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "text",
    "storageKey": null
  }, v8 = [
    v23,
    v32,
    v4,
    {
      "alias": null,
      "args": null,
      "concreteType": "DefaultAggregationValueModel",
      "kind": "LinkedField",
      "name": "values",
      "plural": true,
      "selections": [
        v23,
        v5,
        v6,
        v7
      ],
      "storageKey": null
    }
  ], v9 = {
    "alias": null,
    "args": null,
    "concreteType": "DefaultAggregationValueModel",
    "kind": "LinkedField",
    "name": "values",
    "plural": true,
    "selections": [
      v23,
      v7,
      v5,
      v6
    ],
    "storageKey": null
  }, v10 = [
    v4,
    v9,
    v23,
    v32
  ], v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdOn",
    "storageKey": null
  }, v14 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v15 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v16 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyName",
    "storageKey": null
  }, v17 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "startDate",
    "storageKey": null
  }, v18 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "endDate",
    "storageKey": null
  }, v19 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "version",
    "storageKey": null
  }, v20 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "titleId",
    "storageKey": null
  }, v21 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "industry",
    "storageKey": null
  }, v222 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyIsVerified",
    "storageKey": null
  }, v232 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyId",
    "storageKey": null
  }, v24 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  }, v25 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "positionType",
    "storageKey": null
  }, v26 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "escoOccupationId",
    "storageKey": null
  }, v27 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "escoHierarchy",
    "storageKey": null
  }, v28 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "skillGroupId",
    "storageKey": null
  }, v29 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "numberOfMonthsCertain",
    "storageKey": null
  }, v30 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "numberOfMonthsCertainPlusUnknown",
    "storageKey": null
  }, v31 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "mostRecentCertainExperienceEnd",
    "storageKey": null
  }, v322 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "mostRecentUnknownExperienceEnd",
    "storageKey": null
  }, v33 = [
    v29,
    v30,
    v31,
    v322
  ], v34 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "weight",
    "storageKey": null
  }, v35 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationAmount",
    "storageKey": null
  }, v36 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationType",
    "storageKey": null
  }, v37 = [
    v35,
    v36
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "VacancyRecommendationSearchListPaginationQuery",
      "selections": [
        {
          "args": v1,
          "kind": "FragmentSpread",
          "name": "VacancyRecommendationSearchContainerFragment"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "VacancyRecommendationSearchListPaginationQuery",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecommendationSearchResults",
          "kind": "LinkedField",
          "name": "recruitRecommendationSearch2",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecommendationSearchAggregations",
              "kind": "LinkedField",
              "name": "aggregations",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "status",
                  "plural": false,
                  "selections": v8,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "StandardAggregationResults",
                  "kind": "LinkedField",
                  "name": "standard",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "skills",
                      "plural": false,
                      "selections": v8,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "companies",
                      "plural": false,
                      "selections": v8,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "industries",
                      "plural": false,
                      "selections": v8,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "escoLevel1",
                      "plural": false,
                      "selections": v8,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "escoLevel2",
                      "plural": false,
                      "selections": v10,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "escoLevel3",
                      "plural": false,
                      "selections": v10,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "escoLevel4",
                      "plural": false,
                      "selections": v10,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "escoLevel5",
                      "plural": false,
                      "selections": v10,
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "source",
                  "plural": false,
                  "selections": [
                    v4,
                    v9
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CollectionMetaData",
              "kind": "LinkedField",
              "name": "pagination",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "pages",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "pageNumber",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "itemsPerPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "totalResults",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitRecommendation",
              "kind": "LinkedField",
              "name": "results",
              "plural": true,
              "selections": [
                v11,
                v12,
                v13,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "createdBy",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "employerId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "candidateId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "availableInMonths",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "currentStatus",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "rightToWorkStatus",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "source",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfile",
                  "kind": "LinkedField",
                  "name": "profile",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "recruitProfileId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileRate",
                      "kind": "LinkedField",
                      "name": "rate",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "countryCode",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "currencyCode",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "maximumRateOfPay",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "minimumRateOfPay",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "payType",
                          "storageKey": null
                        },
                        v11
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileAvailability",
                      "kind": "LinkedField",
                      "name": "availability",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "jobSearchStatus",
                          "storageKey": null
                        },
                        v11,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "availabilityStatus",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "availability",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "__typename",
                              "storageKey": null
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "date",
                                  "storageKey": null
                                }
                              ],
                              "type": "CandidateAvailableFromDate",
                              "abstractKey": null
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "immediately",
                                  "storageKey": null
                                }
                              ],
                              "type": "CandidateAvailableImmediately",
                              "abstractKey": null
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "notice",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "timeframe",
                                  "storageKey": null
                                }
                              ],
                              "type": "CandidateAvailableNotice",
                              "abstractKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "NoticeCriteria",
                          "kind": "LinkedField",
                          "name": "noticeCriteria",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "availableFrom",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "noticePeriodWeeks",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "noticeTimeframe",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    v11,
                    v14,
                    v15,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileWorkLocations",
                      "kind": "LinkedField",
                      "name": "workLocations",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "currentLocationName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "currentLocationCountryName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "WorkLocationEntry",
                          "kind": "LinkedField",
                          "name": "workLocations",
                          "plural": true,
                          "selections": [
                            v6
                          ],
                          "storageKey": null
                        },
                        v11
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileExperience",
                      "kind": "LinkedField",
                      "name": "currentPosition",
                      "plural": false,
                      "selections": [
                        v4,
                        v16,
                        v17,
                        v18,
                        v11
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileExperienceCollection",
                      "kind": "LinkedField",
                      "name": "experiences",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileExperience",
                          "kind": "LinkedField",
                          "name": "items",
                          "plural": true,
                          "selections": [
                            v11,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "candidateExperienceId",
                              "storageKey": null
                            },
                            v4,
                            v16,
                            v17,
                            v18,
                            v13,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "updatedOn",
                              "storageKey": null
                            },
                            v19,
                            v20,
                            v21,
                            v222,
                            v232,
                            v24,
                            v25,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "skills",
                              "storageKey": null
                            },
                            v26,
                            v27
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "SkillUsage",
                          "kind": "LinkedField",
                          "name": "skills",
                          "plural": true,
                          "selections": [
                            v6,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "lastUsed",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "DateRange",
                              "kind": "LinkedField",
                              "name": "periods",
                              "plural": true,
                              "selections": [
                                v17,
                                v18
                              ],
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "averageMonthsUsed",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "totalMonthsUsed",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "totalPositionsUsed",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitResume",
                      "kind": "LinkedField",
                      "name": "resume",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "bucket",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "resumeId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "fileKey",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "fileName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "filePath",
                          "storageKey": null
                        },
                        v11
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitMatchRelevanceContainer",
                  "kind": "LinkedField",
                  "name": "matchRelevance",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitMatchSkillRelevance",
                      "kind": "LinkedField",
                      "name": "skillGroups",
                      "plural": true,
                      "selections": [
                        v28,
                        v29,
                        v30,
                        v31,
                        v322
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitMatchRelevance",
                      "kind": "LinkedField",
                      "name": "industry",
                      "plural": false,
                      "selections": v33,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitMatchRelevance",
                      "kind": "LinkedField",
                      "name": "job",
                      "plural": false,
                      "selections": v33,
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitMatchProfile",
                  "kind": "LinkedField",
                  "name": "matchProfile",
                  "plural": false,
                  "selections": [
                    v11,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "vacancyId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitMatchProfileExperience",
                      "kind": "LinkedField",
                      "name": "experience",
                      "plural": true,
                      "selections": [
                        v11,
                        v12,
                        v19,
                        v20,
                        v4,
                        v21,
                        v222,
                        v232,
                        v16,
                        v24,
                        v17,
                        v18,
                        v25,
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "MatchProfileExperienceSkillGroupScore",
                          "kind": "LinkedField",
                          "name": "skillGroupScores",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "groupId",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "hasMatch",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "minSkillGroupScore",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "score",
                              "storageKey": null
                            },
                            v34
                          ],
                          "storageKey": null
                        },
                        v26,
                        v27,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "jobMatchWeight",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "jobMatchScore",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "companyScore",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "companyScoreWeight",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "hasCompanyVector",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Vacancy",
                  "kind": "LinkedField",
                  "name": "vacancy",
                  "plural": false,
                  "selections": [
                    v12,
                    v11,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "SkillGroup",
                      "kind": "LinkedField",
                      "name": "skillGroups",
                      "plural": true,
                      "selections": [
                        v11,
                        v28,
                        v6,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isRequired",
                          "storageKey": null
                        },
                        v34,
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "SkillGroupTerm",
                          "kind": "LinkedField",
                          "name": "terms",
                          "plural": true,
                          "selections": [
                            v6,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "isSkill",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Duration",
                          "kind": "LinkedField",
                          "name": "experience",
                          "plural": false,
                          "selections": v37,
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Duration",
                          "kind": "LinkedField",
                          "name": "recency",
                          "plural": false,
                          "selections": [
                            v36,
                            v35
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "VacancyScoringConfig",
                      "kind": "LinkedField",
                      "name": "scoringConfig",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Duration",
                          "kind": "LinkedField",
                          "name": "industryExperience",
                          "plural": false,
                          "selections": v37,
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "industryNegativeThreshold",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "industryPositiveThreshold",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Duration",
                          "kind": "LinkedField",
                          "name": "industryRecency",
                          "plural": false,
                          "selections": v37,
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "relevanceNegativeThreshold",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "relevancePositiveThreshold",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Duration",
                          "kind": "LinkedField",
                          "name": "relevantExperience",
                          "plural": false,
                          "selections": v37,
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Duration",
                          "kind": "LinkedField",
                          "name": "relevantRecency",
                          "plural": false,
                          "selections": v37,
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsCandidateAccount",
                  "kind": "LinkedField",
                  "name": "candidate",
                  "plural": false,
                  "selections": [
                    v14,
                    v15,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "email",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CandidatePhoneVerification",
                      "kind": "LinkedField",
                      "name": "phone",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "phoneCountryCode",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "phoneCountryPrefix",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "phoneNumber",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "phoneVerificationStatus",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    v11
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "1cebfc95e0bba1401a8d66349431a627",
      "id": null,
      "metadata": {},
      "name": "VacancyRecommendationSearchListPaginationQuery",
      "operationKind": "query",
      "text": "query VacancyRecommendationSearchListPaginationQuery(\n  $input: RecommendationSearchInput2Input!\n) {\n  ...VacancyRecommendationSearchContainerFragment_2VV6jB\n}\n\nfragment AggregationTags_Aggregation on DefaultAggregationModel {\n  title\n  values {\n    count\n    text\n    isSelected\n    name\n  }\n}\n\nfragment CandidateApplicationProfile_profile on RecruitProfile {\n  experiences {\n    items {\n      id\n      candidateExperienceId\n      title\n      companyName\n      startDate\n      endDate\n      ...ExperienceDetails_experience\n    }\n    skills {\n      name\n      lastUsed\n      periods {\n        startDate\n        endDate\n      }\n      averageMonthsUsed\n      totalMonthsUsed\n      totalPositionsUsed\n    }\n  }\n}\n\nfragment DetailsComponent_candidate on AccountsCandidateAccount {\n  firstName\n  lastName\n  email\n  phone {\n    phoneNumber\n    phoneCountryPrefix\n    phoneVerificationStatus\n  }\n}\n\nfragment DetailsComponent_profile on RecruitProfile {\n  recruitProfileId\n  resume {\n    bucket\n    resumeId\n    fileKey\n    fileName\n    filePath\n    id\n  }\n}\n\nfragment ExperienceDetails_experience on RecruitProfileExperience {\n  id\n  createdOn\n  updatedOn\n  candidateExperienceId\n  version\n  titleId\n  title\n  industry\n  companyIsVerified\n  companyId\n  companyName\n  description\n  startDate\n  endDate\n  positionType\n  skills\n  escoOccupationId\n  escoHierarchy\n}\n\nfragment MatchRelevanceProvider_matchProfile on RecruitMatchProfile {\n  id\n  vacancyId\n  experience {\n    id\n    code\n    version\n    titleId\n    title\n    industry\n    companyIsVerified\n    companyId\n    companyName\n    description\n    startDate\n    endDate\n    positionType\n    skillGroupScores {\n      groupId\n      hasMatch\n      minSkillGroupScore\n      score\n      weight\n    }\n    escoOccupationId\n    escoHierarchy\n    jobMatchWeight\n    jobMatchScore\n    companyScore\n    companyScoreWeight\n    hasCompanyVector\n  }\n}\n\nfragment MatchRelevanceProvider_relevance on RecruitMatchRelevanceContainer {\n  skillGroups {\n    skillGroupId\n    numberOfMonthsCertain\n    numberOfMonthsCertainPlusUnknown\n    mostRecentCertainExperienceEnd\n    mostRecentUnknownExperienceEnd\n  }\n  industry {\n    numberOfMonthsCertain\n    numberOfMonthsCertainPlusUnknown\n    mostRecentCertainExperienceEnd\n    mostRecentUnknownExperienceEnd\n  }\n  job {\n    numberOfMonthsCertain\n    numberOfMonthsCertainPlusUnknown\n    mostRecentCertainExperienceEnd\n    mostRecentUnknownExperienceEnd\n  }\n}\n\nfragment MatchRelevanceProvider_vacancy on Vacancy {\n  id\n  code\n  skillGroups {\n    id\n    skillGroupId\n    name\n    isRequired\n    weight\n    terms {\n      name\n      isSkill\n    }\n    experience {\n      durationAmount\n      durationType\n    }\n    recency {\n      durationType\n      durationAmount\n    }\n  }\n  scoringConfig {\n    industryExperience {\n      durationAmount\n      durationType\n    }\n    industryNegativeThreshold\n    industryPositiveThreshold\n    industryRecency {\n      durationAmount\n      durationType\n    }\n    relevanceNegativeThreshold\n    relevancePositiveThreshold\n    relevantExperience {\n      durationAmount\n      durationType\n    }\n    relevantRecency {\n      durationAmount\n      durationType\n    }\n  }\n}\n\nfragment MultiFacetContainer_facet on DefaultAggregationModel {\n  count\n  key\n  title\n  values {\n    count\n    isSelected\n    name\n    text\n  }\n}\n\nfragment ProfileFacetsListFragment on StandardAggregationResults {\n  companies {\n    count\n    ...TagFacetFragment\n  }\n  escoLevel1 {\n    count\n    ...TagFacetFragment\n  }\n  escoLevel2 {\n    count\n    ...TagFacetFragment\n  }\n  escoLevel3 {\n    count\n    ...TagFacetFragment\n  }\n  escoLevel4 {\n    count\n    ...TagFacetFragment\n  }\n  escoLevel5 {\n    count\n    ...TagFacetFragment\n  }\n  industries {\n    count\n    ...TagFacetFragment\n  }\n  skills {\n    count\n    ...TagFacetFragment\n  }\n}\n\nfragment ProfileSkillsFacetsContainer_facets on StandardAggregationResults {\n  skills {\n    count\n    ...MultiFacetContainer_facet\n  }\n}\n\nfragment RecruitProfileApplicationHeader_application on RecruitProfile {\n  id\n  firstName\n  lastName\n  workLocations {\n    currentLocationName\n    currentLocationCountryName\n    workLocations {\n      name\n    }\n    id\n  }\n  currentPosition {\n    title\n    companyName\n    startDate\n    endDate\n    id\n  }\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n  availability {\n    jobSearchStatus\n    availabilityStatus\n    noticeCriteria {\n      availableFrom\n      noticePeriodWeeks\n      noticeTimeframe\n    }\n    id\n  }\n}\n\nfragment TagFacetFragment on DefaultAggregationModel {\n  count\n  key\n  title\n  values {\n    count\n    isSelected\n    name\n    text\n  }\n}\n\nfragment VacancyApplicationSearchFacets_results on StandardAggregationResults {\n  ...ProfileSkillsFacetsContainer_facets\n  companies {\n    count\n    ...MultiFacetContainer_facet\n  }\n  industries {\n    count\n    ...MultiFacetContainer_facet\n  }\n}\n\nfragment VacancyRecommendationHeader_recommendation on RecruitRecommendation {\n  candidate {\n    firstName\n    lastName\n    email\n    phone {\n      phoneCountryCode\n      phoneCountryPrefix\n      phoneNumber\n    }\n    id\n  }\n  profile {\n    currentPosition {\n      companyName\n      startDate\n      endDate\n      title\n      id\n    }\n    id\n  }\n}\n\nfragment VacancyRecommendationSearchActiveFilters_results on RecommendationSearchResults {\n  pagination {\n    totalResults\n    itemsPerPage\n    pageNumber\n    pages\n  }\n  aggregations {\n    status {\n      ...AggregationTags_Aggregation\n    }\n    source {\n      ...AggregationTags_Aggregation\n    }\n    standard {\n      companies {\n        ...AggregationTags_Aggregation\n      }\n      escoLevel1 {\n        ...AggregationTags_Aggregation\n      }\n      escoLevel2 {\n        ...AggregationTags_Aggregation\n      }\n      escoLevel3 {\n        ...AggregationTags_Aggregation\n      }\n      escoLevel4 {\n        ...AggregationTags_Aggregation\n      }\n      escoLevel5 {\n        ...AggregationTags_Aggregation\n      }\n      industries {\n        ...AggregationTags_Aggregation\n      }\n      skills {\n        ...AggregationTags_Aggregation\n      }\n      ...VacancyApplicationSearchFacets_results\n    }\n  }\n}\n\nfragment VacancyRecommendationSearchContainerFragment_2VV6jB on Query {\n  result: recruitRecommendationSearch2(input: $input) {\n    ...VacancyRecommendationSearchFilters_results\n    ...VacancyRecommendationSearchPaging_results\n    ...VacancyRecommendationSearchActiveFilters_results\n    pagination {\n      totalResults\n      itemsPerPage\n      pageNumber\n      pages\n    }\n    aggregations {\n      status {\n        ...MultiFacetContainer_facet\n        title\n        count\n        values {\n          count\n          name\n          isSelected\n          text\n        }\n        key\n      }\n      standard {\n        companies {\n          ...AggregationTags_Aggregation\n        }\n        escoLevel1 {\n          ...AggregationTags_Aggregation\n        }\n        escoLevel2 {\n          ...AggregationTags_Aggregation\n        }\n        escoLevel3 {\n          ...AggregationTags_Aggregation\n        }\n        escoLevel4 {\n          ...AggregationTags_Aggregation\n        }\n        escoLevel5 {\n          ...AggregationTags_Aggregation\n        }\n        industries {\n          ...AggregationTags_Aggregation\n        }\n        skills {\n          ...AggregationTags_Aggregation\n        }\n        ...ProfileFacetsListFragment\n      }\n    }\n    results {\n      id\n      code\n      createdOn\n      createdBy\n      employerId\n      candidateId\n      availableInMonths\n      currentStatus\n      rightToWorkStatus\n      source\n      profile {\n        recruitProfileId\n        rate {\n          countryCode\n          currencyCode\n          maximumRateOfPay\n          minimumRateOfPay\n          payType\n          id\n        }\n        availability {\n          jobSearchStatus\n          id\n          availabilityStatus\n          availability {\n            __typename\n            ... on CandidateAvailableFromDate {\n              date\n            }\n            ... on CandidateAvailableImmediately {\n              immediately\n            }\n            ... on CandidateAvailableNotice {\n              notice\n              timeframe\n            }\n          }\n        }\n        ...RecruitProfileApplicationHeader_application\n        ...CandidateApplicationProfile_profile\n        ...DetailsComponent_profile\n        id\n      }\n      matchRelevance {\n        ...MatchRelevanceProvider_relevance\n      }\n      matchProfile {\n        ...MatchRelevanceProvider_matchProfile\n      }\n      vacancy {\n        code\n        ...MatchRelevanceProvider_vacancy\n        id\n      }\n      candidate {\n        firstName\n        lastName\n        email\n        phone {\n          phoneCountryCode\n          phoneCountryPrefix\n          phoneNumber\n        }\n        ...DetailsComponent_candidate\n        id\n      }\n      ...VacancyRecommendationHeader_recommendation\n    }\n  }\n}\n\nfragment VacancyRecommendationSearchFilters_results on RecommendationSearchResults {\n  aggregations {\n    status {\n      count\n      ...MultiFacetContainer_facet\n    }\n    standard {\n      ...ProfileSkillsFacetsContainer_facets\n      skills {\n        count\n        ...MultiFacetContainer_facet\n      }\n      companies {\n        count\n        ...MultiFacetContainer_facet\n      }\n      industries {\n        count\n        ...MultiFacetContainer_facet\n      }\n      escoLevel1 {\n        count\n        ...MultiFacetContainer_facet\n      }\n    }\n  }\n}\n\nfragment VacancyRecommendationSearchPaging_results on RecommendationSearchResults {\n  pagination {\n    pages\n    pageNumber\n    itemsPerPage\n    totalResults\n  }\n}\n"
    }
  };
}();
node225.hash = "e2cd85d5f47ff628ab387b4dd9a5c932";
var VacancyRecommendationSearchListPaginationQuery_graphql_default = node225;

// src/recommendations/recruiter/components/__generated__/VacancyRecommendationSearchContainerFragment.graphql.ts
var node226 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  }, v1 = [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AggregationTags_Aggregation"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "refetch": {
        "connection": null,
        "fragmentPathInResult": [],
        "operation": VacancyRecommendationSearchListPaginationQuery_graphql_default
      }
    },
    "name": "VacancyRecommendationSearchContainerFragment",
    "selections": [
      {
        "alias": "result",
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "RecommendationSearchResults",
        "kind": "LinkedField",
        "name": "recruitRecommendationSearch2",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "VacancyRecommendationSearchFilters_results"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "VacancyRecommendationSearchPaging_results"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "VacancyRecommendationSearchActiveFilters_results"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CollectionMetaData",
            "kind": "LinkedField",
            "name": "pagination",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalResults",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "itemsPerPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pageNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pages",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecommendationSearchAggregations",
            "kind": "LinkedField",
            "name": "aggregations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "MultiFacetContainer_facet"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  v0,
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DefaultAggregationValueModel",
                    "kind": "LinkedField",
                    "name": "values",
                    "plural": true,
                    "selections": [
                      v0,
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isSelected",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "text",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "key",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "StandardAggregationResults",
                "kind": "LinkedField",
                "name": "standard",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DefaultAggregationModel",
                    "kind": "LinkedField",
                    "name": "companies",
                    "plural": false,
                    "selections": v1,
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DefaultAggregationModel",
                    "kind": "LinkedField",
                    "name": "escoLevel1",
                    "plural": false,
                    "selections": v1,
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DefaultAggregationModel",
                    "kind": "LinkedField",
                    "name": "escoLevel2",
                    "plural": false,
                    "selections": v1,
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DefaultAggregationModel",
                    "kind": "LinkedField",
                    "name": "escoLevel3",
                    "plural": false,
                    "selections": v1,
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DefaultAggregationModel",
                    "kind": "LinkedField",
                    "name": "escoLevel4",
                    "plural": false,
                    "selections": v1,
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DefaultAggregationModel",
                    "kind": "LinkedField",
                    "name": "escoLevel5",
                    "plural": false,
                    "selections": v1,
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DefaultAggregationModel",
                    "kind": "LinkedField",
                    "name": "industries",
                    "plural": false,
                    "selections": v1,
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DefaultAggregationModel",
                    "kind": "LinkedField",
                    "name": "skills",
                    "plural": false,
                    "selections": v1,
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ProfileFacetsListFragment"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitRecommendation",
            "kind": "LinkedField",
            "name": "results",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              v23,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdOn",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdBy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "employerId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "candidateId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "availableInMonths",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currentStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rightToWorkStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "source",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitProfile",
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "recruitProfileId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RecruitProfileRate",
                    "kind": "LinkedField",
                    "name": "rate",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "countryCode",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "currencyCode",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "maximumRateOfPay",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "minimumRateOfPay",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "payType",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RecruitProfileAvailability",
                    "kind": "LinkedField",
                    "name": "availability",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "jobSearchStatus",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "availabilityStatus",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "availability",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "date",
                                "storageKey": null
                              }
                            ],
                            "type": "CandidateAvailableFromDate",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "immediately",
                                "storageKey": null
                              }
                            ],
                            "type": "CandidateAvailableImmediately",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "notice",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "timeframe",
                                "storageKey": null
                              }
                            ],
                            "type": "CandidateAvailableNotice",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "RecruitProfileApplicationHeader_application"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "CandidateApplicationProfile_profile"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "DetailsComponent_profile"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitMatchRelevanceContainer",
                "kind": "LinkedField",
                "name": "matchRelevance",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "MatchRelevanceProvider_relevance"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitMatchProfile",
                "kind": "LinkedField",
                "name": "matchProfile",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "MatchRelevanceProvider_matchProfile"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Vacancy",
                "kind": "LinkedField",
                "name": "vacancy",
                "plural": false,
                "selections": [
                  v23,
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "MatchRelevanceProvider_vacancy"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountsCandidateAccount",
                "kind": "LinkedField",
                "name": "candidate",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "email",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CandidatePhoneVerification",
                    "kind": "LinkedField",
                    "name": "phone",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "phoneCountryCode",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "phoneCountryPrefix",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "phoneNumber",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "DetailsComponent_candidate"
                  }
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "VacancyRecommendationHeader_recommendation"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node226.hash = "e2cd85d5f47ff628ab387b4dd9a5c932";
var VacancyRecommendationSearchContainerFragment_graphql_default = node226;

// src/recommendations/recruiter/components/VacancyRecommendationSearchContainer.tsx
import {
  Suspense as Suspense63,
  memo as memo3,
  useCallback as useCallback117,
  useEffect as useEffect28,
  useMemo as useMemo27,
  useTransition as useTransition10
} from "react";
import { useQueryLoader as useQueryLoader8 } from "react-relay";
import { useAtom as useAtom9 } from "jotai";
import { useHydrateAtoms as useHydrateAtoms2 } from "jotai/utils";
import { EdSkeleton as EdSkeleton55, Loading as Loading3 } from "shared-ui";

// src/recommendations/recruiter/lib/RecommendationsSearch.ts
import { atom as atom9 } from "jotai";
import { atomWithStorage as atomWithStorage2 } from "jotai/utils";
import { SortDir as SortDir5 } from "shared-ui";
var RecommendationSortFieldType = /* @__PURE__ */ ((RecommendationSortFieldType2) => {
  RecommendationSortFieldType2["BEST_MATCH"] = "BEST_MATCH";
  RecommendationSortFieldType2["NAME"] = "NAME";
  RecommendationSortFieldType2["JOB_MATCH_SCORE"] = "JOB_MATCH_SCORE";
  return RecommendationSortFieldType2;
})(RecommendationSortFieldType || {});
var matchSortFields = [
  {
    id: "BEST_MATCH" /* BEST_MATCH */,
    name: "Sort by 'Rank'"
  },
  {
    id: "NAME" /* NAME */,
    name: "Sort by 'Name'"
  },
  {
    id: "JOB_MATCH_SCORE" /* JOB_MATCH_SCORE */,
    name: "Sort by 'Job Match Score'"
  }
];
var recommendationSortFieldAtom = atomWithStorage2(
  "recommendationSortField",
  "BEST_MATCH" /* BEST_MATCH */
);
var recommendationSortDirAtom = atomWithStorage2(
  "recommendationSortDir",
  SortDir5.Asc
);
function recommendationSortFieldToGraphQL(sort) {
  switch (sort) {
    case "BEST_MATCH" /* BEST_MATCH */: {
      return {
        standard: "BEST_MATCH"
      };
    }
    case "NAME" /* NAME */: {
      return {
        standard: "NAME"
      };
    }
    case "JOB_MATCH_SCORE" /* JOB_MATCH_SCORE */: {
      return {
        custom: "JOB_MATCH_SCORE"
      };
    }
  }
}
var recommendationSearchInputAtom = atom9({
  filters: {
    vacancies: []
  },
  fullTextSearch: {
    query: "",
    queryField: {
      standard: "ALL"
    }
  },
  pagination: {
    pageNumber: 1,
    pageSize: 20
  },
  sort: {
    field: {
      standard: "BEST_MATCH"
    },
    order: "DESC"
  }
});

// src/recommendations/recruiter/lib/RecommendationsSearchContext.ts
import { atom as atom10 } from "jotai";
var recommendationsSearchContextAtom = atom10({
  isFiltersOpen: false
});

// src/recommendations/recruiter/components/VacancyRecommendationSearch.tsx
import { Suspense as Suspense61, useCallback as useCallback116 } from "react";
import {
  usePreloadedQuery as usePreloadedQuery18,
  useRefetchableFragment as useRefetchableFragment9
} from "react-relay";
import { useAtom as useAtom8 } from "jotai";
import { Button as Button59, IconText as IconText3, Icons as Icons4, classNames as classNames24 } from "shared-ui";
import { useToggle as useToggle24 } from "shared-lib";
import { MultiFacetContainer as MultiFacetContainer3 } from "app-core";

// src/recommendations/recruiter/components/__generated__/VacancyRecommendationSearchPaging_results.graphql.ts
var node227 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VacancyRecommendationSearchPaging_results",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CollectionMetaData",
      "kind": "LinkedField",
      "name": "pagination",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pages",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pageNumber",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "itemsPerPage",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalResults",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__id",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "RecommendationSearchResults",
  "abstractKey": null
};
node227.hash = "715237ab0ab7f37f8c15cc28c8e411fa";
var VacancyRecommendationSearchPaging_results_graphql_default = node227;

// src/recommendations/recruiter/components/VacancyRecommendationSearchPaging.tsx
import { useCallback as useCallback110 } from "react";
import { useFragment as useFragment59 } from "react-relay";
import { useAtomValue as useAtomValue4 } from "jotai";
import { SimplePagination as SimplePagination3, SimplePaginationCounts } from "shared-ui";
import { jsx as jsx189, jsxs as jsxs127 } from "react/jsx-runtime";
var fragmentDef50 = VacancyRecommendationSearchPaging_results_graphql_default;
var VacancyRecommendationSearchPaging = ({
  fragmentRef,
  onSearch
}) => {
  const data = useFragment59(
    fragmentDef50,
    fragmentRef
  );
  const search4 = useAtomValue4(recommendationSearchInputAtom);
  const onPage = useCallback110(
    (p4) => {
      const newSearch = {
        ...search4,
        pagination: {
          ...search4.pagination,
          pageNumber: p4
        }
      };
      onSearch("VacancyRecommendationSearchPaging", newSearch);
    },
    [search4, onSearch]
  );
  return /* @__PURE__ */ jsxs127("div", { className: "flex flex-col items-end", children: [
    /* @__PURE__ */ jsx189(
      SimplePaginationCounts,
      {
        pages: data.pagination.pages,
        pageNumber: data.pagination.pageNumber,
        itemsPerPage: data.pagination.itemsPerPage,
        totalResults: data.pagination.totalResults
      }
    ),
    data.pagination.pages > 1 && /* @__PURE__ */ jsx189(
      SimplePagination3,
      {
        name: "vacancy-application-search-paging",
        pages: data.pagination.pages,
        pageNumber: data.pagination.pageNumber,
        itemsPerPage: data.pagination.itemsPerPage,
        totalResults: data.pagination.totalResults,
        onPage
      }
    )
  ] });
};

// src/recommendations/recruiter/components/__generated__/VacancyRecommendationSearchFilters_results.graphql.ts
var node228 = function() {
  var v0 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "count",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MultiFacetContainer_facet"
    }
  ];
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "VacancyRecommendationSearchFilters_results",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecommendationSearchAggregations",
        "kind": "LinkedField",
        "name": "aggregations",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DefaultAggregationModel",
            "kind": "LinkedField",
            "name": "status",
            "plural": false,
            "selections": v0,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StandardAggregationResults",
            "kind": "LinkedField",
            "name": "standard",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ProfileSkillsFacetsContainer_facets"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "skills",
                "plural": false,
                "selections": v0,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "companies",
                "plural": false,
                "selections": v0,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "industries",
                "plural": false,
                "selections": v0,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "escoLevel1",
                "plural": false,
                "selections": v0,
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "kind": "ClientExtension",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__id",
            "storageKey": null
          }
        ]
      }
    ],
    "type": "RecommendationSearchResults",
    "abstractKey": null
  };
}();
node228.hash = "532fe2f30787531fc46c6893cd699770";
var VacancyRecommendationSearchFilters_results_graphql_default = node228;

// src/recommendations/recruiter/components/VacancyRecommendationSearchFilters.tsx
var import_lodash4 = __toESM(require_lodash());
import { useCallback as useCallback111, useState as useState64 } from "react";
import { useFragment as useFragment60 } from "react-relay";
import { useAtom as useAtom7 } from "jotai";
import {
  classNames as classNames22,
  FilterSectionContainer as FilterSectionContainer2,
  FilterSectionLink as FilterSectionLink2
} from "shared-ui";
import { MultiFacetContainer as MultiFacetContainer2 } from "app-core";
import { jsx as jsx190, jsxs as jsxs128 } from "react/jsx-runtime";
var fragmentDef51 = VacancyRecommendationSearchFilters_results_graphql_default;
var filterSections = [
  { key: "STATUS", title: "Status" },
  { key: "SKILLS", title: "Skills" },
  { key: "INDUSTRIES", title: "Industries" },
  { key: "COMPANIES", title: "Companies" },
  { key: "ESCOLEVEL1", title: "Esco Level 1" }
];
var VacancyRecommendationSearchFilters = ({
  fragmentRef,
  onSearch
}) => {
  const [context, setContext] = useAtom7(recommendationsSearchContextAtom);
  const toggleOpen = useCallback111(() => {
    setContext({
      ...context,
      isFiltersOpen: !context.isFiltersOpen
    });
  }, [context, setContext]);
  const [searchInput] = useAtom7(recommendationSearchInputAtom);
  const result = useFragment60(
    fragmentDef51,
    fragmentRef
  );
  const [selectedSection, setSelectedSection] = useState64(
    null
  );
  const sections = filterSections.map((s4) => {
    return /* @__PURE__ */ jsx190(
      FilterSectionLink2,
      {
        section: s4,
        onSelect: setSelectedSection,
        selectedKey: selectedSection
      },
      s4.key
    );
  });
  const onFilterChange = useCallback111(
    (change) => {
      const payload = {
        ...searchInput,
        filters: {
          ...searchInput.filters,
          ...change
        }
      };
      onSearch("VacancyRecommendationSearchFilters", payload);
    },
    [searchInput, onSearch]
  );
  const onStandardFilterChange = useCallback111(
    (change) => {
      const payload = {
        ...searchInput,
        filters: {
          ...searchInput.filters,
          standard: {
            ...searchInput.filters?.standard,
            ...change
          }
        }
      };
      onSearch("VacancyRecommendationSearchStandardFilters", payload);
    },
    [searchInput, onSearch]
  );
  const onStatusChange = useCallback111(
    (selected) => {
      onFilterChange({
        status: selected
      });
    },
    [onFilterChange]
  );
  const onCompaniesChanged = useCallback111(
    (selected) => {
      onStandardFilterChange({
        companies: selected
      });
    },
    [onStandardFilterChange]
  );
  const onIndustriesChanged = useCallback111(
    (selected) => {
      onStandardFilterChange({
        industries: selected
      });
    },
    [onStandardFilterChange]
  );
  const onEsco1Changed = useCallback111(
    (selected) => {
      onStandardFilterChange({
        escoLevel1: selected
      });
    },
    [onStandardFilterChange]
  );
  const onSkillsChanged = useCallback111(
    (selected) => {
      onStandardFilterChange({
        skills: selected
      });
    },
    [onStandardFilterChange]
  );
  return /* @__PURE__ */ jsx190("div", { className: classNames22("w-full rounded-2xl border bg-white"), children: /* @__PURE__ */ jsxs128(
    FilterSectionContainer2,
    {
      sections,
      isFiltersOpen: true,
      onToggleOpen: import_lodash4.noop,
      hasSelectedValue: selectedSection !== null,
      toggleSelectedValue: () => setSelectedSection(null),
      children: [
        selectedSection === "COMPANIES" && /* @__PURE__ */ jsx190(
          MultiFacetContainer2,
          {
            fragmentRef: result.aggregations.standard.companies,
            onFacetChanged: onCompaniesChanged
          }
        ),
        selectedSection === "STATUS" && /* @__PURE__ */ jsx190(
          MultiFacetContainer2,
          {
            fragmentRef: result.aggregations.status,
            onFacetChanged: onStatusChange
          }
        ),
        selectedSection === "SKILLS" && /* @__PURE__ */ jsx190(
          ProfileSkillsFacetsContainer,
          {
            fragmentRef: result.aggregations.standard,
            onChanged: onSkillsChanged
          }
        ),
        selectedSection === "INDUSTRIES" && /* @__PURE__ */ jsx190(
          MultiFacetContainer2,
          {
            fragmentRef: result.aggregations.standard.industries,
            onFacetChanged: onIndustriesChanged
          }
        ),
        selectedSection === "ESCOLEVEL1" && /* @__PURE__ */ jsx190(
          MultiFacetContainer2,
          {
            fragmentRef: result.aggregations.standard.escoLevel1,
            onFacetChanged: onEsco1Changed
          }
        )
      ]
    }
  ) });
};

// src/recommendations/recruiter/components/VacancyRecommendationSearchQuery.tsx
import { useCallback as useCallback113 } from "react";
import { useAtomValue as useAtomValue5 } from "jotai";
import { MagnifyingGlassIcon as MagnifyingGlassIcon2 } from "@heroicons/react/20/solid";
import { DebouncedInput as DebouncedInput3 } from "shared-ui";
import { jsx as jsx191, jsxs as jsxs129 } from "react/jsx-runtime";
var VacancyRecommendationSearchQuery = ({ onSearch }) => {
  const search4 = useAtomValue5(recommendationSearchInputAtom);
  const onQueryChanged = useCallback113(
    (query3) => {
      const newSearch = {
        ...search4,
        fullTextSearch: {
          query: query3,
          queryField: {
            standard: "ALL"
          }
        }
      };
      onSearch("VacancyRecommendationSearchQuery", newSearch);
    },
    [onSearch]
  );
  return /* @__PURE__ */ jsxs129("div", { className: "flex grow gap-x-4 lg:gap-x-6", children: [
    /* @__PURE__ */ jsx191("label", { htmlFor: "search-field", className: "sr-only", children: "Search" }),
    /* @__PURE__ */ jsxs129("div", { className: "relative w-full text-gray-400 focus-within:text-gray-600", children: [
      /* @__PURE__ */ jsx191("div", { className: "pointer-events-none absolute inset-y-0 right-1 flex items-center", children: /* @__PURE__ */ jsx191(
        MagnifyingGlassIcon2,
        {
          className: "h-5 w-5 flex-shrink-0",
          "aria-hidden": "true"
        }
      ) }),
      /* @__PURE__ */ jsx191(
        DebouncedInput3,
        {
          placeholder: "Search",
          value: search4.fullTextSearch?.query || "",
          onValueChanged: onQueryChanged
        }
      )
    ] })
  ] });
};

// src/recommendations/recruiter/components/VacancyRecommendationSearchSortFields.tsx
import { useCallback as useCallback114 } from "react";
import { useAtomValue as useAtomValue6 } from "jotai";
import { jsx as jsx193 } from "react/jsx-runtime";
function getVacancyRecommendationSearchSortField(sort) {
  if (sort.standard && sort.standard === "BEST_MATCH") {
    return "BEST_MATCH" /* BEST_MATCH */;
  }
  if (sort.standard && sort.standard === "NAME") {
    return "NAME" /* NAME */;
  }
  if (sort.custom && sort.custom === "JOB_MATCH_SCORE") {
    return "JOB_MATCH_SCORE" /* JOB_MATCH_SCORE */;
  }
  return "BEST_MATCH" /* BEST_MATCH */;
}
var VacancyRecommendationSearchSortFields = ({
  onSearch
}) => {
  const search4 = useAtomValue6(recommendationSearchInputAtom);
  const onSortChanged = useCallback114(
    (value) => {
      const newSearch = {
        ...search4,
        sort: {
          ...search4.sort,
          field: recommendationSortFieldToGraphQL(value)
        }
      };
      onSearch("VacancyRecommendationSearchSortFields", newSearch);
    },
    [search4, onSearch]
  );
  return /* @__PURE__ */ jsx193(
    "select",
    {
      id: "vacancyRecommendationSearchSortFields",
      name: "vacancyRecommendationSearchSortFields",
      value: getVacancyRecommendationSearchSortField(search4.sort.field),
      className: "focus:ring-primary-500 focus:border-primary-500 block grow rounded-md border-gray-300",
      onChange: (e4) => onSortChanged(e4.target.value),
      children: matchSortFields.map((i4) => /* @__PURE__ */ jsx193("option", { value: i4.id, children: i4.name }, i4.id))
    }
  );
};

// src/recommendations/recruiter/components/VacancyRecommendationSearchSortDir.tsx
import { useCallback as useCallback115 } from "react";
import { useAtomValue as useAtomValue7 } from "jotai";
import { getSortDirFromGraphQL, sortDirToGraphQL as sortDirToGraphQL3 } from "shared-ui";
import { jsx as jsx194 } from "react/jsx-runtime";
var VacancyRecommendationSearchSortDir = ({ onSearch }) => {
  const search4 = useAtomValue7(recommendationSearchInputAtom);
  const onSortChanged = useCallback115(
    (value) => {
      const newSearch = {
        ...search4,
        sort: {
          ...search4.sort,
          order: sortDirToGraphQL3(value)
        }
      };
      onSearch("VacancyRecommendationSearchSortDir", newSearch);
    },
    [search4, onSearch]
  );
  return /* @__PURE__ */ jsx194("div", { children: /* @__PURE__ */ jsx194(
    SortDirectionList,
    {
      value: getSortDirFromGraphQL(search4.sort.order),
      onChanged: onSortChanged
    }
  ) });
};

// src/candidates/components/__generated__/VacancyRecommendationSearchActiveFilters_results.graphql.ts
var node229 = function() {
  var v0 = [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AggregationTags_Aggregation"
    }
  ];
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "VacancyRecommendationSearchActiveFilters_results",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CollectionMetaData",
        "kind": "LinkedField",
        "name": "pagination",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalResults",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "itemsPerPage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pageNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pages",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RecommendationSearchAggregations",
        "kind": "LinkedField",
        "name": "aggregations",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DefaultAggregationModel",
            "kind": "LinkedField",
            "name": "status",
            "plural": false,
            "selections": v0,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DefaultAggregationModel",
            "kind": "LinkedField",
            "name": "source",
            "plural": false,
            "selections": v0,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StandardAggregationResults",
            "kind": "LinkedField",
            "name": "standard",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "companies",
                "plural": false,
                "selections": v0,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "escoLevel1",
                "plural": false,
                "selections": v0,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "escoLevel2",
                "plural": false,
                "selections": v0,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "escoLevel3",
                "plural": false,
                "selections": v0,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "escoLevel4",
                "plural": false,
                "selections": v0,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "escoLevel5",
                "plural": false,
                "selections": v0,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "industries",
                "plural": false,
                "selections": v0,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "skills",
                "plural": false,
                "selections": v0,
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "VacancyApplicationSearchFacets_results"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "kind": "ClientExtension",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__id",
            "storageKey": null
          }
        ]
      }
    ],
    "type": "RecommendationSearchResults",
    "abstractKey": null
  };
}();
node229.hash = "6bd5d496b71f51108553d424dec7d970";
var VacancyRecommendationSearchActiveFilters_results_graphql_default = node229;

// src/candidates/components/VacancyRecommendationSearchActiveFilters.tsx
import { Suspense as Suspense59 } from "react";
import { useFragment as useFragment61 } from "react-relay";
import { AggregationTags as AggregationTags2, DisplayFieldEnum as DisplayFieldEnum2 } from "shared-ui";
import { jsx as jsx195, jsxs as jsxs130 } from "react/jsx-runtime";
var fragmentDef52 = VacancyRecommendationSearchActiveFilters_results_graphql_default;
var VacancyRecommendationSearchActiveFilters = ({
  fragmentRef,
  onDeselect
}) => {
  const data = useFragment61(
    fragmentDef52,
    fragmentRef
  );
  return /* @__PURE__ */ jsx195(Suspense59, { fallback: "Loading...", children: /* @__PURE__ */ jsx195("div", { className: "flex justify-between gap-5", children: /* @__PURE__ */ jsxs130("div", { className: "flex flex-wrap gap-1", children: [
    /* @__PURE__ */ jsx195(
      AggregationTags2,
      {
        fragmentRef: data.aggregations.source,
        displayField: DisplayFieldEnum2.text,
        onSelected: (value) => onDeselect({ source: "source", value })
      }
    ),
    /* @__PURE__ */ jsx195(
      AggregationTags2,
      {
        fragmentRef: data.aggregations.standard.companies,
        onSelected: (value) => onDeselect({ source: "companies", value, isStandard: true })
      }
    ),
    /* @__PURE__ */ jsx195(
      AggregationTags2,
      {
        fragmentRef: data.aggregations.standard.industries,
        onSelected: (value) => onDeselect({ source: "industries", value, isStandard: true })
      }
    ),
    /* @__PURE__ */ jsx195(
      AggregationTags2,
      {
        fragmentRef: data.aggregations.standard.skills,
        displayField: DisplayFieldEnum2.text,
        onSelected: (value) => onDeselect({ source: "skills", value, isStandard: true })
      }
    ),
    /* @__PURE__ */ jsx195(
      AggregationTags2,
      {
        fragmentRef: data.aggregations.standard.escoLevel1,
        onSelected: (value) => onDeselect({ source: "escoLevel1", value, isStandard: true })
      }
    ),
    /* @__PURE__ */ jsx195(
      AggregationTags2,
      {
        fragmentRef: data.aggregations.standard.escoLevel2,
        onSelected: (value) => onDeselect({ source: "escoLevel2", value, isStandard: true })
      }
    ),
    /* @__PURE__ */ jsx195(
      AggregationTags2,
      {
        fragmentRef: data.aggregations.standard.escoLevel3,
        onSelected: (value) => onDeselect({ source: "escoLevel3", value, isStandard: true })
      }
    ),
    /* @__PURE__ */ jsx195(
      AggregationTags2,
      {
        fragmentRef: data.aggregations.standard.escoLevel4,
        onSelected: (value) => onDeselect({ source: "escoLevel4", value, isStandard: true })
      }
    ),
    /* @__PURE__ */ jsx195(
      AggregationTags2,
      {
        fragmentRef: data.aggregations.standard.escoLevel5,
        onSelected: (value) => onDeselect({ source: "escoLevel5", value, isStandard: true })
      }
    )
  ] }) }) });
};

// src/recommendations/recruiter/components/VacancyRecommendationSearchList.tsx
import { useState as useState66, Suspense as Suspense60 } from "react";
import {
  usePreloadedQuery as usePreloadedQuery17,
  useRefetchableFragment as useRefetchableFragment8
} from "react-relay";
import { Tag as Tag12, classNames as classNames23 } from "shared-ui";

// src/candidates/components/__generated__/ResumeDownloadQuery.graphql.ts
var node230 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "profileId"
    }
  ], v1 = [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "profileId",
          "variableName": "profileId"
        }
      ],
      "kind": "ScalarField",
      "name": "recruitResumeLinkByCandidateId",
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ResumeDownloadQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ResumeDownloadQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "2c8125eebd37759e1816af37b978a8be",
      "id": null,
      "metadata": {},
      "name": "ResumeDownloadQuery",
      "operationKind": "query",
      "text": "query ResumeDownloadQuery(\n  $profileId: UUID!\n) {\n  recruitResumeLinkByCandidateId(profileId: $profileId)\n}\n"
    }
  };
}();
node230.hash = "4bd017ded493293f07ea3b432e69260e";
var ResumeDownloadQuery_graphql_default = node230;

// src/candidates/components/ResumeDownload.tsx
import { useEffect as useEffect27, useState as useState65 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery28 } from "react-relay";
import { ArrowDownTrayIcon } from "@heroicons/react/24/outline";
import { Button as Button58 } from "shared-ui";
import { Fragment as Fragment47, jsx as jsx196, jsxs as jsxs131 } from "react/jsx-runtime";
var resumeDownloadQueryDef = ResumeDownloadQuery_graphql_default;
var DeferredResumeDownload = ({
  profileId
}) => {
  const [clicked, setClicked] = useState65(false);
  return /* @__PURE__ */ jsxs131("div", { children: [
    !clicked && /* @__PURE__ */ jsxs131(
      Button58,
      {
        onClick: () => setClicked(true),
        className: "justify-baseline flex gap-2",
        children: [
          /* @__PURE__ */ jsx196("span", { children: "Download C.V." }),
          /* @__PURE__ */ jsx196(ArrowDownTrayIcon, { className: "h-5 w-5" })
        ]
      }
    ),
    clicked && /* @__PURE__ */ jsx196(Redirect, { profileId, children: /* @__PURE__ */ jsxs131("div", { className: "justify-baseline flex gap-2", children: [
      /* @__PURE__ */ jsx196("span", { children: "Download C.V." }),
      /* @__PURE__ */ jsx196(ArrowDownTrayIcon, { className: "h-5 w-5" })
    ] }) })
  ] });
};
var Redirect = ({
  profileId,
  children
}) => {
  const data = useLazyLoadQuery28(resumeDownloadQueryDef, {
    profileId
  });
  useEffect27(() => {
    if (data.recruitResumeLinkByCandidateId) {
      window.open(data.recruitResumeLinkByCandidateId, "_blank");
    }
  }, [data.recruitResumeLinkByCandidateId]);
  if (data.recruitResumeLinkByCandidateId == "") {
    return /* @__PURE__ */ jsx196("div", { children: "\u26D4\uFE0F No Resume Found" });
  }
  return /* @__PURE__ */ jsx196(
    "a",
    {
      href: data.recruitResumeLinkByCandidateId,
      target: "_blank",
      rel: "noreferrer",
      children
    }
  );
};

// src/recommendations/recruiter/components/VacancyRecommendationSearchList.tsx
import { jsx as jsx197, jsxs as jsxs133 } from "react/jsx-runtime";
var tabs2 = [
  { name: "Relevance", to: "relevance" },
  { name: "Work History", to: "profile" },
  { name: "Details", to: "details" },
  { name: "Application History", to: "application-history" },
  { name: "Recommendation History", to: "recommendation-history" }
];
var VacancyRecommendationSearchList = ({
  queryRef: queryRef3
}) => {
  const query3 = usePreloadedQuery17(
    vacancyRecommendationSearchQueryDef,
    queryRef3
  );
  const [data] = useRefetchableFragment8(vacancyRecommendationSearchFragmentDef, query3);
  const recommendations = data.result.results || [];
  return /* @__PURE__ */ jsxs133("div", { className: "flex w-full flex-wrap gap-3", children: [
    recommendations?.length == 0 && /* @__PURE__ */ jsx197("div", { className: "flex h-[400px] w-full items-center justify-center rounded-2xl border-2 border-dashed text-center text-2xl text-gray-700", children: "No recommendations found" }),
    recommendations.map((recommendation) => /* @__PURE__ */ jsx197(
      Recommendation,
      {
        recommendation
      },
      recommendation.code
    ))
  ] });
};
var Recommendation = ({ recommendation }) => {
  const [selectedTab, setSelectedTab] = useState66("");
  return /* @__PURE__ */ jsxs133(
    "div",
    {
      className: "items-top flex w-full flex-col justify-between gap-2 overflow-hidden rounded rounded-xl border border-b border-gray-200 bg-white shadow-md",
      children: [
        /* @__PURE__ */ jsxs133("div", { className: "flex flex-col gap-2 lg:px-5 lg:pt-5", children: [
          /* @__PURE__ */ jsxs133(RecruitProfileApplicationHeader, { fragmentRef: recommendation.profile, children: [
            recommendation.rightToWorkStatus && /* @__PURE__ */ jsx197("div", { className: "font-bold", children: /* @__PURE__ */ jsx197(RightToWorkStatus, { status: recommendation.rightToWorkStatus }) }),
            recommendation.profile.rate && /* @__PURE__ */ jsx197("div", { className: "flex w-full justify-start font-bold", children: /* @__PURE__ */ jsx197(RateLabel, { rate: recommendation.profile.rate }) }),
            recommendation.profile.availability && /* @__PURE__ */ jsx197("div", { children: /* @__PURE__ */ jsxs133(Tag12, { children: [
              recommendation.profile.availability.availability.__typename === "CandidateAvailableImmediately" && /* @__PURE__ */ jsx197("div", { children: "Available Immediately" }),
              recommendation.profile.availability.availability.__typename === "CandidateAvailableNotice" && /* @__PURE__ */ jsxs133("div", { children: [
                /* @__PURE__ */ jsxs133("div", { className: "flex items-center", children: [
                  "Available on",
                  " ",
                  recommendation.profile.availability.availability.timeframe
                ] }),
                /* @__PURE__ */ jsxs133("div", { children: [
                  recommendation.profile.availability.availability.notice,
                  " ",
                  "notice"
                ] })
              ] }),
              recommendation.profile.availability.availability.__typename === "CandidateAvailableFromDate" && /* @__PURE__ */ jsxs133("div", { children: [
                /* @__PURE__ */ jsx197("div", { className: "flex items-center", children: "Available From Date" }),
                /* @__PURE__ */ jsx197("div", { children: recommendation.profile.availability.availability.date })
              ] })
            ] }) })
          ] }),
          /* @__PURE__ */ jsx197(
            MatchRelevanceProvider,
            {
              sentences: [],
              matchProfileFragmentRef: recommendation.matchProfile,
              matchRelevanceFragmentRef: recommendation.matchRelevance,
              vacancyFragmentRef: recommendation.vacancy,
              children: /* @__PURE__ */ jsx197(MatchRelevanceScores, {})
            }
          ),
          /* @__PURE__ */ jsx197("div", { children: /* @__PURE__ */ jsx197(
            DeferredResumeDownload,
            {
              profileId: recommendation.profile.recruitProfileId
            }
          ) })
        ] }),
        /* @__PURE__ */ jsx197(Suspense60, { fallback: /* @__PURE__ */ jsx197("div", { className: "px-2 pb-4", children: "Loading..." }), children: /* @__PURE__ */ jsx197("div", { className: "w-full", children: /* @__PURE__ */ jsxs133("div", { className: "flex w-full flex-wrap items-center justify-between border-t bg-gray-100", children: [
          /* @__PURE__ */ jsx197("div", { className: "flex w-full flex-wrap gap-1 p-2", children: tabs2.map((tab) => /* @__PURE__ */ jsx197(
            "div",
            {
              onClick: () => {
                if (selectedTab === tab.name) {
                  setSelectedTab("");
                } else {
                  setSelectedTab(tab.name);
                }
              },
              children: /* @__PURE__ */ jsx197(
                Tag12,
                {
                  color: classNames23(tab.name == selectedTab ? "" : "white"),
                  className: "cursor-pointer hover:bg-gray-200",
                  children: tab.name
                }
              )
            },
            tab.name
          )) }),
          /* @__PURE__ */ jsxs133("div", { className: "w-full", children: [
            selectedTab === "Relevance" && /* @__PURE__ */ jsxs133(
              RecommendationRelevanceProvider,
              {
                vacancyCode: Number(recommendation.vacancy.code),
                recommendationCode: Number(recommendation.code),
                children: [
                  /* @__PURE__ */ jsxs133("div", { className: "m-5 hidden flex-col gap-5 2xl:flex", children: [
                    /* @__PURE__ */ jsx197("div", { className: "rounded-md border bg-white p-5", children: /* @__PURE__ */ jsx197(MatchRelevanceProfileTimeline, {}) }),
                    /* @__PURE__ */ jsx197("div", { className: "rounded-md border bg-white p-5", children: /* @__PURE__ */ jsx197(MatchExperienceSimilarityHighlighter, {}) })
                  ] }),
                  /* @__PURE__ */ jsx197(
                    "div",
                    {
                      className: classNames23(
                        "flex flex-col gap-3 bg-white p-5 2xl:hidden"
                      ),
                      children: /* @__PURE__ */ jsx197(MatchRelevanceProfileTimelineGrid, {})
                    }
                  )
                ]
              }
            ),
            selectedTab === "Work History" && /* @__PURE__ */ jsx197(
              CandidateApplicationProfileComponent,
              {
                fragmentDef: recommendation.profile
              }
            ),
            selectedTab === "Details" && /* @__PURE__ */ jsx197(
              DetailsComponent,
              {
                profileFragmentRef: recommendation.profile,
                candidateFragmentRef: recommendation.candidate
              }
            ),
            selectedTab === "Application History" && /* @__PURE__ */ jsx197("div", { className: "bg-white p-5", children: /* @__PURE__ */ jsx197(
              CandidateApplicationHistory,
              {
                candidateId: recommendation.candidateId
              }
            ) }),
            selectedTab === "Recommendation History" && /* @__PURE__ */ jsx197("div", { className: "bg-white p-5", children: /* @__PURE__ */ jsx197(
              CandidateRecommendationHistory,
              {
                candidateId: recommendation.candidateId
              }
            ) })
          ] })
        ] }) }) })
      ]
    },
    recommendation.code
  );
};

// src/recommendations/recruiter/components/VacancyRecommendationSearch.tsx
import { jsx as jsx198, jsxs as jsxs134 } from "react/jsx-runtime";
var VacancyRecommendationSearch = ({
  queryRef: queryRef3,
  isLoading,
  onSearch
}) => {
  const [filters, setFilters] = useAtom8(recommendationSearchInputAtom);
  const query3 = usePreloadedQuery18(
    vacancyRecommendationSearchQueryDef,
    queryRef3
  );
  const [showFilters, toggleShowFilters] = useToggle24(false);
  const [data] = useRefetchableFragment9(vacancyRecommendationSearchFragmentDef, query3);
  const onDeselect = useCallback116(
    ({
      source,
      value,
      isStandard = false
    }) => {
      const newFilters = filters.filters;
      if (!newFilters) {
        return;
      }
      if (isStandard) {
        let standardFilters = newFilters.standard;
        if (standardFilters) {
          if (source == "skills") {
            standardFilters = standardFilters?.skills?.filter((x4) => {
              return x4.skillId !== Number(value);
            }) || [];
          } else {
            standardFilters = standardFilters[source].filter(
              (x4) => x4 !== value
            );
          }
        }
        const mappedFilters2 = {
          ...filters,
          filters: {
            ...filters.filters,
            standard: {
              ...filters?.filters?.standard,
              [source]: standardFilters
            }
          }
        };
        setFilters(mappedFilters2);
        onSearch(source, mappedFilters2);
        return;
      }
      const updatedFilters = newFilters[source].filter((x4) => x4 !== value);
      const mappedFilters = {
        ...filters,
        filters: {
          ...filters.filters,
          [source]: updatedFilters
        }
      };
      setFilters(mappedFilters);
      onSearch(source, mappedFilters);
    },
    [filters, onSearch, setFilters]
  );
  const onChangedFilters = useCallback116(
    (newFilters) => {
      const newSearch = {
        ...filters,
        filters: {
          ...filters.filters,
          ...newFilters
        }
      };
      onSearch("VacancyRecommendationSearch onChangedFilters", newSearch);
    },
    [filters, onSearch]
  );
  const { result } = data;
  return /* @__PURE__ */ jsxs134(Suspense61, { fallback: "Loading...", children: [
    /* @__PURE__ */ jsxs134("div", { className: "flex flex-col items-center gap-2 p-2", children: [
      /* @__PURE__ */ jsxs134("div", { className: "flex w-full flex-col-reverse items-center justify-between gap-2 border-b lg:flex-row", children: [
        /* @__PURE__ */ jsx198("div", { className: "-mx-2 flex gap-2 self-start lg:self-center", children: /* @__PURE__ */ jsx198(
          MultiFacetContainer3,
          {
            showSearch: false,
            showTitle: false,
            showInline: true,
            fragmentRef: result.aggregations.status,
            onFacetChanged: (status) => onChangedFilters({ status })
          }
        ) }),
        /* @__PURE__ */ jsx198("div", { className: "w-full lg:max-w-[600px]", children: /* @__PURE__ */ jsx198(VacancyRecommendationSearchQuery, { onSearch }) })
      ] }),
      /* @__PURE__ */ jsxs134("div", { className: "flex w-full flex-col justify-between gap-3 lg:flex-row", children: [
        /* @__PURE__ */ jsxs134("div", { className: "flex w-full justify-between", children: [
          /* @__PURE__ */ jsx198("div", { className: "px-2 py-3", children: /* @__PURE__ */ jsx198(
            VacancyRecommendationSearchActiveFilters,
            {
              fragmentRef: result,
              onDeselect
            }
          ) }),
          /* @__PURE__ */ jsx198("div", { children: /* @__PURE__ */ jsx198(
            Button59,
            {
              color: "primary",
              onClick: toggleShowFilters,
              className: "lg:hidden",
              children: /* @__PURE__ */ jsx198(IconText3, { text: "Filters", icon: Icons4.FilterHorizontal })
            }
          ) })
        ] }),
        /* @__PURE__ */ jsxs134("div", { className: "flex gap-3", children: [
          /* @__PURE__ */ jsxs134("div", { className: "flex grow gap-1 lg:items-end", children: [
            /* @__PURE__ */ jsx198("div", { className: "flex grow", children: /* @__PURE__ */ jsx198(VacancyRecommendationSearchSortFields, { onSearch }) }),
            /* @__PURE__ */ jsx198(VacancyRecommendationSearchSortDir, { onSearch })
          ] }),
          /* @__PURE__ */ jsx198("div", { className: "hidden lg:flex", children: /* @__PURE__ */ jsx198(
            VacancyRecommendationSearchPaging,
            {
              fragmentRef: result,
              onSearch
            }
          ) })
        ] })
      ] }),
      /* @__PURE__ */ jsxs134("div", { className: "flex w-full gap-3", children: [
        /* @__PURE__ */ jsx198(
          "div",
          {
            className: classNames24(
              "flex w-full w-full min-w-[400px] lg:max-w-[400px]",
              !showFilters && "hidden lg:flex"
            ),
            children: /* @__PURE__ */ jsx198(
              VacancyRecommendationSearchFilters,
              {
                fragmentRef: result,
                isLoading,
                onSearch
              }
            )
          }
        ),
        /* @__PURE__ */ jsx198(
          "div",
          {
            className: classNames24("w-full lg:flex", showFilters && "hidden"),
            children: /* @__PURE__ */ jsx198(
              VacancyRecommendationSearchList,
              {
                queryRef: queryRef3,
                isLoading
              }
            )
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ jsx198(
      "div",
      {
        className: classNames24(
          "flex self-center pb-10 lg:self-end",
          showFilters && "hidden lg:flex"
        ),
        children: /* @__PURE__ */ jsx198(
          VacancyRecommendationSearchPaging,
          {
            fragmentRef: result,
            onSearch
          }
        )
      }
    )
  ] });
};

// src/recommendations/recruiter/components/VacancyRecommendationSearchContainer.tsx
import { jsx as jsx199 } from "react/jsx-runtime";
var vacancyRecommendationSearchQueryDef = VacancyRecommendationSearchContainerQuery_graphql_default;
var vacancyRecommendationSearchFragmentDef = VacancyRecommendationSearchContainerFragment_graphql_default;
var InitializeSearchAtoms2 = ({ initialValues, children }) => {
  useHydrateAtoms2(initialValues, {
    dangerouslyForceHydrate: true
  });
  return children;
};
var VacancyRecommendationSearchContainerComponent = ({
  vacancyId
}) => {
  const defaultSearchInput = {
    filters: {
      vacancies: [vacancyId]
    },
    fullTextSearch: {
      query: "",
      queryField: {
        standard: "ALL"
      }
    },
    pagination: {
      pageNumber: 1,
      pageSize: 20
    },
    sort: {
      field: {
        standard: "BEST_MATCH"
      },
      order: "DESC"
    }
  };
  const initAtoms = useMemo27(() => {
    return [[recommendationSearchInputAtom, defaultSearchInput]];
  }, []);
  return /* @__PURE__ */ jsx199(Suspense63, { fallback: /* @__PURE__ */ jsx199("div", { children: "Loading Container" }), children: /* @__PURE__ */ jsx199(InitializeSearchAtoms2, { initialValues: initAtoms, children: /* @__PURE__ */ jsx199(VacancyRecommendationSearchLoader, {}) }) });
};
var VacancyRecommendationSearchContainer = memo3(
  VacancyRecommendationSearchContainerComponent
);
var VacancyRecommendationSearchLoader = () => {
  const [input, setInput] = useAtom9(recommendationSearchInputAtom);
  const [queryReference, loadQuery48] = useQueryLoader8(
    vacancyRecommendationSearchQueryDef
  );
  const [isPending, startTransition2] = useTransition10();
  const onSearch = useCallback117(
    (source, input2) => {
      startTransition2(() => {
        setInput(input2);
        console.log(
          `VacancyRecommendationSearchLoader onSearch: Source: ${source}`
        );
        const searchInput = {
          input: input2
        };
        loadQuery48(searchInput, { fetchPolicy: "network-only" });
      });
    },
    [setInput, loadQuery48]
  );
  useEffect28(() => {
    if (!input) {
      return;
    }
    onSearch("VacancyRecommendationSearchLoader Search On Render", input);
  }, [loadQuery48]);
  if (!queryReference) {
    return /* @__PURE__ */ jsx199(EdSkeleton55, {});
  }
  return /* @__PURE__ */ jsx199(Suspense63, { fallback: /* @__PURE__ */ jsx199(Loading3, { label: "Loading Recommendations" }), children: /* @__PURE__ */ jsx199(
    VacancyRecommendationSearch,
    {
      queryRef: queryReference,
      isLoading: isPending,
      onSearch
    }
  ) });
};

// src/vacancies/components/__generated__/VacancyRootRouteQuery.graphql.ts
var node231 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "vacancyCode"
    }
  ], v1 = [
    {
      "fields": [
        {
          "fields": [
            {
              "fields": [
                {
                  "items": [
                    {
                      "kind": "Variable",
                      "name": "byCode.0",
                      "variableName": "vacancyCode"
                    }
                  ],
                  "kind": "ListValue",
                  "name": "byCode"
                }
              ],
              "kind": "ObjectValue",
              "name": "vacancies"
            }
          ],
          "kind": "ObjectValue",
          "name": "filters"
        },
        {
          "kind": "Literal",
          "name": "pagination",
          "value": {
            "pageNumber": 1,
            "pageSize": 10
          }
        },
        {
          "kind": "Literal",
          "name": "sort",
          "value": {
            "field": {
              "standard": "NAME"
            },
            "order": "ASC"
          }
        }
      ],
      "kind": "ObjectValue",
      "name": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  }, v4 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }, v5 = [
    {
      "kind": "Variable",
      "name": "vacancyCode",
      "variableName": "vacancyCode"
    }
  ], v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "key",
    "storageKey": null
  }, v9 = {
    "alias": "vacancy",
    "args": v5,
    "concreteType": "Vacancy",
    "kind": "LinkedField",
    "name": "recruitVacancyByCode",
    "plural": false,
    "selections": [
      v6,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "vacancyId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "employerReference",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "publicDescriptionHtml",
        "storageKey": null
      },
      v7,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "KeyValuePairOfStringAndInt32",
        "kind": "LinkedField",
        "name": "filterStats",
        "plural": true,
        "selections": [
          v8,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      v4
    ],
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "projectName",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "recommendations",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "matches",
    "storageKey": null
  }, v13 = [
    v32,
    v7
  ], v14 = {
    "alias": null,
    "args": null,
    "concreteType": "VacancyCandidateCount",
    "kind": "LinkedField",
    "name": "candidateCounts",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CandidateCount",
        "kind": "LinkedField",
        "name": "created",
        "plural": false,
        "selections": v13,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CandidateCount",
        "kind": "LinkedField",
        "name": "submitted",
        "plural": false,
        "selections": v13,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CandidateCount",
        "kind": "LinkedField",
        "name": "active",
        "plural": false,
        "selections": v13,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CandidateCount",
        "kind": "LinkedField",
        "name": "hired",
        "plural": false,
        "selections": v13,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CandidateCount",
        "kind": "LinkedField",
        "name": "withdrawn",
        "plural": false,
        "selections": v13,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CandidateCount",
        "kind": "LinkedField",
        "name": "unsuccessful",
        "plural": false,
        "selections": v13,
        "storageKey": null
      }
    ],
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "VacancyRootRouteQuery",
      "selections": [
        {
          "alias": "applicationSearch",
          "args": v1,
          "concreteType": "ApplicationSearchResults",
          "kind": "LinkedField",
          "name": "recruitApplicationSearch2",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ApplicationsPieFragment"
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ApplicationSearchAggregations",
              "kind": "LinkedField",
              "name": "aggregations",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "currentState",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationValueModel",
                      "kind": "LinkedField",
                      "name": "values",
                      "plural": true,
                      "selections": [
                        v23,
                        v32
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v4
          ],
          "storageKey": null
        },
        v9,
        {
          "alias": "vacancySearchModel",
          "args": v5,
          "concreteType": "VacancySearchModel",
          "kind": "LinkedField",
          "name": "recruitVacancySearchByCode",
          "plural": false,
          "selections": [
            v6,
            v7,
            v10,
            v11,
            v12,
            v14,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "VacancySearchDashboardChart_vacancy"
            },
            v4
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "VacancyRootRouteQuery",
      "selections": [
        {
          "alias": "applicationSearch",
          "args": v1,
          "concreteType": "ApplicationSearchResults",
          "kind": "LinkedField",
          "name": "recruitApplicationSearch2",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ApplicationSearchAggregations",
              "kind": "LinkedField",
              "name": "aggregations",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "currentState",
                  "plural": false,
                  "selections": [
                    v8,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "title",
                      "storageKey": null
                    },
                    v32,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationValueModel",
                      "kind": "LinkedField",
                      "name": "values",
                      "plural": true,
                      "selections": [
                        v32,
                        v23,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isSelected",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "text",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v4
          ],
          "storageKey": null
        },
        v9,
        {
          "alias": "vacancySearchModel",
          "args": v5,
          "concreteType": "VacancySearchModel",
          "kind": "LinkedField",
          "name": "recruitVacancySearchByCode",
          "plural": false,
          "selections": [
            v6,
            v7,
            v10,
            v11,
            v12,
            v14,
            v23,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "code",
              "storageKey": null
            },
            v4
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "95d2322f6dd3e6610bb2fcd53db5499a",
      "id": null,
      "metadata": {},
      "name": "VacancyRootRouteQuery",
      "operationKind": "query",
      "text": "query VacancyRootRouteQuery(\n  $vacancyCode: Int!\n) {\n  applicationSearch: recruitApplicationSearch2(input: {filters: {vacancies: {byCode: [$vacancyCode]}}, pagination: {pageNumber: 1, pageSize: 10}, sort: {field: {standard: NAME}, order: ASC}}) {\n    ...ApplicationsPieFragment\n    aggregations {\n      currentState {\n        values {\n          name\n          count\n        }\n      }\n    }\n  }\n  vacancy: recruitVacancyByCode(vacancyCode: $vacancyCode) {\n    id\n    vacancyId\n    employerReference\n    publicDescriptionHtml\n    status\n    createdAt\n    filterStats {\n      key\n      value\n    }\n  }\n  vacancySearchModel: recruitVacancySearchByCode(vacancyCode: $vacancyCode) {\n    id\n    status\n    projectName\n    recommendations\n    matches\n    candidateCounts {\n      created {\n        count\n        status\n      }\n      submitted {\n        count\n        status\n      }\n      active {\n        count\n        status\n      }\n      hired {\n        count\n        status\n      }\n      withdrawn {\n        count\n        status\n      }\n      unsuccessful {\n        count\n        status\n      }\n    }\n    ...VacancySearchDashboardChart_vacancy\n  }\n}\n\nfragment ApplicationsPieFragment on ApplicationSearchResults {\n  aggregations {\n    currentState {\n      key\n      title\n      count\n      values {\n        count\n        name\n        isSelected\n        text\n      }\n    }\n  }\n}\n\nfragment VacancySearchDashboardChart_vacancy on VacancySearchModel {\n  id\n  name\n  code\n  status\n  candidateCounts {\n    created {\n      count\n      status\n    }\n    submitted {\n      count\n      status\n    }\n    active {\n      count\n      status\n    }\n    hired {\n      count\n      status\n    }\n    withdrawn {\n      count\n      status\n    }\n    unsuccessful {\n      count\n      status\n    }\n  }\n}\n"
    }
  };
}();
node231.hash = "e62d6e0276bccea2f546e274220af14e";
var VacancyRootRouteQuery_graphql_default = node231;

// src/vacancies/components/__generated__/VacancyRoot_Query.graphql.ts
var node233 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "vacancyId"
    }
  ], v1 = [
    {
      "fields": [
        {
          "kind": "Variable",
          "name": "eq",
          "variableName": "vacancyId"
        }
      ],
      "kind": "ObjectValue",
      "name": "vacancyId"
    }
  ], v23 = [
    {
      "fields": [
        {
          "items": [
            {
              "fields": v1,
              "kind": "ObjectValue",
              "name": "and.0"
            },
            {
              "kind": "Literal",
              "name": "and.1",
              "value": {
                "totalScore": {
                  "gte": 70
                }
              }
            },
            {
              "kind": "Literal",
              "name": "and.2",
              "value": {
                "expiredOn": {
                  "eq": null
                }
              }
            }
          ],
          "kind": "ListValue",
          "name": "and"
        }
      ],
      "kind": "ObjectValue",
      "name": "where"
    }
  ], v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "totalCount",
    "storageKey": null
  }, v4 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 1
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "createdOn": "DESC"
        }
      ]
    },
    {
      "fields": [
        {
          "items": [
            {
              "kind": "Literal",
              "name": "and.0",
              "value": {
                "status": {
                  "eq": "Completed"
                }
              }
            },
            {
              "fields": v1,
              "kind": "ObjectValue",
              "name": "and.1"
            }
          ],
          "kind": "ListValue",
          "name": "and"
        }
      ],
      "kind": "ObjectValue",
      "name": "where"
    }
  ], v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v6 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "talentPool",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vault",
      "storageKey": null
    }
  ], v7 = {
    "alias": null,
    "args": null,
    "concreteType": "CountsBySourceType",
    "kind": "LinkedField",
    "name": "score",
    "plural": false,
    "selections": v6,
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "VacancyRoot_Query",
      "selections": [
        {
          "alias": "goodMatches",
          "args": v23,
          "concreteType": "RecruitVacancyProfileMatchesConnection",
          "kind": "LinkedField",
          "name": "recruitVacancyProfileMatches",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "VacancyMatchesFunnel_matches"
            },
            v32
          ],
          "storageKey": null
        },
        {
          "alias": "run",
          "args": v4,
          "concreteType": "RecruitRecommendationRunsConnection",
          "kind": "LinkedField",
          "name": "recruitRecommendationRuns",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitRecommendationRun",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                v5,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "MatchCounts",
                  "kind": "LinkedField",
                  "name": "matchCounts",
                  "plural": false,
                  "selections": [
                    v7
                  ],
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "VacancyMatchesFunnel_run"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "MatchFunnel_vacancy"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "VacancyRoot_Query",
      "selections": [
        {
          "alias": "goodMatches",
          "args": v23,
          "concreteType": "RecruitVacancyProfileMatchesConnection",
          "kind": "LinkedField",
          "name": "recruitVacancyProfileMatches",
          "plural": false,
          "selections": [
            v32
          ],
          "storageKey": null
        },
        {
          "alias": "run",
          "args": v4,
          "concreteType": "RecruitRecommendationRunsConnection",
          "kind": "LinkedField",
          "name": "recruitRecommendationRuns",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitRecommendationRun",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                v5,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "MatchCounts",
                  "kind": "LinkedField",
                  "name": "matchCounts",
                  "plural": false,
                  "selections": [
                    v7,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "HardFilters",
                      "kind": "LinkedField",
                      "name": "hardFilters",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "sources",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "sourcesLocationsAvailable",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "sourcesLocationsAvailableRate",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "sourcesLocationsAvailableRateEmployment",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CountsBySourceType",
                      "kind": "LinkedField",
                      "name": "similarity",
                      "plural": false,
                      "selections": v6,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CountsBySourceType",
                      "kind": "LinkedField",
                      "name": "relevance",
                      "plural": false,
                      "selections": v6,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CountsBySourceType",
                      "kind": "LinkedField",
                      "name": "skillGroups",
                      "plural": false,
                      "selections": v6,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CountsBySourceType",
                      "kind": "LinkedField",
                      "name": "industryRelevance",
                      "plural": false,
                      "selections": v6,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CountsBySourceType",
                      "kind": "LinkedField",
                      "name": "experienceRelevance",
                      "plural": false,
                      "selections": v6,
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "6d43b5f09f4c9eb83f8e3d9194ffe002",
      "id": null,
      "metadata": {},
      "name": "VacancyRoot_Query",
      "operationKind": "query",
      "text": 'query VacancyRoot_Query(\n  $vacancyId: UUID\n) {\n  goodMatches: recruitVacancyProfileMatches(where: {and: [{vacancyId: {eq: $vacancyId}}, {totalScore: {gte: 70}}, {expiredOn: {eq: null}}]}) {\n    ...VacancyMatchesFunnel_matches\n    totalCount\n  }\n  run: recruitRecommendationRuns(order: [{createdOn: DESC}], first: 1, where: {and: [{status: {eq: "Completed"}}, {vacancyId: {eq: $vacancyId}}]}) {\n    nodes {\n      id\n      matchCounts {\n        score {\n          talentPool\n          vault\n        }\n      }\n      ...VacancyMatchesFunnel_run\n      ...MatchFunnel_vacancy\n    }\n  }\n}\n\nfragment MatchFunnel_vacancy on RecruitRecommendationRun {\n  matchCounts {\n    hardFilters {\n      sources\n      sourcesLocationsAvailable\n      sourcesLocationsAvailableRate\n      sourcesLocationsAvailableRateEmployment\n    }\n    similarity {\n      talentPool\n      vault\n    }\n    relevance {\n      talentPool\n      vault\n    }\n    skillGroups {\n      talentPool\n      vault\n    }\n    industryRelevance {\n      talentPool\n      vault\n    }\n    experienceRelevance {\n      talentPool\n      vault\n    }\n    score {\n      talentPool\n      vault\n    }\n  }\n}\n\nfragment VacancyMatchesFunnel_matches on RecruitVacancyProfileMatchesConnection {\n  totalCount\n}\n\nfragment VacancyMatchesFunnel_run on RecruitRecommendationRun {\n  ...MatchFunnel_vacancy\n}\n'
    }
  };
}();
node233.hash = "5c8a531d02887242c77b831ca25b3932";
var VacancyRoot_Query_graphql_default = node233;

// src/vacancies/components/VacancyRoot.tsx
import { Suspense as Suspense64, useEffect as useEffect30, useMemo as useMemo29 } from "react";
import * as React2 from "react";
import {
  loadQuery as loadQuery17,
  usePreloadedQuery as usePreloadedQuery20,
  useQueryLoader as useQueryLoader10
} from "react-relay";
import { useRouteLoaderData as useRouteLoaderData10 } from "react-router-dom";
import { EdLink as EdLink17, EdSkeleton as EdSkeleton56, Loading as Loading4 } from "shared-ui";
import { formatDate as formatDate5 } from "shared-lib";

// src/vacancies/components/__generated__/VacancyMatchesDashboardQuery.graphql.ts
var node234 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "vacancyId"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "vacancyId",
      "variableName": "vacancyId"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "employmentType",
    "storageKey": null
  }, v4 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "concreteType": "EmployerProfileSource",
    "kind": "LinkedField",
    "name": "employerProfileSources",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProfileSource",
        "kind": "LinkedField",
        "name": "source",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sourceId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sourceName",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "concreteType": "LocationCriteria",
    "kind": "LinkedField",
    "name": "locations",
    "plural": true,
    "selections": [
      v5,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "state",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "countryCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "countryName",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "concreteType": "VacancyRate",
    "kind": "LinkedField",
    "name": "rate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "min",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "max",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "payType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currencyCode",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v9 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "durationType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "durationAmount",
      "storageKey": null
    }
  ], v10 = {
    "alias": null,
    "args": null,
    "concreteType": "VacancyScoringConfig",
    "kind": "LinkedField",
    "name": "scoringConfig",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Duration",
        "kind": "LinkedField",
        "name": "industryExperience",
        "plural": false,
        "selections": v9,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Duration",
        "kind": "LinkedField",
        "name": "industryRecency",
        "plural": false,
        "selections": v9,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Duration",
        "kind": "LinkedField",
        "name": "relevantExperience",
        "plural": false,
        "selections": v9,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Duration",
        "kind": "LinkedField",
        "name": "relevantRecency",
        "plural": false,
        "selections": v9,
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "concreteType": "SkillGroup",
    "kind": "LinkedField",
    "name": "skillGroups",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isRequired",
        "storageKey": null
      },
      v5
    ],
    "storageKey": null
  }, v12 = {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }, v13 = [
    {
      "fields": [
        {
          "kind": "Variable",
          "name": "eq",
          "variableName": "vacancyId"
        }
      ],
      "kind": "ObjectValue",
      "name": "vacancyId"
    }
  ], v14 = {
    "fields": v13,
    "kind": "ObjectValue",
    "name": "and.0"
  }, v15 = [
    v12,
    {
      "fields": [
        {
          "items": [
            v14,
            {
              "kind": "Literal",
              "name": "and.1",
              "value": {
                "isRecommended": {
                  "eq": true
                }
              }
            }
          ],
          "kind": "ListValue",
          "name": "and"
        }
      ],
      "kind": "ObjectValue",
      "name": "where"
    }
  ], v16 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v17 = {
    "kind": "Literal",
    "name": "and.1",
    "value": {
      "totalScore": {
        "gte": 70
      }
    }
  }, v18 = {
    "kind": "Literal",
    "name": "and.2",
    "value": {
      "expiredOn": {
        "eq": null
      }
    }
  }, v19 = [
    {
      "fields": [
        {
          "items": [
            v14,
            v17,
            v18
          ],
          "kind": "ListValue",
          "name": "and"
        }
      ],
      "kind": "ObjectValue",
      "name": "where"
    }
  ], v20 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "totalCount",
    "storageKey": null
  }, v21 = [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "VacancyMatchesFunnel_matches"
    },
    v20
  ], v222 = [
    {
      "fields": [
        {
          "items": [
            v14,
            v17,
            v18,
            {
              "kind": "Literal",
              "name": "and.3",
              "value": {
                "isRecommended": {
                  "eq": false
                }
              }
            }
          ],
          "kind": "ListValue",
          "name": "and"
        }
      ],
      "kind": "ObjectValue",
      "name": "where"
    }
  ], v232 = [
    v12,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "createdOn": "DESC"
        }
      ]
    },
    {
      "fields": [
        {
          "items": [
            {
              "kind": "Literal",
              "name": "and.0",
              "value": {
                "status": {
                  "eq": "Completed"
                }
              }
            },
            {
              "fields": v13,
              "kind": "ObjectValue",
              "name": "and.1"
            }
          ],
          "kind": "ListValue",
          "name": "and"
        }
      ],
      "kind": "ObjectValue",
      "name": "where"
    }
  ], v24 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v25 = [
    v20
  ], v26 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "talentPool",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vault",
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "VacancyMatchesDashboardQuery",
      "selections": [
        {
          "alias": "vacancySearchModel",
          "args": v1,
          "concreteType": "VacancySearchModel",
          "kind": "LinkedField",
          "name": "recruitVacancySearchById",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4
          ],
          "storageKey": null
        },
        {
          "alias": "vacancy",
          "args": v1,
          "concreteType": "Vacancy",
          "kind": "LinkedField",
          "name": "recruitVacancyById",
          "plural": false,
          "selections": [
            v5,
            v6,
            v7,
            v8,
            v10,
            v11
          ],
          "storageKey": null
        },
        {
          "alias": "matches",
          "args": v15,
          "concreteType": "RecruitVacancyProfileMatchesConnection",
          "kind": "LinkedField",
          "name": "recruitVacancyProfileMatches",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitVacancyProfileMatch",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                v16
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": "goodMatches",
          "args": v19,
          "concreteType": "RecruitVacancyProfileMatchesConnection",
          "kind": "LinkedField",
          "name": "recruitVacancyProfileMatches",
          "plural": false,
          "selections": v21,
          "storageKey": null
        },
        {
          "alias": "pendingMatches",
          "args": v222,
          "concreteType": "RecruitVacancyProfileMatchesConnection",
          "kind": "LinkedField",
          "name": "recruitVacancyProfileMatches",
          "plural": false,
          "selections": v21,
          "storageKey": null
        },
        {
          "alias": "completedRuns",
          "args": v232,
          "concreteType": "RecruitRecommendationRunsConnection",
          "kind": "LinkedField",
          "name": "recruitRecommendationRuns",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitRecommendationRun",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "VacancyMatchesFunnel_run"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "MatchFunnel_vacancy"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "VacancyMatchesDashboardQuery",
      "selections": [
        {
          "alias": "vacancySearchModel",
          "args": v1,
          "concreteType": "VacancySearchModel",
          "kind": "LinkedField",
          "name": "recruitVacancySearchById",
          "plural": false,
          "selections": [
            v23,
            v32,
            v24,
            v4
          ],
          "storageKey": null
        },
        {
          "alias": "vacancy",
          "args": v1,
          "concreteType": "Vacancy",
          "kind": "LinkedField",
          "name": "recruitVacancyById",
          "plural": false,
          "selections": [
            v5,
            v6,
            v7,
            v8,
            v10,
            v11,
            v24
          ],
          "storageKey": null
        },
        {
          "alias": "matches",
          "args": v15,
          "concreteType": "RecruitVacancyProfileMatchesConnection",
          "kind": "LinkedField",
          "name": "recruitVacancyProfileMatches",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitVacancyProfileMatch",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                v16,
                v24
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": "goodMatches",
          "args": v19,
          "concreteType": "RecruitVacancyProfileMatchesConnection",
          "kind": "LinkedField",
          "name": "recruitVacancyProfileMatches",
          "plural": false,
          "selections": v25,
          "storageKey": null
        },
        {
          "alias": "pendingMatches",
          "args": v222,
          "concreteType": "RecruitVacancyProfileMatchesConnection",
          "kind": "LinkedField",
          "name": "recruitVacancyProfileMatches",
          "plural": false,
          "selections": v25,
          "storageKey": null
        },
        {
          "alias": "completedRuns",
          "args": v232,
          "concreteType": "RecruitRecommendationRunsConnection",
          "kind": "LinkedField",
          "name": "recruitRecommendationRuns",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitRecommendationRun",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "MatchCounts",
                  "kind": "LinkedField",
                  "name": "matchCounts",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "HardFilters",
                      "kind": "LinkedField",
                      "name": "hardFilters",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "sources",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "sourcesLocationsAvailable",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "sourcesLocationsAvailableRate",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "sourcesLocationsAvailableRateEmployment",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CountsBySourceType",
                      "kind": "LinkedField",
                      "name": "similarity",
                      "plural": false,
                      "selections": v26,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CountsBySourceType",
                      "kind": "LinkedField",
                      "name": "relevance",
                      "plural": false,
                      "selections": v26,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CountsBySourceType",
                      "kind": "LinkedField",
                      "name": "skillGroups",
                      "plural": false,
                      "selections": v26,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CountsBySourceType",
                      "kind": "LinkedField",
                      "name": "industryRelevance",
                      "plural": false,
                      "selections": v26,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CountsBySourceType",
                      "kind": "LinkedField",
                      "name": "experienceRelevance",
                      "plural": false,
                      "selections": v26,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CountsBySourceType",
                      "kind": "LinkedField",
                      "name": "score",
                      "plural": false,
                      "selections": v26,
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                v24
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "a65dd90565e31e2299d2d5ae2c9ab71f",
      "id": null,
      "metadata": {},
      "name": "VacancyMatchesDashboardQuery",
      "operationKind": "query",
      "text": 'query VacancyMatchesDashboardQuery(\n  $vacancyId: UUID!\n) {\n  vacancySearchModel: recruitVacancySearchById(vacancyId: $vacancyId) {\n    status\n    employmentType\n    id\n  }\n  vacancy: recruitVacancyById(vacancyId: $vacancyId) {\n    name\n    employerProfileSources {\n      source {\n        sourceId\n        sourceName\n      }\n    }\n    locations {\n      name\n      state\n      countryCode\n      countryName\n    }\n    rate {\n      min\n      max\n      payType\n      currencyCode\n    }\n    scoringConfig {\n      industryExperience {\n        durationType\n        durationAmount\n      }\n      industryRecency {\n        durationType\n        durationAmount\n      }\n      relevantExperience {\n        durationType\n        durationAmount\n      }\n      relevantRecency {\n        durationType\n        durationAmount\n      }\n    }\n    skillGroups {\n      isRequired\n      name\n    }\n    id\n  }\n  matches: recruitVacancyProfileMatches(where: {and: [{vacancyId: {eq: $vacancyId}}, {isRecommended: {eq: true}}]}, first: 1) {\n    nodes {\n      code\n      id\n    }\n  }\n  goodMatches: recruitVacancyProfileMatches(where: {and: [{vacancyId: {eq: $vacancyId}}, {totalScore: {gte: 70}}, {expiredOn: {eq: null}}]}) {\n    ...VacancyMatchesFunnel_matches\n    totalCount\n  }\n  pendingMatches: recruitVacancyProfileMatches(where: {and: [{vacancyId: {eq: $vacancyId}}, {totalScore: {gte: 70}}, {expiredOn: {eq: null}}, {isRecommended: {eq: false}}]}) {\n    ...VacancyMatchesFunnel_matches\n    totalCount\n  }\n  completedRuns: recruitRecommendationRuns(order: [{createdOn: DESC}], first: 1, where: {and: [{status: {eq: "Completed"}}, {vacancyId: {eq: $vacancyId}}]}) {\n    nodes {\n      ...VacancyMatchesFunnel_run\n      ...MatchFunnel_vacancy\n      id\n    }\n  }\n}\n\nfragment MatchFunnel_vacancy on RecruitRecommendationRun {\n  matchCounts {\n    hardFilters {\n      sources\n      sourcesLocationsAvailable\n      sourcesLocationsAvailableRate\n      sourcesLocationsAvailableRateEmployment\n    }\n    similarity {\n      talentPool\n      vault\n    }\n    relevance {\n      talentPool\n      vault\n    }\n    skillGroups {\n      talentPool\n      vault\n    }\n    industryRelevance {\n      talentPool\n      vault\n    }\n    experienceRelevance {\n      talentPool\n      vault\n    }\n    score {\n      talentPool\n      vault\n    }\n  }\n}\n\nfragment VacancyMatchesFunnel_matches on RecruitVacancyProfileMatchesConnection {\n  totalCount\n}\n\nfragment VacancyMatchesFunnel_run on RecruitRecommendationRun {\n  ...MatchFunnel_vacancy\n}\n'
    }
  };
}();
node234.hash = "7e28ba391ba33db8b73ea2b4cf39a691";
var VacancyMatchesDashboardQuery_graphql_default = node234;

// src/vacancies/components/__generated__/VacancyMatchesDashboardContainer_Query.graphql.ts
var node235 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "vacancyId"
    }
  ], v1 = [
    {
      "fields": [
        {
          "kind": "Variable",
          "name": "eq",
          "variableName": "vacancyId"
        }
      ],
      "kind": "ObjectValue",
      "name": "vacancyId"
    }
  ], v23 = [
    {
      "fields": [
        {
          "items": [
            {
              "fields": v1,
              "kind": "ObjectValue",
              "name": "and.0"
            },
            {
              "kind": "Literal",
              "name": "and.1",
              "value": {
                "totalScore": {
                  "gte": 70
                }
              }
            },
            {
              "kind": "Literal",
              "name": "and.2",
              "value": {
                "expiredOn": {
                  "eq": null
                }
              }
            }
          ],
          "kind": "ListValue",
          "name": "and"
        }
      ],
      "kind": "ObjectValue",
      "name": "where"
    }
  ], v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "totalCount",
    "storageKey": null
  }, v4 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 1
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "createdOn": "DESC"
        }
      ]
    },
    {
      "fields": [
        {
          "items": [
            {
              "kind": "Literal",
              "name": "and.0",
              "value": {
                "status": {
                  "eq": "Completed"
                }
              }
            },
            {
              "fields": v1,
              "kind": "ObjectValue",
              "name": "and.1"
            }
          ],
          "kind": "ListValue",
          "name": "and"
        }
      ],
      "kind": "ObjectValue",
      "name": "where"
    }
  ], v5 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "talentPool",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vault",
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "VacancyMatchesDashboardContainer_Query",
      "selections": [
        {
          "alias": "goodMatches",
          "args": v23,
          "concreteType": "RecruitVacancyProfileMatchesConnection",
          "kind": "LinkedField",
          "name": "recruitVacancyProfileMatches",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "VacancyMatchesFunnel_matches"
            },
            v32
          ],
          "storageKey": null
        },
        {
          "alias": "completedRuns",
          "args": v4,
          "concreteType": "RecruitRecommendationRunsConnection",
          "kind": "LinkedField",
          "name": "recruitRecommendationRuns",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitRecommendationRun",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "VacancyMatchesFunnel_run"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "MatchFunnel_vacancy"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "VacancyMatchesDashboardContainer_Query",
      "selections": [
        {
          "alias": "goodMatches",
          "args": v23,
          "concreteType": "RecruitVacancyProfileMatchesConnection",
          "kind": "LinkedField",
          "name": "recruitVacancyProfileMatches",
          "plural": false,
          "selections": [
            v32
          ],
          "storageKey": null
        },
        {
          "alias": "completedRuns",
          "args": v4,
          "concreteType": "RecruitRecommendationRunsConnection",
          "kind": "LinkedField",
          "name": "recruitRecommendationRuns",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitRecommendationRun",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "MatchCounts",
                  "kind": "LinkedField",
                  "name": "matchCounts",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "HardFilters",
                      "kind": "LinkedField",
                      "name": "hardFilters",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "sources",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "sourcesLocationsAvailable",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "sourcesLocationsAvailableRate",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "sourcesLocationsAvailableRateEmployment",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CountsBySourceType",
                      "kind": "LinkedField",
                      "name": "similarity",
                      "plural": false,
                      "selections": v5,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CountsBySourceType",
                      "kind": "LinkedField",
                      "name": "relevance",
                      "plural": false,
                      "selections": v5,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CountsBySourceType",
                      "kind": "LinkedField",
                      "name": "skillGroups",
                      "plural": false,
                      "selections": v5,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CountsBySourceType",
                      "kind": "LinkedField",
                      "name": "industryRelevance",
                      "plural": false,
                      "selections": v5,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CountsBySourceType",
                      "kind": "LinkedField",
                      "name": "experienceRelevance",
                      "plural": false,
                      "selections": v5,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CountsBySourceType",
                      "kind": "LinkedField",
                      "name": "score",
                      "plural": false,
                      "selections": v5,
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "2cff2782c4f23770d582e3bfc59ea0c5",
      "id": null,
      "metadata": {},
      "name": "VacancyMatchesDashboardContainer_Query",
      "operationKind": "query",
      "text": 'query VacancyMatchesDashboardContainer_Query(\n  $vacancyId: UUID!\n) {\n  goodMatches: recruitVacancyProfileMatches(where: {and: [{vacancyId: {eq: $vacancyId}}, {totalScore: {gte: 70}}, {expiredOn: {eq: null}}]}) {\n    ...VacancyMatchesFunnel_matches\n    totalCount\n  }\n  completedRuns: recruitRecommendationRuns(order: [{createdOn: DESC}], first: 1, where: {and: [{status: {eq: "Completed"}}, {vacancyId: {eq: $vacancyId}}]}) {\n    nodes {\n      ...VacancyMatchesFunnel_run\n      ...MatchFunnel_vacancy\n      id\n    }\n  }\n}\n\nfragment MatchFunnel_vacancy on RecruitRecommendationRun {\n  matchCounts {\n    hardFilters {\n      sources\n      sourcesLocationsAvailable\n      sourcesLocationsAvailableRate\n      sourcesLocationsAvailableRateEmployment\n    }\n    similarity {\n      talentPool\n      vault\n    }\n    relevance {\n      talentPool\n      vault\n    }\n    skillGroups {\n      talentPool\n      vault\n    }\n    industryRelevance {\n      talentPool\n      vault\n    }\n    experienceRelevance {\n      talentPool\n      vault\n    }\n    score {\n      talentPool\n      vault\n    }\n  }\n}\n\nfragment VacancyMatchesFunnel_matches on RecruitVacancyProfileMatchesConnection {\n  totalCount\n}\n\nfragment VacancyMatchesFunnel_run on RecruitRecommendationRun {\n  ...MatchFunnel_vacancy\n}\n'
    }
  };
}();
node235.hash = "7c03f85790c42643a5e5534874595f83";
var VacancyMatchesDashboardContainer_Query_graphql_default = node235;

// src/vacancies/components/VacancyMatchesDashboard.tsx
import { useCallback as useCallback118, useEffect as useEffect29, useMemo as useMemo28, useState as useState67 } from "react";
import {
  useLazyLoadQuery as useLazyLoadQuery29,
  usePreloadedQuery as usePreloadedQuery19,
  useQueryLoader as useQueryLoader9
} from "react-relay";
import { useNavigate as useNavigate20 } from "react-router-dom";
import { createClientMutationId as createClientMutationId57, useSetUserErrorCodes as useSetUserErrorCodes22 } from "shared-lib";
import { Button as Button60, ButtonList as ButtonList19, Spinner as Spinner10, Tag as Tag13, Timeline as Timeline2 } from "shared-ui";

// src/vacancies/components/__generated__/VacancyMatchesFunnel_matches.graphql.ts
var node236 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VacancyMatchesFunnel_matches",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalCount",
      "storageKey": null
    }
  ],
  "type": "RecruitVacancyProfileMatchesConnection",
  "abstractKey": null
};
node236.hash = "0a4eb2ba257effa880ddd064abf5dd6c";
var VacancyMatchesFunnel_matches_graphql_default = node236;

// src/vacancies/components/__generated__/VacancyMatchesFunnel_run.graphql.ts
var node237 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VacancyMatchesFunnel_run",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MatchFunnel_vacancy"
    }
  ],
  "type": "RecruitRecommendationRun",
  "abstractKey": null
};
node237.hash = "7b01189e85aa1ff03dbba154d3441847";
var VacancyMatchesFunnel_run_graphql_default = node237;

// src/vacancies/components/VacancyMatchesFunnel.tsx
import { useFragment as useFragment64 } from "react-relay";

// src/vacancies/components/__generated__/MatchFunnel_vacancy.graphql.ts
var node238 = function() {
  var v0 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "talentPool",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vault",
      "storageKey": null
    }
  ];
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "MatchFunnel_vacancy",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MatchCounts",
        "kind": "LinkedField",
        "name": "matchCounts",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "HardFilters",
            "kind": "LinkedField",
            "name": "hardFilters",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sources",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sourcesLocationsAvailable",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sourcesLocationsAvailableRate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sourcesLocationsAvailableRateEmployment",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CountsBySourceType",
            "kind": "LinkedField",
            "name": "similarity",
            "plural": false,
            "selections": v0,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CountsBySourceType",
            "kind": "LinkedField",
            "name": "relevance",
            "plural": false,
            "selections": v0,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CountsBySourceType",
            "kind": "LinkedField",
            "name": "skillGroups",
            "plural": false,
            "selections": v0,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CountsBySourceType",
            "kind": "LinkedField",
            "name": "industryRelevance",
            "plural": false,
            "selections": v0,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CountsBySourceType",
            "kind": "LinkedField",
            "name": "experienceRelevance",
            "plural": false,
            "selections": v0,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CountsBySourceType",
            "kind": "LinkedField",
            "name": "score",
            "plural": false,
            "selections": v0,
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RecruitRecommendationRun",
    "abstractKey": null
  };
}();
node238.hash = "578099bb5f8556013d8c2acbe82867a2";
var MatchFunnel_vacancy_graphql_default = node238;

// src/vacancies/components/MatchFunnel.tsx
import { useFragment as useFragment63 } from "react-relay";
import { FunnelChart as FunnelChart2 } from "shared-ui";
import { jsx as jsx200 } from "react/jsx-runtime";
var fragmentDef53 = MatchFunnel_vacancy_graphql_default;
var sumValues = (obj) => {
  if (!obj)
    return 0;
  return Object.values(obj).reduce((a4, c4) => {
    return a4 + c4;
  }, 0);
};
var MatchFunnel = ({
  fragmentRef,
  downStreamFunnelCount,
  finalSkillCount,
  colors,
  height = 200
}) => {
  const data = useFragment63(fragmentDef53, fragmentRef);
  let funnelData = [
    {
      label: "Candidates Matching Sources",
      value: data?.matchCounts?.hardFilters?.sources || 0
    },
    {
      label: "Filtered By Locations & Availability",
      value: data?.matchCounts?.hardFilters?.sourcesLocationsAvailable || 0
    },
    {
      label: "Filtered By Rate",
      value: data?.matchCounts?.hardFilters?.sourcesLocationsAvailableRate || 0
    },
    {
      label: "Filtered By Employment Type",
      value: data?.matchCounts?.hardFilters?.sourcesLocationsAvailableRateEmployment || 0
    },
    {
      label: "Filtered By Similar Experience",
      value: sumValues(data?.matchCounts?.similarity)
    }
  ];
  if (data.matchCounts?.relevance?.talentPool) {
    funnelData = [
      ...funnelData,
      {
        label: "Filtered By Relevant Years",
        value: sumValues(data?.matchCounts?.relevance)
      }
    ];
  }
  if (sumValues(data.matchCounts?.skillGroups) > 0) {
    funnelData = [
      ...funnelData,
      {
        label: "Filtered By Skills",
        value: sumValues(data?.matchCounts?.skillGroups)
      }
    ];
  }
  funnelData = [
    ...funnelData,
    {
      label: "Filtered By Low Scoring Candidates",
      value: sumValues(data?.matchCounts?.score)
    },
    {
      label: "Filtered By Candidates to Recommend",
      value: finalSkillCount
    }
  ];
  if (downStreamFunnelCount) {
    funnelData = funnelData.slice(downStreamFunnelCount * -1);
  }
  return /* @__PURE__ */ jsx200(
    FunnelChart2,
    {
      data: funnelData.map((x4) => {
        return {
          ...x4,
          id: x4.label
        };
      }),
      height,
      colors
    }
  );
};

// src/vacancies/components/VacancyMatchesFunnel.tsx
import { jsx as jsx201 } from "react/jsx-runtime";
var matchesFragmentDef = VacancyMatchesFunnel_matches_graphql_default;
var runFragmentDef = VacancyMatchesFunnel_run_graphql_default;
var VacancyMatchesFunnel = ({
  matchesFragmentRef,
  runFragmentRef,
  downStreamFunnelCount,
  colors,
  showTitle = true
}) => {
  const goodMatches = useFragment64(
    matchesFragmentDef,
    matchesFragmentRef
  );
  const run = useFragment64(
    runFragmentDef,
    runFragmentRef
  );
  const totalCount = goodMatches?.totalCount || 0;
  return run ? /* @__PURE__ */ jsx201(
    MatchFunnel,
    {
      fragmentRef: run,
      height: "100%",
      finalSkillCount: totalCount,
      downStreamFunnelCount,
      colors
    }
  ) : /* @__PURE__ */ jsx201("div", {});
};

// src/vacancies/components/VacancyMatchesDashboard.tsx
import { Fragment as Fragment48, jsx as jsx203, jsxs as jsxs135 } from "react/jsx-runtime";
var queryDef31 = VacancyMatchesDashboardQuery_graphql_default;
var useVacancyMatches = (vacancyId) => {
  return useLazyLoadQuery29(queryDef31, {
    vacancyId
  });
};
var VacancyMatchesDashboard = ({ vacancyId, fallback }) => {
  const [queryRef3, loadQuery48] = useQueryLoader9(queryDef31);
  useEffect29(() => {
    loadQuery48({
      vacancyId
    });
  }, []);
  if (!queryRef3) {
    return /* @__PURE__ */ jsx203("div", { children: "loading" });
  }
  return /* @__PURE__ */ jsx203(
    VacancyMatchesDashboardComponent,
    {
      vacancyId,
      fallback,
      queryRef: queryRef3,
      loadQuery: loadQuery48
    }
  );
};
var VacancyDetailItem = ({ label, value }) => /* @__PURE__ */ jsxs135("div", { className: "flex flex-wrap gap-2", children: [
  /* @__PURE__ */ jsxs135("strong", { children: [
    label,
    ": "
  ] }),
  /* @__PURE__ */ jsx203("div", { className: "flex gap-2", children: value })
] });
var SkillGroupTags = ({
  skillGroups,
  isRequired
}) => /* @__PURE__ */ jsxs135("div", { className: "flex flex-wrap gap-2", children: [
  /* @__PURE__ */ jsxs135("strong", { children: [
    isRequired ? "Required" : "Optional",
    " Skill Groups: "
  ] }),
  skillGroups && skillGroups.length > 0 && skillGroups.filter((skillGroup) => skillGroup.isRequired === isRequired).map((skillGroup, index2) => /* @__PURE__ */ jsx203(
    Tag13,
    {
      color: isRequired ? "bg-primary-100" : "bg-gray-100",
      children: skillGroup.name
    },
    index2
  ))
] });
var VacancyDetails2 = ({
  vacancy,
  vacancySearchModel
}) => {
  const navigate = useNavigate20();
  const rateDetails = useMemo28(() => {
    return vacancy?.rate ? /* @__PURE__ */ jsxs135(Fragment48, { children: [
      "\xA3",
      vacancy.rate.max,
      " ",
      vacancy.rate.currencyCode,
      " ",
      vacancy.rate.payType.replace("_", " ").toLowerCase()
    ] }) : null;
  }, [vacancy?.rate]);
  const locations = useMemo28(() => {
    return vacancy?.locations ? vacancy?.locations?.map((location2, index2) => /* @__PURE__ */ jsxs135(Fragment48, { children: [
      location2.name,
      " ",
      location2.state,
      " ",
      location2.countryCode,
      vacancy?.locations?.length - 1 !== index2 && ", "
    ] })) : null;
  }, [vacancy?.locations]);
  const relevantExp = vacancy?.scoringConfig?.relevantExperience;
  const relevantRecency = vacancy?.scoringConfig?.relevantRecency;
  const industryExp = vacancy?.scoringConfig?.industryExperience;
  const industryRecency = vacancy?.scoringConfig?.industryRecency;
  return /* @__PURE__ */ jsxs135("div", { className: "flex w-full flex-col gap-5 p-5", children: [
    /* @__PURE__ */ jsx203("div", { className: "font-bold", children: "Vacancy Requirements:" }),
    /* @__PURE__ */ jsxs135("div", { className: "mb-5 flex w-full flex-col gap-2", children: [
      /* @__PURE__ */ jsx203(VacancyDetailItem, { label: "Vacancy Title", value: vacancy?.name }),
      /* @__PURE__ */ jsx203(VacancyDetailItem, { label: "Location", value: locations }),
      /* @__PURE__ */ jsx203(VacancyDetailItem, { label: "Rates", value: rateDetails }),
      /* @__PURE__ */ jsx203(
        VacancyDetailItem,
        {
          label: "Employment Type",
          value: vacancySearchModel?.employmentType
        }
      ),
      /* @__PURE__ */ jsx203(
        VacancyDetailItem,
        {
          label: "Relevant Experience Required",
          value: `${relevantExp?.durationAmount} ${relevantExp?.durationType.toLowerCase()} within ${relevantRecency?.durationAmount} ${relevantRecency?.durationType.toLowerCase()}`
        }
      ),
      /* @__PURE__ */ jsx203(
        VacancyDetailItem,
        {
          label: "Relevant Industry Experience",
          value: `${industryExp?.durationAmount} ${industryExp?.durationType.toLowerCase()} within ${industryRecency?.durationAmount} ${industryRecency?.durationType.toLowerCase()}`
        }
      ),
      /* @__PURE__ */ jsx203(SkillGroupTags, { skillGroups: vacancy?.skillGroups, isRequired: true }),
      /* @__PURE__ */ jsx203(SkillGroupTags, { skillGroups: vacancy?.skillGroups, isRequired: false })
    ] }),
    /* @__PURE__ */ jsx203(ButtonList19, { justify: "START", children: /* @__PURE__ */ jsx203("div", { children: /* @__PURE__ */ jsx203(
      Button60,
      {
        onClick: () => navigate("../../edit/overview/description"),
        color: "primary",
        children: "Edit Vacancy"
      }
    ) }) })
  ] });
};
var VacancyMatchesDashboardComponent = ({ vacancyId, fallback, queryRef: queryRef3, loadQuery: loadQuery48 }) => {
  const {
    goodMatches,
    pendingMatches,
    completedRuns,
    matches,
    vacancySearchModel,
    vacancy
  } = usePreloadedQuery19(queryDef31, queryRef3);
  const [recommendationsSent, setRecommendationsSent] = useState67(
    matches && matches.nodes?.length != 0 || false
  );
  const [
    hasFinishedSendingRecommendations,
    setHasFinishedSendingRecommendations
  ] = useState67(true);
  const setErrorCode = useSetUserErrorCodes22();
  const [sendMatches, isSendingMatches] = useSendMatches({
    vacancyRelayId: vacancySearchModel?.__id,
    onCompleted: () => {
      setTimeout(() => {
        loadQuery48(
          { vacancyId },
          {
            fetchPolicy: "network-only"
          }
        );
        setHasFinishedSendingRecommendations(true);
      }, 3e3);
    }
  });
  const lastRun = completedRuns?.nodes && completedRuns.nodes.length > 0 ? completedRuns?.nodes[0] : null;
  useEffect29(() => {
    if (lastRun !== null) {
      return;
    }
    const i4 = setInterval(() => {
      loadQuery48(
        { vacancyId },
        {
          fetchPolicy: "network-only"
        }
      );
    }, 3e3);
    return () => clearInterval(i4);
  }, [lastRun, loadQuery48, vacancyId]);
  const allMatchesCount = goodMatches && goodMatches.totalCount || 0;
  const pendingMatchesCount = pendingMatches && pendingMatches.totalCount || 0;
  const sentMatchesCount = allMatchesCount - pendingMatchesCount;
  const onSendMatches = useCallback118(async () => {
    setErrorCode(null);
    setHasFinishedSendingRecommendations(false);
    const input = {
      clientMutationId: createClientMutationId57(),
      vacancyId,
      model: {
        score: 70
      }
    };
    const { result } = await sendMatches({ input });
    if (result.userErrors) {
      setErrorCode(result.userErrors);
    } else {
      setRecommendationsSent(true);
    }
  }, [setErrorCode, vacancyId, sendMatches]);
  return /* @__PURE__ */ jsxs135("div", { className: "flex flex-col gap-5", children: [
    (!recommendationsSent || !hasFinishedSendingRecommendations) && vacancySearchModel?.status !== "FILLED" && /* @__PURE__ */ jsxs135("div", { className: "flex flex-col gap-1 rounded-xl bg-white p-5", children: [
      /* @__PURE__ */ jsx203("p", { className: "text-2xl", children: allMatchesCount == 0 ? `Match Run Complete - No Results Found` : `Match Run Complete - Send Recommendations` }),
      /* @__PURE__ */ jsxs135("p", { children: [
        allMatchesCount != 0 && /* @__PURE__ */ jsxs135("div", { children: [
          "We have found",
          " ",
          /* @__PURE__ */ jsx203("span", { className: "font-bold", children: allMatchesCount }),
          " great Candidates for you. Hit \u2018Send Recommendations\u2019 to invite them to apply to this job."
        ] }),
        allMatchesCount == 0 && /* @__PURE__ */ jsx203("div", { className: "flex flex-col gap-5", children: /* @__PURE__ */ jsx203("p", { className: "[text-wrap: balance]", children: "We couldn't find any Candidates that matched your Vacancy Requirements. Consider raising the Rates, lower the required years of Relevant Experience or remove some of the required Skill groups." }) })
      ] }),
      /* @__PURE__ */ jsx203("div", { className: "mt-4 flex justify-start", children: /* @__PURE__ */ jsxs135("div", { children: [
        allMatchesCount !== 0 && hasFinishedSendingRecommendations && /* @__PURE__ */ jsx203(Button60, { onClick: onSendMatches, color: "primary", children: "Send Recommendations" }),
        !hasFinishedSendingRecommendations && /* @__PURE__ */ jsx203(Spinner10, {})
      ] }) })
    ] }),
    recommendationsSent && hasFinishedSendingRecommendations && /* @__PURE__ */ jsxs135("div", { className: "flex flex-col gap-1 rounded-xl bg-white p-5", children: [
      /* @__PURE__ */ jsx203("p", { className: "text-2xl", children: "Match Run Complete - Recommendations Sent" }),
      /* @__PURE__ */ jsxs135("p", { children: [
        "We have invited",
        " ",
        /* @__PURE__ */ jsx203("span", { className: "font-bold", children: sentMatchesCount == 0 ? allMatchesCount : sentMatchesCount }),
        " ",
        "high scoring Candidates to apply to this role."
      ] })
    ] }),
    /* @__PURE__ */ jsxs135("div", { className: "flex flex-col gap-5 lg:flex-row", children: [
      recommendationsSent && hasFinishedSendingRecommendations && /* @__PURE__ */ jsx203("div", { className: "flex grow flex-col gap-1 rounded-xl bg-white p-5", children: /* @__PURE__ */ jsx203(
        Next,
        {
          matchCount: sentMatchesCount == 0 ? allMatchesCount : sentMatchesCount
        }
      ) }),
      !recommendationsSent && /* @__PURE__ */ jsxs135("div", { className: "flex w-full flex-col gap-5", children: [
        /* @__PURE__ */ jsx203("div", { className: "flex w-full flex-col gap-5 rounded-xl bg-white md:flex-row", children: lastRun && goodMatches ? /* @__PURE__ */ jsxs135("div", { className: "flex w-full flex-col gap-5 p-5", children: [
          /* @__PURE__ */ jsx203("div", { className: "font-bold", children: "Candidate Sources:" }),
          /* @__PURE__ */ jsx203("div", { className: "w-full", children: /* @__PURE__ */ jsx203("div", { className: "flex flex-wrap gap-2", children: vacancy?.employerProfileSources.map((x4) => /* @__PURE__ */ jsx203(Tag13, { children: x4.source.sourceName }, x4.source.sourceId)) }) })
        ] }) : fallback }),
        /* @__PURE__ */ jsx203("div", { className: "flex h-full w-full flex-col gap-5 rounded-xl bg-white md:flex-row", children: lastRun && goodMatches ? /* @__PURE__ */ jsx203(
          VacancyDetails2,
          {
            vacancy,
            vacancySearchModel
          }
        ) : fallback })
      ] }),
      /* @__PURE__ */ jsx203("div", { className: "flex flex-col gap-5 rounded-xl bg-white md:flex-row", children: lastRun && goodMatches ? /* @__PURE__ */ jsxs135("div", { className: "flex flex-col gap-5 p-5", children: [
        /* @__PURE__ */ jsx203("div", { className: "font-bold", children: "Matched and Recommended Candidates" }),
        /* @__PURE__ */ jsx203("div", { className: " h-[550px] w-full lg:w-[550px]", children: /* @__PURE__ */ jsx203(
          VacancyMatchesFunnel,
          {
            matchesFragmentRef: goodMatches,
            runFragmentRef: lastRun,
            downStreamFunnelCount: allMatchesCount && allMatchesCount != 0 ? 5 : null,
            colors: allMatchesCount && allMatchesCount != 0 ? ["#CBE3FB", "#CFF4B8", "#BBEB9D", "#93EE5C", "#7EDA47"] : null
          }
        ) })
      ] }) : fallback })
    ] })
  ] });
};
function VacancyMatchesContainer({
  vacancyId,
  totalMatches
}) {
  const { completedRuns, goodMatches } = useLazyLoadQuery29(
    VacancyMatchesContainer.queries.entry,
    {
      vacancyId
    },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const lastRun = completedRuns?.nodes && completedRuns.nodes.length > 0 ? completedRuns?.nodes[0] : null;
  return /* @__PURE__ */ jsx203(
    VacancyMatchesFunnel,
    {
      showTitle: false,
      matchesFragmentRef: goodMatches,
      runFragmentRef: lastRun,
      downStreamFunnelCount: totalMatches && totalMatches != 0 ? 5 : null,
      colors: totalMatches && totalMatches != 0 ? ["#CBE3FB", "#CFF4B8", "#BBEB9D", "#93EE5C", "#7EDA47"] : null
    }
  );
}
VacancyMatchesContainer.queries = {
  entry: VacancyMatchesDashboardContainer_Query_graphql_default
};
var Next = ({ matchCount }) => {
  return /* @__PURE__ */ jsxs135("div", { children: [
    /* @__PURE__ */ jsxs135("h3", { className: "m-0 text-2xl font-bold leading-7 text-gray-500 sm:truncate sm:text-2xl sm:leading-8", children: [
      " ",
      "What happens next?",
      " "
    ] }),
    /* @__PURE__ */ jsx203(
      Timeline2,
      {
        list: [
          {
            title: "Click 'Send Recommendations'",
            body: `This will confirm the ${matchCount} candidates you identified in the match review process`,
            isCompleted: true
          },
          {
            title: "Recommendations created",
            body: "We create a recommendation for each candidate for tracking the candidate",
            isCompleted: true
          },
          {
            title: "Candidate receives an email",
            body: "Each candidate receives an email, inviting them to apply",
            isCompleted: true
          },
          {
            title: "Candidate applies to vacancy",
            body: "We guide the candidate through their application",
            isActive: true
          },
          {
            title: "Responses are tracked",
            body: "You can track the candidate responses in the Recommendations tab using the Status filter",
            isEmpty: true
          }
        ]
      }
    )
  ] });
};

// src/vacancies/components/__generated__/ApplicationsPieFragment.graphql.ts
var node239 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ApplicationsPieFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ApplicationSearchAggregations",
        "kind": "LinkedField",
        "name": "aggregations",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DefaultAggregationModel",
            "kind": "LinkedField",
            "name": "currentState",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              v0,
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationValueModel",
                "kind": "LinkedField",
                "name": "values",
                "plural": true,
                "selections": [
                  v0,
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isSelected",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "text",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "kind": "ClientExtension",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__id",
            "storageKey": null
          }
        ]
      }
    ],
    "type": "ApplicationSearchResults",
    "abstractKey": null
  };
}();
node239.hash = "1cea19cba72e7b84a723d460449b4c2f";
var ApplicationsPieFragment_graphql_default = node239;

// src/vacancies/components/ApplicationsPie.tsx
import { ResponsivePie as ResponsivePie2 } from "@nivo/pie";
import { useFragment as useFragment65 } from "react-relay";
import { ChartColors as ChartColors2 } from "shared-ui";
import { jsx as jsx204 } from "react/jsx-runtime";
var fragmentDef54 = {
  entry: ApplicationsPieFragment_graphql_default
};
var ApplicationsPie = ({ fragmentRef }) => {
  const data = useFragment65(
    fragmentDef54.entry,
    fragmentRef
  );
  return /* @__PURE__ */ jsx204(
    ResponsivePie2,
    {
      colors: ChartColors2,
      enableArcLinkLabels: false,
      innerRadius: 0.5,
      data: data.aggregations.currentState.values.map((x4) => ({
        id: x4.text,
        label: x4.text,
        value: x4.count
      }))
    }
  );
};

// src/vacancies/components/__generated__/VacancyRecommendationsPieQuery.graphql.ts
var node240 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "id"
    }
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  }, v23 = [
    {
      "alias": null,
      "args": [
        {
          "fields": [
            {
              "fields": [
                {
                  "items": [
                    {
                      "kind": "Variable",
                      "name": "vacancies.0",
                      "variableName": "id"
                    }
                  ],
                  "kind": "ListValue",
                  "name": "vacancies"
                }
              ],
              "kind": "ObjectValue",
              "name": "filters"
            },
            {
              "kind": "Literal",
              "name": "pagination",
              "value": {
                "pageNumber": 1,
                "pageSize": 10
              }
            },
            {
              "kind": "Literal",
              "name": "sort",
              "value": {
                "field": {
                  "standard": "NAME"
                },
                "order": "DESC"
              }
            }
          ],
          "kind": "ObjectValue",
          "name": "input"
        }
      ],
      "concreteType": "RecommendationSearchResults",
      "kind": "LinkedField",
      "name": "recruitRecommendationSearch2",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RecommendationSearchAggregations",
          "kind": "LinkedField",
          "name": "aggregations",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "DefaultAggregationModel",
              "kind": "LinkedField",
              "name": "status",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "key",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                },
                v1,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationValueModel",
                  "kind": "LinkedField",
                  "name": "values",
                  "plural": true,
                  "selections": [
                    v1,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isSelected",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "text",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "VacancyRecommendationsPieQuery",
      "selections": v23,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "VacancyRecommendationsPieQuery",
      "selections": v23
    },
    "params": {
      "cacheID": "51ca3822e7f58d334b96b3d796de553d",
      "id": null,
      "metadata": {},
      "name": "VacancyRecommendationsPieQuery",
      "operationKind": "query",
      "text": "query VacancyRecommendationsPieQuery(\n  $id: UUID!\n) {\n  recruitRecommendationSearch2(input: {filters: {vacancies: [$id]}, pagination: {pageNumber: 1, pageSize: 10}, sort: {field: {standard: NAME}, order: DESC}}) {\n    aggregations {\n      status {\n        key\n        title\n        count\n        values {\n          count\n          name\n          isSelected\n          text\n        }\n      }\n    }\n  }\n}\n"
    }
  };
}();
node240.hash = "ef5076b018613b2e7775d5d3715d1546";
var VacancyRecommendationsPieQuery_graphql_default = node240;

// src/vacancies/components/VacancyRecommendationsPie.tsx
import { useLazyLoadQuery as useLazyLoadQuery30 } from "react-relay";
import { ResponsivePie as ResponsivePie3 } from "@nivo/pie";
import { ChartColors as ChartColors3 } from "shared-ui";
import { jsx as jsx205 } from "react/jsx-runtime";
var queries = {
  entry: VacancyRecommendationsPieQuery_graphql_default
};
var VacancyRecommendationsPie = ({
  vacancyId
}) => {
  const data = useLazyLoadQuery30(queries.entry, {
    id: vacancyId
  });
  return /* @__PURE__ */ jsx205(
    ResponsivePie3,
    {
      colors: ChartColors3,
      enableArcLinkLabels: false,
      innerRadius: 0.5,
      data: data.recruitRecommendationSearch2.aggregations.status.values.filter((x4) => x4.count !== 0).map((x4) => ({
        id: x4.text,
        label: x4.text,
        value: x4.count
      }))
    }
  );
};

// src/vacancies/components/VacancyRoot.tsx
import { Fragment as Fragment49, jsx as jsx206, jsxs as jsxs136 } from "react/jsx-runtime";
var queryDef32 = VacancyRootRouteQuery_graphql_default;
async function loader13(environment, params) {
  const code = params.vacancyCode;
  const vacancyCode = parseInt(code);
  return loadQuery17(
    environment,
    queryDef32,
    {
      vacancyCode
    },
    {
      fetchPolicy: "store-or-network"
    }
  );
}
function useRouteData8(id18) {
  const queryRef3 = useRouteLoaderData10(
    id18
  );
  const data = usePreloadedQuery20(queryDef32, queryRef3);
  return data;
}
var VacancyRoot = ({ id: id18 }) => {
  const data = useRouteData8(id18);
  const { vacancy, vacancySearchModel, applicationSearch } = data;
  const [queryRef3, loadQuery48] = useQueryLoader10(
    queryDefs.recruitRecommendationRuns
  );
  useEffect30(() => {
    loadQuery48({
      vacancyId: vacancy?.vacancyId
    });
  }, [loadQuery48, vacancy?.vacancyId]);
  const applications = useMemo29(() => {
    if (!vacancySearchModel) {
      return 0;
    }
    return Object.values(vacancySearchModel.candidateCounts).reduce(
      (acc, item) => {
        return acc + (item?.count || 0);
      },
      0
    );
  }, [vacancySearchModel]);
  if (!vacancy || !vacancySearchModel || queryRef3 == null || queryRef3 == void 0) {
    return /* @__PURE__ */ jsx206(Fragment49, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx206(
    VacancyRootComponent,
    {
      vacancy,
      vacancySearchModel,
      applications,
      applicationSearch,
      data,
      recommendationRef: queryRef3,
      loadRecommendations: loadQuery48
    }
  );
};
var queryDefs = {
  recruitRecommendationRuns: VacancyRoot_Query_graphql_default
};
var VacancyRootComponent = ({
  vacancy,
  vacancySearchModel,
  applications,
  applicationSearch,
  recommendationRef,
  loadRecommendations
}) => {
  const matches = useVacancyMatches(vacancy.vacancyId);
  const [isPending, startTransition2] = React2.useTransition();
  const runData = usePreloadedQuery20(
    queryDefs.recruitRecommendationRuns,
    recommendationRef
  );
  const run = runData.run?.nodes?.[0];
  const lastRun = matches.completedRuns?.nodes && matches.completedRuns.nodes.length > 0 ? matches.completedRuns?.nodes[0] : null;
  const matchesHaveRun = lastRun !== null;
  useEffect30(() => {
    if (matchesHaveRun) {
      return;
    }
    const i4 = setInterval(() => {
      startTransition2(() => {
        loadRecommendations(
          { vacancyId: vacancy.vacancyId },
          { fetchPolicy: "network-only" }
        );
      });
    }, 3e3);
    return () => clearInterval(i4);
  }, [loadRecommendations, matchesHaveRun, vacancy.vacancyId]);
  if (!vacancy || !vacancySearchModel) {
    return /* @__PURE__ */ jsx206(Fragment49, { children: "Loading..." });
  }
  const totalMatches = (run?.matchCounts?.score?.talentPool || 0) + (run?.matchCounts?.score?.vault || 0);
  const matchesSent = matches.matches && matches?.matches?.nodes?.length != 0 || false;
  if (!matchesHaveRun || isPending) {
    return /* @__PURE__ */ jsx206("div", { className: "flex h-[400px] w-full items-center justify-center", children: /* @__PURE__ */ jsx206(Loading4, { label: `Loading matches...` }) });
  }
  return /* @__PURE__ */ jsx206(Suspense64, { fallback: /* @__PURE__ */ jsx206(EdSkeleton56, {}), children: /* @__PURE__ */ jsxs136("div", { className: "container relative m-5 mx-auto  flex flex-1 flex-col gap-5", children: [
    /* @__PURE__ */ jsx206("div", { className: "right-0 top-40 flex w-full justify-between rounded-xl bg-gray-100 px-5 ", children: /* @__PURE__ */ jsx206("div", { className: "flex flex-wrap md:flex-row md:flex-nowrap md:gap-10", children: [
      {
        title: "Vacancy",
        value: vacancy.status
      },
      {
        title: "Project",
        value: vacancySearchModel.projectName
      },
      {
        title: "Reference",
        value: vacancy.employerReference
      },
      {
        title: "Date Created",
        value: formatDate5(vacancy.createdAt)
      }
    ].map(({ title, value }) => /* @__PURE__ */ jsxs136(
      "div",
      {
        className: "mb-3 flex w-1/2 flex-col md:w-full md:whitespace-nowrap",
        children: [
          /* @__PURE__ */ jsx206("div", { className: "text-sm text-gray-400 md:text-base", children: title }),
          /* @__PURE__ */ jsx206("div", { className: "text-xl text-gray-900 md:text-2xl", children: value })
        ]
      },
      title
    )) }) }),
    /* @__PURE__ */ jsxs136("div", { className: "flex grow flex-col gap-2 px-2", children: [
      /* @__PURE__ */ jsxs136("div", { className: "flex flex-col justify-between gap-2 lg:flex-row", children: [
        /* @__PURE__ */ jsx206(
          EdLink17,
          {
            name: "applications",
            href: "../applications",
            className: "flex w-full grow items-end",
            children: /* @__PURE__ */ jsx206(DashboardCard, { title: "Applications", count: applications, children: /* @__PURE__ */ jsx206("div", { className: " flex items-end justify-end", children: /* @__PURE__ */ jsx206("div", { className: "h-[200px] w-[200px] self-end md:h-[500px] md:w-3/4 md:w-full", children: /* @__PURE__ */ jsx206(ApplicationsPie, { fragmentRef: applicationSearch }) }) }) })
          }
        ),
        /* @__PURE__ */ jsx206(
          EdLink17,
          {
            name: "matches",
            href: totalMatches === 0 ? "../matches?page=info" : "../matches",
            className: "flex w-full grow items-end",
            children: /* @__PURE__ */ jsx206(DashboardCard, { title: "Matches", count: totalMatches, children: /* @__PURE__ */ jsx206("div", { className: "flex items-end justify-end", children: /* @__PURE__ */ jsx206("div", { className: "h-[200px] w-[240px] self-end md:h-[500px] md:w-3/4 md:w-full", children: /* @__PURE__ */ jsx206(VacancyMatchesContainer, { vacancyId: vacancy.vacancyId, totalMatches }) }) }) })
          }
        )
      ] }),
      /* @__PURE__ */ jsxs136("div", { className: "flex flex-col justify-between gap-2 lg:flex-row", children: [
        /* @__PURE__ */ jsx206(
          EdLink17,
          {
            name: "recommendations",
            href: !matchesSent && totalMatches > 0 ? "../matches?page=info" : "../recommendations",
            className: "flex w-full",
            children: /* @__PURE__ */ jsx206(
              DashboardCard,
              {
                title: "Recommendations",
                count: vacancySearchModel.recommendations,
                children: !matchesSent && totalMatches > 0 && vacancy.status !== "FILLED" ? /* @__PURE__ */ jsx206("div", { className: "absolute  bottom-0 left-0 flex w-full w-full items-center justify-center px-5 py-4 font-bold", children: /* @__PURE__ */ jsx206("div", { className: "bg-sulu-500 flex w-full justify-center rounded-lg border p-3 text-black", children: /* @__PURE__ */ jsx206("div", { children: "Send Recommendations" }) }) }) : /* @__PURE__ */ jsx206(Fragment49, { children: /* @__PURE__ */ jsx206("div", { className: " flex items-end justify-end", children: /* @__PURE__ */ jsx206("div", { className: "mt-4 h-[200px] w-[200px] self-end md:h-[500px] md:w-3/4 md:w-full", children: /* @__PURE__ */ jsx206(
                  VacancyRecommendationsPie,
                  {
                    vacancyId: vacancy.vacancyId
                  }
                ) }) }) })
              }
            )
          }
        ),
        /* @__PURE__ */ jsx206("div", { className: "flex w-full ", children: /* @__PURE__ */ jsx206(
          DashboardCard,
          {
            title: "Shortlisted",
            count: applicationSearch.aggregations.currentState.values.filter(
              (x4) => x4.name === "ShortListed"
            )[0]?.count || 0,
            children: /* @__PURE__ */ jsx206("div", { className: " flex items-end justify-end", children: /* @__PURE__ */ jsx206("div", { className: "hidden h-[200px] w-full justify-end pt-10 md:flex md:h-[500px]" }) })
          }
        ) })
      ] })
    ] })
  ] }) });
};
var DashboardCard = ({
  title,
  count,
  children
}) => /* @__PURE__ */ jsx206("div", { className: "flex w-full md:p-3", children: /* @__PURE__ */ jsxs136("div", { className: "relative flex min-h-[200px] w-full flex-col justify-between rounded-2xl border bg-white p-5 text-xl text-gray-500", children: [
  /* @__PURE__ */ jsxs136("div", { className: "absolute left-0 top-0 p-5", children: [
    /* @__PURE__ */ jsx206("div", { children: title }),
    /* @__PURE__ */ jsx206("div", { className: "text-6xl text-black", children: count })
  ] }),
  /* @__PURE__ */ jsx206("div", { className: "w-10/12 self-end", children })
] }) });

// src/vacancies/components/__generated__/VacancyAdsRouteQuery.graphql.ts
var node241 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "vacancyCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "vacancyCode",
      "variableName": "vacancyCode"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v5 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }, v6 = {
    "alias": "vacancy",
    "args": v1,
    "concreteType": "Vacancy",
    "kind": "LinkedField",
    "name": "recruitVacancyByCode",
    "plural": false,
    "selections": [
      v23,
      v32,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "vacancyId",
        "storageKey": null
      },
      v4,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      v5
    ],
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "concreteType": "RecruitTalentPool",
    "kind": "LinkedField",
    "name": "talentPool",
    "plural": false,
    "selections": [
      v23,
      v4,
      v32,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slug",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "customJobBoardBaseUrl",
        "storageKey": null
      }
    ],
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "VacancyAdsRouteQuery",
      "selections": [
        v6,
        {
          "alias": "vacancyTalentPools",
          "args": v1,
          "concreteType": "RecruitTalentPoolVacancyAccess",
          "kind": "LinkedField",
          "name": "recruitTalentPoolsForVacancyByCode",
          "plural": true,
          "selections": [
            v7,
            v5
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "VacancyAdsRouteQuery",
      "selections": [
        v6,
        {
          "alias": "vacancyTalentPools",
          "args": v1,
          "concreteType": "RecruitTalentPoolVacancyAccess",
          "kind": "LinkedField",
          "name": "recruitTalentPoolsForVacancyByCode",
          "plural": true,
          "selections": [
            v7,
            v23,
            v5
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "da929216da4a8c66f6908416170df089",
      "id": null,
      "metadata": {},
      "name": "VacancyAdsRouteQuery",
      "operationKind": "query",
      "text": "query VacancyAdsRouteQuery(\n  $vacancyCode: Int!\n) {\n  vacancy: recruitVacancyByCode(vacancyCode: $vacancyCode) {\n    id\n    code\n    vacancyId\n    name\n    status\n  }\n  vacancyTalentPools: recruitTalentPoolsForVacancyByCode(vacancyCode: $vacancyCode) {\n    talentPool {\n      id\n      name\n      code\n      slug\n      customJobBoardBaseUrl\n    }\n    id\n  }\n}\n"
    }
  };
}();
node241.hash = "66697769aebaccb7cfd9e7aa1e3e16c8";
var VacancyAdsRouteQuery_graphql_default = node241;

// src/vacancies/components/VacancyAds.tsx
import { Suspense as Suspense65 } from "react";
import {
  loadQuery as loadQuery18,
  usePreloadedQuery as usePreloadedQuery21
} from "react-relay";
import { useRouteLoaderData as useRouteLoaderData11 } from "react-router-dom";
import { Card as Card4, EdSkeleton as EdSkeleton57, EdTextLink as EdTextLink2 } from "shared-ui";
import { ElevateEnvironment, getClientEnvironment } from "shared-lib";
import { Fragment as Fragment50, jsx as jsx207, jsxs as jsxs137 } from "react/jsx-runtime";
var queryDef33 = VacancyAdsRouteQuery_graphql_default;
async function loader14(environment, params) {
  const code = params.vacancyCode;
  const vacancyCode = parseInt(code);
  return loadQuery18(environment, queryDef33, {
    vacancyCode
  });
}
function useRouteData9(id18) {
  const queryRef3 = useRouteLoaderData11(
    id18
  );
  const data = usePreloadedQuery21(queryDef33, queryRef3);
  return data;
}
function getUrl(talentPool, vacancyCode) {
  if (talentPool.customJobBoardBaseUrl) {
    return `${talentPool.customJobBoardBaseUrl}/${vacancyCode}`;
  }
  const environment = getClientEnvironment();
  if (environment === ElevateEnvironment.Local) {
    return "";
  }
  if (environment === ElevateEnvironment.LocalHost) {
    return "";
  }
  if (environment === ElevateEnvironment.Develop) {
    return `https://develop.vacancies.elevatedirect.com/talent-pool/${talentPool.slug}/jobads/ad/${vacancyCode}`;
  }
  if (environment === ElevateEnvironment.Staging) {
    return `https://staging.vacancies.elevatedirect.com/talent-pool/${talentPool.slug}/jobads/ad/${vacancyCode}`;
  }
  if (environment === ElevateEnvironment.Production) {
    return `https://vacancies.elevatedirect.com/talent-pool/${talentPool.slug}/jobads/ad/${vacancyCode}`;
  }
  return "";
}
var VacancyAds = ({ routeId: routeId4 }) => {
  const data = useRouteData9(routeId4);
  const { vacancy, vacancyTalentPools } = data;
  if (!vacancy) {
    return /* @__PURE__ */ jsx207(Fragment50, { children: "Loading..." });
  }
  const talentPools = (vacancyTalentPools || []).map((vt) => {
    const link = getUrl(vt.talentPool, vacancy.code);
    return /* @__PURE__ */ jsxs137(
      "div",
      {
        className: "flex items-center justify-between gap-4 p-2 text-xl",
        children: [
          /* @__PURE__ */ jsx207("div", { className: "text-primary-800", children: vt.talentPool.name }),
          /* @__PURE__ */ jsx207("div", { className: "bg-white", children: /* @__PURE__ */ jsx207(
            "a",
            {
              className: "text-primary-800 bg-white underline underline-offset-4",
              target: `${vt.talentPool.name} Talent Pool`,
              href: link,
              children: "View Ad"
            }
          ) })
        ]
      },
      vt.talentPool.id
    );
  });
  return /* @__PURE__ */ jsx207(Suspense65, { fallback: /* @__PURE__ */ jsx207(EdSkeleton57, {}), children: /* @__PURE__ */ jsxs137(Card4, { className: "container m-5 mx-auto border-b bg-white p-4", children: [
    /* @__PURE__ */ jsx207("div", { className: "flex items-center justify-between lg:hidden", children: /* @__PURE__ */ jsx207("div", { className: "flex items-center space-x-2 sm:justify-end", children: /* @__PURE__ */ jsx207(EdTextLink2, { id: "edit-back-link", to: "../", label: "Back" }) }) }),
    /* @__PURE__ */ jsxs137("div", { className: "m-auto lg:w-1/2", children: [
      /* @__PURE__ */ jsx207("div", { className: "flex flex-col p-2", children: /* @__PURE__ */ jsx207("div", { className: "text-primary-900 mb-2 border-b p-2 text-2xl", children: "Vacancy Adverts" }) }),
      /* @__PURE__ */ jsx207("div", { className: "flex flex-col gap-3 divide-y p-2", children: talentPools })
    ] })
  ] }) });
};

// src/vacancies/components/VacancyApplications.tsx
import { Suspense as Suspense66 } from "react";
import { EdSkeleton as EdSkeleton58 } from "shared-ui";
import { jsx as jsx208 } from "react/jsx-runtime";
var VacancyApplicationsRoute = ({ id: id18 }) => {
  console.log("render VacancyApplicationsRoute");
  const data = useVacancyRouteData(id18);
  if (!data.vacancy) {
    return /* @__PURE__ */ jsx208(EdSkeleton58, {});
  }
  return /* @__PURE__ */ jsx208(
    Suspense66,
    {
      fallback: /* @__PURE__ */ jsx208("div", { children: "Loading Applications Search Route" }),
      children: /* @__PURE__ */ jsx208(
        VacancyApplicationSearchContainer,
        {
          fragmentRef: data.vacancy,
          employerId: data.vacancy.employerId
        }
      )
    },
    data.vacancy.code
  );
};

// src/vacancies/components/VacancyConversations.tsx
import { Suspense as Suspense70 } from "react";
import { EdSkeleton as EdSkeleton60 } from "shared-ui";

// src/messaging/applications/components/ApplicationChat.tsx
import { Suspense as Suspense67 } from "react";
import { Button as Button64, EdSkeleton as EdSkeleton59 } from "shared-ui";
import { useToggle as useToggle25 } from "shared-lib";

// src/messaging/applications/components/ApplicationConversationCreateDialog.tsx
import { XCircleIcon as XCircleIcon4 } from "@heroicons/react/24/outline";
import { LogLevel as LogLevel4, useLogger as useLogger23 } from "shared-lib";

// src/messaging/applications/components/ApplicationConversationCreateForm.tsx
import { useCallback as useCallback119, useState as useState68 } from "react";
import { ConnectionHandler as ConnectionHandler4, useRelayEnvironment as useRelayEnvironment3 } from "react-relay";
import { Button as Button61, ButtonList as ButtonList20, Input as Input13 } from "shared-ui";

// src/messaging/applications/mutations/__generated__/AddApplicationConversationMessageMutation.graphql.ts
var node243 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }, v23 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "userErrors",
    "plural": true,
    "selections": [
      v32,
      {
        "kind": "InlineFragment",
        "selections": [
          v4,
          v5
        ],
        "type": "ElevateUserError",
        "abstractKey": "__isElevateUserError"
      }
    ],
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "cursor",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "conversationEventId",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "content",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "sequenceNo",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "eventType",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  }, v14 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdByMessagingUserId",
    "storageKey": null
  }, v15 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateAccountId",
    "storageKey": null
  }, v16 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "AddApplicationConversationMessageMutation",
      "selections": [
        {
          "alias": null,
          "args": v23,
          "concreteType": "ApplicationConversationAddMessagePayload",
          "kind": "LinkedField",
          "name": "applicationConversationAddMessage",
          "plural": false,
          "selections": [
            v6,
            {
              "alias": null,
              "args": null,
              "concreteType": "ConversationEventPayload",
              "kind": "LinkedField",
              "name": "conversationEventPayload",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EdgeOfConversationEvent",
                  "kind": "LinkedField",
                  "name": "event",
                  "plural": false,
                  "selections": [
                    v32,
                    v7,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ConversationEvent",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        v8,
                        v9,
                        v10,
                        v11,
                        v12,
                        v13,
                        v14,
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ConversationUser",
                          "kind": "LinkedField",
                          "name": "createdByMessagingUser",
                          "plural": false,
                          "selections": [
                            v15
                          ],
                          "storageKey": null
                        },
                        v16
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "userErrors",
                  "plural": true,
                  "selections": [
                    v32,
                    v4,
                    v5
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "AddApplicationConversationMessageMutation",
      "selections": [
        {
          "alias": null,
          "args": v23,
          "concreteType": "ApplicationConversationAddMessagePayload",
          "kind": "LinkedField",
          "name": "applicationConversationAddMessage",
          "plural": false,
          "selections": [
            v6,
            {
              "alias": null,
              "args": null,
              "concreteType": "ConversationEventPayload",
              "kind": "LinkedField",
              "name": "conversationEventPayload",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EdgeOfConversationEvent",
                  "kind": "LinkedField",
                  "name": "event",
                  "plural": false,
                  "selections": [
                    v32,
                    v7,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ConversationEvent",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        v8,
                        v9,
                        v10,
                        v11,
                        v12,
                        v13,
                        v14,
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ConversationUser",
                          "kind": "LinkedField",
                          "name": "createdByMessagingUser",
                          "plural": false,
                          "selections": [
                            v15,
                            v8
                          ],
                          "storageKey": null
                        },
                        v16
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "filters": null,
                  "handle": "appendEdge",
                  "key": "",
                  "kind": "LinkedHandle",
                  "name": "event",
                  "handleArgs": [
                    {
                      "kind": "Variable",
                      "name": "connections",
                      "variableName": "connections"
                    }
                  ]
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "userErrors",
                  "plural": true,
                  "selections": [
                    v32,
                    {
                      "kind": "TypeDiscriminator",
                      "abstractKey": "__isElevateUserError"
                    },
                    v4,
                    v5
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "43f0ce673ab07b7bbc4bbca29771d21e",
      "id": null,
      "metadata": {},
      "name": "AddApplicationConversationMessageMutation",
      "operationKind": "mutation",
      "text": "mutation AddApplicationConversationMessageMutation(\n  $input: ApplicationConversationAddMessageInput!\n) {\n  applicationConversationAddMessage(input: $input) {\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        message\n        code\n      }\n    }\n    conversationEventPayload {\n      event {\n        __typename\n        cursor\n        node {\n          id\n          conversationEventId\n          content\n          sequenceNo\n          eventType\n          createdAt\n          createdByMessagingUserId\n          createdByMessagingUser {\n            candidateAccountId\n            id\n          }\n        }\n      }\n      userErrors {\n        __typename\n        __isElevateUserError: __typename\n        message\n        code\n      }\n    }\n  }\n}\n"
    }
  };
}();
node243.hash = "569d30b0056fc9eb5f84688b6151fd0a";
var AddApplicationConversationMessageMutation_graphql_default = node243;

// src/messaging/applications/mutations/AddApplicationConversationMessage.ts
import { commitMutation } from "react-relay";
import { logError } from "shared-lib";
var mutation2 = AddApplicationConversationMessageMutation_graphql_default;
var tempID = 0;
function commit(environment, input, connectionId, onCompleted, onError) {
  return commitMutation(
    environment,
    {
      mutation: mutation2,
      variables: {
        input: {
          ...input,
          clientMutationId: (tempID++).toString()
        },
        connections: [connectionId]
      },
      onCompleted: (data) => {
        onCompleted(data);
      },
      onError: (error) => {
        logError(error);
        if (onError) {
          onError(error);
        }
      }
    }
  );
}
var AddApplicationConversationMessage_default = { commit };

// src/messaging/applications/mutations/__generated__/CreateApplicationConversationMutation.graphql.ts
var node244 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }, v23 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfConversation",
    "kind": "LinkedField",
    "name": "conversation",
    "plural": false,
    "selections": [
      v32,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Conversation",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "conversationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "version",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "data",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "concreteType": "ValidationItem",
    "kind": "LinkedField",
    "name": "validations",
    "plural": true,
    "selections": [
      v32,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      v5
    ],
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "CreateApplicationConversationMutation",
      "selections": [
        {
          "alias": null,
          "args": v23,
          "concreteType": "ApplicationConversationCreatePayload",
          "kind": "LinkedField",
          "name": "applicationConversationCreate",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ConversationPayload",
              "kind": "LinkedField",
              "name": "conversationPayload",
              "plural": false,
              "selections": [
                v4,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "userErrors",
                  "plural": true,
                  "selections": [
                    v5,
                    v6,
                    v7,
                    v8
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "CreateApplicationConversationMutation",
      "selections": [
        {
          "alias": null,
          "args": v23,
          "concreteType": "ApplicationConversationCreatePayload",
          "kind": "LinkedField",
          "name": "applicationConversationCreate",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ConversationPayload",
              "kind": "LinkedField",
              "name": "conversationPayload",
              "plural": false,
              "selections": [
                v4,
                {
                  "alias": null,
                  "args": null,
                  "filters": null,
                  "handle": "prependEdge",
                  "key": "",
                  "kind": "LinkedHandle",
                  "name": "conversation",
                  "handleArgs": [
                    {
                      "kind": "Variable",
                      "name": "connections",
                      "variableName": "connections"
                    }
                  ]
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "userErrors",
                  "plural": true,
                  "selections": [
                    v32,
                    {
                      "kind": "TypeDiscriminator",
                      "abstractKey": "__isElevateUserError"
                    },
                    v5,
                    v6,
                    v7,
                    v8
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "0a711e3f76c8254b8a922fc7da308789",
      "id": null,
      "metadata": {},
      "name": "CreateApplicationConversationMutation",
      "operationKind": "mutation",
      "text": "mutation CreateApplicationConversationMutation(\n  $input: ApplicationConversationCreateInput!\n) {\n  applicationConversationCreate(input: $input) {\n    conversationPayload {\n      conversation {\n        __typename\n        cursor\n        node {\n          id\n          conversationId\n          version\n          title\n        }\n      }\n      userErrors {\n        __typename\n        __isElevateUserError: __typename\n        message\n        code\n        data\n        validations {\n          __typename\n          name\n          message\n        }\n      }\n    }\n  }\n}\n"
    }
  };
}();
node244.hash = "3b0eea1c2d7116f1f9504939dc8f7b20";
var CreateApplicationConversationMutation_graphql_default = node244;

// src/messaging/applications/mutations/CreateApplicationConversation.ts
import { commitMutation as commitMutation2 } from "react-relay";
import { logError as logError2 } from "shared-lib";
var mutation3 = CreateApplicationConversationMutation_graphql_default;
var tempID2 = 0;
function commit2(environment, input, connectionId, onCompleted, onError) {
  return commitMutation2(environment, {
    mutation: mutation3,
    variables: {
      input: {
        ...input,
        clientMutationId: (tempID2++).toString()
      },
      connections: [connectionId]
    },
    onCompleted: (data) => {
      onCompleted(data);
    },
    onError: (error) => {
      logError2(error);
      if (onError) {
        onError(error);
      }
    }
  });
}
var CreateApplicationConversation_default = { commit: commit2 };

// src/messaging/applications/components/ApplicationConversationCreateForm.tsx
import { jsx as jsx209, jsxs as jsxs138 } from "react/jsx-runtime";
var ApplicationConversationCreateForm = ({ applicationId, onDone, onError }) => {
  const environment = useRelayEnvironment3();
  const connectionID = ConnectionHandler4.getConnectionID(
    "root",
    // passed as input to the mutation/subscription
    "ApplicationConversationList_conversations"
  );
  const [title, setTitle] = useState68(null);
  const [isSaving, setSaving] = useState68(false);
  const createConversation = useCallback119(() => {
    if (!title) {
      return;
    }
    setSaving(true);
    CreateApplicationConversation_default.commit(
      environment,
      {
        id: applicationId,
        title,
        isPrivate: false
      },
      connectionID,
      (response) => {
        setSaving(false);
        if (response.applicationConversationCreate.conversationPayload?.conversation.node.conversationId) {
          onDone(
            response.applicationConversationCreate.conversationPayload?.conversation.node.conversationId
          );
        } else if (response.applicationConversationCreate.conversationPayload?.userErrors) {
          onError();
        } else {
          onError();
        }
      }
    );
  }, [applicationId, connectionID, environment, onDone, onError, title]);
  return /* @__PURE__ */ jsxs138("div", { className: "flex flex-col space-y-3 bg-white sm:px-6 sm:py-5", children: [
    /* @__PURE__ */ jsx209("div", { className: "p-3", children: /* @__PURE__ */ jsx209(
      Input13,
      {
        placeholder: " Conversation Title ",
        name: "filter",
        autoFocus: true,
        onValueChange: (filter2) => setTitle(filter2),
        onKeyUp: (e4) => {
          if (e4.code == "Enter" && !e4.shiftKey && title) {
            createConversation();
          }
        }
      },
      "filter"
    ) }),
    /* @__PURE__ */ jsx209("div", { className: "pt-2", children: /* @__PURE__ */ jsx209(ButtonList20, { children: /* @__PURE__ */ jsx209(
      Button61,
      {
        color: "primary",
        disabled: isSaving || !title,
        clicked: createConversation,
        children: "Create Conversation"
      }
    ) }) })
  ] });
};

// src/messaging/applications/components/ApplicationConversationCreateDialog.tsx
import { jsx as jsx211, jsxs as jsxs139 } from "react/jsx-runtime";
var ApplicationConversationForm = ({
  onCreated,
  onCancel,
  applicationId
}) => {
  const [log] = useLogger23();
  return /* @__PURE__ */ jsxs139("div", { className: "flex h-full flex-col overflow-y-scroll bg-white py-6 ", children: [
    /* @__PURE__ */ jsx211("div", { className: "px-4 sm:px-6", children: /* @__PURE__ */ jsxs139("div", { className: "flex items-start justify-between", children: [
      /* @__PURE__ */ jsxs139("div", { className: "text-lg font-medium text-gray-900", children: [
        " ",
        "Create Conversation",
        " "
      ] }),
      /* @__PURE__ */ jsx211("div", { className: "ml-3 flex h-7 items-center", children: /* @__PURE__ */ jsxs139(
        "button",
        {
          type: "button",
          className: "rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2",
          onClick: onCancel,
          children: [
            /* @__PURE__ */ jsx211("span", { className: "sr-only", children: "Close panel" }),
            /* @__PURE__ */ jsx211(XCircleIcon4, { className: "h-6 w-6", "aria-hidden": "true" })
          ]
        }
      ) })
    ] }) }),
    /* @__PURE__ */ jsx211("div", { className: "relative mt-6 flex-1 px-4 sm:px-6", children: /* @__PURE__ */ jsx211(
      ApplicationConversationCreateForm,
      {
        applicationId,
        onDone: (id18) => {
          onCreated(id18);
        },
        onError: () => {
          log("Error Creating Conversation. ", LogLevel4.ERROR);
        }
      }
    ) })
  ] });
};

// src/messaging/applications/components/__generated__/ApplicationConversationsContainerQuery.graphql.ts
var node245 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "applicationId"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "applicationId",
    "variableName": "applicationId"
  }, v23 = [
    v1,
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": {
        "createdAt": "DESC"
      }
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ApplicationConversationsContainerQuery",
      "selections": [
        {
          "args": [
            v1
          ],
          "kind": "FragmentSpread",
          "name": "ApplicationConversationList_conversations"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ApplicationConversationsContainerQuery",
      "selections": [
        {
          "alias": "conversations",
          "args": v23,
          "concreteType": "RecruitConversationsForApplicationConnection",
          "kind": "LinkedField",
          "name": "recruitConversationsForApplication",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitConversationsForApplicationEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Conversation",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "conversationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "referenceId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "referenceEntityTypeName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "version",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "title",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "conversations",
          "args": v23,
          "filters": [],
          "handle": "connection",
          "key": "ApplicationConversationList_conversations",
          "kind": "LinkedHandle",
          "name": "recruitConversationsForApplication"
        }
      ]
    },
    "params": {
      "cacheID": "ad84cec8fcd2da61cd8a881c7bde6c85",
      "id": null,
      "metadata": {},
      "name": "ApplicationConversationsContainerQuery",
      "operationKind": "query",
      "text": "query ApplicationConversationsContainerQuery(\n  $applicationId: UUID!\n) {\n  ...ApplicationConversationList_conversations_2niJhE\n}\n\nfragment ApplicationConversationList_conversations_2niJhE on Query {\n  conversations: recruitConversationsForApplication(applicationId: $applicationId, first: 10, order: {createdAt: DESC}) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        conversationId\n        referenceId\n        referenceEntityTypeName\n        ...ConversationItem_conversation\n        __typename\n      }\n    }\n  }\n}\n\nfragment ConversationItem_conversation on Conversation {\n  id\n  conversationId\n  version\n  title\n}\n"
    }
  };
}();
node245.hash = "4356b6904ceb25ff80fc66462c8cb7d6";
var ApplicationConversationsContainerQuery_graphql_default = node245;

// src/messaging/applications/components/ApplicationConversationsContainer.tsx
import { useLazyLoadQuery as useLazyLoadQuery31 } from "react-relay";

// src/messaging/applications/components/__generated__/ApplicationConversationListPaginationQuery.graphql.ts
var node246 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "applicationId"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": {
        "createdAt": "DESC"
      },
      "kind": "LocalArgument",
      "name": "order"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "after",
      "variableName": "after"
    },
    {
      "kind": "Variable",
      "name": "applicationId",
      "variableName": "applicationId"
    },
    {
      "kind": "Variable",
      "name": "first",
      "variableName": "first"
    },
    {
      "kind": "Variable",
      "name": "order",
      "variableName": "order"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ApplicationConversationListPaginationQuery",
      "selections": [
        {
          "args": v1,
          "kind": "FragmentSpread",
          "name": "ApplicationConversationList_conversations"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ApplicationConversationListPaginationQuery",
      "selections": [
        {
          "alias": "conversations",
          "args": v1,
          "concreteType": "RecruitConversationsForApplicationConnection",
          "kind": "LinkedField",
          "name": "recruitConversationsForApplication",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitConversationsForApplicationEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Conversation",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "conversationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "referenceId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "referenceEntityTypeName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "version",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "title",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "conversations",
          "args": v1,
          "filters": [],
          "handle": "connection",
          "key": "ApplicationConversationList_conversations",
          "kind": "LinkedHandle",
          "name": "recruitConversationsForApplication"
        }
      ]
    },
    "params": {
      "cacheID": "cbaffb04e26d8841753b84fec0efa3e2",
      "id": null,
      "metadata": {},
      "name": "ApplicationConversationListPaginationQuery",
      "operationKind": "query",
      "text": "query ApplicationConversationListPaginationQuery(\n  $after: String\n  $applicationId: UUID!\n  $first: Int = 10\n  $order: [ConversationSort!] = {createdAt: DESC}\n) {\n  ...ApplicationConversationList_conversations_47MFKP\n}\n\nfragment ApplicationConversationList_conversations_47MFKP on Query {\n  conversations: recruitConversationsForApplication(applicationId: $applicationId, first: $first, after: $after, order: $order) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        conversationId\n        referenceId\n        referenceEntityTypeName\n        ...ConversationItem_conversation\n        __typename\n      }\n    }\n  }\n}\n\nfragment ConversationItem_conversation on Conversation {\n  id\n  conversationId\n  version\n  title\n}\n"
    }
  };
}();
node246.hash = "bd5bd75194d20448ad9b2806799c51e9";
var ApplicationConversationListPaginationQuery_graphql_default = node246;

// src/messaging/applications/components/__generated__/ApplicationConversationList_conversations.graphql.ts
var node247 = function() {
  var v0 = [
    "conversations"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "applicationId"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "defaultValue": {
          "createdAt": "DESC"
        },
        "kind": "LocalArgument",
        "name": "order"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": ApplicationConversationListPaginationQuery_graphql_default
      }
    },
    "name": "ApplicationConversationList_conversations",
    "selections": [
      {
        "alias": "conversations",
        "args": null,
        "concreteType": "RecruitConversationsForApplicationConnection",
        "kind": "LinkedField",
        "name": "__ApplicationConversationList_conversations_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitConversationsForApplicationEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Conversation",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "conversationId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "referenceId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "referenceEntityTypeName",
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ConversationItem_conversation"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node247.hash = "bd5bd75194d20448ad9b2806799c51e9";
var ApplicationConversationList_conversations_graphql_default = node247;

// src/messaging/applications/components/ApplicationConversationList.tsx
import { useCallback as useCallback120 } from "react";
import { usePaginationFragment as usePaginationFragment11 } from "react-relay";
import { Button as Button63 } from "shared-ui";

// src/messaging/applications/components/__generated__/ConversationItem_conversation.graphql.ts
var node248 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ConversationItem_conversation",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "conversationId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "type": "Conversation",
  "abstractKey": null
};
node248.hash = "aed7046127c364c57d803a12e3c97192";
var ConversationItem_conversation_graphql_default = node248;

// src/messaging/applications/components/ConversationItem.tsx
import { useFragment as useFragment66 } from "react-relay";
import { jsx as jsx213, jsxs as jsxs140 } from "react/jsx-runtime";
var fragment9 = ConversationItem_conversation_graphql_default;
var ConversationItem = (props) => {
  const data = useFragment66(fragment9, props.application);
  return /* @__PURE__ */ jsxs140(
    "li",
    {
      className: "focus-within:ring-info-600 relative border bg-white px-6 py-5 focus-within:ring-2 focus-within:ring-inset hover:bg-gray-50",
      children: [
        /* @__PURE__ */ jsx213("div", { className: "flex justify-between space-x-3", children: /* @__PURE__ */ jsx213("div", { className: "min-w-0 flex-1", children: /* @__PURE__ */ jsxs140("a", { onClick: props.selected, className: "block focus:outline-none", children: [
          /* @__PURE__ */ jsx213("span", { className: "absolute inset-0", "aria-hidden": "true" }),
          /* @__PURE__ */ jsx213("p", { className: "truncate text-sm font-medium text-gray-900", children: data.title })
        ] }) }) }),
        /* @__PURE__ */ jsx213("div", { className: "mt-1", children: /* @__PURE__ */ jsx213("p", { className: "line-clamp-2 text-sm text-gray-600", children: data.title }) })
      ]
    },
    data.conversationId
  );
};

// src/messaging/applications/components/ApplicationConversationList.tsx
import { Fragment as Fragment51, jsx as jsx214, jsxs as jsxs141 } from "react/jsx-runtime";
var fragment10 = ApplicationConversationList_conversations_graphql_default;
var ApplicationConversationList = ({
  conversationsKey,
  onSelected
}) => {
  function select(conversation) {
    if (!conversation) {
      return;
    }
    onSelected(conversation.conversationId);
  }
  const { data, loadNext, hasNext, isLoadingNext } = usePaginationFragment11(fragment10, conversationsKey);
  const { conversations } = data;
  const rows = conversations?.edges?.map((conversation) => {
    if (!conversation || !conversation.node)
      throw new Error("assertion failed");
    return /* @__PURE__ */ jsx214(
      ConversationItem,
      {
        application: conversation.node,
        selected: () => select(conversation.node)
      },
      conversation.node.conversationId
    );
  });
  const loadMore = useCallback120(() => {
    if (isLoadingNext) {
      return;
    }
    loadNext(2);
  }, [isLoadingNext, loadNext]);
  return /* @__PURE__ */ jsx214(Fragment51, { children: /* @__PURE__ */ jsxs141("nav", { "aria-label": "Message list", className: "min-h-0 flex-1 overflow-y-auto", children: [
    /* @__PURE__ */ jsx214("ul", { role: "list", className: "divide-y divide-gray-200 border-b", children: rows }),
    hasNext && /* @__PURE__ */ jsx214(Button63, { color: "primary", clicked: loadMore, children: "Load More" })
  ] }) });
};

// src/messaging/applications/components/ApplicationConversationsContainer.tsx
import { jsx as jsx215 } from "react/jsx-runtime";
var graphqlQuery6 = ApplicationConversationsContainerQuery_graphql_default;
var ApplicationConversationsContainer = ({ applicationId, onSelect }) => {
  const data = useLazyLoadQuery31(
    graphqlQuery6,
    {
      applicationId
    },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsx215(
    ApplicationConversationList,
    {
      conversationsKey: data,
      onSelected: (id18) => {
        onSelect(id18);
      }
    }
  );
};

// src/messaging/applications/components/ApplicationChat.tsx
import { jsx as jsx216, jsxs as jsxs143 } from "react/jsx-runtime";
var ApplicationChatElement = ({
  toggleCreatingConversation,
  applicationId,
  isCreatingConversation,
  onSelect,
  onCreated
}) => /* @__PURE__ */ jsxs143("div", { className: "flex flex-grow flex-col", children: [
  /* @__PURE__ */ jsx216("div", { className: "my-3 ", children: isCreatingConversation ? /* @__PURE__ */ jsx216("div", { className: "flex flex-grow flex-col bg-white shadow", children: /* @__PURE__ */ jsx216(
    ApplicationConversationForm,
    {
      applicationId,
      onCancel: toggleCreatingConversation,
      onCreated: (x4) => {
        onCreated(x4);
        toggleCreatingConversation();
      }
    }
  ) }) : /* @__PURE__ */ jsx216("div", { className: "flex justify-center sm:justify-start", children: /* @__PURE__ */ jsx216(Button64, { color: "primary", clicked: toggleCreatingConversation, children: "Start a Chat" }) }) }),
  !isCreatingConversation && /* @__PURE__ */ jsx216("div", { className: "items-top flex justify-between", children: /* @__PURE__ */ jsx216("div", { className: "flex-1", children: /* @__PURE__ */ jsx216(Suspense67, { fallback: /* @__PURE__ */ jsx216(EdSkeleton59, {}), children: /* @__PURE__ */ jsx216(
    ApplicationConversationsContainer,
    {
      applicationId,
      onSelect
    }
  ) }) }) })
] });
var ApplicationChat = ({ applicationId, onSelect }) => {
  const [isCreatingConversation, toggleCreatingConversation] = useToggle25(false);
  return /* @__PURE__ */ jsx216(
    ApplicationChatElement,
    {
      onSelect,
      onCreated: onSelect,
      toggleCreatingConversation,
      applicationId,
      isCreatingConversation
    }
  );
};

// src/messaging/applications/components/ApplicationConversationAddMessageForm.tsx
import { useCallback as useCallback121, useState as useState69 } from "react";
import { ConnectionHandler as ConnectionHandler5, useRelayEnvironment as useRelayEnvironment4 } from "react-relay";
import { PaperAirplaneIcon } from "@heroicons/react/24/outline";
import { TextArea as TextArea3, classNames as classNames25 } from "shared-ui";
import { jsx as jsx217, jsxs as jsxs144 } from "react/jsx-runtime";
var ApplicationConversationAddMessageForm = ({ conversationId, onDone, onError }) => {
  const environment = useRelayEnvironment4();
  const connectionID = ConnectionHandler5.getConnectionID(
    "root",
    // passed as input to the mutation/subscription
    "ConversationMessagesList_events"
  );
  const [rows, setRows] = useState69(1);
  const [content, setContent] = useState69(null);
  const onCreate = useCallback121(create, [
    content,
    environment,
    conversationId,
    connectionID,
    onError,
    onDone,
    setRows
  ]);
  function create() {
    if (!content) {
      return;
    }
    setRows(1);
    AddApplicationConversationMessage_default.commit(
      environment,
      {
        conversationId,
        content
      },
      connectionID,
      (response) => {
        console.log("AddApplicationConversationMessage response");
        if (response.applicationConversationAddMessage) {
          if (response.applicationConversationAddMessage.userErrors) {
            onError(response.applicationConversationAddMessage.userErrors);
          } else if (response?.applicationConversationAddMessage?.conversationEventPayload) {
            onDone(
              response.applicationConversationAddMessage.conversationEventPayload.event.node
            );
          }
        }
      }
    );
  }
  return /* @__PURE__ */ jsx217("div", { className: "flex flex-col bg-white ", children: /* @__PURE__ */ jsx217("div", { className: "p-4", children: /* @__PURE__ */ jsxs144("div", { className: "flex h-full flex-grow items-center gap-4", children: [
    /* @__PURE__ */ jsx217(
      TextArea3,
      {
        rows,
        setRows,
        expandable: true,
        value: content || "",
        className: "focus:border-info-500 focus:ring-info-500 block w-full resize-none overflow-hidden overflow-hidden rounded-2xl bg-gray-200 pl-3 text-black sm:text-sm",
        onValueChange: (text) => setContent(text),
        onKeyUp: (e4) => {
          if (e4.code == "Enter" && !e4.shiftKey) {
            onCreate();
            setContent("");
          }
        }
      }
    ),
    /* @__PURE__ */ jsx217(
      "div",
      {
        className: classNames25(
          content ? "text-primary-500 cursor-pointer" : "text-gray-400"
        ),
        onClick: () => {
          onCreate();
          setContent("");
        },
        children: /* @__PURE__ */ jsx217(PaperAirplaneIcon, { className: "h-6 w-6" })
      }
    )
  ] }) }) });
};

// src/messaging/applications/components/__generated__/ApplicationConversationContainerQuery.graphql.ts
var node249 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "id"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "id"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "conversationId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ApplicationConversationContainerQuery",
      "selections": [
        {
          "alias": "conversation",
          "args": v1,
          "concreteType": "Conversation",
          "kind": "LinkedField",
          "name": "recruitConversationById",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ConversationDetails_conversation"
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ApplicationConversationContainerQuery",
      "selections": [
        {
          "alias": "conversation",
          "args": v1,
          "concreteType": "Conversation",
          "kind": "LinkedField",
          "name": "recruitConversationById",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "version",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ConversationUser",
              "kind": "LinkedField",
              "name": "users",
              "plural": true,
              "selections": [
                v23,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "conversationUserId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "firstName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastName",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "e0fd346c4a4078c046c887b4a9b06181",
      "id": null,
      "metadata": {},
      "name": "ApplicationConversationContainerQuery",
      "operationKind": "query",
      "text": "query ApplicationConversationContainerQuery(\n  $id: UUID!\n) {\n  conversation: recruitConversationById(id: $id) {\n    id\n    conversationId\n    title\n    ...ConversationDetails_conversation\n  }\n}\n\nfragment ConversationDetails_conversation on Conversation {\n  id\n  conversationId\n  version\n  title\n  users {\n    id\n    conversationUserId\n    firstName\n    lastName\n  }\n}\n"
    }
  };
}();
node249.hash = "c006617c78211200cea361b565e2a623";
var ApplicationConversationContainerQuery_graphql_default = node249;

// src/messaging/applications/components/ApplicationConversationContainer.tsx
import { useParams as useParams8 } from "react-router-dom";
import { useLazyLoadQuery as useLazyLoadQuery34 } from "react-relay";
import { Breadcrumbs as Breadcrumbs4, MobileHeader as MobileHeader3 } from "shared-ui";

// src/messaging/applications/components/__generated__/ConversationDetails_conversation.graphql.ts
var node250 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ConversationDetails_conversation",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "conversationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "version",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ConversationUser",
        "kind": "LinkedField",
        "name": "users",
        "plural": true,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "conversationUserId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Conversation",
    "abstractKey": null
  };
}();
node250.hash = "3acd2b7a5440794addd8208cde0973c3";
var ConversationDetails_conversation_graphql_default = node250;

// src/messaging/applications/components/ConversationDetails.tsx
import { Suspense as Suspense69 } from "react";
import { useFragment as useFragment67 } from "react-relay";
import {
  ArrowLeftCircleIcon,
  ArrowRightCircleIcon
} from "@heroicons/react/24/solid";
import { useToggle as useToggle26 } from "shared-lib";

// src/messaging/applications/components/__generated__/ConversationMessagesQuery.graphql.ts
var node251 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "sourceId"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "last",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": {
        "createdAt": "ASC"
      }
    },
    {
      "kind": "Variable",
      "name": "sourceId",
      "variableName": "sourceId"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ConversationMessagesQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ConversationMessagesList_events"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ConversationMessagesQuery",
      "selections": [
        {
          "alias": "events",
          "args": v1,
          "concreteType": "RecruitConversationEventByConversationIdConnection",
          "kind": "LinkedField",
          "name": "recruitConversationEventByConversationId",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitConversationEventByConversationIdEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ConversationEvent",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "content",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sequenceNo",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "eventType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdByMessagingUserId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ConversationUser",
                      "kind": "LinkedField",
                      "name": "createdByMessagingUser",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "firstName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "candidateAccountId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "employerUserId",
                          "storageKey": null
                        },
                        v23
                      ],
                      "storageKey": null
                    },
                    v23,
                    v32,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v32
          ],
          "storageKey": null
        },
        {
          "alias": "events",
          "args": v1,
          "filters": [],
          "handle": "connection",
          "key": "ConversationMessagesList_events",
          "kind": "LinkedHandle",
          "name": "recruitConversationEventByConversationId"
        }
      ]
    },
    "params": {
      "cacheID": "524ff041aa0aeda01d152799d34f5921",
      "id": null,
      "metadata": {},
      "name": "ConversationMessagesQuery",
      "operationKind": "query",
      "text": "query ConversationMessagesQuery(\n  $sourceId: UUID!\n) {\n  ...ConversationMessagesList_events\n}\n\nfragment ConversationMessagesList_events on Query {\n  events: recruitConversationEventByConversationId(sourceId: $sourceId, last: 10, order: {createdAt: ASC}) {\n    totalCount\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        content\n        sequenceNo\n        eventType\n        createdAt\n        createdByMessagingUserId\n        createdByMessagingUser {\n          firstName\n          candidateAccountId\n          employerUserId\n          id\n        }\n        id\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node251.hash = "3ff53b393dd35fc185b2ad14ad83c272";
var ConversationMessagesQuery_graphql_default = node251;

// src/messaging/applications/components/ConversationMessages.tsx
import { useLazyLoadQuery as useLazyLoadQuery33 } from "react-relay";

// src/messaging/applications/components/__generated__/ConversationMessagesListPaginationQuery.graphql.ts
var node253 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "before"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "last"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "sourceId"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "before",
    "variableName": "before"
  }, v23 = {
    "kind": "Variable",
    "name": "last",
    "variableName": "last"
  }, v32 = [
    v1,
    v23,
    {
      "kind": "Literal",
      "name": "order",
      "value": {
        "createdAt": "ASC"
      }
    },
    {
      "kind": "Variable",
      "name": "sourceId",
      "variableName": "sourceId"
    }
  ], v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v5 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ConversationMessagesListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v23
          ],
          "kind": "FragmentSpread",
          "name": "ConversationMessagesList_events"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ConversationMessagesListPaginationQuery",
      "selections": [
        {
          "alias": "events",
          "args": v32,
          "concreteType": "RecruitConversationEventByConversationIdConnection",
          "kind": "LinkedField",
          "name": "recruitConversationEventByConversationId",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitConversationEventByConversationIdEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ConversationEvent",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "content",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sequenceNo",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "eventType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdByMessagingUserId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ConversationUser",
                      "kind": "LinkedField",
                      "name": "createdByMessagingUser",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "firstName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "candidateAccountId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "employerUserId",
                          "storageKey": null
                        },
                        v4
                      ],
                      "storageKey": null
                    },
                    v4,
                    v5,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v5
          ],
          "storageKey": null
        },
        {
          "alias": "events",
          "args": v32,
          "filters": [],
          "handle": "connection",
          "key": "ConversationMessagesList_events",
          "kind": "LinkedHandle",
          "name": "recruitConversationEventByConversationId"
        }
      ]
    },
    "params": {
      "cacheID": "f37452e47c7d0bee882663134e9bcde2",
      "id": null,
      "metadata": {},
      "name": "ConversationMessagesListPaginationQuery",
      "operationKind": "query",
      "text": "query ConversationMessagesListPaginationQuery(\n  $before: String\n  $last: Int = 10\n  $sourceId: UUID!\n) {\n  ...ConversationMessagesList_events_SKUZh\n}\n\nfragment ConversationMessagesList_events_SKUZh on Query {\n  events: recruitConversationEventByConversationId(sourceId: $sourceId, last: $last, before: $before, order: {createdAt: ASC}) {\n    totalCount\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        content\n        sequenceNo\n        eventType\n        createdAt\n        createdByMessagingUserId\n        createdByMessagingUser {\n          firstName\n          candidateAccountId\n          employerUserId\n          id\n        }\n        id\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node253.hash = "3305af29b798b190d8c5178ddd2e726c";
var ConversationMessagesListPaginationQuery_graphql_default = node253;

// src/messaging/applications/components/__generated__/ConversationMessagesList_events.graphql.ts
var node254 = function() {
  var v0 = [
    "events"
  ], v1 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "last"
      },
      {
        "kind": "RootArgument",
        "name": "sourceId"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "last",
          "cursor": "before",
          "direction": "backward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": null,
          "backward": {
            "count": "last",
            "cursor": "before"
          },
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": ConversationMessagesListPaginationQuery_graphql_default
      }
    },
    "name": "ConversationMessagesList_events",
    "selections": [
      {
        "alias": "events",
        "args": null,
        "concreteType": "RecruitConversationEventByConversationIdConnection",
        "kind": "LinkedField",
        "name": "__ConversationMessagesList_events_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitConversationEventByConversationIdEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ConversationEvent",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "content",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sequenceNo",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "eventType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdByMessagingUserId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ConversationUser",
                    "kind": "LinkedField",
                    "name": "createdByMessagingUser",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "firstName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "candidateAccountId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "employerUserId",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  v1,
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          v1
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node254.hash = "3305af29b798b190d8c5178ddd2e726c";
var ConversationMessagesList_events_graphql_default = node254;

// src/messaging/applications/components/ConversationMessagesList.tsx
import {
  Suspense as Suspense68,
  useCallback as useCallback123,
  useEffect as useEffect31,
  useRef as useRef5
} from "react";
import { usePaginationFragment as usePaginationFragment12 } from "react-relay";
import { formatDateTime } from "shared-lib";
import { useUserSessionContext as useUserSessionContext5 } from "app-core";
import { classNames as classNames26 } from "shared-ui";
import { jsx as jsx218, jsxs as jsxs145 } from "react/jsx-runtime";
var fragment11 = ConversationMessagesList_events_graphql_default;
var ConversationMessagesList = ({ conversationMessagesKey, conversationId }) => {
  const session = useUserSessionContext5();
  const { data, loadNext, hasNext, isLoadingNext } = usePaginationFragment12(fragment11, conversationMessagesKey);
  const events = (data.events?.edges || []).map((e4) => e4.node);
  const messages = events.map((event) => {
    const currentUserCreatedMessage = event.createdByMessagingUser?.candidateAccountId === session.userId || event.createdByMessagingUser?.employerUserId === session.userId;
    return /* @__PURE__ */ jsx218(
      "li",
      {
        className: classNames26(
          "flex w-full",
          currentUserCreatedMessage ? "justify-end" : "justify-start"
        ),
        children: /* @__PURE__ */ jsxs145(
          "div",
          {
            className: "flex min-w-[60%] max-w-[90%] flex-col gap-2 rounded-xl bg-white px-6 py-8 shadow md:min-w-[35%] md:max-w-[80%] lg:min-w-[30%] lg:max-w-[70%] xl:min-w-[25%] xl:max-w-[60%] 2xl:min-w-[20%] 2xl:max-w-[50%]",
            children: [
              /* @__PURE__ */ jsxs145("div", { className: "flex items-baseline justify-between text-sm", children: [
                /* @__PURE__ */ jsx218("a", { href: "#", className: "text-lg font-medium text-gray-900", children: event.createdByMessagingUser?.firstName }),
                /* @__PURE__ */ jsx218("span", { className: "text-lg text-xs font-medium text-gray-500", children: formatDateTime(event.createdAt) })
              ] }),
              /* @__PURE__ */ jsx218("div", { className: "mt-1 text-sm text-gray-700", children: /* @__PURE__ */ jsx218("div", { className: "whitespace-pre-wrap", children: event.content }) })
            ]
          }
        )
      },
      event.sequenceNo
    );
  });
  const ref = useRef5(null);
  const messageRef = useRef5(null);
  const scrollToEnd = useCallback123(() => {
    if (messageRef.current) {
      messageRef.current.scrollTop = messageRef.current.scrollHeight;
    }
  }, [messageRef]);
  useEffect31(() => {
    scrollToEnd();
  }, [scrollToEnd]);
  return /* @__PURE__ */ jsxs145(
    "div",
    {
      ref,
      className: `flex  max-h-[calc(100vh_-_185px)] grow flex-col justify-between `,
      children: [
        /* @__PURE__ */ jsx218(
          "div",
          {
            ref: messageRef,
            className: "flex flex-col overflow-y-scroll px-4 py-6 sm:px-6",
            children: /* @__PURE__ */ jsx218("ul", { role: "list", className: "flex flex-col gap-4", children: messages })
          }
        ),
        /* @__PURE__ */ jsx218("footer", { className: "w-full flex-shrink border-t border-gray-200 text-center", children: /* @__PURE__ */ jsx218("div", { className: "min-w-0 flex-1", children: /* @__PURE__ */ jsx218(Suspense68, { fallback: /* @__PURE__ */ jsx218("div", { children: "Sending Message...." }), children: /* @__PURE__ */ jsx218(
          ApplicationConversationAddMessageForm,
          {
            conversationId,
            onDone: () => {
              console.log("Added Message");
              scrollToEnd();
            },
            onError: (e4) => {
              console.error(e4);
            }
          }
        ) }) }) })
      ]
    }
  );
};

// src/messaging/applications/components/ConversationMessages.tsx
import { jsx as jsx219 } from "react/jsx-runtime";
var graphqlQuery7 = ConversationMessagesQuery_graphql_default;
var ConversationMessages = ({ conversationId, users }) => {
  const data = useLazyLoadQuery33(
    graphqlQuery7,
    { sourceId: conversationId },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsx219(
    ConversationMessagesList,
    {
      conversationId,
      conversationMessagesKey: data,
      users
    }
  );
};

// src/messaging/applications/components/ConversationDetails.tsx
import { jsx as jsx220, jsxs as jsxs146 } from "react/jsx-runtime";
var fragment12 = ConversationDetails_conversation_graphql_default;
var ConversationDetails = ({ conversationKey }) => {
  const data = useFragment67(fragment12, conversationKey);
  const firstNames = (user) => user.firstName;
  const fullNames = (user) => `${user.firstName} ${user.lastName}`;
  const [showFirstNames, toggleFirstNames] = useToggle26(true);
  return /* @__PURE__ */ jsxs146(
    "div",
    {
      className: "relative flex h-full flex-col overflow-hidden bg-gray-100 ",
      children: [
        /* @__PURE__ */ jsxs146("div", { className: "border-grey flex w-full flex-wrap items-center justify-between gap-2 border-b-2 bg-white px-7 py-6", children: [
          /* @__PURE__ */ jsx220("p", { className: "text-md sm:text-xl", children: data.title }),
          /* @__PURE__ */ jsxs146("div", { className: "flex items-center gap-2", children: [
            /* @__PURE__ */ jsx220("p", { className: "text-gray-400", children: data.users.map(showFirstNames ? firstNames : fullNames).join(", ") }),
            /* @__PURE__ */ jsx220(
              "div",
              {
                className: "items-baseline text-xs text-gray-500",
                onClick: toggleFirstNames,
                children: showFirstNames ? /* @__PURE__ */ jsx220(ArrowRightCircleIcon, { className: "h-5 w-5" }) : /* @__PURE__ */ jsx220(ArrowLeftCircleIcon, { className: "h-5 w-5" })
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ jsx220(Suspense69, { fallback: /* @__PURE__ */ jsx220("div", { children: "Loading Messages..." }), children: /* @__PURE__ */ jsx220(
          ConversationMessages,
          {
            conversationId: data.conversationId,
            users: data.users
          }
        ) })
      ]
    },
    data.conversationId
  );
};

// src/messaging/applications/components/ApplicationConversationContainer.tsx
import { Fragment as Fragment53, jsx as jsx221, jsxs as jsxs147 } from "react/jsx-runtime";
var graphqlQuery8 = ApplicationConversationContainerQuery_graphql_default;
var MobileHeaderNavigation = ({
  link
}) => {
  return /* @__PURE__ */ jsx221("div", { className: "flex flex-col-reverse md:flex-col", children: /* @__PURE__ */ jsx221(
    MobileHeader3,
    {
      showMobileNavIcon: true,
      title: /* @__PURE__ */ jsx221("div", { className: "flex w-full items-center justify-center lg:justify-between", children: /* @__PURE__ */ jsx221("div", { className: "text-2xl font-bold", children: link.name }) })
    }
  ) });
};
var ApplicationConversationContainer = ({
  chatId,
  showBackButton = true,
  idKey = "chatId",
  backLink = "../chats",
  showExpand = true,
  showMobileNavigation = false
}) => {
  const params = useParams8();
  chatId = chatId || params[idKey];
  const data = useLazyLoadQuery34(
    graphqlQuery8,
    { id: chatId },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { conversation } = data;
  if (!conversation) {
    return /* @__PURE__ */ jsx221("div", { children: "Not Found" });
  }
  const conversationDetails = /* @__PURE__ */ jsx221(
    ConversationDetails,
    {
      conversationKey: conversation,
      onSelected: () => {
        console.log(conversation.conversationId);
      }
    }
  );
  if (showBackButton) {
    return /* @__PURE__ */ jsx221(ApplicationContentFocusLayout, { title: "Back to Chats", backLink, children: conversationDetails });
  }
  return /* @__PURE__ */ jsxs147(Fragment53, { children: [
    /* @__PURE__ */ jsx221("div", { className: "flex flex-col border-b lg:flex-col-reverse", children: showMobileNavigation && /* @__PURE__ */ jsx221(
      MobileHeaderNavigation,
      {
        link: { name: conversation.title, id: chatId || "" }
      }
    ) }),
    conversationDetails
  ] });
};

// src/messaging/vacancies/components/VacancyConversationsList.tsx
import { jsx as jsx223 } from "react/jsx-runtime";
var VacancyConversationsList = () => {
  return /* @__PURE__ */ jsx223("div", {});
};

// src/vacancies/components/VacancyConversations.tsx
import { jsx as jsx224 } from "react/jsx-runtime";
var VacancyConversations = ({ id: id18 }) => {
  const data = useVacancyRouteData(id18);
  if (!data.vacancy) {
    return /* @__PURE__ */ jsx224(EdSkeleton60, {});
  }
  return /* @__PURE__ */ jsx224(Suspense70, { fallback: "Loading...", children: /* @__PURE__ */ jsx224(VacancyConversationsList, {}) });
};

// src/vacancies/components/VacancyRecommendations.tsx
import { Suspense as Suspense71 } from "react";
import { EdSkeleton as EdSkeleton61 } from "shared-ui";
import { jsx as jsx225 } from "react/jsx-runtime";
var VacancyRecommendationsRoute = ({ id: id18 }) => {
  const data = useVacancyRouteData(id18);
  if (!data.vacancy) {
    return /* @__PURE__ */ jsx225(EdSkeleton61, {});
  }
  return /* @__PURE__ */ jsx225(Suspense71, { fallback: "Loading...", children: /* @__PURE__ */ jsx225(
    VacancyRecommendationSearchContainer,
    {
      vacancyId: data.vacancy.vacancyId
    }
  ) });
};

// src/vacancies/components/__generated__/VacancyMatchesLayoutQuery.graphql.ts
var node255 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "vacancyCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "vacancyCode",
      "variableName": "vacancyCode"
    }
  ], v23 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "statusLog",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MatchCounts",
        "kind": "LinkedField",
        "name": "matchCounts",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CountsBySourceType",
            "kind": "LinkedField",
            "name": "score",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "talentPool",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vault",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "workforce",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RecruitRecommendationRun",
    "abstractKey": null
  }, v32 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "reason",
        "storageKey": null
      }
    ],
    "type": "VacancyMatchRunNotStarted",
    "abstractKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "VacancyMatchesLayoutQuery",
      "selections": [
        {
          "alias": "state",
          "args": v1,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "recruitRecommendationRunByVacancyCode",
          "plural": false,
          "selections": [
            v23,
            v32
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "VacancyMatchesLayoutQuery",
      "selections": [
        {
          "alias": "state",
          "args": v1,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "recruitRecommendationRunByVacancyCode",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            },
            v23,
            v32,
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                }
              ],
              "type": "Node",
              "abstractKey": "__isNode"
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "28d2c77181e2c8f5ef1952ee20cb69ad",
      "id": null,
      "metadata": {},
      "name": "VacancyMatchesLayoutQuery",
      "operationKind": "query",
      "text": "query VacancyMatchesLayoutQuery(\n  $vacancyCode: Int!\n) {\n  state: recruitRecommendationRunByVacancyCode(vacancyCode: $vacancyCode) {\n    __typename\n    ... on RecruitRecommendationRun {\n      createdOn\n      updatedOn\n      status\n      statusLog\n      matchCounts {\n        score {\n          talentPool\n          vault\n          workforce\n        }\n      }\n    }\n    ... on VacancyMatchRunNotStarted {\n      reason\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n"
    }
  };
}();
node255.hash = "ee7d5fa37cf701217d389c0a26a8b631";
var VacancyMatchesLayoutQuery_graphql_default = node255;

// src/vacancies/components/VacancyMatchesLayout.tsx
import { useCallback as useCallback124, useState as useState70 } from "react";
import { useEffectOnce as useEffectOnce2, useTimeoutFn } from "react-use";
import { EdSkeleton as EdSkeleton64 } from "shared-ui";

// src/vacancies/components/VacancyMatches.tsx
import { Suspense as Suspense73 } from "react";
import { useSearchParams } from "react-router-dom";
import { ButtonTabUnderline, EdSkeleton as EdSkeleton63, Loading as Loading5, useTabs } from "shared-ui";
import { jsx as jsx226, jsxs as jsxs148 } from "react/jsx-runtime";
var VacancyMatchesRunError = ({}) => {
  return /* @__PURE__ */ jsx226("div", { className: "flex justify-center", children: /* @__PURE__ */ jsx226("div", { className: "m-8 flex flex-col items-center gap-2 border border bg-white bg-white p-4", children: /* @__PURE__ */ jsx226("div", { className: "text-danger-500 my-4 border-b pb-2 text-2xl font-medium", children: "An Error Has Occurred" }) }) });
};
var VacancyMatchesPending = ({}) => {
  return /* @__PURE__ */ jsx226("div", { className: "flex justify-center py-20", children: /* @__PURE__ */ jsx226(Loading5, { label: "Loading Matching Candidates" }) });
};
var VacancyRunNotStarted = ({
  reason
}) => {
  let action = /* @__PURE__ */ jsx226("div", {});
  switch (reason) {
    case "INCORRECT_STATUS": {
      action = /* @__PURE__ */ jsxs148("div", { className: "flex flex-col gap-2 px-4", children: [
        /* @__PURE__ */ jsx226("div", { className: "text-warning-500 border-b p-2 text-lg", children: "The Status Is Incorrect" }),
        /* @__PURE__ */ jsx226("div", { className: "p-2 text-sm text-gray-900", children: "Please contact support via chat to resolve" })
      ] });
      return;
    }
    case "MISSING_LOCATION": {
      action = /* @__PURE__ */ jsxs148("div", { className: "flex flex-col gap-2 px-4", children: [
        /* @__PURE__ */ jsx226("div", { className: "text-warning-500 border-b p-2 text-lg", children: "No Location Provided" }),
        /* @__PURE__ */ jsx226("div", { className: "p-2 text-sm text-gray-900", children: "Please add a Location in the Vacancy Editor and try again" })
      ] });
      return;
    }
    case "SCORING_NOT_READY": {
      action = /* @__PURE__ */ jsxs148("div", { className: "flex flex-col gap-2 px-4", children: [
        /* @__PURE__ */ jsx226("div", { className: "text-warning-500 border-b p-2 text-lg", children: "The Scoring System Is Down" }),
        /* @__PURE__ */ jsx226("div", { className: "p-2 text-sm text-gray-900", children: "Please wait, It will return to normal soon" })
      ] });
      return;
    }
    case "OTHER": {
      action = /* @__PURE__ */ jsxs148("div", { className: "flex flex-col gap-2 px-4", children: [
        /* @__PURE__ */ jsx226("div", { className: "text-warning-500 border-b p-2 text-lg", children: "There is a problem with your Vacancy" }),
        /* @__PURE__ */ jsx226("div", { className: "p-2 text-sm text-gray-900", children: "Please contact support via chat to resolve" })
      ] });
      return;
    }
  }
  return /* @__PURE__ */ jsx226("div", { className: "flex justify-center", children: /* @__PURE__ */ jsxs148("div", { className: "m-8 flex flex-col items-center gap-2 border border bg-white bg-white p-8", children: [
    /* @__PURE__ */ jsx226("div", { className: "text-primary-500 my-4 border-b pb-2 text-2xl font-medium", children: "Recommendation Run Not Started" }),
    action
  ] }) });
};
var VacancyMatchesContainer2 = ({ vacancyId }) => {
  const [searchParams] = useSearchParams();
  const [current, tabLinks] = useTabs(
    [
      { name: "info", label: "Info" },
      {
        name: "results",
        label: "Matched Candidates"
      }
    ],
    searchParams.get("page") || "Results"
  );
  let currentTab = /* @__PURE__ */ jsx226("div", {});
  switch (current.name) {
    case "info": {
      currentTab = /* @__PURE__ */ jsx226(Suspense73, { fallback: /* @__PURE__ */ jsx226(EdSkeleton63, {}), children: /* @__PURE__ */ jsx226("div", { className: "lg:m-5", children: /* @__PURE__ */ jsx226(VacancyMatchesDashboard, { vacancyId }) }) });
      break;
    }
    case "results": {
      currentTab = /* @__PURE__ */ jsx226(Suspense73, { fallback: /* @__PURE__ */ jsx226(EdSkeleton63, {}), children: /* @__PURE__ */ jsx226(MatchSearchContainer, { vacancyId }) });
      break;
    }
  }
  return /* @__PURE__ */ jsxs148("div", { children: [
    /* @__PURE__ */ jsx226("div", { className: "p-3", children: /* @__PURE__ */ jsx226(ButtonTabUnderline, { tabs: tabLinks }) }),
    /* @__PURE__ */ jsx226("div", { children: currentTab })
  ] });
};

// src/vacancies/components/VacancyMatchesLayout.tsx
import { jsx as jsx227 } from "react/jsx-runtime";
var queryDef34 = VacancyMatchesLayoutQuery_graphql_default;
var VacancyMatchesLayout = ({
  vacancyRouteId,
  environment
}) => {
  const { vacancy } = useVacancyRouteData(vacancyRouteId);
  if (!vacancy) {
    return /* @__PURE__ */ jsx227(EdSkeleton64, {});
  }
  const [run, setRun] = useState70(null);
  const [notStartedReason, setNotStartedReason] = useState70(null);
  const onLoad = useCallback124(async () => {
    const data = await fetchMatchRun(queryDef34, vacancy.code, environment);
    if (!data || !data.state) {
      return;
    }
    const { state } = data;
    if (state.reason) {
      cancel();
      setNotStartedReason(state.reason);
      return;
    }
    if (state.status && (state.status === "COMPLETED" || state.status === "FAILED")) {
      cancel();
      setRun(state);
      return;
    }
  }, [fetchMatchRun]);
  useEffectOnce2(() => {
    onLoad();
  });
  const [isReady, cancel, reset] = useTimeoutFn(onLoad, 5e3);
  if (notStartedReason) {
    return /* @__PURE__ */ jsx227(VacancyRunNotStarted, { reason: notStartedReason });
  } else if (run && run.status === "PENDING") {
    return /* @__PURE__ */ jsx227(VacancyMatchesPending, {});
  } else if (run && run.status === "FAILED") {
    return /* @__PURE__ */ jsx227(VacancyMatchesRunError, {});
  } else if (run && run.status === "COMPLETED") {
    return /* @__PURE__ */ jsx227(VacancyMatchesContainer2, { vacancyId: vacancy.vacancyId });
  }
  return /* @__PURE__ */ jsx227(VacancyMatchesPending, {});
};

// src/vacancies/components/VacancyRoutes.tsx
import { jsx as jsx228 } from "react/jsx-runtime";
var createVacancyRoutes = (routePrefix, environment, context, options7) => {
  const vacancyRouteId = `${routePrefix}-vacancy`;
  return [
    {
      path: "*",
      id: vacancyRouteId,
      element: /* @__PURE__ */ jsx228(ErrorBoundary5, { FallbackComponent: ErrorBoundaryFallback4, children: /* @__PURE__ */ jsx228(VacancyRoute, { hideHeader: options7?.hideHeader }) }),
      errorElement: /* @__PURE__ */ jsx228(ErrorContainer11, {}),
      handle: {},
      loader: ({ params }) => {
        return vacancyLoader(environment, params);
      },
      children: [
        {
          path: "dashboard",
          id: `${routePrefix}-vacancy-root`,
          element: /* @__PURE__ */ jsx228(VacancyRoot, { id: `${routePrefix}-vacancy-root` }),
          handle: {},
          loader: ({ params }) => {
            return loader13(environment, params);
          }
        },
        {
          id: `${routePrefix}-vacancy-conversations`,
          path: "inbox",
          element: /* @__PURE__ */ jsx228(VacancyConversations, { id: `${routePrefix}-vacancy-conversations` }),
          handle: {
            crumb: () => /* @__PURE__ */ jsx228(BreadcrumbLink6, { to: "edit", label: "Edit" })
          },
          loader: ({ params }) => {
            return loader7(environment, params);
          }
        },
        {
          id: `${vacancyRouteId}-edit`,
          path: "edit",
          element: /* @__PURE__ */ jsx228(OutletRoute3, {}),
          children: createVacancyEditRoutes(
            `${vacancyRouteId}-edit`,
            environment,
            context
          ),
          handle: {
            crumb: () => /* @__PURE__ */ jsx228(BreadcrumbLink6, { to: "edit", label: "Edit" })
          },
          loader: ({ params }) => {
            return loader7(environment, params);
          }
        },
        {
          id: `${vacancyRouteId}-ads`,
          path: "ads",
          element: /* @__PURE__ */ jsx228(VacancyAds, { routeId: `${vacancyRouteId}-ads` }),
          handle: {
            crumb: () => /* @__PURE__ */ jsx228(BreadcrumbLink6, { to: "ads", label: "Adverts" })
          },
          loader: ({ params }) => {
            return loader14(environment, params);
          }
        },
        {
          id: `${vacancyRouteId}-close`,
          path: "close",
          element: /* @__PURE__ */ jsx228(VacancyClose, { routeId: `${vacancyRouteId}-close` }),
          handle: {
            crumb: () => /* @__PURE__ */ jsx228(BreadcrumbLink6, { to: "close", label: "Close" })
          },
          loader: ({ params }) => {
            return loader2(environment, params);
          }
        },
        {
          id: `${routePrefix}-vacancy-matches`,
          path: "matches/*",
          element: /* @__PURE__ */ jsx228(Suspense74, { fallback: "Loading...", children: /* @__PURE__ */ jsx228(OutletRoute3, {}) }),
          errorElement: /* @__PURE__ */ jsx228(ErrorContainer11, {}),
          handle: {
            crumb: () => /* @__PURE__ */ jsx228(Link12, { className: "text-md text-gray-500", to: "matches", children: "Matches" })
          },
          children: [
            {
              path: "*",
              element: /* @__PURE__ */ jsx228(
                VacancyMatchesLayout,
                {
                  vacancyRouteId,
                  environment
                }
              )
            },
            {
              id: `${routePrefix}-vacancy-matches-match`,
              path: ":matchCode/*",
              element: /* @__PURE__ */ jsx228(OutletRoute3, {}),
              errorElement: /* @__PURE__ */ jsx228(ErrorContainer11, {}),
              children: createMatchRoutes(
                `${routePrefix}-vacancy-matches-match`,
                environment,
                context,
                false,
                true
              )
            }
          ]
        },
        {
          id: `${routePrefix}-vacancy-match`,
          path: "match/:matchCode",
          element: /* @__PURE__ */ jsx228(ShowExpandProfile.Provider, { value: false, children: /* @__PURE__ */ jsx228(OutletRoute3, {}) }),
          errorElement: /* @__PURE__ */ jsx228(ErrorContainer11, {}),
          children: createMatchRoutes(
            `${routePrefix}-vacancy-match-match`,
            environment,
            context,
            false,
            true
          )
        },
        {
          id: `${routePrefix}-vacancy-recommendations`,
          path: "recommendations/*",
          element: /* @__PURE__ */ jsx228(
            VacancyRecommendationsRoute,
            {
              id: `${routePrefix}-vacancy-recommendations`
            }
          ),
          errorElement: /* @__PURE__ */ jsx228(ErrorContainer11, {}),
          loader: ({ params }) => {
            return vacancyLoader(environment, params);
          },
          handle: {
            crumb: () => /* @__PURE__ */ jsx228(Link12, { className: "text-md text-gray-500", to: "recommendations", children: "Recommendations" })
          },
          children: [
            {
              path: "",
              element: /* @__PURE__ */ jsx228(ListLayoutMobileList, {}),
              errorElement: /* @__PURE__ */ jsx228(ErrorContainer11, {})
            },
            {
              id: `${routePrefix}-vacancy-recommendations-recommendation`,
              path: ":recommendationCode/*",
              element: /* @__PURE__ */ jsx228(OutletRoute3, {}),
              errorElement: /* @__PURE__ */ jsx228(ErrorContainer11, {}),
              children: createVacancyRecommendationRoutes(
                `${routePrefix}-vacancy-recommendations-recommendation`,
                environment,
                context,
                false,
                true
              )
            }
          ]
        },
        {
          id: `${routePrefix}-vacancy-recommendations-recommendation-view`,
          path: "recommendation/:recommendationCode/*",
          element: /* @__PURE__ */ jsx228(ShowExpandProfile.Provider, { value: false, children: /* @__PURE__ */ jsx228(OutletRoute3, {}) }),
          errorElement: /* @__PURE__ */ jsx228(ErrorContainer11, {}),
          children: createVacancyRecommendationRoutes(
            `${routePrefix}-vacancy-recommendations-recommendation-view`,
            environment,
            context,
            false,
            false
          )
        },
        {
          id: `${routePrefix}-vacancy-applications`,
          path: "applications/*",
          element: /* @__PURE__ */ jsx228(Suspense74, { fallback: /* @__PURE__ */ jsx228(Loading6, { label: "Loading Applications" }), children: /* @__PURE__ */ jsx228(
            VacancyApplicationsRoute,
            {
              id: `${routePrefix}-vacancy-applications`
            }
          ) }),
          loader: ({ params }) => {
            return vacancyLoader(environment, params);
          },
          errorElement: /* @__PURE__ */ jsx228(ErrorContainer11, {}),
          handle: {
            crumb: () => /* @__PURE__ */ jsx228(Link12, { className: "text-md text-gray-500", to: "applications", children: "Applications" })
          },
          children: [
            {
              path: "",
              element: /* @__PURE__ */ jsx228(ListLayoutMobileList, {}),
              errorElement: /* @__PURE__ */ jsx228(ErrorContainer11, {})
            },
            {
              id: `${routePrefix}-vacancy-applications-application`,
              path: ":applicationCode/*",
              element: /* @__PURE__ */ jsx228(OutletRoute3, {}),
              errorElement: /* @__PURE__ */ jsx228(ErrorContainer11, {}),
              children: createCandidateApplicationRoutes(
                `${routePrefix}-vacancy-applications-application`,
                environment,
                context,
                false
              )
            }
          ]
        },
        {
          id: `${routePrefix}-vacancy-application`,
          path: ":applicationCode/*",
          element: /* @__PURE__ */ jsx228(OutletRoute3, {}),
          errorElement: /* @__PURE__ */ jsx228(ErrorContainer11, {}),
          children: createCandidateApplicationRoutes(
            `${routePrefix}-vacancy-application-application`,
            environment,
            context,
            false,
            false
          )
        },
        {
          id: `${routePrefix}-vacancy-dashboard`,
          path: "*",
          element: /* @__PURE__ */ jsx228(Navigate9, { to: "dashboard", replace: true })
        }
      ]
    }
  ];
};

// src/vacancies/components/__generated__/VacancySkillsTextMutation.graphql.ts
var node256 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "concreteType": "VacancySkillsPayload",
    "kind": "LinkedField",
    "name": "vacancy",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "EdgeOfVacancy",
        "kind": "LinkedField",
        "name": "vacancy",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Vacancy",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userRequiredSkills",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userOptionalSkills",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v32 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      }
    ],
    "type": "UserError",
    "abstractKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "VacancySkillsTextMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "RecruitVacancySkillsTextPayload",
          "kind": "LinkedField",
          "name": "recruitVacancySkillsText",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "VacancySkillsTextMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "RecruitVacancySkillsTextPayload",
          "kind": "LinkedField",
          "name": "recruitVacancySkillsText",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "13ee3a92726fec621a8b009ba45e51c7",
      "id": null,
      "metadata": {},
      "name": "VacancySkillsTextMutation",
      "operationKind": "mutation",
      "text": "mutation VacancySkillsTextMutation(\n  $input: RecruitVacancySkillsTextInput!\n) {\n  recruitVacancySkillsText(input: $input) {\n    vacancy {\n      vacancy {\n        node {\n          id\n          userRequiredSkills\n          userOptionalSkills\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on UserError {\n        code\n      }\n    }\n  }\n}\n"
    }
  };
}();
node256.hash = "cd316244c0f6a71139875a83f2df8927";
var VacancySkillsTextMutation_graphql_default = node256;

// src/vacancies/components/__generated__/VacancySkillsText_vacancy.graphql.ts
var node257 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VacancySkillsText_vacancy",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userRequiredSkills",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userOptionalSkills",
      "storageKey": null
    }
  ],
  "type": "Vacancy",
  "abstractKey": null
};
node257.hash = "fe6cefc8dd778159b6514b8cfd386a4c";
var VacancySkillsText_vacancy_graphql_default = node257;

// src/vacancies/components/VacancySkillsText.tsx
import { useCallback as useCallback125 } from "react";
import { zodResolver as zodResolver17 } from "@hookform/resolvers/zod/dist/zod";
import { useForm as useForm18 } from "react-hook-form";
import { useFragment as useFragment68, useMutation as useMutation26 } from "react-relay";
import * as zod13 from "zod";
import { createClientMutationId as createClientMutationId58 } from "shared-lib";
import { Button as Button65, ButtonList as ButtonList21, Error as Error9, FormInput as Input14 } from "shared-ui";
import { jsx as jsx229, jsxs as jsxs149 } from "react/jsx-runtime";
var mutationDef59 = VacancySkillsTextMutation_graphql_default;
var fragmentDef55 = VacancySkillsText_vacancy_graphql_default;
var FormSchema6 = zod13.object({
  userRequired: zod13.string({
    required_error: "Please enter required skills",
    invalid_type_error: "Name must be a string"
  }).min(1, "Please enter required skills"),
  userOptional: zod13.string().optional()
});
var VacancySkillsText = ({
  vacancyId,
  fragmentRef,
  onSuccess,
  onCancel
}) => {
  const data = useFragment68(
    fragmentDef55,
    fragmentRef
  );
  const [commitVacancySkillsTextMutation, vacancySkillsTextMutationInFlight] = useMutation26(mutationDef59);
  const {
    register,
    handleSubmit,
    formState: { errors, isValid }
  } = useForm18({
    resolver: zodResolver17(FormSchema6),
    defaultValues: {
      userRequired: data?.userRequiredSkills.join(", "),
      userOptional: data?.userOptionalSkills.join(", ")
    }
  });
  const onSubmit = handleSubmit((data2) => onSave(isValid, data2));
  const onSave = useCallback125(
    async (isValid2, data2) => {
      if (!isValid2) {
        return;
      }
      const userRequiredSkills = data2.userRequired.split(",").map((skill) => skill.trim());
      const userOptionalSkills = data2.userOptional.split(",").map((skill) => skill.trim());
      commitVacancySkillsTextMutation({
        variables: {
          input: {
            clientMutationId: createClientMutationId58(),
            vacancyId,
            userRequiredSkills,
            userOptionalSkills
          }
        },
        onCompleted: () => {
          onSuccess();
        }
      });
    },
    [commitVacancySkillsTextMutation, onSuccess, vacancyId]
  );
  return /* @__PURE__ */ jsx229("div", { className: "flex gap-4", children: /* @__PURE__ */ jsx229("form", { onSubmit, children: /* @__PURE__ */ jsxs149("div", { className: "flex flex-col gap-4", children: [
    /* @__PURE__ */ jsxs149("div", { className: "flex gap-4", children: [
      /* @__PURE__ */ jsxs149("div", { className: "flex flex-col", children: [
        /* @__PURE__ */ jsx229("p", { className: "text-gray-500", children: "Required Skills" }),
        /* @__PURE__ */ jsx229(Input14, { name: "userRequired", register }),
        /* @__PURE__ */ jsx229(Error9, { children: errors.userRequired && /* @__PURE__ */ jsx229("p", { children: errors.userRequired.message }) })
      ] }),
      /* @__PURE__ */ jsxs149("div", { className: "flex flex-col", children: [
        /* @__PURE__ */ jsx229("p", { className: "text-gray-500", children: "Optional Skills" }),
        /* @__PURE__ */ jsx229(Input14, { name: "userOptional", register }),
        /* @__PURE__ */ jsx229(Error9, { children: errors.userOptional && /* @__PURE__ */ jsx229("p", { children: errors.userOptional.message }) })
      ] })
    ] }),
    /* @__PURE__ */ jsxs149(ButtonList21, { children: [
      /* @__PURE__ */ jsx229("div", { children: /* @__PURE__ */ jsx229(
        Button65,
        {
          color: "primary",
          type: "submit",
          disabled: vacancySkillsTextMutationInFlight,
          children: "Save"
        }
      ) }),
      /* @__PURE__ */ jsx229("div", { children: /* @__PURE__ */ jsx229(Button65, { color: "gray", onClick: onCancel, children: "Cancel" }) })
    ] })
  ] }) }) });
};

// src/vacancies/components/VacancyStatusFilter.tsx
import { useCallback as useCallback126, useState as useState71 } from "react";
import { Switch } from "@headlessui/react";
import { jsx as jsx230, jsxs as jsxs150 } from "react/jsx-runtime";
var statusItems = [
  vacancyStatusOpen,
  vacancyStatusDraft,
  vacancyStatusFilled,
  vacancyStatusArchived
];
var VacancyStatusFilter = ({ status, onChanged }) => {
  const [items, setItems] = useState71(() => {
    return statusItems.map((item) => ({
      ...item,
      checked: status ? status.includes(item.id) : item.checked
    }));
  });
  const change = useCallback126(
    (item, checked) => {
      const currentItem = items.find((i4) => i4.id == item.id);
      if (!currentItem) {
        return;
      }
      const newItems = [
        ...items.filter((i4) => i4.id != item.id),
        {
          ...currentItem,
          checked
        }
      ].sort((a4, b3) => {
        return a4.order - b3.order;
      });
      const statusFilter = newItems.filter((i4) => i4.id !== "ALL").filter((i4) => i4.checked).map((i4) => i4.id);
      setItems(newItems);
      onChanged(statusFilter);
    },
    [items, setItems, onChanged]
  );
  const options7 = items.map((i4) => {
    return /* @__PURE__ */ jsxs150(
      Switch,
      {
        checked: i4.checked,
        onChange: (checked) => change(i4, checked),
        className: `${i4.checked ? "bg-blue-600" : "bg-gray-200"} relative inline-flex items-center gap-2 rounded-full px-2 py-1 transition-colors focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2`,
        children: [
          /* @__PURE__ */ jsx230(
            "span",
            {
              className: `${i4.checked ? "translate-x-3" : "translate-x-1"} inline-block h-4 w-4 transform rounded-full bg-white transition-transform`
            }
          ),
          /* @__PURE__ */ jsx230(Switch.Label, { as: "span", className: "ml-3 text-sm", children: /* @__PURE__ */ jsx230(
            "span",
            {
              className: `${i4.checked ? "text-white" : "text-gray-700"} font-medium `,
              children: i4.name
            }
          ) })
        ]
      },
      i4.id
    );
  });
  return /* @__PURE__ */ jsx230("div", { children: /* @__PURE__ */ jsx230(Switch.Group, { children: /* @__PURE__ */ jsx230("div", { className: "flex flex-wrap items-center gap-2", children: options7 }) }) });
};

// src/vacancies/components/__generated__/VacancySearchAutoCompleteQuery.graphql.ts
var node258 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "alias": "list",
      "args": [
        {
          "kind": "Variable",
          "name": "input",
          "variableName": "input"
        }
      ],
      "concreteType": "VacancySearchResult",
      "kind": "LinkedField",
      "name": "recruitVacanciesSearch",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "VacancySearchModel",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "vacancyId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "code",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CollectionMetaData",
          "kind": "LinkedField",
          "name": "paging",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "pages",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "pageNumber",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "itemsPerPage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalResults",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "VacancySearchAutoCompleteQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "VacancySearchAutoCompleteQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "b906806753438132dc47eeeff6ca9c53",
      "id": null,
      "metadata": {},
      "name": "VacancySearchAutoCompleteQuery",
      "operationKind": "query",
      "text": "query VacancySearchAutoCompleteQuery(\n  $input: VacancySearchInput!\n) {\n  list: recruitVacanciesSearch(input: $input) {\n    items {\n      id\n      vacancyId\n      code\n      name\n    }\n    paging {\n      pages\n      pageNumber\n      itemsPerPage\n      totalResults\n    }\n  }\n}\n"
    }
  };
}();
node258.hash = "0232e0141543784d1441ed514378e9c0";
var VacancySearchAutoCompleteQuery_graphql_default = node258;

// src/vacancies/components/VacancySearchAutoComplete.tsx
import {
  useCallback as useCallback127,
  useEffect as useEffect33,
  useMemo as useMemo30,
  useState as useState73
} from "react";
import { useQueryLoader as useQueryLoader11 } from "react-relay";
import { ChevronUpDownIcon as ChevronUpDownIcon7 } from "@heroicons/react/24/solid";
import { Combobox as Combobox13 } from "@headlessui/react";
import { debounce as debounce9 } from "lodash-es";

// src/vacancies/components/VacancySearchAutoCompleteOptions.tsx
import { usePreloadedQuery as usePreloadedQuery23 } from "react-relay";
import { CheckIcon as CheckIcon7 } from "@heroicons/react/24/solid";
import { Combobox as Combobox12 } from "@headlessui/react";
import { classNames as classNames27 } from "shared-ui";
import { Fragment as Fragment54, jsx as jsx231, jsxs as jsxs151 } from "react/jsx-runtime";
var VacancySearchAutoCompleteOptions = ({ queryRef: queryRef3 }) => {
  const data = usePreloadedQuery23(vacancySearchAutoCompleteQueryDef, queryRef3);
  const { list: list2 } = data;
  const items = list2?.items || [];
  if (items.length === 0) {
    return /* @__PURE__ */ jsx231("div", {});
  }
  return /* @__PURE__ */ jsx231(Combobox12.Options, { className: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm", children: items.map((result) => /* @__PURE__ */ jsx231(
    Combobox12.Option,
    {
      value: result,
      className: ({ active }) => classNames27(
        "relative cursor-default select-none py-2 pl-3 pr-9",
        active ? "bg-info-600 text-white" : "text-gray-900"
      ),
      children: ({ active, selected }) => /* @__PURE__ */ jsxs151(Fragment54, { children: [
        /* @__PURE__ */ jsx231("div", { className: "flex", children: /* @__PURE__ */ jsx231(
          "span",
          {
            className: classNames27(
              "truncate",
              selected ? "font-semibold" : ""
            ),
            children: result.name
          }
        ) }),
        selected && /* @__PURE__ */ jsx231(
          "span",
          {
            className: classNames27(
              "absolute inset-y-0 right-0 flex items-center pr-4",
              active ? "bg-info-600 text-white" : "text-info-600"
            ),
            children: /* @__PURE__ */ jsx231(CheckIcon7, { className: "h-5 w-5", "aria-hidden": "true" })
          }
        )
      ] })
    },
    result.id
  )) });
};

// src/vacancies/components/VacancySearchAutoComplete.tsx
import { jsx as jsx233, jsxs as jsxs153 } from "react/jsx-runtime";
var vacancySearchAutoCompleteQueryDef = VacancySearchAutoCompleteQuery_graphql_default;
var VacancySearchAutoComplete = ({
  onSelected,
  defaultValue,
  showLabel,
  status
}) => {
  const [selected, setSelected] = useState73(defaultValue ?? null);
  const [searchTerm, setSearchTerm] = useState73("");
  const onQueryChangeHandler = useMemo30(
    () => debounce9((q4) => {
      setSearchTerm(q4);
    }, 500),
    []
  );
  useEffect33(() => {
    return () => {
      onQueryChangeHandler.cancel();
    };
  }, []);
  const onSetSelected = useCallback127(
    (r4) => {
      setSelected(r4);
      onSelected(r4);
    },
    [selected]
  );
  const [queryReference, loadQuery48, disposeQuery] = useQueryLoader11(
    vacancySearchAutoCompleteQueryDef
  );
  useEffect33(() => {
    if (!searchTerm) {
      return;
    }
    const input = {
      name: searchTerm,
      pageNumber: 1,
      pageSize: 20,
      status
    };
    loadQuery48({ input }, { fetchPolicy: "network-only" });
  }, [searchTerm]);
  return /* @__PURE__ */ jsxs153(Combobox13, { as: "div", value: selected, onChange: onSetSelected, children: [
    showLabel && /* @__PURE__ */ jsx233(Combobox13.Label, { className: "block text-sm font-medium text-gray-700", children: "Vacancies" }),
    /* @__PURE__ */ jsxs153("div", { className: "relative", children: [
      /* @__PURE__ */ jsx233(
        Combobox13.Input,
        {
          placeholder: "Search Vacancies",
          className: "focus:border-info-500 focus:ring-info-500 w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:outline-none focus:ring-1 sm:text-sm",
          onChange: (event) => onQueryChangeHandler(event.target.value),
          displayValue: (result) => {
            if (result) {
              return result.name;
            }
            return "";
          },
          autoComplete: "off"
        }
      ),
      /* @__PURE__ */ jsx233(Combobox13.Button, { className: "absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none", children: /* @__PURE__ */ jsx233(
        ChevronUpDownIcon7,
        {
          className: "h-5 w-5 text-gray-400",
          "aria-hidden": "true"
        }
      ) }),
      queryReference && /* @__PURE__ */ jsx233(VacancySearchAutoCompleteOptions, { queryRef: queryReference })
    ] })
  ] });
};

// src/vacancies/components/__generated__/VacancySearchHeader_vacancy.graphql.ts
var node259 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VacancySearchHeader_vacancy",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "employerName",
      "storageKey": null
    }
  ],
  "type": "VacancySearchModel",
  "abstractKey": null
};
node259.hash = "99bd2012a4888e09a606eb4c20502f92";
var VacancySearchHeader_vacancy_graphql_default = node259;

// src/vacancies/components/VacancySearchHeader.tsx
import { useFragment as useFragment69 } from "react-relay";
import { jsx as jsx234, jsxs as jsxs154 } from "react/jsx-runtime";
var fragmentDef56 = VacancySearchHeader_vacancy_graphql_default;
var VacancySearchHeader2 = ({ fragmentRef }) => {
  const vacancy = useFragment69(
    fragmentDef56,
    fragmentRef
  );
  return /* @__PURE__ */ jsx234("div", { className: "flex flex-col gap-2", children: /* @__PURE__ */ jsxs154("div", { className: "flex items-center gap-2", children: [
    /* @__PURE__ */ jsx234("div", { className: "text-primary-900 text-lg font-medium", children: vacancy.name }),
    /* @__PURE__ */ jsx234("div", { className: "text-primary-900 text-md", children: vacancy.code }),
    /* @__PURE__ */ jsx234("div", { className: "text-info-900 text-sm", children: vacancy.status }),
    /* @__PURE__ */ jsx234("div", { className: "text-info-900 text-sm", children: vacancy.projectName }),
    /* @__PURE__ */ jsx234("div", { className: "text-info-900 text-sm", children: vacancy.employerName })
  ] }) });
};

// src/vacancies/components/__generated__/VacancySearchDashboardLayout_vacancy.graphql.ts
var node260 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VacancySearchDashboardLayout_vacancy",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "employerReference",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectName",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "VacancySearchDashboardChart_vacancy"
    }
  ],
  "type": "VacancySearchModel",
  "abstractKey": null
};
node260.hash = "f3ccf2a944486aaa1698145f1e23e8a6";
var VacancySearchDashboardLayout_vacancy_graphql_default = node260;

// src/vacancies/components/VacancySearchDashboardLayout.tsx
import { Suspense as Suspense76 } from "react";
import { useFragment as useFragment71 } from "react-relay";
import { EdSkeleton as EdSkeleton66 } from "shared-ui";

// src/vacancies/components/__generated__/VacancySearchDashboardChart_vacancy.graphql.ts
var node261 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  }, v1 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "count",
      "storageKey": null
    },
    v0
  ];
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "VacancySearchDashboardChart_vacancy",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      v0,
      {
        "alias": null,
        "args": null,
        "concreteType": "VacancyCandidateCount",
        "kind": "LinkedField",
        "name": "candidateCounts",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CandidateCount",
            "kind": "LinkedField",
            "name": "created",
            "plural": false,
            "selections": v1,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CandidateCount",
            "kind": "LinkedField",
            "name": "submitted",
            "plural": false,
            "selections": v1,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CandidateCount",
            "kind": "LinkedField",
            "name": "active",
            "plural": false,
            "selections": v1,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CandidateCount",
            "kind": "LinkedField",
            "name": "hired",
            "plural": false,
            "selections": v1,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CandidateCount",
            "kind": "LinkedField",
            "name": "withdrawn",
            "plural": false,
            "selections": v1,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CandidateCount",
            "kind": "LinkedField",
            "name": "unsuccessful",
            "plural": false,
            "selections": v1,
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "VacancySearchModel",
    "abstractKey": null
  };
}();
node261.hash = "91a56f87fea2feb9ea1376d096120e63";
var VacancySearchDashboardChart_vacancy_graphql_default = node261;

// src/vacancies/components/VacancySearchDashboardChart.tsx
import { Suspense as Suspense75 } from "react";
import { useFragment as useFragment70 } from "react-relay";
import { ResponsivePie as ResponsivePie4 } from "@nivo/pie";
import { ChartColors as ChartColors4, EdSkeleton as EdSkeleton65 } from "shared-ui";
import { jsx as jsx235 } from "react/jsx-runtime";
var fragmentDef57 = VacancySearchDashboardChart_vacancy_graphql_default;
function countOrZero(item) {
  if (!item) {
    return 0;
  }
  return item.count;
}
var VacancySearchDashboardChart = ({
  fragmentRef,
  margin = { top: 40, right: 80, bottom: 80, left: 80 }
}) => {
  const data = useFragment70(
    fragmentDef57,
    fragmentRef
  );
  let chartData = [
    {
      id: "Created",
      label: "Created",
      value: countOrZero(data.candidateCounts.created),
      color: "hsl(90, 70%, 50%)"
    },
    {
      id: "Submitted",
      label: "Submitted",
      value: countOrZero(data.candidateCounts.submitted),
      color: "hsl(56, 70%, 50%)"
    },
    {
      id: "Withdrawn",
      label: "Withdrawn",
      value: countOrZero(data.candidateCounts.withdrawn),
      color: "hsl(103, 70%, 50%)"
    },
    {
      id: "Hired",
      label: "Hired",
      value: countOrZero(data.candidateCounts.hired),
      color: "hsl(186, 70%, 50%)"
    },
    {
      id: "Active",
      label: "Active",
      value: countOrZero(data.candidateCounts.active),
      color: "hsl(104, 70%, 50%)"
    }
  ];
  let enableArcLabels = true;
  let isInteractive = true;
  if (chartData.every(({ value }) => value === 0)) {
    enableArcLabels = false;
    isInteractive = false;
    chartData = [
      {
        id: "No applications",
        label: "No Applications",
        value: 1,
        color: "hsl(104, 70%, 0%)"
      }
    ];
  }
  return /* @__PURE__ */ jsx235(Suspense75, { fallback: /* @__PURE__ */ jsx235(EdSkeleton65, {}), children: /* @__PURE__ */ jsx235(
    ResponsivePie4,
    {
      isInteractive,
      enableArcLabels,
      enableArcLinkLabels: false,
      data: chartData,
      colors: ChartColors4,
      margin,
      innerRadius: 0.5,
      padAngle: 0.7,
      activeOuterRadiusOffset: 8,
      borderColor: { from: "color", modifiers: [["darker", 0.2]] },
      arcLinkLabelsSkipAngle: 10,
      arcLinkLabelsThickness: 2,
      arcLabelsSkipAngle: 10
    }
  ) });
};

// src/vacancies/components/VacancySearchDashboardLayout.tsx
import { Fragment as Fragment55, jsx as jsx236, jsxs as jsxs155 } from "react/jsx-runtime";
var fragmentDef58 = VacancySearchDashboardLayout_vacancy_graphql_default;
var VacancySearchDashboardLayout = ({ fragmentRef }) => {
  const data = useFragment71(
    fragmentDef58,
    fragmentRef
  );
  let dashboard3 = /* @__PURE__ */ jsx236(Fragment55, {});
  switch (data.status) {
    case "DRAFT": {
      break;
    }
    case "FILLED": {
      dashboard3 = /* @__PURE__ */ jsx236(VacancySearchDashboardChart, { fragmentRef: data });
      break;
    }
    case "ARCHIVED": {
      dashboard3 = /* @__PURE__ */ jsx236(VacancySearchDashboardChart, { fragmentRef: data });
      break;
    }
    case "OPEN": {
      dashboard3 = /* @__PURE__ */ jsx236(VacancySearchDashboardChart, { fragmentRef: data });
      break;
    }
  }
  return /* @__PURE__ */ jsx236(Suspense76, { fallback: /* @__PURE__ */ jsx236(EdSkeleton66, {}), children: /* @__PURE__ */ jsxs155("div", { className: "flex flex-col justify-between md:flex-row", children: [
    /* @__PURE__ */ jsxs155("div", { className: "items-top flex w-full grow flex-col gap-2 p-5", children: [
      /* @__PURE__ */ jsxs155("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ jsx236("div", { className: "text-primary-500 mr-2 w-24 text-lg uppercase", children: "Project" }),
        /* @__PURE__ */ jsx236("div", { className: "text-lg uppercase text-gray-900", children: data.projectName })
      ] }),
      /* @__PURE__ */ jsxs155("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ jsx236("div", { className: "text-primary-500 mr-2 w-24 text-lg uppercase", children: "Reference" }),
        /* @__PURE__ */ jsx236("div", { className: "text-lg uppercase text-gray-900", children: data.employerReference })
      ] })
    ] }),
    /* @__PURE__ */ jsx236("div", { className: "flex w-full grow bg-gray-100 p-10", children: /* @__PURE__ */ jsxs155("div", { className: "flex-1", style: { height: 600 }, children: [
      /* @__PURE__ */ jsx236("h2", { className: "mb-3 font-bold", children: "Applications" }),
      dashboard3
    ] }) })
  ] }) });
};

// src/vacancies/components/HappyFace.tsx
import { jsx as jsx237, jsxs as jsxs156 } from "react/jsx-runtime";
var HappyFace = () => /* @__PURE__ */ jsxs156(
  "svg",
  {
    width: "380",
    height: "380",
    viewBox: "0 0 247 247",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    children: [
      /* @__PURE__ */ jsx237("rect", { width: "247", height: "247", fill: "url(#pattern0)" }),
      /* @__PURE__ */ jsxs156("defs", { children: [
        /* @__PURE__ */ jsx237(
          "pattern",
          {
            id: "pattern0",
            patternContentUnits: "objectBoundingBox",
            width: "1",
            height: "1",
            children: /* @__PURE__ */ jsx237("use", { xlinkHref: "#image0_1174_8503", transform: "scale(0.0004363)" })
          }
        ),
        /* @__PURE__ */ jsx237(
          "image",
          {
            id: "image0_1174_8503",
            width: "2292",
            height: "2292",
            xlinkHref: "data:image/png;base64,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"
          }
        )
      ] })
    ]
  }
);

// src/vacancies/components/__generated__/VacancyDashboardRouteQuery.graphql.ts
var node263 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "vacancyCode"
    }
  ], v1 = [
    {
      "alias": "vacancy",
      "args": [
        {
          "kind": "Variable",
          "name": "vacancyCode",
          "variableName": "vacancyCode"
        }
      ],
      "concreteType": "Vacancy",
      "kind": "LinkedField",
      "name": "recruitVacancyByCode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "vacancyId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "VacancyDashboardRouteQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "VacancyDashboardRouteQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "cd6092a1ce22766003de6923d3f55645",
      "id": null,
      "metadata": {},
      "name": "VacancyDashboardRouteQuery",
      "operationKind": "query",
      "text": "query VacancyDashboardRouteQuery(\n  $vacancyCode: Int!\n) {\n  vacancy: recruitVacancyByCode(vacancyCode: $vacancyCode) {\n    id\n    code\n    vacancyId\n    name\n  }\n}\n"
    }
  };
}();
node263.hash = "1c4c0a46a9be19c5382640f37b1c8c4a";
var VacancyDashboardRouteQuery_graphql_default = node263;

// src/vacancies/components/VacancyDashboard.tsx
import { Suspense as Suspense77 } from "react";
import {
  loadQuery as loadQuery19,
  usePreloadedQuery as usePreloadedQuery24
} from "react-relay";
import { useRouteLoaderData as useRouteLoaderData12 } from "react-router-dom";
import { EdSkeleton as EdSkeleton67, EdTextLink as EdTextLink3 } from "shared-ui";
import { Fragment as Fragment56, jsx as jsx238, jsxs as jsxs157 } from "react/jsx-runtime";
var queryDef35 = VacancyDashboardRouteQuery_graphql_default;
async function loader15(environment, params) {
  const code = params.vacancyCode;
  const vacancyCode = parseInt(code);
  return loadQuery19(environment, queryDef35, {
    vacancyCode
  });
}
function useRouteData10(id18) {
  const queryRef3 = useRouteLoaderData12(
    id18
  );
  const data = usePreloadedQuery24(
    queryDef35,
    queryRef3
  );
  return data;
}
var VacancyDashboard = ({ id: id18 }) => {
  const data = useRouteData10(id18);
  const { vacancy } = data;
  if (!vacancy) {
    return /* @__PURE__ */ jsx238(Fragment56, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx238(Suspense77, { fallback: /* @__PURE__ */ jsx238(EdSkeleton67, {}), children: /* @__PURE__ */ jsxs157("div", { className: "border-b bg-white p-4", children: [
    /* @__PURE__ */ jsx238("div", { className: "flex items-center justify-between", children: /* @__PURE__ */ jsx238("div", { className: "flex items-center space-x-2 sm:justify-end", children: /* @__PURE__ */ jsx238(EdTextLink3, { id: "edit-back-link", to: "../", label: "Back" }) }) }),
    /* @__PURE__ */ jsx238("div", { children: vacancy.name })
  ] }) });
};

// src/matches/relevance/lib/MatchProfileModel.ts
import { KeyableSet as KeyableSet3, parseDate as parseDate12 } from "shared-lib";

// src/matches/relevance/lib/Relevance.ts
function createRelevance(score, positiveThreshold, negativeThreshold) {
  if (score === null || score === void 0) {
    return "Unknown";
  }
  if (score >= positiveThreshold) {
    return "Yes";
  }
  if (score <= negativeThreshold) {
    return "No";
  }
  return "Unknown";
}
function createRelevanceFromThreshold(threshold, score) {
  if (score === null || score === void 0) {
    return "Unknown";
  }
  if (score > threshold * 1.1) {
    return "Yes";
  }
  if (score < threshold * 0.9) {
    return "No";
  }
  return "Unknown";
}
function combineRelevance(a4, b3) {
  if (a4 === "Yes" && b3 === "Yes") {
    return "Yes";
  }
  if (a4 === "No" || b3 === "No") {
    return "No";
  }
  return "Unknown";
}

// src/matches/relevance/lib/MatchExperienceSkillGroupScore.ts
var MatchExperienceSkillGroupScore = class {
  constructor(data, groupName) {
    this.groupId = data.groupId;
    this.score = data.score;
    this.weight = data.weight;
    this.minScore = data.minSkillGroupScore || 0;
    this.hasMatch = data.hasMatch;
    this.relevance = createRelevanceFromThreshold(
      this.minScore || 0,
      this.score
    );
    this.groupName = groupName;
  }
  key() {
    return this.groupId;
  }
};

// src/matches/relevance/lib/MatchScoreResults.ts
import {
  describeDuration,
  isNotNullOrUndefined as isNotNullOrUndefined7,
  monthsAgo
} from "shared-lib";
function createApplicationScoreResult(name, aggregation, experienceRequirement, recencyRequirement, isSkill) {
  const result = {
    name
  };
  if (aggregation.numberOfMonthsCertain > 0) {
    result.confirmedExperienceDesc = describeDuration(
      aggregation.numberOfMonthsCertain
    );
  }
  const unknown = aggregation.numberOfMonthsCertainPlusUnknown - aggregation.numberOfMonthsCertain;
  if (unknown > 0) {
    result.unknownExperienceDesc = describeDuration(unknown);
  }
  if (experienceRequirement) {
    result.requiredDuration = describeDuration(
      experienceRequirement.durationMonths
    );
    result.hasRequiredExperience = experienceRequirement.isLessThanMonths(
      aggregation.numberOfMonthsCertain
    ) ? "Yes" : experienceRequirement.isLessThanMonths(
      aggregation.numberOfMonthsCertainPlusUnknown
    ) ? "Unknown" : "No";
  } else {
    result.hasRequiredExperience = "Unknown";
  }
  if (recencyRequirement) {
    result.requiredRecency = describeDuration(
      recencyRequirement.durationMonths
    );
    const recencyDate = monthsAgo(recencyRequirement.durationMonths);
    result.hasRequiredRecency = aggregation.mostRecentCertainExperienceEnd && recencyDate < aggregation.mostRecentCertainExperienceEnd ? "Yes" : aggregation.mostRecentUnknownExperienceEnd && recencyDate < aggregation.mostRecentUnknownExperienceEnd ? "Unknown" : "No";
    if (result.hasRequiredRecency === "Yes") {
      result.confirmedRecency = aggregation.mostRecentCertainExperienceEnd;
    }
  } else {
    result.hasRequiredRecency = "Unknown";
  }
  result.fulfillsRequirements = combineRelevance(
    result.hasRequiredExperience,
    result.hasRequiredRecency
  );
  result.isSkill = isSkill;
  return result;
}
function createApplicationScoreResults(relevanceAggregations, scoringConfig, allSkillGroups) {
  const job = createApplicationScoreResult(
    "Experience Relevance",
    relevanceAggregations.job,
    scoringConfig.relevantExperience,
    scoringConfig.relevantRecency,
    false
  );
  const industry = createApplicationScoreResult(
    "Industry Relevance",
    relevanceAggregations.industry,
    scoringConfig.industryExperience,
    scoringConfig.industryRecency,
    false
  );
  const skillGroups = relevanceAggregations.skillGroups.filter((relevance) => {
    return allSkillGroups.containsByKey(relevance.skillGroupId);
  }).map((relevance) => {
    const skillGroup = allSkillGroups.getByKey(relevance.skillGroupId);
    if (skillGroup !== null && skillGroup.experience !== null && skillGroup.recency !== null) {
      const group = createApplicationScoreResult(
        skillGroup.name.toLocaleLowerCase(),
        relevance,
        skillGroup.experience,
        skillGroup.recency,
        true
      );
      return group;
    } else {
      return null;
    }
  }).filter(isNotNullOrUndefined7);
  return {
    jobScore: job,
    industryScore: industry,
    skillGroupScores: skillGroups
  };
}

// src/matches/relevance/lib/MatchRelevance.ts
import { tryParseDate } from "shared-lib";
function createMatchRelevanceAggregations(data) {
  const job = {
    numberOfMonthsCertain: data.job.numberOfMonthsCertain,
    numberOfMonthsCertainPlusUnknown: data.job.numberOfMonthsCertainPlusUnknown,
    mostRecentCertainExperienceEnd: tryParseDate(
      data.job.mostRecentCertainExperienceEnd
    ),
    mostRecentUnknownExperienceEnd: tryParseDate(
      data.job.mostRecentUnknownExperienceEnd
    )
  };
  const industry = {
    numberOfMonthsCertain: data.industry.numberOfMonthsCertain,
    numberOfMonthsCertainPlusUnknown: data.industry.numberOfMonthsCertainPlusUnknown,
    mostRecentCertainExperienceEnd: tryParseDate(
      data.industry.mostRecentCertainExperienceEnd
    ),
    mostRecentUnknownExperienceEnd: tryParseDate(
      data.industry.mostRecentUnknownExperienceEnd
    )
  };
  const skillGroups = data.skillGroups.map((s4) => ({
    skillGroupId: s4.skillGroupId,
    numberOfMonthsCertain: s4.numberOfMonthsCertain,
    numberOfMonthsCertainPlusUnknown: s4.numberOfMonthsCertainPlusUnknown,
    mostRecentCertainExperienceEnd: tryParseDate(
      s4.mostRecentCertainExperienceEnd
    ),
    mostRecentUnknownExperienceEnd: tryParseDate(
      s4.mostRecentUnknownExperienceEnd
    )
  }));
  return {
    job,
    industry,
    skillGroups
  };
}

// src/matches/relevance/lib/MatchProfileModel.ts
function createMatchProfileModel(profile, matchRelevance, vacancy) {
  const scoringConfig = vacancy.scoringConfig;
  const relevanceAggregations = createMatchRelevanceAggregations(matchRelevance);
  const scoreResults = createApplicationScoreResults(
    relevanceAggregations,
    scoringConfig,
    vacancy.skillGroups
  );
  const experience = profile.experience.map(
    (e4) => {
      const skillGroupScores = (e4.skillGroupScores || []).map((sgs) => {
        const group = vacancy.skillGroups.getByKey(sgs.groupId);
        return new MatchExperienceSkillGroupScore(sgs, group?.name);
      });
      return {
        ...e4,
        startDate: parseDate12(e4.startDate),
        endDate: parseDate12(e4.endDate),
        occupationRelevance: createRelevance(
          e4.jobMatchScore,
          scoringConfig.relevancePositiveThreshold,
          scoringConfig.relevanceNegativeThreshold
        ),
        industryRelevance: createRelevance(
          e4.companyScore,
          scoringConfig.industryPositiveThreshold,
          scoringConfig.industryNegativeThreshold
        ),
        skillGroupScores: new KeyableSet3(
          skillGroupScores
        )
      };
    }
  );
  return {
    id: profile.id,
    vacancyId: vacancy.id,
    experience,
    scoreResults
  };
}

// src/matches/relevance/lib/MatchProfileExperienceModel.ts
import { format as format10 } from "date-fns";
function formatDescription(position) {
  return `${position.title} at ${position.companyName} from ${format10(
    position.startDate,
    "MMM y"
  )} to ${format10(position.endDate, "MMM y")}`;
}
function setRelevance(experience, scoringConfig) {
  experience.occupationRelevance = createRelevance(
    experience.jobMatchScore,
    scoringConfig.relevancePositiveThreshold,
    scoringConfig.relevanceNegativeThreshold
  );
  experience.industryRelevance = createRelevance(
    experience.companyScore,
    scoringConfig.industryPositiveThreshold,
    scoringConfig.industryNegativeThreshold
  );
}

// src/matches/relevance/lib/MatchExperienceSimilaritySearch.ts
import { groupBy as groupBy2 } from "lodash-es";
function matchExperienceByFilter2(filter2, index2, similarities) {
  const groupSentenceSimilarities = similarities.filter(
    (s4) => s4.skillGroupId === filter2.groupId
  );
  const similarityGroups = groupBy2(
    groupSentenceSimilarities.map((s4) => ({
      ...s4,
      sentence: s4.sentence.replace(new RegExp("\\\\n", "g"), "")
    })),
    (x4) => x4.experienceId
  );
  const filteredExperience = index2.filterExperiences(filter2.terms);
  const matchedExperiences = filteredExperience.filter((c4) => {
    return similarityGroups[c4.source.id] && similarityGroups[c4.source.id].length > 0;
  });
  const results = matchedExperiences.filter((context) => {
    return !!similarityGroups[context.source.id];
  }).map((context) => {
    const similarity = similarityGroups[context.source.id];
    return {
      result: context,
      similarity
    };
  });
  return results;
}

// src/matches/relevance/components/MatchRelevanceProvider.tsx
import { jsx as jsx239 } from "react/jsx-runtime";
var matchRelevanceFragmentDef = MatchRelevanceProvider_relevance_graphql_default;
var vacancyFragmentDef = MatchRelevanceProvider_vacancy_graphql_default;
var matchProfileFragmentDef = MatchRelevanceProvider_matchProfile_graphql_default;
var relevantThreshold = 0.5;
var MatchRelevanceContext = createContext10(null);
var useMatchRelevanceContext = () => {
  return useContext10(MatchRelevanceContext);
};
var MatchRelevanceProvider = ({
  sentences,
  matchProfileFragmentRef,
  matchRelevanceFragmentRef,
  vacancyFragmentRef,
  children
}) => {
  const matchProfileData = useFragment73(
    matchProfileFragmentDef,
    matchProfileFragmentRef
  );
  const matchRelevanceData = useFragment73(
    matchRelevanceFragmentDef,
    matchRelevanceFragmentRef
  );
  const vacancyData = useFragment73(
    vacancyFragmentDef,
    vacancyFragmentRef
  );
  const [showAll, toggleShowAll] = useToggle27(false);
  const [similarityThreshold, setSimilarityThreshold] = useState74(0);
  const onToggleShowAll = useCallback128(() => {
    toggleShowAll();
    if (showAll) {
      setSimilarityThreshold(0);
    } else {
      setSimilarityThreshold(relevantThreshold);
    }
  }, [showAll, toggleShowAll, setSimilarityThreshold]);
  const [selectedFilter, setSelectedFilter] = useState74(
    null
  );
  const vacancy = useMemo31(() => {
    return createVacancyModel(vacancyData);
  }, [vacancyData]);
  const filters = useMemo31(() => {
    if (!vacancy) {
      return [];
    }
    return createFiltersFromVacancy(vacancy);
  }, [vacancy]);
  const onSelectedFilterChanged = useCallback128(
    (groupId) => {
      if (!groupId) {
        setSelectedFilter(null);
        return;
      }
      if (filters == null || filters.length === 0) {
        return;
      }
      const filter2 = filters.find((f4) => f4.groupId === groupId);
      setSelectedFilter(filter2 || null);
    },
    [setSelectedFilter, filters]
  );
  const [selectedExperienceId, setSelectedExperienceId] = useState74(null);
  const onSelectExperience = useCallback128(
    (id18) => {
      setSelectedExperienceId(id18);
    },
    [setSelectedExperienceId]
  );
  const matchProfile = useMemo31(() => {
    if (!matchProfileData || !matchRelevanceData || !vacancy) {
      return null;
    }
    return createMatchProfileModel(
      matchProfileData,
      matchRelevanceData,
      vacancy
    );
  }, [matchProfileData, matchRelevanceData, vacancy]);
  const experienceIndex = useMemo31(() => {
    if (!matchProfile) {
      return new DocumentSearchIndexCollection2([]);
    }
    return new DocumentSearchIndexCollection2(matchProfile.experience);
  }, [matchProfile]);
  const sentenceSimilarities = sentences;
  return /* @__PURE__ */ jsx239(
    MatchRelevanceContext.Provider,
    {
      value: {
        relevantThreshold,
        similarityThreshold,
        sentenceSimilarities,
        showAll,
        toggleShowAll: onToggleShowAll,
        filters,
        selectedFilter,
        onSelectedFilterChanged,
        vacancy,
        matchProfile,
        experienceIndex,
        selectedExperienceId,
        onSelectExperience
      },
      children
    }
  );
};

// src/matches/relevance/components/MatchRelevanceProfileTimeline.tsx
import { Suspense as Suspense78, useCallback as useCallback129, useMemo as useMemo33 } from "react";
import { classNames as classNames28, EdSkeleton as EdSkeleton68 } from "shared-ui";
import { timeAgo as timeAgo6 } from "shared-lib";

// src/matches/relevance/lib/MatchProfileTimelines.ts
import { KeyableSet as KeyableSet4 } from "shared-lib";
function createTimelineSets(profile, vacancy) {
  if (profile === null || !profile.experience || profile.experience.length === 0) {
    return {};
  }
  const experienceWithRelevance = profile.experience.map((e4) => {
    setRelevance(e4, vacancy.scoringConfig);
    return e4;
  });
  const timeline = createMatchProfileTimeline(
    profile,
    experienceWithRelevance,
    vacancy.skillGroups
  );
  return timeline;
}
function createMatchProfileTimeline(profile, experience, skillGroups) {
  const companyTimeline = createApplicationProfileCompanyTimeline(
    profile,
    experience
  );
  const relevanceTimeline = createApplicationProfileRelevanceTimeline(
    profile,
    experience
  );
  const requiredSkillsTimeline = createApplicationSkillsTimelineScores(
    experience,
    new KeyableSet4(skillGroups.filter((s4) => s4.isRequired))
  );
  const optionalSkillsTimeline = createApplicationSkillsTimelineScores(
    experience,
    new KeyableSet4(
      skillGroups.filter((s4) => s4.isRequired === false)
    )
  );
  const timeline = {
    company: [companyTimeline],
    relevance: relevanceTimeline,
    requiredSkills: requiredSkillsTimeline,
    optionalSkills: optionalSkillsTimeline
  };
  return timeline;
}
function createApplicationSkillsTimelineScores(experience, skillGroups) {
  const timeline = skillGroups.list.map((skillGroup) => {
    const instances = [];
    (experience || []).forEach((position) => {
      if (position.skillGroupScores.items[skillGroup.id]) {
        const score = position.skillGroupScores.items[skillGroup.id];
        instances.push({
          uniqueKey: `${position.id}-${skillGroup.id}`,
          type: "Skill",
          id: skillGroup.id,
          name: position.title,
          description: `${formatDescription(position)}`,
          start: position.startDate,
          end: position.endDate,
          score,
          relevance: score.relevance,
          isRelevant: score.relevance === "Yes",
          isUnknown: score.relevance === "Unknown",
          isNotRelevant: score.relevance === "No",
          source: { position, skillGroup }
        });
      }
    });
    return {
      type: "Skill",
      id: skillGroup.id,
      name: skillGroup.name,
      description: skillGroup.name,
      isSelectable: true,
      instances,
      source: { skillGroup }
    };
  });
  return timeline;
}
function createApplicationProfileRelevanceTimeline(profile, experience) {
  const experienceTimeline = [];
  const industryTimeline = [];
  (experience || []).forEach((position) => {
    experienceTimeline.push({
      uniqueKey: `experience-${position.id}`,
      type: "Experience",
      id: position.id,
      name: position.title,
      description: `${formatDescription(position)}`,
      start: position.startDate,
      end: position.endDate,
      relevance: position.occupationRelevance,
      isRelevant: position.occupationRelevance === "Yes",
      isUnknown: position.occupationRelevance === "Unknown",
      isNotRelevant: position.occupationRelevance === "No",
      source: { position }
    });
    industryTimeline.push({
      uniqueKey: `industry-${position.id}`,
      type: "Industry",
      id: position.id,
      name: position.title,
      description: `${formatDescription(position)}`,
      start: position.startDate,
      end: position.endDate,
      industry: position.industry,
      relevance: position.industryRelevance,
      isRelevant: position.industryRelevance === "Yes",
      isUnknown: position.industryRelevance === "Unknown",
      isNotRelevant: position.industryRelevance === "No",
      source: { position }
    });
  });
  return [
    {
      type: "Experience",
      id: `experience-${profile.id}`,
      name: "Experience",
      description: "Experience",
      isSelectable: false,
      instances: experienceTimeline,
      source: { profile }
    },
    {
      type: "Industry",
      id: `industry-${profile.id}`,
      name: "Industry",
      description: "Industry",
      isSelectable: false,
      instances: industryTimeline,
      source: { profile }
    }
  ];
}
function createApplicationProfileCompanyTimeline(profile, experience) {
  const instances = experience.map((position) => {
    return {
      uniqueKey: `company-${position.id}`,
      type: "Company",
      id: position.id,
      name: position.companyName,
      description: `${formatDescription(position)}`,
      start: position.startDate,
      end: position.endDate,
      source: { position }
    };
  });
  return {
    type: "Company",
    id: `company-${profile.id}`,
    name: "Companies",
    description: "Companies",
    isSelectable: false,
    instances,
    source: { profile }
  };
}

// src/matches/relevance/components/MatchRelevanceProfileTimeline.tsx
import { jsx as jsx240, jsxs as jsxs158 } from "react/jsx-runtime";
function renderItem2(item, onSelect) {
  return /* @__PURE__ */ jsx240(TimelineItemView, { item, onSelect });
}
function renderRelevanceInstance(positioned) {
  const left = `${positioned.context.startPercentage}%`;
  const width = `${positioned.context.widthPercentage}%`;
  const relevance = positioned.instance;
  let highlightClasses = "";
  if (relevance.isRelevant) {
    highlightClasses = "h-6 bg-green-600";
  } else if (relevance.isUnknown) {
    highlightClasses = "h-6 bg-gray-300";
  } else if (relevance.isNotRelevant) {
    highlightClasses = "";
  }
  const title = `${relevance.name} - ${relevance.description} `;
  return /* @__PURE__ */ jsx240(
    "div",
    {
      title,
      style: { left, width },
      className: classNames28(
        "absolute",
        highlightClasses,
        "rounded-lg border-2 border-gray-100"
      )
    },
    positioned.instance.uniqueKey
  );
}
function renderSkillInstance2(positioned, prefix) {
  const left = `${positioned.context.startPercentage}%`;
  const width = `${positioned.context.widthPercentage}%`;
  const relevance = positioned.instance;
  let highlightClasses = "";
  if (relevance.isRelevant) {
    highlightClasses = "h-6 bg-green-600";
  } else if (relevance.isUnknown) {
    highlightClasses = "h-6 bg-gray-300";
  } else if (relevance.isNotRelevant) {
    highlightClasses = "h-4";
  }
  const title = `${positioned.instance.name} - ${timeAgo6(
    positioned.instance.start
  )} to ${timeAgo6(positioned.instance.end)} `;
  return /* @__PURE__ */ jsx240(
    "div",
    {
      title,
      style: { left, width },
      className: classNames28(
        "absolute border-white",
        highlightClasses,
        "rounded-lg border-2 border-gray-100"
      )
    },
    `${prefix}-${positioned.instance.uniqueKey}`
  );
}
function renderRequiredSkillInstance(positioned) {
  return renderSkillInstance2(positioned, "required-skill");
}
function renderOptionalSkillInstance(positioned) {
  return renderSkillInstance2(positioned, "optional-skill");
}
function renderCompanyInstance2(positioned, onSelect) {
  const left = `${positioned.context.startPercentage}%`;
  const width = `${positioned.context.widthPercentage}%`;
  const title = `${positioned.instance.name} - ${timeAgo6(
    positioned.instance.start
  )} to ${timeAgo6(positioned.instance.end)} `;
  return /* @__PURE__ */ jsx240(
    "div",
    {
      title,
      onClick: () => onSelect(positioned.instance.id),
      style: { left, width },
      className: 'text-primary-500 hover:font-bold" absolute cursor-pointer truncate rounded-lg border border-gray-100 bg-yellow-50 p-2 text-center text-sm font-medium uppercase underline',
      children: positioned.instance.name
    },
    positioned.instance.uniqueKey
  );
}
var MatchRelevanceProfileTimeline = () => {
  const relevanceContext = useMatchRelevanceContext();
  const onSelectSkill = useCallback129(
    (item) => {
      relevanceContext.onSelectedFilterChanged(item.id);
    },
    [relevanceContext]
  );
  const sourceItemSets = useMemo33(() => {
    if (!relevanceContext.matchProfile || !relevanceContext.vacancy) {
      return {
        company: [],
        relevance: [],
        requiredSkills: [],
        optionalSkills: []
      };
    }
    const timelineSets = createTimelineSets(
      relevanceContext.matchProfile,
      relevanceContext.vacancy
    );
    return timelineSets;
  }, [relevanceContext]);
  return /* @__PURE__ */ jsx240(Suspense78, { fallback: /* @__PURE__ */ jsx240(EdSkeleton68, {}), children: /* @__PURE__ */ jsxs158(TimelineProvider, { sourceItemSets, children: [
    /* @__PURE__ */ jsx240(TimelineHeader, {}),
    /* @__PURE__ */ jsx240(
      TimelineRowSet,
      {
        renderInstance: (i4) => renderCompanyInstance2(i4, relevanceContext.onSelectExperience),
        renderItem: renderItem2,
        set: "company"
      }
    ),
    /* @__PURE__ */ jsx240(
      TimelineRowSet,
      {
        renderInstance: renderRelevanceInstance,
        renderItem: renderItem2,
        set: "relevance"
      }
    ),
    /* @__PURE__ */ jsx240(
      TimelineRowSet,
      {
        renderInstance: renderRequiredSkillInstance,
        renderItem: (i4) => renderItem2(i4, onSelectSkill),
        set: "requiredSkills"
      }
    ),
    /* @__PURE__ */ jsx240(
      TimelineRowSet,
      {
        renderInstance: renderOptionalSkillInstance,
        renderItem: (i4) => renderItem2(i4, onSelectSkill),
        set: "optionalSkills"
      }
    )
  ] }) });
};

// src/matches/relevance/components/MatchExperienceSimilarityHighlighter.tsx
import { Suspense as Suspense79, useCallback as useCallback130, useState as useState75 } from "react";
import { Switch as Switch2 } from "@headlessui/react";
import { Button as Button66, Tag as Tag15, Timeline as Timeline3 } from "shared-ui";

// src/matches/relevance/components/MatchExperienceMatchedRow.tsx
import { format as format11, formatDistance as formatDistance6 } from "date-fns";
import { Tag as Tag14, classNames as classNames29 } from "shared-ui";
import { parseDate as parseDate13 } from "shared-lib";
import { jsx as jsx241, jsxs as jsxs159 } from "react/jsx-runtime";
var MatchExperienceMatchedRow = ({
  similarityGroups,
  context,
  showAll
}) => {
  const relevanceContext = useMatchRelevanceContext();
  const sentences = similarityGroups.filter((it) => {
    return it.similarity > relevanceContext.similarityThreshold;
  }).map((sentence, i4) => {
    const className = classNames29(
      sentence.similarity < relevanceContext.relevantThreshold && showAll ? "text-neutral-300" : "",
      sentence.similarity > relevanceContext.relevantThreshold ? "font-semibold" : ""
    );
    return /* @__PURE__ */ jsx241("div", { className, children: sentence.sentence }, `${context.source.id}-sentence-${i4}`);
  });
  const startDate = parseDate13(context.source?.startDate);
  const endDate = parseDate13(context.source?.endDate);
  return /* @__PURE__ */ jsxs159("div", { className: "mb-4 flex flex-col bg-white py-2 ", children: [
    /* @__PURE__ */ jsx241("div", { className: "bg-gray-700 px-4 py-5 text-white sm:px-6 md:bg-white md:text-black", children: /* @__PURE__ */ jsxs159("div", { className: "flex flex-col justify-between gap-1 md:flex-col md:flex-wrap", children: [
      /* @__PURE__ */ jsx241("div", { className: "flex items-center justify-between", children: /* @__PURE__ */ jsxs159("h3", { className: "text-lg font-medium leading-5 md:leading-10 md:text-gray-900", children: [
        context.source.title,
        " |",
        " ",
        /* @__PURE__ */ jsx241("strong", { children: context.source.companyName })
      ] }) }),
      context.source?.industry && /* @__PURE__ */ jsx241("div", { className: "flex flex-grow items-center", children: /* @__PURE__ */ jsx241("div", { children: context.source?.industry }) }),
      /* @__PURE__ */ jsx241("div", { className: "flex flex-grow items-center text-sm", children: /* @__PURE__ */ jsxs159("div", { children: [
        format11(startDate, "LLLL y"),
        " - ",
        format11(endDate, "LLLL y"),
        " (",
        formatDistance6(startDate, endDate),
        ")\xA0"
      ] }) })
    ] }) }),
    context.source.positionType && context.source.positionType != "UNKNOWN" && /* @__PURE__ */ jsx241("div", { className: "mx-5 mt-5 md:mb-5 md:mt-0", children: /* @__PURE__ */ jsx241(Tag14, { size: "xsmall", children: context.source.positionType }) }),
    /* @__PURE__ */ jsx241("div", { className: "mb-5 md:mx-5", children: /* @__PURE__ */ jsx241("div", { className: "rounded-md p-4 md:border md:bg-gray-50", children: sentences }) })
  ] }, context.source.id);
};

// src/matches/relevance/components/MatchExperienceSimilarityHighlighter.tsx
import { jsx as jsx243, jsxs as jsxs160 } from "react/jsx-runtime";
var MatchExperienceSimilarityHighlighter = () => {
  const relevanceContext = useMatchRelevanceContext();
  const { selectedFilter } = relevanceContext;
  const [profileIndex, setProfileIndex] = useState75(() => {
    return {
      filteredExperiences: [],
      sentenceHighlightingEnabled: false
    };
  });
  const onSelectSkillGroup = useCallback130(
    ({ groupId }) => {
      console.log("onSelectSkillGroup", groupId);
      relevanceContext.onSelectedFilterChanged(groupId);
    },
    [relevanceContext]
  );
  const onClearSkillGroup = useCallback130(() => {
    relevanceContext.onSelectedFilterChanged(null);
  }, []);
  let matchedRows = /* @__PURE__ */ jsx243("div", { className: "flex h-40 w-full items-center justify-center border bg-gray-100", children: /* @__PURE__ */ jsx243("div", { children: "Select a Skill Group from the Timeline" }) });
  if (selectedFilter && relevanceContext.experienceIndex && relevanceContext.sentenceSimilarities) {
    const results = matchExperienceByFilter2(
      selectedFilter,
      relevanceContext.experienceIndex,
      relevanceContext.sentenceSimilarities
    );
    matchedRows = results.map((result) => {
      return /* @__PURE__ */ jsx243(
        MatchExperienceMatchedRow,
        {
          similarityGroups: result.similarity,
          context: result.result,
          showAll: relevanceContext.showAll
        },
        result.result.source.id
      );
    });
  }
  const terms = (selectedFilter?.terms || []).map((t4) => {
    return /* @__PURE__ */ jsx243(Tag15, { color: `bg-gray-200`, children: t4 }, t4);
  });
  return /* @__PURE__ */ jsx243(Suspense79, { fallback: /* @__PURE__ */ jsx243("div", { children: "Loading Experience..." }), children: /* @__PURE__ */ jsxs160("div", { className: "m-0 p-2", children: [
    selectedFilter && /* @__PURE__ */ jsxs160("div", { className: "flex flex-col rounded border bg-white sm:p-4 md:px-8", children: [
      /* @__PURE__ */ jsxs160("div", { className: "flex items-center justify-between", children: [
        /* @__PURE__ */ jsx243("div", { children: /* @__PURE__ */ jsxs160("strong", { className: "text-primary-400 text-2xl uppercase", children: [
          "Skill group: ",
          selectedFilter.groupName
        ] }) }),
        /* @__PURE__ */ jsx243("div", { className: "flex-1" }),
        /* @__PURE__ */ jsx243("div", { className: "flex items-center justify-end space-x-4", children: /* @__PURE__ */ jsx243(Button66, { color: "primary", clicked: onClearSkillGroup, children: "Clear" }) })
      ] }),
      /* @__PURE__ */ jsx243("div", { className: "mt-3 flex flex-wrap items-center gap-2 border-t pt-3", children: terms })
    ] }),
    /* @__PURE__ */ jsxs160("div", { className: "mt-3 flex flex-col gap-2", children: [
      /* @__PURE__ */ jsx243("p", { className: "p-2 py-4 text-lg font-bold text-neutral-900", children: "Highlighting Work History according to selected Skill Group" }),
      /* @__PURE__ */ jsxs160(
        "div",
        {
          className: "flex cursor-pointer items-center gap-2 p-2 text-sm",
          onClick: relevanceContext.toggleShowAll,
          children: [
            /* @__PURE__ */ jsx243(
              Switch2,
              {
                checked: relevanceContext.showAll,
                className: `${relevanceContext.showAll ? "bg-primary-600" : "bg-gray-200"} relative inline-flex h-6 w-11 items-center rounded-full`,
                children: /* @__PURE__ */ jsx243(
                  "span",
                  {
                    className: `${relevanceContext.showAll ? "translate-x-6" : "translate-x-1"} inline-block h-4 w-4 transform rounded-full bg-white transition`
                  }
                )
              }
            ),
            "Only Show Matching Sentences"
          ]
        }
      )
    ] }),
    /* @__PURE__ */ jsx243("div", { className: "mt-3", children: /* @__PURE__ */ jsxs160("div", { className: "flex pb-3 pt-2", children: [
      /* @__PURE__ */ jsx243("div", { className: "flex-1", children: matchedRows }),
      /* @__PURE__ */ jsx243("div", { className: "sticky top-0 ml-2 h-screen bg-white sm:w-1/4", children: /* @__PURE__ */ jsxs160("div", { className: "relative p-5", children: [
        /* @__PURE__ */ jsx243("p", { className: "text-lg font-bold text-neutral-700", children: "Highlighting" }),
        /* @__PURE__ */ jsxs160("p", { className: "my-2 text-neutral-500", children: [
          "Click on a Skill Group below to",
          " ",
          /* @__PURE__ */ jsx243("span", { className: "font-medium", children: "Highlight" })
        ] }),
        /* @__PURE__ */ jsx243(
          Timeline3,
          {
            list: relevanceContext.filters.map((x4) => {
              const durationAmount = x4?.groupExperience && x4.groupExperience?.durationAmount;
              const durationType = x4?.groupExperience?.durationType;
              const bodyContent = `${durationAmount ? `${durationAmount} ${durationAmount > 1 ? durationType : durationType?.replace("s", "")}` : ""}`;
              return {
                title: x4?.groupName,
                body: bodyContent,
                isActive: true,
                isSelected: false,
                isCompleted: false,
                onClick: () => onSelectSkillGroup(x4)
              };
            })
          }
        )
      ] }) })
    ] }) })
  ] }) });
};

// src/matches/relevance/components/MatchRelevanceScoreResult.tsx
import { jsx as jsx244, jsxs as jsxs161 } from "react/jsx-runtime";
var MatchRelevanceScoreResult = ({ score }) => {
  return /* @__PURE__ */ jsx244("div", { className: "flex h-full flex-col justify-between bg-white px-4", children: /* @__PURE__ */ jsxs161("div", { className: "items-top flex items-center justify-between", children: [
    /* @__PURE__ */ jsxs161("div", { className: "flex flex-col", children: [
      /* @__PURE__ */ jsx244("div", { className: "flex pb-4 lg:pb-0", children: /* @__PURE__ */ jsx244("p", { className: "mr-4 whitespace-nowrap text-base leading-4 text-gray-500", children: score.name }) }),
      score.confirmedExperienceDesc && /* @__PURE__ */ jsx244("p", { className: "mt-1 text-base text-gray-900", children: score.confirmedExperienceDesc }),
      !score.confirmedExperienceDesc && /* @__PURE__ */ jsx244("p", { className: "mt-1 text-base text-gray-900", children: "Experience Unclear" })
    ] }),
    /* @__PURE__ */ jsx244(SignalBarComponent, { state: score.fulfillsRequirements })
  ] }) });
};

// src/matches/relevance/components/MatchRelevanceSkillScoreResults.tsx
import { SignalBar as SignalBar3, SignalBarSize as SignalBarSize3 } from "shared-ui";
import { Fragment as Fragment57, jsx as jsx245, jsxs as jsxs163 } from "react/jsx-runtime";
var MatchRelevanceSkillScoreResults = ({
  skillGroupScores
}) => {
  const totalCount = skillGroupScores.length;
  const relevantCount = skillGroupScores.filter((s4) => {
    return s4.fulfillsRequirements && s4.fulfillsRequirements === "Yes";
  }).length;
  const relevantPercentage = relevantCount / totalCount;
  const allRelevant = totalCount === relevantCount;
  let signalBar = /* @__PURE__ */ jsx245(Fragment57, {});
  if (relevantPercentage < 0.2) {
    signalBar = /* @__PURE__ */ jsx245("div", { className: "text-red-400", children: /* @__PURE__ */ jsx245(SignalBar3, { signalSize: SignalBarSize3.signalBar0, iconSize: "lg" }) });
  } else if (relevantPercentage >= 0.2 && relevantPercentage < 0.4) {
    signalBar = /* @__PURE__ */ jsx245("div", { className: "text-red-400", children: /* @__PURE__ */ jsx245(SignalBar3, { signalSize: SignalBarSize3.signalBar1, iconSize: "lg" }) });
  } else if (relevantPercentage >= 0.4 && relevantPercentage < 0.6) {
    signalBar = /* @__PURE__ */ jsx245("div", { className: "text-gray-400", children: /* @__PURE__ */ jsx245(SignalBar3, { signalSize: SignalBarSize3.signalBar2, iconSize: "lg" }) });
  } else if (relevantPercentage >= 0.6 && relevantPercentage < 0.8) {
    signalBar = /* @__PURE__ */ jsx245("div", { className: "text-gray-400", children: /* @__PURE__ */ jsx245(SignalBar3, { signalSize: SignalBarSize3.signalBar3, iconSize: "lg" }) });
  } else if (relevantPercentage >= 0.8 && relevantPercentage < 1) {
    signalBar = /* @__PURE__ */ jsx245("div", { className: "text-green-600", children: /* @__PURE__ */ jsx245(SignalBar3, { signalSize: SignalBarSize3.signalBar4, iconSize: "lg" }) });
  } else if (relevantPercentage === 1) {
    signalBar = /* @__PURE__ */ jsx245("div", { className: "text-green-600", children: /* @__PURE__ */ jsx245(SignalBar3, { signalSize: SignalBarSize3.signalBar5, iconSize: "lg" }) });
  }
  return /* @__PURE__ */ jsx245("div", { className: "flex h-full flex-col justify-between bg-white px-4", children: /* @__PURE__ */ jsxs163("div", { className: "items-top flex items-center justify-between", children: [
    /* @__PURE__ */ jsxs163("div", { className: "flex flex-col justify-center", children: [
      /* @__PURE__ */ jsx245("div", { className: "flex pb-4 lg:pb-0", children: /* @__PURE__ */ jsx245("p", { className: "mr-4 whitespace-nowrap text-base leading-4 text-gray-500", children: "Required Skill Groups" }) }),
      /* @__PURE__ */ jsxs163("p", { className: "mt-1 text-base text-gray-900", children: [
        "Relevant ",
        relevantCount,
        " of ",
        totalCount
      ] })
    ] }),
    signalBar
  ] }) });
};

// src/matches/relevance/components/MatchRelevanceScores.tsx
import { jsx as jsx246, jsxs as jsxs164 } from "react/jsx-runtime";
var MatchRelevanceScores = () => {
  const relevanceContext = useMatchRelevanceContext();
  if (!relevanceContext.matchProfile?.scoreResults) {
    return /* @__PURE__ */ jsx246("div", {});
  }
  const { matchProfile } = relevanceContext;
  return /* @__PURE__ */ jsxs164("div", { className: "flex w-full flex-col items-center gap-2 divide-y border-y lg:divide-y-0 lg:border-y-0 xl:flex-row", children: [
    /* @__PURE__ */ jsx246(SkillWrapper, { children: /* @__PURE__ */ jsx246(MatchRelevanceScoreResult, { score: matchProfile.scoreResults.jobScore }) }),
    /* @__PURE__ */ jsx246(SkillWrapper, { children: /* @__PURE__ */ jsx246(
      MatchRelevanceScoreResult,
      {
        score: matchProfile.scoreResults.industryScore
      }
    ) }),
    /* @__PURE__ */ jsx246(SkillWrapper, { children: /* @__PURE__ */ jsx246(
      MatchRelevanceSkillScoreResults,
      {
        skillGroupScores: matchProfile.scoreResults.skillGroupScores
      }
    ) })
  ] });
};
var SkillWrapper = ({ children }) => {
  return /* @__PURE__ */ jsx246("div", { className: "flex w-full flex-col py-4 ring-gray-200 lg:rounded-xl lg:ring-1", children });
};

// src/matches/relevance/components/MatchRelevanceProfileTimelineGrid.tsx
import { Suspense as Suspense80, useMemo as useMemo34 } from "react";
import { EdSkeleton as EdSkeleton69, SignalBar as SignalBar4, SignalBarSize as SignalBarSize4 } from "shared-ui";
import { jsx as jsx247, jsxs as jsxs165 } from "react/jsx-runtime";
var MatchRelevanceProfileTimelineGrid = () => {
  const relevanceContext = useMatchRelevanceContext();
  return /* @__PURE__ */ jsx247(
    MatchRelevanceProfileTimelineGridComponent,
    {
      matchProfile: relevanceContext.matchProfile,
      vacancy: relevanceContext.vacancy
    }
  );
};
var MatchRelevanceProfileTimelineGridComponent = ({
  matchProfile,
  vacancy
}) => {
  const sourceItemSets = useMemo34(() => {
    if (!matchProfile || !vacancy) {
      return {
        company: [],
        relevance: [],
        requiredSkills: [],
        optionalSkills: []
      };
    }
    const timelineSets = createTimelineSets(matchProfile, vacancy);
    return timelineSets;
  }, [matchProfile, vacancy]);
  return /* @__PURE__ */ jsx247(Suspense80, { fallback: /* @__PURE__ */ jsx247(EdSkeleton69, {}), children: sourceItemSets.company.map((item) => {
    return /* @__PURE__ */ jsx247("div", { className: "flex flex-col gap-3", children: item.instances.map((instance) => {
      return /* @__PURE__ */ jsx247(
        Relevance,
        {
          vacancy,
          instance
        },
        instance.id
      );
    }) }, item.id);
  }) });
};
var Relevance = ({
  instance,
  vacancy
}) => {
  const requiredSkillGroupNames = useMemo34(() => {
    return Object.values(vacancy?.skillGroups.items).filter((x4) => x4.isRequired).map((x4) => x4.name);
  }, [vacancy]);
  const mappedFields = (instance2) => {
    const scoredFields = instance2.source.position.skillGroupScores.list.reduce(
      (a4, c4) => {
        a4[c4.groupName] = c4.relevance;
        return a4;
      },
      {}
    );
    return {
      ...scoredFields
    };
  };
  return /* @__PURE__ */ jsxs165("div", { className: "divide-y rounded border", children: [
    /* @__PURE__ */ jsxs165("div", { className: "flex w-full items-center justify-between bg-gray-50 p-5", children: [
      /* @__PURE__ */ jsx247("div", { className: "text-lg", children: instance.name }),
      /* @__PURE__ */ jsx247(
        SignalBarComponent,
        {
          state: instance.source.position.occupationRelevance,
          size: "md"
        }
      )
    ] }),
    Object.entries(mappedFields(instance)).filter(([key]) => requiredSkillGroupNames.includes(key)).map(([key, value]) => /* @__PURE__ */ jsxs165("div", { className: "flex w-full justify-between p-5 text-sm", children: [
      /* @__PURE__ */ jsx247("span", { children: key }),
      /* @__PURE__ */ jsxs165("span", { children: [
        value === "Yes" && /* @__PURE__ */ jsx247("div", { className: "text-green-500", children: /* @__PURE__ */ jsx247(
          SignalBar4,
          {
            signalSize: SignalBarSize4.signalBar5,
            iconSize: "sm"
          }
        ) }),
        value === "No" && /* @__PURE__ */ jsxs165("div", { className: "text-red-500", children: [
          " ",
          /* @__PURE__ */ jsx247(
            SignalBar4,
            {
              signalSize: SignalBarSize4.signalBar0,
              iconSize: "sm"
            }
          )
        ] }),
        value === "Unknown" && /* @__PURE__ */ jsx247(
          SignalBar4,
          {
            signalSize: SignalBarSize4.signalBar3,
            iconSize: "sm"
          }
        )
      ] })
    ] }, key))
  ] });
};

// src/matches/recruiter/components/MatchRoute.tsx
import { Navigate as Navigate10 } from "react-router-dom";
import { ErrorContainer as ErrorContainer12 } from "shared-ui";

// src/matches/recruiter/components/__generated__/MatchLayoutQuery.graphql.ts
var node264 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "matchCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "matchCode"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdOn",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "email",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "concreteType": "CandidatePhoneVerification",
    "kind": "LinkedField",
    "name": "phone",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "phoneCountryCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "phoneCountryPrefix",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "phoneNumber",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "emailAddress",
    "storageKey": null
  }, v10 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "MatchLayoutQuery",
      "selections": [
        {
          "alias": "match",
          "args": v1,
          "concreteType": "RecruitVacancyProfileMatch",
          "kind": "LinkedField",
          "name": "recruitVacancyProfileMatchByCode",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "candidate",
              "plural": false,
              "selections": [
                v5,
                v6
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Vacancy",
              "kind": "LinkedField",
              "name": "vacancy",
              "plural": false,
              "selections": [
                v32
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfile",
              "kind": "LinkedField",
              "name": "profile",
              "plural": false,
              "selections": [
                v7,
                v8,
                v9,
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "RecruitProfileHeader_profile"
                }
              ],
              "storageKey": null
            },
            v10
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "MatchLayoutQuery",
      "selections": [
        {
          "alias": "match",
          "args": v1,
          "concreteType": "RecruitVacancyProfileMatch",
          "kind": "LinkedField",
          "name": "recruitVacancyProfileMatchByCode",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "candidate",
              "plural": false,
              "selections": [
                v5,
                v6,
                v23
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Vacancy",
              "kind": "LinkedField",
              "name": "vacancy",
              "plural": false,
              "selections": [
                v32,
                v23
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfile",
              "kind": "LinkedField",
              "name": "profile",
              "plural": false,
              "selections": [
                v7,
                v8,
                v9,
                v23,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileWorkLocations",
                  "kind": "LinkedField",
                  "name": "workLocations",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currentLocationName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currentLocationCountryName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "WorkLocationEntry",
                      "kind": "LinkedField",
                      "name": "workLocations",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    v23
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperience",
                  "kind": "LinkedField",
                  "name": "currentPosition",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "title",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "companyName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "startDate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "endDate",
                      "storageKey": null
                    },
                    v23
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileRate",
                  "kind": "LinkedField",
                  "name": "rate",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "payType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "minimumRateOfPay",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "maximumRateOfPay",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "countryCode",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currencyCode",
                      "storageKey": null
                    },
                    v23
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileAvailability",
                  "kind": "LinkedField",
                  "name": "availability",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobSearchStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "availabilityStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "NoticeCriteria",
                      "kind": "LinkedField",
                      "name": "noticeCriteria",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "availableFrom",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "noticePeriodWeeks",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "noticeTimeframe",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    v23
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "recruitProfileId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "profileType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsCandidateAccount",
                  "kind": "LinkedField",
                  "name": "account",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "accountId",
                      "storageKey": null
                    },
                    v23
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RightToWork",
                  "kind": "LinkedField",
                  "name": "rightToWork",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    v23
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v10
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "70752bb5afd78d5bf3a1ecfc041fd5fb",
      "id": null,
      "metadata": {},
      "name": "MatchLayoutQuery",
      "operationKind": "query",
      "text": "query MatchLayoutQuery(\n  $matchCode: Int!\n) {\n  match: recruitVacancyProfileMatchByCode(code: $matchCode) {\n    id\n    code\n    createdOn\n    candidate {\n      email\n      phone {\n        phoneCountryCode\n        phoneCountryPrefix\n        phoneNumber\n      }\n      id\n    }\n    vacancy {\n      code\n      id\n    }\n    profile {\n      firstName\n      lastName\n      emailAddress\n      ...RecruitProfileHeader_profile\n      id\n    }\n  }\n}\n\nfragment RecruitProfileApplicationHeader_application on RecruitProfile {\n  id\n  firstName\n  lastName\n  workLocations {\n    currentLocationName\n    currentLocationCountryName\n    workLocations {\n      name\n    }\n    id\n  }\n  currentPosition {\n    title\n    companyName\n    startDate\n    endDate\n    id\n  }\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n  availability {\n    jobSearchStatus\n    availabilityStatus\n    noticeCriteria {\n      availableFrom\n      noticePeriodWeeks\n      noticeTimeframe\n    }\n    id\n  }\n}\n\nfragment RecruitProfileHeader_profile on RecruitProfile {\n  ...RecruitProfileApplicationHeader_application\n  id\n  recruitProfileId\n  firstName\n  lastName\n  profileType\n  workLocations {\n    currentLocationName\n    currentLocationCountryName\n    id\n  }\n  account {\n    accountId\n    id\n  }\n  currentPosition {\n    title\n    companyName\n    startDate\n    endDate\n    id\n  }\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n  rightToWork {\n    status\n    id\n  }\n  availability {\n    jobSearchStatus\n    id\n  }\n}\n"
    }
  };
}();
node264.hash = "780a762886a1c38ec4d4f4dad9a73f26";
var MatchLayoutQuery_graphql_default = node264;

// src/matches/recruiter/components/MatchLayout.tsx
import { Suspense as Suspense81, useMemo as useMemo35 } from "react";
import {
  Link as Link13,
  Outlet as Outlet9,
  useLoaderData as useLoaderData3,
  useLocation as useLocation4,
  useParams as useParams9,
  useRouteLoaderData as useRouteLoaderData13
} from "react-router-dom";
import {
  loadQuery as loadQuery20,
  usePreloadedQuery as usePreloadedQuery25
} from "react-relay";
import {
  createLinkState as createLinkState4,
  DynamicBreadcrumb as DynamicBreadcrumb3,
  EdSkeleton as EdSkeleton71,
  Tabs as Tabs4
} from "shared-ui";

// src/matches/recruiter/components/__generated__/MatchProfileRelevanceProviderQuery.graphql.ts
var node265 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "matchCode"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "vacancyCode"
  }, v23 = [
    {
      "kind": "Literal",
      "name": "experienceIds",
      "value": []
    },
    {
      "kind": "Variable",
      "name": "matchCode",
      "variableName": "matchCode"
    },
    {
      "kind": "Literal",
      "name": "skillGroupIds",
      "value": []
    },
    {
      "kind": "Variable",
      "name": "vacancyCode",
      "variableName": "vacancyCode"
    }
  ], v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "experienceId",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "sentence",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "sentenceIndex",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "similarity",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "skillGroupId",
    "storageKey": null
  }, v9 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "matchCode"
    }
  ], v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyScore",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "jobMatchScore",
    "storageKey": null
  }, v14 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "totalScore",
    "storageKey": null
  }, v15 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }, v16 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "numberOfMonthsCertain",
    "storageKey": null
  }, v17 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "numberOfMonthsCertainPlusUnknown",
    "storageKey": null
  }, v18 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "mostRecentCertainExperienceEnd",
    "storageKey": null
  }, v19 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "mostRecentUnknownExperienceEnd",
    "storageKey": null
  }, v20 = [
    v16,
    v17,
    v18,
    v19
  ], v21 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "weight",
    "storageKey": null
  }, v222 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v232 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationAmount",
    "storageKey": null
  }, v24 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationType",
    "storageKey": null
  }, v25 = [
    v232,
    v24
  ];
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "MatchProfileRelevanceProviderQuery",
      "selections": [
        {
          "alias": "results",
          "args": v23,
          "concreteType": "SentenceSimilarity",
          "kind": "LinkedField",
          "name": "recruitVacancyGetSentenceSimilaritiesForMatch",
          "plural": true,
          "selections": [
            v32,
            v4,
            v5,
            v6,
            v7,
            v8,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "MatchRelevanceProvider_sentences"
            }
          ],
          "storageKey": null
        },
        {
          "alias": "match",
          "args": v9,
          "concreteType": "RecruitVacancyProfileMatch",
          "kind": "LinkedField",
          "name": "recruitVacancyProfileMatchByCode",
          "plural": false,
          "selections": [
            v10,
            v11,
            v12,
            v13,
            v14,
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitMatchRelevanceContainer",
              "kind": "LinkedField",
              "name": "matchRelevance",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "MatchRelevanceProvider_relevance"
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitMatchProfile",
              "kind": "LinkedField",
              "name": "matchProfile",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "MatchRelevanceProvider_matchProfile"
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Vacancy",
              "kind": "LinkedField",
              "name": "vacancy",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "MatchRelevanceProvider_vacancy"
                }
              ],
              "storageKey": null
            },
            v15
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "MatchProfileRelevanceProviderQuery",
      "selections": [
        {
          "alias": "results",
          "args": v23,
          "concreteType": "SentenceSimilarity",
          "kind": "LinkedField",
          "name": "recruitVacancyGetSentenceSimilaritiesForMatch",
          "plural": true,
          "selections": [
            v32,
            v4,
            v5,
            v6,
            v7,
            v8
          ],
          "storageKey": null
        },
        {
          "alias": "match",
          "args": v9,
          "concreteType": "RecruitVacancyProfileMatch",
          "kind": "LinkedField",
          "name": "recruitVacancyProfileMatchByCode",
          "plural": false,
          "selections": [
            v10,
            v11,
            v12,
            v13,
            v14,
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitMatchRelevanceContainer",
              "kind": "LinkedField",
              "name": "matchRelevance",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitMatchSkillRelevance",
                  "kind": "LinkedField",
                  "name": "skillGroups",
                  "plural": true,
                  "selections": [
                    v8,
                    v16,
                    v17,
                    v18,
                    v19
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitMatchRelevance",
                  "kind": "LinkedField",
                  "name": "industry",
                  "plural": false,
                  "selections": v20,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitMatchRelevance",
                  "kind": "LinkedField",
                  "name": "job",
                  "plural": false,
                  "selections": v20,
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitMatchProfile",
              "kind": "LinkedField",
              "name": "matchProfile",
              "plural": false,
              "selections": [
                v10,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "vacancyId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitMatchProfileExperience",
                  "kind": "LinkedField",
                  "name": "experience",
                  "plural": true,
                  "selections": [
                    v10,
                    v11,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "version",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "titleId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "title",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "industry",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "companyIsVerified",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "companyId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "companyName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "startDate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "endDate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "positionType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "MatchProfileExperienceSkillGroupScore",
                      "kind": "LinkedField",
                      "name": "skillGroupScores",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "groupId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "hasMatch",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "minSkillGroupScore",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "score",
                          "storageKey": null
                        },
                        v21
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "escoOccupationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "escoHierarchy",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobMatchWeight",
                      "storageKey": null
                    },
                    v13,
                    v12,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "companyScoreWeight",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasCompanyVector",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Vacancy",
              "kind": "LinkedField",
              "name": "vacancy",
              "plural": false,
              "selections": [
                v10,
                v11,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SkillGroup",
                  "kind": "LinkedField",
                  "name": "skillGroups",
                  "plural": true,
                  "selections": [
                    v10,
                    v8,
                    v222,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isRequired",
                      "storageKey": null
                    },
                    v21,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "SkillGroupTerm",
                      "kind": "LinkedField",
                      "name": "terms",
                      "plural": true,
                      "selections": [
                        v222,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isSkill",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Duration",
                      "kind": "LinkedField",
                      "name": "experience",
                      "plural": false,
                      "selections": v25,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Duration",
                      "kind": "LinkedField",
                      "name": "recency",
                      "plural": false,
                      "selections": [
                        v24,
                        v232
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "VacancyScoringConfig",
                  "kind": "LinkedField",
                  "name": "scoringConfig",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Duration",
                      "kind": "LinkedField",
                      "name": "industryExperience",
                      "plural": false,
                      "selections": v25,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "industryNegativeThreshold",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "industryPositiveThreshold",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Duration",
                      "kind": "LinkedField",
                      "name": "industryRecency",
                      "plural": false,
                      "selections": v25,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "relevanceNegativeThreshold",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "relevancePositiveThreshold",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Duration",
                      "kind": "LinkedField",
                      "name": "relevantExperience",
                      "plural": false,
                      "selections": v25,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Duration",
                      "kind": "LinkedField",
                      "name": "relevantRecency",
                      "plural": false,
                      "selections": v25,
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v15
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "fc45e7a20e96e5f95e0a8dcbc943af30",
      "id": null,
      "metadata": {},
      "name": "MatchProfileRelevanceProviderQuery",
      "operationKind": "query",
      "text": "query MatchProfileRelevanceProviderQuery(\n  $vacancyCode: Int!\n  $matchCode: Int!\n) {\n  results: recruitVacancyGetSentenceSimilaritiesForMatch(vacancyCode: $vacancyCode, matchCode: $matchCode, experienceIds: [], skillGroupIds: []) {\n    candidateId\n    experienceId\n    sentence\n    sentenceIndex\n    similarity\n    skillGroupId\n    ...MatchRelevanceProvider_sentences\n  }\n  match: recruitVacancyProfileMatchByCode(code: $matchCode) {\n    id\n    code\n    companyScore\n    jobMatchScore\n    totalScore\n    matchRelevance {\n      ...MatchRelevanceProvider_relevance\n    }\n    matchProfile {\n      ...MatchRelevanceProvider_matchProfile\n    }\n    vacancy {\n      ...MatchRelevanceProvider_vacancy\n      id\n    }\n  }\n}\n\nfragment MatchRelevanceProvider_matchProfile on RecruitMatchProfile {\n  id\n  vacancyId\n  experience {\n    id\n    code\n    version\n    titleId\n    title\n    industry\n    companyIsVerified\n    companyId\n    companyName\n    description\n    startDate\n    endDate\n    positionType\n    skillGroupScores {\n      groupId\n      hasMatch\n      minSkillGroupScore\n      score\n      weight\n    }\n    escoOccupationId\n    escoHierarchy\n    jobMatchWeight\n    jobMatchScore\n    companyScore\n    companyScoreWeight\n    hasCompanyVector\n  }\n}\n\nfragment MatchRelevanceProvider_relevance on RecruitMatchRelevanceContainer {\n  skillGroups {\n    skillGroupId\n    numberOfMonthsCertain\n    numberOfMonthsCertainPlusUnknown\n    mostRecentCertainExperienceEnd\n    mostRecentUnknownExperienceEnd\n  }\n  industry {\n    numberOfMonthsCertain\n    numberOfMonthsCertainPlusUnknown\n    mostRecentCertainExperienceEnd\n    mostRecentUnknownExperienceEnd\n  }\n  job {\n    numberOfMonthsCertain\n    numberOfMonthsCertainPlusUnknown\n    mostRecentCertainExperienceEnd\n    mostRecentUnknownExperienceEnd\n  }\n}\n\nfragment MatchRelevanceProvider_sentences on SentenceSimilarity {\n  candidateId\n  experienceId\n  sentence\n  sentenceIndex\n  similarity\n  skillGroupId\n}\n\nfragment MatchRelevanceProvider_vacancy on Vacancy {\n  id\n  code\n  skillGroups {\n    id\n    skillGroupId\n    name\n    isRequired\n    weight\n    terms {\n      name\n      isSkill\n    }\n    experience {\n      durationAmount\n      durationType\n    }\n    recency {\n      durationType\n      durationAmount\n    }\n  }\n  scoringConfig {\n    industryExperience {\n      durationAmount\n      durationType\n    }\n    industryNegativeThreshold\n    industryPositiveThreshold\n    industryRecency {\n      durationAmount\n      durationType\n    }\n    relevanceNegativeThreshold\n    relevancePositiveThreshold\n    relevantExperience {\n      durationAmount\n      durationType\n    }\n    relevantRecency {\n      durationAmount\n      durationType\n    }\n  }\n}\n"
    }
  };
}();
node265.hash = "d9dc9eadda3f76b61922a878f25468c9";
var MatchProfileRelevanceProviderQuery_graphql_default = node265;

// src/matches/recruiter/components/MatchProfileRelevanceProvider.tsx
import { useLazyLoadQuery as useLazyLoadQuery35 } from "react-relay";
import { EdSkeleton as EdSkeleton70 } from "shared-ui";
import { jsx as jsx248 } from "react/jsx-runtime";
var queryDef36 = MatchProfileRelevanceProviderQuery_graphql_default;
var MatchProfileRelevanceProvider = ({
  vacancyCode,
  matchCode,
  children
}) => {
  const query3 = useLazyLoadQuery35(
    queryDef36,
    {
      vacancyCode,
      matchCode
    },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { match } = query3;
  if (!match || !match.matchProfile || !match.matchRelevance) {
    return /* @__PURE__ */ jsx248(EdSkeleton70, {});
  }
  const { matchProfile, matchRelevance, vacancy } = match;
  return /* @__PURE__ */ jsx248(
    MatchRelevanceProvider,
    {
      sentences: query3.results,
      matchProfileFragmentRef: matchProfile,
      matchRelevanceFragmentRef: matchRelevance,
      vacancyFragmentRef: vacancy,
      children
    }
  );
};

// src/matches/recruiter/components/MatchLayout.tsx
import { Fragment as Fragment58, jsx as jsx249, jsxs as jsxs166 } from "react/jsx-runtime";
var routeId2 = "application-search-home";
var candidateMatchLayoutQueryDef = MatchLayoutQuery_graphql_default;
var tabs3 = [
  { name: "Relevance", to: "relevance" },
  { name: "Work History", to: "profile" },
  { name: "Details", to: "details" }
];
var MatchLayout = ({ showHeader }) => {
  const params = useParams9();
  const preloadedQuery = useLoaderData3();
  const data = usePreloadedQuery25(candidateMatchLayoutQueryDef, preloadedQuery);
  const location2 = useLocation4();
  const tabLinks = tabs3.map((tab) => {
    return createLinkState4(location2, tab.name, tab.to);
  });
  const { match } = data;
  const currentPath = useMemo35(
    () => location2.pathname.slice(
      location2.pathname.lastIndexOf("/"),
      location2.pathname.length
    ),
    [location2.pathname]
  );
  const currentEnvironment = useMemo35(() => {
    return location2.pathname.split("/")[1];
  }, [location2.pathname]);
  if (!match) {
    return /* @__PURE__ */ jsx249(EdSkeleton71, {});
  }
  if (!match.profile) {
    return /* @__PURE__ */ jsx249("div", { className: "border-b bg-white p-4", children: /* @__PURE__ */ jsx249("div", { className: "text-primary-500 text-xl", children: "No Profile Available for Match" }) });
  }
  return /* @__PURE__ */ jsx249(Suspense81, { fallback: "Loading...", children: /* @__PURE__ */ jsxs166("div", { className: "@container flex flex-1 flex-col overflow-scroll", children: [
    showHeader && /* @__PURE__ */ jsx249("div", { className: "flex flex-wrap items-center justify-between border-b bg-white", children: /* @__PURE__ */ jsx249(DynamicBreadcrumb3, {}) }),
    /* @__PURE__ */ jsxs166("div", { className: "items-top @7xl:flex-row flex justify-between gap-2 border-b bg-white p-5", children: [
      /* @__PURE__ */ jsx249(
        RecruitProfileHeader,
        {
          fragmentRef: match.profile,
          expandLink: `/${currentEnvironment}/app/vacancies/view/${match.vacancy.code}/match/${match.code}${currentPath}`
        }
      ),
      /* @__PURE__ */ jsx249(
        MatchProfileRelevanceProvider,
        {
          vacancyCode: Number(params.vacancyCode),
          matchCode: Number(params.matchCode),
          children: /* @__PURE__ */ jsx249(MatchRelevanceScores, {})
        }
      )
    ] }),
    /* @__PURE__ */ jsx249("div", { className: "flex flex-wrap items-center justify-between gap-2 bg-white p-5", children: /* @__PURE__ */ jsx249(Tabs4, { tabs: tabLinks }) }),
    /* @__PURE__ */ jsx249(Outlet9, {})
  ] }) });
};
var MatchLink = ({ routeId: routeId4, label }) => {
  const data = useMatchSearchRouteData(routeId4);
  const { match } = data;
  if (!match) {
    return /* @__PURE__ */ jsx249(Fragment58, {});
  }
  const { profile } = match;
  if (!profile) {
    return /* @__PURE__ */ jsx249(Fragment58, {});
  }
  const name = `${profile.firstName} ${profile.lastName}`;
  return /* @__PURE__ */ jsx249(Suspense81, { fallback: "Loading...", children: /* @__PURE__ */ jsx249(Link13, { to: ".", children: label || name }) });
};
async function loader16(environment, params) {
  const code = params.matchCode;
  const matchCode = parseInt(code);
  return loadQuery20(
    environment,
    candidateMatchLayoutQueryDef,
    {
      matchCode
    }
  );
}
function useMatchSearchRouteData(routeId4) {
  const queryRef3 = useRouteLoaderData13(
    routeId4
  );
  const data = usePreloadedQuery25(
    candidateMatchLayoutQueryDef,
    queryRef3
  );
  return data;
}

// src/matches/recruiter/components/__generated__/MatchRootRouteQuery.graphql.ts
var node266 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "matchCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "matchCode"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdOn",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "email",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "concreteType": "CandidatePhoneVerification",
    "kind": "LinkedField",
    "name": "phone",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "phoneCountryCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "phoneCountryPrefix",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "phoneNumber",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v9 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "MatchRootRouteQuery",
      "selections": [
        {
          "alias": "match",
          "args": v1,
          "concreteType": "RecruitVacancyProfileMatch",
          "kind": "LinkedField",
          "name": "recruitVacancyProfileMatchByCode",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "candidate",
              "plural": false,
              "selections": [
                v5,
                v6,
                v7,
                v8
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfile",
              "kind": "LinkedField",
              "name": "profile",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperience",
                  "kind": "LinkedField",
                  "name": "currentPosition",
                  "plural": false,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "ExperienceViewer_profile"
                    }
                  ],
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "RecruitProfileHeader_profile"
                }
              ],
              "storageKey": null
            },
            v9
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "MatchRootRouteQuery",
      "selections": [
        {
          "alias": "match",
          "args": v1,
          "concreteType": "RecruitVacancyProfileMatch",
          "kind": "LinkedField",
          "name": "recruitVacancyProfileMatchByCode",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "candidate",
              "plural": false,
              "selections": [
                v5,
                v6,
                v7,
                v8,
                v23
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfile",
              "kind": "LinkedField",
              "name": "profile",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperience",
                  "kind": "LinkedField",
                  "name": "currentPosition",
                  "plural": false,
                  "selections": [
                    v23,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "candidateExperienceId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "title",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "companyName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "skills",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "startDate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "endDate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "industry",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "positionType",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                v23,
                v5,
                v6,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileWorkLocations",
                  "kind": "LinkedField",
                  "name": "workLocations",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currentLocationName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currentLocationCountryName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "WorkLocationEntry",
                      "kind": "LinkedField",
                      "name": "workLocations",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    v23
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileRate",
                  "kind": "LinkedField",
                  "name": "rate",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "payType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "minimumRateOfPay",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "maximumRateOfPay",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "countryCode",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currencyCode",
                      "storageKey": null
                    },
                    v23
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileAvailability",
                  "kind": "LinkedField",
                  "name": "availability",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobSearchStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "availabilityStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "NoticeCriteria",
                      "kind": "LinkedField",
                      "name": "noticeCriteria",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "availableFrom",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "noticePeriodWeeks",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "noticeTimeframe",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    v23
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "recruitProfileId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "profileType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsCandidateAccount",
                  "kind": "LinkedField",
                  "name": "account",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "accountId",
                      "storageKey": null
                    },
                    v23
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RightToWork",
                  "kind": "LinkedField",
                  "name": "rightToWork",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    v23
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v9
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "56ff63dfb1e8db9aa907dbc6f3ce2a40",
      "id": null,
      "metadata": {},
      "name": "MatchRootRouteQuery",
      "operationKind": "query",
      "text": "query MatchRootRouteQuery(\n  $matchCode: Int!\n) {\n  match: recruitVacancyProfileMatchByCode(code: $matchCode) {\n    id\n    code\n    createdOn\n    candidate {\n      firstName\n      lastName\n      email\n      phone {\n        phoneCountryCode\n        phoneCountryPrefix\n        phoneNumber\n      }\n      id\n    }\n    profile {\n      currentPosition {\n        ...ExperienceViewer_profile\n        id\n      }\n      ...RecruitProfileHeader_profile\n      id\n    }\n  }\n}\n\nfragment ExperienceViewer_profile on RecruitProfileExperience {\n  id\n  candidateExperienceId\n  title\n  companyName\n  skills\n  startDate\n  description\n  endDate\n  industry\n  positionType\n}\n\nfragment RecruitProfileApplicationHeader_application on RecruitProfile {\n  id\n  firstName\n  lastName\n  workLocations {\n    currentLocationName\n    currentLocationCountryName\n    workLocations {\n      name\n    }\n    id\n  }\n  currentPosition {\n    title\n    companyName\n    startDate\n    endDate\n    id\n  }\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n  availability {\n    jobSearchStatus\n    availabilityStatus\n    noticeCriteria {\n      availableFrom\n      noticePeriodWeeks\n      noticeTimeframe\n    }\n    id\n  }\n}\n\nfragment RecruitProfileHeader_profile on RecruitProfile {\n  ...RecruitProfileApplicationHeader_application\n  id\n  recruitProfileId\n  firstName\n  lastName\n  profileType\n  workLocations {\n    currentLocationName\n    currentLocationCountryName\n    id\n  }\n  account {\n    accountId\n    id\n  }\n  currentPosition {\n    title\n    companyName\n    startDate\n    endDate\n    id\n  }\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n  rightToWork {\n    status\n    id\n  }\n  availability {\n    jobSearchStatus\n    id\n  }\n}\n"
    }
  };
}();
node266.hash = "02a6695c9f53b141643e96412063cb95";
var MatchRootRouteQuery_graphql_default = node266;

// src/matches/recruiter/components/MatchRoot.tsx
import { Suspense as Suspense83 } from "react";
import { loadQuery as loadQuery21 } from "react-relay";
import { Link as Link14 } from "react-router-dom";
import { timeAgo as timeAgo7, useRouteData as useRouteData11 } from "shared-lib";
import { EdSkeleton as EdSkeleton73 } from "shared-ui";
import { Fragment as Fragment59, jsx as jsx250, jsxs as jsxs167 } from "react/jsx-runtime";
var queryDef37 = MatchRootRouteQuery_graphql_default;
async function loader17(environment, params) {
  const code = params.matchCode;
  const matchCode = parseInt(code);
  return loadQuery21(environment, queryDef37, {
    matchCode
  });
}
var MatchRoot = ({ routeId: routeId4, inList }) => {
  const data = useRouteData11(queryDef37, routeId4);
  if (!data) {
    return /* @__PURE__ */ jsx250(Fragment59, { children: "Loading..." });
  }
  const { match } = data;
  if (!match) {
    return /* @__PURE__ */ jsx250(Fragment59, { children: "Loading..." });
  }
  const { profile } = match;
  if (!profile) {
    return /* @__PURE__ */ jsx250("div", { className: "border-b bg-white p-4", children: /* @__PURE__ */ jsx250("div", { className: "text-primary-500 text-xl", children: "No Profile Available for Match" }) });
  }
  return /* @__PURE__ */ jsx250(Suspense83, { fallback: /* @__PURE__ */ jsx250(EdSkeleton73, {}), children: /* @__PURE__ */ jsxs167("div", { className: "border-b bg-white p-4", children: [
    /* @__PURE__ */ jsx250("div", { className: "flex flex-col gap-2", children: match.createdOn && /* @__PURE__ */ jsxs167("div", { className: "text-primary-500 text-md px-4", children: [
      "Created ",
      timeAgo7(match.createdOn)
    ] }) }),
    profile.currentPosition && /* @__PURE__ */ jsx250("div", { className: "m-4 p-4", children: /* @__PURE__ */ jsx250(ExperienceViewer, { fragmentRef: profile.currentPosition }) })
  ] }) });
};
var createRoute12 = (routePrefix, environment, context, inList = true) => {
  const routeId4 = `${routePrefix}-match-search-root`;
  return {
    id: routeId4,
    path: "info",
    element: /* @__PURE__ */ jsx250(MatchRoot, { routeId: routeId4, inList }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx250(Link14, { to: "", children: "Match" })
    },
    loader: ({ params }) => {
      return loader17(environment, params);
    }
  };
};

// src/matches/recruiter/components/__generated__/MatchRelevanceRouteQuery.graphql.ts
var node267 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "matchCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "matchCode"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdOn",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "email",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "concreteType": "CandidatePhoneVerification",
    "kind": "LinkedField",
    "name": "phone",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "phoneCountryCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "phoneCountryPrefix",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "phoneNumber",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v9 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "MatchRelevanceRouteQuery",
      "selections": [
        {
          "alias": "match",
          "args": v1,
          "concreteType": "RecruitVacancyProfileMatch",
          "kind": "LinkedField",
          "name": "recruitVacancyProfileMatchByCode",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "candidate",
              "plural": false,
              "selections": [
                v5,
                v6,
                v7,
                v8
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfile",
              "kind": "LinkedField",
              "name": "profile",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperience",
                  "kind": "LinkedField",
                  "name": "currentPosition",
                  "plural": false,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "ExperienceViewer_profile"
                    }
                  ],
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "RecruitProfileHeader_profile"
                }
              ],
              "storageKey": null
            },
            v9
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "MatchRelevanceRouteQuery",
      "selections": [
        {
          "alias": "match",
          "args": v1,
          "concreteType": "RecruitVacancyProfileMatch",
          "kind": "LinkedField",
          "name": "recruitVacancyProfileMatchByCode",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "candidate",
              "plural": false,
              "selections": [
                v5,
                v6,
                v7,
                v8,
                v23
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfile",
              "kind": "LinkedField",
              "name": "profile",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperience",
                  "kind": "LinkedField",
                  "name": "currentPosition",
                  "plural": false,
                  "selections": [
                    v23,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "candidateExperienceId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "title",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "companyName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "skills",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "startDate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "endDate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "industry",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "positionType",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                v23,
                v5,
                v6,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileWorkLocations",
                  "kind": "LinkedField",
                  "name": "workLocations",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currentLocationName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currentLocationCountryName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "WorkLocationEntry",
                      "kind": "LinkedField",
                      "name": "workLocations",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    v23
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileRate",
                  "kind": "LinkedField",
                  "name": "rate",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "payType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "minimumRateOfPay",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "maximumRateOfPay",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "countryCode",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currencyCode",
                      "storageKey": null
                    },
                    v23
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileAvailability",
                  "kind": "LinkedField",
                  "name": "availability",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobSearchStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "availabilityStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "NoticeCriteria",
                      "kind": "LinkedField",
                      "name": "noticeCriteria",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "availableFrom",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "noticePeriodWeeks",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "noticeTimeframe",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    v23
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "recruitProfileId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "profileType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsCandidateAccount",
                  "kind": "LinkedField",
                  "name": "account",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "accountId",
                      "storageKey": null
                    },
                    v23
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RightToWork",
                  "kind": "LinkedField",
                  "name": "rightToWork",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    v23
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v9
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "084c3b1535263316ce8e1838b78e43e8",
      "id": null,
      "metadata": {},
      "name": "MatchRelevanceRouteQuery",
      "operationKind": "query",
      "text": "query MatchRelevanceRouteQuery(\n  $matchCode: Int!\n) {\n  match: recruitVacancyProfileMatchByCode(code: $matchCode) {\n    id\n    code\n    createdOn\n    candidate {\n      firstName\n      lastName\n      email\n      phone {\n        phoneCountryCode\n        phoneCountryPrefix\n        phoneNumber\n      }\n      id\n    }\n    profile {\n      currentPosition {\n        ...ExperienceViewer_profile\n        id\n      }\n      ...RecruitProfileHeader_profile\n      id\n    }\n  }\n}\n\nfragment ExperienceViewer_profile on RecruitProfileExperience {\n  id\n  candidateExperienceId\n  title\n  companyName\n  skills\n  startDate\n  description\n  endDate\n  industry\n  positionType\n}\n\nfragment RecruitProfileApplicationHeader_application on RecruitProfile {\n  id\n  firstName\n  lastName\n  workLocations {\n    currentLocationName\n    currentLocationCountryName\n    workLocations {\n      name\n    }\n    id\n  }\n  currentPosition {\n    title\n    companyName\n    startDate\n    endDate\n    id\n  }\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n  availability {\n    jobSearchStatus\n    availabilityStatus\n    noticeCriteria {\n      availableFrom\n      noticePeriodWeeks\n      noticeTimeframe\n    }\n    id\n  }\n}\n\nfragment RecruitProfileHeader_profile on RecruitProfile {\n  ...RecruitProfileApplicationHeader_application\n  id\n  recruitProfileId\n  firstName\n  lastName\n  profileType\n  workLocations {\n    currentLocationName\n    currentLocationCountryName\n    id\n  }\n  account {\n    accountId\n    id\n  }\n  currentPosition {\n    title\n    companyName\n    startDate\n    endDate\n    id\n  }\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n  rightToWork {\n    status\n    id\n  }\n  availability {\n    jobSearchStatus\n    id\n  }\n}\n"
    }
  };
}();
node267.hash = "a8b71c69795a81b10d36f9f5a1784ad7";
var MatchRelevanceRouteQuery_graphql_default = node267;

// src/matches/recruiter/components/MatchRelevance.tsx
import { Suspense as Suspense84 } from "react";
import { loadQuery as loadQuery23 } from "react-relay";
import { Link as Link15, useParams as useParams10 } from "react-router-dom";
import { EdSkeleton as EdSkeleton74 } from "shared-ui";
import { jsx as jsx251, jsxs as jsxs168 } from "react/jsx-runtime";
var queryDef38 = MatchRelevanceRouteQuery_graphql_default;
async function loader18(environment, params) {
  const code = params.matchCode;
  const matchCode = parseInt(code);
  return loadQuery23(environment, queryDef38, {
    matchCode
  });
}
var MatchRelevance = () => {
  const params = useParams10();
  return /* @__PURE__ */ jsx251(Suspense84, { fallback: /* @__PURE__ */ jsx251(EdSkeleton74, {}), children: /* @__PURE__ */ jsx251(
    MatchProfileRelevanceProvider,
    {
      vacancyCode: Number(params.vacancyCode),
      matchCode: Number(params.matchCode),
      children: /* @__PURE__ */ jsxs168("div", { className: "m-5 flex flex-col gap-5", children: [
        /* @__PURE__ */ jsx251("div", { className: "rounded-md border bg-white p-5", children: /* @__PURE__ */ jsx251(MatchRelevanceProfileTimeline, {}) }),
        /* @__PURE__ */ jsx251("div", { className: "rounded-md border bg-white p-5", children: /* @__PURE__ */ jsx251(MatchExperienceSimilarityHighlighter, {}) })
      ] })
    }
  ) });
};
var createRoute13 = (routePrefix, environment, context, inList = true) => {
  const routeId4 = `${routePrefix}-match-search-relevance`;
  return {
    id: routeId4,
    path: "relevance",
    element: /* @__PURE__ */ jsx251(MatchRelevance, { routeId: routeId4, inList }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx251(Link15, { to: "", children: "Match" })
    },
    loader: ({ params }) => {
      return loader18(environment, params);
    }
  };
};

// src/matches/recruiter/components/__generated__/MatchProfileQuery.graphql.ts
var node268 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "matchCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "matchCode"
    }
  ], v23 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "startDate",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "endDate",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "MatchProfileQuery",
      "selections": [
        {
          "alias": "match",
          "args": v1,
          "concreteType": "RecruitVacancyProfileMatch",
          "kind": "LinkedField",
          "name": "recruitVacancyProfileMatchByCode",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfile",
              "kind": "LinkedField",
              "name": "profile",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "CandidateApplicationProfile_profile"
                }
              ],
              "storageKey": null
            },
            v23
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "MatchProfileQuery",
      "selections": [
        {
          "alias": "match",
          "args": v1,
          "concreteType": "RecruitVacancyProfileMatch",
          "kind": "LinkedField",
          "name": "recruitVacancyProfileMatchByCode",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfile",
              "kind": "LinkedField",
              "name": "profile",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperienceCollection",
                  "kind": "LinkedField",
                  "name": "experiences",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileExperience",
                      "kind": "LinkedField",
                      "name": "items",
                      "plural": true,
                      "selections": [
                        v32,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "candidateExperienceId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "title",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "companyName",
                          "storageKey": null
                        },
                        v4,
                        v5,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "createdOn",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "updatedOn",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "version",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "titleId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "industry",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "companyIsVerified",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "companyId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "description",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "positionType",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "skills",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "escoOccupationId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "escoHierarchy",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "SkillUsage",
                      "kind": "LinkedField",
                      "name": "skills",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "lastUsed",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "DateRange",
                          "kind": "LinkedField",
                          "name": "periods",
                          "plural": true,
                          "selections": [
                            v4,
                            v5
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "averageMonthsUsed",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "totalMonthsUsed",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "totalPositionsUsed",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                v32
              ],
              "storageKey": null
            },
            v32,
            v23
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "fb013a0eaf4026e2f374d19f97bca101",
      "id": null,
      "metadata": {},
      "name": "MatchProfileQuery",
      "operationKind": "query",
      "text": "query MatchProfileQuery(\n  $matchCode: Int!\n) {\n  match: recruitVacancyProfileMatchByCode(code: $matchCode) {\n    profile {\n      ...CandidateApplicationProfile_profile\n      id\n    }\n    id\n  }\n}\n\nfragment CandidateApplicationProfile_profile on RecruitProfile {\n  experiences {\n    items {\n      id\n      candidateExperienceId\n      title\n      companyName\n      startDate\n      endDate\n      ...ExperienceDetails_experience\n    }\n    skills {\n      name\n      lastUsed\n      periods {\n        startDate\n        endDate\n      }\n      averageMonthsUsed\n      totalMonthsUsed\n      totalPositionsUsed\n    }\n  }\n}\n\nfragment ExperienceDetails_experience on RecruitProfileExperience {\n  id\n  createdOn\n  updatedOn\n  candidateExperienceId\n  version\n  titleId\n  title\n  industry\n  companyIsVerified\n  companyId\n  companyName\n  description\n  startDate\n  endDate\n  positionType\n  skills\n  escoOccupationId\n  escoHierarchy\n}\n"
    }
  };
}();
node268.hash = "b9fa4ec55f4ae3d0a27f9fee2d9364ca";
var MatchProfileQuery_graphql_default = node268;

// src/matches/recruiter/components/MatchProfile.tsx
import { Suspense as Suspense85 } from "react";
import { loadQuery as loadQuery24 } from "react-relay";
import { Link as Link16 } from "react-router-dom";
import { useRouteData as useRouteData12 } from "shared-lib";
import { EdSkeleton as EdSkeleton75 } from "shared-ui";
import { Fragment as Fragment60, jsx as jsx253 } from "react/jsx-runtime";
var queryDef39 = MatchProfileQuery_graphql_default;
async function loader19(environment, params) {
  const code = params.matchCode;
  const matchCode = parseInt(code);
  return loadQuery24(environment, queryDef39, {
    matchCode
  });
}
var MatchProfile = ({ routeId: routeId4 }) => {
  const data = useRouteData12(queryDef39, routeId4);
  if (!data) {
    return /* @__PURE__ */ jsx253(Fragment60, { children: "Loading..." });
  }
  const { match } = data;
  if (!match) {
    return /* @__PURE__ */ jsx253(Fragment60, { children: "Loading..." });
  }
  const { profile } = match;
  if (!profile) {
    return /* @__PURE__ */ jsx253("div", { className: "border-b bg-white p-4", children: /* @__PURE__ */ jsx253("div", { className: "text-primary-500 text-xl", children: "No Profile Available for Match" }) });
  }
  return /* @__PURE__ */ jsx253(Suspense85, { fallback: /* @__PURE__ */ jsx253(EdSkeleton75, {}), children: /* @__PURE__ */ jsx253(CandidateApplicationProfileComponent, { fragmentDef: profile }) });
};
var createRoute14 = (routePrefix, environment, context) => {
  const routeId4 = `${routePrefix}-match-profile-root`;
  return {
    id: routeId4,
    path: "profile",
    element: /* @__PURE__ */ jsx253(MatchProfile, { routeId: routeId4 }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx253(Link16, { to: "", children: "Profile" })
    },
    loader: ({ params }) => {
      return loader19(environment, params);
    }
  };
};

// src/matches/recruiter/components/__generated__/MatchDetailsQuery.graphql.ts
var node269 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "code"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "code"
    }
  ], v23 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "MatchDetailsQuery",
      "selections": [
        {
          "alias": "match",
          "args": v1,
          "concreteType": "RecruitVacancyProfileMatch",
          "kind": "LinkedField",
          "name": "recruitVacancyProfileMatchByCode",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfile",
              "kind": "LinkedField",
              "name": "profile",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "DetailsComponent_profile"
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "candidate",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "DetailsComponent_candidate"
                }
              ],
              "storageKey": null
            },
            v23
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "MatchDetailsQuery",
      "selections": [
        {
          "alias": "match",
          "args": v1,
          "concreteType": "RecruitVacancyProfileMatch",
          "kind": "LinkedField",
          "name": "recruitVacancyProfileMatchByCode",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfile",
              "kind": "LinkedField",
              "name": "profile",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "recruitProfileId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitResume",
                  "kind": "LinkedField",
                  "name": "resume",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "bucket",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "resumeId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "fileKey",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "fileName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "filePath",
                      "storageKey": null
                    },
                    v32
                  ],
                  "storageKey": null
                },
                v32
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "candidate",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "firstName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "email",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CandidatePhoneVerification",
                  "kind": "LinkedField",
                  "name": "phone",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "phoneNumber",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "phoneCountryPrefix",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "phoneVerificationStatus",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                v32
              ],
              "storageKey": null
            },
            v32,
            v23
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "ae9748fc5bf808c391dbb789a8230c33",
      "id": null,
      "metadata": {},
      "name": "MatchDetailsQuery",
      "operationKind": "query",
      "text": "query MatchDetailsQuery(\n  $code: Int!\n) {\n  match: recruitVacancyProfileMatchByCode(code: $code) {\n    profile {\n      ...DetailsComponent_profile\n      id\n    }\n    candidate {\n      ...DetailsComponent_candidate\n      id\n    }\n    id\n  }\n}\n\nfragment DetailsComponent_candidate on AccountsCandidateAccount {\n  firstName\n  lastName\n  email\n  phone {\n    phoneNumber\n    phoneCountryPrefix\n    phoneVerificationStatus\n  }\n}\n\nfragment DetailsComponent_profile on RecruitProfile {\n  recruitProfileId\n  resume {\n    bucket\n    resumeId\n    fileKey\n    fileName\n    filePath\n    id\n  }\n}\n"
    }
  };
}();
node269.hash = "aa9d849fac7ae5defbec356339a3768f";
var MatchDetailsQuery_graphql_default = node269;

// src/matches/recruiter/components/MatchDetails.tsx
import { loadQuery as loadQuery25 } from "react-relay";
import { Link as Link17 } from "react-router-dom";
import { useRouteData as useRouteData13 } from "shared-lib";
import { Fragment as Fragment61, jsx as jsx254 } from "react/jsx-runtime";
var queryDef40 = MatchDetailsQuery_graphql_default;
async function loader20(environment, params) {
  const code = params.matchCode;
  const matchCode = parseInt(code);
  return loadQuery25(environment, queryDef40, {
    code: matchCode
  });
}
var MatchDetails = ({ routeId: routeId4 }) => {
  const data = useRouteData13(queryDef40, routeId4);
  if (!data?.match?.candidate || !data?.match?.profile) {
    return /* @__PURE__ */ jsx254(Fragment61, { children: "loading" });
  }
  return /* @__PURE__ */ jsx254(
    DetailsComponent,
    {
      candidateFragmentRef: data.match?.candidate,
      profileFragmentRef: data.match?.profile
    }
  );
};
var createRoute15 = (routePrefix, environment, context) => {
  const routeId4 = `${routePrefix}-application-details-forms`;
  return {
    id: routeId4,
    path: "details",
    loader: ({ params }) => {
      return loader20(environment, params);
    },
    element: /* @__PURE__ */ jsx254(MatchDetails, { routeId: routeId4 }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx254(Link17, { to: "details", children: "Details" })
    }
  };
};

// src/matches/recruiter/components/MatchRoute.tsx
import { jsx as jsx255 } from "react/jsx-runtime";
var createMatchRoutes = (routePrefix, environment, context, showHeader = true, inList = true) => {
  const routeId4 = `${routePrefix}-${routeId2}`;
  return [
    {
      path: "*",
      id: routeId4,
      element: /* @__PURE__ */ jsx255(MatchLayout, { showHeader }),
      errorElement: /* @__PURE__ */ jsx255(ErrorContainer12, {}),
      handle: {
        crumb: () => /* @__PURE__ */ jsx255(MatchLink, { routeId: routeId4 })
      },
      loader: ({ params }) => {
        return loader16(environment, params);
      },
      children: [
        createRoute12(routePrefix, environment, context, inList),
        createRoute14(routePrefix, environment, context),
        createRoute15(routePrefix, environment, context),
        createRoute13(routePrefix, environment, context, inList),
        {
          path: "*",
          element: /* @__PURE__ */ jsx255(Navigate10, { to: "relevance", replace: true })
        }
      ]
    }
  ];
};

// src/matches/recruiter/components/__generated__/MatchSearchContainerQuery.graphql.ts
var node270 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v5 = [
    v23,
    {
      "alias": null,
      "args": null,
      "concreteType": "DefaultAggregationValueModel",
      "kind": "LinkedField",
      "name": "values",
      "plural": true,
      "selections": [
        v32,
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isSelected",
          "storageKey": null
        },
        v4
      ],
      "storageKey": null
    },
    v32,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    }
  ], v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdOn",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyScore",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "jobMatchScore",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "skillGroupId",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "numberOfMonthsCertain",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "numberOfMonthsCertainPlusUnknown",
    "storageKey": null
  }, v14 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "mostRecentCertainExperienceEnd",
    "storageKey": null
  }, v15 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "mostRecentUnknownExperienceEnd",
    "storageKey": null
  }, v16 = [
    v12,
    v13,
    v14,
    v15
  ], v17 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "version",
    "storageKey": null
  }, v18 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "titleId",
    "storageKey": null
  }, v19 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "industry",
    "storageKey": null
  }, v20 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyIsVerified",
    "storageKey": null
  }, v21 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyId",
    "storageKey": null
  }, v222 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyName",
    "storageKey": null
  }, v232 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  }, v24 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "startDate",
    "storageKey": null
  }, v25 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "endDate",
    "storageKey": null
  }, v26 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "positionType",
    "storageKey": null
  }, v27 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "weight",
    "storageKey": null
  }, v28 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "escoOccupationId",
    "storageKey": null
  }, v29 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "escoHierarchy",
    "storageKey": null
  }, v30 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationAmount",
    "storageKey": null
  }, v31 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationType",
    "storageKey": null
  }, v322 = [
    v30,
    v31
  ], v33 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v34 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v35 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "accountId",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "MatchSearchContainerQuery",
      "selections": [
        {
          "args": v1,
          "kind": "FragmentSpread",
          "name": "MatchSearchContainerFragment"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "MatchSearchContainerQuery",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "ProfileMatchSearchResults",
          "kind": "LinkedField",
          "name": "recruitVacancyProfileMatchSearch",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CollectionMetaData",
              "kind": "LinkedField",
              "name": "pagination",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "totalResults",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "itemsPerPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "pageNumber",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "pages",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "MatchSearchAggregations",
              "kind": "LinkedField",
              "name": "aggregations",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "sourceTypes",
                  "plural": false,
                  "selections": v5,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "StandardAggregationResults",
                  "kind": "LinkedField",
                  "name": "standard",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "companies",
                      "plural": false,
                      "selections": v5,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "escoLevel1",
                      "plural": false,
                      "selections": v5,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "escoLevel2",
                      "plural": false,
                      "selections": v5,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "escoLevel3",
                      "plural": false,
                      "selections": v5,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "escoLevel4",
                      "plural": false,
                      "selections": v5,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "escoLevel5",
                      "plural": false,
                      "selections": v5,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "industries",
                      "plural": false,
                      "selections": v5,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "skills",
                      "plural": false,
                      "selections": v5,
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitVacancyProfileMatch",
              "kind": "LinkedField",
              "name": "matches",
              "plural": true,
              "selections": [
                v6,
                v7,
                v8,
                v9,
                v10,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "totalScore",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitMatchRelevanceContainer",
                  "kind": "LinkedField",
                  "name": "matchRelevance",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitMatchSkillRelevance",
                      "kind": "LinkedField",
                      "name": "skillGroups",
                      "plural": true,
                      "selections": [
                        v11,
                        v12,
                        v13,
                        v14,
                        v15
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitMatchRelevance",
                      "kind": "LinkedField",
                      "name": "industry",
                      "plural": false,
                      "selections": v16,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitMatchRelevance",
                      "kind": "LinkedField",
                      "name": "job",
                      "plural": false,
                      "selections": v16,
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitMatchProfile",
                  "kind": "LinkedField",
                  "name": "matchProfile",
                  "plural": false,
                  "selections": [
                    v6,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "vacancyId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitMatchProfileExperience",
                      "kind": "LinkedField",
                      "name": "experience",
                      "plural": true,
                      "selections": [
                        v6,
                        v7,
                        v17,
                        v18,
                        v23,
                        v19,
                        v20,
                        v21,
                        v222,
                        v232,
                        v24,
                        v25,
                        v26,
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "MatchProfileExperienceSkillGroupScore",
                          "kind": "LinkedField",
                          "name": "skillGroupScores",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "groupId",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "hasMatch",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "minSkillGroupScore",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "score",
                              "storageKey": null
                            },
                            v27
                          ],
                          "storageKey": null
                        },
                        v28,
                        v29,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "jobMatchWeight",
                          "storageKey": null
                        },
                        v10,
                        v9,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "companyScoreWeight",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "hasCompanyVector",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Vacancy",
                  "kind": "LinkedField",
                  "name": "vacancy",
                  "plural": false,
                  "selections": [
                    v6,
                    v7,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "SkillGroup",
                      "kind": "LinkedField",
                      "name": "skillGroups",
                      "plural": true,
                      "selections": [
                        v6,
                        v11,
                        v4,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isRequired",
                          "storageKey": null
                        },
                        v27,
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "SkillGroupTerm",
                          "kind": "LinkedField",
                          "name": "terms",
                          "plural": true,
                          "selections": [
                            v4,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "isSkill",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Duration",
                          "kind": "LinkedField",
                          "name": "experience",
                          "plural": false,
                          "selections": v322,
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Duration",
                          "kind": "LinkedField",
                          "name": "recency",
                          "plural": false,
                          "selections": [
                            v31,
                            v30
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "VacancyScoringConfig",
                      "kind": "LinkedField",
                      "name": "scoringConfig",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Duration",
                          "kind": "LinkedField",
                          "name": "industryExperience",
                          "plural": false,
                          "selections": v322,
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "industryNegativeThreshold",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "industryPositiveThreshold",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Duration",
                          "kind": "LinkedField",
                          "name": "industryRecency",
                          "plural": false,
                          "selections": v322,
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "relevanceNegativeThreshold",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "relevancePositiveThreshold",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Duration",
                          "kind": "LinkedField",
                          "name": "relevantExperience",
                          "plural": false,
                          "selections": v322,
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Duration",
                          "kind": "LinkedField",
                          "name": "relevantRecency",
                          "plural": false,
                          "selections": v322,
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsCandidateAccount",
                  "kind": "LinkedField",
                  "name": "candidate",
                  "plural": false,
                  "selections": [
                    v33,
                    v34,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "email",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CandidatePhoneVerification",
                      "kind": "LinkedField",
                      "name": "phone",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "phoneCountryCode",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "phoneCountryPrefix",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "phoneNumber",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "phoneVerificationStatus",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    v6,
                    v35
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfile",
                  "kind": "LinkedField",
                  "name": "profile",
                  "plural": false,
                  "selections": [
                    v6,
                    v33,
                    v34,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileWorkLocations",
                      "kind": "LinkedField",
                      "name": "workLocations",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "currentLocationName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "currentLocationCountryName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "WorkLocationEntry",
                          "kind": "LinkedField",
                          "name": "workLocations",
                          "plural": true,
                          "selections": [
                            v4
                          ],
                          "storageKey": null
                        },
                        v6
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileExperience",
                      "kind": "LinkedField",
                      "name": "currentPosition",
                      "plural": false,
                      "selections": [
                        v23,
                        v222,
                        v24,
                        v25,
                        v6
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileRate",
                      "kind": "LinkedField",
                      "name": "rate",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "payType",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "minimumRateOfPay",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "maximumRateOfPay",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "countryCode",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "currencyCode",
                          "storageKey": null
                        },
                        v6
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileAvailability",
                      "kind": "LinkedField",
                      "name": "availability",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "jobSearchStatus",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "availabilityStatus",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "NoticeCriteria",
                          "kind": "LinkedField",
                          "name": "noticeCriteria",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "availableFrom",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "noticePeriodWeeks",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "noticeTimeframe",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        v6,
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "availability",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "__typename",
                              "storageKey": null
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "date",
                                  "storageKey": null
                                }
                              ],
                              "type": "CandidateAvailableFromDate",
                              "abstractKey": null
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "immediately",
                                  "storageKey": null
                                }
                              ],
                              "type": "CandidateAvailableImmediately",
                              "abstractKey": null
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "notice",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "timeframe",
                                  "storageKey": null
                                }
                              ],
                              "type": "CandidateAvailableNotice",
                              "abstractKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "recruitProfileId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "profileType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountsCandidateAccount",
                      "kind": "LinkedField",
                      "name": "account",
                      "plural": false,
                      "selections": [
                        v35,
                        v6
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RightToWork",
                      "kind": "LinkedField",
                      "name": "rightToWork",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "status",
                          "storageKey": null
                        },
                        v6
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileExperienceCollection",
                      "kind": "LinkedField",
                      "name": "experiences",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileExperience",
                          "kind": "LinkedField",
                          "name": "items",
                          "plural": true,
                          "selections": [
                            v6,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "candidateExperienceId",
                              "storageKey": null
                            },
                            v23,
                            v222,
                            v24,
                            v25,
                            v8,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "updatedOn",
                              "storageKey": null
                            },
                            v17,
                            v18,
                            v19,
                            v20,
                            v21,
                            v232,
                            v26,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "skills",
                              "storageKey": null
                            },
                            v28,
                            v29
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "SkillUsage",
                          "kind": "LinkedField",
                          "name": "skills",
                          "plural": true,
                          "selections": [
                            v4,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "lastUsed",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "DateRange",
                              "kind": "LinkedField",
                              "name": "periods",
                              "plural": true,
                              "selections": [
                                v24,
                                v25
                              ],
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "averageMonthsUsed",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "totalMonthsUsed",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "totalPositionsUsed",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitResume",
                      "kind": "LinkedField",
                      "name": "resume",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "bucket",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "resumeId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "fileKey",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "fileName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "filePath",
                          "storageKey": null
                        },
                        v6
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitRecommendation",
                  "kind": "LinkedField",
                  "name": "recommendation",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "rightToWorkStatus",
                      "storageKey": null
                    },
                    v6
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "9c1e3ebeb79635905df9bef935a57db6",
      "id": null,
      "metadata": {},
      "name": "MatchSearchContainerQuery",
      "operationKind": "query",
      "text": "query MatchSearchContainerQuery(\n  $input: ProfileMatchSearchInput!\n) {\n  ...MatchSearchContainerFragment_2VV6jB\n}\n\nfragment AggregationTags_Aggregation on DefaultAggregationModel {\n  title\n  values {\n    count\n    text\n    isSelected\n    name\n  }\n}\n\nfragment CandidateApplicationProfile_profile on RecruitProfile {\n  experiences {\n    items {\n      id\n      candidateExperienceId\n      title\n      companyName\n      startDate\n      endDate\n      ...ExperienceDetails_experience\n    }\n    skills {\n      name\n      lastUsed\n      periods {\n        startDate\n        endDate\n      }\n      averageMonthsUsed\n      totalMonthsUsed\n      totalPositionsUsed\n    }\n  }\n}\n\nfragment DetailsComponent_candidate on AccountsCandidateAccount {\n  firstName\n  lastName\n  email\n  phone {\n    phoneNumber\n    phoneCountryPrefix\n    phoneVerificationStatus\n  }\n}\n\nfragment DetailsComponent_profile on RecruitProfile {\n  recruitProfileId\n  resume {\n    bucket\n    resumeId\n    fileKey\n    fileName\n    filePath\n    id\n  }\n}\n\nfragment ExperienceDetails_experience on RecruitProfileExperience {\n  id\n  createdOn\n  updatedOn\n  candidateExperienceId\n  version\n  titleId\n  title\n  industry\n  companyIsVerified\n  companyId\n  companyName\n  description\n  startDate\n  endDate\n  positionType\n  skills\n  escoOccupationId\n  escoHierarchy\n}\n\nfragment MatchRelevanceProvider_matchProfile on RecruitMatchProfile {\n  id\n  vacancyId\n  experience {\n    id\n    code\n    version\n    titleId\n    title\n    industry\n    companyIsVerified\n    companyId\n    companyName\n    description\n    startDate\n    endDate\n    positionType\n    skillGroupScores {\n      groupId\n      hasMatch\n      minSkillGroupScore\n      score\n      weight\n    }\n    escoOccupationId\n    escoHierarchy\n    jobMatchWeight\n    jobMatchScore\n    companyScore\n    companyScoreWeight\n    hasCompanyVector\n  }\n}\n\nfragment MatchRelevanceProvider_relevance on RecruitMatchRelevanceContainer {\n  skillGroups {\n    skillGroupId\n    numberOfMonthsCertain\n    numberOfMonthsCertainPlusUnknown\n    mostRecentCertainExperienceEnd\n    mostRecentUnknownExperienceEnd\n  }\n  industry {\n    numberOfMonthsCertain\n    numberOfMonthsCertainPlusUnknown\n    mostRecentCertainExperienceEnd\n    mostRecentUnknownExperienceEnd\n  }\n  job {\n    numberOfMonthsCertain\n    numberOfMonthsCertainPlusUnknown\n    mostRecentCertainExperienceEnd\n    mostRecentUnknownExperienceEnd\n  }\n}\n\nfragment MatchRelevanceProvider_vacancy on Vacancy {\n  id\n  code\n  skillGroups {\n    id\n    skillGroupId\n    name\n    isRequired\n    weight\n    terms {\n      name\n      isSkill\n    }\n    experience {\n      durationAmount\n      durationType\n    }\n    recency {\n      durationType\n      durationAmount\n    }\n  }\n  scoringConfig {\n    industryExperience {\n      durationAmount\n      durationType\n    }\n    industryNegativeThreshold\n    industryPositiveThreshold\n    industryRecency {\n      durationAmount\n      durationType\n    }\n    relevanceNegativeThreshold\n    relevancePositiveThreshold\n    relevantExperience {\n      durationAmount\n      durationType\n    }\n    relevantRecency {\n      durationAmount\n      durationType\n    }\n  }\n}\n\nfragment MatchSearchContainerFragment_2VV6jB on Query {\n  result: recruitVacancyProfileMatchSearch(input: $input) {\n    ...VacancyMatchSearchActiveFilters_results\n    ...MatchSearchFilters_results\n    ...MatchSearchPaging_results\n    pagination {\n      totalResults\n      itemsPerPage\n      pageNumber\n      pages\n    }\n    aggregations {\n      sourceTypes {\n        ...MultiFacetContainer_facet\n      }\n      standard {\n        companies {\n          ...AggregationTags_Aggregation\n        }\n        escoLevel1 {\n          ...AggregationTags_Aggregation\n        }\n        escoLevel2 {\n          ...AggregationTags_Aggregation\n        }\n        escoLevel3 {\n          ...AggregationTags_Aggregation\n        }\n        escoLevel4 {\n          ...AggregationTags_Aggregation\n        }\n        escoLevel5 {\n          ...AggregationTags_Aggregation\n        }\n        industries {\n          ...AggregationTags_Aggregation\n        }\n        skills {\n          ...AggregationTags_Aggregation\n        }\n        ...ProfileFacetsListFragment\n      }\n    }\n    matches {\n      id\n      code\n      createdOn\n      companyScore\n      jobMatchScore\n      totalScore\n      matchRelevance {\n        ...MatchRelevanceProvider_relevance\n      }\n      matchProfile {\n        ...MatchRelevanceProvider_matchProfile\n      }\n      vacancy {\n        ...MatchRelevanceProvider_vacancy\n        id\n        code\n      }\n      candidate {\n        firstName\n        lastName\n        email\n        phone {\n          phoneCountryCode\n          phoneCountryPrefix\n          phoneNumber\n        }\n        id\n      }\n      profile {\n        ...RecruitProfileHeader_profile\n        ...RecruitProfileApplicationHeader_application\n        id\n      }\n      ...MatchSearchList_match\n    }\n  }\n}\n\nfragment MatchSearchFilters_results on ProfileMatchSearchResults {\n  aggregations {\n    standard {\n      ...ProfileSkillsFacetsContainer_facets\n      skills {\n        count\n        ...MultiFacetContainer_facet\n      }\n      companies {\n        count\n        ...MultiFacetContainer_facet\n      }\n      industries {\n        count\n        ...MultiFacetContainer_facet\n      }\n      escoLevel1 {\n        count\n        ...MultiFacetContainer_facet\n      }\n    }\n  }\n}\n\nfragment MatchSearchList_match on RecruitVacancyProfileMatch {\n  code\n  vacancy {\n    code\n    id\n    ...MatchRelevanceProvider_vacancy\n  }\n  recommendation {\n    rightToWorkStatus\n    id\n  }\n  profile {\n    rate {\n      countryCode\n      currencyCode\n      maximumRateOfPay\n      minimumRateOfPay\n      payType\n      id\n    }\n    availability {\n      availabilityStatus\n      availability {\n        __typename\n        ... on CandidateAvailableFromDate {\n          date\n        }\n        ... on CandidateAvailableImmediately {\n          immediately\n        }\n        ... on CandidateAvailableNotice {\n          notice\n          timeframe\n        }\n      }\n      id\n    }\n    recruitProfileId\n    ...CandidateApplicationProfile_profile\n    ...DetailsComponent_profile\n    ...RecruitProfileApplicationHeader_application\n    id\n  }\n  candidate {\n    accountId\n    ...DetailsComponent_candidate\n    id\n  }\n  matchRelevance {\n    ...MatchRelevanceProvider_relevance\n  }\n  matchProfile {\n    ...MatchRelevanceProvider_matchProfile\n  }\n}\n\nfragment MatchSearchPaging_results on ProfileMatchSearchResults {\n  pagination {\n    pages\n    pageNumber\n    itemsPerPage\n    totalResults\n  }\n}\n\nfragment MultiFacetContainer_facet on DefaultAggregationModel {\n  count\n  key\n  title\n  values {\n    count\n    isSelected\n    name\n    text\n  }\n}\n\nfragment ProfileFacetsListFragment on StandardAggregationResults {\n  companies {\n    count\n    ...TagFacetFragment\n  }\n  escoLevel1 {\n    count\n    ...TagFacetFragment\n  }\n  escoLevel2 {\n    count\n    ...TagFacetFragment\n  }\n  escoLevel3 {\n    count\n    ...TagFacetFragment\n  }\n  escoLevel4 {\n    count\n    ...TagFacetFragment\n  }\n  escoLevel5 {\n    count\n    ...TagFacetFragment\n  }\n  industries {\n    count\n    ...TagFacetFragment\n  }\n  skills {\n    count\n    ...TagFacetFragment\n  }\n}\n\nfragment ProfileSkillsFacetsContainer_facets on StandardAggregationResults {\n  skills {\n    count\n    ...MultiFacetContainer_facet\n  }\n}\n\nfragment RecruitProfileApplicationHeader_application on RecruitProfile {\n  id\n  firstName\n  lastName\n  workLocations {\n    currentLocationName\n    currentLocationCountryName\n    workLocations {\n      name\n    }\n    id\n  }\n  currentPosition {\n    title\n    companyName\n    startDate\n    endDate\n    id\n  }\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n  availability {\n    jobSearchStatus\n    availabilityStatus\n    noticeCriteria {\n      availableFrom\n      noticePeriodWeeks\n      noticeTimeframe\n    }\n    id\n  }\n}\n\nfragment RecruitProfileHeader_profile on RecruitProfile {\n  ...RecruitProfileApplicationHeader_application\n  id\n  recruitProfileId\n  firstName\n  lastName\n  profileType\n  workLocations {\n    currentLocationName\n    currentLocationCountryName\n    id\n  }\n  account {\n    accountId\n    id\n  }\n  currentPosition {\n    title\n    companyName\n    startDate\n    endDate\n    id\n  }\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n  rightToWork {\n    status\n    id\n  }\n  availability {\n    jobSearchStatus\n    id\n  }\n}\n\nfragment TagFacetFragment on DefaultAggregationModel {\n  count\n  key\n  title\n  values {\n    count\n    isSelected\n    name\n    text\n  }\n}\n\nfragment VacancyApplicationSearchFacets_results on StandardAggregationResults {\n  ...ProfileSkillsFacetsContainer_facets\n  companies {\n    count\n    ...MultiFacetContainer_facet\n  }\n  industries {\n    count\n    ...MultiFacetContainer_facet\n  }\n}\n\nfragment VacancyMatchSearchActiveFilters_results on ProfileMatchSearchResults {\n  pagination {\n    totalResults\n    itemsPerPage\n    pageNumber\n    pages\n  }\n  aggregations {\n    sourceTypes {\n      ...AggregationTags_Aggregation\n    }\n    standard {\n      companies {\n        ...AggregationTags_Aggregation\n      }\n      escoLevel1 {\n        ...AggregationTags_Aggregation\n      }\n      escoLevel2 {\n        ...AggregationTags_Aggregation\n      }\n      escoLevel3 {\n        ...AggregationTags_Aggregation\n      }\n      escoLevel4 {\n        ...AggregationTags_Aggregation\n      }\n      escoLevel5 {\n        ...AggregationTags_Aggregation\n      }\n      industries {\n        ...AggregationTags_Aggregation\n      }\n      skills {\n        ...AggregationTags_Aggregation\n      }\n      ...VacancyApplicationSearchFacets_results\n    }\n  }\n}\n"
    }
  };
}();
node270.hash = "81a465e3aca9011bcc3ef87455dc0860";
var MatchSearchContainerQuery_graphql_default = node270;

// src/matches/recruiter/components/__generated__/MatchSearchListFragment.graphql.ts
var node271 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v5 = [
    v23,
    {
      "alias": null,
      "args": null,
      "concreteType": "DefaultAggregationValueModel",
      "kind": "LinkedField",
      "name": "values",
      "plural": true,
      "selections": [
        v32,
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isSelected",
          "storageKey": null
        },
        v4
      ],
      "storageKey": null
    },
    v32,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    }
  ], v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdOn",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyScore",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "jobMatchScore",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "skillGroupId",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "numberOfMonthsCertain",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "numberOfMonthsCertainPlusUnknown",
    "storageKey": null
  }, v14 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "mostRecentCertainExperienceEnd",
    "storageKey": null
  }, v15 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "mostRecentUnknownExperienceEnd",
    "storageKey": null
  }, v16 = [
    v12,
    v13,
    v14,
    v15
  ], v17 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "version",
    "storageKey": null
  }, v18 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "titleId",
    "storageKey": null
  }, v19 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "industry",
    "storageKey": null
  }, v20 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyIsVerified",
    "storageKey": null
  }, v21 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyId",
    "storageKey": null
  }, v222 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyName",
    "storageKey": null
  }, v232 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  }, v24 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "startDate",
    "storageKey": null
  }, v25 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "endDate",
    "storageKey": null
  }, v26 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "positionType",
    "storageKey": null
  }, v27 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "weight",
    "storageKey": null
  }, v28 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "escoOccupationId",
    "storageKey": null
  }, v29 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "escoHierarchy",
    "storageKey": null
  }, v30 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationAmount",
    "storageKey": null
  }, v31 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationType",
    "storageKey": null
  }, v322 = [
    v30,
    v31
  ], v33 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v34 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v35 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "accountId",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "MatchSearchListFragment",
      "selections": [
        {
          "args": v1,
          "kind": "FragmentSpread",
          "name": "MatchSearchContainerFragment"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "MatchSearchListFragment",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "ProfileMatchSearchResults",
          "kind": "LinkedField",
          "name": "recruitVacancyProfileMatchSearch",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CollectionMetaData",
              "kind": "LinkedField",
              "name": "pagination",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "totalResults",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "itemsPerPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "pageNumber",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "pages",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "MatchSearchAggregations",
              "kind": "LinkedField",
              "name": "aggregations",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "sourceTypes",
                  "plural": false,
                  "selections": v5,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "StandardAggregationResults",
                  "kind": "LinkedField",
                  "name": "standard",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "companies",
                      "plural": false,
                      "selections": v5,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "escoLevel1",
                      "plural": false,
                      "selections": v5,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "escoLevel2",
                      "plural": false,
                      "selections": v5,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "escoLevel3",
                      "plural": false,
                      "selections": v5,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "escoLevel4",
                      "plural": false,
                      "selections": v5,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "escoLevel5",
                      "plural": false,
                      "selections": v5,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "industries",
                      "plural": false,
                      "selections": v5,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "skills",
                      "plural": false,
                      "selections": v5,
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitVacancyProfileMatch",
              "kind": "LinkedField",
              "name": "matches",
              "plural": true,
              "selections": [
                v6,
                v7,
                v8,
                v9,
                v10,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "totalScore",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitMatchRelevanceContainer",
                  "kind": "LinkedField",
                  "name": "matchRelevance",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitMatchSkillRelevance",
                      "kind": "LinkedField",
                      "name": "skillGroups",
                      "plural": true,
                      "selections": [
                        v11,
                        v12,
                        v13,
                        v14,
                        v15
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitMatchRelevance",
                      "kind": "LinkedField",
                      "name": "industry",
                      "plural": false,
                      "selections": v16,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitMatchRelevance",
                      "kind": "LinkedField",
                      "name": "job",
                      "plural": false,
                      "selections": v16,
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitMatchProfile",
                  "kind": "LinkedField",
                  "name": "matchProfile",
                  "plural": false,
                  "selections": [
                    v6,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "vacancyId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitMatchProfileExperience",
                      "kind": "LinkedField",
                      "name": "experience",
                      "plural": true,
                      "selections": [
                        v6,
                        v7,
                        v17,
                        v18,
                        v23,
                        v19,
                        v20,
                        v21,
                        v222,
                        v232,
                        v24,
                        v25,
                        v26,
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "MatchProfileExperienceSkillGroupScore",
                          "kind": "LinkedField",
                          "name": "skillGroupScores",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "groupId",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "hasMatch",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "minSkillGroupScore",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "score",
                              "storageKey": null
                            },
                            v27
                          ],
                          "storageKey": null
                        },
                        v28,
                        v29,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "jobMatchWeight",
                          "storageKey": null
                        },
                        v10,
                        v9,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "companyScoreWeight",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "hasCompanyVector",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Vacancy",
                  "kind": "LinkedField",
                  "name": "vacancy",
                  "plural": false,
                  "selections": [
                    v6,
                    v7,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "SkillGroup",
                      "kind": "LinkedField",
                      "name": "skillGroups",
                      "plural": true,
                      "selections": [
                        v6,
                        v11,
                        v4,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isRequired",
                          "storageKey": null
                        },
                        v27,
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "SkillGroupTerm",
                          "kind": "LinkedField",
                          "name": "terms",
                          "plural": true,
                          "selections": [
                            v4,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "isSkill",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Duration",
                          "kind": "LinkedField",
                          "name": "experience",
                          "plural": false,
                          "selections": v322,
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Duration",
                          "kind": "LinkedField",
                          "name": "recency",
                          "plural": false,
                          "selections": [
                            v31,
                            v30
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "VacancyScoringConfig",
                      "kind": "LinkedField",
                      "name": "scoringConfig",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Duration",
                          "kind": "LinkedField",
                          "name": "industryExperience",
                          "plural": false,
                          "selections": v322,
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "industryNegativeThreshold",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "industryPositiveThreshold",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Duration",
                          "kind": "LinkedField",
                          "name": "industryRecency",
                          "plural": false,
                          "selections": v322,
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "relevanceNegativeThreshold",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "relevancePositiveThreshold",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Duration",
                          "kind": "LinkedField",
                          "name": "relevantExperience",
                          "plural": false,
                          "selections": v322,
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Duration",
                          "kind": "LinkedField",
                          "name": "relevantRecency",
                          "plural": false,
                          "selections": v322,
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsCandidateAccount",
                  "kind": "LinkedField",
                  "name": "candidate",
                  "plural": false,
                  "selections": [
                    v33,
                    v34,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "email",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CandidatePhoneVerification",
                      "kind": "LinkedField",
                      "name": "phone",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "phoneCountryCode",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "phoneCountryPrefix",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "phoneNumber",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "phoneVerificationStatus",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    v6,
                    v35
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfile",
                  "kind": "LinkedField",
                  "name": "profile",
                  "plural": false,
                  "selections": [
                    v6,
                    v33,
                    v34,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileWorkLocations",
                      "kind": "LinkedField",
                      "name": "workLocations",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "currentLocationName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "currentLocationCountryName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "WorkLocationEntry",
                          "kind": "LinkedField",
                          "name": "workLocations",
                          "plural": true,
                          "selections": [
                            v4
                          ],
                          "storageKey": null
                        },
                        v6
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileExperience",
                      "kind": "LinkedField",
                      "name": "currentPosition",
                      "plural": false,
                      "selections": [
                        v23,
                        v222,
                        v24,
                        v25,
                        v6
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileRate",
                      "kind": "LinkedField",
                      "name": "rate",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "payType",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "minimumRateOfPay",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "maximumRateOfPay",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "countryCode",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "currencyCode",
                          "storageKey": null
                        },
                        v6
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileAvailability",
                      "kind": "LinkedField",
                      "name": "availability",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "jobSearchStatus",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "availabilityStatus",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "NoticeCriteria",
                          "kind": "LinkedField",
                          "name": "noticeCriteria",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "availableFrom",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "noticePeriodWeeks",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "noticeTimeframe",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        v6,
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "availability",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "__typename",
                              "storageKey": null
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "date",
                                  "storageKey": null
                                }
                              ],
                              "type": "CandidateAvailableFromDate",
                              "abstractKey": null
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "immediately",
                                  "storageKey": null
                                }
                              ],
                              "type": "CandidateAvailableImmediately",
                              "abstractKey": null
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "notice",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "timeframe",
                                  "storageKey": null
                                }
                              ],
                              "type": "CandidateAvailableNotice",
                              "abstractKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "recruitProfileId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "profileType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountsCandidateAccount",
                      "kind": "LinkedField",
                      "name": "account",
                      "plural": false,
                      "selections": [
                        v35,
                        v6
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RightToWork",
                      "kind": "LinkedField",
                      "name": "rightToWork",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "status",
                          "storageKey": null
                        },
                        v6
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileExperienceCollection",
                      "kind": "LinkedField",
                      "name": "experiences",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileExperience",
                          "kind": "LinkedField",
                          "name": "items",
                          "plural": true,
                          "selections": [
                            v6,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "candidateExperienceId",
                              "storageKey": null
                            },
                            v23,
                            v222,
                            v24,
                            v25,
                            v8,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "updatedOn",
                              "storageKey": null
                            },
                            v17,
                            v18,
                            v19,
                            v20,
                            v21,
                            v232,
                            v26,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "skills",
                              "storageKey": null
                            },
                            v28,
                            v29
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "SkillUsage",
                          "kind": "LinkedField",
                          "name": "skills",
                          "plural": true,
                          "selections": [
                            v4,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "lastUsed",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "DateRange",
                              "kind": "LinkedField",
                              "name": "periods",
                              "plural": true,
                              "selections": [
                                v24,
                                v25
                              ],
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "averageMonthsUsed",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "totalMonthsUsed",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "totalPositionsUsed",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitResume",
                      "kind": "LinkedField",
                      "name": "resume",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "bucket",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "resumeId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "fileKey",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "fileName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "filePath",
                          "storageKey": null
                        },
                        v6
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitRecommendation",
                  "kind": "LinkedField",
                  "name": "recommendation",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "rightToWorkStatus",
                      "storageKey": null
                    },
                    v6
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "526ca853ca6be38f78ec559f2f2f2c1b",
      "id": null,
      "metadata": {},
      "name": "MatchSearchListFragment",
      "operationKind": "query",
      "text": "query MatchSearchListFragment(\n  $input: ProfileMatchSearchInput!\n) {\n  ...MatchSearchContainerFragment_2VV6jB\n}\n\nfragment AggregationTags_Aggregation on DefaultAggregationModel {\n  title\n  values {\n    count\n    text\n    isSelected\n    name\n  }\n}\n\nfragment CandidateApplicationProfile_profile on RecruitProfile {\n  experiences {\n    items {\n      id\n      candidateExperienceId\n      title\n      companyName\n      startDate\n      endDate\n      ...ExperienceDetails_experience\n    }\n    skills {\n      name\n      lastUsed\n      periods {\n        startDate\n        endDate\n      }\n      averageMonthsUsed\n      totalMonthsUsed\n      totalPositionsUsed\n    }\n  }\n}\n\nfragment DetailsComponent_candidate on AccountsCandidateAccount {\n  firstName\n  lastName\n  email\n  phone {\n    phoneNumber\n    phoneCountryPrefix\n    phoneVerificationStatus\n  }\n}\n\nfragment DetailsComponent_profile on RecruitProfile {\n  recruitProfileId\n  resume {\n    bucket\n    resumeId\n    fileKey\n    fileName\n    filePath\n    id\n  }\n}\n\nfragment ExperienceDetails_experience on RecruitProfileExperience {\n  id\n  createdOn\n  updatedOn\n  candidateExperienceId\n  version\n  titleId\n  title\n  industry\n  companyIsVerified\n  companyId\n  companyName\n  description\n  startDate\n  endDate\n  positionType\n  skills\n  escoOccupationId\n  escoHierarchy\n}\n\nfragment MatchRelevanceProvider_matchProfile on RecruitMatchProfile {\n  id\n  vacancyId\n  experience {\n    id\n    code\n    version\n    titleId\n    title\n    industry\n    companyIsVerified\n    companyId\n    companyName\n    description\n    startDate\n    endDate\n    positionType\n    skillGroupScores {\n      groupId\n      hasMatch\n      minSkillGroupScore\n      score\n      weight\n    }\n    escoOccupationId\n    escoHierarchy\n    jobMatchWeight\n    jobMatchScore\n    companyScore\n    companyScoreWeight\n    hasCompanyVector\n  }\n}\n\nfragment MatchRelevanceProvider_relevance on RecruitMatchRelevanceContainer {\n  skillGroups {\n    skillGroupId\n    numberOfMonthsCertain\n    numberOfMonthsCertainPlusUnknown\n    mostRecentCertainExperienceEnd\n    mostRecentUnknownExperienceEnd\n  }\n  industry {\n    numberOfMonthsCertain\n    numberOfMonthsCertainPlusUnknown\n    mostRecentCertainExperienceEnd\n    mostRecentUnknownExperienceEnd\n  }\n  job {\n    numberOfMonthsCertain\n    numberOfMonthsCertainPlusUnknown\n    mostRecentCertainExperienceEnd\n    mostRecentUnknownExperienceEnd\n  }\n}\n\nfragment MatchRelevanceProvider_vacancy on Vacancy {\n  id\n  code\n  skillGroups {\n    id\n    skillGroupId\n    name\n    isRequired\n    weight\n    terms {\n      name\n      isSkill\n    }\n    experience {\n      durationAmount\n      durationType\n    }\n    recency {\n      durationType\n      durationAmount\n    }\n  }\n  scoringConfig {\n    industryExperience {\n      durationAmount\n      durationType\n    }\n    industryNegativeThreshold\n    industryPositiveThreshold\n    industryRecency {\n      durationAmount\n      durationType\n    }\n    relevanceNegativeThreshold\n    relevancePositiveThreshold\n    relevantExperience {\n      durationAmount\n      durationType\n    }\n    relevantRecency {\n      durationAmount\n      durationType\n    }\n  }\n}\n\nfragment MatchSearchContainerFragment_2VV6jB on Query {\n  result: recruitVacancyProfileMatchSearch(input: $input) {\n    ...VacancyMatchSearchActiveFilters_results\n    ...MatchSearchFilters_results\n    ...MatchSearchPaging_results\n    pagination {\n      totalResults\n      itemsPerPage\n      pageNumber\n      pages\n    }\n    aggregations {\n      sourceTypes {\n        ...MultiFacetContainer_facet\n      }\n      standard {\n        companies {\n          ...AggregationTags_Aggregation\n        }\n        escoLevel1 {\n          ...AggregationTags_Aggregation\n        }\n        escoLevel2 {\n          ...AggregationTags_Aggregation\n        }\n        escoLevel3 {\n          ...AggregationTags_Aggregation\n        }\n        escoLevel4 {\n          ...AggregationTags_Aggregation\n        }\n        escoLevel5 {\n          ...AggregationTags_Aggregation\n        }\n        industries {\n          ...AggregationTags_Aggregation\n        }\n        skills {\n          ...AggregationTags_Aggregation\n        }\n        ...ProfileFacetsListFragment\n      }\n    }\n    matches {\n      id\n      code\n      createdOn\n      companyScore\n      jobMatchScore\n      totalScore\n      matchRelevance {\n        ...MatchRelevanceProvider_relevance\n      }\n      matchProfile {\n        ...MatchRelevanceProvider_matchProfile\n      }\n      vacancy {\n        ...MatchRelevanceProvider_vacancy\n        id\n        code\n      }\n      candidate {\n        firstName\n        lastName\n        email\n        phone {\n          phoneCountryCode\n          phoneCountryPrefix\n          phoneNumber\n        }\n        id\n      }\n      profile {\n        ...RecruitProfileHeader_profile\n        ...RecruitProfileApplicationHeader_application\n        id\n      }\n      ...MatchSearchList_match\n    }\n  }\n}\n\nfragment MatchSearchFilters_results on ProfileMatchSearchResults {\n  aggregations {\n    standard {\n      ...ProfileSkillsFacetsContainer_facets\n      skills {\n        count\n        ...MultiFacetContainer_facet\n      }\n      companies {\n        count\n        ...MultiFacetContainer_facet\n      }\n      industries {\n        count\n        ...MultiFacetContainer_facet\n      }\n      escoLevel1 {\n        count\n        ...MultiFacetContainer_facet\n      }\n    }\n  }\n}\n\nfragment MatchSearchList_match on RecruitVacancyProfileMatch {\n  code\n  vacancy {\n    code\n    id\n    ...MatchRelevanceProvider_vacancy\n  }\n  recommendation {\n    rightToWorkStatus\n    id\n  }\n  profile {\n    rate {\n      countryCode\n      currencyCode\n      maximumRateOfPay\n      minimumRateOfPay\n      payType\n      id\n    }\n    availability {\n      availabilityStatus\n      availability {\n        __typename\n        ... on CandidateAvailableFromDate {\n          date\n        }\n        ... on CandidateAvailableImmediately {\n          immediately\n        }\n        ... on CandidateAvailableNotice {\n          notice\n          timeframe\n        }\n      }\n      id\n    }\n    recruitProfileId\n    ...CandidateApplicationProfile_profile\n    ...DetailsComponent_profile\n    ...RecruitProfileApplicationHeader_application\n    id\n  }\n  candidate {\n    accountId\n    ...DetailsComponent_candidate\n    id\n  }\n  matchRelevance {\n    ...MatchRelevanceProvider_relevance\n  }\n  matchProfile {\n    ...MatchRelevanceProvider_matchProfile\n  }\n}\n\nfragment MatchSearchPaging_results on ProfileMatchSearchResults {\n  pagination {\n    pages\n    pageNumber\n    itemsPerPage\n    totalResults\n  }\n}\n\nfragment MultiFacetContainer_facet on DefaultAggregationModel {\n  count\n  key\n  title\n  values {\n    count\n    isSelected\n    name\n    text\n  }\n}\n\nfragment ProfileFacetsListFragment on StandardAggregationResults {\n  companies {\n    count\n    ...TagFacetFragment\n  }\n  escoLevel1 {\n    count\n    ...TagFacetFragment\n  }\n  escoLevel2 {\n    count\n    ...TagFacetFragment\n  }\n  escoLevel3 {\n    count\n    ...TagFacetFragment\n  }\n  escoLevel4 {\n    count\n    ...TagFacetFragment\n  }\n  escoLevel5 {\n    count\n    ...TagFacetFragment\n  }\n  industries {\n    count\n    ...TagFacetFragment\n  }\n  skills {\n    count\n    ...TagFacetFragment\n  }\n}\n\nfragment ProfileSkillsFacetsContainer_facets on StandardAggregationResults {\n  skills {\n    count\n    ...MultiFacetContainer_facet\n  }\n}\n\nfragment RecruitProfileApplicationHeader_application on RecruitProfile {\n  id\n  firstName\n  lastName\n  workLocations {\n    currentLocationName\n    currentLocationCountryName\n    workLocations {\n      name\n    }\n    id\n  }\n  currentPosition {\n    title\n    companyName\n    startDate\n    endDate\n    id\n  }\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n  availability {\n    jobSearchStatus\n    availabilityStatus\n    noticeCriteria {\n      availableFrom\n      noticePeriodWeeks\n      noticeTimeframe\n    }\n    id\n  }\n}\n\nfragment RecruitProfileHeader_profile on RecruitProfile {\n  ...RecruitProfileApplicationHeader_application\n  id\n  recruitProfileId\n  firstName\n  lastName\n  profileType\n  workLocations {\n    currentLocationName\n    currentLocationCountryName\n    id\n  }\n  account {\n    accountId\n    id\n  }\n  currentPosition {\n    title\n    companyName\n    startDate\n    endDate\n    id\n  }\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n  rightToWork {\n    status\n    id\n  }\n  availability {\n    jobSearchStatus\n    id\n  }\n}\n\nfragment TagFacetFragment on DefaultAggregationModel {\n  count\n  key\n  title\n  values {\n    count\n    isSelected\n    name\n    text\n  }\n}\n\nfragment VacancyApplicationSearchFacets_results on StandardAggregationResults {\n  ...ProfileSkillsFacetsContainer_facets\n  companies {\n    count\n    ...MultiFacetContainer_facet\n  }\n  industries {\n    count\n    ...MultiFacetContainer_facet\n  }\n}\n\nfragment VacancyMatchSearchActiveFilters_results on ProfileMatchSearchResults {\n  pagination {\n    totalResults\n    itemsPerPage\n    pageNumber\n    pages\n  }\n  aggregations {\n    sourceTypes {\n      ...AggregationTags_Aggregation\n    }\n    standard {\n      companies {\n        ...AggregationTags_Aggregation\n      }\n      escoLevel1 {\n        ...AggregationTags_Aggregation\n      }\n      escoLevel2 {\n        ...AggregationTags_Aggregation\n      }\n      escoLevel3 {\n        ...AggregationTags_Aggregation\n      }\n      escoLevel4 {\n        ...AggregationTags_Aggregation\n      }\n      escoLevel5 {\n        ...AggregationTags_Aggregation\n      }\n      industries {\n        ...AggregationTags_Aggregation\n      }\n      skills {\n        ...AggregationTags_Aggregation\n      }\n      ...VacancyApplicationSearchFacets_results\n    }\n  }\n}\n"
    }
  };
}();
node271.hash = "cc58769b9c33000d69abd5a88fa93125";
var MatchSearchListFragment_graphql_default = node271;

// src/matches/recruiter/components/__generated__/MatchSearchContainerFragment.graphql.ts
var node273 = function() {
  var v0 = [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AggregationTags_Aggregation"
    }
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "refetch": {
        "connection": null,
        "fragmentPathInResult": [],
        "operation": MatchSearchListFragment_graphql_default
      }
    },
    "name": "MatchSearchContainerFragment",
    "selections": [
      {
        "alias": "result",
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "ProfileMatchSearchResults",
        "kind": "LinkedField",
        "name": "recruitVacancyProfileMatchSearch",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "VacancyMatchSearchActiveFilters_results"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "MatchSearchFilters_results"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "MatchSearchPaging_results"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CollectionMetaData",
            "kind": "LinkedField",
            "name": "pagination",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalResults",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "itemsPerPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pageNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pages",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MatchSearchAggregations",
            "kind": "LinkedField",
            "name": "aggregations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "sourceTypes",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "MultiFacetContainer_facet"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "StandardAggregationResults",
                "kind": "LinkedField",
                "name": "standard",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DefaultAggregationModel",
                    "kind": "LinkedField",
                    "name": "companies",
                    "plural": false,
                    "selections": v0,
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DefaultAggregationModel",
                    "kind": "LinkedField",
                    "name": "escoLevel1",
                    "plural": false,
                    "selections": v0,
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DefaultAggregationModel",
                    "kind": "LinkedField",
                    "name": "escoLevel2",
                    "plural": false,
                    "selections": v0,
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DefaultAggregationModel",
                    "kind": "LinkedField",
                    "name": "escoLevel3",
                    "plural": false,
                    "selections": v0,
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DefaultAggregationModel",
                    "kind": "LinkedField",
                    "name": "escoLevel4",
                    "plural": false,
                    "selections": v0,
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DefaultAggregationModel",
                    "kind": "LinkedField",
                    "name": "escoLevel5",
                    "plural": false,
                    "selections": v0,
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DefaultAggregationModel",
                    "kind": "LinkedField",
                    "name": "industries",
                    "plural": false,
                    "selections": v0,
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DefaultAggregationModel",
                    "kind": "LinkedField",
                    "name": "skills",
                    "plural": false,
                    "selections": v0,
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ProfileFacetsListFragment"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitVacancyProfileMatch",
            "kind": "LinkedField",
            "name": "matches",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              v1,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdOn",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "companyScore",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "jobMatchScore",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalScore",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitMatchRelevanceContainer",
                "kind": "LinkedField",
                "name": "matchRelevance",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "MatchRelevanceProvider_relevance"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitMatchProfile",
                "kind": "LinkedField",
                "name": "matchProfile",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "MatchRelevanceProvider_matchProfile"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Vacancy",
                "kind": "LinkedField",
                "name": "vacancy",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "MatchRelevanceProvider_vacancy"
                  },
                  v1
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountsCandidateAccount",
                "kind": "LinkedField",
                "name": "candidate",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "email",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CandidatePhoneVerification",
                    "kind": "LinkedField",
                    "name": "phone",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "phoneCountryCode",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "phoneCountryPrefix",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "phoneNumber",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitProfile",
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "RecruitProfileHeader_profile"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "RecruitProfileApplicationHeader_application"
                  }
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "MatchSearchList_match"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node273.hash = "cc58769b9c33000d69abd5a88fa93125";
var MatchSearchContainerFragment_graphql_default = node273;

// src/matches/recruiter/components/MatchSearchContainer.tsx
import {
  Suspense as Suspense89,
  memo as memo4,
  useCallback as useCallback138,
  useEffect as useEffect34,
  useMemo as useMemo36,
  useTransition as useTransition12
} from "react";
import { useQueryLoader as useQueryLoader12 } from "react-relay";
import { useAtom as useAtom12 } from "jotai";
import { useHydrateAtoms as useHydrateAtoms3 } from "jotai/utils";
import { EdSkeleton as EdSkeleton76, Loading as Loading7 } from "shared-ui";

// src/matches/recruiter/lib/MatchSearch.ts
import { atom as atom11 } from "jotai";
import { atomWithStorage as atomWithStorage3 } from "jotai/utils";
import { SortDir as SortDir6 } from "shared-ui";
var matchSortFields2 = [
  {
    id: "BEST_MATCH" /* BEST_MATCH */,
    name: "Sort by 'Rank'"
  },
  {
    id: "NAME" /* NAME */,
    name: "Sort by 'Name'"
  },
  {
    id: "TOTAL_SCORE" /* TOTAL_SCORE */,
    name: "Sort by 'Total Score'"
  }
];
var matchSortFieldAtom = atomWithStorage3(
  "matchSortField",
  "BEST_MATCH" /* BEST_MATCH */
);
var matchSortDirAtom = atomWithStorage3(
  "matchSortDir",
  SortDir6.Asc
);
function matchSortFieldToGraphQL(sort) {
  switch (sort) {
    case "BEST_MATCH" /* BEST_MATCH */: {
      return {
        standard: "BEST_MATCH"
      };
    }
    case "NAME" /* NAME */: {
      return {
        standard: "NAME"
      };
    }
    case "TOTAL_SCORE" /* TOTAL_SCORE */: {
      return {
        custom: "TOTAL_SCORE"
      };
    }
  }
}
var profileMatchSearchInputAtom = atom11({
  filters: {},
  fullTextSearch: {
    query: "",
    queryField: {
      standard: "ALL"
    }
  },
  pagination: {
    pageNumber: 1,
    pageSize: 20
  },
  sort: {
    field: {
      standard: "BEST_MATCH"
    },
    order: "DESC"
  }
});

// src/matches/recruiter/components/MatchSearch.tsx
import { Suspense as Suspense88, useCallback as useCallback137 } from "react";
import {
  usePreloadedQuery as usePreloadedQuery27,
  useRefetchableFragment as useRefetchableFragment11
} from "react-relay";
import { useAtom as useAtom11 } from "jotai";
import { Button as Button67, IconText as IconText4, Icons as Icons5, classNames as classNames32 } from "shared-ui";
import { useToggle as useToggle28 } from "shared-lib";
import { MultiFacetContainer as MultiFacetContainer5 } from "app-core";

// src/matches/recruiter/components/MatchSearchQuery.tsx
import { useCallback as useCallback131 } from "react";
import { useAtomValue as useAtomValue8 } from "jotai";
import { MagnifyingGlassIcon as MagnifyingGlassIcon3 } from "@heroicons/react/20/solid";
import { DebouncedInput as DebouncedInput4 } from "shared-ui";
import { jsx as jsx256, jsxs as jsxs169 } from "react/jsx-runtime";
var MatchSearchQuery = ({ onSearch }) => {
  const search4 = useAtomValue8(profileMatchSearchInputAtom);
  const onQueryChanged = useCallback131(
    (query3) => {
      const newSearch = {
        ...search4,
        fullTextSearch: {
          query: query3,
          queryField: {
            standard: "ALL"
          }
        }
      };
      onSearch("MatchSearchQuery", newSearch);
    },
    [onSearch]
  );
  return /* @__PURE__ */ jsxs169("div", { className: "flex w-full ", children: [
    /* @__PURE__ */ jsx256("label", { htmlFor: "search-field", className: "sr-only", children: "Search" }),
    /* @__PURE__ */ jsxs169("div", { className: "relative w-full text-gray-400 focus-within:text-gray-600", children: [
      /* @__PURE__ */ jsx256("div", { className: "pointer-events-none absolute inset-y-0 right-1 flex items-center", children: /* @__PURE__ */ jsx256(
        MagnifyingGlassIcon3,
        {
          className: "h-5 w-5 flex-shrink-0",
          "aria-hidden": "true"
        }
      ) }),
      /* @__PURE__ */ jsx256(
        DebouncedInput4,
        {
          placeholder: "Search",
          value: search4.fullTextSearch?.query || "",
          onValueChanged: onQueryChanged
        }
      )
    ] })
  ] });
};

// src/matches/recruiter/components/MatchSearchSortDir.tsx
import { useCallback as useCallback133 } from "react";
import { useAtomValue as useAtomValue9 } from "jotai";
import { getSortDirFromGraphQL as getSortDirFromGraphQL2, sortDirToGraphQL as sortDirToGraphQL4 } from "shared-ui";
import { jsx as jsx257 } from "react/jsx-runtime";
var MatchSearchSortDir = ({ onSearch }) => {
  const search4 = useAtomValue9(profileMatchSearchInputAtom);
  const onSortChanged = useCallback133(
    (value) => {
      const newSearch = {
        ...search4,
        sort: {
          ...search4.sort,
          order: sortDirToGraphQL4(value)
        }
      };
      onSearch("MatchSearchSortDir", newSearch);
    },
    [search4, onSearch]
  );
  return /* @__PURE__ */ jsx257("div", { children: /* @__PURE__ */ jsx257(
    SortDirectionList,
    {
      value: getSortDirFromGraphQL2(search4.sort.order),
      onChanged: onSortChanged
    }
  ) });
};

// src/matches/recruiter/components/MatchSearchSortFields.tsx
import { useCallback as useCallback134 } from "react";
import { useAtomValue as useAtomValue10 } from "jotai";
import { jsx as jsx258 } from "react/jsx-runtime";
function getMatchSearchSortField(sort) {
  if (sort.standard && sort.standard === "BEST_MATCH") {
    return "BEST_MATCH" /* BEST_MATCH */;
  }
  if (sort.standard && sort.standard === "NAME") {
    return "NAME" /* NAME */;
  }
  if (sort.custom && sort.custom === "TOTAL_SCORE") {
    return "TOTAL_SCORE" /* TOTAL_SCORE */;
  }
  return "BEST_MATCH" /* BEST_MATCH */;
}
var MatchSearchSortFields = ({ onSearch }) => {
  const search4 = useAtomValue10(profileMatchSearchInputAtom);
  const onSortChanged = useCallback134(
    (value) => {
      const newSearch = {
        ...search4,
        sort: {
          ...search4.sort,
          field: matchSortFieldToGraphQL(value)
        }
      };
      onSearch("MatchSearchSortFields", newSearch);
    },
    [search4, onSearch]
  );
  return /* @__PURE__ */ jsx258(
    "select",
    {
      id: "matchSearchSortFields",
      name: "matchSearchSortFields",
      value: getMatchSearchSortField(search4.sort.field),
      className: "focus:ring-primary-500 focus:border-primary-500 block w-full rounded-md border-gray-300",
      onChange: (e4) => onSortChanged(e4.target.value),
      children: matchSortFields2.map((i4) => /* @__PURE__ */ jsx258("option", { value: i4.id, children: i4.name }, i4.id))
    }
  );
};

// src/matches/recruiter/components/__generated__/MatchSearchPaging_results.graphql.ts
var node274 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MatchSearchPaging_results",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CollectionMetaData",
      "kind": "LinkedField",
      "name": "pagination",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pages",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pageNumber",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "itemsPerPage",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalResults",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__id",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "ProfileMatchSearchResults",
  "abstractKey": null
};
node274.hash = "194b06719980568b391beade1ace9db2";
var MatchSearchPaging_results_graphql_default = node274;

// src/matches/recruiter/components/MatchSearchPaging.tsx
import { useCallback as useCallback135 } from "react";
import { useFragment as useFragment74 } from "react-relay";
import { useAtomValue as useAtomValue11 } from "jotai";
import { SimplePagination as SimplePagination4, SimplePaginationCounts as SimplePaginationCounts2 } from "shared-ui";
import { jsx as jsx259, jsxs as jsxs170 } from "react/jsx-runtime";
var fragmentDef59 = MatchSearchPaging_results_graphql_default;
var MatchSearchPaging = ({ fragmentRef, onSearch }) => {
  const data = useFragment74(
    fragmentDef59,
    fragmentRef
  );
  const search4 = useAtomValue11(profileMatchSearchInputAtom);
  const onPage = useCallback135(
    (p4) => {
      const newSearch = {
        ...search4,
        pagination: {
          ...search4.pagination,
          pageNumber: p4
        }
      };
      onSearch("MatchSearchPaging", newSearch);
    },
    [search4, onSearch]
  );
  return /* @__PURE__ */ jsxs170("div", { className: "flex flex-col items-end", children: [
    /* @__PURE__ */ jsx259(
      SimplePaginationCounts2,
      {
        pages: data.pagination.pages,
        pageNumber: data.pagination.pageNumber,
        itemsPerPage: data.pagination.itemsPerPage,
        totalResults: data.pagination.totalResults
      }
    ),
    data.pagination.pages > 1 && /* @__PURE__ */ jsx259(
      SimplePagination4,
      {
        name: "vacancy-application-search-paging",
        pages: data.pagination.pages,
        pageNumber: data.pagination.pageNumber,
        itemsPerPage: data.pagination.itemsPerPage,
        totalResults: data.pagination.totalResults,
        onPage
      }
    )
  ] });
};

// src/matches/recruiter/components/__generated__/MatchSearchFilters_results.graphql.ts
var node275 = function() {
  var v0 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "count",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MultiFacetContainer_facet"
    }
  ];
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "MatchSearchFilters_results",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MatchSearchAggregations",
        "kind": "LinkedField",
        "name": "aggregations",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StandardAggregationResults",
            "kind": "LinkedField",
            "name": "standard",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ProfileSkillsFacetsContainer_facets"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "skills",
                "plural": false,
                "selections": v0,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "companies",
                "plural": false,
                "selections": v0,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "industries",
                "plural": false,
                "selections": v0,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "escoLevel1",
                "plural": false,
                "selections": v0,
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "kind": "ClientExtension",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__id",
            "storageKey": null
          }
        ]
      }
    ],
    "type": "ProfileMatchSearchResults",
    "abstractKey": null
  };
}();
node275.hash = "343fba10c10916b5473e78af3ba27bfa";
var MatchSearchFilters_results_graphql_default = node275;

// src/matches/recruiter/components/MatchSearchFilters.tsx
import { useCallback as useCallback136, useState as useState76 } from "react";
import { useFragment as useFragment75 } from "react-relay";
import { useAtom as useAtom10 } from "jotai";
import {
  classNames as classNames30,
  FilterSectionContainer as FilterSectionContainer3,
  FilterSectionLink as FilterSectionLink3
} from "shared-ui";
import { MultiFacetContainer as MultiFacetContainer4 } from "app-core";
import { noop as noop9 } from "shared-lib";
import { jsx as jsx260, jsxs as jsxs171 } from "react/jsx-runtime";
var fragmentDef60 = MatchSearchFilters_results_graphql_default;
var filterSections2 = [
  { key: "SKILLS", title: "Skills" },
  { key: "INDUSTRIES", title: "Industries" },
  { key: "COMPANIES", title: "Companies" },
  { key: "ESCOLEVEL1", title: "Esco Level 1" }
];
var MatchSearchFilters = ({ fragmentRef, onSearch }) => {
  const [searchInput] = useAtom10(profileMatchSearchInputAtom);
  const result = useFragment75(
    fragmentDef60,
    fragmentRef
  );
  const [selectedSection, setSelectedSection] = useState76(
    null
  );
  const sections = filterSections2.map((s4) => {
    return /* @__PURE__ */ jsx260(
      FilterSectionLink3,
      {
        section: s4,
        onSelect: setSelectedSection,
        selectedKey: selectedSection
      },
      s4.key
    );
  });
  const onStandardFilterChange = useCallback136(
    (change) => {
      const payload = {
        ...searchInput,
        filters: {
          ...searchInput.filters,
          standard: {
            ...searchInput.filters?.standard,
            ...change
          }
        }
      };
      onSearch("MatchSearchStandardFilters", payload);
    },
    [searchInput, onSearch]
  );
  const onCompaniesChanged = useCallback136(
    (selected) => {
      onStandardFilterChange({
        companies: selected
      });
    },
    [onStandardFilterChange]
  );
  const onIndustriesChanged = useCallback136(
    (selected) => {
      onStandardFilterChange({
        industries: selected
      });
    },
    [onStandardFilterChange]
  );
  const onEsco1Changed = useCallback136(
    (selected) => {
      onStandardFilterChange({
        escoLevel1: selected
      });
    },
    [onStandardFilterChange]
  );
  const onSkillsChanged = useCallback136(
    (selected) => {
      onStandardFilterChange({
        skills: selected
      });
    },
    [onStandardFilterChange]
  );
  return /* @__PURE__ */ jsx260("div", { className: classNames30("w-full rounded-2xl border bg-white"), children: /* @__PURE__ */ jsxs171(
    FilterSectionContainer3,
    {
      sections,
      isFiltersOpen: true,
      onToggleOpen: noop9,
      hasSelectedValue: selectedSection !== null,
      toggleSelectedValue: () => setSelectedSection(null),
      children: [
        selectedSection === "COMPANIES" && /* @__PURE__ */ jsx260(
          MultiFacetContainer4,
          {
            fragmentRef: result.aggregations.standard.companies,
            onFacetChanged: onCompaniesChanged
          }
        ),
        selectedSection === "SKILLS" && /* @__PURE__ */ jsx260(
          ProfileSkillsFacetsContainer,
          {
            fragmentRef: result.aggregations.standard,
            onChanged: onSkillsChanged
          }
        ),
        selectedSection === "INDUSTRIES" && /* @__PURE__ */ jsx260(
          MultiFacetContainer4,
          {
            fragmentRef: result.aggregations.standard.industries,
            onFacetChanged: onIndustriesChanged
          }
        ),
        selectedSection === "ESCOLEVEL1" && /* @__PURE__ */ jsx260(
          MultiFacetContainer4,
          {
            fragmentRef: result.aggregations.standard.escoLevel1,
            onFacetChanged: onEsco1Changed
          }
        )
      ]
    }
  ) });
};

// src/candidates/components/__generated__/VacancyMatchSearchActiveFilters_results.graphql.ts
var node276 = function() {
  var v0 = [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AggregationTags_Aggregation"
    }
  ];
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "VacancyMatchSearchActiveFilters_results",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CollectionMetaData",
        "kind": "LinkedField",
        "name": "pagination",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalResults",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "itemsPerPage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pageNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pages",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MatchSearchAggregations",
        "kind": "LinkedField",
        "name": "aggregations",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DefaultAggregationModel",
            "kind": "LinkedField",
            "name": "sourceTypes",
            "plural": false,
            "selections": v0,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StandardAggregationResults",
            "kind": "LinkedField",
            "name": "standard",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "companies",
                "plural": false,
                "selections": v0,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "escoLevel1",
                "plural": false,
                "selections": v0,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "escoLevel2",
                "plural": false,
                "selections": v0,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "escoLevel3",
                "plural": false,
                "selections": v0,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "escoLevel4",
                "plural": false,
                "selections": v0,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "escoLevel5",
                "plural": false,
                "selections": v0,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "industries",
                "plural": false,
                "selections": v0,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "skills",
                "plural": false,
                "selections": v0,
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "VacancyApplicationSearchFacets_results"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "kind": "ClientExtension",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__id",
            "storageKey": null
          }
        ]
      }
    ],
    "type": "ProfileMatchSearchResults",
    "abstractKey": null
  };
}();
node276.hash = "f9af31d026e6ab669098a39ff39cfd80";
var VacancyMatchSearchActiveFilters_results_graphql_default = node276;

// src/candidates/components/VacancyMatchSearchActiveFilters.tsx
import { Suspense as Suspense86 } from "react";
import { useFragment as useFragment76 } from "react-relay";
import { AggregationTags as AggregationTags3, DisplayFieldEnum as DisplayFieldEnum3 } from "shared-ui";
import { jsx as jsx261, jsxs as jsxs173 } from "react/jsx-runtime";
var fragmentDef61 = VacancyMatchSearchActiveFilters_results_graphql_default;
var VacancyMatchSearchActiveFilters = ({
  fragmentRef,
  onDeselect
}) => {
  const data = useFragment76(
    fragmentDef61,
    fragmentRef
  );
  return /* @__PURE__ */ jsx261(Suspense86, { fallback: "Loading...", children: /* @__PURE__ */ jsx261("div", { className: "flex justify-between gap-5", children: /* @__PURE__ */ jsxs173("div", { className: "flex flex-wrap gap-1", children: [
    /* @__PURE__ */ jsx261(
      AggregationTags3,
      {
        fragmentRef: data.aggregations.sourceTypes,
        displayField: DisplayFieldEnum3.text,
        onSelected: (value) => onDeselect({ source: "sourceTypes", value, isStandard: true })
      }
    ),
    /* @__PURE__ */ jsx261(
      AggregationTags3,
      {
        fragmentRef: data.aggregations.standard.companies,
        onSelected: (value) => onDeselect({ source: "industries", value, isStandard: true })
      }
    ),
    /* @__PURE__ */ jsx261(
      AggregationTags3,
      {
        fragmentRef: data.aggregations.standard.industries,
        onSelected: (value) => onDeselect({ source: "industries", value, isStandard: true })
      }
    ),
    /* @__PURE__ */ jsx261(
      AggregationTags3,
      {
        fragmentRef: data.aggregations.standard.skills,
        displayField: DisplayFieldEnum3.text,
        onSelected: (value) => onDeselect({ source: "skills", value, isStandard: true })
      }
    ),
    /* @__PURE__ */ jsx261(
      AggregationTags3,
      {
        fragmentRef: data.aggregations.standard.escoLevel1,
        onSelected: (value) => onDeselect({ source: "escoLevel1", value, isStandard: true })
      }
    ),
    /* @__PURE__ */ jsx261(
      AggregationTags3,
      {
        fragmentRef: data.aggregations.standard.escoLevel2,
        onSelected: (value) => onDeselect({ source: "escoLevel2", value, isStandard: true })
      }
    ),
    /* @__PURE__ */ jsx261(
      AggregationTags3,
      {
        fragmentRef: data.aggregations.standard.escoLevel3,
        onSelected: (value) => onDeselect({ source: "escoLevel3", value, isStandard: true })
      }
    ),
    /* @__PURE__ */ jsx261(
      AggregationTags3,
      {
        fragmentRef: data.aggregations.standard.escoLevel4,
        onSelected: (value) => onDeselect({ source: "escoLevel4", value, isStandard: true })
      }
    ),
    /* @__PURE__ */ jsx261(
      AggregationTags3,
      {
        fragmentRef: data.aggregations.standard.escoLevel5,
        onSelected: (value) => onDeselect({ source: "escoLevel5", value, isStandard: true })
      }
    )
  ] }) }) });
};

// src/matches/recruiter/components/__generated__/MatchSearchList_match.graphql.ts
var node277 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "MatchSearchList_match",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "concreteType": "Vacancy",
        "kind": "LinkedField",
        "name": "vacancy",
        "plural": false,
        "selections": [
          v0,
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "MatchRelevanceProvider_vacancy"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitRecommendation",
        "kind": "LinkedField",
        "name": "recommendation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rightToWorkStatus",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitProfile",
        "kind": "LinkedField",
        "name": "profile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitProfileRate",
            "kind": "LinkedField",
            "name": "rate",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "countryCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currencyCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "maximumRateOfPay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "minimumRateOfPay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "payType",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitProfileAvailability",
            "kind": "LinkedField",
            "name": "availability",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "availabilityStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "availability",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "date",
                        "storageKey": null
                      }
                    ],
                    "type": "CandidateAvailableFromDate",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "immediately",
                        "storageKey": null
                      }
                    ],
                    "type": "CandidateAvailableImmediately",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "notice",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "timeframe",
                        "storageKey": null
                      }
                    ],
                    "type": "CandidateAvailableNotice",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "recruitProfileId",
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CandidateApplicationProfile_profile"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DetailsComponent_profile"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RecruitProfileApplicationHeader_application"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsCandidateAccount",
        "kind": "LinkedField",
        "name": "candidate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DetailsComponent_candidate"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitMatchRelevanceContainer",
        "kind": "LinkedField",
        "name": "matchRelevance",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "MatchRelevanceProvider_relevance"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitMatchProfile",
        "kind": "LinkedField",
        "name": "matchProfile",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "MatchRelevanceProvider_matchProfile"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RecruitVacancyProfileMatch",
    "abstractKey": null
  };
}();
node277.hash = "8deb158857dfeb162c134a6a7a6d82bd";
var MatchSearchList_match_graphql_default = node277;

// src/matches/recruiter/components/MatchSearchList.tsx
import {
  isValidElement as isValidElement5,
  useState as useState77,
  Suspense as Suspense87
} from "react";
import {
  useFragment as useFragment77,
  usePreloadedQuery as usePreloadedQuery26,
  useRefetchableFragment as useRefetchableFragment10
} from "react-relay";
import { EdButtonLink as EdButtonLink5, Tag as Tag16, classNames as classNames31 } from "shared-ui";
import { Fragment as Fragment63, jsx as jsx263, jsxs as jsxs174 } from "react/jsx-runtime";
var tabs4 = [
  { name: "Relevance", to: "relevance" },
  { name: "Work History", to: "profile" },
  { name: "Details", to: "details" },
  { name: "Application History", to: "application-history" },
  { name: "Recommendation History", to: "recommendation-history" }
];
var MatchSearchList = ({
  queryRef: queryRef3,
  isLoading
}) => {
  const query3 = usePreloadedQuery26(
    matchSearchContainerQueryDef,
    queryRef3
  );
  const [result, refetch] = useRefetchableFragment10(matchSearchContainerFragmentDef, query3);
  const matches = result.result.matches || [];
  return /* @__PURE__ */ jsxs174("div", { className: "flex w-full flex-wrap gap-3", children: [
    matches?.length == 0 && /* @__PURE__ */ jsx263("div", { className: "flex h-[400px] w-full items-center justify-center rounded-2xl border-2 border-dashed text-center text-2xl text-gray-700", children: "No matches found" }),
    matches.map((match) => /* @__PURE__ */ jsx263(Match, { fragmentRef: match }, match.id))
  ] });
};
function Match({ fragmentRef }) {
  const match = useFragment77(
    Match.fragments.match,
    fragmentRef
  );
  const [selectedTab, setSelectedTab] = useState77("");
  return /* @__PURE__ */ jsxs174(
    "div",
    {
      className: "w-full overflow-hidden rounded-2xl shadow-md",
      children: [
        /* @__PURE__ */ jsxs174(
          "div",
          {
            className: "items-top flex w-full flex-col justify-between gap-2 border-b bg-white pb-2 lg:px-5 lg:pt-5",
            children: [
              /* @__PURE__ */ jsxs174(
                RecruitProfileApplicationHeader,
                {
                  fragmentRef: match.profile,
                  applicationUrl: `../../../../../view/${match.vacancy?.code}/matches/${match.code}`,
                  children: [
                    match.recommendation && /* @__PURE__ */ jsx263("div", { className: "font-bold", children: /* @__PURE__ */ jsx263(
                      RightToWorkStatus,
                      {
                        status: match.recommendation.rightToWorkStatus
                      }
                    ) }),
                    match.profile.rate && /* @__PURE__ */ jsxs174("div", { className: "flex flex-col gap-2", children: [
                      /* @__PURE__ */ jsx263("div", { className: "flex w-full justify-start font-bold", children: /* @__PURE__ */ jsx263(RateLabel, { rate: match.profile.rate }) }),
                      match.profile.availability && /* @__PURE__ */ jsx263("div", { children: /* @__PURE__ */ jsxs174(Tag16, { children: [
                        match.profile.availability.availability.__typename === "CandidateAvailableImmediately" && /* @__PURE__ */ jsx263("div", { children: "Available Immediately" }),
                        match.profile.availability.availability.__typename === "CandidateAvailableNotice" && /* @__PURE__ */ jsxs174("div", { children: [
                          /* @__PURE__ */ jsxs174("div", { className: "flex items-center", children: [
                            "Available on",
                            " ",
                            match.profile.availability.availability.timeframe
                          ] }),
                          /* @__PURE__ */ jsxs174("div", { children: [
                            match.profile.availability.availability.notice,
                            " ",
                            "notice"
                          ] })
                        ] }),
                        match.profile.availability.availability.__typename === "CandidateAvailableFromDate" && /* @__PURE__ */ jsxs174("div", { children: [
                          /* @__PURE__ */ jsx263("div", { className: "flex items-center", children: "Available From Date" }),
                          /* @__PURE__ */ jsx263("div", { children: match.profile.availability.availability.date })
                        ] })
                      ] }) })
                    ] })
                  ]
                }
              ),
              /* @__PURE__ */ jsx263(
                MatchRelevanceProvider,
                {
                  sentences: [],
                  matchProfileFragmentRef: match.matchProfile,
                  matchRelevanceFragmentRef: match.matchRelevance,
                  vacancyFragmentRef: match.vacancy,
                  children: /* @__PURE__ */ jsx263(MatchRelevanceScores, {})
                }
              ),
              /* @__PURE__ */ jsx263("div", { children: /* @__PURE__ */ jsx263(DeferredResumeDownload, { profileId: match.profile.recruitProfileId }) })
            ]
          },
          match.code
        ),
        /* @__PURE__ */ jsxs174("div", { className: "flex flex-wrap items-center justify-between bg-gray-100", children: [
          /* @__PURE__ */ jsx263("div", { className: "flex w-full flex-wrap gap-1 p-2", children: tabs4.map((tab) => /* @__PURE__ */ jsx263(
            "div",
            {
              onClick: () => {
                if (selectedTab === tab.name) {
                  setSelectedTab("");
                } else {
                  setSelectedTab(tab.name);
                }
              },
              children: /* @__PURE__ */ jsx263("div", { children: /* @__PURE__ */ jsx263(
                Tag16,
                {
                  color: classNames31(tab.name == selectedTab ? "" : "white"),
                  className: "cursor-pointer hover:bg-gray-200",
                  children: tab.name
                }
              ) })
            },
            tab.name
          )) }),
          /* @__PURE__ */ jsx263(Suspense87, { fallback: /* @__PURE__ */ jsx263("div", { className: "px-2 pb-4", children: "Loading..." }), children: /* @__PURE__ */ jsxs174("div", { className: "w-full", children: [
            selectedTab === "Relevance" && /* @__PURE__ */ jsxs174(
              MatchProfileRelevanceProvider,
              {
                vacancyCode: Number(match.vacancy.code),
                matchCode: Number(match.code),
                children: [
                  /* @__PURE__ */ jsxs174("div", { className: "m-5 hidden flex-col gap-5 2xl:flex", children: [
                    /* @__PURE__ */ jsx263("div", { className: "rounded-md border bg-white p-5", children: /* @__PURE__ */ jsx263(MatchRelevanceProfileTimeline, {}) }),
                    /* @__PURE__ */ jsx263("div", { className: "rounded-md border bg-white p-5", children: /* @__PURE__ */ jsx263(MatchExperienceSimilarityHighlighter, {}) })
                  ] }),
                  /* @__PURE__ */ jsx263(
                    "div",
                    {
                      className: classNames31(
                        "flex flex-col gap-3 bg-white p-5 2xl:hidden"
                      ),
                      children: /* @__PURE__ */ jsx263(MatchRelevanceProfileTimelineGrid, {})
                    }
                  )
                ]
              }
            ),
            selectedTab === "Work History" && /* @__PURE__ */ jsx263(
              CandidateApplicationProfileComponent,
              {
                fragmentDef: match.profile
              }
            ),
            selectedTab === "Details" && /* @__PURE__ */ jsx263(
              DetailsComponent,
              {
                profileFragmentRef: match.profile,
                candidateFragmentRef: match.candidate
              }
            ),
            selectedTab === "Application History" && match?.candidate?.accountId ? /* @__PURE__ */ jsx263("div", { className: "bg-white p-5", children: /* @__PURE__ */ jsx263(
              CandidateApplicationHistory,
              {
                candidateId: match.candidate.accountId
              }
            ) }) : /* @__PURE__ */ jsx263(Fragment63, {}),
            selectedTab === "Recommendation History" && /* @__PURE__ */ jsx263("div", { className: "bg-white p-5", children: match.candidate?.accountId && /* @__PURE__ */ jsx263(
              CandidateRecommendationHistory,
              {
                candidateId: match.candidate.accountId
              }
            ) })
          ] }) })
        ] })
      ]
    },
    match.code
  );
}
Match.fragments = {
  match: MatchSearchList_match_graphql_default
};

// src/matches/recruiter/components/MatchSearch.tsx
import { jsx as jsx264, jsxs as jsxs175 } from "react/jsx-runtime";
var MatchSearch = ({ queryRef: queryRef3, isLoading, onSearch }) => {
  const [filters, setFilters] = useAtom11(profileMatchSearchInputAtom);
  const query3 = usePreloadedQuery27(
    matchSearchContainerQueryDef,
    queryRef3
  );
  const [data] = useRefetchableFragment11(matchSearchContainerFragmentDef, query3);
  const [showFilters, toggleFilters] = useToggle28(false);
  const { result } = data;
  const onDeselect = useCallback137(
    ({
      source,
      value,
      isStandard = false
    }) => {
      const newFilters = filters.filters;
      if (!newFilters) {
        return;
      }
      if (isStandard) {
        let standardFilters = newFilters.standard;
        if (standardFilters) {
          if (source == "skills") {
            standardFilters = standardFilters?.skills?.filter((x4) => {
              return x4.skillId !== Number(value);
            }) || [];
          } else {
            standardFilters = standardFilters[source].filter(
              (x4) => x4 !== value
            );
          }
        }
        const mappedFilters = {
          ...filters,
          filters: {
            ...filters.filters,
            standard: {
              ...filters?.filters?.standard,
              [source]: standardFilters
            }
          }
        };
        setFilters(mappedFilters);
        onSearch(source, mappedFilters);
        return;
      }
    },
    [filters, onSearch, setFilters]
  );
  const onChangedFilters = useCallback137(
    (newFilters) => {
      const newSearch = {
        ...filters,
        filters: {
          ...filters.filters,
          ...newFilters
        }
      };
      onSearch("VacancyApplicationProfileFacets onChangedFilters", newSearch);
    },
    [filters, onSearch]
  );
  return /* @__PURE__ */ jsx264(Suspense88, { fallback: "Loading...", children: /* @__PURE__ */ jsxs175("div", { className: "flex flex-col items-center justify-center gap-3 px-2", children: [
    /* @__PURE__ */ jsxs175("div", { className: "flex w-full flex-col-reverse items-center justify-between border-b pb-3 lg:flex-row", children: [
      /* @__PURE__ */ jsx264("div", { className: "-m-2 self-start", children: /* @__PURE__ */ jsx264(
        MultiFacetContainer5,
        {
          showSearch: false,
          showTitle: false,
          showInline: true,
          fragmentRef: result.aggregations.sourceTypes,
          onFacetChanged: (sourceTypes) => onChangedFilters({ sourceTypes })
        }
      ) }),
      /* @__PURE__ */ jsx264("div", { className: "flex w-full flex-col items-end gap-3", children: /* @__PURE__ */ jsx264("div", { className: "mb-2 w-full lg:max-w-[600px]", children: /* @__PURE__ */ jsx264(MatchSearchQuery, { onSearch }) }) })
    ] }),
    /* @__PURE__ */ jsxs175("div", { className: "flex w-full flex-col justify-between gap-1 lg:flex-row", children: [
      /* @__PURE__ */ jsxs175("div", { className: "flex w-full flex-row justify-between", children: [
        /* @__PURE__ */ jsx264("div", { children: /* @__PURE__ */ jsx264(
          VacancyMatchSearchActiveFilters,
          {
            fragmentRef: result,
            onDeselect
          }
        ) }),
        /* @__PURE__ */ jsx264("div", { className: "lg:hidden", children: /* @__PURE__ */ jsx264(
          Button67,
          {
            color: "primary",
            onClick: toggleFilters,
            className: "lg:hidden",
            children: /* @__PURE__ */ jsx264(IconText4, { text: "Filters", icon: Icons5.FilterHorizontal })
          }
        ) })
      ] }),
      /* @__PURE__ */ jsxs175("div", { className: "flex items-end justify-between", children: [
        /* @__PURE__ */ jsxs175("div", { className: "hidden gap-1 lg:flex", children: [
          /* @__PURE__ */ jsx264("div", { className: "flex w-[300px]", children: /* @__PURE__ */ jsx264(MatchSearchSortFields, { onSearch }) }),
          /* @__PURE__ */ jsx264(MatchSearchSortDir, { onSearch })
        ] }),
        /* @__PURE__ */ jsx264("div", { className: "hidden lg:flex ", children: /* @__PURE__ */ jsx264(MatchSearchPaging, { fragmentRef: result, onSearch }) })
      ] }),
      /* @__PURE__ */ jsxs175("div", { className: "flex lg:hidden", children: [
        /* @__PURE__ */ jsx264(MatchSearchSortFields, { onSearch }),
        /* @__PURE__ */ jsx264(MatchSearchSortDir, { onSearch })
      ] })
    ] }),
    /* @__PURE__ */ jsxs175("div", { className: "flex w-full gap-3", children: [
      /* @__PURE__ */ jsx264(
        "div",
        {
          className: classNames32(
            "w-full min-w-[400px] lg:flex lg:max-w-[400px]",
            !showFilters && "hidden"
          ),
          children: /* @__PURE__ */ jsx264(
            MatchSearchFilters,
            {
              fragmentRef: result,
              isLoading,
              onSearch
            }
          )
        }
      ),
      /* @__PURE__ */ jsx264(
        "div",
        {
          className: classNames32("w-full lg:flex", showFilters && "hidden"),
          children: /* @__PURE__ */ jsx264(MatchSearchList, { queryRef: queryRef3, isLoading })
        }
      )
    ] }),
    /* @__PURE__ */ jsx264(MatchSearchPaging, { fragmentRef: result, onSearch })
  ] }) });
};

// src/matches/recruiter/components/MatchSearchContainer.tsx
import { jsx as jsx265 } from "react/jsx-runtime";
var matchSearchContainerQueryDef = MatchSearchContainerQuery_graphql_default;
var matchSearchContainerFragmentDef = MatchSearchContainerFragment_graphql_default;
var InitializeSearchAtoms3 = ({ initialValues, children }) => {
  useHydrateAtoms3(initialValues, {
    dangerouslyForceHydrate: true
  });
  return children;
};
var MatchSearchContainerComponent = ({ vacancyId }) => {
  const vacancies = {
    byId: [vacancyId]
  };
  const defaultSearchInput = {
    filters: {
      vacancies
    },
    fullTextSearch: {
      query: "",
      queryField: {
        standard: "ALL"
      }
    },
    pagination: {
      pageNumber: 1,
      pageSize: 20
    },
    sort: {
      field: {
        standard: "BEST_MATCH"
      },
      order: "DESC"
    }
  };
  const initAtoms = useMemo36(() => {
    return [[profileMatchSearchInputAtom, defaultSearchInput]];
  }, []);
  return /* @__PURE__ */ jsx265(Suspense89, { fallback: /* @__PURE__ */ jsx265("div", { children: "Loading Container" }), children: /* @__PURE__ */ jsx265(InitializeSearchAtoms3, { initialValues: initAtoms, children: /* @__PURE__ */ jsx265(MatchSearchLoader, {}) }) });
};
var MatchSearchContainer = memo4(MatchSearchContainerComponent);
var MatchSearchLoader = () => {
  const [input, setInput] = useAtom12(profileMatchSearchInputAtom);
  const [queryReference, loadQuery48] = useQueryLoader12(
    matchSearchContainerQueryDef
  );
  const [isPending, startTransition2] = useTransition12();
  const onSearch = useCallback138(
    (source, input2) => {
      startTransition2(() => {
        setInput(input2);
        console.log(`MatchSearchLoader onSearch: Source: ${source}`);
        const searchInput = {
          input: input2
        };
        loadQuery48(searchInput, { fetchPolicy: "network-only" });
      });
    },
    [setInput, loadQuery48]
  );
  useEffect34(() => {
    if (!input) {
      return;
    }
    onSearch("MatchSearchLoader Search On Render", input);
  }, [loadQuery48]);
  if (!queryReference) {
    return /* @__PURE__ */ jsx265(EdSkeleton76, {});
  }
  return /* @__PURE__ */ jsx265(Suspense89, { fallback: /* @__PURE__ */ jsx265(Loading7, { label: "Loading matches" }), children: /* @__PURE__ */ jsx265("div", { className: "flex flex-col", children: /* @__PURE__ */ jsx265(
    MatchSearch,
    {
      queryRef: queryReference,
      isLoading: isPending,
      onSearch
    }
  ) }) });
};

// src/candidates/components/__generated__/CandidateApplicationWorkflowContainer_application.graphql.ts
var node278 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "parentId",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "workflowDefinitionId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "transitionId",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "nextStateId",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currentStateId",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "concreteType": "WorkflowActionTransition",
    "kind": "LinkedField",
    "name": "actions",
    "plural": true,
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "workflowActionTransitionId",
        "storageKey": null
      },
      v32,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "actionGroup",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "actionType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "actionName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "actionDialog",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "actionLabel",
        "storageKey": null
      },
      v4,
      v5,
      v6,
      {
        "alias": null,
        "args": null,
        "concreteType": "WorkflowSecurityContext",
        "kind": "LinkedField",
        "name": "securityContext",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "WorkflowSecurityUser",
            "kind": "LinkedField",
            "name": "users",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "owner",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "WorkflowPermission",
                "kind": "LinkedField",
                "name": "permissions",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "action",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "resource",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userType",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "concreteType": "WorkflowEventTransition",
    "kind": "LinkedField",
    "name": "events",
    "plural": true,
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "eventName",
        "storageKey": null
      },
      v4,
      v32,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "workflowEventTransitionId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "concreteType": "WorkflowTransition",
    "kind": "LinkedField",
    "name": "transitions",
    "plural": true,
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "workflowTransitionId",
        "storageKey": null
      },
      v32,
      v6,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currentStateName",
        "storageKey": null
      },
      v5,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "nextStateName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "WorkflowTransitionActivity",
        "kind": "LinkedField",
        "name": "activities",
        "plural": true,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "workflowTransitionActivityId",
            "storageKey": null
          },
          v4,
          {
            "alias": null,
            "args": null,
            "concreteType": "WorkflowActivityContext",
            "kind": "LinkedField",
            "name": "context",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "workflowActivityType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "workflowActivityParameters",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CandidateApplicationWorkflowContainer_application",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "applicationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "applicationStateId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "applicationStateName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "workflowStateId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "workflowStateName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "WorkflowDefinition",
        "kind": "LinkedField",
        "name": "workflowDefinition",
        "plural": false,
        "selections": [
          v0,
          v1,
          {
            "alias": null,
            "args": null,
            "concreteType": "WorkflowState",
            "kind": "LinkedField",
            "name": "states",
            "plural": true,
            "selections": [
              v0,
              v1,
              v23,
              {
                "alias": null,
                "args": null,
                "concreteType": "WorkflowState",
                "kind": "LinkedField",
                "name": "children",
                "plural": true,
                "selections": [
                  v0,
                  v1,
                  v23,
                  v7,
                  v8,
                  v9
                ],
                "storageKey": null
              },
              v7,
              v8,
              v9
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Application",
    "abstractKey": null
  };
}();
node278.hash = "7346a8c9917936f9472ef6034226c8df";
var CandidateApplicationWorkflowContainer_application_graphql_default = node278;

// src/candidates/components/CandidateApplicationWorkflowContainer.tsx
import { useFragment as useFragment78 } from "react-relay";

// src/workflows/lib/WorkflowDefinition.ts
import { Queue as Queue2 } from "shared-lib";
function buildWorkflow(input) {
  const index2 = {};
  const states = input.states.map(buildWorkflowState);
  const definition = {
    id: input.id,
    name: input.name,
    states,
    index: index2
  };
  (definition.states || []).forEach((state) => {
    indexStateAndTransitions(definition, state);
  });
  (definition.states || []).forEach((state) => {
    indexActionsAndEvents(definition, state);
  });
  return definition;
}
function buildWorkflowState(input) {
  return {
    ...input
  };
}
function getStateById(definition, workflowStateId) {
  return FindStates(definition, (s4) => s4.id === workflowStateId);
}
function getActions(definition, state, account) {
  const finalActions = [];
  getActionsFromTree(definition, state, account).forEach(
    (action) => {
      if (finalActions.some((a4) => a4.nextStateId == action.nextStateId)) {
        return;
      }
      if (state.id === action.nextStateId) {
        return;
      }
      const toState = state.actions.filter(
        (a4) => a4.nextStateId == action.nextStateId
      );
      if (toState.length > 1) {
        if (action.currentStateId == state.id) {
          finalActions.push(action);
          return;
        }
        const toAdd = toState.filter((a4) => a4.currentStateId == state.id);
        if (toAdd) {
          finalActions.push(action);
          return;
        }
        finalActions.push(toState[0]);
      } else {
        finalActions.push(action);
      }
    }
  );
  return finalActions;
}
function getActionsFromTree(definition, state, account) {
  const actions = [];
  let currentState = state;
  while (true) {
    filterActions(currentState, account).forEach((action) => {
      if (actions.some((a4) => a4.id === action.id)) {
        return;
      }
      actions.push(action);
    });
    if (!currentState.parentId) {
      return actions;
    }
    currentState = definition.index[currentState.parentId];
  }
}
function filterActions(state, account) {
  if (state === null) {
    return [];
  }
  return (state.actions || []).filter((at) => {
    return at.securityContext.users.filter((u4) => {
      return u4.userType === account.accountType;
    }).length > 0;
  });
}
function FindStates(definition, predicate) {
  const q4 = new Queue2();
  (definition.states || []).forEach((child) => {
    q4.enqueue(child);
  });
  while (q4.size() > 0) {
    const current = q4.dequeue();
    if (!current) {
      continue;
    }
    if (predicate(current)) {
      return current;
    }
    (current.children || []).forEach((child) => {
      q4.enqueue(child);
    });
  }
  return null;
}
function indexStateAndTransitions(definition, state) {
  definition.index[state.id] = state;
  (state.transitions || []).forEach((transition) => {
    definition.index[transition.id] = transition;
  });
  (state.children || []).forEach((childState) => {
    indexStateAndTransitions(definition, childState);
  });
}
function indexActionsAndEvents(definition, state) {
  (state.actions || []).forEach((action) => {
    definition.index[action.id] = action;
  });
  (state.events || []).forEach((event) => {
    definition.index[event.id] = event;
  });
}

// src/candidates/components/CandidateApplicationWorkflowStateActionsGroup.tsx
import { useCallback as useCallback147, useState as useState80 } from "react";
import { dispatch } from "use-bus";
import { CheckCircleIcon as CheckCircleIcon3 } from "@heroicons/react/24/outline";
import { createClientMutationId as createClientMutationId66 } from "shared-lib";
import { Button as Button71 } from "shared-ui";

// src/candidates/mutations/__generated__/UseAddApplicationTagMutation.graphql.ts
var node279 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfApplicationTag",
    "kind": "LinkedField",
    "name": "applicationTag",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitApplicationTag",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v23,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tagName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tagDataType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tagValue",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountsUser",
            "kind": "LinkedField",
            "name": "createdByUser",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "emailAddress",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v23,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseAddApplicationTagMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitApplicationTagCreatePayload",
          "kind": "LinkedField",
          "name": "recruitApplicationTagCreate",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseAddApplicationTagMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitApplicationTagCreatePayload",
          "kind": "LinkedField",
          "name": "recruitApplicationTagCreate",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "df32d31ed1b74321e3ff064a2f1664d4",
      "id": null,
      "metadata": {},
      "name": "UseAddApplicationTagMutation",
      "operationKind": "mutation",
      "text": "mutation UseAddApplicationTagMutation(\n  $input: RecruitApplicationTagCreateInput!\n) {\n  result: recruitApplicationTagCreate(input: $input) {\n    applicationTag {\n      node {\n        id\n        code\n        updatedAt\n        tagName\n        tagDataType\n        tagValue\n        createdByUser {\n          firstName\n          lastName\n          emailAddress\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node279.hash = "9d0bc020b280a3012e16e6ee8c6ef828";
var UseAddApplicationTagMutation_graphql_default = node279;

// src/candidates/mutations/UseAddApplicationTag.ts
import { useAsyncMutation as useAsyncMutation39 } from "shared-lib";
var mutationDef60 = UseAddApplicationTagMutation_graphql_default;
function useAddApplicationTag() {
  const [commit11, isBusy] = useAsyncMutation39(mutationDef60);
  return [commit11, isBusy];
}

// src/candidates/mutations/__generated__/UseApplicationWorkflowApproveMutation.graphql.ts
var node280 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfCandidateAccount",
    "kind": "LinkedField",
    "name": "candidateAccount",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsCandidateAccount",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isSignUpComplete",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAccountApproved",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v32 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseApplicationWorkflowApproveMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "AccountsCandidateAccountApprovePayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountApprove",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseApplicationWorkflowApproveMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "AccountsCandidateAccountApprovePayload",
          "kind": "LinkedField",
          "name": "accountsCandidateAccountApprove",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "f1cb3a8fdb31d2fb16e9ea82fd95d9e5",
      "id": null,
      "metadata": {},
      "name": "UseApplicationWorkflowApproveMutation",
      "operationKind": "mutation",
      "text": "mutation UseApplicationWorkflowApproveMutation(\n  $input: AccountsCandidateAccountApproveInput!\n) {\n  result: accountsCandidateAccountApprove(input: $input) {\n    candidateAccount {\n      node {\n        id\n        accountId\n        isSignUpComplete\n        isAccountApproved\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node280.hash = "9ec33a6e1375e19213dec6e48e5ab28a";
var UseApplicationWorkflowApproveMutation_graphql_default = node280;

// src/candidates/mutations/UseApplicationWorkflowApprove.ts
import { useAsyncMutation as useAsyncMutation40 } from "shared-lib";
var mutationDef61 = UseApplicationWorkflowApproveMutation_graphql_default;
function useApplicationWorkflowApprove() {
  const [commit11, isBusy] = useAsyncMutation40(mutationDef61);
  return [commit11, isBusy];
}

// src/candidates/mutations/__generated__/UseApplicationWorkflowHireMutation.graphql.ts
var node281 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfApplicationSqlReadModel",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Application",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "applicationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "seqId",
            "storageKey": null
          },
          v23,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "version",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "applicationStateId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "applicationStateName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "workflowStateId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "workflowStateName",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v23,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseApplicationWorkflowHireMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitApplicationHirePayload",
          "kind": "LinkedField",
          "name": "recruitApplicationHire",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseApplicationWorkflowHireMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitApplicationHirePayload",
          "kind": "LinkedField",
          "name": "recruitApplicationHire",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "a5516fd7e38442e942f685ff852dcf2b",
      "id": null,
      "metadata": {},
      "name": "UseApplicationWorkflowHireMutation",
      "operationKind": "mutation",
      "text": "mutation UseApplicationWorkflowHireMutation(\n  $input: RecruitApplicationHireInput!\n) {\n  result: recruitApplicationHire(input: $input) {\n    payload {\n      node {\n        id\n        applicationId\n        seqId\n        code\n        version\n        updatedAt\n        status\n        applicationStateId\n        applicationStateName\n        workflowStateId\n        workflowStateName\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node281.hash = "f30c69b5a7134ee1c47dfa87f67df561";
var UseApplicationWorkflowHireMutation_graphql_default = node281;

// src/candidates/mutations/UseApplicationWorkflowHire.ts
import { useAsyncMutation as useAsyncMutation41 } from "shared-lib";
var mutationDef62 = UseApplicationWorkflowHireMutation_graphql_default;
function useApplicationWorkflowHire() {
  const [commit11, isBusy] = useAsyncMutation41(mutationDef62);
  return [commit11, isBusy];
}

// src/candidates/mutations/__generated__/UseApplicationWorkflowRejectMutation.graphql.ts
var node283 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfApplicationSqlReadModel",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Application",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "applicationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "seqId",
            "storageKey": null
          },
          v23,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "version",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "applicationStateId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "applicationStateName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "workflowStateId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "workflowStateName",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v23,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseApplicationWorkflowRejectMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitApplicationRejectPayload",
          "kind": "LinkedField",
          "name": "recruitApplicationReject",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseApplicationWorkflowRejectMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitApplicationRejectPayload",
          "kind": "LinkedField",
          "name": "recruitApplicationReject",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "f727e14ac990ca53f9b4f2e60c8f71b3",
      "id": null,
      "metadata": {},
      "name": "UseApplicationWorkflowRejectMutation",
      "operationKind": "mutation",
      "text": "mutation UseApplicationWorkflowRejectMutation(\n  $input: RecruitApplicationRejectInput!\n) {\n  result: recruitApplicationReject(input: $input) {\n    payload {\n      node {\n        id\n        applicationId\n        seqId\n        code\n        version\n        updatedAt\n        status\n        applicationStateId\n        applicationStateName\n        workflowStateId\n        workflowStateName\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node283.hash = "3a73042302da910f409ba889f4ec7715";
var UseApplicationWorkflowRejectMutation_graphql_default = node283;

// src/candidates/mutations/UseApplicationWorkflowReject.ts
import { useAsyncMutation as useAsyncMutation43 } from "shared-lib";
var mutationDef63 = UseApplicationWorkflowRejectMutation_graphql_default;
function useApplicationWorkflowReject() {
  const [commit11, isBusy] = useAsyncMutation43(mutationDef63);
  return [commit11, isBusy];
}

// src/candidates/mutations/__generated__/UseApplicationWorkflowRestoreMutation.graphql.ts
var node284 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfApplicationSqlReadModel",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Application",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "applicationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "seqId",
            "storageKey": null
          },
          v23,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "version",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "applicationStateId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "applicationStateName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "workflowStateId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "workflowStateName",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v23,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseApplicationWorkflowRestoreMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitApplicationRestorePayload",
          "kind": "LinkedField",
          "name": "recruitApplicationRestore",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseApplicationWorkflowRestoreMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitApplicationRestorePayload",
          "kind": "LinkedField",
          "name": "recruitApplicationRestore",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "465edae15e42a646ac699b03b4414148",
      "id": null,
      "metadata": {},
      "name": "UseApplicationWorkflowRestoreMutation",
      "operationKind": "mutation",
      "text": "mutation UseApplicationWorkflowRestoreMutation(\n  $input: RecruitApplicationRestoreInput!\n) {\n  result: recruitApplicationRestore(input: $input) {\n    payload {\n      node {\n        id\n        applicationId\n        seqId\n        code\n        version\n        updatedAt\n        status\n        applicationStateId\n        applicationStateName\n        workflowStateId\n        workflowStateName\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node284.hash = "0aec2e525e65981ec6aba80c620933a7";
var UseApplicationWorkflowRestoreMutation_graphql_default = node284;

// src/candidates/mutations/UseApplicationWorkflowRestore.ts
import { useAsyncMutation as useAsyncMutation44 } from "shared-lib";
var mutationDef64 = UseApplicationWorkflowRestoreMutation_graphql_default;
function useApplicationWorkflowRestore() {
  const [commit11, isBusy] = useAsyncMutation44(mutationDef64);
  return [commit11, isBusy];
}

// src/candidates/mutations/__generated__/UseApplicationWorkflowSubmitMutation.graphql.ts
var node285 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfApplicationSqlReadModel",
    "kind": "LinkedField",
    "name": "application",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Application",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "applicationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "seqId",
            "storageKey": null
          },
          v23,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "version",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "applicationStateId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "applicationStateName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "workflowStateId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "workflowStateName",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v23,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseApplicationWorkflowSubmitMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitApplicationSubmitPayload",
          "kind": "LinkedField",
          "name": "recruitApplicationSubmit",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseApplicationWorkflowSubmitMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitApplicationSubmitPayload",
          "kind": "LinkedField",
          "name": "recruitApplicationSubmit",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "4abdb8d80f925d8681ab40333f7e2300",
      "id": null,
      "metadata": {},
      "name": "UseApplicationWorkflowSubmitMutation",
      "operationKind": "mutation",
      "text": "mutation UseApplicationWorkflowSubmitMutation(\n  $input: RecruitApplicationSubmitInput!\n) {\n  result: recruitApplicationSubmit(input: $input) {\n    application {\n      node {\n        id\n        applicationId\n        seqId\n        code\n        version\n        updatedAt\n        status\n        applicationStateId\n        applicationStateName\n        workflowStateId\n        workflowStateName\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node285.hash = "6b14e94b811399627477da0b0cd993d2";
var UseApplicationWorkflowSubmitMutation_graphql_default = node285;

// src/candidates/mutations/UseApplicationWorkflowSubmit.ts
import { useAsyncMutation as useAsyncMutation45 } from "shared-lib";
var mutationDef65 = UseApplicationWorkflowSubmitMutation_graphql_default;
function useApplicationWorkflowSubmit() {
  const [commit11, isBusy] = useAsyncMutation45(mutationDef65);
  return [commit11, isBusy];
}

// src/candidates/mutations/__generated__/UseApplicationWorkflowTransitionMutation.graphql.ts
var node286 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfApplicationSqlReadModel",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Application",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "applicationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "seqId",
            "storageKey": null
          },
          v23,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "version",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "applicationStateId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "applicationStateName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "workflowStateId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "workflowStateName",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v23,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseApplicationWorkflowTransitionMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitApplicationTransitionPayload",
          "kind": "LinkedField",
          "name": "recruitApplicationTransition",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseApplicationWorkflowTransitionMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitApplicationTransitionPayload",
          "kind": "LinkedField",
          "name": "recruitApplicationTransition",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "af75aa792ce2dd9a16e6fc6e0aaa2226",
      "id": null,
      "metadata": {},
      "name": "UseApplicationWorkflowTransitionMutation",
      "operationKind": "mutation",
      "text": "mutation UseApplicationWorkflowTransitionMutation(\n  $input: RecruitApplicationTransitionInput!\n) {\n  result: recruitApplicationTransition(input: $input) {\n    payload {\n      node {\n        id\n        applicationId\n        seqId\n        code\n        version\n        updatedAt\n        status\n        applicationStateId\n        applicationStateName\n        workflowStateId\n        workflowStateName\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node286.hash = "f7a469f5da0ba62af4b3c20a8faf3fec";
var UseApplicationWorkflowTransitionMutation_graphql_default = node286;

// src/candidates/mutations/UseApplicationWorkflowTransition.ts
import { useAsyncMutation as useAsyncMutation46 } from "shared-lib";
var mutationDef66 = UseApplicationWorkflowTransitionMutation_graphql_default;
function useApplicationWorkflowTransition() {
  const [commit11, isBusy] = useAsyncMutation46(mutationDef66);
  return [commit11, isBusy];
}

// src/candidates/mutations/__generated__/UseUpdateApplicationTagMutation.graphql.ts
var node287 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfApplicationTag",
    "kind": "LinkedField",
    "name": "applicationTag",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitApplicationTag",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v23,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tagName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tagDataType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tagValue",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountsUser",
            "kind": "LinkedField",
            "name": "createdByUser",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "emailAddress",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v23,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseUpdateApplicationTagMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitApplicationTagUpdatePayload",
          "kind": "LinkedField",
          "name": "recruitApplicationTagUpdate",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseUpdateApplicationTagMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitApplicationTagUpdatePayload",
          "kind": "LinkedField",
          "name": "recruitApplicationTagUpdate",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "bf08454cfbecb4f3b3f2754eece0358b",
      "id": null,
      "metadata": {},
      "name": "UseUpdateApplicationTagMutation",
      "operationKind": "mutation",
      "text": "mutation UseUpdateApplicationTagMutation(\n  $input: RecruitApplicationTagUpdateInput!\n) {\n  result: recruitApplicationTagUpdate(input: $input) {\n    applicationTag {\n      node {\n        id\n        code\n        updatedAt\n        tagName\n        tagDataType\n        tagValue\n        createdByUser {\n          firstName\n          lastName\n          emailAddress\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node287.hash = "52686659090c4ccb1b61d8d70d530c02";
var UseUpdateApplicationTagMutation_graphql_default = node287;

// src/candidates/mutations/UseUpdateApplicationTag.ts
import { useAsyncMutation as useAsyncMutation47 } from "shared-lib";
var mutationDef67 = UseUpdateApplicationTagMutation_graphql_default;
function useUpdateApplicationTag() {
  const [commit11, isBusy] = useAsyncMutation47(mutationDef67);
  return [commit11, isBusy];
}

// src/candidates/mutations/__generated__/UseDeleteApplicationTagMutation.graphql.ts
var node288 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "concreteType": "DeleteResult",
    "kind": "LinkedField",
    "name": "result",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "succeeded",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v32 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseDeleteApplicationTagMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitApplicationTagDeletePayload",
          "kind": "LinkedField",
          "name": "recruitApplicationTagDelete",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseDeleteApplicationTagMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitApplicationTagDeletePayload",
          "kind": "LinkedField",
          "name": "recruitApplicationTagDelete",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "0d92437755b3195f0436dc59ab9255d9",
      "id": null,
      "metadata": {},
      "name": "UseDeleteApplicationTagMutation",
      "operationKind": "mutation",
      "text": "mutation UseDeleteApplicationTagMutation(\n  $input: RecruitApplicationTagDeleteInput!\n) {\n  result: recruitApplicationTagDelete(input: $input) {\n    result {\n      succeeded\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node288.hash = "34bf2a6f01dc53c837d34ebaee924384";
var UseDeleteApplicationTagMutation_graphql_default = node288;

// src/candidates/mutations/UseDeleteApplicationTag.ts
import { useAsyncMutation as useAsyncMutation48 } from "shared-lib";
var mutationDef68 = UseDeleteApplicationTagMutation_graphql_default;
function useDeleteApplicationTag() {
  const [commit11, isBusy] = useAsyncMutation48(mutationDef68);
  return [commit11, isBusy];
}

// src/candidates/mutations/__generated__/UseAddApplicationNoteMutation.graphql.ts
var node289 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfApplicationNote",
    "kind": "LinkedField",
    "name": "applicationNote",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitApplicationNote",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v23,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "content",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitApplicationNoteTag",
            "kind": "LinkedField",
            "name": "tags",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountsUser",
            "kind": "LinkedField",
            "name": "createdByUser",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "emailAddress",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v23,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseAddApplicationNoteMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitApplicationNoteCreatePayload",
          "kind": "LinkedField",
          "name": "recruitApplicationNoteCreate",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseAddApplicationNoteMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitApplicationNoteCreatePayload",
          "kind": "LinkedField",
          "name": "recruitApplicationNoteCreate",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "58a6bbf416f0eebb9fe1c96d4e1af47e",
      "id": null,
      "metadata": {},
      "name": "UseAddApplicationNoteMutation",
      "operationKind": "mutation",
      "text": "mutation UseAddApplicationNoteMutation(\n  $input: RecruitApplicationNoteCreateInput!\n) {\n  result: recruitApplicationNoteCreate(input: $input) {\n    applicationNote {\n      node {\n        id\n        code\n        updatedAt\n        content\n        tags {\n          name\n          value\n        }\n        createdByUser {\n          firstName\n          lastName\n          emailAddress\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node289.hash = "f03245d2b19d372f56478a7df6bafa36";
var UseAddApplicationNoteMutation_graphql_default = node289;

// src/candidates/mutations/UseAddApplicationNote.ts
import { useAsyncMutation as useAsyncMutation49 } from "shared-lib";
var mutationDef69 = UseAddApplicationNoteMutation_graphql_default;
function useAddApplicationNote() {
  const [commit11, isBusy] = useAsyncMutation49(mutationDef69);
  return [commit11, isBusy];
}

// src/candidates/mutations/__generated__/UseUpdateApplicationNoteMutation.graphql.ts
var node290 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfApplicationNote",
    "kind": "LinkedField",
    "name": "applicationNote",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitApplicationNote",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v23,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "content",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitApplicationNoteTag",
            "kind": "LinkedField",
            "name": "tags",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountsUser",
            "kind": "LinkedField",
            "name": "createdByUser",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "emailAddress",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v23,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseUpdateApplicationNoteMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitApplicationNoteUpdatePayload",
          "kind": "LinkedField",
          "name": "recruitApplicationNoteUpdate",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseUpdateApplicationNoteMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitApplicationNoteUpdatePayload",
          "kind": "LinkedField",
          "name": "recruitApplicationNoteUpdate",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "4066e64125a81f94fbc378bcf412de77",
      "id": null,
      "metadata": {},
      "name": "UseUpdateApplicationNoteMutation",
      "operationKind": "mutation",
      "text": "mutation UseUpdateApplicationNoteMutation(\n  $input: RecruitApplicationNoteUpdateInput!\n) {\n  result: recruitApplicationNoteUpdate(input: $input) {\n    applicationNote {\n      node {\n        id\n        code\n        updatedAt\n        content\n        tags {\n          name\n          value\n        }\n        createdByUser {\n          firstName\n          lastName\n          emailAddress\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node290.hash = "0b44fc0ffb089863c1fed20a809602de";
var UseUpdateApplicationNoteMutation_graphql_default = node290;

// src/candidates/mutations/UseUpdateApplicationNote.ts
import { useAsyncMutation as useAsyncMutation50 } from "shared-lib";
var mutationDef70 = UseUpdateApplicationNoteMutation_graphql_default;
function useUpdateApplicationNote() {
  const [commit11, isBusy] = useAsyncMutation50(mutationDef70);
  return [commit11, isBusy];
}

// src/candidates/mutations/__generated__/UseDeleteApplicationNoteMutation.graphql.ts
var node291 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "concreteType": "DeleteResult",
    "kind": "LinkedField",
    "name": "result",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "succeeded",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v32 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseDeleteApplicationNoteMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitApplicationNoteDeletePayload",
          "kind": "LinkedField",
          "name": "recruitApplicationNoteDelete",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseDeleteApplicationNoteMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitApplicationNoteDeletePayload",
          "kind": "LinkedField",
          "name": "recruitApplicationNoteDelete",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "d0e22d34d2420b22d52dcb0d7acbeb0d",
      "id": null,
      "metadata": {},
      "name": "UseDeleteApplicationNoteMutation",
      "operationKind": "mutation",
      "text": "mutation UseDeleteApplicationNoteMutation(\n  $input: RecruitApplicationNoteDeleteInput!\n) {\n  result: recruitApplicationNoteDelete(input: $input) {\n    result {\n      succeeded\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node291.hash = "3e37e0fc37316bf60583f5788a68eb72";
var UseDeleteApplicationNoteMutation_graphql_default = node291;

// src/candidates/mutations/UseDeleteApplicationNote.ts
import { useAsyncMutation as useAsyncMutation51 } from "shared-lib";
var mutationDef71 = UseDeleteApplicationNoteMutation_graphql_default;
function useDeleteApplicationNote() {
  const [commit11, isBusy] = useAsyncMutation51(mutationDef71);
  return [commit11, isBusy];
}

// src/candidates/mutations/__generated__/UseRejectDocumentMutation.graphql.ts
var node293 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfApplicationDocument",
    "kind": "LinkedField",
    "name": "applicationDocument",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ApplicationDocument",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "applicationDocumentId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "documentReferenceId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "documentReferenceFileName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "documentTypeId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "documentTypeName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isRequired",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isSubmitted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isUploaded",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "requiresExpiryDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "requiresIssueDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "requiresIssueNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "documentExpiryDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "documentIssueDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "documentIssueNumber",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v32 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseRejectDocumentMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitApplicationDocumentRequestResubmitPayload",
          "kind": "LinkedField",
          "name": "recruitApplicationDocumentRequestResubmit",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseRejectDocumentMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitApplicationDocumentRequestResubmitPayload",
          "kind": "LinkedField",
          "name": "recruitApplicationDocumentRequestResubmit",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "e232aff44f1adbfdd86f426ceacf3173",
      "id": null,
      "metadata": {},
      "name": "UseRejectDocumentMutation",
      "operationKind": "mutation",
      "text": "mutation UseRejectDocumentMutation(\n  $input: RecruitApplicationDocumentRequestResubmitInput!\n) {\n  result: recruitApplicationDocumentRequestResubmit(input: $input) {\n    applicationDocument {\n      node {\n        id\n        applicationDocumentId\n        createdAt\n        updatedAt\n        documentReferenceId\n        documentReferenceFileName\n        documentTypeId\n        documentTypeName\n        isRequired\n        isSubmitted\n        isUploaded\n        status\n        requiresExpiryDate\n        requiresIssueDate\n        requiresIssueNumber\n        documentExpiryDate\n        documentIssueDate\n        documentIssueNumber\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node293.hash = "0eb497764c1ad2ad04f1b21aa2dddfdf";
var UseRejectDocumentMutation_graphql_default = node293;

// src/candidates/mutations/UseRejectDocument.ts
import { useAsyncMutation as useAsyncMutation53 } from "shared-lib";
var mutationDef72 = UseRejectDocumentMutation_graphql_default;
function useRejectDocument() {
  const [commit11, isBusy] = useAsyncMutation53(mutationDef72);
  return [commit11, isBusy];
}

// src/candidates/mutations/__generated__/UseRejectFormMutation.graphql.ts
var node294 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfApplicationForm",
    "kind": "LinkedField",
    "name": "applicationForm",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ApplicationForm",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "applicationFormId",
            "storageKey": null
          },
          v23,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isEdited",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isCompleted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isRequired",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isSubmitted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "formTemplateName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FormField",
            "kind": "LinkedField",
            "name": "fields",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "skipped",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v23,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseRejectFormMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitApplicationFormRejectPayload",
          "kind": "LinkedField",
          "name": "recruitApplicationFormReject",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseRejectFormMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitApplicationFormRejectPayload",
          "kind": "LinkedField",
          "name": "recruitApplicationFormReject",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "4d7d5d4a2ac2c7397c1d2998c67dadd8",
      "id": null,
      "metadata": {},
      "name": "UseRejectFormMutation",
      "operationKind": "mutation",
      "text": "mutation UseRejectFormMutation(\n  $input: RecruitApplicationFormRejectInput!\n) {\n  result: recruitApplicationFormReject(input: $input) {\n    applicationForm {\n      node {\n        id\n        applicationFormId\n        code\n        createdAt\n        updatedAt\n        isEdited\n        isCompleted\n        isRequired\n        isSubmitted\n        formTemplateName\n        fields {\n          key\n          value\n          skipped\n          type\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node294.hash = "9c7a34abe20559a637eaa88c177720c5";
var UseRejectFormMutation_graphql_default = node294;

// src/candidates/mutations/UseRejectForm.ts
import { useAsyncMutation as useAsyncMutation54 } from "shared-lib";
var mutationDef73 = UseRejectFormMutation_graphql_default;
function useRejectForm() {
  const [commit11, isBusy] = useAsyncMutation54(mutationDef73);
  return [commit11, isBusy];
}

// src/candidates/components/__generated__/CandidateApplicationWorkflowRejectButtonQuery.graphql.ts
var node295 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "employerId"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "employerId",
      "variableName": "employerId"
    },
    {
      "kind": "Literal",
      "name": "where",
      "value": {
        "discriminator": {
          "eq": "RejectionReason"
        }
      }
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "concreteType": "PageInfo",
    "kind": "LinkedField",
    "name": "pageInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasNextPage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasPreviousPage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "startCursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endCursor",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "RefDataItemsByEmployerEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RefDataItem",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "discriminator",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tenantId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "display",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "refDataItemId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateApplicationWorkflowRejectButtonQuery",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "RefDataItemsByEmployerConnection",
          "kind": "LinkedField",
          "name": "refDataItemsByEmployer",
          "plural": false,
          "selections": [
            v23,
            v32,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "WithdrawApplicationForm_refData"
            },
            v4
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateApplicationWorkflowRejectButtonQuery",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "RefDataItemsByEmployerConnection",
          "kind": "LinkedField",
          "name": "refDataItemsByEmployer",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "09d77b80eb940e4f56546f64bf6f725c",
      "id": null,
      "metadata": {},
      "name": "CandidateApplicationWorkflowRejectButtonQuery",
      "operationKind": "query",
      "text": 'query CandidateApplicationWorkflowRejectButtonQuery(\n  $employerId: UUID!\n) {\n  refDataItemsByEmployer(employerId: $employerId, where: {discriminator: {eq: "RejectionReason"}}) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        discriminator\n        tenantId\n        display\n        refDataItemId\n      }\n    }\n    ...WithdrawApplicationForm_refData\n  }\n}\n\nfragment WithdrawApplicationForm_refData on RefDataItemsByEmployerConnection {\n  pageInfo {\n    hasNextPage\n    hasPreviousPage\n    startCursor\n    endCursor\n  }\n  edges {\n    cursor\n    node {\n      id\n      discriminator\n      tenantId\n      display\n      refDataItemId\n    }\n  }\n}\n'
    }
  };
}();
node295.hash = "2b15c5aa006c04197fec10d910c6034b";
var CandidateApplicationWorkflowRejectButtonQuery_graphql_default = node295;

// src/candidates/components/CandidateApplicationWorkflowRejectButton.tsx
import { Fragment as Fragment64, useCallback as useCallback139, useState as useState78 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery36 } from "react-relay";
import { Dialog, Transition } from "@headlessui/react";
import { XCircleIcon as XCircleIcon5 } from "@heroicons/react/24/outline";
import { createClientMutationId as createClientMutationId59 } from "shared-lib";
import { Button as Button68, ButtonList as ButtonList23, SelectMenu as SelectMenu4, TextArea as TextArea4 } from "shared-ui";
import { jsx as jsx266, jsxs as jsxs176 } from "react/jsx-runtime";
var queryDef41 = CandidateApplicationWorkflowRejectButtonQuery_graphql_default;
var CandidateApplicationWorkflowRejectButton = ({
  employerId,
  applicationId,
  version,
  action,
  isBusy,
  onDone,
  onUpdating
}) => {
  const data = useLazyLoadQuery36(
    queryDef41,
    {
      employerId
    },
    {
      fetchPolicy: "network-only"
    }
  );
  const items = (data.refDataItemsByEmployer?.edges || []).map(
    ({ node: node566 }) => ({
      id: node566.refDataItemId,
      name: node566.display
    })
  );
  const [reasonId, setReasonId] = useState78(null);
  const [note, setNote] = useState78("");
  const [isRejectOpen, setRejectIsOpen] = useState78(false);
  const onToggleRejectOpen = useCallback139(() => {
    setRejectIsOpen(!isRejectOpen);
  }, [isRejectOpen, setRejectIsOpen]);
  const [reject, isRejecting] = useApplicationWorkflowReject();
  const onReject = useCallback139(async () => {
    if (!reasonId || !note) {
      return;
    }
    onUpdating(true);
    const input = {
      applicationId,
      version,
      reasonId,
      note,
      clientMutationId: createClientMutationId59()
    };
    const { result } = await reject({ input });
    onUpdating(false);
    if (result.payload) {
      onDone();
    }
  }, [reject, onUpdating]);
  let reason = null;
  if (reasonId) {
    reason = items.find((r4) => r4.id === reasonId) || null;
  }
  return /* @__PURE__ */ jsxs176("div", { children: [
    !isRejectOpen && /* @__PURE__ */ jsxs176(
      Button68,
      {
        color: "danger",
        clicked: onToggleRejectOpen,
        disabled: isBusy || isRejecting,
        children: [
          action.actionName,
          /* @__PURE__ */ jsx266(XCircleIcon5, { className: "ml-1 h-4 w-4" })
        ]
      }
    ),
    /* @__PURE__ */ jsx266(Transition, { appear: true, show: isRejectOpen, as: Fragment64, children: /* @__PURE__ */ jsxs176(Dialog, { as: "div", className: "relative z-10", onClose: onToggleRejectOpen, children: [
      /* @__PURE__ */ jsx266(
        Transition.Child,
        {
          as: Fragment64,
          enter: "ease-out duration-300",
          enterFrom: "opacity-0",
          enterTo: "opacity-100",
          leave: "ease-in duration-200",
          leaveFrom: "opacity-100",
          leaveTo: "opacity-0",
          children: /* @__PURE__ */ jsx266("div", { className: "fixed inset-0 bg-black bg-opacity-25" })
        }
      ),
      /* @__PURE__ */ jsx266("div", { className: "fixed inset-0 overflow-y-auto", children: /* @__PURE__ */ jsx266("div", { className: "flex min-h-full items-center justify-center p-4 text-center", children: /* @__PURE__ */ jsx266(
        Transition.Child,
        {
          as: Fragment64,
          enter: "ease-out duration-300",
          enterFrom: "opacity-0 scale-95",
          enterTo: "opacity-100 scale-100",
          leave: "ease-in duration-200",
          leaveFrom: "opacity-100 scale-100",
          leaveTo: "opacity-0 scale-95",
          children: /* @__PURE__ */ jsxs176(Dialog.Panel, { className: "w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all", children: [
            /* @__PURE__ */ jsx266(
              Dialog.Title,
              {
                as: "h3",
                className: "text-lg font-medium leading-6 text-gray-900",
                children: "Reject Candidate"
              }
            ),
            /* @__PURE__ */ jsxs176("div", { className: "mt-2 flex flex-col gap-2", children: [
              /* @__PURE__ */ jsx266(
                SelectMenu4,
                {
                  title: "Reason",
                  items,
                  onChange: (i4) => setReasonId(i4.id),
                  value: reason
                }
              ),
              /* @__PURE__ */ jsx266(
                TextArea4,
                {
                  rows: 3,
                  className: "focus:border-info-500 focus:ring-info-500 block w-full rounded-md border border-gray-300 shadow-sm sm:text-sm",
                  placeholder: "Notes",
                  onValueChange: (text) => setNote(text)
                }
              )
            ] }),
            /* @__PURE__ */ jsx266("div", { className: "mt-4", children: /* @__PURE__ */ jsxs176(ButtonList23, { children: [
              /* @__PURE__ */ jsx266("div", { children: /* @__PURE__ */ jsx266(
                Button68,
                {
                  color: "danger",
                  clicked: onReject,
                  disabled: isBusy || isRejecting || !reasonId || !note,
                  children: action.actionName
                }
              ) }),
              /* @__PURE__ */ jsx266("div", { children: /* @__PURE__ */ jsx266(
                Button68,
                {
                  color: "gray",
                  clicked: onToggleRejectOpen,
                  disabled: isBusy || isRejecting,
                  children: "Cancel"
                }
              ) })
            ] }) })
          ] })
        }
      ) }) })
    ] }) })
  ] });
};

// src/candidates/components/CandidateApplicationWorkflowApproveButton.tsx
import { useCallback as useCallback140 } from "react";
import { createClientMutationId as createClientMutationId60 } from "shared-lib";
import { Button as Button69 } from "shared-ui";
import { jsx as jsx267 } from "react/jsx-runtime";
var CandidateApplicationWorkflowApproveButton = ({
  candidateId,
  isBusy,
  onDone,
  onUpdating
}) => {
  const [approve, isApproving] = useApplicationWorkflowApprove();
  const onApprove = useCallback140(async () => {
    onUpdating(true);
    const input = {
      candidateId,
      clientMutationId: createClientMutationId60()
    };
    const { result } = await approve({ input });
    onUpdating(false);
    if (result.candidateAccount) {
      onDone();
    }
  }, [approve, onUpdating]);
  return /* @__PURE__ */ jsx267(
    Button69,
    {
      color: "primary",
      clicked: onApprove,
      disabled: isBusy || isApproving,
      children: "Approve"
    }
  );
};

// src/candidates/components/CandidateApplicationWorkflowOfferButton.tsx
import { Fragment as Fragment65, useCallback as useCallback146, useState as useState79 } from "react";
import { Dialog as Dialog2, Transition as Transition2 } from "@headlessui/react";
import { ArrowRightIcon as ArrowRightIcon2 } from "@heroicons/react/24/solid";
import { Controller as Controller11, useForm as useForm19 } from "react-hook-form";
import { zodResolver as zodResolver18 } from "@hookform/resolvers/zod";
import { z as z9 } from "zod";
import {
  Button as Button70,
  ButtonList as ButtonList24,
  Error as Error10,
  FormInput as FormInput11,
  FormTextAreaInput as FormTextAreaInput5,
  RadioListInput as RadioListInput3
} from "shared-ui";
import { GeoCountriesSearchBox } from "feature-data-management";

// src/offers/mutations/__generated__/UseOfferAcceptMutation.graphql.ts
var node296 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfOffer",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitOffer",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v23,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "offerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "countryName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currencyCode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "payType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rateAmount",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v23,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseOfferAcceptMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitOfferAcceptPayload",
          "kind": "LinkedField",
          "name": "recruitOfferAccept",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseOfferAcceptMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitOfferAcceptPayload",
          "kind": "LinkedField",
          "name": "recruitOfferAccept",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "02ac5c3c75caee52ea9a747bb7721cbf",
      "id": null,
      "metadata": {},
      "name": "UseOfferAcceptMutation",
      "operationKind": "mutation",
      "text": "mutation UseOfferAcceptMutation(\n  $input: RecruitOfferAcceptInput!\n) {\n  result: recruitOfferAccept(input: $input) {\n    payload {\n      node {\n        id\n        code\n        offerId\n        status\n        countryName\n        currencyCode\n        payType\n        rateAmount\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node296.hash = "0184caf51cab04ca6d1420866c614457";
var UseOfferAcceptMutation_graphql_default = node296;

// src/offers/mutations/UseOfferAccept.ts
import { useCallback as useCallback141 } from "react";
import {
  createClientMutationId as createClientMutationId61,
  useAsyncMutation as useAsyncMutation55,
  useUnhandledError as useUnhandledError20,
  useSetUserErrorCodes as useSetUserErrorCodes23
} from "shared-lib";
var mutationDef74 = UseOfferAcceptMutation_graphql_default;
var useOfferAccept = (applicationId, offerId) => {
  const [, setUnhandledError] = useUnhandledError20();
  const setErrorCodes = useSetUserErrorCodes23();
  const [commitMutation4, isMutationInFlight] = useAsyncMutation55(mutationDef74);
  const invokeMutation = useCallback141(async () => {
    const clientMutationId = createClientMutationId61();
    const input = {
      applicationId,
      offerId,
      clientMutationId
    };
    try {
      const response = await commitMutation4({ input });
      if (response.result.payload) {
        return response.result.payload;
      }
      if (response.result.userErrors) {
        setErrorCodes(response.result.userErrors);
      }
      return null;
    } catch (e4) {
      setUnhandledError(new Error("useOfferAccept Unhandled Error"));
      return null;
    }
  }, [
    applicationId,
    commitMutation4,
    offerId,
    setErrorCodes,
    setUnhandledError
  ]);
  return [invokeMutation, isMutationInFlight];
};

// src/offers/mutations/__generated__/UseOfferDeclineMutation.graphql.ts
var node297 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfOffer",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitOffer",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v23,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "offerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "countryName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currencyCode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "payType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rateAmount",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v23,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseOfferDeclineMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitOfferDeclinePayload",
          "kind": "LinkedField",
          "name": "recruitOfferDecline",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseOfferDeclineMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitOfferDeclinePayload",
          "kind": "LinkedField",
          "name": "recruitOfferDecline",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "b2ee169cb14a7e401d85f16bdc9cabac",
      "id": null,
      "metadata": {},
      "name": "UseOfferDeclineMutation",
      "operationKind": "mutation",
      "text": "mutation UseOfferDeclineMutation(\n  $input: RecruitOfferDeclineInput!\n) {\n  result: recruitOfferDecline(input: $input) {\n    payload {\n      node {\n        id\n        code\n        offerId\n        status\n        countryName\n        currencyCode\n        payType\n        rateAmount\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node297.hash = "6448f631cac3b5c2f0e246cee110d96d";
var UseOfferDeclineMutation_graphql_default = node297;

// src/offers/mutations/UseOfferDecline.ts
import { useCallback as useCallback143 } from "react";
import {
  createClientMutationId as createClientMutationId63,
  useAsyncMutation as useAsyncMutation56,
  useUnhandledError as useUnhandledError21,
  useSetUserErrorCodes as useSetUserErrorCodes24
} from "shared-lib";
var mutationDef75 = UseOfferDeclineMutation_graphql_default;
var useOfferDecline = (applicationId, offerId) => {
  const [, setUnhandledError] = useUnhandledError21();
  const setErrorCodes = useSetUserErrorCodes24();
  const [commitMutation4, isMutationInFlight] = useAsyncMutation56(mutationDef75);
  const invokeMutation = useCallback143(
    async ({ message, reasonId }) => {
      const clientMutationId = createClientMutationId63();
      const input = {
        offerId,
        reasonId,
        candidateDeclineMessage: message,
        clientMutationId
      };
      try {
        const response = await commitMutation4({ input });
        if (response.result.payload) {
          return response.result.payload;
        }
        if (response.result.userErrors) {
          setErrorCodes(response.result.userErrors);
        }
        return null;
      } catch (e4) {
        setUnhandledError(new Error("useOfferDecline Unhandled Error"));
        return null;
      }
    },
    [commitMutation4]
  );
  return [invokeMutation, isMutationInFlight];
};

// src/offers/mutations/__generated__/UseOfferWithdrawMutation.graphql.ts
var node298 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfOffer",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitOffer",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v23,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "offerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "countryName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currencyCode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "payType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rateAmount",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v23,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseOfferWithdrawMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitOfferWithdrawPayload",
          "kind": "LinkedField",
          "name": "recruitOfferWithdraw",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseOfferWithdrawMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitOfferWithdrawPayload",
          "kind": "LinkedField",
          "name": "recruitOfferWithdraw",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "b1f54297e137e2ef398d7a2aac1c8e7e",
      "id": null,
      "metadata": {},
      "name": "UseOfferWithdrawMutation",
      "operationKind": "mutation",
      "text": "mutation UseOfferWithdrawMutation(\n  $input: RecruitOfferWithdrawInput!\n) {\n  result: recruitOfferWithdraw(input: $input) {\n    payload {\n      node {\n        id\n        code\n        offerId\n        status\n        countryName\n        currencyCode\n        payType\n        rateAmount\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node298.hash = "dfa813f019a95331c00e4214f9018e80";
var UseOfferWithdrawMutation_graphql_default = node298;

// src/offers/mutations/UseOfferWithdraw.ts
import { useCallback as useCallback144 } from "react";
import {
  createClientMutationId as createClientMutationId64,
  useAsyncMutation as useAsyncMutation57,
  useUnhandledError as useUnhandledError22,
  useSetUserErrorCodes as useSetUserErrorCodes25
} from "shared-lib";
var mutationDef76 = UseOfferWithdrawMutation_graphql_default;
var useOfferWithdraw = (applicationId, offerId) => {
  const [, setUnhandledError] = useUnhandledError22();
  const setErrorCodes = useSetUserErrorCodes25();
  const [commitMutation4, isMutationInFlight] = useAsyncMutation57(mutationDef76);
  const invokeMutation = useCallback144(
    async ({ note }) => {
      const clientMutationId = createClientMutationId64();
      const input = {
        applicationId,
        offerId,
        note,
        clientMutationId
      };
      try {
        const response = await commitMutation4({ input });
        if (response.result.payload) {
          return response.result.payload;
        }
        if (response.result.userErrors) {
          setErrorCodes(response.result.userErrors);
        }
        return null;
      } catch (e4) {
        setUnhandledError(new Error("useOfferWithdraw Unhandled Error"));
        return null;
      }
    },
    [commitMutation4]
  );
  return [invokeMutation, isMutationInFlight];
};

// src/offers/mutations/__generated__/UseOfferMakeMutation.graphql.ts
var node299 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfOffer",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitOffer",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v23,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "offerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "countryName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currencyCode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "payType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rateAmount",
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v23,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseOfferMakeMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitOfferMakeOfferPayload",
          "kind": "LinkedField",
          "name": "recruitOfferMakeOffer",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseOfferMakeMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitOfferMakeOfferPayload",
          "kind": "LinkedField",
          "name": "recruitOfferMakeOffer",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "dd6f979a35612133dd06c6cecc72abe3",
      "id": null,
      "metadata": {},
      "name": "UseOfferMakeMutation",
      "operationKind": "mutation",
      "text": "mutation UseOfferMakeMutation(\n  $input: RecruitOfferMakeOfferInput!\n) {\n  result: recruitOfferMakeOffer(input: $input) {\n    payload {\n      node {\n        id\n        code\n        offerId\n        status\n        countryName\n        currencyCode\n        payType\n        rateAmount\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node299.hash = "2ed9aa8b1e3500eebafa3ed46c9dfba9";
var UseOfferMakeMutation_graphql_default = node299;

// src/offers/mutations/UseOfferMake.ts
import { useCallback as useCallback145 } from "react";
import {
  createClientMutationId as createClientMutationId65,
  useAsyncMutation as useAsyncMutation58,
  useUnhandledError as useUnhandledError23,
  useSetUserErrorCodes as useSetUserErrorCodes26
} from "shared-lib";
var mutationDef77 = UseOfferMakeMutation_graphql_default;
var useOfferMake = (applicationId) => {
  const [, setUnhandledError] = useUnhandledError23();
  const setErrorCodes = useSetUserErrorCodes26();
  const [commitMutation4, isMutationInFlight] = useAsyncMutation58(mutationDef77);
  const invokeMutation = useCallback145(
    async (data) => {
      const clientMutationId = createClientMutationId65();
      const input = {
        applicationId,
        clientMutationId,
        countryName: data.countryName,
        currencyCode: data.currencyCode,
        endDate: data.endDate,
        notes: data.notes,
        payType: data.payType,
        rate: data.rate,
        startDate: data.startDate
      };
      try {
        const response = await commitMutation4({ input });
        if (response.result.payload) {
          return response.result.payload;
        }
        if (response.result.userErrors) {
          setErrorCodes(response.result.userErrors);
        }
        return null;
      } catch (e4) {
        setUnhandledError(new Error("useOfferMake Unhandled Error"));
        return null;
      }
    },
    [applicationId, commitMutation4, setErrorCodes, setUnhandledError]
  );
  return [invokeMutation, isMutationInFlight];
};

// src/candidates/components/CandidateApplicationWorkflowOfferButton.tsx
import { jsx as jsx268, jsxs as jsxs177 } from "react/jsx-runtime";
var formSchema10 = z9.object({
  country: z9.object({
    iso3: z9.string().min(1, { message: "Country is required" }),
    name: z9.string().min(1, { message: "Country is required" }),
    phone: z9.string().min(1, { message: "Country is required" })
  }),
  endDate: z9.string().min(1, { message: "End Date is required" }),
  notes: z9.string().min(1, { message: "Notes is required" }),
  payType: z9.string().min(1, { message: "Pay Type is required" }),
  rate: z9.number().min(1, { message: "Rate is required" }),
  startDate: z9.string().min(1, { message: "Start Date is required" }),
  currencyCode: z9.object({
    iso3: z9.string().min(1, { message: "Country is required" }),
    name: z9.string().min(1, { message: "Country is required" }),
    phone: z9.string().min(1, { message: "Country is required" })
  })
});
var payTypesList = [
  {
    id: "PER_DAY",
    label: "Per Day"
  },
  {
    id: "PER_HOUR",
    label: "Per Hour"
  },
  {
    id: "PER_YEAR",
    label: "Per Year"
  }
];
var CandidateApplicationWorkflowOfferButton = ({
  applicationId,
  isBusy,
  onDone,
  onUpdating
}) => {
  const [isOfferOpen, setOfferOpen] = useState79(false);
  const onToggleOfferOpen = useCallback146(() => {
    setOfferOpen(!isOfferOpen);
  }, [isOfferOpen, setOfferOpen]);
  const [commitOffer, isOffering] = useOfferMake(applicationId);
  const {
    register,
    handleSubmit,
    formState: { errors },
    control
  } = useForm19({
    resolver: zodResolver18(formSchema10),
    defaultValues: {
      country: {
        iso3: "UK",
        name: "United Kingdom",
        phone: "44"
      },
      startDate: "",
      endDate: "",
      currencyCode: {
        iso3: "UK",
        name: "United Kingdom",
        phone: "44"
      },
      notes: "",
      payType: "PER_DAY",
      rate: 12.33
    }
  });
  const onSave = (props) => {
    commitOffer({
      countryName: props.country.name,
      endDate: props.endDate,
      notes: props.notes,
      payType: props.payType,
      rate: props.rate,
      startDate: props.startDate,
      currencyCode: props.currencyCode.iso3
    }).then(() => {
      setOfferOpen(false);
      onDone();
    });
  };
  return /* @__PURE__ */ jsxs177("div", { children: [
    /* @__PURE__ */ jsxs177(
      Button70,
      {
        color: "white",
        clicked: onToggleOfferOpen,
        disabled: isBusy || isOffering,
        children: [
          "Offer",
          /* @__PURE__ */ jsx268(ArrowRightIcon2, { className: "ml-1 h-4 w-4" })
        ]
      }
    ),
    /* @__PURE__ */ jsx268(Transition2, { appear: true, show: isOfferOpen, as: Fragment65, children: /* @__PURE__ */ jsxs177(Dialog2, { as: "div", className: "relative z-10", onClose: onToggleOfferOpen, children: [
      /* @__PURE__ */ jsx268(
        Transition2.Child,
        {
          as: Fragment65,
          enter: "ease-out duration-300",
          enterFrom: "opacity-0",
          enterTo: "opacity-100",
          leave: "ease-in duration-200",
          leaveFrom: "opacity-100",
          leaveTo: "opacity-0",
          children: /* @__PURE__ */ jsx268("div", { className: "fixed inset-0 bg-black bg-opacity-25" })
        }
      ),
      /* @__PURE__ */ jsx268("div", { className: "fixed inset-0 overflow-y-auto", children: /* @__PURE__ */ jsx268("div", { className: "flex min-h-full items-center justify-center p-4 text-center", children: /* @__PURE__ */ jsx268(
        Transition2.Child,
        {
          as: Fragment65,
          enter: "ease-out duration-300",
          enterFrom: "opacity-0 scale-95",
          enterTo: "opacity-100 scale-100",
          leave: "ease-in duration-200",
          leaveFrom: "opacity-100 scale-100",
          leaveTo: "opacity-0 scale-95",
          children: /* @__PURE__ */ jsxs177(Dialog2.Panel, { className: "w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all", children: [
            /* @__PURE__ */ jsx268(
              Dialog2.Title,
              {
                as: "h3",
                className: "text-lg font-medium leading-6 text-gray-900",
                children: "Create Offer"
              }
            ),
            /* @__PURE__ */ jsxs177("div", { className: "mt-5 flex flex-col gap-5", children: [
              /* @__PURE__ */ jsxs177("div", { children: [
                /* @__PURE__ */ jsx268("label", { className: "text-xs", children: "Country" }),
                /* @__PURE__ */ jsx268(
                  Controller11,
                  {
                    name: "country",
                    control,
                    render: ({ field }) => /* @__PURE__ */ jsx268(
                      GeoCountriesSearchBox,
                      {
                        name: "country",
                        value: field.value,
                        onSelected: field.onChange
                      }
                    )
                  }
                )
              ] }),
              /* @__PURE__ */ jsxs177("div", { children: [
                /* @__PURE__ */ jsx268(
                  FormInput11,
                  {
                    type: `number`,
                    label: "Rate",
                    name: "rate",
                    register
                  }
                ),
                /* @__PURE__ */ jsx268(Error10, { children: errors.rate && /* @__PURE__ */ jsx268("div", { children: errors.rate.message }) })
              ] }),
              /* @__PURE__ */ jsxs177("div", { children: [
                /* @__PURE__ */ jsx268(
                  RadioListInput3,
                  {
                    name: "payType",
                    control,
                    list: payTypesList
                  }
                ),
                /* @__PURE__ */ jsx268(Error10, { children: errors.payType && /* @__PURE__ */ jsx268("div", { children: errors.payType.message }) })
              ] }),
              /* @__PURE__ */ jsxs177("div", { children: [
                /* @__PURE__ */ jsx268(
                  FormInput11,
                  {
                    type: `date`,
                    label: "Start Date",
                    name: "startDate",
                    register
                  }
                ),
                /* @__PURE__ */ jsx268(Error10, { children: errors.startDate && /* @__PURE__ */ jsx268("div", { children: errors.startDate.message }) })
              ] }),
              /* @__PURE__ */ jsxs177("div", { children: [
                /* @__PURE__ */ jsx268(
                  FormInput11,
                  {
                    type: `date`,
                    label: "End Date",
                    name: "endDate",
                    register
                  }
                ),
                /* @__PURE__ */ jsx268(Error10, { children: errors.endDate && /* @__PURE__ */ jsx268("div", { children: errors.endDate.message }) })
              ] }),
              /* @__PURE__ */ jsxs177("div", { children: [
                /* @__PURE__ */ jsx268(
                  FormTextAreaInput5,
                  {
                    label: "Notes",
                    name: "notes",
                    rows: 2,
                    register
                  }
                ),
                /* @__PURE__ */ jsx268(Error10, { children: errors.notes && /* @__PURE__ */ jsx268("div", { children: errors.notes.message }) })
              ] }),
              /* @__PURE__ */ jsxs177("div", { children: [
                /* @__PURE__ */ jsx268("label", { className: "text-xs", children: "Currency Code" }),
                /* @__PURE__ */ jsx268(
                  Controller11,
                  {
                    name: "currencyCode",
                    control,
                    render: ({ field }) => /* @__PURE__ */ jsx268(
                      GeoCountriesSearchBox,
                      {
                        name: "currencyCode",
                        value: field.value,
                        onSelected: field.onChange
                      }
                    )
                  }
                ),
                /* @__PURE__ */ jsx268(Error10, { children: errors.notes && /* @__PURE__ */ jsx268("div", { children: errors?.currencyCode?.message }) })
              ] })
            ] }),
            /* @__PURE__ */ jsx268("div", { className: "mt-4", children: /* @__PURE__ */ jsxs177(ButtonList24, { children: [
              /* @__PURE__ */ jsx268("div", { children: /* @__PURE__ */ jsx268(Button70, { color: "green", clicked: handleSubmit(onSave), children: "Create Offer" }) }),
              /* @__PURE__ */ jsx268("div", { children: /* @__PURE__ */ jsx268(Button70, { color: "gray", clicked: onToggleOfferOpen, children: "Cancel" }) })
            ] }) })
          ] })
        }
      ) }) })
    ] }) })
  ] });
};

// src/candidates/components/CandidateApplicationWorkflowStateActionsGroup.tsx
import { Fragment as Fragment66, jsx as jsx269, jsxs as jsxs178 } from "react/jsx-runtime";
function isGenericTransition(action) {
  const specialActionNames = [
    "Reject",
    "Submit",
    "Approve",
    "Revert"
  ];
  return action.actionDialog === "Button" && specialActionNames.includes(action.actionName) === false;
}
var CandidateApplicationWorkflowStateActionsGroup = ({
  workflowDefinition,
  workflowStateId,
  candidateId,
  employerId,
  applicationId,
  applicationVersion,
  vacancyId,
  accountType,
  onOffer
}) => {
  const [isBusy, setIsBusy] = useState80(false);
  const onUpdateDone = useCallback147(() => {
    setIsBusy(false);
    dispatch("VACANCY_WORKFLOW_STATE_CHANGED");
  }, [setIsBusy]);
  const accountId = {
    accountType
  };
  const state = getStateById(workflowDefinition, workflowStateId);
  if (!state) {
    return /* @__PURE__ */ jsx269("div", { children: "Could Not Find Workflow State" });
  }
  const actions = getActions(workflowDefinition, state, accountId);
  const states = actions.map((s4) => {
    return /* @__PURE__ */ jsx269(
      WorkflowButton,
      {
        candidateId,
        employerId,
        vacancyId,
        applicationId,
        version: applicationVersion,
        action: s4,
        isBusy,
        onDone: onUpdateDone,
        onUpdating: setIsBusy,
        onOffer
      },
      `${s4.id}`
    );
  });
  return /* @__PURE__ */ jsx269("div", { className: "flex flex-col gap-1 lg:gap-4", children: /* @__PURE__ */ jsx269("div", { className: "flex flex-row items-center gap-1 lg:gap-4", children: states }) });
};
var WorkflowButton = ({
  employerId,
  candidateId,
  vacancyId,
  applicationId,
  version,
  action,
  isBusy,
  onDone,
  onUpdating,
  onOffer
}) => {
  if (isGenericTransition(action)) {
    return /* @__PURE__ */ jsx269(
      TransitionButton,
      {
        applicationId,
        version,
        action,
        isBusy,
        onDone,
        onUpdating
      }
    );
  }
  if (action.actionDialog === "Reject" || action.actionName === "Reject") {
    return /* @__PURE__ */ jsx269(
      CandidateApplicationWorkflowRejectButton,
      {
        employerId,
        applicationId,
        version,
        action,
        isBusy,
        onDone,
        onUpdating
      }
    );
  }
  if (action.actionDialog === "Hire") {
    return /* @__PURE__ */ jsx269(
      HireButton,
      {
        applicationId,
        version,
        action,
        isBusy,
        onDone,
        onUpdating
      }
    );
  }
  if (action.actionName === "Approve") {
    return /* @__PURE__ */ jsx269(
      CandidateApplicationWorkflowApproveButton,
      {
        candidateId,
        isBusy,
        onDone,
        onUpdating
      }
    );
  }
  if (action.actionName === "Submit") {
    return /* @__PURE__ */ jsx269(
      SubmitButton,
      {
        applicationId,
        isBusy,
        onDone,
        onUpdating
      }
    );
  }
  if (action.actionName === "Revert") {
    return /* @__PURE__ */ jsx269(
      RestoreButton,
      {
        applicationId,
        vacancyId,
        version,
        isBusy,
        onDone,
        onUpdating
      }
    );
  }
  if (action.actionDialog === "Offer") {
    return /* @__PURE__ */ jsx269(
      CandidateApplicationWorkflowOfferButton,
      {
        applicationId,
        isBusy,
        onDone: onOffer,
        onUpdating
      }
    );
  }
  return /* @__PURE__ */ jsx269(Fragment66, {});
};
var TransitionButton = ({
  applicationId,
  version,
  action,
  isBusy,
  onDone,
  onUpdating
}) => {
  const [transition, isTransitioning] = useApplicationWorkflowTransition();
  const onTransition = useCallback147(async () => {
    onUpdating(true);
    const input = {
      applicationId,
      actionTransitionId: action.workflowActionTransitionId,
      clientMutationId: createClientMutationId66()
    };
    const { result } = await transition({ input });
    onUpdating(false);
    if (result.payload) {
      onDone();
    }
  }, [transition, onUpdating]);
  return /* @__PURE__ */ jsx269(
    Button71,
    {
      color: "transparent",
      clicked: onTransition,
      disabled: isBusy || isTransitioning,
      children: action.actionLabel
    }
  );
};
var HireButton = ({
  applicationId,
  version,
  action,
  isBusy,
  onDone,
  onUpdating
}) => {
  const [hire, isHiring] = useApplicationWorkflowHire();
  const onHire = useCallback147(async () => {
    onUpdating(true);
    const input = {
      applicationId,
      version,
      clientMutationId: createClientMutationId66()
    };
    const { result } = await hire({ input });
    onUpdating(false);
    if (result.payload) {
      onDone();
    }
  }, [hire, onUpdating]);
  return /* @__PURE__ */ jsxs178(Button71, { color: "green", clicked: onHire, disabled: isBusy || isHiring, children: [
    "Hire",
    /* @__PURE__ */ jsx269(CheckCircleIcon3, { className: "ml-1 h-4 w-4" })
  ] });
};
var SubmitButton = ({
  applicationId,
  isBusy,
  onDone,
  onUpdating
}) => {
  const [submit, isSubmiting] = useApplicationWorkflowSubmit();
  const onSubmit = useCallback147(async () => {
    onUpdating(true);
    const input = {
      applicationId,
      clientMutationId: createClientMutationId66()
    };
    const { result } = await submit({ input });
    onUpdating(false);
    if (result.application) {
      onDone();
    }
  }, [submit, onUpdating]);
  return /* @__PURE__ */ jsx269(
    Button71,
    {
      color: "primary",
      clicked: onSubmit,
      disabled: isBusy || isSubmiting,
      children: "Submit"
    }
  );
};
var RestoreButton = ({
  applicationId,
  version,
  vacancyId,
  isBusy,
  onDone,
  onUpdating
}) => {
  const [restore, isRestoring] = useApplicationWorkflowRestore();
  const onRestore = useCallback147(async () => {
    onUpdating(true);
    const input = {
      applicationId,
      version,
      vacancyId,
      clientMutationId: createClientMutationId66()
    };
    const { result } = await restore({ input });
    onUpdating(false);
    if (result.payload) {
      onDone();
    }
  }, [restore, onUpdating]);
  return /* @__PURE__ */ jsx269(
    Button71,
    {
      color: "primary",
      clicked: onRestore,
      disabled: isBusy || isRestoring,
      children: "Restore"
    }
  );
};

// src/candidates/components/CandidateApplicationWorkflowContainer.tsx
import { jsx as jsx270 } from "react/jsx-runtime";
var fragmentDef62 = CandidateApplicationWorkflowContainer_application_graphql_default;
var CandidateApplicationWorkflowContainer = ({
  fragmentRef,
  candidateId,
  employerId,
  applicationId,
  applicationVersion,
  vacancyId,
  accountType,
  onOffer
}) => {
  const data = useFragment78(fragmentDef62, fragmentRef);
  const { workflowDefinition, workflowStateId } = data;
  const definition = buildWorkflow(workflowDefinition);
  const state = getStateById(definition, workflowStateId);
  if (!state) {
    return /* @__PURE__ */ jsx270("div", { children: "Could Not Find Workflow State" });
  }
  return /* @__PURE__ */ jsx270("div", { className: "flex justify-end", children: /* @__PURE__ */ jsx270("div", { children: /* @__PURE__ */ jsx270(
    CandidateApplicationWorkflowStateActionsGroup,
    {
      workflowDefinition: definition,
      workflowStateId,
      candidateId,
      employerId,
      applicationId,
      applicationVersion,
      vacancyId,
      accountType,
      onOffer
    }
  ) }) });
};

// src/candidates/components/__generated__/CandidateApplicationTagsDialogQuery.graphql.ts
var node300 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "applicationCode"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "applicationCode",
    "variableName": "applicationCode"
  }, v23 = [
    v1
  ], v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "applicationId",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "vacancyName",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v9 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }, v10 = [
    v1,
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateApplicationTagsDialogQuery",
      "selections": [
        {
          "args": v23,
          "kind": "FragmentSpread",
          "name": "CandidateApplicationTagEditor_tags"
        },
        {
          "alias": "application",
          "args": v23,
          "concreteType": "Application",
          "kind": "LinkedField",
          "name": "applicationByCode",
          "plural": false,
          "selections": [
            v32,
            v4,
            v5,
            v6,
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "candidate",
              "plural": false,
              "selections": [
                v7,
                v8
              ],
              "storageKey": null
            },
            v9
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateApplicationTagsDialogQuery",
      "selections": [
        {
          "alias": "tags",
          "args": v10,
          "concreteType": "RecruitApplicationTagsConnection",
          "kind": "LinkedField",
          "name": "recruitApplicationTags",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitApplicationTagsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitApplicationTag",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v32,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "tagId",
                      "storageKey": null
                    },
                    v4,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "tagName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "tagDataType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "tagValue",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountsUser",
                      "kind": "LinkedField",
                      "name": "createdByUser",
                      "plural": false,
                      "selections": [
                        v7,
                        v8,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "emailAddress",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v9
          ],
          "storageKey": null
        },
        {
          "alias": "tags",
          "args": v10,
          "filters": [],
          "handle": "connection",
          "key": "CandidateApplicationTagEditor_tags",
          "kind": "LinkedHandle",
          "name": "recruitApplicationTags"
        },
        {
          "alias": "application",
          "args": v23,
          "concreteType": "Application",
          "kind": "LinkedField",
          "name": "applicationByCode",
          "plural": false,
          "selections": [
            v32,
            v4,
            v5,
            v6,
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "candidate",
              "plural": false,
              "selections": [
                v7,
                v8,
                v32
              ],
              "storageKey": null
            },
            v9
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "5ec52a8e9e246d188d74c487a8a85f75",
      "id": null,
      "metadata": {},
      "name": "CandidateApplicationTagsDialogQuery",
      "operationKind": "query",
      "text": "query CandidateApplicationTagsDialogQuery(\n  $applicationCode: Int!\n) {\n  ...CandidateApplicationTagEditor_tags_IzCDo\n  application: applicationByCode(applicationCode: $applicationCode) {\n    id\n    code\n    applicationId\n    vacancyName\n    candidate {\n      firstName\n      lastName\n      id\n    }\n  }\n}\n\nfragment CandidateApplicationTagEditor_tags_IzCDo on Query {\n  tags: recruitApplicationTags(applicationCode: $applicationCode, first: 10) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        tagId\n        code\n        updatedAt\n        tagName\n        tagDataType\n        tagValue\n        createdByUser {\n          firstName\n          lastName\n          emailAddress\n        }\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node300.hash = "eb9c14982ceeb2e0b2dae436e6486fa3";
var CandidateApplicationTagsDialogQuery_graphql_default = node300;

// src/candidates/components/CandidateApplicationTagsDialog.tsx
import { Fragment as Fragment67, Suspense as Suspense90 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery37 } from "react-relay";
import { Dialog as Dialog3, Transition as Transition3 } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { EdSkeleton as EdSkeleton77 } from "shared-ui";

// src/candidates/components/__generated__/ApplicationTagEditorPaginationQuery.graphql.ts
var node301 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "applicationCode"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "after",
      "variableName": "after"
    },
    {
      "kind": "Variable",
      "name": "applicationCode",
      "variableName": "applicationCode"
    },
    {
      "kind": "Variable",
      "name": "first",
      "variableName": "first"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ApplicationTagEditorPaginationQuery",
      "selections": [
        {
          "args": v1,
          "kind": "FragmentSpread",
          "name": "CandidateApplicationTagEditor_tags"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ApplicationTagEditorPaginationQuery",
      "selections": [
        {
          "alias": "tags",
          "args": v1,
          "concreteType": "RecruitApplicationTagsConnection",
          "kind": "LinkedField",
          "name": "recruitApplicationTags",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitApplicationTagsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitApplicationTag",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "tagId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "tagName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "tagDataType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "tagValue",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountsUser",
                      "kind": "LinkedField",
                      "name": "createdByUser",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "firstName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "lastName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "emailAddress",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "tags",
          "args": v1,
          "filters": [],
          "handle": "connection",
          "key": "CandidateApplicationTagEditor_tags",
          "kind": "LinkedHandle",
          "name": "recruitApplicationTags"
        }
      ]
    },
    "params": {
      "cacheID": "542dcac9b233843252d702f7ba16a251",
      "id": null,
      "metadata": {},
      "name": "ApplicationTagEditorPaginationQuery",
      "operationKind": "query",
      "text": "query ApplicationTagEditorPaginationQuery(\n  $after: String\n  $applicationCode: Int\n  $first: Int = 10\n) {\n  ...CandidateApplicationTagEditor_tags_3vTWvv\n}\n\nfragment CandidateApplicationTagEditor_tags_3vTWvv on Query {\n  tags: recruitApplicationTags(applicationCode: $applicationCode, first: $first, after: $after) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        tagId\n        code\n        updatedAt\n        tagName\n        tagDataType\n        tagValue\n        createdByUser {\n          firstName\n          lastName\n          emailAddress\n        }\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node301.hash = "9debd30f6b6cb9cc5c9cc9aa667602d2";
var ApplicationTagEditorPaginationQuery_graphql_default = node301;

// src/candidates/components/__generated__/CandidateApplicationTagEditor_tags.graphql.ts
var node303 = function() {
  var v0 = [
    "tags"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "applicationCode"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": ApplicationTagEditorPaginationQuery_graphql_default
      }
    },
    "name": "CandidateApplicationTagEditor_tags",
    "selections": [
      {
        "alias": "tags",
        "args": null,
        "concreteType": "RecruitApplicationTagsConnection",
        "kind": "LinkedField",
        "name": "__CandidateApplicationTagEditor_tags_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitApplicationTagsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitApplicationTag",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "tagId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "tagName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "tagDataType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "tagValue",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AccountsUser",
                    "kind": "LinkedField",
                    "name": "createdByUser",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "firstName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lastName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "emailAddress",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node303.hash = "9debd30f6b6cb9cc5c9cc9aa667602d2";
var CandidateApplicationTagEditor_tags_graphql_default = node303;

// src/candidates/components/CandidateApplicationTagEditor.tsx
import { useCallback as useCallback148 } from "react";
import { usePaginationFragment as usePaginationFragment13 } from "react-relay";
import { createClientMutationId as createClientMutationId67 } from "shared-lib";
import { DataTagEditor } from "shared-ui";
import { jsx as jsx271 } from "react/jsx-runtime";
var fragmentDef63 = CandidateApplicationTagEditor_tags_graphql_default;
function toEditorTags(data) {
  if (!data.tags?.edges) {
    return [];
  }
  const tags = data.tags.edges?.map((e4) => e4.node);
  return tags;
}
var CandidateApplicationTagEditor = ({
  applicationId,
  applicationCode,
  fragmentRef
}) => {
  const { data, loadNext, hasNext, isLoadingNext, refetch } = usePaginationFragment13(fragmentDef63, fragmentRef);
  const [addTag, isAddingTag] = useAddApplicationTag();
  const [updateTag, isUpdatingTag] = useUpdateApplicationTag();
  const [deleteTag, isDeletingTag] = useDeleteApplicationTag();
  const onAdd = useCallback148(
    async (data2, onDone) => {
      const input = {
        applicationId,
        clientMutationId: createClientMutationId67(),
        tagDataType: "STRING",
        tagName: data2.tagName,
        tagValue: data2.tagValue
      };
      await addTag({
        input
      });
      await refetch({ applicationCode }, { fetchPolicy: "network-only" });
      onDone();
    },
    [addTag, applicationId]
  );
  const onUpdated = useCallback148(
    async (tag, onDone) => {
      const input = {
        clientMutationId: createClientMutationId67(),
        applicationTagId: tag.tagId,
        tagDataType: "STRING",
        tagName: tag.tagName,
        tagValue: tag.tagValue
      };
      await updateTag({
        input
      });
      await refetch({ applicationCode }, { fetchPolicy: "network-only" });
      onDone();
    },
    [updateTag]
  );
  const onRemove = useCallback148(
    async (id18, onDone) => {
      const input = {
        clientMutationId: createClientMutationId67(),
        applicationTagId: id18
      };
      await deleteTag({
        input
      });
      await refetch({ applicationCode }, { fetchPolicy: "network-only" });
      onDone();
    },
    [deleteTag]
  );
  const tags = toEditorTags(data);
  return /* @__PURE__ */ jsx271("div", { className: "flex flex-col gap-2", children: /* @__PURE__ */ jsx271(
    DataTagEditor,
    {
      isBusy: isAddingTag || isUpdatingTag || isDeletingTag,
      onAdd,
      onUpdated,
      onRemove,
      tags
    }
  ) });
};

// src/candidates/components/CandidateApplicationTagsDialog.tsx
import { Fragment as Fragment68, jsx as jsx273, jsxs as jsxs179 } from "react/jsx-runtime";
var queryDef42 = CandidateApplicationTagsDialogQuery_graphql_default;
var CandidateApplicationTagsDialog = ({
  applicationCode,
  isShowing,
  onClose
}) => {
  const query3 = useLazyLoadQuery37(
    queryDef42,
    { applicationCode },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { application: application3 } = query3;
  if (!application3) {
    return /* @__PURE__ */ jsx273(Fragment68, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx273(Suspense90, { fallback: /* @__PURE__ */ jsx273(EdSkeleton77, {}), children: /* @__PURE__ */ jsx273(Transition3.Root, { show: isShowing, as: Fragment67, children: /* @__PURE__ */ jsxs179(Dialog3, { as: "div", className: "relative z-10", onClose, children: [
    /* @__PURE__ */ jsx273("div", { className: "fixed inset-0" }),
    /* @__PURE__ */ jsx273("div", { className: "fixed inset-0 overflow-hidden", children: /* @__PURE__ */ jsx273("div", { className: "absolute inset-0 overflow-hidden", children: /* @__PURE__ */ jsx273("div", { className: "pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10", children: /* @__PURE__ */ jsx273(
      Transition3.Child,
      {
        as: Fragment67,
        enter: "transform transition ease-in-out duration-500 sm:duration-700",
        enterFrom: "translate-x-full",
        enterTo: "translate-x-0",
        leave: "transform transition ease-in-out duration-500 sm:duration-700",
        leaveFrom: "translate-x-0",
        leaveTo: "translate-x-full",
        children: /* @__PURE__ */ jsx273(Dialog3.Panel, { className: "pointer-events-auto w-screen max-w-md", children: /* @__PURE__ */ jsxs179("div", { className: "flex h-full flex-col overflow-y-scroll bg-white shadow-xl", children: [
          /* @__PURE__ */ jsxs179("div", { className: "bg-primary-700 px-4 py-6 sm:px-6", children: [
            /* @__PURE__ */ jsxs179("div", { className: "flex items-center justify-between", children: [
              /* @__PURE__ */ jsx273(Dialog3.Title, { className: "text-base font-semibold leading-6 text-white", children: "Tags" }),
              /* @__PURE__ */ jsx273("div", { className: "ml-3 flex h-7 items-center", children: /* @__PURE__ */ jsxs179(
                "button",
                {
                  type: "button",
                  className: "bg-primary-700 text-primary-200 relative rounded-md hover:text-white focus:outline-none focus:ring-2 focus:ring-white",
                  onClick: onClose,
                  children: [
                    /* @__PURE__ */ jsx273("span", { className: "absolute -inset-2.5" }),
                    /* @__PURE__ */ jsx273("span", { className: "sr-only", children: "Close panel" }),
                    /* @__PURE__ */ jsx273(
                      XMarkIcon,
                      {
                        className: "h-6 w-6",
                        "aria-hidden": "true"
                      }
                    )
                  ]
                }
              ) })
            ] }),
            /* @__PURE__ */ jsx273("div", { className: "mt-1", children: /* @__PURE__ */ jsx273("p", { className: "text-primary-300 text-sm", children: "Edit application tags below" }) })
          ] }),
          /* @__PURE__ */ jsx273("div", { className: "relative flex-1 px-4 py-6 sm:px-6", children: /* @__PURE__ */ jsx273(
            CandidateApplicationTagEditor,
            {
              applicationId: application3.applicationId,
              applicationCode: application3.code,
              fragmentRef: query3
            }
          ) })
        ] }) })
      }
    ) }) }) })
  ] }) }) });
};

// src/candidates/components/__generated__/CandidateApplicationRelevanceRouteQuery.graphql.ts
var node304 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "applicationCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "applicationCode",
      "variableName": "applicationCode"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "recruitProfileId",
    "storageKey": null
  }, v5 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateApplicationRelevanceRouteQuery",
      "selections": [
        {
          "alias": "application",
          "args": v1,
          "concreteType": "Application",
          "kind": "LinkedField",
          "name": "applicationByCode",
          "plural": false,
          "selections": [
            v23,
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": "Vacancy",
              "kind": "LinkedField",
              "name": "vacancy",
              "plural": false,
              "selections": [
                v32
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfile",
              "kind": "LinkedField",
              "name": "profile",
              "plural": false,
              "selections": [
                v4
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "CandidateApplicationRelevance_application"
            },
            v5
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateApplicationRelevanceRouteQuery",
      "selections": [
        {
          "alias": "application",
          "args": v1,
          "concreteType": "Application",
          "kind": "LinkedField",
          "name": "applicationByCode",
          "plural": false,
          "selections": [
            v23,
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": "Vacancy",
              "kind": "LinkedField",
              "name": "vacancy",
              "plural": false,
              "selections": [
                v32,
                v23
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfile",
              "kind": "LinkedField",
              "name": "profile",
              "plural": false,
              "selections": [
                v4,
                v23
              ],
              "storageKey": null
            },
            v5
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "1153b459277b72502ee4f4dc6525ceb7",
      "id": null,
      "metadata": {},
      "name": "CandidateApplicationRelevanceRouteQuery",
      "operationKind": "query",
      "text": "query CandidateApplicationRelevanceRouteQuery(\n  $applicationCode: Int!\n) {\n  application: applicationByCode(applicationCode: $applicationCode) {\n    id\n    code\n    vacancy {\n      code\n      id\n    }\n    profile {\n      recruitProfileId\n      id\n    }\n    ...CandidateApplicationRelevance_application\n  }\n}\n\nfragment CandidateApplicationRelevance_application on Application {\n  code\n  vacancy {\n    code\n    id\n  }\n  profile {\n    recruitProfileId\n    id\n  }\n}\n"
    }
  };
}();
node304.hash = "6363d452805267554260d827567dc877";
var CandidateApplicationRelevanceRouteQuery_graphql_default = node304;

// src/candidates/components/__generated__/CandidateApplicationRelevance_application.graphql.ts
var node305 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CandidateApplicationRelevance_application",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "concreteType": "Vacancy",
        "kind": "LinkedField",
        "name": "vacancy",
        "plural": false,
        "selections": [
          v0
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitProfile",
        "kind": "LinkedField",
        "name": "profile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "recruitProfileId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Application",
    "abstractKey": null
  };
}();
node305.hash = "d9c1aaf545baa4f666092c0344cf38d7";
var CandidateApplicationRelevance_application_graphql_default = node305;

// src/candidates/components/CandidateApplicationRelevance.tsx
import { Suspense as Suspense91 } from "react";
import { loadQuery as loadQuery26, useFragment as useFragment79 } from "react-relay";
import { Link as Link18 } from "react-router-dom";
import { useRouteData as useRouteData14 } from "shared-lib";
import { EdSkeleton as EdSkeleton79, classNames as classNames33 } from "shared-ui";

// src/candidates/components/__generated__/CandidateApplicationRelevanceProviderQuery.graphql.ts
var node306 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "applicationCode"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "profileId"
  }, v23 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "vacancyCode"
  }, v32 = [
    {
      "kind": "Literal",
      "name": "experienceIds",
      "value": []
    },
    {
      "items": [
        {
          "kind": "Variable",
          "name": "profileIds.0",
          "variableName": "profileId"
        }
      ],
      "kind": "ListValue",
      "name": "profileIds"
    },
    {
      "kind": "Literal",
      "name": "skillGroupIds",
      "value": []
    },
    {
      "kind": "Variable",
      "name": "vacancyCode",
      "variableName": "vacancyCode"
    }
  ], v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateId",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "experienceId",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "sentence",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "sentenceIndex",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "similarity",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "skillGroupId",
    "storageKey": null
  }, v10 = [
    {
      "kind": "Variable",
      "name": "applicationCode",
      "variableName": "applicationCode"
    }
  ], v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyScore",
    "storageKey": null
  }, v14 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "jobMatchScore",
    "storageKey": null
  }, v15 = {
    "alias": null,
    "args": null,
    "concreteType": "ApplicationScores",
    "kind": "LinkedField",
    "name": "scores",
    "plural": false,
    "selections": [
      v13,
      v14,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalScore",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v16 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }, v17 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "numberOfMonthsCertain",
    "storageKey": null
  }, v18 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "numberOfMonthsCertainPlusUnknown",
    "storageKey": null
  }, v19 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "mostRecentCertainExperienceEnd",
    "storageKey": null
  }, v20 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "mostRecentUnknownExperienceEnd",
    "storageKey": null
  }, v21 = [
    v17,
    v18,
    v19,
    v20
  ], v222 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v232 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "weight",
    "storageKey": null
  }, v24 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationAmount",
    "storageKey": null
  }, v25 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationType",
    "storageKey": null
  }, v26 = [
    v24,
    v25
  ];
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1,
        v23
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateApplicationRelevanceProviderQuery",
      "selections": [
        {
          "alias": "results",
          "args": v32,
          "concreteType": "SentenceSimilarity",
          "kind": "LinkedField",
          "name": "recruitVacancyGetSentenceSimilarities",
          "plural": true,
          "selections": [
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "MatchRelevanceProvider_sentences"
            }
          ],
          "storageKey": null
        },
        {
          "alias": "application",
          "args": v10,
          "concreteType": "Application",
          "kind": "LinkedField",
          "name": "applicationByCode",
          "plural": false,
          "selections": [
            v11,
            v12,
            v15,
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitMatchRelevanceContainer",
              "kind": "LinkedField",
              "name": "matchRelevance",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "MatchRelevanceProvider_relevance"
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Vacancy",
              "kind": "LinkedField",
              "name": "vacancy",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "MatchRelevanceProvider_vacancy"
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitMatchProfile",
              "kind": "LinkedField",
              "name": "matchProfile",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "MatchRelevanceProvider_matchProfile"
                }
              ],
              "storageKey": null
            },
            v16
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v23,
        v0,
        v1
      ],
      "kind": "Operation",
      "name": "CandidateApplicationRelevanceProviderQuery",
      "selections": [
        {
          "alias": "results",
          "args": v32,
          "concreteType": "SentenceSimilarity",
          "kind": "LinkedField",
          "name": "recruitVacancyGetSentenceSimilarities",
          "plural": true,
          "selections": [
            v4,
            v5,
            v6,
            v7,
            v8,
            v9
          ],
          "storageKey": null
        },
        {
          "alias": "application",
          "args": v10,
          "concreteType": "Application",
          "kind": "LinkedField",
          "name": "applicationByCode",
          "plural": false,
          "selections": [
            v11,
            v12,
            v15,
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitMatchRelevanceContainer",
              "kind": "LinkedField",
              "name": "matchRelevance",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitMatchSkillRelevance",
                  "kind": "LinkedField",
                  "name": "skillGroups",
                  "plural": true,
                  "selections": [
                    v9,
                    v17,
                    v18,
                    v19,
                    v20
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitMatchRelevance",
                  "kind": "LinkedField",
                  "name": "industry",
                  "plural": false,
                  "selections": v21,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitMatchRelevance",
                  "kind": "LinkedField",
                  "name": "job",
                  "plural": false,
                  "selections": v21,
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Vacancy",
              "kind": "LinkedField",
              "name": "vacancy",
              "plural": false,
              "selections": [
                v11,
                v12,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SkillGroup",
                  "kind": "LinkedField",
                  "name": "skillGroups",
                  "plural": true,
                  "selections": [
                    v11,
                    v9,
                    v222,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isRequired",
                      "storageKey": null
                    },
                    v232,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "SkillGroupTerm",
                      "kind": "LinkedField",
                      "name": "terms",
                      "plural": true,
                      "selections": [
                        v222,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isSkill",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Duration",
                      "kind": "LinkedField",
                      "name": "experience",
                      "plural": false,
                      "selections": v26,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Duration",
                      "kind": "LinkedField",
                      "name": "recency",
                      "plural": false,
                      "selections": [
                        v25,
                        v24
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "VacancyScoringConfig",
                  "kind": "LinkedField",
                  "name": "scoringConfig",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Duration",
                      "kind": "LinkedField",
                      "name": "industryExperience",
                      "plural": false,
                      "selections": v26,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "industryNegativeThreshold",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "industryPositiveThreshold",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Duration",
                      "kind": "LinkedField",
                      "name": "industryRecency",
                      "plural": false,
                      "selections": v26,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "relevanceNegativeThreshold",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "relevancePositiveThreshold",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Duration",
                      "kind": "LinkedField",
                      "name": "relevantExperience",
                      "plural": false,
                      "selections": v26,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Duration",
                      "kind": "LinkedField",
                      "name": "relevantRecency",
                      "plural": false,
                      "selections": v26,
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitMatchProfile",
              "kind": "LinkedField",
              "name": "matchProfile",
              "plural": false,
              "selections": [
                v11,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "vacancyId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitMatchProfileExperience",
                  "kind": "LinkedField",
                  "name": "experience",
                  "plural": true,
                  "selections": [
                    v11,
                    v12,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "version",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "titleId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "title",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "industry",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "companyIsVerified",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "companyId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "companyName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "startDate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "endDate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "positionType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "MatchProfileExperienceSkillGroupScore",
                      "kind": "LinkedField",
                      "name": "skillGroupScores",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "groupId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "hasMatch",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "minSkillGroupScore",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "score",
                          "storageKey": null
                        },
                        v232
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "escoOccupationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "escoHierarchy",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobMatchWeight",
                      "storageKey": null
                    },
                    v14,
                    v13,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "companyScoreWeight",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasCompanyVector",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v16
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "a2adbdf395240ae9a3be5df27aa332a9",
      "id": null,
      "metadata": {},
      "name": "CandidateApplicationRelevanceProviderQuery",
      "operationKind": "query",
      "text": "query CandidateApplicationRelevanceProviderQuery(\n  $vacancyCode: Int!\n  $applicationCode: Int!\n  $profileId: UUID!\n) {\n  results: recruitVacancyGetSentenceSimilarities(vacancyCode: $vacancyCode, profileIds: [$profileId], experienceIds: [], skillGroupIds: []) {\n    candidateId\n    experienceId\n    sentence\n    sentenceIndex\n    similarity\n    skillGroupId\n    ...MatchRelevanceProvider_sentences\n  }\n  application: applicationByCode(applicationCode: $applicationCode) {\n    id\n    code\n    scores {\n      companyScore\n      jobMatchScore\n      totalScore\n    }\n    matchRelevance {\n      ...MatchRelevanceProvider_relevance\n    }\n    vacancy {\n      ...MatchRelevanceProvider_vacancy\n      id\n    }\n    matchProfile {\n      ...MatchRelevanceProvider_matchProfile\n    }\n  }\n}\n\nfragment MatchRelevanceProvider_matchProfile on RecruitMatchProfile {\n  id\n  vacancyId\n  experience {\n    id\n    code\n    version\n    titleId\n    title\n    industry\n    companyIsVerified\n    companyId\n    companyName\n    description\n    startDate\n    endDate\n    positionType\n    skillGroupScores {\n      groupId\n      hasMatch\n      minSkillGroupScore\n      score\n      weight\n    }\n    escoOccupationId\n    escoHierarchy\n    jobMatchWeight\n    jobMatchScore\n    companyScore\n    companyScoreWeight\n    hasCompanyVector\n  }\n}\n\nfragment MatchRelevanceProvider_relevance on RecruitMatchRelevanceContainer {\n  skillGroups {\n    skillGroupId\n    numberOfMonthsCertain\n    numberOfMonthsCertainPlusUnknown\n    mostRecentCertainExperienceEnd\n    mostRecentUnknownExperienceEnd\n  }\n  industry {\n    numberOfMonthsCertain\n    numberOfMonthsCertainPlusUnknown\n    mostRecentCertainExperienceEnd\n    mostRecentUnknownExperienceEnd\n  }\n  job {\n    numberOfMonthsCertain\n    numberOfMonthsCertainPlusUnknown\n    mostRecentCertainExperienceEnd\n    mostRecentUnknownExperienceEnd\n  }\n}\n\nfragment MatchRelevanceProvider_sentences on SentenceSimilarity {\n  candidateId\n  experienceId\n  sentence\n  sentenceIndex\n  similarity\n  skillGroupId\n}\n\nfragment MatchRelevanceProvider_vacancy on Vacancy {\n  id\n  code\n  skillGroups {\n    id\n    skillGroupId\n    name\n    isRequired\n    weight\n    terms {\n      name\n      isSkill\n    }\n    experience {\n      durationAmount\n      durationType\n    }\n    recency {\n      durationType\n      durationAmount\n    }\n  }\n  scoringConfig {\n    industryExperience {\n      durationAmount\n      durationType\n    }\n    industryNegativeThreshold\n    industryPositiveThreshold\n    industryRecency {\n      durationAmount\n      durationType\n    }\n    relevanceNegativeThreshold\n    relevancePositiveThreshold\n    relevantExperience {\n      durationAmount\n      durationType\n    }\n    relevantRecency {\n      durationAmount\n      durationType\n    }\n  }\n}\n"
    }
  };
}();
node306.hash = "753c059e1ba4151f8b9eb7490134c4e1";
var CandidateApplicationRelevanceProviderQuery_graphql_default = node306;

// src/candidates/components/CandidateApplicationRelevanceProvider.tsx
import { useLazyLoadQuery as useLazyLoadQuery38 } from "react-relay";
import { EdSkeleton as EdSkeleton78 } from "shared-ui";
import { jsx as jsx274 } from "react/jsx-runtime";
var queryDef43 = CandidateApplicationRelevanceProviderQuery_graphql_default;
var CandidateApplicationRelevanceProvider = ({ vacancyCode, applicationCode, profileId, children }) => {
  const query3 = useLazyLoadQuery38(
    queryDef43,
    {
      vacancyCode,
      applicationCode,
      profileId
    },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { application: application3 } = query3;
  if (!application3 || !application3.matchProfile) {
    return /* @__PURE__ */ jsx274(EdSkeleton78, {});
  }
  const { matchProfile, matchRelevance, vacancy } = application3;
  return /* @__PURE__ */ jsx274(
    MatchRelevanceProvider,
    {
      sentences: query3.results,
      matchProfileFragmentRef: matchProfile,
      matchRelevanceFragmentRef: matchRelevance,
      vacancyFragmentRef: vacancy,
      children
    }
  );
};

// src/candidates/components/CandidateApplicationRelevance.tsx
import { Fragment as Fragment69, jsx as jsx275, jsxs as jsxs180 } from "react/jsx-runtime";
var queryDef44 = CandidateApplicationRelevanceRouteQuery_graphql_default;
async function loader21(environment, params) {
  const code = params.applicationCode;
  const applicationCode = Number(code);
  try {
    return loadQuery26(
      environment,
      queryDef44,
      {
        applicationCode
      }
    );
  } catch (e4) {
    console.error("ApplicationSearchRoot Loader Failed.");
    console.error(e4);
    throw e4;
  }
}
var CandidateApplicationRelevance = ({
  routeId: routeId4
}) => {
  const data = useRouteData14(
    queryDef44,
    routeId4
  );
  if (!data) {
    return /* @__PURE__ */ jsx275(Fragment69, { children: "Loading..." });
  }
  const { application: application3 } = data;
  if (!application3) {
    return /* @__PURE__ */ jsx275(Fragment69, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx275(Suspense91, { fallback: /* @__PURE__ */ jsx275(EdSkeleton79, {}), children: /* @__PURE__ */ jsx275("div", { className: "border-t bg-white", children: /* @__PURE__ */ jsx275(CandidateApplicationRelevanceComponent, { fragmentRef: application3 }) }) });
};
function CandidateApplicationRelevanceComponent({
  fragmentRef,
  grid = false
}) {
  const application3 = useFragment79(
    CandidateApplicationRelevanceComponent.fragments.application,
    fragmentRef
  );
  return /* @__PURE__ */ jsx275(Fragment69, { children: /* @__PURE__ */ jsxs180(
    CandidateApplicationRelevanceProvider,
    {
      vacancyCode: application3.vacancy.code,
      applicationCode: application3.code,
      profileId: application3.profile.recruitProfileId,
      children: [
        /* @__PURE__ */ jsxs180(
          "div",
          {
            className: classNames33(
              "hidden flex-col gap-5 rounded-2xl bg-gray-100 bg-white 2xl:flex"
            ),
            children: [
              /* @__PURE__ */ jsx275("div", { className: "rounded-lg border bg-white p-5", children: /* @__PURE__ */ jsx275(MatchRelevanceProfileTimeline, {}) }),
              /* @__PURE__ */ jsx275("div", { className: "rounded-lg border bg-white p-5", children: /* @__PURE__ */ jsx275(MatchExperienceSimilarityHighlighter, {}) })
            ]
          }
        ),
        /* @__PURE__ */ jsx275(
          "div",
          {
            className: classNames33(
              "flex flex-col gap-3 rounded-2xl bg-white 2xl:hidden"
            ),
            children: /* @__PURE__ */ jsx275(MatchRelevanceProfileTimelineGrid, {})
          }
        )
      ]
    }
  ) });
}
CandidateApplicationRelevanceComponent.fragments = {
  application: CandidateApplicationRelevance_application_graphql_default
};
var createRoute16 = (routePrefix, environment, context) => {
  const routeId4 = `${routePrefix}-application-search-relevance`;
  return {
    id: routeId4,
    path: "relevance/*",
    element: /* @__PURE__ */ jsx275(CandidateApplicationRelevance, { routeId: routeId4 }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx275(Link18, { to: "", children: "Relevance" })
    },
    loader: ({ params }) => {
      return loader21(environment, params);
    }
  };
};

// src/candidates/components/__generated__/CandidateApplicationTasksQuery.graphql.ts
var node307 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "applicationId"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "candidateId"
  }, v23 = [
    {
      "fields": [
        {
          "fields": [
            {
              "fields": [
                {
                  "kind": "Variable",
                  "name": "eq",
                  "variableName": "candidateId"
                }
              ],
              "kind": "ObjectValue",
              "name": "id"
            }
          ],
          "kind": "ObjectValue",
          "name": "assignedTo"
        },
        {
          "kind": "Literal",
          "name": "group",
          "value": {
            "name": {
              "eq": "Application"
            }
          }
        },
        {
          "fields": [
            {
              "fields": [
                {
                  "kind": "Variable",
                  "name": "eq",
                  "variableName": "applicationId"
                }
              ],
              "kind": "ObjectValue",
              "name": "id"
            }
          ],
          "kind": "ObjectValue",
          "name": "source"
        }
      ],
      "kind": "ObjectValue",
      "name": "where"
    }
  ], v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v4 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateApplicationTasksQuery",
      "selections": [
        {
          "alias": "tasks",
          "args": v23,
          "concreteType": "TasksCandidateTasksConnection",
          "kind": "LinkedField",
          "name": "tasksCandidateTasks",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TasksCandidateTask",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                v32,
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "TaskItem_task"
                }
              ],
              "storageKey": null
            },
            v4
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "CandidateApplicationTasksQuery",
      "selections": [
        {
          "alias": "tasks",
          "args": v23,
          "concreteType": "TasksCandidateTasksConnection",
          "kind": "LinkedField",
          "name": "tasksCandidateTasks",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TasksCandidateTask",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                v32,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "candidateTaskId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "type",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "version",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "description",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "summary",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "status",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v4
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "51ca24f5d4ca73c5e2c3fe32b53b8c11",
      "id": null,
      "metadata": {},
      "name": "CandidateApplicationTasksQuery",
      "operationKind": "query",
      "text": 'query CandidateApplicationTasksQuery(\n  $candidateId: UUID!\n  $applicationId: UUID!\n) {\n  tasks: tasksCandidateTasks(where: {assignedTo: {id: {eq: $candidateId}}, group: {name: {eq: "Application"}}, source: {id: {eq: $applicationId}}}) {\n    nodes {\n      id\n      ...TaskItem_task\n    }\n  }\n}\n\nfragment TaskItem_task on TasksCandidateTask {\n  id\n  candidateTaskId\n  type\n  version\n  description\n  title\n  summary\n  status\n}\n'
    }
  };
}();
node307.hash = "835246e653cd2573ef79f64523d7dc1b";
var CandidateApplicationTasksQuery_graphql_default = node307;

// src/candidates/components/__generated__/CandidateApplicationTasksRouteQuery.graphql.ts
var node308 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "applicationCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "applicationCode",
      "variableName": "applicationCode"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "applicationId",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateId",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "vacancyName",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v9 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "employerName",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currencyCode",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "payType",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "max",
    "storageKey": null
  }, v14 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "min",
    "storageKey": null
  }, v15 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "countryCode",
    "storageKey": null
  }, v16 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateApplicationTasksRouteQuery",
      "selections": [
        {
          "alias": "application",
          "args": v1,
          "concreteType": "Application",
          "kind": "LinkedField",
          "name": "applicationByCode",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ApplicationTaskDetails_application"
            },
            v23,
            v32,
            v4,
            v5,
            v6,
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfile",
              "kind": "LinkedField",
              "name": "profile",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ApplicationTaskDetails_profile"
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "candidate",
              "plural": false,
              "selections": [
                v7,
                v8
              ],
              "storageKey": null
            },
            v9
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateApplicationTasksRouteQuery",
      "selections": [
        {
          "alias": "application",
          "args": v1,
          "concreteType": "Application",
          "kind": "LinkedField",
          "name": "applicationByCode",
          "plural": false,
          "selections": [
            v23,
            v4,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "version",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "employerId",
              "storageKey": null
            },
            v10,
            v6,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "applicationStateName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "workflowStateName",
              "storageKey": null
            },
            v5,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "appliedAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "completedByCandidateAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "declinedByCandidateAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "declinedByEmployerAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hiredAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasCompletedDocumentTypes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasCompletedForms",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasCompletedRequiredSkills",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasCompletedOptionalSkills",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasCompletedRate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "rightToWorkStatus",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ApplicationCandidateRate",
              "kind": "LinkedField",
              "name": "candidateRate",
              "plural": false,
              "selections": [
                v11,
                v12,
                v13,
                v14
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Vacancy",
              "kind": "LinkedField",
              "name": "vacancy",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "VacancyRate",
                  "kind": "LinkedField",
                  "name": "rate",
                  "plural": false,
                  "selections": [
                    v13,
                    v14,
                    v11,
                    v12,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currencyCountry",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isPrivate",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "LocationCriteria",
                  "kind": "LinkedField",
                  "name": "locations",
                  "plural": true,
                  "selections": [
                    v15,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "countryName",
                      "storageKey": null
                    },
                    v16,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "entireCountry",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "latitude",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "longitude",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "radius",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "state",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                v23,
                v10,
                v16
              ],
              "storageKey": null
            },
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfile",
              "kind": "LinkedField",
              "name": "profile",
              "plural": false,
              "selections": [
                v23,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "recruitProfileId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileRate",
                  "kind": "LinkedField",
                  "name": "rate",
                  "plural": false,
                  "selections": [
                    v12,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "minimumRateOfPay",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "maximumRateOfPay",
                      "storageKey": null
                    },
                    v15,
                    v11,
                    v23
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperience",
                  "kind": "LinkedField",
                  "name": "experience",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "candidateExperienceId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "companyId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "companyName",
                      "storageKey": null
                    },
                    v23
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "candidate",
              "plural": false,
              "selections": [
                v7,
                v8,
                v23
              ],
              "storageKey": null
            },
            v9
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "fa78ba2791c0d9c31dd117fd48e5d090",
      "id": null,
      "metadata": {},
      "name": "CandidateApplicationTasksRouteQuery",
      "operationKind": "query",
      "text": "query CandidateApplicationTasksRouteQuery(\n  $applicationCode: Int!\n) {\n  application: applicationByCode(applicationCode: $applicationCode) {\n    ...ApplicationTaskDetails_application\n    id\n    code\n    applicationId\n    candidateId\n    vacancyName\n    profile {\n      ...ApplicationTaskDetails_profile\n      id\n    }\n    candidate {\n      firstName\n      lastName\n      id\n    }\n  }\n}\n\nfragment ApplicationRateEditor_RecruitProfile on RecruitProfile {\n  recruitProfileId\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n}\n\nfragment ApplicationTaskDetails_application on Application {\n  id\n  applicationId\n  version\n  employerId\n  employerName\n  vacancyName\n  applicationStateName\n  workflowStateName\n  candidateId\n  appliedAt\n  completedByCandidateAt\n  declinedByCandidateAt\n  declinedByEmployerAt\n  hiredAt\n  hasCompletedDocumentTypes\n  hasCompletedForms\n  hasCompletedRequiredSkills\n  hasCompletedOptionalSkills\n  hasCompletedRate\n  rightToWorkStatus\n  candidateRate {\n    currencyCode\n    payType\n    max\n    min\n  }\n  vacancy {\n    rate {\n      max\n      min\n      currencyCode\n      payType\n      currencyCountry\n      isPrivate\n    }\n    locations {\n      countryCode\n      countryName\n      name\n      entireCountry\n      latitude\n      longitude\n      radius\n      state\n    }\n    id\n  }\n  ...RightToWorkTask_application\n  ...ClarifyOptionalSkillsApplicationTask_application\n  ...ClarifySkillsApplicationTask_application\n  ...OfferTaskFragment_application\n}\n\nfragment ApplicationTaskDetails_profile on RecruitProfile {\n  id\n  recruitProfileId\n  ...ClarifyRateApplicationTask_profile\n  ...ClarifySkillsApplicationTask_profile\n  ...ClarifyOptionalSkillsApplicationTask_profile\n}\n\nfragment ClarifyOptionalSkillsApplicationTask_application on Application {\n  id\n}\n\nfragment ClarifyOptionalSkillsApplicationTask_profile on RecruitProfile {\n  id\n  experience {\n    id\n  }\n  ...ExperienceDropdown_RecruitProfile\n}\n\nfragment ClarifyRateApplicationTask_profile on RecruitProfile {\n  id\n  recruitProfileId\n  ...ApplicationRateEditor_RecruitProfile\n}\n\nfragment ClarifySkillsApplicationTask_application on Application {\n  id\n  applicationId\n}\n\nfragment ClarifySkillsApplicationTask_profile on RecruitProfile {\n  id\n  ...ExperienceDropdown_RecruitProfile\n}\n\nfragment ExperienceDropdown_RecruitProfile on RecruitProfile {\n  experience {\n    candidateExperienceId\n    companyId\n    companyName\n    id\n  }\n}\n\nfragment OfferTaskFragment_application on Application {\n  id\n  applicationId\n  candidateId\n  employerId\n  vacancy {\n    employerName\n    name\n    id\n  }\n}\n\nfragment RightToWorkTask_application on Application {\n  id\n  applicationId\n  version\n  employerId\n  employerName\n  vacancyName\n  applicationStateName\n  workflowStateName\n  appliedAt\n  completedByCandidateAt\n  declinedByCandidateAt\n  declinedByEmployerAt\n  hiredAt\n  hasCompletedDocumentTypes\n  hasCompletedForms\n  hasCompletedRequiredSkills\n  hasCompletedOptionalSkills\n  hasCompletedRate\n  rightToWorkStatus\n  candidateRate {\n    currencyCode\n    payType\n    max\n    min\n  }\n  vacancy {\n    rate {\n      max\n      min\n      currencyCode\n      payType\n      currencyCountry\n      isPrivate\n    }\n    locations {\n      countryCode\n      countryName\n      name\n      entireCountry\n      latitude\n      longitude\n      radius\n      state\n    }\n    id\n  }\n}\n"
    }
  };
}();
node308.hash = "4e5cca425849e75a7e46ac2f1c3bad10";
var CandidateApplicationTasksRouteQuery_graphql_default = node308;

// src/candidates/components/CandidateApplicationTasks.tsx
import { Suspense as Suspense93 } from "react";
import { loadQuery as loadQuery27, useLazyLoadQuery as useLazyLoadQuery39 } from "react-relay";
import { Link as Link19 } from "react-router-dom";
import { useRouteData as useRouteData15 } from "shared-lib";
import { EdSkeleton as EdSkeleton80 } from "shared-ui";
import { TaskItem } from "app-core";
import { Fragment as Fragment70, jsx as jsx276 } from "react/jsx-runtime";
var candidateTasksQueryDef = CandidateApplicationTasksQuery_graphql_default;
var queryDef45 = CandidateApplicationTasksRouteQuery_graphql_default;
async function loader22(environment, params) {
  const code = params.applicationCode;
  const applicationCode = parseInt(code);
  return loadQuery27(environment, queryDef45, {
    applicationCode
  });
}
var CandidateApplicationTasks = ({
  routeId: routeId4
}) => {
  const data = useRouteData15(
    queryDef45,
    routeId4
  );
  const { application: application3 } = data;
  if (!application3 || application3.applicationId == null) {
    return /* @__PURE__ */ jsx276(Fragment70, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx276(
    CandidateApplicationTasksComponent,
    {
      candidateId: application3.candidateId,
      applicationId: application3.applicationId
    }
  );
};
var CandidateApplicationTasksComponent = ({ candidateId, applicationId }) => {
  const tasks = useLazyLoadQuery39(
    candidateTasksQueryDef,
    {
      candidateId,
      applicationId
    }
  );
  if (!tasks) {
    return /* @__PURE__ */ jsx276(Fragment70, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx276(Suspense93, { fallback: /* @__PURE__ */ jsx276(EdSkeleton80, {}), children: /* @__PURE__ */ jsx276("div", { className: "flex flex-col gap-3 p-5 ", children: tasks.tasks?.nodes?.map((task) => {
    return /* @__PURE__ */ jsx276(TaskItem, { fragmentRef: task }, task.id);
  }) }) });
};
var createRoute17 = (routePrefix, environment, context) => {
  const routeId4 = `${routePrefix}-application-search-tasks`;
  return {
    id: routeId4,
    path: "tasks",
    element: /* @__PURE__ */ jsx276(CandidateApplicationTasks, { routeId: routeId4 }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx276(Link19, { to: "tasks", children: "Tasks" })
    },
    loader: ({ params }) => {
      return loader22(environment, params);
    }
  };
};

// src/candidates/components/__generated__/CandidateApplicationDocumentsRouteQuery.graphql.ts
var node309 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "applicationCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "applicationCode",
      "variableName": "applicationCode"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "applicationId",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "vacancyName",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "applicationDocumentId",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasCompletedDocumentTypes",
    "storageKey": null
  }, v10 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateApplicationDocumentsRouteQuery",
      "selections": [
        {
          "alias": "application",
          "args": v1,
          "concreteType": "Application",
          "kind": "LinkedField",
          "name": "applicationByCode",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            v5,
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "candidate",
              "plural": false,
              "selections": [
                v6,
                v7
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ApplicationDocument",
              "kind": "LinkedField",
              "name": "documents",
              "plural": true,
              "selections": [
                v23,
                v8,
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "CandidateApplicationDocumentRow_document"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "CandidateApplicationDocumentDetail_document"
                }
              ],
              "storageKey": null
            },
            v9,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "CandidateApplicationDocuments_application"
            },
            v10
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateApplicationDocumentsRouteQuery",
      "selections": [
        {
          "alias": "application",
          "args": v1,
          "concreteType": "Application",
          "kind": "LinkedField",
          "name": "applicationByCode",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            v5,
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "candidate",
              "plural": false,
              "selections": [
                v6,
                v7,
                v23
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ApplicationDocument",
              "kind": "LinkedField",
              "name": "documents",
              "plural": true,
              "selections": [
                v23,
                v8,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "createdAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "updatedAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "documentReferenceId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "documentReferenceFileName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "documentTypeId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "documentTypeName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isRequired",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isSubmitted",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isUploaded",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "status",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "requiresExpiryDate",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "requiresIssueDate",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "requiresIssueNumber",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "documentExpiryDate",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "documentIssueDate",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "documentIssueNumber",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            },
            v9,
            v10
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "51badf10f95ae26db7181c65d8761c09",
      "id": null,
      "metadata": {},
      "name": "CandidateApplicationDocumentsRouteQuery",
      "operationKind": "query",
      "text": "query CandidateApplicationDocumentsRouteQuery(\n  $applicationCode: Int!\n) {\n  application: applicationByCode(applicationCode: $applicationCode) {\n    id\n    code\n    applicationId\n    vacancyName\n    candidate {\n      firstName\n      lastName\n      id\n    }\n    documents {\n      id\n      applicationDocumentId\n      ...CandidateApplicationDocumentRow_document\n      ...CandidateApplicationDocumentDetail_document\n    }\n    hasCompletedDocumentTypes\n    ...CandidateApplicationDocuments_application\n  }\n}\n\nfragment CandidateApplicationDocumentDetail_document on ApplicationDocument {\n  id\n  applicationDocumentId\n  applicationId\n  createdAt\n  updatedAt\n  documentReferenceId\n  documentReferenceFileName\n  documentTypeId\n  documentTypeName\n  isRequired\n  isSubmitted\n  isUploaded\n  status\n  requiresExpiryDate\n  requiresIssueDate\n  requiresIssueNumber\n  documentExpiryDate\n  documentIssueDate\n  documentIssueNumber\n}\n\nfragment CandidateApplicationDocumentRow_document on ApplicationDocument {\n  id\n  applicationDocumentId\n  createdAt\n  updatedAt\n  documentReferenceId\n  documentReferenceFileName\n  documentTypeId\n  documentTypeName\n  isRequired\n  isSubmitted\n  isUploaded\n  status\n  requiresExpiryDate\n  requiresIssueDate\n  requiresIssueNumber\n  documentExpiryDate\n  documentIssueDate\n  documentIssueNumber\n}\n\nfragment CandidateApplicationDocuments_application on Application {\n  documents {\n    id\n    applicationDocumentId\n    createdAt\n    updatedAt\n    documentReferenceId\n    documentReferenceFileName\n    documentTypeId\n    documentTypeName\n    isRequired\n    isSubmitted\n    isUploaded\n    status\n    requiresExpiryDate\n    requiresIssueDate\n    requiresIssueNumber\n    documentExpiryDate\n    documentIssueDate\n    documentIssueNumber\n    ...CandidateApplicationDocumentRow_document\n    ...CandidateApplicationDocumentDetail_document\n  }\n}\n"
    }
  };
}();
node309.hash = "b1b2de78541b6a1fd80af647acb495a3";
var CandidateApplicationDocumentsRouteQuery_graphql_default = node309;

// src/candidates/components/__generated__/CandidateApplicationDocuments_application.graphql.ts
var node311 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CandidateApplicationDocuments_application",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ApplicationDocument",
      "kind": "LinkedField",
      "name": "documents",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "applicationDocumentId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "documentReferenceId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "documentReferenceFileName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "documentTypeId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "documentTypeName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isRequired",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isSubmitted",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isUploaded",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "requiresExpiryDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "requiresIssueDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "requiresIssueNumber",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "documentExpiryDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "documentIssueDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "documentIssueNumber",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CandidateApplicationDocumentRow_document"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CandidateApplicationDocumentDetail_document"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Application",
  "abstractKey": null
};
node311.hash = "c5b129766a4bc0bcc4be144a933d02b6";
var CandidateApplicationDocuments_application_graphql_default = node311;

// src/candidates/components/CandidateApplicationDocuments.tsx
import { Suspense as Suspense94, useCallback as useCallback150, useState as useState81 } from "react";
import { loadQuery as loadQuery28, useFragment as useFragment81 } from "react-relay";
import { Link as Link20 } from "react-router-dom";
import { formatDate as formatDate6, useRouteData as useRouteData16 } from "shared-lib";
import { EdSkeleton as EdSkeleton81, Table as Table4 } from "shared-ui";

// src/candidates/components/__generated__/CandidateApplicationDocumentDetail_document.graphql.ts
var node313 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CandidateApplicationDocumentDetail_document",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "applicationDocumentId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "applicationId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "documentReferenceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "documentReferenceFileName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "documentTypeId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "documentTypeName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isRequired",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSubmitted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isUploaded",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "requiresExpiryDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "requiresIssueDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "requiresIssueNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "documentExpiryDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "documentIssueDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "documentIssueNumber",
      "storageKey": null
    }
  ],
  "type": "ApplicationDocument",
  "abstractKey": null
};
node313.hash = "89a9709eaab742b29308cfbf51cb9bc8";
var CandidateApplicationDocumentDetail_document_graphql_default = node313;

// src/candidates/components/CandidateApplicationDocumentDetail.tsx
import { useCallback as useCallback149 } from "react";
import { useFragment as useFragment80 } from "react-relay/hooks";
import { createClientMutationId as createClientMutationId68, useToggle as useToggle29 } from "shared-lib";
import {
  Button as Button73,
  ButtonList as ButtonList25,
  DescriptionItem as DescriptionItem2,
  DescriptionList as DescriptionList2,
  Size as Size36
} from "shared-ui";

// src/candidates/components/__generated__/CandidateApplicationDocumentDownloadLinkQuery.graphql.ts
var node314 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "documentReferenceId"
    }
  ], v1 = [
    {
      "alias": "link",
      "args": [
        {
          "kind": "Variable",
          "name": "documentReferenceId",
          "variableName": "documentReferenceId"
        }
      ],
      "concreteType": "DocumentReferenceDownloadLink",
      "kind": "LinkedField",
      "name": "applicationDocumentsGetDownloadLink",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateApplicationDocumentDownloadLinkQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateApplicationDocumentDownloadLinkQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "9cc3a67084e8ec21157947f6d7dfe23c",
      "id": null,
      "metadata": {},
      "name": "CandidateApplicationDocumentDownloadLinkQuery",
      "operationKind": "query",
      "text": "query CandidateApplicationDocumentDownloadLinkQuery(\n  $documentReferenceId: UUID!\n) {\n  link: applicationDocumentsGetDownloadLink(documentReferenceId: $documentReferenceId) {\n    url\n  }\n}\n"
    }
  };
}();
node314.hash = "de30b54a2998f54489d382cc0c60d3aa";
var CandidateApplicationDocumentDownloadLinkQuery_graphql_default = node314;

// src/candidates/components/CandidateApplicationDocumentDownloadLink.tsx
import { useLazyLoadQuery as useLazyLoadQuery40 } from "react-relay";
import { jsx as jsx277, jsxs as jsxs181 } from "react/jsx-runtime";
var queryDef46 = CandidateApplicationDocumentDownloadLinkQuery_graphql_default;
var CandidateApplicationDocumentDownloadLink = ({
  documentReferenceId
}) => {
  const query3 = useLazyLoadQuery40(
    queryDef46,
    { documentReferenceId },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { link } = query3;
  if (!link) {
    return /* @__PURE__ */ jsx277("div", { children: "Link unavailable" });
  }
  return /* @__PURE__ */ jsxs181(
    "a",
    {
      href: link.url,
      target: documentReferenceId,
      className: "text-primary-600 hover:text-primary-500 font-semibold",
      children: [
        "Download ",
        /* @__PURE__ */ jsx277("span", { "aria-hidden": "true", children: " \u2192" })
      ]
    }
  );
};

// src/candidates/components/BooleanItem.tsx
import { classNames as classNames34 } from "shared-ui";
import { jsx as jsx278 } from "react/jsx-runtime";
var BooleanItem = ({ value }) => {
  return /* @__PURE__ */ jsx278(
    "div",
    {
      className: classNames34(
        "text-lg font-medium",
        value ? "text-success-500" : "text-danger-500"
      ),
      children: value ? "Yes" : "No"
    }
  );
};

// src/candidates/components/CandidateApplicationDocumentDetail.tsx
import { Fragment as Fragment71, jsx as jsx279, jsxs as jsxs183 } from "react/jsx-runtime";
var fragmentDef64 = CandidateApplicationDocumentDetail_document_graphql_default;
var CandidateApplicationDocumentDetail = ({
  fragmentRef
}) => {
  const data = useFragment80(fragmentDef64, fragmentRef);
  const [downloadOpen, toggleDownloadOpen] = useToggle29();
  const onCloseDownload = useCallback149(() => {
    toggleDownloadOpen();
  }, []);
  const [reject, isRejecting] = useRejectDocument();
  const onReject = useCallback149(async () => {
    if (isRejecting) {
      return;
    }
    const input = {
      clientMutationId: createClientMutationId68(),
      applicationId: data.applicationId,
      documentReferenceId: data.applicationDocumentId
    };
    await reject({ input });
  }, [reject]);
  return /* @__PURE__ */ jsxs183("div", { className: "border bg-white shadow sm:w-1/2 sm:rounded-lg", children: [
    /* @__PURE__ */ jsxs183("div", { className: "flex items-end justify-between gap-2 px-4 py-6 sm:px-6", children: [
      /* @__PURE__ */ jsxs183("div", { className: "flex items-end gap-4", children: [
        /* @__PURE__ */ jsx279("h3", { className: "text-base font-semibold leading-7 text-gray-900", children: data.documentTypeName }),
        /* @__PURE__ */ jsx279("p", { className: "max-w-2xl text-sm leading-6 text-gray-500", children: data.status })
      ] }),
      /* @__PURE__ */ jsx279("div", { children: data.isUploaded && /* @__PURE__ */ jsx279(Button73, { color: "primary", clicked: toggleDownloadOpen, children: "Request Download Link" }) })
    ] }),
    downloadOpen && /* @__PURE__ */ jsx279("div", { className: "border-y bg-gray-100 px-4 py-4 sm:px-6", children: /* @__PURE__ */ jsx279(
      CandidateApplicationDocumentDownloadLink,
      {
        documentReferenceId: data.documentReferenceId,
        onClose: onCloseDownload
      }
    ) }),
    /* @__PURE__ */ jsx279(
      DescriptionList2,
      {
        heading: /* @__PURE__ */ jsx279("div", { className: "flex space-x-2", children: /* @__PURE__ */ jsx279("span", { className: "text-info-600", children: "Document Details" }) }),
        items: /* @__PURE__ */ jsxs183(Fragment71, { children: [
          /* @__PURE__ */ jsx279(DescriptionItem2, { label: "Expiry Date", children: data.documentExpiryDate }),
          /* @__PURE__ */ jsx279(DescriptionItem2, { label: "Issue Date", children: data.documentIssueDate }),
          /* @__PURE__ */ jsx279(DescriptionItem2, { label: "Issue Number", children: data.documentIssueNumber }),
          /* @__PURE__ */ jsx279(DescriptionItem2, { label: "File Name", children: data.documentReferenceFileName }),
          /* @__PURE__ */ jsx279(DescriptionItem2, { label: "Required", children: /* @__PURE__ */ jsx279(BooleanItem, { value: data.isRequired }) }),
          /* @__PURE__ */ jsx279(DescriptionItem2, { label: "Uploaded", children: /* @__PURE__ */ jsx279(BooleanItem, { value: data.isUploaded }) }),
          /* @__PURE__ */ jsx279(DescriptionItem2, { label: "Submitted", children: /* @__PURE__ */ jsx279(BooleanItem, { value: data.isSubmitted }) })
        ] })
      }
    ),
    data.isSubmitted && /* @__PURE__ */ jsx279("div", { className: "p-4", children: /* @__PURE__ */ jsx279(ButtonList25, { children: /* @__PURE__ */ jsx279("div", { children: /* @__PURE__ */ jsx279(
      Button73,
      {
        disabled: isRejecting,
        color: "warning",
        size: Size36.lg,
        clicked: onReject,
        children: "Reject"
      }
    ) }) }) })
  ] });
};

// src/candidates/components/CandidateApplicationDocuments.tsx
import { Fragment as Fragment73, jsx as jsx280, jsxs as jsxs184 } from "react/jsx-runtime";
var candidateApplicationDocumentDefaultColumns = [
  { id: "status", name: "Status" },
  { id: "documentTypeName", name: "Document Type" },
  { id: "createdOn", name: "Created On" },
  { id: "isRequired", name: "Required" },
  { id: "isSubmitted", name: "Submitted" },
  { id: "isUploaded", name: "Uploaded" }
];
var queryDef47 = CandidateApplicationDocumentsRouteQuery_graphql_default;
async function loader23(environment, params) {
  const code = params.applicationCode;
  const applicationCode = parseInt(code);
  return loadQuery28(
    environment,
    queryDef47,
    {
      applicationCode
    }
  );
}
var CandidateApplicationDocuments = ({
  routeId: routeId4
}) => {
  const data = useRouteData16(
    queryDef47,
    routeId4
  );
  if (!data.application) {
    return /* @__PURE__ */ jsx280(Fragment73, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx280(CandidateApplicationDocumentsComponent, { fragmentRef: data.application });
};
function CandidateApplicationDocumentsComponent({
  fragmentRef
}) {
  const application3 = useFragment81(
    CandidateApplicationDocumentsComponent.fragments.application,
    fragmentRef
  );
  const [selectedId, setSelectedId] = useState81(null);
  const onSelect = useCallback150(
    (id18) => {
      setSelectedId(id18);
    },
    [setSelectedId]
  );
  const onClear = useCallback150(() => {
    setSelectedId(null);
  }, [setSelectedId]);
  const selected = selectedId ? application3.documents.find((d4) => d4.applicationDocumentId === selectedId) : null;
  return /* @__PURE__ */ jsxs184(Suspense94, { fallback: /* @__PURE__ */ jsx280(EdSkeleton81, {}), children: [
    /* @__PURE__ */ jsx280("div", { className: "@container bg-white p-4", children: /* @__PURE__ */ jsx280(
      Table4,
      {
        header: candidateApplicationDocumentDefaultColumns.map((x4) => x4.name),
        emptyMessage: "No documents found",
        items: application3.documents.map((x4) => [
          {
            recordId: x4.applicationDocumentId,
            key: "status",
            value: x4.status
          },
          {
            recordId: x4.applicationDocumentId,
            key: "documentTypeName",
            value: x4.documentTypeName
          },
          {
            recordId: x4.applicationDocumentId,
            key: "createdOn",
            value: x4.createdAt
          },
          {
            recordId: x4.applicationDocumentId,
            key: "isRequired",
            value: x4.isRequired
          },
          {
            recordId: x4.applicationDocumentId,
            key: "isSubmitted",
            value: x4.isSubmitted
          },
          {
            recordId: x4.applicationDocumentId,
            key: "isUploaded",
            value: x4.isUploaded
          }
        ]),
        children: ({ key, value, recordId, label }) => /* @__PURE__ */ jsxs184(Fragment73, { children: [
          /* @__PURE__ */ jsxs184(
            "div",
            {
              onClick: () => onSelect(recordId),
              className: "@4xl:block hidden",
              children: [
                key != "createdOn" && /* @__PURE__ */ jsx280("div", { children: String(value) }),
                key == "createdOn" && /* @__PURE__ */ jsx280("div", { children: formatDate6(new Date(value)) })
              ]
            },
            key + value + "lg"
          ),
          /* @__PURE__ */ jsxs184(
            "div",
            {
              onClick: () => onSelect(recordId),
              className: "@4xl:hidden grid grid-cols-2",
              children: [
                /* @__PURE__ */ jsx280("div", { className: "font-bold", children: label }),
                key != "createdOn" && /* @__PURE__ */ jsx280("div", { children: String(value) }),
                key == "createdOn" && /* @__PURE__ */ jsx280("div", { children: formatDate6(new Date(value)) })
              ]
            },
            key + value + "sm"
          )
        ] })
      }
    ) }),
    selected && /* @__PURE__ */ jsx280("div", { className: "bg-white p-4", children: /* @__PURE__ */ jsx280(
      CandidateApplicationDocumentDetail,
      {
        fragmentRef: selected,
        onClose: onClear
      }
    ) })
  ] });
}
CandidateApplicationDocumentsComponent.fragments = {
  application: CandidateApplicationDocuments_application_graphql_default
};
var createRoute18 = (routePrefix, environment, context) => {
  const routeId4 = `${routePrefix}-application-search-documents`;
  return {
    id: routeId4,
    path: "documents",
    element: /* @__PURE__ */ jsx280(CandidateApplicationDocuments, { routeId: routeId4 }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx280(Link20, { to: "documents", children: "Documents" })
    },
    loader: ({ params }) => {
      return loader23(environment, params);
    }
  };
};

// src/candidates/components/__generated__/CandidateApplicationFormsRouteQuery.graphql.ts
var node315 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "applicationCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "applicationCode",
      "variableName": "applicationCode"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "applicationId",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "vacancyName",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "applicationFormId",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasCompletedForms",
    "storageKey": null
  }, v10 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateApplicationFormsRouteQuery",
      "selections": [
        {
          "alias": "application",
          "args": v1,
          "concreteType": "Application",
          "kind": "LinkedField",
          "name": "applicationByCode",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            v5,
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "candidate",
              "plural": false,
              "selections": [
                v6,
                v7
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ApplicationForm",
              "kind": "LinkedField",
              "name": "forms",
              "plural": true,
              "selections": [
                v23,
                v8,
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "CandidateApplicationFormRow_form"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "CandidateApplicationFormDetail_form"
                }
              ],
              "storageKey": null
            },
            v9,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "CandidateApplicationForms_application"
            },
            v10
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateApplicationFormsRouteQuery",
      "selections": [
        {
          "alias": "application",
          "args": v1,
          "concreteType": "Application",
          "kind": "LinkedField",
          "name": "applicationByCode",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            v5,
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "candidate",
              "plural": false,
              "selections": [
                v6,
                v7,
                v23
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ApplicationForm",
              "kind": "LinkedField",
              "name": "forms",
              "plural": true,
              "selections": [
                v23,
                v8,
                v32,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "createdAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "updatedAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isEdited",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isCompleted",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isRequired",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isSubmitted",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "formTemplateName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FormField",
                  "kind": "LinkedField",
                  "name": "fields",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "key",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "value",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "skipped",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "type",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                v4,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "formTemplateId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v9,
            v10
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "e71b68285da964449e5b4cac155aa43a",
      "id": null,
      "metadata": {},
      "name": "CandidateApplicationFormsRouteQuery",
      "operationKind": "query",
      "text": "query CandidateApplicationFormsRouteQuery(\n  $applicationCode: Int!\n) {\n  application: applicationByCode(applicationCode: $applicationCode) {\n    id\n    code\n    applicationId\n    vacancyName\n    candidate {\n      firstName\n      lastName\n      id\n    }\n    forms {\n      id\n      applicationFormId\n      ...CandidateApplicationFormRow_form\n      ...CandidateApplicationFormDetail_form\n    }\n    hasCompletedForms\n    ...CandidateApplicationForms_application\n  }\n}\n\nfragment CandidateApplicationFormDetail_form on ApplicationForm {\n  id\n  applicationFormId\n  code\n  applicationId\n  createdAt\n  updatedAt\n  isEdited\n  isCompleted\n  isRequired\n  isSubmitted\n  formTemplateId\n  formTemplateName\n  fields {\n    key\n    value\n    skipped\n    type\n  }\n}\n\nfragment CandidateApplicationFormRow_form on ApplicationForm {\n  id\n  applicationFormId\n  code\n  createdAt\n  updatedAt\n  isEdited\n  isCompleted\n  isRequired\n  isSubmitted\n  formTemplateName\n  fields {\n    key\n    value\n    skipped\n    type\n  }\n}\n\nfragment CandidateApplicationForms_application on Application {\n  id\n  code\n  applicationId\n  vacancyName\n  candidate {\n    firstName\n    lastName\n    id\n  }\n  forms {\n    id\n    applicationFormId\n    code\n    createdAt\n    updatedAt\n    isEdited\n    isCompleted\n    isRequired\n    isSubmitted\n    formTemplateName\n    fields {\n      key\n      value\n      skipped\n      type\n    }\n    ...CandidateApplicationFormRow_form\n    ...CandidateApplicationFormDetail_form\n  }\n  hasCompletedForms\n}\n"
    }
  };
}();
node315.hash = "e057f0525ced9933de8293786eba98c2";
var CandidateApplicationFormsRouteQuery_graphql_default = node315;

// src/candidates/components/__generated__/CandidateApplicationForms_application.graphql.ts
var node316 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CandidateApplicationForms_application",
    "selections": [
      v0,
      v1,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "applicationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "vacancyName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsCandidateAccount",
        "kind": "LinkedField",
        "name": "candidate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ApplicationForm",
        "kind": "LinkedField",
        "name": "forms",
        "plural": true,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "applicationFormId",
            "storageKey": null
          },
          v1,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isEdited",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isCompleted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isRequired",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isSubmitted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "formTemplateName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FormField",
            "kind": "LinkedField",
            "name": "fields",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "skipped",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CandidateApplicationFormRow_form"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CandidateApplicationFormDetail_form"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasCompletedForms",
        "storageKey": null
      },
      {
        "kind": "ClientExtension",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__id",
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Application",
    "abstractKey": null
  };
}();
node316.hash = "e67681238ac276aaad498af6ece18650";
var CandidateApplicationForms_application_graphql_default = node316;

// src/candidates/components/CandidateApplicationForms.tsx
import { Suspense as Suspense95, useCallback as useCallback154, useState as useState83 } from "react";
import { loadQuery as loadQuery29, useFragment as useFragment85 } from "react-relay";
import { Link as Link21 } from "react-router-dom";
import { formatDate as formatDate7, useRouteData as useRouteData17 } from "shared-lib";
import { EdSkeleton as EdSkeleton83, Table as Table5 } from "shared-ui";

// src/candidates/components/CandidateApplicationFormRow.tsx
import { useCallback as useCallback151 } from "react";
import { useFragment as useFragment83 } from "react-relay/hooks";
import { formatDateTime as formatDateTime2 } from "shared-lib";
import {
  EdActionCell as EdActionCell2,
  EdColumnCell as EdColumnCell5,
  EdRow as EdRow5,
  LinkButton as LinkButton5
} from "shared-ui";
import { jsx as jsx281, jsxs as jsxs185 } from "react/jsx-runtime";
var candidateApplicationFormDefaultColumns = [
  { id: "name", name: "Name" },
  { id: "createdOn", name: "Created On" },
  { id: "updatedOn", name: "Updated On" },
  { id: "isRequired", name: "Required" },
  { id: "isEdited", name: "Edited" },
  { id: "isCompleted", name: "Completed" },
  { id: "isSubmitted", name: "Submitted" }
];

// src/candidates/components/__generated__/CandidateApplicationFormDetail_form.graphql.ts
var node317 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CandidateApplicationFormDetail_form",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "applicationFormId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "applicationId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isEdited",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isCompleted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isRequired",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSubmitted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "formTemplateId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "formTemplateName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FormField",
      "kind": "LinkedField",
      "name": "fields",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "skipped",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ApplicationForm",
  "abstractKey": null
};
node317.hash = "d9a0fc30f68b4641109225b22d987e52";
var CandidateApplicationFormDetail_form_graphql_default = node317;

// src/candidates/components/CandidateApplicationFormDetail.tsx
import { useCallback as useCallback153 } from "react";
import { useFragment as useFragment84 } from "react-relay/hooks";
import { createClientMutationId as createClientMutationId69 } from "shared-lib";
import {
  Button as Button74,
  ButtonList as ButtonList26,
  DescriptionItem as DescriptionItem3,
  DescriptionList as DescriptionList3,
  Size as Size37
} from "shared-ui";
import { Fragment as Fragment74, jsx as jsx283, jsxs as jsxs186 } from "react/jsx-runtime";
var fragmentDef65 = CandidateApplicationFormDetail_form_graphql_default;
var CandidateApplicationFormDetail = ({ fragmentRef }) => {
  const data = useFragment84(fragmentDef65, fragmentRef);
  const [reject, isRejecting] = useRejectForm();
  const onReject = useCallback153(async () => {
    if (isRejecting) {
      return;
    }
    const input = {
      clientMutationId: createClientMutationId69(),
      applicationId: data.applicationId,
      formTemplateId: data.formTemplateId
    };
    await reject({ input });
  }, [reject]);
  const rows = data.fields.map((f4) => {
    return /* @__PURE__ */ jsxs186("tr", { children: [
      /* @__PURE__ */ jsx283("td", { className: "whitespace-nowrap px-3 py-4 text-sm text-gray-500", children: f4.key }),
      /* @__PURE__ */ jsx283("td", { className: "whitespace-nowrap px-3 py-4 text-sm text-gray-500", children: f4.value })
    ] }, f4.key);
  });
  return /* @__PURE__ */ jsxs186("div", { className: "border bg-white shadow sm:w-1/2 sm:rounded-lg", children: [
    /* @__PURE__ */ jsx283("div", { className: "px-4 py-6 sm:px-6", children: /* @__PURE__ */ jsx283("h3", { className: "text-base font-semibold leading-7 text-gray-900", children: data.formTemplateName }) }),
    /* @__PURE__ */ jsx283(
      DescriptionList3,
      {
        heading: /* @__PURE__ */ jsx283("div", { className: "flex space-x-2", children: /* @__PURE__ */ jsx283("span", { className: "text-info-600", children: "Form Details" }) }),
        items: /* @__PURE__ */ jsxs186(Fragment74, { children: [
          /* @__PURE__ */ jsx283(DescriptionItem3, { label: "Required", children: /* @__PURE__ */ jsx283(BooleanItem, { value: data.isRequired }) }),
          /* @__PURE__ */ jsx283(DescriptionItem3, { label: "Edited", children: /* @__PURE__ */ jsx283(BooleanItem, { value: data.isEdited }) }),
          /* @__PURE__ */ jsx283(DescriptionItem3, { label: "Completed", children: /* @__PURE__ */ jsx283(BooleanItem, { value: data.isCompleted }) }),
          /* @__PURE__ */ jsx283(DescriptionItem3, { label: "Submitted", children: /* @__PURE__ */ jsx283(BooleanItem, { value: data.isSubmitted }) }),
          /* @__PURE__ */ jsx283("div", { className: "px-4 py-6 sm:px-6", children: /* @__PURE__ */ jsxs186("table", { className: "min-w-full divide-y divide-gray-300", children: [
            /* @__PURE__ */ jsx283("thead", { children: /* @__PURE__ */ jsxs186("tr", { children: [
              /* @__PURE__ */ jsx283(
                "th",
                {
                  scope: "col",
                  className: "py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0",
                  children: "Field"
                }
              ),
              /* @__PURE__ */ jsx283(
                "th",
                {
                  scope: "col",
                  className: "px-3 py-3.5 text-left text-sm font-semibold text-gray-900",
                  children: "Value"
                }
              )
            ] }) }),
            /* @__PURE__ */ jsx283("tbody", { className: "divide-y divide-gray-200", children: rows })
          ] }) })
        ] })
      }
    ),
    data.isSubmitted && /* @__PURE__ */ jsx283("div", { className: "p-4", children: /* @__PURE__ */ jsx283(ButtonList26, { children: /* @__PURE__ */ jsx283("div", { children: /* @__PURE__ */ jsx283(
      Button74,
      {
        disabled: isRejecting,
        color: "warning",
        size: Size37.lg,
        clicked: onReject,
        children: "Reject"
      }
    ) }) }) })
  ] });
};

// src/candidates/components/CandidateApplicationForms.tsx
import { Fragment as Fragment75, jsx as jsx284, jsxs as jsxs187 } from "react/jsx-runtime";
var queryDef48 = CandidateApplicationFormsRouteQuery_graphql_default;
async function loader24(environment, params) {
  const code = params.applicationCode;
  const applicationCode = parseInt(code);
  return loadQuery29(environment, queryDef48, {
    applicationCode
  });
}
var CandidateApplicationForms = ({
  routeId: routeId4
}) => {
  const data = useRouteData17(
    queryDef48,
    routeId4
  );
  const { application: application3 } = data;
  if (!application3) {
    return /* @__PURE__ */ jsx284(Fragment75, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx284(CandidateApplicationFormsComponent, { fragmentRef: application3 });
};
function CandidateApplicationFormsComponent({
  fragmentRef
}) {
  const application3 = useFragment85(
    CandidateApplicationFormsComponent.fragments.application,
    fragmentRef
  );
  const [selectedId, setSelectedId] = useState83(null);
  const onSelect = useCallback154(
    (id18) => {
      setSelectedId(id18);
    },
    [setSelectedId]
  );
  const onClear = useCallback154(() => {
    setSelectedId(null);
  }, [setSelectedId]);
  const selected = selectedId ? application3.forms.find((d4) => d4.applicationFormId === selectedId) : null;
  return /* @__PURE__ */ jsxs187(Suspense95, { fallback: /* @__PURE__ */ jsx284(EdSkeleton83, {}), children: [
    /* @__PURE__ */ jsx284("div", { className: "@container bg-white p-4", children: /* @__PURE__ */ jsx284(
      Table5,
      {
        emptyMessage: "No forms found",
        header: candidateApplicationFormDefaultColumns.map((x4) => x4.name),
        items: application3.forms.map((x4) => [
          {
            recordId: x4.applicationFormId,
            key: "name",
            value: x4.formTemplateName
          },
          {
            recordId: x4.applicationFormId,
            key: "createdOn",
            value: new Date(x4.createdAt)
          },
          {
            recordId: x4.applicationFormId,
            key: "updatedOn",
            value: new Date(x4.updatedAt)
          },
          {
            recordId: x4.applicationFormId,
            key: "required",
            value: !!x4.isRequired
          },
          {
            recordId: x4.applicationFormId,
            key: "edited",
            value: !!x4.isEdited
          },
          {
            recordId: x4.applicationFormId,
            key: "completed",
            value: !!x4.isCompleted
          },
          {
            recordId: x4.applicationFormId,
            key: "submitted",
            value: !!x4.isSubmitted
          }
        ]),
        children: ({ recordId, label, key, value }) => {
          const formattedValue = value instanceof Date ? formatDate7(value) : String(value);
          return /* @__PURE__ */ jsxs187(Fragment75, { children: [
            /* @__PURE__ */ jsx284(
              "div",
              {
                onClick: () => onSelect(recordId),
                className: "@lg:block hidden",
                children: formattedValue
              },
              key + value + "lg"
            ),
            /* @__PURE__ */ jsxs187(
              "div",
              {
                onClick: () => onSelect(recordId),
                className: "@lg:hidden grid grid-cols-2",
                children: [
                  /* @__PURE__ */ jsx284("div", { className: "font-bold", children: label }),
                  /* @__PURE__ */ jsx284("div", { children: formattedValue })
                ]
              },
              key + value + "sm"
            )
          ] });
        }
      }
    ) }),
    selected && /* @__PURE__ */ jsx284("div", { className: "bg-white p-4", children: /* @__PURE__ */ jsx284(
      CandidateApplicationFormDetail,
      {
        fragmentRef: selected,
        onClose: onClear
      }
    ) })
  ] });
}
CandidateApplicationFormsComponent.fragments = {
  application: CandidateApplicationForms_application_graphql_default
};
var createRoute19 = (routePrefix, environment, context) => {
  const routeId4 = `${routePrefix}-application-search-forms`;
  return {
    id: routeId4,
    path: "forms",
    element: /* @__PURE__ */ jsx284(CandidateApplicationForms, { routeId: routeId4 }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx284(Link21, { to: "forms", children: "Forms" })
    },
    loader: ({ params }) => {
      return loader24(environment, params);
    }
  };
};

// src/offers/components/__generated__/OfferListQuery.graphql.ts
var node318 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "offerId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "OfferListQuery",
      "selections": [
        {
          "alias": "offers",
          "args": v1,
          "concreteType": "RecruitOffersConnection",
          "kind": "LinkedField",
          "name": "recruitOffers",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitOffer",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                v23,
                v32,
                v4,
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "OfferDashboard_offer"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "OfferListQuery",
      "selections": [
        {
          "alias": "offers",
          "args": v1,
          "concreteType": "RecruitOffersConnection",
          "kind": "LinkedField",
          "name": "recruitOffers",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitOffer",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                v23,
                v32,
                v4,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "applicationId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "status",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "countryName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "currencyCode",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "payType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "rateAmount",
                  "storageKey": null
                },
                {
                  "kind": "ClientExtension",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__id",
                      "storageKey": null
                    }
                  ]
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsCandidateAccount",
                  "kind": "LinkedField",
                  "name": "candidate",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "firstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "email",
                      "storageKey": null
                    },
                    v23
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Vacancy",
                  "kind": "LinkedField",
                  "name": "vacancy",
                  "plural": false,
                  "selections": [
                    v23,
                    v4,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "50dda0d812ab5da62d860c33d4f2ed64",
      "id": null,
      "metadata": {},
      "name": "OfferListQuery",
      "operationKind": "query",
      "text": "query OfferListQuery(\n  $where: RecruitOfferFilter\n) {\n  offers: recruitOffers(where: $where) {\n    nodes {\n      id\n      offerId\n      code\n      ...OfferDashboard_offer\n    }\n  }\n}\n\nfragment OfferDashboard_offer on RecruitOffer {\n  ...OfferWithdrawForm_offer\n  id\n  code\n  offerId\n  status\n  countryName\n  currencyCode\n  payType\n  rateAmount\n  candidate {\n    firstName\n    lastName\n    email\n    id\n  }\n  vacancy {\n    id\n    code\n    name\n  }\n}\n\nfragment OfferWithdrawForm_offer on RecruitOffer {\n  id\n  code\n  offerId\n  applicationId\n  status\n  countryName\n  currencyCode\n  payType\n  rateAmount\n}\n"
    }
  };
}();
node318.hash = "2d391165867973f5630155f73686fa42";
var OfferListQuery_graphql_default = node318;

// src/offers/components/OfferList.tsx
import { useLazyLoadQuery as useLazyLoadQuery41 } from "react-relay";

// src/offers/components/__generated__/OfferDashboardRouteQuery.graphql.ts
var node319 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "offerCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "offerCode"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "offerId",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "countryName",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currencyCode",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "payType",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "rateAmount",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "email",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "concreteType": "Vacancy",
    "kind": "LinkedField",
    "name": "vacancy",
    "plural": false,
    "selections": [
      v23,
      v32,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v14 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "OfferDashboardRouteQuery",
      "selections": [
        {
          "alias": "offer",
          "args": v1,
          "concreteType": "RecruitOffer",
          "kind": "LinkedField",
          "name": "recruitOfferByCode",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "candidate",
              "plural": false,
              "selections": [
                v10,
                v11,
                v12
              ],
              "storageKey": null
            },
            v13,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "OfferWithdrawForm_offer"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "OfferDashboard_offer"
            },
            v14
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "OfferDashboardRouteQuery",
      "selections": [
        {
          "alias": "offer",
          "args": v1,
          "concreteType": "RecruitOffer",
          "kind": "LinkedField",
          "name": "recruitOfferByCode",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "candidate",
              "plural": false,
              "selections": [
                v10,
                v11,
                v12,
                v23
              ],
              "storageKey": null
            },
            v13,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "applicationId",
              "storageKey": null
            },
            v14
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "d05f9e33da5022334c65070b9c2da051",
      "id": null,
      "metadata": {},
      "name": "OfferDashboardRouteQuery",
      "operationKind": "query",
      "text": "query OfferDashboardRouteQuery(\n  $offerCode: Long!\n) {\n  offer: recruitOfferByCode(code: $offerCode) {\n    id\n    code\n    offerId\n    status\n    countryName\n    currencyCode\n    payType\n    rateAmount\n    candidate {\n      firstName\n      lastName\n      email\n      id\n    }\n    vacancy {\n      id\n      code\n      name\n    }\n    ...OfferWithdrawForm_offer\n    ...OfferDashboard_offer\n  }\n}\n\nfragment OfferDashboard_offer on RecruitOffer {\n  ...OfferWithdrawForm_offer\n  id\n  code\n  offerId\n  status\n  countryName\n  currencyCode\n  payType\n  rateAmount\n  candidate {\n    firstName\n    lastName\n    email\n    id\n  }\n  vacancy {\n    id\n    code\n    name\n  }\n}\n\nfragment OfferWithdrawForm_offer on RecruitOffer {\n  id\n  code\n  offerId\n  applicationId\n  status\n  countryName\n  currencyCode\n  payType\n  rateAmount\n}\n"
    }
  };
}();
node319.hash = "4b8a113dd256d31dd703a968f963ceca";
var OfferDashboardRouteQuery_graphql_default = node319;

// src/offers/components/__generated__/OfferDashboard_offer.graphql.ts
var node320 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "OfferDashboard_offer",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "OfferWithdrawForm_offer"
      },
      v0,
      v1,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "offerId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "countryName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currencyCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "payType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rateAmount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsCandidateAccount",
        "kind": "LinkedField",
        "name": "candidate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Vacancy",
        "kind": "LinkedField",
        "name": "vacancy",
        "plural": false,
        "selections": [
          v0,
          v1,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RecruitOffer",
    "abstractKey": null
  };
}();
node320.hash = "5b5c223193feb506139dcb6f4a1fd731";
var OfferDashboard_offer_graphql_default = node320;

// src/offers/components/OfferDashboard.tsx
import {
  loadQuery as loadQuery30,
  useFragment as useFragment87,
  usePreloadedQuery as usePreloadedQuery28
} from "react-relay";
import { useRouteLoaderData as useRouteLoaderData14 } from "react-router-dom";
import { useToggle as useToggle30 } from "shared-lib";
import {
  BreadcrumbLink as BreadcrumbLink7,
  Button as Button76,
  ButtonList as ButtonList28,
  DynamicBreadcrumb as DynamicBreadcrumb4,
  EdSkeleton as EdSkeleton84,
  Size as Size39
} from "shared-ui";

// src/offers/components/OfferStatusLabel.tsx
import { jsx as jsx285 } from "react/jsx-runtime";
var OfferStatusLabel = ({ status }) => {
  switch (status) {
    case "ACCEPTED": {
      return /* @__PURE__ */ jsx285("div", { className: "text-success-500 font-medium", children: "Accepted" });
    }
    case "DECLINED": {
      return /* @__PURE__ */ jsx285("div", { className: "text-danger-500 font-medium", children: "Declined" });
    }
    case "PENDING": {
      return /* @__PURE__ */ jsx285("div", { className: "text-warning-500 font-medium", children: "Pending" });
    }
    case "WITHDRAWN": {
      return /* @__PURE__ */ jsx285("div", { className: "font-medium text-gray-500", children: "Withdrawn" });
    }
  }
  return /* @__PURE__ */ jsx285("div", {});
};

// src/offers/components/OfferPayTypeLabel.tsx
import { jsx as jsx286 } from "react/jsx-runtime";
var OfferPayTypeLabel = ({ payType }) => {
  switch (payType) {
    case "PER_DAY": {
      return /* @__PURE__ */ jsx286("div", { className: "font-medium", children: "Per Day" });
    }
    case "PER_HOUR": {
      return /* @__PURE__ */ jsx286("div", { className: "font-medium", children: "Per Hour" });
    }
    case "PER_YEAR": {
      return /* @__PURE__ */ jsx286("div", { className: "font-medium", children: "per Year" });
    }
  }
  return /* @__PURE__ */ jsx286("div", {});
};

// src/offers/components/__generated__/OfferWithdrawForm_offer.graphql.ts
var node321 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OfferWithdrawForm_offer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "offerId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "applicationId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "countryName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currencyCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "payType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rateAmount",
      "storageKey": null
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__id",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "RecruitOffer",
  "abstractKey": null
};
node321.hash = "dd1a0929e09c87987d997d0b71a7dec4";
var OfferWithdrawForm_offer_graphql_default = node321;

// src/offers/components/OfferWithdrawForm.tsx
import { useCallback as useCallback155, useState as useState84 } from "react";
import { useFragment as useFragment86 } from "react-relay";
import { Button as Button75, ButtonList as ButtonList27, Size as Size38, TextArea as TextArea5 } from "shared-ui";
import { jsx as jsx287, jsxs as jsxs188 } from "react/jsx-runtime";
var fragmentDef66 = OfferWithdrawForm_offer_graphql_default;
var OfferWithdrawForm = ({
  fragmentRef,
  onDone,
  onCancel
}) => {
  const data = useFragment86(
    fragmentDef66,
    fragmentRef
  );
  const [note, setNote] = useState84("");
  const [withdraw, isWithUpdating] = useOfferWithdraw(
    data.applicationId,
    data.offerId
  );
  const onWithdraw = useCallback155(async () => {
    await withdraw({ note });
    onDone();
  }, [note, withdraw]);
  return /* @__PURE__ */ jsxs188("div", { className: "flex flex-1 flex-col", children: [
    /* @__PURE__ */ jsx287("div", { className: "p-4", children: /* @__PURE__ */ jsx287(
      TextArea5,
      {
        rows: 3,
        className: "focus:border-info-500 focus:ring-info-500 block w-full rounded-md border border-gray-300 shadow-sm sm:text-sm",
        placeholder: "Reason",
        onValueChange: (text) => setNote(text)
      }
    ) }),
    /* @__PURE__ */ jsxs188(ButtonList27, { children: [
      /* @__PURE__ */ jsx287("div", { children: /* @__PURE__ */ jsx287(Button75, { color: "danger", size: Size38.md, clicked: onWithdraw, children: "Withdraw" }) }),
      /* @__PURE__ */ jsx287("div", { children: /* @__PURE__ */ jsx287(Button75, { color: "gray", size: Size38.md, clicked: onCancel, children: "Cancel" }) })
    ] })
  ] });
};

// src/offers/components/OfferDashboard.tsx
import { jsx as jsx288, jsxs as jsxs189 } from "react/jsx-runtime";
var queryDef49 = OfferDashboardRouteQuery_graphql_default;
async function loader25(environment, params) {
  const code = params.offerCode;
  const offerCode = Number(code);
  return loadQuery30(environment, queryDef49, {
    offerCode
  });
}
var OfferDashboard = ({ showHeader, routeId: routeId4 }) => {
  const queryRef3 = useRouteLoaderData14(
    routeId4
  );
  const data = usePreloadedQuery28(queryDef49, queryRef3);
  const { offer } = data;
  if (offer === null || offer === void 0) {
    return /* @__PURE__ */ jsx288(EdSkeleton84, {});
  }
  return /* @__PURE__ */ jsx288(OfferDashboardComponent, { fragmentRef: offer, showHeader });
};
function OfferDashboardComponent({
  fragmentRef,
  showHeader = true
}) {
  const offer = useFragment87(
    OfferDashboardComponent.fragments.offer,
    fragmentRef
  );
  const [isWithdrawing, toggleIsWithdrawing] = useToggle30();
  if (offer === null || offer === void 0) {
    return /* @__PURE__ */ jsx288(EdSkeleton84, {});
  }
  const canWithdraw = offer.status === "PENDING";
  const name = `${offer.candidate.firstName} ${offer.candidate.lastName}`;
  let actions = /* @__PURE__ */ jsx288("div", {});
  if (canWithdraw) {
    actions = isWithdrawing ? /* @__PURE__ */ jsx288("div", { className: "p-4", children: /* @__PURE__ */ jsx288(
      OfferWithdrawForm,
      {
        fragmentRef: offer,
        onDone: toggleIsWithdrawing,
        onCancel: toggleIsWithdrawing
      }
    ) }) : /* @__PURE__ */ jsx288("div", { className: "p-4", children: /* @__PURE__ */ jsx288(ButtonList28, { children: /* @__PURE__ */ jsx288("div", { children: /* @__PURE__ */ jsx288(
      Button76,
      {
        color: "danger",
        size: Size39.md,
        clicked: toggleIsWithdrawing,
        children: "Withdraw"
      }
    ) }) }) });
  }
  return /* @__PURE__ */ jsxs189("div", { className: "flex flex-1 flex-col", children: [
    showHeader && /* @__PURE__ */ jsxs189("div", { className: "flex flex-wrap items-center justify-between border-b", children: [
      /* @__PURE__ */ jsx288(DynamicBreadcrumb4, {}),
      /* @__PURE__ */ jsx288("div", { className: "text-primary-500 px-2 font-medium uppercase sm:px-8", children: name }),
      /* @__PURE__ */ jsx288("div", { className: "flex flex-wrap items-center gap-2 px-4", children: offer.vacancy.name })
    ] }),
    /* @__PURE__ */ jsxs189("div", { className: "flex flex-col gap-3 border bg-white sm:m-8", children: [
      /* @__PURE__ */ jsx288("div", { className: "border-b p-4", children: /* @__PURE__ */ jsx288("div", { className: "text-primary-900 text-sm font-medium", children: /* @__PURE__ */ jsx288(OfferStatusLabel, { status: offer.status }) }) }),
      /* @__PURE__ */ jsxs189("div", { className: "flex flex-wrap items-center gap-2 border-b p-4", children: [
        /* @__PURE__ */ jsx288("div", { children: offer.rateAmount }),
        /* @__PURE__ */ jsx288("div", { children: offer.currencyCode }),
        /* @__PURE__ */ jsx288(OfferPayTypeLabel, { payType: offer.payType })
      ] }),
      actions
    ] })
  ] });
}
OfferDashboardComponent.fragments = {
  offer: OfferDashboard_offer_graphql_default
};
var createRoute20 = (offerRouteId, environment, context, showHeader) => {
  const routeId4 = `${offerRouteId}-dashboard`;
  return {
    id: routeId4,
    path: "*",
    element: /* @__PURE__ */ jsx288(OfferDashboard, { showHeader, routeId: offerRouteId }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx288(BreadcrumbLink7, { to: "dashboard", label: "Dashboard" })
    },
    loader: ({ params }) => {
      return loader25(environment, params);
    }
  };
};

// src/offers/components/OfferList.tsx
import { Fragment as Fragment76, jsx as jsx289 } from "react/jsx-runtime";
function OfferList({ applicationId }) {
  const data = useLazyLoadQuery41(OfferList.query, {
    where: { applicationId: { eq: applicationId } }
  });
  return /* @__PURE__ */ jsx289(Fragment76, { children: data.offers?.nodes?.map((x4) => /* @__PURE__ */ jsx289(
    OfferDashboardComponent,
    {
      fragmentRef: x4,
      showHeader: false
    },
    x4.id
  )) });
}
OfferList.query = OfferListQuery_graphql_default;

// src/candidates/components/__generated__/CandidateApplicationInterviewsRouteQuery.graphql.ts
var node323 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "applicationCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "applicationCode",
      "variableName": "applicationCode"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "applicationId",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "vacancyName",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v8 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateApplicationInterviewsRouteQuery",
      "selections": [
        {
          "alias": "application",
          "args": v1,
          "concreteType": "Application",
          "kind": "LinkedField",
          "name": "applicationByCode",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            v5,
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "candidate",
              "plural": false,
              "selections": [
                v6,
                v7
              ],
              "storageKey": null
            },
            v8
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateApplicationInterviewsRouteQuery",
      "selections": [
        {
          "alias": "application",
          "args": v1,
          "concreteType": "Application",
          "kind": "LinkedField",
          "name": "applicationByCode",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            v5,
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "candidate",
              "plural": false,
              "selections": [
                v6,
                v7,
                v23
              ],
              "storageKey": null
            },
            v8
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "66cd23ffd75603d6e5f64cc9d6dfb9d7",
      "id": null,
      "metadata": {},
      "name": "CandidateApplicationInterviewsRouteQuery",
      "operationKind": "query",
      "text": "query CandidateApplicationInterviewsRouteQuery(\n  $applicationCode: Int!\n) {\n  application: applicationByCode(applicationCode: $applicationCode) {\n    id\n    code\n    applicationId\n    vacancyName\n    candidate {\n      firstName\n      lastName\n      id\n    }\n  }\n}\n"
    }
  };
}();
node323.hash = "f1c5d49f9be1735d6026a9d72c1dbc2c";
var CandidateApplicationInterviewsRouteQuery_graphql_default = node323;

// src/candidates/components/CandidateApplicationInterviews.tsx
import { Suspense as Suspense103 } from "react";
import { loadQuery as loadQuery33 } from "react-relay";
import { Link as Link23, Navigate as Navigate12, Outlet as Outlet10, useNavigate as useNavigate21 } from "react-router-dom";
import { useRouteData as useRouteData19 } from "shared-lib";
import { Button as Button81, EdSkeleton as EdSkeleton93, Size as Size41 } from "shared-ui";

// src/interviews/components/__generated__/CandidateInterviewRouteQuery.graphql.ts
var node324 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "interviewCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "interviewCode"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "interviewId",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "scheduledToStartAt",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "declinedAt",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "cancelledAt",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "stage",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "type",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  }, v13 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }, v14 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateInterviewRouteQuery",
      "selections": [
        {
          "alias": "interview",
          "args": v1,
          "concreteType": "RecruitInterview",
          "kind": "LinkedField",
          "name": "recruitInterviewByCode",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            v10,
            v11,
            v12,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "CandidateInterviewDetails_data"
            },
            v13
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateInterviewRouteQuery",
      "selections": [
        {
          "alias": "interview",
          "args": v1,
          "concreteType": "RecruitInterview",
          "kind": "LinkedField",
          "name": "recruitInterviewByCode",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            v10,
            v11,
            v12,
            v14,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "candidateAccountId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Vacancy",
              "kind": "LinkedField",
              "name": "vacancy",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "employerName",
                  "storageKey": null
                },
                v23
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "location",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CommunicationsInterviewMeeting",
              "kind": "LinkedField",
              "name": "meeting",
              "plural": false,
              "selections": [
                v23,
                v32,
                v5,
                v14,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                },
                v11,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "provider",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "sourceType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "contentType",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v13
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "aeffd48c3cb6cea7d2293ee2261abe0e",
      "id": null,
      "metadata": {},
      "name": "CandidateInterviewRouteQuery",
      "operationKind": "query",
      "text": "query CandidateInterviewRouteQuery(\n  $interviewCode: Long!\n) {\n  interview: recruitInterviewByCode(code: $interviewCode) {\n    id\n    code\n    interviewId\n    createdAt\n    scheduledToStartAt\n    declinedAt\n    cancelledAt\n    status\n    stage\n    type\n    description\n    ...CandidateInterviewDetails_data\n  }\n}\n\nfragment CandidateInterviewDetails_data on RecruitInterview {\n  id\n  interviewId\n  code\n  createdAt\n  updatedAt\n  candidateAccountId\n  scheduledToStartAt\n  declinedAt\n  cancelledAt\n  status\n  stage\n  type\n  description\n  ...InterviewCalendar_data\n  ...InterviewDetails_data\n}\n\nfragment InterviewCalendar_data on RecruitInterview {\n  id\n  interviewId\n  status\n  createdAt\n  scheduledToStartAt\n  declinedAt\n  cancelledAt\n  vacancy {\n    employerName\n    id\n  }\n}\n\nfragment InterviewDetails_data on RecruitInterview {\n  id\n  candidateAccountId\n  interviewId\n  createdAt\n  scheduledToStartAt\n  declinedAt\n  cancelledAt\n  status\n  stage\n  type\n  location\n  description\n  vacancy {\n    employerName\n    id\n  }\n  meeting {\n    ...InterviewMeeting_meeting\n    id\n  }\n  ...InterviewCalendar_data\n}\n\nfragment InterviewMeeting_meeting on CommunicationsInterviewMeeting {\n  id\n  code\n  createdAt\n  updatedAt\n  title\n  type\n  provider\n  sourceType\n  contentType\n}\n"
    }
  };
}();
node324.hash = "ba73efe803858c155d5618ff96b368f2";
var CandidateInterviewRouteQuery_graphql_default = node324;

// src/interviews/components/CandidateInterview.tsx
import { Suspense as Suspense98 } from "react";
import { loadQuery as loadQuery31 } from "react-relay";
import { useRouteData as useRouteData18 } from "shared-lib";
import { EdSkeleton as EdSkeleton88 } from "shared-ui";

// src/interviews/components/__generated__/CandidateInterviewDetails_data.graphql.ts
var node325 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CandidateInterviewDetails_data",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "interviewId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "candidateAccountId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "scheduledToStartAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "declinedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cancelledAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "stage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InterviewCalendar_data"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InterviewDetails_data"
    }
  ],
  "type": "RecruitInterview",
  "abstractKey": null
};
node325.hash = "21f779b8b4fdeff20b82afe3767a36ca";
var CandidateInterviewDetails_data_graphql_default = node325;

// src/interviews/components/CandidateInterviewDetails.tsx
import { useCallback as useCallback166, useState as useState89 } from "react";
import { useFragment as useFragment90 } from "react-relay";
import { format as format16 } from "date-fns";
import { Button as Button79, ButtonList as ButtonList31, PageHeader as PageHeader2, PageTitle as PageTitle2 } from "shared-ui";

// src/interviews/lib/Interview.ts
import { parseISO as parseISO8 } from "date-fns";
var Interview = class {
  constructor(scheduledAt, declinedAt, cancelledAt) {
    this.scheduledAt = null;
    this.declinedAt = null;
    this.cancelledAt = null;
    this.canAccept = scheduledAt === null && declinedAt === null && cancelledAt === null;
    this.canDecline = scheduledAt === null && declinedAt === null && cancelledAt === null;
    this.canCancel = scheduledAt !== null;
    this.canReschedule = scheduledAt !== null;
    if (scheduledAt) {
      this.scheduledAt = parseISO8(scheduledAt);
    }
    if (declinedAt) {
      this.declinedAt = parseISO8(declinedAt);
    }
    if (cancelledAt) {
      this.cancelledAt = parseISO8(cancelledAt);
    }
  }
};

// src/interviews/mutations/__generated__/UseInterviewCancelMutation.graphql.ts
var node326 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfInterview",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitInterview",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "interviewId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "version",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdById",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdByAccountType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedById",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedByAccountType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "applicationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vacancyId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "candidateAccountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "duration",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "location",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "stage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "participants",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "candidateInvitedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scheduledToStartAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scheduledToEndAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "declinedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scheduledById",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cancelledAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cancelledById",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v32 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseInterviewCancelMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitInterviewCancelInterviewPayload",
          "kind": "LinkedField",
          "name": "recruitInterviewCancelInterview",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseInterviewCancelMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitInterviewCancelInterviewPayload",
          "kind": "LinkedField",
          "name": "recruitInterviewCancelInterview",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "cf1f313fd0a13691d19feafe930bd27f",
      "id": null,
      "metadata": {},
      "name": "UseInterviewCancelMutation",
      "operationKind": "mutation",
      "text": "mutation UseInterviewCancelMutation(\n  $input: RecruitInterviewCancelInterviewInput!\n) {\n  result: recruitInterviewCancelInterview(input: $input) {\n    payload {\n      node {\n        id\n        interviewId\n        version\n        createdAt\n        createdById\n        createdByAccountType\n        updatedAt\n        updatedById\n        updatedByAccountType\n        employerId\n        applicationId\n        vacancyId\n        candidateAccountId\n        duration\n        location\n        stage\n        type\n        status\n        participants\n        candidateInvitedAt\n        scheduledToStartAt\n        scheduledToEndAt\n        declinedAt\n        scheduledById\n        cancelledAt\n        cancelledById\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node326.hash = "4790c98d0a9faed19228dabb1f0e9c39";
var UseInterviewCancelMutation_graphql_default = node326;

// src/interviews/mutations/UseInterviewCancel.ts
import { useCallback as useCallback156 } from "react";
import {
  createClientMutationId as createClientMutationId70,
  useAsyncMutation as useAsyncMutation59,
  useSetUserErrorCodes as useSetUserErrorCodes27,
  useUnhandledError as useUnhandledError24
} from "shared-lib";
var mutationDef78 = UseInterviewCancelMutation_graphql_default;
var useInterviewCancel = (candidateId, interviewId) => {
  const [, setUnhandledError] = useUnhandledError24();
  const setErrorCodes = useSetUserErrorCodes27();
  const [commitMutation4, isMutationInFlight] = useAsyncMutation59(mutationDef78);
  const invokeMutation = useCallback156(async () => {
    const clientMutationId = createClientMutationId70();
    const input = {
      candidateId,
      interviewId,
      clientMutationId
    };
    try {
      const response = await commitMutation4({ input });
      if (response.result.payload) {
        return response.result.payload;
      }
      if (response.result.userErrors) {
        setErrorCodes(response.result.userErrors);
      }
      return null;
    } catch (e4) {
      setUnhandledError(new Error("useInterviewCancel Unhandled Error"));
      return null;
    }
  }, [commitMutation4]);
  return [invokeMutation, isMutationInFlight];
};

// src/interviews/mutations/__generated__/UseInterviewCreateMutation.graphql.ts
var node327 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfInterview",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitInterview",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "interviewId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "version",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdById",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdByAccountType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedById",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedByAccountType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "applicationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vacancyId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "candidateAccountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "duration",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "location",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "stage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "participants",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "candidateInvitedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scheduledToStartAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scheduledToEndAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "declinedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scheduledById",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cancelledAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cancelledById",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v32 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseInterviewCreateMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitInterviewCreateInterviewPayload",
          "kind": "LinkedField",
          "name": "recruitInterviewCreateInterview",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseInterviewCreateMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitInterviewCreateInterviewPayload",
          "kind": "LinkedField",
          "name": "recruitInterviewCreateInterview",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "be3eaf22cff0d0f341276a073dd420e6",
      "id": null,
      "metadata": {},
      "name": "UseInterviewCreateMutation",
      "operationKind": "mutation",
      "text": "mutation UseInterviewCreateMutation(\n  $input: RecruitInterviewCreateInterviewInput!\n) {\n  result: recruitInterviewCreateInterview(input: $input) {\n    payload {\n      node {\n        id\n        interviewId\n        version\n        createdAt\n        createdById\n        createdByAccountType\n        updatedAt\n        updatedById\n        updatedByAccountType\n        employerId\n        applicationId\n        vacancyId\n        candidateAccountId\n        duration\n        location\n        stage\n        type\n        status\n        participants\n        candidateInvitedAt\n        scheduledToStartAt\n        scheduledToEndAt\n        declinedAt\n        scheduledById\n        cancelledAt\n        cancelledById\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node327.hash = "261289d6576acbc557f815a9345dd0ae";
var UseInterviewCreateMutation_graphql_default = node327;

// src/interviews/mutations/UseInterviewCreate.ts
import { useCallback as useCallback157 } from "react";
import {
  useAsyncMutation as useAsyncMutation60,
  useUnhandledError as useUnhandledError25,
  useSetUserErrorCodes as useSetUserErrorCodes28
} from "shared-lib";
var mutationDef79 = UseInterviewCreateMutation_graphql_default;
var useInterviewCreate = () => {
  const [, setUnhandledError] = useUnhandledError25();
  const setErrorCodes = useSetUserErrorCodes28();
  const [commitMutation4, isMutationInFlight] = useAsyncMutation60(mutationDef79);
  const invokeMutation = useCallback157(
    async (input) => {
      try {
        const response = await commitMutation4({ input });
        if (response.result.payload) {
          return response.result.payload;
        }
        if (response.result.userErrors) {
          setErrorCodes(response.result.userErrors);
        }
        return null;
      } catch (e4) {
        setUnhandledError(new Error("useInterviewCreate Unhandled Error"));
        return null;
      }
    },
    [commitMutation4]
  );
  return [invokeMutation, isMutationInFlight];
};

// src/interviews/mutations/__generated__/UseInterviewDeclineMutation.graphql.ts
var node328 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfInterview",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitInterview",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "interviewId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "version",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdById",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdByAccountType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedById",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedByAccountType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "applicationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vacancyId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "candidateAccountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "duration",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "location",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "stage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "participants",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "candidateInvitedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scheduledToStartAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scheduledToEndAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "declinedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scheduledById",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cancelledAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cancelledById",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v32 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseInterviewDeclineMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitInterviewDeclineInterviewPayload",
          "kind": "LinkedField",
          "name": "recruitInterviewDeclineInterview",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseInterviewDeclineMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitInterviewDeclineInterviewPayload",
          "kind": "LinkedField",
          "name": "recruitInterviewDeclineInterview",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "a24c2956156eea72a6be58deee96c9fd",
      "id": null,
      "metadata": {},
      "name": "UseInterviewDeclineMutation",
      "operationKind": "mutation",
      "text": "mutation UseInterviewDeclineMutation(\n  $input: RecruitInterviewDeclineInterviewInput!\n) {\n  result: recruitInterviewDeclineInterview(input: $input) {\n    payload {\n      node {\n        id\n        interviewId\n        version\n        createdAt\n        createdById\n        createdByAccountType\n        updatedAt\n        updatedById\n        updatedByAccountType\n        employerId\n        applicationId\n        vacancyId\n        candidateAccountId\n        duration\n        location\n        stage\n        type\n        status\n        participants\n        candidateInvitedAt\n        scheduledToStartAt\n        scheduledToEndAt\n        declinedAt\n        scheduledById\n        cancelledAt\n        cancelledById\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node328.hash = "0353e6c2cac7769fa2b461f71dd5df55";
var UseInterviewDeclineMutation_graphql_default = node328;

// src/interviews/mutations/UseInterviewDecline.ts
import { useCallback as useCallback158 } from "react";
import {
  createClientMutationId as createClientMutationId71,
  useAsyncMutation as useAsyncMutation61,
  useUnhandledError as useUnhandledError26,
  useSetUserErrorCodes as useSetUserErrorCodes29
} from "shared-lib";
var mutationDef80 = UseInterviewDeclineMutation_graphql_default;
var useInterviewDecline = (candidateId, interviewId) => {
  const [, setUnhandledError] = useUnhandledError26();
  const setErrorCodes = useSetUserErrorCodes29();
  const [commitMutation4, isMutationInFlight] = useAsyncMutation61(mutationDef80);
  const invokeMutation = useCallback158(async () => {
    const clientMutationId = createClientMutationId71();
    const input = {
      candidateId,
      interviewId,
      clientMutationId
    };
    try {
      const response = await commitMutation4({ input });
      if (response.result.payload) {
        return response.result.payload;
      }
      if (response.result.userErrors) {
        setErrorCodes(response.result.userErrors);
      }
      return null;
    } catch (e4) {
      setUnhandledError(new Error("useInterviewDecline Unhandled Error"));
      return null;
    }
  }, [commitMutation4]);
  return [invokeMutation, isMutationInFlight];
};

// src/interviews/mutations/__generated__/UseInterviewInviteMutation.graphql.ts
var node329 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfInterview",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitInterview",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "interviewId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "version",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdById",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdByAccountType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedById",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedByAccountType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "applicationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vacancyId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "candidateAccountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "duration",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "location",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "stage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "participants",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "candidateInvitedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scheduledToStartAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scheduledToEndAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "declinedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scheduledById",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cancelledAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cancelledById",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v32 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseInterviewInviteMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitInterviewInviteCandidatePayload",
          "kind": "LinkedField",
          "name": "recruitInterviewInviteCandidate",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseInterviewInviteMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitInterviewInviteCandidatePayload",
          "kind": "LinkedField",
          "name": "recruitInterviewInviteCandidate",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "934ccdae09725c020c71d98d3749f195",
      "id": null,
      "metadata": {},
      "name": "UseInterviewInviteMutation",
      "operationKind": "mutation",
      "text": "mutation UseInterviewInviteMutation(\n  $input: RecruitInterviewInviteCandidateInput!\n) {\n  result: recruitInterviewInviteCandidate(input: $input) {\n    payload {\n      node {\n        id\n        interviewId\n        version\n        createdAt\n        createdById\n        createdByAccountType\n        updatedAt\n        updatedById\n        updatedByAccountType\n        employerId\n        applicationId\n        vacancyId\n        candidateAccountId\n        duration\n        location\n        stage\n        type\n        status\n        participants\n        candidateInvitedAt\n        scheduledToStartAt\n        scheduledToEndAt\n        declinedAt\n        scheduledById\n        cancelledAt\n        cancelledById\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node329.hash = "9784d99d7b0030ea106c9aa3e87d5a8a";
var UseInterviewInviteMutation_graphql_default = node329;

// src/interviews/mutations/UseInterviewInvite.ts
import { useCallback as useCallback159 } from "react";
import {
  createClientMutationId as createClientMutationId73,
  useAsyncMutation as useAsyncMutation63,
  useUnhandledError as useUnhandledError27,
  useSetUserErrorCodes as useSetUserErrorCodes30
} from "shared-lib";
var mutationDef81 = UseInterviewInviteMutation_graphql_default;
var useInterviewInvite = () => {
  const [, setUnhandledError] = useUnhandledError27();
  const setErrorCodes = useSetUserErrorCodes30();
  const [commitMutation4, isMutationInFlight] = useAsyncMutation63(mutationDef81);
  const invokeMutation = useCallback159(
    (interviewId) => async () => {
      try {
        const input = {
          clientMutationId: createClientMutationId73(),
          interviewId
        };
        const response = await commitMutation4({ input });
        if (response.result.payload) {
          return response.result.payload;
        }
        if (response.result.userErrors) {
          setErrorCodes(response.result.userErrors);
        }
        return null;
      } catch (e4) {
        setUnhandledError(new Error("useInterviewInvite Unhandled Error"));
        return null;
      }
    },
    [commitMutation4, setErrorCodes, setUnhandledError]
  );
  return [invokeMutation, isMutationInFlight];
};

// src/interviews/mutations/__generated__/UseInterviewRescheduleMutation.graphql.ts
var node330 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfInterview",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitInterview",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "interviewId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "version",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdById",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdByAccountType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedById",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedByAccountType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "applicationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vacancyId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "candidateAccountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "duration",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "location",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "stage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "participants",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "candidateInvitedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scheduledToStartAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scheduledToEndAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "declinedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scheduledById",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cancelledAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cancelledById",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v32 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseInterviewRescheduleMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitInterviewReschedulePayload",
          "kind": "LinkedField",
          "name": "recruitInterviewReschedule",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseInterviewRescheduleMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitInterviewReschedulePayload",
          "kind": "LinkedField",
          "name": "recruitInterviewReschedule",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "9172efd08330df2800e6ed860b1f97bd",
      "id": null,
      "metadata": {},
      "name": "UseInterviewRescheduleMutation",
      "operationKind": "mutation",
      "text": "mutation UseInterviewRescheduleMutation(\n  $input: RecruitInterviewRescheduleInput!\n) {\n  result: recruitInterviewReschedule(input: $input) {\n    payload {\n      node {\n        id\n        interviewId\n        version\n        createdAt\n        createdById\n        createdByAccountType\n        updatedAt\n        updatedById\n        updatedByAccountType\n        employerId\n        applicationId\n        vacancyId\n        candidateAccountId\n        duration\n        location\n        stage\n        type\n        status\n        participants\n        candidateInvitedAt\n        scheduledToStartAt\n        scheduledToEndAt\n        declinedAt\n        scheduledById\n        cancelledAt\n        cancelledById\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node330.hash = "c93f0ac9b246f80c8482b8c99d82bf62";
var UseInterviewRescheduleMutation_graphql_default = node330;

// src/interviews/mutations/UseInterviewReschedule.ts
import { useCallback as useCallback160 } from "react";
import {
  createClientMutationId as createClientMutationId74,
  useAsyncMutation as useAsyncMutation64,
  useUnhandledError as useUnhandledError28,
  useSetUserErrorCodes as useSetUserErrorCodes31
} from "shared-lib";
var mutationDef82 = UseInterviewRescheduleMutation_graphql_default;
var useInterviewReschedule = (candidateId, interviewId) => {
  const [, setUnhandledError] = useUnhandledError28();
  const setErrorCodes = useSetUserErrorCodes31();
  const [commitMutation4, isMutationInFlight] = useAsyncMutation64(mutationDef82);
  const invokeMutation = useCallback160(
    async (form) => {
      const clientMutationId = createClientMutationId74();
      const input = {
        ...form,
        candidateId,
        interviewId,
        clientMutationId
      };
      try {
        const response = await commitMutation4({ input });
        if (response.result.payload) {
          return response.result.payload;
        }
        if (response.result.userErrors) {
          setErrorCodes(response.result.userErrors);
        }
        return null;
      } catch (e4) {
        setUnhandledError(new Error("useInterviewReschedule Unhandled Error"));
        return null;
      }
    },
    [commitMutation4]
  );
  return [invokeMutation, isMutationInFlight];
};

// src/interviews/mutations/__generated__/UseInterviewScheduleMutation.graphql.ts
var node331 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfInterview",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitInterview",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "interviewId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "version",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdById",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdByAccountType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedById",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedByAccountType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "applicationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vacancyId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "candidateAccountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "duration",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "location",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "stage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "participants",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "candidateInvitedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scheduledToStartAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scheduledToEndAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "declinedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scheduledById",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cancelledAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cancelledById",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v32 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseInterviewScheduleMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitInterviewScheduleInterviewPayload",
          "kind": "LinkedField",
          "name": "recruitInterviewScheduleInterview",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseInterviewScheduleMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitInterviewScheduleInterviewPayload",
          "kind": "LinkedField",
          "name": "recruitInterviewScheduleInterview",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "6df058eb85d08c2b5dd89ff2af496820",
      "id": null,
      "metadata": {},
      "name": "UseInterviewScheduleMutation",
      "operationKind": "mutation",
      "text": "mutation UseInterviewScheduleMutation(\n  $input: RecruitInterviewScheduleInterviewInput!\n) {\n  result: recruitInterviewScheduleInterview(input: $input) {\n    payload {\n      node {\n        id\n        interviewId\n        version\n        createdAt\n        createdById\n        createdByAccountType\n        updatedAt\n        updatedById\n        updatedByAccountType\n        employerId\n        applicationId\n        vacancyId\n        candidateAccountId\n        duration\n        location\n        stage\n        type\n        status\n        participants\n        candidateInvitedAt\n        scheduledToStartAt\n        scheduledToEndAt\n        declinedAt\n        scheduledById\n        cancelledAt\n        cancelledById\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node331.hash = "ac6bee6a5203e19701ba30c3a2fae7ad";
var UseInterviewScheduleMutation_graphql_default = node331;

// src/interviews/mutations/UseInterviewSchedule.ts
import { useCallback as useCallback161 } from "react";
import {
  createClientMutationId as createClientMutationId75,
  useAsyncMutation as useAsyncMutation65,
  useUnhandledError as useUnhandledError29,
  useSetUserErrorCodes as useSetUserErrorCodes32
} from "shared-lib";
var mutationDef83 = UseInterviewScheduleMutation_graphql_default;
var useInterviewSchedule = (candidateId, interviewId) => {
  const [, setUnhandledError] = useUnhandledError29();
  const setErrorCodes = useSetUserErrorCodes32();
  const [commitMutation4, isMutationInFlight] = useAsyncMutation65(mutationDef83);
  const invokeMutation = useCallback161(
    async (form) => {
      const clientMutationId = createClientMutationId75();
      const input = {
        ...form,
        candidateId,
        interviewId,
        clientMutationId
      };
      try {
        const response = await commitMutation4({ input });
        if (response.result.payload) {
          return response.result.payload;
        }
        if (response.result.userErrors) {
          setErrorCodes(response.result.userErrors);
        }
        return null;
      } catch (e4) {
        setUnhandledError(new Error("useInterviewSchedule Unhandled Error"));
        return null;
      }
    },
    [commitMutation4]
  );
  return [invokeMutation, isMutationInFlight];
};

// src/interviews/components/__generated__/InterviewDetails_data.graphql.ts
var node333 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InterviewDetails_data",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "candidateAccountId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "interviewId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "scheduledToStartAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "declinedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cancelledAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "stage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "location",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Vacancy",
      "kind": "LinkedField",
      "name": "vacancy",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "employerName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CommunicationsInterviewMeeting",
      "kind": "LinkedField",
      "name": "meeting",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "InterviewMeeting_meeting"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InterviewCalendar_data"
    }
  ],
  "type": "RecruitInterview",
  "abstractKey": null
};
node333.hash = "665bd031c18194e5aabdb6b22ae4dfdd";
var InterviewDetails_data_graphql_default = node333;

// src/interviews/components/InterviewDetails.tsx
import { Suspense as Suspense97, useCallback as useCallback165, useState as useState88 } from "react";
import {
  useFragment as useFragment89,
  usePreloadedQuery as usePreloadedQuery31
} from "react-relay";
import { format as format15 } from "date-fns";
import {
  Button as Button78,
  ButtonList as ButtonList30,
  Card as Card5,
  EdSkeleton as EdSkeleton87,
  PageHeader,
  PageTitle,
  Size as Size40
} from "shared-ui";
import { InterviewMeeting } from "feature-notifications";

// src/interviews/components/__generated__/InterviewCalendarQuery.graphql.ts
var node334 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "interviewId"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "monthEnd"
  }, v23 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "monthStart"
  }, v32 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "timeZone"
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  }, v5 = [
    {
      "alias": "range",
      "args": [
        {
          "kind": "Variable",
          "name": "interviewId",
          "variableName": "interviewId"
        },
        {
          "kind": "Variable",
          "name": "rangeEnd",
          "variableName": "monthEnd"
        },
        {
          "kind": "Variable",
          "name": "rangeStart",
          "variableName": "monthStart"
        },
        {
          "kind": "Variable",
          "name": "timeZone",
          "variableName": "timeZone"
        }
      ],
      "concreteType": "RecruitCalendarRange",
      "kind": "LinkedField",
      "name": "recruitInterviewCalendarRange",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rangeStart",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rangeEnd",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "today",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RecruitCalendarRangeDay",
          "kind": "LinkedField",
          "name": "days",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "index",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "date",
              "storageKey": null
            },
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitCalendarRangeTimeSlot",
              "kind": "LinkedField",
              "name": "timeSlots",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startTime",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1,
        v23,
        v32
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "InterviewCalendarQuery",
      "selections": v5,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v0,
        v23,
        v1,
        v32
      ],
      "kind": "Operation",
      "name": "InterviewCalendarQuery",
      "selections": v5
    },
    "params": {
      "cacheID": "2fe0ae7c4a9b859b2ff63acb0b7c55f6",
      "id": null,
      "metadata": {},
      "name": "InterviewCalendarQuery",
      "operationKind": "query",
      "text": "query InterviewCalendarQuery(\n  $interviewId: UUID!\n  $monthStart: DateTime!\n  $monthEnd: DateTime!\n  $timeZone: String\n) {\n  range: recruitInterviewCalendarRange(interviewId: $interviewId, rangeStart: $monthStart, rangeEnd: $monthEnd, timeZone: $timeZone) {\n    id\n    rangeStart\n    rangeEnd\n    today\n    days {\n      index\n      date\n      status\n      timeSlots {\n        startTime\n        status\n      }\n    }\n  }\n}\n"
    }
  };
}();
node334.hash = "dfdfa446a0827adbaf2a085c7b5a3bab";
var InterviewCalendarQuery_graphql_default = node334;

// src/interviews/components/__generated__/InterviewCalendar_data.graphql.ts
var node335 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InterviewCalendar_data",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "interviewId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "scheduledToStartAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "declinedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cancelledAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Vacancy",
      "kind": "LinkedField",
      "name": "vacancy",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "employerName",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RecruitInterview",
  "abstractKey": null
};
node335.hash = "51b972707431c91e3baeada667edfe4c";
var InterviewCalendar_data_graphql_default = node335;

// src/interviews/components/InterviewCalendar.tsx
import { useCallback as useCallback164, useEffect as useEffect35, useState as useState87 } from "react";
import {
  useFragment as useFragment88,
  usePreloadedQuery as usePreloadedQuery29,
  useQueryLoader as useQueryLoader13
} from "react-relay";
import {
  add,
  format as format14,
  parse,
  startOfToday as startOfToday2,
  startOfMonth as startOfMonth2,
  endOfMonth as endOfMonth3
} from "date-fns";
import { EdSkeleton as EdSkeleton85 } from "shared-ui";

// src/calendars/components/Calendar.tsx
import { useState as useState86 } from "react";
import {
  eachDayOfInterval,
  endOfMonth as endOfMonth2,
  format as format13,
  getDay,
  isEqual as isEqual2,
  isSameDay,
  isSameMonth,
  isToday,
  parseISO as parseISO11,
  startOfToday
} from "date-fns";
import { ChevronLeftIcon, ChevronRightIcon as ChevronRightIcon2 } from "@heroicons/react/24/outline";
import { classNames as classNames35 } from "shared-ui";

// src/calendars/components/Day.tsx
import { parseISO as parseISO10 } from "date-fns";

// src/calendars/components/TimeSlot.tsx
import { useCallback as useCallback163, useState as useState85 } from "react";
import { format as format12, parseISO as parseISO9 } from "date-fns";
import { ArrowRightIcon as ArrowRightIcon3 } from "@heroicons/react/24/outline";
import { Button as Button77, ButtonList as ButtonList29 } from "shared-ui";
import { jsx as jsx290, jsxs as jsxs190 } from "react/jsx-runtime";
var timeSlotSelectedClasses = "border rounded-md shadow-md";
var TimeSlot = ({ isBusy, date, startTime, onSelect }) => {
  const time = parseISO9(startTime);
  const [selected, setSelected] = useState85(false);
  const onSelectSlot = useCallback163(() => {
    onSelect({ date, startTime });
  }, [onSelect, setSelected]);
  return /* @__PURE__ */ jsxs190(
    "div",
    {
      className: `border-b p-3 ${selected && timeSlotSelectedClasses}`,
      children: [
        /* @__PURE__ */ jsxs190(
          "div",
          {
            onClick: () => setSelected(true),
            className: "flex cursor-pointer items-center justify-between",
            children: [
              /* @__PURE__ */ jsx290("div", { children: /* @__PURE__ */ jsx290("p", { className: "text-info-500 font-medium", children: format12(time, "ppp") }) }),
              /* @__PURE__ */ jsx290("div", { children: /* @__PURE__ */ jsx290(ArrowRightIcon3, { className: "h-7 w-7", "aria-hidden": "true" }) })
            ]
          }
        ),
        selected && /* @__PURE__ */ jsx290("div", { className: "mt-3 flex cursor-pointer items-center justify-between border-t pt-2", children: /* @__PURE__ */ jsxs190(ButtonList29, { children: [
          /* @__PURE__ */ jsx290(Button77, { color: "primary", clicked: onSelectSlot, disabled: isBusy, children: "Schedule" }),
          /* @__PURE__ */ jsx290(
            Button77,
            {
              color: "gray",
              clicked: () => setSelected(false),
              disabled: isBusy,
              children: "Cancel"
            }
          )
        ] }) })
      ]
    },
    startTime
  );
};

// src/calendars/components/Day.tsx
import { jsx as jsx291 } from "react/jsx-runtime";
var Day = ({ isBusy, day, onSelect }) => {
  const date = parseISO10(day.date);
  const timeslots = day.timeSlots.map((t4) => {
    return /* @__PURE__ */ jsx291(
      TimeSlot,
      {
        isBusy,
        date,
        startTime: t4.startTime,
        onSelect
      },
      t4.startTime
    );
  });
  return /* @__PURE__ */ jsx291("div", { className: "flex flex-col gap-2", children: timeslots });
};

// src/calendars/components/Calendar.tsx
import { jsx as jsx293, jsxs as jsxs191 } from "react/jsx-runtime";
var colStartClasses = [
  "",
  "col-start-2",
  "col-start-3",
  "col-start-4",
  "col-start-5",
  "col-start-6",
  "col-start-7"
];
var Calendar = ({
  range,
  firstDayCurrentMonth,
  onPreviousMonth,
  onNextMonth,
  isBusy,
  onSelectSlot
}) => {
  const today = startOfToday();
  const [selectedDay, setSelectedDay] = useState86(today);
  const days = eachDayOfInterval({
    start: firstDayCurrentMonth,
    end: endOfMonth2(firstDayCurrentMonth)
  });
  const timeslotDays = range?.days || [];
  const selectedRangeDays = timeslotDays.filter(
    (day) => isSameDay(parseISO11(day.date), selectedDay)
  );
  return /* @__PURE__ */ jsx293("div", { className: "", children: /* @__PURE__ */ jsx293("div", { className: "mx-auto max-w-md px-4 sm:px-7 md:max-w-4xl md:px-6", children: /* @__PURE__ */ jsxs191("div", { className: "md:grid md:grid-cols-2 md:divide-x md:divide-gray-200", children: [
    /* @__PURE__ */ jsxs191("div", { className: "md:pr-14", children: [
      /* @__PURE__ */ jsxs191("div", { className: "flex items-center", children: [
        /* @__PURE__ */ jsx293("h2", { className: "flex-auto font-semibold text-gray-900", children: format13(firstDayCurrentMonth, "MMMM yyyy") }),
        /* @__PURE__ */ jsxs191(
          "button",
          {
            type: "button",
            onClick: onPreviousMonth,
            className: "-my-1.5 flex flex-none items-center justify-center p-1.5 text-gray-400 hover:text-gray-500",
            children: [
              /* @__PURE__ */ jsx293("span", { className: "sr-only", children: "Previous month" }),
              /* @__PURE__ */ jsx293(ChevronLeftIcon, { className: "h-5 w-5", "aria-hidden": "true" })
            ]
          }
        ),
        /* @__PURE__ */ jsxs191(
          "button",
          {
            onClick: onNextMonth,
            type: "button",
            className: "-my-1.5 -mr-1.5 ml-2 flex flex-none items-center justify-center p-1.5 text-gray-400 hover:text-gray-500",
            children: [
              /* @__PURE__ */ jsx293("span", { className: "sr-only", children: "Next month" }),
              /* @__PURE__ */ jsx293(ChevronRightIcon2, { className: "h-5 w-5", "aria-hidden": "true" })
            ]
          }
        )
      ] }),
      /* @__PURE__ */ jsxs191("div", { className: "mt-10 grid grid-cols-7 text-center text-xs leading-6 text-gray-500", children: [
        /* @__PURE__ */ jsx293("div", { children: "S" }),
        /* @__PURE__ */ jsx293("div", { children: "M" }),
        /* @__PURE__ */ jsx293("div", { children: "T" }),
        /* @__PURE__ */ jsx293("div", { children: "W" }),
        /* @__PURE__ */ jsx293("div", { children: "T" }),
        /* @__PURE__ */ jsx293("div", { children: "F" }),
        /* @__PURE__ */ jsx293("div", { children: "S" })
      ] }),
      /* @__PURE__ */ jsx293("div", { className: "mt-2 grid grid-cols-7 text-sm", children: days.map((day, dayIdx) => /* @__PURE__ */ jsxs191(
        "div",
        {
          className: classNames35(
            dayIdx === 0 && colStartClasses[getDay(day)],
            "py-1.5"
          ),
          children: [
            /* @__PURE__ */ jsx293(
              "button",
              {
                type: "button",
                onClick: () => setSelectedDay(day),
                className: classNames35(
                  isEqual2(day, selectedDay) && "text-white",
                  !isEqual2(day, selectedDay) && isToday(day) && "text-danger-500",
                  !isEqual2(day, selectedDay) && !isToday(day) && isSameMonth(day, firstDayCurrentMonth) && "text-gray-900",
                  !isEqual2(day, selectedDay) && !isToday(day) && !isSameMonth(day, firstDayCurrentMonth) && "text-gray-400",
                  isEqual2(day, selectedDay) && isToday(day) && "bg-danger-500",
                  isEqual2(day, selectedDay) && !isToday(day) && "bg-gray-900",
                  !isEqual2(day, selectedDay) && "hover:bg-gray-200",
                  (isEqual2(day, selectedDay) || isToday(day)) && "font-semibold",
                  "mx-auto flex h-8 w-8 items-center justify-center rounded-full"
                ),
                children: /* @__PURE__ */ jsx293("time", { dateTime: format13(day, "yyyy-MM-dd"), children: format13(day, "d") })
              }
            ),
            /* @__PURE__ */ jsx293("div", { className: "mx-auto mt-1 h-1 w-1", children: timeslotDays.some(
              (d4) => isSameDay(parseISO11(d4.date), day)
            ) && /* @__PURE__ */ jsx293("div", { className: "h-1 w-1 rounded-full bg-sky-500" }) })
          ]
        },
        day.toString()
      )) })
    ] }),
    /* @__PURE__ */ jsxs191("section", { className: "mt-2 md:mt-0 md:pl-14", children: [
      /* @__PURE__ */ jsxs191("h2", { className: "font-semibold text-gray-900", children: [
        "Timeslots for",
        " ",
        /* @__PURE__ */ jsx293("time", { dateTime: format13(selectedDay, "yyyy-MM-dd"), children: format13(selectedDay, "MMM dd, yyy") })
      ] }),
      /* @__PURE__ */ jsx293("div", { className: "mt-4 space-y-1 text-sm leading-6 text-gray-500", children: selectedRangeDays.length > 0 ? selectedRangeDays.map((slot) => /* @__PURE__ */ jsx293(
        Day,
        {
          isBusy,
          day: slot,
          onSelect: onSelectSlot
        },
        slot.index
      )) : /* @__PURE__ */ jsx293("p", { children: "No timeslots for today." }) })
    ] })
  ] }) }) });
};

// src/interviews/components/InterviewCalendar.tsx
import { jsx as jsx294 } from "react/jsx-runtime";
var queryDef50 = InterviewCalendarQuery_graphql_default;
var fragmentDef67 = InterviewCalendar_data_graphql_default;
var InterviewCalendar = ({
  candidateId,
  fragmentRef,
  onScheduled
}) => {
  const data = useFragment88(
    fragmentDef67,
    fragmentRef
  );
  const [queryReference, loadQuery48] = useQueryLoader13(queryDef50);
  const today = startOfToday2();
  const month = format14(today, "MMM-yyyy");
  const firstDayCurrentMonth = parse(month, "MMM-yyyy", today);
  const [monthStart, setMonthStart] = useState87(() => startOfMonth2(today));
  const [monthEnd, setMonthEnd] = useState87(() => endOfMonth3(today));
  useEffect35(() => {
    if (!data || !monthStart || !monthEnd) {
      return;
    }
    loadQuery48({
      interviewId: data.interviewId,
      monthStart: format14(monthStart, "yyyy-MMM-dd"),
      monthEnd: format14(monthEnd, "yyyy-MMM-dd")
    });
  }, [monthStart, monthEnd]);
  function previousMonth() {
    const firstDayNextMonth = add(firstDayCurrentMonth, { months: -1 });
    setMonthStart(startOfMonth2(firstDayNextMonth));
    setMonthEnd(endOfMonth3(firstDayNextMonth));
  }
  function nextMonth() {
    const firstDayNextMonth = add(firstDayCurrentMonth, { months: 1 });
    setMonthStart(startOfMonth2(firstDayNextMonth));
    setMonthEnd(endOfMonth3(firstDayNextMonth));
  }
  if (!queryReference) {
    return /* @__PURE__ */ jsx294(EdSkeleton85, {});
  }
  return /* @__PURE__ */ jsx294(
    CalendarLoader,
    {
      candidateId,
      interviewId: data.interviewId,
      interviewStatus: data.status,
      firstDayCurrentMonth,
      onNextMonth: nextMonth,
      onPreviousMonth: previousMonth,
      onScheduled,
      queryRef: queryReference
    }
  );
};
var CalendarLoader = ({
  candidateId,
  interviewId,
  interviewStatus,
  queryRef: queryRef3,
  firstDayCurrentMonth,
  onPreviousMonth,
  onNextMonth,
  onScheduled
}) => {
  const data = usePreloadedQuery29(queryDef50, queryRef3);
  const [schedule, isScheduling] = useInterviewSchedule(
    candidateId,
    interviewId
  );
  const [reschedule, isRescheduling] = useInterviewReschedule(
    candidateId,
    interviewId
  );
  const onSelectSlot = useCallback164(
    async (slot) => {
      if (interviewStatus === "SCHEDULED") {
        const response = await reschedule({
          startTime: slot.startTime
        });
        if (response?.node && onScheduled) {
          onScheduled();
        } else {
        }
      } else if (interviewStatus === "INVITED") {
        const response = await schedule({
          startTime: slot.startTime
        });
        if (response?.node && onScheduled) {
          onScheduled();
        } else {
        }
      }
    },
    [schedule]
  );
  return /* @__PURE__ */ jsx294(
    Calendar,
    {
      firstDayCurrentMonth,
      onPreviousMonth,
      onNextMonth,
      range: data.range,
      isBusy: isScheduling || isRescheduling,
      onSelectSlot
    }
  );
};

// src/interviews/components/__generated__/InterviewLayoutQuery.graphql.ts
var node336 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "id"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "id"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "interviewId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "concreteType": "Vacancy",
    "kind": "LinkedField",
    "name": "vacancy",
    "plural": false,
    "selections": [
      v23,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "employerName",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "type",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "InterviewLayoutQuery",
      "selections": [
        {
          "alias": "interview",
          "args": v1,
          "concreteType": "RecruitInterview",
          "kind": "LinkedField",
          "name": "recruitInterviewById",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "InterviewDetails_data"
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "InterviewLayoutQuery",
      "selections": [
        {
          "alias": "interview",
          "args": v1,
          "concreteType": "RecruitInterview",
          "kind": "LinkedField",
          "name": "recruitInterviewById",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "candidateAccountId",
              "storageKey": null
            },
            v5,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "scheduledToStartAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "declinedAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cancelledAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "stage",
              "storageKey": null
            },
            v6,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "location",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CommunicationsInterviewMeeting",
              "kind": "LinkedField",
              "name": "meeting",
              "plural": false,
              "selections": [
                v23,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "code",
                  "storageKey": null
                },
                v5,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "updatedAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                },
                v6,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "provider",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "sourceType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "contentType",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "c413122818e7117b8ff491d61f22f78c",
      "id": null,
      "metadata": {},
      "name": "InterviewLayoutQuery",
      "operationKind": "query",
      "text": "query InterviewLayoutQuery(\n  $id: UUID!\n) {\n  interview: recruitInterviewById(id: $id) {\n    id\n    interviewId\n    vacancy {\n      id\n      name\n      employerName\n    }\n    ...InterviewDetails_data\n  }\n}\n\nfragment InterviewCalendar_data on RecruitInterview {\n  id\n  interviewId\n  status\n  createdAt\n  scheduledToStartAt\n  declinedAt\n  cancelledAt\n  vacancy {\n    employerName\n    id\n  }\n}\n\nfragment InterviewDetails_data on RecruitInterview {\n  id\n  candidateAccountId\n  interviewId\n  createdAt\n  scheduledToStartAt\n  declinedAt\n  cancelledAt\n  status\n  stage\n  type\n  location\n  description\n  vacancy {\n    employerName\n    id\n  }\n  meeting {\n    ...InterviewMeeting_meeting\n    id\n  }\n  ...InterviewCalendar_data\n}\n\nfragment InterviewMeeting_meeting on CommunicationsInterviewMeeting {\n  id\n  code\n  createdAt\n  updatedAt\n  title\n  type\n  provider\n  sourceType\n  contentType\n}\n"
    }
  };
}();
node336.hash = "183c3df64c7c7f9a849d7267c34c38a9";
var InterviewLayoutQuery_graphql_default = node336;

// src/interviews/components/InterviewLayout.tsx
import { Suspense as Suspense96 } from "react";
import { usePreloadedQuery as usePreloadedQuery30 } from "react-relay";
import { Navigate as Navigate11, Route as Route5, Routes as Routes5 } from "react-router-dom";
import { EdSkeleton as EdSkeleton86 } from "shared-ui";
import { jsx as jsx295, jsxs as jsxs193 } from "react/jsx-runtime";
var interviewLayoutQueryDef = InterviewLayoutQuery_graphql_default;
var InterviewLayout = ({ queryRef: queryRef3 }) => {
  const { interview } = usePreloadedQuery30(
    interviewLayoutQueryDef,
    queryRef3
  );
  if (!interview) {
    return /* @__PURE__ */ jsx295(EdSkeleton86, {});
  }
  return /* @__PURE__ */ jsx295(Suspense96, { fallback: /* @__PURE__ */ jsx295(EdSkeleton86, {}), children: /* @__PURE__ */ jsxs193(Routes5, { children: [
    /* @__PURE__ */ jsx295(
      Route5,
      {
        path: "info",
        element: /* @__PURE__ */ jsx295(InterviewDetails, { fragmentRef: interview })
      }
    ),
    /* @__PURE__ */ jsx295(Route5, { path: "*", element: /* @__PURE__ */ jsx295(Navigate11, { to: "info", replace: true }) })
  ] }) });
};

// src/interviews/components/InterviewDetails.tsx
import { Fragment as Fragment77, jsx as jsx296, jsxs as jsxs194 } from "react/jsx-runtime";
var fragmentDef68 = InterviewDetails_data_graphql_default;
var InterviewDetailsContent = ({
  header,
  content
}) => {
  return /* @__PURE__ */ jsx296(Card5, { className: "m-5", children: /* @__PURE__ */ jsxs194("div", { className: "flex flex-col gap-2", children: [
    /* @__PURE__ */ jsx296(PageHeader, { children: header }),
    content
  ] }) });
};
var InterviewDetailsLoader = ({
  queryRef: queryRef3,
  defaultToScheduling,
  onDone,
  onCancel
}) => {
  const { interview } = usePreloadedQuery31(
    interviewLayoutQueryDef,
    queryRef3
  );
  if (!interview) {
    return /* @__PURE__ */ jsx296(EdSkeleton87, {});
  }
  return /* @__PURE__ */ jsx296(Suspense97, { fallback: /* @__PURE__ */ jsx296(EdSkeleton87, {}), children: /* @__PURE__ */ jsxs194("div", { className: "flex flex-col gap-3", children: [
    /* @__PURE__ */ jsx296(
      InterviewDetails,
      {
        fragmentRef: interview,
        defaultToScheduling,
        onDone
      }
    ),
    /* @__PURE__ */ jsx296("div", { className: "mt-1", children: /* @__PURE__ */ jsx296(ButtonList30, { children: /* @__PURE__ */ jsx296("div", { children: /* @__PURE__ */ jsx296(Button78, { color: "primary", clicked: onCancel, children: "Cancel" }) }) }) })
  ] }) });
};
var formatDescription2 = (description) => {
  return description?.split("\n").map((d4, i4) => /* @__PURE__ */ jsxs194("p", { children: [
    d4,
    /* @__PURE__ */ jsx296("br", {})
  ] }, i4));
};
var InterviewDetails = ({
  fragmentRef,
  defaultToScheduling,
  onDone
}) => {
  const data = useFragment89(fragmentDef68, fragmentRef);
  const [isCancelling, setCancelling] = useState88(false);
  const [isScheduling, setIsScheduling] = useState88(defaultToScheduling);
  const [isRescheduling, setIsRescheduling] = useState88(false);
  const [declineInterview, isDecliningInterview] = useInterviewDecline(
    data.candidateAccountId,
    data.interviewId
  );
  const [cancelInterview, isCancellingInterview] = useInterviewCancel(
    data.candidateAccountId,
    data.interviewId
  );
  const onScheduled = useCallback165(() => {
    if (isRescheduling) {
      setIsRescheduling(false);
    }
    if (isScheduling) {
      setIsScheduling(false);
    }
    if (onDone) {
      onDone();
    }
  }, [isRescheduling, setIsRescheduling, isScheduling, setIsScheduling]);
  const onCancelInterview = useCallback165(async () => {
    const response = await cancelInterview();
    if (response?.node) {
      if (onDone) {
        onDone();
      }
    }
  }, [cancelInterview]);
  const onDeclineInterview = useCallback165(async () => {
    const response = await declineInterview();
    if (response?.node) {
      if (onDone) {
        onDone();
      }
    }
  }, [declineInterview]);
  const interview = new Interview(
    data.scheduledToStartAt,
    data.declinedAt,
    data.cancelledAt
  );
  if (data.status === "SCHEDULED" && isCancelling) {
    return /* @__PURE__ */ jsx296(
      InterviewDetailsContent,
      {
        header: /* @__PURE__ */ jsx296(PageTitle, { title: "Cancel your interview", subTitle: "Are you sure ?" }),
        content: /* @__PURE__ */ jsx296("div", { className: "p-1 sm:p-4", children: /* @__PURE__ */ jsxs194(ButtonList30, { children: [
          /* @__PURE__ */ jsx296(
            Button78,
            {
              color: "warning",
              disabled: isCancellingInterview,
              clicked: onCancelInterview,
              children: "Yes, Cancel Now"
            }
          ),
          /* @__PURE__ */ jsx296(Button78, { color: "primary", clicked: () => setCancelling(false), children: "No, I don't want to Cancel" })
        ] }) })
      }
    );
  }
  if (data.status === "INVITED" && !isScheduling) {
    return /* @__PURE__ */ jsx296(
      InterviewDetailsContent,
      {
        header: /* @__PURE__ */ jsx296(
          PageTitle,
          {
            title: `${data.vacancy.employerName} has invited you to the interview`
          }
        ),
        content: /* @__PURE__ */ jsxs194("div", { children: [
          data.location && /* @__PURE__ */ jsx296("div", { className: "flex items-center gap-2 p-3 sm:p-4", children: /* @__PURE__ */ jsx296("p", { className: "text-lg font-medium text-gray-900", children: formatDescription2(data.location) }) }),
          /* @__PURE__ */ jsx296("div", { className: "p-1 sm:p-4", children: /* @__PURE__ */ jsxs194(ButtonList30, { justify: "GRID", children: [
            /* @__PURE__ */ jsx296(
              Button78,
              {
                size: Size40.md,
                color: "warning",
                clicked: () => setIsScheduling(true),
                children: "Confirm Interview Details"
              }
            ),
            /* @__PURE__ */ jsx296(
              Button78,
              {
                color: "primary",
                size: Size40.md,
                confirmMessage: "Declining the interview request - are you sure?",
                disabled: isDecliningInterview,
                clicked: onDeclineInterview,
                children: "No thanks"
              }
            )
          ] }) })
        ] })
      }
    );
  }
  if (isScheduling || data.status === "SCHEDULED" && isRescheduling) {
    return /* @__PURE__ */ jsx296(
      InterviewDetailsContent,
      {
        header: /* @__PURE__ */ jsx296(
          PageTitle,
          {
            title: /* @__PURE__ */ jsxs194("div", { className: "flex w-full justify-between gap-2", children: [
              /* @__PURE__ */ jsx296("div", { children: "Scheduling" }),
              /* @__PURE__ */ jsx296("div", { children: /* @__PURE__ */ jsx296(
                Button78,
                {
                  onClick: () => isScheduling ? setIsScheduling(false) : setIsRescheduling(false),
                  children: "Cancel"
                }
              ) })
            ] }),
            subTitle: /* @__PURE__ */ jsx296("div", { children: "Choose a slot from the Recruiters calendar below" })
          }
        ),
        content: /* @__PURE__ */ jsx296("div", { className: "p-1 sm:p-4", children: /* @__PURE__ */ jsx296(
          InterviewCalendar,
          {
            candidateId: data.candidateAccountId,
            fragmentRef: data,
            onScheduled
          }
        ) })
      }
    );
  }
  if (data.status === "CANCELLED") {
    return /* @__PURE__ */ jsx296(
      InterviewDetailsContent,
      {
        header: /* @__PURE__ */ jsx296(
          PageTitle,
          {
            title: "You cancelled this interview",
            subTitle: "Contact the recruiter via Chat if this is in error"
          }
        ),
        content: /* @__PURE__ */ jsx296(Fragment77, {})
      }
    );
  }
  if (data.status === "DECLINED") {
    return /* @__PURE__ */ jsx296(
      InterviewDetailsContent,
      {
        header: /* @__PURE__ */ jsx296(
          PageTitle,
          {
            title: "You declined this interview",
            subTitle: "Contact the recruiter via Chat if this is in error"
          }
        ),
        content: /* @__PURE__ */ jsx296(Fragment77, {})
      }
    );
  }
  const scheduledAt = interview.scheduledAt ? /* @__PURE__ */ jsxs194("div", { className: "flex items-center gap-2 text-sm", children: [
    /* @__PURE__ */ jsx296("p", { className: "text-info-500 font-medium", children: format15(interview.scheduledAt, "MMM dd, yyy") }),
    /* @__PURE__ */ jsx296("p", { className: "text-info-500 font-medium", children: format15(interview.scheduledAt, "ppp") })
  ] }) : null;
  let type = "";
  if (data.type === "FACE_TO_FACE") {
    type = "(Face to Face)";
  } else if (data.type === "PHONE") {
    type = "(Phone)";
  } else if (data.type === "VIDEO") {
    type = "(Video)";
  }
  return /* @__PURE__ */ jsx296(
    InterviewDetailsContent,
    {
      header: /* @__PURE__ */ jsxs194("div", { className: "flex flex-wrap items-center justify-between", children: [
        /* @__PURE__ */ jsx296(PageTitle, { title: "Interview Scheduled", subTitle: scheduledAt }),
        type
      ] }),
      content: /* @__PURE__ */ jsxs194("div", { children: [
        data.location && /* @__PURE__ */ jsx296("div", { className: "flex items-center gap-2 p-3 sm:p-4", children: /* @__PURE__ */ jsx296("p", { className: "text-lg font-medium text-gray-900", children: formatDescription2(data.location) }) }),
        data.meeting && /* @__PURE__ */ jsx296("div", { className: "p-1 sm:p-4 m-2 border bg-gray", children: /* @__PURE__ */ jsx296(
          InterviewMeeting,
          {
            fragmentRef: data.meeting
          }
        ) }),
        /* @__PURE__ */ jsx296("div", { className: "p-1 sm:p-4", children: /* @__PURE__ */ jsxs194(ButtonList30, { children: [
          /* @__PURE__ */ jsx296(Button78, { color: "primary", clicked: () => setIsRescheduling(true), children: "Reschedule" }),
          /* @__PURE__ */ jsx296(Button78, { color: "gray", clicked: () => setCancelling(true), children: "Cancel" })
        ] }) })
      ] })
    }
  );
};

// src/interviews/components/CandidateInterviewDetails.tsx
import { Fragment as Fragment78, jsx as jsx297, jsxs as jsxs195 } from "react/jsx-runtime";
var fragmentDef69 = CandidateInterviewDetails_data_graphql_default;
var CandidateInterviewDetailsContent = ({ header, content }) => {
  return /* @__PURE__ */ jsxs195("div", { className: "flex flex-col gap-2", children: [
    /* @__PURE__ */ jsx297(PageHeader2, { children: header }),
    content
  ] });
};
var CandidateInterviewDetails = ({ fragmentRef }) => {
  const data = useFragment90(
    fragmentDef69,
    fragmentRef
  );
  const [isCancelling, setCancelling] = useState89(false);
  const [cancelInterview, isCancellingInterview] = useInterviewCancel(
    data.candidateAccountId,
    data.interviewId
  );
  const onCancel = useCallback166(async () => {
    const response = await cancelInterview();
    if (response?.node) {
    } else {
    }
  }, [cancelInterview]);
  const [inviteInterview, isInvitingInterview] = useInterviewInvite();
  const onInvite = useCallback166(async () => {
    const response = await inviteInterview(data.interviewId)();
    if (response?.node) {
    } else {
    }
  }, [data.interviewId, inviteInterview]);
  const interview = new Interview(
    data.scheduledToStartAt,
    data.declinedAt,
    data.cancelledAt
  );
  if (data.status === "SCHEDULED" && isCancelling) {
    return /* @__PURE__ */ jsx297(
      CandidateInterviewDetailsContent,
      {
        header: /* @__PURE__ */ jsx297(PageTitle2, { title: "Cancel your interview", subTitle: "Are you sure ?" }),
        content: /* @__PURE__ */ jsx297("div", { className: "p-1 sm:p-4", children: /* @__PURE__ */ jsxs195(ButtonList31, { children: [
          /* @__PURE__ */ jsx297(
            Button79,
            {
              color: "warning",
              disabled: isCancellingInterview,
              clicked: onCancel,
              children: "Yes, Cancel Now"
            }
          ),
          /* @__PURE__ */ jsx297(Button79, { color: "primary", clicked: () => setCancelling(false), children: "No, I don't want to Cancel" })
        ] }) })
      }
    );
  }
  if (data.status === "INVITED") {
    return /* @__PURE__ */ jsx297(
      CandidateInterviewDetailsContent,
      {
        header: /* @__PURE__ */ jsx297(PageTitle2, { title: `Interview ${data.code}` }),
        content: /* @__PURE__ */ jsx297("div", { className: "p-1 sm:p-4", children: "We're waiting for the Candidate to respond" })
      }
    );
  }
  if (data.status === "SCHEDULED") {
    return /* @__PURE__ */ jsx297(InterviewDetails, { fragmentRef: data });
  }
  if (data.status === "CANCELLED") {
    return /* @__PURE__ */ jsx297(
      CandidateInterviewDetailsContent,
      {
        header: /* @__PURE__ */ jsx297(
          PageTitle2,
          {
            title: "You cancelled this interview",
            subTitle: "Contact the recruiter via Chat if this is in error"
          }
        ),
        content: /* @__PURE__ */ jsx297(Fragment78, {})
      }
    );
  }
  if (data.status === "DECLINED") {
    return /* @__PURE__ */ jsx297(
      CandidateInterviewDetailsContent,
      {
        header: /* @__PURE__ */ jsx297(
          PageTitle2,
          {
            title: "You declined this interview",
            subTitle: "Contact the recruiter via Chat if this is in error"
          }
        ),
        content: /* @__PURE__ */ jsx297(Fragment78, {})
      }
    );
  }
  if (data.status === "CREATED") {
    return /* @__PURE__ */ jsx297(
      CandidateInterviewDetailsContent,
      {
        header: /* @__PURE__ */ jsx297(PageTitle2, { title: "Send Interview Request", subTitle: "Are you sure ?" }),
        content: /* @__PURE__ */ jsx297("div", { className: "p-1 sm:p-4", children: /* @__PURE__ */ jsx297(ButtonList31, { children: /* @__PURE__ */ jsx297("div", { children: /* @__PURE__ */ jsx297(
          Button79,
          {
            color: "warning",
            disabled: isInvitingInterview,
            clicked: onInvite,
            children: "Send to Candidate"
          }
        ) }) }) })
      }
    );
  }
  const scheduledAt = interview.scheduledAt ? /* @__PURE__ */ jsxs195("div", { className: "flex items-center gap-2 text-sm", children: [
    /* @__PURE__ */ jsx297("p", { className: "text-info-500 font-medium", children: format16(interview.scheduledAt, "MMM dd, yyy") }),
    /* @__PURE__ */ jsx297("p", { className: "text-info-500 font-medium", children: format16(interview.scheduledAt, "ppp") })
  ] }) : null;
  return /* @__PURE__ */ jsx297(
    CandidateInterviewDetailsContent,
    {
      header: /* @__PURE__ */ jsx297("div", { className: "flex flex-wrap items-center justify-between", children: /* @__PURE__ */ jsx297(PageTitle2, { title: `Interview ${data.code}`, subTitle: scheduledAt }) }),
      content: /* @__PURE__ */ jsxs195("div", { children: [
        data.description && /* @__PURE__ */ jsx297("div", { className: "flex items-center gap-2 p-3 sm:p-4", children: /* @__PURE__ */ jsx297("p", { className: "text-lg font-medium text-gray-900", children: data.description }) }),
        data.status,
        scheduledAt,
        /* @__PURE__ */ jsx297("div", { className: "p-1 sm:p-4", children: /* @__PURE__ */ jsx297(ButtonList31, { children: /* @__PURE__ */ jsx297(Button79, { color: "gray", clicked: () => setCancelling(true), children: "Cancel" }) }) })
      ] })
    }
  );
};

// src/interviews/components/CandidateInterview.tsx
import { Fragment as Fragment79, jsx as jsx298 } from "react/jsx-runtime";
var queryDef51 = CandidateInterviewRouteQuery_graphql_default;
async function loader26(environment, params) {
  const code = params.interviewCode;
  const interviewCode = parseInt(code);
  return loadQuery31(environment, queryDef51, {
    interviewCode
  });
}
var CandidateInterview = ({ routeId: routeId4 }) => {
  const data = useRouteData18(queryDef51, routeId4);
  const { interview } = data;
  if (!interview) {
    return /* @__PURE__ */ jsx298(Fragment79, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx298(Suspense98, { fallback: /* @__PURE__ */ jsx298(EdSkeleton88, {}), children: /* @__PURE__ */ jsx298("div", { className: "flex-1 border-b bg-white p-4", children: /* @__PURE__ */ jsx298(
    CandidateInterviewDetails,
    {
      fragmentRef: interview
    },
    interview.__id
  ) }) });
};
var createRoute21 = (routePrefix, environment, context) => {
  const routeId4 = `${routePrefix}-interview`;
  return {
    id: routeId4,
    path: ":interviewCode",
    element: /* @__PURE__ */ jsx298(CandidateInterview, { routeId: routeId4 }),
    loader: ({ params }) => {
      return loader26(environment, params);
    }
  };
};

// src/interviews/components/__generated__/CandidateInterviewsQuery.graphql.ts
var node337 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "applicationId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "order"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "order",
    "variableName": "order"
  }, v23 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 15
    },
    v1,
    {
      "fields": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "eq",
              "variableName": "applicationId"
            }
          ],
          "kind": "ObjectValue",
          "name": "applicationId"
        }
      ],
      "kind": "ObjectValue",
      "name": "where"
    }
  ], v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "type",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateInterviewsQuery",
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "applicationId",
              "variableName": "applicationId"
            },
            v1
          ],
          "kind": "FragmentSpread",
          "name": "CandidateInterviewList_interviews"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateInterviewsQuery",
      "selections": [
        {
          "alias": "interviews",
          "args": v23,
          "concreteType": "RecruitInterviewsConnection",
          "kind": "LinkedField",
          "name": "recruitInterviews",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitInterviewsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitInterview",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v32,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "interviewId",
                      "storageKey": null
                    },
                    v4,
                    v5,
                    v6,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "vacancyId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "applicationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "stage",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    v7,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "candidateAccountId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "scheduledToStartAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "declinedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "cancelledAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Vacancy",
                      "kind": "LinkedField",
                      "name": "vacancy",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "employerName",
                          "storageKey": null
                        },
                        v32
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "location",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CommunicationsInterviewMeeting",
                      "kind": "LinkedField",
                      "name": "meeting",
                      "plural": false,
                      "selections": [
                        v32,
                        v4,
                        v6,
                        v5,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "title",
                          "storageKey": null
                        },
                        v7,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "provider",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "sourceType",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "contentType",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "interviews",
          "args": v23,
          "filters": [],
          "handle": "connection",
          "key": "CandidateInterviewList_interviews",
          "kind": "LinkedHandle",
          "name": "recruitInterviews"
        }
      ]
    },
    "params": {
      "cacheID": "b2b01fc683e0f16bdbb0e21345ca69a6",
      "id": null,
      "metadata": {},
      "name": "CandidateInterviewsQuery",
      "operationKind": "query",
      "text": "query CandidateInterviewsQuery(\n  $applicationId: UUID!\n  $order: [RecruitInterviewSort!]\n) {\n  ...CandidateInterviewList_interviews_1iJDdp\n}\n\nfragment CandidateInterviewDetails_data on RecruitInterview {\n  id\n  interviewId\n  code\n  createdAt\n  updatedAt\n  candidateAccountId\n  scheduledToStartAt\n  declinedAt\n  cancelledAt\n  status\n  stage\n  type\n  description\n  ...InterviewCalendar_data\n  ...InterviewDetails_data\n}\n\nfragment CandidateInterviewList_interviews_1iJDdp on Query {\n  interviews: recruitInterviews(where: {applicationId: {eq: $applicationId}}, first: 15, order: $order) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        interviewId\n        code\n        updatedAt\n        createdAt\n        vacancyId\n        applicationId\n        employerId\n        stage\n        status\n        type\n        ...CandidateInterviewDetails_data\n        __typename\n      }\n    }\n  }\n}\n\nfragment InterviewCalendar_data on RecruitInterview {\n  id\n  interviewId\n  status\n  createdAt\n  scheduledToStartAt\n  declinedAt\n  cancelledAt\n  vacancy {\n    employerName\n    id\n  }\n}\n\nfragment InterviewDetails_data on RecruitInterview {\n  id\n  candidateAccountId\n  interviewId\n  createdAt\n  scheduledToStartAt\n  declinedAt\n  cancelledAt\n  status\n  stage\n  type\n  location\n  description\n  vacancy {\n    employerName\n    id\n  }\n  meeting {\n    ...InterviewMeeting_meeting\n    id\n  }\n  ...InterviewCalendar_data\n}\n\nfragment InterviewMeeting_meeting on CommunicationsInterviewMeeting {\n  id\n  code\n  createdAt\n  updatedAt\n  title\n  type\n  provider\n  sourceType\n  contentType\n}\n"
    }
  };
}();
node337.hash = "03080f1c0989884843057071bfe7a7dc";
var CandidateInterviewsQuery_graphql_default = node337;

// src/interviews/components/CandidateInterviews.tsx
import { Suspense as Suspense99, useCallback as useCallback168, useEffect as useEffect36 } from "react";
import {
  usePreloadedQuery as usePreloadedQuery33,
  useQueryLoader as useQueryLoader14
} from "react-relay";
import { EdSkeleton as EdSkeleton89 } from "shared-ui";

// src/interviews/components/__generated__/CandidateInterviewListPaginationQuery.graphql.ts
var node338 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "applicationId"
    },
    {
      "defaultValue": 15,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": {
        "updatedAt": "DESC"
      },
      "kind": "LocalArgument",
      "name": "order"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v23 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v32 = {
    "kind": "Variable",
    "name": "order",
    "variableName": "order"
  }, v4 = [
    v1,
    v23,
    v32,
    {
      "fields": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "eq",
              "variableName": "applicationId"
            }
          ],
          "kind": "ObjectValue",
          "name": "applicationId"
        }
      ],
      "kind": "ObjectValue",
      "name": "where"
    }
  ], v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "type",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateInterviewListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            {
              "kind": "Variable",
              "name": "applicationId",
              "variableName": "applicationId"
            },
            v23,
            v32
          ],
          "kind": "FragmentSpread",
          "name": "CandidateInterviewList_interviews"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateInterviewListPaginationQuery",
      "selections": [
        {
          "alias": "interviews",
          "args": v4,
          "concreteType": "RecruitInterviewsConnection",
          "kind": "LinkedField",
          "name": "recruitInterviews",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitInterviewsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitInterview",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v5,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "interviewId",
                      "storageKey": null
                    },
                    v6,
                    v7,
                    v8,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "vacancyId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "applicationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "stage",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    v9,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "candidateAccountId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "scheduledToStartAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "declinedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "cancelledAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Vacancy",
                      "kind": "LinkedField",
                      "name": "vacancy",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "employerName",
                          "storageKey": null
                        },
                        v5
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "location",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CommunicationsInterviewMeeting",
                      "kind": "LinkedField",
                      "name": "meeting",
                      "plural": false,
                      "selections": [
                        v5,
                        v6,
                        v8,
                        v7,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "title",
                          "storageKey": null
                        },
                        v9,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "provider",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "sourceType",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "contentType",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "interviews",
          "args": v4,
          "filters": [],
          "handle": "connection",
          "key": "CandidateInterviewList_interviews",
          "kind": "LinkedHandle",
          "name": "recruitInterviews"
        }
      ]
    },
    "params": {
      "cacheID": "d67f86f38a5296307674ca43ea9b1791",
      "id": null,
      "metadata": {},
      "name": "CandidateInterviewListPaginationQuery",
      "operationKind": "query",
      "text": "query CandidateInterviewListPaginationQuery(\n  $after: String\n  $applicationId: UUID\n  $first: Int = 15\n  $order: [RecruitInterviewSort!] = {updatedAt: DESC}\n) {\n  ...CandidateInterviewList_interviews_47MFKP\n}\n\nfragment CandidateInterviewDetails_data on RecruitInterview {\n  id\n  interviewId\n  code\n  createdAt\n  updatedAt\n  candidateAccountId\n  scheduledToStartAt\n  declinedAt\n  cancelledAt\n  status\n  stage\n  type\n  description\n  ...InterviewCalendar_data\n  ...InterviewDetails_data\n}\n\nfragment CandidateInterviewList_interviews_47MFKP on Query {\n  interviews: recruitInterviews(where: {applicationId: {eq: $applicationId}}, first: $first, after: $after, order: $order) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        interviewId\n        code\n        updatedAt\n        createdAt\n        vacancyId\n        applicationId\n        employerId\n        stage\n        status\n        type\n        ...CandidateInterviewDetails_data\n        __typename\n      }\n    }\n  }\n}\n\nfragment InterviewCalendar_data on RecruitInterview {\n  id\n  interviewId\n  status\n  createdAt\n  scheduledToStartAt\n  declinedAt\n  cancelledAt\n  vacancy {\n    employerName\n    id\n  }\n}\n\nfragment InterviewDetails_data on RecruitInterview {\n  id\n  candidateAccountId\n  interviewId\n  createdAt\n  scheduledToStartAt\n  declinedAt\n  cancelledAt\n  status\n  stage\n  type\n  location\n  description\n  vacancy {\n    employerName\n    id\n  }\n  meeting {\n    ...InterviewMeeting_meeting\n    id\n  }\n  ...InterviewCalendar_data\n}\n\nfragment InterviewMeeting_meeting on CommunicationsInterviewMeeting {\n  id\n  code\n  createdAt\n  updatedAt\n  title\n  type\n  provider\n  sourceType\n  contentType\n}\n"
    }
  };
}();
node338.hash = "5dd9a83d313fb50eca4dfb0ec3111c34";
var CandidateInterviewListPaginationQuery_graphql_default = node338;

// src/interviews/components/__generated__/CandidateInterviewList_interviews.graphql.ts
var node339 = function() {
  var v0 = [
    "interviews"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "applicationId"
      },
      {
        "defaultValue": 15,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "defaultValue": {
          "updatedAt": "DESC"
        },
        "kind": "LocalArgument",
        "name": "order"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": CandidateInterviewListPaginationQuery_graphql_default
      }
    },
    "name": "CandidateInterviewList_interviews",
    "selections": [
      {
        "alias": "interviews",
        "args": null,
        "concreteType": "RecruitInterviewsConnection",
        "kind": "LinkedField",
        "name": "__CandidateInterviewList_interviews_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitInterviewsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitInterview",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "interviewId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "vacancyId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "applicationId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "employerId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "stage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "type",
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "CandidateInterviewDetails_data"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node339.hash = "5dd9a83d313fb50eca4dfb0ec3111c34";
var CandidateInterviewList_interviews_graphql_default = node339;

// src/interviews/components/CandidateInterviewList.tsx
import { useCallback as useCallback167 } from "react";
import { usePaginationFragment as usePaginationFragment14 } from "react-relay";
import { jsx as jsx299 } from "react/jsx-runtime";
var fragmentDef70 = CandidateInterviewList_interviews_graphql_default;
var CandidateInterviewList = ({
  fragmentRef
}) => {
  const { data, loadNext, hasNext, isLoadingNext } = usePaginationFragment14(fragmentDef70, fragmentRef);
  const onLoadNext = useCallback167(() => {
    loadNext(10);
  }, [loadNext]);
  const { interviews } = data;
  const loadMore = useCallback167(() => {
    if (isLoadingNext) {
      return;
    }
    loadNext(5);
  }, [isLoadingNext, loadNext]);
  return /* @__PURE__ */ jsx299("div", { className: "flex flex-col gap-5 p-5", children: interviews?.edges?.map((edge) => {
    return /* @__PURE__ */ jsx299("div", { className: "border p-2", children: /* @__PURE__ */ jsx299(CandidateInterviewDetails, { fragmentRef: edge.node }) }, edge.node.id);
  }) });
};

// src/interviews/components/CandidateInterviews.tsx
import { jsx as jsx300 } from "react/jsx-runtime";
var queryDef52 = CandidateInterviewsQuery_graphql_default;
var order = [
  {
    updatedAt: "DESC"
  }
];
var CandidateInterviews = ({ applicationId }) => {
  const [queryReference, loadQuery48, disposeQuery] = useQueryLoader14(queryDef52);
  useEffect36(() => {
    loadQuery48({ applicationId, order }, { fetchPolicy: "network-only" });
  }, [loadQuery48, applicationId, order]);
  const onChanged = useCallback168(
    (options7) => {
      const order2 = {};
      order2[options7.sortField] = options7.sortDir;
      loadQuery48({
        applicationId,
        order: [order2]
      });
    },
    [loadQuery48, applicationId]
  );
  return /* @__PURE__ */ jsx300(Suspense99, { fallback: /* @__PURE__ */ jsx300(EdSkeleton89, {}), children: queryReference && /* @__PURE__ */ jsx300(CandidateInterviewListLoader, { queryRef: queryReference }) });
};
var CandidateInterviewListLoader = ({ queryRef: queryRef3 }) => {
  const data = usePreloadedQuery33(queryDef52, queryRef3);
  return /* @__PURE__ */ jsx300(CandidateInterviewList, { fragmentRef: data });
};

// src/interviews/components/InterviewContainer.tsx
import { Suspense as Suspense100, useCallback as useCallback169, useEffect as useEffect37 } from "react";
import { usePreloadedQuery as usePreloadedQuery34, useQueryLoader as useQueryLoader15 } from "react-relay";
import { EdSkeleton as EdSkeleton90, MobileHeader as MobileHeader4 } from "shared-ui";
import { Fragment as Fragment80, jsx as jsx301, jsxs as jsxs196 } from "react/jsx-runtime";
var InterviewContainer = ({
  interviewId,
  showExpand,
  showMobileNavigation = false
}) => {
  const [queryReference, loadQuery48] = useQueryLoader15(
    interviewLayoutQueryDef
  );
  useEffect37(() => {
    loadQuery48({ id: interviewId });
  }, [interviewId, loadQuery48]);
  const onReload = useCallback169(() => {
    loadQuery48({ id: interviewId }, { fetchPolicy: "network-only" });
  }, [loadQuery48]);
  if (!queryReference) {
    return /* @__PURE__ */ jsx301("div", { className: "m-8", children: /* @__PURE__ */ jsx301(EdSkeleton90, {}) });
  }
  return /* @__PURE__ */ jsxs196(Suspense100, { fallback: /* @__PURE__ */ jsx301(EdSkeleton90, {}), children: [
    /* @__PURE__ */ jsx301("div", { className: "flex flex-col lg:flex-col-reverse", children: showMobileNavigation && /* @__PURE__ */ jsx301(MobileHeaderNavigation2, { queryRef: queryReference }) }),
    /* @__PURE__ */ jsx301(InterviewLayout, { queryRef: queryReference, onReload })
  ] });
};
var MobileHeaderNavigation2 = ({
  queryRef: queryRef3,
  showExpand = true
}) => {
  const data = usePreloadedQuery34(
    interviewLayoutQueryDef,
    queryRef3
  );
  if (!queryRef3) {
    return /* @__PURE__ */ jsx301(Fragment80, {});
  }
  return /* @__PURE__ */ jsx301("div", { className: "flex flex-col-reverse md:flex-col", children: /* @__PURE__ */ jsx301(
    MobileHeader4,
    {
      showMobileNavIcon: true,
      title: /* @__PURE__ */ jsx301("div", { className: "flex w-full items-center justify-center lg:justify-between", children: /* @__PURE__ */ jsx301("div", { className: "text-2xl font-bold", children: data.interview?.vacancy.name || "" }) })
    }
  ) });
};

// src/interviews/components/__generated__/InterviewListPaginationQuery.graphql.ts
var node340 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 15,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v23 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v32 = [
    v1,
    v23,
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ], v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "InterviewListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v23
          ],
          "kind": "FragmentSpread",
          "name": "InterviewList_interviews"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "InterviewListPaginationQuery",
      "selections": [
        {
          "alias": "interviews",
          "args": v32,
          "concreteType": "RecruitInterviewsConnection",
          "kind": "LinkedField",
          "name": "recruitInterviews",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitInterviewsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitInterview",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v4,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "interviewId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "vacancyId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "applicationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "stage",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "type",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Vacancy",
                      "kind": "LinkedField",
                      "name": "vacancy",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "code",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "employerName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "employerLogoUrl",
                          "storageKey": null
                        },
                        v4
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "interviews",
          "args": v32,
          "filters": [],
          "handle": "connection",
          "key": "InterviewList_interviews",
          "kind": "LinkedHandle",
          "name": "recruitInterviews"
        }
      ]
    },
    "params": {
      "cacheID": "d89e56bad402e593f222def833b80580",
      "id": null,
      "metadata": {},
      "name": "InterviewListPaginationQuery",
      "operationKind": "query",
      "text": "query InterviewListPaginationQuery(\n  $after: String\n  $first: Int = 15\n  $where: RecruitInterviewFilter\n) {\n  ...InterviewList_interviews_2HEEH6\n}\n\nfragment InterviewList_interviews_2HEEH6 on Query {\n  interviews: recruitInterviews(where: $where, first: $first, after: $after) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        interviewId\n        vacancyId\n        applicationId\n        employerId\n        stage\n        status\n        type\n        vacancy {\n          name\n          code\n          employerName\n          employerLogoUrl\n          id\n        }\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node340.hash = "9777abca0bb0d12807de5f85b3cd9db1";
var InterviewListPaginationQuery_graphql_default = node340;

// src/interviews/components/__generated__/InterviewList_interviews.graphql.ts
var node341 = function() {
  var v0 = [
    "interviews"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 15,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": InterviewListPaginationQuery_graphql_default
      }
    },
    "name": "InterviewList_interviews",
    "selections": [
      {
        "alias": "interviews",
        "args": null,
        "concreteType": "RecruitInterviewsConnection",
        "kind": "LinkedField",
        "name": "__InterviewList_interviews_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitInterviewsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitInterview",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "interviewId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "vacancyId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "applicationId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "employerId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "stage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "type",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Vacancy",
                    "kind": "LinkedField",
                    "name": "vacancy",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "code",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "employerName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "employerLogoUrl",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node341.hash = "9777abca0bb0d12807de5f85b3cd9db1";
var InterviewList_interviews_graphql_default = node341;

// src/interviews/components/InterviewList.tsx
import { useCallback as useCallback170 } from "react";
import { usePaginationFragment as usePaginationFragment15 } from "react-relay";
import { DocumentIcon as DocumentIcon2 } from "@heroicons/react/24/outline";
import { SectionedLayout as SectionedLayout3, Tag as Tag17 } from "shared-ui";
import { isNotNullOrUndefined as isNotNullOrUndefined8 } from "shared-lib";
import { Fragment as Fragment81, jsx as jsx303, jsxs as jsxs197 } from "react/jsx-runtime";
var fragmentDef71 = InterviewList_interviews_graphql_default;
function vacancyName(name) {
  return /* @__PURE__ */ jsx303("div", { className: "truncate whitespace-pre-line break-all", title: name, children: name });
}
var InterviewStatusHeader = ({ status }) => {
  if (status === "INVITED") {
    return /* @__PURE__ */ jsx303("span", { children: "Invited" });
  }
  if (status === "SCHEDULED") {
    return /* @__PURE__ */ jsx303("span", { children: "Scheduled" });
  }
  if (status === "DECLINED") {
    return /* @__PURE__ */ jsx303("span", { children: "Declined" });
  }
  if (status === "CREATED") {
    return /* @__PURE__ */ jsx303("span", { children: "Pending" });
  }
  if (status === "CANCELLED") {
    return /* @__PURE__ */ jsx303("span", { children: "Cancelled" });
  }
  return /* @__PURE__ */ jsx303(Fragment81, {});
};
function interviewListHeader(interview) {
  return /* @__PURE__ */ jsxs197("div", { className: "flex w-full items-center", children: [
    /* @__PURE__ */ jsx303("div", { className: `flex w-full grow flex-col gap-1`, children: /* @__PURE__ */ jsxs197("div", { className: "flex flex-col gap-1", children: [
      /* @__PURE__ */ jsx303("div", { className: "text-primary-900", children: vacancyName(interview.vacancy.name) }),
      /* @__PURE__ */ jsx303("div", { className: "text-sm text-gray-900", children: interview.vacancy.employerName })
    ] }) }),
    /* @__PURE__ */ jsx303("div", { className: "flex flex-col gap-2 text-right", children: /* @__PURE__ */ jsx303(Tag17, { children: /* @__PURE__ */ jsx303(InterviewStatusHeader, { status: interview.status }) }) })
  ] });
}
function interviewItemHeader(interview) {
  let type = "";
  if (interview.type === "FACE_TO_FACE") {
    type = "(Face to Face)";
  } else if (interview.type === "PHONE") {
    type = "(Phone)";
  }
  return /* @__PURE__ */ jsx303("div", { className: "flex flex-1 flex-col gap-2 sm:flex-row  ", children: /* @__PURE__ */ jsx303("div", { className: "text-md items-top flex w-full flex-row justify-center text-center sm:justify-end lg:text-left", children: /* @__PURE__ */ jsxs197("div", { className: "flex w-full items-center text-xs lg:text-base", children: [
    /* @__PURE__ */ jsxs197("div", { className: "line-clamp-1 whitespace-nowrap text-sm lg:text-lg", children: [
      /* @__PURE__ */ jsx303("span", { className: "font-bold", children: interview.vacancy.name }),
      /* @__PURE__ */ jsx303("span", { className: "ml-1 text-xs md:text-sm", children: interview.vacancy.employerName })
    ] }),
    /* @__PURE__ */ jsxs197("div", { className: "ml-5 lg:text-sm", children: [
      "Stage ",
      interview.stage,
      " ",
      type
    ] }),
    /* @__PURE__ */ jsx303("div", {})
  ] }) }) });
}
var InterviewList = ({ fragmentRef }) => {
  const { data, loadNext, hasNext, isLoadingNext } = usePaginationFragment15(fragmentDef71, fragmentRef);
  const { interviews } = data;
  const sections = (interviews?.edges || []).filter(isNotNullOrUndefined8).map((interview) => {
    return {
      key: interview.node.interviewId,
      listTitle: interviewListHeader(interview.node),
      itemTitle: interviewItemHeader(interview.node),
      icon: () => {
        return /* @__PURE__ */ jsx303("div", { className: "", children: /* @__PURE__ */ jsx303("div", { className: "flex h-[30px] w-[30px] items-center justify-center", children: interview?.node.vacancy.employerLogoUrl == null ? /* @__PURE__ */ jsx303(DocumentIcon2, { className: "h-5 w-5 text-black" }) : /* @__PURE__ */ jsx303(
          "img",
          {
            src: interview?.node.vacancy.employerLogoUrl || "",
            className: "w-full"
          }
        ) }) });
      },
      iconForeground: "text-gray-700",
      iconBackground: "bg-gray-100",
      element: /* @__PURE__ */ jsx303(InterviewContainer, { interviewId: interview.node.interviewId })
    };
  });
  const loadMore = useCallback170(() => {
    if (isLoadingNext) {
      return;
    }
    loadNext(5);
  }, [isLoadingNext, loadNext]);
  return /* @__PURE__ */ jsx303(Fragment81, { children: /* @__PURE__ */ jsx303(
    SectionedLayout3,
    {
      expandLink: (id18) => `../interview/${id18}/info`,
      title: "Interviews",
      sections,
      loadMore: hasNext ? loadMore : () => 0,
      isLoading: isLoadingNext && hasNext,
      emptyState: /* @__PURE__ */ jsx303("div", { className: "m-8", children: /* @__PURE__ */ jsx303("h1", { className: "text-primary-500", children: "No Interviews Currently" }) })
    }
  ) });
};

// src/interviews/components/__generated__/InterviewsContainerQuery.graphql.ts
var node343 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 15
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "InterviewsContainerQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "InterviewList_interviews"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "InterviewsContainerQuery",
      "selections": [
        {
          "alias": "interviews",
          "args": v1,
          "concreteType": "RecruitInterviewsConnection",
          "kind": "LinkedField",
          "name": "recruitInterviews",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitInterviewsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitInterview",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v23,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "interviewId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "vacancyId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "applicationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "stage",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "type",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Vacancy",
                      "kind": "LinkedField",
                      "name": "vacancy",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "code",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "employerName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "employerLogoUrl",
                          "storageKey": null
                        },
                        v23
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "interviews",
          "args": v1,
          "filters": [],
          "handle": "connection",
          "key": "InterviewList_interviews",
          "kind": "LinkedHandle",
          "name": "recruitInterviews"
        }
      ]
    },
    "params": {
      "cacheID": "a822797190599a7fde233645e7d45c13",
      "id": null,
      "metadata": {},
      "name": "InterviewsContainerQuery",
      "operationKind": "query",
      "text": "query InterviewsContainerQuery(\n  $where: RecruitInterviewFilter!\n) {\n  ...InterviewList_interviews\n}\n\nfragment InterviewList_interviews on Query {\n  interviews: recruitInterviews(where: $where, first: 15) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        interviewId\n        vacancyId\n        applicationId\n        employerId\n        stage\n        status\n        type\n        vacancy {\n          name\n          code\n          employerName\n          employerLogoUrl\n          id\n        }\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node343.hash = "b40a83679049708530345ac6c97bb9e7";
var InterviewsContainerQuery_graphql_default = node343;

// src/interviews/components/InterviewsContainer.tsx
import { Suspense as Suspense101 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery43 } from "react-relay";
import { EdSkeleton as EdSkeleton91 } from "shared-ui";
import { jsx as jsx304 } from "react/jsx-runtime";
var graphqlQuery9 = InterviewsContainerQuery_graphql_default;
var InterviewsContainer = ({ candidateId }) => {
  let where = {};
  if (candidateId) {
    where = {
      candidateAccountId: { eq: candidateId }
    };
  }
  const query3 = useLazyLoadQuery43(
    graphqlQuery9,
    { where },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsx304(Suspense101, { fallback: /* @__PURE__ */ jsx304(EdSkeleton91, {}), children: /* @__PURE__ */ jsx304(InterviewList, { fragmentRef: query3 }) });
};

// src/interviews/components/NewInterviewForm.tsx
import { useCallback as useCallback171, useState as useState90 } from "react";
import { Button as Button80, ButtonList as ButtonList33, PageHeader as PageHeader3, TextArea as TextArea6 } from "shared-ui";
import { createClientMutationId as createClientMutationId76 } from "shared-lib";
import { jsx as jsx305, jsxs as jsxs198 } from "react/jsx-runtime";
var interviewTypes = [
  {
    label: "(Choose)",
    value: ""
  },
  {
    label: "Face To Face",
    value: "FACE_TO_FACE"
  },
  {
    label: "Video",
    value: "VIDEO"
  },
  {
    label: "Phone",
    value: "PHONE"
  }
];
var interviewStages = [
  {
    label: "(Choose)",
    value: 0
  },
  {
    label: "1st interview",
    value: 1
  },
  {
    label: "2nd stage interview",
    value: 2
  },
  {
    label: "3rd stage interview",
    value: 3
  },
  {
    label: "4th stage interview",
    value: 4
  }
];
var interviewDurations = [
  {
    label: "(Choose)",
    value: 0
  },
  {
    label: "15 min",
    value: 15
  },
  {
    label: "30 min",
    value: 30
  },
  {
    label: "45 min",
    value: 45
  },
  {
    label: "1 hour",
    value: 60
  }
];
var NewInterviewForm = ({
  applicationId,
  onCancel,
  onCreated
}) => {
  const [type, setType] = useState90(null);
  const [stage, setStage] = useState90(null);
  const [duration2, setDuration] = useState90(null);
  const [location2, setLocation] = useState90(null);
  const [create, isCreating] = useInterviewCreate();
  const [inviteInterview, isInvitingInterview] = useInterviewInvite();
  const onSendInterview = useCallback171(async () => {
    if (!type || type === "" || !stage || !duration2 || !location2) {
      return;
    }
    const interviewType = type;
    const input = {
      applicationId,
      clientMutationId: createClientMutationId76(),
      duration: duration2,
      location: location2,
      stage,
      type: interviewType,
      participationType: "MEETING",
      structure: "CONVERSATION"
    };
    const result = await create(input);
    if (result?.node) {
      await inviteInterview(result?.node.interviewId)();
      onCreated();
    }
  }, [type, stage, duration2, location2]);
  return /* @__PURE__ */ jsxs198("div", { className: "flex flex-col gap-2", children: [
    /* @__PURE__ */ jsx305(PageHeader3, { children: "New Interview" }),
    /* @__PURE__ */ jsxs198("div", { className: "flex flex-col gap-2", children: [
      /* @__PURE__ */ jsxs198("div", { className: "flex flex-col gap-2 pb-2", children: [
        /* @__PURE__ */ jsx305("label", { htmlFor: "type", children: "Type" }),
        /* @__PURE__ */ jsx305(
          "select",
          {
            id: "type",
            name: "type",
            defaultValue: type || void 0,
            className: "focus:ring-primary-500 focus:border-primary-500 block w-full rounded-md border-gray-300",
            onChange: (e4) => setType(e4.target.value),
            children: interviewTypes.map((i4) => /* @__PURE__ */ jsx305("option", { value: i4.value, children: i4.label }, i4.value))
          }
        )
      ] }),
      /* @__PURE__ */ jsxs198("div", { className: "flex flex-col gap-2 pb-2", children: [
        /* @__PURE__ */ jsx305("label", { htmlFor: "stage", children: "Stage" }),
        /* @__PURE__ */ jsx305(
          "select",
          {
            id: "stage",
            name: "stage",
            defaultValue: stage || void 0,
            className: "focus:ring-primary-500 focus:border-primary-500 block w-full rounded-md border-gray-300",
            onChange: (e4) => setStage(parseInt(e4.target.value)),
            children: interviewStages.map((i4) => /* @__PURE__ */ jsx305("option", { value: i4.value, children: i4.label }, i4.value))
          }
        )
      ] }),
      /* @__PURE__ */ jsxs198("div", { className: "flex flex-col gap-2 pb-2", children: [
        /* @__PURE__ */ jsx305("label", { htmlFor: "duration", children: "Duration" }),
        /* @__PURE__ */ jsx305(
          "select",
          {
            id: "duration",
            name: "duration",
            className: "focus:ring-primary-500 focus:border-primary-500 block w-full rounded-md border-gray-300",
            defaultValue: duration2 || void 0,
            onChange: (e4) => setDuration(parseInt(e4.target.value)),
            children: interviewDurations.map((i4) => /* @__PURE__ */ jsx305("option", { value: i4.value, children: i4.label }, i4.value))
          }
        )
      ] }),
      /* @__PURE__ */ jsxs198("div", { className: "flex flex-col gap-2 pb-2", children: [
        /* @__PURE__ */ jsx305("label", { htmlFor: "location", children: "Details" }),
        /* @__PURE__ */ jsx305(
          TextArea6,
          {
            id: "location",
            name: "location",
            value: location2 || "",
            rows: 3,
            className: "focus:border-info-500 focus:ring-info-500 block w-full overflow-hidden rounded-md border border-gray-300 shadow-sm sm:text-sm",
            placeholder: "Information about the Location",
            onValueChange: (text) => setLocation(text)
          }
        )
      ] }),
      /* @__PURE__ */ jsx305("div", { className: "mt-4 border-t pt-4", children: /* @__PURE__ */ jsxs198(ButtonList33, { children: [
        /* @__PURE__ */ jsx305("div", { children: /* @__PURE__ */ jsx305(Button80, { color: "gray", clicked: onCancel, children: "Cancel" }) }),
        /* @__PURE__ */ jsx305("div", { children: /* @__PURE__ */ jsx305(
          Button80,
          {
            color: "primary",
            disabled: !type || !stage || !duration2 || !location2 || isCreating || isInvitingInterview,
            clicked: onSendInterview,
            children: "Invite Candidate"
          }
        ) })
      ] }) })
    ] })
  ] });
};

// src/candidates/components/CandidateApplicationInterviews.tsx
import { Fragment as Fragment83, jsx as jsx306, jsxs as jsxs199 } from "react/jsx-runtime";
var queryDef53 = CandidateApplicationInterviewsRouteQuery_graphql_default;
async function loader27(environment, params) {
  const code = params.applicationCode;
  const applicationCode = parseInt(code);
  return loadQuery33(
    environment,
    queryDef53,
    {
      applicationCode
    }
  );
}
var InterviewsLayout = ({ routeId: routeId4 }) => {
  const data = useRouteData19(
    queryDef53,
    routeId4
  );
  const { application: application3 } = data;
  if (!application3) {
    return /* @__PURE__ */ jsx306(Fragment83, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx306(Suspense103, { fallback: /* @__PURE__ */ jsx306(EdSkeleton93, {}), children: /* @__PURE__ */ jsx306("div", { className: "", children: /* @__PURE__ */ jsx306(Outlet10, {}) }) });
};
var List = ({ routeId: routeId4 }) => {
  const navigate = useNavigate21();
  const data = useRouteData19(
    queryDef53,
    routeId4
  );
  const { application: application3 } = data;
  if (!application3) {
    return /* @__PURE__ */ jsx306(Fragment83, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx306(
    CandidateApplicationInterviewList,
    {
      applicationId: application3.applicationId,
      onClickNewInterview: () => {
        navigate("../create");
      }
    }
  );
};
function CandidateApplicationInterviewList({
  applicationId,
  onClickNewInterview
}) {
  return /* @__PURE__ */ jsxs199(Suspense103, { fallback: /* @__PURE__ */ jsx306(EdSkeleton93, {}), children: [
    /* @__PURE__ */ jsxs199("div", { className: "flex justify-between border-b bg-white p-4", children: [
      /* @__PURE__ */ jsx306("div", { className: "flex items-center", children: "Interviews" }),
      /* @__PURE__ */ jsxs199("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ jsx306(
          Link23,
          {
            className: "text-primary-500 text-md underline underline-offset-4",
            to: "/employers/app/account/calendar",
            children: "Update Availability"
          }
        ),
        /* @__PURE__ */ jsx306(
          Button81,
          {
            color: "primary",
            size: Size41.md,
            onClick: onClickNewInterview,
            children: "New Interview"
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ jsx306(CandidateInterviews, { applicationId })
  ] });
}
var Create = ({ routeId: routeId4 }) => {
  const navigate = useNavigate21();
  const data = useRouteData19(
    queryDef53,
    routeId4
  );
  const { application: application3 } = data;
  if (!application3) {
    return /* @__PURE__ */ jsx306(Fragment83, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsxs199(Suspense103, { fallback: /* @__PURE__ */ jsx306(EdSkeleton93, {}), children: [
    /* @__PURE__ */ jsxs199("div", { className: "flex justify-between border-b bg-white p-4", children: [
      /* @__PURE__ */ jsx306("div", { className: "flex items-center", children: "Create Interview" }),
      /* @__PURE__ */ jsx306("div", { className: "flex items-center gap-2", children: /* @__PURE__ */ jsx306(
        Link23,
        {
          className: "text-primary-500 text-md underline underline-offset-4",
          to: "/employers/app/account/calendar",
          children: "Update Availability"
        }
      ) })
    ] }),
    /* @__PURE__ */ jsx306("div", { className: "m-8 border bg-white p-4", children: /* @__PURE__ */ jsx306(
      NewInterviewForm,
      {
        applicationId: application3.applicationId,
        onCreated: () => {
          navigate("../list");
        },
        onCancel: () => {
          navigate("../list");
        }
      }
    ) })
  ] });
};
var createRoute22 = (routePrefix, environment, context) => {
  const routeId4 = `${routePrefix}-application-search-interviews`;
  return {
    id: routeId4,
    path: "interviews/*",
    element: /* @__PURE__ */ jsx306(InterviewsLayout, { routeId: routeId4 }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx306(Link23, { to: "interviews", children: "Interviews" })
    },
    loader: ({ params }) => {
      return loader27(environment, params);
    },
    children: [
      {
        id: `${routeId4}-list`,
        path: "list/*",
        element: /* @__PURE__ */ jsx306(List, { routeId: routeId4 }),
        children: [
          createRoute21(
            `${routeId4}-list`,
            environment,
            context
          )
        ]
      },
      {
        id: `${routeId4}-create`,
        path: "create/*",
        element: /* @__PURE__ */ jsx306(Create, { routeId: routeId4 })
      },
      {
        path: "*",
        element: /* @__PURE__ */ jsx306(Navigate12, { to: "list", replace: true })
      }
    ]
  };
};

// src/candidates/components/__generated__/ApplicationNotesEditorPaginationQuery.graphql.ts
var node344 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "applicationCode"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "after",
      "variableName": "after"
    },
    {
      "kind": "Variable",
      "name": "applicationCode",
      "variableName": "applicationCode"
    },
    {
      "kind": "Variable",
      "name": "first",
      "variableName": "first"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ApplicationNotesEditorPaginationQuery",
      "selections": [
        {
          "args": v1,
          "kind": "FragmentSpread",
          "name": "CandidateApplicationNotesEditor_notes"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ApplicationNotesEditorPaginationQuery",
      "selections": [
        {
          "alias": "notes",
          "args": v1,
          "concreteType": "RecruitApplicationNotesConnection",
          "kind": "LinkedField",
          "name": "recruitApplicationNotes",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitApplicationNotesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitApplicationNote",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "noteId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "content",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitApplicationNoteTag",
                      "kind": "LinkedField",
                      "name": "tags",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "value",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountsUser",
                      "kind": "LinkedField",
                      "name": "createdByUser",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "firstName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "lastName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "emailAddress",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "notes",
          "args": v1,
          "filters": [],
          "handle": "connection",
          "key": "CandidateApplicationNotesEditor_notes",
          "kind": "LinkedHandle",
          "name": "recruitApplicationNotes"
        }
      ]
    },
    "params": {
      "cacheID": "027f9fcf163a1fbbb940938bd8b7b2cd",
      "id": null,
      "metadata": {},
      "name": "ApplicationNotesEditorPaginationQuery",
      "operationKind": "query",
      "text": "query ApplicationNotesEditorPaginationQuery(\n  $after: String\n  $applicationCode: Int\n  $first: Int = 10\n) {\n  ...CandidateApplicationNotesEditor_notes_3vTWvv\n}\n\nfragment CandidateApplicationNotesEditor_notes_3vTWvv on Query {\n  notes: recruitApplicationNotes(applicationCode: $applicationCode, first: $first, after: $after) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        noteId\n        code\n        updatedAt\n        content\n        tags {\n          name\n          value\n        }\n        createdByUser {\n          firstName\n          lastName\n          emailAddress\n        }\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node344.hash = "291ff792d743d6bbc2f615ca9c9b8bb3";
var ApplicationNotesEditorPaginationQuery_graphql_default = node344;

// src/candidates/components/__generated__/CandidateApplicationNotesEditor_notes.graphql.ts
var node345 = function() {
  var v0 = [
    "notes"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "applicationCode"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": ApplicationNotesEditorPaginationQuery_graphql_default
      }
    },
    "name": "CandidateApplicationNotesEditor_notes",
    "selections": [
      {
        "alias": "notes",
        "args": null,
        "concreteType": "RecruitApplicationNotesConnection",
        "kind": "LinkedField",
        "name": "__CandidateApplicationNotesEditor_notes_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitApplicationNotesEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitApplicationNote",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "noteId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "content",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RecruitApplicationNoteTag",
                    "kind": "LinkedField",
                    "name": "tags",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "value",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AccountsUser",
                    "kind": "LinkedField",
                    "name": "createdByUser",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "firstName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lastName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "emailAddress",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node345.hash = "291ff792d743d6bbc2f615ca9c9b8bb3";
var CandidateApplicationNotesEditor_notes_graphql_default = node345;

// src/candidates/components/__generated__/CandidateApplicationNotesEditorQuery.graphql.ts
var node346 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "applicationCode"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "applicationCode",
    "variableName": "applicationCode"
  }, v23 = [
    v1,
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateApplicationNotesEditorQuery",
      "selections": [
        {
          "args": [
            v1
          ],
          "kind": "FragmentSpread",
          "name": "CandidateApplicationNotesEditor_notes"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateApplicationNotesEditorQuery",
      "selections": [
        {
          "alias": "notes",
          "args": v23,
          "concreteType": "RecruitApplicationNotesConnection",
          "kind": "LinkedField",
          "name": "recruitApplicationNotes",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitApplicationNotesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitApplicationNote",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "noteId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "content",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitApplicationNoteTag",
                      "kind": "LinkedField",
                      "name": "tags",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "value",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountsUser",
                      "kind": "LinkedField",
                      "name": "createdByUser",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "firstName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "lastName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "emailAddress",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "notes",
          "args": v23,
          "filters": [],
          "handle": "connection",
          "key": "CandidateApplicationNotesEditor_notes",
          "kind": "LinkedHandle",
          "name": "recruitApplicationNotes"
        }
      ]
    },
    "params": {
      "cacheID": "1858062c33abeb9d43926e7a9f0838c8",
      "id": null,
      "metadata": {},
      "name": "CandidateApplicationNotesEditorQuery",
      "operationKind": "query",
      "text": "query CandidateApplicationNotesEditorQuery(\n  $applicationCode: Int!\n) {\n  ...CandidateApplicationNotesEditor_notes_IzCDo\n}\n\nfragment CandidateApplicationNotesEditor_notes_IzCDo on Query {\n  notes: recruitApplicationNotes(applicationCode: $applicationCode, first: 10) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        noteId\n        code\n        updatedAt\n        content\n        tags {\n          name\n          value\n        }\n        createdByUser {\n          firstName\n          lastName\n          emailAddress\n        }\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node346.hash = "2200b782eee24eb51edaa83e22e4a259";
var CandidateApplicationNotesEditorQuery_graphql_default = node346;

// src/candidates/components/CandidateApplicationNotesEditor.tsx
import { useCallback as useCallback173 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery44, usePaginationFragment as usePaginationFragment16 } from "react-relay";
import { createClientMutationId as createClientMutationId77, parseDate as parseDate14 } from "shared-lib";
import { jsx as jsx307 } from "react/jsx-runtime";
var fragmentDef72 = CandidateApplicationNotesEditor_notes_graphql_default;
function toEditorNotes(data) {
  if (!data.notes?.edges) {
    return [];
  }
  const notes = data.notes.edges?.map((e4) => {
    return {
      ...e4.node,
      tags: [...e4.node.tags],
      updatedAt: parseDate14(e4.node.updatedAt)
    };
  });
  return notes;
}
function CandidateApplicationNotes({
  applicationCode,
  applicationId
}) {
  const query3 = useLazyLoadQuery44(
    CandidateApplicationNotes.query,
    {
      applicationCode
    }
  );
  return /* @__PURE__ */ jsx307(
    CandidateApplicationNotesEditor,
    {
      fragmentRef: query3,
      applicationId,
      applicationCode
    }
  );
}
CandidateApplicationNotes.query = CandidateApplicationNotesEditorQuery_graphql_default;
var CandidateApplicationNotesEditor = ({
  applicationId,
  applicationCode,
  fragmentRef
}) => {
  const { data, loadNext, hasNext, isLoadingNext, refetch } = usePaginationFragment16(fragmentDef72, fragmentRef);
  const [addNote, isAddingNote] = useAddApplicationNote();
  const [updateNote, isUpdatingNote] = useUpdateApplicationNote();
  const [deleteNote, isDeletingNote] = useDeleteApplicationNote();
  const onAdd = useCallback173(
    async (data2, onDone) => {
      const input = {
        applicationId,
        clientMutationId: createClientMutationId77(),
        content: data2.content,
        tags: data2.tags
      };
      await addNote({
        input
      });
      await refetch({ applicationCode }, { fetchPolicy: "network-only" });
      onDone();
    },
    [addNote, applicationId]
  );
  const onUpdated = useCallback173(
    async (note, onDone) => {
      const input = {
        clientMutationId: createClientMutationId77(),
        applicationNoteId: note.noteId,
        content: note.content,
        tags: note.tags
      };
      await updateNote({
        input
      });
      await refetch({ applicationCode }, { fetchPolicy: "network-only" });
      onDone();
    },
    [updateNote]
  );
  const onRemove = useCallback173(
    async (id18, onDone) => {
      const input = {
        clientMutationId: createClientMutationId77(),
        applicationNoteId: id18
      };
      await deleteNote({
        input
      });
      await refetch({ applicationCode }, { fetchPolicy: "network-only" });
      onDone();
    },
    [deleteNote]
  );
  const notes = toEditorNotes(data);
  return /* @__PURE__ */ jsx307("div", { className: "flex flex-col gap-2", children: /* @__PURE__ */ jsx307(
    NotesEditor,
    {
      isBusy: isAddingNote || isUpdatingNote || isDeletingNote,
      onAdd,
      onUpdated,
      onRemove,
      notes
    }
  ) });
};

// src/candidates/components/__generated__/CandidateApplicationTagsRouteQuery.graphql.ts
var node347 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "applicationCode"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "applicationCode",
    "variableName": "applicationCode"
  }, v23 = [
    v1
  ], v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "applicationId",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "vacancyName",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v9 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }, v10 = [
    v1,
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateApplicationTagsRouteQuery",
      "selections": [
        {
          "args": v23,
          "kind": "FragmentSpread",
          "name": "CandidateApplicationTagEditor_tags"
        },
        {
          "args": v23,
          "kind": "FragmentSpread",
          "name": "CandidateApplicationTagsComponentQuery"
        },
        {
          "alias": "application",
          "args": v23,
          "concreteType": "Application",
          "kind": "LinkedField",
          "name": "applicationByCode",
          "plural": false,
          "selections": [
            v32,
            v4,
            v5,
            v6,
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "candidate",
              "plural": false,
              "selections": [
                v7,
                v8
              ],
              "storageKey": null
            },
            v9
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateApplicationTagsRouteQuery",
      "selections": [
        {
          "alias": "tags",
          "args": v10,
          "concreteType": "RecruitApplicationTagsConnection",
          "kind": "LinkedField",
          "name": "recruitApplicationTags",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitApplicationTagsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitApplicationTag",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v32,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "tagId",
                      "storageKey": null
                    },
                    v4,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "tagName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "tagDataType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "tagValue",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountsUser",
                      "kind": "LinkedField",
                      "name": "createdByUser",
                      "plural": false,
                      "selections": [
                        v7,
                        v8,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "emailAddress",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v9
          ],
          "storageKey": null
        },
        {
          "alias": "tags",
          "args": v10,
          "filters": [],
          "handle": "connection",
          "key": "CandidateApplicationTagEditor_tags",
          "kind": "LinkedHandle",
          "name": "recruitApplicationTags"
        },
        {
          "alias": "application",
          "args": v23,
          "concreteType": "Application",
          "kind": "LinkedField",
          "name": "applicationByCode",
          "plural": false,
          "selections": [
            v32,
            v4,
            v5,
            v6,
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "candidate",
              "plural": false,
              "selections": [
                v7,
                v8,
                v32
              ],
              "storageKey": null
            },
            v9
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "31fd45ebef0349385ef65c1c7cfae28c",
      "id": null,
      "metadata": {},
      "name": "CandidateApplicationTagsRouteQuery",
      "operationKind": "query",
      "text": "query CandidateApplicationTagsRouteQuery(\n  $applicationCode: Int!\n) {\n  ...CandidateApplicationTagEditor_tags_IzCDo\n  ...CandidateApplicationTagsComponentQuery_IzCDo\n  application: applicationByCode(applicationCode: $applicationCode) {\n    id\n    code\n    applicationId\n    vacancyName\n    candidate {\n      firstName\n      lastName\n      id\n    }\n  }\n}\n\nfragment CandidateApplicationTagEditor_tags_IzCDo on Query {\n  tags: recruitApplicationTags(applicationCode: $applicationCode, first: 10) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        tagId\n        code\n        updatedAt\n        tagName\n        tagDataType\n        tagValue\n        createdByUser {\n          firstName\n          lastName\n          emailAddress\n        }\n        __typename\n      }\n    }\n  }\n}\n\nfragment CandidateApplicationTagsComponentQuery_IzCDo on Query {\n  ...CandidateApplicationTagEditor_tags_IzCDo\n  application: applicationByCode(applicationCode: $applicationCode) {\n    id\n    code\n    applicationId\n    vacancyName\n    candidate {\n      firstName\n      lastName\n      id\n    }\n  }\n}\n"
    }
  };
}();
node347.hash = "78229b77f653aa05657fb2e89d18d7e4";
var CandidateApplicationTagsRouteQuery_graphql_default = node347;

// src/candidates/components/__generated__/CandidateApplicationTagsComponentQuery.graphql.ts
var node348 = function() {
  var v0 = [
    {
      "kind": "Variable",
      "name": "applicationCode",
      "variableName": "applicationCode"
    }
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "applicationCode"
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CandidateApplicationTagsComponentQuery",
    "selections": [
      {
        "args": v0,
        "kind": "FragmentSpread",
        "name": "CandidateApplicationTagEditor_tags"
      },
      {
        "alias": "application",
        "args": v0,
        "concreteType": "Application",
        "kind": "LinkedField",
        "name": "applicationByCode",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "applicationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vacancyName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountsCandidateAccount",
            "kind": "LinkedField",
            "name": "candidate",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastName",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node348.hash = "9ebb3023aa3f5502a1e0319166bd4cd9";
var CandidateApplicationTagsComponentQuery_graphql_default = node348;

// src/candidates/components/CandidateApplicationTags.tsx
import { Suspense as Suspense104 } from "react";
import { loadQuery as loadQuery34, useFragment as useFragment91, useLazyLoadQuery as useLazyLoadQuery45 } from "react-relay";
import { Link as Link24 } from "react-router-dom";
import { useRouteData as useRouteData20 } from "shared-lib";
import { EdSkeleton as EdSkeleton94 } from "shared-ui";
import { Fragment as Fragment84, jsx as jsx308 } from "react/jsx-runtime";
var queryDef54 = CandidateApplicationTagsRouteQuery_graphql_default;
async function loader28(environment, params) {
  const code = params.applicationCode;
  const applicationCode = parseInt(code);
  return loadQuery34(environment, queryDef54, {
    applicationCode
  });
}
var CandidateApplicationTags = ({
  routeId: routeId4
}) => {
  const data = useRouteData20(
    queryDef54,
    routeId4
  );
  if (!data.application) {
    throw Error("ApplicationSearch Data Null");
  }
  const { application: application3 } = data;
  if (!application3) {
    return /* @__PURE__ */ jsx308(Fragment84, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx308(CandidateApplicationTagsComponent, { fragmentRef: data });
};
var CandidateApplicationTagsByApplicationCode = ({
  applicationCode
}) => {
  const query3 = useLazyLoadQuery45(queryDef54, {
    applicationCode
  });
  return /* @__PURE__ */ jsx308(CandidateApplicationTagsComponent, { fragmentRef: query3 });
};
function CandidateApplicationTagsComponent({
  fragmentRef
}) {
  const data = useFragment91(
    CandidateApplicationTagsComponent.fragments.query,
    fragmentRef
  );
  if (!data.application) {
    return /* @__PURE__ */ jsx308("div", { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx308(Suspense104, { fallback: /* @__PURE__ */ jsx308(EdSkeleton94, {}), children: /* @__PURE__ */ jsx308("div", { className: "grid gap-2 bg-white", children: /* @__PURE__ */ jsx308(
    CandidateApplicationTagEditor,
    {
      applicationId: data.application?.applicationId,
      applicationCode: data.application?.code,
      fragmentRef: data
    }
  ) }) });
}
CandidateApplicationTagsComponent.fragments = {
  query: CandidateApplicationTagsComponentQuery_graphql_default
};
var createRoute23 = (routePrefix, environment, context) => {
  const routeId4 = `${routePrefix}-application-search-tags`;
  return {
    id: routeId4,
    path: "tags",
    element: /* @__PURE__ */ jsx308(CandidateApplicationTags, { routeId: routeId4 }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx308(Link24, { to: "tags", children: "Tags" })
    },
    loader: ({ params }) => {
      return loader28(environment, params);
    }
  };
};

// src/candidates/components/__generated__/CandidateApplicationHistoryQuery.graphql.ts
var node349 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "candidateId"
    }
  ], v1 = [
    {
      "fields": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "eq",
              "variableName": "candidateId"
            }
          ],
          "kind": "ObjectValue",
          "name": "candidateId"
        }
      ],
      "kind": "ObjectValue",
      "name": "where"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "appliedAt",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "vacancyId",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "employerName",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateApplicationHistoryQuery",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "ApplicationsConnection",
          "kind": "LinkedField",
          "name": "applications",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ApplicationsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Application",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v23,
                    v32,
                    v4,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Vacancy",
                      "kind": "LinkedField",
                      "name": "vacancy",
                      "plural": false,
                      "selections": [
                        v5,
                        v6,
                        v7
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateApplicationHistoryQuery",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "ApplicationsConnection",
          "kind": "LinkedField",
          "name": "applications",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ApplicationsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Application",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v23,
                    v32,
                    v4,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Vacancy",
                      "kind": "LinkedField",
                      "name": "vacancy",
                      "plural": false,
                      "selections": [
                        v5,
                        v6,
                        v7,
                        v8
                      ],
                      "storageKey": null
                    },
                    v8
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "8b62398423ff9b9e481e3eee9acdf409",
      "id": null,
      "metadata": {},
      "name": "CandidateApplicationHistoryQuery",
      "operationKind": "query",
      "text": "query CandidateApplicationHistoryQuery(\n  $candidateId: UUID!\n) {\n  applications(where: {candidateId: {eq: $candidateId}}) {\n    edges {\n      node {\n        code\n        appliedAt\n        status\n        vacancy {\n          vacancyId\n          name\n          employerName\n          id\n        }\n        id\n      }\n    }\n  }\n}\n"
    }
  };
}();
node349.hash = "5760980bc6668d490e682299a11f2081";
var CandidateApplicationHistoryQuery_graphql_default = node349;

// src/candidates/components/CandidateApplicationHistory.tsx
import { useLazyLoadQuery as useLazyLoadQuery46 } from "react-relay";
import { formatDate as formatDate8 } from "shared-lib";
import { EdLink as EdLink18, Tag as Tag18, workflowLabelMap } from "shared-ui";
import { jsx as jsx309, jsxs as jsxs200 } from "react/jsx-runtime";
var queryDef55 = CandidateApplicationHistoryQuery_graphql_default;
var CandidateApplicationHistory = ({
  candidateId
}) => {
  const { applications } = useLazyLoadQuery46(
    queryDef55,
    {
      candidateId
    }
  );
  return /* @__PURE__ */ jsx309("div", { className: "flex flex-col gap-3", children: applications?.edges?.length === 0 ? /* @__PURE__ */ jsx309("div", { children: "No applications found" }) : /* @__PURE__ */ jsx309("div", { className: "divide-y rounded-lg border ", children: applications?.edges?.map(({ node: node566 }) => {
    return /* @__PURE__ */ jsx309("div", { className: "hover:bg-primary-50", children: /* @__PURE__ */ jsx309(
      EdLink18,
      {
        name: "vacancy",
        href: `/employers/app/applications/application/${node566.code}/relevance`,
        children: /* @__PURE__ */ jsxs200("div", { className: "grid grid-cols-2 p-5 lg:grid-cols-3", children: [
          /* @__PURE__ */ jsx309("div", { children: node566.vacancy.name }),
          /* @__PURE__ */ jsxs200("div", { children: [
            "Applied on: ",
            formatDate8(node566.appliedAt)
          ] }),
          /* @__PURE__ */ jsx309("div", { children: /* @__PURE__ */ jsx309(Tag18, { color: "bg-primary-100 my-1 lg:my-0", children: workflowLabelMap(node566.status) }) })
        ] })
      }
    ) }, node566.vacancy.vacancyId);
  }) }) });
};

// src/candidates/components/__generated__/CandidateRecommendationHistoryQuery.graphql.ts
var node350 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "candidateId"
    }
  ], v1 = [
    {
      "fields": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "eq",
              "variableName": "candidateId"
            }
          ],
          "kind": "ObjectValue",
          "name": "candidateId"
        }
      ],
      "kind": "ObjectValue",
      "name": "where"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdOn",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currentStatus",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "vacancyId",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "employerName",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateRecommendationHistoryQuery",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitRecommendationsConnection",
          "kind": "LinkedField",
          "name": "recruitRecommendations",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitRecommendationsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitRecommendation",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v23,
                    v32,
                    v4,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Vacancy",
                      "kind": "LinkedField",
                      "name": "vacancy",
                      "plural": false,
                      "selections": [
                        v5,
                        v6,
                        v7,
                        v4
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateRecommendationHistoryQuery",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitRecommendationsConnection",
          "kind": "LinkedField",
          "name": "recruitRecommendations",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitRecommendationsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitRecommendation",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v23,
                    v32,
                    v4,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Vacancy",
                      "kind": "LinkedField",
                      "name": "vacancy",
                      "plural": false,
                      "selections": [
                        v5,
                        v6,
                        v7,
                        v4,
                        v8
                      ],
                      "storageKey": null
                    },
                    v8
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "5f57d72de5a72ea4e8bf602e90d4ca2e",
      "id": null,
      "metadata": {},
      "name": "CandidateRecommendationHistoryQuery",
      "operationKind": "query",
      "text": "query CandidateRecommendationHistoryQuery(\n  $candidateId: UUID!\n) {\n  data: recruitRecommendations(where: {candidateId: {eq: $candidateId}}) {\n    edges {\n      node {\n        createdOn\n        currentStatus\n        code\n        vacancy {\n          vacancyId\n          name\n          employerName\n          code\n          id\n        }\n        id\n      }\n    }\n  }\n}\n"
    }
  };
}();
node350.hash = "504373c4948e2ff655c3bd1c7f67ebb5";
var CandidateRecommendationHistoryQuery_graphql_default = node350;

// src/candidates/components/CandidateRecommendationHistory.tsx
import { useLazyLoadQuery as useLazyLoadQuery47 } from "react-relay";
import { EdLink as EdLink19, Tag as Tag19 } from "shared-ui";
import { formatDate as formatDate9 } from "shared-lib";
import { jsx as jsx311, jsxs as jsxs201 } from "react/jsx-runtime";
var queryDef56 = CandidateRecommendationHistoryQuery_graphql_default;
var CandidateRecommendationHistory = ({
  candidateId
}) => {
  const { data } = useLazyLoadQuery47(
    queryDef56,
    {
      candidateId
    }
  );
  return /* @__PURE__ */ jsx311("div", { className: "flex flex-col gap-3", children: data?.edges?.length === 0 ? /* @__PURE__ */ jsx311("div", { children: "No recommendations found" }) : /* @__PURE__ */ jsx311("div", { className: "divide-y rounded-lg border ", children: data?.edges?.map(({ node: node566 }) => {
    return /* @__PURE__ */ jsx311("div", { className: "hover:bg-primary-50", children: /* @__PURE__ */ jsx311(
      EdLink19,
      {
        name: "vacancy",
        href: `/employers/app/vacancies/view/${node566.vacancy.code}/dashboard`,
        children: /* @__PURE__ */ jsxs201("div", { className: "grid grid-cols-2 items-center p-5 lg:grid-cols-3", children: [
          /* @__PURE__ */ jsx311("div", { children: node566.vacancy.name }),
          /* @__PURE__ */ jsxs201("div", { children: [
            "Recommended on: ",
            formatDate9(node566.createdOn)
          ] }),
          /* @__PURE__ */ jsx311("div", { children: /* @__PURE__ */ jsx311(Tag19, { color: `bg-primary-100`, className: `my-1 lg:my-0`, children: node566.currentStatus }) })
        ] })
      }
    ) }, node566.vacancy.vacancyId);
  }) }) });
};

// src/candidates/components/CandidateApplicationLayout.tsx
import { Fragment as Fragment85, jsx as jsx313, jsxs as jsxs203 } from "react/jsx-runtime";
var routeId3 = "application-search-home";
var candidateCandidateApplicationLayoutQueryDef = CandidateApplicationLayoutQuery_graphql_default;
var tabs5 = [
  // { name: 'Activity', to: 'activity' },
  { name: "Relevance", to: "relevance" },
  { name: "Work History", to: "profile" },
  { name: "Top Skills", to: "top-skills" },
  { name: "Details", to: "details" },
  { name: "Inbox", to: "inbox" },
  { name: "Interviews", to: "interviews" },
  { name: "Notes", to: "notes" },
  { name: "Tags", to: "tags" },
  { name: "Tasks", to: "tasks" },
  { name: "Documents", to: "documents" },
  { name: "Forms", to: "forms" },
  { name: "Offers", to: "offers" },
  { name: "Application History", to: "application-history" },
  { name: "Recommendation History", to: "recommendations" }
];
var CandidateApplicationLayout = ({ showHeader }) => {
  const [open, toggleOpen] = useToggle31(false);
  const preloadedQuery = useLoaderData4();
  const data = usePreloadedQuery35(
    candidateCandidateApplicationLayoutQueryDef,
    preloadedQuery
  );
  const { application: application3 } = data;
  const navigate = useNavigate23();
  const location2 = useLocation5();
  const tabLinks = tabs5.map((tab) => {
    return createLinkState5(location2, tab.name, tab.to);
  });
  const onGoToOffers = useCallback174(() => {
    navigate("../offers");
  }, [navigate]);
  if (!application3) {
    return /* @__PURE__ */ jsx313("div", { className: "flex h-full w-full items-center justify-center", children: /* @__PURE__ */ jsx313("div", { children: "Could not find application" }) });
  }
  const applicationSearch = data.applicationSearch.results[0];
  return /* @__PURE__ */ jsx313(Suspense105, { fallback: "Loading...", children: /* @__PURE__ */ jsxs203("div", { className: "@container flex flex-1 flex-col overflow-scroll", children: [
    showHeader && /* @__PURE__ */ jsxs203("div", { className: "flex flex-wrap items-center justify-between border-b bg-white", children: [
      /* @__PURE__ */ jsx313(DynamicBreadcrumb5, {}),
      /* @__PURE__ */ jsx313(
        EdLink20,
        {
          name: "vacancy-link",
          href: `/employers/app/vacancies/view/${application3.vacancy.code}/dashboard`,
          children: /* @__PURE__ */ jsxs203("div", { className: "flex items-baseline gap-3 px-2 sm:px-4", children: [
            /* @__PURE__ */ jsx313("div", { className: " text-gray-900", children: "Vacancy:" }),
            /* @__PURE__ */ jsx313("div", { className: "text-primary-500 uppercase", children: application3.vacancy.name }),
            /* @__PURE__ */ jsx313("div", { className: "text-primary-500 uppercase", children: application3.vacancy.employerReference })
          ] })
        }
      )
    ] }),
    /* @__PURE__ */ jsx313(
      ApplicationProfileHeader,
      {
        fragmentDef: applicationSearch.application,
        totalApplications: applicationSearch.totalApplicationsInVacancy,
        applicationRank: applicationSearch.rankInVacancy,
        showTabs: false
      }
    ),
    /* @__PURE__ */ jsx313("div", { className: "flex flex-wrap items-center justify-between gap-2 border-b bg-white px-5", children: /* @__PURE__ */ jsx313("div", { className: "w-full py-2", children: /* @__PURE__ */ jsx313(Tabs5, { tabs: tabLinks }) }) }),
    /* @__PURE__ */ jsx313(Outlet11, {}),
    /* @__PURE__ */ jsx313("div", { className: "relative", children: /* @__PURE__ */ jsx313(
      CandidateApplicationTagsDialog,
      {
        applicationCode: application3.code,
        isShowing: open,
        onClose: toggleOpen
      }
    ) })
  ] }) });
};
function ApplicationProfileHeader({
  fragmentDef: fragmentDef122,
  applicationRank,
  totalApplications,
  showTabs = true
}) {
  const registry = useLinkRegistry2();
  const [selectedTab, setSelectedTab] = useState91("");
  const [conversationKey, setConversationKey] = useState91(null);
  const session = useUserSessionContext6();
  const application3 = useFragment93(
    ApplicationProfileHeader.fragments.application,
    fragmentDef122
  );
  const applicationUrl = registry.applicationLink(application3.code);
  const accountType = fromAccountsUserAccountType(session.accountType);
  return /* @__PURE__ */ jsxs203("div", { className: "items-top flex flex-col justify-between border-b bg-white", children: [
    /* @__PURE__ */ jsxs203("div", { className: "flex flex-col gap-2 lg:px-5 lg:pt-5", children: [
      /* @__PURE__ */ jsxs203(
        RecruitProfileApplicationHeader,
        {
          fragmentRef: application3.profile,
          applicationUrl,
          applicationRank,
          applicationTotal: totalApplications,
          children: [
            /* @__PURE__ */ jsx313("strong", { children: /* @__PURE__ */ jsx313(RightToWorkStatus, { status: application3.rightToWorkStatus }) }),
            application3.profile.rate && /* @__PURE__ */ jsx313("div", { className: "flex w-full justify-start ", children: /* @__PURE__ */ jsx313(RateLabel, { rate: application3.profile.rate }) }),
            /* @__PURE__ */ jsxs203("div", { className: "text-sm", children: [
              "Applied on:",
              " ",
              application3.createdAt && parseDate15(application3.createdAt).toLocaleDateString()
            ] }),
            /* @__PURE__ */ jsx313("div", { children: /* @__PURE__ */ jsx313(Tag20, { className: "border-primary-400 border", children: workflowLabelMap2(application3.workflowStateName) }) })
          ]
        }
      ),
      /* @__PURE__ */ jsx313(
        MatchRelevanceProvider,
        {
          sentences: [],
          matchProfileFragmentRef: application3.matchProfile,
          matchRelevanceFragmentRef: application3.matchRelevance,
          vacancyFragmentRef: application3.vacancy,
          children: /* @__PURE__ */ jsx313(MatchRelevanceScores, {})
        }
      )
    ] }),
    /* @__PURE__ */ jsxs203("div", { className: "flex flex-col-reverse items-start justify-between gap-2 pt-3", children: [
      showTabs && /* @__PURE__ */ jsx313("div", { className: "flex w-full flex-wrap gap-1 border-t bg-gray-100 py-2 pl-3", children: tabs5.map((tab) => /* @__PURE__ */ jsx313(
        "div",
        {
          onClick: () => {
            if (selectedTab === tab.name) {
              setSelectedTab("");
            } else {
              setSelectedTab(tab.name);
            }
          },
          children: /* @__PURE__ */ jsx313(
            Tag20,
            {
              color: classNames36(tab.name == selectedTab ? "" : "white"),
              className: "cursor-pointer hover:bg-gray-400 hover:text-white",
              children: tab.name
            }
          )
        },
        tab.name
      )) }),
      /* @__PURE__ */ jsxs203("div", { className: "flex w-full flex-col gap-3 px-4 pb-2 md:flex-row md:justify-between", children: [
        /* @__PURE__ */ jsx313("div", { className: "flex self-end", children: /* @__PURE__ */ jsx313(
          DeferredResumeDownload,
          {
            profileId: application3.profile.recruitProfileId
          }
        ) }),
        /* @__PURE__ */ jsx313(
          CandidateApplicationWorkflowContainer,
          {
            fragmentRef: application3,
            candidateId: application3.candidate.accountId,
            employerId: application3.employerId,
            applicationId: application3.applicationId,
            applicationVersion: application3.version,
            vacancyId: application3.vacancy.vacancyId,
            accountType,
            onOffer: noop10
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ jsx313(Suspense105, { fallback: /* @__PURE__ */ jsx313("div", { children: "Loading..." }), children: /* @__PURE__ */ jsxs203("div", { className: "w-full", children: [
      selectedTab === "Relevance" && /* @__PURE__ */ jsx313("div", { className: "p-5", children: /* @__PURE__ */ jsx313(
        CandidateApplicationRelevanceComponent,
        {
          fragmentRef: application3
        }
      ) }),
      selectedTab === "Work History" && /* @__PURE__ */ jsx313(
        CandidateApplicationProfileComponent,
        {
          fragmentDef: application3.profile
        }
      ),
      selectedTab === "Details" && /* @__PURE__ */ jsx313(
        DetailsComponent,
        {
          profileFragmentRef: application3.profile,
          candidateFragmentRef: application3.candidate
        }
      ),
      selectedTab === "Top Skills" && /* @__PURE__ */ jsx313("div", { className: "p-5", children: /* @__PURE__ */ jsx313(ProfileWorkTimelineDef, { fragmentRef: application3.profile }) }),
      selectedTab === "Inbox" && /* @__PURE__ */ jsxs203("div", { className: "p-5", children: [
        !conversationKey && /* @__PURE__ */ jsx313(
          ApplicationChat,
          {
            applicationId: application3.applicationId,
            onSelect: (x4) => setConversationKey(x4)
          }
        ),
        conversationKey && /* @__PURE__ */ jsxs203("div", { children: [
          /* @__PURE__ */ jsx313(
            Button83,
            {
              onClick: () => setConversationKey(null),
              color: "primary",
              className: "mb-3",
              children: "Back"
            }
          ),
          /* @__PURE__ */ jsx313(
            ApplicationConversationContainer,
            {
              showBackButton: false,
              chatId: conversationKey
            }
          )
        ] })
      ] }),
      selectedTab === "Tasks" && /* @__PURE__ */ jsx313(
        CandidateApplicationTasksComponent,
        {
          candidateId: application3.candidateId,
          applicationId: application3.applicationId
        }
      ),
      selectedTab === "Documents" && /* @__PURE__ */ jsx313(CandidateApplicationDocumentsComponent, { fragmentRef: application3 }),
      selectedTab === "Forms" && /* @__PURE__ */ jsx313(CandidateApplicationFormsComponent, { fragmentRef: application3 }),
      selectedTab === "Offers" && /* @__PURE__ */ jsx313(OfferList, { applicationId: application3.applicationId }),
      selectedTab === "Interviews" && /* @__PURE__ */ jsx313(Fragment85, { children: /* @__PURE__ */ jsx313(InterviewTab, { applicationId: application3.applicationId }) }),
      selectedTab === "Notes" && /* @__PURE__ */ jsx313(
        CandidateApplicationNotes,
        {
          applicationId: application3.applicationId,
          applicationCode: application3.code
        }
      ),
      selectedTab === "Tags" && /* @__PURE__ */ jsx313("div", { className: "p-5", children: /* @__PURE__ */ jsx313(
        CandidateApplicationTagsByApplicationCode,
        {
          applicationCode: application3.code
        }
      ) }),
      selectedTab === "Application History" && /* @__PURE__ */ jsx313("div", { className: "bg-white p-5", children: /* @__PURE__ */ jsx313(
        CandidateApplicationHistory,
        {
          candidateId: application3.candidateId
        }
      ) }),
      selectedTab === "Recommendation History" && /* @__PURE__ */ jsx313("div", { className: "bg-white p-5", children: /* @__PURE__ */ jsx313(
        CandidateRecommendationHistory,
        {
          candidateId: application3.candidateId
        }
      ) })
    ] }) })
  ] });
}
ApplicationProfileHeader.fragments = {
  application: CandidateApplicationLayout_applicationSearchResult_graphql_default
};
function InterviewTab({ applicationId }) {
  const [newInterviewSelected, toggleNewInterviewSelected] = useToggle31(false);
  return /* @__PURE__ */ jsxs203("div", { children: [
    !newInterviewSelected && /* @__PURE__ */ jsx313(
      CandidateApplicationInterviewList,
      {
        applicationId,
        onClickNewInterview: toggleNewInterviewSelected
      }
    ),
    newInterviewSelected && /* @__PURE__ */ jsx313("div", { className: "p-5", children: /* @__PURE__ */ jsx313(
      NewInterviewForm,
      {
        applicationId,
        onCancel: toggleNewInterviewSelected,
        onCreated: toggleNewInterviewSelected
      }
    ) })
  ] });
}
var CandidateApplicationLink = ({ routeId: routeId4, label }) => {
  const data = useApplicationSearchRouteData(routeId4);
  if (!data.application) {
    return /* @__PURE__ */ jsx313(Fragment85, {});
  }
  const name = `${data.application.candidate.firstName} ${data.application.candidate.lastName}`;
  return /* @__PURE__ */ jsx313(Suspense105, { fallback: "Loading...", children: /* @__PURE__ */ jsx313(Link25, { to: ".", children: label || name }) });
};
async function loader29(environment, params) {
  const code = params.applicationCode;
  const applicationCode = parseInt(code);
  return loadQuery35(
    environment,
    candidateCandidateApplicationLayoutQueryDef,
    {
      applicationCode
    }
  );
}
function useApplicationSearchRouteData(routeId4) {
  const queryRef3 = useRouteLoaderData15(
    routeId4
  );
  const data = usePreloadedQuery35(
    candidateCandidateApplicationLayoutQueryDef,
    queryRef3
  );
  return data;
}

// src/candidates/components/VacancyApplicationSearchListResults.tsx
import { jsx as jsx314, jsxs as jsxs204 } from "react/jsx-runtime";
var fragmentDef73 = VacancyApplicationSearchListResults_results_graphql_default;
var VacancyApplicationSearchListResults = ({
  fragmentRef
}) => {
  const result = useFragment94(
    fragmentDef73,
    fragmentRef
  );
  if (!result) {
    return /* @__PURE__ */ jsx314(EdCard, {});
  }
  return /* @__PURE__ */ jsx314(
    Suspense106,
    {
      fallback: /* @__PURE__ */ jsx314("div", { className: "py-20", children: /* @__PURE__ */ jsx314(Loading8, { label: "Loading Applications" }) }),
      children: /* @__PURE__ */ jsxs204("div", { className: "flex grow flex-col gap-5", children: [
        result.results?.length == 0 && /* @__PURE__ */ jsx314("div", { className: "flex h-[400px] items-center justify-center rounded-2xl border-2 border-dashed text-center text-2xl text-gray-700", children: "No applications found" }),
        result.results?.map((x4) => /* @__PURE__ */ jsx314(
          "div",
          {
            className: "overflow-hidden rounded-2xl shadow-md",
            children: /* @__PURE__ */ jsx314(
              ApplicationProfileHeader,
              {
                fragmentDef: x4.application,
                applicationRank: x4.rankInVacancy,
                totalApplications: x4.totalApplicationsInVacancy
              }
            )
          },
          x4.application.code
        ))
      ] })
    }
  );
};

// src/candidates/components/__generated__/VacancyApplicationSearchFilters_results.graphql.ts
var node351 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VacancyApplicationSearchFilters_results",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ApplicationSearchAggregations",
      "kind": "LinkedField",
      "name": "aggregations",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "VacancyApplicationSearchFacets_aggregations"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "StandardAggregationResults",
          "kind": "LinkedField",
          "name": "standard",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "VacancyApplicationSearchFacets_results"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__id",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "ApplicationSearchResults",
  "abstractKey": null
};
node351.hash = "f44686df2646543ebc9ddc5a36ff769c";
var VacancyApplicationSearchFilters_results_graphql_default = node351;

// src/candidates/components/VacancyApplicationSearchFilters.tsx
import { Suspense as Suspense107 } from "react";
import { useFragment as useFragment96 } from "react-relay";

// src/candidates/components/__generated__/VacancyApplicationSearchFacets_aggregations.graphql.ts
var node353 = function() {
  var v0 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "count",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MultiFacetContainer_facet"
    }
  ];
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "VacancyApplicationSearchFacets_aggregations",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StandardAggregationResults",
        "kind": "LinkedField",
        "name": "standard",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "VacancyApplicationSearchFacets_results"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DefaultAggregationModel",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": v0,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DefaultAggregationModel",
        "kind": "LinkedField",
        "name": "dateCreated",
        "plural": false,
        "selections": v0,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DefaultAggregationModel",
        "kind": "LinkedField",
        "name": "vacancy",
        "plural": false,
        "selections": v0,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DefaultAggregationModel",
        "kind": "LinkedField",
        "name": "applicationState",
        "plural": false,
        "selections": v0,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DefaultAggregationModel",
        "kind": "LinkedField",
        "name": "currentState",
        "plural": false,
        "selections": v0,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DefaultAggregationModel",
        "kind": "LinkedField",
        "name": "industryExperienceRelevance",
        "plural": false,
        "selections": v0,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DefaultAggregationModel",
        "kind": "LinkedField",
        "name": "industryRecencyRelevance",
        "plural": false,
        "selections": v0,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DefaultAggregationModel",
        "kind": "LinkedField",
        "name": "jobExperienceRelevance",
        "plural": false,
        "selections": v0,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DefaultAggregationModel",
        "kind": "LinkedField",
        "name": "jobRecencyRelevance",
        "plural": false,
        "selections": v0,
        "storageKey": null
      }
    ],
    "type": "ApplicationSearchAggregations",
    "abstractKey": null
  };
}();
node353.hash = "3cec3ab7a09ff498718ebd1612075c72";
var VacancyApplicationSearchFacets_aggregations_graphql_default = node353;

// src/candidates/components/__generated__/VacancyApplicationSearchFacets_results.graphql.ts
var node354 = function() {
  var v0 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "count",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MultiFacetContainer_facet"
    }
  ];
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "VacancyApplicationSearchFacets_results",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "ProfileSkillsFacetsContainer_facets"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DefaultAggregationModel",
        "kind": "LinkedField",
        "name": "companies",
        "plural": false,
        "selections": v0,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DefaultAggregationModel",
        "kind": "LinkedField",
        "name": "industries",
        "plural": false,
        "selections": v0,
        "storageKey": null
      }
    ],
    "type": "StandardAggregationResults",
    "abstractKey": null
  };
}();
node354.hash = "f22e313f5a09f169fa2c4e9f2f658989";
var VacancyApplicationSearchFacets_results_graphql_default = node354;

// src/candidates/components/VacancyApplicationSearchFacets.tsx
import { createContext as createContext11, useCallback as useCallback175, useContext as useContext11, useState as useState93 } from "react";
import { useFragment as useFragment95 } from "react-relay";
import { useAtomValue as useAtomValue12 } from "jotai";
import { useAtom as useAtom13 } from "jotai/index";
import {
  FilterSectionContainer as FilterSectionContainer4,
  FilterSectionLink as FilterSectionLink4
} from "shared-ui";
import { MultiFacetContainer as MultiFacetContainer6 } from "app-core";
import { noop as noop11 } from "shared-lib";
import { jsx as jsx315, jsxs as jsxs205 } from "react/jsx-runtime";
var defaultAggregationFacetsFragment2 = VacancyApplicationSearchFacets_aggregations_graphql_default;
var fragmentDef74 = VacancyApplicationSearchFacets_results_graphql_default;
var VacancyApplicationSearchFacetsContext = createContext11([
  { key: "skills", title: "Skills" },
  { key: "Companies", title: "Companies" },
  { key: "Industries", title: "Industries" },
  { key: "Vacancy", title: "Vacancy" },
  { key: "Project", title: "Project" },
  { key: "Application Created Date", title: "Application Created Date" },
  { key: "Application State", title: "Application State" },
  { key: "Current State", title: "Current State" },
  {
    key: "Industry Experience Relevance",
    title: "Industry Experience Relevance"
  },
  { key: "Job Experience Relevance", title: "Job Experience Relevance" },
  { key: "Job Recency Relevance", title: "Job Recency Relevance" }
]);
var VacancyApplicationSearchFacets = ({
  fragmentRef,
  onSearch
}) => {
  const defaultAggregatons = useFragment95(
    defaultAggregationFacetsFragment2,
    fragmentRef
  );
  const data = useFragment95(
    fragmentDef74,
    defaultAggregatons.standard
  );
  const search4 = useAtomValue12(applicationSearchAtom);
  const [context, setContext] = useAtom13(vacancyApplicationSearchContextAtom);
  const filterSections4 = useContext11(VacancyApplicationSearchFacetsContext);
  const toggleOpen = useCallback175(() => {
    setContext({
      ...context,
      isFiltersOpen: !context.isFiltersOpen
    });
  }, [context, setContext]);
  const [selectedSection, setSelectedSection] = useState93(null);
  const sections = filterSections4.map((s4) => {
    return /* @__PURE__ */ jsx315(
      FilterSectionLink4,
      {
        section: s4,
        onSelect: setSelectedSection,
        selectedKey: selectedSection
      },
      s4.key
    );
  });
  const onChanged = useCallback175(
    (standard) => {
      const newSearch = {
        ...search4,
        filters: {
          ...search4.filters,
          standard
        }
      };
      onSearch("VacancyApplicationProfileFacets - onChanged", newSearch);
    },
    [search4, onSearch]
  );
  const onChangedFilters = useCallback175(
    (filters) => {
      const newSearch = {
        ...search4,
        filters
      };
      onSearch("VacancyApplicationProfileFacets onChangedFilters", newSearch);
    },
    [search4, onSearch]
  );
  const onSkillsChanged = useCallback175(
    (skills) => {
      const newSearch = {
        ...search4,
        filters: {
          ...search4.filters,
          standard: {
            ...search4.filters?.standard,
            skills
          }
        }
      };
      onSearch("VacancyApplicationProfileFacets", newSearch);
    },
    [search4, onSearch]
  );
  return /* @__PURE__ */ jsxs205(
    FilterSectionContainer4,
    {
      sections,
      isFiltersOpen: true,
      onToggleOpen: noop11,
      hasSelectedValue: selectedSection !== null,
      toggleSelectedValue: () => setSelectedSection(null),
      children: [
        selectedSection === "skills" && /* @__PURE__ */ jsx315(
          ProfileSkillsFacetsContainer,
          {
            fragmentRef: data,
            onChanged: onSkillsChanged
          }
        ),
        selectedSection === "Companies" && /* @__PURE__ */ jsx315(
          MultiFacetContainer6,
          {
            fragmentRef: data.companies,
            onFacetChanged: (companies) => {
              onChanged({
                ...search4.filters?.standard,
                companies
              });
            }
          }
        ),
        selectedSection === "Industries" && /* @__PURE__ */ jsx315(
          MultiFacetContainer6,
          {
            fragmentRef: data.industries,
            onFacetChanged: (industries) => {
              onChanged({
                ...search4.filters?.standard,
                industries
              });
            }
          }
        ),
        selectedSection === "Project" && /* @__PURE__ */ jsx315(
          MultiFacetContainer6,
          {
            fragmentRef: defaultAggregatons.project,
            onFacetChanged: (projects) => {
              onChangedFilters({
                ...search4.filters,
                projects
              });
            }
          }
        ),
        selectedSection === "Vacancy" && /* @__PURE__ */ jsx315(
          MultiFacetContainer6,
          {
            fragmentRef: defaultAggregatons.vacancy,
            onFacetChanged: (vacancies) => {
              onChangedFilters({
                ...search4.filters,
                vacancies: {
                  byId: vacancies
                }
              });
            }
          }
        ),
        selectedSection === "Application Created Date" && /* @__PURE__ */ jsx315(
          MultiFacetContainer6,
          {
            fragmentRef: defaultAggregatons.dateCreated,
            onFacetChanged: (dateCreated) => {
              const items = dateCreated.filter(
                (x4) => x4 !== search4.filters?.dateCreated
              );
              onChangedFilters({
                ...search4.filters,
                dateCreated: items[0]
              });
            }
          }
        ),
        selectedSection === "Application State" && /* @__PURE__ */ jsx315(
          MultiFacetContainer6,
          {
            fragmentRef: defaultAggregatons.applicationState,
            onFacetChanged: (applicationState) => {
              onChangedFilters({
                ...search4.filters,
                applicationStates: applicationState
              });
            }
          }
        ),
        selectedSection === "Current State" && /* @__PURE__ */ jsx315(
          MultiFacetContainer6,
          {
            fragmentRef: defaultAggregatons.currentState,
            onFacetChanged: (currentStates) => {
              onChangedFilters({
                ...search4.filters,
                currentStates
              });
            }
          }
        ),
        selectedSection === "Industry Experience Relevance" && /* @__PURE__ */ jsx315(
          MultiFacetContainer6,
          {
            fragmentRef: defaultAggregatons.industryExperienceRelevance,
            onFacetChanged: (industryExperienceRelevance) => {
              const currentValue = search4.filters?.industryExperienceRelevance;
              onChangedFilters({
                ...search4.filters,
                industryExperienceRelevance: industryExperienceRelevance.filter(
                  (x4) => x4 !== currentValue
                )[0]
              });
            }
          }
        ),
        selectedSection === "Industry Recency Relevance" && /* @__PURE__ */ jsx315(
          MultiFacetContainer6,
          {
            fragmentRef: defaultAggregatons.industryRecencyRelevance,
            onFacetChanged: (industryRecencyRelevance) => {
              const currentValue = search4.filters?.industryRecencyRelevance;
              onChangedFilters({
                ...search4.filters,
                industryRecencyRelevance: industryRecencyRelevance.filter(
                  (x4) => x4 !== currentValue
                )[0]
              });
            }
          }
        ),
        selectedSection === "Job Experience Relevance" && /* @__PURE__ */ jsx315(
          MultiFacetContainer6,
          {
            fragmentRef: defaultAggregatons.jobExperienceRelevance,
            onFacetChanged: (jobExperienceRelevance) => {
              const currentValue = search4.filters?.jobExperienceRelevance;
              onChangedFilters({
                ...search4.filters,
                jobExperienceRelevance: jobExperienceRelevance.filter(
                  (x4) => x4 !== currentValue
                )[0]
              });
            }
          }
        ),
        selectedSection === "Job Recency Relevance" && /* @__PURE__ */ jsx315(
          MultiFacetContainer6,
          {
            fragmentRef: defaultAggregatons.jobRecencyRelevance,
            onFacetChanged: (jobRecencyRelevance) => {
              const currentValue = search4.filters?.jobRecencyRelevance;
              onChangedFilters({
                ...search4.filters,
                jobRecencyRelevance: jobRecencyRelevance.filter(
                  (x4) => x4 !== currentValue
                )[0]
              });
            }
          }
        )
      ]
    }
  );
};

// src/candidates/components/VacancyApplicationSearchFilters.tsx
import { jsx as jsx316 } from "react/jsx-runtime";
var fragmentDef75 = VacancyApplicationSearchFilters_results_graphql_default;
var VacancyApplicationSearchFilters = ({
  fragmentRef,
  onSearch
}) => {
  const data = useFragment96(
    fragmentDef75,
    fragmentRef
  );
  return /* @__PURE__ */ jsx316(Suspense107, { fallback: "Loading...", children: /* @__PURE__ */ jsx316("div", { className: "flex grow flex-col rounded-md border bg-white", children: /* @__PURE__ */ jsx316(
    VacancyApplicationSearchFacets,
    {
      fragmentRef: data.aggregations,
      onSearch
    }
  ) }) });
};

// src/candidates/components/__generated__/VacancyApplicationSearchPaging_results.graphql.ts
var node355 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VacancyApplicationSearchPaging_results",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CollectionMetaData",
      "kind": "LinkedField",
      "name": "pagination",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pages",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pageNumber",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "itemsPerPage",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalResults",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__id",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "ApplicationSearchResults",
  "abstractKey": null
};
node355.hash = "b3106786bf561e988f183853ff55dca8";
var VacancyApplicationSearchPaging_results_graphql_default = node355;

// src/candidates/components/VacancyApplicationSearchPaging.tsx
import { useCallback as useCallback176 } from "react";
import { useFragment as useFragment97 } from "react-relay";
import { useAtomValue as useAtomValue13 } from "jotai";
import { SimplePagination as SimplePagination5, SimplePaginationCounts as SimplePaginationCounts3 } from "shared-ui";
import { jsx as jsx317, jsxs as jsxs206 } from "react/jsx-runtime";
var fragmentDef76 = VacancyApplicationSearchPaging_results_graphql_default;
var VacancyApplicationSearchPaging = ({
  fragmentRef,
  onSearch
}) => {
  const data = useFragment97(
    fragmentDef76,
    fragmentRef
  );
  const search4 = useAtomValue13(applicationSearchAtom);
  const onPage = useCallback176(
    (p4) => {
      const newSearch = {
        ...search4,
        pagination: {
          ...search4.pagination,
          pageNumber: p4
        }
      };
      onSearch("VacancyApplicationSearchPaging", newSearch);
    },
    [search4, onSearch]
  );
  return /* @__PURE__ */ jsxs206("div", { className: "flex flex-col items-end", children: [
    /* @__PURE__ */ jsx317(
      SimplePaginationCounts3,
      {
        pages: data.pagination.pages,
        pageNumber: data.pagination.pageNumber,
        itemsPerPage: data.pagination.itemsPerPage,
        totalResults: data.pagination.totalResults
      }
    ),
    data.pagination.pages > 1 && /* @__PURE__ */ jsx317(
      SimplePagination5,
      {
        name: "vacancy-application-search-paging",
        pages: data.pagination.pages,
        pageNumber: data.pagination.pageNumber,
        itemsPerPage: data.pagination.itemsPerPage,
        totalResults: data.pagination.totalResults,
        onPage
      }
    )
  ] });
};

// src/candidates/components/__generated__/VacancyApplicationSearchActiveFilters_results.graphql.ts
var node356 = function() {
  var v0 = {
    "args": null,
    "kind": "FragmentSpread",
    "name": "AggregationTags_Aggregation"
  }, v1 = [
    v0
  ];
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "VacancyApplicationSearchActiveFilters_results",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CollectionMetaData",
        "kind": "LinkedField",
        "name": "pagination",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalResults",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "itemsPerPage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pageNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pages",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ApplicationSearchAggregations",
        "kind": "LinkedField",
        "name": "aggregations",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DefaultAggregationModel",
            "kind": "LinkedField",
            "name": "currentState",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TagFacetFragment"
              },
              v0
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DefaultAggregationModel",
            "kind": "LinkedField",
            "name": "applicationState",
            "plural": false,
            "selections": v1,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DefaultAggregationModel",
            "kind": "LinkedField",
            "name": "currentCompany",
            "plural": false,
            "selections": v1,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DefaultAggregationModel",
            "kind": "LinkedField",
            "name": "vacancy",
            "plural": false,
            "selections": v1,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DefaultAggregationModel",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": v1,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DefaultAggregationModel",
            "kind": "LinkedField",
            "name": "dateCreated",
            "plural": false,
            "selections": v1,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DefaultAggregationModel",
            "kind": "LinkedField",
            "name": "skillGroups",
            "plural": false,
            "selections": v1,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DefaultAggregationModel",
            "kind": "LinkedField",
            "name": "jobExperienceRelevance",
            "plural": false,
            "selections": v1,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DefaultAggregationModel",
            "kind": "LinkedField",
            "name": "jobRecencyRelevance",
            "plural": false,
            "selections": v1,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DefaultAggregationModel",
            "kind": "LinkedField",
            "name": "industryExperienceRelevance",
            "plural": false,
            "selections": v1,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DefaultAggregationModel",
            "kind": "LinkedField",
            "name": "industryRecencyRelevance",
            "plural": false,
            "selections": v1,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StandardAggregationResults",
            "kind": "LinkedField",
            "name": "standard",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "companies",
                "plural": false,
                "selections": v1,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "escoLevel1",
                "plural": false,
                "selections": v1,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "escoLevel2",
                "plural": false,
                "selections": v1,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "escoLevel3",
                "plural": false,
                "selections": v1,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "escoLevel4",
                "plural": false,
                "selections": v1,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "escoLevel5",
                "plural": false,
                "selections": v1,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "industries",
                "plural": false,
                "selections": v1,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "skills",
                "plural": false,
                "selections": v1,
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "VacancyApplicationSearchFacets_results"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ApplicationSearchResult",
        "kind": "LinkedField",
        "name": "results",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Application",
            "kind": "LinkedField",
            "name": "application",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "applicationStateName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "workflowStateName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "code",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "applicationId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "version",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "appliedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "applicantSource",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountsCandidateAccount",
                "kind": "LinkedField",
                "name": "candidate",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "VacancyApplicationHeader_candidate"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "email",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitProfileExperience",
                "kind": "LinkedField",
                "name": "currentPosition",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "VacancyApplicationHeader_currentPosition"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "kind": "ClientExtension",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__id",
            "storageKey": null
          }
        ]
      }
    ],
    "type": "ApplicationSearchResults",
    "abstractKey": null
  };
}();
node356.hash = "9cc6a4adef2fad8aa53eb66ccc968e98";
var VacancyApplicationSearchActiveFilters_results_graphql_default = node356;

// src/candidates/components/VacancyApplicationSearchActiveFilters.tsx
import { Suspense as Suspense108 } from "react";
import { useFragment as useFragment98 } from "react-relay";
import { AggregationTags as AggregationTags4, DisplayFieldEnum as DisplayFieldEnum4 } from "shared-ui";
import { jsx as jsx318, jsxs as jsxs207 } from "react/jsx-runtime";
var fragmentDef77 = VacancyApplicationSearchActiveFilters_results_graphql_default;
var VacancyApplicationSearchActiveFilters = ({
  fragmentRef,
  onDeselect
}) => {
  const data = useFragment98(
    fragmentDef77,
    fragmentRef
  );
  return /* @__PURE__ */ jsx318(Suspense108, { fallback: "Loading...", children: /* @__PURE__ */ jsx318("div", { className: "flex justify-between gap-5", children: /* @__PURE__ */ jsxs207("div", { className: "flex flex-wrap gap-1", children: [
    /* @__PURE__ */ jsx318(
      AggregationTags4,
      {
        fragmentRef: data.aggregations.vacancy,
        displayField: DisplayFieldEnum4.text,
        onSelected: (value) => onDeselect({ source: "vacancy", value })
      }
    ),
    /* @__PURE__ */ jsx318(
      AggregationTags4,
      {
        fragmentRef: data.aggregations.project,
        displayField: DisplayFieldEnum4.text,
        onSelected: (value) => onDeselect({ source: "project", value })
      }
    ),
    /* @__PURE__ */ jsx318(
      AggregationTags4,
      {
        fragmentRef: data.aggregations.dateCreated,
        onSelected: (value) => onDeselect({ source: "dateCreated", value })
      }
    ),
    /* @__PURE__ */ jsx318(
      AggregationTags4,
      {
        fragmentRef: data.aggregations.standard.companies,
        onSelected: (value) => onDeselect({ source: "companies", value, isStandard: true })
      }
    ),
    /* @__PURE__ */ jsx318(
      AggregationTags4,
      {
        fragmentRef: data.aggregations.standard.industries,
        onSelected: (value) => onDeselect({ source: "industries", value, isStandard: true })
      }
    ),
    /* @__PURE__ */ jsx318(
      AggregationTags4,
      {
        fragmentRef: data.aggregations.standard.skills,
        displayField: DisplayFieldEnum4.text,
        onSelected: (value) => onDeselect({ source: "skills", value, isStandard: true })
      }
    ),
    /* @__PURE__ */ jsx318(
      AggregationTags4,
      {
        fragmentRef: data.aggregations.standard.escoLevel1,
        onSelected: (value) => onDeselect({ source: "escoLevel1", value, isStandard: true })
      }
    ),
    /* @__PURE__ */ jsx318(
      AggregationTags4,
      {
        fragmentRef: data.aggregations.standard.escoLevel2,
        onSelected: (value) => onDeselect({ source: "escoLevel2", value, isStandard: true })
      }
    ),
    /* @__PURE__ */ jsx318(
      AggregationTags4,
      {
        fragmentRef: data.aggregations.standard.escoLevel3,
        onSelected: (value) => onDeselect({ source: "escoLevel3", value, isStandard: true })
      }
    ),
    /* @__PURE__ */ jsx318(
      AggregationTags4,
      {
        fragmentRef: data.aggregations.standard.escoLevel4,
        onSelected: (value) => onDeselect({ source: "escoLevel4", value, isStandard: true })
      }
    ),
    /* @__PURE__ */ jsx318(
      AggregationTags4,
      {
        fragmentRef: data.aggregations.standard.escoLevel5,
        onSelected: (value) => onDeselect({ source: "escoLevel5", value, isStandard: true })
      }
    ),
    /* @__PURE__ */ jsx318(
      AggregationTags4,
      {
        fragmentRef: data.aggregations.currentState,
        onSelected: (value) => onDeselect({ source: "currentState", value })
      }
    ),
    /* @__PURE__ */ jsx318(
      AggregationTags4,
      {
        fragmentRef: data.aggregations.currentCompany,
        onSelected: (value) => onDeselect({ source: "currentCompany", value })
      }
    ),
    /* @__PURE__ */ jsx318(
      AggregationTags4,
      {
        fragmentRef: data.aggregations.skillGroups,
        onSelected: (value) => onDeselect({ source: "skillGroups", value })
      }
    ),
    /* @__PURE__ */ jsx318(
      AggregationTags4,
      {
        fragmentRef: data.aggregations.jobExperienceRelevance,
        onSelected: (value) => onDeselect({ source: "jobExperienceRelevance", value })
      }
    ),
    /* @__PURE__ */ jsx318(
      AggregationTags4,
      {
        fragmentRef: data.aggregations.jobRecencyRelevance,
        onSelected: (value) => onDeselect({ source: "jobRelevancyRelevance", value })
      }
    ),
    /* @__PURE__ */ jsx318(
      AggregationTags4,
      {
        fragmentRef: data.aggregations.industryExperienceRelevance,
        onSelected: (value) => onDeselect({ source: "industryExperienceRelevance", value })
      }
    ),
    /* @__PURE__ */ jsx318(
      AggregationTags4,
      {
        fragmentRef: data.aggregations.industryRecencyRelevance,
        onSelected: (value) => onDeselect({ source: "industryRecencyRelevance", value })
      }
    )
  ] }) }) });
};

// src/candidates/components/VacancyApplicationSortFields.tsx
import { useCallback as useCallback177 } from "react";
import { useAtomValue as useAtomValue14 } from "jotai";
import { jsx as jsx319 } from "react/jsx-runtime";
function getApplicationSortField(sort) {
  if (sort.standard && sort.standard === "BEST_MATCH") {
    return "BEST_MATCH" /* BEST_MATCH */;
  }
  if (sort.standard && sort.standard === "NAME") {
    return "NAME" /* NAME */;
  }
  if (sort.custom && sort.custom === "APPLICATION_DATE") {
    return "APPLICATION_DATE" /* APPLICATION_DATE */;
  }
  return "BEST_MATCH" /* BEST_MATCH */;
}
var VacancyApplicationSortFields = ({ onSearch }) => {
  const search4 = useAtomValue14(applicationSearchAtom);
  const onSortChanged = useCallback177(
    (value) => {
      const newSearch = {
        ...search4,
        sort: {
          ...search4.sort,
          field: applicationSortFieldToGraphQL(value)
        },
        pagination: {
          ...search4.pagination,
          pageNumber: 1
        }
      };
      onSearch("VacancyApplicationSortFields", newSearch);
    },
    [search4, onSearch]
  );
  return /* @__PURE__ */ jsx319(
    "select",
    {
      id: "vacancyApplicationSortFields",
      name: "vacancyApplicationSortFields",
      value: getApplicationSortField(search4.sort.field),
      className: "focus:ring-primary-500 focus:border-primary-500 block grow rounded-lg border-gray-300",
      onChange: (e4) => onSortChanged(e4.target.value),
      children: applicationSortFields.map((i4) => /* @__PURE__ */ jsx319("option", { value: i4.id, children: i4.name }, i4.id))
    }
  );
};

// src/candidates/components/VacancyApplicationSortDir.tsx
import { useCallback as useCallback178 } from "react";
import { useAtomValue as useAtomValue15 } from "jotai";
import { getSortDirFromGraphQL as getSortDirFromGraphQL3, sortDirToGraphQL as sortDirToGraphQL5 } from "shared-ui";
import { jsx as jsx320 } from "react/jsx-runtime";
var VacancyApplicationSortDir = ({ onSearch }) => {
  const search4 = useAtomValue15(applicationSearchAtom);
  const onSortChanged = useCallback178(
    (value) => {
      const newSearch = {
        ...search4,
        sort: {
          ...search4.sort,
          order: sortDirToGraphQL5(value)
        }
      };
      onSearch("VacancyApplicationSortDir", newSearch);
    },
    [search4, onSearch]
  );
  return /* @__PURE__ */ jsx320("div", { children: /* @__PURE__ */ jsx320(
    SortDirectionList,
    {
      value: getSortDirFromGraphQL3(search4.sort.order),
      onChanged: onSortChanged
    }
  ) });
};

// src/candidates/components/VacancyApplicationSearchBox.tsx
import { useCallback as useCallback179 } from "react";
import { useAtomValue as useAtomValue16 } from "jotai";
import { MagnifyingGlassIcon as MagnifyingGlassIcon4 } from "@heroicons/react/20/solid";
import { DebouncedInput as DebouncedInput5 } from "shared-ui";
import { jsx as jsx321, jsxs as jsxs208 } from "react/jsx-runtime";
var VacancyApplicationSearchBox = ({ onSearch }) => {
  const search4 = useAtomValue16(applicationSearchAtom);
  const onQueryChanged = useCallback179(
    (query3) => {
      const newSearch = {
        ...search4,
        fullTextSearch: {
          query: query3,
          queryField: {
            standard: "ALL"
          }
        }
      };
      onSearch("VacancyApplicationSearchBox", newSearch);
    },
    [onSearch]
  );
  return /* @__PURE__ */ jsxs208("div", { className: "flex ", children: [
    /* @__PURE__ */ jsx321("label", { htmlFor: "search-field", className: "sr-only", children: "Search" }),
    /* @__PURE__ */ jsxs208("div", { className: "relative w-full text-gray-400 focus-within:text-gray-600", children: [
      /* @__PURE__ */ jsx321("div", { className: "pointer-events-none absolute inset-y-0 right-1 flex items-center", children: /* @__PURE__ */ jsx321(
        MagnifyingGlassIcon4,
        {
          className: "h-5 w-5 flex-shrink-0",
          "aria-hidden": "true"
        }
      ) }),
      /* @__PURE__ */ jsx321(
        DebouncedInput5,
        {
          placeholder: "Search",
          value: search4.fullTextSearch?.query,
          onValueChanged: onQueryChanged
        }
      )
    ] })
  ] });
};

// src/candidates/components/VacancyApplicationSearchList.tsx
import { jsx as jsx323, jsxs as jsxs209 } from "react/jsx-runtime";
var vacancyCandidateApplicationSearchListQueryDef = VacancyApplicationSearchListQuery_graphql_default;
var fragmentDef78 = VacancyApplicationSearchList_query_graphql_default;
var VacancyApplicationSearch = ({
  queryRef: queryRef3,
  onSearch,
  showSearch = true,
  showSort = true
}) => {
  const [filters, setFilters] = useAtom14(applicationSearchAtom);
  const onDeselect = useCallback180(
    ({
      source,
      value,
      isStandard = false
    }) => {
      const newFilters = filters.filters;
      if (!newFilters) {
        return;
      }
      if (isStandard) {
        let standardFilters = newFilters.standard;
        if (standardFilters) {
          if (source == "skills") {
            standardFilters = standardFilters?.skills?.filter((x4) => {
              return x4.skillId !== Number(value);
            }) || [];
          } else {
            standardFilters = standardFilters[source].filter((x4) => x4 !== value);
          }
        }
        const mappedFilters2 = {
          ...filters,
          filters: {
            ...filters.filters,
            standard: {
              ...filters?.filters?.standard,
              [source]: standardFilters
            }
          }
        };
        setFilters(mappedFilters2);
        onSearch(source, mappedFilters2);
        return;
      }
      const updatedFilters = newFilters[source].filter((x4) => x4 !== value);
      const mappedFilters = {
        ...filters,
        filters: {
          ...filters.filters,
          [source]: updatedFilters
        }
      };
      setFilters(mappedFilters);
      onSearch(source, mappedFilters);
    },
    [filters, onSearch, setFilters]
  );
  const query3 = usePreloadedQuery36(
    vacancyCandidateApplicationSearchListQueryDef,
    queryRef3
  );
  const [data] = useRefetchableFragment12(fragmentDef78, query3);
  const onChangedFilters = useCallback180(
    (newFilters) => {
      const newSearch = {
        ...filters,
        filters: {
          ...filters.filters,
          ...newFilters
        }
      };
      onSearch("VacancyApplicationProfileFacets onChangedFilters", newSearch);
    },
    [filters, onSearch]
  );
  const { result } = data;
  const [showFilters, toggleShowFilters] = useToggle33(false);
  return /* @__PURE__ */ jsx323(Suspense109, { fallback: /* @__PURE__ */ jsx323("div", { children: "Loading Application Search header" }), children: /* @__PURE__ */ jsxs209("div", { className: "relative mt-2 flex flex-col gap-2 px-2", children: [
    /* @__PURE__ */ jsxs209("div", { className: "flex w-full flex-col items-center justify-between gap-2 border-b lg:flex-row", children: [
      /* @__PURE__ */ jsx323("div", { className: "-m-2 w-full self-start", children: /* @__PURE__ */ jsx323(
        MultiFacetContainer7,
        {
          showSearch: false,
          showTitle: false,
          showInline: true,
          fragmentRef: result.aggregations.currentState,
          onFacetChanged: (filter2) => onChangedFilters({ currentStates: filter2 })
        }
      ) }),
      showSearch && /* @__PURE__ */ jsx323("div", { className: "my-2 flex w-full flex-col items-end gap-1", children: /* @__PURE__ */ jsx323("div", { className: "w-full max-w-[600px]", children: /* @__PURE__ */ jsx323(VacancyApplicationSearchBox, { onSearch }) }) })
    ] }),
    /* @__PURE__ */ jsxs209("div", { className: "sticky top-0 z-[999] flex flex-col items-center gap-2 bg-[#f3f4f6] pb-2 lg:flex-row lg:items-end lg:gap-5", children: [
      /* @__PURE__ */ jsxs209("div", { className: "flex w-full justify-between", children: [
        /* @__PURE__ */ jsx323("div", { children: /* @__PURE__ */ jsx323(
          VacancyApplicationSearchActiveFilters,
          {
            fragmentRef: result,
            onDeselect
          }
        ) }),
        /* @__PURE__ */ jsx323("div", { children: /* @__PURE__ */ jsx323(
          Button84,
          {
            color: "primary",
            onClick: toggleShowFilters,
            className: "lg:hidden",
            children: /* @__PURE__ */ jsx323(
              IconText5,
              {
                text: showFilters ? "Filters" : "Filters",
                icon: Icons6.FilterHorizontal
              }
            )
          }
        ) })
      ] }),
      /* @__PURE__ */ jsx323("div", { className: "flex w-full items-end gap-1 lg:justify-end" }),
      /* @__PURE__ */ jsxs209("div", { className: "hidden lg:flex", children: [
        showSort && /* @__PURE__ */ jsxs209("div", { className: "flex w-full items-end gap-1 lg:justify-end", children: [
          /* @__PURE__ */ jsx323("div", { className: "flex w-full lg:w-[200px]", children: /* @__PURE__ */ jsx323(VacancyApplicationSortFields, { onSearch }) }),
          /* @__PURE__ */ jsx323(VacancyApplicationSortDir, { onSearch })
        ] }),
        /* @__PURE__ */ jsx323(
          VacancyApplicationSearchPaging,
          {
            fragmentRef: result,
            onSearch
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ jsxs209("div", { className: "flex items-start gap-3", children: [
      /* @__PURE__ */ jsx323(
        "div",
        {
          className: classNames37(
            "sticky top-20 w-full lg:min-w-[400px] lg:max-w-[400px]",
            !showFilters && "hidden lg:flex"
          ),
          children: /* @__PURE__ */ jsx323(
            VacancyApplicationSearchFilters,
            {
              fragmentRef: result,
              onSearch
            }
          )
        }
      ),
      !showFilters && /* @__PURE__ */ jsx323(VacancyApplicationSearchList, { queryRef: queryRef3 })
    ] }),
    !showFilters && /* @__PURE__ */ jsx323("div", { className: "my-10 flex w-full justify-center", children: /* @__PURE__ */ jsx323(
      VacancyApplicationSearchPaging,
      {
        fragmentRef: result,
        onSearch
      }
    ) })
  ] }) });
};
var VacancyApplicationSearchList = ({
  queryRef: queryRef3
}) => {
  const query3 = usePreloadedQuery36(
    vacancyCandidateApplicationSearchListQueryDef,
    queryRef3
  );
  const [data] = useRefetchableFragment12(fragmentDef78, query3);
  const { result } = data;
  return /* @__PURE__ */ jsx323(Suspense109, { fallback: /* @__PURE__ */ jsx323("div", { children: "Loading Application Search Results" }), children: /* @__PURE__ */ jsx323(VacancyApplicationSearchListResults, { fragmentRef: result }) });
};

// src/candidates/components/VacancyApplicationSearchContainer.tsx
import { jsx as jsx324 } from "react/jsx-runtime";
var fragmentDef79 = VacancyApplicationSearchContainer_vacancy_graphql_default;
var VacancyApplicationSearchContainerComponent = ({
  fragmentRef,
  employerId
}) => {
  const data = useFragment99(
    fragmentDef79,
    fragmentRef
  );
  const defaultApplicationSearch = useMemo37(() => {
    return {
      filters: {
        vacancies: {
          byId: [data.vacancyId]
        },
        employers: [employerId]
      },
      pagination: {
        pageNumber: 1,
        pageSize: 10
      },
      sort: {
        field: applicationSortFieldToGraphQL(
          "BEST_MATCH" /* BEST_MATCH */
        ),
        order: sortDirToGraphQL6(SortDir8.Desc)
      }
    };
  }, [data.vacancyId, employerId]);
  const initAtoms = useMemo37(() => {
    return [[applicationSearchAtom, defaultApplicationSearch]];
  }, [defaultApplicationSearch]);
  console.log("render VacancyApplicationSearchContainer");
  return /* @__PURE__ */ jsx324(Suspense110, { fallback: /* @__PURE__ */ jsx324("div", { children: "Loading Container" }), children: /* @__PURE__ */ jsx324(InitializeSearchAtoms, { initialValues: initAtoms, children: /* @__PURE__ */ jsx324(VacancyApplicationSearchLoader, {}) }) });
};
var VacancyApplicationSearchContainer = memo5(
  VacancyApplicationSearchContainerComponent
);
var VacancyApplicationSearchLoader = () => {
  const [input, setInput] = useAtom15(applicationSearchAtom);
  const [queryReference, loadQuery48] = useQueryLoader16(
    vacancyCandidateApplicationSearchListQueryDef
  );
  const [isPending, startTransition2] = useTransition13();
  const onSearch = useCallback181(
    (source, newInput) => {
      startTransition2(() => {
        setInput(newInput);
        console.log(
          `VacancyApplicationSearchLoader onSearch: Source: ${source}`
        );
        const searchInput = {
          input
        };
        loadQuery48(searchInput, { fetchPolicy: "network-only" });
      });
    },
    [setInput, input, loadQuery48]
  );
  useEffect38(() => {
    onSearch("VacancyApplicationSearchLoader Search On Render", input);
    return () => {
      setInput(defaultApplicationSearchAtomValues);
    };
  }, [input, onSearch, setInput]);
  return /* @__PURE__ */ jsx324(Suspense110, { fallback: /* @__PURE__ */ jsx324(Loading9, { label: "Loading Applications" }), children: queryReference && /* @__PURE__ */ jsx324("div", { children: /* @__PURE__ */ jsx324(
    VacancyApplicationSearch,
    {
      queryRef: queryReference,
      onSearch
    }
  ) }) });
};

// src/candidates/components/__generated__/CandidateApplicationSearchListQuery.graphql.ts
var node357 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "key",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isSelected",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "text",
    "storageKey": null
  }, v8 = [
    v4,
    v23,
    v32,
    {
      "alias": null,
      "args": null,
      "concreteType": "DefaultAggregationValueModel",
      "kind": "LinkedField",
      "name": "values",
      "plural": true,
      "selections": [
        v4,
        v6,
        v5,
        v7
      ],
      "storageKey": null
    }
  ], v9 = [
    v32,
    {
      "alias": null,
      "args": null,
      "concreteType": "DefaultAggregationValueModel",
      "kind": "LinkedField",
      "name": "values",
      "plural": true,
      "selections": [
        v4,
        v7,
        v6,
        v5
      ],
      "storageKey": null
    }
  ], v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "applicationId",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "version",
    "storageKey": null
  }, v14 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  }, v15 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v16 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v17 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v18 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "accountId",
    "storageKey": null
  }, v19 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "phoneNumber",
    "storageKey": null
  }, v20 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "phoneCountryPrefix",
    "storageKey": null
  }, v21 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "phoneVerificationStatus",
    "storageKey": null
  }, v222 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyName",
    "storageKey": null
  }, v232 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "startDate",
    "storageKey": null
  }, v24 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "endDate",
    "storageKey": null
  }, v25 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "vacancyId",
    "storageKey": null
  }, v26 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "skillGroupId",
    "storageKey": null
  }, v27 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isRequired",
    "storageKey": null
  }, v28 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "weight",
    "storageKey": null
  }, v29 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationAmount",
    "storageKey": null
  }, v30 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "durationType",
    "storageKey": null
  }, v31 = [
    v29,
    v30
  ], v322 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "numberOfMonthsCertain",
    "storageKey": null
  }, v33 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "numberOfMonthsCertainPlusUnknown",
    "storageKey": null
  }, v34 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "mostRecentCertainExperienceEnd",
    "storageKey": null
  }, v35 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "mostRecentUnknownExperienceEnd",
    "storageKey": null
  }, v36 = [
    v322,
    v33,
    v34,
    v35
  ], v37 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "titleId",
    "storageKey": null
  }, v38 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "industry",
    "storageKey": null
  }, v39 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyIsVerified",
    "storageKey": null
  }, v40 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyId",
    "storageKey": null
  }, v41 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  }, v42 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "positionType",
    "storageKey": null
  }, v43 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "escoOccupationId",
    "storageKey": null
  }, v44 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "escoHierarchy",
    "storageKey": null
  }, v45 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "emailAddress",
    "storageKey": null
  }, v46 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }, v47 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateExperienceId",
    "storageKey": null
  }, v48 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdOn",
    "storageKey": null
  }, v49 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedOn",
    "storageKey": null
  }, v50 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "skills",
    "storageKey": null
  }, v51 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  }, v52 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isSubmitted",
    "storageKey": null
  }, v53 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }, v54 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "parentId",
    "storageKey": null
  }, v55 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "workflowDefinitionId",
    "storageKey": null
  }, v56 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "transitionId",
    "storageKey": null
  }, v57 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "nextStateId",
    "storageKey": null
  }, v58 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currentStateId",
    "storageKey": null
  }, v59 = {
    "alias": null,
    "args": null,
    "concreteType": "WorkflowActionTransition",
    "kind": "LinkedField",
    "name": "actions",
    "plural": true,
    "selections": [
      v10,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "workflowActionTransitionId",
        "storageKey": null
      },
      v55,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "actionGroup",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "actionType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "actionName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "actionDialog",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "actionLabel",
        "storageKey": null
      },
      v56,
      v57,
      v58,
      {
        "alias": null,
        "args": null,
        "concreteType": "WorkflowSecurityContext",
        "kind": "LinkedField",
        "name": "securityContext",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "WorkflowSecurityUser",
            "kind": "LinkedField",
            "name": "users",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "owner",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "WorkflowPermission",
                "kind": "LinkedField",
                "name": "permissions",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "action",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "resource",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userType",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v60 = {
    "alias": null,
    "args": null,
    "concreteType": "WorkflowEventTransition",
    "kind": "LinkedField",
    "name": "events",
    "plural": true,
    "selections": [
      v10,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "eventName",
        "storageKey": null
      },
      v56,
      v55,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "workflowEventTransitionId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v61 = {
    "alias": null,
    "args": null,
    "concreteType": "WorkflowTransition",
    "kind": "LinkedField",
    "name": "transitions",
    "plural": true,
    "selections": [
      v10,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "workflowTransitionId",
        "storageKey": null
      },
      v55,
      v58,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currentStateName",
        "storageKey": null
      },
      v57,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "nextStateName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "WorkflowTransitionActivity",
        "kind": "LinkedField",
        "name": "activities",
        "plural": true,
        "selections": [
          v10,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "workflowTransitionActivityId",
            "storageKey": null
          },
          v56,
          {
            "alias": null,
            "args": null,
            "concreteType": "WorkflowActivityContext",
            "kind": "LinkedField",
            "name": "context",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "workflowActivityType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "workflowActivityParameters",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateApplicationSearchListQuery",
      "selections": [
        {
          "args": v1,
          "kind": "FragmentSpread",
          "name": "VacancyApplicationSearchList_query"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateApplicationSearchListQuery",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "ApplicationSearchResults",
          "kind": "LinkedField",
          "name": "recruitApplicationSearch2",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CollectionMetaData",
              "kind": "LinkedField",
              "name": "pagination",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "totalResults",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "itemsPerPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "pageNumber",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "pages",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ApplicationSearchAggregations",
              "kind": "LinkedField",
              "name": "aggregations",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "applicationState",
                  "plural": false,
                  "selections": [
                    v23,
                    v32,
                    v4,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationValueModel",
                      "kind": "LinkedField",
                      "name": "values",
                      "plural": true,
                      "selections": [
                        v4,
                        v5,
                        v6,
                        v7
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "StandardAggregationResults",
                  "kind": "LinkedField",
                  "name": "standard",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "skills",
                      "plural": false,
                      "selections": v8,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "companies",
                      "plural": false,
                      "selections": v8,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "industries",
                      "plural": false,
                      "selections": v8,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "escoLevel1",
                      "plural": false,
                      "selections": v9,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "escoLevel2",
                      "plural": false,
                      "selections": v9,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "escoLevel3",
                      "plural": false,
                      "selections": v9,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "escoLevel4",
                      "plural": false,
                      "selections": v9,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "escoLevel5",
                      "plural": false,
                      "selections": v9,
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "project",
                  "plural": false,
                  "selections": v8,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "dateCreated",
                  "plural": false,
                  "selections": v8,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "vacancy",
                  "plural": false,
                  "selections": v8,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "currentState",
                  "plural": false,
                  "selections": v8,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "industryExperienceRelevance",
                  "plural": false,
                  "selections": v8,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "industryRecencyRelevance",
                  "plural": false,
                  "selections": v8,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "jobExperienceRelevance",
                  "plural": false,
                  "selections": v8,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "jobRecencyRelevance",
                  "plural": false,
                  "selections": v8,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "currentCompany",
                  "plural": false,
                  "selections": v9,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "skillGroups",
                  "plural": false,
                  "selections": v9,
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ApplicationSearchResult",
              "kind": "LinkedField",
              "name": "results",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "rankInVacancy",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "totalApplicationsInVacancy",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Application",
                  "kind": "LinkedField",
                  "name": "application",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "applicationStateName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "workflowStateName",
                      "storageKey": null
                    },
                    v10,
                    v11,
                    v12,
                    v13,
                    v14,
                    v15,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "appliedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "applicantSource",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountsCandidateAccount",
                      "kind": "LinkedField",
                      "name": "candidate",
                      "plural": false,
                      "selections": [
                        v16,
                        v17,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "email",
                          "storageKey": null
                        },
                        v10,
                        v18,
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "CandidatePhoneVerification",
                          "kind": "LinkedField",
                          "name": "phone",
                          "plural": false,
                          "selections": [
                            v19,
                            v20,
                            v21
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileExperience",
                      "kind": "LinkedField",
                      "name": "currentPosition",
                      "plural": false,
                      "selections": [
                        v222,
                        v232,
                        v24,
                        v32,
                        v10
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "candidateId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "rightToWorkStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Vacancy",
                      "kind": "LinkedField",
                      "name": "vacancy",
                      "plural": false,
                      "selections": [
                        v11,
                        v25,
                        v10,
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "SkillGroup",
                          "kind": "LinkedField",
                          "name": "skillGroups",
                          "plural": true,
                          "selections": [
                            v10,
                            v26,
                            v5,
                            v27,
                            v28,
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "SkillGroupTerm",
                              "kind": "LinkedField",
                              "name": "terms",
                              "plural": true,
                              "selections": [
                                v5,
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "isSkill",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Duration",
                              "kind": "LinkedField",
                              "name": "experience",
                              "plural": false,
                              "selections": v31,
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Duration",
                              "kind": "LinkedField",
                              "name": "recency",
                              "plural": false,
                              "selections": [
                                v30,
                                v29
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "VacancyScoringConfig",
                          "kind": "LinkedField",
                          "name": "scoringConfig",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Duration",
                              "kind": "LinkedField",
                              "name": "industryExperience",
                              "plural": false,
                              "selections": v31,
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "industryNegativeThreshold",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "industryPositiveThreshold",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Duration",
                              "kind": "LinkedField",
                              "name": "industryRecency",
                              "plural": false,
                              "selections": v31,
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "relevanceNegativeThreshold",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "relevancePositiveThreshold",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Duration",
                              "kind": "LinkedField",
                              "name": "relevantExperience",
                              "plural": false,
                              "selections": v31,
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Duration",
                              "kind": "LinkedField",
                              "name": "relevantRecency",
                              "plural": false,
                              "selections": v31,
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "WorkflowDefinition",
                          "kind": "LinkedField",
                          "name": "workflowDefinition",
                          "plural": false,
                          "selections": [
                            v10,
                            v5,
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "WorkflowState",
                              "kind": "LinkedField",
                              "name": "states",
                              "plural": true,
                              "selections": [
                                v10,
                                v5,
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "label",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "WorkflowState",
                                  "kind": "LinkedField",
                                  "name": "children",
                                  "plural": true,
                                  "selections": [
                                    v10,
                                    v5
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitMatchRelevanceContainer",
                      "kind": "LinkedField",
                      "name": "matchRelevance",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitMatchSkillRelevance",
                          "kind": "LinkedField",
                          "name": "skillGroups",
                          "plural": true,
                          "selections": [
                            v26,
                            v322,
                            v33,
                            v34,
                            v35
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitMatchRelevance",
                          "kind": "LinkedField",
                          "name": "industry",
                          "plural": false,
                          "selections": v36,
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitMatchRelevance",
                          "kind": "LinkedField",
                          "name": "job",
                          "plural": false,
                          "selections": v36,
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitMatchProfile",
                      "kind": "LinkedField",
                      "name": "matchProfile",
                      "plural": false,
                      "selections": [
                        v10,
                        v25,
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitMatchProfileExperience",
                          "kind": "LinkedField",
                          "name": "experience",
                          "plural": true,
                          "selections": [
                            v10,
                            v11,
                            v13,
                            v37,
                            v32,
                            v38,
                            v39,
                            v40,
                            v222,
                            v41,
                            v232,
                            v24,
                            v42,
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "MatchProfileExperienceSkillGroupScore",
                              "kind": "LinkedField",
                              "name": "skillGroupScores",
                              "plural": true,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "groupId",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "hasMatch",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "minSkillGroupScore",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "score",
                                  "storageKey": null
                                },
                                v28
                              ],
                              "storageKey": null
                            },
                            v43,
                            v44,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "jobMatchWeight",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "jobMatchScore",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "companyScore",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "companyScoreWeight",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "hasCompanyVector",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfile",
                      "kind": "LinkedField",
                      "name": "profile",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileRate",
                          "kind": "LinkedField",
                          "name": "rate",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "countryCode",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "currencyCode",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "maximumRateOfPay",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "minimumRateOfPay",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "payType",
                              "storageKey": null
                            },
                            v10
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "recruitProfileId",
                          "storageKey": null
                        },
                        v11,
                        v16,
                        v17,
                        v45,
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitCandidateProfileNote",
                          "kind": "LinkedField",
                          "name": "notes",
                          "plural": true,
                          "selections": [
                            v11,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "content",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "RecruitCandidateProfileNoteTag",
                              "kind": "LinkedField",
                              "name": "tags",
                              "plural": true,
                              "selections": [
                                v5,
                                v46
                              ],
                              "storageKey": null
                            },
                            v15,
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "AccountsUser",
                              "kind": "LinkedField",
                              "name": "createdByUser",
                              "plural": false,
                              "selections": [
                                v45,
                                v16,
                                v17
                              ],
                              "storageKey": null
                            },
                            v10
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "AccountsCandidateAccount",
                          "kind": "LinkedField",
                          "name": "account",
                          "plural": false,
                          "selections": [
                            v18,
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "CandidatePhoneVerification",
                              "kind": "LinkedField",
                              "name": "phone",
                              "plural": false,
                              "selections": [
                                v21,
                                v19,
                                v20
                              ],
                              "storageKey": null
                            },
                            v10
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileExperience",
                          "kind": "LinkedField",
                          "name": "experience",
                          "plural": true,
                          "selections": [
                            v10,
                            v47,
                            v32,
                            v222,
                            v232,
                            v24,
                            v48,
                            v49,
                            v13,
                            v37,
                            v38,
                            v39,
                            v40,
                            v41,
                            v42,
                            v50,
                            v43,
                            v44
                          ],
                          "storageKey": null
                        },
                        v10,
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileWorkLocations",
                          "kind": "LinkedField",
                          "name": "workLocations",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "currentLocationName",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "currentLocationCountryName",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "WorkLocationEntry",
                              "kind": "LinkedField",
                              "name": "workLocations",
                              "plural": true,
                              "selections": [
                                v5
                              ],
                              "storageKey": null
                            },
                            v10
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileExperience",
                          "kind": "LinkedField",
                          "name": "currentPosition",
                          "plural": false,
                          "selections": [
                            v32,
                            v222,
                            v232,
                            v24,
                            v10
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileAvailability",
                          "kind": "LinkedField",
                          "name": "availability",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "jobSearchStatus",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "availabilityStatus",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "NoticeCriteria",
                              "kind": "LinkedField",
                              "name": "noticeCriteria",
                              "plural": false,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "availableFrom",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "noticePeriodWeeks",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "noticeTimeframe",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            },
                            v10
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "profileType",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RightToWork",
                          "kind": "LinkedField",
                          "name": "rightToWork",
                          "plural": true,
                          "selections": [
                            v51,
                            v10
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitProfileExperienceCollection",
                          "kind": "LinkedField",
                          "name": "experiences",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "RecruitProfileExperience",
                              "kind": "LinkedField",
                              "name": "items",
                              "plural": true,
                              "selections": [
                                v10,
                                v47,
                                v32,
                                v40,
                                v39,
                                v222,
                                v41,
                                v232,
                                v24,
                                v50,
                                v48,
                                v49,
                                v13,
                                v37,
                                v38,
                                v42,
                                v43,
                                v44
                              ],
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "SkillUsage",
                              "kind": "LinkedField",
                              "name": "skills",
                              "plural": true,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "skillId",
                                  "storageKey": null
                                },
                                v5,
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "totalMonthsUsed",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "averageMonthsUsed",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "totalPositionsUsed",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "lastUsed",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "DateRange",
                                  "kind": "LinkedField",
                                  "name": "periods",
                                  "plural": true,
                                  "selections": [
                                    v232,
                                    v24
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecruitResume",
                          "kind": "LinkedField",
                          "name": "resume",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "bucket",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "resumeId",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "fileKey",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "fileName",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "filePath",
                              "storageKey": null
                            },
                            v10
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ApplicationDocument",
                      "kind": "LinkedField",
                      "name": "documents",
                      "plural": true,
                      "selections": [
                        v10,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "applicationDocumentId",
                          "storageKey": null
                        },
                        v14,
                        v15,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "documentReferenceId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "documentReferenceFileName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "documentTypeId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "documentTypeName",
                          "storageKey": null
                        },
                        v27,
                        v52,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isUploaded",
                          "storageKey": null
                        },
                        v51,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "requiresExpiryDate",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "requiresIssueDate",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "requiresIssueNumber",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "documentExpiryDate",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "documentIssueDate",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "documentIssueNumber",
                          "storageKey": null
                        },
                        v12
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "vacancyName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ApplicationForm",
                      "kind": "LinkedField",
                      "name": "forms",
                      "plural": true,
                      "selections": [
                        v10,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "applicationFormId",
                          "storageKey": null
                        },
                        v11,
                        v14,
                        v15,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isEdited",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isCompleted",
                          "storageKey": null
                        },
                        v27,
                        v52,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "formTemplateName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "FormField",
                          "kind": "LinkedField",
                          "name": "fields",
                          "plural": true,
                          "selections": [
                            v23,
                            v46,
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "skipped",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "type",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        v12,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "formTemplateId",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasCompletedForms",
                      "storageKey": null
                    },
                    v53,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "applicationStateId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "workflowStateId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "WorkflowDefinition",
                      "kind": "LinkedField",
                      "name": "workflowDefinition",
                      "plural": false,
                      "selections": [
                        v10,
                        v5,
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "WorkflowState",
                          "kind": "LinkedField",
                          "name": "states",
                          "plural": true,
                          "selections": [
                            v10,
                            v5,
                            v54,
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "WorkflowState",
                              "kind": "LinkedField",
                              "name": "children",
                              "plural": true,
                              "selections": [
                                v10,
                                v5,
                                v54,
                                v59,
                                v60,
                                v61
                              ],
                              "storageKey": null
                            },
                            v59,
                            v60,
                            v61
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v53
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "c00aa56150b4679a5a373f989640a177",
      "id": null,
      "metadata": {},
      "name": "CandidateApplicationSearchListQuery",
      "operationKind": "query",
      "text": "query CandidateApplicationSearchListQuery(\n  $input: ApplicationSearchInput2Input!\n) {\n  ...VacancyApplicationSearchList_query_2VV6jB\n}\n\nfragment AggregationTags_Aggregation on DefaultAggregationModel {\n  title\n  values {\n    count\n    text\n    isSelected\n    name\n  }\n}\n\nfragment CandidateApplicationDocumentDetail_document on ApplicationDocument {\n  id\n  applicationDocumentId\n  applicationId\n  createdAt\n  updatedAt\n  documentReferenceId\n  documentReferenceFileName\n  documentTypeId\n  documentTypeName\n  isRequired\n  isSubmitted\n  isUploaded\n  status\n  requiresExpiryDate\n  requiresIssueDate\n  requiresIssueNumber\n  documentExpiryDate\n  documentIssueDate\n  documentIssueNumber\n}\n\nfragment CandidateApplicationDocumentRow_document on ApplicationDocument {\n  id\n  applicationDocumentId\n  createdAt\n  updatedAt\n  documentReferenceId\n  documentReferenceFileName\n  documentTypeId\n  documentTypeName\n  isRequired\n  isSubmitted\n  isUploaded\n  status\n  requiresExpiryDate\n  requiresIssueDate\n  requiresIssueNumber\n  documentExpiryDate\n  documentIssueDate\n  documentIssueNumber\n}\n\nfragment CandidateApplicationDocuments_application on Application {\n  documents {\n    id\n    applicationDocumentId\n    createdAt\n    updatedAt\n    documentReferenceId\n    documentReferenceFileName\n    documentTypeId\n    documentTypeName\n    isRequired\n    isSubmitted\n    isUploaded\n    status\n    requiresExpiryDate\n    requiresIssueDate\n    requiresIssueNumber\n    documentExpiryDate\n    documentIssueDate\n    documentIssueNumber\n    ...CandidateApplicationDocumentRow_document\n    ...CandidateApplicationDocumentDetail_document\n  }\n}\n\nfragment CandidateApplicationFormDetail_form on ApplicationForm {\n  id\n  applicationFormId\n  code\n  applicationId\n  createdAt\n  updatedAt\n  isEdited\n  isCompleted\n  isRequired\n  isSubmitted\n  formTemplateId\n  formTemplateName\n  fields {\n    key\n    value\n    skipped\n    type\n  }\n}\n\nfragment CandidateApplicationFormRow_form on ApplicationForm {\n  id\n  applicationFormId\n  code\n  createdAt\n  updatedAt\n  isEdited\n  isCompleted\n  isRequired\n  isSubmitted\n  formTemplateName\n  fields {\n    key\n    value\n    skipped\n    type\n  }\n}\n\nfragment CandidateApplicationForms_application on Application {\n  id\n  code\n  applicationId\n  vacancyName\n  candidate {\n    firstName\n    lastName\n    id\n  }\n  forms {\n    id\n    applicationFormId\n    code\n    createdAt\n    updatedAt\n    isEdited\n    isCompleted\n    isRequired\n    isSubmitted\n    formTemplateName\n    fields {\n      key\n      value\n      skipped\n      type\n    }\n    ...CandidateApplicationFormRow_form\n    ...CandidateApplicationFormDetail_form\n  }\n  hasCompletedForms\n}\n\nfragment CandidateApplicationLayout_applicationSearchResult on Application {\n  code\n  applicationId\n  candidateId\n  employerId\n  version\n  rightToWorkStatus\n  createdAt\n  workflowStateName\n  vacancy {\n    code\n    vacancyId\n    id\n    ...MatchRelevanceProvider_vacancy\n  }\n  matchRelevance {\n    ...MatchRelevanceProvider_relevance\n  }\n  matchProfile {\n    ...MatchRelevanceProvider_matchProfile\n  }\n  candidate {\n    accountId\n    ...DetailsComponent_candidate\n    id\n  }\n  profile {\n    rate {\n      countryCode\n      currencyCode\n      maximumRateOfPay\n      minimumRateOfPay\n      payType\n      id\n    }\n    recruitProfileId\n    ...Profile_profile\n    ...RecruitProfileApplicationHeader_application\n    ...CandidateApplicationProfile_profile\n    ...DetailsComponent_profile\n    id\n  }\n  ...CandidateApplicationRelevance_application\n  ...CandidateApplicationDocuments_application\n  ...CandidateApplicationForms_application\n  ...CandidateApplicationWorkflowContainer_application\n}\n\nfragment CandidateApplicationProfile_profile on RecruitProfile {\n  experiences {\n    items {\n      id\n      candidateExperienceId\n      title\n      companyName\n      startDate\n      endDate\n      ...ExperienceDetails_experience\n    }\n    skills {\n      name\n      lastUsed\n      periods {\n        startDate\n        endDate\n      }\n      averageMonthsUsed\n      totalMonthsUsed\n      totalPositionsUsed\n    }\n  }\n}\n\nfragment CandidateApplicationRelevance_application on Application {\n  code\n  vacancy {\n    code\n    id\n  }\n  profile {\n    recruitProfileId\n    id\n  }\n}\n\nfragment CandidateApplicationWorkflowContainer_application on Application {\n  id\n  applicationId\n  updatedAt\n  applicationStateId\n  applicationStateName\n  workflowStateId\n  workflowStateName\n  workflowDefinition {\n    id\n    name\n    states {\n      id\n      name\n      parentId\n      children {\n        id\n        name\n        parentId\n        actions {\n          id\n          workflowActionTransitionId\n          workflowDefinitionId\n          actionGroup\n          actionType\n          actionName\n          actionDialog\n          actionLabel\n          transitionId\n          nextStateId\n          currentStateId\n          securityContext {\n            users {\n              owner\n              permissions {\n                action\n                resource\n              }\n              userType\n            }\n          }\n        }\n        events {\n          id\n          eventName\n          transitionId\n          workflowDefinitionId\n          workflowEventTransitionId\n        }\n        transitions {\n          id\n          workflowTransitionId\n          workflowDefinitionId\n          currentStateId\n          currentStateName\n          nextStateId\n          nextStateName\n          activities {\n            id\n            workflowTransitionActivityId\n            transitionId\n            context {\n              workflowActivityType\n              workflowActivityParameters\n            }\n          }\n        }\n      }\n      actions {\n        id\n        workflowActionTransitionId\n        workflowDefinitionId\n        actionGroup\n        actionType\n        actionName\n        actionDialog\n        actionLabel\n        transitionId\n        nextStateId\n        currentStateId\n        securityContext {\n          users {\n            owner\n            permissions {\n              action\n              resource\n            }\n            userType\n          }\n        }\n      }\n      events {\n        id\n        eventName\n        transitionId\n        workflowDefinitionId\n        workflowEventTransitionId\n      }\n      transitions {\n        id\n        workflowTransitionId\n        workflowDefinitionId\n        currentStateId\n        currentStateName\n        nextStateId\n        nextStateName\n        activities {\n          id\n          workflowTransitionActivityId\n          transitionId\n          context {\n            workflowActivityType\n            workflowActivityParameters\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment DetailsComponent_candidate on AccountsCandidateAccount {\n  firstName\n  lastName\n  email\n  phone {\n    phoneNumber\n    phoneCountryPrefix\n    phoneVerificationStatus\n  }\n}\n\nfragment DetailsComponent_profile on RecruitProfile {\n  recruitProfileId\n  resume {\n    bucket\n    resumeId\n    fileKey\n    fileName\n    filePath\n    id\n  }\n}\n\nfragment ExperienceDetails_experience on RecruitProfileExperience {\n  id\n  createdOn\n  updatedOn\n  candidateExperienceId\n  version\n  titleId\n  title\n  industry\n  companyIsVerified\n  companyId\n  companyName\n  description\n  startDate\n  endDate\n  positionType\n  skills\n  escoOccupationId\n  escoHierarchy\n}\n\nfragment MatchRelevanceProvider_matchProfile on RecruitMatchProfile {\n  id\n  vacancyId\n  experience {\n    id\n    code\n    version\n    titleId\n    title\n    industry\n    companyIsVerified\n    companyId\n    companyName\n    description\n    startDate\n    endDate\n    positionType\n    skillGroupScores {\n      groupId\n      hasMatch\n      minSkillGroupScore\n      score\n      weight\n    }\n    escoOccupationId\n    escoHierarchy\n    jobMatchWeight\n    jobMatchScore\n    companyScore\n    companyScoreWeight\n    hasCompanyVector\n  }\n}\n\nfragment MatchRelevanceProvider_relevance on RecruitMatchRelevanceContainer {\n  skillGroups {\n    skillGroupId\n    numberOfMonthsCertain\n    numberOfMonthsCertainPlusUnknown\n    mostRecentCertainExperienceEnd\n    mostRecentUnknownExperienceEnd\n  }\n  industry {\n    numberOfMonthsCertain\n    numberOfMonthsCertainPlusUnknown\n    mostRecentCertainExperienceEnd\n    mostRecentUnknownExperienceEnd\n  }\n  job {\n    numberOfMonthsCertain\n    numberOfMonthsCertainPlusUnknown\n    mostRecentCertainExperienceEnd\n    mostRecentUnknownExperienceEnd\n  }\n}\n\nfragment MatchRelevanceProvider_vacancy on Vacancy {\n  id\n  code\n  skillGroups {\n    id\n    skillGroupId\n    name\n    isRequired\n    weight\n    terms {\n      name\n      isSkill\n    }\n    experience {\n      durationAmount\n      durationType\n    }\n    recency {\n      durationType\n      durationAmount\n    }\n  }\n  scoringConfig {\n    industryExperience {\n      durationAmount\n      durationType\n    }\n    industryNegativeThreshold\n    industryPositiveThreshold\n    industryRecency {\n      durationAmount\n      durationType\n    }\n    relevanceNegativeThreshold\n    relevancePositiveThreshold\n    relevantExperience {\n      durationAmount\n      durationType\n    }\n    relevantRecency {\n      durationAmount\n      durationType\n    }\n  }\n}\n\nfragment MultiFacetContainer_facet on DefaultAggregationModel {\n  count\n  key\n  title\n  values {\n    count\n    isSelected\n    name\n    text\n  }\n}\n\nfragment ProfileSearchResultTimeline_profile on RecruitProfile {\n  id\n  experiences {\n    items {\n      id\n      candidateExperienceId\n      title\n      companyId\n      companyIsVerified\n      companyName\n      description\n      startDate\n      endDate\n      skills\n    }\n    skills {\n      skillId\n      name\n      totalMonthsUsed\n      averageMonthsUsed\n      totalPositionsUsed\n      lastUsed\n      periods {\n        startDate\n        endDate\n      }\n    }\n  }\n}\n\nfragment ProfileSkillsFacetsContainer_facets on StandardAggregationResults {\n  skills {\n    count\n    ...MultiFacetContainer_facet\n  }\n}\n\nfragment Profile_profile on RecruitProfile {\n  code\n  firstName\n  lastName\n  recruitProfileId\n  emailAddress\n  notes {\n    code\n    content\n    tags {\n      name\n      value\n    }\n    updatedAt\n    createdByUser {\n      emailAddress\n      firstName\n      lastName\n    }\n    id\n  }\n  account {\n    accountId\n    phone {\n      phoneVerificationStatus\n      phoneNumber\n      phoneCountryPrefix\n    }\n    id\n  }\n  experience {\n    id\n    candidateExperienceId\n    title\n    companyName\n    startDate\n    endDate\n    ...ExperienceDetails_experience\n  }\n  ...RecruitProfileHeader_profile\n  ...ProfileSearchResultTimeline_profile\n}\n\nfragment RecruitProfileApplicationHeader_application on RecruitProfile {\n  id\n  firstName\n  lastName\n  workLocations {\n    currentLocationName\n    currentLocationCountryName\n    workLocations {\n      name\n    }\n    id\n  }\n  currentPosition {\n    title\n    companyName\n    startDate\n    endDate\n    id\n  }\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n  availability {\n    jobSearchStatus\n    availabilityStatus\n    noticeCriteria {\n      availableFrom\n      noticePeriodWeeks\n      noticeTimeframe\n    }\n    id\n  }\n}\n\nfragment RecruitProfileHeader_profile on RecruitProfile {\n  ...RecruitProfileApplicationHeader_application\n  id\n  recruitProfileId\n  firstName\n  lastName\n  profileType\n  workLocations {\n    currentLocationName\n    currentLocationCountryName\n    id\n  }\n  account {\n    accountId\n    id\n  }\n  currentPosition {\n    title\n    companyName\n    startDate\n    endDate\n    id\n  }\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n  rightToWork {\n    status\n    id\n  }\n  availability {\n    jobSearchStatus\n    id\n  }\n}\n\nfragment TagFacetFragment on DefaultAggregationModel {\n  count\n  key\n  title\n  values {\n    count\n    isSelected\n    name\n    text\n  }\n}\n\nfragment VacancyApplicationHeader_candidate on AccountsCandidateAccount {\n  firstName\n  lastName\n  email\n}\n\nfragment VacancyApplicationHeader_currentPosition on RecruitProfileExperience {\n  companyName\n  startDate\n  endDate\n  title\n}\n\nfragment VacancyApplicationSearchActiveFilters_results on ApplicationSearchResults {\n  pagination {\n    totalResults\n    itemsPerPage\n    pageNumber\n    pages\n  }\n  aggregations {\n    currentState {\n      ...TagFacetFragment\n      ...AggregationTags_Aggregation\n    }\n    applicationState {\n      ...AggregationTags_Aggregation\n    }\n    currentCompany {\n      ...AggregationTags_Aggregation\n    }\n    vacancy {\n      ...AggregationTags_Aggregation\n    }\n    project {\n      ...AggregationTags_Aggregation\n    }\n    dateCreated {\n      ...AggregationTags_Aggregation\n    }\n    skillGroups {\n      ...AggregationTags_Aggregation\n    }\n    jobExperienceRelevance {\n      ...AggregationTags_Aggregation\n    }\n    jobRecencyRelevance {\n      ...AggregationTags_Aggregation\n    }\n    industryExperienceRelevance {\n      ...AggregationTags_Aggregation\n    }\n    industryRecencyRelevance {\n      ...AggregationTags_Aggregation\n    }\n    standard {\n      companies {\n        ...AggregationTags_Aggregation\n      }\n      escoLevel1 {\n        ...AggregationTags_Aggregation\n      }\n      escoLevel2 {\n        ...AggregationTags_Aggregation\n      }\n      escoLevel3 {\n        ...AggregationTags_Aggregation\n      }\n      escoLevel4 {\n        ...AggregationTags_Aggregation\n      }\n      escoLevel5 {\n        ...AggregationTags_Aggregation\n      }\n      industries {\n        ...AggregationTags_Aggregation\n      }\n      skills {\n        ...AggregationTags_Aggregation\n      }\n      ...VacancyApplicationSearchFacets_results\n    }\n  }\n  results {\n    application {\n      applicationStateName\n      workflowStateName\n      id\n      code\n      applicationId\n      version\n      createdAt\n      updatedAt\n      appliedAt\n      applicantSource\n      candidate {\n        ...VacancyApplicationHeader_candidate\n        firstName\n        lastName\n        email\n        id\n      }\n      currentPosition {\n        ...VacancyApplicationHeader_currentPosition\n        id\n      }\n    }\n  }\n}\n\nfragment VacancyApplicationSearchFacets_aggregations on ApplicationSearchAggregations {\n  standard {\n    ...VacancyApplicationSearchFacets_results\n  }\n  project {\n    count\n    ...MultiFacetContainer_facet\n  }\n  dateCreated {\n    count\n    ...MultiFacetContainer_facet\n  }\n  vacancy {\n    count\n    ...MultiFacetContainer_facet\n  }\n  applicationState {\n    count\n    ...MultiFacetContainer_facet\n  }\n  currentState {\n    count\n    ...MultiFacetContainer_facet\n  }\n  industryExperienceRelevance {\n    count\n    ...MultiFacetContainer_facet\n  }\n  industryRecencyRelevance {\n    count\n    ...MultiFacetContainer_facet\n  }\n  jobExperienceRelevance {\n    count\n    ...MultiFacetContainer_facet\n  }\n  jobRecencyRelevance {\n    count\n    ...MultiFacetContainer_facet\n  }\n}\n\nfragment VacancyApplicationSearchFacets_results on StandardAggregationResults {\n  ...ProfileSkillsFacetsContainer_facets\n  companies {\n    count\n    ...MultiFacetContainer_facet\n  }\n  industries {\n    count\n    ...MultiFacetContainer_facet\n  }\n}\n\nfragment VacancyApplicationSearchFilters_results on ApplicationSearchResults {\n  aggregations {\n    ...VacancyApplicationSearchFacets_aggregations\n    standard {\n      ...VacancyApplicationSearchFacets_results\n    }\n  }\n}\n\nfragment VacancyApplicationSearchListHeader_results on ApplicationSearchResults {\n  pagination {\n    pages\n  }\n  ...VacancyApplicationSearchFilters_results\n  ...VacancyApplicationSearchActiveFilters_results\n  ...VacancyApplicationStatusFilters_results\n  ...VacancyApplicationSearchPaging_results\n}\n\nfragment VacancyApplicationSearchListResults_results on ApplicationSearchResults {\n  pagination {\n    totalResults\n    itemsPerPage\n    pageNumber\n    pages\n  }\n  aggregations {\n    applicationState {\n      key\n      title\n      count\n      values {\n        count\n        name\n        isSelected\n        text\n      }\n    }\n  }\n  results {\n    rankInVacancy\n    totalApplicationsInVacancy\n    application {\n      applicationStateName\n      workflowStateName\n      id\n      code\n      applicationId\n      version\n      createdAt\n      updatedAt\n      appliedAt\n      applicantSource\n      candidate {\n        ...VacancyApplicationHeader_candidate\n        firstName\n        lastName\n        email\n        id\n      }\n      currentPosition {\n        ...VacancyApplicationHeader_currentPosition\n        id\n      }\n      ...CandidateApplicationLayout_applicationSearchResult\n    }\n  }\n}\n\nfragment VacancyApplicationSearchList_query_2VV6jB on Query {\n  result: recruitApplicationSearch2(input: $input) {\n    ...VacancyApplicationSearchListResults_results\n    ...VacancyApplicationSearchListHeader_results\n    ...VacancyApplicationStatusFilters_results\n    ...VacancyApplicationSearchFilters_results\n    ...VacancyApplicationSearchPaging_results\n    ...VacancyApplicationSearchActiveFilters_results\n    aggregations {\n      applicationState {\n        ...MultiFacetContainer_facet\n      }\n      currentState {\n        ...MultiFacetContainer_facet\n      }\n    }\n    results {\n      application {\n        vacancy {\n          vacancyId\n          workflowDefinition {\n            id\n            name\n            states {\n              id\n              name\n              label\n              children {\n                id\n                name\n              }\n            }\n          }\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment VacancyApplicationSearchPaging_results on ApplicationSearchResults {\n  pagination {\n    pages\n    pageNumber\n    itemsPerPage\n    totalResults\n  }\n}\n\nfragment VacancyApplicationStatusFilters_results on ApplicationSearchResults {\n  pagination {\n    totalResults\n  }\n  aggregations {\n    applicationState {\n      key\n      title\n      count\n      values {\n        count\n        name\n        isSelected\n        text\n      }\n    }\n    currentState {\n      key\n      title\n      count\n      values {\n        count\n        name\n        isSelected\n        text\n      }\n    }\n  }\n}\n"
    }
  };
}();
node357.hash = "dec6937fb58869a8b70ac7033aebbc42";
var CandidateApplicationSearchListQuery_graphql_default = node357;

// src/candidates/components/CandidateApplicationSearchList.tsx
import {
  Suspense as Suspense111,
  memo as memo6,
  startTransition,
  useCallback as useCallback183,
  useEffect as useEffect39
} from "react";
import { useQueryLoader as useQueryLoader17 } from "react-relay";
import { useAtom as useAtom16 } from "jotai";
import { EdSkeleton as EdSkeleton95, HeaderBar } from "shared-ui";
import { jsx as jsx325, jsxs as jsxs211 } from "react/jsx-runtime";
var queryDef57 = CandidateApplicationSearchListQuery_graphql_default;
var CandidateApplicationSearchListComponent = () => {
  const [input, setInput] = useAtom16(applicationSearchAtom);
  const [queryReference, loadQuery48] = useQueryLoader17(queryDef57);
  useEffect39(() => {
    loadQuery48({
      input
    });
  }, [loadQuery48, input]);
  const onSearch = useCallback183(
    (source, newInput) => {
      startTransition(() => {
        setInput(newInput);
        console.log(
          `VacancyApplicationSearchLoader onSearch: Source: ${source}`
        );
        const searchInput = {
          input
        };
        loadQuery48(searchInput, { fetchPolicy: "network-only" });
      });
    },
    [setInput, input, loadQuery48]
  );
  useEffect39(() => {
    onSearch("VacancyApplicationSearchLoader Search On Render", {
      ...input,
      filters: input.filters
    });
  }, [input, onSearch]);
  if (!queryReference) {
    return /* @__PURE__ */ jsx325(EdSkeleton95, {});
  }
  return /* @__PURE__ */ jsx325(Suspense111, { fallback: /* @__PURE__ */ jsx325(EdSkeleton95, {}), children: /* @__PURE__ */ jsxs211("div", { className: "lg:my-0", children: [
    /* @__PURE__ */ jsx325(HeaderBar, { title: "Applications", children: /* @__PURE__ */ jsxs211("div", { className: "flex w-full flex-col gap-1 md:flex-row lg:flex-row lg:gap-4", children: [
      /* @__PURE__ */ jsx325("div", { className: "w-full lg:min-w-[300px]", children: /* @__PURE__ */ jsx325(VacancyApplicationSearchBox, { onSearch }) }),
      /* @__PURE__ */ jsxs211("div", { className: "flex w-full items-end gap-1 lg:justify-start", children: [
        /* @__PURE__ */ jsx325("div", { className: "flex w-full lg:w-[200px]", children: /* @__PURE__ */ jsx325(VacancyApplicationSortFields, { onSearch }) }),
        /* @__PURE__ */ jsx325(VacancyApplicationSortDir, { onSearch })
      ] })
    ] }) }),
    /* @__PURE__ */ jsx325(Suspense111, { fallback: /* @__PURE__ */ jsx325(EdSkeleton95, {}), children: /* @__PURE__ */ jsx325(
      VacancyApplicationSearch,
      {
        queryRef: queryReference,
        onSearch,
        showSearch: false,
        showSort: false
      }
    ) })
  ] }) });
};
var CandidateApplicationSearchList = memo6(
  CandidateApplicationSearchListComponent
);

// src/candidates/components/CandidateApplicationRoute.tsx
import { Navigate as Navigate14 } from "react-router-dom";
import { ErrorContainer as ErrorContainer14 } from "shared-ui";

// src/candidates/components/__generated__/CandidateApplicationActivityRouteQuery.graphql.ts
var node358 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "applicationCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "applicationCode",
      "variableName": "applicationCode"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "applicationId",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "vacancyName",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "concreteType": "EventRecord",
    "kind": "LinkedField",
    "name": "events",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "eventId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "created",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "eventType",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v9 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateApplicationActivityRouteQuery",
      "selections": [
        {
          "alias": "application",
          "args": v1,
          "concreteType": "Application",
          "kind": "LinkedField",
          "name": "applicationByCode",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            v5,
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "candidate",
              "plural": false,
              "selections": [
                v6,
                v7
              ],
              "storageKey": null
            },
            v8,
            v9
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateApplicationActivityRouteQuery",
      "selections": [
        {
          "alias": "application",
          "args": v1,
          "concreteType": "Application",
          "kind": "LinkedField",
          "name": "applicationByCode",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            v5,
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "candidate",
              "plural": false,
              "selections": [
                v6,
                v7,
                v23
              ],
              "storageKey": null
            },
            v8,
            v9
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "25952dfb409a8605d7dec4633e2cd172",
      "id": null,
      "metadata": {},
      "name": "CandidateApplicationActivityRouteQuery",
      "operationKind": "query",
      "text": "query CandidateApplicationActivityRouteQuery(\n  $applicationCode: Int!\n) {\n  application: applicationByCode(applicationCode: $applicationCode) {\n    id\n    code\n    applicationId\n    vacancyName\n    candidate {\n      firstName\n      lastName\n      id\n    }\n    events {\n      eventId\n      created\n      eventType\n    }\n  }\n}\n"
    }
  };
}();
node358.hash = "503c9f23818d55cff27b6f130e92fe89";
var CandidateApplicationActivityRouteQuery_graphql_default = node358;

// src/candidates/components/CandidateApplicationActivity.tsx
import { Suspense as Suspense113 } from "react";
import { loadQuery as loadQuery36 } from "react-relay";
import { Link as Link26 } from "react-router-dom";
import { useRouteData as useRouteData21 } from "shared-lib";
import { EdSkeleton as EdSkeleton96 } from "shared-ui";
import { Fragment as Fragment86, jsx as jsx326, jsxs as jsxs213 } from "react/jsx-runtime";
var queryDef58 = CandidateApplicationActivityRouteQuery_graphql_default;
async function loader30(environment, params) {
  const code = params.applicationCode;
  const applicationCode = parseInt(code);
  return loadQuery36(
    environment,
    queryDef58,
    {
      applicationCode
    }
  );
}
var CandidateApplicationActivity = ({
  routeId: routeId4
}) => {
  const data = useRouteData21(
    queryDef58,
    routeId4
  );
  const { application: application3 } = data;
  if (!application3) {
    return /* @__PURE__ */ jsx326(Fragment86, { children: "Loading..." });
  }
  const events = application3.events.map((e4) => /* @__PURE__ */ jsxs213("div", { className: "flex gap-2 border-b bg-white p-4", children: [
    /* @__PURE__ */ jsx326("div", { children: e4.created }),
    /* @__PURE__ */ jsx326("div", { children: e4.eventType })
  ] }, e4.eventId));
  return /* @__PURE__ */ jsx326(Suspense113, { fallback: /* @__PURE__ */ jsx326(EdSkeleton96, {}), children: /* @__PURE__ */ jsx326("div", { className: "border-b bg-white p-4", children: /* @__PURE__ */ jsx326("div", { className: "flex", children: /* @__PURE__ */ jsx326("div", { className: "flex flex-col gap-2 p-4", children: events }) }) }) });
};
var createRoute24 = (routePrefix, environment, context) => {
  const routeId4 = `${routePrefix}-application-search-activity`;
  return {
    id: routeId4,
    path: "activity",
    element: /* @__PURE__ */ jsx326(CandidateApplicationActivity, { routeId: routeId4 }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx326(Link26, { to: "activity", children: "Activity" })
    },
    loader: ({ params }) => {
      return loader30(environment, params);
    }
  };
};

// src/candidates/components/__generated__/CandidateApplicationInboxRouteQuery.graphql.ts
var node359 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "applicationCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "applicationCode",
      "variableName": "applicationCode"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "applicationId",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "vacancyName",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v8 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateApplicationInboxRouteQuery",
      "selections": [
        {
          "alias": "application",
          "args": v1,
          "concreteType": "Application",
          "kind": "LinkedField",
          "name": "applicationByCode",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            v5,
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "candidate",
              "plural": false,
              "selections": [
                v6,
                v7
              ],
              "storageKey": null
            },
            v8
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateApplicationInboxRouteQuery",
      "selections": [
        {
          "alias": "application",
          "args": v1,
          "concreteType": "Application",
          "kind": "LinkedField",
          "name": "applicationByCode",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            v5,
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "candidate",
              "plural": false,
              "selections": [
                v6,
                v7,
                v23
              ],
              "storageKey": null
            },
            v8
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "eb554d57aeb0c1f6b87e13f9b9db192c",
      "id": null,
      "metadata": {},
      "name": "CandidateApplicationInboxRouteQuery",
      "operationKind": "query",
      "text": "query CandidateApplicationInboxRouteQuery(\n  $applicationCode: Int!\n) {\n  application: applicationByCode(applicationCode: $applicationCode) {\n    id\n    code\n    applicationId\n    vacancyName\n    candidate {\n      firstName\n      lastName\n      id\n    }\n  }\n}\n"
    }
  };
}();
node359.hash = "2c1ddfbc81febed6fd7607ea3225ab10";
var CandidateApplicationInboxRouteQuery_graphql_default = node359;

// src/candidates/components/CandidateApplicationInbox.tsx
import { Suspense as Suspense114, useCallback as useCallback184 } from "react";
import { loadQuery as loadQuery37 } from "react-relay";
import { Link as Link27, Navigate as Navigate13, Outlet as Outlet12, useNavigate as useNavigate24 } from "react-router-dom";
import { useRouteData as useRouteData22 } from "shared-lib";
import { EdSkeleton as EdSkeleton97 } from "shared-ui";
import { Fragment as Fragment87, jsx as jsx327 } from "react/jsx-runtime";
var queryDef59 = CandidateApplicationInboxRouteQuery_graphql_default;
async function loader31(environment, params) {
  const code = params.applicationCode;
  const applicationCode = parseInt(code);
  return loadQuery37(environment, queryDef59, {
    applicationCode
  });
}
var InboxLayout = ({ routeId: routeId4 }) => {
  const data = useRouteData22(
    queryDef59,
    routeId4
  );
  const { application: application3 } = data;
  if (!application3) {
    return /* @__PURE__ */ jsx327(Fragment87, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx327(Suspense114, { fallback: /* @__PURE__ */ jsx327(EdSkeleton97, {}), children: /* @__PURE__ */ jsx327("div", { className: "", children: /* @__PURE__ */ jsx327(Outlet12, {}) }) });
};
var InboxList = ({ routeId: routeId4 }) => {
  const navigate = useNavigate24();
  const data = useRouteData22(
    queryDef59,
    routeId4
  );
  const navigateToChat = useCallback184((id18) => {
    navigate(`../item/${id18}`);
  }, []);
  const { application: application3 } = data;
  if (!application3) {
    return /* @__PURE__ */ jsx327(Fragment87, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx327(Suspense114, { fallback: /* @__PURE__ */ jsx327(EdSkeleton97, {}), children: /* @__PURE__ */ jsx327("div", { className: "border-b bg-white p-4", children: /* @__PURE__ */ jsx327(
    ApplicationChat,
    {
      applicationId: application3.applicationId,
      onSelect: navigateToChat
    }
  ) }) });
};
var InboxItem = ({ routeId: routeId4 }) => {
  const navigate = useNavigate24();
  const data = useRouteData22(
    queryDef59,
    routeId4
  );
  const navigateToList = useCallback184(() => {
    navigate(`../list`);
  }, []);
  const { application: application3 } = data;
  if (!application3) {
    return /* @__PURE__ */ jsx327(Fragment87, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx327(Suspense114, { fallback: /* @__PURE__ */ jsx327(EdSkeleton97, {}), children: /* @__PURE__ */ jsx327("div", { className: "", children: /* @__PURE__ */ jsx327(
    ApplicationConversationContainer,
    {
      idKey: "conversationId",
      showBackButton: true,
      backLink: "../list"
    }
  ) }) });
};
var createRoute25 = (routePrefix, environment, context) => {
  const routeId4 = `${routePrefix}-application-search-inbox`;
  return {
    id: routeId4,
    path: "inbox/*",
    element: /* @__PURE__ */ jsx327(InboxLayout, { routeId: routeId4 }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx327(Link27, { to: "inbox", children: "Inbox" })
    },
    loader: ({ params }) => {
      return loader31(environment, params);
    },
    children: [
      {
        id: `${routeId4}-list`,
        path: "list",
        element: /* @__PURE__ */ jsx327(InboxList, { routeId: routeId4 })
      },
      {
        id: `${routeId4}-item`,
        path: "item/:conversationId",
        element: /* @__PURE__ */ jsx327(InboxItem, { routeId: routeId4 })
      },
      {
        path: "*",
        element: /* @__PURE__ */ jsx327(Navigate13, { to: "list", replace: true })
      }
    ]
  };
};

// src/candidates/components/__generated__/CandidateApplicationOffersRouteQuery.graphql.ts
var node360 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "applicationCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "applicationCode",
      "variableName": "applicationCode"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "applicationId",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "vacancyName",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v8 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateApplicationOffersRouteQuery",
      "selections": [
        {
          "alias": "application",
          "args": v1,
          "concreteType": "Application",
          "kind": "LinkedField",
          "name": "applicationByCode",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            v5,
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "candidate",
              "plural": false,
              "selections": [
                v6,
                v7
              ],
              "storageKey": null
            },
            v8
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateApplicationOffersRouteQuery",
      "selections": [
        {
          "alias": "application",
          "args": v1,
          "concreteType": "Application",
          "kind": "LinkedField",
          "name": "applicationByCode",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            v5,
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "candidate",
              "plural": false,
              "selections": [
                v6,
                v7,
                v23
              ],
              "storageKey": null
            },
            v8
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "f2eda244acd97f7aef3f5efce5e6c5c9",
      "id": null,
      "metadata": {},
      "name": "CandidateApplicationOffersRouteQuery",
      "operationKind": "query",
      "text": "query CandidateApplicationOffersRouteQuery(\n  $applicationCode: Int!\n) {\n  application: applicationByCode(applicationCode: $applicationCode) {\n    id\n    code\n    applicationId\n    vacancyName\n    candidate {\n      firstName\n      lastName\n      id\n    }\n  }\n}\n"
    }
  };
}();
node360.hash = "d3c7ee3da560637459c292631933f822";
var CandidateApplicationOffersRouteQuery_graphql_default = node360;

// src/candidates/components/CandidateApplicationOffers.tsx
import { Suspense as Suspense118 } from "react";
import { loadQuery as loadQuery40 } from "react-relay";
import { Link as Link29 } from "react-router-dom";
import { useRouteData as useRouteData23 } from "shared-lib";
import { EdSkeleton as EdSkeleton100 } from "shared-ui";
import { OutletRoute as OutletRoute5 } from "app-core";

// src/offers/components/__generated__/ApplicationOfferSearchListPaginationQuery.graphql.ts
var node361 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v23 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v32 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }, v4 = [
    v1,
    v23,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "updatedAt": "DESC"
        }
      ]
    },
    v32
  ], v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ApplicationOfferSearchListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v23,
            v32
          ],
          "kind": "FragmentSpread",
          "name": "ApplicationOfferSearchList_offers"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ApplicationOfferSearchListPaginationQuery",
      "selections": [
        {
          "alias": "offers",
          "args": v4,
          "concreteType": "RecruitOffersConnection",
          "kind": "LinkedField",
          "name": "recruitOffers",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitOffersEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitOffer",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v5,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "offerId",
                      "storageKey": null
                    },
                    v6,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountsCandidateAccount",
                      "kind": "LinkedField",
                      "name": "candidate",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "firstName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "lastName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "email",
                          "storageKey": null
                        },
                        v5
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Vacancy",
                      "kind": "LinkedField",
                      "name": "vacancy",
                      "plural": false,
                      "selections": [
                        v5,
                        v6,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "offers",
          "args": v4,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "ApplicationOfferSearchList_offers",
          "kind": "LinkedHandle",
          "name": "recruitOffers"
        }
      ]
    },
    "params": {
      "cacheID": "825d333e11d8beee70da7d33abed830e",
      "id": null,
      "metadata": {},
      "name": "ApplicationOfferSearchListPaginationQuery",
      "operationKind": "query",
      "text": "query ApplicationOfferSearchListPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $where: RecruitOfferFilter\n) {\n  ...ApplicationOfferSearchList_offers_3sueo6\n}\n\nfragment ApplicationOfferSearchList_offers_3sueo6 on Query {\n  offers: recruitOffers(first: $first, after: $after, order: [{updatedAt: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        offerId\n        code\n        __typename\n      }\n    }\n    ...OfferSearchResults_offers\n  }\n}\n\nfragment OfferSearchResults_offers on RecruitOffersConnection {\n  pageInfo {\n    hasNextPage\n    hasPreviousPage\n    startCursor\n    endCursor\n  }\n  edges {\n    cursor\n    node {\n      id\n      offerId\n      code\n      createdAt\n      updatedAt\n      status\n      candidate {\n        firstName\n        lastName\n        email\n        id\n      }\n      vacancy {\n        id\n        code\n        name\n      }\n    }\n  }\n}\n"
    }
  };
}();
node361.hash = "1cd675e858ab10b2f0286dd1d60ce0aa";
var ApplicationOfferSearchListPaginationQuery_graphql_default = node361;

// src/offers/components/__generated__/ApplicationOfferSearchList_offers.graphql.ts
var node363 = function() {
  var v0 = [
    "offers"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": ApplicationOfferSearchListPaginationQuery_graphql_default
      }
    },
    "name": "ApplicationOfferSearchList_offers",
    "selections": [
      {
        "alias": "offers",
        "args": [
          {
            "kind": "Literal",
            "name": "order",
            "value": [
              {
                "updatedAt": "DESC"
              }
            ]
          },
          {
            "kind": "Variable",
            "name": "where",
            "variableName": "where"
          }
        ],
        "concreteType": "RecruitOffersConnection",
        "kind": "LinkedField",
        "name": "__ApplicationOfferSearchList_offers_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitOffersEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitOffer",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "offerId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "OfferSearchResults_offers"
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node363.hash = "1cd675e858ab10b2f0286dd1d60ce0aa";
var ApplicationOfferSearchList_offers_graphql_default = node363;

// src/offers/components/__generated__/ApplicationOfferSearchListQuery.graphql.ts
var node364 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }, v23 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "updatedAt": "DESC"
        }
      ]
    },
    v1
  ], v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ApplicationOfferSearchListQuery",
      "selections": [
        {
          "args": [
            v1
          ],
          "kind": "FragmentSpread",
          "name": "ApplicationOfferSearchList_offers"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ApplicationOfferSearchListQuery",
      "selections": [
        {
          "alias": "offers",
          "args": v23,
          "concreteType": "RecruitOffersConnection",
          "kind": "LinkedField",
          "name": "recruitOffers",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitOffersEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitOffer",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v32,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "offerId",
                      "storageKey": null
                    },
                    v4,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountsCandidateAccount",
                      "kind": "LinkedField",
                      "name": "candidate",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "firstName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "lastName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "email",
                          "storageKey": null
                        },
                        v32
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Vacancy",
                      "kind": "LinkedField",
                      "name": "vacancy",
                      "plural": false,
                      "selections": [
                        v32,
                        v4,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "offers",
          "args": v23,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "ApplicationOfferSearchList_offers",
          "kind": "LinkedHandle",
          "name": "recruitOffers"
        }
      ]
    },
    "params": {
      "cacheID": "1e67477f34b506fea3939c0ec3687dd6",
      "id": null,
      "metadata": {},
      "name": "ApplicationOfferSearchListQuery",
      "operationKind": "query",
      "text": "query ApplicationOfferSearchListQuery(\n  $where: RecruitOfferFilter!\n) {\n  ...ApplicationOfferSearchList_offers_3FC4Qo\n}\n\nfragment ApplicationOfferSearchList_offers_3FC4Qo on Query {\n  offers: recruitOffers(first: 10, order: [{updatedAt: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        offerId\n        code\n        __typename\n      }\n    }\n    ...OfferSearchResults_offers\n  }\n}\n\nfragment OfferSearchResults_offers on RecruitOffersConnection {\n  pageInfo {\n    hasNextPage\n    hasPreviousPage\n    startCursor\n    endCursor\n  }\n  edges {\n    cursor\n    node {\n      id\n      offerId\n      code\n      createdAt\n      updatedAt\n      status\n      candidate {\n        firstName\n        lastName\n        email\n        id\n      }\n      vacancy {\n        id\n        code\n        name\n      }\n    }\n  }\n}\n"
    }
  };
}();
node364.hash = "10ac8e6bdb30d8a2afc9183e0517a118";
var ApplicationOfferSearchListQuery_graphql_default = node364;

// src/offers/components/ApplicationOfferSearchList.tsx
import { Suspense as Suspense115 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery48, usePaginationFragment as usePaginationFragment17 } from "react-relay";
import { EdSkeleton as EdSkeleton98 } from "shared-ui";

// src/offers/components/__generated__/OfferSearchResults_offers.graphql.ts
var node365 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "OfferSearchResults_offers",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasNextPage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasPreviousPage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startCursor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "endCursor",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitOffersEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cursor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitOffer",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              v0,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "offerId",
                "storageKey": null
              },
              v1,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountsCandidateAccount",
                "kind": "LinkedField",
                "name": "candidate",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "email",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Vacancy",
                "kind": "LinkedField",
                "name": "vacancy",
                "plural": false,
                "selections": [
                  v0,
                  v1,
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RecruitOffersConnection",
    "abstractKey": null
  };
}();
node365.hash = "0b324f3bc97568f0ccc5f2452ad26628";
var OfferSearchResults_offers_graphql_default = node365;

// src/offers/components/OfferSearchResults.tsx
import { isValidElement as isValidElement6 } from "react";
import { useFragment as useFragment100 } from "react-relay";
import { formatDistanceToNow as formatDistanceToNow5, parseISO as parseISO12 } from "date-fns";
import { isNotNullOrUndefined as isNotNullOrUndefined9 } from "shared-lib";
import { EdButtonLink as EdButtonLink6, ListLayout as ListLayout5, Tag as Tag22 } from "shared-ui";
import { jsx as jsx328, jsxs as jsxs214 } from "react/jsx-runtime";
var fragmentDef80 = OfferSearchResults_offers_graphql_default;
var SectionElement4 = ({ children }) => {
  return /* @__PURE__ */ jsx328("div", { className: "px-2 py-1 sm:px-8 sm:py-5", children });
};
var ItemHeader3 = ({ section }) => {
  const code = section.context.code;
  const titleIsElement = isValidElement6(section.itemTitle);
  return /* @__PURE__ */ jsxs214("div", { children: [
    /* @__PURE__ */ jsx328("div", { children: /* @__PURE__ */ jsx328("h1", { children: "Application" }) }),
    titleIsElement ? section.itemTitle : /* @__PURE__ */ jsx328("div", { className: "font-InterMedium text-info-gray-800 text-3xl font-bold tracking-tight", children: section.itemTitle }),
    /* @__PURE__ */ jsx328("div", { className: "flex items-center space-x-2 sm:justify-end", children: /* @__PURE__ */ jsx328(EdButtonLink6, { name: "View", to: `../../../view/${code}` }) })
  ] });
};
var OfferSearchResults = ({
  fragmentRef,
  loadNext
}) => {
  const data = useFragment100(
    fragmentDef80,
    fragmentRef
  );
  const sections = (data.edges || []).filter(isNotNullOrUndefined9).map((e4) => e4.node).map((offer) => {
    const name = `${offer.candidate.firstName} ${offer.candidate.lastName}`;
    return {
      key: offer.code.toString(),
      mobileLink: `../${offer.code}`,
      itemTitle: name,
      listTitle: /* @__PURE__ */ jsxs214("div", { className: "flex w-full flex-col gap-2", children: [
        /* @__PURE__ */ jsxs214("div", { className: "flex grow justify-between", children: [
          /* @__PURE__ */ jsx328("div", { className: "text-md font-medium uppercase", children: name }),
          /* @__PURE__ */ jsx328(Tag22, { children: offer.status })
        ] }),
        /* @__PURE__ */ jsx328("div", { className: "text-primary-900 text-sm font-medium", children: offer.vacancy.name })
      ] }),
      description: `Updated ${formatDistanceToNow5(
        parseISO12(offer.updatedAt)
      )}`,
      hideIcon: true,
      icon: () => null,
      iconForeground: "text-primary-700",
      iconBackground: "bg-primary-50",
      context: {
        code: offer.code
      },
      element: /* @__PURE__ */ jsx328(SectionElement4, { children: /* @__PURE__ */ jsx328("div", { className: "grid", children: /* @__PURE__ */ jsx328("div", { children: offer.code }) }) })
    };
  });
  return /* @__PURE__ */ jsx328(
    ListLayout5,
    {
      title: "Offers",
      sections,
      itemHeader: (s4) => /* @__PURE__ */ jsx328(ItemHeader3, { section: s4 }),
      loadMore: loadNext,
      isLoading: false,
      showFilters: true
    }
  );
};

// src/offers/components/ApplicationOfferSearchList.tsx
import { jsx as jsx329 } from "react/jsx-runtime";
var fragmentDef81 = ApplicationOfferSearchList_offers_graphql_default;
var OfferSearchListLayout = ({ fragmentRef }) => {
  const { data, loadNext } = usePaginationFragment17(fragmentDef81, fragmentRef);
  const { offers } = data;
  if (offers === null || offers === void 0) {
    return /* @__PURE__ */ jsx329(EdSkeleton98, {});
  }
  return /* @__PURE__ */ jsx329(OfferSearchResults, { fragmentRef: offers, loadNext: () => loadNext(15) });
};
var queryDef60 = ApplicationOfferSearchListQuery_graphql_default;
var ApplicationOfferSearchList = ({
  applicationId
}) => {
  const where = { applicationId: { eq: applicationId } };
  const query3 = useLazyLoadQuery48(
    queryDef60,
    { where },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsx329(Suspense115, { fallback: /* @__PURE__ */ jsx329(EdSkeleton98, {}), children: query3 && /* @__PURE__ */ jsx329(OfferSearchListLayout, { fragmentRef: query3 }) });
};

// src/offers/components/__generated__/EmployersOfferSearchListPaginationQuery.graphql.ts
var node366 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v23 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v32 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }, v4 = [
    v1,
    v23,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "updatedAt": "DESC"
        }
      ]
    },
    v32
  ], v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployersOfferSearchListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v23,
            v32
          ],
          "kind": "FragmentSpread",
          "name": "EmployersOfferSearchList_offers"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployersOfferSearchListPaginationQuery",
      "selections": [
        {
          "alias": "offers",
          "args": v4,
          "concreteType": "RecruitOffersConnection",
          "kind": "LinkedField",
          "name": "recruitOffers",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitOffersEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitOffer",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v5,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "offerId",
                      "storageKey": null
                    },
                    v6,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountsCandidateAccount",
                      "kind": "LinkedField",
                      "name": "candidate",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "firstName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "lastName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "email",
                          "storageKey": null
                        },
                        v5
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Vacancy",
                      "kind": "LinkedField",
                      "name": "vacancy",
                      "plural": false,
                      "selections": [
                        v5,
                        v6,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "offers",
          "args": v4,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "EmployersOfferSearchList_offers",
          "kind": "LinkedHandle",
          "name": "recruitOffers"
        }
      ]
    },
    "params": {
      "cacheID": "df6a7efa85c16609e6664417aad034ee",
      "id": null,
      "metadata": {},
      "name": "EmployersOfferSearchListPaginationQuery",
      "operationKind": "query",
      "text": "query EmployersOfferSearchListPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $where: RecruitOfferFilter\n) {\n  ...EmployersOfferSearchList_offers_3sueo6\n}\n\nfragment EmployersOfferSearchList_offers_3sueo6 on Query {\n  offers: recruitOffers(first: $first, after: $after, order: [{updatedAt: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        offerId\n        code\n        __typename\n      }\n    }\n    ...OfferSearchResults_offers\n  }\n}\n\nfragment OfferSearchResults_offers on RecruitOffersConnection {\n  pageInfo {\n    hasNextPage\n    hasPreviousPage\n    startCursor\n    endCursor\n  }\n  edges {\n    cursor\n    node {\n      id\n      offerId\n      code\n      createdAt\n      updatedAt\n      status\n      candidate {\n        firstName\n        lastName\n        email\n        id\n      }\n      vacancy {\n        id\n        code\n        name\n      }\n    }\n  }\n}\n"
    }
  };
}();
node366.hash = "7284c1cfad945318cb25e45d2e6d7011";
var EmployersOfferSearchListPaginationQuery_graphql_default = node366;

// src/offers/components/__generated__/EmployersOfferSearchList_offers.graphql.ts
var node367 = function() {
  var v0 = [
    "offers"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": EmployersOfferSearchListPaginationQuery_graphql_default
      }
    },
    "name": "EmployersOfferSearchList_offers",
    "selections": [
      {
        "alias": "offers",
        "args": [
          {
            "kind": "Literal",
            "name": "order",
            "value": [
              {
                "updatedAt": "DESC"
              }
            ]
          },
          {
            "kind": "Variable",
            "name": "where",
            "variableName": "where"
          }
        ],
        "concreteType": "RecruitOffersConnection",
        "kind": "LinkedField",
        "name": "__EmployersOfferSearchList_offers_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitOffersEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitOffer",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "offerId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "OfferSearchResults_offers"
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node367.hash = "7284c1cfad945318cb25e45d2e6d7011";
var EmployersOfferSearchList_offers_graphql_default = node367;

// src/offers/components/__generated__/EmployersOfferSearchListQuery.graphql.ts
var node368 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }, v23 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "updatedAt": "DESC"
        }
      ]
    },
    v1
  ], v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployersOfferSearchListQuery",
      "selections": [
        {
          "args": [
            v1
          ],
          "kind": "FragmentSpread",
          "name": "EmployersOfferSearchList_offers"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployersOfferSearchListQuery",
      "selections": [
        {
          "alias": "offers",
          "args": v23,
          "concreteType": "RecruitOffersConnection",
          "kind": "LinkedField",
          "name": "recruitOffers",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitOffersEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitOffer",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v32,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "offerId",
                      "storageKey": null
                    },
                    v4,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountsCandidateAccount",
                      "kind": "LinkedField",
                      "name": "candidate",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "firstName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "lastName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "email",
                          "storageKey": null
                        },
                        v32
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Vacancy",
                      "kind": "LinkedField",
                      "name": "vacancy",
                      "plural": false,
                      "selections": [
                        v32,
                        v4,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "offers",
          "args": v23,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "EmployersOfferSearchList_offers",
          "kind": "LinkedHandle",
          "name": "recruitOffers"
        }
      ]
    },
    "params": {
      "cacheID": "ec9049b0264194dafcf8ca0f1e0648cf",
      "id": null,
      "metadata": {},
      "name": "EmployersOfferSearchListQuery",
      "operationKind": "query",
      "text": "query EmployersOfferSearchListQuery(\n  $where: RecruitOfferFilter!\n) {\n  ...EmployersOfferSearchList_offers_3FC4Qo\n}\n\nfragment EmployersOfferSearchList_offers_3FC4Qo on Query {\n  offers: recruitOffers(first: 10, order: [{updatedAt: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        offerId\n        code\n        __typename\n      }\n    }\n    ...OfferSearchResults_offers\n  }\n}\n\nfragment OfferSearchResults_offers on RecruitOffersConnection {\n  pageInfo {\n    hasNextPage\n    hasPreviousPage\n    startCursor\n    endCursor\n  }\n  edges {\n    cursor\n    node {\n      id\n      offerId\n      code\n      createdAt\n      updatedAt\n      status\n      candidate {\n        firstName\n        lastName\n        email\n        id\n      }\n      vacancy {\n        id\n        code\n        name\n      }\n    }\n  }\n}\n"
    }
  };
}();
node368.hash = "b5d082f36ebed9aa7b4c270cf9cd49c5";
var EmployersOfferSearchListQuery_graphql_default = node368;

// src/offers/components/EmployersOfferSearchList.tsx
import { Suspense as Suspense116, useEffect as useEffect40 } from "react";
import {
  loadQuery as loadQuery38,
  usePaginationFragment as usePaginationFragment18,
  usePreloadedQuery as usePreloadedQuery37,
  useQueryLoader as useQueryLoader18
} from "react-relay";
import { EdSkeleton as EdSkeleton99 } from "shared-ui";
import { resolveEmployerId as resolveEmployerId3 } from "app-core";
import { jsx as jsx330 } from "react/jsx-runtime";
var fragmentDef82 = EmployersOfferSearchList_offers_graphql_default;
var OfferSearchListLayout2 = ({ fragmentRef }) => {
  const { data, loadNext } = usePaginationFragment18(fragmentDef82, fragmentRef);
  const { offers } = data;
  if (offers === null || offers === void 0) {
    return /* @__PURE__ */ jsx330(EdSkeleton99, {});
  }
  return /* @__PURE__ */ jsx330(OfferSearchResults, { fragmentRef: offers, loadNext: () => loadNext(15) });
};
var queryDef61 = EmployersOfferSearchListQuery_graphql_default;
var EmployerOfferSearchListLoader = ({
  queryRef: queryRef3
}) => {
  const data = usePreloadedQuery37(
    queryDef61,
    queryRef3
  );
  return /* @__PURE__ */ jsx330(OfferSearchListLayout2, { fragmentRef: data });
};
var EmployersOfferSearchList = ({ employerId }) => {
  const [queryReference, loadQuery48] = useQueryLoader18(queryDef61);
  useEffect40(() => {
    const where = { employerId: { eq: employerId } };
    loadQuery48({ where }, { fetchPolicy: "network-only" });
  }, [loadQuery48, employerId]);
  return /* @__PURE__ */ jsx330(Suspense116, { fallback: /* @__PURE__ */ jsx330(EdSkeleton99, {}), children: queryReference && /* @__PURE__ */ jsx330(EmployerOfferSearchListLoader, { queryRef: queryReference }) });
};

// src/offers/components/OfferRoutes.tsx
import { ErrorContainer as ErrorContainer13 } from "shared-ui";
import { OutletRoute as OutletRoute4 } from "app-core";

// src/offers/components/__generated__/OfferLayoutQuery.graphql.ts
var node369 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "offerCode"
    }
  ], v1 = [
    {
      "alias": "offer",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "offerCode"
        }
      ],
      "concreteType": "RecruitOffer",
      "kind": "LinkedField",
      "name": "recruitOfferByCode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "offerId",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "OfferLayoutQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "OfferLayoutQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "77c3efb5754207008cce29e031a14ff8",
      "id": null,
      "metadata": {},
      "name": "OfferLayoutQuery",
      "operationKind": "query",
      "text": "query OfferLayoutQuery(\n  $offerCode: Long!\n) {\n  offer: recruitOfferByCode(code: $offerCode) {\n    id\n    code\n    offerId\n  }\n}\n"
    }
  };
}();
node369.hash = "cb7f464ebf8adb90e1fcb5f9ead4d121";
var OfferLayoutQuery_graphql_default = node369;

// src/offers/components/OfferLayout.tsx
import { Suspense as Suspense117 } from "react";
import { Link as Link28, useRouteLoaderData as useRouteLoaderData16 } from "react-router-dom";
import {
  loadQuery as loadQuery39,
  usePreloadedQuery as usePreloadedQuery38
} from "react-relay";
import { Fragment as Fragment88, jsx as jsx331 } from "react/jsx-runtime";
var offerLayoutQueryDef = OfferLayoutQuery_graphql_default;
var OfferLink = ({ routeId: routeId4 }) => {
  const data = useOfferRouteData(routeId4);
  if (!data.offer) {
    return /* @__PURE__ */ jsx331(Fragment88, {});
  }
  return /* @__PURE__ */ jsx331(Suspense117, { fallback: "Loading...", children: /* @__PURE__ */ jsx331(Link28, { to: ".", children: data.offer.code }) });
};
async function loader32(environment, params) {
  const code = params.offerCode;
  const offerCode = Number(code);
  return loadQuery39(environment, offerLayoutQueryDef, {
    offerCode
  });
}
function useOfferRouteData(routeId4) {
  const queryRef3 = useRouteLoaderData16(
    routeId4
  );
  const data = usePreloadedQuery38(
    offerLayoutQueryDef,
    queryRef3
  );
  return data;
}

// src/offers/components/OfferRoutes.tsx
import { jsx as jsx333 } from "react/jsx-runtime";
var createOfferRoutes = (routePrefix, environment, context, showHeader) => {
  const routeId4 = `${routePrefix}-offer`;
  return [
    {
      path: "*",
      id: routeId4,
      element: /* @__PURE__ */ jsx333(OutletRoute4, {}),
      errorElement: /* @__PURE__ */ jsx333(ErrorContainer13, {}),
      handle: {
        crumb: () => /* @__PURE__ */ jsx333(OfferLink, { routeId: routeId4 })
      },
      loader: ({ params }) => {
        return loader32(environment, params);
      },
      children: [
        createRoute20(routeId4, environment, context, showHeader)
      ]
    }
  ];
};

// src/candidates/components/CandidateApplicationOffers.tsx
import { Fragment as Fragment89, jsx as jsx334 } from "react/jsx-runtime";
var queryDef62 = CandidateApplicationOffersRouteQuery_graphql_default;
async function loader33(environment, params) {
  const code = params.applicationCode;
  const applicationCode = parseInt(code);
  return loadQuery40(
    environment,
    queryDef62,
    {
      applicationCode
    }
  );
}
var CandidateApplicationOffers = ({
  routeId: routeId4
}) => {
  const data = useRouteData23(
    queryDef62,
    routeId4
  );
  const { application: application3 } = data;
  if (!application3) {
    return /* @__PURE__ */ jsx334(Fragment89, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx334(Suspense118, { fallback: /* @__PURE__ */ jsx334(EdSkeleton100, {}), children: /* @__PURE__ */ jsx334("div", { className: "border-b bg-white p-4", children: /* @__PURE__ */ jsx334(ApplicationOfferSearchList, { applicationId: application3.applicationId }) }) });
};
var createRoute26 = (routePrefix, environment, context) => {
  const routeId4 = `${routePrefix}-application-search-offers`;
  const childOfferRouteId = `${routePrefix}-application-search-offer`;
  return {
    id: routeId4,
    path: "offers",
    element: /* @__PURE__ */ jsx334(OutletRoute5, {}),
    handle: {
      crumb: () => /* @__PURE__ */ jsx334(Link29, { to: "offers", children: "Offers" })
    },
    loader: ({ params }) => {
      return loader33(environment, params);
    },
    children: [
      {
        id: routeId4 + "-all",
        path: "*",
        element: /* @__PURE__ */ jsx334(CandidateApplicationOffers, { routeId: routeId4 }),
        children: [
          {
            id: childOfferRouteId,
            path: ":offerCode/*",
            element: /* @__PURE__ */ jsx334(OutletRoute5, {}),
            children: createOfferRoutes(
              childOfferRouteId,
              environment,
              context,
              false
            )
          }
        ]
      },
      {
        id: routeId4 + "-list",
        path: "list",
        element: /* @__PURE__ */ jsx334("div", { children: "kust" })
      }
    ]
  };
};

// src/candidates/components/__generated__/CandidateApplicationNotesRouteQuery.graphql.ts
var node370 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "applicationCode"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "applicationCode",
    "variableName": "applicationCode"
  }, v23 = [
    v1
  ], v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "applicationId",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "publicDescriptionHtml",
    "storageKey": null
  }, v8 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }, v9 = [
    v1,
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateApplicationNotesRouteQuery",
      "selections": [
        {
          "args": v23,
          "kind": "FragmentSpread",
          "name": "CandidateApplicationNotesEditor_notes"
        },
        {
          "alias": "application",
          "args": v23,
          "concreteType": "Application",
          "kind": "LinkedField",
          "name": "applicationByCode",
          "plural": false,
          "selections": [
            v32,
            v4,
            v5,
            {
              "alias": null,
              "args": null,
              "concreteType": "Vacancy",
              "kind": "LinkedField",
              "name": "vacancy",
              "plural": false,
              "selections": [
                v6,
                v4,
                v7
              ],
              "storageKey": null
            },
            v8
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateApplicationNotesRouteQuery",
      "selections": [
        {
          "alias": "notes",
          "args": v9,
          "concreteType": "RecruitApplicationNotesConnection",
          "kind": "LinkedField",
          "name": "recruitApplicationNotes",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitApplicationNotesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitApplicationNote",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v32,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "noteId",
                      "storageKey": null
                    },
                    v4,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "content",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitApplicationNoteTag",
                      "kind": "LinkedField",
                      "name": "tags",
                      "plural": true,
                      "selections": [
                        v6,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "value",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountsUser",
                      "kind": "LinkedField",
                      "name": "createdByUser",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "firstName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "lastName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "emailAddress",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v8
          ],
          "storageKey": null
        },
        {
          "alias": "notes",
          "args": v9,
          "filters": [],
          "handle": "connection",
          "key": "CandidateApplicationNotesEditor_notes",
          "kind": "LinkedHandle",
          "name": "recruitApplicationNotes"
        },
        {
          "alias": "application",
          "args": v23,
          "concreteType": "Application",
          "kind": "LinkedField",
          "name": "applicationByCode",
          "plural": false,
          "selections": [
            v32,
            v4,
            v5,
            {
              "alias": null,
              "args": null,
              "concreteType": "Vacancy",
              "kind": "LinkedField",
              "name": "vacancy",
              "plural": false,
              "selections": [
                v6,
                v4,
                v7,
                v32
              ],
              "storageKey": null
            },
            v8
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "ff413df415ca1998431131cbc0c22f2d",
      "id": null,
      "metadata": {},
      "name": "CandidateApplicationNotesRouteQuery",
      "operationKind": "query",
      "text": "query CandidateApplicationNotesRouteQuery(\n  $applicationCode: Int!\n) {\n  ...CandidateApplicationNotesEditor_notes_IzCDo\n  application: applicationByCode(applicationCode: $applicationCode) {\n    id\n    code\n    applicationId\n    vacancy {\n      name\n      code\n      publicDescriptionHtml\n      id\n    }\n  }\n}\n\nfragment CandidateApplicationNotesEditor_notes_IzCDo on Query {\n  notes: recruitApplicationNotes(applicationCode: $applicationCode, first: 10) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        noteId\n        code\n        updatedAt\n        content\n        tags {\n          name\n          value\n        }\n        createdByUser {\n          firstName\n          lastName\n          emailAddress\n        }\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node370.hash = "66881da978584be9732a2bd67797ef60";
var CandidateApplicationNotesRouteQuery_graphql_default = node370;

// src/candidates/components/CandidateApplicationNotes.tsx
import { Suspense as Suspense119 } from "react";
import { loadQuery as loadQuery41 } from "react-relay";
import { Link as Link30 } from "react-router-dom";
import { useRouteData as useRouteData24 } from "shared-lib";
import { EdSkeleton as EdSkeleton101 } from "shared-ui";
import { Fragment as Fragment90, jsx as jsx335 } from "react/jsx-runtime";
var queryDef63 = CandidateApplicationNotesRouteQuery_graphql_default;
async function loader34(environment, params) {
  const code = params.applicationCode;
  const applicationCode = parseInt(code);
  return loadQuery41(environment, queryDef63, {
    applicationCode
  });
}
var CandidateApplicationNotes2 = ({
  routeId: routeId4
}) => {
  const data = useRouteData24(
    queryDef63,
    routeId4
  );
  const { application: application3 } = data;
  if (!application3) {
    return /* @__PURE__ */ jsx335(Fragment90, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx335(Suspense119, { fallback: /* @__PURE__ */ jsx335(EdSkeleton101, {}), children: /* @__PURE__ */ jsx335("div", { className: "grid gap-2 border-b bg-white p-4", children: /* @__PURE__ */ jsx335(
    CandidateApplicationNotesEditor,
    {
      applicationId: application3.applicationId,
      applicationCode: application3.code,
      fragmentRef: data
    }
  ) }) });
};
var createRoute27 = (routePrefix, environment, context) => {
  const routeId4 = `${routePrefix}-application-search-notes`;
  return {
    id: routeId4,
    path: "notes",
    element: /* @__PURE__ */ jsx335(CandidateApplicationNotes2, { routeId: routeId4 }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx335(Link30, { to: "", children: "Application" })
    },
    loader: ({ params }) => {
      return loader34(environment, params);
    }
  };
};

// src/candidates/components/__generated__/CandidateDetailsApplicationRouteQuery.graphql.ts
var node371 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "applicationCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "applicationCode",
      "variableName": "applicationCode"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "applicationId",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "vacancyName",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "concreteType": "ApplicationForm",
    "kind": "LinkedField",
    "name": "forms",
    "plural": true,
    "selections": [
      v23,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "applicationFormId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasCompletedForms",
    "storageKey": null
  }, v8 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateDetailsApplicationRouteQuery",
      "selections": [
        {
          "alias": "application",
          "args": v1,
          "concreteType": "Application",
          "kind": "LinkedField",
          "name": "applicationByCode",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            v5,
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfile",
              "kind": "LinkedField",
              "name": "profile",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "DetailsComponent_profile"
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "candidate",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "DetailsComponent_candidate"
                }
              ],
              "storageKey": null
            },
            v6,
            v7,
            v8
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateDetailsApplicationRouteQuery",
      "selections": [
        {
          "alias": "application",
          "args": v1,
          "concreteType": "Application",
          "kind": "LinkedField",
          "name": "applicationByCode",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            v5,
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfile",
              "kind": "LinkedField",
              "name": "profile",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "recruitProfileId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitResume",
                  "kind": "LinkedField",
                  "name": "resume",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "bucket",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "resumeId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "fileKey",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "fileName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "filePath",
                      "storageKey": null
                    },
                    v23
                  ],
                  "storageKey": null
                },
                v23
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "candidate",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "firstName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "email",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CandidatePhoneVerification",
                  "kind": "LinkedField",
                  "name": "phone",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "phoneNumber",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "phoneCountryPrefix",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "phoneVerificationStatus",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                v23
              ],
              "storageKey": null
            },
            v6,
            v7,
            v8
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "75f4d8cafc1ffe2088ddefad039fd842",
      "id": null,
      "metadata": {},
      "name": "CandidateDetailsApplicationRouteQuery",
      "operationKind": "query",
      "text": "query CandidateDetailsApplicationRouteQuery(\n  $applicationCode: Int!\n) {\n  application: applicationByCode(applicationCode: $applicationCode) {\n    id\n    code\n    applicationId\n    vacancyName\n    profile {\n      ...DetailsComponent_profile\n      id\n    }\n    candidate {\n      ...DetailsComponent_candidate\n      id\n    }\n    forms {\n      id\n      applicationFormId\n    }\n    hasCompletedForms\n  }\n}\n\nfragment DetailsComponent_candidate on AccountsCandidateAccount {\n  firstName\n  lastName\n  email\n  phone {\n    phoneNumber\n    phoneCountryPrefix\n    phoneVerificationStatus\n  }\n}\n\nfragment DetailsComponent_profile on RecruitProfile {\n  recruitProfileId\n  resume {\n    bucket\n    resumeId\n    fileKey\n    fileName\n    filePath\n    id\n  }\n}\n"
    }
  };
}();
node371.hash = "832ccab9b45eff4bd284ef8d651dd03f";
var CandidateDetailsApplicationRouteQuery_graphql_default = node371;

// src/candidates/components/CandidateDetails.tsx
import { loadQuery as loadQuery43 } from "react-relay";
import { Link as Link31 } from "react-router-dom";
import { useRouteData as useRouteData25 } from "shared-lib";
import { Fragment as Fragment91, jsx as jsx336 } from "react/jsx-runtime";
var queryDef64 = CandidateDetailsApplicationRouteQuery_graphql_default;
async function loader35(environment, params) {
  const code = params.applicationCode;
  const applicationCode = parseInt(code);
  return loadQuery43(
    environment,
    queryDef64,
    {
      applicationCode
    }
  );
}
var CandidateDetails = ({ routeId: routeId4 }) => {
  const data = useRouteData25(
    queryDef64,
    routeId4
  );
  const { application: application3 } = data;
  if (!application3) {
    return /* @__PURE__ */ jsx336(Fragment91, { children: "Loading..." });
  }
  return /* @__PURE__ */ jsx336(
    DetailsComponent,
    {
      candidateFragmentRef: application3?.candidate,
      profileFragmentRef: application3?.profile
    }
  );
};
var createRoute28 = (routePrefix, environment, context) => {
  const routeId4 = `${routePrefix}-application-details-forms`;
  return {
    id: routeId4,
    path: "details",
    loader: ({ params }) => {
      return loader35(environment, params);
    },
    element: /* @__PURE__ */ jsx336(CandidateDetails, { routeId: routeId4 }),
    handle: {
      crumb: () => /* @__PURE__ */ jsx336(Link31, { to: "details", children: "Details" })
    }
  };
};

// src/candidates/components/CandidateApplicationRoute.tsx
import { jsx as jsx337 } from "react/jsx-runtime";
var createCandidateApplicationRoutes = (routePrefix, environment, context, showHeader = true, inApplicationList = true) => {
  const routeId4 = `${routePrefix}-${routeId3}`;
  return [
    {
      path: "*",
      id: routeId4,
      element: /* @__PURE__ */ jsx337(CandidateApplicationLayout, { showHeader }),
      errorElement: /* @__PURE__ */ jsx337(ErrorContainer14, {}),
      handle: {
        crumb: () => /* @__PURE__ */ jsx337(CandidateApplicationLink, { routeId: routeId4 })
      },
      loader: ({ params }) => {
        return loader29(environment, params);
      },
      children: [
        createRoute16(routePrefix, environment, context),
        createRoute24(routePrefix, environment, context),
        createRoute25(routePrefix, environment, context),
        createRoute27(routePrefix, environment, context),
        createRoute17(routePrefix, environment, context),
        createRoute(routePrefix, environment, context),
        createRoute22(routePrefix, environment, context),
        createRoute18(routePrefix, environment, context),
        createRoute19(routePrefix, environment, context),
        createRoute26(routePrefix, environment, context),
        createRoute28(routePrefix, environment, context),
        createRoute23(routePrefix, environment, context),
        {
          path: "*",
          element: /* @__PURE__ */ jsx337(Navigate14, { to: "relevance" })
        }
      ]
    }
  ];
};

// src/candidates/components/__generated__/CandidateWorkHistoryListPaginationQuery.graphql.ts
var node373 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 15,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "profileId"
    },
    {
      "defaultValue": {
        "endDate": "DESC"
      },
      "kind": "LocalArgument",
      "name": "sort"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v23 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v32 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }, v4 = [
    v1,
    v23,
    {
      "kind": "Variable",
      "name": "order",
      "variableName": "sort"
    },
    {
      "kind": "Variable",
      "name": "profileId",
      "variableName": "profileId"
    },
    v32
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CandidateWorkHistoryListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v23,
            {
              "kind": "Variable",
              "name": "sort",
              "variableName": "sort"
            },
            v32
          ],
          "kind": "FragmentSpread",
          "name": "CandidateProfileExperienceList_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CandidateWorkHistoryListPaginationQuery",
      "selections": [
        {
          "alias": "list",
          "args": v4,
          "concreteType": "RecruitProfileExperiencesConnection",
          "kind": "LinkedField",
          "name": "recruitProfileExperiences",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfileExperiencesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperience",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "startDate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "endDate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "companyName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "title",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v4,
          "filters": [],
          "handle": "connection",
          "key": "CandidateProfileExperienceList_list",
          "kind": "LinkedHandle",
          "name": "recruitProfileExperiences"
        }
      ]
    },
    "params": {
      "cacheID": "ea5036a32eb0a3b8e2c748479303d887",
      "id": null,
      "metadata": {},
      "name": "CandidateWorkHistoryListPaginationQuery",
      "operationKind": "query",
      "text": "query CandidateWorkHistoryListPaginationQuery(\n  $after: String\n  $first: Int = 15\n  $profileId: UUID!\n  $sort: [RecruitProfileExperienceSort!] = {endDate: DESC}\n  $where: RecruitProfileExperienceFilter\n) {\n  ...CandidateProfileExperienceList_list_5yRcm\n}\n\nfragment CandidateProfileExperienceItemHeader_item on RecruitProfileExperience {\n  id\n  startDate\n  endDate\n  companyName\n  title\n}\n\nfragment CandidateProfileExperienceItem_item on RecruitProfileExperience {\n  id\n  description\n  ...CandidateProfileExperienceItemHeader_item\n}\n\nfragment CandidateProfileExperienceList_list_5yRcm on Query {\n  list: recruitProfileExperiences(profileId: $profileId, first: $first, after: $after, where: $where, order: $sort) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        startDate\n        endDate\n        companyName\n        title\n        ...CandidateProfileExperienceItem_item\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node373.hash = "be7bf38431bbe41359d625b5ffa96858";
var CandidateWorkHistoryListPaginationQuery_graphql_default = node373;

// src/candidates/components/__generated__/CandidateProfileExperienceList_list.graphql.ts
var node374 = function() {
  var v0 = [
    "list"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 15,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "profileId"
      },
      {
        "defaultValue": {
          "endDate": "DESC"
        },
        "kind": "LocalArgument",
        "name": "sort"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": CandidateWorkHistoryListPaginationQuery_graphql_default
      }
    },
    "name": "CandidateProfileExperienceList_list",
    "selections": [
      {
        "alias": "list",
        "args": null,
        "concreteType": "RecruitProfileExperiencesConnection",
        "kind": "LinkedField",
        "name": "__CandidateProfileExperienceList_list_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitProfileExperiencesEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitProfileExperience",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "companyName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "CandidateProfileExperienceItem_item"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node374.hash = "be7bf38431bbe41359d625b5ffa96858";
var CandidateProfileExperienceList_list_graphql_default = node374;

// src/candidates/components/CandidateProfileExperienceList.tsx
import {
  isValidElement as isValidElement7,
  useCallback as useCallback185,
  useEffect as useEffect41,
  useState as useState94
} from "react";
import { usePaginationFragment as usePaginationFragment19 } from "react-relay";
import { useForm as useForm20 } from "react-hook-form";
import { UserIcon } from "@heroicons/react/24/outline";
import { isNotNullOrUndefined as isNotNullOrUndefined10, noop as noop12, useDebounce as useDebounce2 } from "shared-lib";
import { EdButtonLink as EdButtonLink7, SectionedLayout as SectionedLayout4 } from "shared-ui";

// src/candidates/components/__generated__/CandidateProfileExperienceItem_item.graphql.ts
var node375 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CandidateProfileExperienceItem_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CandidateProfileExperienceItemHeader_item"
    }
  ],
  "type": "RecruitProfileExperience",
  "abstractKey": null
};
node375.hash = "8c60cbf2497646b2993337ef5d5fa1e4";
var CandidateProfileExperienceItem_item_graphql_default = node375;

// src/candidates/components/CandidateProfileExperienceItem.tsx
import { useFragment as useFragment103 } from "react-relay";

// src/candidates/components/__generated__/CandidateProfileExperienceItemHeader_item.graphql.ts
var node376 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CandidateProfileExperienceItemHeader_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "companyName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "type": "RecruitProfileExperience",
  "abstractKey": null
};
node376.hash = "fa73b44cb1195f8d3cb02cb4c311e51b";
var CandidateProfileExperienceItemHeader_item_graphql_default = node376;

// src/candidates/components/CandidateProfileExperienceItemHeader.tsx
import { useFragment as useFragment101 } from "react-relay";
import { jsx as jsx338, jsxs as jsxs215 } from "react/jsx-runtime";
var fragmentDef83 = CandidateProfileExperienceItemHeader_item_graphql_default;
var CandidateProfileExperienceItemHeader = ({
  fragmentRef
}) => {
  const data = useFragment101(
    fragmentDef83,
    fragmentRef
  );
  return /* @__PURE__ */ jsxs215("div", { className: "flex flex-col gap-2 sm:flex-row", children: [
    /* @__PURE__ */ jsx338("div", { children: data.title }),
    /* @__PURE__ */ jsx338("div", { children: data.companyName })
  ] });
};

// src/candidates/components/CandidateProfileExperienceItem.tsx
import { jsx as jsx339, jsxs as jsxs216 } from "react/jsx-runtime";
var fragmentDef84 = CandidateProfileExperienceItem_item_graphql_default;
var CandidateProfileExperienceItem = ({ fragmentRef }) => {
  const data = useFragment103(
    fragmentDef84,
    fragmentRef
  );
  return /* @__PURE__ */ jsxs216("div", { className: "flex flex-col gap-2", children: [
    /* @__PURE__ */ jsx339(CandidateProfileExperienceItemHeader, { fragmentRef: data }),
    /* @__PURE__ */ jsx339("div", { className: "p-6", children: data.description })
  ] });
};

// src/candidates/components/CandidateProfileExperienceList.tsx
import { Fragment as Fragment92, jsx as jsx340, jsxs as jsxs217 } from "react/jsx-runtime";
var defaultFilterState2 = { companyName: "" };
var fragment13 = CandidateProfileExperienceList_list_graphql_default;
function createItemHeader(section) {
  const code = section.context.code;
  const titleIsElement = isValidElement7(section.itemTitle);
  return /* @__PURE__ */ jsxs217(Fragment92, { children: [
    titleIsElement ? section.itemTitle : /* @__PURE__ */ jsx340("div", { className: "font-InterMedium text-info-gray-800 text-3xl font-bold tracking-tight", children: section.itemTitle }),
    /* @__PURE__ */ jsxs217("div", { className: "flex items-center space-x-2 sm:justify-end", children: [
      /* @__PURE__ */ jsx340(EdButtonLink7, { name: "View", to: `../../../view/${code}` }),
      /* @__PURE__ */ jsx340(EdButtonLink7, { name: "Edit", to: `../../../edit/${code}` })
    ] })
  ] });
}
function createItemTitle(position) {
  return /* @__PURE__ */ jsxs217("div", { className: "flex flex-col gap-2 sm:flex-row", children: [
    /* @__PURE__ */ jsx340("div", { children: position.title }),
    /* @__PURE__ */ jsx340("div", { children: position.companyName })
  ] });
}
function createListTitle(position) {
  return /* @__PURE__ */ jsxs217("div", { className: "flex flex-col gap-2 sm:flex-row", children: [
    /* @__PURE__ */ jsx340("div", { children: position.title }),
    /* @__PURE__ */ jsx340("div", { children: position.companyName })
  ] });
}
var CandidateProfileExperienceList = ({
  fragmentRef
}) => {
  const { data, loadNext, hasNext, isLoadingNext, refetch } = usePaginationFragment19(fragment13, fragmentRef);
  const { list: list2 } = data;
  const [filters, setFilters] = useState94(defaultFilterState2);
  const sections = (list2?.edges || []).map((edge) => edge.node).filter(isNotNullOrUndefined10).map((position) => {
    return {
      key: position.id,
      listSubtitle: position.title,
      listTitle: createListTitle(position),
      itemTitle: createItemTitle(position),
      icon: () => /* @__PURE__ */ jsx340("div", { className: "flex h-[30px] w-[30px] items-center justify-center", children: /* @__PURE__ */ jsx340(UserIcon, { className: "h-5 w-5" }) }),
      iconForeground: "text-primary-700",
      iconBackground: "bg-white",
      context: {
        id: position.id
      },
      element: /* @__PURE__ */ jsx340(CandidateProfileExperienceItem, { fragmentRef: position })
    };
  });
  const loadMore = useCallback185(() => {
    if (isLoadingNext) {
      return;
    }
    loadNext(5);
  }, [isLoadingNext, loadNext]);
  const debouncedCompanyName = useDebounce2(filters.companyName, 300);
  const { control, watch, getValues, reset } = useForm20();
  const statusField = watch("status");
  const sortField = watch("sort");
  const resetFilters = () => {
    setFilters(defaultFilterState2);
    reset();
  };
  useEffect41(() => {
    let sort = { endDate: "DESC" };
    switch (sortField) {
      case "END_DATE":
        sort = { endDate: "DESC" };
        break;
      case "START_DATE":
        sort = { startDate: "DESC" };
        break;
    }
    refetch(
      {
        sort: [sort]
      },
      {
        fetchPolicy: "store-and-network"
      }
    );
  }, [debouncedCompanyName, refetch, statusField, sortField]);
  return /* @__PURE__ */ jsx340(Fragment92, { children: /* @__PURE__ */ jsx340(
    SectionedLayout4,
    {
      title: "Work History",
      sections,
      itemHeader: createItemHeader,
      loadMore: hasNext ? loadMore : noop12,
      isLoading: isLoadingNext && hasNext,
      showFilters: true
    }
  ) });
};

// src/profile-search/components/Profile.tsx
import { Fragment as Fragment93, jsx as jsx341, jsxs as jsxs218 } from "react/jsx-runtime";
var queryRef2 = ProfileQuery_graphql_default;
var fragmentDef85 = Profile_profile_graphql_default;
var Profile = ({ isInList }) => {
  const { profileId } = useParams11();
  const data = useLazyLoadQuery49(queryRef2, {
    code: profileId ? parseInt(profileId) : 0
  });
  if (!profileId || !data.recruitProfiles || !data.recruitProfiles.nodes || data.recruitProfiles.nodes.length === 0) {
    return /* @__PURE__ */ jsx341("div", { children: "Not found" });
  }
  return /* @__PURE__ */ jsx341(
    ProfileConnectionComponent,
    {
      fragmentRef: data.recruitProfiles.nodes[0],
      isInList
    }
  );
};
var ProfileWorkTimeline = () => {
  const { profileId } = useParams11();
  const data = useLazyLoadQuery49(queryRef2, {
    code: profileId ? parseInt(profileId) : 0
  });
  if (!profileId || !data.recruitProfiles || !data.recruitProfiles.nodes || data.recruitProfiles.nodes.length === 0) {
    return /* @__PURE__ */ jsx341("div", { children: "Not found" });
  }
  return /* @__PURE__ */ jsx341(ProfileWorkTimelineDef, { fragmentRef: data.recruitProfiles.nodes[0] });
};
var ProfileWorkTimelineDef = ({
  fragmentRef
}) => {
  const profile = useFragment104(fragmentDef85, fragmentRef);
  if (!profile) {
    return /* @__PURE__ */ jsx341(Loading10, {});
  }
  return /* @__PURE__ */ jsx341(ProfileSearchResultTimeline, { fragmentRef: profile });
};
var ProfileWorkHistory = () => {
  const { profileId } = useParams11();
  const data = useLazyLoadQuery49(queryRef2, {
    code: profileId ? parseInt(profileId) : 0
  });
  if (!profileId || !data.recruitProfiles || !data.recruitProfiles.nodes || data.recruitProfiles.nodes.length === 0) {
    return /* @__PURE__ */ jsx341("div", { children: "Not found" });
  }
  return /* @__PURE__ */ jsx341(ProfileWorkHistoryComponent, { fragmentRef: data.recruitProfiles.nodes[0] });
};
var ProfileDetails2 = () => {
  const { profileId } = useParams11();
  const data = useLazyLoadQuery49(queryRef2, {
    code: profileId ? parseInt(profileId) : 0
  });
  if (!profileId || !data.recruitProfiles || !data.recruitProfiles.nodes || data.recruitProfiles.nodes.length === 0) {
    return /* @__PURE__ */ jsx341("div", { children: "Not found" });
  }
  return /* @__PURE__ */ jsx341(ProfileDetailsComponent, { fragmentRef: data.recruitProfiles.nodes[0] });
};
var ProfileDetailsComponent = ({
  fragmentRef
}) => {
  const profile = useFragment104(fragmentDef85, fragmentRef);
  return /* @__PURE__ */ jsx341(
    Info,
    {
      fullName: profile.firstName + " " + profile.lastName,
      emailAddress: profile.emailAddress,
      phone: {
        phoneVerificationStatus: profile?.account?.phone?.phoneVerificationStatus || null,
        phoneNumber: profile?.account?.phone?.phoneNumber || null,
        phoneCountryPrefix: profile?.account?.phone?.phoneCountryPrefix || null
      },
      profileId: profile.recruitProfileId
    }
  );
};
var ProfileWorkHistoryComponent = ({
  fragmentRef
}) => {
  const profile = useFragment104(fragmentDef85, fragmentRef);
  const [selectedId, setSelectedId] = useState95(null);
  let selectedContainer = null;
  if (selectedId) {
    const selected = profile.experience.find(
      (e4) => e4.candidateExperienceId === selectedId
    );
    if (selected) {
      selectedContainer = /* @__PURE__ */ jsxs218("div", { className: "", children: [
        /* @__PURE__ */ jsx341("div", { className: "flex justify-end border-b p-2", children: /* @__PURE__ */ jsx341("div", { children: /* @__PURE__ */ jsx341(
          Button85,
          {
            size: Size43.sm,
            color: "primary",
            clicked: () => setSelectedId(null),
            children: "Close"
          }
        ) }) }),
        /* @__PURE__ */ jsx341(ExperienceDetailsComponent, { fragmentRef: selected })
      ] });
    }
  }
  return /* @__PURE__ */ jsxs218("div", { className: "flex flex-wrap gap-5", children: [
    selectedContainer ? /* @__PURE__ */ jsx341("div", { className: "flex flex-1 flex-col gap-5 rounded-2xl border bg-white", children: selectedContainer }) : /* @__PURE__ */ jsxs218("div", { className: "flex flex-1 flex-col gap-3", children: [
      profile.experience.map((experience) => /* @__PURE__ */ jsx341("div", { className: "rounded-lg border bg-white", children: /* @__PURE__ */ jsx341(ExperienceDetailsComponent, { fragmentRef: experience }) }, experience.id)),
      profile.experience.length === 0 && /* @__PURE__ */ jsxs218("div", { className: "flex h-96 flex-col items-center justify-center rounded-lg bg-white", children: [
        /* @__PURE__ */ jsx341("div", { className: "text-2xl font-bold", children: "No experience found" }),
        /* @__PURE__ */ jsx341("div", { className: "text-lg text-gray-500", children: "This user has not added any work experience" })
      ] })
    ] }),
    /* @__PURE__ */ jsx341("div", { className: "w/1-5 flex max-w-md flex-col gap-2 divide-y", children: profile.experience.map((e4) => /* @__PURE__ */ jsxs218(
      "div",
      {
        className: classNames38(
          "flex cursor-pointer flex-col gap-2 rounded-lg bg-white p-3",
          e4.candidateExperienceId === selectedId ? "text-primary-500" : "text-gray-900"
        ),
        onClick: () => setSelectedId(e4.candidateExperienceId),
        children: [
          /* @__PURE__ */ jsxs218("div", { className: "flex items-center gap-2", children: [
            /* @__PURE__ */ jsx341("div", { children: e4.title }),
            /* @__PURE__ */ jsx341("div", { children: e4.companyName })
          ] }),
          /* @__PURE__ */ jsxs218("div", { className: "flex items-center gap-2", children: [
            /* @__PURE__ */ jsx341("div", { children: formatMonth4(e4.startDate) }),
            /* @__PURE__ */ jsx341("div", { children: formatMonth4(e4.endDate) })
          ] })
        ]
      },
      e4.id
    )) })
  ] });
};
var ProfileConnectionComponent = ({
  fragmentRef,
  isInList,
  showSelect = true
}) => {
  const profile = useFragment104(fragmentDef85, fragmentRef);
  const tabs6 = [
    // { name: 'Info', to: 'info' },
    { name: "Top Skills", to: "top-skills" },
    { name: "Work History", to: "work-history" },
    { name: "Details", to: "details" },
    { name: "Notes", to: "notes" },
    { name: "Application History", to: "application-history" },
    { name: "Recommendation History", to: "recommendation-history" }
  ];
  const location2 = useLocation6();
  const tabLinks = tabs6.map((tab) => {
    return createLinkState6(location2, tab.name, tab.to);
  });
  const [selectedTab, setSelectedTab] = useState95("");
  return /* @__PURE__ */ jsxs218("div", { className: "flex w-full flex-col", children: [
    !isInList && /* @__PURE__ */ jsx341(
      Breadcrumbs6,
      {
        links: [
          {
            name: "Profile Search",
            href: "../search"
          },
          {
            name: `${profile.firstName} ${profile.lastName}`,
            href: ""
          }
        ]
      }
    ),
    /* @__PURE__ */ jsxs218("div", { className: "flex flex-col overflow-hidden rounded-xl border bg-white shadow", children: [
      /* @__PURE__ */ jsx341("div", { children: /* @__PURE__ */ jsx341(ShowExpandApplicationProfile.Provider, { value: false, children: /* @__PURE__ */ jsx341(
        RecruitProfileHeader,
        {
          showSelect,
          fragmentRef: profile,
          expandLink: `../../profile/${profile.code}`
        }
      ) }) }),
      /* @__PURE__ */ jsx341("div", { className: "flex w-full gap-1 bg-gray-100 p-2", children: tabs6.map((tab) => /* @__PURE__ */ jsx341(
        "div",
        {
          onClick: () => {
            if (selectedTab === tab.name) {
              setSelectedTab("");
            } else {
              setSelectedTab(tab.name);
            }
          },
          children: /* @__PURE__ */ jsx341("div", { children: /* @__PURE__ */ jsx341(
            Tag23,
            {
              color: classNames38(tab.name == selectedTab ? "" : "white"),
              className: "cursor-pointer hover:bg-gray-200",
              children: tab.name
            }
          ) })
        },
        tab.name
      )) }),
      /* @__PURE__ */ jsx341("div", { children: /* @__PURE__ */ jsx341(Suspense120, { children: {
        "": /* @__PURE__ */ jsx341(Fragment93, {}),
        "Top Skills": /* @__PURE__ */ jsx341(ProfileWorkTimelineDef, { fragmentRef }),
        "Work History": /* @__PURE__ */ jsx341(ProfileWorkHistoryComponent, { fragmentRef }),
        Details: /* @__PURE__ */ jsx341(ProfileDetailsComponent, { fragmentRef }),
        Notes: /* @__PURE__ */ jsx341(ProfilesNotesById, { profileId: profile.recruitProfileId }),
        "Application History": /* @__PURE__ */ jsx341("div", { className: "bg-white p-5", children: profile.account?.accountId && /* @__PURE__ */ jsx341(
          CandidateApplicationHistory,
          {
            candidateId: profile.account.accountId
          }
        ) }),
        "Recommendation History": /* @__PURE__ */ jsx341("div", { className: "bg-white p-5", children: profile.account?.accountId && /* @__PURE__ */ jsx341(
          CandidateRecommendationHistory,
          {
            candidateId: profile.account.accountId
          }
        ) })
      }[selectedTab] }) })
    ] })
  ] });
};

// src/profile-search/components/__generated__/ProfileSkillsFacetsContainer_facets.graphql.ts
var node377 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileSkillsFacetsContainer_facets",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DefaultAggregationModel",
      "kind": "LinkedField",
      "name": "skills",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MultiFacetContainer_facet"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "StandardAggregationResults",
  "abstractKey": null
};
node377.hash = "ae561872ca25466238bc697bda6ba16b";
var ProfileSkillsFacetsContainer_facets_graphql_default = node377;

// src/profile-search/components/ProfileSkillsFacetsContainer.tsx
import { useCallback as useCallback186 } from "react";
import { useFragment as useFragment105 } from "react-relay";
import { MultiFacetContainer as MultiFacetContainer8 } from "app-core";
import { jsx as jsx343 } from "react/jsx-runtime";
var fragmentDef86 = ProfileSkillsFacetsContainer_facets_graphql_default;
var ProfileSkillsFacetsContainer = ({
  fragmentRef,
  onChanged
}) => {
  const data = useFragment105(fragmentDef86, fragmentRef);
  const onSkillsFacetChanged = useCallback186(
    (selected) => {
      const skills = selected.map((id18) => {
        return {
          minimumMonthsExperience: null,
          monthsAgoLastUsed: null,
          skillId: parseInt(id18)
        };
      });
      onChanged(skills);
    },
    [onChanged]
  );
  return /* @__PURE__ */ jsx343(
    MultiFacetContainer8,
    {
      fragmentRef: data.skills,
      onFacetChanged: onSkillsFacetChanged
    }
  );
};

// src/profile-search/components/__generated__/ProfileFacetsListFragment.graphql.ts
var node378 = function() {
  var v0 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "count",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TagFacetFragment"
    }
  ];
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProfileFacetsListFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "DefaultAggregationModel",
        "kind": "LinkedField",
        "name": "companies",
        "plural": false,
        "selections": v0,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DefaultAggregationModel",
        "kind": "LinkedField",
        "name": "escoLevel1",
        "plural": false,
        "selections": v0,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DefaultAggregationModel",
        "kind": "LinkedField",
        "name": "escoLevel2",
        "plural": false,
        "selections": v0,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DefaultAggregationModel",
        "kind": "LinkedField",
        "name": "escoLevel3",
        "plural": false,
        "selections": v0,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DefaultAggregationModel",
        "kind": "LinkedField",
        "name": "escoLevel4",
        "plural": false,
        "selections": v0,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DefaultAggregationModel",
        "kind": "LinkedField",
        "name": "escoLevel5",
        "plural": false,
        "selections": v0,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DefaultAggregationModel",
        "kind": "LinkedField",
        "name": "industries",
        "plural": false,
        "selections": v0,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DefaultAggregationModel",
        "kind": "LinkedField",
        "name": "skills",
        "plural": false,
        "selections": v0,
        "storageKey": null
      }
    ],
    "type": "StandardAggregationResults",
    "abstractKey": null
  };
}();
node378.hash = "7ac616fa664c750a7d54d3129a5dcc0f";
var ProfileFacetsListFragment_graphql_default = node378;

// src/profile-search/components/ProfileFacetsList.tsx
import { useEffect as useEffect43, useReducer, useState as useState96 } from "react";
import { useFragment as useFragment106 } from "react-relay";
import { useSetRecoilState as useSetRecoilState2 } from "recoil";
import { noop as noop13 } from "shared-lib";
import { activeTagsAtom, Button as Button86, Input as Input15, Tag as Tag24, TagFacet } from "shared-ui";
import { jsx as jsx344, jsxs as jsxs219 } from "react/jsx-runtime";
var fragmentDef87 = ProfileFacetsListFragment_graphql_default;
var addOrRemoveIfFound = (array2, value) => {
  const index2 = array2.indexOf(value);
  if (index2 === -1) {
    return [...array2, value];
  } else {
    return array2.filter((x4) => x4 !== value);
  }
};
var initialState = {
  companies: [],
  escoLevel1: [],
  escoLevel2: [],
  escoLevel3: [],
  escoLevel4: [],
  escoLevel5: [],
  industries: [],
  skills: []
};
var ProfileFacetsList = ({
  onSelect = noop13,
  fragmentRef
}) => {
  const data = useFragment106(fragmentDef87, fragmentRef);
  const [state, dispatch2] = useReducer((state2, action) => {
    switch (action.type) {
      case "companies":
        return {
          ...state2,
          companies: addOrRemoveIfFound(state2.companies, action.payload)
        };
      case "escoLevel1":
        return {
          ...state2,
          escoLevel1: addOrRemoveIfFound(state2.escoLevel1, action.payload)
        };
      case "escoLevel2":
        return {
          ...state2,
          escoLevel2: addOrRemoveIfFound(state2.escoLevel2, action.payload)
        };
      case "escoLevel3":
        return {
          ...state2,
          escoLevel3: addOrRemoveIfFound(state2.escoLevel3, action.payload)
        };
      case "escoLevel4":
        return {
          ...state2,
          escoLevel4: addOrRemoveIfFound(state2.escoLevel4, action.payload)
        };
      case "escoLevel5":
        return {
          ...state2,
          escoLevel5: addOrRemoveIfFound(state2.escoLevel5, action.payload)
        };
      case "industries":
        return {
          ...state2,
          industries: addOrRemoveIfFound(state2.industries, action.payload)
        };
      case "skills":
        if (state2.skills.find((x4) => x4.skillId == action.payload.name)) {
          return {
            ...state2,
            skills: state2.skills.filter((x4) => x4.skillId != action.payload.name)
          };
        }
        return {
          ...state2,
          skills: addOrRemoveIfFound(state2.skills, action.payload)
        };
      case "reset":
        return initialState;
    }
    return state2;
  }, initialState);
  useEffect43(() => {
    onSelect(state);
  }, [state]);
  const [selectedSkill, setSelectedSkill] = useState96(null);
  return /* @__PURE__ */ jsxs219("div", { className: "flex w-full flex-col gap-5 border bg-white p-2", children: [
    /* @__PURE__ */ jsx344("div", { children: /* @__PURE__ */ jsx344(
      Button86,
      {
        color: "primary",
        className: "mb-5",
        onClick: () => {
          dispatch2({ type: "reset" });
        },
        children: "Clear filters"
      }
    ) }),
    data.companies.count > 0 && /* @__PURE__ */ jsx344(
      TagFacet,
      {
        fragmentRef: data.companies,
        onSelect: (e4) => dispatch2({ type: "companies", payload: e4.name })
      }
    ),
    data.escoLevel1.count > 0 && /* @__PURE__ */ jsx344(
      TagFacet,
      {
        fragmentRef: data.escoLevel1,
        onSelect: (e4) => dispatch2({ type: "escoLevel1", payload: e4.name })
      }
    ),
    data.escoLevel2.count > 0 && /* @__PURE__ */ jsx344(
      TagFacet,
      {
        fragmentRef: data.escoLevel2,
        onSelect: (e4) => dispatch2({ type: "escoLevel2", payload: e4.name })
      }
    ),
    data.escoLevel3.count > 0 && /* @__PURE__ */ jsx344(
      TagFacet,
      {
        fragmentRef: data.escoLevel3,
        onSelect: (e4) => dispatch2({ type: "escoLevel3", payload: e4.name })
      }
    ),
    data.escoLevel4.count > 0 && /* @__PURE__ */ jsx344(
      TagFacet,
      {
        fragmentRef: data.escoLevel4,
        onSelect: (e4) => dispatch2({ type: "escoLevel4", payload: e4.name })
      }
    ),
    data.escoLevel5.count > 0 && /* @__PURE__ */ jsx344(
      TagFacet,
      {
        fragmentRef: data.escoLevel5,
        onSelect: (e4) => dispatch2({ type: "escoLevel5", payload: e4.name })
      }
    ),
    data.industries.count > 0 && /* @__PURE__ */ jsx344(
      TagFacet,
      {
        fragmentRef: data.industries,
        onSelect: (e4) => dispatch2({ type: "industries", payload: e4.name })
      }
    ),
    data.skills.count > 0 && /* @__PURE__ */ jsxs219("div", { className: "relative", children: [
      selectedSkill && /* @__PURE__ */ jsx344(
        SelectSkill,
        {
          skill: selectedSkill,
          onClose: () => setSelectedSkill(null),
          onSubmit: (skill) => {
            dispatch2({ type: "skills", payload: skill });
            setSelectedSkill(null);
          }
        }
      ),
      /* @__PURE__ */ jsx344(
        TagFacet,
        {
          fragmentRef: data.skills,
          onSelect: (selected) => {
            if (state.skills.find((x4) => x4.skillId == selected.name)) {
              dispatch2({ type: "skills", payload: selected });
            } else {
              setSelectedSkill(selected);
            }
          }
        }
      )
    ] })
  ] });
};
var SelectSkill = ({
  skill,
  onClose,
  onSubmit
}) => {
  const [state, setState] = useState96({
    minimumMonthsExperience: null,
    monthsAgoLastUsed: null,
    skillId: parseInt(skill.name)
  });
  const setLoadingTags = useSetRecoilState2(activeTagsAtom);
  return /* @__PURE__ */ jsx344("div", { className: "absolute flex h-full w-full items-center justify-center saturate-0 backdrop-blur-[3px]", children: /* @__PURE__ */ jsxs219("div", { className: "relative flex w-full flex-col gap-5 rounded border bg-white p-10 xl:w-1/3", children: [
    /* @__PURE__ */ jsx344(
      "div",
      {
        onClick: () => {
          setLoadingTags([]);
          onClose();
        },
        className: "absolute right-8 top-5",
        children: "x"
      }
    ),
    /* @__PURE__ */ jsxs219("div", { className: "justify-baseline flex gap-2", children: [
      "Skill:",
      /* @__PURE__ */ jsx344(Tag24, { children: skill.text })
    ] }),
    /* @__PURE__ */ jsxs219("div", { children: [
      /* @__PURE__ */ jsx344(
        Input15,
        {
          label: `Experience (Months)`,
          type: "number",
          onChange: (event) => setState({
            ...state,
            minimumMonthsExperience: event.target.value ? parseInt(event.target.value) : null
          })
        }
      ),
      /* @__PURE__ */ jsx344(
        Input15,
        {
          label: `Recency (Months)`,
          type: "number",
          onChange: (event) => setState({
            ...state,
            monthsAgoLastUsed: event.target.value ? parseInt(event.target.value) : null
          })
        }
      )
    ] }),
    /* @__PURE__ */ jsx344(
      Button86,
      {
        onClick: () => {
          onSubmit(state);
          onClose();
        },
        children: "Add"
      }
    )
  ] }) });
};

// src/profile-search/components/__generated__/ProfileSearchContainerQuery.graphql.ts
var node379 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v5 = [
    v23,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    },
    v32,
    {
      "alias": null,
      "args": null,
      "concreteType": "DefaultAggregationValueModel",
      "kind": "LinkedField",
      "name": "values",
      "plural": true,
      "selections": [
        v23,
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isSelected",
          "storageKey": null
        },
        v4,
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ], v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "emailAddress",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateExperienceId",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyName",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "startDate",
    "storageKey": null
  }, v14 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "endDate",
    "storageKey": null
  }, v15 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyIsVerified",
    "storageKey": null
  }, v16 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyId",
    "storageKey": null
  }, v17 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  }, v18 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "skills",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ProfileSearchContainerQuery",
      "selections": [
        {
          "args": v1,
          "kind": "FragmentSpread",
          "name": "ProfileSearchContainerFragment"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ProfileSearchContainerQuery",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "ProfileSearchResults",
          "kind": "LinkedField",
          "name": "recruitProfileSearch",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProfileSearchAggregations",
              "kind": "LinkedField",
              "name": "aggregations",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "StandardAggregationResults",
                  "kind": "LinkedField",
                  "name": "standard",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "skills",
                      "plural": false,
                      "selections": v5,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "companies",
                      "plural": false,
                      "selections": v5,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "industries",
                      "plural": false,
                      "selections": v5,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "escoLevel1",
                      "plural": false,
                      "selections": v5,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "escoLevel2",
                      "plural": false,
                      "selections": v5,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "escoLevel3",
                      "plural": false,
                      "selections": v5,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "escoLevel4",
                      "plural": false,
                      "selections": v5,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "escoLevel5",
                      "plural": false,
                      "selections": v5,
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "sourceTypes",
                  "plural": false,
                  "selections": v5,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "lastExperienceYear",
                  "plural": false,
                  "selections": v5,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "educationTitle",
                  "plural": false,
                  "selections": v5,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "educationInstitution",
                  "plural": false,
                  "selections": v5,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "currentCompany",
                  "plural": false,
                  "selections": v5,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "countries",
                  "plural": false,
                  "selections": v5,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "currentCountry",
                  "plural": false,
                  "selections": v5,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "currentCity",
                  "plural": false,
                  "selections": v5,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "cities",
                  "plural": false,
                  "selections": v5,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "talentPools",
                  "plural": false,
                  "selections": v5,
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CollectionMetaData",
              "kind": "LinkedField",
              "name": "pagination",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "totalResults",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "itemsPerPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "pageNumber",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "pages",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfile",
              "kind": "LinkedField",
              "name": "profiles",
              "plural": true,
              "selections": [
                v6,
                v7,
                v8,
                v9,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "recruitProfileId",
                  "storageKey": null
                },
                v10,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitCandidateProfileNote",
                  "kind": "LinkedField",
                  "name": "notes",
                  "plural": true,
                  "selections": [
                    v7,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "content",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitCandidateProfileNoteTag",
                      "kind": "LinkedField",
                      "name": "tags",
                      "plural": true,
                      "selections": [
                        v4,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "value",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountsUser",
                      "kind": "LinkedField",
                      "name": "createdByUser",
                      "plural": false,
                      "selections": [
                        v10,
                        v8,
                        v9
                      ],
                      "storageKey": null
                    },
                    v6
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsCandidateAccount",
                  "kind": "LinkedField",
                  "name": "account",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "accountId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CandidatePhoneVerification",
                      "kind": "LinkedField",
                      "name": "phone",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "phoneVerificationStatus",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "phoneNumber",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "phoneCountryPrefix",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    v6
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperience",
                  "kind": "LinkedField",
                  "name": "experience",
                  "plural": true,
                  "selections": [
                    v6,
                    v11,
                    v32,
                    v12,
                    v13,
                    v14,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "version",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "titleId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "industry",
                      "storageKey": null
                    },
                    v15,
                    v16,
                    v17,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "positionType",
                      "storageKey": null
                    },
                    v18,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "escoOccupationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "escoHierarchy",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileWorkLocations",
                  "kind": "LinkedField",
                  "name": "workLocations",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currentLocationName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currentLocationCountryName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "WorkLocationEntry",
                      "kind": "LinkedField",
                      "name": "workLocations",
                      "plural": true,
                      "selections": [
                        v4
                      ],
                      "storageKey": null
                    },
                    v6
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperience",
                  "kind": "LinkedField",
                  "name": "currentPosition",
                  "plural": false,
                  "selections": [
                    v32,
                    v12,
                    v13,
                    v14,
                    v6
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileRate",
                  "kind": "LinkedField",
                  "name": "rate",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "payType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "minimumRateOfPay",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "maximumRateOfPay",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "countryCode",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currencyCode",
                      "storageKey": null
                    },
                    v6
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileAvailability",
                  "kind": "LinkedField",
                  "name": "availability",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobSearchStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "availabilityStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "NoticeCriteria",
                      "kind": "LinkedField",
                      "name": "noticeCriteria",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "availableFrom",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "noticePeriodWeeks",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "noticeTimeframe",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    v6
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "profileType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RightToWork",
                  "kind": "LinkedField",
                  "name": "rightToWork",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    v6
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperienceCollection",
                  "kind": "LinkedField",
                  "name": "experiences",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileExperience",
                      "kind": "LinkedField",
                      "name": "items",
                      "plural": true,
                      "selections": [
                        v6,
                        v11,
                        v32,
                        v16,
                        v15,
                        v12,
                        v17,
                        v13,
                        v14,
                        v18
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "SkillUsage",
                      "kind": "LinkedField",
                      "name": "skills",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "skillId",
                          "storageKey": null
                        },
                        v4,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "totalMonthsUsed",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "averageMonthsUsed",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "totalPositionsUsed",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "lastUsed",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "DateRange",
                          "kind": "LinkedField",
                          "name": "periods",
                          "plural": true,
                          "selections": [
                            v13,
                            v14
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "dddde20b7dd0ef56c2d992b8e384a8fd",
      "id": null,
      "metadata": {},
      "name": "ProfileSearchContainerQuery",
      "operationKind": "query",
      "text": "query ProfileSearchContainerQuery(\n  $input: ProfileSearchInput!\n) {\n  ...ProfileSearchContainerFragment_2VV6jB\n}\n\nfragment AggregationTags_Aggregation on DefaultAggregationModel {\n  title\n  values {\n    count\n    text\n    isSelected\n    name\n  }\n}\n\nfragment ExperienceDetails_experience on RecruitProfileExperience {\n  id\n  createdOn\n  updatedOn\n  candidateExperienceId\n  version\n  titleId\n  title\n  industry\n  companyIsVerified\n  companyId\n  companyName\n  description\n  startDate\n  endDate\n  positionType\n  skills\n  escoOccupationId\n  escoHierarchy\n}\n\nfragment MultiFacetContainer_facet on DefaultAggregationModel {\n  count\n  key\n  title\n  values {\n    count\n    isSelected\n    name\n    text\n  }\n}\n\nfragment ProfileSearchActiveFilters_results on ProfileSearchResults {\n  pagination {\n    totalResults\n    itemsPerPage\n    pageNumber\n    pages\n  }\n  aggregations {\n    standard {\n      skills {\n        count\n        ...AggregationTags_Aggregation\n      }\n      companies {\n        count\n        ...AggregationTags_Aggregation\n      }\n      industries {\n        count\n        ...AggregationTags_Aggregation\n      }\n      escoLevel1 {\n        count\n        ...AggregationTags_Aggregation\n      }\n    }\n    currentCompany {\n      count\n      ...AggregationTags_Aggregation\n    }\n    countries {\n      count\n      values {\n        isSelected\n      }\n      ...AggregationTags_Aggregation\n    }\n    currentCountry {\n      count\n      values {\n        isSelected\n      }\n      ...AggregationTags_Aggregation\n    }\n    currentCity {\n      count\n      ...AggregationTags_Aggregation\n    }\n    cities {\n      count\n      ...AggregationTags_Aggregation\n    }\n    lastExperienceYear {\n      count\n      ...AggregationTags_Aggregation\n    }\n    sourceTypes {\n      count\n      ...AggregationTags_Aggregation\n    }\n    talentPools {\n      count\n      ...AggregationTags_Aggregation\n    }\n  }\n}\n\nfragment ProfileSearchContainerFragment_2VV6jB on Query {\n  result: recruitProfileSearch(input: $input) {\n    ...ProfileSearchFilters_results\n    ...ProfileSearchActiveFilters_results\n    ...ProfileSearchPaging_results\n    pagination {\n      totalResults\n      itemsPerPage\n      pageNumber\n      pages\n    }\n    aggregations {\n      sourceTypes {\n        ...TagFacetFragment\n      }\n      cities {\n        ...TagFacetFragment\n      }\n      countries {\n        ...TagFacetFragment\n      }\n      currentCity {\n        ...TagFacetFragment\n      }\n      currentCompany {\n        ...TagFacetFragment\n      }\n      currentCountry {\n        ...TagFacetFragment\n      }\n      lastExperienceYear {\n        ...TagFacetFragment\n      }\n      educationInstitution {\n        ...TagFacetFragment\n      }\n      educationTitle {\n        ...TagFacetFragment\n      }\n      standard {\n        escoLevel1 {\n          ...TagFacetFragment\n        }\n        escoLevel2 {\n          ...TagFacetFragment\n        }\n        escoLevel3 {\n          ...TagFacetFragment\n        }\n        escoLevel4 {\n          ...TagFacetFragment\n        }\n        escoLevel5 {\n          ...TagFacetFragment\n        }\n        industries {\n          ...TagFacetFragment\n        }\n        companies {\n          ...TagFacetFragment\n        }\n        skills {\n          values {\n            name\n            text\n            count\n          }\n          ...TagFacetFragment\n        }\n      }\n    }\n    profiles {\n      id\n      code\n      firstName\n      lastName\n      ...Profile_profile\n    }\n  }\n}\n\nfragment ProfileSearchFilters_results on ProfileSearchResults {\n  aggregations {\n    standard {\n      ...ProfileSkillsFacetsContainer_facets\n      skills {\n        count\n        ...MultiFacetContainer_facet\n      }\n      companies {\n        count\n        ...MultiFacetContainer_facet\n      }\n      industries {\n        count\n        ...MultiFacetContainer_facet\n      }\n      escoLevel1 {\n        count\n        ...MultiFacetContainer_facet\n      }\n    }\n    sourceTypes {\n      count\n      ...MultiFacetContainer_facet\n    }\n    lastExperienceYear {\n      count\n      ...MultiFacetContainer_facet\n    }\n    educationTitle {\n      count\n      ...MultiFacetContainer_facet\n    }\n    educationInstitution {\n      count\n      ...MultiFacetContainer_facet\n    }\n    currentCompany {\n      count\n      ...MultiFacetContainer_facet\n    }\n    countries {\n      count\n      ...MultiFacetContainer_facet\n    }\n    currentCountry {\n      count\n      ...MultiFacetContainer_facet\n    }\n    currentCity {\n      count\n      ...MultiFacetContainer_facet\n    }\n    cities {\n      count\n      ...MultiFacetContainer_facet\n    }\n    talentPools {\n      count\n      ...MultiFacetContainer_facet\n    }\n  }\n}\n\nfragment ProfileSearchPaging_results on ProfileSearchResults {\n  pagination {\n    pages\n    pageNumber\n    itemsPerPage\n    totalResults\n  }\n}\n\nfragment ProfileSearchResultTimeline_profile on RecruitProfile {\n  id\n  experiences {\n    items {\n      id\n      candidateExperienceId\n      title\n      companyId\n      companyIsVerified\n      companyName\n      description\n      startDate\n      endDate\n      skills\n    }\n    skills {\n      skillId\n      name\n      totalMonthsUsed\n      averageMonthsUsed\n      totalPositionsUsed\n      lastUsed\n      periods {\n        startDate\n        endDate\n      }\n    }\n  }\n}\n\nfragment ProfileSkillsFacetsContainer_facets on StandardAggregationResults {\n  skills {\n    count\n    ...MultiFacetContainer_facet\n  }\n}\n\nfragment Profile_profile on RecruitProfile {\n  code\n  firstName\n  lastName\n  recruitProfileId\n  emailAddress\n  notes {\n    code\n    content\n    tags {\n      name\n      value\n    }\n    updatedAt\n    createdByUser {\n      emailAddress\n      firstName\n      lastName\n    }\n    id\n  }\n  account {\n    accountId\n    phone {\n      phoneVerificationStatus\n      phoneNumber\n      phoneCountryPrefix\n    }\n    id\n  }\n  experience {\n    id\n    candidateExperienceId\n    title\n    companyName\n    startDate\n    endDate\n    ...ExperienceDetails_experience\n  }\n  ...RecruitProfileHeader_profile\n  ...ProfileSearchResultTimeline_profile\n}\n\nfragment RecruitProfileApplicationHeader_application on RecruitProfile {\n  id\n  firstName\n  lastName\n  workLocations {\n    currentLocationName\n    currentLocationCountryName\n    workLocations {\n      name\n    }\n    id\n  }\n  currentPosition {\n    title\n    companyName\n    startDate\n    endDate\n    id\n  }\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n  availability {\n    jobSearchStatus\n    availabilityStatus\n    noticeCriteria {\n      availableFrom\n      noticePeriodWeeks\n      noticeTimeframe\n    }\n    id\n  }\n}\n\nfragment RecruitProfileHeader_profile on RecruitProfile {\n  ...RecruitProfileApplicationHeader_application\n  id\n  recruitProfileId\n  firstName\n  lastName\n  profileType\n  workLocations {\n    currentLocationName\n    currentLocationCountryName\n    id\n  }\n  account {\n    accountId\n    id\n  }\n  currentPosition {\n    title\n    companyName\n    startDate\n    endDate\n    id\n  }\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n  rightToWork {\n    status\n    id\n  }\n  availability {\n    jobSearchStatus\n    id\n  }\n}\n\nfragment TagFacetFragment on DefaultAggregationModel {\n  count\n  key\n  title\n  values {\n    count\n    isSelected\n    name\n    text\n  }\n}\n"
    }
  };
}();
node379.hash = "9290dbb4a0b2e2a84a84ce1efc27375c";
var ProfileSearchContainerQuery_graphql_default = node379;

// src/profile-search/components/__generated__/ProfileSearchContainerSearchFragment.graphql.ts
var node380 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v5 = [
    v23,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    },
    v32,
    {
      "alias": null,
      "args": null,
      "concreteType": "DefaultAggregationValueModel",
      "kind": "LinkedField",
      "name": "values",
      "plural": true,
      "selections": [
        v23,
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isSelected",
          "storageKey": null
        },
        v4,
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ], v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "emailAddress",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateExperienceId",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyName",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "startDate",
    "storageKey": null
  }, v14 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "endDate",
    "storageKey": null
  }, v15 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyIsVerified",
    "storageKey": null
  }, v16 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyId",
    "storageKey": null
  }, v17 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  }, v18 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "skills",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ProfileSearchContainerSearchFragment",
      "selections": [
        {
          "args": v1,
          "kind": "FragmentSpread",
          "name": "ProfileSearchContainerFragment"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ProfileSearchContainerSearchFragment",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "ProfileSearchResults",
          "kind": "LinkedField",
          "name": "recruitProfileSearch",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProfileSearchAggregations",
              "kind": "LinkedField",
              "name": "aggregations",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "StandardAggregationResults",
                  "kind": "LinkedField",
                  "name": "standard",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "skills",
                      "plural": false,
                      "selections": v5,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "companies",
                      "plural": false,
                      "selections": v5,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "industries",
                      "plural": false,
                      "selections": v5,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "escoLevel1",
                      "plural": false,
                      "selections": v5,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "escoLevel2",
                      "plural": false,
                      "selections": v5,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "escoLevel3",
                      "plural": false,
                      "selections": v5,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "escoLevel4",
                      "plural": false,
                      "selections": v5,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DefaultAggregationModel",
                      "kind": "LinkedField",
                      "name": "escoLevel5",
                      "plural": false,
                      "selections": v5,
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "sourceTypes",
                  "plural": false,
                  "selections": v5,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "lastExperienceYear",
                  "plural": false,
                  "selections": v5,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "educationTitle",
                  "plural": false,
                  "selections": v5,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "educationInstitution",
                  "plural": false,
                  "selections": v5,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "currentCompany",
                  "plural": false,
                  "selections": v5,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "countries",
                  "plural": false,
                  "selections": v5,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "currentCountry",
                  "plural": false,
                  "selections": v5,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "currentCity",
                  "plural": false,
                  "selections": v5,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "cities",
                  "plural": false,
                  "selections": v5,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DefaultAggregationModel",
                  "kind": "LinkedField",
                  "name": "talentPools",
                  "plural": false,
                  "selections": v5,
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CollectionMetaData",
              "kind": "LinkedField",
              "name": "pagination",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "totalResults",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "itemsPerPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "pageNumber",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "pages",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfile",
              "kind": "LinkedField",
              "name": "profiles",
              "plural": true,
              "selections": [
                v6,
                v7,
                v8,
                v9,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "recruitProfileId",
                  "storageKey": null
                },
                v10,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitCandidateProfileNote",
                  "kind": "LinkedField",
                  "name": "notes",
                  "plural": true,
                  "selections": [
                    v7,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "content",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitCandidateProfileNoteTag",
                      "kind": "LinkedField",
                      "name": "tags",
                      "plural": true,
                      "selections": [
                        v4,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "value",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountsUser",
                      "kind": "LinkedField",
                      "name": "createdByUser",
                      "plural": false,
                      "selections": [
                        v10,
                        v8,
                        v9
                      ],
                      "storageKey": null
                    },
                    v6
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsCandidateAccount",
                  "kind": "LinkedField",
                  "name": "account",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "accountId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CandidatePhoneVerification",
                      "kind": "LinkedField",
                      "name": "phone",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "phoneVerificationStatus",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "phoneNumber",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "phoneCountryPrefix",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    v6
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperience",
                  "kind": "LinkedField",
                  "name": "experience",
                  "plural": true,
                  "selections": [
                    v6,
                    v11,
                    v32,
                    v12,
                    v13,
                    v14,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "version",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "titleId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "industry",
                      "storageKey": null
                    },
                    v15,
                    v16,
                    v17,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "positionType",
                      "storageKey": null
                    },
                    v18,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "escoOccupationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "escoHierarchy",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileWorkLocations",
                  "kind": "LinkedField",
                  "name": "workLocations",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currentLocationName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currentLocationCountryName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "WorkLocationEntry",
                      "kind": "LinkedField",
                      "name": "workLocations",
                      "plural": true,
                      "selections": [
                        v4
                      ],
                      "storageKey": null
                    },
                    v6
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperience",
                  "kind": "LinkedField",
                  "name": "currentPosition",
                  "plural": false,
                  "selections": [
                    v32,
                    v12,
                    v13,
                    v14,
                    v6
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileRate",
                  "kind": "LinkedField",
                  "name": "rate",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "payType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "minimumRateOfPay",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "maximumRateOfPay",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "countryCode",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currencyCode",
                      "storageKey": null
                    },
                    v6
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileAvailability",
                  "kind": "LinkedField",
                  "name": "availability",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobSearchStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "availabilityStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "NoticeCriteria",
                      "kind": "LinkedField",
                      "name": "noticeCriteria",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "availableFrom",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "noticePeriodWeeks",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "noticeTimeframe",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    v6
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "profileType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RightToWork",
                  "kind": "LinkedField",
                  "name": "rightToWork",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    v6
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperienceCollection",
                  "kind": "LinkedField",
                  "name": "experiences",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileExperience",
                      "kind": "LinkedField",
                      "name": "items",
                      "plural": true,
                      "selections": [
                        v6,
                        v11,
                        v32,
                        v16,
                        v15,
                        v12,
                        v17,
                        v13,
                        v14,
                        v18
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "SkillUsage",
                      "kind": "LinkedField",
                      "name": "skills",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "skillId",
                          "storageKey": null
                        },
                        v4,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "totalMonthsUsed",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "averageMonthsUsed",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "totalPositionsUsed",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "lastUsed",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "DateRange",
                          "kind": "LinkedField",
                          "name": "periods",
                          "plural": true,
                          "selections": [
                            v13,
                            v14
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "082ac631dc70631add5eacd4d14a338e",
      "id": null,
      "metadata": {},
      "name": "ProfileSearchContainerSearchFragment",
      "operationKind": "query",
      "text": "query ProfileSearchContainerSearchFragment(\n  $input: ProfileSearchInput!\n) {\n  ...ProfileSearchContainerFragment_2VV6jB\n}\n\nfragment AggregationTags_Aggregation on DefaultAggregationModel {\n  title\n  values {\n    count\n    text\n    isSelected\n    name\n  }\n}\n\nfragment ExperienceDetails_experience on RecruitProfileExperience {\n  id\n  createdOn\n  updatedOn\n  candidateExperienceId\n  version\n  titleId\n  title\n  industry\n  companyIsVerified\n  companyId\n  companyName\n  description\n  startDate\n  endDate\n  positionType\n  skills\n  escoOccupationId\n  escoHierarchy\n}\n\nfragment MultiFacetContainer_facet on DefaultAggregationModel {\n  count\n  key\n  title\n  values {\n    count\n    isSelected\n    name\n    text\n  }\n}\n\nfragment ProfileSearchActiveFilters_results on ProfileSearchResults {\n  pagination {\n    totalResults\n    itemsPerPage\n    pageNumber\n    pages\n  }\n  aggregations {\n    standard {\n      skills {\n        count\n        ...AggregationTags_Aggregation\n      }\n      companies {\n        count\n        ...AggregationTags_Aggregation\n      }\n      industries {\n        count\n        ...AggregationTags_Aggregation\n      }\n      escoLevel1 {\n        count\n        ...AggregationTags_Aggregation\n      }\n    }\n    currentCompany {\n      count\n      ...AggregationTags_Aggregation\n    }\n    countries {\n      count\n      values {\n        isSelected\n      }\n      ...AggregationTags_Aggregation\n    }\n    currentCountry {\n      count\n      values {\n        isSelected\n      }\n      ...AggregationTags_Aggregation\n    }\n    currentCity {\n      count\n      ...AggregationTags_Aggregation\n    }\n    cities {\n      count\n      ...AggregationTags_Aggregation\n    }\n    lastExperienceYear {\n      count\n      ...AggregationTags_Aggregation\n    }\n    sourceTypes {\n      count\n      ...AggregationTags_Aggregation\n    }\n    talentPools {\n      count\n      ...AggregationTags_Aggregation\n    }\n  }\n}\n\nfragment ProfileSearchContainerFragment_2VV6jB on Query {\n  result: recruitProfileSearch(input: $input) {\n    ...ProfileSearchFilters_results\n    ...ProfileSearchActiveFilters_results\n    ...ProfileSearchPaging_results\n    pagination {\n      totalResults\n      itemsPerPage\n      pageNumber\n      pages\n    }\n    aggregations {\n      sourceTypes {\n        ...TagFacetFragment\n      }\n      cities {\n        ...TagFacetFragment\n      }\n      countries {\n        ...TagFacetFragment\n      }\n      currentCity {\n        ...TagFacetFragment\n      }\n      currentCompany {\n        ...TagFacetFragment\n      }\n      currentCountry {\n        ...TagFacetFragment\n      }\n      lastExperienceYear {\n        ...TagFacetFragment\n      }\n      educationInstitution {\n        ...TagFacetFragment\n      }\n      educationTitle {\n        ...TagFacetFragment\n      }\n      standard {\n        escoLevel1 {\n          ...TagFacetFragment\n        }\n        escoLevel2 {\n          ...TagFacetFragment\n        }\n        escoLevel3 {\n          ...TagFacetFragment\n        }\n        escoLevel4 {\n          ...TagFacetFragment\n        }\n        escoLevel5 {\n          ...TagFacetFragment\n        }\n        industries {\n          ...TagFacetFragment\n        }\n        companies {\n          ...TagFacetFragment\n        }\n        skills {\n          values {\n            name\n            text\n            count\n          }\n          ...TagFacetFragment\n        }\n      }\n    }\n    profiles {\n      id\n      code\n      firstName\n      lastName\n      ...Profile_profile\n    }\n  }\n}\n\nfragment ProfileSearchFilters_results on ProfileSearchResults {\n  aggregations {\n    standard {\n      ...ProfileSkillsFacetsContainer_facets\n      skills {\n        count\n        ...MultiFacetContainer_facet\n      }\n      companies {\n        count\n        ...MultiFacetContainer_facet\n      }\n      industries {\n        count\n        ...MultiFacetContainer_facet\n      }\n      escoLevel1 {\n        count\n        ...MultiFacetContainer_facet\n      }\n    }\n    sourceTypes {\n      count\n      ...MultiFacetContainer_facet\n    }\n    lastExperienceYear {\n      count\n      ...MultiFacetContainer_facet\n    }\n    educationTitle {\n      count\n      ...MultiFacetContainer_facet\n    }\n    educationInstitution {\n      count\n      ...MultiFacetContainer_facet\n    }\n    currentCompany {\n      count\n      ...MultiFacetContainer_facet\n    }\n    countries {\n      count\n      ...MultiFacetContainer_facet\n    }\n    currentCountry {\n      count\n      ...MultiFacetContainer_facet\n    }\n    currentCity {\n      count\n      ...MultiFacetContainer_facet\n    }\n    cities {\n      count\n      ...MultiFacetContainer_facet\n    }\n    talentPools {\n      count\n      ...MultiFacetContainer_facet\n    }\n  }\n}\n\nfragment ProfileSearchPaging_results on ProfileSearchResults {\n  pagination {\n    pages\n    pageNumber\n    itemsPerPage\n    totalResults\n  }\n}\n\nfragment ProfileSearchResultTimeline_profile on RecruitProfile {\n  id\n  experiences {\n    items {\n      id\n      candidateExperienceId\n      title\n      companyId\n      companyIsVerified\n      companyName\n      description\n      startDate\n      endDate\n      skills\n    }\n    skills {\n      skillId\n      name\n      totalMonthsUsed\n      averageMonthsUsed\n      totalPositionsUsed\n      lastUsed\n      periods {\n        startDate\n        endDate\n      }\n    }\n  }\n}\n\nfragment ProfileSkillsFacetsContainer_facets on StandardAggregationResults {\n  skills {\n    count\n    ...MultiFacetContainer_facet\n  }\n}\n\nfragment Profile_profile on RecruitProfile {\n  code\n  firstName\n  lastName\n  recruitProfileId\n  emailAddress\n  notes {\n    code\n    content\n    tags {\n      name\n      value\n    }\n    updatedAt\n    createdByUser {\n      emailAddress\n      firstName\n      lastName\n    }\n    id\n  }\n  account {\n    accountId\n    phone {\n      phoneVerificationStatus\n      phoneNumber\n      phoneCountryPrefix\n    }\n    id\n  }\n  experience {\n    id\n    candidateExperienceId\n    title\n    companyName\n    startDate\n    endDate\n    ...ExperienceDetails_experience\n  }\n  ...RecruitProfileHeader_profile\n  ...ProfileSearchResultTimeline_profile\n}\n\nfragment RecruitProfileApplicationHeader_application on RecruitProfile {\n  id\n  firstName\n  lastName\n  workLocations {\n    currentLocationName\n    currentLocationCountryName\n    workLocations {\n      name\n    }\n    id\n  }\n  currentPosition {\n    title\n    companyName\n    startDate\n    endDate\n    id\n  }\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n  availability {\n    jobSearchStatus\n    availabilityStatus\n    noticeCriteria {\n      availableFrom\n      noticePeriodWeeks\n      noticeTimeframe\n    }\n    id\n  }\n}\n\nfragment RecruitProfileHeader_profile on RecruitProfile {\n  ...RecruitProfileApplicationHeader_application\n  id\n  recruitProfileId\n  firstName\n  lastName\n  profileType\n  workLocations {\n    currentLocationName\n    currentLocationCountryName\n    id\n  }\n  account {\n    accountId\n    id\n  }\n  currentPosition {\n    title\n    companyName\n    startDate\n    endDate\n    id\n  }\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n  rightToWork {\n    status\n    id\n  }\n  availability {\n    jobSearchStatus\n    id\n  }\n}\n\nfragment TagFacetFragment on DefaultAggregationModel {\n  count\n  key\n  title\n  values {\n    count\n    isSelected\n    name\n    text\n  }\n}\n"
    }
  };
}();
node380.hash = "c2dce2ae59f2c6f53fa200885449e570";
var ProfileSearchContainerSearchFragment_graphql_default = node380;

// src/profile-search/components/__generated__/ProfileSearchContainerFragment.graphql.ts
var node381 = function() {
  var v0 = {
    "args": null,
    "kind": "FragmentSpread",
    "name": "TagFacetFragment"
  }, v1 = [
    v0
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "refetch": {
        "connection": null,
        "fragmentPathInResult": [],
        "operation": ProfileSearchContainerSearchFragment_graphql_default
      }
    },
    "name": "ProfileSearchContainerFragment",
    "selections": [
      {
        "alias": "result",
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "ProfileSearchResults",
        "kind": "LinkedField",
        "name": "recruitProfileSearch",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProfileSearchFilters_results"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProfileSearchActiveFilters_results"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProfileSearchPaging_results"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CollectionMetaData",
            "kind": "LinkedField",
            "name": "pagination",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalResults",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "itemsPerPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pageNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pages",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProfileSearchAggregations",
            "kind": "LinkedField",
            "name": "aggregations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "sourceTypes",
                "plural": false,
                "selections": v1,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "cities",
                "plural": false,
                "selections": v1,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "countries",
                "plural": false,
                "selections": v1,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "currentCity",
                "plural": false,
                "selections": v1,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "currentCompany",
                "plural": false,
                "selections": v1,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "currentCountry",
                "plural": false,
                "selections": v1,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "lastExperienceYear",
                "plural": false,
                "selections": v1,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "educationInstitution",
                "plural": false,
                "selections": v1,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "educationTitle",
                "plural": false,
                "selections": v1,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "StandardAggregationResults",
                "kind": "LinkedField",
                "name": "standard",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DefaultAggregationModel",
                    "kind": "LinkedField",
                    "name": "escoLevel1",
                    "plural": false,
                    "selections": v1,
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DefaultAggregationModel",
                    "kind": "LinkedField",
                    "name": "escoLevel2",
                    "plural": false,
                    "selections": v1,
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DefaultAggregationModel",
                    "kind": "LinkedField",
                    "name": "escoLevel3",
                    "plural": false,
                    "selections": v1,
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DefaultAggregationModel",
                    "kind": "LinkedField",
                    "name": "escoLevel4",
                    "plural": false,
                    "selections": v1,
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DefaultAggregationModel",
                    "kind": "LinkedField",
                    "name": "escoLevel5",
                    "plural": false,
                    "selections": v1,
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DefaultAggregationModel",
                    "kind": "LinkedField",
                    "name": "industries",
                    "plural": false,
                    "selections": v1,
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DefaultAggregationModel",
                    "kind": "LinkedField",
                    "name": "companies",
                    "plural": false,
                    "selections": v1,
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DefaultAggregationModel",
                    "kind": "LinkedField",
                    "name": "skills",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DefaultAggregationValueModel",
                        "kind": "LinkedField",
                        "name": "values",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "text",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "count",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      v0
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitProfile",
            "kind": "LinkedField",
            "name": "profiles",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "code",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastName",
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "Profile_profile"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node381.hash = "c2dce2ae59f2c6f53fa200885449e570";
var ProfileSearchContainerFragment_graphql_default = node381;

// src/profile-search/components/ProfileSearchContainer.tsx
import { Suspense as Suspense125, useCallback as useCallback197, useState as useState100, useTransition as useTransition14 } from "react";
import { useQueryLoader as useQueryLoader19 } from "react-relay";
import { useAtom as useAtom24 } from "jotai";
import {
  Button as Button91,
  IconText as IconText6,
  Icons as Icons7,
  Loading as Loading11,
  Modal as Modal2,
  PreloadedQueryHOC,
  Spinner as Spinner11,
  classNames as classNames40
} from "shared-ui";
import { useToggle as useToggle34 } from "shared-lib";

// src/profile-search/components/ProfileSearchList.tsx
import {
  usePreloadedQuery as usePreloadedQuery39,
  useRefetchableFragment as useRefetchableFragment13
} from "react-relay";
import { EdSkeleton as EdSkeleton103 } from "shared-ui";
import { jsx as jsx345 } from "react/jsx-runtime";
var ProfileSearchList = ({
  queryRef: queryRef3,
  isLoading
}) => {
  const query3 = usePreloadedQuery39(
    profileSearchContainerQueryDef,
    queryRef3
  );
  const [result, refetch] = useRefetchableFragment13(profileSearchContainerFragmentDef, query3);
  const profiles = result.result.profiles || [];
  if (isLoading) {
    return /* @__PURE__ */ jsx345("div", { className: "flex w-full flex-col divide-y", children: Array(4).fill(1).map((x4) => /* @__PURE__ */ jsx345("div", { className: "flex w-full justify-start bg-white p-5", children: /* @__PURE__ */ jsx345(EdSkeleton103, {}) }, x4)) });
  }
  return /* @__PURE__ */ jsx345("div", { children: /* @__PURE__ */ jsx345("div", { className: "flex flex-wrap gap-3", children: profiles.map((x4) => /* @__PURE__ */ jsx345(
    ProfileConnectionComponent,
    {
      fragmentRef: x4,
      isInList: true
    },
    x4.code
  )) }) });
};

// src/profile-search/components/ProfileSearchHeader.tsx
var import_lodash5 = __toESM(require_lodash());
import {
  usePreloadedQuery as usePreloadedQuery40,
  useRefetchableFragment as useRefetchableFragment14
} from "react-relay";

// src/profile-search/components/__generated__/ProfileSearchFilters_results.graphql.ts
var node383 = function() {
  var v0 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "count",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MultiFacetContainer_facet"
    }
  ];
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProfileSearchFilters_results",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProfileSearchAggregations",
        "kind": "LinkedField",
        "name": "aggregations",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StandardAggregationResults",
            "kind": "LinkedField",
            "name": "standard",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ProfileSkillsFacetsContainer_facets"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "skills",
                "plural": false,
                "selections": v0,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "companies",
                "plural": false,
                "selections": v0,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "industries",
                "plural": false,
                "selections": v0,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "escoLevel1",
                "plural": false,
                "selections": v0,
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DefaultAggregationModel",
            "kind": "LinkedField",
            "name": "sourceTypes",
            "plural": false,
            "selections": v0,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DefaultAggregationModel",
            "kind": "LinkedField",
            "name": "lastExperienceYear",
            "plural": false,
            "selections": v0,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DefaultAggregationModel",
            "kind": "LinkedField",
            "name": "educationTitle",
            "plural": false,
            "selections": v0,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DefaultAggregationModel",
            "kind": "LinkedField",
            "name": "educationInstitution",
            "plural": false,
            "selections": v0,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DefaultAggregationModel",
            "kind": "LinkedField",
            "name": "currentCompany",
            "plural": false,
            "selections": v0,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DefaultAggregationModel",
            "kind": "LinkedField",
            "name": "countries",
            "plural": false,
            "selections": v0,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DefaultAggregationModel",
            "kind": "LinkedField",
            "name": "currentCountry",
            "plural": false,
            "selections": v0,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DefaultAggregationModel",
            "kind": "LinkedField",
            "name": "currentCity",
            "plural": false,
            "selections": v0,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DefaultAggregationModel",
            "kind": "LinkedField",
            "name": "cities",
            "plural": false,
            "selections": v0,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DefaultAggregationModel",
            "kind": "LinkedField",
            "name": "talentPools",
            "plural": false,
            "selections": v0,
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "kind": "ClientExtension",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__id",
            "storageKey": null
          }
        ]
      }
    ],
    "type": "ProfileSearchResults",
    "abstractKey": null
  };
}();
node383.hash = "78c0f5dc5e5ae963de60b1b7806e9387";
var ProfileSearchFilters_results_graphql_default = node383;

// src/profile-search/components/ProfileSearchFilters.tsx
import { Suspense as Suspense121, useCallback as useCallback187, useState as useState97 } from "react";
import { useFragment as useFragment107 } from "react-relay";
import { useAtom as useAtom17 } from "jotai";
import { MultiFacetContainer as MultiFacetContainer9 } from "app-core";
import {
  classNames as classNames39,
  FilterSectionContainer as FilterSectionContainer5,
  FilterSectionLink as FilterSectionLink5
} from "shared-ui";
import { Fragment as Fragment94, jsx as jsx346, jsxs as jsxs220 } from "react/jsx-runtime";
var fragmentDef88 = ProfileSearchFilters_results_graphql_default;
var filterSections3 = [
  { key: "SKILLS", title: "Skills" },
  { key: "INDUSTRIES", title: "Industries" },
  { key: "LAST_EXPERIENCE_YEAR", title: "Latest Experience" },
  { key: "SOURCE_TYPES", title: "Source Types" },
  { key: "CURRENT_COMPANY", title: "Current Company" },
  { key: "COMPANIES", title: "Companies" },
  { key: "LOCATIONS", title: "Locations" },
  { key: "TALENT_POOLS", title: "Talent Pools" }
];
var ProfileSearchFilters = ({
  fragmentRef,
  isLoading,
  onSearch
}) => {
  const [context, setContext] = useAtom17(profileSearchContextAtom);
  const [selectedSection, setSelectedSection] = useState97(
    null
  );
  const toggleOpen = useCallback187(() => {
    setContext({
      ...context,
      isFiltersOpen: !context.isFiltersOpen
    });
  }, [context, setContext]);
  const [searchInput, dispatch2] = useAtom17(
    profileSearchAtom
  );
  const result = useFragment107(
    fragmentDef88,
    fragmentRef
  );
  const sections = filterSections3.map((s4) => {
    return /* @__PURE__ */ jsx346(
      FilterSectionLink5,
      {
        section: s4,
        onSelect: setSelectedSection,
        selectedKey: selectedSection
      },
      s4.key
    );
  });
  const onFilterChange = useCallback187(
    (change) => {
      const payload = {
        ...searchInput,
        filters: {
          ...searchInput.filters,
          ...change
        }
      };
      dispatch2({
        source: "ProfileSearchFilter",
        type: "SEARCH",
        payload
      });
      onSearch("ProfileSearchFilters", payload);
    },
    [searchInput, dispatch2, onSearch]
  );
  const onStandardFilterChange = useCallback187(
    (change) => {
      const payload = {
        ...searchInput,
        filters: {
          ...searchInput.filters,
          standard: {
            ...searchInput.filters?.standard,
            ...change
          }
        }
      };
      dispatch2({
        source: "ProfileSearchFilter",
        type: "SEARCH",
        payload
      });
      onSearch("ProfileSearchStandardFilters", payload);
    },
    [searchInput, dispatch2, onSearch]
  );
  const onCurrentCompanyChanged = useCallback187(
    (selected) => {
      onFilterChange({
        currentCompanies: selected
      });
    },
    [onFilterChange]
  );
  const onCurrentCountryChanged = useCallback187(
    (selected) => {
      onFilterChange({
        currentCountries: selected
      });
    },
    [onFilterChange]
  );
  const onCountriesChanged = useCallback187(
    (selected) => {
      onFilterChange({
        countries: selected
      });
    },
    [onFilterChange]
  );
  const onCitiesChanged = useCallback187(
    (selected) => {
      onFilterChange({
        cities: selected
      });
    },
    [onFilterChange]
  );
  const onCurrentCityChanged = useCallback187(
    (selected) => {
      onFilterChange({
        currentCities: selected
      });
    },
    [onFilterChange]
  );
  const onSourceTypeChange = useCallback187(
    (selected) => {
      onFilterChange({
        sourceTypes: selected
      });
    },
    [onFilterChange]
  );
  const onCompaniesChanged = useCallback187(
    (selected) => {
      onStandardFilterChange({
        companies: selected
      });
    },
    [onStandardFilterChange]
  );
  const onIndustriesChanged = useCallback187(
    (selected) => {
      onStandardFilterChange({
        industries: selected
      });
    },
    [onStandardFilterChange]
  );
  const onRecencyChanged = useCallback187(
    (selected) => {
      onFilterChange({
        lastExperienceYear: selected.map((x4) => Number(x4))
      });
    },
    [onFilterChange]
  );
  const onTalentPoolsChanged = useCallback187(
    (selected) => {
      onFilterChange({
        talentPools: selected.map((x4) => x4)
      });
    },
    [onFilterChange]
  );
  const onSkillsChanged = useCallback187(
    (selected) => {
      onStandardFilterChange({
        skills: selected
      });
    },
    [onStandardFilterChange]
  );
  return /* @__PURE__ */ jsx346("div", { className: classNames39("rounded-xl border bg-white"), children: /* @__PURE__ */ jsx346(
    FilterSectionContainer5,
    {
      sections,
      isFiltersOpen: context.isFiltersOpen,
      onToggleOpen: toggleOpen,
      hasSelectedValue: selectedSection !== null,
      toggleSelectedValue: () => setSelectedSection(null),
      children: /* @__PURE__ */ jsxs220(Suspense121, { fallback: "loading multifacet containers", children: [
        selectedSection === "CURRENT_COMPANY" && /* @__PURE__ */ jsx346(
          MultiFacetContainer9,
          {
            fragmentRef: result.aggregations.currentCompany,
            onFacetChanged: onCurrentCompanyChanged
          }
        ),
        selectedSection === "SOURCE_TYPES" && /* @__PURE__ */ jsx346(
          MultiFacetContainer9,
          {
            fragmentRef: result.aggregations.sourceTypes,
            onFacetChanged: onSourceTypeChange
          }
        ),
        selectedSection === "COMPANIES" && /* @__PURE__ */ jsx346(
          MultiFacetContainer9,
          {
            fragmentRef: result.aggregations.standard.companies,
            onFacetChanged: onCompaniesChanged
          }
        ),
        selectedSection === "LOCATIONS" && /* @__PURE__ */ jsxs220(Fragment94, { children: [
          /* @__PURE__ */ jsx346("h1", { className: "px-2 pt-5 text-xl", children: "Locations" }),
          /* @__PURE__ */ jsxs220("div", { className: "flex flex-col gap-5 divide-y-8 ", children: [
            /* @__PURE__ */ jsxs220("div", { children: [
              /* @__PURE__ */ jsx346("h2", { className: "px-2 pt-2 text-lg", children: "Wants to work in" }),
              /* @__PURE__ */ jsx346(
                MultiFacetContainer9,
                {
                  fragmentRef: result.aggregations.countries,
                  onFacetChanged: onCountriesChanged
                }
              ),
              /* @__PURE__ */ jsx346(
                MultiFacetContainer9,
                {
                  fragmentRef: result.aggregations.cities,
                  onFacetChanged: onCitiesChanged
                },
                JSON.stringify(result.aggregations.countries)
              )
            ] }),
            /* @__PURE__ */ jsxs220("div", { children: [
              /* @__PURE__ */ jsx346("h2", { className: "px-2 pt-2 text-lg", children: "Based in" }),
              /* @__PURE__ */ jsx346(
                MultiFacetContainer9,
                {
                  fragmentRef: result.aggregations.currentCountry,
                  onFacetChanged: onCurrentCountryChanged
                }
              ),
              /* @__PURE__ */ jsx346(
                MultiFacetContainer9,
                {
                  fragmentRef: result.aggregations.currentCity,
                  onFacetChanged: onCurrentCityChanged
                },
                JSON.stringify(result.aggregations.currentCountry)
              )
            ] })
          ] })
        ] }),
        selectedSection === "SKILLS" && /* @__PURE__ */ jsx346(
          ProfileSkillsFacetsContainer,
          {
            fragmentRef: result.aggregations.standard,
            onChanged: onSkillsChanged
          }
        ),
        selectedSection === "INDUSTRIES" && /* @__PURE__ */ jsx346(
          MultiFacetContainer9,
          {
            fragmentRef: result.aggregations.standard.industries,
            onFacetChanged: onIndustriesChanged
          }
        ),
        selectedSection === "LAST_EXPERIENCE_YEAR" && /* @__PURE__ */ jsx346(
          MultiFacetContainer9,
          {
            fragmentRef: result.aggregations.lastExperienceYear,
            onFacetChanged: onRecencyChanged
          }
        ),
        selectedSection === "TALENT_POOLS" && /* @__PURE__ */ jsx346(
          MultiFacetContainer9,
          {
            fragmentRef: result.aggregations.talentPools,
            onFacetChanged: onTalentPoolsChanged
          }
        )
      ] })
    }
  ) });
};

// src/profile-search/components/ProfileSearchSortFields.tsx
import { useCallback as useCallback188 } from "react";
import { useAtom as useAtom18 } from "jotai";
import { jsx as jsx347 } from "react/jsx-runtime";
function getProfileSearchSortField(sort) {
  if (sort.standard && sort.standard === "BEST_MATCH") {
    return "BEST_MATCH" /* BEST_MATCH */;
  }
  if (sort.standard && sort.standard === "NAME") {
    return "NAME" /* NAME */;
  }
  if (sort.custom && sort.custom === "LAST_EXPERIENCE_YEAR") {
    return "LAST_EXPERIENCE_YEAR" /* LAST_EXPERIENCE_YEAR */;
  }
  return "BEST_MATCH" /* BEST_MATCH */;
}
var ProfileSearchSortFields = ({ onSearch }) => {
  const [search4, dispatch2] = useAtom18(profileSearchAtom);
  const onSortChanged = useCallback188(
    (value) => {
      const newSearch = {
        ...search4,
        sort: {
          ...search4.sort,
          field: profileSortFieldToGraphQL(value)
        }
      };
      onSearch("ProfileSearchSortFields", newSearch);
      dispatch2({
        source: "ProfileSearchFilter",
        type: "SEARCH",
        payload: newSearch
      });
    },
    [search4, onSearch, dispatch2]
  );
  return /* @__PURE__ */ jsx347(
    "select",
    {
      id: "profileSearchSortFields",
      name: "profileSearchSortFields",
      value: getProfileSearchSortField(search4.sort.field),
      className: "focus:ring-primary-500 focus:border-primary-500 block w-full rounded-md border-gray-300",
      onChange: (e4) => onSortChanged(e4.target.value),
      children: profileSearchSortFields.map((i4) => /* @__PURE__ */ jsx347("option", { value: i4.id, children: i4.name }, i4.id))
    }
  );
};

// src/profile-search/components/ProfileSearchSortDir.tsx
import { useCallback as useCallback189 } from "react";
import { useAtomValue as useAtomValue17 } from "jotai";
import { getSortDirFromGraphQL as getSortDirFromGraphQL4, sortDirToGraphQL as sortDirToGraphQL7 } from "shared-ui";
import { jsx as jsx348 } from "react/jsx-runtime";
var ProfileSearchSortDir = ({ onSearch }) => {
  const search4 = useAtomValue17(profileSearchAtom);
  const onSortChanged = useCallback189(
    (value) => {
      const newSearch = {
        ...search4,
        sort: {
          ...search4.sort,
          order: sortDirToGraphQL7(value)
        }
      };
      onSearch("ProfileSearchSortDir", newSearch);
    },
    [search4, onSearch]
  );
  return /* @__PURE__ */ jsx348("div", { children: /* @__PURE__ */ jsx348(
    SortDirectionList,
    {
      value: getSortDirFromGraphQL4(search4.sort.order),
      onChanged: onSortChanged
    }
  ) });
};

// src/profile-search/components/ProfileSearchQuery.tsx
import { useCallback as useCallback190 } from "react";
import { useAtom as useAtom19 } from "jotai";
import { MagnifyingGlassIcon as MagnifyingGlassIcon5 } from "@heroicons/react/20/solid";
import { InformationCircleIcon } from "@heroicons/react/24/outline";
import { DebouncedInput as DebouncedInput6 } from "shared-ui";
import { jsx as jsx349, jsxs as jsxs221 } from "react/jsx-runtime";
var ProfileSearchQuery = ({ onSearch }) => {
  const [search4, dispatch2] = useAtom19(
    profileSearchAtom
  );
  const onQueryChanged = useCallback190(
    (query3) => {
      const newSearch = {
        ...search4,
        fullTextSearch: {
          query: query3.replace(/“|”/g, '"'),
          queryField: {
            standard: "ALL"
          }
        }
      };
      onSearch("ProfileSearchBox", newSearch);
      dispatch2({
        source: "ProfileSearchBox",
        type: "SEARCH",
        payload: newSearch
      });
    },
    [dispatch2, onSearch, search4]
  );
  return /* @__PURE__ */ jsx349("div", { className: "w-full", children: /* @__PURE__ */ jsxs221("div", { className: "flex w-full grow items-center gap-x-4 lg:gap-x-2", children: [
    /* @__PURE__ */ jsx349("label", { htmlFor: "search-field", className: "sr-only", children: "Search" }),
    /* @__PURE__ */ jsx349(
      InformationCircleIcon,
      {
        className: "h-5 w-5 flex-shrink-0",
        "aria-hidden": "true",
        title: `
This search box supports the following special characters:
'+' signifies AND operation
'|' signifies OR operation
'-' negates a word
"" wraps a word to signify a phrase for searching
'(' and ')' signify precendece
In order to search for any of these special characters, they will need to be scaped with '\\'`
      }
    ),
    /* @__PURE__ */ jsxs221("div", { className: "relative w-full text-gray-400 focus-within:text-gray-600", children: [
      /* @__PURE__ */ jsx349("div", { className: "pointer-events-none absolute inset-y-0 right-1 flex items-center", children: /* @__PURE__ */ jsx349(
        MagnifyingGlassIcon5,
        {
          className: "h-5 w-5 flex-shrink-0",
          "aria-hidden": "true"
        }
      ) }),
      /* @__PURE__ */ jsx349(
        DebouncedInput6,
        {
          placeholder: "Start your Search here\u2026",
          value: search4.fullTextSearch?.query,
          onValueChanged: onQueryChanged
        }
      )
    ] })
  ] }) });
};

// src/profile-search/components/ProfileSearchHeader.tsx
import { jsx as jsx350, jsxs as jsxs223 } from "react/jsx-runtime";
var ProfileSearchHeader = ({
  queryRef: queryRef3,
  isLoading,
  onSearch
}) => {
  const query3 = usePreloadedQuery40(
    profileSearchContainerQueryDef,
    queryRef3
  );
  const [data, refetch] = useRefetchableFragment14(profileSearchContainerFragmentDef, query3);
  const { result } = data;
  return /* @__PURE__ */ jsx350("div", { className: "w-full", children: /* @__PURE__ */ jsx350(
    ProfileSearchFilters,
    {
      fragmentRef: result,
      isLoading,
      onSearch
    }
  ) });
};

// src/profile-search/components/ProfileSearchStartPage.tsx
import { useCallback as useCallback195, useState as useState99 } from "react";
import { useAtom as useAtom23 } from "jotai";
import { MagnifyingGlassIcon as MagnifyingGlassIcon6 } from "@heroicons/react/20/solid";
import { Button as Button90, Input as Input16 } from "shared-ui";

// src/profile-search/components/ProfileSearchSelectedHeader.tsx
import { useCallback as useCallback191 } from "react";
import { useAtom as useAtom20 } from "jotai";
import { Button as Button87, Size as Size44 } from "shared-ui";
import { jsx as jsx351, jsxs as jsxs224 } from "react/jsx-runtime";
var ProfileSearchSelectedHeader = () => {
  const [context, setContext] = useAtom20(profileSearchContextAtom);
  const onClear = useCallback191(() => {
    setContext({
      ...context,
      selectedProfileIds: []
    });
  }, [context, setContext]);
  const onSend = useCallback191(() => {
    setContext({
      ...context,
      isSending: true
    });
  }, [context, setContext]);
  const hasSelectedProfiles = context.selectedProfileIds.length > 0;
  return /* @__PURE__ */ jsx351("div", { children: /* @__PURE__ */ jsxs224("div", { className: "flex items-center gap-1", children: [
    /* @__PURE__ */ jsxs224("div", { className: "flex items-center gap-1 rounded-full border bg-white p-1 pl-3", children: [
      /* @__PURE__ */ jsxs224("div", { className: "text-sm text-gray-800", children: [
        context.selectedProfileIds.length == 0 ? "Select one or more Candidates for a Vacancy Recommendation" : context.selectedProfileIds.length,
        " "
      ] }),
      context.selectedProfileIds.length != 0 && /* @__PURE__ */ jsxs224("div", { className: "pr-1 text-sm text-gray-800", children: [
        "Profile Recommendation",
        context.selectedProfileIds.length != 1 && "s",
        " Selected"
      ] }),
      /* @__PURE__ */ jsx351("div", { children: /* @__PURE__ */ jsx351(
        Button87,
        {
          color: "green",
          size: Size44.md,
          clicked: onSend,
          disabled: !hasSelectedProfiles,
          children: "Send"
        }
      ) })
    ] }),
    hasSelectedProfiles && /* @__PURE__ */ jsx351(Button87, { onClick: onClear, children: "Clear" })
  ] }) });
};

// src/profile-search/components/__generated__/ProfileSearchVacancySendVacancyListQuery.graphql.ts
var node384 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "alias": "vacancies",
      "args": [
        {
          "kind": "Variable",
          "name": "input",
          "variableName": "input"
        }
      ],
      "concreteType": "VacancySearchResult",
      "kind": "LinkedField",
      "name": "recruitVacanciesSearch",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "VacancySearchModel",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "code",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "employerReference",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "vacancyId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ProfileSearchVacancySendVacancyListQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ProfileSearchVacancySendVacancyListQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "aabc34cff555960050938f06215b7887",
      "id": null,
      "metadata": {},
      "name": "ProfileSearchVacancySendVacancyListQuery",
      "operationKind": "query",
      "text": "query ProfileSearchVacancySendVacancyListQuery(\n  $input: VacancySearchInput\n) {\n  vacancies: recruitVacanciesSearch(input: $input) {\n    items {\n      id\n      code\n      name\n      employerReference\n      vacancyId\n    }\n  }\n}\n"
    }
  };
}();
node384.hash = "4b448ee2386eb3ae9eb9828fdd6217da";
var ProfileSearchVacancySendVacancyListQuery_graphql_default = node384;

// src/profile-search/components/ProfileSearchVacancySend.tsx
import { Suspense as Suspense123, useCallback as useCallback194 } from "react";
import { useAtom as useAtom22 } from "jotai";
import { useLazyLoadQuery as useLazyLoadQuery53 } from "react-relay";
import {
  Button as Button89,
  ButtonList as ButtonList35,
  EdSkeleton as EdSkeleton104,
  LinkButton as LinkButton6,
  Size as Size46,
  Table as Table6,
  TextArea as TextArea7
} from "shared-ui";

// src/profile-search/components/__generated__/ProfileSearchSelectedProfilesQuery.graphql.ts
var node385 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "alias": "profiles",
      "args": [
        {
          "kind": "Variable",
          "name": "where",
          "variableName": "where"
        }
      ],
      "concreteType": "RecruitProfilesConnection",
      "kind": "LinkedField",
      "name": "recruitProfiles",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RecruitProfilesEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfile",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "recruitProfileId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "code",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "firstName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "emailAddress",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ProfileSearchSelectedProfilesQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ProfileSearchSelectedProfilesQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "ac306226ff0fa1d23da4f71392046049",
      "id": null,
      "metadata": {},
      "name": "ProfileSearchSelectedProfilesQuery",
      "operationKind": "query",
      "text": "query ProfileSearchSelectedProfilesQuery(\n  $where: RecruitProfileFilter!\n) {\n  profiles: recruitProfiles(where: $where) {\n    edges {\n      node {\n        id\n        recruitProfileId\n        code\n        firstName\n        lastName\n        emailAddress\n      }\n    }\n  }\n}\n"
    }
  };
}();
node385.hash = "cda745661ae2aac5224d1d90458dc6e3";
var ProfileSearchSelectedProfilesQuery_graphql_default = node385;

// src/profile-search/components/ProfileSearchSelectedProfiles.tsx
import { useCallback as useCallback193, useState as useState98 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery51 } from "react-relay";
import { useAtom as useAtom21 } from "jotai";
import { EyeIcon } from "@heroicons/react/24/outline";
import { XCircleIcon as XCircleIcon6 } from "@heroicons/react/24/outline";

// src/profile-search/components/__generated__/ProfileSearchSelectedProfileQuery.graphql.ts
var node386 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "id"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "id"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "recruitProfileId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "emailAddress",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateExperienceId",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyName",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "startDate",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "endDate",
    "storageKey": null
  }, v14 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyIsVerified",
    "storageKey": null
  }, v15 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyId",
    "storageKey": null
  }, v16 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  }, v17 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "skills",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ProfileSearchSelectedProfileQuery",
      "selections": [
        {
          "alias": "profile",
          "args": v1,
          "concreteType": "RecruitProfile",
          "kind": "LinkedField",
          "name": "recruitProfileById",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            v5,
            v6,
            v7,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "Profile_profile"
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ProfileSearchSelectedProfileQuery",
      "selections": [
        {
          "alias": "profile",
          "args": v1,
          "concreteType": "RecruitProfile",
          "kind": "LinkedField",
          "name": "recruitProfileById",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            v5,
            v6,
            v7,
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitCandidateProfileNote",
              "kind": "LinkedField",
              "name": "notes",
              "plural": true,
              "selections": [
                v4,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "content",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitCandidateProfileNoteTag",
                  "kind": "LinkedField",
                  "name": "tags",
                  "plural": true,
                  "selections": [
                    v8,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "value",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "updatedAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsUser",
                  "kind": "LinkedField",
                  "name": "createdByUser",
                  "plural": false,
                  "selections": [
                    v7,
                    v5,
                    v6
                  ],
                  "storageKey": null
                },
                v23
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsCandidateAccount",
              "kind": "LinkedField",
              "name": "account",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "accountId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CandidatePhoneVerification",
                  "kind": "LinkedField",
                  "name": "phone",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "phoneVerificationStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "phoneNumber",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "phoneCountryPrefix",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                v23
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfileExperience",
              "kind": "LinkedField",
              "name": "experience",
              "plural": true,
              "selections": [
                v23,
                v9,
                v10,
                v11,
                v12,
                v13,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "createdOn",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "updatedOn",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "version",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "titleId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "industry",
                  "storageKey": null
                },
                v14,
                v15,
                v16,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "positionType",
                  "storageKey": null
                },
                v17,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "escoOccupationId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "escoHierarchy",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfileWorkLocations",
              "kind": "LinkedField",
              "name": "workLocations",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "currentLocationName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "currentLocationCountryName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "WorkLocationEntry",
                  "kind": "LinkedField",
                  "name": "workLocations",
                  "plural": true,
                  "selections": [
                    v8
                  ],
                  "storageKey": null
                },
                v23
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfileExperience",
              "kind": "LinkedField",
              "name": "currentPosition",
              "plural": false,
              "selections": [
                v10,
                v11,
                v12,
                v13,
                v23
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfileRate",
              "kind": "LinkedField",
              "name": "rate",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "payType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "minimumRateOfPay",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "maximumRateOfPay",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "countryCode",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "currencyCode",
                  "storageKey": null
                },
                v23
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfileAvailability",
              "kind": "LinkedField",
              "name": "availability",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "jobSearchStatus",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "availabilityStatus",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "NoticeCriteria",
                  "kind": "LinkedField",
                  "name": "noticeCriteria",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "availableFrom",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "noticePeriodWeeks",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "noticeTimeframe",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                v23
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "profileType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RightToWork",
              "kind": "LinkedField",
              "name": "rightToWork",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "status",
                  "storageKey": null
                },
                v23
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfileExperienceCollection",
              "kind": "LinkedField",
              "name": "experiences",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperience",
                  "kind": "LinkedField",
                  "name": "items",
                  "plural": true,
                  "selections": [
                    v23,
                    v9,
                    v10,
                    v15,
                    v14,
                    v11,
                    v16,
                    v12,
                    v13,
                    v17
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SkillUsage",
                  "kind": "LinkedField",
                  "name": "skills",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "skillId",
                      "storageKey": null
                    },
                    v8,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "totalMonthsUsed",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "averageMonthsUsed",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "totalPositionsUsed",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastUsed",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DateRange",
                      "kind": "LinkedField",
                      "name": "periods",
                      "plural": true,
                      "selections": [
                        v12,
                        v13
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "d2bfc1fcd6a4b04e8fd20bd11d7f0060",
      "id": null,
      "metadata": {},
      "name": "ProfileSearchSelectedProfileQuery",
      "operationKind": "query",
      "text": "query ProfileSearchSelectedProfileQuery(\n  $id: UUID!\n) {\n  profile: recruitProfileById(id: $id) {\n    id\n    recruitProfileId\n    code\n    firstName\n    lastName\n    emailAddress\n    ...Profile_profile\n  }\n}\n\nfragment ExperienceDetails_experience on RecruitProfileExperience {\n  id\n  createdOn\n  updatedOn\n  candidateExperienceId\n  version\n  titleId\n  title\n  industry\n  companyIsVerified\n  companyId\n  companyName\n  description\n  startDate\n  endDate\n  positionType\n  skills\n  escoOccupationId\n  escoHierarchy\n}\n\nfragment ProfileSearchResultTimeline_profile on RecruitProfile {\n  id\n  experiences {\n    items {\n      id\n      candidateExperienceId\n      title\n      companyId\n      companyIsVerified\n      companyName\n      description\n      startDate\n      endDate\n      skills\n    }\n    skills {\n      skillId\n      name\n      totalMonthsUsed\n      averageMonthsUsed\n      totalPositionsUsed\n      lastUsed\n      periods {\n        startDate\n        endDate\n      }\n    }\n  }\n}\n\nfragment Profile_profile on RecruitProfile {\n  code\n  firstName\n  lastName\n  recruitProfileId\n  emailAddress\n  notes {\n    code\n    content\n    tags {\n      name\n      value\n    }\n    updatedAt\n    createdByUser {\n      emailAddress\n      firstName\n      lastName\n    }\n    id\n  }\n  account {\n    accountId\n    phone {\n      phoneVerificationStatus\n      phoneNumber\n      phoneCountryPrefix\n    }\n    id\n  }\n  experience {\n    id\n    candidateExperienceId\n    title\n    companyName\n    startDate\n    endDate\n    ...ExperienceDetails_experience\n  }\n  ...RecruitProfileHeader_profile\n  ...ProfileSearchResultTimeline_profile\n}\n\nfragment RecruitProfileApplicationHeader_application on RecruitProfile {\n  id\n  firstName\n  lastName\n  workLocations {\n    currentLocationName\n    currentLocationCountryName\n    workLocations {\n      name\n    }\n    id\n  }\n  currentPosition {\n    title\n    companyName\n    startDate\n    endDate\n    id\n  }\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n  availability {\n    jobSearchStatus\n    availabilityStatus\n    noticeCriteria {\n      availableFrom\n      noticePeriodWeeks\n      noticeTimeframe\n    }\n    id\n  }\n}\n\nfragment RecruitProfileHeader_profile on RecruitProfile {\n  ...RecruitProfileApplicationHeader_application\n  id\n  recruitProfileId\n  firstName\n  lastName\n  profileType\n  workLocations {\n    currentLocationName\n    currentLocationCountryName\n    id\n  }\n  account {\n    accountId\n    id\n  }\n  currentPosition {\n    title\n    companyName\n    startDate\n    endDate\n    id\n  }\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n  rightToWork {\n    status\n    id\n  }\n  availability {\n    jobSearchStatus\n    id\n  }\n}\n"
    }
  };
}();
node386.hash = "5d6d9895a28483bfbe4d2681ca069913";
var ProfileSearchSelectedProfileQuery_graphql_default = node386;

// src/profile-search/components/ProfileSearchSelectedProfile.tsx
import { useLazyLoadQuery as useLazyLoadQuery50 } from "react-relay";
import { Button as Button88, ButtonList as ButtonList34, Size as Size45 } from "shared-ui";
import { jsx as jsx353, jsxs as jsxs225 } from "react/jsx-runtime";
var queryDef65 = ProfileSearchSelectedProfileQuery_graphql_default;
var ProfileSearchSelectedProfile = ({
  id: id18,
  onBack,
  onRemove
}) => {
  const query3 = useLazyLoadQuery50(
    queryDef65,
    { id: id18 },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { profile } = query3;
  if (!profile) {
    return /* @__PURE__ */ jsx353("div", { className: "flex flex-col gap-3 py-3", children: "Profile Not Found" });
  }
  return /* @__PURE__ */ jsxs225("div", { className: "flex flex-col gap-3 py-3", children: [
    /* @__PURE__ */ jsx353("div", { className: "border-b py-3", children: /* @__PURE__ */ jsxs225(ButtonList34, { children: [
      /* @__PURE__ */ jsx353("div", { children: /* @__PURE__ */ jsx353(Button88, { color: "primary", size: Size45.md, clicked: onBack, children: "Back" }) }),
      /* @__PURE__ */ jsx353("div", { children: /* @__PURE__ */ jsx353(Button88, { color: "primary", size: Size45.md, clicked: onRemove, children: "Remove" }) })
    ] }) }),
    /* @__PURE__ */ jsxs225("div", { className: "flex flex-col gap-3 py-3", children: [
      /* @__PURE__ */ jsx353(ProfileDetailsComponent, { fragmentRef: profile }),
      /* @__PURE__ */ jsx353(ProfileWorkTimelineDef, { fragmentRef: profile }),
      /* @__PURE__ */ jsx353(ProfileWorkHistoryComponent, { fragmentRef: profile })
    ] })
  ] });
};

// src/profile-search/components/ProfileSearchSelectedProfiles.tsx
import { jsx as jsx354, jsxs as jsxs226 } from "react/jsx-runtime";
var queryDef66 = ProfileSearchSelectedProfilesQuery_graphql_default;
var ProfileSearchSelectedProfiles = () => {
  const [context, setContext] = useAtom21(profileSearchContextAtom);
  const idFilters = context.selectedProfileIds.map((id18) => {
    return { id: { eq: id18 } };
  });
  const where = idFilters.length > 0 ? {
    or: idFilters
  } : null;
  const [selected, setSelected] = useState98(null);
  const onSelect = useCallback193(
    (profile) => {
      setSelected(profile);
    },
    [setSelected]
  );
  const onClearSelected = useCallback193(() => {
    setSelected(null);
  }, [setSelected]);
  const onRemoveSelected = useCallback193(
    ({ profile }) => {
      if (!selected && !profile) {
        return;
      }
      const selectedProfileIds = context.selectedProfileIds.filter(
        (id18) => id18 !== (profile || selected).recruitProfileId
      );
      setContext({
        ...context,
        selectedProfileIds
      });
      setSelected(null);
    },
    [selected, context, setSelected, setContext]
  );
  const onRemoveAll = useCallback193(() => {
    setContext({
      ...context,
      selectedProfileIds: []
    });
    setSelected(null);
  }, [context, setSelected, setContext]);
  return /* @__PURE__ */ jsxs226("div", { className: "flex flex-col gap-5", children: [
    !selected && where && /* @__PURE__ */ jsxs226("div", { className: "flex flex-col gap-3 lg:flex-row", children: [
      /* @__PURE__ */ jsx354("p", { className: "pt-5", children: "Sending To:*" }),
      /* @__PURE__ */ jsx354("div", { className: "bg-white lg:p-4", children: /* @__PURE__ */ jsx354(
        ProfileSearchSelectedProfileList,
        {
          where,
          onSelect,
          onRemove: onRemoveSelected
        }
      ) })
    ] }),
    selected && /* @__PURE__ */ jsx354("div", { className: "border bg-white p-4", children: /* @__PURE__ */ jsx354(
      ProfileSearchSelectedProfile,
      {
        id: selected.recruitProfileId,
        onBack: onClearSelected,
        onRemove: () => onRemoveSelected({ profile: selected })
      }
    ) })
  ] });
};
var ProfileSearchSelectedProfileList = ({
  where,
  onSelect,
  onRemove
}) => {
  const query3 = useLazyLoadQuery51(
    queryDef66,
    { where },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const profiles = query3.profiles?.edges?.map((e4) => e4.node) || [];
  const profilesList = profiles.map((profile) => {
    return /* @__PURE__ */ jsxs226(
      "div",
      {
        className: "flex w-auto flex-col items-start items-center gap-5 rounded-md border-2 border-gray-300 px-5 py-5 lg:flex-row lg:gap-10 lg:gap-20",
        children: [
          /* @__PURE__ */ jsxs226("div", { className: "flex flex-col gap-2", children: [
            /* @__PURE__ */ jsxs226("strong", { children: [
              profile.firstName,
              " ",
              profile.lastName
            ] }),
            /* @__PURE__ */ jsx354("div", { children: profile.emailAddress })
          ] }),
          /* @__PURE__ */ jsxs226("div", { className: "flex items-center gap-5", children: [
            /* @__PURE__ */ jsx354(
              EyeIcon,
              {
                className: "h-10 w-10 cursor-pointer rounded-full bg-green-500 p-2",
                onClick: () => onSelect(profile)
              }
            ),
            /* @__PURE__ */ jsx354(
              XCircleIcon6,
              {
                className: "h-12 w-12 cursor-pointer",
                onClick: () => onRemove({ profile })
              }
            )
          ] })
        ]
      },
      profile.recruitProfileId
    );
  });
  return /* @__PURE__ */ jsx354("div", { className: "flex flex-col flex-wrap gap-5 lg:flex-row", children: profilesList });
};

// src/profile-search/components/ProfileSearchVacancySend.tsx
import { Fragment as Fragment95, jsx as jsx355, jsxs as jsxs227 } from "react/jsx-runtime";
var ProfileSearchVacancySend = () => {
  const [context, setContext] = useAtom22(profileSearchContextAtom);
  const [recommend, isRecommending] = useRecommendVacancy();
  const [filters, setFilters] = useAtom22(vacancySearchAtom);
  const onCancel = useCallback194(() => {
    setContext({
      ...context,
      isSending: false
    });
  }, [context, setContext]);
  const onSelected = useCallback194(
    (result) => {
      setContext({
        ...context,
        selectedVacancy: result,
        isSent: false
      });
    },
    [context, setContext]
  );
  const onClearSelectedVacancy = useCallback194(() => {
    setContext({
      ...context,
      selectedVacancy: null
    });
  }, [context, setContext]);
  const onSetSendMessage = useCallback194(
    (message) => {
      setContext({
        ...context,
        sendMessage: message
      });
    },
    [context, setContext]
  );
  return /* @__PURE__ */ jsxs227("div", { className: "lg:max-6xl flex flex-1 flex-col", children: [
    /* @__PURE__ */ jsx355("div", { className: "relative", children: /* @__PURE__ */ jsx355("div", { children: /* @__PURE__ */ jsx355("h1", { className: "text-2xl lg:pl-4", children: "Send recommendations" }) }) }),
    /* @__PURE__ */ jsxs227("div", { className: "flex flex-col", children: [
      /* @__PURE__ */ jsx355("div", { className: "mt-3 flex w-full lg:p-4", children: /* @__PURE__ */ jsx355(Suspense123, { fallback: /* @__PURE__ */ jsx355(EdSkeleton104, {}), children: /* @__PURE__ */ jsx355(ProfileSearchSelectedProfiles, {}) }) }),
      /* @__PURE__ */ jsx355("div", { className: "mt-3 flex w-full lg:p-4", children: /* @__PURE__ */ jsxs227("div", { className: "flex w-full flex-col lg:mt-0 lg:flex-row lg:gap-10", children: [
        /* @__PURE__ */ jsx355("p", { className: "w-fit", children: "Vacancy*" }),
        /* @__PURE__ */ jsx355("div", { className: "flex w-full items-center justify-between bg-white", children: context.selectedVacancy ? /* @__PURE__ */ jsxs227("div", { className: "flex items-center justify-between gap-2", children: [
          /* @__PURE__ */ jsxs227("div", { className: "flex items-center gap-2", children: [
            /* @__PURE__ */ jsx355("div", { className: "text-gray-900", children: "Vacancy" }),
            /* @__PURE__ */ jsx355("div", { className: "text-primary-900", children: context.selectedVacancy.name })
          ] }),
          /* @__PURE__ */ jsx355("div", { children: /* @__PURE__ */ jsx355(
            LinkButton6,
            {
              label: "Change",
              clicked: onClearSelectedVacancy
            }
          ) })
        ] }) : /* @__PURE__ */ jsx355("div", { className: "w-full", children: /* @__PURE__ */ jsxs227(Suspense123, { fallback: "Loading...", children: [
          /* @__PURE__ */ jsx355(
            VacancySearchBox,
            {
              className: "lg:m-0",
              onSearch: (i4, x4) => setFilters(x4)
            }
          ),
          /* @__PURE__ */ jsx355("div", { className: "@container bg-white", children: /* @__PURE__ */ jsx355(Suspense123, { fallback: "Loading...", children: /* @__PURE__ */ jsx355(VacancyList, { filters, onSelect: onSelected }) }) })
        ] }) }) })
      ] }) })
    ] }),
    /* @__PURE__ */ jsxs227("div", { className: "flex flex-1 flex-col gap-3 bg-white p-4", children: [
      /* @__PURE__ */ jsxs227("div", { className: "flex w-full justify-between gap-10", children: [
        /* @__PURE__ */ jsx355("p", { children: "Message*" }),
        /* @__PURE__ */ jsx355("div", { className: "flex-1", children: /* @__PURE__ */ jsx355(
          TextArea7,
          {
            rows: 3,
            className: "focus:border-info-500 focus:ring-info-500 block w-full rounded-md border border-gray-300 shadow-sm sm:text-sm",
            placeholder: "Message",
            value: context.sendMessage || "",
            onValueChange: onSetSendMessage
          }
        ) })
      ] }),
      /* @__PURE__ */ jsx355("div", { className: "mt-4 border-t py-3", children: /* @__PURE__ */ jsxs227(ButtonList35, { children: [
        /* @__PURE__ */ jsx355("div", { children: /* @__PURE__ */ jsx355(Button89, { color: "transparent", size: Size46.md, clicked: onCancel, children: "Cancel" }) }),
        context.selectedProfileIds.length > 0 && context.selectedVacancy && context.sendMessage ? /* @__PURE__ */ jsx355("div", { children: /* @__PURE__ */ jsx355(
          Button89,
          {
            color: "green",
            size: Size46.md,
            disabled: isRecommending,
            clicked: recommend,
            children: "Send"
          }
        ) }) : /* @__PURE__ */ jsx355("div", { children: /* @__PURE__ */ jsx355(
          Button89,
          {
            color: "gray",
            size: Size46.md,
            disabled: context.selectedProfileIds.length == 0 || !context.selectedVacancy || !context.sendMessage,
            children: "Send"
          }
        ) })
      ] }) })
    ] })
  ] });
};
function VacancyList({
  filters,
  onSelect
}) {
  const { vacancies } = useLazyLoadQuery53(
    VacancyList.query,
    { input: filters }
  );
  const findVacancyByVacancyId = useCallback194(
    (id18) => {
      return vacancies.items.find((x4) => x4.vacancyId === id18);
    },
    [vacancies.items]
  );
  return /* @__PURE__ */ jsx355(
    Table6,
    {
      header: ["Vacancy Name", "Reference"],
      items: vacancies.items.map((x4) => [
        {
          key: "Vacancy Name",
          value: x4.name,
          recordId: x4.vacancyId
        },
        {
          key: "Reference",
          value: String(x4.employerReference),
          recordId: x4.vacancyId
        }
      ]),
      children: ({ recordId, label, key, value }) => {
        const vacancy = findVacancyByVacancyId(recordId) || null;
        return /* @__PURE__ */ jsxs227(Fragment95, { children: [
          /* @__PURE__ */ jsxs227(
            "div",
            {
              onClick: () => onSelect?.(vacancy),
              className: "@4xl:block grid  hidden grid-cols-2",
              children: [
                /* @__PURE__ */ jsx355("div", { className: "font-bold", children: label }),
                /* @__PURE__ */ jsx355("div", { children: value })
              ]
            },
            key + value + "lg"
          ),
          /* @__PURE__ */ jsxs227(
            "div",
            {
              onClick: () => onSelect?.(vacancy),
              className: "@4xl:hidden grid grid-cols-2",
              children: [
                /* @__PURE__ */ jsx355("div", { className: "font-bold", children: label }),
                /* @__PURE__ */ jsx355("div", { children: value })
              ]
            },
            key + value + "sm"
          )
        ] });
      }
    }
  );
}
VacancyList.query = ProfileSearchVacancySendVacancyListQuery_graphql_default;

// src/profile-search/components/ProfileSearchStartPage.tsx
import { jsx as jsx356, jsxs as jsxs228 } from "react/jsx-runtime";
var ProfileSearchStartPage = ({
  onStartSearch
}) => {
  const [context, setContext] = useAtom23(profileSearchContextAtom);
  const [searchInput, dispatch2] = useAtom23(profileSearchAtom);
  const [query3, setQuery] = useState99(null);
  const onSearch = useCallback195(() => {
    if (!query3) {
      return;
    }
    const input = {
      ...searchInput,
      fullTextSearch: {
        query: query3,
        queryField: {
          standard: "ALL"
        }
      }
    };
    dispatch2({ type: "SEARCH", payload: input, source: "ProfileSearchPage" });
    onStartSearch();
  }, [dispatch2, onStartSearch, query3, searchInput]);
  const onKeyDown = useCallback195(
    (event) => {
      if (event.key === "Enter") {
        onSearch();
      }
    },
    [onSearch]
  );
  return /* @__PURE__ */ jsxs228("div", { className: "flex flex-col gap-3 py-4 lg:py-8", children: [
    /* @__PURE__ */ jsxs228("div", { className: "m-auto flex w-1/2 items-center justify-between gap-3 border bg-white p-4", children: [
      context.isSending ? /* @__PURE__ */ jsx356("div", { className: "text-primary-800 text-2xl", children: "Send Recommendations" }) : /* @__PURE__ */ jsx356("div", { className: "text-primary-800 text-2xl", children: "Search Profiles" }),
      /* @__PURE__ */ jsx356(ProfileSearchSelectedHeader, {})
    ] }),
    context.isSending ? /* @__PURE__ */ jsx356("div", { className: "m-auto flex w-1/2", children: /* @__PURE__ */ jsx356(ProfileSearchVacancySend, {}) }) : /* @__PURE__ */ jsxs228("div", { className: "m-auto flex w-1/2 items-center gap-3 rounded-lg border bg-white p-4", children: [
      /* @__PURE__ */ jsxs228("div", { className: "relative w-full text-gray-400 focus-within:text-gray-600", children: [
        /* @__PURE__ */ jsx356("div", { className: "pointer-events-none absolute inset-y-0 right-1 flex items-center", children: /* @__PURE__ */ jsx356(
          MagnifyingGlassIcon6,
          {
            className: "h-5 w-5 flex-shrink-0",
            "aria-hidden": "true"
          }
        ) }),
        /* @__PURE__ */ jsx356(
          Input16,
          {
            onKeyDown,
            onValueChange: setQuery,
            placeholder: "Search for skills, job titles, name, email"
          }
        )
      ] }),
      /* @__PURE__ */ jsx356("div", { children: /* @__PURE__ */ jsx356(Button90, { color: "primary", disabled: !query3, clicked: onSearch, children: "Search" }) })
    ] })
  ] });
};

// src/profile-search/components/__generated__/ProfileSearchPaging_results.graphql.ts
var node387 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileSearchPaging_results",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CollectionMetaData",
      "kind": "LinkedField",
      "name": "pagination",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pages",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pageNumber",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "itemsPerPage",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalResults",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__id",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "ProfileSearchResults",
  "abstractKey": null
};
node387.hash = "36f3ae7dca1d87e5567fb97bdb9a307a";
var ProfileSearchPaging_results_graphql_default = node387;

// src/profile-search/components/ProfileSearchPaging.tsx
import { useCallback as useCallback196 } from "react";
import { useFragment as useFragment108 } from "react-relay";
import { useAtomValue as useAtomValue18 } from "jotai";
import { SimplePagination as SimplePagination6, SimplePaginationCounts as SimplePaginationCounts4 } from "shared-ui";
import { jsx as jsx357, jsxs as jsxs229 } from "react/jsx-runtime";
var fragmentDef89 = ProfileSearchPaging_results_graphql_default;
var ProfileSearchPaging = ({ fragmentRef, onSearch }) => {
  const data = useFragment108(
    fragmentDef89,
    fragmentRef
  );
  const search4 = useAtomValue18(profileSearchAtom);
  const onPage = useCallback196(
    (p4) => {
      const newSearch = {
        ...search4,
        pagination: {
          ...search4.pagination,
          pageNumber: p4
        }
      };
      onSearch("ProfileSearchPaging", newSearch);
    },
    [search4, onSearch]
  );
  return /* @__PURE__ */ jsxs229("div", { className: "flex flex-col-reverse items-center justify-end lg:items-end", children: [
    /* @__PURE__ */ jsx357(
      SimplePagination6,
      {
        name: "vacancy-application-search-paging",
        pages: data.pagination.pages,
        pageNumber: data.pagination.pageNumber,
        itemsPerPage: data.pagination.itemsPerPage,
        totalResults: data.pagination.totalResults,
        onPage
      }
    ),
    /* @__PURE__ */ jsx357(
      SimplePaginationCounts4,
      {
        pages: data.pagination.pages,
        pageNumber: data.pagination.pageNumber,
        itemsPerPage: data.pagination.itemsPerPage,
        totalResults: data.pagination.totalResults
      }
    )
  ] });
};

// src/profile-search/components/__generated__/ProfileSearchActiveFilters_results.graphql.ts
var node388 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  }, v1 = {
    "args": null,
    "kind": "FragmentSpread",
    "name": "AggregationTags_Aggregation"
  }, v23 = [
    v0,
    v1
  ], v32 = [
    v0,
    {
      "alias": null,
      "args": null,
      "concreteType": "DefaultAggregationValueModel",
      "kind": "LinkedField",
      "name": "values",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isSelected",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    v1
  ];
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProfileSearchActiveFilters_results",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CollectionMetaData",
        "kind": "LinkedField",
        "name": "pagination",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalResults",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "itemsPerPage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pageNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pages",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProfileSearchAggregations",
        "kind": "LinkedField",
        "name": "aggregations",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StandardAggregationResults",
            "kind": "LinkedField",
            "name": "standard",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "skills",
                "plural": false,
                "selections": v23,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "companies",
                "plural": false,
                "selections": v23,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "industries",
                "plural": false,
                "selections": v23,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultAggregationModel",
                "kind": "LinkedField",
                "name": "escoLevel1",
                "plural": false,
                "selections": v23,
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DefaultAggregationModel",
            "kind": "LinkedField",
            "name": "currentCompany",
            "plural": false,
            "selections": v23,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DefaultAggregationModel",
            "kind": "LinkedField",
            "name": "countries",
            "plural": false,
            "selections": v32,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DefaultAggregationModel",
            "kind": "LinkedField",
            "name": "currentCountry",
            "plural": false,
            "selections": v32,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DefaultAggregationModel",
            "kind": "LinkedField",
            "name": "currentCity",
            "plural": false,
            "selections": v23,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DefaultAggregationModel",
            "kind": "LinkedField",
            "name": "cities",
            "plural": false,
            "selections": v23,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DefaultAggregationModel",
            "kind": "LinkedField",
            "name": "lastExperienceYear",
            "plural": false,
            "selections": v23,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DefaultAggregationModel",
            "kind": "LinkedField",
            "name": "sourceTypes",
            "plural": false,
            "selections": v23,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DefaultAggregationModel",
            "kind": "LinkedField",
            "name": "talentPools",
            "plural": false,
            "selections": v23,
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "kind": "ClientExtension",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__id",
            "storageKey": null
          }
        ]
      }
    ],
    "type": "ProfileSearchResults",
    "abstractKey": null
  };
}();
node388.hash = "fc58e6002b56c98dce5d31693f4b4a04";
var ProfileSearchActiveFilters_results_graphql_default = node388;

// src/profile-search/components/ProfileSearchActiveFilters.tsx
import { Suspense as Suspense124 } from "react";
import { useFragment as useFragment109 } from "react-relay";
import { AggregationTags as AggregationTags5, DisplayFieldEnum as DisplayFieldEnum5 } from "shared-ui";
import { jsx as jsx358, jsxs as jsxs230 } from "react/jsx-runtime";
var fragmentDef90 = ProfileSearchActiveFilters_results_graphql_default;
var ProfileSearchActiveFilters = ({ fragmentRef }) => {
  const data = useFragment109(
    fragmentDef90,
    fragmentRef
  );
  return /* @__PURE__ */ jsx358(Suspense124, { fallback: "Loading...", children: /* @__PURE__ */ jsxs230("div", { className: "flex flex-col gap-2", children: [
    /* @__PURE__ */ jsx358("div", { children: /* @__PURE__ */ jsxs230("div", { className: "flex flex-wrap gap-1", children: [
      /* @__PURE__ */ jsx358(
        AggregationTags5,
        {
          fragmentRef: data.aggregations.standard.companies
        }
      ),
      /* @__PURE__ */ jsx358(
        AggregationTags5,
        {
          fragmentRef: data.aggregations.standard.industries
        }
      ),
      /* @__PURE__ */ jsx358(
        AggregationTags5,
        {
          fragmentRef: data.aggregations.standard.skills,
          displayField: DisplayFieldEnum5.text
        }
      ),
      /* @__PURE__ */ jsx358(AggregationTags5, { fragmentRef: data.aggregations.sourceTypes }),
      /* @__PURE__ */ jsx358(AggregationTags5, { fragmentRef: data.aggregations.currentCompany }),
      /* @__PURE__ */ jsx358(
        AggregationTags5,
        {
          fragmentRef: data.aggregations.talentPools,
          displayField: DisplayFieldEnum5.text
        }
      ),
      /* @__PURE__ */ jsx358(
        AggregationTags5,
        {
          tagColor: "bg-green-100",
          fragmentRef: data.aggregations.lastExperienceYear
        }
      )
    ] }) }),
    /* @__PURE__ */ jsxs230("div", { className: "flex flex-col gap-2 md:flex-row", children: [
      data.aggregations.countries.values.filter((x4) => x4.isSelected).length > 0 && /* @__PURE__ */ jsxs230("div", { className: "flex shrink flex-col gap-1 rounded-lg p-1", children: [
        /* @__PURE__ */ jsx358("div", { className: "font-base text-[8px] leading-[8px] text-gray-700 md:font-bold", children: "Wants to work in" }),
        /* @__PURE__ */ jsx358("div", { className: "flex ", children: /* @__PURE__ */ jsxs230("div", { className: "flex flex-wrap gap-1 overflow-hidden rounded", children: [
          /* @__PURE__ */ jsx358(AggregationTags5, { fragmentRef: data.aggregations.countries }),
          /* @__PURE__ */ jsx358(AggregationTags5, { fragmentRef: data.aggregations.cities })
        ] }) })
      ] }),
      data.aggregations.currentCountry.values.filter((x4) => x4.isSelected).length > 0 && /* @__PURE__ */ jsxs230("div", { className: "flex flex-col gap-1 rounded-lg  p-1", children: [
        /* @__PURE__ */ jsx358("div", { className: "font-base text-[8px] leading-[8px] text-gray-700 md:font-bold", children: "Based in" }),
        /* @__PURE__ */ jsx358("div", { className: "flex ", children: /* @__PURE__ */ jsxs230("div", { className: "flex flex-wrap gap-1 overflow-hidden rounded", children: [
          /* @__PURE__ */ jsx358(
            AggregationTags5,
            {
              fragmentRef: data.aggregations.currentCountry
            }
          ),
          /* @__PURE__ */ jsx358(
            AggregationTags5,
            {
              fragmentRef: data.aggregations.currentCity
            }
          )
        ] }) })
      ] })
    ] })
  ] }) });
};

// src/profile-search/components/ProfileSearchContainer.tsx
import { Fragment as Fragment96, jsx as jsx359, jsxs as jsxs231 } from "react/jsx-runtime";
var profileSearchContainerQueryDef = ProfileSearchContainerQuery_graphql_default;
var profileSearchContainerFragmentDef = ProfileSearchContainerFragment_graphql_default;
var ProfileSearchLoader = () => {
  const [queryReference, loadQuery48] = useQueryLoader19(profileSearchContainerQueryDef);
  const [isLoading, startTransition2] = useTransition14();
  const onSearch = useCallback197(
    (source, change) => {
      const input = {
        input: change
      };
      startTransition2(() => {
        loadQuery48(input, { fetchPolicy: "network-only" });
      });
    },
    [loadQuery48]
  );
  const [showFilters, toggleFilters] = useToggle34(false);
  const [context, setContext] = useAtom24(profileSearchContextAtom);
  return /* @__PURE__ */ jsxs231(Fragment96, { children: [
    /* @__PURE__ */ jsx359("div", { className: "flex flex-col bg-white  lg:pb-0", children: /* @__PURE__ */ jsxs231("div", { className: "flex flex-col justify-between gap-2 px-4 py-2 lg:flex-row lg:gap-0", children: [
      /* @__PURE__ */ jsx359("div", { className: "flex items-center justify-between", children: /* @__PURE__ */ jsx359("div", { className: "flex items-center gap-3", children: /* @__PURE__ */ jsx359("div", { className: "py-2 text-2xl font-medium text-gray-700", children: "Profile Search" }) }) }),
      /* @__PURE__ */ jsx359("div", { className: "m-auto", children: /* @__PURE__ */ jsx359("div", { className: "flex w-full items-center gap-3", children: /* @__PURE__ */ jsx359("div", { className: "flex w-full justify-end self-end", children: /* @__PURE__ */ jsx359("div", { className: "flex min-w-full lg:min-w-[600px]", children: /* @__PURE__ */ jsx359(ProfileSearchQuery, { onSearch }) }) }) }) })
    ] }) }),
    /* @__PURE__ */ jsxs231(
      Suspense125,
      {
        fallback: /* @__PURE__ */ jsx359("div", { children: /* @__PURE__ */ jsx359(Spinner11, {}) }),
        children: [
          queryReference && /* @__PURE__ */ jsxs231("div", { className: "flex flex-col", children: [
            /* @__PURE__ */ jsx359(Suspense125, { fallback: "loading filters", children: /* @__PURE__ */ jsx359(
              PreloadedQueryHOC,
              {
                queryDef: profileSearchContainerQueryDef,
                fragmentDef: profileSearchContainerFragmentDef,
                queryRef: queryReference,
                children: ({ data }) => {
                  if (!data?.result) {
                    return /* @__PURE__ */ jsx359(Fragment96, { children: "Loading" });
                  }
                  return /* @__PURE__ */ jsxs231("div", { className: "flex flex-col", children: [
                    /* @__PURE__ */ jsx359("div", { className: "p-2", children: /* @__PURE__ */ jsx359(ProfileSearchActiveFilters, { fragmentRef: data.result }) }),
                    /* @__PURE__ */ jsxs231("div", { className: "flex flex-col justify-between gap-2 px-2 lg:flex-row lg:items-end lg:gap-0", children: [
                      /* @__PURE__ */ jsx359("div", { children: /* @__PURE__ */ jsx359(ProfileSearchSelectedHeader, {}) }),
                      /* @__PURE__ */ jsxs231("div", { className: "flex flex-row gap-3 lg:self-end", children: [
                        /* @__PURE__ */ jsx359("div", { className: "w-full self-end", children: /* @__PURE__ */ jsx359(ProfileSearchSortFields, { onSearch }) }),
                        /* @__PURE__ */ jsx359("div", { className: "grow self-end", children: /* @__PURE__ */ jsx359(ProfileSearchSortDir, { onSearch }) }),
                        /* @__PURE__ */ jsx359("div", { className: "hidden lg:block", children: /* @__PURE__ */ jsx359(
                          ProfileSearchPaging,
                          {
                            fragmentRef: data.result,
                            onSearch
                          }
                        ) })
                      ] })
                    ] })
                  ] });
                }
              }
            ) }),
            /* @__PURE__ */ jsxs231("div", { className: "flex grow flex-col gap-3 p-2", children: [
              /* @__PURE__ */ jsx359("div", { className: "self-end", children: /* @__PURE__ */ jsx359(
                Button91,
                {
                  color: "primary",
                  onClick: toggleFilters,
                  className: "lg:hidden",
                  children: /* @__PURE__ */ jsx359(IconText6, { text: "Filters", icon: Icons7.FilterHorizontal })
                }
              ) }),
              /* @__PURE__ */ jsxs231("div", { className: "flex gap-3 ", children: [
                /* @__PURE__ */ jsx359(
                  "div",
                  {
                    className: classNames40(
                      "w-full grow lg:min-w-[400px] lg:max-w-[400px]",
                      showFilters ? "flex" : "hidden lg:flex"
                    ),
                    children: /* @__PURE__ */ jsx359(Suspense125, { fallback: "loading profilesearchheader", children: /* @__PURE__ */ jsx359(
                      ProfileSearchHeader,
                      {
                        queryRef: queryReference,
                        isLoading: false,
                        onSearch
                      }
                    ) })
                  }
                ),
                /* @__PURE__ */ jsxs231(
                  "div",
                  {
                    className: classNames40(
                      showFilters && "hidden",
                      "w-full flex-col lg:flex"
                    ),
                    children: [
                      /* @__PURE__ */ jsx359(Suspense125, { children: /* @__PURE__ */ jsx359(
                        ProfileSearchList,
                        {
                          queryRef: queryReference,
                          isLoading: false
                        }
                      ) }),
                      /* @__PURE__ */ jsx359(
                        PreloadedQueryHOC,
                        {
                          queryDef: profileSearchContainerQueryDef,
                          fragmentDef: profileSearchContainerFragmentDef,
                          queryRef: queryReference,
                          children: ({ data }) => {
                            return /* @__PURE__ */ jsx359("div", { className: "self-end py-5", children: data?.result && /* @__PURE__ */ jsx359(
                              ProfileSearchPaging,
                              {
                                fragmentRef: data.result,
                                onSearch
                              }
                            ) });
                          }
                        }
                      ),
                      context.isSending ? /* @__PURE__ */ jsx359(
                        Modal2,
                        {
                          onClose: () => setContext({
                            ...context,
                            isSending: false
                          }),
                          children: /* @__PURE__ */ jsx359("div", { className: "flex w-full flex-col items-center justify-center p-5", children: /* @__PURE__ */ jsx359("div", { className: "max-h-screen overflow-scroll rounded-2xl bg-white p-5 lg:w-full lg:max-w-[1400px]", children: /* @__PURE__ */ jsx359(ProfileSearchVacancySend, {}) }) })
                        }
                      ) : /* @__PURE__ */ jsx359(Fragment96, {})
                    ]
                  }
                )
              ] })
            ] })
          ] }),
          isLoading && /* @__PURE__ */ jsx359("div", { className: "mt-20 flex h-screen w-full items-start justify-center", children: /* @__PURE__ */ jsx359(Loading11, {}) })
        ]
      }
    )
  ] });
};
var ProfileSearchContainer = () => {
  const [hasStartedSearch, setHasStartedSearch] = useState100(true);
  return /* @__PURE__ */ jsxs231("div", { children: [
    !hasStartedSearch && /* @__PURE__ */ jsx359(
      ProfileSearchStartPage,
      {
        onStartSearch: () => setHasStartedSearch(true)
      }
    ),
    hasStartedSearch && /* @__PURE__ */ jsx359(ProfileSearchLoader, {})
  ] });
};

// src/profiles/list/components/__generated__/RecruitProfileApplicationHeader_application.graphql.ts
var node389 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RecruitProfileApplicationHeader_application",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RecruitProfileWorkLocations",
      "kind": "LinkedField",
      "name": "workLocations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currentLocationName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currentLocationCountryName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "WorkLocationEntry",
          "kind": "LinkedField",
          "name": "workLocations",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RecruitProfileExperience",
      "kind": "LinkedField",
      "name": "currentPosition",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "companyName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endDate",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RecruitProfileRate",
      "kind": "LinkedField",
      "name": "rate",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "payType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "minimumRateOfPay",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "maximumRateOfPay",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "countryCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currencyCode",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RecruitProfileAvailability",
      "kind": "LinkedField",
      "name": "availability",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "jobSearchStatus",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "availabilityStatus",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "NoticeCriteria",
          "kind": "LinkedField",
          "name": "noticeCriteria",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "availableFrom",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "noticePeriodWeeks",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "noticeTimeframe",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RecruitProfile",
  "abstractKey": null
};
node389.hash = "0da3980a78a0cb11fed0e8f7bdbc6f02";
var RecruitProfileApplicationHeader_application_graphql_default = node389;

// src/profiles/list/components/RecruitProfileApplicationHeader.tsx
import { createContext as createContext12, useContext as useContext12 } from "react";
import { useFragment as useFragment110 } from "react-relay";
import { TrophyIcon as TrophyIcon2 } from "@heroicons/react/24/outline";
import { datesAndDuration as datesAndDuration2, parseDate as parseDate16, useToggle as useToggle35 } from "shared-lib";
import { Button as Button93, ExpandButton as ExpandButton2, Size as Size47, ToolTipMessage } from "shared-ui";
import { Fragment as Fragment97, jsx as jsx360, jsxs as jsxs233 } from "react/jsx-runtime";
var fragmentDef91 = RecruitProfileApplicationHeader_application_graphql_default;
var ShowExpandApplicationProfile = createContext12(true);
var RecruitProfileApplicationHeader = ({
  fragmentRef,
  applicationUrl,
  applicationRank,
  applicationTotal,
  children
}) => {
  const profile = useFragment110(
    fragmentDef91,
    fragmentRef
  );
  const showExpand = useContext12(ShowExpandApplicationProfile);
  const [showMore, toggleShowMore] = useToggle35(false);
  return /* @__PURE__ */ jsx360("div", { className: "flex w-full flex-col gap-2 px-4 py-5 lg:rounded-xl lg:border", children: /* @__PURE__ */ jsx360("div", { className: "@7xl:flex-row flex flex-col lg:gap-8", children: /* @__PURE__ */ jsxs233("div", { className: "flex grow flex-row gap-5", children: [
    /* @__PURE__ */ jsxs233("div", { className: "flex grow flex-col gap-5 md:flex-row", children: [
      applicationRank && applicationTotal && /* @__PURE__ */ jsx360("div", { children: /* @__PURE__ */ jsx360(ToolTipMessage, { tooltip: "Candidate Ranking", children: /* @__PURE__ */ jsxs233("div", { className: "bg-primary-100 flex h-14 w-14 flex-col items-center justify-center gap-1 rounded-full md:h-20 md:w-20", children: [
        /* @__PURE__ */ jsx360(TrophyIcon2, { className: "text-primary-800 h-4 w-4 md:h-5 md:w-5" }),
        /* @__PURE__ */ jsxs233("div", { className: "text-primary-800 text-xs md:text-base", children: [
          applicationRank,
          "/",
          applicationTotal
        ] })
      ] }) }) }),
      /* @__PURE__ */ jsx360("div", { className: "flex w-full flex-col gap-2", children: /* @__PURE__ */ jsxs233("div", { className: "flex flex-col justify-between gap-5 md:flex-row", children: [
        /* @__PURE__ */ jsxs233("div", { className: "w-full", children: [
          /* @__PURE__ */ jsx360("div", { className: "flex w-full items-center justify-between gap-2", children: /* @__PURE__ */ jsx360("div", { className: "flex gap-2  whitespace-nowrap", children: /* @__PURE__ */ jsxs233("div", { className: "text-2xl font-medium uppercase text-gray-900", children: [
            profile.firstName,
            " ",
            profile.lastName
          ] }) }) }),
          profile.currentPosition && /* @__PURE__ */ jsxs233("div", { className: "mt-3 flex flex-col gap-3", children: [
            /* @__PURE__ */ jsxs233("div", { className: "flex flex-col", children: [
              /* @__PURE__ */ jsxs233("strong", { className: "text-base", children: [
                profile.currentPosition.title,
                " at",
                " ",
                profile.currentPosition.companyName
              ] }),
              /* @__PURE__ */ jsx360("span", { className: "text-sm", children: datesAndDuration2(
                parseDate16(profile.currentPosition.startDate),
                parseDate16(profile.currentPosition.endDate)
              ) })
            ] }),
            profile.workLocations.workLocations.length > 0 && /* @__PURE__ */ jsx360(Fragment97, { children: /* @__PURE__ */ jsxs233("p", { children: [
              /* @__PURE__ */ jsx360("strong", { children: "Willing To Work in:" }),
              " ",
              /* @__PURE__ */ jsx360("span", { children: profile.workLocations.workLocations.slice(
                0,
                showMore ? profile.workLocations.workLocations.length : 5
              ).map(({ name }) => name).join(", ") }),
              profile.workLocations.workLocations.length > 5 && /* @__PURE__ */ jsx360("div", { children: /* @__PURE__ */ jsx360(
                Button93,
                {
                  size: Size47.sm,
                  className: "mt-2 border",
                  color: "transparent",
                  onClick: toggleShowMore,
                  children: showMore ? "See Less" : "See More"
                }
              ) })
            ] }) })
          ] })
        ] }),
        /* @__PURE__ */ jsx360("div", { className: "flex w-full flex-col gap-3", children })
      ] }) })
    ] }),
    applicationUrl && showExpand && /* @__PURE__ */ jsx360("div", { children: /* @__PURE__ */ jsx360(ExpandButton2, { to: applicationUrl, label: "View Application" }) })
  ] }) }) });
};
var RightToWorkStatus = ({ status }) => {
  switch (status) {
    case "NOT_SET":
      return /* @__PURE__ */ jsx360("div", { className: "text-red-700", children: "Hasn't confirmed Right to Work" });
    case "DOESNT_HAVE_RIGHT_TO_WORK":
      return /* @__PURE__ */ jsx360("div", { className: "text-red-700", children: "Doesn't have Right to Work" });
    case "HAS_RIGHT_TO_WORK":
      return /* @__PURE__ */ jsx360("div", { className: "text-sulu-700", children: "Has Right to Work" });
  }
};

// src/profiles/list/components/RecruitProfileHeader.tsx
import { jsx as jsx361, jsxs as jsxs234 } from "react/jsx-runtime";
var fragmentDef92 = RecruitProfileHeader_profile_graphql_default;
var ShowExpandProfile = createContext13(true);
var RecruitProfileHeader = ({
  fragmentRef,
  expandLink,
  rightToWorkStatus,
  currentStatus,
  showSelect = true
}) => {
  const profile = useFragment111(
    fragmentDef92,
    fragmentRef
  );
  const [context, setContext] = useAtom25(profileSearchContextAtom);
  const onSelect = useCallback198(() => {
    if (!profile.account) {
      return;
    }
    const isSelected2 = context.selectedProfileIds.some(
      (id18) => id18 === profile.recruitProfileId
    );
    const selectedProfileIds = isSelected2 ? context.selectedProfileIds.filter((id18) => id18 !== profile.recruitProfileId) : [...context.selectedProfileIds, profile.recruitProfileId];
    setContext({
      ...context,
      selectedProfileIds
    });
  }, [profile, context, setContext]);
  const isSelected = context.selectedProfileIds && context.selectedProfileIds.some((id18) => id18 === profile.recruitProfileId);
  return /* @__PURE__ */ jsxs234("div", { className: "flex flex-col gap-2 px-5 pb-2 pt-5", children: [
    /* @__PURE__ */ jsx361(
      RecruitProfileApplicationHeader,
      {
        fragmentRef: profile,
        applicationUrl: expandLink,
        children: /* @__PURE__ */ jsxs234("div", { className: "flex w-full justify-between", children: [
          /* @__PURE__ */ jsx361("div", { children: profile.rate && /* @__PURE__ */ jsx361("div", { className: "flex w-full justify-start font-bold", children: /* @__PURE__ */ jsx361(RateLabel, { rate: profile.rate }) }) }),
          showSelect && /* @__PURE__ */ jsx361("div", { className: "", children: /* @__PURE__ */ jsx361("div", { className: "flex flex-col items-end justify-end gap-2", children: profile.account && /* @__PURE__ */ jsx361("div", { children: /* @__PURE__ */ jsx361(
            SwitchInputComponent3,
            {
              value: isSelected,
              onChange: onSelect
            }
          ) }) }) })
        ] })
      }
    ),
    /* @__PURE__ */ jsx361(Suspense126, { children: /* @__PURE__ */ jsx361(DeferredResumeDownload, { profileId: profile.recruitProfileId }) })
  ] });
};

// src/applications/lib/Profile.ts
function formatRate(rate) {
  if (!rate) {
    return "";
  }
  return `${rate.currencyCode} ${formatCurrency(
    rate.currencyCode,
    rate.min
  )}-${formatCurrency(rate.currencyCode, rate.max)} ${payTypeLabel(
    rate?.payType || "PER_DAY"
  )}`;
}

// src/applications/components/__generated__/ApplicationSubmitButtonMutation.graphql.ts
var node390 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfApplicationSqlReadModel",
    "kind": "LinkedField",
    "name": "application",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Application",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "applicationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "version",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "applicationStateId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "applicationStateName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "workflowStateId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "workflowStateName",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v32 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ApplicationSubmitButtonMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "RecruitApplicationSubmitPayload",
          "kind": "LinkedField",
          "name": "recruitApplicationSubmit",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ApplicationSubmitButtonMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "RecruitApplicationSubmitPayload",
          "kind": "LinkedField",
          "name": "recruitApplicationSubmit",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "785943bbda20f5963924b17c254d03d1",
      "id": null,
      "metadata": {},
      "name": "ApplicationSubmitButtonMutation",
      "operationKind": "mutation",
      "text": "mutation ApplicationSubmitButtonMutation(\n  $input: RecruitApplicationSubmitInput!\n) {\n  recruitApplicationSubmit(input: $input) {\n    application {\n      cursor\n      node {\n        id\n        applicationId\n        status\n        version\n        applicationStateId\n        applicationStateName\n        workflowStateId\n        workflowStateName\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node390.hash = "534f05cc610c7d9f4f72dc9cf388875f";
var ApplicationSubmitButtonMutation_graphql_default = node390;

// src/applications/components/ApplicationSubmitButton.tsx
import { useMutation as useMutation27 } from "react-relay";
import {
  createClientMutationId as createClientMutationId78,
  useSetUserErrorCodes as useSetUserErrorCodes33,
  useUnhandledError as useUnhandledError30
} from "shared-lib";
import { Button as Button94, Size as Size48 } from "shared-ui";
import { jsx as jsx363 } from "react/jsx-runtime";
var mutationDef84 = ApplicationSubmitButtonMutation_graphql_default;
var ApplicationSubmitButton = ({
  disabled,
  applicationId,
  onSaving,
  onCompleted
}) => {
  const [, setUnhandledError] = useUnhandledError30();
  const setErrorCode = useSetUserErrorCodes33();
  const [commitMutation4, isMutationInFlight] = useMutation27(mutationDef84);
  return /* @__PURE__ */ jsx363(
    Button94,
    {
      className: "h-12 w-full",
      color: "primary",
      size: Size48.xl,
      clicked: () => {
        onSaving();
        const clientMutationId = createClientMutationId78();
        commitMutation4({
          variables: {
            input: { applicationId, clientMutationId }
          },
          onError: setUnhandledError,
          onCompleted: (response) => {
            if (response.recruitApplicationSubmit.application?.node) {
              onCompleted(
                response.recruitApplicationSubmit.application?.node.applicationId
              );
            }
            if (response.recruitApplicationSubmit.userErrors && response.recruitApplicationSubmit.userErrors.length > 0) {
              const userError = response.recruitApplicationSubmit.userErrors;
              if (userError) {
                setErrorCode(userError);
              }
            }
          }
        });
      },
      disabled: isMutationInFlight || disabled,
      children: "Submit Now"
    }
  );
};

// src/applications/components/__generated__/ApplicationResumeContainerQuery.graphql.ts
var node391 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "resumeId"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "resumeId"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "resumeId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "profileId",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fileName",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasExperience",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasExperienceToClarify",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasRecentExperience",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasRecentExperienceToClarify",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasExperienceToImport",
    "storageKey": null
  }, v14 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasValidExperience",
    "storageKey": null
  }, v15 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasInValidExperience",
    "storageKey": null
  }, v16 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "addedToProfile",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ApplicationResumeContainerQuery",
      "selections": [
        {
          "alias": "resume",
          "args": v1,
          "concreteType": "RecruitResume",
          "kind": "LinkedField",
          "name": "recruitResumeById",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            v10,
            v11,
            v12,
            v13,
            v14,
            v15,
            v16,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ResumeHeader_resume"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ResumeClarifyPositions_resume"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ResumeWorkflow_resume"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ResumePositions_resume"
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ApplicationResumeContainerQuery",
      "selections": [
        {
          "alias": "resume",
          "args": v1,
          "concreteType": "RecruitResume",
          "kind": "LinkedField",
          "name": "recruitResumeById",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            v10,
            v11,
            v12,
            v13,
            v14,
            v15,
            v16,
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitResumeData",
              "kind": "LinkedField",
              "name": "resumeData",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitResumePosition",
                  "kind": "LinkedField",
                  "name": "employmentHistory",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "index",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isInProfile",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "canClarify",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "canImport",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "companyId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "companyName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "companyIsVerified",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "inProfileOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasInvalidCompany",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasInvalidFromDate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasInvalidToDate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "title",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "resumePositionType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "industry",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "from",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "to",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobTitles",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "SkillTag",
                      "kind": "LinkedField",
                      "name": "skills",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "skillId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "skillName",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isExcluded",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "36cb767f49733b90684fe6a4ac38ea57",
      "id": null,
      "metadata": {},
      "name": "ApplicationResumeContainerQuery",
      "operationKind": "query",
      "text": "query ApplicationResumeContainerQuery(\n  $resumeId: UUID!\n) {\n  resume: recruitResumeById(id: $resumeId) {\n    id\n    resumeId\n    profileId\n    createdAt\n    updatedAt\n    fileName\n    status\n    hasExperience\n    hasExperienceToClarify\n    hasRecentExperience\n    hasRecentExperienceToClarify\n    hasExperienceToImport\n    hasValidExperience\n    hasInValidExperience\n    addedToProfile\n    ...ResumeHeader_resume\n    ...ResumeClarifyPositions_resume\n    ...ResumeWorkflow_resume\n    ...ResumePositions_resume\n  }\n}\n\nfragment ResumeClarifyPositions_resume on RecruitResume {\n  id\n  resumeId\n  resumeData {\n    employmentHistory {\n      index\n      isInProfile\n      canClarify\n      canImport\n      ...ResumePositionEditor_position\n    }\n  }\n}\n\nfragment ResumeHeader_resume on RecruitResume {\n  id\n  resumeId\n  profileId\n  createdAt\n  updatedAt\n  fileName\n  status\n}\n\nfragment ResumePositionEditor_position on RecruitResumePosition {\n  index\n  companyId\n  companyName\n  companyIsVerified\n  canClarify\n  canImport\n  isInProfile\n  inProfileOn\n  hasInvalidCompany\n  hasInvalidFromDate\n  hasInvalidToDate\n  title\n  resumePositionType\n  industry\n  description\n  from\n  to\n  jobTitles\n  skills {\n    skillId\n    skillName\n  }\n}\n\nfragment ResumePosition_position on RecruitResumePosition {\n  index\n  companyId\n  companyName\n  companyIsVerified\n  canClarify\n  canImport\n  isInProfile\n  isExcluded\n  inProfileOn\n  title\n  resumePositionType\n  industry\n  description\n  from\n  to\n  jobTitles\n  skills {\n    skillId\n    skillName\n  }\n}\n\nfragment ResumePositions_resume on RecruitResume {\n  id\n  resumeId\n  profileId\n  resumeData {\n    employmentHistory {\n      index\n      canImport\n      isInProfile\n      ...ResumePosition_position\n    }\n  }\n}\n\nfragment ResumeWorkflow_resume on RecruitResume {\n  id\n  resumeId\n  profileId\n  createdAt\n  updatedAt\n  fileName\n  status\n  hasExperience\n  hasExperienceToClarify\n  hasRecentExperience\n  hasRecentExperienceToClarify\n  hasExperienceToImport\n  hasValidExperience\n  hasInValidExperience\n  addedToProfile\n  resumeData {\n    employmentHistory {\n      index\n      isInProfile\n      canClarify\n      canImport\n      ...ResumePositionEditor_position\n    }\n  }\n}\n"
    }
  };
}();
node391.hash = "ed2849b87a8308a2827fc0ff66a101c5";
var ApplicationResumeContainerQuery_graphql_default = node391;

// src/applications/components/ApplicationResumeContainer.tsx
import { useCallback as useCallback199, useState as useState101 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery54 } from "react-relay";
import { useLogger as useLogger24 } from "shared-lib";
import { Fragment as Fragment98, jsx as jsx364, jsxs as jsxs235 } from "react/jsx-runtime";
var queryDef67 = ApplicationResumeContainerQuery_graphql_default;
var ApplicationResumeContainer = ({
  profileId,
  resumeId
}) => {
  const [uiState, setUIState] = useState101(0 /* View */);
  const [log] = useLogger24();
  const query3 = useLazyLoadQuery54(
    queryDef67,
    { resumeId },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { resume } = query3;
  const onClarify = useCallback199(() => {
    setUIState(1 /* Clarify */);
  }, []);
  if (!resume) {
    return /* @__PURE__ */ jsx364("div", { className: "mb-2 bg-white p-2 shadow sm:rounded-lg sm:p-8", children: /* @__PURE__ */ jsx364("h1", { children: "Could Not Find Resume" }) });
  }
  let action;
  switch (uiState) {
    case 0 /* View */: {
      action = /* @__PURE__ */ jsx364(Fragment98, {});
      break;
    }
    case 1 /* Clarify */: {
      action = /* @__PURE__ */ jsx364(Fragment98, { children: /* @__PURE__ */ jsx364(
        ResumeClarifyPositions,
        {
          profileId,
          fragmentRef: resume,
          onDone: () => setUIState(0 /* View */)
        }
      ) });
      break;
    }
    case 2 /* Import */: {
      action = /* @__PURE__ */ jsxs235(Fragment98, { children: [
        /* @__PURE__ */ jsx364("div", { className: "mb-2 border bg-white p-2 sm:p-4", children: "The following positions can be added to your Profile" }),
        /* @__PURE__ */ jsx364(ResumePositions, { fragmentRef: resume, filterCanImportOnly: true })
      ] });
      break;
    }
  }
  return /* @__PURE__ */ jsxs235("div", { className: "lg:my-4 lg:px-8", children: [
    /* @__PURE__ */ jsxs235("div", { className: "mb-2 border bg-white p-2 sm:p-4", children: [
      /* @__PURE__ */ jsx364(ResumeHeader, { fragmentRef: resume }),
      /* @__PURE__ */ jsx364(
        ResumeWorkflow,
        {
          profileId,
          fragmentRef: resume,
          onClarify
        }
      )
    ] }),
    action
  ] });
};

// src/applications/components/__generated__/ApplicationRateEditor_RecruitProfile.graphql.ts
var node393 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ApplicationRateEditor_RecruitProfile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recruitProfileId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RecruitProfileRate",
      "kind": "LinkedField",
      "name": "rate",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "payType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "minimumRateOfPay",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "maximumRateOfPay",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "countryCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currencyCode",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RecruitProfile",
  "abstractKey": null
};
node393.hash = "032bc1d5b50eb5fcd585f5d985a09550";
var ApplicationRateEditor_RecruitProfile_graphql_default = node393;

// src/applications/components/__generated__/ApplicationRateEditorMutation.graphql.ts
var node394 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfApplicationSqlReadModel",
    "kind": "LinkedField",
    "name": "application",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Application",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "applicationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasCompletedRate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "version",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ApplicationCandidateRate",
            "kind": "LinkedField",
            "name": "candidateRate",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "payType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currencyCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "max",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "min",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      v32,
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationItem",
        "kind": "LinkedField",
        "name": "validations",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          v32
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "data",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ApplicationRateEditorMutation",
      "selections": [
        {
          "alias": "payload",
          "args": v1,
          "concreteType": "RecruitApplicationRateUpdatePayload",
          "kind": "LinkedField",
          "name": "recruitApplicationRateUpdate",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ApplicationRateEditorMutation",
      "selections": [
        {
          "alias": "payload",
          "args": v1,
          "concreteType": "RecruitApplicationRateUpdatePayload",
          "kind": "LinkedField",
          "name": "recruitApplicationRateUpdate",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "b271bcad8f378a183c2d842a190fbadc",
      "id": null,
      "metadata": {},
      "name": "ApplicationRateEditorMutation",
      "operationKind": "mutation",
      "text": "mutation ApplicationRateEditorMutation(\n  $input: RecruitApplicationRateUpdateInput!\n) {\n  payload: recruitApplicationRateUpdate(input: $input) {\n    application {\n      node {\n        id\n        applicationId\n        updatedAt\n        hasCompletedRate\n        version\n        candidateRate {\n          payType\n          currencyCode\n          max\n          min\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n        validations {\n          name\n          message\n        }\n        data\n      }\n    }\n  }\n}\n"
    }
  };
}();
node394.hash = "658f741cad0e90ab4925ea2c8bbc5aa2";
var ApplicationRateEditorMutation_graphql_default = node394;

// src/applications/components/ApplicationRateEditor.tsx
import { Suspense as Suspense127, useCallback as useCallback200, useState as useState103 } from "react";
import { useFragment as useFragment113, useMutation as useMutation28 } from "react-relay";
import {
  createClientMutationId as createClientMutationId79,
  useToggle as useToggle36
} from "shared-lib";
import { Spinner as Spinner12, AlertMessage as AlertMessage11 } from "shared-ui";
import { UserErrorList as UserErrorList3 } from "app-core";
import { RateForm as RateForm2 } from "feature-candidate-accounts";
import { jsx as jsx365, jsxs as jsxs236 } from "react/jsx-runtime";
var ApplicationRateEditor = ({
  applicationId,
  customHeader,
  fragmentRef,
  onCompleted
}) => {
  const { rate, recruitProfileId } = useFragment113(
    ApplicationRateEditor_RecruitProfile_graphql_default,
    fragmentRef
  );
  const [commitMutation4, isMutationInFlight] = useMutation28(ApplicationRateEditorMutation_graphql_default);
  const onSave = useCallback200(
    (isValid, form) => {
      if (!form.max || !form.min || !form.payType || !form.countryCode) {
        return;
      }
      commitMutation4({
        variables: {
          input: {
            applicationId,
            clientMutationId: createClientMutationId79(),
            model: {
              countryCode: form.countryCode,
              isPrivate: false,
              max: form.max,
              min: form.min,
              payType: form.payType
            }
          }
        },
        onError: (e4) => {
          console.log(e4.message);
          toggleCriticalFailure();
        },
        onCompleted: (response) => {
          if (response.payload.application?.node) {
            console.log(response.payload.application?.node);
            setCompleted(true);
            if (onCompleted) {
              onCompleted();
            }
          }
        }
      });
    },
    [commitMutation4, recruitProfileId]
  );
  const [completed, setCompleted] = useState103(false);
  const [criticalFailure, toggleCriticalFailure] = useToggle36(false);
  const [userErrors, setUserErrors] = useState103([]);
  return /* @__PURE__ */ jsx365("div", { className: "mb-5 mt-5 flex flex-col gap-5 sm:mx-5 sm:mt-0 sm:gap-0", children: /* @__PURE__ */ jsxs236(Suspense127, { fallback: /* @__PURE__ */ jsx365(Spinner12, {}), children: [
    criticalFailure ? /* @__PURE__ */ jsx365("div", { children: "A error has occurred, please try again" }) : null,
    completed ? /* @__PURE__ */ jsx365(AlertMessage11, { message: "Rate Updated" }) : null,
    /* @__PURE__ */ jsx365(UserErrorList3, { errors: userErrors }),
    /* @__PURE__ */ jsx365(RateForm2, { onSave, isBusy: isMutationInFlight, rate })
  ] }) });
};

// src/applications/components/__generated__/ApplicationRightToWorkEditor_RecruitProfile.graphql.ts
var node395 = function() {
  var v0 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "iso3",
      "storageKey": null
    }
  ];
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ApplicationRightToWorkEditor_RecruitProfile",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "recruitProfileId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RightToWork",
        "kind": "LinkedField",
        "name": "rightToWork",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rightToWorkId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "candidateAccountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "countryIso3",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "statusId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "otherCountryIso3",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "visaType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "visaNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "additionalInfo",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "GeoCountry",
            "kind": "LinkedField",
            "name": "country",
            "plural": false,
            "selections": v0,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "GeoCountry",
            "kind": "LinkedField",
            "name": "otherCountry",
            "plural": false,
            "selections": v0,
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RecruitProfile",
    "abstractKey": null
  };
}();
node395.hash = "acf91a89495b3d47209cc15b34ddee52";
var ApplicationRightToWorkEditor_RecruitProfile_graphql_default = node395;

// src/applications/components/__generated__/ApplicationRightToWorkEditor_application.graphql.ts
var node396 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currencyCode",
    "storageKey": null
  }, v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "payType",
    "storageKey": null
  }, v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "max",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "min",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ApplicationRightToWorkEditor_application",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "applicationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "version",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "employerId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "employerName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "vacancyName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "applicationStateName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "workflowStateName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "appliedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "completedByCandidateAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "declinedByCandidateAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "declinedByEmployerAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hiredAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasCompletedDocumentTypes",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasCompletedForms",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasCompletedRequiredSkills",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasCompletedOptionalSkills",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasCompletedRate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rightToWorkStatus",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ApplicationCandidateRate",
        "kind": "LinkedField",
        "name": "candidateRate",
        "plural": false,
        "selections": [
          v0,
          v1,
          v23,
          v32
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Vacancy",
        "kind": "LinkedField",
        "name": "vacancy",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "VacancyRate",
            "kind": "LinkedField",
            "name": "rate",
            "plural": false,
            "selections": [
              v23,
              v32,
              v0,
              v1,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currencyCountry",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isPrivate",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LocationCriteria",
            "kind": "LinkedField",
            "name": "locations",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "countryCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "countryName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "entireCountry",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "latitude",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "longitude",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "radius",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "state",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Application",
    "abstractKey": null
  };
}();
node396.hash = "a976a68749e0660ad9407650f848782c";
var ApplicationRightToWorkEditor_application_graphql_default = node396;

// src/applications/components/ApplicationRightToWorkEditor.tsx
import { Suspense as Suspense128, useCallback as useCallback204, useState as useState104 } from "react";
import { useFragment as useFragment114 } from "react-relay";
import { createClientMutationId as createClientMutationId81, useToggle as useToggle37 } from "shared-lib";
import { Spinner as Spinner13, AlertMessage as AlertMessage12 } from "shared-ui";

// src/applications/mutations/__generated__/SetApplicationRightToWorkMutation.graphql.ts
var node397 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfApplicationSqlReadModel",
    "kind": "LinkedField",
    "name": "application",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Application",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rightToWorkStatus",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v32 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "SetApplicationRightToWorkMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "RecruitApplicationRightToWorkUpdatePayload",
          "kind": "LinkedField",
          "name": "recruitApplicationRightToWorkUpdate",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "SetApplicationRightToWorkMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "RecruitApplicationRightToWorkUpdatePayload",
          "kind": "LinkedField",
          "name": "recruitApplicationRightToWorkUpdate",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "e131280f8f53304407e4044b35d00196",
      "id": null,
      "metadata": {},
      "name": "SetApplicationRightToWorkMutation",
      "operationKind": "mutation",
      "text": "mutation SetApplicationRightToWorkMutation(\n  $input: RecruitApplicationRightToWorkUpdateInput!\n) {\n  recruitApplicationRightToWorkUpdate(input: $input) {\n    application {\n      node {\n        id\n        rightToWorkStatus\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node397.hash = "9cbedf551f0aa33843f54f36ec03f539";
var SetApplicationRightToWorkMutation_graphql_default = node397;

// src/applications/mutations/SetApplicationRightToWork.ts
import { useCallback as useCallback201 } from "react";
import { useMutation as useMutation29 } from "react-relay";
import { useSetUserErrorCodes as useSetUserErrorCodes34 } from "shared-lib";
var mutationDef85 = SetApplicationRightToWorkMutation_graphql_default;
var useSetApplicationRightToWork = (onDone, onUserError, onError) => {
  const [commitMutation4, isMutationInFlight] = useMutation29(mutationDef85);
  const setErrorCodes = useSetUserErrorCodes34();
  const invokeMutation = useCallback201(
    (input) => {
      commitMutation4({
        variables: {
          input
        },
        onError: (e4) => {
          if (onError) {
            onError(e4);
          }
        },
        onCompleted: (response) => {
          if (response.recruitApplicationRightToWorkUpdate.application?.node) {
            onDone();
          }
          if (response.recruitApplicationRightToWorkUpdate.userErrors && response.recruitApplicationRightToWorkUpdate.userErrors.length > 0) {
            setErrorCodes(
              response.recruitApplicationRightToWorkUpdate.userErrors
            );
          }
        }
      });
    },
    [commitMutation4]
  );
  return [invokeMutation, isMutationInFlight];
};

// src/applications/mutations/__generated__/SetNoResumeMutationMutation.graphql.ts
var node398 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfCandidateExperienceSummary",
    "kind": "LinkedField",
    "name": "profile",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitProfileSummary",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "prefersNoResume",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "statementYourExperience",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "statementWhatYouWant",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currentJobTitleName",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v32 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "SetNoResumeMutationMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitCandidateProfileSummaryUpdatePayload",
          "kind": "LinkedField",
          "name": "recruitCandidateProfileSummaryUpdate",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "SetNoResumeMutationMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitCandidateProfileSummaryUpdatePayload",
          "kind": "LinkedField",
          "name": "recruitCandidateProfileSummaryUpdate",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "b47fc6541c750730d71c6071ea54c2be",
      "id": null,
      "metadata": {},
      "name": "SetNoResumeMutationMutation",
      "operationKind": "mutation",
      "text": "mutation SetNoResumeMutationMutation(\n  $input: RecruitCandidateProfileSummaryUpdateInput!\n) {\n  result: recruitCandidateProfileSummaryUpdate(input: $input) {\n    profile {\n      node {\n        id\n        prefersNoResume\n        statementYourExperience\n        statementWhatYouWant\n        currentJobTitleName\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node398.hash = "267fd9e181d23804615f273bc168b993";
var SetNoResumeMutationMutation_graphql_default = node398;

// src/applications/mutations/SetNoResume.ts
import { useCallback as useCallback203 } from "react";
import { useMutation as useMutation30 } from "react-relay";
import {
  createClientMutationId as createClientMutationId80,
  useUnhandledError as useUnhandledError31,
  useSetUserErrorCodes as useSetUserErrorCodes35
} from "shared-lib";
var mutationDef86 = SetNoResumeMutationMutation_graphql_default;
var useSetNoResume = (profileId, onDone) => {
  const [, setUnhandledError] = useUnhandledError31();
  const setErrorCodes = useSetUserErrorCodes35();
  const [commitMutation4, isMutationInFlight] = useMutation30(mutationDef86);
  const invokeMutation = useCallback203(
    (prefersNoResume) => {
      const clientMutationId = createClientMutationId80();
      commitMutation4({
        variables: {
          input: { profileId, clientMutationId, prefersNoResume }
        },
        onError: (e4) => {
          setUnhandledError(e4);
        },
        onCompleted: (response) => {
          if (response.result.profile?.node) {
            onDone();
          }
          if (response.result.userErrors && response.result.userErrors.length > 0) {
            setErrorCodes(response.result.userErrors);
          }
        }
      });
    },
    [commitMutation4]
  );
  return [invokeMutation, isMutationInFlight];
};

// src/applications/mutations/__generated__/WithdrawApplicationMutation.graphql.ts
var node399 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }, v23 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfApplicationSqlReadModel",
    "kind": "LinkedField",
    "name": "application",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Application",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "version",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "applicationStateId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "applicationStateName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "workflowStateId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "workflowStateName",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "WithdrawApplicationMutation",
      "selections": [
        {
          "alias": null,
          "args": v23,
          "concreteType": "WithdrawApplicationPayload",
          "kind": "LinkedField",
          "name": "withdrawApplication",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ApplicationPayload",
              "kind": "LinkedField",
              "name": "applicationPayload",
              "plural": false,
              "selections": [
                v32,
                v4,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "userErrors",
                  "plural": true,
                  "selections": [
                    v5,
                    v6
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "WithdrawApplicationMutation",
      "selections": [
        {
          "alias": null,
          "args": v23,
          "concreteType": "WithdrawApplicationPayload",
          "kind": "LinkedField",
          "name": "withdrawApplication",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ApplicationPayload",
              "kind": "LinkedField",
              "name": "applicationPayload",
              "plural": false,
              "selections": [
                v32,
                v4,
                {
                  "alias": null,
                  "args": null,
                  "filters": null,
                  "handle": "prependEdge",
                  "key": "",
                  "kind": "LinkedHandle",
                  "name": "application",
                  "handleArgs": [
                    {
                      "kind": "Variable",
                      "name": "connections",
                      "variableName": "connections"
                    }
                  ]
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "userErrors",
                  "plural": true,
                  "selections": [
                    v32,
                    v5,
                    v6
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "6eaf83857f88a3a216a2fe0336678469",
      "id": null,
      "metadata": {},
      "name": "WithdrawApplicationMutation",
      "operationKind": "mutation",
      "text": "mutation WithdrawApplicationMutation(\n  $input: WithdrawApplicationInput!\n) {\n  withdrawApplication(input: $input) {\n    applicationPayload {\n      __typename\n      application {\n        cursor\n        node {\n          id\n          status\n          version\n          applicationStateId\n          applicationStateName\n          workflowStateId\n          workflowStateName\n        }\n      }\n      userErrors {\n        __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node399.hash = "6dee53de82df30d59ffa80d2ed82e3a8";
var WithdrawApplicationMutation_graphql_default = node399;

// src/applications/mutations/WithdrawApplicationMutation.ts
import { commitMutation as commitMutation3 } from "react-relay";
import { logError as logError3, logInfo } from "shared-lib";
var mutation4 = WithdrawApplicationMutation_graphql_default;
var tempID3 = 0;
function commit3(environment, input, connectionId, onCompleted, onError) {
  return commitMutation3(environment, {
    mutation: mutation4,
    variables: {
      input: {
        ...input,
        clientMutationId: (tempID3++).toString()
      },
      connections: [connectionId]
    },
    onCompleted: (response) => {
      logInfo(response);
      onCompleted();
    },
    onError: (error) => {
      logError3(error);
      if (onError) {
        onError(error);
      }
    }
  });
}
var WithdrawApplicationMutation_default = { commit: commit3 };

// src/applications/components/ApplicationRightToWorkEditor.tsx
import { jsx as jsx366, jsxs as jsxs237 } from "react/jsx-runtime";
var profileFragmentDef2 = ApplicationRightToWorkEditor_RecruitProfile_graphql_default;
var applicationFragmentDef = ApplicationRightToWorkEditor_application_graphql_default;
var ApplicationRightToWorkEditor = ({
  profileFragmentRef,
  applicationFragmentRef,
  onSaved,
  onCancel
}) => {
  const [completed, setCompleted] = useState104(false);
  const [criticalFailure, toggleCriticalFailure] = useToggle37(false);
  const [errorCode, setErrorCode] = useState104(null);
  const profile = useFragment114(
    profileFragmentDef2,
    profileFragmentRef
  );
  const application3 = useFragment114(
    applicationFragmentDef,
    applicationFragmentRef
  );
  const [setRightToWork, isSetRightToWorkInProgress] = useSetApplicationRightToWork(
    () => {
      setCompleted(true);
      if (onSaved) {
        onSaved();
      }
    },
    (code) => {
      setErrorCode(code);
    },
    (e4) => {
      toggleCriticalFailure();
    }
  );
  const onSave = useCallback204(
    (isValid, form) => {
      const input = {
        ...form,
        applicationId: application3.applicationId,
        clientMutationId: createClientMutationId81()
      };
      setRightToWork(input);
    },
    []
  );
  let country = void 0;
  if (application3.vacancy.locations && application3.vacancy.locations.length > 0) {
    country = {
      phone: "",
      iso3: application3.vacancy.locations[0].countryCode,
      name: application3.vacancy.locations[0].countryName
    };
  }
  return /* @__PURE__ */ jsx366("div", { className: "2xl:container sm:py-5 2xl:mx-auto", children: /* @__PURE__ */ jsx366("div", { className: "mx-5", children: /* @__PURE__ */ jsxs237(Suspense128, { fallback: /* @__PURE__ */ jsx366(Spinner13, {}), children: [
    criticalFailure ? /* @__PURE__ */ jsx366("div", { children: "A error has occurred, please try again" }) : null,
    completed ? /* @__PURE__ */ jsx366(AlertMessage12, { message: "Right To Work Updated" }) : null,
    /* @__PURE__ */ jsx366(
      RightToWorkForm,
      {
        onSave,
        onCancel,
        showDelete: false,
        isBusy: isSetRightToWorkInProgress,
        country
      }
    )
  ] }) }) });
};

// src/applications/components/ApplicationResumeUpload.tsx
import { useLogger as useLogger25, useToggle as useToggle38 } from "shared-lib";
import { Button as Button95, ButtonList as ButtonList36, Size as Size49 } from "shared-ui";
import { jsx as jsx367, jsxs as jsxs238 } from "react/jsx-runtime";
var ApplicationResumeUpload = ({
  profileId,
  onUploaded,
  onNoResume
}) => {
  const [log] = useLogger25();
  const [isUploading, setIsUploading] = useToggle38();
  const [onSetNoResume, isMutationInFlight] = useSetNoResume(
    profileId,
    onNoResume
  );
  const active = isUploading ? /* @__PURE__ */ jsx367(
    ResumeUpload,
    {
      profileId,
      onUploadStarted: () => log("ResumeUpload Upload Started"),
      onCancel: () => onSetNoResume(true),
      onSuccess: () => {
        onUploaded();
      }
    }
  ) : /* @__PURE__ */ jsxs238("div", { className: "flex grow flex-col gap-3 border bg-white p-4 shadow-sm sm:rounded-lg md:px-8", children: [
    /* @__PURE__ */ jsx367("div", { className: "text-lg font-medium leading-6 text-gray-900", children: "Do you have a Resume ?" }),
    /* @__PURE__ */ jsx367("div", { className: "mt-3 text-base text-gray-500", children: /* @__PURE__ */ jsx367("p", { children: "We recommend uploading one if you do as it improves the chances of being selected." }) }),
    /* @__PURE__ */ jsx367("div", { className: "mt-3", children: /* @__PURE__ */ jsxs238(ButtonList36, { justify: "START", children: [
      /* @__PURE__ */ jsx367(
        Button95,
        {
          color: "primary",
          size: Size49.lg,
          clicked: () => {
            setIsUploading();
          },
          children: "Yes, I can upload one now"
        }
      ),
      /* @__PURE__ */ jsx367(
        Button95,
        {
          color: "gray",
          size: Size49.lg,
          clicked: () => onSetNoResume(true),
          disabled: isMutationInFlight,
          children: "No, i dont have a Resume"
        }
      )
    ] }) })
  ] });
  return /* @__PURE__ */ jsx367("div", { className: "flex justify-center md:m-4 lg:m-8 xl:m-16", children: active });
};

// src/applications/components/ApplicationApplyWorkflow.tsx
import { Fragment as Fragment99, jsx as jsx368, jsxs as jsxs239 } from "react/jsx-runtime";
var accountFragmentDef2 = ApplicationApplyWorkflow_candidate_graphql_default;
var profileFragmentDef3 = ApplicationApplyWorkflow_profile_graphql_default;
var applicationFragmentDef2 = ApplicationApplyWorkflow_application_graphql_default;
var ApplicationApplyWorkflow = ({
  accountFragmentRef,
  profileFragmentRef,
  applicationFragmentRef,
  onCompleted,
  onReload
}) => {
  const account = useFragment115(
    accountFragmentDef2,
    accountFragmentRef
  );
  const profile = useFragment115(
    profileFragmentDef3,
    profileFragmentRef
  );
  const application3 = useFragment115(
    applicationFragmentDef2,
    applicationFragmentRef
  );
  const [log] = useLogger26();
  const [resumeImportState, setResumeImportState] = useResumeWorkflowState();
  const errorCode = useUserErrorCode7();
  const state = useMemo38(() => {
    return getApplicationState(
      log,
      application3,
      account,
      profile,
      resumeImportState
    );
  }, [application3, account, profile, resumeImportState]);
  return /* @__PURE__ */ jsxs239(Fragment99, { children: [
    state === "TermsAndConditionsConsent" /* TermsAndConditionsConsent */ && /* @__PURE__ */ jsx368(CandidateAccountTermsForm, { fragmentRef: account }),
    state === "GdprConsent" /* GdprConsent */ && /* @__PURE__ */ jsx368(CandidateAccountGDPRConsentForm, { fragmentRef: account }),
    state === "EmailAddressConfirm" /* EmailAddressConfirm */ && /* @__PURE__ */ jsx368(CandidateAccountEmailVerifyForm2, { fragmentRef: account }),
    state === "Submit" /* Submit */ && /* @__PURE__ */ jsxs239(Fragment99, { children: [
      !errorCode && /* @__PURE__ */ jsx368("div", { className: "flex justify-center", children: /* @__PURE__ */ jsx368("div", { className: "md:m-4 lg:m-8", children: /* @__PURE__ */ jsxs239("div", { className: "py-4", children: [
        /* @__PURE__ */ jsx368("p", { className: "font-medium text-gray-900", children: "You can now submit your application" }),
        /* @__PURE__ */ jsx368(
          ApplicationSubmitButton,
          {
            disabled: !!errorCode,
            applicationId: application3.applicationId,
            onSaving: onCompleted,
            onCompleted
          }
        )
      ] }) }) }),
      errorCode && errorCode === RecruitDomainErrorCodes.Recruit.Application.ResumeRequired && /* @__PURE__ */ jsx368(
        ApplicationResumeUpload,
        {
          profileId: profile.recruitProfileId,
          onUploaded: () => {
            log("Application Resume Uploaded");
            setResumeImportState({
              importStatus: 1 /* Uploaded */
            });
            onReload();
          },
          onNoResume: () => {
            log("Application Candidate Set No Resume Preference");
            setResumeImportState({
              importStatus: 2 /* NoResume */
            });
            onReload();
          }
        }
      ),
      errorCode && errorCode === RecruitDomainErrorCodes.Recruit.Application.ResumeClarification && /* @__PURE__ */ jsx368("div", { className: "py-4", children: /* @__PURE__ */ jsx368(
        ApplicationResumeContainer,
        {
          profileId: profile.recruitProfileId,
          resumeId: profile.resume.resumeId
        }
      ) })
    ] }),
    state === "ResumeUpload" /* ResumeUpload */ && /* @__PURE__ */ jsx368(
      ApplicationResumeUpload,
      {
        profileId: profile.recruitProfileId,
        onUploaded: () => {
          log("Application Resume Uploaded");
          setResumeImportState({
            importStatus: 1 /* Uploaded */
          });
          onReload();
        },
        onNoResume: () => {
          log("Application Candidate Set No Resume Preference");
          setResumeImportState({
            importStatus: 2 /* NoResume */
          });
          onReload();
        }
      }
    ),
    state === "RateClarification" /* RateClarification */ && /* @__PURE__ */ jsx368(
      ApplicationRateEditor,
      {
        applicationId: application3.applicationId,
        fragmentRef: profile
      }
    ),
    state === "RightToWork" /* RightToWork */ && /* @__PURE__ */ jsx368(
      ApplicationRightToWorkEditor,
      {
        profileFragmentRef: profile,
        applicationFragmentRef: application3
      }
    ),
    state === "ResumeImport" /* ResumeImport */ && /* @__PURE__ */ jsx368(
      ApplicationResumeContainer,
      {
        profileId: profile.recruitProfileId,
        resumeId: profile.resume.resumeId
      }
    ),
    state === "Completed" /* Completed */ && /* @__PURE__ */ jsx368("div", { children: "Completed" })
  ] });
};

// src/applications/components/ApplicationButtons.tsx
import {
  ArchiveBoxIcon as ArchiveIconSolid,
  PencilIcon as PencilIcon3,
  ArrowUturnLeftIcon as ReplyIcon,
  FolderArrowDownIcon as FolderDownloadIcon,
  UserPlusIcon as UserAddIcon
} from "@heroicons/react/24/solid";

// src/applications/components/ApplicationMenu.tsx
import { Fragment as Fragment100 } from "react";
import { Menu, Transition as Transition4 } from "@headlessui/react";
import { ChevronDownIcon as ChevronDownIcon2 } from "@heroicons/react/24/solid";
import { classNames as classNames41 } from "shared-ui";
import { jsx as jsx369, jsxs as jsxs240 } from "react/jsx-runtime";
var ApplicationMenu = () => {
  return /* @__PURE__ */ jsxs240(Menu, { as: "div", className: "relative -ml-px block sm:shadow-sm lg:hidden", children: [
    /* @__PURE__ */ jsx369("div", { children: /* @__PURE__ */ jsxs240(Menu.Button, { className: "focus:ring-info-600 focus:border-info-600 relative inline-flex items-center rounded-r-md border border-gray-300 bg-white px-2 py-2 text-sm font-medium text-gray-900 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 sm:rounded-md sm:px-3", children: [
      /* @__PURE__ */ jsx369("span", { className: "sr-only sm:hidden", children: "More" }),
      /* @__PURE__ */ jsx369("span", { className: "hidden sm:inline", children: "More" }),
      /* @__PURE__ */ jsx369(
        ChevronDownIcon2,
        {
          className: "h-5 w-5 text-gray-400 sm:-mr-1 sm:ml-2",
          "aria-hidden": "true"
        }
      )
    ] }) }),
    /* @__PURE__ */ jsx369(
      Transition4,
      {
        as: Fragment100,
        enter: "transition ease-out duration-100",
        enterFrom: "transform opacity-0 scale-95",
        enterTo: "transform opacity-100 scale-100",
        leave: "transition ease-in duration-75",
        leaveFrom: "transform opacity-100 scale-100",
        leaveTo: "transform opacity-0 scale-95",
        children: /* @__PURE__ */ jsx369(Menu.Items, { className: "absolute right-0 mt-2 w-36 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none", children: /* @__PURE__ */ jsxs240("div", { className: "py-1", children: [
          /* @__PURE__ */ jsx369(Menu.Item, { children: ({ active }) => /* @__PURE__ */ jsx369(
            "a",
            {
              href: "#",
              className: classNames41(
                active ? "bg-gray-100 text-gray-900" : "text-gray-700",
                "block px-4 py-2 text-sm sm:hidden"
              ),
              children: "Note"
            }
          ) }),
          /* @__PURE__ */ jsx369(Menu.Item, { children: ({ active }) => /* @__PURE__ */ jsx369(
            "a",
            {
              href: "#",
              className: classNames41(
                active ? "bg-gray-100 text-gray-900" : "text-gray-700",
                "block px-4 py-2 text-sm sm:hidden"
              ),
              children: "Assign"
            }
          ) }),
          /* @__PURE__ */ jsx369(Menu.Item, { children: ({ active }) => /* @__PURE__ */ jsx369(
            "a",
            {
              href: "#",
              className: classNames41(
                active ? "bg-gray-100 text-gray-900" : "text-gray-700",
                "block px-4 py-2 text-sm"
              ),
              children: "Archive"
            }
          ) }),
          /* @__PURE__ */ jsx369(Menu.Item, { children: ({ active }) => /* @__PURE__ */ jsx369(
            "a",
            {
              href: "#",
              className: classNames41(
                active ? "bg-gray-100 text-gray-900" : "text-gray-700",
                "block px-4 py-2 text-sm"
              ),
              children: "Move"
            }
          ) })
        ] }) })
      }
    )
  ] });
};

// src/applications/components/ApplicationButtons.tsx
import { jsx as jsx370, jsxs as jsxs241 } from "react/jsx-runtime";
var ApplicationButtons = () => {
  return /* @__PURE__ */ jsx370("div", { children: /* @__PURE__ */ jsxs241("div", { className: "relative z-0 inline-flex rounded-md shadow-sm sm:space-x-3 sm:shadow-none", children: [
    /* @__PURE__ */ jsxs241("span", { className: "inline-flex sm:shadow-sm", children: [
      /* @__PURE__ */ jsxs241(
        "button",
        {
          type: "button",
          className: "focus:ring-info-600 focus:border-info-600 relative inline-flex items-center rounded-l-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-900 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1",
          children: [
            /* @__PURE__ */ jsx370(
              ReplyIcon,
              {
                className: "mr-2.5 h-5 w-5 text-gray-400",
                "aria-hidden": "true"
              }
            ),
            /* @__PURE__ */ jsx370("span", { children: "Reply" })
          ]
        }
      ),
      /* @__PURE__ */ jsxs241(
        "button",
        {
          type: "button",
          className: "focus:ring-info-600 focus:border-info-600 relative -ml-px hidden items-center border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-900 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 sm:inline-flex",
          children: [
            /* @__PURE__ */ jsx370(
              PencilIcon3,
              {
                className: "mr-2.5 h-5 w-5 text-gray-400",
                "aria-hidden": "true"
              }
            ),
            /* @__PURE__ */ jsx370("span", { children: "Note" })
          ]
        }
      ),
      /* @__PURE__ */ jsxs241(
        "button",
        {
          type: "button",
          className: "focus:ring-info-600 focus:border-info-600 relative -ml-px hidden items-center rounded-r-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-900 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 sm:inline-flex",
          children: [
            /* @__PURE__ */ jsx370(
              UserAddIcon,
              {
                className: "mr-2.5 h-5 w-5 text-gray-400",
                "aria-hidden": "true"
              }
            ),
            /* @__PURE__ */ jsx370("span", { children: "Assign" })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ jsxs241("span", { className: "hidden space-x-3 lg:flex", children: [
      /* @__PURE__ */ jsxs241(
        "button",
        {
          type: "button",
          className: "focus:ring-info-600 focus:border-info-600 relative -ml-px hidden items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-900 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 sm:inline-flex",
          children: [
            /* @__PURE__ */ jsx370(
              ArchiveIconSolid,
              {
                className: "mr-2.5 h-5 w-5 text-gray-400",
                "aria-hidden": "true"
              }
            ),
            /* @__PURE__ */ jsx370("span", { children: "Archive" })
          ]
        }
      ),
      /* @__PURE__ */ jsxs241(
        "button",
        {
          type: "button",
          className: "focus:ring-info-600 focus:border-info-600 relative -ml-px hidden items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-900 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 sm:inline-flex",
          children: [
            /* @__PURE__ */ jsx370(
              FolderDownloadIcon,
              {
                className: "mr-2.5 h-5 w-5 text-gray-400",
                "aria-hidden": "true"
              }
            ),
            /* @__PURE__ */ jsx370("span", { children: "Move" })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ jsx370(ApplicationMenu, {})
  ] }) });
};

// src/applications/components/ApplicationContainer.tsx
import { Suspense as Suspense134, useCallback as useCallback215, useEffect as useEffect47 } from "react";
import { usePreloadedQuery as usePreloadedQuery45, useQueryLoader as useQueryLoader23 } from "react-relay";
import { Breadcrumbs as Breadcrumbs7, EdSkeleton as EdSkeleton107, MobileHeader as MobileHeader5 } from "shared-ui";

// src/applications/components/__generated__/ApplicationLayoutQuery.graphql.ts
var node400 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "applicationId"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "candidateId"
  }, v23 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sourceId"
  }, v32 = [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "candidateId"
    }
  ], v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "accountId",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isGdprConsented",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isEmailVerified",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasAgreedToTerms",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isSuspended",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isAnonymised",
    "storageKey": null
  }, v13 = [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "applicationId"
    }
  ], v14 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "applicationId",
    "storageKey": null
  }, v15 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "version",
    "storageKey": null
  }, v16 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "employerId",
    "storageKey": null
  }, v17 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "employerName",
    "storageKey": null
  }, v18 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "vacancyName",
    "storageKey": null
  }, v19 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "applicationStateName",
    "storageKey": null
  }, v20 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "workflowStateName",
    "storageKey": null
  }, v21 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "appliedAt",
    "storageKey": null
  }, v222 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "completedByCandidateAt",
    "storageKey": null
  }, v232 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "declinedByCandidateAt",
    "storageKey": null
  }, v24 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "declinedByEmployerAt",
    "storageKey": null
  }, v25 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hiredAt",
    "storageKey": null
  }, v26 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasCompletedDocumentTypes",
    "storageKey": null
  }, v27 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasCompletedForms",
    "storageKey": null
  }, v28 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasCompletedRequiredSkills",
    "storageKey": null
  }, v29 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasCompletedOptionalSkills",
    "storageKey": null
  }, v30 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasCompletedRate",
    "storageKey": null
  }, v31 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "rightToWorkStatus",
    "storageKey": null
  }, v322 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currencyCode",
    "storageKey": null
  }, v33 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "payType",
    "storageKey": null
  }, v34 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "max",
    "storageKey": null
  }, v35 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "min",
    "storageKey": null
  }, v36 = {
    "alias": null,
    "args": null,
    "concreteType": "ApplicationCandidateRate",
    "kind": "LinkedField",
    "name": "candidateRate",
    "plural": false,
    "selections": [
      v322,
      v33,
      v34,
      v35
    ],
    "storageKey": null
  }, v37 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "addedToProfile",
    "storageKey": null
  }, v38 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasValidExperience",
    "storageKey": null
  }, v39 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasExperienceToClarify",
    "storageKey": null
  }, v40 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasExperienceToImport",
    "storageKey": null
  }, v41 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  }, v42 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "countryIso3",
    "storageKey": null
  }, v43 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currentJobTitleName",
    "storageKey": null
  }, v44 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "prefersNoResume",
    "storageKey": null
  }, v45 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "statementWhatYouDo",
    "storageKey": null
  }, v46 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "statementWhatYouWant",
    "storageKey": null
  }, v47 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "statementYourExperience",
    "storageKey": null
  }, v48 = {
    "alias": null,
    "args": null,
    "concreteType": "VacancyRate",
    "kind": "LinkedField",
    "name": "rate",
    "plural": false,
    "selections": [
      v34,
      v35,
      v322,
      v33,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currencyCountry",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isPrivate",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v49 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "countryCode",
    "storageKey": null
  }, v50 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "countryName",
    "storageKey": null
  }, v51 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v52 = {
    "alias": null,
    "args": null,
    "concreteType": "LocationCriteria",
    "kind": "LinkedField",
    "name": "locations",
    "plural": true,
    "selections": [
      v49,
      v50,
      v51,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "entireCountry",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "latitude",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "longitude",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "radius",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "state",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v53 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }, v54 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  }, v55 = [
    v51,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "iso3",
      "storageKey": null
    },
    v4
  ], v56 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "minimumRateOfPay",
    "storageKey": null
  }, v57 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "maximumRateOfPay",
    "storageKey": null
  }, v58 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v59 = [
    v51,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isRequired",
      "storageKey": null
    }
  ], v60 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Variable",
      "name": "sourceId",
      "variableName": "sourceId"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1,
        v23
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "ApplicationLayoutQuery",
      "selections": [
        {
          "alias": "account",
          "args": v32,
          "concreteType": "AccountsCandidateAccount",
          "kind": "LinkedField",
          "name": "accountCandidateAccountById",
          "plural": false,
          "selections": [
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            v10,
            v11,
            v12,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ApplicationApplyWorkflow_candidate"
            }
          ],
          "storageKey": null
        },
        {
          "alias": "application",
          "args": v13,
          "concreteType": "Application",
          "kind": "LinkedField",
          "name": "applicationById",
          "plural": false,
          "selections": [
            v4,
            v14,
            v15,
            v16,
            v17,
            v18,
            v19,
            v20,
            v21,
            v222,
            v232,
            v24,
            v25,
            v26,
            v27,
            v28,
            v29,
            v30,
            v31,
            v36,
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfile",
              "kind": "LinkedField",
              "name": "profile",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitResume",
                  "kind": "LinkedField",
                  "name": "resume",
                  "plural": false,
                  "selections": [
                    v37,
                    v38,
                    v39,
                    v40,
                    v41
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RightToWork",
                  "kind": "LinkedField",
                  "name": "rightToWork",
                  "plural": true,
                  "selections": [
                    v42,
                    v41
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileSummary",
                  "kind": "LinkedField",
                  "name": "summary",
                  "plural": false,
                  "selections": [
                    v43,
                    v44,
                    v45,
                    v46,
                    v47
                  ],
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ApplicationApplyWorkflow_profile"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ApplicationTaskContainer_profile"
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Vacancy",
              "kind": "LinkedField",
              "name": "vacancy",
              "plural": false,
              "selections": [
                v48,
                v52
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ApplicationDetails_application"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ApplicationHeader_application"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ApplicationActions_application"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ApplicationApplyWorkflow_application"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ApplicationTaskContainer_application"
            },
            v53
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ApplicationDetails_tasks"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0,
        v23
      ],
      "kind": "Operation",
      "name": "ApplicationLayoutQuery",
      "selections": [
        {
          "alias": "account",
          "args": v32,
          "concreteType": "AccountsCandidateAccount",
          "kind": "LinkedField",
          "name": "accountCandidateAccountById",
          "plural": false,
          "selections": [
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            v10,
            v11,
            v12,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "email",
              "storageKey": null
            },
            v54
          ],
          "storageKey": null
        },
        {
          "alias": "application",
          "args": v13,
          "concreteType": "Application",
          "kind": "LinkedField",
          "name": "applicationById",
          "plural": false,
          "selections": [
            v4,
            v14,
            v15,
            v16,
            v17,
            v18,
            v19,
            v20,
            v21,
            v222,
            v232,
            v24,
            v25,
            v26,
            v27,
            v28,
            v29,
            v30,
            v31,
            v36,
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfile",
              "kind": "LinkedField",
              "name": "profile",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitResume",
                  "kind": "LinkedField",
                  "name": "resume",
                  "plural": false,
                  "selections": [
                    v37,
                    v38,
                    v39,
                    v40,
                    v41,
                    v4,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "resumeId",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RightToWork",
                  "kind": "LinkedField",
                  "name": "rightToWork",
                  "plural": true,
                  "selections": [
                    v42,
                    v41,
                    v4,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "rightToWorkId",
                      "storageKey": null
                    },
                    v54,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "candidateAccountId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "statusId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "otherCountryIso3",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "visaType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "visaNumber",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "additionalInfo",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "GeoCountry",
                      "kind": "LinkedField",
                      "name": "country",
                      "plural": false,
                      "selections": v55,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "GeoCountry",
                      "kind": "LinkedField",
                      "name": "otherCountry",
                      "plural": false,
                      "selections": v55,
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileSummary",
                  "kind": "LinkedField",
                  "name": "summary",
                  "plural": false,
                  "selections": [
                    v43,
                    v44,
                    v45,
                    v46,
                    v47,
                    v4
                  ],
                  "storageKey": null
                },
                v4,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "recruitProfileId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileRate",
                  "kind": "LinkedField",
                  "name": "rate",
                  "plural": false,
                  "selections": [
                    v33,
                    v56,
                    v57,
                    v49,
                    v322,
                    v4
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperience",
                  "kind": "LinkedField",
                  "name": "experience",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "candidateExperienceId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "companyId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "companyName",
                      "storageKey": null
                    },
                    v4
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Vacancy",
              "kind": "LinkedField",
              "name": "vacancy",
              "plural": false,
              "selections": [
                v48,
                v52,
                v4,
                v51,
                v58,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "employerLogoUrl",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "publicDescriptionText",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SkillGroup",
                  "kind": "LinkedField",
                  "name": "skillGroups",
                  "plural": true,
                  "selections": v59,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "VacancyDates",
                  "kind": "LinkedField",
                  "name": "dates",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "durationDescription",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                v17
              ],
              "storageKey": null
            },
            v54,
            {
              "alias": null,
              "args": null,
              "concreteType": "ClarifySkillGroup",
              "kind": "LinkedField",
              "name": "clarifySkills",
              "plural": true,
              "selections": v59,
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfileWorkLocations",
              "kind": "LinkedField",
              "name": "workLocations",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "WorkLocationEntry",
                  "kind": "LinkedField",
                  "name": "workLocations",
                  "plural": true,
                  "selections": [
                    v4,
                    v51,
                    v50
                  ],
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitResume",
              "kind": "LinkedField",
              "name": "currentResume",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfile",
                  "kind": "LinkedField",
                  "name": "profile",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileRate",
                      "kind": "LinkedField",
                      "name": "rate",
                      "plural": false,
                      "selections": [
                        v56,
                        v57,
                        v33,
                        v322,
                        v4
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileWorkLocations",
                      "kind": "LinkedField",
                      "name": "workLocations",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "WorkLocationEntry",
                          "kind": "LinkedField",
                          "name": "workLocations",
                          "plural": true,
                          "selections": [
                            v4,
                            v51,
                            v49
                          ],
                          "storageKey": null
                        },
                        v4
                      ],
                      "storageKey": null
                    },
                    v4
                  ],
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfileExperience",
              "kind": "LinkedField",
              "name": "experience",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "skills",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            },
            v58,
            v41,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "candidateId",
              "storageKey": null
            },
            v53
          ],
          "storageKey": null
        },
        {
          "alias": "tasks",
          "args": v60,
          "concreteType": "TasksCandidateTasksBySourceIdConnection",
          "kind": "LinkedField",
          "name": "tasksCandidateTasksBySourceId",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "TasksCandidateTasksBySourceIdEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TasksCandidateTask",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v4,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "candidateTaskId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "priority",
                      "storageKey": null
                    },
                    v41,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "type",
                      "storageKey": null
                    },
                    v15,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "title",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "summary",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v53
          ],
          "storageKey": null
        },
        {
          "alias": "tasks",
          "args": v60,
          "filters": [],
          "handle": "connection",
          "key": "TaskBySourceList_tasks",
          "kind": "LinkedHandle",
          "name": "tasksCandidateTasksBySourceId"
        }
      ]
    },
    "params": {
      "cacheID": "aa05d87e52fd30d4cf43afae698ee460",
      "id": null,
      "metadata": {},
      "name": "ApplicationLayoutQuery",
      "operationKind": "query",
      "text": "query ApplicationLayoutQuery(\n  $candidateId: UUID!\n  $applicationId: UUID!\n  $sourceId: UUID!\n) {\n  account: accountCandidateAccountById(id: $candidateId) {\n    id\n    accountId\n    firstName\n    lastName\n    isGdprConsented\n    isEmailVerified\n    hasAgreedToTerms\n    isSuspended\n    isAnonymised\n    ...ApplicationApplyWorkflow_candidate\n  }\n  application: applicationById(id: $applicationId) {\n    id\n    applicationId\n    version\n    employerId\n    employerName\n    vacancyName\n    applicationStateName\n    workflowStateName\n    appliedAt\n    completedByCandidateAt\n    declinedByCandidateAt\n    declinedByEmployerAt\n    hiredAt\n    hasCompletedDocumentTypes\n    hasCompletedForms\n    hasCompletedRequiredSkills\n    hasCompletedOptionalSkills\n    hasCompletedRate\n    rightToWorkStatus\n    candidateRate {\n      currencyCode\n      payType\n      max\n      min\n    }\n    profile {\n      resume {\n        addedToProfile\n        hasValidExperience\n        hasExperienceToClarify\n        hasExperienceToImport\n        status\n        id\n      }\n      rightToWork {\n        countryIso3\n        status\n        id\n      }\n      summary {\n        currentJobTitleName\n        prefersNoResume\n        statementWhatYouDo\n        statementWhatYouWant\n        statementYourExperience\n        id\n      }\n      ...ApplicationApplyWorkflow_profile\n      ...ApplicationTaskContainer_profile\n      id\n    }\n    vacancy {\n      rate {\n        max\n        min\n        currencyCode\n        payType\n        currencyCountry\n        isPrivate\n      }\n      locations {\n        countryCode\n        countryName\n        name\n        entireCountry\n        latitude\n        longitude\n        radius\n        state\n      }\n      id\n    }\n    ...ApplicationDetails_application\n    ...ApplicationHeader_application\n    ...ApplicationActions_application\n    ...ApplicationApplyWorkflow_application\n    ...ApplicationTaskContainer_application\n  }\n  ...ApplicationDetails_tasks\n}\n\nfragment ApplicationActions_application on Application {\n  id\n  status\n  applicationStateName\n  workflowStateName\n  vacancy {\n    id\n    name\n    employerName\n  }\n}\n\nfragment ApplicationApplyWorkflow_application on Application {\n  id\n  applicationId\n  version\n  employerId\n  employerName\n  vacancyName\n  applicationStateName\n  workflowStateName\n  appliedAt\n  completedByCandidateAt\n  declinedByCandidateAt\n  declinedByEmployerAt\n  hiredAt\n  hasCompletedDocumentTypes\n  hasCompletedForms\n  hasCompletedRequiredSkills\n  hasCompletedOptionalSkills\n  hasCompletedRate\n  rightToWorkStatus\n  candidateRate {\n    currencyCode\n    payType\n    max\n    min\n  }\n  vacancy {\n    rate {\n      max\n      min\n      currencyCode\n      payType\n      currencyCountry\n      isPrivate\n    }\n    locations {\n      countryCode\n      countryName\n      name\n      entireCountry\n      latitude\n      longitude\n      radius\n      state\n    }\n    id\n  }\n  ...ApplicationRightToWorkEditor_application\n}\n\nfragment ApplicationApplyWorkflow_candidate on AccountsCandidateAccount {\n  id\n  accountId\n  firstName\n  lastName\n  email\n  createdAt\n  hasAgreedToTerms\n  isGdprConsented\n  isEmailVerified\n  isAnonymised\n  isSuspended\n  ...CandidateAccountEmailVerifyForm_account\n  ...CandidateAccountGDPRConsentForm_account\n  ...CandidateAccountTermsForm_account\n}\n\nfragment ApplicationApplyWorkflow_profile on RecruitProfile {\n  id\n  recruitProfileId\n  resume {\n    resumeId\n    addedToProfile\n    hasExperienceToClarify\n    hasExperienceToImport\n    hasValidExperience\n    status\n    id\n  }\n  summary {\n    currentJobTitleName\n    prefersNoResume\n    statementWhatYouDo\n    statementWhatYouWant\n    statementYourExperience\n    id\n  }\n  rightToWork {\n    countryIso3\n    status\n    id\n  }\n  ...ApplicationRateEditor_RecruitProfile\n  ...ApplicationRightToWorkEditor_RecruitProfile\n}\n\nfragment ApplicationDetails_application on Application {\n  id\n  applicationId\n  version\n  createdAt\n  employerName\n  vacancyName\n  applicationStateName\n  workflowStateName\n  clarifySkills {\n    name\n    isRequired\n  }\n  workLocations {\n    workLocations {\n      id\n      name\n      countryName\n    }\n    id\n  }\n  currentResume {\n    profile {\n      rate {\n        minimumRateOfPay\n        maximumRateOfPay\n        payType\n        currencyCode\n        id\n      }\n      workLocations {\n        workLocations {\n          id\n          name\n          countryCode\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n  candidateRate {\n    min\n    max\n    payType\n    currencyCode\n  }\n  vacancy {\n    id\n    name\n    code\n    employerLogoUrl\n    publicDescriptionText\n    skillGroups {\n      name\n      isRequired\n    }\n    rate {\n      min\n      max\n      payType\n      currencyCode\n    }\n    locations {\n      name\n      countryName\n      countryCode\n    }\n    dates {\n      durationDescription\n    }\n  }\n  experience {\n    skills\n    id\n  }\n  ...CandidateApplicationRelevance_application\n}\n\nfragment ApplicationDetails_tasks on Query {\n  ...TaskBySourceList_tasks\n}\n\nfragment ApplicationHeader_application on Application {\n  id\n  employerName\n  vacancyName\n}\n\nfragment ApplicationRateEditor_RecruitProfile on RecruitProfile {\n  recruitProfileId\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n}\n\nfragment ApplicationRightToWorkEditor_RecruitProfile on RecruitProfile {\n  recruitProfileId\n  rightToWork {\n    id\n    rightToWorkId\n    createdAt\n    updatedAt\n    candidateAccountId\n    countryIso3\n    status\n    statusId\n    otherCountryIso3\n    visaType\n    visaNumber\n    additionalInfo\n    country {\n      name\n      iso3\n      id\n    }\n    otherCountry {\n      name\n      iso3\n      id\n    }\n  }\n}\n\nfragment ApplicationRightToWorkEditor_application on Application {\n  id\n  applicationId\n  version\n  employerId\n  employerName\n  vacancyName\n  applicationStateName\n  workflowStateName\n  appliedAt\n  completedByCandidateAt\n  declinedByCandidateAt\n  declinedByEmployerAt\n  hiredAt\n  hasCompletedDocumentTypes\n  hasCompletedForms\n  hasCompletedRequiredSkills\n  hasCompletedOptionalSkills\n  hasCompletedRate\n  rightToWorkStatus\n  candidateRate {\n    currencyCode\n    payType\n    max\n    min\n  }\n  vacancy {\n    rate {\n      max\n      min\n      currencyCode\n      payType\n      currencyCountry\n      isPrivate\n    }\n    locations {\n      countryCode\n      countryName\n      name\n      entireCountry\n      latitude\n      longitude\n      radius\n      state\n    }\n    id\n  }\n}\n\nfragment ApplicationTaskContainer_application on Application {\n  ...ApplicationRightToWorkEditor_application\n  ...ApplicationTaskDetails_application\n}\n\nfragment ApplicationTaskContainer_profile on RecruitProfile {\n  id\n  ...ApplicationTaskDetails_profile\n}\n\nfragment ApplicationTaskDetails_application on Application {\n  id\n  applicationId\n  version\n  employerId\n  employerName\n  vacancyName\n  applicationStateName\n  workflowStateName\n  candidateId\n  appliedAt\n  completedByCandidateAt\n  declinedByCandidateAt\n  declinedByEmployerAt\n  hiredAt\n  hasCompletedDocumentTypes\n  hasCompletedForms\n  hasCompletedRequiredSkills\n  hasCompletedOptionalSkills\n  hasCompletedRate\n  rightToWorkStatus\n  candidateRate {\n    currencyCode\n    payType\n    max\n    min\n  }\n  vacancy {\n    rate {\n      max\n      min\n      currencyCode\n      payType\n      currencyCountry\n      isPrivate\n    }\n    locations {\n      countryCode\n      countryName\n      name\n      entireCountry\n      latitude\n      longitude\n      radius\n      state\n    }\n    id\n  }\n  ...RightToWorkTask_application\n  ...ClarifyOptionalSkillsApplicationTask_application\n  ...ClarifySkillsApplicationTask_application\n  ...OfferTaskFragment_application\n}\n\nfragment ApplicationTaskDetails_profile on RecruitProfile {\n  id\n  recruitProfileId\n  ...ClarifyRateApplicationTask_profile\n  ...ClarifySkillsApplicationTask_profile\n  ...ClarifyOptionalSkillsApplicationTask_profile\n}\n\nfragment CandidateAccountEmailVerifyForm_account on AccountsCandidateAccount {\n  id\n  accountId\n  firstName\n  email\n  createdAt\n  hasAgreedToTerms\n  isGdprConsented\n  isEmailVerified\n}\n\nfragment CandidateAccountGDPRConsentForm_account on AccountsCandidateAccount {\n  id\n  accountId\n  firstName\n  email\n  createdAt\n  hasAgreedToTerms\n  isGdprConsented\n  isEmailVerified\n}\n\nfragment CandidateAccountTermsForm_account on AccountsCandidateAccount {\n  id\n  accountId\n  firstName\n  email\n  createdAt\n  hasAgreedToTerms\n  isGdprConsented\n  isEmailVerified\n}\n\nfragment CandidateApplicationRelevance_application on Application {\n  code\n  vacancy {\n    code\n    id\n  }\n  profile {\n    recruitProfileId\n    id\n  }\n}\n\nfragment ClarifyOptionalSkillsApplicationTask_application on Application {\n  id\n}\n\nfragment ClarifyOptionalSkillsApplicationTask_profile on RecruitProfile {\n  id\n  experience {\n    id\n  }\n  ...ExperienceDropdown_RecruitProfile\n}\n\nfragment ClarifyRateApplicationTask_profile on RecruitProfile {\n  id\n  recruitProfileId\n  ...ApplicationRateEditor_RecruitProfile\n}\n\nfragment ClarifySkillsApplicationTask_application on Application {\n  id\n  applicationId\n}\n\nfragment ClarifySkillsApplicationTask_profile on RecruitProfile {\n  id\n  ...ExperienceDropdown_RecruitProfile\n}\n\nfragment ExperienceDropdown_RecruitProfile on RecruitProfile {\n  experience {\n    candidateExperienceId\n    companyId\n    companyName\n    id\n  }\n}\n\nfragment OfferTaskFragment_application on Application {\n  id\n  applicationId\n  candidateId\n  employerId\n  vacancy {\n    employerName\n    name\n    id\n  }\n}\n\nfragment RightToWorkTask_application on Application {\n  id\n  applicationId\n  version\n  employerId\n  employerName\n  vacancyName\n  applicationStateName\n  workflowStateName\n  appliedAt\n  completedByCandidateAt\n  declinedByCandidateAt\n  declinedByEmployerAt\n  hiredAt\n  hasCompletedDocumentTypes\n  hasCompletedForms\n  hasCompletedRequiredSkills\n  hasCompletedOptionalSkills\n  hasCompletedRate\n  rightToWorkStatus\n  candidateRate {\n    currencyCode\n    payType\n    max\n    min\n  }\n  vacancy {\n    rate {\n      max\n      min\n      currencyCode\n      payType\n      currencyCountry\n      isPrivate\n    }\n    locations {\n      countryCode\n      countryName\n      name\n      entireCountry\n      latitude\n      longitude\n      radius\n      state\n    }\n    id\n  }\n}\n\nfragment TaskBySourceList_tasks on Query {\n  tasks: tasksCandidateTasksBySourceId(sourceId: $sourceId, first: 10) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        candidateTaskId\n        priority\n        status\n        ...TaskItem_task\n        __typename\n      }\n    }\n  }\n}\n\nfragment TaskItem_task on TasksCandidateTask {\n  id\n  candidateTaskId\n  type\n  version\n  description\n  title\n  summary\n  status\n}\n"
    }
  };
}();
node400.hash = "77d746c68e9577896d4a657ffa7e7c40";
var ApplicationLayoutQuery_graphql_default = node400;

// src/applications/components/ApplicationLayout.tsx
import { Suspense as Suspense133, useCallback as useCallback214, useEffect as useEffect46 } from "react";
import { usePreloadedQuery as usePreloadedQuery44 } from "react-relay";
import {
  Navigate as Navigate15,
  Route as Route6,
  Routes as Routes6,
  useLocation as useLocation7,
  useNavigate as useNavigate27
} from "react-router-dom";
import { ChatBubbleBottomCenterIcon } from "@heroicons/react/24/solid";
import { LogLevel as LogLevel6, useLogger as useLogger28 } from "shared-lib";
import { Button as Button103, EdLink as EdLink21, EdSkeleton as EdSkeleton106, Size as Size51 } from "shared-ui";

// src/tasks/components/__generated__/ApplicationTasksContainerQuery.graphql.ts
var node401 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "sourceId"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Variable",
      "name": "sourceId",
      "variableName": "sourceId"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ApplicationTasksContainerQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TaskBySourceList_tasks"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ApplicationTasksContainerQuery",
      "selections": [
        {
          "alias": "tasks",
          "args": v1,
          "concreteType": "TasksCandidateTasksBySourceIdConnection",
          "kind": "LinkedField",
          "name": "tasksCandidateTasksBySourceId",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "TasksCandidateTasksBySourceIdEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TasksCandidateTask",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "candidateTaskId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "priority",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "type",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "version",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "title",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "summary",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "tasks",
          "args": v1,
          "filters": [],
          "handle": "connection",
          "key": "TaskBySourceList_tasks",
          "kind": "LinkedHandle",
          "name": "tasksCandidateTasksBySourceId"
        }
      ]
    },
    "params": {
      "cacheID": "ffd11958ee9757f24b698d8f38e62503",
      "id": null,
      "metadata": {},
      "name": "ApplicationTasksContainerQuery",
      "operationKind": "query",
      "text": "query ApplicationTasksContainerQuery(\n  $sourceId: UUID!\n) {\n  ...TaskBySourceList_tasks\n}\n\nfragment TaskBySourceList_tasks on Query {\n  tasks: tasksCandidateTasksBySourceId(sourceId: $sourceId, first: 10) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        candidateTaskId\n        priority\n        status\n        ...TaskItem_task\n        __typename\n      }\n    }\n  }\n}\n\nfragment TaskItem_task on TasksCandidateTask {\n  id\n  candidateTaskId\n  type\n  version\n  description\n  title\n  summary\n  status\n}\n"
    }
  };
}();
node401.hash = "79d7af59f9c977c6c1d6d6295fc4b9dd";
var ApplicationTasksContainerQuery_graphql_default = node401;

// src/tasks/components/ApplicationTasksContainer.tsx
import { useLazyLoadQuery as useLazyLoadQuery55 } from "react-relay";
import { TaskBySourceList } from "app-core";
import { jsx as jsx371, jsxs as jsxs243 } from "react/jsx-runtime";
var graphqlQuery10 = ApplicationTasksContainerQuery_graphql_default;
var ApplicationTasksContainer = ({ applicationId, onSelect }) => {
  const data = useLazyLoadQuery55(
    graphqlQuery10,
    { sourceId: applicationId },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsxs243("div", { className: "mt-5 rounded-2xl bg-white p-5 sm:p-10", children: [
    /* @__PURE__ */ jsx371("h2", { className: "text-2xl font-bold", children: "Tasks" }),
    /* @__PURE__ */ jsx371(
      TaskBySourceList,
      {
        sourceId: applicationId,
        fragmentRef: data,
        onSelected: (id18) => {
          if (onSelect) {
            onSelect(id18);
          }
        }
      }
    )
  ] });
};

// src/tasks/components/__generated__/ApplicationTaskDetails_task.graphql.ts
var node403 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ApplicationTaskDetails_task",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "candidateTaskId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "summary",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ClarifyRateApplicationTask_task"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ClarifySkillsApplicationTask_task"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ClarifyOptionalSkillsApplicationTask_task"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CompleteComplianceChecksApplicationTask_task"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CompleteDocumentApplicationTask_task"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CompleteFormApplicationTask_task"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RightToWorkTask_task"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RespondToInterviewTask_task"
    }
  ],
  "type": "TasksCandidateTask",
  "abstractKey": null
};
node403.hash = "037c1a5c766b203b0045f5f7fdfc2263";
var ApplicationTaskDetails_task_graphql_default = node403;

// src/tasks/components/__generated__/ApplicationTaskDetails_application.graphql.ts
var node404 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currencyCode",
    "storageKey": null
  }, v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "payType",
    "storageKey": null
  }, v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "max",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "min",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ApplicationTaskDetails_application",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "applicationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "version",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "employerId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "employerName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "vacancyName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "applicationStateName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "workflowStateName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "candidateId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "appliedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "completedByCandidateAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "declinedByCandidateAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "declinedByEmployerAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hiredAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasCompletedDocumentTypes",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasCompletedForms",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasCompletedRequiredSkills",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasCompletedOptionalSkills",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasCompletedRate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rightToWorkStatus",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ApplicationCandidateRate",
        "kind": "LinkedField",
        "name": "candidateRate",
        "plural": false,
        "selections": [
          v0,
          v1,
          v23,
          v32
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Vacancy",
        "kind": "LinkedField",
        "name": "vacancy",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "VacancyRate",
            "kind": "LinkedField",
            "name": "rate",
            "plural": false,
            "selections": [
              v23,
              v32,
              v0,
              v1,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currencyCountry",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isPrivate",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LocationCriteria",
            "kind": "LinkedField",
            "name": "locations",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "countryCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "countryName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "entireCountry",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "latitude",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "longitude",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "radius",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "state",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "RightToWorkTask_application"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "ClarifyOptionalSkillsApplicationTask_application"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "ClarifySkillsApplicationTask_application"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "OfferTaskFragment_application"
      }
    ],
    "type": "Application",
    "abstractKey": null
  };
}();
node404.hash = "2b470daa8934a673a1661173a5822e51";
var ApplicationTaskDetails_application_graphql_default = node404;

// src/tasks/components/__generated__/ApplicationTaskDetails_profile.graphql.ts
var node405 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ApplicationTaskDetails_profile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recruitProfileId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ClarifyRateApplicationTask_profile"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ClarifySkillsApplicationTask_profile"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ClarifyOptionalSkillsApplicationTask_profile"
    }
  ],
  "type": "RecruitProfile",
  "abstractKey": null
};
node405.hash = "fe556c1321d2903c898d0cfee03ecfdf";
var ApplicationTaskDetails_profile_graphql_default = node405;

// src/tasks/components/ApplicationTaskDetails.tsx
import { useCallback as useCallback211 } from "react";
import { useFragment as useFragment126 } from "react-relay";
import { useNavigate as useNavigate25 } from "react-router-dom";
import { ChevronLeftIcon as ChevronLeftIcon2 } from "@heroicons/react/24/outline";
import { useCandidateTaskComplete } from "app-core";
import { createClientMutationId as createClientMutationId88 } from "shared-lib";
import { Button as Button100 } from "shared-ui";

// src/tasks/components/types/__generated__/RightToWorkTask_task.graphql.ts
var node406 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RightToWorkTask_task",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "candidateTaskId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "summary",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "TasksCandidateTask",
  "abstractKey": null
};
node406.hash = "87176463cc32a505b20e45f7cda6fd4f";
var RightToWorkTask_task_graphql_default = node406;

// src/tasks/components/types/__generated__/RightToWorkTask_application.graphql.ts
var node407 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currencyCode",
    "storageKey": null
  }, v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "payType",
    "storageKey": null
  }, v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "max",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "min",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "RightToWorkTask_application",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "applicationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "version",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "employerId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "employerName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "vacancyName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "applicationStateName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "workflowStateName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "appliedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "completedByCandidateAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "declinedByCandidateAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "declinedByEmployerAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hiredAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasCompletedDocumentTypes",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasCompletedForms",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasCompletedRequiredSkills",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasCompletedOptionalSkills",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasCompletedRate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rightToWorkStatus",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ApplicationCandidateRate",
        "kind": "LinkedField",
        "name": "candidateRate",
        "plural": false,
        "selections": [
          v0,
          v1,
          v23,
          v32
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Vacancy",
        "kind": "LinkedField",
        "name": "vacancy",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "VacancyRate",
            "kind": "LinkedField",
            "name": "rate",
            "plural": false,
            "selections": [
              v23,
              v32,
              v0,
              v1,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currencyCountry",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isPrivate",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LocationCriteria",
            "kind": "LinkedField",
            "name": "locations",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "countryCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "countryName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "entireCountry",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "latitude",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "longitude",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "radius",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "state",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Application",
    "abstractKey": null
  };
}();
node407.hash = "637f0df119fea9a1b6edce035cc7e80f";
var RightToWorkTask_application_graphql_default = node407;

// src/tasks/components/types/RightToWorkTask.tsx
import { Suspense as Suspense129, useCallback as useCallback205, useState as useState105 } from "react";
import { useFragment as useFragment116 } from "react-relay";
import { createClientMutationId as createClientMutationId83, useUserErrorCode as useUserErrorCode8 } from "shared-lib";
import { AlertMessage as AlertMessage13, Button as Button96, ButtonList as ButtonList37, Spinner as Spinner14 } from "shared-ui";
import { TaskCompleteButton, TaskDetailsHeader } from "app-core";
import { jsx as jsx373, jsxs as jsxs244 } from "react/jsx-runtime";
var fragmentDef93 = RightToWorkTask_task_graphql_default;
var applicationFragmentDef3 = RightToWorkTask_application_graphql_default;
var RightToWorkTask = ({
  fragmentRef,
  applicationFragmentRef,
  onCompleted
}) => {
  const data = useFragment116(fragmentDef93, fragmentRef);
  const application3 = useFragment116(
    applicationFragmentDef3,
    applicationFragmentRef
  );
  const [isUpdating, setIsUpdating] = useState105(false);
  const [completed, setCompleted] = useState105(false);
  const errorCode = useUserErrorCode8();
  const [setRightToWork, isSetRightToWorkInProgress] = useSetApplicationRightToWork(() => {
    setCompleted(true);
    if (onCompleted) {
      onCompleted();
    }
  });
  const onSave = useCallback205(
    (isValid, form) => {
      const input = {
        ...form,
        applicationId: application3.applicationId,
        clientMutationId: createClientMutationId83()
      };
      setRightToWork(input);
    },
    []
  );
  let country = void 0;
  if (application3.vacancy.locations && application3.vacancy.locations.length > 0) {
    country = {
      iso3: application3.vacancy.locations[0].countryCode,
      name: application3.vacancy.locations[0].countryName
    };
  }
  return /* @__PURE__ */ jsx373(Suspense129, { fallback: /* @__PURE__ */ jsx373(Spinner14, {}), children: /* @__PURE__ */ jsxs244("div", { className: "container mx-auto sm:py-5", children: [
    /* @__PURE__ */ jsx373(
      TaskDetailsHeader,
      {
        title: data.title,
        status: data.status,
        onSelected: onCompleted
      }
    ),
    /* @__PURE__ */ jsxs244("div", { className: "mt-2", children: [
      /* @__PURE__ */ jsx373("p", { className: "line-clamp-2 text-sm text-gray-600", children: "We need to clarify your right to work for this Application" }),
      isUpdating === false && /* @__PURE__ */ jsx373("div", { className: "mt-2", children: /* @__PURE__ */ jsx373(
        Button96,
        {
          color: "primary",
          clicked: () => {
            console.log("setIsUpdating");
            setIsUpdating(true);
          },
          children: "Update right to work now"
        }
      ) })
    ] }),
    errorCode && errorCode === "PERMISSION_DENIED" && /* @__PURE__ */ jsx373(AlertMessage13, { message: "You do not have permission" }),
    completed && /* @__PURE__ */ jsx373("div", { className: "my-2", children: /* @__PURE__ */ jsx373(AlertMessage13, { message: "Right To Work Updated" }) }),
    isUpdating && /* @__PURE__ */ jsx373("div", { className: "my-2", children: /* @__PURE__ */ jsx373(
      RightToWorkForm,
      {
        onSave,
        showDelete: false,
        showCancel: true,
        onCancel: () => {
          setIsUpdating(false);
        },
        isBusy: isSetRightToWorkInProgress,
        country
      }
    ) }),
    /* @__PURE__ */ jsx373("div", { className: "mt-1", children: /* @__PURE__ */ jsx373(ButtonList37, { children: /* @__PURE__ */ jsx373(
      TaskCompleteButton,
      {
        taskId: data.candidateTaskId,
        onCompleted,
        status: data.status
      }
    ) }) })
  ] }) });
};

// src/tasks/components/types/__generated__/ClarifySkillsApplicationTask_profile.graphql.ts
var node408 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ClarifySkillsApplicationTask_profile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ExperienceDropdown_RecruitProfile"
    }
  ],
  "type": "RecruitProfile",
  "abstractKey": null
};
node408.hash = "b30e5b05e8552a110eba0af5d1de00d5";
var ClarifySkillsApplicationTask_profile_graphql_default = node408;

// src/tasks/components/types/__generated__/ClarifySkillsApplicationTask_task.graphql.ts
var node409 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ClarifySkillsApplicationTask_task",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "candidateTaskId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "summary",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "TasksCandidateTask",
  "abstractKey": null
};
node409.hash = "6ff5f8266eeb83ae5551ebda9be09940";
var ClarifySkillsApplicationTask_task_graphql_default = node409;

// src/tasks/components/types/__generated__/ClarifySkillsApplicationTask_application.graphql.ts
var node411 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ClarifySkillsApplicationTask_application",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "applicationId",
      "storageKey": null
    }
  ],
  "type": "Application",
  "abstractKey": null
};
node411.hash = "ed21d8c047b356008088bd2871576f0b";
var ClarifySkillsApplicationTask_application_graphql_default = node411;

// src/tasks/components/types/__generated__/ClarifySkillsApplicationTaskQuery.graphql.ts
var node413 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "applicationId"
    }
  ], v1 = [
    {
      "alias": "model",
      "args": [
        {
          "kind": "Variable",
          "name": "applicationId",
          "variableName": "applicationId"
        }
      ],
      "concreteType": "ClarifySkillsModel",
      "kind": "LinkedField",
      "name": "applicationGetSkillsToClarifyById",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ClarifySkillGroup",
          "kind": "LinkedField",
          "name": "skillGroups",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "skillGroupId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isRequired",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ClarifySkillsApplicationTaskQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ClarifySkillsApplicationTaskQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "9c382542a22b5ef4c4ee4923aee08b65",
      "id": null,
      "metadata": {},
      "name": "ClarifySkillsApplicationTaskQuery",
      "operationKind": "query",
      "text": "query ClarifySkillsApplicationTaskQuery(\n  $applicationId: UUID!\n) {\n  model: applicationGetSkillsToClarifyById(applicationId: $applicationId) {\n    skillGroups {\n      skillGroupId\n      name\n      isRequired\n    }\n  }\n}\n"
    }
  };
}();
node413.hash = "2c848527f295744c4242eee7d0f3a771";
var ClarifySkillsApplicationTaskQuery_graphql_default = node413;

// src/tasks/components/types/__generated__/ClarifySkillsApplicationTaskMutation.graphql.ts
var node414 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "alias": "result",
      "args": [
        {
          "kind": "Variable",
          "name": "input",
          "variableName": "input"
        }
      ],
      "concreteType": "RecruitApplicationSetRequiredSkillsCompletedPayload",
      "kind": "LinkedField",
      "name": "recruitApplicationSetRequiredSkillsCompleted",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EdgeOfApplicationSqlReadModel",
          "kind": "LinkedField",
          "name": "application",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Application",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasCompletedDocumentTypes",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasCompletedForms",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasCompletedOptionalSkills",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasCompletedRate",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasCompletedRequiredSkills",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ClarifySkillsApplicationTaskMutation",
      "selections": v1,
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ClarifySkillsApplicationTaskMutation",
      "selections": v1
    },
    "params": {
      "cacheID": "529d0b70b3c3f7e407cec97e2f5508ba",
      "id": null,
      "metadata": {},
      "name": "ClarifySkillsApplicationTaskMutation",
      "operationKind": "mutation",
      "text": "mutation ClarifySkillsApplicationTaskMutation(\n  $input: RecruitApplicationSetRequiredSkillsCompletedInput!\n) {\n  result: recruitApplicationSetRequiredSkillsCompleted(input: $input) {\n    application {\n      node {\n        id\n        hasCompletedDocumentTypes\n        hasCompletedForms\n        hasCompletedOptionalSkills\n        hasCompletedRate\n        hasCompletedRequiredSkills\n      }\n    }\n  }\n}\n"
    }
  };
}();
node414.hash = "f39b47590f7618aed96eee7b45cf690f";
var ClarifySkillsApplicationTaskMutation_graphql_default = node414;

// src/tasks/components/types/ClarifySkillsApplicationTask.tsx
import { useEffect as useEffect44, useState as useState106 } from "react";
import {
  useFragment as useFragment117,
  useMutation as useMutation31,
  usePreloadedQuery as usePreloadedQuery41,
  useQueryLoader as useQueryLoader20,
  useSubscribeToInvalidationState
} from "react-relay";
import { createClientMutationId as createClientMutationId84, noop as noop15, useUserErrorCode as useUserErrorCode9 } from "shared-lib";
import { AlertMessage as AlertMessage14, Loading as Loading12, Tags as Tags7 } from "shared-ui";
import { TaskDetailsHeader as TaskDetailsHeader2 } from "app-core";
import { jsx as jsx374, jsxs as jsxs245 } from "react/jsx-runtime";
var profileFragmentDef4 = ClarifySkillsApplicationTask_profile_graphql_default;
var fragmentDef94 = ClarifySkillsApplicationTask_task_graphql_default;
var applicationFragmentDef4 = ClarifySkillsApplicationTask_application_graphql_default;
var queryDef68 = ClarifySkillsApplicationTaskQuery_graphql_default;
var markAsCompleteMutation = ClarifySkillsApplicationTaskMutation_graphql_default;
var ClarifySkillsApplicationTask = (props) => {
  const application3 = useFragment117(
    applicationFragmentDef4,
    props.applicationFragmentRef
  );
  const [queryRef3, loadQuery48] = useQueryLoader20(queryDef68);
  const [commitMutation4, isMutationInFlight] = useMutation31(
    markAsCompleteMutation
  );
  useEffect44(() => {
    loadQuery48(
      { applicationId: props.applicationId },
      { fetchPolicy: "network-only" }
    );
  }, [props.applicationId, loadQuery48]);
  useSubscribeToInvalidationState([application3.id], () => {
    loadQuery48(
      { applicationId: props.applicationId },
      { fetchPolicy: "network-only" }
    );
  });
  if (!queryRef3) {
    return /* @__PURE__ */ jsx374(Loading12, {});
  }
  return /* @__PURE__ */ jsx374(
    ClarifySkillsApplicationTaskComponent,
    {
      ...props,
      queryRef: queryRef3,
      onCompleted: () => {
        commitMutation4({
          variables: {
            input: {
              applicationId: application3.applicationId,
              clientMutationId: createClientMutationId84()
            }
          },
          onCompleted: () => {
            props.onCompleted?.();
          }
        });
      }
    }
  );
};
var ClarifySkillsApplicationTaskComponent = ({
  applicationId,
  queryRef: queryRef3,
  fragmentRef,
  onCompleted,
  profileFragmentRef,
  applicationFragmentRef
}) => {
  const application3 = useFragment117(
    applicationFragmentDef4,
    applicationFragmentRef
  );
  const data = useFragment117(fragmentDef94, fragmentRef);
  const errorCode = useUserErrorCode9();
  const profile = useFragment117(
    profileFragmentDef4,
    profileFragmentRef
  );
  const query3 = usePreloadedQuery41(
    queryDef68,
    queryRef3
  );
  const { model } = query3;
  const skillGroupNames = (model.skillGroups || []).filter((e4) => e4.isRequired).map((e4) => e4.name);
  const [selectedExperience, setSelectedExperience] = useState106("ALL");
  return /* @__PURE__ */ jsxs245("div", { className: "sm:px-6 sm:py-5", children: [
    /* @__PURE__ */ jsx374(
      TaskDetailsHeader2,
      {
        title: data.title,
        status: data.status,
        onSelected: onCompleted
      }
    ),
    /* @__PURE__ */ jsx374("div", { className: "my-2", children: /* @__PURE__ */ jsx374("p", { className: "line-clamp-2 text-sm text-gray-600", children: "The following skills could not be found in your profile. If you do have experience with any, maximise your chances of success by adding them to the description of the relevant role listed below." }) }),
    /* @__PURE__ */ jsx374("div", { className: "mt-2", children: /* @__PURE__ */ jsx374("div", { className: "flex gap-1 pt-2", children: /* @__PURE__ */ jsx374(Tags7, { size: "xsmall", list: [...new Set(skillGroupNames)] }) }) }),
    errorCode && errorCode === "PERMISSION_DENIED" && /* @__PURE__ */ jsx374(AlertMessage14, { message: "You do not have permission" }),
    /* @__PURE__ */ jsx374(
      ExperienceDropdown_default,
      {
        fragmentRef: profile,
        onChange: (e4) => setSelectedExperience(e4)
      }
    ),
    selectedExperience && selectedExperience != "ALL" && /* @__PURE__ */ jsx374(
      ExperienceEditComponent,
      {
        id: selectedExperience,
        applicationId: application3.id,
        profileId: profile.id,
        showCancel: false,
        onDone: () => {
          if (onCompleted) {
            onCompleted();
          }
        },
        onCancel: noop15
      },
      selectedExperience
    )
  ] });
};

// src/tasks/components/types/__generated__/CompleteComplianceChecksApplicationTask_task.graphql.ts
var node415 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CompleteComplianceChecksApplicationTask_task",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "candidateTaskId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "summary",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "TasksCandidateTask",
  "abstractKey": null
};
node415.hash = "4ec807dd2eb54f694d8b78d1997a1533";
var CompleteComplianceChecksApplicationTask_task_graphql_default = node415;

// src/tasks/components/types/CompleteComplianceChecksApplicationTask.tsx
import { useFragment as useFragment118 } from "react-relay";
import { useUserErrorCode as useUserErrorCode10 } from "shared-lib";
import { AlertMessage as AlertMessage15, ButtonList as ButtonList38 } from "shared-ui";
import { TaskCompleteButton as TaskCompleteButton2, TaskDetailsHeader as TaskDetailsHeader3 } from "app-core";
import { jsx as jsx375, jsxs as jsxs246 } from "react/jsx-runtime";
var fragmentDef95 = CompleteComplianceChecksApplicationTask_task_graphql_default;
var CompleteComplianceChecksApplicationTask = ({ fragmentRef, onCompleted }) => {
  const data = useFragment118(fragmentDef95, fragmentRef);
  const errorCode = useUserErrorCode10();
  return /* @__PURE__ */ jsxs246("div", { className: "sm:px-6 sm:py-5", children: [
    /* @__PURE__ */ jsx375(
      TaskDetailsHeader3,
      {
        title: data.title,
        status: data.status,
        onSelected: onCompleted
      }
    ),
    /* @__PURE__ */ jsx375("div", { className: "mt-1", children: /* @__PURE__ */ jsx375("p", { className: "line-clamp-2 text-sm text-gray-600", children: data.description }) }),
    errorCode && errorCode === "PERMISSION_DENIED" && /* @__PURE__ */ jsx375(AlertMessage15, { message: "You do not have permission" }),
    /* @__PURE__ */ jsx375("div", { className: "mt-1", children: /* @__PURE__ */ jsx375(ButtonList38, { children: /* @__PURE__ */ jsx375(
      TaskCompleteButton2,
      {
        taskId: data.candidateTaskId,
        onCompleted,
        status: data.status
      }
    ) }) })
  ] });
};

// src/tasks/components/types/__generated__/CompleteFormApplicationTask_task.graphql.ts
var node416 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "type",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CompleteFormApplicationTask_task",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "candidateTaskId",
        "storageKey": null
      },
      v1,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "version",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "summary",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CandidateTaskSource",
        "kind": "LinkedField",
        "name": "source",
        "plural": false,
        "selections": [
          v1,
          v0
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "data",
        "storageKey": null
      }
    ],
    "type": "TasksCandidateTask",
    "abstractKey": null
  };
}();
node416.hash = "84fd82fe70877964f320c5ba4a0ac7e1";
var CompleteFormApplicationTask_task_graphql_default = node416;

// src/tasks/components/types/CompleteFormApplicationTask.tsx
import { Suspense as Suspense130, useCallback as useCallback207 } from "react";
import { useFragment as useFragment119 } from "react-relay";
import { useUserErrorCode as useUserErrorCode12 } from "shared-lib";
import { AlertMessage as AlertMessage16 } from "shared-ui";
import { TaskDetailsHeader as TaskDetailsHeader4 } from "app-core";

// src/forms/candidates/components/__generated__/ApplicationFormEditorQuery.graphql.ts
var node417 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "applicationId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "formTemplateId"
    }
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "key",
    "storageKey": null
  }, v32 = [
    {
      "alias": "applicationForm",
      "args": [
        {
          "kind": "Variable",
          "name": "applicationId",
          "variableName": "applicationId"
        },
        {
          "kind": "Variable",
          "name": "formTemplateId",
          "variableName": "formTemplateId"
        }
      ],
      "concreteType": "ApplicationForm",
      "kind": "LinkedField",
      "name": "applicationFormByFormTemplateId",
      "plural": false,
      "selections": [
        v1,
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "formTemplateId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "applicationId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isCompleted",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isSubmitted",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "FormField",
          "kind": "LinkedField",
          "name": "fields",
          "plural": true,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "type",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "skipped",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isRequired",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "FormTemplate",
          "kind": "LinkedField",
          "name": "formTemplate",
          "plural": false,
          "selections": [
            v1,
            v23,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "uiSchema",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "dataSchema",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ApplicationFormEditorQuery",
      "selections": v32,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ApplicationFormEditorQuery",
      "selections": v32
    },
    "params": {
      "cacheID": "180d43c6add6df0a65fb740a3b61c5d9",
      "id": null,
      "metadata": {},
      "name": "ApplicationFormEditorQuery",
      "operationKind": "query",
      "text": "query ApplicationFormEditorQuery(\n  $applicationId: UUID!\n  $formTemplateId: UUID!\n) {\n  applicationForm: applicationFormByFormTemplateId(applicationId: $applicationId, formTemplateId: $formTemplateId) {\n    id\n    formTemplateId\n    applicationId\n    code\n    updatedAt\n    isCompleted\n    isSubmitted\n    fields {\n      key\n      type\n      value\n      skipped\n      isRequired\n    }\n    formTemplate {\n      id\n      key\n      name\n      description\n      uiSchema\n      dataSchema\n    }\n  }\n}\n"
    }
  };
}();
node417.hash = "28fc3c759bffe799f1d11709d6c71d5a";
var ApplicationFormEditorQuery_graphql_default = node417;

// src/forms/candidates/components/ApplicationFormEditor.tsx
import { useCallback as useCallback206, useMemo as useMemo39, useState as useState107 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery56 } from "react-relay";
import { JsonFormsStyleContext } from "@jsonforms/vanilla-renderers";
import { JsonForms } from "@jsonforms/react";
import {
  createClientMutationId as createClientMutationId85,
  LogLevel as LogLevel5,
  useLogger as useLogger27,
  useUserErrorCode as useUserErrorCode11
} from "shared-lib";
import {
  Button as Button97,
  ButtonList as ButtonList39,
  elevateJsonFormsCells,
  elevateJsonFormsRenderers,
  elevateJsonFormsStyleContext,
  Size as Size50
} from "shared-ui";

// src/forms/lib/FormField.ts
function loadFormFieldValue(field) {
  if (!field.value) {
    return null;
  }
  if (field.type === "string") {
    return field.value;
  }
  if (field.type === "number") {
    return Number(field.value);
  }
  if (field.type === "integer") {
    return parseInt(field.value);
  }
  if (field.type === "boolean") {
    return field.value === "yes";
  }
  if (field.type === "null") {
    return null;
  }
  if (field.type === "object") {
    return JSON.parse(field.value);
  }
  if (field.type === "array") {
    return JSON.parse(field.value);
  }
  return field.value;
}

// src/forms/candidates/mutations/__generated__/UseApplicationFormSaveMutation.graphql.ts
var node418 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfApplicationForm",
    "kind": "LinkedField",
    "name": "applicationForm",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ApplicationForm",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v23,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isRequired",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isEdited",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isCompleted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isSubmitted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FormField",
            "kind": "LinkedField",
            "name": "fields",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "skipped",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v23,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseApplicationFormSaveMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitApplicationFormSavePayload",
          "kind": "LinkedField",
          "name": "recruitApplicationFormSave",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseApplicationFormSaveMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitApplicationFormSavePayload",
          "kind": "LinkedField",
          "name": "recruitApplicationFormSave",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "aca236c062bec577991abf8ffd518474",
      "id": null,
      "metadata": {},
      "name": "UseApplicationFormSaveMutation",
      "operationKind": "mutation",
      "text": "mutation UseApplicationFormSaveMutation(\n  $input: RecruitApplicationFormSaveInput!\n) {\n  result: recruitApplicationFormSave(input: $input) {\n    applicationForm {\n      node {\n        id\n        code\n        updatedAt\n        isRequired\n        isEdited\n        isCompleted\n        isSubmitted\n        fields {\n          key\n          type\n          skipped\n          value\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node418.hash = "189fcfffb4a2f6ba4f52c63a51b13a88";
var UseApplicationFormSaveMutation_graphql_default = node418;

// src/forms/candidates/mutations/UseApplicationFormSave.ts
import { useAsyncMutation as useAsyncMutation66 } from "shared-lib";
var mutationDef87 = UseApplicationFormSaveMutation_graphql_default;
function useApplicationFormSave() {
  const [commit11, isBusy] = useAsyncMutation66(mutationDef87);
  return [commit11, isBusy];
}

// src/forms/candidates/mutations/__generated__/UseApplicationFormSubmitMutation.graphql.ts
var node419 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfApplicationForm",
    "kind": "LinkedField",
    "name": "applicationForm",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ApplicationForm",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          v23,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isRequired",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isEdited",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isCompleted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isSubmitted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FormField",
            "kind": "LinkedField",
            "name": "fields",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "skipped",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v23,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseApplicationFormSubmitMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitApplicationFormSubmitPayload",
          "kind": "LinkedField",
          "name": "recruitApplicationFormSubmit",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseApplicationFormSubmitMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitApplicationFormSubmitPayload",
          "kind": "LinkedField",
          "name": "recruitApplicationFormSubmit",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "323d5748c0ae9d6665bbbac026d766c8",
      "id": null,
      "metadata": {},
      "name": "UseApplicationFormSubmitMutation",
      "operationKind": "mutation",
      "text": "mutation UseApplicationFormSubmitMutation(\n  $input: RecruitApplicationFormSubmitInput!\n) {\n  result: recruitApplicationFormSubmit(input: $input) {\n    applicationForm {\n      node {\n        id\n        code\n        updatedAt\n        isRequired\n        isEdited\n        isCompleted\n        isSubmitted\n        fields {\n          key\n          type\n          skipped\n          value\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node419.hash = "88bfce3138e5897851b0d22e8a5a43c2";
var UseApplicationFormSubmitMutation_graphql_default = node419;

// src/forms/candidates/mutations/UseApplicationFormSubmit.ts
import { useAsyncMutation as useAsyncMutation67 } from "shared-lib";
var mutationDef88 = UseApplicationFormSubmitMutation_graphql_default;
function useApplicationFormSubmit() {
  const [commit11, isBusy] = useAsyncMutation67(mutationDef88);
  return [commit11, isBusy];
}

// src/forms/candidates/components/ApplicationFormEditor.tsx
import { jsx as jsx376, jsxs as jsxs247 } from "react/jsx-runtime";
var queryDef69 = ApplicationFormEditorQuery_graphql_default;
var FormLoadError = () => /* @__PURE__ */ jsx376("div", { className: "m-8 border bg-white p-8", children: "Could Not Load Form" });
var ApplicationFormEditor = ({
  applicationId,
  formTemplateId,
  onSubmitted,
  onCancel
}) => {
  const [log] = useLogger27();
  const query3 = useLazyLoadQuery56(
    queryDef69,
    { applicationId, formTemplateId },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { applicationForm } = query3;
  const [save, isSaving] = useApplicationFormSave();
  const [submit, isSubmitting] = useApplicationFormSubmit();
  const [hasErrors, setHasErrors] = useState107(false);
  const [formData, setFormData] = useState107(() => {
    if (applicationForm == null || applicationForm.fields == null) {
      return {};
    }
    const fieldData = applicationForm.fields.reduce((formData2, field) => {
      formData2[field.key] = loadFormFieldValue(field);
      return formData2;
    }, {});
    log(fieldData, LogLevel5.INFO);
    return fieldData;
  });
  const onFormChanged = useCallback206(
    ({ data, errors }) => {
      setFormData(data);
      if (errors) {
        const hasError = errors.filter((e4) => e4.data).length > 0;
        setHasErrors(hasError);
      } else {
        setHasErrors(false);
      }
    },
    [setFormData, setHasErrors]
  );
  const schemas = useMemo39(() => {
    if (!applicationForm || !applicationForm.formTemplate?.dataSchema || !applicationForm.formTemplate?.uiSchema) {
      return;
    }
    const dataSchema3 = JSON.parse(
      applicationForm.formTemplate.dataSchema
    );
    const fields = Object.keys(dataSchema3.properties).map((k4) => {
      const property = dataSchema3.properties[k4];
      return {
        key: k4,
        type: property.type,
        description: property.description,
        isRequired: (dataSchema3.required || []).some((r4) => r4 === k4)
      };
    });
    return {
      dataSchema: dataSchema3,
      fields
    };
  }, [query3]);
  const onSubmit = useCallback206(async () => {
    if (!applicationForm || !schemas?.dataSchema) {
      return;
    }
    const input = {
      clientMutationId: createClientMutationId85(),
      applicationId: applicationForm.applicationId,
      formTemplateId: applicationForm.formTemplateId
    };
    await submit({ input });
    onSubmitted();
  }, [submit]);
  const onSave = useCallback206(async () => {
    if (!applicationForm || !schemas?.dataSchema || !schemas?.fields) {
      return;
    }
    const fields = schemas.fields.map((fd) => {
      let value = null;
      if (formData[fd.key]) {
        value = formData[fd.key].toString();
      }
      const field = {
        key: fd.key,
        type: fd.type,
        isRequired: fd.isRequired,
        skipped: false,
        value
      };
      return {
        field,
        isCompleted: !!value || !value && !fd.isRequired
      };
    });
    const requiredFieldsPending = fields.filter((f4) => !f4.isCompleted);
    if (requiredFieldsPending.length > 0) {
      return;
    }
    const input = {
      clientMutationId: createClientMutationId85(),
      applicationId: applicationForm.applicationId,
      formTemplateId: applicationForm.formTemplateId,
      fields: fields.map((f4) => f4.field)
    };
    await save({ input });
  }, [save]);
  const errorCode = useUserErrorCode11();
  if (applicationForm == null) {
    return /* @__PURE__ */ jsx376(FormLoadError, {});
  }
  const { formTemplate } = applicationForm;
  if (applicationForm.isSubmitted) {
    return /* @__PURE__ */ jsx376("div", { className: "m-8 flex items-center justify-center border bg-white p-4", children: "Submitted" });
  }
  return /* @__PURE__ */ jsxs247("div", { className: "sm:px-6 sm:py-5", children: [
    formTemplate.dataSchema && formTemplate.uiSchema ? /* @__PURE__ */ jsxs247("div", { className: "m-8 border bg-white p-8", children: [
      /* @__PURE__ */ jsx376(JsonFormsStyleContext.Provider, { value: elevateJsonFormsStyleContext, children: /* @__PURE__ */ jsx376(
        JsonForms,
        {
          data: formData,
          schema: JSON.parse(formTemplate.dataSchema),
          uischema: JSON.parse(formTemplate.uiSchema),
          renderers: elevateJsonFormsRenderers,
          cells: elevateJsonFormsCells,
          onChange: onFormChanged
        }
      ) }),
      /* @__PURE__ */ jsx376("div", { className: "mt-4 border-t py-4", children: /* @__PURE__ */ jsxs247(ButtonList39, { children: [
        /* @__PURE__ */ jsx376("div", { children: /* @__PURE__ */ jsx376(
          Button97,
          {
            color: "primary",
            disabled: hasErrors || isSaving,
            clicked: onSave,
            children: "Save"
          }
        ) }),
        /* @__PURE__ */ jsx376("div", { children: /* @__PURE__ */ jsx376(
          Button97,
          {
            color: "gray",
            disabled: isSaving,
            clicked: () => {
              onCancel();
            },
            children: "Cancel"
          }
        ) })
      ] }) })
    ] }) : /* @__PURE__ */ jsx376(FormLoadError, {}),
    applicationForm.isCompleted && /* @__PURE__ */ jsx376("div", { className: "m-8 flex items-center justify-center border bg-white p-4", children: /* @__PURE__ */ jsx376(
      Button97,
      {
        color: "primary",
        size: Size50.lg,
        disabled: hasErrors || isSubmitting,
        clicked: onSubmit,
        children: "Submit"
      }
    ) })
  ] });
};

// src/tasks/components/types/CompleteFormApplicationTask.tsx
import { jsx as jsx377, jsxs as jsxs248 } from "react/jsx-runtime";
var fragmentDef96 = CompleteFormApplicationTask_task_graphql_default;
var CompleteFormApplicationTask = ({
  fragmentRef,
  onCompleted
}) => {
  const data = useFragment119(fragmentDef96, fragmentRef);
  const errorCode = useUserErrorCode12();
  const applicationId = data.source.id;
  const context = JSON.parse(data.data);
  const formTemplateId = context.formTemplateId;
  const onCancel = useCallback207(() => {
    console.log("cancel");
  }, []);
  const onSubmitted = useCallback207(() => {
    if (onCompleted) {
      onCompleted();
    }
  }, [onCompleted]);
  return /* @__PURE__ */ jsxs248("div", { className: "sm:px-6 sm:py-5", children: [
    /* @__PURE__ */ jsx377(TaskDetailsHeader4, { title: data.title, status: data.status }),
    /* @__PURE__ */ jsx377("div", { className: "mt-1", children: /* @__PURE__ */ jsx377("p", { className: "line-clamp-2 text-sm text-gray-600", children: data.description }) }),
    errorCode && errorCode === "PERMISSION_DENIED" && /* @__PURE__ */ jsx377(AlertMessage16, { message: "You do not have permission" }),
    /* @__PURE__ */ jsx377(Suspense130, { fallback: "Loading Form...", children: applicationId && formTemplateId && /* @__PURE__ */ jsx377(
      ApplicationFormEditor,
      {
        applicationId,
        formTemplateId,
        onCancel,
        onSubmitted
      }
    ) })
  ] });
};

// src/tasks/components/types/__generated__/CompleteDocumentApplicationTask_task.graphql.ts
var node420 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CompleteDocumentApplicationTask_task",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "candidateTaskId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "summary",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "data",
      "storageKey": null
    }
  ],
  "type": "TasksCandidateTask",
  "abstractKey": null
};
node420.hash = "cebdea6e085b67167d19c48f5d81002c";
var CompleteDocumentApplicationTask_task_graphql_default = node420;

// src/tasks/components/types/__generated__/CompleteDocumentApplicationTaskMutation.graphql.ts
var node421 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "clientMutationId"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentType"
  }, v23 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "fileName"
  }, v32 = [
    {
      "alias": null,
      "args": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "clientMutationId",
              "variableName": "clientMutationId"
            },
            {
              "kind": "Variable",
              "name": "contentType",
              "variableName": "contentType"
            },
            {
              "kind": "Variable",
              "name": "fileName",
              "variableName": "fileName"
            }
          ],
          "kind": "ObjectValue",
          "name": "input"
        }
      ],
      "concreteType": "FilesCreateUserFileUploadUrlPayload",
      "kind": "LinkedField",
      "name": "filesCreateUserFileUploadUrl",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FileUploadResponse",
          "kind": "LinkedField",
          "name": "payload",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1,
        v23
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "CompleteDocumentApplicationTaskMutation",
      "selections": v32,
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v0,
        v23,
        v1
      ],
      "kind": "Operation",
      "name": "CompleteDocumentApplicationTaskMutation",
      "selections": v32
    },
    "params": {
      "cacheID": "81fee3a8f579618600437c4b48599593",
      "id": null,
      "metadata": {},
      "name": "CompleteDocumentApplicationTaskMutation",
      "operationKind": "mutation",
      "text": "mutation CompleteDocumentApplicationTaskMutation(\n  $clientMutationId: String!\n  $fileName: String!\n  $contentType: String!\n) {\n  filesCreateUserFileUploadUrl(input: {clientMutationId: $clientMutationId, fileName: $fileName, contentType: $contentType}) {\n    payload {\n      url\n    }\n  }\n}\n"
    }
  };
}();
node421.hash = "47a7efc815cbfba6076ea45eeafeb07f";
var CompleteDocumentApplicationTaskMutation_graphql_default = node421;

// src/tasks/components/types/__generated__/CompleteDocumentApplicationTaskReferenceMutation.graphql.ts
var node423 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "container",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "documentTypeId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "source",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CompleteDocumentApplicationTaskReferenceMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "RecruitDocumentReferenceImportPayload",
          "kind": "LinkedField",
          "name": "recruitDocumentReferenceImport",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfDocumentReference",
              "kind": "LinkedField",
              "name": "payload",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DocumentReference",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v23,
                    v32,
                    v4
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CompleteDocumentApplicationTaskReferenceMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "RecruitDocumentReferenceImportPayload",
          "kind": "LinkedField",
          "name": "recruitDocumentReferenceImport",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfDocumentReference",
              "kind": "LinkedField",
              "name": "payload",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DocumentReference",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v23,
                    v32,
                    v4,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "92320d2470130324db1ce0e22b6c30a2",
      "id": null,
      "metadata": {},
      "name": "CompleteDocumentApplicationTaskReferenceMutation",
      "operationKind": "mutation",
      "text": "mutation CompleteDocumentApplicationTaskReferenceMutation(\n  $input: RecruitDocumentReferenceImportInput!\n) {\n  recruitDocumentReferenceImport(input: $input) {\n    payload {\n      node {\n        container\n        documentTypeId\n        source\n        id\n      }\n    }\n  }\n}\n"
    }
  };
}();
node423.hash = "3374962abec2923dc5cf53f6838d1e58";
var CompleteDocumentApplicationTaskReferenceMutation_graphql_default = node423;

// src/tasks/components/types/__generated__/CompleteDocumentApplicationTaskDocumentMutation.graphql.ts
var node424 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "applicationDocumentId",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "documentReferenceId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "documentTypeId",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CompleteDocumentApplicationTaskDocumentMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "RecruitApplicationDocumentUploadPayload",
          "kind": "LinkedField",
          "name": "recruitApplicationDocumentUpload",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfApplicationDocument",
              "kind": "LinkedField",
              "name": "applicationDocument",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ApplicationDocument",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v23,
                    v32,
                    v4
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CompleteDocumentApplicationTaskDocumentMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "RecruitApplicationDocumentUploadPayload",
          "kind": "LinkedField",
          "name": "recruitApplicationDocumentUpload",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfApplicationDocument",
              "kind": "LinkedField",
              "name": "applicationDocument",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ApplicationDocument",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v23,
                    v32,
                    v4,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "9f6c464950873f4205ca4fe1dceeab08",
      "id": null,
      "metadata": {},
      "name": "CompleteDocumentApplicationTaskDocumentMutation",
      "operationKind": "mutation",
      "text": "mutation CompleteDocumentApplicationTaskDocumentMutation(\n  $input: RecruitApplicationDocumentUploadInput!\n) {\n  recruitApplicationDocumentUpload(input: $input) {\n    applicationDocument {\n      node {\n        applicationDocumentId\n        documentReferenceId\n        documentTypeId\n        id\n      }\n    }\n  }\n}\n"
    }
  };
}();
node424.hash = "5dc29453bf4806a8da7811481159e7ae";
var CompleteDocumentApplicationTaskDocumentMutation_graphql_default = node424;

// src/tasks/components/types/__generated__/CompleteDocumentApplicationTaskSubmitMutation.graphql.ts
var node425 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "applicationId",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CompleteDocumentApplicationTaskSubmitMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "RecruitApplicationDocumentSubmitPayload",
          "kind": "LinkedField",
          "name": "recruitApplicationDocumentSubmit",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfApplicationDocument",
              "kind": "LinkedField",
              "name": "applicationDocument",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ApplicationDocument",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v23,
                    v32,
                    v4
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CompleteDocumentApplicationTaskSubmitMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "RecruitApplicationDocumentSubmitPayload",
          "kind": "LinkedField",
          "name": "recruitApplicationDocumentSubmit",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfApplicationDocument",
              "kind": "LinkedField",
              "name": "applicationDocument",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ApplicationDocument",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v23,
                    v32,
                    v4,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "3884c149cc853ef85fc734e57e8e1df9",
      "id": null,
      "metadata": {},
      "name": "CompleteDocumentApplicationTaskSubmitMutation",
      "operationKind": "mutation",
      "text": "mutation CompleteDocumentApplicationTaskSubmitMutation(\n  $input: RecruitApplicationDocumentSubmitInput!\n) {\n  recruitApplicationDocumentSubmit(input: $input) {\n    applicationDocument {\n      node {\n        applicationId\n        candidateId\n        status\n        id\n      }\n    }\n  }\n}\n"
    }
  };
}();
node425.hash = "3f16fa8b720416e5b2077b8bf9083bba";
var CompleteDocumentApplicationTaskSubmitMutation_graphql_default = node425;

// src/tasks/components/types/CompleteDocumentApplicationTask.tsx
import { useState as useState108 } from "react";
import { useFragment as useFragment120 } from "react-relay";
import Uppy3 from "@uppy/core";
import {
  createClientMutationId as createClientMutationId86,
  noop as noop16,
  useAsyncMutation as useAsyncMutation68,
  useUserErrorCode as useUserErrorCode13
} from "shared-lib";
import { AlertMessage as AlertMessage17, Error as Error11, Loading as Loading13 } from "shared-ui";
import { TaskDetailsHeader as TaskDetailsHeader5 } from "app-core";
import { jsx as jsx378, jsxs as jsxs249 } from "react/jsx-runtime";
var fragmentDef97 = CompleteDocumentApplicationTask_task_graphql_default;
var mutationDef89 = {
  filesCreateUserFileUploadUrl: CompleteDocumentApplicationTaskMutation_graphql_default,
  recruitDocumentReferenceImport: CompleteDocumentApplicationTaskReferenceMutation_graphql_default,
  recruitApplicationDocumentUpload: CompleteDocumentApplicationTaskDocumentMutation_graphql_default,
  recruitApplicationDocumentSubmit: CompleteDocumentApplicationTaskSubmitMutation_graphql_default
};
var CompleteDocumentApplicationTask = ({
  applicationId,
  fragmentRef,
  onCompleted
}) => {
  const data = useFragment120(
    fragmentDef97,
    fragmentRef
  );
  const errorCode = useUserErrorCode13();
  const [signedUrl] = useAsyncMutation68(
    mutationDef89.filesCreateUserFileUploadUrl
  );
  const [referenceImport] = useAsyncMutation68(
    mutationDef89.recruitDocumentReferenceImport
  );
  const [documentUpload] = useAsyncMutation68(
    mutationDef89.recruitApplicationDocumentUpload
  );
  const [submit] = useAsyncMutation68(
    mutationDef89.recruitApplicationDocumentSubmit
  );
  const [isSaving, setIsSaving] = useState108(false);
  const [error, setError] = useState108(null);
  const uppy3 = new Uppy3({
    restrictions: { maxNumberOfFiles: 1 }
  });
  uppy3.use(AwsS3, {
    async getUploadParameters(file) {
      setIsSaving(true);
      const { filesCreateUserFileUploadUrl } = await signedUrl({
        clientMutationId: createClientMutationId86(),
        fileName: file.name,
        contentType: file.type || "*/*"
      });
      return {
        method: "PUT",
        url: filesCreateUserFileUploadUrl.payload?.url || "",
        headers: {
          "Content-Type": file.type || "*/*"
        }
      };
    }
  });
  uppy3.on("upload-error", (file, err) => {
    setError(err.message);
    setIsSaving(false);
  });
  uppy3.on("upload-success", async (file) => {
    const { documentTypeId, documentReferenceId } = JSON.parse(data.data);
    try {
      await referenceImport({
        input: {
          clientMutationId: createClientMutationId86(),
          documentReferenceId,
          documentTypeId,
          fileName: file?.name || "",
          mimetype: file?.type || "*/*",
          originalPath: file?.source || "",
          size: file?.size || 0,
          source: file?.source || ""
        }
      });
      await documentUpload({
        input: {
          applicationId,
          clientMutationId: createClientMutationId86(),
          documentReferenceId,
          fileName: file?.name || ""
        }
      });
      await submit({
        input: {
          applicationId,
          clientMutationId: createClientMutationId86(),
          documentReferenceId
        }
      });
      if (onCompleted) {
        onCompleted();
      }
    } catch (e4) {
      setIsSaving(false);
      setError(e4.message);
    }
  });
  if (isSaving) {
    return /* @__PURE__ */ jsx378(Loading13, {});
  }
  return /* @__PURE__ */ jsxs249("div", { className: "flex flex-col gap-3 sm:px-6 sm:py-5", children: [
    /* @__PURE__ */ jsx378(
      TaskDetailsHeader5,
      {
        title: data.title,
        status: data.status,
        onSelected: noop16
      }
    ),
    error && /* @__PURE__ */ jsx378(Error11, { children: error }),
    /* @__PURE__ */ jsx378("div", { className: "mt-1", children: /* @__PURE__ */ jsx378("p", { className: "line-clamp-2 text-sm text-gray-600", children: data.description }) }),
    /* @__PURE__ */ jsx378(
      Dashboard_default,
      {
        width: "100%",
        hideUploadButton: false,
        showSelectedFiles: true,
        showProgressDetails: true,
        proudlyDisplayPoweredByUppy: false,
        uppy: uppy3
      }
    ),
    errorCode && errorCode === "PERMISSION_DENIED" && /* @__PURE__ */ jsx378(AlertMessage17, { message: "You do not have permission" })
  ] });
};

// src/tasks/components/types/__generated__/ClarifyRateApplicationTask_profile.graphql.ts
var node426 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ClarifyRateApplicationTask_profile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recruitProfileId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ApplicationRateEditor_RecruitProfile"
    }
  ],
  "type": "RecruitProfile",
  "abstractKey": null
};
node426.hash = "691a735bc1223f22d18e3dfa86d10c08";
var ClarifyRateApplicationTask_profile_graphql_default = node426;

// src/tasks/components/types/__generated__/ClarifyRateApplicationTask_task.graphql.ts
var node427 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ClarifyRateApplicationTask_task",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "candidateTaskId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "version",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "summary",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CandidateTaskSource",
        "kind": "LinkedField",
        "name": "source",
        "plural": false,
        "selections": [
          v0
        ],
        "storageKey": null
      }
    ],
    "type": "TasksCandidateTask",
    "abstractKey": null
  };
}();
node427.hash = "2f75a28254df9af26d439de03e7feab8";
var ClarifyRateApplicationTask_task_graphql_default = node427;

// src/tasks/components/types/ClarifyRateApplicationTask.tsx
import { useFragment as useFragment121 } from "react-relay";
import { TaskDetailsHeader as TaskDetailsHeader6 } from "app-core";
import { jsx as jsx379, jsxs as jsxs250 } from "react/jsx-runtime";
var profileFragmentDef5 = ClarifyRateApplicationTask_profile_graphql_default;
var taskFragmentDef = ClarifyRateApplicationTask_task_graphql_default;
var RateEditorHeader = () => {
  return /* @__PURE__ */ jsx379("div", { className: "text-primary-500 text-lg", children: /* @__PURE__ */ jsx379("p", { children: "What rate do you require for this role ?" }) });
};
var ClarifyRateApplicationTask = ({
  taskFragmentRef,
  profileFragmentRef,
  onCompleted
}) => {
  const task = useFragment121(taskFragmentDef, taskFragmentRef);
  const profile = useFragment121(profileFragmentDef5, profileFragmentRef);
  return /* @__PURE__ */ jsxs250("div", { children: [
    /* @__PURE__ */ jsx379("div", { className: "sm:px-6 sm:py-5", children: /* @__PURE__ */ jsx379(
      TaskDetailsHeader6,
      {
        title: task.title,
        status: task.status,
        onSelected: onCompleted
      }
    ) }),
    /* @__PURE__ */ jsx379(
      ApplicationRateEditor,
      {
        customHeader: /* @__PURE__ */ jsx379(RateEditorHeader, {}),
        applicationId: task.source.id,
        fragmentRef: profile,
        onCompleted
      }
    )
  ] });
};

// src/tasks/components/types/__generated__/ClarifyOptionalSkillsApplicationTask_profile.graphql.ts
var node428 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ClarifyOptionalSkillsApplicationTask_profile",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitProfileExperience",
        "kind": "LinkedField",
        "name": "experience",
        "plural": true,
        "selections": [
          v0
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "ExperienceDropdown_RecruitProfile"
      }
    ],
    "type": "RecruitProfile",
    "abstractKey": null
  };
}();
node428.hash = "79127c82601c4de2ca9fc356356bb98a";
var ClarifyOptionalSkillsApplicationTask_profile_graphql_default = node428;

// src/tasks/components/types/__generated__/ClarifyOptionalSkillsApplicationTask_task.graphql.ts
var node429 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ClarifyOptionalSkillsApplicationTask_task",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "candidateTaskId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "summary",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "TasksCandidateTask",
  "abstractKey": null
};
node429.hash = "bc4c763297361a8b29176f8ef523b9f1";
var ClarifyOptionalSkillsApplicationTask_task_graphql_default = node429;

// src/tasks/components/types/__generated__/ClarifyOptionalSkillsApplicationTask_application.graphql.ts
var node430 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ClarifyOptionalSkillsApplicationTask_application",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Application",
  "abstractKey": null
};
node430.hash = "aa0d716e93f24e188e7351d725cfdbd7";
var ClarifyOptionalSkillsApplicationTask_application_graphql_default = node430;

// src/tasks/components/types/__generated__/ClarifyOptionalSkillsApplicationTaskQuery.graphql.ts
var node431 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "applicationId"
    }
  ], v1 = [
    {
      "alias": "model",
      "args": [
        {
          "kind": "Variable",
          "name": "applicationId",
          "variableName": "applicationId"
        }
      ],
      "concreteType": "ClarifySkillsModel",
      "kind": "LinkedField",
      "name": "applicationGetSkillsToClarifyById",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ClarifySkillGroup",
          "kind": "LinkedField",
          "name": "skillGroups",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "skillGroupId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isRequired",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ClarifyOptionalSkillsApplicationTaskQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ClarifyOptionalSkillsApplicationTaskQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "3674e21b5a0a78d36754495f669a8501",
      "id": null,
      "metadata": {},
      "name": "ClarifyOptionalSkillsApplicationTaskQuery",
      "operationKind": "query",
      "text": "query ClarifyOptionalSkillsApplicationTaskQuery(\n  $applicationId: UUID!\n) {\n  model: applicationGetSkillsToClarifyById(applicationId: $applicationId) {\n    skillGroups {\n      skillGroupId\n      name\n      isRequired\n    }\n  }\n}\n"
    }
  };
}();
node431.hash = "ae755076d20148ddc34d7a9e0b76cd22";
var ClarifyOptionalSkillsApplicationTaskQuery_graphql_default = node431;

// src/tasks/components/types/__generated__/ClarifyOptionalSkillsApplicationTaskMutation.graphql.ts
var node433 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "alias": "result",
      "args": [
        {
          "kind": "Variable",
          "name": "input",
          "variableName": "input"
        }
      ],
      "concreteType": "RecruitApplicationSetOptionalSkillsCompletedPayload",
      "kind": "LinkedField",
      "name": "recruitApplicationSetOptionalSkillsCompleted",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EdgeOfApplicationSqlReadModel",
          "kind": "LinkedField",
          "name": "application",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Application",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasCompletedDocumentTypes",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasCompletedForms",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasCompletedOptionalSkills",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasCompletedRate",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasCompletedRequiredSkills",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ClarifyOptionalSkillsApplicationTaskMutation",
      "selections": v1,
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ClarifyOptionalSkillsApplicationTaskMutation",
      "selections": v1
    },
    "params": {
      "cacheID": "be03285a63d7cf76623b84041702cda3",
      "id": null,
      "metadata": {},
      "name": "ClarifyOptionalSkillsApplicationTaskMutation",
      "operationKind": "mutation",
      "text": "mutation ClarifyOptionalSkillsApplicationTaskMutation(\n  $input: RecruitApplicationSetOptionalSkillsCompletedInput!\n) {\n  result: recruitApplicationSetOptionalSkillsCompleted(input: $input) {\n    application {\n      node {\n        id\n        hasCompletedDocumentTypes\n        hasCompletedForms\n        hasCompletedOptionalSkills\n        hasCompletedRate\n        hasCompletedRequiredSkills\n      }\n    }\n  }\n}\n"
    }
  };
}();
node433.hash = "068f75ed716667e6e8a0d4d3617b19b7";
var ClarifyOptionalSkillsApplicationTaskMutation_graphql_default = node433;

// src/tasks/components/types/ClarifyOptionalSkillsApplicationTask.tsx
import { useEffect as useEffect45, useState as useState109 } from "react";
import {
  useFragment as useFragment123,
  useMutation as useMutation32,
  usePreloadedQuery as usePreloadedQuery43,
  useQueryLoader as useQueryLoader21,
  useSubscribeToInvalidationState as useSubscribeToInvalidationState2
} from "react-relay";
import { createClientMutationId as createClientMutationId87, noop as noop17, useUserErrorCode as useUserErrorCode14 } from "shared-lib";
import { AlertMessage as AlertMessage18, Loading as Loading14, Tags as Tags8 } from "shared-ui";
import { TaskDetailsHeader as TaskDetailsHeader7 } from "app-core";
import { jsx as jsx380, jsxs as jsxs251 } from "react/jsx-runtime";
var profileFragmentDef6 = ClarifyOptionalSkillsApplicationTask_profile_graphql_default;
var fragmentDef98 = ClarifyOptionalSkillsApplicationTask_task_graphql_default;
var applicationFragmentDef5 = ClarifyOptionalSkillsApplicationTask_application_graphql_default;
var optionalSkillsQuery = ClarifyOptionalSkillsApplicationTaskQuery_graphql_default;
var markAsCompleteMutation2 = ClarifyOptionalSkillsApplicationTaskMutation_graphql_default;
var ClarifyOptionalSkillsApplicationTask = ({
  applicationId,
  fragmentRef,
  profileFragmentRef,
  onCompleted,
  onSelected,
  applicationFragmentRef,
  readonly = false,
  isOwner = true
}) => {
  const application3 = useFragment123(
    applicationFragmentDef5,
    applicationFragmentRef
  );
  const [queryRef3, loadQuery48] = useQueryLoader21(
    optionalSkillsQuery
  );
  const [commitMutation4, isMutationInFlight] = useMutation32(
    markAsCompleteMutation2
  );
  useEffect45(() => {
    loadQuery48({ applicationId }, { fetchPolicy: "network-only" });
  }, [applicationId, loadQuery48]);
  useSubscribeToInvalidationState2([application3.id], () => {
    loadQuery48({ applicationId }, { fetchPolicy: "network-only" });
  });
  if (!queryRef3) {
    return /* @__PURE__ */ jsx380(Loading14, {});
  }
  return /* @__PURE__ */ jsx380(
    ClarifyOptionalSkillsApplicationTaskComponent,
    {
      queryRef: queryRef3,
      applicationId,
      fragmentRef,
      profileFragmentRef,
      readonly,
      isOwner,
      onCompleted: () => {
        commitMutation4({
          variables: {
            input: {
              applicationId,
              clientMutationId: createClientMutationId87()
            }
          }
        });
        onCompleted();
      },
      onSelected,
      applicationFragmentRef
    }
  );
};
var ClarifyOptionalSkillsApplicationTaskComponent = ({
  fragmentRef,
  applicationFragmentRef,
  profileFragmentRef,
  queryRef: queryRef3,
  onCompleted,
  onSelected,
  readonly = false,
  isOwner = true
}) => {
  const application3 = useFragment123(
    applicationFragmentDef5,
    applicationFragmentRef
  );
  const data = useFragment123(fragmentDef98, fragmentRef);
  const errorCode = useUserErrorCode14();
  const profile = useFragment123(
    profileFragmentDef6,
    profileFragmentRef
  );
  const query3 = usePreloadedQuery43(
    optionalSkillsQuery,
    queryRef3
  );
  const { model } = query3;
  const skillGroupNames = (model.skillGroups || []).filter((e4) => e4.isRequired === false).map((e4) => e4.name);
  const [selectedExperience, setSelectedExperience] = useState109("NONE");
  return /* @__PURE__ */ jsxs251("div", { className: "sm:px-6 sm:py-5", children: [
    /* @__PURE__ */ jsx380(
      TaskDetailsHeader7,
      {
        title: data.title,
        status: data.status,
        onSelected
      }
    ),
    /* @__PURE__ */ jsx380("div", { className: "mt-2", children: /* @__PURE__ */ jsx380("p", { className: "line-clamp-2 text-sm text-gray-600", children: "The following skills could not be found in your profile. If you do have experience with any, maximise your chances of success by adding them to the description of the relevant role listed below." }) }),
    /* @__PURE__ */ jsx380("div", { className: "mt-2", children: /* @__PURE__ */ jsx380("div", { className: "flex gap-1 pt-2", children: /* @__PURE__ */ jsx380(Tags8, { size: "xsmall", list: [...new Set(skillGroupNames)] }) }) }),
    errorCode && errorCode === "PERMISSION_DENIED" && /* @__PURE__ */ jsx380(AlertMessage18, { message: "You do not have permission" }),
    /* @__PURE__ */ jsx380(
      ExperienceDropdown_default,
      {
        fragmentRef: profile,
        onChange: (e4) => setSelectedExperience(e4)
      }
    ),
    selectedExperience && selectedExperience != "NONE" && /* @__PURE__ */ jsx380(
      ExperienceEditComponent,
      {
        id: selectedExperience,
        applicationId: application3.id,
        profileId: profile.id,
        showCancel: false,
        onDone: onCompleted,
        onCancel: noop17
      },
      selectedExperience
    )
  ] });
};

// src/tasks/components/types/__generated__/RespondToInterviewTask_task.graphql.ts
var node434 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RespondToInterviewTask_task",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "candidateTaskId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "summary",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "data",
      "storageKey": null
    }
  ],
  "type": "TasksCandidateTask",
  "abstractKey": null
};
node434.hash = "a346fc9fc4922a0bf45803b4fb5402f3";
var RespondToInterviewTask_task_graphql_default = node434;

// src/tasks/components/types/RespondToInterviewTask.tsx
import { Suspense as Suspense131, useCallback as useCallback208 } from "react";
import { useFragment as useFragment124, useQueryLoader as useQueryLoader22 } from "react-relay";
import { useToggle as useToggle39, useUserErrorCode as useUserErrorCode15 } from "shared-lib";
import {
  AlertMessage as AlertMessage19,
  Button as Button98,
  ButtonList as ButtonList40,
  EdSkeleton as EdSkeleton105,
  Spinner as Spinner15
} from "shared-ui";
import { TaskDetailsHeader as TaskDetailsHeader8 } from "app-core";
import { jsx as jsx381, jsxs as jsxs253 } from "react/jsx-runtime";
var fragmentDef99 = RespondToInterviewTask_task_graphql_default;
var RespondToInterviewTask = ({
  fragmentRef,
  onCompleted
}) => {
  const [queryReference, loadQuery48, disposeQuery] = useQueryLoader22(interviewLayoutQueryDef);
  const data = useFragment124(fragmentDef99, fragmentRef);
  const errorCode = useUserErrorCode15();
  const [isScheduling, toggleScheduling] = useToggle39();
  const options7 = JSON.parse(data.data);
  const loadInterview = useCallback208(() => {
    loadQuery48({ id: options7.interviewId });
    toggleScheduling();
  }, [loadQuery48, toggleScheduling]);
  const complete = useCallback208(() => {
    if (onCompleted) {
      onCompleted();
    }
  }, [onCompleted]);
  return /* @__PURE__ */ jsx381(Suspense131, { fallback: /* @__PURE__ */ jsx381(Spinner15, {}), children: /* @__PURE__ */ jsxs253("div", { className: "sm:px-6 sm:py-5", children: [
    /* @__PURE__ */ jsx381(TaskDetailsHeader8, { title: data.title, status: data.status }),
    /* @__PURE__ */ jsx381("div", { className: "mt-1", children: /* @__PURE__ */ jsx381("p", { className: "line-clamp-2 text-sm text-gray-600", children: data.description }) }),
    errorCode && errorCode === "PERMISSION_DENIED" && /* @__PURE__ */ jsx381(AlertMessage19, { message: "You do not have permission" }),
    isScheduling && /* @__PURE__ */ jsx381(Suspense131, { fallback: /* @__PURE__ */ jsx381(EdSkeleton105, {}), children: queryReference && /* @__PURE__ */ jsx381(
      InterviewDetailsLoader,
      {
        queryRef: queryReference,
        defaultToScheduling: true,
        onCancel: toggleScheduling,
        onDone: complete
      }
    ) }),
    !isScheduling && /* @__PURE__ */ jsx381("div", { className: "mt-1", children: /* @__PURE__ */ jsxs253(ButtonList40, { children: [
      /* @__PURE__ */ jsx381("div", { className: "mt-2", children: /* @__PURE__ */ jsx381(Button98, { color: "primary", clicked: loadInterview, children: "Schedule Interview" }) }),
      /* @__PURE__ */ jsx381("div", { className: "mt-2", children: /* @__PURE__ */ jsx381(Button98, { color: "primary", children: "Decline Invitation" }) })
    ] }) })
  ] }) });
};

// src/tasks/components/types/__generated__/OfferTaskFragment_application.graphql.ts
var node435 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OfferTaskFragment_application",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "applicationId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "candidateId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "employerId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Vacancy",
      "kind": "LinkedField",
      "name": "vacancy",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "employerName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Application",
  "abstractKey": null
};
node435.hash = "ac0b023ea54387ca80719cebfd1004b4";
var OfferTaskFragment_application_graphql_default = node435;

// src/tasks/components/types/__generated__/OfferTaskQuery.graphql.ts
var node436 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "applicationId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "candidateId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "employerId"
    }
  ], v1 = [
    {
      "fields": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "eq",
              "variableName": "applicationId"
            }
          ],
          "kind": "ObjectValue",
          "name": "applicationId"
        },
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "eq",
              "variableName": "candidateId"
            }
          ],
          "kind": "ObjectValue",
          "name": "candidateId"
        }
      ],
      "kind": "ObjectValue",
      "name": "where"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "offerId",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v4 = {
    "alias": "refDataItems",
    "args": [
      {
        "kind": "Variable",
        "name": "employerId",
        "variableName": "employerId"
      },
      {
        "kind": "Literal",
        "name": "where",
        "value": {
          "discriminator": {
            "eq": "DeclineOpportunityReason"
          }
        }
      }
    ],
    "concreteType": "RefDataItemsByEmployerConnection",
    "kind": "LinkedField",
    "name": "refDataItemsByEmployer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RefDataItemsByEmployerEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cursor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RefDataItem",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              v32,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "display",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "refDataItemId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "OfferTaskQuery",
      "selections": [
        {
          "alias": "offers",
          "args": v1,
          "concreteType": "RecruitOffersConnection",
          "kind": "LinkedField",
          "name": "recruitOffers",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitOffer",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                v23
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        v4
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "OfferTaskQuery",
      "selections": [
        {
          "alias": "offers",
          "args": v1,
          "concreteType": "RecruitOffersConnection",
          "kind": "LinkedField",
          "name": "recruitOffers",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitOffer",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                v23,
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        v4
      ]
    },
    "params": {
      "cacheID": "acb8514f8d93cdcc0d6d38bd4c417656",
      "id": null,
      "metadata": {},
      "name": "OfferTaskQuery",
      "operationKind": "query",
      "text": 'query OfferTaskQuery(\n  $applicationId: UUID!\n  $candidateId: UUID!\n  $employerId: UUID!\n) {\n  offers: recruitOffers(where: {applicationId: {eq: $applicationId}, candidateId: {eq: $candidateId}}) {\n    nodes {\n      offerId\n      id\n    }\n  }\n  refDataItems: refDataItemsByEmployer(employerId: $employerId, where: {discriminator: {eq: "DeclineOpportunityReason"}}) {\n    edges {\n      cursor\n      node {\n        id\n        display\n        refDataItemId\n      }\n    }\n  }\n}\n'
    }
  };
}();
node436.hash = "a4e39d04db4bcb8c8f274c9596a302fd";
var OfferTaskQuery_graphql_default = node436;

// src/tasks/components/types/OfferTask.tsx
import { useCallback as useCallback209, useState as useState110 } from "react";
import { useFragment as useFragment125, useLazyLoadQuery as useLazyLoadQuery57 } from "react-relay";
import { Button as Button99, SelectMenu as SelectMenu5, TextArea as TextArea8 } from "shared-ui";
import { Fragment as Fragment101, jsx as jsx383, jsxs as jsxs254 } from "react/jsx-runtime";
function OfferTask({ applicationRef }) {
  const { candidateId, applicationId, vacancy, employerId } = useFragment125(
    OfferTask.fragments.application,
    applicationRef
  );
  const { offers, refDataItems } = useLazyLoadQuery57(
    OfferTask.query,
    {
      applicationId,
      candidateId,
      employerId
    }
  );
  const [offerState, setOfferState] = useState110(null);
  return /* @__PURE__ */ jsx383("div", { children: offers?.nodes?.map((offer) => {
    return /* @__PURE__ */ jsxs254(Fragment101, { children: [
      /* @__PURE__ */ jsxs254("div", { className: "px-5 pt-5 text-2xl", children: [
        /* @__PURE__ */ jsx383("span", { children: vacancy.name }),
        " at ",
        /* @__PURE__ */ jsx383("span", { children: vacancy.employerName })
      ] }),
      /* @__PURE__ */ jsxs254("div", { className: "flex w-full gap-2 px-5 py-3", children: [
        (offerState === "accepted" || offerState == null) && /* @__PURE__ */ jsx383(
          AcceptOffer,
          {
            applicationId,
            offerId: offer.offerId,
            onClick: setOfferState
          }
        ),
        (offerState === "reject" || offerState == null) && /* @__PURE__ */ jsx383(
          RejectOffer,
          {
            refDataItems,
            applicationId,
            offerId: offer.offerId,
            onClick: setOfferState
          }
        ),
        (offerState === "withdraw" || offerState == null) && /* @__PURE__ */ jsx383(
          WithdrawOffer,
          {
            applicationId,
            offerId: offer.offerId,
            onClick: setOfferState
          }
        )
      ] })
    ] });
  }) });
}
function RejectOffer({
  refDataItems,
  applicationId,
  offerId,
  onClick
}) {
  const [isDeclining, setDeclining] = useState110(false);
  const [decline, isLoading] = useOfferDecline(applicationId, offerId);
  const [declineReason, setDeclineReason] = useState110(null);
  const [text, setText] = useState110("");
  const onDecline = useCallback209(() => {
    setDeclining(true);
    onClick?.("reject");
  }, [onClick]);
  const onSubmit = useCallback209(
    async (message) => {
      if (!text || !declineReason)
        return;
      const data = await decline({
        message,
        reasonId: declineReason.id
      });
      if (data?.node?.status == "DECLINED") {
        setDeclining(false);
        onClick?.(null);
      }
    },
    [decline, declineReason, onClick, text]
  );
  const items = (refDataItems?.edges || []).map(({ node: node566 }) => ({
    id: node566.refDataItemId,
    name: node566.display
  }));
  return /* @__PURE__ */ jsxs254(Fragment101, { children: [
    !isDeclining && /* @__PURE__ */ jsx383(Button99, { color: "danger", onClick: onDecline, children: "Decline" }),
    isDeclining && /* @__PURE__ */ jsxs254("div", { className: "flex w-full flex-col gap-2", children: [
      /* @__PURE__ */ jsx383(
        SelectMenu5,
        {
          title: "Reason",
          items,
          onChange: (value) => setDeclineReason(value),
          value: declineReason
        }
      ),
      /* @__PURE__ */ jsx383(
        TextArea8,
        {
          placeholder: "Why are you declining this offer?",
          className: "h-48 w-full",
          onChange: (e4) => setText(e4.target.value)
        }
      ),
      /* @__PURE__ */ jsx383(
        Button99,
        {
          color: "transparent",
          onClick: () => {
            setDeclining(false);
            onClick?.(null);
          },
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ jsx383(
        Button99,
        {
          color: "primary",
          disabled: isLoading || !declineReason || !text,
          onClick: () => onSubmit(text),
          children: "Submit"
        }
      )
    ] })
  ] });
}
function AcceptOffer({ applicationId, offerId, onClick }) {
  const [withdraw, isLoading] = useOfferAccept(applicationId, offerId);
  return /* @__PURE__ */ jsx383(Button99, { color: "primary", onClick: () => withdraw(), children: "Accept" });
}
function WithdrawOffer({
  applicationId,
  offerId,
  onClick
}) {
  const [isWithdrawing, setWithdrawing] = useState110(false);
  const [withdraw, isLoading] = useOfferWithdraw(applicationId, offerId);
  const [text, setText] = useState110("");
  const onDecline = useCallback209(() => {
    setWithdrawing(true);
    onClick?.("withdraw");
  }, [onClick]);
  const onSubmit = useCallback209(
    (note) => {
      withdraw({
        note
      });
    },
    [withdraw]
  );
  return /* @__PURE__ */ jsxs254(Fragment101, { children: [
    !isWithdrawing && /* @__PURE__ */ jsx383(Button99, { color: "danger", onClick: onDecline, children: "Withdraw" }),
    isWithdrawing && /* @__PURE__ */ jsxs254("div", { className: "flex w-full flex-col gap-2", children: [
      /* @__PURE__ */ jsx383(
        TextArea8,
        {
          placeholder: "Why are you withdrawing from this offer?",
          className: "h-48 w-full",
          onChange: (e4) => setText(e4.target.value)
        }
      ),
      /* @__PURE__ */ jsx383(
        Button99,
        {
          color: "transparent",
          onClick: () => {
            setWithdrawing(false);
            onClick?.(null);
          },
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ jsx383(Button99, { color: "primary", onClick: () => onSubmit(text), children: "Submit" })
    ] })
  ] });
}
OfferTask.fragments = {
  application: OfferTaskFragment_application_graphql_default
};
OfferTask.query = OfferTaskQuery_graphql_default;

// src/tasks/components/ApplicationTaskDetails.tsx
import { jsx as jsx384, jsxs as jsxs255 } from "react/jsx-runtime";
function ApplicationTaskDetails({
  taskFragmentRef,
  applicationFragmentRef,
  profileFragmentRef,
  onCompleted
}) {
  const task = useFragment126(
    ApplicationTaskDetails.fragments.task,
    taskFragmentRef
  );
  const application3 = useFragment126(
    ApplicationTaskDetails.fragments.application,
    applicationFragmentRef
  );
  const profile = useFragment126(
    ApplicationTaskDetails.fragments.profile,
    profileFragmentRef
  );
  const [complete, isBusy] = useCandidateTaskComplete();
  const onComplete = useCallback211(() => {
    async function runUpdate() {
      const input = {
        taskId: task.candidateTaskId,
        clientMutationId: createClientMutationId88()
      };
      const response = await complete({ input });
      if (onCompleted) {
        onCompleted();
      }
    }
    runUpdate();
  }, [complete, onCompleted, task.candidateTaskId]);
  let taskType = /* @__PURE__ */ jsx384("div", { children: task.type });
  switch (task.type) {
    case "RightToWorkTask": {
      taskType = /* @__PURE__ */ jsx384(
        RightToWorkTask,
        {
          onCompleted: onComplete,
          fragmentRef: task,
          applicationFragmentRef: application3
        }
      );
      break;
    }
    case "ClarifySkillsApplicationTask": {
      taskType = /* @__PURE__ */ jsx384(
        ClarifySkillsApplicationTask,
        {
          applicationId: application3.applicationId,
          fragmentRef: task,
          onCompleted: onComplete,
          profileFragmentRef: profile,
          applicationFragmentRef: application3
        }
      );
      break;
    }
    case "ClarifyOptionalSkillsApplicationTask": {
      taskType = /* @__PURE__ */ jsx384(
        ClarifyOptionalSkillsApplicationTask,
        {
          applicationId: application3.applicationId,
          fragmentRef: task,
          profileFragmentRef: profile,
          onCompleted: onComplete,
          applicationFragmentRef: application3
        }
      );
      break;
    }
    case "ClarifyRateApplicationTask": {
      taskType = /* @__PURE__ */ jsx384(
        ClarifyRateApplicationTask,
        {
          taskFragmentRef: task,
          profileFragmentRef: profile,
          onCompleted: onComplete
        }
      );
      break;
    }
    case "CompleteComplianceChecksApplicationTask": {
      taskType = /* @__PURE__ */ jsx384(
        CompleteComplianceChecksApplicationTask,
        {
          fragmentRef: task,
          onCompleted: onComplete
        }
      );
      break;
    }
    case "CompleteFormApplicationTask": {
      taskType = /* @__PURE__ */ jsx384(
        CompleteFormApplicationTask,
        {
          fragmentRef: task,
          onCompleted: onComplete
        }
      );
      break;
    }
    case "CompleteDocumentApplicationTask": {
      taskType = /* @__PURE__ */ jsx384(
        CompleteDocumentApplicationTask,
        {
          applicationId: application3.applicationId,
          fragmentRef: task,
          onCompleted: onComplete
        }
      );
      break;
    }
    case "RespondToInterviewInvitationTask": {
      taskType = /* @__PURE__ */ jsx384(RespondToInterviewTask, { fragmentRef: task, onCompleted: onComplete });
      break;
    }
    case "OfferTask": {
      taskType = /* @__PURE__ */ jsx384(OfferTask, { applicationRef: application3 });
      break;
    }
  }
  const navigate = useNavigate25();
  return /* @__PURE__ */ jsxs255("div", { children: [
    /* @__PURE__ */ jsxs255(Button100, { className: "hidden lg:flex", onClick: () => navigate(-1), children: [
      /* @__PURE__ */ jsx384(ChevronLeftIcon2, { className: "h-4 w-4" }),
      " Back"
    ] }),
    /* @__PURE__ */ jsx384(
      "div",
      {
        className: "mt-4 rounded-xl p-2 sm:border sm:bg-white",
        children: /* @__PURE__ */ jsx384("div", { children: taskType })
      },
      task.candidateTaskId
    )
  ] });
}
ApplicationTaskDetails.fragments = {
  task: ApplicationTaskDetails_task_graphql_default,
  application: ApplicationTaskDetails_application_graphql_default,
  profile: ApplicationTaskDetails_profile_graphql_default
};

// src/tasks/components/__generated__/ApplicationTaskLoaderQuery.graphql.ts
var node437 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "applicationId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "taskId"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "applicationId"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v5 = [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "taskId"
    }
  ], v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "max",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "min",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currencyCode",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "payType",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "employerName",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "version",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "type",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ApplicationTaskLoaderQuery",
      "selections": [
        {
          "alias": "application",
          "args": v1,
          "concreteType": "Application",
          "kind": "LinkedField",
          "name": "applicationById",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": "Vacancy",
              "kind": "LinkedField",
              "name": "vacancy",
              "plural": false,
              "selections": [
                v32,
                v4
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ApplicationTaskDetails_application"
            }
          ],
          "storageKey": null
        },
        {
          "alias": "task",
          "args": v5,
          "concreteType": "TasksCandidateTask",
          "kind": "LinkedField",
          "name": "tasksCandidateTaskById",
          "plural": false,
          "selections": [
            v23,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ApplicationTaskDetails_task"
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ApplicationTaskLoaderQuery",
      "selections": [
        {
          "alias": "application",
          "args": v1,
          "concreteType": "Application",
          "kind": "LinkedField",
          "name": "applicationById",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": "Vacancy",
              "kind": "LinkedField",
              "name": "vacancy",
              "plural": false,
              "selections": [
                v32,
                v4,
                v23,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "VacancyRate",
                  "kind": "LinkedField",
                  "name": "rate",
                  "plural": false,
                  "selections": [
                    v6,
                    v7,
                    v8,
                    v9,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currencyCountry",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isPrivate",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "LocationCriteria",
                  "kind": "LinkedField",
                  "name": "locations",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "countryCode",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "countryName",
                      "storageKey": null
                    },
                    v32,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "entireCountry",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "latitude",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "longitude",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "radius",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "state",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                v10
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "applicationId",
              "storageKey": null
            },
            v11,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "employerId",
              "storageKey": null
            },
            v10,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "vacancyName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "applicationStateName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "workflowStateName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "candidateId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "appliedAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "completedByCandidateAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "declinedByCandidateAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "declinedByEmployerAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hiredAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasCompletedDocumentTypes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasCompletedForms",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasCompletedRequiredSkills",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasCompletedOptionalSkills",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasCompletedRate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "rightToWorkStatus",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ApplicationCandidateRate",
              "kind": "LinkedField",
              "name": "candidateRate",
              "plural": false,
              "selections": [
                v8,
                v9,
                v6,
                v7
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": "task",
          "args": v5,
          "concreteType": "TasksCandidateTask",
          "kind": "LinkedField",
          "name": "tasksCandidateTaskById",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "candidateTaskId",
              "storageKey": null
            },
            v12,
            v11,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "summary",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CandidateTaskSource",
              "kind": "LinkedField",
              "name": "source",
              "plural": false,
              "selections": [
                v23,
                v12
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "data",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "2a959bd27f92f7f3a0b7b90616a8eaa2",
      "id": null,
      "metadata": {},
      "name": "ApplicationTaskLoaderQuery",
      "operationKind": "query",
      "text": "query ApplicationTaskLoaderQuery(\n  $applicationId: UUID!\n  $taskId: UUID!\n) {\n  application: applicationById(id: $applicationId) {\n    id\n    vacancy {\n      name\n      code\n      id\n    }\n    ...ApplicationTaskDetails_application\n  }\n  task: tasksCandidateTaskById(id: $taskId) {\n    id\n    ...ApplicationTaskDetails_task\n  }\n}\n\nfragment ApplicationTaskDetails_application on Application {\n  id\n  applicationId\n  version\n  employerId\n  employerName\n  vacancyName\n  applicationStateName\n  workflowStateName\n  candidateId\n  appliedAt\n  completedByCandidateAt\n  declinedByCandidateAt\n  declinedByEmployerAt\n  hiredAt\n  hasCompletedDocumentTypes\n  hasCompletedForms\n  hasCompletedRequiredSkills\n  hasCompletedOptionalSkills\n  hasCompletedRate\n  rightToWorkStatus\n  candidateRate {\n    currencyCode\n    payType\n    max\n    min\n  }\n  vacancy {\n    rate {\n      max\n      min\n      currencyCode\n      payType\n      currencyCountry\n      isPrivate\n    }\n    locations {\n      countryCode\n      countryName\n      name\n      entireCountry\n      latitude\n      longitude\n      radius\n      state\n    }\n    id\n  }\n  ...RightToWorkTask_application\n  ...ClarifyOptionalSkillsApplicationTask_application\n  ...ClarifySkillsApplicationTask_application\n  ...OfferTaskFragment_application\n}\n\nfragment ApplicationTaskDetails_task on TasksCandidateTask {\n  id\n  candidateTaskId\n  type\n  version\n  description\n  title\n  summary\n  ...ClarifyRateApplicationTask_task\n  ...ClarifySkillsApplicationTask_task\n  ...ClarifyOptionalSkillsApplicationTask_task\n  ...CompleteComplianceChecksApplicationTask_task\n  ...CompleteDocumentApplicationTask_task\n  ...CompleteFormApplicationTask_task\n  ...RightToWorkTask_task\n  ...RespondToInterviewTask_task\n}\n\nfragment ClarifyOptionalSkillsApplicationTask_application on Application {\n  id\n}\n\nfragment ClarifyOptionalSkillsApplicationTask_task on TasksCandidateTask {\n  id\n  candidateTaskId\n  type\n  version\n  description\n  title\n  summary\n  status\n}\n\nfragment ClarifyRateApplicationTask_task on TasksCandidateTask {\n  id\n  candidateTaskId\n  type\n  version\n  description\n  title\n  summary\n  status\n  source {\n    id\n  }\n}\n\nfragment ClarifySkillsApplicationTask_application on Application {\n  id\n  applicationId\n}\n\nfragment ClarifySkillsApplicationTask_task on TasksCandidateTask {\n  id\n  candidateTaskId\n  type\n  version\n  description\n  title\n  summary\n  status\n}\n\nfragment CompleteComplianceChecksApplicationTask_task on TasksCandidateTask {\n  id\n  candidateTaskId\n  type\n  version\n  description\n  title\n  summary\n  status\n}\n\nfragment CompleteDocumentApplicationTask_task on TasksCandidateTask {\n  id\n  candidateTaskId\n  type\n  version\n  description\n  title\n  summary\n  status\n  data\n}\n\nfragment CompleteFormApplicationTask_task on TasksCandidateTask {\n  id\n  candidateTaskId\n  type\n  version\n  description\n  title\n  summary\n  status\n  source {\n    type\n    id\n  }\n  data\n}\n\nfragment OfferTaskFragment_application on Application {\n  id\n  applicationId\n  candidateId\n  employerId\n  vacancy {\n    employerName\n    name\n    id\n  }\n}\n\nfragment RespondToInterviewTask_task on TasksCandidateTask {\n  id\n  candidateTaskId\n  type\n  version\n  description\n  title\n  summary\n  status\n  data\n}\n\nfragment RightToWorkTask_application on Application {\n  id\n  applicationId\n  version\n  employerId\n  employerName\n  vacancyName\n  applicationStateName\n  workflowStateName\n  appliedAt\n  completedByCandidateAt\n  declinedByCandidateAt\n  declinedByEmployerAt\n  hiredAt\n  hasCompletedDocumentTypes\n  hasCompletedForms\n  hasCompletedRequiredSkills\n  hasCompletedOptionalSkills\n  hasCompletedRate\n  rightToWorkStatus\n  candidateRate {\n    currencyCode\n    payType\n    max\n    min\n  }\n  vacancy {\n    rate {\n      max\n      min\n      currencyCode\n      payType\n      currencyCountry\n      isPrivate\n    }\n    locations {\n      countryCode\n      countryName\n      name\n      entireCountry\n      latitude\n      longitude\n      radius\n      state\n    }\n    id\n  }\n}\n\nfragment RightToWorkTask_task on TasksCandidateTask {\n  id\n  candidateTaskId\n  type\n  version\n  description\n  title\n  summary\n  status\n}\n"
    }
  };
}();
node437.hash = "1b4ff3b1f2fea00b37dc597e62a19c47";
var ApplicationTaskLoaderQuery_graphql_default = node437;

// src/tasks/components/__generated__/ApplicationTaskLoader_data.graphql.ts
var node438 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ApplicationTaskLoader_data",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recruitProfileId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ApplicationTaskDetails_profile"
    }
  ],
  "type": "RecruitProfile",
  "abstractKey": null
};
node438.hash = "ea28b5e2d82cafa7028385285abcc994";
var ApplicationTaskLoader_data_graphql_default = node438;

// src/tasks/components/ApplicationTaskLoader.tsx
import { useParams as useParams12 } from "react-router-dom";
import { useFragment as useFragment127, useLazyLoadQuery as useLazyLoadQuery58 } from "react-relay";
import { Button as Button101, ButtonList as ButtonList41 } from "shared-ui";
import { jsx as jsx385, jsxs as jsxs256 } from "react/jsx-runtime";
var graphqlQuery11 = ApplicationTaskLoaderQuery_graphql_default;
var fragmentDef100 = ApplicationTaskLoader_data_graphql_default;
var ApplicationTaskLoader = ({
  fragmentRef,
  onCompleted,
  onBack
}) => {
  const profile = useFragment127(fragmentDef100, fragmentRef);
  const { applicationId } = useParams12();
  const { taskId } = useParams12();
  const data = useLazyLoadQuery58(
    graphqlQuery11,
    { applicationId, taskId },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { task, application: application3 } = data;
  if (!task || !application3) {
    return /* @__PURE__ */ jsx385("div", { children: "Could Not Load Task" });
  }
  return /* @__PURE__ */ jsxs256("div", { className: "p-2 sm:p-8", children: [
    /* @__PURE__ */ jsxs256("div", { className: "flex items-center justify-between px-2", children: [
      /* @__PURE__ */ jsx385("div", { className: "text-xl font-medium uppercase text-gray-900", children: /* @__PURE__ */ jsx385("p", { children: application3.vacancy.name }) }),
      /* @__PURE__ */ jsx385(ButtonList41, { children: /* @__PURE__ */ jsx385(Button101, { clicked: onBack, children: "Back" }) })
    ] }),
    /* @__PURE__ */ jsx385(
      ApplicationTaskDetails,
      {
        taskFragmentRef: task,
        applicationFragmentRef: application3,
        profileFragmentRef: profile,
        onCompleted
      }
    )
  ] });
};

// src/tasks/components/__generated__/ApplicationTaskContainerQuery.graphql.ts
var node439 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "id"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "id"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "type",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ApplicationTaskContainerQuery",
      "selections": [
        {
          "alias": "task",
          "args": v1,
          "concreteType": "TasksCandidateTask",
          "kind": "LinkedField",
          "name": "tasksCandidateTaskById",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ApplicationTaskDetails_task"
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ApplicationTaskContainerQuery",
      "selections": [
        {
          "alias": "task",
          "args": v1,
          "concreteType": "TasksCandidateTask",
          "kind": "LinkedField",
          "name": "tasksCandidateTaskById",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "candidateTaskId",
              "storageKey": null
            },
            v32,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "version",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "summary",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CandidateTaskSource",
              "kind": "LinkedField",
              "name": "source",
              "plural": false,
              "selections": [
                v23,
                v32
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "data",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "87ec1c47355c3d91c72c2d4156e3b4e0",
      "id": null,
      "metadata": {},
      "name": "ApplicationTaskContainerQuery",
      "operationKind": "query",
      "text": "query ApplicationTaskContainerQuery(\n  $id: UUID!\n) {\n  task: tasksCandidateTaskById(id: $id) {\n    ...ApplicationTaskDetails_task\n    id\n  }\n}\n\nfragment ApplicationTaskDetails_task on TasksCandidateTask {\n  id\n  candidateTaskId\n  type\n  version\n  description\n  title\n  summary\n  ...ClarifyRateApplicationTask_task\n  ...ClarifySkillsApplicationTask_task\n  ...ClarifyOptionalSkillsApplicationTask_task\n  ...CompleteComplianceChecksApplicationTask_task\n  ...CompleteDocumentApplicationTask_task\n  ...CompleteFormApplicationTask_task\n  ...RightToWorkTask_task\n  ...RespondToInterviewTask_task\n}\n\nfragment ClarifyOptionalSkillsApplicationTask_task on TasksCandidateTask {\n  id\n  candidateTaskId\n  type\n  version\n  description\n  title\n  summary\n  status\n}\n\nfragment ClarifyRateApplicationTask_task on TasksCandidateTask {\n  id\n  candidateTaskId\n  type\n  version\n  description\n  title\n  summary\n  status\n  source {\n    id\n  }\n}\n\nfragment ClarifySkillsApplicationTask_task on TasksCandidateTask {\n  id\n  candidateTaskId\n  type\n  version\n  description\n  title\n  summary\n  status\n}\n\nfragment CompleteComplianceChecksApplicationTask_task on TasksCandidateTask {\n  id\n  candidateTaskId\n  type\n  version\n  description\n  title\n  summary\n  status\n}\n\nfragment CompleteDocumentApplicationTask_task on TasksCandidateTask {\n  id\n  candidateTaskId\n  type\n  version\n  description\n  title\n  summary\n  status\n  data\n}\n\nfragment CompleteFormApplicationTask_task on TasksCandidateTask {\n  id\n  candidateTaskId\n  type\n  version\n  description\n  title\n  summary\n  status\n  source {\n    type\n    id\n  }\n  data\n}\n\nfragment RespondToInterviewTask_task on TasksCandidateTask {\n  id\n  candidateTaskId\n  type\n  version\n  description\n  title\n  summary\n  status\n  data\n}\n\nfragment RightToWorkTask_task on TasksCandidateTask {\n  id\n  candidateTaskId\n  type\n  version\n  description\n  title\n  summary\n  status\n}\n"
    }
  };
}();
node439.hash = "62739630cf08b5a66c4c5a6bd15464a6";
var ApplicationTaskContainerQuery_graphql_default = node439;

// src/tasks/components/__generated__/ApplicationTaskContainer_application.graphql.ts
var node440 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ApplicationTaskContainer_application",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ApplicationRightToWorkEditor_application"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ApplicationTaskDetails_application"
    }
  ],
  "type": "Application",
  "abstractKey": null
};
node440.hash = "2ae4da648786c64f3bb35ac1852b34b1";
var ApplicationTaskContainer_application_graphql_default = node440;

// src/tasks/components/__generated__/ApplicationTaskContainer_profile.graphql.ts
var node441 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ApplicationTaskContainer_profile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ApplicationTaskDetails_profile"
    }
  ],
  "type": "RecruitProfile",
  "abstractKey": null
};
node441.hash = "6a68ea32e26af088db21de82ac5e7bd8";
var ApplicationTaskContainer_profile_graphql_default = node441;

// src/tasks/components/ApplicationTaskContainer.tsx
import { useParams as useParams13 } from "react-router-dom";
import { useFragment as useFragment128, useLazyLoadQuery as useLazyLoadQuery59 } from "react-relay";
import { jsx as jsx386 } from "react/jsx-runtime";
function ApplicationTaskContainer({
  applicationFragmentRef,
  profileFragmentRef,
  onCompleted
}) {
  const { taskId } = useParams13();
  const application3 = useFragment128(
    ApplicationTaskContainer.fragments.application,
    applicationFragmentRef
  );
  const profile = useFragment128(
    ApplicationTaskContainer.fragments.profile,
    profileFragmentRef
  );
  const data = useLazyLoadQuery59(
    ApplicationTaskContainer.query,
    { id: taskId },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { task } = data;
  return /* @__PURE__ */ jsx386("div", { className: "container mx-auto px-4 md:pt-6", children: /* @__PURE__ */ jsx386(
    ApplicationTaskDetails,
    {
      taskFragmentRef: task,
      applicationFragmentRef: application3,
      profileFragmentRef: profile,
      onCompleted
    }
  ) });
}
ApplicationTaskContainer.query = ApplicationTaskContainerQuery_graphql_default;
ApplicationTaskContainer.fragments = {
  application: ApplicationTaskContainer_application_graphql_default,
  profile: ApplicationTaskContainer_profile_graphql_default
};

// src/applications/components/__generated__/ApplicationDetails_application.graphql.ts
var node443 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v23 = [
    v1,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isRequired",
      "storageKey": null
    }
  ], v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "countryName",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "payType",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currencyCode",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "countryCode",
    "storageKey": null
  }, v7 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "min",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "max",
      "storageKey": null
    },
    v4,
    v5
  ];
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ApplicationDetails_application",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "applicationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "version",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "employerName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "vacancyName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "applicationStateName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "workflowStateName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ClarifySkillGroup",
        "kind": "LinkedField",
        "name": "clarifySkills",
        "plural": true,
        "selections": v23,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitProfileWorkLocations",
        "kind": "LinkedField",
        "name": "workLocations",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "WorkLocationEntry",
            "kind": "LinkedField",
            "name": "workLocations",
            "plural": true,
            "selections": [
              v0,
              v1,
              v32
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitResume",
        "kind": "LinkedField",
        "name": "currentResume",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitProfile",
            "kind": "LinkedField",
            "name": "profile",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitProfileRate",
                "kind": "LinkedField",
                "name": "rate",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "minimumRateOfPay",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "maximumRateOfPay",
                    "storageKey": null
                  },
                  v4,
                  v5
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitProfileWorkLocations",
                "kind": "LinkedField",
                "name": "workLocations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WorkLocationEntry",
                    "kind": "LinkedField",
                    "name": "workLocations",
                    "plural": true,
                    "selections": [
                      v0,
                      v1,
                      v6
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ApplicationCandidateRate",
        "kind": "LinkedField",
        "name": "candidateRate",
        "plural": false,
        "selections": v7,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Vacancy",
        "kind": "LinkedField",
        "name": "vacancy",
        "plural": false,
        "selections": [
          v0,
          v1,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerLogoUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "publicDescriptionText",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SkillGroup",
            "kind": "LinkedField",
            "name": "skillGroups",
            "plural": true,
            "selections": v23,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VacancyRate",
            "kind": "LinkedField",
            "name": "rate",
            "plural": false,
            "selections": v7,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LocationCriteria",
            "kind": "LinkedField",
            "name": "locations",
            "plural": true,
            "selections": [
              v1,
              v32,
              v6
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VacancyDates",
            "kind": "LinkedField",
            "name": "dates",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "durationDescription",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitProfileExperience",
        "kind": "LinkedField",
        "name": "experience",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "skills",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "CandidateApplicationRelevance_application"
      }
    ],
    "type": "Application",
    "abstractKey": null
  };
}();
node443.hash = "071a4facaf2bf526cb4167635a097dda";
var ApplicationDetails_application_graphql_default = node443;

// src/applications/components/__generated__/ApplicationDetails_tasks.graphql.ts
var node444 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ApplicationDetails_tasks",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TaskBySourceList_tasks"
    }
  ],
  "type": "Query",
  "abstractKey": null
};
node444.hash = "1fc566b8bc321d2e35c47f1bd27ac2ad";
var ApplicationDetails_tasks_graphql_default = node444;

// src/applications/components/ApplicationDetails.tsx
import { useFragment as useFragment129 } from "react-relay";
import { CalendarDaysIcon, ClockIcon } from "@heroicons/react/24/outline";
import { format as format17 } from "date-fns";
import { WalletIcon } from "@heroicons/react/24/outline";
import { ResponsivePie as ResponsivePie5 } from "@nivo/pie";
import { useNavigate as useNavigate26 } from "react-router-dom";
import { useToggle as useToggle40 } from "shared-lib";
import { TaskBySourceList as TaskBySourceList2 } from "app-core";
import { Info as Info2, HighlightTags, classNames as classNames42, Card as Card6, ChartColors as ChartColors5 } from "shared-ui";
import { jsx as jsx387, jsxs as jsxs257 } from "react/jsx-runtime";
var fragmentDef101 = ApplicationDetails_application_graphql_default;
var taskFragmentDef2 = ApplicationDetails_tasks_graphql_default;
var ApplicationDetails = (props) => {
  const data = useFragment129(fragmentDef101, props.application);
  const tasks = useFragment129(taskFragmentDef2, props.tasks);
  const navigate = useNavigate26();
  const [showDescription, toggleShowDescription] = useToggle40(false);
  return /* @__PURE__ */ jsxs257("div", { className: "flex flex-col gap-5 py-5 ", children: [
    /* @__PURE__ */ jsxs257("div", { className: "container mx-auto flex flex-col gap-5", children: [
      /* @__PURE__ */ jsx387(Card6, { className: "flex flex-col justify-between gap-5 2xl:flex-row", children: /* @__PURE__ */ jsx387("div", { className: "flex flex-col gap-5", children: /* @__PURE__ */ jsx387("div", { className: `flex justify-between text-gray-300`, children: /* @__PURE__ */ jsxs257("div", { className: "flex flex-col gap-4 sm:flex-row", children: [
        /* @__PURE__ */ jsx387(
          Info2,
          {
            iconColor: "stroke-gray-500",
            color: "text-gray-500",
            value: /* @__PURE__ */ jsxs257("div", { children: [
              "Closing: ",
              format17(new Date(data.createdAt), "dd/MM/yyyy")
            ] }),
            icon: CalendarDaysIcon
          }
        ),
        /* @__PURE__ */ jsx387(
          Info2,
          {
            color: "text-gray-500",
            iconColor: "stroke-gray-500",
            value: /* @__PURE__ */ jsx387(
              RateLabel,
              {
                rate: {
                  countryCode: data.vacancy.rate?.currencyCode || null,
                  currencyCode: data.vacancy.rate?.currencyCode || null,
                  maximumRateOfPay: data.vacancy.rate?.max || 0,
                  minimumRateOfPay: data.vacancy.rate?.min || 0,
                  payType: data.vacancy.rate?.payType || "PER_DAY"
                }
              }
            ),
            icon: WalletIcon
          }
        ),
        /* @__PURE__ */ jsx387(
          Info2,
          {
            color: "text-gray-500",
            iconColor: "stroke-gray-500",
            value: data.vacancy.dates?.durationDescription,
            icon: ClockIcon
          }
        )
      ] }) }) }) }),
      /* @__PURE__ */ jsxs257(Card6, { className: "relative flex flex-col gap-5", children: [
        /* @__PURE__ */ jsx387("h2", { className: "whitespace-pre text-xl", children: "Job Description" }),
        /* @__PURE__ */ jsx387(
          "div",
          {
            className: classNames42(
              "border-primary-400 ml-1 whitespace-pre-line border-l-8 pl-4 text-sm leading-5 text-gray-600 ",
              showDescription ? "" : "line-clamp-4"
            ),
            children: data.vacancy.publicDescriptionText
          }
        ),
        /* @__PURE__ */ jsxs257(
          "div",
          {
            className: "cursor-pointer text-xs",
            onClick: toggleShowDescription,
            children: [
              "Read ",
              showDescription ? "less" : "more"
            ]
          }
        )
      ] }),
      /* @__PURE__ */ jsxs257(Card6, { className: "flex flex-col justify-between gap-10 lg:flex-row 2xl:flex-row", children: [
        /* @__PURE__ */ jsxs257("div", { className: "flex w-full grow flex-col gap-10 lg:w-1/2", children: [
          /* @__PURE__ */ jsx387("h2", { className: "border-primary-400 border-b-2 pb-2 text-xl", children: "Skills" }),
          /* @__PURE__ */ jsx387(
            Skills,
            {
              vacancySkills: [...data.vacancy.skillGroups],
              clarifySkills: [...data.clarifySkills]
            }
          )
        ] }),
        /* @__PURE__ */ jsxs257("div", { className: "w-full", children: [
          /* @__PURE__ */ jsx387("h2", { className: "border-primary-400 border-b-2 pb-2 text-xl", children: "Tasks" }),
          /* @__PURE__ */ jsx387(
            TaskBySourceList2,
            {
              sourceId: data.applicationId,
              fragmentRef: tasks,
              onSelected: function(id18) {
                navigate(`../task/${id18}`);
              }
            }
          )
        ] })
      ] })
    ] }),
    /* @__PURE__ */ jsx387("div", { children: /* @__PURE__ */ jsxs257(
      "div",
      {
        className: classNames42(
          "flex flex-col gap-3 rounded-2xl bg-white p-5 "
        ),
        children: [
          /* @__PURE__ */ jsx387("div", { className: "border-primary-400 border-b-2 pb-2 text-xl", children: "Experience Relevance" }),
          /* @__PURE__ */ jsx387("div", { className: "text-sm", children: "Here is an overview of your experience matching to this vacancy requirements. Consider completing the Clarify Skills tasks as this will further showcase your relevant skills and boost your ranking." }),
          /* @__PURE__ */ jsx387(CandidateApplicationRelevanceComponent, { fragmentRef: data })
        ]
      }
    ) })
  ] });
};
var Skills = ({ vacancySkills, clarifySkills }) => {
  return /* @__PURE__ */ jsx387("div", { className: "flex flex-col", children: /* @__PURE__ */ jsxs257("div", { className: "flex flex-col items-center sm:flex-row-reverse lg:flex-col ", children: [
    /* @__PURE__ */ jsx387("div", { className: "w-full max-w-md pb-4 sm:w-1/2 lg:w-full", children: /* @__PURE__ */ jsx387(
      HighlightTags,
      {
        tags: vacancySkills.map((x4) => {
          const unmatchedSkills = clarifySkills.map(
            (x5) => x5.name
          );
          return {
            ...x4,
            highlight: unmatchedSkills.includes(x4.name)
          };
        }).sort((a4, b3) => {
          if (a4.name == null || b3.name == null)
            return 0;
          return a4.name.length - b3.name.length;
        })
      }
    ) }),
    /* @__PURE__ */ jsx387("div", { className: " h-[300px] w-full sm:w-1/2 lg:w-full", children: /* @__PURE__ */ jsx387(
      DoughnutChart,
      {
        vacancySkills,
        clarifySkills
      }
    ) })
  ] }) });
};
var DoughnutChart = ({ vacancySkills, clarifySkills }) => {
  const unmatchedCount = clarifySkills.length;
  const matchedCount = vacancySkills.length - unmatchedCount;
  const matchedPercentage = vacancySkills.length > 0 ? matchedCount / vacancySkills.length * 100 : 0;
  let matchEmoji = "";
  switch (true) {
    case matchedPercentage == 100:
      matchEmoji = "\u2B50\uFE0F";
      break;
    case matchedPercentage < 10:
      matchEmoji = "\u{1FAE5}";
      break;
    case matchedPercentage < 40:
      matchEmoji = "\u{1F641}";
      break;
    case matchedPercentage < 50:
      matchEmoji = "\u{1F610}";
      break;
    case matchedPercentage < 80:
      matchEmoji = "\u{1F642}";
      break;
    case matchedPercentage < 100:
      matchEmoji = "\u{1F600}";
      break;
  }
  const chartData = [
    {
      id: "Matched",
      label: "Matched Skills",
      value: matchedCount,
      color: "#7EDA47"
    },
    {
      id: "Unmatched",
      label: "Unmatched Skills",
      value: unmatchedCount,
      color: "#E2E2E8"
    }
  ];
  const CenteredMetric = ({
    centerX,
    centerY
  }) => {
    return /* @__PURE__ */ jsx387(
      "text",
      {
        x: centerX,
        y: centerY,
        textAnchor: "middle",
        dominantBaseline: "central",
        style: {
          fontSize: "50px",
          fontWeight: 600
        },
        children: matchEmoji
      }
    );
  };
  return /* @__PURE__ */ jsx387(
    ResponsivePie5,
    {
      layers: ["arcs", "arcLabels", "arcLinkLabels", "legends", CenteredMetric],
      isInteractive: true,
      enableArcLabels: true,
      enableArcLinkLabels: false,
      data: chartData,
      colors: ChartColors5,
      innerRadius: 0.5,
      padAngle: 0.7,
      activeOuterRadiusOffset: 8,
      borderColor: { from: "color", modifiers: [["darker", 0.2]] },
      arcLinkLabelsSkipAngle: 10,
      arcLinkLabelsThickness: 2,
      arcLabelsSkipAngle: 10
    }
  );
};

// src/applications/components/__generated__/WithdrawApplicationDialogQuery.graphql.ts
var node445 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "employerId"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "employerId",
      "variableName": "employerId"
    },
    {
      "kind": "Literal",
      "name": "where",
      "value": {
        "discriminator": {
          "eq": "DeclineOpportunityReason"
        }
      }
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "concreteType": "PageInfo",
    "kind": "LinkedField",
    "name": "pageInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasNextPage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasPreviousPage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "startCursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endCursor",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "cursor",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "discriminator",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "tenantId",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "display",
    "storageKey": null
  }, v8 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "WithdrawApplicationDialogQuery",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "RefDataItemsByEmployerConnection",
          "kind": "LinkedField",
          "name": "refDataItemsByEmployer",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": "RefDataItemsByEmployerEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                v32,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RefDataItem",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v4,
                    v5,
                    v6,
                    v7
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "WithdrawApplicationForm_refData"
            },
            v8
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "WithdrawApplicationDialogQuery",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "RefDataItemsByEmployerConnection",
          "kind": "LinkedField",
          "name": "refDataItemsByEmployer",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": "RefDataItemsByEmployerEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                v32,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RefDataItem",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v4,
                    v5,
                    v6,
                    v7,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "refDataItemId",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v8
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "fb276e37b07dc19fb41e5a09797a1c7e",
      "id": null,
      "metadata": {},
      "name": "WithdrawApplicationDialogQuery",
      "operationKind": "query",
      "text": 'query WithdrawApplicationDialogQuery(\n  $employerId: UUID!\n) {\n  refDataItemsByEmployer(employerId: $employerId, where: {discriminator: {eq: "DeclineOpportunityReason"}}) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        discriminator\n        tenantId\n        display\n      }\n    }\n    ...WithdrawApplicationForm_refData\n  }\n}\n\nfragment WithdrawApplicationForm_refData on RefDataItemsByEmployerConnection {\n  pageInfo {\n    hasNextPage\n    hasPreviousPage\n    startCursor\n    endCursor\n  }\n  edges {\n    cursor\n    node {\n      id\n      discriminator\n      tenantId\n      display\n      refDataItemId\n    }\n  }\n}\n'
    }
  };
}();
node445.hash = "ac21904f4b138829c1f3d1308f1ffeaa";
var WithdrawApplicationDialogQuery_graphql_default = node445;

// src/applications/components/WithdrawApplication.tsx
import {
  ConnectionHandler as ConnectionHandler6,
  useLazyLoadQuery as useLazyLoadQuery60,
  useRelayEnvironment as useRelayEnvironment5
} from "react-relay";
import { logInfo as logInfo2, noop as noop18 } from "shared-lib";

// src/applications/components/__generated__/WithdrawApplicationForm_refData.graphql.ts
var node446 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WithdrawApplicationForm_refData",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PageInfo",
      "kind": "LinkedField",
      "name": "pageInfo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasNextPage",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasPreviousPage",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startCursor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endCursor",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RefDataItemsByEmployerEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cursor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RefDataItem",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "discriminator",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "tenantId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "display",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "refDataItemId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__id",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "RefDataItemsByEmployerConnection",
  "abstractKey": null
};
node446.hash = "b18d85cd1e8934ee8f2684a52fb63e67";
var WithdrawApplicationForm_refData_graphql_default = node446;

// src/applications/components/WithdrawApplicationForm.tsx
import { useCallback as useCallback213 } from "react";
import { useForm as useForm21, Controller as Controller12 } from "react-hook-form";
import { useFragment as useFragment130 } from "react-relay";
import { ActionContainer as ActionContainer8, SelectMenu as SelectMenu6, TextArea as TextArea9 } from "shared-ui";
import { jsx as jsx388, jsxs as jsxs258 } from "react/jsx-runtime";
var refDataFragment = WithdrawApplicationForm_refData_graphql_default;
var WithdrawApplicationForm = ({
  refDataRef,
  vacancyName: vacancyName2,
  employerName,
  onSave,
  onCancel
}) => {
  const refData = useFragment130(refDataFragment, refDataRef);
  const items = (refData?.edges || []).map(({ node: node566 }) => ({
    id: node566.refDataItemId,
    name: node566.display
  }));
  const {
    register,
    handleSubmit,
    control,
    formState: { errors }
  } = useForm21();
  const onSubmit = useCallback213(
    (form) => {
      const data = form;
      onSave({
        reasonId: data.reason.id,
        reason: data.reasonMessage || ""
      });
    },
    [onSave]
  );
  return /* @__PURE__ */ jsx388("div", { className: "mt-10", children: /* @__PURE__ */ jsx388(
    ActionContainer8,
    {
      titleTop: `Withdraw your Application`,
      submitText: "Withdraw Application",
      onSubmit: handleSubmit(onSubmit),
      children: /* @__PURE__ */ jsxs258("div", { className: "flex flex-col gap-5 px-4 md:px-0", children: [
        /* @__PURE__ */ jsx388("div", { children: /* @__PURE__ */ jsx388(
          Controller12,
          {
            control,
            name: "reason",
            rules: { required: true },
            defaultValue: items[0],
            render: ({ field: { onChange, value } }) => /* @__PURE__ */ jsx388(
              SelectMenu6,
              {
                title: "Reason",
                items,
                onChange,
                value
              }
            )
          }
        ) }),
        /* @__PURE__ */ jsxs258("div", { children: [
          /* @__PURE__ */ jsx388(
            "label",
            {
              htmlFor: "reasonMessage",
              className: "block text-sm font-medium text-gray-700",
              children: "Why are you withdrawing your application?"
            }
          ),
          /* @__PURE__ */ jsxs258("div", { children: [
            /* @__PURE__ */ jsx388(
              TextArea9,
              {
                rows: 5,
                type: "text",
                className: "rounded-lg",
                ...register("reasonMessage", { required: true })
              }
            ),
            errors.reasonMessageRequired && /* @__PURE__ */ jsx388("span", { children: "A reason is required" })
          ] })
        ] })
      ] })
    }
  ) });
};

// src/applications/components/WithdrawApplication.tsx
import { jsx as jsx389 } from "react/jsx-runtime";
var withdrawApplicationDialogQ = WithdrawApplicationDialogQuery_graphql_default;
var WithdrawApplication = ({
  applicationId,
  applicationVersion,
  applicationStateName,
  employerId,
  employerName,
  vacancyName: vacancyName2
}) => {
  const connectionId = ConnectionHandler6.getConnectionID(
    "root",
    // passed as input to the mutation/subscription
    "ApplicationList_applications"
  );
  const data = useLazyLoadQuery60(
    withdrawApplicationDialogQ,
    {
      employerId
    },
    {
      fetchPolicy: "network-only"
    }
  );
  const environment = useRelayEnvironment5();
  function saveForm(form) {
    logInfo2(JSON.stringify(form));
    WithdrawApplicationMutation_default.commit(
      environment,
      {
        applicationId,
        version: applicationVersion,
        ...form
      },
      connectionId,
      noop18
    );
  }
  if (applicationStateName === "Active" && data.refDataItemsByEmployer) {
    return /* @__PURE__ */ jsx389(
      WithdrawApplicationForm,
      {
        refDataRef: data.refDataItemsByEmployer,
        employerName,
        vacancyName: vacancyName2,
        onSave: (form) => saveForm(form),
        onCancel: noop18
      }
    );
  }
  return /* @__PURE__ */ jsx389("div", { className: "mt-6 flex items-center space-x-4", children: /* @__PURE__ */ jsx389("p", { children: "This application has been withdrawn" }) });
};

// src/applications/components/ApplicationLayout.tsx
import { jsx as jsx390, jsxs as jsxs259 } from "react/jsx-runtime";
var applicationLayoutQueryDef = ApplicationLayoutQuery_graphql_default;
var DefaultLayout = ({ children, showBackButton = false }) => {
  return /* @__PURE__ */ jsxs259("div", { className: "container mx-auto px-2 sm:px-6 lg:px-8", children: [
    /* @__PURE__ */ jsxs259("div", { className: "flex items-center justify-between pt-4", children: [
      showBackButton && /* @__PURE__ */ jsx390(
        EdLink21,
        {
          href: `../`,
          name: "Back",
          className: "hidden rounded-2xl bg-black px-2 py-1 text-xs text-white xl:flex",
          children: "Back"
        }
      ),
      /* @__PURE__ */ jsx390("div", { className: "mt-5 flex w-full justify-end", children: /* @__PURE__ */ jsxs259("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ jsx390(EdLink21, { href: "../chats", name: "chats", children: /* @__PURE__ */ jsxs259(Button103, { color: "primary", size: Size51.lg, className: "gap-1 text-xs", children: [
          /* @__PURE__ */ jsx390(ChatBubbleBottomCenterIcon, { className: "h-4 w-4 " }),
          /* @__PURE__ */ jsx390("div", { children: "Chat" })
        ] }) }),
        /* @__PURE__ */ jsx390(EdLink21, { href: "../withdraw", name: "withdraw", children: /* @__PURE__ */ jsx390(Button103, { color: "danger", size: Size51.lg, className: "text-xs", children: "Withdraw Application" }) })
      ] }) })
    ] }),
    children
  ] });
};
var ApplicationLayout = ({
  queryRef: queryRef3,
  applicationId,
  onReload,
  defaultPath = "info"
}) => {
  const navigate = useNavigate27();
  const location2 = useLocation7();
  const [log] = useLogger28();
  const [resumeImportState] = useResumeWorkflowState();
  const data = usePreloadedQuery44(
    applicationLayoutQueryDef,
    queryRef3
  );
  const navigateToChat = useCallback214((id18) => {
    navigate(`./chat/${id18}`);
  }, []);
  const onTaskCompleted = useCallback214(() => {
    navigate(`/candidates/app/applications/${applicationId}`);
  }, [applicationId, navigate]);
  const { account, application: application3 } = data;
  const profile = application3?.profile;
  useEffect46(() => {
    log(
      `Loading ApplicationLayout: Account: ${account} Profile: ${profile} Application: ${application3}`,
      LogLevel6.INFO
    );
    if (!account || !profile || !application3) {
      return;
    }
    const state = getApplicationState(
      log,
      application3,
      account,
      profile,
      resumeImportState
    );
    if (state !== "Completed" /* Completed */ && !location2.pathname.includes("apply")) {
      navigate("apply");
    }
    if (state === "Completed" /* Completed */ && location2.pathname.includes("apply")) {
      navigate("info");
    }
  }, [
    account,
    profile,
    application3,
    log,
    resumeImportState,
    location2,
    navigate
  ]);
  if (!account) {
    return /* @__PURE__ */ jsx390("div", { children: "Account Not Created. Please Wait..." });
  }
  if (!profile) {
    return /* @__PURE__ */ jsx390("div", { children: "Profile Not Created. Please Wait..." });
  }
  if (!application3) {
    return /* @__PURE__ */ jsx390("div", { children: "Application Not Created. Please Wait..." });
  }
  return /* @__PURE__ */ jsx390(Suspense133, { fallback: /* @__PURE__ */ jsx390(EdSkeleton106, {}), children: /* @__PURE__ */ jsxs259(Routes6, { children: [
    /* @__PURE__ */ jsx390(
      Route6,
      {
        path: "info",
        element: /* @__PURE__ */ jsx390(DefaultLayout, { showBackButton: defaultPath != "info", children: /* @__PURE__ */ jsx390(ApplicationDetails, { application: application3, tasks: data }) })
      }
    ),
    /* @__PURE__ */ jsx390(
      Route6,
      {
        path: "withdraw",
        element: /* @__PURE__ */ jsx390(DefaultLayout, { showBackButton: true, children: /* @__PURE__ */ jsx390(
          WithdrawApplication,
          {
            applicationId: application3.applicationId,
            applicationVersion: application3.version,
            applicationStateName: application3.applicationStateName,
            employerId: application3.employerId,
            employerName: application3.employerName,
            vacancyName: application3.vacancyName
          },
          application3.__id
        ) })
      }
    ),
    /* @__PURE__ */ jsx390(
      Route6,
      {
        path: "apply",
        element: /* @__PURE__ */ jsx390(Suspense133, { fallback: /* @__PURE__ */ jsx390(EdSkeleton106, {}), children: /* @__PURE__ */ jsx390(
          ApplicationApplyWorkflow,
          {
            accountFragmentRef: account,
            profileFragmentRef: profile,
            applicationFragmentRef: application3,
            onCompleted: () => {
              navigate(`info`);
            },
            onReload
          }
        ) })
      }
    ),
    /* @__PURE__ */ jsx390(
      Route6,
      {
        path: `chats`,
        element: /* @__PURE__ */ jsx390(DefaultLayout, { showBackButton: true, children: /* @__PURE__ */ jsx390(
          ApplicationChat,
          {
            applicationId,
            onSelect: navigateToChat
          }
        ) })
      }
    ),
    /* @__PURE__ */ jsx390(
      Route6,
      {
        path: `chat/:chatId`,
        element: /* @__PURE__ */ jsx390(Suspense133, { fallback: /* @__PURE__ */ jsx390(EdSkeleton106, {}), children: /* @__PURE__ */ jsx390(ApplicationConversationContainer, {}) })
      }
    ),
    /* @__PURE__ */ jsx390(
      Route6,
      {
        path: `tasks`,
        element: /* @__PURE__ */ jsx390(DefaultLayout, { showBackButton: false, children: /* @__PURE__ */ jsx390(Suspense133, { fallback: /* @__PURE__ */ jsx390(EdSkeleton106, {}), children: /* @__PURE__ */ jsx390(
          ApplicationTasksContainer,
          {
            applicationId,
            onSelect: (id18) => {
              navigate(`task/${id18}`);
            }
          }
        ) }) })
      }
    ),
    /* @__PURE__ */ jsx390(
      Route6,
      {
        path: `task/:taskId`,
        element: /* @__PURE__ */ jsx390(Suspense133, { fallback: /* @__PURE__ */ jsx390(EdSkeleton106, {}), children: /* @__PURE__ */ jsx390(
          ApplicationTaskContainer,
          {
            applicationFragmentRef: application3,
            profileFragmentRef: profile,
            onCompleted: onTaskCompleted
          }
        ) })
      }
    ),
    /* @__PURE__ */ jsx390(
      Route6,
      {
        path: "*",
        element: /* @__PURE__ */ jsx390(Navigate15, { to: defaultPath, replace: true })
      }
    )
  ] }) });
};

// src/applications/components/ApplicationContainer.tsx
import { Fragment as Fragment102, jsx as jsx391, jsxs as jsxs260 } from "react/jsx-runtime";
var BreadcrumbLinks2 = ({
  queryRef: queryRef3,
  section
}) => {
  const data = usePreloadedQuery45(
    applicationLayoutQueryDef,
    queryRef3
  );
  if (!data.application) {
    return /* @__PURE__ */ jsx391(Fragment102, {});
  }
  return /* @__PURE__ */ jsx391("div", { className: "flex flex-col-reverse md:flex-col", children: /* @__PURE__ */ jsx391(
    Breadcrumbs7,
    {
      links: [
        { name: section, href: "../../list" },
        {
          name: data.application.vacancyName || "",
          href: ""
        }
      ]
    }
  ) });
};
var MobileHeaderNavigation3 = ({
  queryRef: queryRef3
}) => {
  const data = usePreloadedQuery45(
    applicationLayoutQueryDef,
    queryRef3
  );
  if (!data.application) {
    return /* @__PURE__ */ jsx391(Fragment102, {});
  }
  return /* @__PURE__ */ jsx391("div", { children: /* @__PURE__ */ jsx391(
    MobileHeader5,
    {
      showMobileNavIcon: true,
      title: /* @__PURE__ */ jsx391("div", { className: "flex w-full items-center justify-center lg:justify-between", children: /* @__PURE__ */ jsx391("div", { className: "text-2xl font-bold", children: data.application.vacancyName }) })
    }
  ) });
};
var ApplicationContainer = ({
  candidateId,
  applicationId,
  defaultPath = "info",
  section,
  showExpand = true,
  showMobileNavigation = true
}) => {
  const [queryReference, loadQuery48] = useQueryLoader23(
    applicationLayoutQueryDef
  );
  useEffect47(() => {
    loadQuery48({ candidateId, applicationId, sourceId: applicationId });
  }, [candidateId, applicationId, loadQuery48]);
  const onReload = useCallback215(() => {
    loadQuery48(
      { candidateId, applicationId, sourceId: applicationId },
      { fetchPolicy: "network-only" }
    );
  }, [loadQuery48]);
  if (!queryReference) {
    return /* @__PURE__ */ jsx391("div", { className: "m-8", children: /* @__PURE__ */ jsx391(EdSkeleton107, {}) });
  }
  return /* @__PURE__ */ jsxs260(Suspense134, { fallback: /* @__PURE__ */ jsx391(EdSkeleton107, {}), children: [
    /* @__PURE__ */ jsx391("div", { className: "flex flex-col lg:flex-col-reverse", children: showMobileNavigation && /* @__PURE__ */ jsxs260(Fragment102, { children: [
      /* @__PURE__ */ jsx391(MobileHeaderNavigation3, { queryRef: queryReference }),
      /* @__PURE__ */ jsx391(BreadcrumbLinks2, { queryRef: queryReference, section })
    ] }) }),
    /* @__PURE__ */ jsx391(
      ApplicationLayout,
      {
        defaultPath,
        queryRef: queryReference,
        applicationId,
        onReload
      }
    )
  ] });
};

// src/applications/components/ApplicationContentFocusLayout.tsx
import { useNavigate as useNavigate28 } from "react-router-dom";
import { ChevronLeftIcon as ChevronLeftIcon3 } from "@heroicons/react/24/solid";
import { Button as Button104 } from "shared-ui";
import { jsx as jsx393, jsxs as jsxs261 } from "react/jsx-runtime";
var ApplicationContentFocusLayout = ({ children, title, backLink }) => {
  const navigate = useNavigate28();
  return /* @__PURE__ */ jsxs261("div", { className: "flex flex-grow flex-col", children: [
    /* @__PURE__ */ jsx393("div", { className: "flex items-center space-x-3 rounded-lg border bg-white px-2 py-3", children: /* @__PURE__ */ jsx393("div", { children: /* @__PURE__ */ jsxs261(
      Button104,
      {
        clicked: () => {
          navigate(backLink);
        },
        children: [
          /* @__PURE__ */ jsx393(
            ChevronLeftIcon3,
            {
              className: "h-5 w-5 text-gray-500",
              "aria-hidden": "true"
            }
          ),
          /* @__PURE__ */ jsx393("div", { className: "text-sm text-gray-500", children: title })
        ]
      }
    ) }) }),
    children
  ] });
};

// src/applications/components/__generated__/ApplicationHeader_application.graphql.ts
var node447 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ApplicationHeader_application",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "employerName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vacancyName",
      "storageKey": null
    }
  ],
  "type": "Application",
  "abstractKey": null
};
node447.hash = "e0e61b2fe4afed9d3ba6e129822838b0";
var ApplicationHeader_application_graphql_default = node447;

// src/applications/components/ApplicationHeader.tsx
import { Fragment as Fragment103 } from "react";
import { useFragment as useFragment131 } from "react-relay";
import { Menu as Menu2, Transition as Transition5 } from "@headlessui/react";
import { EllipsisVerticalIcon } from "@heroicons/react/24/solid";
import { classNames as classNames43 } from "shared-ui";
import { jsx as jsx394, jsxs as jsxs263 } from "react/jsx-runtime";
var application = ApplicationHeader_application_graphql_default;
var ApplicationHeader = (props) => {
  const data = useFragment131(application, props.application);
  return /* @__PURE__ */ jsx394("div", { className: "", children: /* @__PURE__ */ jsxs263("div", { className: "sm:flex sm:items-baseline sm:justify-between", children: [
    /* @__PURE__ */ jsxs263("div", { className: "sm:w-0 sm:flex-1", children: [
      /* @__PURE__ */ jsx394(
        "h1",
        {
          id: "message-heading",
          className: "text-lg font-medium text-gray-900",
          children: data.vacancyName
        }
      ),
      /* @__PURE__ */ jsx394("p", { className: "mt-1 truncate text-sm text-gray-500", children: data.employerName })
    ] }),
    /* @__PURE__ */ jsxs263("div", { className: "mt-4 flex items-center justify-between sm:ml-6 sm:mt-0 sm:flex-shrink-0 sm:justify-start", children: [
      /* @__PURE__ */ jsx394("span", { className: "bg-success-100 text-success-800 inline-flex items-center rounded-full px-3 py-0.5 text-sm font-medium", children: "Open" }),
      /* @__PURE__ */ jsxs263(Menu2, { as: "div", className: "relative ml-3 inline-block text-left", children: [
        /* @__PURE__ */ jsx394("div", { children: /* @__PURE__ */ jsxs263(Menu2.Button, { className: "-my-2 flex items-center rounded-full bg-white p-2 text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500", children: [
          /* @__PURE__ */ jsx394("span", { className: "sr-only", children: "Open options" }),
          /* @__PURE__ */ jsx394(EllipsisVerticalIcon, { className: "h-5 w-5", "aria-hidden": "true" })
        ] }) }),
        /* @__PURE__ */ jsx394(
          Transition5,
          {
            as: Fragment103,
            enter: "transition ease-out duration-100",
            enterFrom: "transform opacity-0 scale-95",
            enterTo: "transform opacity-100 scale-100",
            leave: "transition ease-in duration-75",
            leaveFrom: "transform opacity-100 scale-100",
            leaveTo: "transform opacity-0 scale-95",
            children: /* @__PURE__ */ jsx394(Menu2.Items, { className: "absolute right-0 z-40 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none", children: /* @__PURE__ */ jsxs263("div", { className: "py-1", children: [
              /* @__PURE__ */ jsx394(Menu2.Item, { children: ({ active }) => /* @__PURE__ */ jsx394(
                "a",
                {
                  href: "#",
                  className: classNames43(
                    active ? "bg-gray-100 text-gray-900" : "text-gray-700",
                    "flex justify-between px-4 py-2 text-sm"
                  ),
                  children: /* @__PURE__ */ jsx394("span", { children: "Edit" })
                }
              ) }),
              /* @__PURE__ */ jsx394(Menu2.Item, { children: ({ active }) => /* @__PURE__ */ jsx394(
                "a",
                {
                  href: "#",
                  className: classNames43(
                    active ? "bg-gray-100 text-gray-900" : "text-gray-700",
                    "flex justify-between px-4 py-2 text-sm"
                  ),
                  children: /* @__PURE__ */ jsx394("span", { children: "Duplicate" })
                }
              ) }),
              /* @__PURE__ */ jsx394(Menu2.Item, { children: ({ active }) => /* @__PURE__ */ jsx394(
                "button",
                {
                  type: "button",
                  className: classNames43(
                    active ? "bg-gray-100 text-gray-900" : "text-gray-700",
                    "flex w-full justify-between px-4 py-2 text-sm"
                  ),
                  children: /* @__PURE__ */ jsx394("span", { children: "Archive" })
                }
              ) })
            ] }) })
          }
        )
      ] })
    ] })
  ] }) });
};

// src/applications/components/__generated__/ApplicationItem_application.graphql.ts
var node448 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ApplicationItem_application",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "applicationId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "employerName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vacancyName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "applicationStateName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "workflowStateName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Vacancy",
      "kind": "LinkedField",
      "name": "vacancy",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Application",
  "abstractKey": null
};
node448.hash = "fb689c95189fa2140598dd4643577f5e";
var ApplicationItem_application_graphql_default = node448;

// src/applications/components/ApplicationItem.tsx
import { useFragment as useFragment133 } from "react-relay";
import { parseDate as parseDate17, timeAgo as timeAgo9 } from "shared-lib";
import { jsx as jsx395, jsxs as jsxs264 } from "react/jsx-runtime";
var application2 = ApplicationItem_application_graphql_default;
var ApplicationItem = (props) => {
  const data = useFragment133(application2, props.application);
  return /* @__PURE__ */ jsxs264(
    "li",
    {
      className: "focus-within:ring-info-600 relative cursor-pointer bg-white px-6 py-5 focus-within:ring-2 focus-within:ring-inset hover:bg-gray-50",
      children: [
        /* @__PURE__ */ jsxs264("div", { className: "flex justify-between space-x-3", children: [
          /* @__PURE__ */ jsx395("div", { className: "min-w-0 flex-1", children: /* @__PURE__ */ jsxs264("a", { onClick: props.selected, className: "block focus:outline-none", children: [
            /* @__PURE__ */ jsx395("span", { className: "absolute inset-0", "aria-hidden": "true" }),
            /* @__PURE__ */ jsx395("p", { className: "truncate text-sm font-medium text-gray-900", children: data.employerName }),
            /* @__PURE__ */ jsx395("p", { className: "truncate text-sm text-gray-500", children: data.workflowStateName })
          ] }) }),
          /* @__PURE__ */ jsx395(
            "time",
            {
              dateTime: data.vacancy.createdAt,
              className: "flex-shrink-0 whitespace-nowrap text-sm text-gray-500",
              children: timeAgo9(parseDate17(data.vacancy.createdAt))
            }
          )
        ] }),
        /* @__PURE__ */ jsx395("div", { className: "mt-1", children: /* @__PURE__ */ jsx395("p", { className: "line-clamp-2 text-sm text-gray-600", children: data.vacancyName }) })
      ]
    },
    data.applicationId
  );
};

// src/applications/components/__generated__/ApplicationListPaginationQuery.graphql.ts
var node449 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 15,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": {
        "createdAt": "DESC"
      },
      "kind": "LocalArgument",
      "name": "sort"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v23 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v32 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }, v4 = [
    v1,
    v23,
    {
      "kind": "Variable",
      "name": "order",
      "variableName": "sort"
    },
    v32
  ], v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "employerName",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ApplicationListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v23,
            {
              "kind": "Variable",
              "name": "sort",
              "variableName": "sort"
            },
            v32
          ],
          "kind": "FragmentSpread",
          "name": "ApplicationList_applications"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ApplicationListPaginationQuery",
      "selections": [
        {
          "alias": null,
          "args": v4,
          "concreteType": "ApplicationsConnection",
          "kind": "LinkedField",
          "name": "applications",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ApplicationsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Application",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v5,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "applicationId",
                      "storageKey": null
                    },
                    v6,
                    v7,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "vacancyName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasCompletedDocumentTypes",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasCompletedForms",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasCompletedOptionalSkills",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasCompletedRate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasCompletedRequiredSkills",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "applicationStateName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Vacancy",
                      "kind": "LinkedField",
                      "name": "vacancy",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        },
                        v6,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "employerLogoUrl",
                          "storageKey": null
                        },
                        v7,
                        v5,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "createdAt",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "version",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "workflowStateName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": v4,
          "filters": [],
          "handle": "connection",
          "key": "ApplicationList_applications",
          "kind": "LinkedHandle",
          "name": "applications"
        }
      ]
    },
    "params": {
      "cacheID": "bf1ea7b43da4fae9c771ad567143e524",
      "id": null,
      "metadata": {},
      "name": "ApplicationListPaginationQuery",
      "operationKind": "query",
      "text": "query ApplicationListPaginationQuery(\n  $after: String\n  $first: Int = 15\n  $sort: [ApplicationSort!] = {createdAt: DESC}\n  $where: ApplicationFilter\n) {\n  ...ApplicationList_applications_5yRcm\n}\n\nfragment ApplicationItem_application on Application {\n  id\n  applicationId\n  version\n  employerName\n  vacancyName\n  applicationStateName\n  workflowStateName\n  vacancy {\n    createdAt\n    id\n  }\n}\n\nfragment ApplicationList_applications_5yRcm on Query {\n  applications(first: $first, after: $after, where: $where, order: $sort) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        applicationId\n        code\n        employerName\n        vacancyName\n        hasCompletedDocumentTypes\n        hasCompletedForms\n        hasCompletedOptionalSkills\n        hasCompletedRate\n        hasCompletedRequiredSkills\n        applicationStateName\n        vacancy {\n          name\n          code\n          employerLogoUrl\n          employerName\n          id\n        }\n        ...ApplicationItem_application\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node449.hash = "f675b4835a16363c3928559185642726";
var ApplicationListPaginationQuery_graphql_default = node449;

// src/applications/components/__generated__/ApplicationList_applications.graphql.ts
var node450 = function() {
  var v0 = [
    "applications"
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "employerName",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 15,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "defaultValue": {
          "createdAt": "DESC"
        },
        "kind": "LocalArgument",
        "name": "sort"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": ApplicationListPaginationQuery_graphql_default
      }
    },
    "name": "ApplicationList_applications",
    "selections": [
      {
        "alias": "applications",
        "args": null,
        "concreteType": "ApplicationsConnection",
        "kind": "LinkedField",
        "name": "__ApplicationList_applications_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ApplicationsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Application",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "applicationId",
                    "storageKey": null
                  },
                  v1,
                  v23,
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "vacancyName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasCompletedDocumentTypes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasCompletedForms",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasCompletedOptionalSkills",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasCompletedRate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasCompletedRequiredSkills",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "applicationStateName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Vacancy",
                    "kind": "LinkedField",
                    "name": "vacancy",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      v1,
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "employerLogoUrl",
                        "storageKey": null
                      },
                      v23
                    ],
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ApplicationItem_application"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node450.hash = "f675b4835a16363c3928559185642726";
var ApplicationList_applications_graphql_default = node450;

// src/applications/components/__generated__/ApplicationList_JobTitles.graphql.ts
var node451 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ApplicationList_JobTitles",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ApplicationSearchResultItem",
      "kind": "LinkedField",
      "name": "resultItems",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ApplicationAutoCompleteSearchResult",
  "abstractKey": null
};
node451.hash = "246976ed8a4b6a3819b6713a96fd5558";
var ApplicationList_JobTitles_graphql_default = node451;

// src/applications/components/__generated__/ApplicationList_employers.graphql.ts
var node453 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ApplicationList_employers",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ApplicationSearchResultItem",
      "kind": "LinkedField",
      "name": "resultItems",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ApplicationAutoCompleteSearchResult",
  "abstractKey": null
};
node453.hash = "14a9032b86dcff948712f6382e0476c0";
var ApplicationList_employers_graphql_default = node453;

// src/applications/components/ApplicationList.tsx
import { useCallback as useCallback216, useEffect as useEffect48 } from "react";
import { useForm as useForm23 } from "react-hook-form";
import { useFragment as useFragment134, usePaginationFragment as usePaginationFragment20 } from "react-relay";
import { BuildingOffice2Icon as BuildingOffice2Icon2 } from "@heroicons/react/24/outline";
import {
  Button as Button105,
  SectionedLayout as SectionedLayout5,
  SelectMenuInput as SelectMenuInput3,
  Size as Size53,
  Tag as Tag25
} from "shared-ui";
import { isNotNullOrUndefined as isNotNullOrUndefined11, noop as noop19 } from "shared-lib";
import { allListObject, withAll } from "shared-ui";
import { Fragment as Fragment104, jsx as jsx396, jsxs as jsxs265 } from "react/jsx-runtime";
var applicationStateValues = [
  {
    id: "ALL",
    name: "All"
  },
  {
    id: "ACTIVE",
    name: "Active"
  },
  {
    id: "CREATED",
    name: "Created"
  },
  {
    id: "HIRED",
    name: "Hired"
  },
  {
    id: "SUBMITTED",
    name: "Submitted"
  },
  {
    id: "UNSUCCESSFUL",
    name: "Unsuccessful"
  },
  {
    id: "WITHDRAWN",
    name: "Withdrawn"
  }
];
var applicationSortValues3 = [
  {
    id: "MOST_RECENT",
    name: "Most Recent"
  },
  {
    id: "LEAST_RECENT",
    name: "Least Recent"
  },
  {
    id: "EMPLOYER",
    name: "Employer"
  },
  {
    id: "VACANCY_NAME",
    name: "Vacancy Name"
  }
];
var fragment14 = ApplicationList_applications_graphql_default;
var jobTitlefragment = ApplicationList_JobTitles_graphql_default;
var employersFragment = ApplicationList_employers_graphql_default;
var ApplicationList = ({
  candidateId,
  fragmentRef,
  jobTitlesFragmentRef,
  employersFragmentRef,
  defaultPath = "info",
  title: sectionTitle = "Applications"
}) => {
  const { data, loadNext, hasNext, isLoadingNext, refetch } = usePaginationFragment20(fragment14, fragmentRef);
  const jobTitles = useFragment134(
    jobTitlefragment,
    jobTitlesFragmentRef
  );
  const employers = useFragment134(
    employersFragment,
    employersFragmentRef
  );
  const { applications } = data;
  const sections = (applications?.edges || []).filter(isNotNullOrUndefined11).map(({ node: node566 }) => {
    const title = `${node566.vacancy.name} - ${node566.vacancy.code}`;
    return {
      key: node566.applicationId,
      listSubtitle: node566.employerName,
      highlight: !(node566.hasCompletedDocumentTypes && node566.hasCompletedForms && node566.hasCompletedOptionalSkills && node566.hasCompletedRate && node566.hasCompletedRequiredSkills),
      listTitle: /* @__PURE__ */ jsxs265("div", { className: "flex flex-col gap-1", children: [
        /* @__PURE__ */ jsx396("div", { className: "items-top text-primary-900 flex w-full justify-between gap-2", children: /* @__PURE__ */ jsx396("div", { children: node566.vacancy.name }) }),
        /* @__PURE__ */ jsxs265("div", { className: "flex w-full grow justify-between text-sm text-gray-900", children: [
          node566.vacancy.employerName,
          /* @__PURE__ */ jsx396(
            Tag25,
            {
              size: "xsmall",
              color: ((x4) => {
                if (x4 === "Active")
                  return "bg-green-400 text-black";
                return "bg-gray-200 text-gray-800";
              })(node566.applicationStateName),
              children: node566.applicationStateName
            }
          )
        ] })
      ] }),
      itemTitle: /* @__PURE__ */ jsxs265("div", { className: "flex grow flex-col flex-col-reverse items-center justify-end lg:flex-row lg:justify-between xl:w-full", children: [
        /* @__PURE__ */ jsxs265("div", { className: "flex w-full items-center justify-end gap-2 md:justify-start xl:w-auto xl:flex-row-reverse", children: [
          !node566.vacancy.employerLogoUrl && /* @__PURE__ */ jsx396("div", { className: "text-xl font-bold text-gray-800", children: node566.vacancy.employerName }),
          /* @__PURE__ */ jsxs265("div", { className: "hidden lg:flex", children: [
            node566.vacancy.employerLogoUrl && /* @__PURE__ */ jsx396(
              "img",
              {
                src: node566.vacancy.employerLogoUrl,
                alt: node566.vacancy.employerName,
                className: `flex h-[40px] self-end`
              }
            ),
            !node566.vacancy.employerLogoUrl && /* @__PURE__ */ jsx396(BuildingOffice2Icon2, { className: "flex h-[40px] self-end stroke-gray-800" })
          ] })
        ] }),
        /* @__PURE__ */ jsx396("div", { className: "flex w-full grow justify-center text-center font-bold md:text-right lg:justify-end", children: /* @__PURE__ */ jsx396("h1", { className: "line-clamp-1", children: title }) })
      ] }),
      icon: () => {
        let logo = /* @__PURE__ */ jsx396("img", { src: node566.vacancy.employerLogoUrl, className: "w-full" });
        if (node566.vacancy.employerLogoUrl == null) {
          logo = /* @__PURE__ */ jsx396(BuildingOffice2Icon2, { className: "h-5 w-5" });
        }
        return /* @__PURE__ */ jsx396("div", { className: "flex h-[30px] w-[30px] items-center justify-center", children: logo });
      },
      iconForeground: "text-primary-700",
      iconBackground: "bg-gray-100",
      element: /* @__PURE__ */ jsx396(
        ApplicationContainer,
        {
          showMobileNavigation: false,
          section: sectionTitle,
          defaultPath,
          candidateId,
          applicationId: node566.applicationId
        }
      )
    };
  });
  const loadMore = useCallback216(() => {
    if (isLoadingNext) {
      return;
    }
    loadNext(5);
  }, [isLoadingNext, loadNext]);
  const { control, watch, getValues, reset } = useForm23();
  const applicationStateField = watch("application-state");
  const applicationSortField = watch("sort");
  const employerNameField = watch("employer-name");
  const vacancyNameField = watch("vacancy-name");
  useEffect48(() => {
    let sort = {};
    switch (applicationSortField) {
      case "EMPLOYER":
        sort = { employerName: "ASC" };
        break;
      case "VACANCY_NAME":
        sort = { vacancyName: "ASC" };
        break;
      case "MOST_RECENT":
        sort = { createdAt: "DESC" };
        break;
      case "LEAST_RECENT":
        sort = { createdAt: "ASC" };
        break;
    }
    const queryIfHasValue = ({
      field,
      value
    }) => value === void 0 || value === "ALL" ? {} : { [field]: { eq: value } };
    const and = [
      queryIfHasValue({ field: "vacancyName", value: vacancyNameField }),
      queryIfHasValue({ field: "employerName", value: employerNameField }),
      queryIfHasValue({
        field: "applicationState",
        value: applicationStateField
      })
    ];
    refetch(
      {
        where: {
          and
        },
        sort: [sort]
      },
      {
        fetchPolicy: "store-and-network"
      }
    );
  }, [
    refetch,
    applicationStateField,
    applicationSortField,
    vacancyNameField,
    employerNameField
  ]);
  const jobTitlesList = withAll(
    jobTitles.resultItems.map(({ name }) => ({
      id: name,
      name
    }))
  );
  const employersNameList = withAll(
    employers.resultItems.map(({ name }) => ({
      id: name,
      name
    }))
  );
  const expandLink = (id18) => sectionTitle === "Applications" ? `../../application/${id18}/info` : `../../task/${id18}/tasks`;
  return /* @__PURE__ */ jsx396(Fragment104, { children: /* @__PURE__ */ jsx396(
    SectionedLayout5,
    {
      expandLink,
      title: sectionTitle,
      sections,
      loadMore: hasNext ? loadMore : noop19,
      isLoading: isLoadingNext && hasNext,
      showFilters: true,
      children: /* @__PURE__ */ jsx396(SectionedLayout5.Filters, { children: /* @__PURE__ */ jsx396("div", { className: "bg-secondary-50 relative z-10", children: /* @__PURE__ */ jsx396("div", { className: "", children: /* @__PURE__ */ jsxs265("div", { className: "flex w-screen max-w-sm flex-auto flex-col gap-5 p-4 text-sm leading-6", children: [
        /* @__PURE__ */ jsx396("div", { className: "", children: /* @__PURE__ */ jsx396(Button105, { color: "primary", size: Size53.sm, onClick: reset, children: "Clear filters" }) }),
        /* @__PURE__ */ jsxs265("div", { className: "flex justify-between gap-5", children: [
          /* @__PURE__ */ jsx396("h1", { className: "text-md w-12 font-bold", children: "Filter" }),
          /* @__PURE__ */ jsxs265("div", { className: "flex grow flex-col gap-3", children: [
            /* @__PURE__ */ jsxs265("div", { className: "relative rounded-lg ", children: [
              /* @__PURE__ */ jsx396("div", { className: "font-semibold text-gray-900", children: "Employer Name" }),
              /* @__PURE__ */ jsx396(
                SelectMenuInput3,
                {
                  name: "employer-name",
                  title: "",
                  items: employersNameList,
                  control,
                  disabled: false,
                  selectedItem: employersNameList.filter(
                    (x4) => x4.id == getValues("employer-name")
                  )[0] || allListObject
                }
              )
            ] }),
            /* @__PURE__ */ jsxs265("div", { className: "relative rounded-lg  ", children: [
              /* @__PURE__ */ jsx396("div", { className: "font-semibold text-gray-900", children: "Vacancy Name" }),
              /* @__PURE__ */ jsx396(
                SelectMenuInput3,
                {
                  name: "vacancy-name",
                  title: "",
                  items: jobTitlesList,
                  control,
                  disabled: false,
                  selectedItem: jobTitlesList.filter(
                    (x4) => x4.id == getValues("vacancy-name")
                  )[0] || allListObject
                }
              )
            ] }),
            /* @__PURE__ */ jsxs265("div", { className: "relative rounded-lg ", children: [
              /* @__PURE__ */ jsx396("div", { className: "font-semibold text-gray-900", children: "Application State" }),
              /* @__PURE__ */ jsx396(
                SelectMenuInput3,
                {
                  name: "application-state",
                  title: "",
                  items: applicationStateValues,
                  selectedItem: applicationStateValues.filter(
                    (x4) => x4.id == getValues("application-state")
                  )[0] || applicationStateValues[0],
                  control,
                  disabled: false
                }
              )
            ] })
          ] })
        ] }),
        /* @__PURE__ */ jsxs265("div", { className: "flex justify-between gap-5", children: [
          /* @__PURE__ */ jsx396("h1", { className: "text-md w-12 font-bold", children: "Sort" }),
          /* @__PURE__ */ jsx396("div", { className: "flex grow flex-col gap-3", children: /* @__PURE__ */ jsxs265("div", { className: "relative rounded-lg ", children: [
            /* @__PURE__ */ jsx396("div", { className: "font-semibold text-gray-900" }),
            /* @__PURE__ */ jsx396(
              SelectMenuInput3,
              {
                name: "sort",
                title: "",
                items: applicationSortValues3,
                selectedItem: applicationSortValues3.filter(
                  (x4) => x4.id == getValues("sort")
                )[0] || applicationSortValues3[0],
                control,
                disabled: false
              }
            )
          ] }) })
        ] })
      ] }) }) }) })
    }
  ) });
};

// src/applications/components/__generated__/ApplicationsContainerQuery.graphql.ts
var node454 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "candidateId"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "candidateId",
    "variableName": "candidateId"
  }, v23 = {
    "kind": "Literal",
    "name": "searchTerm",
    "value": ""
  }, v32 = [
    v1,
    v23,
    {
      "kind": "Literal",
      "name": "searchType",
      "value": "JOB_TITLE"
    }
  ], v4 = [
    v1,
    v23,
    {
      "kind": "Literal",
      "name": "searchType",
      "value": "EMPLOYER"
    }
  ], v5 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 15
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": {
        "createdAt": "DESC"
      }
    }
  ], v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "employerName",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v10 = [
    {
      "alias": null,
      "args": null,
      "concreteType": "ApplicationSearchResultItem",
      "kind": "LinkedField",
      "name": "resultItems",
      "plural": true,
      "selections": [
        v9
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ApplicationsContainerQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ApplicationList_applications"
        },
        {
          "alias": "jobTitles",
          "args": v32,
          "concreteType": "ApplicationAutoCompleteSearchResult",
          "kind": "LinkedField",
          "name": "searchApplications",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ApplicationList_JobTitles"
            }
          ],
          "storageKey": null
        },
        {
          "alias": "employers",
          "args": v4,
          "concreteType": "ApplicationAutoCompleteSearchResult",
          "kind": "LinkedField",
          "name": "searchApplications",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ApplicationList_employers"
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ApplicationsContainerQuery",
      "selections": [
        {
          "alias": null,
          "args": v5,
          "concreteType": "ApplicationsConnection",
          "kind": "LinkedField",
          "name": "applications",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ApplicationsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Application",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v6,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "applicationId",
                      "storageKey": null
                    },
                    v7,
                    v8,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "vacancyName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasCompletedDocumentTypes",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasCompletedForms",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasCompletedOptionalSkills",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasCompletedRate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasCompletedRequiredSkills",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "applicationStateName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Vacancy",
                      "kind": "LinkedField",
                      "name": "vacancy",
                      "plural": false,
                      "selections": [
                        v9,
                        v7,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "employerLogoUrl",
                          "storageKey": null
                        },
                        v8,
                        v6,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "createdAt",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "version",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "workflowStateName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": 'applications(first:15,order:{"createdAt":"DESC"})'
        },
        {
          "alias": null,
          "args": v5,
          "filters": [],
          "handle": "connection",
          "key": "ApplicationList_applications",
          "kind": "LinkedHandle",
          "name": "applications"
        },
        {
          "alias": "jobTitles",
          "args": v32,
          "concreteType": "ApplicationAutoCompleteSearchResult",
          "kind": "LinkedField",
          "name": "searchApplications",
          "plural": false,
          "selections": v10,
          "storageKey": null
        },
        {
          "alias": "employers",
          "args": v4,
          "concreteType": "ApplicationAutoCompleteSearchResult",
          "kind": "LinkedField",
          "name": "searchApplications",
          "plural": false,
          "selections": v10,
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "9799e6fe716428c5f094465e40f303db",
      "id": null,
      "metadata": {},
      "name": "ApplicationsContainerQuery",
      "operationKind": "query",
      "text": 'query ApplicationsContainerQuery(\n  $candidateId: UUID!\n) {\n  ...ApplicationList_applications\n  jobTitles: searchApplications(candidateId: $candidateId, searchType: JOB_TITLE, searchTerm: "") {\n    ...ApplicationList_JobTitles\n  }\n  employers: searchApplications(candidateId: $candidateId, searchType: EMPLOYER, searchTerm: "") {\n    ...ApplicationList_employers\n  }\n}\n\nfragment ApplicationItem_application on Application {\n  id\n  applicationId\n  version\n  employerName\n  vacancyName\n  applicationStateName\n  workflowStateName\n  vacancy {\n    createdAt\n    id\n  }\n}\n\nfragment ApplicationList_JobTitles on ApplicationAutoCompleteSearchResult {\n  resultItems {\n    name\n  }\n}\n\nfragment ApplicationList_applications on Query {\n  applications(first: 15, order: {createdAt: DESC}) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        applicationId\n        code\n        employerName\n        vacancyName\n        hasCompletedDocumentTypes\n        hasCompletedForms\n        hasCompletedOptionalSkills\n        hasCompletedRate\n        hasCompletedRequiredSkills\n        applicationStateName\n        vacancy {\n          name\n          code\n          employerLogoUrl\n          employerName\n          id\n        }\n        ...ApplicationItem_application\n        __typename\n      }\n    }\n  }\n}\n\nfragment ApplicationList_employers on ApplicationAutoCompleteSearchResult {\n  resultItems {\n    name\n  }\n}\n'
    }
  };
}();
node454.hash = "d26358d0b959fe321b93ddfd200c82c8";
var ApplicationsContainerQuery_graphql_default = node454;

// src/applications/components/ApplicationsContainer.tsx
import { Suspense as Suspense135 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery61 } from "react-relay";
import { EdSkeleton as EdSkeleton108 } from "shared-ui";
import { jsx as jsx397 } from "react/jsx-runtime";
var graphqlQuery12 = ApplicationsContainerQuery_graphql_default;
var ApplicationsContainer = ({
  candidateId,
  defaultPath = "info",
  title = "Applications"
}) => {
  const query3 = useLazyLoadQuery61(
    graphqlQuery12,
    {
      candidateId
    },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsx397(Suspense135, { fallback: /* @__PURE__ */ jsx397(EdSkeleton108, {}), children: /* @__PURE__ */ jsx397(
    ApplicationList,
    {
      title,
      candidateId,
      fragmentRef: query3,
      jobTitlesFragmentRef: query3.jobTitles,
      employersFragmentRef: query3.employers,
      defaultPath
    }
  ) });
};

// src/applications/components/ApplicationsPagination.tsx
import { ChevronDownIcon as ChevronDownIcon3, ChevronUpIcon as ChevronUpIcon2 } from "@heroicons/react/24/solid";
import { jsx as jsx398, jsxs as jsxs266 } from "react/jsx-runtime";
var ApplicationsPagination = () => {
  return /* @__PURE__ */ jsx398("nav", { "aria-label": "Pagination", children: /* @__PURE__ */ jsxs266("span", { className: "relative z-0 inline-flex rounded-md shadow-sm", children: [
    /* @__PURE__ */ jsxs266(
      "a",
      {
        href: "#",
        className: "focus:ring-info-600 focus:border-info-600 relative inline-flex items-center rounded-l-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1",
        children: [
          /* @__PURE__ */ jsx398("span", { className: "sr-only", children: "Next" }),
          /* @__PURE__ */ jsx398(ChevronUpIcon2, { className: "h-5 w-5", "aria-hidden": "true" })
        ]
      }
    ),
    /* @__PURE__ */ jsxs266(
      "a",
      {
        href: "#",
        className: "focus:ring-info-600 focus:border-info-600 relative -ml-px inline-flex items-center rounded-r-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1",
        children: [
          /* @__PURE__ */ jsx398("span", { className: "sr-only", children: "Previous" }),
          /* @__PURE__ */ jsx398(ChevronDownIcon3, { className: "h-5 w-5", "aria-hidden": "true" })
        ]
      }
    )
  ] }) });
};

// src/applications/components/ApplicationToolbar.tsx
import { jsx as jsx399, jsxs as jsxs267 } from "react/jsx-runtime";
var ApplicationToolbar = () => {
  return /* @__PURE__ */ jsx399("div", { className: "flex h-16 flex-col justify-center", children: /* @__PURE__ */ jsx399("div", { className: "px-4 sm:px-6 lg:px-8", children: /* @__PURE__ */ jsxs267("div", { className: "flex justify-between py-3", children: [
    /* @__PURE__ */ jsx399(ApplicationButtons, {}),
    /* @__PURE__ */ jsx399(ApplicationsPagination, {})
  ] }) }) });
};

// src/applications/components/ApplicationWorkflow.tsx
import { useMachine as useMachine2 } from "@xstate/react";
import { createMachine as createMachine2 } from "xstate";
import { jsx as jsx400, jsxs as jsxs268 } from "react/jsx-runtime";
var machine2 = createMachine2({
  id: "applicationWorkflow",
  initial: "listing",
  states: {
    view: {
      id: "view",
      on: {
        VIEW: { target: "view" }
      }
    },
    created: {
      id: "created",
      on: {
        VIEW: { target: "view" }
      }
    },
    submitted: {
      id: "submitted",
      on: {
        VIEW: { target: "view" }
      }
    },
    active: {
      initial: "active",
      on: {
        VIEW: { target: "view" }
      }
    },
    closed: {
      id: "closed",
      on: {
        VIEW: { target: "view" }
      }
    },
    hired: {
      id: "hired",
      on: {
        VIEW: { target: "view" }
      }
    }
  }
});
var ApplicationWorkflow = ({
  application: application3
}) => {
  const [state, send] = useMachine2(machine2);
  return /* @__PURE__ */ jsxs268("div", { children: [
    /* @__PURE__ */ jsx400("h1", { children: "Application Workflow" }),
    state.matches("view") && /* @__PURE__ */ jsx400("div", {}),
    state.matches("active") && /* @__PURE__ */ jsx400("div", {})
  ] });
};

// src/availability/components/__generated__/AvailabilityCalendarQuery.graphql.ts
var node455 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "refId"
    }
  ], v1 = [
    {
      "alias": "rules",
      "args": [
        {
          "kind": "Variable",
          "name": "referenceId",
          "variableName": "refId"
        }
      ],
      "concreteType": "AvailabilityRules",
      "kind": "LinkedField",
      "name": "recruitAvailabilityRulesByReferenceId",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "availabilityRulesId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "employerId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "refId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "refName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AvailabilityRule",
          "kind": "LinkedField",
          "name": "rules",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "date",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AvailabilityRuleInterval",
              "kind": "LinkedField",
              "name": "intervals",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "from",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "to",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "type",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "weekday",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "timeZone",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "AvailabilityCalendarQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "AvailabilityCalendarQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "bd91fac7568dfb60909b7222695f21b7",
      "id": null,
      "metadata": {},
      "name": "AvailabilityCalendarQuery",
      "operationKind": "query",
      "text": "query AvailabilityCalendarQuery(\n  $refId: UUID!\n) {\n  rules: recruitAvailabilityRulesByReferenceId(referenceId: $refId) {\n    id\n    availabilityRulesId\n    employerId\n    refId\n    refName\n    rules {\n      date\n      intervals {\n        from\n        to\n      }\n      type\n      weekday\n    }\n    timeZone\n  }\n}\n"
    }
  };
}();
node455.hash = "89cd740240aabcd83865bae15acd2f42";
var AvailabilityCalendarQuery_graphql_default = node455;

// src/availability/components/AvailabilityCalendar.tsx
import { useCallback as useCallback218, useState as useState113 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery63 } from "react-relay";
import { ErrorBoundary as ErrorBoundary6 } from "react-error-boundary";
import { getDate, format as format20, isToday as isToday2 } from "date-fns";
import { getTimeZoneOrDefault } from "shared-lib";
import { Button as Button107, Tag as Tag26, classNames as classNames44 } from "shared-ui";
import {
  ErrorBoundaryFallback as ErrorBoundaryFallback5,
  useUserSessionContext as useUserSessionContext7
} from "app-core";

// src/availability/lib/AvailabilityCalendar.ts
import {
  addDays,
  format as format18,
  isSameDay as isSameDay2,
  startOfDay,
  startOfWeek,
  subWeeks
} from "date-fns";
import { parseDate as parseDate18 } from "shared-lib";

// src/availability/lib/AvailabilityRules.ts
function defaultAvailabilityRule(weekday) {
  const rule = new AvailabilityRule("WEEKDAY", weekday, null, [
    { from: "09:00", to: "17:00" }
  ]);
  return rule;
}
var AvailabilityRule = class {
  constructor(type, weekday, date, intervals) {
    this.type = type;
    this.weekday = weekday;
    this.date = date;
    this.intervals = intervals;
  }
};
function buildRules(data) {
  const rules = [];
  (data.rules || []).forEach((item) => {
    const rule = new AvailabilityRule(
      item.type,
      item.weekday,
      item.date,
      item.intervals
    );
    rules.push(rule);
  });
  return rules;
}

// src/availability/lib/AvailabilityCalendar.ts
var weekdayToRuleIndexMap = {};
weekdayToRuleIndexMap["SUNDAY" /* Sunday */] = 0;
weekdayToRuleIndexMap["MONDAY" /* Monday */] = 1;
weekdayToRuleIndexMap["TUESDAY" /* Tuesday */] = 2;
weekdayToRuleIndexMap["WEDNESDAY" /* Wednesday */] = 3;
weekdayToRuleIndexMap["THURSDAY" /* Thursday */] = 4;
weekdayToRuleIndexMap["FRIDAY" /* Friday */] = 5;
weekdayToRuleIndexMap["SATURDAY" /* Saturday */] = 6;
var numberOfWeeks = 4;
var now = /* @__PURE__ */ new Date();
var defaultRules = [
  defaultAvailabilityRule("MONDAY" /* Monday */),
  defaultAvailabilityRule("TUESDAY" /* Tuesday */),
  defaultAvailabilityRule("WEDNESDAY" /* Wednesday */),
  defaultAvailabilityRule("THURSDAY" /* Thursday */),
  defaultAvailabilityRule("FRIDAY" /* Friday */)
];
function getWeekday(date) {
  switch (date.getDay()) {
    case 0:
      return "SUNDAY" /* Sunday */;
    case 1:
      return "MONDAY" /* Monday */;
    case 2:
      return "TUESDAY" /* Tuesday */;
    case 3:
      return "WEDNESDAY" /* Wednesday */;
    case 4:
      return "THURSDAY" /* Thursday */;
    case 5:
      return "FRIDAY" /* Friday */;
    case 6:
      return "SATURDAY" /* Saturday */;
  }
  throw Error(`Unknown Day Value: ${date.getDay()}`);
}
function pairDaysWithRules(weeks, rules) {
  weeks.forEach((week) => {
    week.days.forEach((day) => {
      const date = day.date;
      day.rule = rules[date.valueOf()] || rules[date.getDay()];
    });
  });
}
function calculateWeekToDisplay(currentDate) {
  const weekdaysDisplay = [];
  const date = startOfWeek(currentDate);
  for (let i4 = 0; i4 < 7; i4++) {
    const weekDay = addDays(date, i4);
    weekdaysDisplay.push(format18(parseDate18(weekDay), "EEE"));
  }
  return weekdaysDisplay;
}
function createRules(availabilityRules) {
  const rules = {};
  function createRule(rule) {
    if (rule.type === "WEEKDAY" /* Weekday */ && rule.weekday != null) {
      const index2 = weekdayToRuleIndexMap[rule.weekday];
      rules[index2] = rule;
    } else if (rule.date != null) {
      const index2 = parseDate18(rule.date).valueOf();
      rules[index2] = rule;
    } else {
      throw Error(`Cannot Process Rule: ${JSON.stringify(rule)}`);
    }
  }
  if (availabilityRules && availabilityRules.length > 0) {
    availabilityRules.forEach((rule) => {
      createRule(rule);
    });
  } else {
    defaultRules.forEach((rule) => {
      createRule(rule);
    });
  }
  return rules;
}
function nextWeeks(calendar) {
  return addDays(calendar.lastDay, 1);
}
function prevWeeks(calendar) {
  return subWeeks(calendar.firstDay, numberOfWeeks);
}
function createCalendar(startingWeekDate = /* @__PURE__ */ new Date(), rules) {
  const weeks = [];
  const today = startOfDay(now);
  let date = startOfWeek(startingWeekDate);
  for (let w4 = 0; w4 < numberOfWeeks; w4++) {
    const week = {
      id: w4,
      days: []
    };
    for (let i4 = 0; i4 < 7; i4++) {
      let day;
      if (isSameDay2(date, today)) {
        day = "TODAY";
      } else {
        if (date.getUTCDate() === 1) {
          day = format18(parseDate18(date), "d MMM");
        }
      }
      const calendarDay = {
        date,
        day
      };
      week.days.push(calendarDay);
      date = addDays(date, 1);
    }
    weeks.push(week);
  }
  pairDaysWithRules(weeks, rules);
  const lastWeek = weeks[weeks.length - 1];
  const lastCalendarDay = lastWeek.days[lastWeek.days.length - 1];
  const firstDay = weeks[0].days[0].date;
  const lastDay = lastCalendarDay.date;
  const calendar = {
    weekdaysDisplay: calculateWeekToDisplay(startingWeekDate),
    weeks,
    rules,
    firstDay,
    lastDay
  };
  return calendar;
}
function applyToWeekdays(calendar, weekdays, intervals) {
  weekdays.forEach((weekdayOrDate) => {
    let weekday;
    if (weekdayOrDate instanceof Date) {
      weekday = getWeekday(weekdayOrDate);
    } else {
      weekday = weekdayOrDate;
    }
    const rule = new AvailabilityRule(
      "WEEKDAY" /* Weekday */,
      weekday,
      null,
      intervals || []
    );
    const index2 = weekdayToRuleIndexMap[weekday];
    calendar.rules[index2] = rule;
  });
  pairDaysWithRules(calendar.weeks, calendar.rules);
}
function applyToDays(calendar, days, intervals) {
  days.forEach((day) => {
    const rule = new AvailabilityRule(
      "DATE" /* Date */,
      null,
      format18(parseDate18(day), "yyyy-MM-dd"),
      intervals || []
    );
    const index2 = day.valueOf();
    calendar.rules[index2] = rule;
  });
  pairDaysWithRules(calendar.weeks, calendar.rules);
}

// src/availability/mutations/__generated__/UseAvailabilitySetRulesMutation.graphql.ts
var node456 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfAvailabilityRules",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AvailabilityRules",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "availabilityRulesId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "refId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "refName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AvailabilityRule",
            "kind": "LinkedField",
            "name": "rules",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "date",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AvailabilityRuleInterval",
                "kind": "LinkedField",
                "name": "intervals",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "from",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "to",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "weekday",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timeZone",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v32 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseAvailabilitySetRulesMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitAvailabilitySetRulesPayload",
          "kind": "LinkedField",
          "name": "recruitAvailabilitySetRules",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseAvailabilitySetRulesMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitAvailabilitySetRulesPayload",
          "kind": "LinkedField",
          "name": "recruitAvailabilitySetRules",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "9755912ada12ae9242cabeff327f2fb1",
      "id": null,
      "metadata": {},
      "name": "UseAvailabilitySetRulesMutation",
      "operationKind": "mutation",
      "text": "mutation UseAvailabilitySetRulesMutation(\n  $input: RecruitAvailabilitySetRulesInput!\n) {\n  result: recruitAvailabilitySetRules(input: $input) {\n    payload {\n      node {\n        id\n        availabilityRulesId\n        employerId\n        refId\n        refName\n        rules {\n          date\n          intervals {\n            from\n            to\n          }\n          type\n          weekday\n        }\n        timeZone\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node456.hash = "ed1ea5ca5ac37a4bdf908b449420dbca";
var UseAvailabilitySetRulesMutation_graphql_default = node456;

// src/availability/mutations/UseAvailabilitySetRules.ts
import { useAsyncMutation as useAsyncMutation69 } from "shared-lib";
var mutationDef90 = UseAvailabilitySetRulesMutation_graphql_default;
function useAvailabilitySetRules() {
  const [commit11, isBusy] = useAsyncMutation69(mutationDef90);
  return [commit11, isBusy];
}

// src/availability/components/AvailabilityDayEditor.tsx
import { useCallback as useCallback217, useState as useState111 } from "react";
import { format as format19 } from "date-fns";
import { replaceItemInList } from "shared-lib";
import { Button as Button106, Size as Size54 } from "shared-ui";
import { jsx as jsx401, jsxs as jsxs269 } from "react/jsx-runtime";
var availableTime = [];
for (let h11 = 6; h11 < 20; h11++) {
  for (let m4 = 0; m4 < 60; m4 = m4 + 15) {
    availableTime.push(
      `${h11.toString().padStart(2, "0")}:${m4.toString().padStart(2, "0")}`
    );
  }
}
function updateIntervals(intervals, updated) {
  const selected = intervals.find((i4) => i4.id === updated.id);
  if (selected == null) {
    const newIntervals2 = {
      ...intervals,
      ...updated
    };
    return newIntervals2;
  }
  const newIntervals = replaceItemInList(
    intervals,
    selected,
    updated
  );
  return newIntervals;
}
var AvailabilityDayEditor = ({
  calendarDay,
  isBusy,
  onCancel,
  onUpdateToDays,
  onUpdateToWeekdays
}) => {
  const [intervals, setIntervals] = useState111(() => {
    if (!calendarDay || !calendarDay.rule || !calendarDay.rule.intervals) {
      return [];
    }
    return calendarDay.rule.intervals.map((interval, index2) => {
      return {
        id: index2,
        from: interval.from,
        to: interval.to
      };
    });
  });
  const onSetIntervalFrom = useCallback217(
    (interval, value) => {
      const updated = {
        id: interval.id,
        from: value,
        to: interval.to
      };
      const newIntervals = updateIntervals(intervals, updated);
      setIntervals(newIntervals);
    },
    [intervals, setIntervals]
  );
  const onSetIntervalTo = useCallback217(
    (interval, value) => {
      const updated = {
        id: interval.id,
        from: interval.from,
        to: value
      };
      const newIntervals = updateIntervals(intervals, updated);
      setIntervals(newIntervals);
    },
    [intervals, setIntervals]
  );
  const onRemoveInterval = useCallback217(
    (interval) => {
      const newIntervals = intervals.filter((i4) => i4.id !== interval.id);
      setIntervals(newIntervals);
    },
    [intervals, setIntervals]
  );
  const onAddInterval = useCallback217(() => {
    const id18 = intervals.length + 1;
    setIntervals([
      ...intervals,
      {
        id: id18,
        from: availableTime[0],
        to: availableTime[1]
      }
    ]);
  }, [intervals, setIntervals]);
  const onApplyToDays = useCallback217(() => {
    const updated = intervals.map((i4) => ({
      from: i4.from,
      to: i4.to
    }));
    onUpdateToDays(calendarDay.date, updated);
  }, [calendarDay.date, intervals, onUpdateToDays]);
  const onApplyToWeekdays = useCallback217(() => {
    const updated = intervals.map((i4) => ({
      from: i4.from,
      to: i4.to
    }));
    onUpdateToWeekdays(calendarDay.date, updated);
  }, [calendarDay.date, intervals, onUpdateToWeekdays]);
  const intervalsList = intervals.map((interval) => {
    return /* @__PURE__ */ jsxs269(
      "div",
      {
        className: "flex items-center justify-between rounded-md bg-gray-100 p-3",
        children: [
          /* @__PURE__ */ jsxs269("div", { className: "flex items-center", children: [
            /* @__PURE__ */ jsx401("div", { children: /* @__PURE__ */ jsx401(
              "select",
              {
                id: "tabs",
                name: "tabs",
                className: "focus:ring-primary-500 focus:border-primary-500 block w-full rounded-md border-gray-300",
                defaultValue: interval.from,
                onChange: (e4) => onSetIntervalFrom(interval, e4.target.value),
                children: availableTime.map((time) => /* @__PURE__ */ jsx401("option", { value: time, children: time }, time))
              }
            ) }),
            /* @__PURE__ */ jsx401("div", { className: "interval-spacer", children: "-" }),
            /* @__PURE__ */ jsx401("div", { children: /* @__PURE__ */ jsx401(
              "select",
              {
                id: "tabs",
                name: "tabs",
                className: "focus:ring-primary-500 focus:border-primary-500 block w-full rounded-md border-gray-300",
                defaultValue: interval.to,
                onChange: (e4) => onSetIntervalTo(interval, e4.target.value),
                children: availableTime.map((time) => /* @__PURE__ */ jsx401("option", { value: time, children: time }, time))
              }
            ) })
          ] }),
          /* @__PURE__ */ jsx401("div", { children: /* @__PURE__ */ jsx401(Button106, { size: Size54.sm, onClick: () => onRemoveInterval(interval), children: "X" }) })
        ]
      },
      interval.id
    );
  });
  return /* @__PURE__ */ jsxs269("div", { className: "flex h-full w-full flex-col justify-between rounded-md border bg-white p-2", children: [
    /* @__PURE__ */ jsx401("div", { children: /* @__PURE__ */ jsxs269("div", { className: "flex w-full justify-between border-b ", children: [
      /* @__PURE__ */ jsx401("h5", { className: "text-primary-500 mb-2 p-2 text-xl font-medium", children: "Edit Availability" }),
      /* @__PURE__ */ jsx401(Button106, { disabled: isBusy, size: Size54.md, onClick: onCancel, children: "Cancel" })
    ] }) }),
    /* @__PURE__ */ jsxs269("div", { className: "flex flex-col gap-2 py-3", children: [
      intervals.length > 0 && /* @__PURE__ */ jsxs269("div", { className: "flex flex-col md:flex-row", children: [
        /* @__PURE__ */ jsxs269("div", { className: "mb-4 flex w-full flex-col gap-2 p-4", children: [
          intervalsList,
          /* @__PURE__ */ jsx401("div", { className: "flex justify-end border p-4", children: /* @__PURE__ */ jsx401(
            Button106,
            {
              color: "primary",
              disabled: isBusy,
              size: Size54.md,
              onClick: () => onAddInterval(),
              children: "+ New Interval"
            }
          ) })
        ] }),
        /* @__PURE__ */ jsxs269("div", { className: "m-4 flex w-full max-w-md flex-col gap-3 p-4", children: [
          /* @__PURE__ */ jsxs269(
            Button106,
            {
              color: "primary",
              disabled: isBusy,
              size: Size54.sm,
              onClick: onApplyToWeekdays,
              children: [
                "Apply To All ",
                format19(calendarDay.date, "EEEE"),
                "'s"
              ]
            }
          ),
          /* @__PURE__ */ jsxs269(
            Button106,
            {
              color: "primary",
              disabled: isBusy,
              size: Size54.sm,
              onClick: onApplyToDays,
              children: [
                "Apply To ",
                format19(calendarDay.date, "MMM do"),
                " only"
              ]
            }
          )
        ] })
      ] }),
      intervals.length === 0 && /* @__PURE__ */ jsx401("div", { className: "flex justify-center", children: /* @__PURE__ */ jsx401(
        Button106,
        {
          color: "primary",
          disabled: isBusy,
          size: Size54.md,
          onClick: () => onAddInterval(),
          children: "+ New Interval"
        }
      ) })
    ] })
  ] });
};

// src/availability/components/AvailabilityCalendar.tsx
import { jsx as jsx403, jsxs as jsxs270 } from "react/jsx-runtime";
var queryDef70 = AvailabilityCalendarQuery_graphql_default;
var fromDatePattern = "d MMMM";
var fromDateYearPattern = "d MMMM";
function getFromDate(from, to) {
  if (from.getFullYear() != to.getFullYear()) {
    return format20(from, fromDateYearPattern);
  }
  return format20(from, fromDatePattern);
}
function sameDays(dayA, dayB) {
  if (!dayA || !dayB) {
    return false;
  }
  const a4 = dayA.date;
  const b3 = dayB.date;
  return a4.getFullYear() == b3.getFullYear() && a4.getMonth() == b3.getMonth() && a4.getDate() == b3.getDate();
}
var timeZone = getTimeZoneOrDefault();
var AvailabilityCalendar = () => {
  const session = useUserSessionContext7();
  const userId = session.userId;
  const query3 = useLazyLoadQuery63(
    queryDef70,
    { refId: userId },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { rules } = query3;
  const [calendarState, setCalendarState] = useState113(
    () => {
      let calendar;
      if (rules) {
        const ruleIndex = createRules(buildRules(rules));
        calendar = createCalendar(/* @__PURE__ */ new Date(), ruleIndex);
      } else {
        calendar = createCalendar(/* @__PURE__ */ new Date(), {});
      }
      return {
        calendar,
        fromDate: getFromDate(calendar.firstDay, calendar.lastDay),
        toDate: format20(calendar.lastDay, fromDateYearPattern),
        timeZone
      };
    }
  );
  const [selectedDay, setSelectedDay] = useState113(null);
  const onClearSelectedDay = useCallback218(() => {
    setSelectedDay(null);
  }, [setSelectedDay]);
  const onSetWeek = useCallback218(
    (date) => {
      const calendar = createCalendar(date, calendarState.calendar.rules);
      setCalendarState((state) => {
        return {
          ...state,
          calendar,
          fromDate: getFromDate(calendar.firstDay, calendar.lastDay),
          toDate: format20(calendar.lastDay, fromDateYearPattern)
        };
      });
    },
    [calendarState, setCalendarState]
  );
  const onPrevWeek = useCallback218(() => {
    const date = prevWeeks(calendarState.calendar);
    onSetWeek(date);
  }, [calendarState, onSetWeek]);
  const onNextWeek = useCallback218(() => {
    const date = nextWeeks(calendarState.calendar);
    onSetWeek(date);
  }, [calendarState, onSetWeek]);
  const onSetDayHighlighted = useCallback218(
    (day) => {
      setSelectedDay(day);
    },
    [setSelectedDay]
  );
  const [setRules, isSettingRules] = useAvailabilitySetRules();
  const onSetRules = useCallback218(async () => {
    const input = {
      refId: userId,
      refName: "account",
      timeZone,
      rules: Object.values(calendarState.calendar.rules)
    };
    await setRules({
      input
    });
  }, [calendarState, setRules]);
  const onApplyToDays = useCallback218(
    async (date, intervals) => {
      applyToDays(calendarState.calendar, [date], intervals);
      setCalendarState((state) => {
        return {
          ...state,
          calendar: calendarState.calendar
        };
      });
      await onSetRules();
    },
    [calendarState, setCalendarState, onSetRules]
  );
  const onApplyToWeekdays = useCallback218(
    async (date, intervals) => {
      applyToWeekdays(calendarState.calendar, [date], intervals);
      setCalendarState((state) => {
        return {
          ...state,
          calendar: calendarState.calendar
        };
      });
      await onSetRules();
    },
    [calendarState, setCalendarState, onSetRules]
  );
  const calendarTableHeader = calendarState.calendar.weekdaysDisplay.map(
    (weekday) => {
      return /* @__PURE__ */ jsx403("th", { scope: "col", children: weekday }, weekday);
    }
  );
  const calendarTableRows = calendarState.calendar.weeks.map((w4) => {
    const cells = w4.days.map((day) => {
      let rule = /* @__PURE__ */ jsx403("div", {});
      if (day.rule) {
        const intervals = day.rule.intervals.slice(0, 4).map((i4, index2) => {
          return /* @__PURE__ */ jsx403("div", { className: "interval", children: /* @__PURE__ */ jsxs270(Tag26, { children: [
            i4.from,
            " - ",
            i4.to
          ] }) }, `${day.day}-${index2}`);
        });
        rule = /* @__PURE__ */ jsxs270("div", { className: "intervals flex flex-col gap-1 pt-2.5", children: [
          intervals,
          day.rule.intervals.length > 4 && /* @__PURE__ */ jsxs270("div", { className: "intervals-not-shown", children: [
            "+ ",
            day.rule.intervals.length - 4,
            " more"
          ] })
        ] });
      }
      return /* @__PURE__ */ jsxs270(
        "td",
        {
          onClick: () => onSetDayHighlighted(day),
          className: classNames44(
            "max-w-sm cursor-pointer border p-2 text-center align-top hover:bg-gray-200 md:h-36",
            selectedDay && sameDays(day, selectedDay) ? "font-bold" : ""
          ),
          children: [
            /* @__PURE__ */ jsx403("div", { className: "flex items-center justify-center md:items-start md:justify-start", children: /* @__PURE__ */ jsx403(
              "div",
              {
                className: classNames44(
                  isToday2(new Date(day.date)) && "rounded-full bg-red-600 text-white ",
                  "h-6 w-6"
                ),
                children: getDate(day.date)
              }
            ) }),
            /* @__PURE__ */ jsx403("div", { className: "hidden md:flex", children: rule }),
            /* @__PURE__ */ jsx403(
              "div",
              {
                className: classNames44(
                  "text-2xl md:hidden",
                  day.rule ? "text-gray-300" : "text-white"
                ),
                children: "\u2022"
              }
            )
          ]
        },
        day.date.toDateString()
      );
    });
    return /* @__PURE__ */ jsx403("tr", { children: cells }, w4.id);
  });
  return /* @__PURE__ */ jsx403(ErrorBoundary6, { FallbackComponent: ErrorBoundaryFallback5, children: /* @__PURE__ */ jsxs270("div", { className: "flex flex-col gap-4 sm:m-8", children: [
    /* @__PURE__ */ jsxs270("div", { className: "flex-1 rounded-lg border bg-white p-2", children: [
      /* @__PURE__ */ jsxs270("div", { className: "mb-4 flex items-center p-4", children: [
        /* @__PURE__ */ jsx403("div", { className: "text-primary-500", children: /* @__PURE__ */ jsxs270("h5", { children: [
          calendarState.fromDate,
          " - ",
          calendarState.toDate
        ] }) }),
        /* @__PURE__ */ jsx403("div", { className: "flex-1" }),
        /* @__PURE__ */ jsxs270("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ jsx403(Button107, { color: "primary", onClick: onPrevWeek, children: "Previous" }),
          /* @__PURE__ */ jsx403(Button107, { color: "primary", onClick: onNextWeek, children: "Next" })
        ] })
      ] }),
      /* @__PURE__ */ jsx403("table", { className: "w-full table-fixed border-collapse", children: /* @__PURE__ */ jsxs270("tbody", { children: [
        /* @__PURE__ */ jsx403("tr", { children: calendarTableHeader }),
        calendarTableRows
      ] }) })
    ] }),
    selectedDay && /* @__PURE__ */ jsx403(
      AvailabilityDayEditor,
      {
        isBusy: isSettingRules,
        calendarDay: selectedDay,
        onCancel: onClearSelectedDay,
        onUpdateToDays: onApplyToDays,
        onUpdateToWeekdays: onApplyToWeekdays
      },
      selectedDay.date.toISOString()
    )
  ] }) });
};
var createAvailabilityRoutes = (environment, context) => {
  return [
    {
      path: "*",
      element: /* @__PURE__ */ jsx403(AvailabilityCalendar, {})
    }
  ];
};

// src/email-applications/components/__generated__/EmailApplicationContainer_emailApplication.graphql.ts
var node457 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmailApplicationContainer_emailApplication",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailApplicationId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailAddress",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "jobReference",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "jobBoardName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vacancyUnknown",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vacancyClosed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "receivedDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailSubject",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rawContents",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RecruitEmailApplicationEvent",
      "kind": "LinkedField",
      "name": "events",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "date",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "details",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "eventTiming",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isFailure",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__id",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "RecruitEmailApplication",
  "abstractKey": null
};
node457.hash = "618a5c3bae2078db22b445db4f05955f";
var EmailApplicationContainer_emailApplication_graphql_default = node457;

// src/email-applications/components/EmailApplicationContainer.tsx
import { Fragment as Fragment105, useCallback as useCallback220 } from "react";
import { useFragment as useFragment135 } from "react-relay";
import { useNavigate as useNavigate29 } from "react-router-dom";
import { timeAgo as timeAgo10, useToggle as useToggle41 } from "shared-lib";
import {
  Button as Button109,
  DescriptionItem as DescriptionItem4,
  DescriptionList as DescriptionList4,
  HtmlDisplay as HtmlDisplay5,
  Size as Size55
} from "shared-ui";

// src/email-applications/components/ResolveVacancyFormContainer.tsx
import { useCallback as useCallback219, useState as useState114 } from "react";
import { createClientMutationId as createClientMutationId89 } from "shared-lib";
import { Button as Button108, ButtonList as ButtonList43 } from "shared-ui";

// src/email-applications/mutations/__generated__/UseResolveEmailApplicationMutation.graphql.ts
var node458 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfEmailApplication",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitEmailApplication",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailApplicationId",
            "storageKey": null
          },
          v23,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sagaCorrelationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "version",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedBy",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "messageId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bucket",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "key",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isParsingFailed",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailAddress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "attachmentFileName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rawContents",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currentStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailSubject",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "receivedDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "contractorId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "contractorPublicId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vacancyId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "profileId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "applicationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "jobReference",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "jobBoardName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "concreteJobBoardName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vacancyUnknown",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vacancyClosed",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitEmailApplicationEvent",
            "kind": "LinkedField",
            "name": "events",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isFailure",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "eventTiming",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "details",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "date",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v23,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseResolveEmailApplicationMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitEmailApplicationResolveVacancyPayload",
          "kind": "LinkedField",
          "name": "recruitEmailApplicationResolveVacancy",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseResolveEmailApplicationMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitEmailApplicationResolveVacancyPayload",
          "kind": "LinkedField",
          "name": "recruitEmailApplicationResolveVacancy",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "ef52963b33df87be8d31bab79ee352ec",
      "id": null,
      "metadata": {},
      "name": "UseResolveEmailApplicationMutation",
      "operationKind": "mutation",
      "text": "mutation UseResolveEmailApplicationMutation(\n  $input: RecruitEmailApplicationResolveVacancyInput!\n) {\n  data: recruitEmailApplicationResolveVacancy(input: $input) {\n    payload {\n      node {\n        id\n        emailApplicationId\n        code\n        createdOn\n        sagaCorrelationId\n        version\n        updatedAt\n        updatedBy\n        messageId\n        bucket\n        key\n        isParsingFailed\n        firstName\n        lastName\n        emailAddress\n        attachmentFileName\n        rawContents\n        currentStatus\n        emailSubject\n        receivedDate\n        contractorId\n        contractorPublicId\n        vacancyId\n        profileId\n        applicationId\n        jobReference\n        jobBoardName\n        concreteJobBoardName\n        vacancyUnknown\n        vacancyClosed\n        events {\n          isFailure\n          eventTiming\n          details\n          date\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node458.hash = "093d5d986ddbaf1a24846d62894a26ef";
var UseResolveEmailApplicationMutation_graphql_default = node458;

// src/email-applications/mutations/UseResolveEmailApplication.ts
import { useAsyncMutation as useAsyncMutation70 } from "shared-lib";
var mutationDef91 = UseResolveEmailApplicationMutation_graphql_default;
function useResolveEmailApplication() {
  const [commit11, isBusy] = useAsyncMutation70(mutationDef91);
  return [commit11, isBusy];
}

// src/email-applications/components/ResolveVacancyFormContainer.tsx
import { jsx as jsx404, jsxs as jsxs271 } from "react/jsx-runtime";
var ResolveVacancyFormContainer = ({
  emailApplicationId,
  onDone,
  onCancel
}) => {
  const [selected, setSelected] = useState114(null);
  const [resolve, isResolving] = useResolveEmailApplication();
  const onSelected = useCallback219(
    (result) => {
      setSelected(result);
    },
    [setSelected]
  );
  const onResolve = useCallback219(async () => {
    if (!selected) {
      return;
    }
    const input = {
      vacancyId: selected.vacancyId,
      emailApplicationId,
      clientMutationId: createClientMutationId89()
    };
    const response = await resolve({ input });
    if (response.data.payload) {
      onDone();
    }
  }, [selected, resolve]);
  return /* @__PURE__ */ jsxs271("div", { className: "flex flex-col gap-2 p-8", children: [
    /* @__PURE__ */ jsx404("div", { className: "py-4", children: /* @__PURE__ */ jsx404(VacancySearchAutoComplete, { onSelected }) }),
    selected && /* @__PURE__ */ jsx404("div", { className: "border-t py-4", children: /* @__PURE__ */ jsx404(Button108, { color: "primary", clicked: onResolve, children: "Resolve" }) }),
    /* @__PURE__ */ jsx404("div", { className: "border-t py-4", children: /* @__PURE__ */ jsx404(ButtonList43, { children: /* @__PURE__ */ jsx404(Button108, { color: "gray", clicked: onCancel, children: "Cancel" }) }) })
  ] });
};

// src/email-applications/components/EmailApplicationContainer.tsx
import { Fragment as Fragment106, jsx as jsx405, jsxs as jsxs273 } from "react/jsx-runtime";
var fragmentDef102 = EmailApplicationContainer_emailApplication_graphql_default;
var EmailApplicationContainer = ({ fragmentRef }) => {
  const navigate = useNavigate29();
  const [isResolving, toggleIsResolving] = useToggle41();
  const emailApplication = useFragment135(fragmentDef102, fragmentRef);
  const onUpdated = useCallback220(() => {
    navigate(0);
  }, [navigate]);
  const eventsList = (emailApplication.events || []).map((e4) => {
    return /* @__PURE__ */ jsxs273("div", { className: "flex items-center justify-between gap-2 border bg-white p-4 text-sm", children: [
      /* @__PURE__ */ jsx405("div", { className: "text-gray-500", children: e4.date ? timeAgo10(e4.date) : "unknown" }),
      /* @__PURE__ */ jsx405("div", { className: "text-primary-500", children: e4.details })
    ] });
  });
  return /* @__PURE__ */ jsxs273("div", { className: "flex flex-1 flex-col gap-2 border bg-white p-4", children: [
    /* @__PURE__ */ jsxs273("div", { className: "flex items-center gap-2 border-b p-4", children: [
      /* @__PURE__ */ jsx405("div", { className: "text-primary-500 px-1 text-xl font-bold", children: emailApplication.firstName }),
      /* @__PURE__ */ jsx405("div", { className: "text-primary-500 px-1 text-xl font-bold", children: emailApplication.lastName }),
      /* @__PURE__ */ jsx405("div", { className: "px-1 text-xl font-medium text-gray-900", children: emailApplication.emailAddress })
    ] }),
    isResolving ? /* @__PURE__ */ jsx405("div", { children: /* @__PURE__ */ jsx405(
      ResolveVacancyFormContainer,
      {
        emailApplicationId: emailApplication.emailApplicationId,
        onDone: onUpdated,
        onCancel: toggleIsResolving
      }
    ) }) : /* @__PURE__ */ jsxs273(Fragment106, { children: [
      /* @__PURE__ */ jsx405("div", { className: "mt-4 border border-gray-100 sm:w-3/4 lg:w-1/2", children: /* @__PURE__ */ jsx405(
        DescriptionList4,
        {
          classes: "w-full",
          heading: /* @__PURE__ */ jsx405("div", { className: "flex items-center justify-between", children: /* @__PURE__ */ jsx405("div", { className: "text-info-600", children: /* @__PURE__ */ jsx405(HtmlDisplay5, { html: emailApplication.emailSubject }) }) }),
          items: /* @__PURE__ */ jsxs273(Fragment105, { children: [
            emailApplication.vacancyUnknown && /* @__PURE__ */ jsx405(DescriptionItem4, { label: "Vacancy Unknown", children: /* @__PURE__ */ jsx405(
              Button109,
              {
                size: Size55.xl,
                color: "success",
                clicked: toggleIsResolving,
                children: "Resolve"
              }
            ) }),
            emailApplication.vacancyClosed && /* @__PURE__ */ jsx405(DescriptionItem4, { label: "Vacancy Closed", children: /* @__PURE__ */ jsx405("div", { className: "text-danger-800 text-sm", children: "Vacancy was closed when application received" }) }),
            /* @__PURE__ */ jsx405(DescriptionItem4, { label: "Job Reference", children: emailApplication.jobReference }),
            /* @__PURE__ */ jsx405(DescriptionItem4, { label: "Job Board", children: emailApplication.jobBoardName }),
            /* @__PURE__ */ jsx405(DescriptionItem4, { label: "Received On", children: emailApplication.receivedDate })
          ] })
        }
      ) }),
      /* @__PURE__ */ jsxs273("div", { className: "sm:w-3/4 lg:w-1/2", children: [
        /* @__PURE__ */ jsx405("div", { className: "text-primary-500 px-1 py-4 text-sm font-medium", children: "Events" }),
        /* @__PURE__ */ jsx405("div", { children: eventsList })
      ] })
    ] })
  ] });
};

// src/email-applications/components/__generated__/EmailApplicationPaginationQuery.graphql.ts
var node459 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v23 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v32 = [
    v1,
    v23,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "createdAt": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ], v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmailApplicationPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v23
          ],
          "kind": "FragmentSpread",
          "name": "EmailApplicationList_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmailApplicationPaginationQuery",
      "selections": [
        {
          "alias": "list",
          "args": v32,
          "concreteType": "RecruitEmailApplicationsConnection",
          "kind": "LinkedField",
          "name": "recruitEmailApplications",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitEmailApplicationsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitEmailApplication",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v4,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "emailApplicationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitEmailApplicationDocument",
                      "kind": "LinkedField",
                      "name": "data",
                      "plural": false,
                      "selections": [
                        v4,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "key",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "firstName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "lastName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "emailAddress",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "emailSubject",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v32,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "EmailApplication_list",
          "kind": "LinkedHandle",
          "name": "recruitEmailApplications"
        }
      ]
    },
    "params": {
      "cacheID": "c8297e0111aba99652443bb58ca586ee",
      "id": null,
      "metadata": {},
      "name": "EmailApplicationPaginationQuery",
      "operationKind": "query",
      "text": "query EmailApplicationPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $where: RecruitEmailApplicationFilter\n) {\n  ...EmailApplicationList_list_2HEEH6\n}\n\nfragment EmailApplicationList_list_2HEEH6 on Query {\n  list: recruitEmailApplications(first: $first, after: $after, order: [{createdAt: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        emailApplicationId\n        code\n        data {\n          id\n          key\n          firstName\n          lastName\n          emailAddress\n          emailSubject\n        }\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node459.hash = "aad2ee9144c3063e0c20dfcb3be6d3a2";
var EmailApplicationPaginationQuery_graphql_default = node459;

// src/email-applications/components/__generated__/EmailApplicationList_list.graphql.ts
var node460 = function() {
  var v0 = [
    "list"
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": EmailApplicationPaginationQuery_graphql_default
      }
    },
    "name": "EmailApplicationList_list",
    "selections": [
      {
        "alias": "list",
        "args": [
          {
            "kind": "Literal",
            "name": "order",
            "value": [
              {
                "createdAt": "DESC"
              }
            ]
          },
          {
            "kind": "Variable",
            "name": "where",
            "variableName": "where"
          }
        ],
        "concreteType": "RecruitEmailApplicationsConnection",
        "kind": "LinkedField",
        "name": "__EmailApplication_list_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitEmailApplicationsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitEmailApplication",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  v1,
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "emailApplicationId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RecruitEmailApplicationDocument",
                    "kind": "LinkedField",
                    "name": "data",
                    "plural": false,
                    "selections": [
                      v1,
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "key",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "firstName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lastName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "emailAddress",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "emailSubject",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node460.hash = "aad2ee9144c3063e0c20dfcb3be6d3a2";
var EmailApplicationList_list_graphql_default = node460;

// src/email-applications/components/__generated__/EmailApplicationListQuery.graphql.ts
var node461 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "createdAt": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmailApplicationListQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EmailApplicationList_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmailApplicationListQuery",
      "selections": [
        {
          "alias": "list",
          "args": v1,
          "concreteType": "RecruitEmailApplicationsConnection",
          "kind": "LinkedField",
          "name": "recruitEmailApplications",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitEmailApplicationsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitEmailApplication",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v23,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "emailApplicationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitEmailApplicationDocument",
                      "kind": "LinkedField",
                      "name": "data",
                      "plural": false,
                      "selections": [
                        v23,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "key",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "firstName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "lastName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "emailAddress",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "emailSubject",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v1,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "EmailApplication_list",
          "kind": "LinkedHandle",
          "name": "recruitEmailApplications"
        }
      ]
    },
    "params": {
      "cacheID": "5d3903543aeb18857a09d4c4448ca34e",
      "id": null,
      "metadata": {},
      "name": "EmailApplicationListQuery",
      "operationKind": "query",
      "text": "query EmailApplicationListQuery(\n  $where: RecruitEmailApplicationFilter!\n) {\n  ...EmailApplicationList_list\n}\n\nfragment EmailApplicationList_list on Query {\n  list: recruitEmailApplications(first: 10, order: [{createdAt: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        emailApplicationId\n        code\n        data {\n          id\n          key\n          firstName\n          lastName\n          emailAddress\n          emailSubject\n        }\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node461.hash = "338cb8d13348a59691f6e8bd51d80f24";
var EmailApplicationListQuery_graphql_default = node461;

// src/email-applications/components/EmailApplicationList.tsx
import { Suspense as Suspense136, useCallback as useCallback221, useState as useState115 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery64, usePaginationFragment as usePaginationFragment21 } from "react-relay";
import { useLocalStorage as useLocalStorage2 } from "react-use";
import { isNotNullOrUndefined as isNotNullOrUndefined12, useToggle as useToggle43 } from "shared-lib";
import {
  CheckBox as CheckBox5,
  DefaultListLayoutItemHeader as DefaultListLayoutItemHeader2,
  DefaultListLayoutSectionElement as DefaultListLayoutSectionElement2,
  EdSkeleton as EdSkeleton109,
  ListLayout as ListLayout6,
  SearchBox
} from "shared-ui";
import { jsx as jsx406, jsxs as jsxs274 } from "react/jsx-runtime";
var fragmentDef103 = EmailApplicationList_list_graphql_default;
var queryDef71 = EmailApplicationListQuery_graphql_default;
function createLinkTo(section) {
  const code = section.context.code;
  return `../../../view/${code}`;
}
var List2 = ({ fragmentRef }) => {
  const { data, loadNext } = usePaginationFragment21(fragmentDef103, fragmentRef);
  const onLoadNext = useCallback221(() => {
    loadNext(10);
  }, [loadNext]);
  const { list: list2 } = data;
  const sections = (list2?.edges || []).map((e4) => e4.node).filter(isNotNullOrUndefined12).map((jobBoard) => {
    const name = `${jobBoard.data.firstName} ${jobBoard.data.lastName}`;
    return {
      key: jobBoard.code.toString(),
      itemTitle: name,
      listTitle: /* @__PURE__ */ jsx406("div", { className: "flex flex-col gap-2", children: /* @__PURE__ */ jsxs274("div", { className: "flex items-center justify-between gap-2", children: [
        /* @__PURE__ */ jsx406("div", { className: "text-md font-medium uppercase", children: name }),
        /* @__PURE__ */ jsx406("div", { className: "text-md text-blue-500", children: jobBoard.code })
      ] }) }),
      description: /* @__PURE__ */ jsx406("div", { className: "flex items-center gap-2 pt-2 text-sm", children: jobBoard.data.emailSubject }),
      hideIcon: true,
      icon: () => null,
      iconForeground: "text-primary-700",
      iconBackground: "bg-primary-50",
      context: {
        code: jobBoard.code
      },
      element: /* @__PURE__ */ jsx406(DefaultListLayoutSectionElement2, { children: /* @__PURE__ */ jsx406("div", { className: "grid", children: /* @__PURE__ */ jsx406("div", { children: jobBoard.code }) }) })
    };
  });
  return /* @__PURE__ */ jsx406(Suspense136, { fallback: /* @__PURE__ */ jsx406(EdSkeleton109, {}), children: /* @__PURE__ */ jsx406(
    ListLayout6,
    {
      sections,
      itemHeader: (s4) => /* @__PURE__ */ jsx406(
        DefaultListLayoutItemHeader2,
        {
          title: "Job Boards",
          to: createLinkTo,
          section: s4
        }
      ),
      loadMore: onLoadNext,
      isLoading: false,
      showFilters: false
    }
  ) });
};
var EmailApplicationList = ({}) => {
  const [failedOnly, toggleFailedOnly] = useToggle43(true);
  const [vacancyClosed, toggleVacancyClosed] = useToggle43(true);
  const [vacancyUnknown, toggleVacancyUnknown] = useToggle43(true);
  const [term, setTerm] = useState115(null);
  const [searchType, setSearchBy] = useLocalStorage2(
    "email-application-search-by",
    "email"
  );
  const onSetSearchBy = useCallback221(
    (searchBy) => {
      setSearchBy(searchBy);
    },
    [setSearchBy]
  );
  let where = {
    isParsingFailed: {
      eq: failedOnly
    }
  };
  if (term && term !== "" && searchType && searchType !== "none") {
    if (searchType === "email") {
      where = {
        ...where,
        emailAddress: { startsWith: term }
      };
    } else if (searchType === "jobBoardName") {
      where = {
        ...where,
        jobBoardName: { startsWith: term }
      };
    } else if (searchType === "jobReference") {
      where = {
        ...where,
        jobReference: { startsWith: term }
      };
    } else if (searchType === "candidateName") {
      where = {
        ...where,
        or: [
          { firstName: { startsWith: term } },
          { lastName: { startsWith: term } }
        ]
      };
    }
  }
  const query3 = useLazyLoadQuery64(
    queryDef71,
    { where },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsxs274("div", { className: "", children: [
    /* @__PURE__ */ jsxs274("div", { className: "flex items-center justify-between border-b bg-white px-2 py-2 md:px-4 lg:px-8", children: [
      /* @__PURE__ */ jsxs274("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ jsx406("div", { children: /* @__PURE__ */ jsx406("div", { className: "text-sm font-medium text-gray-900", children: "Search" }) }),
        /* @__PURE__ */ jsxs274("div", { className: "flex items-center gap-2 py-2", children: [
          /* @__PURE__ */ jsx406("div", { className: "text-primary-500 text-sm", children: "Query" }),
          /* @__PURE__ */ jsx406(SearchBox, { onChange: setTerm })
        ] }),
        /* @__PURE__ */ jsxs274("div", { className: "flex items-center gap-2 py-2", children: [
          /* @__PURE__ */ jsx406("div", { children: /* @__PURE__ */ jsx406("div", { className: "text-primary-500 text-sm", children: "By" }) }),
          /* @__PURE__ */ jsx406("div", { children: /* @__PURE__ */ jsxs274(
            "select",
            {
              id: "email-notifications-type",
              name: "email-notifications-type",
              className: "focus:ring-primary-500 focus:border-primary-500 block w-full rounded-md border-gray-300",
              value: searchType,
              onChange: (e4) => onSetSearchBy(e4.target.value),
              children: [
                /* @__PURE__ */ jsx406("option", { value: "", children: "--Select--" }, "none"),
                /* @__PURE__ */ jsx406("option", { value: "email", children: "Email" }, "email"),
                /* @__PURE__ */ jsx406("option", { value: "jobReference", children: "Job Reference" }, "jobReference"),
                /* @__PURE__ */ jsx406("option", { value: "jobBoardName", children: "Job Board" }, "jobBoardName"),
                /* @__PURE__ */ jsx406("option", { value: "candidateName", children: "Candidate Name" }, "candidateName")
              ]
            }
          ) })
        ] })
      ] }),
      /* @__PURE__ */ jsxs274("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ jsxs274("div", { className: "flex items-center gap-2 py-2", children: [
          /* @__PURE__ */ jsx406("div", { children: /* @__PURE__ */ jsx406("div", { className: "text-primary-500 text-sm", children: "Vacancy Closed" }) }),
          /* @__PURE__ */ jsx406(CheckBox5, { checked: vacancyClosed, onChanged: toggleVacancyClosed })
        ] }),
        /* @__PURE__ */ jsxs274("div", { className: "flex items-center gap-2 py-2", children: [
          /* @__PURE__ */ jsx406("div", { children: /* @__PURE__ */ jsx406("div", { className: "text-primary-500 text-sm", children: "Vacancy Unknown" }) }),
          /* @__PURE__ */ jsx406(
            CheckBox5,
            {
              checked: vacancyUnknown,
              onChanged: toggleVacancyUnknown
            }
          )
        ] }),
        /* @__PURE__ */ jsxs274("div", { className: "flex items-center gap-2 py-2", children: [
          /* @__PURE__ */ jsx406("div", { children: /* @__PURE__ */ jsx406("div", { className: "text-primary-500 text-sm", children: "Parse Failed" }) }),
          /* @__PURE__ */ jsx406(
            CheckBox5,
            {
              checked: failedOnly,
              title: "Failed Only",
              onChanged: toggleFailedOnly
            }
          )
        ] })
      ] })
    ] }),
    /* @__PURE__ */ jsx406(Suspense136, { fallback: /* @__PURE__ */ jsx406(EdSkeleton109, {}), children: /* @__PURE__ */ jsx406(List2, { fragmentRef: query3 }) })
  ] });
};

// src/email-applications/components/__generated__/EmailApplicationSearchBoxQuery.graphql.ts
var node463 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v23 = [
    {
      "alias": "list",
      "args": [
        {
          "kind": "Literal",
          "name": "order",
          "value": [
            {
              "createdAt": "DESC"
            }
          ]
        },
        {
          "kind": "Variable",
          "name": "where",
          "variableName": "where"
        }
      ],
      "concreteType": "RecruitEmailApplicationsConnection",
      "kind": "LinkedField",
      "name": "recruitEmailApplications",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasPreviousPage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RecruitEmailApplicationsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitEmailApplication",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                v1,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "emailApplicationId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "code",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitEmailApplicationDocument",
                  "kind": "LinkedField",
                  "name": "data",
                  "plural": false,
                  "selections": [
                    v1,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "key",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "firstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "emailAddress",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "emailSubject",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobReference",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobBoardName",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmailApplicationSearchBoxQuery",
      "selections": v23,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmailApplicationSearchBoxQuery",
      "selections": v23
    },
    "params": {
      "cacheID": "6fee8059fb2087053d40c4f3e27eb397",
      "id": null,
      "metadata": {},
      "name": "EmailApplicationSearchBoxQuery",
      "operationKind": "query",
      "text": "query EmailApplicationSearchBoxQuery(\n  $where: RecruitEmailApplicationFilter!\n) {\n  list: recruitEmailApplications(order: [{createdAt: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        emailApplicationId\n        code\n        data {\n          id\n          key\n          firstName\n          lastName\n          emailAddress\n          emailSubject\n          jobReference\n          jobBoardName\n        }\n      }\n    }\n  }\n}\n"
    }
  };
}();
node463.hash = "07e518e8cea893f04edb2af016659254";
var EmailApplicationSearchBoxQuery_graphql_default = node463;

// src/email-applications/components/EmailApplicationSearchBox.tsx
import {
  useCallback as useCallback223,
  useEffect as useEffect49,
  useMemo as useMemo40,
  useState as useState116
} from "react";
import { useQueryLoader as useQueryLoader24 } from "react-relay";
import { ChevronUpDownIcon as ChevronUpDownIcon8 } from "@heroicons/react/24/solid";
import { Combobox as Combobox15 } from "@headlessui/react";
import { debounce as debounce10 } from "lodash-es";

// src/email-applications/components/EmailApplicationSearchBoxOptions.tsx
import { usePreloadedQuery as usePreloadedQuery46 } from "react-relay";
import { CheckIcon as CheckIcon8 } from "@heroicons/react/24/solid";
import { Combobox as Combobox14 } from "@headlessui/react";
import { classNames as classNames45 } from "shared-ui";
import { Fragment as Fragment107, jsx as jsx407, jsxs as jsxs275 } from "react/jsx-runtime";
var EmailApplicationSearchBoxOptions = ({ queryRef: queryRef3 }) => {
  const data = usePreloadedQuery46(emailApplicationSearchBoxQueryDef, queryRef3);
  const { list: list2 } = data;
  const items = list2?.edges?.map((e4) => e4.node) || [];
  if (items.length === 0) {
    return /* @__PURE__ */ jsx407("div", {});
  }
  return /* @__PURE__ */ jsx407(Combobox14.Options, { className: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm", children: items.map((result) => /* @__PURE__ */ jsx407(
    Combobox14.Option,
    {
      value: result,
      className: ({ active }) => classNames45(
        "relative cursor-default select-none py-2 pl-3 pr-9",
        active ? "bg-info-600 text-white" : "text-gray-900"
      ),
      children: ({ active, selected }) => /* @__PURE__ */ jsxs275(Fragment107, { children: [
        /* @__PURE__ */ jsx407("div", { className: "flex", children: /* @__PURE__ */ jsxs275(
          "span",
          {
            className: classNames45(
              "truncate",
              selected ? "font-semibold" : ""
            ),
            children: [
              "`$",
              result.data.emailAddress,
              " - ($",
              result.data.jobReference,
              ")`"
            ]
          }
        ) }),
        selected && /* @__PURE__ */ jsx407(
          "span",
          {
            className: classNames45(
              "absolute inset-y-0 right-0 flex items-center pr-4",
              active ? "bg-info-600 text-white" : "text-info-600"
            ),
            children: /* @__PURE__ */ jsx407(CheckIcon8, { className: "h-5 w-5", "aria-hidden": "true" })
          }
        )
      ] })
    },
    result.code.toString()
  )) });
};

// src/email-applications/components/EmailApplicationSearchBox.tsx
import { jsx as jsx408, jsxs as jsxs276 } from "react/jsx-runtime";
var emailApplicationSearchBoxQueryDef = EmailApplicationSearchBoxQuery_graphql_default;
var EmailApplicationSearchBox = ({
  onSelected,
  defaultValue,
  showLabel
}) => {
  const [selected, setSelected] = useState116(
    defaultValue ?? null
  );
  const [searchTerm, setSearchTerm] = useState116("");
  const onQueryChangeHandler = useMemo40(
    () => debounce10((q4) => {
      setSearchTerm(q4);
    }, 500),
    []
  );
  useEffect49(() => {
    return () => {
      onQueryChangeHandler.cancel();
    };
  }, []);
  const onSetSelected = useCallback223(
    (r4) => {
      setSelected(r4);
      onSelected(r4);
    },
    [selected]
  );
  const [queryReference, loadQuery48, disposeQuery] = useQueryLoader24(
    emailApplicationSearchBoxQueryDef
  );
  useEffect49(() => {
    if (!searchTerm) {
      return;
    }
    const where = {
      or: [
        { firstName: { startsWith: searchTerm } },
        { lastName: { startsWith: searchTerm } },
        { emailAddress: { startsWith: searchTerm } },
        { jobBoardName: { startsWith: searchTerm } },
        { jobReference: { startsWith: searchTerm } }
      ]
    };
    loadQuery48({ where }, { fetchPolicy: "network-only" });
  }, [searchTerm]);
  return /* @__PURE__ */ jsxs276(Combobox15, { as: "div", value: selected, onChange: onSetSelected, children: [
    showLabel && /* @__PURE__ */ jsx408(Combobox15.Label, { className: "block text-sm font-medium text-gray-700", children: "Document Types" }),
    /* @__PURE__ */ jsxs276("div", { className: "relative", children: [
      /* @__PURE__ */ jsx408(
        Combobox15.Input,
        {
          placeholder: "Search Email Applications",
          className: "focus:border-info-500 focus:ring-info-500 w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:outline-none focus:ring-1 sm:text-sm",
          onChange: (event) => onQueryChangeHandler(event.target.value),
          displayValue: (result) => {
            if (result.data.emailAddress) {
              return `${result.data.emailAddress} - (${result.data.jobReference})`;
            }
            return "";
          },
          autoComplete: "off"
        }
      ),
      /* @__PURE__ */ jsx408(Combobox15.Button, { className: "absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none", children: /* @__PURE__ */ jsx408(
        ChevronUpDownIcon8,
        {
          className: "h-5 w-5 text-gray-400",
          "aria-hidden": "true"
        }
      ) }),
      queryReference && /* @__PURE__ */ jsx408(EmailApplicationSearchBoxOptions, { queryRef: queryReference })
    ] })
  ] });
};

// src/email-applications/components/EmailApplicationSearchBoxContainer.tsx
import { jsx as jsx409 } from "react/jsx-runtime";
var EmailApplicationSearchBoxContainer = ({
  onSearchCompleted,
  showLabel
}) => {
  return /* @__PURE__ */ jsx409(
    EmailApplicationSearchBox,
    {
      onSelected: onSearchCompleted,
      showLabel
    }
  );
};

// src/job-board-search/components/__generated__/JobBoardSearchActivateButton_search.graphql.ts
var node464 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobBoardSearchActivateButton_search",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "searchId",
      "storageKey": null
    }
  ],
  "type": "JobBoardSearchSearch",
  "abstractKey": null
};
node464.hash = "380755ef239b37a22bd1d7887aa0f20b";
var JobBoardSearchActivateButton_search_graphql_default = node464;

// src/job-board-search/components/JobBoardSearchActivateButton.tsx
import { useCallback as useCallback224 } from "react";
import {
  ConnectionHandler as ConnectionHandler7,
  useFragment as useFragment136,
  useRelayEnvironment as useRelayEnvironment6
} from "react-relay/hooks";
import { Button as Button110 } from "shared-ui";
import { createClientMutationId as createClientMutationId90 } from "shared-lib";

// src/job-board-search/mutations/__generated__/ActivateSearchMutation.graphql.ts
var node465 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }, v23 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfSearch",
    "kind": "LinkedField",
    "name": "search",
    "plural": false,
    "selections": [
      v32,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "JobBoardSearchSearch",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scheduleStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v5 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "ActivateSearchMutation",
      "selections": [
        {
          "alias": null,
          "args": v23,
          "concreteType": "JobBoardSearchSearchActivatePayload",
          "kind": "LinkedField",
          "name": "jobBoardSearchSearchActivate",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SearchPayload",
              "kind": "LinkedField",
              "name": "searchPayload",
              "plural": false,
              "selections": [
                v4
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "ActivateSearchMutation",
      "selections": [
        {
          "alias": null,
          "args": v23,
          "concreteType": "JobBoardSearchSearchActivatePayload",
          "kind": "LinkedField",
          "name": "jobBoardSearchSearchActivate",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SearchPayload",
              "kind": "LinkedField",
              "name": "searchPayload",
              "plural": false,
              "selections": [
                v4,
                {
                  "alias": null,
                  "args": null,
                  "filters": null,
                  "handle": "prependEdge",
                  "key": "",
                  "kind": "LinkedHandle",
                  "name": "search",
                  "handleArgs": [
                    {
                      "kind": "Variable",
                      "name": "connections",
                      "variableName": "connections"
                    }
                  ]
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32,
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "cf05e7ca053ac58888a8837fe1689d8d",
      "id": null,
      "metadata": {},
      "name": "ActivateSearchMutation",
      "operationKind": "mutation",
      "text": "mutation ActivateSearchMutation(\n  $input: JobBoardSearchSearchActivateInput!\n) {\n  jobBoardSearchSearchActivate(input: $input) {\n    searchPayload {\n      search {\n        __typename\n        cursor\n        node {\n          id\n          status\n          scheduleStatus\n          createdAt\n          updatedAt\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node465.hash = "3947ac4c596bc7d1de3d74e301cca8e8";
var ActivateSearchMutation_graphql_default = node465;

// src/job-board-search/mutations/ActivateSearchMutation.ts
import { createConnectedCommitMutation } from "shared-lib";
var mutation5 = ActivateSearchMutation_graphql_default;
var commit4 = createConnectedCommitMutation(mutation5);
var ActivateSearchMutation_default = { commit: commit4, mutation: mutation5 };

// src/job-board-search/components/JobBoardSearchActivateButton.tsx
import { jsx as jsx411 } from "react/jsx-runtime";
var fragment15 = JobBoardSearchActivateButton_search_graphql_default;
var JobBoardSearchActivateButton = ({
  search: search4,
  onDone,
  onError
}) => {
  const data = useFragment136(
    fragment15,
    search4
  );
  const environment = useRelayEnvironment6();
  const connectionId = ConnectionHandler7.getConnectionID(
    "root",
    // passed as input to the mutation/subscription
    "JobBoardSearchList_searches"
  );
  const onSave = useCallback224(() => {
    if (!data) {
      return;
    }
    const clientMutationId = createClientMutationId90();
    const input = {
      id: data.searchId,
      clientMutationId
    };
    ActivateSearchMutation_default.commit(
      environment,
      input,
      connectionId,
      () => {
        onDone();
      },
      (error) => {
        onError(error);
      }
    );
  }, [data]);
  return /* @__PURE__ */ jsx411("div", { children: /* @__PURE__ */ jsx411(
    Button110,
    {
      color: "primary",
      clicked: () => {
        onSave();
      },
      children: "Activate"
    }
  ) });
};

// src/job-board-search/components/__generated__/JobBoardSearchCloseButton_search.graphql.ts
var node466 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobBoardSearchCloseButton_search",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "searchId",
      "storageKey": null
    }
  ],
  "type": "JobBoardSearchSearch",
  "abstractKey": null
};
node466.hash = "f9994084ff4aa48b5994d09f99be8f14";
var JobBoardSearchCloseButton_search_graphql_default = node466;

// src/job-board-search/components/JobBoardSearchCloseButton.tsx
import { useCallback as useCallback225 } from "react";
import {
  ConnectionHandler as ConnectionHandler8,
  useFragment as useFragment137,
  useRelayEnvironment as useRelayEnvironment7
} from "react-relay/hooks";
import { Button as Button111 } from "shared-ui";
import { createClientMutationId as createClientMutationId91 } from "shared-lib";

// src/job-board-search/mutations/__generated__/CloseSearchMutation.graphql.ts
var node467 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }, v23 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfSearch",
    "kind": "LinkedField",
    "name": "search",
    "plural": false,
    "selections": [
      v32,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "JobBoardSearchSearch",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scheduleStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v5 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "CloseSearchMutation",
      "selections": [
        {
          "alias": null,
          "args": v23,
          "concreteType": "JobBoardSearchSearchClosePayload",
          "kind": "LinkedField",
          "name": "jobBoardSearchSearchClose",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SearchPayload",
              "kind": "LinkedField",
              "name": "searchPayload",
              "plural": false,
              "selections": [
                v4
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "CloseSearchMutation",
      "selections": [
        {
          "alias": null,
          "args": v23,
          "concreteType": "JobBoardSearchSearchClosePayload",
          "kind": "LinkedField",
          "name": "jobBoardSearchSearchClose",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SearchPayload",
              "kind": "LinkedField",
              "name": "searchPayload",
              "plural": false,
              "selections": [
                v4,
                {
                  "alias": null,
                  "args": null,
                  "filters": null,
                  "handle": "prependEdge",
                  "key": "",
                  "kind": "LinkedHandle",
                  "name": "search",
                  "handleArgs": [
                    {
                      "kind": "Variable",
                      "name": "connections",
                      "variableName": "connections"
                    }
                  ]
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32,
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "24bf22c6be99b0b1ec01b0af4aec7ffe",
      "id": null,
      "metadata": {},
      "name": "CloseSearchMutation",
      "operationKind": "mutation",
      "text": "mutation CloseSearchMutation(\n  $input: JobBoardSearchSearchCloseInput!\n) {\n  jobBoardSearchSearchClose(input: $input) {\n    searchPayload {\n      search {\n        __typename\n        cursor\n        node {\n          id\n          status\n          scheduleStatus\n          createdAt\n          updatedAt\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node467.hash = "ba923b12ba43c1f7c68c1e088646ef59";
var CloseSearchMutation_graphql_default = node467;

// src/job-board-search/mutations/CloseSearchMutation.ts
import { createConnectedCommitMutation as createConnectedCommitMutation2 } from "shared-lib";
var mutation6 = CloseSearchMutation_graphql_default;
var commit5 = createConnectedCommitMutation2(mutation6);
var CloseSearchMutation_default = { commit: commit5 };

// src/job-board-search/components/JobBoardSearchCloseButton.tsx
import { jsx as jsx413 } from "react/jsx-runtime";
var fragment16 = JobBoardSearchCloseButton_search_graphql_default;
var JobBoardSearchCloseButton = ({
  search: search4,
  onDone,
  onError
}) => {
  const data = useFragment137(
    fragment16,
    search4
  );
  const environment = useRelayEnvironment7();
  const connectionId = ConnectionHandler8.getConnectionID(
    "root",
    // passed as input to the mutation/subscription
    "JobBoardSearchList_searches"
  );
  const onSave = useCallback225(() => {
    if (!data) {
      return;
    }
    const clientMutationId = createClientMutationId91();
    const input = {
      id: data.searchId,
      clientMutationId
    };
    CloseSearchMutation_default.commit(
      environment,
      input,
      connectionId,
      () => {
        onDone();
      },
      (error) => {
        onError(error);
      }
    );
  }, [data]);
  return /* @__PURE__ */ jsx413("div", { children: /* @__PURE__ */ jsx413(
    Button111,
    {
      clicked: () => {
        onSave();
      },
      children: "Activate"
    }
  ) });
};

// src/job-board-search/components/__generated__/JobBoardSearchContainer_search.graphql.ts
var node468 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v23 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "count",
      "storageKey": null
    }
  ], v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "jobBoardId",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "JobBoardSearchContainer_search",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "searchId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedAt",
        "storageKey": null
      },
      v1,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "organisationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "query",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "resumeDaysOld",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "radius",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "postCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "locationsPattern",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "scheduleStatus",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "JobBoardSearchSearchTriggerSpec",
        "kind": "LinkedField",
        "name": "searchTrigger",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startsOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "endsOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cronExpression",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SearchRunStats",
        "kind": "LinkedField",
        "name": "searchRunStats",
        "plural": false,
        "selections": v23,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SearchResultStats",
        "kind": "LinkedField",
        "name": "searchResultStats",
        "plural": false,
        "selections": v23,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "JobBoardSearchSearchJobBoard",
        "kind": "LinkedField",
        "name": "jobBoards",
        "plural": true,
        "selections": [
          v32,
          {
            "alias": null,
            "args": null,
            "concreteType": "JobBoardSearchSearchParameter",
            "kind": "LinkedField",
            "name": "parameters",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "formId",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "autoDownload",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "JobBoardSearchJobBoard",
        "kind": "LinkedField",
        "name": "jobBoardDefinitions",
        "plural": true,
        "selections": [
          v0,
          v32,
          v1,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "JobBoardSearchDetailForm_search"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "JobBoardSearchDetailView_search"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "JobBoardSearchCreateRunButton_search"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "JobBoardSearchActivateButton_search"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "JobBoardSearchCloseButton_search"
      }
    ],
    "type": "JobBoardSearchSearch",
    "abstractKey": null
  };
}();
node468.hash = "83a9f4f61acd467c638110b170375ab2";
var JobBoardSearchContainer_search_graphql_default = node468;

// src/job-board-search/components/JobBoardSearchContainer.tsx
import { useMemo as useMemo43 } from "react";
import { useMachine as useMachine3 } from "@xstate/react";
import { useFragment as useFragment143 } from "react-relay/hooks";
import { createMachine as createMachine3, State } from "xstate";
import { Button as Button117, ButtonList as ButtonList45, CronSummary } from "shared-ui";

// src/job-board-search/components/__generated__/JobBoardSearchDetailView_search.graphql.ts
var node469 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "jobBoardId",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "JobBoardSearchDetailView_search",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "searchId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedAt",
        "storageKey": null
      },
      v1,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "organisationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "query",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "resumeDaysOld",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "radius",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "postCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "locationsPattern",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "scheduleStatus",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "JobBoardSearchSearchJobBoard",
        "kind": "LinkedField",
        "name": "jobBoards",
        "plural": true,
        "selections": [
          v23,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "autoDownload",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "JobBoardSearchSearchParameter",
            "kind": "LinkedField",
            "name": "parameters",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "formId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "JobBoardSearchJobBoard",
        "kind": "LinkedField",
        "name": "jobBoardDefinitions",
        "plural": true,
        "selections": [
          v0,
          v23,
          v1,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "JobBoardSearchSearch",
    "abstractKey": null
  };
}();
node469.hash = "921aaf17d25a8d99ae77d1772cf6186e";
var JobBoardSearchDetailView_search_graphql_default = node469;

// src/job-board-search/components/JobBoardSearchDetailView.tsx
import { Fragment as Fragment108 } from "react";
import { useFragment as useFragment138 } from "react-relay/hooks";
import { AuditFields, DescriptionItem as DescriptionItem5, DescriptionList as DescriptionList5 } from "shared-ui";

// src/job-board-search/lib/JobBoardSearchModel.ts
function mapJobBoardsFromSearch(jobBoards, jobBoardDefinitions) {
  const boards = (jobBoards ?? []).map((b3) => {
    const definition = jobBoardDefinitions.find(
      (jd) => jd.jobBoardId == b3.jobBoardId
    );
    return {
      jobBoardId: b3.jobBoardId,
      parameters: b3.parameters,
      autoDownload: b3.autoDownload,
      name: definition ? definition.name : "Unknown"
    };
  });
  return boards;
}

// src/job-board-search/components/JobBoardSearchDetailView.tsx
import { jsx as jsx414, jsxs as jsxs277 } from "react/jsx-runtime";
var fragment17 = JobBoardSearchDetailView_search_graphql_default;
var JobBoardSearchDetailView = ({
  search: search4
}) => {
  const data = useFragment138(
    fragment17,
    search4
  );
  const jobBoards = mapJobBoardsFromSearch(
    data.jobBoards,
    data.jobBoardDefinitions
  );
  if (!data) {
    return /* @__PURE__ */ jsx414("div", { children: "No Search Details Available." });
  }
  return /* @__PURE__ */ jsxs277("div", { className: "items-top flex justify-between", children: [
    /* @__PURE__ */ jsx414("div", { className: "flex-1", children: /* @__PURE__ */ jsx414(
      DescriptionList5,
      {
        description: /* @__PURE__ */ jsxs277("div", { className: "mt-4", children: [
          /* @__PURE__ */ jsx414("div", { className: "mb-3 mt-2 flex space-x-4 text-gray-900", children: /* @__PURE__ */ jsx414("div", { children: data.description }) }),
          /* @__PURE__ */ jsx414(
            AuditFields,
            {
              createdOn: data.createdAt,
              updatedOn: data.updatedAt
            }
          )
        ] }),
        items: /* @__PURE__ */ jsxs277(Fragment108, { children: [
          /* @__PURE__ */ jsxs277("dl", { className: "grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2 md:grid-cols-3", children: [
            /* @__PURE__ */ jsx414(DescriptionItem5, { noGrid: true, label: "Name", children: data.name }),
            /* @__PURE__ */ jsx414(DescriptionItem5, { noGrid: true, label: "Query", children: data.query }),
            /* @__PURE__ */ jsx414(DescriptionItem5, { noGrid: true, label: "Location", children: data.locationsPattern })
          ] }),
          /* @__PURE__ */ jsxs277("dl", { className: "grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2 md:grid-cols-3", children: [
            /* @__PURE__ */ jsx414(DescriptionItem5, { noGrid: true, label: "Resume Days Old", children: data.resumeDaysOld }),
            /* @__PURE__ */ jsx414(DescriptionItem5, { noGrid: true, label: "Radius", children: data.radius }),
            /* @__PURE__ */ jsx414(DescriptionItem5, { noGrid: true, label: "Post Code", children: data.postCode })
          ] })
        ] })
      }
    ) }),
    /* @__PURE__ */ jsxs277("div", { className: "flex-1 px-3 sm:ml-4", children: [
      /* @__PURE__ */ jsx414("div", { className: "text-info-500 mb-3 font-medium", children: "Job Boards" }),
      /* @__PURE__ */ jsx414("ul", { children: jobBoards.map((j4) => /* @__PURE__ */ jsx414("li", { children: /* @__PURE__ */ jsxs277("div", { className: "flex items-center space-x-2", children: [
        /* @__PURE__ */ jsx414("div", { children: j4.name }),
        j4.autoDownload && /* @__PURE__ */ jsx414("div", { className: "font-bold", children: "AutoDownload" })
      ] }) }, j4.jobBoardId)) })
    ] })
  ] });
};

// src/job-board-search/components/__generated__/JobBoardSearchDetailForm_search.graphql.ts
var node470 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "jobBoardId",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "JobBoardSearchDetailForm_search",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "searchId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "query",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "resumeDaysOld",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "radius",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "postCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "locationsPattern",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "JobBoardSearchSearchJobBoard",
        "kind": "LinkedField",
        "name": "jobBoards",
        "plural": true,
        "selections": [
          v1,
          {
            "alias": null,
            "args": null,
            "concreteType": "JobBoardSearchSearchParameter",
            "kind": "LinkedField",
            "name": "parameters",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "formId",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "autoDownload",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "JobBoardSearchJobBoard",
        "kind": "LinkedField",
        "name": "jobBoardDefinitions",
        "plural": true,
        "selections": [
          v0,
          v1,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "JobBoardSearchJobBoardEditor_search"
      }
    ],
    "type": "JobBoardSearchSearch",
    "abstractKey": null
  };
}();
node470.hash = "f517359ad1fcebae8f5d41b5c1466761";
var JobBoardSearchDetailForm_search_graphql_default = node470;

// src/job-board-search/components/JobBoardSearchDetailForm.tsx
import { useCallback as useCallback228, useState as useState120 } from "react";
import { useFragment as useFragment140 } from "react-relay/hooks";
import { JsonFormsStyleContext as JsonFormsStyleContext2 } from "@jsonforms/vanilla-renderers";
import { JsonForms as JsonForms2 } from "@jsonforms/react";
import {
  Button as Button114,
  ButtonList as ButtonList44,
  elevateJsonFormsCells as elevateJsonFormsCells2,
  elevateJsonFormsRenderers as elevateJsonFormsRenderers2,
  elevateJsonFormsStyleContext as elevateJsonFormsStyleContext2
} from "shared-ui";
import { createClientMutationId as createClientMutationId93 } from "shared-lib";

// src/job-board-search/mutations/__generated__/CreateSearchRunMutation.graphql.ts
var node471 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "SearchRunPayload",
    "kind": "LinkedField",
    "name": "searchRunPayload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "EdgeOfSearchRun",
        "kind": "LinkedField",
        "name": "searchRun",
        "plural": false,
        "selections": [
          v23,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cursor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "JobBoardSearchSearchRun",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "searchRunId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "searchId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CreateSearchRunMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "JobBoardSearchCreateSearchRunPayload",
          "kind": "LinkedField",
          "name": "jobBoardSearchCreateSearchRun",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CreateSearchRunMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "JobBoardSearchCreateSearchRunPayload",
          "kind": "LinkedField",
          "name": "jobBoardSearchCreateSearchRun",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v23,
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "ef2f800761f742f58f3e6a3796d82e9f",
      "id": null,
      "metadata": {},
      "name": "CreateSearchRunMutation",
      "operationKind": "mutation",
      "text": "mutation CreateSearchRunMutation(\n  $input: JobBoardSearchCreateSearchRunInput!\n) {\n  jobBoardSearchCreateSearchRun(input: $input) {\n    searchRunPayload {\n      searchRun {\n        __typename\n        cursor\n        node {\n          id\n          searchRunId\n          searchId\n          status\n          createdAt\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node471.hash = "c6fbe9f5d5deace14678f4a42a1950a8";
var CreateSearchRunMutation_graphql_default = node471;

// src/job-board-search/mutations/CreateSearchRunMutation.ts
import { createCommitMutation } from "shared-lib";
var mutation7 = CreateSearchRunMutation_graphql_default;
var commit6 = createCommitMutation(mutation7);
var CreateSearchRunMutation_default = { commit: commit6 };

// src/job-board-search/mutations/__generated__/DownloadSearchResultMutation.graphql.ts
var node473 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }, v23 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfSearchResult",
    "kind": "LinkedField",
    "name": "searchResult",
    "plural": false,
    "selections": [
      v32,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "JobBoardSearchSearchResult",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "searchId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "downloadStatus",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v5 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "DownloadSearchResultMutation",
      "selections": [
        {
          "alias": null,
          "args": v23,
          "concreteType": "JobBoardSearchDownloadSearchResultPayload",
          "kind": "LinkedField",
          "name": "jobBoardSearchDownloadSearchResult",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SearchResultPayload",
              "kind": "LinkedField",
              "name": "searchResultPayload",
              "plural": false,
              "selections": [
                v4
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "DownloadSearchResultMutation",
      "selections": [
        {
          "alias": null,
          "args": v23,
          "concreteType": "JobBoardSearchDownloadSearchResultPayload",
          "kind": "LinkedField",
          "name": "jobBoardSearchDownloadSearchResult",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SearchResultPayload",
              "kind": "LinkedField",
              "name": "searchResultPayload",
              "plural": false,
              "selections": [
                v4,
                {
                  "alias": null,
                  "args": null,
                  "filters": null,
                  "handle": "prependEdge",
                  "key": "",
                  "kind": "LinkedHandle",
                  "name": "searchResult",
                  "handleArgs": [
                    {
                      "kind": "Variable",
                      "name": "connections",
                      "variableName": "connections"
                    }
                  ]
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32,
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "b6db174e87d1d585cb507b8b6dd6fa92",
      "id": null,
      "metadata": {},
      "name": "DownloadSearchResultMutation",
      "operationKind": "mutation",
      "text": "mutation DownloadSearchResultMutation(\n  $input: JobBoardSearchDownloadSearchResultInput!\n) {\n  jobBoardSearchDownloadSearchResult(input: $input) {\n    searchResultPayload {\n      searchResult {\n        __typename\n        cursor\n        node {\n          id\n          searchId\n          createdAt\n          updatedAt\n          downloadStatus\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node473.hash = "7fefb6f7cc80bedf0c38ce6773ba0ba0";
var DownloadSearchResultMutation_graphql_default = node473;

// src/job-board-search/mutations/DownloadSearchResultMutation.ts
import { createConnectedCommitMutation as createConnectedCommitMutation3 } from "shared-lib";
var mutation8 = DownloadSearchResultMutation_graphql_default;
var commit7 = createConnectedCommitMutation3(mutation8);
var DownloadSearchResultMutation_default = { commit: commit7 };

// src/job-board-search/mutations/__generated__/ProcessSearchResultMutation.graphql.ts
var node474 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }, v23 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfSearchResult",
    "kind": "LinkedField",
    "name": "searchResult",
    "plural": false,
    "selections": [
      v32,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "JobBoardSearchSearchResult",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "searchId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "downloadStatus",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v5 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "ProcessSearchResultMutation",
      "selections": [
        {
          "alias": null,
          "args": v23,
          "concreteType": "JobBoardSearchProcessSearchResultPayload",
          "kind": "LinkedField",
          "name": "jobBoardSearchProcessSearchResult",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SearchResultPayload",
              "kind": "LinkedField",
              "name": "searchResultPayload",
              "plural": false,
              "selections": [
                v4
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "ProcessSearchResultMutation",
      "selections": [
        {
          "alias": null,
          "args": v23,
          "concreteType": "JobBoardSearchProcessSearchResultPayload",
          "kind": "LinkedField",
          "name": "jobBoardSearchProcessSearchResult",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SearchResultPayload",
              "kind": "LinkedField",
              "name": "searchResultPayload",
              "plural": false,
              "selections": [
                v4,
                {
                  "alias": null,
                  "args": null,
                  "filters": null,
                  "handle": "prependEdge",
                  "key": "",
                  "kind": "LinkedHandle",
                  "name": "searchResult",
                  "handleArgs": [
                    {
                      "kind": "Variable",
                      "name": "connections",
                      "variableName": "connections"
                    }
                  ]
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32,
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "6c41f0b895eb2dcf67f7a7432274f9c8",
      "id": null,
      "metadata": {},
      "name": "ProcessSearchResultMutation",
      "operationKind": "mutation",
      "text": "mutation ProcessSearchResultMutation(\n  $input: JobBoardSearchProcessSearchResultInput!\n) {\n  jobBoardSearchProcessSearchResult(input: $input) {\n    searchResultPayload {\n      searchResult {\n        __typename\n        cursor\n        node {\n          id\n          searchId\n          createdAt\n          updatedAt\n          downloadStatus\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node474.hash = "7f5a3bff58fcdc7ab6916e820217bacf";
var ProcessSearchResultMutation_graphql_default = node474;

// src/job-board-search/mutations/ProcessSearchResultMutation.ts
import { createConnectedCommitMutation as createConnectedCommitMutation4 } from "shared-lib";
var mutation9 = ProcessSearchResultMutation_graphql_default;
var commit8 = createConnectedCommitMutation4(mutation9);
var ProcessSearchResultMutation_default = { commit: commit8 };

// src/job-board-search/mutations/__generated__/RetrySearchRunMutation.graphql.ts
var node475 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "SearchRunPayload",
    "kind": "LinkedField",
    "name": "searchRunPayload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "EdgeOfSearchRun",
        "kind": "LinkedField",
        "name": "searchRun",
        "plural": false,
        "selections": [
          v23,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cursor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "JobBoardSearchSearchRun",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "searchRunId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "searchId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "RetrySearchRunMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "JobBoardSearchRetrySearchRunPayload",
          "kind": "LinkedField",
          "name": "jobBoardSearchRetrySearchRun",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "RetrySearchRunMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "JobBoardSearchRetrySearchRunPayload",
          "kind": "LinkedField",
          "name": "jobBoardSearchRetrySearchRun",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v23,
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "2e69726df8741b7a3632444ddb9c9a58",
      "id": null,
      "metadata": {},
      "name": "RetrySearchRunMutation",
      "operationKind": "mutation",
      "text": "mutation RetrySearchRunMutation(\n  $input: JobBoardSearchRetrySearchRunInput!\n) {\n  jobBoardSearchRetrySearchRun(input: $input) {\n    searchRunPayload {\n      searchRun {\n        __typename\n        cursor\n        node {\n          id\n          searchRunId\n          searchId\n          status\n          createdAt\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node475.hash = "f2b5f98ab11afe6a79f0c09243227485";
var RetrySearchRunMutation_graphql_default = node475;

// src/job-board-search/mutations/RetrySearchRunMutation.ts
import { createCommitMutation as createCommitMutation2 } from "shared-lib";
var mutation10 = RetrySearchRunMutation_graphql_default;
var commit9 = createCommitMutation2(mutation10);
var RetrySearchRunMutation_default = { commit: commit9 };

// src/job-board-search/mutations/__generated__/ScheduleSearchMutation.graphql.ts
var node476 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }, v23 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfSearch",
    "kind": "LinkedField",
    "name": "search",
    "plural": false,
    "selections": [
      v32,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "JobBoardSearchSearch",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scheduleStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "result",
    "storageKey": null
  }, v6 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "ScheduleSearchMutation",
      "selections": [
        {
          "alias": null,
          "args": v23,
          "concreteType": "JobBoardSearchSearchSchedulePayload",
          "kind": "LinkedField",
          "name": "jobBoardSearchSearchSchedule",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SearchSchedulePayload",
              "kind": "LinkedField",
              "name": "searchSchedulePayload",
              "plural": false,
              "selections": [
                v4,
                v5
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v6
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "ScheduleSearchMutation",
      "selections": [
        {
          "alias": null,
          "args": v23,
          "concreteType": "JobBoardSearchSearchSchedulePayload",
          "kind": "LinkedField",
          "name": "jobBoardSearchSearchSchedule",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SearchSchedulePayload",
              "kind": "LinkedField",
              "name": "searchSchedulePayload",
              "plural": false,
              "selections": [
                v4,
                {
                  "alias": null,
                  "args": null,
                  "filters": null,
                  "handle": "prependEdge",
                  "key": "",
                  "kind": "LinkedHandle",
                  "name": "search",
                  "handleArgs": [
                    {
                      "kind": "Variable",
                      "name": "connections",
                      "variableName": "connections"
                    }
                  ]
                },
                v5
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32,
                v6
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "830f759339507582b08fbe482d8dcd4c",
      "id": null,
      "metadata": {},
      "name": "ScheduleSearchMutation",
      "operationKind": "mutation",
      "text": "mutation ScheduleSearchMutation(\n  $input: JobBoardSearchSearchScheduleInput!\n) {\n  jobBoardSearchSearchSchedule(input: $input) {\n    searchSchedulePayload {\n      search {\n        __typename\n        cursor\n        node {\n          id\n          status\n          scheduleStatus\n          createdAt\n          updatedAt\n        }\n      }\n      result\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node476.hash = "ca60f4bfb1919a9601ee89c9a3e6b387";
var ScheduleSearchMutation_graphql_default = node476;

// src/job-board-search/mutations/ScheduleSearchMutation.ts
import { createConnectedCommitMutation as createConnectedCommitMutation5 } from "shared-lib";
var mutation11 = ScheduleSearchMutation_graphql_default;
var commit10 = createConnectedCommitMutation5(mutation11);
var ScheduleSearchMutation_default = { commit: commit10 };

// src/job-board-search/mutations/__generated__/CreateSearchMutation.graphql.ts
var node477 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }, v23 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfSearch",
    "kind": "LinkedField",
    "name": "search",
    "plural": false,
    "selections": [
      v32,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "JobBoardSearchSearch",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "searchId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scheduleStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v5 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "CreateSearchMutation",
      "selections": [
        {
          "alias": "result",
          "args": v23,
          "concreteType": "JobBoardSearchSearchCreatePayload",
          "kind": "LinkedField",
          "name": "jobBoardSearchSearchCreate",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SearchPayload",
              "kind": "LinkedField",
              "name": "searchPayload",
              "plural": false,
              "selections": [
                v4
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "CreateSearchMutation",
      "selections": [
        {
          "alias": "result",
          "args": v23,
          "concreteType": "JobBoardSearchSearchCreatePayload",
          "kind": "LinkedField",
          "name": "jobBoardSearchSearchCreate",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SearchPayload",
              "kind": "LinkedField",
              "name": "searchPayload",
              "plural": false,
              "selections": [
                v4,
                {
                  "alias": null,
                  "args": null,
                  "filters": null,
                  "handle": "prependEdge",
                  "key": "",
                  "kind": "LinkedHandle",
                  "name": "search",
                  "handleArgs": [
                    {
                      "kind": "Variable",
                      "name": "connections",
                      "variableName": "connections"
                    }
                  ]
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32,
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "b4e89db09cbd1f96dd86238055faa25f",
      "id": null,
      "metadata": {},
      "name": "CreateSearchMutation",
      "operationKind": "mutation",
      "text": "mutation CreateSearchMutation(\n  $input: JobBoardSearchSearchCreateInput!\n) {\n  result: jobBoardSearchSearchCreate(input: $input) {\n    searchPayload {\n      search {\n        __typename\n        cursor\n        node {\n          id\n          searchId\n          code\n          status\n          scheduleStatus\n          createdAt\n          updatedAt\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node477.hash = "53635cd55dbc4d5a0ada6075a0b5d07a";
var CreateSearchMutation_graphql_default = node477;

// src/job-board-search/mutations/CreateSearchMutation.ts
import { useAsyncMutation as useAsyncMutation71 } from "shared-lib";
var mutationDef92 = CreateSearchMutation_graphql_default;
function useCreateJobBoardSearch() {
  const [commit11, isBusy] = useAsyncMutation71(mutationDef92);
  return [commit11, isBusy];
}

// src/job-board-search/mutations/__generated__/UseUpdateSearchMutation.graphql.ts
var node478 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }, v23 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v6 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "count",
      "storageKey": null
    }
  ], v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "jobBoardId",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfSearch",
    "kind": "LinkedField",
    "name": "search",
    "plural": false,
    "selections": [
      v32,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "JobBoardSearchSearch",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          v4,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "searchId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          v5,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "organisationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "query",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "resumeDaysOld",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "radius",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "postCode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "locationsPattern",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scheduleStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "JobBoardSearchSearchTriggerSpec",
            "kind": "LinkedField",
            "name": "searchTrigger",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startsOn",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endsOn",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cronExpression",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SearchRunStats",
            "kind": "LinkedField",
            "name": "searchRunStats",
            "plural": false,
            "selections": v6,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SearchResultStats",
            "kind": "LinkedField",
            "name": "searchResultStats",
            "plural": false,
            "selections": v6,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "JobBoardSearchSearchJobBoard",
            "kind": "LinkedField",
            "name": "jobBoards",
            "plural": true,
            "selections": [
              v7,
              {
                "alias": null,
                "args": null,
                "concreteType": "JobBoardSearchSearchParameter",
                "kind": "LinkedField",
                "name": "parameters",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "value",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "formId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "autoDownload",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "JobBoardSearchJobBoard",
            "kind": "LinkedField",
            "name": "jobBoardDefinitions",
            "plural": true,
            "selections": [
              v4,
              v7,
              v5,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "code",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v9 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "UseUpdateSearchMutation",
      "selections": [
        {
          "alias": null,
          "args": v23,
          "concreteType": "JobBoardSearchSearchUpdatePayload",
          "kind": "LinkedField",
          "name": "jobBoardSearchSearchUpdate",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SearchPayload",
              "kind": "LinkedField",
              "name": "searchPayload",
              "plural": false,
              "selections": [
                v8
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v9
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "UseUpdateSearchMutation",
      "selections": [
        {
          "alias": null,
          "args": v23,
          "concreteType": "JobBoardSearchSearchUpdatePayload",
          "kind": "LinkedField",
          "name": "jobBoardSearchSearchUpdate",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SearchPayload",
              "kind": "LinkedField",
              "name": "searchPayload",
              "plural": false,
              "selections": [
                v8,
                {
                  "alias": null,
                  "args": null,
                  "filters": null,
                  "handle": "prependEdge",
                  "key": "",
                  "kind": "LinkedHandle",
                  "name": "search",
                  "handleArgs": [
                    {
                      "kind": "Variable",
                      "name": "connections",
                      "variableName": "connections"
                    }
                  ]
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32,
                v9
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "9e8fcdd0c4c580f253542176bb34a836",
      "id": null,
      "metadata": {},
      "name": "UseUpdateSearchMutation",
      "operationKind": "mutation",
      "text": "mutation UseUpdateSearchMutation(\n  $input: JobBoardSearchSearchUpdateInput!\n) {\n  jobBoardSearchSearchUpdate(input: $input) {\n    searchPayload {\n      search {\n        __typename\n        cursor\n        node {\n          id\n          searchId\n          createdAt\n          updatedAt\n          name\n          description\n          organisationId\n          query\n          resumeDaysOld\n          radius\n          postCode\n          locationsPattern\n          status\n          scheduleStatus\n          searchTrigger {\n            startsOn\n            endsOn\n            cronExpression\n          }\n          searchRunStats {\n            count\n          }\n          searchResultStats {\n            count\n          }\n          jobBoards {\n            jobBoardId\n            parameters {\n              value\n              formId\n            }\n            autoDownload\n          }\n          jobBoardDefinitions {\n            id\n            jobBoardId\n            name\n            code\n          }\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node478.hash = "e4639cdca9a32b6b93575ddd53f1beec";
var UseUpdateSearchMutation_graphql_default = node478;

// src/job-board-search/mutations/UseUpdateSearch.ts
import { useAsyncMutation as useAsyncMutation73 } from "shared-lib";
var mutationDef93 = UseUpdateSearchMutation_graphql_default;
function useUpdateSearch() {
  const [commit11, isBusy] = useAsyncMutation73(mutationDef93);
  return [commit11, isBusy];
}

// src/job-board-search/mutations/__generated__/UseEnableJobBoardSearchModuleMutation.graphql.ts
var node479 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }, v23 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfJobBoardSearchModule",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      v32,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "JobBoardSearchModule",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isTest",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v5 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEnableJobBoardSearchModuleMutation",
      "selections": [
        {
          "alias": "result",
          "args": v23,
          "concreteType": "JobBoardSearchModuleEnablePayload",
          "kind": "LinkedField",
          "name": "jobBoardSearchModuleEnable",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "UseEnableJobBoardSearchModuleMutation",
      "selections": [
        {
          "alias": "result",
          "args": v23,
          "concreteType": "JobBoardSearchModuleEnablePayload",
          "kind": "LinkedField",
          "name": "jobBoardSearchModuleEnable",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "filters": null,
              "handle": "prependEdge",
              "key": "",
              "kind": "LinkedHandle",
              "name": "payload",
              "handleArgs": [
                {
                  "kind": "Variable",
                  "name": "connections",
                  "variableName": "connections"
                }
              ]
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32,
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "baaf464d4deee72f9ae121ffead12df2",
      "id": null,
      "metadata": {},
      "name": "UseEnableJobBoardSearchModuleMutation",
      "operationKind": "mutation",
      "text": "mutation UseEnableJobBoardSearchModuleMutation(\n  $input: JobBoardSearchModuleEnableInput!\n) {\n  result: jobBoardSearchModuleEnable(input: $input) {\n    payload {\n      __typename\n      cursor\n      node {\n        id\n        code\n        status\n        name\n        isTest\n        createdAt\n        updatedAt\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node479.hash = "cf0a38c6f4453d9ba01903e94b6f1251";
var UseEnableJobBoardSearchModuleMutation_graphql_default = node479;

// src/job-board-search/mutations/UseEnableJobBoardSearchModule.ts
import { useAsyncMutation as useAsyncMutation74 } from "shared-lib";
var mutationDef94 = UseEnableJobBoardSearchModuleMutation_graphql_default;
function useEnableJobBoardSearchModule() {
  const [commit11, isBusy] = useAsyncMutation74(mutationDef94);
  return [commit11, isBusy];
}

// src/job-board-search/components/__generated__/JobBoardSearchJobBoardEditor_search.graphql.ts
var node480 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "jobBoardId",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "JobBoardSearchJobBoardEditor_search",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "searchId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "JobBoardSearchSearchJobBoard",
        "kind": "LinkedField",
        "name": "jobBoards",
        "plural": true,
        "selections": [
          v1,
          {
            "alias": null,
            "args": null,
            "concreteType": "JobBoardSearchSearchParameter",
            "kind": "LinkedField",
            "name": "parameters",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "formId",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "autoDownload",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "JobBoardSearchJobBoard",
        "kind": "LinkedField",
        "name": "jobBoardDefinitions",
        "plural": true,
        "selections": [
          v0,
          v1,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "JobBoardSearchSearch",
    "abstractKey": null
  };
}();
node480.hash = "62375a8640058a3651baa2ba7cf1d0a2";
var JobBoardSearchJobBoardEditor_search_graphql_default = node480;

// src/job-board-search/components/JobBoardSearchJobBoardEditor.tsx
import { useState as useState119 } from "react";
import { useFragment as useFragment139 } from "react-relay/hooks";
import { Switch as Switch3 } from "@headlessui/react";
import { Button as Button113 } from "shared-ui";

// src/job-board-search/components/__generated__/JobBoardSearchJobBoardsContainerQuery.graphql.ts
var node481 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "name": "ASC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "JobBoardSearchJobBoardsContainerQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "JobBoardSearchJobBoardsSearchOptions_jobBoards"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "JobBoardSearchJobBoardsContainerQuery",
      "selections": [
        {
          "alias": "results",
          "args": v1,
          "concreteType": "JobBoardSearchJobBoardsConnection",
          "kind": "LinkedField",
          "name": "jobBoardSearchJobBoards",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "JobBoardSearchJobBoardsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "JobBoardSearchJobBoard",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobBoardId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "JobBoardMetadata",
                      "kind": "LinkedField",
                      "name": "metadata",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "constraints",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "shareable",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "results",
          "args": v1,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "JobBoardSearchJobBoardsSearchOptions_results",
          "kind": "LinkedHandle",
          "name": "jobBoardSearchJobBoards"
        }
      ]
    },
    "params": {
      "cacheID": "c5e15fd220ea28aaa332e388567e6688",
      "id": null,
      "metadata": {},
      "name": "JobBoardSearchJobBoardsContainerQuery",
      "operationKind": "query",
      "text": "query JobBoardSearchJobBoardsContainerQuery(\n  $where: JobBoardSearchJobBoardFilter!\n) {\n  ...JobBoardSearchJobBoardsSearchOptions_jobBoards\n}\n\nfragment JobBoardSearchJobBoardsSearchOptions_jobBoards on Query {\n  results: jobBoardSearchJobBoards(first: 10, order: [{name: ASC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        jobBoardId\n        name\n        code\n        metadata {\n          constraints\n          shareable\n        }\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node481.hash = "6e0ec03896d21f54a5f04ee8b9308d3f";
var JobBoardSearchJobBoardsContainerQuery_graphql_default = node481;

// src/job-board-search/components/JobBoardSearchJobBoardsContainer.tsx
import { useCallback as useCallback227, useState as useState118 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery65 } from "react-relay/hooks";

// src/job-board-search/components/JobBoardSearchJobBoardsSearchBox.tsx
var import_lodash6 = __toESM(require_lodash());
import {
  useCallback as useCallback226,
  useEffect as useEffect51,
  useMemo as useMemo41,
  useState as useState117,
  Suspense as Suspense137
} from "react";
import { ChevronUpDownIcon as ChevronUpDownIcon9 } from "@heroicons/react/24/solid";
import { Combobox as Combobox17 } from "@headlessui/react";

// src/job-board-search/components/__generated__/JobBoardSearchJobBoardsSearchOptionsPaginationQuery.graphql.ts
var node483 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v23 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v32 = [
    v1,
    v23,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "name": "ASC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "JobBoardSearchJobBoardsSearchOptionsPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v23
          ],
          "kind": "FragmentSpread",
          "name": "JobBoardSearchJobBoardsSearchOptions_jobBoards"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "JobBoardSearchJobBoardsSearchOptionsPaginationQuery",
      "selections": [
        {
          "alias": "results",
          "args": v32,
          "concreteType": "JobBoardSearchJobBoardsConnection",
          "kind": "LinkedField",
          "name": "jobBoardSearchJobBoards",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "JobBoardSearchJobBoardsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "JobBoardSearchJobBoard",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobBoardId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "JobBoardMetadata",
                      "kind": "LinkedField",
                      "name": "metadata",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "constraints",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "shareable",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "results",
          "args": v32,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "JobBoardSearchJobBoardsSearchOptions_results",
          "kind": "LinkedHandle",
          "name": "jobBoardSearchJobBoards"
        }
      ]
    },
    "params": {
      "cacheID": "9bf498e74c255be85ba6650bbb1e31c2",
      "id": null,
      "metadata": {},
      "name": "JobBoardSearchJobBoardsSearchOptionsPaginationQuery",
      "operationKind": "query",
      "text": "query JobBoardSearchJobBoardsSearchOptionsPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $where: JobBoardSearchJobBoardFilter\n) {\n  ...JobBoardSearchJobBoardsSearchOptions_jobBoards_2HEEH6\n}\n\nfragment JobBoardSearchJobBoardsSearchOptions_jobBoards_2HEEH6 on Query {\n  results: jobBoardSearchJobBoards(first: $first, after: $after, order: [{name: ASC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        jobBoardId\n        name\n        code\n        metadata {\n          constraints\n          shareable\n        }\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node483.hash = "7634e7161594f4f85028c9cbb969b9a5";
var JobBoardSearchJobBoardsSearchOptionsPaginationQuery_graphql_default = node483;

// src/job-board-search/components/__generated__/JobBoardSearchJobBoardsSearchOptions_jobBoards.graphql.ts
var node484 = function() {
  var v0 = [
    "results"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": JobBoardSearchJobBoardsSearchOptionsPaginationQuery_graphql_default
      }
    },
    "name": "JobBoardSearchJobBoardsSearchOptions_jobBoards",
    "selections": [
      {
        "alias": "results",
        "args": [
          {
            "kind": "Literal",
            "name": "order",
            "value": [
              {
                "name": "ASC"
              }
            ]
          },
          {
            "kind": "Variable",
            "name": "where",
            "variableName": "where"
          }
        ],
        "concreteType": "JobBoardSearchJobBoardsConnection",
        "kind": "LinkedField",
        "name": "__JobBoardSearchJobBoardsSearchOptions_results_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "JobBoardSearchJobBoardsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "JobBoardSearchJobBoard",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "jobBoardId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "JobBoardMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "constraints",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "shareable",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node484.hash = "7634e7161594f4f85028c9cbb969b9a5";
var JobBoardSearchJobBoardsSearchOptions_jobBoards_graphql_default = node484;

// src/job-board-search/components/JobBoardSearchJobBoardsSearchOptions.tsx
import { useEffect as useEffect50 } from "react";
import { usePaginationFragment as usePaginationFragment23 } from "react-relay/hooks";
import { Combobox as Combobox16 } from "@headlessui/react";
import { CheckIcon as CheckIcon9 } from "@heroicons/react/24/solid";
import { isNotNull as isNotNull7 } from "shared-lib";
import { classNames as classNames46 } from "shared-ui";
import { Fragment as Fragment109, jsx as jsx415, jsxs as jsxs278 } from "react/jsx-runtime";
var fragment18 = JobBoardSearchJobBoardsSearchOptions_jobBoards_graphql_default;
var JobBoardSearchJobBoardsSearchOptions = ({
  jobBoards,
  searchTerm
}) => {
  const { data, refetch } = usePaginationFragment23(fragment18, jobBoards);
  let where = { isActive: { eq: true } };
  if (searchTerm) {
    where = { or: [{ name: { startsWith: searchTerm } }] };
  }
  useEffect50(() => {
    refetch({ first: 10, where }, { fetchPolicy: "store-or-network" });
  }, [searchTerm]);
  const { results } = data;
  const rows = (results?.edges ?? []).map((edge) => edge.node).filter(isNotNull7);
  return /* @__PURE__ */ jsx415(Combobox16.Options, { className: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm", children: rows.map((result) => /* @__PURE__ */ jsx415(
    Combobox16.Option,
    {
      value: result,
      className: ({ active }) => classNames46(
        "relative cursor-default select-none py-2 pl-3 pr-9",
        active ? "bg-info-600 text-white" : "text-gray-900"
      ),
      children: ({ active, selected }) => /* @__PURE__ */ jsxs278(Fragment109, { children: [
        /* @__PURE__ */ jsx415("div", { className: "flex", children: /* @__PURE__ */ jsxs278(
          "span",
          {
            className: classNames46(
              "truncate",
              selected ? "font-semibold" : ""
            ),
            children: [
              result.name,
              " ",
              result.code
            ]
          }
        ) }),
        selected && /* @__PURE__ */ jsx415(
          "span",
          {
            className: classNames46(
              "absolute inset-y-0 right-0 flex items-center pr-4",
              active ? "bg-info-600 text-white" : "text-info-600"
            ),
            children: /* @__PURE__ */ jsx415(CheckIcon9, { className: "h-5 w-5", "aria-hidden": "true" })
          }
        )
      ] })
    },
    result.id
  )) });
};

// src/job-board-search/components/JobBoardSearchJobBoardsSearchBox.tsx
import { jsx as jsx416, jsxs as jsxs279 } from "react/jsx-runtime";
var JobBoardSearchJobBoardsSearchBox = ({
  onSelected,
  jobBoards,
  defaultValue,
  label
}) => {
  const [selected, setSelected] = useState117(
    defaultValue ?? null
  );
  const [searchTerm, setSearchTerm] = useState117("");
  const onQueryChangeHandler = useMemo41(
    () => (0, import_lodash6.debounce)((q4) => setSearchTerm(q4), 500),
    []
  );
  useEffect51(() => {
    return () => {
      onQueryChangeHandler.cancel();
    };
  }, []);
  const onSetSelected = useCallback226(
    (r4) => {
      setSelected(r4);
      onSelected(r4);
    },
    [selected]
  );
  return /* @__PURE__ */ jsxs279(Combobox17, { as: "div", value: selected, onChange: onSetSelected, children: [
    /* @__PURE__ */ jsx416(Combobox17.Label, { className: "block text-sm font-medium text-gray-700", children: label ? label : "Job Board" }),
    /* @__PURE__ */ jsxs279("div", { className: "relative mt-2", children: [
      /* @__PURE__ */ jsx416(
        Combobox17.Input,
        {
          className: "focus:border-info-500 focus:ring-info-500 w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:outline-none focus:ring-1 sm:text-sm",
          onChange: (event) => onQueryChangeHandler(event.target.value),
          displayValue: (result) => {
            if (result) {
              return `${result.name}`;
            }
            return "";
          },
          autoComplete: "off"
        }
      ),
      /* @__PURE__ */ jsx416(Combobox17.Button, { className: "absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none", children: /* @__PURE__ */ jsx416(
        ChevronUpDownIcon9,
        {
          className: "h-5 w-5 text-gray-400",
          "aria-hidden": "true"
        }
      ) }),
      /* @__PURE__ */ jsx416(Suspense137, { fallback: "Searching...", children: /* @__PURE__ */ jsx416(
        JobBoardSearchJobBoardsSearchOptions,
        {
          jobBoards,
          searchTerm
        }
      ) })
    ] })
  ] });
};

// src/job-board-search/components/JobBoardSearchJobBoardsContainer.tsx
import { jsx as jsx417 } from "react/jsx-runtime";
var graphqlQuery13 = JobBoardSearchJobBoardsContainerQuery_graphql_default;
var JobBoardSearchJobBoardsContainer = ({
  label,
  onSearchCompleted
}) => {
  const [selectedResult, setSelectedResult] = useState118();
  const onSetSelected = useCallback227(
    (r4) => {
      setSelectedResult(r4);
      onSearchCompleted(r4);
    },
    [selectedResult]
  );
  const where = { isActive: { eq: true } };
  const query3 = useLazyLoadQuery65(
    graphqlQuery13,
    { where },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsx417(
    JobBoardSearchJobBoardsSearchBox,
    {
      label,
      onSelected: onSetSelected,
      jobBoards: query3
    }
  );
};

// src/job-board-search/components/JobBoardSearchJobBoardEditor.tsx
import { jsx as jsx418, jsxs as jsxs280 } from "react/jsx-runtime";
var fragmentDef104 = JobBoardSearchJobBoardEditor_search_graphql_default;
var JobBoardSearchJobBoardEditor = ({
  fragmentRef,
  onChanged
}) => {
  const data = useFragment139(
    fragmentDef104,
    fragmentRef
  );
  function initJobBoards() {
    return mapJobBoardsFromSearch(data.jobBoards, data.jobBoardDefinitions);
  }
  const [jobBoards, setJobBoards] = useState119(initJobBoards);
  function addJobBoard(board) {
    const boards = [...jobBoards, board];
    setJobBoards(boards);
    onChanged(boards);
  }
  function updateJobBoard(board) {
    let boards = jobBoards.filter((a4) => a4.jobBoardId !== board.jobBoardId);
    boards = [...boards, board];
    setJobBoards(boards);
    onChanged(boards);
  }
  function removeJobBoard(board) {
    const boards = jobBoards.filter((a4) => a4.jobBoardId !== board.jobBoardId);
    setJobBoards(boards);
    onChanged(boards);
  }
  function toggleAutoDownloadJobBoard(board) {
    const newBoard = {
      ...board,
      autoDownload: !board.autoDownload
    };
    updateJobBoard(newBoard);
  }
  return /* @__PURE__ */ jsxs280("div", { className: "", children: [
    /* @__PURE__ */ jsx418("div", { className: "p-2", children: /* @__PURE__ */ jsx418(
      JobBoardSearchJobBoardsContainer,
      {
        label: "Search Job Boards",
        onSearchCompleted: (result) => {
          const newJobBoard = {
            jobBoardId: result.jobBoardId,
            name: result.name,
            parameters: [],
            autoDownload: false
          };
          addJobBoard(newJobBoard);
        }
      }
    ) }),
    /* @__PURE__ */ jsxs280("div", { className: "mt-3 p-2", children: [
      /* @__PURE__ */ jsx418("div", { className: "text-info-500 font-medium", children: "Job Boards" }),
      /* @__PURE__ */ jsx418("ul", { children: jobBoards.map((j4) => /* @__PURE__ */ jsx418("li", { children: /* @__PURE__ */ jsxs280("div", { className: "flex items-center justify-between", children: [
        /* @__PURE__ */ jsxs280("div", { children: [
          /* @__PURE__ */ jsx418("div", { children: j4.name }),
          /* @__PURE__ */ jsx418("div", { children: /* @__PURE__ */ jsxs280(
            Switch3,
            {
              checked: j4.autoDownload,
              onChange: () => toggleAutoDownloadJobBoard(j4),
              className: `${j4.autoDownload ? "bg-info-600" : "bg-gray-200"} relative inline-flex h-6 w-11 items-center rounded-full`,
              children: [
                /* @__PURE__ */ jsx418("span", { className: "sr-only", children: "Enable notifications" }),
                /* @__PURE__ */ jsx418(
                  "span",
                  {
                    className: `${j4.autoDownload ? "translate-x-6" : "translate-x-1"} inline-block h-4 w-4 transform rounded-full bg-white`
                  }
                )
              ]
            }
          ) })
        ] }),
        /* @__PURE__ */ jsx418("div", { children: /* @__PURE__ */ jsx418(
          Button113,
          {
            clicked: () => {
              removeJobBoard(j4);
            },
            children: "x"
          }
        ) })
      ] }) }, j4.jobBoardId)) })
    ] })
  ] });
};

// src/job-board-search/components/JobBoardSearchDetailForm.tsx
import { jsx as jsx419, jsxs as jsxs281 } from "react/jsx-runtime";
var dataSchema = {
  type: "object",
  properties: {
    query: {
      type: "string",
      minLength: 1,
      description: 'Search Query e.g. rail AND "project manager"'
    },
    locationsPattern: {
      type: "string",
      minLength: 3,
      description: "Location pattern e.g UK|London"
    },
    resumeDaysOld: {
      type: "number",
      description: "How old the resume can be (days)"
    },
    radius: {
      type: "number",
      description: "Radius around location (miles)"
    },
    postCode: {
      type: "string",
      description: "A location as a postcode (optional)"
    },
    description: {
      type: "string",
      minLength: 3,
      description: "Description of the search"
    }
  },
  required: ["query", "locationsPattern"]
};
var uiSchema = {
  type: "VerticalLayout",
  elements: [
    {
      type: "Control",
      scope: "#/properties/query"
    },
    {
      type: "Control",
      scope: "#/properties/locationsPattern"
    },
    {
      type: "Control",
      scope: "#/properties/resumeDaysOld"
    },
    {
      type: "Control",
      scope: "#/properties/radius"
    },
    {
      type: "Control",
      scope: "#/properties/postCode"
    },
    {
      type: "Control",
      scope: "#/properties/description"
    }
  ]
};
var fragmentDef105 = JobBoardSearchDetailForm_search_graphql_default;
var JobBoardSearchDetailForm = ({
  fragmentRef,
  onDone,
  onCancel,
  onError
}) => {
  const data = useFragment140(
    fragmentDef105,
    fragmentRef
  );
  function initJobBoards() {
    return mapJobBoardsFromSearch(data.jobBoards, data.jobBoardDefinitions);
  }
  function initForm() {
    return {
      query: data.query,
      locationsPattern: data.locationsPattern,
      resumeDaysOld: data.resumeDaysOld,
      radius: data.radius,
      postCode: data.postCode,
      description: data.description
    };
  }
  const [hasErrors, setHasErrors] = useState120(false);
  const [jobBoards, setJobBoards] = useState120(initJobBoards);
  const [formData, setFormData] = useState120(initForm);
  const onChange = useCallback228(
    (form) => {
      setFormData(form);
    },
    [formData]
  );
  const [saveSearch, isSavingSearch] = useUpdateSearch();
  const onSave = useCallback228(
    async (form) => {
      if (!form.query || !form.locationsPattern) {
        return;
      }
      const updatedJobBoards = jobBoards.map((j4) => {
        return {
          jobBoardId: j4.jobBoardId,
          autoDownload: j4.autoDownload,
          searchParameters: j4.parameters
        };
      });
      const clientMutationId = createClientMutationId93();
      const input = {
        input: {
          id: data.searchId,
          query: form.query,
          description: form.description,
          resumeDaysOld: form.resumeDaysOld,
          radius: form.radius,
          locationsPattern: form.locationsPattern,
          postCode: form.postCode,
          jobBoards: updatedJobBoards,
          clientMutationId
        }
      };
      const response = await saveSearch({
        connections: [],
        input
      });
      if (response.jobBoardSearchSearchUpdate.searchPayload) {
        onDone();
      } else if (response.jobBoardSearchSearchUpdate.userErrors) {
        onError(response.jobBoardSearchSearchUpdate.userErrors);
      }
    },
    [formData, jobBoards]
  );
  return /* @__PURE__ */ jsxs281("div", { children: [
    /* @__PURE__ */ jsxs281("div", { className: "items-top flex justify-between", children: [
      /* @__PURE__ */ jsx419("div", { className: "flex-1", children: /* @__PURE__ */ jsx419(JsonFormsStyleContext2.Provider, { value: elevateJsonFormsStyleContext2, children: /* @__PURE__ */ jsx419(
        JsonForms2,
        {
          data: formData,
          schema: dataSchema,
          uischema: uiSchema,
          renderers: elevateJsonFormsRenderers2,
          cells: elevateJsonFormsCells2,
          onChange: (form) => {
            onChange(form.data);
            if (form.errors) {
              const hasError = form.errors.filter((e4) => e4.data).length > 0;
              setHasErrors(hasError);
            } else {
              setHasErrors(false);
            }
          }
        }
      ) }) }),
      /* @__PURE__ */ jsx419("div", { className: "ml-3 flex-1", children: /* @__PURE__ */ jsx419(
        JobBoardSearchJobBoardEditor,
        {
          fragmentRef: data,
          onChanged: (boards) => {
            setJobBoards(boards);
          }
        }
      ) })
    ] }),
    /* @__PURE__ */ jsxs281(ButtonList44, { children: [
      /* @__PURE__ */ jsx419(
        Button114,
        {
          color: "primary",
          disabled: hasErrors,
          clicked: () => {
            onSave(formData);
          },
          children: "Save"
        }
      ),
      /* @__PURE__ */ jsx419(
        Button114,
        {
          color: "gray",
          clicked: () => {
            onCancel();
          },
          children: "Cancel"
        }
      )
    ] })
  ] });
};

// src/job-board-search/components/JobBoardSearchScheduleForm.tsx
import { useCallback as useCallback229, useState as useState121 } from "react";
import { ConnectionHandler as ConnectionHandler9, useRelayEnvironment as useRelayEnvironment8 } from "react-relay/hooks";
import { addYears as addYears2 } from "date-fns";
import { Button as Button115, CronEditor } from "shared-ui";
import { createClientMutationId as createClientMutationId94, useToggle as useToggle44 } from "shared-lib";
import { jsx as jsx420, jsxs as jsxs283 } from "react/jsx-runtime";
var initialData = {
  startDate: /* @__PURE__ */ new Date(),
  endDate: addYears2(/* @__PURE__ */ new Date(), 1),
  cronExpression: ""
};
var JobBoardSearchScheduleForm = ({
  searchId,
  onDone,
  onError,
  onCancel
}) => {
  const environment = useRelayEnvironment8();
  const connectionId = ConnectionHandler9.getConnectionID(
    "root",
    // passed as input to the mutation/subscription
    "JobBoardSearchList_searches"
  );
  const [isBusy, toggleIsBusy] = useToggle44();
  const [data, setData] = useState121(initialData);
  const onChange = useCallback229(
    (cronState) => {
      setData(cronState);
    },
    [data]
  );
  const onScheduleSearch = useCallback229(() => {
    if (!data || !data.cronExpression || !data.startDate || !data.endDate) {
      return;
    }
    toggleIsBusy();
    const clientMutationId = createClientMutationId94();
    const input = {
      searchId,
      cronExpression: data.cronExpression,
      startsOn: data.startDate.toDateString(),
      endsOn: data.endDate.toDateString(),
      clientMutationId
    };
    ScheduleSearchMutation_default.commit(
      environment,
      input,
      connectionId,
      () => {
        toggleIsBusy();
        onDone();
      },
      (error) => {
        toggleIsBusy();
        onError(error);
      }
    );
  }, [data]);
  return /* @__PURE__ */ jsxs283("div", { children: [
    /* @__PURE__ */ jsx420(CronEditor, { data, onChanged: onChange }),
    /* @__PURE__ */ jsxs283("div", { className: "mt-2 flex justify-end space-x-2 border-t border-gray-100 pt-3", children: [
      /* @__PURE__ */ jsx420(Button115, { disabled: isBusy, color: "primary", clicked: onScheduleSearch, children: "Schedule" }),
      /* @__PURE__ */ jsx420(Button115, { disabled: isBusy, clicked: onCancel, children: "Cancel" })
    ] })
  ] });
};

// src/job-board-search/components/__generated__/JobBoardSearchCreateRunButton_search.graphql.ts
var node485 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobBoardSearchCreateRunButton_search",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "searchId",
      "storageKey": null
    }
  ],
  "type": "JobBoardSearchSearch",
  "abstractKey": null
};
node485.hash = "262db81361392e13dd99ef185768fdf4";
var JobBoardSearchCreateRunButton_search_graphql_default = node485;

// src/job-board-search/components/JobBoardSearchCreateRunButton.tsx
import { useCallback as useCallback230 } from "react";
import { useFragment as useFragment141, useRelayEnvironment as useRelayEnvironment9 } from "react-relay/hooks";
import { Button as Button116 } from "shared-ui";
import { createClientMutationId as createClientMutationId95, useToggle as useToggle45 } from "shared-lib";
import { jsx as jsx421 } from "react/jsx-runtime";
var fragment19 = JobBoardSearchCreateRunButton_search_graphql_default;
var JobBoardSearchCreateRunButton = ({
  search: search4,
  onDone,
  onError
}) => {
  const data = useFragment141(
    fragment19,
    search4
  );
  const [isBusy, toggleIsBusy] = useToggle45(false);
  const environment = useRelayEnvironment9();
  const onSave = useCallback230(() => {
    if (!data) {
      return;
    }
    toggleIsBusy();
    const clientMutationId = createClientMutationId95();
    const input = {
      id: data.searchId,
      clientMutationId
    };
    CreateSearchRunMutation_default.commit(
      environment,
      input,
      () => {
        onDone();
        toggleIsBusy();
      },
      (error) => {
        onError(error);
      }
    );
  }, [data]);
  return /* @__PURE__ */ jsx421("div", { children: /* @__PURE__ */ jsx421(
    Button116,
    {
      disabled: isBusy,
      color: "primary",
      confirmMessage: "Confirm Run New Search ?",
      clicked: () => {
        onSave();
      },
      children: "Run New Search"
    }
  ) });
};

// src/job-board-search/components/JobBoardSearchContainer.tsx
import { jsx as jsx423, jsxs as jsxs284 } from "react/jsx-runtime";
var searchMachine = createMachine3({
  id: "search",
  initial: "loading",
  states: {
    loading: {},
    drafted: {
      initial: "viewing",
      states: {
        viewing: {
          on: {
            EDIT: { target: "editing" },
            DELETE: { target: "#deleting" }
          }
        },
        editing: {
          on: {
            CANCEL: { target: "viewing" },
            DELETE: { target: "#deleting" }
          }
        }
      }
    },
    activated: {
      initial: "viewing",
      states: {
        viewing: {
          on: {
            EDIT: { target: "editing" },
            SCHEDULE: { target: "#scheduling" },
            DELETE: { target: "#deleting" },
            CLOSE: { target: "#closing" }
          }
        },
        editing: {
          on: {
            CANCEL: { target: "viewing" },
            DELETE: { target: "#deleting" },
            CLOSE: { target: "#closing" }
          }
        }
      }
    },
    scheduling: {
      id: "scheduling",
      on: {
        SCHEDULE: { target: "activated" },
        CANCEL: { target: "activated" }
      }
    },
    deleting: {
      id: "deleting",
      on: {
        SCHEDULE: { target: "activated" },
        CANCEL: { target: "activated" }
      }
    },
    closing: {
      id: "closing",
      on: {
        SCHEDULE: { target: "activated" },
        CANCEL: { target: "activated" }
      }
    },
    closed: {
      id: "closed"
    }
  }
});
var fragment20 = JobBoardSearchContainer_search_graphql_default;
function getStateFromStatus(status) {
  switch (status) {
    case "DRAFT": {
      return "drafted";
    }
    case "ACTIVE": {
      return "activated";
    }
    case "CLOSED": {
      return "closed";
    }
  }
  return "loading";
}
function hasExecuted(data) {
  return !!data.searchRunStats?.count && data.searchRunStats?.count > 0;
}
var JobBoardSearchHeader = ({ name, status, scheduleStatus }) => {
  return /* @__PURE__ */ jsxs284("div", { className: "flex items-center space-x-2 text-lg", children: [
    /* @__PURE__ */ jsx423("div", { className: "text-info-500", children: name }),
    /* @__PURE__ */ jsx423("div", { children: status }),
    /* @__PURE__ */ jsx423("div", { children: scheduleStatus })
  ] });
};
var JobBoardSearchContainer = ({
  search: search4,
  onUpdate
}) => {
  const data = useFragment143(
    fragment20,
    search4
  );
  const initialState2 = useMemo43(() => {
    return searchMachine.resolveState(
      State.from(getStateFromStatus(data.status) ?? searchMachine.initialState)
    );
  }, [data.status]);
  const [state, send] = useMachine3(searchMachine, {
    state: initialState2
  });
  if (!data) {
    return /* @__PURE__ */ jsx423("div", { children: "No Search Details Available." });
  }
  return /* @__PURE__ */ jsxs284("div", { className: "", children: [
    state.matches("loading") && /* @__PURE__ */ jsx423("div", { className: "text-info-500 text-md font-medium", children: "Loading....." }),
    state.matches("drafted") && /* @__PURE__ */ jsx423(
      JobBoardSearchHeader,
      {
        name: data.name,
        status: data.status,
        scheduleStatus: data.scheduleStatus
      }
    ),
    state.matches("drafted.viewing") && /* @__PURE__ */ jsxs284("div", { children: [
      /* @__PURE__ */ jsx423("div", { className: "my-4", children: /* @__PURE__ */ jsx423(JobBoardSearchDetailView, { search: data }) }),
      /* @__PURE__ */ jsxs284(ButtonList45, { justify: "START", children: [
        /* @__PURE__ */ jsx423(
          Button117,
          {
            color: "primary",
            clicked: () => {
              send("EDIT");
            },
            children: "Edit"
          }
        ),
        /* @__PURE__ */ jsx423(
          JobBoardSearchActivateButton,
          {
            search: data,
            onDone: () => {
              onUpdate();
              send("ACTIVATE");
            },
            onError: (e4) => {
              console.error(e4);
            }
          }
        ),
        /* @__PURE__ */ jsx423(
          Button117,
          {
            color: "warning",
            clicked: () => {
              send("DELETE");
            },
            children: "Delete"
          }
        )
      ] })
    ] }),
    state.matches("drafted.editing") && /* @__PURE__ */ jsx423("div", { className: "my-4", children: /* @__PURE__ */ jsx423(
      JobBoardSearchDetailForm,
      {
        fragmentRef: data,
        onDone: () => {
          onUpdate();
          send("CANCEL");
        },
        onCancel: () => {
          send("CANCEL");
        },
        onError: (e4) => {
          console.error(e4);
        }
      }
    ) }),
    state.matches("activated") && /* @__PURE__ */ jsx423(
      JobBoardSearchHeader,
      {
        name: data.name,
        status: data.status,
        scheduleStatus: data.scheduleStatus
      }
    ),
    state.matches("activated.viewing") && /* @__PURE__ */ jsxs284("div", { className: "mt-3", children: [
      data.scheduleStatus === "SCHEDULED" && /* @__PURE__ */ jsx423("div", { className: "my-2 border-b border-gray-100 pb-2", children: data.searchTrigger && data.searchTrigger.cronExpression ? /* @__PURE__ */ jsx423("div", { children: /* @__PURE__ */ jsx423("div", { className: "my-2 border-b border-gray-100 pb-2", children: /* @__PURE__ */ jsx423(CronSummary, { cron: data.searchTrigger.cronExpression }) }) }) : /* @__PURE__ */ jsx423("div", { children: /* @__PURE__ */ jsx423("p", { className: "text-danger-300 text-sm font-medium", children: "There's a problem with the schedule, could not load from the server." }) }) }),
      /* @__PURE__ */ jsx423("div", { className: "mt-3", children: /* @__PURE__ */ jsxs284(ButtonList45, { justify: "START", children: [
        /* @__PURE__ */ jsx423(
          Button117,
          {
            color: "primary",
            clicked: () => {
              send("EDIT");
            },
            children: "Edit"
          }
        ),
        /* @__PURE__ */ jsx423(
          Button117,
          {
            color: "primary",
            clicked: () => {
              send("SCHEDULE");
            },
            children: "Reschedule"
          }
        ),
        /* @__PURE__ */ jsx423(
          JobBoardSearchCreateRunButton,
          {
            search: data,
            onDone: () => {
              onUpdate();
            },
            onError: (e4) => {
              console.error(e4);
            }
          }
        ),
        hasExecuted(data) ? /* @__PURE__ */ jsx423(
          Button117,
          {
            color: "warning",
            clicked: () => {
              send("CLOSE");
            },
            children: "Close"
          }
        ) : /* @__PURE__ */ jsx423(
          Button117,
          {
            color: "warning",
            clicked: () => {
              send("DELETE");
            },
            children: "Delete"
          }
        )
      ] }) })
    ] }),
    state.matches("activated.editing") && /* @__PURE__ */ jsx423("div", { className: "my-4 md:w-2/3", children: /* @__PURE__ */ jsx423(
      JobBoardSearchDetailForm,
      {
        fragmentRef: data,
        onDone: () => {
          onUpdate();
          send("CANCEL");
        },
        onCancel: () => {
          send("CANCEL");
        },
        onError: (e4) => {
          console.error(e4);
        }
      }
    ) }),
    state.matches("scheduling") && /* @__PURE__ */ jsxs284("div", { children: [
      /* @__PURE__ */ jsx423(
        JobBoardSearchHeader,
        {
          name: data.name,
          status: data.status,
          scheduleStatus: data.scheduleStatus
        }
      ),
      /* @__PURE__ */ jsxs284("div", { className: "card", children: [
        /* @__PURE__ */ jsx423("div", { className: "flex items-center justify-between", children: /* @__PURE__ */ jsx423("div", { className: "text-info-500 text-lg font-bold", children: "Scheduling" }) }),
        /* @__PURE__ */ jsx423("div", { className: "my-4 space-y-8 divide-y divide-gray-200", children: /* @__PURE__ */ jsx423(
          JobBoardSearchScheduleForm,
          {
            searchId: data.searchId,
            onDone: () => {
              onUpdate();
              send("SCHEDULE");
            },
            onCancel: () => {
              send("CANCEL");
            },
            onError: (e4) => {
              console.error(e4);
            }
          }
        ) })
      ] })
    ] }),
    state.matches("deleting") && /* @__PURE__ */ jsxs284("div", { children: [
      /* @__PURE__ */ jsx423(
        JobBoardSearchHeader,
        {
          name: data.name,
          status: data.status,
          scheduleStatus: data.scheduleStatus
        }
      ),
      /* @__PURE__ */ jsx423("div", { className: "mt-3", children: /* @__PURE__ */ jsxs284(ButtonList45, { justify: "START", children: [
        /* @__PURE__ */ jsx423(
          Button117,
          {
            color: "primary",
            clicked: () => {
              send("EDIT");
            },
            children: "Cancel"
          }
        ),
        /* @__PURE__ */ jsx423(
          Button117,
          {
            color: "warning",
            confirmMessage: "Delete, Are you sure ?",
            clicked: () => {
              send("DELETE");
            },
            children: "Delete"
          }
        )
      ] }) })
    ] }),
    state.matches("closing") && /* @__PURE__ */ jsx423("div", { children: /* @__PURE__ */ jsx423("div", { className: "text-info-500 text-lg font-bold", children: "Closing" }) }),
    state.matches("closed") && /* @__PURE__ */ jsx423("div", { children: /* @__PURE__ */ jsx423("div", { className: "text-info-500 text-lg font-bold", children: "Closed" }) })
  ] });
};

// src/job-board-search/components/__generated__/JobBoardSearchListPaginationQuery.graphql.ts
var node486 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "order"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "organisationId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v23 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v32 = [
    v1,
    v23,
    {
      "kind": "Variable",
      "name": "order",
      "variableName": "order"
    },
    {
      "kind": "Variable",
      "name": "organisationId",
      "variableName": "organisationId"
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "JobBoardSearchListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v23
          ],
          "kind": "FragmentSpread",
          "name": "JobBoardSearchList_searches"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "JobBoardSearchListPaginationQuery",
      "selections": [
        {
          "alias": "searches",
          "args": v32,
          "concreteType": "JobBoardSearchSearchesConnection",
          "kind": "LinkedField",
          "name": "jobBoardSearchSearches",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "JobBoardSearchSearchesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "JobBoardSearchSearch",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "searchId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "organisationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "query",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "resumeDaysOld",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "radius",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "postCode",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "locationsPattern",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "scheduleStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "searches",
          "args": v32,
          "filters": [],
          "handle": "connection",
          "key": "JobBoardSearchList_searches",
          "kind": "LinkedHandle",
          "name": "jobBoardSearchSearches"
        }
      ]
    },
    "params": {
      "cacheID": "27d40e41a2fd608c26935964fb4d3362",
      "id": null,
      "metadata": {},
      "name": "JobBoardSearchListPaginationQuery",
      "operationKind": "query",
      "text": "query JobBoardSearchListPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $order: [JobBoardSearchSearchSort!]\n  $organisationId: UUID!\n  $where: JobBoardSearchSearchFilter\n) {\n  ...JobBoardSearchList_searches_2HEEH6\n}\n\nfragment JobBoardSearchList_searches_2HEEH6 on Query {\n  searches: jobBoardSearchSearches(organisationId: $organisationId, first: $first, after: $after, order: $order, where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        code\n        searchId\n        ...JobBoardSearchRow_search\n        __typename\n      }\n    }\n  }\n}\n\nfragment JobBoardSearchRow_search on JobBoardSearchSearch {\n  id\n  code\n  searchId\n  createdAt\n  updatedAt\n  name\n  description\n  organisationId\n  query\n  resumeDaysOld\n  radius\n  postCode\n  locationsPattern\n  status\n  scheduleStatus\n}\n"
    }
  };
}();
node486.hash = "92dfd8a0d9ea8bb2e731b71dc437d068";
var JobBoardSearchListPaginationQuery_graphql_default = node486;

// src/job-board-search/components/__generated__/JobBoardSearchList_searches.graphql.ts
var node487 = function() {
  var v0 = [
    "searches"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "order"
      },
      {
        "kind": "RootArgument",
        "name": "organisationId"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": JobBoardSearchListPaginationQuery_graphql_default
      }
    },
    "name": "JobBoardSearchList_searches",
    "selections": [
      {
        "alias": "searches",
        "args": null,
        "concreteType": "JobBoardSearchSearchesConnection",
        "kind": "LinkedField",
        "name": "__JobBoardSearchList_searches_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "JobBoardSearchSearchesEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "JobBoardSearchSearch",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "searchId",
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "JobBoardSearchRow_search"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node487.hash = "92dfd8a0d9ea8bb2e731b71dc437d068";
var JobBoardSearchList_searches_graphql_default = node487;

// src/job-board-search/components/JobBoardSearchList.tsx
import { useCallback as useCallback233 } from "react";
import { usePaginationFragment as usePaginationFragment24 } from "react-relay/hooks";
import {
  EdListHeader,
  EdTable as EdTable5,
  selectColumn,
  SortDir as SortDir9
} from "shared-ui";
import { isNotNull as isNotNull8 } from "shared-lib";

// src/job-board-search/components/__generated__/JobBoardSearchRow_search.graphql.ts
var node488 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobBoardSearchRow_search",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "searchId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "organisationId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "query",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "resumeDaysOld",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "radius",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "postCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "locationsPattern",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "scheduleStatus",
      "storageKey": null
    }
  ],
  "type": "JobBoardSearchSearch",
  "abstractKey": null
};
node488.hash = "8b246a2d0bd0584cdd03413c9c5fcc3c";
var JobBoardSearchRow_search_graphql_default = node488;

// src/job-board-search/components/JobBoardSearchRow.tsx
import { useCallback as useCallback231 } from "react";
import { useFragment as useFragment144 } from "react-relay/hooks";
import { EdActionCell as EdActionCell3, EdColumnCell as EdColumnCell6, EdRow as EdRow6, LinkButton as LinkButton7 } from "shared-ui";
import { formatDateTime as formatDateTime3 } from "shared-lib";
import { jsx as jsx424, jsxs as jsxs285 } from "react/jsx-runtime";
var search = JobBoardSearchRow_search_graphql_default;
var JobBoardSearchRow = (props) => {
  const data = useFragment144(search, props.search);
  const select = useCallback231(() => {
    props.selected(data);
  }, []);
  return /* @__PURE__ */ jsxs285(EdRow6, { clicked: select, rowKey: data.id, children: [
    /* @__PURE__ */ jsx424(EdColumnCell6, { children: data.name }),
    /* @__PURE__ */ jsx424(EdColumnCell6, { children: data.query }),
    /* @__PURE__ */ jsx424(EdColumnCell6, { children: formatDateTime3(data.createdAt) }),
    /* @__PURE__ */ jsx424(EdColumnCell6, { children: formatDateTime3(data.updatedAt) }),
    /* @__PURE__ */ jsx424(EdColumnCell6, { children: data.status }),
    /* @__PURE__ */ jsx424(EdColumnCell6, { children: data.scheduleStatus }),
    /* @__PURE__ */ jsx424(EdActionCell3, { children: /* @__PURE__ */ jsx424(LinkButton7, { label: "Select", clicked: select }) })
  ] });
};

// src/job-board-search/components/JobBoardSearchList.tsx
import { jsx as jsx425, jsxs as jsxs286 } from "react/jsx-runtime";
var defaultColumns2 = [
  { id: "name", name: "Name" },
  { id: "query", name: "Query" },
  { id: "createdOn", name: "Created On", sort: true },
  {
    id: "updatedOn",
    name: "Last Elevate Update",
    sort: true,
    sortValue: SortDir9.Desc
  },
  { id: "status", name: "Status" },
  { id: "scheduleStatus", name: "Schedule" }
];
var fragment21 = JobBoardSearchList_searches_graphql_default;
var JobBoardSearchList = ({
  onSelect,
  searchesKey
}) => {
  const paging = usePaginationFragment24(fragment21, searchesKey);
  const onSortChanged = useCallback233((columns) => {
    const hasOrderBy = columns.filter((c4) => c4.sort && c4.sortValue).length > 0;
    if (hasOrderBy === false) {
      return;
    }
    const orderBy = [];
    const createdAt = selectColumn("createdOn", columns);
    if (createdAt) {
      orderBy.push({ createdAt });
    }
    const updatedAt = selectColumn("updatedOn", columns);
    if (updatedAt) {
      orderBy.push({ updatedAt });
    }
    refetch(
      { first: 10, order: orderBy },
      {
        fetchPolicy: "network-only",
        onComplete: (e4) => {
          if (e4) {
            console.error(e4);
          }
        }
      }
    );
  }, []);
  const { data, refetch } = paging;
  const nodes = (data.searches?.edges ?? []).map((edge) => edge.node).filter(isNotNull8);
  const rows = nodes.map((node566) => {
    return /* @__PURE__ */ jsx425(JobBoardSearchRow, { search: node566, selected: onSelect }, node566.id);
  });
  return /* @__PURE__ */ jsxs286("div", { children: [
    /* @__PURE__ */ jsx425(EdListHeader, { total: data.searches?.totalCount, paging }),
    /* @__PURE__ */ jsx425("div", { className: "flex", children: /* @__PURE__ */ jsx425("div", { className: "w-full", children: /* @__PURE__ */ jsx425(
      EdTable5,
      {
        defaultColumns: defaultColumns2,
        rows,
        onSortChanged
      }
    ) }) })
  ] });
};

// src/job-board-search/components/JobBoardSearchNewForm.tsx
import { useCallback as useCallback234, useState as useState123 } from "react";
import { ConnectionHandler as ConnectionHandler10, useRelayEnvironment as useRelayEnvironment10 } from "react-relay/hooks";
import { JsonFormsStyleContext as JsonFormsStyleContext3 } from "@jsonforms/vanilla-renderers";
import { JsonForms as JsonForms3 } from "@jsonforms/react";
import {
  Button as Button118,
  ButtonList as ButtonList46,
  elevateJsonFormsCells as elevateJsonFormsCells3,
  elevateJsonFormsRenderers as elevateJsonFormsRenderers3,
  elevateJsonFormsStyleContext as elevateJsonFormsStyleContext3
} from "shared-ui";
import { createClientMutationId as createClientMutationId96 } from "shared-lib";
import { jsx as jsx426, jsxs as jsxs287 } from "react/jsx-runtime";
var dataSchema2 = {
  type: "object",
  properties: {
    name: {
      type: "string",
      minLength: 3,
      description: "Name of the Search e.g. Senior Rail Engineer, Luton"
    }
  },
  required: ["name"]
};
var uiSchema2 = {
  type: "VerticalLayout",
  elements: [
    {
      type: "Control",
      scope: "#/properties/name"
    }
  ]
};
var JobBoardSearchNewForm = ({
  organisationId,
  onDone,
  onCancel
}) => {
  const [serverError, setServerError] = useState123(null);
  const [hasErrors, setHasErrors] = useState123(false);
  const [data, setData] = useState123();
  const environment = useRelayEnvironment10();
  const [createSearch, isCreatingSearch] = useCreateJobBoardSearch();
  const connectionId = ConnectionHandler10.getConnectionID(
    "root",
    // passed as input to the mutation/subscription
    "JobBoardSearchList_searches"
  );
  const onChange = useCallback234(
    (form) => {
      setData(form);
    },
    [data]
  );
  const onSave = useCallback234(async () => {
    if (!data?.name) {
      return;
    }
    const input = {
      input: {
        clientMutationId: createClientMutationId96(),
        organisationId,
        name: data.name
      }
    };
    const response = await createSearch({ connections: [connectionId], input });
    const search4 = response?.result?.searchPayload?.search?.node;
    if (search4) {
      onDone(search4.code);
    }
  }, [data]);
  return /* @__PURE__ */ jsxs287("div", { children: [
    serverError && /* @__PURE__ */ jsxs287("div", { children: [
      /* @__PURE__ */ jsx426("div", { children: "Error Creating Search" }),
      /* @__PURE__ */ jsx426("div", { children: serverError })
    ] }),
    /* @__PURE__ */ jsx426(JsonFormsStyleContext3.Provider, { value: elevateJsonFormsStyleContext3, children: /* @__PURE__ */ jsx426(
      JsonForms3,
      {
        data,
        schema: dataSchema2,
        uischema: uiSchema2,
        renderers: elevateJsonFormsRenderers3,
        cells: elevateJsonFormsCells3,
        onChange: (form) => {
          onChange(form.data);
          if (form.errors) {
            const hasError = form.errors.filter((e4) => e4.data).length > 0;
            setHasErrors(hasError);
          } else {
            setHasErrors(false);
          }
        }
      }
    ) }),
    /* @__PURE__ */ jsxs287(ButtonList46, { children: [
      /* @__PURE__ */ jsx426(Button118, { color: "primary", disabled: hasErrors, clicked: onSave, children: "Create Search" }),
      /* @__PURE__ */ jsx426(
        Button118,
        {
          color: "gray",
          clicked: () => {
            onCancel();
          },
          children: "Cancel"
        }
      )
    ] })
  ] });
};

// src/job-board-search/components/__generated__/JobBoardSearchResultDownloadButton_searchResult.graphql.ts
var node489 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobBoardSearchResultDownloadButton_searchResult",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "searchResultId",
      "storageKey": null
    }
  ],
  "type": "JobBoardSearchSearchResult",
  "abstractKey": null
};
node489.hash = "fb47296f225b0ea3e2cb156cb2e67cb6";
var JobBoardSearchResultDownloadButton_searchResult_graphql_default = node489;

// src/job-board-search/components/JobBoardSearchResultDownloadButton.tsx
import { useCallback as useCallback235 } from "react";
import {
  ConnectionHandler as ConnectionHandler11,
  useFragment as useFragment145,
  useRelayEnvironment as useRelayEnvironment11
} from "react-relay/hooks";
import { Button as Button119 } from "shared-ui";
import { createClientMutationId as createClientMutationId97 } from "shared-lib";
import { jsx as jsx427 } from "react/jsx-runtime";
var fragment22 = JobBoardSearchResultDownloadButton_searchResult_graphql_default;
var JobBoardSearchResultDownloadButton = ({
  searchResult,
  onDone,
  onError
}) => {
  const data = useFragment145(
    fragment22,
    searchResult
  );
  const environment = useRelayEnvironment11();
  const connectionId = ConnectionHandler11.getConnectionID(
    "root",
    // passed as input to the mutation/subscription
    "JobBoardSearchResultList_results"
  );
  const onSave = useCallback235(() => {
    if (!data) {
      return;
    }
    const clientMutationId = createClientMutationId97();
    const input = {
      id: data.searchResultId,
      clientMutationId
    };
    DownloadSearchResultMutation_default.commit(
      environment,
      input,
      connectionId,
      () => {
        onDone();
      },
      (error) => {
        onError(error);
      }
    );
  }, [data]);
  return /* @__PURE__ */ jsx427("div", { children: /* @__PURE__ */ jsx427(
    Button119,
    {
      color: "primary",
      confirmMessage: "Download, Are you sure ? ",
      clicked: () => {
        onSave();
      },
      children: "Download"
    }
  ) });
};

// src/job-board-search/components/__generated__/JobBoardSearchResultListPaginationQuery.graphql.ts
var node490 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "order"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "organisationId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v23 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v32 = [
    v1,
    v23,
    {
      "kind": "Variable",
      "name": "order",
      "variableName": "order"
    },
    {
      "kind": "Variable",
      "name": "organisationId",
      "variableName": "organisationId"
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "JobBoardSearchResultListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v23
          ],
          "kind": "FragmentSpread",
          "name": "JobBoardSearchResultList_results"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "JobBoardSearchResultListPaginationQuery",
      "selections": [
        {
          "alias": "results",
          "args": v32,
          "concreteType": "JobBoardSearchSearchResultsConnection",
          "kind": "LinkedField",
          "name": "jobBoardSearchSearchResults",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "JobBoardSearchSearchResultsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "JobBoardSearchSearchResult",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "searchResultId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "organisationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "searchId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "firstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "availability",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "cvId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "type",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sourceKey",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sourceFullName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "score",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "salary",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "rank",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "location",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastPosition",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "snippets",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "recordMatchStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "downloadStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "parseStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "profileId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "results",
          "args": v32,
          "filters": [],
          "handle": "connection",
          "key": "JobBoardSearchResultList_results",
          "kind": "LinkedHandle",
          "name": "jobBoardSearchSearchResults"
        }
      ]
    },
    "params": {
      "cacheID": "f05edd4f0ce067de37ddea92f925524b",
      "id": null,
      "metadata": {},
      "name": "JobBoardSearchResultListPaginationQuery",
      "operationKind": "query",
      "text": "query JobBoardSearchResultListPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $order: [JobBoardSearchSearchResultSort!]\n  $organisationId: UUID!\n  $where: JobBoardSearchSearchResultFilter\n) {\n  ...JobBoardSearchResultList_results_2HEEH6\n}\n\nfragment JobBoardSearchResultDownloadButton_searchResult on JobBoardSearchSearchResult {\n  id\n  searchResultId\n}\n\nfragment JobBoardSearchResultList_results_2HEEH6 on Query {\n  results: jobBoardSearchSearchResults(organisationId: $organisationId, first: $first, after: $after, order: $order, where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        searchResultId\n        ...JobBoardSearchResultRow_result\n        __typename\n      }\n    }\n  }\n}\n\nfragment JobBoardSearchResultProcessButton_searchResult on JobBoardSearchSearchResult {\n  id\n  searchResultId\n}\n\nfragment JobBoardSearchResultRow_result on JobBoardSearchSearchResult {\n  id\n  searchResultId\n  createdAt\n  updatedAt\n  organisationId\n  searchId\n  name\n  firstName\n  lastName\n  availability\n  cvId\n  type\n  sourceKey\n  sourceFullName\n  score\n  salary\n  rank\n  location\n  lastPosition\n  snippets\n  recordMatchStatus\n  downloadStatus\n  parseStatus\n  profileId\n  ...JobBoardSearchResultDownloadButton_searchResult\n  ...JobBoardSearchResultProcessButton_searchResult\n}\n"
    }
  };
}();
node490.hash = "5e07743efca0fd35edea66d02b58e672";
var JobBoardSearchResultListPaginationQuery_graphql_default = node490;

// src/job-board-search/components/__generated__/JobBoardSearchResultList_results.graphql.ts
var node491 = function() {
  var v0 = [
    "results"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "order"
      },
      {
        "kind": "RootArgument",
        "name": "organisationId"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": JobBoardSearchResultListPaginationQuery_graphql_default
      }
    },
    "name": "JobBoardSearchResultList_results",
    "selections": [
      {
        "alias": "results",
        "args": null,
        "concreteType": "JobBoardSearchSearchResultsConnection",
        "kind": "LinkedField",
        "name": "__JobBoardSearchResultList_results_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "JobBoardSearchSearchResultsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "JobBoardSearchSearchResult",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "searchResultId",
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "JobBoardSearchResultRow_result"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node491.hash = "5e07743efca0fd35edea66d02b58e672";
var JobBoardSearchResultList_results_graphql_default = node491;

// src/job-board-search/components/JobBoardSearchResultList.tsx
import { useCallback as useCallback237, useState as useState124 } from "react";
import { usePaginationFragment as usePaginationFragment25 } from "react-relay/hooks";
import {
  EdListHeader as EdListHeader2,
  EdTable as EdTable6,
  RadioList as RadioList9,
  selectColumn as selectColumn2,
  SelectMenu as SelectMenu7
} from "shared-ui";
import { isNotNull as isNotNull9 } from "shared-lib";

// src/job-board-search/components/__generated__/JobBoardSearchResultRow_result.graphql.ts
var node493 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobBoardSearchResultRow_result",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "searchResultId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "organisationId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "searchId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "availability",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cvId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sourceKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sourceFullName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "score",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "salary",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rank",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "location",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastPosition",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "snippets",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recordMatchStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "downloadStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "parseStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profileId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "JobBoardSearchResultDownloadButton_searchResult"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "JobBoardSearchResultProcessButton_searchResult"
    }
  ],
  "type": "JobBoardSearchSearchResult",
  "abstractKey": null
};
node493.hash = "f859baf657c926db6e09263f59c3ae1f";
var JobBoardSearchResultRow_result_graphql_default = node493;

// src/job-board-search/components/JobBoardSearchResultRow.tsx
import { useCallback as useCallback236, useReducer as useReducer2 } from "react";
import { useFragment as useFragment146 } from "react-relay/hooks";
import { EdActionCell as EdActionCell4, EdColumnCell as EdColumnCell7, EdRow as EdRow7, LinkButton as LinkButton8 } from "shared-ui";
import { formatDateTime as formatDateTime4 } from "shared-lib";
import { jsx as jsx428, jsxs as jsxs288 } from "react/jsx-runtime";
var search2 = JobBoardSearchResultRow_result_graphql_default;
var JobBoardSearchResultRow = ({
  onSelected,
  result
}) => {
  const data = useFragment146(search2, result);
  const [isSelected, toggleIsSelected] = useReducer2((state) => {
    return !state;
  }, false);
  const select = useCallback236(() => {
    onSelected(data);
    toggleIsSelected();
  }, []);
  return /* @__PURE__ */ jsxs288(EdRow7, { clicked: select, rowKey: data.id, children: [
    /* @__PURE__ */ jsx428(EdColumnCell7, { children: formatDateTime4(data.createdAt) }),
    /* @__PURE__ */ jsx428(EdColumnCell7, { children: data.firstName }),
    /* @__PURE__ */ jsx428(EdColumnCell7, { children: data.lastName }),
    /* @__PURE__ */ jsx428(EdColumnCell7, { children: data.availability }),
    /* @__PURE__ */ jsx428(EdColumnCell7, { children: data.salary }),
    /* @__PURE__ */ jsx428(EdColumnCell7, { children: data.rank }),
    /* @__PURE__ */ jsx428(EdColumnCell7, { children: data.sourceFullName }),
    /* @__PURE__ */ jsx428(EdColumnCell7, { children: data.downloadStatus }),
    /* @__PURE__ */ jsx428(EdColumnCell7, { children: data.parseStatus }),
    /* @__PURE__ */ jsx428(EdColumnCell7, { children: data.recordMatchStatus }),
    /* @__PURE__ */ jsxs288(EdActionCell4, { children: [
      /* @__PURE__ */ jsx428(LinkButton8, { label: "Select", clicked: select }),
      isSelected && /* @__PURE__ */ jsx428("div", { className: "mt-2 px-3", children: /* @__PURE__ */ jsx428(
        JobBoardSearchResultDownloadButton,
        {
          searchResult: data,
          onDone: () => {
          },
          onError: (e4) => {
            console.error(e4);
          }
        }
      ) })
    ] })
  ] });
};

// src/job-board-search/components/JobBoardSearchResultList.tsx
import { jsx as jsx429, jsxs as jsxs289 } from "react/jsx-runtime";
var defaultColumns3 = [
  { id: "created", name: "Created", sort: true },
  { id: "firstName", name: "First Name" },
  { id: "lastName", name: "Last Name" },
  { id: "availability", name: "Availability" },
  { id: "salary", name: "Salary" },
  { id: "rank", name: "Rank" },
  { id: "source", name: "Source" },
  { id: "downloaded", name: "Downloaded" },
  { id: "parsed", name: "Parsed" },
  { id: "matched", name: "Matched" }
];
var fragment23 = JobBoardSearchResultList_results_graphql_default;
var defaultDownloadStatus = {
  id: "Done",
  name: "Done"
};
var downloadStatusList = [
  defaultDownloadStatus,
  {
    id: "Pending",
    name: "Pending"
  },
  {
    id: "None",
    name: "None"
  },
  {
    id: "Failed",
    name: "Failed"
  },
  {
    id: "ALL",
    name: "All"
  }
];
var defaultParseStatus = {
  id: "ALL",
  label: "All"
};
var parseStatusList = [
  defaultParseStatus,
  {
    id: "Pending",
    label: "Pending"
  },
  {
    id: "Done",
    label: "Done"
  },
  {
    id: "Failed",
    label: "Failed"
  }
];
var defaultMatchStatus = {
  id: "ALL",
  label: "All"
};
var recordMatchStatusList = [
  defaultMatchStatus,
  {
    id: "Pending",
    label: "Pending"
  },
  {
    id: "IsMatched",
    label: "Is Matched"
  },
  {
    id: "NotMatched",
    label: "Not Matched"
  }
];
var JobBoardSearchResultList = ({
  results,
  onSelect,
  onFilter
}) => {
  const [downloadStatus, setDownloadStatus] = useState124(
    defaultDownloadStatus
  );
  const [parseStatus, setParseStatus] = useState124(defaultParseStatus);
  const [recordMatchStatus, setRecordMatchStatus] = useState124(defaultMatchStatus);
  const changeDownloadStatus = useCallback237(
    (r4) => {
      setDownloadStatus(r4);
      onFilter({
        downloadStatus: r4.id,
        recordMatchStatus: recordMatchStatus.id,
        parseStatus: parseStatus.id
      });
    },
    [downloadStatus]
  );
  const changeRecordMatchStatus = useCallback237(
    (r4) => {
      setRecordMatchStatus(r4);
      onFilter({
        downloadStatus: downloadStatus.id,
        recordMatchStatus: r4.id,
        parseStatus: parseStatus.id
      });
    },
    [downloadStatus]
  );
  const changeParseStatusStatus = useCallback237(
    (r4) => {
      setParseStatus(r4);
      onFilter({
        downloadStatus: downloadStatus.id,
        recordMatchStatus: recordMatchStatus.id,
        parseStatus: r4.id
      });
    },
    [downloadStatus]
  );
  const rowSelected = useCallback237((e4) => {
    onSelect({
      id: e4.id
    });
  }, []);
  const paging = usePaginationFragment25(fragment23, results);
  const onSortChanged = useCallback237((columns) => {
    const hasOrderBy = columns.filter((c4) => c4.sort && c4.sortValue).length > 0;
    if (hasOrderBy === false) {
      return;
    }
    const orderBy = [];
    const createdAt = selectColumn2("createdOn", columns);
    if (createdAt) {
      orderBy.push({ createdAt });
    }
    const updatedAt = selectColumn2("updatedOn", columns);
    if (updatedAt) {
      orderBy.push({ updatedAt });
    }
    refetch(
      { first: 10, order: orderBy },
      {
        fetchPolicy: "network-only",
        onComplete: (e4) => {
          if (e4) {
            console.error(e4);
          } else {
            console.log("changed sort on job order list");
          }
        }
      }
    );
  }, []);
  const { data, refetch } = paging;
  const nodes = (data.results?.edges ?? []).map((edge) => edge.node).filter(isNotNull9);
  const rows = nodes.map((node566) => {
    return /* @__PURE__ */ jsx429(
      JobBoardSearchResultRow,
      {
        result: node566,
        onSelected: rowSelected
      },
      node566.searchResultId
    );
  });
  return /* @__PURE__ */ jsxs289("div", { children: [
    /* @__PURE__ */ jsxs289("div", { className: "flex items-center justify-between", children: [
      /* @__PURE__ */ jsxs289("div", { className: "flex items-center space-x-4", children: [
        /* @__PURE__ */ jsx429("label", { className: "text-gray-700", htmlFor: "filter", children: "Download" }),
        /* @__PURE__ */ jsx429(
          SelectMenu7,
          {
            className: "w-64",
            items: downloadStatusList,
            value: downloadStatus,
            onChange: changeDownloadStatus
          }
        )
      ] }),
      /* @__PURE__ */ jsxs289("div", { className: "flex items-center space-x-4", children: [
        /* @__PURE__ */ jsx429("label", { className: "text-gray-700", htmlFor: "filter", children: "Parsed" }),
        /* @__PURE__ */ jsx429("div", { children: /* @__PURE__ */ jsx429(
          RadioList9,
          {
            list: parseStatusList,
            value: parseStatus,
            onChange: changeParseStatusStatus
          }
        ) })
      ] }),
      /* @__PURE__ */ jsxs289("div", { className: "flex items-center space-x-4", children: [
        /* @__PURE__ */ jsx429("label", { className: "text-gray-700", htmlFor: "filter", children: "Record Matched" }),
        /* @__PURE__ */ jsx429("div", { children: /* @__PURE__ */ jsx429(
          RadioList9,
          {
            list: recordMatchStatusList,
            value: recordMatchStatus,
            onChange: changeRecordMatchStatus
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ jsx429(EdListHeader2, { total: data.results?.totalCount, paging }),
    /* @__PURE__ */ jsx429("div", { className: "flex", children: /* @__PURE__ */ jsx429("div", { className: "w-full", children: /* @__PURE__ */ jsx429(
      EdTable6,
      {
        defaultColumns: defaultColumns3,
        rows,
        onSortChanged
      }
    ) }) })
  ] });
};

// src/job-board-search/components/__generated__/JobBoardSearchResultProcessButton_searchResult.graphql.ts
var node494 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobBoardSearchResultProcessButton_searchResult",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "searchResultId",
      "storageKey": null
    }
  ],
  "type": "JobBoardSearchSearchResult",
  "abstractKey": null
};
node494.hash = "e06a75743f078b2a2a53cd36ea4e7d94";
var JobBoardSearchResultProcessButton_searchResult_graphql_default = node494;

// src/job-board-search/components/JobBoardSearchResultProcessButton.tsx
import { useCallback as useCallback238 } from "react";
import {
  ConnectionHandler as ConnectionHandler12,
  useFragment as useFragment147,
  useRelayEnvironment as useRelayEnvironment12
} from "react-relay/hooks";
import { Button as Button120 } from "shared-ui";
import { createClientMutationId as createClientMutationId98 } from "shared-lib";
import { jsx as jsx430 } from "react/jsx-runtime";
var fragment24 = JobBoardSearchResultProcessButton_searchResult_graphql_default;
var JobBoardSearchResultProcessButton = ({
  searchResult,
  onDone,
  onError
}) => {
  const data = useFragment147(
    fragment24,
    searchResult
  );
  const environment = useRelayEnvironment12();
  const connectionId = ConnectionHandler12.getConnectionID(
    "root",
    // passed as input to the mutation/subscription
    "JobBoardSearchResultList_results"
  );
  const onSave = useCallback238(() => {
    if (!data) {
      return;
    }
    const clientMutationId = createClientMutationId98();
    const input = {
      id: data.searchResultId,
      clientMutationId
    };
    ProcessSearchResultMutation_default.commit(
      environment,
      input,
      connectionId,
      () => {
        onDone();
      },
      (error) => {
        onError(error);
      }
    );
  }, [data]);
  return /* @__PURE__ */ jsx430("div", { children: /* @__PURE__ */ jsx430(
    Button120,
    {
      color: "primary",
      clicked: () => {
        onSave();
      },
      children: "Ingest"
    }
  ) });
};

// src/job-board-search/components/__generated__/JobBoardSearchResultsContainerQuery.graphql.ts
var node495 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "order"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "organisationId"
  }, v23 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "where"
  }, v32 = {
    "kind": "Variable",
    "name": "order",
    "variableName": "order"
  }, v4 = {
    "kind": "Variable",
    "name": "organisationId",
    "variableName": "organisationId"
  }, v5 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "searchResultId",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "availability",
    "storageKey": null
  }, v12 = {
    "alias": "runs",
    "args": [
      v32,
      v4,
      v5
    ],
    "concreteType": "JobBoardSearchSearchResultsConnection",
    "kind": "LinkedField",
    "name": "jobBoardSearchSearchResults",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "JobBoardSearchSearchResultsEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "JobBoardSearchSearchResult",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              v6,
              v7,
              v8,
              v9,
              v10,
              v11
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v13 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    v32,
    v4,
    v5
  ];
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1,
        v23
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "JobBoardSearchResultsContainerQuery",
      "selections": [
        v12,
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "JobBoardSearchResultList_results"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0,
        v23
      ],
      "kind": "Operation",
      "name": "JobBoardSearchResultsContainerQuery",
      "selections": [
        v12,
        {
          "alias": "results",
          "args": v13,
          "concreteType": "JobBoardSearchSearchResultsConnection",
          "kind": "LinkedField",
          "name": "jobBoardSearchSearchResults",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "JobBoardSearchSearchResultsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "JobBoardSearchSearchResult",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v6,
                    v7,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "organisationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "searchId",
                      "storageKey": null
                    },
                    v8,
                    v9,
                    v10,
                    v11,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "cvId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "type",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sourceKey",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sourceFullName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "score",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "salary",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "rank",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "location",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastPosition",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "snippets",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "recordMatchStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "downloadStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "parseStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "profileId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "results",
          "args": v13,
          "filters": [],
          "handle": "connection",
          "key": "JobBoardSearchResultList_results",
          "kind": "LinkedHandle",
          "name": "jobBoardSearchSearchResults"
        }
      ]
    },
    "params": {
      "cacheID": "2da6c6faa58c87f3a3ee10a37ec7f79c",
      "id": null,
      "metadata": {},
      "name": "JobBoardSearchResultsContainerQuery",
      "operationKind": "query",
      "text": "query JobBoardSearchResultsContainerQuery(\n  $organisationId: UUID!\n  $order: [JobBoardSearchSearchResultSort!]!\n  $where: JobBoardSearchSearchResultFilter!\n) {\n  runs: jobBoardSearchSearchResults(organisationId: $organisationId, order: $order, where: $where) {\n    edges {\n      node {\n        id\n        searchResultId\n        name\n        firstName\n        lastName\n        availability\n      }\n    }\n  }\n  ...JobBoardSearchResultList_results\n}\n\nfragment JobBoardSearchResultDownloadButton_searchResult on JobBoardSearchSearchResult {\n  id\n  searchResultId\n}\n\nfragment JobBoardSearchResultList_results on Query {\n  results: jobBoardSearchSearchResults(organisationId: $organisationId, first: 10, order: $order, where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        searchResultId\n        ...JobBoardSearchResultRow_result\n        __typename\n      }\n    }\n  }\n}\n\nfragment JobBoardSearchResultProcessButton_searchResult on JobBoardSearchSearchResult {\n  id\n  searchResultId\n}\n\nfragment JobBoardSearchResultRow_result on JobBoardSearchSearchResult {\n  id\n  searchResultId\n  createdAt\n  updatedAt\n  organisationId\n  searchId\n  name\n  firstName\n  lastName\n  availability\n  cvId\n  type\n  sourceKey\n  sourceFullName\n  score\n  salary\n  rank\n  location\n  lastPosition\n  snippets\n  recordMatchStatus\n  downloadStatus\n  parseStatus\n  profileId\n  ...JobBoardSearchResultDownloadButton_searchResult\n  ...JobBoardSearchResultProcessButton_searchResult\n}\n"
    }
  };
}();
node495.hash = "e2cbd264c68e474078ed92240cf6d51f";
var JobBoardSearchResultsContainerQuery_graphql_default = node495;

// src/job-board-search/components/JobBoardSearchResultsContainer.tsx
import { useState as useState125 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery67 } from "react-relay/hooks";
import { useMachine as useMachine5 } from "@xstate/react";
import { createMachine as createMachine5 } from "xstate";

// src/job-board-search/components/__generated__/JobBoardSearchResultContainerQuery.graphql.ts
var node496 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "id"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "id"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "organisationId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "searchId",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "searchResultId",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "availability",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "cvId",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "type",
    "storageKey": null
  }, v14 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "sourceKey",
    "storageKey": null
  }, v15 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "sourceFullName",
    "storageKey": null
  }, v16 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "score",
    "storageKey": null
  }, v17 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "salary",
    "storageKey": null
  }, v18 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "rank",
    "storageKey": null
  }, v19 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "location",
    "storageKey": null
  }, v20 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastPosition",
    "storageKey": null
  }, v21 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "snippets",
    "storageKey": null
  }, v222 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "downloadStatus",
    "storageKey": null
  }, v232 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "parseStatus",
    "storageKey": null
  }, v24 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "recordMatchStatus",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "JobBoardSearchResultContainerQuery",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "JobBoardSearchSearchResult",
          "kind": "LinkedField",
          "name": "jobBoardSearchSearchResultById",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            v10,
            v11,
            v12,
            v13,
            v14,
            v15,
            v16,
            v17,
            v18,
            v19,
            v20,
            v21,
            v222,
            v232,
            v24,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "JobBoardSearchResultDownloadButton_searchResult"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "JobBoardSearchResultProcessButton_searchResult"
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "JobBoardSearchResultContainerQuery",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "JobBoardSearchSearchResult",
          "kind": "LinkedField",
          "name": "jobBoardSearchSearchResultById",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            v10,
            v11,
            v12,
            v13,
            v14,
            v15,
            v16,
            v17,
            v18,
            v19,
            v20,
            v21,
            v222,
            v232,
            v24
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "e2c205a35a7513ef8d038188e008e70c",
      "id": null,
      "metadata": {},
      "name": "JobBoardSearchResultContainerQuery",
      "operationKind": "query",
      "text": "query JobBoardSearchResultContainerQuery(\n  $id: ID!\n) {\n  result: jobBoardSearchSearchResultById(id: $id) {\n    id\n    organisationId\n    searchId\n    searchResultId\n    createdAt\n    updatedAt\n    name\n    firstName\n    lastName\n    availability\n    cvId\n    type\n    sourceKey\n    sourceFullName\n    score\n    salary\n    rank\n    location\n    lastPosition\n    snippets\n    downloadStatus\n    parseStatus\n    recordMatchStatus\n    ...JobBoardSearchResultDownloadButton_searchResult\n    ...JobBoardSearchResultProcessButton_searchResult\n  }\n}\n\nfragment JobBoardSearchResultDownloadButton_searchResult on JobBoardSearchSearchResult {\n  id\n  searchResultId\n}\n\nfragment JobBoardSearchResultProcessButton_searchResult on JobBoardSearchSearchResult {\n  id\n  searchResultId\n}\n"
    }
  };
}();
node496.hash = "37698c14cbeabd308fc7fd4bd4776885";
var JobBoardSearchResultContainerQuery_graphql_default = node496;

// src/job-board-search/components/JobBoardSearchResultContainer.tsx
import { useMachine as useMachine4 } from "@xstate/react";
import { useLazyLoadQuery as useLazyLoadQuery66 } from "react-relay/hooks";
import { createMachine as createMachine4 } from "xstate";
import { AuditFields as AuditFields2, Button as Button121, ButtonList as ButtonList47 } from "shared-ui";
import { useRefresh } from "shared-lib";
import { jsx as jsx431, jsxs as jsxs290 } from "react/jsx-runtime";
var machine3 = createMachine4({
  id: "searchResult",
  initial: "viewing",
  states: {
    viewing: {
      on: {
        EDIT: { target: "editing" }
      }
    },
    editing: {
      on: {
        CANCEL: { target: "viewing" }
      }
    }
  }
});
var graphqlQuery14 = JobBoardSearchResultContainerQuery_graphql_default;
var JobBoardSearchResultContainer = ({
  id: id18,
  onClose
}) => {
  const [state, send] = useMachine4(machine3);
  const [options7, refresh] = useRefresh();
  const query3 = useLazyLoadQuery66(
    graphqlQuery14,
    { id: id18 },
    options7
  );
  const { result } = query3;
  if (!result) {
    return /* @__PURE__ */ jsx431("div", { children: "No Search Result Data Available." });
  }
  return /* @__PURE__ */ jsxs290("div", { className: "", children: [
    state.matches("viewing") && /* @__PURE__ */ jsxs290("div", { className: "", children: [
      /* @__PURE__ */ jsxs290("div", { className: "mb-2 flex items-center justify-between border-b border-gray-100 pb-2", children: [
        /* @__PURE__ */ jsxs290("div", { className: "mb-2 flex items-center space-x-2 pb-2", children: [
          /* @__PURE__ */ jsx431("div", { children: result.firstName }),
          /* @__PURE__ */ jsx431("div", { children: result.lastName }),
          /* @__PURE__ */ jsx431(
            AuditFields2,
            {
              createdOn: result.createdAt,
              updatedOn: result.updatedAt
            }
          )
        ] }),
        /* @__PURE__ */ jsx431(ButtonList47, { children: /* @__PURE__ */ jsx431(Button121, { color: "gray", clicked: onClose, children: "Back To Search Results" }) })
      ] }),
      /* @__PURE__ */ jsxs290("div", { children: [
        /* @__PURE__ */ jsx431("div", { className: "mb-2 border-b border-gray-100 pb-2", children: /* @__PURE__ */ jsxs290(ButtonList47, { justify: "START", children: [
          (result.parseStatus === "FAILED" || result.parseStatus === "PENDING") && /* @__PURE__ */ jsx431(
            JobBoardSearchResultProcessButton,
            {
              searchResult: result,
              onDone: refresh,
              onError: (e4) => {
                console.error(e4);
              }
            }
          ),
          (result.downloadStatus === "FAILED" || result.downloadStatus === "PENDING") && /* @__PURE__ */ jsx431(
            JobBoardSearchResultDownloadButton,
            {
              searchResult: result,
              onDone: refresh,
              onError: (e4) => {
                console.error(e4);
              }
            }
          )
        ] }) }),
        /* @__PURE__ */ jsx431("ul", { children: (result.snippets || []).map((s4, i4) => /* @__PURE__ */ jsx431(
          "li",
          {
            className: "mb-2 flex items-center border-b border-gray-100 pb-2",
            children: s4
          },
          i4
        )) })
      ] })
    ] }),
    state.matches("editing") && /* @__PURE__ */ jsxs290("div", { className: "my-3 flex justify-start space-x-2", children: [
      /* @__PURE__ */ jsx431("div", { className: "text-info-500 text-md font-medium", children: "Editing....." }),
      /* @__PURE__ */ jsx431(
        Button121,
        {
          clicked: () => {
            send("CANCEL");
          },
          children: "Cancel"
        }
      )
    ] })
  ] });
};

// src/job-board-search/components/JobBoardSearchResultsContainer.tsx
import { jsx as jsx433, jsxs as jsxs291 } from "react/jsx-runtime";
var machine4 = createMachine5({
  id: "searchRuns",
  initial: "listing",
  states: {
    listing: {
      id: "listing",
      on: {
        VIEW: { target: "item" }
      }
    },
    item: {
      initial: "viewing",
      states: {
        viewing: {
          on: {
            LIST: { target: "#listing" }
          }
        },
        editing: {
          on: {
            CANCEL: { target: "viewing" }
          }
        }
      }
    }
  }
});
var graphqlQuery15 = JobBoardSearchResultsContainerQuery_graphql_default;
var JobBoardSearchResultsContainer = ({
  organisationId,
  searchId,
  searchRunId
}) => {
  const order2 = [{ score: "DESC" }];
  const [downloadStatus, setDownloadStatus] = useState125(null);
  const [parseStatus, setParseStatus] = useState125(null);
  const [recordMatchStatus, setRecordMatchStatus] = useState125(
    null
  );
  const [state, send] = useMachine5(machine4);
  let where = {
    organisationId: { eq: organisationId },
    searchId: { eq: searchId }
  };
  if (searchRunId) {
    where = {
      ...where,
      searchRunId: { eq: searchRunId }
    };
  }
  if (downloadStatus && downloadStatus != "ALL") {
    where = {
      ...where,
      downloadStatus: { eq: downloadStatus }
    };
  }
  if (parseStatus && parseStatus != "ALL") {
    where = {
      ...where,
      parseStatus: { eq: parseStatus }
    };
  }
  if (recordMatchStatus && recordMatchStatus != "ALL") {
    where = {
      ...where,
      recordMatchStatus: { eq: recordMatchStatus }
    };
  }
  const [selectedId, setSelectedId] = useState125(null);
  const query3 = useLazyLoadQuery67(
    graphqlQuery15,
    { organisationId, where, order: order2 },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsxs291("div", { children: [
    state.matches("listing") && /* @__PURE__ */ jsx433(
      JobBoardSearchResultList,
      {
        results: query3,
        onSelect: ({ id: id18 }) => {
          setSelectedId(id18);
          send("VIEW");
        },
        onFilter: (f4) => {
          setDownloadStatus(f4.downloadStatus);
          setParseStatus(f4.parseStatus);
          setRecordMatchStatus(f4.recordMatchStatus);
        }
      }
    ),
    state.matches("item.viewing") && selectedId && /* @__PURE__ */ jsx433("div", { children: /* @__PURE__ */ jsx433(
      JobBoardSearchResultContainer,
      {
        id: selectedId,
        onClose: () => {
          send("LIST");
        }
      }
    ) })
  ] });
};

// src/job-board-search/components/JobBoardSearchRetryRunButton.tsx
import { useCallback as useCallback239 } from "react";
import { useRelayEnvironment as useRelayEnvironment13 } from "react-relay/hooks";
import { Button as Button123 } from "shared-ui";
import { createClientMutationId as createClientMutationId99, useToggle as useToggle46 } from "shared-lib";
import { jsx as jsx434 } from "react/jsx-runtime";
var JobBoardSearchRetryRunButton = ({
  searchId,
  onDone,
  onError
}) => {
  const [isBusy, toggleIsBusy] = useToggle46(false);
  const environment = useRelayEnvironment13();
  const onSave = useCallback239(() => {
    if (!searchId) {
      return;
    }
    toggleIsBusy();
    const clientMutationId = createClientMutationId99();
    const input = {
      id: searchId,
      clientMutationId
    };
    RetrySearchRunMutation_default.commit(
      environment,
      input,
      () => {
        onDone();
        toggleIsBusy();
      },
      (error) => {
        onError(error);
      }
    );
  }, [searchId]);
  return /* @__PURE__ */ jsx434("div", { children: /* @__PURE__ */ jsx434(
    Button123,
    {
      disabled: isBusy,
      color: "primary",
      confirmMessage: "Confirm Retry Search ?",
      clicked: () => {
        onSave();
      },
      children: "Retry Search"
    }
  ) });
};

// src/job-board-search/components/__generated__/JobBoardSearchRunContainerQuery.graphql.ts
var node497 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "id"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "id"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "organisationId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "searchId",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "searchRunId",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "JobBoardSearchRunContainerQuery",
      "selections": [
        {
          "alias": "run",
          "args": v1,
          "concreteType": "JobBoardSearchSearchRun",
          "kind": "LinkedField",
          "name": "jobBoardSearchSearchRunById",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            v5,
            v6,
            v7,
            v8,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "JobBoardSearchRunView_run"
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "JobBoardSearchRunContainerQuery",
      "selections": [
        {
          "alias": "run",
          "args": v1,
          "concreteType": "JobBoardSearchSearchRun",
          "kind": "LinkedField",
          "name": "jobBoardSearchSearchRunById",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            v5,
            v6,
            v7,
            v8,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "resultCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "pollStatus",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "pollResults",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "JobBoardSearchSearchError",
              "kind": "LinkedField",
              "name": "errors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "message",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "code",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "a09de2e1e4e5a062e5b349d8fae07ad2",
      "id": null,
      "metadata": {},
      "name": "JobBoardSearchRunContainerQuery",
      "operationKind": "query",
      "text": "query JobBoardSearchRunContainerQuery(\n  $id: UUID!\n) {\n  run: jobBoardSearchSearchRunById(id: $id) {\n    id\n    organisationId\n    searchId\n    searchRunId\n    createdAt\n    updatedAt\n    status\n    ...JobBoardSearchRunView_run\n  }\n}\n\nfragment JobBoardSearchRunView_run on JobBoardSearchSearchRun {\n  id\n  searchId\n  createdAt\n  updatedAt\n  organisationId\n  status\n  resultCount\n  pollStatus\n  pollResults\n  errors {\n    message\n    code\n  }\n}\n"
    }
  };
}();
node497.hash = "beb3dcfca2acdb1c9f1fcfe49dab268f";
var JobBoardSearchRunContainerQuery_graphql_default = node497;

// src/job-board-search/components/JobBoardSearchRunContainer.tsx
import { useLazyLoadQuery as useLazyLoadQuery68 } from "react-relay/hooks";
import { AuditFields as AuditFields3, Button as Button124, ButtonList as ButtonList48 } from "shared-ui";
import { useRefresh as useRefresh2 } from "shared-lib";
import { jsx as jsx435, jsxs as jsxs293 } from "react/jsx-runtime";
var graphqlQuery16 = JobBoardSearchRunContainerQuery_graphql_default;
var JobBoardSearchRunContainer = ({
  id: id18,
  onClose
}) => {
  const [options7, refresh] = useRefresh2();
  const query3 = useLazyLoadQuery68(
    graphqlQuery16,
    { id: id18 },
    options7
  );
  const { run } = query3;
  if (!run) {
    return /* @__PURE__ */ jsx435("div", { children: "No Search Details Available." });
  }
  return /* @__PURE__ */ jsxs293("div", { children: [
    /* @__PURE__ */ jsxs293("div", { className: "mb-2 flex items-center justify-between border-b border-gray-100 pb-2", children: [
      /* @__PURE__ */ jsx435(AuditFields3, { createdOn: run.createdAt, updatedOn: run.updatedAt }),
      /* @__PURE__ */ jsxs293(ButtonList48, { children: [
        /* @__PURE__ */ jsx435(Button124, { color: "gray", clicked: onClose, children: "Back To Search Runs" }),
        run.status === "FAILED" && /* @__PURE__ */ jsx435(
          JobBoardSearchRetryRunButton,
          {
            searchId: id18,
            onDone: refresh,
            onError: (e4) => {
              console.error(e4);
            }
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ jsx435(
      JobBoardSearchResultsContainer,
      {
        organisationId: run.organisationId,
        searchId: run.searchId,
        searchRunId: run.searchRunId
      }
    )
  ] });
};

// src/job-board-search/components/__generated__/JobBoardSearchRunListPaginationQuery.graphql.ts
var node498 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "order"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "organisationId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v23 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v32 = [
    v1,
    v23,
    {
      "kind": "Variable",
      "name": "order",
      "variableName": "order"
    },
    {
      "kind": "Variable",
      "name": "organisationId",
      "variableName": "organisationId"
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "JobBoardSearchRunListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v23
          ],
          "kind": "FragmentSpread",
          "name": "JobBoardSearchRunList_searches"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "JobBoardSearchRunListPaginationQuery",
      "selections": [
        {
          "alias": "searches",
          "args": v32,
          "concreteType": "JobBoardSearchRunsConnection",
          "kind": "LinkedField",
          "name": "jobBoardSearchRuns",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "JobBoardSearchRunsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "JobBoardSearchSearchRun",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "searchRunId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "organisationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "searchId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "JobBoardSearchSearchError",
                      "kind": "LinkedField",
                      "name": "errors",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "code",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "message",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "handles",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "pollStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "pollResults",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "resultCount",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "searches",
          "args": v32,
          "filters": [],
          "handle": "connection",
          "key": "JobBoardSearchRunList_searches",
          "kind": "LinkedHandle",
          "name": "jobBoardSearchRuns"
        }
      ]
    },
    "params": {
      "cacheID": "f0832500ebc1178647faf88ec7af98a6",
      "id": null,
      "metadata": {},
      "name": "JobBoardSearchRunListPaginationQuery",
      "operationKind": "query",
      "text": "query JobBoardSearchRunListPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $order: [JobBoardSearchSearchRunSort!]\n  $organisationId: UUID!\n  $where: JobBoardSearchSearchRunFilter\n) {\n  ...JobBoardSearchRunList_searches_2HEEH6\n}\n\nfragment JobBoardSearchRunList_searches_2HEEH6 on Query {\n  searches: jobBoardSearchRuns(organisationId: $organisationId, first: $first, after: $after, order: $order, where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        searchRunId\n        ...JobBoardSearchRunRow_search\n        __typename\n      }\n    }\n  }\n}\n\nfragment JobBoardSearchRunRow_search on JobBoardSearchSearchRun {\n  id\n  createdAt\n  updatedAt\n  searchRunId\n  organisationId\n  searchId\n  status\n  errors {\n    code\n    message\n  }\n  handles\n  pollStatus\n  pollResults\n  resultCount\n}\n"
    }
  };
}();
node498.hash = "525c855fc9ffbdb2e8c7e5f0e1ae2554";
var JobBoardSearchRunListPaginationQuery_graphql_default = node498;

// src/job-board-search/components/__generated__/JobBoardSearchRunList_searches.graphql.ts
var node499 = function() {
  var v0 = [
    "searches"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "order"
      },
      {
        "kind": "RootArgument",
        "name": "organisationId"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": JobBoardSearchRunListPaginationQuery_graphql_default
      }
    },
    "name": "JobBoardSearchRunList_searches",
    "selections": [
      {
        "alias": "searches",
        "args": null,
        "concreteType": "JobBoardSearchRunsConnection",
        "kind": "LinkedField",
        "name": "__JobBoardSearchRunList_searches_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "JobBoardSearchRunsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "JobBoardSearchSearchRun",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "searchRunId",
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "JobBoardSearchRunRow_search"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node499.hash = "525c855fc9ffbdb2e8c7e5f0e1ae2554";
var JobBoardSearchRunList_searches_graphql_default = node499;

// src/job-board-search/components/JobBoardSearchRunList.tsx
import { useCallback as useCallback241 } from "react";
import { usePaginationFragment as usePaginationFragment26 } from "react-relay/hooks";
import {
  EdListHeader as EdListHeader3,
  EdTable as EdTable7,
  selectColumn as selectColumn3,
  SortDir as SortDir10
} from "shared-ui";
import { isNotNull as isNotNull10 } from "shared-lib";

// src/job-board-search/components/__generated__/JobBoardSearchRunRow_search.graphql.ts
var node500 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobBoardSearchRunRow_search",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "searchRunId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "organisationId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "searchId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "JobBoardSearchSearchError",
      "kind": "LinkedField",
      "name": "errors",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "message",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "handles",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pollStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pollResults",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "resultCount",
      "storageKey": null
    }
  ],
  "type": "JobBoardSearchSearchRun",
  "abstractKey": null
};
node500.hash = "b91f4b3ff0ad2cfaa751488dd17af80d";
var JobBoardSearchRunRow_search_graphql_default = node500;

// src/job-board-search/components/JobBoardSearchRunRow.tsx
import { useCallback as useCallback240 } from "react";
import { useFragment as useFragment148 } from "react-relay/hooks";
import { EdActionCell as EdActionCell5, EdColumnCell as EdColumnCell8, EdRow as EdRow8, LinkButton as LinkButton9 } from "shared-ui";
import { formatDateTime as formatDateTime5 } from "shared-lib";
import { jsx as jsx436, jsxs as jsxs294 } from "react/jsx-runtime";
var search3 = JobBoardSearchRunRow_search_graphql_default;
var JobBoardSearchRunRow = (props) => {
  const data = useFragment148(search3, props.search);
  const select = useCallback240(() => {
    props.selected(data);
  }, []);
  return /* @__PURE__ */ jsxs294(EdRow8, { clicked: select, rowKey: data.id, children: [
    /* @__PURE__ */ jsx436(EdColumnCell8, { children: data.status }),
    /* @__PURE__ */ jsx436(EdColumnCell8, { children: data.resultCount }),
    /* @__PURE__ */ jsx436(EdColumnCell8, { children: formatDateTime5(data.createdAt) }),
    /* @__PURE__ */ jsx436(EdColumnCell8, { children: formatDateTime5(data.updatedAt) }),
    /* @__PURE__ */ jsx436(EdActionCell5, { children: /* @__PURE__ */ jsx436(LinkButton9, { label: "Select", clicked: select }) })
  ] });
};

// src/job-board-search/components/JobBoardSearchRunList.tsx
import { jsx as jsx437, jsxs as jsxs295 } from "react/jsx-runtime";
var defaultColumns4 = [
  { id: "status", name: "Status" },
  { id: "resultCount", name: "Results" },
  { id: "createdOn", name: "Created On", sort: true },
  {
    id: "updatedOn",
    name: "Last Elevate Update",
    sort: true,
    sortValue: SortDir10.Desc
  }
];
var fragment25 = JobBoardSearchRunList_searches_graphql_default;
var JobBoardSearchRunList = ({
  onSelect,
  runs
}) => {
  const rowSelected = useCallback241((e4) => {
    onSelect({
      id: e4.searchRunId
    });
  }, []);
  const paging = usePaginationFragment26(fragment25, runs);
  const onSortChanged = useCallback241((columns) => {
    const hasOrderBy = columns.filter((c4) => c4.sort && c4.sortValue).length > 0;
    if (hasOrderBy === false) {
      return;
    }
    const orderBy = [];
    const createdAt = selectColumn3("createdOn", columns);
    if (createdAt) {
      orderBy.push({ createdAt });
    }
    const updatedAt = selectColumn3("updatedOn", columns);
    if (updatedAt) {
      orderBy.push({ updatedAt });
    }
    refetch(
      { first: 10, order: orderBy },
      {
        fetchPolicy: "network-only",
        onComplete: (e4) => {
          if (e4) {
            console.error(e4);
          } else {
            console.log("changed sort on job order list");
          }
        }
      }
    );
  }, []);
  const { data, refetch } = paging;
  const nodes = (data.searches?.edges ?? []).map((edge) => edge.node).filter(isNotNull10);
  const rows = nodes.map((node566) => {
    return /* @__PURE__ */ jsx437(
      JobBoardSearchRunRow,
      {
        search: node566,
        selected: rowSelected
      },
      node566.id
    );
  });
  return /* @__PURE__ */ jsxs295("div", { children: [
    /* @__PURE__ */ jsx437(
      EdListHeader3,
      {
        total: data.searches?.totalCount,
        paging,
        content: /* @__PURE__ */ jsx437("div", {})
      }
    ),
    /* @__PURE__ */ jsx437("div", { className: "flex", children: /* @__PURE__ */ jsx437("div", { className: "w-full", children: /* @__PURE__ */ jsx437(
      EdTable7,
      {
        defaultColumns: defaultColumns4,
        rows,
        onSortChanged
      }
    ) }) })
  ] });
};

// src/job-board-search/components/__generated__/JobBoardSearchRunsContainerQuery.graphql.ts
var node501 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "order"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "organisationId"
  }, v23 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "where"
  }, v32 = {
    "kind": "Variable",
    "name": "order",
    "variableName": "order"
  }, v4 = {
    "kind": "Variable",
    "name": "organisationId",
    "variableName": "organisationId"
  }, v5 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "searchRunId",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  }, v9 = {
    "alias": "runs",
    "args": [
      v32,
      v4,
      v5
    ],
    "concreteType": "JobBoardSearchRunsConnection",
    "kind": "LinkedField",
    "name": "jobBoardSearchRuns",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "JobBoardSearchRunsEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "JobBoardSearchSearchRun",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              v6,
              v7,
              v8
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v10 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    v32,
    v4,
    v5
  ];
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1,
        v23
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "JobBoardSearchRunsContainerQuery",
      "selections": [
        v9,
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "JobBoardSearchRunList_searches"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0,
        v23
      ],
      "kind": "Operation",
      "name": "JobBoardSearchRunsContainerQuery",
      "selections": [
        v9,
        {
          "alias": "searches",
          "args": v10,
          "concreteType": "JobBoardSearchRunsConnection",
          "kind": "LinkedField",
          "name": "jobBoardSearchRuns",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "JobBoardSearchRunsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "JobBoardSearchSearchRun",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v6,
                    v7,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "organisationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "searchId",
                      "storageKey": null
                    },
                    v8,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "JobBoardSearchSearchError",
                      "kind": "LinkedField",
                      "name": "errors",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "code",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "message",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "handles",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "pollStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "pollResults",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "resultCount",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "searches",
          "args": v10,
          "filters": [],
          "handle": "connection",
          "key": "JobBoardSearchRunList_searches",
          "kind": "LinkedHandle",
          "name": "jobBoardSearchRuns"
        }
      ]
    },
    "params": {
      "cacheID": "04989ac16d43e0423e0c80030446cc86",
      "id": null,
      "metadata": {},
      "name": "JobBoardSearchRunsContainerQuery",
      "operationKind": "query",
      "text": "query JobBoardSearchRunsContainerQuery(\n  $organisationId: UUID!\n  $order: [JobBoardSearchSearchRunSort!]!\n  $where: JobBoardSearchSearchRunFilter!\n) {\n  runs: jobBoardSearchRuns(organisationId: $organisationId, order: $order, where: $where) {\n    edges {\n      node {\n        id\n        searchRunId\n        status\n      }\n    }\n  }\n  ...JobBoardSearchRunList_searches\n}\n\nfragment JobBoardSearchRunList_searches on Query {\n  searches: jobBoardSearchRuns(organisationId: $organisationId, first: 10, order: $order, where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        searchRunId\n        ...JobBoardSearchRunRow_search\n        __typename\n      }\n    }\n  }\n}\n\nfragment JobBoardSearchRunRow_search on JobBoardSearchSearchRun {\n  id\n  createdAt\n  updatedAt\n  searchRunId\n  organisationId\n  searchId\n  status\n  errors {\n    code\n    message\n  }\n  handles\n  pollStatus\n  pollResults\n  resultCount\n}\n"
    }
  };
}();
node501.hash = "3f9f9694c3a26a1b0f874405377a9419";
var JobBoardSearchRunsContainerQuery_graphql_default = node501;

// src/job-board-search/components/JobBoardSearchRunsContainer.tsx
import { useState as useState126 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery69 } from "react-relay/hooks";
import { useMachine as useMachine6 } from "@xstate/react";
import { createMachine as createMachine6 } from "xstate";
import { RadioList as RadioList10 } from "shared-ui";
import { jsx as jsx438, jsxs as jsxs296 } from "react/jsx-runtime";
var machine5 = createMachine6({
  id: "searchRuns",
  initial: "listing",
  states: {
    listing: {
      id: "listing",
      on: {
        VIEW: { target: "item" }
      }
    },
    item: {
      initial: "viewing",
      states: {
        viewing: {
          on: {
            LIST: { target: "#listing" }
          }
        },
        editing: {
          on: {
            CANCEL: { target: "viewing" }
          }
        }
      }
    }
  }
});
var graphqlQuery17 = JobBoardSearchRunsContainerQuery_graphql_default;
var defaultStatus = {
  id: "Completed",
  label: "Completed"
};
var statusList = [
  defaultStatus,
  {
    id: "Pending",
    label: "Pending"
  },
  {
    id: "Searching",
    label: "Searching"
  },
  {
    id: "Failed",
    label: "Failed"
  },
  {
    id: "All",
    label: "All"
  }
];
var JobBoardSearchRunsContainer = ({
  organisationId,
  searchId
}) => {
  const order2 = [{ updatedAt: "DESC" }];
  const [status, setStatus] = useState126(defaultStatus);
  const [state, send] = useMachine6(machine5);
  const where = {
    organisationId: { eq: organisationId },
    searchId: { eq: searchId }
  };
  if (status && status.id !== "All") {
    where.status = { eq: status.id };
  }
  const [selectedId, setSelectedId] = useState126(null);
  const query3 = useLazyLoadQuery69(
    graphqlQuery17,
    { organisationId, where, order: order2 },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsxs296("div", { children: [
    state.matches("listing") && /* @__PURE__ */ jsxs296("div", { children: [
      /* @__PURE__ */ jsxs296("div", { className: "flex items-center space-x-4 p-2", children: [
        /* @__PURE__ */ jsx438("label", { className: "text-gray-700", htmlFor: "filter", children: "Status" }),
        /* @__PURE__ */ jsx438("div", { children: /* @__PURE__ */ jsx438(
          RadioList10,
          {
            list: statusList,
            value: status,
            onChange: (status2) => setStatus(status2)
          }
        ) })
      ] }),
      /* @__PURE__ */ jsx438(
        JobBoardSearchRunList,
        {
          onSelect: ({ id: id18 }) => {
            setSelectedId(id18);
            send("VIEW");
          },
          runs: query3
        }
      )
    ] }),
    state.matches("item") && selectedId && /* @__PURE__ */ jsx438(
      JobBoardSearchRunContainer,
      {
        id: selectedId,
        onClose: () => {
          send("LIST");
        }
      }
    )
  ] });
};

// src/job-board-search/components/__generated__/JobBoardSearchRunView_run.graphql.ts
var node503 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobBoardSearchRunView_run",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "searchId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "organisationId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "resultCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pollStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pollResults",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "JobBoardSearchSearchError",
      "kind": "LinkedField",
      "name": "errors",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "message",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "JobBoardSearchSearchRun",
  "abstractKey": null
};
node503.hash = "e4d89bd8c5b1b7300eedf835403488e5";
var JobBoardSearchRunView_run_graphql_default = node503;

// src/job-board-search/components/JobBoardSearchRunView.tsx
import { Fragment as Fragment110 } from "react";
import { useFragment as useFragment149 } from "react-relay/hooks";
import { AuditFields as AuditFields4, DescriptionItem as DescriptionItem6, DescriptionList as DescriptionList6 } from "shared-ui";
import { jsx as jsx439, jsxs as jsxs297 } from "react/jsx-runtime";
var fragment26 = JobBoardSearchRunView_run_graphql_default;
var JobBoardSearchRunView = ({ run }) => {
  const data = useFragment149(fragment26, run);
  if (!data) {
    return /* @__PURE__ */ jsx439("div", { children: "No Search Details Available." });
  }
  return /* @__PURE__ */ jsx439(
    DescriptionList6,
    {
      heading: "Search Run",
      description: /* @__PURE__ */ jsx439("div", { className: "mt-4", children: /* @__PURE__ */ jsx439(AuditFields4, { createdOn: data.createdAt, updatedOn: data.updatedAt }) }),
      items: /* @__PURE__ */ jsxs297(Fragment110, { children: [
        /* @__PURE__ */ jsx439(DescriptionItem6, { label: "Status", children: data.status }),
        /* @__PURE__ */ jsx439(DescriptionItem6, { label: "Poll Status", children: data.pollStatus }),
        /* @__PURE__ */ jsx439(DescriptionItem6, { label: "Result Count", children: data.resultCount })
      ] })
    }
  );
};

// src/job-board-search/lib/JobBoardSearchStatus.ts
var JobBoardSearchStatus = /* @__PURE__ */ ((JobBoardSearchStatus2) => {
  JobBoardSearchStatus2[JobBoardSearchStatus2["Draft"] = 0] = "Draft";
  JobBoardSearchStatus2[JobBoardSearchStatus2["Active"] = 1] = "Active";
  JobBoardSearchStatus2[JobBoardSearchStatus2["Closed"] = 2] = "Closed";
  return JobBoardSearchStatus2;
})(JobBoardSearchStatus || {});

// src/job-board-search/lib/JobBoardSearchStatusList.ts
var JobBoardSearchStatusList = [
  {
    id: "All",
    label: "All"
  },
  {
    id: 1 /* Active */.toString(),
    label: "Active"
  },
  {
    id: 0 /* Draft */.toString(),
    label: "Draft"
  },
  {
    id: 2 /* Closed */.toString(),
    label: "Closed"
  }
];

// src/job-boards/components/__generated__/JobBoardListPaginationQuery.graphql.ts
var node504 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v23 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v32 = [
    v1,
    v23,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "name": "ASC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "JobBoardListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v23
          ],
          "kind": "FragmentSpread",
          "name": "JobBoardList_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "JobBoardListPaginationQuery",
      "selections": [
        {
          "alias": "list",
          "args": v32,
          "concreteType": "RecruitJobBoardsConnection",
          "kind": "LinkedField",
          "name": "recruitJobBoards",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitJobBoardsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitJobBoard",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobBoardId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isVisible",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "inboxEmail",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "candidateEmailLocation",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "candidateEmailRegex",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobReferenceLocation",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobReferenceCustomHeader",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobReferenceRegex",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v32,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "JobBoardList_list",
          "kind": "LinkedHandle",
          "name": "recruitJobBoards"
        }
      ]
    },
    "params": {
      "cacheID": "cb4377c287e481f9fb75b97612a1a648",
      "id": null,
      "metadata": {},
      "name": "JobBoardListPaginationQuery",
      "operationKind": "query",
      "text": "query JobBoardListPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $where: RecruitJobBoardFilter\n) {\n  ...JobBoardList_list_2HEEH6\n}\n\nfragment JobBoardList_list_2HEEH6 on Query {\n  list: recruitJobBoards(first: $first, after: $after, order: [{name: ASC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        jobBoardId\n        code\n        isVisible\n        name\n        inboxEmail\n        candidateEmailLocation\n        candidateEmailRegex\n        jobReferenceLocation\n        jobReferenceCustomHeader\n        jobReferenceRegex\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node504.hash = "809c0930dd4204b6b9dc9a61fecb105c";
var JobBoardListPaginationQuery_graphql_default = node504;

// src/job-boards/components/__generated__/JobBoardList_list.graphql.ts
var node505 = function() {
  var v0 = [
    "list"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": JobBoardListPaginationQuery_graphql_default
      }
    },
    "name": "JobBoardList_list",
    "selections": [
      {
        "alias": "list",
        "args": [
          {
            "kind": "Literal",
            "name": "order",
            "value": [
              {
                "name": "ASC"
              }
            ]
          },
          {
            "kind": "Variable",
            "name": "where",
            "variableName": "where"
          }
        ],
        "concreteType": "RecruitJobBoardsConnection",
        "kind": "LinkedField",
        "name": "__JobBoardList_list_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitJobBoardsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitJobBoard",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "jobBoardId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isVisible",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "inboxEmail",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "candidateEmailLocation",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "candidateEmailRegex",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "jobReferenceLocation",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "jobReferenceCustomHeader",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "jobReferenceRegex",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node505.hash = "809c0930dd4204b6b9dc9a61fecb105c";
var JobBoardList_list_graphql_default = node505;

// src/job-boards/components/__generated__/JobBoardListQuery.graphql.ts
var node506 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "name": "ASC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "JobBoardListQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "JobBoardList_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "JobBoardListQuery",
      "selections": [
        {
          "alias": "list",
          "args": v1,
          "concreteType": "RecruitJobBoardsConnection",
          "kind": "LinkedField",
          "name": "recruitJobBoards",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitJobBoardsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitJobBoard",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobBoardId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isVisible",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "inboxEmail",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "candidateEmailLocation",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "candidateEmailRegex",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobReferenceLocation",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobReferenceCustomHeader",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobReferenceRegex",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v1,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "JobBoardList_list",
          "kind": "LinkedHandle",
          "name": "recruitJobBoards"
        }
      ]
    },
    "params": {
      "cacheID": "fe69b6ea3a61bdc543e70185f55374d0",
      "id": null,
      "metadata": {},
      "name": "JobBoardListQuery",
      "operationKind": "query",
      "text": "query JobBoardListQuery(\n  $where: RecruitJobBoardFilter!\n) {\n  ...JobBoardList_list\n}\n\nfragment JobBoardList_list on Query {\n  list: recruitJobBoards(first: 10, order: [{name: ASC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        jobBoardId\n        code\n        isVisible\n        name\n        inboxEmail\n        candidateEmailLocation\n        candidateEmailRegex\n        jobReferenceLocation\n        jobReferenceCustomHeader\n        jobReferenceRegex\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node506.hash = "e7c24a35f4e17f39aa757e5e42c35e67";
var JobBoardListQuery_graphql_default = node506;

// src/job-boards/components/JobBoardList.tsx
import { Suspense as Suspense138, useCallback as useCallback243 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery70, usePaginationFragment as usePaginationFragment27 } from "react-relay";
import {
  BooleanIcon,
  DefaultListLayoutItemHeader as DefaultListLayoutItemHeader3,
  DefaultListLayoutSectionElement as DefaultListLayoutSectionElement3,
  EdSkeleton as EdSkeleton110,
  ListLayout as ListLayout7
} from "shared-ui";
import { isNotNullOrUndefined as isNotNullOrUndefined13 } from "shared-lib";
import { jsx as jsx440, jsxs as jsxs298 } from "react/jsx-runtime";
var fragmentDef106 = JobBoardList_list_graphql_default;
var queryDef72 = JobBoardListQuery_graphql_default;
function createLinkTo2(section) {
  const code = section.context.code;
  return `../../../view/${code}`;
}
var List3 = ({ fragmentRef }) => {
  const { data, loadNext } = usePaginationFragment27(fragmentDef106, fragmentRef);
  const onLoadNext = useCallback243(() => {
    loadNext(10);
  }, [loadNext]);
  const { list: list2 } = data;
  const sections = (list2?.edges || []).map((e4) => e4.node).filter(isNotNullOrUndefined13).map((jobBoard) => {
    const name = `${jobBoard.name}`;
    return {
      key: jobBoard.code.toString(),
      itemTitle: name,
      listTitle: /* @__PURE__ */ jsx440("div", { className: "flex flex-col gap-2", children: /* @__PURE__ */ jsxs298("div", { className: "flex items-center justify-between gap-2", children: [
        /* @__PURE__ */ jsx440("div", { className: "text-md font-medium uppercase", children: name }),
        /* @__PURE__ */ jsx440("div", { className: "text-md text-blue-500", children: jobBoard.code })
      ] }) }),
      description: /* @__PURE__ */ jsxs298("div", { className: "flex items-center gap-2 pt-2 text-sm", children: [
        /* @__PURE__ */ jsx440("div", { children: "Visible" }),
        /* @__PURE__ */ jsx440(BooleanIcon, { value: jobBoard.isVisible || false })
      ] }),
      hideIcon: true,
      icon: () => null,
      iconForeground: "text-primary-700",
      iconBackground: "bg-primary-50",
      context: {
        code: jobBoard.code
      },
      element: /* @__PURE__ */ jsx440(DefaultListLayoutSectionElement3, { children: /* @__PURE__ */ jsx440("div", { className: "grid", children: /* @__PURE__ */ jsx440("div", { children: jobBoard.code }) }) })
    };
  });
  return /* @__PURE__ */ jsx440(Suspense138, { fallback: /* @__PURE__ */ jsx440(EdSkeleton110, {}), children: /* @__PURE__ */ jsx440(
    ListLayout7,
    {
      title: "Job Boards",
      sections,
      itemHeader: (s4) => /* @__PURE__ */ jsx440(
        DefaultListLayoutItemHeader3,
        {
          title: "Job Boards",
          to: createLinkTo2,
          section: s4
        }
      ),
      loadMore: onLoadNext,
      isLoading: false,
      showFilters: true
    }
  ) });
};
var JobBoardList = ({ where }) => {
  const query3 = useLazyLoadQuery70(
    queryDef72,
    { where },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsx440(List3, { fragmentRef: query3 });
};

// src/job-boards/components/__generated__/JobBoardSearchBoxContainerQuery.graphql.ts
var node507 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "name": "ASC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "JobBoardSearchBoxContainerQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "JobBoardSearchBox_jobBoards"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "JobBoardSearchBoxContainerQuery",
      "selections": [
        {
          "alias": "list",
          "args": v1,
          "concreteType": "RecruitJobBoardsConnection",
          "kind": "LinkedField",
          "name": "recruitJobBoards",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitJobBoardsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitJobBoard",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobBoardId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isVisible",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "inboxEmail",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "candidateEmailLocation",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "candidateEmailRegex",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobReferenceLocation",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobReferenceCustomHeader",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobReferenceRegex",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v1,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "JobBoardSearchBox_list",
          "kind": "LinkedHandle",
          "name": "recruitJobBoards"
        }
      ]
    },
    "params": {
      "cacheID": "309f034927628c41c87f3eba17c4f602",
      "id": null,
      "metadata": {},
      "name": "JobBoardSearchBoxContainerQuery",
      "operationKind": "query",
      "text": "query JobBoardSearchBoxContainerQuery(\n  $where: RecruitJobBoardFilter!\n) {\n  ...JobBoardSearchBox_jobBoards\n}\n\nfragment JobBoardSearchBox_jobBoards on Query {\n  list: recruitJobBoards(first: 10, order: [{name: ASC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        jobBoardId\n        code\n        isVisible\n        name\n        inboxEmail\n        candidateEmailLocation\n        candidateEmailRegex\n        jobReferenceLocation\n        jobReferenceCustomHeader\n        jobReferenceRegex\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node507.hash = "231d49fe24e93c954164208a7726a372";
var JobBoardSearchBoxContainerQuery_graphql_default = node507;

// src/job-boards/components/JobBoardSearchBoxContainer.tsx
import { useCallback as useCallback245, useState as useState128 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery71 } from "react-relay";

// src/job-boards/components/__generated__/JobBoardSearchBoxPaginationQuery.graphql.ts
var node508 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v23 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v32 = [
    v1,
    v23,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "name": "ASC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "JobBoardSearchBoxPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v23
          ],
          "kind": "FragmentSpread",
          "name": "JobBoardSearchBox_jobBoards"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "JobBoardSearchBoxPaginationQuery",
      "selections": [
        {
          "alias": "list",
          "args": v32,
          "concreteType": "RecruitJobBoardsConnection",
          "kind": "LinkedField",
          "name": "recruitJobBoards",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitJobBoardsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitJobBoard",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobBoardId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isVisible",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "inboxEmail",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "candidateEmailLocation",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "candidateEmailRegex",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobReferenceLocation",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobReferenceCustomHeader",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobReferenceRegex",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v32,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "JobBoardSearchBox_list",
          "kind": "LinkedHandle",
          "name": "recruitJobBoards"
        }
      ]
    },
    "params": {
      "cacheID": "efa6668b8c834604aacab68d7e94de0e",
      "id": null,
      "metadata": {},
      "name": "JobBoardSearchBoxPaginationQuery",
      "operationKind": "query",
      "text": "query JobBoardSearchBoxPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $where: RecruitJobBoardFilter\n) {\n  ...JobBoardSearchBox_jobBoards_2HEEH6\n}\n\nfragment JobBoardSearchBox_jobBoards_2HEEH6 on Query {\n  list: recruitJobBoards(first: $first, after: $after, order: [{name: ASC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        jobBoardId\n        code\n        isVisible\n        name\n        inboxEmail\n        candidateEmailLocation\n        candidateEmailRegex\n        jobReferenceLocation\n        jobReferenceCustomHeader\n        jobReferenceRegex\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node508.hash = "7fee1acc8ed5cfd08fb4acd696f64e62";
var JobBoardSearchBoxPaginationQuery_graphql_default = node508;

// src/job-boards/components/__generated__/JobBoardSearchBox_jobBoards.graphql.ts
var node509 = function() {
  var v0 = [
    "list"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": JobBoardSearchBoxPaginationQuery_graphql_default
      }
    },
    "name": "JobBoardSearchBox_jobBoards",
    "selections": [
      {
        "alias": "list",
        "args": [
          {
            "kind": "Literal",
            "name": "order",
            "value": [
              {
                "name": "ASC"
              }
            ]
          },
          {
            "kind": "Variable",
            "name": "where",
            "variableName": "where"
          }
        ],
        "concreteType": "RecruitJobBoardsConnection",
        "kind": "LinkedField",
        "name": "__JobBoardSearchBox_list_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitJobBoardsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitJobBoard",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "jobBoardId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isVisible",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "inboxEmail",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "candidateEmailLocation",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "candidateEmailRegex",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "jobReferenceLocation",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "jobReferenceCustomHeader",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "jobReferenceRegex",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node509.hash = "7fee1acc8ed5cfd08fb4acd696f64e62";
var JobBoardSearchBox_jobBoards_graphql_default = node509;

// src/job-boards/components/JobBoardSearchBox.tsx
import {
  useCallback as useCallback244,
  useEffect as useEffect53,
  useMemo as useMemo44,
  useState as useState127
} from "react";
import { usePaginationFragment as usePaginationFragment28 } from "react-relay";
import { debounce as debounce12 } from "lodash-es";
import { CheckIcon as CheckIcon10, ChevronUpDownIcon as ChevronUpDownIcon10 } from "@heroicons/react/24/solid";
import { Combobox as Combobox18 } from "@headlessui/react";
import { classNames as classNames47 } from "shared-ui";
import { Fragment as Fragment111, jsx as jsx441, jsxs as jsxs299 } from "react/jsx-runtime";
var fragment27 = JobBoardSearchBox_jobBoards_graphql_default;
var JobBoardSearchBox = ({
  onSelected,
  jobBoards,
  defaultValue,
  showLabel
}) => {
  const [selected, setSelected] = useState127(
    defaultValue ?? null
  );
  const [searchTerm, setSearchTerm] = useState127("");
  const onQueryChangeHandler = useMemo44(
    () => debounce12((q4) => setSearchTerm(q4), 500),
    []
  );
  useEffect53(() => {
    return () => {
      onQueryChangeHandler.cancel();
    };
  }, []);
  const onSetSelected = useCallback244(
    (r4) => {
      setSelected(r4);
      onSelected(r4);
    },
    [selected]
  );
  const { data, refetch } = usePaginationFragment28(fragment27, jobBoards);
  const where = { isDeleted: { eq: false } };
  if (searchTerm) {
    where.and = [
      { name: { startsWith: searchTerm } },
      { isDeleted: { eq: false } }
    ];
  } else {
    where.and = [{ isDeleted: { eq: false } }];
  }
  useEffect53(() => {
    refetch({ first: 10, where }, { fetchPolicy: "store-or-network" });
  }, [searchTerm]);
  const { list: list2 } = data;
  const rows = (list2?.edges ?? []).map((edge) => edge.node);
  return /* @__PURE__ */ jsxs299(Combobox18, { as: "div", value: selected, onChange: onSetSelected, children: [
    showLabel && /* @__PURE__ */ jsx441(Combobox18.Label, { className: "block text-sm font-medium text-gray-700", children: "JobBoard" }),
    /* @__PURE__ */ jsxs299("div", { className: "relative", children: [
      /* @__PURE__ */ jsx441(
        Combobox18.Input,
        {
          className: "focus:border-info-500 focus:ring-info-500 w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:outline-none focus:ring-1 sm:text-sm",
          onChange: (event) => onQueryChangeHandler(event.target.value),
          displayValue: (result) => {
            if (result) {
              return result.name;
            }
            return "";
          },
          autoComplete: "off"
        }
      ),
      /* @__PURE__ */ jsx441(Combobox18.Button, { className: "absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none", children: /* @__PURE__ */ jsx441(
        ChevronUpDownIcon10,
        {
          className: "h-5 w-5 text-gray-400",
          "aria-hidden": "true"
        }
      ) }),
      rows.length > 0 && /* @__PURE__ */ jsx441(Combobox18.Options, { className: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm", children: rows.map((result) => /* @__PURE__ */ jsx441(
        Combobox18.Option,
        {
          value: result,
          className: ({ active }) => classNames47(
            "relative cursor-default select-none py-2 pl-3 pr-9",
            active ? "bg-info-600 text-white" : "text-gray-900"
          ),
          children: ({ active, selected: selected2 }) => /* @__PURE__ */ jsxs299(Fragment111, { children: [
            /* @__PURE__ */ jsx441("div", { className: "flex", children: /* @__PURE__ */ jsx441(
              "span",
              {
                className: classNames47(
                  "truncate",
                  selected2 ? "font-semibold" : ""
                ),
                children: result.name
              }
            ) }),
            selected2 && /* @__PURE__ */ jsx441(
              "span",
              {
                className: classNames47(
                  "absolute inset-y-0 right-0 flex items-center pr-4",
                  active ? "bg-info-600 text-white" : "text-info-600"
                ),
                children: /* @__PURE__ */ jsx441(CheckIcon10, { className: "h-5 w-5", "aria-hidden": "true" })
              }
            )
          ] })
        },
        result.id
      )) })
    ] })
  ] });
};

// src/job-boards/components/JobBoardSearchBoxContainer.tsx
import { jsx as jsx443 } from "react/jsx-runtime";
var graphqlQuery18 = JobBoardSearchBoxContainerQuery_graphql_default;
var JobBoardSearchBoxContainer = ({
  onSearchCompleted
}) => {
  const [selectedResult, setSelectedResult] = useState128();
  const onSetSelected = useCallback245(
    (r4) => {
      setSelectedResult(r4);
      onSearchCompleted(r4);
    },
    [selectedResult]
  );
  const where = { isDeleted: { eq: false } };
  const query3 = useLazyLoadQuery71(
    graphqlQuery18,
    { where },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsx443(JobBoardSearchBox, { onSelected: onSetSelected, jobBoards: query3 });
};

// src/job-boards/components/__generated__/JobBoardSearchBoxInputQuery.graphql.ts
var node511 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "name": "ASC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "JobBoardSearchBoxInputQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "JobBoardSearchBox_jobBoards"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "JobBoardSearchBoxInputQuery",
      "selections": [
        {
          "alias": "list",
          "args": v1,
          "concreteType": "RecruitJobBoardsConnection",
          "kind": "LinkedField",
          "name": "recruitJobBoards",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitJobBoardsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitJobBoard",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobBoardId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isVisible",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "inboxEmail",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "candidateEmailLocation",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "candidateEmailRegex",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobReferenceLocation",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobReferenceCustomHeader",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobReferenceRegex",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v1,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "JobBoardSearchBox_list",
          "kind": "LinkedHandle",
          "name": "recruitJobBoards"
        }
      ]
    },
    "params": {
      "cacheID": "8a5ab42d3b8816da6d6d005b905e9ec2",
      "id": null,
      "metadata": {},
      "name": "JobBoardSearchBoxInputQuery",
      "operationKind": "query",
      "text": "query JobBoardSearchBoxInputQuery(\n  $where: RecruitJobBoardFilter!\n) {\n  ...JobBoardSearchBox_jobBoards\n}\n\nfragment JobBoardSearchBox_jobBoards on Query {\n  list: recruitJobBoards(first: 10, order: [{name: ASC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        jobBoardId\n        code\n        isVisible\n        name\n        inboxEmail\n        candidateEmailLocation\n        candidateEmailRegex\n        jobReferenceLocation\n        jobReferenceCustomHeader\n        jobReferenceRegex\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node511.hash = "761f931f60b446ad2b09ae4505f6420e";
var JobBoardSearchBoxInputQuery_graphql_default = node511;

// src/job-boards/components/JobBoardSearchBoxInput.tsx
import { Controller as Controller13 } from "react-hook-form";
import { useLazyLoadQuery as useLazyLoadQuery73 } from "react-relay";
import { jsx as jsx444 } from "react/jsx-runtime";
var graphqlQuery19 = JobBoardSearchBoxInputQuery_graphql_default;
var JobBoardSearchBoxInput = ({
  name,
  control,
  defaultValue,
  showLabel
}) => {
  const where = { isDeleted: { eq: false } };
  const query3 = useLazyLoadQuery73(
    graphqlQuery19,
    { where },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsx444(
    Controller13,
    {
      control,
      name,
      render: ({ field: { onChange: onControllerChange } }) => /* @__PURE__ */ jsx444(
        JobBoardSearchBox,
        {
          onSelected: (result) => {
            onControllerChange(result);
          },
          jobBoards: query3,
          defaultValue,
          showLabel
        }
      )
    }
  );
};

// src/job-publishing/components/__generated__/IdibuConfigContainer_config.graphql.ts
var node513 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IdibuConfigContainer_config",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "idibuConfigId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdById",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdByAccountType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedById",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedByAccountType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "employerId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uppHash",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uppSenderId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAdminOnly",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Employer",
      "kind": "LinkedField",
      "name": "employer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RecruitIdibuConfig",
  "abstractKey": null
};
node513.hash = "a1ef0a92fcfed5c90277ac1cd8ee8f95";
var IdibuConfigContainer_config_graphql_default = node513;

// src/job-publishing/components/IdibuConfigContainer.tsx
import { useFragment as useFragment150 } from "react-relay";
import { BooleanIcon as BooleanIcon2, DescriptionItem as DescriptionItem7, DescriptionList as DescriptionList7 } from "shared-ui";
import { timeAgo as timeAgo11 } from "shared-lib";
import { Fragment as Fragment112, jsx as jsx445, jsxs as jsxs300 } from "react/jsx-runtime";
var fragmentDef107 = IdibuConfigContainer_config_graphql_default;
var IdibuConfigContainer = ({ fragmentRef }) => {
  const data = useFragment150(fragmentDef107, fragmentRef);
  return /* @__PURE__ */ jsx445(
    DescriptionList7,
    {
      heading: /* @__PURE__ */ jsx445("div", { className: "flex flex-col gap-2", children: /* @__PURE__ */ jsxs300("span", { className: "text-sm text-gray-500", children: [
        "Updated ",
        timeAgo11(data.updatedAt)
      ] }) }),
      items: /* @__PURE__ */ jsxs300(Fragment112, { children: [
        /* @__PURE__ */ jsx445(DescriptionItem7, { label: "Upp Hash", children: /* @__PURE__ */ jsx445("div", { children: data.uppHash }) }),
        /* @__PURE__ */ jsx445(DescriptionItem7, { label: "Upp Sender Id", children: /* @__PURE__ */ jsx445("div", { children: data.uppSenderId }) }),
        /* @__PURE__ */ jsx445(DescriptionItem7, { label: "Enabled", children: /* @__PURE__ */ jsx445(BooleanIcon2, { value: data.isEnabled }) }),
        /* @__PURE__ */ jsx445(DescriptionItem7, { label: "Admin Only", children: /* @__PURE__ */ jsx445(BooleanIcon2, { value: data.isAdminOnly }) })
      ] })
    }
  );
};

// src/job-publishing/components/IdibuConfigEditor.tsx
import { useCallback as useCallback246 } from "react";
import * as zod14 from "zod";
import { useForm as useForm24 } from "react-hook-form";
import { zodResolver as zodResolver19 } from "@hookform/resolvers/zod";
import {
  createClientMutationId as createClientMutationId100,
  useSetUserErrorCodes as useSetUserErrorCodes36,
  useUserErrorCode as useUserErrorCode16
} from "shared-lib";
import {
  ActionContainer as ActionContainer9,
  ErrorField as ErrorField7,
  FormErrorCode as FormErrorCode2,
  FormErrorCodes as FormErrorCodes4,
  FormInputRow as FormInputRow7,
  InputField as InputField5,
  SwitchInput as SwitchInput2
} from "shared-ui";

// src/job-publishing/mutations/__generated__/UseSetIdibuConfigForEmployerMutation.graphql.ts
var node514 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfIdibuConfig",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitIdibuConfig",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "idibuConfigId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "version",
            "storageKey": null
          },
          v23,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdById",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdByAccountType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedById",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedByAccountType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "uppHash",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "uppSenderId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isEnabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAdminOnly",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v23,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseSetIdibuConfigForEmployerMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitJobBoardIntegrationsSetConfigForEmployerPayload",
          "kind": "LinkedField",
          "name": "recruitJobBoardIntegrationsSetConfigForEmployer",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseSetIdibuConfigForEmployerMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitJobBoardIntegrationsSetConfigForEmployerPayload",
          "kind": "LinkedField",
          "name": "recruitJobBoardIntegrationsSetConfigForEmployer",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "0378e221ac38cf1031e7c78583a46d6d",
      "id": null,
      "metadata": {},
      "name": "UseSetIdibuConfigForEmployerMutation",
      "operationKind": "mutation",
      "text": "mutation UseSetIdibuConfigForEmployerMutation(\n  $input: RecruitJobBoardIntegrationsSetConfigForEmployerInput!\n) {\n  data: recruitJobBoardIntegrationsSetConfigForEmployer(input: $input) {\n    payload {\n      node {\n        id\n        idibuConfigId\n        version\n        code\n        createdAt\n        createdById\n        createdByAccountType\n        updatedAt\n        updatedById\n        updatedByAccountType\n        employerId\n        uppHash\n        uppSenderId\n        isEnabled\n        isAdminOnly\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node514.hash = "0bdb75e9f8d4e6823e8ab5f8f75cb038";
var UseSetIdibuConfigForEmployerMutation_graphql_default = node514;

// src/job-publishing/mutations/UseSetIdibuConfigForEmployer.ts
import { useAsyncMutation as useAsyncMutation75 } from "shared-lib";
var mutationDef95 = UseSetIdibuConfigForEmployerMutation_graphql_default;
function useSetIdibuConfigForEmployer() {
  const [commit11, isBusy] = useAsyncMutation75(mutationDef95);
  return [commit11, isBusy];
}

// src/job-publishing/components/IdibuConfigEditor.tsx
import { jsx as jsx446, jsxs as jsxs301 } from "react/jsx-runtime";
var formSchema11 = zod14.object({
  uppHash: zod14.string().min(1, { message: "uppHash is required" }),
  uppSenderId: zod14.string().min(1, { message: "uppSenderId is required" }),
  isEnabled: zod14.boolean(),
  isAdminOnly: zod14.boolean()
});
var IdibuConfigEditor = ({
  employerId,
  onDone,
  onCancel
}) => {
  const defaultValues2 = {
    uppHash: "",
    uppSenderId: "",
    isEnabled: false,
    isAdminOnly: true
  };
  const setErrorCode = useSetUserErrorCodes36();
  const { register, handleSubmit, watch, formState, control } = useForm24({
    resolver: zodResolver19(formSchema11),
    defaultValues: defaultValues2,
    mode: "onChange"
  });
  const userErrorCode = useUserErrorCode16();
  const [setConfig, isSettingConfig] = useSetIdibuConfigForEmployer();
  const onSave = useCallback246(
    async (form) => {
      setErrorCode(null);
      if (!form.uppHash || !form.uppSenderId) {
        return;
      }
      const input = {
        clientMutationId: createClientMutationId100(),
        employerId,
        uppHash: form.uppHash,
        uppSenderId: form.uppSenderId,
        isEnabled: form.isEnabled,
        isAdminOnly: form.isAdminOnly
      };
      const response = await setConfig({ input });
      if (response.data.userErrors && response.data.userErrors.length > 0) {
        setErrorCode(response.data.userErrors);
      }
      if (response.data.payload?.node) {
        onDone(response.data.payload.node);
      }
    },
    [setConfig]
  );
  const onSubmit = handleSubmit(
    async (form) => {
      await onSave(form);
    },
    (invalid) => {
      console.error(invalid);
    }
  );
  const { errors, isValid, isDirty } = formState;
  let errorDisplay = /* @__PURE__ */ jsx446(FormErrorCodes4, {});
  if (userErrorCode) {
    errorDisplay = /* @__PURE__ */ jsx446(FormErrorCode2, { message: userErrorCode });
  }
  return /* @__PURE__ */ jsxs301("div", { className: "m-4 flex flex-col items-center justify-center", children: [
    errorDisplay,
    /* @__PURE__ */ jsx446("form", { onSubmit, children: /* @__PURE__ */ jsxs301(
      ActionContainer9,
      {
        isDirty,
        showSubmit: true,
        showCancel: true,
        onCancel,
        isDisabled: isSettingConfig,
        titleTop: `Set Idibu Config`,
        children: [
          /* @__PURE__ */ jsxs301(FormInputRow7, { name: "uppHash", title: "Upp Hash *", children: [
            /* @__PURE__ */ jsx446(
              InputField5,
              {
                register,
                name: "uppHash",
                required: true,
                placeholder: "Upp Hash"
              }
            ),
            /* @__PURE__ */ jsx446(ErrorField7, { field: errors.uppHash })
          ] }),
          /* @__PURE__ */ jsxs301(FormInputRow7, { name: "uppSenderId", title: "Upp Sender Id *", children: [
            /* @__PURE__ */ jsx446(
              InputField5,
              {
                register,
                name: "uppSenderId",
                required: true,
                placeholder: "Upp Sender Id"
              }
            ),
            /* @__PURE__ */ jsx446(ErrorField7, { field: errors.uppSenderId })
          ] }),
          /* @__PURE__ */ jsxs301(FormInputRow7, { name: "isEnabled", title: "Enabled *", children: [
            /* @__PURE__ */ jsx446(
              SwitchInput2,
              {
                control,
                name: "isEnabled",
                defaultChecked: false
              }
            ),
            /* @__PURE__ */ jsx446(ErrorField7, { field: errors.isEnabled })
          ] }),
          /* @__PURE__ */ jsxs301(FormInputRow7, { name: "isAdminOnly", title: "Admin Only *", children: [
            /* @__PURE__ */ jsx446(
              SwitchInput2,
              {
                control,
                name: "isAdminOnly",
                defaultChecked: false
              }
            ),
            /* @__PURE__ */ jsx446(ErrorField7, { field: errors.isAdminOnly })
          ] })
        ]
      }
    ) })
  ] });
};

// src/profile-sources/components/ProfileSourcesRoutes.tsx
import { ErrorContainer as ErrorContainer15 } from "shared-ui";

// src/profile-sources/components/__generated__/EmployerProfileSourcesRouteQuery.graphql.ts
var node515 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "employerId"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "employerId",
      "variableName": "employerId"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": "employerTalentPools",
    "args": v1,
    "concreteType": "RecruitTalentPool",
    "kind": "LinkedField",
    "name": "recruitTalentPoolsForEmployer",
    "plural": true,
    "selections": [
      v23,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "talentPoolId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 15
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": {
        "createdOn": "DESC"
      }
    },
    {
      "fields": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "eq",
              "variableName": "employerId"
            }
          ],
          "kind": "ObjectValue",
          "name": "employerId"
        },
        {
          "fields": [
            {
              "kind": "Literal",
              "name": "eq",
              "value": null
            }
          ],
          "kind": "ObjectValue",
          "name": "sourceType"
        }
      ],
      "kind": "ObjectValue",
      "name": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerProfileSourcesRouteQuery",
      "selections": [
        {
          "args": v1,
          "kind": "FragmentSpread",
          "name": "EmployerProfileSourceList_sources"
        },
        v32
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerProfileSourcesRouteQuery",
      "selections": [
        {
          "alias": "sources",
          "args": v4,
          "concreteType": "RecruitEmployerProfileSourcesConnection",
          "kind": "LinkedField",
          "name": "recruitEmployerProfileSources",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitEmployerProfileSourcesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EmployerProfileSource",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v23,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "seqId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountId",
                      "kind": "LinkedField",
                      "name": "createdBy",
                      "plural": false,
                      "selections": [
                        v23,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "accountType",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ProfileSource",
                      "kind": "LinkedField",
                      "name": "source",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "sourceId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "sourceName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "sourceType",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "sources",
          "args": v4,
          "filters": [],
          "handle": "connection",
          "key": "EmployerProfileSourceList_sources",
          "kind": "LinkedHandle",
          "name": "recruitEmployerProfileSources"
        },
        v32
      ]
    },
    "params": {
      "cacheID": "b7bd20955d0cf9a655e9ff685165fbb8",
      "id": null,
      "metadata": {},
      "name": "EmployerProfileSourcesRouteQuery",
      "operationKind": "query",
      "text": "query EmployerProfileSourcesRouteQuery(\n  $employerId: UUID!\n) {\n  ...EmployerProfileSourceList_sources_4aLTpM\n  employerTalentPools: recruitTalentPoolsForEmployer(employerId: $employerId) {\n    id\n    name\n    talentPoolId\n  }\n}\n\nfragment EmployerProfileSourceList_sources_4aLTpM on Query {\n  sources: recruitEmployerProfileSources(first: 15, where: {employerId: {eq: $employerId}, sourceType: {}}, order: {createdOn: DESC}) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        seqId\n        createdOn\n        createdBy {\n          id\n          accountType\n        }\n        employerId\n        source {\n          sourceId\n          sourceName\n          sourceType\n        }\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node515.hash = "34f5eed8615053539e7499e125042813";
var EmployerProfileSourcesRouteQuery_graphql_default = node515;

// src/profile-sources/components/EmployerProfileSourcesRoute.tsx
import { Suspense as Suspense139 } from "react";
import {
  loadQuery as loadQuery44,
  usePreloadedQuery as usePreloadedQuery47
} from "react-relay";
import { useRouteLoaderData as useRouteLoaderData17 } from "react-router-dom";
import { EdSkeleton as EdSkeleton111 } from "shared-ui";
import { resolveEmployerId as resolveEmployerId4 } from "app-core";

// src/profile-sources/components/__generated__/EmployerProfileSourceListPaginationQuery.graphql.ts
var node516 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "employerId"
    },
    {
      "defaultValue": 15,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": {
        "createdOn": "DESC"
      },
      "kind": "LocalArgument",
      "name": "sort"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "sourceType"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v23 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v32 = [
    v1,
    v23,
    {
      "kind": "Variable",
      "name": "order",
      "variableName": "sort"
    },
    {
      "fields": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "eq",
              "variableName": "employerId"
            }
          ],
          "kind": "ObjectValue",
          "name": "employerId"
        },
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "eq",
              "variableName": "sourceType"
            }
          ],
          "kind": "ObjectValue",
          "name": "sourceType"
        }
      ],
      "kind": "ObjectValue",
      "name": "where"
    }
  ], v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerProfileSourceListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            {
              "kind": "Variable",
              "name": "employerId",
              "variableName": "employerId"
            },
            v23,
            {
              "kind": "Variable",
              "name": "sort",
              "variableName": "sort"
            },
            {
              "kind": "Variable",
              "name": "sourceType",
              "variableName": "sourceType"
            }
          ],
          "kind": "FragmentSpread",
          "name": "EmployerProfileSourceList_sources"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerProfileSourceListPaginationQuery",
      "selections": [
        {
          "alias": "sources",
          "args": v32,
          "concreteType": "RecruitEmployerProfileSourcesConnection",
          "kind": "LinkedField",
          "name": "recruitEmployerProfileSources",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitEmployerProfileSourcesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EmployerProfileSource",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v4,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "seqId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountId",
                      "kind": "LinkedField",
                      "name": "createdBy",
                      "plural": false,
                      "selections": [
                        v4,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "accountType",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ProfileSource",
                      "kind": "LinkedField",
                      "name": "source",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "sourceId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "sourceName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "sourceType",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "sources",
          "args": v32,
          "filters": [],
          "handle": "connection",
          "key": "EmployerProfileSourceList_sources",
          "kind": "LinkedHandle",
          "name": "recruitEmployerProfileSources"
        }
      ]
    },
    "params": {
      "cacheID": "f909f4186bda2d692a056ec29d18f477",
      "id": null,
      "metadata": {},
      "name": "EmployerProfileSourceListPaginationQuery",
      "operationKind": "query",
      "text": "query EmployerProfileSourceListPaginationQuery(\n  $after: String\n  $employerId: UUID\n  $first: Int = 15\n  $sort: [EmployerProfileSourceSort!] = {createdOn: DESC}\n  $sourceType: String\n) {\n  ...EmployerProfileSourceList_sources_1q8nb1\n}\n\nfragment EmployerProfileSourceList_sources_1q8nb1 on Query {\n  sources: recruitEmployerProfileSources(first: $first, after: $after, where: {employerId: {eq: $employerId}, sourceType: {eq: $sourceType}}, order: $sort) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        seqId\n        createdOn\n        createdBy {\n          id\n          accountType\n        }\n        employerId\n        source {\n          sourceId\n          sourceName\n          sourceType\n        }\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node516.hash = "3638828b2ec0152fb43679be8d8181ec";
var EmployerProfileSourceListPaginationQuery_graphql_default = node516;

// src/profile-sources/components/__generated__/EmployerProfileSourceList_sources.graphql.ts
var node517 = function() {
  var v0 = [
    "sources"
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "employerId"
      },
      {
        "defaultValue": 15,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "defaultValue": {
          "createdOn": "DESC"
        },
        "kind": "LocalArgument",
        "name": "sort"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sourceType"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": EmployerProfileSourceListPaginationQuery_graphql_default
      }
    },
    "name": "EmployerProfileSourceList_sources",
    "selections": [
      {
        "alias": "sources",
        "args": null,
        "concreteType": "RecruitEmployerProfileSourcesConnection",
        "kind": "LinkedField",
        "name": "__EmployerProfileSourceList_sources_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitEmployerProfileSourcesEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EmployerProfileSource",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  v1,
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "seqId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdOn",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AccountId",
                    "kind": "LinkedField",
                    "name": "createdBy",
                    "plural": false,
                    "selections": [
                      v1,
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "accountType",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "employerId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProfileSource",
                    "kind": "LinkedField",
                    "name": "source",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "sourceId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "sourceName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "sourceType",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node517.hash = "3638828b2ec0152fb43679be8d8181ec";
var EmployerProfileSourceList_sources_graphql_default = node517;

// src/profile-sources/components/EmployerProfileSourceList.tsx
import { useCallback as useCallback247, useState as useState129 } from "react";
import { usePaginationFragment as usePaginationFragment29 } from "react-relay";
import { Switch as Switch4 } from "@headlessui/react";
import { createClientMutationId as createClientMutationId101, isNotNull as isNotNull11 } from "shared-lib";

// src/profile-sources/mutations/__generated__/UseEmployerProfileSourcesUpdateMutation.graphql.ts
var node518 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfEmployerProfileSource",
    "kind": "LinkedField",
    "name": "payload",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "EmployerProfileSource",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          v23,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "seqId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountId",
            "kind": "LinkedField",
            "name": "createdBy",
            "plural": false,
            "selections": [
              v23,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accountType",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProfileSource",
            "kind": "LinkedField",
            "name": "source",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sourceId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sourceName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sourceType",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerProfileSourcesUpdateMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitEmployerProfileSourcesUpdatePayload",
          "kind": "LinkedField",
          "name": "recruitEmployerProfileSourcesUpdate",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerProfileSourcesUpdateMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "RecruitEmployerProfileSourcesUpdatePayload",
          "kind": "LinkedField",
          "name": "recruitEmployerProfileSourcesUpdate",
          "plural": false,
          "selections": [
            v32,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "05ddf088da77ac357698c47c75fbc129",
      "id": null,
      "metadata": {},
      "name": "UseEmployerProfileSourcesUpdateMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerProfileSourcesUpdateMutation(\n  $input: RecruitEmployerProfileSourcesUpdateInput!\n) {\n  result: recruitEmployerProfileSourcesUpdate(input: $input) {\n    payload {\n      node {\n        id\n        seqId\n        createdOn\n        createdBy {\n          id\n          accountType\n        }\n        employerId\n        source {\n          sourceId\n          sourceName\n          sourceType\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node518.hash = "190b04f4f21bd13e5c6424e7d399de39";
var UseEmployerProfileSourcesUpdateMutation_graphql_default = node518;

// src/profile-sources/mutations/UseEmployerProfileSourcesUpdate.ts
import { useAsyncMutation as useAsyncMutation76 } from "shared-lib";
var mutationDef96 = UseEmployerProfileSourcesUpdateMutation_graphql_default;
function useEmployerProfileSourcesUpdate() {
  const [commit11, isBusy] = useAsyncMutation76(mutationDef96);
  return [commit11, isBusy];
}

// src/profile-sources/lib/ProfileSources.ts
var TalentPoolSourceType = "talent-pool";

// src/profile-sources/components/EmployerProfileSourceList.tsx
import { jsx as jsx447, jsxs as jsxs303 } from "react/jsx-runtime";
var fragmentDef108 = EmployerProfileSourceList_sources_graphql_default;
var EmployerProfileSourceList = ({
  fragmentRef,
  onSelect,
  employerTalentPools,
  employerId
}) => {
  const { data, refetch } = usePaginationFragment29(fragmentDef108, fragmentRef);
  const { sources } = data;
  const rows = (sources?.edges ?? []).map((edge) => edge.node).filter(isNotNull11);
  return /* @__PURE__ */ jsxs303("fieldset", { children: [
    /* @__PURE__ */ jsx447("legend", { className: "text-base font-semibold leading-6 text-gray-900", children: "Default Vacancy Talent Pool Profile Sources" }),
    /* @__PURE__ */ jsx447("div", { className: "mt-4 divide-y divide-gray-200 border-t border-gray-200", children: (employerTalentPools || []).map((tp) => /* @__PURE__ */ jsx447(
      EmployerProfileSource,
      {
        talentPool: tp,
        employerId,
        sources: rows,
        onSelect
      },
      tp.talentPoolId
    )) })
  ] });
};
var EmployerProfileSource = ({
  talentPool,
  employerId,
  sources,
  onSelect
}) => {
  const [isDefaultEnabled, setIsDefaultEnabled] = useState129(() => {
    return sources.some((s4) => {
      return s4.source.sourceId === talentPool.talentPoolId;
    });
  });
  const [setSources, isSettingSources] = useEmployerProfileSourcesUpdate();
  const onToggleEnabled = useCallback247(async () => {
    let changes = sources.map(
      (s4) => {
        return {
          employerId,
          selected: true,
          sourceType: TalentPoolSourceType,
          sourceId: s4.source.sourceId
        };
      }
    );
    if (isDefaultEnabled) {
      changes = changes.filter((c4) => c4.sourceId !== talentPool.talentPoolId);
    } else {
      changes = [
        ...changes,
        {
          employerId,
          selected: true,
          sourceType: TalentPoolSourceType,
          sourceId: talentPool.talentPoolId
        }
      ];
    }
    const input = {
      clientMutationId: createClientMutationId101(),
      employerId,
      changes
    };
    const response = await setSources({ input });
    if (response.result.payload) {
      console.log("Changed");
      setIsDefaultEnabled(!isDefaultEnabled);
    }
  }, [onSelect, isDefaultEnabled]);
  return /* @__PURE__ */ jsxs303(
    "div",
    {
      className: "relative flex cursor-pointer items-start py-4 hover:bg-gray-50",
      children: [
        /* @__PURE__ */ jsx447("div", { className: "min-w-0 flex-1 text-sm leading-6", children: /* @__PURE__ */ jsx447(
          "label",
          {
            htmlFor: `source-${talentPool.talentPoolId}`,
            className: "select-none font-medium text-gray-900",
            children: talentPool.name
          }
        ) }),
        /* @__PURE__ */ jsx447("div", { className: "ml-3 flex h-6 items-center", children: /* @__PURE__ */ jsxs303(
          Switch4,
          {
            checked: isDefaultEnabled,
            onChange: onToggleEnabled,
            className: `${isDefaultEnabled ? "bg-blue-600" : "bg-gray-200"} relative inline-flex h-6 w-11 items-center rounded-full`,
            children: [
              /* @__PURE__ */ jsx447("span", { className: "sr-only", children: "Is Enabled By Default" }),
              /* @__PURE__ */ jsx447(
                "span",
                {
                  className: `${isDefaultEnabled ? "translate-x-6" : "translate-x-1"} inline-block h-4 w-4 transform rounded-full bg-white transition`
                }
              )
            ]
          }
        ) })
      ]
    },
    talentPool.talentPoolId
  );
};

// src/profile-sources/components/EmployerProfileSourcesRoute.tsx
import { jsx as jsx448 } from "react/jsx-runtime";
var queryDef73 = EmployerProfileSourcesRouteQuery_graphql_default;
async function loader36(environment, params, context) {
  const employerId = resolveEmployerId4(params, context);
  const queryRef3 = loadQuery44(
    environment,
    queryDef73,
    {
      employerId
    }
  );
  return {
    employerId,
    queryRef: queryRef3
  };
}
function useRouteData26(routeId4) {
  const { employerId, queryRef: queryRef3 } = useRouteLoaderData17(routeId4);
  const query3 = usePreloadedQuery47(
    queryDef73,
    queryRef3
  );
  return {
    employerId,
    query: query3
  };
}
var EmployerProfileSourcesRoute = ({ routeId: routeId4, onSelect }) => {
  const { employerId, query: query3 } = useRouteData26(routeId4);
  const { employerTalentPools } = query3;
  return /* @__PURE__ */ jsx448(Suspense139, { fallback: /* @__PURE__ */ jsx448(EdSkeleton111, {}), children: /* @__PURE__ */ jsx448("div", { className: "flex flex-1 bg-white", children: /* @__PURE__ */ jsx448("div", { className: "flex w-full flex-col", children: /* @__PURE__ */ jsx448("div", { className: "w-full border bg-white p-8 md:m-8 md:mt-20 md:w-1/2 lg:mt-8", children: /* @__PURE__ */ jsx448(
    EmployerProfileSourceList,
    {
      employerId,
      fragmentRef: query3,
      employerTalentPools,
      onSelect
    }
  ) }) }) }) });
};

// src/profile-sources/components/ProfileSourcesRoutes.tsx
import { jsx as jsx449 } from "react/jsx-runtime";
var createProfileSourcesRoutes = (routePrefix, environment, context) => {
  const routeId4 = `${routePrefix}-profile-sources`;
  return [
    {
      path: "*",
      id: routeId4,
      element: /* @__PURE__ */ jsx449(EmployerProfileSourcesRoute, { routeId: routeId4 }),
      errorElement: /* @__PURE__ */ jsx449(ErrorContainer15, {}),
      handle: {
        crumb: () => /* @__PURE__ */ jsx449("div", {})
      },
      loader: ({ params }) => {
        return loader36(environment, params, context);
      }
    }
  ];
};

// src/profile-sources/components/__generated__/EmployerProfileSourcesContainerQuery.graphql.ts
var node519 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "employerId"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "employerId",
      "variableName": "employerId"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": "employerTalentPools",
    "args": v1,
    "concreteType": "RecruitTalentPool",
    "kind": "LinkedField",
    "name": "recruitTalentPoolsForEmployer",
    "plural": true,
    "selections": [
      v23,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "talentPoolId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 15
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": {
        "createdOn": "DESC"
      }
    },
    {
      "fields": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "eq",
              "variableName": "employerId"
            }
          ],
          "kind": "ObjectValue",
          "name": "employerId"
        },
        {
          "fields": [
            {
              "kind": "Literal",
              "name": "eq",
              "value": null
            }
          ],
          "kind": "ObjectValue",
          "name": "sourceType"
        }
      ],
      "kind": "ObjectValue",
      "name": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerProfileSourcesContainerQuery",
      "selections": [
        {
          "args": v1,
          "kind": "FragmentSpread",
          "name": "EmployerProfileSourceList_sources"
        },
        v32
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerProfileSourcesContainerQuery",
      "selections": [
        {
          "alias": "sources",
          "args": v4,
          "concreteType": "RecruitEmployerProfileSourcesConnection",
          "kind": "LinkedField",
          "name": "recruitEmployerProfileSources",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitEmployerProfileSourcesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EmployerProfileSource",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v23,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "seqId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountId",
                      "kind": "LinkedField",
                      "name": "createdBy",
                      "plural": false,
                      "selections": [
                        v23,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "accountType",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ProfileSource",
                      "kind": "LinkedField",
                      "name": "source",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "sourceId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "sourceName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "sourceType",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "sources",
          "args": v4,
          "filters": [],
          "handle": "connection",
          "key": "EmployerProfileSourceList_sources",
          "kind": "LinkedHandle",
          "name": "recruitEmployerProfileSources"
        },
        v32
      ]
    },
    "params": {
      "cacheID": "9006c38bdabe9d09624041e1c9df6297",
      "id": null,
      "metadata": {},
      "name": "EmployerProfileSourcesContainerQuery",
      "operationKind": "query",
      "text": "query EmployerProfileSourcesContainerQuery(\n  $employerId: UUID!\n) {\n  ...EmployerProfileSourceList_sources_4aLTpM\n  employerTalentPools: recruitTalentPoolsForEmployer(employerId: $employerId) {\n    id\n    name\n    talentPoolId\n  }\n}\n\nfragment EmployerProfileSourceList_sources_4aLTpM on Query {\n  sources: recruitEmployerProfileSources(first: 15, where: {employerId: {eq: $employerId}, sourceType: {}}, order: {createdOn: DESC}) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        seqId\n        createdOn\n        createdBy {\n          id\n          accountType\n        }\n        employerId\n        source {\n          sourceId\n          sourceName\n          sourceType\n        }\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node519.hash = "5956379cbbe0af77e9f0bb66a2e2b50f";
var EmployerProfileSourcesContainerQuery_graphql_default = node519;

// src/profile-sources/components/EmployerProfileSourcesContainer.tsx
import { Suspense as Suspense140 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery74 } from "react-relay";
import { EdSkeleton as EdSkeleton113 } from "shared-ui";
import { jsx as jsx450 } from "react/jsx-runtime";
var queryDef74 = EmployerProfileSourcesContainerQuery_graphql_default;
var EmployerProfileSourcesContainer = ({
  employerId,
  onSelect
}) => {
  const query3 = useLazyLoadQuery74(
    queryDef74,
    { employerId }
  );
  const { employerTalentPools } = query3;
  return /* @__PURE__ */ jsx450(Suspense140, { fallback: /* @__PURE__ */ jsx450(EdSkeleton113, {}), children: /* @__PURE__ */ jsx450(
    EmployerProfileSourceList,
    {
      employerId,
      fragmentRef: query3,
      employerTalentPools,
      onSelect
    }
  ) });
};

// src/talent-pools/talent-pool-employer-access/components/__generated__/EmployerVacancyTalentPoolDefaultInvitesEditorQuery.graphql.ts
var node520 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "employerId"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "employerId",
      "variableName": "employerId"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": "defaults",
    "args": v1,
    "concreteType": "RecruitEmployerVacancyDefaults",
    "kind": "LinkedField",
    "name": "recruitEmployerVacancyDefaultsByEmployer",
    "plural": false,
    "selections": [
      v23,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "employerVacancyDefaultsId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "inviteToTalentPoolIds",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "privateRateMode",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 15
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": {
        "seqId": "DESC"
      }
    },
    {
      "fields": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "eq",
              "variableName": "employerId"
            }
          ],
          "kind": "ObjectValue",
          "name": "employerId"
        }
      ],
      "kind": "ObjectValue",
      "name": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerVacancyTalentPoolDefaultInvitesEditorQuery",
      "selections": [
        {
          "args": v1,
          "kind": "FragmentSpread",
          "name": "EmployerVacancyTalentPoolDefaultsList_access"
        },
        v32
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerVacancyTalentPoolDefaultInvitesEditorQuery",
      "selections": [
        {
          "alias": "access",
          "args": v4,
          "concreteType": "RecruitTalentPoolEmployerAccessConnection",
          "kind": "LinkedField",
          "name": "recruitTalentPoolEmployerAccess",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitTalentPoolEmployerAccessEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitTalentPoolEmployerAccess",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v23,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "talentPoolEmployerAccessId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountId",
                      "kind": "LinkedField",
                      "name": "createdBy",
                      "plural": false,
                      "selections": [
                        v23,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "accountType",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitTalentPool",
                      "kind": "LinkedField",
                      "name": "talentPool",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "talentPoolId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        },
                        v23
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "access",
          "args": v4,
          "filters": [],
          "handle": "connection",
          "key": "EmployerVacancyTalentPoolDefaultsList_access",
          "kind": "LinkedHandle",
          "name": "recruitTalentPoolEmployerAccess"
        },
        v32
      ]
    },
    "params": {
      "cacheID": "fb7c9574c230abb03cdd5195d1a22a76",
      "id": null,
      "metadata": {},
      "name": "EmployerVacancyTalentPoolDefaultInvitesEditorQuery",
      "operationKind": "query",
      "text": "query EmployerVacancyTalentPoolDefaultInvitesEditorQuery(\n  $employerId: UUID!\n) {\n  ...EmployerVacancyTalentPoolDefaultsList_access_4aLTpM\n  defaults: recruitEmployerVacancyDefaultsByEmployer(employerId: $employerId) {\n    id\n    employerVacancyDefaultsId\n    createdOn\n    inviteToTalentPoolIds\n    privateRateMode\n  }\n}\n\nfragment EmployerVacancyTalentPoolDefaultsList_access_4aLTpM on Query {\n  access: recruitTalentPoolEmployerAccess(first: 15, where: {employerId: {eq: $employerId}}, order: {seqId: DESC}) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        talentPoolEmployerAccessId\n        code\n        createdBy {\n          id\n          accountType\n        }\n        employerId\n        talentPool {\n          talentPoolId\n          name\n          id\n        }\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node520.hash = "e5cbd8d8c8682c3039f76f2c54cabc0d";
var EmployerVacancyTalentPoolDefaultInvitesEditorQuery_graphql_default = node520;

// src/talent-pools/talent-pool-employer-access/components/EmployerVacancyTalentPoolDefaultInvitesEditor.tsx
import { Suspense as Suspense141 } from "react";
import {
  loadQuery as loadQuery45,
  usePreloadedQuery as usePreloadedQuery48
} from "react-relay";
import { useRouteLoaderData as useRouteLoaderData18 } from "react-router-dom";
import { EdSkeleton as EdSkeleton114, ErrorContainer as ErrorContainer16 } from "shared-ui";
import { resolveEmployerId as resolveEmployerId5 } from "app-core";

// src/talent-pools/talent-pool-employer-access/components/__generated__/EmployerVacancyTalentPoolDefaultsListPaginationQuery.graphql.ts
var node521 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "employerId"
    },
    {
      "defaultValue": 15,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": {
        "seqId": "DESC"
      },
      "kind": "LocalArgument",
      "name": "sort"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v23 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v32 = [
    v1,
    v23,
    {
      "kind": "Variable",
      "name": "order",
      "variableName": "sort"
    },
    {
      "fields": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "eq",
              "variableName": "employerId"
            }
          ],
          "kind": "ObjectValue",
          "name": "employerId"
        }
      ],
      "kind": "ObjectValue",
      "name": "where"
    }
  ], v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerVacancyTalentPoolDefaultsListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            {
              "kind": "Variable",
              "name": "employerId",
              "variableName": "employerId"
            },
            v23,
            {
              "kind": "Variable",
              "name": "sort",
              "variableName": "sort"
            }
          ],
          "kind": "FragmentSpread",
          "name": "EmployerVacancyTalentPoolDefaultsList_access"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerVacancyTalentPoolDefaultsListPaginationQuery",
      "selections": [
        {
          "alias": "access",
          "args": v32,
          "concreteType": "RecruitTalentPoolEmployerAccessConnection",
          "kind": "LinkedField",
          "name": "recruitTalentPoolEmployerAccess",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitTalentPoolEmployerAccessEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitTalentPoolEmployerAccess",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v4,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "talentPoolEmployerAccessId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountId",
                      "kind": "LinkedField",
                      "name": "createdBy",
                      "plural": false,
                      "selections": [
                        v4,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "accountType",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitTalentPool",
                      "kind": "LinkedField",
                      "name": "talentPool",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "talentPoolId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        },
                        v4
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "access",
          "args": v32,
          "filters": [],
          "handle": "connection",
          "key": "EmployerVacancyTalentPoolDefaultsList_access",
          "kind": "LinkedHandle",
          "name": "recruitTalentPoolEmployerAccess"
        }
      ]
    },
    "params": {
      "cacheID": "425cb66b4deee3e67d82c81d160f167a",
      "id": null,
      "metadata": {},
      "name": "EmployerVacancyTalentPoolDefaultsListPaginationQuery",
      "operationKind": "query",
      "text": "query EmployerVacancyTalentPoolDefaultsListPaginationQuery(\n  $after: String\n  $employerId: UUID\n  $first: Int = 15\n  $sort: [RecruitTalentPoolEmployerAccessSort!] = {seqId: DESC}\n) {\n  ...EmployerVacancyTalentPoolDefaultsList_access_4la0dt\n}\n\nfragment EmployerVacancyTalentPoolDefaultsList_access_4la0dt on Query {\n  access: recruitTalentPoolEmployerAccess(first: $first, after: $after, where: {employerId: {eq: $employerId}}, order: $sort) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        talentPoolEmployerAccessId\n        code\n        createdBy {\n          id\n          accountType\n        }\n        employerId\n        talentPool {\n          talentPoolId\n          name\n          id\n        }\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node521.hash = "944bd8d1da64f7306ad7ce2f3cea9b32";
var EmployerVacancyTalentPoolDefaultsListPaginationQuery_graphql_default = node521;

// src/talent-pools/talent-pool-employer-access/components/__generated__/EmployerVacancyTalentPoolDefaultsList_access.graphql.ts
var node523 = function() {
  var v0 = [
    "access"
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "employerId"
      },
      {
        "defaultValue": 15,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "defaultValue": {
          "seqId": "DESC"
        },
        "kind": "LocalArgument",
        "name": "sort"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": EmployerVacancyTalentPoolDefaultsListPaginationQuery_graphql_default
      }
    },
    "name": "EmployerVacancyTalentPoolDefaultsList_access",
    "selections": [
      {
        "alias": "access",
        "args": null,
        "concreteType": "RecruitTalentPoolEmployerAccessConnection",
        "kind": "LinkedField",
        "name": "__EmployerVacancyTalentPoolDefaultsList_access_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitTalentPoolEmployerAccessEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitTalentPoolEmployerAccess",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  v1,
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "talentPoolEmployerAccessId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AccountId",
                    "kind": "LinkedField",
                    "name": "createdBy",
                    "plural": false,
                    "selections": [
                      v1,
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "accountType",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "employerId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RecruitTalentPool",
                    "kind": "LinkedField",
                    "name": "talentPool",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "talentPoolId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node523.hash = "944bd8d1da64f7306ad7ce2f3cea9b32";
var EmployerVacancyTalentPoolDefaultsList_access_graphql_default = node523;

// src/talent-pools/talent-pool-employer-access/components/EmployerVacancyTalentPoolDefaultsList.tsx
import { useCallback as useCallback248, useMemo as useMemo45, useState as useState130 } from "react";
import { usePaginationFragment as usePaginationFragment30 } from "react-relay";
import { Switch as Switch5 } from "@headlessui/react";
import { createClientMutationId as createClientMutationId103, isNotNull as isNotNull12 } from "shared-lib";
import { classNames as classNames48 } from "shared-ui";

// src/talent-pools/talent-pool-employer-access/mutations/__generated__/UseEmployerVacancyDefaultsUpdateMutation.graphql.ts
var node524 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "concreteType": "RecruitEmployerVacancyDefaults",
    "kind": "LinkedField",
    "name": "result",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "employerVacancyDefaultsId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "inviteToTalentPoolIds",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "privateRateMode",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v32 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseEmployerVacancyDefaultsUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitEmployerVacancyDefaultsUpdatePayload",
          "kind": "LinkedField",
          "name": "recruitEmployerVacancyDefaultsUpdate",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseEmployerVacancyDefaultsUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitEmployerVacancyDefaultsUpdatePayload",
          "kind": "LinkedField",
          "name": "recruitEmployerVacancyDefaultsUpdate",
          "plural": false,
          "selections": [
            v23,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "a7ef6c6918d13fad2681900c7e727940",
      "id": null,
      "metadata": {},
      "name": "UseEmployerVacancyDefaultsUpdateMutation",
      "operationKind": "mutation",
      "text": "mutation UseEmployerVacancyDefaultsUpdateMutation(\n  $input: RecruitEmployerVacancyDefaultsUpdateInput!\n) {\n  data: recruitEmployerVacancyDefaultsUpdate(input: $input) {\n    result {\n      id\n      employerVacancyDefaultsId\n      createdOn\n      inviteToTalentPoolIds\n      privateRateMode\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node524.hash = "28fef5e73fb78a3d2af5a4b50e53925b";
var UseEmployerVacancyDefaultsUpdateMutation_graphql_default = node524;

// src/talent-pools/talent-pool-employer-access/mutations/UseEmployerVacancyDefaultsUpdate.ts
import { useAsyncMutation as useAsyncMutation77 } from "shared-lib";
var mutationDef97 = UseEmployerVacancyDefaultsUpdateMutation_graphql_default;
function useEmployerVacancyDefaultsUpdate() {
  const [commit11, isBusy] = useAsyncMutation77(mutationDef97);
  return [commit11, isBusy];
}

// src/talent-pools/talent-pool-employer-access/components/EmployerVacancyTalentPoolDefaultsList.tsx
import { jsx as jsx451, jsxs as jsxs304 } from "react/jsx-runtime";
var fragmentDef109 = EmployerVacancyTalentPoolDefaultsList_access_graphql_default;
function mapAccess(available, selectedTalentPoolIds) {
  const ids = selectedTalentPoolIds || [];
  return available.map((access) => ({
    name: access.talentPool.name,
    id: access.talentPool.talentPoolId,
    isSelected: ids.includes(access.talentPool.talentPoolId)
  }));
}
var EmployerVacancyTalentPoolDefaultsList = ({
  employerId,
  defaultInviteTalentPools,
  fragmentRef
}) => {
  const { data, refetch } = usePaginationFragment30(fragmentDef109, fragmentRef);
  const { access } = data;
  const [update, isUpdating] = useEmployerVacancyDefaultsUpdate();
  const nodes = (access?.edges ?? []).map((edge) => edge.node).filter(isNotNull12);
  const rows = useMemo45(
    () => mapAccess(nodes, defaultInviteTalentPools),
    [nodes, defaultInviteTalentPools]
  );
  const onChanged = useCallback248(
    async (selector) => {
      let ids = [];
      if (selector.isSelected) {
        ids = [...defaultInviteTalentPools, selector.id];
      } else {
        ids = defaultInviteTalentPools.filter((id18) => id18 !== selector.id);
      }
      const input = {
        employerId,
        talentPoolIds: ids,
        clientMutationId: createClientMutationId103()
      };
      await update({ input });
    },
    [defaultInviteTalentPools]
  );
  return /* @__PURE__ */ jsxs304("fieldset", { children: [
    /* @__PURE__ */ jsx451("legend", { className: "text-base font-semibold leading-6 text-gray-900", children: "Default Candidate Talent Pool per Vacancy" }),
    /* @__PURE__ */ jsx451("div", { className: "mt-4 w-full divide-y divide-gray-200 border-t border-gray-200", children: rows.map((es) => /* @__PURE__ */ jsx451(
      TalentPoolEmployerAccessItem,
      {
        selector: es,
        onChanged
      },
      es.id
    )) })
  ] });
};
var TalentPoolEmployerAccessItem = ({
  selector,
  onChanged
}) => {
  const isBusy = false;
  const [isSelected, setIsSelected] = useState130(selector.isSelected);
  const toggleEmployerAccess = useCallback248(() => {
    setIsSelected(!isSelected);
    onChanged({
      ...selector,
      isSelected: !isSelected
    });
  }, [isSelected, selector, onChanged]);
  return /* @__PURE__ */ jsxs304(
    "div",
    {
      className: "relative flex cursor-pointer items-start py-4 hover:bg-gray-50",
      children: [
        /* @__PURE__ */ jsx451("div", { className: "min-w-0 flex-1 text-sm leading-6", children: /* @__PURE__ */ jsx451(
          "label",
          {
            htmlFor: `source-${selector.id}`,
            className: "select-none font-medium text-gray-900",
            children: selector.name
          }
        ) }),
        /* @__PURE__ */ jsx451("div", { className: "ml-3 flex h-6 items-center", children: /* @__PURE__ */ jsx451(
          Switch5,
          {
            disabled: isBusy,
            checked: isSelected,
            onChange: toggleEmployerAccess,
            className: classNames48(
              isSelected ? "bg-primary-600" : "bg-gray-200",
              "focus:ring-primary-600 relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2"
            ),
            children: /* @__PURE__ */ jsx451(
              "span",
              {
                "aria-hidden": "true",
                className: classNames48(
                  isSelected ? "translate-x-5" : "translate-x-0",
                  "pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
                )
              }
            )
          }
        ) })
      ]
    },
    selector.id
  );
};

// src/talent-pools/talent-pool-employer-access/components/EmployerVacancyTalentPoolDefaultInvitesEditor.tsx
import { jsx as jsx453 } from "react/jsx-runtime";
var queryDef75 = EmployerVacancyTalentPoolDefaultInvitesEditorQuery_graphql_default;
async function loader37(environment, params, context) {
  console.log(`EmployerProfileSources Loader`);
  const employerId = resolveEmployerId5(params, context);
  const queryRef3 = loadQuery45(
    environment,
    queryDef75,
    {
      employerId
    }
  );
  return {
    employerId,
    queryRef: queryRef3
  };
}
function useRouteData27(routeId4) {
  const { employerId, queryRef: queryRef3 } = useRouteLoaderData18(routeId4);
  const query3 = usePreloadedQuery48(
    queryDef75,
    queryRef3
  );
  return {
    employerId,
    query: query3
  };
}
var EmployerVacancyTalentPoolDefaultInvitesEditor = ({ routeId: routeId4 }) => {
  const { employerId, query: query3 } = useRouteData27(routeId4);
  const { defaults } = query3;
  return /* @__PURE__ */ jsx453(Suspense141, { fallback: /* @__PURE__ */ jsx453(EdSkeleton114, {}), children: /* @__PURE__ */ jsx453("div", { className: "flex flex-1 bg-white", children: /* @__PURE__ */ jsx453("div", { className: "flex w-full flex-col", children: /* @__PURE__ */ jsx453("div", { className: "w-full border bg-white p-8 md:m-8 md:mt-20 md:w-1/2 lg:mt-8", children: /* @__PURE__ */ jsx453(
    EmployerVacancyTalentPoolDefaultsList,
    {
      defaultInviteTalentPools: defaults?.inviteToTalentPoolIds || [],
      employerId,
      fragmentRef: query3
    }
  ) }) }) }) });
};
var createEmployerVacancyTalentPoolDefaultInvitesEditorRoute = (routePrefix, environment, context) => {
  const routeId4 = `${routePrefix}-talent-pool-employer-access`;
  return [
    {
      path: "*",
      id: routeId4,
      element: /* @__PURE__ */ jsx453(EmployerVacancyTalentPoolDefaultInvitesEditor, { routeId: routeId4 }),
      errorElement: /* @__PURE__ */ jsx453(ErrorContainer16, {}),
      handle: {
        crumb: () => /* @__PURE__ */ jsx453("div", {})
      },
      loader: ({ params }) => {
        return loader37(environment, params, context);
      }
    }
  ];
};

// src/talent-pools/talent-pool-employer-access/components/TalentPoolAddAccessContainer.tsx
import { Suspense as Suspense145, useCallback as useCallback251, useState as useState133 } from "react";
import { createClientMutationId as createClientMutationId106 } from "shared-lib";
import { BooleanIcon as BooleanIcon4, Button as Button128, EdSkeleton as EdSkeleton117, Size as Size56 } from "shared-ui";

// src/talent-pools/talent-pools/components/__generated__/TalentPoolContainer_talentPool.graphql.ts
var node525 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "TalentPoolContainer_talentPool",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "talentPoolId",
        "storageKey": null
      },
      v1,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "theme",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "enabled",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "inviteOnly",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slug",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "customInviteLink",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "joinDeclinedLink",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitTalentPoolTheme",
        "kind": "LinkedField",
        "name": "customTheme",
        "plural": false,
        "selections": [
          v0,
          v1,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "primaryColor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "logoUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "heroBgColor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "heroBorderColor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "heroTextColor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "primaryButtonTextColor",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "TalentPoolUpdateEditor_talentPool"
      },
      {
        "kind": "ClientExtension",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__id",
            "storageKey": null
          }
        ]
      }
    ],
    "type": "RecruitTalentPool",
    "abstractKey": null
  };
}();
node525.hash = "964710c41736faba744f65661b5bd635";
var TalentPoolContainer_talentPool_graphql_default = node525;

// src/talent-pools/talent-pools/components/TalentPoolContainer.tsx
import { Fragment as Fragment113 } from "react";
import { useFragment as useFragment152 } from "react-relay";
import {
  BooleanIcon as BooleanIcon3,
  Button as Button125,
  DescriptionItem as DescriptionItem8,
  DescriptionList as DescriptionList8,
  HtmlDisplay as HtmlDisplay6
} from "shared-ui";
import { useToggle as useToggle47 } from "shared-lib";

// src/talent-pools/talent-pools/components/__generated__/TalentPoolUpdateEditor_talentPool.graphql.ts
var node526 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "TalentPoolUpdateEditor_talentPool",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "talentPoolId",
        "storageKey": null
      },
      v1,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "theme",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "enabled",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "inviteOnly",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slug",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "customInviteLink",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "joinDeclinedLink",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitTalentPoolTheme",
        "kind": "LinkedField",
        "name": "customTheme",
        "plural": false,
        "selections": [
          v0,
          v1,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "primaryColor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "logoUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "heroBgColor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "heroBorderColor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "heroTextColor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "primaryButtonTextColor",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "kind": "ClientExtension",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__id",
            "storageKey": null
          }
        ]
      }
    ],
    "type": "RecruitTalentPool",
    "abstractKey": null
  };
}();
node526.hash = "80e1cd8a3b3d9c13f4e09bc89bb864aa";
var TalentPoolUpdateEditor_talentPool_graphql_default = node526;

// src/talent-pools/talent-pools/components/TalentPoolUpdateEditor.tsx
import { useCallback as useCallback249 } from "react";
import { useFragment as useFragment151 } from "react-relay";
import { createClientMutationId as createClientMutationId104, useUserErrorCodes } from "shared-lib";

// src/talent-pools/talent-pools/mutations/__generated__/UseTalentPoolCreateMutation.graphql.ts
var node527 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfTalentPool",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitTalentPool",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          v23,
          v32,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "talentPoolId",
            "storageKey": null
          },
          v4,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "theme",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "inviteOnly",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slug",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customInviteLink",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "joinDeclinedLink",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitTalentPoolTheme",
            "kind": "LinkedField",
            "name": "customTheme",
            "plural": false,
            "selections": [
              v23,
              v4,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "primaryColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "logoUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "heroBgColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "heroBorderColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "heroTextColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "primaryButtonTextColor",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v6 = {
    "kind": "InlineFragment",
    "selections": [
      v32,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseTalentPoolCreateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitTalentPoolCreatePayload",
          "kind": "LinkedField",
          "name": "recruitTalentPoolCreate",
          "plural": false,
          "selections": [
            v5,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v6
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseTalentPoolCreateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitTalentPoolCreatePayload",
          "kind": "LinkedField",
          "name": "recruitTalentPoolCreate",
          "plural": false,
          "selections": [
            v5,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v6
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "57250f6e73a77f713c4b7081b3425af9",
      "id": null,
      "metadata": {},
      "name": "UseTalentPoolCreateMutation",
      "operationKind": "mutation",
      "text": "mutation UseTalentPoolCreateMutation(\n  $input: RecruitTalentPoolCreateInput!\n) {\n  data: recruitTalentPoolCreate(input: $input) {\n    payload {\n      node {\n        id\n        code\n        talentPoolId\n        name\n        description\n        theme\n        enabled\n        inviteOnly\n        slug\n        customInviteLink\n        joinDeclinedLink\n        customTheme {\n          id\n          name\n          primaryColor\n          logoUrl\n          heroBgColor\n          heroBorderColor\n          heroTextColor\n          primaryButtonTextColor\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node527.hash = "b5739f6975e3bb62064672348109c6d8";
var UseTalentPoolCreateMutation_graphql_default = node527;

// src/talent-pools/talent-pools/mutations/UseTalentPoolCreate.ts
import { useAsyncMutation as useAsyncMutation78 } from "shared-lib";
var mutationDef98 = UseTalentPoolCreateMutation_graphql_default;
function useTalentPoolCreate() {
  const [commit11, isBusy] = useAsyncMutation78(mutationDef98);
  return [commit11, isBusy];
}

// src/talent-pools/talent-pools/mutations/__generated__/UseTalentPoolEmployerAccessRemoveMutation.graphql.ts
var node528 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseTalentPoolEmployerAccessRemoveMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitTalentPoolEmployerAccessRemovePayload",
          "kind": "LinkedField",
          "name": "recruitTalentPoolEmployerAccessRemove",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfTalentPoolEmployerAccess",
              "kind": "LinkedField",
              "name": "payload",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitTalentPoolEmployerAccess",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v23
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseTalentPoolEmployerAccessRemoveMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitTalentPoolEmployerAccessRemovePayload",
          "kind": "LinkedField",
          "name": "recruitTalentPoolEmployerAccessRemove",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfTalentPoolEmployerAccess",
              "kind": "LinkedField",
              "name": "payload",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitTalentPoolEmployerAccess",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v23,
                    {
                      "alias": null,
                      "args": null,
                      "filters": null,
                      "handle": "deleteRecord",
                      "key": "",
                      "kind": "ScalarHandle",
                      "name": "id"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "8c232addde6fcd635695487d98d39326",
      "id": null,
      "metadata": {},
      "name": "UseTalentPoolEmployerAccessRemoveMutation",
      "operationKind": "mutation",
      "text": "mutation UseTalentPoolEmployerAccessRemoveMutation(\n  $input: RecruitTalentPoolEmployerAccessRemoveInput!\n) {\n  data: recruitTalentPoolEmployerAccessRemove(input: $input) {\n    payload {\n      node {\n        id\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node528.hash = "809f3bdfafa80ac8ff19a6753c875f7d";
var UseTalentPoolEmployerAccessRemoveMutation_graphql_default = node528;

// src/talent-pools/talent-pools/mutations/UseTalentPoolEmployerAccessRemove.ts
import { useAsyncMutation as useAsyncMutation79 } from "shared-lib";
var mutationDef99 = UseTalentPoolEmployerAccessRemoveMutation_graphql_default;
function useTalentPoolEmployerAccessRemove() {
  const [commit11, isBusy] = useAsyncMutation79(mutationDef99);
  return [commit11, isBusy];
}

// src/talent-pools/talent-pools/mutations/__generated__/UseTalentPoolEmployerAccessSetMutation.graphql.ts
var node529 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfTalentPoolEmployerAccess",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitTalentPoolEmployerAccess",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          v23,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "talentPoolEmployerAccessId",
            "storageKey": null
          },
          v32,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "version",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "talentPoolId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountId",
            "kind": "LinkedField",
            "name": "createdBy",
            "plural": false,
            "selections": [
              v23,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accountType",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canUpdate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canInviteMembers",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canViewMembers",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canAddAccess",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v5 = {
    "kind": "InlineFragment",
    "selections": [
      v32,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseTalentPoolEmployerAccessSetMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitTalentPoolEmployerAccessSetPayload",
          "kind": "LinkedField",
          "name": "recruitTalentPoolEmployerAccessSet",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseTalentPoolEmployerAccessSetMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitTalentPoolEmployerAccessSetPayload",
          "kind": "LinkedField",
          "name": "recruitTalentPoolEmployerAccessSet",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "a8c1d33dc76362a65e4aa9b5034eaa81",
      "id": null,
      "metadata": {},
      "name": "UseTalentPoolEmployerAccessSetMutation",
      "operationKind": "mutation",
      "text": "mutation UseTalentPoolEmployerAccessSetMutation(\n  $input: RecruitTalentPoolEmployerAccessSetInput!\n) {\n  data: recruitTalentPoolEmployerAccessSet(input: $input) {\n    payload {\n      node {\n        id\n        talentPoolEmployerAccessId\n        code\n        version\n        talentPoolId\n        employerId\n        employerName\n        createdBy {\n          id\n          accountType\n        }\n        canUpdate\n        canInviteMembers\n        canViewMembers\n        canAddAccess\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node529.hash = "52555c3f602371871e1f4ecbda66ebe3";
var UseTalentPoolEmployerAccessSetMutation_graphql_default = node529;

// src/talent-pools/talent-pools/mutations/UseTalentPoolEmployerAccessSet.ts
import { useAsyncMutation as useAsyncMutation80 } from "shared-lib";
var mutationDef100 = UseTalentPoolEmployerAccessSetMutation_graphql_default;
function useTalentPoolEmployerAccessSet() {
  const [commit11, isBusy] = useAsyncMutation80(mutationDef100);
  return [commit11, isBusy];
}

// src/talent-pools/talent-pools/mutations/__generated__/UseTalentPoolUpdateMutation.graphql.ts
var node530 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfTalentPool",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitTalentPool",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          v23,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "talentPoolId",
            "storageKey": null
          },
          v32,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "theme",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "inviteOnly",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slug",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customInviteLink",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "joinDeclinedLink",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitTalentPoolTheme",
            "kind": "LinkedField",
            "name": "customTheme",
            "plural": false,
            "selections": [
              v23,
              v32,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "primaryColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "logoUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "heroBgColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "heroBorderColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "heroTextColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "primaryButtonTextColor",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v5 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseTalentPoolUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitTalentPoolUpdatePayload",
          "kind": "LinkedField",
          "name": "recruitTalentPoolUpdate",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseTalentPoolUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitTalentPoolUpdatePayload",
          "kind": "LinkedField",
          "name": "recruitTalentPoolUpdate",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "808c511557c665bd1a89b291ed1c2c76",
      "id": null,
      "metadata": {},
      "name": "UseTalentPoolUpdateMutation",
      "operationKind": "mutation",
      "text": "mutation UseTalentPoolUpdateMutation(\n  $input: RecruitTalentPoolUpdateInput!\n) {\n  data: recruitTalentPoolUpdate(input: $input) {\n    payload {\n      node {\n        id\n        talentPoolId\n        name\n        description\n        theme\n        enabled\n        inviteOnly\n        slug\n        customInviteLink\n        joinDeclinedLink\n        customTheme {\n          id\n          name\n          primaryColor\n          logoUrl\n          heroBgColor\n          heroBorderColor\n          heroTextColor\n          primaryButtonTextColor\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node530.hash = "bc47d0657d3a19519d7c1093f624a193";
var UseTalentPoolUpdateMutation_graphql_default = node530;

// src/talent-pools/talent-pools/mutations/UseTalentPoolUpdate.ts
import { useAsyncMutation as useAsyncMutation81 } from "shared-lib";
var mutationDef101 = UseTalentPoolUpdateMutation_graphql_default;
function useTalentPoolUpdate() {
  const [commit11, isBusy] = useAsyncMutation81(mutationDef101);
  return [commit11, isBusy];
}

// src/talent-pools/talent-pools/components/TalentPoolForm.tsx
import * as zod15 from "zod";
import { useForm as useForm25 } from "react-hook-form";
import { zodResolver as zodResolver20 } from "@hookform/resolvers/zod";
import {
  ActionContainer as ActionContainer10,
  ErrorField as ErrorField8,
  FormInputRow as FormInputRow8,
  FormTextAreaInput as FormTextAreaInput6,
  InputField as InputField6,
  SwitchInput as SwitchInput3
} from "shared-ui";
import { jsx as jsx454, jsxs as jsxs305 } from "react/jsx-runtime";
var formSchema12 = zod15.object({
  name: zod15.string().min(1, { message: "name is required" }),
  slug: zod15.string().min(1, { message: "slug is required" }),
  description: zod15.string().min(1, { message: "description is required" }),
  joinDeclinedLink: zod15.string().nullable(),
  customInviteLink: zod15.string().nullable(),
  enabled: zod15.boolean(),
  inviteOnly: zod15.boolean()
});
var TalentPoolForm = ({
  talentPool,
  isDisabled,
  onDone,
  onCancel
}) => {
  const defaultValues2 = {
    name: talentPool?.name || "",
    slug: talentPool?.slug || "",
    description: talentPool?.description || "",
    joinDeclinedLink: talentPool?.joinDeclinedLink || null,
    customInviteLink: talentPool?.customInviteLink || null,
    enabled: talentPool?.enabled || false,
    inviteOnly: talentPool?.inviteOnly || false
  };
  const { register, handleSubmit, watch, formState, control } = useForm25({
    resolver: zodResolver20(formSchema12),
    defaultValues: defaultValues2,
    mode: "onChange"
  });
  const onSubmit = handleSubmit(
    (form) => {
      onDone({
        ...form
      });
    },
    (invalid) => {
      console.error(invalid);
    }
  );
  const { errors, isValid, isDirty } = formState;
  return /* @__PURE__ */ jsx454("form", { onSubmit, children: /* @__PURE__ */ jsxs305(
    ActionContainer10,
    {
      isDirty,
      showSubmit: true,
      showCancel: true,
      onCancel,
      isDisabled,
      titleTop: `Talent Pool`,
      children: [
        /* @__PURE__ */ jsxs305(FormInputRow8, { name: "name", title: "Name *", children: [
          /* @__PURE__ */ jsx454(
            InputField6,
            {
              register,
              name: "name",
              required: true,
              placeholder: "Name"
            }
          ),
          /* @__PURE__ */ jsx454(ErrorField8, { field: errors.name })
        ] }),
        /* @__PURE__ */ jsxs305(FormInputRow8, { name: "slug", title: "Slug *", children: [
          /* @__PURE__ */ jsx454(
            InputField6,
            {
              register,
              name: "slug",
              required: true,
              placeholder: "Slug"
            }
          ),
          /* @__PURE__ */ jsx454(ErrorField8, { field: errors.slug })
        ] }),
        /* @__PURE__ */ jsxs305(FormInputRow8, { name: "description", title: "Description *", children: [
          /* @__PURE__ */ jsx454(
            FormTextAreaInput6,
            {
              rows: 10,
              className: "mt-1",
              placeholder: " What i did ",
              name: "description",
              required: true,
              register
            }
          ),
          /* @__PURE__ */ jsx454(ErrorField8, { field: errors.description })
        ] }),
        /* @__PURE__ */ jsxs305(FormInputRow8, { name: "enabled", title: "Enabled *", children: [
          /* @__PURE__ */ jsx454(
            SwitchInput3,
            {
              control,
              name: "enabled",
              defaultChecked: false
            }
          ),
          /* @__PURE__ */ jsx454(ErrorField8, { field: errors.enabled })
        ] }),
        /* @__PURE__ */ jsxs305(FormInputRow8, { name: "inviteOnly", title: "Invite Only *", children: [
          /* @__PURE__ */ jsx454(
            SwitchInput3,
            {
              control,
              name: "inviteOnly",
              defaultChecked: false
            }
          ),
          /* @__PURE__ */ jsx454(ErrorField8, { field: errors.inviteOnly })
        ] }),
        /* @__PURE__ */ jsxs305(FormInputRow8, { name: "joinDeclinedLink", title: "Join Declined Link", children: [
          /* @__PURE__ */ jsx454(
            InputField6,
            {
              register,
              name: "joinDeclinedLink",
              required: false
            }
          ),
          /* @__PURE__ */ jsx454(ErrorField8, { field: errors.joinDeclinedLink })
        ] }),
        /* @__PURE__ */ jsxs305(FormInputRow8, { name: "customInviteLink", title: "Custom Invite Link", children: [
          /* @__PURE__ */ jsx454(
            InputField6,
            {
              register,
              name: "customInviteLink",
              required: false
            }
          ),
          /* @__PURE__ */ jsx454(ErrorField8, { field: errors.customInviteLink })
        ] })
      ]
    }
  ) });
};

// src/talent-pools/talent-pools/components/TalentPoolUpdateEditor.tsx
import { jsx as jsx455 } from "react/jsx-runtime";
var fragmentDef110 = TalentPoolUpdateEditor_talentPool_graphql_default;
var TalentPoolUpdateEditor = ({
  fragmentRef,
  onDone,
  onCancel
}) => {
  const talentPool = useFragment151(fragmentDef110, fragmentRef);
  const [userErrorCode, setErrorCode] = useUserErrorCodes();
  const [updateTalentPool, isUpdatingTalentPool] = useTalentPoolUpdate();
  const onUpdate = useCallback249(
    async (form) => {
      setErrorCode(null);
      if (!form.name) {
        return;
      }
      const input = {
        clientMutationId: createClientMutationId104(),
        talentPoolId: talentPool.talentPoolId,
        name: form.name,
        slug: form.slug || form.name.toLowerCase(),
        description: form.description,
        joinDeclinedLink: form.joinDeclinedLink,
        customInviteLink: form.customInviteLink,
        enabled: form.enabled,
        inviteOnly: form.inviteOnly
      };
      const response = await updateTalentPool({ input });
      if (response.data.userErrors && response.data.userErrors.length > 0) {
        setErrorCode(response.data.userErrors);
      }
      if (response.data.payload?.node) {
        onDone(response.data.payload);
      }
    },
    [updateTalentPool]
  );
  return /* @__PURE__ */ jsx455(
    TalentPoolForm,
    {
      onDone: onUpdate,
      onCancel,
      talentPool,
      isDisabled: isUpdatingTalentPool
    }
  );
};

// src/talent-pools/talent-pools/components/TalentPoolContainer.tsx
import { jsx as jsx456, jsxs as jsxs306 } from "react/jsx-runtime";
var fragmentDef111 = TalentPoolContainer_talentPool_graphql_default;
var TalentPoolContainer = ({ fragmentRef }) => {
  const [isEditing, toggleIsEditing] = useToggle47();
  const talentPool = useFragment152(fragmentDef111, fragmentRef);
  return /* @__PURE__ */ jsxs306("div", { className: "m-auto mt-2 flex flex-1 flex-col gap-2 border bg-white p-4 ", children: [
    /* @__PURE__ */ jsxs306("div", { className: "flex items-center justify-between gap-2 border-b p-4", children: [
      /* @__PURE__ */ jsx456("div", { className: "text-primary-500 px-1 text-xl font-bold", children: talentPool.name }),
      /* @__PURE__ */ jsxs306("div", { className: "flex items-center gap-4 pt-2 text-sm", children: [
        /* @__PURE__ */ jsxs306("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ jsx456("div", { children: "Enabled" }),
          /* @__PURE__ */ jsx456(BooleanIcon3, { value: talentPool.enabled })
        ] }),
        /* @__PURE__ */ jsx456("div", { children: isEditing ? /* @__PURE__ */ jsx456(Button125, { color: "gray", clicked: toggleIsEditing, children: "Cancel" }) : /* @__PURE__ */ jsx456(Button125, { color: "primary", clicked: toggleIsEditing, children: "Edit" }) })
      ] })
    ] }),
    isEditing ? /* @__PURE__ */ jsx456("div", { className: "m-4 border border-gray-100", children: /* @__PURE__ */ jsx456(
      TalentPoolUpdateEditor,
      {
        fragmentRef: talentPool,
        onDone: toggleIsEditing,
        onCancel: toggleIsEditing
      }
    ) }) : /* @__PURE__ */ jsx456("div", { className: "m-4 border border-gray-100", children: /* @__PURE__ */ jsx456(
      DescriptionList8,
      {
        classes: "w-full",
        heading: /* @__PURE__ */ jsx456("div", { className: "flex items-center justify-between", children: /* @__PURE__ */ jsx456("div", { className: "text-info-600", children: /* @__PURE__ */ jsx456(HtmlDisplay6, { html: talentPool.description }) }) }),
        items: /* @__PURE__ */ jsxs306(Fragment113, { children: [
          /* @__PURE__ */ jsx456(DescriptionItem8, { label: "Invite Only", children: /* @__PURE__ */ jsx456(BooleanIcon3, { value: talentPool.inviteOnly }) }),
          /* @__PURE__ */ jsx456(DescriptionItem8, { label: "Custom Invite Link", children: talentPool.customInviteLink }),
          /* @__PURE__ */ jsx456(DescriptionItem8, { label: "Custom Join Declined Link", children: talentPool.joinDeclinedLink }),
          /* @__PURE__ */ jsx456(DescriptionItem8, { label: "Theme", children: talentPool.theme }),
          talentPool.customTheme && /* @__PURE__ */ jsx456(DescriptionItem8, { label: "Custom Theme", children: /* @__PURE__ */ jsxs306("ul", { children: [
            /* @__PURE__ */ jsxs306("li", { className: "flex flex-row items-center gap-2", children: [
              /* @__PURE__ */ jsx456("div", { children: "Name" }),
              /* @__PURE__ */ jsx456("div", { children: talentPool.customTheme.name })
            ] }),
            /* @__PURE__ */ jsxs306("li", { className: "flex flex-row items-center gap-2", children: [
              /* @__PURE__ */ jsx456("div", { children: "heroBgColor" }),
              /* @__PURE__ */ jsx456("div", { children: talentPool.customTheme.heroBgColor })
            ] }),
            /* @__PURE__ */ jsxs306("li", { className: "flex flex-row items-center gap-2", children: [
              /* @__PURE__ */ jsx456("div", { children: "heroBorderColor" }),
              /* @__PURE__ */ jsx456("div", { children: talentPool.customTheme.heroBorderColor })
            ] }),
            /* @__PURE__ */ jsxs306("li", { className: "flex flex-row items-center gap-2", children: [
              /* @__PURE__ */ jsx456("div", { children: "heroTextColor" }),
              /* @__PURE__ */ jsx456("div", { children: talentPool.customTheme.heroTextColor })
            ] }),
            /* @__PURE__ */ jsxs306("li", { className: "flex flex-row items-center gap-2", children: [
              /* @__PURE__ */ jsx456("div", { children: "logoUrl" }),
              /* @__PURE__ */ jsx456("div", { children: talentPool.customTheme.logoUrl })
            ] }),
            /* @__PURE__ */ jsxs306("li", { className: "flex flex-row items-center gap-2", children: [
              /* @__PURE__ */ jsx456("div", { children: "primaryButtonTextColor" }),
              /* @__PURE__ */ jsx456("div", { children: talentPool.customTheme.primaryButtonTextColor })
            ] }),
            /* @__PURE__ */ jsxs306("li", { className: "flex flex-row items-center gap-2", children: [
              /* @__PURE__ */ jsx456("div", { children: "primaryColor" }),
              /* @__PURE__ */ jsx456("div", { children: talentPool.customTheme.primaryColor })
            ] })
          ] }) })
        ] })
      }
    ) })
  ] });
};

// src/talent-pools/talent-pools/components/TalentPoolCreateEditor.tsx
import { useCallback as useCallback250 } from "react";
import { createClientMutationId as createClientMutationId105, useUserErrorCodes as useUserErrorCodes2 } from "shared-lib";
import { jsx as jsx457 } from "react/jsx-runtime";
var TalentPoolCreateEditor = ({ onDone, onCancel }) => {
  const [userErrorCode, setErrorCode] = useUserErrorCodes2();
  const [createTalentPool, isCreatingTalentPool] = useTalentPoolCreate();
  const onCreate = useCallback250(
    async (form) => {
      setErrorCode(null);
      if (!form.name || !form.description) {
        return;
      }
      const input = {
        clientMutationId: createClientMutationId105(),
        name: form.name,
        slug: form.slug,
        description: form.description,
        joinDeclinedLink: form.joinDeclinedLink,
        customInviteLink: form.customInviteLink,
        enabled: form.enabled,
        inviteOnly: form.inviteOnly
      };
      const response = await createTalentPool({ input });
      if (response.data.userErrors && response.data.userErrors.length > 0) {
        setErrorCode(response.data.userErrors);
      }
      if (response.data.payload?.node) {
        onDone(response.data.payload.node);
      }
    },
    [createTalentPool]
  );
  return /* @__PURE__ */ jsx457(
    TalentPoolForm,
    {
      onDone: onCreate,
      onCancel,
      isDisabled: isCreatingTalentPool
    }
  );
};

// src/talent-pools/talent-pools/components/__generated__/TalentPoolListContainerQuery.graphql.ts
var node531 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "name": "ASC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "TalentPoolListContainerQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TalentPoolListContainer_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "TalentPoolListContainerQuery",
      "selections": [
        {
          "alias": "list",
          "args": v1,
          "concreteType": "RecruitTalentPoolsConnection",
          "kind": "LinkedField",
          "name": "recruitTalentPools",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitTalentPoolsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitTalentPool",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "talentPoolId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "theme",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "enabled",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v1,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "TalentPoolListContainer_list",
          "kind": "LinkedHandle",
          "name": "recruitTalentPools"
        }
      ]
    },
    "params": {
      "cacheID": "d56f7ab542e7a697277be90dcfc3c8de",
      "id": null,
      "metadata": {},
      "name": "TalentPoolListContainerQuery",
      "operationKind": "query",
      "text": "query TalentPoolListContainerQuery(\n  $where: RecruitTalentPoolFilter!\n) {\n  ...TalentPoolListContainer_list\n}\n\nfragment TalentPoolListContainer_list on Query {\n  list: recruitTalentPools(first: 10, order: [{name: ASC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        talentPoolId\n        code\n        name\n        theme\n        enabled\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node531.hash = "3e33d59506098f80b161d71e184b9c31";
var TalentPoolListContainerQuery_graphql_default = node531;

// src/talent-pools/talent-pools/components/__generated__/TalentPoolsListContainerPaginationQuery.graphql.ts
var node533 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v23 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v32 = [
    v1,
    v23,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "name": "ASC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "TalentPoolsListContainerPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v23
          ],
          "kind": "FragmentSpread",
          "name": "TalentPoolListContainer_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "TalentPoolsListContainerPaginationQuery",
      "selections": [
        {
          "alias": "list",
          "args": v32,
          "concreteType": "RecruitTalentPoolsConnection",
          "kind": "LinkedField",
          "name": "recruitTalentPools",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitTalentPoolsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitTalentPool",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "talentPoolId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "theme",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "enabled",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v32,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "TalentPoolListContainer_list",
          "kind": "LinkedHandle",
          "name": "recruitTalentPools"
        }
      ]
    },
    "params": {
      "cacheID": "d71272f85a1d59ea7b47335b2fe9db84",
      "id": null,
      "metadata": {},
      "name": "TalentPoolsListContainerPaginationQuery",
      "operationKind": "query",
      "text": "query TalentPoolsListContainerPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $where: RecruitTalentPoolFilter\n) {\n  ...TalentPoolListContainer_list_2HEEH6\n}\n\nfragment TalentPoolListContainer_list_2HEEH6 on Query {\n  list: recruitTalentPools(first: $first, after: $after, order: [{name: ASC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        talentPoolId\n        code\n        name\n        theme\n        enabled\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node533.hash = "e75d6f697b50d066778327ddbdca1afe";
var TalentPoolsListContainerPaginationQuery_graphql_default = node533;

// src/talent-pools/talent-pools/components/__generated__/TalentPoolListContainer_list.graphql.ts
var node534 = function() {
  var v0 = [
    "list"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": TalentPoolsListContainerPaginationQuery_graphql_default
      }
    },
    "name": "TalentPoolListContainer_list",
    "selections": [
      {
        "alias": "list",
        "args": [
          {
            "kind": "Literal",
            "name": "order",
            "value": [
              {
                "name": "ASC"
              }
            ]
          },
          {
            "kind": "Variable",
            "name": "where",
            "variableName": "where"
          }
        ],
        "concreteType": "RecruitTalentPoolsConnection",
        "kind": "LinkedField",
        "name": "__TalentPoolListContainer_list_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitTalentPoolsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitTalentPool",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "talentPoolId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "theme",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enabled",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node534.hash = "e75d6f697b50d066778327ddbdca1afe";
var TalentPoolListContainer_list_graphql_default = node534;

// src/talent-pools/talent-pools/components/TalentPoolListContainer.tsx
import { Suspense as Suspense143, useState as useState131 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery75, usePaginationFragment as usePaginationFragment31 } from "react-relay";
import { useNavigate as useNavigate30, useLocation as useLocation8 } from "react-router-dom";
import { Button as Button126, EdSkeleton as EdSkeleton115, HeaderBar as HeaderBar2 } from "shared-ui";
import { useDebounce as useDebounce3 } from "shared-lib";
import { jsx as jsx458, jsxs as jsxs307 } from "react/jsx-runtime";
var queryDef76 = TalentPoolListContainerQuery_graphql_default;
var fragmentDef112 = TalentPoolListContainer_list_graphql_default;
var List4 = ({
  filter: filter2,
  fragmentRef,
  setTalentPoolListCount
}) => {
  const { data } = usePaginationFragment31(fragmentDef112, fragmentRef);
  const { list: list2 } = data;
  const navigate = useNavigate30();
  if (list2?.totalCount && list2?.totalCount > 0 && (!filter2 || filter2?.length > 0)) {
    setTalentPoolListCount(
      (prev) => list2.totalCount > prev ? list2.totalCount : prev
    );
  }
  return /* @__PURE__ */ jsx458(Suspense143, { fallback: /* @__PURE__ */ jsx458(EdSkeleton115, {}), children: /* @__PURE__ */ jsx458("div", { className: "flex flex-col divide-y", children: list2?.edges?.map((x4) => /* @__PURE__ */ jsx458("div", { className: "flex flex-col gap-2 px-5 py-4", children: /* @__PURE__ */ jsxs307("div", { className: "flex items-center justify-between gap-2", children: [
    /* @__PURE__ */ jsx458("div", { className: "text-md uppercase", children: x4.node.name }),
    /* @__PURE__ */ jsx458(
      Button126,
      {
        color: "primary",
        onClick: () => navigate(`../${x4.node.code}/details`),
        children: "View"
      }
    )
  ] }) }, x4.node.code)) }) });
};
var TalentPoolListContainer = ({ onCreate }) => {
  const location2 = useLocation8();
  const [filter2, setFilter] = useState131(null);
  const [talentPoolListCount, setTalentPoolListCount] = useState131(0);
  const searchTerm = useDebounce3(filter2, 500);
  const where = location2.pathname.includes("admin") ? {} : { enabled: { eq: true } };
  if (searchTerm) {
    where.or = [{ name: { startsWith: filter2 } }];
  }
  const query3 = useLazyLoadQuery75(
    queryDef76,
    { where },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsxs307("div", { className: "flex w-full flex-col", children: [
    /* @__PURE__ */ jsx458(HeaderBar2, { title: "Talent Pools", children: (talentPoolListCount >= 15 || location2.pathname.includes("admin")) && /* @__PURE__ */ jsx458("div", { className: "flex w-full items-center space-x-4 md:min-w-[600px] lg:p-2", children: /* @__PURE__ */ jsx458(
      TextQueryFilter,
      {
        placeholder: `Search`,
        onChanged: (filter3) => setFilter(filter3)
      }
    ) }) }),
    /* @__PURE__ */ jsx458("div", { className: "container mx-auto max-w-4xl flex-1 bg-white md:mt-10 md:rounded-2xl", children: /* @__PURE__ */ jsx458(Suspense143, { fallback: /* @__PURE__ */ jsx458(EdSkeleton115, {}), children: /* @__PURE__ */ jsx458(
      List4,
      {
        filter: filter2,
        fragmentRef: query3,
        setTalentPoolListCount
      }
    ) }) })
  ] });
};

// src/talent-pools/talent-pools/components/__generated__/TalentPoolVacanciesCodeQuery.graphql.ts
var node535 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "talentPoolCode"
    }
  ], v1 = [
    {
      "alias": "data",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "talentPoolCode"
        }
      ],
      "concreteType": "RecruitTalentPool",
      "kind": "LinkedField",
      "name": "recruitTalentPoolByCode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "talentPoolId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "TalentPoolVacanciesCodeQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "TalentPoolVacanciesCodeQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "27989458a8ac77ebae6caab409115d9a",
      "id": null,
      "metadata": {},
      "name": "TalentPoolVacanciesCodeQuery",
      "operationKind": "query",
      "text": "query TalentPoolVacanciesCodeQuery(\n  $talentPoolCode: Int!\n) {\n  data: recruitTalentPoolByCode(code: $talentPoolCode) {\n    id\n    talentPoolId\n  }\n}\n"
    }
  };
}();
node535.hash = "acd733347b2492e4e02fe90c7de53778";
var TalentPoolVacanciesCodeQuery_graphql_default = node535;

// src/talent-pools/talent-pools/components/__generated__/TalentPoolVacanciesQuery.graphql.ts
var node536 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectIds"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "talentPoolIds"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "talentPoolIds",
    "variableName": "talentPoolIds"
  }, v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  }, v32 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "count",
      "storageKey": null
    },
    v23
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "TalentPoolVacanciesQuery",
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "projectIds",
              "variableName": "projectIds"
            },
            v1
          ],
          "kind": "FragmentSpread",
          "name": "ProjectVacanciesList_vacancies"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "TalentPoolVacanciesQuery",
      "selections": [
        {
          "alias": "vacancies",
          "args": [
            {
              "fields": [
                {
                  "kind": "Literal",
                  "name": "pageNumber",
                  "value": 1
                },
                {
                  "kind": "Literal",
                  "name": "pageSize",
                  "value": 15
                },
                {
                  "kind": "Variable",
                  "name": "projectId",
                  "variableName": "projectIds"
                },
                {
                  "kind": "Literal",
                  "name": "sortField",
                  "value": "DATE_OPENED"
                },
                {
                  "kind": "Literal",
                  "name": "sortOrder",
                  "value": "DESC"
                },
                v1
              ],
              "kind": "ObjectValue",
              "name": "input"
            }
          ],
          "concreteType": "VacancySearchResult",
          "kind": "LinkedField",
          "name": "recruitVacanciesSearch",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CollectionMetaData",
              "kind": "LinkedField",
              "name": "paging",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "pages",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "pageNumber",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "itemsPerPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "totalResults",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "VacancySearchModel",
              "kind": "LinkedField",
              "name": "items",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "code",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "projectName",
                  "storageKey": null
                },
                v23,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "employerName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "employerReference",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "dateCreated",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "dateOpened",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "dateToBeFilled",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "expiresAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "matches",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "recommendations",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "createdByName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "VacancyCandidateCount",
                  "kind": "LinkedField",
                  "name": "candidateCounts",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CandidateCount",
                      "kind": "LinkedField",
                      "name": "active",
                      "plural": false,
                      "selections": v32,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CandidateCount",
                      "kind": "LinkedField",
                      "name": "created",
                      "plural": false,
                      "selections": v32,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CandidateCount",
                      "kind": "LinkedField",
                      "name": "hired",
                      "plural": false,
                      "selections": v32,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CandidateCount",
                      "kind": "LinkedField",
                      "name": "submitted",
                      "plural": false,
                      "selections": v32,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CandidateCount",
                      "kind": "LinkedField",
                      "name": "unsuccessful",
                      "plural": false,
                      "selections": v32,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CandidateCount",
                      "kind": "LinkedField",
                      "name": "withdrawn",
                      "plural": false,
                      "selections": v32,
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "dea30716184f64aa074743bb93b5e0e6",
      "id": null,
      "metadata": {},
      "name": "TalentPoolVacanciesQuery",
      "operationKind": "query",
      "text": "query TalentPoolVacanciesQuery(\n  $projectIds: [UUID!]\n  $talentPoolIds: [UUID!]\n) {\n  ...ProjectVacanciesList_vacancies_48whSk\n}\n\nfragment ProjectVacanciesList_vacancies_48whSk on Query {\n  vacancies: recruitVacanciesSearch(input: {pageNumber: 1, projectId: $projectIds, talentPoolIds: $talentPoolIds, pageSize: 15, sortField: DATE_OPENED, sortOrder: DESC}) {\n    paging {\n      pages\n      pageNumber\n      itemsPerPage\n      totalResults\n    }\n    items {\n      name\n      code\n      projectName\n      status\n      employerName\n      employerReference\n      dateCreated\n      dateOpened\n      dateToBeFilled\n      expiresAt\n      matches\n      recommendations\n      createdByName\n      candidateCounts {\n        active {\n          count\n          status\n        }\n        created {\n          count\n          status\n        }\n        hired {\n          count\n          status\n        }\n        submitted {\n          count\n          status\n        }\n        unsuccessful {\n          count\n          status\n        }\n        withdrawn {\n          count\n          status\n        }\n      }\n      id\n    }\n  }\n}\n"
    }
  };
}();
node536.hash = "dc212b212cc7a1de0495d1847ddf4920";
var TalentPoolVacanciesQuery_graphql_default = node536;

// src/talent-pools/talent-pools/components/TalentPoolVacancies.tsx
import { Suspense as Suspense144 } from "react";
import { loadQuery as loadQuery46, useLazyLoadQuery as useLazyLoadQuery76 } from "react-relay";
import { Button as Button127, EdLink as EdLink22, EdSkeleton as EdSkeleton116 } from "shared-ui";
import { useRouteData as useRouteData28 } from "shared-lib";
import { jsx as jsx459, jsxs as jsxs308 } from "react/jsx-runtime";
function TalentPoolVacancies({ routeId: routeId4 }) {
  const code = useRouteData28(
    TalentPoolVacancies.query,
    routeId4
  );
  if (!code.data?.talentPoolId) {
    return /* @__PURE__ */ jsx459(EdSkeleton116, {});
  }
  return /* @__PURE__ */ jsx459(TalentPoolVacanciesComponent, { talentPoolId: code.data?.talentPoolId });
}
TalentPoolVacancies.loader = async (environment, params) => {
  return loadQuery46(
    environment,
    TalentPoolVacancies.query,
    {
      talentPoolCode: Number(params.talentPoolCode)
    }
  );
};
TalentPoolVacancies.query = TalentPoolVacanciesCodeQuery_graphql_default;
function TalentPoolVacanciesComponent({
  talentPoolId
}) {
  const data = useLazyLoadQuery76(
    TalentPoolVacanciesComponent.query,
    {
      talentPoolIds: [talentPoolId]
    },
    {
      fetchPolicy: "store-and-network"
    }
  );
  if (!data) {
    return /* @__PURE__ */ jsx459(EdSkeleton116, {});
  }
  return /* @__PURE__ */ jsx459(Suspense144, { fallback: /* @__PURE__ */ jsx459(EdSkeleton116, {}), children: /* @__PURE__ */ jsxs308("div", { className: "flex flex-col gap-3 p-3 px-2 md:px-5", children: [
    /* @__PURE__ */ jsx459(
      EdLink22,
      {
        name: "add-vacancy",
        className: "self-end",
        href: `/employers/app/vacancies/create?projectId=`,
        children: /* @__PURE__ */ jsx459(Button127, { color: "primary", children: "Add Vacancy" })
      }
    ),
    /* @__PURE__ */ jsx459(Suspense144, { fallback: /* @__PURE__ */ jsx459(EdSkeleton116, {}), children: /* @__PURE__ */ jsx459("div", { className: "", children: /* @__PURE__ */ jsx459(ProjectVacanciesList, { fragmentRef: data }) }) })
  ] }) });
}
TalentPoolVacanciesComponent.query = TalentPoolVacanciesQuery_graphql_default;

// src/talent-pools/talent-pool-employer-access/components/TalentPoolAddAccessContainer.tsx
import { jsx as jsx460, jsxs as jsxs309 } from "react/jsx-runtime";
var TalentPoolAddAccessContainer = ({
  talentPool,
  onDone,
  onCancel
}) => {
  const [accessSet, isSettingAccess] = useTalentPoolEmployerAccessSet();
  const [employer, setEmployer] = useState133(null);
  const onAdd = useCallback251(async () => {
    if (!employer || !talentPool) {
      return;
    }
    const input = {
      employerId: employer.employerId,
      talentPoolId: talentPool.talentPoolId,
      canAddAccess: false,
      canInviteMembers: false,
      canUpdate: false,
      canViewMembers: false,
      clientMutationId: createClientMutationId106()
    };
    const response = await accessSet({ input });
    if (response.data.payload) {
      onDone(response.data.payload.node.code);
    }
  }, [employer]);
  return /* @__PURE__ */ jsx460(Suspense145, { fallback: /* @__PURE__ */ jsx460(EdSkeleton117, {}), children: /* @__PURE__ */ jsxs309("div", { className: "flex flex-1 flex-col gap-2 border bg-white p-4", children: [
    /* @__PURE__ */ jsxs309("div", { className: "flex items-center justify-between gap-2 border-b p-4", children: [
      /* @__PURE__ */ jsx460("div", { className: "text-primary-500 px-1 text-xl font-bold", children: talentPool.name }),
      /* @__PURE__ */ jsx460("div", { className: "flex items-center gap-4 pt-2 text-sm", children: /* @__PURE__ */ jsxs309("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ jsx460("div", { children: "Enabled" }),
        /* @__PURE__ */ jsx460(BooleanIcon4, { value: talentPool.enabled })
      ] }) })
    ] }),
    /* @__PURE__ */ jsxs309("div", { className: "m-4 w-1/2 border bg-white p-4", children: [
      /* @__PURE__ */ jsx460("div", { className: "text-primary-500 border-b p-2 text-lg", children: "Search for Employer" }),
      /* @__PURE__ */ jsx460("div", { className: "px-2 py-8", children: /* @__PURE__ */ jsx460(EmployerSearchContainer, { onSearchCompleted: setEmployer }) }),
      employer && /* @__PURE__ */ jsxs309("div", { className: "m-4 flex w-1/2 items-center gap-2", children: [
        /* @__PURE__ */ jsx460(Button128, { clicked: onAdd, color: "primary", size: Size56.lg, children: "Grant Access" }),
        /* @__PURE__ */ jsx460(Button128, { clicked: onCancel, color: "gray", size: Size56.lg, children: "Cancel" })
      ] })
    ] })
  ] }) });
};

// src/talent-pools/talent-pool-employer-access/components/__generated__/TalentPoolEmployerAccessForm_talentPoolAccess.graphql.ts
var node537 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TalentPoolEmployerAccessForm_talentPoolAccess",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "talentPoolEmployerAccessId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "talentPoolId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "employerId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "employerName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canUpdate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canInviteMembers",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canViewMembers",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canAddAccess",
      "storageKey": null
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__id",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "RecruitTalentPoolEmployerAccess",
  "abstractKey": null
};
node537.hash = "8ff5ef2624047ea090db168de5871544";
var TalentPoolEmployerAccessForm_talentPoolAccess_graphql_default = node537;

// src/talent-pools/talent-pool-employer-access/components/TalentPoolEmployerAccessForm.tsx
import { useCallback as useCallback253 } from "react";
import { useFragment as useFragment153 } from "react-relay";
import * as zod16 from "zod";
import { useForm as useForm26 } from "react-hook-form";
import { zodResolver as zodResolver21 } from "@hookform/resolvers/zod";
import { createClientMutationId as createClientMutationId107 } from "shared-lib";
import {
  ActionContainer as ActionContainer11,
  ErrorField as ErrorField9,
  FormInputRow as FormInputRow9,
  SwitchInput as SwitchInput4
} from "shared-ui";
import { jsx as jsx461, jsxs as jsxs311 } from "react/jsx-runtime";
var fragmentDef113 = TalentPoolEmployerAccessForm_talentPoolAccess_graphql_default;
var formSchema13 = zod16.object({
  canUpdate: zod16.boolean(),
  canAddAccess: zod16.boolean(),
  canInviteMembers: zod16.boolean(),
  canViewMembers: zod16.boolean()
});
var TalentPoolEmployerAccessForm = ({
  fragmentRef,
  onDone,
  onCancel
}) => {
  const access = useFragment153(fragmentDef113, fragmentRef);
  const defaultValues2 = {
    canUpdate: access?.canUpdate || false,
    canAddAccess: access?.canAddAccess || false,
    canInviteMembers: access?.canInviteMembers || false,
    canViewMembers: access?.canViewMembers || false
  };
  const { handleSubmit, watch, formState, control } = useForm26({
    resolver: zodResolver21(formSchema13),
    defaultValues: defaultValues2,
    mode: "onChange"
  });
  const [accessSet, isSettingAccess] = useTalentPoolEmployerAccessSet();
  const onAccessSet = useCallback253(
    async (form) => {
      if (!access) {
        return;
      }
      const input = {
        employerId: access?.employerId,
        talentPoolId: access?.talentPoolId,
        canAddAccess: form.canAddAccess,
        canInviteMembers: form.canInviteMembers,
        canUpdate: form.canUpdate,
        canViewMembers: form.canViewMembers,
        clientMutationId: createClientMutationId107()
      };
      const response = await accessSet({ input });
      if (response.data.payload) {
        onDone();
      }
    },
    [accessSet]
  );
  const onSubmit = handleSubmit(
    async (form) => {
      await onAccessSet(form);
    },
    (invalid) => {
      console.error(invalid);
    }
  );
  const { errors, isValid, isDirty } = formState;
  return /* @__PURE__ */ jsx461("form", { onSubmit, children: /* @__PURE__ */ jsxs311(
    ActionContainer11,
    {
      isDirty,
      showSubmit: true,
      showCancel: true,
      onCancel,
      isDisabled: isSettingAccess,
      titleTop: `Talent Pool`,
      children: [
        /* @__PURE__ */ jsxs311(FormInputRow9, { name: "canUpdate", title: "Can Update *", children: [
          /* @__PURE__ */ jsx461(SwitchInput4, { control, name: "canUpdate" }),
          /* @__PURE__ */ jsx461(ErrorField9, { field: errors.canUpdate })
        ] }),
        /* @__PURE__ */ jsxs311(FormInputRow9, { name: "canAddAccess", title: "Can Add Access *", children: [
          /* @__PURE__ */ jsx461(SwitchInput4, { control, name: "canAddAccess" }),
          /* @__PURE__ */ jsx461(ErrorField9, { field: errors.canAddAccess })
        ] }),
        /* @__PURE__ */ jsxs311(FormInputRow9, { name: "canInviteMembers", title: "Can Invite Members *", children: [
          /* @__PURE__ */ jsx461(SwitchInput4, { control, name: "canInviteMembers" }),
          /* @__PURE__ */ jsx461(ErrorField9, { field: errors.canInviteMembers })
        ] }),
        /* @__PURE__ */ jsxs311(FormInputRow9, { name: "canViewMembers", title: "Can View Members *", children: [
          /* @__PURE__ */ jsx461(SwitchInput4, { control, name: "canViewMembers" }),
          /* @__PURE__ */ jsx461(ErrorField9, { field: errors.canViewMembers })
        ] })
      ]
    }
  ) });
};

// src/talent-pools/talent-pool-invites/components/TalentPoolCreateInternalInviteForm.tsx
import { useCallback as useCallback254 } from "react";
import * as zod17 from "zod";
import { useForm as useForm27 } from "react-hook-form";
import { zodResolver as zodResolver23 } from "@hookform/resolvers/zod";
import {
  createClientMutationId as createClientMutationId108,
  useSetUserErrorCodes as useSetUserErrorCodes37,
  useUserErrorCode as useUserErrorCode17
} from "shared-lib";
import {
  ActionContainer as ActionContainer12,
  ErrorField as ErrorField10,
  FormErrorCode as FormErrorCode3,
  FormErrorCodes as FormErrorCodes5,
  FormInputRow as FormInputRow10,
  FormTextAreaInput as FormTextAreaInput7
} from "shared-ui";

// src/talent-pools/talent-pool-invites/mutations/__generated__/UseTalentPoolCreateExternalInviteMutation.graphql.ts
var node538 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfTalentPoolInvite",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitTalentPoolInvite",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          v23,
          v32,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "talentPoolInviteId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "talentPoolId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "candidateId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "source",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "candidateFirstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "candidateLastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "candidateEmail",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sourceId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountId",
            "kind": "LinkedField",
            "name": "createdBy",
            "plural": false,
            "selections": [
              v23,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accountType",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v5 = {
    "kind": "InlineFragment",
    "selections": [
      v32,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseTalentPoolCreateExternalInviteMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitTalentPoolInviteInviteExternalPayload",
          "kind": "LinkedField",
          "name": "recruitTalentPoolInviteInviteExternal",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseTalentPoolCreateExternalInviteMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitTalentPoolInviteInviteExternalPayload",
          "kind": "LinkedField",
          "name": "recruitTalentPoolInviteInviteExternal",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "f73b858f952e0b63415e0fce607f7eb7",
      "id": null,
      "metadata": {},
      "name": "UseTalentPoolCreateExternalInviteMutation",
      "operationKind": "mutation",
      "text": "mutation UseTalentPoolCreateExternalInviteMutation(\n  $input: RecruitTalentPoolInviteInviteExternalInput!\n) {\n  data: recruitTalentPoolInviteInviteExternal(input: $input) {\n    payload {\n      node {\n        id\n        code\n        talentPoolInviteId\n        talentPoolId\n        updatedAt\n        candidateId\n        status\n        source\n        candidateFirstName\n        candidateLastName\n        candidateEmail\n        sourceId\n        createdBy {\n          id\n          accountType\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node538.hash = "ee035bbc1f625e8142fc2dda96823d85";
var UseTalentPoolCreateExternalInviteMutation_graphql_default = node538;

// src/talent-pools/talent-pool-invites/mutations/UseTalentPoolCreateExternalInvite.ts
import { useAsyncMutation as useAsyncMutation83 } from "shared-lib";
var mutationDef102 = UseTalentPoolCreateExternalInviteMutation_graphql_default;
function useTalentPoolCreateExternalInvite() {
  const [commit11, isBusy] = useAsyncMutation83(mutationDef102);
  return [commit11, isBusy];
}

// src/talent-pools/talent-pool-invites/mutations/__generated__/UseTalentPoolCreateInternalInviteMutation.graphql.ts
var node539 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfTalentPoolInvite",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitTalentPoolInvite",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          v23,
          v32,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "talentPoolInviteId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "talentPoolId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "candidateId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "source",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "candidateFirstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "candidateLastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "candidateEmail",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sourceId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountId",
            "kind": "LinkedField",
            "name": "createdBy",
            "plural": false,
            "selections": [
              v23,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accountType",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v5 = {
    "kind": "InlineFragment",
    "selections": [
      v32,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseTalentPoolCreateInternalInviteMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitTalentPoolInviteInviteInternalPayload",
          "kind": "LinkedField",
          "name": "recruitTalentPoolInviteInviteInternal",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseTalentPoolCreateInternalInviteMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitTalentPoolInviteInviteInternalPayload",
          "kind": "LinkedField",
          "name": "recruitTalentPoolInviteInviteInternal",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "9214bf4ffce625fb894064660ff088e5",
      "id": null,
      "metadata": {},
      "name": "UseTalentPoolCreateInternalInviteMutation",
      "operationKind": "mutation",
      "text": "mutation UseTalentPoolCreateInternalInviteMutation(\n  $input: RecruitTalentPoolInviteInviteInternalInput!\n) {\n  data: recruitTalentPoolInviteInviteInternal(input: $input) {\n    payload {\n      node {\n        id\n        code\n        talentPoolInviteId\n        talentPoolId\n        updatedAt\n        candidateId\n        status\n        source\n        candidateFirstName\n        candidateLastName\n        candidateEmail\n        sourceId\n        createdBy {\n          id\n          accountType\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node539.hash = "db133ce895b3ebc1a5adea8c86bd672f";
var UseTalentPoolCreateInternalInviteMutation_graphql_default = node539;

// src/talent-pools/talent-pool-invites/mutations/UseTalentPoolCreateInternalInvite.ts
import { useAsyncMutation as useAsyncMutation84 } from "shared-lib";
var mutationDef103 = UseTalentPoolCreateInternalInviteMutation_graphql_default;
function useTalentPoolCreateInternalInvite() {
  const [commit11, isBusy] = useAsyncMutation84(mutationDef103);
  return [commit11, isBusy];
}

// src/talent-pools/talent-pool-invites/mutations/__generated__/UseTalentPoolInviteExpireMutation.graphql.ts
var node540 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseTalentPoolInviteExpireMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitTalentPoolInviteExpirePayload",
          "kind": "LinkedField",
          "name": "recruitTalentPoolInviteExpire",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfTalentPoolInvite",
              "kind": "LinkedField",
              "name": "payload",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitTalentPoolInvite",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v23
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseTalentPoolInviteExpireMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitTalentPoolInviteExpirePayload",
          "kind": "LinkedField",
          "name": "recruitTalentPoolInviteExpire",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfTalentPoolInvite",
              "kind": "LinkedField",
              "name": "payload",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitTalentPoolInvite",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v23,
                    {
                      "alias": null,
                      "args": null,
                      "filters": null,
                      "handle": "deleteRecord",
                      "key": "",
                      "kind": "ScalarHandle",
                      "name": "id"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "db6db81708287064a9b93e63b33cb29d",
      "id": null,
      "metadata": {},
      "name": "UseTalentPoolInviteExpireMutation",
      "operationKind": "mutation",
      "text": "mutation UseTalentPoolInviteExpireMutation(\n  $input: RecruitTalentPoolInviteExpireInput!\n) {\n  data: recruitTalentPoolInviteExpire(input: $input) {\n    payload {\n      node {\n        id\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node540.hash = "c10033a82b26c6dfd7f396a4d15c5ac3";
var UseTalentPoolInviteExpireMutation_graphql_default = node540;

// src/talent-pools/talent-pool-invites/mutations/UseTalentPoolInviteExpire.ts
import { useAsyncMutation as useAsyncMutation85 } from "shared-lib";
var mutationDef104 = UseTalentPoolInviteExpireMutation_graphql_default;
function useTalentPoolInviteExpire() {
  const [commit11, isBusy] = useAsyncMutation85(mutationDef104);
  return [commit11, isBusy];
}

// src/talent-pools/talent-pool-invites/lib/error-codes.ts
var TalentPoolErrorCodes = class {
};
TalentPoolErrorCodes.MEMBERSHIP_ALREADY_EXISTS = "RECRUIT_RecruitTalentPoolInvite_MEMBERSHIP_ALREADY_EXISTS";
TalentPoolErrorCodes.INVITE_ALREADY_EXISTS = "RECRUIT_RecruitTalentPoolInvite_INVITE_ALREADY_EXISTS";

// src/talent-pools/talent-pool-invites/components/TalentPoolCreateInternalInviteForm.tsx
import { jsx as jsx463, jsxs as jsxs313 } from "react/jsx-runtime";
var formSchema14 = zod17.object({
  message: zod17.string().min(1, { message: "message is required" })
});
var TalentPoolCreateInternalInviteForm = ({
  talentPoolId,
  profileId,
  onCreate,
  onCancel
}) => {
  const defaultValues2 = {
    firstName: "",
    lastName: "",
    email: "",
    message: ""
  };
  const setErrorCode = useSetUserErrorCodes37();
  const { register, handleSubmit, watch, formState, control } = useForm27({
    resolver: zodResolver23(formSchema14),
    defaultValues: defaultValues2,
    mode: "onChange"
  });
  const userErrorCode = useUserErrorCode17();
  const [createInvite, isCreatingInvite] = useTalentPoolCreateInternalInvite();
  const onSave = useCallback254(
    async (form) => {
      setErrorCode(null);
      if (!form.message) {
        return;
      }
      const input = {
        talentPoolId,
        profileId,
        clientMutationId: createClientMutationId108(),
        message: form.message,
        sendInvite: true
      };
      const response = await createInvite({ input });
      if (response.data.userErrors && response.data.userErrors.length > 0) {
        setErrorCode(response.data.userErrors);
      }
      if (response.data.payload?.node) {
        onCreate(response.data.payload.node);
      }
    },
    [createInvite]
  );
  const onSubmit = handleSubmit(
    async (form) => {
      await onSave(form);
    },
    (invalid) => {
      console.error(invalid);
    }
  );
  const { errors, isValid, isDirty } = formState;
  let errorDisplay = /* @__PURE__ */ jsx463(FormErrorCodes5, {});
  if (userErrorCode && userErrorCode === TalentPoolErrorCodes.MEMBERSHIP_ALREADY_EXISTS) {
    errorDisplay = /* @__PURE__ */ jsx463("div", { className: "my-4", children: /* @__PURE__ */ jsx463(FormErrorCode3, { message: "Membership already exists" }) });
  }
  if (userErrorCode && userErrorCode === TalentPoolErrorCodes.INVITE_ALREADY_EXISTS) {
    errorDisplay = /* @__PURE__ */ jsx463("div", { className: "my-4", children: /* @__PURE__ */ jsx463(FormErrorCode3, { message: "Invite already exists" }) });
  }
  return /* @__PURE__ */ jsxs313("form", { onSubmit, children: [
    errorDisplay,
    /* @__PURE__ */ jsx463(
      ActionContainer12,
      {
        isDirty,
        showSubmit: true,
        showCancel: true,
        isDisabled: isCreatingInvite,
        submitText: "Create Invite",
        titleTop: `Create Invite`,
        children: /* @__PURE__ */ jsxs313(FormInputRow10, { name: "message", title: "Message *", children: [
          /* @__PURE__ */ jsx463(
            FormTextAreaInput7,
            {
              rows: 6,
              register,
              name: "message",
              required: false,
              placeholder: "Message"
            }
          ),
          /* @__PURE__ */ jsx463(ErrorField10, { field: errors.message })
        ] })
      }
    )
  ] });
};

// src/talent-pools/talent-pool-invites/components/TalentPoolCreateExternalInviteForm.tsx
import { useCallback as useCallback255 } from "react";
import * as zod18 from "zod";
import { useForm as useForm28 } from "react-hook-form";
import { zodResolver as zodResolver24 } from "@hookform/resolvers/zod";
import {
  createClientMutationId as createClientMutationId109,
  useSetUserErrorCodes as useSetUserErrorCodes38,
  useUserErrorCode as useUserErrorCode18
} from "shared-lib";
import {
  ActionContainer as ActionContainer13,
  ErrorField as ErrorField11,
  FormErrorCode as FormErrorCode4,
  FormErrorCodes as FormErrorCodes6,
  FormInputRow as FormInputRow11,
  FormTextAreaInput as FormTextAreaInput8,
  InputField as InputField7
} from "shared-ui";
import { jsx as jsx464, jsxs as jsxs314 } from "react/jsx-runtime";
var formSchema15 = zod18.object({
  firstName: zod18.string().min(1, { message: "Firstname is required" }),
  lastName: zod18.string().min(1, { message: "Lastname is required" }),
  email: zod18.string().min(1, { message: "Email is required" }).email({
    message: "Must be a valid email"
  }),
  message: zod18.string().min(1, { message: "message is required" })
});
var TalentPoolCreateExternalInviteForm = ({
  talentPoolId,
  onCreate,
  onCancel
}) => {
  const defaultValues2 = {
    firstName: "",
    lastName: "",
    email: "",
    message: ""
  };
  const setErrorCode = useSetUserErrorCodes38();
  const { register, handleSubmit, watch, formState, control } = useForm28({
    resolver: zodResolver24(formSchema15),
    defaultValues: defaultValues2,
    mode: "onChange"
  });
  const userErrorCode = useUserErrorCode18();
  const [createInvite, isCreatingInvite] = useTalentPoolCreateExternalInvite();
  const onSave = useCallback255(
    async (form) => {
      setErrorCode(null);
      if (!form.firstName || !form.lastName || !form.email || !form.message) {
        return;
      }
      const input = {
        talentPoolId,
        clientMutationId: createClientMutationId109(),
        firstName: form.firstName,
        lastName: form.lastName,
        email: form.email,
        message: form.message,
        sendInvite: true
      };
      const response = await createInvite({ input });
      if (response.data.userErrors && response.data.userErrors.length > 0) {
        setErrorCode(response.data.userErrors);
      }
      if (response.data.payload?.node) {
        onCreate(response.data.payload.node);
      }
    },
    [createInvite, onCreate, setErrorCode, talentPoolId]
  );
  const onSubmit = handleSubmit(
    async (form) => {
      await onSave(form);
    },
    (invalid) => {
      console.error(invalid);
    }
  );
  const { errors, isValid, isDirty } = formState;
  let errorDisplay = /* @__PURE__ */ jsx464(FormErrorCodes6, {});
  if (userErrorCode && userErrorCode === TalentPoolErrorCodes.MEMBERSHIP_ALREADY_EXISTS) {
    errorDisplay = /* @__PURE__ */ jsx464("div", { className: "my-4", children: /* @__PURE__ */ jsx464(FormErrorCode4, { message: "Membership already exists" }) });
  }
  return /* @__PURE__ */ jsxs314("form", { onSubmit, children: [
    errorDisplay,
    /* @__PURE__ */ jsxs314(
      ActionContainer13,
      {
        isDirty,
        onCancel,
        showSubmit: true,
        showCancel: true,
        isDisabled: isCreatingInvite,
        submitText: "Create Invite",
        titleTop: `Create Invite`,
        children: [
          /* @__PURE__ */ jsxs314(FormInputRow11, { name: "firstName", title: "First Name *", children: [
            /* @__PURE__ */ jsx464(
              InputField7,
              {
                register,
                name: "firstName",
                required: true,
                placeholder: "User First Name"
              }
            ),
            /* @__PURE__ */ jsx464(ErrorField11, { field: errors.firstName })
          ] }),
          /* @__PURE__ */ jsxs314(FormInputRow11, { name: "lastName", title: "Last Name *", children: [
            /* @__PURE__ */ jsx464(
              InputField7,
              {
                register,
                name: "lastName",
                required: true,
                placeholder: "User Last Name"
              }
            ),
            /* @__PURE__ */ jsx464(ErrorField11, { field: errors.lastName })
          ] }),
          /* @__PURE__ */ jsxs314(FormInputRow11, { name: "email", title: "Email *", children: [
            /* @__PURE__ */ jsx464(
              InputField7,
              {
                register,
                name: "email",
                required: true,
                placeholder: "User Email"
              }
            ),
            /* @__PURE__ */ jsx464(ErrorField11, { field: errors.email })
          ] }),
          /* @__PURE__ */ jsxs314(FormInputRow11, { name: "message", title: "Message *", children: [
            /* @__PURE__ */ jsx464(
              FormTextAreaInput8,
              {
                rows: 6,
                register,
                name: "message",
                required: false,
                placeholder: "Message"
              }
            ),
            /* @__PURE__ */ jsx464(ErrorField11, { field: errors.message })
          ] })
        ]
      }
    )
  ] });
};

// src/talent-pools/talent-pool-invites/components/TalentPoolCreateInviteContainer.tsx
import { Suspense as Suspense146, useCallback as useCallback256, useState as useState134 } from "react";
import { useForm as useForm29 } from "react-hook-form";
import { useToggle as useToggle48 } from "shared-lib";
import { Button as Button129, EdSkeleton as EdSkeleton118, SwitchInputComponent as SwitchInputComponent4 } from "shared-ui";
import { Fragment as Fragment114, jsx as jsx465, jsxs as jsxs315 } from "react/jsx-runtime";
var TalentPoolCreateInviteContainer = ({
  talentPool,
  onDone,
  onCancel
}) => {
  const [profile, setProfile] = useState134(null);
  const onSetProfile = useCallback256(
    (result) => {
      setProfile(result);
    },
    [setProfile]
  );
  const [isCreatingExternal, toggleCreateExternal] = useToggle48();
  const onCreated = useCallback256(
    (invite) => {
      onDone(invite.talentPoolInviteId);
    },
    [onDone]
  );
  let editor = null;
  if (isCreatingExternal) {
    editor = /* @__PURE__ */ jsx465(
      TalentPoolCreateExternalInviteForm,
      {
        talentPoolId: talentPool.talentPoolId,
        onCreate: onCreated,
        onCancel: toggleCreateExternal
      }
    );
  } else if (profile) {
    editor = /* @__PURE__ */ jsx465(
      TalentPoolCreateInternalInviteForm,
      {
        talentPoolId: talentPool.talentPoolId,
        profileId: profile.recruitProfileId,
        onCreate: onCreated,
        onCancel
      }
    );
  }
  const { control } = useForm29();
  return /* @__PURE__ */ jsx465(Suspense146, { fallback: /* @__PURE__ */ jsx465(EdSkeleton118, {}), children: /* @__PURE__ */ jsxs315("div", { className: "flex-1 px-4 pt-4", children: [
    /* @__PURE__ */ jsxs315("div", { className: "flex flex-col items-start justify-between md:flex-row md:items-center", children: [
      /* @__PURE__ */ jsx465("div", { className: "text-2xl", children: "Create Invite" }),
      /* @__PURE__ */ jsx465("div", { className: "py-2", children: /* @__PURE__ */ jsx465(
        SwitchInputComponent4,
        {
          value: isCreatingExternal,
          onChange: toggleCreateExternal,
          label: "Create an External Invite"
        }
      ) })
    ] }),
    /* @__PURE__ */ jsxs315("div", { className: "flex flex-1 flex-col gap-2 border-b bg-white py-4", children: [
      /* @__PURE__ */ jsx465("div", { className: "flex w-full flex-col md:flex-row md:items-end md:gap-8", children: !isCreatingExternal && /* @__PURE__ */ jsx465("div", { className: "flex w-full flex-col gap-2 md:w-1/2", children: /* @__PURE__ */ jsxs315(Fragment114, { children: [
        /* @__PURE__ */ jsx465("div", { children: "Search for Profile to Invite" }),
        /* @__PURE__ */ jsx465(ProfileSearchBoxContainer, { onSearchCompleted: onSetProfile })
      ] }) }) }),
      editor
    ] }),
    /* @__PURE__ */ jsx465("div", { className: "w-full p-2", children: /* @__PURE__ */ jsx465(Button129, { clicked: onCancel, color: "gray", children: "Cancel" }) })
  ] }) });
};

// src/talent-pools/talent-pool-invites/components/__generated__/TalentPoolInviteListContainerQuery.graphql.ts
var node541 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "code": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "TalentPoolInviteListContainerQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TalentPoolInviteListContainer_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "TalentPoolInviteListContainerQuery",
      "selections": [
        {
          "alias": "list",
          "args": v1,
          "concreteType": "RecruitTalentPoolInvitesConnection",
          "kind": "LinkedField",
          "name": "recruitTalentPoolInvites",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitTalentPoolInvitesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitTalentPoolInvite",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "talentPoolId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "candidateId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "source",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "candidateFirstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "candidateLastName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "candidateEmail",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sourceId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v1,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "TalentPoolInviteListContainer_list",
          "kind": "LinkedHandle",
          "name": "recruitTalentPoolInvites"
        }
      ]
    },
    "params": {
      "cacheID": "c843543e2ca1e2c3f731493ea68bcf27",
      "id": null,
      "metadata": {},
      "name": "TalentPoolInviteListContainerQuery",
      "operationKind": "query",
      "text": "query TalentPoolInviteListContainerQuery(\n  $where: RecruitTalentPoolInviteFilter!\n) {\n  ...TalentPoolInviteListContainer_list\n}\n\nfragment TalentPoolInviteListContainer_list on Query {\n  list: recruitTalentPoolInvites(first: 10, order: [{code: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        code\n        updatedAt\n        talentPoolId\n        candidateId\n        status\n        source\n        candidateFirstName\n        candidateLastName\n        candidateEmail\n        sourceId\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node541.hash = "bd48daa4c5ccc401cbcf4267d0c78b2f";
var TalentPoolInviteListContainerQuery_graphql_default = node541;

// src/talent-pools/talent-pool-invites/components/__generated__/TalentPoolInvitesListContainerPaginationQuery.graphql.ts
var node543 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v23 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v32 = [
    v1,
    v23,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "code": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "TalentPoolInvitesListContainerPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v23
          ],
          "kind": "FragmentSpread",
          "name": "TalentPoolInviteListContainer_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "TalentPoolInvitesListContainerPaginationQuery",
      "selections": [
        {
          "alias": "list",
          "args": v32,
          "concreteType": "RecruitTalentPoolInvitesConnection",
          "kind": "LinkedField",
          "name": "recruitTalentPoolInvites",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitTalentPoolInvitesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitTalentPoolInvite",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "talentPoolId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "candidateId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "source",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "candidateFirstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "candidateLastName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "candidateEmail",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sourceId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v32,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "TalentPoolInviteListContainer_list",
          "kind": "LinkedHandle",
          "name": "recruitTalentPoolInvites"
        }
      ]
    },
    "params": {
      "cacheID": "5acfc8ba5a68ce92460ef3ca178b00db",
      "id": null,
      "metadata": {},
      "name": "TalentPoolInvitesListContainerPaginationQuery",
      "operationKind": "query",
      "text": "query TalentPoolInvitesListContainerPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $where: RecruitTalentPoolInviteFilter\n) {\n  ...TalentPoolInviteListContainer_list_2HEEH6\n}\n\nfragment TalentPoolInviteListContainer_list_2HEEH6 on Query {\n  list: recruitTalentPoolInvites(first: $first, after: $after, order: [{code: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        code\n        updatedAt\n        talentPoolId\n        candidateId\n        status\n        source\n        candidateFirstName\n        candidateLastName\n        candidateEmail\n        sourceId\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node543.hash = "43302b93248c8f6198882bd8539f6afb";
var TalentPoolInvitesListContainerPaginationQuery_graphql_default = node543;

// src/talent-pools/talent-pool-invites/components/__generated__/TalentPoolInviteListContainer_list.graphql.ts
var node544 = function() {
  var v0 = [
    "list"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": TalentPoolInvitesListContainerPaginationQuery_graphql_default
      }
    },
    "name": "TalentPoolInviteListContainer_list",
    "selections": [
      {
        "alias": "list",
        "args": [
          {
            "kind": "Literal",
            "name": "order",
            "value": [
              {
                "code": "DESC"
              }
            ]
          },
          {
            "kind": "Variable",
            "name": "where",
            "variableName": "where"
          }
        ],
        "concreteType": "RecruitTalentPoolInvitesConnection",
        "kind": "LinkedField",
        "name": "__TalentPoolInviteListContainer_list_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitTalentPoolInvitesEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitTalentPoolInvite",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "talentPoolId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "candidateId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "source",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "candidateFirstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "candidateLastName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "candidateEmail",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sourceId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node544.hash = "43302b93248c8f6198882bd8539f6afb";
var TalentPoolInviteListContainer_list_graphql_default = node544;

// src/talent-pools/talent-pool-invites/components/TalentPoolInviteListContainer.tsx
import { Suspense as Suspense147, useCallback as useCallback257, useState as useState135, useTransition as useTransition15 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery77, usePaginationFragment as usePaginationFragment33 } from "react-relay";
import { formatDistanceToNow as formatDistanceToNow6, parseISO as parseISO13 } from "date-fns";
import { useLocation as useLocation9 } from "react-router-dom";
import { AdjustmentsVerticalIcon, UsersIcon } from "@heroicons/react/24/solid";
import {
  Button as Button130,
  classNames as classNames49,
  createLinkState as createLinkState7,
  EdSkeleton as EdSkeleton119,
  Input as Input17,
  Size as Size57,
  Spinner as Spinner16,
  Table as Table7,
  Tag as Tag27
} from "shared-ui";
import { useDebounce as useDebounce4 } from "shared-lib";
import { Fragment as Fragment115, jsx as jsx466, jsxs as jsxs316 } from "react/jsx-runtime";
var queryDef77 = TalentPoolInviteListContainerQuery_graphql_default;
var fragmentDef114 = TalentPoolInviteListContainer_list_graphql_default;
var List5 = ({ fragmentRef }) => {
  const { data, loadNext, refetch } = usePaginationFragment33(fragmentDef114, fragmentRef);
  const [isLoadingNext, setIsLoadingNext] = useTransition15();
  const onLoadNext = useCallback257(() => {
    setIsLoadingNext(() => {
      loadNext(10);
    });
  }, [loadNext]);
  const { list: list2 } = data;
  const location2 = useLocation9();
  const tabs6 = [
    createLinkState7(location2, "Open", `open`, UsersIcon),
    createLinkState7(location2, "Accepted", `accepted`, UsersIcon),
    createLinkState7(location2, "Declined", `declined`, UsersIcon),
    createLinkState7(location2, "Expired", `expired`, AdjustmentsVerticalIcon)
  ];
  const [loading, startTransition2] = useTransition15();
  const [filter2, setFilter] = useState135("ALL");
  const onSelect = useCallback257(
    (value) => {
      let where = {};
      if (value !== "ALL") {
        where = {
          status: { eq: value }
        };
      }
      startTransition2(() => {
        refetch({ where });
      });
      setFilter(value);
    },
    [refetch]
  );
  return /* @__PURE__ */ jsxs316(Suspense147, { fallback: /* @__PURE__ */ jsx466(EdSkeleton119, {}), children: [
    /* @__PURE__ */ jsxs316("div", { className: "@container mx-2 mt-5 flex items-center gap-1", children: [
      ["All", "Open", "Accepted", "Declined", "Withdrawn"].map((x4, i4) => /* @__PURE__ */ jsx466(
        "div",
        {
          className: classNames49("cursor-pointer"),
          onClick: () => onSelect(x4.toUpperCase()),
          children: /* @__PURE__ */ jsx466(
            Tag27,
            {
              color: filter2 == x4.toUpperCase() && "bg-blue-400" || "bg-blue-200",
              children: x4
            }
          )
        },
        i4
      )),
      loading && /* @__PURE__ */ jsx466(Spinner16, {})
    ] }),
    /* @__PURE__ */ jsx466(
      Table7,
      {
        header: [
          "First Name",
          "Last Name",
          "Invite Sent Date",
          "Email Address",
          "Status"
        ],
        items: list2?.edges?.map((x4) => [
          {
            key: "candidateFirstName",
            value: x4?.node?.candidateFirstName || ""
          },
          {
            key: "candidateLastName",
            value: x4?.node?.candidateLastName || ""
          },
          { key: "updatedAt", value: x4?.node?.updatedAt || "" },
          { key: "candidateEmail", value: x4?.node?.candidateEmail || "" },
          { key: "status", value: x4?.node?.status || "" }
        ]),
        children: ({ key, value }) => /* @__PURE__ */ jsxs316(Fragment115, { children: [
          /* @__PURE__ */ jsxs316("div", { className: "@4xl:block hidden", children: [
            key === "updatedAt" && formatDistanceToNow6(parseISO13(value), { addSuffix: true }),
            key === "status" && /* @__PURE__ */ jsx466(Tag27, { children: value }),
            key !== "updatedAt" && key !== "status" && value
          ] }, key + value + "lg"),
          /* @__PURE__ */ jsxs316(
            "div",
            {
              className: "@4xl:hidden grid grid-cols-2",
              children: [
                /* @__PURE__ */ jsx466("div", { className: "font-bold", children: key }),
                /* @__PURE__ */ jsxs316("div", { children: [
                  key === "Updated At" && formatDistanceToNow6(parseISO13(value), { addSuffix: true }),
                  key === "Status" && /* @__PURE__ */ jsx466(Tag27, { children: value }),
                  key !== "Updated At" && key !== "Status" && value
                ] })
              ]
            },
            key + value + "sm"
          )
        ] })
      }
    ),
    data.list?.pageInfo.hasNextPage && /* @__PURE__ */ jsxs316("div", { className: "mx-5 mb-5 flex items-center justify-end gap-2", children: [
      /* @__PURE__ */ jsx466(Button130, { color: "primary", onClick: onLoadNext, children: "Load more" }),
      isLoadingNext && /* @__PURE__ */ jsx466(Spinner16, {})
    ] })
  ] });
};
var TalentPoolInvitesListContainer = ({
  talentPoolId,
  onCreate
}) => {
  const [filter2, setFilter] = useState135(null);
  const searchTerm = useDebounce4(filter2, 500);
  const where = {
    talentPoolId: { eq: talentPoolId }
  };
  if (searchTerm) {
    where.or = [{ candidateEmail: { startsWith: filter2 } }];
  }
  const query3 = useLazyLoadQuery77(
    queryDef77,
    { where },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsxs316("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ jsxs316("div", { className: "flex items-center justify-between space-x-4 border-b", children: [
      /* @__PURE__ */ jsxs316("div", { className: "flex items-center space-x-4 p-2", children: [
        /* @__PURE__ */ jsx466("label", { className: "text-gray-700", htmlFor: "filter", children: "Filter" }),
        /* @__PURE__ */ jsx466("div", { className: "sm:w-64", children: /* @__PURE__ */ jsx466(
          Input17,
          {
            placeholder: "Email",
            name: "filter",
            onValueChange: (filter3) => setFilter(filter3)
          },
          "filter"
        ) })
      ] }),
      /* @__PURE__ */ jsx466("div", { className: "p-2", children: /* @__PURE__ */ jsx466(Button130, { color: "primary", size: Size57.md, clicked: onCreate, children: "Create Invite" }) })
    ] }),
    /* @__PURE__ */ jsx466("div", { className: "flex-1", children: /* @__PURE__ */ jsx466(List5, { fragmentRef: query3 }) })
  ] });
};

// src/talent-pools/talent-pool-members/components/__generated__/TalentPoolMemberContainerQuery.graphql.ts
var node545 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "profileId"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 15
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": {
        "endDate": "DESC"
      }
    },
    {
      "kind": "Variable",
      "name": "profileId",
      "variableName": "profileId"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "TalentPoolMemberContainerQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CandidateProfileExperienceList_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "TalentPoolMemberContainerQuery",
      "selections": [
        {
          "alias": "list",
          "args": v1,
          "concreteType": "RecruitProfileExperiencesConnection",
          "kind": "LinkedField",
          "name": "recruitProfileExperiences",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfileExperiencesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperience",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "startDate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "endDate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "companyName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "title",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v1,
          "filters": [],
          "handle": "connection",
          "key": "CandidateProfileExperienceList_list",
          "kind": "LinkedHandle",
          "name": "recruitProfileExperiences"
        }
      ]
    },
    "params": {
      "cacheID": "2c2c95cb64d61cf0a45186e5e204ab42",
      "id": null,
      "metadata": {},
      "name": "TalentPoolMemberContainerQuery",
      "operationKind": "query",
      "text": "query TalentPoolMemberContainerQuery(\n  $profileId: UUID!\n) {\n  ...CandidateProfileExperienceList_list\n}\n\nfragment CandidateProfileExperienceItemHeader_item on RecruitProfileExperience {\n  id\n  startDate\n  endDate\n  companyName\n  title\n}\n\nfragment CandidateProfileExperienceItem_item on RecruitProfileExperience {\n  id\n  description\n  ...CandidateProfileExperienceItemHeader_item\n}\n\nfragment CandidateProfileExperienceList_list on Query {\n  list: recruitProfileExperiences(profileId: $profileId, first: 15, order: {endDate: DESC}) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        startDate\n        endDate\n        companyName\n        title\n        ...CandidateProfileExperienceItem_item\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node545.hash = "a28eff525e450b06e56a2b6dc1efd611";
var TalentPoolMemberContainerQuery_graphql_default = node545;

// src/talent-pools/talent-pool-members/components/__generated__/TalentPoolMemberContainer_member.graphql.ts
var node546 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TalentPoolMemberContainer_member",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "talentPoolMembershipId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "talentPoolId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RecruitProfile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "recruitProfileId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "emailAddress",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__id",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "RecruitTalentPoolMembership",
  "abstractKey": null
};
node546.hash = "1b482d0ddc42831fcbcb3141f0f8c99b";
var TalentPoolMemberContainer_member_graphql_default = node546;

// src/talent-pools/talent-pool-members/components/TalentPoolMemberContainer.tsx
import { Suspense as Suspense148, useCallback as useCallback258 } from "react";
import { useFragment as useFragment154, useLazyLoadQuery as useLazyLoadQuery78 } from "react-relay";
import { createClientMutationId as createClientMutationId110, useToggle as useToggle49 } from "shared-lib";
import { Button as Button131, EdSkeleton as EdSkeleton120, Size as Size58 } from "shared-ui";

// src/talent-pools/talent-pool-members/mutations/__generated__/UseTalentPoolMembershipRevokeMutation.graphql.ts
var node547 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseTalentPoolMembershipRevokeMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitTalentPoolMembershipRevokeAccessPayload",
          "kind": "LinkedField",
          "name": "recruitTalentPoolMembershipRevokeAccess",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfTalentPoolMembership",
              "kind": "LinkedField",
              "name": "payload",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitTalentPoolMembership",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v23
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseTalentPoolMembershipRevokeMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitTalentPoolMembershipRevokeAccessPayload",
          "kind": "LinkedField",
          "name": "recruitTalentPoolMembershipRevokeAccess",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfTalentPoolMembership",
              "kind": "LinkedField",
              "name": "payload",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitTalentPoolMembership",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v23,
                    {
                      "alias": null,
                      "args": null,
                      "filters": null,
                      "handle": "deleteRecord",
                      "key": "",
                      "kind": "ScalarHandle",
                      "name": "id"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v32
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "2b43c9115ff762b364bcc9783543c18d",
      "id": null,
      "metadata": {},
      "name": "UseTalentPoolMembershipRevokeMutation",
      "operationKind": "mutation",
      "text": "mutation UseTalentPoolMembershipRevokeMutation(\n  $input: RecruitTalentPoolMembershipRevokeAccessInput!\n) {\n  data: recruitTalentPoolMembershipRevokeAccess(input: $input) {\n    payload {\n      node {\n        id\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node547.hash = "9377e73d28254fa950f1b2f7965ea9c9";
var UseTalentPoolMembershipRevokeMutation_graphql_default = node547;

// src/talent-pools/talent-pool-members/mutations/UseTalentPoolMembershipRevoke.ts
import { useAsyncMutation as useAsyncMutation86 } from "shared-lib";
var mutationDef105 = UseTalentPoolMembershipRevokeMutation_graphql_default;
function useTalentPoolMembershipRevoke() {
  const [commit11, isBusy] = useAsyncMutation86(mutationDef105);
  return [commit11, isBusy];
}

// src/talent-pools/talent-pool-members/components/TalentPoolMemberContainer.tsx
import { jsx as jsx467, jsxs as jsxs317 } from "react/jsx-runtime";
var queryDef78 = TalentPoolMemberContainerQuery_graphql_default;
var fragmentDef115 = TalentPoolMemberContainer_member_graphql_default;
var TalentPoolMemberContainer = ({
  onRevoked,
  fragmentRef
}) => {
  const membership = useFragment154(fragmentDef115, fragmentRef);
  const { profile } = membership;
  const [revokeMembership, isRevokingMembership] = useTalentPoolMembershipRevoke();
  const onRevokeMembership = useCallback258(async () => {
    const input = {
      clientMutationId: createClientMutationId110(),
      talentPoolMembershipId: membership.talentPoolMembershipId
    };
    const response = await revokeMembership({ input });
    if (response.data.payload) {
      onRevoked();
    }
  }, [revokeMembership]);
  const [isRevoking, toggleIsEditing] = useToggle49();
  const actions = membership.status === "STARTED" ? /* @__PURE__ */ jsx467("div", { children: isRevoking ? /* @__PURE__ */ jsx467(Button131, { color: "gray", clicked: toggleIsEditing, children: "Cancel" }) : /* @__PURE__ */ jsx467(Button131, { color: "primary", clicked: toggleIsEditing, children: "Revoke" }) }) : /* @__PURE__ */ jsx467("div", {});
  return /* @__PURE__ */ jsxs317("div", { className: "flex flex-col gap-2", children: [
    /* @__PURE__ */ jsxs317("div", { className: "flex items-center justify-between gap-2 border-b p-4", children: [
      /* @__PURE__ */ jsxs317("div", { className: "text-primary-500 flex items-center gap-2 text-xl font-bold", children: [
        /* @__PURE__ */ jsx467("div", { className: "", children: membership.profile.firstName }),
        /* @__PURE__ */ jsx467("div", { className: "", children: membership.profile.lastName })
      ] }),
      /* @__PURE__ */ jsxs317("div", { className: "flex items-center gap-4 pt-2 text-sm", children: [
        /* @__PURE__ */ jsxs317("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ jsx467("div", { children: "Status" }),
          /* @__PURE__ */ jsx467("div", { className: "text-primary-500 font-medium", children: membership.status })
        ] }),
        actions
      ] })
    ] }),
    isRevoking ? /* @__PURE__ */ jsx467("div", { className: "m-4", children: /* @__PURE__ */ jsxs317(Button131, { size: Size58.xl, color: "danger", clicked: onRevokeMembership, children: [
      "Revoke, Are you sure ?",
      " "
    ] }) }) : /* @__PURE__ */ jsx467(
      TalentPoolMemberProfileContainer,
      {
        profileId: profile.recruitProfileId
      }
    )
  ] });
};
var TalentPoolMemberProfileContainer = ({
  profileId
}) => {
  const query3 = useLazyLoadQuery78(
    queryDef78,
    { profileId },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsx467(Suspense148, { fallback: /* @__PURE__ */ jsx467(EdSkeleton120, {}), children: /* @__PURE__ */ jsx467(CandidateProfileExperienceList, { fragmentRef: query3 }) });
};

// src/talent-pools/talent-pool-members/components/__generated__/TalentPoolMemberListContainerContainerPaginationQuery.graphql.ts
var node548 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "emailAddress",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateExperienceId",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyName",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "startDate",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "endDate",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyIsVerified",
    "storageKey": null
  }, v14 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyId",
    "storageKey": null
  }, v15 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  }, v16 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "skills",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "TalentPoolMemberListContainerContainerPaginationQuery",
      "selections": [
        {
          "args": v1,
          "kind": "FragmentSpread",
          "name": "TalentPoolMemberListContainerContainer_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "TalentPoolMemberListContainerContainerPaginationQuery",
      "selections": [
        {
          "alias": "list",
          "args": v1,
          "concreteType": "ProfileSearchResults",
          "kind": "LinkedField",
          "name": "recruitProfileSearch",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfile",
              "kind": "LinkedField",
              "name": "profiles",
              "plural": true,
              "selections": [
                v23,
                v32,
                v4,
                v5,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "recruitProfileId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitCandidateProfileNote",
                  "kind": "LinkedField",
                  "name": "notes",
                  "plural": true,
                  "selections": [
                    v5,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "content",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitCandidateProfileNoteTag",
                      "kind": "LinkedField",
                      "name": "tags",
                      "plural": true,
                      "selections": [
                        v6,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "value",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountsUser",
                      "kind": "LinkedField",
                      "name": "createdByUser",
                      "plural": false,
                      "selections": [
                        v4,
                        v23,
                        v32
                      ],
                      "storageKey": null
                    },
                    v7
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsCandidateAccount",
                  "kind": "LinkedField",
                  "name": "account",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "accountId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CandidatePhoneVerification",
                      "kind": "LinkedField",
                      "name": "phone",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "phoneVerificationStatus",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "phoneNumber",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "phoneCountryPrefix",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    v7
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperience",
                  "kind": "LinkedField",
                  "name": "experience",
                  "plural": true,
                  "selections": [
                    v7,
                    v8,
                    v9,
                    v10,
                    v11,
                    v12,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "version",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "titleId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "industry",
                      "storageKey": null
                    },
                    v13,
                    v14,
                    v15,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "positionType",
                      "storageKey": null
                    },
                    v16,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "escoOccupationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "escoHierarchy",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                v7,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileWorkLocations",
                  "kind": "LinkedField",
                  "name": "workLocations",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currentLocationName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currentLocationCountryName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "WorkLocationEntry",
                      "kind": "LinkedField",
                      "name": "workLocations",
                      "plural": true,
                      "selections": [
                        v6
                      ],
                      "storageKey": null
                    },
                    v7
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperience",
                  "kind": "LinkedField",
                  "name": "currentPosition",
                  "plural": false,
                  "selections": [
                    v9,
                    v10,
                    v11,
                    v12,
                    v7
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileRate",
                  "kind": "LinkedField",
                  "name": "rate",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "payType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "minimumRateOfPay",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "maximumRateOfPay",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "countryCode",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currencyCode",
                      "storageKey": null
                    },
                    v7
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileAvailability",
                  "kind": "LinkedField",
                  "name": "availability",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobSearchStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "availabilityStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "NoticeCriteria",
                      "kind": "LinkedField",
                      "name": "noticeCriteria",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "availableFrom",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "noticePeriodWeeks",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "noticeTimeframe",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    v7
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "profileType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RightToWork",
                  "kind": "LinkedField",
                  "name": "rightToWork",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    v7
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperienceCollection",
                  "kind": "LinkedField",
                  "name": "experiences",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileExperience",
                      "kind": "LinkedField",
                      "name": "items",
                      "plural": true,
                      "selections": [
                        v7,
                        v8,
                        v9,
                        v14,
                        v13,
                        v10,
                        v15,
                        v11,
                        v12,
                        v16
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "SkillUsage",
                      "kind": "LinkedField",
                      "name": "skills",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "skillId",
                          "storageKey": null
                        },
                        v6,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "totalMonthsUsed",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "averageMonthsUsed",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "totalPositionsUsed",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "lastUsed",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "DateRange",
                          "kind": "LinkedField",
                          "name": "periods",
                          "plural": true,
                          "selections": [
                            v11,
                            v12
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CollectionMetaData",
              "kind": "LinkedField",
              "name": "pagination",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "itemsPerPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "pageNumber",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "pages",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "totalResults",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "67b1e940c38b625e57960274d7ee7523",
      "id": null,
      "metadata": {},
      "name": "TalentPoolMemberListContainerContainerPaginationQuery",
      "operationKind": "query",
      "text": "query TalentPoolMemberListContainerContainerPaginationQuery(\n  $input: ProfileSearchInput!\n) {\n  ...TalentPoolMemberListContainerContainer_list_2VV6jB\n}\n\nfragment ExperienceDetails_experience on RecruitProfileExperience {\n  id\n  createdOn\n  updatedOn\n  candidateExperienceId\n  version\n  titleId\n  title\n  industry\n  companyIsVerified\n  companyId\n  companyName\n  description\n  startDate\n  endDate\n  positionType\n  skills\n  escoOccupationId\n  escoHierarchy\n}\n\nfragment ProfileSearchResultTimeline_profile on RecruitProfile {\n  id\n  experiences {\n    items {\n      id\n      candidateExperienceId\n      title\n      companyId\n      companyIsVerified\n      companyName\n      description\n      startDate\n      endDate\n      skills\n    }\n    skills {\n      skillId\n      name\n      totalMonthsUsed\n      averageMonthsUsed\n      totalPositionsUsed\n      lastUsed\n      periods {\n        startDate\n        endDate\n      }\n    }\n  }\n}\n\nfragment Profile_profile on RecruitProfile {\n  code\n  firstName\n  lastName\n  recruitProfileId\n  emailAddress\n  notes {\n    code\n    content\n    tags {\n      name\n      value\n    }\n    updatedAt\n    createdByUser {\n      emailAddress\n      firstName\n      lastName\n    }\n    id\n  }\n  account {\n    accountId\n    phone {\n      phoneVerificationStatus\n      phoneNumber\n      phoneCountryPrefix\n    }\n    id\n  }\n  experience {\n    id\n    candidateExperienceId\n    title\n    companyName\n    startDate\n    endDate\n    ...ExperienceDetails_experience\n  }\n  ...RecruitProfileHeader_profile\n  ...ProfileSearchResultTimeline_profile\n}\n\nfragment RecruitProfileApplicationHeader_application on RecruitProfile {\n  id\n  firstName\n  lastName\n  workLocations {\n    currentLocationName\n    currentLocationCountryName\n    workLocations {\n      name\n    }\n    id\n  }\n  currentPosition {\n    title\n    companyName\n    startDate\n    endDate\n    id\n  }\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n  availability {\n    jobSearchStatus\n    availabilityStatus\n    noticeCriteria {\n      availableFrom\n      noticePeriodWeeks\n      noticeTimeframe\n    }\n    id\n  }\n}\n\nfragment RecruitProfileHeader_profile on RecruitProfile {\n  ...RecruitProfileApplicationHeader_application\n  id\n  recruitProfileId\n  firstName\n  lastName\n  profileType\n  workLocations {\n    currentLocationName\n    currentLocationCountryName\n    id\n  }\n  account {\n    accountId\n    id\n  }\n  currentPosition {\n    title\n    companyName\n    startDate\n    endDate\n    id\n  }\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n  rightToWork {\n    status\n    id\n  }\n  availability {\n    jobSearchStatus\n    id\n  }\n}\n\nfragment TalentPoolMemberListContainerContainer_list_2VV6jB on Query {\n  list: recruitProfileSearch(input: $input) {\n    profiles {\n      firstName\n      lastName\n      emailAddress\n      ...Profile_profile\n      id\n    }\n    pagination {\n      itemsPerPage\n      pageNumber\n      pages\n      totalResults\n    }\n  }\n}\n"
    }
  };
}();
node548.hash = "cb5d6b4cbdcd5cc4f7a6d47fa0551a7a";
var TalentPoolMemberListContainerContainerPaginationQuery_graphql_default = node548;

// src/talent-pools/talent-pool-members/components/__generated__/TalentPoolMemberListContainerContainer_list.graphql.ts
var node549 = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [],
      "operation": TalentPoolMemberListContainerContainerPaginationQuery_graphql_default
    }
  },
  "name": "TalentPoolMemberListContainerContainer_list",
  "selections": [
    {
      "alias": "list",
      "args": [
        {
          "kind": "Variable",
          "name": "input",
          "variableName": "input"
        }
      ],
      "concreteType": "ProfileSearchResults",
      "kind": "LinkedField",
      "name": "recruitProfileSearch",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RecruitProfile",
          "kind": "LinkedField",
          "name": "profiles",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "firstName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lastName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "emailAddress",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "Profile_profile"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CollectionMetaData",
          "kind": "LinkedField",
          "name": "pagination",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "itemsPerPage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "pageNumber",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "pages",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalResults",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
node549.hash = "cb5d6b4cbdcd5cc4f7a6d47fa0551a7a";
var TalentPoolMemberListContainerContainer_list_graphql_default = node549;

// src/talent-pools/talent-pool-members/components/__generated__/TalentPoolMemberListContainerContainerQuery.graphql.ts
var node550 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "emailAddress",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "candidateExperienceId",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyName",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "startDate",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "endDate",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyIsVerified",
    "storageKey": null
  }, v14 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyId",
    "storageKey": null
  }, v15 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  }, v16 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "skills",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "TalentPoolMemberListContainerContainerQuery",
      "selections": [
        {
          "args": v1,
          "kind": "FragmentSpread",
          "name": "TalentPoolMemberListContainerContainer_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "TalentPoolMemberListContainerContainerQuery",
      "selections": [
        {
          "alias": "list",
          "args": v1,
          "concreteType": "ProfileSearchResults",
          "kind": "LinkedField",
          "name": "recruitProfileSearch",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitProfile",
              "kind": "LinkedField",
              "name": "profiles",
              "plural": true,
              "selections": [
                v23,
                v32,
                v4,
                v5,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "recruitProfileId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitCandidateProfileNote",
                  "kind": "LinkedField",
                  "name": "notes",
                  "plural": true,
                  "selections": [
                    v5,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "content",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitCandidateProfileNoteTag",
                      "kind": "LinkedField",
                      "name": "tags",
                      "plural": true,
                      "selections": [
                        v6,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "value",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountsUser",
                      "kind": "LinkedField",
                      "name": "createdByUser",
                      "plural": false,
                      "selections": [
                        v4,
                        v23,
                        v32
                      ],
                      "storageKey": null
                    },
                    v7
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountsCandidateAccount",
                  "kind": "LinkedField",
                  "name": "account",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "accountId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CandidatePhoneVerification",
                      "kind": "LinkedField",
                      "name": "phone",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "phoneVerificationStatus",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "phoneNumber",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "phoneCountryPrefix",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    v7
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperience",
                  "kind": "LinkedField",
                  "name": "experience",
                  "plural": true,
                  "selections": [
                    v7,
                    v8,
                    v9,
                    v10,
                    v11,
                    v12,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "version",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "titleId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "industry",
                      "storageKey": null
                    },
                    v13,
                    v14,
                    v15,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "positionType",
                      "storageKey": null
                    },
                    v16,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "escoOccupationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "escoHierarchy",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                v7,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileWorkLocations",
                  "kind": "LinkedField",
                  "name": "workLocations",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currentLocationName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currentLocationCountryName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "WorkLocationEntry",
                      "kind": "LinkedField",
                      "name": "workLocations",
                      "plural": true,
                      "selections": [
                        v6
                      ],
                      "storageKey": null
                    },
                    v7
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperience",
                  "kind": "LinkedField",
                  "name": "currentPosition",
                  "plural": false,
                  "selections": [
                    v9,
                    v10,
                    v11,
                    v12,
                    v7
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileRate",
                  "kind": "LinkedField",
                  "name": "rate",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "payType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "minimumRateOfPay",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "maximumRateOfPay",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "countryCode",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currencyCode",
                      "storageKey": null
                    },
                    v7
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileAvailability",
                  "kind": "LinkedField",
                  "name": "availability",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobSearchStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "availabilityStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "NoticeCriteria",
                      "kind": "LinkedField",
                      "name": "noticeCriteria",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "availableFrom",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "noticePeriodWeeks",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "noticeTimeframe",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    v7
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "profileType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RightToWork",
                  "kind": "LinkedField",
                  "name": "rightToWork",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    v7
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitProfileExperienceCollection",
                  "kind": "LinkedField",
                  "name": "experiences",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitProfileExperience",
                      "kind": "LinkedField",
                      "name": "items",
                      "plural": true,
                      "selections": [
                        v7,
                        v8,
                        v9,
                        v14,
                        v13,
                        v10,
                        v15,
                        v11,
                        v12,
                        v16
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "SkillUsage",
                      "kind": "LinkedField",
                      "name": "skills",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "skillId",
                          "storageKey": null
                        },
                        v6,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "totalMonthsUsed",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "averageMonthsUsed",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "totalPositionsUsed",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "lastUsed",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "DateRange",
                          "kind": "LinkedField",
                          "name": "periods",
                          "plural": true,
                          "selections": [
                            v11,
                            v12
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CollectionMetaData",
              "kind": "LinkedField",
              "name": "pagination",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "itemsPerPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "pageNumber",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "pages",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "totalResults",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "a4d1ed2b083a3e421b2868fde7e23e47",
      "id": null,
      "metadata": {},
      "name": "TalentPoolMemberListContainerContainerQuery",
      "operationKind": "query",
      "text": "query TalentPoolMemberListContainerContainerQuery(\n  $input: ProfileSearchInput!\n) {\n  ...TalentPoolMemberListContainerContainer_list_2VV6jB\n}\n\nfragment ExperienceDetails_experience on RecruitProfileExperience {\n  id\n  createdOn\n  updatedOn\n  candidateExperienceId\n  version\n  titleId\n  title\n  industry\n  companyIsVerified\n  companyId\n  companyName\n  description\n  startDate\n  endDate\n  positionType\n  skills\n  escoOccupationId\n  escoHierarchy\n}\n\nfragment ProfileSearchResultTimeline_profile on RecruitProfile {\n  id\n  experiences {\n    items {\n      id\n      candidateExperienceId\n      title\n      companyId\n      companyIsVerified\n      companyName\n      description\n      startDate\n      endDate\n      skills\n    }\n    skills {\n      skillId\n      name\n      totalMonthsUsed\n      averageMonthsUsed\n      totalPositionsUsed\n      lastUsed\n      periods {\n        startDate\n        endDate\n      }\n    }\n  }\n}\n\nfragment Profile_profile on RecruitProfile {\n  code\n  firstName\n  lastName\n  recruitProfileId\n  emailAddress\n  notes {\n    code\n    content\n    tags {\n      name\n      value\n    }\n    updatedAt\n    createdByUser {\n      emailAddress\n      firstName\n      lastName\n    }\n    id\n  }\n  account {\n    accountId\n    phone {\n      phoneVerificationStatus\n      phoneNumber\n      phoneCountryPrefix\n    }\n    id\n  }\n  experience {\n    id\n    candidateExperienceId\n    title\n    companyName\n    startDate\n    endDate\n    ...ExperienceDetails_experience\n  }\n  ...RecruitProfileHeader_profile\n  ...ProfileSearchResultTimeline_profile\n}\n\nfragment RecruitProfileApplicationHeader_application on RecruitProfile {\n  id\n  firstName\n  lastName\n  workLocations {\n    currentLocationName\n    currentLocationCountryName\n    workLocations {\n      name\n    }\n    id\n  }\n  currentPosition {\n    title\n    companyName\n    startDate\n    endDate\n    id\n  }\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n  availability {\n    jobSearchStatus\n    availabilityStatus\n    noticeCriteria {\n      availableFrom\n      noticePeriodWeeks\n      noticeTimeframe\n    }\n    id\n  }\n}\n\nfragment RecruitProfileHeader_profile on RecruitProfile {\n  ...RecruitProfileApplicationHeader_application\n  id\n  recruitProfileId\n  firstName\n  lastName\n  profileType\n  workLocations {\n    currentLocationName\n    currentLocationCountryName\n    id\n  }\n  account {\n    accountId\n    id\n  }\n  currentPosition {\n    title\n    companyName\n    startDate\n    endDate\n    id\n  }\n  rate {\n    payType\n    minimumRateOfPay\n    maximumRateOfPay\n    countryCode\n    currencyCode\n    id\n  }\n  rightToWork {\n    status\n    id\n  }\n  availability {\n    jobSearchStatus\n    id\n  }\n}\n\nfragment TalentPoolMemberListContainerContainer_list_2VV6jB on Query {\n  list: recruitProfileSearch(input: $input) {\n    profiles {\n      firstName\n      lastName\n      emailAddress\n      ...Profile_profile\n      id\n    }\n    pagination {\n      itemsPerPage\n      pageNumber\n      pages\n      totalResults\n    }\n  }\n}\n"
    }
  };
}();
node550.hash = "d4e211bc757e403eebc66e6af228f99b";
var TalentPoolMemberListContainerContainerQuery_graphql_default = node550;

// src/talent-pools/talent-pool-members/components/TalentPoolMemberListContainer.tsx
import { Suspense as Suspense149 } from "react";
import { useFragment as useFragment155 } from "react-relay";
import { Button as Button133, EdSkeleton as EdSkeleton121, SimplePagination as SimplePagination7, Size as Size59 } from "shared-ui";
import { jsx as jsx468, jsxs as jsxs318 } from "react/jsx-runtime";
function List6({ fragmentRef }) {
  const data = useFragment155(
    List6.fragments.profiles,
    fragmentRef
  );
  const { list: list2 } = data;
  return /* @__PURE__ */ jsxs318(Suspense149, { fallback: /* @__PURE__ */ jsx468(EdSkeleton121, {}), children: [
    /* @__PURE__ */ jsx468("div", { className: "flex flex-col gap-5 bg-gray-100 pt-5", children: list2?.profiles.map((x4) => /* @__PURE__ */ jsx468(
      ProfileConnectionComponent,
      {
        isInList: true,
        fragmentRef: x4,
        showSelect: false
      },
      x4.emailAddress
    )) }),
    /* @__PURE__ */ jsx468(
      SimplePagination7,
      {
        name: "TalentPoolMemberListContainer",
        totalResults: list2.pagination.totalResults,
        itemsPerPage: list2.pagination.itemsPerPage,
        pageNumber: list2.pagination.pageNumber,
        pages: list2.pagination.pages,
        onPage: function(pageNumber) {
          throw new Error("Function not implemented.");
        }
      }
    )
  ] });
}
List6.fragments = {
  profiles: TalentPoolMemberListContainerContainer_list_graphql_default
};
function TalentPoolMemberListContainer({
  onCreate,
  talentPoolId
}) {
  const talentPoolQuery = {
    filters: {
      talentPools: [talentPoolId]
    },
    pagination: { pageNumber: 1, pageSize: 10 },
    sort: { field: { standard: "BEST_MATCH" }, order: "DESC" },
    fullTextSearch: { query: "", queryField: { standard: "ALL" } }
  };
  const talentPoolLink = `../../../profile-search?q=${btoa(
    JSON.stringify(talentPoolQuery)
  )}`;
  return /* @__PURE__ */ jsx468("div", { className: "flex flex-1 flex-col", children: /* @__PURE__ */ jsx468("div", { className: "flex items-center justify-between border-b px-1 py-3", children: /* @__PURE__ */ jsxs318("div", { className: "flex w-full flex-col gap-5", children: [
    /* @__PURE__ */ jsx468("div", { className: "self-end", children: /* @__PURE__ */ jsx468(Button133, { clicked: onCreate, color: "primary", children: "Create Invite" }) }),
    /* @__PURE__ */ jsx468("div", { className: "flex min-h-[300px] w-full items-center justify-center border-2 border-dashed", children: /* @__PURE__ */ jsx468("a", { href: talentPoolLink, children: /* @__PURE__ */ jsx468(Button133, { color: "primary", size: Size59.lg, children: "View Members" }) }) })
  ] }) }) });
}
TalentPoolMemberListContainer.query = TalentPoolMemberListContainerContainerQuery_graphql_default;

// src/vacancy-qa/components/__generated__/VacancyQualityAssuranceRouteQuery.graphql.ts
var node551 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "qaCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "qaCode"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "vacancyQualityAssuranceId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v5 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }, v6 = [
    v23,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountType",
      "storageKey": null
    }
  ], v7 = {
    "alias": null,
    "args": null,
    "concreteType": "AccountId",
    "kind": "LinkedField",
    "name": "createdBy",
    "plural": false,
    "selections": v6,
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "VacancyQualityAssuranceRouteQuery",
      "selections": [
        {
          "alias": "assurance",
          "args": v1,
          "concreteType": "VacancyQualityAssurance",
          "kind": "LinkedField",
          "name": "recruitVacancyQualityAssuranceByCode",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "VacancyQualityAssuranceDetails_assure"
            },
            v5
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "VacancyQualityAssuranceRouteQuery",
      "selections": [
        {
          "alias": "assurance",
          "args": v1,
          "concreteType": "VacancyQualityAssurance",
          "kind": "LinkedField",
          "name": "recruitVacancyQualityAssuranceByCode",
          "plural": false,
          "selections": [
            v23,
            v32,
            v4,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "version",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            },
            v7,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountId",
              "kind": "LinkedField",
              "name": "updatedBy",
              "plural": false,
              "selections": v6,
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "assignedOn",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "assignedToEmail",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountsAdminUser",
              "kind": "LinkedField",
              "name": "assignedTo",
              "plural": false,
              "selections": [
                v23,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "firstName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "emailAddress",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "employerId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "employerName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "projectId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "projectName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "vacancyId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "vacancyName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "VacancyQualityAssuranceNote",
              "kind": "LinkedField",
              "name": "notes",
              "plural": true,
              "selections": [
                v23,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "vacancyQualityAssuranceNoteId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "createdOn",
                  "storageKey": null
                },
                v7,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "content",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isPositive",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v5
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "807627604202b798a5a0bc720a07e1c8",
      "id": null,
      "metadata": {},
      "name": "VacancyQualityAssuranceRouteQuery",
      "operationKind": "query",
      "text": "query VacancyQualityAssuranceRouteQuery(\n  $qaCode: Int!\n) {\n  assurance: recruitVacancyQualityAssuranceByCode(code: $qaCode) {\n    id\n    vacancyQualityAssuranceId\n    code\n    ...VacancyQualityAssuranceDetails_assure\n  }\n}\n\nfragment VacancyQualityAssuranceAddNote_assure on VacancyQualityAssurance {\n  id\n  vacancyQualityAssuranceId\n  code\n  version\n  createdAt\n  createdBy {\n    id\n    accountType\n  }\n  updatedAt\n  updatedBy {\n    id\n    accountType\n  }\n  assignedOn\n  assignedToEmail\n  assignedTo {\n    id\n    firstName\n    lastName\n    emailAddress\n  }\n  employerId\n  employerName\n  projectId\n  projectName\n  vacancyId\n  vacancyName\n  status\n  notes {\n    id\n    vacancyQualityAssuranceNoteId\n    createdOn\n    createdBy {\n      id\n      accountType\n    }\n    content\n    isPositive\n  }\n}\n\nfragment VacancyQualityAssuranceAssign_assure on VacancyQualityAssurance {\n  id\n  vacancyQualityAssuranceId\n  code\n  version\n  createdAt\n  createdBy {\n    id\n    accountType\n  }\n  updatedAt\n  updatedBy {\n    id\n    accountType\n  }\n  assignedOn\n  assignedToEmail\n  assignedTo {\n    id\n    firstName\n    lastName\n    emailAddress\n  }\n  employerId\n  employerName\n  projectId\n  projectName\n  vacancyId\n  vacancyName\n  status\n  notes {\n    id\n    vacancyQualityAssuranceNoteId\n    createdOn\n    createdBy {\n      id\n      accountType\n    }\n    content\n    isPositive\n  }\n}\n\nfragment VacancyQualityAssuranceDetails_assure on VacancyQualityAssurance {\n  id\n  vacancyQualityAssuranceId\n  code\n  version\n  createdAt\n  createdBy {\n    id\n    accountType\n  }\n  updatedAt\n  updatedBy {\n    id\n    accountType\n  }\n  assignedOn\n  assignedToEmail\n  assignedTo {\n    id\n    firstName\n    lastName\n    emailAddress\n  }\n  employerId\n  employerName\n  projectId\n  projectName\n  vacancyId\n  vacancyName\n  status\n  notes {\n    id\n    vacancyQualityAssuranceNoteId\n    createdOn\n    createdBy {\n      id\n      accountType\n    }\n    content\n    isPositive\n  }\n  ...VacancyQualityAssuranceAssign_assure\n  ...VacancyQualityAssuranceNotesList_assure\n  ...VacancyQualityAssuranceAddNote_assure\n  ...VacancyQualityAssuranceEditNote_assure\n}\n\nfragment VacancyQualityAssuranceEditNote_assure on VacancyQualityAssurance {\n  id\n  vacancyQualityAssuranceId\n  code\n  version\n  createdAt\n  createdBy {\n    id\n    accountType\n  }\n  updatedAt\n  updatedBy {\n    id\n    accountType\n  }\n  assignedOn\n  assignedToEmail\n  assignedTo {\n    id\n    firstName\n    lastName\n    emailAddress\n  }\n  employerId\n  employerName\n  projectId\n  projectName\n  vacancyId\n  vacancyName\n  status\n  notes {\n    id\n    vacancyQualityAssuranceNoteId\n    createdOn\n    createdBy {\n      id\n      accountType\n    }\n    content\n    isPositive\n  }\n}\n\nfragment VacancyQualityAssuranceNotesList_assure on VacancyQualityAssurance {\n  id\n  vacancyQualityAssuranceId\n  code\n  version\n  createdAt\n  createdBy {\n    id\n    accountType\n  }\n  updatedAt\n  updatedBy {\n    id\n    accountType\n  }\n  assignedOn\n  assignedToEmail\n  assignedTo {\n    id\n    firstName\n    lastName\n    emailAddress\n  }\n  employerId\n  employerName\n  projectId\n  projectName\n  vacancyId\n  vacancyName\n  status\n  notes {\n    id\n    vacancyQualityAssuranceNoteId\n    createdOn\n    createdBy {\n      id\n      accountType\n    }\n    content\n    isPositive\n  }\n}\n"
    }
  };
}();
node551.hash = "b91500f43a0081756435be393ab8309f";
var VacancyQualityAssuranceRouteQuery_graphql_default = node551;

// src/vacancy-qa/components/VacancyQualityAssuranceRoute.tsx
import {
  loadQuery as loadQuery47,
  usePreloadedQuery as usePreloadedQuery49
} from "react-relay";
import {
  Navigate as Navigate16,
  useRouteLoaderData as useRouteLoaderData19
} from "react-router-dom";
import { EdSkeleton as EdSkeleton123 } from "shared-ui";
import { OutletRoute as OutletRoute6 } from "app-core";

// src/vacancy-qa/components/__generated__/VacancyQualityAssuranceDetails_assure.graphql.ts
var node553 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v1 = [
    v0,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountType",
      "storageKey": null
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "concreteType": "AccountId",
    "kind": "LinkedField",
    "name": "createdBy",
    "plural": false,
    "selections": v1,
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "VacancyQualityAssuranceDetails_assure",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "vacancyQualityAssuranceId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "version",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      },
      v23,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountId",
        "kind": "LinkedField",
        "name": "updatedBy",
        "plural": false,
        "selections": v1,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assignedOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assignedToEmail",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsAdminUser",
        "kind": "LinkedField",
        "name": "assignedTo",
        "plural": false,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailAddress",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "employerId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "employerName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "projectId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "projectName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "vacancyId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "vacancyName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "VacancyQualityAssuranceNote",
        "kind": "LinkedField",
        "name": "notes",
        "plural": true,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vacancyQualityAssuranceNoteId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdOn",
            "storageKey": null
          },
          v23,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "content",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isPositive",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "VacancyQualityAssuranceAssign_assure"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "VacancyQualityAssuranceNotesList_assure"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "VacancyQualityAssuranceAddNote_assure"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "VacancyQualityAssuranceEditNote_assure"
      }
    ],
    "type": "VacancyQualityAssurance",
    "abstractKey": null
  };
}();
node553.hash = "61176c59422b507c0f64fcc1d7abdfee";
var VacancyQualityAssuranceDetails_assure_graphql_default = node553;

// src/vacancy-qa/components/VacancyQualityAssuranceDetails.tsx
import { useCallback as useCallback264, useState as useState138 } from "react";
import { useFragment as useFragment160 } from "react-relay";
import { useToggle as useToggle50 } from "shared-lib";
import { Button as Button137, PageHeader as PageHeader4, Size as Size61 } from "shared-ui";

// src/vacancy-qa/components/__generated__/VacancyQualityAssuranceNotesList_assure.graphql.ts
var node554 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v1 = [
    v0,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountType",
      "storageKey": null
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "concreteType": "AccountId",
    "kind": "LinkedField",
    "name": "createdBy",
    "plural": false,
    "selections": v1,
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "VacancyQualityAssuranceNotesList_assure",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "vacancyQualityAssuranceId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "version",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      },
      v23,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountId",
        "kind": "LinkedField",
        "name": "updatedBy",
        "plural": false,
        "selections": v1,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assignedOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assignedToEmail",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsAdminUser",
        "kind": "LinkedField",
        "name": "assignedTo",
        "plural": false,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailAddress",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "employerId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "employerName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "projectId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "projectName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "vacancyId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "vacancyName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "VacancyQualityAssuranceNote",
        "kind": "LinkedField",
        "name": "notes",
        "plural": true,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vacancyQualityAssuranceNoteId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdOn",
            "storageKey": null
          },
          v23,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "content",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isPositive",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "VacancyQualityAssurance",
    "abstractKey": null
  };
}();
node554.hash = "73b7b65a369766d23a79aba881da0ec5";
var VacancyQualityAssuranceNotesList_assure_graphql_default = node554;

// src/vacancy-qa/components/VacancyQualityAssuranceNotesList.tsx
import { useCallback as useCallback259 } from "react";
import { useFragment as useFragment156 } from "react-relay";
import { timeAgo as timeAgo12 } from "shared-lib";
import { jsx as jsx469, jsxs as jsxs319 } from "react/jsx-runtime";
var fragmentDef116 = VacancyQualityAssuranceNotesList_assure_graphql_default;
var NoteItem = ({ note, onSelect }) => {
  const onClick = useCallback259(() => {
    onSelect(note);
  }, [note, onSelect]);
  return /* @__PURE__ */ jsxs319("div", { className: "flex flex-col gap-2 p-4", onClick, children: [
    /* @__PURE__ */ jsxs319("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ jsx469("div", { className: "text-sm text-gray-500", children: timeAgo12(note.createdOn) }),
      /* @__PURE__ */ jsx469("div", { className: "text-sm", children: note.isPositive ? /* @__PURE__ */ jsx469("span", { className: "font-medium text-green-500", children: "Positive" }) : /* @__PURE__ */ jsx469("span", { className: "font-medium text-red-500", children: "Negative" }) })
    ] }),
    /* @__PURE__ */ jsx469("div", { className: "text-gray-900", children: note.content })
  ] });
};
var VacancyQualityAssuranceNotesList = ({
  fragmentRef,
  onSelect
}) => {
  const assurance = useFragment156(
    fragmentDef116,
    fragmentRef
  );
  if (assurance.notes.length === 0) {
    return /* @__PURE__ */ jsx469("div", { className: "text-primary-500 py-2 font-bold", children: "No notes added yet" });
  }
  const notesList = assurance.notes.map((n3) => {
    return /* @__PURE__ */ jsx469(NoteItem, { note: n3, onSelect }, n3.id);
  });
  return /* @__PURE__ */ jsx469("div", { className: "flex flex-1 flex-col gap-2", children: /* @__PURE__ */ jsx469("div", { className: "flex flex-col gap-2 divide-y p-4", children: notesList }) });
};

// src/vacancy-qa/components/__generated__/VacancyQualityAssuranceAddNote_assure.graphql.ts
var node555 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v1 = [
    v0,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountType",
      "storageKey": null
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "concreteType": "AccountId",
    "kind": "LinkedField",
    "name": "createdBy",
    "plural": false,
    "selections": v1,
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "VacancyQualityAssuranceAddNote_assure",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "vacancyQualityAssuranceId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "version",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      },
      v23,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountId",
        "kind": "LinkedField",
        "name": "updatedBy",
        "plural": false,
        "selections": v1,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assignedOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assignedToEmail",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsAdminUser",
        "kind": "LinkedField",
        "name": "assignedTo",
        "plural": false,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailAddress",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "employerId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "employerName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "projectId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "projectName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "vacancyId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "vacancyName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "VacancyQualityAssuranceNote",
        "kind": "LinkedField",
        "name": "notes",
        "plural": true,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vacancyQualityAssuranceNoteId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdOn",
            "storageKey": null
          },
          v23,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "content",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isPositive",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "VacancyQualityAssurance",
    "abstractKey": null
  };
}();
node555.hash = "24e238a822bc5279ef9f468ba0d37f69";
var VacancyQualityAssuranceAddNote_assure_graphql_default = node555;

// src/vacancy-qa/components/VacancyQualityAssuranceAddNote.tsx
import { useCallback as useCallback261 } from "react";
import { ConnectionHandler as ConnectionHandler13, useFragment as useFragment157 } from "react-relay";
import { createClientMutationId as createClientMutationId111 } from "shared-lib";

// src/vacancy-qa/mutations/__generated__/UseVacancyQualityAssuranceAddNoteMutation.graphql.ts
var node556 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }, v23 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v5 = [
    v32,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountType",
      "storageKey": null
    }
  ], v6 = {
    "alias": null,
    "args": null,
    "concreteType": "AccountId",
    "kind": "LinkedField",
    "name": "createdBy",
    "plural": false,
    "selections": v5,
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfVacancyQualityAssurance",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "VacancyQualityAssurance",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          v32,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vacancyQualityAssuranceId",
            "storageKey": null
          },
          v4,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "version",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          v6,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountId",
            "kind": "LinkedField",
            "name": "updatedBy",
            "plural": false,
            "selections": v5,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "assignedOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "assignedToEmail",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountsAdminUser",
            "kind": "LinkedField",
            "name": "assignedTo",
            "plural": false,
            "selections": [
              v32,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "emailAddress",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "projectId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "projectName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vacancyId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vacancyName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VacancyQualityAssuranceNote",
            "kind": "LinkedField",
            "name": "notes",
            "plural": true,
            "selections": [
              v32,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vacancyQualityAssuranceNoteId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdOn",
                "storageKey": null
              },
              v6,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "content",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isPositive",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v8 = {
    "kind": "InlineFragment",
    "selections": [
      v4,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "UseVacancyQualityAssuranceAddNoteMutation",
      "selections": [
        {
          "alias": "data",
          "args": v23,
          "concreteType": "RecruitVacancyQualityAssuranceAddNotePayload",
          "kind": "LinkedField",
          "name": "recruitVacancyQualityAssuranceAddNote",
          "plural": false,
          "selections": [
            v7,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v8
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "UseVacancyQualityAssuranceAddNoteMutation",
      "selections": [
        {
          "alias": "data",
          "args": v23,
          "concreteType": "RecruitVacancyQualityAssuranceAddNotePayload",
          "kind": "LinkedField",
          "name": "recruitVacancyQualityAssuranceAddNote",
          "plural": false,
          "selections": [
            v7,
            {
              "alias": null,
              "args": null,
              "filters": null,
              "handle": "appendEdge",
              "key": "",
              "kind": "LinkedHandle",
              "name": "payload",
              "handleArgs": [
                {
                  "kind": "Variable",
                  "name": "connections",
                  "variableName": "connections"
                }
              ]
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v8
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "accd3ff5d10fdbdf7b3a95df66743525",
      "id": null,
      "metadata": {},
      "name": "UseVacancyQualityAssuranceAddNoteMutation",
      "operationKind": "mutation",
      "text": "mutation UseVacancyQualityAssuranceAddNoteMutation(\n  $input: RecruitVacancyQualityAssuranceAddNoteInput!\n) {\n  data: recruitVacancyQualityAssuranceAddNote(input: $input) {\n    payload {\n      cursor\n      node {\n        id\n        vacancyQualityAssuranceId\n        code\n        version\n        createdAt\n        createdBy {\n          id\n          accountType\n        }\n        updatedAt\n        updatedBy {\n          id\n          accountType\n        }\n        assignedOn\n        assignedToEmail\n        assignedTo {\n          id\n          firstName\n          lastName\n          emailAddress\n        }\n        employerId\n        employerName\n        projectId\n        projectName\n        vacancyId\n        vacancyName\n        status\n        notes {\n          id\n          vacancyQualityAssuranceNoteId\n          createdOn\n          createdBy {\n            id\n            accountType\n          }\n          content\n          isPositive\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node556.hash = "04b095f0b7b143770bb93aa96a801f46";
var UseVacancyQualityAssuranceAddNoteMutation_graphql_default = node556;

// src/vacancy-qa/mutations/UseVacancyQualityAssuranceAddNote.ts
import { useAsyncMutation as useAsyncMutation87 } from "shared-lib";
var mutationDef106 = UseVacancyQualityAssuranceAddNoteMutation_graphql_default;
function useVacancyQualityAssuranceAddNote() {
  const [commit11, isBusy] = useAsyncMutation87(mutationDef106);
  return [commit11, isBusy];
}

// src/vacancy-qa/mutations/__generated__/UseVacancyQualityAssuranceAssignMutation.graphql.ts
var node557 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }, v23 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v5 = [
    v32,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountType",
      "storageKey": null
    }
  ], v6 = {
    "alias": null,
    "args": null,
    "concreteType": "AccountId",
    "kind": "LinkedField",
    "name": "createdBy",
    "plural": false,
    "selections": v5,
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfVacancyQualityAssurance",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "VacancyQualityAssurance",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          v32,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vacancyQualityAssuranceId",
            "storageKey": null
          },
          v4,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "version",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          v6,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountId",
            "kind": "LinkedField",
            "name": "updatedBy",
            "plural": false,
            "selections": v5,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "assignedOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "assignedToEmail",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountsAdminUser",
            "kind": "LinkedField",
            "name": "assignedTo",
            "plural": false,
            "selections": [
              v32,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "emailAddress",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "projectId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "projectName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vacancyId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vacancyName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VacancyQualityAssuranceNote",
            "kind": "LinkedField",
            "name": "notes",
            "plural": true,
            "selections": [
              v32,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vacancyQualityAssuranceNoteId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdOn",
                "storageKey": null
              },
              v6,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "content",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isPositive",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v8 = {
    "kind": "InlineFragment",
    "selections": [
      v4,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "UseVacancyQualityAssuranceAssignMutation",
      "selections": [
        {
          "alias": "data",
          "args": v23,
          "concreteType": "RecruitVacancyQualityAssuranceAssignPayload",
          "kind": "LinkedField",
          "name": "recruitVacancyQualityAssuranceAssign",
          "plural": false,
          "selections": [
            v7,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v8
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "UseVacancyQualityAssuranceAssignMutation",
      "selections": [
        {
          "alias": "data",
          "args": v23,
          "concreteType": "RecruitVacancyQualityAssuranceAssignPayload",
          "kind": "LinkedField",
          "name": "recruitVacancyQualityAssuranceAssign",
          "plural": false,
          "selections": [
            v7,
            {
              "alias": null,
              "args": null,
              "filters": null,
              "handle": "appendEdge",
              "key": "",
              "kind": "LinkedHandle",
              "name": "payload",
              "handleArgs": [
                {
                  "kind": "Variable",
                  "name": "connections",
                  "variableName": "connections"
                }
              ]
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v8
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "9447835acfe6fe66ced589b9383197fd",
      "id": null,
      "metadata": {},
      "name": "UseVacancyQualityAssuranceAssignMutation",
      "operationKind": "mutation",
      "text": "mutation UseVacancyQualityAssuranceAssignMutation(\n  $input: RecruitVacancyQualityAssuranceAssignInput!\n) {\n  data: recruitVacancyQualityAssuranceAssign(input: $input) {\n    payload {\n      cursor\n      node {\n        id\n        vacancyQualityAssuranceId\n        code\n        version\n        createdAt\n        createdBy {\n          id\n          accountType\n        }\n        updatedAt\n        updatedBy {\n          id\n          accountType\n        }\n        assignedOn\n        assignedToEmail\n        assignedTo {\n          id\n          firstName\n          lastName\n          emailAddress\n        }\n        employerId\n        employerName\n        projectId\n        projectName\n        vacancyId\n        vacancyName\n        status\n        notes {\n          id\n          vacancyQualityAssuranceNoteId\n          createdOn\n          createdBy {\n            id\n            accountType\n          }\n          content\n          isPositive\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node557.hash = "40d71e01d877cd334b5fcec500e5f30a";
var UseVacancyQualityAssuranceAssignMutation_graphql_default = node557;

// src/vacancy-qa/mutations/UseVacancyQualityAssuranceAssign.ts
import { useAsyncMutation as useAsyncMutation88 } from "shared-lib";
var mutationDef107 = UseVacancyQualityAssuranceAssignMutation_graphql_default;
function useVacancyQualityAssuranceAssign() {
  const [commit11, isBusy] = useAsyncMutation88(mutationDef107);
  return [commit11, isBusy];
}

// src/vacancy-qa/mutations/__generated__/UseVacancyQualityAssuranceRemoveNoteMutation.graphql.ts
var node558 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }, v23 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "cursor",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v5 = {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "UseVacancyQualityAssuranceRemoveNoteMutation",
      "selections": [
        {
          "alias": "data",
          "args": v23,
          "concreteType": "RecruitVacancyQualityAssuranceRemoveNotePayload",
          "kind": "LinkedField",
          "name": "recruitVacancyQualityAssuranceRemoveNote",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfVacancyQualityAssurance",
              "kind": "LinkedField",
              "name": "payload",
              "plural": false,
              "selections": [
                v32,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "VacancyQualityAssurance",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v4
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "UseVacancyQualityAssuranceRemoveNoteMutation",
      "selections": [
        {
          "alias": "data",
          "args": v23,
          "concreteType": "RecruitVacancyQualityAssuranceRemoveNotePayload",
          "kind": "LinkedField",
          "name": "recruitVacancyQualityAssuranceRemoveNote",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfVacancyQualityAssurance",
              "kind": "LinkedField",
              "name": "payload",
              "plural": false,
              "selections": [
                v32,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "VacancyQualityAssurance",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v4,
                    {
                      "alias": null,
                      "args": null,
                      "filters": null,
                      "handle": "deleteEdge",
                      "key": "",
                      "kind": "ScalarHandle",
                      "name": "id",
                      "handleArgs": [
                        {
                          "kind": "Variable",
                          "name": "connections",
                          "variableName": "connections"
                        }
                      ]
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "033dd8698e930ddaf09652531205a722",
      "id": null,
      "metadata": {},
      "name": "UseVacancyQualityAssuranceRemoveNoteMutation",
      "operationKind": "mutation",
      "text": "mutation UseVacancyQualityAssuranceRemoveNoteMutation(\n  $input: RecruitVacancyQualityAssuranceRemoveNoteInput!\n) {\n  data: recruitVacancyQualityAssuranceRemoveNote(input: $input) {\n    payload {\n      cursor\n      node {\n        id\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node558.hash = "a3236a5688888a89b8f031363e5fcac3";
var UseVacancyQualityAssuranceRemoveNoteMutation_graphql_default = node558;

// src/vacancy-qa/mutations/UseVacancyQualityAssuranceRemoveNote.ts
import { useAsyncMutation as useAsyncMutation89 } from "shared-lib";
var mutationDef108 = UseVacancyQualityAssuranceRemoveNoteMutation_graphql_default;
function useVacancyQualityAssuranceRemoveNote() {
  const [commit11, isBusy] = useAsyncMutation89(mutationDef108);
  return [commit11, isBusy];
}

// src/vacancy-qa/mutations/__generated__/UseVacancyQualityAssuranceUpdateNoteMutation.graphql.ts
var node559 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = [
    v23,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountType",
      "storageKey": null
    }
  ], v5 = {
    "alias": null,
    "args": null,
    "concreteType": "AccountId",
    "kind": "LinkedField",
    "name": "createdBy",
    "plural": false,
    "selections": v4,
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfVacancyQualityAssurance",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "VacancyQualityAssurance",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          v23,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vacancyQualityAssuranceId",
            "storageKey": null
          },
          v32,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "version",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          v5,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountId",
            "kind": "LinkedField",
            "name": "updatedBy",
            "plural": false,
            "selections": v4,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "assignedOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "assignedToEmail",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountsAdminUser",
            "kind": "LinkedField",
            "name": "assignedTo",
            "plural": false,
            "selections": [
              v23,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "emailAddress",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "projectId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "projectName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vacancyId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vacancyName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VacancyQualityAssuranceNote",
            "kind": "LinkedField",
            "name": "notes",
            "plural": true,
            "selections": [
              v23,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vacancyQualityAssuranceNoteId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdOn",
                "storageKey": null
              },
              v5,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "content",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isPositive",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v7 = {
    "kind": "InlineFragment",
    "selections": [
      v32,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseVacancyQualityAssuranceUpdateNoteMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitVacancyQualityAssuranceUpdateNotePayload",
          "kind": "LinkedField",
          "name": "recruitVacancyQualityAssuranceUpdateNote",
          "plural": false,
          "selections": [
            v6,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v7
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseVacancyQualityAssuranceUpdateNoteMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RecruitVacancyQualityAssuranceUpdateNotePayload",
          "kind": "LinkedField",
          "name": "recruitVacancyQualityAssuranceUpdateNote",
          "plural": false,
          "selections": [
            v6,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v7
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "f45b01795249b78abdb2030637c1200d",
      "id": null,
      "metadata": {},
      "name": "UseVacancyQualityAssuranceUpdateNoteMutation",
      "operationKind": "mutation",
      "text": "mutation UseVacancyQualityAssuranceUpdateNoteMutation(\n  $input: RecruitVacancyQualityAssuranceUpdateNoteInput!\n) {\n  data: recruitVacancyQualityAssuranceUpdateNote(input: $input) {\n    payload {\n      cursor\n      node {\n        id\n        vacancyQualityAssuranceId\n        code\n        version\n        createdAt\n        createdBy {\n          id\n          accountType\n        }\n        updatedAt\n        updatedBy {\n          id\n          accountType\n        }\n        assignedOn\n        assignedToEmail\n        assignedTo {\n          id\n          firstName\n          lastName\n          emailAddress\n        }\n        employerId\n        employerName\n        projectId\n        projectName\n        vacancyId\n        vacancyName\n        status\n        notes {\n          id\n          vacancyQualityAssuranceNoteId\n          createdOn\n          createdBy {\n            id\n            accountType\n          }\n          content\n          isPositive\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node559.hash = "1b0656f9c6f1031ebc7778050f310983";
var UseVacancyQualityAssuranceUpdateNoteMutation_graphql_default = node559;

// src/vacancy-qa/mutations/UseVacancyQualityAssuranceUpdateNote.ts
import { useAsyncMutation as useAsyncMutation90 } from "shared-lib";
var mutationDef109 = UseVacancyQualityAssuranceUpdateNoteMutation_graphql_default;
function useVacancyQualityAssuranceUpdateNote() {
  const [commit11, isBusy] = useAsyncMutation90(mutationDef109);
  return [commit11, isBusy];
}

// src/vacancy-qa/components/VacancyQualityAssuranceNoteEditor.tsx
import { useCallback as useCallback260, useState as useState136 } from "react";
import { Button as Button134, ButtonList as ButtonList49, CheckBox as CheckBox6, TextArea as TextArea10 } from "shared-ui";
import { jsx as jsx470, jsxs as jsxs320 } from "react/jsx-runtime";
var VacancyQualityAssuranceNoteEditor = ({
  data,
  saveText,
  onSaved,
  onCancel
}) => {
  const [noteContent, setNoteContent] = useState136(() => {
    if (!data) {
      return null;
    }
    return data.content;
  });
  const onUpdateNoteContent = useCallback260(
    (value) => {
      setNoteContent(value);
    },
    [setNoteContent]
  );
  const onClearNoteContent = useCallback260(() => {
    setNoteContent(null);
  }, [setNoteContent]);
  const [isPositive, setIsPositive] = useState136(() => {
    if (!data) {
      return true;
    }
    return data.isPositive;
  });
  const onToggleIsPositive = useCallback260(() => {
    setIsPositive(!isPositive);
  }, [isPositive, setIsPositive]);
  const onSave = useCallback260(() => {
    if (!noteContent || noteContent === "") {
      return;
    }
    const data2 = {
      content: noteContent,
      isPositive
    };
    onSaved(data2);
  }, [onSaved, noteContent, isPositive]);
  return /* @__PURE__ */ jsxs320("div", { className: "flex flex-col gap-4", children: [
    /* @__PURE__ */ jsx470("div", { className: "flex items-center gap-2", children: /* @__PURE__ */ jsx470(
      TextArea10,
      {
        placeholder: " Note Content ",
        name: "noteName",
        rows: 4,
        value: noteContent || "",
        onValueChange: onUpdateNoteContent
      },
      "noteName"
    ) }),
    /* @__PURE__ */ jsx470("div", { className: "flex items-center py-2", children: /* @__PURE__ */ jsx470(
      CheckBox6,
      {
        checked: isPositive,
        title: /* @__PURE__ */ jsx470("span", { children: "Positive" }),
        onChanged: onToggleIsPositive
      }
    ) }),
    /* @__PURE__ */ jsx470("div", { className: "flex items-center gap-2 border-t py-4", children: /* @__PURE__ */ jsxs320(ButtonList49, { children: [
      /* @__PURE__ */ jsx470(Button134, { color: "primary", disabled: !noteContent, clicked: onSave, children: saveText }),
      /* @__PURE__ */ jsx470(
        Button134,
        {
          color: "gray",
          disabled: !noteContent,
          clicked: onClearNoteContent,
          children: "Clear"
        }
      ),
      onCancel && /* @__PURE__ */ jsx470(Button134, { color: "gray", disabled: !noteContent, clicked: onCancel, children: "Cancel" })
    ] }) })
  ] });
};

// src/vacancy-qa/components/VacancyQualityAssuranceAddNote.tsx
import { jsx as jsx471 } from "react/jsx-runtime";
var fragmentDef117 = VacancyQualityAssuranceAddNote_assure_graphql_default;
var VacancyQualityAssuranceAddNote = ({
  fragmentRef,
  onCreated,
  onCancel
}) => {
  const assurance = useFragment157(
    fragmentDef117,
    fragmentRef
  );
  const connectionId = ConnectionHandler13.getConnectionID(
    "root",
    "VacancyQualityAssuranceListContainer_list"
  );
  const [addNote, isAddingNote] = useVacancyQualityAssuranceAddNote();
  const onCreateNote = useCallback261(
    async (data) => {
      if (!data.content || data.content === "") {
        return;
      }
      const input = {
        clientMutationId: createClientMutationId111(),
        id: assurance.vacancyQualityAssuranceId,
        version: assurance.version,
        content: data.content,
        isPositive: data.isPositive
      };
      const response = await addNote({ input, connections: [connectionId] });
      if (response.data.payload) {
        onCreated();
      }
    },
    [assurance, addNote, onCreated]
  );
  return /* @__PURE__ */ jsx471("div", { className: "p-4", children: /* @__PURE__ */ jsx471(
    VacancyQualityAssuranceNoteEditor,
    {
      saveText: "Create",
      onSaved: onCreateNote,
      onCancel
    }
  ) });
};

// src/vacancy-qa/components/__generated__/VacancyQualityAssuranceEditNote_assure.graphql.ts
var node560 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v1 = [
    v0,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountType",
      "storageKey": null
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "concreteType": "AccountId",
    "kind": "LinkedField",
    "name": "createdBy",
    "plural": false,
    "selections": v1,
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "VacancyQualityAssuranceEditNote_assure",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "vacancyQualityAssuranceId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "version",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      },
      v23,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountId",
        "kind": "LinkedField",
        "name": "updatedBy",
        "plural": false,
        "selections": v1,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assignedOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assignedToEmail",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsAdminUser",
        "kind": "LinkedField",
        "name": "assignedTo",
        "plural": false,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailAddress",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "employerId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "employerName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "projectId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "projectName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "vacancyId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "vacancyName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "VacancyQualityAssuranceNote",
        "kind": "LinkedField",
        "name": "notes",
        "plural": true,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vacancyQualityAssuranceNoteId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdOn",
            "storageKey": null
          },
          v23,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "content",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isPositive",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "VacancyQualityAssurance",
    "abstractKey": null
  };
}();
node560.hash = "8903900c47902f3605f1e025a6e10b60";
var VacancyQualityAssuranceEditNote_assure_graphql_default = node560;

// src/vacancy-qa/components/VacancyQualityAssuranceEditNote.tsx
import { useCallback as useCallback262 } from "react";
import { ConnectionHandler as ConnectionHandler14, useFragment as useFragment158 } from "react-relay";
import { createClientMutationId as createClientMutationId113, timeAgo as timeAgo13 } from "shared-lib";
import { Button as Button135 } from "shared-ui";
import { jsx as jsx473, jsxs as jsxs321 } from "react/jsx-runtime";
var fragmentDef118 = VacancyQualityAssuranceEditNote_assure_graphql_default;
var VacancyQualityAssuranceEditNote = ({
  fragmentRef,
  noteId,
  onChanged,
  onCancel
}) => {
  const assurance = useFragment158(
    fragmentDef118,
    fragmentRef
  );
  const note = assurance.notes.find((n3) => n3.id === noteId);
  const [editNote] = useVacancyQualityAssuranceUpdateNote();
  const onSaveNote = useCallback262(
    async (data) => {
      if (!data.content || data.content === "") {
        return;
      }
      const input = {
        clientMutationId: createClientMutationId113(),
        id: assurance.vacancyQualityAssuranceId,
        noteId,
        version: assurance.version,
        content: data.content,
        isPositive: data.isPositive
      };
      const response = await editNote({ input });
      if (response.data.payload) {
        onChanged();
      }
    },
    [assurance, editNote, onChanged]
  );
  const connectionId = ConnectionHandler14.getConnectionID(
    "root",
    "VacancyQualityAssuranceListContainer_list"
  );
  const [removeNote, isRemovingNote] = useVacancyQualityAssuranceRemoveNote();
  const onDeleteNote = useCallback262(async () => {
    const input = {
      clientMutationId: createClientMutationId113(),
      id: assurance.vacancyQualityAssuranceId,
      noteId,
      version: assurance.version
    };
    const response = await removeNote({ input, connections: [connectionId] });
    if (response.data.payload) {
      onChanged();
    }
  }, [assurance, editNote, onChanged]);
  if (!note) {
    return /* @__PURE__ */ jsx473("div", { className: "p-4", children: /* @__PURE__ */ jsx473("div", { className: "text-warning-500 text-xl", children: "Note not found!" }) });
  }
  return /* @__PURE__ */ jsxs321("div", { className: "p-4", children: [
    /* @__PURE__ */ jsxs321("div", { className: "flex items-center justify-between gap-2 border-b py-2", children: [
      /* @__PURE__ */ jsx473("div", { className: "flex items-center gap-2", children: /* @__PURE__ */ jsx473("div", { className: "text-sm text-gray-500", children: timeAgo13(note.createdOn) }) }),
      /* @__PURE__ */ jsx473("div", { className: "p-4", children: /* @__PURE__ */ jsx473(
        Button135,
        {
          color: "danger",
          disabled: isRemovingNote,
          confirmMessage: "Are you sure ?",
          clicked: onDeleteNote,
          children: "Delete Note"
        }
      ) })
    ] }),
    /* @__PURE__ */ jsx473(
      VacancyQualityAssuranceNoteEditor,
      {
        saveText: "Update",
        data: note,
        onSaved: onSaveNote,
        onCancel
      }
    )
  ] });
};

// src/vacancy-qa/components/__generated__/VacancyQualityAssuranceAssign_assure.graphql.ts
var node561 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v1 = [
    v0,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountType",
      "storageKey": null
    }
  ], v23 = {
    "alias": null,
    "args": null,
    "concreteType": "AccountId",
    "kind": "LinkedField",
    "name": "createdBy",
    "plural": false,
    "selections": v1,
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "VacancyQualityAssuranceAssign_assure",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "vacancyQualityAssuranceId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "version",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      },
      v23,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountId",
        "kind": "LinkedField",
        "name": "updatedBy",
        "plural": false,
        "selections": v1,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assignedOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assignedToEmail",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountsAdminUser",
        "kind": "LinkedField",
        "name": "assignedTo",
        "plural": false,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailAddress",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "employerId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "employerName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "projectId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "projectName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "vacancyId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "vacancyName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "VacancyQualityAssuranceNote",
        "kind": "LinkedField",
        "name": "notes",
        "plural": true,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vacancyQualityAssuranceNoteId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdOn",
            "storageKey": null
          },
          v23,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "content",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isPositive",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "VacancyQualityAssurance",
    "abstractKey": null
  };
}();
node561.hash = "37215cbc896b19e4a3f5359fd83100c3";
var VacancyQualityAssuranceAssign_assure_graphql_default = node561;

// src/vacancy-qa/components/VacancyQualityAssuranceAssign.tsx
import { useCallback as useCallback263, useState as useState137 } from "react";
import { ConnectionHandler as ConnectionHandler15, useFragment as useFragment159 } from "react-relay";
import { createClientMutationId as createClientMutationId114 } from "shared-lib";
import { Button as Button136, ButtonList as ButtonList50, Size as Size60 } from "shared-ui";
import { AdminUserSearchBoxContainer } from "app-core";
import { jsx as jsx474, jsxs as jsxs322 } from "react/jsx-runtime";
var fragmentDef119 = VacancyQualityAssuranceAssign_assure_graphql_default;
var VacancyQualityAssuranceAssign = ({
  fragmentRef,
  onAssigned,
  onCancel
}) => {
  const assurance = useFragment159(
    fragmentDef119,
    fragmentRef
  );
  const connectionId = ConnectionHandler15.getConnectionID(
    "root",
    "VacancyQualityAssuranceListContainer_list"
  );
  const [assign2, isAssigning] = useVacancyQualityAssuranceAssign();
  const [assignedTo, setAssignedTo] = useState137();
  const onAssign = useCallback263(async () => {
    if (!assignedTo) {
      return;
    }
    const input = {
      clientMutationId: createClientMutationId114(),
      id: assurance.vacancyQualityAssuranceId,
      version: assurance.version,
      assignedToId: assignedTo.accountId
    };
    const response = await assign2({ input, connections: [connectionId] });
    if (response.data.payload) {
      onAssigned();
    }
  }, [assurance, assign2, isAssigning, onAssigned]);
  return /* @__PURE__ */ jsxs322("div", { className: "flex flex-col gap-2", children: [
    /* @__PURE__ */ jsx474("div", { className: "flex flex-col gap-2", children: /* @__PURE__ */ jsx474(AdminUserSearchBoxContainer, { onSearchCompleted: setAssignedTo }) }),
    /* @__PURE__ */ jsx474("div", { className: "flex flex-col gap-2", children: /* @__PURE__ */ jsxs322(ButtonList50, { children: [
      /* @__PURE__ */ jsx474(
        Button136,
        {
          color: "primary",
          size: Size60.lg,
          disabled: isAssigning || !assignedTo,
          clicked: onAssign,
          children: "Assign"
        }
      ),
      /* @__PURE__ */ jsx474(
        Button136,
        {
          color: "gray",
          size: Size60.lg,
          disabled: isAssigning,
          clicked: onCancel,
          children: "Cancel"
        }
      )
    ] }) })
  ] });
};

// src/vacancy-qa/components/VacancyQualityAssuranceDetails.tsx
import { jsx as jsx475, jsxs as jsxs323 } from "react/jsx-runtime";
var fragmentDef120 = VacancyQualityAssuranceDetails_assure_graphql_default;
var Header2 = ({ fragmentRef, onAssign }) => {
  const assurance = useFragment160(
    fragmentDef120,
    fragmentRef
  );
  return /* @__PURE__ */ jsxs323("div", { className: "flex flex-col gap-2", children: [
    /* @__PURE__ */ jsx475(PageHeader4, { children: assurance.vacancyName }),
    /* @__PURE__ */ jsx475("div", { className: "flex flex-col gap-2 p-4", children: /* @__PURE__ */ jsxs323("div", { className: "flex items-center gap-3", children: [
      /* @__PURE__ */ jsx475("div", { className: "text-gray-500", children: "Assigned" }),
      assurance.assignedTo ? /* @__PURE__ */ jsx475("div", { className: "text-primary-500", children: assurance.assignedTo.emailAddress }) : /* @__PURE__ */ jsx475("div", { className: "text-primary-500", children: "Not Assigned" }),
      /* @__PURE__ */ jsx475("div", { children: /* @__PURE__ */ jsx475(Button137, { color: "primary", size: Size61.sm, clicked: onAssign, children: "Assign" }) })
    ] }) })
  ] });
};
var VacancyQualityAssuranceDetails = ({ fragmentRef }) => {
  const assurance = useFragment160(
    fragmentDef120,
    fragmentRef
  );
  const [isAdding, toggleIsAdding] = useToggle50();
  const [isAssigning, toggleIsAssigning] = useToggle50();
  const [selectedNoteId, setSelectedNoteId] = useState138(null);
  const onSelectNote = useCallback264(
    (note) => {
      setSelectedNoteId(note.id);
    },
    [setSelectedNoteId]
  );
  const onClearSelectedNote = useCallback264(() => {
    setSelectedNoteId(null);
  }, [setSelectedNoteId]);
  return /* @__PURE__ */ jsxs323("div", { className: "flex flex-1 flex-col gap-2", children: [
    /* @__PURE__ */ jsx475(Header2, { fragmentRef, onAssign: toggleIsAssigning }),
    isAssigning && /* @__PURE__ */ jsx475("div", { className: "border bg-white p-4 lg:m-8 lg:p-8", children: /* @__PURE__ */ jsx475(
      VacancyQualityAssuranceAssign,
      {
        fragmentRef: assurance,
        onAssigned: toggleIsAssigning,
        onCancel: toggleIsAssigning
      }
    ) }),
    selectedNoteId ? /* @__PURE__ */ jsx475("div", { className: "border bg-white p-4", children: /* @__PURE__ */ jsx475(
      VacancyQualityAssuranceEditNote,
      {
        fragmentRef: assurance,
        noteId: selectedNoteId,
        onChanged: onClearSelectedNote,
        onCancel: onClearSelectedNote
      }
    ) }) : /* @__PURE__ */ jsx475("div", { className: "border bg-white p-4", children: isAdding ? /* @__PURE__ */ jsx475(
      VacancyQualityAssuranceAddNote,
      {
        fragmentRef: assurance,
        onCreated: toggleIsAdding,
        onCancel: toggleIsAdding
      }
    ) : /* @__PURE__ */ jsxs323("div", { className: "", children: [
      /* @__PURE__ */ jsxs323("div", { className: "flex items-center justify-between gap-2 border-b py-2", children: [
        /* @__PURE__ */ jsx475("div", { className: "text-primary-500 p-2 font-medium", children: "Notes" }),
        /* @__PURE__ */ jsx475("div", { children: /* @__PURE__ */ jsx475(Button137, { color: "primary", clicked: toggleIsAdding, children: "Add Note" }) })
      ] }),
      /* @__PURE__ */ jsx475("div", { className: "px-2 py-4", children: /* @__PURE__ */ jsx475(
        VacancyQualityAssuranceNotesList,
        {
          fragmentRef: assurance,
          onSelect: onSelectNote
        }
      ) })
    ] }) })
  ] });
};

// src/vacancy-qa/components/VacancyQualityAssuranceRoute.tsx
import { jsx as jsx476 } from "react/jsx-runtime";
var vacancyQualityAssuranceRouteQueryDef = VacancyQualityAssuranceRouteQuery_graphql_default;
function useVacancyQualityAssuranceRouteData(routeId4) {
  const queryRef3 = useRouteLoaderData19(
    routeId4
  );
  const data = usePreloadedQuery49(
    vacancyQualityAssuranceRouteQueryDef,
    queryRef3
  );
  return data;
}
async function loader38(environment, params) {
  const code = params.qaCode;
  const qaCode = parseInt(code);
  return loadQuery47(
    environment,
    vacancyQualityAssuranceRouteQueryDef,
    {
      qaCode
    }
  );
}
var Details = ({ routeId: routeId4 }) => {
  const data = useVacancyQualityAssuranceRouteData(routeId4);
  const { assurance } = data;
  if (!assurance) {
    return /* @__PURE__ */ jsx476(EdSkeleton123, {});
  }
  return /* @__PURE__ */ jsx476("div", { className: "flex-1", children: /* @__PURE__ */ jsx476(VacancyQualityAssuranceDetails, { fragmentRef: assurance }) });
};
var createVacancyQualityAssuranceRoute = (routePrefix, environment, context) => {
  const routeId4 = `${routePrefix}-vacancy-quality-assurance`;
  const detailsRouteId = `${routeId4}-details`;
  return {
    id: routeId4,
    path: ":qaCode",
    element: /* @__PURE__ */ jsx476(OutletRoute6, {}),
    loader: ({ params }) => {
      return loader38(environment, params);
    },
    children: [
      {
        id: detailsRouteId,
        path: "details/*",
        element: /* @__PURE__ */ jsx476(Details, { routeId: routeId4 })
      },
      {
        path: "*",
        element: /* @__PURE__ */ jsx476(Navigate16, { to: "details", replace: true })
      }
    ]
  };
};

// src/vacancy-qa/components/__generated__/VacancyQualityAssuranceListContainerQuery.graphql.ts
var node563 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }, v23 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "createdAt": "DESC"
        }
      ]
    },
    v1
  ], v32 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "VacancyQualityAssuranceListContainerQuery",
      "selections": [
        {
          "args": [
            v1
          ],
          "kind": "FragmentSpread",
          "name": "VacancyQualityAssuranceListContainer_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "VacancyQualityAssuranceListContainerQuery",
      "selections": [
        {
          "alias": "list",
          "args": v23,
          "concreteType": "RecruitVacancyQualityAssurancesConnection",
          "kind": "LinkedField",
          "name": "recruitVacancyQualityAssurances",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitVacancyQualityAssurancesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "VacancyQualityAssurance",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v32,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "vacancyQualityAssuranceId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "vacancyId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "vacancyName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "assignedToEmail",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountsAdminUser",
                      "kind": "LinkedField",
                      "name": "assignedTo",
                      "plural": false,
                      "selections": [
                        v32,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "firstName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "lastName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "emailAddress",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v23,
          "filters": [],
          "handle": "connection",
          "key": "VacancyQualityAssuranceListContainer_list",
          "kind": "LinkedHandle",
          "name": "recruitVacancyQualityAssurances"
        }
      ]
    },
    "params": {
      "cacheID": "7d5b6d034cb5ace14652eeeabaa702e5",
      "id": null,
      "metadata": {},
      "name": "VacancyQualityAssuranceListContainerQuery",
      "operationKind": "query",
      "text": "query VacancyQualityAssuranceListContainerQuery(\n  $where: VacancyQualityAssuranceFilter!\n) {\n  ...VacancyQualityAssuranceListContainer_list_3FC4Qo\n}\n\nfragment VacancyQualityAssuranceListContainer_list_3FC4Qo on Query {\n  list: recruitVacancyQualityAssurances(first: 10, order: [{createdAt: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        vacancyQualityAssuranceId\n        code\n        createdAt\n        updatedAt\n        employerId\n        employerName\n        vacancyId\n        vacancyName\n        assignedToEmail\n        assignedTo {\n          id\n          firstName\n          lastName\n          emailAddress\n        }\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node563.hash = "f4db887c5b576d512b32c074d27ee1f5";
var VacancyQualityAssuranceListContainerQuery_graphql_default = node563;

// src/vacancy-qa/components/__generated__/VacancyQualityAssurancesListContainerPaginationQuery.graphql.ts
var node564 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v23 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v32 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }, v4 = [
    v1,
    v23,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "createdAt": "DESC"
        }
      ]
    },
    v32
  ], v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "VacancyQualityAssurancesListContainerPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v23,
            v32
          ],
          "kind": "FragmentSpread",
          "name": "VacancyQualityAssuranceListContainer_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "VacancyQualityAssurancesListContainerPaginationQuery",
      "selections": [
        {
          "alias": "list",
          "args": v4,
          "concreteType": "RecruitVacancyQualityAssurancesConnection",
          "kind": "LinkedField",
          "name": "recruitVacancyQualityAssurances",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitVacancyQualityAssurancesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "VacancyQualityAssurance",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v5,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "vacancyQualityAssuranceId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "vacancyId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "vacancyName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "assignedToEmail",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountsAdminUser",
                      "kind": "LinkedField",
                      "name": "assignedTo",
                      "plural": false,
                      "selections": [
                        v5,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "firstName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "lastName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "emailAddress",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v4,
          "filters": [],
          "handle": "connection",
          "key": "VacancyQualityAssuranceListContainer_list",
          "kind": "LinkedHandle",
          "name": "recruitVacancyQualityAssurances"
        }
      ]
    },
    "params": {
      "cacheID": "6b0fd7f51146b5d6df7bf58402d7e3d7",
      "id": null,
      "metadata": {},
      "name": "VacancyQualityAssurancesListContainerPaginationQuery",
      "operationKind": "query",
      "text": "query VacancyQualityAssurancesListContainerPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $where: VacancyQualityAssuranceFilter!\n) {\n  ...VacancyQualityAssuranceListContainer_list_3sueo6\n}\n\nfragment VacancyQualityAssuranceListContainer_list_3sueo6 on Query {\n  list: recruitVacancyQualityAssurances(first: $first, after: $after, order: [{createdAt: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        vacancyQualityAssuranceId\n        code\n        createdAt\n        updatedAt\n        employerId\n        employerName\n        vacancyId\n        vacancyName\n        assignedToEmail\n        assignedTo {\n          id\n          firstName\n          lastName\n          emailAddress\n        }\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node564.hash = "c1a13c540e2410c9ed687441190fcb73";
var VacancyQualityAssurancesListContainerPaginationQuery_graphql_default = node564;

// src/vacancy-qa/components/__generated__/VacancyQualityAssuranceListContainer_list.graphql.ts
var node565 = function() {
  var v0 = [
    "list"
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": VacancyQualityAssurancesListContainerPaginationQuery_graphql_default
      }
    },
    "name": "VacancyQualityAssuranceListContainer_list",
    "selections": [
      {
        "alias": "list",
        "args": null,
        "concreteType": "RecruitVacancyQualityAssurancesConnection",
        "kind": "LinkedField",
        "name": "__VacancyQualityAssuranceListContainer_list_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitVacancyQualityAssurancesEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "VacancyQualityAssurance",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  v1,
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "vacancyQualityAssuranceId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "employerId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "employerName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "vacancyId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "vacancyName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "assignedToEmail",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AccountsAdminUser",
                    "kind": "LinkedField",
                    "name": "assignedTo",
                    "plural": false,
                    "selections": [
                      v1,
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "firstName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lastName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "emailAddress",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node565.hash = "c1a13c540e2410c9ed687441190fcb73";
var VacancyQualityAssuranceListContainer_list_graphql_default = node565;

// src/vacancy-qa/components/VacancyQualityAssuranceListContainer.tsx
import { Suspense as Suspense150, useCallback as useCallback265, useState as useState139 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery79, usePaginationFragment as usePaginationFragment34 } from "react-relay";
import { formatDistanceToNow as formatDistanceToNow7, parseISO as parseISO14 } from "date-fns";
import { useLocalStorage as useLocalStorage3 } from "react-use";
import {
  CheckBox as CheckBox7,
  DefaultListLayoutItemHeader as DefaultListLayoutItemHeader4,
  DefaultListLayoutSectionElement as DefaultListLayoutSectionElement4,
  EdSkeleton as EdSkeleton124,
  ListLayout as ListLayout8,
  PageHeading
} from "shared-ui";
import { isNotNullOrUndefined as isNotNullOrUndefined14 } from "shared-lib";
import { useUserSessionContext as useUserSessionContext8 } from "app-core";
import { jsx as jsx477, jsxs as jsxs324 } from "react/jsx-runtime";
var queryDef79 = VacancyQualityAssuranceListContainerQuery_graphql_default;
var fragmentDef121 = VacancyQualityAssuranceListContainer_list_graphql_default;
function createLinkTo3(section) {
  const code = section.context.code;
  return `../../../view/${code}`;
}
var List7 = ({ fragmentRef }) => {
  const { data, loadNext } = usePaginationFragment34(fragmentDef121, fragmentRef);
  const onLoadNext = useCallback265(() => {
    loadNext(10);
  }, [loadNext]);
  const { list: list2 } = data;
  const sections = (list2?.edges || []).map((e4) => e4.node).filter(isNotNullOrUndefined14).map((qa) => {
    const name = `${qa.vacancyName}`;
    return {
      key: qa.code.toString(),
      itemTitle: name,
      listTitle: /* @__PURE__ */ jsx477("div", { className: "flex flex-col gap-2", children: /* @__PURE__ */ jsxs324("div", { className: "flex items-center justify-between gap-2", children: [
        /* @__PURE__ */ jsx477("div", { className: "text-md font-medium uppercase", children: name }),
        /* @__PURE__ */ jsx477("div", { className: "text-md text-blue-500", children: qa.code })
      ] }) }),
      description: /* @__PURE__ */ jsxs324("div", { className: "pt-2 text-sm", children: [
        "Created ",
        formatDistanceToNow7(parseISO14(qa.createdAt))
      ] }),
      hideIcon: true,
      icon: () => null,
      iconForeground: "text-primary-700",
      iconBackground: "bg-primary-50",
      context: {
        code: qa.code
      },
      element: /* @__PURE__ */ jsx477(DefaultListLayoutSectionElement4, { children: /* @__PURE__ */ jsx477("div", { className: "grid", children: /* @__PURE__ */ jsx477("div", { children: qa.code }) }) })
    };
  });
  return /* @__PURE__ */ jsx477(Suspense150, { fallback: /* @__PURE__ */ jsx477(EdSkeleton124, {}), children: /* @__PURE__ */ jsx477(
    ListLayout8,
    {
      sections,
      itemHeader: (s4) => /* @__PURE__ */ jsx477(
        DefaultListLayoutItemHeader4,
        {
          title: "Tenants",
          to: createLinkTo3,
          section: s4
        }
      ),
      loadMore: onLoadNext,
      isLoading: false
    }
  ) });
};
var statusList2 = [
  { id: "DONE", display: "Done" },
  { id: "FAILED", display: "Failed" },
  { id: "PENDING", display: "Pending" }
];
var statusOptions = statusList2.map((d4) => {
  return /* @__PURE__ */ jsx477("option", { value: d4.id, children: d4.display }, d4.id);
});
var VacancyQualityAssurancesListContainer = () => {
  const session = useUserSessionContext8();
  const [myTasks, setMyTasks] = useLocalStorage3(
    "VacancyQualityAssurancesListMyTasks"
  );
  const [status, setStatus] = useLocalStorage3(
    "VacancyQualityAssurancesListStatus"
  );
  const onSetStatus = useCallback265(
    (e4) => {
      const result = e4.target.value;
      if (result === "") {
        setStatus(null);
      } else {
        setStatus(result);
      }
    },
    [setStatus]
  );
  const [employer, setEmployer] = useLocalStorage3(
    "VacancyQualityAssurancesListEmployer"
  );
  const onEmployerSelected = useCallback265(
    (result) => {
      setEmployer(result);
    },
    [setEmployer]
  );
  const [project, setProject] = useLocalStorage3(
    "VacancyQualityAssurancesListProject"
  );
  const onProjectSelected = useCallback265(
    (result) => {
      setProject(result);
    },
    [setProject]
  );
  const [vacancy, setVacancy] = useState139(null);
  const onVacancySelected = useCallback265(
    (result) => {
      setVacancy(result);
    },
    [setVacancy]
  );
  const filters = [];
  if (employer) {
    filters.push({ employerId: { eq: employer.employerId } });
  }
  if (project) {
    filters.push({ projectId: { eq: project.id } });
  }
  if (vacancy) {
    filters.push({ vacancyId: { eq: vacancy.vacancyId } });
  }
  if (status) {
    filters.push({ status: { eq: status } });
  }
  if (myTasks && session && session.userId) {
    filters.push({ assignedToId: { eq: session.userId } });
  }
  const where = {
    and: filters
  };
  const query3 = useLazyLoadQuery79(
    queryDef79,
    { where },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsxs324("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ jsxs324("div", { className: "flex items-center gap-2 space-x-4 border-b bg-white px-4 py-2", children: [
      /* @__PURE__ */ jsx477(PageHeading, { children: "QA" }),
      /* @__PURE__ */ jsx477("div", { className: "flex items-center py-2", children: /* @__PURE__ */ jsx477(
        CheckBox7,
        {
          checked: myTasks ?? false,
          title: /* @__PURE__ */ jsx477("span", { children: "My Tasks" }),
          onChanged: setMyTasks
        }
      ) }),
      /* @__PURE__ */ jsxs324("div", { className: "flex items-center space-x-4 py-2", children: [
        /* @__PURE__ */ jsx477("label", { className: "text-gray-700", htmlFor: "filter", children: "Employer" }),
        /* @__PURE__ */ jsx477("div", { className: "sm:w-64", children: /* @__PURE__ */ jsx477(Suspense150, { children: /* @__PURE__ */ jsx477(
          EmployerSearchContainer,
          {
            defaultValue: employer,
            onSearchCompleted: onEmployerSelected
          }
        ) }) })
      ] }),
      /* @__PURE__ */ jsxs324("div", { className: "flex items-center space-x-4 py-2", children: [
        /* @__PURE__ */ jsx477("label", { className: "text-gray-700", htmlFor: "filter", children: "Project" }),
        /* @__PURE__ */ jsx477("div", { className: "sm:w-64", children: employer ? /* @__PURE__ */ jsx477(Suspense150, { children: /* @__PURE__ */ jsx477(
          ProjectSearchBox,
          {
            name: "vacancy-qa-project-search",
            defaultValue: project,
            employerId: employer.employerId,
            onSelected: onProjectSelected,
            showLabel: false
          }
        ) }) : /* @__PURE__ */ jsx477("div", { className: "text-sm text-gray-500", children: "First Select Employer" }) })
      ] }),
      /* @__PURE__ */ jsxs324("div", { className: "flex items-center space-x-4 py-2", children: [
        /* @__PURE__ */ jsx477("label", { className: "text-gray-700", htmlFor: "filter", children: "Vacancy" }),
        /* @__PURE__ */ jsx477("div", { className: "sm:w-64", children: /* @__PURE__ */ jsx477(Suspense150, { children: /* @__PURE__ */ jsx477(VacancySearchAutoComplete, { onSelected: onVacancySelected }) }) })
      ] }),
      /* @__PURE__ */ jsxs324("div", { className: "flex items-center space-x-4 py-2", children: [
        /* @__PURE__ */ jsx477("label", { className: "text-gray-700", htmlFor: "filter", children: "Status" }),
        /* @__PURE__ */ jsx477("div", { className: "sm:w-64", children: /* @__PURE__ */ jsxs324(
          "select",
          {
            id: "countryOptions",
            name: "countryOptions",
            className: "focus:ring-primary-500 focus:border-primary-500 block w-full rounded-md border-gray-300",
            onChange: onSetStatus,
            value: status ?? "",
            children: [
              /* @__PURE__ */ jsx477("option", { value: "", children: "--Select--" }, ""),
              statusOptions
            ]
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ jsx477("div", { className: "flex-1", children: /* @__PURE__ */ jsx477(Suspense150, { fallback: /* @__PURE__ */ jsx477(EdSkeleton124, {}), children: /* @__PURE__ */ jsx477(List7, { fragmentRef: query3 }) }) })
  ] });
};
export {
  ActivateSearchMutation_default as ActivateSearchMutation,
  AddApplicationConversationMessage_default as AddApplicationConversationMessage,
  ApplicationActions,
  ApplicationApplyStates,
  ApplicationApplyWorkflow,
  ApplicationButtons,
  ApplicationChat,
  ApplicationContainer,
  ApplicationContentFocusLayout,
  ApplicationConversationAddMessageForm,
  ApplicationConversationContainer,
  ApplicationConversationCreateForm,
  ApplicationConversationForm,
  ApplicationConversationList,
  ApplicationConversationsContainer,
  ApplicationDetails,
  ApplicationHeader,
  ApplicationItem,
  ApplicationList,
  ApplicationMenu,
  ApplicationOfferSearchList,
  ApplicationResumeContainer,
  ApplicationResumeUpload,
  ApplicationRightToWorkEditor,
  ApplicationSortFieldType,
  ApplicationSubmitButton,
  ApplicationTaskContainer,
  ApplicationTaskDetails,
  ApplicationTaskLoader,
  ApplicationTasksContainer,
  ApplicationToolbar,
  ApplicationWorkflow,
  ApplicationsContainer,
  ApplicationsPagination,
  AvailabilityCalendar,
  AvailableInList,
  CandidateApplicationHistory,
  CandidateApplicationLayout,
  CandidateApplicationProfile2 as CandidateApplicationProfile,
  CandidateApplicationSearchList,
  CandidateInterviews,
  CandidateProfileExperienceList,
  CandidateRecommendationHistory,
  CloseSearchMutation_default as CloseSearchMutation,
  CompaniesTags,
  ConversationDetails,
  ConversationItem,
  ConversationMessages,
  ConversationMessagesList,
  CreateApplicationConversation_default as CreateApplicationConversation,
  CreateSearchRunMutation_default as CreateSearchRunMutation,
  DocumentSearchIndex,
  DocumentSearchIndexCollection,
  DocumentSearchResult,
  DownloadSearchResultMutation_default as DownloadSearchResultMutation,
  EmailApplicationContainer,
  EmailApplicationList,
  EmailApplicationSearchBox,
  EmailApplicationSearchBoxContainer,
  EmployerProfileSourcesContainer,
  EmployersOfferSearchList,
  ExperienceAdd,
  ExperienceDetailsComponent,
  ExperienceEdit,
  ExperienceEditComponent,
  ExperienceForm,
  ExperienceItem,
  ExperienceLayout,
  ExperienceViewer,
  HappyFace,
  IdibuConfigContainer,
  IdibuConfigEditor,
  IndustriesTags,
  InitializeSearchAtoms,
  Interview,
  InterviewContainer,
  InterviewDetails,
  InterviewDetailsLoader,
  InterviewLayout,
  InterviewList,
  InterviewsContainer,
  JobBoardList,
  JobBoardSearchActivateButton,
  JobBoardSearchBoxContainer,
  JobBoardSearchBoxInput,
  JobBoardSearchCloseButton,
  JobBoardSearchContainer,
  JobBoardSearchCreateRunButton,
  JobBoardSearchDetailForm,
  JobBoardSearchDetailView,
  JobBoardSearchList,
  JobBoardSearchNewForm,
  JobBoardSearchResultDownloadButton,
  JobBoardSearchResultList,
  JobBoardSearchResultProcessButton,
  JobBoardSearchResultRow,
  JobBoardSearchResultsContainer,
  JobBoardSearchRetryRunButton,
  JobBoardSearchRow,
  JobBoardSearchRunContainer,
  JobBoardSearchRunList,
  JobBoardSearchRunRow,
  JobBoardSearchRunView,
  JobBoardSearchRunsContainer,
  JobBoardSearchScheduleForm,
  JobBoardSearchStatus,
  JobBoardSearchStatusList,
  JobSearchStatusLabel,
  JobTitleSearchBox,
  JobTitleSearchBoxInput,
  JobTitleSearchContainer,
  LocationsContainer,
  LocationsList,
  MatchFunnel,
  MultiFilter,
  NewInterviewForm,
  PayTypes,
  ProcessSearchResultMutation_default as ProcessSearchResultMutation,
  Profile,
  ProfileConnectionComponent,
  ProfileContainer,
  ProfileDetails2 as ProfileDetails,
  ProfileDetailsComponent,
  ProfileEdit,
  ProfileFacetsList,
  ProfileInfoSidebar,
  ProfileNotes,
  ProfileNotesComponent,
  ProfileResumeUpload,
  ProfileSearchBox,
  ProfileSearchBoxContainer,
  ProfileSearchBoxInput,
  ProfileSearchContainer,
  ProfileSearchOptions,
  ProfileSearchResultTimeline,
  ProfileSearchStartPage,
  ProfileSkillSearch,
  ProfileSkillsFacetsContainer,
  ProfileSortFieldType,
  ProfileWorkHistory,
  ProfileWorkHistoryComponent,
  ProfileWorkTimeline,
  ProfileWorkTimelineDef,
  ProfilesNotesById,
  ProjectFilters,
  ProjectList,
  ProjectSearchBox,
  ProjectSearchBoxInput,
  PublicRecommendationLayout,
  PublicRecommendationLoader,
  RateInfo,
  RateLabel,
  RateType,
  Rates,
  RecommendationApplyButton,
  RecommendationContainer,
  RecommendationDeclineButton,
  RecommendationDeclineMessage,
  RecommendationDeclineReasonSelector,
  RecommendationExpired,
  RecommendationHeader,
  RecommendationLayout,
  RecommendationList,
  RecommendationLoader,
  RecommendationNoDecision,
  RecommendationSortFieldType,
  RecommendationWorkflowChange,
  RecommendationWorkflowDeclinedDataRemoved,
  RecommendationWorkflowDeclinedNoReason,
  RecommendationWorkflowDeclinedUnsuitableLocation,
  RecommendationWorkflowDeclinedUnsuitableRate,
  RecommendationWorkflowDeclinedUnsuitableSkills,
  RecommendationWorkflowNoDecision,
  RecommendationsContainer,
  RecruitProfileApplicationHeader,
  RecruitProfileHeader,
  ResumeBoundaryFallback,
  ResumeClarifyPositions,
  ResumeContainer,
  ResumeHeader,
  ResumeImportStatus,
  ResumeList,
  ResumePoller,
  ResumePollerLoader,
  ResumePosition,
  ResumePositionEditor,
  ResumePositions,
  ResumeSkills,
  ResumeStatusLabel,
  ResumeUpload,
  ResumeUploadContainer,
  ResumeUploader,
  ResumeView,
  ResumeWorkflow,
  ResumesLayout,
  RetrySearchRunMutation_default as RetrySearchRunMutation,
  RightToWorkAdd,
  RightToWorkEdit,
  RightToWorkEditor,
  RightToWorkForm,
  RightToWorkList,
  RightToWorkStatus,
  RoleTypes,
  Salary,
  SalaryEditorInput,
  ScheduleSearchMutation_default as ScheduleSearchMutation,
  ShowExpandApplicationProfile,
  ShowExpandProfile,
  ShowExpandVacancy,
  SignalBarComponent,
  SingleFilter,
  SkillGroupList,
  SkillSearchBox,
  SkillSearchBoxInput,
  SortDirectionList,
  TalentPoolAddAccessContainer,
  TalentPoolContainer,
  TalentPoolCreateEditor,
  TalentPoolCreateExternalInviteForm,
  TalentPoolCreateInternalInviteForm,
  TalentPoolCreateInviteContainer,
  TalentPoolEmployerAccessForm,
  TalentPoolErrorCodes,
  TalentPoolInvitesListContainer,
  TalentPoolListContainer,
  TalentPoolMemberContainer,
  TalentPoolMemberListContainer,
  TalentPoolMemberProfileContainer,
  TalentPoolVacancies,
  TalentPoolVacanciesComponent,
  TextQueryFilter,
  UseCandidateResumeUploadGraphQL,
  VacancyAdDetails,
  VacancyAdSummary,
  VacancyApplicationSearchContainer,
  VacancyApplicationSearchFacets,
  VacancyApplicationSearchFacetsContext,
  VacancyApplicationsRoute,
  VacancyApplyButton,
  VacancyApplyContainer,
  VacancyApplyPublicContainer,
  VacancyConversations,
  VacancyConversationsList,
  VacancyCreateContainer,
  VacancyDashboard,
  VacancyEditorProgressBar,
  VacancyLink,
  VacancyMatchesLayout,
  VacancyQualityAssurancesListContainer,
  VacancyRecommendationSearchContainer,
  VacancyRecommendationSearchLoader,
  VacancyRecommendationsRoute,
  VacancyRoot,
  VacancyRoute,
  VacancyScoringConfig,
  VacancySearchAutoComplete,
  VacancySearchAutoCompleteOptions,
  VacancySearchContainer,
  VacancySearchDashboardLayout,
  VacancySearchHeader2 as VacancySearchHeader,
  VacancySearchLoader,
  VacancySkillGroup,
  VacancySkillsText,
  VacancyStatusFilter,
  WithdrawApplication,
  WithdrawApplicationForm,
  WorkLocationsContainer,
  applicationCanBeSubmitted,
  applicationSearchAtom,
  applicationSortBestMatch,
  applicationSortFieldToGraphQL,
  applicationSortFields,
  applicationSortValues,
  applicationStatusValues,
  atomWithCompare,
  buildProfileCompanyTimeline,
  buildProfileFilteredSkillsTimeline,
  buildProfileModel,
  buildProfileTimelineSets,
  buildProfileTopSkillsTimeline,
  calculateDuration,
  candidateHasRight,
  createAvailabilityRoutes,
  createCandidateApplicationRoutes,
  createDefaultEmployerReference,
  createEmployerVacancyTalentPoolDefaultInvitesEditorRoute,
  createFiltersFromVacancy,
  createIndex,
  createIndexedPositionsIndex,
  createMatchRoutes,
  createOfferRoutes,
  createProfileSourcesRoutes,
  createRoute7 as createProjectCreateRoute,
  createProjectRoutes,
  createRightToWorkStatus,
  createRightToWorkStatusLabel,
  createRightToWorkStatusList,
  createRoute11 as createRoute,
  createSkillTimelineItem,
  createVacancyEditRoutes,
  createVacancyModel,
  createVacancyQualityAssuranceRoute,
  createVacancyRecommendationRoutes,
  createVacancyRoutes,
  createRoute21 as createdCandidateInterviewRoute,
  defaultApplicationSearchAtomValues,
  defaultApplicationSort,
  defaultApplicationSortOrder,
  defaultFilterState,
  deserializeSkillGroups,
  emailApplicationSearchBoxQueryDef,
  facetLabels,
  fetchMatchRun,
  filterExperiencesByTerms,
  formatRate,
  fromPayType,
  getApplicationState,
  interviewLayoutQueryDef,
  isBusyWithResume,
  linkRegistryAtom,
  loader12 as loader,
  matchExperienceByFilter,
  matchSortFields,
  mutation5 as mutation,
  mutationDef59 as mutationDef,
  payTypeLabel,
  pluralizeDuration,
  positionDatesAndDuration,
  profileSearchAtom,
  profileSearchContainerFragmentDef,
  profileSearchContainerQueryDef,
  profileSearchContextAtom,
  profileSearchSortFields,
  profileSortFieldToGraphQL,
  publicRecommendationLayoutQueryDef,
  queryDef30 as queryDef,
  recommendationLayoutQueryDef,
  recommendationSearchInputAtom,
  recommendationSortDirAtom,
  recommendationSortFieldAtom,
  recommendationSortFieldToGraphQL,
  recommendationsSearchContextAtom,
  requiresResumeImport,
  requiresResumeUpload,
  serializeSkillGroups,
  toDuration,
  toPayType,
  toRoleType,
  toVacancyDurationCode,
  useCandidateExperienceCreate,
  useCandidateExperienceEdit,
  useCandidateExperienceRemove,
  useCandidateProfileChangeJobTitle,
  useCandidateResumeAddPositions,
  useCandidateResumeCreateUploadUrl,
  useCandidateResumeExcludePosition,
  useCandidateResumeImportPositions,
  useCandidateResumeUpdatePosition,
  useCandidateResumeUpload,
  useCreateJobBoardSearch,
  useDeleteRightToWork,
  useEnableJobBoardSearchModule,
  useInterviewCancel,
  useInterviewCreate,
  useInterviewDecline,
  useInterviewInvite,
  useInterviewReschedule,
  useInterviewSchedule,
  useLegacyPagination,
  useLinkRegistry,
  useLinkRegistryState,
  useLoadMoreApplications,
  useOffsetPagination,
  useRecommendVacancy,
  useRecommendationAddRightToWork,
  useRecommendationApply,
  useRecommendationComment,
  useRecommendationDecline,
  useRecommendationDeclineAvailability,
  useRecommendationDeclineCloseAccount,
  useRecommendationDeclineFeedbackAvailability,
  useRecommendationDeclineFeedbackLocation,
  useRecommendationDeclineFeedbackRate,
  useRecommendationDeclineFeedbackSkills,
  useRecommendationDeclineLocation,
  useRecommendationDeclineNotInterested,
  useRecommendationDeclineRate,
  useRecommendationDeclineSkills,
  useResumeWorkflowState,
  useSendMatches,
  useSetApplicationRightToWork,
  useSetLinkRegistry,
  useSetNoResume,
  useSetRightToWork,
  useTalentPoolCreate,
  useTalentPoolCreateExternalInvite,
  useTalentPoolCreateInternalInvite,
  useTalentPoolEmployerAccessRemove,
  useTalentPoolEmployerAccessSet,
  useTalentPoolInviteExpire,
  useTalentPoolUpdate,
  useUpdateSearch,
  useVacancyApply,
  useVacancyChangeFormVersion,
  useVacancyCreate,
  useVacancyDocumentAdd,
  useVacancyDocumentRemove,
  useVacancyFormAdd,
  useVacancyFormRemove,
  useVacancyFulfill,
  useVacancyProfileSourceAdd,
  useVacancyProfileSourceRemove,
  useVacancyProfileSourcesUpdate,
  useVacancyRouteData,
  useVacancySkillsGeneration,
  useVacancyUpdate,
  useVacancyUpdateDescription,
  useVacancyUpdateDetails,
  useVacancyUpdateScoring,
  vacancyApplicationSearchContextAtom,
  loader15 as vacancyDashboardLoader,
  vacancyDetailsHaveChanged,
  loader7 as vacancyEditLoader,
  vacancyLayoutQueryDef,
  vacancyLoader,
  vacancyRecommendationSearchFragmentDef,
  vacancyRecommendationSearchQueryDef,
  loader13 as vacancyRootLoader,
  vacancySearchAtom,
  vacancySearchAutoCompleteQueryDef,
  vacancySearchContainerQueryDef,
  vacancySelectAtom,
  vacancySortBestMatch,
  vacancySortLastActivity,
  vacancySortValues,
  vacancyStatusArchived,
  vacancyStatusDraft,
  vacancyStatusFilled,
  vacancyStatusOpen,
  vacancyStatusValues,
  workflowStateChangeEventsAtom
};
/*! Bundled license information:

classnames/index.js:
  (*!
  	Copyright (c) 2018 Jed Watson.
  	Licensed under the MIT License (MIT), see
  	http://jedwatson.github.io/classnames
  *)

react-is/cjs/react-is.production.min.js:
  (** @license React v16.13.1
   * react-is.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)

react-is/cjs/react-is.development.js:
  (** @license React v16.13.1
   * react-is.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)

object-assign/index.js:
  (*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  *)

@uppy/utils/lib/Translator.js:
  (**
   * Takes a string with placeholder variables like `%{smart_count} file selected`
   * and replaces it with values from options `{smart_count: 5}`
   *
   * @license https://github.com/airbnb/polyglot.js/blob/master/LICENSE
   * taken from https://github.com/airbnb/polyglot.js/blob/master/lib/polyglot.js#L299
   *
   * @param phrase that needs interpolation, with placeholders
   * @param options with values that will be used to replace placeholders
   *)
*/
/*! Bundled license information:

lodash/lodash.js:
  (**
   * @license
   * Lodash <https://lodash.com/>
   * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
   * Released under MIT license <https://lodash.com/license>
   * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
   * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
   *)

react-is/cjs/react-is.production.min.js:
  (** @license React v16.13.1
   * react-is.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)

react-is/cjs/react-is.development.js:
  (** @license React v16.13.1
   * react-is.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)

object-assign/index.js:
  (*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  *)

classnames/index.js:
  (*!
  	Copyright (c) 2018 Jed Watson.
  	Licensed under the MIT License (MIT), see
  	http://jedwatson.github.io/classnames
  *)
*/
//# sourceMappingURL=index.mjs.map